/**
 * This file is auto-generated by codegen.ts.
 * DO NOT EDIT IT MANUALLY!
 */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  JSONObject: any;
  UnixEpochTimestamp: number;
  bigint: string;
  date: string;
  float8: number;
  int8: `${number}`;
  interval: string;
  json: any;
  jsonb: any;
  name: string;
  numeric: number;
  smallint: number;
  timestamp: string;
  timestamptz: string;
  uuid: string;
  vector: number[];
};

export type AcceptCepTosResult = {
  __typename?: 'AcceptCepTosResult';
  success: Scalars['Boolean'];
};

export type AccessibleOrganization = {
  __typename?: 'AccessibleOrganization';
  can_create_workspaces: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  workspaces: Array<AccessibleWorkspace>;
};

export type AccessibleWorkspace = {
  __typename?: 'AccessibleWorkspace';
  id: Scalars['Int'];
  is_ad_studio: Scalars['Boolean'];
  is_member: Scalars['Boolean'];
  member_count?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ActionFeatureBreakdown = {
  __typename?: 'ActionFeatureBreakdown';
  values: Array<ActionFeatureValue>;
  window: Scalars['String'];
};

export type ActionFeatureBreakdowns = {
  __typename?: 'ActionFeatureBreakdowns';
  actionFeatureName: Scalars['String'];
  breakdowns: Array<ActionFeatureBreakdown>;
};

export type ActionFeatureValue = {
  __typename?: 'ActionFeatureValue';
  count: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
};

export type ActionPlanApproval = {
  __typename?: 'ActionPlanApproval';
  approvedAt: Scalars['String'];
  approvedBy?: Maybe<Scalars['Int']>;
};

export type ActionPlanApprovalSummaryInput = {
  planId: Scalars['uuid'];
};

/** A file a plan's calls name by fileId, and the storage key /agents/files serves it from. */
export type ActionPlanFile = {
  __typename?: 'ActionPlanFile';
  fileId: Scalars['String'];
  mimeType: Scalars['String'];
  storageKey: Scalars['String'];
};

/** Names a plan by its id, as of its latest version, or one version of it. */
export type ActionPlanFilesInput = {
  planId?: InputMaybe<Scalars['uuid']>;
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type ActivateContentEmailDynamicContentCampaignResponse = {
  __typename?: 'ActivateContentEmailDynamicContentCampaignResponse';
  campaignId: Scalars['String'];
};

export type ActiveCampaignDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ActiveCampaignDescribeObjectResult = ActiveCampaignDescribeObjectSuccess;

export type ActiveCampaignDescribeObjectSuccess = {
  __typename?: 'ActiveCampaignDescribeObjectSuccess';
  fields: Array<ActiveCampaignField>;
};

export type ActiveCampaignField = {
  __typename?: 'ActiveCampaignField';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export const ActivityActorType = {
  Agent: 'agent',
  User: 'user'
} as const;

export type ActivityActorType = typeof ActivityActorType[keyof typeof ActivityActorType];
/**
 * One change a write made. One write can make several, each its own event.
 * An event is filed under a project, and maybe one of its tasks, or under a
 * Library file. A commented event's payload carries the comment's current
 * body, and an event that attaches or places a Library file carries its
 * fileName, fileType and canvasId.
 */
export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  /** An agent's event names the user it ran for: "Ada's Agent". */
  actorName: Scalars['String'];
  actorType: ActivityActorType;
  actorUserId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  file?: Maybe<ActivityFile>;
  id: Scalars['ID'];
  kind: ActivityKind;
  payload: Scalars['JSON'];
  project?: Maybe<ActivityProject>;
  task?: Maybe<ActivityTask>;
};

/**
 * The Library file an event is filed under: a canvas, a doc on its own, or the
 * file an ad or email comment was made on.
 */
export type ActivityFile = {
  __typename?: 'ActivityFile';
  /** Set for a canvas, whose page opens by this id. */
  canvasId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export const ActivityKind = {
  ActionStarted: 'action_started',
  Archived: 'archived',
  CanvasFileAdded: 'canvas_file_added',
  CanvasFileRemoved: 'canvas_file_removed',
  Commented: 'commented',
  FileDeleted: 'file_deleted',
  FileEdited: 'file_edited',
  FileRenamed: 'file_renamed',
  FileRestored: 'file_restored',
  FileVersionRestored: 'file_version_restored',
  Linked: 'linked',
  Moved: 'moved',
  Opened: 'opened',
  StatusLine: 'status_line',
  TaskArchived: 'task_archived',
  TaskBlockerAdded: 'task_blocker_added',
  TaskBlockerRemoved: 'task_blocker_removed',
  TaskCreated: 'task_created',
  TaskReviewApproved: 'task_review_approved',
  TaskReviewChangesRequested: 'task_review_changes_requested',
  TaskReviewCommented: 'task_review_commented',
  TaskReviewRequested: 'task_review_requested',
  TaskReviewWithdrawn: 'task_review_withdrawn',
  TaskStatusChanged: 'task_status_changed',
  TaskTagged: 'task_tagged',
  TaskUnarchived: 'task_unarchived',
  TaskUntagged: 'task_untagged',
  TaskUpdated: 'task_updated',
  TaskUserAdded: 'task_user_added',
  TaskUserRemoved: 'task_user_removed',
  Unarchived: 'unarchived',
  Unlinked: 'unlinked',
  UserAdded: 'user_added',
  UserRemoved: 'user_removed'
} as const;

export type ActivityKind = typeof ActivityKind[keyof typeof ActivityKind];
export type ActivityProject = {
  __typename?: 'ActivityProject';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ActivityTask = {
  __typename?: 'ActivityTask';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type AdAgentArtifact = {
  __typename?: 'AdAgentArtifact';
  createdAt: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  objectStorageKey: Scalars['String'];
  workspaceId: Scalars['Int'];
};

export type AdExportChannel = {
  __typename?: 'AdExportChannel';
  enabled: Scalars['Boolean'];
  guidance?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isPredefined: Scalars['Boolean'];
  name: Scalars['String'];
  sizes: Array<AdExportChannelSize>;
};

export type AdExportChannelMutationResponse = {
  __typename?: 'AdExportChannelMutationResponse';
  id: Scalars['uuid'];
};

export type AdExportChannelSize = {
  __typename?: 'AdExportChannelSize';
  adCount: Scalars['Int'];
  guidance?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  isDefault: Scalars['Boolean'];
  label: Scalars['String'];
  width: Scalars['Int'];
};

export type AdExportChannelSuccessResponse = {
  __typename?: 'AdExportChannelSuccessResponse';
  success: Scalars['Boolean'];
};

/** Stored video media extraction for one creative, from the creative_media table creative tagging writes. */
export type AdInsightsCreativeMedia = {
  __typename?: 'AdInsightsCreativeMedia';
  creativeId: Scalars['String'];
  /** The platform media URL the extraction ran against. */
  creativeUrl?: Maybe<Scalars['String']>;
  /** The most recent extraction failure, cleared by the next success. */
  error?: Maybe<Scalars['String']>;
  /**
   * Machine-extracted media facts (the CatalogMediaMetadata shape, the same as
   * CatalogProduct.metadata): duration, dimensions, transcript, hooks, scenes,
   * music and aiDescription on a shared seconds clock. Null until an extraction
   * succeeds; a later failure keeps the last good value.
   */
  metadata?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['String']>;
  /** Extraction pipeline version of metadata; 0 until an extraction succeeds. */
  version?: Maybe<Scalars['Int']>;
};

export type AdInsightsCreativeTag = {
  __typename?: 'AdInsightsCreativeTag';
  /** Values the tag can be set to with updateCreativeTag; null when the dimension is not editable in place. */
  allowedValues?: Maybe<Array<Scalars['String']>>;
  confidence?: Maybe<Scalars['String']>;
  creativeId: Scalars['String'];
  creativeType?: Maybe<Scalars['String']>;
  dimensionKey: Scalars['String'];
  dimensionName: Scalars['String'];
  /** True when none of the dimension's values fit, so the tag has no value. */
  noMatch: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  version?: Maybe<Scalars['Int']>;
};

export type AdInsightsCreativeTagUpdate = {
  __typename?: 'AdInsightsCreativeTagUpdate';
  creativeId: Scalars['String'];
  dimensionKey: Scalars['String'];
  value: Scalars['String'];
};

export type AdInsightsSavedView = {
  __typename?: 'AdInsightsSavedView';
  id: Scalars['ID'];
  layout: Scalars['String'];
  name: Scalars['String'];
  query: Scalars['JSON'];
};

export type AdLaunchConfigInput = {
  adName?: InputMaybe<Scalars['String']>;
  callToAction: Scalars['String'];
  callToActions?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<Scalars['String']>>;
  destinationUrl: Scalars['String'];
  headline: Scalars['String'];
  headlines?: InputMaybe<Array<Scalars['String']>>;
  primaryText: Scalars['String'];
  primaryTexts?: InputMaybe<Array<Scalars['String']>>;
  queuedAdId: Scalars['uuid'];
  selectedAspectRatios?: InputMaybe<Array<Scalars['String']>>;
  selectedImageStorageKeys: Array<SelectedImageStorageKeyInput>;
  selectedSizeVariantsByRatio?: InputMaybe<Array<SelectedSizeVariantByRatioInput>>;
  urlParameters?: InputMaybe<Scalars['String']>;
};

export type AdLaunchProgressInput = {
  queuedAdIds: Array<Scalars['uuid']>;
};

export type AdLaunchProgressItem = {
  __typename?: 'AdLaunchProgressItem';
  errorMessage?: Maybe<Scalars['String']>;
  queuedAdId: Scalars['uuid'];
  status: Scalars['String'];
};

export type AdReferenceOrigin = {
  __typename?: 'AdReferenceOrigin';
  collectionName?: Maybe<Scalars['String']>;
  /** One of catalog, web, upload or brand. */
  kind: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** The component_assets key of the reference file. */
  path: Scalars['String'];
  sourceUrl?: Maybe<Scalars['String']>;
};

export type AdStatsModelConfigurationInput = {
  asset_id_column?: InputMaybe<Scalars['String']>;
  clicks_column?: InputMaybe<Scalars['String']>;
  impressions_column?: InputMaybe<Scalars['String']>;
  spend_column?: InputMaybe<Scalars['String']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/**
 * What a status write actually did. 'updated' carries only the ads that moved;
 * ads already in the requested status come back under 'unchanged' rather than
 * failing the call, so re-applying a status is a no-op.
 */
export type AdStatusResult = {
  __typename?: 'AdStatusResult';
  adBriefAssetId: Scalars['uuid'];
  status: Scalars['String'];
};

/**
 * One ad's requested status. Grouped as a list so the bulk grid and the single
 * ad detail view are the same call.
 */
export type AdStatusUpdateInput = {
  adBriefAssetId: Scalars['uuid'];
  status: Scalars['String'];
};

export type AdStatusWritePayload = {
  __typename?: 'AdStatusWritePayload';
  unchanged: Array<Scalars['uuid']>;
  updated: Array<AdStatusResult>;
};

export type AdStudioAccount = {
  __typename?: 'AdStudioAccount';
  /** Numeric account ID (without act_ prefix). */
  id: Scalars['ID'];
  /** Human-readable account name from account_history; null if unavailable. */
  name?: Maybe<Scalars['String']>;
};

export type AdStudioCatalogTagSchema = {
  __typename?: 'AdStudioCatalogTagSchema';
  assetGroupName: Scalars['String'];
  tags: Array<AdStudioCatalogTagSchemaEntry>;
};

export type AdStudioCatalogTagSchemaEntry = {
  __typename?: 'AdStudioCatalogTagSchemaEntry';
  key: Scalars['String'];
  /** Sample of known values for this tag key (capped). */
  values: Array<Scalars['String']>;
};

export type AdStudioEnrichedProduct = {
  __typename?: 'AdStudioEnrichedProduct';
  id: Scalars['ID'];
  outputs: Array<AdStudioEnrichedProductOutput>;
  title?: Maybe<Scalars['String']>;
};

export type AdStudioEnrichedProductOutput = {
  __typename?: 'AdStudioEnrichedProductOutput';
  imageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  treatmentId: Scalars['ID'];
};

export type AdStudioEnrichedProductsPage = {
  __typename?: 'AdStudioEnrichedProductsPage';
  products: Array<AdStudioEnrichedProduct>;
  totalProducts: Scalars['Int'];
};

export type AdStudioEnrichmentRun = {
  __typename?: 'AdStudioEnrichmentRun';
  createdAt: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['String']>;
  isForceRun: Scalars['Boolean'];
  isTestRun: Scalars['Boolean'];
  jobId: Scalars['ID'];
  startedAt?: Maybe<Scalars['String']>;
  stats?: Maybe<AdStudioEnrichmentRunStats>;
  status: Scalars['String'];
};

export type AdStudioEnrichmentRunStats = {
  __typename?: 'AdStudioEnrichmentRunStats';
  /**
   * Per-treatment breakdown of the enrichment counts. Null on runs recorded
   * before the breakdown existed.
   */
  byTreatment?: Maybe<Array<AdStudioEnrichmentRunTreatmentStats>>;
  enrichmentFailed: Scalars['Int'];
  enrichmentSkipped: Scalars['Int'];
  enrichmentSucceeded: Scalars['Int'];
  productsDeleted: Scalars['Int'];
  productsInserted: Scalars['Int'];
  productsRead: Scalars['Int'];
  productsUpdated: Scalars['Int'];
};

export type AdStudioEnrichmentRunTreatmentStats = {
  __typename?: 'AdStudioEnrichmentRunTreatmentStats';
  failed: Scalars['Int'];
  skipped: Scalars['Int'];
  succeeded: Scalars['Int'];
  treatmentId: Scalars['ID'];
};

export type AdStudioFeedEnrichmentSummary = {
  __typename?: 'AdStudioFeedEnrichmentSummary';
  enriched: Scalars['Int'];
  failed: Scalars['Int'];
  pending: Scalars['Int'];
  total: Scalars['Int'];
};

export type AdStudioFeedProduct = {
  __typename?: 'AdStudioFeedProduct';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images: Array<AdStudioFeedProductImage>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Product tag key → value (string-coerced), for manifest user_tags bindings. */
  userTags: Scalars['JSON'];
};

export type AdStudioFeedProductImage = {
  __typename?: 'AdStudioFeedProductImage';
  primary: Scalars['Boolean'];
  /** "primary" or "additional-N" — matches the manifest image-binding grammar. */
  slot: Scalars['String'];
  url: Scalars['String'];
};

export type AdStudioPreviewImageUrl = {
  __typename?: 'AdStudioPreviewImageUrl';
  productId: Scalars['String'];
  url: Scalars['String'];
};

export type AdStudioSyncConfigInput = {
  /**
   * Ignored. The group is chosen per import. Kept until no deployed frontend
   * sends it; removing it now would reject the running app's save mutation.
   */
  assetGroupId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

export type AdStudioTemplateCreateContextInput = {
  importSource: Scalars['String'];
  inferName?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type AdStudioTemplateEditContextInput = {
  entityId: Scalars['uuid'];
};

export type AdTemplateSourceAdInput = {
  assetId: Scalars['uuid'];
  assetVersionId: Scalars['uuid'];
};

export type AddAdExportChannelSizeInput = {
  channelId: Scalars['uuid'];
  guidance?: InputMaybe<Scalars['String']>;
  height: Scalars['Int'];
  hidden?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  width: Scalars['Int'];
};

export type AddAsanaTaskCommentInput = {
  /** Omit to comment on the campaign's own task. */
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  body: Scalars['String'];
  campaignId: Scalars['ID'];
};

export type AddCepParentModelsInput = {
  connectionId: Scalars['ID'];
  mode?: InputMaybe<Scalars['String']>;
  parentModelIds: Array<Scalars['ID']>;
};

export type AddCepParentModelsResult = {
  __typename?: 'AddCepParentModelsResult';
  cepWorkspaceConfigId: Scalars['String'];
  parentModelIds: Array<Scalars['ID']>;
};

export type AdminEntitlementRequestInput = {
  reason: Scalars['String'];
  workspaceId: Scalars['Int'];
};

export type AdminEntitlementRequestResult = {
  __typename?: 'AdminEntitlementRequestResult';
  message?: Maybe<Scalars['String']>;
  status: AdminEntitlementRequestStatus;
  taskId?: Maybe<Scalars['String']>;
};

export const AdminEntitlementRequestStatus = {
  Error: 'Error',
  Granted: 'Granted',
  NotRequired: 'NotRequired',
  Requested: 'Requested'
} as const;

export type AdminEntitlementRequestStatus = typeof AdminEntitlementRequestStatus[keyof typeof AdminEntitlementRequestStatus];
export const AdminEntitlementStatus = {
  Approved: 'Approved',
  Cancelled: 'Cancelled',
  Denied: 'Denied',
  Error: 'Error',
  NotConfigured: 'NotConfigured',
  NotFound: 'NotFound',
  Pending: 'Pending'
} as const;

export type AdminEntitlementStatus = typeof AdminEntitlementStatus[keyof typeof AdminEntitlementStatus];
export type AdminEntitlementStatusInput = {
  taskId?: InputMaybe<Scalars['String']>;
  workspaceId?: InputMaybe<Scalars['Int']>;
};

export type AdminEntitlementStatusResult = {
  __typename?: 'AdminEntitlementStatusResult';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status: AdminEntitlementStatus;
  taskId?: Maybe<Scalars['String']>;
};

export type AdminFragmentInput = {
  executionId: Scalars['String'];
  fragmentId: Scalars['String'];
  messageId: Scalars['String'];
};

export type AdminFragmentResult = {
  __typename?: 'AdminFragmentResult';
  content: Scalars['String'];
  fileCount: Scalars['Int'];
  status: Scalars['String'];
  storageKey: Scalars['String'];
  totalRows?: Maybe<Scalars['Int']>;
};

export type AdminLinkCepBrandsToProfilesInput = {
  /** Report what would change and write nothing. */
  dryRun: Scalars['Boolean'];
  /** The workspace whose CEP brands to link. */
  workspaceId: Scalars['ID'];
};

export type AdminLinkCepBrandsToProfilesResult = {
  __typename?: 'AdminLinkCepBrandsToProfilesResult';
  /** CEP brands whose logo was copied into the profile created from them. A dry run lists the logos it would copy. */
  copiedLogoCepBrandIds: Array<Scalars['String']>;
  /** CEP brands created for brand profiles that had none. */
  createdCepBrandIds: Array<Scalars['String']>;
  /** Names of the brand profiles created, including a new workspace default. */
  createdProfiles: Array<Scalars['String']>;
  /** CEP brands whose logo could not be copied, so their new profile has no logo. */
  failedLogoCepBrandIds: Array<Scalars['String']>;
  /** Existing CEP brands that were linked to a brand profile. */
  linkedCepBrandIds: Array<Scalars['String']>;
};

export type AdminManualRetryFragmentInput = {
  executionId: Scalars['String'];
  fragmentId: Scalars['String'];
  messageId: Scalars['String'];
};

export type AdminManualRetryFragmentResult = {
  __typename?: 'AdminManualRetryFragmentResult';
  checkpointOffset: Scalars['Int'];
  enqueuedJobId?: Maybe<Scalars['String']>;
  fragmentId: Scalars['String'];
  previousStatus: Scalars['String'];
  transitioned: Scalars['Boolean'];
};

export type AdminManualRetryFragmentsForExecutionInput = {
  executionId: Scalars['String'];
  messageId: Scalars['String'];
};

export type AdminManualRetryFragmentsForExecutionResult = {
  __typename?: 'AdminManualRetryFragmentsForExecutionResult';
  results: Array<AdminManualRetryFragmentResult>;
};

export type AdminRedriveCampaignRunInput = {
  campaignRunId: Scalars['ID'];
};

export type AdminRedriveCampaignRunResult = {
  __typename?: 'AdminRedriveCampaignRunResult';
  executionId: Scalars['ID'];
  reopenedRun: Scalars['Boolean'];
};

export type AdminReplaceGlobalSuppressionListInput = {
  channelType: GlobalSuppressionChannelType;
  kind: GlobalSuppressionKind;
  /**
   * Audit label recorded on every row this upload keeps or adds,
   * e.g. "spam_domains_2026_09" or "role_based".
   */
  source: Scalars['String'];
  /**
   * The complete list for this channelType and kind. The server trims,
   * lowercases, strips a stray leading or trailing "@", and dedupes. Any
   * blank or malformed entry rejects the whole call. Rows not in the list
   * are deleted, so an empty list clears the kind.
   */
  values: Array<Scalars['String']>;
};

/**
 * Counts for one replace. total is the rows under (channelType, kind)
 * after the call and equals the number of distinct values sent; removed is
 * what the previous list had that this one does not.
 */
export type AdminReplaceGlobalSuppressionListResult = {
  __typename?: 'AdminReplaceGlobalSuppressionListResult';
  added: Scalars['Int'];
  removed: Scalars['Int'];
  total: Scalars['Int'];
  unchanged: Scalars['Int'];
};

export type AdminRepointCepForwardingQueuesInput = {
  /** Report what would change and write nothing. */
  dryRun: Scalars['Boolean'];
  /** Which copy of each queue to move the syncs onto. */
  target: CepForwardingQueueTarget;
  /** The workspace whose CEP forwarding syncs to move. It must be in this API's region. */
  workspaceId: Scalars['ID'];
};

export type AdminRepointCepForwardingQueuesResult = {
  __typename?: 'AdminRepointCepForwardingQueuesResult';
  /** Syncs moved onto the target queue. A dry run lists the syncs it would move. */
  moved: Array<CepForwardingQueueMove>;
  /** Syncs left where they are, with the reason. */
  skipped: Array<CepForwardingQueueSkip>;
};

export type AdminResetCepUserStateCounts = {
  __typename?: 'AdminResetCepUserStateCounts';
  channelUnsubscribe: Scalars['Int'];
  consent: Scalars['Int'];
  reachability: Scalars['Int'];
};

export type AdminResetCepUserStateInput = {
  /** Restrict to one channel. Omit to reset across all channels. */
  channelType?: InputMaybe<Scalars['String']>;
  /**
   * Convenience identifier — e.g. E.164 phone or email. The server hashes
   * it with the workspace salt to derive hashed_user_handle, and looks up
   * hashed_parent_model_pk from prior sends for consent / channel-unsub.
   */
  deliveryHandle?: InputMaybe<Scalars['String']>;
  /**
   * Canonical CEP user identifier. Provide exactly one of parentModelPk or
   * deliveryHandle.
   */
  parentModelPk?: InputMaybe<Scalars['String']>;
  /** Which state to clear. Defaults to all three when omitted. */
  scope?: InputMaybe<Array<CepUserStateScope>>;
};

export type AdminResetCepUserStateResult = {
  __typename?: 'AdminResetCepUserStateResult';
  rowsDeleted: AdminResetCepUserStateCounts;
};

export type AdminSkippedFragment = {
  __typename?: 'AdminSkippedFragment';
  fragmentId: Scalars['String'];
  reason: Scalars['String'];
};

export type AdminUpdateFragmentsInput = {
  executionId: Scalars['String'];
  /** Matched against send_batch_fragments for this execution. */
  fragmentIds: Array<Scalars['String']>;
  /** Applied to every row of every named fragment. */
  updates: Array<FragmentFieldUpdateInput>;
};

export type AdminUpdateFragmentsResult = {
  __typename?: 'AdminUpdateFragmentsResult';
  missingFragmentIds: Array<Scalars['String']>;
  skipped: Array<AdminSkippedFragment>;
  updated: Array<AdminUpdatedFragment>;
};

export type AdminUpdatedFragment = {
  __typename?: 'AdminUpdatedFragment';
  filesRewritten: Scalars['Int'];
  fragmentId: Scalars['String'];
  rowsPatched: Scalars['Int'];
  status: Scalars['String'];
};

export type AeoCreateSiteResult = {
  __typename?: 'AeoCreateSiteResult';
  precheckRunId?: Maybe<Scalars['ID']>;
  siteId: Scalars['ID'];
};

export type AeoSiteResult = {
  __typename?: 'AeoSiteResult';
  siteId: Scalars['ID'];
};

/** A connector the workspace added, which agents act through with its extension's or destination's credentials. */
export type AgentConnector = {
  __typename?: 'AgentConnector';
  credential: AgentConnectorCredential;
  /** True when the tools come from the connected system, which refreshAgentConnectorTools lists again. */
  discoversTools: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The extension's or destination's name, when the user can read it. */
  name?: Maybe<Scalars['String']>;
  readPermission: AgentToolPermission;
  tools: Array<AgentConnectorTool>;
  /** When discovery last listed the tools, as an ISO timestamp. Null before it first succeeds. */
  toolsDiscoveredAt?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  writePermission: AgentToolPermission;
};

export type AgentConnectorCredential = {
  __typename?: 'AgentConnectorCredential';
  /** The extension's or destination's ID. */
  id: Scalars['ID'];
  kind: AgentConnectorCredentialKind;
  name?: Maybe<Scalars['String']>;
};

/** The kind of stored credential a connector acts with. */
export const AgentConnectorCredentialKind = {
  Destination: 'destination',
  Extension: 'extension'
} as const;

export type AgentConnectorCredentialKind = typeof AgentConnectorCredentialKind[keyof typeof AgentConnectorCredentialKind];
/** A system agents can act on once the workspace adds it as a connector, such as Asana. */
export type AgentConnectorDefinition = {
  __typename?: 'AgentConnectorDefinition';
  credentialKinds: Array<AgentConnectorCredentialKind>;
  /** The extensions and destinations the user can read that could back a new connector of this type. */
  credentialOptions: Array<AgentConnectorCredential>;
  description: Scalars['String'];
  name: Scalars['String'];
  /** Empty when each connector discovers its tools from the connected system. */
  tools: Array<AgentConnectorDefinitionTool>;
  /** The connector type, such as asana. */
  type: Scalars['String'];
};

export type AgentConnectorDefinitionTool = {
  __typename?: 'AgentConnectorDefinitionTool';
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  /** The JSON Schema of the tool's arguments, with titles for display. */
  parametersSchema: Scalars['JSON'];
  readonly: Scalars['Boolean'];
};

export type AgentConnectorTool = {
  __typename?: 'AgentConnectorTool';
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  /** The permission the tool runs with: its own, or the connector's for read-only or write tools. */
  permission: AgentToolPermission;
  readonly: Scalars['Boolean'];
};

export type AgentConnectorToolPermissionInput = {
  permission: AgentToolPermission;
  toolId: Scalars['String'];
};

/**
 * One definition as the Definitions tab shows it: the current version's
 * content plus entity-level scope and creation time. Serves both the list and
 * the detail pane; the whole workspace loads in one query and the client
 * searches, filters and sorts.
 */
export type AgentDefinition = {
  __typename?: 'AgentDefinition';
  /** Agents the definition applies to. Empty means all agents. */
  agentScopes: Array<AgentScope>;
  /**
   * The assumed version the current version approved without changing its
   * markdown, so a chat that cited the assumption still matches. Null otherwise.
   */
  approvedFromVersionId?: Maybe<Scalars['uuid']>;
  /**
   * Brand profiles the definition applies to. Empty means all brand profiles.
   * Assignments to deleted profiles stay listed with isDeleted = true.
   */
  brandProfileAssignments: Array<BrandProfileAssignment>;
  /** From the entity, not the version, so editing does not re-order the list. */
  createdAt: Scalars['timestamptz'];
  /** Whether an agent has proposed an update to the current version that is still pending review. */
  hasProposedUpdate: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** Optimistic concurrency token for the save mutation. */
  latestVersionId: Scalars['uuid'];
  markdown: Scalars['String'];
  name: Scalars['String'];
  scope: AgenticSettingsEntityScope;
  /**
   * The user themselves supplied what this definition records, rather than an
   * agent inferring it. An agent weighs one of these above an assumption it
   * proposed on its own, and below an approved definition.
   */
  statedByUser: Scalars['Boolean'];
  status: AgentDefinitionStatus;
  /**
   * The current version's creation time, so it moves on every edit while
   * createdAt stays put. Equal to createdAt until someone edits.
   */
  updatedAt: Scalars['timestamptz'];
  /**
   * The workspace user who saved the current version. Null on an assumed
   * definition, whose current version an agent wrote rather than the person
   * whose session produced it, and null when the attributed user is gone.
   */
  updatedByUser?: Maybe<AgenticSettingsEntityUser>;
  usage: AgentDefinitionUsage;
  /** When the agent should apply this definition; the version's description. */
  usageGuidance?: Maybe<Scalars['String']>;
};

/**
 * One definition for the detail pane. Only what belongs to the definition as a
 * whole sits here; name, content and status are per version, and the last
 * version is the current one.
 */
export type AgentDefinitionDetail = {
  __typename?: 'AgentDefinitionDetail';
  agentScopes: Array<AgentScope>;
  brandProfileAssignments: Array<BrandProfileAssignment>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Whether an agent wrote the current version. */
  isAgentAuthored: Scalars['Boolean'];
  /** Each chat session's newest proposal, if undecided and made against the current version, sorted oldest first. */
  proposedUpdates: Array<AgentDefinitionProposedUpdate>;
  scope: AgenticSettingsEntityScope;
  /** The current version's creation time. */
  updatedAt: Scalars['timestamptz'];
  /** Who saved the current version. Null when an agent wrote it or the user is gone. */
  updatedByUser?: Maybe<AgenticSettingsEntityUser>;
  /** Distinct sessions across every version. */
  usage: AgentDefinitionUsage;
  /** Oldest first. */
  versions: Array<AgentDefinitionVersion>;
};

/**
 * A change an agent proposed to the current version of an approved definition,
 * applied or rejected through applyAgenticSettingsContextReview.
 */
export type AgentDefinitionProposedUpdate = {
  __typename?: 'AgentDefinitionProposedUpdate';
  createdAt: Scalars['timestamptz'];
  markdown: Scalars['String'];
  name: Scalars['String'];
  reviewId: Scalars['uuid'];
  suggestionId: Scalars['uuid'];
  /** Null keeps the definition's current usage guidance. */
  usageGuidance?: Maybe<Scalars['String']>;
};

export type AgentDefinitionSession = {
  __typename?: 'AgentDefinitionSession';
  /**
   * Where the session was started, e.g. "ad-studio" or "lifecycle-studio". The client
   * builds the session link from it.
   */
  creationSource?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** The root interaction that first read the definition, for linking to it in the chat. */
  interactionId: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** When this session first read the definition. */
  readAt: Scalars['timestamptz'];
  /** The report run that owns this session, when it is from a report. */
  report?: Maybe<AgentDefinitionSessionReport>;
  user?: Maybe<AgentDefinitionSessionUser>;
  /** Every version of the definition this session read. */
  versionIds: Array<Scalars['uuid']>;
};

export type AgentDefinitionSessionPage = {
  __typename?: 'AgentDefinitionSessionPage';
  /** Opaque; pass back as the cursor argument for the next page. Null at the end. */
  nextCursor?: Maybe<Scalars['String']>;
  sessions: Array<AgentDefinitionSession>;
};

export type AgentDefinitionSessionReport = {
  __typename?: 'AgentDefinitionSessionReport';
  name: Scalars['String'];
  reportId: Scalars['uuid'];
  runId: Scalars['uuid'];
};

export type AgentDefinitionSessionUser = {
  __typename?: 'AgentDefinitionSessionUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export const AgentDefinitionStatus = {
  Assumed: 'assumed',
  Verified: 'verified'
} as const;

export type AgentDefinitionStatus = typeof AgentDefinitionStatus[keyof typeof AgentDefinitionStatus];
/**
 * All-time usage, counting only sessions where an agent read the definition.
 * Hidden and deleted sessions are excluded so the counts match the sessions
 * list.
 */
export type AgentDefinitionUsage = {
  __typename?: 'AgentDefinitionUsage';
  /** Null when no agent has read it. */
  firstReferencedAt?: Maybe<Scalars['timestamptz']>;
  personCount: Scalars['Int'];
  sessionCount: Scalars['Int'];
};

export type AgentDefinitionVersion = {
  __typename?: 'AgentDefinitionVersion';
  /**
   * The assumed version a verified definition version is directly based on.
   * Only persisted on the first verified version; a later edit does not carry it forward.
   */
  basedOnVersionId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  markdown: Scalars['String'];
  name: Scalars['String'];
  statedByUser: Scalars['Boolean'];
  status: AgentDefinitionStatus;
  /** A session that read several versions counts under each. */
  usage: AgentDefinitionUsage;
  usageGuidance?: Maybe<Scalars['String']>;
};

export type AgentFileUploadResponse = {
  __typename?: 'AgentFileUploadResponse';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  storageKey: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Agent Memory stores user-defined context for marketing agents.
 * Scoping levels (mutually exclusive):
 * - Workspace-level: parentModelId=NULL, sourceId=NULL (e.g., "Our fiscal year starts in July")
 * - Parent Model: parentModelId=<id>, sourceId=NULL (e.g., Customer Studio schema: "Customer LTV uses 3-year window")
 * - Data Source: parentModelId=NULL, sourceId=<id> (e.g., SQL/table logic: "Use 90-day window for orders")
 */
export type AgentMemory = {
  __typename?: 'AgentMemory';
  createdAt: Scalars['timestamptz'];
  /** Null when the creating user has since been deleted. */
  createdBy?: Maybe<Scalars['String']>;
  data: Scalars['JSONObject'];
  id: Scalars['uuid'];
  parentModelId?: Maybe<Scalars['bigint']>;
  sourceId?: Maybe<Scalars['bigint']>;
  workspaceId: Scalars['bigint'];
};

/**
 * Which agents a context file is routed to. null/absent agentScopes means the
 * file applies to all agents; a non-empty array restricts it to the listed
 * agents. Supported agents: Ad Studio (ads), Lifecycle Studio (lcm), and the
 * data/reporting agents (data).
 */
export const AgentScope = {
  Ads: 'ads',
  Data: 'data',
  Lcm: 'lcm'
} as const;

export type AgentScope = typeof AgentScope[keyof typeof AgentScope];
export type AgentSessionMessagesResponse = {
  __typename?: 'AgentSessionMessagesResponse';
  context: LlmSessionContext;
  interactions: Array<LlmChatInteraction>;
  name: Scalars['String'];
};

export type AgentSettings = {
  __typename?: 'AgentSettings';
  active_inference_backend_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['String'];
  settings: Scalars['JSON'];
  updated_at: Scalars['String'];
};

export type AgentSettingsFileReadUrlResponse = {
  __typename?: 'AgentSettingsFileReadUrlResponse';
  url: Scalars['String'];
};

/** Whether the agent may run a tool: always, once the user approves a plan with it, or never. */
export const AgentToolPermission = {
  Allow: 'allow',
  Ask: 'ask',
  Deny: 'deny'
} as const;

export type AgentToolPermission = typeof AgentToolPermission[keyof typeof AgentToolPermission];
/**
 * Daily credit spend by source and user over the trailing window defined by
 * USAGE_BREAKDOWN_TRAILING_MONTHS (including the current month). Populated for
 * every workspace with agents enabled; when agents are off, `enabled` is false
 * and `buckets`/`users` are empty.
 */
export type AgentUsageBreakdownResponse = {
  __typename?: 'AgentUsageBreakdownResponse';
  buckets: Array<AgentUsageBucket>;
  enabled: Scalars['Boolean'];
  /**
   * 1st of current month, 00:00 UTC (inclusive) — the current billing period.
   * The period end is derivable as the 1st of the next UTC month.
   */
  periodStart: Scalars['timestamptz'];
  /** Display info for every user referenced by `buckets.userId`. */
  users: Array<AgentUsageUser>;
};

/**
 * One day of credit spend for one raw creation_source by one user. Zero-count
 * day/source/user combinations are omitted.
 */
export type AgentUsageBucket = {
  __typename?: 'AgentUsageBucket';
  credits: Scalars['Int'];
  /** UTC day, "YYYY-MM-DD". */
  date: Scalars['String'];
  /** Raw creation_source value (e.g. "agents", "audiences", "slack", "report-run"). */
  source: Scalars['String'];
  /** The user (created_by) who spent these credits. Join against `users`. */
  userId: Scalars['String'];
};

/**
 * Credit usage for the current billing period.
 * When `enabled` is false, every other field is null — this happens when the
 * workspace is a full agents buyer or the LaunchDarkly flag is off.
 */
export type AgentUsageCredits = {
  __typename?: 'AgentUsageCredits';
  distinctActiveUsers?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  /** Last millisecond of the current month, UTC (inclusive). Display-only. */
  periodEnd?: Maybe<Scalars['timestamptz']>;
  /** 1st of next month, 00:00 UTC (exclusive). The moment credits reset. */
  periodEndExclusive?: Maybe<Scalars['timestamptz']>;
  /** 1st of current month, 00:00 UTC (inclusive). */
  periodStart?: Maybe<Scalars['timestamptz']>;
  used?: Maybe<Scalars['Int']>;
};

/** Display info for a user that appears in the breakdown buckets. */
export type AgentUsageUser = {
  __typename?: 'AgentUsageUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type AgenticSettingsAdTemplateContent = {
  __typename?: 'AgenticSettingsAdTemplateContent';
  assets: Scalars['JSONObject'];
  authoringSessionId: Scalars['uuid'];
  editorHtml?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  importSource: Scalars['String'];
  manifest: Scalars['JSONObject'];
  originalSampleValues?: Maybe<Scalars['JSONObject']>;
  preview: AgenticSettingsAdTemplatePreview;
  schemaVersion: Scalars['Int'];
  status: Scalars['String'];
  usageGuidance: Scalars['String'];
};

export type AgenticSettingsAdTemplateContentInput = {
  editorHtml?: InputMaybe<Scalars['String']>;
  manifest: Scalars['JSONObject'];
  markAsReady?: InputMaybe<Scalars['Boolean']>;
  usageGuidance: Scalars['String'];
};

export type AgenticSettingsAdTemplateDraftContent = {
  __typename?: 'AgenticSettingsAdTemplateDraftContent';
  authoringSessionId: Scalars['uuid'];
  importSource: Scalars['String'];
  status: Scalars['String'];
};

export type AgenticSettingsAdTemplatePreview = {
  __typename?: 'AgenticSettingsAdTemplatePreview';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type AgenticSettingsContent = AgenticSettingsAdTemplateContent | AgenticSettingsAdTemplateDraftContent | AgenticSettingsCopyExamplesContent | AgenticSettingsFileContent | AgenticSettingsMarkdownContent;

export type AgenticSettingsContextReviewApplyResult = {
  __typename?: 'AgenticSettingsContextReviewApplyResult';
  applied: Array<Scalars['uuid']>;
  rejected: Array<Scalars['uuid']>;
  skippedStale: Array<Scalars['uuid']>;
  /**
   * Accepts refused because the agent revised the proposal after this one was made — the
   * user accepted a card between the agent writing its replacement and the panel refreshing.
   * Distinct from skippedStale, which means the underlying doc changed rather than the
   * suggestion. Both are skips, so the rest of the batch still applies.
   */
  skippedSuperseded: Array<Scalars['uuid']>;
};

export const AgenticSettingsContextReviewDecision = {
  Accept: 'accept',
  Reject: 'reject'
} as const;

export type AgenticSettingsContextReviewDecision = typeof AgenticSettingsContextReviewDecision[keyof typeof AgenticSettingsContextReviewDecision];
export type AgenticSettingsContextReviewDecisionInput = {
  decision: AgenticSettingsContextReviewDecision;
  suggestionId: Scalars['uuid'];
};

export type AgenticSettingsContextReviewMarkdownContent = {
  __typename?: 'AgenticSettingsContextReviewMarkdownContent';
  markdown: Scalars['String'];
};

export type AgenticSettingsContextReviewSuggestion = {
  __typename?: 'AgenticSettingsContextReviewSuggestion';
  /**
   * The entity an accepted suggestion wrote to, including the one an add_entity created.
   * Null until accepted, and for brand-profile operations, which write no entity version.
   */
  appliedEntityId?: Maybe<Scalars['uuid']>;
  appliedToEntityVersionId?: Maybe<Scalars['uuid']>;
  cardSummary?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  entityId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /**
   * True when reviewed_entity_version_id is no longer the current version of entity_id
   * (or the entity is gone). Computed at read time. Add-entity suggestions are never stale.
   */
  isStale: Scalars['Boolean'];
  opType: AgenticSettingsReviewOpType;
  /** Discriminated union over (op_type, entity_type). The FE narrows on __typename. */
  operation: AgenticSettingsReviewOperation;
  reason: AgenticSettingsReviewSuggestionReason;
  /** When the suggestion was approved or rejected. Null while it is still pending. */
  resolvedAt?: Maybe<Scalars['timestamptz']>;
  /**
   * The review this suggestion was emitted in. The apply mutation is review-scoped, so the
   * session working-set panel — whose heads span turns, and therefore reviews — needs this
   * to group its accept calls.
   */
  reviewId: Scalars['uuid'];
  /**
   * The entity version the agent reviewed against — i.e. what the agent saw when it
   * proposed this suggestion. Null for add_entity suggestions (no prior version) and
   * when the loaded version is no longer retrievable.
   */
  reviewedEntityVersion?: Maybe<AgenticSettingsReviewedEntity>;
  status: AgenticSettingsReviewSuggestionStatus;
  summary: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /**
   * What the review panel renders for this suggestion, built by the suggestion's review
   * target. Shaped by reviewSuggestionViewSchema in
   * lib/llm/agentic-settings-entities/review-targets/view.ts, which the app parses.
   */
  view: Scalars['JSONObject'];
};

export type AgenticSettingsCopyExample = {
  __typename?: 'AgenticSettingsCopyExample';
  body: Scalars['String'];
  campaignName?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  excluded: Scalars['Boolean'];
  exclusionReason?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /**
   * Source ad creative image URLs (ads channel), so the reviewer can compare the
   * ad to the copy transcribed from it. Signed CDN URLs that can expire.
   */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  preheader?: Maybe<Scalars['String']>;
  rawBody?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AgenticSettingsCopyExampleInput = {
  body: Scalars['String'];
  campaignName?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  excluded: Scalars['Boolean'];
  exclusionReason?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  preheader?: InputMaybe<Scalars['String']>;
  rawBody?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AgenticSettingsCopyExamplesConnectionSource = {
  __typename?: 'AgenticSettingsCopyExamplesConnectionSource';
  backend: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastSuccessfulRunAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  schema: Scalars['String'];
  sourceType: Scalars['String'];
  syncId: Scalars['String'];
};

export type AgenticSettingsCopyExamplesContent = {
  __typename?: 'AgenticSettingsCopyExamplesContent';
  channel: Scalars['String'];
  examples: Array<AgenticSettingsCopyExample>;
  extractionParams: AgenticSettingsCopyExamplesExtractionParams;
  source: AgenticSettingsCopyExamplesSource;
  target: AgenticSettingsCopyExamplesTarget;
};

export type AgenticSettingsCopyExamplesContentInput = {
  channel: Scalars['String'];
  examples: Array<AgenticSettingsCopyExampleInput>;
  extractionParams: AgenticSettingsCopyExamplesExtractionParamsInput;
  source: AgenticSettingsCopyExamplesSourceInput;
};

export type AgenticSettingsCopyExamplesExtractionParams = {
  __typename?: 'AgenticSettingsCopyExamplesExtractionParams';
  lookbackDays: Scalars['Int'];
  minSends?: Maybe<Scalars['Int']>;
  /** Free-text scoping hint the agent interprets when authoring its SQL. Never executed as SQL. */
  rowFilterNote?: Maybe<Scalars['String']>;
  targetCount: Scalars['Int'];
};

export type AgenticSettingsCopyExamplesExtractionParamsInput = {
  lookbackDays: Scalars['Int'];
  minSends?: InputMaybe<Scalars['Int']>;
  rowFilterNote?: InputMaybe<Scalars['String']>;
  targetCount: Scalars['Int'];
};

export type AgenticSettingsCopyExamplesResolvedColumns = {
  __typename?: 'AgenticSettingsCopyExamplesResolvedColumns';
  body: Scalars['String'];
  id: Scalars['String'];
  isArchived?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type AgenticSettingsCopyExamplesResolvedColumnsInput = {
  body: Scalars['String'];
  id: Scalars['String'];
  isArchived?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type AgenticSettingsCopyExamplesResolvedSource = {
  __typename?: 'AgenticSettingsCopyExamplesResolvedSource';
  columns: AgenticSettingsCopyExamplesResolvedColumns;
  table: Scalars['String'];
};

export type AgenticSettingsCopyExamplesResolvedSourceInput = {
  columns: AgenticSettingsCopyExamplesResolvedColumnsInput;
  table: Scalars['String'];
};

export type AgenticSettingsCopyExamplesSource = {
  __typename?: 'AgenticSettingsCopyExamplesSource';
  connectionId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fivetranSyncId?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  /** Meta Ad Library page fields; set only when kind is meta_ad_library. */
  pageId?: Maybe<Scalars['String']>;
  pageName?: Maybe<Scalars['String']>;
  resolvedSource?: Maybe<AgenticSettingsCopyExamplesResolvedSource>;
};

export type AgenticSettingsCopyExamplesSourceInput = {
  country?: InputMaybe<Scalars['String']>;
  fivetranSyncId?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  /** Meta Ad Library page fields; required when kind is meta_ad_library. */
  pageId?: InputMaybe<Scalars['String']>;
  pageName?: InputMaybe<Scalars['String']>;
  resolvedSource?: InputMaybe<AgenticSettingsCopyExamplesResolvedSourceInput>;
};

/**
 * Server-authoritative scoping target: injected from the ingestion marker, never accepted on input.
 * `destinationId` null is the channel-generic set applying to every destination on the channel.
 */
export type AgenticSettingsCopyExamplesTarget = {
  __typename?: 'AgenticSettingsCopyExamplesTarget';
  destinationId?: Maybe<Scalars['String']>;
};

export type AgenticSettingsEntity = {
  __typename?: 'AgenticSettingsEntity';
  /**
   * Agents this entity is routed to. An empty array means the entity applies to
   * all agents (an empty scope is coerced to null on write).
   */
  agentScopes: Array<AgentScope>;
  /**
   * Brand profiles this entity is assigned to. An empty array means the
   * entity applies to all brand profiles. Assignments pointing to
   * soft-deleted brand profiles are included with isDeleted = true so the
   * UI can surface orphaned-state warnings.
   */
  brandProfileAssignments: Array<BrandProfileAssignment>;
  content: AgenticSettingsContent;
  contextType?: Maybe<ContextFileType>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /**
   * Set when the entity was created by an external context sync; null for
   * manual entries. UI uses this to look up the source's warehouse icon.
   */
  externalContextSourceId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /**
   * True for a global, Hightouch-managed entity (a promoted skill living in the
   * dedicated managed store), which every workspace sees read-only. False for a
   * normal per-workspace entity.
   */
  isManaged: Scalars['Boolean'];
  /**
   * True when the entity is hidden from every listing and reaches an agent only
   * through a document that cites it.
   */
  isReferenceOnly: Scalars['Boolean'];
  latestVersionId: Scalars['uuid'];
  name: Scalars['String'];
  /**
   * Model / data-source scope. Only memories are ever scoped today; every
   * other type reports workspace mode with no targets.
   */
  scope: AgenticSettingsEntityScope;
  sourceType: AgenticSettingsEntitySourceType;
  /**
   * Field names that the external context source overwrites on each sync.
   * Non-empty implies the entity is synced; empty implies a user-created
   * entry. UI uses this to disable just the synced inputs.
   */
  syncedFields: Array<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /**
   * The workspace user who saved the latest version, for last-updated-by
   * attribution. Null when no user is behind the write (an external context
   * sync, an agent-applied review, or a Hightouch-managed entity), or when the
   * attributed user no longer exists.
   */
  updatedByUser?: Maybe<AgenticSettingsEntityUser>;
  /**
   * For a global managed skill, whether it is disabled in the viewing workspace.
   * Always false for workspace-owned entities.
   */
  workspaceDisabled: Scalars['Boolean'];
  workspaceId: Scalars['bigint'];
};

export type AgenticSettingsEntityScope = {
  __typename?: 'AgenticSettingsEntityScope';
  scopeMode: AgenticSettingsEntityScopeMode;
  /**
   * Empty with scopeMode = scoped means every target the entity was scoped to
   * has since been deleted: the entity currently loads nowhere until it is
   * re-scoped or deleted.
   */
  targets: Array<AgenticSettingsEntityScopeTarget>;
};

/**
 * No targets scopes the entity to the whole workspace; one or more scopes it to
 * those models and sources.
 */
export type AgenticSettingsEntityScopeInput = {
  targets: Array<AgenticSettingsEntityScopeTargetInput>;
};

/**
 * Where an entity applies. `workspace` loads for every interaction;
 * `scoped` loads only for interactions on one of the listed parent models or
 * data sources.
 */
export const AgenticSettingsEntityScopeMode = {
  Scoped: 'scoped',
  Workspace: 'workspace'
} as const;

export type AgenticSettingsEntityScopeMode = typeof AgenticSettingsEntityScopeMode[keyof typeof AgenticSettingsEntityScopeMode];
/**
 * One scope target. Exactly one of parentModelId / sourceId is set. Targets
 * are hard-deleted with their model or source, so a listed target is always
 * live.
 */
export type AgenticSettingsEntityScopeTarget = {
  __typename?: 'AgenticSettingsEntityScopeTarget';
  parentModelId?: Maybe<Scalars['bigint']>;
  parentModelName?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['bigint']>;
  sourceName?: Maybe<Scalars['String']>;
};

export type AgenticSettingsEntityScopeTargetInput = {
  parentModelId?: InputMaybe<Scalars['bigint']>;
  sourceId?: InputMaybe<Scalars['bigint']>;
};

/**
 * Where an entity came from: authored in the app (manual), pulled from an
 * external context source (synced), Hightouch-managed and global (hightouch),
 * produced from another entity's content, such as the pages and extracted
 * text of a PDF (derived), or written by an agent mid-session (agent).
 */
export const AgenticSettingsEntitySourceType = {
  Agent: 'agent',
  Derived: 'derived',
  Hightouch: 'hightouch',
  Manual: 'manual',
  Synced: 'synced'
} as const;

export type AgenticSettingsEntitySourceType = typeof AgenticSettingsEntitySourceType[keyof typeof AgenticSettingsEntitySourceType];
export const AgenticSettingsEntityType = {
  AdTemplate: 'ad_template',
  ContextFile: 'context_file',
  ContextMarkdown: 'context_markdown',
  CopyReferences: 'copy_references',
  Definition: 'definition',
  Style: 'style'
} as const;

export type AgenticSettingsEntityType = typeof AgenticSettingsEntityType[keyof typeof AgenticSettingsEntityType];
export type AgenticSettingsEntityUser = {
  __typename?: 'AgenticSettingsEntityUser';
  id: Scalars['String'];
  name: Scalars['String'];
};

export const AgenticSettingsEntityVersionOperation = {
  Created: 'created',
  Deleted: 'deleted',
  Restored: 'restored',
  Updated: 'updated'
} as const;

export type AgenticSettingsEntityVersionOperation = typeof AgenticSettingsEntityVersionOperation[keyof typeof AgenticSettingsEntityVersionOperation];
export type AgenticSettingsFileContent = {
  __typename?: 'AgenticSettingsFileContent';
  filename: Scalars['String'];
  filesize: Scalars['Int'];
  filetype: Scalars['String'];
  url: Scalars['String'];
};

/** Required on create — must always provide the file payload. */
export type AgenticSettingsFileContentCreateInput = {
  file: AgenticSettingsFileContentInput;
};

/**
 * File payload for create/update. s3Key is the key returned by
 * initiateContextFileUpload after PUTting the bytes to its presigned URL; the
 * bytes never travel through the GraphQL body.
 */
export type AgenticSettingsFileContentInput = {
  filename: Scalars['String'];
  filetype: Scalars['String'];
  s3Key: Scalars['String'];
};

/**
 * On update, 'file' may be null — when null, the prior version's file
 * (s3_key, filename, filetype, filesize, extracted_text_s3_key) is reused.
 * Saves an S3 round-trip and avoids changing the storage key when only
 * metadata is being edited.
 */
export type AgenticSettingsFileContentUpdateInput = {
  file?: InputMaybe<AgenticSettingsFileContentInput>;
};

export type AgenticSettingsMarkdownContent = {
  __typename?: 'AgenticSettingsMarkdownContent';
  /** The steps of a DAG skill. The markdown is generated from them. */
  dag?: Maybe<Scalars['JSONObject']>;
  /** Whether this is a DAG skill, for a list that needs to know without fetching the steps. */
  isDagSkill: Scalars['Boolean'];
  markdown: Scalars['String'];
};

export type AgenticSettingsMarkdownContentInput = {
  /** The steps of a DAG skill. Its markdown is generated from them on save. */
  dag?: InputMaybe<Scalars['JSONObject']>;
  markdown: Scalars['String'];
};

export const AgenticSettingsReviewOpType = {
  AddAssets: 'add_assets',
  AddEntity: 'add_entity',
  ApproveAssumption: 'approve_assumption',
  CreateBrandProfile: 'create_brand_profile',
  CreateChannel: 'create_channel',
  CreateDefinition: 'create_definition',
  DeleteChannelSize: 'delete_channel_size',
  DeleteDefinition: 'delete_definition',
  DeleteEntity: 'delete_entity',
  EditEntity: 'edit_entity',
  ManageLibraryAsset: 'manage_library_asset',
  SetDefaultChannelSize: 'set_default_channel_size',
  UpdateBrandImageGuardrails: 'update_brand_image_guardrails',
  UpdateBrandProfile: 'update_brand_profile',
  UpdateChannel: 'update_channel',
  UpdateCollectionImageGuardrails: 'update_collection_image_guardrails',
  UpdateDefinition: 'update_definition'
} as const;

export type AgenticSettingsReviewOpType = typeof AgenticSettingsReviewOpType[keyof typeof AgenticSettingsReviewOpType];
export type AgenticSettingsReviewOperation = AgenticSettingsReviewOperationAddFile | AgenticSettingsReviewOperationAddMarkdown | AgenticSettingsReviewOperationCreateBrandProfile | AgenticSettingsReviewOperationDelete | AgenticSettingsReviewOperationEditFile | AgenticSettingsReviewOperationEditMarkdown | AgenticSettingsReviewOperationUpdateBrandProfile | AgenticSettingsReviewOperationViewOnly;

export type AgenticSettingsReviewOperationAddFile = {
  __typename?: 'AgenticSettingsReviewOperationAddFile';
  /**
   * Agents the operation proposed routing the doc to. Null when it proposed no change to
   * the routing.
   */
  agentScopes?: Maybe<ProposedAgentScopes>;
  /**
   * Brand profiles the operation proposed assigning the doc to. Null when it proposed no
   * change to the assignment.
   */
  brandProfileIds?: Maybe<ProposedBrandProfileIds>;
  /**
   * Context-type classification the operation proposed. Null when it proposed no change
   * to the classification.
   */
  contextType?: Maybe<ProposedContextType>;
  description?: Maybe<Scalars['String']>;
  entityType: AgenticSettingsEntityType;
  fileId: Scalars['String'];
  filename?: Maybe<Scalars['String']>;
  filetype?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  opType: AgenticSettingsReviewOpType;
  url?: Maybe<Scalars['String']>;
};

export type AgenticSettingsReviewOperationAddMarkdown = {
  __typename?: 'AgenticSettingsReviewOperationAddMarkdown';
  /**
   * Agents the operation proposed routing the doc to. Null when it proposed no change to
   * the routing.
   */
  agentScopes?: Maybe<ProposedAgentScopes>;
  /**
   * Brand profiles the operation proposed assigning the doc to. Null when it proposed no
   * change to the assignment.
   */
  brandProfileIds?: Maybe<ProposedBrandProfileIds>;
  content: AgenticSettingsContextReviewMarkdownContent;
  /**
   * Context-type classification the operation proposed. Null when it proposed no change
   * to the classification.
   */
  contextType?: Maybe<ProposedContextType>;
  description?: Maybe<Scalars['String']>;
  entityType: AgenticSettingsEntityType;
  name: Scalars['String'];
  opType: AgenticSettingsReviewOpType;
};

/**
 * A proposed new brand profile. Carries the name the profile would be created with
 * instead of addressing an existing one, so there is no profileId and no staleness
 * token. `content` is exactly what the agent proposed, with no live row merged in.
 */
export type AgenticSettingsReviewOperationCreateBrandProfile = {
  __typename?: 'AgenticSettingsReviewOperationCreateBrandProfile';
  content: BrandProfileReviewContent;
  name: Scalars['String'];
  opType: AgenticSettingsReviewOpType;
};

export type AgenticSettingsReviewOperationDelete = {
  __typename?: 'AgenticSettingsReviewOperationDelete';
  /**
   * The type of the entity being deleted, read from the reviewed version so every
   * operation variant carries one.
   */
  entityType: AgenticSettingsEntityType;
  opType: AgenticSettingsReviewOpType;
};

export type AgenticSettingsReviewOperationEditFile = {
  __typename?: 'AgenticSettingsReviewOperationEditFile';
  /**
   * Agents the operation proposed routing the doc to. Null when it proposed no change to
   * the routing.
   */
  agentScopes?: Maybe<ProposedAgentScopes>;
  /**
   * Brand profiles the operation proposed assigning the doc to. Null when it proposed no
   * change to the assignment.
   */
  brandProfileIds?: Maybe<ProposedBrandProfileIds>;
  /**
   * Context-type classification the operation proposed. Null when it proposed no change
   * to the classification.
   */
  contextType?: Maybe<ProposedContextType>;
  description?: Maybe<Scalars['String']>;
  entityType: AgenticSettingsEntityType;
  name?: Maybe<Scalars['String']>;
  opType: AgenticSettingsReviewOpType;
};

export type AgenticSettingsReviewOperationEditMarkdown = {
  __typename?: 'AgenticSettingsReviewOperationEditMarkdown';
  /**
   * Agents the operation proposed routing the doc to. Null when it proposed no change to
   * the routing.
   */
  agentScopes?: Maybe<ProposedAgentScopes>;
  /**
   * Brand profiles the operation proposed assigning the doc to. Null when it proposed no
   * change to the assignment.
   */
  brandProfileIds?: Maybe<ProposedBrandProfileIds>;
  content?: Maybe<AgenticSettingsContextReviewMarkdownContent>;
  /**
   * Context-type classification the operation proposed. Null when it proposed no change
   * to the classification.
   */
  contextType?: Maybe<ProposedContextType>;
  description?: Maybe<Scalars['String']>;
  entityType: AgenticSettingsEntityType;
  name?: Maybe<Scalars['String']>;
  opType: AgenticSettingsReviewOpType;
};

export type AgenticSettingsReviewOperationUpdateBrandProfile = {
  __typename?: 'AgenticSettingsReviewOperationUpdateBrandProfile';
  content: BrandProfileReviewContent;
  opType: AgenticSettingsReviewOpType;
  profileId?: Maybe<Scalars['String']>;
  reviewedUpdatedAt?: Maybe<Scalars['String']>;
};

/** A suggestion of a kind added after operation was deprecated, which only view describes. */
export type AgenticSettingsReviewOperationViewOnly = {
  __typename?: 'AgenticSettingsReviewOperationViewOnly';
  opType: AgenticSettingsReviewOpType;
};

export const AgenticSettingsReviewSuggestionReason = {
  Clarity: 'clarity',
  Contradiction: 'contradiction',
  Gap: 'gap',
  Redundancy: 'redundancy',
  Stale: 'stale'
} as const;

export type AgenticSettingsReviewSuggestionReason = typeof AgenticSettingsReviewSuggestionReason[keyof typeof AgenticSettingsReviewSuggestionReason];
export const AgenticSettingsReviewSuggestionStatus = {
  Accepted: 'accepted',
  Pending: 'pending',
  Rejected: 'rejected'
} as const;

export type AgenticSettingsReviewSuggestionStatus = typeof AgenticSettingsReviewSuggestionStatus[keyof typeof AgenticSettingsReviewSuggestionStatus];
/**
 * Snapshot of an entity version as it was loaded into a context-review interaction.
 * Distinct from AgenticSettingsEntity (which represents the current state) because
 * this version may no longer be the entity's current version. `isCurrent` reflects
 * that comparison at read time.
 */
export type AgenticSettingsReviewedEntity = {
  __typename?: 'AgenticSettingsReviewedEntity';
  content: AgenticSettingsContent;
  /**
   * The operation on the entity's current (latest) version row. Lets the FE tell
   * "reviewed version still current" from "entity has been edited or deleted since."
   * Equal to the reviewed version's own operation when `isCurrent` is true.
   */
  currentEntityVersionOperation: AgenticSettingsEntityVersionOperation;
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /**
   * True when this entity version is still the entity's current version (no edits
   * have happened since the agent reviewed it).
   */
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  versionCreatedAt: Scalars['timestamptz'];
  versionId: Scalars['uuid'];
};

export type AgenticUfmJob = {
  __typename?: 'AgenticUFMJob';
  agentName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  featureMatrixId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  status: Scalars['String'];
};

export type AgenticUfmJobResponse = {
  __typename?: 'AgenticUFMJobResponse';
  jobId: Scalars['String'];
};

export type AiChannelSite = {
  __typename?: 'AiChannelSite';
  created_at: Scalars['String'];
  domain: Scalars['String'];
  id: Scalars['ID'];
  is_sample: Scalars['Boolean'];
  last_run_at?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AiChannelSiteOrderBy = {
  created_at?: InputMaybe<AiChannelSiteOrderDirection>;
};

export const AiChannelSiteOrderDirection = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type AiChannelSiteOrderDirection = typeof AiChannelSiteOrderDirection[keyof typeof AiChannelSiteOrderDirection];
export type AirBoard = {
  __typename?: 'AirBoard';
  id: Scalars['String'];
  parentBoardId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AirBoardTreeResult = {
  __typename?: 'AirBoardTreeResult';
  boards: Array<AirBoard>;
};

export type AirtableGetBasesInput = {
  destinationId: Scalars['String'];
};

export type AirtableGetBasesResult = AirtableGetBasesSuccess;

export type AirtableGetBasesSuccess = {
  __typename?: 'AirtableGetBasesSuccess';
  bases: Array<Base>;
};

export type AirtableGetTablesMetaInput = {
  baseId: Scalars['String'];
  destinationId: Scalars['String'];
};

export type AirtableGetTablesMetaResult = AirtableGetTablesMetaSuccess;

export type AirtableGetTablesMetaSuccess = {
  __typename?: 'AirtableGetTablesMetaSuccess';
  tables: Array<Table>;
};

export type AlertMigrationResult = {
  __typename?: 'AlertMigrationResult';
  createdChannels: Array<Scalars['String']>;
  syncMonitorOverrides: Array<Scalars['String']>;
  syncsWithDisabledChannels: Array<Scalars['String']>;
  updatedDestinations: Array<Scalars['String']>;
};

export type AmpActionDestinationScopeInput = {
  access: AmpDestinationAccess;
  id: Scalars['ID'];
};

export type AmpAdContent = {
  __typename?: 'AmpAdContent';
  assetId: Scalars['ID'];
  /** Maps each filename the ad references to its storage key. */
  componentAssets?: Maybe<Scalars['JSON']>;
  previewUrl?: Maybe<Scalars['String']>;
  svg?: Maybe<Scalars['String']>;
  /** A motion ad's composition, which carries no preview image of its own. */
  videoComposition?: Maybe<Scalars['JSON']>;
};

/** An AMP agent: one llm_chat_sessions row whose runtime is the agent harness. */
export type AmpAgent = {
  __typename?: 'AmpAgent';
  createdAt: Scalars['timestamptz'];
  /** The failure reason of the latest interaction while the status is failed. */
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** The parameters that the agent was created with. */
  parameters?: Maybe<Scalars['JSON']>;
  status: AmpAgentStatus;
  type: Scalars['String'];
  /** The member who created the agent. */
  user: AmpAgentUser;
};

/** A message of the transcript or the inbox, in the shape of the message frames of the event stream. */
export type AmpAgentMessage = {
  __typename?: 'AmpAgentMessage';
  createdAt: Scalars['timestamptz'];
  files: Scalars['JSON'];
  fromAgentId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** Null while the message is in the inbox. */
  index?: Maybe<Scalars['Int']>;
  /** On a user message, the metadata that the chat reads apart from the text, such as the answers of a quiz. Null when the message carries none. */
  metadata?: Maybe<Scalars['JSON']>;
  role: AmpAgentMessageRole;
  sender?: Maybe<AmpAgentSender>;
  senderUserId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  thinking: Array<Scalars['String']>;
  toolCallId?: Maybe<Scalars['String']>;
  /** The tool calls of an assistant message: id, name, and input of each. */
  toolCalls: Scalars['JSON'];
};

export const AmpAgentMessageRole = {
  Assistant: 'assistant',
  System: 'system',
  Tool: 'tool',
  User: 'user'
} as const;

export type AmpAgentMessageRole = typeof AmpAgentMessageRole[keyof typeof AmpAgentMessageRole];
export type AmpAgentSender = {
  __typename?: 'AmpAgentSender';
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export const AmpAgentStatus = {
  Failed: 'failed',
  Idle: 'idle',
  Queued: 'queued',
  Running: 'running',
  Stopped: 'stopped'
} as const;

export type AmpAgentStatus = typeof AmpAgentStatus[keyof typeof AmpAgentStatus];
export type AmpAgentUser = {
  __typename?: 'AmpAgentUser';
  id: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

/** Whether every member of a group reviewer must approve, or any one. */
export const AmpApprovalRule = {
  All: 'all',
  Any: 'any'
} as const;

export type AmpApprovalRule = typeof AmpApprovalRule[keyof typeof AmpApprovalRule];
export type AmpAssetSourceDefinition = {
  __typename?: 'AmpAssetSourceDefinition';
  configurationForm: Scalars['JSON'];
  name: Scalars['String'];
  syncConfigurationForm: Scalars['JSON'];
  type: Scalars['String'];
};

export type AmpAssetSyncRunRef = {
  __typename?: 'AmpAssetSyncRunRef';
  id: Scalars['ID'];
  status: Scalars['String'];
};

/**
 * One change an AMP write made. One write can make several, each its own event.
 * An event is filed under a project, and maybe one of its tasks, or under a
 * Library file.
 */
export type AmpBoardActivityEvent = {
  __typename?: 'AmpBoardActivityEvent';
  /** An agent's event names the user it ran for: "Ada's Agent". */
  actorName: Scalars['String'];
  actorType: AmpBoardActorType;
  actorUserId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  file?: Maybe<AmpBoardActivityFile>;
  id: Scalars['ID'];
  kind: AmpBoardActivityKind;
  payload: Scalars['JSON'];
  project?: Maybe<AmpBoardActivityProject>;
  task?: Maybe<AmpBoardActivityTask>;
};

/**
 * The Library file an event is filed under: a canvas, a doc on its own, or the
 * file an ad or email comment was made on.
 */
export type AmpBoardActivityFile = {
  __typename?: 'AmpBoardActivityFile';
  /** Set for a canvas, whose page opens by this id. */
  canvasId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export const AmpBoardActivityKind = {
  ActionStarted: 'action_started',
  Archived: 'archived',
  CanvasFileAdded: 'canvas_file_added',
  CanvasFileRemoved: 'canvas_file_removed',
  Commented: 'commented',
  FileDeleted: 'file_deleted',
  FileEdited: 'file_edited',
  FileRenamed: 'file_renamed',
  FileRestored: 'file_restored',
  FileVersionRestored: 'file_version_restored',
  Linked: 'linked',
  Moved: 'moved',
  Opened: 'opened',
  StatusLine: 'status_line',
  TaskArchived: 'task_archived',
  TaskBlockerAdded: 'task_blocker_added',
  TaskBlockerRemoved: 'task_blocker_removed',
  TaskCreated: 'task_created',
  TaskReviewApproved: 'task_review_approved',
  TaskReviewChangesRequested: 'task_review_changes_requested',
  TaskReviewCommented: 'task_review_commented',
  TaskReviewRequested: 'task_review_requested',
  TaskReviewWithdrawn: 'task_review_withdrawn',
  TaskStatusChanged: 'task_status_changed',
  TaskTagged: 'task_tagged',
  TaskUnarchived: 'task_unarchived',
  TaskUntagged: 'task_untagged',
  TaskUpdated: 'task_updated',
  TaskUserAdded: 'task_user_added',
  TaskUserRemoved: 'task_user_removed',
  Unarchived: 'unarchived',
  Unlinked: 'unlinked',
  UserAdded: 'user_added',
  UserRemoved: 'user_removed'
} as const;

export type AmpBoardActivityKind = typeof AmpBoardActivityKind[keyof typeof AmpBoardActivityKind];
export type AmpBoardActivityProject = {
  __typename?: 'AmpBoardActivityProject';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type AmpBoardActivityTask = {
  __typename?: 'AmpBoardActivityTask';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export const AmpBoardActorType = {
  Agent: 'agent',
  User: 'user'
} as const;

export type AmpBoardActorType = typeof AmpBoardActorType[keyof typeof AmpBoardActorType];
export type AmpCanvas = {
  __typename?: 'AmpCanvas';
  file: AmpFile;
  nodes: Array<AmpCanvasNode>;
};

export type AmpCanvasContent = {
  __typename?: 'AmpCanvasContent';
  brandProfileId?: Maybe<Scalars['ID']>;
  canvasId: Scalars['ID'];
};

export type AmpCanvasNode = {
  __typename?: 'AmpCanvasNode';
  file?: Maybe<AmpFile>;
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  zIndex?: Maybe<Scalars['Int']>;
};

export type AmpCanvasNodeStamp = {
  __typename?: 'AmpCanvasNodeStamp';
  file: AmpFileStamp;
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  x: Scalars['Float'];
  y: Scalars['Float'];
  zIndex?: Maybe<Scalars['Int']>;
};

/** The canvas as ampCanvas reads it, with each file's stamp in place of its content, so a poll can read the canvas again only once something on it changes. */
export type AmpCanvasStamp = {
  __typename?: 'AmpCanvasStamp';
  file: AmpFileStamp;
  nodes: Array<AmpCanvasNodeStamp>;
};

export type AmpCanvasUpdateInput = {
  name: Scalars['String'];
};

export type AmpChangeResult = {
  __typename?: 'AmpChangeResult';
  changed: Scalars['Boolean'];
  id: Scalars['ID'];
};

export const AmpDestinationAccess = {
  Read: 'read',
  Write: 'write'
} as const;

export type AmpDestinationAccess = typeof AmpDestinationAccess[keyof typeof AmpDestinationAccess];
export type AmpEmailContent = {
  __typename?: 'AmpEmailContent';
  emailId: Scalars['ID'];
  html?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['ID']>;
  subject?: Maybe<Scalars['String']>;
};

/** A published email image and the storage key of its private original, which /agents/files can load resized. */
export type AmpEmailImageKey = {
  __typename?: 'AmpEmailImageKey';
  key: Scalars['String'];
  url: Scalars['String'];
};

export type AmpEmailImageKeysResult = {
  __typename?: 'AmpEmailImageKeysResult';
  images: Array<AmpEmailImageKey>;
};

export type AmpEmailUpdateInput = {
  name?: InputMaybe<Scalars['String']>;
  version: CreateContentEmailVersionInput;
};

export type AmpExistingNodeCreateInput = {
  adBriefAssetId?: InputMaybe<Scalars['ID']>;
  canvasId: Scalars['ID'];
  contentEmailId?: InputMaybe<Scalars['ID']>;
  position: AmpPositionInput;
};

/**
 * An object outside Hightouch: where it lives, what it is, and how to open it.
 * metadata carries whatever else the writer knows about it.
 */
export type AmpExternalRefInput = {
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  kind: Scalars['String'];
  label: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  system: Scalars['String'];
};

export type AmpFile = {
  __typename?: 'AmpFile';
  ad?: Maybe<AmpAdContent>;
  canvas?: Maybe<AmpCanvasContent>;
  createdBy?: Maybe<Scalars['Int']>;
  email?: Maybe<AmpEmailContent>;
  folderId?: Maybe<Scalars['ID']>;
  generationStatus: Scalars['String'];
  html?: Maybe<AmpFileHtmlContent>;
  id: Scalars['ID'];
  /** Whether the file is in Drafts. A draft is in no folder. */
  isDraft: Scalars['Boolean'];
  /** Whether the current user has favorited the file. */
  isFavorite: Scalars['Boolean'];
  markdown?: Maybe<AmpMarkdownContent>;
  message?: Maybe<AmpMessageContent>;
  name?: Maybe<Scalars['String']>;
  /** The settings entity behind a doc or upload, which its comment threads hang off. */
  settingsEntityId?: Maybe<Scalars['ID']>;
  slides?: Maybe<AmpSlidesContent>;
  type: AmpFileType;
  updatedAt: Scalars['timestamptz'];
  upload?: Maybe<AmpUploadContent>;
  versionId?: Maybe<Scalars['ID']>;
  /** Private files are visible only to Hightouch staff. */
  visibility: AmpFileVisibility;
};

export type AmpFileActionResult = {
  __typename?: 'AmpFileActionResult';
  /** Files this action made visible to the workspace. */
  sharedFileIds: Array<Scalars['ID']>;
};

export type AmpFileCreateInput = {
  brandProfileId?: InputMaybe<Scalars['ID']>;
  canvas?: InputMaybe<AmpFilePlacementInput>;
  filename?: InputMaybe<Scalars['String']>;
  filetype?: InputMaybe<Scalars['String']>;
  /** Files the new file in this folder, or at the top level when null. Omitted starts it in Drafts, or a canvas at the top level. */
  folderId?: InputMaybe<Scalars['ID']>;
  markdown?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  s3Key?: InputMaybe<Scalars['String']>;
  type: AmpFileType;
  /** Defaults to workspace. Only Hightouch staff can make a file private, and a file placed on a canvas takes the canvas's visibility. */
  visibility?: InputMaybe<AmpFileVisibility>;
};

export type AmpFileHtmlContent = {
  __typename?: 'AmpFileHtmlContent';
  /** Maps each ad:<filename> ref in the markup to a URL the browser can load. */
  assets: Scalars['JSON'];
  html: Scalars['String'];
};

export type AmpFileHtmlUpdateInput = {
  /** Assets stay as they are; ad:<filename> refs resolve against the current assets. */
  html: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type AmpFileMarkdownUpdateInput = {
  content: AgenticSettingsMarkdownContentInput;
  name?: InputMaybe<Scalars['String']>;
};

export type AmpFilePage = {
  __typename?: 'AmpFilePage';
  items: Array<AmpFile>;
  nextOffset?: Maybe<Scalars['Int']>;
  /** Files matching the filters across every page. */
  totalCount: Scalars['Int'];
};

export type AmpFilePlacementInput = {
  id: Scalars['ID'];
  position: AmpPositionInput;
};

export const AmpFileSort = {
  Newest: 'newest',
  Oldest: 'oldest',
  Updated: 'updated'
} as const;

export type AmpFileSort = typeof AmpFileSort[keyof typeof AmpFileSort];
/** What a file shows besides its content. One of these changes whenever its AmpFile does, so a poll can read the file again only then. */
export type AmpFileStamp = {
  __typename?: 'AmpFileStamp';
  folderId?: Maybe<Scalars['ID']>;
  generationStatus: Scalars['String'];
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  versionId?: Maybe<Scalars['ID']>;
  visibility: AmpFileVisibility;
};

export const AmpFileType = {
  Ad: 'ad',
  Canvas: 'canvas',
  Doc: 'doc',
  Email: 'email',
  Html: 'html',
  Push: 'push',
  Slides: 'slides',
  Sms: 'sms',
  Upload: 'upload'
} as const;

export type AmpFileType = typeof AmpFileType[keyof typeof AmpFileType];
export type AmpFileTypeCount = {
  __typename?: 'AmpFileTypeCount';
  count: Scalars['Int'];
  type: AmpFileType;
};

export type AmpFileUpdateInput = {
  ad?: InputMaybe<CreateAssetVersionInput>;
  ampFileHtml?: InputMaybe<AmpFileHtmlUpdateInput>;
  ampFileMarkdown?: InputMaybe<AmpFileMarkdownUpdateInput>;
  ampFileUpload?: InputMaybe<AmpFileUploadUpdateInput>;
  baseVersionId?: InputMaybe<Scalars['ID']>;
  canvas?: InputMaybe<AmpCanvasUpdateInput>;
  email?: InputMaybe<AmpEmailUpdateInput>;
  id: Scalars['ID'];
};

export type AmpFileUpload = {
  __typename?: 'AmpFileUpload';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type AmpFileUploadUpdateInput = {
  content: AgenticSettingsFileContentUpdateInput;
  name?: InputMaybe<Scalars['String']>;
};

export type AmpFileUsage = {
  __typename?: 'AmpFileUsage';
  canvasIds: Array<Scalars['ID']>;
  count: Scalars['Int'];
};

export type AmpFileVersion = {
  __typename?: 'AmpFileVersion';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['Int']>;
  /** The agent turn that saved the version. Only docs, uploads, web pages and slides record it. */
  createdByInteractionId?: Maybe<Scalars['ID']>;
  createdByUser?: Maybe<AmpFileVersionAuthor>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type AmpFileVersionAuthor = {
  __typename?: 'AmpFileVersionAuthor';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export const AmpFileVisibility = {
  Private: 'private',
  Workspace: 'workspace'
} as const;

export type AmpFileVisibility = typeof AmpFileVisibility[keyof typeof AmpFileVisibility];
export type AmpFileWriteResult = {
  __typename?: 'AmpFileWriteResult';
  current?: Maybe<AmpFile>;
  file?: Maybe<AmpFile>;
  status: Scalars['String'];
};

export type AmpFolder = {
  __typename?: 'AmpFolder';
  id: Scalars['ID'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
};

export type AmpFolderFileCount = {
  __typename?: 'AmpFolderFileCount';
  count: Scalars['Int'];
  folderId: Scalars['ID'];
};

/**
 * The viewer's notifications in projects that are not archived and in Library
 * files the viewer can see, newest first.
 * needsYou is review requests still waiting on the viewer: the task is in
 * review, not archived, and the viewer reviews it. updates is everything else.
 */
export type AmpInbox = {
  __typename?: 'AmpInbox';
  filterOptions: AmpInboxFilterOptions;
  hasMoreUpdates: Scalars['Boolean'];
  needsYou: Array<AmpInboxNotification>;
  updates: Array<AmpInboxNotification>;
};

/** Everyone and every project some notification in the inbox has, under no filter. */
export type AmpInboxFilterOptions = {
  __typename?: 'AmpInboxFilterOptions';
  hasAgent: Scalars['Boolean'];
  projects: Array<AmpBoardActivityProject>;
  users: Array<AmpInboxUser>;
};

/** Each list keeps what matches any of its values. An empty list keeps everything. */
export type AmpInboxFiltersInput = {
  projectIds: Array<Scalars['ID']>;
  /** agent, or a user id. */
  sources: Array<Scalars['ID']>;
  types: Array<InboxNotificationType>;
};

/**
 * An AMP event the viewer should hear about, and why. changelogId is the
 * notification's id, which frontends deployed before inbox read state by.
 */
export type AmpInboxNotification = {
  __typename?: 'AmpInboxNotification';
  changelogId: Scalars['ID'];
  createdAt: Scalars['String'];
  event: AmpBoardActivityEvent;
  id: Scalars['ID'];
  readAt?: Maybe<Scalars['String']>;
  reason: InboxReason;
};

/**
 * Unread notifications, counted no further than the badge shows. hasMore is
 * set when there are more than count.
 */
export type AmpInboxUnreadCount = {
  __typename?: 'AmpInboxUnreadCount';
  count: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type AmpInboxUser = {
  __typename?: 'AmpInboxUser';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** The files listAmpFiles lists with no filters, counted for the Library sidebar. */
export type AmpLibraryCounts = {
  __typename?: 'AmpLibraryCounts';
  /** Files outside Drafts. */
  all: Scalars['Int'];
  drafts: Scalars['Int'];
  favorites: Scalars['Int'];
  /** Files filed directly in each folder. Folders without files are left out. */
  folders: Array<AmpFolderFileCount>;
  /** The current user's files outside Drafts. */
  mine: Scalars['Int'];
  /** Every file type, including those with no files. */
  types: Array<AmpFileTypeCount>;
};

export type AmpMarkdownContent = {
  __typename?: 'AmpMarkdownContent';
  markdown: Scalars['String'];
};

export type AmpMessageContent = {
  __typename?: 'AmpMessageContent';
  artifactId: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type AmpMutationResult = {
  __typename?: 'AmpMutationResult';
  id: Scalars['ID'];
};

export type AmpNodeCreateInput = {
  canvasId: Scalars['ID'];
  fileId: Scalars['ID'];
  position: AmpPositionInput;
};

export type AmpNodeMoveInput = {
  canvasId: Scalars['ID'];
  nodeId: Scalars['ID'];
  position: AmpPositionInput;
  revision: Scalars['Int'];
};

export type AmpNodeRemoveInput = {
  canvasId: Scalars['ID'];
  nodeId: Scalars['ID'];
  revision: Scalars['Int'];
};

export type AmpNodeWriteResult = {
  __typename?: 'AmpNodeWriteResult';
  current?: Maybe<AmpCanvasNode>;
  node?: Maybe<AmpCanvasNode>;
  status: Scalars['String'];
};

export type AmpPositionInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z_index?: InputMaybe<Scalars['Int']>;
};

export type AmpProjectExternalRefInput = {
  id: Scalars['String'];
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export const AmpProjectLinkKind = {
  Action: 'action',
  ActionPlan: 'action_plan',
  Ad: 'ad',
  Audience: 'audience',
  BriefVersion: 'brief_version',
  Campaign: 'campaign',
  CampaignArtifact: 'campaign_artifact',
  ChatSession: 'chat_session',
  Email: 'email',
  External: 'external',
  File: 'file',
  NativeDeliveryCampaign: 'native_delivery_campaign',
  Opportunity: 'opportunity',
  Sync: 'sync'
} as const;

export type AmpProjectLinkKind = typeof AmpProjectLinkKind[keyof typeof AmpProjectLinkKind];
export type AmpProjectLinkResult = {
  __typename?: 'AmpProjectLinkResult';
  id: Scalars['ID'];
  linkId: Scalars['ID'];
};

/**
 * One of id (for a Hightouch object) or external (for anything else).
 * destinationId files an external object under the connected destination it
 * belongs to.
 */
export type AmpProjectLinkTargetInput = {
  destinationId?: InputMaybe<Scalars['ID']>;
  external?: InputMaybe<AmpExternalRefInput>;
  id?: InputMaybe<Scalars['ID']>;
  kind: AmpProjectLinkKind;
};

export type AmpProjectMutationResult = {
  __typename?: 'AmpProjectMutationResult';
  id: Scalars['ID'];
};

export const AmpProjectStatus = {
  Done: 'done',
  Draft: 'draft',
  InProgress: 'in_progress'
} as const;

export type AmpProjectStatus = typeof AmpProjectStatus[keyof typeof AmpProjectStatus];
export type AmpSlidesContent = {
  __typename?: 'AmpSlidesContent';
  downloadUrl?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  slideCount?: Maybe<Scalars['Int']>;
  slideIds: Array<Scalars['ID']>;
  slideUrls: Array<Scalars['String']>;
};

export type AmpTaskApprovalMove = {
  __typename?: 'AmpTaskApprovalMove';
  id: Scalars['ID'];
  statusId: Scalars['ID'];
};

export type AmpTaskDecisionWithdrawn = {
  __typename?: 'AmpTaskDecisionWithdrawn';
  taskId: Scalars['ID'];
};

/** An active monitor that wakes the task's agent session or a session it started. */
export type AmpTaskMonitor = {
  __typename?: 'AmpTaskMonitor';
  /** When the source was last read. Null before the first read. */
  checkedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdByName?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** What the agent does when the monitor fires. */
  instructions: Scalars['String'];
  name: Scalars['String'];
  /** True when the monitor ends the first time it fires. */
  once: Scalars['Boolean'];
  /** The source the monitor reads, such as asana.task. */
  sourceType: Scalars['String'];
};

/** The approval met the step, so the task moved on. */
export type AmpTaskReviewAdvanced = {
  __typename?: 'AmpTaskReviewAdvanced';
  taskId: Scalars['ID'];
  toStatusId: Scalars['ID'];
};

export type AmpTaskReviewOutcome = AmpTaskReviewAdvanced | AmpTaskReviewRecorded | AmpTaskReviewRefused;

export type AmpTaskReviewRecorded = {
  __typename?: 'AmpTaskReviewRecorded';
  taskId: Scalars['ID'];
};

export const AmpTaskReviewRefusal = {
  NotTheReviewer: 'not_the_reviewer',
  /**
   * The reviewer row is gone: the task entered a status again, or the reviewer
   * was removed.
   */
  ReviewerReplaced: 'reviewer_replaced'
} as const;

export type AmpTaskReviewRefusal = typeof AmpTaskReviewRefusal[keyof typeof AmpTaskReviewRefusal];
/** Nothing was recorded. */
export type AmpTaskReviewRefused = {
  __typename?: 'AmpTaskReviewRefused';
  reason: AmpTaskReviewRefusal;
};

export type AmpTaskReviewResult = {
  __typename?: 'AmpTaskReviewResult';
  id: Scalars['ID'];
  /** Set when the approval moved the task. */
  statusId?: Maybe<Scalars['ID']>;
};

export const AmpTaskReviewSubmitKind = {
  Approved: 'approved',
  ChangesRequested: 'changes_requested',
  Commented: 'commented'
} as const;

export type AmpTaskReviewSubmitKind = typeof AmpTaskReviewSubmitKind[keyof typeof AmpTaskReviewSubmitKind];
export const AmpTaskStatusCategory = {
  Active: 'active',
  Backlog: 'backlog',
  Done: 'done',
  Review: 'review'
} as const;

export type AmpTaskStatusCategory = typeof AmpTaskStatusCategory[keyof typeof AmpTaskStatusCategory];
export type AmpTaskTagResult = {
  __typename?: 'AmpTaskTagResult';
  id: Scalars['ID'];
  tagId: Scalars['ID'];
};

/** A user or group on a task: one of userId or userGroupId. */
export type AmpTaskUserInput = {
  userGroupId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type AmpTaskWithdrawOutcome = AmpTaskDecisionWithdrawn | AmpTaskWithdrawalRefused;

export const AmpTaskWithdrawalRefusal = {
  NotTheReviewer: 'not_the_reviewer',
  NothingToWithdraw: 'nothing_to_withdraw',
  /**
   * The reviewer row is gone: the task entered a status again, or the reviewer
   * was removed.
   */
  ReviewerReplaced: 'reviewer_replaced'
} as const;

export type AmpTaskWithdrawalRefusal = typeof AmpTaskWithdrawalRefusal[keyof typeof AmpTaskWithdrawalRefusal];
/** Nothing was withdrawn. */
export type AmpTaskWithdrawalRefused = {
  __typename?: 'AmpTaskWithdrawalRefused';
  reason: AmpTaskWithdrawalRefusal;
};

export type AmpUploadContent = {
  __typename?: 'AmpUploadContent';
  downloadUrl: Scalars['String'];
  filename: Scalars['String'];
  filetype: Scalars['String'];
};

export type AnalyticsCohortDefinitionInput = {
  filter: Scalars['JSONObject'];
  name?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type AnalyticsCohortDefinitionOutput = {
  __typename?: 'AnalyticsCohortDefinitionOutput';
  filter: Scalars['JSONObject'];
  name?: Maybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  subsetIds?: Maybe<Array<Scalars['String']>>;
};

export type AnalyzeEntryEventDistributionInput = {
  eventRelationshipId: Scalars['String'];
  /**
   * Template strings from the live editor, keyed by channel field. Only the
   * entry-event variables the message actually references are analyzed.
   */
  templateData: Scalars['JSONObject'];
};

export type AnalyzeMessagePreviewInput = {
  /** Template strings from the live editor, keyed by channel field. */
  templateData: Scalars['JSONObject'];
};

export type AnalyzedEventField = {
  __typename?: 'AnalyzedEventField';
  field: Scalars['String'];
  type: Scalars['String'];
};

export type AnalyzedEventSchema = {
  __typename?: 'AnalyzedEventSchema';
  eventType: Scalars['String'];
  fields: Array<AnalyzedEventField>;
};

export type ApplyEspUserFieldsImportResult = {
  __typename?: 'ApplyEspUserFieldsImportResult';
  importedCount: Scalars['Int'];
  skippedCount: Scalars['Int'];
};

export type ApplyIdrChangePlanErrorResponse = {
  __typename?: 'ApplyIdrChangePlanErrorResponse';
  error: Scalars['String'];
};

export type ApplyIdrChangePlanInput = {
  messageContentIndex?: InputMaybe<Scalars['Int']>;
  messageId?: InputMaybe<Scalars['uuid']>;
  plan: Scalars['JSONObject'];
};

export type ApplyIdrChangePlanResponse = ApplyIdrChangePlanErrorResponse | ApplyIdrChangePlanStaleResponse | ApplyIdrChangePlanSuccessResponse;

export type ApplyIdrChangePlanStaleResponse = {
  __typename?: 'ApplyIdrChangePlanStaleResponse';
  error: Scalars['String'];
};

export type ApplyIdrChangePlanSuccessResponse = {
  __typename?: 'ApplyIdrChangePlanSuccessResponse';
  graphId: Scalars['String'];
};

export type ApplyVariantSuggestionInput = {
  feedback?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  suggestedValue: Scalars['String'];
  userEditedValue?: InputMaybe<Scalars['String']>;
  variableName: Scalars['String'];
};

export type ApproveActionPlanInput = {
  planId?: InputMaybe<Scalars['uuid']>;
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type AprimoClassification = {
  __typename?: 'AprimoClassification';
  id: Scalars['String'];
  name: Scalars['String'];
  subfolderCount: Scalars['Int'];
};

export type AprimoClassificationTreeResult = {
  __typename?: 'AprimoClassificationTreeResult';
  classifications: Array<AprimoClassification>;
};

export type AprimoFieldOptionItem = {
  __typename?: 'AprimoFieldOptionItem';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type AprimoMetadataFieldOption = {
  __typename?: 'AprimoMetadataFieldOption';
  dataType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  options?: Maybe<Array<AprimoFieldOptionItem>>;
  value: Scalars['String'];
};

export type AprimoMetadataFieldOptionsInput = {
  extensionId?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['JSON']>;
};

export type ArchiveCepWhatsAppTemplateResult = {
  __typename?: 'ArchiveCepWhatsAppTemplateResult';
  id: Scalars['ID'];
};

export type ArchivedFailure = {
  __typename?: 'ArchivedFailure';
  errors: Array<ArchivedFailureError>;
  eventType: Scalars['String'];
  payload: Scalars['JSONObject'];
  receivedAt: Scalars['String'];
};

export type ArchivedFailureError = {
  __typename?: 'ArchivedFailureError';
  message: Scalars['String'];
  table: Scalars['String'];
};

export type AsanaAttachAssetsResponse = {
  __typename?: 'AsanaAttachAssetsResponse';
  /** Poll `asanaAssetAttachment` with this. */
  jobId: Scalars['ID'];
};

export type AsanaAttachStatus = {
  __typename?: 'AsanaAttachStatus';
  attached: Scalars['Int'];
  failed: Scalars['Int'];
  status: Scalars['String'];
};

export type AsanaAttachment = {
  __typename?: 'AsanaAttachment';
  createdAt?: Maybe<Scalars['String']>;
  gid: Scalars['ID'];
  /** True when this attachment is the link back to the campaign being viewed. */
  isCurrentCampaign: Scalars['Boolean'];
  name: Scalars['String'];
  sizeBytes?: Maybe<Scalars['Float']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type AsanaAttachmentSection = {
  __typename?: 'AsanaAttachmentSection';
  error?: Maybe<Scalars['String']>;
  items: Array<AsanaAttachment>;
};

export type AsanaComment = {
  __typename?: 'AsanaComment';
  authorName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  gid: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  textHtml?: Maybe<Scalars['String']>;
};

export type AsanaCommentSection = {
  __typename?: 'AsanaCommentSection';
  error?: Maybe<Scalars['String']>;
  items: Array<AsanaComment>;
};

export type AsanaCustomField = {
  __typename?: 'AsanaCustomField';
  dateValue?: Maybe<Scalars['String']>;
  displayValue?: Maybe<Scalars['String']>;
  /** Selectable options only — a disabled option still renders as a value. */
  enumOptions: Array<AsanaEnumOption>;
  enumValue?: Maybe<AsanaEnumOption>;
  gid: Scalars['ID'];
  /** False for formula fields and types with no editor; rendering one would 400 on save. */
  isEditable: Scalars['Boolean'];
  /** Whether the field belongs to the workspace rather than to any one project. */
  isWorkspaceWide: Scalars['Boolean'];
  multiEnumValues: Array<AsanaEnumOption>;
  name: Scalars['String'];
  numberValue?: Maybe<Scalars['Float']>;
  peopleValue: Array<AsanaNamedRef>;
  textValue?: Maybe<Scalars['String']>;
  /** text | number | enum | multi_enum | date | people */
  type: Scalars['String'];
};

/** Custom fields under the project defining them. A null project is the trailing group: workspace-wide fields, and any whose project could not be read. */
export type AsanaCustomFieldGroup = {
  __typename?: 'AsanaCustomFieldGroup';
  fields: Array<AsanaCustomField>;
  /** True only when every field in the group is workspace-wide, so an unattributed field is never labelled global. */
  isWorkspaceWide: Scalars['Boolean'];
  project?: Maybe<AsanaNamedRef>;
};

export type AsanaCustomFieldWriteInput = {
  dateValue?: InputMaybe<Scalars['String']>;
  enumOptionGid?: InputMaybe<Scalars['ID']>;
  gid: Scalars['ID'];
  multiEnumOptionGids?: InputMaybe<Array<Scalars['ID']>>;
  numberValue?: InputMaybe<Scalars['Float']>;
  peopleGids?: InputMaybe<Array<Scalars['ID']>>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type AsanaEnumOption = {
  __typename?: 'AsanaEnumOption';
  color?: Maybe<Scalars['String']>;
  gid: Scalars['ID'];
  name: Scalars['String'];
};

export type AsanaNamedRef = {
  __typename?: 'AsanaNamedRef';
  gid: Scalars['ID'];
  name: Scalars['String'];
};

/** A value that may be cleared. Omitting the wrapper leaves the field untouched; passing one with a null value clears it. */
export type AsanaNullableValue = {
  value?: InputMaybe<Scalars['String']>;
};

/** The workflow status a custom-typed task carries. Separate from completion, and null on an ordinary task. */
export type AsanaStatus = {
  __typename?: 'AsanaStatus';
  currentColor?: Maybe<Scalars['String']>;
  currentGid?: Maybe<Scalars['ID']>;
  currentName?: Maybe<Scalars['String']>;
  /** In the workflow's own order; disabled states are excluded. */
  options: Array<AsanaStatusOption>;
  typeName: Scalars['String'];
};

export type AsanaStatusOption = {
  __typename?: 'AsanaStatusOption';
  color?: Maybe<Scalars['String']>;
  gid: Scalars['ID'];
  /** Whether Asana treats this state as completing the task. */
  isComplete: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AsanaSubtask = {
  __typename?: 'AsanaSubtask';
  assignee?: Maybe<AsanaNamedRef>;
  completed: Scalars['Boolean'];
  dueOn?: Maybe<Scalars['String']>;
  gid: Scalars['ID'];
  name: Scalars['String'];
  permalinkUrl?: Maybe<Scalars['String']>;
};

/** An error rather than an empty list, so a failed section is not shown as an empty one. */
export type AsanaSubtaskSection = {
  __typename?: 'AsanaSubtaskSection';
  error?: Maybe<Scalars['String']>;
  items: Array<AsanaSubtask>;
};

export type AsanaTaskActivity = {
  __typename?: 'AsanaTaskActivity';
  attachments: AsanaAttachmentSection;
  comments: AsanaCommentSection;
  subtasks: AsanaSubtaskSection;
};

export type AsanaTaskDetail = {
  __typename?: 'AsanaTaskDetail';
  assignee?: Maybe<AsanaNamedRef>;
  completed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['String']>;
  /** The same fields under the project that defines each, as Asana groups them. */
  customFieldGroups: Array<AsanaCustomFieldGroup>;
  /** Every field, flat. A write resolves a field by gid against this, not against the groups. */
  customFields: Array<AsanaCustomField>;
  dueOn?: Maybe<Scalars['String']>;
  followers: Array<AsanaNamedRef>;
  htmlNotes?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['String']>;
  /** Read-only. Asana descriptions carry embeds and mentions a round trip would destroy. */
  name: Scalars['String'];
  permalinkUrl: Scalars['String'];
  /** The primary project — the first membership. */
  project?: Maybe<AsanaNamedRef>;
  /** Every project the task belongs to, primary first. */
  projects: Array<AsanaTaskProject>;
  section?: Maybe<AsanaNamedRef>;
  status?: Maybe<AsanaStatus>;
  taskGid: Scalars['ID'];
  workspace?: Maybe<AsanaNamedRef>;
};

export type AsanaTaskProject = {
  __typename?: 'AsanaTaskProject';
  project: AsanaNamedRef;
  section?: Maybe<AsanaNamedRef>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  alwaysInjectIntoContext: Scalars['Boolean'];
  assetCount: Scalars['Int'];
  /** The kind of asset held, or null when the collection accepts any kind. */
  baseType?: Maybe<Scalars['String']>;
  brandProfileIds: Array<Scalars['String']>;
  /**
   * True when a DAM writes into this collection. Its contents belong to the
   * sync, so it is not an upload target.
   */
  damSynced: Scalars['Boolean'];
  id: Scalars['ID'];
  imageGuardrails?: Maybe<Scalars['JSON']>;
  instructions: Scalars['String'];
  name: Scalars['String'];
  /** What feeds the collection. Null for a collection users upload into. */
  syncKind?: Maybe<AssetCollectionSyncKind>;
  /** True for backend-owned collections; only instructions are editable. */
  system: Scalars['Boolean'];
};

export type AssetCollectionInput = {
  alwaysInjectIntoContext?: InputMaybe<Scalars['Boolean']>;
  /** Omit or send null for a collection that accepts any kind. */
  baseType?: InputMaybe<Scalars['String']>;
  brandProfileIds?: InputMaybe<Array<Scalars['String']>>;
  imageGuardrails?: InputMaybe<Scalars['JSON']>;
  instructions?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * dam for a collection a DAM syncs into, which takes every kind and ignores
   * baseType. Omit or send null for a collection users upload into. Set once,
   * at creation.
   */
  syncKind?: InputMaybe<AssetCollectionSyncKind>;
};

/**
 * Every field is optional: only what is supplied is written, so a caller
 * editing one thing never round-trips the whole definition.
 */
export type AssetCollectionPatch = {
  alwaysInjectIntoContext?: InputMaybe<Scalars['Boolean']>;
  baseType?: InputMaybe<Scalars['String']>;
  brandProfileIds?: InputMaybe<Array<Scalars['String']>>;
  imageGuardrails?: InputMaybe<Scalars['JSON']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export const AssetCollectionSyncKind = {
  AdPlatform: 'ad_platform',
  Dam: 'dam',
  Getty: 'getty',
  Product: 'product'
} as const;

export type AssetCollectionSyncKind = typeof AssetCollectionSyncKind[keyof typeof AssetCollectionSyncKind];
export type AssetColumn = {
  __typename?: 'AssetColumn';
  name: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

/**
 * Where a thread is pinned, validated against the comment anchor schema: kind
 * is point (the default, for clients that predate kinds), canvas, inline, or slide.
 * point takes x and y as fractions of the rendered asset (0..1) and t in
 * seconds into a video; canvas takes x and y in canvas coordinates; inline
 * takes no fields, its marker living in the content. slide takes a persistent slideId.
 */
export type AssetCommentAnchorInput = {
  kind?: InputMaybe<Scalars['String']>;
  slideId?: InputMaybe<Scalars['ID']>;
  t?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

/**
 * One row of the notification feed, with everything it renders. body is null
 * only for an agent reply that is still pending or has failed; author is null
 * if its row lost the join.
 *
 * Names travel with the comment rather than being resolved by the caller: this
 * feed spans the workspace, so a caller has no subject to scope a follow-up
 * query by and would be fetching them back by id, a round trip per page.
 */
export type AssetCommentFeedEntry = {
  __typename?: 'AssetCommentFeedEntry';
  author?: Maybe<UnreadAssetCommentActor>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['uuid'];
  /**
   * Whether the caller still has this to catch up on. Always true under the
   * UNREAD filter; under ALL it is the row's unread marker, computed by the
   * same expression UNREAD filters on so the two can never disagree.
   */
  isUnread: Scalars['Boolean'];
  mentions: Array<UnreadAssetCommentActor>;
  status: Scalars['String'];
  thread: UnreadAssetCommentThread;
  updatedAt: Scalars['String'];
};

/**
 * Which half of the feed to read. Both are comment-grained — three replies to
 * one thread are three rows. UNREAD returns only what the caller hasn't caught
 * up on; ALL returns every comment, each carrying its own isUnread.
 */
export const AssetCommentFeedFilter = {
  All: 'ALL',
  Unread: 'UNREAD'
} as const;

export type AssetCommentFeedFilter = typeof AssetCommentFeedFilter[keyof typeof AssetCommentFeedFilter];
export type AssetCommentFeedPage = {
  __typename?: 'AssetCommentFeedPage';
  comments: Array<AssetCommentFeedEntry>;
  /** Opaque; pass back as the cursor argument for the next page. Null at the end. */
  nextCursor?: Maybe<Scalars['String']>;
};

/**
 * Someone the comment mentions. Exactly one field must be set; agent is true
 * for Hightouch's agent.
 */
export type AssetCommentMentionInput = {
  agent?: InputMaybe<Scalars['Boolean']>;
  reviewAgentId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AssetCommentPayload = {
  __typename?: 'AssetCommentPayload';
  commentId: Scalars['uuid'];
  status: Scalars['String'];
  threadId: Scalars['uuid'];
};

/**
 * One agent's review of one ad, and what came of it.
 *
 * Exactly one of threadId and failure is set. A threadId means the thread
 * exists, is visible on its ad, and has an agent run behind it.
 */
export type AssetCommentReview = {
  __typename?: 'AssetCommentReview';
  failure?: Maybe<AssetCommentReviewFailure>;
  reviewAgentId: Scalars['uuid'];
  threadId?: Maybe<Scalars['uuid']>;
};

/**
 * Why a requested review is not coming. The two differ in what they leave on the
 * ad: run_not_started has a thread holding a reply marked failed, so there is
 * something to look at, while thread_not_opened left no trace of the request.
 */
export const AssetCommentReviewFailure = {
  RunNotStarted: 'run_not_started',
  ThreadNotOpened: 'thread_not_opened'
} as const;

export type AssetCommentReviewFailure = typeof AssetCommentReviewFailure[keyof typeof AssetCommentReviewFailure];
/**
 * The reviews started on one ad. An agent only reviews ads of its own brand, so
 * this carries the agents that matched rather than every agent asked for, and is
 * empty for an ad none of them matched.
 */
export type AssetCommentReviewResult = {
  __typename?: 'AssetCommentReviewResult';
  adBriefAssetId: Scalars['uuid'];
  reviews: Array<AssetCommentReview>;
};

/**
 * The asset a thread hangs off. Exactly one field must be set. channelSizeId is
 * valid only with adBriefAssetId, and scopes the thread to one rendered size
 * rather than to the asset across all of them. It identifies the channel size,
 * not a size-variant row, so the thread survives regeneration. Omit it to
 * comment on the primary size, which has no channel of its own.
 *
 * ampProjectId and ampTaskId open a thread on an AMP board project or task in
 * the caller's workspace. settingsEntityId opens one on a canvas doc or upload
 * the caller can see, and ampCanvasId one on a canvas itself. Those take no
 * version and cannot mention review agents, since there is no render to review.
 */
export type AssetCommentSubjectInput = {
  adBriefAssetId?: InputMaybe<Scalars['uuid']>;
  ampCanvasId?: InputMaybe<Scalars['uuid']>;
  ampProjectId?: InputMaybe<Scalars['uuid']>;
  ampTaskId?: InputMaybe<Scalars['uuid']>;
  campaignArtifactId?: InputMaybe<Scalars['uuid']>;
  channelSizeId?: InputMaybe<Scalars['uuid']>;
  contentEmailId?: InputMaybe<Scalars['uuid']>;
  settingsEntityId?: InputMaybe<Scalars['uuid']>;
};

export type AssetCommentThreadPayload = {
  __typename?: 'AssetCommentThreadPayload';
  status: Scalars['String'];
  threadId: Scalars['uuid'];
};

/**
 * The asset a thread hangs off — the outbound mirror of
 * AssetCommentSubjectInput, and what a caller needs to link to the thread.
 * Exactly one id is set; channelSizeId only ever accompanies adBriefAssetId.
 */
export type AssetCommentThreadSubject = {
  __typename?: 'AssetCommentThreadSubject';
  adBriefAssetId?: Maybe<Scalars['uuid']>;
  ampCanvasId?: Maybe<Scalars['uuid']>;
  ampProjectId?: Maybe<Scalars['uuid']>;
  ampTaskId?: Maybe<Scalars['uuid']>;
  campaignArtifactId?: Maybe<Scalars['uuid']>;
  channelSizeId?: Maybe<Scalars['uuid']>;
  contentEmailId?: Maybe<Scalars['uuid']>;
  settingsEntityId?: Maybe<Scalars['uuid']>;
};

/**
 * The asset version the comment was written against. Tracking only — comments
 * carry across versions until their thread is resolved. Exactly one version id
 * may be set. sizeVariantId is only valid alongside adVersionId and is not
 * recorded: a resize is its own ad, so adVersionId names its render.
 */
export type AssetCommentVersionInput = {
  adVersionId?: InputMaybe<Scalars['uuid']>;
  campaignVersionId?: InputMaybe<Scalars['uuid']>;
  emailVersionId?: InputMaybe<Scalars['uuid']>;
  sizeVariantId?: InputMaybe<Scalars['uuid']>;
};

export type AssetData = {
  __typename?: 'AssetData';
  assetColumns: Array<AssetColumn>;
  id: Scalars['String'];
  metricAttribution: Array<AssetMetricAttribution>;
};

export type AssetMetricAttribution = {
  __typename?: 'AssetMetricAttribution';
  attributionMethodId?: Maybe<Scalars['String']>;
  attributionValue: Scalars['Float'];
  goalId: Scalars['String'];
};

export type AssetModelColumn = {
  modelId: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AssetModelConfigurationInput = {
  primary_key_column?: InputMaybe<Scalars['String']>;
  primary_label_column?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/**
 * A user who has acted on or been mentioned on an ad, for naming them where the
 * Hasura users permission hides them.
 */
export type AssetRelevantUser = {
  __typename?: 'AssetRelevantUser';
  isHightouchStaff: Scalars['Boolean'];
  name: Scalars['String'];
  userId: Scalars['Int'];
};

export type AssetTagDimension = {
  __typename?: 'AssetTagDimension';
  appliesTo: Array<Scalars['String']>;
  assetGroupId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  multi: Scalars['Boolean'];
  name: Scalars['String'];
  /** The tagger may leave this dimension unset when it does not apply to an asset. */
  nullable: Scalars['Boolean'];
  valueType: Scalars['String'];
  values: Array<AssetTagValue>;
  version: Scalars['Int'];
};

export type AssetTagValue = {
  __typename?: 'AssetTagValue';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type AssignableUserGroup = {
  __typename?: 'AssignableUserGroup';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AssociateStaticListToAudienceInput = {
  audienceChanges?: InputMaybe<CampaignCsvAudienceChangesInput>;
  audienceId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type AssociateStaticListToAudienceResult = {
  __typename?: 'AssociateStaticListToAudienceResult';
  audienceId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type AthenaCredentials = {
  accessKeyId?: InputMaybe<Scalars['String']>;
  apiSecret?: InputMaybe<Scalars['String']>;
  credentialId?: InputMaybe<Scalars['Int']>;
};

export type AthenaDataCatalog = {
  __typename?: 'AthenaDataCatalog';
  name: Scalars['String'];
};

export type AthenaDatabase = {
  __typename?: 'AthenaDatabase';
  name: Scalars['String'];
};

export type AthenaListDataCatalogsResult = {
  __typename?: 'AthenaListDataCatalogsResult';
  dataCatalogs: Array<AthenaDataCatalog>;
};

export type AthenaListDatabasesResult = {
  __typename?: 'AthenaListDatabasesResult';
  databases: Array<AthenaDatabase>;
};

export type AthenaListWorkGroupsResult = {
  __typename?: 'AthenaListWorkGroupsResult';
  workGroups: Array<AthenaWorkGroup>;
};

export type AthenaWorkGroup = {
  __typename?: 'AthenaWorkGroup';
  name: Scalars['String'];
};

export type AttachCampaignAssetsToAsanaTaskInput = {
  campaignId: Scalars['ID'];
  /** Email candidates. Push and SMS carry no renderable email and are rejected. */
  candidateIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Attaches the brief's current version as a PDF. */
  includeBrief?: InputMaybe<Scalars['Boolean']>;
  /** Sample personalization data, as the PNG export modal sends it. Absent, candidates render with their template variables as written. */
  personalization?: InputMaybe<Scalars['JSON']>;
  /** Dynamic-content branch per slot, as the PNG export modal sends it. */
  slotSelections?: InputMaybe<Scalars['JSON']>;
};

export type AttemptedRow = {
  __typename?: 'AttemptedRow';
  batchId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['JSONObject']>;
  fields: Scalars['String'];
  fieldsOmittedBytes?: Maybe<Scalars['Float']>;
  fieldsOmittedReason?: Maybe<AttemptedRowFieldsOmittedReason>;
  id: Scalars['String'];
  isBatchError?: Maybe<Scalars['Boolean']>;
  opType: SyncOp;
  rejected: Scalars['Boolean'];
  rejectionReason?: Maybe<Scalars['String']>;
  requestInfoKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export const AttemptedRowFieldsOmittedReason = {
  PageTooLarge: 'PAGE_TOO_LARGE',
  RowTooLarge: 'ROW_TOO_LARGE'
} as const;

export type AttemptedRowFieldsOmittedReason = typeof AttemptedRowFieldsOmittedReason[keyof typeof AttemptedRowFieldsOmittedReason];
export type AttemptedRowsPaginationOptions = {
  limit: Scalars['Int'];
  pageKey?: InputMaybe<Scalars['String']>;
};

export type AttemptedRowsResult = {
  __typename?: 'AttemptedRowsResult';
  nextPageKey?: Maybe<Scalars['String']>;
  rows: Array<Maybe<AttemptedRow>>;
};

export const AttributionType = {
  LastTouch: 'last_touch',
  MultiTouch: 'multi_touch'
} as const;

export type AttributionType = typeof AttributionType[keyof typeof AttributionType];
export type Audience = {
  __typename?: 'Audience';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AudienceComparisonBackgroundError = {
  __typename?: 'AudienceComparisonBackgroundError';
  error: Scalars['String'];
};

export type AudienceComparisonBackgroundJob = {
  __typename?: 'AudienceComparisonBackgroundJob';
  jobId: Scalars['String'];
};

export type AudienceComparisonBackgroundResponse = {
  __typename?: 'AudienceComparisonBackgroundResponse';
  result?: Maybe<AudienceComparisonBackgroundResponseData>;
};

export type AudienceComparisonBackgroundResponseData = AudienceComparisonBackgroundError | AudienceComparisonResult;

export type AudienceComparisonResult = {
  __typename?: 'AudienceComparisonResult';
  allAudiencesOverlapSize: Scalars['Float'];
  audienceSize: Scalars['Float'];
  comparisons: Array<AudienceComparisonStats>;
  sampledModelsRate?: Maybe<Scalars['Float']>;
  usedSampledModels?: Maybe<Scalars['Boolean']>;
};

export type AudienceComparisonStats = {
  __typename?: 'AudienceComparisonStats';
  audienceId: Scalars['String'];
  audienceSize: Scalars['Float'];
  overlapSize: Scalars['Float'];
};

export type AudienceFilterCreator = {
  __typename?: 'AudienceFilterCreator';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AudienceFilterOptions = {
  __typename?: 'AudienceFilterOptions';
  creators: Array<AudienceFilterCreator>;
  hasMatchboosterAudiences: Scalars['Boolean'];
  hasRealtimeAudiences: Scalars['Boolean'];
  parentModels: Array<AudienceFilterParentModel>;
  sources: Array<AudienceFilterSource>;
  subsets: Array<AudienceFilterSubset>;
};

export type AudienceFilterParentModel = {
  __typename?: 'AudienceFilterParentModel';
  id: Scalars['String'];
  name: Scalars['String'];
  sourceIcon?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
};

export type AudienceFilterSource = {
  __typename?: 'AudienceFilterSource';
  definitionName?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AudienceFilterSubset = {
  __typename?: 'AudienceFilterSubset';
  groupName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AudienceLabelPair = {
  __typename?: 'AudienceLabelPair';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AudienceMembership = {
  __typename?: 'AudienceMembership';
  audience_id: Scalars['String'];
  last_event_time: Scalars['String'];
  user_id: Scalars['String'];
};

export type AudienceMembershipsBackgroundResult = AudienceMembershipsResponse | ProfileExplorerError;

export type AudienceMembershipsResponse = {
  __typename?: 'AudienceMembershipsResponse';
  currentAudienceMemberships: Array<Array<AudienceMembership>>;
  parentModelId: Scalars['String'];
  pastAudienceMemberships: Array<Array<AudienceMembership>>;
  userIds: Array<Scalars['String']>;
};

export type AudienceReferenceStats = {
  __typename?: 'AudienceReferenceStats';
  journeys: Array<JourneysRatio>;
  modelColumns: Array<ModelColumnsRatio>;
  modelRelationships: Array<ModelRelationshipsRatio>;
  segments: Array<SegmentsRatio>;
  traits: Array<TraitsRatio>;
};

export type AudienceSizeMetric = {
  __typename?: 'AudienceSizeMetric';
  timestamp: Scalars['UnixEpochTimestamp'];
  value: Scalars['bigint'];
};

export type AudienceSizeMetricsInput = {
  audienceId: Scalars['bigint'];
  endTime: Scalars['UnixEpochTimestamp'];
  interval: Interval;
  startTime: Scalars['UnixEpochTimestamp'];
};

export type AudienceSizeMetricsResult = {
  __typename?: 'AudienceSizeMetricsResult';
  data: Array<AudienceSizeMetric>;
};

export type AudienceSnapshotAtPull = {
  __typename?: 'AudienceSnapshotAtPull';
  /** The audience's visual_query_filter at the time of the pull. */
  visualQueryFilter?: Maybe<Scalars['JSONObject']>;
};

export type AuditLogFilters = {
  api_key_ids?: InputMaybe<Array<Scalars['String']>>;
  end_date?: InputMaybe<Scalars['String']>;
  filtered_resources?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Changelog row primary key. When set, narrows the result to that one row. The
   * audit log drawer uses this to re-fetch a single row's `old` / `new` payload on
   * demand after the user clicks a list row.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether the response should include the heavy `old` / `new` jsonb payloads for
   * each row. Defaults to true for backwards compatibility. The audit log settings
   * page list sets this to false; the drawer re-issues with `id` set and
   * `include_diffs: true` to fetch one row's diff on demand. The backend still
   * reads the jsonb columns (it needs them to derive `action` and disambiguate
   * audience/audience-schema/model rows) but drops them from the response, which
   * cuts Hasura→API→browser bytes and browser JSON-parse time. A follow-up should
   * move the derived metadata to scalar columns so Hasura can skip the jsonb entirely.
   */
  include_diffs?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  resource_id?: InputMaybe<Scalars['String']>;
  resource_name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  user_ids?: InputMaybe<Array<Scalars['String']>>;
};

export type AuthorizedReviewers = {
  __typename?: 'AuthorizedReviewers';
  userIds: Array<Scalars['String']>;
};

export type AvailableEventMetric = {
  __typename?: 'AvailableEventMetric';
  aggType: EventsAggregateTypeEnum;
  dimensions: EventDimensions;
  maxTimestamp: Scalars['UnixEpochTimestamp'];
  metric: EventsMetricEnum;
  minTimestamp: Scalars['UnixEpochTimestamp'];
  value: Scalars['Float'];
};

export type AvailableEventMetrics = {
  __typename?: 'AvailableEventMetrics';
  id: Scalars['String'];
  resourceType: EventsResourceType;
  results: Array<AvailableEventMetric>;
};

export type AvailableFeature = {
  __typename?: 'AvailableFeature';
  dimension: Scalars['String'];
  featureType: Scalars['String'];
};

export type AvailableFeatures = {
  __typename?: 'AvailableFeatures';
  features: Array<AvailableFeature>;
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  created_at: Scalars['String'];
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: JobStatus;
};

export type BackgroundJobErrorResponse = {
  __typename?: 'BackgroundJobErrorResponse';
  error: Scalars['String'];
};

export type BackgroundJobInput = {
  jobId: Scalars['String'];
};

export type BackgroundJobResponse = BackgroundJobErrorResponse | BackgroundJobSuccessResponse;

export type BackgroundJobResult = {
  __typename?: 'BackgroundJobResult';
  jobId: Scalars['String'];
};

export type BackgroundJobSuccessResponse = {
  __typename?: 'BackgroundJobSuccessResponse';
  jobId: Scalars['uuid'];
};

export type BackgroundQueryResult = {
  __typename?: 'BackgroundQueryResult';
  immediateData?: Maybe<Scalars['JSONObject']>;
  jobId?: Maybe<Scalars['String']>;
};

export type Base = {
  __typename?: 'Base';
  id: Scalars['String'];
  name: Scalars['String'];
  permissionLevel: Scalars['String'];
};

export type BeefreeAccessToken = {
  __typename?: 'BeefreeAccessToken';
  access_token: Scalars['String'];
  v2: Scalars['Boolean'];
};

export type BillingChartEmbedUrlResult = {
  __typename?: 'BillingChartEmbedUrlResult';
  url: Scalars['String'];
};

export type BillingOrganization = {
  __typename?: 'BillingOrganization';
  billing?: Maybe<Scalars['JSONObject']>;
  entitlements?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  plan?: Maybe<Plan>;
  slug: Scalars['String'];
  workspaces: Array<Workspace>;
};

export const BinIntervalTypeEnum = {
  Days: 'DAYS',
  Hours: 'HOURS',
  Minutes: 'MINUTES',
  Weeks: 'WEEKS'
} as const;

export type BinIntervalTypeEnum = typeof BinIntervalTypeEnum[keyof typeof BinIntervalTypeEnum];
export type BingAdAccount = {
  __typename?: 'BingAdAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BingAdAccountInput = {
  bingAdsDestinationId: Scalars['bigint'];
};

export type BlockedApiKey = {
  __typename?: 'BlockedApiKey';
  id: Scalars['String'];
  lastUsed?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerEmail: Scalars['String'];
  ownerName?: Maybe<Scalars['String']>;
  workspaceName?: Maybe<Scalars['String']>;
};

export type BlocklistQuery = {
  _placeholder?: InputMaybe<Scalars['JSONObject']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BounceBreakdownBucket = {
  __typename?: 'BounceBreakdownBucket';
  count: Scalars['Int'];
  /** Raw grouping key: the base SMTP code (e.g. "550") or the recipient domain (e.g. "gmail.com"); "other" for the rolled-up long tail. */
  key: Scalars['String'];
  /** The raw keys rolled into this bucket, sorted desc. Populated only on the "other" bucket so the UI can reveal the long tail; empty otherwise. */
  subBuckets: Array<BounceBreakdownSubBucket>;
};

export type BounceBreakdownSubBucket = {
  __typename?: 'BounceBreakdownSubBucket';
  count: Scalars['Int'];
  /** A single raw key (base SMTP code or recipient domain) rolled into the "other" bucket. */
  key: Scalars['String'];
};

export type BrandProfile = {
  __typename?: 'BrandProfile';
  brand_guidelines?: Maybe<Scalars['String']>;
  brand_guidelines_source_file?: Maybe<Scalars['JSON']>;
  business_context?: Maybe<Scalars['String']>;
  company_information: Scalars['JSON'];
  created_at: Scalars['String'];
  fonts: Scalars['JSON'];
  id: Scalars['uuid'];
  is_default: Scalars['Boolean'];
  logos: Scalars['JSON'];
  name: Scalars['String'];
  updated_at: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

export type BrandProfileAssignment = {
  __typename?: 'BrandProfileAssignment';
  id: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
};

/**
 * One brand profile's font index, with every entry's typographic identity
 * filled in from the font binary.
 */
export type BrandProfileFonts = {
  __typename?: 'BrandProfileFonts';
  brandProfileId: Scalars['ID'];
  /**
   * The profile's fonts jsonb, shaped as BrandFonts, with every files[]
   * entry enriched. Null when the profile stores no fonts.
   */
  fonts?: Maybe<Scalars['JSON']>;
};

export type BrandProfileReviewColor = {
  __typename?: 'BrandProfileReviewColor';
  hex: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/**
 * The brand profile as accept will persist it: each proposed column replaces
 * the live column, and an omitted column keeps the live value read at load time.
 */
export type BrandProfileReviewContent = {
  __typename?: 'BrandProfileReviewContent';
  colors: Array<BrandProfileReviewColor>;
  fonts: BrandProfileReviewFonts;
  logos: Array<BrandProfileReviewLogo>;
};

export type BrandProfileReviewFontFamily = {
  __typename?: 'BrandProfileReviewFontFamily';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type BrandProfileReviewFontFile = {
  __typename?: 'BrandProfileReviewFontFile';
  familyName?: Maybe<Scalars['String']>;
  fileId: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  /**
   * Fetchable URL for the font bytes: a chat upload resolves through its storage
   * key, a live entry through its stored URL.
   */
  url?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type BrandProfileReviewFonts = {
  __typename?: 'BrandProfileReviewFonts';
  families: Array<BrandProfileReviewFontFamily>;
  files: Array<BrandProfileReviewFontFile>;
};

export type BrandProfileReviewLogo = {
  __typename?: 'BrandProfileReviewLogo';
  description?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  /**
   * Fetchable URL for the image: a chat upload resolves through its storage
   * key, a live entry through its stored URL.
   */
  url?: Maybe<Scalars['String']>;
};

export type BulkDeleteResult = {
  __typename?: 'BulkDeleteResult';
  affected_rows: Scalars['Int'];
};

export type BulkUpsertDecisionEngineMessageError = {
  __typename?: 'BulkUpsertDecisionEngineMessageError';
  error: Scalars['String'];
  flowId: Scalars['uuid'];
  index: Scalars['Int'];
  messageId?: Maybe<Scalars['uuid']>;
};

export type BulkUpsertDecisionEngineMessageInput = {
  autoTag?: InputMaybe<Scalars['Boolean']>;
  flowId: Scalars['uuid'];
  flowMessageConfig?: InputMaybe<Scalars['JSONObject']>;
  message: DecisionEngineMessageInput;
  messageId?: InputMaybe<Scalars['uuid']>;
};

export type BulkUpsertDecisionEngineMessageResult = {
  __typename?: 'BulkUpsertDecisionEngineMessageResult';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type BulkUpsertDecisionEngineMessagesResult = {
  __typename?: 'BulkUpsertDecisionEngineMessagesResult';
  errors: Array<BulkUpsertDecisionEngineMessageError>;
  messages: Array<BulkUpsertDecisionEngineMessageResult>;
};

export type BundleVideoExportsInput = {
  filename?: InputMaybe<Scalars['String']>;
  videoExportIds: Array<Scalars['uuid']>;
};

export type BundleVideoExportsResponse = {
  __typename?: 'BundleVideoExportsResponse';
  bundleId: Scalars['uuid'];
  jobId: Scalars['uuid'];
};

export type BynderCollection = {
  __typename?: 'BynderCollection';
  id: Scalars['String'];
  isPublic: Scalars['Boolean'];
  mediaCount: Scalars['Int'];
  name: Scalars['String'];
};

export type BynderCollectionsResult = {
  __typename?: 'BynderCollectionsResult';
  collections: Array<BynderCollection>;
};

export type BynderMetapropertiesResult = {
  __typename?: 'BynderMetapropertiesResult';
  metaproperties: Array<BynderMetaproperty>;
};

export type BynderMetaproperty = {
  __typename?: 'BynderMetaproperty';
  id: Scalars['String'];
  label: Scalars['String'];
  /** The database name that asset filters use. */
  name: Scalars['String'];
  type: Scalars['String'];
};

export type BynderMetapropertyOption = {
  __typename?: 'BynderMetapropertyOption';
  id: Scalars['String'];
  label: Scalars['String'];
  /** The option name that asset filters use. */
  name: Scalars['String'];
};

export type BynderMetapropertyOptionsResult = {
  __typename?: 'BynderMetapropertyOptionsResult';
  /** True when Bynder has more options than this page; search by name to narrow them. */
  hasMore: Scalars['Boolean'];
  options: Array<BynderMetapropertyOption>;
};

export type BynderTagsResult = {
  __typename?: 'BynderTagsResult';
  tags: Array<Scalars['String']>;
};

export type CachedAudienceSizeResponse = {
  __typename?: 'CachedAudienceSizeResponse';
  audienceId?: Maybe<Scalars['bigint']>;
  evaluatedAt?: Maybe<Scalars['String']>;
  parentModelId: Scalars['bigint'];
  size?: Maybe<Scalars['String']>;
  usedSampledModel?: Maybe<Scalars['Boolean']>;
};

export type CachedAudienceSizesResponse = {
  __typename?: 'CachedAudienceSizesResponse';
  audienceId: Scalars['bigint'];
  evaluatedAt?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  usedSampledModel?: Maybe<Scalars['Boolean']>;
};

export type CalendarContext = {
  __typename?: 'CalendarContext';
  entityId?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  markdown: Scalars['String'];
  versionId?: Maybe<Scalars['ID']>;
};

export type CalendarView = {
  __typename?: 'CalendarView';
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  createdAt: Scalars['String'];
  createdBy: Scalars['ID'];
  filters: Scalars['JSON'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedBy?: Maybe<Scalars['ID']>;
  visibility: CalendarViewVisibility;
};

export const CalendarViewVisibility = {
  Personal: 'PERSONAL',
  Workspace: 'WORKSPACE'
} as const;

export type CalendarViewVisibility = typeof CalendarViewVisibility[keyof typeof CalendarViewVisibility];
export type CampaignAllStats = {
  __typename?: 'CampaignAllStats';
  allTime: Array<CampaignStats>;
  byRun: Array<CampaignRunStats>;
  hourly: Array<CampaignHourlyStats>;
};

export type CampaignAnalyticsDashboardBackgroundResult = {
  __typename?: 'CampaignAnalyticsDashboardBackgroundResult';
  result?: Maybe<CampaignAnalyticsDashboardResultData>;
};

export type CampaignAnalyticsDashboardData = {
  __typename?: 'CampaignAnalyticsDashboardData';
  assets: Array<AssetData>;
  paginationResults: PaginationResults;
};

export type CampaignAnalyticsDashboardError = {
  __typename?: 'CampaignAnalyticsDashboardError';
  error: Scalars['String'];
};

export type CampaignAnalyticsDashboardJobIdentifier = {
  __typename?: 'CampaignAnalyticsDashboardJobIdentifier';
  jobId: Scalars['String'];
};

export type CampaignAnalyticsDashboardResult = {
  __typename?: 'CampaignAnalyticsDashboardResult';
  backgroundJob?: Maybe<CampaignAnalyticsDashboardJobIdentifier>;
};

export type CampaignAnalyticsDashboardResultData = CampaignAnalyticsDashboardData | CampaignAnalyticsDashboardError;

export type CampaignCalendar = {
  __typename?: 'CampaignCalendar';
  filterOptions: CampaignCalendarFilterOptions;
  sends: Array<CampaignCalendarSend>;
  series: Array<CampaignCalendarSeries>;
};

export const CampaignCalendarChannel = {
  Email: 'email',
  InApp: 'in_app',
  Push: 'push',
  Sms: 'sms',
  Unknown: 'unknown',
  WebPush: 'web_push'
} as const;

export type CampaignCalendarChannel = typeof CampaignCalendarChannel[keyof typeof CampaignCalendarChannel];
export type CampaignCalendarConnection = {
  __typename?: 'CampaignCalendarConnection';
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: CampaignCalendarPlatform;
};

export const CampaignCalendarConnectionState = {
  Broken: 'broken',
  Connecting: 'connecting',
  Synced: 'synced',
  Syncing: 'syncing'
} as const;

export type CampaignCalendarConnectionState = typeof CampaignCalendarConnectionState[keyof typeof CampaignCalendarConnectionState];
export type CampaignCalendarConnectorSetup = {
  __typename?: 'CampaignCalendarConnectorSetup';
  /** connecting until Fivetran reports the connector healthy, syncing until its first sync completes, broken when paused or failing. */
  connectionState: CampaignCalendarConnectionState;
  /** Whether a calendar build has published for this connector, even with no sends. Stays true after the connector breaks. */
  hasCalendarData: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  platform: CampaignCalendarPlatform;
};

export type CampaignCalendarEngagementSetup = {
  __typename?: 'CampaignCalendarEngagementSetup';
  connectorId: Scalars['ID'];
  /** native_metrics when the platform reports engagement itself; present once enrichment rows are published. */
  state: CampaignCalendarEngagementState;
};

export const CampaignCalendarEngagementState = {
  Missing: 'missing',
  NativeMetrics: 'native_metrics',
  Present: 'present'
} as const;

export type CampaignCalendarEngagementState = typeof CampaignCalendarEngagementState[keyof typeof CampaignCalendarEngagementState];
export type CampaignCalendarEnrichmentRun = {
  __typename?: 'CampaignCalendarEnrichmentRun';
  sessionId: Scalars['ID'];
  startedAt: Scalars['String'];
  /** The status of the run's latest interaction: pending, complete, failed or canceled. */
  status: Scalars['String'];
};

export type CampaignCalendarEnrichmentStart = {
  __typename?: 'CampaignCalendarEnrichmentStart';
  reason?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['ID']>;
  /** started, or skipped with a reason: disabled, no_warehouse_access, no_connectors, no_parent_model or in_flight. */
  status: Scalars['String'];
};

export type CampaignCalendarFilterOptions = {
  __typename?: 'CampaignCalendarFilterOptions';
  channels: Array<CampaignCalendarChannel>;
  connections: Array<CampaignCalendarConnection>;
  motions: Array<CampaignCalendarSeries>;
  targetingNames: Array<Scalars['String']>;
};

export type CampaignCalendarInput = {
  endAt: Scalars['String'];
  startAt: Scalars['String'];
};

export const CampaignCalendarOccurrenceGrain = {
  Day: 'day',
  Exact: 'exact',
  RecipientLocal: 'recipient_local'
} as const;

export type CampaignCalendarOccurrenceGrain = typeof CampaignCalendarOccurrenceGrain[keyof typeof CampaignCalendarOccurrenceGrain];
export const CampaignCalendarPlatform = {
  Braze: 'braze',
  Iterable: 'iterable',
  Klaviyo: 'klaviyo',
  NativeDelivery: 'native_delivery',
  Sailthru: 'sailthru',
  SalesforceMarketingCloud: 'salesforce_marketing_cloud'
} as const;

export type CampaignCalendarPlatform = typeof CampaignCalendarPlatform[keyof typeof CampaignCalendarPlatform];
export type CampaignCalendarSend = {
  __typename?: 'CampaignCalendarSend';
  bodyText?: Maybe<Scalars['String']>;
  channel: CampaignCalendarChannel;
  channels: Array<CampaignCalendarChannel>;
  connectionId: Scalars['String'];
  deliveredCount?: Maybe<Scalars['Float']>;
  espUrl?: Maybe<Scalars['String']>;
  htmlRef?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Why enrichment ignores this send, such as a proof, a seed-list send, or a send the Calendar context says to ignore. Null when the send is not ignored, including sends enrichment has not judged. */
  ignoreSendReason?: Maybe<Scalars['String']>;
  /** Unique opens including machine opens. Set when the source reports them, including when it cannot exclude machine opens and uniqueOpens is null. */
  machineInclusiveOpens?: Maybe<Scalars['Float']>;
  metrics: Scalars['JSON'];
  name: Scalars['String'];
  occurrenceGrain: CampaignCalendarOccurrenceGrain;
  platform: CampaignCalendarPlatform;
  preheader?: Maybe<Scalars['String']>;
  /** Message instances sent, from the metric source selected during normalization. Null means unavailable. */
  recipientsCount?: Maybe<Scalars['Float']>;
  sendType: CampaignCalendarSendType;
  sendTypeSource: CampaignCalendarSendTypeSource;
  /** An ISO instant, recipient-local clock without an offset, or date, as identified by occurrenceGrain. */
  sentAt: Scalars['String'];
  seriesId: Scalars['ID'];
  sourceTimeBasis: Scalars['String'];
  status: CampaignCalendarStatus;
  subject?: Maybe<Scalars['String']>;
  targeting: Array<CampaignCalendarTargeting>;
  title?: Maybe<Scalars['String']>;
  uniqueClicks?: Maybe<Scalars['Float']>;
  /** Unique opens with machine opens, such as Apple Mail Privacy Protection prefetches, excluded where the source can tell them apart. */
  uniqueOpens?: Maybe<Scalars['Float']>;
  workspaceId: Scalars['String'];
};

export const CampaignCalendarSendType = {
  Blast: 'blast',
  Triggered: 'triggered',
  Unknown: 'unknown'
} as const;

export type CampaignCalendarSendType = typeof CampaignCalendarSendType[keyof typeof CampaignCalendarSendType];
export const CampaignCalendarSendTypeSource = {
  Inferred: 'inferred',
  Native: 'native',
  Unknown: 'unknown'
} as const;

export type CampaignCalendarSendTypeSource = typeof CampaignCalendarSendTypeSource[keyof typeof CampaignCalendarSendTypeSource];
export type CampaignCalendarSeries = {
  __typename?: 'CampaignCalendarSeries';
  entryCount: Scalars['Float'];
  espCampaignId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: CampaignCalendarPlatform;
  source: CampaignCalendarSeriesSource;
};

export const CampaignCalendarSeriesSource = {
  Native: 'native'
} as const;

export type CampaignCalendarSeriesSource = typeof CampaignCalendarSeriesSource[keyof typeof CampaignCalendarSeriesSource];
export const CampaignCalendarStatus = {
  Canceled: 'canceled',
  Scheduled: 'scheduled',
  Sent: 'sent'
} as const;

export type CampaignCalendarStatus = typeof CampaignCalendarStatus[keyof typeof CampaignCalendarStatus];
export type CampaignCalendarTargeting = {
  __typename?: 'CampaignCalendarTargeting';
  espId: Scalars['String'];
  kind: CampaignCalendarTargetingKind;
  name: Scalars['String'];
};

export const CampaignCalendarTargetingKind = {
  List: 'list',
  Segment: 'segment'
} as const;

export type CampaignCalendarTargetingKind = typeof CampaignCalendarTargetingKind[keyof typeof CampaignCalendarTargetingKind];
export type CampaignChannelCreative = CampaignChannelCreativeUnavailable | EmailSendCreative | InAppSendCreative | PushSendCreative | SmsSendCreative | WebPushSendCreative;

export type CampaignChannelCreativeUnavailable = {
  __typename?: 'CampaignChannelCreativeUnavailable';
  variationId?: Maybe<Scalars['String']>;
};

export type CampaignCsvAudienceChangesInput = {
  subsetIds: Array<Scalars['ID']>;
  targetingMode: Scalars['String'];
  visualQueryFilter: Scalars['JSON'];
};

/**
 * One row of the Campaigns tab. A campaign-triggered row aggregates all of the
 * campaign's messages; a journey-triggered row is a single message, because a
 * journey has no campaign record to roll up into. Read "campaign" in the field
 * names as "row" — see the per-field docs.
 */
export type CampaignDeliverabilityStats = {
  __typename?: 'CampaignDeliverabilityStats';
  bounced: Scalars['Int'];
  /** Campaign id when triggerType is "campaign", else the message id — a journey row has no campaign, so do not link this to a campaign page without checking triggerType. */
  campaignId: Scalars['String'];
  /** Campaign name when triggerType is "campaign", else the message name. */
  campaignName: Scalars['String'];
  channelType?: Maybe<Scalars['String']>;
  clicked: Scalars['Int'];
  delivered: Scalars['Int'];
  journeyId?: Maybe<Scalars['String']>;
  journeyName?: Maybe<Scalars['String']>;
  /** A representative message for the row: the campaign's highest-sending message (ties broken by lower id), or the row's own message for a journey. Stable for a given window, but a multi-message campaign has other messages this does not name. */
  messageId: Scalars['String'];
  opened: Scalars['Int'];
  sendFailed: Scalars['Int'];
  sent: Scalars['Int'];
  skipped: Scalars['Int'];
  /** "campaign" or "journey" — which of the two shapes above this row is. */
  triggerType?: Maybe<Scalars['String']>;
  unsubscribed: Scalars['Int'];
};

export type CampaignDerivedStatusResult = {
  __typename?: 'CampaignDerivedStatusResult';
  campaignId: Scalars['ID'];
  derivedStatus: DerivedCampaignStatus;
};

export type CampaignHourlyEntry = {
  __typename?: 'CampaignHourlyEntry';
  hour: Scalars['String'];
  totalSent: Scalars['Int'];
};

export type CampaignHourlyStats = {
  __typename?: 'CampaignHourlyStats';
  campaignId: Scalars['ID'];
  hourly: Array<CampaignHourlyEntry>;
  totalSent: Scalars['Int'];
};

export const CampaignInsightCategory = {
  Creative: 'creative',
  Frequency: 'frequency',
  Segments: 'segments'
} as const;

export type CampaignInsightCategory = typeof CampaignInsightCategory[keyof typeof CampaignInsightCategory];
export type CampaignInsightCategoryCount = {
  __typename?: 'CampaignInsightCategoryCount';
  category: CampaignInsightCategory;
  count: Scalars['Int'];
};

export type CampaignInsightChart = {
  __typename?: 'CampaignInsightChart';
  /** Agent-authored markup stored verbatim; the frontend sanitizes it at render time. */
  html: Scalars['String'];
  title: Scalars['String'];
};

export type CampaignInsightFeedItem = {
  __typename?: 'CampaignInsightFeedItem';
  batchId: Scalars['uuid'];
  category: CampaignInsightCategory;
  finding: CampaignInsightFinding;
  isSaved: Scalars['Boolean'];
  publishedAt: Scalars['String'];
};

export type CampaignInsightFeedPage = {
  __typename?: 'CampaignInsightFeedPage';
  categoryCounts: Array<CampaignInsightCategoryCount>;
  items: Array<CampaignInsightFeedItem>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type CampaignInsightFinding = {
  __typename?: 'CampaignInsightFinding';
  chart?: Maybe<CampaignInsightChart>;
  chip: Scalars['String'];
  desc: Scalars['String'];
  headline: Scalars['String'];
  /** The finding's campaign_insights row uuid. */
  id: Scalars['uuid'];
  recommendation?: Maybe<Scalars['String']>;
  stats: Array<CampaignInsightStat>;
  /** The viewer's own rating; null when they have not rated. Other users' ratings are never exposed. */
  viewerRating?: Maybe<CampaignInsightRating>;
};

export type CampaignInsightRating = {
  __typename?: 'CampaignInsightRating';
  reason?: Maybe<Scalars['String']>;
  score: CampaignInsightRatingScore;
};

export const CampaignInsightRatingScore = {
  Down: 'down',
  Up: 'up'
} as const;

export type CampaignInsightRatingScore = typeof CampaignInsightRatingScore[keyof typeof CampaignInsightRatingScore];
export type CampaignInsightSet = {
  __typename?: 'CampaignInsightSet';
  creative: Array<CampaignInsightFinding>;
  frequency: Array<CampaignInsightFinding>;
  segments: Array<CampaignInsightFinding>;
};

export type CampaignInsightStat = {
  __typename?: 'CampaignInsightStat';
  /** "positive" or "negative"; null for neutral. */
  emphasis?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

/** A saved definition a Campaign Insights run can load. */
export type CampaignInsightsDefinitionOption = {
  __typename?: 'CampaignInsightsDefinitionOption';
  /** The definition's entity id, stable across its edits. */
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** scoped definitions load only when the run's parent model or source matches. */
  scopeMode: CampaignInsightsDefinitionScopeMode;
  /** verified when a user approved it; assumed otherwise. */
  status: CampaignInsightsDefinitionStatus;
};

export const CampaignInsightsDefinitionRole = {
  Metric: 'metric',
  Segment: 'segment'
} as const;

export type CampaignInsightsDefinitionRole = typeof CampaignInsightsDefinitionRole[keyof typeof CampaignInsightsDefinitionRole];
export const CampaignInsightsDefinitionScopeMode = {
  Scoped: 'scoped',
  Workspace: 'workspace'
} as const;

export type CampaignInsightsDefinitionScopeMode = typeof CampaignInsightsDefinitionScopeMode[keyof typeof CampaignInsightsDefinitionScopeMode];
export type CampaignInsightsDefinitionSelection = {
  __typename?: 'CampaignInsightsDefinitionSelection';
  /** Null when the saved id no longer names a definition a run can load. */
  definition?: Maybe<CampaignInsightsDefinitionOption>;
  definitionId: Scalars['uuid'];
  role: CampaignInsightsDefinitionRole;
};

export type CampaignInsightsDefinitionSettings = {
  __typename?: 'CampaignInsightsDefinitionSettings';
  eligibleDefinitions: Array<CampaignInsightsDefinitionOption>;
  onboardingCompleted: Scalars['Boolean'];
  selections: Array<CampaignInsightsDefinitionSelection>;
};

export const CampaignInsightsDefinitionStatus = {
  Assumed: 'assumed',
  Verified: 'verified'
} as const;

export type CampaignInsightsDefinitionStatus = typeof CampaignInsightsDefinitionStatus[keyof typeof CampaignInsightsDefinitionStatus];
export type CampaignInsightsLiveBatch = {
  __typename?: 'CampaignInsightsLiveBatch';
  batchId: Scalars['uuid'];
  createdAt: Scalars['String'];
  /** Agent session the batch's cards came from; null for hand-authored batches. */
  llmChatSessionId?: Maybe<Scalars['uuid']>;
  /** Workspace insight cards; per-send cards are counted by sendCount. */
  rowCount: Scalars['Int'];
  /** Distinct calendar sends with cards in the batch. */
  sendCount: Scalars['Int'];
};

export type CampaignInsightsRun = {
  __typename?: 'CampaignInsightsRun';
  createdAt: Scalars['String'];
  id: Scalars['uuid'];
  status: CampaignInsightsRunStatus;
};

export const CampaignInsightsRunStatus = {
  Completed: 'completed',
  Failed: 'failed',
  Running: 'running'
} as const;

export type CampaignInsightsRunStatus = typeof CampaignInsightsRunStatus[keyof typeof CampaignInsightsRunStatus];
export type CampaignRecipient = {
  __typename?: 'CampaignRecipient';
  /** SMTP status; set only on a failure. */
  bounceCode?: Maybe<Scalars['String']>;
  channelType?: Maybe<Scalars['String']>;
  clicked: Scalars['Boolean'];
  /** Push platforms attempted for this recipient. Empty for email and SMS. */
  devicePlatforms: Array<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  lastActivityAt?: Maybe<Scalars['String']>;
  messageExecutionId?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  opened: Scalars['Boolean'];
  parentModelPk: Scalars['String'];
  /** The raw dispatcher drop reason; set only on a skip. */
  reason?: Maybe<Scalars['String']>;
  /** Pointer into the dispatcher's rendered content, for the message drawer. */
  renderedS3Key?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['String']>;
  status: CampaignRecipientStatus;
};

export const CampaignRecipientEngagement = {
  Clicked: 'clicked',
  Opened: 'opened'
} as const;

export type CampaignRecipientEngagement = typeof CampaignRecipientEngagement[keyof typeof CampaignRecipientEngagement];
/**
 * Narrowing that joins the cache key: each combination is its own question,
 * computed on the worker and cached like any other. Search is not here, because
 * it changes per keystroke -- use searchCampaignRecipients for that.
 */
export type CampaignRecipientFiltersInput = {
  engagement?: InputMaybe<CampaignRecipientEngagement>;
  /** Recipient handle domains. Email only. */
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  /** Push only. */
  pushOs?: InputMaybe<Scalars['String']>;
  /**
   * Dispatcher drop reasons. A value this build does not know is refused rather
   * than dropped, because a dropped one would be answered as though it had never
   * been asked for. An empty list is refused for the same reason.
   */
  reasons?: InputMaybe<Array<Scalars['String']>>;
};

export type CampaignRecipientSearchResult = {
  __typename?: 'CampaignRecipientSearchResult';
  /** More matches exist than this page holds; narrow the term. */
  hasMore: Scalars['Boolean'];
  recipients: Array<CampaignRecipient>;
  unavailableReason?: Maybe<CampaignRecipientsUnavailableReason>;
};

export const CampaignRecipientStatus = {
  Bounced: 'bounced',
  Delivered: 'delivered',
  Failed: 'failed',
  Sent: 'sent',
  Skipped: 'skipped'
} as const;

export type CampaignRecipientStatus = typeof CampaignRecipientStatus[keyof typeof CampaignRecipientStatus];
export type CampaignRecipientStatusCount = {
  __typename?: 'CampaignRecipientStatusCount';
  count: Scalars['Int'];
  status: CampaignRecipientStatus;
};

export type CampaignRecipientsFailed = {
  __typename?: 'CampaignRecipientsFailed';
  error: Scalars['String'];
};

export type CampaignRecipientsPage = {
  __typename?: 'CampaignRecipientsPage';
  /** When these rows were measured against the warehouse. */
  evaluatedAt: Scalars['String'];
  recipients: Array<CampaignRecipient>;
  /**
   * One entry per status, counted over the whole run rather than the window and
   * never narrowed by the status filter, so a status you are not looking at
   * still reports what it holds.
   */
  statusCounts: Array<CampaignRecipientStatusCount>;
  /**
   * Recipients matching the question, which is the run's true total only when
   * totalIsCapped is false.
   */
  totalCount: Scalars['Int'];
  /**
   * True when the run has more matching recipients than one computation holds.
   * A computation holds windowSize rows, so any run larger than that is capped
   * whether or not filters are set. Narrowing by status or by the filters input
   * changes which rows the window holds, not how many. Read totalCount as the
   * run's true total only when this is false.
   */
  totalIsCapped: Scalars['Boolean'];
  unavailableReason?: Maybe<CampaignRecipientsUnavailableReason>;
  /** How many rows one computation holds. The cap behind totalIsCapped. */
  windowSize: Scalars['Int'];
};

export type CampaignRecipientsPending = {
  __typename?: 'CampaignRecipientsPending';
  jobId: Scalars['ID'];
};

/**
 * The computation finished and its rows are in the cache rather than here. Read
 * them with getCampaignRecipients, passing the same arguments the computation
 * was started with: it re-derives the cache key server-side, so a page can never
 * come back under filters other than the ones that asked for it. The entry has a
 * TTL, so a poll answered long after the fact can still be followed by a miss.
 */
export type CampaignRecipientsReady = {
  __typename?: 'CampaignRecipientsReady';
  evaluatedAt: Scalars['String'];
};

export type CampaignRecipientsResult = CampaignRecipientsFailed | CampaignRecipientsPending | CampaignRecipientsReady;

export const CampaignRecipientsUnavailableReason = {
  /** The workspace has not ingested the CEP event tables yet. */
  NoEventTables: 'no_event_tables',
  /** A campaign with no messages has no recipients. */
  NoMessages: 'no_messages'
} as const;

export type CampaignRecipientsUnavailableReason = typeof CampaignRecipientsUnavailableReason[keyof typeof CampaignRecipientsUnavailableReason];
export type CampaignReportingLabelFilter = {
  groupId: Scalars['String'];
  labelIds: Array<Scalars['String']>;
};

export type CampaignRunStats = {
  __typename?: 'CampaignRunStats';
  campaignId: Scalars['ID'];
  campaignRunId: Scalars['ID'];
  totalClicks: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalDeviceOpens?: Maybe<Scalars['Int']>;
  totalDevicesAccepted?: Maybe<Scalars['Int']>;
  totalDevicesRejected?: Maybe<Scalars['Int']>;
  totalDropped: Scalars['Int'];
  totalFailed: Scalars['Int'];
  totalOpens: Scalars['Int'];
  totalSent: Scalars['Int'];
  totalSpamReports: Scalars['Int'];
};

export type CampaignStats = {
  __typename?: 'CampaignStats';
  campaignId: Scalars['ID'];
  totalClicks: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalOpens: Scalars['Int'];
  totalSent: Scalars['Int'];
};

export const CanAction = {
  CanAccessData: 'can_access_data',
  CanApprove: 'can_approve',
  CanConfigureAgents: 'can_configure_agents',
  CanConfigureJourney: 'can_configure_journey',
  CanCreate: 'can_create',
  CanCreateDestinations: 'can_create_destinations',
  CanCreateEventForwardingDestinations: 'can_create_event_forwarding_destinations',
  CanCreateEventFunctions: 'can_create_event_functions',
  CanCreateEventPlans: 'can_create_event_plans',
  CanCreateEventSources: 'can_create_event_sources',
  CanCreateEventWarehouseDestinations: 'can_create_event_warehouse_destinations',
  CanCreateSources: 'can_create_sources',
  CanDebug: 'can_debug',
  CanDelete: 'can_delete',
  CanDeleteJourney: 'can_delete_journey',
  CanDraftNativeDelivery: 'can_draft_native_delivery',
  CanEditDecisionEngineContent: 'can_edit_decision_engine_content',
  CanGrantSupportAccess: 'can_grant_support_access',
  CanIngestCepPushTokens: 'can_ingest_cep_push_tokens',
  CanManageDecisionEngine: 'can_manage_decision_engine',
  CanManageNativeDeliveryAssets: 'can_manage_native_delivery_assets',
  CanManageNativeDeliveryChannels: 'can_manage_native_delivery_channels',
  CanManageNativeDeliveryMessages: 'can_manage_native_delivery_messages',
  CanManageNativeDeliverySettings: 'can_manage_native_delivery_settings',
  CanPreview: 'can_preview',
  CanRead: 'can_read',
  CanReadCepConsent: 'can_read_cep_consent',
  CanRun: 'can_run',
  CanRunJourney: 'can_run_journey',
  CanSync: 'can_sync',
  CanTest: 'can_test',
  CanUpdate: 'can_update',
  CanUpdateCepConsent: 'can_update_cep_consent',
  CanViewAgents: 'can_view_agents',
  CanViewNativeDelivery: 'can_view_native_delivery',
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type CanAction = typeof CanAction[keyof typeof CanAction];
export type CanActionGrants = {
  __typename?: 'CanActionGrants';
  grants: Array<CanAction>;
};

export type CanCreateAnyEventSync = {
  __typename?: 'CanCreateAnyEventSync';
  canCreateForwarding: Scalars['Boolean'];
  canCreateWarehouse: Scalars['Boolean'];
};

export type CancelAnalyticsQueryResponse = {
  __typename?: 'CancelAnalyticsQueryResponse';
  jobId: Scalars['String'];
};

export type CancelCampaignAnalyticsDashboardQueryResponse = {
  __typename?: 'CancelCampaignAnalyticsDashboardQueryResponse';
  jobId: Scalars['String'];
};

export type CancelEnrichmentResponse = {
  __typename?: 'CancelEnrichmentResponse';
  id: Scalars['String'];
};

export type CancelExtensionExportResult = {
  __typename?: 'CancelExtensionExportResult';
  success: Scalars['Boolean'];
};

export type CancelExtensionImportResult = {
  __typename?: 'CancelExtensionImportResult';
  success: Scalars['Boolean'];
};

export type CancelLlmBackgroundJobInput = {
  jobId: Scalars['uuid'];
};

export type CancelLlmBackgroundJobResponse = {
  __typename?: 'CancelLLMBackgroundJobResponse';
  jobId: Scalars['uuid'];
};

export type CancelLlmChatInteractionResponse = {
  __typename?: 'CancelLlmChatInteractionResponse';
  canceled: Scalars['Boolean'];
};

export type CancelPredictiveTraitsQueueJobError = {
  __typename?: 'CancelPredictiveTraitsQueueJobError';
  error: Scalars['String'];
};

export type CancelPredictiveTraitsQueueJobInput = {
  jobId: Scalars['String'];
};

export type CancelPredictiveTraitsQueueJobResult = CancelPredictiveTraitsQueueJobError | CancelPredictiveTraitsQueueJobSuccess;

export type CancelPredictiveTraitsQueueJobSuccess = {
  __typename?: 'CancelPredictiveTraitsQueueJobSuccess';
  jobId: Scalars['String'];
  message: Scalars['String'];
};

export type CancelPredictorRunError = {
  __typename?: 'CancelPredictorRunError';
  error: Scalars['String'];
};

export type CancelPredictorRunInput = {
  predictorRunId: Scalars['uuid'];
};

export type CancelPredictorRunResult = CancelPredictorRunError | CancelPredictorRunSuccess;

export type CancelPredictorRunSuccess = {
  __typename?: 'CancelPredictorRunSuccess';
  message: Scalars['String'];
  predictorRunId: Scalars['uuid'];
};

export type CancelPreviewQueryJobResponse = {
  __typename?: 'CancelPreviewQueryJobResponse';
  jobId: Scalars['String'];
};

export type CancelSyncRunOutput = {
  __typename?: 'CancelSyncRunOutput';
  cancelled: Scalars['Boolean'];
};

export type CantoFolder = {
  __typename?: 'CantoFolder';
  assetCount: Scalars['Int'];
  id: Scalars['String'];
  idPath: Scalars['String'];
  name: Scalars['String'];
  namePath: Scalars['String'];
  scheme: Scalars['String'];
  subfolderCount: Scalars['Int'];
};

export type CantoFolderTreeResult = {
  __typename?: 'CantoFolderTreeResult';
  folders: Array<CantoFolder>;
};

export type CardinalityDetectionFailure = {
  __typename?: 'CardinalityDetectionFailure';
  error: Scalars['String'];
  type: CardinalityDetectionStatus;
};

export type CardinalityDetectionInput = {
  jobId: Scalars['String'];
};

export type CardinalityDetectionProcessing = {
  __typename?: 'CardinalityDetectionProcessing';
  type: CardinalityDetectionStatus;
};

export type CardinalityDetectionResult = CardinalityDetectionFailure | CardinalityDetectionProcessing | CardinalityDetectionSuccess;

export const CardinalityDetectionStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type CardinalityDetectionStatus = typeof CardinalityDetectionStatus[keyof typeof CardinalityDetectionStatus];
export type CardinalityDetectionSuccess = {
  __typename?: 'CardinalityDetectionSuccess';
  detectedCardinality: Scalars['String'];
  type: CardinalityDetectionStatus;
};

export type CatalogDimensionTagFilter = {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CatalogFilterableUserTag = {
  __typename?: 'CatalogFilterableUserTag';
  key: Scalars['String'];
  /** Every value the key holds in the collection (capped). */
  values: Array<Scalars['String']>;
};

export type CatalogModelConfigurationInput = {
  primary_key?: InputMaybe<Scalars['String']>;
  primary_label?: InputMaybe<Scalars['String']>;
  secondary_label?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  assetGroupId?: Maybe<Scalars['ID']>;
  content?: Maybe<CatalogProductContent>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dimensionTags: Scalars['JSON'];
  id: Scalars['String'];
  /**
   * Machine-extracted media facts (the CatalogMediaMetadata shape): duration,
   * display dimensions and codec, plus the video extraction's transcript
   * segments, hooks, scenes and aiDescription on a shared seconds clock. Null
   * until the extraction job has run for the row, which is feature-flagged, so
   * most rows carry null. A full transcript is large — request it on single-row
   * queries, not on a page of products.
   */
  metadata?: Maybe<Scalars['JSON']>;
  /**
   * The row's import key ("record id") — the column the customer mapped as
   * their product identifier at upload. Often a SKU, but not guaranteed (some
   * workspaces key products by URL or another id).
   */
  sourceRowKey: Scalars['String'];
  tags?: Maybe<Scalars['JSON']>;
  /**
   * Signed CDN URL for the primary image at grid thumbnail size, so a grid can
   * render tiles without a round trip through /agents/catalog/image. Null for
   * videos and SVGs (which that endpoint serves by other means) and when the
   * resizer isn't configured; callers fall back to building their own URL.
   */
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['String'];
  userDefinedType?: Maybe<Scalars['String']>;
};

export type CatalogProductContent = {
  __typename?: 'CatalogProductContent';
  images: Array<CatalogProductImage>;
  type: Scalars['String'];
};

export type CatalogProductImage = {
  __typename?: 'CatalogProductImage';
  filename: Scalars['String'];
  /**
   * The stored file's MIME type. DAM imports store the file under the asset
   * id with no extension, so this is the only record of its type.
   */
  mimeType?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  /**
   * A readable copy of an original in a format the model cannot read, such
   * as TIFF or AVIF.
   */
  standardCopy?: Maybe<CatalogProductStandardCopy>;
};

export type CatalogProductStandardCopy = {
  __typename?: 'CatalogProductStandardCopy';
  filename: Scalars['String'];
  mimeType: Scalars['String'];
};

export type CatalogProductsResult = {
  __typename?: 'CatalogProductsResult';
  nextCursor?: Maybe<Scalars['String']>;
  products: Array<CatalogProduct>;
  totalCount: Scalars['Int'];
};

export type CepAudienceProfileSearchResult = {
  __typename?: 'CepAudienceProfileSearchResult';
  audienceName?: Maybe<Scalars['String']>;
  rows: Array<Scalars['JSONObject']>;
};

export type CepConsentManagementUrlResult = {
  __typename?: 'CepConsentManagementUrlResult';
  url: Scalars['String'];
};

export type CepDeviceToken = {
  __typename?: 'CepDeviceToken';
  deviceModel?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

export type CepEmailPreviewScreenshots = {
  __typename?: 'CepEmailPreviewScreenshots';
  default: Scalars['String'];
  horizontal?: Maybe<Scalars['String']>;
};

export type CepEmailPreviewTestClientResult = {
  __typename?: 'CepEmailPreviewTestClientResult';
  fullThumbnail?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  screenshots: CepEmailPreviewScreenshots;
  status: CepEmailPreviewTestStatus;
  thumbnail?: Maybe<Scalars['String']>;
};

export const CepEmailPreviewTestStatus = {
  Bounced: 'bounced',
  Complete: 'complete',
  Pending: 'pending',
  Processing: 'processing'
} as const;

export type CepEmailPreviewTestStatus = typeof CepEmailPreviewTestStatus[keyof typeof CepEmailPreviewTestStatus];
export type CepForwardingQueueMove = {
  __typename?: 'CepForwardingQueueMove';
  destinationId: Scalars['ID'];
  /** The SQS destination's region after the move. */
  destinationRegion: Scalars['String'];
  fromQueueUrl: Scalars['String'];
  syncId: Scalars['ID'];
  toQueueUrl: Scalars['String'];
};

export type CepForwardingQueueSkip = {
  __typename?: 'CepForwardingQueueSkip';
  reason: Scalars['String'];
  syncId: Scalars['ID'];
};

export const CepForwardingQueueTarget = {
  /** The control-plane copy, named for the workspace's region. */
  ControlPlane: 'CONTROL_PLANE',
  /** The region's own copy of each CEP forwarding queue. */
  DataPlane: 'DATA_PLANE'
} as const;

export type CepForwardingQueueTarget = typeof CepForwardingQueueTarget[keyof typeof CepForwardingQueueTarget];
export type CepJourneyTileInput = {
  journeyId: Scalars['ID'];
  nodeId: Scalars['ID'];
};

export type CepLinkTrackingDefaults = {
  __typename?: 'CepLinkTrackingDefaults';
  defaultTrackingDomain: Scalars['String'];
};

export type CepLocalizationElement = {
  __typename?: 'CepLocalizationElement';
  /** Human label for where this sits in the email ("Paragraph 2"). Display only. */
  context: Scalars['String'];
  elementKey: Scalars['String'];
  /**
   * The element's identity, as `{element key}:{slot}` — the worksheet's ID
   * column and the `data-ht-key` a canvas click resolves.
   */
  id: Scalars['ID'];
  /** One entry per `CepLocalizationStatus.locales`, in the same order. */
  locales: Array<CepLocalizationElementLocale>;
  /**
   * Deselected in the Localize tab: the row renders in the default language and
   * no send resolves a translation for it.
   */
  off: Scalars['Boolean'];
  slot: Scalars['String'];
  /**
   * A translation applies only while this hash of the source text matches, so
   * editing the copy returns the element to the default language.
   */
  sourceHash: Scalars['String'];
  sourceText: Scalars['String'];
  /** The A/B arm content row this element belongs to; null for the base body. */
  variantId?: Maybe<Scalars['ID']>;
};

export type CepLocalizationElementLocale = {
  __typename?: 'CepLocalizationElementLocale';
  /** One of `CepLocalizationStatus.locales`, which carries the value. */
  localeId: Scalars['ID'];
  state: CepTranslationState;
  /**
   * The stored translation for this cell, verbatim. Null exactly when `state`
   * is `missing`. For `translated` it is the value a send would use. For
   * `stale` it is the translation written against copy the marketer has since
   * edited, which a send never uses.
   */
  translatedValue?: Maybe<Scalars['String']>;
};

export type CepLocalizationLocale = {
  __typename?: 'CepLocalizationLocale';
  id: Scalars['ID'];
  /** The locale's matching value, e.g. "fr-FR", from `cep_locales.value`. */
  value: Scalars['String'];
};

export type CepLocalizationOwnerInput = {
  id: Scalars['ID'];
  type: CepLocalizationOwnerType;
};

export const CepLocalizationOwnerType = {
  ContentBlock: 'contentBlock',
  EmailTemplate: 'emailTemplate',
  Message: 'message',
  WhatsappTemplate: 'whatsappTemplate'
} as const;

export type CepLocalizationOwnerType = typeof CepLocalizationOwnerType[keyof typeof CepLocalizationOwnerType];
export type CepLocalizationStatus = {
  __typename?: 'CepLocalizationStatus';
  /**
   * Every translatable element of the saved draft, in document order. Empty when
   * the message has never been saved, has no translatable copy, or its body took
   * a write path that doesn't stamp.
   */
  elements: Array<CepLocalizationElement>;
  /**
   * The message's target locales, ordered by value. The authored locale is a
   * source rather than a target, so it never appears here.
   */
  locales: Array<CepLocalizationLocale>;
};

export type CepManagedModelChangeSummary = {
  __typename?: 'CepManagedModelChangeSummary';
  changes: Array<Scalars['String']>;
  managedModelType: Scalars['String'];
  segmentId: Scalars['ID'];
  /** One of "created" | "updated" | "skipped" | "errored". */
  status: Scalars['String'];
};

export type CepMessageDevicePreviewClient = {
  __typename?: 'CepMessageDevicePreviewClient';
  /** Set when category is web. */
  browser?: Maybe<Scalars['String']>;
  category: CepMessageDevicePreviewClientCategory;
  client: Scalars['String'];
  /** Set when category is desktop. */
  desktopApp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDarkMode: Scalars['Boolean'];
  isPopular: Scalars['Boolean'];
  isSelectedByDefault: Scalars['Boolean'];
  /** Set when category is mobile. */
  mobileDevice?: Maybe<Scalars['String']>;
  os: Scalars['String'];
  providerGroup: CepMessageDevicePreviewProvider;
  /** Sub-type label (e.g. Android app, Gmail.com, Desktop app). */
  type: Scalars['String'];
};

export const CepMessageDevicePreviewClientCategory = {
  Desktop: 'desktop',
  Mobile: 'mobile',
  Web: 'web'
} as const;

export type CepMessageDevicePreviewClientCategory = typeof CepMessageDevicePreviewClientCategory[keyof typeof CepMessageDevicePreviewClientCategory];
export const CepMessageDevicePreviewProvider = {
  Aol: 'AOL',
  Apple: 'Apple',
  Gmail: 'Gmail',
  Outlook: 'Outlook',
  Yahoo: 'Yahoo'
} as const;

export type CepMessageDevicePreviewProvider = typeof CepMessageDevicePreviewProvider[keyof typeof CepMessageDevicePreviewProvider];
/**
 * Whether the lookup settled the question of what this messaging service can do.
 * An unverified result proves nothing and must never be read as unsupported.
 */
export const CepMessagingServiceLookup = {
  Invalid: 'invalid',
  NotFound: 'not_found',
  Ok: 'ok',
  Unverified: 'unverified'
} as const;

export type CepMessagingServiceLookup = typeof CepMessagingServiceLookup[keyof typeof CepMessagingServiceLookup];
export type CepParentModelSettings = {
  __typename?: 'CepParentModelSettings';
  columnMappings?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  parentModelId: Scalars['ID'];
  warehouseAttributeCacheSyncId?: Maybe<Scalars['ID']>;
};

export type CepProfileCacheResult = {
  __typename?: 'CepProfileCacheResult';
  cachedAt: Scalars['String'];
  rowCount: Scalars['Int'];
  rows: Array<Scalars['JSONObject']>;
};

export type CepProfileSearchResult = {
  __typename?: 'CepProfileSearchResult';
  rows: Array<Scalars['JSONObject']>;
};

export type CepProviderResult = {
  __typename?: 'CepProviderResult';
  id: Scalars['ID'];
};

export type CepReachabilityCounts = {
  __typename?: 'CepReachabilityCounts';
  audienceSize: Scalars['Int'];
  /**
   * Zero when unavailableReason is set. Read unavailableReason before treating
   * this as a measurement.
   */
  contactableCount: Scalars['Int'];
  /** When these counts were measured against the warehouse. */
  evaluatedAt: Scalars['String'];
  hasDuplicates: Scalars['Boolean'];
  /** Zero when unavailableReason is set. See contactableCount. */
  reachableCount: Scalars['Int'];
  /** Set when CEP is not configured far enough to measure the counts. */
  unavailableReason?: Maybe<CepReachabilityUnavailableReason>;
  /**
   * Rows passing consent and suppression that the send-time locale gate would
   * then drop. The gate drops a pk whole, so every row of a skipped pk counts
   * here, keeping this a row count like contactableCount and reachableCount.
   * US numbers are counted first, in whatsAppMarketingUsContactableCount, and
   * one failing both consent and locale is counted as unsubscribed, so the
   * breakdown sums to the contactable count. Null when localization is
   * inactive, when the audience has no message, and when nothing was measured.
   */
  unsupportedLocaleCount?: Maybe<Scalars['Int']>;
  /**
   * Contactable rows with a US number, which the WhatsApp marketing gate never
   * sends to. They are counted first, before consent and locale, so no other
   * count includes them. Null when the gate does not apply.
   */
  whatsAppMarketingUsContactableCount?: Maybe<Scalars['Int']>;
};

export type CepReachabilityFailed = {
  __typename?: 'CepReachabilityFailed';
  error: Scalars['String'];
};

export type CepReachabilityPending = {
  __typename?: 'CepReachabilityPending';
  jobId: Scalars['ID'];
};

export type CepReachabilityReady = {
  __typename?: 'CepReachabilityReady';
  counts: CepReachabilityCounts;
};

export type CepReachabilityResult = CepReachabilityFailed | CepReachabilityPending | CepReachabilityReady;

/**
 * Why a count could not be measured. Each value is a CEP configuration state,
 * not a failure — the workspace has not finished setting up the data the count
 * depends on.
 */
export const CepReachabilityUnavailableReason = {
  /** The workspace's CEP consent events table does not exist yet. */
  MissingConsentData: 'missing_consent_data',
  /** No email/phone column is mapped for the message's channel. */
  MissingHandleColumn: 'missing_handle_column',
  /** The workspace's CEP push token events table does not exist yet. */
  MissingPushTokenData: 'missing_push_token_data'
} as const;

export type CepReachabilityUnavailableReason = typeof CepReachabilityUnavailableReason[keyof typeof CepReachabilityUnavailableReason];
export type CepSignupTraitCreated = {
  __typename?: 'CepSignupTraitCreated';
  field: Scalars['String'];
  traitId: Scalars['String'];
};

export type CepSignupTraitFieldInput = {
  /** What the trait is called in the UI. Defaults to the field name. */
  label?: InputMaybe<Scalars['String']>;
  /** The key the signup form posts, without the `traits_` prefix. */
  name: Scalars['String'];
};

/**
 * One staged cell from the Localize tab's table. The hash and text come off the
 * status row the marketer edited: the write binds to that hash, so an edit
 * staged against copy that was re-saved in the meantime lands as stale rather
 * than silently rebinding to text the translator never read.
 */
export type CepTranslationEditInput = {
  elementKey: Scalars['String'];
  /** One of the target locales the owner's `cep_localization_settings` row selects. */
  localeId: Scalars['ID'];
  slot: Scalars['String'];
  sourceHash: Scalars['String'];
  /**
   * The source text the translation was written against. Must hash to
   * `sourceHash`.
   */
  sourceText: Scalars['String'];
  /**
   * The translation to store. Null clears the cell: every stored row for this
   * (element, slot, locale) is deleted, stale ones included, so editing the
   * copy back cannot resurrect a cleared translation.
   */
  value?: InputMaybe<Scalars['String']>;
};

export type CepTranslationEditsResult = {
  __typename?: 'CepTranslationEditsResult';
  /**
   * Values written — inserts and overwrites. An edit whose value already
   * matched the stored row is skipped and counts toward neither field.
   */
  applied: Scalars['Int'];
  /**
   * Rows deleted by the batch's clears, counting every hash a cleared cell
   * held.
   */
  cleared: Scalars['Int'];
};

export const CepTranslationState = {
  Missing: 'missing',
  Stale: 'stale',
  Translated: 'translated'
} as const;

export type CepTranslationState = typeof CepTranslationState[keyof typeof CepTranslationState];
export type CepTwilioPhoneNumber = {
  __typename?: 'CepTwilioPhoneNumber';
  friendlyName?: Maybe<Scalars['String']>;
  /** E.164 */
  phoneNumber: Scalars['String'];
  sid: Scalars['String'];
  sms: Scalars['Boolean'];
  voice: Scalars['Boolean'];
};

export type CepTwilioPhoneNumbersInput = {
  accountSid: Scalars['String'];
  apiKey: Scalars['String'];
  apiKeySecret: Scalars['String'];
};

export const CepUserStateScope = {
  ChannelUnsub: 'CHANNEL_UNSUB',
  Consent: 'CONSENT',
  Reachability: 'REACHABILITY'
} as const;

export type CepUserStateScope = typeof CepUserStateScope[keyof typeof CepUserStateScope];
export type CepValidateFontCssResult = {
  __typename?: 'CepValidateFontCssResult';
  families: Array<Scalars['String']>;
  /** False when the CSS couldn't be loaded/parsed, or declared no fonts. */
  valid: Scalars['Boolean'];
};

/** The state of the WhatsApp Business Account behind a provider. */
export const CepWhatsAppAccountStatus = {
  Error: 'error',
  Limited: 'limited',
  Verified: 'verified'
} as const;

export type CepWhatsAppAccountStatus = typeof CepWhatsAppAccountStatus[keyof typeof CepWhatsAppAccountStatus];
export type CepWhatsAppDraftLocaleReview = {
  __typename?: 'CepWhatsAppDraftLocaleReview';
  isDefault: Scalars['Boolean'];
  localeId?: Maybe<Scalars['ID']>;
  /** Meta's reason, on a rejected locale. */
  rejectionReason?: Maybe<Scalars['String']>;
  /** When the state began: its submission, approval or rejection. */
  since?: Maybe<Scalars['String']>;
  /** Never unchanged: the list holds only locales the draft changed. */
  state: CepWhatsAppDraftReviewState;
};

export type CepWhatsAppDraftReview = {
  __typename?: 'CepWhatsAppDraftReview';
  /** Each locale the draft changed that publishing checks, the default locale included. */
  locales: Array<CepWhatsAppDraftLocaleReview>;
  /** Meta's reason, on a rejected draft. */
  rejectionReason?: Maybe<Scalars['String']>;
  /** The latest since among the locales in that state. */
  since?: Maybe<Scalars['String']>;
  /** A rejection outranks a locale still to submit, which outranks one under review. */
  state: CepWhatsAppDraftReviewState;
};

export const CepWhatsAppDraftReviewState = {
  Approved: 'approved',
  Pending: 'pending',
  Rejected: 'rejected',
  /** The draft changed nothing Meta reviews, so it can publish now. */
  Unchanged: 'unchanged',
  Unsubmitted: 'unsubmitted'
} as const;

export type CepWhatsAppDraftReviewState = typeof CepWhatsAppDraftReviewState[keyof typeof CepWhatsAppDraftReviewState];
/** How a WhatsApp signal or sender is doing */
export const CepWhatsAppHealthState = {
  Blocked: 'blocked',
  Limited: 'limited',
  Ok: 'ok'
} as const;

export type CepWhatsAppHealthState = typeof CepWhatsAppHealthState[keyof typeof CepWhatsAppHealthState];
/**
 * The WhatsApp Business Account behind one provider. Derived from Meta, so it
 * describes the account rather than any one sender.
 */
export type CepWhatsAppProviderStatus = {
  __typename?: 'CepWhatsAppProviderStatus';
  /** Meta's own verification word */
  businessVerificationStatus?: Maybe<Scalars['String']>;
  /** Why the last read failed, if it did. */
  error?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['String']>;
  /** Meta's own explanation of a constrained account, when it gave one */
  limitReason?: Maybe<Scalars['String']>;
  /** A dead or revoked token: the fix is reconnecting, not retrying. */
  needsReconnect: Scalars['Boolean'];
  providerId: Scalars['ID'];
  /**
   * Unique recipients per rolling 24 hours. Meta sets this per business
   * portfolio, so it belongs to the account rather than to any one sender.
   * Null means unknown, never zero.
   */
  sendLimitPer24h?: Maybe<Scalars['Int']>;
  /** Meta reports no cap, which reads differently from an unknown limit. */
  sendLimitUnlimited: Scalars['Boolean'];
  status: CepWhatsAppAccountStatus;
};

export type CepWhatsAppSender = {
  __typename?: 'CepWhatsAppSender';
  displayName?: Maybe<Scalars['String']>;
  health: Array<CepWhatsAppSenderHealthSignal>;
  /** Worst of the sender's health signals. */
  healthState?: Maybe<CepWhatsAppHealthState>;
  id: Scalars['ID'];
  lastSyncedAt: Scalars['String'];
  /** E.164, or null for a sender with no number. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Twilio sender SID. */
  providerSenderId: Scalars['String'];
  senderIdentityId: Scalars['ID'];
  throughputPerSecond?: Maybe<Scalars['Int']>;
};

/** One normalised health signal behind a WhatsApp sender's status badge. */
export type CepWhatsAppSenderHealthSignal = {
  __typename?: 'CepWhatsAppSenderHealthSignal';
  key: Scalars['String'];
  label: Scalars['String'];
  state: CepWhatsAppHealthState;
};

export type CepWhatsAppSendersResult = {
  __typename?: 'CepWhatsAppSendersResult';
  /**
   * Set when an identity could not be refreshed. The senders returned beside it
   * are the last known set, not a current one.
   */
  error?: Maybe<Scalars['String']>;
  senders: Array<CepWhatsAppSender>;
};

export type CepWhatsAppTemplateDuplicate = {
  __typename?: 'CepWhatsAppTemplateDuplicate';
  id: Scalars['ID'];
  /**
   * Whether it's the version a live campaign is sending, when the checked
   * template is that campaign's draft. Changing only buttons, the header or the
   * category can't get past Meta's duplicate rule through the draft.
   */
  isLiveVersion: Scalars['Boolean'];
  name: Scalars['String'];
  /** Where the author can find it. Null when nothing that still exists uses it. */
  usedBy?: Maybe<CepWhatsAppTemplateUsage>;
};

export type CepWhatsAppTemplateLinkResult = {
  __typename?: 'CepWhatsAppTemplateLinkResult';
  /** The template the message now sends. */
  templateId: Scalars['ID'];
  /** The content version that binds it, now published. */
  version: Scalars['Int'];
};

export type CepWhatsAppTemplateLocale = {
  __typename?: 'CepWhatsAppTemplateLocale';
  approvedAt?: Maybe<Scalars['String']>;
  /** The category the locale sends under: Meta's, or the one requested until Meta sets one. */
  category: Scalars['String'];
  /** The content this locale would be submitted with. Null while any part is untranslated. */
  content?: Maybe<Scalars['JSONObject']>;
  /** Whether Meta approved the locale's template and still lets it send. */
  isApproved: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  /** The Meta language the locale is submitted in. */
  language: Scalars['String'];
  /** The workspace locale's code, such as fr-FR. */
  locale: Scalars['String'];
  localeId: Scalars['ID'];
  /** Whether the locale still has to go to Meta: not approved, and never submitted or changed since. */
  needsSubmission: Scalars['Boolean'];
  /** Meta's quality rating of the locale's template. */
  quality?: Maybe<Scalars['String']>;
  /** Meta's reason, on a rejected locale. */
  rejectionReason?: Maybe<Scalars['String']>;
  /** The locale's review status: Meta's verdict, or UNSUBMITTED. */
  status: Scalars['String'];
  submittedAt?: Maybe<Scalars['String']>;
};

export type CepWhatsAppTemplateSampleInput = {
  /** The variable's name, as the template's merge tag writes it. */
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CepWhatsAppTemplateUsage = {
  __typename?: 'CepWhatsAppTemplateUsage';
  /** The campaign, journey or library template id. */
  id: Scalars['ID'];
  kind: CepWhatsAppTemplateUsageKind;
  name: Scalars['String'];
};

export const CepWhatsAppTemplateUsageKind = {
  Campaign: 'campaign',
  Journey: 'journey',
  Library: 'library'
} as const;

export type CepWhatsAppTemplateUsageKind = typeof CepWhatsAppTemplateUsageKind[keyof typeof CepWhatsAppTemplateUsageKind];
export type ChangedRealtimeEventColumn = {
  __typename?: 'ChangedRealtimeEventColumn';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ChangedRealtimeEventColumnOutput = {
  __typename?: 'ChangedRealtimeEventColumnOutput';
  audience_count: Scalars['String'];
  new: ChangedRealtimeEventColumn;
  old: ChangedRealtimeEventColumn;
};

export type ChangelogItem = {
  __typename?: 'ChangelogItem';
  action: Scalars['String'];
  action_by?: Maybe<Scalars['String']>;
  action_by_api_key_id?: Maybe<Scalars['String']>;
  action_why?: Maybe<Scalars['String']>;
  api_key_name?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  id: Scalars['String'];
  is_guest_admin?: Maybe<Scalars['Boolean']>;
  new?: Maybe<Scalars['JSONObject']>;
  old?: Maybe<Scalars['JSONObject']>;
  resource: Scalars['String'];
  resource_id: Scalars['String'];
  resource_name: Scalars['String'];
  user_name: Scalars['String'];
};

export type ChangelogResult = {
  __typename?: 'ChangelogResult';
  items: Array<ChangelogItem>;
  resources: Array<Scalars['String']>;
  /**
   * Capped total. The resolver short-circuits its count query after a fixed
   * number of matching rows so it doesn't have to scan the workspace's entire
   * changelog history on every list request. When the cap is hit, `total`
   * equals the cap and `totalIsCapped` is true.
   */
  total: Scalars['Int'];
  /**
   * True when the count short-circuited at the cap (real total >= cap).
   * Frontends should render the count as "<total>+" in that case.
   */
  totalIsCapped: Scalars['Boolean'];
};

export type ChannelEngagement = {
  __typename?: 'ChannelEngagement';
  channelType: Scalars['String'];
  clickRate?: Maybe<Scalars['String']>;
  openRate?: Maybe<Scalars['String']>;
  totalReceived: Scalars['Int'];
};

export type ChannelSubscriptions = {
  __typename?: 'ChannelSubscriptions';
  channel: Scalars['String'];
  channelOptOut?: Maybe<SubscriptionLastUpdate>;
  channelOptedIn: Scalars['Boolean'];
  channelOptedOut: Scalars['Boolean'];
  topics: Array<SubscriptionTopic>;
};

export type ChartCardRunData = {
  __typename?: 'ChartCardRunData';
  chartCardId: Scalars['uuid'];
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  isStale: Scalars['Boolean'];
  pendingChartCardRun?: Maybe<ChartCardRunHandle>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ChartCardRunHandle = {
  __typename?: 'ChartCardRunHandle';
  chartCardId: Scalars['uuid'];
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
};

export type ChartError = {
  __typename?: 'ChartError';
  chartCardId: Scalars['uuid'];
  error: Scalars['String'];
};

export type ChartMetadataEntry = {
  __typename?: 'ChartMetadataEntry';
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['JSONObject']>;
};

export type ChartResult = ChartCardRunHandle | ChartError;

export type ChatFileUploadRequestInput = {
  fileName: Scalars['String'];
  /**
   * Omitted when the caller does not have the bytes yet (a library attachment
   * fetches them only once its upload is admitted). The object's real size is
   * still enforced when the upload is confirmed.
   */
  fileSizeBytes?: InputMaybe<Scalars['Float']>;
};

export type ChatFileUploadTarget = {
  __typename?: 'ChatFileUploadTarget';
  fileName: Scalars['String'];
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type CheckDestinationPermissionsInput = {
  /** Checks this one destination instead of a scope. */
  destinationId?: InputMaybe<Scalars['ID']>;
  /** Defaults to linked_connectors. */
  scope?: InputMaybe<DestinationPermissionScope>;
};

export type CheckFacebookTokenPermissionsInput = {
  facebookDestinationId: Scalars['String'];
};

export type CheckFacebookTokenPermissionsResponse = {
  __typename?: 'CheckFacebookTokenPermissionsResponse';
  grantedPermissions: Array<Scalars['String']>;
  hasRequiredPermissions: Scalars['Boolean'];
  missingPermissions: Array<Scalars['String']>;
  tokenUser?: Maybe<MetaTokenUser>;
};

export type CheckTunnelResult = {
  __typename?: 'CheckTunnelResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/**
 * A definition version as a chat response cited it. It can be older than the
 * current version, or belong to a deleted definition.
 */
export type CitedAgentDefinitionVersion = {
  __typename?: 'CitedAgentDefinitionVersion';
  definitionId: Scalars['uuid'];
  id: Scalars['uuid'];
  markdown: Scalars['String'];
  name: Scalars['String'];
  status: AgentDefinitionStatus;
  usageGuidance?: Maybe<Scalars['String']>;
};

export type CleanUpDestinationsInput = {
  destinationIds: Array<Scalars['String']>;
};

export type CleanUpDestinationsResponse = {
  __typename?: 'CleanUpDestinationsResponse';
  failures: Array<CleanUpFailure>;
  success: Scalars['Boolean'];
};

export type CleanUpFailure = {
  __typename?: 'CleanUpFailure';
  destinationId: Scalars['String'];
  error: Scalars['String'];
};

export type ClearAidContentRecommendationsResponse = {
  __typename?: 'ClearAIDContentRecommendationsResponse';
  deletedCount: Scalars['Int'];
};

export type ClearPredictorErrorError = {
  __typename?: 'ClearPredictorErrorError';
  error: Scalars['String'];
};

export type ClearPredictorErrorInput = {
  predictorId: Scalars['uuid'];
};

export type ClearPredictorErrorResult = ClearPredictorErrorError | ClearPredictorErrorSuccess;

export type ClearPredictorErrorSuccess = {
  __typename?: 'ClearPredictorErrorSuccess';
  message: Scalars['String'];
  predictorId: Scalars['uuid'];
};

export type ClientSuccessDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ClientSuccessDescribeObjectResult = {
  __typename?: 'ClientSuccessDescribeObjectResult';
  customFields: Array<Maybe<ClientSuccessField>>;
  fields: Array<ClientSuccessField>;
};

export type ClientSuccessField = {
  __typename?: 'ClientSuccessField';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CloneAgentSessionInput = {
  originalSessionId: Scalars['uuid'];
};

export type CloneAgentSessionResponse = {
  __typename?: 'CloneAgentSessionResponse';
  sessionId: Scalars['uuid'];
};

export type CloneJourneyInput = {
  journey: JourneyInput;
  source_journey_id: Scalars['String'];
};

export type CloneJourneyOutput = {
  __typename?: 'CloneJourneyOutput';
  journey_id: Scalars['String'];
};

export type CloudCredentialQueryResult = {
  __typename?: 'CloudCredentialQueryResult';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  provider: Scalars['String'];
  stripped_config: Scalars['JSONObject'];
};

export type CloudCredentialsMutationInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  provider: Scalars['String'];
};

export type CloudCredentialsResult = {
  __typename?: 'CloudCredentialsResult';
  id: Scalars['String'];
  provider: Scalars['String'];
};

export type CohortInput = {
  baselineGroup?: InputMaybe<Scalars['String']>;
  cohortDefinition?: InputMaybe<AnalyticsCohortDefinitionInput>;
  id?: InputMaybe<Scalars['String']>;
  messageCampaignRunId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<CohortType>;
};

export type CohortOrId = {
  __typename?: 'CohortOrId';
  cohortDefinition?: Maybe<AnalyticsCohortDefinitionOutput>;
  cohortId?: Maybe<Scalars['String']>;
};

export const CohortType = {
  Audience: 'audience',
  JourneySplitNode: 'journey_split_node',
  Message: 'message'
} as const;

export type CohortType = typeof CohortType[keyof typeof CohortType];
export type CollectionConfigOverrideInput = {
  collection_id: Scalars['String'];
  rewardModelConfiguration?: InputMaybe<Scalars['JSONObject']>;
  use_collaborative_filtering?: InputMaybe<Scalars['Boolean']>;
};

export type ColumnResponse = {
  __typename?: 'ColumnResponse';
  columns: Array<QueryColumn>;
};

export type ColumnSourceSurvivorship = {
  __typename?: 'ColumnSourceSurvivorship';
  idrModelId: Scalars['String'];
  survivorshipRuleType: Scalars['String'];
};

export type ColumnSourceSurvivorshipInput = {
  idrModelId: Scalars['String'];
  survivorshipRuleType: Scalars['String'];
};

export type ColumnValidationError = {
  __typename?: 'ColumnValidationError';
  column_name: Scalars['String'];
  reasons: Array<Scalars['String']>;
};

export type CommonFilterSuggestion = {
  __typename?: 'CommonFilterSuggestion';
  conditionTemplate: Scalars['JSONObject'];
  conditionType: Scalars['String'];
  count: Scalars['Int'];
  ratio: Scalars['Float'];
};

export type CommonFilterSuggestionsResult = {
  __typename?: 'CommonFilterSuggestionsResult';
  sampleSize: Scalars['Int'];
  suggestions: Array<CommonFilterSuggestion>;
  totalAudiencesOnModel: Scalars['Int'];
};

export type Competitor = {
  __typename?: 'Competitor';
  accounts: Array<CompetitorAccount>;
  /** Ads scraped across every account. */
  adsCount: Scalars['Int'];
  createdAt: Scalars['String'];
  /** The brand's website domain, when the competitor was created from brand search. */
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** competitor or inspiration. */
  kind: Scalars['String'];
  lastScrapedAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reportScheduleId?: Maybe<Scalars['ID']>;
  /** scraping while any account is pending or scraping; failed when every account failed; otherwise completed or pending. */
  status: Scalars['String'];
};

/** An ad-library account a competitor is connected to. */
export type CompetitorAccount = {
  __typename?: 'CompetitorAccount';
  adsCount: Scalars['Int'];
  avatarUrl?: Maybe<Scalars['String']>;
  /** facebook (Meta Ad Library), google, linkedin, or tiktok. */
  channel: Scalars['String'];
  displayName: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  /** The id the channel's ad library scopes ads by. */
  externalId: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastScrapedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type CompetitorAccountInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  channel: Scalars['String'];
  displayName: Scalars['String'];
  externalId: Scalars['String'];
  externalUrl?: InputMaybe<Scalars['String']>;
};

/** One channel's search outcome. A channel that failed reports error and no results; the others still return. */
export type CompetitorAccountSearch = {
  __typename?: 'CompetitorAccountSearch';
  channel: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  results: Array<CompetitorAccountSearchResult>;
};

export type CompetitorAccountSearchResult = {
  __typename?: 'CompetitorAccountSearchResult';
  adsCountEstimate?: Maybe<Scalars['Int']>;
  avatarUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  channel: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  /** Follower count of a brand account. */
  followers?: Maybe<Scalars['Int']>;
  headquarters?: Maybe<Scalars['String']>;
  igFollowers?: Maybe<Scalars['Int']>;
  igUsername?: Maybe<Scalars['String']>;
  /** advertiser: an entity in the channel's ad library. account: the brand's own profile (TikTok, keyed by @handle). */
  kind: Scalars['String'];
  likes?: Maybe<Scalars['Int']>;
  /** The searched website or link this account was confirmed against. */
  matchedQuery?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** False when the channel lists the account but cannot pull its ads. */
  scrapeable: Scalars['Boolean'];
  verified?: Maybe<Scalars['Boolean']>;
  /** The advertiser's website domain, where the channel reports one. */
  website?: Maybe<Scalars['String']>;
};

export type CompetitorAd = {
  __typename?: 'CompetitorAd';
  adId: Scalars['String'];
  bodyText?: Maybe<Scalars['String']>;
  cards?: Maybe<Scalars['JSON']>;
  /** The channel the ad was scraped from. */
  channel?: Maybe<Scalars['String']>;
  competitorName: Scalars['String'];
  /** The ad's primary media URL, which keys its creative tags. */
  creativeId?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  displayFormat?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  linkUrl?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
  platforms?: Maybe<Array<Scalars['String']>>;
  startDate?: Maybe<Scalars['String']>;
  /** The creative's tags, once the tagging job has processed it. Dimensions that do not apply are left out. */
  tags?: Maybe<Array<CompetitorAdTag>>;
  /** Speech transcript of a video creative, once extracted. */
  transcript?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type CompetitorAdTag = {
  __typename?: 'CompetitorAdTag';
  dimensionKey: Scalars['String'];
  dimensionName: Scalars['String'];
  value: Scalars['JSON'];
};

export type CompetitorAdsResult = {
  __typename?: 'CompetitorAdsResult';
  ads: Array<CompetitorAd>;
  totalCount: Scalars['Int'];
};

/** A brand from logo.dev's company search. */
export type CompetitorBrand = {
  __typename?: 'CompetitorBrand';
  domain: Scalars['String'];
  name: Scalars['String'];
};

export type CompetitorBrandInput = {
  domain: Scalars['String'];
  name: Scalars['String'];
};

export type CompileContentArtifactDynamicContentInput = {
  artifactId: Scalars['uuid'];
  deliveryType: MessageDeliveryType;
  /**
   * Destination whose cached ESP fields should be checked. Missing fields come
   * back as advisory warnings. Its type must equal the compile target.
   */
  destinationId?: InputMaybe<Scalars['String']>;
  target: CompileTarget;
  /** Version to compile; defaults to the artifact's current version. */
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type CompileContentArtifactDynamicContentResponse = {
  __typename?: 'CompileContentArtifactDynamicContentResponse';
  /** Message body in the target dialect, every branch behind a native switch. */
  body: Scalars['String'];
  channel: LcmMessageChannel;
  /** Blocking issues. Export must not proceed. */
  errors: Array<Scalars['String']>;
  /** Profile fields the provider must supply at send time. */
  requiredFields: Array<Scalars['String']>;
  /** Push title, rewritten into the target dialect. Null for SMS. */
  title?: Maybe<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};

export type CompileContentEmailDynamicContentInput = {
  /** Selects the compile dialect for the deployment strategy. */
  deliveryType: ContentDeploymentDeliveryType;
  /**
   * Destination whose cached user fields should be checked. Missing fields are
   * returned as advisory warnings for ESP-orchestrated delivery.
   */
  destinationId?: InputMaybe<Scalars['String']>;
  emailId: Scalars['uuid'];
  /** iterable | braze | sfmc | klaviyo | sailthru */
  target: Scalars['String'];
  /** Version to compile; defaults to the email's current version. */
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type CompileContentEmailDynamicContentResponse = {
  __typename?: 'CompileContentEmailDynamicContentResponse';
  /** Blocking issues. Deploy must not proceed. */
  errors: Array<Scalars['String']>;
  /**
   * Per-recipient fields the send payload must supply: branch keys + merge
   * variables found in the template (and subject).
   */
  requiredFields: Array<Scalars['String']>;
  /**
   * Subject rewritten into the target dialect when applicable (AMPscript for
   * SFMC); null when the email has no subject.
   */
  subject?: Maybe<Scalars['String']>;
  /**
   * Target-dialect template with every branch embedded behind a switch on the
   * slot's branch-key field. Safe to paste into the target ESP.
   */
  template: Scalars['String'];
  warnings: Array<Scalars['String']>;
};

/**
 * Dialects the dynamic-content compiler can emit. Mirrors the CompileTarget
 * union in dynamic-content/types.ts. Emitting a dialect is not the same as
 * being able to write to that provider — Braze compiles but has no SMS/push
 * campaign API, so the provider service is the gate on export.
 */
export const CompileTarget = {
  Braze: 'braze',
  Iterable: 'iterable',
  Klaviyo: 'klaviyo',
  Sailthru: 'sailthru',
  Sfmc: 'sfmc'
} as const;

export type CompileTarget = typeof CompileTarget[keyof typeof CompileTarget];
export type CompleteCepWhatsAppEmbeddedSignupInput = {
  businessId: Scalars['String'];
  /** The exchangeable code from FB.login, valid for 30 seconds. */
  code: Scalars['String'];
  /** The number the customer chose before signup, checked against the one Meta connected. */
  phoneNumber: Scalars['String'];
  phoneNumberId: Scalars['String'];
  wabaId: Scalars['String'];
};

export type CompleteCepWhatsAppEmbeddedSignupResult = {
  __typename?: 'CompleteCepWhatsAppEmbeddedSignupResult';
  /** Opaque and short-lived. Pass it to createCepProvider as whatsappSignupToken. */
  signupToken: Scalars['String'];
};

export type ComponentImpact = {
  __typename?: 'ComponentImpact';
  schema_slugs: Array<Scalars['String']>;
};

export type ConfidenceInterval = {
  __typename?: 'ConfidenceInterval';
  confidence: Scalars['Float'];
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type ConfigureChannelDoubleOptInInput = {
  cepChannelId: Scalars['ID'];
  /**
   * SMS only: the message sent after the recipient confirms their
   * subscription, persisted as a campaign-less message owned by the channel via
   * cep_channels.double_opt_in_confirmation_message_id. Required for SMS double
   * opt-in; omitted for email (which confirms via redirectUrl).
   */
  confirmationMessage?: InputMaybe<CreateDoubleOptInTopicMessageInput>;
  /**
   * The primary opt-in message, persisted as a campaign-less message owned by
   * the channel via cep_channels.double_opt_in_message_id. For email this is
   * the opt-in confirmation email; for SMS it is the opt-in instructions
   * telling the recipient how to confirm.
   */
  message: CreateDoubleOptInTopicMessageInput;
  /**
   * Email only: page the recipient lands on after confirming their
   * subscription. Required for email double opt-in; omitted for SMS, which
   * confirms via a reply and a confirmation message instead of a redirect.
   */
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ConfigureChannelDoubleOptInResult = {
  __typename?: 'ConfigureChannelDoubleOptInResult';
  cepChannelId: Scalars['ID'];
  confirmationMessageId?: Maybe<Scalars['ID']>;
  messageId: Scalars['ID'];
};

export type ConfigureSsoInput = {
  cert: Scalars['String'];
  signInEndpoint: Scalars['String'];
};

export type ConfirmAdAssetMediaUploadInput = {
  assetId: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ConfirmAdAssetMediaUploadResponse = {
  __typename?: 'ConfirmAdAssetMediaUploadResponse';
  contentType: Scalars['String'];
  name: Scalars['String'];
  s3Key: Scalars['String'];
};

export type ConnectedChannel = {
  __typename?: 'ConnectedChannel';
  category: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
};

export type ConnectionDetails = {
  __typename?: 'ConnectionDetails';
  host: Scalars['String'];
  port: Scalars['Int'];
};

export type ConnectionRole = {
  __typename?: 'ConnectionRole';
  available: Scalars['Boolean'];
  firstSeenAt: Scalars['String'];
  id: Scalars['String'];
  lastSeenAt: Scalars['String'];
  roleIdentifier: Scalars['String'];
};

export type ConnectionRoleCacheStatus = {
  __typename?: 'ConnectionRoleCacheStatus';
  connectionId: Scalars['Int'];
  lastRefreshAttemptedAt: Scalars['String'];
  lastRefreshError?: Maybe<Scalars['String']>;
  lastRefreshSucceededAt: Scalars['String'];
  principalFingerprint: Scalars['String'];
};

export type ConnectionRoleMapping = {
  __typename?: 'ConnectionRoleMapping';
  connectionId: Scalars['Int'];
  connectionRoleId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  priority: Scalars['Int'];
  updatedAt: Scalars['String'];
  userGroupId: Scalars['String'];
};

export type ConnectionRoleSettings = {
  __typename?: 'ConnectionRoleSettings';
  connectionId: Scalars['Int'];
  createdAt: Scalars['String'];
  defaultConnectionRoleId: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ConsentPurgeValidationError = {
  __typename?: 'ConsentPurgeValidationError';
  /**
   * One of revocationsModel | primaryKey | revokedAt | sanitizedColumns,
   * matching the form fields.
   */
  field: Scalars['String'];
  message: Scalars['String'];
};

export type ConsentPurgeValidationFailed = {
  __typename?: 'ConsentPurgeValidationFailed';
  errors: Array<ConsentPurgeValidationError>;
};

export type ContentArtifactDynamicSlot = {
  __typename?: 'ContentArtifactDynamicSlot';
  /**
   * "audience_schema" or "esp_profile" — selects the condition dialect
   * branches carry.
   */
  assignmentSource: Scalars['String'];
  assignmentType: Scalars['String'];
  /**
   * Branch array: { id, name, condition, content, blocks?, fields?,
   * contentId? }[] for message-scoped slots.
   */
  branches: Scalars['JSON'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  scope: Scalars['String'];
};

export type ContentArtifactMetadata = {
  __typename?: 'ContentArtifactMetadata';
  createdBy?: Maybe<Scalars['Int']>;
  generateInput?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

export type ContentArtifactMetadataInput = {
  generateInput?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  content: Scalars['String'];
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liquidTag?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ContentComponentInput = {
  componentType?: InputMaybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/**
 * How a dynamic-content deployment delivers sends / which compile dialect
 * to emit. Values match content_deployments.delivery_type.
 */
export const ContentDeploymentDeliveryType = {
  AiDecisioning: 'ai_decisioning',
  EspOrchestrated: 'esp_orchestrated',
  TriggerSync: 'trigger_sync'
} as const;

export type ContentDeploymentDeliveryType = typeof ContentDeploymentDeliveryType[keyof typeof ContentDeploymentDeliveryType];
export type ContentElementChangeInput = {
  annotation: Scalars['String'];
  label: Scalars['String'];
};

/**
 * Placement-shaped slot for the LCM editor. `id` is the HTML marker /
 * usage id. Read `branches` are hydrated:
 * ({ id, name, condition, content, contentId }[]).
 */
export type ContentEmailDynamicSlot = {
  __typename?: 'ContentEmailDynamicSlot';
  /**
   * Library condition mode: `audience_schema` (audience AST per branch) or
   * `esp_profile` (ESP-native predicate per branch, in `espCondition`).
   */
  assignmentSource: Scalars['String'];
  assignmentType: Scalars['String'];
  branches: Scalars['JSON'];
  id: Scalars['uuid'];
  /**
   * Placement display name (per usage, falling back to the library name;
   * also slugged into AID variable names at compile time).
   */
  name: Scalars['String'];
};

export type ContentEmailPersonalizationPreviewResponse = {
  __typename?: 'ContentEmailPersonalizationPreviewResponse';
  catalogs: Array<ContentPersonalizationCatalog>;
  esp?: Maybe<EspDestinationInfo>;
  language: ContentPersonalizationTemplateLanguage;
  lastRefreshedAt?: Maybe<Scalars['timestamptz']>;
  options: Array<ContentPersonalizationPreviewOption>;
  parseDiagnostic?: Maybe<Scalars['String']>;
  /**
   * The expanded email this preview was built from. Lets clients render a
   * preview from this query alone instead of also running a render query.
   * Null for non-email previews.
   */
  renderedEmail?: Maybe<RenderedEmailWithContentBlocks>;
  /**
   * Merge tags written in a different ESP's dialect than the resolved provider
   * expects. Advisory, not blocking: the tags are preserved as authored, but
   * export to the provider is refused until they are rewritten. Empty when no
   * ESP target resolved.
   */
  templateDialectWarnings: Array<Scalars['String']>;
  unsimulatedTags: Array<Scalars['String']>;
  variables: Array<ContentEmailPersonalizationVariable>;
};

export type ContentEmailPersonalizationVariable = {
  __typename?: 'ContentEmailPersonalizationVariable';
  examples: Array<Scalars['JSON']>;
  existsInEsp?: Maybe<Scalars['Boolean']>;
  isConditional: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ContentEmailVersionResolvedHtmlResponse = {
  __typename?: 'ContentEmailVersionResolvedHtmlResponse';
  html?: Maybe<Scalars['String']>;
};

export type ContentImageReadUrlResponse = {
  __typename?: 'ContentImageReadUrlResponse';
  expiresAt?: Maybe<Scalars['timestamptz']>;
  url: Scalars['String'];
};

export type ContentImageSearchErrorResult = {
  __typename?: 'ContentImageSearchErrorResult';
  error: Scalars['String'];
};

export type ContentImageSearchJobResponse = {
  __typename?: 'ContentImageSearchJobResponse';
  jobId: Scalars['String'];
};

export type ContentImageSearchPendingResult = {
  __typename?: 'ContentImageSearchPendingResult';
  status: Scalars['String'];
};

export type ContentImageSearchResultResponse = ContentImageSearchErrorResult | ContentImageSearchPendingResult | ContentImageSearchSuccessResult;

export type ContentImageSearchSuccessResult = {
  __typename?: 'ContentImageSearchSuccessResult';
  results: Array<SearchContentImagesResult>;
};

export type ContentNodeForImageUrl = {
  __typename?: 'ContentNodeForImageUrl';
  html?: Maybe<Scalars['String']>;
  nodeId: Scalars['uuid'];
  svg?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ContentPersonalizationCatalog = {
  __typename?: 'ContentPersonalizationCatalog';
  name: Scalars['String'];
  sampleRows: Array<Scalars['JSON']>;
};

export type ContentPersonalizationPreviewArtifactInput = {
  contentArtifactId: Scalars['uuid'];
  versionId: Scalars['uuid'];
};

export type ContentPersonalizationPreviewEmailInput = {
  contentEmailId: Scalars['uuid'];
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type ContentPersonalizationPreviewOption = {
  __typename?: 'ContentPersonalizationPreviewOption';
  values: Scalars['JSON'];
};

export const ContentPersonalizationTemplateLanguage = {
  Handlebars: 'HANDLEBARS',
  Liquid: 'LIQUID'
} as const;

export type ContentPersonalizationTemplateLanguage = typeof ContentPersonalizationTemplateLanguage[keyof typeof ContentPersonalizationTemplateLanguage];
/**
 * Which store a citation points at: a workspace-owned entity (`entity:<id>`) or
 * a global, Hightouch-managed one (`global:<id>`). The same id can exist on
 * both, so a target is only identified by scope and id together.
 */
export const ContextCitationScope = {
  Global: 'global',
  Workspace: 'workspace'
} as const;

export type ContextCitationScope = typeof ContextCitationScope[keyof typeof ContextCitationScope];
/** A document that cites the entity being described. */
export type ContextEntityCitingSource = {
  __typename?: 'ContextEntityCitingSource';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type ContextEntityUsage = {
  __typename?: 'ContextEntityUsage';
  categories: Array<ContextEntityUsageCategoryStats>;
  entityId: Scalars['uuid'];
  windowDays: Scalars['Int'];
};

/** Per-agent usage stats for a single context entity, over the requested window. */
export type ContextEntityUsageCategoryStats = {
  __typename?: 'ContextEntityUsageCategoryStats';
  category: ContextUsageAgentCategory;
  /** True when this agent force-injects the entity's context type into its system prompt (always in context). readRate is not meaningful here — surface 'Always loaded' instead of a percentage. */
  forceInjected: Scalars['Boolean'];
  /** All-time interactions where the file was in scope. */
  interactionsWithFile: Scalars['Int'];
  /** readsThisWindow / timesAvailableThisWindow. Null only when nothing was in scope. */
  readRate?: Maybe<Scalars['Float']>;
  /** Interactions in the window that read the file. */
  readsThisWindow: Scalars['Int'];
  /** Interactions in the window where the file was in scope — the read-rate denominator. */
  timesAvailableThisWindow: Scalars['Int'];
  /** All-time interactions that read the file. */
  totalReads: Scalars['Int'];
};

export const ContextFileType = {
  BrandGuidelines: 'brand_guidelines',
  BusinessContext: 'business_context',
  LaunchPlaybook: 'launch_playbook',
  Skill: 'skill',
  StyleImage: 'style_image',
  WinnerCriteria: 'winner_criteria'
} as const;

export type ContextFileType = typeof ContextFileType[keyof typeof ContextFileType];
export type ContextReviewSuggestions = {
  __typename?: 'ContextReviewSuggestions';
  isLatest: Scalars['Boolean'];
  suggestions: Array<AgenticSettingsContextReviewSuggestion>;
};

/**
 * Agent bucket that context-usage stats are grouped by, derived from the
 * session's creation source. Ads, Lifecycle, and Data (reports) agents map to
 * their own buckets; every other agent falls into Other.
 */
export const ContextUsageAgentCategory = {
  Ads: 'ads',
  Data: 'data',
  Lcm: 'lcm',
  Other: 'other'
} as const;

export type ContextUsageAgentCategory = typeof ContextUsageAgentCategory[keyof typeof ContextUsageAgentCategory];
export type ConvertEmlToHtmlInput = {
  eml: Scalars['String'];
};

export type ConvertEmlToHtmlResponse = {
  __typename?: 'ConvertEmlToHtmlResponse';
  html: Scalars['String'];
};

export type ConvertSessionToReportPromptErrorResponse = {
  __typename?: 'ConvertSessionToReportPromptErrorResponse';
  error: Scalars['String'];
};

export type ConvertSessionToReportPromptInput = {
  originalSessionId: Scalars['uuid'];
};

export type ConvertSessionToReportPromptResponse = ConvertSessionToReportPromptErrorResponse | ConvertSessionToReportPromptSuccessResponse;

export type ConvertSessionToReportPromptSuccessResponse = {
  __typename?: 'ConvertSessionToReportPromptSuccessResponse';
  interactionId: Scalars['uuid'];
};

export type CopyReferencesIngestionRun = {
  __typename?: 'CopyReferencesIngestionRun';
  brandProfileId?: Maybe<Scalars['uuid']>;
  channel: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /**
   * Destination this run's copy-examples set is scoped to, from the session
   * marker. Null for a channel-generic run. Lets the UI scope run status per
   * (channel, destination) tuple.
   */
  destinationId?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  interactionId?: Maybe<Scalars['uuid']>;
  sessionId: Scalars['uuid'];
  status: CopyReferencesIngestionStatus;
  updatedAt: Scalars['timestamptz'];
};

export const CopyReferencesIngestionStatus = {
  Canceled: 'canceled',
  Complete: 'complete',
  Failed: 'failed',
  Pending: 'pending'
} as const;

export type CopyReferencesIngestionStatus = typeof CopyReferencesIngestionStatus[keyof typeof CopyReferencesIngestionStatus];
export const CopyReferencesManualFormat = {
  Csv: 'csv',
  Markdown: 'markdown'
} as const;

export type CopyReferencesManualFormat = typeof CopyReferencesManualFormat[keyof typeof CopyReferencesManualFormat];
export type CopyReferencesManualInput = {
  format: CopyReferencesManualFormat;
  text: Scalars['String'];
};

/**
 * A brand's public Meta Ad Library page to pull ad copy from. `pageId` comes
 * from searchMetaAdLibraryCompanies; `country` is the ISO country code to
 * fetch ads for (defaults to US).
 */
export type CopyReferencesMetaAdLibraryInput = {
  country?: InputMaybe<Scalars['String']>;
  pageId: Scalars['String'];
  pageName?: InputMaybe<Scalars['String']>;
};

export type CopyReferencesReview = {
  __typename?: 'CopyReferencesReview';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  suggestions: Array<CopyReferencesReviewSuggestion>;
  summary: Scalars['String'];
};

/** Reviewer-authored example appended to the proposed content on accept. */
export type CopyReferencesReviewCopyExampleAdditionInput = {
  body: Scalars['String'];
  campaignName?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 * Reviewer edit to one proposed example's copy fields, applied on accept.
 * Omitted/null fields keep the proposed value; an empty string clears an
 * optional field. body cannot be cleared, only replaced.
 */
export type CopyReferencesReviewCopyExampleEditInput = {
  body?: InputMaybe<Scalars['String']>;
  campaignName?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  exampleId: Scalars['String'];
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CopyReferencesReviewCopyExampleOverrideInput = {
  exampleId: Scalars['String'];
  excluded: Scalars['Boolean'];
};

export type CopyReferencesReviewDecisionInput = {
  copyExampleAdditions?: InputMaybe<Array<CopyReferencesReviewCopyExampleAdditionInput>>;
  copyExampleEdits?: InputMaybe<Array<CopyReferencesReviewCopyExampleEditInput>>;
  copyExampleOverrides?: InputMaybe<Array<CopyReferencesReviewCopyExampleOverrideInput>>;
  /**
   * Ids of proposed examples to drop entirely — unlike an exclusion override,
   * a removed example is not kept on the entity for later re-inclusion.
   */
  copyExampleRemovals?: InputMaybe<Array<Scalars['String']>>;
  decision: AgenticSettingsContextReviewDecision;
  suggestionId: Scalars['uuid'];
};

export type CopyReferencesReviewSuggestion = {
  __typename?: 'CopyReferencesReviewSuggestion';
  appliedToEntityVersionId?: Maybe<Scalars['uuid']>;
  currentContent?: Maybe<AgenticSettingsCopyExamplesContent>;
  entityId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isStale: Scalars['Boolean'];
  opType: AgenticSettingsReviewOpType;
  proposedContent: AgenticSettingsCopyExamplesContent;
  reason: AgenticSettingsReviewSuggestionReason;
  status: AgenticSettingsReviewSuggestionStatus;
  summary: Scalars['String'];
};

/**
 * A customer-owned warehouse Source plus the pre-selected table to read
 * historical sends from. `connectionId` is the Hightouch Source id; `table`
 * is the fully-qualified table name (e.g. `schema.table`).
 */
export type CopyReferencesWarehouseInput = {
  connectionId: Scalars['String'];
  table: Scalars['String'];
};

export type CreateAdStudioProjectSessionInput = {
  adStudioStyleId?: InputMaybe<Scalars['ID']>;
  adStudioStyleMode?: InputMaybe<Scalars['String']>;
  agentMode?: InputMaybe<Scalars['String']>;
  brandProfileId?: InputMaybe<Scalars['ID']>;
  conceptCount?: InputMaybe<Scalars['Int']>;
  context?: InputMaybe<LlmSessionContextInput>;
  creationSource?: InputMaybe<Scalars['String']>;
  creativeBoost?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<Array<FileInput>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  initialUserPrompt: Scalars['String'];
  interactionContext?: InputMaybe<InteractionContextInput>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  projectContext: Scalars['JSONObject'];
  projectName: Scalars['String'];
};

export type CreateAdStudioProjectSessionResponse = {
  __typename?: 'CreateAdStudioProjectSessionResponse';
  interactionId?: Maybe<Scalars['uuid']>;
  projectId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type CreateAdTemplateInput = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  figmaConnectionId?: InputMaybe<Scalars['uuid']>;
  figmaSourceId?: InputMaybe<Scalars['uuid']>;
  figmaUrl?: InputMaybe<Scalars['String']>;
  inferName?: InputMaybe<Scalars['Boolean']>;
  instructions?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  source: Scalars['String'];
  sourceAd?: InputMaybe<AdTemplateSourceAdInput>;
};

export type CreateAdTemplateResponse = {
  __typename?: 'CreateAdTemplateResponse';
  error?: Maybe<Scalars['String']>;
  interactionId?: Maybe<Scalars['uuid']>;
  sessionId?: Maybe<Scalars['uuid']>;
};

export type CreateAgentConnectorInput = {
  credentialId: Scalars['ID'];
  credentialKind: AgentConnectorCredentialKind;
  type: Scalars['String'];
};

/**
 * A definition written by hand. Only a user who can approve definitions can
 * create one, so it starts verified.
 */
export type CreateAgentDefinitionInput = {
  /** Omit or leave empty to apply the definition to all agents. */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  /** Omit or leave empty to apply the definition to all brand profiles. */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  markdown: Scalars['String'];
  name: Scalars['String'];
  scope: AgenticSettingsEntityScopeInput;
  usageGuidance?: InputMaybe<Scalars['String']>;
};

/**
 * Creates one memory per item, all or nothing: if any memory fails to save,
 * none are saved. The batch-level parentModelId / sourceId scopes every memory
 * in the batch; omitting both creates workspace-wide memories.
 */
export type CreateAgentMemoriesInput = {
  memories: Array<CreateAgentMemoryInput>;
  parentModelId?: InputMaybe<Scalars['bigint']>;
  sourceId?: InputMaybe<Scalars['bigint']>;
};

export type CreateAgentMemoriesResponse = {
  __typename?: 'CreateAgentMemoriesResponse';
  memories: Array<AgentMemory>;
};

/**
 * Create agent memory with scoping rules:
 * - General workspace knowledge: omit both parentModelId and sourceId
 * - Customer Studio schema-specific: set parentModelId only
 * - Data source/SQL-specific: set sourceId only
 * Note: parentModelId and sourceId are mutually exclusive
 */
export type CreateAgentMemoryInput = {
  content: Scalars['String'];
  parentModelId?: InputMaybe<Scalars['bigint']>;
  sourceId?: InputMaybe<Scalars['bigint']>;
  title: Scalars['String'];
};

export type CreateAgentSessionInput = {
  context?: InputMaybe<LlmSessionContextInput>;
  creationSource: Scalars['String'];
  customAgentId?: InputMaybe<Scalars['String']>;
  customAgentPrompt?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<FileInput>>;
  focusedContent?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  initialUserPrompt: Scalars['String'];
  interactionContext?: InputMaybe<InteractionContextInput>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<MetadataInput>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  reportScheduleId?: InputMaybe<Scalars['String']>;
};

export type CreateAgentSessionResponse = {
  __typename?: 'CreateAgentSessionResponse';
  error?: Maybe<Scalars['String']>;
  interactionId?: Maybe<Scalars['uuid']>;
  sessionId: Scalars['uuid'];
};

export type CreateAgenticSettingsEntityInput = {
  /**
   * Agents this entity is routed to. Omitted or empty means "applies to all
   * agents" (an empty array is coerced to null on write).
   */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  /**
   * Optional brand-profile assignment to apply at creation. Omitted or empty
   * means "applies to all brand profiles" (zero join rows). Each id must
   * reference a non-deleted brand profile in the caller's workspace.
   */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  contextCopyExamples?: InputMaybe<AgenticSettingsCopyExamplesContentInput>;
  contextFile?: InputMaybe<AgenticSettingsFileContentCreateInput>;
  contextMarkdown?: InputMaybe<AgenticSettingsMarkdownContentInput>;
  contextType?: InputMaybe<ContextFileType>;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  /**
   * Hides the entity from every listing. It reaches an agent only through a
   * document that cites it, so create it this way for an asset (an image, a
   * supporting document) that belongs to another document rather than standing
   * on its own. Omitted means false.
   */
  isReferenceOnly?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type: AgenticSettingsEntityType;
};

export type CreateAmpActionInput = {
  contextLinkIds?: InputMaybe<Array<Scalars['ID']>>;
  destinations?: InputMaybe<Array<AmpActionDestinationScopeInput>>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  instruction: Scalars['String'];
  title: Scalars['String'];
};

export type CreateAmpActionResult = {
  __typename?: 'CreateAmpActionResult';
  actionId: Scalars['ID'];
  id: Scalars['ID'];
};

export type CreateAmpAgentInput = {
  /** The context snapshot of the sender, sent with the first message: an object whose keys are names of plugins of the agent type that declare a context, each with a value that passes the schema of that plugin context, for example {"canvas": {...}}. At most 16 KiB of JSON. Omitted or null sends no snapshot. */
  context?: InputMaybe<Scalars['JSON']>;
  /** The parameters of the agent, fixed for its lifetime: a value that passes the parameters schema of the agent type. Omitted or null passes none, which only an agent type whose parameters are optional accepts. An agent type without a parameters schema rejects any. */
  parameters?: InputMaybe<Scalars['JSON']>;
  /** Files that the member uploaded through initiateChatFileUploads, sent with the first message. */
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  text: Scalars['String'];
  /** An agent type of the harness. */
  type: Scalars['String'];
};

export type CreateAmpAgentResponse = {
  __typename?: 'CreateAmpAgentResponse';
  agent: AmpAgent;
  interactionId: Scalars['uuid'];
  message: AmpAgentMessage;
};

export type CreateAmpAssetGroupInput = {
  name: Scalars['String'];
};

export type CreateAmpAssetSourceInput = {
  config: Scalars['JSON'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreateAmpAssetSyncInput = {
  config: Scalars['JSON'];
  name: Scalars['String'];
  newTargetAssetGroup?: InputMaybe<CreateAmpAssetGroupInput>;
  schedule?: InputMaybe<Scalars['JSON']>;
  schedulePaused?: InputMaybe<Scalars['Boolean']>;
  source: CreateAmpAssetSourceInput;
  targetAssetGroupId?: InputMaybe<Scalars['ID']>;
};

/** links attach work to the project in the same transaction that opens it. */
export type CreateAmpProjectInput = {
  brandProfileId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  /** An ISO 8601 instant with an offset. */
  dueAt?: InputMaybe<Scalars['String']>;
  externalRef?: InputMaybe<AmpProjectExternalRefInput>;
  /** An emoji that stands in for the project on task cards. */
  icon?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<AmpProjectLinkTargetInput>>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Without ownerUserIds the project belongs to whoever opens it. */
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  /** An ISO 8601 instant with an offset. */
  startAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AmpProjectStatus>;
  statusLine?: InputMaybe<Scalars['String']>;
  /**
   * Without a workflowId, true (the default) gives the project a task board on
   * the workspace default workflow, and false gives it none. Without a task
   * board the project takes no tasks.
   */
  taskBoard?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  /** The task board's workflow. A workflowId implies taskBoard. */
  workflowId?: InputMaybe<Scalars['ID']>;
};

/**
 * Without a statusId the task gets the first backlog status of the project's
 * workflow. With a parentTaskId it is a subtask instead, starting in the
 * backlog category. Without ownerUserIds the task belongs to whoever creates it.
 */
export type CreateAmpTaskInput = {
  assignees?: InputMaybe<Array<AmpTaskUserInput>>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<AmpProjectLinkTargetInput>>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  parentTaskId?: InputMaybe<Scalars['ID']>;
  reviewers?: InputMaybe<Array<AmpTaskUserInput>>;
  statusId?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateApiKeyInput = {
  hash: Scalars['String'];
  name: Scalars['String'];
  userGroupId?: InputMaybe<Scalars['String']>;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  id: Scalars['String'];
};

export type CreateAsanaTaskForCampaignInput = {
  campaignId: Scalars['ID'];
  name: Scalars['String'];
  /** Plain text. Asana's rich description field rejects anything outside its markup grammar, which typed prose routinely is. */
  notes?: InputMaybe<Scalars['String']>;
  /** The project to file the task in. Omitted, the task lands in no project and only its assignee will find it. */
  projectGid?: InputMaybe<Scalars['ID']>;
};

/**
 * assetId is the asset the version is appended to: a primary or a native
 * resize, each with its own versions and component map. With a primary,
 * channelSizeId names one of its sizes in the older form and the version lands
 * on that size's resize (created on its first save); with a resize asset's id
 * it is ignored.
 */
export type CreateAssetVersionInput = {
  assetId: Scalars['uuid'];
  assetName?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetUrl?: InputMaybe<Scalars['String']>;
  autosave?: InputMaybe<Scalars['Boolean']>;
  channelSizeId?: InputMaybe<Scalars['String']>;
  componentAssets?: InputMaybe<Scalars['JSON']>;
  compositeBase64?: InputMaybe<Scalars['String']>;
  llmChatMessageId?: InputMaybe<Scalars['uuid']>;
  newComponentAssets?: InputMaybe<Array<NewComponentAssetInput>>;
  svg?: InputMaybe<Scalars['String']>;
  /**
   * Enriched Catalog template manifest. On a template asset the version's
   * manifest is carried forward when omitted; the save is validated so the
   * markup and manifest stay a bijection.
   */
  templateManifest?: InputMaybe<Scalars['JSON']>;
  videoComposition?: InputMaybe<Scalars['JSON']>;
};

export type CreateAssetVersionResponse = {
  __typename?: 'CreateAssetVersionResponse';
  versionId: Scalars['uuid'];
};

export type CreateAudienceTemplateInput = {
  definition: Scalars['jsonb'];
  description: Scalars['String'];
  labels?: InputMaybe<Scalars['jsonb']>;
  name: Scalars['String'];
  parentModelId: Scalars['bigint'];
};

export type CreateAudienceTemplateResponse = {
  __typename?: 'CreateAudienceTemplateResponse';
  id: Scalars['uuid'];
};

export type CreateAuditLogExportResult = {
  __typename?: 'CreateAuditLogExportResult';
  id: Scalars['String'];
};

export type CreateCalendarViewInput = {
  filters: Scalars['JSON'];
  name: Scalars['String'];
  visibility?: CalendarViewVisibility;
};

export type CreateCampaignResult = {
  __typename?: 'CreateCampaignResult';
  campaignId: Scalars['String'];
};

export type CreateCepChannelInput = {
  channelDailyCap?: InputMaybe<Scalars['Int']>;
  channelFreqCap?: InputMaybe<Scalars['JSONObject']>;
  channelType: Scalars['String'];
  linkTrackingConfig?: InputMaybe<Scalars['JSONObject']>;
  quietHoursConfig?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateCepChannelResult = {
  __typename?: 'CreateCepChannelResult';
  id: Scalars['String'];
};

export type CreateCepCloudflareTrackingDomainInput = {
  domain: Scalars['String'];
};

export type CreateCepCloudflareTrackingDomainResult = {
  __typename?: 'CreateCepCloudflareTrackingDomainResult';
  dnsRecords: Array<VerifyCepDomainDnsRecord>;
  id: Scalars['ID'];
};

export type CreateCepDevicePreviewInput = {
  cepEmailTemplateId?: InputMaybe<Scalars['uuid']>;
  /**
   * Mailgun client IDs to render the preview against.
   * If this list is empty, the preview will be rendered against the default set of clients.
   */
  clients?: InputMaybe<Array<Scalars['String']>>;
  html: Scalars['String'];
  /**
   * Optional owner. Provide at most one of messageId or cepEmailTemplateId; omit
   * both for a standalone preview that a message or template adopts on save.
   */
  messageId?: InputMaybe<Scalars['uuid']>;
  /** Interpolated subject and html that get forwarded to the provider's API to render the preview. */
  subject: Scalars['String'];
  templateHtml: Scalars['String'];
  /**
   * The locale whose translations resolved the interpolated subject and html
   * above. Null means the default locale. The template reads the same in every
   * locale, so only this field tells two locales' previews apart.
   */
  templateLocaleId?: InputMaybe<Scalars['uuid']>;
  /**
   * Raw template form, snapshotted on the row so staleness can be detected by
   * comparing against the owner's current template.
   */
  templateSubject: Scalars['String'];
};

export type CreateCepDevicePreviewResult = {
  __typename?: 'CreateCepDevicePreviewResult';
  id: Scalars['uuid'];
};

export type CreateCepEventSyncInput = {
  warehouseConnectionId: Scalars['Int'];
};

export type CreateCepEventSyncResult = {
  __typename?: 'CreateCepEventSyncResult';
  created: Scalars['Boolean'];
  eventSourceId: Scalars['String'];
  eventWarehouseDestinationId: Scalars['String'];
  forwardingDestinationId: Scalars['String'];
  forwardingSyncId: Scalars['String'];
  warehouseSyncId: Scalars['String'];
  writeKey: Scalars['String'];
};

export type CreateCepProviderInput = {
  cepChannelId: Scalars['ID'];
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  providerType: Scalars['String'];
  secrets: Scalars['JSONObject'];
  transactional?: InputMaybe<Scalars['Boolean']>;
  /** From completeCepWhatsAppEmbeddedSignup. Supplies the provider's WhatsApp Business Account and Meta token. */
  whatsappSignupToken?: InputMaybe<Scalars['String']>;
};

export type CreateCepWhatsAppTemplateInput = {
  /** Whether the template joins the reusable library. Defaults to false. */
  addedToLibrary?: InputMaybe<Scalars['Boolean']>;
  /** The CEP brand the template belongs to. Null or absent: usable by every brand. */
  cepBrandId?: InputMaybe<Scalars['ID']>;
  /** Required only when the workspace has more than one WhatsApp account. */
  cepProviderId?: InputMaybe<Scalars['ID']>;
  /**
   * A template whose localization the new one takes, for a copy of its
   * content: its languages and translations, each locale unsubmitted.
   */
  copyLocalizationFromTemplateId?: InputMaybe<Scalars['ID']>;
  /** Authored content: components, and an example value per variable. */
  editorState?: InputMaybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  requestedCategory: Scalars['String'];
};

export type CreateCepWhatsAppTemplateResult = {
  __typename?: 'CreateCepWhatsAppTemplateResult';
  id: Scalars['ID'];
};

export type CreateComponentFromDocumentInput = {
  /** Component type (e.g. "Header", "Footer"). Free-form. Generated from the source document when omitted. */
  componentType?: InputMaybe<Scalars['String']>;
  /** Short description of the component. Generated from the source document when omitted. */
  description?: InputMaybe<Scalars['String']>;
  /** Display name for the new component. Generated from the source document when omitted. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Full cleaned source document (doctype + html + head styles + body) with the
   * user's selected element marked by a single `data-ht-component-anchor`
   * attribute. The extraction agent reads this to recover the element plus its
   * responsive counterpart(s) and required ancestor scaffolding.
   */
  sourceHtml: Scalars['String'];
};

export type CreateConnectionRoleMappingInput = {
  connectionId: Scalars['Int'];
  connectionRoleId: Scalars['String'];
  priority: Scalars['Int'];
  userGroupId: Scalars['String'];
};

export type CreateContentArtifactInput = {
  artifactType: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  llmChatSessionId?: InputMaybe<Scalars['uuid']>;
  name: Scalars['String'];
};

export type CreateContentArtifactResponse = {
  __typename?: 'CreateContentArtifactResponse';
  artifactId: Scalars['uuid'];
};

export type CreateContentCopyVersionInput = {
  contentCopyId: Scalars['uuid'];
  fields: Scalars['JSON'];
};

export type CreateContentCopyVersionResponse = {
  __typename?: 'CreateContentCopyVersionResponse';
  versionId: Scalars['uuid'];
};

export type CreateContentEmailAndSessionInput = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  html: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  referenceEmailId: Scalars['uuid'];
  subject?: InputMaybe<Scalars['String']>;
};

export type CreateContentEmailAndSessionResponse = {
  __typename?: 'CreateContentEmailAndSessionResponse';
  id: Scalars['uuid'];
  sessionId: Scalars['uuid'];
  versionId: Scalars['uuid'];
};

export type CreateContentEmailFromNdTemplateResult = {
  __typename?: 'CreateContentEmailFromNdTemplateResult';
  contentEmailId: Scalars['uuid'];
};

export type CreateContentEmailVersionInput = {
  contentEmailId: Scalars['uuid'];
  html: Scalars['String'];
  llmChatMessageId?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type CreateContentEmailVersionResponse = {
  __typename?: 'CreateContentEmailVersionResponse';
  versionId: Scalars['uuid'];
};

export type CreateContentImageUploadConflict = {
  __typename?: 'CreateContentImageUploadConflict';
  existingImageId: Scalars['uuid'];
  message: Scalars['String'];
};

export type CreateContentImageUploadInput = {
  altText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalProviderId?: InputMaybe<Scalars['String']>;
  externalProviderMetadata?: InputMaybe<Scalars['JSON']>;
  externalProviderType?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  sizeBytes?: InputMaybe<Scalars['Int']>;
  sourceNodeId?: InputMaybe<Scalars['uuid']>;
  sourceType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type CreateContentImageUploadResponse = {
  __typename?: 'CreateContentImageUploadResponse';
  id: Scalars['uuid'];
  key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type CreateContentImageUploadResponseV2 = CreateContentImageUploadConflict | CreateContentImageUploadResponse | CreateContentImageUploadValidationError;

export type CreateContentImageUploadValidationError = {
  __typename?: 'CreateContentImageUploadValidationError';
  message: Scalars['String'];
};

export type CreateDamSyncInput = {
  filters: ImportFiltersInput;
  name: Scalars['String'];
  newTargetAssetGroup?: InputMaybe<NewDamSyncCollectionInput>;
  schedule?: InputMaybe<Scalars['JSON']>;
  schedulePaused?: InputMaybe<Scalars['Boolean']>;
  /**
   * The collection the sync writes into, fixed once the sync exists. Provide
   * exactly one of targetAssetGroupId (a DAM collection) or newTargetAssetGroup.
   */
  targetAssetGroupId?: InputMaybe<Scalars['ID']>;
};

export type CreateDecisionEngineFlowWithModelResult = CreateDecisionEngineFlowWithModelSuccess | DecisionEngineError;

export type CreateDecisionEngineFlowWithModelSuccess = {
  __typename?: 'CreateDecisionEngineFlowWithModelSuccess';
  flowId: Scalars['uuid'];
  modelId: Scalars['uuid'];
};

export type CreateDecisionEngineMessageResult = CreateDecisionEngineMessageSuccess | DecisionEngineError;

export type CreateDecisionEngineMessageSuccess = {
  __typename?: 'CreateDecisionEngineMessageSuccess';
  id: Scalars['uuid'];
};

export type CreateDoubleOptInSubscriptionTopicInput = {
  cepChannelId: Scalars['ID'];
  confirmationMessage?: InputMaybe<CreateDoubleOptInTopicMessageInput>;
  description?: InputMaybe<Scalars['String']>;
  externalIdentifier?: InputMaybe<Scalars['String']>;
  message: CreateDoubleOptInTopicMessageInput;
  name: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
  senderIdentityIds: Array<Scalars['ID']>;
};

export type CreateDoubleOptInSubscriptionTopicResult = {
  __typename?: 'CreateDoubleOptInSubscriptionTopicResult';
  messageId: Scalars['ID'];
  topicId: Scalars['ID'];
};

export type CreateDoubleOptInTopicMessageInput = {
  /**
   * Editor-specific design state (BEE design JSON or HTML editor source),
   * stored verbatim on message_contents.editor_state.
   */
  editorState: Scalars['JSONObject'];
  preheader?: InputMaybe<Scalars['String']>;
  /**
   * `{ column, templateKey }` pairs extracted from the content's Liquid
   * variables, matching message_contents.profile_mappings. Defaults to [].
   */
  profileMappings?: InputMaybe<Array<Scalars['JSONObject']>>;
  /**
   * Rendered output captured from the editor on save, e.g. `{ html }` for
   * email. Stored on message_contents.rendered_output.
   */
  renderedOutput: Scalars['JSONObject'];
  subject?: InputMaybe<Scalars['String']>;
};

export type CreateEmailTemplateInput = {
  /**
   * Source content email whose imported provider settings (e.g. UTM link
   * params) should be applied to the created template.
   */
  contentEmailId?: InputMaybe<Scalars['String']>;
  /**
   * Also create a campaign from the new template (Iterable only). The campaign
   * is created in a ready state for the customer to review and send.
   */
  createCampaign?: InputMaybe<Scalars['Boolean']>;
  /** Explicit GA campaign name; same precedence semantics as linkParams. */
  googleAnalyticsCampaignName?: InputMaybe<Scalars['String']>;
  html: Scalars['String'];
  /**
   * Explicit link params to set on the created template (e.g. user-edited in
   * the export UI). Takes precedence over contentEmailId resolution; an empty
   * list creates the template with no link params.
   */
  linkParams?: InputMaybe<Array<TemplateLinkParamInput>>;
  name: Scalars['String'];
  plaintext?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  shouldInlineCss?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateEmailTemplateResult = {
  __typename?: 'CreateEmailTemplateResult';
  campaignId?: Maybe<Scalars['String']>;
  templateId: Scalars['String'];
};

export type CreateEventComponentInput = {
  description?: InputMaybe<Scalars['String']>;
  event_plan_id: Scalars['String'];
  name: Scalars['String'];
  schema: Scalars['JSONObject'];
  version?: InputMaybe<Scalars['String']>;
};

export type CreateEventForwardingSyncInput = {
  config: Scalars['JSONObject'];
  destination_id: Scalars['String'];
  event_source_ids: Array<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type CreateEventPlanGrant = {
  can_edit: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type CreateEventPlanInput = {
  default_schema_version?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  grants?: InputMaybe<Array<CreateEventPlanGrant>>;
  name: Scalars['String'];
  on_undeclared_schema?: InputMaybe<Scalars['String']>;
  schema_version_path?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateEventSchemaInput = {
  event_name?: InputMaybe<Scalars['String']>;
  event_plan_id?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<EventSchemaEventType>;
  event_version?: InputMaybe<Scalars['String']>;
  include_built_in_context?: InputMaybe<Scalars['Boolean']>;
  on_schema_violation?: InputMaybe<EventSchemaOnSchemaViolation>;
  on_undeclared_fields?: InputMaybe<EventSchemaOnUndeclaredFields>;
  schema?: InputMaybe<Scalars['JSONObject']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateEventSourceGrant = {
  can_access_data: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type CreateEventSourceInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  grants?: InputMaybe<Array<CreateEventSourceGrant>>;
  name: Scalars['String'];
  slug: Scalars['String'];
  tunnel_id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateEventVolumeReportResult = {
  __typename?: 'CreateEventVolumeReportResult';
  ok: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type CreateEventWarehouseDestinationGrant = {
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type CreateEventWarehouseDestinationInput = {
  config: Scalars['JSONObject'];
  credential_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  grants?: InputMaybe<Array<CreateEventWarehouseDestinationGrant>>;
  name: Scalars['String'];
  schema_settings?: InputMaybe<Scalars['JSONObject']>;
  slug: Scalars['String'];
  tunnel_id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateEventWarehouseSyncInput = {
  event_source_ids: Array<Scalars['String']>;
  event_warehouse_destination_id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  schedule: Scalars['JSONObject'];
  schemaOnly?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};

export type CreateExtensionInput = {
  adStudioSyncConfig?: InputMaybe<AdStudioSyncConfigInput>;
  config: Scalars['JSON'];
  name: Scalars['String'];
  setupComplete?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type CreateExtensionResult = {
  __typename?: 'CreateExtensionResult';
  id: Scalars['String'];
};

export type CreateExternalContextSourceInput = {
  config: Scalars['jsonb'];
  integration: Scalars['String'];
  name: Scalars['String'];
  purpose: Scalars['String'];
  syncFrequency?: InputMaybe<Scalars['jsonb']>;
};

export type CreateFigmaPluginApiKeyInput = {
  /**
   * The confirmation code shown on the Figma plugin's screen — the user
   * transcribes it into the connect page to prove they initiated the flow.
   */
  userCode: Scalars['String'];
  writeKey: Scalars['String'];
};

export type CreateFigmaPluginApiKeyResult = {
  __typename?: 'CreateFigmaPluginApiKeyResult';
  id: Scalars['String'];
};

export type CreateFivetranExtensionInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
};

export type CreateFivetranExtensionResult = FivetranExtension | FivetranExtensionError;

export type CreateFunctionGrant = {
  can_edit: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type CreateFunctionInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  grants?: InputMaybe<Array<CreateFunctionGrant>>;
  name: Scalars['String'];
};

export type CreateFunctionResourceInput = {
  function_id: Scalars['String'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
};

export type CreateFunctionResponse = {
  __typename?: 'CreateFunctionResponse';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  version_number: Scalars['Int'];
};

export type CreateFunctionVersionInput = {
  code: Scalars['String'];
  id: Scalars['String'];
};

export type CreateFunctionVersionResponse = {
  __typename?: 'CreateFunctionVersionResponse';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  version_number: Scalars['Int'];
};

export type CreateGoldenRecordBaseColumnsErrorResponse = {
  __typename?: 'CreateGoldenRecordBaseColumnsErrorResponse';
  error: Scalars['String'];
};

export type CreateGoldenRecordBaseColumnsInput = {
  goldenRecordId: Scalars['String'];
  modelColumns: Array<GoldenRecordModelBaseColumns>;
};

export type CreateGoldenRecordBaseColumnsResponse = CreateGoldenRecordBaseColumnsErrorResponse | CreateGoldenRecordBaseColumnsSuccessResponse;

export type CreateGoldenRecordBaseColumnsSuccessResponse = {
  __typename?: 'CreateGoldenRecordBaseColumnsSuccessResponse';
  goldenRecordId: Scalars['String'];
};

export type CreateGoldenRecordColumnErrorResponse = {
  __typename?: 'CreateGoldenRecordColumnErrorResponse';
  error: Scalars['String'];
};

export type CreateGoldenRecordColumnInput = {
  alias?: InputMaybe<Scalars['String']>;
  columnName: Scalars['String'];
  goldenRecordId: Scalars['String'];
  identifier?: InputMaybe<Scalars['String']>;
  survivorshipRuleType: Scalars['String'];
};

export type CreateGoldenRecordColumnResponse = CreateGoldenRecordColumnErrorResponse | CreateGoldenRecordColumnSuccessResponse;

export type CreateGoldenRecordColumnSuccessResponse = {
  __typename?: 'CreateGoldenRecordColumnSuccessResponse';
  id: Scalars['String'];
};

export type CreateGoldenRecordErrorResponse = {
  __typename?: 'CreateGoldenRecordErrorResponse';
  error: Scalars['String'];
};

export type CreateGoldenRecordInput = {
  graphId: Scalars['String'];
};

export type CreateGoldenRecordResponse = CreateGoldenRecordErrorResponse | CreateGoldenRecordSuccessResponse;

export type CreateGoldenRecordSuccessResponse = {
  __typename?: 'CreateGoldenRecordSuccessResponse';
  id: Scalars['String'];
};

export type CreateGoogleServiceAccountResult = CreateGoogleServiceAccountSuccess;

export type CreateGoogleServiceAccountSuccess = {
  __typename?: 'CreateGoogleServiceAccountSuccess';
  serviceAccount: GoogleServiceAccount;
};

export type CreateHouseholdingModelErrorResponse = {
  __typename?: 'CreateHouseholdingModelErrorResponse';
  error: Scalars['String'];
};

export type CreateHouseholdingModelInput = {
  goldenRecordId: Scalars['String'];
};

export type CreateHouseholdingModelResponse = CreateHouseholdingModelErrorResponse | CreateHouseholdingModelSuccessResponse;

export type CreateHouseholdingModelSuccessResponse = {
  __typename?: 'CreateHouseholdingModelSuccessResponse';
  id: Scalars['bigint'];
};

export type CreateIdrGraphErrorResponse = {
  __typename?: 'CreateIDRGraphErrorResponse';
  error: Scalars['String'];
};

export type CreateIdrGraphInput = {
  connectionId: Scalars['String'];
  description: Scalars['String'];
  householding_enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  outputTable: Scalars['String'];
  probabilisticConfig?: InputMaybe<Scalars['JSONObject']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  schedulePaused: Scalars['Boolean'];
  scheduleUpdatedAt: Scalars['String'];
  state: Scalars['String'];
  version: Scalars['Int'];
};

export type CreateIdrGraphResponse = CreateIdrGraphErrorResponse | CreateIdrGraphSuccessResponse;

export type CreateIdrGraphSuccessResponse = {
  __typename?: 'CreateIDRGraphSuccessResponse';
  graphId: Scalars['String'];
};

export type CreateIdrModelBulkInput = {
  graphId: Scalars['String'];
  models: Array<CreateIdrModelInput>;
};

export type CreateIdrModelErrorResponse = {
  __typename?: 'CreateIDRModelErrorResponse';
  error: Scalars['String'];
};

export type CreateIdrModelInput = {
  goldenRecordBaseSurvivorshipRuleType?: InputMaybe<Scalars['String']>;
  mappings: Array<IdrModelMappingInput>;
  orderBy?: InputMaybe<IdrModelOrderByInput>;
  rank: Scalars['Int'];
  scopeColumn?: InputMaybe<Scalars['String']>;
  segmentId: Scalars['String'];
  type: Scalars['String'];
  watermarkLookbackDays?: InputMaybe<Scalars['Int']>;
};

export type CreateIdrModelResponse = CreateIdrModelErrorResponse | CreateIdrModelSuccessResponse;

export type CreateIdrModelSuccessResponse = {
  __typename?: 'CreateIDRModelSuccessResponse';
  idrModelIds: Array<Scalars['String']>;
};

export type CreateIdrSequenceLinksErrorResponse = {
  __typename?: 'CreateIdrSequenceLinksErrorResponse';
  error: Scalars['String'];
};

export type CreateIdrSequenceLinksResponse = CreateIdrSequenceLinksErrorResponse | CreateIdrSequenceLinksSuccessResponse;

export type CreateIdrSequenceLinksSuccessResponse = {
  __typename?: 'CreateIdrSequenceLinksSuccessResponse';
  ids: Array<Scalars['String']>;
};

export type CreateInAppMessageTemplateInput = {
  name: Scalars['String'];
  /** Liquid HTML that previews messages from this version. It may read only the template's field tags. Omitted, null, or blank stores no preview; a new version does not inherit the previous version's. */
  previewHtml?: InputMaybe<Scalars['String']>;
  /** The push apps a message using this version may target. Each must exist in the workspace and be enabled. Omitted or empty allows none; a new version does not inherit the previous version's. */
  pushAppIds?: InputMaybe<Array<Scalars['ID']>>;
  template: Scalars['JSONObject'];
};

export type CreateJourneyFromTemplateInput = {
  audience_id?: InputMaybe<Scalars['String']>;
  journey: JourneyInput;
  parent_model_id: Scalars['String'];
  template_id: Scalars['String'];
};

export type CreateJourneyFromTemplateOutput = {
  __typename?: 'CreateJourneyFromTemplateOutput';
  journey_id: Scalars['String'];
};

export type CreateJourneyTraitInput = {
  anchorNodeId?: InputMaybe<Scalars['String']>;
  column?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Scalars['JSON']>;
  defaultValue?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['JSON']>;
  journeyId: Scalars['String'];
  name: Scalars['String'];
  orderByColumn?: InputMaybe<Scalars['String']>;
  relationshipId?: InputMaybe<Scalars['String']>;
  selectColumn?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateJourneyTraitOutput = {
  __typename?: 'CreateJourneyTraitOutput';
  id: Scalars['String'];
};

export type CreateLinkedEmailFromContentEmailResult = {
  __typename?: 'CreateLinkedEmailFromContentEmailResult';
  contentEmailId: Scalars['uuid'];
  contentEmailVersionId: Scalars['uuid'];
  messageContentsId: Scalars['uuid'];
  sessionId: Scalars['String'];
};

export type CreateLinkedEmailFromTemplateResult = {
  __typename?: 'CreateLinkedEmailFromTemplateResult';
  contentEmailId: Scalars['uuid'];
  contentEmailVersionId: Scalars['uuid'];
  messageContentsId: Scalars['uuid'];
  sessionId: Scalars['String'];
};

export type CreateLinkedMessageDraftResult = {
  __typename?: 'CreateLinkedMessageDraftResult';
  messageContentsId: Scalars['uuid'];
  version: Scalars['Int'];
};

export type CreateLlmInferenceBackendInput = {
  config: Scalars['JSONObject'];
  name: Scalars['String'];
  provider: Scalars['String'];
};

export type CreateModelConfigurationInput = {
  ad_stats?: InputMaybe<AdStatsModelConfigurationInput>;
  asset?: InputMaybe<AssetModelConfigurationInput>;
  catalog?: InputMaybe<CatalogModelConfigurationInput>;
  connection_id: Scalars['bigint'];
  custom_query?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  enable_top_k?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<EventModelConfigurationInput>;
  folder_id?: InputMaybe<Scalars['String']>;
  interaction?: InputMaybe<InteractionModelConfigurationInput>;
  is_general_model?: InputMaybe<Scalars['Boolean']>;
  is_schema?: InputMaybe<Scalars['Boolean']>;
  is_streamable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  primary_key?: InputMaybe<Scalars['String']>;
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['JSONObject']>;
  query_looker_look_id?: InputMaybe<Scalars['String']>;
  query_raw_sql?: InputMaybe<Scalars['String']>;
  query_table_name?: InputMaybe<Scalars['String']>;
  query_type: Scalars['String'];
  realtime_enabled?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  tags?: InputMaybe<Scalars['JSONObject']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
};

export type CreateModelConfigurationResponse = {
  __typename?: 'CreateModelConfigurationResponse';
  columns?: Maybe<Array<DiscoveredModelColumn>>;
  draft_id?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ColumnValidationError>>;
  model_id?: Maybe<Scalars['bigint']>;
};

export type CreateOrUpdateCepManagedModelsInput = {
  /** Channel types to create or update. Each must be one of "email" | "sms" | "push". */
  channelTypes: Array<Scalars['String']>;
};

export type CreateOrUpdateCepManagedModelsResult = {
  __typename?: 'CreateOrUpdateCepManagedModelsResult';
  results: Array<CepManagedModelChangeSummary>;
};

export type CreatePredictorCatalogFeatureDefinitionInput = {
  catalogModelId?: InputMaybe<Scalars['String']>;
  keyEvents: Array<PredictorCatalogEventInput>;
  name: Scalars['String'];
  parentModelId: Scalars['String'];
};

export type CreatePredictorError = {
  __typename?: 'CreatePredictorError';
  error: Scalars['String'];
};

export type CreatePredictorFeatureDefinitionError = {
  __typename?: 'CreatePredictorFeatureDefinitionError';
  error: Scalars['String'];
};

export type CreatePredictorFeatureDefinitionInput = {
  keyEvents: Array<PredictorEventInput>;
  name: Scalars['String'];
  parentModelId: Scalars['String'];
  propertyFeatures: Array<PredictorFeatureDefinitionPropertyInput>;
};

export type CreatePredictorFeatureDefinitionResult = CreatePredictorFeatureDefinitionError | CreatePredictorFeatureDefinitionSuccess;

export type CreatePredictorFeatureDefinitionSuccess = {
  __typename?: 'CreatePredictorFeatureDefinitionSuccess';
  featureDefinitionId: Scalars['uuid'];
  message: Scalars['String'];
};

export type CreatePredictorInput = {
  audienceDefinition: Scalars['JSONObject'];
  baseAudienceId?: InputMaybe<Scalars['String']>;
  catalogDefinition?: InputMaybe<Scalars['JSONObject']>;
  catalogId?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSONObject']>;
  description: Scalars['String'];
  featureDefinitionId?: InputMaybe<Scalars['uuid']>;
  isDemo?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  outcome?: InputMaybe<PredictorOutcomeInput>;
  parentModelId: Scalars['String'];
  suppressionFilter?: InputMaybe<Scalars['JSONObject']>;
};

export type CreatePredictorResult = CreatePredictorError | CreatePredictorSuccess;

export type CreatePredictorSuccess = {
  __typename?: 'CreatePredictorSuccess';
  featureDefinitionId?: Maybe<Scalars['uuid']>;
  message: Scalars['String'];
  outcomeId?: Maybe<Scalars['uuid']>;
  predictorId: Scalars['uuid'];
  traitDefinitionId: Scalars['uuid'];
};

export type CreateProjectCampaignInput = {
  additionalContext?: InputMaybe<Scalars['String']>;
  /**
   * Optional Asana task URL. Rejected when no task GID parses out; stored on the
   * campaign config only once the task was fetched into the brief prompt.
   */
  asanaTaskUrl?: InputMaybe<Scalars['String']>;
  /**
   * Free-form description of who the campaign should target — who they are and
   * where they are in their journey. Optional qualitative context that feeds the
   * brief-generation prompt; it does not drive targeting.
   */
  audienceDescription?: InputMaybe<Scalars['String']>;
  /**
   * Whether the campaign targets a single audience or multiple sub-audiences:
   * "single" or "subsegments" (default). Drives how many audience segments the
   * brief defines and whether message plans target distinct sub-audiences.
   */
  audienceScope?: InputMaybe<Scalars['String']>;
  autoMode?: InputMaybe<Scalars['Boolean']>;
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  /**
   * Free-form plan for how to split candidates across templates — used only when
   * templateStrategy is "other". Distinct from templateGuidance (general
   * template-usage direction); this describes the per-template distribution
   * (e.g. "template 1 for message 1, template 2 for message 2").
   */
  candidateSplitPlan?: InputMaybe<Scalars['String']>;
  /**
   * The per-message candidate count (the "candidates per message" control),
   * clamped to 1..10. How it's applied depends on templateStrategy: with
   * "per_template" it's candidates PER TEMPLATE (total = N × #templates); with
   * "agent_choice"/"other" it's the total per message. Channels without templates
   * use max(N, 3). Omit to use the per-channel defaults.
   */
  candidatesPerMessage?: InputMaybe<Scalars['Int']>;
  channels?: InputMaybe<Array<Scalars['String']>>;
  /**
   * content_emails ids of the reusable email components pre-selected in the
   * intake form. Carried on the agent session context; the message-plan skill
   * resolves them (workspace-scoped, live components only) and stamps the
   * resolved summaries onto each plan so email candidate generation steers the
   * email agent toward them.
   */
  componentIds?: InputMaybe<Array<Scalars['uuid']>>;
  files?: InputMaybe<Array<FileInput>>;
  goal?: InputMaybe<Scalars['String']>;
  /**
   * Client-supplied id used as the campaign primary key for idempotency. A
   * redelivered request carrying the same id is deduped instead of creating a
   * duplicate project. Optional for backwards compatibility.
   */
  id?: InputMaybe<Scalars['uuid']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  /**
   * content_images ids of the library images selected in the intake form's
   * "Additional assets" picker. The resolver loads them from the image library
   * (dropping ids that don't exist in the workspace), stores the surviving ids
   * on the campaign row as an immutable intake snapshot
   * (config.libraryImageIds), and saves the downloaded images as campaign file
   * artifacts alongside the ad-hoc files uploads.
   */
  libraryImageIds?: InputMaybe<Array<Scalars['uuid']>>;
  name: Scalars['String'];
  parentModelId?: InputMaybe<Scalars['bigint']>;
  /**
   * Optional free-text instructions describing how the campaign should use
   * personalization (e.g. "only personalize greetings with first name"). Only
   * meaningful when personalizationMode is "allowed"; empty/absent = the agent
   * chooses personalization itself.
   */
  personalizationGuidance?: InputMaybe<Scalars['String']>;
  /**
   * Whether the project's agents may use personalization variables: "allowed"
   * (default) or "none" (every recipient receives identical content).
   */
  personalizationMode?: InputMaybe<Scalars['String']>;
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  /**
   * ad_artifacts_catalog ids of the products selected in the intake form's
   * "Additional assets" picker. The resolver re-resolves them against the
   * catalog (dropping ids that don't exist in the workspace), stores the
   * surviving ids on the campaign row as an immutable intake snapshot
   * (config.productCatalogIds), and feeds the resolved products to the
   * brief-generation prompt as ground truth.
   */
  productCatalogIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * When set, the campaign is created from this existing chat session: the
   * session is cloned (conversation history + files) into a hidden LCM session,
   * the brief prompt is submitted to the clone, and the brief is grounded in
   * the research already in the conversation. The original chat is untouched.
   */
  sourceSessionId?: InputMaybe<Scalars['uuid']>;
  /**
   * How email candidates should use their selected template(s): "adhere"
   * (reskin — default) or "deviate" (restructure the layout while keeping the
   * template's brand styling). Applied to every email candidate in the project.
   */
  templateBehavior?: InputMaybe<Scalars['String']>;
  /**
   * Optional free-form direction on how to use the selected template(s). Applied
   * in addition to templateBehavior, on every email candidate in the project.
   */
  templateGuidance?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['uuid']>>;
  /**
   * How the selected templates map onto each message's candidates:
   * "per_template" (default — N candidates from each template), "agent_choice"
   * (N total, distributed across the templates), or "other" (N total, following
   * the free-form plan in candidateSplitPlan). Only meaningful for email with
   * templates.
   */
  templateStrategy?: InputMaybe<Scalars['String']>;
};

export type CreateProjectCampaignResponse = {
  __typename?: 'CreateProjectCampaignResponse';
  id: Scalars['uuid'];
  interactionId?: Maybe<Scalars['uuid']>;
};

export type CreatePublicFontFromFileInput = {
  storageKey: Scalars['String'];
};

export type CreatePublicFontFromFileResponse = {
  __typename?: 'CreatePublicFontFromFileResponse';
  publicUrl: Scalars['String'];
};

export type CreatePublicImageFromCatalogProductInput = {
  artifactId: Scalars['uuid'];
  imageFile: Scalars['String'];
};

export type CreatePublicImageFromCatalogProductResponse = {
  __typename?: 'CreatePublicImageFromCatalogProductResponse';
  publicUrl: Scalars['String'];
};

export type CreatePublicImageFromContentImageInput = {
  imageId: Scalars['uuid'];
};

export type CreatePublicImageFromContentImageResponse = {
  __typename?: 'CreatePublicImageFromContentImageResponse';
  publicUrl: Scalars['String'];
};

export type CreatePushAppInput = {
  apps: Array<CreatePushAppVariantInput>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreatePushAppResult = {
  __typename?: 'CreatePushAppResult';
  pushApps: Array<CreatedPushApp>;
};

export type CreatePushAppVariantInput = {
  platform: PushAppPlatform;
};

export type CreatePushCampaignInput = {
  actionButtons?: InputMaybe<Array<PushActionButtonInput>>;
  clickAction?: InputMaybe<Scalars['String']>;
  clickUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  name: Scalars['String'];
  title: Scalars['String'];
};

export type CreatePushEventSyncInput = {
  eventSourceId: Scalars['String'];
  warehouseConnectionId: Scalars['Int'];
};

export type CreatePushEventSyncResult = {
  __typename?: 'CreatePushEventSyncResult';
  created: Scalars['Boolean'];
  eventSourceId: Scalars['String'];
  eventWarehouseDestinationId: Scalars['String'];
  forwardingDestinationId: Scalars['String'];
  forwardingSyncId: Scalars['String'];
  warehouseSyncId: Scalars['String'];
  writeKey: Scalars['String'];
};

export type CreateQueuedEventFragmentInput = {
  numRows: Scalars['Int'];
  objectStorageKey: Scalars['String'];
  sizeBytes: Scalars['Int'];
  syncId: Scalars['String'];
};

export type CreateQueuedEventFragmentsInput = {
  fragments: Array<CreateQueuedEventFragmentInput>;
  replicateFragmentsByNumber?: InputMaybe<Scalars['Int']>;
};

export type CreateQueuedEventFragmentsResult = {
  __typename?: 'CreateQueuedEventFragmentsResult';
  inserted: Scalars['Int'];
  ok: Scalars['Boolean'];
};

export type CreateRealtimeEventModelInput = {
  eventSourceId: Scalars['ID'];
  fields: Array<RealtimeEventFieldInput>;
  kind: RealtimeEventModelKind;
  name: Scalars['String'];
  parentModelId: Scalars['ID'];
};

export type CreateRelationshipInput = {
  cardinality: Scalars['String'];
  from: Scalars['String'];
  fromName?: InputMaybe<Scalars['String']>;
  isHiddenFromAudienceFilter: Scalars['Boolean'];
  isMergingIntoFrom: Scalars['Boolean'];
  isMergingIntoTo: Scalars['Boolean'];
  joinMappings: Array<JoinMappingInput>;
  slug?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
  toName?: InputMaybe<Scalars['String']>;
};

export type CreateReportScheduleContentInput = {
  context: Scalars['JSONObject'];
  deliveryConfig?: InputMaybe<Scalars['JSONObject']>;
  files?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  prompt: Scalars['String'];
  recipient?: InputMaybe<Scalars['JSON']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
};

/**
 * Adds one derived ad of assetId. channelSizeId is required without a template;
 * with one, the template's canvas must be exactly that size, and without one
 * the ad is untagged at the template's canvas.
 */
export type CreateSizeVariantInput = {
  assetId: Scalars['uuid'];
  channelSizeId?: InputMaybe<Scalars['uuid']>;
  template?: InputMaybe<ResizeTemplateInput>;
};

export type CreateSizeVariantResponse = {
  __typename?: 'CreateSizeVariantResponse';
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type CreateSmsCampaignInput = {
  message: Scalars['String'];
  name: Scalars['String'];
};

export type CreateStagedJourneyInput = {
  source_journey_id: Scalars['String'];
};

export type CreateStagedJourneyOutput = {
  __typename?: 'CreateStagedJourneyOutput';
  journey_id: Scalars['String'];
  journey_version_id: Scalars['String'];
};

export type CreateStyleEntityInput = {
  /** Omitted or empty means every agent. */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  /** Omitted or empty means "applies to all brand profiles". */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  /**
   * The style document. Omitted creates an empty document; duplicate-as-draft
   * passes the source style's.
   */
  markdown?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTrackedAudienceListError = {
  __typename?: 'CreateTrackedAudienceListError';
  error: Scalars['String'];
};

export type CreateTrackedAudienceListInput = {
  /**
   * List of audiences to include, when audienceSelectionMode is 'allowlist'.
   * Must be empty when audienceSelectionMode is 'all_for_parent'
   */
  audienceIds: Array<Scalars['ID']>;
  /** Choose whether to select 'all_for_parent' vs. 'allowlist' of audiences for this list. */
  audienceSelectionMode: TrackedAudienceListMode;
  description?: InputMaybe<Scalars['String']>;
  freshnessSeconds?: InputMaybe<Scalars['Int']>;
  includeAudienceName?: InputMaybe<Scalars['Boolean']>;
  includeSplitGroup?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  outputFormat?: InputMaybe<TrackedAudienceListOutputFormat>;
  parentModelId: Scalars['ID'];
};

export type CreateTrackedAudienceListResult = CreateTrackedAudienceListError | CreateTrackedAudienceListSuccess;

export type CreateTrackedAudienceListSuccess = {
  __typename?: 'CreateTrackedAudienceListSuccess';
  traitDefinitionId: Scalars['uuid'];
};

export type CreateTraitDefinitionInput = {
  config: Scalars['jsonb'];
  description?: InputMaybe<Scalars['String']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  predictorId?: InputMaybe<Scalars['uuid']>;
  relationshipId?: InputMaybe<Scalars['bigint']>;
  segmentId: Scalars['bigint'];
  topKEnabled?: InputMaybe<Scalars['Boolean']>;
  topKSyncInterval?: InputMaybe<Scalars['Int']>;
  traitTemplateId?: InputMaybe<Scalars['uuid']>;
  triggerTopKSync?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type CreateUserImageEditNodeInput = {
  html?: InputMaybe<Scalars['String']>;
  renderedPngBase64: Scalars['String'];
  sourceNodeId: Scalars['uuid'];
  /**
   * Exactly one of svg or html must be provided. Nodes saved with html keep
   * html as their canonical markup (svg stays null).
   */
  svg?: InputMaybe<Scalars['String']>;
};

export type CreateUserImageEditNodeResult = {
  __typename?: 'CreateUserImageEditNodeResult';
  nodeId: Scalars['uuid'];
};

/**
 * Deprecated alias of CreateUserImageEditNodeInput. Kept until deployed
 * frontends stop declaring variables with this type name.
 */
export type CreateUserSvgEditNodeInput = {
  html?: InputMaybe<Scalars['String']>;
  renderedPngBase64: Scalars['String'];
  sourceNodeId: Scalars['uuid'];
  svg?: InputMaybe<Scalars['String']>;
};

export type CreateUserSvgEditNodeResult = {
  __typename?: 'CreateUserSvgEditNodeResult';
  nodeId: Scalars['uuid'];
};

export type CreateWorkspaceResult = {
  __typename?: 'CreateWorkspaceResult';
  id: Scalars['Int'];
};

export type CreatedPushApp = {
  __typename?: 'CreatedPushApp';
  id: Scalars['ID'];
  platform: PushAppPlatform;
};

export type CreatedRealtimeEventModel = {
  __typename?: 'CreatedRealtimeEventModel';
  eventModelId: Scalars['ID'];
  relationshipId: Scalars['ID'];
};

export type CreationOptions = {
  destinationId?: InputMaybe<Scalars['String']>;
  eventSourceId?: InputMaybe<Scalars['String']>;
  eventSourceIds?: InputMaybe<Array<Scalars['String']>>;
  modelId?: InputMaybe<Scalars['String']>;
  parentModelId?: InputMaybe<Scalars['String']>;
  /**
   * Replacement for parentModelId on trait creation checks
   * (parent_model_id -> segment_id rename in progress).
   */
  segmentId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  syncIds?: InputMaybe<Array<Scalars['String']>>;
  syncTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ModelType>;
  warehouseDestinationId?: InputMaybe<Scalars['String']>;
};

export type CreativeClassificationRunRef = {
  __typename?: 'CreativeClassificationRunRef';
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type CreativeDimensionValueInput = {
  description?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  admin_type?: Maybe<Scalars['String']>;
  auth0_auth_id?: Maybe<Scalars['String']>;
  avatar_json?: Maybe<Scalars['JSONObject']>;
  can_impersonate: Scalars['Boolean'];
  chameleon_uid?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  current_workspace_id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  impersonation_type?: Maybe<Scalars['String']>;
  is_impersonating: Scalars['Boolean'];
  name: Scalars['String'];
  not_member_of_current_workspace?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  personalization?: Maybe<UserPersonalization>;
  pylon_email_hash?: Maybe<Scalars['String']>;
  space?: Maybe<Space>;
  user_group_ids: Array<Scalars['String']>;
};

export type CustomAgentInput = {
  id?: InputMaybe<Scalars['String']>;
  prompt: Scalars['String'];
  templateName?: InputMaybe<Scalars['String']>;
  type: CustomAgentType;
};

export const CustomAgentType = {
  Template: 'TEMPLATE',
  UserDefined: 'USER_DEFINED'
} as const;

export type CustomAgentType = typeof CustomAgentType[keyof typeof CustomAgentType];
export type CustomDestinationField = {
  __typename?: 'CustomDestinationField';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identifier?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type CustomDestinationListFieldsInput = {
  destinationId: Scalars['String'];
  mode?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
};

export type CustomDestinationListFieldsResult = {
  __typename?: 'CustomDestinationListFieldsResult';
  fields?: Maybe<Array<CustomDestinationField>>;
  freeform?: Maybe<Scalars['Boolean']>;
};

export type CustomDestinationListModesInput = {
  destinationId: Scalars['String'];
  object?: InputMaybe<Scalars['String']>;
};

export type CustomDestinationListModesResult = {
  __typename?: 'CustomDestinationListModesResult';
  modes?: Maybe<Array<CustomDestinationMode>>;
};

export type CustomDestinationListObjectsInput = {
  destinationId: Scalars['String'];
};

export type CustomDestinationListObjectsResult = {
  __typename?: 'CustomDestinationListObjectsResult';
  objects?: Maybe<Array<CustomDestinationObject>>;
};

export type CustomDestinationListOptionsInput = {
  destinationId: Scalars['String'];
  mode?: InputMaybe<Scalars['String']>;
  object?: InputMaybe<Scalars['String']>;
};

export type CustomDestinationListOptionsResult = {
  __typename?: 'CustomDestinationListOptionsResult';
  options?: Maybe<CustomDestinationOptions>;
};

export type CustomDestinationMode = {
  __typename?: 'CustomDestinationMode';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type CustomDestinationObject = {
  __typename?: 'CustomDestinationObject';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type CustomDestinationOptions = {
  __typename?: 'CustomDestinationOptions';
  schema?: Maybe<Scalars['String']>;
  uiSchema?: Maybe<Scalars['String']>;
};

export type CustomDestinationValidateConfigurationInput = {
  destinationId: Scalars['String'];
  jsonInstanceConfiguration: Scalars['String'];
};

export type CustomDestinationValidateConfigurationResult = {
  __typename?: 'CustomDestinationValidateConfigurationResult';
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CustomRuleInput = {
  category: Scalars['String'];
  name: Scalars['String'];
  rule: Scalars['String'];
};

export type CustomRuleOutput = {
  __typename?: 'CustomRuleOutput';
  category: Scalars['String'];
  name: Scalars['String'];
  rule: Scalars['String'];
};

export type DailyDeliverabilityStats = {
  __typename?: 'DailyDeliverabilityStats';
  bouncedRaw: Scalars['Int'];
  bouncedUnique: Scalars['Int'];
  clickedRaw: Scalars['Int'];
  clickedUnique: Scalars['Int'];
  date: Scalars['String'];
  deliveredRaw: Scalars['Int'];
  deliveredUnique: Scalars['Int'];
  /** In-app only: the recipient consumed the message. */
  dismissedRaw: Scalars['Int'];
  dismissedUnique: Scalars['Int'];
  /**
   * The provider accepted the send and did not deliver it: an email drop, or
   * an SMS or WhatsApp message the carrier reported undelivered. Zero on push
   * and in-app, which have no equivalent event.
   */
  droppedRaw: Scalars['Int'];
  droppedUnique: Scalars['Int'];
  /**
   * In-app only: the app put the message on screen. Zero on every other
   * channel, which has no equivalent event.
   */
  impressionsRaw: Scalars['Int'];
  impressionsUnique: Scalars['Int'];
  openedRaw: Scalars['Int'];
  openedUnique: Scalars['Int'];
  sendFailedRaw: Scalars['Int'];
  sendFailedUnique: Scalars['Int'];
  sentRaw: Scalars['Int'];
  sentUnique: Scalars['Int'];
  skippedRaw: Scalars['Int'];
  skippedUnique: Scalars['Int'];
  spamReportedRaw: Scalars['Int'];
  spamReportedUnique: Scalars['Int'];
  subscribedRaw: Scalars['Int'];
  subscribedUnique: Scalars['Int'];
  unsubscribedRaw: Scalars['Int'];
  unsubscribedUnique: Scalars['Int'];
};

export type DailyMessageStats = {
  __typename?: 'DailyMessageStats';
  day: Scalars['String'];
  totalClicks: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalOpens: Scalars['Int'];
  totalSent: Scalars['Int'];
};

export type DashboardOptions = {
  cohortFilter?: InputMaybe<Scalars['JSONObject']>;
  lookbackWindow?: InputMaybe<Scalars['Int']>;
  messageCampaignRunId?: InputMaybe<Scalars['uuid']>;
  timeWindow?: InputMaybe<TimeWindow>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};

export const DashboardSyncMetricGranularity = {
  FourHour: 'four_hour',
  OneDay: 'one_day',
  OneWeek: 'one_week',
  TwoDay: 'two_day'
} as const;

export type DashboardSyncMetricGranularity = typeof DashboardSyncMetricGranularity[keyof typeof DashboardSyncMetricGranularity];
export type DashboardSyncRequestIds = {
  __typename?: 'DashboardSyncRequestIds';
  failed: Array<Scalars['bigint']>;
  succeeded: Array<Scalars['bigint']>;
  warning: Array<Scalars['bigint']>;
};

export type DbtAccount = {
  __typename?: 'DbtAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DbtCredential = {
  __typename?: 'DbtCredential';
  account_url?: Maybe<Scalars['String']>;
  api_key?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DbtEnvironment = {
  __typename?: 'DbtEnvironment';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DbtJob = {
  __typename?: 'DbtJob';
  environment?: Maybe<DbtEnvironment>;
  environment_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  project?: Maybe<DbtProject>;
  project_id?: Maybe<Scalars['String']>;
};

export type DbtProject = {
  __typename?: 'DbtProject';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DebugMetaPageAccessInput = {
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
};

export type DebugMetaPageAccessResponse = {
  __typename?: 'DebugMetaPageAccessResponse';
  haltedReason?: Maybe<Scalars['String']>;
  reads: Array<MetaGraphDebugRead>;
  tokenUser?: Maybe<MetaTokenUser>;
};

export type DebugParams = {
  timestamp?: InputMaybe<Scalars['UnixEpochTimestamp']>;
};

export type DebugSendMatchingInput = {
  flowId: Scalars['uuid'];
  limitPerChannel?: InputMaybe<Scalars['Int']>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
};

export type DebugSendMatchingResult = {
  __typename?: 'DebugSendMatchingResult';
  jobId: Scalars['String'];
  querySql: Scalars['String'];
};

export type DebuggerExportStatus = {
  __typename?: 'DebuggerExportStatus';
  createdAt?: Maybe<Scalars['String']>;
  exists: Scalars['Boolean'];
  isStale?: Maybe<Scalars['Boolean']>;
};

export type DecisionContextColumnInput = {
  castTo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/**
 * A channel a group cap can apply to. These are channel types, not channel ids:
 * a cap covers every channel of that type across the group's agents. Surface is
 * absent on purpose — onsite delivery sends on demand, so a planned cap can't
 * hold it.
 */
export const DecisionEngineArbitrationChannel = {
  Email: 'email',
  Inapp: 'inapp',
  Push: 'push',
  Raw: 'raw',
  Sms: 'sms'
} as const;

export type DecisionEngineArbitrationChannel = typeof DecisionEngineArbitrationChannel[keyof typeof DecisionEngineArbitrationChannel];
export type DecisionEngineArbitrationChannelFrequency = {
  __typename?: 'DecisionEngineArbitrationChannelFrequency';
  channel: DecisionEngineArbitrationChannel;
  inLastDays: Scalars['Int'];
  maxSends: Scalars['Int'];
};

export type DecisionEngineArbitrationChannelFrequencyInput = {
  channel: DecisionEngineArbitrationChannel;
  inLastDays: Scalars['Int'];
  maxSends: Scalars['Int'];
};

export const DecisionEngineArbitrationEnforcementStatus = {
  Disabled: 'disabled',
  Enforcing: 'enforcing',
  Failed: 'failed',
  /** Agents in the current plan enforce; the rest send normally until a plan includes them. */
  Partial: 'partial',
  Pending: 'pending',
  Shadow: 'shadow'
} as const;

export type DecisionEngineArbitrationEnforcementStatus = typeof DecisionEngineArbitrationEnforcementStatus[keyof typeof DecisionEngineArbitrationEnforcementStatus];
/**
 * An arbitration group. primaryKey and connectionId are established by the
 * group's first member and re-established by the next first member.
 */
export type DecisionEngineArbitrationGroup = {
  __typename?: 'DecisionEngineArbitrationGroup';
  /**
   * Which set of arbitration decisions is live. Bumped on every mode flip, so
   * decisions made in shadow are never counted once the group enforces.
   */
  arbitrationEpoch: Scalars['Int'];
  config: DecisionEngineArbitrationGroupConfig;
  connectionId?: Maybe<Scalars['bigint']>;
  epochStartedAt: Scalars['String'];
  id: Scalars['uuid'];
  mode: DecisionEngineArbitrationGroupMode;
  name: Scalars['String'];
  primaryKey?: Maybe<Scalars['String']>;
};

/**
 * Send caps for a group. globalFrequency counts every send across the group's
 * agents; each channelFrequencies entry caps one channel type on top of it.
 */
export type DecisionEngineArbitrationGroupConfig = {
  __typename?: 'DecisionEngineArbitrationGroupConfig';
  channelFrequencies: Array<DecisionEngineArbitrationChannelFrequency>;
  globalFrequency: DecisionEngineUserFrequency;
};

export type DecisionEngineArbitrationGroupConfigInput = {
  /** Required: an update replaces the whole config, so an omitted list drops every channel cap. */
  channelFrequencies: Array<DecisionEngineArbitrationChannelFrequencyInput>;
  globalFrequency: DecisionEngineUserFrequencyInput;
};

export type DecisionEngineArbitrationGroupMembership = {
  __typename?: 'DecisionEngineArbitrationGroupMembership';
  flowId: Scalars['uuid'];
  flowWeight: Scalars['Float'];
  groupId: Scalars['uuid'];
  id: Scalars['uuid'];
};

export const DecisionEngineArbitrationGroupMode = {
  Enforcing: 'enforcing',
  Shadow: 'shadow'
} as const;

export type DecisionEngineArbitrationGroupMode = typeof DecisionEngineArbitrationGroupMode[keyof typeof DecisionEngineArbitrationGroupMode];
export type DecisionEngineArbitrationModeStatus = {
  __typename?: 'DecisionEngineArbitrationModeStatus';
  arbitrationEpoch: Scalars['Int'];
  canEnforce: Scalars['Boolean'];
  mode: DecisionEngineArbitrationGroupMode;
  status: DecisionEngineArbitrationEnforcementStatus;
};

export type DecisionEngineChannelInfo = {
  __typename?: 'DecisionEngineChannelInfo';
  config: Scalars['JSONObject'];
  destination?: Maybe<DecisionEngineDestinationInfo>;
  id: Scalars['uuid'];
  type: Scalars['String'];
};

export type DecisionEngineChannelSchedulingInput = {
  config: Scalars['JSONObject'];
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
};

export type DecisionEngineConfigInput = {
  company_blurb?: InputMaybe<Scalars['String']>;
  history_dimensions?: InputMaybe<Array<Scalars['String']>>;
  ignore_s3_state?: InputMaybe<Scalars['Boolean']>;
  measurement_window_days?: InputMaybe<Scalars['Int']>;
  message_completion_interval_days?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  output_schema?: InputMaybe<Scalars['String']>;
  slack_channel?: InputMaybe<Scalars['String']>;
  touch_cached_interactions_older_than_days?: InputMaybe<Scalars['Int']>;
};

export type DecisionEngineConsentPurgeColumnsInput = {
  primaryKey: Scalars['String'];
  revokedAt: Scalars['String'];
};

export type DecisionEngineConsentPurgeInput = {
  columns: DecisionEngineConsentPurgeColumnsInput;
  /**
   * Omit to leave the stored mode alone, so a save that changes the revocations
   * model of a purging flow does not stop it purging. A config that has never
   * carried a mode becomes plan.
   */
  mode?: InputMaybe<DecisionEngineConsentPurgeMode>;
  /**
   * Stringified segments.id of the revocations model. Must be a model on the
   * engine's source, in the caller's workspace.
   */
  revocationsModelId: Scalars['String'];
};

/**
 * Whether a sanitize run purges the users its revocations model returns, or only
 * reports what it would purge. Execute is irreversible and has no restore path.
 */
export const DecisionEngineConsentPurgeMode = {
  Execute: 'execute',
  Plan: 'plan'
} as const;

export type DecisionEngineConsentPurgeMode = typeof DecisionEngineConsentPurgeMode[keyof typeof DecisionEngineConsentPurgeMode];
export type DecisionEngineDestinationBaseResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationBaseResource';
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationEmailResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationEmailResource';
  from?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  preheader?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationEmailTemplatesResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationEmailTemplatesResource';
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  templates?: Maybe<Array<EmailTemplate>>;
};

export type DecisionEngineDestinationInAppResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationInAppResource';
  body?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationInfo = {
  __typename?: 'DecisionEngineDestinationInfo';
  type: Scalars['String'];
};

export type DecisionEngineDestinationPushResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationPushResource';
  body?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationResource = {
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationResourceError = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationResourceError';
  details?: Maybe<Scalars['JSON']>;
  error: MessagePreviewEspError;
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DecisionEngineDestinationSmsResource = DecisionEngineDestinationResource & {
  __typename?: 'DecisionEngineDestinationSmsResource';
  body?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type DecisionEngineError = {
  __typename?: 'DecisionEngineError';
  error: Scalars['JSONObject'];
};

export type DecisionEngineFeatureMatrixRelationshipInput = {
  /** The relationship's FMRelationshipConfig, as the save is about to store it. */
  config: Scalars['JSONObject'];
  enabled: Scalars['Boolean'];
  /** model_relationships.id, or null for the parent model's own columns. */
  relationshipId?: InputMaybe<Scalars['Int']>;
};

export type DecisionEngineFlowMessageInfo = {
  __typename?: 'DecisionEngineFlowMessageInfo';
  config: Scalars['JSONObject'];
  decision_engine_flow_id: Scalars['uuid'];
};

export type DecisionEngineFlowOverridePeriodCreateInput = {
  endsAt: Scalars['timestamptz'];
  excludeFromTraining?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** Validated against OverridePeriodPatch. */
  patch: Scalars['JSONObject'];
  startsAt: Scalars['timestamptz'];
};

export type DecisionEngineFlowOverridePeriodUpdateInput = {
  /** true schedules a Draft and false unschedules a Scheduled period. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['timestamptz']>;
  excludeFromTraining?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** Validated against OverridePeriodPatch. */
  patch?: InputMaybe<Scalars['JSONObject']>;
  startsAt?: InputMaybe<Scalars['timestamptz']>;
};

export type DecisionEngineFlowRunPlotImageUrl = {
  __typename?: 'DecisionEngineFlowRunPlotImageUrl';
  signed_url: Scalars['String'];
};

export type DecisionEngineFlowRunPlotManifest = {
  __typename?: 'DecisionEngineFlowRunPlotManifest';
  bucket: Scalars['String'];
  data_key?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  experiment?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  normalization?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  plot_name: Scalars['String'];
  plot_path: Scalars['String'];
  plot_type: Scalars['String'];
  signed_url: Scalars['String'];
  split_variant?: Maybe<Scalars['String']>;
  time_frame?: Maybe<Scalars['String']>;
};

export type DecisionEngineFlowSchedulingInput = {
  id: Scalars['uuid'];
  timing: Scalars['JSONObject'];
};

export type DecisionEngineFlowVolumeRampEpisode = {
  __typename?: 'DecisionEngineFlowVolumeRampEpisode';
  createdAt: Scalars['timestamptz'];
  endedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  kind: DecisionEngineFlowVolumeRampKind;
  plan: DecisionEngineFlowVolumeRampPlan;
};

export const DecisionEngineFlowVolumeRampKind = {
  Launch: 'launch',
  Reramp: 'reramp'
} as const;

export type DecisionEngineFlowVolumeRampKind = typeof DecisionEngineFlowVolumeRampKind[keyof typeof DecisionEngineFlowVolumeRampKind];
export type DecisionEngineFlowVolumeRampPlan = {
  __typename?: 'DecisionEngineFlowVolumeRampPlan';
  points: Array<DecisionEngineFlowVolumeRampStage>;
};

/** Checked against the plan rules in VolumeRampPlan: day 0 first, increasing days, non-decreasing percentages, ending at 100% by day 14. */
export type DecisionEngineFlowVolumeRampPlanInput = {
  points: Array<DecisionEngineFlowVolumeRampStageInput>;
};

export type DecisionEngineFlowVolumeRampStage = {
  __typename?: 'DecisionEngineFlowVolumeRampStage';
  day: Scalars['Int'];
  percent: Scalars['Int'];
};

export type DecisionEngineFlowVolumeRampStageInput = {
  day: Scalars['Int'];
  percent: Scalars['Int'];
};

export type DecisionEngineFlowVolumeRampStartInput = {
  mode: DecisionEngineFlowVolumeRampStartMode;
  /** Required for reramp. */
  plan?: InputMaybe<DecisionEngineFlowVolumeRampPlanInput>;
};

export const DecisionEngineFlowVolumeRampStartMode = {
  /** Resume the current episode, or start at the full audience without one. */
  Continue: 'continue',
  /** Start a new episode with the given plan. */
  Reramp: 'reramp'
} as const;

export type DecisionEngineFlowVolumeRampStartMode = typeof DecisionEngineFlowVolumeRampStartMode[keyof typeof DecisionEngineFlowVolumeRampStartMode];
export type DecisionEngineFlowVolumeRampState = {
  __typename?: 'DecisionEngineFlowVolumeRampState';
  /** The start time, pinned at first delivery, of the episode's first successful live run. */
  anchor?: Maybe<Scalars['timestamptz']>;
  /** Calendar days since the anchor, in the agent's scheduling timezone. */
  day?: Maybe<Scalars['Int']>;
  /** The latest episode since the latest full reset. */
  episode?: Maybe<DecisionEngineFlowVolumeRampEpisode>;
  hasStartedLiveRun: Scalars['Boolean'];
  /** The highest share a successful live run admitted since the latest reset. */
  highestPercentSinceReset?: Maybe<Scalars['Int']>;
  /** The start time, pinned at first delivery, of the latest successful live run since the latest reset. */
  latestLiveRunAt?: Maybe<Scalars['timestamptz']>;
  nextStage?: Maybe<DecisionEngineFlowVolumeRampStage>;
  /** Today's share under the episode, in the agent's scheduling timezone. Null without an episode, which admits everyone. */
  percent?: Maybe<Scalars['Int']>;
  /** A cancellation of all upcoming recommendations succeeded after the latest live run. A re-ramp requires one once a live run has started. */
  rolledBackSinceLatestLiveRun: Scalars['Boolean'];
  status?: Maybe<DecisionEngineFlowVolumeRampStatus>;
};

export const DecisionEngineFlowVolumeRampStatus = {
  Completed: 'completed',
  /** Ended early; every later run admits the full audience. */
  Ended: 'ended',
  Ramping: 'ramping',
  /** Before the episode's first successful live run, which runs at the day-0 percentage. */
  Scheduled: 'scheduled'
} as const;

export type DecisionEngineFlowVolumeRampStatus = typeof DecisionEngineFlowVolumeRampStatus[keyof typeof DecisionEngineFlowVolumeRampStatus];
export type DecisionEngineFlowWithModelInput = {
  audience_id: Scalars['String'];
  config: Scalars['JSONObject'];
  decision_engine_id: Scalars['uuid'];
  flow_type?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parent_model_id?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  timing: Scalars['JSONObject'];
};

export type DecisionEngineMessageInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  content?: InputMaybe<Scalars['String']>;
  decision_engine_channel_id: Scalars['uuid'];
  name: Scalars['String'];
  tags?: InputMaybe<Scalars['JSONObject']>;
  variables?: InputMaybe<Scalars['JSON']>;
};

export type DecisionEngineMessageTag = {
  __typename?: 'DecisionEngineMessageTag';
  flowEnabled: Scalars['Boolean'];
  flowId: Scalars['uuid'];
  flowName: Scalars['String'];
  flowStatus: Scalars['String'];
  message: DecisionEngineMessageWithVariables;
};

export type DecisionEngineMessageTagResource = {
  channelId: Scalars['uuid'];
  existingTags?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  resourceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type DecisionEngineMessageWithVariables = {
  __typename?: 'DecisionEngineMessageWithVariables';
  channel?: Maybe<DecisionEngineChannelInfo>;
  config: Scalars['JSONObject'];
  deleted_at?: Maybe<Scalars['String']>;
  flow_message?: Maybe<DecisionEngineFlowMessageInfo>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  tags?: Maybe<Scalars['JSONObject']>;
  variables: Scalars['JSON'];
};

export type DecisionEngineResult = DecisionEngineError | DecisionEngineSuccess;

export type DecisionEngineSuccess = {
  __typename?: 'DecisionEngineSuccess';
  ok: Scalars['Boolean'];
};

/**
 * Customer-tunable sync knobs, persisted into the channel config's
 * syncConfigOverride so they survive AID sync-config regeneration. Each knob
 * applies only if the channel's destination honors it; explicit null deletes
 * the knob's key from the override.
 */
export type DecisionEngineSyncTuningInput = {
  batchSize?: InputMaybe<Scalars['Int']>;
  mode?: InputMaybe<Scalars['String']>;
  parallelization?: InputMaybe<Scalars['Int']>;
  sleepMs?: InputMaybe<Scalars['Int']>;
  useFtp?: InputMaybe<Scalars['Boolean']>;
};

export type DecisionEngineTableNames = {
  __typename?: 'DecisionEngineTableNames';
  flowId: Scalars['uuid'];
  qualifiedAttributionTableName: Scalars['String'];
  qualifiedRecommendationsTableName: Scalars['String'];
  /**
   * Null when the flow has no channels with send events configured, since the
   * sends table is only written during send matching for flows that do.
   */
  qualifiedSendsTableName?: Maybe<Scalars['String']>;
  qualifiedUserExperimentGroupsTableName: Scalars['String'];
};

export type DecisionEngineUserFrequency = {
  __typename?: 'DecisionEngineUserFrequency';
  inLastDays: Scalars['Int'];
  maxSends: Scalars['Int'];
};

export type DecisionEngineUserFrequencyInput = {
  inLastDays: Scalars['Int'];
  maxSends: Scalars['Int'];
};

export type DecisionEngineVariantTagResource = {
  existingTags?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  variableName?: InputMaybe<Scalars['String']>;
  variantValue: Scalars['String'];
};

export type DecisionOutcomeInput = {
  filter?: InputMaybe<Scalars['JSONObject']>;
  segment_id: Scalars['String'];
};

export type DeleteAgentFileInput = {
  storageKey: Scalars['String'];
};

export type DeleteAgentFileResponse = {
  __typename?: 'DeleteAgentFileResponse';
  success: Scalars['Boolean'];
};

export type DeleteAgentMemoryResponse = {
  __typename?: 'DeleteAgentMemoryResponse';
  success: Scalars['Boolean'];
};

export type DeleteAsanaTaskAttachmentInput = {
  attachmentGid: Scalars['ID'];
  campaignId: Scalars['ID'];
};

export type DeleteAssetVersionInput = {
  versionId: Scalars['uuid'];
};

export type DeleteAssetVersionResponse = {
  __typename?: 'DeleteAssetVersionResponse';
  newCurrentVersionId?: Maybe<Scalars['uuid']>;
  success: Scalars['Boolean'];
};

export type DeleteCepBrandLogoInput = {
  id: Scalars['String'];
};

export type DeleteCepBrandLogoResponse = {
  __typename?: 'DeleteCepBrandLogoResponse';
  id: Scalars['String'];
};

export type DeleteCepEventSyncResult = {
  __typename?: 'DeleteCepEventSyncResult';
  deleted: Scalars['Boolean'];
  deletedEventSourceId?: Maybe<Scalars['String']>;
  deletedEventWarehouseDestinationId?: Maybe<Scalars['String']>;
  deletedForwardingDestinationId?: Maybe<Scalars['String']>;
  deletedForwardingSyncId?: Maybe<Scalars['String']>;
  deletedWarehouseSyncId?: Maybe<Scalars['String']>;
};

export type DeleteContentSettingsFontFileInput = {
  storageKey: Scalars['String'];
};

export type DeleteContentSettingsFontFileOutput = {
  __typename?: 'DeleteContentSettingsFontFileOutput';
  success: Scalars['Boolean'];
};

export type DeleteDbtCloudCredentialResult = {
  __typename?: 'DeleteDbtCloudCredentialResult';
  id: Scalars['Int'];
};

export type DeleteEventComponentResult = {
  __typename?: 'DeleteEventComponentResult';
  errors: Array<EventSchemaError>;
  impact?: Maybe<ComponentImpact>;
  ok: Scalars['Boolean'];
};

export type DeleteEventSchemasInput = {
  event_name?: InputMaybe<Scalars['String']>;
  event_plan_id: Scalars['String'];
  event_type: Scalars['String'];
  event_version?: InputMaybe<Scalars['String']>;
};

export type DeleteExtensionResult = {
  __typename?: 'DeleteExtensionResult';
  success: Scalars['Boolean'];
};

export type DeleteFivetranAgentSyncResponse = {
  __typename?: 'DeleteFivetranAgentSyncResponse';
  id: Scalars['String'];
};

export type DeleteFivetranExtensionResult = {
  __typename?: 'DeleteFivetranExtensionResult';
  id?: Maybe<Scalars['String']>;
};

export type DeleteFontFileInput = {
  storageKey: Scalars['String'];
};

export type DeleteFontFileResponse = {
  __typename?: 'DeleteFontFileResponse';
  success: Scalars['Boolean'];
};

export type DeleteFunctionResourceResponse = {
  __typename?: 'DeleteFunctionResourceResponse';
  id: Scalars['String'];
};

export type DeleteFunctionResponse = {
  __typename?: 'DeleteFunctionResponse';
  affected_rows: Scalars['Int'];
};

export type DeleteGoldenRecordBaseColumnErrorResponse = {
  __typename?: 'DeleteGoldenRecordBaseColumnErrorResponse';
  error: Scalars['String'];
};

export type DeleteGoldenRecordBaseColumnInput = {
  columnName: Scalars['String'];
  goldenRecordId: Scalars['String'];
  idrModelId: Scalars['String'];
  segmentId: Scalars['bigint'];
};

export type DeleteGoldenRecordBaseColumnResponse = DeleteGoldenRecordBaseColumnErrorResponse | DeleteGoldenRecordBaseColumnSuccessResponse;

export type DeleteGoldenRecordBaseColumnSuccessResponse = {
  __typename?: 'DeleteGoldenRecordBaseColumnSuccessResponse';
  goldenRecordId: Scalars['String'];
};

export type DeleteGoldenRecordColumnErrorResponse = {
  __typename?: 'DeleteGoldenRecordColumnErrorResponse';
  error: Scalars['String'];
};

export type DeleteGoldenRecordColumnInput = {
  id: Scalars['String'];
};

export type DeleteGoldenRecordColumnResponse = DeleteGoldenRecordColumnErrorResponse | DeleteGoldenRecordColumnSuccessResponse;

export type DeleteGoldenRecordColumnSuccessResponse = {
  __typename?: 'DeleteGoldenRecordColumnSuccessResponse';
  id: Scalars['String'];
};

export type DeleteIdrGraphErrorResponse = {
  __typename?: 'DeleteIDRGraphErrorResponse';
  error: Scalars['String'];
};

export type DeleteIdrGraphInput = {
  graphIds: Array<Scalars['String']>;
};

export type DeleteIdrGraphResponse = DeleteIdrGraphErrorResponse | DeleteIdrGraphSuccessResponse;

export type DeleteIdrGraphSuccessResponse = {
  __typename?: 'DeleteIDRGraphSuccessResponse';
  graphIds: Array<Scalars['String']>;
};

export type DeleteIdrModelErrorResponse = {
  __typename?: 'DeleteIDRModelErrorResponse';
  error: Scalars['String'];
};

export type DeleteIdrModelInput = {
  idrModelId: Scalars['String'];
};

export type DeleteIdrModelResponse = DeleteIdrModelErrorResponse | DeleteIdrModelSuccessResponse;

export type DeleteIdrModelSuccessResponse = {
  __typename?: 'DeleteIDRModelSuccessResponse';
  idrModelId: Scalars['String'];
};

export type DeleteIdrSequenceLinksErrorResponse = {
  __typename?: 'DeleteIdrSequenceLinksErrorResponse';
  error: Scalars['String'];
};

export type DeleteIdrSequenceLinksResponse = DeleteIdrSequenceLinksErrorResponse | DeleteIdrSequenceLinksSuccessResponse;

export type DeleteIdrSequenceLinksSuccessResponse = {
  __typename?: 'DeleteIdrSequenceLinksSuccessResponse';
  success: Scalars['Boolean'];
};

export type DeleteInAppMessageInput = {
  messageId: Scalars['String'];
  parentModelPk: Scalars['String'];
};

export type DeleteInAppMessageResult = {
  __typename?: 'DeleteInAppMessageResult';
  deleted: Scalars['Boolean'];
};

export type DeleteJourneyInput = {
  id: Scalars['String'];
};

export type DeleteJourneyOutput = {
  __typename?: 'DeleteJourneyOutput';
  id: Scalars['String'];
};

export type DeleteJourneyTemplateInput = {
  id: Scalars['String'];
};

export type DeleteJourneyTemplateOutput = {
  __typename?: 'DeleteJourneyTemplateOutput';
  id: Scalars['String'];
};

export type DeleteJourneyTraitInput = {
  id: Scalars['String'];
};

export type DeleteJourneyTraitOutput = {
  __typename?: 'DeleteJourneyTraitOutput';
  id: Scalars['String'];
};

export type DeleteLlmChatSessionResponse = {
  __typename?: 'DeleteLLMChatSessionResponse';
  success: Scalars['Boolean'];
};

export type DeleteLogoFileInput = {
  storageKey: Scalars['String'];
};

export type DeleteLogoFileResponse = {
  __typename?: 'DeleteLogoFileResponse';
  success: Scalars['Boolean'];
};

export type DeleteMessageAbTestInput = {
  messageExperimentId: Scalars['uuid'];
};

export type DeleteMessageAbTestResult = {
  __typename?: 'DeleteMessageAbTestResult';
  experimentId: Scalars['uuid'];
};

export type DeleteMetaAdInput = {
  launchId: Scalars['uuid'];
};

export type DeleteMetaAdResponse = {
  __typename?: 'DeleteMetaAdResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteModelColumnsV2Response = {
  __typename?: 'DeleteModelColumnsV2Response';
  affected_rows: Scalars['Int'];
};

export type DeleteModelOutput = {
  __typename?: 'DeleteModelOutput';
  id: Scalars['int8'];
};

export type DeletePredictorError = {
  __typename?: 'DeletePredictorError';
  error: Scalars['String'];
};

export type DeletePredictorFeatureDefinitionError = {
  __typename?: 'DeletePredictorFeatureDefinitionError';
  error: Scalars['String'];
};

export type DeletePredictorFeatureDefinitionInput = {
  featureDefinitionId: Scalars['uuid'];
};

export type DeletePredictorFeatureDefinitionResult = DeletePredictorFeatureDefinitionError | DeletePredictorFeatureDefinitionSuccess;

export type DeletePredictorFeatureDefinitionSuccess = {
  __typename?: 'DeletePredictorFeatureDefinitionSuccess';
  featureDefinitionId: Scalars['uuid'];
  message: Scalars['String'];
};

export type DeletePredictorInput = {
  predictorId: Scalars['uuid'];
};

export type DeletePredictorResult = DeletePredictorError | DeletePredictorSuccess;

export type DeletePredictorSuccess = {
  __typename?: 'DeletePredictorSuccess';
  message: Scalars['String'];
  predictorId: Scalars['uuid'];
};

export type DeletePushEventSyncInput = {
  eventSourceId: Scalars['String'];
};

export type DeletePushEventSyncResult = {
  __typename?: 'DeletePushEventSyncResult';
  deleted: Scalars['Boolean'];
  deletedEventWarehouseDestinationId?: Maybe<Scalars['String']>;
  deletedForwardingDestinationId?: Maybe<Scalars['String']>;
  deletedForwardingSyncId?: Maybe<Scalars['String']>;
  deletedWarehouseSyncId?: Maybe<Scalars['String']>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  id: Scalars['String'];
};

/**
 * Names the derived ad to delete: its own id, or its source ad's id with a
 * channelSizeId, which names the only live derived ad at that size and is
 * rejected when the size holds several. A channelSizeId sent with a derived
 * ad's id is ignored. A source ad alone is rejected.
 */
export type DeleteSizeVariantInput = {
  assetId: Scalars['uuid'];
  channelSizeId?: InputMaybe<Scalars['uuid']>;
};

export type DeleteSizeVariantResponse = {
  __typename?: 'DeleteSizeVariantResponse';
  success: Scalars['Boolean'];
};

export type DeleteSyncIdrScheduleErrorResponse = {
  __typename?: 'DeleteSyncIdrScheduleErrorResponse';
  error: Scalars['String'];
};

export type DeleteSyncIdrScheduleResponse = DeleteSyncIdrScheduleErrorResponse | DeleteSyncIdrScheduleSuccessResponse;

export type DeleteSyncIdrScheduleSuccessResponse = {
  __typename?: 'DeleteSyncIdrScheduleSuccessResponse';
  success: Scalars['Boolean'];
};

export type DeleteSyncOutput = {
  __typename?: 'DeleteSyncOutput';
  id: Scalars['bigint'];
};

export type DeletedRealtimeEventColumnOutput = {
  __typename?: 'DeletedRealtimeEventColumnOutput';
  audience_count: Scalars['String'];
  name: Scalars['String'];
};

export const DeliverabilityBounceClass = {
  Hard: 'hard',
  Soft: 'soft'
} as const;

export type DeliverabilityBounceClass = typeof DeliverabilityBounceClass[keyof typeof DeliverabilityBounceClass];
export const DeliverabilityBounceDimension = {
  Domain: 'domain',
  Reason: 'reason'
} as const;

export type DeliverabilityBounceDimension = typeof DeliverabilityBounceDimension[keyof typeof DeliverabilityBounceDimension];
export type DeliverabilityBounceDimensionBreakdown = {
  __typename?: 'DeliverabilityBounceDimensionBreakdown';
  buckets: Array<BounceBreakdownBucket>;
  total: Scalars['Int'];
};

export type DeliverabilityByCampaign = {
  __typename?: 'DeliverabilityByCampaign';
  campaigns: Array<CampaignDeliverabilityStats>;
  /** When the nightly run behind these rows computed them, as an ISO timestamp. Null when they were read live. */
  computedAt?: Maybe<Scalars['String']>;
  /** Rows matching the window before the limit is applied. Depends on orderBy: every ordering except "sent" drops never-sent rows first, so re-sorting can change this count. */
  total: Scalars['Int'];
};

export type DeliverabilityByLocale = {
  __typename?: 'DeliverabilityByLocale';
  locales: Array<LocaleDeliverabilityStats>;
};

export type DeliverabilityByMessage = {
  __typename?: 'DeliverabilityByMessage';
  messages: Array<MessageDeliverabilityStats>;
  /** Rows matching the window before the limit is applied. Depends on orderBy: every ordering except "sent" drops never-sent rows first, so re-sorting can change this count. */
  total: Scalars['Int'];
};

export type DeliverabilityByOsOverTime = {
  __typename?: 'DeliverabilityByOsOverTime';
  osBreakdowns: Array<OsTimeSeries>;
};

export type DeliverabilityByProviderOverTime = {
  __typename?: 'DeliverabilityByProviderOverTime';
  providers: Array<ProviderTimeSeries>;
};

export type DeliverabilityFeedDomainAccess = {
  __typename?: 'DeliverabilityFeedDomainAccess';
  domain: Scalars['String'];
  status: DeliverabilityFeedDomainAccessStatus;
};

export const DeliverabilityFeedDomainAccessStatus = {
  NotShared: 'not_shared',
  Readable: 'readable',
  Unknown: 'unknown'
} as const;

export type DeliverabilityFeedDomainAccessStatus = typeof DeliverabilityFeedDomainAccessStatus[keyof typeof DeliverabilityFeedDomainAccessStatus];
export type DeliverabilityMetricEntry = {
  __typename?: 'DeliverabilityMetricEntry';
  metric: Scalars['String'];
  result: DeliverabilityMetricResult;
};

export type DeliverabilityMetricResult = {
  __typename?: 'DeliverabilityMetricResult';
  previousRaw: Scalars['Int'];
  previousSentRaw: Scalars['Int'];
  previousSentUnique: Scalars['Int'];
  previousUnique: Scalars['Int'];
  raw: Scalars['Int'];
  sentRaw: Scalars['Int'];
  sentUnique: Scalars['Int'];
  timeSeries?: Maybe<Array<DeliverabilityTimeSeriesPoint>>;
  unique: Scalars['Int'];
};

/** Metric a reporting table can rank by. Rates divide by "sent", so a never-sent row has rate 0. */
export const DeliverabilityMetricSortField = {
  ClickRate: 'clickRate',
  Clicked: 'clicked',
  OpenRate: 'openRate',
  Sent: 'sent'
} as const;

export type DeliverabilityMetricSortField = typeof DeliverabilityMetricSortField[keyof typeof DeliverabilityMetricSortField];
export type DeliverabilityOverTime = {
  __typename?: 'DeliverabilityOverTime';
  daily: Array<DailyDeliverabilityStats>;
};

export type DeliverabilitySkipsByReason = {
  __typename?: 'DeliverabilitySkipsByReason';
  buckets: Array<SkipReasonBucket>;
  total: Scalars['Int'];
};

export const DeliverabilitySortDirection = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type DeliverabilitySortDirection = typeof DeliverabilitySortDirection[keyof typeof DeliverabilitySortDirection];
export type DeliverabilityTimeSeriesPoint = {
  __typename?: 'DeliverabilityTimeSeriesPoint';
  date: Scalars['String'];
  raw: Scalars['Int'];
  unique: Scalars['Int'];
};

export type DemoInsightsRun = {
  __typename?: 'DemoInsightsRun';
  brandName: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['String']>;
  schemaName: Scalars['String'];
  startedAt?: Maybe<Scalars['String']>;
  /** syncing | active | broken — mirrors fivetran_agent_syncs.status */
  status: Scalars['String'];
};

export type DemoMockMessageStatisticsInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  clearExisting?: InputMaybe<Scalars['Boolean']>;
  clickRate?: InputMaybe<Scalars['Float']>;
  dailySentMax: Scalars['Int'];
  dailySentMin: Scalars['Int'];
  deliveryRate?: InputMaybe<Scalars['Float']>;
  endDate: Scalars['String'];
  messageIds: Array<Scalars['String']>;
  openRate?: InputMaybe<Scalars['Float']>;
  spamRate?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['String'];
};

export type DemoMockMessageStatisticsResult = {
  __typename?: 'DemoMockMessageStatisticsResult';
  rowsInserted: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type DeployContentArtifactDynamicContentInput = {
  /** SFMC Push: MobilePush application id. */
  applicationId?: InputMaybe<Scalars['String']>;
  applicationName?: InputMaybe<Scalars['String']>;
  artifactId: Scalars['uuid'];
  deliveryType: MessageDeliveryType;
  destinationId: Scalars['String'];
  forceReplaceDeployment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Audience id whose members receive the triggered send. Required for
   * trigger_sync; omitted for esp_orchestrated.
   */
  modelId?: InputMaybe<Scalars['String']>;
  /** SFMC: model column carrying the subscriber / contact key. */
  recipientColumn?: InputMaybe<Scalars['String']>;
};

export type DeployContentArtifactDynamicContentResponse = {
  __typename?: 'DeployContentArtifactDynamicContentResponse';
  campaignId?: Maybe<Scalars['String']>;
  deploymentId: Scalars['uuid'];
  requiredFields: Array<Scalars['String']>;
  syncId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};

export type DeployContentEmailDynamicContentInput = {
  /**
   * AI Decisioning: disambiguates when the flow's engine has multiple email
   * channels for this destination.
   */
  aidChannelId?: InputMaybe<Scalars['ID']>;
  /** AI Decisioning: the decision-engine flow to register the message on. */
  aidFlowId?: InputMaybe<Scalars['ID']>;
  /**
   * API-triggered campaign to wire into the paused sync. For Braze, the
   * campaign the user created from the deployed template (step 2).
   */
  campaignId?: InputMaybe<Scalars['ID']>;
  /**
   * Iterable ESP-orchestrated only: also create a Ready campaign from the newly
   * created template. Ignored on a redeploy, which updates the existing
   * template rather than creating one.
   */
  createCampaign?: InputMaybe<Scalars['Boolean']>;
  /** How the deployment delivers sends / which compile dialect to emit. */
  deliveryType: ContentDeploymentDeliveryType;
  destinationId: Scalars['ID'];
  /**
   * Braze dispatcher model: the workspace's dispatcher content block, which
   * the shared sender campaign's body references. Opts the deployment into
   * the dispatcher model (requires campaignId); omit it for the default
   * template model.
   */
  dispatcherContentBlockId?: InputMaybe<Scalars['ID']>;
  emailId: Scalars['uuid'];
  /**
   * Iterable: create a replacement Ready campaign while preserving the
   * deployed template and managed sync. Braze: clear the selected campaign
   * so the user can recreate it from the updated template and reselect.
   */
  forceRecreateCampaign?: InputMaybe<Scalars['Boolean']>;
  /**
   * Replace an existing deployment when switching delivery type for the same
   * email + destination. Clears prior target_refs and sync binding.
   */
  forceReplaceDeployment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Iterable ESP-orchestrated only: Google Analytics campaign name
   * (utm_campaign). Same precedence semantics as linkParams.
   */
  googleAnalyticsCampaignName?: InputMaybe<Scalars['String']>;
  /**
   * Iterable ESP-orchestrated only: UTM/link parameters appended to every link
   * in the deployed template. Omit to inherit the source email's captured
   * params; an empty list deploys the template with none.
   */
  linkParams?: InputMaybe<Array<TemplateLinkParamInput>>;
  /**
   * Iterable trigger syncs only: message type applied to the template and
   * inherited by the campaign. Frequency behavior remains configured in
   * Iterable.
   */
  messageTypeId?: InputMaybe<Scalars['ID']>;
  /** The audience whose members receive the send (trigger_sync only). */
  modelId?: InputMaybe<Scalars['ID']>;
  /** The user reviewed export preflight findings and chose to proceed. */
  overrideTemplateErrors?: InputMaybe<Scalars['Boolean']>;
  preheader?: InputMaybe<Scalars['String']>;
  /**
   * Model column carrying the recipient identity, for targets that need an
   * explicit one (Braze external_user_id / SFMC subscriberKey).
   */
  recipientColumn?: InputMaybe<Scalars['String']>;
  /**
   * SFMC send classification ObjectID — required to create a Triggered Send
   * Definition on first deploy.
   */
  sendClassificationId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  /**
   * The provider template to update. When omitted, the prior deployment's
   * template is updated or a new template is created.
   */
  templateId?: InputMaybe<Scalars['ID']>;
  /** Provider template metadata supplied by the export modal. */
  templateName?: InputMaybe<Scalars['String']>;
  /** Version to deploy; defaults to the email's current version. */
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type DeployContentEmailDynamicContentResponse = {
  __typename?: 'DeployContentEmailDynamicContentResponse';
  /** AI Decisioning only: the registered decision-engine message. */
  aidMessageId?: Maybe<Scalars['String']>;
  /**
   * Iterable campaign id, Braze API-triggered campaign id (after attach), or
   * SFMC Triggered Send Definition CustomerKey.
   */
  campaignId?: Maybe<Scalars['String']>;
  contentBlockId?: Maybe<Scalars['String']>;
  contentBlockLiquidTag?: Maybe<Scalars['String']>;
  deploymentId: Scalars['uuid'];
  requiredFields: Array<Scalars['String']>;
  /** Null for AI Decisioning and ESP-orchestrated deploys — no HT sync. */
  syncId?: Maybe<Scalars['ID']>;
  /** Iterable / Braze / SFMC Content Builder Email template id. */
  templateId?: Maybe<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};

export const DeploymentFailureReasons = {
  DependencyAuthorization: 'DependencyAuthorization',
  Draft: 'Draft',
  ExtensionSetup: 'ExtensionSetup',
  InvalidOrganization: 'InvalidOrganization',
  ResourceNotFound: 'ResourceNotFound',
  ResourceTypeMismatch: 'ResourceTypeMismatch',
  SegmentDeploymentNeeded: 'SegmentDeploymentNeeded',
  Unauthorized: 'Unauthorized',
  Unknown: 'Unknown',
  UnlinkedDependency: 'UnlinkedDependency'
} as const;

export type DeploymentFailureReasons = typeof DeploymentFailureReasons[keyof typeof DeploymentFailureReasons];
export const DeploymentOperation = {
  Create: 'create',
  Update: 'update'
} as const;

export type DeploymentOperation = typeof DeploymentOperation[keyof typeof DeploymentOperation];
export const DeploymentResourceType = {
  Connections: 'connections',
  Destinations: 'destinations'
} as const;

export type DeploymentResourceType = typeof DeploymentResourceType[keyof typeof DeploymentResourceType];
export type DeploymentTestHistory = {
  __typename?: 'DeploymentTestHistory';
  created_at: Scalars['String'];
  created_by: Scalars['bigint'];
  target_workspace: ResourceLinkWorkspace;
};

export type DeploymentTestResult = FailedDeploymentTestResult | SuccessfulDeploymentTestResult;

export type DeploymentValidationResult = FailedDeploymentValidationResult | SuccessfulDeploymentValidationResult;

export const DerivedCampaignStatus = {
  Activated: 'activated',
  Archived: 'archived',
  Completed: 'completed',
  Draft: 'draft',
  Error: 'error',
  Paused: 'paused',
  Running: 'running',
  Scheduled: 'scheduled'
} as const;

export type DerivedCampaignStatus = typeof DerivedCampaignStatus[keyof typeof DerivedCampaignStatus];
export type DestinationCategory = {
  __typename?: 'DestinationCategory';
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DestinationDefinition = {
  __typename?: 'DestinationDefinition';
  approvalRequirement?: Maybe<Scalars['String']>;
  categories: Array<Maybe<DestinationCategory>>;
  configVersion?: Maybe<Scalars['Int']>;
  docs: Scalars['String'];
  eventForwarding: Scalars['Boolean'];
  features: Array<Maybe<Scalars['String']>>;
  icon: Scalars['String'];
  longPitch: Scalars['String'];
  name: Scalars['String'];
  oauthUrl?: Maybe<Scalars['String']>;
  releasedAt?: Maybe<Scalars['String']>;
  requiresInternalApproval?: Maybe<Scalars['Boolean']>;
  shortPitch: Scalars['String'];
  status: Scalars['String'];
  supportedSourceTypes?: Maybe<Array<Scalars['String']>>;
  supportsRealtimeAudienceSyncs: Scalars['Boolean'];
  testConnection: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  writesResults: Scalars['Boolean'];
};

export type DestinationDefinitionInput = {
  slug: Scalars['String'];
};

export type DestinationGrant = {
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type DestinationInput = {
  destinationTypes: Array<Scalars['String']>;
};

export type DestinationMethod = {
  __typename?: 'DestinationMethod';
  authIcon?: Maybe<Scalars['String']>;
  authLabel?: Maybe<Scalars['String']>;
  badge?: Maybe<Scalars['JSON']>;
  form?: Maybe<Scalars['JSON']>;
  fullAuthLabel?: Maybe<Scalars['String']>;
  isDeprecated?: Maybe<Scalars['Boolean']>;
  isPreOAuthForm?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  method: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  tunneling?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type DestinationPermission = {
  __typename?: 'DestinationPermission';
  permission: Scalars['String'];
  purpose: Scalars['String'];
};

export type DestinationPermissionResult = {
  __typename?: 'DestinationPermissionResult';
  connectorIds: Array<Scalars['ID']>;
  destinationId?: Maybe<Scalars['ID']>;
  destinationName?: Maybe<Scalars['String']>;
  missing: Array<DestinationPermission>;
  provider: Scalars['String'];
  /** Set when the row's probes could not run: no_destination_linked, destination_not_supported, configuration_unavailable or provider_check_failed. */
  reason?: Maybe<Scalars['String']>;
  status: DestinationPermissionStatus;
  unverified: Array<DestinationPermission>;
};

export const DestinationPermissionScope = {
  /** Every destination of a supported ESP type, whether or not a connector uses it. */
  AllDestinations: 'all_destinations',
  /** Destinations that a calendar connector reads through, plus connectors with no destination linked. */
  LinkedConnectors: 'linked_connectors'
} as const;

export type DestinationPermissionScope = typeof DestinationPermissionScope[keyof typeof DestinationPermissionScope];
export const DestinationPermissionStatus = {
  Missing: 'missing',
  Ready: 'ready',
  Unverified: 'unverified'
} as const;

export type DestinationPermissionStatus = typeof DestinationPermissionStatus[keyof typeof DestinationPermissionStatus];
export type DestinationResult = {
  __typename?: 'DestinationResult';
  id: Scalars['bigint'];
};

export type DestinationTypesResult = {
  __typename?: 'DestinationTypesResult';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type DestinationsMutationInput = {
  analytics_ingestion_connection_id?: InputMaybe<Scalars['bigint']>;
  analytics_ingestion_schedule?: InputMaybe<Scalars['JSONObject']>;
  config?: InputMaybe<Scalars['JSONObject']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  setup_complete?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

export type DetectRelationshipCardinalityOutput = {
  __typename?: 'DetectRelationshipCardinalityOutput';
  detectedCardinality?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
};

export type DetectSubsetScopedConditionCyclesResult = {
  __typename?: 'DetectSubsetScopedConditionCyclesResult';
  cycleDescription?: Maybe<Scalars['String']>;
  hasCycle: Scalars['Boolean'];
};

export type Device = {
  __typename?: 'Device';
  lastActive: Scalars['String'];
  name: Scalars['String'];
};

export type DiffRealtimeEventColumnInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DiffRealtimeEventColumnsOutput = {
  __typename?: 'DiffRealtimeEventColumnsOutput';
  changed: Array<ChangedRealtimeEventColumnOutput>;
  deleted: Array<DeletedRealtimeEventColumnOutput>;
};

export type DiscardFigmaImportDraftResult = {
  __typename?: 'DiscardFigmaImportDraftResult';
  success: Scalars['Boolean'];
};

export type DiscardMessageDraftResult = {
  __typename?: 'DiscardMessageDraftResult';
  affectedRows: Scalars['Int'];
};

export type DiscardReportDraftInput = {
  draftVersionId: Scalars['uuid'];
  reportScheduleId: Scalars['uuid'];
};

export type DisclaimerSpecInput = {
  machineReadable: Scalars['Boolean'];
  position: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type DiscoverBackgroundFailure = {
  __typename?: 'DiscoverBackgroundFailure';
  error: Scalars['String'];
  type: Scalars['String'];
};

export type DiscoverBackgroundProcessing = {
  __typename?: 'DiscoverBackgroundProcessing';
  type: Scalars['String'];
};

export type DiscoverBackgroundResult = DiscoverBackgroundFailure | DiscoverBackgroundProcessing | DiscoverBackgroundSuccess;

export type DiscoverBackgroundSuccess = {
  __typename?: 'DiscoverBackgroundSuccess';
  executionTime: Scalars['Int'];
  type: Scalars['String'];
};

export type DiscoverFigmaDesignsInput = {
  connectionId?: InputMaybe<Scalars['uuid']>;
  figmaUrl: Scalars['String'];
};

export type DiscoveredModelColumn = {
  __typename?: 'DiscoveredModelColumn';
  name: Scalars['String'];
  raw_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DocumentLink = {
  __typename?: 'DocumentLink';
  label?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type DraftModelConfigurationResponse = {
  __typename?: 'DraftModelConfigurationResponse';
  columns?: Maybe<Array<DiscoveredModelColumn>>;
  draft_id?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<ColumnValidationError>>;
};

export const DraftOperation = {
  Create: 'CREATE',
  Update: 'UPDATE'
} as const;

export type DraftOperation = typeof DraftOperation[keyof typeof DraftOperation];
export const DraftStatus = {
  Approved: 'approved',
  Rejected: 'rejected'
} as const;

export type DraftStatus = typeof DraftStatus[keyof typeof DraftStatus];
export type DryRunInput = {
  allowMultishot?: InputMaybe<Scalars['Boolean']>;
  attributionTypeOverride?: InputMaybe<AttributionType>;
  banditConfiguration?: InputMaybe<Scalars['JSONObject']>;
  collectionModelConfiguration?: InputMaybe<Array<InputMaybe<CollectionConfigOverrideInput>>>;
  enableCacheSeed?: InputMaybe<Scalars['Boolean']>;
  featureMatrixIdOverride?: InputMaybe<Scalars['uuid']>;
  flowId: Scalars['uuid'];
  forceAllUsers?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  includeAggregations?: InputMaybe<Scalars['Boolean']>;
  includeBreakdowns?: InputMaybe<Scalars['Boolean']>;
  intelligentTargetingOverride?: InputMaybe<Scalars['JSONObject']>;
  keepPulledUserChunks?: InputMaybe<Scalars['Boolean']>;
  messageCompletionIntervalDays?: InputMaybe<Scalars['Int']>;
  modelMapping?: InputMaybe<Scalars['JSONObject']>;
  modelOverrides?: InputMaybe<Scalars['JSONObject']>;
  overrideAudienceId?: InputMaybe<Scalars['String']>;
  reuseStartAt?: InputMaybe<Scalars['Boolean']>;
  splitOverride?: InputMaybe<Scalars['JSONObject']>;
  stackOverride?: InputMaybe<Scalars['String']>;
  startFrom?: InputMaybe<Scalars['JSONObject']>;
  tagConfigOverride?: InputMaybe<Array<InputMaybe<Scalars['JSONObject']>>>;
  timing?: InputMaybe<Scalars['JSONObject']>;
  valueOptimizationOverride?: InputMaybe<Scalars['JSONObject']>;
};

export type DuplicateIdrGraphErrorResponse = {
  __typename?: 'DuplicateIDRGraphErrorResponse';
  error: Scalars['String'];
};

export type DuplicateIdrGraphInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  outputTable: Scalars['String'];
  sourceGraphId: Scalars['String'];
};

export type DuplicateIdrGraphResponse = DuplicateIdrGraphErrorResponse | DuplicateIdrGraphSuccessResponse;

export type DuplicateIdrGraphSuccessResponse = {
  __typename?: 'DuplicateIDRGraphSuccessResponse';
  graphId: Scalars['String'];
};

export type DynamicContentBranchInput = {
  /** The branch with no condition is the fallback. Exactly one per group. */
  audienceCondition?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** Filters reporting to recipients sent this branch. slotId is the slot library id. */
export type DynamicContentBranchSelectionInput = {
  branchId: Scalars['String'];
  slotId: Scalars['String'];
};

/**
 * Content for one case. Set `body` for every field: element HTML for
 * `emailBody`, one URL for `pushImage`, one URL or empty for `smsLink`
 * and `smsMedia`, case text for the other fields. Set `links` for `smsBody`.
 * An `emailSubject` or `emailPreheader` case is one line of text with no
 * content block and no Dynamic content marker.
 */
export type DynamicContentCaseContentInput = {
  body?: InputMaybe<Scalars['String']>;
  /** The links of an smsBody case. Its body holds one placeholder per link. */
  links?: InputMaybe<Array<SmsLinkInput>>;
  /**
   * The Beefree modules an emailBody case's body was exported from. Stored so the
   * scoped editor re-opens from the case rather than from the design, which needs
   * editor-state json: Beefree cannot open html.
   */
  modules?: InputMaybe<Array<Scalars['JSONObject']>>;
  /**
   * Merge tags this variant references, resolved against the condition's parent
   * model. Stored on the variant's own row, so it stays accurate no matter which
   * write path last edited the variant; the orchestrator unions it with the
   * message's own lanes when deciding which columns to export.
   */
  profileMappings?: InputMaybe<Array<ProfileMappingInput>>;
};

export type DynamicContentCaseInput = {
  branchId: Scalars['uuid'];
  /** A case with no content is excluded and sends nothing. */
  content?: InputMaybe<DynamicContentCaseContentInput>;
};

/**
 * Dynamic content written in the same transaction as the published content
 * version. The value is the complete Dynamic content of the message: groups
 * absent from it keep their rows, usages absent from it are detached.
 */
export type DynamicContentChangesetInput = {
  groups?: InputMaybe<Array<DynamicContentGroupInput>>;
  placements?: InputMaybe<Array<DynamicContentPlacementInput>>;
};

export type DynamicContentGroupInput = {
  /** An AI Decisioning agent picks the branch instead of the ranked conditions. Omit to keep the saved value. */
  agentSelectable?: InputMaybe<Scalars['Boolean']>;
  branches: Array<DynamicContentBranchInput>;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type DynamicContentPlacementInput = {
  /**
   * Each listed branch has saved content or an explicit exclusion. An omitted
   * branch has no saved content.
   */
  cases: Array<DynamicContentCaseInput>;
  /**
   * The message field this placement sits in. It must belong to the message's
   * channel, and it decides the content shape a case can use.
   */
  field: DynamicContentTargetField;
  libraryId: Scalars['uuid'];
  /** The element display name. Omitted or null preserves an existing name. */
  name?: InputMaybe<Scalars['String']>;
  /** The message part the group is placed on, for example `module:<uuid>`. */
  partKey: Scalars['String'];
};

/** Every message field a condition can be placed in. */
export const DynamicContentTargetField = {
  EmailBody: 'emailBody',
  EmailPreheader: 'emailPreheader',
  EmailSubject: 'emailSubject',
  PushBody: 'pushBody',
  PushImage: 'pushImage',
  PushSubtitle: 'pushSubtitle',
  PushTitle: 'pushTitle',
  SmsBody: 'smsBody',
  SmsLink: 'smsLink',
  SmsMedia: 'smsMedia'
} as const;

export type DynamicContentTargetField = typeof DynamicContentTargetField[keyof typeof DynamicContentTargetField];
export type Edge = {
  __typename?: 'Edge';
  from_node_id: Scalars['String'];
  to_node_id: Scalars['String'];
};

export type EdgeInput = {
  from_node_id: Scalars['String'];
  to_node_id: Scalars['String'];
};

/**
 * Each field left out stays as it is; null clears the ones that can be empty.
 * ownerUserIds and memberUserIds each replace everyone in that role.
 */
export type EditAmpProjectInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  brandProfileId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  memberUserIds?: InputMaybe<Array<Scalars['ID']>>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  startAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AmpProjectStatus>;
  title?: InputMaybe<Scalars['String']>;
};

/**
 * Each field left out stays as it is; null clears description and dueAt.
 * ownerUserIds and assignees each replace everyone in that role.
 * statusCategory is for a subtask, which has no workflow status.
 */
export type EditAmpTaskInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  assignees?: InputMaybe<Array<AmpTaskUserInput>>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['String']>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  statusCategory?: InputMaybe<AmpTaskStatusCategory>;
  title?: InputMaybe<Scalars['String']>;
};

export type ElementChangeSuggestionInput = {
  annotation: Scalars['String'];
  label: Scalars['String'];
};

export type EllieAdminInternetRequestsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  olderThanMinutes?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  siteId: Scalars['String'];
};

export type EllieAdminMonitorInput = {
  after?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
  days?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  impact?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  selected?: InputMaybe<Scalars['String']>;
  semanticOffset?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  trigger?: InputMaybe<Scalars['String']>;
  tz?: InputMaybe<Scalars['String']>;
  view: EllieMonitorView;
};

export type EllieAdminReadInput = {
  action?: InputMaybe<Scalars['String']>;
  clearedBefore?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export type EllieChat = {
  __typename?: 'EllieChat';
  id: Scalars['String'];
  isOwner: Scalars['Boolean'];
  ownerName?: Maybe<Scalars['String']>;
  running?: Maybe<Scalars['Boolean']>;
  shared: Scalars['Boolean'];
  title: Scalars['String'];
  turns: Array<EllieChatTurn>;
  updatedAt: Scalars['String'];
};

export type EllieChatCopy = {
  __typename?: 'EllieChatCopy';
  id: Scalars['String'];
};

export type EllieChatSummary = {
  __typename?: 'EllieChatSummary';
  id: Scalars['String'];
  ownerName?: Maybe<Scalars['String']>;
  shared: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EllieChatTurn = {
  __typename?: 'EllieChatTurn';
  id: Scalars['String'];
  role: Scalars['String'];
  text: Scalars['String'];
  toolsUsed?: Maybe<Array<Scalars['String']>>;
};

export type EllieConfiguration = {
  __typename?: 'EllieConfiguration';
  companyId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

export const EllieMonitorView = {
  BrainFile: 'brainFile',
  BrainTree: 'brainTree',
  Campaign: 'campaign',
  Campaigns: 'campaigns',
  ChangelogDiff: 'changelogDiff',
  ChangelogImpact: 'changelogImpact',
  Configuration: 'configuration',
  FileDiff: 'fileDiff',
  History: 'history',
  Maintenance: 'maintenance',
  Overview: 'overview',
  Panel: 'panel',
  Panels: 'panels',
  Requests: 'requests',
  Timeline: 'timeline',
  Usage: 'usage',
  Watch: 'watch',
  Watches: 'watches'
} as const;

export type EllieMonitorView = typeof EllieMonitorView[keyof typeof EllieMonitorView];
export type ElliePatchInput = {
  body: Scalars['jsonb'];
  siteId: Scalars['String'];
};

export type EllieReadInput = {
  aeoStage?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  buyerProblem?: InputMaybe<Scalars['String']>;
  certainty?: InputMaybe<Scalars['String']>;
  excluded?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  material?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  q?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<Scalars['String']>;
  sha256?: InputMaybe<Scalars['String']>;
  siteId: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type EllieResearchResult = {
  __typename?: 'EllieResearchResult';
  data?: Maybe<Scalars['jsonb']>;
  snapshotRefreshing: Scalars['Boolean'];
};

export type EmailBestPracticesInput = {
  customRules: Array<CustomRuleInput>;
  disabledRules: Array<Scalars['String']>;
};

export type EmailBestPracticesOutput = {
  __typename?: 'EmailBestPracticesOutput';
  customRules: Array<CustomRuleOutput>;
  disabledRules: Array<Scalars['String']>;
};

export type EmailMessageType = {
  __typename?: 'EmailMessageType';
  channelId: Scalars['ID'];
  channelName: Scalars['String'];
  channelType: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EmailPngExportRun = {
  __typename?: 'EmailPngExportRun';
  error?: Maybe<Scalars['String']>;
  frames: Array<ExportEmailToPngFrame>;
  id: Scalars['ID'];
  /**
   * Set when personalization was requested but the export fell back to the
   * raw template (in whole or in part) instead of failing.
   */
  personalizationWarning?: Maybe<Scalars['String']>;
  status: EmailPngExportRunStatus;
};

export const EmailPngExportRunStatus = {
  Complete: 'complete',
  Failed: 'failed',
  Pending: 'pending',
  Running: 'running'
} as const;

export type EmailPngExportRunStatus = typeof EmailPngExportRunStatus[keyof typeof EmailPngExportRunStatus];
export type EmailPreviewTemplate = {
  __typename?: 'EmailPreviewTemplate';
  /** The template/campaign ID in the destination */
  id: Scalars['String'];
  /** The name of the template/campaign */
  name: Scalars['String'];
  /** The type of resource (e.g., "campaign", "canvas") */
  type: Scalars['String'];
};

export type EmailSendCreative = {
  __typename?: 'EmailSendCreative';
  html: Scalars['String'];
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unresolvedContentBlocks: Array<EmailSendCreativeBlock>;
  variationId?: Maybe<Scalars['String']>;
  variations: Array<EmailSendCreativeVariation>;
  verificationErrors: Array<Scalars['String']>;
};

export type EmailSendCreativeBlock = {
  __typename?: 'EmailSendCreativeBlock';
  name: Scalars['String'];
  reason: Scalars['String'];
};

export type EmailSendCreativeVariation = {
  __typename?: 'EmailSendCreativeVariation';
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  variationId: Scalars['String'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  plaintext?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  shouldInlineCss?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type EmailTemplateProviderMetadata = {
  __typename?: 'EmailTemplateProviderMetadata';
  googleAnalyticsCampaignName?: Maybe<Scalars['String']>;
  linkParams?: Maybe<Array<TemplateLinkParam>>;
};

export type EnablePushAppAndConfigureEventsInput = {
  appId: Scalars['ID'];
};

export type EnablePushAppAndConfigureEventsResult = {
  __typename?: 'EnablePushAppAndConfigureEventsResult';
  appId: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type EnqueueGoalComputationResponse = {
  __typename?: 'EnqueueGoalComputationResponse';
  jobs: Array<EnqueuedGoalComputationJob>;
};

export type EnqueueStaticListCsvMaterializationInput = {
  /** Selected CSV columns to retain as campaign variables. */
  attributeColumns?: InputMaybe<Array<StaticListCsvAttributeColumnInput>>;
  /** Set when updating an existing audience; omitted when creating a new one. */
  audienceId?: InputMaybe<Scalars['ID']>;
  /** Upload through the campaign CSV flow, including uploads without personalization columns. */
  campaignCsv?: InputMaybe<Scalars['Boolean']>;
  /** Column in the uploaded CSV that holds the identifier to join on. */
  csvColumn: Scalars['String'];
  /** Original name of the uploaded file, persisted so the UI can display it. */
  originalFilename: Scalars['String'];
  parentModelId: Scalars['ID'];
  /** Object-store key of the uploaded CSV */
  sourceFileKey: Scalars['String'];
  /** Column of the parent model or audience to join the CSV column against. */
  warehouseColumn: Scalars['String'];
};

export type EnqueueStaticListCsvMaterializationResult = {
  __typename?: 'EnqueueStaticListCsvMaterializationResult';
  jobId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type EnqueueStaticListRefreshPreviewInput = {
  audienceId: Scalars['ID'];
};

export type EnqueueStaticListRefreshPreviewResult = {
  __typename?: 'EnqueueStaticListRefreshPreviewResult';
  jobId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type EnqueueStaticListSnapshotMaterializationInput = {
  audienceId: Scalars['ID'];
};

export type EnqueueStaticListSnapshotMaterializationResult = {
  __typename?: 'EnqueueStaticListSnapshotMaterializationResult';
  jobId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type EnqueueStaticListSnapshotRefreshInput = {
  audienceId: Scalars['ID'];
};

export type EnqueueStaticListSnapshotRefreshResult = {
  __typename?: 'EnqueueStaticListSnapshotRefreshResult';
  jobId: Scalars['ID'];
  staticListId: Scalars['ID'];
};

export type EnqueuedGoalComputationJob = {
  __typename?: 'EnqueuedGoalComputationJob';
  id: Scalars['String'];
};

export type EnrichedCatalogSyncJobRef = {
  __typename?: 'EnrichedCatalogSyncJobRef';
  jobId: Scalars['ID'];
  status: Scalars['String'];
};

export type EnrichmentJob = {
  __typename?: 'EnrichmentJob';
  created_at: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: EnrichmentStatus;
};

export const EnrichmentStatus = {
  Cancelled: 'CANCELLED',
  Cancelling: 'CANCELLING',
  Failed: 'FAILED',
  Processing: 'PROCESSING',
  Success: 'SUCCESS'
} as const;

export type EnrichmentStatus = typeof EnrichmentStatus[keyof typeof EnrichmentStatus];
export type EnsureCepWhatsAppMessageTemplateResult = {
  __typename?: 'EnsureCepWhatsAppMessageTemplateResult';
  /** The message's draft version, set once a draft is staged; the next draft save goes after it. */
  draftVersion?: Maybe<Scalars['Int']>;
  templateId: Scalars['ID'];
};

export type EnsureTemplateEditingSessionInput = {
  contentEmailId: Scalars['uuid'];
};

export type EnsureTemplateEditingSessionResponse = {
  __typename?: 'EnsureTemplateEditingSessionResponse';
  sessionId: Scalars['uuid'];
};

export type EntitlementBundle = {
  __typename?: 'EntitlementBundle';
  featureKeys: Array<Scalars['String']>;
  key: Scalars['String'];
  label: Scalars['String'];
};

export type EntitlementCenterOrganizationRef = {
  __typename?: 'EntitlementCenterOrganizationRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EntitlementCenterUserRef = {
  __typename?: 'EntitlementCenterUserRef';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EntitlementCenterView = {
  __typename?: 'EntitlementCenterView';
  bundles: Array<EntitlementBundle>;
  features: Array<EntitlementFeatureRow>;
  organization?: Maybe<EntitlementCenterOrganizationRef>;
  planTier?: Maybe<Scalars['String']>;
  workspace: EntitlementCenterWorkspaceRef;
};

export type EntitlementCenterWorkspaceRef = {
  __typename?: 'EntitlementCenterWorkspaceRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * A single feature enable/extend (upsert). expiresAt is a nullable absolute
 * ISO datetime; null = indefinite (no expiry).
 */
export type EntitlementFeatureGrantInput = {
  expiresAt?: InputMaybe<Scalars['String']>;
  featureKey: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  /**
   * One of the feature's grantable tiers. Null grants it untiered, which for a
   * tiered feature means its highest tier. Re-granting at a different tier
   * replaces the tier on the existing grant rather than adding a second one.
   */
  tier?: InputMaybe<Scalars['String']>;
};

export type EntitlementFeatureRow = {
  __typename?: 'EntitlementFeatureRow';
  enabled: Scalars['Boolean'];
  entitlementKeys: Array<Scalars['String']>;
  grant?: Maybe<EntitlementGrant>;
  key: Scalars['String'];
  label: Scalars['String'];
  /** Null unless LaunchDarkly is why this row reads the way it does. */
  ldScope?: Maybe<EntitlementLdScope>;
  managedByPlan: Scalars['Boolean'];
  scope: ResourceType;
  source: EntitlementSource;
  /**
   * Effective tier — the highest any source confers — or null when the feature is
   * boolean or off. The source field names whichever source accounts for it.
   */
  tier?: Maybe<Scalars['String']>;
  /** Grantable tiers, lowest first. Empty for a boolean feature. */
  tiers: Array<EntitlementTier>;
};

export type EntitlementGrant = {
  __typename?: 'EntitlementGrant';
  createdAt: Scalars['String'];
  entitlement: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  grantedBy?: Maybe<EntitlementCenterUserRef>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  resourceType: ResourceType;
  /** Tier this grant confers. Null for a boolean entitlement. */
  tier?: Maybe<Scalars['String']>;
};

/**
 * Who a LaunchDarkly-driven answer applies to. A LaunchDarkly rule can target
 * an individual user, so a flag can be on for the staff member viewing this
 * page while no one else in the workspace has it.
 */
export const EntitlementLdScope = {
  /** On only for the caller. No one else in the workspace has it. */
  ViewerOnly: 'VIEWER_ONLY',
  /** On under a workspace-scoped context, so the workspace has it. */
  Workspace: 'WORKSPACE'
} as const;

export type EntitlementLdScope = typeof EntitlementLdScope[keyof typeof EntitlementLdScope];
export type EntitlementOverage = {
  __typename?: 'EntitlementOverage';
  destinationOverage: Scalars['Boolean'];
  destinationOverageText: Scalars['String'];
  firstOverageDate?: Maybe<Scalars['String']>;
  overage: Scalars['Boolean'];
  overageLockout: Scalars['Boolean'];
  premiumOverage: Scalars['Boolean'];
};

/** Apply a preset bundle; expands server-side to its member features. */
export type EntitlementPresetGrantInput = {
  expiresAt?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  presetKey: Scalars['String'];
};

export const EntitlementSource = {
  Granted: 'GRANTED',
  LaunchDarkly: 'LAUNCH_DARKLY',
  None: 'NONE',
  Plan: 'PLAN'
} as const;

export type EntitlementSource = typeof EntitlementSource[keyof typeof EntitlementSource];
/**
 * A tier a feature can be granted at. Multi-valued entitlements (currently only
 * Agents: free/full) declare these; boolean features have none.
 */
export type EntitlementTier = {
  __typename?: 'EntitlementTier';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type EntitlementValues = {
  __typename?: 'EntitlementValues';
  /**
   * The following are surfaced so the frontend can gate on the engine's answer
   * rather than on the org entitlements jsonb or a LaunchDarkly flag alone.
   * Only the engine sees an active staff grant from the Entitlement Center —
   * grants live in the entitlement_grants table, which neither of those sources
   * knows about, so a granted workspace would otherwise keep a locked UI.
   */
  adStudio: Scalars['Boolean'];
  agents: Scalars['Boolean'];
  analytics: Scalars['Boolean'];
  analyticsPreLaunch: Scalars['Boolean'];
  approvals: Scalars['Boolean'];
  audiences: Scalars['Boolean'];
  auditLogs: Scalars['Boolean'];
  campaigns: Scalars['Boolean'];
  cep: Scalars['Boolean'];
  customRoles: Scalars['Boolean'];
  /**
   * The org entitlements key OR an active staff grant. Confers the full agents
   * tier. Distinct from the agents field above, which additionally folds in the
   * LD tier's free variant and is masked by the org AI kill-switch.
   */
  dataAgents: Scalars['Boolean'];
  decisionEngine: Scalars['Boolean'];
  events: Scalars['Boolean'];
  /**
   * Whether the external MCP server exposes any tools. Which tools it exposes
   * still depends on adStudio and the agent products.
   */
  externalMcp: Scalars['Boolean'];
  externalStorage: Scalars['Boolean'];
  /**
   * The engine gates this on the "paid" plan tier — any non-null SKU qualifies,
   * matching what the gitSync mutations in base/gitResolvers.ts enforce.
   */
  gitSync: Scalars['Boolean'];
  idr: Scalars['Boolean'];
  /**
   * The IDR agent, which is write-capable: a workspace holding this may both
   * inspect graphs and have the agent propose change plans.
   */
  idrAgent: Scalars['Boolean'];
  journeys: Scalars['Boolean'];
  lifecycleStudio: Scalars['Boolean'];
  matchbooster: Scalars['Boolean'];
  pidr: Scalars['Boolean'];
  predictiveTraits: Scalars['Boolean'];
  realtimeAudiences: Scalars['Boolean'];
  /** Setting when a sync schedule starts and ends. */
  scheduleStartEnd: Scalars['Boolean'];
  sso: Scalars['Boolean'];
  syncUsageReporting: Scalars['Boolean'];
  warehouseSyncLogs: Scalars['Boolean'];
  warehouseToolsInBackground: Scalars['Boolean'];
};

/**
 * An entity cited by the document being described. Carries enough to render the
 * citation in place, including the presigned URL for a file target.
 */
export type EntityCitationTarget = {
  __typename?: 'EntityCitationTarget';
  id: Scalars['uuid'];
  name: Scalars['String'];
  scope: ContextCitationScope;
  type: AgenticSettingsEntityType;
  /** Presigned read URL for a context_file target, null for every other type. */
  url?: Maybe<Scalars['String']>;
};

/** Both citation directions for one entity. */
export type EntityCitations = {
  __typename?: 'EntityCitations';
  /** Workspace documents whose content cites this entity. */
  citedBy: Array<ContextEntityCitingSource>;
  /**
   * Entities this one's content cites, in the order they appear. A citation whose
   * target no longer resolves is omitted.
   */
  cites: Array<EntityCitationTarget>;
  entityId: Scalars['uuid'];
};

export type ErrorCodeDetails = {
  __typename?: 'ErrorCodeDetails';
  links?: Maybe<Array<DocumentLink>>;
  userFriendlyMessage: Scalars['String'];
};

export type EspCatalogRefreshJobResult = {
  __typename?: 'EspCatalogRefreshJobResult';
  enqueued: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  resource: EspCatalogResource;
};

export const EspCatalogResource = {
  ContentBlocks: 'content_blocks',
  UserFields: 'user_fields'
} as const;

export type EspCatalogResource = typeof EspCatalogResource[keyof typeof EspCatalogResource];
export type EspDestinationInfo = {
  __typename?: 'EspDestinationInfo';
  catalogEligible: Scalars['Boolean'];
  destinationId: Scalars['String'];
  destinationType: Scalars['String'];
  templatingLanguage: Scalars['String'];
};

export const EspFieldSource = {
  Custom: 'custom',
  Standard: 'standard'
} as const;

export type EspFieldSource = typeof EspFieldSource[keyof typeof EspFieldSource];
export type EspUserFieldImportInput = {
  description?: InputMaybe<Scalars['String']>;
  fieldType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  source: EspFieldSource;
};

export type EspUserFieldProposal = {
  __typename?: 'EspUserFieldProposal';
  description?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  mergeTag: Scalars['String'];
  name: Scalars['String'];
  source: EspFieldSource;
};

export type EventAggregationsInput = {
  categoricalColumns?: InputMaybe<Array<Scalars['String']>>;
  numericColumns?: InputMaybe<Array<Scalars['String']>>;
};

export type EventComponent = {
  __typename?: 'EventComponent';
  description?: Maybe<Scalars['String']>;
  event_plan_id: Scalars['String'];
  id: Scalars['String'];
  imports: Array<Scalars['String']>;
  name: Scalars['String'];
  resolvedSchema: Scalars['JSONObject'];
  schema: Scalars['JSONObject'];
  slug: Scalars['String'];
  version: Scalars['String'];
};

export type EventComponentResult = {
  __typename?: 'EventComponentResult';
  component?: Maybe<EventComponent>;
  errors: Array<EventSchemaError>;
  ok: Scalars['Boolean'];
};

export type EventDefintion = {
  __typename?: 'EventDefintion';
  context?: Maybe<Scalars['JSON']>;
  default?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subscription: Scalars['JSON'];
  title: Scalars['String'];
};

export type EventDimensions = {
  __typename?: 'EventDimensions';
  eventName?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
};

export type EventDimensionsInput = {
  eventName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type EventForwardingDestinationGrant = {
  can_edit: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type EventForwardingSyncResult = {
  __typename?: 'EventForwardingSyncResult';
  id: Scalars['String'];
};

export type EventMetricRequests = {
  aggregateRequests?: InputMaybe<EventsAggregateRequests>;
  currentDataRequests?: InputMaybe<EventsCurrentDataRequest>;
  timeseriesRequests?: InputMaybe<EventsTimeseriesRequests>;
};

export type EventMetrics = {
  __typename?: 'EventMetrics';
  dimensions?: Maybe<EventDimensions>;
  id: Scalars['String'];
  resourceType: EventsResourceType;
  results: Array<EventMetricsData>;
};

export type EventMetricsData = {
  __typename?: 'EventMetricsData';
  aggregateData?: Maybe<Array<Maybe<EventsAggregateData>>>;
  currentData?: Maybe<EventsCurrentData>;
  timeseriesData?: Maybe<Array<Maybe<EventsTimeseriesData>>>;
};

export type EventModelConfigurationInput = {
  primary_key?: InputMaybe<Scalars['String']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

export type EventPlanResult = {
  __typename?: 'EventPlanResult';
  id: Scalars['String'];
};

export type EventRequest = {
  __typename?: 'EventRequest';
  meta?: Maybe<Scalars['JSONObject']>;
  request?: Maybe<Scalars['JSONObject']>;
  response?: Maybe<Scalars['JSONObject']>;
};

export type EventSchemaError = {
  __typename?: 'EventSchemaError';
  instancePath?: Maybe<Scalars['String']>;
  keyword?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  params?: Maybe<Scalars['JSONObject']>;
  schemaPath?: Maybe<Scalars['String']>;
};

export const EventSchemaEventType = {
  Alias: 'alias',
  Group: 'group',
  Identify: 'identify',
  Page: 'page',
  Screen: 'screen',
  Track: 'track'
} as const;

export type EventSchemaEventType = typeof EventSchemaEventType[keyof typeof EventSchemaEventType];
export type EventSchemaInput = {
  event_name?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<EventSchemaEventType>;
  event_version?: InputMaybe<Scalars['String']>;
  include_built_in_context?: InputMaybe<Scalars['Boolean']>;
  on_schema_violation?: InputMaybe<EventSchemaOnSchemaViolation>;
  on_undeclared_fields?: InputMaybe<EventSchemaOnUndeclaredFields>;
  schema?: InputMaybe<Scalars['JSONObject']>;
  slug?: InputMaybe<Scalars['String']>;
};

export const EventSchemaOnSchemaViolation = {
  AllowEvent: 'ALLOW_EVENT',
  BlockEvent: 'BLOCK_EVENT'
} as const;

export type EventSchemaOnSchemaViolation = typeof EventSchemaOnSchemaViolation[keyof typeof EventSchemaOnSchemaViolation];
export const EventSchemaOnUndeclaredFields = {
  AllowEvent: 'ALLOW_EVENT',
  BlockEvent: 'BLOCK_EVENT',
  OmitFields: 'OMIT_FIELDS'
} as const;

export type EventSchemaOnUndeclaredFields = typeof EventSchemaOnUndeclaredFields[keyof typeof EventSchemaOnUndeclaredFields];
export type EventSchemaResult = {
  __typename?: 'EventSchemaResult';
  components: Array<EventComponent>;
  event_name?: Maybe<Scalars['String']>;
  event_plan_id: Scalars['String'];
  event_type: EventSchemaEventType;
  event_version: Scalars['String'];
  id: Scalars['String'];
  include_built_in_context?: Maybe<Scalars['Boolean']>;
  on_schema_violation?: Maybe<EventSchemaOnSchemaViolation>;
  on_undeclared_fields?: Maybe<EventSchemaOnUndeclaredFields>;
  resolvedSchema: Scalars['JSONObject'];
  schema: Scalars['JSONObject'];
  slug?: Maybe<Scalars['String']>;
};

export type EventSourceResult = {
  __typename?: 'EventSourceResult';
  id: Scalars['String'];
};

export type EventTimeseriesInterval = {
  __typename?: 'EventTimeseriesInterval';
  binInterval: Scalars['Int'];
  binType: BinIntervalTypeEnum;
};

export type EventTimeseriesIntervalInput = {
  binInterval: Scalars['Int'];
  binType: BinIntervalTypeEnum;
};

export type EventTrace = {
  __typename?: 'EventTrace';
  spans: Array<EventTraceSpan>;
};

export type EventTraceAudience = {
  __typename?: 'EventTraceAudience';
  modelId: Scalars['String'];
  modelName?: Maybe<Scalars['String']>;
  modelSlug?: Maybe<Scalars['String']>;
};

export type EventTraceDecision = {
  __typename?: 'EventTraceDecision';
  reason: Scalars['String'];
  result: EventTraceDecisionResult;
};

export const EventTraceDecisionResult = {
  Accepted: 'accepted',
  Filtered: 'filtered',
  Rejected: 'rejected'
} as const;

export type EventTraceDecisionResult = typeof EventTraceDecisionResult[keyof typeof EventTraceDecisionResult];
export type EventTraceForwardingSync = {
  __typename?: 'EventTraceForwardingSync';
  syncId: Scalars['String'];
  syncName?: Maybe<Scalars['String']>;
  syncSlug: Scalars['String'];
};

export type EventTraceJourney = {
  __typename?: 'EventTraceJourney';
  journeyId: Scalars['String'];
  journeyName: Scalars['String'];
};

export type EventTraceParentModel = {
  __typename?: 'EventTraceParentModel';
  modelId: Scalars['String'];
  modelName?: Maybe<Scalars['String']>;
  modelSlug?: Maybe<Scalars['String']>;
};

export type EventTraceSpan = {
  __typename?: 'EventTraceSpan';
  audience?: Maybe<EventTraceAudience>;
  decisions: Array<EventTraceDecision>;
  endTime: Scalars['String'];
  forwardingSync?: Maybe<EventTraceForwardingSync>;
  journey?: Maybe<EventTraceJourney>;
  parentModel?: Maybe<EventTraceParentModel>;
  parentSpanId?: Maybe<Scalars['String']>;
  spanId: Scalars['String'];
  startTime: Scalars['String'];
  status: EventTraceSpanStatus;
  step: Scalars['String'];
  warehouseSync?: Maybe<EventTraceWarehouseSync>;
};

export const EventTraceSpanStatus = {
  Error: 'ERROR',
  Ok: 'OK'
} as const;

export type EventTraceSpanStatus = typeof EventTraceSpanStatus[keyof typeof EventTraceSpanStatus];
export type EventTraceWarehouseSync = {
  __typename?: 'EventTraceWarehouseSync';
  syncId: Scalars['String'];
  syncName?: Maybe<Scalars['String']>;
  syncSlug: Scalars['String'];
};

export type EventWarehouseDestinationResult = {
  __typename?: 'EventWarehouseDestinationResult';
  id: Scalars['String'];
};

export type EventWarehouseSyncResult = {
  __typename?: 'EventWarehouseSyncResult';
  id: Scalars['String'];
};

export type EventWarehouseSyncRun = {
  __typename?: 'EventWarehouseSyncRun';
  error?: Maybe<Scalars['JSONObject']>;
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  num_failed_events?: Maybe<Scalars['Int']>;
  num_planned_events?: Maybe<Scalars['Int']>;
  schema_only: Scalars['Boolean'];
  started_at?: Maybe<Scalars['String']>;
  table_summary?: Maybe<Scalars['JSONObject']>;
};

export type EventsAggregateData = {
  __typename?: 'EventsAggregateData';
  aggType: EventsAggregateTypeEnum;
  metric: EventsMetricEnum;
  value: Scalars['Float'];
};

export type EventsAggregateRequests = {
  aggType: EventsAggregateTypeEnum;
  endTime: Scalars['UnixEpochTimestamp'];
  metrics: Array<EventsMetricEnum>;
  startTime: Scalars['UnixEpochTimestamp'];
};

export const EventsAggregateTypeEnum = {
  Avg: 'AVG',
  Max: 'MAX',
  Min: 'MIN',
  P95: 'P95',
  P99: 'P99',
  Sum: 'SUM'
} as const;

export type EventsAggregateTypeEnum = typeof EventsAggregateTypeEnum[keyof typeof EventsAggregateTypeEnum];
export type EventsCurrentData = {
  __typename?: 'EventsCurrentData';
  metric: EventsMetricEnum;
  value: Scalars['Float'];
};

export type EventsCurrentDataRequest = {
  metric: EventsMetricEnum;
};

export type EventsDataPoint = {
  __typename?: 'EventsDataPoint';
  timestamp: Scalars['UnixEpochTimestamp'];
  value: Scalars['Float'];
};

export const EventsMetricEnum = {
  Attempted: 'ATTEMPTED',
  Delivered: 'DELIVERED',
  Evaluated: 'EVALUATED',
  Failed: 'FAILED',
  Lag: 'LAG',
  MembershipEntrance: 'MEMBERSHIP_ENTRANCE',
  Received: 'RECEIVED',
  Retry: 'RETRY'
} as const;

export type EventsMetricEnum = typeof EventsMetricEnum[keyof typeof EventsMetricEnum];
export const EventsResourceType = {
  Audience: 'AUDIENCE',
  Source: 'SOURCE',
  Sync: 'SYNC'
} as const;

export type EventsResourceType = typeof EventsResourceType[keyof typeof EventsResourceType];
export type EventsTimeseriesData = {
  __typename?: 'EventsTimeseriesData';
  dataPoints: Array<EventsDataPoint>;
  interval: EventTimeseriesInterval;
  metric: EventsMetricEnum;
};

export type EventsTimeseriesRequests = {
  endTime: Scalars['UnixEpochTimestamp'];
  interval?: InputMaybe<EventTimeseriesIntervalInput>;
  metrics: Array<EventsMetricEnum>;
  startTime: Scalars['UnixEpochTimestamp'];
};

export type ExecuteLlmBackgroundJobErrorResponse = {
  __typename?: 'ExecuteLLMBackgroundJobErrorResponse';
  error: Scalars['String'];
};

export type ExecuteLlmBackgroundJobInput = {
  audienceConfigSummary?: InputMaybe<LlmBackgroundJobAudienceConfigSummaryInput>;
  existingAudienceDetailedSummary?: InputMaybe<LlmBackgroundJobExistingAudienceSummaryInput>;
  existingAudienceSummary?: InputMaybe<LlmBackgroundJobExistingAudienceSummaryInput>;
  type: LlmBackgroundJobType;
};

export type ExecuteLlmBackgroundJobResponse = ExecuteLlmBackgroundJobErrorResponse | ExecuteLlmBackgroundJobSuccessResponse;

export type ExecuteLlmBackgroundJobSuccessResponse = {
  __typename?: 'ExecuteLLMBackgroundJobSuccessResponse';
  jobId: Scalars['uuid'];
};

export type ExecuteLlmConversationBackgroundErrorResponse = {
  __typename?: 'ExecuteLLMConversationBackgroundErrorResponse';
  error: Scalars['String'];
};

export type ExecuteLlmConversationBackgroundResponse = ExecuteLlmConversationBackgroundErrorResponse | ExecuteLlmConversationBackgroundSessionBusyResponse | ExecuteLlmConversationBackgroundSuccessResponse;

/**
 * Returned when the session already has a pending root interaction. The
 * mutation did NOT enqueue new work — the caller must wait for the in-flight
 * interaction to finish (or explicitly cancel it via cancelLLMChatInteraction)
 * before submitting again. Carries the actual pending interaction ID so the
 * client can reconcile its view of session state.
 */
export type ExecuteLlmConversationBackgroundSessionBusyResponse = {
  __typename?: 'ExecuteLLMConversationBackgroundSessionBusyResponse';
  /** The root interaction that is currently pending on this session. */
  pendingInteractionId: Scalars['String'];
};

export type ExecuteLlmConversationBackgroundSuccessResponse = {
  __typename?: 'ExecuteLLMConversationBackgroundSuccessResponse';
  interactionId: Scalars['uuid'];
  /**
   * Set when the original session had been deleted by the retention job: the
   * message was enqueued into this freshly created replacement session instead.
   */
  recreatedSessionId?: Maybe<Scalars['uuid']>;
};

export type ExecuteMarketingAgentConversationInput = {
  customAgentId?: InputMaybe<Scalars['uuid']>;
  customAgentPrompt?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<FileInput>>;
  focusedContent?: InputMaybe<Scalars['String']>;
  interactionContext?: InputMaybe<InteractionContextInput>;
  metadata?: InputMaybe<MetadataInput>;
  model?: InputMaybe<Scalars['String']>;
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  reportScheduleId?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['String'];
  userPrompt: Scalars['String'];
};

export type ExperimentRunData = {
  __typename?: 'ExperimentRunData';
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  experimentId: Scalars['uuid'];
  isStale: Scalars['Boolean'];
  pendingChartCardRun?: Maybe<ExperimentRunHandle>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ExperimentRunHandle = {
  __typename?: 'ExperimentRunHandle';
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
  experimentId: Scalars['uuid'];
};

/** Batch export for bulk download. One disclosure choice applies to every target. */
export type ExportBulkVideoAdsInput = {
  disclaimerSpec?: InputMaybe<DisclaimerSpecInput>;
  targets: Array<ExportVideoAdTargetInput>;
};

export type ExportBulkVideoAdsResponse = {
  __typename?: 'ExportBulkVideoAdsResponse';
  exports: Array<ExportBulkVideoAdsResponseItem>;
};

export type ExportBulkVideoAdsResponseItem = {
  __typename?: 'ExportBulkVideoAdsResponseItem';
  adBriefAssetSizeVariantId?: Maybe<Scalars['uuid']>;
  adBriefAssetVersionId: Scalars['uuid'];
  status: Scalars['String'];
  videoExportId: Scalars['uuid'];
};

export type ExportContentArtifactDynamicContentInput = {
  artifactId: Scalars['uuid'];
  /** Provider campaign to update. Omit to create a new one. */
  campaignId?: InputMaybe<Scalars['String']>;
  campaignName: Scalars['String'];
  destinationId: Scalars['String'];
  /** Version to export; defaults to the artifact's current version. */
  versionId?: InputMaybe<Scalars['uuid']>;
};

export type ExportContentArtifactDynamicContentResponse = {
  __typename?: 'ExportContentArtifactDynamicContentResponse';
  campaignId: Scalars['String'];
  requiredFields: Array<Scalars['String']>;
  warnings: Array<Scalars['String']>;
};

export type ExportContentEmailProblem = {
  __typename?: 'ExportContentEmailProblem';
  /** Null when the problem is not tied to one dynamic content block. */
  blockName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  variantName?: Maybe<Scalars['String']>;
};

export type ExportContentEmailToNativeDeliveryResult = {
  __typename?: 'ExportContentEmailToNativeDeliveryResult';
  /** Null when the export is blocked. */
  campaignId?: Maybe<Scalars['uuid']>;
  problems: Array<ExportContentEmailProblem>;
};

export type ExportEmailHtmlToStorageInput = {
  filename: Scalars['String'];
  html: Scalars['String'];
  parentDirectory?: InputMaybe<Scalars['String']>;
};

export type ExportEmailHtmlToStorageResult = {
  __typename?: 'ExportEmailHtmlToStorageResult';
  objectKey: Scalars['String'];
};

export type ExportEmailToPngFrame = {
  __typename?: 'ExportEmailToPngFrame';
  scheme: ExportEmailToPngFrameScheme;
  /**
   * API streaming URL for the rendered PNG
   * (/api/agents/files?key=...&stream=true), served through the Hightouch domain
   * so corporate proxies don't reset the connection. Fetch with
   * credentials: "include". Null while the run is pending, running, or failed —
   * the frontend can use the placeholder frame to render a loading state.
   */
  url?: Maybe<Scalars['String']>;
  width: ExportEmailToPngFrameWidth;
};

export type ExportEmailToPngFrameInput = {
  scheme: ExportEmailToPngFrameScheme;
  width: ExportEmailToPngFrameWidth;
};

export const ExportEmailToPngFrameScheme = {
  Dark: 'dark',
  Light: 'light'
} as const;

export type ExportEmailToPngFrameScheme = typeof ExportEmailToPngFrameScheme[keyof typeof ExportEmailToPngFrameScheme];
export const ExportEmailToPngFrameWidth = {
  Desktop: 'desktop',
  Mobile: 'mobile'
} as const;

export type ExportEmailToPngFrameWidth = typeof ExportEmailToPngFrameWidth[keyof typeof ExportEmailToPngFrameWidth];
export type ExportEmailToPngInput = {
  contentEmailId: Scalars['ID'];
  contentEmailVersionId: Scalars['ID'];
  /**
   * Expand provider content blocks (Braze/Iterable/SFMC tags, Klaviyo
   * universal-content divs) into their content, the way the in-app preview
   * does. Defaults to true; pass false to export the raw references instead.
   */
  expandContentBlocks?: InputMaybe<Scalars['Boolean']>;
  frames?: InputMaybe<Array<ExportEmailToPngFrameInput>>;
  personalization?: InputMaybe<ExportEmailToPngPersonalizationInput>;
  /**
   * Dynamic-content variant selections (slot id → branch id), as shown on the
   * preview canvas. The export always resolves dynamic slots to a single
   * branch; this only overrides which one — slots without a selection use
   * their priority-first branch.
   */
  slotSelections?: InputMaybe<Scalars['JSON']>;
};

export type ExportEmailToPngPersonalizationCatalogInput = {
  name: Scalars['String'];
  /** Sample rows as flat records of field name to string/number/boolean value. */
  sampleRows: Array<Scalars['JSON']>;
};

/**
 * Sample personalization data — as shown in the studio's personalization
 * preview — to render into the template before screenshotting, so exported
 * PNGs show realistic content instead of raw template variables.
 */
export type ExportEmailToPngPersonalizationInput = {
  catalogs?: InputMaybe<Array<ExportEmailToPngPersonalizationCatalogInput>>;
  language: ContentPersonalizationTemplateLanguage;
  /** Flat record of variable name to string/number/boolean sample value. */
  values: Scalars['JSON'];
};

export type ExportEmailToPngResponse = {
  __typename?: 'ExportEmailToPngResponse';
  runId: Scalars['ID'];
};

export type ExportVideoAdInput = {
  adBriefAssetSizeVariantId?: InputMaybe<Scalars['uuid']>;
  adBriefAssetVersionId: Scalars['uuid'];
  disclaimerSpec?: InputMaybe<DisclaimerSpecInput>;
};

export type ExportVideoAdResponse = {
  __typename?: 'ExportVideoAdResponse';
  status: Scalars['String'];
  videoExportId: Scalars['uuid'];
};

export type ExportVideoAdTargetInput = {
  adBriefAssetSizeVariantId?: InputMaybe<Scalars['uuid']>;
  adBriefAssetVersionId: Scalars['uuid'];
};

export type ExportWebPageToPsdResponse = {
  __typename?: 'ExportWebPageToPsdResponse';
  runId: Scalars['ID'];
};

export type ExposureLogFeedAdvertiserId = {
  __typename?: 'ExposureLogFeedAdvertiserId';
  advertiserId: Scalars['String'];
  feed: Scalars['String'];
};

export type ExposureLogFeedAdvertiserIdInput = {
  advertiserId: Scalars['String'];
  feed: Scalars['String'];
};

/**
 * One day of a TTD REDS feed to load from TTD's S3 before resolving. The
 * schema version is discovered from the listing.
 */
export type ExposureLogRedsDayInput = {
  advertiserId: Scalars['String'];
  date: Scalars['String'];
  feed: Scalars['String'];
  partnerId: Scalars['String'];
};

export type ExposureLogResolutionConfig = {
  __typename?: 'ExposureLogResolutionConfig';
  advertiserId: Scalars['String'];
  customerWarehouseSurface: Scalars['String'];
  enabled: Scalars['Boolean'];
  feedAdvertiserIds: Array<ExposureLogFeedAdvertiserId>;
  feeds: Array<Scalars['String']>;
  lookbackDays: Scalars['Int'];
  partnerId: Scalars['String'];
  startDate: Scalars['String'];
  startHourUtc: Scalars['Int'];
};

export type ExposureLogResolutionConfigInput = {
  advertiserId: Scalars['String'];
  customerWarehouseSurface: Scalars['String'];
  enabled: Scalars['Boolean'];
  feedAdvertiserIds?: InputMaybe<Array<ExposureLogFeedAdvertiserIdInput>>;
  feeds: Array<Scalars['String']>;
  lookbackDays: Scalars['Int'];
  partnerId: Scalars['String'];
  startDate: Scalars['String'];
  startHourUtc: Scalars['Int'];
};

export type ExposureLogResolutionConfigResult = {
  __typename?: 'ExposureLogResolutionConfigResult';
  config?: Maybe<ExposureLogResolutionConfig>;
  invalidReason?: Maybe<Scalars['String']>;
};

export type ExtensionCapability = {
  __typename?: 'ExtensionCapability';
  supportsExport: Scalars['Boolean'];
  /** True when connections of this type can have syncs. */
  supportsSyncs: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ExtensionDefinition = {
  __typename?: 'ExtensionDefinition';
  exportForm?: Maybe<Scalars['JSON']>;
  form: Scalars['JSON'];
  name: Scalars['String'];
  supportsExport: Scalars['Boolean'];
  type: Scalars['String'];
};

export type ExtensionExportFile = {
  __typename?: 'ExtensionExportFile';
  error?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['String'];
  status: Scalars['String'];
};

export type ExtensionExportJob = {
  __typename?: 'ExtensionExportJob';
  createdAt: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  exportConfig?: Maybe<Scalars['JSON']>;
  files: Array<ExtensionExportFile>;
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  progress: ExtensionExportProgress;
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ExtensionExportProgress = {
  __typename?: 'ExtensionExportProgress';
  cancelled: Scalars['Int'];
  failed: Scalars['Int'];
  finished: Scalars['Int'];
  needsReconciliation: Scalars['Int'];
  total: Scalars['Int'];
};

export type ExtensionHealthCheck = {
  __typename?: 'ExtensionHealthCheck';
  category: ExtensionHealthCheckCategory;
  extension: ExtensionHealthCheckNames;
  lastStatusCheckTime?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  status: ExtensionHealthCheckStatus;
};

export const ExtensionHealthCheckCategory = {
  Alerts: 'Alerts',
  Dbt: 'Dbt',
  DbtCloud: 'DbtCloud',
  Fivetran: 'Fivetran',
  GitSync: 'GitSync',
  Looker: 'Looker',
  Monitoring: 'Monitoring',
  Sigma: 'Sigma'
} as const;

export type ExtensionHealthCheckCategory = typeof ExtensionHealthCheckCategory[keyof typeof ExtensionHealthCheckCategory];
export const ExtensionHealthCheckNames = {
  Datadog: 'Datadog',
  DbtCloud: 'DbtCloud',
  DbtCommitChecks: 'DbtCommitChecks',
  DbtExposures: 'DbtExposures',
  DbtModelSync: 'DbtModelSync',
  Fivetran: 'Fivetran',
  GitSync: 'GitSync',
  GitSyncCommitChecks: 'GitSyncCommitChecks',
  Looker: 'Looker',
  Sigma: 'Sigma',
  SyncAlerts: 'SyncAlerts'
} as const;

export type ExtensionHealthCheckNames = typeof ExtensionHealthCheckNames[keyof typeof ExtensionHealthCheckNames];
export const ExtensionHealthCheckStatus = {
  Disabled: 'Disabled',
  Failing: 'Failing',
  Healthy: 'Healthy',
  Unconfigured: 'Unconfigured',
  Warning: 'Warning'
} as const;

export type ExtensionHealthCheckStatus = typeof ExtensionHealthCheckStatus[keyof typeof ExtensionHealthCheckStatus];
export type ExtensionImportJob = {
  __typename?: 'ExtensionImportJob';
  createdAt: Scalars['String'];
  filters?: Maybe<Scalars['JSON']>;
  finishedAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  progress: ExtensionImportProgress;
  result?: Maybe<ExtensionImportJobResult>;
  startedAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /**
   * The asset group this run imported into. Null for a run with no group, and
   * for every run that predates the column.
   */
  targetAssetGroupId?: Maybe<Scalars['String']>;
};

export type ExtensionImportJobResult = {
  __typename?: 'ExtensionImportJobResult';
  error?: Maybe<Scalars['String']>;
  failed: Scalars['Int'];
  imported: Scalars['Int'];
};

export type ExtensionImportProgress = {
  __typename?: 'ExtensionImportProgress';
  failed: Scalars['Int'];
  imported: Scalars['Int'];
  skipped: Scalars['Int'];
  unsupported: Scalars['Int'];
};

export type ExternalContextSource = {
  __typename?: 'ExternalContextSource';
  config: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  integration: Scalars['String'];
  lastError?: Maybe<Scalars['String']>;
  lastRunAt?: Maybe<Scalars['timestamptz']>;
  lastStatus?: Maybe<Scalars['String']>;
  lastSuccessfulRunAt?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  purpose: Scalars['String'];
  syncFrequency: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
  workspaceId: Scalars['bigint'];
};

/**
 * The job itself failed (timeout, worker crash, etc.) — distinct from a
 * successful probe that returned `valid: false`.
 */
export type ExternalContextSourceConnectionTestFailure = {
  __typename?: 'ExternalContextSourceConnectionTestFailure';
  error: Scalars['String'];
  status: ExternalContextSourceConnectionTestStatus;
};

export type ExternalContextSourceConnectionTestProcessing = {
  __typename?: 'ExternalContextSourceConnectionTestProcessing';
  status: ExternalContextSourceConnectionTestStatus;
};

export type ExternalContextSourceConnectionTestResult = ExternalContextSourceConnectionTestFailure | ExternalContextSourceConnectionTestProcessing | ExternalContextSourceConnectionTestSuccess;

export const ExternalContextSourceConnectionTestStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type ExternalContextSourceConnectionTestStatus = typeof ExternalContextSourceConnectionTestStatus[keyof typeof ExternalContextSourceConnectionTestStatus];
/**
 * The validate probe completed. `valid` distinguishes "warehouse said no"
 * (e.g. table/column missing) from job-level success.
 */
export type ExternalContextSourceConnectionTestSuccess = {
  __typename?: 'ExternalContextSourceConnectionTestSuccess';
  errors: Array<Scalars['String']>;
  status: ExternalContextSourceConnectionTestStatus;
  valid: Scalars['Boolean'];
};

export type ExtractEspUserFieldsResult = {
  __typename?: 'ExtractEspUserFieldsResult';
  fields: Array<EspUserFieldProposal>;
  skippedCount: Scalars['Int'];
};

export type FacebookAdAccount = {
  __typename?: 'FacebookAdAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookAdAccountInput = {
  facebookDestinationId: Scalars['bigint'];
};

export type FacebookAdCatalogGetProductCatalogs = {
  __typename?: 'FacebookAdCatalogGetProductCatalogs';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FacebookAdCatalogGetProductCatalogsInput = {
  destinationId: Scalars['String'];
};

export type FacebookAdCatalogGetProductCatalogsResult = FacebookAdCatalogGetProductCatalogsSuccess;

export type FacebookAdCatalogGetProductCatalogsSuccess = {
  __typename?: 'FacebookAdCatalogGetProductCatalogsSuccess';
  fields: Array<FacebookAdCatalogGetProductCatalogs>;
};

export type FailedDeploymentTestResult = {
  __typename?: 'FailedDeploymentTestResult';
  passed: Scalars['Boolean'];
  results: Array<Maybe<DeploymentValidationResult>>;
  targetWorkspace: ResourceLinkWorkspace;
};

export type FailedDeploymentValidationResult = {
  __typename?: 'FailedDeploymentValidationResult';
  duration?: Maybe<Scalars['Float']>;
  fatal: Scalars['Boolean'];
  message: Scalars['String'];
  passed: Scalars['Boolean'];
  reason: DeploymentFailureReasons;
  stepName: ValidatorNames;
};

export type FailedEvent = {
  __typename?: 'FailedEvent';
  errorCode?: Maybe<Scalars['Int']>;
  errorMsg?: Maybe<Scalars['String']>;
  firstAttemptAt: Scalars['UnixEpochTimestamp'];
  hightouch: Scalars['JSONObject'];
  lastAttemptAt: Scalars['UnixEpochTimestamp'];
  maxRetryCount?: Maybe<Scalars['Int']>;
  maxRetryDurationInMs?: Maybe<Scalars['Int']>;
  payload: Scalars['JSONObject'];
  requestKey?: Maybe<Scalars['String']>;
  totalAttempts: Scalars['Int'];
};

export const FailedEventTypeEnum = {
  Archived: 'ARCHIVED',
  Retry: 'RETRY'
} as const;

export type FailedEventTypeEnum = typeof FailedEventTypeEnum[keyof typeof FailedEventTypeEnum];
export type FailedEvents = {
  __typename?: 'FailedEvents';
  events: Array<FailedEvent>;
};

export type FailedQueryResponse = {
  __typename?: 'FailedQueryResponse';
  error: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  sql?: Maybe<Scalars['String']>;
};

export type FailedRowExportResponse = {
  __typename?: 'FailedRowExportResponse';
  error: Scalars['String'];
};

export type FailoverBucketTestResult = {
  __typename?: 'FailoverBucketTestResult';
  hightouchRegion: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  statuses: Array<TestConnectionStatus>;
  success: Scalars['Boolean'];
};

export type FeatureMatrixColumnsResult = {
  __typename?: 'FeatureMatrixColumnsResult';
  parentModel: FeatureMatrixParentModel;
  relationships: Array<FeatureMatrixRelationship>;
};

export type FeatureMatrixOutputColumn = {
  __typename?: 'FeatureMatrixOutputColumn';
  modelName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type FeatureMatrixParentModel = {
  __typename?: 'FeatureMatrixParentModel';
  columns: Array<FilterableColumn>;
  modelId: Scalars['String'];
  modelName: Scalars['String'];
};

export type FeatureMatrixRelationship = {
  __typename?: 'FeatureMatrixRelationship';
  columns: Array<FilterableColumn>;
  isEventModel: Scalars['Boolean'];
  mergedIntoRelationshipIds: Array<Scalars['String']>;
  relationshipId: Scalars['String'];
  relationshipName?: Maybe<Scalars['String']>;
  requiresAggregation: Scalars['Boolean'];
  targetModelId: Scalars['String'];
  targetModelName: Scalars['String'];
  timestampColumn?: Maybe<Scalars['String']>;
};

export type FeatureMatrixSqlResult = {
  __typename?: 'FeatureMatrixSqlResult';
  columns: Array<FeatureMatrixOutputColumn>;
  sql: Scalars['String'];
};

export type FeatureSchemaEntry = {
  __typename?: 'FeatureSchemaEntry';
  aggregationType?: Maybe<Scalars['String']>;
  insightsDisplayName?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  name: Scalars['String'];
  sourceColumn: Scalars['String'];
  type: Scalars['String'];
};

export type FeatureSqlBackgroundInput = {
  flowId: Scalars['uuid'];
  runSql?: InputMaybe<Scalars['Boolean']>;
};

export type FeatureSqlBackgroundResult = {
  __typename?: 'FeatureSqlBackgroundResult';
  jobId?: Maybe<Scalars['String']>;
  querySql: Scalars['String'];
};

export type FeedbackItemInput = {
  content: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type FetchCepProviderDomain = {
  __typename?: 'FetchCepProviderDomain';
  dnsRecords: Array<VerifyCepDomainDnsRecord>;
  domain: Scalars['String'];
  subdomain: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type FetchCepProviderDomainsInput = {
  providerId: Scalars['ID'];
};

export type FetchCepProviderDomainsResult = {
  __typename?: 'FetchCepProviderDomainsResult';
  domains: Array<FetchCepProviderDomain>;
  error?: Maybe<Scalars['String']>;
  verifiedSenders: Array<FetchCepProviderVerifiedSender>;
};

export type FetchCepProviderVerifiedSender = {
  __typename?: 'FetchCepProviderVerifiedSender';
  fromEmail: Scalars['String'];
  fromName?: Maybe<Scalars['String']>;
};

export type FetchMetaAdAccountsInput = {
  facebookDestinationId: Scalars['String'];
};

export type FetchMetaAdStatusesInput = {
  facebookDestinationId: Scalars['String'];
  metaAdIds: Array<Scalars['String']>;
};

export type FetchMetaAdsetAdsInput = {
  adsetId: Scalars['String'];
  facebookDestinationId: Scalars['String'];
};

export type FetchMetaAdsetsInput = {
  campaignId: Scalars['String'];
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
};

export type FetchMetaCampaignsInput = {
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
};

export type FetchMetaInstagramIdentitiesInput = {
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
  metaPageId: Scalars['String'];
};

export type FetchMetaPagesInput = {
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
};

export type Field = {
  __typename?: 'Field';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type FigmaDesignCandidate = {
  __typename?: 'FigmaDesignCandidate';
  containerId: Scalars['String'];
  containerName: Scalars['String'];
  figmaUrl: Scalars['String'];
  height: Scalars['Float'];
  name: Scalars['String'];
  nodeId: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  width: Scalars['Float'];
};

export type FigmaDesignDiscovery = {
  __typename?: 'FigmaDesignDiscovery';
  candidates: Array<FigmaDesignCandidate>;
  sourceId: Scalars['uuid'];
};

export type FigmaImportDraft = {
  __typename?: 'FigmaImportDraft';
  createdAt: Scalars['String'];
  discoveredImageCount: Scalars['Int'];
  figmaFileKey: Scalars['String'];
  figmaNodeId: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  previewHtml: Scalars['String'];
  warnings: Array<Scalars['String']>;
};

export type FileInput = {
  base64Data: Scalars['String'];
  /**
   * Catalog artifact id when the file was picked from an Ad Studio asset
   * collection, so its collection's rules follow the attachment.
   */
  catalogAssetId?: InputMaybe<Scalars['String']>;
  contentImageId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  /**
   * Folder the file was dropped from, relative to the drop and /-separated,
   * e.g. "Brand A/Summer 2025/Final". Omit for a file dropped on its own.
   */
  folderPath?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
};

export type FilterableColumn = {
  __typename?: 'FilterableColumn';
  alias?: Maybe<Scalars['String']>;
  case_sensitive?: Maybe<Scalars['Boolean']>;
  column_reference: Scalars['JSONObject'];
  custom_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disable?: Maybe<Scalars['Boolean']>;
  disable_preview?: Maybe<Scalars['Boolean']>;
  last_top_k_sync_timestamp?: Maybe<Scalars['String']>;
  merged_relationship_names?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Scalars['JSONObject']>;
  model_id: Scalars['String'];
  model_name: Scalars['String'];
  name: Scalars['String'];
  privacy_level?: Maybe<Scalars['String']>;
  raw_type?: Maybe<Scalars['String']>;
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type FilterableColumnsForSegment = {
  __typename?: 'FilterableColumnsForSegment';
  columns: Array<FilterableColumn>;
  segmentId: Scalars['bigint'];
};

export type FivetranAgentSyncResponse = {
  __typename?: 'FivetranAgentSyncResponse';
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type FivetranConnector = {
  __typename?: 'FivetranConnector';
  id: Scalars['String'];
  schema: Scalars['String'];
  service: Scalars['String'];
  succeeded_at?: Maybe<Scalars['String']>;
};

export type FivetranExtension = {
  __typename?: 'FivetranExtension';
  api_key: Scalars['String'];
  created_at: Scalars['String'];
  fivetran_webhook_id: Scalars['String'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSONObject']>;
  webhook_id: Scalars['String'];
};

export type FivetranExtensionError = {
  __typename?: 'FivetranExtensionError';
  fivetranError?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type FivetranGroup = {
  __typename?: 'FivetranGroup';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** One Fivetran setup test, as Fivetran reported it. */
export type FivetranSetupTest = {
  __typename?: 'FivetranSetupTest';
  message?: Maybe<Scalars['String']>;
  /** PASSED, FAILED, JOB_FAILED, WARNING and so on; FAILED and JOB_FAILED are failures. */
  status: Scalars['String'];
  title: Scalars['String'];
};

export const FivetranSourceType = {
  AmazonAds: 'amazon_ads',
  AmazonDsp: 'amazon_dsp',
  Applovin: 'applovin',
  Attentive: 'attentive',
  BingAds: 'bing_ads',
  Braze: 'braze',
  FacebookAds: 'facebook_ads',
  GoogleAds: 'google_ads',
  GoogleDisplayAndVideo_360: 'google_display_and_video_360',
  GoogleSearchAds_360: 'google_search_ads_360',
  Iterable: 'iterable',
  Klaviyo: 'klaviyo',
  Liftoff: 'liftoff',
  LinkedinAds: 'linkedin_ads',
  Marketo: 'marketo',
  Moloco: 'moloco',
  PinterestAds: 'pinterest_ads',
  RedditAds: 'reddit_ads',
  Sailthru: 'sailthru',
  SalesforceMarketingCloud: 'salesforce_marketing_cloud',
  SnapchatAds: 'snapchat_ads',
  Taboola: 'taboola',
  TheTradeDesk: 'the_trade_desk',
  TiktokAds: 'tiktok_ads',
  YahooDsp: 'yahoo_dsp'
} as const;

export type FivetranSourceType = typeof FivetranSourceType[keyof typeof FivetranSourceType];
export type FivetranSyncTrigger = {
  __typename?: 'FivetranSyncTrigger';
  fivetran_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type FivetranTransformation = {
  __typename?: 'FivetranTransformation';
  dbt_model_id: Scalars['String'];
  dbt_project_id: Scalars['String'];
  id: Scalars['String'];
  last_run?: Maybe<Scalars['String']>;
  output_model_name: Scalars['String'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type FloatComparisonExp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export type FlowAggregations = {
  __typename?: 'FlowAggregations';
  actionFeatureBreakdowns: Array<ActionFeatureBreakdowns>;
  messages: Array<FlowMessageAggregation>;
  sendsByDay: Array<SendsByDay>;
  skippedSendsByDay: Array<SendsByDay>;
  totalSends: Scalars['Int'];
  totalSkippedSends: Scalars['Int'];
  totalUniqueUsersSkippedSends: Scalars['Int'];
  uniqueUsersSkippedSendsByDay: Array<SendsByDay>;
};

export type FlowMessageAggregation = {
  __typename?: 'FlowMessageAggregation';
  messageId: Scalars['String'];
  numUsersInAudienceEligible: Scalars['Int'];
  sendShareLast7Days: Scalars['Float'];
  totalSends: Scalars['Int'];
  totalSendsForUsersInAudience: Scalars['Int'];
  totalSkippedSends: Scalars['Int'];
  totalUniqueUsersSkippedSends: Scalars['Int'];
  uniqueUsersInAudienceWithSend: Scalars['Int'];
};

export type FocusedFilterInput = {
  conditionId?: InputMaybe<Scalars['String']>;
  conditionType?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
};

export type Folder = {
  __typename?: 'Folder';
  count: Scalars['Int'];
  id: Scalars['String'];
  name: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export const FolderResourceType = {
  Experiments: 'experiments',
  Models: 'models',
  Syncs: 'syncs'
} as const;

export type FolderResourceType = typeof FolderResourceType[keyof typeof FolderResourceType];
export type FolderSelectionInput = {
  id: Scalars['String'];
  idPath?: InputMaybe<Scalars['String']>;
  namePath?: InputMaybe<Scalars['String']>;
  scheme: Scalars['String'];
};

export const FolderType = {
  Audiences: 'audiences',
  Models: 'models'
} as const;

export type FolderType = typeof FolderType[keyof typeof FolderType];
export type FontFileUploadResponse = {
  __typename?: 'FontFileUploadResponse';
  /**
   * Typographic family parsed from the font binary (name table ID 16), e.g.
   * Geist for Geist-Black.woff2. Null when the binary was unparseable.
   */
  familyName?: Maybe<Scalars['String']>;
  fontUrl: Scalars['String'];
  /**
   * Variable fonts only: named instances, e.g. {"Bold": {"wght": 700}}. May
   * be an empty object for a variable font without named instances.
   */
  namedVariations?: Maybe<Scalars['JSON']>;
  /**
   * The face's own PostScript name (name ID 6), e.g. Avenir-Heavy — the name
   * Photoshop matches a text layer against. Null when the binary lacks one.
   */
  postscriptName?: Maybe<Scalars['String']>;
  /** Raw typographic family (name ID 16), null when the binary lacks one. */
  preferredFamily?: Maybe<Scalars['String']>;
  /** Raw typographic subfamily (name ID 17), null when the binary lacks one. */
  preferredSubfamily?: Maybe<Scalars['String']>;
  publicFontUrl: Scalars['String'];
  storageKey: Scalars['String'];
  /**
   * CSS font-style parsed from the binary: normal or italic. Null when
   * unparseable.
   */
  style?: Maybe<Scalars['String']>;
  /**
   * Variable fonts only: design axes keyed by tag, e.g.
   * {"wght": {"name": "Weight", "min": 200, "default": 200, "max": 1000}}.
   */
  variationAxes?: Maybe<Scalars['JSON']>;
  /**
   * CSS font-weight parsed from the binary: a single value like 900, or a
   * range like 100 900 for a variable font. Null when unparseable.
   */
  weight?: Maybe<Scalars['String']>;
};

export type FormkitDefinitionInput = {
  type: Scalars['String'];
};

export type FormkitEventSyncContext = {
  destinationId: Scalars['Int'];
  modelId?: InputMaybe<Scalars['Int']>;
  syncId?: InputMaybe<Scalars['Int']>;
};

export type FormkitEventSyncHandlerInput = {
  context: FormkitEventSyncContext;
  handler: Scalars['String'];
  variables?: InputMaybe<Scalars['JSONObject']>;
};

export type FormkitSourceContext = {
  type: Scalars['String'];
};

export type FormkitSourceHandlerInput = {
  context: FormkitSourceContext;
  handler: Scalars['String'];
  variables?: InputMaybe<Scalars['JSONObject']>;
};

export type FormkitSyncContext = {
  destinationId: Scalars['Int'];
  modelId: Scalars['Int'];
  syncId?: InputMaybe<Scalars['Int']>;
};

export type FormkitSyncDefinition = {
  __typename?: 'FormkitSyncDefinition';
  form?: Maybe<Scalars['JSON']>;
  supportsOverrides?: Maybe<Scalars['Boolean']>;
};

export type FormkitSyncHandlerInput = {
  context: FormkitSyncContext;
  handler: Scalars['String'];
  variables?: InputMaybe<Scalars['JSONObject']>;
};

export type FormkitValidationInput = {
  config: Scalars['JSONObject'];
  context?: InputMaybe<Scalars['JSONObject']>;
  event?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type FragmentFieldUpdateInput = {
  /** NDJSON row key, e.g. ht_subject_variant_key. */
  key: Scalars['String'];
  /** Fragment values are string-coerced on export, so this is written as-is. */
  value: Scalars['String'];
};

export type FreshdeskField = {
  __typename?: 'FreshdeskField';
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type FreshdeskListCustomFieldsInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type FreshdeskListCustomFieldsResult = FreshdeskListCustomFieldsSuccess;

export type FreshdeskListCustomFieldsSuccess = {
  __typename?: 'FreshdeskListCustomFieldsSuccess';
  fields: Array<FreshdeskField>;
};

export type FrontDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type FrontDescribeObjectResult = FrontDescribeObjectSuccess;

export type FrontDescribeObjectSuccess = {
  __typename?: 'FrontDescribeObjectSuccess';
  fields: Array<FrontObjectField>;
};

export type FrontObjectField = {
  __typename?: 'FrontObjectField';
  custom: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type FrontendDbtSyncConfig = {
  __typename?: 'FrontendDbtSyncConfig';
  branch?: Maybe<Scalars['String']>;
  checks_enabled?: Maybe<Scalars['Boolean']>;
  commit?: Maybe<Scalars['String']>;
  connection_id: Scalars['bigint'];
  default_schema?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  env_vars?: Maybe<Scalars['jsonb']>;
  error?: Maybe<Scalars['jsonb']>;
  exposure_sync_branch?: Maybe<Scalars['String']>;
  exposure_sync_enabled?: Maybe<Scalars['Boolean']>;
  exposure_sync_error?: Maybe<Scalars['jsonb']>;
  exposure_sync_last_run_at?: Maybe<Scalars['String']>;
  exposure_sync_path?: Maybe<Scalars['String']>;
  failed_attempts?: Maybe<Scalars['Int']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  git_credentials?: Maybe<GitCredentialsType>;
  git_credentials_id: Scalars['bigint'];
  id: Scalars['bigint'];
  last_run_at?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  selector?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  use_database_overrides?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type FrontendDbtSyncConfigInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  commit?: InputMaybe<Scalars['String']>;
  connection_id: Scalars['bigint'];
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  env_vars?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_branch?: InputMaybe<Scalars['String']>;
  exposure_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  exposure_sync_path?: InputMaybe<Scalars['String']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  git_credentials_id: Scalars['bigint'];
  metadata?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FrontendDbtSyncConfigUpdateInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  commit?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['Int']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  env_vars?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_branch?: InputMaybe<Scalars['String']>;
  exposure_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  exposure_sync_error?: InputMaybe<Scalars['String']>;
  exposure_sync_last_run_at?: InputMaybe<Scalars['String']>;
  exposure_sync_path?: InputMaybe<Scalars['String']>;
  failed_attempts?: InputMaybe<Scalars['Int']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  git_credentials_id?: InputMaybe<Scalars['Int']>;
  last_run_at?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FrontifyFolder = {
  __typename?: 'FrontifyFolder';
  hasSubfolders: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FrontifyFolderTreeResult = {
  __typename?: 'FrontifyFolderTreeResult';
  folders: Array<FrontifyFolder>;
};

export type FrontifyLibrariesResult = {
  __typename?: 'FrontifyLibrariesResult';
  libraries: Array<FrontifyLibrary>;
};

export type FrontifyLibrary = {
  __typename?: 'FrontifyLibrary';
  brandName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FrontifyMetadataProperty = {
  __typename?: 'FrontifyMetadataProperty';
  id: Scalars['String'];
  name: Scalars['String'];
  options?: Maybe<Array<FrontifyMetadataPropertyOption>>;
  type: Scalars['String'];
};

export type FrontifyMetadataPropertyOption = {
  __typename?: 'FrontifyMetadataPropertyOption';
  id: Scalars['String'];
  value: Scalars['String'];
};

export type FunctionResourceResponse = {
  __typename?: 'FunctionResourceResponse';
  id: Scalars['String'];
};

export type FunnelBackgroundJobId = {
  __typename?: 'FunnelBackgroundJobId';
  cohorts: Array<CohortOrId>;
  jobId: Scalars['String'];
};

export type FunnelMetricBackgroundData = {
  __typename?: 'FunnelMetricBackgroundData';
  data: Array<FunnelMetricDataForCohortOrError>;
  jobId: Scalars['String'];
};

export type FunnelMetricBackgroundResult = {
  __typename?: 'FunnelMetricBackgroundResult';
  data: Array<FunnelMetricBackgroundData>;
};

export type FunnelMetricDataForCohort = {
  __typename?: 'FunnelMetricDataForCohort';
  cohort: CohortOrId;
  groups: Array<FunnelMetricDataForCohortGroup>;
  lowConfidenceResults: Scalars['Boolean'];
  usedSampledModels: Scalars['Boolean'];
};

export type FunnelMetricDataForCohortGroup = {
  __typename?: 'FunnelMetricDataForCohortGroup';
  groupBy?: Maybe<Array<MetricGroupByKey>>;
  splitId?: Maybe<Scalars['String']>;
  stages: Array<FunnelMetricStageData>;
};

export type FunnelMetricDataForCohortOrError = FunnelMetricDataForCohort | FunnelMetricErrorForCohort;

export type FunnelMetricErrorForCohort = {
  __typename?: 'FunnelMetricErrorForCohort';
  cohort: CohortOrId;
  error: Scalars['String'];
};

export type FunnelMetricResult = {
  __typename?: 'FunnelMetricResult';
  backgroundJobs: Array<FunnelBackgroundJobId>;
  immediateData: Array<FunnelMetricDataForCohort>;
};

export type FunnelMetricStageData = {
  __typename?: 'FunnelMetricStageData';
  count: Scalars['Int'];
  stage: FunnelStageDefinition;
};

export type FunnelStageDefinition = {
  __typename?: 'FunnelStageDefinition';
  eventModelId: Scalars['String'];
  filter?: Maybe<Scalars['JSONObject']>;
  relationshipId: Scalars['String'];
};

export type FunnelStageDefinitionInput = {
  eventModelId: Scalars['String'];
  filter?: InputMaybe<Scalars['JSONObject']>;
  relationshipId: Scalars['String'];
};

export type GainsightGetAccountAttributesInput = {
  destinationId: Scalars['String'];
};

export type GainsightGetUserAttributesInput = {
  destinationId: Scalars['String'];
};

export type GainsightpxAccountAttributes = {
  __typename?: 'GainsightpxAccountAttributes';
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type GainsightpxGetAccountAttributesResult = GainsightpxGetAccountAttributesSuccess;

export type GainsightpxGetAccountAttributesSuccess = {
  __typename?: 'GainsightpxGetAccountAttributesSuccess';
  fields: Array<GainsightpxAccountAttributes>;
};

export type GainsightpxGetUserAttributesResult = GainsightpxGetUserAttributesSuccess;

export type GainsightpxGetUserAttributesSuccess = {
  __typename?: 'GainsightpxGetUserAttributesSuccess';
  fields: Array<GainsightpxUserAttributes>;
};

export type GainsightpxUserAttributes = {
  __typename?: 'GainsightpxUserAttributes';
  id: Scalars['String'];
  name: Scalars['String'];
  origin: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type GenerateAdVariationsInput = {
  assetId: Scalars['uuid'];
  count?: InputMaybe<Scalars['Int']>;
};

export type GenerateAdVariationsResponse = {
  __typename?: 'GenerateAdVariationsResponse';
  assetId: Scalars['uuid'];
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type GenerateAssetVariantInput = {
  aspectRatio: Scalars['String'];
  assetId: Scalars['uuid'];
  instructions?: InputMaybe<Scalars['String']>;
};

export type GenerateAssetVariantResponse = {
  __typename?: 'GenerateAssetVariantResponse';
  aspectRatio: Scalars['String'];
  variantUrl: Scalars['String'];
};

export type GenerateCopyInput = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  files?: InputMaybe<Array<FileInput>>;
  imageIds?: InputMaybe<Array<Scalars['uuid']>>;
  interactionContext?: InputMaybe<Scalars['JSON']>;
  referenceArtifactId?: InputMaybe<Scalars['uuid']>;
};

export type GenerateCopyResponse = {
  __typename?: 'GenerateCopyResponse';
  id: Scalars['uuid'];
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type GenerateDemoInsightsInput = {
  brandName: Scalars['String'];
};

export type GenerateDynamicContentVariantsInput = {
  /** Free-text direction for how the variants should differ. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Document-order index of the selected element in the displayed version's
   * body (querySelectorAll("*")), computed by the app.
   */
  elementIndex: Scalars['Int'];
  /** Display label for the element ("Image", "Text", …) — prompt flavor only. */
  elementType: Scalars['String'];
  /**
   * Reference images or files for the agent to use when writing variants.
   * Same FileInput shape as generateEmail / createProjectCampaign.
   */
  files?: InputMaybe<Array<FileInput>>;
  /**
   * The selected element's outerHTML (markers stripped), resolved by the app
   * from the version the user is viewing.
   */
  selectedElementHtml: Scalars['String'];
  /** The email builder chat session — the email is resolved from it. */
  sessionId: Scalars['uuid'];
  variationCount: Scalars['Int'];
};

export type GenerateDynamicContentVariantsResponse = {
  __typename?: 'GenerateDynamicContentVariantsResponse';
  interactionId: Scalars['uuid'];
};

export type GenerateEmailInput = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  components?: InputMaybe<Array<ContentComponentInput>>;
  description: Scalars['String'];
  elementChangeSuggestions?: InputMaybe<Array<ContentElementChangeInput>>;
  files?: InputMaybe<Array<FileInput>>;
  focusedContent?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<Scalars['uuid']>>;
  interactionContext?: InputMaybe<Scalars['JSON']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  referenceEmailId: Scalars['uuid'];
};

export type GenerateEmailResponse = {
  __typename?: 'GenerateEmailResponse';
  id: Scalars['uuid'];
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type GenerateMessageCandidate = {
  __typename?: 'GenerateMessageCandidate';
  candidateId: Scalars['uuid'];
  planId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type GenerateMessageCandidatesInput = {
  campaignId: Scalars['uuid'];
  planIds: Array<Scalars['uuid']>;
};

export type GenerateMessageCandidatesResponse = {
  __typename?: 'GenerateMessageCandidatesResponse';
  candidates: Array<GenerateMessageCandidate>;
  /** Plans whose candidate generation was enqueued by this call. Plans already generating or generated are silently skipped. */
  enqueuedPlanIds: Array<Scalars['uuid']>;
  errors: Array<Scalars['String']>;
};

export type GenerateMessageDynamicContentVariantsInput = {
  artifactId: Scalars['uuid'];
  /** Skeleton block id (content.blocks) of the text block being made dynamic. */
  blockId: Scalars['String'];
  /** The block's current text — becomes the fallback fragment. */
  blockText: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  /**
   * Reference images or files for the agent to use when writing variants.
   * Same FileInput shape as generateEmail / createProjectCampaign.
   */
  files?: InputMaybe<Array<FileInput>>;
  sessionId: Scalars['uuid'];
  variationCount: Scalars['Int'];
};

export type GenerateMessageDynamicContentVariantsResponse = {
  __typename?: 'GenerateMessageDynamicContentVariantsResponse';
  interactionId: Scalars['uuid'];
};

export type GenerateMessagePlansInput = {
  campaignId: Scalars['uuid'];
  candidateSplitPlan?: InputMaybe<Scalars['String']>;
  candidatesPerMessage?: InputMaybe<Scalars['Int']>;
  channels?: InputMaybe<Array<Scalars['String']>>;
  guidance: Scalars['String'];
  templateBehavior?: InputMaybe<Scalars['String']>;
  templateGuidance?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['uuid']>>;
  templateStrategy?: InputMaybe<Scalars['String']>;
};

export type GenerateMessagePlansResponse = {
  __typename?: 'GenerateMessagePlansResponse';
  interactionId: Scalars['uuid'];
};

export type GenerateMoreCandidatesInput = {
  campaignId: Scalars['uuid'];
  candidatesPerMessage?: InputMaybe<Scalars['Int']>;
  guidance?: InputMaybe<Scalars['String']>;
  planId: Scalars['uuid'];
  templateGuidance?: InputMaybe<Scalars['String']>;
  templateIds?: InputMaybe<Array<Scalars['uuid']>>;
  templateStrategy?: InputMaybe<Scalars['String']>;
};

export type GenerateMoreCandidatesResponse = {
  __typename?: 'GenerateMoreCandidatesResponse';
  interactionId: Scalars['uuid'];
};

export type GenerateVariantsSuggestionsInput = {
  flowId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};

export type GenerateVariantsSuggestionsResult = {
  __typename?: 'GenerateVariantsSuggestionsResult';
  sessionId: Scalars['uuid'];
};

export type GetAccessibleModelIdsOutput = {
  __typename?: 'GetAccessibleModelIdsOutput';
  modelIds: Array<Scalars['bigint']>;
};

export type GetAccessibleOrganizationsResult = {
  __typename?: 'GetAccessibleOrganizationsResult';
  organizations: Array<AccessibleOrganization>;
};

export type GetAdComponentAssetUrlsInput = {
  /**
   * Nullable so an ad_brief_assets row can pass its own version_id, which is
   * null while the ad is pending. A null id resolves to no urls.
   */
  adBriefAssetVersionId?: InputMaybe<Scalars['uuid']>;
};

export type GetAdComponentAssetUrlsResponse = {
  __typename?: 'GetAdComponentAssetUrlsResponse';
  /**
   * Filename to fetchable URL. A filename whose storage key sits outside the
   * workspace's ad-assets prefix is omitted rather than failing the batch, so
   * callers must keep their per-file fallback for anything missing.
   */
  urls: Scalars['JSON'];
  /**
   * Filename to signed URL of the full-size webp rendition, only for the image
   * filenames the version's markup references. Without a resizer the originals
   * are presigned instead, matching /agents/files?format=webp. Callers must
   * keep their /agents/files fallback for any filename missing from the map.
   */
  webpUrls: Scalars['JSON'];
};

export type GetAgentSettingsFileReadUrlInput = {
  key: Scalars['String'];
};

export type GetAnalyzedEventSchemasInput = {
  eventSourceId?: InputMaybe<Scalars['String']>;
  eventSourceIds?: InputMaybe<Array<Scalars['String']>>;
  eventType?: InputMaybe<Scalars['String']>;
};

export type GetAnalyzedEventSchemasResult = {
  __typename?: 'GetAnalyzedEventSchemasResult';
  schemas: Array<AnalyzedEventSchema>;
};

export type GetArchivedFailuresInput = {
  fromDate: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  pageKey?: InputMaybe<Scalars['String']>;
  syncId: Scalars['String'];
};

export type GetArchivedFailuresResult = {
  __typename?: 'GetArchivedFailuresResult';
  events: Array<ArchivedFailure>;
  nextPageKey?: Maybe<Scalars['String']>;
};

export type GetArchivedFailuresSummaryInput = {
  fromDate: Scalars['String'];
  syncId: Scalars['String'];
};

export type GetArchivedFailuresSummaryResult = {
  __typename?: 'GetArchivedFailuresSummaryResult';
  numFailures: Scalars['Int'];
};

export type GetAvailableEventMetricsInput = {
  aggType: EventsAggregateTypeEnum;
  endTime: Scalars['UnixEpochTimestamp'];
  id: Scalars['String'];
  metrics: Array<EventsMetricEnum>;
  resourceType: EventsResourceType;
  startTime: Scalars['UnixEpochTimestamp'];
};

/**
 * Batch status poll. Ids that no longer resolve are omitted from the statuses
 * list rather than erroring, so one missing export can't wedge a polling loop.
 */
export type GetBulkVideoExportStatusesInput = {
  videoExportIds: Array<Scalars['uuid']>;
};

export type GetBulkVideoExportStatusesResponse = {
  __typename?: 'GetBulkVideoExportStatusesResponse';
  statuses: Array<GetVideoExportStatusResponse>;
};

export type GetCepDevicePreviewResultsResponse = {
  __typename?: 'GetCepDevicePreviewResultsResponse';
  results: Array<CepEmailPreviewTestClientResult>;
};

export type GetCepMessagingServiceChannelsInput = {
  messagingServiceSid: Scalars['String'];
  providerId: Scalars['ID'];
};

export type GetCepMessagingServiceChannelsResult = {
  __typename?: 'GetCepMessagingServiceChannelsResult';
  /** The channels the sender pool can send on. Set only when outcome is ok. */
  channels?: Maybe<Array<Scalars['String']>>;
  error?: Maybe<Scalars['String']>;
  outcome: CepMessagingServiceLookup;
};

export type GetContentArtifactContentInput = {
  artifactId: Scalars['uuid'];
  version?: InputMaybe<Scalars['Int']>;
};

export type GetContentArtifactContentResponse = {
  __typename?: 'GetContentArtifactContentResponse';
  content: Scalars['JSON'];
  metadata: ContentArtifactMetadata;
  version: Scalars['Int'];
};

export type GetContentEmailPersonalizationPreviewInput = {
  campaignId?: InputMaybe<Scalars['uuid']>;
  currentValues?: InputMaybe<Scalars['JSON']>;
  email?: InputMaybe<ContentPersonalizationPreviewEmailInput>;
  localSource?: InputMaybe<LocalEmailTemplateInput>;
  push?: InputMaybe<ContentPersonalizationPreviewArtifactInput>;
  sampleCount?: InputMaybe<Scalars['Int']>;
  sms?: InputMaybe<ContentPersonalizationPreviewArtifactInput>;
};

export type GetContentEmailVersionResolvedHtmlInput = {
  id: Scalars['uuid'];
};

export type GetContentImageReadUrlInput = {
  contentDisposition?: InputMaybe<Scalars['String']>;
  expireSeconds?: InputMaybe<Scalars['Int']>;
  id: Scalars['uuid'];
};

export type GetContentNodesForImageUrlsInput = {
  imageUrls: Array<Scalars['String']>;
};

export type GetDestinationStrippedConfigurationInput = {
  destinationId: Scalars['bigint'];
};

export type GetDeviceTokensForUserInput = {
  pushAppId: Scalars['String'];
  userId: Scalars['String'];
};

export type GetEventMetricsInput = {
  dimensions?: InputMaybe<EventDimensionsInput>;
  id: Scalars['String'];
  requests: Array<EventMetricRequests>;
  resourceType: EventsResourceType;
};

export type GetEventPayloadInput = {
  eventKey: Scalars['String'];
};

export type GetEventPayloadResult = {
  __typename?: 'GetEventPayloadResult';
  payload: Scalars['JSONObject'];
};

export type GetEventRequestInput = {
  requestKey: Scalars['String'];
};

export type GetEventTraceInput = {
  eventId: Scalars['String'];
  sourceId: Scalars['String'];
};

export type GetEventWarehouseSyncRunsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetEventWarehouseSyncRunsOrderBy>;
  syncId: Scalars['String'];
};

export type GetEventWarehouseSyncRunsInputRemoteRelEventWarehouseSyncsruns = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetEventWarehouseSyncRunsOrderBy>;
};

export type GetEventWarehouseSyncRunsOrderBy = {
  started_at: Scalars['String'];
};

export type GetEventWarehouseSyncRunsResult = {
  __typename?: 'GetEventWarehouseSyncRunsResult';
  event_warehouse_sync_runs: Array<EventWarehouseSyncRun>;
};

export type GetFailedEventsInput = {
  syncId: Scalars['String'];
  type: FailedEventTypeEnum;
};

export type GetImageLineageInput = {
  campaignArtifactVersionId?: InputMaybe<Scalars['uuid']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  nodeId?: InputMaybe<Scalars['uuid']>;
};

export type GetLookerLookOutput = {
  __typename?: 'GetLookerLookOutput';
  look: LookerLook;
};

export type GetMarketingCampaignArtifactContentInput = {
  artifactId: Scalars['uuid'];
  version?: InputMaybe<Scalars['Int']>;
};

export type GetSchemaGraphOutput = {
  __typename?: 'GetSchemaGraphOutput';
  models: Array<Model>;
  relationships: Array<Relationship>;
};

export type GetTagsResult = {
  __typename?: 'GetTagsResult';
  messageTags?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  tagType: Scalars['String'];
  variantTags?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
};

export type GetTagsSchemaResults = {
  __typename?: 'GetTagsSchemaResults';
  tagSchema: Scalars['JSONObject'];
};

export type GetTunnelResult = {
  __typename?: 'GetTunnelResult';
  connection?: Maybe<ConnectionDetails>;
  tunnel: Tunnel;
  type: Scalars['String'];
};

export type GetVideoExportBundleStatusInput = {
  jobId: Scalars['uuid'];
};

/**
 * Terminal states carry either the download fields or the error fields.
 * `status` is a JobStatus value.
 */
export type GetVideoExportBundleStatusResponse = {
  __typename?: 'GetVideoExportBundleStatusResponse';
  /**
   * Float rather than Int: fifty MP4s can pass the 2 GiB that a GraphQL Int
   * holds.
   */
  bytes?: Maybe<Scalars['Float']>;
  downloadUrl?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  includedCount?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  skippedCount?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
};

export type GetVideoExportStatusInput = {
  videoExportId: Scalars['uuid'];
};

export type GetVideoExportStatusResponse = {
  __typename?: 'GetVideoExportStatusResponse';
  assetLocation?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  renderId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  videoExportId: Scalars['uuid'];
};

export type GetWarehouseSyncErrorSummaryInput = {
  runId: Scalars['String'];
};

export type GetWarehouseSyncErrorSummaryResult = {
  __typename?: 'GetWarehouseSyncErrorSummaryResult';
  errors: Array<SyncErrorSummary>;
};

export const GettyComposition = {
  Abstract: 'abstract',
  Candid: 'candid',
  CloseUp: 'close_up',
  CopySpace: 'copy_space',
  CutOut: 'cut_out',
  FullFrame: 'full_frame',
  FullLength: 'full_length',
  Headshot: 'headshot',
  LookingAtCamera: 'looking_at_camera',
  Macro: 'macro',
  MediumShot: 'medium_shot',
  PartOfASeries: 'part_of_a_series',
  Portrait: 'portrait',
  Sparse: 'sparse',
  StillLife: 'still_life',
  ThreeQuarterLength: 'three_quarter_length',
  WaistUp: 'waist_up',
  WideShot: 'wide_shot'
} as const;

export type GettyComposition = typeof GettyComposition[keyof typeof GettyComposition];
export const GettyGraphicalStyle = {
  FineArt: 'fine_art',
  Illustration: 'illustration',
  Photography: 'photography',
  Vector: 'vector'
} as const;

export type GettyGraphicalStyle = typeof GettyGraphicalStyle[keyof typeof GettyGraphicalStyle];
export type GettyImage = {
  __typename?: 'GettyImage';
  caption?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  /** Set when this workspace already licensed the image. */
  licensedCatalogId?: Maybe<Scalars['String']>;
  previewUrl: Scalars['String'];
  thumbUrl: Scalars['String'];
  title: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export const GettyOrientation = {
  Horizontal: 'horizontal',
  PanoramicHorizontal: 'panoramic_horizontal',
  PanoramicVertical: 'panoramic_vertical',
  Square: 'square',
  Vertical: 'vertical'
} as const;

export type GettyOrientation = typeof GettyOrientation[keyof typeof GettyOrientation];
export type GettySearchResult = {
  __typename?: 'GettySearchResult';
  images: Array<GettyImage>;
  resultCount: Scalars['Int'];
};

export const GettySortOrder = {
  BestMatch: 'best_match',
  MostPopular: 'most_popular',
  Newest: 'newest',
  Random: 'random'
} as const;

export type GettySortOrder = typeof GettySortOrder[keyof typeof GettySortOrder];
export type GitCredentialsType = {
  __typename?: 'GitCredentialsType';
  id: Scalars['bigint'];
  type: Scalars['String'];
};

export type GitRepositoryTreeEntry = {
  __typename?: 'GitRepositoryTreeEntry';
  path: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  supported: Scalars['Boolean'];
  type: GitRepositoryTreeEntryType;
  unsupportedReason?: Maybe<Scalars['String']>;
};

export const GitRepositoryTreeEntryType = {
  Directory: 'DIRECTORY',
  File: 'FILE'
} as const;

export type GitRepositoryTreeEntryType = typeof GitRepositoryTreeEntryType[keyof typeof GitRepositoryTreeEntryType];
export type GitRepositoryTreeResult = {
  __typename?: 'GitRepositoryTreeResult';
  entries: Array<GitRepositoryTreeEntry>;
};

export type GitSyncConfigResult = {
  __typename?: 'GitSyncConfigResult';
  id: Scalars['int8'];
};

export type GithubBranch = {
  __typename?: 'GithubBranch';
  name: Scalars['String'];
};

export type GithubCredentialMutationInput = {
  id?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  ssh_privatekey?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};

export type GithubCredentialResult = {
  __typename?: 'GithubCredentialResult';
  credentials?: Maybe<Scalars['JSONObject']>;
  id: Scalars['String'];
  tunnel_id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  username?: Maybe<Scalars['String']>;
  workspace_id: Scalars['String'];
};

export type GithubRepository = {
  __typename?: 'GithubRepository';
  fullName: Scalars['String'];
  htmlUrl: Scalars['String'];
};

export type GlobalDecisioningAgentSummary = {
  __typename?: 'GlobalDecisioningAgentSummary';
  agents: Array<GlobalDecisioningAgentSummaryRow>;
  scope: GlobalDecisioningAnalyticsScope;
};

export type GlobalDecisioningAgentSummaryRow = {
  __typename?: 'GlobalDecisioningAgentSummaryRow';
  accepted: Scalars['Float'];
  constrained: Scalars['Float'];
  decisions: Scalars['Float'];
  displaced: Scalars['Float'];
  expectedRewardMeanAccepted?: Maybe<Scalars['Float']>;
  expectedRewardMeanDisplaced?: Maybe<Scalars['Float']>;
  expectedRewardStdAccepted?: Maybe<Scalars['Float']>;
  expectedRewardStdDisplaced?: Maybe<Scalars['Float']>;
  flowId: Scalars['String'];
  scoreMeanAccepted?: Maybe<Scalars['Float']>;
  scoreMeanDisplaced?: Maybe<Scalars['Float']>;
  scoreStdAccepted?: Maybe<Scalars['Float']>;
  scoreStdDisplaced?: Maybe<Scalars['Float']>;
};

export type GlobalDecisioningAnalyticsScope = {
  __typename?: 'GlobalDecisioningAnalyticsScope';
  arbitrationEpoch: Scalars['Int'];
  earliestSendDate?: Maybe<Scalars['String']>;
  epochStartedAt: Scalars['String'];
  fromDate: Scalars['String'];
  latestSendDate?: Maybe<Scalars['String']>;
  mode: DecisionEngineArbitrationGroupMode;
};

export type GlobalDecisioningCompetition = {
  __typename?: 'GlobalDecisioningCompetition';
  pairs: Array<GlobalDecisioningCompetitionRow>;
  scope: GlobalDecisioningAnalyticsScope;
};

export type GlobalDecisioningCompetitionRow = {
  __typename?: 'GlobalDecisioningCompetitionRow';
  aWins: Scalars['Float'];
  avgScoreGap?: Maybe<Scalars['Float']>;
  contests: Scalars['Float'];
  flowA: Scalars['String'];
  flowB: Scalars['String'];
};

/** One change a user made to a group's configuration. Only the fields that belong to the kind are set. */
export type GlobalDecisioningConfigChange = {
  __typename?: 'GlobalDecisioningConfigChange';
  /** Null when the user no longer exists. */
  actorName?: Maybe<Scalars['String']>;
  changedAt: Scalars['String'];
  channel?: Maybe<DecisionEngineArbitrationChannel>;
  flowId?: Maybe<Scalars['String']>;
  /** Null when the agent has since been deleted. */
  flowName?: Maybe<Scalars['String']>;
  fromCap?: Maybe<DecisionEngineUserFrequency>;
  fromMode?: Maybe<DecisionEngineArbitrationGroupMode>;
  fromName?: Maybe<Scalars['String']>;
  fromWeight?: Maybe<Scalars['Float']>;
  kind: GlobalDecisioningConfigChangeKind;
  toCap?: Maybe<DecisionEngineUserFrequency>;
  toMode?: Maybe<DecisionEngineArbitrationGroupMode>;
  toName?: Maybe<Scalars['String']>;
  toWeight?: Maybe<Scalars['Float']>;
};

export const GlobalDecisioningConfigChangeKind = {
  AgentAdded: 'agent_added',
  AgentRemoved: 'agent_removed',
  ChannelCapAdded: 'channel_cap_added',
  ChannelCapChanged: 'channel_cap_changed',
  ChannelCapRemoved: 'channel_cap_removed',
  GroupRenamed: 'group_renamed',
  ModeChanged: 'mode_changed',
  TotalCapChanged: 'total_cap_changed',
  WeightChanged: 'weight_changed'
} as const;

export type GlobalDecisioningConfigChangeKind = typeof GlobalDecisioningConfigChangeKind[keyof typeof GlobalDecisioningConfigChangeKind];
export type GlobalDecisioningConfigChanges = {
  __typename?: 'GlobalDecisioningConfigChanges';
  /** Newest first. */
  changes: Array<GlobalDecisioningConfigChange>;
  fromDate: Scalars['String'];
  /** True when older changes in the window were left out. */
  truncated: Scalars['Boolean'];
};

export type GlobalDecisioningDecisionMix = {
  __typename?: 'GlobalDecisioningDecisionMix';
  points: Array<GlobalDecisioningDecisionMixPoint>;
  scope: GlobalDecisioningAnalyticsScope;
};

export type GlobalDecisioningDecisionMixPoint = {
  __typename?: 'GlobalDecisioningDecisionMixPoint';
  count: Scalars['Float'];
  decisionState: Scalars['String'];
  flowId: Scalars['String'];
  sendDate: Scalars['String'];
};

export type GlobalDecisioningKeptInstead = {
  __typename?: 'GlobalDecisioningKeptInstead';
  channel: Scalars['String'];
  flowId: Scalars['String'];
  inLockSlice: Scalars['Boolean'];
  interactionGroupId: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  sendAt: Scalars['String'];
};

export type GlobalDecisioningTimelineEvent = {
  __typename?: 'GlobalDecisioningTimelineEvent';
  agentWeight?: Maybe<Scalars['Float']>;
  channel: Scalars['String'];
  channelType?: Maybe<Scalars['String']>;
  expectedReward?: Maybe<Scalars['Float']>;
  flowId: Scalars['String'];
  interactionGroupId: Scalars['String'];
  interactionId?: Maybe<Scalars['String']>;
  keptInstead: Array<GlobalDecisioningKeptInstead>;
  percentile?: Maybe<Scalars['Float']>;
  rejectReason?: Maybe<Scalars['String']>;
  runAt: Scalars['String'];
  runId: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  sendAt: Scalars['String'];
  state: GlobalDecisioningTimelineEventState;
  timezone?: Maybe<Scalars['String']>;
};

export const GlobalDecisioningTimelineEventState = {
  ApprovedPast: 'approved_past',
  LockedApproved: 'locked_approved',
  LockedRejected: 'locked_rejected',
  PlannedApproved: 'planned_approved',
  PlannedRejected: 'planned_rejected',
  RejectedPast: 'rejected_past'
} as const;

export type GlobalDecisioningTimelineEventState = typeof GlobalDecisioningTimelineEventState[keyof typeof GlobalDecisioningTimelineEventState];
export type GlobalDecisioningTimelinePlan = {
  __typename?: 'GlobalDecisioningTimelinePlan';
  runAt?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['String']>;
  status: GlobalDecisioningTimelinePlanStatus;
};

export const GlobalDecisioningTimelinePlanStatus = {
  Available: 'available',
  NoPlan: 'no_plan',
  SnapshotMissing: 'snapshot_missing'
} as const;

export type GlobalDecisioningTimelinePlanStatus = typeof GlobalDecisioningTimelinePlanStatus[keyof typeof GlobalDecisioningTimelinePlanStatus];
export type GlobalDecisioningUserTimeline = {
  __typename?: 'GlobalDecisioningUserTimeline';
  events: Array<GlobalDecisioningTimelineEvent>;
  plan: GlobalDecisioningTimelinePlan;
  primaryKey: Scalars['String'];
  scope: GlobalDecisioningAnalyticsScope;
  toDate?: Maybe<Scalars['String']>;
  truncated: Scalars['Boolean'];
};

export const GlobalSuppressionChannelType = {
  Email: 'email'
} as const;

export type GlobalSuppressionChannelType = typeof GlobalSuppressionChannelType[keyof typeof GlobalSuppressionChannelType];
export const GlobalSuppressionKind = {
  Domain: 'domain',
  LocalPart: 'local_part'
} as const;

export type GlobalSuppressionKind = typeof GlobalSuppressionKind[keyof typeof GlobalSuppressionKind];
export type GoldenRecordModelBaseColumns = {
  columnNames: Array<Scalars['String']>;
  idrModelId: Scalars['String'];
  segmentId: Scalars['bigint'];
};

export type GoogleAdAccount = {
  __typename?: 'GoogleAdAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GoogleAdAccountInput = {
  googleAdsDestinationId: Scalars['bigint'];
};

export const GoogleDriveContextAuth = {
  Oauth: 'OAUTH',
  ServiceAccount: 'SERVICE_ACCOUNT'
} as const;

export type GoogleDriveContextAuth = typeof GoogleDriveContextAuth[keyof typeof GoogleDriveContextAuth];
export type GoogleDriveContextFile = {
  __typename?: 'GoogleDriveContextFile';
  id: Scalars['String'];
  mimeType: Scalars['String'];
  modifiedTime: Scalars['String'];
  name: Scalars['String'];
  skipReason?: Maybe<Scalars['String']>;
  webViewLink: Scalars['String'];
};

export type GoogleDriveContextFilesResult = {
  __typename?: 'GoogleDriveContextFilesResult';
  files: Array<GoogleDriveContextFile>;
  /** Picked files the credential can't read, or that are in the trash. */
  inaccessibleFileIds: Array<Scalars['String']>;
};

export type GoogleServiceAccount = {
  __typename?: 'GoogleServiceAccount';
  credentials: Scalars['String'];
  email: Scalars['String'];
};

export type GooglesheetsListSheetsInput = {
  destinationId: Scalars['String'];
  spreadsheetId: Scalars['String'];
};

export type GooglesheetsListSheetsResult = GooglesheetsListSheetsSuccess;

export type GooglesheetsListSheetsSuccess = {
  __typename?: 'GooglesheetsListSheetsSuccess';
  sheetNames: Array<SheetName>;
};

export type GooglesheetsSpreadSheet = {
  __typename?: 'GooglesheetsSpreadSheet';
  id: Scalars['String'];
  name: Scalars['String'];
  webViewLink: Scalars['String'];
};

export type HouseholdMembershipsBackgroundResult = HouseholdMembershipsResponse | ProfileExplorerError;

export type HouseholdMembershipsInput = {
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
};

export type HouseholdMembershipsResponse = {
  __typename?: 'HouseholdMembershipsResponse';
  households: Array<HouseholdRow>;
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
};

export type HouseholdRow = {
  __typename?: 'HouseholdRow';
  members: Array<Member>;
  modelId: Scalars['String'];
  modelName: Scalars['String'];
  primaryKeyValue: Scalars['String'];
  primaryLabelValue: Scalars['String'];
  semanticType: Scalars['String'];
};

export type HubSpotDescribeGlobalInput = {
  destinationId: Scalars['String'];
};

export type HubSpotDescribeGlobalResult = HubSpotDescribeGlobalSuccess;

export type HubSpotDescribeGlobalSuccess = {
  __typename?: 'HubSpotDescribeGlobalSuccess';
  objectsV2: Array<HubSpotObjectDescription>;
};

export type HubSpotDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type HubSpotDescribeObjectResult = HubSpotDescribeObjectSuccess;

export type HubSpotDescribeObjectSuccess = {
  __typename?: 'HubSpotDescribeObjectSuccess';
  associations: Array<HubSpotObjectAssociation>;
  fields: Array<HubSpotObjectField>;
};

export type HubSpotLegacyDescribeGlobalInput = {
  destinationId: Scalars['String'];
};

export type HubSpotLegacyDescribeGlobalResult = HubSpotLegacyDescribeGlobalSuccess;

export type HubSpotLegacyDescribeGlobalSuccess = {
  __typename?: 'HubSpotLegacyDescribeGlobalSuccess';
  objectsV2: Array<HubSpotLegacyObjectDescription>;
};

export type HubSpotLegacyDescribeObjectInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type HubSpotLegacyDescribeObjectResult = HubSpotLegacyDescribeObjectSuccess;

export type HubSpotLegacyDescribeObjectSuccess = {
  __typename?: 'HubSpotLegacyDescribeObjectSuccess';
  associations: Array<HubSpotLegacyObjectAssociation>;
  fields: Array<HubSpotLegacyObjectField>;
};

export type HubSpotLegacyObjectAssociation = {
  __typename?: 'HubSpotLegacyObjectAssociation';
  fromObjectTypeId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  toObjectTypeId: Scalars['String'];
};

export type HubSpotLegacyObjectDescription = {
  __typename?: 'HubSpotLegacyObjectDescription';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HubSpotLegacyObjectField = {
  __typename?: 'HubSpotLegacyObjectField';
  isUpdateable: Scalars['Boolean'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
  unique: Scalars['Boolean'];
};

export type HubSpotObjectAssociation = {
  __typename?: 'HubSpotObjectAssociation';
  fromObjectTypeId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  toObjectTypeId: Scalars['String'];
};

export type HubSpotObjectDescription = {
  __typename?: 'HubSpotObjectDescription';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HubSpotObjectField = {
  __typename?: 'HubSpotObjectField';
  isUpdateable: Scalars['Boolean'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
  unique: Scalars['Boolean'];
};

export type IdrModelMappingInput = {
  column: Scalars['String'];
  identifier: Scalars['String'];
};

export type IdrModelOrderByInput = {
  column: Scalars['String'];
  order: Scalars['String'];
};

export type IdentifierValueStatsQuery = {
  htId: Scalars['String'];
  identifier: Scalars['String'];
  value: Scalars['String'];
};

export type IdrExcludedIdentifier = {
  __typename?: 'IdrExcludedIdentifier';
  identifier: Scalars['String'];
};

export type IdrIdentifier = {
  identifier: Scalars['String'];
  value: Scalars['String'];
};

export type IdrIdentifierSuggestion = {
  __typename?: 'IdrIdentifierSuggestion';
  column: Scalars['String'];
  identifier: Scalars['String'];
  matchType: IdrSuggestionMatchType;
};

export type IdrIdentifierSuggestionsInput = {
  /** Identifiers set on the graph's other models in the open form but not saved yet, such as a custom identifier created on the previous model. Suggestions reuse them like saved identifiers. */
  draftIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Set when the model is added to or edited in an existing graph, so suggestions reuse the graph's identifiers. A v1 graph gets no suggestions. */
  graphId?: InputMaybe<Scalars['ID']>;
  modelId: Scalars['ID'];
};

export type IdrIdentifierSuggestionsResult = {
  __typename?: 'IdrIdentifierSuggestionsResult';
  /** At most one per column, best first. An identifier can repeat across columns, so the caller assigns each identifier to one column. */
  suggestions: Array<IdrIdentifierSuggestion>;
};

export type IdrInput = {
  fullReRun: Scalars['Boolean'];
  idrId: Scalars['String'];
};

export type IdrMergeConvergence = {
  __typename?: 'IdrMergeConvergence';
  allCoClustered: Scalars['Boolean'];
  edges: Array<IdrMergeEdge>;
  finalProfiles: Array<Scalars['String']>;
  message: Scalars['String'];
  records: Array<IdrMergeConvergenceRecordTrace>;
};

export type IdrMergeConvergenceRecordInput = {
  primaryKey: Scalars['String'];
  source: Scalars['String'];
};

export type IdrMergeConvergenceRecordTrace = {
  __typename?: 'IdrMergeConvergenceRecordTrace';
  finalHtId?: Maybe<Scalars['String']>;
  outcome: Scalars['String'];
  primaryKey: Scalars['String'];
  source: Scalars['String'];
  startHtId?: Maybe<Scalars['String']>;
};

export type IdrMergeEdge = {
  __typename?: 'IdrMergeEdge';
  fromHtId: Scalars['String'];
  reasons: Array<Scalars['String']>;
  toHtId: Scalars['String'];
};

export type IdrOutput = {
  __typename?: 'IdrOutput';
  id?: Maybe<Scalars['String']>;
  probabilisticConfig?: Maybe<Scalars['JSONObject']>;
};

export type IdrPidrMergeEdge = {
  __typename?: 'IdrPidrMergeEdge';
  combinedHtId: Scalars['String'];
  fromHtId: Scalars['String'];
  matchScore?: Maybe<Scalars['Float']>;
  pairAPrimaryKey?: Maybe<Scalars['String']>;
  pairASource?: Maybe<Scalars['String']>;
  pairBPrimaryKey?: Maybe<Scalars['String']>;
  pairBSource?: Maybe<Scalars['String']>;
  threshold: Scalars['String'];
  values: Array<IdrPidrPairValue>;
};

export type IdrPidrOverlay = {
  __typename?: 'IdrPidrOverlay';
  edges: Array<IdrPidrMergeEdge>;
  status: IdrPidrOverlayStatus;
  thresholds: Array<IdrPidrThreshold>;
  valuesTruncated: Scalars['Boolean'];
};

export const IdrPidrOverlayStatus = {
  NotProbabilistic: 'not_probabilistic',
  Resolved: 'resolved',
  Stale: 'stale',
  Unavailable: 'unavailable'
} as const;

export type IdrPidrOverlayStatus = typeof IdrPidrOverlayStatus[keyof typeof IdrPidrOverlayStatus];
export type IdrPidrPairValue = {
  __typename?: 'IdrPidrPairValue';
  identifier: Scalars['String'];
  valueA?: Maybe<Scalars['String']>;
  valueB?: Maybe<Scalars['String']>;
};

export type IdrPidrThreshold = {
  __typename?: 'IdrPidrThreshold';
  name: Scalars['String'];
  value: Scalars['Float'];
};

export const IdrProfileAnalysisGroup = {
  EmailCounterpart: 'emailCounterpart',
  MultipleNamesWithRepeatedContact: 'multipleNamesWithRepeatedContact',
  PhoneCounterpart: 'phoneCounterpart',
  SinkProfile: 'sinkProfile',
  SplitEmail: 'splitEmail',
  SplitPhone: 'splitPhone'
} as const;

export type IdrProfileAnalysisGroup = typeof IdrProfileAnalysisGroup[keyof typeof IdrProfileAnalysisGroup];
export type IdrProfileAnalysisJob = {
  __typename?: 'IdrProfileAnalysisJob';
  jobId: Scalars['String'];
  sql: Scalars['String'];
};

export type IdrProfileAnalysisProfileFilter = {
  identifier: Scalars['String'];
  sql: Scalars['String'];
};

export type IdrProfileAnalysisQuery = {
  bucketIndex?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<IdrProfileAnalysisGroup>;
  profileCounterpartMetrics?: InputMaybe<Scalars['Boolean']>;
  type: IdrProfileAnalysisQueryType;
};

export const IdrProfileAnalysisQueryType = {
  IdentityGroupSample: 'identity_group_sample',
  IdentityGroups: 'identity_groups',
  ProfileConsolidationDistribution: 'profile_consolidation_distribution',
  ProfileConsolidationSample: 'profile_consolidation_sample',
  ProfileSizeDistribution: 'profile_size_distribution',
  ProfileSizeSample: 'profile_size_sample'
} as const;

export type IdrProfileAnalysisQueryType = typeof IdrProfileAnalysisQueryType[keyof typeof IdrProfileAnalysisQueryType];
export type IdrProfileAnalysisRequest = {
  idrId: Scalars['String'];
  profileFilter?: InputMaybe<IdrProfileAnalysisProfileFilter>;
  query: IdrProfileAnalysisQuery;
  threshold: Scalars['String'];
};

export type IdrProfileAnalysisSql = {
  __typename?: 'IdrProfileAnalysisSql';
  sql: Scalars['String'];
};

export type IdrProfilesErrorResult = {
  __typename?: 'IdrProfilesErrorResult';
  error: Scalars['String'];
};

export type IdrProfilesJob = {
  __typename?: 'IdrProfilesJob';
  jobId: Scalars['String'];
};

export type IdrProfilesJobResult = IdrProfilesErrorResult | IdrProfilesSuccessResult;

export type IdrProfilesQuery = {
  blocklist?: InputMaybe<BlocklistQuery>;
  identifierValueStats?: InputMaybe<IdentifierValueStatsQuery>;
  pendingSuperclusters?: InputMaybe<PendingSuperclustersQuery>;
  profile?: InputMaybe<ProfileQuery>;
  profileIdentifierRows?: InputMaybe<ProfileIdentifierRowsQuery>;
  profileIdentifierStats?: InputMaybe<ProfileIdentifierStatsQuery>;
  profileIdentifierValues?: InputMaybe<ProfileIdentifierValuesQuery>;
  profileMatchScores?: InputMaybe<ProfileMatchScoresQuery>;
  profileSourceRows?: InputMaybe<ProfileSourceRowsQuery>;
  profileSourceStats?: InputMaybe<ProfileSourceStatsQuery>;
  profiles?: InputMaybe<ProfilesQuery>;
  superclusterSampleRows?: InputMaybe<SuperclusterSampleRowsQuery>;
  superclusterValueCounts?: InputMaybe<SuperclusterValueCountsQuery>;
  superclusters?: InputMaybe<SuperclustersQuery>;
};

export type IdrProfilesQueryColumn = {
  __typename?: 'IdrProfilesQueryColumn';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type IdrProfilesRequest = {
  idrId: Scalars['String'];
  query: IdrProfilesQuery;
  threshold?: InputMaybe<Scalars['String']>;
};

export type IdrProfilesSuccessResult = {
  __typename?: 'IdrProfilesSuccessResult';
  columns: Array<IdrProfilesQueryColumn>;
  pageInfo?: Maybe<PageInfo>;
  queryType: Scalars['String'];
  rows: Array<Scalars['JSONObject']>;
  total?: Maybe<Scalars['Int']>;
};

export type IdrReingestRow = {
  __typename?: 'IdrReingestRow';
  createdAt: Scalars['String'];
  idrId: Scalars['String'];
  idrRunId?: Maybe<Scalars['String']>;
  processed: Scalars['Boolean'];
  requestId: Scalars['String'];
};

export type IdrRowPairRef = {
  a: IdrRowRef;
  b: IdrRowRef;
};

export type IdrRowRef = {
  primaryKey: Scalars['String'];
  source: Scalars['String'];
};

/** The create wizard's models, before the graph exists. */
export type IdrRuleSuggestionsDraftInput = {
  models: Array<IdrRuleSuggestionsModelInput>;
  sourceId: Scalars['ID'];
};

/** Send graphId for a saved graph, or draft in the create wizard. */
export type IdrRuleSuggestionsInput = {
  draft?: InputMaybe<IdrRuleSuggestionsDraftInput>;
  /** The server reads the graph's saved mappings and ignores draft. A v1 graph gets no suggestions. */
  graphId?: InputMaybe<Scalars['ID']>;
};

export type IdrRuleSuggestionsModelInput = {
  /** The identifiers the model maps, in the open form. */
  identifiers: Array<Scalars['String']>;
  modelId: Scalars['ID'];
};

export type IdrRuleSuggestionsResult = {
  __typename?: 'IdrRuleSuggestionsResult';
  /** Mapped identifiers that are not in the merge rules, in alphabetical order. */
  excluded: Array<IdrExcludedIdentifier>;
  /** Default limits. They are not checked against data. */
  limitRules: Array<IdrSuggestedLimitRule>;
  /** Highest priority first. */
  mergeRules: Array<IdrSuggestedMergeRule>;
};

export type IdrRun = {
  __typename?: 'IdrRun';
  runId: Scalars['String'];
  status: IdrRunStatus;
};

export const IdrRunStatus = {
  Cancelled: 'CANCELLED',
  Cancelling: 'CANCELLING',
  Failure: 'FAILURE',
  Processing: 'PROCESSING',
  Queued: 'QUEUED',
  Success: 'SUCCESS'
} as const;

export type IdrRunStatus = typeof IdrRunStatus[keyof typeof IdrRunStatus];
export type IdrSequenceLink = {
  __typename?: 'IdrSequenceLink';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  predecessorIdrId: Scalars['String'];
  successorIdrId: Scalars['String'];
};

export type IdrSequenceLinkInput = {
  predecessorIdrId: Scalars['String'];
  successorIdrId: Scalars['String'];
};

export type IdrSuggestedLimitRule = {
  __typename?: 'IdrSuggestedLimitRule';
  identifier: Scalars['String'];
  limit: Scalars['Int'];
};

export type IdrSuggestedMergeRule = {
  __typename?: 'IdrSuggestedMergeRule';
  identifier: Scalars['String'];
};

/** How the column name matched the identifier. Ignores case and separators. */
export const IdrSuggestionMatchType = {
  /** The column name is a common name for the identifier, such as dob for date_of_birth. */
  Alias: 'alias',
  /** The column name is the identifier, such as EMAIL for email. */
  Exact: 'exact',
  /** The column name contains the identifier or a looser name for it, such as billing_email. The user should check it. */
  Token: 'token'
} as const;

export type IdrSuggestionMatchType = typeof IdrSuggestionMatchType[keyof typeof IdrSuggestionMatchType];
export type IdrTrainingInput = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  idrId: Scalars['String'];
};

export type IdrTrainingRun = {
  __typename?: 'IdrTrainingRun';
  id: Scalars['String'];
  status: Scalars['String'];
};

export type ImageLineageEdge = {
  __typename?: 'ImageLineageEdge';
  createdAt: Scalars['String'];
  fromNodeId: Scalars['uuid'];
  toNodeId: Scalars['uuid'];
  type: Scalars['String'];
};

export type ImageLineageGraphResult = {
  __typename?: 'ImageLineageGraphResult';
  edges: Array<ImageLineageEdge>;
  nodes: Array<ImageLineageNode>;
  targetNodeId: Scalars['uuid'];
};

export type ImageLineageNode = {
  __typename?: 'ImageLineageNode';
  agentEditPrompt?: Maybe<Scalars['String']>;
  /**
   * For catalog_artifact nodes: the ad_artifacts_catalog row the image was
   * materialized from.
   */
  artifactsCatalogId?: Maybe<Scalars['uuid']>;
  componentAssetUrls?: Maybe<Scalars['JSON']>;
  contentImageId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['String'];
  height: Scalars['Int'];
  /**
   * Editor HTML markup — the canonical representation when present (svg is
   * never rewritten once a node has html). Raster layers use image:filename
   * refs resolved via componentAssetUrls, same as svg.
   */
  html?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  imageEditingSessionId?: Maybe<Scalars['uuid']>;
  /**
   * For svg nodes created via create_image: the image style ids the agent
   * used to generate the image, if any.
   */
  imageStyleIds?: Maybe<Array<Scalars['uuid']>>;
  interactionId?: Maybe<Scalars['uuid']>;
  mimeType: Scalars['String'];
  /**
   * Stable public CDN URL for the node's rendered bytes. Non-null only when
   * the node has been promoted to the public bucket (publicS3Key is set).
   * Safe to embed in durable artifacts such as email HTML; unlike url, this
   * never falls back to a time-limited signed private URL.
   */
  publicUrl?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['uuid']>;
  sourceUrl?: Maybe<Scalars['String']>;
  svg?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  width: Scalars['Int'];
};

export type ImportAllAssetsResult = {
  __typename?: 'ImportAllAssetsResult';
  extensionImportId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ImportContentCopyInput = {
  description?: InputMaybe<Scalars['String']>;
  fields: Scalars['JSON'];
  name: Scalars['String'];
};

export type ImportContentCopyResponse = {
  __typename?: 'ImportContentCopyResponse';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type ImportContentEmailInput = {
  /**
   * Optional brand-profile assignment to apply at import. Omitted or empty
   * means "applies to all brand profiles" (zero join rows). Each id must
   * reference a non-deleted brand profile in the caller's workspace.
   */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  /**
   * Marks the imported row as a reusable component (e.g. "Header", "Footer")
   * rather than a full email/template. Omitted/empty imports a regular email.
   * Free-form: the UI suggests common types but accepts any value.
   */
  componentType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eml?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};

export type ImportContentEmailResponse = {
  __typename?: 'ImportContentEmailResponse';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

export type ImportEmailTemplatesResult = {
  __typename?: 'ImportEmailTemplatesResult';
  errors: Array<Scalars['String']>;
  failedCount: Scalars['Int'];
  importedCount: Scalars['Int'];
};

export type ImportFiltersInput = {
  assetCreatedBy?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  dateCreatedTo?: InputMaybe<Scalars['String']>;
  folders?: InputMaybe<Array<FolderSelectionInput>>;
  metadataFilters?: InputMaybe<Scalars['JSON']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ImproveReportInstructionsInput = {
  comments: Array<ReportCommentInput>;
  reportScheduleId: Scalars['String'];
  reportScheduleRunId: Scalars['String'];
};

export type ImproveReportInstructionsResponse = {
  __typename?: 'ImproveReportInstructionsResponse';
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

/** A tier-3 instance: values keyed by tag, authored against one template version. */
export type InAppMessageContent = {
  __typename?: 'InAppMessageContent';
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  templateId: Scalars['ID'];
  templateVersion: Scalars['Int'];
  values: Scalars['JSONObject'];
};

export type InAppMessageDeviceResult = {
  __typename?: 'InAppMessageDeviceResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token: Scalars['String'];
};

/**
 * A tier-2 in-app message schema (template): tagged type-slots plus attached
 * validators, authored by a workspace admin. Immutable and versioned; each
 * version carries a frozen instanceSchema snapshot.
 */
export type InAppMessageTemplate = {
  __typename?: 'InAppMessageTemplate';
  createdAt: Scalars['String'];
  createdBy?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  instanceSchema: Scalars['JSONObject'];
  name: Scalars['String'];
  /** Liquid HTML that previews messages from this version in Hightouch. Never sent to devices. */
  previewHtml?: Maybe<Scalars['String']>;
  template: Scalars['JSONObject'];
  typeSetId: Scalars['String'];
  updatedAt: Scalars['String'];
  version: Scalars['Int'];
};

export type InAppSchemaIssue = {
  __typename?: 'InAppSchemaIssue';
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  validator?: Maybe<Scalars['String']>;
};

export type InAppSendCreative = {
  __typename?: 'InAppSendCreative';
  body?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * The viewer's notifications in projects that are not archived and in Library
 * files the viewer can see, grouped, newest group first.
 * needsYou is groups with a task whose review still waits on the viewer: the
 * task is in review, not archived, and the viewer reviews it. updates is
 * everything else. waitingTaskIds is every task whose review waits on the
 * viewer, read with the notifications so the two always agree.
 */
export type Inbox = {
  __typename?: 'Inbox';
  filterOptions: InboxFilterOptions;
  hasMoreUpdates: Scalars['Boolean'];
  needsYou: Array<InboxGroup>;
  updates: Array<InboxGroup>;
  waitingTaskIds: Array<Scalars['ID']>;
};

/** Everyone, and every project and file, some notification in the inbox has, under no filter. */
export type InboxFilterOptions = {
  __typename?: 'InboxFilterOptions';
  files: Array<ActivityFile>;
  hasAgent: Scalars['Boolean'];
  projects: Array<ActivityProject>;
  users: Array<InboxUser>;
};

/** Each list keeps what matches any of its values. An empty list keeps everything. */
export type InboxFiltersInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
  projectIds: Array<Scalars['ID']>;
  /** agent, or a user id. */
  sources: Array<Scalars['ID']>;
  types: Array<InboxNotificationType>;
};

/**
 * The notifications in one project, or about one Library file outside any
 * project, newest first.
 */
export type InboxGroup = {
  __typename?: 'InboxGroup';
  /** What the notifications are about: project: or file: and its id. */
  id: Scalars['ID'];
  latestAt: Scalars['String'];
  notifications: Array<InboxNotification>;
  /** The strongest reason among the notifications. */
  reason: InboxReason;
  unreadCount: Scalars['Int'];
};

/**
 * An event the viewer should hear about, and why. createdAt is when it reached
 * the viewer, which is later than its event for a mention added by an edit.
 */
export type InboxNotification = {
  __typename?: 'InboxNotification';
  createdAt: Scalars['String'];
  event: ActivityEvent;
  id: Scalars['ID'];
  readAt?: Maybe<Scalars['String']>;
  reason: InboxReason;
  response?: Maybe<InboxResponse>;
};

export const InboxNotificationType = {
  Agent: 'agent',
  Assignment: 'assignment',
  Comment: 'comment',
  Edit: 'edit',
  Mention: 'mention',
  Reply: 'reply',
  Review: 'review',
  Status: 'status'
} as const;

export type InboxNotificationType = typeof InboxNotificationType[keyof typeof InboxNotificationType];
export const InboxReason = {
  Assignee: 'assignee',
  Favorite: 'favorite',
  Member: 'member',
  Mention: 'mention',
  Owner: 'owner',
  Reply: 'reply',
  Review: 'review'
} as const;

export type InboxReason = typeof InboxReason[keyof typeof InboxReason];
/**
 * What the viewer did about a notification after it reached them: their first
 * later reply in its thread, or their first later review of its task.
 */
export type InboxResponse = {
  __typename?: 'InboxResponse';
  at: Scalars['String'];
  kind: InboxResponseKind;
};

export const InboxResponseKind = {
  Approved: 'approved',
  ChangesRequested: 'changes_requested',
  Replied: 'replied',
  Resolved: 'resolved'
} as const;

export type InboxResponseKind = typeof InboxResponseKind[keyof typeof InboxResponseKind];
/**
 * Groups with an unread notification, counted no further than the badge shows.
 * hasMore is set when there are more than count.
 */
export type InboxUnreadCount = {
  __typename?: 'InboxUnreadCount';
  count: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type InboxUser = {
  __typename?: 'InboxUser';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InitiateAdAssetMediaUploadInput = {
  assetId: Scalars['String'];
  contentType: Scalars['String'];
  fileSizeBytes: Scalars['Int'];
  filename: Scalars['String'];
};

export type InitiateAdAssetMediaUploadResponse = {
  __typename?: 'InitiateAdAssetMediaUploadResponse';
  /**
   * The component_assets filename the confirmed file is registered under, and
   * the suffix of the ad: reference a layer uses for it.
   */
  name: Scalars['String'];
  /**
   * Presigned S3 PUT URL. The browser uploads the file here directly with the
   * declared content type, then confirms.
   */
  uploadUrl: Scalars['String'];
};

export type InitiateChatFileUploadInput = {
  fileName: Scalars['String'];
  fileSizeBytes: Scalars['Float'];
};

export type InitiateChatFileUploadResponse = {
  __typename?: 'InitiateChatFileUploadResponse';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type InitiateChatFileUploadsInput = {
  files: Array<ChatFileUploadRequestInput>;
};

export type InitiateChatFileUploadsResponse = {
  __typename?: 'InitiateChatFileUploadsResponse';
  files: Array<ChatFileUploadTarget>;
};

export type InitiateContextFileUploadInput = {
  fileSizeBytes: Scalars['Int'];
  filename: Scalars['String'];
  filetype: Scalars['String'];
};

/**
 * A presigned PUT URL the browser uploads the file bytes to directly, plus the
 * storage key to hand back via AgenticSettingsFileContentInput.s3Key. The
 * object is verified server-side (workspace prefix + size) when the entity is
 * saved; nothing is persisted until then.
 */
export type InitiateContextFileUploadResult = {
  __typename?: 'InitiateContextFileUploadResult';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type InitiateLaunchAssetUploadInput = {
  adBriefAssetId: Scalars['String'];
  aspectRatio: Scalars['String'];
};

export type InitiateLaunchAssetUploadResponse = {
  __typename?: 'InitiateLaunchAssetUploadResponse';
  contentType: Scalars['String'];
  uploadKey: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type InitiativeGoalListItem = {
  __typename?: 'InitiativeGoalListItem';
  details?: Maybe<Scalars['String']>;
  goal: Scalars['String'];
  id: Scalars['uuid'];
  insightCount: Scalars['Int'];
  latestJobStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  updatedByName?: Maybe<Scalars['String']>;
};

export type InjectCampaignInsightsResult = {
  __typename?: 'InjectCampaignInsightsResult';
  /** The inserted batch's id. Null on a dry run. */
  batchId?: Maybe<Scalars['uuid']>;
  droppedFindingCount: Scalars['Int'];
  droppedSendIds: Array<Scalars['String']>;
  /** One sentence listing every dropped send id; null when nothing was dropped. */
  warning?: Maybe<Scalars['String']>;
};

export type InsertAdBriefWithVersionInput = {
  adStudioProjectId?: InputMaybe<Scalars['uuid']>;
  assets?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  llmChatMessageId?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  summary?: InputMaybe<Scalars['String']>;
};

export type InsertAdBriefWithVersionResponse = {
  __typename?: 'InsertAdBriefWithVersionResponse';
  adBriefId: Scalars['uuid'];
  versionId?: Maybe<Scalars['uuid']>;
};

export const InsightsRebuildResult = {
  AlreadyQueued: 'already_queued',
  NotBuildable: 'not_buildable',
  Queued: 'queued'
} as const;

export type InsightsRebuildResult = typeof InsightsRebuildResult[keyof typeof InsightsRebuildResult];
export type InspectPushPayloadEntry = {
  __typename?: 'InspectPushPayloadEntry';
  /** Pretty-printed provider JSON (APNs aps+hightouch for iOS, FCM message for Android). */
  payload: Scalars['String'];
  /** ios | android */
  platform: Scalars['String'];
};

export type InspectPushPayloadInput = {
  body: Scalars['String'];
  /** Reuses the test-send config so the inspected payload matches a real send. */
  config?: InputMaybe<SendTestPushConfigInput>;
  /** Targeted push apps. Determines which platforms (iOS/Android) to render. */
  pushAppIds: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type InspectPushPayloadResult = {
  __typename?: 'InspectPushPayloadResult';
  payloads: Array<InspectPushPayloadEntry>;
};

export type InspectorMessagesBackgroundInput = {
  direction: Scalars['String'];
  flowId?: InputMaybe<Scalars['uuid']>;
  primaryKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type InspectorV2MessagesBackgroundInput = {
  flowIds: Array<Scalars['uuid']>;
  limit?: InputMaybe<Scalars['Int']>;
  primaryKeySearch?: InputMaybe<Scalars['String']>;
};

/** A workspace-shared collection of saved competitor and inspiration ads. */
export type InspirationBoard = {
  __typename?: 'InspirationBoard';
  /** Newest save first. */
  ads: Array<InspirationBoardAd>;
  adsCount: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** An ad saved to a board, addressed the way the scraped ad tables key it. */
export type InspirationBoardAd = {
  __typename?: 'InspirationBoardAd';
  adId: Scalars['String'];
  /** facebook (Meta Ad Library), google, linkedin, or tiktok. */
  channel: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  /** The ad-library account the ad was scraped under. */
  pageId: Scalars['String'];
};

export type InspirationBoardAdInput = {
  adId: Scalars['String'];
  channel: Scalars['String'];
  pageId: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/**
 * A single context file the root agent read during an interaction, with inline
 * usage stats scoped to that interaction's agent category.
 */
export type InteractionContextFileRead = {
  __typename?: 'InteractionContextFileRead';
  /** For copy_references files, the channel their management page is keyed by (email/sms/push/ads). Null for other types. */
  channel?: Maybe<Scalars['String']>;
  /** The metadata.contextType tag (e.g. skill) that routes the file to its own Context Hub surface. Null for untagged files. */
  contextType?: Maybe<Scalars['String']>;
  entityId: Scalars['uuid'];
  name: Scalars['String'];
  readAt: Scalars['timestamptz'];
  readsThisWindow: Scalars['Int'];
  /** All-time interactions that read the file. */
  totalReads: Scalars['Int'];
  type: AgenticSettingsEntityType;
  versionId: Scalars['uuid'];
};

export type InteractionContextFilesRead = {
  __typename?: 'InteractionContextFilesRead';
  /** Agent category of the interaction. Null only when the interaction isn't found or its session has no creation source. */
  category?: Maybe<ContextUsageAgentCategory>;
  files: Array<InteractionContextFileRead>;
  windowDays: Scalars['Int'];
};

export type InteractionContextInput = {
  adStudioAssetGroupId?: InputMaybe<Scalars['String']>;
  adStudioProjectId?: InputMaybe<Scalars['String']>;
  adStudioStyleId?: InputMaybe<Scalars['String']>;
  adStudioStyleMode?: InputMaybe<Scalars['String']>;
  adStudioTemplateCreate?: InputMaybe<AdStudioTemplateCreateContextInput>;
  adStudioTemplateEdit?: InputMaybe<AdStudioTemplateEditContextInput>;
  adStudioTemplateIds?: InputMaybe<Array<Scalars['uuid']>>;
  agentMode?: InputMaybe<Scalars['String']>;
  artifactId?: InputMaybe<Scalars['String']>;
  conceptCount?: InputMaybe<Scalars['Int']>;
  creativeBoost?: InputMaybe<Scalars['Boolean']>;
  emailId?: InputMaybe<Scalars['String']>;
  /** The style chosen for emails a canvas turn starts. */
  emailStyleId?: InputMaybe<Scalars['String']>;
  feedbackItems?: InputMaybe<Array<FeedbackItemInput>>;
  injectAdArtifacts?: InputMaybe<Scalars['Boolean']>;
  isEmailReviewEnabled?: InputMaybe<Scalars['Boolean']>;
  lcmActivity?: InputMaybe<Scalars['JSONObject']>;
  /**
   * Links the new session to an ad_brief_asset (per-asset edit sessions).
   * Without channelSizeId the session becomes the asset's main edit session;
   * with it, the size variant's session for that channel size.
   */
  linkToAdBriefAsset?: InputMaybe<LinkToAdBriefAssetInput>;
  linkToAdStudioProject?: InputMaybe<Scalars['Boolean']>;
  /**
   * Makes the new session this ND email message's one chat, replacing any chat the message had.
   * Other mutations ignore it.
   */
  linkToNdMessage?: InputMaybe<LinkToNdMessageInput>;
  referenceAssetIds?: InputMaybe<Array<Scalars['String']>>;
  selectedContentNodeId?: InputMaybe<Scalars['String']>;
  /** The beta video engine for the ads a canvas turn starts. */
  useVideoEngine?: InputMaybe<Scalars['Boolean']>;
};

export type InteractionModelConfigurationInput = {
  type: Scalars['String'];
};

export type InteractionProgress = {
  __typename?: 'InteractionProgress';
  steps: Array<ProgressStep>;
};

export type IntercomAttribute = {
  __typename?: 'IntercomAttribute';
  api_writable: Scalars['Boolean'];
  custom: Scalars['Boolean'];
  data_type: Scalars['String'];
  name: Scalars['String'];
};

export type IntercomListAttributesInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type IntercomListAttributesResult = IntercomListAttributesSuccess;

export type IntercomListAttributesSuccess = {
  __typename?: 'IntercomListAttributesSuccess';
  fields: Array<IntercomAttribute>;
};

export type Interval = {
  binInterval: Scalars['Int'];
  binType: IntervalBinType;
};

export const IntervalBinType = {
  Hours: 'HOURS',
  Minutes: 'MINUTES'
} as const;

export type IntervalBinType = typeof IntervalBinType[keyof typeof IntervalBinType];
export type InvokeWorkspaceFunctionTesterArgs = {
  code: Scalars['String'];
  data: Array<Scalars['JSONObject']>;
  metadata: Scalars['JSONObject'];
};

export type InvokeWorkspaceFunctionTesterError = {
  __typename?: 'InvokeWorkspaceFunctionTesterError';
  logs?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type InvokeWorkspaceFunctionTesterResponse = InvokeWorkspaceFunctionTesterError | InvokeWorkspaceFunctionTesterSuccess | WorkspaceTesterFunctionCreating;

export type InvokeWorkspaceFunctionTesterSuccess = {
  __typename?: 'InvokeWorkspaceFunctionTesterSuccess';
  data: Array<Scalars['JSONObject']>;
  executionTime?: Maybe<Scalars['Int']>;
  logs?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type IsValidEventSchemaResult = {
  __typename?: 'IsValidEventSchemaResult';
  errors: Array<EventSchemaError>;
  isValid: Scalars['Boolean'];
};

export type IterableCampaign = {
  __typename?: 'IterableCampaign';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type IterableCatalogFields = {
  __typename?: 'IterableCatalogFields';
  id: Scalars['String'];
  iterableType: Scalars['String'];
  name: Scalars['String'];
  type: StandardFieldType;
};

export type IterableCatalogs = {
  __typename?: 'IterableCatalogs';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type IterableField = {
  __typename?: 'IterableField';
  name: Scalars['String'];
  standardType: StandardFieldType;
  type: Scalars['String'];
};

export type IterableGetCampaigns = {
  __typename?: 'IterableGetCampaigns';
  campaigns: Array<IterableCampaign>;
};

export type IterableGetCampaignsInput = {
  destinationId: Scalars['String'];
};

export type IterableGetCatalogFields = {
  __typename?: 'IterableGetCatalogFields';
  catalogFields?: Maybe<Array<IterableCatalogFields>>;
};

export type IterableGetCatalogFieldsInput = {
  catalogName?: InputMaybe<Scalars['String']>;
  destinationId: Scalars['String'];
};

export type IterableGetCatalogs = {
  __typename?: 'IterableGetCatalogs';
  catalogs: Array<IterableCatalogs>;
};

export type IterableGetCatalogsInput = {
  destinationId: Scalars['String'];
};

export type IterableGetTemplates = {
  __typename?: 'IterableGetTemplates';
  templates: Array<IterableTemplate>;
};

export type IterableGetTemplatesInput = {
  destinationId: Scalars['String'];
};

export type IterableTemplate = {
  __typename?: 'IterableTemplate';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export const IterableTemplateType = {
  Base: 'Base',
  Blast: 'Blast',
  Triggered: 'Triggered',
  Workflow: 'Workflow'
} as const;

export type IterableTemplateType = typeof IterableTemplateType[keyof typeof IterableTemplateType];
export type IterableUserFieldsInput = {
  destinationId: Scalars['String'];
};

export type IterableUserFieldsResult = IterableUserFieldsSuccess;

export type IterableUserFieldsSuccess = {
  __typename?: 'IterableUserFieldsSuccess';
  fields: Array<IterableField>;
};

export const JobStatus = {
  Cancelled: 'cancelled',
  Cancelling: 'cancelling',
  Failed: 'failed',
  Finished: 'finished',
  Processing: 'processing',
  Queued: 'queued'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export type JoinMapping = {
  __typename?: 'JoinMapping';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type JoinMappingInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type Journey = {
  __typename?: 'Journey';
  description?: Maybe<Scalars['String']>;
  exit_criteria?: Maybe<Scalars['JSONObject']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notes: Array<Note>;
  parent_model_id: Scalars['String'];
  schedule: Scalars['JSONObject'];
  status: Scalars['String'];
  version_id: Scalars['String'];
};

export type JourneyChange = {
  __typename?: 'JourneyChange';
  changes: Scalars['JSONObject'];
  created_at: Scalars['String'];
  created_by_user: JourneyChangeUser;
  description?: Maybe<Scalars['String']>;
  journey_name: Scalars['String'];
  run_count: Scalars['Int'];
  version_id: Scalars['String'];
};

export type JourneyChangeUser = {
  __typename?: 'JourneyChangeUser';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type JourneyContextVariable = {
  __typename?: 'JourneyContextVariable';
  journey_id: Scalars['String'];
  journey_name: Scalars['String'];
  last_updated_at?: Maybe<Scalars['String']>;
  variable_name: Scalars['String'];
  variable_type: Scalars['String'];
  variable_value?: Maybe<Scalars['String']>;
};

export type JourneyContextVariablesBackgroundResult = JourneyContextVariablesResponse | ProfileExplorerError;

export type JourneyContextVariablesResponse = {
  __typename?: 'JourneyContextVariablesResponse';
  contextVariables: Array<JourneyContextVariable>;
  parentModelId: Scalars['String'];
};

export type JourneyDiff = {
  __typename?: 'JourneyDiff';
  edges_added: Array<JourneyDiffEdge>;
  edges_removed: Array<JourneyDiffEdge>;
  journey_description_change?: Maybe<JourneyDiffFieldChange>;
  journey_exit_criteria_change?: Maybe<JourneyDiffFieldChange>;
  journey_name_change?: Maybe<JourneyDiffFieldChange>;
  journey_schedule_change?: Maybe<JourneyDiffFieldChange>;
  nodes_added: Array<JourneyDiffNode>;
  nodes_changed: Array<JourneyDiffNode>;
  nodes_removed: Array<JourneyDiffNode>;
  syncs_added: Array<JourneyDiffSync>;
  syncs_changed: Array<JourneyDiffSync>;
  syncs_removed: Array<JourneyDiffSync>;
};

export type JourneyDiffEdge = {
  __typename?: 'JourneyDiffEdge';
  from_node_id: Scalars['String'];
  to_node_id: Scalars['String'];
};

export type JourneyDiffFieldChange = {
  __typename?: 'JourneyDiffFieldChange';
  from?: Maybe<Scalars['JSON']>;
  to?: Maybe<Scalars['JSON']>;
};

export type JourneyDiffNode = {
  __typename?: 'JourneyDiffNode';
  config_change?: Maybe<JourneyDiffFieldChange>;
  event_relationship_id_change?: Maybe<JourneyDiffFieldChange>;
  id: Scalars['String'];
  name: Scalars['String'];
  name_change?: Maybe<JourneyDiffFieldChange>;
  segment_id_change?: Maybe<JourneyDiffFieldChange>;
  type: Scalars['String'];
  type_change?: Maybe<JourneyDiffFieldChange>;
};

export type JourneyDiffSync = {
  __typename?: 'JourneyDiffSync';
  changes?: Maybe<Scalars['JSONObject']>;
  destination_instance_id?: Maybe<Scalars['String']>;
  exit_config?: Maybe<Scalars['JSONObject']>;
  mode?: Maybe<Scalars['String']>;
  node_id: Scalars['String'];
  placeholder_destination_id?: Maybe<Scalars['String']>;
};

export type JourneyGraph = {
  __typename?: 'JourneyGraph';
  edges: Array<Edge>;
  journey: Journey;
  nodes: Array<Node>;
};

export type JourneyGraphInput = {
  edges?: InputMaybe<Array<EdgeInput>>;
  journey: JourneyInput;
  nodes?: InputMaybe<Array<NodeInput>>;
};

export type JourneyInAppContentInput = {
  template_id: Scalars['String'];
  values: Scalars['JSONObject'];
};

export type JourneyInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  context_config?: InputMaybe<Scalars['JSONObject']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  exit_criteria?: InputMaybe<Scalars['JSONObject']>;
  force_remove_rows?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<NoteInput>>;
  reset?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  status?: InputMaybe<Scalars['String']>;
  version_id?: InputMaybe<Scalars['String']>;
};

export type JourneyMembership = {
  __typename?: 'JourneyMembership';
  entry_time: Scalars['String'];
  journey_id: Scalars['String'];
  journey_name: Scalars['String'];
  status: JourneyMembershipStatus;
  user_id: Scalars['String'];
};

export const JourneyMembershipStatus = {
  Completed: 'COMPLETED',
  Exited: 'EXITED',
  InProgress: 'IN_PROGRESS'
} as const;

export type JourneyMembershipStatus = typeof JourneyMembershipStatus[keyof typeof JourneyMembershipStatus];
export type JourneyMembershipsBackgroundResult = JourneyMembershipsResponse | ProfileExplorerError;

export type JourneyMembershipsResponse = {
  __typename?: 'JourneyMembershipsResponse';
  journeyMemberships: Array<JourneyMembership>;
  parentModelId: Scalars['String'];
};

export type JourneyMessageDynamicContentInput = {
  groups: Array<DynamicContentGroupInput>;
  placements: Array<DynamicContentPlacementInput>;
};

export type JourneyRun = {
  __typename?: 'JourneyRun';
  id: Scalars['String'];
  journey_id: Scalars['String'];
  simulation_id?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type JourneyTemplate = {
  __typename?: 'JourneyTemplate';
  description: Scalars['String'];
  exit_criteria?: Maybe<Scalars['JSONObject']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notes: Array<Note>;
  parent_model_id?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['JSONObject']>;
};

export type JourneyTemplateGraph = {
  __typename?: 'JourneyTemplateGraph';
  edges: Array<Edge>;
  journey: JourneyTemplate;
  nodes: Array<Node>;
};

export type JourneyTemplateInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  journeyGraph: JourneyGraphInput;
  name: Scalars['String'];
  parent_model_id?: InputMaybe<Scalars['String']>;
};

export type JourneyTrait = {
  __typename?: 'JourneyTrait';
  anchorNodeId?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  relationshipId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export const JourneyTraitAccumulatedState = {
  Drop: 'DROP',
  Keep: 'KEEP'
} as const;

export type JourneyTraitAccumulatedState = typeof JourneyTraitAccumulatedState[keyof typeof JourneyTraitAccumulatedState];
export type JourneysRatio = {
  __typename?: 'JourneysRatio';
  journeyId: Scalars['String'];
  ratio: Scalars['Float'];
};

export type KlaviyoConversionMetricsInput = {
  klaviyoDestinationId: Scalars['bigint'];
};

export type KlaviyoMetric = {
  __typename?: 'KlaviyoMetric';
  id: Scalars['String'];
  integrationName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LlmBackgroundJobAudienceConfigSummaryInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['bigint'];
  visualQueryFilter: Scalars['JSONObject'];
};

export type LlmBackgroundJobAudienceSummarySuccessResult = {
  __typename?: 'LLMBackgroundJobAudienceSummarySuccessResult';
  summary: Scalars['String'];
};

export type LlmBackgroundJobExistingAudienceSummaryInput = {
  segmentId: Scalars['bigint'];
};

export type LlmBackgroundJobFailure = {
  __typename?: 'LLMBackgroundJobFailure';
  error: Scalars['String'];
  type: LlmBackgroundJobStatus;
};

export type LlmBackgroundJobProcessing = {
  __typename?: 'LLMBackgroundJobProcessing';
  type: LlmBackgroundJobStatus;
};

export type LlmBackgroundJobResult = LlmBackgroundJobFailure | LlmBackgroundJobProcessing | LlmBackgroundJobSuccess;

export const LlmBackgroundJobStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type LlmBackgroundJobStatus = typeof LlmBackgroundJobStatus[keyof typeof LlmBackgroundJobStatus];
export type LlmBackgroundJobSuccess = {
  __typename?: 'LLMBackgroundJobSuccess';
  result: LlmBackgroundJobSuccessResult;
  type: LlmBackgroundJobStatus;
};

export type LlmBackgroundJobSuccessResult = LlmBackgroundJobAudienceSummarySuccessResult;

export const LlmBackgroundJobType = {
  AudienceConfigSummary: 'audience_config_summary',
  ExistingAudienceDetailedSummary: 'existing_audience_detailed_summary',
  ExistingAudienceSummary: 'existing_audience_summary'
} as const;

export type LlmBackgroundJobType = typeof LlmBackgroundJobType[keyof typeof LlmBackgroundJobType];
export type LlmChatInteraction = {
  __typename?: 'LLMChatInteraction';
  id: Scalars['uuid'];
  interactionContext?: Maybe<Scalars['JSONObject']>;
  messages: Array<ResponseMessage>;
  status: Scalars['String'];
};

export type LlmChatInteractionDetailsResponse = {
  __typename?: 'LLMChatInteractionDetailsResponse';
  cancelReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdByUser?: Maybe<SessionCreatedByUser>;
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  interactionContext?: Maybe<Scalars['JSONObject']>;
  messages: Array<ResponseMessage>;
  nextInteractionId?: Maybe<Scalars['uuid']>;
  progress: InteractionProgress;
  status: Scalars['String'];
};

export const LlmModel = {
  Gpt4o: 'gpt4o',
  O3: 'o3'
} as const;

export type LlmModel = typeof LlmModel[keyof typeof LlmModel];
export type LlmSessionContext = {
  __typename?: 'LLMSessionContext';
  context?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type LlmSessionContextInput = {
  context?: InputMaybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type LatestDashboardChartCardRuns = {
  __typename?: 'LatestDashboardChartCardRuns';
  chartCardRuns: Array<ChartCardRunData>;
  id?: Maybe<Scalars['uuid']>;
};

export type LatestSampledSegmentJob = {
  __typename?: 'LatestSampledSegmentJob';
  createdAt: Scalars['String'];
  finishedAt: Scalars['String'];
  jobId: Scalars['String'];
  result: LatestSampledSegmentJobResult;
  segmentId: Scalars['Int'];
  status: SampledSegmentJobStatus;
};

export type LatestSampledSegmentJobOutput = {
  __typename?: 'LatestSampledSegmentJobOutput';
  result: Array<LatestSampledSegmentJob>;
};

export type LatestSampledSegmentJobResult = {
  __typename?: 'LatestSampledSegmentJobResult';
  error?: Maybe<Scalars['String']>;
  sampledRowCount?: Maybe<Scalars['String']>;
  totalRowCount?: Maybe<Scalars['String']>;
};

export type LaunchAdsInput = {
  adConfigs: Array<AdLaunchConfigInput>;
  facebookDestinationId: Scalars['String'];
  metaAccountId: Scalars['String'];
  metaAdsetId: Scalars['String'];
  metaAdsetName?: InputMaybe<Scalars['String']>;
  metaCampaignId: Scalars['String'];
  metaCampaignName?: InputMaybe<Scalars['String']>;
  metaInstagramActorId?: InputMaybe<Scalars['String']>;
  metaPageId: Scalars['String'];
  queuedAdIds: Array<Scalars['uuid']>;
  /**
   * Use the Facebook Page as the Instagram identity (a page-backed Instagram
   * account, created on first use). Mutually exclusive with
   * metaInstagramActorId. Requires the workspace's page-backed Instagram flag
   * and a destination token that carries the page scopes.
   */
  useFacebookPageAsInstagramIdentity?: InputMaybe<Scalars['Boolean']>;
};

export type LaunchAdsResponse = {
  __typename?: 'LaunchAdsResponse';
  failed: Array<LaunchError>;
  failureCount: Scalars['Int'];
  successCount: Scalars['Int'];
  successful: Array<LaunchSuccess>;
  totalCount: Scalars['Int'];
};

export type LaunchError = {
  __typename?: 'LaunchError';
  adName: Scalars['String'];
  errorMessage: Scalars['String'];
  queuedAdId: Scalars['uuid'];
};

export type LaunchSuccess = {
  __typename?: 'LaunchSuccess';
  id: Scalars['uuid'];
  launchedAt: Scalars['String'];
  metaAdId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type LaunchesActiveCriteria = {
  __typename?: 'LaunchesActiveCriteria';
  entityId: Scalars['ID'];
  versionId: Scalars['ID'];
};

export type LaunchesAdItem = {
  __typename?: 'LaunchesAdItem';
  adId: Scalars['String'];
  channel: Scalars['String'];
};

export type LaunchesCampaignItem = {
  __typename?: 'LaunchesCampaignItem';
  campaignId: Scalars['String'];
  channel: Scalars['String'];
};

export type LaunchesConceptItem = {
  __typename?: 'LaunchesConceptItem';
  /** Null when the concept is judged across all channels. */
  channel?: Maybe<Scalars['String']>;
  tags: Array<LaunchesConceptTag>;
};

export type LaunchesConceptTag = {
  __typename?: 'LaunchesConceptTag';
  member: Scalars['String'];
  /** Null when the concept's ads are untagged on this member. */
  value?: Maybe<Scalars['String']>;
};

export type LaunchesCoverage = {
  __typename?: 'LaunchesCoverage';
  judgedAds: Scalars['Int'];
  judgedCampaigns: Scalars['Int'];
  launchedAds: Scalars['Int'];
  launchedCampaigns: Scalars['Int'];
};

export type LaunchesCriterionJudgment = {
  __typename?: 'LaunchesCriterionJudgment';
  criterion: Scalars['String'];
  judgment: LaunchesJudgment;
};

export type LaunchesItem = LaunchesAdItem | LaunchesCampaignItem | LaunchesConceptItem;

export type LaunchesJudgedCriteria = {
  __typename?: 'LaunchesJudgedCriteria';
  entityId: Scalars['ID'];
  /** Whether the doc has not been edited since this run judged by it. */
  isCurrentVersion: Scalars['Boolean'];
  markdown: Scalars['String'];
  versionId: Scalars['ID'];
};

export type LaunchesJudgment = {
  __typename?: 'LaunchesJudgment';
  bucket: LaunchesVerdictBucket;
  /** The status name from the winner criteria. */
  label: Scalars['String'];
  reason: Scalars['String'];
};

export type LaunchesRun = {
  __typename?: 'LaunchesRun';
  coverage?: Maybe<LaunchesCoverage>;
  /** The criteria version this run judged by; null only if it can no longer be read. */
  criteria?: Maybe<LaunchesJudgedCriteria>;
  finishedAt: Scalars['String'];
  id: Scalars['ID'];
  /** Null when the run saved no verdicts. */
  judged?: Maybe<LaunchesRunJudged>;
  /** The days this run judged. */
  window: LaunchesWindow;
};

export type LaunchesRunJudged = {
  __typename?: 'LaunchesRunJudged';
  /** The tag dimensions that define a concept in this run. */
  conceptMembers: Array<Scalars['String']>;
  verdicts: Array<LaunchesVerdict>;
};

export type LaunchesState = {
  __typename?: 'LaunchesState';
  /** The criteria the next run judges by, or null when no usable winner criteria doc is active. */
  activeCriteria?: Maybe<LaunchesActiveCriteria>;
  /** Set when the newest finished run failed, after latestRun. */
  lastFailedRunAt?: Maybe<Scalars['String']>;
  /** The latest run that finished without an error. */
  latestRun?: Maybe<LaunchesRun>;
  /** A run is queued, handed to the agent, or running. */
  pendingRun: Scalars['Boolean'];
};

export type LaunchesVerdict = {
  __typename?: 'LaunchesVerdict';
  criteria: Array<LaunchesCriterionJudgment>;
  item: LaunchesItem;
  /** Identifies the item within its run. */
  key: Scalars['String'];
  overall: LaunchesJudgment;
};

export const LaunchesVerdictBucket = {
  Learning: 'learning',
  OnPar: 'on_par',
  Underperforming: 'underperforming',
  Winner: 'winner'
} as const;

export type LaunchesVerdictBucket = typeof LaunchesVerdictBucket[keyof typeof LaunchesVerdictBucket];
export type LaunchesWindow = {
  __typename?: 'LaunchesWindow';
  from: Scalars['String'];
  to: Scalars['String'];
};

/**
 * Channels a copy artifact can compile to. Email lives in the sibling
 * content-email schema and never reaches these operations.
 */
export const LcmMessageChannel = {
  Push: 'push',
  Sms: 'sms'
} as const;

export type LcmMessageChannel = typeof LcmMessageChannel[keyof typeof LcmMessageChannel];
export type LibraryImage = {
  __typename?: 'LibraryImage';
  agent_description?: Maybe<Scalars['String']>;
  alt_text?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_user?: Maybe<LibraryImageUser>;
  description?: Maybe<Scalars['String']>;
  external_public_url?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  legacy_content_image_id?: Maybe<Scalars['uuid']>;
  mime_type: Scalars['String'];
  name: Scalars['String'];
  presigned_url: LibraryImageUrl;
  size_bytes?: Maybe<Scalars['Float']>;
  source_node_id?: Maybe<Scalars['uuid']>;
  source_type: Scalars['String'];
  tags: Array<LibraryImageTag>;
  updated_at: Scalars['timestamptz'];
  width?: Maybe<Scalars['Int']>;
};


export type LibraryImagePresignedUrlArgs = {
  input?: InputMaybe<LibraryImageUrlInput>;
};

export type LibraryImageAggregate = {
  __typename?: 'LibraryImageAggregate';
  aggregate: LibraryImageCount;
};

export type LibraryImageCount = {
  __typename?: 'LibraryImageCount';
  count: Scalars['Int'];
};

export type LibraryImageGroupCount = {
  __typename?: 'LibraryImageGroupCount';
  asset_group_id?: Maybe<Scalars['uuid']>;
  count: Scalars['Int'];
};

export type LibraryImageTag = {
  __typename?: 'LibraryImageTag';
  agent_value?: Maybe<Scalars['String']>;
  tag: LibraryTag;
  value?: Maybe<Scalars['String']>;
};

export type LibraryImageTagFilter = {
  _or?: InputMaybe<Array<LibraryImageTagFilter>>;
  agent_value?: InputMaybe<LibraryStringFilter>;
  tag?: InputMaybe<LibraryTagDefinitionFilter>;
  value?: InputMaybe<LibraryStringFilter>;
};

export type LibraryImageTagInput = {
  content_image_id: Scalars['uuid'];
  content_tag_id: Scalars['uuid'];
  created_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

export type LibraryImageUrl = {
  __typename?: 'LibraryImageUrl';
  url: Scalars['String'];
};

export type LibraryImageUrlInput = {
  contentDisposition?: InputMaybe<Scalars['String']>;
  expireSeconds?: InputMaybe<Scalars['Int']>;
};

export type LibraryImageUser = {
  __typename?: 'LibraryImageUser';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type LibraryImagesFilter = {
  _and?: InputMaybe<Array<LibraryImagesFilter>>;
  asset_group_id?: InputMaybe<LibraryStringFilter>;
  id?: InputMaybe<LibraryStringFilter>;
  name?: InputMaybe<LibraryNameFilter>;
  source_type?: InputMaybe<LibraryStringFilter>;
  tags?: InputMaybe<LibraryImageTagFilter>;
};

export type LibraryMutationResult = {
  __typename?: 'LibraryMutationResult';
  affected_rows: Scalars['Int'];
};

export type LibraryNameFilter = {
  _eq?: InputMaybe<Scalars['String']>;
  /** A case-insensitive LIKE pattern. The caller escapes % and _. */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
};

export type LibraryStringFilter = {
  _eq?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
};

export type LibraryTag = {
  __typename?: 'LibraryTag';
  /** The collection the tag applies to. Null applies to every collection. */
  asset_group_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** Null when the tag has no fixed list of values. */
  possible_values?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

export type LibraryTagDefinitionFilter = {
  /** Accepts _eq only. When set, name is ignored. */
  id?: InputMaybe<LibraryStringFilter>;
  /** Tag names are not unique; prefer id. Accepts _eq only. */
  name?: InputMaybe<LibraryStringFilter>;
};

export type LibraryTagInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  possible_values?: InputMaybe<Array<Scalars['String']>>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

export type LibraryTagInsertResult = {
  __typename?: 'LibraryTagInsertResult';
  returning: Array<LibraryTag>;
};

export type LiftStats = {
  __typename?: 'LiftStats';
  confidenceInterval?: Maybe<ConfidenceInterval>;
  value: Scalars['Float'];
};

export type LineageDependentRow = {
  __typename?: 'LineageDependentRow';
  /** Exact number of resources that directly depend on this row's resource. */
  directDependentCount: Scalars['Int'];
  edgeType: Scalars['String'];
  node: LineageNode;
};

export type LineageDependentsPage = {
  __typename?: 'LineageDependentsPage';
  pageInfo: LineagePageInfo;
  partitions: Array<LineagePartitionDiagnostics>;
  rows?: Maybe<Array<LineageDependentRow>>;
  snapshotToken?: Maybe<Scalars['String']>;
  status: LineageStatus;
  timings: LineageRequestTimings;
};

export type LineageEdge = {
  __typename?: 'LineageEdge';
  edgeType: Scalars['String'];
  fromNodeId: Scalars['String'];
  id: Scalars['String'];
  toNodeId: Scalars['String'];
};

export type LineageGraphResult = {
  __typename?: 'LineageGraphResult';
  /** Number of distinct edges in this page, not the whole graph. */
  edgeCount?: Maybe<Scalars['Int']>;
  edges?: Maybe<Array<LineageEdge>>;
  /** Number of distinct endpoint nodes in this page, not the whole graph. */
  nodeCount?: Maybe<Scalars['Int']>;
  /**
   * Nodes at the endpoints of this page's edges. A node can appear on multiple
   * pages, so callers should deduplicate nodes by ID.
   */
  nodes?: Maybe<Array<LineageNode>>;
  pageInfo: LineagePageInfo;
  partitions: Array<LineagePartitionDiagnostics>;
  status: LineageStatus;
  timings: LineageRequestTimings;
};

export type LineageMarkDirtyResult = {
  __typename?: 'LineageMarkDirtyResult';
  markedCount: Scalars['Int'];
  ownerResourceTypes: Array<Scalars['String']>;
};

export type LineageNode = {
  __typename?: 'LineageNode';
  exists: Scalars['Boolean'];
  id: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  /**
   * The identifiers needed to build a link to this resource. Null when the type,
   * kind, and resource ID are enough, or when the resource is gone.
   */
  locationData?: Maybe<LineageNodeLocationData>;
  /**
   * Display name of the resource. Null when the resource has no name of its own
   * or no longer exists.
   */
  name?: Maybe<Scalars['String']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type LineageNodeLocationData = {
  __typename?: 'LineageNodeLocationData';
  /** The channel that owns the resource, for resources edited in its drawer. */
  channelId?: Maybe<Scalars['String']>;
  /**
   * A flow that uses the resource, for resources edited on flow-scoped pages.
   * One representative when several flows share it.
   */
  flowId?: Maybe<Scalars['String']>;
  /**
   * The model a column belongs to, the model a relationship starts from, or
   * the parent model a subset filters.
   */
  modelId?: Maybe<Scalars['String']>;
  /** The source that owns the model, for resources that live under a source. */
  sourceId?: Maybe<Scalars['String']>;
  /** The subset group a subset value belongs to. Its page lives under the group. */
  subsetGroupId?: Maybe<Scalars['String']>;
};

export type LineagePageInfo = {
  __typename?: 'LineagePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type LineagePartitionDiagnostics = {
  __typename?: 'LineagePartitionDiagnostics';
  hasActiveJob: Scalars['Boolean'];
  isDirty: Scalars['Boolean'];
  ownerResourceType: Scalars['String'];
  reason: Scalars['String'];
  requiredExtractorVersion: Scalars['Int'];
  snapshotCompletedAt?: Maybe<Scalars['String']>;
  snapshotId?: Maybe<Scalars['String']>;
  snapshotStartedAt?: Maybe<Scalars['String']>;
  stats?: Maybe<LineagePartitionStats>;
  status: LineageStatus;
  storedExtractorVersion?: Maybe<Scalars['Int']>;
};

export type LineagePartitionStats = {
  __typename?: 'LineagePartitionStats';
  directEdgesEmitted: Scalars['Int'];
  durationMs: Scalars['Int'];
  edgesInserted: Scalars['Int'];
  extractorVersion: Scalars['Int'];
  heapUsedDeltaMB: Scalars['Float'];
  heapUsedPeakMB: Scalars['Float'];
  heapUsedStartMB: Scalars['Float'];
  ownerResourceType: Scalars['String'];
  pages: Scalars['Int'];
  rowsScanned: Scalars['Int'];
  sinkDurationMs: Scalars['Int'];
  structuralEdgesEmitted: Scalars['Int'];
  workspaceId: Scalars['Int'];
};

export type LineageRequestTimings = {
  __typename?: 'LineageRequestTimings';
  classificationMs: Scalars['Int'];
  hydrationMs: Scalars['Int'];
  traversalMs: Scalars['Int'];
};

export type LineageResourceDependentCounts = {
  __typename?: 'LineageResourceDependentCounts';
  directDependents: Scalars['Int'];
  indirectDependents: Scalars['Int'];
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type LineageResourceDependentCountsResult = {
  __typename?: 'LineageResourceDependentCountsResult';
  counts?: Maybe<Array<LineageResourceDependentCounts>>;
  partitions: Array<LineagePartitionDiagnostics>;
  snapshotToken?: Maybe<Scalars['String']>;
  status: LineageStatus;
  timings: LineageRequestTimings;
};

/** A lineage resource reference. */
export type LineageResourceRef = {
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type LineageResourceStats = {
  __typename?: 'LineageResourceStats';
  /** Distinct dependents per resource type across the whole subtree. */
  dependentCountsByType?: Maybe<Array<LineageTypeCount>>;
  directDependencies?: Maybe<Scalars['Int']>;
  directDependents?: Maybe<Scalars['Int']>;
  indirectDependencies?: Maybe<Scalars['Int']>;
  indirectDependents?: Maybe<Scalars['Int']>;
  /**
   * Whole-graph freshness, not just this resource. Every count is null until a
   * snapshot is readable.
   */
  status: LineageStatus;
};

export const LineageStatus = {
  Failed: 'FAILED',
  Ready: 'READY',
  Rebuilding: 'REBUILDING'
} as const;

export type LineageStatus = typeof LineageStatus[keyof typeof LineageStatus];
export type LineageTypeCount = {
  __typename?: 'LineageTypeCount';
  count: Scalars['Int'];
  resourceType: Scalars['String'];
};

export type LinkAsanaTaskInput = {
  campaignId: Scalars['ID'];
  /** A task URL pasted from Asana, in any of the shapes Asana produces. */
  taskUrl: Scalars['String'];
};

export type LinkClickRow = {
  __typename?: 'LinkClickRow';
  index: Scalars['Int'];
  rate: Scalars['Float'];
  totalClicks: Scalars['Int'];
  uniqueClickers: Scalars['Int'];
  url: Scalars['String'];
};

export type LinkConnectionsResponse = {
  __typename?: 'LinkConnectionsResponse';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<DeploymentFailureReasons>;
  success: Scalars['Boolean'];
};

export type LinkDestinationsResponse = {
  __typename?: 'LinkDestinationsResponse';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<DeploymentFailureReasons>;
  success: Scalars['Boolean'];
};

export type LinkExistingContentEmailResult = {
  __typename?: 'LinkExistingContentEmailResult';
  contentEmailId: Scalars['uuid'];
  /**
   * Null when the email has no version yet (freshly generating); publish is
   * rejected until a version exists.
   */
  contentEmailVersionId?: Maybe<Scalars['uuid']>;
  messageContentsId: Scalars['uuid'];
  sessionId: Scalars['String'];
};

export type LinkToAdBriefAssetInput = {
  assetId: Scalars['String'];
  channelSizeId?: InputMaybe<Scalars['String']>;
};

export type LinkToNdMessageInput = {
  messageId: Scalars['uuid'];
};

export type LinkableResource = {
  __typename?: 'LinkableResource';
  existing_link?: Maybe<ResourceLink>;
  id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  workspace: ResourceLinkWorkspace;
};

export type ListAllSourceDependenciesResult = {
  __typename?: 'ListAllSourceDependenciesResult';
  sources: Array<Maybe<ListAllSourceDependenciesResultObject>>;
};

export type ListAllSourceDependenciesResultObject = {
  __typename?: 'ListAllSourceDependenciesResultObject';
  dependencies: ListSourceDependenciesResult;
  id: Scalars['String'];
};

export type ListAllTraitReferencesResultV2 = {
  __typename?: 'ListAllTraitReferencesResultV2';
  audiences: Array<Scalars['String']>;
  traitEnrichments: Array<TraitEnrichmentReference>;
};

export type ListAvailableThroughRelationshipsOutput = {
  __typename?: 'ListAvailableThroughRelationshipsOutput';
  throughRelationships: Array<ThroughRelationship>;
};

export type ListCepMessageDevicePreviewClientsResult = {
  __typename?: 'ListCepMessageDevicePreviewClientsResult';
  clients: Array<CepMessageDevicePreviewClient>;
};

export type ListFoldersOutput = {
  __typename?: 'ListFoldersOutput';
  audienceCount: Scalars['Int'];
  decisioningCount: Scalars['Int'];
  folders: Array<Folder>;
  journeyCount: Scalars['Int'];
  modelCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ListRelationshipsOutput = {
  __typename?: 'ListRelationshipsOutput';
  relationships: Array<Relationship>;
};

export type ListSemanticViewsResult = {
  __typename?: 'ListSemanticViewsResult';
  /** Empty when the source's role sees no semantic-layer views. */
  views: Array<SemanticViewSummary>;
};

export type ListSourceDependenciesResult = {
  __typename?: 'ListSourceDependenciesResult';
  audiences: Array<Maybe<SourceAudienceDependencyReference>>;
  blockers: Array<SourceDeleteBlocker>;
  models: Array<Maybe<SourceModelDependencyReference>>;
  syncs: Array<Maybe<SourceSyncDependencyReference>>;
};

export type LiveSourceEvent = {
  __typename?: 'LiveSourceEvent';
  id: Scalars['String'];
  payload: Scalars['JSONObject'];
  rateLimitIgnoredCount: Scalars['Int'];
  validation: LiveSourceEventValidation;
};

export type LiveSourceEventSchemaViolation = {
  __typename?: 'LiveSourceEventSchemaViolation';
  dataPath?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  schemaPath?: Maybe<Scalars['String']>;
  undeclaredField?: Maybe<Scalars['String']>;
};

export type LiveSourceEventValidation = {
  __typename?: 'LiveSourceEventValidation';
  blockReasons?: Maybe<Array<Scalars['String']>>;
  isBlockedViolation?: Maybe<Scalars['Boolean']>;
  violations: Array<LiveSourceEventSchemaViolation>;
};

export type LiveSourceEvents = {
  __typename?: 'LiveSourceEvents';
  events: Array<LiveSourceEvent>;
  latestEventId?: Maybe<Scalars['String']>;
  numEvents: Scalars['Int'];
};

export type LiveSourceEventsInput = {
  lastSeenEventId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};

export type LlmInferenceBackend = {
  __typename?: 'LlmInferenceBackend';
  config: Scalars['JSONObject'];
  createdAt: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  provider: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type LocalEmailTemplateInput = {
  html: Scalars['String'];
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type LocaleDeliverabilityStats = {
  __typename?: 'LocaleDeliverabilityStats';
  clicked: Scalars['Int'];
  /** The registered cep_locales spelling, or the stamped one for a locale no longer registered. Null for sends that carry no locale (Unknown). */
  locale?: Maybe<Scalars['String']>;
  opened: Scalars['Int'];
  /** Sent (recipient, message) pairs, like MessageDeliverabilityStats.sent. A recipient sent in two locales counts in both rows. */
  sent: Scalars['Int'];
};

export type LogoFileUploadResponse = {
  __typename?: 'LogoFileUploadResponse';
  /** Stable id for the brand_profiles.logos entry the client writes. */
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  /** Media type of the file served at publicUrl. */
  mimeType: Scalars['String'];
  /** Unauthenticated URL for email recipients; SVGs are served as PNG. */
  publicUrl: Scalars['String'];
  sizeBytes: Scalars['Int'];
  storageKey: Scalars['String'];
};

export type LookerConfig = {
  __typename?: 'LookerConfig';
  client_id: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['bigint'];
  tunnel_id?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type LookerCredentialsInput = {
  client_id: Scalars['String'];
  client_secret: Scalars['String'];
  id?: InputMaybe<Scalars['bigint']>;
  tunnel_id?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type LookerLook = {
  __typename?: 'LookerLook';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sql?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export const ManifestDayRemovalMode = {
  /** Keep the day with an empty file list so the seeder re-fetches it */
  Reseed: 'reseed',
  /** Delete the day key entirely — the day will not be re-cached */
  Skip: 'skip'
} as const;

export type ManifestDayRemovalMode = typeof ManifestDayRemovalMode[keyof typeof ManifestDayRemovalMode];
export type ManifestFileVerification = {
  __typename?: 'ManifestFileVerification';
  day: Scalars['String'];
  exists: Scalars['Boolean'];
  fileLocation: Scalars['String'];
  numRows?: Maybe<Scalars['Int']>;
};

export type ManuallyEnqueuePredictiveTraitsJobError = {
  __typename?: 'ManuallyEnqueuePredictiveTraitsJobError';
  error: Scalars['String'];
};

export type ManuallyEnqueuePredictiveTraitsJobInput = {
  cacheEventPullId?: InputMaybe<Scalars['uuid']>;
  endDate?: InputMaybe<Scalars['String']>;
  jobType: PredictiveTraitsJobTypeEnum;
  predictorArtifactId?: InputMaybe<Scalars['uuid']>;
  predictorId?: InputMaybe<Scalars['uuid']>;
  startDate?: InputMaybe<Scalars['String']>;
  trainingMatrixEndDate?: InputMaybe<Scalars['String']>;
};

export type ManuallyEnqueuePredictiveTraitsJobResult = ManuallyEnqueuePredictiveTraitsJobError | ManuallyEnqueuePredictiveTraitsJobSuccess;

export type ManuallyEnqueuePredictiveTraitsJobSuccess = {
  __typename?: 'ManuallyEnqueuePredictiveTraitsJobSuccess';
  jobId: Scalars['String'];
  message: Scalars['String'];
  predictorRunId: Scalars['uuid'];
};

export type MarketingDestination = {
  __typename?: 'MarketingDestination';
  id: Scalars['bigint'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export const MatchBoosterRegion = {
  Eu: 'eu',
  Us: 'us'
} as const;

export type MatchBoosterRegion = typeof MatchBoosterRegion[keyof typeof MatchBoosterRegion];
export type MatchBoosterTest = {
  __typename?: 'MatchBoosterTest';
  finished_at?: Maybe<Scalars['String']>;
  folder_id: Scalars['String'];
  last_checked_at: Scalars['String'];
  started_at: Scalars['String'];
  status: Scalars['String'];
};

export type MatchboostingIdentifier = {
  __typename?: 'MatchboostingIdentifier';
  alias: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
};

export type Member = {
  __typename?: 'Member';
  primaryKeyValue: Scalars['String'];
  primaryLabelValue?: Maybe<Scalars['String']>;
  secondaryLabelValue?: Maybe<Scalars['String']>;
};

export type MergeTagColumn = {
  __typename?: 'MergeTagColumn';
  column_reference: Scalars['JSONObject'];
  column_type: Scalars['String'];
  display_name: Scalars['String'];
  effective_privacy_level?: Maybe<Scalars['String']>;
  group_label: Scalars['String'];
  is_realtime_trait?: Maybe<Scalars['Boolean']>;
  template_key: Scalars['String'];
  top_k_enabled?: Maybe<Scalars['Boolean']>;
};

export type MergedSyncRequestDuration = {
  __typename?: 'MergedSyncRequestDuration';
  self: Scalars['Float'];
  total: Scalars['Float'];
};

export type MergedSyncRequestError = {
  __typename?: 'MergedSyncRequestError';
  errorCodeDetail?: Maybe<ErrorCodeDetails>;
  errorInfo?: Maybe<Scalars['JSONObject']>;
  message: Scalars['String'];
  timestamp?: Maybe<Scalars['UnixEpochTimestamp']>;
};

export type MergedSyncRequestEvent = {
  __typename?: 'MergedSyncRequestEvent';
  durationMillis: MergedSyncRequestDuration;
  endTime?: Maybe<Scalars['UnixEpochTimestamp']>;
  errors: Array<MergedSyncRequestError>;
  span: MergedSyncRequestEventSpan;
  startTime?: Maybe<Scalars['UnixEpochTimestamp']>;
  status: MergedSyncRequestEventStatus;
};

export const MergedSyncRequestEventSpan = {
  Cdc: 'cdc',
  ExecuteDestination: 'execute_destination',
  ExecuteQuery: 'execute_query',
  GeneratePlan: 'generate_plan',
  LoadEnrichmentData: 'load_enrichment_data',
  PlanProduction: 'plan_production',
  Prepare: 'prepare',
  PrepareDestination: 'prepare_destination',
  PrepareQuery: 'prepare_query',
  Queue: 'queue',
  Report: 'report',
  Sync: 'sync'
} as const;

export type MergedSyncRequestEventSpan = typeof MergedSyncRequestEventSpan[keyof typeof MergedSyncRequestEventSpan];
export const MergedSyncRequestEventStatus = {
  Active: 'Active',
  Completed: 'Completed',
  Failed: 'Failed',
  NotStarted: 'NotStarted'
} as const;

export type MergedSyncRequestEventStatus = typeof MergedSyncRequestEventStatus[keyof typeof MergedSyncRequestEventStatus];
export type Message = {
  __typename?: 'Message';
  /** Brand the message belongs to. Null when no message row matches the event. */
  brandId?: Maybe<Scalars['String']>;
  channel: Scalars['String'];
  from: MessageFrom;
  html?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Push-only: rich notification image URL from the sent payload */
  imageUrl?: Maybe<Scalars['String']>;
  messageExecutionId: Scalars['String'];
  name: Scalars['String'];
  preheader?: Maybe<Scalars['String']>;
  /** True when the rendered payload belonged to a different recipient; content is withheld. */
  renderedContentMismatch: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
  timeline: Array<TimelineStep>;
  triggeredAt: Scalars['String'];
  /** WhatsApp-only: the message as the recipient saw it, in the template editor's shape */
  whatsappContent?: Maybe<Scalars['JSONObject']>;
};

export type MessageAbTestArm = {
  __typename?: 'MessageAbTestArm';
  contentId: Scalars['uuid'];
  id: Scalars['uuid'];
  variantKey: Scalars['String'];
};

export type MessageAbTestPrimaryMetricInput = {
  direction?: InputMaybe<Scalars['String']>;
  goalDefinition: Scalars['JSONObject'];
};

export type MessageAbTestResults = {
  __typename?: 'MessageAbTestResults';
  campaignRunId?: Maybe<Scalars['uuid']>;
  experimentId: Scalars['uuid'];
  isStale?: Maybe<Scalars['Boolean']>;
  lastRanAt?: Maybe<Scalars['String']>;
  pendingChartCardRunId?: Maybe<Scalars['uuid']>;
  status: MessageAbTestResultsStatus;
  variants: Array<MessageAbTestVariantResult>;
};

export const MessageAbTestResultsStatus = {
  AwaitingFirstRun: 'AWAITING_FIRST_RUN',
  Computing: 'COMPUTING',
  NoSendYet: 'NO_SEND_YET',
  Ready: 'READY'
} as const;

export type MessageAbTestResultsStatus = typeof MessageAbTestResultsStatus[keyof typeof MessageAbTestResultsStatus];
export type MessageAbTestVariantMetric = {
  __typename?: 'MessageAbTestVariantMetric';
  eventModelId?: Maybe<Scalars['String']>;
  /** Whether this metric is the experiment's configured primary metric. */
  isPrimary: Scalars['Boolean'];
  /**
   * cep_managed_models.type, e.g. "email_opened". The stable key for display
   * labels ("Open rate"); null for custom (non-managed) event models.
   */
  managedModelType?: Maybe<Scalars['String']>;
  /** The event model's segment name, e.g. "Email opened". */
  name?: Maybe<Scalars['String']>;
  /**
   * value / cohort size. Use this for rate columns — never derive a rate from
   * the baseline-normalized summaryStats value.
   */
  rate?: Maybe<Scalars['Float']>;
  /** Raw metric total for the arm's own cohort (summaryStats rawValue). */
  value?: Maybe<Scalars['Float']>;
};

export type MessageAbTestVariantResult = {
  __typename?: 'MessageAbTestVariantResult';
  delivered: Scalars['Int'];
  metrics: Array<MessageAbTestVariantMetric>;
  /**
   * Unique users sent / delivered, live from the warehouse event tables —
   * scoped to the requested campaign run, or the whole experiment history when
   * no run was supplied.
   */
  recipients: Scalars['Int'];
  variantKey: Scalars['String'];
};

export type MessageActivity = {
  __typename?: 'MessageActivity';
  brandId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  channelType: Scalars['String'];
  eventLabel: Scalars['String'];
  eventType: Scalars['String'];
  journeyId?: Maybe<Scalars['String']>;
  journeyName?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  messageName?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
};

export type MessageActivityResponse = {
  __typename?: 'MessageActivityResponse';
  events: Array<MessageActivity>;
  totalCount: Scalars['Int'];
};

export type MessageAggregations = {
  __typename?: 'MessageAggregations';
  actionFeatureBreakdowns: Array<ActionFeatureBreakdowns>;
  messageId: Scalars['String'];
  numUsersInAudienceEligible: Scalars['Int'];
  sendShareLast7Days: Scalars['Float'];
  sendsByDay: Array<SendsByDay>;
  skippedSendsByDay: Array<SendsByDay>;
  totalSends: Scalars['Int'];
  totalSendsForUsersInAudience: Scalars['Int'];
  totalSkippedSends: Scalars['Int'];
  totalUniqueUsersSkippedSends: Scalars['Int'];
  uniqueUsersInAudienceWithSend: Scalars['Int'];
  uniqueUsersSkippedSendsByDay: Array<SendsByDay>;
};

export type MessageComponentInput = {
  componentType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MessageConfig = {
  __typename?: 'MessageConfig';
  cep_whatsapp_template_id?: Maybe<Scalars['String']>;
  channel_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  editor_state?: Maybe<Scalars['JSONObject']>;
  experiments?: Maybe<Array<MessageExperiment>>;
  from_email?: Maybe<Scalars['String']>;
  from_name?: Maybe<Scalars['String']>;
  measurement_config?: Maybe<Scalars['JSONObject']>;
  message_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings?: Maybe<Scalars['JSON']>;
  rendered_output?: Maybe<Scalars['JSONObject']>;
  reply_to_email?: Maybe<Scalars['String']>;
  reply_to_name?: Maybe<Scalars['String']>;
  send_gates?: Maybe<Scalars['JSONObject']>;
  sender_identity_id?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subscription_topic?: Maybe<Scalars['String']>;
  subscription_topic_id?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSONObject']>;
  transactional?: Maybe<Scalars['Boolean']>;
  whatsapp_category?: Maybe<Scalars['String']>;
};

export type MessageConfigInput = {
  cep_brand_id?: InputMaybe<Scalars['String']>;
  cep_device_preview_id?: InputMaybe<Scalars['String']>;
  cep_whatsapp_template_id?: InputMaybe<Scalars['String']>;
  channel_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dynamic_content?: InputMaybe<JourneyMessageDynamicContentInput>;
  editor_state?: InputMaybe<Scalars['JSONObject']>;
  experiments?: InputMaybe<Array<MessageExperimentInput>>;
  from_email?: InputMaybe<Scalars['String']>;
  from_name?: InputMaybe<Scalars['String']>;
  inapp_content?: InputMaybe<JourneyInAppContentInput>;
  localization?: InputMaybe<MessageLocalizationInput>;
  measurement_config?: InputMaybe<Scalars['JSONObject']>;
  message_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['JSON']>;
  push_app_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  push_config?: InputMaybe<Scalars['JSONObject']>;
  rendered_output?: InputMaybe<Scalars['JSONObject']>;
  reply_to_email?: InputMaybe<Scalars['String']>;
  reply_to_name?: InputMaybe<Scalars['String']>;
  send_gates?: InputMaybe<Scalars['JSONObject']>;
  sender_identity_id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  subscription_topic?: InputMaybe<Scalars['String']>;
  subscription_topic_id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
  whatsapp_category?: InputMaybe<Scalars['String']>;
  whatsapp_localization_source_template_id?: InputMaybe<Scalars['String']>;
};

export type MessageContactInfo = {
  __typename?: 'MessageContactInfo';
  devices: Array<Device>;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type MessageDeliverabilityStats = {
  __typename?: 'MessageDeliverabilityStats';
  bounced: Scalars['Int'];
  clicked: Scalars['Int'];
  delivered: Scalars['Int'];
  messageId: Scalars['String'];
  messageName: Scalars['String'];
  opened: Scalars['Int'];
  sendFailed: Scalars['Int'];
  sent: Scalars['Int'];
  sentUnique: Scalars['Int'];
  skipped: Scalars['Int'];
  spamReported: Scalars['Int'];
  subscribed: Scalars['Int'];
  triggerId?: Maybe<Scalars['String']>;
  triggerName?: Maybe<Scalars['String']>;
  triggerType?: Maybe<Scalars['String']>;
  unsubscribed: Scalars['Int'];
};

/**
 * How a compiled message is delivered. Narrower than the email schema's
 * ContentDeploymentDeliveryType: SMS/push has no message-scoped AI Decisioning
 * path, so ai_decisioning is absent rather than accepted-then-rejected.
 */
export const MessageDeliveryType = {
  EspOrchestrated: 'esp_orchestrated',
  TriggerSync: 'trigger_sync'
} as const;

export type MessageDeliveryType = typeof MessageDeliveryType[keyof typeof MessageDeliveryType];
export type MessageEngagement = {
  __typename?: 'MessageEngagement';
  channels: Array<ChannelEngagement>;
  failureRate?: Maybe<Scalars['String']>;
  totalReceived: Scalars['Int'];
};

export type MessageExperiment = {
  __typename?: 'MessageExperiment';
  arms: Array<MessageExperimentArm>;
  element: Scalars['String'];
  measurement_config?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  primary_metric?: Maybe<MessageExperimentPrimaryMetric>;
  secondary_metrics?: Maybe<Array<MessageExperimentPrimaryMetric>>;
};

export type MessageExperimentArm = {
  __typename?: 'MessageExperimentArm';
  editor_state?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings?: Maybe<Scalars['JSON']>;
  rendered_output?: Maybe<Scalars['JSONObject']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['String']>;
  variant_key: Scalars['String'];
};

export type MessageExperimentArmInput = {
  editor_state?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['JSON']>;
  rendered_output?: InputMaybe<Scalars['JSONObject']>;
  subject?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['String']>;
  variant_key: Scalars['String'];
};

export type MessageExperimentInput = {
  arms: Array<MessageExperimentArmInput>;
  element: Scalars['String'];
  measurement_config?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  primary_metric?: InputMaybe<MessageExperimentPrimaryMetricInput>;
  secondary_metrics?: InputMaybe<Array<MessageExperimentPrimaryMetricInput>>;
};

export type MessageExperimentPrimaryMetric = {
  __typename?: 'MessageExperimentPrimaryMetric';
  direction?: Maybe<Scalars['String']>;
  goal_definition?: Maybe<Scalars['JSONObject']>;
};

export type MessageExperimentPrimaryMetricInput = {
  direction?: InputMaybe<Scalars['String']>;
  goal_definition?: InputMaybe<Scalars['JSONObject']>;
};

export type MessageFrom = {
  __typename?: 'MessageFrom';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type MessageHourlyStatsBatch = {
  __typename?: 'MessageHourlyStatsBatch';
  hourly: Array<MessageHourlyVolumeEntry>;
  messageId: Scalars['String'];
  totalSent: Scalars['Int'];
};

export type MessageHourlyVolumeEntry = {
  __typename?: 'MessageHourlyVolumeEntry';
  hour: Scalars['String'];
  totalSent: Scalars['Int'];
};

export type MessageLocalizationEditInput = {
  elementKey: Scalars['String'];
  localeId: Scalars['String'];
  slot: Scalars['String'];
  sourceHash: Scalars['String'];
  sourceText: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type MessageLocalizationInput = {
  edits?: InputMaybe<Array<MessageLocalizationEditInput>>;
  settings?: InputMaybe<MessageLocalizationSettingsInput>;
};

export type MessageLocalizationSettingsInput = {
  defaultLocaleId: Scalars['String'];
  enabled: Scalars['Boolean'];
  localeIds: Array<Scalars['String']>;
};

export type MessagePreviewAidAdmin = {
  __typename?: 'MessagePreviewAidAdmin';
  email: Scalars['String'];
  id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
};

export const MessagePreviewCheckStatus = {
  CouldNotVerify: 'could_not_verify',
  Error: 'error',
  Found: 'found',
  Missing: 'missing',
  NotChecked: 'not_checked'
} as const;

export type MessagePreviewCheckStatus = typeof MessagePreviewCheckStatus[keyof typeof MessagePreviewCheckStatus];
export type MessagePreviewContentInput = {
  locale?: InputMaybe<Scalars['String']>;
  selectedVariants: Scalars['JSONObject'];
  /** Non-personalized variables from the editor, excluding customer-row values. */
  variables: Scalars['JSONObject'];
};

export type MessagePreviewDeliverySetup = {
  __typename?: 'MessagePreviewDeliverySetup';
  lastMatchedAt?: Maybe<Scalars['String']>;
  lastMatchedRecipientMode?: Maybe<MessagePreviewRecipientMode>;
  missingPrerequisites: Array<MessagePreviewSetupPrerequisite>;
  recipientMode: MessagePreviewRecipientMode;
  snippetCheck?: Maybe<MessagePreviewSnippetCheck>;
  snippetCheckIsCurrent: Scalars['Boolean'];
  syntheticRejectCode?: Maybe<Scalars['String']>;
  syntheticRejectedAt?: Maybe<Scalars['String']>;
  testUserCheck?: Maybe<MessagePreviewTestUserCheck>;
  testUserCheckIsCurrent: Scalars['Boolean'];
};

export type MessagePreviewEspError = {
  __typename?: 'MessagePreviewEspError';
  code: Scalars['String'];
  kind: MessagePreviewEspErrorKind;
  responseStatus?: Maybe<Scalars['Int']>;
  safeText: Scalars['String'];
  scope?: Maybe<Scalars['String']>;
};

export const MessagePreviewEspErrorKind = {
  Authentication: 'authentication',
  Permission: 'permission',
  Unknown: 'unknown'
} as const;

export type MessagePreviewEspErrorKind = typeof MessagePreviewEspErrorKind[keyof typeof MessagePreviewEspErrorKind];
export const MessagePreviewFailureKind = {
  Authentication: 'authentication',
  HightouchBeforeSend: 'hightouch_before_send',
  Permission: 'permission',
  RateLimited: 'rate_limited',
  RecipientRejected: 'recipient_rejected',
  Timeout: 'timeout',
  UnknownSendOutcome: 'unknown_send_outcome',
  UserNotFound: 'user_not_found'
} as const;

export type MessagePreviewFailureKind = typeof MessagePreviewFailureKind[keyof typeof MessagePreviewFailureKind];
export type MessagePreviewFlowMessageIdInput = {
  flowId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};

export type MessagePreviewRecipient = {
  __typename?: 'MessagePreviewRecipient';
  recipientMode: MessagePreviewRecipientMode;
  testAddress: Scalars['String'];
  testUserId?: Maybe<Scalars['String']>;
};

export const MessagePreviewRecipientMode = {
  Registered: 'registered',
  Synthetic: 'synthetic'
} as const;

export type MessagePreviewRecipientMode = typeof MessagePreviewRecipientMode[keyof typeof MessagePreviewRecipientMode];
export type MessagePreviewRecipientPatch = {
  recipientMode?: InputMaybe<MessagePreviewRecipientMode>;
  testUserId?: InputMaybe<Scalars['String']>;
};

export type MessagePreviewRun = {
  __typename?: 'MessagePreviewRun';
  contentFingerprint: Scalars['String'];
  createdBy?: Maybe<Scalars['bigint']>;
  createdByName?: Maybe<Scalars['String']>;
  deadline: Scalars['String'];
  errorCode?: Maybe<Scalars['String']>;
  espResponseStatus?: Maybe<Scalars['Int']>;
  failureKind?: Maybe<MessagePreviewFailureKind>;
  flowId: Scalars['uuid'];
  id: Scalars['uuid'];
  locale?: Maybe<Scalars['String']>;
  matchedAt?: Maybe<Scalars['String']>;
  messageId: Scalars['uuid'];
  method: MessagePreviewRunMethod;
  preheader?: Maybe<Scalars['String']>;
  protocolVersion: Scalars['Int'];
  receivedAt?: Maybe<Scalars['String']>;
  recipientMode?: Maybe<MessagePreviewRecipientMode>;
  render?: Maybe<Scalars['String']>;
  requestedAt: Scalars['String'];
  resolvedTemplateId: Scalars['String'];
  safeErrorText?: Maybe<Scalars['String']>;
  selectedVariants: Scalars['JSONObject'];
  sender?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['String']>;
  status: MessagePreviewRunStatus;
  subject?: Maybe<Scalars['String']>;
  traceId: Scalars['uuid'];
  unmatchedEmailReceivedAt?: Maybe<Scalars['String']>;
  workspaceId: Scalars['bigint'];
};

export const MessagePreviewRunMethod = {
  Render: 'render',
  Send: 'send'
} as const;

export type MessagePreviewRunMethod = typeof MessagePreviewRunMethod[keyof typeof MessagePreviewRunMethod];
export const MessagePreviewRunStatus = {
  Completed: 'completed',
  Expired: 'expired',
  Failed: 'failed',
  Stopped: 'stopped',
  TimedOut: 'timed_out',
  Waiting: 'waiting'
} as const;

export type MessagePreviewRunStatus = typeof MessagePreviewRunStatus[keyof typeof MessagePreviewRunStatus];
export const MessagePreviewSetupPrerequisite = {
  RegisteredRecipient: 'registered_recipient',
  TestUserKey: 'test_user_key'
} as const;

export type MessagePreviewSetupPrerequisite = typeof MessagePreviewSetupPrerequisite[keyof typeof MessagePreviewSetupPrerequisite];
export type MessagePreviewSnippetCheck = {
  __typename?: 'MessagePreviewSnippetCheck';
  checkedAt: Scalars['String'];
  checkedBy?: Maybe<Scalars['bigint']>;
  error?: Maybe<MessagePreviewEspError>;
  result: MessagePreviewCheckStatus;
  templateId: Scalars['String'];
};

export type MessagePreviewSnippetCheckResult = {
  __typename?: 'MessagePreviewSnippetCheckResult';
  check: MessagePreviewSnippetCheck;
  details?: Maybe<Scalars['JSON']>;
  isCurrent: Scalars['Boolean'];
};

export type MessagePreviewState = {
  __typename?: 'MessagePreviewState';
  /** Actionable message when status is failed. */
  error?: Maybe<Scalars['String']>;
  /** Structured ESP error retained only in the requesting browser session. */
  espError?: Maybe<MessagePreviewEspError>;
  espErrorDetails?: Maybe<Scalars['JSON']>;
  /** When the displayed render was received. */
  receivedAt?: Maybe<Scalars['String']>;
  /** Rendered HTML of the most recently accepted preview email. */
  render?: Maybe<Scalars['String']>;
  /** Sanitized request details retained only in the requesting browser session. */
  requestInfoSet?: Maybe<Array<Scalars['JSONObject']>>;
  /** When a preview was last requested; the acceptance window opens here. */
  requestedAt?: Maybe<Scalars['String']>;
  run?: Maybe<MessagePreviewRun>;
  /**
   * Address the last triggered send targeted, recorded server-side at trigger
   * time — the resolver is the only place that knows which recipient mode was
   * actually resolved (the registered-mode flag can override the channel
   * config). Null for rows that predate the field.
   */
  sentToAddress?: Maybe<Scalars['String']>;
  status: MessagePreviewStatus;
  /**
   * Registered mode only: preview emails received at the account address since
   * the last request that carried no attributable trace ID (usually a missing
   * template snippet). Lets timeout copy say "we received email we couldn't
   * match — check your template snippet".
   */
  untaggedDropCount?: Maybe<Scalars['Int']>;
};

/**
 * Lifecycle of a message's preview capture. 'none' means no preview state
 * exists for the message (nothing requested yet, or the last render aged out
 * of storage).
 */
export const MessagePreviewStatus = {
  Displaying: 'displaying',
  Failed: 'failed',
  None: 'none',
  Waiting: 'waiting'
} as const;

export type MessagePreviewStatus = typeof MessagePreviewStatus[keyof typeof MessagePreviewStatus];
export type MessagePreviewTestUserCheck = {
  __typename?: 'MessagePreviewTestUserCheck';
  checkedAt: Scalars['String'];
  checkedBy?: Maybe<Scalars['bigint']>;
  configuration: MessagePreviewTestUserConfiguration;
  emailMatches?: Maybe<Scalars['Boolean']>;
  error?: Maybe<MessagePreviewEspError>;
  result: MessagePreviewCheckStatus;
  userFound?: Maybe<Scalars['Boolean']>;
};

export type MessagePreviewTestUserCheckResult = {
  __typename?: 'MessagePreviewTestUserCheckResult';
  check?: Maybe<MessagePreviewTestUserCheck>;
  details?: Maybe<Scalars['JSON']>;
  isCurrent: Scalars['Boolean'];
};

export type MessagePreviewTestUserConfiguration = {
  __typename?: 'MessagePreviewTestUserConfiguration';
  destinationId: Scalars['bigint'];
  recipientMode: MessagePreviewRecipientMode;
  recipientRevision: Scalars['Int'];
  testAddress: Scalars['String'];
  testUserId?: Maybe<Scalars['String']>;
};

export type MessagePreviewUnmatchedEmailRender = {
  __typename?: 'MessagePreviewUnmatchedEmailRender';
  canViewBody: Scalars['Boolean'];
  receivedAt: Scalars['String'];
  render?: Maybe<Scalars['String']>;
  snippetGuidance: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  unverified: Scalars['Boolean'];
};

export type MessageSimilarity = {
  __typename?: 'MessageSimilarity';
  messageId: Scalars['uuid'];
  similarityScore: Scalars['Float'];
};

export type MessageSimilarityRating = {
  __typename?: 'MessageSimilarityRating';
  messageId: Scalars['uuid'];
  rating: Scalars['Float'];
};

export type MessageSimilarityRatingResult = {
  __typename?: 'MessageSimilarityRatingResult';
  result: Array<MessageSimilarityRating>;
};

export type MessageSimilarityReasons = {
  __typename?: 'MessageSimilarityReasons';
  error?: Maybe<DecisionEngineError>;
  messageId: Scalars['uuid'];
  reasons: Array<Scalars['String']>;
};

export type MessageSimilarityReasonsResult = {
  __typename?: 'MessageSimilarityReasonsResult';
  reasons: Array<MessageSimilarityReasons>;
};

export type MessageStats = {
  __typename?: 'MessageStats';
  daily: Array<DailyMessageStats>;
  messageId: Scalars['String'];
  totalClicks: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalDeviceOpens?: Maybe<Scalars['Int']>;
  totalDevicesAccepted?: Maybe<Scalars['Int']>;
  totalDevicesRejected?: Maybe<Scalars['Int']>;
  totalDropped: Scalars['Int'];
  totalFailed: Scalars['Int'];
  totalOpens: Scalars['Int'];
  totalSent: Scalars['Int'];
  totalSpamReports: Scalars['Int'];
};

export type MessageTimelineEvent = {
  __typename?: 'MessageTimelineEvent';
  campaignId?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  channelType?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  journeyId?: Maybe<Scalars['String']>;
  journeyName?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  type: Scalars['String'];
};

export type MessageTimelineEventsResponse = {
  __typename?: 'MessageTimelineEventsResponse';
  events: Array<MessageTimelineEvent>;
};

export type MessageVariableSimilarity = {
  __typename?: 'MessageVariableSimilarity';
  messageId: Scalars['uuid'];
  similarityScore: Scalars['Float'];
  variableName: Scalars['String'];
  variantIndexLeft: Scalars['Int'];
  variantIndexRight: Scalars['Int'];
  variantValueLeft: Scalars['String'];
  variantValueRight: Scalars['String'];
};

export type MessageVariantArmInput = {
  editorState?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  preheader?: InputMaybe<Scalars['String']>;
  profileMappings: Array<ProfileMappingInput>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  subject?: InputMaybe<Scalars['String']>;
  /** Minted by the browser, which keys the arm's localization tags by it. Server-minted when omitted. */
  variantId?: InputMaybe<Scalars['String']>;
  variantKey: Scalars['String'];
};

export type MessagesList = {
  __typename?: 'MessagesList';
  messages: Array<Message>;
  totalCount: Scalars['Int'];
};

export const MessagesSortKey = {
  DeliveredAtAsc: 'DELIVERED_AT_ASC',
  DeliveredAtDesc: 'DELIVERED_AT_DESC',
  HighestClickRate: 'HIGHEST_CLICK_RATE',
  HighestOpenRate: 'HIGHEST_OPEN_RATE',
  MostSent: 'MOST_SENT',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type MessagesSortKey = typeof MessagesSortKey[keyof typeof MessagesSortKey];
export type MessagingCampaign = {
  __typename?: 'MessagingCampaign';
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type MetaAdAccount = {
  __typename?: 'MetaAdAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

/**
 * A Meta Ad Library page matching a company search, for the ads-channel copy
 * references wizard's page picker.
 */
export type MetaAdLibraryCompanyMatch = {
  __typename?: 'MetaAdLibraryCompanyMatch';
  activeAdsCount?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  /**
   * ISO country code of the page's market. Brands often run one page per
   * country with identical names and likes, so this is the disambiguator.
   */
  country?: Maybe<Scalars['String']>;
  igFollowers?: Maybe<Scalars['Int']>;
  igUsername?: Maybe<Scalars['String']>;
  likes?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pageId: Scalars['String'];
  pageUrl?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type MetaAdStatus = {
  __typename?: 'MetaAdStatus';
  effectiveStatus: Scalars['String'];
  impressions?: Maybe<Scalars['String']>;
  metaAdId: Scalars['String'];
  spend?: Maybe<Scalars['String']>;
};

export type MetaAdset = {
  __typename?: 'MetaAdset';
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instagramPositions?: Maybe<Array<Scalars['String']>>;
  isDynamicCreative?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  publisherPlatforms?: Maybe<Array<Scalars['String']>>;
  status: Scalars['String'];
  targetsInstagram?: Maybe<Scalars['Boolean']>;
};

export type MetaAdsetAd = {
  __typename?: 'MetaAdsetAd';
  effectiveStatus: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type MetaCampaign = {
  __typename?: 'MetaCampaign';
  id: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
  stopTime?: Maybe<Scalars['String']>;
};

export type MetaGraphDebugError = {
  __typename?: 'MetaGraphDebugError';
  code?: Maybe<Scalars['Int']>;
  errorSubcode?: Maybe<Scalars['Int']>;
  fbtraceId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MetaGraphDebugRead = {
  __typename?: 'MetaGraphDebugRead';
  data?: Maybe<Scalars['JSON']>;
  errorMessage?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  metaError?: Maybe<MetaGraphDebugError>;
  ok: Scalars['Boolean'];
  path: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type MetaInstagramIdentities = {
  __typename?: 'MetaInstagramIdentities';
  autoResolvedId?: Maybe<Scalars['String']>;
  candidates: Array<MetaInstagramIdentity>;
};

export type MetaInstagramIdentity = {
  __typename?: 'MetaInstagramIdentity';
  id: Scalars['String'];
  source: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type MetaPage = {
  __typename?: 'MetaPage';
  category?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type MetaTokenUser = {
  __typename?: 'MetaTokenUser';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type MetadataInput = {
  actionPlanApproval?: InputMaybe<ActionPlanApprovalSummaryInput>;
  components?: InputMaybe<Array<MessageComponentInput>>;
  customAgent?: InputMaybe<CustomAgentInput>;
  elementChangeSuggestions?: InputMaybe<Array<ElementChangeSuggestionInput>>;
  focusedFilter?: InputMaybe<FocusedFilterInput>;
  insightId?: InputMaybe<Scalars['String']>;
  interactionStyle?: InputMaybe<Scalars['String']>;
  isSuggestedPrompt?: InputMaybe<Scalars['Boolean']>;
  modeTransitionSummary?: InputMaybe<ModeTransitionSummaryInput>;
  promptFacade?: InputMaybe<PromptFacadeInput>;
  quizAnswerSummary?: InputMaybe<QuizAnswerSummaryInput>;
  /**
   * The exact native primary or resize open in the editor. A primary keeps its
   * role even when it carries a channel association; selectedChannelSizeId
   * remains the selector for older clients.
   */
  selectedAdBriefAssetId?: InputMaybe<Scalars['String']>;
  selectedChannelSizeId?: InputMaybe<Scalars['String']>;
  selectedSizeKey?: InputMaybe<Scalars['String']>;
  selectedSizeVersionId?: InputMaybe<Scalars['String']>;
  selectedVersionId?: InputMaybe<Scalars['String']>;
  submittedContext?: InputMaybe<Array<SubmittedContextInput>>;
  unsavedJourneyGraph?: InputMaybe<Scalars['JSONObject']>;
};

export type Metric = {
  attributionMethodId?: InputMaybe<Scalars['String']>;
  goalId: Scalars['String'];
};

export type MetricBackgroundResult = {
  __typename?: 'MetricBackgroundResult';
  data: Array<MetricResult>;
};

export type MetricData = {
  __typename?: 'MetricData';
  audienceSnapshotUsed: Scalars['Boolean'];
  data: Array<MetricSeries>;
  lowConfidenceResults: Scalars['Boolean'];
  summaryStats?: Maybe<MetricSummary>;
  usedSampledModels: Scalars['Boolean'];
};

export type MetricError = {
  __typename?: 'MetricError';
  error: Scalars['String'];
};

export type MetricGroupByColumn = {
  buckets?: InputMaybe<Array<Scalars['JSONObject']>>;
  column: Scalars['JSONObject'];
};

export type MetricGroupByKey = {
  __typename?: 'MetricGroupByKey';
  column: Scalars['JSONObject'];
  value?: Maybe<Scalars['String']>;
};

export type MetricIdentifier = {
  __typename?: 'MetricIdentifier';
  cohortDefinition?: Maybe<AnalyticsCohortDefinitionOutput>;
  cohortId?: Maybe<Scalars['String']>;
  metricDefinition?: Maybe<Scalars['JSONObject']>;
  metricId?: Maybe<Scalars['String']>;
};

export type MetricJobIdentifier = {
  __typename?: 'MetricJobIdentifier';
  cohortDefinition?: Maybe<AnalyticsCohortDefinitionOutput>;
  cohortId?: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  metricDefinition?: Maybe<Scalars['JSONObject']>;
  metricId?: Maybe<Scalars['String']>;
};

export type MetricResult = {
  __typename?: 'MetricResult';
  ids: MetricJobIdentifier;
  result: MetricResultData;
};

export type MetricResultData = MetricData | MetricError;

export type MetricResultFromCache = {
  __typename?: 'MetricResultFromCache';
  cachedAt?: Maybe<Scalars['String']>;
  ids: MetricIdentifier;
  result: MetricResultData;
};

export type MetricSeries = {
  __typename?: 'MetricSeries';
  data: Array<MetricSeriesDatapoint>;
  groupBy?: Maybe<Array<MetricGroupByKey>>;
  splitId?: Maybe<Scalars['String']>;
};

export type MetricSeriesDatapoint = {
  __typename?: 'MetricSeriesDatapoint';
  meta?: Maybe<Scalars['JSONObject']>;
  timestamp: Scalars['String'];
  value: Scalars['Float'];
};

export type MetricSummary = {
  __typename?: 'MetricSummary';
  data: Array<MetricSummaryStats>;
  timeWindow: MetricSummaryTimeWindow;
};

export type MetricSummaryStats = {
  __typename?: 'MetricSummaryStats';
  confidenceInterval?: Maybe<ConfidenceInterval>;
  isBaseline: Scalars['Boolean'];
  isNormalized: Scalars['Boolean'];
  lift?: Maybe<LiftStats>;
  rawValue: Scalars['Float'];
  size: Scalars['Int'];
  splitName?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type MetricSummaryTimeWindow = {
  __typename?: 'MetricSummaryTimeWindow';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type MetricsResult = {
  __typename?: 'MetricsResult';
  members: Array<WorkspaceMembersResult>;
  metrics: Array<MetricsRowResult>;
};

export type MetricsRowResult = {
  __typename?: 'MetricsRowResult';
  audiences?: Maybe<Scalars['Int']>;
  connections?: Maybe<Scalars['Int']>;
  created_at: Scalars['String'];
  destinations?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  models?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  syncs?: Maybe<Scalars['Int']>;
};

export type ModeTransitionSummaryInput = {
  actionLabel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  targetAgentMode: Scalars['String'];
  title: Scalars['String'];
};

export type Model = {
  __typename?: 'Model';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idrOutput?: Maybe<IdrOutput>;
  name: Scalars['String'];
  semantic_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ModelColumn = {
  __typename?: 'ModelColumn';
  alias?: Maybe<Scalars['String']>;
  case_sensitive?: Maybe<Scalars['Boolean']>;
  column_reference: Scalars['JSONObject'];
  custom_type?: Maybe<Scalars['String']>;
  disable?: Maybe<Scalars['Boolean']>;
  disable_preview?: Maybe<Scalars['Boolean']>;
  is_related: Scalars['Boolean'];
  last_top_k_sync_timestamp?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  model_id: Scalars['String'];
  model_name: Scalars['String'];
  name: Scalars['String'];
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ModelColumnInput = {
  alias?: InputMaybe<Scalars['String']>;
  case_sensitive?: InputMaybe<Scalars['Boolean']>;
  custom_type?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  raw_type?: InputMaybe<Scalars['String']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ModelColumnsRatio = {
  __typename?: 'ModelColumnsRatio';
  modelId: Scalars['String'];
  name: Scalars['String'];
  ratio: Scalars['Float'];
};

export type ModelCount = {
  __typename?: 'ModelCount';
  count: Scalars['Int'];
  modelId: Scalars['String'];
  modelName: Scalars['String'];
};

export type ModelCountsByPkBackgroundResult = ModelCountsByPkResponse | ProfileExplorerError;

export type ModelCountsByPkInput = {
  /** Event counts only: narrow to these brands' messages and drop event models a brand cannot scope. Absent applies no filter; empty matches nothing. */
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  modelType: ProfileExplorerModelType;
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['ID'];
};

export type ModelCountsByPkResponse = {
  __typename?: 'ModelCountsByPkResponse';
  counts: Array<ModelCount>;
};

export type ModelData = {
  __typename?: 'ModelData';
  is_event_model: Scalars['Boolean'];
  model_id?: Maybe<Scalars['String']>;
  model_name: Scalars['String'];
};

export type ModelDeploymentResult = FailedDeploymentTestResult | SuccessfulModelDeploymentResult;

export type ModelDraft = {
  _set: Scalars['JSONObject'];
  modelColumns?: InputMaybe<Array<Scalars['JSONObject']>>;
};

export type ModelRelationshipsRatio = {
  __typename?: 'ModelRelationshipsRatio';
  modelRelationshipId: Scalars['String'];
  ratio: Scalars['Float'];
};

export type ModelRowsByPkInput = {
  modelId?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
};

export const ModelType = {
  Audience: 'audience',
  GeneralModel: 'general_model',
  Model: 'model',
  Schema: 'schema'
} as const;

export type ModelType = typeof ModelType[keyof typeof ModelType];
export type ModifyModelColumnsResponse = {
  __typename?: 'ModifyModelColumnsResponse';
  affected_rows: Scalars['Int'];
};

export type MongoDbListCollectionsInput = {
  destinationId: Scalars['String'];
};

/** A branch of an agent-chosen group: the id the engine picks, and the name the marketer sees. */
export type NativeDeliveryAgentBranch = {
  __typename?: 'NativeDeliveryAgentBranch';
  label: Scalars['String'];
  value: Scalars['String'];
};

/** A dynamic content group the agent chooses a branch of, registered on the agent message as one variable. */
export type NativeDeliveryAgentGroup = {
  __typename?: 'NativeDeliveryAgentGroup';
  /** The group name the marketer sees. */
  label: Scalars['String'];
  /** The AI Decisioning variable name. */
  name: Scalars['String'];
  /** The group's branches as Native Delivery has them. */
  values: Array<NativeDeliveryAgentBranch>;
};

export type NativeDeliveryAgentGroups = {
  __typename?: 'NativeDeliveryAgentGroups';
  groups: Array<NativeDeliveryAgentGroup>;
  /** False when no agent flow message names the message's campaign. */
  linked: Scalars['Boolean'];
};

/**
 * The native delivery message an agent message delivers through, rendered the
 * way a send would be: the published templates with the previewed user's merge
 * tags and the chosen branch of each agent-chosen dynamic content group.
 */
export type NativeDeliveryAgentPreview = {
  __typename?: 'NativeDeliveryAgentPreview';
  body?: Maybe<Scalars['String']>;
  errors: Array<NativeDeliveryAgentPreviewError>;
  html?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  /**
   * Names of the dynamic content groups whose branch the agent does not choose.
   * The preview does not evaluate their rules, so each renders its fallback branch.
   */
  ruleBasedGroups: Array<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NativeDeliveryAgentPreviewError = {
  __typename?: 'NativeDeliveryAgentPreviewError';
  column: Scalars['String'];
  templateKey: Scalars['String'];
  /** missing_column, null_value or inconsistent_default */
  type: Scalars['String'];
};

export type NativeDeliveryDraftResult = {
  __typename?: 'NativeDeliveryDraftResult';
  id: Scalars['uuid'];
  status: Scalars['String'];
};

export const NativeDeliveryReviewDecision = {
  Approved: 'approved',
  Rejected: 'rejected'
} as const;

export type NativeDeliveryReviewDecision = typeof NativeDeliveryReviewDecision[keyof typeof NativeDeliveryReviewDecision];
export type NewComponentAssetInput = {
  content: Scalars['String'];
  filename: Scalars['String'];
  mimeType: Scalars['String'];
};

export type NewDamSyncCollectionInput = {
  name: Scalars['String'];
};

export type Node = {
  __typename?: 'Node';
  config: Scalars['JSONObject'];
  description?: Maybe<Scalars['String']>;
  event_relationship_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  message_config?: Maybe<MessageConfig>;
  name: Scalars['String'];
  notes?: Maybe<Array<Note>>;
  position?: Maybe<Scalars['JSONObject']>;
  realtime_function_config?: Maybe<RealtimeFunctionConfig>;
  realtime_sync_config?: Maybe<RealtimeSyncConfig>;
  segment_id?: Maybe<Scalars['String']>;
  source_node_id?: Maybe<Scalars['uuid']>;
  sync_configs?: Maybe<Array<SyncConfig>>;
  type: Scalars['String'];
};

export type NodeInput = {
  config: Scalars['JSONObject'];
  decision_context_columns?: InputMaybe<Array<DecisionContextColumnInput>>;
  decision_outcome?: InputMaybe<DecisionOutcomeInput>;
  description?: InputMaybe<Scalars['String']>;
  event_relationship_id?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  message_config?: InputMaybe<MessageConfigInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['JSONObject']>;
  realtime_function_config?: InputMaybe<RealtimeFunctionConfigInput>;
  realtime_sync_config?: InputMaybe<RealtimeSyncConfigInput>;
  segment_id?: InputMaybe<Scalars['String']>;
  source_node_id?: InputMaybe<Scalars['uuid']>;
  sync_configs?: InputMaybe<Array<SyncConfigInput>>;
  type: Scalars['String'];
};

export type NodeRealtimeSyncConfig = {
  __typename?: 'NodeRealtimeSyncConfig';
  destination_id?: Maybe<Scalars['String']>;
  function_id?: Maybe<Scalars['String']>;
  node_id: Scalars['String'];
  subscription_config: Scalars['JSONObject'];
};

export type NormalTunnel = Tunnel & {
  __typename?: 'NormalTunnel';
  createdAt?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serviceHost: Scalars['String'];
  servicePort: Scalars['Int'];
  sshHost: Scalars['String'];
  sshPort?: Maybe<Scalars['Int']>;
  sshUser?: Maybe<Scalars['String']>;
  tunnelPort?: Maybe<Scalars['Int']>;
};

export type NormalTunnelInput = {
  name: Scalars['String'];
  serviceHost: Scalars['String'];
  servicePort: Scalars['Int'];
  sshHost: Scalars['String'];
  sshPort?: InputMaybe<Scalars['Int']>;
};

export type NormalTunnelOutput = {
  __typename?: 'NormalTunnelOutput';
  publicKey?: Maybe<Scalars['String']>;
  tunnel: NormalTunnel;
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String'];
  id: Scalars['String'];
  node_id?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['JSONObject']>;
};

export type NoteInput = {
  content: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  node_id?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['JSONObject']>;
};

export type OpportunityBrandLatestRun = {
  __typename?: 'OpportunityBrandLatestRun';
  brandProfileId: Scalars['ID'];
  status: OpportunityBrandRunStatus;
};

export const OpportunityBrandRunStatus = {
  Complete: 'complete',
  Failed: 'failed',
  NeverRan: 'never_ran',
  Running: 'running'
} as const;

export type OpportunityBrandRunStatus = typeof OpportunityBrandRunStatus[keyof typeof OpportunityBrandRunStatus];
export type OpportunityDefinition = {
  __typename?: 'OpportunityDefinition';
  brandProfileIds: Array<Scalars['ID']>;
  categories: Array<Scalars['String']>;
  id: Scalars['ID'];
  lastRunAt?: Maybe<Scalars['String']>;
  latestBrandRuns: Array<OpportunityBrandLatestRun>;
  maxCards: Scalars['Int'];
  name: Scalars['String'];
  prompt: Scalars['String'];
  recipient: Array<Scalars['String']>;
  schedule?: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
};

export type OpportunityDefinitionInput = {
  brandProfileIds: Array<Scalars['ID']>;
  categories: Array<Scalars['String']>;
  maxCards?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  prompt: Scalars['String'];
  recipient?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Scalars['JSON']>;
};

export type OrangeLogicFolder = {
  __typename?: 'OrangeLogicFolder';
  assetCount: Scalars['Int'];
  id: Scalars['String'];
  idPath: Scalars['String'];
  name: Scalars['String'];
  namePath: Scalars['String'];
  scheme: Scalars['String'];
  subfolderCount: Scalars['Int'];
};

export type OrangeLogicFolderTreeResult = {
  __typename?: 'OrangeLogicFolderTreeResult';
  folders: Array<OrangeLogicFolder>;
};

export type OrbitListWorkspaces = {
  __typename?: 'OrbitListWorkspaces';
  workspaces: Array<OrbitWorkspace>;
};

export type OrbitListWorkspacesInput = {
  destinationId: Scalars['String'];
};

export type OrbitWorkspace = {
  __typename?: 'OrbitWorkspace';
  name: Scalars['String'];
  path: Scalars['String'];
};

export type OrderByCampaignColumn = {
  assetColumn?: InputMaybe<Scalars['String']>;
  attributionMethodId?: InputMaybe<Scalars['String']>;
  direction: OrderByDirection;
  goalId?: InputMaybe<Scalars['String']>;
  type: OrderByCampaignColumnType;
};

export const OrderByCampaignColumnType = {
  Asset: 'asset',
  Metric: 'metric'
} as const;

export type OrderByCampaignColumnType = typeof OrderByCampaignColumnType[keyof typeof OrderByCampaignColumnType];
export const OrderByDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type OrderByDirection = typeof OrderByDirection[keyof typeof OrderByDirection];
export type Organization = {
  __typename?: 'Organization';
  id: Scalars['Int'];
  logo_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OrganizationDestination = {
  __typename?: 'OrganizationDestination';
  definition: OrganizationDestinationDefinition;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tags: Scalars['JSONObject'];
  type: Scalars['String'];
};

export type OrganizationDestinationDefinition = {
  __typename?: 'OrganizationDestinationDefinition';
  icon: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type OrganizationDestinationFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  workspaceId: Scalars['String'];
};

export type OrganizationDestinations = {
  __typename?: 'OrganizationDestinations';
  destinations: Array<OrganizationDestination>;
  hasMore: Scalars['Boolean'];
};

export type OrganizationGeneralModel = {
  __typename?: 'OrganizationGeneralModel';
  id: Scalars['String'];
  name: Scalars['String'];
  source: OrganizationSource;
};

export type OrganizationGeneralModelFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  workspaceId: Scalars['String'];
};

export type OrganizationGeneralModels = {
  __typename?: 'OrganizationGeneralModels';
  generalModels: Array<OrganizationGeneralModel>;
  hasMore: Scalars['Boolean'];
};

export type OrganizationMqr = {
  __typename?: 'OrganizationMqr';
  percentage_change: Scalars['Float'];
  total_monthly_queried_records: Scalars['Int'];
  usage_period: Scalars['String'];
  workspaces: Array<WorkspaceMqr>;
};

export type OrganizationParentModel = {
  __typename?: 'OrganizationParentModel';
  id: Scalars['String'];
  name: Scalars['String'];
  source: OrganizationSource;
  subsets: Array<OrganizationSubset>;
};

export type OrganizationParentModelFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  workspaceId: Scalars['String'];
};

export type OrganizationParentModels = {
  __typename?: 'OrganizationParentModels';
  hasMore: Scalars['Boolean'];
  parentModels: Array<OrganizationParentModel>;
};

export type OrganizationSource = {
  __typename?: 'OrganizationSource';
  definition: OrganizationSourceDefinition;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tags: Scalars['JSONObject'];
  type: Scalars['String'];
};

export type OrganizationSourceDefinition = {
  __typename?: 'OrganizationSourceDefinition';
  cleanRoomType?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  isSampleDataSource: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type OrganizationSourceFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  workspaceId: Scalars['String'];
};

export type OrganizationSources = {
  __typename?: 'OrganizationSources';
  connections: Array<OrganizationSource>;
  hasMore: Scalars['Boolean'];
};

export type OrganizationSubset = {
  __typename?: 'OrganizationSubset';
  group: OrganizationSubsetGroup;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OrganizationSubsetGroup = {
  __typename?: 'OrganizationSubsetGroup';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OsTimeSeries = {
  __typename?: 'OsTimeSeries';
  os: PushOs;
  points: Array<DeliverabilityTimeSeriesPoint>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedEmailTemplatesResult = {
  __typename?: 'PaginatedEmailTemplatesResult';
  hasMore: Scalars['Boolean'];
  templates: Array<EmailTemplate>;
  totalCount: Scalars['Int'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PaginationOptions = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PaginationResults = {
  __typename?: 'PaginationResults';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PartnerConnection = {
  __typename?: 'PartnerConnection';
  defaultWorkspaceName?: Maybe<Scalars['String']>;
  partnerLogo: Scalars['String'];
  partnerName: Scalars['String'];
  resources?: Maybe<Array<Maybe<Scalars['String']>>>;
  returnUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  userIsLinked: Scalars['Boolean'];
  uuid: Scalars['String'];
  workspaceId?: Maybe<Scalars['Int']>;
};

export type PartnerInformation = {
  __typename?: 'PartnerInformation';
  partnerLogo: Scalars['String'];
  partnerName: Scalars['String'];
  resources?: Maybe<Array<Maybe<Scalars['String']>>>;
  type: Scalars['String'];
};

export type PathModels = {
  __typename?: 'PathModels';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PathSegment = {
  __typename?: 'PathSegment';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PendingSuperclustersQuery = {
  /** Paginated by cluster so all identifiers for the cluster are on the same page */
  pagination?: InputMaybe<PaginationInput>;
};

export type PitRiskColumnClassification = {
  __typename?: 'PitRiskColumnClassification';
  columnName: Scalars['String'];
  reason: Scalars['String'];
  risk: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  entitlements?: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  sku: Scalars['String'];
};

export const PredictiveTraitsJobTypeEnum = {
  BuildTrainingMatrix: 'BUILD_TRAINING_MATRIX',
  CatalogBuildTrainingMatrix: 'CATALOG_BUILD_TRAINING_MATRIX',
  CatalogInference: 'CATALOG_INFERENCE',
  CatalogTrainModel: 'CATALOG_TRAIN_MODEL',
  Inference: 'INFERENCE',
  LookalikeInference: 'LOOKALIKE_INFERENCE',
  LookalikeTrain: 'LOOKALIKE_TRAIN',
  PullCachedEvent: 'PULL_CACHED_EVENT',
  TrainModel: 'TRAIN_MODEL'
} as const;

export type PredictiveTraitsJobTypeEnum = typeof PredictiveTraitsJobTypeEnum[keyof typeof PredictiveTraitsJobTypeEnum];
export type PredictiveTraitsQueueJob = {
  __typename?: 'PredictiveTraitsQueueJob';
  createdAt: Scalars['String'];
  jobId: Scalars['String'];
  payload?: Maybe<Scalars['JSONObject']>;
  status: Scalars['String'];
  tenantId: Scalars['String'];
};

export type PredictiveTraitsQueueResult = {
  __typename?: 'PredictiveTraitsQueueResult';
  jobs: Array<PredictiveTraitsQueueJob>;
};

export type PredictorCatalogEventInput = {
  catalogRelationshipId: Scalars['String'];
  filter: Scalars['JSONObject'];
  name: Scalars['String'];
  userRelationshipId: Scalars['String'];
};

export type PredictorEventInput = {
  aggregations?: InputMaybe<EventAggregationsInput>;
  filter: Scalars['JSONObject'];
  name: Scalars['String'];
  relationshipId: Scalars['String'];
};

export type PredictorFeatureDefinitionPropertyInput = {
  columnName: Scalars['JSON'];
  modelId: Scalars['String'];
};

export type PredictorOutcomeInput = {
  aggregation?: InputMaybe<Scalars['String']>;
  keyEvent: PredictorEventInput;
  timeframe: TimeframeInput;
  type?: InputMaybe<Scalars['String']>;
  valueColumn?: InputMaybe<Scalars['String']>;
};

export type PreviewAnalysis = {
  __typename?: 'PreviewAnalysis';
  groups: Array<PreviewGroup>;
  /** Parent model row count; null on failure. */
  matchCount?: Maybe<Scalars['Int']>;
};

export type PreviewFeatureMatrixForFlowInput = {
  featureMatrixId: Scalars['uuid'];
  flowId: Scalars['uuid'];
  runSql?: InputMaybe<Scalars['Boolean']>;
};

export type PreviewFeatureMatrixForFlowResult = {
  __typename?: 'PreviewFeatureMatrixForFlowResult';
  columns: Array<FeatureMatrixOutputColumn>;
  jobId?: Maybe<Scalars['String']>;
  querySql: Scalars['String'];
};

export type PreviewGroup = {
  __typename?: 'PreviewGroup';
  /** User-facing column label (the column alias or variable name). */
  displayName: Scalars['String'];
  /**
   * Share (0-100) of recipients matching no listed value (substitution: not
   * filled; control flow: top-k miss). Null when any option count is null or
   * matchCount is null/0.
   */
  fallbackSharePercent?: Maybe<Scalars['Float']>;
  /** What a recipient with no value sees, from the template's `default:` filters — one entry per distinct outcome, in the order written, with any `unset` entry last. Empty when there is nothing to name. */
  fallbacks: Array<ScenarioFallback>;
  options: Array<PreviewOption>;
  /** How the template writes the variable — `{% if %}` branch vs `{{ }}` substitution — independent of `type`, which reports the bucketing. Drives the sidebar's glyph so a branch always looks like a branch whatever its column's top-k enablement made of it. */
  templateType: ScenarioVariableType;
  /** How the group is bucketed: `control_flow` lists the column's own values, `variable` collapses to filled / no value set. Follows what the axis can enumerate for the column (profile: top-k enablement), so it needn't match how the template writes the variable. */
  type: ScenarioVariableType;
};

export type PreviewMatchingEntryEventInput = {
  eventRelationshipId: Scalars['String'];
  selection: Array<ScenarioSelectionInput>;
};

export type PreviewMatchingEntryEventResult = {
  __typename?: 'PreviewMatchingEntryEventResult';
  /**
   * Up to 10 matching events, each keyed by journey_entry_event.* template
   * keys — a random sample the UI overlays one of and shuffles among the rest.
   */
  eventRows: Array<Scalars['JSONObject']>;
  /** True when no recent event matches the selection (show the no-match state). */
  noMatch: Scalars['Boolean'];
};

export type PreviewMatchingProfileInput = {
  /**
   * Optional audience (the campaign/journey send pool) to sample from. When set,
   * the matching profile is drawn from within that audience's membership; when
   * omitted, from the whole CEP parent model. It's an audience segment id — only
   * audiences are supported, not arbitrary segments.
   */
  audienceId?: InputMaybe<Scalars['ID']>;
  /**
   * Force a live warehouse query, bypassing the scenario-sample cache. The FE
   * sets this to fetch the exact match after a cache miss returned an instant
   * placeholder (`exactMatchPending`).
   */
  forceLive?: InputMaybe<Scalars['Boolean']>;
  selection: Array<ScenarioSelectionInput>;
  /**
   * Merge-tag keys (`template_key`) referenced by the message content being
   * previewed. When set, expensive non-raw columns (traits, related, transformed)
   * are fetched only if referenced here or in `selection` — each unreferenced
   * one would otherwise add its own aggregation join to the warehouse query. Raw
   * parent-model columns are always fetched (they're free) so the profile panel
   * keeps its values. When omitted, every syncable column is fetched.
   */
  templateKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type PreviewMatchingProfileResult = {
  __typename?: 'PreviewMatchingProfileResult';
  /**
   * True when `profileRows` is an instant placeholder (a generic parent-model
   * sample) returned on a cache miss rather than the exact match. The FE shows a
   * "finding a match" state and refetches with `forceLive: true`.
   */
  exactMatchPending: Scalars['Boolean'];
  /** True when no real profile matches the selection (show the no-match state). */
  noMatch: Scalars['Boolean'];
  /**
   * Up to 10 real profiles matching the selection — a random sample for
   * coverage, empty when nothing matches. The UI shows one and lets the
   * marketer shuffle among the rest without re-querying.
   */
  profileRows: Array<Scalars['JSONObject']>;
  /**
   * Where the returned rows came from — the precomputed scenario-sample CACHE
   * or a LIVE warehouse query.
   */
  servedFrom: PreviewProfileSource;
};

export type PreviewOption = {
  __typename?: 'PreviewOption';
  /**
   * Merge-tag template key (`template_key`) this option targets — feeds
   * `ScenarioSelectionInput.column` to condition the matching-profile fetch.
   */
  column: Scalars['String'];
  /**
   * Per-option render fingerprint; flips when the value's share moves.
   * Backend always populates it; declared optional so existing FE
   * operations that don't select it stay compatible.
   */
  fingerprint?: Maybe<Scalars['String']>;
  /** A top-k value, or `"filled"` for substitution vars. */
  label: Scalars['String'];
  /** Share of parent model matching this value (0-100); null if uncomputable. */
  sharePercent?: Maybe<Scalars['Float']>;
  /**
   * The chosen top-k bucket value — feeds `ScenarioSelectionInput.value`
   * (`"filled"` = is-not-null for substitution vars, else an equals match).
   */
  value: Scalars['String'];
};

export const PreviewProfileSource = {
  /** Rows came from the precomputed scenario-sample cache. */
  Cache: 'CACHE',
  /** Rows came from a live warehouse query. */
  Live: 'LIVE'
} as const;

export type PreviewProfileSource = typeof PreviewProfileSource[keyof typeof PreviewProfileSource];
export type PreviewQuerySchemaBackgroundJobFailure = {
  __typename?: 'PreviewQuerySchemaBackgroundJobFailure';
  error: Scalars['String'];
  type: PreviewQuerySchemaStatus;
};

export type PreviewQuerySchemaBackgroundJobProcessing = {
  __typename?: 'PreviewQuerySchemaBackgroundJobProcessing';
  type: PreviewQuerySchemaStatus;
};

export type PreviewQuerySchemaBackgroundJobResult = PreviewQuerySchemaBackgroundJobFailure | PreviewQuerySchemaBackgroundJobProcessing | PreviewQuerySchemaBackgroundJobSuccess;

export type PreviewQuerySchemaBackgroundJobSuccess = {
  __typename?: 'PreviewQuerySchemaBackgroundJobSuccess';
  result: ColumnResponse;
  type: PreviewQuerySchemaStatus;
};

export const PreviewQuerySchemaStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type PreviewQuerySchemaStatus = typeof PreviewQuerySchemaStatus[keyof typeof PreviewQuerySchemaStatus];
/**
 * Which Snowflake role a preview ran under, when Snowflake RBAC applied an
 * override. Absent when the preview ran as the source's service account.
 * `basis` is "mapping" (the user's group mapping) or "default" (the source's
 * default role).
 */
export type PreviewRoleResolution = {
  __typename?: 'PreviewRoleResolution';
  basis: Scalars['String'];
  roleIdentifier: Scalars['String'];
};

export type PriorityList = {
  __typename?: 'PriorityList';
  audiences?: Maybe<Array<Audience>>;
  id: Scalars['String'];
  name: Scalars['String'];
  parentModelId: Scalars['String'];
};

export type ProcessingRowExportResponse = {
  __typename?: 'ProcessingRowExportResponse';
  status: Scalars['String'];
};

export type ProfileExplorerError = {
  __typename?: 'ProfileExplorerError';
  error: Scalars['String'];
};

export type ProfileExplorerJob = {
  __typename?: 'ProfileExplorerJob';
  jobId: Scalars['String'];
};

export const ProfileExplorerModelType = {
  Event: 'event',
  Related: 'related'
} as const;

export type ProfileExplorerModelType = typeof ProfileExplorerModelType[keyof typeof ProfileExplorerModelType];
export type ProfileIdentifierRowsQuery = {
  htId: Scalars['String'];
  identifier: Scalars['String'];
  limit: Scalars['Int'];
  value: Scalars['String'];
};

export type ProfileIdentifierStatsQuery = {
  htId: Scalars['String'];
};

export type ProfileIdentifierValuesQuery = {
  htId: Scalars['String'];
  identifier: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
};

export type ProfileMappingInput = {
  /**
   * The mapped column, stored verbatim in the profile_mappings jsonb. This is a
   * ColumnReference object (not a plain string), matching the shape the app
   * already writes to message_contents.profile_mappings.
   */
  column: Scalars['JSONObject'];
  templateKey: Scalars['String'];
};

export type ProfileMatchScoresQuery = {
  htId: Scalars['String'];
};

export type ProfileQuery = {
  htId: Scalars['String'];
};

export type ProfileSourceRowsQuery = {
  htId: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  source: Scalars['String'];
};

export type ProfileSourceStatsQuery = {
  htId: Scalars['String'];
};

export type ProfilesQuery = {
  pagination?: InputMaybe<PaginationInput>;
};

export type ProgressStep = {
  __typename?: 'ProgressStep';
  completed: Scalars['Boolean'];
  description: Scalars['String'];
  raw?: Maybe<Scalars['JSON']>;
};

export type PromoteAdStudioIdeaResponse = {
  __typename?: 'PromoteAdStudioIdeaResponse';
  id: Scalars['ID'];
};

export type PromoteContentNodeToPublicInput = {
  nodeId: Scalars['uuid'];
};

export type PromoteContentNodeToPublicResult = {
  __typename?: 'PromoteContentNodeToPublicResult';
  publicUrl: Scalars['String'];
};

export type PromoteFigmaImportDraftInput = {
  /**
   * When set, promote into a reusable component of this type instead of a
   * standalone template. Blank/omitted promotes as a template.
   */
  componentType?: InputMaybe<Scalars['String']>;
  draftId: Scalars['String'];
  name: Scalars['String'];
};

export type PromoteFigmaImportDraftResult = {
  __typename?: 'PromoteFigmaImportDraftResult';
  contentEmailId: Scalars['String'];
  droppedImageNodeIds?: Maybe<Array<Scalars['String']>>;
  promotedImageCount?: Maybe<Scalars['Int']>;
  warnings: Array<Scalars['String']>;
};

export type PromoteReportDraftInput = {
  draftVersionId: Scalars['uuid'];
  reportScheduleId: Scalars['uuid'];
};

export type PromptFacadeInput = {
  kind: Scalars['String'];
  label: Scalars['String'];
};

/**
 * Agent routing a review operation proposed. Absent when the operation leaves the doc's
 * existing routing alone.
 */
export type ProposedAgentScopes = {
  __typename?: 'ProposedAgentScopes';
  /** Empty widens to all agents. */
  value: Array<AgentScope>;
};

/**
 * Brand profile assignment a review operation proposed. Absent when the operation leaves
 * the doc's existing assignment alone.
 */
export type ProposedBrandProfileIds = {
  __typename?: 'ProposedBrandProfileIds';
  /** Empty widens to all brand profiles. */
  value: Array<Scalars['String']>;
};

/**
 * A context-type classification a review operation proposed. Absent when the operation
 * leaves the doc's existing classification alone.
 */
export type ProposedContextType = {
  __typename?: 'ProposedContextType';
  /** Null clears the classification. */
  value?: Maybe<ContextFileType>;
};

export type ProviderTimeSeries = {
  __typename?: 'ProviderTimeSeries';
  points: Array<DeliverabilityTimeSeriesPoint>;
  provider: Scalars['String'];
};

export type PublicImageJobErrorResult = {
  __typename?: 'PublicImageJobErrorResult';
  error: Scalars['String'];
};

export type PublicImageJobPending = {
  __typename?: 'PublicImageJobPending';
  jobId: Scalars['String'];
};

export type PublicImageJobResultResponse = PublicImageJobErrorResult | PublicImageJobSuccessResult;

export type PublicImageJobSuccessResult = {
  __typename?: 'PublicImageJobSuccessResult';
  publicUrl: Scalars['String'];
};

export type PublicImageReady = {
  __typename?: 'PublicImageReady';
  publicUrl: Scalars['String'];
};

export type PublishMessageDraftResult = {
  __typename?: 'PublishMessageDraftResult';
  draftVersion?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  metadataDraftVersion?: Maybe<Scalars['Int']>;
  metadataVersion?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type PublishStagedJourneyInput = {
  dry_run?: InputMaybe<Scalars['Boolean']>;
  journey_id: Scalars['String'];
  staged_version_id: Scalars['String'];
};

export type PublishStagedJourneyOutput = {
  __typename?: 'PublishStagedJourneyOutput';
  diff?: Maybe<JourneyDiff>;
  journey_id: Scalars['String'];
  journey_version_id: Scalars['String'];
};

export type PurgeWorkspacePredictiveTraitsQueueError = {
  __typename?: 'PurgeWorkspacePredictiveTraitsQueueError';
  error: Scalars['String'];
};

export type PurgeWorkspacePredictiveTraitsQueueResult = PurgeWorkspacePredictiveTraitsQueueError | PurgeWorkspacePredictiveTraitsQueueSuccess;

export type PurgeWorkspacePredictiveTraitsQueueSuccess = {
  __typename?: 'PurgeWorkspacePredictiveTraitsQueueSuccess';
  cancelledCount: Scalars['Int'];
  message: Scalars['String'];
};

export type PushActionButtonInput = {
  actionType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export const PushAppEnvironment = {
  Mock: 'mock',
  Production: 'production',
  Sandbox: 'sandbox'
} as const;

export type PushAppEnvironment = typeof PushAppEnvironment[keyof typeof PushAppEnvironment];
export const PushAppPlatform = {
  Android: 'android',
  Ios: 'ios'
} as const;

export type PushAppPlatform = typeof PushAppPlatform[keyof typeof PushAppPlatform];
export type PushAppResult = {
  __typename?: 'PushAppResult';
  id: Scalars['ID'];
};

export const PushOs = {
  Android: 'android',
  Ios: 'ios'
} as const;

export type PushOs = typeof PushOs[keyof typeof PushOs];
export type PushSendCreative = {
  __typename?: 'PushSendCreative';
  body: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type QueryColumn = {
  __typename?: 'QueryColumn';
  name: Scalars['String'];
  raw_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type QueryExportResult = {
  __typename?: 'QueryExportResult';
  data?: Maybe<Scalars['JSONObject']>;
  queryTime: Scalars['Float'];
};

export type QueryResponse = FailedQueryResponse | SuccessfulQueryResponse;

export type QueueAdForLaunchInput = {
  adBriefAssetId: Scalars['uuid'];
  adBriefAssetVersionId?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
};

export type QueueAdForLaunchResponse = {
  __typename?: 'QueueAdForLaunchResponse';
  id: Scalars['uuid'];
  status: Scalars['String'];
};

export type QueueEmailBestPracticeSessionInput = {
  artifactVersionId: Scalars['uuid'];
};

export type QueueEmailBestPracticeSessionResponse = {
  __typename?: 'QueueEmailBestPracticeSessionResponse';
  interactionId?: Maybe<Scalars['uuid']>;
  runId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type QueueMultipleAdsForLaunchInput = {
  items: Array<QueueMultipleAdsItem>;
  platform?: InputMaybe<Scalars['String']>;
};

export type QueueMultipleAdsForLaunchResponse = {
  __typename?: 'QueueMultipleAdsForLaunchResponse';
  count: Scalars['Int'];
  queued: Array<QueueAdForLaunchResponse>;
};

export type QueueMultipleAdsItem = {
  adBriefAssetId: Scalars['uuid'];
  adBriefAssetVersionId?: InputMaybe<Scalars['uuid']>;
};

export type QueueSource = {
  __typename?: 'QueueSource';
  active_pollers: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  error_timestamp?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  total_pollers: Scalars['Int'];
};

export type QuizAnswerSummaryAnswerInput = {
  detail?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
};

export type QuizAnswerSummaryInput = {
  actionLabel?: InputMaybe<Scalars['String']>;
  questions: Array<QuizAnswerSummaryQuestionInput>;
  title?: InputMaybe<Scalars['String']>;
  totalQuestions?: InputMaybe<Scalars['Int']>;
};

export type QuizAnswerSummaryQuestionInput = {
  answers: Array<QuizAnswerSummaryAnswerInput>;
  id?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  other?: InputMaybe<Scalars['String']>;
  skipped?: InputMaybe<Scalars['Boolean']>;
};

export const RtaWarehousePullMode = {
  /** User-initiated refresh; preserves the scheduled cadence. */
  OnDemand: 'ON_DEMAND',
  /** Force an immediate full refresh and reset the scheduled cadence. */
  Scheduled: 'SCHEDULED'
} as const;

export type RtaWarehousePullMode = typeof RtaWarehousePullMode[keyof typeof RtaWarehousePullMode];
export type RealtimeAddressTrait = {
  __typename?: 'RealtimeAddressTrait';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RealtimeEventColumnChangeInput = {
  new?: InputMaybe<RealtimeEventColumnInput>;
  old?: InputMaybe<RealtimeEventColumnInput>;
};

export type RealtimeEventColumnInput = {
  alias?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type RealtimeEventFieldInput = {
  jsonPath: Scalars['String'];
  type: Scalars['String'];
};

export const RealtimeEventModelKind = {
  EmittedEvent: 'EMITTED_EVENT',
  FunctionResponse: 'FUNCTION_RESPONSE'
} as const;

export type RealtimeEventModelKind = typeof RealtimeEventModelKind[keyof typeof RealtimeEventModelKind];
export type RealtimeFunctionConfig = {
  __typename?: 'RealtimeFunctionConfig';
  function_id: Scalars['String'];
  subscription_config: Scalars['JSONObject'];
};

export type RealtimeFunctionConfigInput = {
  function_id: Scalars['String'];
  subscription_config: Scalars['JSONObject'];
};

export type RealtimeJourneyConditionsAtPull = {
  __typename?: 'RealtimeJourneyConditionsAtPull';
  /** Compiled condition trees the pull read from the journey's nodes and exit criteria. */
  conditionTrees: Array<Scalars['JSONObject']>;
  /** Sync subscription configs the pull read from the journey's tiles. */
  syncConfigs: Array<Scalars['JSONObject']>;
};

export type RealtimeSyncConfig = {
  __typename?: 'RealtimeSyncConfig';
  destination_id: Scalars['String'];
  subscription_config: Scalars['JSONObject'];
};

export type RealtimeSyncConfigInput = {
  destination_id: Scalars['String'];
  subscription_config: Scalars['JSONObject'];
};

export type RecalculateEmbeddingsResult = {
  __typename?: 'RecalculateEmbeddingsResult';
  affectedRows: Scalars['Int'];
};

export type RefreshAllCepManagedModelsResult = {
  __typename?: 'RefreshAllCepManagedModelsResult';
  jobsEnqueued: Scalars['Int'];
};

export type RefreshCepProfileCacheResult = {
  __typename?: 'RefreshCepProfileCacheResult';
  jobId?: Maybe<Scalars['String']>;
  refresh: Scalars['Boolean'];
};

export type RefreshDecisionEngineFlowAudienceSizesResponse = {
  __typename?: 'RefreshDecisionEngineFlowAudienceSizesResponse';
  /** False when throttled: values are fresh (10-minute cooldown) or an equivalent refresh is already in flight. */
  enqueued: Scalars['Boolean'];
  jobId?: Maybe<Scalars['ID']>;
};

export const RefreshReportingCacheStatus = {
  AlreadyRunning: 'already_running',
  Started: 'started'
} as const;

export type RefreshReportingCacheStatus = typeof RefreshReportingCacheStatus[keyof typeof RefreshReportingCacheStatus];
export type RefreshSignalsResponse = {
  __typename?: 'RefreshSignalsResponse';
  enqueued: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reportScheduleId?: Maybe<Scalars['ID']>;
};

/**
 * Names the derived ad to regenerate. Its own id rebuilds it from the source
 * version it was made from. Its source ad's id with a channelSizeId replaces
 * the only live derived ad at that size from the source's current version and
 * is rejected when the size holds several. A channelSizeId sent with a derived
 * ad's id is ignored. A source ad alone is rejected.
 */
export type RegenerateSizeVariantInput = {
  assetId: Scalars['uuid'];
  channelSizeId?: InputMaybe<Scalars['uuid']>;
};

export type RegenerateSizeVariantResponse = {
  __typename?: 'RegenerateSizeVariantResponse';
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type RejectIdrChangePlanInput = {
  messageContentIndex: Scalars['Int'];
  messageId: Scalars['uuid'];
};

export type RelatedGoldenRecordModel = {
  __typename?: 'RelatedGoldenRecordModel';
  golden_record_id: Scalars['String'];
  idr_id: Scalars['String'];
  parent_model_id: Scalars['String'];
};

export type Relationship = {
  __typename?: 'Relationship';
  cardinality: Scalars['String'];
  cardinalityDetectionStatus?: Maybe<Scalars['String']>;
  detectedCardinality?: Maybe<Scalars['String']>;
  edgeId?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  fromName?: Maybe<Scalars['String']>;
  isHiddenFromAudienceFilter: Scalars['Boolean'];
  isMergingIntoFrom: Scalars['Boolean'];
  isMergingIntoTo: Scalars['Boolean'];
  joinMappings: Array<JoinMapping>;
  reverseEdgeId?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  to: Scalars['String'];
  toName?: Maybe<Scalars['String']>;
};

export type RelaunchMetaAdConfigInput = {
  adName?: InputMaybe<Scalars['String']>;
  callToAction?: InputMaybe<Scalars['String']>;
  callToActions?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<Scalars['String']>>;
  destinationUrl?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  headlines?: InputMaybe<Array<Scalars['String']>>;
  primaryText?: InputMaybe<Scalars['String']>;
  primaryTexts?: InputMaybe<Array<Scalars['String']>>;
  selectedAspectRatios?: InputMaybe<Array<Scalars['String']>>;
  selectedImageStorageKeys: Array<SelectedImageStorageKeyInput>;
  selectedSizeVariantsByRatio?: InputMaybe<Array<SelectedSizeVariantByRatioInput>>;
  urlParameters?: InputMaybe<Scalars['String']>;
};

export type RelaunchMetaAdInput = {
  adBriefAssetVersionId?: InputMaybe<Scalars['uuid']>;
  adConfig?: InputMaybe<RelaunchMetaAdConfigInput>;
  launchId: Scalars['uuid'];
};

export type RelaunchMetaAdResponse = {
  __typename?: 'RelaunchMetaAdResponse';
  id: Scalars['uuid'];
  launchedAt: Scalars['String'];
  metaAdId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/**
 * The single most relevant report card for the current user on the agentic
 * homepage, ranked by their tracked report views. Null when the workspace has no
 * eligible report (a completed, non-hidden run with a card summary).
 */
export type RelevantReportCard = {
  __typename?: 'RelevantReportCard';
  cardSummary?: Maybe<Scalars['JSON']>;
  finishedAt?: Maybe<Scalars['String']>;
  reportId: Scalars['uuid'];
  reportName: Scalars['String'];
  runId: Scalars['uuid'];
};

export type RemoveAdFromLaunchQueueInput = {
  queuedAdId: Scalars['uuid'];
};

export type RemoveAdFromLaunchQueueResponse = {
  __typename?: 'RemoveAdFromLaunchQueueResponse';
  success: Scalars['Boolean'];
};

export type RemoveManifestDayResult = DecisionEngineError | RemoveManifestDaySuccess;

export type RemoveManifestDaySuccess = {
  __typename?: 'RemoveManifestDaySuccess';
  /** The manifest revision created by the edit — now the latest for the flow */
  newManifestId: Scalars['uuid'];
};

export type RenameMessagePlanInput = {
  name: Scalars['String'];
  planId: Scalars['uuid'];
};

export type RenameMessagePlanResponse = {
  __typename?: 'RenameMessagePlanResponse';
  name: Scalars['String'];
  planId: Scalars['uuid'];
};

export type RenderMessageDynamicSlotBranchInput = {
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type RenderMessageDynamicSlotInput = {
  branches: Array<RenderMessageDynamicSlotBranchInput>;
  libraryId: Scalars['ID'];
  previewBranchId: Scalars['ID'];
  usageId: Scalars['ID'];
};

export type RenderMessageError = {
  __typename?: 'RenderMessageError';
  column: Scalars['String'];
  templateKey: Scalars['String'];
  type: Scalars['String'];
};

export type RenderMessageInput = {
  /**
   * Preview-only overrides for control-plane variables (topic_name,
   * message_send_id, …) — the CP lane. Only the vars the user explicitly
   * edited; anything omitted is resolved to its real value server-side. Kept
   * separate from profileData so the two categories never munge.
   */
  controlPlaneVariableOverrides?: InputMaybe<Scalars['JSONObject']>;
  /**
   * Explicit preview-only overrides for csv_* variables, applied after the campaign CSV lookup.
   * Omitted keys use CSV values; null previews an unset value. Does not affect campaign sends.
   */
  csvVariableOverrides?: InputMaybe<Scalars['JSONObject']>;
  dynamicSlots?: InputMaybe<Array<RenderMessageDynamicSlotInput>>;
  /**
   * Render the message as a recipient in this locale would receive it. The body's
   * own `{% ht_loc %}` tags resolve against `translations` during the render pass,
   * hash-guarded, so text edited since a translation was written renders in the
   * default language rather than showing a stale translation. Requires
   * `translations`. Omit to render the source language.
   */
  localeId?: InputMaybe<Scalars['ID']>;
  /**
   * Wrap each localizable text element of the rendered body in a span carrying its
   * identity (`data-ht-key="{element key}:{slot}"`), so the Localize tab can map a
   * click in the preview to the element it belongs to. Preview-only; works with or
   * without a locale, since elements are picked before anything is translated.
   */
  localizationSelectable?: InputMaybe<Scalars['Boolean']>;
  /**
   * The message being previewed. When provided, the resolver resolves the
   * message-derived control-plane variables (topic_name, message_id) so the
   * preview renders the same values the send path would.
   */
  messageId?: InputMaybe<Scalars['ID']>;
  /**
   * Warehouse (parent-model) profile data — the CDW lane. Control-plane
   * variables do NOT belong here; send those in controlPlaneVariableOverrides.
   */
  profileData: Scalars['JSONObject'];
  smsLink?: InputMaybe<Scalars['String']>;
  /**
   * Record of template key -> Liquid template string. Every value must be a
   * string (the resolver validates at runtime). Message previews use the
   * well-known keys subject/subtitle/preheader/html ("html" additionally
   * gets content-block rewriting, and those four keys can emit sourcemaps);
   * callers may pass arbitrary additional keys, e.g. the test-push config
   * fields. JSONObject rather than a closed input type because key sets can
   * be dynamic and keys need not be legal GraphQL names (btn.0.name,
   * custom.0, ...).
   */
  templateData: Scalars['JSONObject'];
  /**
   * The locale's translations as the caller holds them. Every templateData value is
   * rendered as sent and must carry its own `{% ht_loc %}` tags, whole fields like a
   * subject included, since the resolver stamps nothing. So a host previews the
   * stamped copy and rows it holds rather than whatever the store last saw. Embedded
   * content-block rows are still read from the store. Required with localeId; an
   * empty list renders every tag in the default language.
   */
  translations?: InputMaybe<Array<RenderMessageTranslationInput>>;
};

export type RenderMessageResult = {
  __typename?: 'RenderMessageResult';
  /**
   * Optional per-template-key map of conditionally rendered block ranges over
   * the same rendered output as `sourceMaps` — one range per `{% if %}` /
   * `{% elsif %}` / `{% else %}` / `{% unless %}` / `{% case %}` branch
   * body that actually rendered. Only populated when the client selects this
   * field. Shape: `{ [templateKey: string]: Array<{ start: number; end: number }> }`
   * with the same offset conventions as `sourceMaps`.
   */
  blockSourceMaps?: Maybe<Scalars['JSONObject']>;
  errors: Array<RenderMessageError>;
  rendered: Scalars['JSONObject'];
  /**
   * Effective control-plane variable values used for this render (real
   * resolved defaults with any caller overrides applied). Lets the editor's
   * attribute panel show the same values that were rendered, rather than a
   * sample.
   */
  resolvedControlPlaneVariables: Scalars['JSONObject'];
  /**
   * Optional per-template-key map of click-to-edit popover ranges over the
   * rendered output. Only populated when the client selects this field;
   * otherwise the resolver skips the sourcemap pipeline entirely so existing
   * callers see byte-identical behavior. Shape:
   * `{ [templateKey: string]: Array<{ start: number; end: number; name: string }> }`
   * where `start` is inclusive and `end` is exclusive (UTF-16 offsets into
   * `rendered[templateKey]`); `start === end` is valid and represents an
   * empty rendered variable.
   */
  sourceMaps?: Maybe<Scalars['JSONObject']>;
};

export type RenderMessageTranslationInput = {
  elementKey: Scalars['String'];
  slot: Scalars['String'];
  sourceHash: Scalars['String'];
  value: Scalars['String'];
};

export type RenderedEmailWithContentBlocks = {
  __typename?: 'RenderedEmailWithContentBlocks';
  espDestination?: Maybe<EspDestinationInfo>;
  html?: Maybe<Scalars['String']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  unresolvedContentBlocks: Array<UnresolvedContentBlock>;
  /**
   * Provider-side failures hit while expanding content blocks (auth, rate
   * limits, timeouts) — distinct from blocks missing from the catalog.
   */
  verificationErrors: Array<Scalars['String']>;
};

export type RenderedMonitorConditionStatus = {
  __typename?: 'RenderedMonitorConditionStatus';
  conditionType: Scalars['String'];
  evaluatedAt: Scalars['String'];
  eventTime: Scalars['String'];
  id: Scalars['uuid'];
  metadata?: Maybe<RenderedMonitorConditionStatusMetadata>;
  muteUntil?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type RenderedMonitorConditionStatusMetadata = {
  __typename?: 'RenderedMonitorConditionStatusMetadata';
  error?: Maybe<Scalars['String']>;
};

/** Staff-only cross-workspace lookup of a report run's card summary by run ID for debugging. */
export type ReportCardByRunId = {
  __typename?: 'ReportCardByRunId';
  cardSummary?: Maybe<Scalars['JSON']>;
  finishedAt?: Maybe<Scalars['String']>;
  reportName: Scalars['String'];
  runId: Scalars['uuid'];
  workspaceId: Scalars['String'];
};

export type ReportCommentInput = {
  annotation: Scalars['String'];
  kind: ReportCommentKind;
  sectionHeading?: InputMaybe<Scalars['String']>;
};

export const ReportCommentKind = {
  Overall: 'overall',
  Preamble: 'preamble',
  Section: 'section'
} as const;

export type ReportCommentKind = typeof ReportCommentKind[keyof typeof ReportCommentKind];
export type ReportCustomization = {
  __typename?: 'ReportCustomization';
  predefinedQuestions: ReportPredefinedQuestions;
  questions: Array<ReportCustomizationQuestion>;
};

export type ReportCustomizationQuestion = {
  __typename?: 'ReportCustomizationQuestion';
  id: Scalars['String'];
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type ReportPredefinedQuestions = {
  __typename?: 'ReportPredefinedQuestions';
  channels?: Maybe<Array<Scalars['String']>>;
  comparison?: Maybe<Scalars['String']>;
  format: Scalars['String'];
  timePeriod?: Maybe<Scalars['String']>;
};

export type ReportScheduleContentMutationResponse = {
  __typename?: 'ReportScheduleContentMutationResponse';
  id: Scalars['uuid'];
};

export type ReportVersionMissingReference = {
  __typename?: 'ReportVersionMissingReference';
  id: Scalars['String'];
  kind: Scalars['String'];
};

export type ReportVersionReferenceCheck = {
  __typename?: 'ReportVersionReferenceCheck';
  missingReferences: Array<ReportVersionMissingReference>;
  ok: Scalars['Boolean'];
};

export type RequestArtifactReviewsInput = {
  artifactId: Scalars['uuid'];
  artifactVersionId: Scalars['uuid'];
  message?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type RequestArtifactReviewsResponse = {
  __typename?: 'RequestArtifactReviewsResponse';
  invalidatedReviewIds: Array<Scalars['uuid']>;
  reviewIds: Array<Scalars['uuid']>;
};

export type RequestInfo = {
  __typename?: 'RequestInfo';
  data: Scalars['JSONObject'];
  requestType: Scalars['String'];
};

export type ResetCachedEventPullWatermarkError = {
  __typename?: 'ResetCachedEventPullWatermarkError';
  error: Scalars['String'];
};

export type ResetCachedEventPullWatermarkInput = {
  cachedEventPullId: Scalars['uuid'];
};

export type ResetCachedEventPullWatermarkResult = ResetCachedEventPullWatermarkError | ResetCachedEventPullWatermarkSuccess;

export type ResetCachedEventPullWatermarkSuccess = {
  __typename?: 'ResetCachedEventPullWatermarkSuccess';
  cachedEventPullId: Scalars['uuid'];
  message: Scalars['String'];
};

export type ResetFeatureDefinitionCachedStateError = {
  __typename?: 'ResetFeatureDefinitionCachedStateError';
  error: Scalars['String'];
};

export type ResetFeatureDefinitionCachedStateInput = {
  featureDefinitionId: Scalars['uuid'];
};

export type ResetFeatureDefinitionCachedStateResult = ResetFeatureDefinitionCachedStateError | ResetFeatureDefinitionCachedStateSuccess;

export type ResetFeatureDefinitionCachedStateSuccess = {
  __typename?: 'ResetFeatureDefinitionCachedStateSuccess';
  featureDefinitionId: Scalars['uuid'];
  message: Scalars['String'];
};

export type ResetPredictorStateError = {
  __typename?: 'ResetPredictorStateError';
  error: Scalars['String'];
};

export type ResetPredictorStateInput = {
  predictorId: Scalars['uuid'];
};

export type ResetPredictorStateResult = ResetPredictorStateError | ResetPredictorStateSuccess;

export type ResetPredictorStateSuccess = {
  __typename?: 'ResetPredictorStateSuccess';
  message: Scalars['String'];
  predictorId: Scalars['uuid'];
};

export type ResizeTemplateInput = {
  entityId: Scalars['uuid'];
  entityVersionId: Scalars['uuid'];
};

export type ResourceAuthorization = {
  __typename?: 'ResourceAuthorization';
  isAuthorized: Scalars['Boolean'];
};

export type ResourceAuthorizationBatchInput = {
  v2?: InputMaybe<ResourceAuthorizationInput>;
};

export type ResourceAuthorizationInput = {
  creationOptions?: InputMaybe<CreationOptions>;
  grant: CanAction;
  id?: InputMaybe<Scalars['String']>;
  resource: UserGroupResourceType;
};

export type ResourceDraftResult = {
  __typename?: 'ResourceDraftResult';
  id: Scalars['String'];
};

export type ResourceGroupCanAction = {
  __typename?: 'ResourceGroupCanAction';
  resourceId: Scalars['String'];
  userGroupIds: Array<Scalars['String']>;
};

export type ResourceHealthMetric = {
  __typename?: 'ResourceHealthMetric';
  conditionChangeIds: Array<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  timeBucket: Scalars['String'];
};

export type ResourceLink = {
  __typename?: 'ResourceLink';
  id: Scalars['bigint'];
  resource_id: Scalars['bigint'];
  workspace: ResourceLinkWorkspace;
};

export type ResourceLinkWorkspace = {
  __typename?: 'ResourceLinkWorkspace';
  id: Scalars['bigint'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export const ResourceType = {
  Organization: 'organization',
  Workspace: 'workspace'
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];
export type ResourcesWithCanActionInput = {
  action: CanAction;
  resourceType: UserGroupResourceType;
};

export type ResourcesWithCanActionResult = {
  __typename?: 'ResourcesWithCanActionResult';
  resources: Array<ResourceGroupCanAction>;
};

export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  completedAt?: Maybe<Scalars['String']>;
  content: Scalars['JSON'];
  createdAt?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  messageContentIndex?: Maybe<Scalars['Int']>;
  messageId?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
};

export type RestoreReportVersionInput = {
  reportScheduleId: Scalars['uuid'];
  targetVersionId: Scalars['uuid'];
};

export type RetryArchivedFailuresInput = {
  fromDate: Scalars['String'];
  syncId: Scalars['String'];
};

export type RetryArchivedFailuresResult = {
  __typename?: 'RetryArchivedFailuresResult';
  numRetried: Scalars['Int'];
};

export type ReverseTunnel = Tunnel & {
  __typename?: 'ReverseTunnel';
  createdAt?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sshdPort?: Maybe<Scalars['Int']>;
  tunnelPort?: Maybe<Scalars['Int']>;
};

export type ReverseTunnelInput = {
  name: Scalars['String'];
};

export type ReverseTunnelOutput = {
  __typename?: 'ReverseTunnelOutput';
  privateKeyBase64?: Maybe<Scalars['String']>;
  tunnel: ReverseTunnel;
};

export type ReviewAgent = {
  __typename?: 'ReviewAgent';
  brandProfileId: Scalars['uuid'];
  createdAt: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /**
   * Null when the attached entity has been deleted. The agent is still
   * returned, so the UI can say what is wrong with it.
   */
  skill?: Maybe<ReviewAgentSkill>;
  updatedAt: Scalars['String'];
};

export type ReviewAgentPayload = {
  __typename?: 'ReviewAgentPayload';
  brandProfileId: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  settingsEntityId: Scalars['uuid'];
};

/**
 * isSkill is false once the entity has been reclassified away from a skill —
 * the attachment is only validated when it is written.
 */
export type ReviewAgentSkill = {
  __typename?: 'ReviewAgentSkill';
  id: Scalars['uuid'];
  isSkill: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ReviewCampaignDraftResult = {
  __typename?: 'ReviewCampaignDraftResult';
  /** True when approving also launched a draft campaign. */
  campaignLaunched: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** Launch validation errors, when approval succeeded but the launch did not. */
  launchErrors?: Maybe<Array<Scalars['String']>>;
  status: Scalars['String'];
};

export type ReviewJourneyDraftResult = {
  __typename?: 'ReviewJourneyDraftResult';
  id: Scalars['uuid'];
  status: Scalars['String'];
};

/** The message content and metadata versions rendered on the reviewer's screen. */
export type ReviewedMessageVersionInput = {
  contentVersion: Scalars['Int'];
  messageId: Scalars['uuid'];
  metadataVersion?: InputMaybe<Scalars['Int']>;
};

export type RowExportBackgroundResult = {
  __typename?: 'RowExportBackgroundResult';
  jobId: Scalars['String'];
};

export const RowExportFormat = {
  Csv: 'csv',
  Json: 'json'
} as const;

export type RowExportFormat = typeof RowExportFormat[keyof typeof RowExportFormat];
export type RowExportResponse = FailedRowExportResponse | ProcessingRowExportResponse | SuccessfulRowExportResponse;

export const RowExportType = {
  All: 'all',
  Error: 'error',
  Success: 'success'
} as const;

export type RowExportType = typeof RowExportType[keyof typeof RowExportType];
export type RunAssetClassificationResult = {
  __typename?: 'RunAssetClassificationResult';
  enqueued: Scalars['Boolean'];
};

export type RunExposureLogResolutionResponse = {
  __typename?: 'RunExposureLogResolutionResponse';
  jobId: Scalars['String'];
};

export type RunMatchBoosterTestResponse = {
  __typename?: 'RunMatchBoosterTestResponse';
  jobId: Scalars['String'];
};

export type RunOpportunityDefinitionResponse = {
  __typename?: 'RunOpportunityDefinitionResponse';
  enqueued: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reportScheduleId: Scalars['ID'];
};

export type RunningTagsJobResponse = {
  __typename?: 'RunningTagsJobResponse';
  createdAt?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['JSONObject']>;
  jobId?: Maybe<Scalars['String']>;
};

export type SalesloftCustomFields = {
  __typename?: 'SalesloftCustomFields';
  field_type: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  standardType: StandardFieldType;
  value_type: Scalars['String'];
};

export type SalesloftCustomFieldsInput = {
  destinationId: Scalars['String'];
};

export type SalesloftCustomFieldsResult = SalesloftCustomFieldsSuccess;

export type SalesloftCustomFieldsSuccess = {
  __typename?: 'SalesloftCustomFieldsSuccess';
  fields: Array<SalesloftCustomFields>;
};

export type SampleModel = {
  __typename?: 'SampleModel';
  name: Scalars['String'];
  sql: Scalars['String'];
};

export const SampledSegmentJobStatus = {
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
  Finished: 'FINISHED'
} as const;

export type SampledSegmentJobStatus = typeof SampledSegmentJobStatus[keyof typeof SampledSegmentJobStatus];
export type SaveAgentAudienceInput = {
  audienceDefinition: Scalars['JSONObject'];
  sessionId: Scalars['uuid'];
};

export type SaveAgentAudienceResponse = {
  __typename?: 'SaveAgentAudienceResponse';
  id: Scalars['bigint'];
};

/**
 * Approve and edit are the same write: content, status and scope are all
 * replaced wholesale in one transaction, with brand profiles and agents
 * replaced only when given. expectedVersionId is the
 * latestVersionId the caller read, and rejects the write when a newer
 * version exists.
 */
export type SaveAgentDefinitionInput = {
  /** Omit to keep the current agents. Empty applies the definition to all agents. */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  /** The assumed version being approved; recorded on the verified version this save writes. */
  basedOnVersionId?: InputMaybe<Scalars['uuid']>;
  /** Omit to keep the current assignments. Empty applies the definition to all brand profiles. */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  expectedVersionId: Scalars['uuid'];
  id: Scalars['uuid'];
  markdown: Scalars['String'];
  name: Scalars['String'];
  scope: AgenticSettingsEntityScopeInput;
  status: AgentDefinitionStatus;
  usageGuidance?: InputMaybe<Scalars['String']>;
};

export type SaveArtifactErrorResponse = {
  __typename?: 'SaveArtifactErrorResponse';
  error: Scalars['String'];
};

export type SaveArtifactInput = {
  artifactId: Scalars['uuid'];
  content: Scalars['String'];
  /**
   * When saving a campaign brief, whether to enqueue an agent run that
   * reconciles the campaign's message plans against the edited brief. Defaults
   * to true (the historical behavior). Pass false to persist the brief edit
   * without touching existing message plans.
   */
  reconcileMessagePlans?: InputMaybe<Scalars['Boolean']>;
};

export type SaveArtifactResponse = SaveArtifactErrorResponse | SaveArtifactSuccessResponse;

export type SaveArtifactSuccessResponse = {
  __typename?: 'SaveArtifactSuccessResponse';
  version: Scalars['Int'];
};

export type SaveCalendarContextInput = {
  expectedVersionId?: InputMaybe<Scalars['ID']>;
  markdown: Scalars['String'];
};

export type SaveContentArtifactVersionErrorResponse = {
  __typename?: 'SaveContentArtifactVersionErrorResponse';
  error: Scalars['String'];
};

export type SaveContentArtifactVersionInput = {
  artifactId: Scalars['uuid'];
  content: Scalars['JSON'];
  metadata?: InputMaybe<ContentArtifactMetadataInput>;
};

export type SaveContentArtifactVersionResponse = SaveContentArtifactVersionErrorResponse | SaveContentArtifactVersionSuccessResponse;

export type SaveContentArtifactVersionSuccessResponse = {
  __typename?: 'SaveContentArtifactVersionSuccessResponse';
  version: Scalars['Int'];
  versionId: Scalars['uuid'];
};

export type SaveCreativeDimensionInput = {
  assetGroupId?: InputMaybe<Scalars['ID']>;
  /** The config for that type. An ai enum's values come from the values argument. */
  config: Scalars['JSON'];
  description?: InputMaybe<Scalars['String']>;
  /** The row to edit. Omit it to create a tag or override a system tag. */
  id?: InputMaybe<Scalars['ID']>;
  key: Scalars['String'];
  name: Scalars['String'];
  namespace: Scalars['String'];
  /** How the dimension is evaluated: ai or pipeline. */
  type: Scalars['String'];
  /** The full list of values. Values left out are rejected; omit it to keep the list. */
  values?: InputMaybe<Array<CreativeDimensionValueInput>>;
};

export type SaveCreativeDimensionResult = {
  __typename?: 'SaveCreativeDimensionResult';
  id: Scalars['ID'];
  version: Scalars['Int'];
};

export type SaveDecisionEngineChannelInput = {
  config: Scalars['JSONObject'];
  decision_engine_id: Scalars['uuid'];
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  send_event?: InputMaybe<SaveDecisionEngineChannelSendEventInput>;
  send_event_id?: InputMaybe<Scalars['uuid']>;
  type: Scalars['String'];
};

export type SaveDecisionEngineChannelSendEventInput = {
  attribution: Scalars['JSONObject'];
  filter?: InputMaybe<Scalars['JSONObject']>;
  id?: InputMaybe<Scalars['uuid']>;
  name: Scalars['String'];
  segment_id: Scalars['bigint'];
};

export type SaveDecisionEngineFlowMessageInput = {
  collections?: InputMaybe<Array<SaveDecisionEngineMessageCollectionInput>>;
  flowMessageConfig?: InputMaybe<Scalars['JSONObject']>;
  messageConfig?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  offerId?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
};

export type SaveDecisionEngineMessageCollectionInput = {
  collectionId: Scalars['uuid'];
  itemCount: Scalars['Int'];
};

export type SaveDefaultAssignmentSourceResult = {
  __typename?: 'SaveDefaultAssignmentSourceResult';
  saved: Scalars['Boolean'];
};

export type SaveEntitlementChangesInput = {
  grants: Array<EntitlementFeatureGrantInput>;
  presets: Array<EntitlementPresetGrantInput>;
  revocations: Array<Scalars['String']>;
  workspaceId: Scalars['ID'];
};

export type SaveEspDestinationResult = {
  __typename?: 'SaveEspDestinationResult';
  saved: Scalars['Boolean'];
};

export type SaveInAppMessageContentInput = {
  messageId: Scalars['ID'];
  templateId: Scalars['ID'];
  values: Scalars['JSONObject'];
};

export type SaveMessageAbTestInput = {
  element: Scalars['String'];
  measurementWindow?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  name: Scalars['String'];
  primaryMetric?: InputMaybe<MessageAbTestPrimaryMetricInput>;
  secondaryMetrics?: InputMaybe<Array<MessageAbTestPrimaryMetricInput>>;
  variants: Array<MessageVariantArmInput>;
};

export type SaveMessageAbTestResult = {
  __typename?: 'SaveMessageAbTestResult';
  arms: Array<MessageAbTestArm>;
  experimentId: Scalars['uuid'];
  messageExperimentId: Scalars['uuid'];
};

/**
 * Sparse writes: body (editorState/renderedOutput) is written to
 * message_contents only; subject/preheader to message_contents_metadata only.
 */
export type SaveMessageBodyInput = {
  editorState?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  profileMappings: Array<ProfileMappingInput>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  version: Scalars['Int'];
};

/**
 * Content payload for a message version write. Body (editorState/renderedOutput)
 * stays in message_contents; subject/preheader are mirrored into
 * message_contents_metadata during the copy-forward window.
 */
export type SaveMessageContentInput = {
  dynamicContent?: InputMaybe<DynamicContentChangesetInput>;
  editorState?: InputMaybe<Scalars['JSONObject']>;
  messageId: Scalars['uuid'];
  preheader?: InputMaybe<Scalars['String']>;
  profileMappings: Array<ProfileMappingInput>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  subject?: InputMaybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type SaveMessageContentResult = {
  __typename?: 'SaveMessageContentResult';
  id: Scalars['uuid'];
  version: Scalars['Int'];
};

export type SaveMessageMetadataInput = {
  messageId: Scalars['uuid'];
  preheader?: InputMaybe<Scalars['String']>;
  profileMappings: Array<ProfileMappingInput>;
  subject?: InputMaybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type SaveModelConfigurationInput = {
  custom_query?: InputMaybe<Scalars['JSONObject']>;
  is_streamable?: InputMaybe<Scalars['Boolean']>;
  primary_key?: InputMaybe<Scalars['String']>;
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['JSONObject']>;
  query_looker_look_id?: InputMaybe<Scalars['String']>;
  query_raw_sql?: InputMaybe<Scalars['String']>;
  query_table_name?: InputMaybe<Scalars['String']>;
  query_type: Scalars['String'];
  realtime_enabled?: InputMaybe<Scalars['Boolean']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
};

export type SaveSessionAssumptionInput = {
  assumptionKey?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
  title: Scalars['String'];
};

export type SaveSessionAssumptionResponse = {
  __typename?: 'SaveSessionAssumptionResponse';
  definitionId: Scalars['uuid'];
};

export type SavedChartRunData = {
  __typename?: 'SavedChartRunData';
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  isStale: Scalars['Boolean'];
  pendingChartCardRun?: Maybe<SavedChartRunHandle>;
  savedChartId: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type SavedChartRunHandle = {
  __typename?: 'SavedChartRunHandle';
  chartCardRunId: Scalars['uuid'];
  createdAt?: Maybe<Scalars['String']>;
  savedChartId: Scalars['uuid'];
};

export type SavedDecisionEngineChannel = {
  __typename?: 'SavedDecisionEngineChannel';
  id: Scalars['uuid'];
};

export type ScenarioFallback = {
  __typename?: 'ScenarioFallback';
  kind: ScenarioFallbackKind;
  /** The literal text (may be empty), or the expression's source. Empty for `unset`. */
  value: Scalars['String'];
};

/** `literal` is text the recipient sees; `expression` is an argument we can name but not evaluate; `unset` is a usage carrying no `default:`. */
export const ScenarioFallbackKind = {
  Expression: 'expression',
  Literal: 'literal',
  Unset: 'unset'
} as const;

export type ScenarioFallbackKind = typeof ScenarioFallbackKind[keyof typeof ScenarioFallbackKind];
/**
 * One scenario chip the marketer selected. `column` is the merge-tag key
 * (`template_key`) — the bare column name for a raw column, or the prefixed
 * key (e.g. `merged_<name>`) for a merged column. `value` is the chosen
 * top-k bucket (`""` = unset, `"filled"` = is-not-null for substitution
 * vars, otherwise an equals match). Only raw and merged columns are supported
 * in V1; selections on other column kinds are ignored.
 */
export type ScenarioSelectionInput = {
  column: Scalars['String'];
  /**
   * When set, this is the residual ("matches none of these values") — the
   * Fallback box. Builds `IS NULL OR NOT-IN(residualValues)` for control flow,
   * or `IS NULL` for substitution. Mutually exclusive with `value`.
   */
  residualValues?: InputMaybe<Array<Scalars['String']>>;
  type: ScenarioVariableType;
  /**
   * A single chosen value (`""` = unset/IS NULL, `"filled"` = IS NOT NULL for
   * substitution vars, otherwise equals). Omitted for a residual selection.
   */
  value?: InputMaybe<Scalars['String']>;
};

/**
 * The kind of template variable a scenario selection targets. Disambiguates the
 * `"filled"` sentinel value, which only means is-not-null for substitution vars.
 */
export const ScenarioVariableType = {
  ControlFlow: 'control_flow',
  Variable: 'variable'
} as const;

export type ScenarioVariableType = typeof ScenarioVariableType[keyof typeof ScenarioVariableType];
export type SearchContentImagesInput = {
  assetGroupId?: InputMaybe<Scalars['uuid']>;
  disableEnhancedSearch?: InputMaybe<Scalars['Boolean']>;
  disableTextSearch?: InputMaybe<Scalars['Boolean']>;
  disableVectorSearch?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  rrfK?: InputMaybe<Scalars['Int']>;
  textWeight?: InputMaybe<Scalars['Float']>;
  threshold?: InputMaybe<Scalars['Float']>;
  vectorWeight?: InputMaybe<Scalars['Float']>;
};

export type SearchContentImagesResult = {
  __typename?: 'SearchContentImagesResult';
  agentDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  mimeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  presignedUrl: Scalars['String'];
  similarity: Scalars['Float'];
  sizeBytes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  width?: Maybe<Scalars['Int']>;
};

export type SearchLookerLooksOutput = {
  __typename?: 'SearchLookerLooksOutput';
  looks: Array<LookerLook>;
};

export type SeedRowError = {
  __typename?: 'SeedRowError';
  email: Scalars['String'];
  reason: Scalars['String'];
};

export type SeedRowInput = {
  email: Scalars['String'];
  vars: Scalars['JSONObject'];
};

export type SegmentsRatio = {
  __typename?: 'SegmentsRatio';
  ratio: Scalars['Float'];
  segmentId: Scalars['String'];
};

export type SelectedImageStorageKeyInput = {
  aspectRatio: Scalars['String'];
  storageKey: Scalars['String'];
};

export type SelectedSizeVariantByRatioInput = {
  adBriefAssetSizeVariantId?: InputMaybe<Scalars['uuid']>;
  adBriefAssetVersionId?: InputMaybe<Scalars['uuid']>;
  aspectRatio: Scalars['String'];
};

/** Mirrors the SemanticViewDefinition interface type in core/sources — keep the shapes aligned. */
export type SemanticViewDefinition = {
  __typename?: 'SemanticViewDefinition';
  /** Raw DDL (Snowflake) or CREATE ... LANGUAGE YAML statement (Databricks). The lossless source of truth; the structured fields are a best-effort projection. */
  definition: Scalars['String'];
  dimensions: Array<SemanticViewField>;
  /** Which engine's dialect the expressions are written in. */
  engine?: Maybe<Scalars['String']>;
  /** View-level row filter applied to every query (Databricks). */
  filter?: Maybe<Scalars['String']>;
  metrics: Array<SemanticViewField>;
  /** Best-effort list of fully-qualified tables the view references. */
  referencedTables: Array<Scalars['String']>;
};

/** Mirrors the SemanticViewField interface type in core/sources — keep the shapes aligned. */
export type SemanticViewField = {
  __typename?: 'SemanticViewField';
  comment?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Logical table the field is declared on, when the engine attributes it. */
  sourceAlias?: Maybe<Scalars['String']>;
  /** Business-name synonyms, where the engine declares them (Snowflake). */
  synonyms?: Maybe<Array<Scalars['String']>>;
};

export type SemanticViewReferenceInput = {
  /** Top-level namespace: database in Snowflake, catalog in Databricks. */
  catalog?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  schema: Scalars['String'];
};

export type SemanticViewSummary = {
  __typename?: 'SemanticViewSummary';
  catalog?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  schema: Scalars['String'];
};

export type SendAmpAgentMessageInput = {
  agentId: Scalars['uuid'];
  /** The context snapshot of the sender, with the same keys and limits as on createAmpAgent. Omitted or null sends no snapshot, and the agent keeps the previous snapshot of the sender. */
  context?: InputMaybe<Scalars['JSON']>;
  /** Metadata that the chat reads apart from the text, with the fields of user message metadata that an AMP agent message carries, such as quizAnswerSummary. The agent sees only the text. Unknown fields are dropped. Omitted or null sends none. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Files that the member uploaded through initiateChatFileUploads, sent with the message. */
  preUploadedFiles?: InputMaybe<Array<SessionFileInput>>;
  text: Scalars['String'];
};

export type SendAmpAgentMessageResponse = {
  __typename?: 'SendAmpAgentMessageResponse';
  /** The interaction that the message joined or opened. */
  interactionId: Scalars['uuid'];
  message: AmpAgentMessage;
};

export type SendConfigFinding = {
  __typename?: 'SendConfigFinding';
  channelId: Scalars['String'];
  channelType: Scalars['String'];
  code: SendConfigFindingCode;
  message: Scalars['String'];
  severity: SendConfigFindingSeverity;
};

export const SendConfigFindingCode = {
  CampaignIdHasOuterWhitespace: 'campaign_id_has_outer_whitespace',
  CampaignIdsLookLikeNames: 'campaign_ids_look_like_names',
  MissingCampaignColumn: 'missing_campaign_column',
  NoSendEvent: 'no_send_event'
} as const;

export type SendConfigFindingCode = typeof SendConfigFindingCode[keyof typeof SendConfigFindingCode];
export const SendConfigFindingSeverity = {
  Error: 'error',
  Info: 'info',
  Warning: 'warning'
} as const;

export type SendConfigFindingSeverity = typeof SendConfigFindingSeverity[keyof typeof SendConfigFindingSeverity];
export type SendCounts = {
  __typename?: 'SendCounts';
  total: Scalars['Int'];
  unmatched: Scalars['Int'];
};

export type SendDiagnostics = {
  __typename?: 'SendDiagnostics';
  configFindings: Array<SendConfigFinding>;
  evalEndDate: Scalars['String'];
  evalStartDate: Scalars['String'];
  generatedAt: Scalars['String'];
  sliceStatus: SendDiagnosticsSliceStatus;
  suspects: Array<SendDropSuspect>;
};

export const SendDiagnosticsSliceStatus = {
  Available: 'available',
  NoSyncLogs: 'no_sync_logs',
  NoSyncs: 'no_syncs',
  UnsentFiltered: 'unsent_filtered'
} as const;

export type SendDiagnosticsSliceStatus = typeof SendDiagnosticsSliceStatus[keyof typeof SendDiagnosticsSliceStatus];
export type SendDropSuspect = {
  __typename?: 'SendDropSuspect';
  /** Every value of the suspect's slice dimension on its message, largest first. Null for whole-message suspects. */
  breakdown?: Maybe<Array<SendDropSuspectBreakdownEntry>>;
  cause: SendDropSuspectCause;
  channel?: Maybe<Scalars['String']>;
  comparison: SendDropSuspectComparison;
  /** Unmatched recs above the reference rate. Suspects are ordered by it. */
  excessUnmatched: Scalars['Float'];
  messageBaseline?: Maybe<SendCounts>;
  messageId: Scalars['String'];
  /** The whole message over the scored days and the trailing baseline. Null for reports written before these fields existed. */
  messageObserved?: Maybe<SendCounts>;
  observed: SendCounts;
  reference?: Maybe<SendCounts>;
  /** Null when the whole message is the suspect. */
  slice?: Maybe<SendDropSuspectSlice>;
  /** Distinct users on the channel whom Hightouch tried without reaching, on the median scored day. Unreachable suspects only. */
  unreachableUsers?: Maybe<Scalars['Float']>;
};

export type SendDropSuspectBreakdownEntry = {
  __typename?: 'SendDropSuspectBreakdownEntry';
  baseline: SendCounts;
  observed: SendCounts;
  value: Scalars['String'];
};

export const SendDropSuspectCause = {
  Config: 'config',
  EspCap: 'esp_cap',
  EspUnexplained: 'esp_unexplained',
  GroupGap: 'group_gap',
  Late: 'late',
  NearTotal: 'near_total',
  TimeWindow: 'time_window',
  Unreachable: 'unreachable'
} as const;

export type SendDropSuspectCause = typeof SendDropSuspectCause[keyof typeof SendDropSuspectCause];
export const SendDropSuspectComparison = {
  RestOfMessage: 'rest_of_message',
  Trailing: 'trailing'
} as const;

export type SendDropSuspectComparison = typeof SendDropSuspectComparison[keyof typeof SendDropSuspectComparison];
export type SendDropSuspectSlice = {
  __typename?: 'SendDropSuspectSlice';
  kind: SendDropSuspectSliceKind;
  /** Variable or feature name; null for time buckets and reachability. */
  name?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export const SendDropSuspectSliceKind = {
  Feature: 'feature',
  Reachability: 'reachability',
  TimeBucket: 'time_bucket',
  Variant: 'variant'
} as const;

export type SendDropSuspectSliceKind = typeof SendDropSuspectSliceKind[keyof typeof SendDropSuspectSliceKind];
export type SendEmailPreviewInput = {
  /** The campaign or template ID in the destination */
  campaignId: Scalars['String'];
  /** Optional config type (e.g., "canvas" for Braze Canvas, defaults to "trigger") */
  configType?: InputMaybe<Scalars['String']>;
  /** The ID of the destination (Braze, Iterable, etc.) */
  destinationId: Scalars['String'];
  /**
   * Variables to substitute in the email template.
   * These will be available as hightouch.recommendation.variables in the template.
   */
  variables: Scalars['JSONObject'];
};

export type SendEmailPreviewResponse = {
  __typename?: 'SendEmailPreviewResponse';
  /** Error message if the preview failed to send */
  error?: Maybe<Scalars['String']>;
  /** The unique ID for this preview. Use this to fetch the rendered email via getEmailPreview. */
  previewId: Scalars['String'];
};

export type SendInAppMessageInput = {
  /** The in-app message JSON blob. Validated server-side before it is stored. */
  message: Scalars['JSONObject'];
  /** The parent model primary key (unhashed) whose iOS devices should receive the ghost push. */
  parentModelPk: Scalars['String'];
};

export type SendInAppMessageResult = {
  __typename?: 'SendInAppMessageResult';
  deviceResults: Array<InAppMessageDeviceResult>;
  /** Server-minted (or caller-supplied) id the message was stored under. */
  messageId: Scalars['String'];
};

export type SendSeedBatchInput = {
  messageId: Scalars['ID'];
  rows: Array<SeedRowInput>;
  /**
   * Optional sender-identity override, like the single test send; defaults to
   * the message's configured sender identity. The from/reply-to envelope is
   * always resolved server-side from the identity — never caller-supplied.
   */
  senderIdentityId?: InputMaybe<Scalars['ID']>;
  /**
   * Editor-state templates, same shape as renderMessage input — the seed
   * batch renders "what you're looking at", including unsaved edits.
   */
  templateData: Scalars['JSONObject'];
};

export type SendSeedBatchResult = {
  __typename?: 'SendSeedBatchResult';
  errors: Array<SeedRowError>;
  rejected: Scalars['Int'];
  sent: Scalars['Int'];
};

export type SendTestEmailInput = {
  fromEmail: Scalars['String'];
  fromName?: InputMaybe<Scalars['String']>;
  htmlBody: Scalars['String'];
  messageId?: InputMaybe<Scalars['ID']>;
  /**
   * The previewed profile the body was rendered with, so link parameters
   * render against the same data.
   */
  profileData?: InputMaybe<Scalars['JSONObject']>;
  /**
   * Custom List-Unsubscribe URL, rendered by the FE's renderMessage call (same
   * preview row + overrides as the body). The backend attaches it as the
   * List-Unsubscribe header without re-rendering.
   */
  renderedListUnsubscribeUrl?: InputMaybe<Scalars['String']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  replyToName?: InputMaybe<Scalars['String']>;
  senderIdentityId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
  /** Email test groups in the caller's workspace to send to. */
  testGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A single recipient address, deduplicated case-insensitively against the test group members. */
  to?: InputMaybe<Scalars['String']>;
};

export type SendTestEmailResult = {
  __typename?: 'SendTestEmailResult';
  error?: Maybe<Scalars['String']>;
  /** One entry per rejected recipient, with the reason it was rejected. */
  errors?: Maybe<Array<SeedRowError>>;
  /** Unique recipients the email could not be sent to. */
  rejected?: Maybe<Scalars['Int']>;
  /** Unique recipients the email was sent to. Zero when the request was rejected before any send. */
  sent?: Maybe<Scalars['Int']>;
  /** True only when every recipient received the email. */
  success: Scalars['Boolean'];
};

export type SendTestPushActionButtonInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  /** One of: both | ios | android */
  platform: Scalars['String'];
  url: Scalars['String'];
};

export type SendTestPushAndroidConfigInput = {
  clickBehaviorUrl?: InputMaybe<Scalars['String']>;
  /** One of: normal | high */
  deliveryPriority?: InputMaybe<Scalars['String']>;
  groupKey?: InputMaybe<Scalars['String']>;
  notificationChannel?: InputMaybe<Scalars['String']>;
  replaceNotificationId?: InputMaybe<Scalars['String']>;
};

export type SendTestPushBadgeConfigInput = {
  /** One of: no_change | set | increment */
  mode: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
};

export type SendTestPushConfigInput = {
  actionButtons?: InputMaybe<Array<SendTestPushActionButtonInput>>;
  android?: InputMaybe<SendTestPushAndroidConfigInput>;
  /** Cross-platform replace-on-device key (apns-collapse-id / FCM collapse_key). */
  collapseKey?: InputMaybe<Scalars['String']>;
  customData?: InputMaybe<Array<SendTestPushCustomDataInput>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  ios?: InputMaybe<SendTestPushIosConfigInput>;
  /** Silent (background data) push: no notification is shown; the SDK delivers customData to the host app and/or the iOS badge updates. */
  isSilent?: InputMaybe<Scalars['Boolean']>;
  messageExpiryHours?: InputMaybe<Scalars['Int']>;
  /** Sound filename or 'default'. Currently delivered to iOS only, matching real sends. */
  sound?: InputMaybe<Scalars['String']>;
};

export type SendTestPushCustomDataInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SendTestPushDeviceInput = {
  pushAppId: Scalars['String'];
  token: Scalars['String'];
};

export type SendTestPushInput = {
  body: Scalars['String'];
  /**
   * Full push content config. Omitting it preserves the legacy
   * title+body-only behavior. All templated fields are sent pre-rendered,
   * matching the email/SMS test-send convention.
   */
  config?: InputMaybe<SendTestPushConfigInput>;
  devices: Array<SendTestPushDeviceInput>;
  title: Scalars['String'];
};

export type SendTestPushIosConfigInput = {
  badgeConfig?: InputMaybe<SendTestPushBadgeConfigInput>;
  clickBehaviorUrl?: InputMaybe<Scalars['String']>;
  /** One of: active | time-sensitive | passive | critical */
  interruptionLevel?: InputMaybe<Scalars['String']>;
  relevanceScore?: InputMaybe<Scalars['Float']>;
  subtitle?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
};

export type SendTestPushResult = {
  __typename?: 'SendTestPushResult';
  results: Array<TestPushTokenResult>;
};

export type SendTestSmsInput = {
  body: Scalars['String'];
  from?: InputMaybe<Scalars['String']>;
  linkTemplate?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<SmsLinkInput>>;
  mediaUrl?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['ID']>;
  messagingServiceSid?: InputMaybe<Scalars['String']>;
  profileData?: InputMaybe<Scalars['JSONObject']>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  senderIdentityId?: InputMaybe<Scalars['ID']>;
  to: Scalars['String'];
};

export type SendTestSmsResult = {
  __typename?: 'SendTestSmsResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SendTestWhatsAppMessageInput = {
  /** The composer's unsaved content. Ignored for an approved template, which sends as approved, and for a translated locale. */
  editorState?: InputMaybe<Scalars['JSONObject']>;
  /** The locale to send. Absent sends the default locale, the one the template is written in. */
  localeId?: InputMaybe<Scalars['ID']>;
  /** Picks the default sender as this message would send in production. */
  messageId?: InputMaybe<Scalars['ID']>;
  /** Variable name to example value, taking precedence over the content's own examples. */
  sampleOverrides?: InputMaybe<Scalars['JSONObject']>;
  /** One of whatsAppTestSenders' ids. The default sender is used when absent. */
  senderId?: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
  to: Scalars['String'];
};

export type SendTestWhatsAppMessageResult = {
  __typename?: 'SendTestWhatsAppMessageResult';
  error?: Maybe<Scalars['String']>;
  /** The number the test was sent from. */
  fromPhone?: Maybe<Scalars['String']>;
  /** Delivery depends on the recipient having messaged fromPhone in the last 24 hours. */
  requiresOpenSession?: Maybe<Scalars['Boolean']>;
  simulated?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type SendsByDay = {
  __typename?: 'SendsByDay';
  count: Scalars['Int'];
  date: Scalars['String'];
};

/** A context file the root agent read at least once during a session. */
export type SessionContextFile = {
  __typename?: 'SessionContextFile';
  /** For copy_references files, the channel their management page is keyed by (email/sms/push/ads). Null for other types. */
  channel?: Maybe<Scalars['String']>;
  /** The metadata.contextType tag (e.g. skill) that routes the file to its own Context Hub surface. Null for untagged files. */
  contextType?: Maybe<Scalars['String']>;
  entityId: Scalars['uuid'];
  /** The latest read across the session's interactions. Orders the list, most recent first. */
  lastReadAt: Scalars['timestamptz'];
  name: Scalars['String'];
  type: AgenticSettingsEntityType;
};

export type SessionCreatedByUser = {
  __typename?: 'SessionCreatedByUser';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

/**
 * A file staged via presigned upload, or an existing catalog asset referenced
 * by id. Supply exactly one of s3Key or catalogAssetId. The resolver verifies
 * workspace ownership, existence, type, and size before attaching it.
 */
export type SessionFileInput = {
  /**
   * Catalog artifact id when the file was picked from an Ad Studio asset
   * collection, so its collection's rules follow the attachment.
   */
  catalogAssetId?: InputMaybe<Scalars['String']>;
  contentImageId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  /**
   * Folder the file was dropped from, relative to the drop and /-separated,
   * e.g. "Brand A/Summer 2025/Final". Omit for a file dropped on its own.
   */
  folderPath?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  s3Key?: InputMaybe<Scalars['String']>;
};

/**
 * Setting readPermission or writePermission applies it to every read-only or write tool, clearing their
 * own permissions, before tools sets any of those.
 */
export type SetAgentConnectorPermissionsInput = {
  id: Scalars['ID'];
  readPermission?: InputMaybe<AgentToolPermission>;
  tools?: InputMaybe<Array<AgentConnectorToolPermissionInput>>;
  writePermission?: InputMaybe<AgentToolPermission>;
};

export type SetAsanaSubtaskCompletedInput = {
  /** Omit when the parent is the campaign's own task. */
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
  completed: Scalars['Boolean'];
  subtaskGid: Scalars['ID'];
};

export type SetCepBrandFooterInput = {
  /** The CEP brand whose footer to save. Defaults to the workspace's earliest brand. */
  cepBrandId?: InputMaybe<Scalars['ID']>;
  /** The source the marketer wrote, before localization stamps tags into rowHtml. */
  rawHtml: Scalars['String'];
  rowHtml: Scalars['String'];
  rowJson: Scalars['JSONObject'];
};

export type SetCepBrandFooterResponse = {
  __typename?: 'SetCepBrandFooterResponse';
  id: Scalars['String'];
};

export type SetCepBrandLogoInput = {
  brandSettingsId: Scalars['String'];
  imageId: Scalars['String'];
  publicUrl: Scalars['String'];
};

export type SetCepBrandLogoResponse = {
  __typename?: 'SetCepBrandLogoResponse';
  id: Scalars['String'];
};

export type SetCepParentModelAndConfigureEventsInput = {
  mode?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['ID'];
};

export type SetCepParentModelAndConfigureEventsResult = {
  __typename?: 'SetCepParentModelAndConfigureEventsResult';
  cepWorkspaceConfigId: Scalars['String'];
  created: Scalars['Boolean'];
  eventSourceId: Scalars['String'];
  eventWarehouseDestinationId: Scalars['String'];
  forwardingDestinationId: Scalars['String'];
  forwardingSyncId: Scalars['String'];
  parentModelId: Scalars['ID'];
  warehouseSyncId: Scalars['String'];
  writeKey: Scalars['String'];
};

export type SetCepWhatsAppTemplateLocaleSamplesInput = {
  localeId: Scalars['ID'];
  samples: Array<CepWhatsAppTemplateSampleInput>;
  templateId: Scalars['ID'];
};

export type SetCepWhatsAppTemplateLocaleSamplesResult = {
  __typename?: 'SetCepWhatsAppTemplateLocaleSamplesResult';
  templateId: Scalars['ID'];
};

export type SetCepWhatsAppTemplateLocalizationInput = {
  /** The locale the template is written in. Fixed once localization is set. */
  defaultLocaleId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  /** Every locale the template goes out in, the default included when selected. */
  localeIds: Array<Scalars['ID']>;
  /**
   * The template, or its draft's copy on a live campaign. Either one writes the
   * selection to both, which they share.
   */
  templateId: Scalars['ID'];
};

export type SetCepWhatsAppTemplateLocalizationResult = {
  __typename?: 'SetCepWhatsAppTemplateLocalizationResult';
  templateId: Scalars['ID'];
};

export type SetCepWorkspaceFallbackLocaleResult = {
  __typename?: 'SetCepWorkspaceFallbackLocaleResult';
  columnMappings: Scalars['JSONObject'];
  locale: CepLocalizationLocale;
};

export type SetDefaultChannelSizeInput = {
  channelSizeId?: InputMaybe<Scalars['uuid']>;
};

export type SetGoldenRecordColumnSourceSurvivorshipErrorResponse = {
  __typename?: 'SetGoldenRecordColumnSourceSurvivorshipErrorResponse';
  error: Scalars['String'];
};

export type SetGoldenRecordColumnSourceSurvivorshipInput = {
  goldenRecordColumnId: Scalars['String'];
  sourceSurvivorships: Array<ColumnSourceSurvivorshipInput>;
};

export type SetGoldenRecordColumnSourceSurvivorshipResponse = SetGoldenRecordColumnSourceSurvivorshipErrorResponse | SetGoldenRecordColumnSourceSurvivorshipSuccessResponse;

export type SetGoldenRecordColumnSourceSurvivorshipSuccessResponse = {
  __typename?: 'SetGoldenRecordColumnSourceSurvivorshipSuccessResponse';
  goldenRecordColumnId: Scalars['String'];
  sourceSurvivorships: Array<ColumnSourceSurvivorship>;
};

export type SetInAppMessagePushAppsInput = {
  messageId: Scalars['ID'];
  pushAppIds: Array<Scalars['ID']>;
};

export type SetInAppMessagePushAppsResult = {
  __typename?: 'SetInAppMessagePushAppsResult';
  messageId: Scalars['ID'];
  pushAppIds: Array<Scalars['ID']>;
};

export type SetSyncIdrScheduleErrorResponse = {
  __typename?: 'SetSyncIdrScheduleErrorResponse';
  error: Scalars['String'];
};

export type SetSyncIdrScheduleResponse = SetSyncIdrScheduleErrorResponse | SetSyncIdrScheduleSuccessResponse;

export type SetSyncIdrScheduleSuccessResponse = {
  __typename?: 'SetSyncIdrScheduleSuccessResponse';
  id: Scalars['String'];
};

export type SetUpCepSignupsResult = {
  __typename?: 'SetUpCepSignupsResult';
  created: Array<CepSignupTraitCreated>;
  /** False when the models were already there, so only traits were added. */
  modelsCreated: Scalars['Boolean'];
  /** Fields that already had a trait. Declaring one again is a no-op. */
  skipped: Array<Scalars['String']>;
};

export type SetWarehouseExportEnabledForSourceOutput = {
  __typename?: 'SetWarehouseExportEnabledForSourceOutput';
  count: Scalars['Int'];
};

export type SetWarehouseExportEnabledOutput = {
  __typename?: 'SetWarehouseExportEnabledOutput';
  enabled: Scalars['Boolean'];
};

export type SetupFivetranSyncInput = {
  destinationId?: InputMaybe<Scalars['bigint']>;
  enabledAdAccounts?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  sourceConfig?: InputMaybe<SetupFivetranSyncSourceConfig>;
  sourceType: FivetranSourceType;
};

export type SetupFivetranSyncResponse = {
  __typename?: 'SetupFivetranSyncResponse';
  connectCardUrl: Scalars['String'];
  connectorId: Scalars['String'];
  status: Scalars['String'];
  syncId: Scalars['String'];
};

/**
 * Per-source-type extras for setupFivetranSync. Each field is set only when
 * the relevant source type is being configured. The resolver picks the
 * field(s) that apply to the chosen sourceType and ignores the rest.
 */
export type SetupFivetranSyncSourceConfig = {
  /**
   * Required when sourceType is "klaviyo". The Klaviyo metric ID the
   * customer picked for conversion attribution (e.g. the ID of the
   * "Placed Order" metric). Sourced from the klaviyoConversionMetrics
   * query.
   */
  klaviyoConversionMetricId?: InputMaybe<Scalars['String']>;
};

export type SetupInWarehouseDiffingForSourceOutput = {
  __typename?: 'SetupInWarehouseDiffingForSourceOutput';
  ignored?: Maybe<Scalars['Boolean']>;
};

export type SetupInWarehouseDiffingWithCredentialsOutput = {
  __typename?: 'SetupInWarehouseDiffingWithCredentialsOutput';
  ignored?: Maybe<Scalars['Boolean']>;
};

export type ShareAgentSessionToSlackErrorResponse = {
  __typename?: 'ShareAgentSessionToSlackErrorResponse';
  error: Scalars['String'];
};

export type ShareAgentSessionToSlackInput = {
  channelId: Scalars['String'];
  sessionId: Scalars['uuid'];
};

export type ShareAgentSessionToSlackResponse = ShareAgentSessionToSlackErrorResponse | ShareAgentSessionToSlackSuccessResponse;

export type ShareAgentSessionToSlackSuccessResponse = {
  __typename?: 'ShareAgentSessionToSlackSuccessResponse';
  jobId: Scalars['String'];
};

export type SheetName = {
  __typename?: 'SheetName';
  name: Scalars['String'];
};

export type SigmaElement = {
  __typename?: 'SigmaElement';
  elementId: Scalars['String'];
  name: Scalars['String'];
};

export type SigmaElements = {
  __typename?: 'SigmaElements';
  elements: Array<Maybe<SigmaElement>>;
};

export type SigmaExtension = {
  __typename?: 'SigmaExtension';
  clientId: Scalars['String'];
  cloud: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
};

export type SigmaExtensionError = {
  __typename?: 'SigmaExtensionError';
  message?: Maybe<Scalars['String']>;
  sigmaError?: Maybe<Scalars['String']>;
  sigmaStatus?: Maybe<Scalars['Int']>;
};

export type SigmaExtensionOrError = SigmaExtension | SigmaExtensionError;

export type SigmaPage = {
  __typename?: 'SigmaPage';
  name: Scalars['String'];
  pageId: Scalars['String'];
};

export type SigmaPages = {
  __typename?: 'SigmaPages';
  pages: Array<Maybe<SigmaPage>>;
};

export type SigmaQuery = {
  __typename?: 'SigmaQuery';
  elementId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
};

export type SigmaWorkbook = {
  __typename?: 'SigmaWorkbook';
  createdAt: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
  workbookId: Scalars['String'];
};

export type SigmaWorkbookDetail = {
  __typename?: 'SigmaWorkbookDetail';
  createdAt: Scalars['String'];
  name: Scalars['String'];
  pages: Array<Maybe<SigmaWorkbookPage>>;
  updatedAt: Scalars['String'];
  workbookId: Scalars['String'];
};

export type SigmaWorkbookElement = {
  __typename?: 'SigmaWorkbookElement';
  elementId: Scalars['String'];
  name: Scalars['String'];
  sql: Scalars['String'];
};

export type SigmaWorkbookPage = {
  __typename?: 'SigmaWorkbookPage';
  elements: Array<Maybe<SigmaWorkbookElement>>;
  name: Scalars['String'];
  pageId: Scalars['String'];
};

export type SigmaWorkbooks = {
  __typename?: 'SigmaWorkbooks';
  workbooks: Array<Maybe<SigmaWorkbook>>;
};

export type SkipReasonBucket = {
  __typename?: 'SkipReasonBucket';
  count: Scalars['Int'];
  reason: Scalars['String'];
  /** Raw drop reasons composing this bucket (count > 0), sorted desc. Lets the UI reveal what an aggregated bucket — especially "other" — contains. */
  subReasons: Array<SkipSubReason>;
};

export type SkipSubReason = {
  __typename?: 'SkipSubReason';
  count: Scalars['Int'];
  /** Raw dispatcher drop reason (a DispatcherDropReason enum value); the client maps it to a human label. */
  reason: Scalars['String'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SlackListChannelsInput = {
  destinationId: Scalars['String'];
};

export type SlackListChannelsSuccess = {
  __typename?: 'SlackListChannelsSuccess';
  channels: Array<SlackChannel>;
};

export const SlugResourceType = {
  Connections: 'connections',
  Destinations: 'destinations',
  EventForwardingSyncs: 'event_forwarding_syncs',
  EventPlans: 'event_plans',
  EventSchemas: 'event_schemas',
  EventSources: 'event_sources',
  EventWarehouseDestinations: 'event_warehouse_destinations',
  EventWarehouseSyncs: 'event_warehouse_syncs',
  ModelRelationships: 'model_relationships',
  Segments: 'segments',
  SyncSequences: 'sync_sequences',
  SyncTemplates: 'sync_templates',
  Syncs: 'syncs'
} as const;

export type SlugResourceType = typeof SlugResourceType[keyof typeof SlugResourceType];
export type SmsLinkInput = {
  id: Scalars['ID'];
  template: Scalars['String'];
};

export type SmsSendCreative = {
  __typename?: 'SmsSendCreative';
  body: Scalars['String'];
};

export type SourceAudienceDependencyReference = {
  __typename?: 'SourceAudienceDependencyReference';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SourceCategory = {
  __typename?: 'SourceCategory';
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  type: Scalars['String'];
};

export type SourceColumnDescription = {
  __typename?: 'SourceColumnDescription';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SourceDefinedDescription = {
  __typename?: 'SourceDefinedDescription';
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SourceDefinition = {
  __typename?: 'SourceDefinition';
  allowedDestinations?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Maybe<SourceCategory>>>;
  cleanRoomType?: Maybe<Scalars['String']>;
  creatablePrimaryKey?: Maybe<Scalars['Boolean']>;
  disableTest: Scalars['Boolean'];
  docs: Scalars['String'];
  icon: Scalars['String'];
  inWarehouseMigrationDisabled?: Maybe<Scalars['Boolean']>;
  isSampleDataSource: Scalars['Boolean'];
  longPitch: Scalars['String'];
  name: Scalars['String'];
  releasedAt?: Maybe<Scalars['String']>;
  sampleModels?: Maybe<Array<Maybe<SampleModel>>>;
  shortPitch: Scalars['String'];
  status: Scalars['String'];
  supportedQueries: Array<Scalars['String']>;
  supportsArrayExpansion: Scalars['Boolean'];
  supportsCrossDatabaseDiscovery: Scalars['Boolean'];
  supportsCrossDbReference: Scalars['Boolean'];
  supportsInWarehouseDiffing: Scalars['Boolean'];
  supportsIpFiltering: Scalars['Boolean'];
  supportsResultSchema: Scalars['Boolean'];
  supportsSampling: Scalars['Boolean'];
  supportsSemanticViews: Scalars['Boolean'];
  supportsTopK: Scalars['Boolean'];
  supportsTunneling: Scalars['Boolean'];
  supportsWarehouseExport: Scalars['Boolean'];
  supportsWarehouseExportStage: Scalars['Boolean'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type SourceDefinitionInput = {
  sampleDataSourceId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SourceDefinitionInputV2 = {
  id: Scalars['bigint'];
  type: Scalars['String'];
};

export type SourceDeleteBlocker = {
  __typename?: 'SourceDeleteBlocker';
  id: Scalars['String'];
  name: Scalars['String'];
  type: SourceDeleteBlockerType;
};

export const SourceDeleteBlockerType = {
  Campaign: 'campaign',
  Condition: 'condition',
  DecisionEngineConfiguration: 'decisionEngineConfiguration',
  DecisionEngineFlow: 'decisionEngineFlow',
  Destination: 'destination',
  DynamicContent: 'dynamicContent',
  EtlConnection: 'etlConnection',
  Journey: 'journey',
  JourneyTemplate: 'journeyTemplate',
  Model: 'model',
  PriorityList: 'priorityList',
  Sequence: 'sequence'
} as const;

export type SourceDeleteBlockerType = typeof SourceDeleteBlockerType[keyof typeof SourceDeleteBlockerType];
export type SourceGrant = {
  can_access_data: Scalars['Boolean'];
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit: Scalars['Boolean'];
  can_manage_schema: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  user_group_id: Scalars['String'];
};

export type SourceMethod = {
  __typename?: 'SourceMethod';
  credentialsForm?: Maybe<Scalars['JSON']>;
  form?: Maybe<Scalars['JSON']>;
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  method: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  tunneling?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type SourceModelDependencyReference = {
  __typename?: 'SourceModelDependencyReference';
  id: Scalars['String'];
  modelSourceType: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
};

export type SourceMutationInput = {
  audience_holdout_enabled?: InputMaybe<Scalars['Boolean']>;
  audience_snapshotting_enabled?: InputMaybe<Scalars['Boolean']>;
  config?: InputMaybe<Scalars['JSONObject']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plan_in_warehouse?: InputMaybe<Scalars['Boolean']>;
  plan_in_warehouse_config?: InputMaybe<Scalars['JSONObject']>;
  sample_data_source_id?: InputMaybe<Scalars['String']>;
  setup_complete?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  tunnel_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_history_config?: InputMaybe<Scalars['JSONObject']>;
};

export type SourceMutationResult = {
  __typename?: 'SourceMutationResult';
  id: Scalars['Int'];
};

export type SourceSchemaConfigInput = {
  audit: Scalars['String'];
  matchbooster: Scalars['String'];
  planner: Scalars['String'];
};

export type SourceSyncDependencyReference = {
  __typename?: 'SourceSyncDependencyReference';
  destinationName: Scalars['String'];
  destinationType: Scalars['String'];
  id: Scalars['String'];
  modelName: Scalars['String'];
  modelType: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type Space = {
  __typename?: 'Space';
  current_space_id?: Maybe<Scalars['String']>;
  is_user_space_scoped: Scalars['Boolean'];
};

/**
 * An audience template selected for a space individually. Can only be changed,
 * and is only consulted, while the space's access mode is "selected".
 */
export type SpaceAudienceTemplate = {
  __typename?: 'SpaceAudienceTemplate';
  audienceTemplateId: Scalars['uuid'];
  spaceId: Scalars['uuid'];
};

export const SpaceAudienceTemplateAccessMode = {
  All: 'all',
  Selected: 'selected'
} as const;

export type SpaceAudienceTemplateAccessMode = typeof SpaceAudienceTemplateAccessMode[keyof typeof SpaceAudienceTemplateAccessMode];
export type SpaceScopedColumnTopKStatus = {
  __typename?: 'SpaceScopedColumnTopKStatus';
  columnName: Scalars['String'];
  lastSyncAttempted?: Maybe<Scalars['String']>;
  lastSyncCompleted?: Maybe<Scalars['String']>;
  topKError?: Maybe<Scalars['String']>;
};

export const SsoEnforcement = {
  AllLogins: 'all_logins',
  NewUsers: 'new_users',
  None: 'none'
} as const;

export type SsoEnforcement = typeof SsoEnforcement[keyof typeof SsoEnforcement];
export type SsoEnforcementImpact = {
  __typename?: 'SsoEnforcementImpact';
  blockedApiKeyCount: Scalars['Int'];
  blockedApiKeys: Array<BlockedApiKey>;
};

export const StandardFieldType = {
  Array: 'ARRAY',
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  Datetime: 'DATETIME',
  Email: 'EMAIL',
  Enum: 'ENUM',
  Number: 'NUMBER',
  Object: 'OBJECT',
  Reference: 'REFERENCE',
  String: 'STRING',
  Unknown: 'UNKNOWN'
} as const;

export type StandardFieldType = typeof StandardFieldType[keyof typeof StandardFieldType];
/**
 * The outcome of a bulk review request, one entry per ad asked for, in the order
 * they were given. A caller should report the reviews that succeeded rather than
 * the number it asked for.
 */
export type StartAssetCommentReviewsPayload = {
  __typename?: 'StartAssetCommentReviewsPayload';
  results: Array<AssetCommentReviewResult>;
};

export type StartAssetEditSessionInput = {
  assetId: Scalars['uuid'];
  userPrompt: Scalars['String'];
};

export type StartAssetEditSessionResponse = {
  __typename?: 'StartAssetEditSessionResponse';
  assetId: Scalars['uuid'];
  focusedContent: Scalars['String'];
  interactionId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type StartBackgroundDiscovery = {
  __typename?: 'StartBackgroundDiscovery';
  jobId: Scalars['String'];
};

export type StartContentNodeEditSessionInput = {
  contentImageId?: InputMaybe<Scalars['uuid']>;
  contentNodeId?: InputMaybe<Scalars['uuid']>;
  imageUrl?: InputMaybe<Scalars['String']>;
};

export type StartContentNodeEditSessionResult = {
  __typename?: 'StartContentNodeEditSessionResult';
  interactionId?: Maybe<Scalars['uuid']>;
  nodeId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};

export type StartCopyReferencesIngestionInput = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
  channel: Scalars['String'];
  /**
   * Destination the copy examples are scoped to. Omit for a channel-generic
   * config (applies to every destination on the channel).
   */
  destinationId?: InputMaybe<Scalars['String']>;
  fivetranSyncId?: InputMaybe<Scalars['String']>;
  lookbackDays: Scalars['Int'];
  manual?: InputMaybe<CopyReferencesManualInput>;
  metaAdLibrary?: InputMaybe<CopyReferencesMetaAdLibraryInput>;
  minSends?: InputMaybe<Scalars['Int']>;
  /**
   * Optional free-text scoping guidance the ingestion agent interprets when
   * authoring its extraction SQL (e.g. "only promotional campaigns"). This is a
   * hint, not SQL — the server never executes it.
   */
  rowFilterNote?: InputMaybe<Scalars['String']>;
  targetCount: Scalars['Int'];
  warehouse?: InputMaybe<CopyReferencesWarehouseInput>;
};

export type StartFigmaImportInput = {
  figmaUrl: Scalars['String'];
  mobileFigmaUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  targetEmailWidth?: InputMaybe<Scalars['Int']>;
};

export type StartFigmaImportResult = {
  __typename?: 'StartFigmaImportResult';
  draftId: Scalars['String'];
  interactionId?: Maybe<Scalars['String']>;
  sessionId: Scalars['String'];
};

export type StartPublicImageFromContentImageResponse = PublicImageJobPending | PublicImageReady;

export type StartSyncRunOutput = {
  __typename?: 'StartSyncRunOutput';
  scheduled: Scalars['Boolean'];
};

export type StartSyncRunsForSegmentOutput = {
  __typename?: 'StartSyncRunsForSegmentOutput';
  result: Array<SyncIdScheduledOutput>;
};

export type StartSyncRunsWithDiffModeOverrideOutput = {
  __typename?: 'StartSyncRunsWithDiffModeOverrideOutput';
  result: Array<SyncIdScheduledOutput>;
};

export type StartTestSourceBackgroundJob = {
  __typename?: 'StartTestSourceBackgroundJob';
  jobId: Scalars['uuid'];
};

export type StartWarehouseShareSetupBackgroundJob = {
  __typename?: 'StartWarehouseShareSetupBackgroundJob';
  jobId: Scalars['uuid'];
};

export type StaticListCsvAttributeColumnInput = {
  csvHeader: Scalars['String'];
  variableName: Scalars['String'];
};

export type StaticListCsvFile = {
  __typename?: 'StaticListCsvFile';
  columns: Array<Scalars['String']>;
  fileSize: Scalars['Int'];
  rowCount: Scalars['Int'];
};

export type StaticListRefreshPreviewError = {
  __typename?: 'StaticListRefreshPreviewError';
  error: Scalars['String'];
};

export type StaticListRefreshPreviewResponse = StaticListRefreshPreviewError | StaticListRefreshPreviewSuccess;

export type StaticListRefreshPreviewSuccess = {
  __typename?: 'StaticListRefreshPreviewSuccess';
  entered: Scalars['Int'];
  exited: Scalars['Int'];
  size: Scalars['Int'];
};

export const StaticListResultKind = {
  Duplicates: 'DUPLICATES',
  Matches: 'MATCHES',
  Unmatched: 'UNMATCHED'
} as const;

export type StaticListResultKind = typeof StaticListResultKind[keyof typeof StaticListResultKind];
export type StaticListUnmatchedResultError = {
  __typename?: 'StaticListUnmatchedResultError';
  error: Scalars['String'];
};

export type StaticListUnmatchedResultResponse = StaticListUnmatchedResultError | StaticListUnmatchedResultSuccess;

export type StaticListUnmatchedResultSuccess = {
  __typename?: 'StaticListUnmatchedResultSuccess';
  count: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  rows: Array<Scalars['JSON']>;
  totalPages: Scalars['Int'];
};

export type StopAmpAgentResponse = {
  __typename?: 'StopAmpAgentResponse';
  stopped: Scalars['Int'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type StripeRedirectResult = {
  __typename?: 'StripeRedirectResult';
  redirect: Scalars['String'];
};

export type StyleEntity = {
  __typename?: 'StyleEntity';
  /** Agents this style is offered to. Empty means every agent. */
  agentScopes: Array<AgentScope>;
  /**
   * Live brand-profile assignments. Empty means "applies to all brand
   * profiles" (the legacy single nullable brand_profile_id, generalized).
   */
  brandProfiles: Array<StyleEntityBrandProfile>;
  /** Entities the document cites (its reference images), with presigned URLs. */
  cites: Array<EntityCitationTarget>;
  createdAt: Scalars['timestamptz'];
  createdByUser?: Maybe<StyleEntityCreatedBy>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** The style as a markdown document. */
  markdown: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /**
   * The workspace user who saved the latest version, for last-updated-by
   * attribution. Null when no user is behind the write (an agent-applied
   * change, a sync, or a Hightouch-managed style), or when the attributed user
   * no longer exists.
   */
  updatedByUser?: Maybe<AgenticSettingsEntityUser>;
  /**
   * Current version row id — the optimistic-concurrency token for
   * updateStyleEntity.expectedVersionId.
   */
  versionId: Scalars['uuid'];
};

export type StyleEntityBrandProfile = {
  __typename?: 'StyleEntityBrandProfile';
  id: Scalars['uuid'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type StyleEntityCreatedBy = {
  __typename?: 'StyleEntityCreatedBy';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SubmitCepWhatsAppTemplateLocaleResult = {
  __typename?: 'SubmitCepWhatsAppTemplateLocaleResult';
  /** Why this locale wasn't submitted. Null when it was. */
  error?: Maybe<Scalars['String']>;
  localeId: Scalars['ID'];
  rejectionReason?: Maybe<Scalars['String']>;
  /** Meta's review state, as the provider reported it. Null when the submission failed. */
  status?: Maybe<Scalars['String']>;
};

export type SubmitCepWhatsAppTemplateResult = {
  __typename?: 'SubmitCepWhatsAppTemplateResult';
  id: Scalars['ID'];
  rejectionReason?: Maybe<Scalars['String']>;
  /** Meta's review state, as the provider reported it. */
  status: Scalars['String'];
};

export type SubmittedContextInput = {
  id: Scalars['String'];
  kind: SubmittedContextKind;
  label: Scalars['String'];
};

export const SubmittedContextKind = {
  Insight: 'insight',
  Send: 'send'
} as const;

export type SubmittedContextKind = typeof SubmittedContextKind[keyof typeof SubmittedContextKind];
export type SubscriptionActor = {
  __typename?: 'SubscriptionActor';
  email: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SubscriptionEvent = {
  __typename?: 'SubscriptionEvent';
  consentStatus: Scalars['String'];
  id: Scalars['String'];
  timestamp?: Maybe<Scalars['String']>;
  topicId: Scalars['String'];
  topicName: Scalars['String'];
};

export type SubscriptionEventsResponse = {
  __typename?: 'SubscriptionEventsResponse';
  events: Array<SubscriptionEvent>;
};

export type SubscriptionLastUpdate = {
  __typename?: 'SubscriptionLastUpdate';
  action: Scalars['String'];
  timestamp?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<SubscriptionActor>;
  updatedBySource?: Maybe<Scalars['String']>;
};

export type SubscriptionTopic = {
  __typename?: 'SubscriptionTopic';
  consentMechanism: Scalars['String'];
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdate: SubscriptionLastUpdate;
  name: Scalars['String'];
  status: Scalars['String'];
};

export type SuccessfulDeploymentTestResult = {
  __typename?: 'SuccessfulDeploymentTestResult';
  history: Array<DeploymentTestHistory>;
  passed: Scalars['Boolean'];
  results: Array<Maybe<DeploymentValidationResult>>;
  sourceObj: Scalars['JSONObject'];
  targetObj?: Maybe<Scalars['JSONObject']>;
  targetWorkspace: ResourceLinkWorkspace;
  type: DeploymentOperation;
  userCanOnlyDraft: Scalars['Boolean'];
  workspaceApprovalsRequired: Scalars['Boolean'];
};

export type SuccessfulDeploymentValidationResult = {
  __typename?: 'SuccessfulDeploymentValidationResult';
  duration?: Maybe<Scalars['Float']>;
  passed: Scalars['Boolean'];
  stepName: ValidatorNames;
  targetWorkspaceId: Scalars['bigint'];
};

export type SuccessfulModelDeploymentResult = {
  __typename?: 'SuccessfulModelDeploymentResult';
  deployedResourceId: Scalars['bigint'];
  deploymentHistoryId?: Maybe<Scalars['bigint']>;
  draftId?: Maybe<Scalars['String']>;
};

export type SuccessfulQueryResponse = {
  __typename?: 'SuccessfulQueryResponse';
  columns: Array<QueryColumn>;
  exceedsPreviewMax: Scalars['Boolean'];
  /**
   * When previewing a trait on a related model, this contains the inferred primary key column name
   * that was used from the relationship's from_column
   */
  inferredPrimaryKey?: Maybe<Scalars['String']>;
  /**
   * This indicates the total number of rows in the warehouse table.
   * We use a String becauase large tables can be bigger than 32 bit
   * integers and cause graphql serialization errors.
   */
  numRowsWithoutLimit?: Maybe<Scalars['String']>;
  /**
   * Snowflake RBAC: the role this preview ran under, when an override applied.
   * Null when the preview used the service account (RBAC off / disabled).
   */
  roleResolution?: Maybe<PreviewRoleResolution>;
  rows: Array<Scalars['JSONObject']>;
  /**
   * This indicates the total count of rows in the preview result set and is used for pagination.
   * It is usually less than numRowsWithoutLimit, but can be equal if the entire table is previewed.
   * We use a String becauase large tables can be bigger than 32 bit
   * integers and cause graphql serialization errors.
   */
  rowsCount?: Maybe<Scalars['String']>;
  sampledModelsRate?: Maybe<Scalars['Float']>;
  sql?: Maybe<Scalars['String']>;
  usedSampledModels?: Maybe<Scalars['Boolean']>;
};

export type SuccessfulRowExportResponse = {
  __typename?: 'SuccessfulRowExportResponse';
  headUrl?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type SuccessfulSyncDeploymentResult = {
  __typename?: 'SuccessfulSyncDeploymentResult';
  deployedResourceId: Scalars['bigint'];
  deploymentHistoryId?: Maybe<Scalars['bigint']>;
  draftId?: Maybe<Scalars['String']>;
};

export type SuccessfulSyncOpsByDestinationInput = {
  endTime: Scalars['UnixEpochTimestamp'];
  segmentId: Scalars['bigint'];
  startTime: Scalars['UnixEpochTimestamp'];
};

export type SuccessfulSyncOpsByDestinationResult = {
  __typename?: 'SuccessfulSyncOpsByDestinationResult';
  data?: Maybe<Array<SuccessfulSyncOpsDestinationTimeseries>>;
};

export type SuccessfulSyncOpsByDestinationTimePoint = {
  __typename?: 'SuccessfulSyncOpsByDestinationTimePoint';
  successOps: Scalars['bigint'];
  timestamp: Scalars['UnixEpochTimestamp'];
};

export type SuccessfulSyncOpsDestinationTimeseries = {
  __typename?: 'SuccessfulSyncOpsDestinationTimeseries';
  destinationId: Scalars['bigint'];
  destinationName: Scalars['String'];
  timeseries: Array<SuccessfulSyncOpsByDestinationTimePoint>;
};

/**
 * Campaign intake fields pre-filled from a pasted Asana task URL. The name and
 * goal are the task's own title and description, verbatim; the other fields are
 * extracted by an LLM pass over the rendered ticket and are null when the
 * ticket gives no basis for them.
 */
export type SuggestCampaignIntakeFromAsanaTaskResponse = {
  __typename?: 'SuggestCampaignIntakeFromAsanaTaskResponse';
  audienceDescription?: Maybe<Scalars['String']>;
  /** "single" or "subsegments" */
  audienceScope?: Maybe<Scalars['String']>;
  /** Subset of ["email", "push", "sms"] */
  channels?: Maybe<Array<Scalars['String']>>;
  goal?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The task's title, for the form to confirm which task was read. */
  taskName: Scalars['String'];
};

export type SuggestFilterColumnsResponse = {
  __typename?: 'SuggestFilterColumnsResponse';
  suggestions: Array<Scalars['JSONObject']>;
};

/**
 * Campaign intake fields extracted from a chat transcript to pre-fill the
 * "Create campaign from chat" wizard. Every field is nullable — null means the
 * conversation didn't clearly establish it and the form field keeps its normal
 * default.
 */
export type SuggestProjectCampaignIntakeResponse = {
  __typename?: 'SuggestProjectCampaignIntakeResponse';
  audienceDescription?: Maybe<Scalars['String']>;
  /** "single" or "subsegments" */
  audienceScope?: Maybe<Scalars['String']>;
  /** Subset of ["email", "push", "sms"] */
  channels?: Maybe<Array<Scalars['String']>>;
  goal?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SuggestedTopicsForCategory = {
  __typename?: 'SuggestedTopicsForCategory';
  category: Scalars['String'];
  topics: Array<Scalars['String']>;
};

export type SuperclusterSampleRowsQuery = {
  htId: Scalars['String'];
  identifier: Scalars['String'];
  limit: Scalars['Int'];
  runId: Scalars['String'];
  value: Scalars['String'];
};

export type SuperclusterValueCountsQuery = {
  htId: Scalars['String'];
  identifier: Scalars['String'];
  runId: Scalars['String'];
  value: Scalars['String'];
};

export type SuperclustersQuery = {
  /** Paginated by cluster so all identifiers for the cluster are on the same page */
  pagination?: InputMaybe<PaginationInput>;
  runId: Scalars['String'];
};

export type SuppressionListSizeResult = {
  __typename?: 'SuppressionListSizeResult';
  evaluatedAt?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  suppressionListId: Scalars['ID'];
  usedSampledModel?: Maybe<Scalars['Boolean']>;
};

export type SyncAttemptMetric = {
  __typename?: 'SyncAttemptMetric';
  destination_id?: Maybe<Scalars['bigint']>;
  failed_operations: Scalars['bigint'];
  source_id?: Maybe<Scalars['bigint']>;
  successful_operations: Scalars['bigint'];
  time_bucket: Scalars['String'];
};

export type SyncConfig = {
  __typename?: 'SyncConfig';
  destination_instance_id?: Maybe<Scalars['String']>;
  exit_config: Scalars['JSONObject'];
  mode: Scalars['String'];
  placeholder_destination_id?: Maybe<Scalars['String']>;
};

export type SyncConfigInput = {
  destination_instance_id?: InputMaybe<Scalars['String']>;
  exit_config?: InputMaybe<Scalars['JSONObject']>;
  full_sync_config?: InputMaybe<Scalars['JSONObject']>;
  is_clone?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<Scalars['String']>;
  placeholder_destination_id?: InputMaybe<Scalars['String']>;
  source_journey_sync_id?: InputMaybe<Scalars['String']>;
};

export type SyncDeploymentResult = FailedDeploymentTestResult | SuccessfulSyncDeploymentResult;

export type SyncDraft = {
  _set: Scalars['JSONObject'];
  /** Set to the IDR graph this sync is scheduled to run after. Passing undefined is a no-op, null will unlink. */
  idrGraphId?: InputMaybe<Scalars['String']>;
};

export type SyncErrorSummary = {
  __typename?: 'SyncErrorSummary';
  error: Scalars['String'];
  lastReceivedAt: Scalars['String'];
  numEvents: Scalars['Int'];
  samplePayloadKeys: Array<Scalars['String']>;
};

export type SyncFilterCreator = {
  __typename?: 'SyncFilterCreator';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SyncFilterDestination = {
  __typename?: 'SyncFilterDestination';
  definitionIcon?: Maybe<Scalars['String']>;
  definitionName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SyncFilterJourney = {
  __typename?: 'SyncFilterJourney';
  name: Scalars['String'];
};

export type SyncFilterLabel = {
  __typename?: 'SyncFilterLabel';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SyncFilterOptions = {
  __typename?: 'SyncFilterOptions';
  creators: Array<SyncFilterCreator>;
  destinations: Array<SyncFilterDestination>;
  hasMatchboosting: Scalars['Boolean'];
  journeys: Array<SyncFilterJourney>;
  labels: Array<SyncFilterLabel>;
  priorityLists: Array<SyncFilterPriorityList>;
  sources: Array<SyncFilterSource>;
};

export type SyncFilterPriorityList = {
  __typename?: 'SyncFilterPriorityList';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SyncFilterSource = {
  __typename?: 'SyncFilterSource';
  definitionIcon?: Maybe<Scalars['String']>;
  definitionName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SyncIdScheduledOutput = {
  __typename?: 'SyncIdScheduledOutput';
  id: Scalars['Int'];
  scheduled: Scalars['Boolean'];
};

export const SyncOp = {
  Added: 'ADDED',
  Changed: 'CHANGED',
  Removed: 'REMOVED'
} as const;

export type SyncOp = typeof SyncOp[keyof typeof SyncOp];
export type SyncReconciliationDataPoint = {
  __typename?: 'SyncReconciliationDataPoint';
  messageId?: Maybe<Scalars['String']>;
  rowCount: Scalars['Int'];
  sendDate: Scalars['String'];
  status: SyncReconciliationStatus;
};

export const SyncReconciliationStatus = {
  CustomerManaged: 'customer_managed',
  Holdout: 'holdout',
  InSyncFailed: 'in_sync_failed',
  InSyncSucceeded: 'in_sync_succeeded',
  NeverSynced: 'never_synced'
} as const;

export type SyncReconciliationStatus = typeof SyncReconciliationStatus[keyof typeof SyncReconciliationStatus];
export type SyncRequestMetricV2 = {
  __typename?: 'SyncRequestMetricV2';
  destination_id?: Maybe<Scalars['bigint']>;
  failed_count: Scalars['Int'];
  source_id?: Maybe<Scalars['bigint']>;
  succeeded_count: Scalars['Int'];
  time_bucket: Scalars['String'];
  warning_count: Scalars['Int'];
};

export type SyncResultBatch = {
  __typename?: 'SyncResultBatch';
  attemptedRows?: Maybe<Array<Scalars['JSONObject']>>;
  batchId: Scalars['String'];
  rejectedRows?: Maybe<Array<Scalars['JSONObject']>>;
  requestInfoSet?: Maybe<Array<Maybe<RequestInfo>>>;
  /**
   * Rows a results destination (HTTP Lookup) would load into its results
   * table, keyed by column name.
   */
  resultRows?: Maybe<Array<Scalars['JSONObject']>>;
};

export type SyncRowsQueried = {
  __typename?: 'SyncRowsQueried';
  timestamp: Scalars['UnixEpochTimestamp'];
  value: Scalars['bigint'];
};

export type SyncRowsQueriedInput = {
  endTime: Scalars['UnixEpochTimestamp'];
  startTime: Scalars['UnixEpochTimestamp'];
  syncId: Scalars['bigint'];
};

export type SyncRowsQueriedResult = {
  __typename?: 'SyncRowsQueriedResult';
  data: Array<SyncRowsQueried>;
};

export type SyncRunMetric = {
  __typename?: 'SyncRunMetric';
  rejectedOps: Scalars['bigint'];
  runCount: Scalars['Int'];
  successOps: Scalars['bigint'];
  timestamp: Scalars['UnixEpochTimestamp'];
};

export type SyncRunMetricsInput = {
  endTime: Scalars['UnixEpochTimestamp'];
  interval: Interval;
  startTime: Scalars['UnixEpochTimestamp'];
  syncId: Scalars['bigint'];
};

export type SyncRunMetricsResult = {
  __typename?: 'SyncRunMetricsResult';
  data: Array<SyncRunMetric>;
};

export type SyncableColumn = {
  __typename?: 'SyncableColumn';
  alias?: Maybe<Scalars['String']>;
  column_reference: Scalars['JSONObject'];
  custom_type?: Maybe<Scalars['String']>;
  effective_privacy_level?: Maybe<Scalars['String']>;
  is_boosted_column: Scalars['Boolean'];
  merged_relationship_names?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Scalars['JSONObject']>;
  model: ModelData;
  name: Scalars['String'];
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type SyncableColumnRowKey = {
  __typename?: 'SyncableColumnRowKey';
  reference: Scalars['String'];
  rowKey: Scalars['String'];
};

export type Table = {
  __typename?: 'Table';
  fields: Array<Field>;
  name: Scalars['String'];
};

export type TagContentImagesInput = {
  imageIds: Array<Scalars['uuid']>;
};

export type TagContentImagesPipelineResponse = {
  __typename?: 'TagContentImagesPipelineResponse';
  pipelineRunId?: Maybe<Scalars['uuid']>;
};

export const TagType = {
  Message: 'message',
  Variant: 'variant'
} as const;

export type TagType = typeof TagType[keyof typeof TagType];
export type TagsBackgroundJobResult = GetTagsResult | GetTagsSchemaResults;

export type TagsJobResponse = {
  __typename?: 'TagsJobResponse';
  createdAt?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
};

export type TemplateLinkParam = {
  __typename?: 'TemplateLinkParam';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** A single UTM/link parameter appended to links in a deployed template. */
export type TemplateLinkParamInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type TestCepProviderConnectionInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerType: Scalars['String'];
  secrets?: InputMaybe<Scalars['JSONObject']>;
};

export type TestCepProviderConnectionResult = {
  __typename?: 'TestCepProviderConnectionResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestConnectionResult = {
  __typename?: 'TestConnectionResult';
  message?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<TestConnectionStatus>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TestConnectionStatus = {
  __typename?: 'TestConnectionStatus';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestDestinationResponse = {
  __typename?: 'TestDestinationResponse';
  metadata?: Maybe<Scalars['JSONObject']>;
  reason?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Maybe<TestDestinationStepStatus>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TestDestinationStepStatus = {
  __typename?: 'TestDestinationStepStatus';
  error?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestExtensionConnectionInput = {
  config: Scalars['JSON'];
  extensionId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TestExtensionConnectionResult = {
  __typename?: 'TestExtensionConnectionResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type TestExternalContextSourceConnectionInput = {
  config: Scalars['jsonb'];
  integration: Scalars['String'];
};

export type TestExternalContextSourceConnectionJob = {
  __typename?: 'TestExternalContextSourceConnectionJob';
  jobId: Scalars['uuid'];
};

export type TestFailoverBucketsResult = {
  __typename?: 'TestFailoverBucketsResult';
  results: Array<FailoverBucketTestResult>;
  success: Scalars['Boolean'];
};

export type TestFivetranConnectionResponse = {
  __typename?: 'TestFivetranConnectionResponse';
  setupTests: Array<FivetranSetupTest>;
};

export type TestFivetranWebhookResult = {
  __typename?: 'TestFivetranWebhookResult';
  message?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  succeed: Scalars['Boolean'];
};

export type TestIdrOnCompleteSqlErrorResponse = {
  __typename?: 'TestIDROnCompleteSqlErrorResponse';
  error: Scalars['String'];
};

export type TestIdrOnCompleteSqlInput = {
  graphId: Scalars['String'];
  sql: Scalars['String'];
};

export type TestIdrOnCompleteSqlResponse = TestIdrOnCompleteSqlErrorResponse | TestIdrOnCompleteSqlSuccessResponse;

export type TestIdrOnCompleteSqlSuccessResponse = {
  __typename?: 'TestIDROnCompleteSqlSuccessResponse';
  durationMs: Scalars['Int'];
  /**
   * True when the SQL was still executing without errors when the test's
   * time budget expired and it was canceled.
   */
  timedOut: Scalars['Boolean'];
};

export type TestPersonalizationApiInput = {
  destinationId: Scalars['bigint'];
  flowId: Scalars['uuid'];
  userId: Scalars['String'];
};

export type TestPersonalizationApiResult = {
  __typename?: 'TestPersonalizationApiResult';
  body?: Maybe<Scalars['JSONObject']>;
  /** HTTP status returned by PAPI, or 0 if the upstream request did not complete successfully. */
  status: Scalars['Int'];
};

export type TestPushTokenResult = {
  __typename?: 'TestPushTokenResult';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token: Scalars['String'];
};

export type TestSourceBackgroundJobFailure = {
  __typename?: 'TestSourceBackgroundJobFailure';
  error: Scalars['String'];
  type: TestSourceStatus;
};

export type TestSourceBackgroundJobProcessing = {
  __typename?: 'TestSourceBackgroundJobProcessing';
  type: TestSourceStatus;
};

export type TestSourceBackgroundJobResult = TestSourceBackgroundJobFailure | TestSourceBackgroundJobProcessing | TestSourceBackgroundJobSuccess;

export type TestSourceBackgroundJobSuccess = {
  __typename?: 'TestSourceBackgroundJobSuccess';
  result: TestSourceResult;
  type: TestSourceStatus;
};

export type TestSourceInput = {
  configuration?: InputMaybe<Scalars['JSONObject']>;
  credentialId?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  tunnelId?: InputMaybe<Scalars['String']>;
  warehousePlanConfig?: InputMaybe<Scalars['JSONObject']>;
};

export type TestSourceResult = {
  __typename?: 'TestSourceResult';
  stepResults: Array<Scalars['JSONObject']>;
  success: Scalars['Boolean'];
};

export const TestSourceStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type TestSourceStatus = typeof TestSourceStatus[keyof typeof TestSourceStatus];
export type TestSourceStep = {
  __typename?: 'TestSourceStep';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TestSyncConfigurationResult = {
  __typename?: 'TestSyncConfigurationResult';
  batches: Array<SyncResultBatch>;
  error?: Maybe<Scalars['String']>;
};

export type ThroughInstance = {
  __typename?: 'ThroughInstance';
  id: Scalars['String'];
  models: Array<PathModels>;
  pathSegments: Array<PathSegment>;
};

export type ThroughRelationship = {
  __typename?: 'ThroughRelationship';
  id: Scalars['String'];
  name: Scalars['String'];
  through: Array<ThroughInstance>;
};

export type TimeSeriesMetricResult = {
  __typename?: 'TimeSeriesMetricResult';
  backgroundJobs: Array<MetricJobIdentifier>;
  immediateData: Array<MetricResultFromCache>;
};

export type TimeWindow = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type TimeframeInput = {
  is_churn?: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  unit: Scalars['String'];
};

export type TimelineStep = {
  __typename?: 'TimelineStep';
  completed: Scalars['Boolean'];
  status: Scalars['String'];
  timestamp?: Maybe<Scalars['String']>;
};

export type ToggleCachedEventPullEnabledError = {
  __typename?: 'ToggleCachedEventPullEnabledError';
  error: Scalars['String'];
};

export type ToggleCachedEventPullEnabledInput = {
  cachedEventPullId: Scalars['uuid'];
  enabled: Scalars['Boolean'];
};

export type ToggleCachedEventPullEnabledResult = ToggleCachedEventPullEnabledError | ToggleCachedEventPullEnabledSuccess;

export type ToggleCachedEventPullEnabledSuccess = {
  __typename?: 'ToggleCachedEventPullEnabledSuccess';
  cachedEventPullId: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  message: Scalars['String'];
};

export type TogglePredictorEnabledError = {
  __typename?: 'TogglePredictorEnabledError';
  error: Scalars['String'];
};

export type TogglePredictorEnabledInput = {
  enabled: Scalars['Boolean'];
  predictorId: Scalars['uuid'];
};

export type TogglePredictorEnabledResult = TogglePredictorEnabledError | TogglePredictorEnabledSuccess;

export type TogglePredictorEnabledSuccess = {
  __typename?: 'TogglePredictorEnabledSuccess';
  enabled: Scalars['Boolean'];
  message: Scalars['String'];
  predictorId: Scalars['uuid'];
};

export type TopKColumnResponse = {
  __typename?: 'TopKColumnResponse';
  error?: Maybe<Scalars['String']>;
  modelId: Scalars['String'];
  name: Scalars['String'];
  values?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type TopKResponse = {
  __typename?: 'TopKResponse';
  columns: Array<TopKColumnResponse>;
};

export type TopKSpaceScopingLoadEstimate = {
  __typename?: 'TopKSpaceScopingLoadEstimate';
  /**
   * How long the most recently completed workspace-level top-k column
   * sync took, in milliseconds, or null when no column sync has ever
   * completed in this workspace.
   */
  lastJobDurationMs?: Maybe<Scalars['Int']>;
  parentModelsCount: Scalars['Int'];
  spacesCount: Scalars['Int'];
};

export type TopKTraitResponse = {
  __typename?: 'TopKTraitResponse';
  error?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export const TrackedAudienceListMode = {
  /**
   * Every eligible audience for the list's parent model, resolved at query time.
   * Automatically picks up audiences created after the list.
   */
  AllForParent: 'all_for_parent',
  /** Explicit set of audiences (frozen at creation, edited by the user). */
  Allowlist: 'allowlist'
} as const;

export type TrackedAudienceListMode = typeof TrackedAudienceListMode[keyof typeof TrackedAudienceListMode];
export const TrackedAudienceListOutputFormat = {
  /** Emits an array of audience ids (e.g. ["123", "456"]). */
  Id: 'id',
  /**
   * Emits an array of objects, each carrying { audience_id }. The extra keys
   * are opt-in per list: includeAudienceName adds audience_name (resolved from
   * the audience at query time, null if it no longer exists), and
   * includeSplitGroup adds split_group.
   */
  Object: 'object'
} as const;

export type TrackedAudienceListOutputFormat = typeof TrackedAudienceListOutputFormat[keyof typeof TrackedAudienceListOutputFormat];
export type TraitDefinition = {
  __typename?: 'TraitDefinition';
  /**
   * Non-archived traits created from this template (Hasura's
   * child_traits(where: {archived_at: {_is_null: true}})), scoped to the
   * session workspace like the root field.
   */
  activeTraits: Array<TraitDefinition>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  config: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['bigint'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  predictor?: Maybe<Predictors>;
  predictorId?: Maybe<Scalars['uuid']>;
  relationship?: Maybe<ModelRelationships>;
  relationshipId?: Maybe<Scalars['bigint']>;
  segment?: Maybe<Segments>;
  segmentId: Scalars['bigint'];
  topKEnabled: Scalars['Boolean'];
  topKStatuses: Array<TraitDefinitionTopKStatus>;
  topKSyncInterval?: Maybe<Scalars['Int']>;
  /**
   * Audiences and trait enrichments referencing this trait — the same data the
   * trait_references_v2 Hasura remote relationship returns today.
   */
  traitReferences: TraitDefinitionReferences;
  traitTemplateId?: Maybe<Scalars['uuid']>;
  triggerTopKSync?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  updatedBy: Scalars['bigint'];
  workspaceId: Scalars['bigint'];
};

export type TraitDefinitionEnrichmentReference = {
  __typename?: 'TraitDefinitionEnrichmentReference';
  alias: Scalars['String'];
  audienceId: Scalars['String'];
  audienceName: Scalars['String'];
};

export type TraitDefinitionReferences = {
  __typename?: 'TraitDefinitionReferences';
  audiences: Array<Scalars['String']>;
  traitEnrichments: Array<TraitDefinitionEnrichmentReference>;
};

export type TraitDefinitionTopKStatus = {
  __typename?: 'TraitDefinitionTopKStatus';
  lastSyncAttempted?: Maybe<Scalars['timestamptz']>;
  /**
   * When the values being served were written. Only a run that produced values
   * advances this; every run advances lastSyncAttempted, so on a failure the two
   * dates separate "last refreshed" from "last attempted".
   */
  lastSyncCompleted?: Maybe<Scalars['timestamptz']>;
  topKError?: Maybe<Scalars['String']>;
  traitId: Scalars['uuid'];
};

export type TraitDefinitionsResult = {
  __typename?: 'TraitDefinitionsResult';
  totalCount: Scalars['Int'];
  traits: Array<TraitDefinition>;
};

export const TraitDefinitionsSortDirection = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type TraitDefinitionsSortDirection = typeof TraitDefinitionsSortDirection[keyof typeof TraitDefinitionsSortDirection];
/**
 * Sortable fields. Values are the camelCase TraitDefinition field names they
 * sort on, so clients can pass their own field keys straight through;
 * relatedModelName and activeTraitCount are derived (the related model's name,
 * and the number of activeTraits).
 */
export const TraitDefinitionsSortKey = {
  ActiveTraitCount: 'activeTraitCount',
  CreatedAt: 'createdAt',
  Name: 'name',
  RelatedModelName: 'relatedModelName',
  Type: 'type',
  UpdatedAt: 'updatedAt'
} as const;

export type TraitDefinitionsSortKey = typeof TraitDefinitionsSortKey[keyof typeof TraitDefinitionsSortKey];
export type TraitEnrichmentReference = {
  __typename?: 'TraitEnrichmentReference';
  alias: Scalars['String'];
  audienceId: Scalars['String'];
  audienceName: Scalars['String'];
};

export type TraitsRatio = {
  __typename?: 'TraitsRatio';
  ratio: Scalars['Float'];
  traitDefinitionId: Scalars['String'];
};

export type TreatmentPreviewJob = {
  __typename?: 'TreatmentPreviewJob';
  startedAt: Scalars['String'];
  status: Scalars['String'];
};

export type TriggerAidContentRecommendationsRunResponse = {
  __typename?: 'TriggerAIDContentRecommendationsRunResponse';
  enqueued: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reportScheduleId?: Maybe<Scalars['ID']>;
};

export type TriggerEtlSyncRunResult = {
  __typename?: 'TriggerEtlSyncRunResult';
  background_job_id: Scalars['String'];
  etl_sync_run_id: Scalars['String'];
};

export type TriggerIdeasRunResponse = {
  __typename?: 'TriggerIdeasRunResponse';
  enqueued: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reportScheduleId?: Maybe<Scalars['ID']>;
};

export type TriggerLaunchTrackingRunResponse = {
  __typename?: 'TriggerLaunchTrackingRunResponse';
  enqueued: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  state: LaunchesState;
};

export type TriggerMessagePreviewInput = {
  /** Destination campaign identifier in its native type — a string (Braze) or a number (Iterable). */
  campaignId?: InputMaybe<Scalars['JSON']>;
  /** Required for v2 sends and renders; separate from the personalized send payload. */
  content?: InputMaybe<MessagePreviewContentInput>;
  flowId: Scalars['uuid'];
  /** Selected collection items, keyed by collection. */
  items?: InputMaybe<Scalars['JSONObject']>;
  /**
   * Preview method: "render" previews destination-side as the previewed user
   * without sending; "send" triggers a real test send. Omitted means "send"
   * (legacy behavior for frontends that predate the field).
   */
  method?: InputMaybe<Scalars['String']>;
  protocolVersion?: InputMaybe<Scalars['Int']>;
  /** Destination resource/asset identifier in its native type — a string or a number (Marketo). */
  resourceId?: InputMaybe<Scalars['JSON']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  /** Raw parent-model row for the previewed user. */
  user?: InputMaybe<Scalars['JSONObject']>;
  variables?: InputMaybe<Scalars['JSONObject']>;
};

export type Tunnel = {
  createdAt?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tunnelPort?: Maybe<Scalars['Int']>;
};

export type UnlinkAsanaTaskInput = {
  campaignId: Scalars['ID'];
};

/**
 * Who wrote a comment or was mentioned in it, named for rendering. kind is what
 * distinguishes the two — a review agent's id is a uuid and a user's is numeric,
 * so exactly one of the id fields is set. name is null only if the row has since
 * lost its name.
 */
export type UnreadAssetCommentActor = {
  __typename?: 'UnreadAssetCommentActor';
  /** user, reviewAgent, or agent for Hightouch's agent, which has no id. */
  kind: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  reviewAgentId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['Int']>;
};

/**
 * The ad a thread hangs off, with the route to open it. Present only when the
 * subject is an ad in a folder or a project, so at least one of folderId and
 * adStudioProjectId is set. Anything else has nowhere to navigate, and the
 * caller should leave the row inert.
 */
export type UnreadAssetCommentAd = {
  __typename?: 'UnreadAssetCommentAd';
  adBriefId: Scalars['uuid'];
  adStudioProjectId?: Maybe<Scalars['uuid']>;
  assetId: Scalars['uuid'];
  assetName?: Maybe<Scalars['String']>;
  channelSizeId?: Maybe<Scalars['uuid']>;
  folderId?: Maybe<Scalars['uuid']>;
};

/**
 * The AMP board project or task a thread hangs off, with what the row is
 * called. taskId is null for a thread on the project itself; a task thread
 * still carries its project's id.
 */
export type UnreadAssetCommentAmpSubject = {
  __typename?: 'UnreadAssetCommentAmpSubject';
  projectId: Scalars['uuid'];
  taskId?: Maybe<Scalars['uuid']>;
  title: Scalars['String'];
};

/**
 * A capped tally: count stops at the cap and hasMore says it was hit, so a
 * caller renders the overflow ("99+") rather than reporting the cap as a total.
 */
export type UnreadAssetCommentCount = {
  __typename?: 'UnreadAssetCommentCount';
  count: Scalars['Int'];
  hasMore: Scalars['Boolean'];
};

export type UnreadAssetCommentThread = {
  __typename?: 'UnreadAssetCommentThread';
  ad?: Maybe<UnreadAssetCommentAd>;
  amp?: Maybe<UnreadAssetCommentAmpSubject>;
  id: Scalars['uuid'];
  status: Scalars['String'];
  subject: AssetCommentThreadSubject;
};

export type UnresolvedContentBlock = {
  __typename?: 'UnresolvedContentBlock';
  name: Scalars['String'];
  reason: Scalars['String'];
};

export type UpdateAgenticSettingsEntityInput = {
  adTemplate?: InputMaybe<AgenticSettingsAdTemplateContentInput>;
  /**
   * Agents this entity is routed to. Undefined leaves the current scope intact;
   * null or an empty array clears it (applies to all agents).
   */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  contextCopyExamples?: InputMaybe<AgenticSettingsCopyExamplesContentInput>;
  contextFile?: InputMaybe<AgenticSettingsFileContentUpdateInput>;
  /**
   * The new content of a context_markdown entity. Omitted keeps the current
   * content, so metadata can be saved on an entry whose content is synced.
   */
  contextMarkdown?: InputMaybe<AgenticSettingsMarkdownContentInput>;
  contextType?: InputMaybe<ContextFileType>;
  description?: InputMaybe<Scalars['String']>;
  expectedVersionId?: InputMaybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /**
   * Sets or clears the reference-only flag. Omitted leaves it as it is. Clearing
   * it is how a reference asset becomes a standalone document; setting it hides
   * a document that only makes sense inside another one.
   */
  isReferenceOnly?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type: AgenticSettingsEntityType;
};

export type UpdateAmpAssetSourceInput = {
  config?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAmpAssetSyncInput = {
  config?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['JSON']>;
  schedulePaused?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<UpdateAmpAssetSourceInput>;
  targetAssetGroupId?: InputMaybe<Scalars['ID']>;
};

export type UpdateApiKeyUserGroupInput = {
  id: Scalars['int8'];
  /**
   * Null returns the key to its creator's permissions, which is an offered
   * choice rather than a way to widen a key by accident.
   */
  userGroupId?: InputMaybe<Scalars['int8']>;
};

export type UpdateAsanaTaskInput = {
  /** Omit to edit the campaign's own task. */
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  assignee?: InputMaybe<AsanaNullableValue>;
  campaignId: Scalars['ID'];
  completed?: InputMaybe<Scalars['Boolean']>;
  customFields?: InputMaybe<Array<AsanaCustomFieldWriteInput>>;
  dueOn?: InputMaybe<AsanaNullableValue>;
  /** Plain text, unlike the description — no markup and nothing embedded to lose. */
  name?: InputMaybe<Scalars['String']>;
  /** Moves the task into this section of a project it already belongs to. */
  sectionGid?: InputMaybe<Scalars['ID']>;
  /** A status option's gid, for a task whose custom type defines a workflow. */
  statusOptionGid?: InputMaybe<Scalars['ID']>;
};

export type UpdateAudienceTemplateInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAudienceTemplateResponse = {
  __typename?: 'UpdateAudienceTemplateResponse';
  id: Scalars['uuid'];
};

export type UpdateBlocklistInput = {
  /**
   * Deprecated: use allowAndBackfillValue. Allows the values without
   * re-scanning rows, so rows already ingested with a value nulled keep it nulled.
   */
  allow?: InputMaybe<Array<IdrIdentifier>>;
  /**
   * Allow the values and, on the next run, re-scan the source for rows
   * carrying them and merge those rows into their existing clusters.
   */
  allowAndBackfillValue?: InputMaybe<Array<IdrIdentifier>>;
  /** Deprecated: use blockAndReingestCluster. */
  blockAndReingest?: InputMaybe<Array<IdrIdentifier>>;
  /**
   * Block the values and, on the next run, tear down the clusters they belong
   * to and ingest those rows again.
   */
  blockAndReingestCluster?: InputMaybe<Array<IdrIdentifier>>;
  idrId: Scalars['String'];
  unallow?: InputMaybe<Array<IdrIdentifier>>;
  unblock?: InputMaybe<Array<IdrIdentifier>>;
};

export type UpdateBlocklistJob = {
  __typename?: 'UpdateBlocklistJob';
  jobId: Scalars['String'];
};

export type UpdateBlocklistJobFailure = {
  __typename?: 'UpdateBlocklistJobFailure';
  error?: Maybe<Scalars['String']>;
  status: UpdateBlocklistJobStatus;
};

export type UpdateBlocklistJobPending = {
  __typename?: 'UpdateBlocklistJobPending';
  status: UpdateBlocklistJobStatus;
};

export type UpdateBlocklistJobResult = UpdateBlocklistJobFailure | UpdateBlocklistJobPending | UpdateBlocklistJobSuccess;

export const UpdateBlocklistJobStatus = {
  Failure: 'FAILURE',
  Pending: 'PENDING',
  Success: 'SUCCESS'
} as const;

export type UpdateBlocklistJobStatus = typeof UpdateBlocklistJobStatus[keyof typeof UpdateBlocklistJobStatus];
export type UpdateBlocklistJobSuccess = {
  __typename?: 'UpdateBlocklistJobSuccess';
  status: UpdateBlocklistJobStatus;
};

export type UpdateCachedEventPullSettingsError = {
  __typename?: 'UpdateCachedEventPullSettingsError';
  error: Scalars['String'];
};

export type UpdateCachedEventPullSettingsInput = {
  bufferedWatermarkDays?: InputMaybe<Scalars['Int']>;
  cachedEventPullId: Scalars['uuid'];
  eventLabel?: InputMaybe<Scalars['String']>;
  maxPullWindowDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateCachedEventPullSettingsResult = UpdateCachedEventPullSettingsError | UpdateCachedEventPullSettingsSuccess;

export type UpdateCachedEventPullSettingsSuccess = {
  __typename?: 'UpdateCachedEventPullSettingsSuccess';
  cachedEventPullId: Scalars['uuid'];
  message: Scalars['String'];
};

export type UpdateCalendarViewInput = {
  filters?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignStatusResult = {
  __typename?: 'UpdateCampaignStatusResult';
  campaignId?: Maybe<Scalars['ID']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateCepChannelDailyCapResult = {
  __typename?: 'UpdateCepChannelDailyCapResult';
  channelDailyCap?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
};

export type UpdateCepParentModelSettingsInput = {
  columnMappings?: InputMaybe<Scalars['JSONObject']>;
  parentModelId: Scalars['ID'];
  warehouseAttributeCacheSyncId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCepParentModelsSettingsInput = {
  parentModels: Array<UpdateCepParentModelSettingsInput>;
};

export type UpdateCepProviderInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  secrets?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateCepWhatsAppMessageCategoryInput = {
  messageId: Scalars['ID'];
  requestedCategory: Scalars['String'];
};

export type UpdateCepWhatsAppTemplateInput = {
  /** Moves the template to another WhatsApp account, and so possibly another WABA. */
  cepProviderId?: InputMaybe<Scalars['ID']>;
  /** Authored content: components, and an example value per variable. */
  editorState?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  requestedCategory?: InputMaybe<Scalars['String']>;
};

export type UpdateCepWhatsAppTemplateResult = {
  __typename?: 'UpdateCepWhatsAppTemplateResult';
  /** True when the content changed after the template was last submitted. */
  hasUnsubmittedChanges: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type UpdateComponentAssetInput = {
  assetId: Scalars['uuid'];
  autosave?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type UpdateComponentAssetResponse = {
  __typename?: 'UpdateComponentAssetResponse';
  versionId: Scalars['uuid'];
};

export type UpdateConnectionRoleMappingInput = {
  connectionRoleId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
};

export type UpdateConsentPurgeResult = ConsentPurgeValidationFailed | DecisionEngineSuccess;

export type UpdateContentArtifactMetadataInput = {
  artifactId: Scalars['uuid'];
  generateInput?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateContentArtifactMetadataResponse = {
  __typename?: 'UpdateContentArtifactMetadataResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateDamSyncInput = {
  filters?: InputMaybe<ImportFiltersInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Null clears the schedule. */
  schedule?: InputMaybe<Scalars['JSON']>;
  schedulePaused?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDecisionEngineMessageInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  content?: InputMaybe<Scalars['String']>;
  flowMessageConfig?: InputMaybe<Scalars['JSONObject']>;
  llm_description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  variables?: InputMaybe<Scalars['JSON']>;
};

export type UpdateDomainSourcesInput = {
  event_plan_id: Scalars['String'];
  source_ids: Array<Scalars['String']>;
};

export type UpdateDomainSourcesResult = {
  __typename?: 'UpdateDomainSourcesResult';
  affected_rows: Scalars['Int'];
};

export type UpdateEmailTemplateInput = {
  /**
   * Source content email whose imported provider settings (e.g. UTM link
   * params) should be applied to the updated template. Used only when no
   * explicit linkParams / googleAnalyticsCampaignName is given.
   */
  contentEmailId?: InputMaybe<Scalars['String']>;
  /** Explicit GA campaign name; same precedence semantics as linkParams. */
  googleAnalyticsCampaignName?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  /**
   * Explicit link params to set on the template. Takes precedence over
   * contentEmailId resolution; an empty list clears the params the template
   * currently carries. Omit to leave the provider's params untouched.
   */
  linkParams?: InputMaybe<Array<TemplateLinkParamInput>>;
  name?: InputMaybe<Scalars['String']>;
  plaintext?: InputMaybe<Scalars['String']>;
  preheader?: InputMaybe<Scalars['String']>;
  shouldInlineCss?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateId: Scalars['String'];
};

export type UpdateEventComponentInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateEventForwardingSyncInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateEventPlanInput = {
  default_schema_version?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  on_undeclared_schema?: InputMaybe<Scalars['String']>;
  schema_version_path?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSchemaInput = {
  eventSchemaVersionIdsToUpdate?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  schema: EventSchemaInput;
  updatesToPropagateAcrossVersions?: InputMaybe<EventSchemaInput>;
  workspace_id: Scalars['String'];
};

export type UpdateEventSourceInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  event_plan_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  on_undeclared_schema?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['String']>;
};

export type UpdateEventWarehouseDestinationInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema_settings?: InputMaybe<Scalars['JSONObject']>;
  slug?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['String']>;
};

export type UpdateEventWarehouseSyncInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  schemaOnly?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateExtensionInput = {
  adStudioSyncConfig?: InputMaybe<AdStudioSyncConfigInput>;
  config?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  setupComplete?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateExtensionResult = {
  __typename?: 'UpdateExtensionResult';
  id: Scalars['String'];
};

export type UpdateExternalContextSourceInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  syncFrequency?: InputMaybe<Scalars['jsonb']>;
};

export type UpdateFivetranSyncAccountsInput = {
  /** `null` = sync all accessible accounts. Non-empty list pins specific accounts. */
  enabledAdAccounts?: InputMaybe<Array<Scalars['String']>>;
  syncId: Scalars['String'];
};

export type UpdateFivetranSyncAccountsResponse = {
  __typename?: 'UpdateFivetranSyncAccountsResponse';
  enabledAdAccounts?: Maybe<Array<Scalars['String']>>;
  syncId: Scalars['String'];
};

export type UpdateFivetranSyncAuthInput = {
  destinationId?: InputMaybe<Scalars['bigint']>;
  enabledAdAccounts?: InputMaybe<Array<Scalars['String']>>;
  sourceConfig?: InputMaybe<SetupFivetranSyncSourceConfig>;
  syncId: Scalars['String'];
};

export type UpdateFunctionInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFunctionResponse = {
  __typename?: 'UpdateFunctionResponse';
  id: Scalars['String'];
};

export type UpdateGoldenRecordColumnErrorResponse = {
  __typename?: 'UpdateGoldenRecordColumnErrorResponse';
  error: Scalars['String'];
};

export type UpdateGoldenRecordColumnInput = {
  columnName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  identifier?: InputMaybe<Scalars['String']>;
  survivorshipRuleType?: InputMaybe<Scalars['String']>;
};

export type UpdateGoldenRecordColumnResponse = UpdateGoldenRecordColumnErrorResponse | UpdateGoldenRecordColumnSuccessResponse;

export type UpdateGoldenRecordColumnSuccessResponse = {
  __typename?: 'UpdateGoldenRecordColumnSuccessResponse';
  id: Scalars['String'];
};

export type UpdateGoldenRecordErrorResponse = {
  __typename?: 'UpdateGoldenRecordErrorResponse';
  error: Scalars['String'];
};

export type UpdateGoldenRecordInput = {
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};

export type UpdateGoldenRecordResponse = UpdateGoldenRecordErrorResponse | UpdateGoldenRecordSuccessResponse;

export type UpdateGoldenRecordSuccessResponse = {
  __typename?: 'UpdateGoldenRecordSuccessResponse';
  id: Scalars['String'];
};

export type UpdateIdrGraphErrorResponse = {
  __typename?: 'UpdateIDRGraphErrorResponse';
  error: Scalars['String'];
};

export type UpdateIdrGraphInput = {
  blockRules?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  fullRerun?: InputMaybe<Scalars['Boolean']>;
  graphId: Scalars['String'];
  householding_enabled?: InputMaybe<Scalars['Boolean']>;
  mergeRules?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  onCompleteSql?: InputMaybe<Scalars['String']>;
  outputTable?: InputMaybe<Scalars['String']>;
  probabilisticConfig?: InputMaybe<Scalars['JSONObject']>;
  resolutionRules?: InputMaybe<Scalars['JSON']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  schedulePaused?: InputMaybe<Scalars['Boolean']>;
  scheduleUpdatedAt?: InputMaybe<Scalars['String']>;
};

export type UpdateIdrGraphResponse = UpdateIdrGraphErrorResponse | UpdateIdrGraphSuccessResponse;

export type UpdateIdrGraphSuccessResponse = {
  __typename?: 'UpdateIDRGraphSuccessResponse';
  graphId: Scalars['String'];
};

export type UpdateIdrModelBulkInput = {
  graphId: Scalars['String'];
  models: Array<UpdateIdrModelInput>;
};

export type UpdateIdrModelErrorResponse = {
  __typename?: 'UpdateIDRModelErrorResponse';
  error: Scalars['String'];
};

export type UpdateIdrModelInput = {
  goldenRecordBaseSurvivorshipRuleType?: InputMaybe<Scalars['String']>;
  idrModelId: Scalars['String'];
  mappings?: InputMaybe<Array<IdrModelMappingInput>>;
  orderBy?: InputMaybe<IdrModelOrderByInput>;
  rank?: InputMaybe<Scalars['Int']>;
  scopeColumn?: InputMaybe<Scalars['String']>;
  watermarkLookbackDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateIdrModelResponse = UpdateIdrModelErrorResponse | UpdateIdrModelSuccessResponse;

export type UpdateIdrModelSuccessResponse = {
  __typename?: 'UpdateIDRModelSuccessResponse';
  idrModelIds: Array<Scalars['String']>;
};

export type UpdateJourneyOutput = {
  __typename?: 'UpdateJourneyOutput';
  dropped_edges: Array<Edge>;
  id_map: Scalars['JSONObject'];
  result: JourneyGraph;
};

export type UpdateJourneyTemplateOutput = {
  __typename?: 'UpdateJourneyTemplateOutput';
  id_map: Scalars['JSONObject'];
  result: JourneyTemplateGraph;
};

export type UpdateJourneyTraitInput = {
  accumulatedState: JourneyTraitAccumulatedState;
  conditions?: InputMaybe<Scalars['JSON']>;
  defaultValue?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateJourneyTraitOutput = {
  __typename?: 'UpdateJourneyTraitOutput';
  id: Scalars['String'];
  journeyStateVersion: Scalars['Int'];
};

export type UpdateLibraryImageInput = {
  alt_text?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLlmChatMessageContentInput = {
  content: Scalars['JSONObject'];
  id: Scalars['uuid'];
  index?: InputMaybe<Scalars['Int']>;
};

export type UpdateLlmInferenceBackendInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateManyDecisionEngineMessagesInput = {
  messageId: Scalars['uuid'];
  offerId?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
  variables?: InputMaybe<Scalars['JSON']>;
};

/**
 * primaryMetric replaces the metric (null clears it). arms is the full desired set
 * reconciled by provenance: sourceVariantKey continues an existing arm (content
 * re-keyed to variantKey), otherwise the arm is inserted + seeded; arms not
 * referenced as a source are removed.
 */
export type UpdateMessageAbTestInput = {
  arms?: InputMaybe<Array<UpdateMessageVariantArmInput>>;
  measurementWindow?: InputMaybe<Scalars['JSONObject']>;
  messageExperimentId: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
  primaryMetric?: InputMaybe<MessageAbTestPrimaryMetricInput>;
  secondaryMetrics?: InputMaybe<Array<MessageAbTestPrimaryMetricInput>>;
};

export type UpdateMessageAbTestResult = {
  __typename?: 'UpdateMessageAbTestResult';
  experimentId: Scalars['uuid'];
  messageExperimentId: Scalars['uuid'];
};

export type UpdateMessageContentInput = {
  editorState?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['uuid'];
  preheader?: InputMaybe<Scalars['String']>;
  profileMappings?: InputMaybe<Array<ProfileMappingInput>>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type UpdateMessagePlanInput = {
  desiredAction: Scalars['String'];
  guidance: Scalars['String'];
  planId: Scalars['uuid'];
  recipient?: InputMaybe<Scalars['String']>;
};

export type UpdateMessagePlanResponse = {
  __typename?: 'UpdateMessagePlanResponse';
  /** The candidate re-authoring interaction kicked off by this brief edit. */
  interactionId: Scalars['uuid'];
};

export type UpdateMessageVariantArmInput = {
  editorState?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  preheader?: InputMaybe<Scalars['String']>;
  profileMappings?: InputMaybe<Array<ProfileMappingInput>>;
  renderedOutput?: InputMaybe<Scalars['JSONObject']>;
  sourceVariantKey?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  /** A new arm's id, as on MessageVariantArmInput. A continuing arm keeps its own. */
  variantId?: InputMaybe<Scalars['String']>;
  variantKey: Scalars['String'];
};

export type UpdateModelColumnsResponse = {
  __typename?: 'UpdateModelColumnsResponse';
  columns?: Maybe<Array<DiscoveredModelColumn>>;
  errors?: Maybe<Array<ColumnValidationError>>;
};

/**
 * pIDR-only pair blocklist: the pair's edge is dropped from pIDR scoring
 * output, so the two rows never link directly — but they can still land in
 * one cluster transitively via other rows. The order of the pair's rows
 * does not matter. Hightouch staff only.
 */
export type UpdatePidrPairBlocklistInput = {
  block?: InputMaybe<Array<IdrRowPairRef>>;
  idrId: Scalars['String'];
  unblock?: InputMaybe<Array<IdrRowPairRef>>;
};

/**
 * pIDR-only row blocklist: blocked rows do not generate any matches — they
 * produce no blocking keys, pairs, or scores. They still appear in the pIDR
 * output with their dIDR ht_id, so they keep their golden records.
 * Hightouch staff only.
 */
export type UpdatePidrRowBlocklistInput = {
  block?: InputMaybe<Array<IdrRowRef>>;
  idrId: Scalars['String'];
  unblock?: InputMaybe<Array<IdrRowRef>>;
};

/**
 * pIDR-only value blocklist: blocked values are nulled out during pIDR
 * normalization. Values must be supplied in pIDR post-normalization form —
 * they are matched against normalized row values as-is.
 * Hightouch staff only.
 */
export type UpdatePidrValueBlocklistInput = {
  block?: InputMaybe<Array<IdrIdentifier>>;
  idrId: Scalars['String'];
  unblock?: InputMaybe<Array<IdrIdentifier>>;
};

export type UpdatePredictorCatalogFeatureDefinitionInput = {
  catalogModelId: Scalars['String'];
  featureDefinitionId: Scalars['uuid'];
  keyEvents: Array<PredictorCatalogEventInput>;
  name: Scalars['String'];
};

export type UpdatePredictorError = {
  __typename?: 'UpdatePredictorError';
  error: Scalars['String'];
};

export type UpdatePredictorFeatureDefinitionError = {
  __typename?: 'UpdatePredictorFeatureDefinitionError';
  error: Scalars['String'];
};

export type UpdatePredictorFeatureDefinitionInput = {
  featureDefinitionId: Scalars['uuid'];
  keyEvents: Array<PredictorEventInput>;
  name: Scalars['String'];
  parentModelId: Scalars['String'];
  propertyFeatures: Array<PredictorFeatureDefinitionPropertyInput>;
};

export type UpdatePredictorFeatureDefinitionResult = UpdatePredictorFeatureDefinitionError | UpdatePredictorFeatureDefinitionSuccess;

export type UpdatePredictorFeatureDefinitionSuccess = {
  __typename?: 'UpdatePredictorFeatureDefinitionSuccess';
  featureDefinitionId: Scalars['uuid'];
  message: Scalars['String'];
};

export type UpdatePredictorInput = {
  audienceDefinition: Scalars['JSONObject'];
  baseAudienceId?: InputMaybe<Scalars['String']>;
  catalogDefinition?: InputMaybe<Scalars['JSONObject']>;
  catalogId?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSONObject']>;
  description: Scalars['String'];
  featureDefinitionId?: InputMaybe<Scalars['uuid']>;
  name: Scalars['String'];
  outcome?: InputMaybe<PredictorOutcomeInput>;
  parentModelId: Scalars['String'];
  predictorId: Scalars['uuid'];
  suppressionFilter?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdatePredictorResult = UpdatePredictorError | UpdatePredictorSuccess;

export type UpdatePredictorSettingsError = {
  __typename?: 'UpdatePredictorSettingsError';
  error: Scalars['String'];
};

export type UpdatePredictorSettingsInput = {
  catalogLookbackDays?: InputMaybe<Scalars['Int']>;
  catalogTopK?: InputMaybe<Scalars['Int']>;
  inferenceBatchSize?: InputMaybe<Scalars['Int']>;
  inferenceCronExpression?: InputMaybe<Scalars['String']>;
  lookalikeEligibleSampleSize?: InputMaybe<Scalars['Int']>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
  maxUsersForTraining?: InputMaybe<Scalars['Int']>;
  predictorId: Scalars['uuid'];
  trainingMatrixMaxRows?: InputMaybe<Scalars['Int']>;
  watermarkStrategy?: InputMaybe<Scalars['String']>;
};

export type UpdatePredictorSettingsResult = UpdatePredictorSettingsError | UpdatePredictorSettingsSuccess;

export type UpdatePredictorSettingsSuccess = {
  __typename?: 'UpdatePredictorSettingsSuccess';
  message: Scalars['String'];
  predictorId: Scalars['uuid'];
};

export type UpdatePredictorSuccess = {
  __typename?: 'UpdatePredictorSuccess';
  featureDefinitionId: Scalars['uuid'];
  message: Scalars['String'];
  outcomeId: Scalars['uuid'];
  predictorId: Scalars['uuid'];
};

export type UpdatePriorityListResponse = {
  __typename?: 'UpdatePriorityListResponse';
  id: Scalars['String'];
};

export type UpdatePushAppInput = {
  bundleId?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<PushAppEnvironment>;
  eventSourceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PushAppPlatform>;
  secrets?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdatePushCampaignInput = {
  actionButtons?: InputMaybe<Array<PushActionButtonInput>>;
  campaignId: Scalars['String'];
  clickAction?: InputMaybe<Scalars['String']>;
  clickUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateRealtimeEventColumnsOutput = {
  __typename?: 'UpdateRealtimeEventColumnsOutput';
  updatedAudienceCount: Scalars['Int'];
};

export type UpdateRelationshipInput = {
  cardinality: Scalars['String'];
  from: Scalars['String'];
  fromName?: InputMaybe<Scalars['String']>;
  isHiddenFromAudienceFilter: Scalars['Boolean'];
  isMergingIntoFrom: Scalars['Boolean'];
  isMergingIntoTo: Scalars['Boolean'];
  joinMappings: Array<JoinMappingInput>;
  slug: Scalars['String'];
  to: Scalars['String'];
  toName?: InputMaybe<Scalars['String']>;
};

/**
 * Update a report's versioned content. Every content field is optional; only
 * the provided fields are written (e.g. the agent-edit flow updates prompt
 * alone). Omit a field to leave it unchanged. prompt and context are required
 * columns and cannot be nulled; files may be set to an empty list to clear it.
 */
export type UpdateReportScheduleContentInput = {
  context?: InputMaybe<Scalars['JSONObject']>;
  files?: InputMaybe<Scalars['JSON']>;
  prompt?: InputMaybe<Scalars['String']>;
  reportScheduleId: Scalars['uuid'];
};

export type UpdateSchemaModelInput = {
  primary_key?: InputMaybe<Scalars['String']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
};

export type UpdateSchemaModelResponse = {
  __typename?: 'UpdateSchemaModelResponse';
  model_id: Scalars['bigint'];
};

export type UpdateSmsCampaignInput = {
  campaignId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSplitsConfigResponse = {
  __typename?: 'UpdateSplitsConfigResponse';
  id: Scalars['String'];
};

export type UpdateStyleEntityInput = {
  /** Omitted keeps the current scopes; empty means every agent. */
  agentScopes?: InputMaybe<Array<AgentScope>>;
  /**
   * Omitted keeps the current assignment; provided replaces it (empty array =
   * applies to all brand profiles).
   */
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  description?: InputMaybe<Scalars['String']>;
  /**
   * When set, the update only applies if this is still the current version id;
   * otherwise the mutation returns conflict: true with the current state and
   * writes nothing. Omitted = last write wins.
   */
  expectedVersionId?: InputMaybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Replaces the style document. */
  markdown?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateStyleEntityResult = {
  __typename?: 'UpdateStyleEntityResult';
  conflict: Scalars['Boolean'];
  style: StyleEntity;
};

export type UpdateSyncTemplateInput = {
  config?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  journey_settings?: InputMaybe<Scalars['JSONObject']>;
  matchbooster_region?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  override_config?: InputMaybe<Scalars['JSONObject']>;
  row_threshold_attempted?: InputMaybe<Scalars['String']>;
  row_threshold_total?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateSyncTemplateResponse = {
  __typename?: 'UpdateSyncTemplateResponse';
  id: Scalars['Int'];
};

export type UpdateTraitDefinitionInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  predictorId?: InputMaybe<Scalars['uuid']>;
  relationshipId?: InputMaybe<Scalars['bigint']>;
  topKEnabled?: InputMaybe<Scalars['Boolean']>;
  topKSyncInterval?: InputMaybe<Scalars['Int']>;
  triggerTopKSync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateTraitInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateTraitResponse = {
  __typename?: 'UpdateTraitResponse';
  id: Scalars['String'];
};

export type UploadAgentFileInput = {
  base64Data: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type UploadContentSettingsFontFileInput = {
  base64Data: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type UploadContentSettingsFontFileOutput = {
  __typename?: 'UploadContentSettingsFontFileOutput';
  fileName: Scalars['String'];
  fontUrl: Scalars['String'];
  storageKey: Scalars['String'];
};

export type UploadFontFileInput = {
  base64Data: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type UploadLogoFileInput = {
  base64Data: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type UploadManuallyEditedImageInput = {
  emailId?: InputMaybe<Scalars['uuid']>;
  html?: InputMaybe<Scalars['String']>;
  imageData: Scalars['String'];
  llmChatMessageId?: InputMaybe<Scalars['uuid']>;
  mimeType: Scalars['String'];
  originalImageUrl?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  sourceNodeId?: InputMaybe<Scalars['uuid']>;
  /**
   * At most one of svg or html may be provided. Nodes saved with html keep
   * html as their canonical markup (svg stays null).
   */
  svg?: InputMaybe<Scalars['String']>;
};

export type UploadManuallyEditedImageResponse = {
  __typename?: 'UploadManuallyEditedImageResponse';
  publicUrl: Scalars['String'];
};

export type UploadMediaAssetInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UploadMediaAssetResult = {
  __typename?: 'UploadMediaAssetResult';
  error?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type UploadMediaAssetsResult = {
  __typename?: 'UploadMediaAssetsResult';
  assets: Array<UploadMediaAssetResult>;
  failedCount: Scalars['Int'];
  successCount: Scalars['Int'];
};

export type UpsertAgentSettingsInput = {
  activeInferenceBackendId?: InputMaybe<Scalars['uuid']>;
  settings: Scalars['JSON'];
};

export type UpsertContentArtifactDynamicSlotContentInput = {
  artifactId: Scalars['uuid'];
  /** Fragment blocks: [{ type: "text", id?, text }] (text-only in v1). */
  blocks: Scalars['JSON'];
  /** Omit to mint a new variant; pass to update an existing one. */
  contentId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  slotId: Scalars['uuid'];
};

export type UpsertContentArtifactDynamicSlotContentResponse = {
  __typename?: 'UpsertContentArtifactDynamicSlotContentResponse';
  contentId: Scalars['uuid'];
};

export type UpsertContentArtifactDynamicSlotInput = {
  artifactId: Scalars['uuid'];
  /**
   * "audience_schema" or "esp_profile". On create, omitted resolves the
   * workspace/ESP-context default; on update, omitted leaves it unchanged.
   * Note: the SMS/push deploy compiles audience conditions only today — ESP
   * branches deploy once esp_orchestrated lands for messages.
   */
  assignmentSource?: InputMaybe<Scalars['String']>;
  assignmentType?: InputMaybe<Scalars['String']>;
  /**
   * Branch array. Inline branches carry fields or blocks; create-then-reference
   * branches carry contentId (same contentId on several branches = N:1 share).
   */
  branches: Scalars['JSON'];
  name?: InputMaybe<Scalars['String']>;
  parentModelId?: InputMaybe<Scalars['String']>;
  slotId: Scalars['uuid'];
};

export type UpsertContentArtifactDynamicSlotResponse = {
  __typename?: 'UpsertContentArtifactDynamicSlotResponse';
  id: Scalars['uuid'];
};

export type UpsertContentEmailDynamicSlotContentInput = {
  /** Email element HTML for this variant (single root, no nested slot marker). */
  content: Scalars['String'];
  /** Omit to mint a new usage-scoped content variant; pass to update one. */
  contentId?: InputMaybe<Scalars['uuid']>;
  emailId: Scalars['uuid'];
  /** Branch / variant display name stored on the content row. */
  name?: InputMaybe<Scalars['String']>;
  slotId: Scalars['uuid'];
};

export type UpsertContentEmailDynamicSlotContentResponse = {
  __typename?: 'UpsertContentEmailDynamicSlotContentResponse';
  contentId: Scalars['uuid'];
};

export type UpsertContentEmailDynamicSlotInput = {
  assignmentType?: InputMaybe<Scalars['String']>;
  /**
   * Preferred: { id, name, condition, contentId }[] — create variants with
   * upsertContentEmailDynamicSlotContent first, then reference contentId here
   * (same id on multiple branches to share). Legacy: { id, name, condition,
   * content }[] still mints a 1:1 content row per branch.
   */
  branches: Scalars['JSON'];
  emailId: Scalars['uuid'];
  /**
   * Placement display name, stored per usage — renaming one placement never
   * retitles sibling placements sharing the library. On create, defaults to
   * "Dynamic content". On update, omit to leave the existing name unchanged.
   */
  name?: InputMaybe<Scalars['String']>;
  /** Required on create when the email has no audience/campaign parent. */
  parentModelId?: InputMaybe<Scalars['String']>;
  slotId: Scalars['uuid'];
};

export type UpsertContentEmailDynamicSlotResponse = {
  __typename?: 'UpsertContentEmailDynamicSlotResponse';
  id: Scalars['uuid'];
};

export type UpsertContentSettingsInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
  custom_guidance?: InputMaybe<Scalars['String']>;
  email_best_practices?: InputMaybe<EmailBestPracticesInput>;
  prefers_external_image_urls?: InputMaybe<Scalars['Boolean']>;
};

export type UpsertContentSettingsOutput = {
  __typename?: 'UpsertContentSettingsOutput';
  brand_guidelines?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  custom_guidance?: Maybe<Scalars['String']>;
  email_best_practices?: Maybe<EmailBestPracticesOutput>;
  id: Scalars['uuid'];
  prefers_external_image_urls: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id: Scalars['bigint'];
};

export type UpsertEventSchemaResult = {
  __typename?: 'UpsertEventSchemaResult';
  errors: Array<EventSchemaError>;
  ok: Scalars['Boolean'];
  schema?: Maybe<EventSchemaResult>;
};

export type UpsertRelationshipsOutput = {
  __typename?: 'UpsertRelationshipsOutput';
  added: Scalars['Int'];
  removed: Scalars['Int'];
  updated: Scalars['Int'];
};

export type UpsertSigmaExtensionInput = {
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  cloud: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type UserDevice = {
  __typename?: 'UserDevice';
  deviceModel?: Maybe<Scalars['String']>;
  lastActive: Scalars['String'];
  osName?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
};

export type UserDevicesResponse = {
  __typename?: 'UserDevicesResponse';
  devices: Array<UserDevice>;
};

export const UserGroupResourceType = {
  Destination: 'destination',
  EventForwardingDestination: 'event_forwarding_destination',
  EventForwardingSync: 'event_forwarding_sync',
  EventFunction: 'event_function',
  EventPlan: 'event_plan',
  EventSource: 'event_source',
  EventWarehouseDestination: 'event_warehouse_destination',
  EventWarehouseSync: 'event_warehouse_sync',
  Idr: 'idr',
  Journey: 'journey',
  Model: 'model',
  RealtimeAudienceSync: 'realtime_audience_sync',
  Source: 'source',
  Sync: 'sync',
  SyncSequence: 'sync_sequence',
  Trait: 'trait',
  Workspace: 'workspace'
} as const;

export type UserGroupResourceType = typeof UserGroupResourceType[keyof typeof UserGroupResourceType];
export type UserInferredTimeZoneResponse = {
  __typename?: 'UserInferredTimeZoneResponse';
  ianaTz?: Maybe<Scalars['String']>;
  signalSource?: Maybe<Scalars['String']>;
};

export type UserPersonalization = {
  __typename?: 'UserPersonalization';
  company_country?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  company_size?: Maybe<Scalars['String']>;
};

export type UserSubscriptionsResponse = {
  __typename?: 'UserSubscriptionsResponse';
  channels: Array<ChannelSubscriptions>;
};

export type ValidateDatadogCredentialsInput = {
  apiKey: Scalars['String'];
  site: Scalars['String'];
};

export type ValidateDatadogCredentialsOutput = {
  __typename?: 'ValidateDatadogCredentialsOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ValidateInAppMessageContentInput = {
  templateId: Scalars['ID'];
  values: Scalars['JSONObject'];
};

export type ValidateInAppMessageContentResult = {
  __typename?: 'ValidateInAppMessageContentResult';
  issues: Array<InAppSchemaIssue>;
  valid: Scalars['Boolean'];
};

export type ValidatePredictorFeatureDefinitionInput = {
  audienceDefinition?: InputMaybe<Scalars['JSONObject']>;
  keyEvents: Array<PredictorEventInput>;
  parentModelId: Scalars['String'];
  propertyFeatures: Array<PredictorFeatureDefinitionPropertyInput>;
};

export type ValidatePredictorFeatureDefinitionResult = {
  __typename?: 'ValidatePredictorFeatureDefinitionResult';
  columns: Array<PitRiskColumnClassification>;
  source: Scalars['String'];
};

export type ValidateSettingsInput = {
  bingAdsDestinationId?: InputMaybe<Scalars['String']>;
  facebookDestinationId?: InputMaybe<Scalars['String']>;
  googleAdsDestinationId?: InputMaybe<Scalars['String']>;
};

export type ValidateSettingsResponse = {
  __typename?: 'ValidateSettingsResponse';
  description?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export const ValidatorNames = {
  Authorization: 'Authorization',
  DbtModelExists: 'DbtModelExists',
  Draft: 'Draft',
  LinkedConnections: 'LinkedConnections',
  LinkedDestinations: 'LinkedDestinations',
  LookerExtensionExists: 'LookerExtensionExists',
  Organization: 'Organization',
  ScheduleExtensions: 'ScheduleExtensions',
  SegmentDeploymentNeeded: 'SegmentDeploymentNeeded',
  SigmaExtensionExists: 'SigmaExtensionExists'
} as const;

export type ValidatorNames = typeof ValidatorNames[keyof typeof ValidatorNames];
export type VerifyCepCloudflareTrackingDomainInput = {
  id: Scalars['ID'];
};

export type VerifyCepDomainDnsRecord = {
  __typename?: 'VerifyCepDomainDnsRecord';
  host: Scalars['String'];
  record_type: Scalars['String'];
  valid: Scalars['Boolean'];
  value: Scalars['String'];
};

export type VerifyCepDomainInput = {
  domain: Scalars['String'];
  providerId: Scalars['ID'];
};

export type VerifyCepDomainResult = {
  __typename?: 'VerifyCepDomainResult';
  dnsRecords: Array<VerifyCepDomainDnsRecord>;
  error?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export type VisualQuerySqlResult = {
  __typename?: 'VisualQuerySQLResult';
  sql: Scalars['String'];
};

export type WarehouseEvent = {
  __typename?: 'WarehouseEvent';
  id: Scalars['String'];
  modelId: Scalars['String'];
  modelName: Scalars['String'];
  timestamp: Scalars['String'];
};

export type WarehouseEventsTimelineBackgroundResult = ProfileExplorerError | WarehouseEventsTimelineResponse;

export type WarehouseEventsTimelineInput = {
  limit?: InputMaybe<Scalars['Int']>;
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
  timeRangeDays?: InputMaybe<Scalars['Int']>;
};

export type WarehouseEventsTimelineResponse = {
  __typename?: 'WarehouseEventsTimelineResponse';
  events: Array<WarehouseEvent>;
};

export type WarehouseShareAvailableDatabases = {
  __typename?: 'WarehouseShareAvailableDatabases';
  databases: Array<Scalars['String']>;
};

export type WarehouseShareDatabase = {
  __typename?: 'WarehouseShareDatabase';
  /** Per-share failure reason when status is error, else null. */
  error?: Maybe<Scalars['String']>;
  /** Customer database/catalog name. */
  name: Scalars['String'];
  status: WarehouseShareDatabaseStatus;
};

export const WarehouseShareDatabaseStatus = {
  Active: 'active',
  Error: 'error',
  Pending: 'pending',
  Removing: 'removing'
} as const;

export type WarehouseShareDatabaseStatus = typeof WarehouseShareDatabaseStatus[keyof typeof WarehouseShareDatabaseStatus];
export type WarehouseShareEligibility = {
  __typename?: 'WarehouseShareEligibility';
  eligible: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type WarehouseShareMirror = {
  __typename?: 'WarehouseShareMirror';
  connectionId: Scalars['bigint'];
  /**
   * Per-database child state (incl. pending/removing). The only carrier of
   * per-share detail — connection-level summaries (is anything active? which
   * names are shared?) are derived from this plus status, never sent twice.
   */
  databases: Array<WarehouseShareDatabase>;
  /** Derived from child rows (always present). */
  status: WarehouseShareMirrorStatus;
};

export const WarehouseShareMirrorStatus = {
  Active: 'active',
  Degraded: 'degraded',
  Disabled: 'disabled',
  Error: 'error',
  Provisioning: 'provisioning'
} as const;

export type WarehouseShareMirrorStatus = typeof WarehouseShareMirrorStatus[keyof typeof WarehouseShareMirrorStatus];
export const WarehouseSharePlatform = {
  Databricks: 'databricks',
  Snowflake: 'snowflake'
} as const;

export type WarehouseSharePlatform = typeof WarehouseSharePlatform[keyof typeof WarehouseSharePlatform];
export type WarehouseShareSetup = {
  __typename?: 'WarehouseShareSetup';
  /** Live validation of those grants against the source connection. */
  checks: Array<WarehouseShareValidationCheck>;
  /** SQL the customer runs in their own warehouse to grant Hightouch access. */
  customerCommands: Array<Scalars['String']>;
  platform: WarehouseSharePlatform;
  /** True when every check passed — provisioning can proceed. */
  ready: Scalars['Boolean'];
};

export type WarehouseShareSetupBackgroundJobFailure = {
  __typename?: 'WarehouseShareSetupBackgroundJobFailure';
  error: Scalars['String'];
  type: WarehouseShareSetupJobStatus;
};

export type WarehouseShareSetupBackgroundJobProcessing = {
  __typename?: 'WarehouseShareSetupBackgroundJobProcessing';
  type: WarehouseShareSetupJobStatus;
};

export type WarehouseShareSetupBackgroundJobResult = WarehouseShareSetupBackgroundJobFailure | WarehouseShareSetupBackgroundJobProcessing | WarehouseShareSetupBackgroundJobSuccess;

export type WarehouseShareSetupBackgroundJobSuccess = {
  __typename?: 'WarehouseShareSetupBackgroundJobSuccess';
  result: WarehouseShareSetup;
  type: WarehouseShareSetupJobStatus;
};

export const WarehouseShareSetupJobStatus = {
  Failure: 'Failure',
  Processing: 'Processing',
  Success: 'Success'
} as const;

export type WarehouseShareSetupJobStatus = typeof WarehouseShareSetupJobStatus[keyof typeof WarehouseShareSetupJobStatus];
export type WarehouseShareValidationCheck = {
  __typename?: 'WarehouseShareValidationCheck';
  error?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  passed: Scalars['Boolean'];
};

export type WarmEspContentBlockCatalogsResult = {
  __typename?: 'WarmEspContentBlockCatalogsResult';
  enqueuedDestinationIds: Array<Scalars['String']>;
};

export type WebPagePsdExportFrame = {
  __typename?: 'WebPagePsdExportFrame';
  /** Layers artifact for building the PSD in the browser. Null until the run completes. */
  url?: Maybe<Scalars['String']>;
  width: Scalars['Int'];
};

export type WebPagePsdExportRun = {
  __typename?: 'WebPagePsdExportRun';
  error?: Maybe<Scalars['String']>;
  frames: Array<WebPagePsdExportFrame>;
  id: Scalars['ID'];
  status: WebPagePsdExportRunStatus;
};

export const WebPagePsdExportRunStatus = {
  Complete: 'complete',
  Failed: 'failed',
  Pending: 'pending',
  Running: 'running'
} as const;

export type WebPagePsdExportRunStatus = typeof WebPagePsdExportRunStatus[keyof typeof WebPagePsdExportRunStatus];
export type WebPushSendCreative = {
  __typename?: 'WebPushSendCreative';
  body: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type WhatsAppTestSender = {
  __typename?: 'WhatsAppTestSender';
  displayName?: Maybe<Scalars['String']>;
  /** Every health signal in display order, or empty when healthState is null. */
  health: Array<CepWhatsAppSenderHealthSignal>;
  /** Null for a configured number the store has no row for, and for a sandbox's number. */
  healthState?: Maybe<CepWhatsAppHealthState>;
  /** The stored sender's id, or an identity-scoped id for a configured number the store has no row for. */
  id: Scalars['ID'];
  /** The sender a test uses when none is picked. */
  isDefault: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
};

export type WhatsAppTestSenderResult = {
  __typename?: 'WhatsAppTestSenderResult';
  error?: Maybe<Scalars['String']>;
  sender?: Maybe<WhatsAppTestSender>;
};

export type WhatsAppTestSendersResult = {
  __typename?: 'WhatsAppTestSendersResult';
  /** Set when the template has nothing to send from. Blocked senders are still listed alongside it. */
  error?: Maybe<Scalars['String']>;
  senders: Array<WhatsAppTestSender>;
};

export type Workspace = {
  __typename?: 'Workspace';
  domain?: Maybe<Scalars['String']>;
  feature_flags?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  is_approved: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WorkspaceEntitlements = {
  __typename?: 'WorkspaceEntitlements';
  /**
   * The effective agents tier: "off", "free", or "full". The highest of the LD
   * dataAgents variant, a staff grant at either tier, and the org entitlements
   * key. The only way the frontend can see a free-tier staff grant, since
   * dataAgents above means full. Not masked by the org AI kill-switch.
   */
  agentsTier: Scalars['String'];
  entitlements: EntitlementValues;
  overage: EntitlementOverage;
};

export type WorkspaceMembersResult = {
  __typename?: 'WorkspaceMembersResult';
  count: Scalars['Int'];
  workspace_id: Scalars['String'];
};

export type WorkspaceMqr = {
  __typename?: 'WorkspaceMqr';
  id: Scalars['Int'];
  monthly_queried_records: Scalars['Int'];
  name: Scalars['String'];
};

export type WorkspaceNotificationChannelResult = {
  __typename?: 'WorkspaceNotificationChannelResult';
  id: Scalars['String'];
};

export type WorkspaceNotificationChannelTest = {
  __typename?: 'WorkspaceNotificationChannelTest';
  error?: Maybe<Scalars['JSONObject']>;
  success: Scalars['Boolean'];
};

export type WorkspaceTesterFunctionCreating = {
  __typename?: 'WorkspaceTesterFunctionCreating';
  type: Scalars['String'];
};

export type ZendeskCustomObjectField = {
  __typename?: 'ZendeskCustomObjectField';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ZendeskCustomObjectType = {
  __typename?: 'ZendeskCustomObjectType';
  name: Scalars['String'];
};

export type ZendeskField = {
  __typename?: 'ZendeskField';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ZendeskListCustomFieldsInput = {
  destinationId: Scalars['String'];
  object: Scalars['String'];
};

export type ZendeskListCustomFieldsResult = ZendeskListCustomFieldsSuccess;

export type ZendeskListCustomFieldsSuccess = {
  __typename?: 'ZendeskListCustomFieldsSuccess';
  fields: Array<ZendeskField>;
};

export type ZendeskListCustomObjectPropertiesInput = {
  destinationId: Scalars['String'];
  objectType: Scalars['String'];
};

export type ZendeskListCustomObjectPropertiesResult = ZendeskListCustomObjectPropertiesSuccess;

export type ZendeskListCustomObjectPropertiesSuccess = {
  __typename?: 'ZendeskListCustomObjectPropertiesSuccess';
  properties: Array<ZendeskCustomObjectField>;
};

export type ZendeskListCustomObjectTypesInput = {
  destinationId: Scalars['String'];
};

export type ZendeskListCustomObjectTypesResult = ZendeskListCustomObjectTypesSuccess;

export type ZendeskListCustomObjectTypesSuccess = {
  __typename?: 'ZendeskListCustomObjectTypesSuccess';
  objectTypes: Array<ZendeskCustomObjectType>;
};

/** columns and relationships of "ad_agent_artifacts" */
export type AdAgentArtifacts = {
  __typename?: 'ad_agent_artifacts';
  created_at: Scalars['timestamptz'];
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  id: Scalars['uuid'];
  object_storage_key: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "ad_agent_artifacts". All fields are combined with a logical 'AND'. */
export type AdAgentArtifactsBoolExp = {
  _and?: InputMaybe<Array<AdAgentArtifactsBoolExp>>;
  _not?: InputMaybe<AdAgentArtifactsBoolExp>;
  _or?: InputMaybe<Array<AdAgentArtifactsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  filename?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  object_storage_key?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "ad_agent_artifacts". */
export type AdAgentArtifactsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  filename?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  object_storage_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_agent_artifacts" */
export const AdAgentArtifactsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByLlmChatInteractionId: 'created_by_llm_chat_interaction_id',
  /** column name */
  Description: 'description',
  /** column name */
  Filename: 'filename',
  /** column name */
  Id: 'id',
  /** column name */
  ObjectStorageKey: 'object_storage_key',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdAgentArtifactsSelectColumn = typeof AdAgentArtifactsSelectColumn[keyof typeof AdAgentArtifactsSelectColumn];
/** Streaming cursor of the table "ad_agent_artifacts" */
export type AdAgentArtifactsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdAgentArtifactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdAgentArtifactsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  object_storage_key?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "ad_asset_favorites" */
export type AdAssetFavorites = {
  __typename?: 'ad_asset_favorites';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "ad_asset_favorites" */
export type AdAssetFavoritesAggregate = {
  __typename?: 'ad_asset_favorites_aggregate';
  aggregate?: Maybe<AdAssetFavoritesAggregateFields>;
  nodes: Array<AdAssetFavorites>;
};

export type AdAssetFavoritesAggregateBoolExp = {
  count?: InputMaybe<AdAssetFavoritesAggregateBoolExpCount>;
};

export type AdAssetFavoritesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdAssetFavoritesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_asset_favorites" */
export type AdAssetFavoritesAggregateFields = {
  __typename?: 'ad_asset_favorites_aggregate_fields';
  avg?: Maybe<AdAssetFavoritesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdAssetFavoritesMaxFields>;
  min?: Maybe<AdAssetFavoritesMinFields>;
  stddev?: Maybe<AdAssetFavoritesStddevFields>;
  stddev_pop?: Maybe<AdAssetFavoritesStddevPopFields>;
  stddev_samp?: Maybe<AdAssetFavoritesStddevSampFields>;
  sum?: Maybe<AdAssetFavoritesSumFields>;
  var_pop?: Maybe<AdAssetFavoritesVarPopFields>;
  var_samp?: Maybe<AdAssetFavoritesVarSampFields>;
  variance?: Maybe<AdAssetFavoritesVarianceFields>;
};


/** aggregate fields of "ad_asset_favorites" */
export type AdAssetFavoritesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_asset_favorites" */
export type AdAssetFavoritesAggregateOrderBy = {
  avg?: InputMaybe<AdAssetFavoritesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdAssetFavoritesMaxOrderBy>;
  min?: InputMaybe<AdAssetFavoritesMinOrderBy>;
  stddev?: InputMaybe<AdAssetFavoritesStddevOrderBy>;
  stddev_pop?: InputMaybe<AdAssetFavoritesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdAssetFavoritesStddevSampOrderBy>;
  sum?: InputMaybe<AdAssetFavoritesSumOrderBy>;
  var_pop?: InputMaybe<AdAssetFavoritesVarPopOrderBy>;
  var_samp?: InputMaybe<AdAssetFavoritesVarSampOrderBy>;
  variance?: InputMaybe<AdAssetFavoritesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ad_asset_favorites" */
export type AdAssetFavoritesArrRelInsertInput = {
  data: Array<AdAssetFavoritesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdAssetFavoritesOnConflict>;
};

/** aggregate avg on columns */
export type AdAssetFavoritesAvgFields = {
  __typename?: 'ad_asset_favorites_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_asset_favorites". All fields are combined with a logical 'AND'. */
export type AdAssetFavoritesBoolExp = {
  _and?: InputMaybe<Array<AdAssetFavoritesBoolExp>>;
  _not?: InputMaybe<AdAssetFavoritesBoolExp>;
  _or?: InputMaybe<Array<AdAssetFavoritesBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_asset_favorites" */
export const AdAssetFavoritesConstraint = {
  /** unique or primary key constraint on columns "user_id", "ad_brief_asset_id" */
  AdAssetFavoritesAdBriefAssetIdUserIdKey: 'ad_asset_favorites_ad_brief_asset_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  AdAssetFavoritesPkey: 'ad_asset_favorites_pkey'
} as const;

export type AdAssetFavoritesConstraint = typeof AdAssetFavoritesConstraint[keyof typeof AdAssetFavoritesConstraint];
/** input type for inserting data into table "ad_asset_favorites" */
export type AdAssetFavoritesInsertInput = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AdAssetFavoritesMaxFields = {
  __typename?: 'ad_asset_favorites_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdAssetFavoritesMinFields = {
  __typename?: 'ad_asset_favorites_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_asset_favorites" */
export type AdAssetFavoritesMutationResponse = {
  __typename?: 'ad_asset_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdAssetFavorites>;
};

/** on_conflict condition type for table "ad_asset_favorites" */
export type AdAssetFavoritesOnConflict = {
  constraint: AdAssetFavoritesConstraint;
  update_columns?: Array<AdAssetFavoritesUpdateColumn>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};

/** Ordering options when selecting data from "ad_asset_favorites". */
export type AdAssetFavoritesOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_asset_favorites" */
export const AdAssetFavoritesSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdAssetFavoritesSelectColumn = typeof AdAssetFavoritesSelectColumn[keyof typeof AdAssetFavoritesSelectColumn];
/** aggregate stddev on columns */
export type AdAssetFavoritesStddevFields = {
  __typename?: 'ad_asset_favorites_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdAssetFavoritesStddevPopFields = {
  __typename?: 'ad_asset_favorites_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdAssetFavoritesStddevSampFields = {
  __typename?: 'ad_asset_favorites_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_asset_favorites" */
export type AdAssetFavoritesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdAssetFavoritesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdAssetFavoritesStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdAssetFavoritesSumFields = {
  __typename?: 'ad_asset_favorites_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "ad_asset_favorites" (current role has no relevant permissions) */
export const AdAssetFavoritesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AdAssetFavoritesUpdateColumn = typeof AdAssetFavoritesUpdateColumn[keyof typeof AdAssetFavoritesUpdateColumn];
/** aggregate var_pop on columns */
export type AdAssetFavoritesVarPopFields = {
  __typename?: 'ad_asset_favorites_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdAssetFavoritesVarSampFields = {
  __typename?: 'ad_asset_favorites_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdAssetFavoritesVarianceFields = {
  __typename?: 'ad_asset_favorites_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_asset_favorites" */
export type AdAssetFavoritesVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueue = {
  __typename?: 'ad_brief_asset_launch_queue';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  /** An object relationship */
  ad_brief_asset_version?: Maybe<AdBriefAssetVersions>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  destination_config?: Maybe<Scalars['jsonb']>;
  error_message?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  platform: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueDestinationConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueAggregate = {
  __typename?: 'ad_brief_asset_launch_queue_aggregate';
  aggregate?: Maybe<AdBriefAssetLaunchQueueAggregateFields>;
  nodes: Array<AdBriefAssetLaunchQueue>;
};

/** aggregate fields of "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueAggregateFields = {
  __typename?: 'ad_brief_asset_launch_queue_aggregate_fields';
  avg?: Maybe<AdBriefAssetLaunchQueueAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefAssetLaunchQueueMaxFields>;
  min?: Maybe<AdBriefAssetLaunchQueueMinFields>;
  stddev?: Maybe<AdBriefAssetLaunchQueueStddevFields>;
  stddev_pop?: Maybe<AdBriefAssetLaunchQueueStddevPopFields>;
  stddev_samp?: Maybe<AdBriefAssetLaunchQueueStddevSampFields>;
  sum?: Maybe<AdBriefAssetLaunchQueueSumFields>;
  var_pop?: Maybe<AdBriefAssetLaunchQueueVarPopFields>;
  var_samp?: Maybe<AdBriefAssetLaunchQueueVarSampFields>;
  variance?: Maybe<AdBriefAssetLaunchQueueVarianceFields>;
};


/** aggregate fields of "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefAssetLaunchQueueSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetLaunchQueueAppendInput = {
  destination_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AdBriefAssetLaunchQueueAvgFields = {
  __typename?: 'ad_brief_asset_launch_queue_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_brief_asset_launch_queue". All fields are combined with a logical 'AND'. */
export type AdBriefAssetLaunchQueueBoolExp = {
  _and?: InputMaybe<Array<AdBriefAssetLaunchQueueBoolExp>>;
  _not?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
  _or?: InputMaybe<Array<AdBriefAssetLaunchQueueBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  ad_brief_asset_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_config?: InputMaybe<JsonbComparisonExp>;
  error_message?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  platform?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_brief_asset_launch_queue" */
export const AdBriefAssetLaunchQueueConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "ad_brief_asset_id" */
  AdBriefAssetLaunchQueueActiveAssetKey: 'ad_brief_asset_launch_queue_active_asset_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefAssetLaunchQueueIdWorkspaceIdKey: 'ad_brief_asset_launch_queue_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdBriefAssetLaunchQueuePkey: 'ad_brief_asset_launch_queue_pkey'
} as const;

export type AdBriefAssetLaunchQueueConstraint = typeof AdBriefAssetLaunchQueueConstraint[keyof typeof AdBriefAssetLaunchQueueConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdBriefAssetLaunchQueueDeleteAtPathInput = {
  destination_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdBriefAssetLaunchQueueDeleteElemInput = {
  destination_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdBriefAssetLaunchQueueDeleteKeyInput = {
  destination_config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueInsertInput = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsObjRelInsertInput>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  destination_config?: InputMaybe<Scalars['jsonb']>;
  error_message?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdBriefAssetLaunchQueueMaxFields = {
  __typename?: 'ad_brief_asset_launch_queue_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdBriefAssetLaunchQueueMinFields = {
  __typename?: 'ad_brief_asset_launch_queue_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueMutationResponse = {
  __typename?: 'ad_brief_asset_launch_queue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefAssetLaunchQueue>;
};

/** on_conflict condition type for table "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueOnConflict = {
  constraint: AdBriefAssetLaunchQueueConstraint;
  update_columns?: Array<AdBriefAssetLaunchQueueUpdateColumn>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};

/** Ordering options when selecting data from "ad_brief_asset_launch_queue". */
export type AdBriefAssetLaunchQueueOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  destination_config?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platform?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_brief_asset_launch_queue */
export type AdBriefAssetLaunchQueuePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetLaunchQueuePrependInput = {
  destination_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_brief_asset_launch_queue" */
export const AdBriefAssetLaunchQueueSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AdBriefAssetVersionId: 'ad_brief_asset_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  DestinationConfig: 'destination_config',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  Id: 'id',
  /** column name */
  Platform: 'platform',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefAssetLaunchQueueSelectColumn = typeof AdBriefAssetLaunchQueueSelectColumn[keyof typeof AdBriefAssetLaunchQueueSelectColumn];
/** input type for updating data in table "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  destination_config?: InputMaybe<Scalars['jsonb']>;
  error_message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdBriefAssetLaunchQueueStddevFields = {
  __typename?: 'ad_brief_asset_launch_queue_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdBriefAssetLaunchQueueStddevPopFields = {
  __typename?: 'ad_brief_asset_launch_queue_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdBriefAssetLaunchQueueStddevSampFields = {
  __typename?: 'ad_brief_asset_launch_queue_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_brief_asset_launch_queue" */
export type AdBriefAssetLaunchQueueStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefAssetLaunchQueueStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefAssetLaunchQueueStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  destination_config?: InputMaybe<Scalars['jsonb']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefAssetLaunchQueueSumFields = {
  __typename?: 'ad_brief_asset_launch_queue_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ad_brief_asset_launch_queue" */
export const AdBriefAssetLaunchQueueUpdateColumn = {
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  DestinationConfig: 'destination_config',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  Status: 'status'
} as const;

export type AdBriefAssetLaunchQueueUpdateColumn = typeof AdBriefAssetLaunchQueueUpdateColumn[keyof typeof AdBriefAssetLaunchQueueUpdateColumn];
export type AdBriefAssetLaunchQueueUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdBriefAssetLaunchQueueAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchQueueDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdBriefAssetLaunchQueueDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdBriefAssetLaunchQueueDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdBriefAssetLaunchQueuePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdBriefAssetLaunchQueueSetInput>;
  /** filter the rows which have to be updated */
  where: AdBriefAssetLaunchQueueBoolExp;
};

/** aggregate var_pop on columns */
export type AdBriefAssetLaunchQueueVarPopFields = {
  __typename?: 'ad_brief_asset_launch_queue_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdBriefAssetLaunchQueueVarSampFields = {
  __typename?: 'ad_brief_asset_launch_queue_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdBriefAssetLaunchQueueVarianceFields = {
  __typename?: 'ad_brief_asset_launch_queue_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_brief_asset_launches" */
export type AdBriefAssetLaunches = {
  __typename?: 'ad_brief_asset_launches';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  /** An object relationship */
  ad_brief_asset_version?: Maybe<AdBriefAssetVersions>;
  ad_brief_asset_version_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id: Scalars['bigint'];
  error_message?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  launched_at?: Maybe<Scalars['timestamptz']>;
  platform: Scalars['String'];
  platform_config: Scalars['jsonb'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesPlatformConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesAggregate = {
  __typename?: 'ad_brief_asset_launches_aggregate';
  aggregate?: Maybe<AdBriefAssetLaunchesAggregateFields>;
  nodes: Array<AdBriefAssetLaunches>;
};

/** aggregate fields of "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesAggregateFields = {
  __typename?: 'ad_brief_asset_launches_aggregate_fields';
  avg?: Maybe<AdBriefAssetLaunchesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefAssetLaunchesMaxFields>;
  min?: Maybe<AdBriefAssetLaunchesMinFields>;
  stddev?: Maybe<AdBriefAssetLaunchesStddevFields>;
  stddev_pop?: Maybe<AdBriefAssetLaunchesStddevPopFields>;
  stddev_samp?: Maybe<AdBriefAssetLaunchesStddevSampFields>;
  sum?: Maybe<AdBriefAssetLaunchesSumFields>;
  var_pop?: Maybe<AdBriefAssetLaunchesVarPopFields>;
  var_samp?: Maybe<AdBriefAssetLaunchesVarSampFields>;
  variance?: Maybe<AdBriefAssetLaunchesVarianceFields>;
};


/** aggregate fields of "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefAssetLaunchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetLaunchesAppendInput = {
  platform_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AdBriefAssetLaunchesAvgFields = {
  __typename?: 'ad_brief_asset_launches_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_brief_asset_launches". All fields are combined with a logical 'AND'. */
export type AdBriefAssetLaunchesBoolExp = {
  _and?: InputMaybe<Array<AdBriefAssetLaunchesBoolExp>>;
  _not?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
  _or?: InputMaybe<Array<AdBriefAssetLaunchesBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  ad_brief_asset_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  error_message?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  launched_at?: InputMaybe<TimestamptzComparisonExp>;
  platform?: InputMaybe<StringComparisonExp>;
  platform_config?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_brief_asset_launches" */
export const AdBriefAssetLaunchesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefAssetLaunchesIdWorkspaceIdKey: 'ad_brief_asset_launches_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdBriefAssetLaunchesPkey: 'ad_brief_asset_launches_pkey'
} as const;

export type AdBriefAssetLaunchesConstraint = typeof AdBriefAssetLaunchesConstraint[keyof typeof AdBriefAssetLaunchesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdBriefAssetLaunchesDeleteAtPathInput = {
  platform_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdBriefAssetLaunchesDeleteElemInput = {
  platform_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdBriefAssetLaunchesDeleteKeyInput = {
  platform_config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesInsertInput = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsObjRelInsertInput>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  error_message?: InputMaybe<Scalars['String']>;
  launched_at?: InputMaybe<Scalars['timestamptz']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_config?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdBriefAssetLaunchesMaxFields = {
  __typename?: 'ad_brief_asset_launches_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  destination_id?: Maybe<Scalars['bigint']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  launched_at?: Maybe<Scalars['timestamptz']>;
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdBriefAssetLaunchesMinFields = {
  __typename?: 'ad_brief_asset_launches_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  destination_id?: Maybe<Scalars['bigint']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  launched_at?: Maybe<Scalars['timestamptz']>;
  platform?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesMutationResponse = {
  __typename?: 'ad_brief_asset_launches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefAssetLaunches>;
};

/** on_conflict condition type for table "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesOnConflict = {
  constraint: AdBriefAssetLaunchesConstraint;
  update_columns?: Array<AdBriefAssetLaunchesUpdateColumn>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};

/** Ordering options when selecting data from "ad_brief_asset_launches". */
export type AdBriefAssetLaunchesOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  launched_at?: InputMaybe<OrderBy>;
  platform?: InputMaybe<OrderBy>;
  platform_config?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_brief_asset_launches */
export type AdBriefAssetLaunchesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetLaunchesPrependInput = {
  platform_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_brief_asset_launches" */
export const AdBriefAssetLaunchesSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AdBriefAssetVersionId: 'ad_brief_asset_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  Id: 'id',
  /** column name */
  LaunchedAt: 'launched_at',
  /** column name */
  Platform: 'platform',
  /** column name */
  PlatformConfig: 'platform_config',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefAssetLaunchesSelectColumn = typeof AdBriefAssetLaunchesSelectColumn[keyof typeof AdBriefAssetLaunchesSelectColumn];
/** input type for updating data in table "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  launched_at?: InputMaybe<Scalars['timestamptz']>;
  platform_config?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdBriefAssetLaunchesStddevFields = {
  __typename?: 'ad_brief_asset_launches_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdBriefAssetLaunchesStddevPopFields = {
  __typename?: 'ad_brief_asset_launches_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdBriefAssetLaunchesStddevSampFields = {
  __typename?: 'ad_brief_asset_launches_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_brief_asset_launches" */
export type AdBriefAssetLaunchesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefAssetLaunchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefAssetLaunchesStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  launched_at?: InputMaybe<Scalars['timestamptz']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_config?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefAssetLaunchesSumFields = {
  __typename?: 'ad_brief_asset_launches_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ad_brief_asset_launches" */
export const AdBriefAssetLaunchesUpdateColumn = {
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  LaunchedAt: 'launched_at',
  /** column name */
  PlatformConfig: 'platform_config',
  /** column name */
  Status: 'status'
} as const;

export type AdBriefAssetLaunchesUpdateColumn = typeof AdBriefAssetLaunchesUpdateColumn[keyof typeof AdBriefAssetLaunchesUpdateColumn];
export type AdBriefAssetLaunchesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdBriefAssetLaunchesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdBriefAssetLaunchesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdBriefAssetLaunchesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdBriefAssetLaunchesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdBriefAssetLaunchesSetInput>;
  /** filter the rows which have to be updated */
  where: AdBriefAssetLaunchesBoolExp;
};

/** aggregate var_pop on columns */
export type AdBriefAssetLaunchesVarPopFields = {
  __typename?: 'ad_brief_asset_launches_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdBriefAssetLaunchesVarSampFields = {
  __typename?: 'ad_brief_asset_launches_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdBriefAssetLaunchesVarianceFields = {
  __typename?: 'ad_brief_asset_launches_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariants = {
  __typename?: 'ad_brief_asset_size_variants';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  /** An array relationship */
  amp_asset_ratings: Array<AmpAssetRatings>;
  /** An aggregate relationship */
  amp_asset_ratings_aggregate: AmpAssetRatingsAggregate;
  asset_type: Scalars['String'];
  asset_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  channel_size?: Maybe<AdExportChannelSizes>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  size_key?: Maybe<Scalars['String']>;
  source_version_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  video_composition?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  video_exports: Array<VideoExports>;
  /** An aggregate relationship */
  video_exports_aggregate: VideoExportsAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAmpAssetRatingsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAmpAssetRatingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVideoCompositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVideoExportsArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVideoExportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};

/** aggregated selection of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAggregate = {
  __typename?: 'ad_brief_asset_size_variants_aggregate';
  aggregate?: Maybe<AdBriefAssetSizeVariantsAggregateFields>;
  nodes: Array<AdBriefAssetSizeVariants>;
};

export type AdBriefAssetSizeVariantsAggregateBoolExp = {
  count?: InputMaybe<AdBriefAssetSizeVariantsAggregateBoolExpCount>;
};

export type AdBriefAssetSizeVariantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAggregateFields = {
  __typename?: 'ad_brief_asset_size_variants_aggregate_fields';
  avg?: Maybe<AdBriefAssetSizeVariantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefAssetSizeVariantsMaxFields>;
  min?: Maybe<AdBriefAssetSizeVariantsMinFields>;
  stddev?: Maybe<AdBriefAssetSizeVariantsStddevFields>;
  stddev_pop?: Maybe<AdBriefAssetSizeVariantsStddevPopFields>;
  stddev_samp?: Maybe<AdBriefAssetSizeVariantsStddevSampFields>;
  sum?: Maybe<AdBriefAssetSizeVariantsSumFields>;
  var_pop?: Maybe<AdBriefAssetSizeVariantsVarPopFields>;
  var_samp?: Maybe<AdBriefAssetSizeVariantsVarSampFields>;
  variance?: Maybe<AdBriefAssetSizeVariantsVarianceFields>;
};


/** aggregate fields of "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAggregateOrderBy = {
  avg?: InputMaybe<AdBriefAssetSizeVariantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdBriefAssetSizeVariantsMaxOrderBy>;
  min?: InputMaybe<AdBriefAssetSizeVariantsMinOrderBy>;
  stddev?: InputMaybe<AdBriefAssetSizeVariantsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdBriefAssetSizeVariantsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdBriefAssetSizeVariantsStddevSampOrderBy>;
  sum?: InputMaybe<AdBriefAssetSizeVariantsSumOrderBy>;
  var_pop?: InputMaybe<AdBriefAssetSizeVariantsVarPopOrderBy>;
  var_samp?: InputMaybe<AdBriefAssetSizeVariantsVarSampOrderBy>;
  variance?: InputMaybe<AdBriefAssetSizeVariantsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsArrRelInsertInput = {
  data: Array<AdBriefAssetSizeVariantsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetSizeVariantsOnConflict>;
};

/** aggregate avg on columns */
export type AdBriefAssetSizeVariantsAvgFields = {
  __typename?: 'ad_brief_asset_size_variants_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_brief_asset_size_variants". All fields are combined with a logical 'AND'. */
export type AdBriefAssetSizeVariantsBoolExp = {
  _and?: InputMaybe<Array<AdBriefAssetSizeVariantsBoolExp>>;
  _not?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  _or?: InputMaybe<Array<AdBriefAssetSizeVariantsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  amp_asset_ratings?: InputMaybe<AmpAssetRatingsBoolExp>;
  amp_asset_ratings_aggregate?: InputMaybe<AmpAssetRatingsAggregateBoolExp>;
  asset_type?: InputMaybe<StringComparisonExp>;
  asset_url?: InputMaybe<StringComparisonExp>;
  channel_size?: InputMaybe<AdExportChannelSizesBoolExp>;
  channel_size_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_interaction_id?: InputMaybe<UuidComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_message_id?: InputMaybe<UuidComparisonExp>;
  size_key?: InputMaybe<StringComparisonExp>;
  source_version_id?: InputMaybe<UuidComparisonExp>;
  svg?: InputMaybe<StringComparisonExp>;
  video_composition?: InputMaybe<JsonbComparisonExp>;
  video_exports?: InputMaybe<VideoExportsBoolExp>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_brief_asset_size_variants" */
export const AdBriefAssetSizeVariantsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id", "source_version_id", "ad_brief_asset_id" */
  AbasvWorkspaceVariantAssetSourceVersionKey: 'abasv_workspace_variant_asset_source_version_key',
  /** unique or primary key constraint on columns "id" */
  AdBriefAssetSizeVariantsPkey: 'ad_brief_asset_size_variants_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefAssetSizeVariantsWorkspaceIdIdKey: 'ad_brief_asset_size_variants_workspace_id_id_key'
} as const;

export type AdBriefAssetSizeVariantsConstraint = typeof AdBriefAssetSizeVariantsConstraint[keyof typeof AdBriefAssetSizeVariantsConstraint];
/** input type for inserting data into table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsInsertInput = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  amp_asset_ratings?: InputMaybe<AmpAssetRatingsArrRelInsertInput>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  channel_size?: InputMaybe<AdExportChannelSizesObjRelInsertInput>;
  channel_size_id?: InputMaybe<Scalars['uuid']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  size_key?: InputMaybe<Scalars['String']>;
  source_version_id?: InputMaybe<Scalars['uuid']>;
  svg?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdBriefAssetSizeVariantsMaxFields = {
  __typename?: 'ad_brief_asset_size_variants_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  size_key?: Maybe<Scalars['String']>;
  source_version_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  size_key?: InputMaybe<OrderBy>;
  source_version_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdBriefAssetSizeVariantsMinFields = {
  __typename?: 'ad_brief_asset_size_variants_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  size_key?: Maybe<Scalars['String']>;
  source_version_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  size_key?: InputMaybe<OrderBy>;
  source_version_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsMutationResponse = {
  __typename?: 'ad_brief_asset_size_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefAssetSizeVariants>;
};

/** input type for inserting object relation for remote table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsObjRelInsertInput = {
  data: AdBriefAssetSizeVariantsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetSizeVariantsOnConflict>;
};

/** on_conflict condition type for table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsOnConflict = {
  constraint: AdBriefAssetSizeVariantsConstraint;
  update_columns?: Array<AdBriefAssetSizeVariantsUpdateColumn>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};

/** Ordering options when selecting data from "ad_brief_asset_size_variants". */
export type AdBriefAssetSizeVariantsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  amp_asset_ratings_aggregate?: InputMaybe<AmpAssetRatingsAggregateOrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  channel_size?: InputMaybe<AdExportChannelSizesOrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  size_key?: InputMaybe<OrderBy>;
  source_version_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  video_composition?: InputMaybe<OrderBy>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_brief_asset_size_variants" */
export const AdBriefAssetSizeVariantsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AssetType: 'asset_type',
  /** column name */
  AssetUrl: 'asset_url',
  /** column name */
  ChannelSizeId: 'channel_size_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByInteractionId: 'created_by_interaction_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatMessageId: 'llm_chat_message_id',
  /** column name */
  SizeKey: 'size_key',
  /** column name */
  SourceVersionId: 'source_version_id',
  /** column name */
  Svg: 'svg',
  /** column name */
  VideoComposition: 'video_composition',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefAssetSizeVariantsSelectColumn = typeof AdBriefAssetSizeVariantsSelectColumn[keyof typeof AdBriefAssetSizeVariantsSelectColumn];
/** aggregate stddev on columns */
export type AdBriefAssetSizeVariantsStddevFields = {
  __typename?: 'ad_brief_asset_size_variants_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdBriefAssetSizeVariantsStddevPopFields = {
  __typename?: 'ad_brief_asset_size_variants_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdBriefAssetSizeVariantsStddevSampFields = {
  __typename?: 'ad_brief_asset_size_variants_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefAssetSizeVariantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefAssetSizeVariantsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  channel_size_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  size_key?: InputMaybe<Scalars['String']>;
  source_version_id?: InputMaybe<Scalars['uuid']>;
  svg?: InputMaybe<Scalars['String']>;
  video_composition?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefAssetSizeVariantsSumFields = {
  __typename?: 'ad_brief_asset_size_variants_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "ad_brief_asset_size_variants" (current role has no relevant permissions) */
export const AdBriefAssetSizeVariantsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AdBriefAssetSizeVariantsUpdateColumn = typeof AdBriefAssetSizeVariantsUpdateColumn[keyof typeof AdBriefAssetSizeVariantsUpdateColumn];
/** aggregate var_pop on columns */
export type AdBriefAssetSizeVariantsVarPopFields = {
  __typename?: 'ad_brief_asset_size_variants_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdBriefAssetSizeVariantsVarSampFields = {
  __typename?: 'ad_brief_asset_size_variants_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdBriefAssetSizeVariantsVarianceFields = {
  __typename?: 'ad_brief_asset_size_variants_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_brief_asset_size_variants" */
export type AdBriefAssetSizeVariantsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersions = {
  __typename?: 'ad_brief_asset_versions';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  /** An array relationship */
  amp_asset_ratings: Array<AmpAssetRatings>;
  /** An aggregate relationship */
  amp_asset_ratings_aggregate: AmpAssetRatingsAggregate;
  /** A computed field, executes function "ad_brief_asset_versions_asset_keys" */
  asset_keys?: Maybe<Scalars['jsonb']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type: Scalars['String'];
  asset_url: Scalars['String'];
  asset_versions?: Maybe<Scalars['jsonb']>;
  autosave: Scalars['Boolean'];
  component_asset_urls: GetAdComponentAssetUrlsResponse;
  component_assets?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_interaction?: Maybe<LlmChatInteractions>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  deleted_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  image_state?: Maybe<Scalars['String']>;
  /** An object relationship */
  llm_chat_message?: Maybe<LlmChatMessages>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  template_manifest?: Maybe<Scalars['jsonb']>;
  variants?: Maybe<Scalars['jsonb']>;
  video_composition?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  video_exports: Array<VideoExports>;
  /** An aggregate relationship */
  video_exports_aggregate: VideoExportsAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAmpAssetRatingsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAmpAssetRatingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAssetKeysArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAssetVersionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsComponentAssetsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsTemplateManifestArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVariantsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVideoCompositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVideoExportsArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


/** columns and relationships of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVideoExportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};

/** aggregated selection of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAggregate = {
  __typename?: 'ad_brief_asset_versions_aggregate';
  aggregate?: Maybe<AdBriefAssetVersionsAggregateFields>;
  nodes: Array<AdBriefAssetVersions>;
};

export type AdBriefAssetVersionsAggregateBoolExp = {
  bool_and?: InputMaybe<AdBriefAssetVersionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AdBriefAssetVersionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AdBriefAssetVersionsAggregateBoolExpCount>;
};

export type AdBriefAssetVersionsAggregateBoolExpBoolAnd = {
  arguments: AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdBriefAssetVersionsAggregateBoolExpBoolOr = {
  arguments: AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdBriefAssetVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAggregateFields = {
  __typename?: 'ad_brief_asset_versions_aggregate_fields';
  avg?: Maybe<AdBriefAssetVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefAssetVersionsMaxFields>;
  min?: Maybe<AdBriefAssetVersionsMinFields>;
  stddev?: Maybe<AdBriefAssetVersionsStddevFields>;
  stddev_pop?: Maybe<AdBriefAssetVersionsStddevPopFields>;
  stddev_samp?: Maybe<AdBriefAssetVersionsStddevSampFields>;
  sum?: Maybe<AdBriefAssetVersionsSumFields>;
  var_pop?: Maybe<AdBriefAssetVersionsVarPopFields>;
  var_samp?: Maybe<AdBriefAssetVersionsVarSampFields>;
  variance?: Maybe<AdBriefAssetVersionsVarianceFields>;
};


/** aggregate fields of "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAggregateOrderBy = {
  avg?: InputMaybe<AdBriefAssetVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdBriefAssetVersionsMaxOrderBy>;
  min?: InputMaybe<AdBriefAssetVersionsMinOrderBy>;
  stddev?: InputMaybe<AdBriefAssetVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdBriefAssetVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdBriefAssetVersionsStddevSampOrderBy>;
  sum?: InputMaybe<AdBriefAssetVersionsSumOrderBy>;
  var_pop?: InputMaybe<AdBriefAssetVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<AdBriefAssetVersionsVarSampOrderBy>;
  variance?: InputMaybe<AdBriefAssetVersionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsArrRelInsertInput = {
  data: Array<AdBriefAssetVersionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetVersionsOnConflict>;
};

/** aggregate avg on columns */
export type AdBriefAssetVersionsAvgFields = {
  __typename?: 'ad_brief_asset_versions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_brief_asset_versions". All fields are combined with a logical 'AND'. */
export type AdBriefAssetVersionsBoolExp = {
  _and?: InputMaybe<Array<AdBriefAssetVersionsBoolExp>>;
  _not?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  _or?: InputMaybe<Array<AdBriefAssetVersionsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  amp_asset_ratings?: InputMaybe<AmpAssetRatingsBoolExp>;
  amp_asset_ratings_aggregate?: InputMaybe<AmpAssetRatingsAggregateBoolExp>;
  asset_keys?: InputMaybe<JsonbComparisonExp>;
  asset_name?: InputMaybe<StringComparisonExp>;
  asset_type?: InputMaybe<StringComparisonExp>;
  asset_url?: InputMaybe<StringComparisonExp>;
  asset_versions?: InputMaybe<JsonbComparisonExp>;
  autosave?: InputMaybe<BooleanComparisonExp>;
  component_assets?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  created_by_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_by?: InputMaybe<BigintComparisonExp>;
  deleted_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image_state?: InputMaybe<StringComparisonExp>;
  llm_chat_message?: InputMaybe<LlmChatMessagesBoolExp>;
  llm_chat_message_id?: InputMaybe<UuidComparisonExp>;
  svg?: InputMaybe<StringComparisonExp>;
  template_manifest?: InputMaybe<JsonbComparisonExp>;
  variants?: InputMaybe<JsonbComparisonExp>;
  video_composition?: InputMaybe<JsonbComparisonExp>;
  video_exports?: InputMaybe<VideoExportsBoolExp>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_brief_asset_versions" */
export const AdBriefAssetVersionsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id", "ad_brief_asset_id" */
  AbavWorkspaceVersionAssetKey: 'abav_workspace_version_asset_key',
  /** unique or primary key constraint on columns "id" */
  AdBriefAssetVersionsPkey: 'ad_brief_asset_versions_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefAssetVersionsWorkspaceIdIdKey: 'ad_brief_asset_versions_workspace_id_id_key',
  /** unique or primary key constraint on columns "workspace_id", "legacy_size_variant_id" */
  AdBriefAssetVersionsWorkspaceLegacySizeKey: 'ad_brief_asset_versions_workspace_legacy_size_key'
} as const;

export type AdBriefAssetVersionsConstraint = typeof AdBriefAssetVersionsConstraint[keyof typeof AdBriefAssetVersionsConstraint];
/** input type for inserting data into table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsInsertInput = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  amp_asset_ratings?: InputMaybe<AmpAssetRatingsArrRelInsertInput>;
  asset_name?: InputMaybe<Scalars['String']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  autosave?: InputMaybe<Scalars['Boolean']>;
  llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  svg?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type AdBriefAssetVersionsMaxFields = {
  __typename?: 'ad_brief_asset_versions_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  image_state?: Maybe<Scalars['String']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdBriefAssetVersionsMinFields = {
  __typename?: 'ad_brief_asset_versions_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  image_state?: Maybe<Scalars['String']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsMutationResponse = {
  __typename?: 'ad_brief_asset_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefAssetVersions>;
};

/** input type for inserting object relation for remote table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsObjRelInsertInput = {
  data: AdBriefAssetVersionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetVersionsOnConflict>;
};

/** on_conflict condition type for table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsOnConflict = {
  constraint: AdBriefAssetVersionsConstraint;
  update_columns?: Array<AdBriefAssetVersionsUpdateColumn>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};

/** Ordering options when selecting data from "ad_brief_asset_versions". */
export type AdBriefAssetVersionsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  amp_asset_ratings_aggregate?: InputMaybe<AmpAssetRatingsAggregateOrderBy>;
  asset_keys?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  asset_versions?: InputMaybe<OrderBy>;
  autosave?: InputMaybe<OrderBy>;
  component_assets?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  deleted_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_message?: InputMaybe<LlmChatMessagesOrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  template_manifest?: InputMaybe<OrderBy>;
  variants?: InputMaybe<OrderBy>;
  video_composition?: InputMaybe<OrderBy>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_brief_asset_versions" */
export const AdBriefAssetVersionsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AssetName: 'asset_name',
  /** column name */
  AssetType: 'asset_type',
  /** column name */
  AssetUrl: 'asset_url',
  /** column name */
  AssetVersions: 'asset_versions',
  /** column name */
  Autosave: 'autosave',
  /** column name */
  ComponentAssets: 'component_assets',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreatedByInteractionId: 'created_by_interaction_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  DeletedBy: 'deleted_by',
  /** column name */
  Id: 'id',
  /** column name */
  ImageState: 'image_state',
  /** column name */
  LlmChatMessageId: 'llm_chat_message_id',
  /** column name */
  Svg: 'svg',
  /** column name */
  TemplateManifest: 'template_manifest',
  /** column name */
  Variants: 'variants',
  /** column name */
  VideoComposition: 'video_composition',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefAssetVersionsSelectColumn = typeof AdBriefAssetVersionsSelectColumn[keyof typeof AdBriefAssetVersionsSelectColumn];
/** select "ad_brief_asset_versions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_brief_asset_versions" */
export const AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Autosave: 'autosave'
} as const;

export type AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolAndArgumentsColumns = typeof AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolAndArgumentsColumns];
/** select "ad_brief_asset_versions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_brief_asset_versions" */
export const AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Autosave: 'autosave'
} as const;

export type AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolOrArgumentsColumns = typeof AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AdBriefAssetVersionsSelectColumnAdBriefAssetVersionsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type AdBriefAssetVersionsStddevFields = {
  __typename?: 'ad_brief_asset_versions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdBriefAssetVersionsStddevPopFields = {
  __typename?: 'ad_brief_asset_versions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdBriefAssetVersionsStddevSampFields = {
  __typename?: 'ad_brief_asset_versions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefAssetVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefAssetVersionsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  asset_name?: InputMaybe<Scalars['String']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  asset_versions?: InputMaybe<Scalars['jsonb']>;
  autosave?: InputMaybe<Scalars['Boolean']>;
  component_assets?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_state?: InputMaybe<Scalars['String']>;
  llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  svg?: InputMaybe<Scalars['String']>;
  template_manifest?: InputMaybe<Scalars['jsonb']>;
  variants?: InputMaybe<Scalars['jsonb']>;
  video_composition?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefAssetVersionsSumFields = {
  __typename?: 'ad_brief_asset_versions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  deleted_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "ad_brief_asset_versions" (current role has no relevant permissions) */
export const AdBriefAssetVersionsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AdBriefAssetVersionsUpdateColumn = typeof AdBriefAssetVersionsUpdateColumn[keyof typeof AdBriefAssetVersionsUpdateColumn];
/** aggregate var_pop on columns */
export type AdBriefAssetVersionsVarPopFields = {
  __typename?: 'ad_brief_asset_versions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdBriefAssetVersionsVarSampFields = {
  __typename?: 'ad_brief_asset_versions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdBriefAssetVersionsVarianceFields = {
  __typename?: 'ad_brief_asset_versions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  deleted_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_brief_asset_versions" */
export type AdBriefAssetVersionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  deleted_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssets = {
  __typename?: 'ad_brief_assets';
  /** An array relationship */
  ad_asset_favorites: Array<AdAssetFavorites>;
  /** An aggregate relationship */
  ad_asset_favorites_aggregate: AdAssetFavoritesAggregate;
  /** An object relationship */
  ad_brief?: Maybe<AdBriefs>;
  /** An array relationship */
  ad_brief_asset_size_variants: Array<AdBriefAssetSizeVariants>;
  /** An aggregate relationship */
  ad_brief_asset_size_variants_aggregate: AdBriefAssetSizeVariantsAggregate;
  /** An array relationship */
  ad_brief_asset_versions: Array<AdBriefAssetVersions>;
  /** An aggregate relationship */
  ad_brief_asset_versions_aggregate: AdBriefAssetVersionsAggregate;
  ad_brief_id: Scalars['uuid'];
  /** An array relationship */
  ad_studio_sessions: Array<AdStudioSessions>;
  /** An aggregate relationship */
  ad_studio_sessions_aggregate: AdStudioSessionsAggregate;
  /** A computed field, executes function "ad_brief_assets_asset_keys" */
  asset_keys?: Maybe<Scalars['jsonb']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type: Scalars['String'];
  asset_url: Scalars['String'];
  asset_versions?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  channel_size?: Maybe<AdExportChannelSizes>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  component_asset_urls: GetAdComponentAssetUrlsResponse;
  component_assets?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_llm_chat_message?: Maybe<LlmChatMessages>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  current_status?: Maybe<Scalars['String']>;
  /** An object relationship */
  current_version?: Maybe<AdBriefAssetVersions>;
  decomp_failure_reason?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  folder?: Maybe<Folders>;
  folder_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  image_state?: Maybe<Scalars['String']>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  size_variant_sessions?: Maybe<Scalars['jsonb']>;
  source_ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  source_template_entity_id?: Maybe<Scalars['uuid']>;
  source_template_entity_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  source_version?: Maybe<AdBriefAssetVersions>;
  /** An array relationship */
  statuses: Array<AssetStatuses>;
  /** An aggregate relationship */
  statuses_aggregate: AssetStatusesAggregate;
  svg?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  version_id?: Maybe<Scalars['uuid']>;
  video_composition?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  video_exports: Array<VideoExports>;
  /** An aggregate relationship */
  video_exports_aggregate: VideoExportsAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdAssetFavoritesArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdAssetFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdBriefAssetSizeVariantsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdBriefAssetSizeVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdBriefAssetVersionsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdBriefAssetVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdStudioSessionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAdStudioSessionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAssetKeysArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsAssetVersionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsComponentAssetsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsSizeVariantSessionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsVideoCompositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsVideoExportsArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


/** columns and relationships of "ad_brief_assets" */
export type AdBriefAssetsVideoExportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};

/** aggregated selection of "ad_brief_assets" */
export type AdBriefAssetsAggregate = {
  __typename?: 'ad_brief_assets_aggregate';
  aggregate?: Maybe<AdBriefAssetsAggregateFields>;
  nodes: Array<AdBriefAssets>;
};

export type AdBriefAssetsAggregateBoolExp = {
  count?: InputMaybe<AdBriefAssetsAggregateBoolExpCount>;
};

export type AdBriefAssetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefAssetsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_brief_assets" */
export type AdBriefAssetsAggregateFields = {
  __typename?: 'ad_brief_assets_aggregate_fields';
  avg?: Maybe<AdBriefAssetsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefAssetsMaxFields>;
  min?: Maybe<AdBriefAssetsMinFields>;
  stddev?: Maybe<AdBriefAssetsStddevFields>;
  stddev_pop?: Maybe<AdBriefAssetsStddevPopFields>;
  stddev_samp?: Maybe<AdBriefAssetsStddevSampFields>;
  sum?: Maybe<AdBriefAssetsSumFields>;
  var_pop?: Maybe<AdBriefAssetsVarPopFields>;
  var_samp?: Maybe<AdBriefAssetsVarSampFields>;
  variance?: Maybe<AdBriefAssetsVarianceFields>;
};


/** aggregate fields of "ad_brief_assets" */
export type AdBriefAssetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_brief_assets" */
export type AdBriefAssetsAggregateOrderBy = {
  avg?: InputMaybe<AdBriefAssetsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdBriefAssetsMaxOrderBy>;
  min?: InputMaybe<AdBriefAssetsMinOrderBy>;
  stddev?: InputMaybe<AdBriefAssetsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdBriefAssetsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdBriefAssetsStddevSampOrderBy>;
  sum?: InputMaybe<AdBriefAssetsSumOrderBy>;
  var_pop?: InputMaybe<AdBriefAssetsVarPopOrderBy>;
  var_samp?: InputMaybe<AdBriefAssetsVarSampOrderBy>;
  variance?: InputMaybe<AdBriefAssetsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetsAppendInput = {
  size_variant_sessions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ad_brief_assets" */
export type AdBriefAssetsArrRelInsertInput = {
  data: Array<AdBriefAssetsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetsOnConflict>;
};

/** aggregate avg on columns */
export type AdBriefAssetsAvgFields = {
  __typename?: 'ad_brief_assets_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_brief_assets" */
export type AdBriefAssetsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_brief_assets". All fields are combined with a logical 'AND'. */
export type AdBriefAssetsBoolExp = {
  _and?: InputMaybe<Array<AdBriefAssetsBoolExp>>;
  _not?: InputMaybe<AdBriefAssetsBoolExp>;
  _or?: InputMaybe<Array<AdBriefAssetsBoolExp>>;
  ad_asset_favorites?: InputMaybe<AdAssetFavoritesBoolExp>;
  ad_asset_favorites_aggregate?: InputMaybe<AdAssetFavoritesAggregateBoolExp>;
  ad_brief?: InputMaybe<AdBriefsBoolExp>;
  ad_brief_asset_size_variants?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  ad_brief_asset_size_variants_aggregate?: InputMaybe<AdBriefAssetSizeVariantsAggregateBoolExp>;
  ad_brief_asset_versions?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  ad_brief_asset_versions_aggregate?: InputMaybe<AdBriefAssetVersionsAggregateBoolExp>;
  ad_brief_id?: InputMaybe<UuidComparisonExp>;
  ad_studio_sessions?: InputMaybe<AdStudioSessionsBoolExp>;
  ad_studio_sessions_aggregate?: InputMaybe<AdStudioSessionsAggregateBoolExp>;
  asset_keys?: InputMaybe<JsonbComparisonExp>;
  asset_name?: InputMaybe<StringComparisonExp>;
  asset_type?: InputMaybe<StringComparisonExp>;
  asset_url?: InputMaybe<StringComparisonExp>;
  asset_versions?: InputMaybe<JsonbComparisonExp>;
  channel_size?: InputMaybe<AdExportChannelSizesBoolExp>;
  channel_size_id?: InputMaybe<UuidComparisonExp>;
  component_assets?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_llm_chat_message?: InputMaybe<LlmChatMessagesBoolExp>;
  created_by_llm_chat_message_id?: InputMaybe<UuidComparisonExp>;
  current_status?: InputMaybe<StringComparisonExp>;
  current_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  decomp_failure_reason?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  folder?: InputMaybe<FoldersBoolExp>;
  folder_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image_state?: InputMaybe<StringComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  size_variant_sessions?: InputMaybe<JsonbComparisonExp>;
  source_ad_brief_asset_version_id?: InputMaybe<UuidComparisonExp>;
  source_template_entity_id?: InputMaybe<UuidComparisonExp>;
  source_template_entity_version_id?: InputMaybe<UuidComparisonExp>;
  source_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  statuses?: InputMaybe<AssetStatusesBoolExp>;
  statuses_aggregate?: InputMaybe<AssetStatusesAggregateBoolExp>;
  svg?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  version_id?: InputMaybe<UuidComparisonExp>;
  video_composition?: InputMaybe<JsonbComparisonExp>;
  video_exports?: InputMaybe<VideoExportsBoolExp>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_brief_assets" */
export const AdBriefAssetsConstraint = {
  /** unique or primary key constraint on columns "id" */
  AdBriefAssetsPkey: 'ad_brief_assets_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefAssetsWorkspaceIdIdKey: 'ad_brief_assets_workspace_id_id_key'
} as const;

export type AdBriefAssetsConstraint = typeof AdBriefAssetsConstraint[keyof typeof AdBriefAssetsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdBriefAssetsDeleteAtPathInput = {
  size_variant_sessions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdBriefAssetsDeleteElemInput = {
  size_variant_sessions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdBriefAssetsDeleteKeyInput = {
  size_variant_sessions?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_brief_assets" */
export type AdBriefAssetsInsertInput = {
  ad_asset_favorites?: InputMaybe<AdAssetFavoritesArrRelInsertInput>;
  ad_brief?: InputMaybe<AdBriefsObjRelInsertInput>;
  ad_brief_asset_size_variants?: InputMaybe<AdBriefAssetSizeVariantsArrRelInsertInput>;
  ad_brief_asset_versions?: InputMaybe<AdBriefAssetVersionsArrRelInsertInput>;
  ad_brief_id?: InputMaybe<Scalars['uuid']>;
  asset_name?: InputMaybe<Scalars['String']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  channel_size?: InputMaybe<AdExportChannelSizesObjRelInsertInput>;
  created_by_llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  current_version?: InputMaybe<AdBriefAssetVersionsObjRelInsertInput>;
  folder?: InputMaybe<FoldersObjRelInsertInput>;
  source_version?: InputMaybe<AdBriefAssetVersionsObjRelInsertInput>;
};

/** aggregate max on columns */
export type AdBriefAssetsMaxFields = {
  __typename?: 'ad_brief_assets_max_fields';
  ad_brief_id?: Maybe<Scalars['uuid']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  current_status?: Maybe<Scalars['String']>;
  decomp_failure_reason?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  image_state?: Maybe<Scalars['String']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  source_ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  source_template_entity_id?: Maybe<Scalars['uuid']>;
  source_template_entity_version_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_brief_assets" */
export type AdBriefAssetsMaxOrderBy = {
  ad_brief_id?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  decomp_failure_reason?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  source_ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  source_template_entity_id?: InputMaybe<OrderBy>;
  source_template_entity_version_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdBriefAssetsMinFields = {
  __typename?: 'ad_brief_assets_min_fields';
  ad_brief_id?: Maybe<Scalars['uuid']>;
  asset_name?: Maybe<Scalars['String']>;
  asset_type?: Maybe<Scalars['String']>;
  asset_url?: Maybe<Scalars['String']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  current_status?: Maybe<Scalars['String']>;
  decomp_failure_reason?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  image_state?: Maybe<Scalars['String']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  source_ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  source_template_entity_id?: Maybe<Scalars['uuid']>;
  source_template_entity_version_id?: Maybe<Scalars['uuid']>;
  svg?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_brief_assets" */
export type AdBriefAssetsMinOrderBy = {
  ad_brief_id?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  decomp_failure_reason?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  source_ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  source_template_entity_id?: InputMaybe<OrderBy>;
  source_template_entity_version_id?: InputMaybe<OrderBy>;
  svg?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_brief_assets" */
export type AdBriefAssetsMutationResponse = {
  __typename?: 'ad_brief_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefAssets>;
};

/** input type for inserting object relation for remote table "ad_brief_assets" */
export type AdBriefAssetsObjRelInsertInput = {
  data: AdBriefAssetsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefAssetsOnConflict>;
};

/** on_conflict condition type for table "ad_brief_assets" */
export type AdBriefAssetsOnConflict = {
  constraint: AdBriefAssetsConstraint;
  update_columns?: Array<AdBriefAssetsUpdateColumn>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};

/** Ordering options when selecting data from "ad_brief_assets". */
export type AdBriefAssetsOrderBy = {
  ad_asset_favorites_aggregate?: InputMaybe<AdAssetFavoritesAggregateOrderBy>;
  ad_brief?: InputMaybe<AdBriefsOrderBy>;
  ad_brief_asset_size_variants_aggregate?: InputMaybe<AdBriefAssetSizeVariantsAggregateOrderBy>;
  ad_brief_asset_versions_aggregate?: InputMaybe<AdBriefAssetVersionsAggregateOrderBy>;
  ad_brief_id?: InputMaybe<OrderBy>;
  ad_studio_sessions_aggregate?: InputMaybe<AdStudioSessionsAggregateOrderBy>;
  asset_keys?: InputMaybe<OrderBy>;
  asset_name?: InputMaybe<OrderBy>;
  asset_type?: InputMaybe<OrderBy>;
  asset_url?: InputMaybe<OrderBy>;
  asset_versions?: InputMaybe<OrderBy>;
  channel_size?: InputMaybe<AdExportChannelSizesOrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  component_assets?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message?: InputMaybe<LlmChatMessagesOrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  current_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  decomp_failure_reason?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  folder?: InputMaybe<FoldersOrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_state?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  size_variant_sessions?: InputMaybe<OrderBy>;
  source_ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  source_template_entity_id?: InputMaybe<OrderBy>;
  source_template_entity_version_id?: InputMaybe<OrderBy>;
  source_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  statuses_aggregate?: InputMaybe<AssetStatusesAggregateOrderBy>;
  svg?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  video_composition?: InputMaybe<OrderBy>;
  video_exports_aggregate?: InputMaybe<VideoExportsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_brief_assets */
export type AdBriefAssetsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdBriefAssetsPrependInput = {
  size_variant_sessions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_brief_assets" */
export const AdBriefAssetsSelectColumn = {
  /** column name */
  AdBriefId: 'ad_brief_id',
  /** column name */
  AssetName: 'asset_name',
  /** column name */
  AssetType: 'asset_type',
  /** column name */
  AssetUrl: 'asset_url',
  /** column name */
  AssetVersions: 'asset_versions',
  /** column name */
  ChannelSizeId: 'channel_size_id',
  /** column name */
  ComponentAssets: 'component_assets',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByLlmChatMessageId: 'created_by_llm_chat_message_id',
  /** column name */
  CurrentStatus: 'current_status',
  /** column name */
  DecompFailureReason: 'decomp_failure_reason',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  Id: 'id',
  /** column name */
  ImageState: 'image_state',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  SizeVariantSessions: 'size_variant_sessions',
  /** column name */
  SourceAdBriefAssetVersionId: 'source_ad_brief_asset_version_id',
  /** column name */
  SourceTemplateEntityId: 'source_template_entity_id',
  /** column name */
  SourceTemplateEntityVersionId: 'source_template_entity_version_id',
  /** column name */
  Svg: 'svg',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  VersionId: 'version_id',
  /** column name */
  VideoComposition: 'video_composition',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefAssetsSelectColumn = typeof AdBriefAssetsSelectColumn[keyof typeof AdBriefAssetsSelectColumn];
/** input type for updating data in table "ad_brief_assets" */
export type AdBriefAssetsSetInput = {
  asset_name?: InputMaybe<Scalars['String']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  size_variant_sessions?: InputMaybe<Scalars['jsonb']>;
  version_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AdBriefAssetsStddevFields = {
  __typename?: 'ad_brief_assets_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_brief_assets" */
export type AdBriefAssetsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdBriefAssetsStddevPopFields = {
  __typename?: 'ad_brief_assets_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_brief_assets" */
export type AdBriefAssetsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdBriefAssetsStddevSampFields = {
  __typename?: 'ad_brief_assets_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_brief_assets" */
export type AdBriefAssetsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_brief_assets" */
export type AdBriefAssetsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefAssetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefAssetsStreamCursorValueInput = {
  ad_brief_id?: InputMaybe<Scalars['uuid']>;
  asset_name?: InputMaybe<Scalars['String']>;
  asset_type?: InputMaybe<Scalars['String']>;
  asset_url?: InputMaybe<Scalars['String']>;
  asset_versions?: InputMaybe<Scalars['jsonb']>;
  channel_size_id?: InputMaybe<Scalars['uuid']>;
  component_assets?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  current_status?: InputMaybe<Scalars['String']>;
  decomp_failure_reason?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_state?: InputMaybe<Scalars['String']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  size_variant_sessions?: InputMaybe<Scalars['jsonb']>;
  source_ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  source_template_entity_id?: InputMaybe<Scalars['uuid']>;
  source_template_entity_version_id?: InputMaybe<Scalars['uuid']>;
  svg?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version_id?: InputMaybe<Scalars['uuid']>;
  video_composition?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefAssetsSumFields = {
  __typename?: 'ad_brief_assets_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_brief_assets" */
export type AdBriefAssetsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "ad_brief_assets" */
export const AdBriefAssetsUpdateColumn = {
  /** column name */
  AssetName: 'asset_name',
  /** column name */
  AssetType: 'asset_type',
  /** column name */
  AssetUrl: 'asset_url',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  SizeVariantSessions: 'size_variant_sessions',
  /** column name */
  VersionId: 'version_id'
} as const;

export type AdBriefAssetsUpdateColumn = typeof AdBriefAssetsUpdateColumn[keyof typeof AdBriefAssetsUpdateColumn];
export type AdBriefAssetsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdBriefAssetsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdBriefAssetsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdBriefAssetsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdBriefAssetsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdBriefAssetsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdBriefAssetsSetInput>;
  /** filter the rows which have to be updated */
  where: AdBriefAssetsBoolExp;
};

/** aggregate var_pop on columns */
export type AdBriefAssetsVarPopFields = {
  __typename?: 'ad_brief_assets_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_brief_assets" */
export type AdBriefAssetsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdBriefAssetsVarSampFields = {
  __typename?: 'ad_brief_assets_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_brief_assets" */
export type AdBriefAssetsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdBriefAssetsVarianceFields = {
  __typename?: 'ad_brief_assets_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_brief_assets" */
export type AdBriefAssetsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_briefs" */
export type AdBriefs = {
  __typename?: 'ad_briefs';
  /** An array relationship */
  ad_brief_assets: Array<AdBriefAssets>;
  /** An aggregate relationship */
  ad_brief_assets_aggregate: AdBriefAssetsAggregate;
  /** An object relationship */
  ad_studio_project?: Maybe<AdStudioProjects>;
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_llm_chat_message?: Maybe<LlmChatMessages>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_starred: Scalars['Boolean'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  metadata?: Maybe<Scalars['jsonb']>;
  summary?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_briefs" */
export type AdBriefsAdBriefAssetsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


/** columns and relationships of "ad_briefs" */
export type AdBriefsAdBriefAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


/** columns and relationships of "ad_briefs" */
export type AdBriefsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ad_briefs" */
export type AdBriefsAggregate = {
  __typename?: 'ad_briefs_aggregate';
  aggregate?: Maybe<AdBriefsAggregateFields>;
  nodes: Array<AdBriefs>;
};

export type AdBriefsAggregateBoolExp = {
  bool_and?: InputMaybe<AdBriefsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AdBriefsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AdBriefsAggregateBoolExpCount>;
};

export type AdBriefsAggregateBoolExpBoolAnd = {
  arguments: AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdBriefsAggregateBoolExpBoolOr = {
  arguments: AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdBriefsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdBriefsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdBriefsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_briefs" */
export type AdBriefsAggregateFields = {
  __typename?: 'ad_briefs_aggregate_fields';
  avg?: Maybe<AdBriefsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdBriefsMaxFields>;
  min?: Maybe<AdBriefsMinFields>;
  stddev?: Maybe<AdBriefsStddevFields>;
  stddev_pop?: Maybe<AdBriefsStddevPopFields>;
  stddev_samp?: Maybe<AdBriefsStddevSampFields>;
  sum?: Maybe<AdBriefsSumFields>;
  var_pop?: Maybe<AdBriefsVarPopFields>;
  var_samp?: Maybe<AdBriefsVarSampFields>;
  variance?: Maybe<AdBriefsVarianceFields>;
};


/** aggregate fields of "ad_briefs" */
export type AdBriefsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdBriefsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_briefs" */
export type AdBriefsAggregateOrderBy = {
  avg?: InputMaybe<AdBriefsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdBriefsMaxOrderBy>;
  min?: InputMaybe<AdBriefsMinOrderBy>;
  stddev?: InputMaybe<AdBriefsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdBriefsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdBriefsStddevSampOrderBy>;
  sum?: InputMaybe<AdBriefsSumOrderBy>;
  var_pop?: InputMaybe<AdBriefsVarPopOrderBy>;
  var_samp?: InputMaybe<AdBriefsVarSampOrderBy>;
  variance?: InputMaybe<AdBriefsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdBriefsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ad_briefs" */
export type AdBriefsArrRelInsertInput = {
  data: Array<AdBriefsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefsOnConflict>;
};

/** aggregate avg on columns */
export type AdBriefsAvgFields = {
  __typename?: 'ad_briefs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_briefs" */
export type AdBriefsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_briefs". All fields are combined with a logical 'AND'. */
export type AdBriefsBoolExp = {
  _and?: InputMaybe<Array<AdBriefsBoolExp>>;
  _not?: InputMaybe<AdBriefsBoolExp>;
  _or?: InputMaybe<Array<AdBriefsBoolExp>>;
  ad_brief_assets?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_assets_aggregate?: InputMaybe<AdBriefAssetsAggregateBoolExp>;
  ad_studio_project?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_project_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_llm_chat_message?: InputMaybe<LlmChatMessagesBoolExp>;
  created_by_llm_chat_message_id?: InputMaybe<UuidComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_starred?: InputMaybe<BooleanComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_briefs" */
export const AdBriefsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdBriefsIdWorkspaceIdKey: 'ad_briefs_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdBriefsPkey: 'ad_briefs_pkey'
} as const;

export type AdBriefsConstraint = typeof AdBriefsConstraint[keyof typeof AdBriefsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdBriefsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdBriefsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdBriefsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_briefs" */
export type AdBriefsInsertInput = {
  ad_brief_assets?: InputMaybe<AdBriefAssetsArrRelInsertInput>;
  ad_studio_project?: InputMaybe<AdStudioProjectsObjRelInsertInput>;
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  created_by_llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  is_starred?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  summary?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AdBriefsMaxFields = {
  __typename?: 'ad_briefs_max_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_briefs" */
export type AdBriefsMaxOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdBriefsMinFields = {
  __typename?: 'ad_briefs_min_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_briefs" */
export type AdBriefsMinOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_briefs" */
export type AdBriefsMutationResponse = {
  __typename?: 'ad_briefs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdBriefs>;
};

/** input type for inserting object relation for remote table "ad_briefs" */
export type AdBriefsObjRelInsertInput = {
  data: AdBriefsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdBriefsOnConflict>;
};

/** on_conflict condition type for table "ad_briefs" */
export type AdBriefsOnConflict = {
  constraint: AdBriefsConstraint;
  update_columns?: Array<AdBriefsUpdateColumn>;
  where?: InputMaybe<AdBriefsBoolExp>;
};

/** Ordering options when selecting data from "ad_briefs". */
export type AdBriefsOrderBy = {
  ad_brief_assets_aggregate?: InputMaybe<AdBriefAssetsAggregateOrderBy>;
  ad_studio_project?: InputMaybe<AdStudioProjectsOrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_message?: InputMaybe<LlmChatMessagesOrderBy>;
  created_by_llm_chat_message_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_starred?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_briefs */
export type AdBriefsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdBriefsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_briefs" */
export const AdBriefsSelectColumn = {
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByLlmChatMessageId: 'created_by_llm_chat_message_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  IsStarred: 'is_starred',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Summary: 'summary',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdBriefsSelectColumn = typeof AdBriefsSelectColumn[keyof typeof AdBriefsSelectColumn];
/** select "ad_briefs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_briefs" */
export const AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsStarred: 'is_starred'
} as const;

export type AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolAndArgumentsColumns = typeof AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolAndArgumentsColumns];
/** select "ad_briefs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_briefs" */
export const AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsStarred: 'is_starred'
} as const;

export type AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolOrArgumentsColumns = typeof AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AdBriefsSelectColumnAdBriefsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "ad_briefs" */
export type AdBriefsSetInput = {
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  is_starred?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  summary?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdBriefsStddevFields = {
  __typename?: 'ad_briefs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_briefs" */
export type AdBriefsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdBriefsStddevPopFields = {
  __typename?: 'ad_briefs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_briefs" */
export type AdBriefsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdBriefsStddevSampFields = {
  __typename?: 'ad_briefs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_briefs" */
export type AdBriefsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_briefs" */
export type AdBriefsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdBriefsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdBriefsStreamCursorValueInput = {
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_starred?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  summary?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdBriefsSumFields = {
  __typename?: 'ad_briefs_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_briefs" */
export type AdBriefsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "ad_briefs" */
export const AdBriefsUpdateColumn = {
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Description: 'description',
  /** column name */
  IsStarred: 'is_starred',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Summary: 'summary'
} as const;

export type AdBriefsUpdateColumn = typeof AdBriefsUpdateColumn[keyof typeof AdBriefsUpdateColumn];
export type AdBriefsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdBriefsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdBriefsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdBriefsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdBriefsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdBriefsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdBriefsSetInput>;
  /** filter the rows which have to be updated */
  where: AdBriefsBoolExp;
};

/** aggregate var_pop on columns */
export type AdBriefsVarPopFields = {
  __typename?: 'ad_briefs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_briefs" */
export type AdBriefsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdBriefsVarSampFields = {
  __typename?: 'ad_briefs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_briefs" */
export type AdBriefsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdBriefsVarianceFields = {
  __typename?: 'ad_briefs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_briefs" */
export type AdBriefsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_export_channel_sizes" */
export type AdExportChannelSizes = {
  __typename?: 'ad_export_channel_sizes';
  /** An object relationship */
  channel?: Maybe<AdExportChannels>;
  channel_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  guidance?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_default: Scalars['Boolean'];
  label: Scalars['String'];
  /** An array relationship */
  size_variants: Array<AdBriefAssetSizeVariants>;
  /** An aggregate relationship */
  size_variants_aggregate: AdBriefAssetSizeVariantsAggregate;
  width: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_export_channel_sizes" */
export type AdExportChannelSizesSizeVariantsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


/** columns and relationships of "ad_export_channel_sizes" */
export type AdExportChannelSizesSizeVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};

/** aggregated selection of "ad_export_channel_sizes" */
export type AdExportChannelSizesAggregate = {
  __typename?: 'ad_export_channel_sizes_aggregate';
  aggregate?: Maybe<AdExportChannelSizesAggregateFields>;
  nodes: Array<AdExportChannelSizes>;
};

export type AdExportChannelSizesAggregateBoolExp = {
  bool_and?: InputMaybe<AdExportChannelSizesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AdExportChannelSizesAggregateBoolExpBoolOr>;
  count?: InputMaybe<AdExportChannelSizesAggregateBoolExpCount>;
};

export type AdExportChannelSizesAggregateBoolExpBoolAnd = {
  arguments: AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdExportChannelSizesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdExportChannelSizesAggregateBoolExpBoolOr = {
  arguments: AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdExportChannelSizesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdExportChannelSizesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdExportChannelSizesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_export_channel_sizes" */
export type AdExportChannelSizesAggregateFields = {
  __typename?: 'ad_export_channel_sizes_aggregate_fields';
  avg?: Maybe<AdExportChannelSizesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdExportChannelSizesMaxFields>;
  min?: Maybe<AdExportChannelSizesMinFields>;
  stddev?: Maybe<AdExportChannelSizesStddevFields>;
  stddev_pop?: Maybe<AdExportChannelSizesStddevPopFields>;
  stddev_samp?: Maybe<AdExportChannelSizesStddevSampFields>;
  sum?: Maybe<AdExportChannelSizesSumFields>;
  var_pop?: Maybe<AdExportChannelSizesVarPopFields>;
  var_samp?: Maybe<AdExportChannelSizesVarSampFields>;
  variance?: Maybe<AdExportChannelSizesVarianceFields>;
};


/** aggregate fields of "ad_export_channel_sizes" */
export type AdExportChannelSizesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_export_channel_sizes" */
export type AdExportChannelSizesAggregateOrderBy = {
  avg?: InputMaybe<AdExportChannelSizesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdExportChannelSizesMaxOrderBy>;
  min?: InputMaybe<AdExportChannelSizesMinOrderBy>;
  stddev?: InputMaybe<AdExportChannelSizesStddevOrderBy>;
  stddev_pop?: InputMaybe<AdExportChannelSizesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdExportChannelSizesStddevSampOrderBy>;
  sum?: InputMaybe<AdExportChannelSizesSumOrderBy>;
  var_pop?: InputMaybe<AdExportChannelSizesVarPopOrderBy>;
  var_samp?: InputMaybe<AdExportChannelSizesVarSampOrderBy>;
  variance?: InputMaybe<AdExportChannelSizesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ad_export_channel_sizes" */
export type AdExportChannelSizesArrRelInsertInput = {
  data: Array<AdExportChannelSizesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdExportChannelSizesOnConflict>;
};

/** aggregate avg on columns */
export type AdExportChannelSizesAvgFields = {
  __typename?: 'ad_export_channel_sizes_avg_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesAvgOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_export_channel_sizes". All fields are combined with a logical 'AND'. */
export type AdExportChannelSizesBoolExp = {
  _and?: InputMaybe<Array<AdExportChannelSizesBoolExp>>;
  _not?: InputMaybe<AdExportChannelSizesBoolExp>;
  _or?: InputMaybe<Array<AdExportChannelSizesBoolExp>>;
  channel?: InputMaybe<AdExportChannelsBoolExp>;
  channel_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  guidance?: InputMaybe<StringComparisonExp>;
  height?: InputMaybe<IntComparisonExp>;
  hidden?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_default?: InputMaybe<BooleanComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  size_variants?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  size_variants_aggregate?: InputMaybe<AdBriefAssetSizeVariantsAggregateBoolExp>;
  width?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_export_channel_sizes" */
export const AdExportChannelSizesConstraint = {
  /** unique or primary key constraint on columns "channel_id", "width", "height" */
  AdExportChannelSizesChannelDims: 'ad_export_channel_sizes_channel_dims',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdExportChannelSizesIdWorkspaceIdKey: 'ad_export_channel_sizes_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdExportChannelSizesPkey: 'ad_export_channel_sizes_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  AdExportChannelSizesWorkspaceDefault: 'ad_export_channel_sizes_workspace_default'
} as const;

export type AdExportChannelSizesConstraint = typeof AdExportChannelSizesConstraint[keyof typeof AdExportChannelSizesConstraint];
/** input type for inserting data into table "ad_export_channel_sizes" */
export type AdExportChannelSizesInsertInput = {
  channel?: InputMaybe<AdExportChannelsObjRelInsertInput>;
  channel_id?: InputMaybe<Scalars['uuid']>;
  guidance?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  size_variants?: InputMaybe<AdBriefAssetSizeVariantsArrRelInsertInput>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AdExportChannelSizesMaxFields = {
  __typename?: 'ad_export_channel_sizes_max_fields';
  channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  guidance?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesMaxOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  guidance?: InputMaybe<OrderBy>;
  height?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdExportChannelSizesMinFields = {
  __typename?: 'ad_export_channel_sizes_min_fields';
  channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  guidance?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesMinOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  guidance?: InputMaybe<OrderBy>;
  height?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_export_channel_sizes" */
export type AdExportChannelSizesMutationResponse = {
  __typename?: 'ad_export_channel_sizes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdExportChannelSizes>;
};

/** input type for inserting object relation for remote table "ad_export_channel_sizes" */
export type AdExportChannelSizesObjRelInsertInput = {
  data: AdExportChannelSizesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdExportChannelSizesOnConflict>;
};

/** on_conflict condition type for table "ad_export_channel_sizes" */
export type AdExportChannelSizesOnConflict = {
  constraint: AdExportChannelSizesConstraint;
  update_columns?: Array<AdExportChannelSizesUpdateColumn>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};

/** Ordering options when selecting data from "ad_export_channel_sizes". */
export type AdExportChannelSizesOrderBy = {
  channel?: InputMaybe<AdExportChannelsOrderBy>;
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  guidance?: InputMaybe<OrderBy>;
  height?: InputMaybe<OrderBy>;
  hidden?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_default?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  size_variants_aggregate?: InputMaybe<AdBriefAssetSizeVariantsAggregateOrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_export_channel_sizes */
export type AdExportChannelSizesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "ad_export_channel_sizes" */
export const AdExportChannelSizesSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Guidance: 'guidance',
  /** column name */
  Height: 'height',
  /** column name */
  Hidden: 'hidden',
  /** column name */
  Id: 'id',
  /** column name */
  IsDefault: 'is_default',
  /** column name */
  Label: 'label',
  /** column name */
  Width: 'width',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdExportChannelSizesSelectColumn = typeof AdExportChannelSizesSelectColumn[keyof typeof AdExportChannelSizesSelectColumn];
/** select "ad_export_channel_sizes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_export_channel_sizes" */
export const AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Hidden: 'hidden',
  /** column name */
  IsDefault: 'is_default'
} as const;

export type AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolAndArgumentsColumns = typeof AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolAndArgumentsColumns];
/** select "ad_export_channel_sizes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_export_channel_sizes" */
export const AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Hidden: 'hidden',
  /** column name */
  IsDefault: 'is_default'
} as const;

export type AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolOrArgumentsColumns = typeof AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AdExportChannelSizesSelectColumnAdExportChannelSizesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "ad_export_channel_sizes" */
export type AdExportChannelSizesSetInput = {
  guidance?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdExportChannelSizesStddevFields = {
  __typename?: 'ad_export_channel_sizes_stddev_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesStddevOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdExportChannelSizesStddevPopFields = {
  __typename?: 'ad_export_channel_sizes_stddev_pop_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesStddevPopOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdExportChannelSizesStddevSampFields = {
  __typename?: 'ad_export_channel_sizes_stddev_samp_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesStddevSampOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_export_channel_sizes" */
export type AdExportChannelSizesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdExportChannelSizesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdExportChannelSizesStreamCursorValueInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guidance?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdExportChannelSizesSumFields = {
  __typename?: 'ad_export_channel_sizes_sum_fields';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesSumOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "ad_export_channel_sizes" */
export const AdExportChannelSizesUpdateColumn = {
  /** column name */
  Guidance: 'guidance'
} as const;

export type AdExportChannelSizesUpdateColumn = typeof AdExportChannelSizesUpdateColumn[keyof typeof AdExportChannelSizesUpdateColumn];
export type AdExportChannelSizesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdExportChannelSizesSetInput>;
  /** filter the rows which have to be updated */
  where: AdExportChannelSizesBoolExp;
};

/** aggregate var_pop on columns */
export type AdExportChannelSizesVarPopFields = {
  __typename?: 'ad_export_channel_sizes_var_pop_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesVarPopOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdExportChannelSizesVarSampFields = {
  __typename?: 'ad_export_channel_sizes_var_samp_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesVarSampOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdExportChannelSizesVarianceFields = {
  __typename?: 'ad_export_channel_sizes_variance_fields';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_export_channel_sizes" */
export type AdExportChannelSizesVarianceOrderBy = {
  height?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_export_channels" */
export type AdExportChannels = {
  __typename?: 'ad_export_channels';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  enabled: Scalars['Boolean'];
  guidance?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_predefined: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  sizes: Array<AdExportChannelSizes>;
  /** An aggregate relationship */
  sizes_aggregate: AdExportChannelSizesAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_export_channels" */
export type AdExportChannelsSizesArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


/** columns and relationships of "ad_export_channels" */
export type AdExportChannelsSizesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};

/** aggregated selection of "ad_export_channels" */
export type AdExportChannelsAggregate = {
  __typename?: 'ad_export_channels_aggregate';
  aggregate?: Maybe<AdExportChannelsAggregateFields>;
  nodes: Array<AdExportChannels>;
};

/** aggregate fields of "ad_export_channels" */
export type AdExportChannelsAggregateFields = {
  __typename?: 'ad_export_channels_aggregate_fields';
  avg?: Maybe<AdExportChannelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdExportChannelsMaxFields>;
  min?: Maybe<AdExportChannelsMinFields>;
  stddev?: Maybe<AdExportChannelsStddevFields>;
  stddev_pop?: Maybe<AdExportChannelsStddevPopFields>;
  stddev_samp?: Maybe<AdExportChannelsStddevSampFields>;
  sum?: Maybe<AdExportChannelsSumFields>;
  var_pop?: Maybe<AdExportChannelsVarPopFields>;
  var_samp?: Maybe<AdExportChannelsVarSampFields>;
  variance?: Maybe<AdExportChannelsVarianceFields>;
};


/** aggregate fields of "ad_export_channels" */
export type AdExportChannelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdExportChannelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AdExportChannelsAvgFields = {
  __typename?: 'ad_export_channels_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_export_channels". All fields are combined with a logical 'AND'. */
export type AdExportChannelsBoolExp = {
  _and?: InputMaybe<Array<AdExportChannelsBoolExp>>;
  _not?: InputMaybe<AdExportChannelsBoolExp>;
  _or?: InputMaybe<Array<AdExportChannelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  guidance?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_predefined?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  sizes?: InputMaybe<AdExportChannelSizesBoolExp>;
  sizes_aggregate?: InputMaybe<AdExportChannelSizesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_export_channels" */
export const AdExportChannelsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdExportChannelsIdWorkspaceIdKey: 'ad_export_channels_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdExportChannelsPkey: 'ad_export_channels_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  AdExportChannelsWorkspaceNameActive: 'ad_export_channels_workspace_name_active'
} as const;

export type AdExportChannelsConstraint = typeof AdExportChannelsConstraint[keyof typeof AdExportChannelsConstraint];
/** input type for inserting data into table "ad_export_channels" */
export type AdExportChannelsInsertInput = {
  guidance?: InputMaybe<Scalars['String']>;
  is_predefined?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<AdExportChannelSizesArrRelInsertInput>;
};

/** aggregate max on columns */
export type AdExportChannelsMaxFields = {
  __typename?: 'ad_export_channels_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  guidance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdExportChannelsMinFields = {
  __typename?: 'ad_export_channels_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  guidance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_export_channels" */
export type AdExportChannelsMutationResponse = {
  __typename?: 'ad_export_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdExportChannels>;
};

/** input type for inserting object relation for remote table "ad_export_channels" */
export type AdExportChannelsObjRelInsertInput = {
  data: AdExportChannelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdExportChannelsOnConflict>;
};

/** on_conflict condition type for table "ad_export_channels" */
export type AdExportChannelsOnConflict = {
  constraint: AdExportChannelsConstraint;
  update_columns?: Array<AdExportChannelsUpdateColumn>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};

/** Ordering options when selecting data from "ad_export_channels". */
export type AdExportChannelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  guidance?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_predefined?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sizes_aggregate?: InputMaybe<AdExportChannelSizesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_export_channels */
export type AdExportChannelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "ad_export_channels" */
export const AdExportChannelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Guidance: 'guidance',
  /** column name */
  Id: 'id',
  /** column name */
  IsPredefined: 'is_predefined',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdExportChannelsSelectColumn = typeof AdExportChannelsSelectColumn[keyof typeof AdExportChannelsSelectColumn];
/** input type for updating data in table "ad_export_channels" */
export type AdExportChannelsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  guidance?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdExportChannelsStddevFields = {
  __typename?: 'ad_export_channels_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdExportChannelsStddevPopFields = {
  __typename?: 'ad_export_channels_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdExportChannelsStddevSampFields = {
  __typename?: 'ad_export_channels_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_export_channels" */
export type AdExportChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdExportChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdExportChannelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  guidance?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_predefined?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdExportChannelsSumFields = {
  __typename?: 'ad_export_channels_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ad_export_channels" */
export const AdExportChannelsUpdateColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Guidance: 'guidance',
  /** column name */
  Name: 'name'
} as const;

export type AdExportChannelsUpdateColumn = typeof AdExportChannelsUpdateColumn[keyof typeof AdExportChannelsUpdateColumn];
export type AdExportChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdExportChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: AdExportChannelsBoolExp;
};

/** aggregate var_pop on columns */
export type AdExportChannelsVarPopFields = {
  __typename?: 'ad_export_channels_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdExportChannelsVarSampFields = {
  __typename?: 'ad_export_channels_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdExportChannelsVarianceFields = {
  __typename?: 'ad_export_channels_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRuns = {
  __typename?: 'ad_generation_pipeline_runs';
  /** An object relationship */
  ad_studio_project?: Maybe<AdStudioProjects>;
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  error?: Maybe<Scalars['String']>;
  job_id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_interaction?: Maybe<LlmChatInteractions>;
  name?: Maybe<Scalars['String']>;
  state: Scalars['jsonb'];
  /** An object relationship */
  workflow?: Maybe<AdGenerationWorkflows>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsAggregate = {
  __typename?: 'ad_generation_pipeline_runs_aggregate';
  aggregate?: Maybe<AdGenerationPipelineRunsAggregateFields>;
  nodes: Array<AdGenerationPipelineRuns>;
};

export type AdGenerationPipelineRunsAggregateBoolExp = {
  count?: InputMaybe<AdGenerationPipelineRunsAggregateBoolExpCount>;
};

export type AdGenerationPipelineRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsAggregateFields = {
  __typename?: 'ad_generation_pipeline_runs_aggregate_fields';
  avg?: Maybe<AdGenerationPipelineRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdGenerationPipelineRunsMaxFields>;
  min?: Maybe<AdGenerationPipelineRunsMinFields>;
  stddev?: Maybe<AdGenerationPipelineRunsStddevFields>;
  stddev_pop?: Maybe<AdGenerationPipelineRunsStddevPopFields>;
  stddev_samp?: Maybe<AdGenerationPipelineRunsStddevSampFields>;
  sum?: Maybe<AdGenerationPipelineRunsSumFields>;
  var_pop?: Maybe<AdGenerationPipelineRunsVarPopFields>;
  var_samp?: Maybe<AdGenerationPipelineRunsVarSampFields>;
  variance?: Maybe<AdGenerationPipelineRunsVarianceFields>;
};


/** aggregate fields of "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsAggregateOrderBy = {
  avg?: InputMaybe<AdGenerationPipelineRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdGenerationPipelineRunsMaxOrderBy>;
  min?: InputMaybe<AdGenerationPipelineRunsMinOrderBy>;
  stddev?: InputMaybe<AdGenerationPipelineRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdGenerationPipelineRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdGenerationPipelineRunsStddevSampOrderBy>;
  sum?: InputMaybe<AdGenerationPipelineRunsSumOrderBy>;
  var_pop?: InputMaybe<AdGenerationPipelineRunsVarPopOrderBy>;
  var_samp?: InputMaybe<AdGenerationPipelineRunsVarSampOrderBy>;
  variance?: InputMaybe<AdGenerationPipelineRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AdGenerationPipelineRunsAvgFields = {
  __typename?: 'ad_generation_pipeline_runs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_generation_pipeline_runs". All fields are combined with a logical 'AND'. */
export type AdGenerationPipelineRunsBoolExp = {
  _and?: InputMaybe<Array<AdGenerationPipelineRunsBoolExp>>;
  _not?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
  _or?: InputMaybe<Array<AdGenerationPipelineRunsBoolExp>>;
  ad_studio_project?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_project_id?: InputMaybe<UuidComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  job_id?: InputMaybe<UuidComparisonExp>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  workflow?: InputMaybe<AdGenerationWorkflowsBoolExp>;
  workflow_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AdGenerationPipelineRunsMaxFields = {
  __typename?: 'ad_generation_pipeline_runs_max_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  error?: Maybe<Scalars['String']>;
  job_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsMaxOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdGenerationPipelineRunsMinFields = {
  __typename?: 'ad_generation_pipeline_runs_min_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  error?: Maybe<Scalars['String']>;
  job_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsMinOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsMutationResponse = {
  __typename?: 'ad_generation_pipeline_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdGenerationPipelineRuns>;
};

/** Ordering options when selecting data from "ad_generation_pipeline_runs". */
export type AdGenerationPipelineRunsOrderBy = {
  ad_studio_project?: InputMaybe<AdStudioProjectsOrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  name?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<AdGenerationWorkflowsOrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_generation_pipeline_runs */
export type AdGenerationPipelineRunsPkColumnsInput = {
  job_id: Scalars['uuid'];
};

/** select columns of table "ad_generation_pipeline_runs" */
export const AdGenerationPipelineRunsSelectColumn = {
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByLlmChatInteractionId: 'created_by_llm_chat_interaction_id',
  /** column name */
  Error: 'error',
  /** column name */
  JobId: 'job_id',
  /** column name */
  Name: 'name',
  /** column name */
  State: 'state',
  /** column name */
  WorkflowId: 'workflow_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdGenerationPipelineRunsSelectColumn = typeof AdGenerationPipelineRunsSelectColumn[keyof typeof AdGenerationPipelineRunsSelectColumn];
/** input type for updating data in table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsSetInput = {
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdGenerationPipelineRunsStddevFields = {
  __typename?: 'ad_generation_pipeline_runs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdGenerationPipelineRunsStddevPopFields = {
  __typename?: 'ad_generation_pipeline_runs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdGenerationPipelineRunsStddevSampFields = {
  __typename?: 'ad_generation_pipeline_runs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdGenerationPipelineRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdGenerationPipelineRunsStreamCursorValueInput = {
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  error?: InputMaybe<Scalars['String']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['jsonb']>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdGenerationPipelineRunsSumFields = {
  __typename?: 'ad_generation_pipeline_runs_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

export type AdGenerationPipelineRunsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdGenerationPipelineRunsSetInput>;
  /** filter the rows which have to be updated */
  where: AdGenerationPipelineRunsBoolExp;
};

/** aggregate var_pop on columns */
export type AdGenerationPipelineRunsVarPopFields = {
  __typename?: 'ad_generation_pipeline_runs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdGenerationPipelineRunsVarSampFields = {
  __typename?: 'ad_generation_pipeline_runs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdGenerationPipelineRunsVarianceFields = {
  __typename?: 'ad_generation_pipeline_runs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_generation_pipeline_runs" */
export type AdGenerationPipelineRunsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_generation_workflows" */
export type AdGenerationWorkflows = {
  __typename?: 'ad_generation_workflows';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_interaction?: Maybe<LlmChatInteractions>;
  name: Scalars['String'];
  /** An array relationship */
  pipeline_runs: Array<AdGenerationPipelineRuns>;
  /** An aggregate relationship */
  pipeline_runs_aggregate: AdGenerationPipelineRunsAggregate;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_generation_workflows" */
export type AdGenerationWorkflowsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_generation_workflows" */
export type AdGenerationWorkflowsPipelineRunsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


/** columns and relationships of "ad_generation_workflows" */
export type AdGenerationWorkflowsPipelineRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};

/** aggregated selection of "ad_generation_workflows" */
export type AdGenerationWorkflowsAggregate = {
  __typename?: 'ad_generation_workflows_aggregate';
  aggregate?: Maybe<AdGenerationWorkflowsAggregateFields>;
  nodes: Array<AdGenerationWorkflows>;
};

/** aggregate fields of "ad_generation_workflows" */
export type AdGenerationWorkflowsAggregateFields = {
  __typename?: 'ad_generation_workflows_aggregate_fields';
  avg?: Maybe<AdGenerationWorkflowsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdGenerationWorkflowsMaxFields>;
  min?: Maybe<AdGenerationWorkflowsMinFields>;
  stddev?: Maybe<AdGenerationWorkflowsStddevFields>;
  stddev_pop?: Maybe<AdGenerationWorkflowsStddevPopFields>;
  stddev_samp?: Maybe<AdGenerationWorkflowsStddevSampFields>;
  sum?: Maybe<AdGenerationWorkflowsSumFields>;
  var_pop?: Maybe<AdGenerationWorkflowsVarPopFields>;
  var_samp?: Maybe<AdGenerationWorkflowsVarSampFields>;
  variance?: Maybe<AdGenerationWorkflowsVarianceFields>;
};


/** aggregate fields of "ad_generation_workflows" */
export type AdGenerationWorkflowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdGenerationWorkflowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdGenerationWorkflowsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AdGenerationWorkflowsAvgFields = {
  __typename?: 'ad_generation_workflows_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_generation_workflows". All fields are combined with a logical 'AND'. */
export type AdGenerationWorkflowsBoolExp = {
  _and?: InputMaybe<Array<AdGenerationWorkflowsBoolExp>>;
  _not?: InputMaybe<AdGenerationWorkflowsBoolExp>;
  _or?: InputMaybe<Array<AdGenerationWorkflowsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  pipeline_runs?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
  pipeline_runs_aggregate?: InputMaybe<AdGenerationPipelineRunsAggregateBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdGenerationWorkflowsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdGenerationWorkflowsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdGenerationWorkflowsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdGenerationWorkflowsMaxFields = {
  __typename?: 'ad_generation_workflows_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdGenerationWorkflowsMinFields = {
  __typename?: 'ad_generation_workflows_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_generation_workflows" */
export type AdGenerationWorkflowsMutationResponse = {
  __typename?: 'ad_generation_workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdGenerationWorkflows>;
};

/** Ordering options when selecting data from "ad_generation_workflows". */
export type AdGenerationWorkflowsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  name?: InputMaybe<OrderBy>;
  pipeline_runs_aggregate?: InputMaybe<AdGenerationPipelineRunsAggregateOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_generation_workflows */
export type AdGenerationWorkflowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdGenerationWorkflowsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_generation_workflows" */
export const AdGenerationWorkflowsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreatedByLlmChatInteractionId: 'created_by_llm_chat_interaction_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdGenerationWorkflowsSelectColumn = typeof AdGenerationWorkflowsSelectColumn[keyof typeof AdGenerationWorkflowsSelectColumn];
/** input type for updating data in table "ad_generation_workflows" */
export type AdGenerationWorkflowsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type AdGenerationWorkflowsStddevFields = {
  __typename?: 'ad_generation_workflows_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdGenerationWorkflowsStddevPopFields = {
  __typename?: 'ad_generation_workflows_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdGenerationWorkflowsStddevSampFields = {
  __typename?: 'ad_generation_workflows_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_generation_workflows" */
export type AdGenerationWorkflowsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdGenerationWorkflowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdGenerationWorkflowsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  created_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdGenerationWorkflowsSumFields = {
  __typename?: 'ad_generation_workflows_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

export type AdGenerationWorkflowsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdGenerationWorkflowsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdGenerationWorkflowsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdGenerationWorkflowsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdGenerationWorkflowsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdGenerationWorkflowsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdGenerationWorkflowsSetInput>;
  /** filter the rows which have to be updated */
  where: AdGenerationWorkflowsBoolExp;
};

/** aggregate var_pop on columns */
export type AdGenerationWorkflowsVarPopFields = {
  __typename?: 'ad_generation_workflows_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdGenerationWorkflowsVarSampFields = {
  __typename?: 'ad_generation_workflows_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdGenerationWorkflowsVarianceFields = {
  __typename?: 'ad_generation_workflows_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_stats_models" */
export type AdStatsModels = {
  __typename?: 'ad_stats_models';
  asset_id_column: Scalars['String'];
  clicks_column?: Maybe<Scalars['String']>;
  impressions_column?: Maybe<Scalars['String']>;
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  spend_column?: Maybe<Scalars['String']>;
  timestamp_column: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "ad_stats_models". All fields are combined with a logical 'AND'. */
export type AdStatsModelsBoolExp = {
  _and?: InputMaybe<Array<AdStatsModelsBoolExp>>;
  _not?: InputMaybe<AdStatsModelsBoolExp>;
  _or?: InputMaybe<Array<AdStatsModelsBoolExp>>;
  asset_id_column?: InputMaybe<StringComparisonExp>;
  clicks_column?: InputMaybe<StringComparisonExp>;
  impressions_column?: InputMaybe<StringComparisonExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  spend_column?: InputMaybe<StringComparisonExp>;
  timestamp_column?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_stats_models" */
export const AdStatsModelsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "model_id" */
  AdStatsModelsModelIdWorkspaceIdKey: 'ad_stats_models_model_id_workspace_id_key',
  /** unique or primary key constraint on columns "model_id" */
  AdStatsModelsPkey: 'ad_stats_models_pkey'
} as const;

export type AdStatsModelsConstraint = typeof AdStatsModelsConstraint[keyof typeof AdStatsModelsConstraint];
/** input type for incrementing numeric columns in table "ad_stats_models" */
export type AdStatsModelsIncInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "ad_stats_models" */
export type AdStatsModelsInsertInput = {
  asset_id_column?: InputMaybe<Scalars['String']>;
  clicks_column?: InputMaybe<Scalars['String']>;
  impressions_column?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  spend_column?: InputMaybe<Scalars['String']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "ad_stats_models" */
export type AdStatsModelsMutationResponse = {
  __typename?: 'ad_stats_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStatsModels>;
};

/** input type for inserting object relation for remote table "ad_stats_models" */
export type AdStatsModelsObjRelInsertInput = {
  data: AdStatsModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStatsModelsOnConflict>;
};

/** on_conflict condition type for table "ad_stats_models" */
export type AdStatsModelsOnConflict = {
  constraint: AdStatsModelsConstraint;
  update_columns?: Array<AdStatsModelsUpdateColumn>;
  where?: InputMaybe<AdStatsModelsBoolExp>;
};

/** Ordering options when selecting data from "ad_stats_models". */
export type AdStatsModelsOrderBy = {
  asset_id_column?: InputMaybe<OrderBy>;
  clicks_column?: InputMaybe<OrderBy>;
  impressions_column?: InputMaybe<OrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  spend_column?: InputMaybe<OrderBy>;
  timestamp_column?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_stats_models */
export type AdStatsModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** select columns of table "ad_stats_models" */
export const AdStatsModelsSelectColumn = {
  /** column name */
  AssetIdColumn: 'asset_id_column',
  /** column name */
  ClicksColumn: 'clicks_column',
  /** column name */
  ImpressionsColumn: 'impressions_column',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  SpendColumn: 'spend_column',
  /** column name */
  TimestampColumn: 'timestamp_column',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStatsModelsSelectColumn = typeof AdStatsModelsSelectColumn[keyof typeof AdStatsModelsSelectColumn];
/** input type for updating data in table "ad_stats_models" */
export type AdStatsModelsSetInput = {
  asset_id_column?: InputMaybe<Scalars['String']>;
  clicks_column?: InputMaybe<Scalars['String']>;
  impressions_column?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  spend_column?: InputMaybe<Scalars['String']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ad_stats_models" */
export type AdStatsModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStatsModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStatsModelsStreamCursorValueInput = {
  asset_id_column?: InputMaybe<Scalars['String']>;
  clicks_column?: InputMaybe<Scalars['String']>;
  impressions_column?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  spend_column?: InputMaybe<Scalars['String']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "ad_stats_models" */
export const AdStatsModelsUpdateColumn = {
  /** column name */
  AssetIdColumn: 'asset_id_column',
  /** column name */
  ClicksColumn: 'clicks_column',
  /** column name */
  ImpressionsColumn: 'impressions_column',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  SpendColumn: 'spend_column',
  /** column name */
  TimestampColumn: 'timestamp_column'
} as const;

export type AdStatsModelsUpdateColumn = typeof AdStatsModelsUpdateColumn[keyof typeof AdStatsModelsUpdateColumn];
export type AdStatsModelsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdStatsModelsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdStatsModelsSetInput>;
  /** filter the rows which have to be updated */
  where: AdStatsModelsBoolExp;
};

/** columns and relationships of "ad_studio_product_feeds" */
export type AdStudioProductFeeds = {
  __typename?: 'ad_studio_product_feeds';
  amp_asset_group_id: Scalars['uuid'];
  /** An object relationship */
  asset_group?: Maybe<AmpAssetGroups>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  token: Scalars['String'];
  /** An array relationship */
  treatments: Array<AdStudioTreatments>;
  /** An aggregate relationship */
  treatments_aggregate: AdStudioTreatmentsAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_studio_product_feeds" */
export type AdStudioProductFeedsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_studio_product_feeds" */
export type AdStudioProductFeedsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_studio_product_feeds" */
export type AdStudioProductFeedsTreatmentsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


/** columns and relationships of "ad_studio_product_feeds" */
export type AdStudioProductFeedsTreatmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};

/** aggregated selection of "ad_studio_product_feeds" */
export type AdStudioProductFeedsAggregate = {
  __typename?: 'ad_studio_product_feeds_aggregate';
  aggregate?: Maybe<AdStudioProductFeedsAggregateFields>;
  nodes: Array<AdStudioProductFeeds>;
};

/** aggregate fields of "ad_studio_product_feeds" */
export type AdStudioProductFeedsAggregateFields = {
  __typename?: 'ad_studio_product_feeds_aggregate_fields';
  avg?: Maybe<AdStudioProductFeedsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioProductFeedsMaxFields>;
  min?: Maybe<AdStudioProductFeedsMinFields>;
  stddev?: Maybe<AdStudioProductFeedsStddevFields>;
  stddev_pop?: Maybe<AdStudioProductFeedsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioProductFeedsStddevSampFields>;
  sum?: Maybe<AdStudioProductFeedsSumFields>;
  var_pop?: Maybe<AdStudioProductFeedsVarPopFields>;
  var_samp?: Maybe<AdStudioProductFeedsVarSampFields>;
  variance?: Maybe<AdStudioProductFeedsVarianceFields>;
};


/** aggregate fields of "ad_studio_product_feeds" */
export type AdStudioProductFeedsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioProductFeedsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdStudioProductFeedsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AdStudioProductFeedsAvgFields = {
  __typename?: 'ad_studio_product_feeds_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_studio_product_feeds". All fields are combined with a logical 'AND'. */
export type AdStudioProductFeedsBoolExp = {
  _and?: InputMaybe<Array<AdStudioProductFeedsBoolExp>>;
  _not?: InputMaybe<AdStudioProductFeedsBoolExp>;
  _or?: InputMaybe<Array<AdStudioProductFeedsBoolExp>>;
  amp_asset_group_id?: InputMaybe<UuidComparisonExp>;
  asset_group?: InputMaybe<AmpAssetGroupsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  token?: InputMaybe<StringComparisonExp>;
  treatments?: InputMaybe<AdStudioTreatmentsBoolExp>;
  treatments_aggregate?: InputMaybe<AdStudioTreatmentsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_studio_product_feeds" */
export const AdStudioProductFeedsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdStudioProductFeedsIdWorkspaceIdKey: 'ad_studio_product_feeds_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdStudioProductFeedsPkey: 'ad_studio_product_feeds_pkey',
  /** unique or primary key constraint on columns "token" */
  AdStudioProductFeedsTokenKey: 'ad_studio_product_feeds_token_key'
} as const;

export type AdStudioProductFeedsConstraint = typeof AdStudioProductFeedsConstraint[keyof typeof AdStudioProductFeedsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdStudioProductFeedsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdStudioProductFeedsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdStudioProductFeedsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_studio_product_feeds" */
export type AdStudioProductFeedsInsertInput = {
  amp_asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<AdStudioTreatmentsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AdStudioProductFeedsMaxFields = {
  __typename?: 'ad_studio_product_feeds_max_fields';
  amp_asset_group_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdStudioProductFeedsMinFields = {
  __typename?: 'ad_studio_product_feeds_min_fields';
  amp_asset_group_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_studio_product_feeds" */
export type AdStudioProductFeedsMutationResponse = {
  __typename?: 'ad_studio_product_feeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStudioProductFeeds>;
};

/** input type for inserting object relation for remote table "ad_studio_product_feeds" */
export type AdStudioProductFeedsObjRelInsertInput = {
  data: AdStudioProductFeedsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStudioProductFeedsOnConflict>;
};

/** on_conflict condition type for table "ad_studio_product_feeds" */
export type AdStudioProductFeedsOnConflict = {
  constraint: AdStudioProductFeedsConstraint;
  update_columns?: Array<AdStudioProductFeedsUpdateColumn>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};

/** Ordering options when selecting data from "ad_studio_product_feeds". */
export type AdStudioProductFeedsOrderBy = {
  amp_asset_group_id?: InputMaybe<OrderBy>;
  asset_group?: InputMaybe<AmpAssetGroupsOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  treatments_aggregate?: InputMaybe<AdStudioTreatmentsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_studio_product_feeds */
export type AdStudioProductFeedsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdStudioProductFeedsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_studio_product_feeds" */
export const AdStudioProductFeedsSelectColumn = {
  /** column name */
  AmpAssetGroupId: 'amp_asset_group_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Token: 'token',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioProductFeedsSelectColumn = typeof AdStudioProductFeedsSelectColumn[keyof typeof AdStudioProductFeedsSelectColumn];
/** input type for updating data in table "ad_studio_product_feeds" */
export type AdStudioProductFeedsSetInput = {
  amp_asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdStudioProductFeedsStddevFields = {
  __typename?: 'ad_studio_product_feeds_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdStudioProductFeedsStddevPopFields = {
  __typename?: 'ad_studio_product_feeds_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdStudioProductFeedsStddevSampFields = {
  __typename?: 'ad_studio_product_feeds_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_studio_product_feeds" */
export type AdStudioProductFeedsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioProductFeedsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioProductFeedsStreamCursorValueInput = {
  amp_asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioProductFeedsSumFields = {
  __typename?: 'ad_studio_product_feeds_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "ad_studio_product_feeds" */
export const AdStudioProductFeedsUpdateColumn = {
  /** column name */
  AmpAssetGroupId: 'amp_asset_group_id',
  /** column name */
  Config: 'config',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Name: 'name'
} as const;

export type AdStudioProductFeedsUpdateColumn = typeof AdStudioProductFeedsUpdateColumn[keyof typeof AdStudioProductFeedsUpdateColumn];
export type AdStudioProductFeedsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdStudioProductFeedsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdStudioProductFeedsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdStudioProductFeedsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdStudioProductFeedsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdStudioProductFeedsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdStudioProductFeedsSetInput>;
  /** filter the rows which have to be updated */
  where: AdStudioProductFeedsBoolExp;
};

/** aggregate var_pop on columns */
export type AdStudioProductFeedsVarPopFields = {
  __typename?: 'ad_studio_product_feeds_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdStudioProductFeedsVarSampFields = {
  __typename?: 'ad_studio_product_feeds_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdStudioProductFeedsVarianceFields = {
  __typename?: 'ad_studio_product_feeds_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersions = {
  __typename?: 'ad_studio_project_brief_versions';
  /** An object relationship */
  ad_studio_project?: Maybe<AdStudioProjects>;
  ad_studio_project_id: Scalars['uuid'];
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsAggregate = {
  __typename?: 'ad_studio_project_brief_versions_aggregate';
  aggregate?: Maybe<AdStudioProjectBriefVersionsAggregateFields>;
  nodes: Array<AdStudioProjectBriefVersions>;
};

/** aggregate fields of "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsAggregateFields = {
  __typename?: 'ad_studio_project_brief_versions_aggregate_fields';
  avg?: Maybe<AdStudioProjectBriefVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioProjectBriefVersionsMaxFields>;
  min?: Maybe<AdStudioProjectBriefVersionsMinFields>;
  stddev?: Maybe<AdStudioProjectBriefVersionsStddevFields>;
  stddev_pop?: Maybe<AdStudioProjectBriefVersionsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioProjectBriefVersionsStddevSampFields>;
  sum?: Maybe<AdStudioProjectBriefVersionsSumFields>;
  var_pop?: Maybe<AdStudioProjectBriefVersionsVarPopFields>;
  var_samp?: Maybe<AdStudioProjectBriefVersionsVarSampFields>;
  variance?: Maybe<AdStudioProjectBriefVersionsVarianceFields>;
};


/** aggregate fields of "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioProjectBriefVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AdStudioProjectBriefVersionsAvgFields = {
  __typename?: 'ad_studio_project_brief_versions_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ad_studio_project_brief_versions". All fields are combined with a logical 'AND'. */
export type AdStudioProjectBriefVersionsBoolExp = {
  _and?: InputMaybe<Array<AdStudioProjectBriefVersionsBoolExp>>;
  _not?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
  _or?: InputMaybe<Array<AdStudioProjectBriefVersionsBoolExp>>;
  ad_studio_project?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_project_id?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_studio_project_brief_versions" */
export const AdStudioProjectBriefVersionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  AdStudioProjectBriefVersionsPkey: 'ad_studio_project_brief_versions_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdStudioProjectBriefVersionsWorkspaceIdIdKey: 'ad_studio_project_brief_versions_workspace_id_id_key'
} as const;

export type AdStudioProjectBriefVersionsConstraint = typeof AdStudioProjectBriefVersionsConstraint[keyof typeof AdStudioProjectBriefVersionsConstraint];
/** input type for inserting data into table "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsInsertInput = {
  ad_studio_project?: InputMaybe<AdStudioProjectsObjRelInsertInput>;
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AdStudioProjectBriefVersionsMaxFields = {
  __typename?: 'ad_studio_project_brief_versions_max_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AdStudioProjectBriefVersionsMinFields = {
  __typename?: 'ad_studio_project_brief_versions_min_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsMutationResponse = {
  __typename?: 'ad_studio_project_brief_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStudioProjectBriefVersions>;
};

/** on_conflict condition type for table "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsOnConflict = {
  constraint: AdStudioProjectBriefVersionsConstraint;
  update_columns?: Array<AdStudioProjectBriefVersionsUpdateColumn>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};

/** Ordering options when selecting data from "ad_studio_project_brief_versions". */
export type AdStudioProjectBriefVersionsOrderBy = {
  ad_studio_project?: InputMaybe<AdStudioProjectsOrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_studio_project_brief_versions" */
export const AdStudioProjectBriefVersionsSelectColumn = {
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  Id: 'id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioProjectBriefVersionsSelectColumn = typeof AdStudioProjectBriefVersionsSelectColumn[keyof typeof AdStudioProjectBriefVersionsSelectColumn];
/** aggregate stddev on columns */
export type AdStudioProjectBriefVersionsStddevFields = {
  __typename?: 'ad_studio_project_brief_versions_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AdStudioProjectBriefVersionsStddevPopFields = {
  __typename?: 'ad_studio_project_brief_versions_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AdStudioProjectBriefVersionsStddevSampFields = {
  __typename?: 'ad_studio_project_brief_versions_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ad_studio_project_brief_versions" */
export type AdStudioProjectBriefVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioProjectBriefVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioProjectBriefVersionsStreamCursorValueInput = {
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioProjectBriefVersionsSumFields = {
  __typename?: 'ad_studio_project_brief_versions_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "ad_studio_project_brief_versions" (current role has no relevant permissions) */
export const AdStudioProjectBriefVersionsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AdStudioProjectBriefVersionsUpdateColumn = typeof AdStudioProjectBriefVersionsUpdateColumn[keyof typeof AdStudioProjectBriefVersionsUpdateColumn];
/** aggregate var_pop on columns */
export type AdStudioProjectBriefVersionsVarPopFields = {
  __typename?: 'ad_studio_project_brief_versions_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AdStudioProjectBriefVersionsVarSampFields = {
  __typename?: 'ad_studio_project_brief_versions_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AdStudioProjectBriefVersionsVarianceFields = {
  __typename?: 'ad_studio_project_brief_versions_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ad_studio_project_pins" */
export type AdStudioProjectPins = {
  __typename?: 'ad_studio_project_pins';
  /** An object relationship */
  ad_studio_project?: Maybe<AdStudioProjects>;
  ad_studio_project_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "ad_studio_project_pins" */
export type AdStudioProjectPinsAggregate = {
  __typename?: 'ad_studio_project_pins_aggregate';
  aggregate?: Maybe<AdStudioProjectPinsAggregateFields>;
  nodes: Array<AdStudioProjectPins>;
};

export type AdStudioProjectPinsAggregateBoolExp = {
  count?: InputMaybe<AdStudioProjectPinsAggregateBoolExpCount>;
};

export type AdStudioProjectPinsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioProjectPinsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_studio_project_pins" */
export type AdStudioProjectPinsAggregateFields = {
  __typename?: 'ad_studio_project_pins_aggregate_fields';
  avg?: Maybe<AdStudioProjectPinsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioProjectPinsMaxFields>;
  min?: Maybe<AdStudioProjectPinsMinFields>;
  stddev?: Maybe<AdStudioProjectPinsStddevFields>;
  stddev_pop?: Maybe<AdStudioProjectPinsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioProjectPinsStddevSampFields>;
  sum?: Maybe<AdStudioProjectPinsSumFields>;
  var_pop?: Maybe<AdStudioProjectPinsVarPopFields>;
  var_samp?: Maybe<AdStudioProjectPinsVarSampFields>;
  variance?: Maybe<AdStudioProjectPinsVarianceFields>;
};


/** aggregate fields of "ad_studio_project_pins" */
export type AdStudioProjectPinsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_studio_project_pins" */
export type AdStudioProjectPinsAggregateOrderBy = {
  avg?: InputMaybe<AdStudioProjectPinsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdStudioProjectPinsMaxOrderBy>;
  min?: InputMaybe<AdStudioProjectPinsMinOrderBy>;
  stddev?: InputMaybe<AdStudioProjectPinsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdStudioProjectPinsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdStudioProjectPinsStddevSampOrderBy>;
  sum?: InputMaybe<AdStudioProjectPinsSumOrderBy>;
  var_pop?: InputMaybe<AdStudioProjectPinsVarPopOrderBy>;
  var_samp?: InputMaybe<AdStudioProjectPinsVarSampOrderBy>;
  variance?: InputMaybe<AdStudioProjectPinsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "ad_studio_project_pins" */
export type AdStudioProjectPinsArrRelInsertInput = {
  data: Array<AdStudioProjectPinsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStudioProjectPinsOnConflict>;
};

/** aggregate avg on columns */
export type AdStudioProjectPinsAvgFields = {
  __typename?: 'ad_studio_project_pins_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_studio_project_pins". All fields are combined with a logical 'AND'. */
export type AdStudioProjectPinsBoolExp = {
  _and?: InputMaybe<Array<AdStudioProjectPinsBoolExp>>;
  _not?: InputMaybe<AdStudioProjectPinsBoolExp>;
  _or?: InputMaybe<Array<AdStudioProjectPinsBoolExp>>;
  ad_studio_project?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_project_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_studio_project_pins" */
export const AdStudioProjectPinsConstraint = {
  /** unique or primary key constraint on columns "user_id", "ad_studio_project_id" */
  AdStudioProjectPinsAdStudioProjectIdUserIdKey: 'ad_studio_project_pins_ad_studio_project_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  AdStudioProjectPinsPkey: 'ad_studio_project_pins_pkey'
} as const;

export type AdStudioProjectPinsConstraint = typeof AdStudioProjectPinsConstraint[keyof typeof AdStudioProjectPinsConstraint];
/** input type for inserting data into table "ad_studio_project_pins" */
export type AdStudioProjectPinsInsertInput = {
  ad_studio_project?: InputMaybe<AdStudioProjectsObjRelInsertInput>;
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AdStudioProjectPinsMaxFields = {
  __typename?: 'ad_studio_project_pins_max_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsMaxOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdStudioProjectPinsMinFields = {
  __typename?: 'ad_studio_project_pins_min_fields';
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsMinOrderBy = {
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_studio_project_pins" */
export type AdStudioProjectPinsMutationResponse = {
  __typename?: 'ad_studio_project_pins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStudioProjectPins>;
};

/** on_conflict condition type for table "ad_studio_project_pins" */
export type AdStudioProjectPinsOnConflict = {
  constraint: AdStudioProjectPinsConstraint;
  update_columns?: Array<AdStudioProjectPinsUpdateColumn>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};

/** Ordering options when selecting data from "ad_studio_project_pins". */
export type AdStudioProjectPinsOrderBy = {
  ad_studio_project?: InputMaybe<AdStudioProjectsOrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_studio_project_pins" */
export const AdStudioProjectPinsSelectColumn = {
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioProjectPinsSelectColumn = typeof AdStudioProjectPinsSelectColumn[keyof typeof AdStudioProjectPinsSelectColumn];
/** aggregate stddev on columns */
export type AdStudioProjectPinsStddevFields = {
  __typename?: 'ad_studio_project_pins_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdStudioProjectPinsStddevPopFields = {
  __typename?: 'ad_studio_project_pins_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdStudioProjectPinsStddevSampFields = {
  __typename?: 'ad_studio_project_pins_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_studio_project_pins" */
export type AdStudioProjectPinsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioProjectPinsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioProjectPinsStreamCursorValueInput = {
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioProjectPinsSumFields = {
  __typename?: 'ad_studio_project_pins_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "ad_studio_project_pins" (current role has no relevant permissions) */
export const AdStudioProjectPinsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AdStudioProjectPinsUpdateColumn = typeof AdStudioProjectPinsUpdateColumn[keyof typeof AdStudioProjectPinsUpdateColumn];
/** aggregate var_pop on columns */
export type AdStudioProjectPinsVarPopFields = {
  __typename?: 'ad_studio_project_pins_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdStudioProjectPinsVarSampFields = {
  __typename?: 'ad_studio_project_pins_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdStudioProjectPinsVarianceFields = {
  __typename?: 'ad_studio_project_pins_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_studio_project_pins" */
export type AdStudioProjectPinsVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjects = {
  __typename?: 'ad_studio_projects';
  /** An array relationship */
  ad_briefs: Array<AdBriefs>;
  /** An aggregate relationship */
  ad_briefs_aggregate: AdBriefsAggregate;
  /** An array relationship */
  ad_studio_sessions: Array<AdStudioSessions>;
  /** An aggregate relationship */
  ad_studio_sessions_aggregate: AdStudioSessionsAggregate;
  /** An object relationship */
  brand_profile?: Maybe<BrandProfiles>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  context: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_hidden: Scalars['Boolean'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  my_pins: Array<AdStudioProjectPins>;
  /** An aggregate relationship */
  my_pins_aggregate: AdStudioProjectPinsAggregate;
  name: Scalars['String'];
  /** An array relationship */
  pipeline_runs: Array<AdGenerationPipelineRuns>;
  /** An aggregate relationship */
  pipeline_runs_aggregate: AdGenerationPipelineRunsAggregate;
  /** An object relationship */
  report_schedule_run?: Maybe<ReportScheduleRuns>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  source: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsAdBriefsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsAdBriefsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsAdStudioSessionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsAdStudioSessionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsMyPinsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsMyPinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsPipelineRunsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


/** columns and relationships of "ad_studio_projects" */
export type AdStudioProjectsPipelineRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};

/** aggregated selection of "ad_studio_projects" */
export type AdStudioProjectsAggregate = {
  __typename?: 'ad_studio_projects_aggregate';
  aggregate?: Maybe<AdStudioProjectsAggregateFields>;
  nodes: Array<AdStudioProjects>;
};

export type AdStudioProjectsAggregateBoolExp = {
  bool_and?: InputMaybe<AdStudioProjectsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AdStudioProjectsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AdStudioProjectsAggregateBoolExpCount>;
};

export type AdStudioProjectsAggregateBoolExpBoolAnd = {
  arguments: AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioProjectsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdStudioProjectsAggregateBoolExpBoolOr = {
  arguments: AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioProjectsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AdStudioProjectsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioProjectsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_studio_projects" */
export type AdStudioProjectsAggregateFields = {
  __typename?: 'ad_studio_projects_aggregate_fields';
  avg?: Maybe<AdStudioProjectsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioProjectsMaxFields>;
  min?: Maybe<AdStudioProjectsMinFields>;
  stddev?: Maybe<AdStudioProjectsStddevFields>;
  stddev_pop?: Maybe<AdStudioProjectsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioProjectsStddevSampFields>;
  sum?: Maybe<AdStudioProjectsSumFields>;
  var_pop?: Maybe<AdStudioProjectsVarPopFields>;
  var_samp?: Maybe<AdStudioProjectsVarSampFields>;
  variance?: Maybe<AdStudioProjectsVarianceFields>;
};


/** aggregate fields of "ad_studio_projects" */
export type AdStudioProjectsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_studio_projects" */
export type AdStudioProjectsAggregateOrderBy = {
  avg?: InputMaybe<AdStudioProjectsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdStudioProjectsMaxOrderBy>;
  min?: InputMaybe<AdStudioProjectsMinOrderBy>;
  stddev?: InputMaybe<AdStudioProjectsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdStudioProjectsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdStudioProjectsStddevSampOrderBy>;
  sum?: InputMaybe<AdStudioProjectsSumOrderBy>;
  var_pop?: InputMaybe<AdStudioProjectsVarPopOrderBy>;
  var_samp?: InputMaybe<AdStudioProjectsVarSampOrderBy>;
  variance?: InputMaybe<AdStudioProjectsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdStudioProjectsAppendInput = {
  context?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ad_studio_projects" */
export type AdStudioProjectsArrRelInsertInput = {
  data: Array<AdStudioProjectsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStudioProjectsOnConflict>;
};

/** aggregate avg on columns */
export type AdStudioProjectsAvgFields = {
  __typename?: 'ad_studio_projects_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_studio_projects" */
export type AdStudioProjectsAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_studio_projects". All fields are combined with a logical 'AND'. */
export type AdStudioProjectsBoolExp = {
  _and?: InputMaybe<Array<AdStudioProjectsBoolExp>>;
  _not?: InputMaybe<AdStudioProjectsBoolExp>;
  _or?: InputMaybe<Array<AdStudioProjectsBoolExp>>;
  ad_briefs?: InputMaybe<AdBriefsBoolExp>;
  ad_briefs_aggregate?: InputMaybe<AdBriefsAggregateBoolExp>;
  ad_studio_sessions?: InputMaybe<AdStudioSessionsBoolExp>;
  ad_studio_sessions_aggregate?: InputMaybe<AdStudioSessionsAggregateBoolExp>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  context?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_hidden?: InputMaybe<BooleanComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  my_pins?: InputMaybe<AdStudioProjectPinsBoolExp>;
  my_pins_aggregate?: InputMaybe<AdStudioProjectPinsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  pipeline_runs?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
  pipeline_runs_aggregate?: InputMaybe<AdGenerationPipelineRunsAggregateBoolExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_studio_projects" */
export const AdStudioProjectsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdStudioProjectsIdWorkspaceIdKey: 'ad_studio_projects_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdStudioProjectsPkey: 'ad_studio_projects_pkey'
} as const;

export type AdStudioProjectsConstraint = typeof AdStudioProjectsConstraint[keyof typeof AdStudioProjectsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdStudioProjectsDeleteAtPathInput = {
  context?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdStudioProjectsDeleteElemInput = {
  context?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdStudioProjectsDeleteKeyInput = {
  context?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ad_studio_projects" */
export type AdStudioProjectsInsertInput = {
  ad_briefs?: InputMaybe<AdBriefsArrRelInsertInput>;
  brand_profile?: InputMaybe<BrandProfilesObjRelInsertInput>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  context?: InputMaybe<Scalars['jsonb']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  my_pins?: InputMaybe<AdStudioProjectPinsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdStudioProjectsMaxFields = {
  __typename?: 'ad_studio_projects_max_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_studio_projects" */
export type AdStudioProjectsMaxOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdStudioProjectsMinFields = {
  __typename?: 'ad_studio_projects_min_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_studio_projects" */
export type AdStudioProjectsMinOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_studio_projects" */
export type AdStudioProjectsMutationResponse = {
  __typename?: 'ad_studio_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStudioProjects>;
};

/** input type for inserting object relation for remote table "ad_studio_projects" */
export type AdStudioProjectsObjRelInsertInput = {
  data: AdStudioProjectsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStudioProjectsOnConflict>;
};

/** on_conflict condition type for table "ad_studio_projects" */
export type AdStudioProjectsOnConflict = {
  constraint: AdStudioProjectsConstraint;
  update_columns?: Array<AdStudioProjectsUpdateColumn>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};

/** Ordering options when selecting data from "ad_studio_projects". */
export type AdStudioProjectsOrderBy = {
  ad_briefs_aggregate?: InputMaybe<AdBriefsAggregateOrderBy>;
  ad_studio_sessions_aggregate?: InputMaybe<AdStudioSessionsAggregateOrderBy>;
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  context?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_hidden?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  my_pins_aggregate?: InputMaybe<AdStudioProjectPinsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  pipeline_runs_aggregate?: InputMaybe<AdGenerationPipelineRunsAggregateOrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_studio_projects */
export type AdStudioProjectsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdStudioProjectsPrependInput = {
  context?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_studio_projects" */
export const AdStudioProjectsSelectColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  IsHidden: 'is_hidden',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  Source: 'source',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioProjectsSelectColumn = typeof AdStudioProjectsSelectColumn[keyof typeof AdStudioProjectsSelectColumn];
/** select "ad_studio_projects_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ad_studio_projects" */
export const AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsHidden: 'is_hidden'
} as const;

export type AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolAndArgumentsColumns = typeof AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolAndArgumentsColumns];
/** select "ad_studio_projects_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ad_studio_projects" */
export const AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsHidden: 'is_hidden'
} as const;

export type AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolOrArgumentsColumns = typeof AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AdStudioProjectsSelectColumnAdStudioProjectsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "ad_studio_projects" */
export type AdStudioProjectsSetInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  context?: InputMaybe<Scalars['jsonb']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdStudioProjectsStddevFields = {
  __typename?: 'ad_studio_projects_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_studio_projects" */
export type AdStudioProjectsStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdStudioProjectsStddevPopFields = {
  __typename?: 'ad_studio_projects_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_studio_projects" */
export type AdStudioProjectsStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdStudioProjectsStddevSampFields = {
  __typename?: 'ad_studio_projects_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_studio_projects" */
export type AdStudioProjectsStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_studio_projects" */
export type AdStudioProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioProjectsStreamCursorValueInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  context?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioProjectsSumFields = {
  __typename?: 'ad_studio_projects_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_studio_projects" */
export type AdStudioProjectsSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "ad_studio_projects" */
export const AdStudioProjectsUpdateColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  Context: 'context',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  IsHidden: 'is_hidden',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  Status: 'status'
} as const;

export type AdStudioProjectsUpdateColumn = typeof AdStudioProjectsUpdateColumn[keyof typeof AdStudioProjectsUpdateColumn];
export type AdStudioProjectsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdStudioProjectsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdStudioProjectsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdStudioProjectsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdStudioProjectsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdStudioProjectsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdStudioProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: AdStudioProjectsBoolExp;
};

/** aggregate var_pop on columns */
export type AdStudioProjectsVarPopFields = {
  __typename?: 'ad_studio_projects_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_studio_projects" */
export type AdStudioProjectsVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdStudioProjectsVarSampFields = {
  __typename?: 'ad_studio_projects_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_studio_projects" */
export type AdStudioProjectsVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdStudioProjectsVarianceFields = {
  __typename?: 'ad_studio_projects_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_studio_projects" */
export type AdStudioProjectsVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_studio_sessions" */
export type AdStudioSessions = {
  __typename?: 'ad_studio_sessions';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ad_studio_project?: Maybe<AdStudioProjects>;
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id: Scalars['uuid'];
  session_type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "ad_studio_sessions" */
export type AdStudioSessionsAggregate = {
  __typename?: 'ad_studio_sessions_aggregate';
  aggregate?: Maybe<AdStudioSessionsAggregateFields>;
  nodes: Array<AdStudioSessions>;
};

export type AdStudioSessionsAggregateBoolExp = {
  count?: InputMaybe<AdStudioSessionsAggregateBoolExpCount>;
};

export type AdStudioSessionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioSessionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_studio_sessions" */
export type AdStudioSessionsAggregateFields = {
  __typename?: 'ad_studio_sessions_aggregate_fields';
  avg?: Maybe<AdStudioSessionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioSessionsMaxFields>;
  min?: Maybe<AdStudioSessionsMinFields>;
  stddev?: Maybe<AdStudioSessionsStddevFields>;
  stddev_pop?: Maybe<AdStudioSessionsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioSessionsStddevSampFields>;
  sum?: Maybe<AdStudioSessionsSumFields>;
  var_pop?: Maybe<AdStudioSessionsVarPopFields>;
  var_samp?: Maybe<AdStudioSessionsVarSampFields>;
  variance?: Maybe<AdStudioSessionsVarianceFields>;
};


/** aggregate fields of "ad_studio_sessions" */
export type AdStudioSessionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_studio_sessions" */
export type AdStudioSessionsAggregateOrderBy = {
  avg?: InputMaybe<AdStudioSessionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdStudioSessionsMaxOrderBy>;
  min?: InputMaybe<AdStudioSessionsMinOrderBy>;
  stddev?: InputMaybe<AdStudioSessionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdStudioSessionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdStudioSessionsStddevSampOrderBy>;
  sum?: InputMaybe<AdStudioSessionsSumOrderBy>;
  var_pop?: InputMaybe<AdStudioSessionsVarPopOrderBy>;
  var_samp?: InputMaybe<AdStudioSessionsVarSampOrderBy>;
  variance?: InputMaybe<AdStudioSessionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AdStudioSessionsAvgFields = {
  __typename?: 'ad_studio_sessions_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_studio_sessions". All fields are combined with a logical 'AND'. */
export type AdStudioSessionsBoolExp = {
  _and?: InputMaybe<Array<AdStudioSessionsBoolExp>>;
  _not?: InputMaybe<AdStudioSessionsBoolExp>;
  _or?: InputMaybe<Array<AdStudioSessionsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  ad_studio_project?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_project_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  session_type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AdStudioSessionsMaxFields = {
  __typename?: 'ad_studio_sessions_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  session_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  session_type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdStudioSessionsMinFields = {
  __typename?: 'ad_studio_sessions_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_studio_project_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  session_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  session_type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "ad_studio_sessions". */
export type AdStudioSessionsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_studio_project?: InputMaybe<AdStudioProjectsOrderBy>;
  ad_studio_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  session_type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "ad_studio_sessions" */
export const AdStudioSessionsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AdStudioProjectId: 'ad_studio_project_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  SessionType: 'session_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioSessionsSelectColumn = typeof AdStudioSessionsSelectColumn[keyof typeof AdStudioSessionsSelectColumn];
/** aggregate stddev on columns */
export type AdStudioSessionsStddevFields = {
  __typename?: 'ad_studio_sessions_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdStudioSessionsStddevPopFields = {
  __typename?: 'ad_studio_sessions_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdStudioSessionsStddevSampFields = {
  __typename?: 'ad_studio_sessions_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_studio_sessions" */
export type AdStudioSessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioSessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioSessionsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_studio_project_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  session_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioSessionsSumFields = {
  __typename?: 'ad_studio_sessions_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AdStudioSessionsVarPopFields = {
  __typename?: 'ad_studio_sessions_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdStudioSessionsVarSampFields = {
  __typename?: 'ad_studio_sessions_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdStudioSessionsVarianceFields = {
  __typename?: 'ad_studio_sessions_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_studio_sessions" */
export type AdStudioSessionsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "ad_studio_treatments" */
export type AdStudioTreatments = {
  __typename?: 'ad_studio_treatments';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  preview: Scalars['jsonb'];
  priority: Scalars['Int'];
  /** An object relationship */
  product_feed?: Maybe<AdStudioProductFeeds>;
  product_feed_id: Scalars['uuid'];
  segment_filters: Scalars['jsonb'];
  status: Scalars['String'];
  /** An object relationship */
  template_asset?: Maybe<AdBriefAssets>;
  template_asset_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "ad_studio_treatments" */
export type AdStudioTreatmentsPreviewArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "ad_studio_treatments" */
export type AdStudioTreatmentsSegmentFiltersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ad_studio_treatments" */
export type AdStudioTreatmentsAggregate = {
  __typename?: 'ad_studio_treatments_aggregate';
  aggregate?: Maybe<AdStudioTreatmentsAggregateFields>;
  nodes: Array<AdStudioTreatments>;
};

export type AdStudioTreatmentsAggregateBoolExp = {
  count?: InputMaybe<AdStudioTreatmentsAggregateBoolExpCount>;
};

export type AdStudioTreatmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AdStudioTreatmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "ad_studio_treatments" */
export type AdStudioTreatmentsAggregateFields = {
  __typename?: 'ad_studio_treatments_aggregate_fields';
  avg?: Maybe<AdStudioTreatmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AdStudioTreatmentsMaxFields>;
  min?: Maybe<AdStudioTreatmentsMinFields>;
  stddev?: Maybe<AdStudioTreatmentsStddevFields>;
  stddev_pop?: Maybe<AdStudioTreatmentsStddevPopFields>;
  stddev_samp?: Maybe<AdStudioTreatmentsStddevSampFields>;
  sum?: Maybe<AdStudioTreatmentsSumFields>;
  var_pop?: Maybe<AdStudioTreatmentsVarPopFields>;
  var_samp?: Maybe<AdStudioTreatmentsVarSampFields>;
  variance?: Maybe<AdStudioTreatmentsVarianceFields>;
};


/** aggregate fields of "ad_studio_treatments" */
export type AdStudioTreatmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ad_studio_treatments" */
export type AdStudioTreatmentsAggregateOrderBy = {
  avg?: InputMaybe<AdStudioTreatmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AdStudioTreatmentsMaxOrderBy>;
  min?: InputMaybe<AdStudioTreatmentsMinOrderBy>;
  stddev?: InputMaybe<AdStudioTreatmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<AdStudioTreatmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AdStudioTreatmentsStddevSampOrderBy>;
  sum?: InputMaybe<AdStudioTreatmentsSumOrderBy>;
  var_pop?: InputMaybe<AdStudioTreatmentsVarPopOrderBy>;
  var_samp?: InputMaybe<AdStudioTreatmentsVarSampOrderBy>;
  variance?: InputMaybe<AdStudioTreatmentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdStudioTreatmentsAppendInput = {
  segment_filters?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ad_studio_treatments" */
export type AdStudioTreatmentsArrRelInsertInput = {
  data: Array<AdStudioTreatmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AdStudioTreatmentsOnConflict>;
};

/** aggregate avg on columns */
export type AdStudioTreatmentsAvgFields = {
  __typename?: 'ad_studio_treatments_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "ad_studio_treatments". All fields are combined with a logical 'AND'. */
export type AdStudioTreatmentsBoolExp = {
  _and?: InputMaybe<Array<AdStudioTreatmentsBoolExp>>;
  _not?: InputMaybe<AdStudioTreatmentsBoolExp>;
  _or?: InputMaybe<Array<AdStudioTreatmentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  preview?: InputMaybe<JsonbComparisonExp>;
  priority?: InputMaybe<IntComparisonExp>;
  product_feed?: InputMaybe<AdStudioProductFeedsBoolExp>;
  product_feed_id?: InputMaybe<UuidComparisonExp>;
  segment_filters?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  template_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  template_asset_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "ad_studio_treatments" */
export const AdStudioTreatmentsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AdStudioTreatmentsIdWorkspaceIdKey: 'ad_studio_treatments_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AdStudioTreatmentsPkey: 'ad_studio_treatments_pkey'
} as const;

export type AdStudioTreatmentsConstraint = typeof AdStudioTreatmentsConstraint[keyof typeof AdStudioTreatmentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdStudioTreatmentsDeleteAtPathInput = {
  segment_filters?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdStudioTreatmentsDeleteElemInput = {
  segment_filters?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdStudioTreatmentsDeleteKeyInput = {
  segment_filters?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ad_studio_treatments" */
export type AdStudioTreatmentsIncInput = {
  priority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ad_studio_treatments" */
export type AdStudioTreatmentsInsertInput = {
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  product_feed?: InputMaybe<AdStudioProductFeedsObjRelInsertInput>;
  product_feed_id?: InputMaybe<Scalars['uuid']>;
  segment_filters?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  template_asset?: InputMaybe<AdBriefAssetsObjRelInsertInput>;
  template_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AdStudioTreatmentsMaxFields = {
  __typename?: 'ad_studio_treatments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  product_feed_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  template_asset_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  product_feed_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  template_asset_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AdStudioTreatmentsMinFields = {
  __typename?: 'ad_studio_treatments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  product_feed_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  template_asset_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  product_feed_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  template_asset_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "ad_studio_treatments" */
export type AdStudioTreatmentsMutationResponse = {
  __typename?: 'ad_studio_treatments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AdStudioTreatments>;
};

/** on_conflict condition type for table "ad_studio_treatments" */
export type AdStudioTreatmentsOnConflict = {
  constraint: AdStudioTreatmentsConstraint;
  update_columns?: Array<AdStudioTreatmentsUpdateColumn>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};

/** Ordering options when selecting data from "ad_studio_treatments". */
export type AdStudioTreatmentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  preview?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  product_feed?: InputMaybe<AdStudioProductFeedsOrderBy>;
  product_feed_id?: InputMaybe<OrderBy>;
  segment_filters?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  template_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  template_asset_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: ad_studio_treatments */
export type AdStudioTreatmentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdStudioTreatmentsPrependInput = {
  segment_filters?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ad_studio_treatments" */
export const AdStudioTreatmentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  Preview: 'preview',
  /** column name */
  Priority: 'priority',
  /** column name */
  ProductFeedId: 'product_feed_id',
  /** column name */
  SegmentFilters: 'segment_filters',
  /** column name */
  Status: 'status',
  /** column name */
  TemplateAssetId: 'template_asset_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdStudioTreatmentsSelectColumn = typeof AdStudioTreatmentsSelectColumn[keyof typeof AdStudioTreatmentsSelectColumn];
/** input type for updating data in table "ad_studio_treatments" */
export type AdStudioTreatmentsSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  segment_filters?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  template_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AdStudioTreatmentsStddevFields = {
  __typename?: 'ad_studio_treatments_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdStudioTreatmentsStddevPopFields = {
  __typename?: 'ad_studio_treatments_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdStudioTreatmentsStddevSampFields = {
  __typename?: 'ad_studio_treatments_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ad_studio_treatments" */
export type AdStudioTreatmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdStudioTreatmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdStudioTreatmentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['jsonb']>;
  priority?: InputMaybe<Scalars['Int']>;
  product_feed_id?: InputMaybe<Scalars['uuid']>;
  segment_filters?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  template_asset_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AdStudioTreatmentsSumFields = {
  __typename?: 'ad_studio_treatments_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  priority?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "ad_studio_treatments" */
export const AdStudioTreatmentsUpdateColumn = {
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  Priority: 'priority',
  /** column name */
  SegmentFilters: 'segment_filters',
  /** column name */
  Status: 'status',
  /** column name */
  TemplateAssetId: 'template_asset_id'
} as const;

export type AdStudioTreatmentsUpdateColumn = typeof AdStudioTreatmentsUpdateColumn[keyof typeof AdStudioTreatmentsUpdateColumn];
export type AdStudioTreatmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AdStudioTreatmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AdStudioTreatmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AdStudioTreatmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AdStudioTreatmentsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AdStudioTreatmentsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AdStudioTreatmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdStudioTreatmentsSetInput>;
  /** filter the rows which have to be updated */
  where: AdStudioTreatmentsBoolExp;
};

/** aggregate var_pop on columns */
export type AdStudioTreatmentsVarPopFields = {
  __typename?: 'ad_studio_treatments_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdStudioTreatmentsVarSampFields = {
  __typename?: 'ad_studio_treatments_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdStudioTreatmentsVarianceFields = {
  __typename?: 'ad_studio_treatments_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ad_studio_treatments" */
export type AdStudioTreatmentsVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "admin_entitlements" */
export type AdminEntitlements = {
  __typename?: 'admin_entitlements';
  created_at: Scalars['timestamptz'];
  entitlement: Scalars['String'];
  expires_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "admin_entitlements". All fields are combined with a logical 'AND'. */
export type AdminEntitlementsBoolExp = {
  _and?: InputMaybe<Array<AdminEntitlementsBoolExp>>;
  _not?: InputMaybe<AdminEntitlementsBoolExp>;
  _or?: InputMaybe<Array<AdminEntitlementsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  entitlement?: InputMaybe<StringComparisonExp>;
  expires_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "admin_entitlements". */
export type AdminEntitlementsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  entitlement?: InputMaybe<OrderBy>;
  expires_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "admin_entitlements" */
export const AdminEntitlementsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Entitlement: 'entitlement',
  /** column name */
  ExpiresAt: 'expires_at',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UserId: 'user_id'
} as const;

export type AdminEntitlementsSelectColumn = typeof AdminEntitlementsSelectColumn[keyof typeof AdminEntitlementsSelectColumn];
/** Streaming cursor of the table "admin_entitlements" */
export type AdminEntitlementsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdminEntitlementsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdminEntitlementsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entitlement?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "admin_workspace_entitlements" */
export type AdminWorkspaceEntitlements = {
  __typename?: 'admin_workspace_entitlements';
  created_at?: Maybe<Scalars['timestamptz']>;
  entitlement?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "admin_workspace_entitlements". All fields are combined with a logical 'AND'. */
export type AdminWorkspaceEntitlementsBoolExp = {
  _and?: InputMaybe<Array<AdminWorkspaceEntitlementsBoolExp>>;
  _not?: InputMaybe<AdminWorkspaceEntitlementsBoolExp>;
  _or?: InputMaybe<Array<AdminWorkspaceEntitlementsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  entitlement?: InputMaybe<StringComparisonExp>;
  expires_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "admin_workspace_entitlements". */
export type AdminWorkspaceEntitlementsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  entitlement?: InputMaybe<OrderBy>;
  expires_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "admin_workspace_entitlements" */
export const AdminWorkspaceEntitlementsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Entitlement: 'entitlement',
  /** column name */
  ExpiresAt: 'expires_at',
  /** column name */
  Id: 'id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AdminWorkspaceEntitlementsSelectColumn = typeof AdminWorkspaceEntitlementsSelectColumn[keyof typeof AdminWorkspaceEntitlementsSelectColumn];
/** Streaming cursor of the table "admin_workspace_entitlements" */
export type AdminWorkspaceEntitlementsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AdminWorkspaceEntitlementsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AdminWorkspaceEntitlementsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entitlement?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "agent_asset_versions" */
export type AgentAssetVersions = {
  __typename?: 'agent_asset_versions';
  agent_asset_id: Scalars['uuid'];
  /** An object relationship */
  asset: AgentAssets;
  content_hash: Scalars['String'];
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_interaction?: Maybe<LlmChatInteractions>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  generation?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  object_storage_key: Scalars['String'];
  size_bytes?: Maybe<Scalars['bigint']>;
  version: Scalars['Int'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agent_asset_versions" */
export type AgentAssetVersionsGenerationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "agent_asset_versions" */
export type AgentAssetVersionsAggregate = {
  __typename?: 'agent_asset_versions_aggregate';
  aggregate?: Maybe<AgentAssetVersionsAggregateFields>;
  nodes: Array<AgentAssetVersions>;
};

export type AgentAssetVersionsAggregateBoolExp = {
  count?: InputMaybe<AgentAssetVersionsAggregateBoolExpCount>;
};

export type AgentAssetVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AgentAssetVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agent_asset_versions" */
export type AgentAssetVersionsAggregateFields = {
  __typename?: 'agent_asset_versions_aggregate_fields';
  avg?: Maybe<AgentAssetVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AgentAssetVersionsMaxFields>;
  min?: Maybe<AgentAssetVersionsMinFields>;
  stddev?: Maybe<AgentAssetVersionsStddevFields>;
  stddev_pop?: Maybe<AgentAssetVersionsStddevPopFields>;
  stddev_samp?: Maybe<AgentAssetVersionsStddevSampFields>;
  sum?: Maybe<AgentAssetVersionsSumFields>;
  var_pop?: Maybe<AgentAssetVersionsVarPopFields>;
  var_samp?: Maybe<AgentAssetVersionsVarSampFields>;
  variance?: Maybe<AgentAssetVersionsVarianceFields>;
};


/** aggregate fields of "agent_asset_versions" */
export type AgentAssetVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent_asset_versions" */
export type AgentAssetVersionsAggregateOrderBy = {
  avg?: InputMaybe<AgentAssetVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgentAssetVersionsMaxOrderBy>;
  min?: InputMaybe<AgentAssetVersionsMinOrderBy>;
  stddev?: InputMaybe<AgentAssetVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AgentAssetVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgentAssetVersionsStddevSampOrderBy>;
  sum?: InputMaybe<AgentAssetVersionsSumOrderBy>;
  var_pop?: InputMaybe<AgentAssetVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<AgentAssetVersionsVarSampOrderBy>;
  variance?: InputMaybe<AgentAssetVersionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AgentAssetVersionsAvgFields = {
  __typename?: 'agent_asset_versions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agent_asset_versions". All fields are combined with a logical 'AND'. */
export type AgentAssetVersionsBoolExp = {
  _and?: InputMaybe<Array<AgentAssetVersionsBoolExp>>;
  _not?: InputMaybe<AgentAssetVersionsBoolExp>;
  _or?: InputMaybe<Array<AgentAssetVersionsBoolExp>>;
  agent_asset_id?: InputMaybe<UuidComparisonExp>;
  asset?: InputMaybe<AgentAssetsBoolExp>;
  content_hash?: InputMaybe<StringComparisonExp>;
  content_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  created_by_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  generation?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  object_storage_key?: InputMaybe<StringComparisonExp>;
  size_bytes?: InputMaybe<BigintComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AgentAssetVersionsMaxFields = {
  __typename?: 'agent_asset_versions_max_fields';
  agent_asset_id?: Maybe<Scalars['uuid']>;
  content_hash?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  object_storage_key?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsMaxOrderBy = {
  agent_asset_id?: InputMaybe<OrderBy>;
  content_hash?: InputMaybe<OrderBy>;
  content_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  object_storage_key?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AgentAssetVersionsMinFields = {
  __typename?: 'agent_asset_versions_min_fields';
  agent_asset_id?: Maybe<Scalars['uuid']>;
  content_hash?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  object_storage_key?: Maybe<Scalars['String']>;
  size_bytes?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsMinOrderBy = {
  agent_asset_id?: InputMaybe<OrderBy>;
  content_hash?: InputMaybe<OrderBy>;
  content_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  object_storage_key?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "agent_asset_versions". */
export type AgentAssetVersionsOrderBy = {
  agent_asset_id?: InputMaybe<OrderBy>;
  asset?: InputMaybe<AgentAssetsOrderBy>;
  content_hash?: InputMaybe<OrderBy>;
  content_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  generation?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  object_storage_key?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agent_asset_versions" */
export const AgentAssetVersionsSelectColumn = {
  /** column name */
  AgentAssetId: 'agent_asset_id',
  /** column name */
  ContentHash: 'content_hash',
  /** column name */
  ContentType: 'content_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreatedByInteractionId: 'created_by_interaction_id',
  /** column name */
  Generation: 'generation',
  /** column name */
  Id: 'id',
  /** column name */
  ObjectStorageKey: 'object_storage_key',
  /** column name */
  SizeBytes: 'size_bytes',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgentAssetVersionsSelectColumn = typeof AgentAssetVersionsSelectColumn[keyof typeof AgentAssetVersionsSelectColumn];
/** aggregate stddev on columns */
export type AgentAssetVersionsStddevFields = {
  __typename?: 'agent_asset_versions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AgentAssetVersionsStddevPopFields = {
  __typename?: 'agent_asset_versions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AgentAssetVersionsStddevSampFields = {
  __typename?: 'agent_asset_versions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "agent_asset_versions" */
export type AgentAssetVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgentAssetVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentAssetVersionsStreamCursorValueInput = {
  agent_asset_id?: InputMaybe<Scalars['uuid']>;
  content_hash?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  generation?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  object_storage_key?: InputMaybe<Scalars['String']>;
  size_bytes?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AgentAssetVersionsSumFields = {
  __typename?: 'agent_asset_versions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  size_bytes?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AgentAssetVersionsVarPopFields = {
  __typename?: 'agent_asset_versions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AgentAssetVersionsVarSampFields = {
  __typename?: 'agent_asset_versions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AgentAssetVersionsVarianceFields = {
  __typename?: 'agent_asset_versions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  size_bytes?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent_asset_versions" */
export type AgentAssetVersionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  size_bytes?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "agent_assets" */
export type AgentAssets = {
  __typename?: 'agent_assets';
  /** An object relationship */
  ad_brief_asset: AdBriefAssets;
  ad_brief_asset_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  filename: Scalars['String'];
  id: Scalars['uuid'];
  type: Scalars['String'];
  /** An array relationship */
  versions: Array<AgentAssetVersions>;
  /** An aggregate relationship */
  versions_aggregate: AgentAssetVersionsAggregate;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agent_assets" */
export type AgentAssetsVersionsArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


/** columns and relationships of "agent_assets" */
export type AgentAssetsVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};

/** aggregated selection of "agent_assets" */
export type AgentAssetsAggregate = {
  __typename?: 'agent_assets_aggregate';
  aggregate?: Maybe<AgentAssetsAggregateFields>;
  nodes: Array<AgentAssets>;
};

/** aggregate fields of "agent_assets" */
export type AgentAssetsAggregateFields = {
  __typename?: 'agent_assets_aggregate_fields';
  avg?: Maybe<AgentAssetsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AgentAssetsMaxFields>;
  min?: Maybe<AgentAssetsMinFields>;
  stddev?: Maybe<AgentAssetsStddevFields>;
  stddev_pop?: Maybe<AgentAssetsStddevPopFields>;
  stddev_samp?: Maybe<AgentAssetsStddevSampFields>;
  sum?: Maybe<AgentAssetsSumFields>;
  var_pop?: Maybe<AgentAssetsVarPopFields>;
  var_samp?: Maybe<AgentAssetsVarSampFields>;
  variance?: Maybe<AgentAssetsVarianceFields>;
};


/** aggregate fields of "agent_assets" */
export type AgentAssetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AgentAssetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AgentAssetsAvgFields = {
  __typename?: 'agent_assets_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "agent_assets". All fields are combined with a logical 'AND'. */
export type AgentAssetsBoolExp = {
  _and?: InputMaybe<Array<AgentAssetsBoolExp>>;
  _not?: InputMaybe<AgentAssetsBoolExp>;
  _or?: InputMaybe<Array<AgentAssetsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  filename?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  versions?: InputMaybe<AgentAssetVersionsBoolExp>;
  versions_aggregate?: InputMaybe<AgentAssetVersionsAggregateBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AgentAssetsMaxFields = {
  __typename?: 'agent_assets_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AgentAssetsMinFields = {
  __typename?: 'agent_assets_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "agent_assets". */
export type AgentAssetsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  filename?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  versions_aggregate?: InputMaybe<AgentAssetVersionsAggregateOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agent_assets" */
export const AgentAssetsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Filename: 'filename',
  /** column name */
  Id: 'id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgentAssetsSelectColumn = typeof AgentAssetsSelectColumn[keyof typeof AgentAssetsSelectColumn];
/** aggregate stddev on columns */
export type AgentAssetsStddevFields = {
  __typename?: 'agent_assets_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AgentAssetsStddevPopFields = {
  __typename?: 'agent_assets_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AgentAssetsStddevSampFields = {
  __typename?: 'agent_assets_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "agent_assets" */
export type AgentAssetsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgentAssetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentAssetsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AgentAssetsSumFields = {
  __typename?: 'agent_assets_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AgentAssetsVarPopFields = {
  __typename?: 'agent_assets_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AgentAssetsVarSampFields = {
  __typename?: 'agent_assets_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AgentAssetsVarianceFields = {
  __typename?: 'agent_assets_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "agent_report_suggestions" */
export type AgentReportSuggestions = {
  __typename?: 'agent_report_suggestions';
  context_version_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  suggestions: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agent_report_suggestions" */
export type AgentReportSuggestionsSuggestionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "agent_report_suggestions". All fields are combined with a logical 'AND'. */
export type AgentReportSuggestionsBoolExp = {
  _and?: InputMaybe<Array<AgentReportSuggestionsBoolExp>>;
  _not?: InputMaybe<AgentReportSuggestionsBoolExp>;
  _or?: InputMaybe<Array<AgentReportSuggestionsBoolExp>>;
  context_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  suggestions?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "agent_report_suggestions". */
export type AgentReportSuggestionsOrderBy = {
  context_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  suggestions?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agent_report_suggestions" */
export const AgentReportSuggestionsSelectColumn = {
  /** column name */
  ContextVersionId: 'context_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Suggestions: 'suggestions',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgentReportSuggestionsSelectColumn = typeof AgentReportSuggestionsSelectColumn[keyof typeof AgentReportSuggestionsSelectColumn];
/** Streaming cursor of the table "agent_report_suggestions" */
export type AgentReportSuggestionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgentReportSuggestionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentReportSuggestionsStreamCursorValueInput = {
  context_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  suggestions?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "agent_suggestion_batches" */
export type AgentSuggestionBatches = {
  __typename?: 'agent_suggestion_batches';
  context_version_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  suggestions: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agent_suggestion_batches" */
export type AgentSuggestionBatchesSuggestionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "agent_suggestion_batches". All fields are combined with a logical 'AND'. */
export type AgentSuggestionBatchesBoolExp = {
  _and?: InputMaybe<Array<AgentSuggestionBatchesBoolExp>>;
  _not?: InputMaybe<AgentSuggestionBatchesBoolExp>;
  _or?: InputMaybe<Array<AgentSuggestionBatchesBoolExp>>;
  context_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  suggestions?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "agent_suggestion_batches". */
export type AgentSuggestionBatchesOrderBy = {
  context_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  suggestions?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agent_suggestion_batches" */
export const AgentSuggestionBatchesSelectColumn = {
  /** column name */
  ContextVersionId: 'context_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Suggestions: 'suggestions',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgentSuggestionBatchesSelectColumn = typeof AgentSuggestionBatchesSelectColumn[keyof typeof AgentSuggestionBatchesSelectColumn];
/** Streaming cursor of the table "agent_suggestion_batches" */
export type AgentSuggestionBatchesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgentSuggestionBatchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentSuggestionBatchesStreamCursorValueInput = {
  context_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  suggestions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "agent_suggestions" */
export type AgentSuggestions = {
  __typename?: 'agent_suggestions';
  created_at?: Maybe<Scalars['timestamptz']>;
  suggestions?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agent_suggestions" */
export type AgentSuggestionsSuggestionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "agent_suggestions". All fields are combined with a logical 'AND'. */
export type AgentSuggestionsBoolExp = {
  _and?: InputMaybe<Array<AgentSuggestionsBoolExp>>;
  _not?: InputMaybe<AgentSuggestionsBoolExp>;
  _or?: InputMaybe<Array<AgentSuggestionsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  suggestions?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "agent_suggestions". */
export type AgentSuggestionsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  suggestions?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agent_suggestions" */
export const AgentSuggestionsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Suggestions: 'suggestions',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgentSuggestionsSelectColumn = typeof AgentSuggestionsSelectColumn[keyof typeof AgentSuggestionsSelectColumn];
/** Streaming cursor of the table "agent_suggestions" */
export type AgentSuggestionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgentSuggestionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgentSuggestionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  suggestions?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "agentic_settings" */
export type AgenticSettings = {
  __typename?: 'agentic_settings';
  /** An object relationship */
  active_inference_backend?: Maybe<LlmInferenceBackends>;
  active_inference_backend_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  settings: Scalars['jsonb'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agentic_settings" */
export type AgenticSettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AgenticSettingsAppendInput = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "agentic_settings". All fields are combined with a logical 'AND'. */
export type AgenticSettingsBoolExp = {
  _and?: InputMaybe<Array<AgenticSettingsBoolExp>>;
  _not?: InputMaybe<AgenticSettingsBoolExp>;
  _or?: InputMaybe<Array<AgenticSettingsBoolExp>>;
  active_inference_backend?: InputMaybe<LlmInferenceBackendsBoolExp>;
  active_inference_backend_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  settings?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "agentic_settings" */
export const AgenticSettingsConstraint = {
  /** unique or primary key constraint on columns "workspace_id" */
  AgenticSettingsPkey: 'agentic_settings_pkey'
} as const;

export type AgenticSettingsConstraint = typeof AgenticSettingsConstraint[keyof typeof AgenticSettingsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AgenticSettingsDeleteAtPathInput = {
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AgenticSettingsDeleteElemInput = {
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AgenticSettingsDeleteKeyInput = {
  settings?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinks = {
  __typename?: 'agentic_settings_entities_links';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  position: Scalars['Int'];
  skill_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow_status?: Maybe<AmpWorkflowStatuses>;
  workflow_status_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksAggregateOrderBy = {
  avg?: InputMaybe<AgenticSettingsEntitiesLinksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgenticSettingsEntitiesLinksMaxOrderBy>;
  min?: InputMaybe<AgenticSettingsEntitiesLinksMinOrderBy>;
  stddev?: InputMaybe<AgenticSettingsEntitiesLinksStddevOrderBy>;
  stddev_pop?: InputMaybe<AgenticSettingsEntitiesLinksStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgenticSettingsEntitiesLinksStddevSampOrderBy>;
  sum?: InputMaybe<AgenticSettingsEntitiesLinksSumOrderBy>;
  var_pop?: InputMaybe<AgenticSettingsEntitiesLinksVarPopOrderBy>;
  var_samp?: InputMaybe<AgenticSettingsEntitiesLinksVarSampOrderBy>;
  variance?: InputMaybe<AgenticSettingsEntitiesLinksVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksArrRelInsertInput = {
  data: Array<AgenticSettingsEntitiesLinksInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgenticSettingsEntitiesLinksOnConflict>;
};

/** order by avg() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agentic_settings_entities_links". All fields are combined with a logical 'AND'. */
export type AgenticSettingsEntitiesLinksBoolExp = {
  _and?: InputMaybe<Array<AgenticSettingsEntitiesLinksBoolExp>>;
  _not?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
  _or?: InputMaybe<Array<AgenticSettingsEntitiesLinksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  skill_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workflow_status?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  workflow_status_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "agentic_settings_entities_links" */
export const AgenticSettingsEntitiesLinksConstraint = {
  /** unique or primary key constraint on columns "id" */
  AgenticSettingsEntitiesLinksPkey: 'agentic_settings_entities_links_pkey',
  /** unique or primary key constraint on columns "skill_id", "workflow_status_id" */
  AgenticSettingsEntitiesLinksWorkflowStatusSkillKey: 'agentic_settings_entities_links_workflow_status_skill_key'
} as const;

export type AgenticSettingsEntitiesLinksConstraint = typeof AgenticSettingsEntitiesLinksConstraint[keyof typeof AgenticSettingsEntitiesLinksConstraint];
/** input type for incrementing numeric columns in table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksIncInput = {
  position?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksInsertInput = {
  position?: InputMaybe<Scalars['Int']>;
  skill_id?: InputMaybe<Scalars['uuid']>;
  workflow_status?: InputMaybe<AmpWorkflowStatusesObjRelInsertInput>;
  workflow_status_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  skill_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_status_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  skill_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_status_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksMutationResponse = {
  __typename?: 'agentic_settings_entities_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AgenticSettingsEntitiesLinks>;
};

/** on_conflict condition type for table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksOnConflict = {
  constraint: AgenticSettingsEntitiesLinksConstraint;
  update_columns?: Array<AgenticSettingsEntitiesLinksUpdateColumn>;
  where?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
};

/** Ordering options when selecting data from "agentic_settings_entities_links". */
export type AgenticSettingsEntitiesLinksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  skill_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_status?: InputMaybe<AmpWorkflowStatusesOrderBy>;
  workflow_status_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agentic_settings_entities_links */
export type AgenticSettingsEntitiesLinksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "agentic_settings_entities_links" */
export const AgenticSettingsEntitiesLinksSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Position: 'position',
  /** column name */
  SkillId: 'skill_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkflowStatusId: 'workflow_status_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgenticSettingsEntitiesLinksSelectColumn = typeof AgenticSettingsEntitiesLinksSelectColumn[keyof typeof AgenticSettingsEntitiesLinksSelectColumn];
/** input type for updating data in table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksSetInput = {
  position?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgenticSettingsEntitiesLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgenticSettingsEntitiesLinksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  skill_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_status_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "agentic_settings_entities_links" */
export const AgenticSettingsEntitiesLinksUpdateColumn = {
  /** column name */
  Position: 'position'
} as const;

export type AgenticSettingsEntitiesLinksUpdateColumn = typeof AgenticSettingsEntitiesLinksUpdateColumn[keyof typeof AgenticSettingsEntitiesLinksUpdateColumn];
export type AgenticSettingsEntitiesLinksUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AgenticSettingsEntitiesLinksIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgenticSettingsEntitiesLinksSetInput>;
  /** filter the rows which have to be updated */
  where: AgenticSettingsEntitiesLinksBoolExp;
};

/** order by var_pop() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "agentic_settings_entities_links" */
export type AgenticSettingsEntitiesLinksVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestions = {
  __typename?: 'agentic_settings_entity_review_suggestions';
  applied_to_entity_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  created_by_session_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  index: Scalars['Int'];
  op_type: Scalars['String'];
  operation: Scalars['jsonb'];
  proposed_entity_key?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  review_id: Scalars['uuid'];
  reviewed_entity_id?: Maybe<Scalars['uuid']>;
  reviewed_entity_version_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsOperationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsAggregate = {
  __typename?: 'agentic_settings_entity_review_suggestions_aggregate';
  aggregate?: Maybe<AgenticSettingsEntityReviewSuggestionsAggregateFields>;
  nodes: Array<AgenticSettingsEntityReviewSuggestions>;
};

export type AgenticSettingsEntityReviewSuggestionsAggregateBoolExp = {
  count?: InputMaybe<AgenticSettingsEntityReviewSuggestionsAggregateBoolExpCount>;
};

export type AgenticSettingsEntityReviewSuggestionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsAggregateFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_aggregate_fields';
  avg?: Maybe<AgenticSettingsEntityReviewSuggestionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AgenticSettingsEntityReviewSuggestionsMaxFields>;
  min?: Maybe<AgenticSettingsEntityReviewSuggestionsMinFields>;
  stddev?: Maybe<AgenticSettingsEntityReviewSuggestionsStddevFields>;
  stddev_pop?: Maybe<AgenticSettingsEntityReviewSuggestionsStddevPopFields>;
  stddev_samp?: Maybe<AgenticSettingsEntityReviewSuggestionsStddevSampFields>;
  sum?: Maybe<AgenticSettingsEntityReviewSuggestionsSumFields>;
  var_pop?: Maybe<AgenticSettingsEntityReviewSuggestionsVarPopFields>;
  var_samp?: Maybe<AgenticSettingsEntityReviewSuggestionsVarSampFields>;
  variance?: Maybe<AgenticSettingsEntityReviewSuggestionsVarianceFields>;
};


/** aggregate fields of "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsAggregateOrderBy = {
  avg?: InputMaybe<AgenticSettingsEntityReviewSuggestionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgenticSettingsEntityReviewSuggestionsMaxOrderBy>;
  min?: InputMaybe<AgenticSettingsEntityReviewSuggestionsMinOrderBy>;
  stddev?: InputMaybe<AgenticSettingsEntityReviewSuggestionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AgenticSettingsEntityReviewSuggestionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgenticSettingsEntityReviewSuggestionsStddevSampOrderBy>;
  sum?: InputMaybe<AgenticSettingsEntityReviewSuggestionsSumOrderBy>;
  var_pop?: InputMaybe<AgenticSettingsEntityReviewSuggestionsVarPopOrderBy>;
  var_samp?: InputMaybe<AgenticSettingsEntityReviewSuggestionsVarSampOrderBy>;
  variance?: InputMaybe<AgenticSettingsEntityReviewSuggestionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AgenticSettingsEntityReviewSuggestionsAvgFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_avg_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsAvgOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agentic_settings_entity_review_suggestions". All fields are combined with a logical 'AND'. */
export type AgenticSettingsEntityReviewSuggestionsBoolExp = {
  _and?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsBoolExp>>;
  _not?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
  _or?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsBoolExp>>;
  applied_to_entity_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_session_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  index?: InputMaybe<IntComparisonExp>;
  op_type?: InputMaybe<StringComparisonExp>;
  operation?: InputMaybe<JsonbComparisonExp>;
  proposed_entity_key?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  review_id?: InputMaybe<UuidComparisonExp>;
  reviewed_entity_id?: InputMaybe<UuidComparisonExp>;
  reviewed_entity_version_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AgenticSettingsEntityReviewSuggestionsMaxFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_max_fields';
  applied_to_entity_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  created_by_session_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  op_type?: Maybe<Scalars['String']>;
  proposed_entity_key?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  review_id?: Maybe<Scalars['uuid']>;
  reviewed_entity_id?: Maybe<Scalars['uuid']>;
  reviewed_entity_version_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsMaxOrderBy = {
  applied_to_entity_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_session_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  op_type?: InputMaybe<OrderBy>;
  proposed_entity_key?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  review_id?: InputMaybe<OrderBy>;
  reviewed_entity_id?: InputMaybe<OrderBy>;
  reviewed_entity_version_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AgenticSettingsEntityReviewSuggestionsMinFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_min_fields';
  applied_to_entity_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  created_by_session_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  op_type?: Maybe<Scalars['String']>;
  proposed_entity_key?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  review_id?: Maybe<Scalars['uuid']>;
  reviewed_entity_id?: Maybe<Scalars['uuid']>;
  reviewed_entity_version_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsMinOrderBy = {
  applied_to_entity_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_session_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  op_type?: InputMaybe<OrderBy>;
  proposed_entity_key?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  review_id?: InputMaybe<OrderBy>;
  reviewed_entity_id?: InputMaybe<OrderBy>;
  reviewed_entity_version_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "agentic_settings_entity_review_suggestions". */
export type AgenticSettingsEntityReviewSuggestionsOrderBy = {
  applied_to_entity_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_session_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  op_type?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  proposed_entity_key?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  review_id?: InputMaybe<OrderBy>;
  reviewed_entity_id?: InputMaybe<OrderBy>;
  reviewed_entity_version_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agentic_settings_entity_review_suggestions" */
export const AgenticSettingsEntityReviewSuggestionsSelectColumn = {
  /** column name */
  AppliedToEntityVersionId: 'applied_to_entity_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByInteractionId: 'created_by_interaction_id',
  /** column name */
  CreatedBySessionId: 'created_by_session_id',
  /** column name */
  Id: 'id',
  /** column name */
  Index: 'index',
  /** column name */
  OpType: 'op_type',
  /** column name */
  Operation: 'operation',
  /** column name */
  ProposedEntityKey: 'proposed_entity_key',
  /** column name */
  Reason: 'reason',
  /** column name */
  ReviewId: 'review_id',
  /** column name */
  ReviewedEntityId: 'reviewed_entity_id',
  /** column name */
  ReviewedEntityVersionId: 'reviewed_entity_version_id',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgenticSettingsEntityReviewSuggestionsSelectColumn = typeof AgenticSettingsEntityReviewSuggestionsSelectColumn[keyof typeof AgenticSettingsEntityReviewSuggestionsSelectColumn];
/** aggregate stddev on columns */
export type AgenticSettingsEntityReviewSuggestionsStddevFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_stddev_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsStddevOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AgenticSettingsEntityReviewSuggestionsStddevPopFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_stddev_pop_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsStddevPopOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AgenticSettingsEntityReviewSuggestionsStddevSampFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_stddev_samp_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsStddevSampOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgenticSettingsEntityReviewSuggestionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgenticSettingsEntityReviewSuggestionsStreamCursorValueInput = {
  applied_to_entity_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  created_by_session_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  op_type?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<Scalars['jsonb']>;
  proposed_entity_key?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  reviewed_entity_id?: InputMaybe<Scalars['uuid']>;
  reviewed_entity_version_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AgenticSettingsEntityReviewSuggestionsSumFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_sum_fields';
  index?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsSumOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AgenticSettingsEntityReviewSuggestionsVarPopFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_var_pop_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsVarPopOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AgenticSettingsEntityReviewSuggestionsVarSampFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_var_samp_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsVarSampOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AgenticSettingsEntityReviewSuggestionsVarianceFields = {
  __typename?: 'agentic_settings_entity_review_suggestions_variance_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agentic_settings_entity_review_suggestions" */
export type AgenticSettingsEntityReviewSuggestionsVarianceOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "agentic_settings_entity_reviews" */
export type AgenticSettingsEntityReviews = {
  __typename?: 'agentic_settings_entity_reviews';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  llm_chat_interaction_id: Scalars['uuid'];
  /** An array relationship */
  suggestions: Array<AgenticSettingsEntityReviewSuggestions>;
  /** An aggregate relationship */
  suggestions_aggregate: AgenticSettingsEntityReviewSuggestionsAggregate;
  summary: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "agentic_settings_entity_reviews" */
export type AgenticSettingsEntityReviewsSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


/** columns and relationships of "agentic_settings_entity_reviews" */
export type AgenticSettingsEntityReviewsSuggestionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};

/** Boolean expression to filter rows from the table "agentic_settings_entity_reviews". All fields are combined with a logical 'AND'. */
export type AgenticSettingsEntityReviewsBoolExp = {
  _and?: InputMaybe<Array<AgenticSettingsEntityReviewsBoolExp>>;
  _not?: InputMaybe<AgenticSettingsEntityReviewsBoolExp>;
  _or?: InputMaybe<Array<AgenticSettingsEntityReviewsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  suggestions?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
  suggestions_aggregate?: InputMaybe<AgenticSettingsEntityReviewSuggestionsAggregateBoolExp>;
  summary?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "agentic_settings_entity_reviews". */
export type AgenticSettingsEntityReviewsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_interaction_id?: InputMaybe<OrderBy>;
  suggestions_aggregate?: InputMaybe<AgenticSettingsEntityReviewSuggestionsAggregateOrderBy>;
  summary?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "agentic_settings_entity_reviews" */
export const AgenticSettingsEntityReviewsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatInteractionId: 'llm_chat_interaction_id',
  /** column name */
  Summary: 'summary',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgenticSettingsEntityReviewsSelectColumn = typeof AgenticSettingsEntityReviewsSelectColumn[keyof typeof AgenticSettingsEntityReviewsSelectColumn];
/** Streaming cursor of the table "agentic_settings_entity_reviews" */
export type AgenticSettingsEntityReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgenticSettingsEntityReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgenticSettingsEntityReviewsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  summary?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "agentic_settings" */
export type AgenticSettingsInsertInput = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "agentic_settings" */
export type AgenticSettingsMutationResponse = {
  __typename?: 'agentic_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AgenticSettings>;
};

/** on_conflict condition type for table "agentic_settings" */
export type AgenticSettingsOnConflict = {
  constraint: AgenticSettingsConstraint;
  update_columns?: Array<AgenticSettingsUpdateColumn>;
  where?: InputMaybe<AgenticSettingsBoolExp>;
};

/** Ordering options when selecting data from "agentic_settings". */
export type AgenticSettingsOrderBy = {
  active_inference_backend?: InputMaybe<LlmInferenceBackendsOrderBy>;
  active_inference_backend_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  settings?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agentic_settings */
export type AgenticSettingsPkColumnsInput = {
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AgenticSettingsPrependInput = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "agentic_settings" */
export const AgenticSettingsSelectColumn = {
  /** column name */
  ActiveInferenceBackendId: 'active_inference_backend_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Settings: 'settings',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AgenticSettingsSelectColumn = typeof AgenticSettingsSelectColumn[keyof typeof AgenticSettingsSelectColumn];
/** input type for updating data in table "agentic_settings" */
export type AgenticSettingsSetInput = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "agentic_settings" */
export type AgenticSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgenticSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgenticSettingsStreamCursorValueInput = {
  active_inference_backend_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "agentic_settings" */
export const AgenticSettingsUpdateColumn = {
  /** column name */
  Settings: 'settings'
} as const;

export type AgenticSettingsUpdateColumn = typeof AgenticSettingsUpdateColumn[keyof typeof AgenticSettingsUpdateColumn];
export type AgenticSettingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AgenticSettingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AgenticSettingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AgenticSettingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AgenticSettingsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AgenticSettingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgenticSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: AgenticSettingsBoolExp;
};

/** columns and relationships of "airbyte_syncs" */
export type AirbyteSyncs = {
  __typename?: 'airbyte_syncs';
  airbyte_destination_id: Scalars['String'];
  airbyte_source_id: Scalars['String'];
  airbyte_sync_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  hightouch_destination_id: Scalars['bigint'];
  hightouch_destination_type: Scalars['String'];
  id: Scalars['uuid'];
  last_run_completed_at?: Maybe<Scalars['timestamptz']>;
  schema_name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "airbyte_syncs". All fields are combined with a logical 'AND'. */
export type AirbyteSyncsBoolExp = {
  _and?: InputMaybe<Array<AirbyteSyncsBoolExp>>;
  _not?: InputMaybe<AirbyteSyncsBoolExp>;
  _or?: InputMaybe<Array<AirbyteSyncsBoolExp>>;
  airbyte_destination_id?: InputMaybe<StringComparisonExp>;
  airbyte_source_id?: InputMaybe<StringComparisonExp>;
  airbyte_sync_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  hightouch_destination_id?: InputMaybe<BigintComparisonExp>;
  hightouch_destination_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_run_completed_at?: InputMaybe<TimestamptzComparisonExp>;
  schema_name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "airbyte_syncs". */
export type AirbyteSyncsOrderBy = {
  airbyte_destination_id?: InputMaybe<OrderBy>;
  airbyte_source_id?: InputMaybe<OrderBy>;
  airbyte_sync_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  hightouch_destination_id?: InputMaybe<OrderBy>;
  hightouch_destination_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_completed_at?: InputMaybe<OrderBy>;
  schema_name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "airbyte_syncs" */
export const AirbyteSyncsSelectColumn = {
  /** column name */
  AirbyteDestinationId: 'airbyte_destination_id',
  /** column name */
  AirbyteSourceId: 'airbyte_source_id',
  /** column name */
  AirbyteSyncId: 'airbyte_sync_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  HightouchDestinationId: 'hightouch_destination_id',
  /** column name */
  HightouchDestinationType: 'hightouch_destination_type',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunCompletedAt: 'last_run_completed_at',
  /** column name */
  SchemaName: 'schema_name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AirbyteSyncsSelectColumn = typeof AirbyteSyncsSelectColumn[keyof typeof AirbyteSyncsSelectColumn];
/** Streaming cursor of the table "airbyte_syncs" */
export type AirbyteSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AirbyteSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AirbyteSyncsStreamCursorValueInput = {
  airbyte_destination_id?: InputMaybe<Scalars['String']>;
  airbyte_source_id?: InputMaybe<Scalars['String']>;
  airbyte_sync_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hightouch_destination_id?: InputMaybe<Scalars['bigint']>;
  hightouch_destination_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_run_completed_at?: InputMaybe<Scalars['timestamptz']>;
  schema_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "alert_instances" */
export type AlertInstances = {
  __typename?: 'alert_instances';
  /** An object relationship */
  alert: Alerts;
  alert_id: Scalars['bigint'];
  alert_on_success?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  fatal_error?: Maybe<Scalars['Boolean']>;
  row_error?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  sync_template?: Maybe<SyncTemplates>;
  sync_template_id?: Maybe<Scalars['Int']>;
};

/** order by aggregate values of table "alert_instances" */
export type AlertInstancesAggregateOrderBy = {
  avg?: InputMaybe<AlertInstancesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AlertInstancesMaxOrderBy>;
  min?: InputMaybe<AlertInstancesMinOrderBy>;
  stddev?: InputMaybe<AlertInstancesStddevOrderBy>;
  stddev_pop?: InputMaybe<AlertInstancesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AlertInstancesStddevSampOrderBy>;
  sum?: InputMaybe<AlertInstancesSumOrderBy>;
  var_pop?: InputMaybe<AlertInstancesVarPopOrderBy>;
  var_samp?: InputMaybe<AlertInstancesVarSampOrderBy>;
  variance?: InputMaybe<AlertInstancesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "alert_instances" */
export type AlertInstancesArrRelInsertInput = {
  data: Array<AlertInstancesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AlertInstancesOnConflict>;
};

/** order by avg() on columns of table "alert_instances" */
export type AlertInstancesAvgOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "alert_instances". All fields are combined with a logical 'AND'. */
export type AlertInstancesBoolExp = {
  _and?: InputMaybe<Array<AlertInstancesBoolExp>>;
  _not?: InputMaybe<AlertInstancesBoolExp>;
  _or?: InputMaybe<Array<AlertInstancesBoolExp>>;
  alert?: InputMaybe<AlertsBoolExp>;
  alert_id?: InputMaybe<BigintComparisonExp>;
  alert_on_success?: InputMaybe<BooleanComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  fatal_error?: InputMaybe<BooleanComparisonExp>;
  row_error?: InputMaybe<BooleanComparisonExp>;
  sync_template?: InputMaybe<SyncTemplatesBoolExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "alert_instances" */
export const AlertInstancesConstraint = {
  /** unique or primary key constraint on columns "id" */
  AlertInstancesPkey: 'alert_instances_pkey',
  /** unique or primary key constraint on columns "destination_instance_id", "alert_id" */
  DestinationInstanceUnique: 'destination_instance_unique',
  /** unique or primary key constraint on columns "sync_template_id", "alert_id" */
  SyncTemplateUnique: 'sync_template_unique'
} as const;

export type AlertInstancesConstraint = typeof AlertInstancesConstraint[keyof typeof AlertInstancesConstraint];
/** input type for inserting data into table "alert_instances" */
export type AlertInstancesInsertInput = {
  alert?: InputMaybe<AlertsObjRelInsertInput>;
  alert_id?: InputMaybe<Scalars['bigint']>;
  alert_on_success?: InputMaybe<Scalars['Boolean']>;
  destination_instance?: InputMaybe<DestinationInstancesObjRelInsertInput>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  fatal_error?: InputMaybe<Scalars['Boolean']>;
  row_error?: InputMaybe<Scalars['Boolean']>;
  sync_template?: InputMaybe<SyncTemplatesObjRelInsertInput>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "alert_instances" */
export type AlertInstancesMaxOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "alert_instances" */
export type AlertInstancesMinOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "alert_instances" */
export type AlertInstancesMutationResponse = {
  __typename?: 'alert_instances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AlertInstances>;
};

/** on_conflict condition type for table "alert_instances" */
export type AlertInstancesOnConflict = {
  constraint: AlertInstancesConstraint;
  update_columns?: Array<AlertInstancesUpdateColumn>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};

/** Ordering options when selecting data from "alert_instances". */
export type AlertInstancesOrderBy = {
  alert?: InputMaybe<AlertsOrderBy>;
  alert_id?: InputMaybe<OrderBy>;
  alert_on_success?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  fatal_error?: InputMaybe<OrderBy>;
  row_error?: InputMaybe<OrderBy>;
  sync_template?: InputMaybe<SyncTemplatesOrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** select columns of table "alert_instances" */
export const AlertInstancesSelectColumn = {
  /** column name */
  AlertId: 'alert_id',
  /** column name */
  AlertOnSuccess: 'alert_on_success',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  RowError: 'row_error',
  /** column name */
  SyncTemplateId: 'sync_template_id'
} as const;

export type AlertInstancesSelectColumn = typeof AlertInstancesSelectColumn[keyof typeof AlertInstancesSelectColumn];
/** input type for updating data in table "alert_instances" */
export type AlertInstancesSetInput = {
  alert_on_success?: InputMaybe<Scalars['Boolean']>;
  fatal_error?: InputMaybe<Scalars['Boolean']>;
  row_error?: InputMaybe<Scalars['Boolean']>;
};

/** order by stddev() on columns of table "alert_instances" */
export type AlertInstancesStddevOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "alert_instances" */
export type AlertInstancesStddevPopOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "alert_instances" */
export type AlertInstancesStddevSampOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "alert_instances" */
export type AlertInstancesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AlertInstancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AlertInstancesStreamCursorValueInput = {
  alert_id?: InputMaybe<Scalars['bigint']>;
  alert_on_success?: InputMaybe<Scalars['Boolean']>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  fatal_error?: InputMaybe<Scalars['Boolean']>;
  row_error?: InputMaybe<Scalars['Boolean']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "alert_instances" */
export type AlertInstancesSumOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** update columns of table "alert_instances" */
export const AlertInstancesUpdateColumn = {
  /** column name */
  AlertOnSuccess: 'alert_on_success',
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  RowError: 'row_error'
} as const;

export type AlertInstancesUpdateColumn = typeof AlertInstancesUpdateColumn[keyof typeof AlertInstancesUpdateColumn];
export type AlertInstancesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AlertInstancesSetInput>;
  /** filter the rows which have to be updated */
  where: AlertInstancesBoolExp;
};

/** order by var_pop() on columns of table "alert_instances" */
export type AlertInstancesVarPopOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "alert_instances" */
export type AlertInstancesVarSampOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "alert_instances" */
export type AlertInstancesVarianceOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "alert_statuses" */
export type AlertStatuses = {
  __typename?: 'alert_statuses';
  /** An object relationship */
  alert: Alerts;
  alert_id: Scalars['bigint'];
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  error?: Maybe<Scalars['jsonb']>;
  last_attempted: Scalars['timestamptz'];
};


/** columns and relationships of "alert_statuses" */
export type AlertStatusesErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "alert_statuses" */
export type AlertStatusesAggregateOrderBy = {
  avg?: InputMaybe<AlertStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AlertStatusesMaxOrderBy>;
  min?: InputMaybe<AlertStatusesMinOrderBy>;
  stddev?: InputMaybe<AlertStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<AlertStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AlertStatusesStddevSampOrderBy>;
  sum?: InputMaybe<AlertStatusesSumOrderBy>;
  var_pop?: InputMaybe<AlertStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<AlertStatusesVarSampOrderBy>;
  variance?: InputMaybe<AlertStatusesVarianceOrderBy>;
};

/** order by avg() on columns of table "alert_statuses" */
export type AlertStatusesAvgOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "alert_statuses". All fields are combined with a logical 'AND'. */
export type AlertStatusesBoolExp = {
  _and?: InputMaybe<Array<AlertStatusesBoolExp>>;
  _not?: InputMaybe<AlertStatusesBoolExp>;
  _or?: InputMaybe<Array<AlertStatusesBoolExp>>;
  alert?: InputMaybe<AlertsBoolExp>;
  alert_id?: InputMaybe<BigintComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  last_attempted?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "alert_statuses" */
export type AlertStatusesMaxOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  last_attempted?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "alert_statuses" */
export type AlertStatusesMinOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  last_attempted?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "alert_statuses". */
export type AlertStatusesOrderBy = {
  alert?: InputMaybe<AlertsOrderBy>;
  alert_id?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  last_attempted?: InputMaybe<OrderBy>;
};

/** select columns of table "alert_statuses" */
export const AlertStatusesSelectColumn = {
  /** column name */
  AlertId: 'alert_id',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  Error: 'error',
  /** column name */
  LastAttempted: 'last_attempted'
} as const;

export type AlertStatusesSelectColumn = typeof AlertStatusesSelectColumn[keyof typeof AlertStatusesSelectColumn];
/** order by stddev() on columns of table "alert_statuses" */
export type AlertStatusesStddevOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "alert_statuses" */
export type AlertStatusesStddevPopOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "alert_statuses" */
export type AlertStatusesStddevSampOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "alert_statuses" */
export type AlertStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AlertStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AlertStatusesStreamCursorValueInput = {
  alert_id?: InputMaybe<Scalars['bigint']>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  error?: InputMaybe<Scalars['jsonb']>;
  last_attempted?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "alert_statuses" */
export type AlertStatusesSumOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "alert_statuses" */
export type AlertStatusesVarPopOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "alert_statuses" */
export type AlertStatusesVarSampOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "alert_statuses" */
export type AlertStatusesVarianceOrderBy = {
  alert_id?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "alerts" */
export type Alerts = {
  __typename?: 'alerts';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  alert_interval?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  config: Scalars['jsonb'];
  created_by?: Maybe<Scalars['bigint']>;
  fatal_error_default: Scalars['Boolean'];
  id: Scalars['bigint'];
  name: Scalars['name'];
  on_success_default?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  pagerduty_credential?: Maybe<PagerdutyCredentials>;
  pagerduty_credential_id?: Maybe<Scalars['bigint']>;
  row_error_default: Scalars['Boolean'];
  /** An object relationship */
  slack_credential?: Maybe<SlackCredentials>;
  slack_credential_id?: Maybe<Scalars['bigint']>;
  type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "alerts" */
export type AlertsAlertInstancesArgs = {
  distinct_on?: InputMaybe<Array<AlertInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertInstancesOrderBy>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "alerts" */
export type AlertsAlertStatusesArgs = {
  distinct_on?: InputMaybe<Array<AlertStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertStatusesOrderBy>>;
  where?: InputMaybe<AlertStatusesBoolExp>;
};


/** columns and relationships of "alerts" */
export type AlertsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AlertsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "alerts". All fields are combined with a logical 'AND'. */
export type AlertsBoolExp = {
  _and?: InputMaybe<Array<AlertsBoolExp>>;
  _not?: InputMaybe<AlertsBoolExp>;
  _or?: InputMaybe<Array<AlertsBoolExp>>;
  alert_instances?: InputMaybe<AlertInstancesBoolExp>;
  alert_interval?: InputMaybe<BigintComparisonExp>;
  alert_statuses?: InputMaybe<AlertStatusesBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  fatal_error_default?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<NameComparisonExp>;
  on_success_default?: InputMaybe<BooleanComparisonExp>;
  pagerduty_credential?: InputMaybe<PagerdutyCredentialsBoolExp>;
  pagerduty_credential_id?: InputMaybe<BigintComparisonExp>;
  row_error_default?: InputMaybe<BooleanComparisonExp>;
  slack_credential?: InputMaybe<SlackCredentialsBoolExp>;
  slack_credential_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "alerts" */
export const AlertsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AlertsIdWorkspaceIdKey: 'alerts_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AlertsPkey: 'alerts_pkey'
} as const;

export type AlertsConstraint = typeof AlertsConstraint[keyof typeof AlertsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AlertsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AlertsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AlertsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "alerts" */
export type AlertsIncInput = {
  alert_interval?: InputMaybe<Scalars['bigint']>;
  pagerduty_credential_id?: InputMaybe<Scalars['bigint']>;
  slack_credential_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "alerts" */
export type AlertsInsertInput = {
  alert_instances?: InputMaybe<AlertInstancesArrRelInsertInput>;
  alert_interval?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  fatal_error_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['name']>;
  on_success_default?: InputMaybe<Scalars['Boolean']>;
  pagerduty_credential?: InputMaybe<PagerdutyCredentialsObjRelInsertInput>;
  pagerduty_credential_id?: InputMaybe<Scalars['bigint']>;
  row_error_default?: InputMaybe<Scalars['Boolean']>;
  slack_credential_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "alerts" */
export type AlertsMutationResponse = {
  __typename?: 'alerts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alerts>;
};

/** input type for inserting object relation for remote table "alerts" */
export type AlertsObjRelInsertInput = {
  data: AlertsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AlertsOnConflict>;
};

/** on_conflict condition type for table "alerts" */
export type AlertsOnConflict = {
  constraint: AlertsConstraint;
  update_columns?: Array<AlertsUpdateColumn>;
  where?: InputMaybe<AlertsBoolExp>;
};

/** Ordering options when selecting data from "alerts". */
export type AlertsOrderBy = {
  alert_instances_aggregate?: InputMaybe<AlertInstancesAggregateOrderBy>;
  alert_interval?: InputMaybe<OrderBy>;
  alert_statuses_aggregate?: InputMaybe<AlertStatusesAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  fatal_error_default?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  on_success_default?: InputMaybe<OrderBy>;
  pagerduty_credential?: InputMaybe<PagerdutyCredentialsOrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_error_default?: InputMaybe<OrderBy>;
  slack_credential?: InputMaybe<SlackCredentialsOrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: alerts */
export type AlertsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AlertsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "alerts" */
export const AlertsSelectColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FatalErrorDefault: 'fatal_error_default',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OnSuccessDefault: 'on_success_default',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowErrorDefault: 'row_error_default',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AlertsSelectColumn = typeof AlertsSelectColumn[keyof typeof AlertsSelectColumn];
/** input type for updating data in table "alerts" */
export type AlertsSetInput = {
  alert_interval?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  fatal_error_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['name']>;
  on_success_default?: InputMaybe<Scalars['Boolean']>;
  pagerduty_credential_id?: InputMaybe<Scalars['bigint']>;
  row_error_default?: InputMaybe<Scalars['Boolean']>;
  slack_credential_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "alerts" */
export type AlertsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AlertsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AlertsStreamCursorValueInput = {
  alert_interval?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  fatal_error_default?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['name']>;
  on_success_default?: InputMaybe<Scalars['Boolean']>;
  pagerduty_credential_id?: InputMaybe<Scalars['bigint']>;
  row_error_default?: InputMaybe<Scalars['Boolean']>;
  slack_credential_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "alerts" */
export const AlertsUpdateColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  Config: 'config',
  /** column name */
  FatalErrorDefault: 'fatal_error_default',
  /** column name */
  Name: 'name',
  /** column name */
  OnSuccessDefault: 'on_success_default',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowErrorDefault: 'row_error_default',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  Type: 'type'
} as const;

export type AlertsUpdateColumn = typeof AlertsUpdateColumn[keyof typeof AlertsUpdateColumn];
export type AlertsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AlertsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AlertsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AlertsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AlertsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AlertsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AlertsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AlertsSetInput>;
  /** filter the rows which have to be updated */
  where: AlertsBoolExp;
};

/** columns and relationships of "all_memberships_v2" */
export type AllMembershipsV2 = {
  __typename?: 'all_memberships_v2';
  /** An array relationship */
  memberships: Array<WorkspaceMembers>;
  /** An aggregate relationship */
  memberships_aggregate: WorkspaceMembersAggregate;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "all_memberships_v2" */
export type AllMembershipsV2MembershipsArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


/** columns and relationships of "all_memberships_v2" */
export type AllMembershipsV2MembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};

/** aggregated selection of "all_memberships_v2" */
export type AllMembershipsV2Aggregate = {
  __typename?: 'all_memberships_v2_aggregate';
  aggregate?: Maybe<AllMembershipsV2AggregateFields>;
  nodes: Array<AllMembershipsV2>;
};

export type AllMembershipsV2AggregateBoolExp = {
  count?: InputMaybe<AllMembershipsV2AggregateBoolExpCount>;
};

export type AllMembershipsV2AggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AllMembershipsV2BoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "all_memberships_v2" */
export type AllMembershipsV2AggregateFields = {
  __typename?: 'all_memberships_v2_aggregate_fields';
  avg?: Maybe<AllMembershipsV2AvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AllMembershipsV2MaxFields>;
  min?: Maybe<AllMembershipsV2MinFields>;
  stddev?: Maybe<AllMembershipsV2StddevFields>;
  stddev_pop?: Maybe<AllMembershipsV2StddevPopFields>;
  stddev_samp?: Maybe<AllMembershipsV2StddevSampFields>;
  sum?: Maybe<AllMembershipsV2SumFields>;
  var_pop?: Maybe<AllMembershipsV2VarPopFields>;
  var_samp?: Maybe<AllMembershipsV2VarSampFields>;
  variance?: Maybe<AllMembershipsV2VarianceFields>;
};


/** aggregate fields of "all_memberships_v2" */
export type AllMembershipsV2AggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "all_memberships_v2" */
export type AllMembershipsV2AggregateOrderBy = {
  avg?: InputMaybe<AllMembershipsV2AvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AllMembershipsV2MaxOrderBy>;
  min?: InputMaybe<AllMembershipsV2MinOrderBy>;
  stddev?: InputMaybe<AllMembershipsV2StddevOrderBy>;
  stddev_pop?: InputMaybe<AllMembershipsV2StddevPopOrderBy>;
  stddev_samp?: InputMaybe<AllMembershipsV2StddevSampOrderBy>;
  sum?: InputMaybe<AllMembershipsV2SumOrderBy>;
  var_pop?: InputMaybe<AllMembershipsV2VarPopOrderBy>;
  var_samp?: InputMaybe<AllMembershipsV2VarSampOrderBy>;
  variance?: InputMaybe<AllMembershipsV2VarianceOrderBy>;
};

/** aggregate avg on columns */
export type AllMembershipsV2AvgFields = {
  __typename?: 'all_memberships_v2_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "all_memberships_v2" */
export type AllMembershipsV2AvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "all_memberships_v2". All fields are combined with a logical 'AND'. */
export type AllMembershipsV2BoolExp = {
  _and?: InputMaybe<Array<AllMembershipsV2BoolExp>>;
  _not?: InputMaybe<AllMembershipsV2BoolExp>;
  _or?: InputMaybe<Array<AllMembershipsV2BoolExp>>;
  memberships?: InputMaybe<WorkspaceMembersBoolExp>;
  memberships_aggregate?: InputMaybe<WorkspaceMembersAggregateBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AllMembershipsV2MaxFields = {
  __typename?: 'all_memberships_v2_max_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "all_memberships_v2" */
export type AllMembershipsV2MaxOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AllMembershipsV2MinFields = {
  __typename?: 'all_memberships_v2_min_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "all_memberships_v2" */
export type AllMembershipsV2MinOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "all_memberships_v2". */
export type AllMembershipsV2OrderBy = {
  memberships_aggregate?: InputMaybe<WorkspaceMembersAggregateOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "all_memberships_v2" */
export const AllMembershipsV2SelectColumn = {
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AllMembershipsV2SelectColumn = typeof AllMembershipsV2SelectColumn[keyof typeof AllMembershipsV2SelectColumn];
/** aggregate stddev on columns */
export type AllMembershipsV2StddevFields = {
  __typename?: 'all_memberships_v2_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "all_memberships_v2" */
export type AllMembershipsV2StddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AllMembershipsV2StddevPopFields = {
  __typename?: 'all_memberships_v2_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "all_memberships_v2" */
export type AllMembershipsV2StddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AllMembershipsV2StddevSampFields = {
  __typename?: 'all_memberships_v2_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "all_memberships_v2" */
export type AllMembershipsV2StddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "all_memberships_v2" */
export type AllMembershipsV2StreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AllMembershipsV2StreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AllMembershipsV2StreamCursorValueInput = {
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AllMembershipsV2SumFields = {
  __typename?: 'all_memberships_v2_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "all_memberships_v2" */
export type AllMembershipsV2SumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AllMembershipsV2VarPopFields = {
  __typename?: 'all_memberships_v2_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "all_memberships_v2" */
export type AllMembershipsV2VarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AllMembershipsV2VarSampFields = {
  __typename?: 'all_memberships_v2_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "all_memberships_v2" */
export type AllMembershipsV2VarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AllMembershipsV2VarianceFields = {
  __typename?: 'all_memberships_v2_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "all_memberships_v2" */
export type AllMembershipsV2VarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_action_calls" */
export type AmpActionCalls = {
  __typename?: 'amp_action_calls';
  /** An object relationship */
  action?: Maybe<AmpActions>;
  action_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  payload: Scalars['jsonb'];
  seq: Scalars['Int'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_action_calls" */
export type AmpActionCallsPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_action_calls" */
export type AmpActionCallsAggregate = {
  __typename?: 'amp_action_calls_aggregate';
  aggregate?: Maybe<AmpActionCallsAggregateFields>;
  nodes: Array<AmpActionCalls>;
};

export type AmpActionCallsAggregateBoolExp = {
  count?: InputMaybe<AmpActionCallsAggregateBoolExpCount>;
};

export type AmpActionCallsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpActionCallsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_action_calls" */
export type AmpActionCallsAggregateFields = {
  __typename?: 'amp_action_calls_aggregate_fields';
  avg?: Maybe<AmpActionCallsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpActionCallsMaxFields>;
  min?: Maybe<AmpActionCallsMinFields>;
  stddev?: Maybe<AmpActionCallsStddevFields>;
  stddev_pop?: Maybe<AmpActionCallsStddevPopFields>;
  stddev_samp?: Maybe<AmpActionCallsStddevSampFields>;
  sum?: Maybe<AmpActionCallsSumFields>;
  var_pop?: Maybe<AmpActionCallsVarPopFields>;
  var_samp?: Maybe<AmpActionCallsVarSampFields>;
  variance?: Maybe<AmpActionCallsVarianceFields>;
};


/** aggregate fields of "amp_action_calls" */
export type AmpActionCallsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_action_calls" */
export type AmpActionCallsAggregateOrderBy = {
  avg?: InputMaybe<AmpActionCallsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpActionCallsMaxOrderBy>;
  min?: InputMaybe<AmpActionCallsMinOrderBy>;
  stddev?: InputMaybe<AmpActionCallsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpActionCallsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpActionCallsStddevSampOrderBy>;
  sum?: InputMaybe<AmpActionCallsSumOrderBy>;
  var_pop?: InputMaybe<AmpActionCallsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpActionCallsVarSampOrderBy>;
  variance?: InputMaybe<AmpActionCallsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpActionCallsAvgFields = {
  __typename?: 'amp_action_calls_avg_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_action_calls" */
export type AmpActionCallsAvgOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_action_calls". All fields are combined with a logical 'AND'. */
export type AmpActionCallsBoolExp = {
  _and?: InputMaybe<Array<AmpActionCallsBoolExp>>;
  _not?: InputMaybe<AmpActionCallsBoolExp>;
  _or?: InputMaybe<Array<AmpActionCallsBoolExp>>;
  action?: InputMaybe<AmpActionsBoolExp>;
  action_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpActionCallsMaxFields = {
  __typename?: 'amp_action_calls_max_fields';
  action_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_action_calls" */
export type AmpActionCallsMaxOrderBy = {
  action_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpActionCallsMinFields = {
  __typename?: 'amp_action_calls_min_fields';
  action_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_action_calls" */
export type AmpActionCallsMinOrderBy = {
  action_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_action_calls". */
export type AmpActionCallsOrderBy = {
  action?: InputMaybe<AmpActionsOrderBy>;
  action_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_action_calls" */
export const AmpActionCallsSelectColumn = {
  /** column name */
  ActionId: 'action_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  Payload: 'payload',
  /** column name */
  Seq: 'seq',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpActionCallsSelectColumn = typeof AmpActionCallsSelectColumn[keyof typeof AmpActionCallsSelectColumn];
/** aggregate stddev on columns */
export type AmpActionCallsStddevFields = {
  __typename?: 'amp_action_calls_stddev_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_action_calls" */
export type AmpActionCallsStddevOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpActionCallsStddevPopFields = {
  __typename?: 'amp_action_calls_stddev_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_action_calls" */
export type AmpActionCallsStddevPopOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpActionCallsStddevSampFields = {
  __typename?: 'amp_action_calls_stddev_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_action_calls" */
export type AmpActionCallsStddevSampOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_action_calls" */
export type AmpActionCallsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpActionCallsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpActionCallsStreamCursorValueInput = {
  action_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  seq?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpActionCallsSumFields = {
  __typename?: 'amp_action_calls_sum_fields';
  destination_id?: Maybe<Scalars['bigint']>;
  seq?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_action_calls" */
export type AmpActionCallsSumOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpActionCallsVarPopFields = {
  __typename?: 'amp_action_calls_var_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_action_calls" */
export type AmpActionCallsVarPopOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpActionCallsVarSampFields = {
  __typename?: 'amp_action_calls_var_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_action_calls" */
export type AmpActionCallsVarSampOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpActionCallsVarianceFields = {
  __typename?: 'amp_action_calls_variance_fields';
  destination_id?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_action_calls" */
export type AmpActionCallsVarianceOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_action_plan_versions" */
export type AmpActionPlanVersions = {
  __typename?: 'amp_action_plan_versions';
  /** An object relationship */
  amp_action_plan?: Maybe<AmpActionPlans>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  plan: Scalars['jsonb'];
  plan_id: Scalars['uuid'];
  tool_call_id: Scalars['String'];
  /** An array relationship */
  tool_calls: Array<AmpActionToolCalls>;
  /** An aggregate relationship */
  tool_calls_aggregate: AmpActionToolCallsAggregate;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_action_plan_versions" */
export type AmpActionPlanVersionsPlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_action_plan_versions" */
export type AmpActionPlanVersionsToolCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


/** columns and relationships of "amp_action_plan_versions" */
export type AmpActionPlanVersionsToolCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};

/** aggregated selection of "amp_action_plan_versions" */
export type AmpActionPlanVersionsAggregate = {
  __typename?: 'amp_action_plan_versions_aggregate';
  aggregate?: Maybe<AmpActionPlanVersionsAggregateFields>;
  nodes: Array<AmpActionPlanVersions>;
};

export type AmpActionPlanVersionsAggregateBoolExp = {
  count?: InputMaybe<AmpActionPlanVersionsAggregateBoolExpCount>;
};

export type AmpActionPlanVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpActionPlanVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_action_plan_versions" */
export type AmpActionPlanVersionsAggregateFields = {
  __typename?: 'amp_action_plan_versions_aggregate_fields';
  avg?: Maybe<AmpActionPlanVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpActionPlanVersionsMaxFields>;
  min?: Maybe<AmpActionPlanVersionsMinFields>;
  stddev?: Maybe<AmpActionPlanVersionsStddevFields>;
  stddev_pop?: Maybe<AmpActionPlanVersionsStddevPopFields>;
  stddev_samp?: Maybe<AmpActionPlanVersionsStddevSampFields>;
  sum?: Maybe<AmpActionPlanVersionsSumFields>;
  var_pop?: Maybe<AmpActionPlanVersionsVarPopFields>;
  var_samp?: Maybe<AmpActionPlanVersionsVarSampFields>;
  variance?: Maybe<AmpActionPlanVersionsVarianceFields>;
};


/** aggregate fields of "amp_action_plan_versions" */
export type AmpActionPlanVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsAggregateOrderBy = {
  avg?: InputMaybe<AmpActionPlanVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpActionPlanVersionsMaxOrderBy>;
  min?: InputMaybe<AmpActionPlanVersionsMinOrderBy>;
  stddev?: InputMaybe<AmpActionPlanVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpActionPlanVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpActionPlanVersionsStddevSampOrderBy>;
  sum?: InputMaybe<AmpActionPlanVersionsSumOrderBy>;
  var_pop?: InputMaybe<AmpActionPlanVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpActionPlanVersionsVarSampOrderBy>;
  variance?: InputMaybe<AmpActionPlanVersionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpActionPlanVersionsAvgFields = {
  __typename?: 'amp_action_plan_versions_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_action_plan_versions". All fields are combined with a logical 'AND'. */
export type AmpActionPlanVersionsBoolExp = {
  _and?: InputMaybe<Array<AmpActionPlanVersionsBoolExp>>;
  _not?: InputMaybe<AmpActionPlanVersionsBoolExp>;
  _or?: InputMaybe<Array<AmpActionPlanVersionsBoolExp>>;
  amp_action_plan?: InputMaybe<AmpActionPlansBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  plan?: InputMaybe<JsonbComparisonExp>;
  plan_id?: InputMaybe<UuidComparisonExp>;
  tool_call_id?: InputMaybe<StringComparisonExp>;
  tool_calls?: InputMaybe<AmpActionToolCallsBoolExp>;
  tool_calls_aggregate?: InputMaybe<AmpActionToolCallsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpActionPlanVersionsMaxFields = {
  __typename?: 'amp_action_plan_versions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plan_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  plan_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpActionPlanVersionsMinFields = {
  __typename?: 'amp_action_plan_versions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  plan_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  plan_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_action_plan_versions". */
export type AmpActionPlanVersionsOrderBy = {
  amp_action_plan?: InputMaybe<AmpActionPlansOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  plan_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  tool_calls_aggregate?: InputMaybe<AmpActionToolCallsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_action_plan_versions" */
export const AmpActionPlanVersionsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Plan: 'plan',
  /** column name */
  PlanId: 'plan_id',
  /** column name */
  ToolCallId: 'tool_call_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpActionPlanVersionsSelectColumn = typeof AmpActionPlanVersionsSelectColumn[keyof typeof AmpActionPlanVersionsSelectColumn];
/** aggregate stddev on columns */
export type AmpActionPlanVersionsStddevFields = {
  __typename?: 'amp_action_plan_versions_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpActionPlanVersionsStddevPopFields = {
  __typename?: 'amp_action_plan_versions_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpActionPlanVersionsStddevSampFields = {
  __typename?: 'amp_action_plan_versions_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_action_plan_versions" */
export type AmpActionPlanVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpActionPlanVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpActionPlanVersionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['jsonb']>;
  plan_id?: InputMaybe<Scalars['uuid']>;
  tool_call_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpActionPlanVersionsSumFields = {
  __typename?: 'amp_action_plan_versions_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpActionPlanVersionsVarPopFields = {
  __typename?: 'amp_action_plan_versions_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpActionPlanVersionsVarSampFields = {
  __typename?: 'amp_action_plan_versions_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpActionPlanVersionsVarianceFields = {
  __typename?: 'amp_action_plan_versions_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_action_plan_versions" */
export type AmpActionPlanVersionsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_action_plans" */
export type AmpActionPlans = {
  __typename?: 'amp_action_plans';
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  approved_by_user?: Maybe<Users>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id: Scalars['uuid'];
  plan: Scalars['jsonb'];
  tool_call_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  versions: Array<AmpActionPlanVersions>;
  /** An aggregate relationship */
  versions_aggregate: AmpActionPlanVersionsAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_action_plans" */
export type AmpActionPlansPlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_action_plans" */
export type AmpActionPlansVersionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


/** columns and relationships of "amp_action_plans" */
export type AmpActionPlansVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};

/** aggregated selection of "amp_action_plans" */
export type AmpActionPlansAggregate = {
  __typename?: 'amp_action_plans_aggregate';
  aggregate?: Maybe<AmpActionPlansAggregateFields>;
  nodes: Array<AmpActionPlans>;
};

export type AmpActionPlansAggregateBoolExp = {
  count?: InputMaybe<AmpActionPlansAggregateBoolExpCount>;
};

export type AmpActionPlansAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpActionPlansBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_action_plans" */
export type AmpActionPlansAggregateFields = {
  __typename?: 'amp_action_plans_aggregate_fields';
  avg?: Maybe<AmpActionPlansAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpActionPlansMaxFields>;
  min?: Maybe<AmpActionPlansMinFields>;
  stddev?: Maybe<AmpActionPlansStddevFields>;
  stddev_pop?: Maybe<AmpActionPlansStddevPopFields>;
  stddev_samp?: Maybe<AmpActionPlansStddevSampFields>;
  sum?: Maybe<AmpActionPlansSumFields>;
  var_pop?: Maybe<AmpActionPlansVarPopFields>;
  var_samp?: Maybe<AmpActionPlansVarSampFields>;
  variance?: Maybe<AmpActionPlansVarianceFields>;
};


/** aggregate fields of "amp_action_plans" */
export type AmpActionPlansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_action_plans" */
export type AmpActionPlansAggregateOrderBy = {
  avg?: InputMaybe<AmpActionPlansAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpActionPlansMaxOrderBy>;
  min?: InputMaybe<AmpActionPlansMinOrderBy>;
  stddev?: InputMaybe<AmpActionPlansStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpActionPlansStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpActionPlansStddevSampOrderBy>;
  sum?: InputMaybe<AmpActionPlansSumOrderBy>;
  var_pop?: InputMaybe<AmpActionPlansVarPopOrderBy>;
  var_samp?: InputMaybe<AmpActionPlansVarSampOrderBy>;
  variance?: InputMaybe<AmpActionPlansVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpActionPlansAvgFields = {
  __typename?: 'amp_action_plans_avg_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_action_plans" */
export type AmpActionPlansAvgOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_action_plans". All fields are combined with a logical 'AND'. */
export type AmpActionPlansBoolExp = {
  _and?: InputMaybe<Array<AmpActionPlansBoolExp>>;
  _not?: InputMaybe<AmpActionPlansBoolExp>;
  _or?: InputMaybe<Array<AmpActionPlansBoolExp>>;
  approved_at?: InputMaybe<TimestamptzComparisonExp>;
  approved_by?: InputMaybe<BigintComparisonExp>;
  approved_by_user?: InputMaybe<UsersBoolExp>;
  canceled_at?: InputMaybe<TimestamptzComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  plan?: InputMaybe<JsonbComparisonExp>;
  tool_call_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  versions?: InputMaybe<AmpActionPlanVersionsBoolExp>;
  versions_aggregate?: InputMaybe<AmpActionPlanVersionsAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpActionPlansMaxFields = {
  __typename?: 'amp_action_plans_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['bigint']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_action_plans" */
export type AmpActionPlansMaxOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  approved_by?: InputMaybe<OrderBy>;
  canceled_at?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpActionPlansMinFields = {
  __typename?: 'amp_action_plans_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  approved_by?: Maybe<Scalars['bigint']>;
  canceled_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_action_plans" */
export type AmpActionPlansMinOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  approved_by?: InputMaybe<OrderBy>;
  canceled_at?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_action_plans". */
export type AmpActionPlansOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  approved_by?: InputMaybe<OrderBy>;
  approved_by_user?: InputMaybe<UsersOrderBy>;
  canceled_at?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  versions_aggregate?: InputMaybe<AmpActionPlanVersionsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_action_plans" */
export const AmpActionPlansSelectColumn = {
  /** column name */
  ApprovedAt: 'approved_at',
  /** column name */
  ApprovedBy: 'approved_by',
  /** column name */
  CanceledAt: 'canceled_at',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Plan: 'plan',
  /** column name */
  ToolCallId: 'tool_call_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpActionPlansSelectColumn = typeof AmpActionPlansSelectColumn[keyof typeof AmpActionPlansSelectColumn];
/** aggregate stddev on columns */
export type AmpActionPlansStddevFields = {
  __typename?: 'amp_action_plans_stddev_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_action_plans" */
export type AmpActionPlansStddevOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpActionPlansStddevPopFields = {
  __typename?: 'amp_action_plans_stddev_pop_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_action_plans" */
export type AmpActionPlansStddevPopOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpActionPlansStddevSampFields = {
  __typename?: 'amp_action_plans_stddev_samp_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_action_plans" */
export type AmpActionPlansStddevSampOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_action_plans" */
export type AmpActionPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpActionPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpActionPlansStreamCursorValueInput = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  approved_by?: InputMaybe<Scalars['bigint']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['jsonb']>;
  tool_call_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpActionPlansSumFields = {
  __typename?: 'amp_action_plans_sum_fields';
  approved_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_action_plans" */
export type AmpActionPlansSumOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpActionPlansVarPopFields = {
  __typename?: 'amp_action_plans_var_pop_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_action_plans" */
export type AmpActionPlansVarPopOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpActionPlansVarSampFields = {
  __typename?: 'amp_action_plans_var_samp_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_action_plans" */
export type AmpActionPlansVarSampOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpActionPlansVarianceFields = {
  __typename?: 'amp_action_plans_variance_fields';
  approved_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_action_plans" */
export type AmpActionPlansVarianceOrderBy = {
  approved_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_action_tool_calls" */
export type AmpActionToolCalls = {
  __typename?: 'amp_action_tool_calls';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id: Scalars['uuid'];
  plan_tool_call_id: Scalars['String'];
  /** An object relationship */
  plan_version?: Maybe<AmpActionPlanVersions>;
  plan_version_id: Scalars['uuid'];
  tool_call_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_action_tool_calls" */
export type AmpActionToolCallsAggregate = {
  __typename?: 'amp_action_tool_calls_aggregate';
  aggregate?: Maybe<AmpActionToolCallsAggregateFields>;
  nodes: Array<AmpActionToolCalls>;
};

export type AmpActionToolCallsAggregateBoolExp = {
  count?: InputMaybe<AmpActionToolCallsAggregateBoolExpCount>;
};

export type AmpActionToolCallsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpActionToolCallsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_action_tool_calls" */
export type AmpActionToolCallsAggregateFields = {
  __typename?: 'amp_action_tool_calls_aggregate_fields';
  avg?: Maybe<AmpActionToolCallsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpActionToolCallsMaxFields>;
  min?: Maybe<AmpActionToolCallsMinFields>;
  stddev?: Maybe<AmpActionToolCallsStddevFields>;
  stddev_pop?: Maybe<AmpActionToolCallsStddevPopFields>;
  stddev_samp?: Maybe<AmpActionToolCallsStddevSampFields>;
  sum?: Maybe<AmpActionToolCallsSumFields>;
  var_pop?: Maybe<AmpActionToolCallsVarPopFields>;
  var_samp?: Maybe<AmpActionToolCallsVarSampFields>;
  variance?: Maybe<AmpActionToolCallsVarianceFields>;
};


/** aggregate fields of "amp_action_tool_calls" */
export type AmpActionToolCallsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_action_tool_calls" */
export type AmpActionToolCallsAggregateOrderBy = {
  avg?: InputMaybe<AmpActionToolCallsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpActionToolCallsMaxOrderBy>;
  min?: InputMaybe<AmpActionToolCallsMinOrderBy>;
  stddev?: InputMaybe<AmpActionToolCallsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpActionToolCallsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpActionToolCallsStddevSampOrderBy>;
  sum?: InputMaybe<AmpActionToolCallsSumOrderBy>;
  var_pop?: InputMaybe<AmpActionToolCallsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpActionToolCallsVarSampOrderBy>;
  variance?: InputMaybe<AmpActionToolCallsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpActionToolCallsAvgFields = {
  __typename?: 'amp_action_tool_calls_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_action_tool_calls". All fields are combined with a logical 'AND'. */
export type AmpActionToolCallsBoolExp = {
  _and?: InputMaybe<Array<AmpActionToolCallsBoolExp>>;
  _not?: InputMaybe<AmpActionToolCallsBoolExp>;
  _or?: InputMaybe<Array<AmpActionToolCallsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  plan_tool_call_id?: InputMaybe<StringComparisonExp>;
  plan_version?: InputMaybe<AmpActionPlanVersionsBoolExp>;
  plan_version_id?: InputMaybe<UuidComparisonExp>;
  tool_call_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpActionToolCallsMaxFields = {
  __typename?: 'amp_action_tool_calls_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  plan_tool_call_id?: Maybe<Scalars['String']>;
  plan_version_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  plan_tool_call_id?: InputMaybe<OrderBy>;
  plan_version_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpActionToolCallsMinFields = {
  __typename?: 'amp_action_tool_calls_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  plan_tool_call_id?: Maybe<Scalars['String']>;
  plan_version_id?: Maybe<Scalars['uuid']>;
  tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  plan_tool_call_id?: InputMaybe<OrderBy>;
  plan_version_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_action_tool_calls". */
export type AmpActionToolCallsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  plan_tool_call_id?: InputMaybe<OrderBy>;
  plan_version?: InputMaybe<AmpActionPlanVersionsOrderBy>;
  plan_version_id?: InputMaybe<OrderBy>;
  tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_action_tool_calls" */
export const AmpActionToolCallsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  PlanToolCallId: 'plan_tool_call_id',
  /** column name */
  PlanVersionId: 'plan_version_id',
  /** column name */
  ToolCallId: 'tool_call_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpActionToolCallsSelectColumn = typeof AmpActionToolCallsSelectColumn[keyof typeof AmpActionToolCallsSelectColumn];
/** aggregate stddev on columns */
export type AmpActionToolCallsStddevFields = {
  __typename?: 'amp_action_tool_calls_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpActionToolCallsStddevPopFields = {
  __typename?: 'amp_action_tool_calls_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpActionToolCallsStddevSampFields = {
  __typename?: 'amp_action_tool_calls_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_action_tool_calls" */
export type AmpActionToolCallsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpActionToolCallsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpActionToolCallsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  plan_tool_call_id?: InputMaybe<Scalars['String']>;
  plan_version_id?: InputMaybe<Scalars['uuid']>;
  tool_call_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpActionToolCallsSumFields = {
  __typename?: 'amp_action_tool_calls_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpActionToolCallsVarPopFields = {
  __typename?: 'amp_action_tool_calls_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpActionToolCallsVarSampFields = {
  __typename?: 'amp_action_tool_calls_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpActionToolCallsVarianceFields = {
  __typename?: 'amp_action_tool_calls_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_action_tool_calls" */
export type AmpActionToolCallsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_actions" */
export type AmpActions = {
  __typename?: 'amp_actions';
  /** An array relationship */
  calls: Array<AmpActionCalls>;
  /** An aggregate relationship */
  calls_aggregate: AmpActionCallsAggregate;
  created_at: Scalars['timestamptz'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  instruction: Scalars['String'];
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  project?: Maybe<AmpProjects>;
  project_id: Scalars['uuid'];
  scope: Scalars['jsonb'];
  started_at: Scalars['timestamptz'];
  started_by: Scalars['String'];
  /** An object relationship */
  started_by_user?: Maybe<Users>;
  started_by_user_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_actions" */
export type AmpActionsCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


/** columns and relationships of "amp_actions" */
export type AmpActionsCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


/** columns and relationships of "amp_actions" */
export type AmpActionsScopeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_actions" */
export type AmpActionsAggregate = {
  __typename?: 'amp_actions_aggregate';
  aggregate?: Maybe<AmpActionsAggregateFields>;
  nodes: Array<AmpActions>;
};

export type AmpActionsAggregateBoolExp = {
  count?: InputMaybe<AmpActionsAggregateBoolExpCount>;
};

export type AmpActionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpActionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_actions" */
export type AmpActionsAggregateFields = {
  __typename?: 'amp_actions_aggregate_fields';
  avg?: Maybe<AmpActionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpActionsMaxFields>;
  min?: Maybe<AmpActionsMinFields>;
  stddev?: Maybe<AmpActionsStddevFields>;
  stddev_pop?: Maybe<AmpActionsStddevPopFields>;
  stddev_samp?: Maybe<AmpActionsStddevSampFields>;
  sum?: Maybe<AmpActionsSumFields>;
  var_pop?: Maybe<AmpActionsVarPopFields>;
  var_samp?: Maybe<AmpActionsVarSampFields>;
  variance?: Maybe<AmpActionsVarianceFields>;
};


/** aggregate fields of "amp_actions" */
export type AmpActionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_actions" */
export type AmpActionsAggregateOrderBy = {
  avg?: InputMaybe<AmpActionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpActionsMaxOrderBy>;
  min?: InputMaybe<AmpActionsMinOrderBy>;
  stddev?: InputMaybe<AmpActionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpActionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpActionsStddevSampOrderBy>;
  sum?: InputMaybe<AmpActionsSumOrderBy>;
  var_pop?: InputMaybe<AmpActionsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpActionsVarSampOrderBy>;
  variance?: InputMaybe<AmpActionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpActionsAvgFields = {
  __typename?: 'amp_actions_avg_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_actions" */
export type AmpActionsAvgOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_actions". All fields are combined with a logical 'AND'. */
export type AmpActionsBoolExp = {
  _and?: InputMaybe<Array<AmpActionsBoolExp>>;
  _not?: InputMaybe<AmpActionsBoolExp>;
  _or?: InputMaybe<Array<AmpActionsBoolExp>>;
  calls?: InputMaybe<AmpActionCallsBoolExp>;
  calls_aggregate?: InputMaybe<AmpActionCallsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instruction?: InputMaybe<StringComparisonExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  project?: InputMaybe<AmpProjectsBoolExp>;
  project_id?: InputMaybe<UuidComparisonExp>;
  scope?: InputMaybe<JsonbComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  started_by?: InputMaybe<StringComparisonExp>;
  started_by_user?: InputMaybe<UsersBoolExp>;
  started_by_user_id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpActionsMaxFields = {
  __typename?: 'amp_actions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  instruction?: Maybe<Scalars['String']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  started_by?: Maybe<Scalars['String']>;
  started_by_user_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_actions" */
export type AmpActionsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instruction?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  started_by?: InputMaybe<OrderBy>;
  started_by_user_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpActionsMinFields = {
  __typename?: 'amp_actions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  instruction?: Maybe<Scalars['String']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  started_by?: Maybe<Scalars['String']>;
  started_by_user_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_actions" */
export type AmpActionsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instruction?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  started_by?: InputMaybe<OrderBy>;
  started_by_user_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_actions". */
export type AmpActionsOrderBy = {
  calls_aggregate?: InputMaybe<AmpActionCallsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  instruction?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  project?: InputMaybe<AmpProjectsOrderBy>;
  project_id?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  started_by?: InputMaybe<OrderBy>;
  started_by_user?: InputMaybe<UsersOrderBy>;
  started_by_user_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_actions" */
export const AmpActionsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  Instruction: 'instruction',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  ProjectId: 'project_id',
  /** column name */
  Scope: 'scope',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  StartedBy: 'started_by',
  /** column name */
  StartedByUserId: 'started_by_user_id',
  /** column name */
  Status: 'status',
  /** column name */
  Summary: 'summary',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpActionsSelectColumn = typeof AmpActionsSelectColumn[keyof typeof AmpActionsSelectColumn];
/** aggregate stddev on columns */
export type AmpActionsStddevFields = {
  __typename?: 'amp_actions_stddev_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_actions" */
export type AmpActionsStddevOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpActionsStddevPopFields = {
  __typename?: 'amp_actions_stddev_pop_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_actions" */
export type AmpActionsStddevPopOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpActionsStddevSampFields = {
  __typename?: 'amp_actions_stddev_samp_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_actions" */
export type AmpActionsStddevSampOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_actions" */
export type AmpActionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpActionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpActionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  instruction?: InputMaybe<Scalars['String']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  scope?: InputMaybe<Scalars['jsonb']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  started_by?: InputMaybe<Scalars['String']>;
  started_by_user_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpActionsSumFields = {
  __typename?: 'amp_actions_sum_fields';
  started_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_actions" */
export type AmpActionsSumOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpActionsVarPopFields = {
  __typename?: 'amp_actions_var_pop_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_actions" */
export type AmpActionsVarPopOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpActionsVarSampFields = {
  __typename?: 'amp_actions_var_samp_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_actions" */
export type AmpActionsVarSampOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpActionsVarianceFields = {
  __typename?: 'amp_actions_variance_fields';
  started_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_actions" */
export type AmpActionsVarianceOrderBy = {
  started_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_asset_groups" */
export type AmpAssetGroups = {
  __typename?: 'amp_asset_groups';
  always_inject_into_context: Scalars['Boolean'];
  base_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  brand_profile_assignments: Array<BrandProfileAssetGroups>;
  /** An aggregate relationship */
  brand_profile_assignments_aggregate: BrandProfileAssetGroupsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  editable: Scalars['Boolean'];
  id: Scalars['uuid'];
  image_guardrails: Scalars['jsonb'];
  instructions: Scalars['String'];
  name: Scalars['String'];
  sync_kind?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_asset_groups" */
export type AmpAssetGroupsBrandProfileAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


/** columns and relationships of "amp_asset_groups" */
export type AmpAssetGroupsBrandProfileAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


/** columns and relationships of "amp_asset_groups" */
export type AmpAssetGroupsImageGuardrailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_asset_groups" */
export type AmpAssetGroupsAggregate = {
  __typename?: 'amp_asset_groups_aggregate';
  aggregate?: Maybe<AmpAssetGroupsAggregateFields>;
  nodes: Array<AmpAssetGroups>;
};

/** aggregate fields of "amp_asset_groups" */
export type AmpAssetGroupsAggregateFields = {
  __typename?: 'amp_asset_groups_aggregate_fields';
  avg?: Maybe<AmpAssetGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpAssetGroupsMaxFields>;
  min?: Maybe<AmpAssetGroupsMinFields>;
  stddev?: Maybe<AmpAssetGroupsStddevFields>;
  stddev_pop?: Maybe<AmpAssetGroupsStddevPopFields>;
  stddev_samp?: Maybe<AmpAssetGroupsStddevSampFields>;
  sum?: Maybe<AmpAssetGroupsSumFields>;
  var_pop?: Maybe<AmpAssetGroupsVarPopFields>;
  var_samp?: Maybe<AmpAssetGroupsVarSampFields>;
  variance?: Maybe<AmpAssetGroupsVarianceFields>;
};


/** aggregate fields of "amp_asset_groups" */
export type AmpAssetGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpAssetGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpAssetGroupsAvgFields = {
  __typename?: 'amp_asset_groups_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_asset_groups". All fields are combined with a logical 'AND'. */
export type AmpAssetGroupsBoolExp = {
  _and?: InputMaybe<Array<AmpAssetGroupsBoolExp>>;
  _not?: InputMaybe<AmpAssetGroupsBoolExp>;
  _or?: InputMaybe<Array<AmpAssetGroupsBoolExp>>;
  always_inject_into_context?: InputMaybe<BooleanComparisonExp>;
  base_type?: InputMaybe<StringComparisonExp>;
  brand_profile_assignments?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
  brand_profile_assignments_aggregate?: InputMaybe<BrandProfileAssetGroupsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  editable?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image_guardrails?: InputMaybe<JsonbComparisonExp>;
  instructions?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  sync_kind?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpAssetGroupsMaxFields = {
  __typename?: 'amp_asset_groups_max_fields';
  base_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  instructions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sync_kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpAssetGroupsMinFields = {
  __typename?: 'amp_asset_groups_min_fields';
  base_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  instructions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sync_kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "amp_asset_groups". */
export type AmpAssetGroupsOrderBy = {
  always_inject_into_context?: InputMaybe<OrderBy>;
  base_type?: InputMaybe<OrderBy>;
  brand_profile_assignments_aggregate?: InputMaybe<BrandProfileAssetGroupsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  editable?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_guardrails?: InputMaybe<OrderBy>;
  instructions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sync_kind?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_asset_groups" */
export const AmpAssetGroupsSelectColumn = {
  /** column name */
  AlwaysInjectIntoContext: 'always_inject_into_context',
  /** column name */
  BaseType: 'base_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Editable: 'editable',
  /** column name */
  Id: 'id',
  /** column name */
  ImageGuardrails: 'image_guardrails',
  /** column name */
  Instructions: 'instructions',
  /** column name */
  Name: 'name',
  /** column name */
  SyncKind: 'sync_kind',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpAssetGroupsSelectColumn = typeof AmpAssetGroupsSelectColumn[keyof typeof AmpAssetGroupsSelectColumn];
/** aggregate stddev on columns */
export type AmpAssetGroupsStddevFields = {
  __typename?: 'amp_asset_groups_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpAssetGroupsStddevPopFields = {
  __typename?: 'amp_asset_groups_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpAssetGroupsStddevSampFields = {
  __typename?: 'amp_asset_groups_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_asset_groups" */
export type AmpAssetGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpAssetGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpAssetGroupsStreamCursorValueInput = {
  always_inject_into_context?: InputMaybe<Scalars['Boolean']>;
  base_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sync_kind?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpAssetGroupsSumFields = {
  __typename?: 'amp_asset_groups_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AmpAssetGroupsVarPopFields = {
  __typename?: 'amp_asset_groups_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpAssetGroupsVarSampFields = {
  __typename?: 'amp_asset_groups_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpAssetGroupsVarianceFields = {
  __typename?: 'amp_asset_groups_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_asset_ratings" */
export type AmpAssetRatings = {
  __typename?: 'amp_asset_ratings';
  /** An object relationship */
  ad_brief_asset_size_variant?: Maybe<AdBriefAssetSizeVariants>;
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ad_brief_asset_version?: Maybe<AdBriefAssetVersions>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  rating: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_asset_ratings" */
export type AmpAssetRatingsRatingArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_asset_ratings" */
export type AmpAssetRatingsAggregate = {
  __typename?: 'amp_asset_ratings_aggregate';
  aggregate?: Maybe<AmpAssetRatingsAggregateFields>;
  nodes: Array<AmpAssetRatings>;
};

export type AmpAssetRatingsAggregateBoolExp = {
  count?: InputMaybe<AmpAssetRatingsAggregateBoolExpCount>;
};

export type AmpAssetRatingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpAssetRatingsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_asset_ratings" */
export type AmpAssetRatingsAggregateFields = {
  __typename?: 'amp_asset_ratings_aggregate_fields';
  avg?: Maybe<AmpAssetRatingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpAssetRatingsMaxFields>;
  min?: Maybe<AmpAssetRatingsMinFields>;
  stddev?: Maybe<AmpAssetRatingsStddevFields>;
  stddev_pop?: Maybe<AmpAssetRatingsStddevPopFields>;
  stddev_samp?: Maybe<AmpAssetRatingsStddevSampFields>;
  sum?: Maybe<AmpAssetRatingsSumFields>;
  var_pop?: Maybe<AmpAssetRatingsVarPopFields>;
  var_samp?: Maybe<AmpAssetRatingsVarSampFields>;
  variance?: Maybe<AmpAssetRatingsVarianceFields>;
};


/** aggregate fields of "amp_asset_ratings" */
export type AmpAssetRatingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_asset_ratings" */
export type AmpAssetRatingsAggregateOrderBy = {
  avg?: InputMaybe<AmpAssetRatingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpAssetRatingsMaxOrderBy>;
  min?: InputMaybe<AmpAssetRatingsMinOrderBy>;
  stddev?: InputMaybe<AmpAssetRatingsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpAssetRatingsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpAssetRatingsStddevSampOrderBy>;
  sum?: InputMaybe<AmpAssetRatingsSumOrderBy>;
  var_pop?: InputMaybe<AmpAssetRatingsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpAssetRatingsVarSampOrderBy>;
  variance?: InputMaybe<AmpAssetRatingsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AmpAssetRatingsAppendInput = {
  rating?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "amp_asset_ratings" */
export type AmpAssetRatingsArrRelInsertInput = {
  data: Array<AmpAssetRatingsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpAssetRatingsOnConflict>;
};

/** aggregate avg on columns */
export type AmpAssetRatingsAvgFields = {
  __typename?: 'amp_asset_ratings_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_asset_ratings". All fields are combined with a logical 'AND'. */
export type AmpAssetRatingsBoolExp = {
  _and?: InputMaybe<Array<AmpAssetRatingsBoolExp>>;
  _not?: InputMaybe<AmpAssetRatingsBoolExp>;
  _or?: InputMaybe<Array<AmpAssetRatingsBoolExp>>;
  ad_brief_asset_size_variant?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  ad_brief_asset_size_variant_id?: InputMaybe<UuidComparisonExp>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  ad_brief_asset_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  rating?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_asset_ratings" */
export const AmpAssetRatingsConstraint = {
  /** unique or primary key constraint on columns "id" */
  AmpAssetRatingsPkey: 'amp_asset_ratings_pkey',
  /** unique or primary key constraint on columns "user_id", "ad_brief_asset_size_variant_id" */
  AmpAssetRatingsSizeVariantUserKey: 'amp_asset_ratings_size_variant_user_key',
  /** unique or primary key constraint on columns "user_id", "ad_brief_asset_version_id" */
  AmpAssetRatingsVersionUserKey: 'amp_asset_ratings_version_user_key'
} as const;

export type AmpAssetRatingsConstraint = typeof AmpAssetRatingsConstraint[keyof typeof AmpAssetRatingsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AmpAssetRatingsDeleteAtPathInput = {
  rating?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AmpAssetRatingsDeleteElemInput = {
  rating?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AmpAssetRatingsDeleteKeyInput = {
  rating?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "amp_asset_ratings" */
export type AmpAssetRatingsInsertInput = {
  ad_brief_asset_size_variant?: InputMaybe<AdBriefAssetSizeVariantsObjRelInsertInput>;
  ad_brief_asset_size_variant_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsObjRelInsertInput>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type AmpAssetRatingsMaxFields = {
  __typename?: 'amp_asset_ratings_max_fields';
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsMaxOrderBy = {
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpAssetRatingsMinFields = {
  __typename?: 'amp_asset_ratings_min_fields';
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsMinOrderBy = {
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_asset_ratings" */
export type AmpAssetRatingsMutationResponse = {
  __typename?: 'amp_asset_ratings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpAssetRatings>;
};

/** on_conflict condition type for table "amp_asset_ratings" */
export type AmpAssetRatingsOnConflict = {
  constraint: AmpAssetRatingsConstraint;
  update_columns?: Array<AmpAssetRatingsUpdateColumn>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};

/** Ordering options when selecting data from "amp_asset_ratings". */
export type AmpAssetRatingsOrderBy = {
  ad_brief_asset_size_variant?: InputMaybe<AdBriefAssetSizeVariantsOrderBy>;
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_asset_ratings */
export type AmpAssetRatingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AmpAssetRatingsPrependInput = {
  rating?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "amp_asset_ratings" */
export const AmpAssetRatingsSelectColumn = {
  /** column name */
  AdBriefAssetSizeVariantId: 'ad_brief_asset_size_variant_id',
  /** column name */
  AdBriefAssetVersionId: 'ad_brief_asset_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Rating: 'rating',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpAssetRatingsSelectColumn = typeof AmpAssetRatingsSelectColumn[keyof typeof AmpAssetRatingsSelectColumn];
/** input type for updating data in table "amp_asset_ratings" */
export type AmpAssetRatingsSetInput = {
  rating?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type AmpAssetRatingsStddevFields = {
  __typename?: 'amp_asset_ratings_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpAssetRatingsStddevPopFields = {
  __typename?: 'amp_asset_ratings_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpAssetRatingsStddevSampFields = {
  __typename?: 'amp_asset_ratings_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_asset_ratings" */
export type AmpAssetRatingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpAssetRatingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpAssetRatingsStreamCursorValueInput = {
  ad_brief_asset_size_variant_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpAssetRatingsSumFields = {
  __typename?: 'amp_asset_ratings_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "amp_asset_ratings" */
export const AmpAssetRatingsUpdateColumn = {
  /** column name */
  Rating: 'rating'
} as const;

export type AmpAssetRatingsUpdateColumn = typeof AmpAssetRatingsUpdateColumn[keyof typeof AmpAssetRatingsUpdateColumn];
export type AmpAssetRatingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AmpAssetRatingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AmpAssetRatingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AmpAssetRatingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AmpAssetRatingsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AmpAssetRatingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpAssetRatingsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpAssetRatingsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpAssetRatingsVarPopFields = {
  __typename?: 'amp_asset_ratings_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpAssetRatingsVarSampFields = {
  __typename?: 'amp_asset_ratings_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpAssetRatingsVarianceFields = {
  __typename?: 'amp_asset_ratings_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_asset_ratings" */
export type AmpAssetRatingsVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_asset_sources" */
export type AmpAssetSources = {
  __typename?: 'amp_asset_sources';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  extension?: Maybe<Extensions>;
  extension_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  syncs: Array<AmpAssetSyncs>;
  /** An aggregate relationship */
  syncs_aggregate: AmpAssetSyncsAggregate;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_asset_sources" */
export type AmpAssetSourcesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_asset_sources" */
export type AmpAssetSourcesSyncsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


/** columns and relationships of "amp_asset_sources" */
export type AmpAssetSourcesSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};

/** aggregated selection of "amp_asset_sources" */
export type AmpAssetSourcesAggregate = {
  __typename?: 'amp_asset_sources_aggregate';
  aggregate?: Maybe<AmpAssetSourcesAggregateFields>;
  nodes: Array<AmpAssetSources>;
};

/** aggregate fields of "amp_asset_sources" */
export type AmpAssetSourcesAggregateFields = {
  __typename?: 'amp_asset_sources_aggregate_fields';
  avg?: Maybe<AmpAssetSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpAssetSourcesMaxFields>;
  min?: Maybe<AmpAssetSourcesMinFields>;
  stddev?: Maybe<AmpAssetSourcesStddevFields>;
  stddev_pop?: Maybe<AmpAssetSourcesStddevPopFields>;
  stddev_samp?: Maybe<AmpAssetSourcesStddevSampFields>;
  sum?: Maybe<AmpAssetSourcesSumFields>;
  var_pop?: Maybe<AmpAssetSourcesVarPopFields>;
  var_samp?: Maybe<AmpAssetSourcesVarSampFields>;
  variance?: Maybe<AmpAssetSourcesVarianceFields>;
};


/** aggregate fields of "amp_asset_sources" */
export type AmpAssetSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpAssetSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpAssetSourcesAvgFields = {
  __typename?: 'amp_asset_sources_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_asset_sources". All fields are combined with a logical 'AND'. */
export type AmpAssetSourcesBoolExp = {
  _and?: InputMaybe<Array<AmpAssetSourcesBoolExp>>;
  _not?: InputMaybe<AmpAssetSourcesBoolExp>;
  _or?: InputMaybe<Array<AmpAssetSourcesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  extension?: InputMaybe<ExtensionsBoolExp>;
  extension_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  syncs?: InputMaybe<AmpAssetSyncsBoolExp>;
  syncs_aggregate?: InputMaybe<AmpAssetSyncsAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpAssetSourcesMaxFields = {
  __typename?: 'amp_asset_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  extension_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpAssetSourcesMinFields = {
  __typename?: 'amp_asset_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  extension_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "amp_asset_sources". */
export type AmpAssetSourcesOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  extension?: InputMaybe<ExtensionsOrderBy>;
  extension_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  syncs_aggregate?: InputMaybe<AmpAssetSyncsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_asset_sources" */
export const AmpAssetSourcesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ExtensionId: 'extension_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpAssetSourcesSelectColumn = typeof AmpAssetSourcesSelectColumn[keyof typeof AmpAssetSourcesSelectColumn];
/** aggregate stddev on columns */
export type AmpAssetSourcesStddevFields = {
  __typename?: 'amp_asset_sources_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpAssetSourcesStddevPopFields = {
  __typename?: 'amp_asset_sources_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpAssetSourcesStddevSampFields = {
  __typename?: 'amp_asset_sources_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_asset_sources" */
export type AmpAssetSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpAssetSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpAssetSourcesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  extension_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpAssetSourcesSumFields = {
  __typename?: 'amp_asset_sources_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AmpAssetSourcesVarPopFields = {
  __typename?: 'amp_asset_sources_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpAssetSourcesVarSampFields = {
  __typename?: 'amp_asset_sources_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpAssetSourcesVarianceFields = {
  __typename?: 'amp_asset_sources_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_asset_sync_runs" */
export type AmpAssetSyncRuns = {
  __typename?: 'amp_asset_sync_runs';
  config_snapshot?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** A computed field, executes function "amp_asset_sync_run_error" */
  error?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "amp_asset_sync_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  job_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "amp_asset_sync_run_result" */
  result?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "amp_asset_sync_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  state: Scalars['String'];
  /** A computed field, executes function "amp_asset_sync_run_status" */
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  sync: AmpAssetSyncs;
  sync_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsConfigSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsAggregate = {
  __typename?: 'amp_asset_sync_runs_aggregate';
  aggregate?: Maybe<AmpAssetSyncRunsAggregateFields>;
  nodes: Array<AmpAssetSyncRuns>;
};

export type AmpAssetSyncRunsAggregateBoolExp = {
  count?: InputMaybe<AmpAssetSyncRunsAggregateBoolExpCount>;
};

export type AmpAssetSyncRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpAssetSyncRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsAggregateFields = {
  __typename?: 'amp_asset_sync_runs_aggregate_fields';
  avg?: Maybe<AmpAssetSyncRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpAssetSyncRunsMaxFields>;
  min?: Maybe<AmpAssetSyncRunsMinFields>;
  stddev?: Maybe<AmpAssetSyncRunsStddevFields>;
  stddev_pop?: Maybe<AmpAssetSyncRunsStddevPopFields>;
  stddev_samp?: Maybe<AmpAssetSyncRunsStddevSampFields>;
  sum?: Maybe<AmpAssetSyncRunsSumFields>;
  var_pop?: Maybe<AmpAssetSyncRunsVarPopFields>;
  var_samp?: Maybe<AmpAssetSyncRunsVarSampFields>;
  variance?: Maybe<AmpAssetSyncRunsVarianceFields>;
};


/** aggregate fields of "amp_asset_sync_runs" */
export type AmpAssetSyncRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsAggregateOrderBy = {
  avg?: InputMaybe<AmpAssetSyncRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpAssetSyncRunsMaxOrderBy>;
  min?: InputMaybe<AmpAssetSyncRunsMinOrderBy>;
  stddev?: InputMaybe<AmpAssetSyncRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpAssetSyncRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpAssetSyncRunsStddevSampOrderBy>;
  sum?: InputMaybe<AmpAssetSyncRunsSumOrderBy>;
  var_pop?: InputMaybe<AmpAssetSyncRunsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpAssetSyncRunsVarSampOrderBy>;
  variance?: InputMaybe<AmpAssetSyncRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpAssetSyncRunsAvgFields = {
  __typename?: 'amp_asset_sync_runs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_asset_sync_runs". All fields are combined with a logical 'AND'. */
export type AmpAssetSyncRunsBoolExp = {
  _and?: InputMaybe<Array<AmpAssetSyncRunsBoolExp>>;
  _not?: InputMaybe<AmpAssetSyncRunsBoolExp>;
  _or?: InputMaybe<Array<AmpAssetSyncRunsBoolExp>>;
  config_snapshot?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_id?: InputMaybe<UuidComparisonExp>;
  result?: InputMaybe<JsonbComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<AmpAssetSyncsBoolExp>;
  sync_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpAssetSyncRunsMaxFields = {
  __typename?: 'amp_asset_sync_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "amp_asset_sync_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "amp_asset_sync_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  /** A computed field, executes function "amp_asset_sync_run_status" */
  status?: Maybe<Scalars['String']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpAssetSyncRunsMinFields = {
  __typename?: 'amp_asset_sync_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "amp_asset_sync_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "amp_asset_sync_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  /** A computed field, executes function "amp_asset_sync_run_status" */
  status?: Maybe<Scalars['String']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_asset_sync_runs". */
export type AmpAssetSyncRunsOrderBy = {
  config_snapshot?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  result?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync?: InputMaybe<AmpAssetSyncsOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_asset_sync_runs" */
export const AmpAssetSyncRunsSelectColumn = {
  /** column name */
  ConfigSnapshot: 'config_snapshot',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  JobId: 'job_id',
  /** column name */
  State: 'state',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpAssetSyncRunsSelectColumn = typeof AmpAssetSyncRunsSelectColumn[keyof typeof AmpAssetSyncRunsSelectColumn];
/** aggregate stddev on columns */
export type AmpAssetSyncRunsStddevFields = {
  __typename?: 'amp_asset_sync_runs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpAssetSyncRunsStddevPopFields = {
  __typename?: 'amp_asset_sync_runs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpAssetSyncRunsStddevSampFields = {
  __typename?: 'amp_asset_sync_runs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpAssetSyncRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpAssetSyncRunsStreamCursorValueInput = {
  config_snapshot?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  sync_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpAssetSyncRunsSumFields = {
  __typename?: 'amp_asset_sync_runs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpAssetSyncRunsVarPopFields = {
  __typename?: 'amp_asset_sync_runs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpAssetSyncRunsVarSampFields = {
  __typename?: 'amp_asset_sync_runs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpAssetSyncRunsVarianceFields = {
  __typename?: 'amp_asset_sync_runs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_asset_sync_runs" */
export type AmpAssetSyncRunsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_asset_syncs" */
export type AmpAssetSyncs = {
  __typename?: 'amp_asset_syncs';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  runs: Array<AmpAssetSyncRuns>;
  /** An aggregate relationship */
  runs_aggregate: AmpAssetSyncRunsAggregate;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  /** An object relationship */
  source: AmpAssetSources;
  source_id: Scalars['uuid'];
  /** An object relationship */
  target_asset_group: AmpAssetGroups;
  target_asset_group_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_asset_syncs" */
export type AmpAssetSyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_asset_syncs" */
export type AmpAssetSyncsRunsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


/** columns and relationships of "amp_asset_syncs" */
export type AmpAssetSyncsRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


/** columns and relationships of "amp_asset_syncs" */
export type AmpAssetSyncsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_asset_syncs" */
export type AmpAssetSyncsAggregate = {
  __typename?: 'amp_asset_syncs_aggregate';
  aggregate?: Maybe<AmpAssetSyncsAggregateFields>;
  nodes: Array<AmpAssetSyncs>;
};

export type AmpAssetSyncsAggregateBoolExp = {
  bool_and?: InputMaybe<AmpAssetSyncsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AmpAssetSyncsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AmpAssetSyncsAggregateBoolExpCount>;
};

export type AmpAssetSyncsAggregateBoolExpBoolAnd = {
  arguments: AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpAssetSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpAssetSyncsAggregateBoolExpBoolOr = {
  arguments: AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpAssetSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpAssetSyncsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpAssetSyncsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_asset_syncs" */
export type AmpAssetSyncsAggregateFields = {
  __typename?: 'amp_asset_syncs_aggregate_fields';
  avg?: Maybe<AmpAssetSyncsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpAssetSyncsMaxFields>;
  min?: Maybe<AmpAssetSyncsMinFields>;
  stddev?: Maybe<AmpAssetSyncsStddevFields>;
  stddev_pop?: Maybe<AmpAssetSyncsStddevPopFields>;
  stddev_samp?: Maybe<AmpAssetSyncsStddevSampFields>;
  sum?: Maybe<AmpAssetSyncsSumFields>;
  var_pop?: Maybe<AmpAssetSyncsVarPopFields>;
  var_samp?: Maybe<AmpAssetSyncsVarSampFields>;
  variance?: Maybe<AmpAssetSyncsVarianceFields>;
};


/** aggregate fields of "amp_asset_syncs" */
export type AmpAssetSyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_asset_syncs" */
export type AmpAssetSyncsAggregateOrderBy = {
  avg?: InputMaybe<AmpAssetSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpAssetSyncsMaxOrderBy>;
  min?: InputMaybe<AmpAssetSyncsMinOrderBy>;
  stddev?: InputMaybe<AmpAssetSyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpAssetSyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpAssetSyncsStddevSampOrderBy>;
  sum?: InputMaybe<AmpAssetSyncsSumOrderBy>;
  var_pop?: InputMaybe<AmpAssetSyncsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpAssetSyncsVarSampOrderBy>;
  variance?: InputMaybe<AmpAssetSyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpAssetSyncsAvgFields = {
  __typename?: 'amp_asset_syncs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_asset_syncs". All fields are combined with a logical 'AND'. */
export type AmpAssetSyncsBoolExp = {
  _and?: InputMaybe<Array<AmpAssetSyncsBoolExp>>;
  _not?: InputMaybe<AmpAssetSyncsBoolExp>;
  _or?: InputMaybe<Array<AmpAssetSyncsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  runs?: InputMaybe<AmpAssetSyncRunsBoolExp>;
  runs_aggregate?: InputMaybe<AmpAssetSyncRunsAggregateBoolExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  source?: InputMaybe<AmpAssetSourcesBoolExp>;
  source_id?: InputMaybe<UuidComparisonExp>;
  target_asset_group?: InputMaybe<AmpAssetGroupsBoolExp>;
  target_asset_group_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpAssetSyncsMaxFields = {
  __typename?: 'amp_asset_syncs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['uuid']>;
  target_asset_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source_id?: InputMaybe<OrderBy>;
  target_asset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpAssetSyncsMinFields = {
  __typename?: 'amp_asset_syncs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['uuid']>;
  target_asset_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source_id?: InputMaybe<OrderBy>;
  target_asset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_asset_syncs". */
export type AmpAssetSyncsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  runs_aggregate?: InputMaybe<AmpAssetSyncRunsAggregateOrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  source?: InputMaybe<AmpAssetSourcesOrderBy>;
  source_id?: InputMaybe<OrderBy>;
  target_asset_group?: InputMaybe<AmpAssetGroupsOrderBy>;
  target_asset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_asset_syncs" */
export const AmpAssetSyncsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SourceId: 'source_id',
  /** column name */
  TargetAssetGroupId: 'target_asset_group_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpAssetSyncsSelectColumn = typeof AmpAssetSyncsSelectColumn[keyof typeof AmpAssetSyncsSelectColumn];
/** select "amp_asset_syncs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "amp_asset_syncs" */
export const AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolAndArgumentsColumns = typeof AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolAndArgumentsColumns];
/** select "amp_asset_syncs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "amp_asset_syncs" */
export const AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolOrArgumentsColumns = typeof AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AmpAssetSyncsSelectColumnAmpAssetSyncsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type AmpAssetSyncsStddevFields = {
  __typename?: 'amp_asset_syncs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpAssetSyncsStddevPopFields = {
  __typename?: 'amp_asset_syncs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpAssetSyncsStddevSampFields = {
  __typename?: 'amp_asset_syncs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_asset_syncs" */
export type AmpAssetSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpAssetSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpAssetSyncsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  source_id?: InputMaybe<Scalars['uuid']>;
  target_asset_group_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpAssetSyncsSumFields = {
  __typename?: 'amp_asset_syncs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpAssetSyncsVarPopFields = {
  __typename?: 'amp_asset_syncs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpAssetSyncsVarSampFields = {
  __typename?: 'amp_asset_syncs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpAssetSyncsVarianceFields = {
  __typename?: 'amp_asset_syncs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_asset_syncs" */
export type AmpAssetSyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRuns = {
  __typename?: 'amp_creative_classification_runs';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** A computed field, executes function "amp_creative_classification_run_error" */
  error?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "amp_creative_classification_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  job_id: Scalars['uuid'];
  namespace: Scalars['String'];
  /** A computed field, executes function "amp_creative_classification_run_result" */
  result?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "amp_creative_classification_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "amp_creative_classification_run_status" */
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsAggregate = {
  __typename?: 'amp_creative_classification_runs_aggregate';
  aggregate?: Maybe<AmpCreativeClassificationRunsAggregateFields>;
  nodes: Array<AmpCreativeClassificationRuns>;
};

/** aggregate fields of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsAggregateFields = {
  __typename?: 'amp_creative_classification_runs_aggregate_fields';
  avg?: Maybe<AmpCreativeClassificationRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpCreativeClassificationRunsMaxFields>;
  min?: Maybe<AmpCreativeClassificationRunsMinFields>;
  stddev?: Maybe<AmpCreativeClassificationRunsStddevFields>;
  stddev_pop?: Maybe<AmpCreativeClassificationRunsStddevPopFields>;
  stddev_samp?: Maybe<AmpCreativeClassificationRunsStddevSampFields>;
  sum?: Maybe<AmpCreativeClassificationRunsSumFields>;
  var_pop?: Maybe<AmpCreativeClassificationRunsVarPopFields>;
  var_samp?: Maybe<AmpCreativeClassificationRunsVarSampFields>;
  variance?: Maybe<AmpCreativeClassificationRunsVarianceFields>;
};


/** aggregate fields of "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpCreativeClassificationRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpCreativeClassificationRunsAvgFields = {
  __typename?: 'amp_creative_classification_runs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_creative_classification_runs". All fields are combined with a logical 'AND'. */
export type AmpCreativeClassificationRunsBoolExp = {
  _and?: InputMaybe<Array<AmpCreativeClassificationRunsBoolExp>>;
  _not?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
  _or?: InputMaybe<Array<AmpCreativeClassificationRunsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_id?: InputMaybe<UuidComparisonExp>;
  namespace?: InputMaybe<StringComparisonExp>;
  result?: InputMaybe<JsonbComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpCreativeClassificationRunsMaxFields = {
  __typename?: 'amp_creative_classification_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "amp_creative_classification_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
  namespace?: Maybe<Scalars['String']>;
  /** A computed field, executes function "amp_creative_classification_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "amp_creative_classification_run_status" */
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpCreativeClassificationRunsMinFields = {
  __typename?: 'amp_creative_classification_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "amp_creative_classification_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
  namespace?: Maybe<Scalars['String']>;
  /** A computed field, executes function "amp_creative_classification_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "amp_creative_classification_run_status" */
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "amp_creative_classification_runs". */
export type AmpCreativeClassificationRunsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  namespace?: InputMaybe<OrderBy>;
  result?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_creative_classification_runs" */
export const AmpCreativeClassificationRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  JobId: 'job_id',
  /** column name */
  Namespace: 'namespace',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpCreativeClassificationRunsSelectColumn = typeof AmpCreativeClassificationRunsSelectColumn[keyof typeof AmpCreativeClassificationRunsSelectColumn];
/** aggregate stddev on columns */
export type AmpCreativeClassificationRunsStddevFields = {
  __typename?: 'amp_creative_classification_runs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpCreativeClassificationRunsStddevPopFields = {
  __typename?: 'amp_creative_classification_runs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpCreativeClassificationRunsStddevSampFields = {
  __typename?: 'amp_creative_classification_runs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_creative_classification_runs" */
export type AmpCreativeClassificationRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpCreativeClassificationRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpCreativeClassificationRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  namespace?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpCreativeClassificationRunsSumFields = {
  __typename?: 'amp_creative_classification_runs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AmpCreativeClassificationRunsVarPopFields = {
  __typename?: 'amp_creative_classification_runs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpCreativeClassificationRunsVarSampFields = {
  __typename?: 'amp_creative_classification_runs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpCreativeClassificationRunsVarianceFields = {
  __typename?: 'amp_creative_classification_runs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_creative_dimension_values" */
export type AmpCreativeDimensionValues = {
  __typename?: 'amp_creative_dimension_values';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  dimension: AmpCreativeDimensions;
  dimension_id: Scalars['uuid'];
  id: Scalars['uuid'];
  learned_in_run_id?: Maybe<Scalars['uuid']>;
  origin: Scalars['String'];
  status: Scalars['String'];
  support_count?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  value: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesAggregateOrderBy = {
  avg?: InputMaybe<AmpCreativeDimensionValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpCreativeDimensionValuesMaxOrderBy>;
  min?: InputMaybe<AmpCreativeDimensionValuesMinOrderBy>;
  stddev?: InputMaybe<AmpCreativeDimensionValuesStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpCreativeDimensionValuesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpCreativeDimensionValuesStddevSampOrderBy>;
  sum?: InputMaybe<AmpCreativeDimensionValuesSumOrderBy>;
  var_pop?: InputMaybe<AmpCreativeDimensionValuesVarPopOrderBy>;
  var_samp?: InputMaybe<AmpCreativeDimensionValuesVarSampOrderBy>;
  variance?: InputMaybe<AmpCreativeDimensionValuesVarianceOrderBy>;
};

/** order by avg() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_creative_dimension_values". All fields are combined with a logical 'AND'. */
export type AmpCreativeDimensionValuesBoolExp = {
  _and?: InputMaybe<Array<AmpCreativeDimensionValuesBoolExp>>;
  _not?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
  _or?: InputMaybe<Array<AmpCreativeDimensionValuesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  dimension?: InputMaybe<AmpCreativeDimensionsBoolExp>;
  dimension_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  learned_in_run_id?: InputMaybe<UuidComparisonExp>;
  origin?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  support_count?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dimension_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learned_in_run_id?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dimension_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learned_in_run_id?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_creative_dimension_values". */
export type AmpCreativeDimensionValuesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dimension?: InputMaybe<AmpCreativeDimensionsOrderBy>;
  dimension_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  learned_in_run_id?: InputMaybe<OrderBy>;
  origin?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_creative_dimension_values" */
export const AmpCreativeDimensionValuesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DimensionId: 'dimension_id',
  /** column name */
  Id: 'id',
  /** column name */
  LearnedInRunId: 'learned_in_run_id',
  /** column name */
  Origin: 'origin',
  /** column name */
  Status: 'status',
  /** column name */
  SupportCount: 'support_count',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Value: 'value',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpCreativeDimensionValuesSelectColumn = typeof AmpCreativeDimensionValuesSelectColumn[keyof typeof AmpCreativeDimensionValuesSelectColumn];
/** order by stddev() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpCreativeDimensionValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpCreativeDimensionValuesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  learned_in_run_id?: InputMaybe<Scalars['uuid']>;
  origin?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  support_count?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "amp_creative_dimension_values" */
export type AmpCreativeDimensionValuesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  support_count?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_creative_dimensions" */
export type AmpCreativeDimensions = {
  __typename?: 'amp_creative_dimensions';
  allow_learning: Scalars['Boolean'];
  asset_group_id?: Maybe<Scalars['uuid']>;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  key: Scalars['String'];
  minor_version: Scalars['Int'];
  name: Scalars['String'];
  namespace: Scalars['String'];
  override_type?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An array relationship */
  values: Array<AmpCreativeDimensionValues>;
  version: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_creative_dimensions" */
export type AmpCreativeDimensionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_creative_dimensions" */
export type AmpCreativeDimensionsValuesArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionValuesOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
};

/** aggregated selection of "amp_creative_dimensions" */
export type AmpCreativeDimensionsAggregate = {
  __typename?: 'amp_creative_dimensions_aggregate';
  aggregate?: Maybe<AmpCreativeDimensionsAggregateFields>;
  nodes: Array<AmpCreativeDimensions>;
};

/** aggregate fields of "amp_creative_dimensions" */
export type AmpCreativeDimensionsAggregateFields = {
  __typename?: 'amp_creative_dimensions_aggregate_fields';
  avg?: Maybe<AmpCreativeDimensionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpCreativeDimensionsMaxFields>;
  min?: Maybe<AmpCreativeDimensionsMinFields>;
  stddev?: Maybe<AmpCreativeDimensionsStddevFields>;
  stddev_pop?: Maybe<AmpCreativeDimensionsStddevPopFields>;
  stddev_samp?: Maybe<AmpCreativeDimensionsStddevSampFields>;
  sum?: Maybe<AmpCreativeDimensionsSumFields>;
  var_pop?: Maybe<AmpCreativeDimensionsVarPopFields>;
  var_samp?: Maybe<AmpCreativeDimensionsVarSampFields>;
  variance?: Maybe<AmpCreativeDimensionsVarianceFields>;
};


/** aggregate fields of "amp_creative_dimensions" */
export type AmpCreativeDimensionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpCreativeDimensionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AmpCreativeDimensionsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AmpCreativeDimensionsAvgFields = {
  __typename?: 'amp_creative_dimensions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_creative_dimensions". All fields are combined with a logical 'AND'. */
export type AmpCreativeDimensionsBoolExp = {
  _and?: InputMaybe<Array<AmpCreativeDimensionsBoolExp>>;
  _not?: InputMaybe<AmpCreativeDimensionsBoolExp>;
  _or?: InputMaybe<Array<AmpCreativeDimensionsBoolExp>>;
  allow_learning?: InputMaybe<BooleanComparisonExp>;
  asset_group_id?: InputMaybe<UuidComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  minor_version?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  namespace?: InputMaybe<StringComparisonExp>;
  override_type?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  values?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_creative_dimensions" */
export const AmpCreativeDimensionsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpCreativeDimensionsIdWorkspaceIdKey: 'amp_creative_dimensions_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AmpCreativeDimensionsPkey: 'amp_creative_dimensions_pkey',
  /** unique or primary key constraint on columns "key", "workspace_id", "namespace" */
  AmpCreativeDimensionsWorkspaceIdNamespaceKeyKey: 'amp_creative_dimensions_workspace_id_namespace_key_key'
} as const;

export type AmpCreativeDimensionsConstraint = typeof AmpCreativeDimensionsConstraint[keyof typeof AmpCreativeDimensionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AmpCreativeDimensionsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AmpCreativeDimensionsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AmpCreativeDimensionsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "amp_creative_dimensions" */
export type AmpCreativeDimensionsIncInput = {
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "amp_creative_dimensions" */
export type AmpCreativeDimensionsInsertInput = {
  asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AmpCreativeDimensionsMaxFields = {
  __typename?: 'amp_creative_dimensions_max_fields';
  asset_group_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  minor_version?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  namespace?: Maybe<Scalars['String']>;
  override_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpCreativeDimensionsMinFields = {
  __typename?: 'amp_creative_dimensions_min_fields';
  asset_group_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  minor_version?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  namespace?: Maybe<Scalars['String']>;
  override_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_creative_dimensions" */
export type AmpCreativeDimensionsMutationResponse = {
  __typename?: 'amp_creative_dimensions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpCreativeDimensions>;
};

/** on_conflict condition type for table "amp_creative_dimensions" */
export type AmpCreativeDimensionsOnConflict = {
  constraint: AmpCreativeDimensionsConstraint;
  update_columns?: Array<AmpCreativeDimensionsUpdateColumn>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};

/** Ordering options when selecting data from "amp_creative_dimensions". */
export type AmpCreativeDimensionsOrderBy = {
  allow_learning?: InputMaybe<OrderBy>;
  asset_group_id?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  minor_version?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  namespace?: InputMaybe<OrderBy>;
  override_type?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  values_aggregate?: InputMaybe<AmpCreativeDimensionValuesAggregateOrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_creative_dimensions */
export type AmpCreativeDimensionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AmpCreativeDimensionsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "amp_creative_dimensions" */
export const AmpCreativeDimensionsSelectColumn = {
  /** column name */
  AllowLearning: 'allow_learning',
  /** column name */
  AssetGroupId: 'asset_group_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  MinorVersion: 'minor_version',
  /** column name */
  Name: 'name',
  /** column name */
  Namespace: 'namespace',
  /** column name */
  OverrideType: 'override_type',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpCreativeDimensionsSelectColumn = typeof AmpCreativeDimensionsSelectColumn[keyof typeof AmpCreativeDimensionsSelectColumn];
/** input type for updating data in table "amp_creative_dimensions" */
export type AmpCreativeDimensionsSetInput = {
  asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AmpCreativeDimensionsStddevFields = {
  __typename?: 'amp_creative_dimensions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpCreativeDimensionsStddevPopFields = {
  __typename?: 'amp_creative_dimensions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpCreativeDimensionsStddevSampFields = {
  __typename?: 'amp_creative_dimensions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_creative_dimensions" */
export type AmpCreativeDimensionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpCreativeDimensionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpCreativeDimensionsStreamCursorValueInput = {
  allow_learning?: InputMaybe<Scalars['Boolean']>;
  asset_group_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  minor_version?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<Scalars['String']>;
  override_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpCreativeDimensionsSumFields = {
  __typename?: 'amp_creative_dimensions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  minor_version?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_creative_dimensions" */
export const AmpCreativeDimensionsUpdateColumn = {
  /** column name */
  AssetGroupId: 'asset_group_id',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  Type: 'type',
  /** column name */
  Version: 'version'
} as const;

export type AmpCreativeDimensionsUpdateColumn = typeof AmpCreativeDimensionsUpdateColumn[keyof typeof AmpCreativeDimensionsUpdateColumn];
export type AmpCreativeDimensionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AmpCreativeDimensionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AmpCreativeDimensionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AmpCreativeDimensionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AmpCreativeDimensionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AmpCreativeDimensionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AmpCreativeDimensionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpCreativeDimensionsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpCreativeDimensionsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpCreativeDimensionsVarPopFields = {
  __typename?: 'amp_creative_dimensions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpCreativeDimensionsVarSampFields = {
  __typename?: 'amp_creative_dimensions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpCreativeDimensionsVarianceFields = {
  __typename?: 'amp_creative_dimensions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  minor_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_file_favorites" */
export type AmpFileFavorites = {
  __typename?: 'amp_file_favorites';
  /** An object relationship */
  amp_file?: Maybe<AmpFiles>;
  amp_file_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "amp_file_favorites". All fields are combined with a logical 'AND'. */
export type AmpFileFavoritesBoolExp = {
  _and?: InputMaybe<Array<AmpFileFavoritesBoolExp>>;
  _not?: InputMaybe<AmpFileFavoritesBoolExp>;
  _or?: InputMaybe<Array<AmpFileFavoritesBoolExp>>;
  amp_file?: InputMaybe<AmpFilesBoolExp>;
  amp_file_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_file_favorites" */
export const AmpFileFavoritesConstraint = {
  /** unique or primary key constraint on columns "user_id", "amp_file_id" */
  AmpFileFavoritesPkey: 'amp_file_favorites_pkey'
} as const;

export type AmpFileFavoritesConstraint = typeof AmpFileFavoritesConstraint[keyof typeof AmpFileFavoritesConstraint];
/** input type for inserting data into table "amp_file_favorites" */
export type AmpFileFavoritesInsertInput = {
  amp_file_id?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "amp_file_favorites" */
export type AmpFileFavoritesMutationResponse = {
  __typename?: 'amp_file_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpFileFavorites>;
};

/** on_conflict condition type for table "amp_file_favorites" */
export type AmpFileFavoritesOnConflict = {
  constraint: AmpFileFavoritesConstraint;
  update_columns?: Array<AmpFileFavoritesUpdateColumn>;
  where?: InputMaybe<AmpFileFavoritesBoolExp>;
};

/** Ordering options when selecting data from "amp_file_favorites". */
export type AmpFileFavoritesOrderBy = {
  amp_file?: InputMaybe<AmpFilesOrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_file_favorites" */
export const AmpFileFavoritesSelectColumn = {
  /** column name */
  AmpFileId: 'amp_file_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpFileFavoritesSelectColumn = typeof AmpFileFavoritesSelectColumn[keyof typeof AmpFileFavoritesSelectColumn];
/** Streaming cursor of the table "amp_file_favorites" */
export type AmpFileFavoritesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpFileFavoritesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpFileFavoritesStreamCursorValueInput = {
  amp_file_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "amp_file_favorites" (current role has no relevant permissions) */
export const AmpFileFavoritesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpFileFavoritesUpdateColumn = typeof AmpFileFavoritesUpdateColumn[keyof typeof AmpFileFavoritesUpdateColumn];
/** columns and relationships of "amp_files" */
export type AmpFiles = {
  __typename?: 'amp_files';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  canvas_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  generation_status: Scalars['String'];
  id: Scalars['uuid'];
  is_draft: Scalars['Boolean'];
  /** A computed field, executes function "amp_file_name" */
  name?: Maybe<Scalars['String']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  visibility: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_files" */
export type AmpFilesAggregate = {
  __typename?: 'amp_files_aggregate';
  aggregate?: Maybe<AmpFilesAggregateFields>;
  nodes: Array<AmpFiles>;
};

/** aggregate fields of "amp_files" */
export type AmpFilesAggregateFields = {
  __typename?: 'amp_files_aggregate_fields';
  avg?: Maybe<AmpFilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpFilesMaxFields>;
  min?: Maybe<AmpFilesMinFields>;
  stddev?: Maybe<AmpFilesStddevFields>;
  stddev_pop?: Maybe<AmpFilesStddevPopFields>;
  stddev_samp?: Maybe<AmpFilesStddevSampFields>;
  sum?: Maybe<AmpFilesSumFields>;
  var_pop?: Maybe<AmpFilesVarPopFields>;
  var_samp?: Maybe<AmpFilesVarSampFields>;
  variance?: Maybe<AmpFilesVarianceFields>;
};


/** aggregate fields of "amp_files" */
export type AmpFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpFilesAvgFields = {
  __typename?: 'amp_files_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_files". All fields are combined with a logical 'AND'. */
export type AmpFilesBoolExp = {
  _and?: InputMaybe<Array<AmpFilesBoolExp>>;
  _not?: InputMaybe<AmpFilesBoolExp>;
  _or?: InputMaybe<Array<AmpFilesBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  canvas_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  generation_status?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_draft?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  settings_entity_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  visibility?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpFilesMaxFields = {
  __typename?: 'amp_files_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  canvas_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  generation_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "amp_file_name" */
  name?: Maybe<Scalars['String']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpFilesMinFields = {
  __typename?: 'amp_files_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  canvas_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  generation_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "amp_file_name" */
  name?: Maybe<Scalars['String']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "amp_files". */
export type AmpFilesOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  canvas_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  generation_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_draft?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  visibility?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_files" */
export const AmpFilesSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  CanvasId: 'canvas_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  GenerationStatus: 'generation_status',
  /** column name */
  Id: 'id',
  /** column name */
  IsDraft: 'is_draft',
  /** column name */
  SettingsEntityId: 'settings_entity_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  Visibility: 'visibility',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpFilesSelectColumn = typeof AmpFilesSelectColumn[keyof typeof AmpFilesSelectColumn];
/** aggregate stddev on columns */
export type AmpFilesStddevFields = {
  __typename?: 'amp_files_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpFilesStddevPopFields = {
  __typename?: 'amp_files_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpFilesStddevSampFields = {
  __typename?: 'amp_files_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_files" */
export type AmpFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpFilesStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  canvas_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  generation_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  settings_entity_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpFilesSumFields = {
  __typename?: 'amp_files_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AmpFilesVarPopFields = {
  __typename?: 'amp_files_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpFilesVarSampFields = {
  __typename?: 'amp_files_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpFilesVarianceFields = {
  __typename?: 'amp_files_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_followed_sources" */
export type AmpFollowedSources = {
  __typename?: 'amp_followed_sources';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  id: Scalars['uuid'];
  source: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_followed_sources" */
export type AmpFollowedSourcesAggregate = {
  __typename?: 'amp_followed_sources_aggregate';
  aggregate?: Maybe<AmpFollowedSourcesAggregateFields>;
  nodes: Array<AmpFollowedSources>;
};

/** aggregate fields of "amp_followed_sources" */
export type AmpFollowedSourcesAggregateFields = {
  __typename?: 'amp_followed_sources_aggregate_fields';
  avg?: Maybe<AmpFollowedSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpFollowedSourcesMaxFields>;
  min?: Maybe<AmpFollowedSourcesMinFields>;
  stddev?: Maybe<AmpFollowedSourcesStddevFields>;
  stddev_pop?: Maybe<AmpFollowedSourcesStddevPopFields>;
  stddev_samp?: Maybe<AmpFollowedSourcesStddevSampFields>;
  sum?: Maybe<AmpFollowedSourcesSumFields>;
  var_pop?: Maybe<AmpFollowedSourcesVarPopFields>;
  var_samp?: Maybe<AmpFollowedSourcesVarSampFields>;
  variance?: Maybe<AmpFollowedSourcesVarianceFields>;
};


/** aggregate fields of "amp_followed_sources" */
export type AmpFollowedSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpFollowedSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpFollowedSourcesAvgFields = {
  __typename?: 'amp_followed_sources_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_followed_sources". All fields are combined with a logical 'AND'. */
export type AmpFollowedSourcesBoolExp = {
  _and?: InputMaybe<Array<AmpFollowedSourcesBoolExp>>;
  _not?: InputMaybe<AmpFollowedSourcesBoolExp>;
  _or?: InputMaybe<Array<AmpFollowedSourcesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_followed_sources" */
export const AmpFollowedSourcesConstraint = {
  /** unique or primary key constraint on columns "id" */
  AdsFollowedSourcesPkey: 'ads_followed_sources_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  AmpFollowedSourcesWsSource: 'amp_followed_sources_ws_source'
} as const;

export type AmpFollowedSourcesConstraint = typeof AmpFollowedSourcesConstraint[keyof typeof AmpFollowedSourcesConstraint];
/** input type for inserting data into table "amp_followed_sources" */
export type AmpFollowedSourcesInsertInput = {
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmpFollowedSourcesMaxFields = {
  __typename?: 'amp_followed_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpFollowedSourcesMinFields = {
  __typename?: 'amp_followed_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_followed_sources" */
export type AmpFollowedSourcesMutationResponse = {
  __typename?: 'amp_followed_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpFollowedSources>;
};

/** on_conflict condition type for table "amp_followed_sources" */
export type AmpFollowedSourcesOnConflict = {
  constraint: AmpFollowedSourcesConstraint;
  update_columns?: Array<AmpFollowedSourcesUpdateColumn>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};

/** Ordering options when selecting data from "amp_followed_sources". */
export type AmpFollowedSourcesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_followed_sources */
export type AmpFollowedSourcesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_followed_sources" */
export const AmpFollowedSourcesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Source: 'source',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpFollowedSourcesSelectColumn = typeof AmpFollowedSourcesSelectColumn[keyof typeof AmpFollowedSourcesSelectColumn];
/** input type for updating data in table "amp_followed_sources" */
export type AmpFollowedSourcesSetInput = {
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpFollowedSourcesStddevFields = {
  __typename?: 'amp_followed_sources_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpFollowedSourcesStddevPopFields = {
  __typename?: 'amp_followed_sources_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpFollowedSourcesStddevSampFields = {
  __typename?: 'amp_followed_sources_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_followed_sources" */
export type AmpFollowedSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpFollowedSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpFollowedSourcesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpFollowedSourcesSumFields = {
  __typename?: 'amp_followed_sources_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_followed_sources" */
export const AmpFollowedSourcesUpdateColumn = {
  /** column name */
  Source: 'source'
} as const;

export type AmpFollowedSourcesUpdateColumn = typeof AmpFollowedSourcesUpdateColumn[keyof typeof AmpFollowedSourcesUpdateColumn];
export type AmpFollowedSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpFollowedSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: AmpFollowedSourcesBoolExp;
};

/** aggregate var_pop on columns */
export type AmpFollowedSourcesVarPopFields = {
  __typename?: 'amp_followed_sources_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpFollowedSourcesVarSampFields = {
  __typename?: 'amp_followed_sources_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpFollowedSourcesVarianceFields = {
  __typename?: 'amp_followed_sources_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_followed_topics" */
export type AmpFollowedTopics = {
  __typename?: 'amp_followed_topics';
  classification: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  id: Scalars['uuid'];
  label: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_followed_topics" */
export type AmpFollowedTopicsClassificationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_followed_topics" */
export type AmpFollowedTopicsAggregate = {
  __typename?: 'amp_followed_topics_aggregate';
  aggregate?: Maybe<AmpFollowedTopicsAggregateFields>;
  nodes: Array<AmpFollowedTopics>;
};

/** aggregate fields of "amp_followed_topics" */
export type AmpFollowedTopicsAggregateFields = {
  __typename?: 'amp_followed_topics_aggregate_fields';
  avg?: Maybe<AmpFollowedTopicsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpFollowedTopicsMaxFields>;
  min?: Maybe<AmpFollowedTopicsMinFields>;
  stddev?: Maybe<AmpFollowedTopicsStddevFields>;
  stddev_pop?: Maybe<AmpFollowedTopicsStddevPopFields>;
  stddev_samp?: Maybe<AmpFollowedTopicsStddevSampFields>;
  sum?: Maybe<AmpFollowedTopicsSumFields>;
  var_pop?: Maybe<AmpFollowedTopicsVarPopFields>;
  var_samp?: Maybe<AmpFollowedTopicsVarSampFields>;
  variance?: Maybe<AmpFollowedTopicsVarianceFields>;
};


/** aggregate fields of "amp_followed_topics" */
export type AmpFollowedTopicsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpFollowedTopicsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AmpFollowedTopicsAppendInput = {
  classification?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AmpFollowedTopicsAvgFields = {
  __typename?: 'amp_followed_topics_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_followed_topics". All fields are combined with a logical 'AND'. */
export type AmpFollowedTopicsBoolExp = {
  _and?: InputMaybe<Array<AmpFollowedTopicsBoolExp>>;
  _not?: InputMaybe<AmpFollowedTopicsBoolExp>;
  _or?: InputMaybe<Array<AmpFollowedTopicsBoolExp>>;
  classification?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_followed_topics" */
export const AmpFollowedTopicsConstraint = {
  /** unique or primary key constraint on columns "id" */
  AdsFollowedTopicsPkey: 'ads_followed_topics_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  AmpFollowedTopicsWsLabel: 'amp_followed_topics_ws_label'
} as const;

export type AmpFollowedTopicsConstraint = typeof AmpFollowedTopicsConstraint[keyof typeof AmpFollowedTopicsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AmpFollowedTopicsDeleteAtPathInput = {
  classification?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AmpFollowedTopicsDeleteElemInput = {
  classification?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AmpFollowedTopicsDeleteKeyInput = {
  classification?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "amp_followed_topics" */
export type AmpFollowedTopicsInsertInput = {
  classification?: InputMaybe<Scalars['jsonb']>;
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmpFollowedTopicsMaxFields = {
  __typename?: 'amp_followed_topics_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpFollowedTopicsMinFields = {
  __typename?: 'amp_followed_topics_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_followed_topics" */
export type AmpFollowedTopicsMutationResponse = {
  __typename?: 'amp_followed_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpFollowedTopics>;
};

/** on_conflict condition type for table "amp_followed_topics" */
export type AmpFollowedTopicsOnConflict = {
  constraint: AmpFollowedTopicsConstraint;
  update_columns?: Array<AmpFollowedTopicsUpdateColumn>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};

/** Ordering options when selecting data from "amp_followed_topics". */
export type AmpFollowedTopicsOrderBy = {
  classification?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_followed_topics */
export type AmpFollowedTopicsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AmpFollowedTopicsPrependInput = {
  classification?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "amp_followed_topics" */
export const AmpFollowedTopicsSelectColumn = {
  /** column name */
  Classification: 'classification',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Label: 'label',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpFollowedTopicsSelectColumn = typeof AmpFollowedTopicsSelectColumn[keyof typeof AmpFollowedTopicsSelectColumn];
/** input type for updating data in table "amp_followed_topics" */
export type AmpFollowedTopicsSetInput = {
  classification?: InputMaybe<Scalars['jsonb']>;
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpFollowedTopicsStddevFields = {
  __typename?: 'amp_followed_topics_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpFollowedTopicsStddevPopFields = {
  __typename?: 'amp_followed_topics_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpFollowedTopicsStddevSampFields = {
  __typename?: 'amp_followed_topics_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_followed_topics" */
export type AmpFollowedTopicsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpFollowedTopicsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpFollowedTopicsStreamCursorValueInput = {
  classification?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpFollowedTopicsSumFields = {
  __typename?: 'amp_followed_topics_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_followed_topics" */
export const AmpFollowedTopicsUpdateColumn = {
  /** column name */
  Classification: 'classification',
  /** column name */
  Label: 'label',
  /** column name */
  Type: 'type'
} as const;

export type AmpFollowedTopicsUpdateColumn = typeof AmpFollowedTopicsUpdateColumn[keyof typeof AmpFollowedTopicsUpdateColumn];
export type AmpFollowedTopicsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AmpFollowedTopicsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AmpFollowedTopicsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AmpFollowedTopicsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AmpFollowedTopicsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AmpFollowedTopicsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpFollowedTopicsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpFollowedTopicsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpFollowedTopicsVarPopFields = {
  __typename?: 'amp_followed_topics_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpFollowedTopicsVarSampFields = {
  __typename?: 'amp_followed_topics_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpFollowedTopicsVarianceFields = {
  __typename?: 'amp_followed_topics_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_launch_verdicts" */
export type AmpLaunchVerdicts = {
  __typename?: 'amp_launch_verdicts';
  bucket?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  criterion?: Maybe<Scalars['String']>;
  entity_key?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  level: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  report_schedule_run: ReportScheduleRuns;
  report_schedule_run_id: Scalars['uuid'];
  run?: Maybe<Scalars['jsonb']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_launch_verdicts" */
export type AmpLaunchVerdictsRunArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsAggregateOrderBy = {
  avg?: InputMaybe<AmpLaunchVerdictsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpLaunchVerdictsMaxOrderBy>;
  min?: InputMaybe<AmpLaunchVerdictsMinOrderBy>;
  stddev?: InputMaybe<AmpLaunchVerdictsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpLaunchVerdictsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpLaunchVerdictsStddevSampOrderBy>;
  sum?: InputMaybe<AmpLaunchVerdictsSumOrderBy>;
  var_pop?: InputMaybe<AmpLaunchVerdictsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpLaunchVerdictsVarSampOrderBy>;
  variance?: InputMaybe<AmpLaunchVerdictsVarianceOrderBy>;
};

/** order by avg() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_launch_verdicts". All fields are combined with a logical 'AND'. */
export type AmpLaunchVerdictsBoolExp = {
  _and?: InputMaybe<Array<AmpLaunchVerdictsBoolExp>>;
  _not?: InputMaybe<AmpLaunchVerdictsBoolExp>;
  _or?: InputMaybe<Array<AmpLaunchVerdictsBoolExp>>;
  bucket?: InputMaybe<StringComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  criterion?: InputMaybe<StringComparisonExp>;
  entity_key?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  level?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  run?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsMaxOrderBy = {
  bucket?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  criterion?: InputMaybe<OrderBy>;
  entity_key?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsMinOrderBy = {
  bucket?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  criterion?: InputMaybe<OrderBy>;
  entity_key?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_launch_verdicts". */
export type AmpLaunchVerdictsOrderBy = {
  bucket?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  criterion?: InputMaybe<OrderBy>;
  entity_key?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  level?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  run?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_launch_verdicts" */
export const AmpLaunchVerdictsSelectColumn = {
  /** column name */
  Bucket: 'bucket',
  /** column name */
  Channel: 'channel',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Criterion: 'criterion',
  /** column name */
  EntityKey: 'entity_key',
  /** column name */
  Id: 'id',
  /** column name */
  Label: 'label',
  /** column name */
  Level: 'level',
  /** column name */
  Reason: 'reason',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  Run: 'run',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpLaunchVerdictsSelectColumn = typeof AmpLaunchVerdictsSelectColumn[keyof typeof AmpLaunchVerdictsSelectColumn];
/** order by stddev() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_launch_verdicts" */
export type AmpLaunchVerdictsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpLaunchVerdictsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpLaunchVerdictsStreamCursorValueInput = {
  bucket?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  criterion?: InputMaybe<Scalars['String']>;
  entity_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  run?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "amp_launch_verdicts" */
export type AmpLaunchVerdictsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_opportunities" */
export type AmpOpportunities = {
  __typename?: 'amp_opportunities';
  agent_session_id: Scalars['uuid'];
  brand_profile_id: Scalars['uuid'];
  category: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session: LlmChatSessions;
  /** An array relationship */
  project_links: Array<AmpProjectLinks>;
  /** An aggregate relationship */
  project_links_aggregate: AmpProjectLinksAggregate;
  report: Scalars['String'];
  /** An object relationship */
  report_schedule_run: ReportScheduleRuns;
  report_schedule_run_id: Scalars['uuid'];
  status: Scalars['String'];
  summary: Scalars['String'];
  tags: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_opportunities" */
export type AmpOpportunitiesProjectLinksArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_opportunities" */
export type AmpOpportunitiesProjectLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_opportunities" */
export type AmpOpportunitiesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_opportunities" */
export type AmpOpportunitiesAggregate = {
  __typename?: 'amp_opportunities_aggregate';
  aggregate?: Maybe<AmpOpportunitiesAggregateFields>;
  nodes: Array<AmpOpportunities>;
};

export type AmpOpportunitiesAggregateBoolExp = {
  count?: InputMaybe<AmpOpportunitiesAggregateBoolExpCount>;
};

export type AmpOpportunitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpOpportunitiesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_opportunities" */
export type AmpOpportunitiesAggregateFields = {
  __typename?: 'amp_opportunities_aggregate_fields';
  avg?: Maybe<AmpOpportunitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpOpportunitiesMaxFields>;
  min?: Maybe<AmpOpportunitiesMinFields>;
  stddev?: Maybe<AmpOpportunitiesStddevFields>;
  stddev_pop?: Maybe<AmpOpportunitiesStddevPopFields>;
  stddev_samp?: Maybe<AmpOpportunitiesStddevSampFields>;
  sum?: Maybe<AmpOpportunitiesSumFields>;
  var_pop?: Maybe<AmpOpportunitiesVarPopFields>;
  var_samp?: Maybe<AmpOpportunitiesVarSampFields>;
  variance?: Maybe<AmpOpportunitiesVarianceFields>;
};


/** aggregate fields of "amp_opportunities" */
export type AmpOpportunitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_opportunities" */
export type AmpOpportunitiesAggregateOrderBy = {
  avg?: InputMaybe<AmpOpportunitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpOpportunitiesMaxOrderBy>;
  min?: InputMaybe<AmpOpportunitiesMinOrderBy>;
  stddev?: InputMaybe<AmpOpportunitiesStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpOpportunitiesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpOpportunitiesStddevSampOrderBy>;
  sum?: InputMaybe<AmpOpportunitiesSumOrderBy>;
  var_pop?: InputMaybe<AmpOpportunitiesVarPopOrderBy>;
  var_samp?: InputMaybe<AmpOpportunitiesVarSampOrderBy>;
  variance?: InputMaybe<AmpOpportunitiesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpOpportunitiesAvgFields = {
  __typename?: 'amp_opportunities_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_opportunities" */
export type AmpOpportunitiesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_opportunities". All fields are combined with a logical 'AND'. */
export type AmpOpportunitiesBoolExp = {
  _and?: InputMaybe<Array<AmpOpportunitiesBoolExp>>;
  _not?: InputMaybe<AmpOpportunitiesBoolExp>;
  _or?: InputMaybe<Array<AmpOpportunitiesBoolExp>>;
  agent_session_id?: InputMaybe<UuidComparisonExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  headline?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  project_links?: InputMaybe<AmpProjectLinksBoolExp>;
  project_links_aggregate?: InputMaybe<AmpProjectLinksAggregateBoolExp>;
  report?: InputMaybe<StringComparisonExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpOpportunitiesMaxFields = {
  __typename?: 'amp_opportunities_max_fields';
  agent_session_id?: Maybe<Scalars['uuid']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  report?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_opportunities" */
export type AmpOpportunitiesMaxOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpOpportunitiesMinFields = {
  __typename?: 'amp_opportunities_min_fields';
  agent_session_id?: Maybe<Scalars['uuid']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  report?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_opportunities" */
export type AmpOpportunitiesMinOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_opportunities" */
export type AmpOpportunitiesMutationResponse = {
  __typename?: 'amp_opportunities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpOpportunities>;
};

/** Ordering options when selecting data from "amp_opportunities". */
export type AmpOpportunitiesOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  project_links_aggregate?: InputMaybe<AmpProjectLinksAggregateOrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_opportunities */
export type AmpOpportunitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_opportunities" */
export const AmpOpportunitiesSelectColumn = {
  /** column name */
  AgentSessionId: 'agent_session_id',
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  Category: 'category',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Headline: 'headline',
  /** column name */
  Id: 'id',
  /** column name */
  Report: 'report',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  Status: 'status',
  /** column name */
  Summary: 'summary',
  /** column name */
  Tags: 'tags',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpOpportunitiesSelectColumn = typeof AmpOpportunitiesSelectColumn[keyof typeof AmpOpportunitiesSelectColumn];
/** input type for updating data in table "amp_opportunities" */
export type AmpOpportunitiesSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpOpportunitiesStddevFields = {
  __typename?: 'amp_opportunities_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_opportunities" */
export type AmpOpportunitiesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpOpportunitiesStddevPopFields = {
  __typename?: 'amp_opportunities_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_opportunities" */
export type AmpOpportunitiesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpOpportunitiesStddevSampFields = {
  __typename?: 'amp_opportunities_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_opportunities" */
export type AmpOpportunitiesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_opportunities" */
export type AmpOpportunitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpOpportunitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpOpportunitiesStreamCursorValueInput = {
  agent_session_id?: InputMaybe<Scalars['uuid']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  report?: InputMaybe<Scalars['String']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpOpportunitiesSumFields = {
  __typename?: 'amp_opportunities_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_opportunities" */
export type AmpOpportunitiesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

export type AmpOpportunitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpOpportunitiesSetInput>;
  /** filter the rows which have to be updated */
  where: AmpOpportunitiesBoolExp;
};

/** aggregate var_pop on columns */
export type AmpOpportunitiesVarPopFields = {
  __typename?: 'amp_opportunities_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_opportunities" */
export type AmpOpportunitiesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpOpportunitiesVarSampFields = {
  __typename?: 'amp_opportunities_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_opportunities" */
export type AmpOpportunitiesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpOpportunitiesVarianceFields = {
  __typename?: 'amp_opportunities_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_opportunities" */
export type AmpOpportunitiesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_project_links" */
export type AmpProjectLinks = {
  __typename?: 'amp_project_links';
  /** An object relationship */
  ad_studio_project_brief_version?: Maybe<AdStudioProjectBriefVersions>;
  ad_studio_project_brief_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_action?: Maybe<AmpActions>;
  amp_action_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_action_plan?: Maybe<AmpActionPlans>;
  amp_action_plan_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_file?: Maybe<AmpFiles>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_opportunity?: Maybe<AmpOpportunities>;
  amp_opportunity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  audience?: Maybe<Segments>;
  audience_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id?: Maybe<Scalars['bigint']>;
  external?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  marketing_campaign?: Maybe<MarketingCampaigns>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  native_delivery_campaign?: Maybe<Campaigns>;
  native_delivery_campaign_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  project?: Maybe<AmpProjects>;
  project_id: Scalars['uuid'];
  /** An object relationship */
  sync?: Maybe<DestinationInstances>;
  sync_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  task?: Maybe<AmpTasks>;
  task_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_project_links" */
export type AmpProjectLinksExternalArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_project_links" */
export type AmpProjectLinksAggregate = {
  __typename?: 'amp_project_links_aggregate';
  aggregate?: Maybe<AmpProjectLinksAggregateFields>;
  nodes: Array<AmpProjectLinks>;
};

export type AmpProjectLinksAggregateBoolExp = {
  count?: InputMaybe<AmpProjectLinksAggregateBoolExpCount>;
};

export type AmpProjectLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpProjectLinksBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_project_links" */
export type AmpProjectLinksAggregateFields = {
  __typename?: 'amp_project_links_aggregate_fields';
  avg?: Maybe<AmpProjectLinksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpProjectLinksMaxFields>;
  min?: Maybe<AmpProjectLinksMinFields>;
  stddev?: Maybe<AmpProjectLinksStddevFields>;
  stddev_pop?: Maybe<AmpProjectLinksStddevPopFields>;
  stddev_samp?: Maybe<AmpProjectLinksStddevSampFields>;
  sum?: Maybe<AmpProjectLinksSumFields>;
  var_pop?: Maybe<AmpProjectLinksVarPopFields>;
  var_samp?: Maybe<AmpProjectLinksVarSampFields>;
  variance?: Maybe<AmpProjectLinksVarianceFields>;
};


/** aggregate fields of "amp_project_links" */
export type AmpProjectLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_project_links" */
export type AmpProjectLinksAggregateOrderBy = {
  avg?: InputMaybe<AmpProjectLinksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpProjectLinksMaxOrderBy>;
  min?: InputMaybe<AmpProjectLinksMinOrderBy>;
  stddev?: InputMaybe<AmpProjectLinksStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpProjectLinksStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpProjectLinksStddevSampOrderBy>;
  sum?: InputMaybe<AmpProjectLinksSumOrderBy>;
  var_pop?: InputMaybe<AmpProjectLinksVarPopOrderBy>;
  var_samp?: InputMaybe<AmpProjectLinksVarSampOrderBy>;
  variance?: InputMaybe<AmpProjectLinksVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpProjectLinksAvgFields = {
  __typename?: 'amp_project_links_avg_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_project_links" */
export type AmpProjectLinksAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_project_links". All fields are combined with a logical 'AND'. */
export type AmpProjectLinksBoolExp = {
  _and?: InputMaybe<Array<AmpProjectLinksBoolExp>>;
  _not?: InputMaybe<AmpProjectLinksBoolExp>;
  _or?: InputMaybe<Array<AmpProjectLinksBoolExp>>;
  ad_studio_project_brief_version?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
  ad_studio_project_brief_version_id?: InputMaybe<UuidComparisonExp>;
  amp_action?: InputMaybe<AmpActionsBoolExp>;
  amp_action_id?: InputMaybe<UuidComparisonExp>;
  amp_action_plan?: InputMaybe<AmpActionPlansBoolExp>;
  amp_action_plan_id?: InputMaybe<UuidComparisonExp>;
  amp_file?: InputMaybe<AmpFilesBoolExp>;
  amp_file_id?: InputMaybe<UuidComparisonExp>;
  amp_opportunity?: InputMaybe<AmpOpportunitiesBoolExp>;
  amp_opportunity_id?: InputMaybe<UuidComparisonExp>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  external?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  marketing_campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  marketing_campaign_id?: InputMaybe<UuidComparisonExp>;
  native_delivery_campaign?: InputMaybe<CampaignsBoolExp>;
  native_delivery_campaign_id?: InputMaybe<UuidComparisonExp>;
  project?: InputMaybe<AmpProjectsBoolExp>;
  project_id?: InputMaybe<UuidComparisonExp>;
  sync?: InputMaybe<DestinationInstancesBoolExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  task?: InputMaybe<AmpTasksBoolExp>;
  task_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpProjectLinksMaxFields = {
  __typename?: 'amp_project_links_max_fields';
  ad_studio_project_brief_version_id?: Maybe<Scalars['uuid']>;
  amp_action_id?: Maybe<Scalars['uuid']>;
  amp_action_plan_id?: Maybe<Scalars['uuid']>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  amp_opportunity_id?: Maybe<Scalars['uuid']>;
  audience_id?: Maybe<Scalars['bigint']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  native_delivery_campaign_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['bigint']>;
  task_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_project_links" */
export type AmpProjectLinksMaxOrderBy = {
  ad_studio_project_brief_version_id?: InputMaybe<OrderBy>;
  amp_action_id?: InputMaybe<OrderBy>;
  amp_action_plan_id?: InputMaybe<OrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_opportunity_id?: InputMaybe<OrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  native_delivery_campaign_id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpProjectLinksMinFields = {
  __typename?: 'amp_project_links_min_fields';
  ad_studio_project_brief_version_id?: Maybe<Scalars['uuid']>;
  amp_action_id?: Maybe<Scalars['uuid']>;
  amp_action_plan_id?: Maybe<Scalars['uuid']>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  amp_opportunity_id?: Maybe<Scalars['uuid']>;
  audience_id?: Maybe<Scalars['bigint']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  native_delivery_campaign_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['bigint']>;
  task_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_project_links" */
export type AmpProjectLinksMinOrderBy = {
  ad_studio_project_brief_version_id?: InputMaybe<OrderBy>;
  amp_action_id?: InputMaybe<OrderBy>;
  amp_action_plan_id?: InputMaybe<OrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_opportunity_id?: InputMaybe<OrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  native_delivery_campaign_id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_project_links" */
export type AmpProjectLinksMutationResponse = {
  __typename?: 'amp_project_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpProjectLinks>;
};

/** Ordering options when selecting data from "amp_project_links". */
export type AmpProjectLinksOrderBy = {
  ad_studio_project_brief_version?: InputMaybe<AdStudioProjectBriefVersionsOrderBy>;
  ad_studio_project_brief_version_id?: InputMaybe<OrderBy>;
  amp_action?: InputMaybe<AmpActionsOrderBy>;
  amp_action_id?: InputMaybe<OrderBy>;
  amp_action_plan?: InputMaybe<AmpActionPlansOrderBy>;
  amp_action_plan_id?: InputMaybe<OrderBy>;
  amp_file?: InputMaybe<AmpFilesOrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_opportunity?: InputMaybe<AmpOpportunitiesOrderBy>;
  amp_opportunity_id?: InputMaybe<OrderBy>;
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  external?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  marketing_campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  native_delivery_campaign?: InputMaybe<CampaignsOrderBy>;
  native_delivery_campaign_id?: InputMaybe<OrderBy>;
  project?: InputMaybe<AmpProjectsOrderBy>;
  project_id?: InputMaybe<OrderBy>;
  sync?: InputMaybe<DestinationInstancesOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  task?: InputMaybe<AmpTasksOrderBy>;
  task_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_project_links" */
export const AmpProjectLinksSelectColumn = {
  /** column name */
  AdStudioProjectBriefVersionId: 'ad_studio_project_brief_version_id',
  /** column name */
  AmpActionId: 'amp_action_id',
  /** column name */
  AmpActionPlanId: 'amp_action_plan_id',
  /** column name */
  AmpFileId: 'amp_file_id',
  /** column name */
  AmpOpportunityId: 'amp_opportunity_id',
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  External: 'external',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  MarketingCampaignId: 'marketing_campaign_id',
  /** column name */
  NativeDeliveryCampaignId: 'native_delivery_campaign_id',
  /** column name */
  ProjectId: 'project_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  TaskId: 'task_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpProjectLinksSelectColumn = typeof AmpProjectLinksSelectColumn[keyof typeof AmpProjectLinksSelectColumn];
/** aggregate stddev on columns */
export type AmpProjectLinksStddevFields = {
  __typename?: 'amp_project_links_stddev_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_project_links" */
export type AmpProjectLinksStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpProjectLinksStddevPopFields = {
  __typename?: 'amp_project_links_stddev_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_project_links" */
export type AmpProjectLinksStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpProjectLinksStddevSampFields = {
  __typename?: 'amp_project_links_stddev_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_project_links" */
export type AmpProjectLinksStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_project_links" */
export type AmpProjectLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpProjectLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpProjectLinksStreamCursorValueInput = {
  ad_studio_project_brief_version_id?: InputMaybe<Scalars['uuid']>;
  amp_action_id?: InputMaybe<Scalars['uuid']>;
  amp_action_plan_id?: InputMaybe<Scalars['uuid']>;
  amp_file_id?: InputMaybe<Scalars['uuid']>;
  amp_opportunity_id?: InputMaybe<Scalars['uuid']>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  external?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  native_delivery_campaign_id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpProjectLinksSumFields = {
  __typename?: 'amp_project_links_sum_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_project_links" */
export type AmpProjectLinksSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpProjectLinksVarPopFields = {
  __typename?: 'amp_project_links_var_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_project_links" */
export type AmpProjectLinksVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpProjectLinksVarSampFields = {
  __typename?: 'amp_project_links_var_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_project_links" */
export type AmpProjectLinksVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpProjectLinksVarianceFields = {
  __typename?: 'amp_project_links_variance_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_project_links" */
export type AmpProjectLinksVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_project_pins" */
export type AmpProjectPins = {
  __typename?: 'amp_project_pins';
  amp_project_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  project?: Maybe<AmpProjects>;
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "amp_project_pins". All fields are combined with a logical 'AND'. */
export type AmpProjectPinsBoolExp = {
  _and?: InputMaybe<Array<AmpProjectPinsBoolExp>>;
  _not?: InputMaybe<AmpProjectPinsBoolExp>;
  _or?: InputMaybe<Array<AmpProjectPinsBoolExp>>;
  amp_project_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  project?: InputMaybe<AmpProjectsBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_project_pins" */
export const AmpProjectPinsConstraint = {
  /** unique or primary key constraint on columns "user_id", "amp_project_id" */
  AmpProjectPinsPkey: 'amp_project_pins_pkey'
} as const;

export type AmpProjectPinsConstraint = typeof AmpProjectPinsConstraint[keyof typeof AmpProjectPinsConstraint];
/** input type for inserting data into table "amp_project_pins" */
export type AmpProjectPinsInsertInput = {
  amp_project_id?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "amp_project_pins" */
export type AmpProjectPinsMutationResponse = {
  __typename?: 'amp_project_pins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpProjectPins>;
};

/** on_conflict condition type for table "amp_project_pins" */
export type AmpProjectPinsOnConflict = {
  constraint: AmpProjectPinsConstraint;
  update_columns?: Array<AmpProjectPinsUpdateColumn>;
  where?: InputMaybe<AmpProjectPinsBoolExp>;
};

/** Ordering options when selecting data from "amp_project_pins". */
export type AmpProjectPinsOrderBy = {
  amp_project_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  project?: InputMaybe<AmpProjectsOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_project_pins" */
export const AmpProjectPinsSelectColumn = {
  /** column name */
  AmpProjectId: 'amp_project_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpProjectPinsSelectColumn = typeof AmpProjectPinsSelectColumn[keyof typeof AmpProjectPinsSelectColumn];
/** Streaming cursor of the table "amp_project_pins" */
export type AmpProjectPinsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpProjectPinsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpProjectPinsStreamCursorValueInput = {
  amp_project_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "amp_project_pins" (current role has no relevant permissions) */
export const AmpProjectPinsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpProjectPinsUpdateColumn = typeof AmpProjectPinsUpdateColumn[keyof typeof AmpProjectPinsUpdateColumn];
/** columns and relationships of "amp_project_users" */
export type AmpProjectUsers = {
  __typename?: 'amp_project_users';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  project?: Maybe<AmpProjects>;
  project_id: Scalars['uuid'];
  type: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An array relationship */
  user_memberships: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  user_memberships_aggregate: AllMembershipsV2Aggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_project_users" */
export type AmpProjectUsersUserMembershipsArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "amp_project_users" */
export type AmpProjectUsersUserMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};

/** aggregated selection of "amp_project_users" */
export type AmpProjectUsersAggregate = {
  __typename?: 'amp_project_users_aggregate';
  aggregate?: Maybe<AmpProjectUsersAggregateFields>;
  nodes: Array<AmpProjectUsers>;
};

export type AmpProjectUsersAggregateBoolExp = {
  count?: InputMaybe<AmpProjectUsersAggregateBoolExpCount>;
};

export type AmpProjectUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpProjectUsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_project_users" */
export type AmpProjectUsersAggregateFields = {
  __typename?: 'amp_project_users_aggregate_fields';
  avg?: Maybe<AmpProjectUsersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpProjectUsersMaxFields>;
  min?: Maybe<AmpProjectUsersMinFields>;
  stddev?: Maybe<AmpProjectUsersStddevFields>;
  stddev_pop?: Maybe<AmpProjectUsersStddevPopFields>;
  stddev_samp?: Maybe<AmpProjectUsersStddevSampFields>;
  sum?: Maybe<AmpProjectUsersSumFields>;
  var_pop?: Maybe<AmpProjectUsersVarPopFields>;
  var_samp?: Maybe<AmpProjectUsersVarSampFields>;
  variance?: Maybe<AmpProjectUsersVarianceFields>;
};


/** aggregate fields of "amp_project_users" */
export type AmpProjectUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_project_users" */
export type AmpProjectUsersAggregateOrderBy = {
  avg?: InputMaybe<AmpProjectUsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpProjectUsersMaxOrderBy>;
  min?: InputMaybe<AmpProjectUsersMinOrderBy>;
  stddev?: InputMaybe<AmpProjectUsersStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpProjectUsersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpProjectUsersStddevSampOrderBy>;
  sum?: InputMaybe<AmpProjectUsersSumOrderBy>;
  var_pop?: InputMaybe<AmpProjectUsersVarPopOrderBy>;
  var_samp?: InputMaybe<AmpProjectUsersVarSampOrderBy>;
  variance?: InputMaybe<AmpProjectUsersVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpProjectUsersAvgFields = {
  __typename?: 'amp_project_users_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_project_users" */
export type AmpProjectUsersAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_project_users". All fields are combined with a logical 'AND'. */
export type AmpProjectUsersBoolExp = {
  _and?: InputMaybe<Array<AmpProjectUsersBoolExp>>;
  _not?: InputMaybe<AmpProjectUsersBoolExp>;
  _or?: InputMaybe<Array<AmpProjectUsersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  project?: InputMaybe<AmpProjectsBoolExp>;
  project_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  user_memberships?: InputMaybe<AllMembershipsV2BoolExp>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_project_users" */
export const AmpProjectUsersConstraint = {
  /** unique or primary key constraint on columns "id" */
  AmpProjectUsersPkey: 'amp_project_users_pkey',
  /** unique or primary key constraint on columns "user_id", "project_id" */
  AmpProjectUsersProjectUserKey: 'amp_project_users_project_user_key'
} as const;

export type AmpProjectUsersConstraint = typeof AmpProjectUsersConstraint[keyof typeof AmpProjectUsersConstraint];
/** input type for inserting data into table "amp_project_users" */
export type AmpProjectUsersInsertInput = {
  project_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AmpProjectUsersMaxFields = {
  __typename?: 'amp_project_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_project_users" */
export type AmpProjectUsersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpProjectUsersMinFields = {
  __typename?: 'amp_project_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_project_users" */
export type AmpProjectUsersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_project_users" */
export type AmpProjectUsersMutationResponse = {
  __typename?: 'amp_project_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpProjectUsers>;
};

/** on_conflict condition type for table "amp_project_users" */
export type AmpProjectUsersOnConflict = {
  constraint: AmpProjectUsersConstraint;
  update_columns?: Array<AmpProjectUsersUpdateColumn>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};

/** Ordering options when selecting data from "amp_project_users". */
export type AmpProjectUsersOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  project?: InputMaybe<AmpProjectsOrderBy>;
  project_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_project_users" */
export const AmpProjectUsersSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  ProjectId: 'project_id',
  /** column name */
  Type: 'type',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpProjectUsersSelectColumn = typeof AmpProjectUsersSelectColumn[keyof typeof AmpProjectUsersSelectColumn];
/** aggregate stddev on columns */
export type AmpProjectUsersStddevFields = {
  __typename?: 'amp_project_users_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_project_users" */
export type AmpProjectUsersStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpProjectUsersStddevPopFields = {
  __typename?: 'amp_project_users_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_project_users" */
export type AmpProjectUsersStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpProjectUsersStddevSampFields = {
  __typename?: 'amp_project_users_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_project_users" */
export type AmpProjectUsersStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_project_users" */
export type AmpProjectUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpProjectUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpProjectUsersStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpProjectUsersSumFields = {
  __typename?: 'amp_project_users_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_project_users" */
export type AmpProjectUsersSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "amp_project_users" (current role has no relevant permissions) */
export const AmpProjectUsersUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpProjectUsersUpdateColumn = typeof AmpProjectUsersUpdateColumn[keyof typeof AmpProjectUsersUpdateColumn];
/** aggregate var_pop on columns */
export type AmpProjectUsersVarPopFields = {
  __typename?: 'amp_project_users_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_project_users" */
export type AmpProjectUsersVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpProjectUsersVarSampFields = {
  __typename?: 'amp_project_users_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_project_users" */
export type AmpProjectUsersVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpProjectUsersVarianceFields = {
  __typename?: 'amp_project_users_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_project_users" */
export type AmpProjectUsersVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_projects" */
export type AmpProjects = {
  __typename?: 'amp_projects';
  /** An array relationship */
  actions: Array<AmpActions>;
  /** An aggregate relationship */
  actions_aggregate: AmpActionsAggregate;
  archived_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  brand_profile?: Maybe<BrandProfiles>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  comment_threads: Array<AssetCommentThreads>;
  /** An aggregate relationship */
  comment_threads_aggregate: AssetCommentThreadsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  external_ref?: Maybe<Scalars['jsonb']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  links: Array<AmpProjectLinks>;
  /** An aggregate relationship */
  links_aggregate: AmpProjectLinksAggregate;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  opened_by: Scalars['String'];
  /** An object relationship */
  opened_by_user?: Maybe<Users>;
  opened_by_user_id?: Maybe<Scalars['bigint']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  status_line?: Maybe<Scalars['String']>;
  /** An array relationship */
  tasks: Array<AmpTasks>;
  /** An aggregate relationship */
  tasks_aggregate: AmpTasksAggregate;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<AmpProjectUsers>;
  /** An aggregate relationship */
  users_aggregate: AmpProjectUsersAggregate;
  /** An object relationship */
  workflow?: Maybe<AmpWorkflows>;
  workflow_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsActionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsCommentThreadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsCommentThreadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsExternalRefArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsLinksArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsTasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsTasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


/** columns and relationships of "amp_projects" */
export type AmpProjectsUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};

/** aggregated selection of "amp_projects" */
export type AmpProjectsAggregate = {
  __typename?: 'amp_projects_aggregate';
  aggregate?: Maybe<AmpProjectsAggregateFields>;
  nodes: Array<AmpProjects>;
};

export type AmpProjectsAggregateBoolExp = {
  count?: InputMaybe<AmpProjectsAggregateBoolExpCount>;
};

export type AmpProjectsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpProjectsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_projects" */
export type AmpProjectsAggregateFields = {
  __typename?: 'amp_projects_aggregate_fields';
  avg?: Maybe<AmpProjectsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpProjectsMaxFields>;
  min?: Maybe<AmpProjectsMinFields>;
  stddev?: Maybe<AmpProjectsStddevFields>;
  stddev_pop?: Maybe<AmpProjectsStddevPopFields>;
  stddev_samp?: Maybe<AmpProjectsStddevSampFields>;
  sum?: Maybe<AmpProjectsSumFields>;
  var_pop?: Maybe<AmpProjectsVarPopFields>;
  var_samp?: Maybe<AmpProjectsVarSampFields>;
  variance?: Maybe<AmpProjectsVarianceFields>;
};


/** aggregate fields of "amp_projects" */
export type AmpProjectsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_projects" */
export type AmpProjectsAggregateOrderBy = {
  avg?: InputMaybe<AmpProjectsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpProjectsMaxOrderBy>;
  min?: InputMaybe<AmpProjectsMinOrderBy>;
  stddev?: InputMaybe<AmpProjectsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpProjectsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpProjectsStddevSampOrderBy>;
  sum?: InputMaybe<AmpProjectsSumOrderBy>;
  var_pop?: InputMaybe<AmpProjectsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpProjectsVarSampOrderBy>;
  variance?: InputMaybe<AmpProjectsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AmpProjectsAppendInput = {
  external_ref?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AmpProjectsAvgFields = {
  __typename?: 'amp_projects_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_projects" */
export type AmpProjectsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_projects". All fields are combined with a logical 'AND'. */
export type AmpProjectsBoolExp = {
  _and?: InputMaybe<Array<AmpProjectsBoolExp>>;
  _not?: InputMaybe<AmpProjectsBoolExp>;
  _or?: InputMaybe<Array<AmpProjectsBoolExp>>;
  actions?: InputMaybe<AmpActionsBoolExp>;
  actions_aggregate?: InputMaybe<AmpActionsAggregateBoolExp>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  comment_threads?: InputMaybe<AssetCommentThreadsBoolExp>;
  comment_threads_aggregate?: InputMaybe<AssetCommentThreadsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  due_at?: InputMaybe<TimestamptzComparisonExp>;
  external_ref?: InputMaybe<JsonbComparisonExp>;
  icon?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  links?: InputMaybe<AmpProjectLinksBoolExp>;
  links_aggregate?: InputMaybe<AmpProjectLinksAggregateBoolExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  opened_by?: InputMaybe<StringComparisonExp>;
  opened_by_user?: InputMaybe<UsersBoolExp>;
  opened_by_user_id?: InputMaybe<BigintComparisonExp>;
  start_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_line?: InputMaybe<StringComparisonExp>;
  tasks?: InputMaybe<AmpTasksBoolExp>;
  tasks_aggregate?: InputMaybe<AmpTasksAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<AmpProjectUsersBoolExp>;
  users_aggregate?: InputMaybe<AmpProjectUsersAggregateBoolExp>;
  workflow?: InputMaybe<AmpWorkflowsBoolExp>;
  workflow_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AmpProjectsDeleteAtPathInput = {
  external_ref?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AmpProjectsDeleteElemInput = {
  external_ref?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AmpProjectsDeleteKeyInput = {
  external_ref?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmpProjectsMaxFields = {
  __typename?: 'amp_projects_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  opened_by?: Maybe<Scalars['String']>;
  opened_by_user_id?: Maybe<Scalars['bigint']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  status_line?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_projects" */
export type AmpProjectsMaxOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  icon?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  opened_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_line?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpProjectsMinFields = {
  __typename?: 'amp_projects_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  opened_by?: Maybe<Scalars['String']>;
  opened_by_user_id?: Maybe<Scalars['bigint']>;
  start_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  status_line?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_projects" */
export type AmpProjectsMinOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  icon?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  opened_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_line?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_projects" */
export type AmpProjectsMutationResponse = {
  __typename?: 'amp_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpProjects>;
};

/** Ordering options when selecting data from "amp_projects". */
export type AmpProjectsOrderBy = {
  actions_aggregate?: InputMaybe<AmpActionsAggregateOrderBy>;
  archived_at?: InputMaybe<OrderBy>;
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  comment_threads_aggregate?: InputMaybe<AssetCommentThreadsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  external_ref?: InputMaybe<OrderBy>;
  icon?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  links_aggregate?: InputMaybe<AmpProjectLinksAggregateOrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  opened_by?: InputMaybe<OrderBy>;
  opened_by_user?: InputMaybe<UsersOrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_line?: InputMaybe<OrderBy>;
  tasks_aggregate?: InputMaybe<AmpTasksAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  users_aggregate?: InputMaybe<AmpProjectUsersAggregateOrderBy>;
  workflow?: InputMaybe<AmpWorkflowsOrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_projects */
export type AmpProjectsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AmpProjectsPrependInput = {
  external_ref?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "amp_projects" */
export const AmpProjectsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Description: 'description',
  /** column name */
  DueAt: 'due_at',
  /** column name */
  ExternalRef: 'external_ref',
  /** column name */
  Icon: 'icon',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  OpenedBy: 'opened_by',
  /** column name */
  OpenedByUserId: 'opened_by_user_id',
  /** column name */
  StartAt: 'start_at',
  /** column name */
  Status: 'status',
  /** column name */
  StatusLine: 'status_line',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkflowId: 'workflow_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpProjectsSelectColumn = typeof AmpProjectsSelectColumn[keyof typeof AmpProjectsSelectColumn];
/** input type for updating data in table "amp_projects" */
export type AmpProjectsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamptz']>;
  external_ref?: InputMaybe<Scalars['jsonb']>;
  icon?: InputMaybe<Scalars['String']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  status_line?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpProjectsStddevFields = {
  __typename?: 'amp_projects_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_projects" */
export type AmpProjectsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpProjectsStddevPopFields = {
  __typename?: 'amp_projects_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_projects" */
export type AmpProjectsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpProjectsStddevSampFields = {
  __typename?: 'amp_projects_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_projects" */
export type AmpProjectsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_projects" */
export type AmpProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpProjectsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamptz']>;
  external_ref?: InputMaybe<Scalars['jsonb']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  opened_by?: InputMaybe<Scalars['String']>;
  opened_by_user_id?: InputMaybe<Scalars['bigint']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  status_line?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpProjectsSumFields = {
  __typename?: 'amp_projects_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  opened_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_projects" */
export type AmpProjectsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type AmpProjectsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AmpProjectsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AmpProjectsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AmpProjectsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AmpProjectsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AmpProjectsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpProjectsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpProjectsVarPopFields = {
  __typename?: 'amp_projects_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_projects" */
export type AmpProjectsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpProjectsVarSampFields = {
  __typename?: 'amp_projects_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_projects" */
export type AmpProjectsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpProjectsVarianceFields = {
  __typename?: 'amp_projects_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  opened_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_projects" */
export type AmpProjectsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  opened_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_signals" */
export type AmpSignals = {
  __typename?: 'amp_signals';
  agent_session_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session: LlmChatSessions;
  metadata: Scalars['jsonb'];
  report: Scalars['String'];
  /** An object relationship */
  report_schedule_run: ReportScheduleRuns;
  report_schedule_run_id: Scalars['uuid'];
  summary: Scalars['String'];
  topic_labels: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_signals" */
export type AmpSignalsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amp_signals" */
export type AmpSignalsTopicLabelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amp_signals" */
export type AmpSignalsAggregate = {
  __typename?: 'amp_signals_aggregate';
  aggregate?: Maybe<AmpSignalsAggregateFields>;
  nodes: Array<AmpSignals>;
};

export type AmpSignalsAggregateBoolExp = {
  count?: InputMaybe<AmpSignalsAggregateBoolExpCount>;
};

export type AmpSignalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpSignalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_signals" */
export type AmpSignalsAggregateFields = {
  __typename?: 'amp_signals_aggregate_fields';
  avg?: Maybe<AmpSignalsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpSignalsMaxFields>;
  min?: Maybe<AmpSignalsMinFields>;
  stddev?: Maybe<AmpSignalsStddevFields>;
  stddev_pop?: Maybe<AmpSignalsStddevPopFields>;
  stddev_samp?: Maybe<AmpSignalsStddevSampFields>;
  sum?: Maybe<AmpSignalsSumFields>;
  var_pop?: Maybe<AmpSignalsVarPopFields>;
  var_samp?: Maybe<AmpSignalsVarSampFields>;
  variance?: Maybe<AmpSignalsVarianceFields>;
};


/** aggregate fields of "amp_signals" */
export type AmpSignalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_signals" */
export type AmpSignalsAggregateOrderBy = {
  avg?: InputMaybe<AmpSignalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpSignalsMaxOrderBy>;
  min?: InputMaybe<AmpSignalsMinOrderBy>;
  stddev?: InputMaybe<AmpSignalsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpSignalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpSignalsStddevSampOrderBy>;
  sum?: InputMaybe<AmpSignalsSumOrderBy>;
  var_pop?: InputMaybe<AmpSignalsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpSignalsVarSampOrderBy>;
  variance?: InputMaybe<AmpSignalsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpSignalsAvgFields = {
  __typename?: 'amp_signals_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_signals" */
export type AmpSignalsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_signals". All fields are combined with a logical 'AND'. */
export type AmpSignalsBoolExp = {
  _and?: InputMaybe<Array<AmpSignalsBoolExp>>;
  _not?: InputMaybe<AmpSignalsBoolExp>;
  _or?: InputMaybe<Array<AmpSignalsBoolExp>>;
  agent_session_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  headline?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  report?: InputMaybe<StringComparisonExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  topic_labels?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpSignalsMaxFields = {
  __typename?: 'amp_signals_max_fields';
  agent_session_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  report?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_signals" */
export type AmpSignalsMaxOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpSignalsMinFields = {
  __typename?: 'amp_signals_min_fields';
  agent_session_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  report?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_signals" */
export type AmpSignalsMinOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_signals". */
export type AmpSignalsOrderBy = {
  agent_session_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  headline?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  metadata?: InputMaybe<OrderBy>;
  report?: InputMaybe<OrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  topic_labels?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_signals" */
export const AmpSignalsSelectColumn = {
  /** column name */
  AgentSessionId: 'agent_session_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Headline: 'headline',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Report: 'report',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  Summary: 'summary',
  /** column name */
  TopicLabels: 'topic_labels',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpSignalsSelectColumn = typeof AmpSignalsSelectColumn[keyof typeof AmpSignalsSelectColumn];
/** aggregate stddev on columns */
export type AmpSignalsStddevFields = {
  __typename?: 'amp_signals_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_signals" */
export type AmpSignalsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpSignalsStddevPopFields = {
  __typename?: 'amp_signals_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_signals" */
export type AmpSignalsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpSignalsStddevSampFields = {
  __typename?: 'amp_signals_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_signals" */
export type AmpSignalsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_signals" */
export type AmpSignalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpSignalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpSignalsStreamCursorValueInput = {
  agent_session_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  report?: InputMaybe<Scalars['String']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  summary?: InputMaybe<Scalars['String']>;
  topic_labels?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpSignalsSumFields = {
  __typename?: 'amp_signals_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_signals" */
export type AmpSignalsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpSignalsVarPopFields = {
  __typename?: 'amp_signals_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_signals" */
export type AmpSignalsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpSignalsVarSampFields = {
  __typename?: 'amp_signals_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_signals" */
export type AmpSignalsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpSignalsVarianceFields = {
  __typename?: 'amp_signals_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_signals" */
export type AmpSignalsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_tags" */
export type AmpTags = {
  __typename?: 'amp_tags';
  color?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  task_tags: Array<AmpTaskTags>;
  /** An aggregate relationship */
  task_tags_aggregate: AmpTaskTagsAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_tags" */
export type AmpTagsTaskTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


/** columns and relationships of "amp_tags" */
export type AmpTagsTaskTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};

/** aggregated selection of "amp_tags" */
export type AmpTagsAggregate = {
  __typename?: 'amp_tags_aggregate';
  aggregate?: Maybe<AmpTagsAggregateFields>;
  nodes: Array<AmpTags>;
};

/** aggregate fields of "amp_tags" */
export type AmpTagsAggregateFields = {
  __typename?: 'amp_tags_aggregate_fields';
  avg?: Maybe<AmpTagsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTagsMaxFields>;
  min?: Maybe<AmpTagsMinFields>;
  stddev?: Maybe<AmpTagsStddevFields>;
  stddev_pop?: Maybe<AmpTagsStddevPopFields>;
  stddev_samp?: Maybe<AmpTagsStddevSampFields>;
  sum?: Maybe<AmpTagsSumFields>;
  var_pop?: Maybe<AmpTagsVarPopFields>;
  var_samp?: Maybe<AmpTagsVarSampFields>;
  variance?: Maybe<AmpTagsVarianceFields>;
};


/** aggregate fields of "amp_tags" */
export type AmpTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpTagsAvgFields = {
  __typename?: 'amp_tags_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_tags". All fields are combined with a logical 'AND'. */
export type AmpTagsBoolExp = {
  _and?: InputMaybe<Array<AmpTagsBoolExp>>;
  _not?: InputMaybe<AmpTagsBoolExp>;
  _or?: InputMaybe<Array<AmpTagsBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  task_tags?: InputMaybe<AmpTaskTagsBoolExp>;
  task_tags_aggregate?: InputMaybe<AmpTaskTagsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_tags" */
export const AmpTagsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpTagsIdWorkspaceIdKey: 'amp_tags_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AmpTagsPkey: 'amp_tags_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  AmpTagsWorkspaceIdNameKey: 'amp_tags_workspace_id_name_key'
} as const;

export type AmpTagsConstraint = typeof AmpTagsConstraint[keyof typeof AmpTagsConstraint];
/** input type for inserting data into table "amp_tags" */
export type AmpTagsInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmpTagsMaxFields = {
  __typename?: 'amp_tags_max_fields';
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpTagsMinFields = {
  __typename?: 'amp_tags_min_fields';
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_tags" */
export type AmpTagsMutationResponse = {
  __typename?: 'amp_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTags>;
};

/** on_conflict condition type for table "amp_tags" */
export type AmpTagsOnConflict = {
  constraint: AmpTagsConstraint;
  update_columns?: Array<AmpTagsUpdateColumn>;
  where?: InputMaybe<AmpTagsBoolExp>;
};

/** Ordering options when selecting data from "amp_tags". */
export type AmpTagsOrderBy = {
  color?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  task_tags_aggregate?: InputMaybe<AmpTaskTagsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_tags */
export type AmpTagsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_tags" */
export const AmpTagsSelectColumn = {
  /** column name */
  Color: 'color',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTagsSelectColumn = typeof AmpTagsSelectColumn[keyof typeof AmpTagsSelectColumn];
/** input type for updating data in table "amp_tags" */
export type AmpTagsSetInput = {
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpTagsStddevFields = {
  __typename?: 'amp_tags_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpTagsStddevPopFields = {
  __typename?: 'amp_tags_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpTagsStddevSampFields = {
  __typename?: 'amp_tags_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_tags" */
export type AmpTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTagsStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTagsSumFields = {
  __typename?: 'amp_tags_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_tags" */
export const AmpTagsUpdateColumn = {
  /** column name */
  Color: 'color',
  /** column name */
  Name: 'name'
} as const;

export type AmpTagsUpdateColumn = typeof AmpTagsUpdateColumn[keyof typeof AmpTagsUpdateColumn];
export type AmpTagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpTagsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpTagsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpTagsVarPopFields = {
  __typename?: 'amp_tags_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpTagsVarSampFields = {
  __typename?: 'amp_tags_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpTagsVarianceFields = {
  __typename?: 'amp_tags_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_task_relations" */
export type AmpTaskRelations = {
  __typename?: 'amp_task_relations';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  source_task?: Maybe<AmpTasks>;
  source_task_id: Scalars['uuid'];
  /** An object relationship */
  target_task?: Maybe<AmpTasks>;
  target_task_id: Scalars['uuid'];
  type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_task_relations" */
export type AmpTaskRelationsAggregate = {
  __typename?: 'amp_task_relations_aggregate';
  aggregate?: Maybe<AmpTaskRelationsAggregateFields>;
  nodes: Array<AmpTaskRelations>;
};

export type AmpTaskRelationsAggregateBoolExp = {
  count?: InputMaybe<AmpTaskRelationsAggregateBoolExpCount>;
};

export type AmpTaskRelationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskRelationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_task_relations" */
export type AmpTaskRelationsAggregateFields = {
  __typename?: 'amp_task_relations_aggregate_fields';
  avg?: Maybe<AmpTaskRelationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTaskRelationsMaxFields>;
  min?: Maybe<AmpTaskRelationsMinFields>;
  stddev?: Maybe<AmpTaskRelationsStddevFields>;
  stddev_pop?: Maybe<AmpTaskRelationsStddevPopFields>;
  stddev_samp?: Maybe<AmpTaskRelationsStddevSampFields>;
  sum?: Maybe<AmpTaskRelationsSumFields>;
  var_pop?: Maybe<AmpTaskRelationsVarPopFields>;
  var_samp?: Maybe<AmpTaskRelationsVarSampFields>;
  variance?: Maybe<AmpTaskRelationsVarianceFields>;
};


/** aggregate fields of "amp_task_relations" */
export type AmpTaskRelationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_task_relations" */
export type AmpTaskRelationsAggregateOrderBy = {
  avg?: InputMaybe<AmpTaskRelationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTaskRelationsMaxOrderBy>;
  min?: InputMaybe<AmpTaskRelationsMinOrderBy>;
  stddev?: InputMaybe<AmpTaskRelationsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTaskRelationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTaskRelationsStddevSampOrderBy>;
  sum?: InputMaybe<AmpTaskRelationsSumOrderBy>;
  var_pop?: InputMaybe<AmpTaskRelationsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTaskRelationsVarSampOrderBy>;
  variance?: InputMaybe<AmpTaskRelationsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpTaskRelationsAvgFields = {
  __typename?: 'amp_task_relations_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_task_relations" */
export type AmpTaskRelationsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_task_relations". All fields are combined with a logical 'AND'. */
export type AmpTaskRelationsBoolExp = {
  _and?: InputMaybe<Array<AmpTaskRelationsBoolExp>>;
  _not?: InputMaybe<AmpTaskRelationsBoolExp>;
  _or?: InputMaybe<Array<AmpTaskRelationsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  source_task?: InputMaybe<AmpTasksBoolExp>;
  source_task_id?: InputMaybe<UuidComparisonExp>;
  target_task?: InputMaybe<AmpTasksBoolExp>;
  target_task_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_task_relations" */
export const AmpTaskRelationsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "type", "source_task_id", "target_task_id" */
  AmpTaskRelationsEdgeKey: 'amp_task_relations_edge_key',
  /** unique or primary key constraint on columns "id" */
  AmpTaskRelationsPkey: 'amp_task_relations_pkey'
} as const;

export type AmpTaskRelationsConstraint = typeof AmpTaskRelationsConstraint[keyof typeof AmpTaskRelationsConstraint];
/** input type for inserting data into table "amp_task_relations" */
export type AmpTaskRelationsInsertInput = {
  source_task_id?: InputMaybe<Scalars['uuid']>;
  target_task_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AmpTaskRelationsMaxFields = {
  __typename?: 'amp_task_relations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  source_task_id?: Maybe<Scalars['uuid']>;
  target_task_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_task_relations" */
export type AmpTaskRelationsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source_task_id?: InputMaybe<OrderBy>;
  target_task_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTaskRelationsMinFields = {
  __typename?: 'amp_task_relations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  source_task_id?: Maybe<Scalars['uuid']>;
  target_task_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_task_relations" */
export type AmpTaskRelationsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source_task_id?: InputMaybe<OrderBy>;
  target_task_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_task_relations" */
export type AmpTaskRelationsMutationResponse = {
  __typename?: 'amp_task_relations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTaskRelations>;
};

/** on_conflict condition type for table "amp_task_relations" */
export type AmpTaskRelationsOnConflict = {
  constraint: AmpTaskRelationsConstraint;
  update_columns?: Array<AmpTaskRelationsUpdateColumn>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};

/** Ordering options when selecting data from "amp_task_relations". */
export type AmpTaskRelationsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source_task?: InputMaybe<AmpTasksOrderBy>;
  source_task_id?: InputMaybe<OrderBy>;
  target_task?: InputMaybe<AmpTasksOrderBy>;
  target_task_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_task_relations" */
export const AmpTaskRelationsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  SourceTaskId: 'source_task_id',
  /** column name */
  TargetTaskId: 'target_task_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTaskRelationsSelectColumn = typeof AmpTaskRelationsSelectColumn[keyof typeof AmpTaskRelationsSelectColumn];
/** aggregate stddev on columns */
export type AmpTaskRelationsStddevFields = {
  __typename?: 'amp_task_relations_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_task_relations" */
export type AmpTaskRelationsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTaskRelationsStddevPopFields = {
  __typename?: 'amp_task_relations_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_task_relations" */
export type AmpTaskRelationsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTaskRelationsStddevSampFields = {
  __typename?: 'amp_task_relations_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_task_relations" */
export type AmpTaskRelationsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_task_relations" */
export type AmpTaskRelationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTaskRelationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTaskRelationsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  source_task_id?: InputMaybe<Scalars['uuid']>;
  target_task_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTaskRelationsSumFields = {
  __typename?: 'amp_task_relations_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_task_relations" */
export type AmpTaskRelationsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "amp_task_relations" (current role has no relevant permissions) */
export const AmpTaskRelationsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpTaskRelationsUpdateColumn = typeof AmpTaskRelationsUpdateColumn[keyof typeof AmpTaskRelationsUpdateColumn];
/** aggregate var_pop on columns */
export type AmpTaskRelationsVarPopFields = {
  __typename?: 'amp_task_relations_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_task_relations" */
export type AmpTaskRelationsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTaskRelationsVarSampFields = {
  __typename?: 'amp_task_relations_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_task_relations" */
export type AmpTaskRelationsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTaskRelationsVarianceFields = {
  __typename?: 'amp_task_relations_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_task_relations" */
export type AmpTaskRelationsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_task_reviews" */
export type AmpTaskReviews = {
  __typename?: 'amp_task_reviews';
  /** An object relationship */
  asset_comment?: Maybe<AssetComments>;
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  kind: Scalars['String'];
  /** An object relationship */
  status?: Maybe<AmpWorkflowStatuses>;
  status_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  task?: Maybe<AmpTasks>;
  task_id: Scalars['uuid'];
  /** An object relationship */
  task_user?: Maybe<AmpTaskUsers>;
  task_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_task_reviews" */
export type AmpTaskReviewsAggregate = {
  __typename?: 'amp_task_reviews_aggregate';
  aggregate?: Maybe<AmpTaskReviewsAggregateFields>;
  nodes: Array<AmpTaskReviews>;
};

export type AmpTaskReviewsAggregateBoolExp = {
  count?: InputMaybe<AmpTaskReviewsAggregateBoolExpCount>;
};

export type AmpTaskReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskReviewsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_task_reviews" */
export type AmpTaskReviewsAggregateFields = {
  __typename?: 'amp_task_reviews_aggregate_fields';
  avg?: Maybe<AmpTaskReviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTaskReviewsMaxFields>;
  min?: Maybe<AmpTaskReviewsMinFields>;
  stddev?: Maybe<AmpTaskReviewsStddevFields>;
  stddev_pop?: Maybe<AmpTaskReviewsStddevPopFields>;
  stddev_samp?: Maybe<AmpTaskReviewsStddevSampFields>;
  sum?: Maybe<AmpTaskReviewsSumFields>;
  var_pop?: Maybe<AmpTaskReviewsVarPopFields>;
  var_samp?: Maybe<AmpTaskReviewsVarSampFields>;
  variance?: Maybe<AmpTaskReviewsVarianceFields>;
};


/** aggregate fields of "amp_task_reviews" */
export type AmpTaskReviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_task_reviews" */
export type AmpTaskReviewsAggregateOrderBy = {
  avg?: InputMaybe<AmpTaskReviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTaskReviewsMaxOrderBy>;
  min?: InputMaybe<AmpTaskReviewsMinOrderBy>;
  stddev?: InputMaybe<AmpTaskReviewsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTaskReviewsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTaskReviewsStddevSampOrderBy>;
  sum?: InputMaybe<AmpTaskReviewsSumOrderBy>;
  var_pop?: InputMaybe<AmpTaskReviewsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTaskReviewsVarSampOrderBy>;
  variance?: InputMaybe<AmpTaskReviewsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpTaskReviewsAvgFields = {
  __typename?: 'amp_task_reviews_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_task_reviews". All fields are combined with a logical 'AND'. */
export type AmpTaskReviewsBoolExp = {
  _and?: InputMaybe<Array<AmpTaskReviewsBoolExp>>;
  _not?: InputMaybe<AmpTaskReviewsBoolExp>;
  _or?: InputMaybe<Array<AmpTaskReviewsBoolExp>>;
  asset_comment?: InputMaybe<AssetCommentsBoolExp>;
  asset_comment_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  status_id?: InputMaybe<UuidComparisonExp>;
  task?: InputMaybe<AmpTasksBoolExp>;
  task_id?: InputMaybe<UuidComparisonExp>;
  task_user?: InputMaybe<AmpTaskUsersBoolExp>;
  task_user_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpTaskReviewsMaxFields = {
  __typename?: 'amp_task_reviews_max_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
  task_user_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsMaxOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  task_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTaskReviewsMinFields = {
  __typename?: 'amp_task_reviews_min_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
  task_user_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsMinOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  task_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "amp_task_reviews". */
export type AmpTaskReviewsOrderBy = {
  asset_comment?: InputMaybe<AssetCommentsOrderBy>;
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  status?: InputMaybe<AmpWorkflowStatusesOrderBy>;
  status_id?: InputMaybe<OrderBy>;
  task?: InputMaybe<AmpTasksOrderBy>;
  task_id?: InputMaybe<OrderBy>;
  task_user?: InputMaybe<AmpTaskUsersOrderBy>;
  task_user_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_task_reviews" */
export const AmpTaskReviewsSelectColumn = {
  /** column name */
  AssetCommentId: 'asset_comment_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  StatusId: 'status_id',
  /** column name */
  TaskId: 'task_id',
  /** column name */
  TaskUserId: 'task_user_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTaskReviewsSelectColumn = typeof AmpTaskReviewsSelectColumn[keyof typeof AmpTaskReviewsSelectColumn];
/** aggregate stddev on columns */
export type AmpTaskReviewsStddevFields = {
  __typename?: 'amp_task_reviews_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTaskReviewsStddevPopFields = {
  __typename?: 'amp_task_reviews_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTaskReviewsStddevSampFields = {
  __typename?: 'amp_task_reviews_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_task_reviews" */
export type AmpTaskReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTaskReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTaskReviewsStreamCursorValueInput = {
  asset_comment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['uuid']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  task_user_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTaskReviewsSumFields = {
  __typename?: 'amp_task_reviews_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpTaskReviewsVarPopFields = {
  __typename?: 'amp_task_reviews_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTaskReviewsVarSampFields = {
  __typename?: 'amp_task_reviews_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTaskReviewsVarianceFields = {
  __typename?: 'amp_task_reviews_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_task_reviews" */
export type AmpTaskReviewsVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_task_tags" */
export type AmpTaskTags = {
  __typename?: 'amp_task_tags';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  tag?: Maybe<AmpTags>;
  tag_id: Scalars['uuid'];
  /** An object relationship */
  task?: Maybe<AmpTasks>;
  task_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "amp_task_tags" */
export type AmpTaskTagsAggregate = {
  __typename?: 'amp_task_tags_aggregate';
  aggregate?: Maybe<AmpTaskTagsAggregateFields>;
  nodes: Array<AmpTaskTags>;
};

export type AmpTaskTagsAggregateBoolExp = {
  count?: InputMaybe<AmpTaskTagsAggregateBoolExpCount>;
};

export type AmpTaskTagsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskTagsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_task_tags" */
export type AmpTaskTagsAggregateFields = {
  __typename?: 'amp_task_tags_aggregate_fields';
  avg?: Maybe<AmpTaskTagsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTaskTagsMaxFields>;
  min?: Maybe<AmpTaskTagsMinFields>;
  stddev?: Maybe<AmpTaskTagsStddevFields>;
  stddev_pop?: Maybe<AmpTaskTagsStddevPopFields>;
  stddev_samp?: Maybe<AmpTaskTagsStddevSampFields>;
  sum?: Maybe<AmpTaskTagsSumFields>;
  var_pop?: Maybe<AmpTaskTagsVarPopFields>;
  var_samp?: Maybe<AmpTaskTagsVarSampFields>;
  variance?: Maybe<AmpTaskTagsVarianceFields>;
};


/** aggregate fields of "amp_task_tags" */
export type AmpTaskTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_task_tags" */
export type AmpTaskTagsAggregateOrderBy = {
  avg?: InputMaybe<AmpTaskTagsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTaskTagsMaxOrderBy>;
  min?: InputMaybe<AmpTaskTagsMinOrderBy>;
  stddev?: InputMaybe<AmpTaskTagsStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTaskTagsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTaskTagsStddevSampOrderBy>;
  sum?: InputMaybe<AmpTaskTagsSumOrderBy>;
  var_pop?: InputMaybe<AmpTaskTagsVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTaskTagsVarSampOrderBy>;
  variance?: InputMaybe<AmpTaskTagsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpTaskTagsAvgFields = {
  __typename?: 'amp_task_tags_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_task_tags" */
export type AmpTaskTagsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_task_tags". All fields are combined with a logical 'AND'. */
export type AmpTaskTagsBoolExp = {
  _and?: InputMaybe<Array<AmpTaskTagsBoolExp>>;
  _not?: InputMaybe<AmpTaskTagsBoolExp>;
  _or?: InputMaybe<Array<AmpTaskTagsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<AmpTagsBoolExp>;
  tag_id?: InputMaybe<UuidComparisonExp>;
  task?: InputMaybe<AmpTasksBoolExp>;
  task_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AmpTaskTagsMaxFields = {
  __typename?: 'amp_task_tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_task_tags" */
export type AmpTaskTagsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tag_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTaskTagsMinFields = {
  __typename?: 'amp_task_tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  task_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_task_tags" */
export type AmpTaskTagsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tag_id?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_task_tags" */
export type AmpTaskTagsMutationResponse = {
  __typename?: 'amp_task_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTaskTags>;
};

/** Ordering options when selecting data from "amp_task_tags". */
export type AmpTaskTagsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tag?: InputMaybe<AmpTagsOrderBy>;
  tag_id?: InputMaybe<OrderBy>;
  task?: InputMaybe<AmpTasksOrderBy>;
  task_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_task_tags" */
export const AmpTaskTagsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  TagId: 'tag_id',
  /** column name */
  TaskId: 'task_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTaskTagsSelectColumn = typeof AmpTaskTagsSelectColumn[keyof typeof AmpTaskTagsSelectColumn];
/** aggregate stddev on columns */
export type AmpTaskTagsStddevFields = {
  __typename?: 'amp_task_tags_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_task_tags" */
export type AmpTaskTagsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTaskTagsStddevPopFields = {
  __typename?: 'amp_task_tags_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_task_tags" */
export type AmpTaskTagsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTaskTagsStddevSampFields = {
  __typename?: 'amp_task_tags_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_task_tags" */
export type AmpTaskTagsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_task_tags" */
export type AmpTaskTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTaskTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTaskTagsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  tag_id?: InputMaybe<Scalars['uuid']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTaskTagsSumFields = {
  __typename?: 'amp_task_tags_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_task_tags" */
export type AmpTaskTagsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AmpTaskTagsVarPopFields = {
  __typename?: 'amp_task_tags_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_task_tags" */
export type AmpTaskTagsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTaskTagsVarSampFields = {
  __typename?: 'amp_task_tags_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_task_tags" */
export type AmpTaskTagsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTaskTagsVarianceFields = {
  __typename?: 'amp_task_tags_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_task_tags" */
export type AmpTaskTagsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_task_users" */
export type AmpTaskUsers = {
  __typename?: 'amp_task_users';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  group_peers: Array<AmpTaskUsers>;
  /** An aggregate relationship */
  group_peers_aggregate: AmpTaskUsersAggregate;
  id: Scalars['uuid'];
  member_rule?: Maybe<Scalars['String']>;
  /** An array relationship */
  peers: Array<AmpTaskUsers>;
  /** An aggregate relationship */
  peers_aggregate: AmpTaskUsersAggregate;
  required: Scalars['Boolean'];
  /** An array relationship */
  reviews: Array<AmpTaskReviews>;
  /** An aggregate relationship */
  reviews_aggregate: AmpTaskReviewsAggregate;
  /** An object relationship */
  task?: Maybe<AmpTasks>;
  task_id: Scalars['uuid'];
  /** An object relationship */
  team?: Maybe<AmpTeams>;
  team_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_group?: Maybe<UserGroups>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  user_memberships: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  user_memberships_aggregate: AllMembershipsV2Aggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersGroupPeersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersGroupPeersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersPeersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersPeersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersReviewsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersUserMembershipsArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "amp_task_users" */
export type AmpTaskUsersUserMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};

/** aggregated selection of "amp_task_users" */
export type AmpTaskUsersAggregate = {
  __typename?: 'amp_task_users_aggregate';
  aggregate?: Maybe<AmpTaskUsersAggregateFields>;
  nodes: Array<AmpTaskUsers>;
};

export type AmpTaskUsersAggregateBoolExp = {
  bool_and?: InputMaybe<AmpTaskUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AmpTaskUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<AmpTaskUsersAggregateBoolExpCount>;
};

export type AmpTaskUsersAggregateBoolExpBoolAnd = {
  arguments: AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpTaskUsersAggregateBoolExpBoolOr = {
  arguments: AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpTaskUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTaskUsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_task_users" */
export type AmpTaskUsersAggregateFields = {
  __typename?: 'amp_task_users_aggregate_fields';
  avg?: Maybe<AmpTaskUsersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTaskUsersMaxFields>;
  min?: Maybe<AmpTaskUsersMinFields>;
  stddev?: Maybe<AmpTaskUsersStddevFields>;
  stddev_pop?: Maybe<AmpTaskUsersStddevPopFields>;
  stddev_samp?: Maybe<AmpTaskUsersStddevSampFields>;
  sum?: Maybe<AmpTaskUsersSumFields>;
  var_pop?: Maybe<AmpTaskUsersVarPopFields>;
  var_samp?: Maybe<AmpTaskUsersVarSampFields>;
  variance?: Maybe<AmpTaskUsersVarianceFields>;
};


/** aggregate fields of "amp_task_users" */
export type AmpTaskUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_task_users" */
export type AmpTaskUsersAggregateOrderBy = {
  avg?: InputMaybe<AmpTaskUsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTaskUsersMaxOrderBy>;
  min?: InputMaybe<AmpTaskUsersMinOrderBy>;
  stddev?: InputMaybe<AmpTaskUsersStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTaskUsersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTaskUsersStddevSampOrderBy>;
  sum?: InputMaybe<AmpTaskUsersSumOrderBy>;
  var_pop?: InputMaybe<AmpTaskUsersVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTaskUsersVarSampOrderBy>;
  variance?: InputMaybe<AmpTaskUsersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "amp_task_users" */
export type AmpTaskUsersArrRelInsertInput = {
  data: Array<AmpTaskUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpTaskUsersOnConflict>;
};

/** aggregate avg on columns */
export type AmpTaskUsersAvgFields = {
  __typename?: 'amp_task_users_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_task_users" */
export type AmpTaskUsersAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_task_users". All fields are combined with a logical 'AND'. */
export type AmpTaskUsersBoolExp = {
  _and?: InputMaybe<Array<AmpTaskUsersBoolExp>>;
  _not?: InputMaybe<AmpTaskUsersBoolExp>;
  _or?: InputMaybe<Array<AmpTaskUsersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  group_peers?: InputMaybe<AmpTaskUsersBoolExp>;
  group_peers_aggregate?: InputMaybe<AmpTaskUsersAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  member_rule?: InputMaybe<StringComparisonExp>;
  peers?: InputMaybe<AmpTaskUsersBoolExp>;
  peers_aggregate?: InputMaybe<AmpTaskUsersAggregateBoolExp>;
  required?: InputMaybe<BooleanComparisonExp>;
  reviews?: InputMaybe<AmpTaskReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<AmpTaskReviewsAggregateBoolExp>;
  task?: InputMaybe<AmpTasksBoolExp>;
  task_id?: InputMaybe<UuidComparisonExp>;
  team?: InputMaybe<AmpTeamsBoolExp>;
  team_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  user_memberships?: InputMaybe<AllMembershipsV2BoolExp>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_task_users" */
export const AmpTaskUsersConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpTaskUsersIdWorkspaceIdKey: 'amp_task_users_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AmpTaskUsersPkey: 'amp_task_users_pkey',
  /** unique or primary key constraint on columns "task_id", "type", "team_id" */
  AmpTaskUsersTaskTypeTeamUnique: 'amp_task_users_task_type_team_unique',
  /** unique or primary key constraint on columns "user_group_id", "task_id", "type" */
  AmpTaskUsersTaskTypeUserGroupUnique: 'amp_task_users_task_type_user_group_unique',
  /** unique or primary key constraint on columns "user_id", "task_id", "type" */
  AmpTaskUsersTaskTypeUserUnique: 'amp_task_users_task_type_user_unique'
} as const;

export type AmpTaskUsersConstraint = typeof AmpTaskUsersConstraint[keyof typeof AmpTaskUsersConstraint];
/** input type for inserting data into table "amp_task_users" */
export type AmpTaskUsersInsertInput = {
  group_peers?: InputMaybe<AmpTaskUsersArrRelInsertInput>;
  peers?: InputMaybe<AmpTaskUsersArrRelInsertInput>;
  task_id?: InputMaybe<Scalars['uuid']>;
  team?: InputMaybe<AmpTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AmpTaskUsersMaxFields = {
  __typename?: 'amp_task_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  member_rule?: Maybe<Scalars['String']>;
  task_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_task_users" */
export type AmpTaskUsersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  team_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTaskUsersMinFields = {
  __typename?: 'amp_task_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  member_rule?: Maybe<Scalars['String']>;
  task_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_task_users" */
export type AmpTaskUsersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  task_id?: InputMaybe<OrderBy>;
  team_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_task_users" */
export type AmpTaskUsersMutationResponse = {
  __typename?: 'amp_task_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTaskUsers>;
};

/** on_conflict condition type for table "amp_task_users" */
export type AmpTaskUsersOnConflict = {
  constraint: AmpTaskUsersConstraint;
  update_columns?: Array<AmpTaskUsersUpdateColumn>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};

/** Ordering options when selecting data from "amp_task_users". */
export type AmpTaskUsersOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  group_peers_aggregate?: InputMaybe<AmpTaskUsersAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  peers_aggregate?: InputMaybe<AmpTaskUsersAggregateOrderBy>;
  required?: InputMaybe<OrderBy>;
  reviews_aggregate?: InputMaybe<AmpTaskReviewsAggregateOrderBy>;
  task?: InputMaybe<AmpTasksOrderBy>;
  task_id?: InputMaybe<OrderBy>;
  team?: InputMaybe<AmpTeamsOrderBy>;
  team_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_task_users" */
export const AmpTaskUsersSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  MemberRule: 'member_rule',
  /** column name */
  Required: 'required',
  /** column name */
  TaskId: 'task_id',
  /** column name */
  TeamId: 'team_id',
  /** column name */
  Type: 'type',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTaskUsersSelectColumn = typeof AmpTaskUsersSelectColumn[keyof typeof AmpTaskUsersSelectColumn];
/** select "amp_task_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "amp_task_users" */
export const AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Required: 'required'
} as const;

export type AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolAndArgumentsColumns = typeof AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolAndArgumentsColumns];
/** select "amp_task_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "amp_task_users" */
export const AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Required: 'required'
} as const;

export type AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolOrArgumentsColumns = typeof AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AmpTaskUsersSelectColumnAmpTaskUsersAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type AmpTaskUsersStddevFields = {
  __typename?: 'amp_task_users_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_task_users" */
export type AmpTaskUsersStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTaskUsersStddevPopFields = {
  __typename?: 'amp_task_users_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_task_users" */
export type AmpTaskUsersStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTaskUsersStddevSampFields = {
  __typename?: 'amp_task_users_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_task_users" */
export type AmpTaskUsersStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_task_users" */
export type AmpTaskUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTaskUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTaskUsersStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  member_rule?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  task_id?: InputMaybe<Scalars['uuid']>;
  team_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTaskUsersSumFields = {
  __typename?: 'amp_task_users_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_task_users" */
export type AmpTaskUsersSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "amp_task_users" (current role has no relevant permissions) */
export const AmpTaskUsersUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpTaskUsersUpdateColumn = typeof AmpTaskUsersUpdateColumn[keyof typeof AmpTaskUsersUpdateColumn];
/** aggregate var_pop on columns */
export type AmpTaskUsersVarPopFields = {
  __typename?: 'amp_task_users_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_task_users" */
export type AmpTaskUsersVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTaskUsersVarSampFields = {
  __typename?: 'amp_task_users_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_task_users" */
export type AmpTaskUsersVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTaskUsersVarianceFields = {
  __typename?: 'amp_task_users_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_task_users" */
export type AmpTaskUsersVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_tasks" */
export type AmpTasks = {
  __typename?: 'amp_tasks';
  archived_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  comment_threads: Array<AssetCommentThreads>;
  /** An aggregate relationship */
  comment_threads_aggregate: AssetCommentThreadsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An array relationship */
  creator_tasks: Array<AmpTasks>;
  /** An aggregate relationship */
  creator_tasks_aggregate: AmpTasksAggregate;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  incoming_relations: Array<AmpTaskRelations>;
  /** An aggregate relationship */
  incoming_relations_aggregate: AmpTaskRelationsAggregate;
  /** An array relationship */
  links: Array<AmpProjectLinks>;
  /** An aggregate relationship */
  links_aggregate: AmpProjectLinksAggregate;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  outgoing_relations: Array<AmpTaskRelations>;
  /** An aggregate relationship */
  outgoing_relations_aggregate: AmpTaskRelationsAggregate;
  /** An object relationship */
  parent?: Maybe<AmpTasks>;
  parent_task_id?: Maybe<Scalars['uuid']>;
  position: Scalars['Int'];
  /** An object relationship */
  project?: Maybe<AmpProjects>;
  project_id: Scalars['uuid'];
  /** An array relationship */
  reviews: Array<AmpTaskReviews>;
  /** An aggregate relationship */
  reviews_aggregate: AmpTaskReviewsAggregate;
  /** An object relationship */
  status?: Maybe<AmpWorkflowStatuses>;
  status_category?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  subtasks: Array<AmpTasks>;
  /** An aggregate relationship */
  subtasks_aggregate: AmpTasksAggregate;
  /** An array relationship */
  tags: Array<AmpTaskTags>;
  /** An aggregate relationship */
  tags_aggregate: AmpTaskTagsAggregate;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<AmpTaskUsers>;
  /** An aggregate relationship */
  users_aggregate: AmpTaskUsersAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksCommentThreadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksCommentThreadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksCreatorTasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksCreatorTasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksIncomingRelationsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksIncomingRelationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksLinksArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksOutgoingRelationsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksOutgoingRelationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksReviewsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksSubtasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksSubtasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_tasks" */
export type AmpTasksUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};

/** aggregated selection of "amp_tasks" */
export type AmpTasksAggregate = {
  __typename?: 'amp_tasks_aggregate';
  aggregate?: Maybe<AmpTasksAggregateFields>;
  nodes: Array<AmpTasks>;
};

export type AmpTasksAggregateBoolExp = {
  count?: InputMaybe<AmpTasksAggregateBoolExpCount>;
};

export type AmpTasksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTasksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTasksBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_tasks" */
export type AmpTasksAggregateFields = {
  __typename?: 'amp_tasks_aggregate_fields';
  avg?: Maybe<AmpTasksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTasksMaxFields>;
  min?: Maybe<AmpTasksMinFields>;
  stddev?: Maybe<AmpTasksStddevFields>;
  stddev_pop?: Maybe<AmpTasksStddevPopFields>;
  stddev_samp?: Maybe<AmpTasksStddevSampFields>;
  sum?: Maybe<AmpTasksSumFields>;
  var_pop?: Maybe<AmpTasksVarPopFields>;
  var_samp?: Maybe<AmpTasksVarSampFields>;
  variance?: Maybe<AmpTasksVarianceFields>;
};


/** aggregate fields of "amp_tasks" */
export type AmpTasksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTasksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_tasks" */
export type AmpTasksAggregateOrderBy = {
  avg?: InputMaybe<AmpTasksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTasksMaxOrderBy>;
  min?: InputMaybe<AmpTasksMinOrderBy>;
  stddev?: InputMaybe<AmpTasksStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTasksStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTasksStddevSampOrderBy>;
  sum?: InputMaybe<AmpTasksSumOrderBy>;
  var_pop?: InputMaybe<AmpTasksVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTasksVarSampOrderBy>;
  variance?: InputMaybe<AmpTasksVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AmpTasksAvgFields = {
  __typename?: 'amp_tasks_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_tasks" */
export type AmpTasksAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_tasks". All fields are combined with a logical 'AND'. */
export type AmpTasksBoolExp = {
  _and?: InputMaybe<Array<AmpTasksBoolExp>>;
  _not?: InputMaybe<AmpTasksBoolExp>;
  _or?: InputMaybe<Array<AmpTasksBoolExp>>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  comment_threads?: InputMaybe<AssetCommentThreadsBoolExp>;
  comment_threads_aggregate?: InputMaybe<AssetCommentThreadsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  creator_tasks?: InputMaybe<AmpTasksBoolExp>;
  creator_tasks_aggregate?: InputMaybe<AmpTasksAggregateBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  due_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  incoming_relations?: InputMaybe<AmpTaskRelationsBoolExp>;
  incoming_relations_aggregate?: InputMaybe<AmpTaskRelationsAggregateBoolExp>;
  links?: InputMaybe<AmpProjectLinksBoolExp>;
  links_aggregate?: InputMaybe<AmpProjectLinksAggregateBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  outgoing_relations?: InputMaybe<AmpTaskRelationsBoolExp>;
  outgoing_relations_aggregate?: InputMaybe<AmpTaskRelationsAggregateBoolExp>;
  parent?: InputMaybe<AmpTasksBoolExp>;
  parent_task_id?: InputMaybe<UuidComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  project?: InputMaybe<AmpProjectsBoolExp>;
  project_id?: InputMaybe<UuidComparisonExp>;
  reviews?: InputMaybe<AmpTaskReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<AmpTaskReviewsAggregateBoolExp>;
  status?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  status_category?: InputMaybe<StringComparisonExp>;
  status_id?: InputMaybe<UuidComparisonExp>;
  subtasks?: InputMaybe<AmpTasksBoolExp>;
  subtasks_aggregate?: InputMaybe<AmpTasksAggregateBoolExp>;
  tags?: InputMaybe<AmpTaskTagsBoolExp>;
  tags_aggregate?: InputMaybe<AmpTaskTagsAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<AmpTaskUsersBoolExp>;
  users_aggregate?: InputMaybe<AmpTaskUsersAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "amp_tasks" */
export type AmpTasksIncInput = {
  position?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AmpTasksMaxFields = {
  __typename?: 'amp_tasks_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  parent_task_id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  status_category?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_tasks" */
export type AmpTasksMaxOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parent_task_id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  status_category?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTasksMinFields = {
  __typename?: 'amp_tasks_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  parent_task_id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  status_category?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_tasks" */
export type AmpTasksMinOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parent_task_id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  project_id?: InputMaybe<OrderBy>;
  status_category?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_tasks" */
export type AmpTasksMutationResponse = {
  __typename?: 'amp_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTasks>;
};

/** Ordering options when selecting data from "amp_tasks". */
export type AmpTasksOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  comment_threads_aggregate?: InputMaybe<AssetCommentThreadsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  creator_tasks_aggregate?: InputMaybe<AmpTasksAggregateOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  due_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  incoming_relations_aggregate?: InputMaybe<AmpTaskRelationsAggregateOrderBy>;
  links_aggregate?: InputMaybe<AmpProjectLinksAggregateOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  outgoing_relations_aggregate?: InputMaybe<AmpTaskRelationsAggregateOrderBy>;
  parent?: InputMaybe<AmpTasksOrderBy>;
  parent_task_id?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  project?: InputMaybe<AmpProjectsOrderBy>;
  project_id?: InputMaybe<OrderBy>;
  reviews_aggregate?: InputMaybe<AmpTaskReviewsAggregateOrderBy>;
  status?: InputMaybe<AmpWorkflowStatusesOrderBy>;
  status_category?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  subtasks_aggregate?: InputMaybe<AmpTasksAggregateOrderBy>;
  tags_aggregate?: InputMaybe<AmpTaskTagsAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  users_aggregate?: InputMaybe<AmpTaskUsersAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_tasks */
export type AmpTasksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_tasks" */
export const AmpTasksSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Description: 'description',
  /** column name */
  DueAt: 'due_at',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  ParentTaskId: 'parent_task_id',
  /** column name */
  Position: 'position',
  /** column name */
  ProjectId: 'project_id',
  /** column name */
  StatusCategory: 'status_category',
  /** column name */
  StatusId: 'status_id',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTasksSelectColumn = typeof AmpTasksSelectColumn[keyof typeof AmpTasksSelectColumn];
/** input type for updating data in table "amp_tasks" */
export type AmpTasksSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamptz']>;
  position?: InputMaybe<Scalars['Int']>;
  status_category?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpTasksStddevFields = {
  __typename?: 'amp_tasks_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_tasks" */
export type AmpTasksStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTasksStddevPopFields = {
  __typename?: 'amp_tasks_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_tasks" */
export type AmpTasksStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTasksStddevSampFields = {
  __typename?: 'amp_tasks_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_tasks" */
export type AmpTasksStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_tasks" */
export type AmpTasksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTasksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTasksStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  parent_task_id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status_category?: InputMaybe<Scalars['String']>;
  status_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTasksSumFields = {
  __typename?: 'amp_tasks_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  position?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_tasks" */
export type AmpTasksSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type AmpTasksUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AmpTasksIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpTasksSetInput>;
  /** filter the rows which have to be updated */
  where: AmpTasksBoolExp;
};

/** aggregate var_pop on columns */
export type AmpTasksVarPopFields = {
  __typename?: 'amp_tasks_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_tasks" */
export type AmpTasksVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTasksVarSampFields = {
  __typename?: 'amp_tasks_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_tasks" */
export type AmpTasksVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTasksVarianceFields = {
  __typename?: 'amp_tasks_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_tasks" */
export type AmpTasksVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_team_members" */
export type AmpTeamMembers = {
  __typename?: 'amp_team_members';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  team?: Maybe<AmpTeams>;
  team_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  /** An array relationship */
  user_memberships: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  user_memberships_aggregate: AllMembershipsV2Aggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_team_members" */
export type AmpTeamMembersUserMembershipsArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "amp_team_members" */
export type AmpTeamMembersUserMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};

/** aggregated selection of "amp_team_members" */
export type AmpTeamMembersAggregate = {
  __typename?: 'amp_team_members_aggregate';
  aggregate?: Maybe<AmpTeamMembersAggregateFields>;
  nodes: Array<AmpTeamMembers>;
};

export type AmpTeamMembersAggregateBoolExp = {
  count?: InputMaybe<AmpTeamMembersAggregateBoolExpCount>;
};

export type AmpTeamMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpTeamMembersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_team_members" */
export type AmpTeamMembersAggregateFields = {
  __typename?: 'amp_team_members_aggregate_fields';
  avg?: Maybe<AmpTeamMembersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTeamMembersMaxFields>;
  min?: Maybe<AmpTeamMembersMinFields>;
  stddev?: Maybe<AmpTeamMembersStddevFields>;
  stddev_pop?: Maybe<AmpTeamMembersStddevPopFields>;
  stddev_samp?: Maybe<AmpTeamMembersStddevSampFields>;
  sum?: Maybe<AmpTeamMembersSumFields>;
  var_pop?: Maybe<AmpTeamMembersVarPopFields>;
  var_samp?: Maybe<AmpTeamMembersVarSampFields>;
  variance?: Maybe<AmpTeamMembersVarianceFields>;
};


/** aggregate fields of "amp_team_members" */
export type AmpTeamMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_team_members" */
export type AmpTeamMembersAggregateOrderBy = {
  avg?: InputMaybe<AmpTeamMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpTeamMembersMaxOrderBy>;
  min?: InputMaybe<AmpTeamMembersMinOrderBy>;
  stddev?: InputMaybe<AmpTeamMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpTeamMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpTeamMembersStddevSampOrderBy>;
  sum?: InputMaybe<AmpTeamMembersSumOrderBy>;
  var_pop?: InputMaybe<AmpTeamMembersVarPopOrderBy>;
  var_samp?: InputMaybe<AmpTeamMembersVarSampOrderBy>;
  variance?: InputMaybe<AmpTeamMembersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "amp_team_members" */
export type AmpTeamMembersArrRelInsertInput = {
  data: Array<AmpTeamMembersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpTeamMembersOnConflict>;
};

/** aggregate avg on columns */
export type AmpTeamMembersAvgFields = {
  __typename?: 'amp_team_members_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_team_members" */
export type AmpTeamMembersAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_team_members". All fields are combined with a logical 'AND'. */
export type AmpTeamMembersBoolExp = {
  _and?: InputMaybe<Array<AmpTeamMembersBoolExp>>;
  _not?: InputMaybe<AmpTeamMembersBoolExp>;
  _or?: InputMaybe<Array<AmpTeamMembersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  team?: InputMaybe<AmpTeamsBoolExp>;
  team_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  user_memberships?: InputMaybe<AllMembershipsV2BoolExp>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_team_members" */
export const AmpTeamMembersConstraint = {
  /** unique or primary key constraint on columns "id" */
  AmpTeamMembersPkey: 'amp_team_members_pkey',
  /** unique or primary key constraint on columns "user_id", "team_id" */
  AmpTeamMembersTeamUserKey: 'amp_team_members_team_user_key'
} as const;

export type AmpTeamMembersConstraint = typeof AmpTeamMembersConstraint[keyof typeof AmpTeamMembersConstraint];
/** input type for inserting data into table "amp_team_members" */
export type AmpTeamMembersInsertInput = {
  team?: InputMaybe<AmpTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AmpTeamMembersMaxFields = {
  __typename?: 'amp_team_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_team_members" */
export type AmpTeamMembersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  team_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpTeamMembersMinFields = {
  __typename?: 'amp_team_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_team_members" */
export type AmpTeamMembersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  team_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_team_members" */
export type AmpTeamMembersMutationResponse = {
  __typename?: 'amp_team_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTeamMembers>;
};

/** on_conflict condition type for table "amp_team_members" */
export type AmpTeamMembersOnConflict = {
  constraint: AmpTeamMembersConstraint;
  update_columns?: Array<AmpTeamMembersUpdateColumn>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};

/** Ordering options when selecting data from "amp_team_members". */
export type AmpTeamMembersOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  team?: InputMaybe<AmpTeamsOrderBy>;
  team_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "amp_team_members" */
export const AmpTeamMembersSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  TeamId: 'team_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTeamMembersSelectColumn = typeof AmpTeamMembersSelectColumn[keyof typeof AmpTeamMembersSelectColumn];
/** aggregate stddev on columns */
export type AmpTeamMembersStddevFields = {
  __typename?: 'amp_team_members_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_team_members" */
export type AmpTeamMembersStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpTeamMembersStddevPopFields = {
  __typename?: 'amp_team_members_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_team_members" */
export type AmpTeamMembersStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpTeamMembersStddevSampFields = {
  __typename?: 'amp_team_members_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_team_members" */
export type AmpTeamMembersStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_team_members" */
export type AmpTeamMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTeamMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTeamMembersStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  team_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTeamMembersSumFields = {
  __typename?: 'amp_team_members_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_team_members" */
export type AmpTeamMembersSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "amp_team_members" (current role has no relevant permissions) */
export const AmpTeamMembersUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AmpTeamMembersUpdateColumn = typeof AmpTeamMembersUpdateColumn[keyof typeof AmpTeamMembersUpdateColumn];
/** aggregate var_pop on columns */
export type AmpTeamMembersVarPopFields = {
  __typename?: 'amp_team_members_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_team_members" */
export type AmpTeamMembersVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpTeamMembersVarSampFields = {
  __typename?: 'amp_team_members_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_team_members" */
export type AmpTeamMembersVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpTeamMembersVarianceFields = {
  __typename?: 'amp_team_members_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_team_members" */
export type AmpTeamMembersVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_teams" */
export type AmpTeams = {
  __typename?: 'amp_teams';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An array relationship */
  members: Array<AmpTeamMembers>;
  /** An aggregate relationship */
  members_aggregate: AmpTeamMembersAggregate;
  name: Scalars['String'];
  /** An array relationship */
  task_users: Array<AmpTaskUsers>;
  /** An aggregate relationship */
  task_users_aggregate: AmpTaskUsersAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_teams" */
export type AmpTeamsMembersArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


/** columns and relationships of "amp_teams" */
export type AmpTeamsMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


/** columns and relationships of "amp_teams" */
export type AmpTeamsTaskUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


/** columns and relationships of "amp_teams" */
export type AmpTeamsTaskUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};

/** aggregated selection of "amp_teams" */
export type AmpTeamsAggregate = {
  __typename?: 'amp_teams_aggregate';
  aggregate?: Maybe<AmpTeamsAggregateFields>;
  nodes: Array<AmpTeams>;
};

/** aggregate fields of "amp_teams" */
export type AmpTeamsAggregateFields = {
  __typename?: 'amp_teams_aggregate_fields';
  avg?: Maybe<AmpTeamsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpTeamsMaxFields>;
  min?: Maybe<AmpTeamsMinFields>;
  stddev?: Maybe<AmpTeamsStddevFields>;
  stddev_pop?: Maybe<AmpTeamsStddevPopFields>;
  stddev_samp?: Maybe<AmpTeamsStddevSampFields>;
  sum?: Maybe<AmpTeamsSumFields>;
  var_pop?: Maybe<AmpTeamsVarPopFields>;
  var_samp?: Maybe<AmpTeamsVarSampFields>;
  variance?: Maybe<AmpTeamsVarianceFields>;
};


/** aggregate fields of "amp_teams" */
export type AmpTeamsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpTeamsAvgFields = {
  __typename?: 'amp_teams_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_teams". All fields are combined with a logical 'AND'. */
export type AmpTeamsBoolExp = {
  _and?: InputMaybe<Array<AmpTeamsBoolExp>>;
  _not?: InputMaybe<AmpTeamsBoolExp>;
  _or?: InputMaybe<Array<AmpTeamsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  members?: InputMaybe<AmpTeamMembersBoolExp>;
  members_aggregate?: InputMaybe<AmpTeamMembersAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  task_users?: InputMaybe<AmpTaskUsersBoolExp>;
  task_users_aggregate?: InputMaybe<AmpTaskUsersAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_teams" */
export const AmpTeamsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpTeamsIdWorkspaceIdKey: 'amp_teams_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AmpTeamsPkey: 'amp_teams_pkey'
} as const;

export type AmpTeamsConstraint = typeof AmpTeamsConstraint[keyof typeof AmpTeamsConstraint];
/** input type for inserting data into table "amp_teams" */
export type AmpTeamsInsertInput = {
  members?: InputMaybe<AmpTeamMembersArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  task_users?: InputMaybe<AmpTaskUsersArrRelInsertInput>;
};

/** aggregate max on columns */
export type AmpTeamsMaxFields = {
  __typename?: 'amp_teams_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpTeamsMinFields = {
  __typename?: 'amp_teams_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_teams" */
export type AmpTeamsMutationResponse = {
  __typename?: 'amp_teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpTeams>;
};

/** input type for inserting object relation for remote table "amp_teams" */
export type AmpTeamsObjRelInsertInput = {
  data: AmpTeamsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpTeamsOnConflict>;
};

/** on_conflict condition type for table "amp_teams" */
export type AmpTeamsOnConflict = {
  constraint: AmpTeamsConstraint;
  update_columns?: Array<AmpTeamsUpdateColumn>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};

/** Ordering options when selecting data from "amp_teams". */
export type AmpTeamsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  members_aggregate?: InputMaybe<AmpTeamMembersAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  task_users_aggregate?: InputMaybe<AmpTaskUsersAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_teams */
export type AmpTeamsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_teams" */
export const AmpTeamsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpTeamsSelectColumn = typeof AmpTeamsSelectColumn[keyof typeof AmpTeamsSelectColumn];
/** input type for updating data in table "amp_teams" */
export type AmpTeamsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpTeamsStddevFields = {
  __typename?: 'amp_teams_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpTeamsStddevPopFields = {
  __typename?: 'amp_teams_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpTeamsStddevSampFields = {
  __typename?: 'amp_teams_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_teams" */
export type AmpTeamsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpTeamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpTeamsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpTeamsSumFields = {
  __typename?: 'amp_teams_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_teams" */
export const AmpTeamsUpdateColumn = {
  /** column name */
  Name: 'name'
} as const;

export type AmpTeamsUpdateColumn = typeof AmpTeamsUpdateColumn[keyof typeof AmpTeamsUpdateColumn];
export type AmpTeamsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpTeamsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpTeamsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpTeamsVarPopFields = {
  __typename?: 'amp_teams_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpTeamsVarSampFields = {
  __typename?: 'amp_teams_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpTeamsVarianceFields = {
  __typename?: 'amp_teams_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewers = {
  __typename?: 'amp_workflow_status_reviewers';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  member_rule?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  /** An object relationship */
  status?: Maybe<AmpWorkflowStatuses>;
  status_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_group?: Maybe<UserGroups>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  user_memberships: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  user_memberships_aggregate: AllMembershipsV2Aggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersUserMembershipsArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersUserMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};

/** aggregated selection of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersAggregate = {
  __typename?: 'amp_workflow_status_reviewers_aggregate';
  aggregate?: Maybe<AmpWorkflowStatusReviewersAggregateFields>;
  nodes: Array<AmpWorkflowStatusReviewers>;
};

export type AmpWorkflowStatusReviewersAggregateBoolExp = {
  bool_and?: InputMaybe<AmpWorkflowStatusReviewersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AmpWorkflowStatusReviewersAggregateBoolExpBoolOr>;
  count?: InputMaybe<AmpWorkflowStatusReviewersAggregateBoolExpCount>;
};

export type AmpWorkflowStatusReviewersAggregateBoolExpBoolAnd = {
  arguments: AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpWorkflowStatusReviewersAggregateBoolExpBoolOr = {
  arguments: AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AmpWorkflowStatusReviewersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersAggregateFields = {
  __typename?: 'amp_workflow_status_reviewers_aggregate_fields';
  avg?: Maybe<AmpWorkflowStatusReviewersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpWorkflowStatusReviewersMaxFields>;
  min?: Maybe<AmpWorkflowStatusReviewersMinFields>;
  stddev?: Maybe<AmpWorkflowStatusReviewersStddevFields>;
  stddev_pop?: Maybe<AmpWorkflowStatusReviewersStddevPopFields>;
  stddev_samp?: Maybe<AmpWorkflowStatusReviewersStddevSampFields>;
  sum?: Maybe<AmpWorkflowStatusReviewersSumFields>;
  var_pop?: Maybe<AmpWorkflowStatusReviewersVarPopFields>;
  var_samp?: Maybe<AmpWorkflowStatusReviewersVarSampFields>;
  variance?: Maybe<AmpWorkflowStatusReviewersVarianceFields>;
};


/** aggregate fields of "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersAggregateOrderBy = {
  avg?: InputMaybe<AmpWorkflowStatusReviewersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpWorkflowStatusReviewersMaxOrderBy>;
  min?: InputMaybe<AmpWorkflowStatusReviewersMinOrderBy>;
  stddev?: InputMaybe<AmpWorkflowStatusReviewersStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpWorkflowStatusReviewersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpWorkflowStatusReviewersStddevSampOrderBy>;
  sum?: InputMaybe<AmpWorkflowStatusReviewersSumOrderBy>;
  var_pop?: InputMaybe<AmpWorkflowStatusReviewersVarPopOrderBy>;
  var_samp?: InputMaybe<AmpWorkflowStatusReviewersVarSampOrderBy>;
  variance?: InputMaybe<AmpWorkflowStatusReviewersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersArrRelInsertInput = {
  data: Array<AmpWorkflowStatusReviewersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpWorkflowStatusReviewersOnConflict>;
};

/** aggregate avg on columns */
export type AmpWorkflowStatusReviewersAvgFields = {
  __typename?: 'amp_workflow_status_reviewers_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_workflow_status_reviewers". All fields are combined with a logical 'AND'. */
export type AmpWorkflowStatusReviewersBoolExp = {
  _and?: InputMaybe<Array<AmpWorkflowStatusReviewersBoolExp>>;
  _not?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
  _or?: InputMaybe<Array<AmpWorkflowStatusReviewersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  member_rule?: InputMaybe<StringComparisonExp>;
  required?: InputMaybe<BooleanComparisonExp>;
  status?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  status_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  user_memberships?: InputMaybe<AllMembershipsV2BoolExp>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_workflow_status_reviewers" */
export const AmpWorkflowStatusReviewersConstraint = {
  /** unique or primary key constraint on columns "id" */
  AmpWorkflowStatusReviewersPkey: 'amp_workflow_status_reviewers_pkey',
  /** unique or primary key constraint on columns "user_group_id", "status_id" */
  AmpWorkflowStatusReviewersStatusUserGroupKey: 'amp_workflow_status_reviewers_status_user_group_key',
  /** unique or primary key constraint on columns "user_id", "status_id" */
  AmpWorkflowStatusReviewersStatusUserKey: 'amp_workflow_status_reviewers_status_user_key'
} as const;

export type AmpWorkflowStatusReviewersConstraint = typeof AmpWorkflowStatusReviewersConstraint[keyof typeof AmpWorkflowStatusReviewersConstraint];
/** input type for inserting data into table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersInsertInput = {
  member_rule?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AmpWorkflowStatusesObjRelInsertInput>;
  status_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AmpWorkflowStatusReviewersMaxFields = {
  __typename?: 'amp_workflow_status_reviewers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  member_rule?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpWorkflowStatusReviewersMinFields = {
  __typename?: 'amp_workflow_status_reviewers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  member_rule?: Maybe<Scalars['String']>;
  status_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  status_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersMutationResponse = {
  __typename?: 'amp_workflow_status_reviewers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpWorkflowStatusReviewers>;
};

/** on_conflict condition type for table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersOnConflict = {
  constraint: AmpWorkflowStatusReviewersConstraint;
  update_columns?: Array<AmpWorkflowStatusReviewersUpdateColumn>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};

/** Ordering options when selecting data from "amp_workflow_status_reviewers". */
export type AmpWorkflowStatusReviewersOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  member_rule?: InputMaybe<OrderBy>;
  required?: InputMaybe<OrderBy>;
  status?: InputMaybe<AmpWorkflowStatusesOrderBy>;
  status_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_memberships_aggregate?: InputMaybe<AllMembershipsV2AggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_workflow_status_reviewers */
export type AmpWorkflowStatusReviewersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_workflow_status_reviewers" */
export const AmpWorkflowStatusReviewersSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  MemberRule: 'member_rule',
  /** column name */
  Required: 'required',
  /** column name */
  StatusId: 'status_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpWorkflowStatusReviewersSelectColumn = typeof AmpWorkflowStatusReviewersSelectColumn[keyof typeof AmpWorkflowStatusReviewersSelectColumn];
/** select "amp_workflow_status_reviewers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "amp_workflow_status_reviewers" */
export const AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Required: 'required'
} as const;

export type AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolAndArgumentsColumns = typeof AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolAndArgumentsColumns];
/** select "amp_workflow_status_reviewers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "amp_workflow_status_reviewers" */
export const AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Required: 'required'
} as const;

export type AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolOrArgumentsColumns = typeof AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AmpWorkflowStatusReviewersSelectColumnAmpWorkflowStatusReviewersAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersSetInput = {
  member_rule?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type AmpWorkflowStatusReviewersStddevFields = {
  __typename?: 'amp_workflow_status_reviewers_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpWorkflowStatusReviewersStddevPopFields = {
  __typename?: 'amp_workflow_status_reviewers_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpWorkflowStatusReviewersStddevSampFields = {
  __typename?: 'amp_workflow_status_reviewers_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpWorkflowStatusReviewersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpWorkflowStatusReviewersStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  member_rule?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  status_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpWorkflowStatusReviewersSumFields = {
  __typename?: 'amp_workflow_status_reviewers_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "amp_workflow_status_reviewers" */
export const AmpWorkflowStatusReviewersUpdateColumn = {
  /** column name */
  MemberRule: 'member_rule',
  /** column name */
  Required: 'required'
} as const;

export type AmpWorkflowStatusReviewersUpdateColumn = typeof AmpWorkflowStatusReviewersUpdateColumn[keyof typeof AmpWorkflowStatusReviewersUpdateColumn];
export type AmpWorkflowStatusReviewersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpWorkflowStatusReviewersSetInput>;
  /** filter the rows which have to be updated */
  where: AmpWorkflowStatusReviewersBoolExp;
};

/** aggregate var_pop on columns */
export type AmpWorkflowStatusReviewersVarPopFields = {
  __typename?: 'amp_workflow_status_reviewers_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpWorkflowStatusReviewersVarSampFields = {
  __typename?: 'amp_workflow_status_reviewers_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpWorkflowStatusReviewersVarianceFields = {
  __typename?: 'amp_workflow_status_reviewers_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_workflow_status_reviewers" */
export type AmpWorkflowStatusReviewersVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatuses = {
  __typename?: 'amp_workflow_statuses';
  agent_instruction?: Maybe<Scalars['String']>;
  /** An array relationship */
  agentic_settings_entities_links: Array<AgenticSettingsEntitiesLinks>;
  approval_rule: Scalars['String'];
  /** An object relationship */
  approved_status?: Maybe<AmpWorkflowStatuses>;
  approved_status_id?: Maybe<Scalars['uuid']>;
  category: Scalars['String'];
  category_rank?: Maybe<Scalars['smallint']>;
  color?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  position: Scalars['Int'];
  /** An array relationship */
  reviewers: Array<AmpWorkflowStatusReviewers>;
  /** An aggregate relationship */
  reviewers_aggregate: AmpWorkflowStatusReviewersAggregate;
  /** An array relationship */
  tasks: Array<AmpTasks>;
  /** An aggregate relationship */
  tasks_aggregate: AmpTasksAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow?: Maybe<AmpWorkflows>;
  workflow_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatusesAgenticSettingsEntitiesLinksArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntitiesLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntitiesLinksOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
};


/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatusesReviewersArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatusesReviewersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatusesTasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


/** columns and relationships of "amp_workflow_statuses" */
export type AmpWorkflowStatusesTasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};

/** aggregated selection of "amp_workflow_statuses" */
export type AmpWorkflowStatusesAggregate = {
  __typename?: 'amp_workflow_statuses_aggregate';
  aggregate?: Maybe<AmpWorkflowStatusesAggregateFields>;
  nodes: Array<AmpWorkflowStatuses>;
};

export type AmpWorkflowStatusesAggregateBoolExp = {
  count?: InputMaybe<AmpWorkflowStatusesAggregateBoolExpCount>;
};

export type AmpWorkflowStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "amp_workflow_statuses" */
export type AmpWorkflowStatusesAggregateFields = {
  __typename?: 'amp_workflow_statuses_aggregate_fields';
  avg?: Maybe<AmpWorkflowStatusesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpWorkflowStatusesMaxFields>;
  min?: Maybe<AmpWorkflowStatusesMinFields>;
  stddev?: Maybe<AmpWorkflowStatusesStddevFields>;
  stddev_pop?: Maybe<AmpWorkflowStatusesStddevPopFields>;
  stddev_samp?: Maybe<AmpWorkflowStatusesStddevSampFields>;
  sum?: Maybe<AmpWorkflowStatusesSumFields>;
  var_pop?: Maybe<AmpWorkflowStatusesVarPopFields>;
  var_samp?: Maybe<AmpWorkflowStatusesVarSampFields>;
  variance?: Maybe<AmpWorkflowStatusesVarianceFields>;
};


/** aggregate fields of "amp_workflow_statuses" */
export type AmpWorkflowStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesAggregateOrderBy = {
  avg?: InputMaybe<AmpWorkflowStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AmpWorkflowStatusesMaxOrderBy>;
  min?: InputMaybe<AmpWorkflowStatusesMinOrderBy>;
  stddev?: InputMaybe<AmpWorkflowStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<AmpWorkflowStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AmpWorkflowStatusesStddevSampOrderBy>;
  sum?: InputMaybe<AmpWorkflowStatusesSumOrderBy>;
  var_pop?: InputMaybe<AmpWorkflowStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<AmpWorkflowStatusesVarSampOrderBy>;
  variance?: InputMaybe<AmpWorkflowStatusesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "amp_workflow_statuses" */
export type AmpWorkflowStatusesArrRelInsertInput = {
  data: Array<AmpWorkflowStatusesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpWorkflowStatusesOnConflict>;
};

/** aggregate avg on columns */
export type AmpWorkflowStatusesAvgFields = {
  __typename?: 'amp_workflow_statuses_avg_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesAvgOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "amp_workflow_statuses". All fields are combined with a logical 'AND'. */
export type AmpWorkflowStatusesBoolExp = {
  _and?: InputMaybe<Array<AmpWorkflowStatusesBoolExp>>;
  _not?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  _or?: InputMaybe<Array<AmpWorkflowStatusesBoolExp>>;
  agent_instruction?: InputMaybe<StringComparisonExp>;
  agentic_settings_entities_links?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
  approval_rule?: InputMaybe<StringComparisonExp>;
  approved_status?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  approved_status_id?: InputMaybe<UuidComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  category_rank?: InputMaybe<SmallintComparisonExp>;
  color?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  reviewers?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
  reviewers_aggregate?: InputMaybe<AmpWorkflowStatusReviewersAggregateBoolExp>;
  tasks?: InputMaybe<AmpTasksBoolExp>;
  tasks_aggregate?: InputMaybe<AmpTasksAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<AmpWorkflowsBoolExp>;
  workflow_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_workflow_statuses" */
export const AmpWorkflowStatusesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpWorkflowStatusesIdWorkspaceIdKey: 'amp_workflow_statuses_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AmpWorkflowStatusesPkey: 'amp_workflow_statuses_pkey'
} as const;

export type AmpWorkflowStatusesConstraint = typeof AmpWorkflowStatusesConstraint[keyof typeof AmpWorkflowStatusesConstraint];
/** input type for incrementing numeric columns in table "amp_workflow_statuses" */
export type AmpWorkflowStatusesIncInput = {
  position?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "amp_workflow_statuses" */
export type AmpWorkflowStatusesInsertInput = {
  agentic_settings_entities_links?: InputMaybe<AgenticSettingsEntitiesLinksArrRelInsertInput>;
  approval_rule?: InputMaybe<Scalars['String']>;
  approved_status?: InputMaybe<AmpWorkflowStatusesObjRelInsertInput>;
  approved_status_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  reviewers?: InputMaybe<AmpWorkflowStatusReviewersArrRelInsertInput>;
  workflow?: InputMaybe<AmpWorkflowsObjRelInsertInput>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AmpWorkflowStatusesMaxFields = {
  __typename?: 'amp_workflow_statuses_max_fields';
  agent_instruction?: Maybe<Scalars['String']>;
  approval_rule?: Maybe<Scalars['String']>;
  approved_status_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['String']>;
  category_rank?: Maybe<Scalars['smallint']>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesMaxOrderBy = {
  agent_instruction?: InputMaybe<OrderBy>;
  approval_rule?: InputMaybe<OrderBy>;
  approved_status_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_rank?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AmpWorkflowStatusesMinFields = {
  __typename?: 'amp_workflow_statuses_min_fields';
  agent_instruction?: Maybe<Scalars['String']>;
  approval_rule?: Maybe<Scalars['String']>;
  approved_status_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['String']>;
  category_rank?: Maybe<Scalars['smallint']>;
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesMinOrderBy = {
  agent_instruction?: InputMaybe<OrderBy>;
  approval_rule?: InputMaybe<OrderBy>;
  approved_status_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_rank?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "amp_workflow_statuses" */
export type AmpWorkflowStatusesMutationResponse = {
  __typename?: 'amp_workflow_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpWorkflowStatuses>;
};

/** input type for inserting object relation for remote table "amp_workflow_statuses" */
export type AmpWorkflowStatusesObjRelInsertInput = {
  data: AmpWorkflowStatusesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpWorkflowStatusesOnConflict>;
};

/** on_conflict condition type for table "amp_workflow_statuses" */
export type AmpWorkflowStatusesOnConflict = {
  constraint: AmpWorkflowStatusesConstraint;
  update_columns?: Array<AmpWorkflowStatusesUpdateColumn>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};

/** Ordering options when selecting data from "amp_workflow_statuses". */
export type AmpWorkflowStatusesOrderBy = {
  agent_instruction?: InputMaybe<OrderBy>;
  agentic_settings_entities_links_aggregate?: InputMaybe<AgenticSettingsEntitiesLinksAggregateOrderBy>;
  approval_rule?: InputMaybe<OrderBy>;
  approved_status?: InputMaybe<AmpWorkflowStatusesOrderBy>;
  approved_status_id?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_rank?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  reviewers_aggregate?: InputMaybe<AmpWorkflowStatusReviewersAggregateOrderBy>;
  tasks_aggregate?: InputMaybe<AmpTasksAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<AmpWorkflowsOrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_workflow_statuses */
export type AmpWorkflowStatusesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_workflow_statuses" */
export const AmpWorkflowStatusesSelectColumn = {
  /** column name */
  AgentInstruction: 'agent_instruction',
  /** column name */
  ApprovalRule: 'approval_rule',
  /** column name */
  ApprovedStatusId: 'approved_status_id',
  /** column name */
  Category: 'category',
  /** column name */
  CategoryRank: 'category_rank',
  /** column name */
  Color: 'color',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Position: 'position',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkflowId: 'workflow_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpWorkflowStatusesSelectColumn = typeof AmpWorkflowStatusesSelectColumn[keyof typeof AmpWorkflowStatusesSelectColumn];
/** input type for updating data in table "amp_workflow_statuses" */
export type AmpWorkflowStatusesSetInput = {
  agent_instruction?: InputMaybe<Scalars['String']>;
  approval_rule?: InputMaybe<Scalars['String']>;
  approved_status_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AmpWorkflowStatusesStddevFields = {
  __typename?: 'amp_workflow_statuses_stddev_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesStddevOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AmpWorkflowStatusesStddevPopFields = {
  __typename?: 'amp_workflow_statuses_stddev_pop_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesStddevPopOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AmpWorkflowStatusesStddevSampFields = {
  __typename?: 'amp_workflow_statuses_stddev_samp_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesStddevSampOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "amp_workflow_statuses" */
export type AmpWorkflowStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpWorkflowStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpWorkflowStatusesStreamCursorValueInput = {
  agent_instruction?: InputMaybe<Scalars['String']>;
  approval_rule?: InputMaybe<Scalars['String']>;
  approved_status_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['String']>;
  category_rank?: InputMaybe<Scalars['smallint']>;
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpWorkflowStatusesSumFields = {
  __typename?: 'amp_workflow_statuses_sum_fields';
  category_rank?: Maybe<Scalars['smallint']>;
  position?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesSumOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "amp_workflow_statuses" */
export const AmpWorkflowStatusesUpdateColumn = {
  /** column name */
  AgentInstruction: 'agent_instruction',
  /** column name */
  ApprovalRule: 'approval_rule',
  /** column name */
  ApprovedStatusId: 'approved_status_id',
  /** column name */
  Category: 'category',
  /** column name */
  Color: 'color',
  /** column name */
  Name: 'name',
  /** column name */
  Position: 'position'
} as const;

export type AmpWorkflowStatusesUpdateColumn = typeof AmpWorkflowStatusesUpdateColumn[keyof typeof AmpWorkflowStatusesUpdateColumn];
export type AmpWorkflowStatusesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AmpWorkflowStatusesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpWorkflowStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: AmpWorkflowStatusesBoolExp;
};

/** aggregate var_pop on columns */
export type AmpWorkflowStatusesVarPopFields = {
  __typename?: 'amp_workflow_statuses_var_pop_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesVarPopOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AmpWorkflowStatusesVarSampFields = {
  __typename?: 'amp_workflow_statuses_var_samp_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesVarSampOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AmpWorkflowStatusesVarianceFields = {
  __typename?: 'amp_workflow_statuses_variance_fields';
  category_rank?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amp_workflow_statuses" */
export type AmpWorkflowStatusesVarianceOrderBy = {
  category_rank?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "amp_workflows" */
export type AmpWorkflows = {
  __typename?: 'amp_workflows';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_default: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  projects: Array<AmpProjects>;
  /** An aggregate relationship */
  projects_aggregate: AmpProjectsAggregate;
  /** An array relationship */
  statuses: Array<AmpWorkflowStatuses>;
  /** An aggregate relationship */
  statuses_aggregate: AmpWorkflowStatusesAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "amp_workflows" */
export type AmpWorkflowsProjectsArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


/** columns and relationships of "amp_workflows" */
export type AmpWorkflowsProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


/** columns and relationships of "amp_workflows" */
export type AmpWorkflowsStatusesArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


/** columns and relationships of "amp_workflows" */
export type AmpWorkflowsStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};

/** aggregated selection of "amp_workflows" */
export type AmpWorkflowsAggregate = {
  __typename?: 'amp_workflows_aggregate';
  aggregate?: Maybe<AmpWorkflowsAggregateFields>;
  nodes: Array<AmpWorkflows>;
};

/** aggregate fields of "amp_workflows" */
export type AmpWorkflowsAggregateFields = {
  __typename?: 'amp_workflows_aggregate_fields';
  avg?: Maybe<AmpWorkflowsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AmpWorkflowsMaxFields>;
  min?: Maybe<AmpWorkflowsMinFields>;
  stddev?: Maybe<AmpWorkflowsStddevFields>;
  stddev_pop?: Maybe<AmpWorkflowsStddevPopFields>;
  stddev_samp?: Maybe<AmpWorkflowsStddevSampFields>;
  sum?: Maybe<AmpWorkflowsSumFields>;
  var_pop?: Maybe<AmpWorkflowsVarPopFields>;
  var_samp?: Maybe<AmpWorkflowsVarSampFields>;
  variance?: Maybe<AmpWorkflowsVarianceFields>;
};


/** aggregate fields of "amp_workflows" */
export type AmpWorkflowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AmpWorkflowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AmpWorkflowsAvgFields = {
  __typename?: 'amp_workflows_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "amp_workflows". All fields are combined with a logical 'AND'. */
export type AmpWorkflowsBoolExp = {
  _and?: InputMaybe<Array<AmpWorkflowsBoolExp>>;
  _not?: InputMaybe<AmpWorkflowsBoolExp>;
  _or?: InputMaybe<Array<AmpWorkflowsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_default?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  projects?: InputMaybe<AmpProjectsBoolExp>;
  projects_aggregate?: InputMaybe<AmpProjectsAggregateBoolExp>;
  statuses?: InputMaybe<AmpWorkflowStatusesBoolExp>;
  statuses_aggregate?: InputMaybe<AmpWorkflowStatusesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "amp_workflows" */
export const AmpWorkflowsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AmpWorkflowsIdWorkspaceIdKey: 'amp_workflows_id_workspace_id_key',
  /** unique or primary key constraint on columns "workspace_id" */
  AmpWorkflowsOneDefaultPerWorkspace: 'amp_workflows_one_default_per_workspace',
  /** unique or primary key constraint on columns "id" */
  AmpWorkflowsPkey: 'amp_workflows_pkey'
} as const;

export type AmpWorkflowsConstraint = typeof AmpWorkflowsConstraint[keyof typeof AmpWorkflowsConstraint];
/** input type for inserting data into table "amp_workflows" */
export type AmpWorkflowsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<AmpWorkflowStatusesArrRelInsertInput>;
};

/** aggregate max on columns */
export type AmpWorkflowsMaxFields = {
  __typename?: 'amp_workflows_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AmpWorkflowsMinFields = {
  __typename?: 'amp_workflows_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "amp_workflows" */
export type AmpWorkflowsMutationResponse = {
  __typename?: 'amp_workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AmpWorkflows>;
};

/** input type for inserting object relation for remote table "amp_workflows" */
export type AmpWorkflowsObjRelInsertInput = {
  data: AmpWorkflowsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AmpWorkflowsOnConflict>;
};

/** on_conflict condition type for table "amp_workflows" */
export type AmpWorkflowsOnConflict = {
  constraint: AmpWorkflowsConstraint;
  update_columns?: Array<AmpWorkflowsUpdateColumn>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};

/** Ordering options when selecting data from "amp_workflows". */
export type AmpWorkflowsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_default?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  projects_aggregate?: InputMaybe<AmpProjectsAggregateOrderBy>;
  statuses_aggregate?: InputMaybe<AmpWorkflowStatusesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: amp_workflows */
export type AmpWorkflowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "amp_workflows" */
export const AmpWorkflowsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  IsDefault: 'is_default',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AmpWorkflowsSelectColumn = typeof AmpWorkflowsSelectColumn[keyof typeof AmpWorkflowsSelectColumn];
/** input type for updating data in table "amp_workflows" */
export type AmpWorkflowsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AmpWorkflowsStddevFields = {
  __typename?: 'amp_workflows_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AmpWorkflowsStddevPopFields = {
  __typename?: 'amp_workflows_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AmpWorkflowsStddevSampFields = {
  __typename?: 'amp_workflows_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "amp_workflows" */
export type AmpWorkflowsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AmpWorkflowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AmpWorkflowsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AmpWorkflowsSumFields = {
  __typename?: 'amp_workflows_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "amp_workflows" */
export const AmpWorkflowsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  IsDefault: 'is_default',
  /** column name */
  Name: 'name'
} as const;

export type AmpWorkflowsUpdateColumn = typeof AmpWorkflowsUpdateColumn[keyof typeof AmpWorkflowsUpdateColumn];
export type AmpWorkflowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AmpWorkflowsSetInput>;
  /** filter the rows which have to be updated */
  where: AmpWorkflowsBoolExp;
};

/** aggregate var_pop on columns */
export type AmpWorkflowsVarPopFields = {
  __typename?: 'amp_workflows_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AmpWorkflowsVarSampFields = {
  __typename?: 'amp_workflows_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AmpWorkflowsVarianceFields = {
  __typename?: 'amp_workflows_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "analytics_ingestion_stats" */
export type AnalyticsIngestionStats = {
  __typename?: 'analytics_ingestion_stats';
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  duration_ms: Scalars['bigint'];
  error?: Maybe<Scalars['String']>;
  extracted_audiences_count?: Maybe<Scalars['Int']>;
  last_ran_at: Scalars['timestamptz'];
  processed_ad_accounts_count?: Maybe<Scalars['Int']>;
  report_type: Scalars['String'];
  status: Scalars['String'];
  uuid: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "analytics_ingestion_stats". All fields are combined with a logical 'AND'. */
export type AnalyticsIngestionStatsBoolExp = {
  _and?: InputMaybe<Array<AnalyticsIngestionStatsBoolExp>>;
  _not?: InputMaybe<AnalyticsIngestionStatsBoolExp>;
  _or?: InputMaybe<Array<AnalyticsIngestionStatsBoolExp>>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  duration_ms?: InputMaybe<BigintComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  extracted_audiences_count?: InputMaybe<IntComparisonExp>;
  last_ran_at?: InputMaybe<TimestamptzComparisonExp>;
  processed_ad_accounts_count?: InputMaybe<IntComparisonExp>;
  report_type?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "analytics_ingestion_stats". */
export type AnalyticsIngestionStatsOrderBy = {
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  duration_ms?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  extracted_audiences_count?: InputMaybe<OrderBy>;
  last_ran_at?: InputMaybe<OrderBy>;
  processed_ad_accounts_count?: InputMaybe<OrderBy>;
  report_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** select columns of table "analytics_ingestion_stats" */
export const AnalyticsIngestionStatsSelectColumn = {
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  DurationMs: 'duration_ms',
  /** column name */
  Error: 'error',
  /** column name */
  ExtractedAudiencesCount: 'extracted_audiences_count',
  /** column name */
  LastRanAt: 'last_ran_at',
  /** column name */
  ProcessedAdAccountsCount: 'processed_ad_accounts_count',
  /** column name */
  ReportType: 'report_type',
  /** column name */
  Status: 'status',
  /** column name */
  Uuid: 'uuid'
} as const;

export type AnalyticsIngestionStatsSelectColumn = typeof AnalyticsIngestionStatsSelectColumn[keyof typeof AnalyticsIngestionStatsSelectColumn];
/** Streaming cursor of the table "analytics_ingestion_stats" */
export type AnalyticsIngestionStatsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalyticsIngestionStatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalyticsIngestionStatsStreamCursorValueInput = {
  destination_id?: InputMaybe<Scalars['bigint']>;
  duration_ms?: InputMaybe<Scalars['bigint']>;
  error?: InputMaybe<Scalars['String']>;
  extracted_audiences_count?: InputMaybe<Scalars['Int']>;
  last_ran_at?: InputMaybe<Scalars['timestamptz']>;
  processed_ad_accounts_count?: InputMaybe<Scalars['Int']>;
  report_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "analytics_reports" */
export type AnalyticsReports = {
  __typename?: 'analytics_reports';
  audience_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  dashboard_id?: Maybe<Scalars['uuid']>;
  experiment_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  saved_chart_id?: Maybe<Scalars['uuid']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "analytics_reports" */
export type AnalyticsReportsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AnalyticsReportsAppendInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "analytics_reports". All fields are combined with a logical 'AND'. */
export type AnalyticsReportsBoolExp = {
  _and?: InputMaybe<Array<AnalyticsReportsBoolExp>>;
  _not?: InputMaybe<AnalyticsReportsBoolExp>;
  _or?: InputMaybe<Array<AnalyticsReportsBoolExp>>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  dashboard_id?: InputMaybe<UuidComparisonExp>;
  experiment_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  saved_chart_id?: InputMaybe<UuidComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "analytics_reports" */
export const AnalyticsReportsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AnalyticsReportsIdWorkspaceIdKey: 'analytics_reports_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AnalyticsReportsPkey: 'analytics_reports_pkey'
} as const;

export type AnalyticsReportsConstraint = typeof AnalyticsReportsConstraint[keyof typeof AnalyticsReportsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AnalyticsReportsDeleteAtPathInput = {
  schedule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AnalyticsReportsDeleteElemInput = {
  schedule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AnalyticsReportsDeleteKeyInput = {
  schedule?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "analytics_reports" */
export type AnalyticsReportsInsertInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
};

/** response of any mutation on the table "analytics_reports" */
export type AnalyticsReportsMutationResponse = {
  __typename?: 'analytics_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalyticsReports>;
};

/** input type for inserting object relation for remote table "analytics_reports" */
export type AnalyticsReportsObjRelInsertInput = {
  data: AnalyticsReportsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalyticsReportsOnConflict>;
};

/** on_conflict condition type for table "analytics_reports" */
export type AnalyticsReportsOnConflict = {
  constraint: AnalyticsReportsConstraint;
  update_columns?: Array<AnalyticsReportsUpdateColumn>;
  where?: InputMaybe<AnalyticsReportsBoolExp>;
};

/** Ordering options when selecting data from "analytics_reports". */
export type AnalyticsReportsOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analytics_reports */
export type AnalyticsReportsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AnalyticsReportsPrependInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "analytics_reports" */
export const AnalyticsReportsSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DashboardId: 'dashboard_id',
  /** column name */
  ExperimentId: 'experiment_id',
  /** column name */
  Id: 'id',
  /** column name */
  SavedChartId: 'saved_chart_id',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type AnalyticsReportsSelectColumn = typeof AnalyticsReportsSelectColumn[keyof typeof AnalyticsReportsSelectColumn];
/** input type for updating data in table "analytics_reports" */
export type AnalyticsReportsSetInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "analytics_reports" */
export type AnalyticsReportsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalyticsReportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalyticsReportsStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "analytics_reports" */
export const AnalyticsReportsUpdateColumn = {
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type AnalyticsReportsUpdateColumn = typeof AnalyticsReportsUpdateColumn[keyof typeof AnalyticsReportsUpdateColumn];
export type AnalyticsReportsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AnalyticsReportsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AnalyticsReportsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AnalyticsReportsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AnalyticsReportsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AnalyticsReportsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalyticsReportsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalyticsReportsBoolExp;
};

/** columns and relationships of "api_keys" */
export type ApiKeys = {
  __typename?: 'api_keys';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  last_used?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  user_group?: Maybe<UserGroups>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "api_keys" */
export type ApiKeysAggregateOrderBy = {
  avg?: InputMaybe<ApiKeysAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApiKeysMaxOrderBy>;
  min?: InputMaybe<ApiKeysMinOrderBy>;
  stddev?: InputMaybe<ApiKeysStddevOrderBy>;
  stddev_pop?: InputMaybe<ApiKeysStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ApiKeysStddevSampOrderBy>;
  sum?: InputMaybe<ApiKeysSumOrderBy>;
  var_pop?: InputMaybe<ApiKeysVarPopOrderBy>;
  var_samp?: InputMaybe<ApiKeysVarSampOrderBy>;
  variance?: InputMaybe<ApiKeysVarianceOrderBy>;
};

/** order by avg() on columns of table "api_keys" */
export type ApiKeysAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "api_keys". All fields are combined with a logical 'AND'. */
export type ApiKeysBoolExp = {
  _and?: InputMaybe<Array<ApiKeysBoolExp>>;
  _not?: InputMaybe<ApiKeysBoolExp>;
  _or?: InputMaybe<Array<ApiKeysBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_used?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "api_keys" */
export type ApiKeysMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_used?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "api_keys" */
export type ApiKeysMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_used?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "api_keys" */
export type ApiKeysMutationResponse = {
  __typename?: 'api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApiKeys>;
};

/** Ordering options when selecting data from "api_keys". */
export type ApiKeysOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_used?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "api_keys" */
export const ApiKeysSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LastUsed: 'last_used',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ApiKeysSelectColumn = typeof ApiKeysSelectColumn[keyof typeof ApiKeysSelectColumn];
/** order by stddev() on columns of table "api_keys" */
export type ApiKeysStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "api_keys" */
export type ApiKeysStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "api_keys" */
export type ApiKeysStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "api_keys" */
export type ApiKeysStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApiKeysStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApiKeysStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_used?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "api_keys" */
export type ApiKeysSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "api_keys" */
export type ApiKeysVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "api_keys" */
export type ApiKeysVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "api_keys" */
export type ApiKeysVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "artifact_favorites" */
export type ArtifactFavorites = {
  __typename?: 'artifact_favorites';
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "artifact_favorites" */
export type ArtifactFavoritesAggregate = {
  __typename?: 'artifact_favorites_aggregate';
  aggregate?: Maybe<ArtifactFavoritesAggregateFields>;
  nodes: Array<ArtifactFavorites>;
};

export type ArtifactFavoritesAggregateBoolExp = {
  count?: InputMaybe<ArtifactFavoritesAggregateBoolExpCount>;
};

export type ArtifactFavoritesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ArtifactFavoritesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "artifact_favorites" */
export type ArtifactFavoritesAggregateFields = {
  __typename?: 'artifact_favorites_aggregate_fields';
  avg?: Maybe<ArtifactFavoritesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArtifactFavoritesMaxFields>;
  min?: Maybe<ArtifactFavoritesMinFields>;
  stddev?: Maybe<ArtifactFavoritesStddevFields>;
  stddev_pop?: Maybe<ArtifactFavoritesStddevPopFields>;
  stddev_samp?: Maybe<ArtifactFavoritesStddevSampFields>;
  sum?: Maybe<ArtifactFavoritesSumFields>;
  var_pop?: Maybe<ArtifactFavoritesVarPopFields>;
  var_samp?: Maybe<ArtifactFavoritesVarSampFields>;
  variance?: Maybe<ArtifactFavoritesVarianceFields>;
};


/** aggregate fields of "artifact_favorites" */
export type ArtifactFavoritesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "artifact_favorites" */
export type ArtifactFavoritesAggregateOrderBy = {
  avg?: InputMaybe<ArtifactFavoritesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ArtifactFavoritesMaxOrderBy>;
  min?: InputMaybe<ArtifactFavoritesMinOrderBy>;
  stddev?: InputMaybe<ArtifactFavoritesStddevOrderBy>;
  stddev_pop?: InputMaybe<ArtifactFavoritesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ArtifactFavoritesStddevSampOrderBy>;
  sum?: InputMaybe<ArtifactFavoritesSumOrderBy>;
  var_pop?: InputMaybe<ArtifactFavoritesVarPopOrderBy>;
  var_samp?: InputMaybe<ArtifactFavoritesVarSampOrderBy>;
  variance?: InputMaybe<ArtifactFavoritesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "artifact_favorites" */
export type ArtifactFavoritesArrRelInsertInput = {
  data: Array<ArtifactFavoritesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactFavoritesOnConflict>;
};

/** aggregate avg on columns */
export type ArtifactFavoritesAvgFields = {
  __typename?: 'artifact_favorites_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "artifact_favorites" */
export type ArtifactFavoritesAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "artifact_favorites". All fields are combined with a logical 'AND'. */
export type ArtifactFavoritesBoolExp = {
  _and?: InputMaybe<Array<ArtifactFavoritesBoolExp>>;
  _not?: InputMaybe<ArtifactFavoritesBoolExp>;
  _or?: InputMaybe<Array<ArtifactFavoritesBoolExp>>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "artifact_favorites" */
export const ArtifactFavoritesConstraint = {
  /** unique or primary key constraint on columns "user_id", "campaign_artifact_id" */
  ArtifactFavoritesPkey: 'artifact_favorites_pkey'
} as const;

export type ArtifactFavoritesConstraint = typeof ArtifactFavoritesConstraint[keyof typeof ArtifactFavoritesConstraint];
/** input type for inserting data into table "artifact_favorites" */
export type ArtifactFavoritesInsertInput = {
  campaign_artifact?: InputMaybe<CampaignArtifactsObjRelInsertInput>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ArtifactFavoritesMaxFields = {
  __typename?: 'artifact_favorites_max_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "artifact_favorites" */
export type ArtifactFavoritesMaxOrderBy = {
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ArtifactFavoritesMinFields = {
  __typename?: 'artifact_favorites_min_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "artifact_favorites" */
export type ArtifactFavoritesMinOrderBy = {
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "artifact_favorites" */
export type ArtifactFavoritesMutationResponse = {
  __typename?: 'artifact_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArtifactFavorites>;
};

/** on_conflict condition type for table "artifact_favorites" */
export type ArtifactFavoritesOnConflict = {
  constraint: ArtifactFavoritesConstraint;
  update_columns?: Array<ArtifactFavoritesUpdateColumn>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};

/** Ordering options when selecting data from "artifact_favorites". */
export type ArtifactFavoritesOrderBy = {
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "artifact_favorites" */
export const ArtifactFavoritesSelectColumn = {
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ArtifactFavoritesSelectColumn = typeof ArtifactFavoritesSelectColumn[keyof typeof ArtifactFavoritesSelectColumn];
/** aggregate stddev on columns */
export type ArtifactFavoritesStddevFields = {
  __typename?: 'artifact_favorites_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "artifact_favorites" */
export type ArtifactFavoritesStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArtifactFavoritesStddevPopFields = {
  __typename?: 'artifact_favorites_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "artifact_favorites" */
export type ArtifactFavoritesStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArtifactFavoritesStddevSampFields = {
  __typename?: 'artifact_favorites_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "artifact_favorites" */
export type ArtifactFavoritesStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "artifact_favorites" */
export type ArtifactFavoritesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArtifactFavoritesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArtifactFavoritesStreamCursorValueInput = {
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ArtifactFavoritesSumFields = {
  __typename?: 'artifact_favorites_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "artifact_favorites" */
export type ArtifactFavoritesSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "artifact_favorites" (current role has no relevant permissions) */
export const ArtifactFavoritesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ArtifactFavoritesUpdateColumn = typeof ArtifactFavoritesUpdateColumn[keyof typeof ArtifactFavoritesUpdateColumn];
/** aggregate var_pop on columns */
export type ArtifactFavoritesVarPopFields = {
  __typename?: 'artifact_favorites_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "artifact_favorites" */
export type ArtifactFavoritesVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArtifactFavoritesVarSampFields = {
  __typename?: 'artifact_favorites_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "artifact_favorites" */
export type ArtifactFavoritesVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArtifactFavoritesVarianceFields = {
  __typename?: 'artifact_favorites_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "artifact_favorites" */
export type ArtifactFavoritesVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "artifact_review_comments" */
export type ArtifactReviewComments = {
  __typename?: 'artifact_review_comments';
  artifact_review_id: Scalars['uuid'];
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_interaction?: Maybe<LlmChatInteractions>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_version?: Maybe<CampaignArtifactVersions>;
  id: Scalars['uuid'];
  resolved_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  resolved_by_interaction?: Maybe<LlmChatInteractions>;
  resolved_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  resolved_by_version?: Maybe<CampaignArtifactVersions>;
  /** An object relationship */
  review?: Maybe<ArtifactReviews>;
  status: Scalars['String'];
  type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "artifact_review_comments" */
export type ArtifactReviewCommentsAggregate = {
  __typename?: 'artifact_review_comments_aggregate';
  aggregate?: Maybe<ArtifactReviewCommentsAggregateFields>;
  nodes: Array<ArtifactReviewComments>;
};

export type ArtifactReviewCommentsAggregateBoolExp = {
  count?: InputMaybe<ArtifactReviewCommentsAggregateBoolExpCount>;
};

export type ArtifactReviewCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ArtifactReviewCommentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "artifact_review_comments" */
export type ArtifactReviewCommentsAggregateFields = {
  __typename?: 'artifact_review_comments_aggregate_fields';
  avg?: Maybe<ArtifactReviewCommentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArtifactReviewCommentsMaxFields>;
  min?: Maybe<ArtifactReviewCommentsMinFields>;
  stddev?: Maybe<ArtifactReviewCommentsStddevFields>;
  stddev_pop?: Maybe<ArtifactReviewCommentsStddevPopFields>;
  stddev_samp?: Maybe<ArtifactReviewCommentsStddevSampFields>;
  sum?: Maybe<ArtifactReviewCommentsSumFields>;
  var_pop?: Maybe<ArtifactReviewCommentsVarPopFields>;
  var_samp?: Maybe<ArtifactReviewCommentsVarSampFields>;
  variance?: Maybe<ArtifactReviewCommentsVarianceFields>;
};


/** aggregate fields of "artifact_review_comments" */
export type ArtifactReviewCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "artifact_review_comments" */
export type ArtifactReviewCommentsAggregateOrderBy = {
  avg?: InputMaybe<ArtifactReviewCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ArtifactReviewCommentsMaxOrderBy>;
  min?: InputMaybe<ArtifactReviewCommentsMinOrderBy>;
  stddev?: InputMaybe<ArtifactReviewCommentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ArtifactReviewCommentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ArtifactReviewCommentsStddevSampOrderBy>;
  sum?: InputMaybe<ArtifactReviewCommentsSumOrderBy>;
  var_pop?: InputMaybe<ArtifactReviewCommentsVarPopOrderBy>;
  var_samp?: InputMaybe<ArtifactReviewCommentsVarSampOrderBy>;
  variance?: InputMaybe<ArtifactReviewCommentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "artifact_review_comments" */
export type ArtifactReviewCommentsArrRelInsertInput = {
  data: Array<ArtifactReviewCommentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactReviewCommentsOnConflict>;
};

/** aggregate avg on columns */
export type ArtifactReviewCommentsAvgFields = {
  __typename?: 'artifact_review_comments_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "artifact_review_comments". All fields are combined with a logical 'AND'. */
export type ArtifactReviewCommentsBoolExp = {
  _and?: InputMaybe<Array<ArtifactReviewCommentsBoolExp>>;
  _not?: InputMaybe<ArtifactReviewCommentsBoolExp>;
  _or?: InputMaybe<Array<ArtifactReviewCommentsBoolExp>>;
  artifact_review_id?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_artifact_version_id?: InputMaybe<UuidComparisonExp>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  created_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_version?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resolved_by_artifact_version_id?: InputMaybe<UuidComparisonExp>;
  resolved_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  resolved_by_version?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  review?: InputMaybe<ArtifactReviewsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "artifact_review_comments" */
export const ArtifactReviewCommentsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ArtifactReviewCommentsIdWorkspaceIdKey: 'artifact_review_comments_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ArtifactReviewCommentsPkey: 'artifact_review_comments_pkey'
} as const;

export type ArtifactReviewCommentsConstraint = typeof ArtifactReviewCommentsConstraint[keyof typeof ArtifactReviewCommentsConstraint];
/** input type for inserting data into table "artifact_review_comments" */
export type ArtifactReviewCommentsInsertInput = {
  artifact_review_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_by_artifact_version_id?: InputMaybe<Scalars['uuid']>;
  created_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  review?: InputMaybe<ArtifactReviewsObjRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArtifactReviewCommentsMaxFields = {
  __typename?: 'artifact_review_comments_max_fields';
  artifact_review_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  resolved_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  resolved_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsMaxOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_artifact_version_id?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resolved_by_artifact_version_id?: InputMaybe<OrderBy>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ArtifactReviewCommentsMinFields = {
  __typename?: 'artifact_review_comments_min_fields';
  artifact_review_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  created_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  resolved_by_artifact_version_id?: Maybe<Scalars['uuid']>;
  resolved_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsMinOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_artifact_version_id?: InputMaybe<OrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resolved_by_artifact_version_id?: InputMaybe<OrderBy>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "artifact_review_comments" */
export type ArtifactReviewCommentsMutationResponse = {
  __typename?: 'artifact_review_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArtifactReviewComments>;
};

/** on_conflict condition type for table "artifact_review_comments" */
export type ArtifactReviewCommentsOnConflict = {
  constraint: ArtifactReviewCommentsConstraint;
  update_columns?: Array<ArtifactReviewCommentsUpdateColumn>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};

/** Ordering options when selecting data from "artifact_review_comments". */
export type ArtifactReviewCommentsOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_artifact_version_id?: InputMaybe<OrderBy>;
  created_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  created_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  created_by_version?: InputMaybe<CampaignArtifactVersionsOrderBy>;
  id?: InputMaybe<OrderBy>;
  resolved_by_artifact_version_id?: InputMaybe<OrderBy>;
  resolved_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  resolved_by_version?: InputMaybe<CampaignArtifactVersionsOrderBy>;
  review?: InputMaybe<ArtifactReviewsOrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: artifact_review_comments */
export type ArtifactReviewCommentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "artifact_review_comments" */
export const ArtifactReviewCommentsSelectColumn = {
  /** column name */
  ArtifactReviewId: 'artifact_review_id',
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByArtifactVersionId: 'created_by_artifact_version_id',
  /** column name */
  CreatedByLlmChatInteractionId: 'created_by_llm_chat_interaction_id',
  /** column name */
  Id: 'id',
  /** column name */
  ResolvedByArtifactVersionId: 'resolved_by_artifact_version_id',
  /** column name */
  ResolvedByLlmChatInteractionId: 'resolved_by_llm_chat_interaction_id',
  /** column name */
  Status: 'status',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ArtifactReviewCommentsSelectColumn = typeof ArtifactReviewCommentsSelectColumn[keyof typeof ArtifactReviewCommentsSelectColumn];
/** input type for updating data in table "artifact_review_comments" */
export type ArtifactReviewCommentsSetInput = {
  resolved_by_artifact_version_id?: InputMaybe<Scalars['uuid']>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ArtifactReviewCommentsStddevFields = {
  __typename?: 'artifact_review_comments_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArtifactReviewCommentsStddevPopFields = {
  __typename?: 'artifact_review_comments_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArtifactReviewCommentsStddevSampFields = {
  __typename?: 'artifact_review_comments_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "artifact_review_comments" */
export type ArtifactReviewCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArtifactReviewCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArtifactReviewCommentsStreamCursorValueInput = {
  artifact_review_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_artifact_version_id?: InputMaybe<Scalars['uuid']>;
  created_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  resolved_by_artifact_version_id?: InputMaybe<Scalars['uuid']>;
  resolved_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ArtifactReviewCommentsSumFields = {
  __typename?: 'artifact_review_comments_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "artifact_review_comments" */
export const ArtifactReviewCommentsUpdateColumn = {
  /** column name */
  ResolvedByArtifactVersionId: 'resolved_by_artifact_version_id',
  /** column name */
  ResolvedByLlmChatInteractionId: 'resolved_by_llm_chat_interaction_id',
  /** column name */
  Status: 'status'
} as const;

export type ArtifactReviewCommentsUpdateColumn = typeof ArtifactReviewCommentsUpdateColumn[keyof typeof ArtifactReviewCommentsUpdateColumn];
export type ArtifactReviewCommentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ArtifactReviewCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: ArtifactReviewCommentsBoolExp;
};

/** aggregate var_pop on columns */
export type ArtifactReviewCommentsVarPopFields = {
  __typename?: 'artifact_review_comments_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArtifactReviewCommentsVarSampFields = {
  __typename?: 'artifact_review_comments_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArtifactReviewCommentsVarianceFields = {
  __typename?: 'artifact_review_comments_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "artifact_review_comments" */
export type ArtifactReviewCommentsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "artifact_review_statuses" */
export type ArtifactReviewStatuses = {
  __typename?: 'artifact_review_statuses';
  artifact_review_id: Scalars['uuid'];
  comment?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  review?: Maybe<ArtifactReviews>;
  status: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "artifact_review_statuses" */
export type ArtifactReviewStatusesAggregate = {
  __typename?: 'artifact_review_statuses_aggregate';
  aggregate?: Maybe<ArtifactReviewStatusesAggregateFields>;
  nodes: Array<ArtifactReviewStatuses>;
};

export type ArtifactReviewStatusesAggregateBoolExp = {
  count?: InputMaybe<ArtifactReviewStatusesAggregateBoolExpCount>;
};

export type ArtifactReviewStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ArtifactReviewStatusesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "artifact_review_statuses" */
export type ArtifactReviewStatusesAggregateFields = {
  __typename?: 'artifact_review_statuses_aggregate_fields';
  avg?: Maybe<ArtifactReviewStatusesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArtifactReviewStatusesMaxFields>;
  min?: Maybe<ArtifactReviewStatusesMinFields>;
  stddev?: Maybe<ArtifactReviewStatusesStddevFields>;
  stddev_pop?: Maybe<ArtifactReviewStatusesStddevPopFields>;
  stddev_samp?: Maybe<ArtifactReviewStatusesStddevSampFields>;
  sum?: Maybe<ArtifactReviewStatusesSumFields>;
  var_pop?: Maybe<ArtifactReviewStatusesVarPopFields>;
  var_samp?: Maybe<ArtifactReviewStatusesVarSampFields>;
  variance?: Maybe<ArtifactReviewStatusesVarianceFields>;
};


/** aggregate fields of "artifact_review_statuses" */
export type ArtifactReviewStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "artifact_review_statuses" */
export type ArtifactReviewStatusesAggregateOrderBy = {
  avg?: InputMaybe<ArtifactReviewStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ArtifactReviewStatusesMaxOrderBy>;
  min?: InputMaybe<ArtifactReviewStatusesMinOrderBy>;
  stddev?: InputMaybe<ArtifactReviewStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<ArtifactReviewStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ArtifactReviewStatusesStddevSampOrderBy>;
  sum?: InputMaybe<ArtifactReviewStatusesSumOrderBy>;
  var_pop?: InputMaybe<ArtifactReviewStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<ArtifactReviewStatusesVarSampOrderBy>;
  variance?: InputMaybe<ArtifactReviewStatusesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "artifact_review_statuses" */
export type ArtifactReviewStatusesArrRelInsertInput = {
  data: Array<ArtifactReviewStatusesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactReviewStatusesOnConflict>;
};

/** aggregate avg on columns */
export type ArtifactReviewStatusesAvgFields = {
  __typename?: 'artifact_review_statuses_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "artifact_review_statuses". All fields are combined with a logical 'AND'. */
export type ArtifactReviewStatusesBoolExp = {
  _and?: InputMaybe<Array<ArtifactReviewStatusesBoolExp>>;
  _not?: InputMaybe<ArtifactReviewStatusesBoolExp>;
  _or?: InputMaybe<Array<ArtifactReviewStatusesBoolExp>>;
  artifact_review_id?: InputMaybe<UuidComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  review?: InputMaybe<ArtifactReviewsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "artifact_review_statuses" */
export const ArtifactReviewStatusesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ArtifactReviewStatusesIdWorkspaceIdKey: 'artifact_review_statuses_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ArtifactReviewStatusesPkey: 'artifact_review_statuses_pkey'
} as const;

export type ArtifactReviewStatusesConstraint = typeof ArtifactReviewStatusesConstraint[keyof typeof ArtifactReviewStatusesConstraint];
/** input type for inserting data into table "artifact_review_statuses" */
export type ArtifactReviewStatusesInsertInput = {
  artifact_review_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<ArtifactReviewsObjRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ArtifactReviewStatusesMaxFields = {
  __typename?: 'artifact_review_statuses_max_fields';
  artifact_review_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesMaxOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ArtifactReviewStatusesMinFields = {
  __typename?: 'artifact_review_statuses_min_fields';
  artifact_review_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesMinOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "artifact_review_statuses" */
export type ArtifactReviewStatusesMutationResponse = {
  __typename?: 'artifact_review_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArtifactReviewStatuses>;
};

/** on_conflict condition type for table "artifact_review_statuses" */
export type ArtifactReviewStatusesOnConflict = {
  constraint: ArtifactReviewStatusesConstraint;
  update_columns?: Array<ArtifactReviewStatusesUpdateColumn>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};

/** Ordering options when selecting data from "artifact_review_statuses". */
export type ArtifactReviewStatusesOrderBy = {
  artifact_review_id?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  review?: InputMaybe<ArtifactReviewsOrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "artifact_review_statuses" */
export const ArtifactReviewStatusesSelectColumn = {
  /** column name */
  ArtifactReviewId: 'artifact_review_id',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ArtifactReviewStatusesSelectColumn = typeof ArtifactReviewStatusesSelectColumn[keyof typeof ArtifactReviewStatusesSelectColumn];
/** aggregate stddev on columns */
export type ArtifactReviewStatusesStddevFields = {
  __typename?: 'artifact_review_statuses_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArtifactReviewStatusesStddevPopFields = {
  __typename?: 'artifact_review_statuses_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArtifactReviewStatusesStddevSampFields = {
  __typename?: 'artifact_review_statuses_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "artifact_review_statuses" */
export type ArtifactReviewStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArtifactReviewStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArtifactReviewStatusesStreamCursorValueInput = {
  artifact_review_id?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ArtifactReviewStatusesSumFields = {
  __typename?: 'artifact_review_statuses_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "artifact_review_statuses" (current role has no relevant permissions) */
export const ArtifactReviewStatusesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ArtifactReviewStatusesUpdateColumn = typeof ArtifactReviewStatusesUpdateColumn[keyof typeof ArtifactReviewStatusesUpdateColumn];
/** aggregate var_pop on columns */
export type ArtifactReviewStatusesVarPopFields = {
  __typename?: 'artifact_review_statuses_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArtifactReviewStatusesVarSampFields = {
  __typename?: 'artifact_review_statuses_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArtifactReviewStatusesVarianceFields = {
  __typename?: 'artifact_review_statuses_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "artifact_review_statuses" */
export type ArtifactReviewStatusesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "artifact_reviewers" */
export type ArtifactReviewers = {
  __typename?: 'artifact_reviewers';
  artifact_types: Array<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  custom_agent?: Maybe<CustomAgents>;
  custom_agent_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  reviews: Array<ArtifactReviews>;
  /** An aggregate relationship */
  reviews_aggregate: ArtifactReviewsAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "artifact_reviewers" */
export type ArtifactReviewersReviewsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


/** columns and relationships of "artifact_reviewers" */
export type ArtifactReviewersReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};

/** aggregated selection of "artifact_reviewers" */
export type ArtifactReviewersAggregate = {
  __typename?: 'artifact_reviewers_aggregate';
  aggregate?: Maybe<ArtifactReviewersAggregateFields>;
  nodes: Array<ArtifactReviewers>;
};

/** aggregate fields of "artifact_reviewers" */
export type ArtifactReviewersAggregateFields = {
  __typename?: 'artifact_reviewers_aggregate_fields';
  avg?: Maybe<ArtifactReviewersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArtifactReviewersMaxFields>;
  min?: Maybe<ArtifactReviewersMinFields>;
  stddev?: Maybe<ArtifactReviewersStddevFields>;
  stddev_pop?: Maybe<ArtifactReviewersStddevPopFields>;
  stddev_samp?: Maybe<ArtifactReviewersStddevSampFields>;
  sum?: Maybe<ArtifactReviewersSumFields>;
  var_pop?: Maybe<ArtifactReviewersVarPopFields>;
  var_samp?: Maybe<ArtifactReviewersVarSampFields>;
  variance?: Maybe<ArtifactReviewersVarianceFields>;
};


/** aggregate fields of "artifact_reviewers" */
export type ArtifactReviewersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ArtifactReviewersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ArtifactReviewersAvgFields = {
  __typename?: 'artifact_reviewers_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "artifact_reviewers". All fields are combined with a logical 'AND'. */
export type ArtifactReviewersBoolExp = {
  _and?: InputMaybe<Array<ArtifactReviewersBoolExp>>;
  _not?: InputMaybe<ArtifactReviewersBoolExp>;
  _or?: InputMaybe<Array<ArtifactReviewersBoolExp>>;
  artifact_types?: InputMaybe<StringArrayComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  custom_agent?: InputMaybe<CustomAgentsBoolExp>;
  custom_agent_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  reviews?: InputMaybe<ArtifactReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<ArtifactReviewsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "artifact_reviewers" */
export const ArtifactReviewersConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ArtifactReviewersIdWorkspaceIdKey: 'artifact_reviewers_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ArtifactReviewersPkey: 'artifact_reviewers_pkey'
} as const;

export type ArtifactReviewersConstraint = typeof ArtifactReviewersConstraint[keyof typeof ArtifactReviewersConstraint];
/** input type for inserting data into table "artifact_reviewers" */
export type ArtifactReviewersInsertInput = {
  artifact_types?: InputMaybe<Array<Scalars['String']>>;
  custom_agent?: InputMaybe<CustomAgentsObjRelInsertInput>;
  custom_agent_id?: InputMaybe<Scalars['uuid']>;
  reviews?: InputMaybe<ArtifactReviewsArrRelInsertInput>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ArtifactReviewersMaxFields = {
  __typename?: 'artifact_reviewers_max_fields';
  artifact_types?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_agent_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ArtifactReviewersMinFields = {
  __typename?: 'artifact_reviewers_min_fields';
  artifact_types?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_agent_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "artifact_reviewers" */
export type ArtifactReviewersMutationResponse = {
  __typename?: 'artifact_reviewers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArtifactReviewers>;
};

/** input type for inserting object relation for remote table "artifact_reviewers" */
export type ArtifactReviewersObjRelInsertInput = {
  data: ArtifactReviewersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactReviewersOnConflict>;
};

/** on_conflict condition type for table "artifact_reviewers" */
export type ArtifactReviewersOnConflict = {
  constraint: ArtifactReviewersConstraint;
  update_columns?: Array<ArtifactReviewersUpdateColumn>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};

/** Ordering options when selecting data from "artifact_reviewers". */
export type ArtifactReviewersOrderBy = {
  artifact_types?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  custom_agent?: InputMaybe<CustomAgentsOrderBy>;
  custom_agent_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reviews_aggregate?: InputMaybe<ArtifactReviewsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: artifact_reviewers */
export type ArtifactReviewersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "artifact_reviewers" */
export const ArtifactReviewersSelectColumn = {
  /** column name */
  ArtifactTypes: 'artifact_types',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CustomAgentId: 'custom_agent_id',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ArtifactReviewersSelectColumn = typeof ArtifactReviewersSelectColumn[keyof typeof ArtifactReviewersSelectColumn];
/** input type for updating data in table "artifact_reviewers" */
export type ArtifactReviewersSetInput = {
  artifact_types?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate stddev on columns */
export type ArtifactReviewersStddevFields = {
  __typename?: 'artifact_reviewers_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ArtifactReviewersStddevPopFields = {
  __typename?: 'artifact_reviewers_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ArtifactReviewersStddevSampFields = {
  __typename?: 'artifact_reviewers_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "artifact_reviewers" */
export type ArtifactReviewersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArtifactReviewersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArtifactReviewersStreamCursorValueInput = {
  artifact_types?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_agent_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ArtifactReviewersSumFields = {
  __typename?: 'artifact_reviewers_sum_fields';
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "artifact_reviewers" */
export const ArtifactReviewersUpdateColumn = {
  /** column name */
  ArtifactTypes: 'artifact_types'
} as const;

export type ArtifactReviewersUpdateColumn = typeof ArtifactReviewersUpdateColumn[keyof typeof ArtifactReviewersUpdateColumn];
export type ArtifactReviewersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ArtifactReviewersSetInput>;
  /** filter the rows which have to be updated */
  where: ArtifactReviewersBoolExp;
};

/** aggregate var_pop on columns */
export type ArtifactReviewersVarPopFields = {
  __typename?: 'artifact_reviewers_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ArtifactReviewersVarSampFields = {
  __typename?: 'artifact_reviewers_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ArtifactReviewersVarianceFields = {
  __typename?: 'artifact_reviewers_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "artifact_reviews" */
export type ArtifactReviews = {
  __typename?: 'artifact_reviews';
  /** An object relationship */
  artifact?: Maybe<CampaignArtifacts>;
  artifact_id: Scalars['uuid'];
  artifact_reviewer_id: Scalars['uuid'];
  artifact_version_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  comments: Array<ArtifactReviewComments>;
  /** An aggregate relationship */
  comments_aggregate: ArtifactReviewCommentsAggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  requested_by_user?: Maybe<Users>;
  requested_by_user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  reviewed_by_interaction?: Maybe<LlmChatInteractions>;
  reviewed_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  reviewer?: Maybe<ArtifactReviewers>;
  reviewer_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  statuses: Array<ArtifactReviewStatuses>;
  /** An aggregate relationship */
  statuses_aggregate: ArtifactReviewStatusesAggregate;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "artifact_reviews" */
export type ArtifactReviewsCommentsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


/** columns and relationships of "artifact_reviews" */
export type ArtifactReviewsCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


/** columns and relationships of "artifact_reviews" */
export type ArtifactReviewsStatusesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


/** columns and relationships of "artifact_reviews" */
export type ArtifactReviewsStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};

/** aggregated selection of "artifact_reviews" */
export type ArtifactReviewsAggregate = {
  __typename?: 'artifact_reviews_aggregate';
  aggregate?: Maybe<ArtifactReviewsAggregateFields>;
  nodes: Array<ArtifactReviews>;
};

export type ArtifactReviewsAggregateBoolExp = {
  count?: InputMaybe<ArtifactReviewsAggregateBoolExpCount>;
};

export type ArtifactReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ArtifactReviewsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "artifact_reviews" */
export type ArtifactReviewsAggregateFields = {
  __typename?: 'artifact_reviews_aggregate_fields';
  avg?: Maybe<ArtifactReviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ArtifactReviewsMaxFields>;
  min?: Maybe<ArtifactReviewsMinFields>;
  stddev?: Maybe<ArtifactReviewsStddevFields>;
  stddev_pop?: Maybe<ArtifactReviewsStddevPopFields>;
  stddev_samp?: Maybe<ArtifactReviewsStddevSampFields>;
  sum?: Maybe<ArtifactReviewsSumFields>;
  var_pop?: Maybe<ArtifactReviewsVarPopFields>;
  var_samp?: Maybe<ArtifactReviewsVarSampFields>;
  variance?: Maybe<ArtifactReviewsVarianceFields>;
};


/** aggregate fields of "artifact_reviews" */
export type ArtifactReviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "artifact_reviews" */
export type ArtifactReviewsAggregateOrderBy = {
  avg?: InputMaybe<ArtifactReviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ArtifactReviewsMaxOrderBy>;
  min?: InputMaybe<ArtifactReviewsMinOrderBy>;
  stddev?: InputMaybe<ArtifactReviewsStddevOrderBy>;
  stddev_pop?: InputMaybe<ArtifactReviewsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ArtifactReviewsStddevSampOrderBy>;
  sum?: InputMaybe<ArtifactReviewsSumOrderBy>;
  var_pop?: InputMaybe<ArtifactReviewsVarPopOrderBy>;
  var_samp?: InputMaybe<ArtifactReviewsVarSampOrderBy>;
  variance?: InputMaybe<ArtifactReviewsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "artifact_reviews" */
export type ArtifactReviewsArrRelInsertInput = {
  data: Array<ArtifactReviewsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactReviewsOnConflict>;
};

/** aggregate avg on columns */
export type ArtifactReviewsAvgFields = {
  __typename?: 'artifact_reviews_avg_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "artifact_reviews" */
export type ArtifactReviewsAvgOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "artifact_reviews". All fields are combined with a logical 'AND'. */
export type ArtifactReviewsBoolExp = {
  _and?: InputMaybe<Array<ArtifactReviewsBoolExp>>;
  _not?: InputMaybe<ArtifactReviewsBoolExp>;
  _or?: InputMaybe<Array<ArtifactReviewsBoolExp>>;
  artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  artifact_id?: InputMaybe<UuidComparisonExp>;
  artifact_reviewer_id?: InputMaybe<UuidComparisonExp>;
  artifact_version_id?: InputMaybe<UuidComparisonExp>;
  comments?: InputMaybe<ArtifactReviewCommentsBoolExp>;
  comments_aggregate?: InputMaybe<ArtifactReviewCommentsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requested_by_user?: InputMaybe<UsersBoolExp>;
  requested_by_user_id?: InputMaybe<BigintComparisonExp>;
  reviewed_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  reviewer?: InputMaybe<ArtifactReviewersBoolExp>;
  reviewer_type?: InputMaybe<StringComparisonExp>;
  statuses?: InputMaybe<ArtifactReviewStatusesBoolExp>;
  statuses_aggregate?: InputMaybe<ArtifactReviewStatusesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "artifact_reviews" */
export const ArtifactReviewsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ArtifactReviewsIdWorkspaceIdKey: 'artifact_reviews_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ArtifactReviewsPkey: 'artifact_reviews_pkey'
} as const;

export type ArtifactReviewsConstraint = typeof ArtifactReviewsConstraint[keyof typeof ArtifactReviewsConstraint];
/** input type for inserting data into table "artifact_reviews" */
export type ArtifactReviewsInsertInput = {
  artifact?: InputMaybe<CampaignArtifactsObjRelInsertInput>;
  artifact_id?: InputMaybe<Scalars['uuid']>;
  artifact_reviewer_id?: InputMaybe<Scalars['uuid']>;
  artifact_version_id?: InputMaybe<Scalars['uuid']>;
  comments?: InputMaybe<ArtifactReviewCommentsArrRelInsertInput>;
  requested_by_user_id?: InputMaybe<Scalars['bigint']>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  reviewer?: InputMaybe<ArtifactReviewersObjRelInsertInput>;
  reviewer_type?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<ArtifactReviewStatusesArrRelInsertInput>;
};

/** aggregate max on columns */
export type ArtifactReviewsMaxFields = {
  __typename?: 'artifact_reviews_max_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_reviewer_id?: Maybe<Scalars['uuid']>;
  artifact_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  requested_by_user_id?: Maybe<Scalars['bigint']>;
  reviewed_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  reviewer_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "artifact_reviews" */
export type ArtifactReviewsMaxOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  artifact_reviewer_id?: InputMaybe<OrderBy>;
  artifact_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requested_by_user_id?: InputMaybe<OrderBy>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  reviewer_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ArtifactReviewsMinFields = {
  __typename?: 'artifact_reviews_min_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_reviewer_id?: Maybe<Scalars['uuid']>;
  artifact_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  requested_by_user_id?: Maybe<Scalars['bigint']>;
  reviewed_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  reviewer_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "artifact_reviews" */
export type ArtifactReviewsMinOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  artifact_reviewer_id?: InputMaybe<OrderBy>;
  artifact_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requested_by_user_id?: InputMaybe<OrderBy>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  reviewer_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "artifact_reviews" */
export type ArtifactReviewsMutationResponse = {
  __typename?: 'artifact_reviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ArtifactReviews>;
};

/** input type for inserting object relation for remote table "artifact_reviews" */
export type ArtifactReviewsObjRelInsertInput = {
  data: ArtifactReviewsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ArtifactReviewsOnConflict>;
};

/** on_conflict condition type for table "artifact_reviews" */
export type ArtifactReviewsOnConflict = {
  constraint: ArtifactReviewsConstraint;
  update_columns?: Array<ArtifactReviewsUpdateColumn>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};

/** Ordering options when selecting data from "artifact_reviews". */
export type ArtifactReviewsOrderBy = {
  artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  artifact_id?: InputMaybe<OrderBy>;
  artifact_reviewer_id?: InputMaybe<OrderBy>;
  artifact_version_id?: InputMaybe<OrderBy>;
  comments_aggregate?: InputMaybe<ArtifactReviewCommentsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requested_by_user?: InputMaybe<UsersOrderBy>;
  requested_by_user_id?: InputMaybe<OrderBy>;
  reviewed_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  reviewer?: InputMaybe<ArtifactReviewersOrderBy>;
  reviewer_type?: InputMaybe<OrderBy>;
  statuses_aggregate?: InputMaybe<ArtifactReviewStatusesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: artifact_reviews */
export type ArtifactReviewsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "artifact_reviews" */
export const ArtifactReviewsSelectColumn = {
  /** column name */
  ArtifactId: 'artifact_id',
  /** column name */
  ArtifactReviewerId: 'artifact_reviewer_id',
  /** column name */
  ArtifactVersionId: 'artifact_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  RequestedByUserId: 'requested_by_user_id',
  /** column name */
  ReviewedByLlmChatInteractionId: 'reviewed_by_llm_chat_interaction_id',
  /** column name */
  ReviewerType: 'reviewer_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ArtifactReviewsSelectColumn = typeof ArtifactReviewsSelectColumn[keyof typeof ArtifactReviewsSelectColumn];
/** input type for updating data in table "artifact_reviews" */
export type ArtifactReviewsSetInput = {
  reviewed_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ArtifactReviewsStddevFields = {
  __typename?: 'artifact_reviews_stddev_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "artifact_reviews" */
export type ArtifactReviewsStddevOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ArtifactReviewsStddevPopFields = {
  __typename?: 'artifact_reviews_stddev_pop_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "artifact_reviews" */
export type ArtifactReviewsStddevPopOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ArtifactReviewsStddevSampFields = {
  __typename?: 'artifact_reviews_stddev_samp_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "artifact_reviews" */
export type ArtifactReviewsStddevSampOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "artifact_reviews" */
export type ArtifactReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ArtifactReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ArtifactReviewsStreamCursorValueInput = {
  artifact_id?: InputMaybe<Scalars['uuid']>;
  artifact_reviewer_id?: InputMaybe<Scalars['uuid']>;
  artifact_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  requested_by_user_id?: InputMaybe<Scalars['bigint']>;
  reviewed_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  reviewer_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ArtifactReviewsSumFields = {
  __typename?: 'artifact_reviews_sum_fields';
  requested_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "artifact_reviews" */
export type ArtifactReviewsSumOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "artifact_reviews" */
export const ArtifactReviewsUpdateColumn = {
  /** column name */
  ReviewedByLlmChatInteractionId: 'reviewed_by_llm_chat_interaction_id'
} as const;

export type ArtifactReviewsUpdateColumn = typeof ArtifactReviewsUpdateColumn[keyof typeof ArtifactReviewsUpdateColumn];
export type ArtifactReviewsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ArtifactReviewsSetInput>;
  /** filter the rows which have to be updated */
  where: ArtifactReviewsBoolExp;
};

/** aggregate var_pop on columns */
export type ArtifactReviewsVarPopFields = {
  __typename?: 'artifact_reviews_var_pop_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "artifact_reviews" */
export type ArtifactReviewsVarPopOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ArtifactReviewsVarSampFields = {
  __typename?: 'artifact_reviews_var_samp_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "artifact_reviews" */
export type ArtifactReviewsVarSampOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ArtifactReviewsVarianceFields = {
  __typename?: 'artifact_reviews_variance_fields';
  requested_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "artifact_reviews" */
export type ArtifactReviewsVarianceOrderBy = {
  requested_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comment_mentions" */
export type AssetCommentMentions = {
  __typename?: 'asset_comment_mentions';
  /** An object relationship */
  asset_comment?: Maybe<AssetComments>;
  asset_comment_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  mentioned_review_agent?: Maybe<ReviewAgents>;
  mentioned_review_agent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  mentioned_user?: Maybe<Users>;
  mentioned_user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "asset_comment_mentions" */
export type AssetCommentMentionsAggregate = {
  __typename?: 'asset_comment_mentions_aggregate';
  aggregate?: Maybe<AssetCommentMentionsAggregateFields>;
  nodes: Array<AssetCommentMentions>;
};

export type AssetCommentMentionsAggregateBoolExp = {
  count?: InputMaybe<AssetCommentMentionsAggregateBoolExpCount>;
};

export type AssetCommentMentionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetCommentMentionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_comment_mentions" */
export type AssetCommentMentionsAggregateFields = {
  __typename?: 'asset_comment_mentions_aggregate_fields';
  avg?: Maybe<AssetCommentMentionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetCommentMentionsMaxFields>;
  min?: Maybe<AssetCommentMentionsMinFields>;
  stddev?: Maybe<AssetCommentMentionsStddevFields>;
  stddev_pop?: Maybe<AssetCommentMentionsStddevPopFields>;
  stddev_samp?: Maybe<AssetCommentMentionsStddevSampFields>;
  sum?: Maybe<AssetCommentMentionsSumFields>;
  var_pop?: Maybe<AssetCommentMentionsVarPopFields>;
  var_samp?: Maybe<AssetCommentMentionsVarSampFields>;
  variance?: Maybe<AssetCommentMentionsVarianceFields>;
};


/** aggregate fields of "asset_comment_mentions" */
export type AssetCommentMentionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_comment_mentions" */
export type AssetCommentMentionsAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentMentionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentMentionsMaxOrderBy>;
  min?: InputMaybe<AssetCommentMentionsMinOrderBy>;
  stddev?: InputMaybe<AssetCommentMentionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentMentionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentMentionsStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentMentionsSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentMentionsVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentMentionsVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentMentionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetCommentMentionsAvgFields = {
  __typename?: 'asset_comment_mentions_avg_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsAvgOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comment_mentions". All fields are combined with a logical 'AND'. */
export type AssetCommentMentionsBoolExp = {
  _and?: InputMaybe<Array<AssetCommentMentionsBoolExp>>;
  _not?: InputMaybe<AssetCommentMentionsBoolExp>;
  _or?: InputMaybe<Array<AssetCommentMentionsBoolExp>>;
  asset_comment?: InputMaybe<AssetCommentsBoolExp>;
  asset_comment_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mentioned_review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  mentioned_review_agent_id?: InputMaybe<UuidComparisonExp>;
  mentioned_user?: InputMaybe<UsersBoolExp>;
  mentioned_user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetCommentMentionsMaxFields = {
  __typename?: 'asset_comment_mentions_max_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mentioned_review_agent_id?: Maybe<Scalars['uuid']>;
  mentioned_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsMaxOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mentioned_review_agent_id?: InputMaybe<OrderBy>;
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetCommentMentionsMinFields = {
  __typename?: 'asset_comment_mentions_min_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mentioned_review_agent_id?: Maybe<Scalars['uuid']>;
  mentioned_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsMinOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mentioned_review_agent_id?: InputMaybe<OrderBy>;
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_comment_mentions". */
export type AssetCommentMentionsOrderBy = {
  asset_comment?: InputMaybe<AssetCommentsOrderBy>;
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mentioned_review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  mentioned_review_agent_id?: InputMaybe<OrderBy>;
  mentioned_user?: InputMaybe<UsersOrderBy>;
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_comment_mentions" */
export const AssetCommentMentionsSelectColumn = {
  /** column name */
  AssetCommentId: 'asset_comment_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  MentionedReviewAgentId: 'mentioned_review_agent_id',
  /** column name */
  MentionedUserId: 'mentioned_user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentMentionsSelectColumn = typeof AssetCommentMentionsSelectColumn[keyof typeof AssetCommentMentionsSelectColumn];
/** aggregate stddev on columns */
export type AssetCommentMentionsStddevFields = {
  __typename?: 'asset_comment_mentions_stddev_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsStddevOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetCommentMentionsStddevPopFields = {
  __typename?: 'asset_comment_mentions_stddev_pop_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsStddevPopOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetCommentMentionsStddevSampFields = {
  __typename?: 'asset_comment_mentions_stddev_samp_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsStddevSampOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comment_mentions" */
export type AssetCommentMentionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentMentionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentMentionsStreamCursorValueInput = {
  asset_comment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mentioned_review_agent_id?: InputMaybe<Scalars['uuid']>;
  mentioned_user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetCommentMentionsSumFields = {
  __typename?: 'asset_comment_mentions_sum_fields';
  mentioned_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsSumOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetCommentMentionsVarPopFields = {
  __typename?: 'asset_comment_mentions_var_pop_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsVarPopOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetCommentMentionsVarSampFields = {
  __typename?: 'asset_comment_mentions_var_samp_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsVarSampOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetCommentMentionsVarianceFields = {
  __typename?: 'asset_comment_mentions_variance_fields';
  mentioned_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_comment_mentions" */
export type AssetCommentMentionsVarianceOrderBy = {
  mentioned_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comment_statuses" */
export type AssetCommentStatuses = {
  __typename?: 'asset_comment_statuses';
  /** An object relationship */
  asset_comment?: Maybe<AssetComments>;
  asset_comment_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_review_agent?: Maybe<ReviewAgents>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  status: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "asset_comment_statuses" */
export type AssetCommentStatusesAggregate = {
  __typename?: 'asset_comment_statuses_aggregate';
  aggregate?: Maybe<AssetCommentStatusesAggregateFields>;
  nodes: Array<AssetCommentStatuses>;
};

export type AssetCommentStatusesAggregateBoolExp = {
  count?: InputMaybe<AssetCommentStatusesAggregateBoolExpCount>;
};

export type AssetCommentStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetCommentStatusesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_comment_statuses" */
export type AssetCommentStatusesAggregateFields = {
  __typename?: 'asset_comment_statuses_aggregate_fields';
  avg?: Maybe<AssetCommentStatusesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetCommentStatusesMaxFields>;
  min?: Maybe<AssetCommentStatusesMinFields>;
  stddev?: Maybe<AssetCommentStatusesStddevFields>;
  stddev_pop?: Maybe<AssetCommentStatusesStddevPopFields>;
  stddev_samp?: Maybe<AssetCommentStatusesStddevSampFields>;
  sum?: Maybe<AssetCommentStatusesSumFields>;
  var_pop?: Maybe<AssetCommentStatusesVarPopFields>;
  var_samp?: Maybe<AssetCommentStatusesVarSampFields>;
  variance?: Maybe<AssetCommentStatusesVarianceFields>;
};


/** aggregate fields of "asset_comment_statuses" */
export type AssetCommentStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_comment_statuses" */
export type AssetCommentStatusesAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentStatusesMaxOrderBy>;
  min?: InputMaybe<AssetCommentStatusesMinOrderBy>;
  stddev?: InputMaybe<AssetCommentStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentStatusesStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentStatusesSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentStatusesVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentStatusesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetCommentStatusesAvgFields = {
  __typename?: 'asset_comment_statuses_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comment_statuses". All fields are combined with a logical 'AND'. */
export type AssetCommentStatusesBoolExp = {
  _and?: InputMaybe<Array<AssetCommentStatusesBoolExp>>;
  _not?: InputMaybe<AssetCommentStatusesBoolExp>;
  _or?: InputMaybe<Array<AssetCommentStatusesBoolExp>>;
  asset_comment?: InputMaybe<AssetCommentsBoolExp>;
  asset_comment_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  created_by_review_agent_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetCommentStatusesMaxFields = {
  __typename?: 'asset_comment_statuses_max_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesMaxOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetCommentStatusesMinFields = {
  __typename?: 'asset_comment_statuses_min_fields';
  asset_comment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesMinOrderBy = {
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_comment_statuses". */
export type AssetCommentStatusesOrderBy = {
  asset_comment?: InputMaybe<AssetCommentsOrderBy>;
  asset_comment_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_comment_statuses" */
export const AssetCommentStatusesSelectColumn = {
  /** column name */
  AssetCommentId: 'asset_comment_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByReviewAgentId: 'created_by_review_agent_id',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentStatusesSelectColumn = typeof AssetCommentStatusesSelectColumn[keyof typeof AssetCommentStatusesSelectColumn];
/** aggregate stddev on columns */
export type AssetCommentStatusesStddevFields = {
  __typename?: 'asset_comment_statuses_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetCommentStatusesStddevPopFields = {
  __typename?: 'asset_comment_statuses_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetCommentStatusesStddevSampFields = {
  __typename?: 'asset_comment_statuses_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comment_statuses" */
export type AssetCommentStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentStatusesStreamCursorValueInput = {
  asset_comment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: InputMaybe<Scalars['uuid']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetCommentStatusesSumFields = {
  __typename?: 'asset_comment_statuses_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetCommentStatusesVarPopFields = {
  __typename?: 'asset_comment_statuses_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetCommentStatusesVarSampFields = {
  __typename?: 'asset_comment_statuses_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetCommentStatusesVarianceFields = {
  __typename?: 'asset_comment_statuses_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_comment_statuses" */
export type AssetCommentStatusesVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comment_thread_reads" */
export type AssetCommentThreadReads = {
  __typename?: 'asset_comment_thread_reads';
  /** An object relationship */
  asset_comment_thread?: Maybe<AssetCommentThreads>;
  asset_comment_thread_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  last_read_comment_at: Scalars['timestamptz'];
  manually_marked_unread_at?: Maybe<Scalars['timestamptz']>;
  user_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentThreadReadsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentThreadReadsMaxOrderBy>;
  min?: InputMaybe<AssetCommentThreadReadsMinOrderBy>;
  stddev?: InputMaybe<AssetCommentThreadReadsStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentThreadReadsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentThreadReadsStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentThreadReadsSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentThreadReadsVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentThreadReadsVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentThreadReadsVarianceOrderBy>;
};

/** order by avg() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comment_thread_reads". All fields are combined with a logical 'AND'. */
export type AssetCommentThreadReadsBoolExp = {
  _and?: InputMaybe<Array<AssetCommentThreadReadsBoolExp>>;
  _not?: InputMaybe<AssetCommentThreadReadsBoolExp>;
  _or?: InputMaybe<Array<AssetCommentThreadReadsBoolExp>>;
  asset_comment_thread?: InputMaybe<AssetCommentThreadsBoolExp>;
  asset_comment_thread_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  last_read_comment_at?: InputMaybe<TimestamptzComparisonExp>;
  manually_marked_unread_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "asset_comment_thread_reads" */
export const AssetCommentThreadReadsConstraint = {
  /** unique or primary key constraint on columns "user_id", "workspace_id", "asset_comment_thread_id" */
  AssetCommentThreadReadsPkey: 'asset_comment_thread_reads_pkey'
} as const;

export type AssetCommentThreadReadsConstraint = typeof AssetCommentThreadReadsConstraint[keyof typeof AssetCommentThreadReadsConstraint];
/** input type for inserting data into table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsInsertInput = {
  asset_comment_thread_id?: InputMaybe<Scalars['uuid']>;
  last_read_comment_at?: InputMaybe<Scalars['timestamptz']>;
  manually_marked_unread_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsMaxOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  last_read_comment_at?: InputMaybe<OrderBy>;
  manually_marked_unread_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsMinOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  last_read_comment_at?: InputMaybe<OrderBy>;
  manually_marked_unread_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsMutationResponse = {
  __typename?: 'asset_comment_thread_reads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetCommentThreadReads>;
};

/** on_conflict condition type for table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsOnConflict = {
  constraint: AssetCommentThreadReadsConstraint;
  update_columns?: Array<AssetCommentThreadReadsUpdateColumn>;
  where?: InputMaybe<AssetCommentThreadReadsBoolExp>;
};

/** Ordering options when selecting data from "asset_comment_thread_reads". */
export type AssetCommentThreadReadsOrderBy = {
  asset_comment_thread?: InputMaybe<AssetCommentThreadsOrderBy>;
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  last_read_comment_at?: InputMaybe<OrderBy>;
  manually_marked_unread_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: asset_comment_thread_reads */
export type AssetCommentThreadReadsPkColumnsInput = {
  asset_comment_thread_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "asset_comment_thread_reads" */
export const AssetCommentThreadReadsSelectColumn = {
  /** column name */
  AssetCommentThreadId: 'asset_comment_thread_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  LastReadCommentAt: 'last_read_comment_at',
  /** column name */
  ManuallyMarkedUnreadAt: 'manually_marked_unread_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentThreadReadsSelectColumn = typeof AssetCommentThreadReadsSelectColumn[keyof typeof AssetCommentThreadReadsSelectColumn];
/** input type for updating data in table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsSetInput = {
  last_read_comment_at?: InputMaybe<Scalars['timestamptz']>;
  manually_marked_unread_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentThreadReadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentThreadReadsStreamCursorValueInput = {
  asset_comment_thread_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  last_read_comment_at?: InputMaybe<Scalars['timestamptz']>;
  manually_marked_unread_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "asset_comment_thread_reads" */
export const AssetCommentThreadReadsUpdateColumn = {
  /** column name */
  LastReadCommentAt: 'last_read_comment_at',
  /** column name */
  ManuallyMarkedUnreadAt: 'manually_marked_unread_at'
} as const;

export type AssetCommentThreadReadsUpdateColumn = typeof AssetCommentThreadReadsUpdateColumn[keyof typeof AssetCommentThreadReadsUpdateColumn];
export type AssetCommentThreadReadsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetCommentThreadReadsSetInput>;
  /** filter the rows which have to be updated */
  where: AssetCommentThreadReadsBoolExp;
};

/** order by var_pop() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "asset_comment_thread_reads" */
export type AssetCommentThreadReadsVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comment_thread_statuses" */
export type AssetCommentThreadStatuses = {
  __typename?: 'asset_comment_thread_statuses';
  /** An object relationship */
  asset_comment_thread?: Maybe<AssetCommentThreads>;
  asset_comment_thread_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_review_agent?: Maybe<ReviewAgents>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  status: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesAggregate = {
  __typename?: 'asset_comment_thread_statuses_aggregate';
  aggregate?: Maybe<AssetCommentThreadStatusesAggregateFields>;
  nodes: Array<AssetCommentThreadStatuses>;
};

export type AssetCommentThreadStatusesAggregateBoolExp = {
  count?: InputMaybe<AssetCommentThreadStatusesAggregateBoolExpCount>;
};

export type AssetCommentThreadStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesAggregateFields = {
  __typename?: 'asset_comment_thread_statuses_aggregate_fields';
  avg?: Maybe<AssetCommentThreadStatusesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetCommentThreadStatusesMaxFields>;
  min?: Maybe<AssetCommentThreadStatusesMinFields>;
  stddev?: Maybe<AssetCommentThreadStatusesStddevFields>;
  stddev_pop?: Maybe<AssetCommentThreadStatusesStddevPopFields>;
  stddev_samp?: Maybe<AssetCommentThreadStatusesStddevSampFields>;
  sum?: Maybe<AssetCommentThreadStatusesSumFields>;
  var_pop?: Maybe<AssetCommentThreadStatusesVarPopFields>;
  var_samp?: Maybe<AssetCommentThreadStatusesVarSampFields>;
  variance?: Maybe<AssetCommentThreadStatusesVarianceFields>;
};


/** aggregate fields of "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentThreadStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentThreadStatusesMaxOrderBy>;
  min?: InputMaybe<AssetCommentThreadStatusesMinOrderBy>;
  stddev?: InputMaybe<AssetCommentThreadStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentThreadStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentThreadStatusesStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentThreadStatusesSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentThreadStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentThreadStatusesVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentThreadStatusesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetCommentThreadStatusesAvgFields = {
  __typename?: 'asset_comment_thread_statuses_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comment_thread_statuses". All fields are combined with a logical 'AND'. */
export type AssetCommentThreadStatusesBoolExp = {
  _and?: InputMaybe<Array<AssetCommentThreadStatusesBoolExp>>;
  _not?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
  _or?: InputMaybe<Array<AssetCommentThreadStatusesBoolExp>>;
  asset_comment_thread?: InputMaybe<AssetCommentThreadsBoolExp>;
  asset_comment_thread_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  created_by_review_agent_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetCommentThreadStatusesMaxFields = {
  __typename?: 'asset_comment_thread_statuses_max_fields';
  asset_comment_thread_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesMaxOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetCommentThreadStatusesMinFields = {
  __typename?: 'asset_comment_thread_statuses_min_fields';
  asset_comment_thread_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesMinOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_comment_thread_statuses". */
export type AssetCommentThreadStatusesOrderBy = {
  asset_comment_thread?: InputMaybe<AssetCommentThreadsOrderBy>;
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_comment_thread_statuses" */
export const AssetCommentThreadStatusesSelectColumn = {
  /** column name */
  AssetCommentThreadId: 'asset_comment_thread_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByReviewAgentId: 'created_by_review_agent_id',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentThreadStatusesSelectColumn = typeof AssetCommentThreadStatusesSelectColumn[keyof typeof AssetCommentThreadStatusesSelectColumn];
/** aggregate stddev on columns */
export type AssetCommentThreadStatusesStddevFields = {
  __typename?: 'asset_comment_thread_statuses_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetCommentThreadStatusesStddevPopFields = {
  __typename?: 'asset_comment_thread_statuses_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetCommentThreadStatusesStddevSampFields = {
  __typename?: 'asset_comment_thread_statuses_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentThreadStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentThreadStatusesStreamCursorValueInput = {
  asset_comment_thread_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: InputMaybe<Scalars['uuid']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetCommentThreadStatusesSumFields = {
  __typename?: 'asset_comment_thread_statuses_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetCommentThreadStatusesVarPopFields = {
  __typename?: 'asset_comment_thread_statuses_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetCommentThreadStatusesVarSampFields = {
  __typename?: 'asset_comment_thread_statuses_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetCommentThreadStatusesVarianceFields = {
  __typename?: 'asset_comment_thread_statuses_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_comment_thread_statuses" */
export type AssetCommentThreadStatusesVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreads = {
  __typename?: 'asset_comment_threads';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  amp_canvas_id?: Maybe<Scalars['uuid']>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_project?: Maybe<AmpProjects>;
  amp_project_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  amp_task?: Maybe<AmpTasks>;
  amp_task_id?: Maybe<Scalars['uuid']>;
  anchor?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  batched_in_interaction?: Maybe<LlmChatInteractions>;
  batched_in_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  channel_size?: Maybe<AdExportChannelSizes>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  comments: Array<AssetComments>;
  /** An aggregate relationship */
  comments_aggregate: AssetCommentsAggregate;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_review_agent?: Maybe<ReviewAgents>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  current_status: Scalars['String'];
  id: Scalars['uuid'];
  last_comment_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  reads: Array<AssetCommentThreadReads>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  statuses: Array<AssetCommentThreadStatuses>;
  /** An aggregate relationship */
  statuses_aggregate: AssetCommentThreadStatusesAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsAnchorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsCommentsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsReadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadReadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadReadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadReadsBoolExp>;
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


/** columns and relationships of "asset_comment_threads" */
export type AssetCommentThreadsStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};

/** aggregated selection of "asset_comment_threads" */
export type AssetCommentThreadsAggregate = {
  __typename?: 'asset_comment_threads_aggregate';
  aggregate?: Maybe<AssetCommentThreadsAggregateFields>;
  nodes: Array<AssetCommentThreads>;
};

export type AssetCommentThreadsAggregateBoolExp = {
  count?: InputMaybe<AssetCommentThreadsAggregateBoolExpCount>;
};

export type AssetCommentThreadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetCommentThreadsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_comment_threads" */
export type AssetCommentThreadsAggregateFields = {
  __typename?: 'asset_comment_threads_aggregate_fields';
  avg?: Maybe<AssetCommentThreadsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetCommentThreadsMaxFields>;
  min?: Maybe<AssetCommentThreadsMinFields>;
  stddev?: Maybe<AssetCommentThreadsStddevFields>;
  stddev_pop?: Maybe<AssetCommentThreadsStddevPopFields>;
  stddev_samp?: Maybe<AssetCommentThreadsStddevSampFields>;
  sum?: Maybe<AssetCommentThreadsSumFields>;
  var_pop?: Maybe<AssetCommentThreadsVarPopFields>;
  var_samp?: Maybe<AssetCommentThreadsVarSampFields>;
  variance?: Maybe<AssetCommentThreadsVarianceFields>;
};


/** aggregate fields of "asset_comment_threads" */
export type AssetCommentThreadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_comment_threads" */
export type AssetCommentThreadsAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentThreadsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentThreadsMaxOrderBy>;
  min?: InputMaybe<AssetCommentThreadsMinOrderBy>;
  stddev?: InputMaybe<AssetCommentThreadsStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentThreadsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentThreadsStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentThreadsSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentThreadsVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentThreadsVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentThreadsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetCommentThreadsAvgFields = {
  __typename?: 'asset_comment_threads_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comment_threads". All fields are combined with a logical 'AND'. */
export type AssetCommentThreadsBoolExp = {
  _and?: InputMaybe<Array<AssetCommentThreadsBoolExp>>;
  _not?: InputMaybe<AssetCommentThreadsBoolExp>;
  _or?: InputMaybe<Array<AssetCommentThreadsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  amp_canvas_id?: InputMaybe<UuidComparisonExp>;
  amp_file_id?: InputMaybe<UuidComparisonExp>;
  amp_project?: InputMaybe<AmpProjectsBoolExp>;
  amp_project_id?: InputMaybe<UuidComparisonExp>;
  amp_task?: InputMaybe<AmpTasksBoolExp>;
  amp_task_id?: InputMaybe<UuidComparisonExp>;
  anchor?: InputMaybe<JsonbComparisonExp>;
  batched_in_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  batched_in_interaction_id?: InputMaybe<UuidComparisonExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  channel_size?: InputMaybe<AdExportChannelSizesBoolExp>;
  channel_size_id?: InputMaybe<UuidComparisonExp>;
  comments?: InputMaybe<AssetCommentsBoolExp>;
  comments_aggregate?: InputMaybe<AssetCommentsAggregateBoolExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  created_by_review_agent_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  current_status?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_comment_at?: InputMaybe<TimestamptzComparisonExp>;
  reads?: InputMaybe<AssetCommentThreadReadsBoolExp>;
  settings_entity_id?: InputMaybe<UuidComparisonExp>;
  statuses?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
  statuses_aggregate?: InputMaybe<AssetCommentThreadStatusesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetCommentThreadsMaxFields = {
  __typename?: 'asset_comment_threads_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  amp_canvas_id?: Maybe<Scalars['uuid']>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  amp_project_id?: Maybe<Scalars['uuid']>;
  amp_task_id?: Maybe<Scalars['uuid']>;
  batched_in_interaction_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  current_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_comment_at?: Maybe<Scalars['timestamptz']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  amp_canvas_id?: InputMaybe<OrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_project_id?: InputMaybe<OrderBy>;
  amp_task_id?: InputMaybe<OrderBy>;
  batched_in_interaction_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_comment_at?: InputMaybe<OrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetCommentThreadsMinFields = {
  __typename?: 'asset_comment_threads_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  amp_canvas_id?: Maybe<Scalars['uuid']>;
  amp_file_id?: Maybe<Scalars['uuid']>;
  amp_project_id?: Maybe<Scalars['uuid']>;
  amp_task_id?: Maybe<Scalars['uuid']>;
  batched_in_interaction_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  channel_size_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: Maybe<Scalars['uuid']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  current_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_comment_at?: Maybe<Scalars['timestamptz']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  amp_canvas_id?: InputMaybe<OrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_project_id?: InputMaybe<OrderBy>;
  amp_task_id?: InputMaybe<OrderBy>;
  batched_in_interaction_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_comment_at?: InputMaybe<OrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_comment_threads". */
export type AssetCommentThreadsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  amp_canvas_id?: InputMaybe<OrderBy>;
  amp_file_id?: InputMaybe<OrderBy>;
  amp_project?: InputMaybe<AmpProjectsOrderBy>;
  amp_project_id?: InputMaybe<OrderBy>;
  amp_task?: InputMaybe<AmpTasksOrderBy>;
  amp_task_id?: InputMaybe<OrderBy>;
  anchor?: InputMaybe<OrderBy>;
  batched_in_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  batched_in_interaction_id?: InputMaybe<OrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  channel_size?: InputMaybe<AdExportChannelSizesOrderBy>;
  channel_size_id?: InputMaybe<OrderBy>;
  comments_aggregate?: InputMaybe<AssetCommentsAggregateOrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  created_by_review_agent_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_comment_at?: InputMaybe<OrderBy>;
  reads_aggregate?: InputMaybe<AssetCommentThreadReadsAggregateOrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  statuses_aggregate?: InputMaybe<AssetCommentThreadStatusesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_comment_threads" */
export const AssetCommentThreadsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AmpCanvasId: 'amp_canvas_id',
  /** column name */
  AmpFileId: 'amp_file_id',
  /** column name */
  AmpProjectId: 'amp_project_id',
  /** column name */
  AmpTaskId: 'amp_task_id',
  /** column name */
  Anchor: 'anchor',
  /** column name */
  BatchedInInteractionId: 'batched_in_interaction_id',
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  ChannelSizeId: 'channel_size_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByReviewAgentId: 'created_by_review_agent_id',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  CurrentStatus: 'current_status',
  /** column name */
  Id: 'id',
  /** column name */
  LastCommentAt: 'last_comment_at',
  /** column name */
  SettingsEntityId: 'settings_entity_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentThreadsSelectColumn = typeof AssetCommentThreadsSelectColumn[keyof typeof AssetCommentThreadsSelectColumn];
/** aggregate stddev on columns */
export type AssetCommentThreadsStddevFields = {
  __typename?: 'asset_comment_threads_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetCommentThreadsStddevPopFields = {
  __typename?: 'asset_comment_threads_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetCommentThreadsStddevSampFields = {
  __typename?: 'asset_comment_threads_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comment_threads" */
export type AssetCommentThreadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentThreadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentThreadsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  amp_canvas_id?: InputMaybe<Scalars['uuid']>;
  amp_file_id?: InputMaybe<Scalars['uuid']>;
  amp_project_id?: InputMaybe<Scalars['uuid']>;
  amp_task_id?: InputMaybe<Scalars['uuid']>;
  anchor?: InputMaybe<Scalars['jsonb']>;
  batched_in_interaction_id?: InputMaybe<Scalars['uuid']>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  channel_size_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_review_agent_id?: InputMaybe<Scalars['uuid']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  current_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_comment_at?: InputMaybe<Scalars['timestamptz']>;
  settings_entity_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetCommentThreadsSumFields = {
  __typename?: 'asset_comment_threads_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetCommentThreadsVarPopFields = {
  __typename?: 'asset_comment_threads_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetCommentThreadsVarSampFields = {
  __typename?: 'asset_comment_threads_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetCommentThreadsVarianceFields = {
  __typename?: 'asset_comment_threads_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_comment_threads" */
export type AssetCommentThreadsVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_comments" */
export type AssetComments = {
  __typename?: 'asset_comments';
  /** An object relationship */
  asset_comment_thread?: Maybe<AssetCommentThreads>;
  asset_comment_thread_id: Scalars['uuid'];
  author_llm_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  author_review_agent?: Maybe<ReviewAgents>;
  author_review_agent_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  author_user?: Maybe<Users>;
  author_user_id?: Maybe<Scalars['bigint']>;
  body?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_on_ad_version?: Maybe<AdBriefAssetVersions>;
  created_on_ad_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_on_campaign_version?: Maybe<CampaignArtifactVersions>;
  created_on_campaign_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_on_email_version?: Maybe<ContentEmailVersions>;
  created_on_email_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_on_size_variant?: Maybe<AdBriefAssetSizeVariants>;
  created_on_size_variant_id?: Maybe<Scalars['uuid']>;
  current_status: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_interaction?: Maybe<LlmChatInteractions>;
  llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  mentions: Array<AssetCommentMentions>;
  /** An aggregate relationship */
  mentions_aggregate: AssetCommentMentionsAggregate;
  /** An array relationship */
  statuses: Array<AssetCommentStatuses>;
  /** An aggregate relationship */
  statuses_aggregate: AssetCommentStatusesAggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "asset_comments" */
export type AssetCommentsMentionsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


/** columns and relationships of "asset_comments" */
export type AssetCommentsMentionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


/** columns and relationships of "asset_comments" */
export type AssetCommentsStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


/** columns and relationships of "asset_comments" */
export type AssetCommentsStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};

/** aggregated selection of "asset_comments" */
export type AssetCommentsAggregate = {
  __typename?: 'asset_comments_aggregate';
  aggregate?: Maybe<AssetCommentsAggregateFields>;
  nodes: Array<AssetComments>;
};

export type AssetCommentsAggregateBoolExp = {
  count?: InputMaybe<AssetCommentsAggregateBoolExpCount>;
};

export type AssetCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetCommentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_comments" */
export type AssetCommentsAggregateFields = {
  __typename?: 'asset_comments_aggregate_fields';
  avg?: Maybe<AssetCommentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetCommentsMaxFields>;
  min?: Maybe<AssetCommentsMinFields>;
  stddev?: Maybe<AssetCommentsStddevFields>;
  stddev_pop?: Maybe<AssetCommentsStddevPopFields>;
  stddev_samp?: Maybe<AssetCommentsStddevSampFields>;
  sum?: Maybe<AssetCommentsSumFields>;
  var_pop?: Maybe<AssetCommentsVarPopFields>;
  var_samp?: Maybe<AssetCommentsVarSampFields>;
  variance?: Maybe<AssetCommentsVarianceFields>;
};


/** aggregate fields of "asset_comments" */
export type AssetCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_comments" */
export type AssetCommentsAggregateOrderBy = {
  avg?: InputMaybe<AssetCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetCommentsMaxOrderBy>;
  min?: InputMaybe<AssetCommentsMinOrderBy>;
  stddev?: InputMaybe<AssetCommentsStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetCommentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetCommentsStddevSampOrderBy>;
  sum?: InputMaybe<AssetCommentsSumOrderBy>;
  var_pop?: InputMaybe<AssetCommentsVarPopOrderBy>;
  var_samp?: InputMaybe<AssetCommentsVarSampOrderBy>;
  variance?: InputMaybe<AssetCommentsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetCommentsAvgFields = {
  __typename?: 'asset_comments_avg_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_comments" */
export type AssetCommentsAvgOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_comments". All fields are combined with a logical 'AND'. */
export type AssetCommentsBoolExp = {
  _and?: InputMaybe<Array<AssetCommentsBoolExp>>;
  _not?: InputMaybe<AssetCommentsBoolExp>;
  _or?: InputMaybe<Array<AssetCommentsBoolExp>>;
  asset_comment_thread?: InputMaybe<AssetCommentThreadsBoolExp>;
  asset_comment_thread_id?: InputMaybe<UuidComparisonExp>;
  author_llm_session_id?: InputMaybe<UuidComparisonExp>;
  author_review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  author_review_agent_id?: InputMaybe<UuidComparisonExp>;
  author_user?: InputMaybe<UsersBoolExp>;
  author_user_id?: InputMaybe<BigintComparisonExp>;
  body?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_on_ad_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  created_on_ad_version_id?: InputMaybe<UuidComparisonExp>;
  created_on_campaign_version?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  created_on_campaign_version_id?: InputMaybe<UuidComparisonExp>;
  created_on_email_version?: InputMaybe<ContentEmailVersionsBoolExp>;
  created_on_email_version_id?: InputMaybe<UuidComparisonExp>;
  created_on_size_variant?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  created_on_size_variant_id?: InputMaybe<UuidComparisonExp>;
  current_status?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  mentions?: InputMaybe<AssetCommentMentionsBoolExp>;
  mentions_aggregate?: InputMaybe<AssetCommentMentionsAggregateBoolExp>;
  statuses?: InputMaybe<AssetCommentStatusesBoolExp>;
  statuses_aggregate?: InputMaybe<AssetCommentStatusesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetCommentsMaxFields = {
  __typename?: 'asset_comments_max_fields';
  asset_comment_thread_id?: Maybe<Scalars['uuid']>;
  author_llm_session_id?: Maybe<Scalars['uuid']>;
  author_review_agent_id?: Maybe<Scalars['uuid']>;
  author_user_id?: Maybe<Scalars['bigint']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_on_ad_version_id?: Maybe<Scalars['uuid']>;
  created_on_campaign_version_id?: Maybe<Scalars['uuid']>;
  created_on_email_version_id?: Maybe<Scalars['uuid']>;
  created_on_size_variant_id?: Maybe<Scalars['uuid']>;
  current_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_comments" */
export type AssetCommentsMaxOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  author_llm_session_id?: InputMaybe<OrderBy>;
  author_review_agent_id?: InputMaybe<OrderBy>;
  author_user_id?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_on_ad_version_id?: InputMaybe<OrderBy>;
  created_on_campaign_version_id?: InputMaybe<OrderBy>;
  created_on_email_version_id?: InputMaybe<OrderBy>;
  created_on_size_variant_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_interaction_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetCommentsMinFields = {
  __typename?: 'asset_comments_min_fields';
  asset_comment_thread_id?: Maybe<Scalars['uuid']>;
  author_llm_session_id?: Maybe<Scalars['uuid']>;
  author_review_agent_id?: Maybe<Scalars['uuid']>;
  author_user_id?: Maybe<Scalars['bigint']>;
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_on_ad_version_id?: Maybe<Scalars['uuid']>;
  created_on_campaign_version_id?: Maybe<Scalars['uuid']>;
  created_on_email_version_id?: Maybe<Scalars['uuid']>;
  created_on_size_variant_id?: Maybe<Scalars['uuid']>;
  current_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_comments" */
export type AssetCommentsMinOrderBy = {
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  author_llm_session_id?: InputMaybe<OrderBy>;
  author_review_agent_id?: InputMaybe<OrderBy>;
  author_user_id?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_on_ad_version_id?: InputMaybe<OrderBy>;
  created_on_campaign_version_id?: InputMaybe<OrderBy>;
  created_on_email_version_id?: InputMaybe<OrderBy>;
  created_on_size_variant_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_interaction_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_comments". */
export type AssetCommentsOrderBy = {
  asset_comment_thread?: InputMaybe<AssetCommentThreadsOrderBy>;
  asset_comment_thread_id?: InputMaybe<OrderBy>;
  author_llm_session_id?: InputMaybe<OrderBy>;
  author_review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  author_review_agent_id?: InputMaybe<OrderBy>;
  author_user?: InputMaybe<UsersOrderBy>;
  author_user_id?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_on_ad_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  created_on_ad_version_id?: InputMaybe<OrderBy>;
  created_on_campaign_version?: InputMaybe<CampaignArtifactVersionsOrderBy>;
  created_on_campaign_version_id?: InputMaybe<OrderBy>;
  created_on_email_version?: InputMaybe<ContentEmailVersionsOrderBy>;
  created_on_email_version_id?: InputMaybe<OrderBy>;
  created_on_size_variant?: InputMaybe<AdBriefAssetSizeVariantsOrderBy>;
  created_on_size_variant_id?: InputMaybe<OrderBy>;
  current_status?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  llm_chat_interaction_id?: InputMaybe<OrderBy>;
  mentions_aggregate?: InputMaybe<AssetCommentMentionsAggregateOrderBy>;
  statuses_aggregate?: InputMaybe<AssetCommentStatusesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_comments" */
export const AssetCommentsSelectColumn = {
  /** column name */
  AssetCommentThreadId: 'asset_comment_thread_id',
  /** column name */
  AuthorLlmSessionId: 'author_llm_session_id',
  /** column name */
  AuthorReviewAgentId: 'author_review_agent_id',
  /** column name */
  AuthorUserId: 'author_user_id',
  /** column name */
  Body: 'body',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedOnAdVersionId: 'created_on_ad_version_id',
  /** column name */
  CreatedOnCampaignVersionId: 'created_on_campaign_version_id',
  /** column name */
  CreatedOnEmailVersionId: 'created_on_email_version_id',
  /** column name */
  CreatedOnSizeVariantId: 'created_on_size_variant_id',
  /** column name */
  CurrentStatus: 'current_status',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatInteractionId: 'llm_chat_interaction_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetCommentsSelectColumn = typeof AssetCommentsSelectColumn[keyof typeof AssetCommentsSelectColumn];
/** aggregate stddev on columns */
export type AssetCommentsStddevFields = {
  __typename?: 'asset_comments_stddev_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_comments" */
export type AssetCommentsStddevOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetCommentsStddevPopFields = {
  __typename?: 'asset_comments_stddev_pop_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_comments" */
export type AssetCommentsStddevPopOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetCommentsStddevSampFields = {
  __typename?: 'asset_comments_stddev_samp_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_comments" */
export type AssetCommentsStddevSampOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_comments" */
export type AssetCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetCommentsStreamCursorValueInput = {
  asset_comment_thread_id?: InputMaybe<Scalars['uuid']>;
  author_llm_session_id?: InputMaybe<Scalars['uuid']>;
  author_review_agent_id?: InputMaybe<Scalars['uuid']>;
  author_user_id?: InputMaybe<Scalars['bigint']>;
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_on_ad_version_id?: InputMaybe<Scalars['uuid']>;
  created_on_campaign_version_id?: InputMaybe<Scalars['uuid']>;
  created_on_email_version_id?: InputMaybe<Scalars['uuid']>;
  created_on_size_variant_id?: InputMaybe<Scalars['uuid']>;
  current_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetCommentsSumFields = {
  __typename?: 'asset_comments_sum_fields';
  author_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_comments" */
export type AssetCommentsSumOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetCommentsVarPopFields = {
  __typename?: 'asset_comments_var_pop_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_comments" */
export type AssetCommentsVarPopOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetCommentsVarSampFields = {
  __typename?: 'asset_comments_var_samp_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_comments" */
export type AssetCommentsVarSampOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetCommentsVarianceFields = {
  __typename?: 'asset_comments_variance_fields';
  author_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_comments" */
export type AssetCommentsVarianceOrderBy = {
  author_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "asset_models" */
export type AssetModels = {
  __typename?: 'asset_models';
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  primary_key_column: Scalars['String'];
  primary_label_column: Scalars['String'];
  type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
};

/** Boolean expression to filter rows from the table "asset_models". All fields are combined with a logical 'AND'. */
export type AssetModelsBoolExp = {
  _and?: InputMaybe<Array<AssetModelsBoolExp>>;
  _not?: InputMaybe<AssetModelsBoolExp>;
  _or?: InputMaybe<Array<AssetModelsBoolExp>>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  primary_key_column?: InputMaybe<StringComparisonExp>;
  primary_label_column?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
};

/** unique or primary key constraints on table "asset_models" */
export const AssetModelsConstraint = {
  /** unique or primary key constraint on columns "model_id" */
  AssetModelsPkey: 'asset_models_pkey',
  /** unique or primary key constraint on columns "workspace_id", "model_id" */
  AssetModelsWorkspaceIdModelIdKey: 'asset_models_workspace_id_model_id_key'
} as const;

export type AssetModelsConstraint = typeof AssetModelsConstraint[keyof typeof AssetModelsConstraint];
/** input type for inserting data into table "asset_models" */
export type AssetModelsInsertInput = {
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key_column?: InputMaybe<Scalars['String']>;
  primary_label_column?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "asset_models" */
export type AssetModelsMutationResponse = {
  __typename?: 'asset_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetModels>;
};

/** input type for inserting object relation for remote table "asset_models" */
export type AssetModelsObjRelInsertInput = {
  data: AssetModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetModelsOnConflict>;
};

/** on_conflict condition type for table "asset_models" */
export type AssetModelsOnConflict = {
  constraint: AssetModelsConstraint;
  update_columns?: Array<AssetModelsUpdateColumn>;
  where?: InputMaybe<AssetModelsBoolExp>;
};

/** Ordering options when selecting data from "asset_models". */
export type AssetModelsOrderBy = {
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  primary_key_column?: InputMaybe<OrderBy>;
  primary_label_column?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
};

/** primary key columns input for table: asset_models */
export type AssetModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** select columns of table "asset_models" */
export const AssetModelsSelectColumn = {
  /** column name */
  ModelId: 'model_id',
  /** column name */
  PrimaryKeyColumn: 'primary_key_column',
  /** column name */
  PrimaryLabelColumn: 'primary_label_column',
  /** column name */
  Type: 'type'
} as const;

export type AssetModelsSelectColumn = typeof AssetModelsSelectColumn[keyof typeof AssetModelsSelectColumn];
/** input type for updating data in table "asset_models" */
export type AssetModelsSetInput = {
  primary_key_column?: InputMaybe<Scalars['String']>;
  primary_label_column?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "asset_models" */
export type AssetModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetModelsStreamCursorValueInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key_column?: InputMaybe<Scalars['String']>;
  primary_label_column?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "asset_models" */
export const AssetModelsUpdateColumn = {
  /** column name */
  PrimaryKeyColumn: 'primary_key_column',
  /** column name */
  PrimaryLabelColumn: 'primary_label_column',
  /** column name */
  Type: 'type'
} as const;

export type AssetModelsUpdateColumn = typeof AssetModelsUpdateColumn[keyof typeof AssetModelsUpdateColumn];
export type AssetModelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetModelsSetInput>;
  /** filter the rows which have to be updated */
  where: AssetModelsBoolExp;
};

/** columns and relationships of "asset_statuses" */
export type AssetStatuses = {
  __typename?: 'asset_statuses';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  note?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "asset_statuses" */
export type AssetStatusesAggregate = {
  __typename?: 'asset_statuses_aggregate';
  aggregate?: Maybe<AssetStatusesAggregateFields>;
  nodes: Array<AssetStatuses>;
};

export type AssetStatusesAggregateBoolExp = {
  count?: InputMaybe<AssetStatusesAggregateBoolExpCount>;
};

export type AssetStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetStatusesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "asset_statuses" */
export type AssetStatusesAggregateFields = {
  __typename?: 'asset_statuses_aggregate_fields';
  avg?: Maybe<AssetStatusesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AssetStatusesMaxFields>;
  min?: Maybe<AssetStatusesMinFields>;
  stddev?: Maybe<AssetStatusesStddevFields>;
  stddev_pop?: Maybe<AssetStatusesStddevPopFields>;
  stddev_samp?: Maybe<AssetStatusesStddevSampFields>;
  sum?: Maybe<AssetStatusesSumFields>;
  var_pop?: Maybe<AssetStatusesVarPopFields>;
  var_samp?: Maybe<AssetStatusesVarSampFields>;
  variance?: Maybe<AssetStatusesVarianceFields>;
};


/** aggregate fields of "asset_statuses" */
export type AssetStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_statuses" */
export type AssetStatusesAggregateOrderBy = {
  avg?: InputMaybe<AssetStatusesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssetStatusesMaxOrderBy>;
  min?: InputMaybe<AssetStatusesMinOrderBy>;
  stddev?: InputMaybe<AssetStatusesStddevOrderBy>;
  stddev_pop?: InputMaybe<AssetStatusesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AssetStatusesStddevSampOrderBy>;
  sum?: InputMaybe<AssetStatusesSumOrderBy>;
  var_pop?: InputMaybe<AssetStatusesVarPopOrderBy>;
  var_samp?: InputMaybe<AssetStatusesVarSampOrderBy>;
  variance?: InputMaybe<AssetStatusesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type AssetStatusesAvgFields = {
  __typename?: 'asset_statuses_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_statuses" */
export type AssetStatusesAvgOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "asset_statuses". All fields are combined with a logical 'AND'. */
export type AssetStatusesBoolExp = {
  _and?: InputMaybe<Array<AssetStatusesBoolExp>>;
  _not?: InputMaybe<AssetStatusesBoolExp>;
  _or?: InputMaybe<Array<AssetStatusesBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AssetStatusesMaxFields = {
  __typename?: 'asset_statuses_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_statuses" */
export type AssetStatusesMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssetStatusesMinFields = {
  __typename?: 'asset_statuses_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_statuses" */
export type AssetStatusesMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "asset_statuses". */
export type AssetStatusesOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "asset_statuses" */
export const AssetStatusesSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  Id: 'id',
  /** column name */
  Note: 'note',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AssetStatusesSelectColumn = typeof AssetStatusesSelectColumn[keyof typeof AssetStatusesSelectColumn];
/** aggregate stddev on columns */
export type AssetStatusesStddevFields = {
  __typename?: 'asset_statuses_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_statuses" */
export type AssetStatusesStddevOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AssetStatusesStddevPopFields = {
  __typename?: 'asset_statuses_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_statuses" */
export type AssetStatusesStddevPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AssetStatusesStddevSampFields = {
  __typename?: 'asset_statuses_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_statuses" */
export type AssetStatusesStddevSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "asset_statuses" */
export type AssetStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AssetStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetStatusesStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetStatusesSumFields = {
  __typename?: 'asset_statuses_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_statuses" */
export type AssetStatusesSumOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AssetStatusesVarPopFields = {
  __typename?: 'asset_statuses_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_statuses" */
export type AssetStatusesVarPopOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AssetStatusesVarSampFields = {
  __typename?: 'asset_statuses_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_statuses" */
export type AssetStatusesVarSampOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AssetStatusesVarianceFields = {
  __typename?: 'asset_statuses_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_statuses" */
export type AssetStatusesVarianceOrderBy = {
  created_by_user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "attribution_methods" */
export type AttributionMethods = {
  __typename?: 'attribution_methods';
  /** An array relationship */
  attribution_methods_interactions: Array<AttributionMethodsInteractions>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Users>;
  created_by_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "attribution_methods" */
export type AttributionMethodsAttributionMethodsInteractionsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsInteractionsOrderBy>>;
  where?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
};

/** aggregated selection of "attribution_methods" */
export type AttributionMethodsAggregate = {
  __typename?: 'attribution_methods_aggregate';
  aggregate?: Maybe<AttributionMethodsAggregateFields>;
  nodes: Array<AttributionMethods>;
};

export type AttributionMethodsAggregateBoolExp = {
  count?: InputMaybe<AttributionMethodsAggregateBoolExpCount>;
};

export type AttributionMethodsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AttributionMethodsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "attribution_methods" */
export type AttributionMethodsAggregateFields = {
  __typename?: 'attribution_methods_aggregate_fields';
  avg?: Maybe<AttributionMethodsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AttributionMethodsMaxFields>;
  min?: Maybe<AttributionMethodsMinFields>;
  stddev?: Maybe<AttributionMethodsStddevFields>;
  stddev_pop?: Maybe<AttributionMethodsStddevPopFields>;
  stddev_samp?: Maybe<AttributionMethodsStddevSampFields>;
  sum?: Maybe<AttributionMethodsSumFields>;
  var_pop?: Maybe<AttributionMethodsVarPopFields>;
  var_samp?: Maybe<AttributionMethodsVarSampFields>;
  variance?: Maybe<AttributionMethodsVarianceFields>;
};


/** aggregate fields of "attribution_methods" */
export type AttributionMethodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "attribution_methods" */
export type AttributionMethodsAggregateOrderBy = {
  avg?: InputMaybe<AttributionMethodsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AttributionMethodsMaxOrderBy>;
  min?: InputMaybe<AttributionMethodsMinOrderBy>;
  stddev?: InputMaybe<AttributionMethodsStddevOrderBy>;
  stddev_pop?: InputMaybe<AttributionMethodsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AttributionMethodsStddevSampOrderBy>;
  sum?: InputMaybe<AttributionMethodsSumOrderBy>;
  var_pop?: InputMaybe<AttributionMethodsVarPopOrderBy>;
  var_samp?: InputMaybe<AttributionMethodsVarSampOrderBy>;
  variance?: InputMaybe<AttributionMethodsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "attribution_methods" */
export type AttributionMethodsArrRelInsertInput = {
  data: Array<AttributionMethodsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributionMethodsOnConflict>;
};

/** aggregate avg on columns */
export type AttributionMethodsAvgFields = {
  __typename?: 'attribution_methods_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "attribution_methods" */
export type AttributionMethodsAvgOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "attribution_methods". All fields are combined with a logical 'AND'. */
export type AttributionMethodsBoolExp = {
  _and?: InputMaybe<Array<AttributionMethodsBoolExp>>;
  _not?: InputMaybe<AttributionMethodsBoolExp>;
  _or?: InputMaybe<Array<AttributionMethodsBoolExp>>;
  attribution_methods_interactions?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<UsersBoolExp>;
  created_by_id?: InputMaybe<BigintComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<UsersBoolExp>;
  updated_by_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "attribution_methods" */
export const AttributionMethodsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AttributionMethodsIdWorkspaceIdIdx: 'attribution_methods_id_workspace_id_idx',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AttributionMethodsIdWorkspaceIdKey: 'attribution_methods_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AttributionMethodsPkey: 'attribution_methods_pkey'
} as const;

export type AttributionMethodsConstraint = typeof AttributionMethodsConstraint[keyof typeof AttributionMethodsConstraint];
/** input type for inserting data into table "attribution_methods" */
export type AttributionMethodsInsertInput = {
  attribution_methods_interactions?: InputMaybe<AttributionMethodsInteractionsArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractions = {
  __typename?: 'attribution_methods_interactions';
  attribution_method_id: Scalars['uuid'];
  /** An array relationship */
  attribution_methods: Array<AttributionMethods>;
  /** An aggregate relationship */
  attribution_methods_aggregate: AttributionMethodsAggregate;
  conditions?: Maybe<Scalars['jsonb']>;
  interaction_model_id: Scalars['bigint'];
  /** An array relationship */
  interactions: Array<InteractionModels>;
  lookback_window?: Maybe<Scalars['jsonb']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractionsAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractionsAttributionMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractionsConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractionsInteractionsArgs = {
  distinct_on?: InputMaybe<Array<InteractionModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InteractionModelsOrderBy>>;
  where?: InputMaybe<InteractionModelsBoolExp>;
};


/** columns and relationships of "attribution_methods_interactions" */
export type AttributionMethodsInteractionsLookbackWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsAggregateOrderBy = {
  avg?: InputMaybe<AttributionMethodsInteractionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AttributionMethodsInteractionsMaxOrderBy>;
  min?: InputMaybe<AttributionMethodsInteractionsMinOrderBy>;
  stddev?: InputMaybe<AttributionMethodsInteractionsStddevOrderBy>;
  stddev_pop?: InputMaybe<AttributionMethodsInteractionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AttributionMethodsInteractionsStddevSampOrderBy>;
  sum?: InputMaybe<AttributionMethodsInteractionsSumOrderBy>;
  var_pop?: InputMaybe<AttributionMethodsInteractionsVarPopOrderBy>;
  var_samp?: InputMaybe<AttributionMethodsInteractionsVarSampOrderBy>;
  variance?: InputMaybe<AttributionMethodsInteractionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AttributionMethodsInteractionsAppendInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsArrRelInsertInput = {
  data: Array<AttributionMethodsInteractionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributionMethodsInteractionsOnConflict>;
};

/** order by avg() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsAvgOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "attribution_methods_interactions". All fields are combined with a logical 'AND'. */
export type AttributionMethodsInteractionsBoolExp = {
  _and?: InputMaybe<Array<AttributionMethodsInteractionsBoolExp>>;
  _not?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
  _or?: InputMaybe<Array<AttributionMethodsInteractionsBoolExp>>;
  attribution_method_id?: InputMaybe<UuidComparisonExp>;
  attribution_methods?: InputMaybe<AttributionMethodsBoolExp>;
  attribution_methods_aggregate?: InputMaybe<AttributionMethodsAggregateBoolExp>;
  conditions?: InputMaybe<JsonbComparisonExp>;
  interaction_model_id?: InputMaybe<BigintComparisonExp>;
  interactions?: InputMaybe<InteractionModelsBoolExp>;
  lookback_window?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "attribution_methods_interactions" */
export const AttributionMethodsInteractionsConstraint = {
  /** unique or primary key constraint on columns "attribution_method_id", "interaction_model_id" */
  AttributionMethodsInteractionsPkey: 'attribution_methods_interactions_pkey'
} as const;

export type AttributionMethodsInteractionsConstraint = typeof AttributionMethodsInteractionsConstraint[keyof typeof AttributionMethodsInteractionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AttributionMethodsInteractionsDeleteAtPathInput = {
  conditions?: InputMaybe<Array<Scalars['String']>>;
  lookback_window?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AttributionMethodsInteractionsDeleteElemInput = {
  conditions?: InputMaybe<Scalars['Int']>;
  lookback_window?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AttributionMethodsInteractionsDeleteKeyInput = {
  conditions?: InputMaybe<Scalars['String']>;
  lookback_window?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsIncInput = {
  interaction_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsInsertInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  attribution_methods?: InputMaybe<AttributionMethodsArrRelInsertInput>;
  conditions?: InputMaybe<Scalars['jsonb']>;
  interaction_model_id?: InputMaybe<Scalars['bigint']>;
  interactions?: InputMaybe<InteractionModelsArrRelInsertInput>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsMaxOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsMinOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsMutationResponse = {
  __typename?: 'attribution_methods_interactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributionMethodsInteractions>;
};

/** on_conflict condition type for table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsOnConflict = {
  constraint: AttributionMethodsInteractionsConstraint;
  update_columns?: Array<AttributionMethodsInteractionsUpdateColumn>;
  where?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
};

/** Ordering options when selecting data from "attribution_methods_interactions". */
export type AttributionMethodsInteractionsOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  attribution_methods_aggregate?: InputMaybe<AttributionMethodsAggregateOrderBy>;
  conditions?: InputMaybe<OrderBy>;
  interaction_model_id?: InputMaybe<OrderBy>;
  interactions_aggregate?: InputMaybe<InteractionModelsAggregateOrderBy>;
  lookback_window?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: attribution_methods_interactions */
export type AttributionMethodsInteractionsPkColumnsInput = {
  attribution_method_id: Scalars['uuid'];
  interaction_model_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AttributionMethodsInteractionsPrependInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "attribution_methods_interactions" */
export const AttributionMethodsInteractionsSelectColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  Conditions: 'conditions',
  /** column name */
  InteractionModelId: 'interaction_model_id',
  /** column name */
  LookbackWindow: 'lookback_window',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AttributionMethodsInteractionsSelectColumn = typeof AttributionMethodsInteractionsSelectColumn[keyof typeof AttributionMethodsInteractionsSelectColumn];
/** input type for updating data in table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsSetInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  conditions?: InputMaybe<Scalars['jsonb']>;
  interaction_model_id?: InputMaybe<Scalars['bigint']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsStddevOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsStddevPopOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsStddevSampOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AttributionMethodsInteractionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributionMethodsInteractionsStreamCursorValueInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  conditions?: InputMaybe<Scalars['jsonb']>;
  interaction_model_id?: InputMaybe<Scalars['bigint']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsSumOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "attribution_methods_interactions" */
export const AttributionMethodsInteractionsUpdateColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  Conditions: 'conditions',
  /** column name */
  InteractionModelId: 'interaction_model_id',
  /** column name */
  LookbackWindow: 'lookback_window'
} as const;

export type AttributionMethodsInteractionsUpdateColumn = typeof AttributionMethodsInteractionsUpdateColumn[keyof typeof AttributionMethodsInteractionsUpdateColumn];
export type AttributionMethodsInteractionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AttributionMethodsInteractionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AttributionMethodsInteractionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AttributionMethodsInteractionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AttributionMethodsInteractionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AttributionMethodsInteractionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AttributionMethodsInteractionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributionMethodsInteractionsSetInput>;
  /** filter the rows which have to be updated */
  where: AttributionMethodsInteractionsBoolExp;
};

/** order by var_pop() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsVarPopOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsVarSampOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "attribution_methods_interactions" */
export type AttributionMethodsInteractionsVarianceOrderBy = {
  interaction_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type AttributionMethodsMaxFields = {
  __typename?: 'attribution_methods_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "attribution_methods" */
export type AttributionMethodsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AttributionMethodsMinFields = {
  __typename?: 'attribution_methods_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "attribution_methods" */
export type AttributionMethodsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "attribution_methods" */
export type AttributionMethodsMutationResponse = {
  __typename?: 'attribution_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributionMethods>;
};

/** input type for inserting object relation for remote table "attribution_methods" */
export type AttributionMethodsObjRelInsertInput = {
  data: AttributionMethodsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributionMethodsOnConflict>;
};

/** on_conflict condition type for table "attribution_methods" */
export type AttributionMethodsOnConflict = {
  constraint: AttributionMethodsConstraint;
  update_columns?: Array<AttributionMethodsUpdateColumn>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};

/** Ordering options when selecting data from "attribution_methods". */
export type AttributionMethodsOrderBy = {
  attribution_methods_interactions_aggregate?: InputMaybe<AttributionMethodsInteractionsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<UsersOrderBy>;
  created_by_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<UsersOrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: attribution_methods */
export type AttributionMethodsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "attribution_methods" */
export const AttributionMethodsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedById: 'created_by_id',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedById: 'updated_by_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AttributionMethodsSelectColumn = typeof AttributionMethodsSelectColumn[keyof typeof AttributionMethodsSelectColumn];
/** input type for updating data in table "attribution_methods" */
export type AttributionMethodsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AttributionMethodsStddevFields = {
  __typename?: 'attribution_methods_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "attribution_methods" */
export type AttributionMethodsStddevOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AttributionMethodsStddevPopFields = {
  __typename?: 'attribution_methods_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "attribution_methods" */
export type AttributionMethodsStddevPopOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AttributionMethodsStddevSampFields = {
  __typename?: 'attribution_methods_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "attribution_methods" */
export type AttributionMethodsStddevSampOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "attribution_methods" */
export type AttributionMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AttributionMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributionMethodsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AttributionMethodsSumFields = {
  __typename?: 'attribution_methods_sum_fields';
  created_by_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "attribution_methods" */
export type AttributionMethodsSumOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "attribution_methods" */
export const AttributionMethodsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  Type: 'type'
} as const;

export type AttributionMethodsUpdateColumn = typeof AttributionMethodsUpdateColumn[keyof typeof AttributionMethodsUpdateColumn];
export type AttributionMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributionMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: AttributionMethodsBoolExp;
};

/** aggregate var_pop on columns */
export type AttributionMethodsVarPopFields = {
  __typename?: 'attribution_methods_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "attribution_methods" */
export type AttributionMethodsVarPopOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AttributionMethodsVarSampFields = {
  __typename?: 'attribution_methods_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "attribution_methods" */
export type AttributionMethodsVarSampOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AttributionMethodsVarianceFields = {
  __typename?: 'attribution_methods_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "attribution_methods" */
export type AttributionMethodsVarianceOrderBy = {
  created_by_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_goals" */
export type AudienceGoals = {
  __typename?: 'audience_goals';
  enabled: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  /** An object relationship */
  goal: Goals;
  goal_id: Scalars['uuid'];
  /** An array relationship */
  goal_metrics: Array<GoalMetrics>;
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "audience_goals" */
export type AudienceGoalsGoalMetricsArgs = {
  distinct_on?: InputMaybe<Array<GoalMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalMetricsOrderBy>>;
  where?: InputMaybe<GoalMetricsBoolExp>;
};

/** aggregated selection of "audience_goals" */
export type AudienceGoalsAggregate = {
  __typename?: 'audience_goals_aggregate';
  aggregate?: Maybe<AudienceGoalsAggregateFields>;
  nodes: Array<AudienceGoals>;
};

export type AudienceGoalsAggregateBoolExp = {
  bool_and?: InputMaybe<AudienceGoalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AudienceGoalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AudienceGoalsAggregateBoolExpCount>;
};

export type AudienceGoalsAggregateBoolExpBoolAnd = {
  arguments: AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceGoalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AudienceGoalsAggregateBoolExpBoolOr = {
  arguments: AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceGoalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AudienceGoalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceGoalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_goals" */
export type AudienceGoalsAggregateFields = {
  __typename?: 'audience_goals_aggregate_fields';
  avg?: Maybe<AudienceGoalsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceGoalsMaxFields>;
  min?: Maybe<AudienceGoalsMinFields>;
  stddev?: Maybe<AudienceGoalsStddevFields>;
  stddev_pop?: Maybe<AudienceGoalsStddevPopFields>;
  stddev_samp?: Maybe<AudienceGoalsStddevSampFields>;
  sum?: Maybe<AudienceGoalsSumFields>;
  var_pop?: Maybe<AudienceGoalsVarPopFields>;
  var_samp?: Maybe<AudienceGoalsVarSampFields>;
  variance?: Maybe<AudienceGoalsVarianceFields>;
};


/** aggregate fields of "audience_goals" */
export type AudienceGoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_goals" */
export type AudienceGoalsAggregateOrderBy = {
  avg?: InputMaybe<AudienceGoalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceGoalsMaxOrderBy>;
  min?: InputMaybe<AudienceGoalsMinOrderBy>;
  stddev?: InputMaybe<AudienceGoalsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceGoalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceGoalsStddevSampOrderBy>;
  sum?: InputMaybe<AudienceGoalsSumOrderBy>;
  var_pop?: InputMaybe<AudienceGoalsVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceGoalsVarSampOrderBy>;
  variance?: InputMaybe<AudienceGoalsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "audience_goals" */
export type AudienceGoalsArrRelInsertInput = {
  data: Array<AudienceGoalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceGoalsOnConflict>;
};

/** aggregate avg on columns */
export type AudienceGoalsAvgFields = {
  __typename?: 'audience_goals_avg_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_goals" */
export type AudienceGoalsAvgOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_goals". All fields are combined with a logical 'AND'. */
export type AudienceGoalsBoolExp = {
  _and?: InputMaybe<Array<AudienceGoalsBoolExp>>;
  _not?: InputMaybe<AudienceGoalsBoolExp>;
  _or?: InputMaybe<Array<AudienceGoalsBoolExp>>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
  goal_metrics?: InputMaybe<GoalMetricsBoolExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "audience_goals" */
export const AudienceGoalsConstraint = {
  /** unique or primary key constraint on columns "segment_id", "goal_id" */
  AudienceGoalsPkey: 'audience_goals_pkey'
} as const;

export type AudienceGoalsConstraint = typeof AudienceGoalsConstraint[keyof typeof AudienceGoalsConstraint];
/** input type for incrementing numeric columns in table "audience_goals" */
export type AudienceGoalsIncInput = {
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "audience_goals" */
export type AudienceGoalsInsertInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  goal?: InputMaybe<GoalsObjRelInsertInput>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AudienceGoalsMaxFields = {
  __typename?: 'audience_goals_max_fields';
  error?: Maybe<Scalars['String']>;
  goal_id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audience_goals" */
export type AudienceGoalsMaxOrderBy = {
  error?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceGoalsMinFields = {
  __typename?: 'audience_goals_min_fields';
  error?: Maybe<Scalars['String']>;
  goal_id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audience_goals" */
export type AudienceGoalsMinOrderBy = {
  error?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_goals" */
export type AudienceGoalsMutationResponse = {
  __typename?: 'audience_goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceGoals>;
};

/** on_conflict condition type for table "audience_goals" */
export type AudienceGoalsOnConflict = {
  constraint: AudienceGoalsConstraint;
  update_columns?: Array<AudienceGoalsUpdateColumn>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};

/** Ordering options when selecting data from "audience_goals". */
export type AudienceGoalsOrderBy = {
  enabled?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  goal?: InputMaybe<GoalsOrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  goal_metrics_aggregate?: InputMaybe<GoalMetricsAggregateOrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_goals */
export type AudienceGoalsPkColumnsInput = {
  goal_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};

/** select columns of table "audience_goals" */
export const AudienceGoalsSelectColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Error: 'error',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceGoalsSelectColumn = typeof AudienceGoalsSelectColumn[keyof typeof AudienceGoalsSelectColumn];
/** select "audience_goals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "audience_goals" */
export const AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolAndArgumentsColumns = typeof AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolAndArgumentsColumns];
/** select "audience_goals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "audience_goals" */
export const AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolOrArgumentsColumns = typeof AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AudienceGoalsSelectColumnAudienceGoalsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "audience_goals" */
export type AudienceGoalsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AudienceGoalsStddevFields = {
  __typename?: 'audience_goals_stddev_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_goals" */
export type AudienceGoalsStddevOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceGoalsStddevPopFields = {
  __typename?: 'audience_goals_stddev_pop_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_goals" */
export type AudienceGoalsStddevPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceGoalsStddevSampFields = {
  __typename?: 'audience_goals_stddev_samp_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_goals" */
export type AudienceGoalsStddevSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_goals" */
export type AudienceGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceGoalsStreamCursorValueInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceGoalsSumFields = {
  __typename?: 'audience_goals_sum_fields';
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_goals" */
export type AudienceGoalsSumOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "audience_goals" */
export const AudienceGoalsUpdateColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type AudienceGoalsUpdateColumn = typeof AudienceGoalsUpdateColumn[keyof typeof AudienceGoalsUpdateColumn];
export type AudienceGoalsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AudienceGoalsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceGoalsBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceGoalsVarPopFields = {
  __typename?: 'audience_goals_var_pop_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_goals" */
export type AudienceGoalsVarPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceGoalsVarSampFields = {
  __typename?: 'audience_goals_var_samp_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_goals" */
export type AudienceGoalsVarSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceGoalsVarianceFields = {
  __typename?: 'audience_goals_variance_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_goals" */
export type AudienceGoalsVarianceOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_overviews" */
export type AudienceOverviews = {
  __typename?: 'audience_overviews';
  /** An object relationship */
  analytics_report?: Maybe<AnalyticsReports>;
  /** An object relationship */
  audience: Segments;
  audience_id: Scalars['bigint'];
  /** An object relationship */
  dashboard?: Maybe<Dashboards>;
  dashboard_id?: Maybe<Scalars['uuid']>;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "audience_overviews" */
export type AudienceOverviewsAggregate = {
  __typename?: 'audience_overviews_aggregate';
  aggregate?: Maybe<AudienceOverviewsAggregateFields>;
  nodes: Array<AudienceOverviews>;
};

export type AudienceOverviewsAggregateBoolExp = {
  count?: InputMaybe<AudienceOverviewsAggregateBoolExpCount>;
};

export type AudienceOverviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceOverviewsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_overviews" */
export type AudienceOverviewsAggregateFields = {
  __typename?: 'audience_overviews_aggregate_fields';
  avg?: Maybe<AudienceOverviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceOverviewsMaxFields>;
  min?: Maybe<AudienceOverviewsMinFields>;
  stddev?: Maybe<AudienceOverviewsStddevFields>;
  stddev_pop?: Maybe<AudienceOverviewsStddevPopFields>;
  stddev_samp?: Maybe<AudienceOverviewsStddevSampFields>;
  sum?: Maybe<AudienceOverviewsSumFields>;
  var_pop?: Maybe<AudienceOverviewsVarPopFields>;
  var_samp?: Maybe<AudienceOverviewsVarSampFields>;
  variance?: Maybe<AudienceOverviewsVarianceFields>;
};


/** aggregate fields of "audience_overviews" */
export type AudienceOverviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_overviews" */
export type AudienceOverviewsAggregateOrderBy = {
  avg?: InputMaybe<AudienceOverviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceOverviewsMaxOrderBy>;
  min?: InputMaybe<AudienceOverviewsMinOrderBy>;
  stddev?: InputMaybe<AudienceOverviewsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceOverviewsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceOverviewsStddevSampOrderBy>;
  sum?: InputMaybe<AudienceOverviewsSumOrderBy>;
  var_pop?: InputMaybe<AudienceOverviewsVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceOverviewsVarSampOrderBy>;
  variance?: InputMaybe<AudienceOverviewsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "audience_overviews" */
export type AudienceOverviewsArrRelInsertInput = {
  data: Array<AudienceOverviewsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceOverviewsOnConflict>;
};

/** aggregate avg on columns */
export type AudienceOverviewsAvgFields = {
  __typename?: 'audience_overviews_avg_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_overviews" */
export type AudienceOverviewsAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_overviews". All fields are combined with a logical 'AND'. */
export type AudienceOverviewsBoolExp = {
  _and?: InputMaybe<Array<AudienceOverviewsBoolExp>>;
  _not?: InputMaybe<AudienceOverviewsBoolExp>;
  _or?: InputMaybe<Array<AudienceOverviewsBoolExp>>;
  analytics_report?: InputMaybe<AnalyticsReportsBoolExp>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  dashboard?: InputMaybe<DashboardsBoolExp>;
  dashboard_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "audience_overviews" */
export const AudienceOverviewsConstraint = {
  /** unique or primary key constraint on columns "audience_id" */
  AudienceOverviewsPkey: 'audience_overviews_pkey'
} as const;

export type AudienceOverviewsConstraint = typeof AudienceOverviewsConstraint[keyof typeof AudienceOverviewsConstraint];
/** input type for inserting data into table "audience_overviews" */
export type AudienceOverviewsInsertInput = {
  analytics_report?: InputMaybe<AnalyticsReportsObjRelInsertInput>;
  audience?: InputMaybe<SegmentsObjRelInsertInput>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  dashboard?: InputMaybe<DashboardsObjRelInsertInput>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AudienceOverviewsMaxFields = {
  __typename?: 'audience_overviews_max_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  dashboard_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audience_overviews" */
export type AudienceOverviewsMaxOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceOverviewsMinFields = {
  __typename?: 'audience_overviews_min_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  dashboard_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audience_overviews" */
export type AudienceOverviewsMinOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_overviews" */
export type AudienceOverviewsMutationResponse = {
  __typename?: 'audience_overviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceOverviews>;
};

/** input type for inserting object relation for remote table "audience_overviews" */
export type AudienceOverviewsObjRelInsertInput = {
  data: AudienceOverviewsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceOverviewsOnConflict>;
};

/** on_conflict condition type for table "audience_overviews" */
export type AudienceOverviewsOnConflict = {
  constraint: AudienceOverviewsConstraint;
  update_columns?: Array<AudienceOverviewsUpdateColumn>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};

/** Ordering options when selecting data from "audience_overviews". */
export type AudienceOverviewsOrderBy = {
  analytics_report?: InputMaybe<AnalyticsReportsOrderBy>;
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  dashboard?: InputMaybe<DashboardsOrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_overviews */
export type AudienceOverviewsPkColumnsInput = {
  audience_id: Scalars['bigint'];
};

/** select columns of table "audience_overviews" */
export const AudienceOverviewsSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  DashboardId: 'dashboard_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceOverviewsSelectColumn = typeof AudienceOverviewsSelectColumn[keyof typeof AudienceOverviewsSelectColumn];
/** input type for updating data in table "audience_overviews" */
export type AudienceOverviewsSetInput = {
  dashboard_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AudienceOverviewsStddevFields = {
  __typename?: 'audience_overviews_stddev_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_overviews" */
export type AudienceOverviewsStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceOverviewsStddevPopFields = {
  __typename?: 'audience_overviews_stddev_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_overviews" */
export type AudienceOverviewsStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceOverviewsStddevSampFields = {
  __typename?: 'audience_overviews_stddev_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_overviews" */
export type AudienceOverviewsStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_overviews" */
export type AudienceOverviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceOverviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceOverviewsStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceOverviewsSumFields = {
  __typename?: 'audience_overviews_sum_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_overviews" */
export type AudienceOverviewsSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "audience_overviews" */
export const AudienceOverviewsUpdateColumn = {
  /** column name */
  DashboardId: 'dashboard_id'
} as const;

export type AudienceOverviewsUpdateColumn = typeof AudienceOverviewsUpdateColumn[keyof typeof AudienceOverviewsUpdateColumn];
export type AudienceOverviewsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceOverviewsSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceOverviewsBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceOverviewsVarPopFields = {
  __typename?: 'audience_overviews_var_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_overviews" */
export type AudienceOverviewsVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceOverviewsVarSampFields = {
  __typename?: 'audience_overviews_var_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_overviews" */
export type AudienceOverviewsVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceOverviewsVarianceFields = {
  __typename?: 'audience_overviews_variance_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_overviews" */
export type AudienceOverviewsVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_primary_metrics" */
export type AudiencePrimaryMetrics = {
  __typename?: 'audience_primary_metrics';
  /** An object relationship */
  audience: Segments;
  audience_id: Scalars['bigint'];
  /** An object relationship */
  metric: Goals;
  metric_id: Scalars['uuid'];
};

/** aggregated selection of "audience_primary_metrics" */
export type AudiencePrimaryMetricsAggregate = {
  __typename?: 'audience_primary_metrics_aggregate';
  aggregate?: Maybe<AudiencePrimaryMetricsAggregateFields>;
  nodes: Array<AudiencePrimaryMetrics>;
};

export type AudiencePrimaryMetricsAggregateBoolExp = {
  count?: InputMaybe<AudiencePrimaryMetricsAggregateBoolExpCount>;
};

export type AudiencePrimaryMetricsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_primary_metrics" */
export type AudiencePrimaryMetricsAggregateFields = {
  __typename?: 'audience_primary_metrics_aggregate_fields';
  avg?: Maybe<AudiencePrimaryMetricsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudiencePrimaryMetricsMaxFields>;
  min?: Maybe<AudiencePrimaryMetricsMinFields>;
  stddev?: Maybe<AudiencePrimaryMetricsStddevFields>;
  stddev_pop?: Maybe<AudiencePrimaryMetricsStddevPopFields>;
  stddev_samp?: Maybe<AudiencePrimaryMetricsStddevSampFields>;
  sum?: Maybe<AudiencePrimaryMetricsSumFields>;
  var_pop?: Maybe<AudiencePrimaryMetricsVarPopFields>;
  var_samp?: Maybe<AudiencePrimaryMetricsVarSampFields>;
  variance?: Maybe<AudiencePrimaryMetricsVarianceFields>;
};


/** aggregate fields of "audience_primary_metrics" */
export type AudiencePrimaryMetricsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsAggregateOrderBy = {
  avg?: InputMaybe<AudiencePrimaryMetricsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudiencePrimaryMetricsMaxOrderBy>;
  min?: InputMaybe<AudiencePrimaryMetricsMinOrderBy>;
  stddev?: InputMaybe<AudiencePrimaryMetricsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudiencePrimaryMetricsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudiencePrimaryMetricsStddevSampOrderBy>;
  sum?: InputMaybe<AudiencePrimaryMetricsSumOrderBy>;
  var_pop?: InputMaybe<AudiencePrimaryMetricsVarPopOrderBy>;
  var_samp?: InputMaybe<AudiencePrimaryMetricsVarSampOrderBy>;
  variance?: InputMaybe<AudiencePrimaryMetricsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "audience_primary_metrics" */
export type AudiencePrimaryMetricsArrRelInsertInput = {
  data: Array<AudiencePrimaryMetricsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudiencePrimaryMetricsOnConflict>;
};

/** aggregate avg on columns */
export type AudiencePrimaryMetricsAvgFields = {
  __typename?: 'audience_primary_metrics_avg_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_primary_metrics". All fields are combined with a logical 'AND'. */
export type AudiencePrimaryMetricsBoolExp = {
  _and?: InputMaybe<Array<AudiencePrimaryMetricsBoolExp>>;
  _not?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
  _or?: InputMaybe<Array<AudiencePrimaryMetricsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  metric?: InputMaybe<GoalsBoolExp>;
  metric_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "audience_primary_metrics" */
export const AudiencePrimaryMetricsConstraint = {
  /** unique or primary key constraint on columns "metric_id", "audience_id" */
  AudiencePrimaryMetricsPkey: 'audience_primary_metrics_pkey'
} as const;

export type AudiencePrimaryMetricsConstraint = typeof AudiencePrimaryMetricsConstraint[keyof typeof AudiencePrimaryMetricsConstraint];
/** input type for incrementing numeric columns in table "audience_primary_metrics" */
export type AudiencePrimaryMetricsIncInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "audience_primary_metrics" */
export type AudiencePrimaryMetricsInsertInput = {
  audience?: InputMaybe<SegmentsObjRelInsertInput>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  metric?: InputMaybe<GoalsObjRelInsertInput>;
  metric_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AudiencePrimaryMetricsMaxFields = {
  __typename?: 'audience_primary_metrics_max_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  metric_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsMaxOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  metric_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudiencePrimaryMetricsMinFields = {
  __typename?: 'audience_primary_metrics_min_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  metric_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsMinOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  metric_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_primary_metrics" */
export type AudiencePrimaryMetricsMutationResponse = {
  __typename?: 'audience_primary_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudiencePrimaryMetrics>;
};

/** on_conflict condition type for table "audience_primary_metrics" */
export type AudiencePrimaryMetricsOnConflict = {
  constraint: AudiencePrimaryMetricsConstraint;
  update_columns?: Array<AudiencePrimaryMetricsUpdateColumn>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};

/** Ordering options when selecting data from "audience_primary_metrics". */
export type AudiencePrimaryMetricsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  metric?: InputMaybe<GoalsOrderBy>;
  metric_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_primary_metrics */
export type AudiencePrimaryMetricsPkColumnsInput = {
  audience_id: Scalars['bigint'];
  metric_id: Scalars['uuid'];
};

/** select columns of table "audience_primary_metrics" */
export const AudiencePrimaryMetricsSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  MetricId: 'metric_id'
} as const;

export type AudiencePrimaryMetricsSelectColumn = typeof AudiencePrimaryMetricsSelectColumn[keyof typeof AudiencePrimaryMetricsSelectColumn];
/** input type for updating data in table "audience_primary_metrics" */
export type AudiencePrimaryMetricsSetInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  metric_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AudiencePrimaryMetricsStddevFields = {
  __typename?: 'audience_primary_metrics_stddev_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudiencePrimaryMetricsStddevPopFields = {
  __typename?: 'audience_primary_metrics_stddev_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudiencePrimaryMetricsStddevSampFields = {
  __typename?: 'audience_primary_metrics_stddev_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_primary_metrics" */
export type AudiencePrimaryMetricsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudiencePrimaryMetricsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudiencePrimaryMetricsStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  metric_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AudiencePrimaryMetricsSumFields = {
  __typename?: 'audience_primary_metrics_sum_fields';
  audience_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** update columns of table "audience_primary_metrics" */
export const AudiencePrimaryMetricsUpdateColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  MetricId: 'metric_id'
} as const;

export type AudiencePrimaryMetricsUpdateColumn = typeof AudiencePrimaryMetricsUpdateColumn[keyof typeof AudiencePrimaryMetricsUpdateColumn];
export type AudiencePrimaryMetricsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AudiencePrimaryMetricsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudiencePrimaryMetricsSetInput>;
  /** filter the rows which have to be updated */
  where: AudiencePrimaryMetricsBoolExp;
};

/** aggregate var_pop on columns */
export type AudiencePrimaryMetricsVarPopFields = {
  __typename?: 'audience_primary_metrics_var_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudiencePrimaryMetricsVarSampFields = {
  __typename?: 'audience_primary_metrics_var_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudiencePrimaryMetricsVarianceFields = {
  __typename?: 'audience_primary_metrics_variance_fields';
  audience_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_primary_metrics" */
export type AudiencePrimaryMetricsVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_splits" */
export type AudienceSplits = {
  __typename?: 'audience_splits';
  column_value: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  friendly_name: Scalars['String'];
  id: Scalars['uuid'];
  is_holdout_group: Scalars['Boolean'];
  max_size?: Maybe<Scalars['Int']>;
  percentage: Scalars['numeric'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "audience_splits" */
export type AudienceSplitsColumnValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "audience_splits" */
export type AudienceSplitsDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};

/** aggregated selection of "audience_splits" */
export type AudienceSplitsAggregate = {
  __typename?: 'audience_splits_aggregate';
  aggregate?: Maybe<AudienceSplitsAggregateFields>;
  nodes: Array<AudienceSplits>;
};

export type AudienceSplitsAggregateBoolExp = {
  bool_and?: InputMaybe<AudienceSplitsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AudienceSplitsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AudienceSplitsAggregateBoolExpCount>;
};

export type AudienceSplitsAggregateBoolExpBoolAnd = {
  arguments: AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceSplitsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AudienceSplitsAggregateBoolExpBoolOr = {
  arguments: AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceSplitsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AudienceSplitsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceSplitsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_splits" */
export type AudienceSplitsAggregateFields = {
  __typename?: 'audience_splits_aggregate_fields';
  avg?: Maybe<AudienceSplitsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceSplitsMaxFields>;
  min?: Maybe<AudienceSplitsMinFields>;
  stddev?: Maybe<AudienceSplitsStddevFields>;
  stddev_pop?: Maybe<AudienceSplitsStddevPopFields>;
  stddev_samp?: Maybe<AudienceSplitsStddevSampFields>;
  sum?: Maybe<AudienceSplitsSumFields>;
  var_pop?: Maybe<AudienceSplitsVarPopFields>;
  var_samp?: Maybe<AudienceSplitsVarSampFields>;
  variance?: Maybe<AudienceSplitsVarianceFields>;
};


/** aggregate fields of "audience_splits" */
export type AudienceSplitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_splits" */
export type AudienceSplitsAggregateOrderBy = {
  avg?: InputMaybe<AudienceSplitsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceSplitsMaxOrderBy>;
  min?: InputMaybe<AudienceSplitsMinOrderBy>;
  stddev?: InputMaybe<AudienceSplitsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceSplitsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceSplitsStddevSampOrderBy>;
  sum?: InputMaybe<AudienceSplitsSumOrderBy>;
  var_pop?: InputMaybe<AudienceSplitsVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceSplitsVarSampOrderBy>;
  variance?: InputMaybe<AudienceSplitsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AudienceSplitsAppendInput = {
  column_value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "audience_splits" */
export type AudienceSplitsArrRelInsertInput = {
  data: Array<AudienceSplitsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSplitsOnConflict>;
};

/** aggregate avg on columns */
export type AudienceSplitsAvgFields = {
  __typename?: 'audience_splits_avg_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_splits" */
export type AudienceSplitsAvgOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_splits". All fields are combined with a logical 'AND'. */
export type AudienceSplitsBoolExp = {
  _and?: InputMaybe<Array<AudienceSplitsBoolExp>>;
  _not?: InputMaybe<AudienceSplitsBoolExp>;
  _or?: InputMaybe<Array<AudienceSplitsBoolExp>>;
  column_value?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsBoolExp>;
  friendly_name?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_holdout_group?: InputMaybe<BooleanComparisonExp>;
  max_size?: InputMaybe<IntComparisonExp>;
  percentage?: InputMaybe<NumericComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "audience_splits" */
export const AudienceSplitsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AudienceSplitsIdWorkspaceIdKey: 'audience_splits_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AudienceSplitsPkey: 'audience_splits_pkey',
  /** unique or primary key constraint on columns "segment_id", "column_value" */
  AudienceSplitsSegmentIdColumnValueKey: 'audience_splits_segment_id_column_value_key'
} as const;

export type AudienceSplitsConstraint = typeof AudienceSplitsConstraint[keyof typeof AudienceSplitsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AudienceSplitsDeleteAtPathInput = {
  column_value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AudienceSplitsDeleteElemInput = {
  column_value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AudienceSplitsDeleteKeyInput = {
  column_value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audience_splits" */
export type AudienceSplitsIncInput = {
  max_size?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "audience_splits" */
export type AudienceSplitsInsertInput = {
  column_value?: InputMaybe<Scalars['jsonb']>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsArrRelInsertInput>;
  friendly_name?: InputMaybe<Scalars['String']>;
  is_holdout_group?: InputMaybe<Scalars['Boolean']>;
  max_size?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AudienceSplitsMaxFields = {
  __typename?: 'audience_splits_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  max_size?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['numeric']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "audience_splits" */
export type AudienceSplitsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  friendly_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceSplitsMinFields = {
  __typename?: 'audience_splits_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  friendly_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  max_size?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['numeric']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "audience_splits" */
export type AudienceSplitsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  friendly_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_splits" */
export type AudienceSplitsMutationResponse = {
  __typename?: 'audience_splits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceSplits>;
};

/** input type for inserting object relation for remote table "audience_splits" */
export type AudienceSplitsObjRelInsertInput = {
  data: AudienceSplitsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSplitsOnConflict>;
};

/** on_conflict condition type for table "audience_splits" */
export type AudienceSplitsOnConflict = {
  constraint: AudienceSplitsConstraint;
  update_columns?: Array<AudienceSplitsUpdateColumn>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};

/** Ordering options when selecting data from "audience_splits". */
export type AudienceSplitsOrderBy = {
  column_value?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_instance_splits_aggregate?: InputMaybe<DestinationInstanceSplitsAggregateOrderBy>;
  friendly_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_holdout_group?: InputMaybe<OrderBy>;
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_splits */
export type AudienceSplitsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AudienceSplitsPrependInput = {
  column_value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audience_splits" */
export const AudienceSplitsSelectColumn = {
  /** column name */
  ColumnValue: 'column_value',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FriendlyName: 'friendly_name',
  /** column name */
  Id: 'id',
  /** column name */
  IsHoldoutGroup: 'is_holdout_group',
  /** column name */
  MaxSize: 'max_size',
  /** column name */
  Percentage: 'percentage',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type AudienceSplitsSelectColumn = typeof AudienceSplitsSelectColumn[keyof typeof AudienceSplitsSelectColumn];
/** select "audience_splits_aggregate_bool_exp_bool_and_arguments_columns" columns of table "audience_splits" */
export const AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsHoldoutGroup: 'is_holdout_group'
} as const;

export type AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolAndArgumentsColumns = typeof AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolAndArgumentsColumns];
/** select "audience_splits_aggregate_bool_exp_bool_or_arguments_columns" columns of table "audience_splits" */
export const AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsHoldoutGroup: 'is_holdout_group'
} as const;

export type AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolOrArgumentsColumns = typeof AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof AudienceSplitsSelectColumnAudienceSplitsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "audience_splits" */
export type AudienceSplitsSetInput = {
  column_value?: InputMaybe<Scalars['jsonb']>;
  friendly_name?: InputMaybe<Scalars['String']>;
  max_size?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type AudienceSplitsStddevFields = {
  __typename?: 'audience_splits_stddev_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_splits" */
export type AudienceSplitsStddevOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceSplitsStddevPopFields = {
  __typename?: 'audience_splits_stddev_pop_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_splits" */
export type AudienceSplitsStddevPopOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceSplitsStddevSampFields = {
  __typename?: 'audience_splits_stddev_samp_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_splits" */
export type AudienceSplitsStddevSampOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_splits" */
export type AudienceSplitsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceSplitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceSplitsStreamCursorValueInput = {
  column_value?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  friendly_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_holdout_group?: InputMaybe<Scalars['Boolean']>;
  max_size?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AudienceSplitsSumFields = {
  __typename?: 'audience_splits_sum_fields';
  max_size?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['numeric']>;
  segment_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_splits" */
export type AudienceSplitsSumOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** update columns of table "audience_splits" */
export const AudienceSplitsUpdateColumn = {
  /** column name */
  ColumnValue: 'column_value',
  /** column name */
  FriendlyName: 'friendly_name',
  /** column name */
  MaxSize: 'max_size',
  /** column name */
  Percentage: 'percentage'
} as const;

export type AudienceSplitsUpdateColumn = typeof AudienceSplitsUpdateColumn[keyof typeof AudienceSplitsUpdateColumn];
export type AudienceSplitsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AudienceSplitsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AudienceSplitsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AudienceSplitsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AudienceSplitsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AudienceSplitsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AudienceSplitsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceSplitsSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceSplitsBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceSplitsVarPopFields = {
  __typename?: 'audience_splits_var_pop_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_splits" */
export type AudienceSplitsVarPopOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceSplitsVarSampFields = {
  __typename?: 'audience_splits_var_samp_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_splits" */
export type AudienceSplitsVarSampOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceSplitsVarianceFields = {
  __typename?: 'audience_splits_variance_fields';
  max_size?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_splits" */
export type AudienceSplitsVarianceOrderBy = {
  max_size?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModels = {
  __typename?: 'audience_subset_group_required_models';
  /** An object relationship */
  audience_subset_group?: Maybe<AudienceSubsetGroups>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id: Scalars['bigint'];
  subset_group_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsAggregate = {
  __typename?: 'audience_subset_group_required_models_aggregate';
  aggregate?: Maybe<AudienceSubsetGroupRequiredModelsAggregateFields>;
  nodes: Array<AudienceSubsetGroupRequiredModels>;
};

export type AudienceSubsetGroupRequiredModelsAggregateBoolExp = {
  count?: InputMaybe<AudienceSubsetGroupRequiredModelsAggregateBoolExpCount>;
};

export type AudienceSubsetGroupRequiredModelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsAggregateFields = {
  __typename?: 'audience_subset_group_required_models_aggregate_fields';
  avg?: Maybe<AudienceSubsetGroupRequiredModelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceSubsetGroupRequiredModelsMaxFields>;
  min?: Maybe<AudienceSubsetGroupRequiredModelsMinFields>;
  stddev?: Maybe<AudienceSubsetGroupRequiredModelsStddevFields>;
  stddev_pop?: Maybe<AudienceSubsetGroupRequiredModelsStddevPopFields>;
  stddev_samp?: Maybe<AudienceSubsetGroupRequiredModelsStddevSampFields>;
  sum?: Maybe<AudienceSubsetGroupRequiredModelsSumFields>;
  var_pop?: Maybe<AudienceSubsetGroupRequiredModelsVarPopFields>;
  var_samp?: Maybe<AudienceSubsetGroupRequiredModelsVarSampFields>;
  variance?: Maybe<AudienceSubsetGroupRequiredModelsVarianceFields>;
};


/** aggregate fields of "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsAggregateOrderBy = {
  avg?: InputMaybe<AudienceSubsetGroupRequiredModelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceSubsetGroupRequiredModelsMaxOrderBy>;
  min?: InputMaybe<AudienceSubsetGroupRequiredModelsMinOrderBy>;
  stddev?: InputMaybe<AudienceSubsetGroupRequiredModelsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceSubsetGroupRequiredModelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceSubsetGroupRequiredModelsStddevSampOrderBy>;
  sum?: InputMaybe<AudienceSubsetGroupRequiredModelsSumOrderBy>;
  var_pop?: InputMaybe<AudienceSubsetGroupRequiredModelsVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceSubsetGroupRequiredModelsVarSampOrderBy>;
  variance?: InputMaybe<AudienceSubsetGroupRequiredModelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsArrRelInsertInput = {
  data: Array<AudienceSubsetGroupRequiredModelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSubsetGroupRequiredModelsOnConflict>;
};

/** aggregate avg on columns */
export type AudienceSubsetGroupRequiredModelsAvgFields = {
  __typename?: 'audience_subset_group_required_models_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_subset_group_required_models". All fields are combined with a logical 'AND'. */
export type AudienceSubsetGroupRequiredModelsBoolExp = {
  _and?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsBoolExp>>;
  _not?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
  _or?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsBoolExp>>;
  audience_subset_group?: InputMaybe<AudienceSubsetGroupsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  subset_group_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "audience_subset_group_required_models" */
export const AudienceSubsetGroupRequiredModelsConstraint = {
  /** unique or primary key constraint on columns "segment_id", "subset_group_id" */
  AudienceSubsetGroupRequiredModelsPkey: 'audience_subset_group_required_models_pkey'
} as const;

export type AudienceSubsetGroupRequiredModelsConstraint = typeof AudienceSubsetGroupRequiredModelsConstraint[keyof typeof AudienceSubsetGroupRequiredModelsConstraint];
/** input type for inserting data into table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsInsertInput = {
  audience_subset_group?: InputMaybe<AudienceSubsetGroupsObjRelInsertInput>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  subset_group_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AudienceSubsetGroupRequiredModelsMaxFields = {
  __typename?: 'audience_subset_group_required_models_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  subset_group_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceSubsetGroupRequiredModelsMinFields = {
  __typename?: 'audience_subset_group_required_models_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  subset_group_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsMutationResponse = {
  __typename?: 'audience_subset_group_required_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceSubsetGroupRequiredModels>;
};

/** on_conflict condition type for table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsOnConflict = {
  constraint: AudienceSubsetGroupRequiredModelsConstraint;
  update_columns?: Array<AudienceSubsetGroupRequiredModelsUpdateColumn>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};

/** Ordering options when selecting data from "audience_subset_group_required_models". */
export type AudienceSubsetGroupRequiredModelsOrderBy = {
  audience_subset_group?: InputMaybe<AudienceSubsetGroupsOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "audience_subset_group_required_models" */
export const AudienceSubsetGroupRequiredModelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SubsetGroupId: 'subset_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceSubsetGroupRequiredModelsSelectColumn = typeof AudienceSubsetGroupRequiredModelsSelectColumn[keyof typeof AudienceSubsetGroupRequiredModelsSelectColumn];
/** aggregate stddev on columns */
export type AudienceSubsetGroupRequiredModelsStddevFields = {
  __typename?: 'audience_subset_group_required_models_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceSubsetGroupRequiredModelsStddevPopFields = {
  __typename?: 'audience_subset_group_required_models_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceSubsetGroupRequiredModelsStddevSampFields = {
  __typename?: 'audience_subset_group_required_models_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceSubsetGroupRequiredModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceSubsetGroupRequiredModelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  subset_group_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceSubsetGroupRequiredModelsSumFields = {
  __typename?: 'audience_subset_group_required_models_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "audience_subset_group_required_models" (current role has no relevant permissions) */
export const AudienceSubsetGroupRequiredModelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AudienceSubsetGroupRequiredModelsUpdateColumn = typeof AudienceSubsetGroupRequiredModelsUpdateColumn[keyof typeof AudienceSubsetGroupRequiredModelsUpdateColumn];
/** aggregate var_pop on columns */
export type AudienceSubsetGroupRequiredModelsVarPopFields = {
  __typename?: 'audience_subset_group_required_models_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceSubsetGroupRequiredModelsVarSampFields = {
  __typename?: 'audience_subset_group_required_models_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceSubsetGroupRequiredModelsVarianceFields = {
  __typename?: 'audience_subset_group_required_models_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_subset_group_required_models" */
export type AudienceSubsetGroupRequiredModelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "audience_subset_groups" */
export type AudienceSubsetGroups = {
  __typename?: 'audience_subset_groups';
  /** An object relationship */
  connection?: Maybe<Connections>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_required: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  /** An array relationship */
  required_models: Array<AudienceSubsetGroupRequiredModels>;
  /** An aggregate relationship */
  required_models_aggregate: AudienceSubsetGroupRequiredModelsAggregate;
  /** An array relationship */
  subset_values: Array<AudienceSubsetValues>;
  /** An aggregate relationship */
  subset_values_aggregate: AudienceSubsetValuesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "audience_subset_groups" */
export type AudienceSubsetGroupsRequiredModelsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


/** columns and relationships of "audience_subset_groups" */
export type AudienceSubsetGroupsRequiredModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


/** columns and relationships of "audience_subset_groups" */
export type AudienceSubsetGroupsSubsetValuesArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


/** columns and relationships of "audience_subset_groups" */
export type AudienceSubsetGroupsSubsetValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};

/** aggregated selection of "audience_subset_groups" */
export type AudienceSubsetGroupsAggregate = {
  __typename?: 'audience_subset_groups_aggregate';
  aggregate?: Maybe<AudienceSubsetGroupsAggregateFields>;
  nodes: Array<AudienceSubsetGroups>;
};

/** aggregate fields of "audience_subset_groups" */
export type AudienceSubsetGroupsAggregateFields = {
  __typename?: 'audience_subset_groups_aggregate_fields';
  avg?: Maybe<AudienceSubsetGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceSubsetGroupsMaxFields>;
  min?: Maybe<AudienceSubsetGroupsMinFields>;
  stddev?: Maybe<AudienceSubsetGroupsStddevFields>;
  stddev_pop?: Maybe<AudienceSubsetGroupsStddevPopFields>;
  stddev_samp?: Maybe<AudienceSubsetGroupsStddevSampFields>;
  sum?: Maybe<AudienceSubsetGroupsSumFields>;
  var_pop?: Maybe<AudienceSubsetGroupsVarPopFields>;
  var_samp?: Maybe<AudienceSubsetGroupsVarSampFields>;
  variance?: Maybe<AudienceSubsetGroupsVarianceFields>;
};


/** aggregate fields of "audience_subset_groups" */
export type AudienceSubsetGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceSubsetGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AudienceSubsetGroupsAvgFields = {
  __typename?: 'audience_subset_groups_avg_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audience_subset_groups". All fields are combined with a logical 'AND'. */
export type AudienceSubsetGroupsBoolExp = {
  _and?: InputMaybe<Array<AudienceSubsetGroupsBoolExp>>;
  _not?: InputMaybe<AudienceSubsetGroupsBoolExp>;
  _or?: InputMaybe<Array<AudienceSubsetGroupsBoolExp>>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_required?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  required_models?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
  required_models_aggregate?: InputMaybe<AudienceSubsetGroupRequiredModelsAggregateBoolExp>;
  subset_values?: InputMaybe<AudienceSubsetValuesBoolExp>;
  subset_values_aggregate?: InputMaybe<AudienceSubsetValuesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "audience_subset_groups" */
export const AudienceSubsetGroupsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AudienceSubsetGroupsIdWorkspaceIdKey: 'audience_subset_groups_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AudienceSubsetGroupsPkey: 'audience_subset_groups_pkey'
} as const;

export type AudienceSubsetGroupsConstraint = typeof AudienceSubsetGroupsConstraint[keyof typeof AudienceSubsetGroupsConstraint];
/** input type for inserting data into table "audience_subset_groups" */
export type AudienceSubsetGroupsInsertInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  required_models?: InputMaybe<AudienceSubsetGroupRequiredModelsArrRelInsertInput>;
  subset_values?: InputMaybe<AudienceSubsetValuesArrRelInsertInput>;
};

/** aggregate max on columns */
export type AudienceSubsetGroupsMaxFields = {
  __typename?: 'audience_subset_groups_max_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AudienceSubsetGroupsMinFields = {
  __typename?: 'audience_subset_groups_min_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "audience_subset_groups" */
export type AudienceSubsetGroupsMutationResponse = {
  __typename?: 'audience_subset_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceSubsetGroups>;
};

/** input type for inserting object relation for remote table "audience_subset_groups" */
export type AudienceSubsetGroupsObjRelInsertInput = {
  data: AudienceSubsetGroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSubsetGroupsOnConflict>;
};

/** on_conflict condition type for table "audience_subset_groups" */
export type AudienceSubsetGroupsOnConflict = {
  constraint: AudienceSubsetGroupsConstraint;
  update_columns?: Array<AudienceSubsetGroupsUpdateColumn>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};

/** Ordering options when selecting data from "audience_subset_groups". */
export type AudienceSubsetGroupsOrderBy = {
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_required?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  required_models_aggregate?: InputMaybe<AudienceSubsetGroupRequiredModelsAggregateOrderBy>;
  subset_values_aggregate?: InputMaybe<AudienceSubsetValuesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_subset_groups */
export type AudienceSubsetGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "audience_subset_groups" */
export const AudienceSubsetGroupsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  IsRequired: 'is_required',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceSubsetGroupsSelectColumn = typeof AudienceSubsetGroupsSelectColumn[keyof typeof AudienceSubsetGroupsSelectColumn];
/** input type for updating data in table "audience_subset_groups" */
export type AudienceSubsetGroupsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AudienceSubsetGroupsStddevFields = {
  __typename?: 'audience_subset_groups_stddev_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AudienceSubsetGroupsStddevPopFields = {
  __typename?: 'audience_subset_groups_stddev_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AudienceSubsetGroupsStddevSampFields = {
  __typename?: 'audience_subset_groups_stddev_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audience_subset_groups" */
export type AudienceSubsetGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceSubsetGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceSubsetGroupsStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceSubsetGroupsSumFields = {
  __typename?: 'audience_subset_groups_sum_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "audience_subset_groups" */
export const AudienceSubsetGroupsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  IsRequired: 'is_required',
  /** column name */
  Name: 'name'
} as const;

export type AudienceSubsetGroupsUpdateColumn = typeof AudienceSubsetGroupsUpdateColumn[keyof typeof AudienceSubsetGroupsUpdateColumn];
export type AudienceSubsetGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceSubsetGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceSubsetGroupsBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceSubsetGroupsVarPopFields = {
  __typename?: 'audience_subset_groups_var_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AudienceSubsetGroupsVarSampFields = {
  __typename?: 'audience_subset_groups_var_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AudienceSubsetGroupsVarianceFields = {
  __typename?: 'audience_subset_groups_variance_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditions = {
  __typename?: 'audience_subset_value_scoped_conditions';
  condition: Scalars['jsonb'];
  ordinal: Scalars['smallint'];
  /** An object relationship */
  root_model?: Maybe<Segments>;
  root_model_id: Scalars['bigint'];
  /** An object relationship */
  subset_value?: Maybe<AudienceSubsetValues>;
  subset_value_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditionsConditionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditionsAggregate = {
  __typename?: 'audience_subset_value_scoped_conditions_aggregate';
  aggregate?: Maybe<AudienceSubsetValueScopedConditionsAggregateFields>;
  nodes: Array<AudienceSubsetValueScopedConditions>;
};

/** aggregate fields of "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditionsAggregateFields = {
  __typename?: 'audience_subset_value_scoped_conditions_aggregate_fields';
  avg?: Maybe<AudienceSubsetValueScopedConditionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceSubsetValueScopedConditionsMaxFields>;
  min?: Maybe<AudienceSubsetValueScopedConditionsMinFields>;
  stddev?: Maybe<AudienceSubsetValueScopedConditionsStddevFields>;
  stddev_pop?: Maybe<AudienceSubsetValueScopedConditionsStddevPopFields>;
  stddev_samp?: Maybe<AudienceSubsetValueScopedConditionsStddevSampFields>;
  sum?: Maybe<AudienceSubsetValueScopedConditionsSumFields>;
  var_pop?: Maybe<AudienceSubsetValueScopedConditionsVarPopFields>;
  var_samp?: Maybe<AudienceSubsetValueScopedConditionsVarSampFields>;
  variance?: Maybe<AudienceSubsetValueScopedConditionsVarianceFields>;
};


/** aggregate fields of "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceSubsetValueScopedConditionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AudienceSubsetValueScopedConditionsAvgFields = {
  __typename?: 'audience_subset_value_scoped_conditions_avg_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audience_subset_value_scoped_conditions". All fields are combined with a logical 'AND'. */
export type AudienceSubsetValueScopedConditionsBoolExp = {
  _and?: InputMaybe<Array<AudienceSubsetValueScopedConditionsBoolExp>>;
  _not?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
  _or?: InputMaybe<Array<AudienceSubsetValueScopedConditionsBoolExp>>;
  condition?: InputMaybe<JsonbComparisonExp>;
  ordinal?: InputMaybe<SmallintComparisonExp>;
  root_model?: InputMaybe<SegmentsBoolExp>;
  root_model_id?: InputMaybe<BigintComparisonExp>;
  subset_value?: InputMaybe<AudienceSubsetValuesBoolExp>;
  subset_value_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type AudienceSubsetValueScopedConditionsMaxFields = {
  __typename?: 'audience_subset_value_scoped_conditions_max_fields';
  ordinal?: Maybe<Scalars['smallint']>;
  root_model_id?: Maybe<Scalars['bigint']>;
  subset_value_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AudienceSubsetValueScopedConditionsMinFields = {
  __typename?: 'audience_subset_value_scoped_conditions_min_fields';
  ordinal?: Maybe<Scalars['smallint']>;
  root_model_id?: Maybe<Scalars['bigint']>;
  subset_value_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "audience_subset_value_scoped_conditions". */
export type AudienceSubsetValueScopedConditionsOrderBy = {
  condition?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  root_model?: InputMaybe<SegmentsOrderBy>;
  root_model_id?: InputMaybe<OrderBy>;
  subset_value?: InputMaybe<AudienceSubsetValuesOrderBy>;
  subset_value_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "audience_subset_value_scoped_conditions" */
export const AudienceSubsetValueScopedConditionsSelectColumn = {
  /** column name */
  Condition: 'condition',
  /** column name */
  Ordinal: 'ordinal',
  /** column name */
  RootModelId: 'root_model_id',
  /** column name */
  SubsetValueId: 'subset_value_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceSubsetValueScopedConditionsSelectColumn = typeof AudienceSubsetValueScopedConditionsSelectColumn[keyof typeof AudienceSubsetValueScopedConditionsSelectColumn];
/** aggregate stddev on columns */
export type AudienceSubsetValueScopedConditionsStddevFields = {
  __typename?: 'audience_subset_value_scoped_conditions_stddev_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AudienceSubsetValueScopedConditionsStddevPopFields = {
  __typename?: 'audience_subset_value_scoped_conditions_stddev_pop_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AudienceSubsetValueScopedConditionsStddevSampFields = {
  __typename?: 'audience_subset_value_scoped_conditions_stddev_samp_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audience_subset_value_scoped_conditions" */
export type AudienceSubsetValueScopedConditionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceSubsetValueScopedConditionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceSubsetValueScopedConditionsStreamCursorValueInput = {
  condition?: InputMaybe<Scalars['jsonb']>;
  ordinal?: InputMaybe<Scalars['smallint']>;
  root_model_id?: InputMaybe<Scalars['bigint']>;
  subset_value_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceSubsetValueScopedConditionsSumFields = {
  __typename?: 'audience_subset_value_scoped_conditions_sum_fields';
  ordinal?: Maybe<Scalars['smallint']>;
  root_model_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type AudienceSubsetValueScopedConditionsVarPopFields = {
  __typename?: 'audience_subset_value_scoped_conditions_var_pop_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AudienceSubsetValueScopedConditionsVarSampFields = {
  __typename?: 'audience_subset_value_scoped_conditions_var_samp_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AudienceSubsetValueScopedConditionsVarianceFields = {
  __typename?: 'audience_subset_value_scoped_conditions_variance_fields';
  ordinal?: Maybe<Scalars['Float']>;
  root_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValues = {
  __typename?: 'audience_subset_values';
  /** An array relationship */
  audiences_subsets: Array<AudiencesSubsets>;
  /** An aggregate relationship */
  audiences_subsets_aggregate: AudiencesSubsetsAggregate;
  conditions: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  subset_group: AudienceSubsetGroups;
  subset_group_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  user_group_subset_authorization: Array<UserGroupSubsetAuthorization>;
  /** An array relationship */
  user_group_subset_grants: Array<UserGroupSubsetGrants>;
  /** An aggregate relationship */
  user_group_subset_grants_aggregate: UserGroupSubsetGrantsAggregate;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesAudiencesSubsetsArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesAudiencesSubsetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesScopedConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesUserGroupSubsetAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesUserGroupSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


/** columns and relationships of "audience_subset_values" */
export type AudienceSubsetValuesUserGroupSubsetGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};

/** aggregated selection of "audience_subset_values" */
export type AudienceSubsetValuesAggregate = {
  __typename?: 'audience_subset_values_aggregate';
  aggregate?: Maybe<AudienceSubsetValuesAggregateFields>;
  nodes: Array<AudienceSubsetValues>;
};

export type AudienceSubsetValuesAggregateBoolExp = {
  count?: InputMaybe<AudienceSubsetValuesAggregateBoolExpCount>;
};

export type AudienceSubsetValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceSubsetValuesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_subset_values" */
export type AudienceSubsetValuesAggregateFields = {
  __typename?: 'audience_subset_values_aggregate_fields';
  avg?: Maybe<AudienceSubsetValuesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceSubsetValuesMaxFields>;
  min?: Maybe<AudienceSubsetValuesMinFields>;
  stddev?: Maybe<AudienceSubsetValuesStddevFields>;
  stddev_pop?: Maybe<AudienceSubsetValuesStddevPopFields>;
  stddev_samp?: Maybe<AudienceSubsetValuesStddevSampFields>;
  sum?: Maybe<AudienceSubsetValuesSumFields>;
  var_pop?: Maybe<AudienceSubsetValuesVarPopFields>;
  var_samp?: Maybe<AudienceSubsetValuesVarSampFields>;
  variance?: Maybe<AudienceSubsetValuesVarianceFields>;
};


/** aggregate fields of "audience_subset_values" */
export type AudienceSubsetValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_subset_values" */
export type AudienceSubsetValuesAggregateOrderBy = {
  avg?: InputMaybe<AudienceSubsetValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceSubsetValuesMaxOrderBy>;
  min?: InputMaybe<AudienceSubsetValuesMinOrderBy>;
  stddev?: InputMaybe<AudienceSubsetValuesStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceSubsetValuesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceSubsetValuesStddevSampOrderBy>;
  sum?: InputMaybe<AudienceSubsetValuesSumOrderBy>;
  var_pop?: InputMaybe<AudienceSubsetValuesVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceSubsetValuesVarSampOrderBy>;
  variance?: InputMaybe<AudienceSubsetValuesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AudienceSubsetValuesAppendInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "audience_subset_values" */
export type AudienceSubsetValuesArrRelInsertInput = {
  data: Array<AudienceSubsetValuesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSubsetValuesOnConflict>;
};

/** aggregate avg on columns */
export type AudienceSubsetValuesAvgFields = {
  __typename?: 'audience_subset_values_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_subset_values". All fields are combined with a logical 'AND'. */
export type AudienceSubsetValuesBoolExp = {
  _and?: InputMaybe<Array<AudienceSubsetValuesBoolExp>>;
  _not?: InputMaybe<AudienceSubsetValuesBoolExp>;
  _or?: InputMaybe<Array<AudienceSubsetValuesBoolExp>>;
  audiences_subsets?: InputMaybe<AudiencesSubsetsBoolExp>;
  audiences_subsets_aggregate?: InputMaybe<AudiencesSubsetsAggregateBoolExp>;
  conditions?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  scoped_conditions?: InputMaybe<JsonbComparisonExp>;
  subset_group?: InputMaybe<AudienceSubsetGroupsBoolExp>;
  subset_group_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  user_group_subset_authorization?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
  user_group_subset_grants?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
  user_group_subset_grants_aggregate?: InputMaybe<UserGroupSubsetGrantsAggregateBoolExp>;
};

/** unique or primary key constraints on table "audience_subset_values" */
export const AudienceSubsetValuesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  AudienceSubsetValuesIdWorkspaceIdKey: 'audience_subset_values_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  AudienceSubsetValuesPkey: 'audience_subset_values_pkey'
} as const;

export type AudienceSubsetValuesConstraint = typeof AudienceSubsetValuesConstraint[keyof typeof AudienceSubsetValuesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AudienceSubsetValuesDeleteAtPathInput = {
  conditions?: InputMaybe<Array<Scalars['String']>>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AudienceSubsetValuesDeleteElemInput = {
  conditions?: InputMaybe<Scalars['Int']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AudienceSubsetValuesDeleteKeyInput = {
  conditions?: InputMaybe<Scalars['String']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "audience_subset_values" */
export type AudienceSubsetValuesInsertInput = {
  audiences_subsets?: InputMaybe<AudiencesSubsetsArrRelInsertInput>;
  conditions?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['jsonb']>;
  subset_group?: InputMaybe<AudienceSubsetGroupsObjRelInsertInput>;
  subset_group_id?: InputMaybe<Scalars['uuid']>;
  user_group_subset_grants?: InputMaybe<UserGroupSubsetGrantsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AudienceSubsetValuesMaxFields = {
  __typename?: 'audience_subset_values_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subset_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceSubsetValuesMinFields = {
  __typename?: 'audience_subset_values_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subset_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_subset_values" */
export type AudienceSubsetValuesMutationResponse = {
  __typename?: 'audience_subset_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceSubsetValues>;
};

/** input type for inserting object relation for remote table "audience_subset_values" */
export type AudienceSubsetValuesObjRelInsertInput = {
  data: AudienceSubsetValuesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceSubsetValuesOnConflict>;
};

/** on_conflict condition type for table "audience_subset_values" */
export type AudienceSubsetValuesOnConflict = {
  constraint: AudienceSubsetValuesConstraint;
  update_columns?: Array<AudienceSubsetValuesUpdateColumn>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};

/** Ordering options when selecting data from "audience_subset_values". */
export type AudienceSubsetValuesOrderBy = {
  audiences_subsets_aggregate?: InputMaybe<AudiencesSubsetsAggregateOrderBy>;
  conditions?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  scoped_conditions?: InputMaybe<OrderBy>;
  subset_group?: InputMaybe<AudienceSubsetGroupsOrderBy>;
  subset_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_group_subset_authorization_aggregate?: InputMaybe<UserGroupSubsetAuthorizationAggregateOrderBy>;
  user_group_subset_grants_aggregate?: InputMaybe<UserGroupSubsetGrantsAggregateOrderBy>;
};

/** primary key columns input for table: audience_subset_values */
export type AudienceSubsetValuesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AudienceSubsetValuesPrependInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audience_subset_values" */
export const AudienceSubsetValuesSelectColumn = {
  /** column name */
  Conditions: 'conditions',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ScopedConditions: 'scoped_conditions',
  /** column name */
  SubsetGroupId: 'subset_group_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type AudienceSubsetValuesSelectColumn = typeof AudienceSubsetValuesSelectColumn[keyof typeof AudienceSubsetValuesSelectColumn];
/** input type for updating data in table "audience_subset_values" */
export type AudienceSubsetValuesSetInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type AudienceSubsetValuesStddevFields = {
  __typename?: 'audience_subset_values_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceSubsetValuesStddevPopFields = {
  __typename?: 'audience_subset_values_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceSubsetValuesStddevSampFields = {
  __typename?: 'audience_subset_values_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_subset_values" */
export type AudienceSubsetValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceSubsetValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceSubsetValuesStreamCursorValueInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** Array of condition blocks, each with a root_model_id indicating where to apply. If root_model_id is null, conditions apply at parent model level. All blocks are applied with AND, matching the root_model appearance in queries. */
  scoped_conditions?: InputMaybe<Scalars['jsonb']>;
  subset_group_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceSubsetValuesSumFields = {
  __typename?: 'audience_subset_values_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "audience_subset_values" */
export const AudienceSubsetValuesUpdateColumn = {
  /** column name */
  Conditions: 'conditions',
  /** column name */
  Name: 'name',
  /** column name */
  ScopedConditions: 'scoped_conditions'
} as const;

export type AudienceSubsetValuesUpdateColumn = typeof AudienceSubsetValuesUpdateColumn[keyof typeof AudienceSubsetValuesUpdateColumn];
export type AudienceSubsetValuesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AudienceSubsetValuesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AudienceSubsetValuesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AudienceSubsetValuesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AudienceSubsetValuesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AudienceSubsetValuesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceSubsetValuesSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceSubsetValuesBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceSubsetValuesVarPopFields = {
  __typename?: 'audience_subset_values_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceSubsetValuesVarSampFields = {
  __typename?: 'audience_subset_values_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceSubsetValuesVarianceFields = {
  __typename?: 'audience_subset_values_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_subset_values" */
export type AudienceSubsetValuesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** input type for inserting array relation for remote table "audience_template_segments" */
export type AudienceTemplateSegmentsArrRelInsertInput = {
  data: Array<AudienceTemplateSegmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudienceTemplateSegmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "audience_template_segments". All fields are combined with a logical 'AND'. */
export type AudienceTemplateSegmentsBoolExp = {
  _and?: InputMaybe<Array<AudienceTemplateSegmentsBoolExp>>;
  _not?: InputMaybe<AudienceTemplateSegmentsBoolExp>;
  _or?: InputMaybe<Array<AudienceTemplateSegmentsBoolExp>>;
};

/** unique or primary key constraints on table "audience_template_segments" */
export const AudienceTemplateSegmentsConstraint = {
  /** unique or primary key constraint on columns "template_id", "segment_id" */
  AudienceTemplateSegmentsPkey: 'audience_template_segments_pkey'
} as const;

export type AudienceTemplateSegmentsConstraint = typeof AudienceTemplateSegmentsConstraint[keyof typeof AudienceTemplateSegmentsConstraint];
/** input type for inserting data into table "audience_template_segments" */
export type AudienceTemplateSegmentsInsertInput = {
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "audience_template_segments" */
export type AudienceTemplateSegmentsMutationResponse = {
  __typename?: 'audience_template_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
};

/** on_conflict condition type for table "audience_template_segments" */
export type AudienceTemplateSegmentsOnConflict = {
  constraint: AudienceTemplateSegmentsConstraint;
  update_columns?: Array<AudienceTemplateSegmentsUpdateColumn>;
  where?: InputMaybe<AudienceTemplateSegmentsBoolExp>;
};

/** placeholder for update columns of table "audience_template_segments" (current role has no relevant permissions) */
export const AudienceTemplateSegmentsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type AudienceTemplateSegmentsUpdateColumn = typeof AudienceTemplateSegmentsUpdateColumn[keyof typeof AudienceTemplateSegmentsUpdateColumn];
/** columns and relationships of "audience_templates" */
export type AudienceTemplates = {
  __typename?: 'audience_templates';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  definition: Scalars['jsonb'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  labels: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "audience_templates" */
export type AudienceTemplatesDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "audience_templates" */
export type AudienceTemplatesLabelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "audience_templates" */
export type AudienceTemplatesAggregate = {
  __typename?: 'audience_templates_aggregate';
  aggregate?: Maybe<AudienceTemplatesAggregateFields>;
  nodes: Array<AudienceTemplates>;
};

export type AudienceTemplatesAggregateBoolExp = {
  count?: InputMaybe<AudienceTemplatesAggregateBoolExpCount>;
};

export type AudienceTemplatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudienceTemplatesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audience_templates" */
export type AudienceTemplatesAggregateFields = {
  __typename?: 'audience_templates_aggregate_fields';
  avg?: Maybe<AudienceTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudienceTemplatesMaxFields>;
  min?: Maybe<AudienceTemplatesMinFields>;
  stddev?: Maybe<AudienceTemplatesStddevFields>;
  stddev_pop?: Maybe<AudienceTemplatesStddevPopFields>;
  stddev_samp?: Maybe<AudienceTemplatesStddevSampFields>;
  sum?: Maybe<AudienceTemplatesSumFields>;
  var_pop?: Maybe<AudienceTemplatesVarPopFields>;
  var_samp?: Maybe<AudienceTemplatesVarSampFields>;
  variance?: Maybe<AudienceTemplatesVarianceFields>;
};


/** aggregate fields of "audience_templates" */
export type AudienceTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audience_templates" */
export type AudienceTemplatesAggregateOrderBy = {
  avg?: InputMaybe<AudienceTemplatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudienceTemplatesMaxOrderBy>;
  min?: InputMaybe<AudienceTemplatesMinOrderBy>;
  stddev?: InputMaybe<AudienceTemplatesStddevOrderBy>;
  stddev_pop?: InputMaybe<AudienceTemplatesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudienceTemplatesStddevSampOrderBy>;
  sum?: InputMaybe<AudienceTemplatesSumOrderBy>;
  var_pop?: InputMaybe<AudienceTemplatesVarPopOrderBy>;
  var_samp?: InputMaybe<AudienceTemplatesVarSampOrderBy>;
  variance?: InputMaybe<AudienceTemplatesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AudienceTemplatesAppendInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  labels?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AudienceTemplatesAvgFields = {
  __typename?: 'audience_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audience_templates" */
export type AudienceTemplatesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audience_templates". All fields are combined with a logical 'AND'. */
export type AudienceTemplatesBoolExp = {
  _and?: InputMaybe<Array<AudienceTemplatesBoolExp>>;
  _not?: InputMaybe<AudienceTemplatesBoolExp>;
  _or?: InputMaybe<Array<AudienceTemplatesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  definition?: InputMaybe<JsonbComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  labels?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AudienceTemplatesDeleteAtPathInput = {
  definition?: InputMaybe<Array<Scalars['String']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AudienceTemplatesDeleteElemInput = {
  definition?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AudienceTemplatesDeleteKeyInput = {
  definition?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "audience_templates" */
export type AudienceTemplatesIncInput = {
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AudienceTemplatesMaxFields = {
  __typename?: 'audience_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "audience_templates" */
export type AudienceTemplatesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudienceTemplatesMinFields = {
  __typename?: 'audience_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "audience_templates" */
export type AudienceTemplatesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audience_templates" */
export type AudienceTemplatesMutationResponse = {
  __typename?: 'audience_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudienceTemplates>;
};

/** Ordering options when selecting data from "audience_templates". */
export type AudienceTemplatesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  definition?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  labels?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audience_templates */
export type AudienceTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AudienceTemplatesPrependInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  labels?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "audience_templates" */
export const AudienceTemplatesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Definition: 'definition',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Labels: 'labels',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type AudienceTemplatesSelectColumn = typeof AudienceTemplatesSelectColumn[keyof typeof AudienceTemplatesSelectColumn];
/** input type for updating data in table "audience_templates" */
export type AudienceTemplatesSetInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AudienceTemplatesStddevFields = {
  __typename?: 'audience_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audience_templates" */
export type AudienceTemplatesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudienceTemplatesStddevPopFields = {
  __typename?: 'audience_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audience_templates" */
export type AudienceTemplatesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudienceTemplatesStddevSampFields = {
  __typename?: 'audience_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audience_templates" */
export type AudienceTemplatesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audience_templates" */
export type AudienceTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudienceTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudienceTemplatesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  definition?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AudienceTemplatesSumFields = {
  __typename?: 'audience_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audience_templates" */
export type AudienceTemplatesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type AudienceTemplatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AudienceTemplatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AudienceTemplatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AudienceTemplatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AudienceTemplatesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AudienceTemplatesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AudienceTemplatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudienceTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: AudienceTemplatesBoolExp;
};

/** aggregate var_pop on columns */
export type AudienceTemplatesVarPopFields = {
  __typename?: 'audience_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audience_templates" */
export type AudienceTemplatesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudienceTemplatesVarSampFields = {
  __typename?: 'audience_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audience_templates" */
export type AudienceTemplatesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudienceTemplatesVarianceFields = {
  __typename?: 'audience_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audience_templates" */
export type AudienceTemplatesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Specifies which audiences use each subset. */
export type AudiencesSubsets = {
  __typename?: 'audiences_subsets';
  /** An object relationship */
  audience: Segments;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  segment_id: Scalars['bigint'];
  /** An object relationship */
  subset_value: AudienceSubsetValues;
  subset_value_id: Scalars['uuid'];
};

/** aggregated selection of "audiences_subsets" */
export type AudiencesSubsetsAggregate = {
  __typename?: 'audiences_subsets_aggregate';
  aggregate?: Maybe<AudiencesSubsetsAggregateFields>;
  nodes: Array<AudiencesSubsets>;
};

export type AudiencesSubsetsAggregateBoolExp = {
  count?: InputMaybe<AudiencesSubsetsAggregateBoolExpCount>;
};

export type AudiencesSubsetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AudiencesSubsetsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "audiences_subsets" */
export type AudiencesSubsetsAggregateFields = {
  __typename?: 'audiences_subsets_aggregate_fields';
  avg?: Maybe<AudiencesSubsetsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AudiencesSubsetsMaxFields>;
  min?: Maybe<AudiencesSubsetsMinFields>;
  stddev?: Maybe<AudiencesSubsetsStddevFields>;
  stddev_pop?: Maybe<AudiencesSubsetsStddevPopFields>;
  stddev_samp?: Maybe<AudiencesSubsetsStddevSampFields>;
  sum?: Maybe<AudiencesSubsetsSumFields>;
  var_pop?: Maybe<AudiencesSubsetsVarPopFields>;
  var_samp?: Maybe<AudiencesSubsetsVarSampFields>;
  variance?: Maybe<AudiencesSubsetsVarianceFields>;
};


/** aggregate fields of "audiences_subsets" */
export type AudiencesSubsetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "audiences_subsets" */
export type AudiencesSubsetsAggregateOrderBy = {
  avg?: InputMaybe<AudiencesSubsetsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AudiencesSubsetsMaxOrderBy>;
  min?: InputMaybe<AudiencesSubsetsMinOrderBy>;
  stddev?: InputMaybe<AudiencesSubsetsStddevOrderBy>;
  stddev_pop?: InputMaybe<AudiencesSubsetsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AudiencesSubsetsStddevSampOrderBy>;
  sum?: InputMaybe<AudiencesSubsetsSumOrderBy>;
  var_pop?: InputMaybe<AudiencesSubsetsVarPopOrderBy>;
  var_samp?: InputMaybe<AudiencesSubsetsVarSampOrderBy>;
  variance?: InputMaybe<AudiencesSubsetsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "audiences_subsets" */
export type AudiencesSubsetsArrRelInsertInput = {
  data: Array<AudiencesSubsetsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AudiencesSubsetsOnConflict>;
};

/** aggregate avg on columns */
export type AudiencesSubsetsAvgFields = {
  __typename?: 'audiences_subsets_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "audiences_subsets" */
export type AudiencesSubsetsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "audiences_subsets". All fields are combined with a logical 'AND'. */
export type AudiencesSubsetsBoolExp = {
  _and?: InputMaybe<Array<AudiencesSubsetsBoolExp>>;
  _not?: InputMaybe<AudiencesSubsetsBoolExp>;
  _or?: InputMaybe<Array<AudiencesSubsetsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  subset_value?: InputMaybe<AudienceSubsetValuesBoolExp>;
  subset_value_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "audiences_subsets" */
export const AudiencesSubsetsConstraint = {
  /** unique or primary key constraint on columns "segment_id", "subset_value_id" */
  AudiencesSubsetsPkey: 'audiences_subsets_pkey'
} as const;

export type AudiencesSubsetsConstraint = typeof AudiencesSubsetsConstraint[keyof typeof AudiencesSubsetsConstraint];
/** input type for inserting data into table "audiences_subsets" */
export type AudiencesSubsetsInsertInput = {
  audience?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  subset_value?: InputMaybe<AudienceSubsetValuesObjRelInsertInput>;
  subset_value_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AudiencesSubsetsMaxFields = {
  __typename?: 'audiences_subsets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  subset_value_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "audiences_subsets" */
export type AudiencesSubsetsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_value_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AudiencesSubsetsMinFields = {
  __typename?: 'audiences_subsets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  subset_value_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "audiences_subsets" */
export type AudiencesSubsetsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_value_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "audiences_subsets" */
export type AudiencesSubsetsMutationResponse = {
  __typename?: 'audiences_subsets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AudiencesSubsets>;
};

/** on_conflict condition type for table "audiences_subsets" */
export type AudiencesSubsetsOnConflict = {
  constraint: AudiencesSubsetsConstraint;
  update_columns?: Array<AudiencesSubsetsUpdateColumn>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};

/** Ordering options when selecting data from "audiences_subsets". */
export type AudiencesSubsetsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  subset_value?: InputMaybe<AudienceSubsetValuesOrderBy>;
  subset_value_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: audiences_subsets */
export type AudiencesSubsetsPkColumnsInput = {
  segment_id: Scalars['bigint'];
  subset_value_id: Scalars['uuid'];
};

/** select columns of table "audiences_subsets" */
export const AudiencesSubsetsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SubsetValueId: 'subset_value_id'
} as const;

export type AudiencesSubsetsSelectColumn = typeof AudiencesSubsetsSelectColumn[keyof typeof AudiencesSubsetsSelectColumn];
/** input type for updating data in table "audiences_subsets" */
export type AudiencesSubsetsSetInput = {
  subset_value_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AudiencesSubsetsStddevFields = {
  __typename?: 'audiences_subsets_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "audiences_subsets" */
export type AudiencesSubsetsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AudiencesSubsetsStddevPopFields = {
  __typename?: 'audiences_subsets_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "audiences_subsets" */
export type AudiencesSubsetsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AudiencesSubsetsStddevSampFields = {
  __typename?: 'audiences_subsets_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "audiences_subsets" */
export type AudiencesSubsetsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "audiences_subsets" */
export type AudiencesSubsetsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AudiencesSubsetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AudiencesSubsetsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  subset_value_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AudiencesSubsetsSumFields = {
  __typename?: 'audiences_subsets_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "audiences_subsets" */
export type AudiencesSubsetsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** update columns of table "audiences_subsets" */
export const AudiencesSubsetsUpdateColumn = {
  /** column name */
  SubsetValueId: 'subset_value_id'
} as const;

export type AudiencesSubsetsUpdateColumn = typeof AudiencesSubsetsUpdateColumn[keyof typeof AudiencesSubsetsUpdateColumn];
export type AudiencesSubsetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AudiencesSubsetsSetInput>;
  /** filter the rows which have to be updated */
  where: AudiencesSubsetsBoolExp;
};

/** aggregate var_pop on columns */
export type AudiencesSubsetsVarPopFields = {
  __typename?: 'audiences_subsets_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "audiences_subsets" */
export type AudiencesSubsetsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AudiencesSubsetsVarSampFields = {
  __typename?: 'audiences_subsets_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "audiences_subsets" */
export type AudiencesSubsetsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AudiencesSubsetsVarianceFields = {
  __typename?: 'audiences_subsets_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "audiences_subsets" */
export type AudiencesSubsetsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "auth0_connections" */
export type Auth0Connections = {
  __typename?: 'auth0_connections';
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organizations;
};

/** order by aggregate values of table "auth0_connections" */
export type Auth0ConnectionsAggregateOrderBy = {
  avg?: InputMaybe<Auth0ConnectionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<Auth0ConnectionsMaxOrderBy>;
  min?: InputMaybe<Auth0ConnectionsMinOrderBy>;
  stddev?: InputMaybe<Auth0ConnectionsStddevOrderBy>;
  stddev_pop?: InputMaybe<Auth0ConnectionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<Auth0ConnectionsStddevSampOrderBy>;
  sum?: InputMaybe<Auth0ConnectionsSumOrderBy>;
  var_pop?: InputMaybe<Auth0ConnectionsVarPopOrderBy>;
  var_samp?: InputMaybe<Auth0ConnectionsVarSampOrderBy>;
  variance?: InputMaybe<Auth0ConnectionsVarianceOrderBy>;
};

/** order by avg() on columns of table "auth0_connections" */
export type Auth0ConnectionsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "auth0_connections". All fields are combined with a logical 'AND'. */
export type Auth0ConnectionsBoolExp = {
  _and?: InputMaybe<Array<Auth0ConnectionsBoolExp>>;
  _not?: InputMaybe<Auth0ConnectionsBoolExp>;
  _or?: InputMaybe<Array<Auth0ConnectionsBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
};

/** order by max() on columns of table "auth0_connections" */
export type Auth0ConnectionsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "auth0_connections" */
export type Auth0ConnectionsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "auth0_connections". */
export type Auth0ConnectionsOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
};

/** select columns of table "auth0_connections" */
export const Auth0ConnectionsSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name'
} as const;

export type Auth0ConnectionsSelectColumn = typeof Auth0ConnectionsSelectColumn[keyof typeof Auth0ConnectionsSelectColumn];
/** order by stddev() on columns of table "auth0_connections" */
export type Auth0ConnectionsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "auth0_connections" */
export type Auth0ConnectionsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "auth0_connections" */
export type Auth0ConnectionsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "auth0_connections" */
export type Auth0ConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: Auth0ConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth0ConnectionsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "auth0_connections" */
export type Auth0ConnectionsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "auth0_connections" */
export type Auth0ConnectionsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "auth0_connections" */
export type Auth0ConnectionsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "auth0_connections" */
export type Auth0ConnectionsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "billing_by_destination" */
export type BillingByDestination = {
  __typename?: 'billing_by_destination';
  billing_type?: Maybe<Scalars['String']>;
  is_free_destination?: Maybe<Scalars['Boolean']>;
  is_in_trial?: Maybe<Scalars['Boolean']>;
  is_premium_destination?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['bigint']>;
  trial_expiration_date?: Maybe<Scalars['date']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "billing_by_destination". All fields are combined with a logical 'AND'. */
export type BillingByDestinationBoolExp = {
  _and?: InputMaybe<Array<BillingByDestinationBoolExp>>;
  _not?: InputMaybe<BillingByDestinationBoolExp>;
  _or?: InputMaybe<Array<BillingByDestinationBoolExp>>;
  billing_type?: InputMaybe<StringComparisonExp>;
  is_free_destination?: InputMaybe<BooleanComparisonExp>;
  is_in_trial?: InputMaybe<BooleanComparisonExp>;
  is_premium_destination?: InputMaybe<BooleanComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  trial_expiration_date?: InputMaybe<DateComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "billing_by_destination". */
export type BillingByDestinationOrderBy = {
  billing_type?: InputMaybe<OrderBy>;
  is_free_destination?: InputMaybe<OrderBy>;
  is_in_trial?: InputMaybe<OrderBy>;
  is_premium_destination?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  trial_expiration_date?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "billing_by_destination" */
export const BillingByDestinationSelectColumn = {
  /** column name */
  BillingType: 'billing_type',
  /** column name */
  IsFreeDestination: 'is_free_destination',
  /** column name */
  IsInTrial: 'is_in_trial',
  /** column name */
  IsPremiumDestination: 'is_premium_destination',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  TrialExpirationDate: 'trial_expiration_date',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type BillingByDestinationSelectColumn = typeof BillingByDestinationSelectColumn[keyof typeof BillingByDestinationSelectColumn];
/** Streaming cursor of the table "billing_by_destination" */
export type BillingByDestinationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BillingByDestinationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BillingByDestinationStreamCursorValueInput = {
  billing_type?: InputMaybe<Scalars['String']>;
  is_free_destination?: InputMaybe<Scalars['Boolean']>;
  is_in_trial?: InputMaybe<Scalars['Boolean']>;
  is_premium_destination?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  trial_expiration_date?: InputMaybe<Scalars['date']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "billing_products" */
export type BillingProducts = {
  __typename?: 'billing_products';
  entitlements: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  sku: Scalars['String'];
};


/** columns and relationships of "billing_products" */
export type BillingProductsEntitlementsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "billing_products". All fields are combined with a logical 'AND'. */
export type BillingProductsBoolExp = {
  _and?: InputMaybe<Array<BillingProductsBoolExp>>;
  _not?: InputMaybe<BillingProductsBoolExp>;
  _or?: InputMaybe<Array<BillingProductsBoolExp>>;
  entitlements?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  sku?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "billing_products". */
export type BillingProductsOrderBy = {
  entitlements?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sku?: InputMaybe<OrderBy>;
};

/** select columns of table "billing_products" */
export const BillingProductsSelectColumn = {
  /** column name */
  Entitlements: 'entitlements',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Sku: 'sku'
} as const;

export type BillingProductsSelectColumn = typeof BillingProductsSelectColumn[keyof typeof BillingProductsSelectColumn];
/** Streaming cursor of the table "billing_products" */
export type BillingProductsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BillingProductsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BillingProductsStreamCursorValueInput = {
  entitlements?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "brand_profile_asset_groups" */
export type BrandProfileAssetGroups = {
  __typename?: 'brand_profile_asset_groups';
  /** An object relationship */
  asset_group: AmpAssetGroups;
  asset_group_id: Scalars['uuid'];
  /** An object relationship */
  brand_profile: BrandProfiles;
  brand_profile_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsAggregate = {
  __typename?: 'brand_profile_asset_groups_aggregate';
  aggregate?: Maybe<BrandProfileAssetGroupsAggregateFields>;
  nodes: Array<BrandProfileAssetGroups>;
};

export type BrandProfileAssetGroupsAggregateBoolExp = {
  count?: InputMaybe<BrandProfileAssetGroupsAggregateBoolExpCount>;
};

export type BrandProfileAssetGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsAggregateFields = {
  __typename?: 'brand_profile_asset_groups_aggregate_fields';
  avg?: Maybe<BrandProfileAssetGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BrandProfileAssetGroupsMaxFields>;
  min?: Maybe<BrandProfileAssetGroupsMinFields>;
  stddev?: Maybe<BrandProfileAssetGroupsStddevFields>;
  stddev_pop?: Maybe<BrandProfileAssetGroupsStddevPopFields>;
  stddev_samp?: Maybe<BrandProfileAssetGroupsStddevSampFields>;
  sum?: Maybe<BrandProfileAssetGroupsSumFields>;
  var_pop?: Maybe<BrandProfileAssetGroupsVarPopFields>;
  var_samp?: Maybe<BrandProfileAssetGroupsVarSampFields>;
  variance?: Maybe<BrandProfileAssetGroupsVarianceFields>;
};


/** aggregate fields of "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsAggregateOrderBy = {
  avg?: InputMaybe<BrandProfileAssetGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BrandProfileAssetGroupsMaxOrderBy>;
  min?: InputMaybe<BrandProfileAssetGroupsMinOrderBy>;
  stddev?: InputMaybe<BrandProfileAssetGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<BrandProfileAssetGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BrandProfileAssetGroupsStddevSampOrderBy>;
  sum?: InputMaybe<BrandProfileAssetGroupsSumOrderBy>;
  var_pop?: InputMaybe<BrandProfileAssetGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<BrandProfileAssetGroupsVarSampOrderBy>;
  variance?: InputMaybe<BrandProfileAssetGroupsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type BrandProfileAssetGroupsAvgFields = {
  __typename?: 'brand_profile_asset_groups_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "brand_profile_asset_groups". All fields are combined with a logical 'AND'. */
export type BrandProfileAssetGroupsBoolExp = {
  _and?: InputMaybe<Array<BrandProfileAssetGroupsBoolExp>>;
  _not?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
  _or?: InputMaybe<Array<BrandProfileAssetGroupsBoolExp>>;
  asset_group?: InputMaybe<AmpAssetGroupsBoolExp>;
  asset_group_id?: InputMaybe<UuidComparisonExp>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type BrandProfileAssetGroupsMaxFields = {
  __typename?: 'brand_profile_asset_groups_max_fields';
  asset_group_id?: Maybe<Scalars['uuid']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsMaxOrderBy = {
  asset_group_id?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BrandProfileAssetGroupsMinFields = {
  __typename?: 'brand_profile_asset_groups_min_fields';
  asset_group_id?: Maybe<Scalars['uuid']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsMinOrderBy = {
  asset_group_id?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "brand_profile_asset_groups". */
export type BrandProfileAssetGroupsOrderBy = {
  asset_group?: InputMaybe<AmpAssetGroupsOrderBy>;
  asset_group_id?: InputMaybe<OrderBy>;
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "brand_profile_asset_groups" */
export const BrandProfileAssetGroupsSelectColumn = {
  /** column name */
  AssetGroupId: 'asset_group_id',
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type BrandProfileAssetGroupsSelectColumn = typeof BrandProfileAssetGroupsSelectColumn[keyof typeof BrandProfileAssetGroupsSelectColumn];
/** aggregate stddev on columns */
export type BrandProfileAssetGroupsStddevFields = {
  __typename?: 'brand_profile_asset_groups_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BrandProfileAssetGroupsStddevPopFields = {
  __typename?: 'brand_profile_asset_groups_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BrandProfileAssetGroupsStddevSampFields = {
  __typename?: 'brand_profile_asset_groups_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BrandProfileAssetGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BrandProfileAssetGroupsStreamCursorValueInput = {
  asset_group_id?: InputMaybe<Scalars['uuid']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type BrandProfileAssetGroupsSumFields = {
  __typename?: 'brand_profile_asset_groups_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type BrandProfileAssetGroupsVarPopFields = {
  __typename?: 'brand_profile_asset_groups_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BrandProfileAssetGroupsVarSampFields = {
  __typename?: 'brand_profile_asset_groups_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BrandProfileAssetGroupsVarianceFields = {
  __typename?: 'brand_profile_asset_groups_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "brand_profile_asset_groups" */
export type BrandProfileAssetGroupsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "brand_profile_content_emails" */
export type BrandProfileContentEmails = {
  __typename?: 'brand_profile_content_emails';
  /** An object relationship */
  brand_profile: BrandProfiles;
  brand_profile_id: Scalars['uuid'];
  /** An object relationship */
  content_email: ContentEmails;
  content_email_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "brand_profile_content_emails" */
export type BrandProfileContentEmailsAggregate = {
  __typename?: 'brand_profile_content_emails_aggregate';
  aggregate?: Maybe<BrandProfileContentEmailsAggregateFields>;
  nodes: Array<BrandProfileContentEmails>;
};

export type BrandProfileContentEmailsAggregateBoolExp = {
  count?: InputMaybe<BrandProfileContentEmailsAggregateBoolExpCount>;
};

export type BrandProfileContentEmailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BrandProfileContentEmailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "brand_profile_content_emails" */
export type BrandProfileContentEmailsAggregateFields = {
  __typename?: 'brand_profile_content_emails_aggregate_fields';
  avg?: Maybe<BrandProfileContentEmailsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BrandProfileContentEmailsMaxFields>;
  min?: Maybe<BrandProfileContentEmailsMinFields>;
  stddev?: Maybe<BrandProfileContentEmailsStddevFields>;
  stddev_pop?: Maybe<BrandProfileContentEmailsStddevPopFields>;
  stddev_samp?: Maybe<BrandProfileContentEmailsStddevSampFields>;
  sum?: Maybe<BrandProfileContentEmailsSumFields>;
  var_pop?: Maybe<BrandProfileContentEmailsVarPopFields>;
  var_samp?: Maybe<BrandProfileContentEmailsVarSampFields>;
  variance?: Maybe<BrandProfileContentEmailsVarianceFields>;
};


/** aggregate fields of "brand_profile_content_emails" */
export type BrandProfileContentEmailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsAggregateOrderBy = {
  avg?: InputMaybe<BrandProfileContentEmailsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BrandProfileContentEmailsMaxOrderBy>;
  min?: InputMaybe<BrandProfileContentEmailsMinOrderBy>;
  stddev?: InputMaybe<BrandProfileContentEmailsStddevOrderBy>;
  stddev_pop?: InputMaybe<BrandProfileContentEmailsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BrandProfileContentEmailsStddevSampOrderBy>;
  sum?: InputMaybe<BrandProfileContentEmailsSumOrderBy>;
  var_pop?: InputMaybe<BrandProfileContentEmailsVarPopOrderBy>;
  var_samp?: InputMaybe<BrandProfileContentEmailsVarSampOrderBy>;
  variance?: InputMaybe<BrandProfileContentEmailsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type BrandProfileContentEmailsAvgFields = {
  __typename?: 'brand_profile_content_emails_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "brand_profile_content_emails". All fields are combined with a logical 'AND'. */
export type BrandProfileContentEmailsBoolExp = {
  _and?: InputMaybe<Array<BrandProfileContentEmailsBoolExp>>;
  _not?: InputMaybe<BrandProfileContentEmailsBoolExp>;
  _or?: InputMaybe<Array<BrandProfileContentEmailsBoolExp>>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type BrandProfileContentEmailsMaxFields = {
  __typename?: 'brand_profile_content_emails_max_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsMaxOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BrandProfileContentEmailsMinFields = {
  __typename?: 'brand_profile_content_emails_min_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsMinOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "brand_profile_content_emails". */
export type BrandProfileContentEmailsOrderBy = {
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "brand_profile_content_emails" */
export const BrandProfileContentEmailsSelectColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type BrandProfileContentEmailsSelectColumn = typeof BrandProfileContentEmailsSelectColumn[keyof typeof BrandProfileContentEmailsSelectColumn];
/** aggregate stddev on columns */
export type BrandProfileContentEmailsStddevFields = {
  __typename?: 'brand_profile_content_emails_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BrandProfileContentEmailsStddevPopFields = {
  __typename?: 'brand_profile_content_emails_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BrandProfileContentEmailsStddevSampFields = {
  __typename?: 'brand_profile_content_emails_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "brand_profile_content_emails" */
export type BrandProfileContentEmailsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BrandProfileContentEmailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BrandProfileContentEmailsStreamCursorValueInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type BrandProfileContentEmailsSumFields = {
  __typename?: 'brand_profile_content_emails_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type BrandProfileContentEmailsVarPopFields = {
  __typename?: 'brand_profile_content_emails_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BrandProfileContentEmailsVarSampFields = {
  __typename?: 'brand_profile_content_emails_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BrandProfileContentEmailsVarianceFields = {
  __typename?: 'brand_profile_content_emails_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "brand_profile_content_emails" */
export type BrandProfileContentEmailsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "brand_profile_settings_entities" */
export type BrandProfileSettingsEntities = {
  __typename?: 'brand_profile_settings_entities';
  /** An object relationship */
  brand_profile: BrandProfiles;
  brand_profile_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  settings_entity_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesAggregate = {
  __typename?: 'brand_profile_settings_entities_aggregate';
  aggregate?: Maybe<BrandProfileSettingsEntitiesAggregateFields>;
  nodes: Array<BrandProfileSettingsEntities>;
};

export type BrandProfileSettingsEntitiesAggregateBoolExp = {
  count?: InputMaybe<BrandProfileSettingsEntitiesAggregateBoolExpCount>;
};

export type BrandProfileSettingsEntitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesAggregateFields = {
  __typename?: 'brand_profile_settings_entities_aggregate_fields';
  avg?: Maybe<BrandProfileSettingsEntitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BrandProfileSettingsEntitiesMaxFields>;
  min?: Maybe<BrandProfileSettingsEntitiesMinFields>;
  stddev?: Maybe<BrandProfileSettingsEntitiesStddevFields>;
  stddev_pop?: Maybe<BrandProfileSettingsEntitiesStddevPopFields>;
  stddev_samp?: Maybe<BrandProfileSettingsEntitiesStddevSampFields>;
  sum?: Maybe<BrandProfileSettingsEntitiesSumFields>;
  var_pop?: Maybe<BrandProfileSettingsEntitiesVarPopFields>;
  var_samp?: Maybe<BrandProfileSettingsEntitiesVarSampFields>;
  variance?: Maybe<BrandProfileSettingsEntitiesVarianceFields>;
};


/** aggregate fields of "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesAggregateOrderBy = {
  avg?: InputMaybe<BrandProfileSettingsEntitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BrandProfileSettingsEntitiesMaxOrderBy>;
  min?: InputMaybe<BrandProfileSettingsEntitiesMinOrderBy>;
  stddev?: InputMaybe<BrandProfileSettingsEntitiesStddevOrderBy>;
  stddev_pop?: InputMaybe<BrandProfileSettingsEntitiesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<BrandProfileSettingsEntitiesStddevSampOrderBy>;
  sum?: InputMaybe<BrandProfileSettingsEntitiesSumOrderBy>;
  var_pop?: InputMaybe<BrandProfileSettingsEntitiesVarPopOrderBy>;
  var_samp?: InputMaybe<BrandProfileSettingsEntitiesVarSampOrderBy>;
  variance?: InputMaybe<BrandProfileSettingsEntitiesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type BrandProfileSettingsEntitiesAvgFields = {
  __typename?: 'brand_profile_settings_entities_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "brand_profile_settings_entities". All fields are combined with a logical 'AND'. */
export type BrandProfileSettingsEntitiesBoolExp = {
  _and?: InputMaybe<Array<BrandProfileSettingsEntitiesBoolExp>>;
  _not?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
  _or?: InputMaybe<Array<BrandProfileSettingsEntitiesBoolExp>>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  settings_entity_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type BrandProfileSettingsEntitiesMaxFields = {
  __typename?: 'brand_profile_settings_entities_max_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesMaxOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BrandProfileSettingsEntitiesMinFields = {
  __typename?: 'brand_profile_settings_entities_min_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  settings_entity_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesMinOrderBy = {
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "brand_profile_settings_entities". */
export type BrandProfileSettingsEntitiesOrderBy = {
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  settings_entity_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "brand_profile_settings_entities" */
export const BrandProfileSettingsEntitiesSelectColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  SettingsEntityId: 'settings_entity_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type BrandProfileSettingsEntitiesSelectColumn = typeof BrandProfileSettingsEntitiesSelectColumn[keyof typeof BrandProfileSettingsEntitiesSelectColumn];
/** aggregate stddev on columns */
export type BrandProfileSettingsEntitiesStddevFields = {
  __typename?: 'brand_profile_settings_entities_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type BrandProfileSettingsEntitiesStddevPopFields = {
  __typename?: 'brand_profile_settings_entities_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type BrandProfileSettingsEntitiesStddevSampFields = {
  __typename?: 'brand_profile_settings_entities_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BrandProfileSettingsEntitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BrandProfileSettingsEntitiesStreamCursorValueInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  settings_entity_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type BrandProfileSettingsEntitiesSumFields = {
  __typename?: 'brand_profile_settings_entities_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type BrandProfileSettingsEntitiesVarPopFields = {
  __typename?: 'brand_profile_settings_entities_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type BrandProfileSettingsEntitiesVarSampFields = {
  __typename?: 'brand_profile_settings_entities_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BrandProfileSettingsEntitiesVarianceFields = {
  __typename?: 'brand_profile_settings_entities_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "brand_profile_settings_entities" */
export type BrandProfileSettingsEntitiesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "brand_profiles" */
export type BrandProfiles = {
  __typename?: 'brand_profiles';
  /** An array relationship */
  ad_studio_projects: Array<AdStudioProjects>;
  /** An aggregate relationship */
  ad_studio_projects_aggregate: AdStudioProjectsAggregate;
  ai_disclosure_defaults?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  asset_group_assignments: Array<BrandProfileAssetGroups>;
  /** An aggregate relationship */
  asset_group_assignments_aggregate: BrandProfileAssetGroupsAggregate;
  brand_guidelines?: Maybe<Scalars['String']>;
  brand_guidelines_source_file?: Maybe<Scalars['jsonb']>;
  business_context?: Maybe<Scalars['String']>;
  colors: Scalars['jsonb'];
  company_information: Scalars['jsonb'];
  /** An array relationship */
  content_email_assignments: Array<BrandProfileContentEmails>;
  /** An aggregate relationship */
  content_email_assignments_aggregate: BrandProfileContentEmailsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  default_assignment_source?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  email_style_configuration?: Maybe<Scalars['jsonb']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  fonts: Scalars['jsonb'];
  id: Scalars['uuid'];
  image_guardrails: Scalars['jsonb'];
  is_default: Scalars['Boolean'];
  logos: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  settings_entity_assignments: Array<BrandProfileSettingsEntities>;
  /** An aggregate relationship */
  settings_entity_assignments_aggregate: BrandProfileSettingsEntitiesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesAdStudioProjectsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesAdStudioProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesAiDisclosureDefaultsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesAssetGroupAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesAssetGroupAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesBrandGuidelinesSourceFileArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesColorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesCompanyInformationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesContentEmailAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesContentEmailAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesEmailStyleConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesFontsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesImageGuardrailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesLogosArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesSettingsEntityAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


/** columns and relationships of "brand_profiles" */
export type BrandProfilesSettingsEntityAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};

/** aggregated selection of "brand_profiles" */
export type BrandProfilesAggregate = {
  __typename?: 'brand_profiles_aggregate';
  aggregate?: Maybe<BrandProfilesAggregateFields>;
  nodes: Array<BrandProfiles>;
};

/** aggregate fields of "brand_profiles" */
export type BrandProfilesAggregateFields = {
  __typename?: 'brand_profiles_aggregate_fields';
  avg?: Maybe<BrandProfilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BrandProfilesMaxFields>;
  min?: Maybe<BrandProfilesMinFields>;
  stddev?: Maybe<BrandProfilesStddevFields>;
  stddev_pop?: Maybe<BrandProfilesStddevPopFields>;
  stddev_samp?: Maybe<BrandProfilesStddevSampFields>;
  sum?: Maybe<BrandProfilesSumFields>;
  var_pop?: Maybe<BrandProfilesVarPopFields>;
  var_samp?: Maybe<BrandProfilesVarSampFields>;
  variance?: Maybe<BrandProfilesVarianceFields>;
};


/** aggregate fields of "brand_profiles" */
export type BrandProfilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BrandProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BrandProfilesAppendInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['jsonb']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['jsonb']>;
  colors?: InputMaybe<Scalars['jsonb']>;
  company_information?: InputMaybe<Scalars['jsonb']>;
  email_style_configuration?: InputMaybe<Scalars['jsonb']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  logos?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type BrandProfilesAvgFields = {
  __typename?: 'brand_profiles_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "brand_profiles". All fields are combined with a logical 'AND'. */
export type BrandProfilesBoolExp = {
  _and?: InputMaybe<Array<BrandProfilesBoolExp>>;
  _not?: InputMaybe<BrandProfilesBoolExp>;
  _or?: InputMaybe<Array<BrandProfilesBoolExp>>;
  ad_studio_projects?: InputMaybe<AdStudioProjectsBoolExp>;
  ad_studio_projects_aggregate?: InputMaybe<AdStudioProjectsAggregateBoolExp>;
  ai_disclosure_defaults?: InputMaybe<JsonbComparisonExp>;
  asset_group_assignments?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
  asset_group_assignments_aggregate?: InputMaybe<BrandProfileAssetGroupsAggregateBoolExp>;
  brand_guidelines?: InputMaybe<StringComparisonExp>;
  brand_guidelines_source_file?: InputMaybe<JsonbComparisonExp>;
  business_context?: InputMaybe<StringComparisonExp>;
  colors?: InputMaybe<JsonbComparisonExp>;
  company_information?: InputMaybe<JsonbComparisonExp>;
  content_email_assignments?: InputMaybe<BrandProfileContentEmailsBoolExp>;
  content_email_assignments_aggregate?: InputMaybe<BrandProfileContentEmailsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  default_assignment_source?: InputMaybe<StringComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  email_style_configuration?: InputMaybe<JsonbComparisonExp>;
  esp_destination_id?: InputMaybe<BigintComparisonExp>;
  esp_target_kind?: InputMaybe<StringComparisonExp>;
  fonts?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image_guardrails?: InputMaybe<JsonbComparisonExp>;
  is_default?: InputMaybe<BooleanComparisonExp>;
  logos?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  settings_entity_assignments?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
  settings_entity_assignments_aggregate?: InputMaybe<BrandProfileSettingsEntitiesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "brand_profiles" */
export const BrandProfilesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  BrandProfilesIdWorkspaceIdKey: 'brand_profiles_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  BrandProfilesPkey: 'brand_profiles_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  BrandProfilesWorkspaceDefaultUnique: 'brand_profiles_workspace_default_unique',
  /** unique or primary key constraint on columns "workspace_id" */
  BrandProfilesWorkspaceNameUnique: 'brand_profiles_workspace_name_unique'
} as const;

export type BrandProfilesConstraint = typeof BrandProfilesConstraint[keyof typeof BrandProfilesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BrandProfilesDeleteAtPathInput = {
  ai_disclosure_defaults?: InputMaybe<Array<Scalars['String']>>;
  brand_guidelines_source_file?: InputMaybe<Array<Scalars['String']>>;
  colors?: InputMaybe<Array<Scalars['String']>>;
  company_information?: InputMaybe<Array<Scalars['String']>>;
  email_style_configuration?: InputMaybe<Array<Scalars['String']>>;
  fonts?: InputMaybe<Array<Scalars['String']>>;
  image_guardrails?: InputMaybe<Array<Scalars['String']>>;
  logos?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BrandProfilesDeleteElemInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['Int']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['Int']>;
  colors?: InputMaybe<Scalars['Int']>;
  company_information?: InputMaybe<Scalars['Int']>;
  email_style_configuration?: InputMaybe<Scalars['Int']>;
  fonts?: InputMaybe<Scalars['Int']>;
  image_guardrails?: InputMaybe<Scalars['Int']>;
  logos?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BrandProfilesDeleteKeyInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['String']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Scalars['String']>;
  company_information?: InputMaybe<Scalars['String']>;
  email_style_configuration?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Scalars['String']>;
  image_guardrails?: InputMaybe<Scalars['String']>;
  logos?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "brand_profiles" */
export type BrandProfilesInsertInput = {
  ad_studio_projects?: InputMaybe<AdStudioProjectsArrRelInsertInput>;
  ai_disclosure_defaults?: InputMaybe<Scalars['jsonb']>;
  brand_guidelines?: InputMaybe<Scalars['String']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['jsonb']>;
  business_context?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Scalars['jsonb']>;
  company_information?: InputMaybe<Scalars['jsonb']>;
  email_style_configuration?: InputMaybe<Scalars['jsonb']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  logos?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BrandProfilesMaxFields = {
  __typename?: 'brand_profiles_max_fields';
  brand_guidelines?: Maybe<Scalars['String']>;
  business_context?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type BrandProfilesMinFields = {
  __typename?: 'brand_profiles_min_fields';
  brand_guidelines?: Maybe<Scalars['String']>;
  business_context?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "brand_profiles" */
export type BrandProfilesMutationResponse = {
  __typename?: 'brand_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BrandProfiles>;
};

/** input type for inserting object relation for remote table "brand_profiles" */
export type BrandProfilesObjRelInsertInput = {
  data: BrandProfilesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BrandProfilesOnConflict>;
};

/** on_conflict condition type for table "brand_profiles" */
export type BrandProfilesOnConflict = {
  constraint: BrandProfilesConstraint;
  update_columns?: Array<BrandProfilesUpdateColumn>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};

/** Ordering options when selecting data from "brand_profiles". */
export type BrandProfilesOrderBy = {
  ad_studio_projects_aggregate?: InputMaybe<AdStudioProjectsAggregateOrderBy>;
  ai_disclosure_defaults?: InputMaybe<OrderBy>;
  asset_group_assignments_aggregate?: InputMaybe<BrandProfileAssetGroupsAggregateOrderBy>;
  brand_guidelines?: InputMaybe<OrderBy>;
  brand_guidelines_source_file?: InputMaybe<OrderBy>;
  business_context?: InputMaybe<OrderBy>;
  colors?: InputMaybe<OrderBy>;
  company_information?: InputMaybe<OrderBy>;
  content_email_assignments_aggregate?: InputMaybe<BrandProfileContentEmailsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  default_assignment_source?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  email_style_configuration?: InputMaybe<OrderBy>;
  esp_destination_id?: InputMaybe<OrderBy>;
  esp_target_kind?: InputMaybe<OrderBy>;
  fonts?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image_guardrails?: InputMaybe<OrderBy>;
  is_default?: InputMaybe<OrderBy>;
  logos?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  settings_entity_assignments_aggregate?: InputMaybe<BrandProfileSettingsEntitiesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: brand_profiles */
export type BrandProfilesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BrandProfilesPrependInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['jsonb']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['jsonb']>;
  colors?: InputMaybe<Scalars['jsonb']>;
  company_information?: InputMaybe<Scalars['jsonb']>;
  email_style_configuration?: InputMaybe<Scalars['jsonb']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  logos?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "brand_profiles" */
export const BrandProfilesSelectColumn = {
  /** column name */
  AiDisclosureDefaults: 'ai_disclosure_defaults',
  /** column name */
  BrandGuidelines: 'brand_guidelines',
  /** column name */
  BrandGuidelinesSourceFile: 'brand_guidelines_source_file',
  /** column name */
  BusinessContext: 'business_context',
  /** column name */
  Colors: 'colors',
  /** column name */
  CompanyInformation: 'company_information',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DefaultAssignmentSource: 'default_assignment_source',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  EmailStyleConfiguration: 'email_style_configuration',
  /** column name */
  EspDestinationId: 'esp_destination_id',
  /** column name */
  EspTargetKind: 'esp_target_kind',
  /** column name */
  Fonts: 'fonts',
  /** column name */
  Id: 'id',
  /** column name */
  ImageGuardrails: 'image_guardrails',
  /** column name */
  IsDefault: 'is_default',
  /** column name */
  Logos: 'logos',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type BrandProfilesSelectColumn = typeof BrandProfilesSelectColumn[keyof typeof BrandProfilesSelectColumn];
/** input type for updating data in table "brand_profiles" */
export type BrandProfilesSetInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['jsonb']>;
  brand_guidelines?: InputMaybe<Scalars['String']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['jsonb']>;
  business_context?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Scalars['jsonb']>;
  company_information?: InputMaybe<Scalars['jsonb']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  email_style_configuration?: InputMaybe<Scalars['jsonb']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  logos?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BrandProfilesStddevFields = {
  __typename?: 'brand_profiles_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BrandProfilesStddevPopFields = {
  __typename?: 'brand_profiles_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BrandProfilesStddevSampFields = {
  __typename?: 'brand_profiles_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "brand_profiles" */
export type BrandProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BrandProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BrandProfilesStreamCursorValueInput = {
  ai_disclosure_defaults?: InputMaybe<Scalars['jsonb']>;
  brand_guidelines?: InputMaybe<Scalars['String']>;
  brand_guidelines_source_file?: InputMaybe<Scalars['jsonb']>;
  business_context?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Scalars['jsonb']>;
  company_information?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  default_assignment_source?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  email_style_configuration?: InputMaybe<Scalars['jsonb']>;
  esp_destination_id?: InputMaybe<Scalars['bigint']>;
  esp_target_kind?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_guardrails?: InputMaybe<Scalars['jsonb']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  logos?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type BrandProfilesSumFields = {
  __typename?: 'brand_profiles_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "brand_profiles" */
export const BrandProfilesUpdateColumn = {
  /** column name */
  AiDisclosureDefaults: 'ai_disclosure_defaults',
  /** column name */
  BrandGuidelines: 'brand_guidelines',
  /** column name */
  BrandGuidelinesSourceFile: 'brand_guidelines_source_file',
  /** column name */
  BusinessContext: 'business_context',
  /** column name */
  Colors: 'colors',
  /** column name */
  CompanyInformation: 'company_information',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  EmailStyleConfiguration: 'email_style_configuration',
  /** column name */
  Fonts: 'fonts',
  /** column name */
  ImageGuardrails: 'image_guardrails',
  /** column name */
  IsDefault: 'is_default',
  /** column name */
  Logos: 'logos',
  /** column name */
  Name: 'name'
} as const;

export type BrandProfilesUpdateColumn = typeof BrandProfilesUpdateColumn[keyof typeof BrandProfilesUpdateColumn];
export type BrandProfilesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BrandProfilesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BrandProfilesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BrandProfilesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BrandProfilesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BrandProfilesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BrandProfilesSetInput>;
  /** filter the rows which have to be updated */
  where: BrandProfilesBoolExp;
};

/** aggregate var_pop on columns */
export type BrandProfilesVarPopFields = {
  __typename?: 'brand_profiles_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BrandProfilesVarSampFields = {
  __typename?: 'brand_profiles_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BrandProfilesVarianceFields = {
  __typename?: 'brand_profiles_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cached_event_pulls" */
export type CachedEventPulls = {
  __typename?: 'cached_event_pulls';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  last_watermark?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  predictor_feature_definition_events: Array<PredictorFeatureDefinitionEvents>;
  /** An array relationship */
  predictor_outcomes: Array<PredictorOutcomes>;
  /** An array relationship */
  predictor_runs: Array<PredictorRuns>;
  /** An aggregate relationship */
  predictor_runs_aggregate: PredictorRunsAggregate;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "cached_event_pulls" */
export type CachedEventPullsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cached_event_pulls" */
export type CachedEventPullsPredictorFeatureDefinitionEventsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionEventsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
};


/** columns and relationships of "cached_event_pulls" */
export type CachedEventPullsPredictorOutcomesArgs = {
  distinct_on?: InputMaybe<Array<PredictorOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorOutcomesOrderBy>>;
  where?: InputMaybe<PredictorOutcomesBoolExp>;
};


/** columns and relationships of "cached_event_pulls" */
export type CachedEventPullsPredictorRunsArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


/** columns and relationships of "cached_event_pulls" */
export type CachedEventPullsPredictorRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};

/** Boolean expression to filter rows from the table "cached_event_pulls". All fields are combined with a logical 'AND'. */
export type CachedEventPullsBoolExp = {
  _and?: InputMaybe<Array<CachedEventPullsBoolExp>>;
  _not?: InputMaybe<CachedEventPullsBoolExp>;
  _or?: InputMaybe<Array<CachedEventPullsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_watermark?: InputMaybe<TimestamptzComparisonExp>;
  predictor_feature_definition_events?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
  predictor_outcomes?: InputMaybe<PredictorOutcomesBoolExp>;
  predictor_runs?: InputMaybe<PredictorRunsBoolExp>;
  predictor_runs_aggregate?: InputMaybe<PredictorRunsAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "cached_event_pulls". */
export type CachedEventPullsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_watermark?: InputMaybe<OrderBy>;
  predictor_feature_definition_events_aggregate?: InputMaybe<PredictorFeatureDefinitionEventsAggregateOrderBy>;
  predictor_outcomes_aggregate?: InputMaybe<PredictorOutcomesAggregateOrderBy>;
  predictor_runs_aggregate?: InputMaybe<PredictorRunsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cached_event_pulls" */
export const CachedEventPullsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  LastWatermark: 'last_watermark',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CachedEventPullsSelectColumn = typeof CachedEventPullsSelectColumn[keyof typeof CachedEventPullsSelectColumn];
/** Streaming cursor of the table "cached_event_pulls" */
export type CachedEventPullsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CachedEventPullsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CachedEventPullsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_watermark?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRuns = {
  __typename?: 'campaign_artifact_version_best_practice_runs';
  applied_to_artifact_version_id?: Maybe<Scalars['uuid']>;
  artifact_id: Scalars['uuid'];
  artifact_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  input?: Maybe<Scalars['jsonb']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  output?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsInputArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsOutputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsAggregate = {
  __typename?: 'campaign_artifact_version_best_practice_runs_aggregate';
  aggregate?: Maybe<CampaignArtifactVersionBestPracticeRunsAggregateFields>;
  nodes: Array<CampaignArtifactVersionBestPracticeRuns>;
};

/** aggregate fields of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsAggregateFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_aggregate_fields';
  avg?: Maybe<CampaignArtifactVersionBestPracticeRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignArtifactVersionBestPracticeRunsMaxFields>;
  min?: Maybe<CampaignArtifactVersionBestPracticeRunsMinFields>;
  stddev?: Maybe<CampaignArtifactVersionBestPracticeRunsStddevFields>;
  stddev_pop?: Maybe<CampaignArtifactVersionBestPracticeRunsStddevPopFields>;
  stddev_samp?: Maybe<CampaignArtifactVersionBestPracticeRunsStddevSampFields>;
  sum?: Maybe<CampaignArtifactVersionBestPracticeRunsSumFields>;
  var_pop?: Maybe<CampaignArtifactVersionBestPracticeRunsVarPopFields>;
  var_samp?: Maybe<CampaignArtifactVersionBestPracticeRunsVarSampFields>;
  variance?: Maybe<CampaignArtifactVersionBestPracticeRunsVarianceFields>;
};


/** aggregate fields of "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CampaignArtifactVersionBestPracticeRunsAvgFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "campaign_artifact_version_best_practice_runs". All fields are combined with a logical 'AND'. */
export type CampaignArtifactVersionBestPracticeRunsBoolExp = {
  _and?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsBoolExp>>;
  _not?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
  _or?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsBoolExp>>;
  applied_to_artifact_version_id?: InputMaybe<UuidComparisonExp>;
  artifact_id?: InputMaybe<UuidComparisonExp>;
  artifact_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  input?: InputMaybe<JsonbComparisonExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  output?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CampaignArtifactVersionBestPracticeRunsMaxFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_max_fields';
  applied_to_artifact_version_id?: Maybe<Scalars['uuid']>;
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CampaignArtifactVersionBestPracticeRunsMinFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_min_fields';
  applied_to_artifact_version_id?: Maybe<Scalars['uuid']>;
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "campaign_artifact_version_best_practice_runs". */
export type CampaignArtifactVersionBestPracticeRunsOrderBy = {
  applied_to_artifact_version_id?: InputMaybe<OrderBy>;
  artifact_id?: InputMaybe<OrderBy>;
  artifact_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  output?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "campaign_artifact_version_best_practice_runs" */
export const CampaignArtifactVersionBestPracticeRunsSelectColumn = {
  /** column name */
  AppliedToArtifactVersionId: 'applied_to_artifact_version_id',
  /** column name */
  ArtifactId: 'artifact_id',
  /** column name */
  ArtifactVersionId: 'artifact_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Input: 'input',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Output: 'output',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignArtifactVersionBestPracticeRunsSelectColumn = typeof CampaignArtifactVersionBestPracticeRunsSelectColumn[keyof typeof CampaignArtifactVersionBestPracticeRunsSelectColumn];
/** aggregate stddev on columns */
export type CampaignArtifactVersionBestPracticeRunsStddevFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CampaignArtifactVersionBestPracticeRunsStddevPopFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CampaignArtifactVersionBestPracticeRunsStddevSampFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "campaign_artifact_version_best_practice_runs" */
export type CampaignArtifactVersionBestPracticeRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignArtifactVersionBestPracticeRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignArtifactVersionBestPracticeRunsStreamCursorValueInput = {
  applied_to_artifact_version_id?: InputMaybe<Scalars['uuid']>;
  artifact_id?: InputMaybe<Scalars['uuid']>;
  artifact_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  input?: InputMaybe<Scalars['jsonb']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  output?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignArtifactVersionBestPracticeRunsSumFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CampaignArtifactVersionBestPracticeRunsVarPopFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CampaignArtifactVersionBestPracticeRunsVarSampFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CampaignArtifactVersionBestPracticeRunsVarianceFields = {
  __typename?: 'campaign_artifact_version_best_practice_runs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "campaign_artifact_versions" */
export type CampaignArtifactVersions = {
  __typename?: 'campaign_artifact_versions';
  /** An object relationship */
  artifact: CampaignArtifacts;
  artifact_id: Scalars['uuid'];
  content?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  s3_key?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


/** columns and relationships of "campaign_artifact_versions" */
export type CampaignArtifactVersionsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "campaign_artifact_versions" */
export type CampaignArtifactVersionsAggregate = {
  __typename?: 'campaign_artifact_versions_aggregate';
  aggregate?: Maybe<CampaignArtifactVersionsAggregateFields>;
  nodes: Array<CampaignArtifactVersions>;
};

export type CampaignArtifactVersionsAggregateBoolExp = {
  count?: InputMaybe<CampaignArtifactVersionsAggregateBoolExpCount>;
};

export type CampaignArtifactVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaign_artifact_versions" */
export type CampaignArtifactVersionsAggregateFields = {
  __typename?: 'campaign_artifact_versions_aggregate_fields';
  avg?: Maybe<CampaignArtifactVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignArtifactVersionsMaxFields>;
  min?: Maybe<CampaignArtifactVersionsMinFields>;
  stddev?: Maybe<CampaignArtifactVersionsStddevFields>;
  stddev_pop?: Maybe<CampaignArtifactVersionsStddevPopFields>;
  stddev_samp?: Maybe<CampaignArtifactVersionsStddevSampFields>;
  sum?: Maybe<CampaignArtifactVersionsSumFields>;
  var_pop?: Maybe<CampaignArtifactVersionsVarPopFields>;
  var_samp?: Maybe<CampaignArtifactVersionsVarSampFields>;
  variance?: Maybe<CampaignArtifactVersionsVarianceFields>;
};


/** aggregate fields of "campaign_artifact_versions" */
export type CampaignArtifactVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsAggregateOrderBy = {
  avg?: InputMaybe<CampaignArtifactVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignArtifactVersionsMaxOrderBy>;
  min?: InputMaybe<CampaignArtifactVersionsMinOrderBy>;
  stddev?: InputMaybe<CampaignArtifactVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignArtifactVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignArtifactVersionsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignArtifactVersionsSumOrderBy>;
  var_pop?: InputMaybe<CampaignArtifactVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignArtifactVersionsVarSampOrderBy>;
  variance?: InputMaybe<CampaignArtifactVersionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CampaignArtifactVersionsAvgFields = {
  __typename?: 'campaign_artifact_versions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaign_artifact_versions". All fields are combined with a logical 'AND'. */
export type CampaignArtifactVersionsBoolExp = {
  _and?: InputMaybe<Array<CampaignArtifactVersionsBoolExp>>;
  _not?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  _or?: InputMaybe<Array<CampaignArtifactVersionsBoolExp>>;
  artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  artifact_id?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_interaction_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  s3_key?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** aggregate max on columns */
export type CampaignArtifactVersionsMaxFields = {
  __typename?: 'campaign_artifact_versions_max_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  s3_key?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsMaxOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3_key?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignArtifactVersionsMinFields = {
  __typename?: 'campaign_artifact_versions_min_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_interaction_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  s3_key?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsMinOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3_key?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "campaign_artifact_versions". */
export type CampaignArtifactVersionsOrderBy = {
  artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  artifact_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_interaction_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  s3_key?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** select columns of table "campaign_artifact_versions" */
export const CampaignArtifactVersionsSelectColumn = {
  /** column name */
  ArtifactId: 'artifact_id',
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreatedByInteractionId: 'created_by_interaction_id',
  /** column name */
  Id: 'id',
  /** column name */
  S3Key: 's3_key',
  /** column name */
  Version: 'version'
} as const;

export type CampaignArtifactVersionsSelectColumn = typeof CampaignArtifactVersionsSelectColumn[keyof typeof CampaignArtifactVersionsSelectColumn];
/** aggregate stddev on columns */
export type CampaignArtifactVersionsStddevFields = {
  __typename?: 'campaign_artifact_versions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignArtifactVersionsStddevPopFields = {
  __typename?: 'campaign_artifact_versions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignArtifactVersionsStddevSampFields = {
  __typename?: 'campaign_artifact_versions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaign_artifact_versions" */
export type CampaignArtifactVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignArtifactVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignArtifactVersionsStreamCursorValueInput = {
  artifact_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  created_by_interaction_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  s3_key?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CampaignArtifactVersionsSumFields = {
  __typename?: 'campaign_artifact_versions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CampaignArtifactVersionsVarPopFields = {
  __typename?: 'campaign_artifact_versions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignArtifactVersionsVarSampFields = {
  __typename?: 'campaign_artifact_versions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignArtifactVersionsVarianceFields = {
  __typename?: 'campaign_artifact_versions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaign_artifact_versions" */
export type CampaignArtifactVersionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifacts = {
  __typename?: 'campaign_artifacts';
  artifact_type: Scalars['String'];
  /** An object relationship */
  campaign?: Maybe<MarketingCampaigns>;
  campaign_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  content_emails: Array<ContentEmails>;
  /** An aggregate relationship */
  content_emails_aggregate: ContentEmailsAggregate;
  created_at: Scalars['timestamptz'];
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  current_version: Scalars['Int'];
  description: Scalars['String'];
  filename: Scalars['String'];
  /** An object relationship */
  folder?: Maybe<Folders>;
  folder_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  is_private: Scalars['Boolean'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  metadata: Scalars['jsonb'];
  /** An array relationship */
  my_favorites: Array<ArtifactFavorites>;
  /** An aggregate relationship */
  my_favorites_aggregate: ArtifactFavoritesAggregate;
  /** An array relationship */
  reviews: Array<ArtifactReviews>;
  /** An aggregate relationship */
  reviews_aggregate: ArtifactReviewsAggregate;
  saved_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  versions: Array<CampaignArtifactVersions>;
  /** An aggregate relationship */
  versions_aggregate: CampaignArtifactVersionsAggregate;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsContentEmailsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsContentEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsMyFavoritesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsMyFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsReviewsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsVersionsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


/** columns and relationships of "campaign_artifacts" */
export type CampaignArtifactsVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};

/** aggregated selection of "campaign_artifacts" */
export type CampaignArtifactsAggregate = {
  __typename?: 'campaign_artifacts_aggregate';
  aggregate?: Maybe<CampaignArtifactsAggregateFields>;
  nodes: Array<CampaignArtifacts>;
};

export type CampaignArtifactsAggregateBoolExp = {
  bool_and?: InputMaybe<CampaignArtifactsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CampaignArtifactsAggregateBoolExpBoolOr>;
  count?: InputMaybe<CampaignArtifactsAggregateBoolExpCount>;
};

export type CampaignArtifactsAggregateBoolExpBoolAnd = {
  arguments: CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignArtifactsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CampaignArtifactsAggregateBoolExpBoolOr = {
  arguments: CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignArtifactsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CampaignArtifactsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignArtifactsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaign_artifacts" */
export type CampaignArtifactsAggregateFields = {
  __typename?: 'campaign_artifacts_aggregate_fields';
  avg?: Maybe<CampaignArtifactsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignArtifactsMaxFields>;
  min?: Maybe<CampaignArtifactsMinFields>;
  stddev?: Maybe<CampaignArtifactsStddevFields>;
  stddev_pop?: Maybe<CampaignArtifactsStddevPopFields>;
  stddev_samp?: Maybe<CampaignArtifactsStddevSampFields>;
  sum?: Maybe<CampaignArtifactsSumFields>;
  var_pop?: Maybe<CampaignArtifactsVarPopFields>;
  var_samp?: Maybe<CampaignArtifactsVarSampFields>;
  variance?: Maybe<CampaignArtifactsVarianceFields>;
};


/** aggregate fields of "campaign_artifacts" */
export type CampaignArtifactsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaign_artifacts" */
export type CampaignArtifactsAggregateOrderBy = {
  avg?: InputMaybe<CampaignArtifactsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignArtifactsMaxOrderBy>;
  min?: InputMaybe<CampaignArtifactsMinOrderBy>;
  stddev?: InputMaybe<CampaignArtifactsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignArtifactsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignArtifactsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignArtifactsSumOrderBy>;
  var_pop?: InputMaybe<CampaignArtifactsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignArtifactsVarSampOrderBy>;
  variance?: InputMaybe<CampaignArtifactsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CampaignArtifactsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CampaignArtifactsAvgFields = {
  __typename?: 'campaign_artifacts_avg_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaign_artifacts" */
export type CampaignArtifactsAvgOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaign_artifacts". All fields are combined with a logical 'AND'. */
export type CampaignArtifactsBoolExp = {
  _and?: InputMaybe<Array<CampaignArtifactsBoolExp>>;
  _not?: InputMaybe<CampaignArtifactsBoolExp>;
  _or?: InputMaybe<Array<CampaignArtifactsBoolExp>>;
  artifact_type?: InputMaybe<StringComparisonExp>;
  campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  content_emails?: InputMaybe<ContentEmailsBoolExp>;
  content_emails_aggregate?: InputMaybe<ContentEmailsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  current_version?: InputMaybe<IntComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  filename?: InputMaybe<StringComparisonExp>;
  folder?: InputMaybe<FoldersBoolExp>;
  folder_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_private?: InputMaybe<BooleanComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  my_favorites?: InputMaybe<ArtifactFavoritesBoolExp>;
  my_favorites_aggregate?: InputMaybe<ArtifactFavoritesAggregateBoolExp>;
  reviews?: InputMaybe<ArtifactReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<ArtifactReviewsAggregateBoolExp>;
  saved_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  versions?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  versions_aggregate?: InputMaybe<CampaignArtifactVersionsAggregateBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "campaign_artifacts" */
export const CampaignArtifactsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CampaignArtifactsIdWorkspaceIdKey: 'campaign_artifacts_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CampaignArtifactsPkey: 'campaign_artifacts_pkey',
  /** unique or primary key constraint on columns "workspace_id", "filename", "campaign_id" */
  CampaignArtifactsWorkspaceCampaignFilenameKey: 'campaign_artifacts_workspace_campaign_filename_key'
} as const;

export type CampaignArtifactsConstraint = typeof CampaignArtifactsConstraint[keyof typeof CampaignArtifactsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CampaignArtifactsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CampaignArtifactsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CampaignArtifactsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "campaign_artifacts" */
export type CampaignArtifactsIncInput = {
  current_version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "campaign_artifacts" */
export type CampaignArtifactsInsertInput = {
  artifact_type?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_by_llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<FoldersObjRelInsertInput>;
  my_favorites?: InputMaybe<ArtifactFavoritesArrRelInsertInput>;
  reviews?: InputMaybe<ArtifactReviewsArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CampaignArtifactsMaxFields = {
  __typename?: 'campaign_artifacts_max_fields';
  artifact_type?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  current_version?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "campaign_artifacts" */
export type CampaignArtifactsMaxOrderBy = {
  artifact_type?: InputMaybe<OrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_session_id?: InputMaybe<OrderBy>;
  current_version?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  filename?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignArtifactsMinFields = {
  __typename?: 'campaign_artifacts_min_fields';
  artifact_type?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  current_version?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "campaign_artifacts" */
export type CampaignArtifactsMinOrderBy = {
  artifact_type?: InputMaybe<OrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_session_id?: InputMaybe<OrderBy>;
  current_version?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  filename?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "campaign_artifacts" */
export type CampaignArtifactsMutationResponse = {
  __typename?: 'campaign_artifacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CampaignArtifacts>;
};

/** input type for inserting object relation for remote table "campaign_artifacts" */
export type CampaignArtifactsObjRelInsertInput = {
  data: CampaignArtifactsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CampaignArtifactsOnConflict>;
};

/** on_conflict condition type for table "campaign_artifacts" */
export type CampaignArtifactsOnConflict = {
  constraint: CampaignArtifactsConstraint;
  update_columns?: Array<CampaignArtifactsUpdateColumn>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};

/** Ordering options when selecting data from "campaign_artifacts". */
export type CampaignArtifactsOrderBy = {
  artifact_type?: InputMaybe<OrderBy>;
  campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  content_emails_aggregate?: InputMaybe<ContentEmailsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_llm_chat_session_id?: InputMaybe<OrderBy>;
  current_version?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  filename?: InputMaybe<OrderBy>;
  folder?: InputMaybe<FoldersOrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_private?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  metadata?: InputMaybe<OrderBy>;
  my_favorites_aggregate?: InputMaybe<ArtifactFavoritesAggregateOrderBy>;
  reviews_aggregate?: InputMaybe<ArtifactReviewsAggregateOrderBy>;
  saved_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  versions_aggregate?: InputMaybe<CampaignArtifactVersionsAggregateOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: campaign_artifacts */
export type CampaignArtifactsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CampaignArtifactsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "campaign_artifacts" */
export const CampaignArtifactsSelectColumn = {
  /** column name */
  ArtifactType: 'artifact_type',
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByLlmChatSessionId: 'created_by_llm_chat_session_id',
  /** column name */
  CurrentVersion: 'current_version',
  /** column name */
  Description: 'description',
  /** column name */
  Filename: 'filename',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  Id: 'id',
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  SavedAt: 'saved_at',
  /** column name */
  Status: 'status',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignArtifactsSelectColumn = typeof CampaignArtifactsSelectColumn[keyof typeof CampaignArtifactsSelectColumn];
/** select "campaign_artifacts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "campaign_artifacts" */
export const CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsPrivate: 'is_private'
} as const;

export type CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolAndArgumentsColumns = typeof CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolAndArgumentsColumns];
/** select "campaign_artifacts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "campaign_artifacts" */
export const CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsPrivate: 'is_private'
} as const;

export type CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolOrArgumentsColumns = typeof CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof CampaignArtifactsSelectColumnCampaignArtifactsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "campaign_artifacts" */
export type CampaignArtifactsSetInput = {
  current_version?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  saved_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CampaignArtifactsStddevFields = {
  __typename?: 'campaign_artifacts_stddev_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaign_artifacts" */
export type CampaignArtifactsStddevOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignArtifactsStddevPopFields = {
  __typename?: 'campaign_artifacts_stddev_pop_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaign_artifacts" */
export type CampaignArtifactsStddevPopOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignArtifactsStddevSampFields = {
  __typename?: 'campaign_artifacts_stddev_samp_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaign_artifacts" */
export type CampaignArtifactsStddevSampOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaign_artifacts" */
export type CampaignArtifactsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignArtifactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignArtifactsStreamCursorValueInput = {
  artifact_type?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  current_version?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  saved_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignArtifactsSumFields = {
  __typename?: 'campaign_artifacts_sum_fields';
  current_version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "campaign_artifacts" */
export type CampaignArtifactsSumOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "campaign_artifacts" */
export const CampaignArtifactsUpdateColumn = {
  /** column name */
  CurrentVersion: 'current_version',
  /** column name */
  Description: 'description',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  SavedAt: 'saved_at',
  /** column name */
  Title: 'title'
} as const;

export type CampaignArtifactsUpdateColumn = typeof CampaignArtifactsUpdateColumn[keyof typeof CampaignArtifactsUpdateColumn];
export type CampaignArtifactsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CampaignArtifactsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CampaignArtifactsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CampaignArtifactsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CampaignArtifactsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CampaignArtifactsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CampaignArtifactsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CampaignArtifactsSetInput>;
  /** filter the rows which have to be updated */
  where: CampaignArtifactsBoolExp;
};

/** aggregate var_pop on columns */
export type CampaignArtifactsVarPopFields = {
  __typename?: 'campaign_artifacts_var_pop_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaign_artifacts" */
export type CampaignArtifactsVarPopOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignArtifactsVarSampFields = {
  __typename?: 'campaign_artifacts_var_samp_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaign_artifacts" */
export type CampaignArtifactsVarSampOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignArtifactsVarianceFields = {
  __typename?: 'campaign_artifacts_variance_fields';
  current_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaign_artifacts" */
export type CampaignArtifactsVarianceOrderBy = {
  current_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "campaign_drafts" */
export type CampaignDrafts = {
  __typename?: 'campaign_drafts';
  approved_message_versions?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  campaign: Campaigns;
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  requested_approver_ids: Scalars['jsonb'];
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  reviewed_by_user?: Maybe<Users>;
  status: Scalars['String'];
  submission_comment?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "campaign_drafts" */
export type CampaignDraftsApprovedMessageVersionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "campaign_drafts" */
export type CampaignDraftsRequestedApproverIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "campaign_drafts" */
export type CampaignDraftsAggregate = {
  __typename?: 'campaign_drafts_aggregate';
  aggregate?: Maybe<CampaignDraftsAggregateFields>;
  nodes: Array<CampaignDrafts>;
};

export type CampaignDraftsAggregateBoolExp = {
  count?: InputMaybe<CampaignDraftsAggregateBoolExpCount>;
};

export type CampaignDraftsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignDraftsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaign_drafts" */
export type CampaignDraftsAggregateFields = {
  __typename?: 'campaign_drafts_aggregate_fields';
  avg?: Maybe<CampaignDraftsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignDraftsMaxFields>;
  min?: Maybe<CampaignDraftsMinFields>;
  stddev?: Maybe<CampaignDraftsStddevFields>;
  stddev_pop?: Maybe<CampaignDraftsStddevPopFields>;
  stddev_samp?: Maybe<CampaignDraftsStddevSampFields>;
  sum?: Maybe<CampaignDraftsSumFields>;
  var_pop?: Maybe<CampaignDraftsVarPopFields>;
  var_samp?: Maybe<CampaignDraftsVarSampFields>;
  variance?: Maybe<CampaignDraftsVarianceFields>;
};


/** aggregate fields of "campaign_drafts" */
export type CampaignDraftsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaign_drafts" */
export type CampaignDraftsAggregateOrderBy = {
  avg?: InputMaybe<CampaignDraftsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignDraftsMaxOrderBy>;
  min?: InputMaybe<CampaignDraftsMinOrderBy>;
  stddev?: InputMaybe<CampaignDraftsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignDraftsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignDraftsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignDraftsSumOrderBy>;
  var_pop?: InputMaybe<CampaignDraftsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignDraftsVarSampOrderBy>;
  variance?: InputMaybe<CampaignDraftsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CampaignDraftsAvgFields = {
  __typename?: 'campaign_drafts_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaign_drafts" */
export type CampaignDraftsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaign_drafts". All fields are combined with a logical 'AND'. */
export type CampaignDraftsBoolExp = {
  _and?: InputMaybe<Array<CampaignDraftsBoolExp>>;
  _not?: InputMaybe<CampaignDraftsBoolExp>;
  _or?: InputMaybe<Array<CampaignDraftsBoolExp>>;
  approved_message_versions?: InputMaybe<JsonbComparisonExp>;
  campaign?: InputMaybe<CampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requested_approver_ids?: InputMaybe<JsonbComparisonExp>;
  resolution_comment?: InputMaybe<StringComparisonExp>;
  reviewed_at?: InputMaybe<TimestamptzComparisonExp>;
  reviewed_by?: InputMaybe<BigintComparisonExp>;
  reviewed_by_user?: InputMaybe<UsersBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  submission_comment?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CampaignDraftsMaxFields = {
  __typename?: 'campaign_drafts_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  submission_comment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "campaign_drafts" */
export type CampaignDraftsMaxOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignDraftsMinFields = {
  __typename?: 'campaign_drafts_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  submission_comment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "campaign_drafts" */
export type CampaignDraftsMinOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "campaign_drafts". */
export type CampaignDraftsOrderBy = {
  approved_message_versions?: InputMaybe<OrderBy>;
  campaign?: InputMaybe<CampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  requested_approver_ids?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  reviewed_by_user?: InputMaybe<UsersOrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "campaign_drafts" */
export const CampaignDraftsSelectColumn = {
  /** column name */
  ApprovedMessageVersions: 'approved_message_versions',
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  RequestedApproverIds: 'requested_approver_ids',
  /** column name */
  ResolutionComment: 'resolution_comment',
  /** column name */
  ReviewedAt: 'reviewed_at',
  /** column name */
  ReviewedBy: 'reviewed_by',
  /** column name */
  Status: 'status',
  /** column name */
  SubmissionComment: 'submission_comment',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignDraftsSelectColumn = typeof CampaignDraftsSelectColumn[keyof typeof CampaignDraftsSelectColumn];
/** aggregate stddev on columns */
export type CampaignDraftsStddevFields = {
  __typename?: 'campaign_drafts_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaign_drafts" */
export type CampaignDraftsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignDraftsStddevPopFields = {
  __typename?: 'campaign_drafts_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaign_drafts" */
export type CampaignDraftsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignDraftsStddevSampFields = {
  __typename?: 'campaign_drafts_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaign_drafts" */
export type CampaignDraftsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaign_drafts" */
export type CampaignDraftsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignDraftsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignDraftsStreamCursorValueInput = {
  approved_message_versions?: InputMaybe<Scalars['jsonb']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  requested_approver_ids?: InputMaybe<Scalars['jsonb']>;
  resolution_comment?: InputMaybe<Scalars['String']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']>;
  reviewed_by?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  submission_comment?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignDraftsSumFields = {
  __typename?: 'campaign_drafts_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "campaign_drafts" */
export type CampaignDraftsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CampaignDraftsVarPopFields = {
  __typename?: 'campaign_drafts_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaign_drafts" */
export type CampaignDraftsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignDraftsVarSampFields = {
  __typename?: 'campaign_drafts_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaign_drafts" */
export type CampaignDraftsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignDraftsVarianceFields = {
  __typename?: 'campaign_drafts_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaign_drafts" */
export type CampaignDraftsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "campaign_labels" */
export type CampaignLabels = {
  __typename?: 'campaign_labels';
  /** An object relationship */
  campaign: Campaigns;
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "campaign_labels" */
export type CampaignLabelsAggregate = {
  __typename?: 'campaign_labels_aggregate';
  aggregate?: Maybe<CampaignLabelsAggregateFields>;
  nodes: Array<CampaignLabels>;
};

export type CampaignLabelsAggregateBoolExp = {
  count?: InputMaybe<CampaignLabelsAggregateBoolExpCount>;
};

export type CampaignLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaign_labels" */
export type CampaignLabelsAggregateFields = {
  __typename?: 'campaign_labels_aggregate_fields';
  avg?: Maybe<CampaignLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignLabelsMaxFields>;
  min?: Maybe<CampaignLabelsMinFields>;
  stddev?: Maybe<CampaignLabelsStddevFields>;
  stddev_pop?: Maybe<CampaignLabelsStddevPopFields>;
  stddev_samp?: Maybe<CampaignLabelsStddevSampFields>;
  sum?: Maybe<CampaignLabelsSumFields>;
  var_pop?: Maybe<CampaignLabelsVarPopFields>;
  var_samp?: Maybe<CampaignLabelsVarSampFields>;
  variance?: Maybe<CampaignLabelsVarianceFields>;
};


/** aggregate fields of "campaign_labels" */
export type CampaignLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaign_labels" */
export type CampaignLabelsAggregateOrderBy = {
  avg?: InputMaybe<CampaignLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignLabelsMaxOrderBy>;
  min?: InputMaybe<CampaignLabelsMinOrderBy>;
  stddev?: InputMaybe<CampaignLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignLabelsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignLabelsSumOrderBy>;
  var_pop?: InputMaybe<CampaignLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignLabelsVarSampOrderBy>;
  variance?: InputMaybe<CampaignLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "campaign_labels" */
export type CampaignLabelsArrRelInsertInput = {
  data: Array<CampaignLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CampaignLabelsOnConflict>;
};

/** aggregate avg on columns */
export type CampaignLabelsAvgFields = {
  __typename?: 'campaign_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaign_labels" */
export type CampaignLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaign_labels". All fields are combined with a logical 'AND'. */
export type CampaignLabelsBoolExp = {
  _and?: InputMaybe<Array<CampaignLabelsBoolExp>>;
  _not?: InputMaybe<CampaignLabelsBoolExp>;
  _or?: InputMaybe<Array<CampaignLabelsBoolExp>>;
  campaign?: InputMaybe<CampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "campaign_labels" */
export const CampaignLabelsConstraint = {
  /** unique or primary key constraint on columns "label_id", "campaign_id" */
  CampaignLabelsPkey: 'campaign_labels_pkey'
} as const;

export type CampaignLabelsConstraint = typeof CampaignLabelsConstraint[keyof typeof CampaignLabelsConstraint];
/** input type for inserting data into table "campaign_labels" */
export type CampaignLabelsInsertInput = {
  campaign?: InputMaybe<CampaignsObjRelInsertInput>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CampaignLabelsMaxFields = {
  __typename?: 'campaign_labels_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "campaign_labels" */
export type CampaignLabelsMaxOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignLabelsMinFields = {
  __typename?: 'campaign_labels_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "campaign_labels" */
export type CampaignLabelsMinOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "campaign_labels" */
export type CampaignLabelsMutationResponse = {
  __typename?: 'campaign_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CampaignLabels>;
};

/** on_conflict condition type for table "campaign_labels" */
export type CampaignLabelsOnConflict = {
  constraint: CampaignLabelsConstraint;
  update_columns?: Array<CampaignLabelsUpdateColumn>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};

/** Ordering options when selecting data from "campaign_labels". */
export type CampaignLabelsOrderBy = {
  campaign?: InputMaybe<CampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "campaign_labels" */
export const CampaignLabelsSelectColumn = {
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignLabelsSelectColumn = typeof CampaignLabelsSelectColumn[keyof typeof CampaignLabelsSelectColumn];
/** aggregate stddev on columns */
export type CampaignLabelsStddevFields = {
  __typename?: 'campaign_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaign_labels" */
export type CampaignLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignLabelsStddevPopFields = {
  __typename?: 'campaign_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaign_labels" */
export type CampaignLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignLabelsStddevSampFields = {
  __typename?: 'campaign_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaign_labels" */
export type CampaignLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaign_labels" */
export type CampaignLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignLabelsStreamCursorValueInput = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignLabelsSumFields = {
  __typename?: 'campaign_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "campaign_labels" */
export type CampaignLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "campaign_labels" (current role has no relevant permissions) */
export const CampaignLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type CampaignLabelsUpdateColumn = typeof CampaignLabelsUpdateColumn[keyof typeof CampaignLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type CampaignLabelsVarPopFields = {
  __typename?: 'campaign_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaign_labels" */
export type CampaignLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignLabelsVarSampFields = {
  __typename?: 'campaign_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaign_labels" */
export type CampaignLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignLabelsVarianceFields = {
  __typename?: 'campaign_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaign_labels" */
export type CampaignLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "campaign_list_entries" */
export type CampaignListEntries = {
  __typename?: 'campaign_list_entries';
  /** An object relationship */
  campaign?: Maybe<Campaigns>;
  campaign_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  /** An object relationship */
  message?: Maybe<Messages>;
  message_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "campaign_list_entries" */
export type CampaignListEntriesAggregate = {
  __typename?: 'campaign_list_entries_aggregate';
  aggregate?: Maybe<CampaignListEntriesAggregateFields>;
  nodes: Array<CampaignListEntries>;
};

/** aggregate fields of "campaign_list_entries" */
export type CampaignListEntriesAggregateFields = {
  __typename?: 'campaign_list_entries_aggregate_fields';
  avg?: Maybe<CampaignListEntriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignListEntriesMaxFields>;
  min?: Maybe<CampaignListEntriesMinFields>;
  stddev?: Maybe<CampaignListEntriesStddevFields>;
  stddev_pop?: Maybe<CampaignListEntriesStddevPopFields>;
  stddev_samp?: Maybe<CampaignListEntriesStddevSampFields>;
  sum?: Maybe<CampaignListEntriesSumFields>;
  var_pop?: Maybe<CampaignListEntriesVarPopFields>;
  var_samp?: Maybe<CampaignListEntriesVarSampFields>;
  variance?: Maybe<CampaignListEntriesVarianceFields>;
};


/** aggregate fields of "campaign_list_entries" */
export type CampaignListEntriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignListEntriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CampaignListEntriesAvgFields = {
  __typename?: 'campaign_list_entries_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "campaign_list_entries". All fields are combined with a logical 'AND'. */
export type CampaignListEntriesBoolExp = {
  _and?: InputMaybe<Array<CampaignListEntriesBoolExp>>;
  _not?: InputMaybe<CampaignListEntriesBoolExp>;
  _or?: InputMaybe<Array<CampaignListEntriesBoolExp>>;
  campaign?: InputMaybe<CampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CampaignListEntriesMaxFields = {
  __typename?: 'campaign_list_entries_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  message_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CampaignListEntriesMinFields = {
  __typename?: 'campaign_list_entries_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  message_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "campaign_list_entries". */
export type CampaignListEntriesOrderBy = {
  campaign?: InputMaybe<CampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "campaign_list_entries" */
export const CampaignListEntriesSelectColumn = {
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignListEntriesSelectColumn = typeof CampaignListEntriesSelectColumn[keyof typeof CampaignListEntriesSelectColumn];
/** aggregate stddev on columns */
export type CampaignListEntriesStddevFields = {
  __typename?: 'campaign_list_entries_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CampaignListEntriesStddevPopFields = {
  __typename?: 'campaign_list_entries_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CampaignListEntriesStddevSampFields = {
  __typename?: 'campaign_list_entries_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "campaign_list_entries" */
export type CampaignListEntriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignListEntriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignListEntriesStreamCursorValueInput = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Scalars['String']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignListEntriesSumFields = {
  __typename?: 'campaign_list_entries_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CampaignListEntriesVarPopFields = {
  __typename?: 'campaign_list_entries_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CampaignListEntriesVarSampFields = {
  __typename?: 'campaign_list_entries_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CampaignListEntriesVarianceFields = {
  __typename?: 'campaign_list_entries_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "campaign_runs" */
export type CampaignRuns = {
  __typename?: 'campaign_runs';
  /** An object relationship */
  campaign?: Maybe<Campaigns>;
  campaign_id: Scalars['uuid'];
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  drop_reason_counts: Scalars['jsonb'];
  error_message?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  locked_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  total_dropped: Scalars['Int'];
  total_eligible: Scalars['Int'];
  total_scheduled: Scalars['Int'];
  total_timed_out: Scalars['Int'];
  total_triggered: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "campaign_runs" */
export type CampaignRunsDropReasonCountsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "campaign_runs" */
export type CampaignRunsAggregate = {
  __typename?: 'campaign_runs_aggregate';
  aggregate?: Maybe<CampaignRunsAggregateFields>;
  nodes: Array<CampaignRuns>;
};

export type CampaignRunsAggregateBoolExp = {
  count?: InputMaybe<CampaignRunsAggregateBoolExpCount>;
};

export type CampaignRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaign_runs" */
export type CampaignRunsAggregateFields = {
  __typename?: 'campaign_runs_aggregate_fields';
  avg?: Maybe<CampaignRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignRunsMaxFields>;
  min?: Maybe<CampaignRunsMinFields>;
  stddev?: Maybe<CampaignRunsStddevFields>;
  stddev_pop?: Maybe<CampaignRunsStddevPopFields>;
  stddev_samp?: Maybe<CampaignRunsStddevSampFields>;
  sum?: Maybe<CampaignRunsSumFields>;
  var_pop?: Maybe<CampaignRunsVarPopFields>;
  var_samp?: Maybe<CampaignRunsVarSampFields>;
  variance?: Maybe<CampaignRunsVarianceFields>;
};


/** aggregate fields of "campaign_runs" */
export type CampaignRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaign_runs" */
export type CampaignRunsAggregateOrderBy = {
  avg?: InputMaybe<CampaignRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignRunsMaxOrderBy>;
  min?: InputMaybe<CampaignRunsMinOrderBy>;
  stddev?: InputMaybe<CampaignRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignRunsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignRunsSumOrderBy>;
  var_pop?: InputMaybe<CampaignRunsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignRunsVarSampOrderBy>;
  variance?: InputMaybe<CampaignRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CampaignRunsAvgFields = {
  __typename?: 'campaign_runs_avg_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaign_runs" */
export type CampaignRunsAvgOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaign_runs". All fields are combined with a logical 'AND'. */
export type CampaignRunsBoolExp = {
  _and?: InputMaybe<Array<CampaignRunsBoolExp>>;
  _not?: InputMaybe<CampaignRunsBoolExp>;
  _or?: InputMaybe<Array<CampaignRunsBoolExp>>;
  campaign?: InputMaybe<CampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  drop_reason_counts?: InputMaybe<JsonbComparisonExp>;
  error_message?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locked_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  total_dropped?: InputMaybe<IntComparisonExp>;
  total_eligible?: InputMaybe<IntComparisonExp>;
  total_scheduled?: InputMaybe<IntComparisonExp>;
  total_timed_out?: InputMaybe<IntComparisonExp>;
  total_triggered?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CampaignRunsMaxFields = {
  __typename?: 'campaign_runs_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locked_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_dropped?: Maybe<Scalars['Int']>;
  total_eligible?: Maybe<Scalars['Int']>;
  total_scheduled?: Maybe<Scalars['Int']>;
  total_timed_out?: Maybe<Scalars['Int']>;
  total_triggered?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "campaign_runs" */
export type CampaignRunsMaxOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locked_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignRunsMinFields = {
  __typename?: 'campaign_runs_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  error_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  locked_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_dropped?: Maybe<Scalars['Int']>;
  total_eligible?: Maybe<Scalars['Int']>;
  total_scheduled?: Maybe<Scalars['Int']>;
  total_timed_out?: Maybe<Scalars['Int']>;
  total_triggered?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "campaign_runs" */
export type CampaignRunsMinOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locked_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "campaign_runs" */
export type CampaignRunsMutationResponse = {
  __typename?: 'campaign_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CampaignRuns>;
};

/** Ordering options when selecting data from "campaign_runs". */
export type CampaignRunsOrderBy = {
  campaign?: InputMaybe<CampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  drop_reason_counts?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locked_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: campaign_runs */
export type CampaignRunsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "campaign_runs" */
export const CampaignRunsSelectColumn = {
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DropReasonCounts: 'drop_reason_counts',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  Id: 'id',
  /** column name */
  LockedAt: 'locked_at',
  /** column name */
  Status: 'status',
  /** column name */
  TotalDropped: 'total_dropped',
  /** column name */
  TotalEligible: 'total_eligible',
  /** column name */
  TotalScheduled: 'total_scheduled',
  /** column name */
  TotalTimedOut: 'total_timed_out',
  /** column name */
  TotalTriggered: 'total_triggered',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignRunsSelectColumn = typeof CampaignRunsSelectColumn[keyof typeof CampaignRunsSelectColumn];
/** input type for updating data in table "campaign_runs" */
export type CampaignRunsSetInput = {
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CampaignRunsStddevFields = {
  __typename?: 'campaign_runs_stddev_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaign_runs" */
export type CampaignRunsStddevOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignRunsStddevPopFields = {
  __typename?: 'campaign_runs_stddev_pop_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaign_runs" */
export type CampaignRunsStddevPopOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignRunsStddevSampFields = {
  __typename?: 'campaign_runs_stddev_samp_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaign_runs" */
export type CampaignRunsStddevSampOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaign_runs" */
export type CampaignRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignRunsStreamCursorValueInput = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  drop_reason_counts?: InputMaybe<Scalars['jsonb']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  locked_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  total_dropped?: InputMaybe<Scalars['Int']>;
  total_eligible?: InputMaybe<Scalars['Int']>;
  total_scheduled?: InputMaybe<Scalars['Int']>;
  total_timed_out?: InputMaybe<Scalars['Int']>;
  total_triggered?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignRunsSumFields = {
  __typename?: 'campaign_runs_sum_fields';
  total_dropped?: Maybe<Scalars['Int']>;
  total_eligible?: Maybe<Scalars['Int']>;
  total_scheduled?: Maybe<Scalars['Int']>;
  total_timed_out?: Maybe<Scalars['Int']>;
  total_triggered?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "campaign_runs" */
export type CampaignRunsSumOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type CampaignRunsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CampaignRunsSetInput>;
  /** filter the rows which have to be updated */
  where: CampaignRunsBoolExp;
};

/** aggregate var_pop on columns */
export type CampaignRunsVarPopFields = {
  __typename?: 'campaign_runs_var_pop_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaign_runs" */
export type CampaignRunsVarPopOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignRunsVarSampFields = {
  __typename?: 'campaign_runs_var_samp_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaign_runs" */
export type CampaignRunsVarSampOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignRunsVarianceFields = {
  __typename?: 'campaign_runs_variance_fields';
  total_dropped?: Maybe<Scalars['Float']>;
  total_eligible?: Maybe<Scalars['Float']>;
  total_scheduled?: Maybe<Scalars['Float']>;
  total_timed_out?: Maybe<Scalars['Float']>;
  total_triggered?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaign_runs" */
export type CampaignRunsVarianceOrderBy = {
  total_dropped?: InputMaybe<OrderBy>;
  total_eligible?: InputMaybe<OrderBy>;
  total_scheduled?: InputMaybe<OrderBy>;
  total_timed_out?: InputMaybe<OrderBy>;
  total_triggered?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "campaigns" */
export type Campaigns = {
  __typename?: 'campaigns';
  /** An array relationship */
  campaign_labels: Array<CampaignLabels>;
  /** An aggregate relationship */
  campaign_labels_aggregate: CampaignLabelsAggregate;
  /** An array relationship */
  campaign_runs: Array<CampaignRuns>;
  /** An aggregate relationship */
  campaign_runs_aggregate: CampaignRunsAggregate;
  campaign_type?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  drafts: Array<CampaignDrafts>;
  /** An aggregate relationship */
  drafts_aggregate: CampaignDraftsAggregate;
  evaluation_count: Scalars['Int'];
  id: Scalars['uuid'];
  last_evaluated_at?: Maybe<Scalars['timestamptz']>;
  max_recurrences?: Maybe<Scalars['Int']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  schedule_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  tags: Scalars['jsonb'];
  targeting_mode: Scalars['String'];
  timezone_mode: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "campaigns" */
export type CampaignsCampaignLabelsArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsCampaignLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsCampaignRunsArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsCampaignRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsDraftsArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "campaigns" */
export type CampaignsScheduleConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "campaigns" */
export type CampaignsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "campaigns" */
export type CampaignsAggregate = {
  __typename?: 'campaigns_aggregate';
  aggregate?: Maybe<CampaignsAggregateFields>;
  nodes: Array<Campaigns>;
};

export type CampaignsAggregateBoolExp = {
  count?: InputMaybe<CampaignsAggregateBoolExpCount>;
};

export type CampaignsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CampaignsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CampaignsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "campaigns" */
export type CampaignsAggregateFields = {
  __typename?: 'campaigns_aggregate_fields';
  avg?: Maybe<CampaignsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CampaignsMaxFields>;
  min?: Maybe<CampaignsMinFields>;
  stddev?: Maybe<CampaignsStddevFields>;
  stddev_pop?: Maybe<CampaignsStddevPopFields>;
  stddev_samp?: Maybe<CampaignsStddevSampFields>;
  sum?: Maybe<CampaignsSumFields>;
  var_pop?: Maybe<CampaignsVarPopFields>;
  var_samp?: Maybe<CampaignsVarSampFields>;
  variance?: Maybe<CampaignsVarianceFields>;
};


/** aggregate fields of "campaigns" */
export type CampaignsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CampaignsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campaigns" */
export type CampaignsAggregateOrderBy = {
  avg?: InputMaybe<CampaignsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CampaignsMaxOrderBy>;
  min?: InputMaybe<CampaignsMinOrderBy>;
  stddev?: InputMaybe<CampaignsStddevOrderBy>;
  stddev_pop?: InputMaybe<CampaignsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CampaignsStddevSampOrderBy>;
  sum?: InputMaybe<CampaignsSumOrderBy>;
  var_pop?: InputMaybe<CampaignsVarPopOrderBy>;
  var_samp?: InputMaybe<CampaignsVarSampOrderBy>;
  variance?: InputMaybe<CampaignsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CampaignsAppendInput = {
  schedule_config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "campaigns" */
export type CampaignsArrRelInsertInput = {
  data: Array<CampaignsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CampaignsOnConflict>;
};

/** aggregate avg on columns */
export type CampaignsAvgFields = {
  __typename?: 'campaigns_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campaigns" */
export type CampaignsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "campaigns". All fields are combined with a logical 'AND'. */
export type CampaignsBoolExp = {
  _and?: InputMaybe<Array<CampaignsBoolExp>>;
  _not?: InputMaybe<CampaignsBoolExp>;
  _or?: InputMaybe<Array<CampaignsBoolExp>>;
  campaign_labels?: InputMaybe<CampaignLabelsBoolExp>;
  campaign_labels_aggregate?: InputMaybe<CampaignLabelsAggregateBoolExp>;
  campaign_runs?: InputMaybe<CampaignRunsBoolExp>;
  campaign_runs_aggregate?: InputMaybe<CampaignRunsAggregateBoolExp>;
  campaign_type?: InputMaybe<StringComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  drafts?: InputMaybe<CampaignDraftsBoolExp>;
  drafts_aggregate?: InputMaybe<CampaignDraftsAggregateBoolExp>;
  evaluation_count?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_evaluated_at?: InputMaybe<TimestamptzComparisonExp>;
  max_recurrences?: InputMaybe<IntComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  messages_aggregate?: InputMaybe<MessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  schedule_config?: InputMaybe<JsonbComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  targeting_mode?: InputMaybe<StringComparisonExp>;
  timezone_mode?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "campaigns" */
export const CampaignsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CampaignsIdWorkspaceIdKey: 'campaigns_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CampaignsPkey: 'campaigns_pkey'
} as const;

export type CampaignsConstraint = typeof CampaignsConstraint[keyof typeof CampaignsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CampaignsDeleteAtPathInput = {
  schedule_config?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CampaignsDeleteElemInput = {
  schedule_config?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CampaignsDeleteKeyInput = {
  schedule_config?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "campaigns" */
export type CampaignsIncInput = {
  max_recurrences?: InputMaybe<Scalars['Int']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "campaigns" */
export type CampaignsInsertInput = {
  campaign_labels?: InputMaybe<CampaignLabelsArrRelInsertInput>;
  campaign_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  max_recurrences?: InputMaybe<Scalars['Int']>;
  messages?: InputMaybe<MessagesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  schedule_config?: InputMaybe<Scalars['jsonb']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_mode?: InputMaybe<Scalars['String']>;
  timezone_mode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CampaignsMaxFields = {
  __typename?: 'campaigns_max_fields';
  campaign_type?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  evaluation_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  last_evaluated_at?: Maybe<Scalars['timestamptz']>;
  max_recurrences?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  targeting_mode?: Maybe<Scalars['String']>;
  timezone_mode?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "campaigns" */
export type CampaignsMaxOrderBy = {
  campaign_type?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_evaluated_at?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  targeting_mode?: InputMaybe<OrderBy>;
  timezone_mode?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CampaignsMinFields = {
  __typename?: 'campaigns_min_fields';
  campaign_type?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  evaluation_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  last_evaluated_at?: Maybe<Scalars['timestamptz']>;
  max_recurrences?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  targeting_mode?: Maybe<Scalars['String']>;
  timezone_mode?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "campaigns" */
export type CampaignsMinOrderBy = {
  campaign_type?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_evaluated_at?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  targeting_mode?: InputMaybe<OrderBy>;
  timezone_mode?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "campaigns" */
export type CampaignsMutationResponse = {
  __typename?: 'campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Campaigns>;
};

/** input type for inserting object relation for remote table "campaigns" */
export type CampaignsObjRelInsertInput = {
  data: CampaignsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CampaignsOnConflict>;
};

/** on_conflict condition type for table "campaigns" */
export type CampaignsOnConflict = {
  constraint: CampaignsConstraint;
  update_columns?: Array<CampaignsUpdateColumn>;
  where?: InputMaybe<CampaignsBoolExp>;
};

/** Ordering options when selecting data from "campaigns". */
export type CampaignsOrderBy = {
  campaign_labels_aggregate?: InputMaybe<CampaignLabelsAggregateOrderBy>;
  campaign_runs_aggregate?: InputMaybe<CampaignRunsAggregateOrderBy>;
  campaign_type?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  drafts_aggregate?: InputMaybe<CampaignDraftsAggregateOrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_evaluated_at?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<MessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  schedule_config?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  targeting_mode?: InputMaybe<OrderBy>;
  timezone_mode?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: campaigns */
export type CampaignsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CampaignsPrependInput = {
  schedule_config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "campaigns" */
export const CampaignsSelectColumn = {
  /** column name */
  CampaignType: 'campaign_type',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  EvaluationCount: 'evaluation_count',
  /** column name */
  Id: 'id',
  /** column name */
  LastEvaluatedAt: 'last_evaluated_at',
  /** column name */
  MaxRecurrences: 'max_recurrences',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  ScheduleConfig: 'schedule_config',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Status: 'status',
  /** column name */
  Tags: 'tags',
  /** column name */
  TargetingMode: 'targeting_mode',
  /** column name */
  TimezoneMode: 'timezone_mode',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CampaignsSelectColumn = typeof CampaignsSelectColumn[keyof typeof CampaignsSelectColumn];
/** input type for updating data in table "campaigns" */
export type CampaignsSetInput = {
  campaign_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  max_recurrences?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  schedule_config?: InputMaybe<Scalars['jsonb']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_mode?: InputMaybe<Scalars['String']>;
  timezone_mode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CampaignsStddevFields = {
  __typename?: 'campaigns_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campaigns" */
export type CampaignsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CampaignsStddevPopFields = {
  __typename?: 'campaigns_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campaigns" */
export type CampaignsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CampaignsStddevSampFields = {
  __typename?: 'campaigns_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campaigns" */
export type CampaignsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "campaigns" */
export type CampaignsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CampaignsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CampaignsStreamCursorValueInput = {
  campaign_type?: InputMaybe<Scalars['String']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  evaluation_count?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_evaluated_at?: InputMaybe<Scalars['timestamptz']>;
  max_recurrences?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  schedule_config?: InputMaybe<Scalars['jsonb']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_mode?: InputMaybe<Scalars['String']>;
  timezone_mode?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CampaignsSumFields = {
  __typename?: 'campaigns_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  evaluation_count?: Maybe<Scalars['Int']>;
  max_recurrences?: Maybe<Scalars['Int']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "campaigns" */
export type CampaignsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "campaigns" */
export const CampaignsUpdateColumn = {
  /** column name */
  CampaignType: 'campaign_type',
  /** column name */
  Description: 'description',
  /** column name */
  MaxRecurrences: 'max_recurrences',
  /** column name */
  Name: 'name',
  /** column name */
  ScheduleConfig: 'schedule_config',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Tags: 'tags',
  /** column name */
  TargetingMode: 'targeting_mode',
  /** column name */
  TimezoneMode: 'timezone_mode'
} as const;

export type CampaignsUpdateColumn = typeof CampaignsUpdateColumn[keyof typeof CampaignsUpdateColumn];
export type CampaignsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CampaignsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CampaignsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CampaignsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CampaignsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CampaignsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CampaignsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CampaignsSetInput>;
  /** filter the rows which have to be updated */
  where: CampaignsBoolExp;
};

/** aggregate var_pop on columns */
export type CampaignsVarPopFields = {
  __typename?: 'campaigns_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campaigns" */
export type CampaignsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CampaignsVarSampFields = {
  __typename?: 'campaigns_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campaigns" */
export type CampaignsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CampaignsVarianceFields = {
  __typename?: 'campaigns_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  evaluation_count?: Maybe<Scalars['Float']>;
  max_recurrences?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campaigns" */
export type CampaignsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  evaluation_count?: InputMaybe<OrderBy>;
  max_recurrences?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "catalog_collections" */
export type CatalogCollections = {
  __typename?: 'catalog_collections';
  /** An object relationship */
  catalog: CatalogModels;
  catalog_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  filter?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "catalog_collections" */
export type CatalogCollectionsFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CatalogCollectionsAppendInput = {
  filter?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "catalog_collections". All fields are combined with a logical 'AND'. */
export type CatalogCollectionsBoolExp = {
  _and?: InputMaybe<Array<CatalogCollectionsBoolExp>>;
  _not?: InputMaybe<CatalogCollectionsBoolExp>;
  _or?: InputMaybe<Array<CatalogCollectionsBoolExp>>;
  catalog?: InputMaybe<CatalogModelsBoolExp>;
  catalog_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  filter?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "catalog_collections" */
export const CatalogCollectionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  CatalogCollectionsPkey: 'catalog_collections_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CatalogCollectionsWorkspaceIdIdKey: 'catalog_collections_workspace_id_id_key'
} as const;

export type CatalogCollectionsConstraint = typeof CatalogCollectionsConstraint[keyof typeof CatalogCollectionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CatalogCollectionsDeleteAtPathInput = {
  filter?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CatalogCollectionsDeleteElemInput = {
  filter?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CatalogCollectionsDeleteKeyInput = {
  filter?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "catalog_collections" */
export type CatalogCollectionsInsertInput = {
  catalog?: InputMaybe<CatalogModelsObjRelInsertInput>;
  catalog_id?: InputMaybe<Scalars['bigint']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "catalog_collections" */
export type CatalogCollectionsMutationResponse = {
  __typename?: 'catalog_collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CatalogCollections>;
};

/** input type for inserting object relation for remote table "catalog_collections" */
export type CatalogCollectionsObjRelInsertInput = {
  data: CatalogCollectionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CatalogCollectionsOnConflict>;
};

/** on_conflict condition type for table "catalog_collections" */
export type CatalogCollectionsOnConflict = {
  constraint: CatalogCollectionsConstraint;
  update_columns?: Array<CatalogCollectionsUpdateColumn>;
  where?: InputMaybe<CatalogCollectionsBoolExp>;
};

/** Ordering options when selecting data from "catalog_collections". */
export type CatalogCollectionsOrderBy = {
  catalog?: InputMaybe<CatalogModelsOrderBy>;
  catalog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  filter?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: catalog_collections */
export type CatalogCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CatalogCollectionsPrependInput = {
  filter?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "catalog_collections" */
export const CatalogCollectionsSelectColumn = {
  /** column name */
  CatalogId: 'catalog_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Filter: 'filter',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CatalogCollectionsSelectColumn = typeof CatalogCollectionsSelectColumn[keyof typeof CatalogCollectionsSelectColumn];
/** input type for updating data in table "catalog_collections" */
export type CatalogCollectionsSetInput = {
  filter?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "catalog_collections" */
export type CatalogCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CatalogCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CatalogCollectionsStreamCursorValueInput = {
  catalog_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "catalog_collections" */
export const CatalogCollectionsUpdateColumn = {
  /** column name */
  Filter: 'filter',
  /** column name */
  Name: 'name'
} as const;

export type CatalogCollectionsUpdateColumn = typeof CatalogCollectionsUpdateColumn[keyof typeof CatalogCollectionsUpdateColumn];
export type CatalogCollectionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CatalogCollectionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CatalogCollectionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CatalogCollectionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CatalogCollectionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CatalogCollectionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CatalogCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: CatalogCollectionsBoolExp;
};

/** columns and relationships of "catalog_models" */
export type CatalogModels = {
  __typename?: 'catalog_models';
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  primary_key: Scalars['String'];
  primary_label: Scalars['String'];
  secondary_label?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "catalog_models". All fields are combined with a logical 'AND'. */
export type CatalogModelsBoolExp = {
  _and?: InputMaybe<Array<CatalogModelsBoolExp>>;
  _not?: InputMaybe<CatalogModelsBoolExp>;
  _or?: InputMaybe<Array<CatalogModelsBoolExp>>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  primary_key?: InputMaybe<StringComparisonExp>;
  primary_label?: InputMaybe<StringComparisonExp>;
  secondary_label?: InputMaybe<StringComparisonExp>;
  thumbnail?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "catalog_models" */
export const CatalogModelsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "model_id" */
  CatalogModelsModelIdWorkspaceIdKey: 'catalog_models_model_id_workspace_id_key',
  /** unique or primary key constraint on columns "model_id" */
  CatalogModelsPkey: 'catalog_models_pkey'
} as const;

export type CatalogModelsConstraint = typeof CatalogModelsConstraint[keyof typeof CatalogModelsConstraint];
/** input type for inserting data into table "catalog_models" */
export type CatalogModelsInsertInput = {
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key?: InputMaybe<Scalars['String']>;
  primary_label?: InputMaybe<Scalars['String']>;
  secondary_label?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "catalog_models" */
export type CatalogModelsMutationResponse = {
  __typename?: 'catalog_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CatalogModels>;
};

/** input type for inserting object relation for remote table "catalog_models" */
export type CatalogModelsObjRelInsertInput = {
  data: CatalogModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CatalogModelsOnConflict>;
};

/** on_conflict condition type for table "catalog_models" */
export type CatalogModelsOnConflict = {
  constraint: CatalogModelsConstraint;
  update_columns?: Array<CatalogModelsUpdateColumn>;
  where?: InputMaybe<CatalogModelsBoolExp>;
};

/** Ordering options when selecting data from "catalog_models". */
export type CatalogModelsOrderBy = {
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  primary_key?: InputMaybe<OrderBy>;
  primary_label?: InputMaybe<OrderBy>;
  secondary_label?: InputMaybe<OrderBy>;
  thumbnail?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: catalog_models */
export type CatalogModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** select columns of table "catalog_models" */
export const CatalogModelsSelectColumn = {
  /** column name */
  ModelId: 'model_id',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  PrimaryLabel: 'primary_label',
  /** column name */
  SecondaryLabel: 'secondary_label',
  /** column name */
  Thumbnail: 'thumbnail',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CatalogModelsSelectColumn = typeof CatalogModelsSelectColumn[keyof typeof CatalogModelsSelectColumn];
/** input type for updating data in table "catalog_models" */
export type CatalogModelsSetInput = {
  primary_key?: InputMaybe<Scalars['String']>;
  primary_label?: InputMaybe<Scalars['String']>;
  secondary_label?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "catalog_models" */
export type CatalogModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CatalogModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CatalogModelsStreamCursorValueInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key?: InputMaybe<Scalars['String']>;
  primary_label?: InputMaybe<Scalars['String']>;
  secondary_label?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "catalog_models" */
export const CatalogModelsUpdateColumn = {
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  PrimaryLabel: 'primary_label',
  /** column name */
  SecondaryLabel: 'secondary_label',
  /** column name */
  Thumbnail: 'thumbnail'
} as const;

export type CatalogModelsUpdateColumn = typeof CatalogModelsUpdateColumn[keyof typeof CatalogModelsUpdateColumn];
export type CatalogModelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CatalogModelsSetInput>;
  /** filter the rows which have to be updated */
  where: CatalogModelsBoolExp;
};

/** columns and relationships of "cep_brand_settings" */
export type CepBrandSettings = {
  __typename?: 'cep_brand_settings';
  /** An object relationship */
  brand_profile?: Maybe<BrandProfiles>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  button_background_color: Scalars['String'];
  button_label_color: Scalars['String'];
  /** The id of the linked brand profile logo (an entry of brand_profiles.logos) that the consent center page shows. NULL, or an id the profile no longer has, falls back to logo_public_url, else the page shows no logo. */
  consent_logo_id?: Maybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width: Scalars['Int'];
  content_background_color: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  fonts?: Maybe<Scalars['jsonb']>;
  footer_links: Scalars['jsonb'];
  id: Scalars['uuid'];
  library_logo_image?: Maybe<LibraryImage>;
  link_color: Scalars['String'];
  link_underline: Scalars['Boolean'];
  list_unsubscribe_url_template?: Maybe<Scalars['String']>;
  logo_image_id?: Maybe<Scalars['uuid']>;
  logo_public_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  page_background_color: Scalars['String'];
  privacy_policy_url?: Maybe<Scalars['String']>;
  terms_of_service_url?: Maybe<Scalars['String']>;
  text_color: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_brand_settings" */
export type CepBrandSettingsFontsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_brand_settings" */
export type CepBrandSettingsFooterLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_brand_settings" */
export type CepBrandSettingsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_brand_settings" */
export type CepBrandSettingsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_brand_settings" */
export type CepBrandSettingsAggregate = {
  __typename?: 'cep_brand_settings_aggregate';
  aggregate?: Maybe<CepBrandSettingsAggregateFields>;
  nodes: Array<CepBrandSettings>;
};

/** aggregate fields of "cep_brand_settings" */
export type CepBrandSettingsAggregateFields = {
  __typename?: 'cep_brand_settings_aggregate_fields';
  avg?: Maybe<CepBrandSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepBrandSettingsMaxFields>;
  min?: Maybe<CepBrandSettingsMinFields>;
  stddev?: Maybe<CepBrandSettingsStddevFields>;
  stddev_pop?: Maybe<CepBrandSettingsStddevPopFields>;
  stddev_samp?: Maybe<CepBrandSettingsStddevSampFields>;
  sum?: Maybe<CepBrandSettingsSumFields>;
  var_pop?: Maybe<CepBrandSettingsVarPopFields>;
  var_samp?: Maybe<CepBrandSettingsVarSampFields>;
  variance?: Maybe<CepBrandSettingsVarianceFields>;
};


/** aggregate fields of "cep_brand_settings" */
export type CepBrandSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepBrandSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepBrandSettingsAppendInput = {
  fonts?: InputMaybe<Scalars['jsonb']>;
  footer_links?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CepBrandSettingsAvgFields = {
  __typename?: 'cep_brand_settings_avg_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_brand_settings". All fields are combined with a logical 'AND'. */
export type CepBrandSettingsBoolExp = {
  _and?: InputMaybe<Array<CepBrandSettingsBoolExp>>;
  _not?: InputMaybe<CepBrandSettingsBoolExp>;
  _or?: InputMaybe<Array<CepBrandSettingsBoolExp>>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  button_background_color?: InputMaybe<StringComparisonExp>;
  button_label_color?: InputMaybe<StringComparisonExp>;
  consent_logo_id?: InputMaybe<StringComparisonExp>;
  content_area_width?: InputMaybe<IntComparisonExp>;
  content_background_color?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fonts?: InputMaybe<JsonbComparisonExp>;
  footer_links?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  link_color?: InputMaybe<StringComparisonExp>;
  link_underline?: InputMaybe<BooleanComparisonExp>;
  list_unsubscribe_url_template?: InputMaybe<StringComparisonExp>;
  logo_image_id?: InputMaybe<UuidComparisonExp>;
  logo_public_url?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  page_background_color?: InputMaybe<StringComparisonExp>;
  privacy_policy_url?: InputMaybe<StringComparisonExp>;
  terms_of_service_url?: InputMaybe<StringComparisonExp>;
  text_color?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_brand_settings" */
export const CepBrandSettingsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "brand_profile_id" */
  CepBrandSettingsBrandProfileIdWorkspaceIdKey: 'cep_brand_settings_brand_profile_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepBrandSettingsPkey: 'cep_brand_settings_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepBrandSettingsWorkspaceIdIdKey: 'cep_brand_settings_workspace_id_id_key'
} as const;

export type CepBrandSettingsConstraint = typeof CepBrandSettingsConstraint[keyof typeof CepBrandSettingsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepBrandSettingsDeleteAtPathInput = {
  fonts?: InputMaybe<Array<Scalars['String']>>;
  footer_links?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepBrandSettingsDeleteElemInput = {
  fonts?: InputMaybe<Scalars['Int']>;
  footer_links?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepBrandSettingsDeleteKeyInput = {
  fonts?: InputMaybe<Scalars['String']>;
  footer_links?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "cep_brand_settings" */
export type CepBrandSettingsIncInput = {
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cep_brand_settings" */
export type CepBrandSettingsInsertInput = {
  brand_profile?: InputMaybe<BrandProfilesObjRelInsertInput>;
  button_background_color?: InputMaybe<Scalars['String']>;
  button_label_color?: InputMaybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: InputMaybe<Scalars['Int']>;
  content_background_color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  footer_links?: InputMaybe<Scalars['jsonb']>;
  link_color?: InputMaybe<Scalars['String']>;
  link_underline?: InputMaybe<Scalars['Boolean']>;
  list_unsubscribe_url_template?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  page_background_color?: InputMaybe<Scalars['String']>;
  privacy_policy_url?: InputMaybe<Scalars['String']>;
  terms_of_service_url?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CepBrandSettingsMaxFields = {
  __typename?: 'cep_brand_settings_max_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  button_background_color?: Maybe<Scalars['String']>;
  button_label_color?: Maybe<Scalars['String']>;
  /** The id of the linked brand profile logo (an entry of brand_profiles.logos) that the consent center page shows. NULL, or an id the profile no longer has, falls back to logo_public_url, else the page shows no logo. */
  consent_logo_id?: Maybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Int']>;
  content_background_color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link_color?: Maybe<Scalars['String']>;
  list_unsubscribe_url_template?: Maybe<Scalars['String']>;
  logo_image_id?: Maybe<Scalars['uuid']>;
  logo_public_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  page_background_color?: Maybe<Scalars['String']>;
  privacy_policy_url?: Maybe<Scalars['String']>;
  terms_of_service_url?: Maybe<Scalars['String']>;
  text_color?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepBrandSettingsMinFields = {
  __typename?: 'cep_brand_settings_min_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  button_background_color?: Maybe<Scalars['String']>;
  button_label_color?: Maybe<Scalars['String']>;
  /** The id of the linked brand profile logo (an entry of brand_profiles.logos) that the consent center page shows. NULL, or an id the profile no longer has, falls back to logo_public_url, else the page shows no logo. */
  consent_logo_id?: Maybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Int']>;
  content_background_color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link_color?: Maybe<Scalars['String']>;
  list_unsubscribe_url_template?: Maybe<Scalars['String']>;
  logo_image_id?: Maybe<Scalars['uuid']>;
  logo_public_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  page_background_color?: Maybe<Scalars['String']>;
  privacy_policy_url?: Maybe<Scalars['String']>;
  terms_of_service_url?: Maybe<Scalars['String']>;
  text_color?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_brand_settings" */
export type CepBrandSettingsMutationResponse = {
  __typename?: 'cep_brand_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepBrandSettings>;
};

/** input type for inserting object relation for remote table "cep_brand_settings" */
export type CepBrandSettingsObjRelInsertInput = {
  data: CepBrandSettingsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepBrandSettingsOnConflict>;
};

/** on_conflict condition type for table "cep_brand_settings" */
export type CepBrandSettingsOnConflict = {
  constraint: CepBrandSettingsConstraint;
  update_columns?: Array<CepBrandSettingsUpdateColumn>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};

/** Ordering options when selecting data from "cep_brand_settings". */
export type CepBrandSettingsOrderBy = {
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  button_background_color?: InputMaybe<OrderBy>;
  button_label_color?: InputMaybe<OrderBy>;
  consent_logo_id?: InputMaybe<OrderBy>;
  content_area_width?: InputMaybe<OrderBy>;
  content_background_color?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  fonts?: InputMaybe<OrderBy>;
  footer_links?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  link_color?: InputMaybe<OrderBy>;
  link_underline?: InputMaybe<OrderBy>;
  list_unsubscribe_url_template?: InputMaybe<OrderBy>;
  logo_image_id?: InputMaybe<OrderBy>;
  logo_public_url?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  page_background_color?: InputMaybe<OrderBy>;
  privacy_policy_url?: InputMaybe<OrderBy>;
  terms_of_service_url?: InputMaybe<OrderBy>;
  text_color?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_brand_settings */
export type CepBrandSettingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepBrandSettingsPrependInput = {
  fonts?: InputMaybe<Scalars['jsonb']>;
  footer_links?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_brand_settings" */
export const CepBrandSettingsSelectColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  ButtonBackgroundColor: 'button_background_color',
  /** column name */
  ButtonLabelColor: 'button_label_color',
  /** column name */
  ConsentLogoId: 'consent_logo_id',
  /** column name */
  ContentAreaWidth: 'content_area_width',
  /** column name */
  ContentBackgroundColor: 'content_background_color',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  Fonts: 'fonts',
  /** column name */
  FooterLinks: 'footer_links',
  /** column name */
  Id: 'id',
  /** column name */
  LinkColor: 'link_color',
  /** column name */
  LinkUnderline: 'link_underline',
  /** column name */
  ListUnsubscribeUrlTemplate: 'list_unsubscribe_url_template',
  /** column name */
  LogoImageId: 'logo_image_id',
  /** column name */
  LogoPublicUrl: 'logo_public_url',
  /** column name */
  Name: 'name',
  /** column name */
  PageBackgroundColor: 'page_background_color',
  /** column name */
  PrivacyPolicyUrl: 'privacy_policy_url',
  /** column name */
  TermsOfServiceUrl: 'terms_of_service_url',
  /** column name */
  TextColor: 'text_color',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepBrandSettingsSelectColumn = typeof CepBrandSettingsSelectColumn[keyof typeof CepBrandSettingsSelectColumn];
/** input type for updating data in table "cep_brand_settings" */
export type CepBrandSettingsSetInput = {
  button_background_color?: InputMaybe<Scalars['String']>;
  button_label_color?: InputMaybe<Scalars['String']>;
  /** The id of the linked brand profile logo (an entry of brand_profiles.logos) that the consent center page shows. NULL, or an id the profile no longer has, falls back to logo_public_url, else the page shows no logo. */
  consent_logo_id?: InputMaybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: InputMaybe<Scalars['Int']>;
  content_background_color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  footer_links?: InputMaybe<Scalars['jsonb']>;
  link_color?: InputMaybe<Scalars['String']>;
  link_underline?: InputMaybe<Scalars['Boolean']>;
  list_unsubscribe_url_template?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page_background_color?: InputMaybe<Scalars['String']>;
  privacy_policy_url?: InputMaybe<Scalars['String']>;
  terms_of_service_url?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepBrandSettingsStddevFields = {
  __typename?: 'cep_brand_settings_stddev_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepBrandSettingsStddevPopFields = {
  __typename?: 'cep_brand_settings_stddev_pop_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepBrandSettingsStddevSampFields = {
  __typename?: 'cep_brand_settings_stddev_samp_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_brand_settings" */
export type CepBrandSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepBrandSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepBrandSettingsStreamCursorValueInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  button_background_color?: InputMaybe<Scalars['String']>;
  button_label_color?: InputMaybe<Scalars['String']>;
  /** The id of the linked brand profile logo (an entry of brand_profiles.logos) that the consent center page shows. NULL, or an id the profile no longer has, falls back to logo_public_url, else the page shows no logo. */
  consent_logo_id?: InputMaybe<Scalars['String']>;
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: InputMaybe<Scalars['Int']>;
  content_background_color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fonts?: InputMaybe<Scalars['jsonb']>;
  footer_links?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  link_color?: InputMaybe<Scalars['String']>;
  link_underline?: InputMaybe<Scalars['Boolean']>;
  list_unsubscribe_url_template?: InputMaybe<Scalars['String']>;
  logo_image_id?: InputMaybe<Scalars['uuid']>;
  logo_public_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page_background_color?: InputMaybe<Scalars['String']>;
  privacy_policy_url?: InputMaybe<Scalars['String']>;
  terms_of_service_url?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepBrandSettingsSumFields = {
  __typename?: 'cep_brand_settings_sum_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_brand_settings" */
export const CepBrandSettingsUpdateColumn = {
  /** column name */
  ButtonBackgroundColor: 'button_background_color',
  /** column name */
  ButtonLabelColor: 'button_label_color',
  /** column name */
  ConsentLogoId: 'consent_logo_id',
  /** column name */
  ContentAreaWidth: 'content_area_width',
  /** column name */
  ContentBackgroundColor: 'content_background_color',
  /** column name */
  Description: 'description',
  /** column name */
  Fonts: 'fonts',
  /** column name */
  FooterLinks: 'footer_links',
  /** column name */
  LinkColor: 'link_color',
  /** column name */
  LinkUnderline: 'link_underline',
  /** column name */
  ListUnsubscribeUrlTemplate: 'list_unsubscribe_url_template',
  /** column name */
  Name: 'name',
  /** column name */
  PageBackgroundColor: 'page_background_color',
  /** column name */
  PrivacyPolicyUrl: 'privacy_policy_url',
  /** column name */
  TermsOfServiceUrl: 'terms_of_service_url',
  /** column name */
  TextColor: 'text_color'
} as const;

export type CepBrandSettingsUpdateColumn = typeof CepBrandSettingsUpdateColumn[keyof typeof CepBrandSettingsUpdateColumn];
export type CepBrandSettingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepBrandSettingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepBrandSettingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepBrandSettingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepBrandSettingsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CepBrandSettingsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepBrandSettingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepBrandSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: CepBrandSettingsBoolExp;
};

/** aggregate var_pop on columns */
export type CepBrandSettingsVarPopFields = {
  __typename?: 'cep_brand_settings_var_pop_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepBrandSettingsVarSampFields = {
  __typename?: 'cep_brand_settings_var_samp_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepBrandSettingsVarianceFields = {
  __typename?: 'cep_brand_settings_variance_fields';
  /** Default content width (px) seeded into new CEP messages and content blocks. Existing designs and per-design overrides are unaffected. */
  content_area_width?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_channels" */
export type CepChannels = {
  __typename?: 'cep_channels';
  /** An array relationship */
  cep_providers: Array<CepProviders>;
  /** An aggregate relationship */
  cep_providers_aggregate: CepProvidersAggregate;
  /** An array relationship */
  cep_subscription_topics: Array<CepSubscriptionTopics>;
  /** An aggregate relationship */
  cep_subscription_topics_aggregate: CepSubscriptionTopicsAggregate;
  channel_daily_cap?: Maybe<Scalars['Int']>;
  channel_freq_cap?: Maybe<Scalars['jsonb']>;
  channel_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  double_opt_in_confirmation_message?: Maybe<Messages>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_enabled: Scalars['Boolean'];
  /** An object relationship */
  double_opt_in_message?: Maybe<Messages>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  link_tracking_config?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  quiet_hours_config?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_channels" */
export type CepChannelsCepProvidersArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsCepProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsCepSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsCepSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsChannelFreqCapArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsLinkTrackingConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_channels" */
export type CepChannelsQuietHoursConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_channels" */
export type CepChannelsAggregate = {
  __typename?: 'cep_channels_aggregate';
  aggregate?: Maybe<CepChannelsAggregateFields>;
  nodes: Array<CepChannels>;
};

/** aggregate fields of "cep_channels" */
export type CepChannelsAggregateFields = {
  __typename?: 'cep_channels_aggregate_fields';
  avg?: Maybe<CepChannelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepChannelsMaxFields>;
  min?: Maybe<CepChannelsMinFields>;
  stddev?: Maybe<CepChannelsStddevFields>;
  stddev_pop?: Maybe<CepChannelsStddevPopFields>;
  stddev_samp?: Maybe<CepChannelsStddevSampFields>;
  sum?: Maybe<CepChannelsSumFields>;
  var_pop?: Maybe<CepChannelsVarPopFields>;
  var_samp?: Maybe<CepChannelsVarSampFields>;
  variance?: Maybe<CepChannelsVarianceFields>;
};


/** aggregate fields of "cep_channels" */
export type CepChannelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepChannelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepChannelsAppendInput = {
  channel_freq_cap?: InputMaybe<Scalars['jsonb']>;
  link_tracking_config?: InputMaybe<Scalars['jsonb']>;
  quiet_hours_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CepChannelsAvgFields = {
  __typename?: 'cep_channels_avg_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_channels". All fields are combined with a logical 'AND'. */
export type CepChannelsBoolExp = {
  _and?: InputMaybe<Array<CepChannelsBoolExp>>;
  _not?: InputMaybe<CepChannelsBoolExp>;
  _or?: InputMaybe<Array<CepChannelsBoolExp>>;
  cep_providers?: InputMaybe<CepProvidersBoolExp>;
  cep_providers_aggregate?: InputMaybe<CepProvidersAggregateBoolExp>;
  cep_subscription_topics?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topics_aggregate?: InputMaybe<CepSubscriptionTopicsAggregateBoolExp>;
  channel_daily_cap?: InputMaybe<IntComparisonExp>;
  channel_freq_cap?: InputMaybe<JsonbComparisonExp>;
  channel_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  double_opt_in_confirmation_message?: InputMaybe<MessagesBoolExp>;
  double_opt_in_confirmation_message_id?: InputMaybe<UuidComparisonExp>;
  double_opt_in_enabled?: InputMaybe<BooleanComparisonExp>;
  double_opt_in_message?: InputMaybe<MessagesBoolExp>;
  double_opt_in_message_id?: InputMaybe<UuidComparisonExp>;
  double_opt_in_redirect_url?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  link_tracking_config?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  quiet_hours_config?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_channels" */
export const CepChannelsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepChannelsIdWorkspaceIdKey: 'cep_channels_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepChannelsPkey: 'cep_channels_pkey',
  /** unique or primary key constraint on columns "workspace_id", "channel_type" */
  CepChannelsWorkspaceChannelIdx: 'cep_channels_workspace_channel_idx'
} as const;

export type CepChannelsConstraint = typeof CepChannelsConstraint[keyof typeof CepChannelsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepChannelsDeleteAtPathInput = {
  channel_freq_cap?: InputMaybe<Array<Scalars['String']>>;
  link_tracking_config?: InputMaybe<Array<Scalars['String']>>;
  quiet_hours_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepChannelsDeleteElemInput = {
  channel_freq_cap?: InputMaybe<Scalars['Int']>;
  link_tracking_config?: InputMaybe<Scalars['Int']>;
  quiet_hours_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepChannelsDeleteKeyInput = {
  channel_freq_cap?: InputMaybe<Scalars['String']>;
  link_tracking_config?: InputMaybe<Scalars['String']>;
  quiet_hours_config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_channels" */
export type CepChannelsInsertInput = {
  cep_providers?: InputMaybe<CepProvidersArrRelInsertInput>;
  cep_subscription_topics?: InputMaybe<CepSubscriptionTopicsArrRelInsertInput>;
  channel_freq_cap?: InputMaybe<Scalars['jsonb']>;
  channel_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  double_opt_in_confirmation_message?: InputMaybe<MessagesObjRelInsertInput>;
  double_opt_in_message?: InputMaybe<MessagesObjRelInsertInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  link_tracking_config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  quiet_hours_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CepChannelsMaxFields = {
  __typename?: 'cep_channels_max_fields';
  channel_daily_cap?: Maybe<Scalars['Int']>;
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepChannelsMinFields = {
  __typename?: 'cep_channels_min_fields';
  channel_daily_cap?: Maybe<Scalars['Int']>;
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_channels" */
export type CepChannelsMutationResponse = {
  __typename?: 'cep_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepChannels>;
};

/** input type for inserting object relation for remote table "cep_channels" */
export type CepChannelsObjRelInsertInput = {
  data: CepChannelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepChannelsOnConflict>;
};

/** on_conflict condition type for table "cep_channels" */
export type CepChannelsOnConflict = {
  constraint: CepChannelsConstraint;
  update_columns?: Array<CepChannelsUpdateColumn>;
  where?: InputMaybe<CepChannelsBoolExp>;
};

/** Ordering options when selecting data from "cep_channels". */
export type CepChannelsOrderBy = {
  cep_providers_aggregate?: InputMaybe<CepProvidersAggregateOrderBy>;
  cep_subscription_topics_aggregate?: InputMaybe<CepSubscriptionTopicsAggregateOrderBy>;
  channel_daily_cap?: InputMaybe<OrderBy>;
  channel_freq_cap?: InputMaybe<OrderBy>;
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  double_opt_in_confirmation_message?: InputMaybe<MessagesOrderBy>;
  double_opt_in_confirmation_message_id?: InputMaybe<OrderBy>;
  double_opt_in_enabled?: InputMaybe<OrderBy>;
  double_opt_in_message?: InputMaybe<MessagesOrderBy>;
  double_opt_in_message_id?: InputMaybe<OrderBy>;
  double_opt_in_redirect_url?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  link_tracking_config?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  quiet_hours_config?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_channels */
export type CepChannelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepChannelsPrependInput = {
  channel_freq_cap?: InputMaybe<Scalars['jsonb']>;
  link_tracking_config?: InputMaybe<Scalars['jsonb']>;
  quiet_hours_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_channels" */
export const CepChannelsSelectColumn = {
  /** column name */
  ChannelDailyCap: 'channel_daily_cap',
  /** column name */
  ChannelFreqCap: 'channel_freq_cap',
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DoubleOptInConfirmationMessageId: 'double_opt_in_confirmation_message_id',
  /** column name */
  DoubleOptInEnabled: 'double_opt_in_enabled',
  /** column name */
  DoubleOptInMessageId: 'double_opt_in_message_id',
  /** column name */
  DoubleOptInRedirectUrl: 'double_opt_in_redirect_url',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  LinkTrackingConfig: 'link_tracking_config',
  /** column name */
  Name: 'name',
  /** column name */
  QuietHoursConfig: 'quiet_hours_config',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepChannelsSelectColumn = typeof CepChannelsSelectColumn[keyof typeof CepChannelsSelectColumn];
/** input type for updating data in table "cep_channels" */
export type CepChannelsSetInput = {
  channel_freq_cap?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  link_tracking_config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  quiet_hours_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CepChannelsStddevFields = {
  __typename?: 'cep_channels_stddev_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepChannelsStddevPopFields = {
  __typename?: 'cep_channels_stddev_pop_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepChannelsStddevSampFields = {
  __typename?: 'cep_channels_stddev_samp_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_channels" */
export type CepChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepChannelsStreamCursorValueInput = {
  channel_daily_cap?: InputMaybe<Scalars['Int']>;
  channel_freq_cap?: InputMaybe<Scalars['jsonb']>;
  channel_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: InputMaybe<Scalars['uuid']>;
  double_opt_in_enabled?: InputMaybe<Scalars['Boolean']>;
  double_opt_in_message_id?: InputMaybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  link_tracking_config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  quiet_hours_config?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepChannelsSumFields = {
  __typename?: 'cep_channels_sum_fields';
  channel_daily_cap?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_channels" */
export const CepChannelsUpdateColumn = {
  /** column name */
  ChannelFreqCap: 'channel_freq_cap',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  LinkTrackingConfig: 'link_tracking_config',
  /** column name */
  Name: 'name',
  /** column name */
  QuietHoursConfig: 'quiet_hours_config'
} as const;

export type CepChannelsUpdateColumn = typeof CepChannelsUpdateColumn[keyof typeof CepChannelsUpdateColumn];
export type CepChannelsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepChannelsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepChannelsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepChannelsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepChannelsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepChannelsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: CepChannelsBoolExp;
};

/** aggregate var_pop on columns */
export type CepChannelsVarPopFields = {
  __typename?: 'cep_channels_var_pop_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepChannelsVarSampFields = {
  __typename?: 'cep_channels_var_samp_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepChannelsVarianceFields = {
  __typename?: 'cep_channels_variance_fields';
  channel_daily_cap?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_content_block_message_usages" */
export type CepContentBlockMessageUsages = {
  __typename?: 'cep_content_block_message_usages';
  /** An object relationship */
  content_block: CepContentBlocks;
  content_block_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesAggregate = {
  __typename?: 'cep_content_block_message_usages_aggregate';
  aggregate?: Maybe<CepContentBlockMessageUsagesAggregateFields>;
  nodes: Array<CepContentBlockMessageUsages>;
};

export type CepContentBlockMessageUsagesAggregateBoolExp = {
  count?: InputMaybe<CepContentBlockMessageUsagesAggregateBoolExpCount>;
};

export type CepContentBlockMessageUsagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesAggregateFields = {
  __typename?: 'cep_content_block_message_usages_aggregate_fields';
  avg?: Maybe<CepContentBlockMessageUsagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepContentBlockMessageUsagesMaxFields>;
  min?: Maybe<CepContentBlockMessageUsagesMinFields>;
  stddev?: Maybe<CepContentBlockMessageUsagesStddevFields>;
  stddev_pop?: Maybe<CepContentBlockMessageUsagesStddevPopFields>;
  stddev_samp?: Maybe<CepContentBlockMessageUsagesStddevSampFields>;
  sum?: Maybe<CepContentBlockMessageUsagesSumFields>;
  var_pop?: Maybe<CepContentBlockMessageUsagesVarPopFields>;
  var_samp?: Maybe<CepContentBlockMessageUsagesVarSampFields>;
  variance?: Maybe<CepContentBlockMessageUsagesVarianceFields>;
};


/** aggregate fields of "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesAggregateOrderBy = {
  avg?: InputMaybe<CepContentBlockMessageUsagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepContentBlockMessageUsagesMaxOrderBy>;
  min?: InputMaybe<CepContentBlockMessageUsagesMinOrderBy>;
  stddev?: InputMaybe<CepContentBlockMessageUsagesStddevOrderBy>;
  stddev_pop?: InputMaybe<CepContentBlockMessageUsagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepContentBlockMessageUsagesStddevSampOrderBy>;
  sum?: InputMaybe<CepContentBlockMessageUsagesSumOrderBy>;
  var_pop?: InputMaybe<CepContentBlockMessageUsagesVarPopOrderBy>;
  var_samp?: InputMaybe<CepContentBlockMessageUsagesVarSampOrderBy>;
  variance?: InputMaybe<CepContentBlockMessageUsagesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CepContentBlockMessageUsagesAvgFields = {
  __typename?: 'cep_content_block_message_usages_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_content_block_message_usages". All fields are combined with a logical 'AND'. */
export type CepContentBlockMessageUsagesBoolExp = {
  _and?: InputMaybe<Array<CepContentBlockMessageUsagesBoolExp>>;
  _not?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
  _or?: InputMaybe<Array<CepContentBlockMessageUsagesBoolExp>>;
  content_block?: InputMaybe<CepContentBlocksBoolExp>;
  content_block_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepContentBlockMessageUsagesMaxFields = {
  __typename?: 'cep_content_block_message_usages_max_fields';
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  message_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesMaxOrderBy = {
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepContentBlockMessageUsagesMinFields = {
  __typename?: 'cep_content_block_message_usages_min_fields';
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  message_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesMinOrderBy = {
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cep_content_block_message_usages". */
export type CepContentBlockMessageUsagesOrderBy = {
  content_block?: InputMaybe<CepContentBlocksOrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_content_block_message_usages" */
export const CepContentBlockMessageUsagesSelectColumn = {
  /** column name */
  ContentBlockId: 'content_block_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepContentBlockMessageUsagesSelectColumn = typeof CepContentBlockMessageUsagesSelectColumn[keyof typeof CepContentBlockMessageUsagesSelectColumn];
/** aggregate stddev on columns */
export type CepContentBlockMessageUsagesStddevFields = {
  __typename?: 'cep_content_block_message_usages_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepContentBlockMessageUsagesStddevPopFields = {
  __typename?: 'cep_content_block_message_usages_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepContentBlockMessageUsagesStddevSampFields = {
  __typename?: 'cep_content_block_message_usages_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepContentBlockMessageUsagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepContentBlockMessageUsagesStreamCursorValueInput = {
  content_block_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepContentBlockMessageUsagesSumFields = {
  __typename?: 'cep_content_block_message_usages_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CepContentBlockMessageUsagesVarPopFields = {
  __typename?: 'cep_content_block_message_usages_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepContentBlockMessageUsagesVarSampFields = {
  __typename?: 'cep_content_block_message_usages_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepContentBlockMessageUsagesVarianceFields = {
  __typename?: 'cep_content_block_message_usages_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_content_block_message_usages" */
export type CepContentBlockMessageUsagesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocks = {
  __typename?: 'cep_content_blocks';
  available_in_realtime: Scalars['Boolean'];
  /** An object relationship */
  brand_settings?: Maybe<CepBrandSettings>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  component_type: Scalars['String'];
  /** An array relationship */
  content_block_labels: Array<ContentBlockLabels>;
  /** An aggregate relationship */
  content_block_labels_aggregate: ContentBlockLabelsAggregate;
  /** An array relationship */
  content_dynamic_slot_usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  content_dynamic_slot_usages_aggregate: ContentDynamicSlotUsagesAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  kind: Scalars['String'];
  /** An array relationship */
  message_usages: Array<CepContentBlockMessageUsages>;
  /** An aggregate relationship */
  message_usages_aggregate: CepContentBlockMessageUsagesAggregate;
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  raw_html: Scalars['String'];
  row_html: Scalars['String'];
  row_json?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksContentBlockLabelsArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksContentBlockLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksContentDynamicSlotUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksContentDynamicSlotUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksMessageUsagesArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksMessageUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_content_blocks" */
export type CepContentBlocksRowJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_content_blocks" */
export type CepContentBlocksAggregate = {
  __typename?: 'cep_content_blocks_aggregate';
  aggregate?: Maybe<CepContentBlocksAggregateFields>;
  nodes: Array<CepContentBlocks>;
};

/** aggregate fields of "cep_content_blocks" */
export type CepContentBlocksAggregateFields = {
  __typename?: 'cep_content_blocks_aggregate_fields';
  avg?: Maybe<CepContentBlocksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepContentBlocksMaxFields>;
  min?: Maybe<CepContentBlocksMinFields>;
  stddev?: Maybe<CepContentBlocksStddevFields>;
  stddev_pop?: Maybe<CepContentBlocksStddevPopFields>;
  stddev_samp?: Maybe<CepContentBlocksStddevSampFields>;
  sum?: Maybe<CepContentBlocksSumFields>;
  var_pop?: Maybe<CepContentBlocksVarPopFields>;
  var_samp?: Maybe<CepContentBlocksVarSampFields>;
  variance?: Maybe<CepContentBlocksVarianceFields>;
};


/** aggregate fields of "cep_content_blocks" */
export type CepContentBlocksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepContentBlocksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepContentBlocksAppendInput = {
  row_json?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CepContentBlocksAvgFields = {
  __typename?: 'cep_content_blocks_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_content_blocks". All fields are combined with a logical 'AND'. */
export type CepContentBlocksBoolExp = {
  _and?: InputMaybe<Array<CepContentBlocksBoolExp>>;
  _not?: InputMaybe<CepContentBlocksBoolExp>;
  _or?: InputMaybe<Array<CepContentBlocksBoolExp>>;
  available_in_realtime?: InputMaybe<BooleanComparisonExp>;
  brand_settings?: InputMaybe<CepBrandSettingsBoolExp>;
  cep_brand_id?: InputMaybe<UuidComparisonExp>;
  component_type?: InputMaybe<StringComparisonExp>;
  content_block_labels?: InputMaybe<ContentBlockLabelsBoolExp>;
  content_block_labels_aggregate?: InputMaybe<ContentBlockLabelsAggregateBoolExp>;
  content_dynamic_slot_usages?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  message_usages?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
  message_usages_aggregate?: InputMaybe<CepContentBlockMessageUsagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  raw_html?: InputMaybe<StringComparisonExp>;
  row_html?: InputMaybe<StringComparisonExp>;
  row_json?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_content_blocks" */
export const CepContentBlocksConstraint = {
  /** unique or primary key constraint on columns "id" */
  CepContentBlocksPkey: 'cep_content_blocks_pkey',
  /** unique or primary key constraint on columns "workspace_id", "cep_brand_id" */
  CepContentBlocksUniqueFooterPerBrandIdx: 'cep_content_blocks_unique_footer_per_brand_idx',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepContentBlocksWorkspaceIdIdKey: 'cep_content_blocks_workspace_id_id_key'
} as const;

export type CepContentBlocksConstraint = typeof CepContentBlocksConstraint[keyof typeof CepContentBlocksConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepContentBlocksDeleteAtPathInput = {
  row_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepContentBlocksDeleteElemInput = {
  row_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepContentBlocksDeleteKeyInput = {
  row_json?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_content_blocks" */
export type CepContentBlocksInsertInput = {
  available_in_realtime?: InputMaybe<Scalars['Boolean']>;
  brand_settings?: InputMaybe<CepBrandSettingsObjRelInsertInput>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  component_type?: InputMaybe<Scalars['String']>;
  content_block_labels?: InputMaybe<ContentBlockLabelsArrRelInsertInput>;
  content_dynamic_slot_usages?: InputMaybe<ContentDynamicSlotUsagesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  raw_html?: InputMaybe<Scalars['String']>;
  row_html?: InputMaybe<Scalars['String']>;
  row_json?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CepContentBlocksMaxFields = {
  __typename?: 'cep_content_blocks_max_fields';
  cep_brand_id?: Maybe<Scalars['uuid']>;
  component_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  raw_html?: Maybe<Scalars['String']>;
  row_html?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepContentBlocksMinFields = {
  __typename?: 'cep_content_blocks_min_fields';
  cep_brand_id?: Maybe<Scalars['uuid']>;
  component_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  raw_html?: Maybe<Scalars['String']>;
  row_html?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_content_blocks" */
export type CepContentBlocksMutationResponse = {
  __typename?: 'cep_content_blocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepContentBlocks>;
};

/** input type for inserting object relation for remote table "cep_content_blocks" */
export type CepContentBlocksObjRelInsertInput = {
  data: CepContentBlocksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepContentBlocksOnConflict>;
};

/** on_conflict condition type for table "cep_content_blocks" */
export type CepContentBlocksOnConflict = {
  constraint: CepContentBlocksConstraint;
  update_columns?: Array<CepContentBlocksUpdateColumn>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};

/** Ordering options when selecting data from "cep_content_blocks". */
export type CepContentBlocksOrderBy = {
  available_in_realtime?: InputMaybe<OrderBy>;
  brand_settings?: InputMaybe<CepBrandSettingsOrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  component_type?: InputMaybe<OrderBy>;
  content_block_labels_aggregate?: InputMaybe<ContentBlockLabelsAggregateOrderBy>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  message_usages_aggregate?: InputMaybe<CepContentBlockMessageUsagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  raw_html?: InputMaybe<OrderBy>;
  row_html?: InputMaybe<OrderBy>;
  row_json?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_content_blocks */
export type CepContentBlocksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepContentBlocksPrependInput = {
  row_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_content_blocks" */
export const CepContentBlocksSelectColumn = {
  /** column name */
  AvailableInRealtime: 'available_in_realtime',
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  ComponentType: 'component_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  Name: 'name',
  /** column name */
  RawHtml: 'raw_html',
  /** column name */
  RowHtml: 'row_html',
  /** column name */
  RowJson: 'row_json',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepContentBlocksSelectColumn = typeof CepContentBlocksSelectColumn[keyof typeof CepContentBlocksSelectColumn];
/** input type for updating data in table "cep_content_blocks" */
export type CepContentBlocksSetInput = {
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  component_type?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  raw_html?: InputMaybe<Scalars['String']>;
  row_html?: InputMaybe<Scalars['String']>;
  row_json?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CepContentBlocksStddevFields = {
  __typename?: 'cep_content_blocks_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepContentBlocksStddevPopFields = {
  __typename?: 'cep_content_blocks_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepContentBlocksStddevSampFields = {
  __typename?: 'cep_content_blocks_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_content_blocks" */
export type CepContentBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepContentBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepContentBlocksStreamCursorValueInput = {
  available_in_realtime?: InputMaybe<Scalars['Boolean']>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  component_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  raw_html?: InputMaybe<Scalars['String']>;
  row_html?: InputMaybe<Scalars['String']>;
  row_json?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepContentBlocksSumFields = {
  __typename?: 'cep_content_blocks_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_content_blocks" */
export const CepContentBlocksUpdateColumn = {
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  ComponentType: 'component_type',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Name: 'name',
  /** column name */
  RawHtml: 'raw_html',
  /** column name */
  RowHtml: 'row_html',
  /** column name */
  RowJson: 'row_json'
} as const;

export type CepContentBlocksUpdateColumn = typeof CepContentBlocksUpdateColumn[keyof typeof CepContentBlocksUpdateColumn];
export type CepContentBlocksUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepContentBlocksAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepContentBlocksDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepContentBlocksDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepContentBlocksDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepContentBlocksPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepContentBlocksSetInput>;
  /** filter the rows which have to be updated */
  where: CepContentBlocksBoolExp;
};

/** aggregate var_pop on columns */
export type CepContentBlocksVarPopFields = {
  __typename?: 'cep_content_blocks_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepContentBlocksVarSampFields = {
  __typename?: 'cep_content_blocks_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepContentBlocksVarianceFields = {
  __typename?: 'cep_content_blocks_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_device_previews" */
export type CepDevicePreviews = {
  __typename?: 'cep_device_previews';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  provider: Scalars['String'];
  provider_id: Scalars['String'];
  template: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_device_previews" */
export type CepDevicePreviewsTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_device_previews" */
export type CepDevicePreviewsAggregate = {
  __typename?: 'cep_device_previews_aggregate';
  aggregate?: Maybe<CepDevicePreviewsAggregateFields>;
  nodes: Array<CepDevicePreviews>;
};

/** aggregate fields of "cep_device_previews" */
export type CepDevicePreviewsAggregateFields = {
  __typename?: 'cep_device_previews_aggregate_fields';
  avg?: Maybe<CepDevicePreviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepDevicePreviewsMaxFields>;
  min?: Maybe<CepDevicePreviewsMinFields>;
  stddev?: Maybe<CepDevicePreviewsStddevFields>;
  stddev_pop?: Maybe<CepDevicePreviewsStddevPopFields>;
  stddev_samp?: Maybe<CepDevicePreviewsStddevSampFields>;
  sum?: Maybe<CepDevicePreviewsSumFields>;
  var_pop?: Maybe<CepDevicePreviewsVarPopFields>;
  var_samp?: Maybe<CepDevicePreviewsVarSampFields>;
  variance?: Maybe<CepDevicePreviewsVarianceFields>;
};


/** aggregate fields of "cep_device_previews" */
export type CepDevicePreviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepDevicePreviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepDevicePreviewsAvgFields = {
  __typename?: 'cep_device_previews_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_device_previews". All fields are combined with a logical 'AND'. */
export type CepDevicePreviewsBoolExp = {
  _and?: InputMaybe<Array<CepDevicePreviewsBoolExp>>;
  _not?: InputMaybe<CepDevicePreviewsBoolExp>;
  _or?: InputMaybe<Array<CepDevicePreviewsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  template?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepDevicePreviewsMaxFields = {
  __typename?: 'cep_device_previews_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepDevicePreviewsMinFields = {
  __typename?: 'cep_device_previews_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "cep_device_previews". */
export type CepDevicePreviewsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_device_previews" */
export const CepDevicePreviewsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Provider: 'provider',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  Template: 'template',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepDevicePreviewsSelectColumn = typeof CepDevicePreviewsSelectColumn[keyof typeof CepDevicePreviewsSelectColumn];
/** aggregate stddev on columns */
export type CepDevicePreviewsStddevFields = {
  __typename?: 'cep_device_previews_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepDevicePreviewsStddevPopFields = {
  __typename?: 'cep_device_previews_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepDevicePreviewsStddevSampFields = {
  __typename?: 'cep_device_previews_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_device_previews" */
export type CepDevicePreviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepDevicePreviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepDevicePreviewsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepDevicePreviewsSumFields = {
  __typename?: 'cep_device_previews_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CepDevicePreviewsVarPopFields = {
  __typename?: 'cep_device_previews_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepDevicePreviewsVarSampFields = {
  __typename?: 'cep_device_previews_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepDevicePreviewsVarianceFields = {
  __typename?: 'cep_device_previews_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_domains" */
export type CepDomains = {
  __typename?: 'cep_domains';
  /** An object relationship */
  cep_provider?: Maybe<CepProviders>;
  cep_provider_id?: Maybe<Scalars['uuid']>;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  domain: Scalars['String'];
  domain_type: Scalars['String'];
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_domains" */
export type CepDomainsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_domains" */
export type CepDomainsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_domains" */
export type CepDomainsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_domains" */
export type CepDomainsAggregate = {
  __typename?: 'cep_domains_aggregate';
  aggregate?: Maybe<CepDomainsAggregateFields>;
  nodes: Array<CepDomains>;
};

export type CepDomainsAggregateBoolExp = {
  count?: InputMaybe<CepDomainsAggregateBoolExpCount>;
};

export type CepDomainsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepDomainsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepDomainsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_domains" */
export type CepDomainsAggregateFields = {
  __typename?: 'cep_domains_aggregate_fields';
  avg?: Maybe<CepDomainsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepDomainsMaxFields>;
  min?: Maybe<CepDomainsMinFields>;
  stddev?: Maybe<CepDomainsStddevFields>;
  stddev_pop?: Maybe<CepDomainsStddevPopFields>;
  stddev_samp?: Maybe<CepDomainsStddevSampFields>;
  sum?: Maybe<CepDomainsSumFields>;
  var_pop?: Maybe<CepDomainsVarPopFields>;
  var_samp?: Maybe<CepDomainsVarSampFields>;
  variance?: Maybe<CepDomainsVarianceFields>;
};


/** aggregate fields of "cep_domains" */
export type CepDomainsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepDomainsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_domains" */
export type CepDomainsAggregateOrderBy = {
  avg?: InputMaybe<CepDomainsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepDomainsMaxOrderBy>;
  min?: InputMaybe<CepDomainsMinOrderBy>;
  stddev?: InputMaybe<CepDomainsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepDomainsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepDomainsStddevSampOrderBy>;
  sum?: InputMaybe<CepDomainsSumOrderBy>;
  var_pop?: InputMaybe<CepDomainsVarPopOrderBy>;
  var_samp?: InputMaybe<CepDomainsVarSampOrderBy>;
  variance?: InputMaybe<CepDomainsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepDomainsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "cep_domains" */
export type CepDomainsArrRelInsertInput = {
  data: Array<CepDomainsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepDomainsOnConflict>;
};

/** aggregate avg on columns */
export type CepDomainsAvgFields = {
  __typename?: 'cep_domains_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_domains" */
export type CepDomainsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_domains". All fields are combined with a logical 'AND'. */
export type CepDomainsBoolExp = {
  _and?: InputMaybe<Array<CepDomainsBoolExp>>;
  _not?: InputMaybe<CepDomainsBoolExp>;
  _or?: InputMaybe<Array<CepDomainsBoolExp>>;
  cep_provider?: InputMaybe<CepProvidersBoolExp>;
  cep_provider_id?: InputMaybe<UuidComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  domain?: InputMaybe<StringComparisonExp>;
  domain_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_domains" */
export const CepDomainsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepDomainsIdWorkspaceIdKey: 'cep_domains_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepDomainsPkey: 'cep_domains_pkey'
} as const;

export type CepDomainsConstraint = typeof CepDomainsConstraint[keyof typeof CepDomainsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepDomainsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepDomainsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepDomainsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_domains" */
export type CepDomainsInsertInput = {
  cep_provider?: InputMaybe<CepProvidersObjRelInsertInput>;
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  domain?: InputMaybe<Scalars['String']>;
  domain_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CepDomainsMaxFields = {
  __typename?: 'cep_domains_max_fields';
  cep_provider_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  domain?: Maybe<Scalars['String']>;
  domain_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_domains" */
export type CepDomainsMaxOrderBy = {
  cep_provider_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  domain_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepDomainsMinFields = {
  __typename?: 'cep_domains_min_fields';
  cep_provider_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  domain?: Maybe<Scalars['String']>;
  domain_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_domains" */
export type CepDomainsMinOrderBy = {
  cep_provider_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  domain_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_domains" */
export type CepDomainsMutationResponse = {
  __typename?: 'cep_domains_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepDomains>;
};

/** on_conflict condition type for table "cep_domains" */
export type CepDomainsOnConflict = {
  constraint: CepDomainsConstraint;
  update_columns?: Array<CepDomainsUpdateColumn>;
  where?: InputMaybe<CepDomainsBoolExp>;
};

/** Ordering options when selecting data from "cep_domains". */
export type CepDomainsOrderBy = {
  cep_provider?: InputMaybe<CepProvidersOrderBy>;
  cep_provider_id?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  domain?: InputMaybe<OrderBy>;
  domain_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_domains */
export type CepDomainsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepDomainsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_domains" */
export const CepDomainsSelectColumn = {
  /** column name */
  CepProviderId: 'cep_provider_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Domain: 'domain',
  /** column name */
  DomainType: 'domain_type',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepDomainsSelectColumn = typeof CepDomainsSelectColumn[keyof typeof CepDomainsSelectColumn];
/** input type for updating data in table "cep_domains" */
export type CepDomainsSetInput = {
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  domain?: InputMaybe<Scalars['String']>;
  domain_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepDomainsStddevFields = {
  __typename?: 'cep_domains_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_domains" */
export type CepDomainsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepDomainsStddevPopFields = {
  __typename?: 'cep_domains_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_domains" */
export type CepDomainsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepDomainsStddevSampFields = {
  __typename?: 'cep_domains_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_domains" */
export type CepDomainsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_domains" */
export type CepDomainsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepDomainsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepDomainsStreamCursorValueInput = {
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  domain?: InputMaybe<Scalars['String']>;
  domain_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepDomainsSumFields = {
  __typename?: 'cep_domains_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_domains" */
export type CepDomainsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "cep_domains" */
export const CepDomainsUpdateColumn = {
  /** column name */
  CepProviderId: 'cep_provider_id',
  /** column name */
  Config: 'config',
  /** column name */
  Domain: 'domain',
  /** column name */
  DomainType: 'domain_type',
  /** column name */
  Name: 'name'
} as const;

export type CepDomainsUpdateColumn = typeof CepDomainsUpdateColumn[keyof typeof CepDomainsUpdateColumn];
export type CepDomainsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepDomainsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepDomainsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepDomainsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepDomainsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepDomainsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepDomainsSetInput>;
  /** filter the rows which have to be updated */
  where: CepDomainsBoolExp;
};

/** aggregate var_pop on columns */
export type CepDomainsVarPopFields = {
  __typename?: 'cep_domains_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_domains" */
export type CepDomainsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepDomainsVarSampFields = {
  __typename?: 'cep_domains_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_domains" */
export type CepDomainsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepDomainsVarianceFields = {
  __typename?: 'cep_domains_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_domains" */
export type CepDomainsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContents = {
  __typename?: 'cep_email_template_contents';
  /** An object relationship */
  cep_email_template: CepEmailTemplates;
  cep_email_template_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  editor_state?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings: Scalars['jsonb'];
  rendered_output?: Maybe<Scalars['jsonb']>;
  subject?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContentsEditorStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContentsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContentsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContentsProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_email_template_contents" */
export type CepEmailTemplateContentsRenderedOutputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_email_template_contents" */
export type CepEmailTemplateContentsAggregate = {
  __typename?: 'cep_email_template_contents_aggregate';
  aggregate?: Maybe<CepEmailTemplateContentsAggregateFields>;
  nodes: Array<CepEmailTemplateContents>;
};

export type CepEmailTemplateContentsAggregateBoolExp = {
  count?: InputMaybe<CepEmailTemplateContentsAggregateBoolExpCount>;
};

export type CepEmailTemplateContentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepEmailTemplateContentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_email_template_contents" */
export type CepEmailTemplateContentsAggregateFields = {
  __typename?: 'cep_email_template_contents_aggregate_fields';
  avg?: Maybe<CepEmailTemplateContentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepEmailTemplateContentsMaxFields>;
  min?: Maybe<CepEmailTemplateContentsMinFields>;
  stddev?: Maybe<CepEmailTemplateContentsStddevFields>;
  stddev_pop?: Maybe<CepEmailTemplateContentsStddevPopFields>;
  stddev_samp?: Maybe<CepEmailTemplateContentsStddevSampFields>;
  sum?: Maybe<CepEmailTemplateContentsSumFields>;
  var_pop?: Maybe<CepEmailTemplateContentsVarPopFields>;
  var_samp?: Maybe<CepEmailTemplateContentsVarSampFields>;
  variance?: Maybe<CepEmailTemplateContentsVarianceFields>;
};


/** aggregate fields of "cep_email_template_contents" */
export type CepEmailTemplateContentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_email_template_contents" */
export type CepEmailTemplateContentsAggregateOrderBy = {
  avg?: InputMaybe<CepEmailTemplateContentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepEmailTemplateContentsMaxOrderBy>;
  min?: InputMaybe<CepEmailTemplateContentsMinOrderBy>;
  stddev?: InputMaybe<CepEmailTemplateContentsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepEmailTemplateContentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepEmailTemplateContentsStddevSampOrderBy>;
  sum?: InputMaybe<CepEmailTemplateContentsSumOrderBy>;
  var_pop?: InputMaybe<CepEmailTemplateContentsVarPopOrderBy>;
  var_samp?: InputMaybe<CepEmailTemplateContentsVarSampOrderBy>;
  variance?: InputMaybe<CepEmailTemplateContentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepEmailTemplateContentsAppendInput = {
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "cep_email_template_contents" */
export type CepEmailTemplateContentsArrRelInsertInput = {
  data: Array<CepEmailTemplateContentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepEmailTemplateContentsOnConflict>;
};

/** aggregate avg on columns */
export type CepEmailTemplateContentsAvgFields = {
  __typename?: 'cep_email_template_contents_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_email_template_contents". All fields are combined with a logical 'AND'. */
export type CepEmailTemplateContentsBoolExp = {
  _and?: InputMaybe<Array<CepEmailTemplateContentsBoolExp>>;
  _not?: InputMaybe<CepEmailTemplateContentsBoolExp>;
  _or?: InputMaybe<Array<CepEmailTemplateContentsBoolExp>>;
  cep_email_template?: InputMaybe<CepEmailTemplatesBoolExp>;
  cep_email_template_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  editor_state?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  rendered_output?: InputMaybe<JsonbComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_email_template_contents" */
export const CepEmailTemplateContentsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepEmailTemplateContentsIdWorkspaceIdKey: 'cep_email_template_contents_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepEmailTemplateContentsPkey: 'cep_email_template_contents_pkey',
  /** unique or primary key constraint on columns "cep_email_template_id", "version" */
  CepEmailTemplateContentsTemplateIdVersionKey: 'cep_email_template_contents_template_id_version_key'
} as const;

export type CepEmailTemplateContentsConstraint = typeof CepEmailTemplateContentsConstraint[keyof typeof CepEmailTemplateContentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepEmailTemplateContentsDeleteAtPathInput = {
  profile_mappings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepEmailTemplateContentsDeleteElemInput = {
  profile_mappings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepEmailTemplateContentsDeleteKeyInput = {
  profile_mappings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_email_template_contents" */
export type CepEmailTemplateContentsInsertInput = {
  cep_email_template?: InputMaybe<CepEmailTemplatesObjRelInsertInput>;
  cep_email_template_id?: InputMaybe<Scalars['uuid']>;
  editor_state?: InputMaybe<Scalars['jsonb']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CepEmailTemplateContentsMaxFields = {
  __typename?: 'cep_email_template_contents_max_fields';
  cep_email_template_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsMaxOrderBy = {
  cep_email_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepEmailTemplateContentsMinFields = {
  __typename?: 'cep_email_template_contents_min_fields';
  cep_email_template_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsMinOrderBy = {
  cep_email_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_email_template_contents" */
export type CepEmailTemplateContentsMutationResponse = {
  __typename?: 'cep_email_template_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepEmailTemplateContents>;
};

/** input type for inserting object relation for remote table "cep_email_template_contents" */
export type CepEmailTemplateContentsObjRelInsertInput = {
  data: CepEmailTemplateContentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepEmailTemplateContentsOnConflict>;
};

/** on_conflict condition type for table "cep_email_template_contents" */
export type CepEmailTemplateContentsOnConflict = {
  constraint: CepEmailTemplateContentsConstraint;
  update_columns?: Array<CepEmailTemplateContentsUpdateColumn>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};

/** Ordering options when selecting data from "cep_email_template_contents". */
export type CepEmailTemplateContentsOrderBy = {
  cep_email_template?: InputMaybe<CepEmailTemplatesOrderBy>;
  cep_email_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  editor_state?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  preheader?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  rendered_output?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_email_template_contents */
export type CepEmailTemplateContentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepEmailTemplateContentsPrependInput = {
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_email_template_contents" */
export const CepEmailTemplateContentsSelectColumn = {
  /** column name */
  CepEmailTemplateId: 'cep_email_template_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EditorState: 'editor_state',
  /** column name */
  Id: 'id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  RenderedOutput: 'rendered_output',
  /** column name */
  Subject: 'subject',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepEmailTemplateContentsSelectColumn = typeof CepEmailTemplateContentsSelectColumn[keyof typeof CepEmailTemplateContentsSelectColumn];
/** input type for updating data in table "cep_email_template_contents" */
export type CepEmailTemplateContentsSetInput = {
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepEmailTemplateContentsStddevFields = {
  __typename?: 'cep_email_template_contents_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepEmailTemplateContentsStddevPopFields = {
  __typename?: 'cep_email_template_contents_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepEmailTemplateContentsStddevSampFields = {
  __typename?: 'cep_email_template_contents_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_email_template_contents" */
export type CepEmailTemplateContentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepEmailTemplateContentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepEmailTemplateContentsStreamCursorValueInput = {
  cep_email_template_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  editor_state?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepEmailTemplateContentsSumFields = {
  __typename?: 'cep_email_template_contents_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "cep_email_template_contents" */
export const CepEmailTemplateContentsUpdateColumn = {
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  Subject: 'subject'
} as const;

export type CepEmailTemplateContentsUpdateColumn = typeof CepEmailTemplateContentsUpdateColumn[keyof typeof CepEmailTemplateContentsUpdateColumn];
export type CepEmailTemplateContentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepEmailTemplateContentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepEmailTemplateContentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepEmailTemplateContentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepEmailTemplateContentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepEmailTemplateContentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepEmailTemplateContentsSetInput>;
  /** filter the rows which have to be updated */
  where: CepEmailTemplateContentsBoolExp;
};

/** aggregate var_pop on columns */
export type CepEmailTemplateContentsVarPopFields = {
  __typename?: 'cep_email_template_contents_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepEmailTemplateContentsVarSampFields = {
  __typename?: 'cep_email_template_contents_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepEmailTemplateContentsVarianceFields = {
  __typename?: 'cep_email_template_contents_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_email_template_contents" */
export type CepEmailTemplateContentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplates = {
  __typename?: 'cep_email_templates';
  available_in_realtime: Scalars['Boolean'];
  /** An object relationship */
  brand_settings?: Maybe<CepBrandSettings>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  cep_email_template_contents: Array<CepEmailTemplateContents>;
  /** An aggregate relationship */
  cep_email_template_contents_aggregate: CepEmailTemplateContentsAggregate;
  /** An object relationship */
  cep_sender_identity?: Maybe<CepSenderIdentities>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cep_subscription_topic?: Maybe<CepSubscriptionTopics>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  current_content?: Maybe<CepEmailTemplateContents>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  device_preview?: Maybe<CepDevicePreviews>;
  /** An array relationship */
  email_template_labels: Array<EmailTemplateLabels>;
  /** An aggregate relationship */
  email_template_labels_aggregate: EmailTemplateLabelsAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  published_version: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesCepEmailTemplateContentsArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesCepEmailTemplateContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesEmailTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesEmailTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_email_templates" */
export type CepEmailTemplatesNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_email_templates" */
export type CepEmailTemplatesAggregate = {
  __typename?: 'cep_email_templates_aggregate';
  aggregate?: Maybe<CepEmailTemplatesAggregateFields>;
  nodes: Array<CepEmailTemplates>;
};

/** aggregate fields of "cep_email_templates" */
export type CepEmailTemplatesAggregateFields = {
  __typename?: 'cep_email_templates_aggregate_fields';
  avg?: Maybe<CepEmailTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepEmailTemplatesMaxFields>;
  min?: Maybe<CepEmailTemplatesMinFields>;
  stddev?: Maybe<CepEmailTemplatesStddevFields>;
  stddev_pop?: Maybe<CepEmailTemplatesStddevPopFields>;
  stddev_samp?: Maybe<CepEmailTemplatesStddevSampFields>;
  sum?: Maybe<CepEmailTemplatesSumFields>;
  var_pop?: Maybe<CepEmailTemplatesVarPopFields>;
  var_samp?: Maybe<CepEmailTemplatesVarSampFields>;
  variance?: Maybe<CepEmailTemplatesVarianceFields>;
};


/** aggregate fields of "cep_email_templates" */
export type CepEmailTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepEmailTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepEmailTemplatesAvgFields = {
  __typename?: 'cep_email_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_email_templates". All fields are combined with a logical 'AND'. */
export type CepEmailTemplatesBoolExp = {
  _and?: InputMaybe<Array<CepEmailTemplatesBoolExp>>;
  _not?: InputMaybe<CepEmailTemplatesBoolExp>;
  _or?: InputMaybe<Array<CepEmailTemplatesBoolExp>>;
  available_in_realtime?: InputMaybe<BooleanComparisonExp>;
  brand_settings?: InputMaybe<CepBrandSettingsBoolExp>;
  cep_brand_id?: InputMaybe<UuidComparisonExp>;
  cep_device_preview_id?: InputMaybe<UuidComparisonExp>;
  cep_email_template_contents?: InputMaybe<CepEmailTemplateContentsBoolExp>;
  cep_email_template_contents_aggregate?: InputMaybe<CepEmailTemplateContentsAggregateBoolExp>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesBoolExp>;
  cep_sender_identity_id?: InputMaybe<UuidComparisonExp>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topic_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  current_content?: InputMaybe<CepEmailTemplateContentsBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  device_preview?: InputMaybe<CepDevicePreviewsBoolExp>;
  email_template_labels?: InputMaybe<EmailTemplateLabelsBoolExp>;
  email_template_labels_aggregate?: InputMaybe<EmailTemplateLabelsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  published_version?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_email_templates" */
export const CepEmailTemplatesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepEmailTemplatesIdWorkspaceIdKey: 'cep_email_templates_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepEmailTemplatesPkey: 'cep_email_templates_pkey'
} as const;

export type CepEmailTemplatesConstraint = typeof CepEmailTemplatesConstraint[keyof typeof CepEmailTemplatesConstraint];
/** input type for incrementing numeric columns in table "cep_email_templates" */
export type CepEmailTemplatesIncInput = {
  published_version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cep_email_templates" */
export type CepEmailTemplatesInsertInput = {
  available_in_realtime?: InputMaybe<Scalars['Boolean']>;
  brand_settings?: InputMaybe<CepBrandSettingsObjRelInsertInput>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_email_template_contents?: InputMaybe<CepEmailTemplateContentsArrRelInsertInput>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesObjRelInsertInput>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsObjRelInsertInput>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  current_content?: InputMaybe<CepEmailTemplateContentsObjRelInsertInput>;
  email_template_labels?: InputMaybe<EmailTemplateLabelsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CepEmailTemplatesMaxFields = {
  __typename?: 'cep_email_templates_max_fields';
  cep_brand_id?: Maybe<Scalars['uuid']>;
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  published_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepEmailTemplatesMinFields = {
  __typename?: 'cep_email_templates_min_fields';
  cep_brand_id?: Maybe<Scalars['uuid']>;
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  published_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_email_templates" */
export type CepEmailTemplatesMutationResponse = {
  __typename?: 'cep_email_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepEmailTemplates>;
};

/** input type for inserting object relation for remote table "cep_email_templates" */
export type CepEmailTemplatesObjRelInsertInput = {
  data: CepEmailTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepEmailTemplatesOnConflict>;
};

/** on_conflict condition type for table "cep_email_templates" */
export type CepEmailTemplatesOnConflict = {
  constraint: CepEmailTemplatesConstraint;
  update_columns?: Array<CepEmailTemplatesUpdateColumn>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};

/** Ordering options when selecting data from "cep_email_templates". */
export type CepEmailTemplatesOrderBy = {
  available_in_realtime?: InputMaybe<OrderBy>;
  brand_settings?: InputMaybe<CepBrandSettingsOrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  cep_device_preview_id?: InputMaybe<OrderBy>;
  cep_email_template_contents_aggregate?: InputMaybe<CepEmailTemplateContentsAggregateOrderBy>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesOrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsOrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  current_content?: InputMaybe<CepEmailTemplateContentsOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  device_preview?: InputMaybe<CepDevicePreviewsOrderBy>;
  email_template_labels_aggregate?: InputMaybe<EmailTemplateLabelsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_email_templates */
export type CepEmailTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_email_templates" */
export const CepEmailTemplatesSelectColumn = {
  /** column name */
  AvailableInRealtime: 'available_in_realtime',
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  CepDevicePreviewId: 'cep_device_preview_id',
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PublishedVersion: 'published_version',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepEmailTemplatesSelectColumn = typeof CepEmailTemplatesSelectColumn[keyof typeof CepEmailTemplatesSelectColumn];
/** input type for updating data in table "cep_email_templates" */
export type CepEmailTemplatesSetInput = {
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  published_version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CepEmailTemplatesStddevFields = {
  __typename?: 'cep_email_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepEmailTemplatesStddevPopFields = {
  __typename?: 'cep_email_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepEmailTemplatesStddevSampFields = {
  __typename?: 'cep_email_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_email_templates" */
export type CepEmailTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepEmailTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepEmailTemplatesStreamCursorValueInput = {
  available_in_realtime?: InputMaybe<Scalars['Boolean']>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_device_preview_id?: InputMaybe<Scalars['uuid']>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  published_version?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepEmailTemplatesSumFields = {
  __typename?: 'cep_email_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  published_version?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_email_templates" */
export const CepEmailTemplatesUpdateColumn = {
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Name: 'name',
  /** column name */
  PublishedVersion: 'published_version'
} as const;

export type CepEmailTemplatesUpdateColumn = typeof CepEmailTemplatesUpdateColumn[keyof typeof CepEmailTemplatesUpdateColumn];
export type CepEmailTemplatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CepEmailTemplatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepEmailTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: CepEmailTemplatesBoolExp;
};

/** aggregate var_pop on columns */
export type CepEmailTemplatesVarPopFields = {
  __typename?: 'cep_email_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepEmailTemplatesVarSampFields = {
  __typename?: 'cep_email_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepEmailTemplatesVarianceFields = {
  __typename?: 'cep_email_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_inapp_message_contents" */
export type CepInappMessageContents = {
  __typename?: 'cep_inapp_message_contents';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  instance_values: Scalars['jsonb'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  /** An object relationship */
  template: CepInappMessageTemplates;
  template_id: Scalars['uuid'];
  template_version: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_inapp_message_contents" */
export type CepInappMessageContentsInstanceValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_inapp_message_contents" */
export type CepInappMessageContentsAggregate = {
  __typename?: 'cep_inapp_message_contents_aggregate';
  aggregate?: Maybe<CepInappMessageContentsAggregateFields>;
  nodes: Array<CepInappMessageContents>;
};

export type CepInappMessageContentsAggregateBoolExp = {
  count?: InputMaybe<CepInappMessageContentsAggregateBoolExpCount>;
};

export type CepInappMessageContentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepInappMessageContentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_inapp_message_contents" */
export type CepInappMessageContentsAggregateFields = {
  __typename?: 'cep_inapp_message_contents_aggregate_fields';
  avg?: Maybe<CepInappMessageContentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepInappMessageContentsMaxFields>;
  min?: Maybe<CepInappMessageContentsMinFields>;
  stddev?: Maybe<CepInappMessageContentsStddevFields>;
  stddev_pop?: Maybe<CepInappMessageContentsStddevPopFields>;
  stddev_samp?: Maybe<CepInappMessageContentsStddevSampFields>;
  sum?: Maybe<CepInappMessageContentsSumFields>;
  var_pop?: Maybe<CepInappMessageContentsVarPopFields>;
  var_samp?: Maybe<CepInappMessageContentsVarSampFields>;
  variance?: Maybe<CepInappMessageContentsVarianceFields>;
};


/** aggregate fields of "cep_inapp_message_contents" */
export type CepInappMessageContentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_inapp_message_contents" */
export type CepInappMessageContentsAggregateOrderBy = {
  avg?: InputMaybe<CepInappMessageContentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepInappMessageContentsMaxOrderBy>;
  min?: InputMaybe<CepInappMessageContentsMinOrderBy>;
  stddev?: InputMaybe<CepInappMessageContentsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepInappMessageContentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepInappMessageContentsStddevSampOrderBy>;
  sum?: InputMaybe<CepInappMessageContentsSumOrderBy>;
  var_pop?: InputMaybe<CepInappMessageContentsVarPopOrderBy>;
  var_samp?: InputMaybe<CepInappMessageContentsVarSampOrderBy>;
  variance?: InputMaybe<CepInappMessageContentsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CepInappMessageContentsAvgFields = {
  __typename?: 'cep_inapp_message_contents_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_inapp_message_contents". All fields are combined with a logical 'AND'. */
export type CepInappMessageContentsBoolExp = {
  _and?: InputMaybe<Array<CepInappMessageContentsBoolExp>>;
  _not?: InputMaybe<CepInappMessageContentsBoolExp>;
  _or?: InputMaybe<Array<CepInappMessageContentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instance_values?: InputMaybe<JsonbComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  template?: InputMaybe<CepInappMessageTemplatesBoolExp>;
  template_id?: InputMaybe<UuidComparisonExp>;
  template_version?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepInappMessageContentsMaxFields = {
  __typename?: 'cep_inapp_message_contents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  template_id?: Maybe<Scalars['uuid']>;
  template_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  template_id?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepInappMessageContentsMinFields = {
  __typename?: 'cep_inapp_message_contents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  template_id?: Maybe<Scalars['uuid']>;
  template_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  template_id?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cep_inapp_message_contents". */
export type CepInappMessageContentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  instance_values?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<CepInappMessageTemplatesOrderBy>;
  template_id?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_inapp_message_contents" */
export const CepInappMessageContentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  InstanceValues: 'instance_values',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  TemplateId: 'template_id',
  /** column name */
  TemplateVersion: 'template_version',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepInappMessageContentsSelectColumn = typeof CepInappMessageContentsSelectColumn[keyof typeof CepInappMessageContentsSelectColumn];
/** aggregate stddev on columns */
export type CepInappMessageContentsStddevFields = {
  __typename?: 'cep_inapp_message_contents_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepInappMessageContentsStddevPopFields = {
  __typename?: 'cep_inapp_message_contents_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepInappMessageContentsStddevSampFields = {
  __typename?: 'cep_inapp_message_contents_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_inapp_message_contents" */
export type CepInappMessageContentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepInappMessageContentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepInappMessageContentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  instance_values?: InputMaybe<Scalars['jsonb']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  template_version?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepInappMessageContentsSumFields = {
  __typename?: 'cep_inapp_message_contents_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  template_version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CepInappMessageContentsVarPopFields = {
  __typename?: 'cep_inapp_message_contents_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepInappMessageContentsVarSampFields = {
  __typename?: 'cep_inapp_message_contents_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepInappMessageContentsVarianceFields = {
  __typename?: 'cep_inapp_message_contents_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  template_version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_inapp_message_contents" */
export type CepInappMessageContentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  template_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushApps = {
  __typename?: 'cep_inapp_message_template_push_apps';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  push_app: PushApps;
  push_app_id: Scalars['uuid'];
  /** An object relationship */
  template: CepInappMessageTemplates;
  template_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsAggregateOrderBy = {
  avg?: InputMaybe<CepInappMessageTemplatePushAppsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepInappMessageTemplatePushAppsMaxOrderBy>;
  min?: InputMaybe<CepInappMessageTemplatePushAppsMinOrderBy>;
  stddev?: InputMaybe<CepInappMessageTemplatePushAppsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepInappMessageTemplatePushAppsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepInappMessageTemplatePushAppsStddevSampOrderBy>;
  sum?: InputMaybe<CepInappMessageTemplatePushAppsSumOrderBy>;
  var_pop?: InputMaybe<CepInappMessageTemplatePushAppsVarPopOrderBy>;
  var_samp?: InputMaybe<CepInappMessageTemplatePushAppsVarSampOrderBy>;
  variance?: InputMaybe<CepInappMessageTemplatePushAppsVarianceOrderBy>;
};

/** order by avg() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_inapp_message_template_push_apps". All fields are combined with a logical 'AND'. */
export type CepInappMessageTemplatePushAppsBoolExp = {
  _and?: InputMaybe<Array<CepInappMessageTemplatePushAppsBoolExp>>;
  _not?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
  _or?: InputMaybe<Array<CepInappMessageTemplatePushAppsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  push_app?: InputMaybe<PushAppsBoolExp>;
  push_app_id?: InputMaybe<UuidComparisonExp>;
  template?: InputMaybe<CepInappMessageTemplatesBoolExp>;
  template_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cep_inapp_message_template_push_apps". */
export type CepInappMessageTemplatePushAppsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  push_app?: InputMaybe<PushAppsOrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<CepInappMessageTemplatesOrderBy>;
  template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_inapp_message_template_push_apps" */
export const CepInappMessageTemplatePushAppsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  PushAppId: 'push_app_id',
  /** column name */
  TemplateId: 'template_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepInappMessageTemplatePushAppsSelectColumn = typeof CepInappMessageTemplatePushAppsSelectColumn[keyof typeof CepInappMessageTemplatePushAppsSelectColumn];
/** order by stddev() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepInappMessageTemplatePushAppsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepInappMessageTemplatePushAppsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
  template_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "cep_inapp_message_template_push_apps" */
export type CepInappMessageTemplatePushAppsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplates = {
  __typename?: 'cep_inapp_message_templates';
  /** An array relationship */
  contents: Array<CepInappMessageContents>;
  /** An aggregate relationship */
  contents_aggregate: CepInappMessageContentsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  instance_schema: Scalars['jsonb'];
  name: Scalars['String'];
  preview_html?: Maybe<Scalars['String']>;
  /** An array relationship */
  push_apps: Array<CepInappMessageTemplatePushApps>;
  template: Scalars['jsonb'];
  type_set_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesContentsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesInstanceSchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesPushAppsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatePushAppsOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
};


/** columns and relationships of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesAggregate = {
  __typename?: 'cep_inapp_message_templates_aggregate';
  aggregate?: Maybe<CepInappMessageTemplatesAggregateFields>;
  nodes: Array<CepInappMessageTemplates>;
};

/** aggregate fields of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesAggregateFields = {
  __typename?: 'cep_inapp_message_templates_aggregate_fields';
  avg?: Maybe<CepInappMessageTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepInappMessageTemplatesMaxFields>;
  min?: Maybe<CepInappMessageTemplatesMinFields>;
  stddev?: Maybe<CepInappMessageTemplatesStddevFields>;
  stddev_pop?: Maybe<CepInappMessageTemplatesStddevPopFields>;
  stddev_samp?: Maybe<CepInappMessageTemplatesStddevSampFields>;
  sum?: Maybe<CepInappMessageTemplatesSumFields>;
  var_pop?: Maybe<CepInappMessageTemplatesVarPopFields>;
  var_samp?: Maybe<CepInappMessageTemplatesVarSampFields>;
  variance?: Maybe<CepInappMessageTemplatesVarianceFields>;
};


/** aggregate fields of "cep_inapp_message_templates" */
export type CepInappMessageTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepInappMessageTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepInappMessageTemplatesAvgFields = {
  __typename?: 'cep_inapp_message_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_inapp_message_templates". All fields are combined with a logical 'AND'. */
export type CepInappMessageTemplatesBoolExp = {
  _and?: InputMaybe<Array<CepInappMessageTemplatesBoolExp>>;
  _not?: InputMaybe<CepInappMessageTemplatesBoolExp>;
  _or?: InputMaybe<Array<CepInappMessageTemplatesBoolExp>>;
  contents?: InputMaybe<CepInappMessageContentsBoolExp>;
  contents_aggregate?: InputMaybe<CepInappMessageContentsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  instance_schema?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  preview_html?: InputMaybe<StringComparisonExp>;
  push_apps?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
  template?: InputMaybe<JsonbComparisonExp>;
  type_set_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepInappMessageTemplatesMaxFields = {
  __typename?: 'cep_inapp_message_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  preview_html?: Maybe<Scalars['String']>;
  type_set_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepInappMessageTemplatesMinFields = {
  __typename?: 'cep_inapp_message_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  preview_html?: Maybe<Scalars['String']>;
  type_set_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "cep_inapp_message_templates". */
export type CepInappMessageTemplatesOrderBy = {
  contents_aggregate?: InputMaybe<CepInappMessageContentsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  instance_schema?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  preview_html?: InputMaybe<OrderBy>;
  push_apps_aggregate?: InputMaybe<CepInappMessageTemplatePushAppsAggregateOrderBy>;
  template?: InputMaybe<OrderBy>;
  type_set_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_inapp_message_templates" */
export const CepInappMessageTemplatesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  InstanceSchema: 'instance_schema',
  /** column name */
  Name: 'name',
  /** column name */
  PreviewHtml: 'preview_html',
  /** column name */
  Template: 'template',
  /** column name */
  TypeSetId: 'type_set_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepInappMessageTemplatesSelectColumn = typeof CepInappMessageTemplatesSelectColumn[keyof typeof CepInappMessageTemplatesSelectColumn];
/** aggregate stddev on columns */
export type CepInappMessageTemplatesStddevFields = {
  __typename?: 'cep_inapp_message_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepInappMessageTemplatesStddevPopFields = {
  __typename?: 'cep_inapp_message_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepInappMessageTemplatesStddevSampFields = {
  __typename?: 'cep_inapp_message_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_inapp_message_templates" */
export type CepInappMessageTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepInappMessageTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepInappMessageTemplatesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  instance_schema?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  preview_html?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  type_set_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepInappMessageTemplatesSumFields = {
  __typename?: 'cep_inapp_message_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CepInappMessageTemplatesVarPopFields = {
  __typename?: 'cep_inapp_message_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepInappMessageTemplatesVarSampFields = {
  __typename?: 'cep_inapp_message_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepInappMessageTemplatesVarianceFields = {
  __typename?: 'cep_inapp_message_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_locales" */
export type CepLocales = {
  __typename?: 'cep_locales';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  value: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_locales" */
export type CepLocalesNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_locales" */
export type CepLocalesNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_locales" */
export type CepLocalesAggregate = {
  __typename?: 'cep_locales_aggregate';
  aggregate?: Maybe<CepLocalesAggregateFields>;
  nodes: Array<CepLocales>;
};

/** aggregate fields of "cep_locales" */
export type CepLocalesAggregateFields = {
  __typename?: 'cep_locales_aggregate_fields';
  avg?: Maybe<CepLocalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepLocalesMaxFields>;
  min?: Maybe<CepLocalesMinFields>;
  stddev?: Maybe<CepLocalesStddevFields>;
  stddev_pop?: Maybe<CepLocalesStddevPopFields>;
  stddev_samp?: Maybe<CepLocalesStddevSampFields>;
  sum?: Maybe<CepLocalesSumFields>;
  var_pop?: Maybe<CepLocalesVarPopFields>;
  var_samp?: Maybe<CepLocalesVarSampFields>;
  variance?: Maybe<CepLocalesVarianceFields>;
};


/** aggregate fields of "cep_locales" */
export type CepLocalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepLocalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepLocalesAvgFields = {
  __typename?: 'cep_locales_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_locales". All fields are combined with a logical 'AND'. */
export type CepLocalesBoolExp = {
  _and?: InputMaybe<Array<CepLocalesBoolExp>>;
  _not?: InputMaybe<CepLocalesBoolExp>;
  _or?: InputMaybe<Array<CepLocalesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_locales" */
export const CepLocalesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepLocalesIdWorkspaceIdKey: 'cep_locales_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepLocalesPkey: 'cep_locales_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  CepLocalesWorkspaceValueKey: 'cep_locales_workspace_value_key'
} as const;

export type CepLocalesConstraint = typeof CepLocalesConstraint[keyof typeof CepLocalesConstraint];
/** input type for inserting data into table "cep_locales" */
export type CepLocalesInsertInput = {
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CepLocalesMaxFields = {
  __typename?: 'cep_locales_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepLocalesMinFields = {
  __typename?: 'cep_locales_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_locales" */
export type CepLocalesMutationResponse = {
  __typename?: 'cep_locales_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepLocales>;
};

/** input type for inserting object relation for remote table "cep_locales" */
export type CepLocalesObjRelInsertInput = {
  data: CepLocalesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepLocalesOnConflict>;
};

/** on_conflict condition type for table "cep_locales" */
export type CepLocalesOnConflict = {
  constraint: CepLocalesConstraint;
  update_columns?: Array<CepLocalesUpdateColumn>;
  where?: InputMaybe<CepLocalesBoolExp>;
};

/** Ordering options when selecting data from "cep_locales". */
export type CepLocalesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_locales */
export type CepLocalesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_locales" */
export const CepLocalesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Value: 'value',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepLocalesSelectColumn = typeof CepLocalesSelectColumn[keyof typeof CepLocalesSelectColumn];
/** input type for updating data in table "cep_locales" */
export type CepLocalesSetInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepLocalesStddevFields = {
  __typename?: 'cep_locales_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepLocalesStddevPopFields = {
  __typename?: 'cep_locales_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepLocalesStddevSampFields = {
  __typename?: 'cep_locales_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_locales" */
export type CepLocalesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepLocalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepLocalesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepLocalesSumFields = {
  __typename?: 'cep_locales_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_locales" */
export const CepLocalesUpdateColumn = {
  /** column name */
  Value: 'value'
} as const;

export type CepLocalesUpdateColumn = typeof CepLocalesUpdateColumn[keyof typeof CepLocalesUpdateColumn];
export type CepLocalesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepLocalesSetInput>;
  /** filter the rows which have to be updated */
  where: CepLocalesBoolExp;
};

/** aggregate var_pop on columns */
export type CepLocalesVarPopFields = {
  __typename?: 'cep_locales_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepLocalesVarSampFields = {
  __typename?: 'cep_locales_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepLocalesVarianceFields = {
  __typename?: 'cep_locales_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_localization_settings" */
export type CepLocalizationSettings = {
  __typename?: 'cep_localization_settings';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_block?: Maybe<CepContentBlocks>;
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  default_locale: CepLocales;
  default_locale_id: Scalars['uuid'];
  /** An object relationship */
  email_template?: Maybe<CepEmailTemplates>;
  email_template_id?: Maybe<Scalars['uuid']>;
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids: Array<Scalars['uuid']>;
  /** An object relationship */
  message?: Maybe<Messages>;
  message_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  whatsapp_template?: Maybe<CepWhatsappTemplates>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_localization_settings" */
export type CepLocalizationSettingsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_localization_settings" */
export type CepLocalizationSettingsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_localization_settings" */
export type CepLocalizationSettingsAggregate = {
  __typename?: 'cep_localization_settings_aggregate';
  aggregate?: Maybe<CepLocalizationSettingsAggregateFields>;
  nodes: Array<CepLocalizationSettings>;
};

/** aggregate fields of "cep_localization_settings" */
export type CepLocalizationSettingsAggregateFields = {
  __typename?: 'cep_localization_settings_aggregate_fields';
  avg?: Maybe<CepLocalizationSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepLocalizationSettingsMaxFields>;
  min?: Maybe<CepLocalizationSettingsMinFields>;
  stddev?: Maybe<CepLocalizationSettingsStddevFields>;
  stddev_pop?: Maybe<CepLocalizationSettingsStddevPopFields>;
  stddev_samp?: Maybe<CepLocalizationSettingsStddevSampFields>;
  sum?: Maybe<CepLocalizationSettingsSumFields>;
  var_pop?: Maybe<CepLocalizationSettingsVarPopFields>;
  var_samp?: Maybe<CepLocalizationSettingsVarSampFields>;
  variance?: Maybe<CepLocalizationSettingsVarianceFields>;
};


/** aggregate fields of "cep_localization_settings" */
export type CepLocalizationSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepLocalizationSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepLocalizationSettingsAvgFields = {
  __typename?: 'cep_localization_settings_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_localization_settings". All fields are combined with a logical 'AND'. */
export type CepLocalizationSettingsBoolExp = {
  _and?: InputMaybe<Array<CepLocalizationSettingsBoolExp>>;
  _not?: InputMaybe<CepLocalizationSettingsBoolExp>;
  _or?: InputMaybe<Array<CepLocalizationSettingsBoolExp>>;
  cep_whatsapp_template_id?: InputMaybe<UuidComparisonExp>;
  content_block?: InputMaybe<CepContentBlocksBoolExp>;
  content_block_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  default_locale?: InputMaybe<CepLocalesBoolExp>;
  default_locale_id?: InputMaybe<UuidComparisonExp>;
  email_template?: InputMaybe<CepEmailTemplatesBoolExp>;
  email_template_id?: InputMaybe<UuidComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locale_ids?: InputMaybe<UuidArrayComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  whatsapp_template?: InputMaybe<CepWhatsappTemplatesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_localization_settings" */
export const CepLocalizationSettingsConstraint = {
  /** unique or primary key constraint on columns "content_block_id" */
  CepLocalizationSettingsContentBlockKey: 'cep_localization_settings_content_block_key',
  /** unique or primary key constraint on columns "email_template_id" */
  CepLocalizationSettingsEmailTemplateKey: 'cep_localization_settings_email_template_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepLocalizationSettingsIdWorkspaceIdKey: 'cep_localization_settings_id_workspace_id_key',
  /** unique or primary key constraint on columns "message_id" */
  CepLocalizationSettingsMessageKey: 'cep_localization_settings_message_key',
  /** unique or primary key constraint on columns "id" */
  CepLocalizationSettingsPkey: 'cep_localization_settings_pkey',
  /** unique or primary key constraint on columns "cep_whatsapp_template_id" */
  CepLocalizationSettingsWhatsappTemplateKey: 'cep_localization_settings_whatsapp_template_key'
} as const;

export type CepLocalizationSettingsConstraint = typeof CepLocalizationSettingsConstraint[keyof typeof CepLocalizationSettingsConstraint];
/** input type for inserting data into table "cep_localization_settings" */
export type CepLocalizationSettingsInsertInput = {
  content_block?: InputMaybe<CepContentBlocksObjRelInsertInput>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  default_locale?: InputMaybe<CepLocalesObjRelInsertInput>;
  default_locale_id?: InputMaybe<Scalars['uuid']>;
  email_template?: InputMaybe<CepEmailTemplatesObjRelInsertInput>;
  email_template_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids?: InputMaybe<Array<Scalars['uuid']>>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CepLocalizationSettingsMaxFields = {
  __typename?: 'cep_localization_settings_max_fields';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_locale_id?: Maybe<Scalars['uuid']>;
  email_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids?: Maybe<Array<Scalars['uuid']>>;
  message_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepLocalizationSettingsMinFields = {
  __typename?: 'cep_localization_settings_min_fields';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_locale_id?: Maybe<Scalars['uuid']>;
  email_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids?: Maybe<Array<Scalars['uuid']>>;
  message_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_localization_settings" */
export type CepLocalizationSettingsMutationResponse = {
  __typename?: 'cep_localization_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepLocalizationSettings>;
};

/** on_conflict condition type for table "cep_localization_settings" */
export type CepLocalizationSettingsOnConflict = {
  constraint: CepLocalizationSettingsConstraint;
  update_columns?: Array<CepLocalizationSettingsUpdateColumn>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};

/** Ordering options when selecting data from "cep_localization_settings". */
export type CepLocalizationSettingsOrderBy = {
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_block?: InputMaybe<CepContentBlocksOrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  default_locale?: InputMaybe<CepLocalesOrderBy>;
  default_locale_id?: InputMaybe<OrderBy>;
  email_template?: InputMaybe<CepEmailTemplatesOrderBy>;
  email_template_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale_ids?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  whatsapp_template?: InputMaybe<CepWhatsappTemplatesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_localization_settings */
export type CepLocalizationSettingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_localization_settings" */
export const CepLocalizationSettingsSelectColumn = {
  /** column name */
  CepWhatsappTemplateId: 'cep_whatsapp_template_id',
  /** column name */
  ContentBlockId: 'content_block_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DefaultLocaleId: 'default_locale_id',
  /** column name */
  EmailTemplateId: 'email_template_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  LocaleIds: 'locale_ids',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepLocalizationSettingsSelectColumn = typeof CepLocalizationSettingsSelectColumn[keyof typeof CepLocalizationSettingsSelectColumn];
/** input type for updating data in table "cep_localization_settings" */
export type CepLocalizationSettingsSetInput = {
  default_locale_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids?: InputMaybe<Array<Scalars['uuid']>>;
};

/** aggregate stddev on columns */
export type CepLocalizationSettingsStddevFields = {
  __typename?: 'cep_localization_settings_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepLocalizationSettingsStddevPopFields = {
  __typename?: 'cep_localization_settings_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepLocalizationSettingsStddevSampFields = {
  __typename?: 'cep_localization_settings_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_localization_settings" */
export type CepLocalizationSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepLocalizationSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepLocalizationSettingsStreamCursorValueInput = {
  cep_whatsapp_template_id?: InputMaybe<Scalars['uuid']>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  default_locale_id?: InputMaybe<Scalars['uuid']>;
  email_template_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Every locale this owner's copy goes out in, the source locale included when a marketer selected it. A profile whose locale is absent takes cep_workspace_config.localization_fallback instead. Translation targets are this set minus default_locale_id. These ids carry no foreign key, so readers must intersect them against cep_locales for the same workspace_id. */
  locale_ids?: InputMaybe<Array<Scalars['uuid']>>;
  message_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepLocalizationSettingsSumFields = {
  __typename?: 'cep_localization_settings_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_localization_settings" */
export const CepLocalizationSettingsUpdateColumn = {
  /** column name */
  DefaultLocaleId: 'default_locale_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  LocaleIds: 'locale_ids'
} as const;

export type CepLocalizationSettingsUpdateColumn = typeof CepLocalizationSettingsUpdateColumn[keyof typeof CepLocalizationSettingsUpdateColumn];
export type CepLocalizationSettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepLocalizationSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: CepLocalizationSettingsBoolExp;
};

/** aggregate var_pop on columns */
export type CepLocalizationSettingsVarPopFields = {
  __typename?: 'cep_localization_settings_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepLocalizationSettingsVarSampFields = {
  __typename?: 'cep_localization_settings_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepLocalizationSettingsVarianceFields = {
  __typename?: 'cep_localization_settings_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_managed_models" */
export type CepManagedModels = {
  __typename?: 'cep_managed_models';
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "cep_managed_models". All fields are combined with a logical 'AND'. */
export type CepManagedModelsBoolExp = {
  _and?: InputMaybe<Array<CepManagedModelsBoolExp>>;
  _not?: InputMaybe<CepManagedModelsBoolExp>;
  _or?: InputMaybe<Array<CepManagedModelsBoolExp>>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "cep_managed_models". */
export type CepManagedModelsOrderBy = {
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_managed_models" */
export const CepManagedModelsSelectColumn = {
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepManagedModelsSelectColumn = typeof CepManagedModelsSelectColumn[keyof typeof CepManagedModelsSelectColumn];
/** Streaming cursor of the table "cep_managed_models" */
export type CepManagedModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepManagedModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepManagedModelsStreamCursorValueInput = {
  segment_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "cep_message_device_previews" */
export type CepMessageDevicePreviews = {
  __typename?: 'cep_message_device_previews';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  message?: Maybe<Messages>;
  message_id?: Maybe<Scalars['uuid']>;
  provider: Scalars['String'];
  provider_id: Scalars['String'];
  template: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_message_device_previews" */
export type CepMessageDevicePreviewsTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_message_device_previews" */
export type CepMessageDevicePreviewsAggregate = {
  __typename?: 'cep_message_device_previews_aggregate';
  aggregate?: Maybe<CepMessageDevicePreviewsAggregateFields>;
  nodes: Array<CepMessageDevicePreviews>;
};

export type CepMessageDevicePreviewsAggregateBoolExp = {
  count?: InputMaybe<CepMessageDevicePreviewsAggregateBoolExpCount>;
};

export type CepMessageDevicePreviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_message_device_previews" */
export type CepMessageDevicePreviewsAggregateFields = {
  __typename?: 'cep_message_device_previews_aggregate_fields';
  avg?: Maybe<CepMessageDevicePreviewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepMessageDevicePreviewsMaxFields>;
  min?: Maybe<CepMessageDevicePreviewsMinFields>;
  stddev?: Maybe<CepMessageDevicePreviewsStddevFields>;
  stddev_pop?: Maybe<CepMessageDevicePreviewsStddevPopFields>;
  stddev_samp?: Maybe<CepMessageDevicePreviewsStddevSampFields>;
  sum?: Maybe<CepMessageDevicePreviewsSumFields>;
  var_pop?: Maybe<CepMessageDevicePreviewsVarPopFields>;
  var_samp?: Maybe<CepMessageDevicePreviewsVarSampFields>;
  variance?: Maybe<CepMessageDevicePreviewsVarianceFields>;
};


/** aggregate fields of "cep_message_device_previews" */
export type CepMessageDevicePreviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsAggregateOrderBy = {
  avg?: InputMaybe<CepMessageDevicePreviewsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepMessageDevicePreviewsMaxOrderBy>;
  min?: InputMaybe<CepMessageDevicePreviewsMinOrderBy>;
  stddev?: InputMaybe<CepMessageDevicePreviewsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepMessageDevicePreviewsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepMessageDevicePreviewsStddevSampOrderBy>;
  sum?: InputMaybe<CepMessageDevicePreviewsSumOrderBy>;
  var_pop?: InputMaybe<CepMessageDevicePreviewsVarPopOrderBy>;
  var_samp?: InputMaybe<CepMessageDevicePreviewsVarSampOrderBy>;
  variance?: InputMaybe<CepMessageDevicePreviewsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CepMessageDevicePreviewsAvgFields = {
  __typename?: 'cep_message_device_previews_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_message_device_previews". All fields are combined with a logical 'AND'. */
export type CepMessageDevicePreviewsBoolExp = {
  _and?: InputMaybe<Array<CepMessageDevicePreviewsBoolExp>>;
  _not?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
  _or?: InputMaybe<Array<CepMessageDevicePreviewsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  template?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepMessageDevicePreviewsMaxFields = {
  __typename?: 'cep_message_device_previews_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepMessageDevicePreviewsMinFields = {
  __typename?: 'cep_message_device_previews_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_message_device_previews" */
export type CepMessageDevicePreviewsMutationResponse = {
  __typename?: 'cep_message_device_previews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepMessageDevicePreviews>;
};

/** Ordering options when selecting data from "cep_message_device_previews". */
export type CepMessageDevicePreviewsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  template?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_message_device_previews */
export type CepMessageDevicePreviewsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_message_device_previews" */
export const CepMessageDevicePreviewsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Provider: 'provider',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  Template: 'template',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepMessageDevicePreviewsSelectColumn = typeof CepMessageDevicePreviewsSelectColumn[keyof typeof CepMessageDevicePreviewsSelectColumn];
/** input type for updating data in table "cep_message_device_previews" */
export type CepMessageDevicePreviewsSetInput = {
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepMessageDevicePreviewsStddevFields = {
  __typename?: 'cep_message_device_previews_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepMessageDevicePreviewsStddevPopFields = {
  __typename?: 'cep_message_device_previews_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepMessageDevicePreviewsStddevSampFields = {
  __typename?: 'cep_message_device_previews_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_message_device_previews" */
export type CepMessageDevicePreviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepMessageDevicePreviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepMessageDevicePreviewsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepMessageDevicePreviewsSumFields = {
  __typename?: 'cep_message_device_previews_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type CepMessageDevicePreviewsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepMessageDevicePreviewsSetInput>;
  /** filter the rows which have to be updated */
  where: CepMessageDevicePreviewsBoolExp;
};

/** aggregate var_pop on columns */
export type CepMessageDevicePreviewsVarPopFields = {
  __typename?: 'cep_message_device_previews_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepMessageDevicePreviewsVarSampFields = {
  __typename?: 'cep_message_device_previews_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepMessageDevicePreviewsVarianceFields = {
  __typename?: 'cep_message_device_previews_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_message_device_previews" */
export type CepMessageDevicePreviewsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_providers" */
export type CepProviders = {
  __typename?: 'cep_providers';
  /** An object relationship */
  cep_channel: CepChannels;
  cep_channel_id: Scalars['uuid'];
  /** An array relationship */
  cep_domains: Array<CepDomains>;
  /** An aggregate relationship */
  cep_domains_aggregate: CepDomainsAggregate;
  /** An array relationship */
  cep_sender_identities: Array<CepSenderIdentities>;
  /** An aggregate relationship */
  cep_sender_identities_aggregate: CepSenderIdentitiesAggregate;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  provider_type: Scalars['String'];
  /** Which message type this credential set is dedicated to, or NULL when it serves both. NULL is the pool model: the marketing/transactional split lives in the provider's pools (SendGrid IP pools, Twilio Messaging Services) rather than in separate credentials. */
  transactional?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_providers" */
export type CepProvidersCepDomainsArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersCepDomainsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersCepSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersCepSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_providers" */
export type CepProvidersNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_providers" */
export type CepProvidersAggregate = {
  __typename?: 'cep_providers_aggregate';
  aggregate?: Maybe<CepProvidersAggregateFields>;
  nodes: Array<CepProviders>;
};

export type CepProvidersAggregateBoolExp = {
  bool_and?: InputMaybe<CepProvidersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CepProvidersAggregateBoolExpBoolOr>;
  count?: InputMaybe<CepProvidersAggregateBoolExpCount>;
};

export type CepProvidersAggregateBoolExpBoolAnd = {
  arguments: CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepProvidersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepProvidersAggregateBoolExpBoolOr = {
  arguments: CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepProvidersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepProvidersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepProvidersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepProvidersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_providers" */
export type CepProvidersAggregateFields = {
  __typename?: 'cep_providers_aggregate_fields';
  avg?: Maybe<CepProvidersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepProvidersMaxFields>;
  min?: Maybe<CepProvidersMinFields>;
  stddev?: Maybe<CepProvidersStddevFields>;
  stddev_pop?: Maybe<CepProvidersStddevPopFields>;
  stddev_samp?: Maybe<CepProvidersStddevSampFields>;
  sum?: Maybe<CepProvidersSumFields>;
  var_pop?: Maybe<CepProvidersVarPopFields>;
  var_samp?: Maybe<CepProvidersVarSampFields>;
  variance?: Maybe<CepProvidersVarianceFields>;
};


/** aggregate fields of "cep_providers" */
export type CepProvidersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepProvidersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_providers" */
export type CepProvidersAggregateOrderBy = {
  avg?: InputMaybe<CepProvidersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepProvidersMaxOrderBy>;
  min?: InputMaybe<CepProvidersMinOrderBy>;
  stddev?: InputMaybe<CepProvidersStddevOrderBy>;
  stddev_pop?: InputMaybe<CepProvidersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepProvidersStddevSampOrderBy>;
  sum?: InputMaybe<CepProvidersSumOrderBy>;
  var_pop?: InputMaybe<CepProvidersVarPopOrderBy>;
  var_samp?: InputMaybe<CepProvidersVarSampOrderBy>;
  variance?: InputMaybe<CepProvidersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepProvidersAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "cep_providers" */
export type CepProvidersArrRelInsertInput = {
  data: Array<CepProvidersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepProvidersOnConflict>;
};

/** aggregate avg on columns */
export type CepProvidersAvgFields = {
  __typename?: 'cep_providers_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_providers" */
export type CepProvidersAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_providers". All fields are combined with a logical 'AND'. */
export type CepProvidersBoolExp = {
  _and?: InputMaybe<Array<CepProvidersBoolExp>>;
  _not?: InputMaybe<CepProvidersBoolExp>;
  _or?: InputMaybe<Array<CepProvidersBoolExp>>;
  cep_channel?: InputMaybe<CepChannelsBoolExp>;
  cep_channel_id?: InputMaybe<UuidComparisonExp>;
  cep_domains?: InputMaybe<CepDomainsBoolExp>;
  cep_domains_aggregate?: InputMaybe<CepDomainsAggregateBoolExp>;
  cep_sender_identities?: InputMaybe<CepSenderIdentitiesBoolExp>;
  cep_sender_identities_aggregate?: InputMaybe<CepSenderIdentitiesAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  provider_type?: InputMaybe<StringComparisonExp>;
  transactional?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_providers" */
export const CepProvidersConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepProvidersIdWorkspaceIdKey: 'cep_providers_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepProvidersPkey: 'cep_providers_pkey'
} as const;

export type CepProvidersConstraint = typeof CepProvidersConstraint[keyof typeof CepProvidersConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepProvidersDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepProvidersDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepProvidersDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_providers" */
export type CepProvidersInsertInput = {
  cep_channel?: InputMaybe<CepChannelsObjRelInsertInput>;
  cep_channel_id?: InputMaybe<Scalars['uuid']>;
  cep_domains?: InputMaybe<CepDomainsArrRelInsertInput>;
  cep_sender_identities?: InputMaybe<CepSenderIdentitiesArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  provider_type?: InputMaybe<Scalars['String']>;
  /** Which message type this credential set is dedicated to, or NULL when it serves both. NULL is the pool model: the marketing/transactional split lives in the provider's pools (SendGrid IP pools, Twilio Messaging Services) rather than in separate credentials. */
  transactional?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type CepProvidersMaxFields = {
  __typename?: 'cep_providers_max_fields';
  cep_channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  provider_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_providers" */
export type CepProvidersMaxOrderBy = {
  cep_channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepProvidersMinFields = {
  __typename?: 'cep_providers_min_fields';
  cep_channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  provider_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_providers" */
export type CepProvidersMinOrderBy = {
  cep_channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_providers" */
export type CepProvidersMutationResponse = {
  __typename?: 'cep_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepProviders>;
};

/** input type for inserting object relation for remote table "cep_providers" */
export type CepProvidersObjRelInsertInput = {
  data: CepProvidersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepProvidersOnConflict>;
};

/** on_conflict condition type for table "cep_providers" */
export type CepProvidersOnConflict = {
  constraint: CepProvidersConstraint;
  update_columns?: Array<CepProvidersUpdateColumn>;
  where?: InputMaybe<CepProvidersBoolExp>;
};

/** Ordering options when selecting data from "cep_providers". */
export type CepProvidersOrderBy = {
  cep_channel?: InputMaybe<CepChannelsOrderBy>;
  cep_channel_id?: InputMaybe<OrderBy>;
  cep_domains_aggregate?: InputMaybe<CepDomainsAggregateOrderBy>;
  cep_sender_identities_aggregate?: InputMaybe<CepSenderIdentitiesAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  provider_type?: InputMaybe<OrderBy>;
  transactional?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_providers */
export type CepProvidersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepProvidersPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_providers" */
export const CepProvidersSelectColumn = {
  /** column name */
  CepChannelId: 'cep_channel_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ProviderType: 'provider_type',
  /** column name */
  Transactional: 'transactional',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepProvidersSelectColumn = typeof CepProvidersSelectColumn[keyof typeof CepProvidersSelectColumn];
/** select "cep_providers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cep_providers" */
export const CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolAndArgumentsColumns = typeof CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolAndArgumentsColumns[keyof typeof CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolAndArgumentsColumns];
/** select "cep_providers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cep_providers" */
export const CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolOrArgumentsColumns = typeof CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolOrArgumentsColumns[keyof typeof CepProvidersSelectColumnCepProvidersAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "cep_providers" */
export type CepProvidersSetInput = {
  cep_channel_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepProvidersStddevFields = {
  __typename?: 'cep_providers_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_providers" */
export type CepProvidersStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepProvidersStddevPopFields = {
  __typename?: 'cep_providers_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_providers" */
export type CepProvidersStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepProvidersStddevSampFields = {
  __typename?: 'cep_providers_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_providers" */
export type CepProvidersStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_providers" */
export type CepProvidersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepProvidersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepProvidersStreamCursorValueInput = {
  cep_channel_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  provider_type?: InputMaybe<Scalars['String']>;
  /** Which message type this credential set is dedicated to, or NULL when it serves both. NULL is the pool model: the marketing/transactional split lives in the provider's pools (SendGrid IP pools, Twilio Messaging Services) rather than in separate credentials. */
  transactional?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepProvidersSumFields = {
  __typename?: 'cep_providers_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_providers" */
export type CepProvidersSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "cep_providers" */
export const CepProvidersUpdateColumn = {
  /** column name */
  CepChannelId: 'cep_channel_id',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name'
} as const;

export type CepProvidersUpdateColumn = typeof CepProvidersUpdateColumn[keyof typeof CepProvidersUpdateColumn];
export type CepProvidersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepProvidersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepProvidersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepProvidersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepProvidersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepProvidersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepProvidersSetInput>;
  /** filter the rows which have to be updated */
  where: CepProvidersBoolExp;
};

/** aggregate var_pop on columns */
export type CepProvidersVarPopFields = {
  __typename?: 'cep_providers_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_providers" */
export type CepProvidersVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepProvidersVarSampFields = {
  __typename?: 'cep_providers_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_providers" */
export type CepProvidersVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepProvidersVarianceFields = {
  __typename?: 'cep_providers_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_providers" */
export type CepProvidersVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentities = {
  __typename?: 'cep_sender_identities';
  /** An object relationship */
  cep_provider: CepProviders;
  cep_provider_id: Scalars['uuid'];
  /** An array relationship */
  cep_subscription_topic_sender_identities: Array<CepSubscriptionTopicSenderIdentities>;
  /** An aggregate relationship */
  cep_subscription_topic_sender_identities_aggregate: CepSubscriptionTopicSenderIdentitiesAggregate;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  transactional: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesCepSubscriptionTopicSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesCepSubscriptionTopicSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_sender_identities" */
export type CepSenderIdentitiesNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_sender_identities" */
export type CepSenderIdentitiesAggregate = {
  __typename?: 'cep_sender_identities_aggregate';
  aggregate?: Maybe<CepSenderIdentitiesAggregateFields>;
  nodes: Array<CepSenderIdentities>;
};

export type CepSenderIdentitiesAggregateBoolExp = {
  bool_and?: InputMaybe<CepSenderIdentitiesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CepSenderIdentitiesAggregateBoolExpBoolOr>;
  count?: InputMaybe<CepSenderIdentitiesAggregateBoolExpCount>;
};

export type CepSenderIdentitiesAggregateBoolExpBoolAnd = {
  arguments: CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSenderIdentitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepSenderIdentitiesAggregateBoolExpBoolOr = {
  arguments: CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSenderIdentitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepSenderIdentitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSenderIdentitiesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_sender_identities" */
export type CepSenderIdentitiesAggregateFields = {
  __typename?: 'cep_sender_identities_aggregate_fields';
  avg?: Maybe<CepSenderIdentitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSenderIdentitiesMaxFields>;
  min?: Maybe<CepSenderIdentitiesMinFields>;
  stddev?: Maybe<CepSenderIdentitiesStddevFields>;
  stddev_pop?: Maybe<CepSenderIdentitiesStddevPopFields>;
  stddev_samp?: Maybe<CepSenderIdentitiesStddevSampFields>;
  sum?: Maybe<CepSenderIdentitiesSumFields>;
  var_pop?: Maybe<CepSenderIdentitiesVarPopFields>;
  var_samp?: Maybe<CepSenderIdentitiesVarSampFields>;
  variance?: Maybe<CepSenderIdentitiesVarianceFields>;
};


/** aggregate fields of "cep_sender_identities" */
export type CepSenderIdentitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_sender_identities" */
export type CepSenderIdentitiesAggregateOrderBy = {
  avg?: InputMaybe<CepSenderIdentitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepSenderIdentitiesMaxOrderBy>;
  min?: InputMaybe<CepSenderIdentitiesMinOrderBy>;
  stddev?: InputMaybe<CepSenderIdentitiesStddevOrderBy>;
  stddev_pop?: InputMaybe<CepSenderIdentitiesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepSenderIdentitiesStddevSampOrderBy>;
  sum?: InputMaybe<CepSenderIdentitiesSumOrderBy>;
  var_pop?: InputMaybe<CepSenderIdentitiesVarPopOrderBy>;
  var_samp?: InputMaybe<CepSenderIdentitiesVarSampOrderBy>;
  variance?: InputMaybe<CepSenderIdentitiesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepSenderIdentitiesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "cep_sender_identities" */
export type CepSenderIdentitiesArrRelInsertInput = {
  data: Array<CepSenderIdentitiesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSenderIdentitiesOnConflict>;
};

/** aggregate avg on columns */
export type CepSenderIdentitiesAvgFields = {
  __typename?: 'cep_sender_identities_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_sender_identities". All fields are combined with a logical 'AND'. */
export type CepSenderIdentitiesBoolExp = {
  _and?: InputMaybe<Array<CepSenderIdentitiesBoolExp>>;
  _not?: InputMaybe<CepSenderIdentitiesBoolExp>;
  _or?: InputMaybe<Array<CepSenderIdentitiesBoolExp>>;
  cep_provider?: InputMaybe<CepProvidersBoolExp>;
  cep_provider_id?: InputMaybe<UuidComparisonExp>;
  cep_subscription_topic_sender_identities?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
  cep_subscription_topic_sender_identities_aggregate?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  messages_aggregate?: InputMaybe<MessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  transactional?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_sender_identities" */
export const CepSenderIdentitiesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepSenderIdentitiesIdWorkspaceIdKey: 'cep_sender_identities_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepSenderIdentitiesPkey: 'cep_sender_identities_pkey'
} as const;

export type CepSenderIdentitiesConstraint = typeof CepSenderIdentitiesConstraint[keyof typeof CepSenderIdentitiesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepSenderIdentitiesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepSenderIdentitiesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepSenderIdentitiesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_sender_identities" */
export type CepSenderIdentitiesInsertInput = {
  cep_provider?: InputMaybe<CepProvidersObjRelInsertInput>;
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_sender_identities?: InputMaybe<CepSubscriptionTopicSenderIdentitiesArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<MessagesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  transactional?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type CepSenderIdentitiesMaxFields = {
  __typename?: 'cep_sender_identities_max_fields';
  cep_provider_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesMaxOrderBy = {
  cep_provider_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepSenderIdentitiesMinFields = {
  __typename?: 'cep_sender_identities_min_fields';
  cep_provider_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesMinOrderBy = {
  cep_provider_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_sender_identities" */
export type CepSenderIdentitiesMutationResponse = {
  __typename?: 'cep_sender_identities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepSenderIdentities>;
};

/** input type for inserting object relation for remote table "cep_sender_identities" */
export type CepSenderIdentitiesObjRelInsertInput = {
  data: CepSenderIdentitiesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSenderIdentitiesOnConflict>;
};

/** on_conflict condition type for table "cep_sender_identities" */
export type CepSenderIdentitiesOnConflict = {
  constraint: CepSenderIdentitiesConstraint;
  update_columns?: Array<CepSenderIdentitiesUpdateColumn>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};

/** Ordering options when selecting data from "cep_sender_identities". */
export type CepSenderIdentitiesOrderBy = {
  cep_provider?: InputMaybe<CepProvidersOrderBy>;
  cep_provider_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_sender_identities_aggregate?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<MessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  transactional?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_sender_identities */
export type CepSenderIdentitiesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepSenderIdentitiesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_sender_identities" */
export const CepSenderIdentitiesSelectColumn = {
  /** column name */
  CepProviderId: 'cep_provider_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Transactional: 'transactional',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSenderIdentitiesSelectColumn = typeof CepSenderIdentitiesSelectColumn[keyof typeof CepSenderIdentitiesSelectColumn];
/** select "cep_sender_identities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cep_sender_identities" */
export const CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolAndArgumentsColumns = typeof CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolAndArgumentsColumns];
/** select "cep_sender_identities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cep_sender_identities" */
export const CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolOrArgumentsColumns = typeof CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof CepSenderIdentitiesSelectColumnCepSenderIdentitiesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "cep_sender_identities" */
export type CepSenderIdentitiesSetInput = {
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type CepSenderIdentitiesStddevFields = {
  __typename?: 'cep_sender_identities_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepSenderIdentitiesStddevPopFields = {
  __typename?: 'cep_sender_identities_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepSenderIdentitiesStddevSampFields = {
  __typename?: 'cep_sender_identities_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_sender_identities" */
export type CepSenderIdentitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSenderIdentitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSenderIdentitiesStreamCursorValueInput = {
  cep_provider_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSenderIdentitiesSumFields = {
  __typename?: 'cep_sender_identities_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "cep_sender_identities" */
export const CepSenderIdentitiesUpdateColumn = {
  /** column name */
  CepProviderId: 'cep_provider_id',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  Transactional: 'transactional'
} as const;

export type CepSenderIdentitiesUpdateColumn = typeof CepSenderIdentitiesUpdateColumn[keyof typeof CepSenderIdentitiesUpdateColumn];
export type CepSenderIdentitiesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepSenderIdentitiesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepSenderIdentitiesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepSenderIdentitiesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepSenderIdentitiesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepSenderIdentitiesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepSenderIdentitiesSetInput>;
  /** filter the rows which have to be updated */
  where: CepSenderIdentitiesBoolExp;
};

/** aggregate var_pop on columns */
export type CepSenderIdentitiesVarPopFields = {
  __typename?: 'cep_sender_identities_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepSenderIdentitiesVarSampFields = {
  __typename?: 'cep_sender_identities_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepSenderIdentitiesVarianceFields = {
  __typename?: 'cep_sender_identities_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_sender_identities" */
export type CepSenderIdentitiesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_sender_identity_senders" */
export type CepSenderIdentitySenders = {
  __typename?: 'cep_sender_identity_senders';
  /** An object relationship */
  cep_sender_identity: CepSenderIdentities;
  cep_sender_identity_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  details: Scalars['jsonb'];
  display_name?: Maybe<Scalars['String']>;
  health_state?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_synced_at: Scalars['timestamptz'];
  phone_number?: Maybe<Scalars['String']>;
  provider_sender_id: Scalars['String'];
  sender_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_sender_identity_senders" */
export type CepSenderIdentitySendersDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_sender_identity_senders" */
export type CepSenderIdentitySendersAggregate = {
  __typename?: 'cep_sender_identity_senders_aggregate';
  aggregate?: Maybe<CepSenderIdentitySendersAggregateFields>;
  nodes: Array<CepSenderIdentitySenders>;
};

/** aggregate fields of "cep_sender_identity_senders" */
export type CepSenderIdentitySendersAggregateFields = {
  __typename?: 'cep_sender_identity_senders_aggregate_fields';
  avg?: Maybe<CepSenderIdentitySendersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSenderIdentitySendersMaxFields>;
  min?: Maybe<CepSenderIdentitySendersMinFields>;
  stddev?: Maybe<CepSenderIdentitySendersStddevFields>;
  stddev_pop?: Maybe<CepSenderIdentitySendersStddevPopFields>;
  stddev_samp?: Maybe<CepSenderIdentitySendersStddevSampFields>;
  sum?: Maybe<CepSenderIdentitySendersSumFields>;
  var_pop?: Maybe<CepSenderIdentitySendersVarPopFields>;
  var_samp?: Maybe<CepSenderIdentitySendersVarSampFields>;
  variance?: Maybe<CepSenderIdentitySendersVarianceFields>;
};


/** aggregate fields of "cep_sender_identity_senders" */
export type CepSenderIdentitySendersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSenderIdentitySendersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepSenderIdentitySendersAvgFields = {
  __typename?: 'cep_sender_identity_senders_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_sender_identity_senders". All fields are combined with a logical 'AND'. */
export type CepSenderIdentitySendersBoolExp = {
  _and?: InputMaybe<Array<CepSenderIdentitySendersBoolExp>>;
  _not?: InputMaybe<CepSenderIdentitySendersBoolExp>;
  _or?: InputMaybe<Array<CepSenderIdentitySendersBoolExp>>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesBoolExp>;
  cep_sender_identity_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<JsonbComparisonExp>;
  display_name?: InputMaybe<StringComparisonExp>;
  health_state?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_synced_at?: InputMaybe<TimestamptzComparisonExp>;
  phone_number?: InputMaybe<StringComparisonExp>;
  provider_sender_id?: InputMaybe<StringComparisonExp>;
  sender_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepSenderIdentitySendersMaxFields = {
  __typename?: 'cep_sender_identity_senders_max_fields';
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  health_state?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_synced_at?: Maybe<Scalars['timestamptz']>;
  phone_number?: Maybe<Scalars['String']>;
  provider_sender_id?: Maybe<Scalars['String']>;
  sender_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepSenderIdentitySendersMinFields = {
  __typename?: 'cep_sender_identity_senders_min_fields';
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  health_state?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_synced_at?: Maybe<Scalars['timestamptz']>;
  phone_number?: Maybe<Scalars['String']>;
  provider_sender_id?: Maybe<Scalars['String']>;
  sender_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "cep_sender_identity_senders". */
export type CepSenderIdentitySendersOrderBy = {
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesOrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  display_name?: InputMaybe<OrderBy>;
  health_state?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_synced_at?: InputMaybe<OrderBy>;
  phone_number?: InputMaybe<OrderBy>;
  provider_sender_id?: InputMaybe<OrderBy>;
  sender_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_sender_identity_senders" */
export const CepSenderIdentitySendersSelectColumn = {
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Details: 'details',
  /** column name */
  DisplayName: 'display_name',
  /** column name */
  HealthState: 'health_state',
  /** column name */
  Id: 'id',
  /** column name */
  LastSyncedAt: 'last_synced_at',
  /** column name */
  PhoneNumber: 'phone_number',
  /** column name */
  ProviderSenderId: 'provider_sender_id',
  /** column name */
  SenderType: 'sender_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSenderIdentitySendersSelectColumn = typeof CepSenderIdentitySendersSelectColumn[keyof typeof CepSenderIdentitySendersSelectColumn];
/** aggregate stddev on columns */
export type CepSenderIdentitySendersStddevFields = {
  __typename?: 'cep_sender_identity_senders_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepSenderIdentitySendersStddevPopFields = {
  __typename?: 'cep_sender_identity_senders_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepSenderIdentitySendersStddevSampFields = {
  __typename?: 'cep_sender_identity_senders_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_sender_identity_senders" */
export type CepSenderIdentitySendersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSenderIdentitySendersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSenderIdentitySendersStreamCursorValueInput = {
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  display_name?: InputMaybe<Scalars['String']>;
  health_state?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_synced_at?: InputMaybe<Scalars['timestamptz']>;
  phone_number?: InputMaybe<Scalars['String']>;
  provider_sender_id?: InputMaybe<Scalars['String']>;
  sender_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSenderIdentitySendersSumFields = {
  __typename?: 'cep_sender_identity_senders_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CepSenderIdentitySendersVarPopFields = {
  __typename?: 'cep_sender_identity_senders_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepSenderIdentitySendersVarSampFields = {
  __typename?: 'cep_sender_identity_senders_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepSenderIdentitySendersVarianceFields = {
  __typename?: 'cep_sender_identity_senders_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentities = {
  __typename?: 'cep_subscription_topic_sender_identities';
  /** An object relationship */
  cep_sender_identity: CepSenderIdentities;
  cep_sender_identity_id: Scalars['uuid'];
  /** An object relationship */
  cep_subscription_topic: CepSubscriptionTopics;
  cep_subscription_topic_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesAggregate = {
  __typename?: 'cep_subscription_topic_sender_identities_aggregate';
  aggregate?: Maybe<CepSubscriptionTopicSenderIdentitiesAggregateFields>;
  nodes: Array<CepSubscriptionTopicSenderIdentities>;
};

export type CepSubscriptionTopicSenderIdentitiesAggregateBoolExp = {
  count?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAggregateBoolExpCount>;
};

export type CepSubscriptionTopicSenderIdentitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesAggregateFields = {
  __typename?: 'cep_subscription_topic_sender_identities_aggregate_fields';
  avg?: Maybe<CepSubscriptionTopicSenderIdentitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSubscriptionTopicSenderIdentitiesMaxFields>;
  min?: Maybe<CepSubscriptionTopicSenderIdentitiesMinFields>;
  stddev?: Maybe<CepSubscriptionTopicSenderIdentitiesStddevFields>;
  stddev_pop?: Maybe<CepSubscriptionTopicSenderIdentitiesStddevPopFields>;
  stddev_samp?: Maybe<CepSubscriptionTopicSenderIdentitiesStddevSampFields>;
  sum?: Maybe<CepSubscriptionTopicSenderIdentitiesSumFields>;
  var_pop?: Maybe<CepSubscriptionTopicSenderIdentitiesVarPopFields>;
  var_samp?: Maybe<CepSubscriptionTopicSenderIdentitiesVarSampFields>;
  variance?: Maybe<CepSubscriptionTopicSenderIdentitiesVarianceFields>;
};


/** aggregate fields of "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesAggregateOrderBy = {
  avg?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepSubscriptionTopicSenderIdentitiesMaxOrderBy>;
  min?: InputMaybe<CepSubscriptionTopicSenderIdentitiesMinOrderBy>;
  stddev?: InputMaybe<CepSubscriptionTopicSenderIdentitiesStddevOrderBy>;
  stddev_pop?: InputMaybe<CepSubscriptionTopicSenderIdentitiesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepSubscriptionTopicSenderIdentitiesStddevSampOrderBy>;
  sum?: InputMaybe<CepSubscriptionTopicSenderIdentitiesSumOrderBy>;
  var_pop?: InputMaybe<CepSubscriptionTopicSenderIdentitiesVarPopOrderBy>;
  var_samp?: InputMaybe<CepSubscriptionTopicSenderIdentitiesVarSampOrderBy>;
  variance?: InputMaybe<CepSubscriptionTopicSenderIdentitiesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesArrRelInsertInput = {
  data: Array<CepSubscriptionTopicSenderIdentitiesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSubscriptionTopicSenderIdentitiesOnConflict>;
};

/** aggregate avg on columns */
export type CepSubscriptionTopicSenderIdentitiesAvgFields = {
  __typename?: 'cep_subscription_topic_sender_identities_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_subscription_topic_sender_identities". All fields are combined with a logical 'AND'. */
export type CepSubscriptionTopicSenderIdentitiesBoolExp = {
  _and?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesBoolExp>>;
  _not?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
  _or?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesBoolExp>>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesBoolExp>;
  cep_sender_identity_id?: InputMaybe<UuidComparisonExp>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topic_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_subscription_topic_sender_identities" */
export const CepSubscriptionTopicSenderIdentitiesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepSubTopicSenderIdentitiesIdWorkspaceIdKey: 'cep_sub_topic_sender_identities_id_workspace_id_key',
  /** unique or primary key constraint on columns "cep_sender_identity_id", "workspace_id", "cep_subscription_topic_id" */
  CepSubTopicSenderIdentitiesUnique: 'cep_sub_topic_sender_identities_unique',
  /** unique or primary key constraint on columns "id" */
  CepSubscriptionTopicSenderIdentitiesPkey: 'cep_subscription_topic_sender_identities_pkey'
} as const;

export type CepSubscriptionTopicSenderIdentitiesConstraint = typeof CepSubscriptionTopicSenderIdentitiesConstraint[keyof typeof CepSubscriptionTopicSenderIdentitiesConstraint];
/** input type for inserting data into table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesInsertInput = {
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesObjRelInsertInput>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsObjRelInsertInput>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CepSubscriptionTopicSenderIdentitiesMaxFields = {
  __typename?: 'cep_subscription_topic_sender_identities_max_fields';
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesMaxOrderBy = {
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepSubscriptionTopicSenderIdentitiesMinFields = {
  __typename?: 'cep_subscription_topic_sender_identities_min_fields';
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesMinOrderBy = {
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesMutationResponse = {
  __typename?: 'cep_subscription_topic_sender_identities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepSubscriptionTopicSenderIdentities>;
};

/** on_conflict condition type for table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesOnConflict = {
  constraint: CepSubscriptionTopicSenderIdentitiesConstraint;
  update_columns?: Array<CepSubscriptionTopicSenderIdentitiesUpdateColumn>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};

/** Ordering options when selecting data from "cep_subscription_topic_sender_identities". */
export type CepSubscriptionTopicSenderIdentitiesOrderBy = {
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesOrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsOrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_subscription_topic_sender_identities" */
export const CepSubscriptionTopicSenderIdentitiesSelectColumn = {
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSubscriptionTopicSenderIdentitiesSelectColumn = typeof CepSubscriptionTopicSenderIdentitiesSelectColumn[keyof typeof CepSubscriptionTopicSenderIdentitiesSelectColumn];
/** aggregate stddev on columns */
export type CepSubscriptionTopicSenderIdentitiesStddevFields = {
  __typename?: 'cep_subscription_topic_sender_identities_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepSubscriptionTopicSenderIdentitiesStddevPopFields = {
  __typename?: 'cep_subscription_topic_sender_identities_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepSubscriptionTopicSenderIdentitiesStddevSampFields = {
  __typename?: 'cep_subscription_topic_sender_identities_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSubscriptionTopicSenderIdentitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSubscriptionTopicSenderIdentitiesStreamCursorValueInput = {
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSubscriptionTopicSenderIdentitiesSumFields = {
  __typename?: 'cep_subscription_topic_sender_identities_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "cep_subscription_topic_sender_identities" (current role has no relevant permissions) */
export const CepSubscriptionTopicSenderIdentitiesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type CepSubscriptionTopicSenderIdentitiesUpdateColumn = typeof CepSubscriptionTopicSenderIdentitiesUpdateColumn[keyof typeof CepSubscriptionTopicSenderIdentitiesUpdateColumn];
/** aggregate var_pop on columns */
export type CepSubscriptionTopicSenderIdentitiesVarPopFields = {
  __typename?: 'cep_subscription_topic_sender_identities_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepSubscriptionTopicSenderIdentitiesVarSampFields = {
  __typename?: 'cep_subscription_topic_sender_identities_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepSubscriptionTopicSenderIdentitiesVarianceFields = {
  __typename?: 'cep_subscription_topic_sender_identities_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_subscription_topic_sender_identities" */
export type CepSubscriptionTopicSenderIdentitiesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopics = {
  __typename?: 'cep_subscription_topics';
  /** An object relationship */
  cep_channel: CepChannels;
  cep_channel_id: Scalars['uuid'];
  /** An array relationship */
  cep_subscription_topic_sender_identities: Array<CepSubscriptionTopicSenderIdentities>;
  /** An aggregate relationship */
  cep_subscription_topic_sender_identities_aggregate: CepSubscriptionTopicSenderIdentitiesAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  external_identifier?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  policy: Scalars['String'];
  /** An object relationship */
  push_app?: Maybe<PushApps>;
  push_app_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsCepSubscriptionTopicSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsCepSubscriptionTopicSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_subscription_topics" */
export type CepSubscriptionTopicsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_subscription_topics" */
export type CepSubscriptionTopicsAggregate = {
  __typename?: 'cep_subscription_topics_aggregate';
  aggregate?: Maybe<CepSubscriptionTopicsAggregateFields>;
  nodes: Array<CepSubscriptionTopics>;
};

export type CepSubscriptionTopicsAggregateBoolExp = {
  count?: InputMaybe<CepSubscriptionTopicsAggregateBoolExpCount>;
};

export type CepSubscriptionTopicsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_subscription_topics" */
export type CepSubscriptionTopicsAggregateFields = {
  __typename?: 'cep_subscription_topics_aggregate_fields';
  avg?: Maybe<CepSubscriptionTopicsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSubscriptionTopicsMaxFields>;
  min?: Maybe<CepSubscriptionTopicsMinFields>;
  stddev?: Maybe<CepSubscriptionTopicsStddevFields>;
  stddev_pop?: Maybe<CepSubscriptionTopicsStddevPopFields>;
  stddev_samp?: Maybe<CepSubscriptionTopicsStddevSampFields>;
  sum?: Maybe<CepSubscriptionTopicsSumFields>;
  var_pop?: Maybe<CepSubscriptionTopicsVarPopFields>;
  var_samp?: Maybe<CepSubscriptionTopicsVarSampFields>;
  variance?: Maybe<CepSubscriptionTopicsVarianceFields>;
};


/** aggregate fields of "cep_subscription_topics" */
export type CepSubscriptionTopicsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_subscription_topics" */
export type CepSubscriptionTopicsAggregateOrderBy = {
  avg?: InputMaybe<CepSubscriptionTopicsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepSubscriptionTopicsMaxOrderBy>;
  min?: InputMaybe<CepSubscriptionTopicsMinOrderBy>;
  stddev?: InputMaybe<CepSubscriptionTopicsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepSubscriptionTopicsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepSubscriptionTopicsStddevSampOrderBy>;
  sum?: InputMaybe<CepSubscriptionTopicsSumOrderBy>;
  var_pop?: InputMaybe<CepSubscriptionTopicsVarPopOrderBy>;
  var_samp?: InputMaybe<CepSubscriptionTopicsVarSampOrderBy>;
  variance?: InputMaybe<CepSubscriptionTopicsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "cep_subscription_topics" */
export type CepSubscriptionTopicsArrRelInsertInput = {
  data: Array<CepSubscriptionTopicsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSubscriptionTopicsOnConflict>;
};

/** aggregate avg on columns */
export type CepSubscriptionTopicsAvgFields = {
  __typename?: 'cep_subscription_topics_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_subscription_topics". All fields are combined with a logical 'AND'. */
export type CepSubscriptionTopicsBoolExp = {
  _and?: InputMaybe<Array<CepSubscriptionTopicsBoolExp>>;
  _not?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  _or?: InputMaybe<Array<CepSubscriptionTopicsBoolExp>>;
  cep_channel?: InputMaybe<CepChannelsBoolExp>;
  cep_channel_id?: InputMaybe<UuidComparisonExp>;
  cep_subscription_topic_sender_identities?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
  cep_subscription_topic_sender_identities_aggregate?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  double_opt_in_confirmation_message_id?: InputMaybe<UuidComparisonExp>;
  double_opt_in_message_id?: InputMaybe<UuidComparisonExp>;
  double_opt_in_redirect_url?: InputMaybe<StringComparisonExp>;
  external_identifier?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  messages_aggregate?: InputMaybe<MessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  policy?: InputMaybe<StringComparisonExp>;
  push_app?: InputMaybe<PushAppsBoolExp>;
  push_app_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_subscription_topics" */
export const CepSubscriptionTopicsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepSubscriptionTopicsIdWorkspaceIdKey: 'cep_subscription_topics_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepSubscriptionTopicsPkey: 'cep_subscription_topics_pkey',
  /** unique or primary key constraint on columns "external_identifier", "workspace_id" */
  CepSubscriptionTopicsWorkspaceExternalIdentifierUnique: 'cep_subscription_topics_workspace_external_identifier_unique'
} as const;

export type CepSubscriptionTopicsConstraint = typeof CepSubscriptionTopicsConstraint[keyof typeof CepSubscriptionTopicsConstraint];
/** input type for inserting data into table "cep_subscription_topics" */
export type CepSubscriptionTopicsInsertInput = {
  cep_channel?: InputMaybe<CepChannelsObjRelInsertInput>;
  cep_channel_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_sender_identities?: InputMaybe<CepSubscriptionTopicSenderIdentitiesArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  external_identifier?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<MessagesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  policy?: InputMaybe<Scalars['String']>;
  push_app?: InputMaybe<PushAppsObjRelInsertInput>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CepSubscriptionTopicsMaxFields = {
  __typename?: 'cep_subscription_topics_max_fields';
  cep_channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  external_identifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  push_app_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsMaxOrderBy = {
  cep_channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  double_opt_in_confirmation_message_id?: InputMaybe<OrderBy>;
  double_opt_in_message_id?: InputMaybe<OrderBy>;
  double_opt_in_redirect_url?: InputMaybe<OrderBy>;
  external_identifier?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepSubscriptionTopicsMinFields = {
  __typename?: 'cep_subscription_topics_min_fields';
  cep_channel_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_message_id?: Maybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: Maybe<Scalars['String']>;
  external_identifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  push_app_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsMinOrderBy = {
  cep_channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  double_opt_in_confirmation_message_id?: InputMaybe<OrderBy>;
  double_opt_in_message_id?: InputMaybe<OrderBy>;
  double_opt_in_redirect_url?: InputMaybe<OrderBy>;
  external_identifier?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  policy?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_subscription_topics" */
export type CepSubscriptionTopicsMutationResponse = {
  __typename?: 'cep_subscription_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepSubscriptionTopics>;
};

/** input type for inserting object relation for remote table "cep_subscription_topics" */
export type CepSubscriptionTopicsObjRelInsertInput = {
  data: CepSubscriptionTopicsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSubscriptionTopicsOnConflict>;
};

/** on_conflict condition type for table "cep_subscription_topics" */
export type CepSubscriptionTopicsOnConflict = {
  constraint: CepSubscriptionTopicsConstraint;
  update_columns?: Array<CepSubscriptionTopicsUpdateColumn>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};

/** Ordering options when selecting data from "cep_subscription_topics". */
export type CepSubscriptionTopicsOrderBy = {
  cep_channel?: InputMaybe<CepChannelsOrderBy>;
  cep_channel_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_sender_identities_aggregate?: InputMaybe<CepSubscriptionTopicSenderIdentitiesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  double_opt_in_confirmation_message_id?: InputMaybe<OrderBy>;
  double_opt_in_message_id?: InputMaybe<OrderBy>;
  double_opt_in_redirect_url?: InputMaybe<OrderBy>;
  external_identifier?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<MessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  policy?: InputMaybe<OrderBy>;
  push_app?: InputMaybe<PushAppsOrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_subscription_topics */
export type CepSubscriptionTopicsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_subscription_topics" */
export const CepSubscriptionTopicsSelectColumn = {
  /** column name */
  CepChannelId: 'cep_channel_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DoubleOptInConfirmationMessageId: 'double_opt_in_confirmation_message_id',
  /** column name */
  DoubleOptInMessageId: 'double_opt_in_message_id',
  /** column name */
  DoubleOptInRedirectUrl: 'double_opt_in_redirect_url',
  /** column name */
  ExternalIdentifier: 'external_identifier',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Policy: 'policy',
  /** column name */
  PushAppId: 'push_app_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSubscriptionTopicsSelectColumn = typeof CepSubscriptionTopicsSelectColumn[keyof typeof CepSubscriptionTopicsSelectColumn];
/** input type for updating data in table "cep_subscription_topics" */
export type CepSubscriptionTopicsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  external_identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type CepSubscriptionTopicsStddevFields = {
  __typename?: 'cep_subscription_topics_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepSubscriptionTopicsStddevPopFields = {
  __typename?: 'cep_subscription_topics_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepSubscriptionTopicsStddevSampFields = {
  __typename?: 'cep_subscription_topics_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_subscription_topics" */
export type CepSubscriptionTopicsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSubscriptionTopicsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSubscriptionTopicsStreamCursorValueInput = {
  cep_channel_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  double_opt_in_confirmation_message_id?: InputMaybe<Scalars['uuid']>;
  double_opt_in_message_id?: InputMaybe<Scalars['uuid']>;
  double_opt_in_redirect_url?: InputMaybe<Scalars['String']>;
  external_identifier?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['String']>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSubscriptionTopicsSumFields = {
  __typename?: 'cep_subscription_topics_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "cep_subscription_topics" */
export const CepSubscriptionTopicsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  ExternalIdentifier: 'external_identifier',
  /** column name */
  Name: 'name',
  /** column name */
  PushAppId: 'push_app_id'
} as const;

export type CepSubscriptionTopicsUpdateColumn = typeof CepSubscriptionTopicsUpdateColumn[keyof typeof CepSubscriptionTopicsUpdateColumn];
export type CepSubscriptionTopicsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepSubscriptionTopicsSetInput>;
  /** filter the rows which have to be updated */
  where: CepSubscriptionTopicsBoolExp;
};

/** aggregate var_pop on columns */
export type CepSubscriptionTopicsVarPopFields = {
  __typename?: 'cep_subscription_topics_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepSubscriptionTopicsVarSampFields = {
  __typename?: 'cep_subscription_topics_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepSubscriptionTopicsVarianceFields = {
  __typename?: 'cep_subscription_topics_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_subscription_topics" */
export type CepSubscriptionTopicsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopics = {
  __typename?: 'cep_suppression_list_subscription_topics';
  /** An object relationship */
  cep_subscription_topic: CepSubscriptionTopics;
  cep_subscription_topic_id: Scalars['uuid'];
  /** An object relationship */
  cep_suppression_list: CepSuppressionLists;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  suppression_list_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsAggregate = {
  __typename?: 'cep_suppression_list_subscription_topics_aggregate';
  aggregate?: Maybe<CepSuppressionListSubscriptionTopicsAggregateFields>;
  nodes: Array<CepSuppressionListSubscriptionTopics>;
};

export type CepSuppressionListSubscriptionTopicsAggregateBoolExp = {
  count?: InputMaybe<CepSuppressionListSubscriptionTopicsAggregateBoolExpCount>;
};

export type CepSuppressionListSubscriptionTopicsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsAggregateFields = {
  __typename?: 'cep_suppression_list_subscription_topics_aggregate_fields';
  avg?: Maybe<CepSuppressionListSubscriptionTopicsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSuppressionListSubscriptionTopicsMaxFields>;
  min?: Maybe<CepSuppressionListSubscriptionTopicsMinFields>;
  stddev?: Maybe<CepSuppressionListSubscriptionTopicsStddevFields>;
  stddev_pop?: Maybe<CepSuppressionListSubscriptionTopicsStddevPopFields>;
  stddev_samp?: Maybe<CepSuppressionListSubscriptionTopicsStddevSampFields>;
  sum?: Maybe<CepSuppressionListSubscriptionTopicsSumFields>;
  var_pop?: Maybe<CepSuppressionListSubscriptionTopicsVarPopFields>;
  var_samp?: Maybe<CepSuppressionListSubscriptionTopicsVarSampFields>;
  variance?: Maybe<CepSuppressionListSubscriptionTopicsVarianceFields>;
};


/** aggregate fields of "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsAggregateOrderBy = {
  avg?: InputMaybe<CepSuppressionListSubscriptionTopicsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepSuppressionListSubscriptionTopicsMaxOrderBy>;
  min?: InputMaybe<CepSuppressionListSubscriptionTopicsMinOrderBy>;
  stddev?: InputMaybe<CepSuppressionListSubscriptionTopicsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepSuppressionListSubscriptionTopicsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepSuppressionListSubscriptionTopicsStddevSampOrderBy>;
  sum?: InputMaybe<CepSuppressionListSubscriptionTopicsSumOrderBy>;
  var_pop?: InputMaybe<CepSuppressionListSubscriptionTopicsVarPopOrderBy>;
  var_samp?: InputMaybe<CepSuppressionListSubscriptionTopicsVarSampOrderBy>;
  variance?: InputMaybe<CepSuppressionListSubscriptionTopicsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsArrRelInsertInput = {
  data: Array<CepSuppressionListSubscriptionTopicsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSuppressionListSubscriptionTopicsOnConflict>;
};

/** aggregate avg on columns */
export type CepSuppressionListSubscriptionTopicsAvgFields = {
  __typename?: 'cep_suppression_list_subscription_topics_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_suppression_list_subscription_topics". All fields are combined with a logical 'AND'. */
export type CepSuppressionListSubscriptionTopicsBoolExp = {
  _and?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsBoolExp>>;
  _not?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
  _or?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsBoolExp>>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topic_id?: InputMaybe<UuidComparisonExp>;
  cep_suppression_list?: InputMaybe<CepSuppressionListsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  suppression_list_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_suppression_list_subscription_topics" */
export const CepSuppressionListSubscriptionTopicsConstraint = {
  /** unique or primary key constraint on columns "cep_subscription_topic_id", "suppression_list_id" */
  CepSuppressionListSubscriptionTopicsPkey: 'cep_suppression_list_subscription_topics_pkey'
} as const;

export type CepSuppressionListSubscriptionTopicsConstraint = typeof CepSuppressionListSubscriptionTopicsConstraint[keyof typeof CepSuppressionListSubscriptionTopicsConstraint];
/** input type for inserting data into table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsInsertInput = {
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsObjRelInsertInput>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  cep_suppression_list?: InputMaybe<CepSuppressionListsObjRelInsertInput>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  suppression_list_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CepSuppressionListSubscriptionTopicsMaxFields = {
  __typename?: 'cep_suppression_list_subscription_topics_max_fields';
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  suppression_list_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsMaxOrderBy = {
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  suppression_list_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepSuppressionListSubscriptionTopicsMinFields = {
  __typename?: 'cep_suppression_list_subscription_topics_min_fields';
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  suppression_list_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsMinOrderBy = {
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  suppression_list_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsMutationResponse = {
  __typename?: 'cep_suppression_list_subscription_topics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepSuppressionListSubscriptionTopics>;
};

/** on_conflict condition type for table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsOnConflict = {
  constraint: CepSuppressionListSubscriptionTopicsConstraint;
  update_columns?: Array<CepSuppressionListSubscriptionTopicsUpdateColumn>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};

/** Ordering options when selecting data from "cep_suppression_list_subscription_topics". */
export type CepSuppressionListSubscriptionTopicsOrderBy = {
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsOrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  cep_suppression_list?: InputMaybe<CepSuppressionListsOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  suppression_list_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_suppression_list_subscription_topics" */
export const CepSuppressionListSubscriptionTopicsSelectColumn = {
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  SuppressionListId: 'suppression_list_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSuppressionListSubscriptionTopicsSelectColumn = typeof CepSuppressionListSubscriptionTopicsSelectColumn[keyof typeof CepSuppressionListSubscriptionTopicsSelectColumn];
/** aggregate stddev on columns */
export type CepSuppressionListSubscriptionTopicsStddevFields = {
  __typename?: 'cep_suppression_list_subscription_topics_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepSuppressionListSubscriptionTopicsStddevPopFields = {
  __typename?: 'cep_suppression_list_subscription_topics_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepSuppressionListSubscriptionTopicsStddevSampFields = {
  __typename?: 'cep_suppression_list_subscription_topics_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSuppressionListSubscriptionTopicsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSuppressionListSubscriptionTopicsStreamCursorValueInput = {
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  suppression_list_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSuppressionListSubscriptionTopicsSumFields = {
  __typename?: 'cep_suppression_list_subscription_topics_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "cep_suppression_list_subscription_topics" (current role has no relevant permissions) */
export const CepSuppressionListSubscriptionTopicsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type CepSuppressionListSubscriptionTopicsUpdateColumn = typeof CepSuppressionListSubscriptionTopicsUpdateColumn[keyof typeof CepSuppressionListSubscriptionTopicsUpdateColumn];
/** aggregate var_pop on columns */
export type CepSuppressionListSubscriptionTopicsVarPopFields = {
  __typename?: 'cep_suppression_list_subscription_topics_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepSuppressionListSubscriptionTopicsVarSampFields = {
  __typename?: 'cep_suppression_list_subscription_topics_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepSuppressionListSubscriptionTopicsVarianceFields = {
  __typename?: 'cep_suppression_list_subscription_topics_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_suppression_list_subscription_topics" */
export type CepSuppressionListSubscriptionTopicsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionLists = {
  __typename?: 'cep_suppression_lists';
  /** An array relationship */
  cep_suppression_list_subscription_topics: Array<CepSuppressionListSubscriptionTopics>;
  /** An aggregate relationship */
  cep_suppression_list_subscription_topics_aggregate: CepSuppressionListSubscriptionTopicsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  papi_model_id?: Maybe<Scalars['bigint']>;
  papi_sync_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  visual_query: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionListsCepSuppressionListSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionListsCepSuppressionListSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionListsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionListsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_suppression_lists" */
export type CepSuppressionListsVisualQueryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_suppression_lists" */
export type CepSuppressionListsAggregate = {
  __typename?: 'cep_suppression_lists_aggregate';
  aggregate?: Maybe<CepSuppressionListsAggregateFields>;
  nodes: Array<CepSuppressionLists>;
};

/** aggregate fields of "cep_suppression_lists" */
export type CepSuppressionListsAggregateFields = {
  __typename?: 'cep_suppression_lists_aggregate_fields';
  avg?: Maybe<CepSuppressionListsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepSuppressionListsMaxFields>;
  min?: Maybe<CepSuppressionListsMinFields>;
  stddev?: Maybe<CepSuppressionListsStddevFields>;
  stddev_pop?: Maybe<CepSuppressionListsStddevPopFields>;
  stddev_samp?: Maybe<CepSuppressionListsStddevSampFields>;
  sum?: Maybe<CepSuppressionListsSumFields>;
  var_pop?: Maybe<CepSuppressionListsVarPopFields>;
  var_samp?: Maybe<CepSuppressionListsVarSampFields>;
  variance?: Maybe<CepSuppressionListsVarianceFields>;
};


/** aggregate fields of "cep_suppression_lists" */
export type CepSuppressionListsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepSuppressionListsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepSuppressionListsAppendInput = {
  visual_query?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CepSuppressionListsAvgFields = {
  __typename?: 'cep_suppression_lists_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_suppression_lists". All fields are combined with a logical 'AND'. */
export type CepSuppressionListsBoolExp = {
  _and?: InputMaybe<Array<CepSuppressionListsBoolExp>>;
  _not?: InputMaybe<CepSuppressionListsBoolExp>;
  _or?: InputMaybe<Array<CepSuppressionListsBoolExp>>;
  cep_suppression_list_subscription_topics?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
  cep_suppression_list_subscription_topics_aggregate?: InputMaybe<CepSuppressionListSubscriptionTopicsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  papi_model_id?: InputMaybe<BigintComparisonExp>;
  papi_sync_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  visual_query?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_suppression_lists" */
export const CepSuppressionListsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepSuppressionListsIdWorkspaceIdKey: 'cep_suppression_lists_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepSuppressionListsPkey: 'cep_suppression_lists_pkey',
  /** unique or primary key constraint on columns "workspace_id", "name" */
  CepSuppressionListsWorkspaceIdNameKey: 'cep_suppression_lists_workspace_id_name_key'
} as const;

export type CepSuppressionListsConstraint = typeof CepSuppressionListsConstraint[keyof typeof CepSuppressionListsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepSuppressionListsDeleteAtPathInput = {
  visual_query?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepSuppressionListsDeleteElemInput = {
  visual_query?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepSuppressionListsDeleteKeyInput = {
  visual_query?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "cep_suppression_lists" */
export type CepSuppressionListsInsertInput = {
  cep_suppression_list_subscription_topics?: InputMaybe<CepSuppressionListSubscriptionTopicsArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  visual_query?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type CepSuppressionListsMaxFields = {
  __typename?: 'cep_suppression_lists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  papi_model_id?: Maybe<Scalars['bigint']>;
  papi_sync_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepSuppressionListsMinFields = {
  __typename?: 'cep_suppression_lists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  papi_model_id?: Maybe<Scalars['bigint']>;
  papi_sync_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_suppression_lists" */
export type CepSuppressionListsMutationResponse = {
  __typename?: 'cep_suppression_lists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepSuppressionLists>;
};

/** input type for inserting object relation for remote table "cep_suppression_lists" */
export type CepSuppressionListsObjRelInsertInput = {
  data: CepSuppressionListsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepSuppressionListsOnConflict>;
};

/** on_conflict condition type for table "cep_suppression_lists" */
export type CepSuppressionListsOnConflict = {
  constraint: CepSuppressionListsConstraint;
  update_columns?: Array<CepSuppressionListsUpdateColumn>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};

/** Ordering options when selecting data from "cep_suppression_lists". */
export type CepSuppressionListsOrderBy = {
  cep_suppression_list_subscription_topics_aggregate?: InputMaybe<CepSuppressionListSubscriptionTopicsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  papi_model_id?: InputMaybe<OrderBy>;
  papi_sync_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  visual_query?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_suppression_lists */
export type CepSuppressionListsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepSuppressionListsPrependInput = {
  visual_query?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_suppression_lists" */
export const CepSuppressionListsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PapiModelId: 'papi_model_id',
  /** column name */
  PapiSyncId: 'papi_sync_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VisualQuery: 'visual_query',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepSuppressionListsSelectColumn = typeof CepSuppressionListsSelectColumn[keyof typeof CepSuppressionListsSelectColumn];
/** input type for updating data in table "cep_suppression_lists" */
export type CepSuppressionListsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  visual_query?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type CepSuppressionListsStddevFields = {
  __typename?: 'cep_suppression_lists_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepSuppressionListsStddevPopFields = {
  __typename?: 'cep_suppression_lists_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepSuppressionListsStddevSampFields = {
  __typename?: 'cep_suppression_lists_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_suppression_lists" */
export type CepSuppressionListsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepSuppressionListsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepSuppressionListsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  papi_model_id?: InputMaybe<Scalars['bigint']>;
  papi_sync_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  visual_query?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepSuppressionListsSumFields = {
  __typename?: 'cep_suppression_lists_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  papi_model_id?: Maybe<Scalars['bigint']>;
  papi_sync_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_suppression_lists" */
export const CepSuppressionListsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  VisualQuery: 'visual_query'
} as const;

export type CepSuppressionListsUpdateColumn = typeof CepSuppressionListsUpdateColumn[keyof typeof CepSuppressionListsUpdateColumn];
export type CepSuppressionListsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepSuppressionListsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepSuppressionListsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepSuppressionListsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepSuppressionListsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepSuppressionListsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepSuppressionListsSetInput>;
  /** filter the rows which have to be updated */
  where: CepSuppressionListsBoolExp;
};

/** aggregate var_pop on columns */
export type CepSuppressionListsVarPopFields = {
  __typename?: 'cep_suppression_lists_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepSuppressionListsVarSampFields = {
  __typename?: 'cep_suppression_lists_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepSuppressionListsVarianceFields = {
  __typename?: 'cep_suppression_lists_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  papi_model_id?: Maybe<Scalars['Float']>;
  papi_sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_test_group_members" */
export type CepTestGroupMembers = {
  __typename?: 'cep_test_group_members';
  channel_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  phone_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  test_group: CepTestGroups;
  test_group_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
  /** An array relationship */
  workspace_members: Array<WorkspaceMembers>;
  /** An aggregate relationship */
  workspace_members_aggregate: WorkspaceMembersAggregate;
};


/** columns and relationships of "cep_test_group_members" */
export type CepTestGroupMembersNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_test_group_members" */
export type CepTestGroupMembersNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_test_group_members" */
export type CepTestGroupMembersWorkspaceMembersArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


/** columns and relationships of "cep_test_group_members" */
export type CepTestGroupMembersWorkspaceMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};

/** aggregated selection of "cep_test_group_members" */
export type CepTestGroupMembersAggregate = {
  __typename?: 'cep_test_group_members_aggregate';
  aggregate?: Maybe<CepTestGroupMembersAggregateFields>;
  nodes: Array<CepTestGroupMembers>;
};

export type CepTestGroupMembersAggregateBoolExp = {
  count?: InputMaybe<CepTestGroupMembersAggregateBoolExpCount>;
};

export type CepTestGroupMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepTestGroupMembersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_test_group_members" */
export type CepTestGroupMembersAggregateFields = {
  __typename?: 'cep_test_group_members_aggregate_fields';
  avg?: Maybe<CepTestGroupMembersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepTestGroupMembersMaxFields>;
  min?: Maybe<CepTestGroupMembersMinFields>;
  stddev?: Maybe<CepTestGroupMembersStddevFields>;
  stddev_pop?: Maybe<CepTestGroupMembersStddevPopFields>;
  stddev_samp?: Maybe<CepTestGroupMembersStddevSampFields>;
  sum?: Maybe<CepTestGroupMembersSumFields>;
  var_pop?: Maybe<CepTestGroupMembersVarPopFields>;
  var_samp?: Maybe<CepTestGroupMembersVarSampFields>;
  variance?: Maybe<CepTestGroupMembersVarianceFields>;
};


/** aggregate fields of "cep_test_group_members" */
export type CepTestGroupMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_test_group_members" */
export type CepTestGroupMembersAggregateOrderBy = {
  avg?: InputMaybe<CepTestGroupMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepTestGroupMembersMaxOrderBy>;
  min?: InputMaybe<CepTestGroupMembersMinOrderBy>;
  stddev?: InputMaybe<CepTestGroupMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<CepTestGroupMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepTestGroupMembersStddevSampOrderBy>;
  sum?: InputMaybe<CepTestGroupMembersSumOrderBy>;
  var_pop?: InputMaybe<CepTestGroupMembersVarPopOrderBy>;
  var_samp?: InputMaybe<CepTestGroupMembersVarSampOrderBy>;
  variance?: InputMaybe<CepTestGroupMembersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "cep_test_group_members" */
export type CepTestGroupMembersArrRelInsertInput = {
  data: Array<CepTestGroupMembersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CepTestGroupMembersOnConflict>;
};

/** aggregate avg on columns */
export type CepTestGroupMembersAvgFields = {
  __typename?: 'cep_test_group_members_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_test_group_members". All fields are combined with a logical 'AND'. */
export type CepTestGroupMembersBoolExp = {
  _and?: InputMaybe<Array<CepTestGroupMembersBoolExp>>;
  _not?: InputMaybe<CepTestGroupMembersBoolExp>;
  _or?: InputMaybe<Array<CepTestGroupMembersBoolExp>>;
  channel_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  phone_number?: InputMaybe<StringComparisonExp>;
  test_group?: InputMaybe<CepTestGroupsBoolExp>;
  test_group_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
  workspace_members?: InputMaybe<WorkspaceMembersBoolExp>;
  workspace_members_aggregate?: InputMaybe<WorkspaceMembersAggregateBoolExp>;
};

/** unique or primary key constraints on table "cep_test_group_members" */
export const CepTestGroupMembersConstraint = {
  /** unique or primary key constraint on columns "email", "test_group_id" */
  CepTestGroupMembersGroupEmailKey: 'cep_test_group_members_group_email_key',
  /** unique or primary key constraint on columns "phone_number", "test_group_id" */
  CepTestGroupMembersGroupPhoneKey: 'cep_test_group_members_group_phone_key',
  /** unique or primary key constraint on columns "user_id", "test_group_id" */
  CepTestGroupMembersGroupUserKey: 'cep_test_group_members_group_user_key',
  /** unique or primary key constraint on columns "id" */
  CepTestGroupMembersPkey: 'cep_test_group_members_pkey'
} as const;

export type CepTestGroupMembersConstraint = typeof CepTestGroupMembersConstraint[keyof typeof CepTestGroupMembersConstraint];
/** input type for inserting data into table "cep_test_group_members" */
export type CepTestGroupMembersInsertInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  phone_number?: InputMaybe<Scalars['String']>;
  test_group?: InputMaybe<CepTestGroupsObjRelInsertInput>;
  test_group_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type CepTestGroupMembersMaxFields = {
  __typename?: 'cep_test_group_members_max_fields';
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phone_number?: Maybe<Scalars['String']>;
  test_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersMaxOrderBy = {
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phone_number?: InputMaybe<OrderBy>;
  test_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepTestGroupMembersMinFields = {
  __typename?: 'cep_test_group_members_min_fields';
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phone_number?: Maybe<Scalars['String']>;
  test_group_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersMinOrderBy = {
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  phone_number?: InputMaybe<OrderBy>;
  test_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "cep_test_group_members" */
export type CepTestGroupMembersMutationResponse = {
  __typename?: 'cep_test_group_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepTestGroupMembers>;
};

/** on_conflict condition type for table "cep_test_group_members" */
export type CepTestGroupMembersOnConflict = {
  constraint: CepTestGroupMembersConstraint;
  update_columns?: Array<CepTestGroupMembersUpdateColumn>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};

/** Ordering options when selecting data from "cep_test_group_members". */
export type CepTestGroupMembersOrderBy = {
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  phone_number?: InputMaybe<OrderBy>;
  test_group?: InputMaybe<CepTestGroupsOrderBy>;
  test_group_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
  workspace_members_aggregate?: InputMaybe<WorkspaceMembersAggregateOrderBy>;
};

/** select columns of table "cep_test_group_members" */
export const CepTestGroupMembersSelectColumn = {
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  PhoneNumber: 'phone_number',
  /** column name */
  TestGroupId: 'test_group_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepTestGroupMembersSelectColumn = typeof CepTestGroupMembersSelectColumn[keyof typeof CepTestGroupMembersSelectColumn];
/** aggregate stddev on columns */
export type CepTestGroupMembersStddevFields = {
  __typename?: 'cep_test_group_members_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepTestGroupMembersStddevPopFields = {
  __typename?: 'cep_test_group_members_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepTestGroupMembersStddevSampFields = {
  __typename?: 'cep_test_group_members_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_test_group_members" */
export type CepTestGroupMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepTestGroupMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepTestGroupMembersStreamCursorValueInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  phone_number?: InputMaybe<Scalars['String']>;
  test_group_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepTestGroupMembersSumFields = {
  __typename?: 'cep_test_group_members_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "cep_test_group_members" (current role has no relevant permissions) */
export const CepTestGroupMembersUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type CepTestGroupMembersUpdateColumn = typeof CepTestGroupMembersUpdateColumn[keyof typeof CepTestGroupMembersUpdateColumn];
/** aggregate var_pop on columns */
export type CepTestGroupMembersVarPopFields = {
  __typename?: 'cep_test_group_members_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepTestGroupMembersVarSampFields = {
  __typename?: 'cep_test_group_members_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepTestGroupMembersVarianceFields = {
  __typename?: 'cep_test_group_members_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_test_group_members" */
export type CepTestGroupMembersVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_test_groups" */
export type CepTestGroups = {
  __typename?: 'cep_test_groups';
  channel_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An array relationship */
  members: Array<CepTestGroupMembers>;
  /** An aggregate relationship */
  members_aggregate: CepTestGroupMembersAggregate;
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_test_groups" */
export type CepTestGroupsMembersArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


/** columns and relationships of "cep_test_groups" */
export type CepTestGroupsMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


/** columns and relationships of "cep_test_groups" */
export type CepTestGroupsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_test_groups" */
export type CepTestGroupsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "cep_test_groups" */
export type CepTestGroupsAggregate = {
  __typename?: 'cep_test_groups_aggregate';
  aggregate?: Maybe<CepTestGroupsAggregateFields>;
  nodes: Array<CepTestGroups>;
};

/** aggregate fields of "cep_test_groups" */
export type CepTestGroupsAggregateFields = {
  __typename?: 'cep_test_groups_aggregate_fields';
  avg?: Maybe<CepTestGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepTestGroupsMaxFields>;
  min?: Maybe<CepTestGroupsMinFields>;
  stddev?: Maybe<CepTestGroupsStddevFields>;
  stddev_pop?: Maybe<CepTestGroupsStddevPopFields>;
  stddev_samp?: Maybe<CepTestGroupsStddevSampFields>;
  sum?: Maybe<CepTestGroupsSumFields>;
  var_pop?: Maybe<CepTestGroupsVarPopFields>;
  var_samp?: Maybe<CepTestGroupsVarSampFields>;
  variance?: Maybe<CepTestGroupsVarianceFields>;
};


/** aggregate fields of "cep_test_groups" */
export type CepTestGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepTestGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepTestGroupsAvgFields = {
  __typename?: 'cep_test_groups_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_test_groups". All fields are combined with a logical 'AND'. */
export type CepTestGroupsBoolExp = {
  _and?: InputMaybe<Array<CepTestGroupsBoolExp>>;
  _not?: InputMaybe<CepTestGroupsBoolExp>;
  _or?: InputMaybe<Array<CepTestGroupsBoolExp>>;
  channel_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  members?: InputMaybe<CepTestGroupMembersBoolExp>;
  members_aggregate?: InputMaybe<CepTestGroupMembersAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_test_groups" */
export const CepTestGroupsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id", "channel_type" */
  CepTestGroupsIdWorkspaceIdChannelTypeKey: 'cep_test_groups_id_workspace_id_channel_type_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepTestGroupsIdWorkspaceIdKey: 'cep_test_groups_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepTestGroupsPkey: 'cep_test_groups_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  CepTestGroupsWorkspaceNameKey: 'cep_test_groups_workspace_name_key'
} as const;

export type CepTestGroupsConstraint = typeof CepTestGroupsConstraint[keyof typeof CepTestGroupsConstraint];
/** input type for inserting data into table "cep_test_groups" */
export type CepTestGroupsInsertInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  members?: InputMaybe<CepTestGroupMembersArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CepTestGroupsMaxFields = {
  __typename?: 'cep_test_groups_max_fields';
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepTestGroupsMinFields = {
  __typename?: 'cep_test_groups_min_fields';
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_test_groups" */
export type CepTestGroupsMutationResponse = {
  __typename?: 'cep_test_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepTestGroups>;
};

/** input type for inserting object relation for remote table "cep_test_groups" */
export type CepTestGroupsObjRelInsertInput = {
  data: CepTestGroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepTestGroupsOnConflict>;
};

/** on_conflict condition type for table "cep_test_groups" */
export type CepTestGroupsOnConflict = {
  constraint: CepTestGroupsConstraint;
  update_columns?: Array<CepTestGroupsUpdateColumn>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};

/** Ordering options when selecting data from "cep_test_groups". */
export type CepTestGroupsOrderBy = {
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  members_aggregate?: InputMaybe<CepTestGroupMembersAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_test_groups */
export type CepTestGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "cep_test_groups" */
export const CepTestGroupsSelectColumn = {
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepTestGroupsSelectColumn = typeof CepTestGroupsSelectColumn[keyof typeof CepTestGroupsSelectColumn];
/** input type for updating data in table "cep_test_groups" */
export type CepTestGroupsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CepTestGroupsStddevFields = {
  __typename?: 'cep_test_groups_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepTestGroupsStddevPopFields = {
  __typename?: 'cep_test_groups_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepTestGroupsStddevSampFields = {
  __typename?: 'cep_test_groups_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_test_groups" */
export type CepTestGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepTestGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepTestGroupsStreamCursorValueInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepTestGroupsSumFields = {
  __typename?: 'cep_test_groups_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_test_groups" */
export const CepTestGroupsUpdateColumn = {
  /** column name */
  Name: 'name'
} as const;

export type CepTestGroupsUpdateColumn = typeof CepTestGroupsUpdateColumn[keyof typeof CepTestGroupsUpdateColumn];
export type CepTestGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepTestGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: CepTestGroupsBoolExp;
};

/** aggregate var_pop on columns */
export type CepTestGroupsVarPopFields = {
  __typename?: 'cep_test_groups_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepTestGroupsVarSampFields = {
  __typename?: 'cep_test_groups_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepTestGroupsVarianceFields = {
  __typename?: 'cep_test_groups_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_translations" */
export type CepTranslations = {
  __typename?: 'cep_translations';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  element_key: Scalars['String'];
  email_template_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  locale_id: Scalars['uuid'];
  /** An object relationship */
  message?: Maybe<Messages>;
  message_id?: Maybe<Scalars['uuid']>;
  slot: Scalars['String'];
  source_hash: Scalars['String'];
  source_text: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  upload_id?: Maybe<Scalars['uuid']>;
  value: Scalars['String'];
  variant_arm_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  whatsapp_template?: Maybe<CepWhatsappTemplates>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "cep_translations". All fields are combined with a logical 'AND'. */
export type CepTranslationsBoolExp = {
  _and?: InputMaybe<Array<CepTranslationsBoolExp>>;
  _not?: InputMaybe<CepTranslationsBoolExp>;
  _or?: InputMaybe<Array<CepTranslationsBoolExp>>;
  cep_whatsapp_template_id?: InputMaybe<UuidComparisonExp>;
  content_block_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  element_key?: InputMaybe<StringComparisonExp>;
  email_template_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locale_id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  slot?: InputMaybe<StringComparisonExp>;
  source_hash?: InputMaybe<StringComparisonExp>;
  source_text?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  upload_id?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
  variant_arm_id?: InputMaybe<UuidComparisonExp>;
  whatsapp_template?: InputMaybe<CepWhatsappTemplatesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "cep_translations". */
export type CepTranslationsOrderBy = {
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  element_key?: InputMaybe<OrderBy>;
  email_template_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale_id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  slot?: InputMaybe<OrderBy>;
  source_hash?: InputMaybe<OrderBy>;
  source_text?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  upload_id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  variant_arm_id?: InputMaybe<OrderBy>;
  whatsapp_template?: InputMaybe<CepWhatsappTemplatesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_translations" */
export const CepTranslationsSelectColumn = {
  /** column name */
  CepWhatsappTemplateId: 'cep_whatsapp_template_id',
  /** column name */
  ContentBlockId: 'content_block_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ElementKey: 'element_key',
  /** column name */
  EmailTemplateId: 'email_template_id',
  /** column name */
  Id: 'id',
  /** column name */
  LocaleId: 'locale_id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Slot: 'slot',
  /** column name */
  SourceHash: 'source_hash',
  /** column name */
  SourceText: 'source_text',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UploadId: 'upload_id',
  /** column name */
  Value: 'value',
  /** column name */
  VariantArmId: 'variant_arm_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepTranslationsSelectColumn = typeof CepTranslationsSelectColumn[keyof typeof CepTranslationsSelectColumn];
/** Streaming cursor of the table "cep_translations" */
export type CepTranslationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepTranslationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepTranslationsStreamCursorValueInput = {
  cep_whatsapp_template_id?: InputMaybe<Scalars['uuid']>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  element_key?: InputMaybe<Scalars['String']>;
  email_template_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  locale_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  slot?: InputMaybe<Scalars['String']>;
  source_hash?: InputMaybe<Scalars['String']>;
  source_text?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  upload_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
  variant_arm_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocales = {
  __typename?: 'cep_whatsapp_template_locales';
  approved_at?: Maybe<Scalars['timestamptz']>;
  category?: Maybe<Scalars['String']>;
  category_synced_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  cep_locale?: Maybe<CepLocales>;
  /** An object relationship */
  cep_whatsapp_template: CepWhatsappTemplates;
  cep_whatsapp_template_id: Scalars['uuid'];
  content_updated_at: Scalars['timestamptz'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  editor_state?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  is_source: Scalars['Boolean'];
  language: Scalars['String'];
  locale_id?: Maybe<Scalars['uuid']>;
  provider_content_deletion_requested_at?: Maybe<Scalars['timestamptz']>;
  provider_content_id?: Maybe<Scalars['String']>;
  provider_content_snapshot?: Maybe<Scalars['jsonb']>;
  quality?: Maybe<Scalars['String']>;
  quality_synced_at?: Maybe<Scalars['timestamptz']>;
  rejection_reason?: Maybe<Scalars['String']>;
  requested_category: Scalars['String'];
  samples: Scalars['jsonb'];
  status: Scalars['String'];
  status_synced_at?: Maybe<Scalars['timestamptz']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  variables: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesEditorStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesProviderContentSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesSamplesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesVariablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesAggregate = {
  __typename?: 'cep_whatsapp_template_locales_aggregate';
  aggregate?: Maybe<CepWhatsappTemplateLocalesAggregateFields>;
  nodes: Array<CepWhatsappTemplateLocales>;
};

export type CepWhatsappTemplateLocalesAggregateBoolExp = {
  bool_and?: InputMaybe<CepWhatsappTemplateLocalesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CepWhatsappTemplateLocalesAggregateBoolExpBoolOr>;
  count?: InputMaybe<CepWhatsappTemplateLocalesAggregateBoolExpCount>;
};

export type CepWhatsappTemplateLocalesAggregateBoolExpBoolAnd = {
  arguments: CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepWhatsappTemplateLocalesAggregateBoolExpBoolOr = {
  arguments: CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CepWhatsappTemplateLocalesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesAggregateFields = {
  __typename?: 'cep_whatsapp_template_locales_aggregate_fields';
  avg?: Maybe<CepWhatsappTemplateLocalesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepWhatsappTemplateLocalesMaxFields>;
  min?: Maybe<CepWhatsappTemplateLocalesMinFields>;
  stddev?: Maybe<CepWhatsappTemplateLocalesStddevFields>;
  stddev_pop?: Maybe<CepWhatsappTemplateLocalesStddevPopFields>;
  stddev_samp?: Maybe<CepWhatsappTemplateLocalesStddevSampFields>;
  sum?: Maybe<CepWhatsappTemplateLocalesSumFields>;
  var_pop?: Maybe<CepWhatsappTemplateLocalesVarPopFields>;
  var_samp?: Maybe<CepWhatsappTemplateLocalesVarSampFields>;
  variance?: Maybe<CepWhatsappTemplateLocalesVarianceFields>;
};


/** aggregate fields of "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesAggregateOrderBy = {
  avg?: InputMaybe<CepWhatsappTemplateLocalesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepWhatsappTemplateLocalesMaxOrderBy>;
  min?: InputMaybe<CepWhatsappTemplateLocalesMinOrderBy>;
  stddev?: InputMaybe<CepWhatsappTemplateLocalesStddevOrderBy>;
  stddev_pop?: InputMaybe<CepWhatsappTemplateLocalesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepWhatsappTemplateLocalesStddevSampOrderBy>;
  sum?: InputMaybe<CepWhatsappTemplateLocalesSumOrderBy>;
  var_pop?: InputMaybe<CepWhatsappTemplateLocalesVarPopOrderBy>;
  var_samp?: InputMaybe<CepWhatsappTemplateLocalesVarSampOrderBy>;
  variance?: InputMaybe<CepWhatsappTemplateLocalesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CepWhatsappTemplateLocalesAvgFields = {
  __typename?: 'cep_whatsapp_template_locales_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_whatsapp_template_locales". All fields are combined with a logical 'AND'. */
export type CepWhatsappTemplateLocalesBoolExp = {
  _and?: InputMaybe<Array<CepWhatsappTemplateLocalesBoolExp>>;
  _not?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
  _or?: InputMaybe<Array<CepWhatsappTemplateLocalesBoolExp>>;
  approved_at?: InputMaybe<TimestamptzComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  category_synced_at?: InputMaybe<TimestamptzComparisonExp>;
  cep_locale?: InputMaybe<CepLocalesBoolExp>;
  cep_whatsapp_template?: InputMaybe<CepWhatsappTemplatesBoolExp>;
  cep_whatsapp_template_id?: InputMaybe<UuidComparisonExp>;
  content_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  editor_state?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_source?: InputMaybe<BooleanComparisonExp>;
  language?: InputMaybe<StringComparisonExp>;
  locale_id?: InputMaybe<UuidComparisonExp>;
  provider_content_deletion_requested_at?: InputMaybe<TimestamptzComparisonExp>;
  provider_content_id?: InputMaybe<StringComparisonExp>;
  provider_content_snapshot?: InputMaybe<JsonbComparisonExp>;
  quality?: InputMaybe<StringComparisonExp>;
  quality_synced_at?: InputMaybe<TimestamptzComparisonExp>;
  rejection_reason?: InputMaybe<StringComparisonExp>;
  requested_category?: InputMaybe<StringComparisonExp>;
  samples?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_synced_at?: InputMaybe<TimestamptzComparisonExp>;
  submitted_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  variables?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepWhatsappTemplateLocalesMaxFields = {
  __typename?: 'cep_whatsapp_template_locales_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  category?: Maybe<Scalars['String']>;
  category_synced_at?: Maybe<Scalars['timestamptz']>;
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  locale_id?: Maybe<Scalars['uuid']>;
  provider_content_deletion_requested_at?: Maybe<Scalars['timestamptz']>;
  provider_content_id?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['String']>;
  quality_synced_at?: Maybe<Scalars['timestamptz']>;
  rejection_reason?: Maybe<Scalars['String']>;
  requested_category?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_synced_at?: Maybe<Scalars['timestamptz']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesMaxOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_synced_at?: InputMaybe<OrderBy>;
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_updated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  locale_id?: InputMaybe<OrderBy>;
  provider_content_deletion_requested_at?: InputMaybe<OrderBy>;
  provider_content_id?: InputMaybe<OrderBy>;
  quality?: InputMaybe<OrderBy>;
  quality_synced_at?: InputMaybe<OrderBy>;
  rejection_reason?: InputMaybe<OrderBy>;
  requested_category?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_synced_at?: InputMaybe<OrderBy>;
  submitted_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepWhatsappTemplateLocalesMinFields = {
  __typename?: 'cep_whatsapp_template_locales_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  category?: Maybe<Scalars['String']>;
  category_synced_at?: Maybe<Scalars['timestamptz']>;
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Scalars['String']>;
  locale_id?: Maybe<Scalars['uuid']>;
  provider_content_deletion_requested_at?: Maybe<Scalars['timestamptz']>;
  provider_content_id?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['String']>;
  quality_synced_at?: Maybe<Scalars['timestamptz']>;
  rejection_reason?: Maybe<Scalars['String']>;
  requested_category?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_synced_at?: Maybe<Scalars['timestamptz']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesMinOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_synced_at?: InputMaybe<OrderBy>;
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_updated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  locale_id?: InputMaybe<OrderBy>;
  provider_content_deletion_requested_at?: InputMaybe<OrderBy>;
  provider_content_id?: InputMaybe<OrderBy>;
  quality?: InputMaybe<OrderBy>;
  quality_synced_at?: InputMaybe<OrderBy>;
  rejection_reason?: InputMaybe<OrderBy>;
  requested_category?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_synced_at?: InputMaybe<OrderBy>;
  submitted_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cep_whatsapp_template_locales". */
export type CepWhatsappTemplateLocalesOrderBy = {
  approved_at?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  category_synced_at?: InputMaybe<OrderBy>;
  cep_locale?: InputMaybe<CepLocalesOrderBy>;
  cep_whatsapp_template?: InputMaybe<CepWhatsappTemplatesOrderBy>;
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_updated_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  editor_state?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_source?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  locale_id?: InputMaybe<OrderBy>;
  provider_content_deletion_requested_at?: InputMaybe<OrderBy>;
  provider_content_id?: InputMaybe<OrderBy>;
  provider_content_snapshot?: InputMaybe<OrderBy>;
  quality?: InputMaybe<OrderBy>;
  quality_synced_at?: InputMaybe<OrderBy>;
  rejection_reason?: InputMaybe<OrderBy>;
  requested_category?: InputMaybe<OrderBy>;
  samples?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_synced_at?: InputMaybe<OrderBy>;
  submitted_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  variables?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_whatsapp_template_locales" */
export const CepWhatsappTemplateLocalesSelectColumn = {
  /** column name */
  ApprovedAt: 'approved_at',
  /** column name */
  Category: 'category',
  /** column name */
  CategorySyncedAt: 'category_synced_at',
  /** column name */
  CepWhatsappTemplateId: 'cep_whatsapp_template_id',
  /** column name */
  ContentUpdatedAt: 'content_updated_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EditorState: 'editor_state',
  /** column name */
  Id: 'id',
  /** column name */
  IsSource: 'is_source',
  /** column name */
  Language: 'language',
  /** column name */
  LocaleId: 'locale_id',
  /** column name */
  ProviderContentDeletionRequestedAt: 'provider_content_deletion_requested_at',
  /** column name */
  ProviderContentId: 'provider_content_id',
  /** column name */
  ProviderContentSnapshot: 'provider_content_snapshot',
  /** column name */
  Quality: 'quality',
  /** column name */
  QualitySyncedAt: 'quality_synced_at',
  /** column name */
  RejectionReason: 'rejection_reason',
  /** column name */
  RequestedCategory: 'requested_category',
  /** column name */
  Samples: 'samples',
  /** column name */
  Status: 'status',
  /** column name */
  StatusSyncedAt: 'status_synced_at',
  /** column name */
  SubmittedAt: 'submitted_at',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Variables: 'variables',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepWhatsappTemplateLocalesSelectColumn = typeof CepWhatsappTemplateLocalesSelectColumn[keyof typeof CepWhatsappTemplateLocalesSelectColumn];
/** select "cep_whatsapp_template_locales_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cep_whatsapp_template_locales" */
export const CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsSource: 'is_source'
} as const;

export type CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolAndArgumentsColumns = typeof CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolAndArgumentsColumns];
/** select "cep_whatsapp_template_locales_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cep_whatsapp_template_locales" */
export const CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsSource: 'is_source'
} as const;

export type CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolOrArgumentsColumns = typeof CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof CepWhatsappTemplateLocalesSelectColumnCepWhatsappTemplateLocalesAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type CepWhatsappTemplateLocalesStddevFields = {
  __typename?: 'cep_whatsapp_template_locales_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepWhatsappTemplateLocalesStddevPopFields = {
  __typename?: 'cep_whatsapp_template_locales_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepWhatsappTemplateLocalesStddevSampFields = {
  __typename?: 'cep_whatsapp_template_locales_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepWhatsappTemplateLocalesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepWhatsappTemplateLocalesStreamCursorValueInput = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  category?: InputMaybe<Scalars['String']>;
  category_synced_at?: InputMaybe<Scalars['timestamptz']>;
  cep_whatsapp_template_id?: InputMaybe<Scalars['uuid']>;
  content_updated_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  editor_state?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_source?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  locale_id?: InputMaybe<Scalars['uuid']>;
  provider_content_deletion_requested_at?: InputMaybe<Scalars['timestamptz']>;
  provider_content_id?: InputMaybe<Scalars['String']>;
  provider_content_snapshot?: InputMaybe<Scalars['jsonb']>;
  quality?: InputMaybe<Scalars['String']>;
  quality_synced_at?: InputMaybe<Scalars['timestamptz']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  requested_category?: InputMaybe<Scalars['String']>;
  samples?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  status_synced_at?: InputMaybe<Scalars['timestamptz']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  variables?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepWhatsappTemplateLocalesSumFields = {
  __typename?: 'cep_whatsapp_template_locales_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CepWhatsappTemplateLocalesVarPopFields = {
  __typename?: 'cep_whatsapp_template_locales_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepWhatsappTemplateLocalesVarSampFields = {
  __typename?: 'cep_whatsapp_template_locales_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepWhatsappTemplateLocalesVarianceFields = {
  __typename?: 'cep_whatsapp_template_locales_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_whatsapp_template_locales" */
export type CepWhatsappTemplateLocalesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cep_whatsapp_templates" */
export type CepWhatsappTemplates = {
  __typename?: 'cep_whatsapp_templates';
  added_to_library: Scalars['Boolean'];
  archived_at?: Maybe<Scalars['timestamptz']>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cep_provider?: Maybe<CepProviders>;
  /** An array relationship */
  cep_whatsapp_template_locales: Array<CepWhatsappTemplateLocales>;
  /** An aggregate relationship */
  cep_whatsapp_template_locales_aggregate: CepWhatsappTemplateLocalesAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  forked_from_template_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** Whether a campaign past Draft or any journey sends the template, which keeps an approval from being discarded */
  in_use?: Maybe<Scalars['Boolean']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  /** An array relationship */
  message_contents: Array<MessageContents>;
  /** An aggregate relationship */
  message_contents_aggregate: MessageContentsAggregate;
  name: Scalars['String'];
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  waba_id: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesCepWhatsappTemplateLocalesArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


/** columns and relationships of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesCepWhatsappTemplateLocalesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


/** columns and relationships of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


/** columns and relationships of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};

/** aggregated selection of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesAggregate = {
  __typename?: 'cep_whatsapp_templates_aggregate';
  aggregate?: Maybe<CepWhatsappTemplatesAggregateFields>;
  nodes: Array<CepWhatsappTemplates>;
};

/** aggregate fields of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesAggregateFields = {
  __typename?: 'cep_whatsapp_templates_aggregate_fields';
  avg?: Maybe<CepWhatsappTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepWhatsappTemplatesMaxFields>;
  min?: Maybe<CepWhatsappTemplatesMinFields>;
  stddev?: Maybe<CepWhatsappTemplatesStddevFields>;
  stddev_pop?: Maybe<CepWhatsappTemplatesStddevPopFields>;
  stddev_samp?: Maybe<CepWhatsappTemplatesStddevSampFields>;
  sum?: Maybe<CepWhatsappTemplatesSumFields>;
  var_pop?: Maybe<CepWhatsappTemplatesVarPopFields>;
  var_samp?: Maybe<CepWhatsappTemplatesVarSampFields>;
  variance?: Maybe<CepWhatsappTemplatesVarianceFields>;
};


/** aggregate fields of "cep_whatsapp_templates" */
export type CepWhatsappTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepWhatsappTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CepWhatsappTemplatesAvgFields = {
  __typename?: 'cep_whatsapp_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_whatsapp_templates". All fields are combined with a logical 'AND'. */
export type CepWhatsappTemplatesBoolExp = {
  _and?: InputMaybe<Array<CepWhatsappTemplatesBoolExp>>;
  _not?: InputMaybe<CepWhatsappTemplatesBoolExp>;
  _or?: InputMaybe<Array<CepWhatsappTemplatesBoolExp>>;
  added_to_library?: InputMaybe<BooleanComparisonExp>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  cep_brand_id?: InputMaybe<UuidComparisonExp>;
  cep_provider?: InputMaybe<CepProvidersBoolExp>;
  cep_whatsapp_template_locales?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
  cep_whatsapp_template_locales_aggregate?: InputMaybe<CepWhatsappTemplateLocalesAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  forked_from_template_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  in_use?: InputMaybe<BooleanComparisonExp>;
  live_message_count?: InputMaybe<IntComparisonExp>;
  message_contents?: InputMaybe<MessageContentsBoolExp>;
  message_contents_aggregate?: InputMaybe<MessageContentsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  waba_id?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepWhatsappTemplatesMaxFields = {
  __typename?: 'cep_whatsapp_templates_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  forked_from_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  waba_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepWhatsappTemplatesMinFields = {
  __typename?: 'cep_whatsapp_templates_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  forked_from_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  waba_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "cep_whatsapp_templates". */
export type CepWhatsappTemplatesOrderBy = {
  added_to_library?: InputMaybe<OrderBy>;
  archived_at?: InputMaybe<OrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  cep_provider?: InputMaybe<CepProvidersOrderBy>;
  cep_whatsapp_template_locales_aggregate?: InputMaybe<CepWhatsappTemplateLocalesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  forked_from_template_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  in_use?: InputMaybe<OrderBy>;
  live_message_count?: InputMaybe<OrderBy>;
  message_contents_aggregate?: InputMaybe<MessageContentsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  waba_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_whatsapp_templates" */
export const CepWhatsappTemplatesSelectColumn = {
  /** column name */
  AddedToLibrary: 'added_to_library',
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ForkedFromTemplateId: 'forked_from_template_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ProviderId: 'provider_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WabaId: 'waba_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepWhatsappTemplatesSelectColumn = typeof CepWhatsappTemplatesSelectColumn[keyof typeof CepWhatsappTemplatesSelectColumn];
/** aggregate stddev on columns */
export type CepWhatsappTemplatesStddevFields = {
  __typename?: 'cep_whatsapp_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepWhatsappTemplatesStddevPopFields = {
  __typename?: 'cep_whatsapp_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepWhatsappTemplatesStddevSampFields = {
  __typename?: 'cep_whatsapp_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_whatsapp_templates" */
export type CepWhatsappTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepWhatsappTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepWhatsappTemplatesStreamCursorValueInput = {
  added_to_library?: InputMaybe<Scalars['Boolean']>;
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  forked_from_template_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  waba_id?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepWhatsappTemplatesSumFields = {
  __typename?: 'cep_whatsapp_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CepWhatsappTemplatesVarPopFields = {
  __typename?: 'cep_whatsapp_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepWhatsappTemplatesVarSampFields = {
  __typename?: 'cep_whatsapp_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepWhatsappTemplatesVarianceFields = {
  __typename?: 'cep_whatsapp_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** Messages whose published or draft content sends the template */
  live_message_count?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfig = {
  __typename?: 'cep_workspace_config';
  campaign_approval_required: Scalars['Boolean'];
  column_mappings?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  connection?: Maybe<Connections>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  hash_salt: Scalars['String'];
  id: Scalars['uuid'];
  journey_approval_required: Scalars['Boolean'];
  localization_fallback: Scalars['String'];
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  parent_models: Array<CepWorkspaceParentModels>;
  /** An aggregate relationship */
  parent_models_aggregate: CepWorkspaceParentModelsAggregate;
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  timezone_inference_enabled: Scalars['Boolean'];
  tos_accepted?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  warehouse_attribute_cache_sync?: Maybe<DestinationInstances>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigColumnMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigParentModelsArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigParentModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


/** columns and relationships of "cep_workspace_config" */
export type CepWorkspaceConfigTosAcceptedArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_workspace_config" */
export type CepWorkspaceConfigAggregate = {
  __typename?: 'cep_workspace_config_aggregate';
  aggregate?: Maybe<CepWorkspaceConfigAggregateFields>;
  nodes: Array<CepWorkspaceConfig>;
};

/** aggregate fields of "cep_workspace_config" */
export type CepWorkspaceConfigAggregateFields = {
  __typename?: 'cep_workspace_config_aggregate_fields';
  avg?: Maybe<CepWorkspaceConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepWorkspaceConfigMaxFields>;
  min?: Maybe<CepWorkspaceConfigMinFields>;
  stddev?: Maybe<CepWorkspaceConfigStddevFields>;
  stddev_pop?: Maybe<CepWorkspaceConfigStddevPopFields>;
  stddev_samp?: Maybe<CepWorkspaceConfigStddevSampFields>;
  sum?: Maybe<CepWorkspaceConfigSumFields>;
  var_pop?: Maybe<CepWorkspaceConfigVarPopFields>;
  var_samp?: Maybe<CepWorkspaceConfigVarSampFields>;
  variance?: Maybe<CepWorkspaceConfigVarianceFields>;
};


/** aggregate fields of "cep_workspace_config" */
export type CepWorkspaceConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepWorkspaceConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CepWorkspaceConfigAppendInput = {
  column_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CepWorkspaceConfigAvgFields = {
  __typename?: 'cep_workspace_config_avg_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cep_workspace_config". All fields are combined with a logical 'AND'. */
export type CepWorkspaceConfigBoolExp = {
  _and?: InputMaybe<Array<CepWorkspaceConfigBoolExp>>;
  _not?: InputMaybe<CepWorkspaceConfigBoolExp>;
  _or?: InputMaybe<Array<CepWorkspaceConfigBoolExp>>;
  campaign_approval_required?: InputMaybe<BooleanComparisonExp>;
  column_mappings?: InputMaybe<JsonbComparisonExp>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  hash_salt?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_approval_required?: InputMaybe<BooleanComparisonExp>;
  localization_fallback?: InputMaybe<StringComparisonExp>;
  mode?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  parent_models?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
  parent_models_aggregate?: InputMaybe<CepWorkspaceParentModelsAggregateBoolExp>;
  profile_cache_refreshed_at?: InputMaybe<TimestamptzComparisonExp>;
  timezone_inference_enabled?: InputMaybe<BooleanComparisonExp>;
  tos_accepted?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  warehouse_attribute_cache_sync?: InputMaybe<DestinationInstancesBoolExp>;
  warehouse_attribute_cache_sync_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "cep_workspace_config" */
export const CepWorkspaceConfigConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CepWorkspaceConfigIdWorkspaceIdKey: 'cep_workspace_config_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  CepWorkspaceConfigPkey: 'cep_workspace_config_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  CepWorkspaceConfigWorkspaceIdKey: 'cep_workspace_config_workspace_id_key'
} as const;

export type CepWorkspaceConfigConstraint = typeof CepWorkspaceConfigConstraint[keyof typeof CepWorkspaceConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CepWorkspaceConfigDeleteAtPathInput = {
  column_mappings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CepWorkspaceConfigDeleteElemInput = {
  column_mappings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CepWorkspaceConfigDeleteKeyInput = {
  column_mappings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "cep_workspace_config" */
export type CepWorkspaceConfigIncInput = {
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "cep_workspace_config" */
export type CepWorkspaceConfigInsertInput = {
  campaign_approval_required?: InputMaybe<Scalars['Boolean']>;
  column_mappings?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  hash_salt?: InputMaybe<Scalars['String']>;
  journey_approval_required?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync?: InputMaybe<DestinationInstancesObjRelInsertInput>;
};

/** aggregate max on columns */
export type CepWorkspaceConfigMaxFields = {
  __typename?: 'cep_workspace_config_max_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  hash_salt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  localization_fallback?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CepWorkspaceConfigMinFields = {
  __typename?: 'cep_workspace_config_min_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  hash_salt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  localization_fallback?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "cep_workspace_config" */
export type CepWorkspaceConfigMutationResponse = {
  __typename?: 'cep_workspace_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CepWorkspaceConfig>;
};

/** input type for inserting object relation for remote table "cep_workspace_config" */
export type CepWorkspaceConfigObjRelInsertInput = {
  data: CepWorkspaceConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CepWorkspaceConfigOnConflict>;
};

/** on_conflict condition type for table "cep_workspace_config" */
export type CepWorkspaceConfigOnConflict = {
  constraint: CepWorkspaceConfigConstraint;
  update_columns?: Array<CepWorkspaceConfigUpdateColumn>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};

/** Ordering options when selecting data from "cep_workspace_config". */
export type CepWorkspaceConfigOrderBy = {
  campaign_approval_required?: InputMaybe<OrderBy>;
  column_mappings?: InputMaybe<OrderBy>;
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  hash_salt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_approval_required?: InputMaybe<OrderBy>;
  localization_fallback?: InputMaybe<OrderBy>;
  mode?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  parent_models_aggregate?: InputMaybe<CepWorkspaceParentModelsAggregateOrderBy>;
  profile_cache_refreshed_at?: InputMaybe<OrderBy>;
  timezone_inference_enabled?: InputMaybe<OrderBy>;
  tos_accepted?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  warehouse_attribute_cache_sync?: InputMaybe<DestinationInstancesOrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cep_workspace_config */
export type CepWorkspaceConfigPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CepWorkspaceConfigPrependInput = {
  column_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "cep_workspace_config" */
export const CepWorkspaceConfigSelectColumn = {
  /** column name */
  CampaignApprovalRequired: 'campaign_approval_required',
  /** column name */
  ColumnMappings: 'column_mappings',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  HashSalt: 'hash_salt',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyApprovalRequired: 'journey_approval_required',
  /** column name */
  LocalizationFallback: 'localization_fallback',
  /** column name */
  Mode: 'mode',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  ProfileCacheRefreshedAt: 'profile_cache_refreshed_at',
  /** column name */
  TimezoneInferenceEnabled: 'timezone_inference_enabled',
  /** column name */
  TosAccepted: 'tos_accepted',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseAttributeCacheSyncId: 'warehouse_attribute_cache_sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepWorkspaceConfigSelectColumn = typeof CepWorkspaceConfigSelectColumn[keyof typeof CepWorkspaceConfigSelectColumn];
/** input type for updating data in table "cep_workspace_config" */
export type CepWorkspaceConfigSetInput = {
  campaign_approval_required?: InputMaybe<Scalars['Boolean']>;
  column_mappings?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  hash_salt?: InputMaybe<Scalars['String']>;
  journey_approval_required?: InputMaybe<Scalars['Boolean']>;
  localization_fallback?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  timezone_inference_enabled?: InputMaybe<Scalars['Boolean']>;
  warehouse_attribute_cache_sync_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type CepWorkspaceConfigStddevFields = {
  __typename?: 'cep_workspace_config_stddev_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CepWorkspaceConfigStddevPopFields = {
  __typename?: 'cep_workspace_config_stddev_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CepWorkspaceConfigStddevSampFields = {
  __typename?: 'cep_workspace_config_stddev_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cep_workspace_config" */
export type CepWorkspaceConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepWorkspaceConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepWorkspaceConfigStreamCursorValueInput = {
  campaign_approval_required?: InputMaybe<Scalars['Boolean']>;
  column_mappings?: InputMaybe<Scalars['jsonb']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  hash_salt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_approval_required?: InputMaybe<Scalars['Boolean']>;
  localization_fallback?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  timezone_inference_enabled?: InputMaybe<Scalars['Boolean']>;
  tos_accepted?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepWorkspaceConfigSumFields = {
  __typename?: 'cep_workspace_config_sum_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "cep_workspace_config" */
export const CepWorkspaceConfigUpdateColumn = {
  /** column name */
  CampaignApprovalRequired: 'campaign_approval_required',
  /** column name */
  ColumnMappings: 'column_mappings',
  /** column name */
  Description: 'description',
  /** column name */
  HashSalt: 'hash_salt',
  /** column name */
  JourneyApprovalRequired: 'journey_approval_required',
  /** column name */
  LocalizationFallback: 'localization_fallback',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  TimezoneInferenceEnabled: 'timezone_inference_enabled',
  /** column name */
  WarehouseAttributeCacheSyncId: 'warehouse_attribute_cache_sync_id'
} as const;

export type CepWorkspaceConfigUpdateColumn = typeof CepWorkspaceConfigUpdateColumn[keyof typeof CepWorkspaceConfigUpdateColumn];
export type CepWorkspaceConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CepWorkspaceConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CepWorkspaceConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CepWorkspaceConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CepWorkspaceConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CepWorkspaceConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CepWorkspaceConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CepWorkspaceConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CepWorkspaceConfigBoolExp;
};

/** aggregate var_pop on columns */
export type CepWorkspaceConfigVarPopFields = {
  __typename?: 'cep_workspace_config_var_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CepWorkspaceConfigVarSampFields = {
  __typename?: 'cep_workspace_config_var_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CepWorkspaceConfigVarianceFields = {
  __typename?: 'cep_workspace_config_variance_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Native Delivery settings for each parent model of a workspace. While cepMultiParentModel is off, the settings are written to cep_workspace_config and the trigger mirror_cep_workspace_config_parent_model copies them here. */
export type CepWorkspaceParentModels = {
  __typename?: 'cep_workspace_parent_models';
  column_mappings?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  warehouse_attribute_cache_sync?: Maybe<DestinationInstances>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id: Scalars['bigint'];
};


/** Native Delivery settings for each parent model of a workspace. While cepMultiParentModel is off, the settings are written to cep_workspace_config and the trigger mirror_cep_workspace_config_parent_model copies them here. */
export type CepWorkspaceParentModelsColumnMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsAggregate = {
  __typename?: 'cep_workspace_parent_models_aggregate';
  aggregate?: Maybe<CepWorkspaceParentModelsAggregateFields>;
  nodes: Array<CepWorkspaceParentModels>;
};

export type CepWorkspaceParentModelsAggregateBoolExp = {
  count?: InputMaybe<CepWorkspaceParentModelsAggregateBoolExpCount>;
};

export type CepWorkspaceParentModelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsAggregateFields = {
  __typename?: 'cep_workspace_parent_models_aggregate_fields';
  avg?: Maybe<CepWorkspaceParentModelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CepWorkspaceParentModelsMaxFields>;
  min?: Maybe<CepWorkspaceParentModelsMinFields>;
  stddev?: Maybe<CepWorkspaceParentModelsStddevFields>;
  stddev_pop?: Maybe<CepWorkspaceParentModelsStddevPopFields>;
  stddev_samp?: Maybe<CepWorkspaceParentModelsStddevSampFields>;
  sum?: Maybe<CepWorkspaceParentModelsSumFields>;
  var_pop?: Maybe<CepWorkspaceParentModelsVarPopFields>;
  var_samp?: Maybe<CepWorkspaceParentModelsVarSampFields>;
  variance?: Maybe<CepWorkspaceParentModelsVarianceFields>;
};


/** aggregate fields of "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsAggregateOrderBy = {
  avg?: InputMaybe<CepWorkspaceParentModelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CepWorkspaceParentModelsMaxOrderBy>;
  min?: InputMaybe<CepWorkspaceParentModelsMinOrderBy>;
  stddev?: InputMaybe<CepWorkspaceParentModelsStddevOrderBy>;
  stddev_pop?: InputMaybe<CepWorkspaceParentModelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CepWorkspaceParentModelsStddevSampOrderBy>;
  sum?: InputMaybe<CepWorkspaceParentModelsSumOrderBy>;
  var_pop?: InputMaybe<CepWorkspaceParentModelsVarPopOrderBy>;
  var_samp?: InputMaybe<CepWorkspaceParentModelsVarSampOrderBy>;
  variance?: InputMaybe<CepWorkspaceParentModelsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CepWorkspaceParentModelsAvgFields = {
  __typename?: 'cep_workspace_parent_models_avg_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsAvgOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "cep_workspace_parent_models". All fields are combined with a logical 'AND'. */
export type CepWorkspaceParentModelsBoolExp = {
  _and?: InputMaybe<Array<CepWorkspaceParentModelsBoolExp>>;
  _not?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
  _or?: InputMaybe<Array<CepWorkspaceParentModelsBoolExp>>;
  column_mappings?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  profile_cache_refreshed_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  warehouse_attribute_cache_sync?: InputMaybe<DestinationInstancesBoolExp>;
  warehouse_attribute_cache_sync_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CepWorkspaceParentModelsMaxFields = {
  __typename?: 'cep_workspace_parent_models_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  profile_cache_refreshed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CepWorkspaceParentModelsMinFields = {
  __typename?: 'cep_workspace_parent_models_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  profile_cache_refreshed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "cep_workspace_parent_models". */
export type CepWorkspaceParentModelsOrderBy = {
  column_mappings?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  profile_cache_refreshed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync?: InputMaybe<DestinationInstancesOrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "cep_workspace_parent_models" */
export const CepWorkspaceParentModelsSelectColumn = {
  /** column name */
  ColumnMappings: 'column_mappings',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  ProfileCacheRefreshedAt: 'profile_cache_refreshed_at',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WarehouseAttributeCacheSyncId: 'warehouse_attribute_cache_sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CepWorkspaceParentModelsSelectColumn = typeof CepWorkspaceParentModelsSelectColumn[keyof typeof CepWorkspaceParentModelsSelectColumn];
/** aggregate stddev on columns */
export type CepWorkspaceParentModelsStddevFields = {
  __typename?: 'cep_workspace_parent_models_stddev_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsStddevOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CepWorkspaceParentModelsStddevPopFields = {
  __typename?: 'cep_workspace_parent_models_stddev_pop_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsStddevPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CepWorkspaceParentModelsStddevSampFields = {
  __typename?: 'cep_workspace_parent_models_stddev_samp_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsStddevSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CepWorkspaceParentModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CepWorkspaceParentModelsStreamCursorValueInput = {
  column_mappings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  profile_cache_refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  warehouse_attribute_cache_sync_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CepWorkspaceParentModelsSumFields = {
  __typename?: 'cep_workspace_parent_models_sum_fields';
  parent_model_id?: Maybe<Scalars['bigint']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsSumOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CepWorkspaceParentModelsVarPopFields = {
  __typename?: 'cep_workspace_parent_models_var_pop_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsVarPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CepWorkspaceParentModelsVarSampFields = {
  __typename?: 'cep_workspace_parent_models_var_samp_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsVarSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CepWorkspaceParentModelsVarianceFields = {
  __typename?: 'cep_workspace_parent_models_variance_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  warehouse_attribute_cache_sync_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "cep_workspace_parent_models" */
export type CepWorkspaceParentModelsVarianceOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  warehouse_attribute_cache_sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "chart_cards" */
export type ChartCards = {
  __typename?: 'chart_cards';
  /** An object relationship */
  chart?: Maybe<SavedAnalyticsCharts>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  dashboard: Dashboards;
  dashboard_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** This is nullable so we can set this to null when the FK gets deleted. We may want to keep this record around for UI reasons. */
  saved_analytics_chart_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};

/** order by aggregate values of table "chart_cards" */
export type ChartCardsAggregateOrderBy = {
  avg?: InputMaybe<ChartCardsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChartCardsMaxOrderBy>;
  min?: InputMaybe<ChartCardsMinOrderBy>;
  stddev?: InputMaybe<ChartCardsStddevOrderBy>;
  stddev_pop?: InputMaybe<ChartCardsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ChartCardsStddevSampOrderBy>;
  sum?: InputMaybe<ChartCardsSumOrderBy>;
  var_pop?: InputMaybe<ChartCardsVarPopOrderBy>;
  var_samp?: InputMaybe<ChartCardsVarSampOrderBy>;
  variance?: InputMaybe<ChartCardsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "chart_cards" */
export type ChartCardsArrRelInsertInput = {
  data: Array<ChartCardsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ChartCardsOnConflict>;
};

/** order by avg() on columns of table "chart_cards" */
export type ChartCardsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "chart_cards". All fields are combined with a logical 'AND'. */
export type ChartCardsBoolExp = {
  _and?: InputMaybe<Array<ChartCardsBoolExp>>;
  _not?: InputMaybe<ChartCardsBoolExp>;
  _or?: InputMaybe<Array<ChartCardsBoolExp>>;
  chart?: InputMaybe<SavedAnalyticsChartsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  dashboard?: InputMaybe<DashboardsBoolExp>;
  dashboard_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  saved_analytics_chart_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "chart_cards" */
export const ChartCardsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ChartCardsIdWorkspaceIdKey: 'chart_cards_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ChartCardsPkey: 'chart_cards_pkey'
} as const;

export type ChartCardsConstraint = typeof ChartCardsConstraint[keyof typeof ChartCardsConstraint];
/** input type for inserting data into table "chart_cards" */
export type ChartCardsInsertInput = {
  chart?: InputMaybe<SavedAnalyticsChartsObjRelInsertInput>;
  dashboard?: InputMaybe<DashboardsObjRelInsertInput>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
  /** This is nullable so we can set this to null when the FK gets deleted. We may want to keep this record around for UI reasons. */
  saved_analytics_chart_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "chart_cards" */
export type ChartCardsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** This is nullable so we can set this to null when the FK gets deleted. We may want to keep this record around for UI reasons. */
  saved_analytics_chart_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "chart_cards" */
export type ChartCardsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** This is nullable so we can set this to null when the FK gets deleted. We may want to keep this record around for UI reasons. */
  saved_analytics_chart_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "chart_cards" */
export type ChartCardsMutationResponse = {
  __typename?: 'chart_cards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ChartCards>;
};

/** on_conflict condition type for table "chart_cards" */
export type ChartCardsOnConflict = {
  constraint: ChartCardsConstraint;
  update_columns?: Array<ChartCardsUpdateColumn>;
  where?: InputMaybe<ChartCardsBoolExp>;
};

/** Ordering options when selecting data from "chart_cards". */
export type ChartCardsOrderBy = {
  chart?: InputMaybe<SavedAnalyticsChartsOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  dashboard?: InputMaybe<DashboardsOrderBy>;
  dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_analytics_chart_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "chart_cards" */
export const ChartCardsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DashboardId: 'dashboard_id',
  /** column name */
  Id: 'id',
  /** column name */
  SavedAnalyticsChartId: 'saved_analytics_chart_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type ChartCardsSelectColumn = typeof ChartCardsSelectColumn[keyof typeof ChartCardsSelectColumn];
/** order by stddev() on columns of table "chart_cards" */
export type ChartCardsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "chart_cards" */
export type ChartCardsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "chart_cards" */
export type ChartCardsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "chart_cards" */
export type ChartCardsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ChartCardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChartCardsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  dashboard_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** This is nullable so we can set this to null when the FK gets deleted. We may want to keep this record around for UI reasons. */
  saved_analytics_chart_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "chart_cards" */
export type ChartCardsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "chart_cards" (current role has no relevant permissions) */
export const ChartCardsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ChartCardsUpdateColumn = typeof ChartCardsUpdateColumn[keyof typeof ChartCardsUpdateColumn];
/** order by var_pop() on columns of table "chart_cards" */
export type ChartCardsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "chart_cards" */
export type ChartCardsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "chart_cards" */
export type ChartCardsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** columns and relationships of "cloud_credentials" */
export type CloudCredentials = {
  __typename?: 'cloud_credentials';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  provider: Scalars['String'];
  /** A computed field, executes function "cloud_credential_stripped_config" */
  stripped_config?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
};


/** columns and relationships of "cloud_credentials" */
export type CloudCredentialsStrippedConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "cloud_credentials". All fields are combined with a logical 'AND'. */
export type CloudCredentialsBoolExp = {
  _and?: InputMaybe<Array<CloudCredentialsBoolExp>>;
  _not?: InputMaybe<CloudCredentialsBoolExp>;
  _or?: InputMaybe<Array<CloudCredentialsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  stripped_config?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
};

/** response of any mutation on the table "cloud_credentials" */
export type CloudCredentialsMutationResponse = {
  __typename?: 'cloud_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CloudCredentials>;
};

/** Ordering options when selecting data from "cloud_credentials". */
export type CloudCredentialsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  stripped_config?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
};

/** select columns of table "cloud_credentials" */
export const CloudCredentialsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Provider: 'provider',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type CloudCredentialsSelectColumn = typeof CloudCredentialsSelectColumn[keyof typeof CloudCredentialsSelectColumn];
/** Streaming cursor of the table "cloud_credentials" */
export type CloudCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CloudCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CloudCredentialsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "competitor_accounts" */
export type CompetitorAccounts = {
  __typename?: 'competitor_accounts';
  /** An object relationship */
  competitor: Competitors;
  /** An object relationship */
  competitor_ad_scrape: CompetitorAdScrapes;
  competitor_ad_scrape_id: Scalars['uuid'];
  competitor_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "competitor_accounts" */
export type CompetitorAccountsAggregate = {
  __typename?: 'competitor_accounts_aggregate';
  aggregate?: Maybe<CompetitorAccountsAggregateFields>;
  nodes: Array<CompetitorAccounts>;
};

export type CompetitorAccountsAggregateBoolExp = {
  count?: InputMaybe<CompetitorAccountsAggregateBoolExpCount>;
};

export type CompetitorAccountsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompetitorAccountsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "competitor_accounts" */
export type CompetitorAccountsAggregateFields = {
  __typename?: 'competitor_accounts_aggregate_fields';
  avg?: Maybe<CompetitorAccountsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompetitorAccountsMaxFields>;
  min?: Maybe<CompetitorAccountsMinFields>;
  stddev?: Maybe<CompetitorAccountsStddevFields>;
  stddev_pop?: Maybe<CompetitorAccountsStddevPopFields>;
  stddev_samp?: Maybe<CompetitorAccountsStddevSampFields>;
  sum?: Maybe<CompetitorAccountsSumFields>;
  var_pop?: Maybe<CompetitorAccountsVarPopFields>;
  var_samp?: Maybe<CompetitorAccountsVarSampFields>;
  variance?: Maybe<CompetitorAccountsVarianceFields>;
};


/** aggregate fields of "competitor_accounts" */
export type CompetitorAccountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "competitor_accounts" */
export type CompetitorAccountsAggregateOrderBy = {
  avg?: InputMaybe<CompetitorAccountsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompetitorAccountsMaxOrderBy>;
  min?: InputMaybe<CompetitorAccountsMinOrderBy>;
  stddev?: InputMaybe<CompetitorAccountsStddevOrderBy>;
  stddev_pop?: InputMaybe<CompetitorAccountsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CompetitorAccountsStddevSampOrderBy>;
  sum?: InputMaybe<CompetitorAccountsSumOrderBy>;
  var_pop?: InputMaybe<CompetitorAccountsVarPopOrderBy>;
  var_samp?: InputMaybe<CompetitorAccountsVarSampOrderBy>;
  variance?: InputMaybe<CompetitorAccountsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CompetitorAccountsAvgFields = {
  __typename?: 'competitor_accounts_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "competitor_accounts" */
export type CompetitorAccountsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "competitor_accounts". All fields are combined with a logical 'AND'. */
export type CompetitorAccountsBoolExp = {
  _and?: InputMaybe<Array<CompetitorAccountsBoolExp>>;
  _not?: InputMaybe<CompetitorAccountsBoolExp>;
  _or?: InputMaybe<Array<CompetitorAccountsBoolExp>>;
  competitor?: InputMaybe<CompetitorsBoolExp>;
  competitor_ad_scrape?: InputMaybe<CompetitorAdScrapesBoolExp>;
  competitor_ad_scrape_id?: InputMaybe<UuidComparisonExp>;
  competitor_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CompetitorAccountsMaxFields = {
  __typename?: 'competitor_accounts_max_fields';
  competitor_ad_scrape_id?: Maybe<Scalars['uuid']>;
  competitor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "competitor_accounts" */
export type CompetitorAccountsMaxOrderBy = {
  competitor_ad_scrape_id?: InputMaybe<OrderBy>;
  competitor_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompetitorAccountsMinFields = {
  __typename?: 'competitor_accounts_min_fields';
  competitor_ad_scrape_id?: Maybe<Scalars['uuid']>;
  competitor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "competitor_accounts" */
export type CompetitorAccountsMinOrderBy = {
  competitor_ad_scrape_id?: InputMaybe<OrderBy>;
  competitor_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "competitor_accounts". */
export type CompetitorAccountsOrderBy = {
  competitor?: InputMaybe<CompetitorsOrderBy>;
  competitor_ad_scrape?: InputMaybe<CompetitorAdScrapesOrderBy>;
  competitor_ad_scrape_id?: InputMaybe<OrderBy>;
  competitor_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "competitor_accounts" */
export const CompetitorAccountsSelectColumn = {
  /** column name */
  CompetitorAdScrapeId: 'competitor_ad_scrape_id',
  /** column name */
  CompetitorId: 'competitor_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CompetitorAccountsSelectColumn = typeof CompetitorAccountsSelectColumn[keyof typeof CompetitorAccountsSelectColumn];
/** aggregate stddev on columns */
export type CompetitorAccountsStddevFields = {
  __typename?: 'competitor_accounts_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "competitor_accounts" */
export type CompetitorAccountsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CompetitorAccountsStddevPopFields = {
  __typename?: 'competitor_accounts_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "competitor_accounts" */
export type CompetitorAccountsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CompetitorAccountsStddevSampFields = {
  __typename?: 'competitor_accounts_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "competitor_accounts" */
export type CompetitorAccountsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "competitor_accounts" */
export type CompetitorAccountsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompetitorAccountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitorAccountsStreamCursorValueInput = {
  competitor_ad_scrape_id?: InputMaybe<Scalars['uuid']>;
  competitor_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CompetitorAccountsSumFields = {
  __typename?: 'competitor_accounts_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "competitor_accounts" */
export type CompetitorAccountsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type CompetitorAccountsVarPopFields = {
  __typename?: 'competitor_accounts_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "competitor_accounts" */
export type CompetitorAccountsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CompetitorAccountsVarSampFields = {
  __typename?: 'competitor_accounts_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "competitor_accounts" */
export type CompetitorAccountsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompetitorAccountsVarianceFields = {
  __typename?: 'competitor_accounts_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "competitor_accounts" */
export type CompetitorAccountsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "competitor_ad_scrapes" */
export type CompetitorAdScrapes = {
  __typename?: 'competitor_ad_scrapes';
  ads_count?: Maybe<Scalars['Int']>;
  avatar_url?: Maybe<Scalars['String']>;
  channel: Scalars['String'];
  /** An array relationship */
  competitor_accounts: Array<CompetitorAccounts>;
  /** An aggregate relationship */
  competitor_accounts_aggregate: CompetitorAccountsAggregate;
  competitor_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  external_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_scraped_at?: Maybe<Scalars['timestamptz']>;
  metadata?: Maybe<Scalars['jsonb']>;
  page_id: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "competitor_ad_scrapes" */
export type CompetitorAdScrapesCompetitorAccountsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


/** columns and relationships of "competitor_ad_scrapes" */
export type CompetitorAdScrapesCompetitorAccountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


/** columns and relationships of "competitor_ad_scrapes" */
export type CompetitorAdScrapesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "competitor_ad_scrapes". All fields are combined with a logical 'AND'. */
export type CompetitorAdScrapesBoolExp = {
  _and?: InputMaybe<Array<CompetitorAdScrapesBoolExp>>;
  _not?: InputMaybe<CompetitorAdScrapesBoolExp>;
  _or?: InputMaybe<Array<CompetitorAdScrapesBoolExp>>;
  ads_count?: InputMaybe<IntComparisonExp>;
  avatar_url?: InputMaybe<StringComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  competitor_accounts?: InputMaybe<CompetitorAccountsBoolExp>;
  competitor_accounts_aggregate?: InputMaybe<CompetitorAccountsAggregateBoolExp>;
  competitor_name?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  external_url?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_scraped_at?: InputMaybe<TimestamptzComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  page_id?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "competitor_ad_scrapes". */
export type CompetitorAdScrapesOrderBy = {
  ads_count?: InputMaybe<OrderBy>;
  avatar_url?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  competitor_accounts_aggregate?: InputMaybe<CompetitorAccountsAggregateOrderBy>;
  competitor_name?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  external_url?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_scraped_at?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  page_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "competitor_ad_scrapes" */
export const CompetitorAdScrapesSelectColumn = {
  /** column name */
  AdsCount: 'ads_count',
  /** column name */
  AvatarUrl: 'avatar_url',
  /** column name */
  Channel: 'channel',
  /** column name */
  CompetitorName: 'competitor_name',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  ExternalUrl: 'external_url',
  /** column name */
  Id: 'id',
  /** column name */
  LastScrapedAt: 'last_scraped_at',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  PageId: 'page_id',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type CompetitorAdScrapesSelectColumn = typeof CompetitorAdScrapesSelectColumn[keyof typeof CompetitorAdScrapesSelectColumn];
/** Streaming cursor of the table "competitor_ad_scrapes" */
export type CompetitorAdScrapesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompetitorAdScrapesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitorAdScrapesStreamCursorValueInput = {
  ads_count?: InputMaybe<Scalars['Int']>;
  avatar_url?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  competitor_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  external_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_scraped_at?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  page_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "competitors" */
export type Competitors = {
  __typename?: 'competitors';
  /** An array relationship */
  accounts: Array<CompetitorAccounts>;
  /** An aggregate relationship */
  accounts_aggregate: CompetitorAccountsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  kind: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "competitors" */
export type CompetitorsAccountsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


/** columns and relationships of "competitors" */
export type CompetitorsAccountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};

/** aggregated selection of "competitors" */
export type CompetitorsAggregate = {
  __typename?: 'competitors_aggregate';
  aggregate?: Maybe<CompetitorsAggregateFields>;
  nodes: Array<Competitors>;
};

/** aggregate fields of "competitors" */
export type CompetitorsAggregateFields = {
  __typename?: 'competitors_aggregate_fields';
  avg?: Maybe<CompetitorsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompetitorsMaxFields>;
  min?: Maybe<CompetitorsMinFields>;
  stddev?: Maybe<CompetitorsStddevFields>;
  stddev_pop?: Maybe<CompetitorsStddevPopFields>;
  stddev_samp?: Maybe<CompetitorsStddevSampFields>;
  sum?: Maybe<CompetitorsSumFields>;
  var_pop?: Maybe<CompetitorsVarPopFields>;
  var_samp?: Maybe<CompetitorsVarSampFields>;
  variance?: Maybe<CompetitorsVarianceFields>;
};


/** aggregate fields of "competitors" */
export type CompetitorsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompetitorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompetitorsAvgFields = {
  __typename?: 'competitors_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "competitors". All fields are combined with a logical 'AND'. */
export type CompetitorsBoolExp = {
  _and?: InputMaybe<Array<CompetitorsBoolExp>>;
  _not?: InputMaybe<CompetitorsBoolExp>;
  _or?: InputMaybe<Array<CompetitorsBoolExp>>;
  accounts?: InputMaybe<CompetitorAccountsBoolExp>;
  accounts_aggregate?: InputMaybe<CompetitorAccountsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type CompetitorsMaxFields = {
  __typename?: 'competitors_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CompetitorsMinFields = {
  __typename?: 'competitors_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "competitors". */
export type CompetitorsOrderBy = {
  accounts_aggregate?: InputMaybe<CompetitorAccountsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "competitors" */
export const CompetitorsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CompetitorsSelectColumn = typeof CompetitorsSelectColumn[keyof typeof CompetitorsSelectColumn];
/** aggregate stddev on columns */
export type CompetitorsStddevFields = {
  __typename?: 'competitors_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CompetitorsStddevPopFields = {
  __typename?: 'competitors_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CompetitorsStddevSampFields = {
  __typename?: 'competitors_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "competitors" */
export type CompetitorsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CompetitorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompetitorsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CompetitorsSumFields = {
  __typename?: 'competitors_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type CompetitorsVarPopFields = {
  __typename?: 'competitors_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CompetitorsVarSampFields = {
  __typename?: 'competitors_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompetitorsVarianceFields = {
  __typename?: 'competitors_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "condition_template_labels" */
export type ConditionTemplateLabels = {
  __typename?: 'condition_template_labels';
  /** An object relationship */
  condition_template: ContentDynamicSlotLibraries;
  condition_template_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "condition_template_labels" */
export type ConditionTemplateLabelsAggregate = {
  __typename?: 'condition_template_labels_aggregate';
  aggregate?: Maybe<ConditionTemplateLabelsAggregateFields>;
  nodes: Array<ConditionTemplateLabels>;
};

export type ConditionTemplateLabelsAggregateBoolExp = {
  count?: InputMaybe<ConditionTemplateLabelsAggregateBoolExpCount>;
};

export type ConditionTemplateLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConditionTemplateLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "condition_template_labels" */
export type ConditionTemplateLabelsAggregateFields = {
  __typename?: 'condition_template_labels_aggregate_fields';
  avg?: Maybe<ConditionTemplateLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ConditionTemplateLabelsMaxFields>;
  min?: Maybe<ConditionTemplateLabelsMinFields>;
  stddev?: Maybe<ConditionTemplateLabelsStddevFields>;
  stddev_pop?: Maybe<ConditionTemplateLabelsStddevPopFields>;
  stddev_samp?: Maybe<ConditionTemplateLabelsStddevSampFields>;
  sum?: Maybe<ConditionTemplateLabelsSumFields>;
  var_pop?: Maybe<ConditionTemplateLabelsVarPopFields>;
  var_samp?: Maybe<ConditionTemplateLabelsVarSampFields>;
  variance?: Maybe<ConditionTemplateLabelsVarianceFields>;
};


/** aggregate fields of "condition_template_labels" */
export type ConditionTemplateLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "condition_template_labels" */
export type ConditionTemplateLabelsAggregateOrderBy = {
  avg?: InputMaybe<ConditionTemplateLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConditionTemplateLabelsMaxOrderBy>;
  min?: InputMaybe<ConditionTemplateLabelsMinOrderBy>;
  stddev?: InputMaybe<ConditionTemplateLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<ConditionTemplateLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ConditionTemplateLabelsStddevSampOrderBy>;
  sum?: InputMaybe<ConditionTemplateLabelsSumOrderBy>;
  var_pop?: InputMaybe<ConditionTemplateLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<ConditionTemplateLabelsVarSampOrderBy>;
  variance?: InputMaybe<ConditionTemplateLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "condition_template_labels" */
export type ConditionTemplateLabelsArrRelInsertInput = {
  data: Array<ConditionTemplateLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConditionTemplateLabelsOnConflict>;
};

/** aggregate avg on columns */
export type ConditionTemplateLabelsAvgFields = {
  __typename?: 'condition_template_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "condition_template_labels". All fields are combined with a logical 'AND'. */
export type ConditionTemplateLabelsBoolExp = {
  _and?: InputMaybe<Array<ConditionTemplateLabelsBoolExp>>;
  _not?: InputMaybe<ConditionTemplateLabelsBoolExp>;
  _or?: InputMaybe<Array<ConditionTemplateLabelsBoolExp>>;
  condition_template?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
  condition_template_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "condition_template_labels" */
export const ConditionTemplateLabelsConstraint = {
  /** unique or primary key constraint on columns "condition_template_id", "label_id" */
  ConditionTemplateLabelsPkey: 'condition_template_labels_pkey'
} as const;

export type ConditionTemplateLabelsConstraint = typeof ConditionTemplateLabelsConstraint[keyof typeof ConditionTemplateLabelsConstraint];
/** input type for inserting data into table "condition_template_labels" */
export type ConditionTemplateLabelsInsertInput = {
  condition_template?: InputMaybe<ContentDynamicSlotLibrariesObjRelInsertInput>;
  condition_template_id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ConditionTemplateLabelsMaxFields = {
  __typename?: 'condition_template_labels_max_fields';
  condition_template_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsMaxOrderBy = {
  condition_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ConditionTemplateLabelsMinFields = {
  __typename?: 'condition_template_labels_min_fields';
  condition_template_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsMinOrderBy = {
  condition_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "condition_template_labels" */
export type ConditionTemplateLabelsMutationResponse = {
  __typename?: 'condition_template_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConditionTemplateLabels>;
};

/** on_conflict condition type for table "condition_template_labels" */
export type ConditionTemplateLabelsOnConflict = {
  constraint: ConditionTemplateLabelsConstraint;
  update_columns?: Array<ConditionTemplateLabelsUpdateColumn>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};

/** Ordering options when selecting data from "condition_template_labels". */
export type ConditionTemplateLabelsOrderBy = {
  condition_template?: InputMaybe<ContentDynamicSlotLibrariesOrderBy>;
  condition_template_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "condition_template_labels" */
export const ConditionTemplateLabelsSelectColumn = {
  /** column name */
  ConditionTemplateId: 'condition_template_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ConditionTemplateLabelsSelectColumn = typeof ConditionTemplateLabelsSelectColumn[keyof typeof ConditionTemplateLabelsSelectColumn];
/** aggregate stddev on columns */
export type ConditionTemplateLabelsStddevFields = {
  __typename?: 'condition_template_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ConditionTemplateLabelsStddevPopFields = {
  __typename?: 'condition_template_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ConditionTemplateLabelsStddevSampFields = {
  __typename?: 'condition_template_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "condition_template_labels" */
export type ConditionTemplateLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ConditionTemplateLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConditionTemplateLabelsStreamCursorValueInput = {
  condition_template_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ConditionTemplateLabelsSumFields = {
  __typename?: 'condition_template_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "condition_template_labels" (current role has no relevant permissions) */
export const ConditionTemplateLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ConditionTemplateLabelsUpdateColumn = typeof ConditionTemplateLabelsUpdateColumn[keyof typeof ConditionTemplateLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type ConditionTemplateLabelsVarPopFields = {
  __typename?: 'condition_template_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ConditionTemplateLabelsVarSampFields = {
  __typename?: 'condition_template_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ConditionTemplateLabelsVarianceFields = {
  __typename?: 'condition_template_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "condition_template_labels" */
export type ConditionTemplateLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "connections" */
export type Connections = {
  __typename?: 'connections';
  audience_holdout_enabled: Scalars['Boolean'];
  audience_snapshotting_enabled: Scalars['Boolean'];
  autorun?: Maybe<Scalars['Boolean']>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  credential_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  default_workspaces: Array<Workspaces>;
  definition: SourceDefinition;
  definitionV2: SourceDefinition;
  id: Scalars['bigint'];
  is_demo?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  plan_in_warehouse: Scalars['Boolean'];
  plan_in_warehouse_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sample_data_source?: Maybe<SampleDataSources>;
  sample_data_source_id?: Maybe<Scalars['uuid']>;
  setup_complete: Scalars['Boolean'];
  /** An object relationship */
  share_mirror?: Maybe<SourceShareMirrors>;
  slug?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['jsonb']>;
  stripped_config: Scalars['JSONObject'];
  tags: Scalars['jsonb'];
  /** An object relationship */
  tunnel?: Maybe<Tunnels>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An array relationship */
  user_group_source_grants: Array<UserGroupSourceGrants>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "connections" */
export type ConnectionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsDefaultWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<WorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspacesOrderBy>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};


/** columns and relationships of "connections" */
export type ConnectionsPlanInWarehouseConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "connections" */
export type ConnectionsUserGroupSourceGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSourceGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSourceGrantsBoolExp>;
};


/** columns and relationships of "connections" */
export type ConnectionsWarehouseHistoryConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "connections" */
export type ConnectionsAggregate = {
  __typename?: 'connections_aggregate';
  aggregate?: Maybe<ConnectionsAggregateFields>;
  nodes: Array<Connections>;
};

export type ConnectionsAggregateBoolExp = {
  bool_and?: InputMaybe<ConnectionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ConnectionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<ConnectionsAggregateBoolExpCount>;
};

export type ConnectionsAggregateBoolExpBoolAnd = {
  arguments: ConnectionsSelectColumnConnectionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConnectionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ConnectionsAggregateBoolExpBoolOr = {
  arguments: ConnectionsSelectColumnConnectionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConnectionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ConnectionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ConnectionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "connections" */
export type ConnectionsAggregateFields = {
  __typename?: 'connections_aggregate_fields';
  avg?: Maybe<ConnectionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ConnectionsMaxFields>;
  min?: Maybe<ConnectionsMinFields>;
  stddev?: Maybe<ConnectionsStddevFields>;
  stddev_pop?: Maybe<ConnectionsStddevPopFields>;
  stddev_samp?: Maybe<ConnectionsStddevSampFields>;
  sum?: Maybe<ConnectionsSumFields>;
  var_pop?: Maybe<ConnectionsVarPopFields>;
  var_samp?: Maybe<ConnectionsVarSampFields>;
  variance?: Maybe<ConnectionsVarianceFields>;
};


/** aggregate fields of "connections" */
export type ConnectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "connections" */
export type ConnectionsAggregateOrderBy = {
  avg?: InputMaybe<ConnectionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ConnectionsMaxOrderBy>;
  min?: InputMaybe<ConnectionsMinOrderBy>;
  stddev?: InputMaybe<ConnectionsStddevOrderBy>;
  stddev_pop?: InputMaybe<ConnectionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ConnectionsStddevSampOrderBy>;
  sum?: InputMaybe<ConnectionsSumOrderBy>;
  var_pop?: InputMaybe<ConnectionsVarPopOrderBy>;
  var_samp?: InputMaybe<ConnectionsVarSampOrderBy>;
  variance?: InputMaybe<ConnectionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ConnectionsAvgFields = {
  __typename?: 'connections_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "connections" */
export type ConnectionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "connections". All fields are combined with a logical 'AND'. */
export type ConnectionsBoolExp = {
  _and?: InputMaybe<Array<ConnectionsBoolExp>>;
  _not?: InputMaybe<ConnectionsBoolExp>;
  _or?: InputMaybe<Array<ConnectionsBoolExp>>;
  audience_holdout_enabled?: InputMaybe<BooleanComparisonExp>;
  audience_snapshotting_enabled?: InputMaybe<BooleanComparisonExp>;
  autorun?: InputMaybe<BooleanComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  credential_id?: InputMaybe<BigintComparisonExp>;
  default_workspaces?: InputMaybe<WorkspacesBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_demo?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  plan_in_warehouse?: InputMaybe<BooleanComparisonExp>;
  plan_in_warehouse_config?: InputMaybe<JsonbComparisonExp>;
  sample_data_source?: InputMaybe<SampleDataSourcesBoolExp>;
  sample_data_source_id?: InputMaybe<UuidComparisonExp>;
  setup_complete?: InputMaybe<BooleanComparisonExp>;
  share_mirror?: InputMaybe<SourceShareMirrorsBoolExp>;
  slug?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  tunnel?: InputMaybe<TunnelsBoolExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user_group_source_grants?: InputMaybe<UserGroupSourceGrantsBoolExp>;
  warehouse_history_config?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ConnectionsMaxFields = {
  __typename?: 'connections_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sample_data_source_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "connections" */
export type ConnectionsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sample_data_source_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ConnectionsMinFields = {
  __typename?: 'connections_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sample_data_source_id?: Maybe<Scalars['uuid']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "connections" */
export type ConnectionsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sample_data_source_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "connections" */
export type ConnectionsMutationResponse = {
  __typename?: 'connections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Connections>;
};

/** Ordering options when selecting data from "connections". */
export type ConnectionsOrderBy = {
  audience_holdout_enabled?: InputMaybe<OrderBy>;
  audience_snapshotting_enabled?: InputMaybe<OrderBy>;
  autorun?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  default_workspaces_aggregate?: InputMaybe<WorkspacesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  is_demo?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plan_in_warehouse?: InputMaybe<OrderBy>;
  plan_in_warehouse_config?: InputMaybe<OrderBy>;
  sample_data_source?: InputMaybe<SampleDataSourcesOrderBy>;
  sample_data_source_id?: InputMaybe<OrderBy>;
  setup_complete?: InputMaybe<OrderBy>;
  share_mirror?: InputMaybe<SourceShareMirrorsOrderBy>;
  slug?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  tunnel?: InputMaybe<TunnelsOrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  user_group_source_grants_aggregate?: InputMaybe<UserGroupSourceGrantsAggregateOrderBy>;
  warehouse_history_config?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "connections" */
export const ConnectionsSelectColumn = {
  /** column name */
  AudienceHoldoutEnabled: 'audience_holdout_enabled',
  /** column name */
  AudienceSnapshottingEnabled: 'audience_snapshotting_enabled',
  /** column name */
  Autorun: 'autorun',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  IsDemo: 'is_demo',
  /** column name */
  Name: 'name',
  /** column name */
  PlanInWarehouse: 'plan_in_warehouse',
  /** column name */
  PlanInWarehouseConfig: 'plan_in_warehouse_config',
  /** column name */
  SampleDataSourceId: 'sample_data_source_id',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  State: 'state',
  /** column name */
  Tags: 'tags',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ConnectionsSelectColumn = typeof ConnectionsSelectColumn[keyof typeof ConnectionsSelectColumn];
/** select "connections_aggregate_bool_exp_bool_and_arguments_columns" columns of table "connections" */
export const ConnectionsSelectColumnConnectionsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  AudienceHoldoutEnabled: 'audience_holdout_enabled',
  /** column name */
  AudienceSnapshottingEnabled: 'audience_snapshotting_enabled',
  /** column name */
  Autorun: 'autorun',
  /** column name */
  IsDemo: 'is_demo',
  /** column name */
  PlanInWarehouse: 'plan_in_warehouse',
  /** column name */
  SetupComplete: 'setup_complete'
} as const;

export type ConnectionsSelectColumnConnectionsAggregateBoolExpBoolAndArgumentsColumns = typeof ConnectionsSelectColumnConnectionsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof ConnectionsSelectColumnConnectionsAggregateBoolExpBoolAndArgumentsColumns];
/** select "connections_aggregate_bool_exp_bool_or_arguments_columns" columns of table "connections" */
export const ConnectionsSelectColumnConnectionsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  AudienceHoldoutEnabled: 'audience_holdout_enabled',
  /** column name */
  AudienceSnapshottingEnabled: 'audience_snapshotting_enabled',
  /** column name */
  Autorun: 'autorun',
  /** column name */
  IsDemo: 'is_demo',
  /** column name */
  PlanInWarehouse: 'plan_in_warehouse',
  /** column name */
  SetupComplete: 'setup_complete'
} as const;

export type ConnectionsSelectColumnConnectionsAggregateBoolExpBoolOrArgumentsColumns = typeof ConnectionsSelectColumnConnectionsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof ConnectionsSelectColumnConnectionsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type ConnectionsStddevFields = {
  __typename?: 'connections_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "connections" */
export type ConnectionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ConnectionsStddevPopFields = {
  __typename?: 'connections_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "connections" */
export type ConnectionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ConnectionsStddevSampFields = {
  __typename?: 'connections_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "connections" */
export type ConnectionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "connections" */
export type ConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConnectionsStreamCursorValueInput = {
  audience_holdout_enabled?: InputMaybe<Scalars['Boolean']>;
  audience_snapshotting_enabled?: InputMaybe<Scalars['Boolean']>;
  autorun?: InputMaybe<Scalars['Boolean']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_demo?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  plan_in_warehouse?: InputMaybe<Scalars['Boolean']>;
  plan_in_warehouse_config?: InputMaybe<Scalars['jsonb']>;
  sample_data_source_id?: InputMaybe<Scalars['uuid']>;
  setup_complete?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ConnectionsSumFields = {
  __typename?: 'connections_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "connections" */
export type ConnectionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ConnectionsVarPopFields = {
  __typename?: 'connections_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "connections" */
export type ConnectionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ConnectionsVarSampFields = {
  __typename?: 'connections_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "connections" */
export type ConnectionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ConnectionsVarianceFields = {
  __typename?: 'connections_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "connections" */
export type ConnectionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_block_labels" */
export type ContentBlockLabels = {
  __typename?: 'content_block_labels';
  /** An object relationship */
  content_block: CepContentBlocks;
  content_block_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_block_labels" */
export type ContentBlockLabelsAggregate = {
  __typename?: 'content_block_labels_aggregate';
  aggregate?: Maybe<ContentBlockLabelsAggregateFields>;
  nodes: Array<ContentBlockLabels>;
};

export type ContentBlockLabelsAggregateBoolExp = {
  count?: InputMaybe<ContentBlockLabelsAggregateBoolExpCount>;
};

export type ContentBlockLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentBlockLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_block_labels" */
export type ContentBlockLabelsAggregateFields = {
  __typename?: 'content_block_labels_aggregate_fields';
  avg?: Maybe<ContentBlockLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentBlockLabelsMaxFields>;
  min?: Maybe<ContentBlockLabelsMinFields>;
  stddev?: Maybe<ContentBlockLabelsStddevFields>;
  stddev_pop?: Maybe<ContentBlockLabelsStddevPopFields>;
  stddev_samp?: Maybe<ContentBlockLabelsStddevSampFields>;
  sum?: Maybe<ContentBlockLabelsSumFields>;
  var_pop?: Maybe<ContentBlockLabelsVarPopFields>;
  var_samp?: Maybe<ContentBlockLabelsVarSampFields>;
  variance?: Maybe<ContentBlockLabelsVarianceFields>;
};


/** aggregate fields of "content_block_labels" */
export type ContentBlockLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_block_labels" */
export type ContentBlockLabelsAggregateOrderBy = {
  avg?: InputMaybe<ContentBlockLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentBlockLabelsMaxOrderBy>;
  min?: InputMaybe<ContentBlockLabelsMinOrderBy>;
  stddev?: InputMaybe<ContentBlockLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentBlockLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentBlockLabelsStddevSampOrderBy>;
  sum?: InputMaybe<ContentBlockLabelsSumOrderBy>;
  var_pop?: InputMaybe<ContentBlockLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentBlockLabelsVarSampOrderBy>;
  variance?: InputMaybe<ContentBlockLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "content_block_labels" */
export type ContentBlockLabelsArrRelInsertInput = {
  data: Array<ContentBlockLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentBlockLabelsOnConflict>;
};

/** aggregate avg on columns */
export type ContentBlockLabelsAvgFields = {
  __typename?: 'content_block_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_block_labels" */
export type ContentBlockLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_block_labels". All fields are combined with a logical 'AND'. */
export type ContentBlockLabelsBoolExp = {
  _and?: InputMaybe<Array<ContentBlockLabelsBoolExp>>;
  _not?: InputMaybe<ContentBlockLabelsBoolExp>;
  _or?: InputMaybe<Array<ContentBlockLabelsBoolExp>>;
  content_block?: InputMaybe<CepContentBlocksBoolExp>;
  content_block_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_block_labels" */
export const ContentBlockLabelsConstraint = {
  /** unique or primary key constraint on columns "label_id", "content_block_id" */
  ContentBlockLabelsPkey: 'content_block_labels_pkey'
} as const;

export type ContentBlockLabelsConstraint = typeof ContentBlockLabelsConstraint[keyof typeof ContentBlockLabelsConstraint];
/** input type for inserting data into table "content_block_labels" */
export type ContentBlockLabelsInsertInput = {
  content_block?: InputMaybe<CepContentBlocksObjRelInsertInput>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ContentBlockLabelsMaxFields = {
  __typename?: 'content_block_labels_max_fields';
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_block_labels" */
export type ContentBlockLabelsMaxOrderBy = {
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentBlockLabelsMinFields = {
  __typename?: 'content_block_labels_min_fields';
  content_block_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_block_labels" */
export type ContentBlockLabelsMinOrderBy = {
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_block_labels" */
export type ContentBlockLabelsMutationResponse = {
  __typename?: 'content_block_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentBlockLabels>;
};

/** on_conflict condition type for table "content_block_labels" */
export type ContentBlockLabelsOnConflict = {
  constraint: ContentBlockLabelsConstraint;
  update_columns?: Array<ContentBlockLabelsUpdateColumn>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};

/** Ordering options when selecting data from "content_block_labels". */
export type ContentBlockLabelsOrderBy = {
  content_block?: InputMaybe<CepContentBlocksOrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "content_block_labels" */
export const ContentBlockLabelsSelectColumn = {
  /** column name */
  ContentBlockId: 'content_block_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentBlockLabelsSelectColumn = typeof ContentBlockLabelsSelectColumn[keyof typeof ContentBlockLabelsSelectColumn];
/** aggregate stddev on columns */
export type ContentBlockLabelsStddevFields = {
  __typename?: 'content_block_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_block_labels" */
export type ContentBlockLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentBlockLabelsStddevPopFields = {
  __typename?: 'content_block_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_block_labels" */
export type ContentBlockLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentBlockLabelsStddevSampFields = {
  __typename?: 'content_block_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_block_labels" */
export type ContentBlockLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_block_labels" */
export type ContentBlockLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentBlockLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentBlockLabelsStreamCursorValueInput = {
  content_block_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentBlockLabelsSumFields = {
  __typename?: 'content_block_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_block_labels" */
export type ContentBlockLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "content_block_labels" (current role has no relevant permissions) */
export const ContentBlockLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ContentBlockLabelsUpdateColumn = typeof ContentBlockLabelsUpdateColumn[keyof typeof ContentBlockLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type ContentBlockLabelsVarPopFields = {
  __typename?: 'content_block_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_block_labels" */
export type ContentBlockLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentBlockLabelsVarSampFields = {
  __typename?: 'content_block_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_block_labels" */
export type ContentBlockLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentBlockLabelsVarianceFields = {
  __typename?: 'content_block_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_block_labels" */
export type ContentBlockLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_blocks" */
export type ContentBlocks = {
  __typename?: 'content_blocks';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_blocks" */
export type ContentBlocksAggregate = {
  __typename?: 'content_blocks_aggregate';
  aggregate?: Maybe<ContentBlocksAggregateFields>;
  nodes: Array<ContentBlocks>;
};

/** aggregate fields of "content_blocks" */
export type ContentBlocksAggregateFields = {
  __typename?: 'content_blocks_aggregate_fields';
  avg?: Maybe<ContentBlocksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentBlocksMaxFields>;
  min?: Maybe<ContentBlocksMinFields>;
  stddev?: Maybe<ContentBlocksStddevFields>;
  stddev_pop?: Maybe<ContentBlocksStddevPopFields>;
  stddev_samp?: Maybe<ContentBlocksStddevSampFields>;
  sum?: Maybe<ContentBlocksSumFields>;
  var_pop?: Maybe<ContentBlocksVarPopFields>;
  var_samp?: Maybe<ContentBlocksVarSampFields>;
  variance?: Maybe<ContentBlocksVarianceFields>;
};


/** aggregate fields of "content_blocks" */
export type ContentBlocksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentBlocksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContentBlocksAvgFields = {
  __typename?: 'content_blocks_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_blocks". All fields are combined with a logical 'AND'. */
export type ContentBlocksBoolExp = {
  _and?: InputMaybe<Array<ContentBlocksBoolExp>>;
  _not?: InputMaybe<ContentBlocksBoolExp>;
  _or?: InputMaybe<Array<ContentBlocksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  html?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_blocks" */
export const ContentBlocksConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentBlocksIdWorkspaceIdUnique: 'content_blocks_id_workspace_id_unique',
  /** unique or primary key constraint on columns "id" */
  ContentBlocksPkey: 'content_blocks_pkey'
} as const;

export type ContentBlocksConstraint = typeof ContentBlocksConstraint[keyof typeof ContentBlocksConstraint];
/** input type for inserting data into table "content_blocks" */
export type ContentBlocksInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContentBlocksMaxFields = {
  __typename?: 'content_blocks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentBlocksMinFields = {
  __typename?: 'content_blocks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "content_blocks" */
export type ContentBlocksMutationResponse = {
  __typename?: 'content_blocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentBlocks>;
};

/** on_conflict condition type for table "content_blocks" */
export type ContentBlocksOnConflict = {
  constraint: ContentBlocksConstraint;
  update_columns?: Array<ContentBlocksUpdateColumn>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};

/** Ordering options when selecting data from "content_blocks". */
export type ContentBlocksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  html?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_blocks */
export type ContentBlocksPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_blocks" */
export const ContentBlocksSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Html: 'html',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentBlocksSelectColumn = typeof ContentBlocksSelectColumn[keyof typeof ContentBlocksSelectColumn];
/** input type for updating data in table "content_blocks" */
export type ContentBlocksSetInput = {
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ContentBlocksStddevFields = {
  __typename?: 'content_blocks_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentBlocksStddevPopFields = {
  __typename?: 'content_blocks_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentBlocksStddevSampFields = {
  __typename?: 'content_blocks_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_blocks" */
export type ContentBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentBlocksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentBlocksSumFields = {
  __typename?: 'content_blocks_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "content_blocks" */
export const ContentBlocksUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Html: 'html',
  /** column name */
  Name: 'name'
} as const;

export type ContentBlocksUpdateColumn = typeof ContentBlocksUpdateColumn[keyof typeof ContentBlocksUpdateColumn];
export type ContentBlocksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentBlocksSetInput>;
  /** filter the rows which have to be updated */
  where: ContentBlocksBoolExp;
};

/** aggregate var_pop on columns */
export type ContentBlocksVarPopFields = {
  __typename?: 'content_blocks_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentBlocksVarSampFields = {
  __typename?: 'content_blocks_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentBlocksVarianceFields = {
  __typename?: 'content_blocks_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "content_deployments" */
export type ContentDeployments = {
  __typename?: 'content_deployments';
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  compile_manifest: Scalars['jsonb'];
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  delivery_type: Scalars['String'];
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id: Scalars['bigint'];
  id: Scalars['uuid'];
  status: Scalars['String'];
  /** An object relationship */
  sync?: Maybe<DestinationInstances>;
  sync_id?: Maybe<Scalars['bigint']>;
  target_refs: Scalars['jsonb'];
  target_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_deployments" */
export type ContentDeploymentsCompileManifestArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "content_deployments" */
export type ContentDeploymentsTargetRefsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_deployments" */
export type ContentDeploymentsAggregate = {
  __typename?: 'content_deployments_aggregate';
  aggregate?: Maybe<ContentDeploymentsAggregateFields>;
  nodes: Array<ContentDeployments>;
};

/** aggregate fields of "content_deployments" */
export type ContentDeploymentsAggregateFields = {
  __typename?: 'content_deployments_aggregate_fields';
  avg?: Maybe<ContentDeploymentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDeploymentsMaxFields>;
  min?: Maybe<ContentDeploymentsMinFields>;
  stddev?: Maybe<ContentDeploymentsStddevFields>;
  stddev_pop?: Maybe<ContentDeploymentsStddevPopFields>;
  stddev_samp?: Maybe<ContentDeploymentsStddevSampFields>;
  sum?: Maybe<ContentDeploymentsSumFields>;
  var_pop?: Maybe<ContentDeploymentsVarPopFields>;
  var_samp?: Maybe<ContentDeploymentsVarSampFields>;
  variance?: Maybe<ContentDeploymentsVarianceFields>;
};


/** aggregate fields of "content_deployments" */
export type ContentDeploymentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDeploymentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContentDeploymentsAvgFields = {
  __typename?: 'content_deployments_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_deployments". All fields are combined with a logical 'AND'. */
export type ContentDeploymentsBoolExp = {
  _and?: InputMaybe<Array<ContentDeploymentsBoolExp>>;
  _not?: InputMaybe<ContentDeploymentsBoolExp>;
  _or?: InputMaybe<Array<ContentDeploymentsBoolExp>>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  compile_manifest?: InputMaybe<JsonbComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  delivery_type?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<DestinationInstancesBoolExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  target_refs?: InputMaybe<JsonbComparisonExp>;
  target_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ContentDeploymentsMaxFields = {
  __typename?: 'content_deployments_max_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  delivery_type?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_id?: Maybe<Scalars['bigint']>;
  target_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentDeploymentsMinFields = {
  __typename?: 'content_deployments_min_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  delivery_type?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_id?: Maybe<Scalars['bigint']>;
  target_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "content_deployments". */
export type ContentDeploymentsOrderBy = {
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  compile_manifest?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  delivery_type?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync?: InputMaybe<DestinationInstancesOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  target_refs?: InputMaybe<OrderBy>;
  target_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "content_deployments" */
export const ContentDeploymentsSelectColumn = {
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  CompileManifest: 'compile_manifest',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeliveryType: 'delivery_type',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  TargetRefs: 'target_refs',
  /** column name */
  TargetType: 'target_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDeploymentsSelectColumn = typeof ContentDeploymentsSelectColumn[keyof typeof ContentDeploymentsSelectColumn];
/** aggregate stddev on columns */
export type ContentDeploymentsStddevFields = {
  __typename?: 'content_deployments_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentDeploymentsStddevPopFields = {
  __typename?: 'content_deployments_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentDeploymentsStddevSampFields = {
  __typename?: 'content_deployments_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_deployments" */
export type ContentDeploymentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDeploymentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDeploymentsStreamCursorValueInput = {
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  compile_manifest?: InputMaybe<Scalars['jsonb']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
  target_refs?: InputMaybe<Scalars['jsonb']>;
  target_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDeploymentsSumFields = {
  __typename?: 'content_deployments_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  sync_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ContentDeploymentsVarPopFields = {
  __typename?: 'content_deployments_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentDeploymentsVarSampFields = {
  __typename?: 'content_deployments_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentDeploymentsVarianceFields = {
  __typename?: 'content_deployments_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  sync_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignments = {
  __typename?: 'content_dynamic_slot_assignments';
  /** An object relationship */
  branch: ContentDynamicSlotBranches;
  branch_id: Scalars['uuid'];
  /** An object relationship */
  content: ContentDynamicSlotContents;
  content_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  library_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  usage: ContentDynamicSlotUsages;
  usage_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsAggregate = {
  __typename?: 'content_dynamic_slot_assignments_aggregate';
  aggregate?: Maybe<ContentDynamicSlotAssignmentsAggregateFields>;
  nodes: Array<ContentDynamicSlotAssignments>;
};

export type ContentDynamicSlotAssignmentsAggregateBoolExp = {
  count?: InputMaybe<ContentDynamicSlotAssignmentsAggregateBoolExpCount>;
};

export type ContentDynamicSlotAssignmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsAggregateFields = {
  __typename?: 'content_dynamic_slot_assignments_aggregate_fields';
  avg?: Maybe<ContentDynamicSlotAssignmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDynamicSlotAssignmentsMaxFields>;
  min?: Maybe<ContentDynamicSlotAssignmentsMinFields>;
  stddev?: Maybe<ContentDynamicSlotAssignmentsStddevFields>;
  stddev_pop?: Maybe<ContentDynamicSlotAssignmentsStddevPopFields>;
  stddev_samp?: Maybe<ContentDynamicSlotAssignmentsStddevSampFields>;
  sum?: Maybe<ContentDynamicSlotAssignmentsSumFields>;
  var_pop?: Maybe<ContentDynamicSlotAssignmentsVarPopFields>;
  var_samp?: Maybe<ContentDynamicSlotAssignmentsVarSampFields>;
  variance?: Maybe<ContentDynamicSlotAssignmentsVarianceFields>;
};


/** aggregate fields of "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsAggregateOrderBy = {
  avg?: InputMaybe<ContentDynamicSlotAssignmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentDynamicSlotAssignmentsMaxOrderBy>;
  min?: InputMaybe<ContentDynamicSlotAssignmentsMinOrderBy>;
  stddev?: InputMaybe<ContentDynamicSlotAssignmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentDynamicSlotAssignmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentDynamicSlotAssignmentsStddevSampOrderBy>;
  sum?: InputMaybe<ContentDynamicSlotAssignmentsSumOrderBy>;
  var_pop?: InputMaybe<ContentDynamicSlotAssignmentsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentDynamicSlotAssignmentsVarSampOrderBy>;
  variance?: InputMaybe<ContentDynamicSlotAssignmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsArrRelInsertInput = {
  data: Array<ContentDynamicSlotAssignmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotAssignmentsOnConflict>;
};

/** aggregate avg on columns */
export type ContentDynamicSlotAssignmentsAvgFields = {
  __typename?: 'content_dynamic_slot_assignments_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_dynamic_slot_assignments". All fields are combined with a logical 'AND'. */
export type ContentDynamicSlotAssignmentsBoolExp = {
  _and?: InputMaybe<Array<ContentDynamicSlotAssignmentsBoolExp>>;
  _not?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
  _or?: InputMaybe<Array<ContentDynamicSlotAssignmentsBoolExp>>;
  branch?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
  branch_id?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
  content_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  library_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  usage?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  usage_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_dynamic_slot_assignments" */
export const ContentDynamicSlotAssignmentsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentDynamicSlotAssignmentsIdWorkspaceIdKey: 'content_dynamic_slot_assignments_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ContentDynamicSlotAssignmentsPkey: 'content_dynamic_slot_assignments_pkey',
  /** unique or primary key constraint on columns "branch_id", "usage_id" */
  ContentDynamicSlotAssignmentsUsageIdBranchIdKey: 'content_dynamic_slot_assignments_usage_id_branch_id_key'
} as const;

export type ContentDynamicSlotAssignmentsConstraint = typeof ContentDynamicSlotAssignmentsConstraint[keyof typeof ContentDynamicSlotAssignmentsConstraint];
/** input type for inserting data into table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsInsertInput = {
  branch?: InputMaybe<ContentDynamicSlotBranchesObjRelInsertInput>;
  branch_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<ContentDynamicSlotContentsObjRelInsertInput>;
  content_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  usage?: InputMaybe<ContentDynamicSlotUsagesObjRelInsertInput>;
  usage_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ContentDynamicSlotAssignmentsMaxFields = {
  __typename?: 'content_dynamic_slot_assignments_max_fields';
  branch_id?: Maybe<Scalars['uuid']>;
  content_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  usage_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsMaxOrderBy = {
  branch_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentDynamicSlotAssignmentsMinFields = {
  __typename?: 'content_dynamic_slot_assignments_min_fields';
  branch_id?: Maybe<Scalars['uuid']>;
  content_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  usage_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsMinOrderBy = {
  branch_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsMutationResponse = {
  __typename?: 'content_dynamic_slot_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentDynamicSlotAssignments>;
};

/** on_conflict condition type for table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsOnConflict = {
  constraint: ContentDynamicSlotAssignmentsConstraint;
  update_columns?: Array<ContentDynamicSlotAssignmentsUpdateColumn>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};

/** Ordering options when selecting data from "content_dynamic_slot_assignments". */
export type ContentDynamicSlotAssignmentsOrderBy = {
  branch?: InputMaybe<ContentDynamicSlotBranchesOrderBy>;
  branch_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<ContentDynamicSlotContentsOrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  usage?: InputMaybe<ContentDynamicSlotUsagesOrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_dynamic_slot_assignments */
export type ContentDynamicSlotAssignmentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_dynamic_slot_assignments" */
export const ContentDynamicSlotAssignmentsSelectColumn = {
  /** column name */
  BranchId: 'branch_id',
  /** column name */
  ContentId: 'content_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  LibraryId: 'library_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UsageId: 'usage_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDynamicSlotAssignmentsSelectColumn = typeof ContentDynamicSlotAssignmentsSelectColumn[keyof typeof ContentDynamicSlotAssignmentsSelectColumn];
/** input type for updating data in table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsSetInput = {
  content_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ContentDynamicSlotAssignmentsStddevFields = {
  __typename?: 'content_dynamic_slot_assignments_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentDynamicSlotAssignmentsStddevPopFields = {
  __typename?: 'content_dynamic_slot_assignments_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentDynamicSlotAssignmentsStddevSampFields = {
  __typename?: 'content_dynamic_slot_assignments_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDynamicSlotAssignmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDynamicSlotAssignmentsStreamCursorValueInput = {
  branch_id?: InputMaybe<Scalars['uuid']>;
  content_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  usage_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDynamicSlotAssignmentsSumFields = {
  __typename?: 'content_dynamic_slot_assignments_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "content_dynamic_slot_assignments" */
export const ContentDynamicSlotAssignmentsUpdateColumn = {
  /** column name */
  ContentId: 'content_id'
} as const;

export type ContentDynamicSlotAssignmentsUpdateColumn = typeof ContentDynamicSlotAssignmentsUpdateColumn[keyof typeof ContentDynamicSlotAssignmentsUpdateColumn];
export type ContentDynamicSlotAssignmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentDynamicSlotAssignmentsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentDynamicSlotAssignmentsBoolExp;
};

/** aggregate var_pop on columns */
export type ContentDynamicSlotAssignmentsVarPopFields = {
  __typename?: 'content_dynamic_slot_assignments_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentDynamicSlotAssignmentsVarSampFields = {
  __typename?: 'content_dynamic_slot_assignments_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentDynamicSlotAssignmentsVarianceFields = {
  __typename?: 'content_dynamic_slot_assignments_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_dynamic_slot_assignments" */
export type ContentDynamicSlotAssignmentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranches = {
  __typename?: 'content_dynamic_slot_branches';
  /** An array relationship */
  assignments: Array<ContentDynamicSlotAssignments>;
  /** An aggregate relationship */
  assignments_aggregate: ContentDynamicSlotAssignmentsAggregate;
  audience_condition?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  esp_condition?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  library: ContentDynamicSlotLibraries;
  library_id: Scalars['uuid'];
  name: Scalars['String'];
  rank: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAudienceConditionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAggregate = {
  __typename?: 'content_dynamic_slot_branches_aggregate';
  aggregate?: Maybe<ContentDynamicSlotBranchesAggregateFields>;
  nodes: Array<ContentDynamicSlotBranches>;
};

export type ContentDynamicSlotBranchesAggregateBoolExp = {
  count?: InputMaybe<ContentDynamicSlotBranchesAggregateBoolExpCount>;
};

export type ContentDynamicSlotBranchesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAggregateFields = {
  __typename?: 'content_dynamic_slot_branches_aggregate_fields';
  avg?: Maybe<ContentDynamicSlotBranchesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDynamicSlotBranchesMaxFields>;
  min?: Maybe<ContentDynamicSlotBranchesMinFields>;
  stddev?: Maybe<ContentDynamicSlotBranchesStddevFields>;
  stddev_pop?: Maybe<ContentDynamicSlotBranchesStddevPopFields>;
  stddev_samp?: Maybe<ContentDynamicSlotBranchesStddevSampFields>;
  sum?: Maybe<ContentDynamicSlotBranchesSumFields>;
  var_pop?: Maybe<ContentDynamicSlotBranchesVarPopFields>;
  var_samp?: Maybe<ContentDynamicSlotBranchesVarSampFields>;
  variance?: Maybe<ContentDynamicSlotBranchesVarianceFields>;
};


/** aggregate fields of "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAggregateOrderBy = {
  avg?: InputMaybe<ContentDynamicSlotBranchesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentDynamicSlotBranchesMaxOrderBy>;
  min?: InputMaybe<ContentDynamicSlotBranchesMinOrderBy>;
  stddev?: InputMaybe<ContentDynamicSlotBranchesStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentDynamicSlotBranchesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentDynamicSlotBranchesStddevSampOrderBy>;
  sum?: InputMaybe<ContentDynamicSlotBranchesSumOrderBy>;
  var_pop?: InputMaybe<ContentDynamicSlotBranchesVarPopOrderBy>;
  var_samp?: InputMaybe<ContentDynamicSlotBranchesVarSampOrderBy>;
  variance?: InputMaybe<ContentDynamicSlotBranchesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContentDynamicSlotBranchesAppendInput = {
  audience_condition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesArrRelInsertInput = {
  data: Array<ContentDynamicSlotBranchesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotBranchesOnConflict>;
};

/** aggregate avg on columns */
export type ContentDynamicSlotBranchesAvgFields = {
  __typename?: 'content_dynamic_slot_branches_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_dynamic_slot_branches". All fields are combined with a logical 'AND'. */
export type ContentDynamicSlotBranchesBoolExp = {
  _and?: InputMaybe<Array<ContentDynamicSlotBranchesBoolExp>>;
  _not?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
  _or?: InputMaybe<Array<ContentDynamicSlotBranchesBoolExp>>;
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateBoolExp>;
  audience_condition?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  esp_condition?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  library?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
  library_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_dynamic_slot_branches" */
export const ContentDynamicSlotBranchesConstraint = {
  /** unique or primary key constraint on columns "library_id", "id" */
  ContentDynamicSlotBranchesIdLibraryIdKey: 'content_dynamic_slot_branches_id_library_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentDynamicSlotBranchesIdWorkspaceIdKey: 'content_dynamic_slot_branches_id_workspace_id_key',
  /** unique or primary key constraint on columns "library_id", "rank" */
  ContentDynamicSlotBranchesLibraryIdRankKey: 'content_dynamic_slot_branches_library_id_rank_key',
  /** unique or primary key constraint on columns "library_id" */
  ContentDynamicSlotBranchesOneFallbackPerLibrary: 'content_dynamic_slot_branches_one_fallback_per_library',
  /** unique or primary key constraint on columns "id" */
  ContentDynamicSlotBranchesPkey: 'content_dynamic_slot_branches_pkey'
} as const;

export type ContentDynamicSlotBranchesConstraint = typeof ContentDynamicSlotBranchesConstraint[keyof typeof ContentDynamicSlotBranchesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContentDynamicSlotBranchesDeleteAtPathInput = {
  audience_condition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContentDynamicSlotBranchesDeleteElemInput = {
  audience_condition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContentDynamicSlotBranchesDeleteKeyInput = {
  audience_condition?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesIncInput = {
  rank?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesInsertInput = {
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsArrRelInsertInput>;
  audience_condition?: InputMaybe<Scalars['jsonb']>;
  esp_condition?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  library?: InputMaybe<ContentDynamicSlotLibrariesObjRelInsertInput>;
  library_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ContentDynamicSlotBranchesMaxFields = {
  __typename?: 'content_dynamic_slot_branches_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  esp_condition?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  esp_condition?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentDynamicSlotBranchesMinFields = {
  __typename?: 'content_dynamic_slot_branches_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  esp_condition?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  esp_condition?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesMutationResponse = {
  __typename?: 'content_dynamic_slot_branches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentDynamicSlotBranches>;
};

/** input type for inserting object relation for remote table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesObjRelInsertInput = {
  data: ContentDynamicSlotBranchesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotBranchesOnConflict>;
};

/** on_conflict condition type for table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesOnConflict = {
  constraint: ContentDynamicSlotBranchesConstraint;
  update_columns?: Array<ContentDynamicSlotBranchesUpdateColumn>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};

/** Ordering options when selecting data from "content_dynamic_slot_branches". */
export type ContentDynamicSlotBranchesOrderBy = {
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateOrderBy>;
  audience_condition?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  esp_condition?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library?: InputMaybe<ContentDynamicSlotLibrariesOrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_dynamic_slot_branches */
export type ContentDynamicSlotBranchesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContentDynamicSlotBranchesPrependInput = {
  audience_condition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "content_dynamic_slot_branches" */
export const ContentDynamicSlotBranchesSelectColumn = {
  /** column name */
  AudienceCondition: 'audience_condition',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EspCondition: 'esp_condition',
  /** column name */
  Id: 'id',
  /** column name */
  LibraryId: 'library_id',
  /** column name */
  Name: 'name',
  /** column name */
  Rank: 'rank',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDynamicSlotBranchesSelectColumn = typeof ContentDynamicSlotBranchesSelectColumn[keyof typeof ContentDynamicSlotBranchesSelectColumn];
/** input type for updating data in table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesSetInput = {
  audience_condition?: InputMaybe<Scalars['jsonb']>;
  esp_condition?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ContentDynamicSlotBranchesStddevFields = {
  __typename?: 'content_dynamic_slot_branches_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentDynamicSlotBranchesStddevPopFields = {
  __typename?: 'content_dynamic_slot_branches_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentDynamicSlotBranchesStddevSampFields = {
  __typename?: 'content_dynamic_slot_branches_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDynamicSlotBranchesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDynamicSlotBranchesStreamCursorValueInput = {
  audience_condition?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  esp_condition?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDynamicSlotBranchesSumFields = {
  __typename?: 'content_dynamic_slot_branches_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  rank?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "content_dynamic_slot_branches" */
export const ContentDynamicSlotBranchesUpdateColumn = {
  /** column name */
  AudienceCondition: 'audience_condition',
  /** column name */
  EspCondition: 'esp_condition',
  /** column name */
  Name: 'name',
  /** column name */
  Rank: 'rank'
} as const;

export type ContentDynamicSlotBranchesUpdateColumn = typeof ContentDynamicSlotBranchesUpdateColumn[keyof typeof ContentDynamicSlotBranchesUpdateColumn];
export type ContentDynamicSlotBranchesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContentDynamicSlotBranchesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ContentDynamicSlotBranchesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ContentDynamicSlotBranchesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ContentDynamicSlotBranchesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContentDynamicSlotBranchesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContentDynamicSlotBranchesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentDynamicSlotBranchesSetInput>;
  /** filter the rows which have to be updated */
  where: ContentDynamicSlotBranchesBoolExp;
};

/** aggregate var_pop on columns */
export type ContentDynamicSlotBranchesVarPopFields = {
  __typename?: 'content_dynamic_slot_branches_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentDynamicSlotBranchesVarSampFields = {
  __typename?: 'content_dynamic_slot_branches_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentDynamicSlotBranchesVarianceFields = {
  __typename?: 'content_dynamic_slot_branches_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_dynamic_slot_branches" */
export type ContentDynamicSlotBranchesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContents = {
  __typename?: 'content_dynamic_slot_contents';
  /** An array relationship */
  assignments: Array<ContentDynamicSlotAssignments>;
  /** An aggregate relationship */
  assignments_aggregate: ContentDynamicSlotAssignmentsAggregate;
  content: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  library_id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  profile_mappings: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  usage: ContentDynamicSlotUsages;
  usage_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAggregate = {
  __typename?: 'content_dynamic_slot_contents_aggregate';
  aggregate?: Maybe<ContentDynamicSlotContentsAggregateFields>;
  nodes: Array<ContentDynamicSlotContents>;
};

export type ContentDynamicSlotContentsAggregateBoolExp = {
  count?: InputMaybe<ContentDynamicSlotContentsAggregateBoolExpCount>;
};

export type ContentDynamicSlotContentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAggregateFields = {
  __typename?: 'content_dynamic_slot_contents_aggregate_fields';
  avg?: Maybe<ContentDynamicSlotContentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDynamicSlotContentsMaxFields>;
  min?: Maybe<ContentDynamicSlotContentsMinFields>;
  stddev?: Maybe<ContentDynamicSlotContentsStddevFields>;
  stddev_pop?: Maybe<ContentDynamicSlotContentsStddevPopFields>;
  stddev_samp?: Maybe<ContentDynamicSlotContentsStddevSampFields>;
  sum?: Maybe<ContentDynamicSlotContentsSumFields>;
  var_pop?: Maybe<ContentDynamicSlotContentsVarPopFields>;
  var_samp?: Maybe<ContentDynamicSlotContentsVarSampFields>;
  variance?: Maybe<ContentDynamicSlotContentsVarianceFields>;
};


/** aggregate fields of "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAggregateOrderBy = {
  avg?: InputMaybe<ContentDynamicSlotContentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentDynamicSlotContentsMaxOrderBy>;
  min?: InputMaybe<ContentDynamicSlotContentsMinOrderBy>;
  stddev?: InputMaybe<ContentDynamicSlotContentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentDynamicSlotContentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentDynamicSlotContentsStddevSampOrderBy>;
  sum?: InputMaybe<ContentDynamicSlotContentsSumOrderBy>;
  var_pop?: InputMaybe<ContentDynamicSlotContentsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentDynamicSlotContentsVarSampOrderBy>;
  variance?: InputMaybe<ContentDynamicSlotContentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContentDynamicSlotContentsAppendInput = {
  content?: InputMaybe<Scalars['jsonb']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsArrRelInsertInput = {
  data: Array<ContentDynamicSlotContentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotContentsOnConflict>;
};

/** aggregate avg on columns */
export type ContentDynamicSlotContentsAvgFields = {
  __typename?: 'content_dynamic_slot_contents_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_dynamic_slot_contents". All fields are combined with a logical 'AND'. */
export type ContentDynamicSlotContentsBoolExp = {
  _and?: InputMaybe<Array<ContentDynamicSlotContentsBoolExp>>;
  _not?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
  _or?: InputMaybe<Array<ContentDynamicSlotContentsBoolExp>>;
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateBoolExp>;
  content?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  library_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  usage?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  usage_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_dynamic_slot_contents" */
export const ContentDynamicSlotContentsConstraint = {
  /** unique or primary key constraint on columns "library_id", "id" */
  ContentDynamicSlotContentsIdLibraryIdKey: 'content_dynamic_slot_contents_id_library_id_key',
  /** unique or primary key constraint on columns "id", "usage_id" */
  ContentDynamicSlotContentsIdUsageIdKey: 'content_dynamic_slot_contents_id_usage_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentDynamicSlotContentsIdWorkspaceIdKey: 'content_dynamic_slot_contents_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ContentDynamicSlotContentsPkey: 'content_dynamic_slot_contents_pkey'
} as const;

export type ContentDynamicSlotContentsConstraint = typeof ContentDynamicSlotContentsConstraint[keyof typeof ContentDynamicSlotContentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContentDynamicSlotContentsDeleteAtPathInput = {
  content?: InputMaybe<Array<Scalars['String']>>;
  profile_mappings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContentDynamicSlotContentsDeleteElemInput = {
  content?: InputMaybe<Scalars['Int']>;
  profile_mappings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContentDynamicSlotContentsDeleteKeyInput = {
  content?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsInsertInput = {
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  usage?: InputMaybe<ContentDynamicSlotUsagesObjRelInsertInput>;
  usage_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ContentDynamicSlotContentsMaxFields = {
  __typename?: 'content_dynamic_slot_contents_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  usage_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentDynamicSlotContentsMinFields = {
  __typename?: 'content_dynamic_slot_contents_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  usage_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsMutationResponse = {
  __typename?: 'content_dynamic_slot_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentDynamicSlotContents>;
};

/** input type for inserting object relation for remote table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsObjRelInsertInput = {
  data: ContentDynamicSlotContentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotContentsOnConflict>;
};

/** on_conflict condition type for table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsOnConflict = {
  constraint: ContentDynamicSlotContentsConstraint;
  update_columns?: Array<ContentDynamicSlotContentsUpdateColumn>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};

/** Ordering options when selecting data from "content_dynamic_slot_contents". */
export type ContentDynamicSlotContentsOrderBy = {
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  usage?: InputMaybe<ContentDynamicSlotUsagesOrderBy>;
  usage_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_dynamic_slot_contents */
export type ContentDynamicSlotContentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContentDynamicSlotContentsPrependInput = {
  content?: InputMaybe<Scalars['jsonb']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "content_dynamic_slot_contents" */
export const ContentDynamicSlotContentsSelectColumn = {
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  LibraryId: 'library_id',
  /** column name */
  Name: 'name',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UsageId: 'usage_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDynamicSlotContentsSelectColumn = typeof ContentDynamicSlotContentsSelectColumn[keyof typeof ContentDynamicSlotContentsSelectColumn];
/** input type for updating data in table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsSetInput = {
  content?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type ContentDynamicSlotContentsStddevFields = {
  __typename?: 'content_dynamic_slot_contents_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentDynamicSlotContentsStddevPopFields = {
  __typename?: 'content_dynamic_slot_contents_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentDynamicSlotContentsStddevSampFields = {
  __typename?: 'content_dynamic_slot_contents_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDynamicSlotContentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDynamicSlotContentsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  usage_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDynamicSlotContentsSumFields = {
  __typename?: 'content_dynamic_slot_contents_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "content_dynamic_slot_contents" */
export const ContentDynamicSlotContentsUpdateColumn = {
  /** column name */
  Content: 'content',
  /** column name */
  Name: 'name',
  /** column name */
  ProfileMappings: 'profile_mappings'
} as const;

export type ContentDynamicSlotContentsUpdateColumn = typeof ContentDynamicSlotContentsUpdateColumn[keyof typeof ContentDynamicSlotContentsUpdateColumn];
export type ContentDynamicSlotContentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContentDynamicSlotContentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ContentDynamicSlotContentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ContentDynamicSlotContentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ContentDynamicSlotContentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContentDynamicSlotContentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentDynamicSlotContentsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentDynamicSlotContentsBoolExp;
};

/** aggregate var_pop on columns */
export type ContentDynamicSlotContentsVarPopFields = {
  __typename?: 'content_dynamic_slot_contents_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentDynamicSlotContentsVarSampFields = {
  __typename?: 'content_dynamic_slot_contents_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentDynamicSlotContentsVarianceFields = {
  __typename?: 'content_dynamic_slot_contents_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_dynamic_slot_contents" */
export type ContentDynamicSlotContentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibraries = {
  __typename?: 'content_dynamic_slot_libraries';
  agent_selectable: Scalars['Boolean'];
  assignment_source: Scalars['String'];
  assignment_type: Scalars['String'];
  /** An array relationship */
  branches: Array<ContentDynamicSlotBranches>;
  /** An aggregate relationship */
  branches_aggregate: ContentDynamicSlotBranchesAggregate;
  /** An array relationship */
  condition_template_labels: Array<ConditionTemplateLabels>;
  /** An aggregate relationship */
  condition_template_labels_aggregate: ConditionTemplateLabelsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  is_template: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  scope: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An array relationship */
  usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  usages_aggregate: ContentDynamicSlotUsagesAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesBranchesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesBranchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesConditionTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesConditionTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};

/** aggregated selection of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesAggregate = {
  __typename?: 'content_dynamic_slot_libraries_aggregate';
  aggregate?: Maybe<ContentDynamicSlotLibrariesAggregateFields>;
  nodes: Array<ContentDynamicSlotLibraries>;
};

/** aggregate fields of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesAggregateFields = {
  __typename?: 'content_dynamic_slot_libraries_aggregate_fields';
  avg?: Maybe<ContentDynamicSlotLibrariesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDynamicSlotLibrariesMaxFields>;
  min?: Maybe<ContentDynamicSlotLibrariesMinFields>;
  stddev?: Maybe<ContentDynamicSlotLibrariesStddevFields>;
  stddev_pop?: Maybe<ContentDynamicSlotLibrariesStddevPopFields>;
  stddev_samp?: Maybe<ContentDynamicSlotLibrariesStddevSampFields>;
  sum?: Maybe<ContentDynamicSlotLibrariesSumFields>;
  var_pop?: Maybe<ContentDynamicSlotLibrariesVarPopFields>;
  var_samp?: Maybe<ContentDynamicSlotLibrariesVarSampFields>;
  variance?: Maybe<ContentDynamicSlotLibrariesVarianceFields>;
};


/** aggregate fields of "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDynamicSlotLibrariesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContentDynamicSlotLibrariesAvgFields = {
  __typename?: 'content_dynamic_slot_libraries_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_dynamic_slot_libraries". All fields are combined with a logical 'AND'. */
export type ContentDynamicSlotLibrariesBoolExp = {
  _and?: InputMaybe<Array<ContentDynamicSlotLibrariesBoolExp>>;
  _not?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
  _or?: InputMaybe<Array<ContentDynamicSlotLibrariesBoolExp>>;
  agent_selectable?: InputMaybe<BooleanComparisonExp>;
  assignment_source?: InputMaybe<StringComparisonExp>;
  assignment_type?: InputMaybe<StringComparisonExp>;
  branches?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
  branches_aggregate?: InputMaybe<ContentDynamicSlotBranchesAggregateBoolExp>;
  condition_template_labels?: InputMaybe<ConditionTemplateLabelsBoolExp>;
  condition_template_labels_aggregate?: InputMaybe<ConditionTemplateLabelsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_template?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  scope?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  usages?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_dynamic_slot_libraries" */
export const ContentDynamicSlotLibrariesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentDynamicSlotLibrariesIdWorkspaceIdKey: 'content_dynamic_slot_libraries_id_workspace_id_key',
  /** unique or primary key constraint on columns "id", "is_template", "workspace_id" */
  ContentDynamicSlotLibrariesIdWorkspaceIsTemplateKey: 'content_dynamic_slot_libraries_id_workspace_is_template_key',
  /** unique or primary key constraint on columns "id" */
  ContentDynamicSlotLibrariesPkey: 'content_dynamic_slot_libraries_pkey'
} as const;

export type ContentDynamicSlotLibrariesConstraint = typeof ContentDynamicSlotLibrariesConstraint[keyof typeof ContentDynamicSlotLibrariesConstraint];
/** input type for incrementing numeric columns in table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesIncInput = {
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesInsertInput = {
  agent_selectable?: InputMaybe<Scalars['Boolean']>;
  assignment_source?: InputMaybe<Scalars['String']>;
  assignment_type?: InputMaybe<Scalars['String']>;
  branches?: InputMaybe<ContentDynamicSlotBranchesArrRelInsertInput>;
  condition_template_labels?: InputMaybe<ConditionTemplateLabelsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  scope?: InputMaybe<Scalars['String']>;
  usages?: InputMaybe<ContentDynamicSlotUsagesArrRelInsertInput>;
};

/** aggregate max on columns */
export type ContentDynamicSlotLibrariesMaxFields = {
  __typename?: 'content_dynamic_slot_libraries_max_fields';
  assignment_source?: Maybe<Scalars['String']>;
  assignment_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentDynamicSlotLibrariesMinFields = {
  __typename?: 'content_dynamic_slot_libraries_min_fields';
  assignment_source?: Maybe<Scalars['String']>;
  assignment_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesMutationResponse = {
  __typename?: 'content_dynamic_slot_libraries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentDynamicSlotLibraries>;
};

/** input type for inserting object relation for remote table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesObjRelInsertInput = {
  data: ContentDynamicSlotLibrariesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotLibrariesOnConflict>;
};

/** on_conflict condition type for table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesOnConflict = {
  constraint: ContentDynamicSlotLibrariesConstraint;
  update_columns?: Array<ContentDynamicSlotLibrariesUpdateColumn>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};

/** Ordering options when selecting data from "content_dynamic_slot_libraries". */
export type ContentDynamicSlotLibrariesOrderBy = {
  agent_selectable?: InputMaybe<OrderBy>;
  assignment_source?: InputMaybe<OrderBy>;
  assignment_type?: InputMaybe<OrderBy>;
  branches_aggregate?: InputMaybe<ContentDynamicSlotBranchesAggregateOrderBy>;
  condition_template_labels_aggregate?: InputMaybe<ConditionTemplateLabelsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  is_template?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_dynamic_slot_libraries */
export type ContentDynamicSlotLibrariesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_dynamic_slot_libraries" */
export const ContentDynamicSlotLibrariesSelectColumn = {
  /** column name */
  AgentSelectable: 'agent_selectable',
  /** column name */
  AssignmentSource: 'assignment_source',
  /** column name */
  AssignmentType: 'assignment_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  IsTemplate: 'is_template',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Scope: 'scope',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDynamicSlotLibrariesSelectColumn = typeof ContentDynamicSlotLibrariesSelectColumn[keyof typeof ContentDynamicSlotLibrariesSelectColumn];
/** input type for updating data in table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesSetInput = {
  agent_selectable?: InputMaybe<Scalars['Boolean']>;
  assignment_source?: InputMaybe<Scalars['String']>;
  assignment_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  scope?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ContentDynamicSlotLibrariesStddevFields = {
  __typename?: 'content_dynamic_slot_libraries_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentDynamicSlotLibrariesStddevPopFields = {
  __typename?: 'content_dynamic_slot_libraries_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentDynamicSlotLibrariesStddevSampFields = {
  __typename?: 'content_dynamic_slot_libraries_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_dynamic_slot_libraries" */
export type ContentDynamicSlotLibrariesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDynamicSlotLibrariesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDynamicSlotLibrariesStreamCursorValueInput = {
  agent_selectable?: InputMaybe<Scalars['Boolean']>;
  assignment_source?: InputMaybe<Scalars['String']>;
  assignment_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDynamicSlotLibrariesSumFields = {
  __typename?: 'content_dynamic_slot_libraries_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "content_dynamic_slot_libraries" */
export const ContentDynamicSlotLibrariesUpdateColumn = {
  /** column name */
  AgentSelectable: 'agent_selectable',
  /** column name */
  AssignmentSource: 'assignment_source',
  /** column name */
  AssignmentType: 'assignment_type',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Scope: 'scope'
} as const;

export type ContentDynamicSlotLibrariesUpdateColumn = typeof ContentDynamicSlotLibrariesUpdateColumn[keyof typeof ContentDynamicSlotLibrariesUpdateColumn];
export type ContentDynamicSlotLibrariesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ContentDynamicSlotLibrariesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentDynamicSlotLibrariesSetInput>;
  /** filter the rows which have to be updated */
  where: ContentDynamicSlotLibrariesBoolExp;
};

/** aggregate var_pop on columns */
export type ContentDynamicSlotLibrariesVarPopFields = {
  __typename?: 'content_dynamic_slot_libraries_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentDynamicSlotLibrariesVarSampFields = {
  __typename?: 'content_dynamic_slot_libraries_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentDynamicSlotLibrariesVarianceFields = {
  __typename?: 'content_dynamic_slot_libraries_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsages = {
  __typename?: 'content_dynamic_slot_usages';
  /** An array relationship */
  assignments: Array<ContentDynamicSlotAssignments>;
  /** An aggregate relationship */
  assignments_aggregate: ContentDynamicSlotAssignmentsAggregate;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_block?: Maybe<CepContentBlocks>;
  content_block_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  contents: Array<ContentDynamicSlotContents>;
  /** An aggregate relationship */
  contents_aggregate: ContentDynamicSlotContentsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  library: ContentDynamicSlotLibraries;
  library_id: Scalars['uuid'];
  /** An object relationship */
  message?: Maybe<Messages>;
  message_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesContentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


/** columns and relationships of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};

/** aggregated selection of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAggregate = {
  __typename?: 'content_dynamic_slot_usages_aggregate';
  aggregate?: Maybe<ContentDynamicSlotUsagesAggregateFields>;
  nodes: Array<ContentDynamicSlotUsages>;
};

export type ContentDynamicSlotUsagesAggregateBoolExp = {
  count?: InputMaybe<ContentDynamicSlotUsagesAggregateBoolExpCount>;
};

export type ContentDynamicSlotUsagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAggregateFields = {
  __typename?: 'content_dynamic_slot_usages_aggregate_fields';
  avg?: Maybe<ContentDynamicSlotUsagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentDynamicSlotUsagesMaxFields>;
  min?: Maybe<ContentDynamicSlotUsagesMinFields>;
  stddev?: Maybe<ContentDynamicSlotUsagesStddevFields>;
  stddev_pop?: Maybe<ContentDynamicSlotUsagesStddevPopFields>;
  stddev_samp?: Maybe<ContentDynamicSlotUsagesStddevSampFields>;
  sum?: Maybe<ContentDynamicSlotUsagesSumFields>;
  var_pop?: Maybe<ContentDynamicSlotUsagesVarPopFields>;
  var_samp?: Maybe<ContentDynamicSlotUsagesVarSampFields>;
  variance?: Maybe<ContentDynamicSlotUsagesVarianceFields>;
};


/** aggregate fields of "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAggregateOrderBy = {
  avg?: InputMaybe<ContentDynamicSlotUsagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentDynamicSlotUsagesMaxOrderBy>;
  min?: InputMaybe<ContentDynamicSlotUsagesMinOrderBy>;
  stddev?: InputMaybe<ContentDynamicSlotUsagesStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentDynamicSlotUsagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentDynamicSlotUsagesStddevSampOrderBy>;
  sum?: InputMaybe<ContentDynamicSlotUsagesSumOrderBy>;
  var_pop?: InputMaybe<ContentDynamicSlotUsagesVarPopOrderBy>;
  var_samp?: InputMaybe<ContentDynamicSlotUsagesVarSampOrderBy>;
  variance?: InputMaybe<ContentDynamicSlotUsagesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesArrRelInsertInput = {
  data: Array<ContentDynamicSlotUsagesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotUsagesOnConflict>;
};

/** aggregate avg on columns */
export type ContentDynamicSlotUsagesAvgFields = {
  __typename?: 'content_dynamic_slot_usages_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_dynamic_slot_usages". All fields are combined with a logical 'AND'. */
export type ContentDynamicSlotUsagesBoolExp = {
  _and?: InputMaybe<Array<ContentDynamicSlotUsagesBoolExp>>;
  _not?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  _or?: InputMaybe<Array<ContentDynamicSlotUsagesBoolExp>>;
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateBoolExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifact_id?: InputMaybe<UuidComparisonExp>;
  content_block?: InputMaybe<CepContentBlocksBoolExp>;
  content_block_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  contents?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
  contents_aggregate?: InputMaybe<ContentDynamicSlotContentsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  library?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
  library_id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_dynamic_slot_usages" */
export const ContentDynamicSlotUsagesConstraint = {
  /** unique or primary key constraint on columns "library_id", "id" */
  ContentDynamicSlotUsagesIdLibraryIdKey: 'content_dynamic_slot_usages_id_library_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentDynamicSlotUsagesIdWorkspaceIdKey: 'content_dynamic_slot_usages_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ContentDynamicSlotUsagesPkey: 'content_dynamic_slot_usages_pkey'
} as const;

export type ContentDynamicSlotUsagesConstraint = typeof ContentDynamicSlotUsagesConstraint[keyof typeof ContentDynamicSlotUsagesConstraint];
/** input type for inserting data into table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesInsertInput = {
  assignments?: InputMaybe<ContentDynamicSlotAssignmentsArrRelInsertInput>;
  campaign_artifact?: InputMaybe<CampaignArtifactsObjRelInsertInput>;
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_block?: InputMaybe<CepContentBlocksObjRelInsertInput>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  contents?: InputMaybe<ContentDynamicSlotContentsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  library?: InputMaybe<ContentDynamicSlotLibrariesObjRelInsertInput>;
  library_id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ContentDynamicSlotUsagesMaxFields = {
  __typename?: 'content_dynamic_slot_usages_max_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_block_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesMaxOrderBy = {
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentDynamicSlotUsagesMinFields = {
  __typename?: 'content_dynamic_slot_usages_min_fields';
  campaign_artifact_id?: Maybe<Scalars['uuid']>;
  content_block_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  library_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesMinOrderBy = {
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  library_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesMutationResponse = {
  __typename?: 'content_dynamic_slot_usages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentDynamicSlotUsages>;
};

/** input type for inserting object relation for remote table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesObjRelInsertInput = {
  data: ContentDynamicSlotUsagesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ContentDynamicSlotUsagesOnConflict>;
};

/** on_conflict condition type for table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesOnConflict = {
  constraint: ContentDynamicSlotUsagesConstraint;
  update_columns?: Array<ContentDynamicSlotUsagesUpdateColumn>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};

/** Ordering options when selecting data from "content_dynamic_slot_usages". */
export type ContentDynamicSlotUsagesOrderBy = {
  assignments_aggregate?: InputMaybe<ContentDynamicSlotAssignmentsAggregateOrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_artifact_id?: InputMaybe<OrderBy>;
  content_block?: InputMaybe<CepContentBlocksOrderBy>;
  content_block_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  contents_aggregate?: InputMaybe<ContentDynamicSlotContentsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  library?: InputMaybe<ContentDynamicSlotLibrariesOrderBy>;
  library_id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_dynamic_slot_usages */
export type ContentDynamicSlotUsagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_dynamic_slot_usages" */
export const ContentDynamicSlotUsagesSelectColumn = {
  /** column name */
  CampaignArtifactId: 'campaign_artifact_id',
  /** column name */
  ContentBlockId: 'content_block_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  LibraryId: 'library_id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentDynamicSlotUsagesSelectColumn = typeof ContentDynamicSlotUsagesSelectColumn[keyof typeof ContentDynamicSlotUsagesSelectColumn];
/** input type for updating data in table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesSetInput = {
  library_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ContentDynamicSlotUsagesStddevFields = {
  __typename?: 'content_dynamic_slot_usages_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentDynamicSlotUsagesStddevPopFields = {
  __typename?: 'content_dynamic_slot_usages_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentDynamicSlotUsagesStddevSampFields = {
  __typename?: 'content_dynamic_slot_usages_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentDynamicSlotUsagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentDynamicSlotUsagesStreamCursorValueInput = {
  campaign_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_block_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  library_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentDynamicSlotUsagesSumFields = {
  __typename?: 'content_dynamic_slot_usages_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "content_dynamic_slot_usages" */
export const ContentDynamicSlotUsagesUpdateColumn = {
  /** column name */
  LibraryId: 'library_id'
} as const;

export type ContentDynamicSlotUsagesUpdateColumn = typeof ContentDynamicSlotUsagesUpdateColumn[keyof typeof ContentDynamicSlotUsagesUpdateColumn];
export type ContentDynamicSlotUsagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentDynamicSlotUsagesSetInput>;
  /** filter the rows which have to be updated */
  where: ContentDynamicSlotUsagesBoolExp;
};

/** aggregate var_pop on columns */
export type ContentDynamicSlotUsagesVarPopFields = {
  __typename?: 'content_dynamic_slot_usages_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentDynamicSlotUsagesVarSampFields = {
  __typename?: 'content_dynamic_slot_usages_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentDynamicSlotUsagesVarianceFields = {
  __typename?: 'content_dynamic_slot_usages_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_dynamic_slot_usages" */
export type ContentDynamicSlotUsagesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_email_message_links" */
export type ContentEmailMessageLinks = {
  __typename?: 'content_email_message_links';
  /** An object relationship */
  content_email: ContentEmails;
  content_email_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  variant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_email_message_links" */
export type ContentEmailMessageLinksAggregate = {
  __typename?: 'content_email_message_links_aggregate';
  aggregate?: Maybe<ContentEmailMessageLinksAggregateFields>;
  nodes: Array<ContentEmailMessageLinks>;
};

export type ContentEmailMessageLinksAggregateBoolExp = {
  count?: InputMaybe<ContentEmailMessageLinksAggregateBoolExpCount>;
};

export type ContentEmailMessageLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailMessageLinksBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_email_message_links" */
export type ContentEmailMessageLinksAggregateFields = {
  __typename?: 'content_email_message_links_aggregate_fields';
  avg?: Maybe<ContentEmailMessageLinksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentEmailMessageLinksMaxFields>;
  min?: Maybe<ContentEmailMessageLinksMinFields>;
  stddev?: Maybe<ContentEmailMessageLinksStddevFields>;
  stddev_pop?: Maybe<ContentEmailMessageLinksStddevPopFields>;
  stddev_samp?: Maybe<ContentEmailMessageLinksStddevSampFields>;
  sum?: Maybe<ContentEmailMessageLinksSumFields>;
  var_pop?: Maybe<ContentEmailMessageLinksVarPopFields>;
  var_samp?: Maybe<ContentEmailMessageLinksVarSampFields>;
  variance?: Maybe<ContentEmailMessageLinksVarianceFields>;
};


/** aggregate fields of "content_email_message_links" */
export type ContentEmailMessageLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_email_message_links" */
export type ContentEmailMessageLinksAggregateOrderBy = {
  avg?: InputMaybe<ContentEmailMessageLinksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentEmailMessageLinksMaxOrderBy>;
  min?: InputMaybe<ContentEmailMessageLinksMinOrderBy>;
  stddev?: InputMaybe<ContentEmailMessageLinksStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentEmailMessageLinksStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentEmailMessageLinksStddevSampOrderBy>;
  sum?: InputMaybe<ContentEmailMessageLinksSumOrderBy>;
  var_pop?: InputMaybe<ContentEmailMessageLinksVarPopOrderBy>;
  var_samp?: InputMaybe<ContentEmailMessageLinksVarSampOrderBy>;
  variance?: InputMaybe<ContentEmailMessageLinksVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ContentEmailMessageLinksAvgFields = {
  __typename?: 'content_email_message_links_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_email_message_links". All fields are combined with a logical 'AND'. */
export type ContentEmailMessageLinksBoolExp = {
  _and?: InputMaybe<Array<ContentEmailMessageLinksBoolExp>>;
  _not?: InputMaybe<ContentEmailMessageLinksBoolExp>;
  _or?: InputMaybe<Array<ContentEmailMessageLinksBoolExp>>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  variant_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ContentEmailMessageLinksMaxFields = {
  __typename?: 'content_email_message_links_max_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  variant_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksMaxOrderBy = {
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentEmailMessageLinksMinFields = {
  __typename?: 'content_email_message_links_min_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  variant_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksMinOrderBy = {
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "content_email_message_links". */
export type ContentEmailMessageLinksOrderBy = {
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "content_email_message_links" */
export const ContentEmailMessageLinksSelectColumn = {
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  VariantId: 'variant_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentEmailMessageLinksSelectColumn = typeof ContentEmailMessageLinksSelectColumn[keyof typeof ContentEmailMessageLinksSelectColumn];
/** aggregate stddev on columns */
export type ContentEmailMessageLinksStddevFields = {
  __typename?: 'content_email_message_links_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentEmailMessageLinksStddevPopFields = {
  __typename?: 'content_email_message_links_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentEmailMessageLinksStddevSampFields = {
  __typename?: 'content_email_message_links_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_email_message_links" */
export type ContentEmailMessageLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentEmailMessageLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentEmailMessageLinksStreamCursorValueInput = {
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  variant_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentEmailMessageLinksSumFields = {
  __typename?: 'content_email_message_links_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ContentEmailMessageLinksVarPopFields = {
  __typename?: 'content_email_message_links_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentEmailMessageLinksVarSampFields = {
  __typename?: 'content_email_message_links_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentEmailMessageLinksVarianceFields = {
  __typename?: 'content_email_message_links_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_email_message_links" */
export type ContentEmailMessageLinksVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_email_variants" */
export type ContentEmailVariants = {
  __typename?: 'content_email_variants';
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  label: Scalars['String'];
  message_variable_values: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_email_variants" */
export type ContentEmailVariantsMessageVariableValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_email_variants" */
export type ContentEmailVariantsAggregate = {
  __typename?: 'content_email_variants_aggregate';
  aggregate?: Maybe<ContentEmailVariantsAggregateFields>;
  nodes: Array<ContentEmailVariants>;
};

export type ContentEmailVariantsAggregateBoolExp = {
  count?: InputMaybe<ContentEmailVariantsAggregateBoolExpCount>;
};

export type ContentEmailVariantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailVariantsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_email_variants" */
export type ContentEmailVariantsAggregateFields = {
  __typename?: 'content_email_variants_aggregate_fields';
  avg?: Maybe<ContentEmailVariantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentEmailVariantsMaxFields>;
  min?: Maybe<ContentEmailVariantsMinFields>;
  stddev?: Maybe<ContentEmailVariantsStddevFields>;
  stddev_pop?: Maybe<ContentEmailVariantsStddevPopFields>;
  stddev_samp?: Maybe<ContentEmailVariantsStddevSampFields>;
  sum?: Maybe<ContentEmailVariantsSumFields>;
  var_pop?: Maybe<ContentEmailVariantsVarPopFields>;
  var_samp?: Maybe<ContentEmailVariantsVarSampFields>;
  variance?: Maybe<ContentEmailVariantsVarianceFields>;
};


/** aggregate fields of "content_email_variants" */
export type ContentEmailVariantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_email_variants" */
export type ContentEmailVariantsAggregateOrderBy = {
  avg?: InputMaybe<ContentEmailVariantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentEmailVariantsMaxOrderBy>;
  min?: InputMaybe<ContentEmailVariantsMinOrderBy>;
  stddev?: InputMaybe<ContentEmailVariantsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentEmailVariantsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentEmailVariantsStddevSampOrderBy>;
  sum?: InputMaybe<ContentEmailVariantsSumOrderBy>;
  var_pop?: InputMaybe<ContentEmailVariantsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentEmailVariantsVarSampOrderBy>;
  variance?: InputMaybe<ContentEmailVariantsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContentEmailVariantsAppendInput = {
  message_variable_values?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ContentEmailVariantsAvgFields = {
  __typename?: 'content_email_variants_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_email_variants" */
export type ContentEmailVariantsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_email_variants". All fields are combined with a logical 'AND'. */
export type ContentEmailVariantsBoolExp = {
  _and?: InputMaybe<Array<ContentEmailVariantsBoolExp>>;
  _not?: InputMaybe<ContentEmailVariantsBoolExp>;
  _or?: InputMaybe<Array<ContentEmailVariantsBoolExp>>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  message_variable_values?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_email_variants" */
export const ContentEmailVariantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ContentEmailVariantsPkey: 'content_email_variants_pkey'
} as const;

export type ContentEmailVariantsConstraint = typeof ContentEmailVariantsConstraint[keyof typeof ContentEmailVariantsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContentEmailVariantsDeleteAtPathInput = {
  message_variable_values?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContentEmailVariantsDeleteElemInput = {
  message_variable_values?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContentEmailVariantsDeleteKeyInput = {
  message_variable_values?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "content_email_variants" */
export type ContentEmailVariantsInsertInput = {
  content_email_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  message_variable_values?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type ContentEmailVariantsMaxFields = {
  __typename?: 'content_email_variants_max_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_email_variants" */
export type ContentEmailVariantsMaxOrderBy = {
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentEmailVariantsMinFields = {
  __typename?: 'content_email_variants_min_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_email_variants" */
export type ContentEmailVariantsMinOrderBy = {
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_email_variants" */
export type ContentEmailVariantsMutationResponse = {
  __typename?: 'content_email_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentEmailVariants>;
};

/** on_conflict condition type for table "content_email_variants" */
export type ContentEmailVariantsOnConflict = {
  constraint: ContentEmailVariantsConstraint;
  update_columns?: Array<ContentEmailVariantsUpdateColumn>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};

/** Ordering options when selecting data from "content_email_variants". */
export type ContentEmailVariantsOrderBy = {
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  message_variable_values?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_email_variants */
export type ContentEmailVariantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContentEmailVariantsPrependInput = {
  message_variable_values?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "content_email_variants" */
export const ContentEmailVariantsSelectColumn = {
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Label: 'label',
  /** column name */
  MessageVariableValues: 'message_variable_values',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentEmailVariantsSelectColumn = typeof ContentEmailVariantsSelectColumn[keyof typeof ContentEmailVariantsSelectColumn];
/** input type for updating data in table "content_email_variants" */
export type ContentEmailVariantsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  message_variable_values?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type ContentEmailVariantsStddevFields = {
  __typename?: 'content_email_variants_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_email_variants" */
export type ContentEmailVariantsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentEmailVariantsStddevPopFields = {
  __typename?: 'content_email_variants_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_email_variants" */
export type ContentEmailVariantsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentEmailVariantsStddevSampFields = {
  __typename?: 'content_email_variants_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_email_variants" */
export type ContentEmailVariantsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_email_variants" */
export type ContentEmailVariantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentEmailVariantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentEmailVariantsStreamCursorValueInput = {
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  message_variable_values?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentEmailVariantsSumFields = {
  __typename?: 'content_email_variants_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_email_variants" */
export type ContentEmailVariantsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "content_email_variants" */
export const ContentEmailVariantsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Label: 'label',
  /** column name */
  MessageVariableValues: 'message_variable_values'
} as const;

export type ContentEmailVariantsUpdateColumn = typeof ContentEmailVariantsUpdateColumn[keyof typeof ContentEmailVariantsUpdateColumn];
export type ContentEmailVariantsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContentEmailVariantsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ContentEmailVariantsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ContentEmailVariantsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ContentEmailVariantsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContentEmailVariantsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentEmailVariantsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentEmailVariantsBoolExp;
};

/** aggregate var_pop on columns */
export type ContentEmailVariantsVarPopFields = {
  __typename?: 'content_email_variants_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_email_variants" */
export type ContentEmailVariantsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentEmailVariantsVarSampFields = {
  __typename?: 'content_email_variants_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_email_variants" */
export type ContentEmailVariantsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentEmailVariantsVarianceFields = {
  __typename?: 'content_email_variants_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_email_variants" */
export type ContentEmailVariantsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_email_versions" */
export type ContentEmailVersions = {
  __typename?: 'content_email_versions';
  artifact_version_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  campaign_artifact_version?: Maybe<CampaignArtifactVersions>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  image_url_overrides: Scalars['jsonb'];
  /** An object relationship */
  llm_chat_message?: Maybe<LlmChatMessages>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  resolved_html: ContentEmailVersionResolvedHtmlResponse;
  subject?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_email_versions" */
export type ContentEmailVersionsImageUrlOverridesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_email_versions" */
export type ContentEmailVersionsAggregate = {
  __typename?: 'content_email_versions_aggregate';
  aggregate?: Maybe<ContentEmailVersionsAggregateFields>;
  nodes: Array<ContentEmailVersions>;
};

export type ContentEmailVersionsAggregateBoolExp = {
  count?: InputMaybe<ContentEmailVersionsAggregateBoolExpCount>;
};

export type ContentEmailVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_email_versions" */
export type ContentEmailVersionsAggregateFields = {
  __typename?: 'content_email_versions_aggregate_fields';
  avg?: Maybe<ContentEmailVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentEmailVersionsMaxFields>;
  min?: Maybe<ContentEmailVersionsMinFields>;
  stddev?: Maybe<ContentEmailVersionsStddevFields>;
  stddev_pop?: Maybe<ContentEmailVersionsStddevPopFields>;
  stddev_samp?: Maybe<ContentEmailVersionsStddevSampFields>;
  sum?: Maybe<ContentEmailVersionsSumFields>;
  var_pop?: Maybe<ContentEmailVersionsVarPopFields>;
  var_samp?: Maybe<ContentEmailVersionsVarSampFields>;
  variance?: Maybe<ContentEmailVersionsVarianceFields>;
};


/** aggregate fields of "content_email_versions" */
export type ContentEmailVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_email_versions" */
export type ContentEmailVersionsAggregateOrderBy = {
  avg?: InputMaybe<ContentEmailVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentEmailVersionsMaxOrderBy>;
  min?: InputMaybe<ContentEmailVersionsMinOrderBy>;
  stddev?: InputMaybe<ContentEmailVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentEmailVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentEmailVersionsStddevSampOrderBy>;
  sum?: InputMaybe<ContentEmailVersionsSumOrderBy>;
  var_pop?: InputMaybe<ContentEmailVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentEmailVersionsVarSampOrderBy>;
  variance?: InputMaybe<ContentEmailVersionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ContentEmailVersionsAvgFields = {
  __typename?: 'content_email_versions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_email_versions" */
export type ContentEmailVersionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_email_versions". All fields are combined with a logical 'AND'. */
export type ContentEmailVersionsBoolExp = {
  _and?: InputMaybe<Array<ContentEmailVersionsBoolExp>>;
  _not?: InputMaybe<ContentEmailVersionsBoolExp>;
  _or?: InputMaybe<Array<ContentEmailVersionsBoolExp>>;
  artifact_version_id?: InputMaybe<UuidComparisonExp>;
  campaign_artifact_version?: InputMaybe<CampaignArtifactVersionsBoolExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image_url_overrides?: InputMaybe<JsonbComparisonExp>;
  llm_chat_message?: InputMaybe<LlmChatMessagesBoolExp>;
  llm_chat_message_id?: InputMaybe<UuidComparisonExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ContentEmailVersionsMaxFields = {
  __typename?: 'content_email_versions_max_fields';
  artifact_version_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_email_versions" */
export type ContentEmailVersionsMaxOrderBy = {
  artifact_version_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentEmailVersionsMinFields = {
  __typename?: 'content_email_versions_min_fields';
  artifact_version_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_email_versions" */
export type ContentEmailVersionsMinOrderBy = {
  artifact_version_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "content_email_versions". */
export type ContentEmailVersionsOrderBy = {
  artifact_version_id?: InputMaybe<OrderBy>;
  campaign_artifact_version?: InputMaybe<CampaignArtifactVersionsOrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  image_url_overrides?: InputMaybe<OrderBy>;
  llm_chat_message?: InputMaybe<LlmChatMessagesOrderBy>;
  llm_chat_message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "content_email_versions" */
export const ContentEmailVersionsSelectColumn = {
  /** column name */
  ArtifactVersionId: 'artifact_version_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  ImageUrlOverrides: 'image_url_overrides',
  /** column name */
  LlmChatMessageId: 'llm_chat_message_id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  Subject: 'subject',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentEmailVersionsSelectColumn = typeof ContentEmailVersionsSelectColumn[keyof typeof ContentEmailVersionsSelectColumn];
/** aggregate stddev on columns */
export type ContentEmailVersionsStddevFields = {
  __typename?: 'content_email_versions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_email_versions" */
export type ContentEmailVersionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentEmailVersionsStddevPopFields = {
  __typename?: 'content_email_versions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_email_versions" */
export type ContentEmailVersionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentEmailVersionsStddevSampFields = {
  __typename?: 'content_email_versions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_email_versions" */
export type ContentEmailVersionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_email_versions" */
export type ContentEmailVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentEmailVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentEmailVersionsStreamCursorValueInput = {
  artifact_version_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url_overrides?: InputMaybe<Scalars['jsonb']>;
  llm_chat_message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentEmailVersionsSumFields = {
  __typename?: 'content_email_versions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_email_versions" */
export type ContentEmailVersionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ContentEmailVersionsVarPopFields = {
  __typename?: 'content_email_versions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_email_versions" */
export type ContentEmailVersionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentEmailVersionsVarSampFields = {
  __typename?: 'content_email_versions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_email_versions" */
export type ContentEmailVersionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentEmailVersionsVarianceFields = {
  __typename?: 'content_email_versions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_email_versions" */
export type ContentEmailVersionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_emails" */
export type ContentEmails = {
  __typename?: 'content_emails';
  artifact_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  brand_profile_assignments: Array<BrandProfileContentEmails>;
  /** An aggregate relationship */
  brand_profile_assignments_aggregate: BrandProfileContentEmailsAggregate;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  component_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  content_dynamic_slot_usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  content_dynamic_slot_usages_aggregate: ContentDynamicSlotUsagesAggregate;
  /** An array relationship */
  content_email_message_links: Array<ContentEmailMessageLinks>;
  /** An aggregate relationship */
  content_email_message_links_aggregate: ContentEmailMessageLinksAggregate;
  /** An array relationship */
  content_email_variants: Array<ContentEmailVariants>;
  /** An aggregate relationship */
  content_email_variants_aggregate: ContentEmailVariantsAggregate;
  /** An object relationship */
  content_email_version?: Maybe<ContentEmailVersions>;
  /** An array relationship */
  content_email_versions: Array<ContentEmailVersions>;
  /** An aggregate relationship */
  content_email_versions_aggregate: ContentEmailVersionsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  external_provider_id?: Maybe<Scalars['String']>;
  external_provider_metadata?: Maybe<Scalars['jsonb']>;
  external_provider_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  figma_import_drafts: Array<FigmaImportDrafts>;
  generate_input?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  is_private: Scalars['Boolean'];
  is_template_enabled: Scalars['Boolean'];
  /** An object relationship */
  lcm_message_candidate?: Maybe<LcmMessageCandidates>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  marketing_campaign_messages: Array<MarketingCampaignMessages>;
  /** An aggregate relationship */
  marketing_campaign_messages_aggregate: MarketingCampaignMessagesAggregate;
  name: Scalars['String'];
  source: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  variant_llm_chat_session?: Maybe<LlmChatSessions>;
  variant_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  version_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  versions: Array<ContentEmailVersions>;
  /** An aggregate relationship */
  versions_aggregate: ContentEmailVersionsAggregate;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_emails" */
export type ContentEmailsBrandProfileAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsBrandProfileAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentDynamicSlotUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentDynamicSlotUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailMessageLinksArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailMessageLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailVariantsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsContentEmailVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsExternalProviderMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsFigmaImportDraftsArgs = {
  distinct_on?: InputMaybe<Array<FigmaImportDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FigmaImportDraftsOrderBy>>;
  where?: InputMaybe<FigmaImportDraftsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsGenerateInputArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsMarketingCampaignMessagesArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsMarketingCampaignMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


/** columns and relationships of "content_emails" */
export type ContentEmailsVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};

/** aggregated selection of "content_emails" */
export type ContentEmailsAggregate = {
  __typename?: 'content_emails_aggregate';
  aggregate?: Maybe<ContentEmailsAggregateFields>;
  nodes: Array<ContentEmails>;
};

export type ContentEmailsAggregateBoolExp = {
  bool_and?: InputMaybe<ContentEmailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ContentEmailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<ContentEmailsAggregateBoolExpCount>;
};

export type ContentEmailsAggregateBoolExpBoolAnd = {
  arguments: ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ContentEmailsAggregateBoolExpBoolOr = {
  arguments: ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ContentEmailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContentEmailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "content_emails" */
export type ContentEmailsAggregateFields = {
  __typename?: 'content_emails_aggregate_fields';
  avg?: Maybe<ContentEmailsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentEmailsMaxFields>;
  min?: Maybe<ContentEmailsMinFields>;
  stddev?: Maybe<ContentEmailsStddevFields>;
  stddev_pop?: Maybe<ContentEmailsStddevPopFields>;
  stddev_samp?: Maybe<ContentEmailsStddevSampFields>;
  sum?: Maybe<ContentEmailsSumFields>;
  var_pop?: Maybe<ContentEmailsVarPopFields>;
  var_samp?: Maybe<ContentEmailsVarSampFields>;
  variance?: Maybe<ContentEmailsVarianceFields>;
};


/** aggregate fields of "content_emails" */
export type ContentEmailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "content_emails" */
export type ContentEmailsAggregateOrderBy = {
  avg?: InputMaybe<ContentEmailsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContentEmailsMaxOrderBy>;
  min?: InputMaybe<ContentEmailsMinOrderBy>;
  stddev?: InputMaybe<ContentEmailsStddevOrderBy>;
  stddev_pop?: InputMaybe<ContentEmailsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ContentEmailsStddevSampOrderBy>;
  sum?: InputMaybe<ContentEmailsSumOrderBy>;
  var_pop?: InputMaybe<ContentEmailsVarPopOrderBy>;
  var_samp?: InputMaybe<ContentEmailsVarSampOrderBy>;
  variance?: InputMaybe<ContentEmailsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContentEmailsAppendInput = {
  external_provider_metadata?: InputMaybe<Scalars['jsonb']>;
  generate_input?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ContentEmailsAvgFields = {
  __typename?: 'content_emails_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "content_emails" */
export type ContentEmailsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "content_emails". All fields are combined with a logical 'AND'. */
export type ContentEmailsBoolExp = {
  _and?: InputMaybe<Array<ContentEmailsBoolExp>>;
  _not?: InputMaybe<ContentEmailsBoolExp>;
  _or?: InputMaybe<Array<ContentEmailsBoolExp>>;
  artifact_id?: InputMaybe<UuidComparisonExp>;
  brand_profile_assignments?: InputMaybe<BrandProfileContentEmailsBoolExp>;
  brand_profile_assignments_aggregate?: InputMaybe<BrandProfileContentEmailsAggregateBoolExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  component_type?: InputMaybe<StringComparisonExp>;
  content_dynamic_slot_usages?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateBoolExp>;
  content_email_message_links?: InputMaybe<ContentEmailMessageLinksBoolExp>;
  content_email_message_links_aggregate?: InputMaybe<ContentEmailMessageLinksAggregateBoolExp>;
  content_email_variants?: InputMaybe<ContentEmailVariantsBoolExp>;
  content_email_variants_aggregate?: InputMaybe<ContentEmailVariantsAggregateBoolExp>;
  content_email_version?: InputMaybe<ContentEmailVersionsBoolExp>;
  content_email_versions?: InputMaybe<ContentEmailVersionsBoolExp>;
  content_email_versions_aggregate?: InputMaybe<ContentEmailVersionsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  external_provider_id?: InputMaybe<StringComparisonExp>;
  external_provider_metadata?: InputMaybe<JsonbComparisonExp>;
  external_provider_type?: InputMaybe<StringComparisonExp>;
  figma_import_drafts?: InputMaybe<FigmaImportDraftsBoolExp>;
  generate_input?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_private?: InputMaybe<BooleanComparisonExp>;
  is_template_enabled?: InputMaybe<BooleanComparisonExp>;
  lcm_message_candidate?: InputMaybe<LcmMessageCandidatesBoolExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  marketing_campaign_messages?: InputMaybe<MarketingCampaignMessagesBoolExp>;
  marketing_campaign_messages_aggregate?: InputMaybe<MarketingCampaignMessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  variant_llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  variant_llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  version_id?: InputMaybe<UuidComparisonExp>;
  versions?: InputMaybe<ContentEmailVersionsBoolExp>;
  versions_aggregate?: InputMaybe<ContentEmailVersionsAggregateBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContentEmailsDeleteAtPathInput = {
  external_provider_metadata?: InputMaybe<Array<Scalars['String']>>;
  generate_input?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContentEmailsDeleteElemInput = {
  external_provider_metadata?: InputMaybe<Scalars['Int']>;
  generate_input?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContentEmailsDeleteKeyInput = {
  external_provider_metadata?: InputMaybe<Scalars['String']>;
  generate_input?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContentEmailsMaxFields = {
  __typename?: 'content_emails_max_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  component_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  external_provider_id?: Maybe<Scalars['String']>;
  external_provider_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  variant_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "content_emails" */
export type ContentEmailsMaxOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  component_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_provider_id?: InputMaybe<OrderBy>;
  external_provider_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  variant_llm_chat_session_id?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContentEmailsMinFields = {
  __typename?: 'content_emails_min_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  component_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  external_provider_id?: Maybe<Scalars['String']>;
  external_provider_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  variant_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "content_emails" */
export type ContentEmailsMinOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  component_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_provider_id?: InputMaybe<OrderBy>;
  external_provider_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  variant_llm_chat_session_id?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "content_emails" */
export type ContentEmailsMutationResponse = {
  __typename?: 'content_emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentEmails>;
};

/** Ordering options when selecting data from "content_emails". */
export type ContentEmailsOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  brand_profile_assignments_aggregate?: InputMaybe<BrandProfileContentEmailsAggregateOrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  component_type?: InputMaybe<OrderBy>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateOrderBy>;
  content_email_message_links_aggregate?: InputMaybe<ContentEmailMessageLinksAggregateOrderBy>;
  content_email_variants_aggregate?: InputMaybe<ContentEmailVariantsAggregateOrderBy>;
  content_email_version?: InputMaybe<ContentEmailVersionsOrderBy>;
  content_email_versions_aggregate?: InputMaybe<ContentEmailVersionsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_provider_id?: InputMaybe<OrderBy>;
  external_provider_metadata?: InputMaybe<OrderBy>;
  external_provider_type?: InputMaybe<OrderBy>;
  figma_import_drafts_aggregate?: InputMaybe<FigmaImportDraftsAggregateOrderBy>;
  generate_input?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_private?: InputMaybe<OrderBy>;
  is_template_enabled?: InputMaybe<OrderBy>;
  lcm_message_candidate?: InputMaybe<LcmMessageCandidatesOrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  marketing_campaign_messages_aggregate?: InputMaybe<MarketingCampaignMessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  variant_llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  variant_llm_chat_session_id?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  versions_aggregate?: InputMaybe<ContentEmailVersionsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_emails */
export type ContentEmailsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContentEmailsPrependInput = {
  external_provider_metadata?: InputMaybe<Scalars['jsonb']>;
  generate_input?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "content_emails" */
export const ContentEmailsSelectColumn = {
  /** column name */
  ArtifactId: 'artifact_id',
  /** column name */
  ComponentType: 'component_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Description: 'description',
  /** column name */
  ExternalProviderId: 'external_provider_id',
  /** column name */
  ExternalProviderMetadata: 'external_provider_metadata',
  /** column name */
  ExternalProviderType: 'external_provider_type',
  /** column name */
  GenerateInput: 'generate_input',
  /** column name */
  Id: 'id',
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  IsTemplateEnabled: 'is_template_enabled',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  Source: 'source',
  /** column name */
  Status: 'status',
  /** column name */
  Subject: 'subject',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VariantLlmChatSessionId: 'variant_llm_chat_session_id',
  /** column name */
  VersionId: 'version_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentEmailsSelectColumn = typeof ContentEmailsSelectColumn[keyof typeof ContentEmailsSelectColumn];
/** select "content_emails_aggregate_bool_exp_bool_and_arguments_columns" columns of table "content_emails" */
export const ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  IsTemplateEnabled: 'is_template_enabled'
} as const;

export type ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolAndArgumentsColumns = typeof ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolAndArgumentsColumns];
/** select "content_emails_aggregate_bool_exp_bool_or_arguments_columns" columns of table "content_emails" */
export const ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  IsTemplateEnabled: 'is_template_enabled'
} as const;

export type ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolOrArgumentsColumns = typeof ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof ContentEmailsSelectColumnContentEmailsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "content_emails" */
export type ContentEmailsSetInput = {
  component_type?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  external_provider_metadata?: InputMaybe<Scalars['jsonb']>;
  generate_input?: InputMaybe<Scalars['jsonb']>;
  is_template_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  version_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type ContentEmailsStddevFields = {
  __typename?: 'content_emails_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "content_emails" */
export type ContentEmailsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ContentEmailsStddevPopFields = {
  __typename?: 'content_emails_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "content_emails" */
export type ContentEmailsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ContentEmailsStddevSampFields = {
  __typename?: 'content_emails_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "content_emails" */
export type ContentEmailsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "content_emails" */
export type ContentEmailsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentEmailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentEmailsStreamCursorValueInput = {
  artifact_id?: InputMaybe<Scalars['uuid']>;
  component_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  external_provider_id?: InputMaybe<Scalars['String']>;
  external_provider_metadata?: InputMaybe<Scalars['jsonb']>;
  external_provider_type?: InputMaybe<Scalars['String']>;
  generate_input?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  is_template_enabled?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  variant_llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  version_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentEmailsSumFields = {
  __typename?: 'content_emails_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "content_emails" */
export type ContentEmailsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type ContentEmailsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContentEmailsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ContentEmailsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ContentEmailsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ContentEmailsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContentEmailsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentEmailsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentEmailsBoolExp;
};

/** aggregate var_pop on columns */
export type ContentEmailsVarPopFields = {
  __typename?: 'content_emails_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "content_emails" */
export type ContentEmailsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ContentEmailsVarSampFields = {
  __typename?: 'content_emails_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "content_emails" */
export type ContentEmailsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ContentEmailsVarianceFields = {
  __typename?: 'content_emails_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "content_emails" */
export type ContentEmailsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "content_settings" */
export type ContentSettings = {
  __typename?: 'content_settings';
  brand_guidelines?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  custom_guidance?: Maybe<Scalars['String']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  default_esp_destination_id?: Maybe<Scalars['bigint']>;
  email_best_practices?: Maybe<Scalars['jsonb']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  prefers_external_image_urls: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "content_settings" */
export type ContentSettingsBrandGuidelinesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "content_settings" */
export type ContentSettingsEmailBestPracticesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "content_settings" */
export type ContentSettingsAggregate = {
  __typename?: 'content_settings_aggregate';
  aggregate?: Maybe<ContentSettingsAggregateFields>;
  nodes: Array<ContentSettings>;
};

/** aggregate fields of "content_settings" */
export type ContentSettingsAggregateFields = {
  __typename?: 'content_settings_aggregate_fields';
  avg?: Maybe<ContentSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentSettingsMaxFields>;
  min?: Maybe<ContentSettingsMinFields>;
  stddev?: Maybe<ContentSettingsStddevFields>;
  stddev_pop?: Maybe<ContentSettingsStddevPopFields>;
  stddev_samp?: Maybe<ContentSettingsStddevSampFields>;
  sum?: Maybe<ContentSettingsSumFields>;
  var_pop?: Maybe<ContentSettingsVarPopFields>;
  var_samp?: Maybe<ContentSettingsVarSampFields>;
  variance?: Maybe<ContentSettingsVarianceFields>;
};


/** aggregate fields of "content_settings" */
export type ContentSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ContentSettingsAppendInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ContentSettingsAvgFields = {
  __typename?: 'content_settings_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_settings". All fields are combined with a logical 'AND'. */
export type ContentSettingsBoolExp = {
  _and?: InputMaybe<Array<ContentSettingsBoolExp>>;
  _not?: InputMaybe<ContentSettingsBoolExp>;
  _or?: InputMaybe<Array<ContentSettingsBoolExp>>;
  brand_guidelines?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  custom_guidance?: InputMaybe<StringComparisonExp>;
  default_assignment_source?: InputMaybe<StringComparisonExp>;
  default_esp_destination_id?: InputMaybe<BigintComparisonExp>;
  email_best_practices?: InputMaybe<JsonbComparisonExp>;
  esp_target_kind?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  prefers_external_image_urls?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_settings" */
export const ContentSettingsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ContentSettingsPkey: 'content_settings_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  ContentSettingsWorkspaceIdKey: 'content_settings_workspace_id_key'
} as const;

export type ContentSettingsConstraint = typeof ContentSettingsConstraint[keyof typeof ContentSettingsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ContentSettingsDeleteAtPathInput = {
  brand_guidelines?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ContentSettingsDeleteElemInput = {
  brand_guidelines?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ContentSettingsDeleteKeyInput = {
  brand_guidelines?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "content_settings" */
export type ContentSettingsInsertInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
  custom_guidance?: InputMaybe<Scalars['String']>;
  prefers_external_image_urls?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ContentSettingsMaxFields = {
  __typename?: 'content_settings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  custom_guidance?: Maybe<Scalars['String']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  default_esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentSettingsMinFields = {
  __typename?: 'content_settings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  custom_guidance?: Maybe<Scalars['String']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  default_esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "content_settings" */
export type ContentSettingsMutationResponse = {
  __typename?: 'content_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentSettings>;
};

/** on_conflict condition type for table "content_settings" */
export type ContentSettingsOnConflict = {
  constraint: ContentSettingsConstraint;
  update_columns?: Array<ContentSettingsUpdateColumn>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};

/** Ordering options when selecting data from "content_settings". */
export type ContentSettingsOrderBy = {
  brand_guidelines?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  custom_guidance?: InputMaybe<OrderBy>;
  default_assignment_source?: InputMaybe<OrderBy>;
  default_esp_destination_id?: InputMaybe<OrderBy>;
  email_best_practices?: InputMaybe<OrderBy>;
  esp_target_kind?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  prefers_external_image_urls?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_settings */
export type ContentSettingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ContentSettingsPrependInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "content_settings" */
export const ContentSettingsSelectColumn = {
  /** column name */
  BrandGuidelines: 'brand_guidelines',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CustomGuidance: 'custom_guidance',
  /** column name */
  DefaultAssignmentSource: 'default_assignment_source',
  /** column name */
  DefaultEspDestinationId: 'default_esp_destination_id',
  /** column name */
  EmailBestPractices: 'email_best_practices',
  /** column name */
  EspTargetKind: 'esp_target_kind',
  /** column name */
  Id: 'id',
  /** column name */
  PrefersExternalImageUrls: 'prefers_external_image_urls',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentSettingsSelectColumn = typeof ContentSettingsSelectColumn[keyof typeof ContentSettingsSelectColumn];
/** input type for updating data in table "content_settings" */
export type ContentSettingsSetInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
  custom_guidance?: InputMaybe<Scalars['String']>;
  prefers_external_image_urls?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ContentSettingsStddevFields = {
  __typename?: 'content_settings_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentSettingsStddevPopFields = {
  __typename?: 'content_settings_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentSettingsStddevSampFields = {
  __typename?: 'content_settings_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_settings" */
export type ContentSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentSettingsStreamCursorValueInput = {
  brand_guidelines?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  custom_guidance?: InputMaybe<Scalars['String']>;
  default_assignment_source?: InputMaybe<Scalars['String']>;
  default_esp_destination_id?: InputMaybe<Scalars['bigint']>;
  email_best_practices?: InputMaybe<Scalars['jsonb']>;
  esp_target_kind?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  prefers_external_image_urls?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentSettingsSumFields = {
  __typename?: 'content_settings_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  default_esp_destination_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "content_settings" */
export const ContentSettingsUpdateColumn = {
  /** column name */
  BrandGuidelines: 'brand_guidelines',
  /** column name */
  CustomGuidance: 'custom_guidance',
  /** column name */
  PrefersExternalImageUrls: 'prefers_external_image_urls'
} as const;

export type ContentSettingsUpdateColumn = typeof ContentSettingsUpdateColumn[keyof typeof ContentSettingsUpdateColumn];
export type ContentSettingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ContentSettingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ContentSettingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ContentSettingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ContentSettingsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ContentSettingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: ContentSettingsBoolExp;
};

/** aggregate var_pop on columns */
export type ContentSettingsVarPopFields = {
  __typename?: 'content_settings_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentSettingsVarSampFields = {
  __typename?: 'content_settings_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentSettingsVarianceFields = {
  __typename?: 'content_settings_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  default_esp_destination_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "content_tags" */
export type ContentTags = {
  __typename?: 'content_tags';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  possible_values?: Maybe<Array<Scalars['String']>>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_tags" */
export type ContentTagsAggregate = {
  __typename?: 'content_tags_aggregate';
  aggregate?: Maybe<ContentTagsAggregateFields>;
  nodes: Array<ContentTags>;
};

/** aggregate fields of "content_tags" */
export type ContentTagsAggregateFields = {
  __typename?: 'content_tags_aggregate_fields';
  avg?: Maybe<ContentTagsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentTagsMaxFields>;
  min?: Maybe<ContentTagsMinFields>;
  stddev?: Maybe<ContentTagsStddevFields>;
  stddev_pop?: Maybe<ContentTagsStddevPopFields>;
  stddev_samp?: Maybe<ContentTagsStddevSampFields>;
  sum?: Maybe<ContentTagsSumFields>;
  var_pop?: Maybe<ContentTagsVarPopFields>;
  var_samp?: Maybe<ContentTagsVarSampFields>;
  variance?: Maybe<ContentTagsVarianceFields>;
};


/** aggregate fields of "content_tags" */
export type ContentTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContentTagsAvgFields = {
  __typename?: 'content_tags_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_tags". All fields are combined with a logical 'AND'. */
export type ContentTagsBoolExp = {
  _and?: InputMaybe<Array<ContentTagsBoolExp>>;
  _not?: InputMaybe<ContentTagsBoolExp>;
  _or?: InputMaybe<Array<ContentTagsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  possible_values?: InputMaybe<StringArrayComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ContentTagsMaxFields = {
  __typename?: 'content_tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  possible_values?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentTagsMinFields = {
  __typename?: 'content_tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  possible_values?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "content_tags". */
export type ContentTagsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  possible_values?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "content_tags" */
export const ContentTagsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PossibleValues: 'possible_values',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentTagsSelectColumn = typeof ContentTagsSelectColumn[keyof typeof ContentTagsSelectColumn];
/** aggregate stddev on columns */
export type ContentTagsStddevFields = {
  __typename?: 'content_tags_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentTagsStddevPopFields = {
  __typename?: 'content_tags_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentTagsStddevSampFields = {
  __typename?: 'content_tags_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_tags" */
export type ContentTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentTagsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  possible_values?: InputMaybe<Array<Scalars['String']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentTagsSumFields = {
  __typename?: 'content_tags_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ContentTagsVarPopFields = {
  __typename?: 'content_tags_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentTagsVarSampFields = {
  __typename?: 'content_tags_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentTagsVarianceFields = {
  __typename?: 'content_tags_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "content_templates" */
export type ContentTemplates = {
  __typename?: 'content_templates';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  html: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "content_templates" */
export type ContentTemplatesAggregate = {
  __typename?: 'content_templates_aggregate';
  aggregate?: Maybe<ContentTemplatesAggregateFields>;
  nodes: Array<ContentTemplates>;
};

/** aggregate fields of "content_templates" */
export type ContentTemplatesAggregateFields = {
  __typename?: 'content_templates_aggregate_fields';
  avg?: Maybe<ContentTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ContentTemplatesMaxFields>;
  min?: Maybe<ContentTemplatesMinFields>;
  stddev?: Maybe<ContentTemplatesStddevFields>;
  stddev_pop?: Maybe<ContentTemplatesStddevPopFields>;
  stddev_samp?: Maybe<ContentTemplatesStddevSampFields>;
  sum?: Maybe<ContentTemplatesSumFields>;
  var_pop?: Maybe<ContentTemplatesVarPopFields>;
  var_samp?: Maybe<ContentTemplatesVarSampFields>;
  variance?: Maybe<ContentTemplatesVarianceFields>;
};


/** aggregate fields of "content_templates" */
export type ContentTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContentTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ContentTemplatesAvgFields = {
  __typename?: 'content_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "content_templates". All fields are combined with a logical 'AND'. */
export type ContentTemplatesBoolExp = {
  _and?: InputMaybe<Array<ContentTemplatesBoolExp>>;
  _not?: InputMaybe<ContentTemplatesBoolExp>;
  _or?: InputMaybe<Array<ContentTemplatesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  html?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "content_templates" */
export const ContentTemplatesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ContentTemplatesIdWorkspaceIdUnique: 'content_templates_id_workspace_id_unique',
  /** unique or primary key constraint on columns "id" */
  ContentTemplatesPkey: 'content_templates_pkey'
} as const;

export type ContentTemplatesConstraint = typeof ContentTemplatesConstraint[keyof typeof ContentTemplatesConstraint];
/** input type for inserting data into table "content_templates" */
export type ContentTemplatesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ContentTemplatesMaxFields = {
  __typename?: 'content_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ContentTemplatesMinFields = {
  __typename?: 'content_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "content_templates" */
export type ContentTemplatesMutationResponse = {
  __typename?: 'content_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ContentTemplates>;
};

/** on_conflict condition type for table "content_templates" */
export type ContentTemplatesOnConflict = {
  constraint: ContentTemplatesConstraint;
  update_columns?: Array<ContentTemplatesUpdateColumn>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};

/** Ordering options when selecting data from "content_templates". */
export type ContentTemplatesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  html?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: content_templates */
export type ContentTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "content_templates" */
export const ContentTemplatesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Html: 'html',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Subject: 'subject',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ContentTemplatesSelectColumn = typeof ContentTemplatesSelectColumn[keyof typeof ContentTemplatesSelectColumn];
/** input type for updating data in table "content_templates" */
export type ContentTemplatesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ContentTemplatesStddevFields = {
  __typename?: 'content_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ContentTemplatesStddevPopFields = {
  __typename?: 'content_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ContentTemplatesStddevSampFields = {
  __typename?: 'content_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "content_templates" */
export type ContentTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ContentTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContentTemplatesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ContentTemplatesSumFields = {
  __typename?: 'content_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "content_templates" */
export const ContentTemplatesUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Html: 'html',
  /** column name */
  Name: 'name',
  /** column name */
  Subject: 'subject'
} as const;

export type ContentTemplatesUpdateColumn = typeof ContentTemplatesUpdateColumn[keyof typeof ContentTemplatesUpdateColumn];
export type ContentTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContentTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: ContentTemplatesBoolExp;
};

/** aggregate var_pop on columns */
export type ContentTemplatesVarPopFields = {
  __typename?: 'content_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ContentTemplatesVarSampFields = {
  __typename?: 'content_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ContentTemplatesVarianceFields = {
  __typename?: 'content_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "current_report_schedule_versions" */
export type CurrentReportScheduleVersions = {
  __typename?: 'current_report_schedule_versions';
  context?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  discarded_at?: Maybe<Scalars['timestamptz']>;
  files?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  last_version_id?: Maybe<Scalars['uuid']>;
  parent_version_id?: Maybe<Scalars['uuid']>;
  prompt?: Maybe<Scalars['String']>;
  report_schedule_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version_number?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "current_report_schedule_versions" */
export type CurrentReportScheduleVersionsContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "current_report_schedule_versions" */
export type CurrentReportScheduleVersionsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "current_report_schedule_versions". All fields are combined with a logical 'AND'. */
export type CurrentReportScheduleVersionsBoolExp = {
  _and?: InputMaybe<Array<CurrentReportScheduleVersionsBoolExp>>;
  _not?: InputMaybe<CurrentReportScheduleVersionsBoolExp>;
  _or?: InputMaybe<Array<CurrentReportScheduleVersionsBoolExp>>;
  context?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  discarded_at?: InputMaybe<TimestamptzComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_version_id?: InputMaybe<UuidComparisonExp>;
  parent_version_id?: InputMaybe<UuidComparisonExp>;
  prompt?: InputMaybe<StringComparisonExp>;
  report_schedule_id?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  version_number?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "current_report_schedule_versions". */
export type CurrentReportScheduleVersionsOrderBy = {
  context?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  discarded_at?: InputMaybe<OrderBy>;
  files?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_version_id?: InputMaybe<OrderBy>;
  parent_version_id?: InputMaybe<OrderBy>;
  prompt?: InputMaybe<OrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "current_report_schedule_versions" */
export const CurrentReportScheduleVersionsSelectColumn = {
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DiscardedAt: 'discarded_at',
  /** column name */
  Files: 'files',
  /** column name */
  Id: 'id',
  /** column name */
  LastVersionId: 'last_version_id',
  /** column name */
  ParentVersionId: 'parent_version_id',
  /** column name */
  Prompt: 'prompt',
  /** column name */
  ReportScheduleId: 'report_schedule_id',
  /** column name */
  Source: 'source',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  VersionNumber: 'version_number',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CurrentReportScheduleVersionsSelectColumn = typeof CurrentReportScheduleVersionsSelectColumn[keyof typeof CurrentReportScheduleVersionsSelectColumn];
/** Streaming cursor of the table "current_report_schedule_versions" */
export type CurrentReportScheduleVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CurrentReportScheduleVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrentReportScheduleVersionsStreamCursorValueInput = {
  context?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  discarded_at?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_version_id?: InputMaybe<Scalars['uuid']>;
  parent_version_id?: InputMaybe<Scalars['uuid']>;
  prompt?: InputMaybe<Scalars['String']>;
  report_schedule_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version_number?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** ordering argument of a cursor */
export const CursorOrdering = {
  /** ascending ordering of the cursor */
  Asc: 'ASC',
  /** descending ordering of the cursor */
  Desc: 'DESC'
} as const;

export type CursorOrdering = typeof CursorOrdering[keyof typeof CursorOrdering];
/** columns and relationships of "custom_agents" */
export type CustomAgents = {
  __typename?: 'custom_agents';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  prompt: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "custom_agents" */
export type CustomAgentsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CustomAgentsAppendInput = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "custom_agents". All fields are combined with a logical 'AND'. */
export type CustomAgentsBoolExp = {
  _and?: InputMaybe<Array<CustomAgentsBoolExp>>;
  _not?: InputMaybe<CustomAgentsBoolExp>;
  _or?: InputMaybe<Array<CustomAgentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  prompt?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "custom_agents" */
export const CustomAgentsConstraint = {
  /** unique or primary key constraint on columns "id" */
  CustomAgentsPkey: 'custom_agents_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  CustomAgentsWorkspaceIdIdKey: 'custom_agents_workspace_id_id_key'
} as const;

export type CustomAgentsConstraint = typeof CustomAgentsConstraint[keyof typeof CustomAgentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CustomAgentsDeleteAtPathInput = {
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CustomAgentsDeleteElemInput = {
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CustomAgentsDeleteKeyInput = {
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "custom_agents" */
export type CustomAgentsIncInput = {
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "custom_agents" */
export type CustomAgentsInsertInput = {
  files?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "custom_agents" */
export type CustomAgentsMutationResponse = {
  __typename?: 'custom_agents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomAgents>;
};

/** input type for inserting object relation for remote table "custom_agents" */
export type CustomAgentsObjRelInsertInput = {
  data: CustomAgentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomAgentsOnConflict>;
};

/** on_conflict condition type for table "custom_agents" */
export type CustomAgentsOnConflict = {
  constraint: CustomAgentsConstraint;
  update_columns?: Array<CustomAgentsUpdateColumn>;
  where?: InputMaybe<CustomAgentsBoolExp>;
};

/** Ordering options when selecting data from "custom_agents". */
export type CustomAgentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  files?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  prompt?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_agents */
export type CustomAgentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CustomAgentsPrependInput = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "custom_agents" */
export const CustomAgentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Files: 'files',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Prompt: 'prompt',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type CustomAgentsSelectColumn = typeof CustomAgentsSelectColumn[keyof typeof CustomAgentsSelectColumn];
/** input type for updating data in table "custom_agents" */
export type CustomAgentsSetInput = {
  files?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "custom_agents" */
export type CustomAgentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CustomAgentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomAgentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "custom_agents" */
export const CustomAgentsUpdateColumn = {
  /** column name */
  Files: 'files',
  /** column name */
  Name: 'name',
  /** column name */
  Prompt: 'prompt',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type CustomAgentsUpdateColumn = typeof CustomAgentsUpdateColumn[keyof typeof CustomAgentsUpdateColumn];
export type CustomAgentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CustomAgentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CustomAgentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CustomAgentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CustomAgentsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomAgentsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CustomAgentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomAgentsSetInput>;
  /** filter the rows which have to be updated */
  where: CustomAgentsBoolExp;
};

/** columns and relationships of "dashboards" */
export type Dashboards = {
  __typename?: 'dashboards';
  /** An object relationship */
  analytics_report?: Maybe<AnalyticsReports>;
  /** An array relationship */
  audience_overviews: Array<AudienceOverviews>;
  /** An aggregate relationship */
  audience_overviews_aggregate: AudienceOverviewsAggregate;
  /** An array relationship */
  chart_cards: Array<ChartCards>;
  cohort_filter?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  layout: Scalars['jsonb'];
  lookback_window?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  organization_id: Scalars['bigint'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  use_sampled_models?: Maybe<Scalars['Boolean']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "dashboards" */
export type DashboardsAudienceOverviewsArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


/** columns and relationships of "dashboards" */
export type DashboardsAudienceOverviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


/** columns and relationships of "dashboards" */
export type DashboardsChartCardsArgs = {
  distinct_on?: InputMaybe<Array<ChartCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChartCardsOrderBy>>;
  where?: InputMaybe<ChartCardsBoolExp>;
};


/** columns and relationships of "dashboards" */
export type DashboardsCohortFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dashboards" */
export type DashboardsLayoutArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dashboards" */
export type DashboardsLookbackWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "dashboards" */
export type DashboardsAggregate = {
  __typename?: 'dashboards_aggregate';
  aggregate?: Maybe<DashboardsAggregateFields>;
  nodes: Array<Dashboards>;
};

/** aggregate fields of "dashboards" */
export type DashboardsAggregateFields = {
  __typename?: 'dashboards_aggregate_fields';
  avg?: Maybe<DashboardsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DashboardsMaxFields>;
  min?: Maybe<DashboardsMinFields>;
  stddev?: Maybe<DashboardsStddevFields>;
  stddev_pop?: Maybe<DashboardsStddevPopFields>;
  stddev_samp?: Maybe<DashboardsStddevSampFields>;
  sum?: Maybe<DashboardsSumFields>;
  var_pop?: Maybe<DashboardsVarPopFields>;
  var_samp?: Maybe<DashboardsVarSampFields>;
  variance?: Maybe<DashboardsVarianceFields>;
};


/** aggregate fields of "dashboards" */
export type DashboardsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DashboardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DashboardsAppendInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  layout?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type DashboardsAvgFields = {
  __typename?: 'dashboards_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dashboards". All fields are combined with a logical 'AND'. */
export type DashboardsBoolExp = {
  _and?: InputMaybe<Array<DashboardsBoolExp>>;
  _not?: InputMaybe<DashboardsBoolExp>;
  _or?: InputMaybe<Array<DashboardsBoolExp>>;
  analytics_report?: InputMaybe<AnalyticsReportsBoolExp>;
  audience_overviews?: InputMaybe<AudienceOverviewsBoolExp>;
  audience_overviews_aggregate?: InputMaybe<AudienceOverviewsAggregateBoolExp>;
  chart_cards?: InputMaybe<ChartCardsBoolExp>;
  cohort_filter?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  layout?: InputMaybe<JsonbComparisonExp>;
  lookback_window?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  use_sampled_models?: InputMaybe<BooleanComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "dashboards" */
export const DashboardsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DashboardsIdWorkspaceIdKey: 'dashboards_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DashboardsPkey: 'dashboards_pkey'
} as const;

export type DashboardsConstraint = typeof DashboardsConstraint[keyof typeof DashboardsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DashboardsDeleteAtPathInput = {
  cohort_filter?: InputMaybe<Array<Scalars['String']>>;
  layout?: InputMaybe<Array<Scalars['String']>>;
  lookback_window?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DashboardsDeleteElemInput = {
  cohort_filter?: InputMaybe<Scalars['Int']>;
  layout?: InputMaybe<Scalars['Int']>;
  lookback_window?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DashboardsDeleteKeyInput = {
  cohort_filter?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['String']>;
  lookback_window?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "dashboards" */
export type DashboardsInsertInput = {
  analytics_report?: InputMaybe<AnalyticsReportsObjRelInsertInput>;
  audience_overviews?: InputMaybe<AudienceOverviewsArrRelInsertInput>;
  chart_cards?: InputMaybe<ChartCardsArrRelInsertInput>;
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  use_sampled_models?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type DashboardsMaxFields = {
  __typename?: 'dashboards_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DashboardsMinFields = {
  __typename?: 'dashboards_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "dashboards" */
export type DashboardsMutationResponse = {
  __typename?: 'dashboards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dashboards>;
};

/** input type for inserting object relation for remote table "dashboards" */
export type DashboardsObjRelInsertInput = {
  data: DashboardsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DashboardsOnConflict>;
};

/** on_conflict condition type for table "dashboards" */
export type DashboardsOnConflict = {
  constraint: DashboardsConstraint;
  update_columns?: Array<DashboardsUpdateColumn>;
  where?: InputMaybe<DashboardsBoolExp>;
};

/** Ordering options when selecting data from "dashboards". */
export type DashboardsOrderBy = {
  analytics_report?: InputMaybe<AnalyticsReportsOrderBy>;
  audience_overviews_aggregate?: InputMaybe<AudienceOverviewsAggregateOrderBy>;
  chart_cards_aggregate?: InputMaybe<ChartCardsAggregateOrderBy>;
  cohort_filter?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  layout?: InputMaybe<OrderBy>;
  lookback_window?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  use_sampled_models?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: dashboards */
export type DashboardsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DashboardsPrependInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  layout?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "dashboards" */
export const DashboardsSelectColumn = {
  /** column name */
  CohortFilter: 'cohort_filter',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Layout: 'layout',
  /** column name */
  LookbackWindow: 'lookback_window',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UseSampledModels: 'use_sampled_models',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DashboardsSelectColumn = typeof DashboardsSelectColumn[keyof typeof DashboardsSelectColumn];
/** input type for updating data in table "dashboards" */
export type DashboardsSetInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  use_sampled_models?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type DashboardsStddevFields = {
  __typename?: 'dashboards_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DashboardsStddevPopFields = {
  __typename?: 'dashboards_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DashboardsStddevSampFields = {
  __typename?: 'dashboards_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dashboards" */
export type DashboardsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DashboardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DashboardsStreamCursorValueInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  layout?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  use_sampled_models?: InputMaybe<Scalars['Boolean']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DashboardsSumFields = {
  __typename?: 'dashboards_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "dashboards" */
export const DashboardsUpdateColumn = {
  /** column name */
  CohortFilter: 'cohort_filter',
  /** column name */
  Description: 'description',
  /** column name */
  Layout: 'layout',
  /** column name */
  LookbackWindow: 'lookback_window',
  /** column name */
  Name: 'name',
  /** column name */
  UseSampledModels: 'use_sampled_models'
} as const;

export type DashboardsUpdateColumn = typeof DashboardsUpdateColumn[keyof typeof DashboardsUpdateColumn];
export type DashboardsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DashboardsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DashboardsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DashboardsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DashboardsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DashboardsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DashboardsSetInput>;
  /** filter the rows which have to be updated */
  where: DashboardsBoolExp;
};

/** aggregate var_pop on columns */
export type DashboardsVarPopFields = {
  __typename?: 'dashboards_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DashboardsVarSampFields = {
  __typename?: 'dashboards_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DashboardsVarianceFields = {
  __typename?: 'dashboards_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "datadog_credentials" */
export type DatadogCredentials = {
  __typename?: 'datadog_credentials';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  site: Scalars['String'];
  workspace_id: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "datadog_credentials". All fields are combined with a logical 'AND'. */
export type DatadogCredentialsBoolExp = {
  _and?: InputMaybe<Array<DatadogCredentialsBoolExp>>;
  _not?: InputMaybe<DatadogCredentialsBoolExp>;
  _or?: InputMaybe<Array<DatadogCredentialsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  site?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "datadog_credentials" */
export const DatadogCredentialsConstraint = {
  /** unique or primary key constraint on columns "id" */
  DatadogCredentialsPkey: 'datadog_credentials_pkey'
} as const;

export type DatadogCredentialsConstraint = typeof DatadogCredentialsConstraint[keyof typeof DatadogCredentialsConstraint];
/** input type for inserting data into table "datadog_credentials" */
export type DatadogCredentialsInsertInput = {
  api_key?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "datadog_credentials" */
export type DatadogCredentialsMutationResponse = {
  __typename?: 'datadog_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DatadogCredentials>;
};

/** on_conflict condition type for table "datadog_credentials" */
export type DatadogCredentialsOnConflict = {
  constraint: DatadogCredentialsConstraint;
  update_columns?: Array<DatadogCredentialsUpdateColumn>;
  where?: InputMaybe<DatadogCredentialsBoolExp>;
};

/** Ordering options when selecting data from "datadog_credentials". */
export type DatadogCredentialsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  site?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: datadog_credentials */
export type DatadogCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "datadog_credentials" */
export const DatadogCredentialsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Site: 'site',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DatadogCredentialsSelectColumn = typeof DatadogCredentialsSelectColumn[keyof typeof DatadogCredentialsSelectColumn];
/** input type for updating data in table "datadog_credentials" */
export type DatadogCredentialsSetInput = {
  api_key?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "datadog_credentials" */
export type DatadogCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DatadogCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DatadogCredentialsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** update columns of table "datadog_credentials" */
export const DatadogCredentialsUpdateColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  Site: 'site'
} as const;

export type DatadogCredentialsUpdateColumn = typeof DatadogCredentialsUpdateColumn[keyof typeof DatadogCredentialsUpdateColumn];
export type DatadogCredentialsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DatadogCredentialsSetInput>;
  /** filter the rows which have to be updated */
  where: DatadogCredentialsBoolExp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "dbt_cloud_sync_config" */
export type DbtCloudSyncConfig = {
  __typename?: 'dbt_cloud_sync_config';
  account_id: Scalars['String'];
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  credentials: DbtCredentials;
  default_catalog?: Maybe<Scalars['String']>;
  default_schema?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** dbt cloud job_id */
  job_id: Scalars['String'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_id?: Maybe<Scalars['String']>;
  use_database_overrides: Scalars['Boolean'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "dbt_cloud_sync_config". All fields are combined with a logical 'AND'. */
export type DbtCloudSyncConfigBoolExp = {
  _and?: InputMaybe<Array<DbtCloudSyncConfigBoolExp>>;
  _not?: InputMaybe<DbtCloudSyncConfigBoolExp>;
  _or?: InputMaybe<Array<DbtCloudSyncConfigBoolExp>>;
  account_id?: InputMaybe<StringComparisonExp>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  credentials?: InputMaybe<DbtCredentialsBoolExp>;
  default_catalog?: InputMaybe<StringComparisonExp>;
  default_schema?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_id?: InputMaybe<StringComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_id?: InputMaybe<StringComparisonExp>;
  use_database_overrides?: InputMaybe<BooleanComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "dbt_cloud_sync_config" */
export const DbtCloudSyncConfigConstraint = {
  /** unique or primary key constraint on columns "connection_id", "account_id", "job_id" */
  DbtCloudSyncConfigAccountIdJobIdConnectionIdKey: 'dbt_cloud_sync_config_account_id_job_id_connection_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DbtCloudSyncConfigIdWorkspaceIdKey: 'dbt_cloud_sync_config_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DbtCloudSyncConfigPkey: 'dbt_cloud_sync_config_pkey'
} as const;

export type DbtCloudSyncConfigConstraint = typeof DbtCloudSyncConfigConstraint[keyof typeof DbtCloudSyncConfigConstraint];
/** input type for incrementing numeric columns in table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigIncInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigInsertInput = {
  account_id?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  dbt_credentials_id?: InputMaybe<Scalars['bigint']>;
  default_catalog?: InputMaybe<Scalars['String']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** dbt cloud job_id */
  job_id?: InputMaybe<Scalars['String']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_id?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
};

/** response of any mutation on the table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigMutationResponse = {
  __typename?: 'dbt_cloud_sync_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DbtCloudSyncConfig>;
};

/** on_conflict condition type for table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigOnConflict = {
  constraint: DbtCloudSyncConfigConstraint;
  update_columns?: Array<DbtCloudSyncConfigUpdateColumn>;
  where?: InputMaybe<DbtCloudSyncConfigBoolExp>;
};

/** Ordering options when selecting data from "dbt_cloud_sync_config". */
export type DbtCloudSyncConfigOrderBy = {
  account_id?: InputMaybe<OrderBy>;
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  credentials?: InputMaybe<DbtCredentialsOrderBy>;
  default_catalog?: InputMaybe<OrderBy>;
  default_schema?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_id?: InputMaybe<OrderBy>;
  use_database_overrides?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: dbt_cloud_sync_config */
export type DbtCloudSyncConfigPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "dbt_cloud_sync_config" */
export const DbtCloudSyncConfigSelectColumn = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DefaultCatalog: 'default_catalog',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  JobId: 'job_id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunId: 'last_run_id',
  /** column name */
  UseDatabaseOverrides: 'use_database_overrides',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DbtCloudSyncConfigSelectColumn = typeof DbtCloudSyncConfigSelectColumn[keyof typeof DbtCloudSyncConfigSelectColumn];
/** input type for updating data in table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigSetInput = {
  account_id?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  default_catalog?: InputMaybe<Scalars['String']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** dbt cloud job_id */
  job_id?: InputMaybe<Scalars['String']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_id?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "dbt_cloud_sync_config" */
export type DbtCloudSyncConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DbtCloudSyncConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbtCloudSyncConfigStreamCursorValueInput = {
  account_id?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  default_catalog?: InputMaybe<Scalars['String']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** dbt cloud job_id */
  job_id?: InputMaybe<Scalars['String']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_id?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "dbt_cloud_sync_config" */
export const DbtCloudSyncConfigUpdateColumn = {
  /** column name */
  AccountId: 'account_id',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  DefaultCatalog: 'default_catalog',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  JobId: 'job_id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunId: 'last_run_id',
  /** column name */
  UseDatabaseOverrides: 'use_database_overrides'
} as const;

export type DbtCloudSyncConfigUpdateColumn = typeof DbtCloudSyncConfigUpdateColumn[keyof typeof DbtCloudSyncConfigUpdateColumn];
export type DbtCloudSyncConfigUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DbtCloudSyncConfigIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DbtCloudSyncConfigSetInput>;
  /** filter the rows which have to be updated */
  where: DbtCloudSyncConfigBoolExp;
};

/** columns and relationships of "dbt_cloud_webhooks" */
export type DbtCloudWebhooks = {
  __typename?: 'dbt_cloud_webhooks';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  credentials: DbtCredentials;
  /** dbt cloud webhook id */
  dbt_cloud_id?: Maybe<Scalars['String']>;
  dbt_credentials_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** An object relationship */
  incoming_webhook: IncomingWebhooks;
  incoming_webhook_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "dbt_cloud_webhooks". All fields are combined with a logical 'AND'. */
export type DbtCloudWebhooksBoolExp = {
  _and?: InputMaybe<Array<DbtCloudWebhooksBoolExp>>;
  _not?: InputMaybe<DbtCloudWebhooksBoolExp>;
  _or?: InputMaybe<Array<DbtCloudWebhooksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  credentials?: InputMaybe<DbtCredentialsBoolExp>;
  dbt_cloud_id?: InputMaybe<StringComparisonExp>;
  dbt_credentials_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  incoming_webhook?: InputMaybe<IncomingWebhooksBoolExp>;
  incoming_webhook_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "dbt_cloud_webhooks". */
export type DbtCloudWebhooksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  credentials?: InputMaybe<DbtCredentialsOrderBy>;
  dbt_cloud_id?: InputMaybe<OrderBy>;
  dbt_credentials_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  incoming_webhook?: InputMaybe<IncomingWebhooksOrderBy>;
  incoming_webhook_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "dbt_cloud_webhooks" */
export const DbtCloudWebhooksSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DbtCloudId: 'dbt_cloud_id',
  /** column name */
  DbtCredentialsId: 'dbt_credentials_id',
  /** column name */
  Id: 'id',
  /** column name */
  IncomingWebhookId: 'incoming_webhook_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DbtCloudWebhooksSelectColumn = typeof DbtCloudWebhooksSelectColumn[keyof typeof DbtCloudWebhooksSelectColumn];
/** Streaming cursor of the table "dbt_cloud_webhooks" */
export type DbtCloudWebhooksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DbtCloudWebhooksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbtCloudWebhooksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** dbt cloud webhook id */
  dbt_cloud_id?: InputMaybe<Scalars['String']>;
  dbt_credentials_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  incoming_webhook_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "dbt_credentials" */
export type DbtCredentials = {
  __typename?: 'dbt_credentials';
  account_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  subdomain?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
};


/** columns and relationships of "dbt_credentials" */
export type DbtCredentialsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dbt_credentials". All fields are combined with a logical 'AND'. */
export type DbtCredentialsBoolExp = {
  _and?: InputMaybe<Array<DbtCredentialsBoolExp>>;
  _not?: InputMaybe<DbtCredentialsBoolExp>;
  _or?: InputMaybe<Array<DbtCredentialsBoolExp>>;
  account_url?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  subdomain?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
};

/** Ordering options when selecting data from "dbt_credentials". */
export type DbtCredentialsOrderBy = {
  account_url?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  subdomain?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
};

/** select columns of table "dbt_credentials" */
export const DbtCredentialsSelectColumn = {
  /** column name */
  AccountUrl: 'account_url',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Subdomain: 'subdomain',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DbtCredentialsSelectColumn = typeof DbtCredentialsSelectColumn[keyof typeof DbtCredentialsSelectColumn];
/** Streaming cursor of the table "dbt_credentials" */
export type DbtCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DbtCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbtCredentialsStreamCursorValueInput = {
  account_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  subdomain?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfig = {
  __typename?: 'dbt_sync_config';
  branch: Scalars['String'];
  checks_enabled?: Maybe<Scalars['Boolean']>;
  commit?: Maybe<Scalars['String']>;
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  default_schema: Scalars['String'];
  enabled: Scalars['Boolean'];
  env_vars?: Maybe<Scalars['jsonb']>;
  error?: Maybe<Scalars['jsonb']>;
  exposure_sync_branch?: Maybe<Scalars['String']>;
  exposure_sync_enabled?: Maybe<Scalars['Boolean']>;
  exposure_sync_error?: Maybe<Scalars['jsonb']>;
  exposure_sync_last_run_at?: Maybe<Scalars['timestamptz']>;
  exposure_sync_path?: Maybe<Scalars['String']>;
  failed_attempts: Scalars['Int'];
  full_resync?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  git_credentials: GitCredentials;
  git_credentials_id: Scalars['bigint'];
  id: Scalars['bigint'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  metadata?: Maybe<Scalars['jsonb']>;
  path?: Maybe<Scalars['String']>;
  repository?: Maybe<Scalars['String']>;
  selector?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['jsonb']>;
  target?: Maybe<Scalars['String']>;
  use_database_overrides?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigEnvVarsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigExposureSyncErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dbt_sync_config" */
export type DbtSyncConfigStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DbtSyncConfigAppendInput = {
  env_vars?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_error?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "dbt_sync_config". All fields are combined with a logical 'AND'. */
export type DbtSyncConfigBoolExp = {
  _and?: InputMaybe<Array<DbtSyncConfigBoolExp>>;
  _not?: InputMaybe<DbtSyncConfigBoolExp>;
  _or?: InputMaybe<Array<DbtSyncConfigBoolExp>>;
  branch?: InputMaybe<StringComparisonExp>;
  checks_enabled?: InputMaybe<BooleanComparisonExp>;
  commit?: InputMaybe<StringComparisonExp>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  default_schema?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  env_vars?: InputMaybe<JsonbComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  exposure_sync_branch?: InputMaybe<StringComparisonExp>;
  exposure_sync_enabled?: InputMaybe<BooleanComparisonExp>;
  exposure_sync_error?: InputMaybe<JsonbComparisonExp>;
  exposure_sync_last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  exposure_sync_path?: InputMaybe<StringComparisonExp>;
  failed_attempts?: InputMaybe<IntComparisonExp>;
  full_resync?: InputMaybe<BooleanComparisonExp>;
  git_credentials?: InputMaybe<GitCredentialsBoolExp>;
  git_credentials_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  repository?: InputMaybe<StringComparisonExp>;
  selector?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  target?: InputMaybe<StringComparisonExp>;
  use_database_overrides?: InputMaybe<BooleanComparisonExp>;
  version?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "dbt_sync_config" */
export const DbtSyncConfigConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DbtSyncConfigIdWorkspaceIdKey: 'dbt_sync_config_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DbtSyncConfigPkey: 'dbt_sync_config_pkey'
} as const;

export type DbtSyncConfigConstraint = typeof DbtSyncConfigConstraint[keyof typeof DbtSyncConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DbtSyncConfigDeleteAtPathInput = {
  env_vars?: InputMaybe<Array<Scalars['String']>>;
  error?: InputMaybe<Array<Scalars['String']>>;
  exposure_sync_error?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DbtSyncConfigDeleteElemInput = {
  env_vars?: InputMaybe<Scalars['Int']>;
  error?: InputMaybe<Scalars['Int']>;
  exposure_sync_error?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DbtSyncConfigDeleteKeyInput = {
  env_vars?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  exposure_sync_error?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "dbt_sync_config" */
export type DbtSyncConfigIncInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  failed_attempts?: InputMaybe<Scalars['Int']>;
  git_credentials_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "dbt_sync_config" */
export type DbtSyncConfigInsertInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  commit?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  env_vars?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_branch?: InputMaybe<Scalars['String']>;
  exposure_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  exposure_sync_last_run_at?: InputMaybe<Scalars['timestamptz']>;
  exposure_sync_path?: InputMaybe<Scalars['String']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  git_credentials_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "dbt_sync_config" */
export type DbtSyncConfigMutationResponse = {
  __typename?: 'dbt_sync_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DbtSyncConfig>;
};

/** on_conflict condition type for table "dbt_sync_config" */
export type DbtSyncConfigOnConflict = {
  constraint: DbtSyncConfigConstraint;
  update_columns?: Array<DbtSyncConfigUpdateColumn>;
  where?: InputMaybe<DbtSyncConfigBoolExp>;
};

/** Ordering options when selecting data from "dbt_sync_config". */
export type DbtSyncConfigOrderBy = {
  branch?: InputMaybe<OrderBy>;
  checks_enabled?: InputMaybe<OrderBy>;
  commit?: InputMaybe<OrderBy>;
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  default_schema?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  env_vars?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exposure_sync_branch?: InputMaybe<OrderBy>;
  exposure_sync_enabled?: InputMaybe<OrderBy>;
  exposure_sync_error?: InputMaybe<OrderBy>;
  exposure_sync_last_run_at?: InputMaybe<OrderBy>;
  exposure_sync_path?: InputMaybe<OrderBy>;
  failed_attempts?: InputMaybe<OrderBy>;
  full_resync?: InputMaybe<OrderBy>;
  git_credentials?: InputMaybe<GitCredentialsOrderBy>;
  git_credentials_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  repository?: InputMaybe<OrderBy>;
  selector?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  target?: InputMaybe<OrderBy>;
  use_database_overrides?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: dbt_sync_config */
export type DbtSyncConfigPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DbtSyncConfigPrependInput = {
  env_vars?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_error?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "dbt_sync_config" */
export const DbtSyncConfigSelectColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  ChecksEnabled: 'checks_enabled',
  /** column name */
  Commit: 'commit',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnvVars: 'env_vars',
  /** column name */
  Error: 'error',
  /** column name */
  ExposureSyncBranch: 'exposure_sync_branch',
  /** column name */
  ExposureSyncEnabled: 'exposure_sync_enabled',
  /** column name */
  ExposureSyncError: 'exposure_sync_error',
  /** column name */
  ExposureSyncLastRunAt: 'exposure_sync_last_run_at',
  /** column name */
  ExposureSyncPath: 'exposure_sync_path',
  /** column name */
  FailedAttempts: 'failed_attempts',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  GitCredentialsId: 'git_credentials_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  Selector: 'selector',
  /** column name */
  State: 'state',
  /** column name */
  Target: 'target',
  /** column name */
  UseDatabaseOverrides: 'use_database_overrides',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DbtSyncConfigSelectColumn = typeof DbtSyncConfigSelectColumn[keyof typeof DbtSyncConfigSelectColumn];
/** input type for updating data in table "dbt_sync_config" */
export type DbtSyncConfigSetInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  commit?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  env_vars?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_branch?: InputMaybe<Scalars['String']>;
  exposure_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  exposure_sync_error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_last_run_at?: InputMaybe<Scalars['timestamptz']>;
  exposure_sync_path?: InputMaybe<Scalars['String']>;
  failed_attempts?: InputMaybe<Scalars['Int']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  git_credentials_id?: InputMaybe<Scalars['bigint']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "dbt_sync_config" */
export type DbtSyncConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DbtSyncConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbtSyncConfigStreamCursorValueInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  commit?: InputMaybe<Scalars['String']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  default_schema?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  env_vars?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_branch?: InputMaybe<Scalars['String']>;
  exposure_sync_enabled?: InputMaybe<Scalars['Boolean']>;
  exposure_sync_error?: InputMaybe<Scalars['jsonb']>;
  exposure_sync_last_run_at?: InputMaybe<Scalars['timestamptz']>;
  exposure_sync_path?: InputMaybe<Scalars['String']>;
  failed_attempts?: InputMaybe<Scalars['Int']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  git_credentials_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  selector?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['jsonb']>;
  target?: InputMaybe<Scalars['String']>;
  use_database_overrides?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "dbt_sync_config" */
export const DbtSyncConfigUpdateColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  ChecksEnabled: 'checks_enabled',
  /** column name */
  Commit: 'commit',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  DefaultSchema: 'default_schema',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnvVars: 'env_vars',
  /** column name */
  Error: 'error',
  /** column name */
  ExposureSyncBranch: 'exposure_sync_branch',
  /** column name */
  ExposureSyncEnabled: 'exposure_sync_enabled',
  /** column name */
  ExposureSyncError: 'exposure_sync_error',
  /** column name */
  ExposureSyncLastRunAt: 'exposure_sync_last_run_at',
  /** column name */
  ExposureSyncPath: 'exposure_sync_path',
  /** column name */
  FailedAttempts: 'failed_attempts',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  GitCredentialsId: 'git_credentials_id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  Selector: 'selector',
  /** column name */
  Target: 'target',
  /** column name */
  UseDatabaseOverrides: 'use_database_overrides',
  /** column name */
  Version: 'version'
} as const;

export type DbtSyncConfigUpdateColumn = typeof DbtSyncConfigUpdateColumn[keyof typeof DbtSyncConfigUpdateColumn];
export type DbtSyncConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DbtSyncConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DbtSyncConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DbtSyncConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DbtSyncConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DbtSyncConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DbtSyncConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DbtSyncConfigSetInput>;
  /** filter the rows which have to be updated */
  where: DbtSyncConfigBoolExp;
};

/** columns and relationships of "dbt_sync_models" */
export type DbtSyncModels = {
  __typename?: 'dbt_sync_models';
  data: Scalars['jsonb'];
  /** An object relationship */
  dbt_cloud_sync_config?: Maybe<DbtCloudSyncConfig>;
  /** An object relationship */
  dbt_sync_config?: Maybe<DbtSyncConfig>;
  dbt_sync_config_id?: Maybe<Scalars['bigint']>;
  dbt_unique_id: Scalars['String'];
  id: Scalars['bigint'];
  last_commit_synced?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  removed: Scalars['Boolean'];
  schema: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "dbt_sync_models" */
export type DbtSyncModelsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "dbt_sync_models". All fields are combined with a logical 'AND'. */
export type DbtSyncModelsBoolExp = {
  _and?: InputMaybe<Array<DbtSyncModelsBoolExp>>;
  _not?: InputMaybe<DbtSyncModelsBoolExp>;
  _or?: InputMaybe<Array<DbtSyncModelsBoolExp>>;
  data?: InputMaybe<JsonbComparisonExp>;
  dbt_cloud_sync_config?: InputMaybe<DbtCloudSyncConfigBoolExp>;
  dbt_sync_config?: InputMaybe<DbtSyncConfigBoolExp>;
  dbt_sync_config_id?: InputMaybe<BigintComparisonExp>;
  dbt_unique_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_commit_synced?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  removed?: InputMaybe<BooleanComparisonExp>;
  schema?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "dbt_sync_models". */
export type DbtSyncModelsOrderBy = {
  data?: InputMaybe<OrderBy>;
  dbt_cloud_sync_config?: InputMaybe<DbtCloudSyncConfigOrderBy>;
  dbt_sync_config?: InputMaybe<DbtSyncConfigOrderBy>;
  dbt_sync_config_id?: InputMaybe<OrderBy>;
  dbt_unique_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_commit_synced?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  removed?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "dbt_sync_models" */
export const DbtSyncModelsSelectColumn = {
  /** column name */
  Data: 'data',
  /** column name */
  DbtSyncConfigId: 'dbt_sync_config_id',
  /** column name */
  DbtUniqueId: 'dbt_unique_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastCommitSynced: 'last_commit_synced',
  /** column name */
  Name: 'name',
  /** column name */
  Removed: 'removed',
  /** column name */
  Schema: 'schema',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DbtSyncModelsSelectColumn = typeof DbtSyncModelsSelectColumn[keyof typeof DbtSyncModelsSelectColumn];
/** Streaming cursor of the table "dbt_sync_models" */
export type DbtSyncModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DbtSyncModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbtSyncModelsStreamCursorValueInput = {
  data?: InputMaybe<Scalars['jsonb']>;
  dbt_sync_config_id?: InputMaybe<Scalars['bigint']>;
  dbt_unique_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_commit_synced?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  removed?: InputMaybe<Scalars['Boolean']>;
  schema?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMemberships = {
  __typename?: 'decision_engine_arbitration_group_memberships';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  flow: DecisionEngineFlows;
  flow_id: Scalars['uuid'];
  flow_weight: Scalars['float8'];
  /** An object relationship */
  group: DecisionEngineArbitrationGroups;
  group_id: Scalars['uuid'];
  id: Scalars['uuid'];
  last_packed_epoch?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsAggregate = {
  __typename?: 'decision_engine_arbitration_group_memberships_aggregate';
  aggregate?: Maybe<DecisionEngineArbitrationGroupMembershipsAggregateFields>;
  nodes: Array<DecisionEngineArbitrationGroupMemberships>;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExp = {
  avg?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvg>;
  corr?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorr>;
  count?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpMax>;
  min?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpSum>;
  var_samp?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSamp>;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvg = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorr = {
  arguments: DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArguments = {
  X: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns;
  Y: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: IntComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSamp = {
  arguments: DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArguments = {
  X: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns;
  Y: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpMax = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpMin = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSamp = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpSum = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

export type DecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSamp = {
  arguments: DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsAggregateFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_aggregate_fields';
  avg?: Maybe<DecisionEngineArbitrationGroupMembershipsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DecisionEngineArbitrationGroupMembershipsMaxFields>;
  min?: Maybe<DecisionEngineArbitrationGroupMembershipsMinFields>;
  stddev?: Maybe<DecisionEngineArbitrationGroupMembershipsStddevFields>;
  stddev_pop?: Maybe<DecisionEngineArbitrationGroupMembershipsStddevPopFields>;
  stddev_samp?: Maybe<DecisionEngineArbitrationGroupMembershipsStddevSampFields>;
  sum?: Maybe<DecisionEngineArbitrationGroupMembershipsSumFields>;
  var_pop?: Maybe<DecisionEngineArbitrationGroupMembershipsVarPopFields>;
  var_samp?: Maybe<DecisionEngineArbitrationGroupMembershipsVarSampFields>;
  variance?: Maybe<DecisionEngineArbitrationGroupMembershipsVarianceFields>;
};


/** aggregate fields of "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineArbitrationGroupMembershipsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineArbitrationGroupMembershipsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineArbitrationGroupMembershipsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineArbitrationGroupMembershipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineArbitrationGroupMembershipsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineArbitrationGroupMembershipsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineArbitrationGroupMembershipsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineArbitrationGroupMembershipsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineArbitrationGroupMembershipsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type DecisionEngineArbitrationGroupMembershipsAvgFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_avg_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsAvgOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_arbitration_group_memberships". All fields are combined with a logical 'AND'. */
export type DecisionEngineArbitrationGroupMembershipsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsBoolExp>>;
  _not?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  flow_id?: InputMaybe<UuidComparisonExp>;
  flow_weight?: InputMaybe<Float8ComparisonExp>;
  group?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
  group_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_packed_epoch?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type DecisionEngineArbitrationGroupMembershipsMaxFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flow_id?: Maybe<Scalars['uuid']>;
  flow_weight?: Maybe<Scalars['float8']>;
  group_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_packed_epoch?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  flow_weight?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DecisionEngineArbitrationGroupMembershipsMinFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flow_id?: Maybe<Scalars['uuid']>;
  flow_weight?: Maybe<Scalars['float8']>;
  group_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_packed_epoch?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  flow_weight?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_arbitration_group_memberships". */
export type DecisionEngineArbitrationGroupMembershipsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  flow_weight?: InputMaybe<OrderBy>;
  group?: InputMaybe<DecisionEngineArbitrationGroupsOrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  FlowWeight: 'flow_weight',
  /** column name */
  GroupId: 'group_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastPackedEpoch: 'last_packed_epoch',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumn = typeof DecisionEngineArbitrationGroupMembershipsSelectColumn[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumn];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_avg_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvgArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvgArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvgArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpAvgArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_corr_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCorrArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpCovarSampArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_max_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMaxArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMaxArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMaxArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMaxArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_min_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMinArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMinArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMinArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpMinArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSampArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSampArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSampArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpStddevSampArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_sum_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpSumArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpSumArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpSumArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpSumArgumentsColumns];
/** select "decision_engine_arbitration_group_memberships_aggregate_bool_exp_var_samp_arguments_columns" columns of table "decision_engine_arbitration_group_memberships" */
export const DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSampArgumentsColumns = {
  /** column name */
  FlowWeight: 'flow_weight'
} as const;

export type DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSampArgumentsColumns = typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSampArgumentsColumns[keyof typeof DecisionEngineArbitrationGroupMembershipsSelectColumnDecisionEngineArbitrationGroupMembershipsAggregateBoolExpVarSampArgumentsColumns];
/** aggregate stddev on columns */
export type DecisionEngineArbitrationGroupMembershipsStddevFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_stddev_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsStddevOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DecisionEngineArbitrationGroupMembershipsStddevPopFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_stddev_pop_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsStddevPopOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DecisionEngineArbitrationGroupMembershipsStddevSampFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_stddev_samp_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsStddevSampOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineArbitrationGroupMembershipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineArbitrationGroupMembershipsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  flow_weight?: InputMaybe<Scalars['float8']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_packed_epoch?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DecisionEngineArbitrationGroupMembershipsSumFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_sum_fields';
  flow_weight?: Maybe<Scalars['float8']>;
  last_packed_epoch?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsSumOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type DecisionEngineArbitrationGroupMembershipsVarPopFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_var_pop_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsVarPopOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DecisionEngineArbitrationGroupMembershipsVarSampFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_var_samp_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsVarSampOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DecisionEngineArbitrationGroupMembershipsVarianceFields = {
  __typename?: 'decision_engine_arbitration_group_memberships_variance_fields';
  flow_weight?: Maybe<Scalars['Float']>;
  last_packed_epoch?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "decision_engine_arbitration_group_memberships" */
export type DecisionEngineArbitrationGroupMembershipsVarianceOrderBy = {
  flow_weight?: InputMaybe<OrderBy>;
  last_packed_epoch?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroups = {
  __typename?: 'decision_engine_arbitration_groups';
  arbitration_epoch: Scalars['Int'];
  arbitration_epoch_started_at: Scalars['timestamptz'];
  config: Scalars['jsonb'];
  connection_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  memberships: Array<DecisionEngineArbitrationGroupMemberships>;
  /** An aggregate relationship */
  memberships_aggregate: DecisionEngineArbitrationGroupMembershipsAggregate;
  mode: Scalars['String'];
  name: Scalars['String'];
  primary_key?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsMembershipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


/** columns and relationships of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};

/** aggregated selection of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsAggregate = {
  __typename?: 'decision_engine_arbitration_groups_aggregate';
  aggregate?: Maybe<DecisionEngineArbitrationGroupsAggregateFields>;
  nodes: Array<DecisionEngineArbitrationGroups>;
};

/** aggregate fields of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsAggregateFields = {
  __typename?: 'decision_engine_arbitration_groups_aggregate_fields';
  avg?: Maybe<DecisionEngineArbitrationGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DecisionEngineArbitrationGroupsMaxFields>;
  min?: Maybe<DecisionEngineArbitrationGroupsMinFields>;
  stddev?: Maybe<DecisionEngineArbitrationGroupsStddevFields>;
  stddev_pop?: Maybe<DecisionEngineArbitrationGroupsStddevPopFields>;
  stddev_samp?: Maybe<DecisionEngineArbitrationGroupsStddevSampFields>;
  sum?: Maybe<DecisionEngineArbitrationGroupsSumFields>;
  var_pop?: Maybe<DecisionEngineArbitrationGroupsVarPopFields>;
  var_samp?: Maybe<DecisionEngineArbitrationGroupsVarSampFields>;
  variance?: Maybe<DecisionEngineArbitrationGroupsVarianceFields>;
};


/** aggregate fields of "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DecisionEngineArbitrationGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DecisionEngineArbitrationGroupsAvgFields = {
  __typename?: 'decision_engine_arbitration_groups_avg_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "decision_engine_arbitration_groups". All fields are combined with a logical 'AND'. */
export type DecisionEngineArbitrationGroupsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineArbitrationGroupsBoolExp>>;
  _not?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineArbitrationGroupsBoolExp>>;
  arbitration_epoch?: InputMaybe<IntComparisonExp>;
  arbitration_epoch_started_at?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  memberships?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  memberships_aggregate?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateBoolExp>;
  mode?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  primary_key?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type DecisionEngineArbitrationGroupsMaxFields = {
  __typename?: 'decision_engine_arbitration_groups_max_fields';
  arbitration_epoch?: Maybe<Scalars['Int']>;
  arbitration_epoch_started_at?: Maybe<Scalars['timestamptz']>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primary_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DecisionEngineArbitrationGroupsMinFields = {
  __typename?: 'decision_engine_arbitration_groups_min_fields';
  arbitration_epoch?: Maybe<Scalars['Int']>;
  arbitration_epoch_started_at?: Maybe<Scalars['timestamptz']>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primary_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "decision_engine_arbitration_groups". */
export type DecisionEngineArbitrationGroupsOrderBy = {
  arbitration_epoch?: InputMaybe<OrderBy>;
  arbitration_epoch_started_at?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  memberships_aggregate?: InputMaybe<DecisionEngineArbitrationGroupMembershipsAggregateOrderBy>;
  mode?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  primary_key?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_arbitration_groups" */
export const DecisionEngineArbitrationGroupsSelectColumn = {
  /** column name */
  ArbitrationEpoch: 'arbitration_epoch',
  /** column name */
  ArbitrationEpochStartedAt: 'arbitration_epoch_started_at',
  /** column name */
  Config: 'config',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Mode: 'mode',
  /** column name */
  Name: 'name',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineArbitrationGroupsSelectColumn = typeof DecisionEngineArbitrationGroupsSelectColumn[keyof typeof DecisionEngineArbitrationGroupsSelectColumn];
/** aggregate stddev on columns */
export type DecisionEngineArbitrationGroupsStddevFields = {
  __typename?: 'decision_engine_arbitration_groups_stddev_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DecisionEngineArbitrationGroupsStddevPopFields = {
  __typename?: 'decision_engine_arbitration_groups_stddev_pop_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DecisionEngineArbitrationGroupsStddevSampFields = {
  __typename?: 'decision_engine_arbitration_groups_stddev_samp_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "decision_engine_arbitration_groups" */
export type DecisionEngineArbitrationGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineArbitrationGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineArbitrationGroupsStreamCursorValueInput = {
  arbitration_epoch?: InputMaybe<Scalars['Int']>;
  arbitration_epoch_started_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primary_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DecisionEngineArbitrationGroupsSumFields = {
  __typename?: 'decision_engine_arbitration_groups_sum_fields';
  arbitration_epoch?: Maybe<Scalars['Int']>;
  connection_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type DecisionEngineArbitrationGroupsVarPopFields = {
  __typename?: 'decision_engine_arbitration_groups_var_pop_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DecisionEngineArbitrationGroupsVarSampFields = {
  __typename?: 'decision_engine_arbitration_groups_var_samp_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DecisionEngineArbitrationGroupsVarianceFields = {
  __typename?: 'decision_engine_arbitration_groups_variance_fields';
  arbitration_epoch?: Maybe<Scalars['Float']>;
  connection_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannels = {
  __typename?: 'decision_engine_channels';
  /** An array relationship */
  channel_syncs: Array<DecisionEngineFlowChannelSync>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_id: Scalars['uuid'];
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id?: Maybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  /** An array relationship */
  messages: Array<DecisionEngineMessages>;
  /** An aggregate relationship */
  messages_aggregate: DecisionEngineMessagesAggregate;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  send_event?: Maybe<DecisionEngineSendEvents>;
  send_event_id?: Maybe<Scalars['uuid']>;
  state: Scalars['jsonb'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannelsChannelSyncsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowChannelSyncSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowChannelSyncOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
};


/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannelsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannelsMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannelsMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


/** columns and relationships of "decision_engine_channels" */
export type DecisionEngineChannelsStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_channels" */
export type DecisionEngineChannelsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineChannelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineChannelsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineChannelsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineChannelsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineChannelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineChannelsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineChannelsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineChannelsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineChannelsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineChannelsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineChannelsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsAvgOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_channels". All fields are combined with a logical 'AND'. */
export type DecisionEngineChannelsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineChannelsBoolExp>>;
  _not?: InputMaybe<DecisionEngineChannelsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineChannelsBoolExp>>;
  channel_syncs?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  messages?: InputMaybe<DecisionEngineMessagesBoolExp>;
  messages_aggregate?: InputMaybe<DecisionEngineMessagesAggregateBoolExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  send_event?: InputMaybe<DecisionEngineSendEventsBoolExp>;
  send_event_id?: InputMaybe<UuidComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineChannelsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineChannelsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineChannelsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "decision_engine_channels" */
export type DecisionEngineChannelsIncInput = {
  destination_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  send_event_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  send_event_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_channels" */
export type DecisionEngineChannelsMutationResponse = {
  __typename?: 'decision_engine_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineChannels>;
};

/** Ordering options when selecting data from "decision_engine_channels". */
export type DecisionEngineChannelsOrderBy = {
  channel_syncs_aggregate?: InputMaybe<DecisionEngineFlowChannelSyncAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<DecisionEngineMessagesAggregateOrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  send_event?: InputMaybe<DecisionEngineSendEventsOrderBy>;
  send_event_id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_channels */
export type DecisionEngineChannelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineChannelsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_channels" */
export const DecisionEngineChannelsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Label: 'label',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  SendEventId: 'send_event_id',
  /** column name */
  State: 'state',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineChannelsSelectColumn = typeof DecisionEngineChannelsSelectColumn[keyof typeof DecisionEngineChannelsSelectColumn];
/** input type for updating data in table "decision_engine_channels" */
export type DecisionEngineChannelsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  send_event_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsStddevOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsStddevPopOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsStddevSampOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_channels" */
export type DecisionEngineChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineChannelsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  send_event_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsSumOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type DecisionEngineChannelsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineChannelsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineChannelsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineChannelsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineChannelsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineChannelsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineChannelsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineChannelsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsVarPopOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsVarSampOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_channels" */
export type DecisionEngineChannelsVarianceOrderBy = {
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_collections" */
export type DecisionEngineCollections = {
  __typename?: 'decision_engine_collections';
  catalog_collection_id: Scalars['uuid'];
  /** An object relationship */
  collection: CatalogCollections;
  config: Scalars['jsonb'];
  decision_engine_id: Scalars['uuid'];
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_collections" */
export type DecisionEngineCollectionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_collections" */
export type DecisionEngineCollectionsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineCollectionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineCollectionsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineCollectionsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineCollectionsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineCollectionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineCollectionsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineCollectionsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineCollectionsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineCollectionsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineCollectionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineCollectionsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "decision_engine_collections" */
export type DecisionEngineCollectionsArrRelInsertInput = {
  data: Array<DecisionEngineCollectionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineCollectionsOnConflict>;
};

/** order by avg() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_collections". All fields are combined with a logical 'AND'. */
export type DecisionEngineCollectionsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineCollectionsBoolExp>>;
  _not?: InputMaybe<DecisionEngineCollectionsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineCollectionsBoolExp>>;
  catalog_collection_id?: InputMaybe<UuidComparisonExp>;
  collection?: InputMaybe<CatalogCollectionsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_collections" */
export const DecisionEngineCollectionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  DecisionEngineCollectionsPkey: 'decision_engine_collections_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineCollectionsUniqueIdWorkspaceId: 'decision_engine_collections_unique_id_workspace_id'
} as const;

export type DecisionEngineCollectionsConstraint = typeof DecisionEngineCollectionsConstraint[keyof typeof DecisionEngineCollectionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineCollectionsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineCollectionsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineCollectionsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_collections" */
export type DecisionEngineCollectionsInsertInput = {
  catalog_collection_id?: InputMaybe<Scalars['uuid']>;
  collection?: InputMaybe<CatalogCollectionsObjRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsMaxOrderBy = {
  catalog_collection_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsMinOrderBy = {
  catalog_collection_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_collections" */
export type DecisionEngineCollectionsMutationResponse = {
  __typename?: 'decision_engine_collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineCollections>;
};

/** input type for inserting object relation for remote table "decision_engine_collections" */
export type DecisionEngineCollectionsObjRelInsertInput = {
  data: DecisionEngineCollectionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineCollectionsOnConflict>;
};

/** on_conflict condition type for table "decision_engine_collections" */
export type DecisionEngineCollectionsOnConflict = {
  constraint: DecisionEngineCollectionsConstraint;
  update_columns?: Array<DecisionEngineCollectionsUpdateColumn>;
  where?: InputMaybe<DecisionEngineCollectionsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_collections". */
export type DecisionEngineCollectionsOrderBy = {
  catalog_collection_id?: InputMaybe<OrderBy>;
  collection?: InputMaybe<CatalogCollectionsOrderBy>;
  config?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_collections */
export type DecisionEngineCollectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineCollectionsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_collections" */
export const DecisionEngineCollectionsSelectColumn = {
  /** column name */
  CatalogCollectionId: 'catalog_collection_id',
  /** column name */
  Config: 'config',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  Id: 'id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineCollectionsSelectColumn = typeof DecisionEngineCollectionsSelectColumn[keyof typeof DecisionEngineCollectionsSelectColumn];
/** input type for updating data in table "decision_engine_collections" */
export type DecisionEngineCollectionsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_collections" */
export type DecisionEngineCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineCollectionsStreamCursorValueInput = {
  catalog_collection_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_collections" */
export const DecisionEngineCollectionsUpdateColumn = {
  /** column name */
  Config: 'config'
} as const;

export type DecisionEngineCollectionsUpdateColumn = typeof DecisionEngineCollectionsUpdateColumn[keyof typeof DecisionEngineCollectionsUpdateColumn];
export type DecisionEngineCollectionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineCollectionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineCollectionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineCollectionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineCollectionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineCollectionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineCollectionsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_collections" */
export type DecisionEngineCollectionsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendations = {
  __typename?: 'decision_engine_content_recommendations';
  actioned_at?: Maybe<Scalars['timestamptz']>;
  assessed_at?: Maybe<Scalars['timestamptz']>;
  body: Scalars['String'];
  category: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dismissed_at?: Maybe<Scalars['timestamptz']>;
  extrapolated: Scalars['Boolean'];
  /** An object relationship */
  flow: DecisionEngineFlows;
  flow_id: Scalars['uuid'];
  id: Scalars['uuid'];
  inferred_action_status?: Maybe<Scalars['String']>;
  /** An object relationship */
  marketing_campaign?: Maybe<MarketingCampaigns>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  message_references: Scalars['jsonb'];
  rating?: Maybe<Scalars['String']>;
  /** An object relationship */
  report_schedule_run: ReportScheduleRuns;
  report_schedule_run_id: Scalars['uuid'];
  resulting_content: Scalars['jsonb'];
  resulting_content_summary?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_action_status?: Maybe<Scalars['String']>;
  user_action_updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsMessageReferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsResultingContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsAggregate = {
  __typename?: 'decision_engine_content_recommendations_aggregate';
  aggregate?: Maybe<DecisionEngineContentRecommendationsAggregateFields>;
  nodes: Array<DecisionEngineContentRecommendations>;
};

/** aggregate fields of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsAggregateFields = {
  __typename?: 'decision_engine_content_recommendations_aggregate_fields';
  avg?: Maybe<DecisionEngineContentRecommendationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DecisionEngineContentRecommendationsMaxFields>;
  min?: Maybe<DecisionEngineContentRecommendationsMinFields>;
  stddev?: Maybe<DecisionEngineContentRecommendationsStddevFields>;
  stddev_pop?: Maybe<DecisionEngineContentRecommendationsStddevPopFields>;
  stddev_samp?: Maybe<DecisionEngineContentRecommendationsStddevSampFields>;
  sum?: Maybe<DecisionEngineContentRecommendationsSumFields>;
  var_pop?: Maybe<DecisionEngineContentRecommendationsVarPopFields>;
  var_samp?: Maybe<DecisionEngineContentRecommendationsVarSampFields>;
  variance?: Maybe<DecisionEngineContentRecommendationsVarianceFields>;
};


/** aggregate fields of "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DecisionEngineContentRecommendationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DecisionEngineContentRecommendationsAvgFields = {
  __typename?: 'decision_engine_content_recommendations_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "decision_engine_content_recommendations". All fields are combined with a logical 'AND'. */
export type DecisionEngineContentRecommendationsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineContentRecommendationsBoolExp>>;
  _not?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineContentRecommendationsBoolExp>>;
  actioned_at?: InputMaybe<TimestamptzComparisonExp>;
  assessed_at?: InputMaybe<TimestamptzComparisonExp>;
  body?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  dismissed_at?: InputMaybe<TimestamptzComparisonExp>;
  extrapolated?: InputMaybe<BooleanComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  flow_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inferred_action_status?: InputMaybe<StringComparisonExp>;
  marketing_campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  marketing_campaign_id?: InputMaybe<UuidComparisonExp>;
  message_references?: InputMaybe<JsonbComparisonExp>;
  rating?: InputMaybe<StringComparisonExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  resulting_content?: InputMaybe<JsonbComparisonExp>;
  resulting_content_summary?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_action_status?: InputMaybe<StringComparisonExp>;
  user_action_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type DecisionEngineContentRecommendationsMaxFields = {
  __typename?: 'decision_engine_content_recommendations_max_fields';
  actioned_at?: Maybe<Scalars['timestamptz']>;
  assessed_at?: Maybe<Scalars['timestamptz']>;
  body?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dismissed_at?: Maybe<Scalars['timestamptz']>;
  flow_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  inferred_action_status?: Maybe<Scalars['String']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  resulting_content_summary?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_action_status?: Maybe<Scalars['String']>;
  user_action_updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DecisionEngineContentRecommendationsMinFields = {
  __typename?: 'decision_engine_content_recommendations_min_fields';
  actioned_at?: Maybe<Scalars['timestamptz']>;
  assessed_at?: Maybe<Scalars['timestamptz']>;
  body?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dismissed_at?: Maybe<Scalars['timestamptz']>;
  flow_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  inferred_action_status?: Maybe<Scalars['String']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  rating?: Maybe<Scalars['String']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  resulting_content_summary?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_action_status?: Maybe<Scalars['String']>;
  user_action_updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsMutationResponse = {
  __typename?: 'decision_engine_content_recommendations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineContentRecommendations>;
};

/** Ordering options when selecting data from "decision_engine_content_recommendations". */
export type DecisionEngineContentRecommendationsOrderBy = {
  actioned_at?: InputMaybe<OrderBy>;
  assessed_at?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  dismissed_at?: InputMaybe<OrderBy>;
  extrapolated?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inferred_action_status?: InputMaybe<OrderBy>;
  marketing_campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  message_references?: InputMaybe<OrderBy>;
  rating?: InputMaybe<OrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  resulting_content?: InputMaybe<OrderBy>;
  resulting_content_summary?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_action_status?: InputMaybe<OrderBy>;
  user_action_updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_content_recommendations */
export type DecisionEngineContentRecommendationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "decision_engine_content_recommendations" */
export const DecisionEngineContentRecommendationsSelectColumn = {
  /** column name */
  ActionedAt: 'actioned_at',
  /** column name */
  AssessedAt: 'assessed_at',
  /** column name */
  Body: 'body',
  /** column name */
  Category: 'category',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DismissedAt: 'dismissed_at',
  /** column name */
  Extrapolated: 'extrapolated',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  Id: 'id',
  /** column name */
  InferredActionStatus: 'inferred_action_status',
  /** column name */
  MarketingCampaignId: 'marketing_campaign_id',
  /** column name */
  MessageReferences: 'message_references',
  /** column name */
  Rating: 'rating',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  ResultingContent: 'resulting_content',
  /** column name */
  ResultingContentSummary: 'resulting_content_summary',
  /** column name */
  Status: 'status',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserActionStatus: 'user_action_status',
  /** column name */
  UserActionUpdatedAt: 'user_action_updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineContentRecommendationsSelectColumn = typeof DecisionEngineContentRecommendationsSelectColumn[keyof typeof DecisionEngineContentRecommendationsSelectColumn];
/** input type for updating data in table "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsSetInput = {
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  rating?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  user_action_status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DecisionEngineContentRecommendationsStddevFields = {
  __typename?: 'decision_engine_content_recommendations_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DecisionEngineContentRecommendationsStddevPopFields = {
  __typename?: 'decision_engine_content_recommendations_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DecisionEngineContentRecommendationsStddevSampFields = {
  __typename?: 'decision_engine_content_recommendations_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "decision_engine_content_recommendations" */
export type DecisionEngineContentRecommendationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineContentRecommendationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineContentRecommendationsStreamCursorValueInput = {
  actioned_at?: InputMaybe<Scalars['timestamptz']>;
  assessed_at?: InputMaybe<Scalars['timestamptz']>;
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dismissed_at?: InputMaybe<Scalars['timestamptz']>;
  extrapolated?: InputMaybe<Scalars['Boolean']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  inferred_action_status?: InputMaybe<Scalars['String']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  message_references?: InputMaybe<Scalars['jsonb']>;
  rating?: InputMaybe<Scalars['String']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  resulting_content?: InputMaybe<Scalars['jsonb']>;
  resulting_content_summary?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_action_status?: InputMaybe<Scalars['String']>;
  user_action_updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DecisionEngineContentRecommendationsSumFields = {
  __typename?: 'decision_engine_content_recommendations_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

export type DecisionEngineContentRecommendationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineContentRecommendationsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineContentRecommendationsBoolExp;
};

/** aggregate var_pop on columns */
export type DecisionEngineContentRecommendationsVarPopFields = {
  __typename?: 'decision_engine_content_recommendations_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DecisionEngineContentRecommendationsVarSampFields = {
  __typename?: 'decision_engine_content_recommendations_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DecisionEngineContentRecommendationsVarianceFields = {
  __typename?: 'decision_engine_content_recommendations_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatrices = {
  __typename?: 'decision_engine_feature_matrices';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_id: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  engine?: Maybe<DecisionEngines>;
  /** An array relationship */
  flows: Array<DecisionEngineFlows>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['Int'];
  /** An array relationship */
  relationships: Array<DecisionEngineFeatureMatrixRelationships>;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesFlowsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowsBoolExp>;
};


/** columns and relationships of "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
};

/** order by aggregate values of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFeatureMatricesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFeatureMatricesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFeatureMatricesMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFeatureMatricesStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFeatureMatricesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFeatureMatricesStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFeatureMatricesSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFeatureMatricesVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFeatureMatricesVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFeatureMatricesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesArrRelInsertInput = {
  data: Array<DecisionEngineFeatureMatricesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineFeatureMatricesOnConflict>;
};

/** order by avg() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesAvgOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_feature_matrices". All fields are combined with a logical 'AND'. */
export type DecisionEngineFeatureMatricesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFeatureMatricesBoolExp>>;
  _not?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFeatureMatricesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  engine?: InputMaybe<DecisionEnginesBoolExp>;
  flows?: InputMaybe<DecisionEngineFlowsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<IntComparisonExp>;
  relationships?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_feature_matrices" */
export const DecisionEngineFeatureMatricesConstraint = {
  /** unique or primary key constraint on columns "id" */
  DecisionEngineFeatureMatricesPkey: 'decision_engine_feature_matrices_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineFeatureMatricesWorkspaceIdIdKey: 'decision_engine_feature_matrices_workspace_id_id_key'
} as const;

export type DecisionEngineFeatureMatricesConstraint = typeof DecisionEngineFeatureMatricesConstraint[keyof typeof DecisionEngineFeatureMatricesConstraint];
/** input type for incrementing numeric columns in table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesIncInput = {
  parent_model_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesInsertInput = {
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<DecisionEnginesObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['Int']>;
  relationships?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsArrRelInsertInput>;
};

/** order by max() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesMutationResponse = {
  __typename?: 'decision_engine_feature_matrices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFeatureMatrices>;
};

/** input type for inserting object relation for remote table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesObjRelInsertInput = {
  data: DecisionEngineFeatureMatricesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineFeatureMatricesOnConflict>;
};

/** on_conflict condition type for table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesOnConflict = {
  constraint: DecisionEngineFeatureMatricesConstraint;
  update_columns?: Array<DecisionEngineFeatureMatricesUpdateColumn>;
  where?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_feature_matrices". */
export type DecisionEngineFeatureMatricesOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  engine?: InputMaybe<DecisionEnginesOrderBy>;
  flows_aggregate?: InputMaybe<DecisionEngineFlowsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationships_aggregate?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_feature_matrices */
export type DecisionEngineFeatureMatricesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "decision_engine_feature_matrices" */
export const DecisionEngineFeatureMatricesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFeatureMatricesSelectColumn = typeof DecisionEngineFeatureMatricesSelectColumn[keyof typeof DecisionEngineFeatureMatricesSelectColumn];
/** input type for updating data in table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesStddevOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesStddevPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesStddevSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFeatureMatricesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFeatureMatricesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesSumOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_feature_matrices" */
export const DecisionEngineFeatureMatricesUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id'
} as const;

export type DecisionEngineFeatureMatricesUpdateColumn = typeof DecisionEngineFeatureMatricesUpdateColumn[keyof typeof DecisionEngineFeatureMatricesUpdateColumn];
export type DecisionEngineFeatureMatricesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineFeatureMatricesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineFeatureMatricesSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineFeatureMatricesBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesVarPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesVarSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_feature_matrices" */
export type DecisionEngineFeatureMatricesVarianceOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationships = {
  __typename?: 'decision_engine_feature_matrix_relationships';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_feature_matrix_id: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  /** An object relationship */
  feature_matrix?: Maybe<DecisionEngineFeatureMatrices>;
  id: Scalars['uuid'];
  /** An object relationship */
  relationship?: Maybe<ModelRelationships>;
  relationship_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFeatureMatrixRelationshipsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsArrRelInsertInput = {
  data: Array<DecisionEngineFeatureMatrixRelationshipsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsOnConflict>;
};

/** order by avg() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsAvgOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_feature_matrix_relationships". All fields are combined with a logical 'AND'. */
export type DecisionEngineFeatureMatrixRelationshipsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_feature_matrix_id?: InputMaybe<UuidComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  feature_matrix?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  relationship?: InputMaybe<ModelRelationshipsBoolExp>;
  relationship_id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_feature_matrix_relationships" */
export const DecisionEngineFeatureMatrixRelationshipsConstraint = {
  /** unique or primary key constraint on columns "relationship_id", "decision_engine_feature_matrix_id" */
  DecisionEngineFeatureMatriDecisionEngineFeatureMatriKey: 'decision_engine_feature_matri_decision_engine_feature_matri_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineFeatureMatrixRelationshipsPkey: 'decision_engine_feature_matrix_relationships_pkey'
} as const;

export type DecisionEngineFeatureMatrixRelationshipsConstraint = typeof DecisionEngineFeatureMatrixRelationshipsConstraint[keyof typeof DecisionEngineFeatureMatrixRelationshipsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineFeatureMatrixRelationshipsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineFeatureMatrixRelationshipsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineFeatureMatrixRelationshipsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsIncInput = {
  relationship_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_feature_matrix_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  feature_matrix?: InputMaybe<DecisionEngineFeatureMatricesObjRelInsertInput>;
  relationship?: InputMaybe<ModelRelationshipsObjRelInsertInput>;
  relationship_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsMutationResponse = {
  __typename?: 'decision_engine_feature_matrix_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFeatureMatrixRelationships>;
};

/** on_conflict condition type for table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsOnConflict = {
  constraint: DecisionEngineFeatureMatrixRelationshipsConstraint;
  update_columns?: Array<DecisionEngineFeatureMatrixRelationshipsUpdateColumn>;
  where?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_feature_matrix_relationships". */
export type DecisionEngineFeatureMatrixRelationshipsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  feature_matrix?: InputMaybe<DecisionEngineFeatureMatricesOrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship?: InputMaybe<ModelRelationshipsOrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_feature_matrix_relationships */
export type DecisionEngineFeatureMatrixRelationshipsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFeatureMatrixRelationshipsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_feature_matrix_relationships" */
export const DecisionEngineFeatureMatrixRelationshipsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFeatureMatrixId: 'decision_engine_feature_matrix_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFeatureMatrixRelationshipsSelectColumn = typeof DecisionEngineFeatureMatrixRelationshipsSelectColumn[keyof typeof DecisionEngineFeatureMatrixRelationshipsSelectColumn];
/** input type for updating data in table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  relationship_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsStddevOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsStddevPopOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsStddevSampOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFeatureMatrixRelationshipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFeatureMatrixRelationshipsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_feature_matrix_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  relationship_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsSumOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_feature_matrix_relationships" */
export const DecisionEngineFeatureMatrixRelationshipsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type DecisionEngineFeatureMatrixRelationshipsUpdateColumn = typeof DecisionEngineFeatureMatrixRelationshipsUpdateColumn[keyof typeof DecisionEngineFeatureMatrixRelationshipsUpdateColumn];
export type DecisionEngineFeatureMatrixRelationshipsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineFeatureMatrixRelationshipsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsVarPopOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsVarSampOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_feature_matrix_relationships" */
export type DecisionEngineFeatureMatrixRelationshipsVarianceOrderBy = {
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSync = {
  __typename?: 'decision_engine_flow_channel_sync';
  /** An object relationship */
  channel: DecisionEngineChannels;
  channel_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  /** An object relationship */
  flow: DecisionEngineFlows;
  flow_id: Scalars['uuid'];
  /** Last result of moving this channel's decisions into native delivery: {"status": "running" | "ok" | "error", "at": ISO time, "error"?: message}. Null until the first refresh. */
  native_delivery_status?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncNativeDeliveryStatusArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFlowChannelSyncAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowChannelSyncMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowChannelSyncMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFlowChannelSyncStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFlowChannelSyncStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFlowChannelSyncStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFlowChannelSyncSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFlowChannelSyncVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFlowChannelSyncVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFlowChannelSyncVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncAvgOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_channel_sync". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowChannelSyncBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowChannelSyncBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowChannelSyncBoolExp>>;
  channel?: InputMaybe<DecisionEngineChannelsBoolExp>;
  channel_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  flow_id?: InputMaybe<UuidComparisonExp>;
  native_delivery_status?: InputMaybe<JsonbComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncMaxOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncMinOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_flow_channel_sync". */
export type DecisionEngineFlowChannelSyncOrderBy = {
  channel?: InputMaybe<DecisionEngineChannelsOrderBy>;
  channel_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  native_delivery_status?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_channel_sync" */
export const DecisionEngineFlowChannelSyncSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  NativeDeliveryStatus: 'native_delivery_status',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineFlowChannelSyncSelectColumn = typeof DecisionEngineFlowChannelSyncSelectColumn[keyof typeof DecisionEngineFlowChannelSyncSelectColumn];
/** order by stddev() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncStddevOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncStddevPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncStddevSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowChannelSyncStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowChannelSyncStreamCursorValueInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  /** Last result of moving this channel's decisions into native delivery: {"status": "running" | "ok" | "error", "at": ISO time, "error"?: message}. Null until the first refresh. */
  native_delivery_status?: InputMaybe<Scalars['jsonb']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncSumOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncVarPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncVarSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_flow_channel_sync" */
export type DecisionEngineFlowChannelSyncVarianceOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_flow_charts" */
export type DecisionEngineFlowCharts = {
  __typename?: 'decision_engine_flow_charts';
  breakdown_by_dimension?: Maybe<Scalars['String']>;
  breakdown_by_type: Scalars['String'];
  chart_type: Scalars['String'];
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  decision_engine_flow: DecisionEngineFlows;
  filter_by?: Maybe<Scalars['String']>;
  filter_by_type?: Maybe<Scalars['String']>;
  filter_value?: Maybe<Scalars['String']>;
  flow_id: Scalars['uuid'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  outcome_id: Scalars['uuid'];
  rank: Scalars['numeric'];
  time_series_request: Scalars['jsonb'];
  top_chart: Scalars['Boolean'];
};


/** columns and relationships of "decision_engine_flow_charts" */
export type DecisionEngineFlowChartsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_charts" */
export type DecisionEngineFlowChartsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_charts" */
export type DecisionEngineFlowChartsTimeSeriesRequestArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_charts". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowChartsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowChartsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowChartsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowChartsBoolExp>>;
  breakdown_by_dimension?: InputMaybe<StringComparisonExp>;
  breakdown_by_type?: InputMaybe<StringComparisonExp>;
  chart_type?: InputMaybe<StringComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  filter_by?: InputMaybe<StringComparisonExp>;
  filter_by_type?: InputMaybe<StringComparisonExp>;
  filter_value?: InputMaybe<StringComparisonExp>;
  flow_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  outcome_id?: InputMaybe<UuidComparisonExp>;
  rank?: InputMaybe<NumericComparisonExp>;
  time_series_request?: InputMaybe<JsonbComparisonExp>;
  top_chart?: InputMaybe<BooleanComparisonExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_charts". */
export type DecisionEngineFlowChartsOrderBy = {
  breakdown_by_dimension?: InputMaybe<OrderBy>;
  breakdown_by_type?: InputMaybe<OrderBy>;
  chart_type?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  filter_by?: InputMaybe<OrderBy>;
  filter_by_type?: InputMaybe<OrderBy>;
  filter_value?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  outcome_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  time_series_request?: InputMaybe<OrderBy>;
  top_chart?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_charts" */
export const DecisionEngineFlowChartsSelectColumn = {
  /** column name */
  BreakdownByDimension: 'breakdown_by_dimension',
  /** column name */
  BreakdownByType: 'breakdown_by_type',
  /** column name */
  ChartType: 'chart_type',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FilterBy: 'filter_by',
  /** column name */
  FilterByType: 'filter_by_type',
  /** column name */
  FilterValue: 'filter_value',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  OutcomeId: 'outcome_id',
  /** column name */
  Rank: 'rank',
  /** column name */
  TimeSeriesRequest: 'time_series_request',
  /** column name */
  TopChart: 'top_chart'
} as const;

export type DecisionEngineFlowChartsSelectColumn = typeof DecisionEngineFlowChartsSelectColumn[keyof typeof DecisionEngineFlowChartsSelectColumn];
/** Streaming cursor of the table "decision_engine_flow_charts" */
export type DecisionEngineFlowChartsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowChartsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowChartsStreamCursorValueInput = {
  breakdown_by_dimension?: InputMaybe<Scalars['String']>;
  breakdown_by_type?: InputMaybe<Scalars['String']>;
  chart_type?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filter_by?: InputMaybe<Scalars['String']>;
  filter_by_type?: InputMaybe<Scalars['String']>;
  filter_value?: InputMaybe<Scalars['String']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  outcome_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['numeric']>;
  time_series_request?: InputMaybe<Scalars['jsonb']>;
  top_chart?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperiments = {
  __typename?: 'decision_engine_flow_experiments';
  audience_percent: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  decision_engine_flow: DecisionEngineFlows;
  decision_engine_flow_id: Scalars['uuid'];
  /** An object relationship */
  flow?: Maybe<DecisionEngineFlows>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** order by aggregate values of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFlowExperimentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowExperimentsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowExperimentsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFlowExperimentsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFlowExperimentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFlowExperimentsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFlowExperimentsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFlowExperimentsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFlowExperimentsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFlowExperimentsVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsAvgOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_experiments". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowExperimentsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowExperimentsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowExperimentsBoolExp>>;
  audience_percent?: InputMaybe<NumericComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_flow_experiments" */
export const DecisionEngineFlowExperimentsConstraint = {
  /** unique or primary key constraint on columns "decision_engine_flow_id", "name" */
  DecisionEngineFlowExperimentsPkey: 'decision_engine_flow_experiments_pkey'
} as const;

export type DecisionEngineFlowExperimentsConstraint = typeof DecisionEngineFlowExperimentsConstraint[keyof typeof DecisionEngineFlowExperimentsConstraint];
/** input type for incrementing numeric columns in table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsIncInput = {
  audience_percent?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsInsertInput = {
  audience_percent?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsMaxOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsMinOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsMutationResponse = {
  __typename?: 'decision_engine_flow_experiments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFlowExperiments>;
};

/** on_conflict condition type for table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsOnConflict = {
  constraint: DecisionEngineFlowExperimentsConstraint;
  update_columns?: Array<DecisionEngineFlowExperimentsUpdateColumn>;
  where?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_experiments". */
export type DecisionEngineFlowExperimentsOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_flow_experiments */
export type DecisionEngineFlowExperimentsPkColumnsInput = {
  decision_engine_flow_id: Scalars['uuid'];
  name: Scalars['String'];
};

/** select columns of table "decision_engine_flow_experiments" */
export const DecisionEngineFlowExperimentsSelectColumn = {
  /** column name */
  AudiencePercent: 'audience_percent',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineFlowExperimentsSelectColumn = typeof DecisionEngineFlowExperimentsSelectColumn[keyof typeof DecisionEngineFlowExperimentsSelectColumn];
/** input type for updating data in table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsSetInput = {
  audience_percent?: InputMaybe<Scalars['numeric']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsStddevOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsStddevPopOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsStddevSampOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowExperimentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowExperimentsStreamCursorValueInput = {
  audience_percent?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsSumOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_flow_experiments" */
export const DecisionEngineFlowExperimentsUpdateColumn = {
  /** column name */
  AudiencePercent: 'audience_percent',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineFlowExperimentsUpdateColumn = typeof DecisionEngineFlowExperimentsUpdateColumn[keyof typeof DecisionEngineFlowExperimentsUpdateColumn];
export type DecisionEngineFlowExperimentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineFlowExperimentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineFlowExperimentsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineFlowExperimentsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsVarPopOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsVarSampOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_flow_experiments" */
export type DecisionEngineFlowExperimentsVarianceOrderBy = {
  audience_percent?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_flow_messages" */
export type DecisionEngineFlowMessages = {
  __typename?: 'decision_engine_flow_messages';
  audience_size?: Maybe<Scalars['bigint']>;
  audience_size_computed_at?: Maybe<Scalars['timestamptz']>;
  config: Scalars['jsonb'];
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  disabled_at?: Maybe<Scalars['timestamptz']>;
  enabled?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  flow?: Maybe<DecisionEngineFlows>;
  /** An object relationship */
  message: DecisionEngineMessages;
  /** An object relationship */
  model?: Maybe<Segments>;
  segment_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFlowMessagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowMessagesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowMessagesMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFlowMessagesStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFlowMessagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFlowMessagesStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFlowMessagesSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFlowMessagesVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFlowMessagesVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFlowMessagesVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesAvgOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_messages". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowMessagesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowMessagesBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowMessagesBoolExp>>;
  audience_size?: InputMaybe<BigintComparisonExp>;
  audience_size_computed_at?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_message_id?: InputMaybe<UuidComparisonExp>;
  disabled_at?: InputMaybe<TimestamptzComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  message?: InputMaybe<DecisionEngineMessagesBoolExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesMaxOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  audience_size_computed_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  disabled_at?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesMinOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  audience_size_computed_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  disabled_at?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_flow_messages". */
export type DecisionEngineFlowMessagesOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  audience_size_computed_at?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  disabled_at?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  message?: InputMaybe<DecisionEngineMessagesOrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_messages" */
export const DecisionEngineFlowMessagesSelectColumn = {
  /** column name */
  AudienceSize: 'audience_size',
  /** column name */
  AudienceSizeComputedAt: 'audience_size_computed_at',
  /** column name */
  Config: 'config',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DecisionEngineMessageId: 'decision_engine_message_id',
  /** column name */
  DisabledAt: 'disabled_at',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFlowMessagesSelectColumn = typeof DecisionEngineFlowMessagesSelectColumn[keyof typeof DecisionEngineFlowMessagesSelectColumn];
/** order by stddev() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesStddevOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesStddevPopOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesStddevSampOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowMessagesStreamCursorValueInput = {
  audience_size?: InputMaybe<Scalars['bigint']>;
  audience_size_computed_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_message_id?: InputMaybe<Scalars['uuid']>;
  disabled_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesSumOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesVarPopOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesVarSampOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_flow_messages" */
export type DecisionEngineFlowMessagesVarianceOrderBy = {
  audience_size?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomes = {
  __typename?: 'decision_engine_flow_outcomes';
  created_at: Scalars['timestamptz'];
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
  /** An object relationship */
  flow?: Maybe<DecisionEngineFlows>;
  /** An object relationship */
  outcome: DecisionEngineOutcomes;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFlowOutcomesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowOutcomesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowOutcomesMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFlowOutcomesStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFlowOutcomesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFlowOutcomesStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFlowOutcomesSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFlowOutcomesVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFlowOutcomesVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFlowOutcomesVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_outcomes". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowOutcomesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowOutcomesBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowOutcomesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_outcome_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  outcome?: InputMaybe<DecisionEngineOutcomesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_flow_outcomes" */
export const DecisionEngineFlowOutcomesConstraint = {
  /** unique or primary key constraint on columns "decision_engine_outcome_id", "decision_engine_flow_id" */
  DecisionEngineFlowOutcomesPkey: 'decision_engine_flow_outcomes_pkey'
} as const;

export type DecisionEngineFlowOutcomesConstraint = typeof DecisionEngineFlowOutcomesConstraint[keyof typeof DecisionEngineFlowOutcomesConstraint];
/** input type for inserting data into table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesInsertInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_outcome_id?: InputMaybe<Scalars['uuid']>;
  outcome?: InputMaybe<DecisionEngineOutcomesObjRelInsertInput>;
};

/** order by max() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesMutationResponse = {
  __typename?: 'decision_engine_flow_outcomes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFlowOutcomes>;
};

/** on_conflict condition type for table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesOnConflict = {
  constraint: DecisionEngineFlowOutcomesConstraint;
  update_columns?: Array<DecisionEngineFlowOutcomesUpdateColumn>;
  where?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_outcomes". */
export type DecisionEngineFlowOutcomesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  outcome?: InputMaybe<DecisionEngineOutcomesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_outcomes" */
export const DecisionEngineFlowOutcomesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DecisionEngineOutcomeId: 'decision_engine_outcome_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFlowOutcomesSelectColumn = typeof DecisionEngineFlowOutcomesSelectColumn[keyof typeof DecisionEngineFlowOutcomesSelectColumn];
/** order by stddev() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowOutcomesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowOutcomesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_outcome_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "decision_engine_flow_outcomes" (current role has no relevant permissions) */
export const DecisionEngineFlowOutcomesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type DecisionEngineFlowOutcomesUpdateColumn = typeof DecisionEngineFlowOutcomesUpdateColumn[keyof typeof DecisionEngineFlowOutcomesUpdateColumn];
/** order by var_pop() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_flow_outcomes" */
export type DecisionEngineFlowOutcomesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_flow_override_periods" */
export type DecisionEngineFlowOverridePeriods = {
  __typename?: 'decision_engine_flow_override_periods';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  decision_engine_flow_id: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  ends_at: Scalars['timestamptz'];
  exclude_from_training: Scalars['Boolean'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  patch: Scalars['jsonb'];
  starts_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_flow_override_periods" */
export type DecisionEngineFlowOverridePeriodsPatchArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_override_periods". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowOverridePeriodsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowOverridePeriodsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  ends_at?: InputMaybe<TimestamptzComparisonExp>;
  exclude_from_training?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  patch?: InputMaybe<JsonbComparisonExp>;
  starts_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_override_periods". */
export type DecisionEngineFlowOverridePeriodsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  ends_at?: InputMaybe<OrderBy>;
  exclude_from_training?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  patch?: InputMaybe<OrderBy>;
  starts_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_override_periods" */
export const DecisionEngineFlowOverridePeriodsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EndsAt: 'ends_at',
  /** column name */
  ExcludeFromTraining: 'exclude_from_training',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Patch: 'patch',
  /** column name */
  StartsAt: 'starts_at',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFlowOverridePeriodsSelectColumn = typeof DecisionEngineFlowOverridePeriodsSelectColumn[keyof typeof DecisionEngineFlowOverridePeriodsSelectColumn];
/** Streaming cursor of the table "decision_engine_flow_override_periods" */
export type DecisionEngineFlowOverridePeriodsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowOverridePeriodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowOverridePeriodsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  exclude_from_training?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  patch?: InputMaybe<Scalars['jsonb']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRuns = {
  __typename?: 'decision_engine_flow_runs';
  /** A computed field, executes function "decision_engine_flow_run_cancellation_info" */
  cancellation_info?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  decision_engine: DecisionEngines;
  /** An object relationship */
  decision_engine_flow: DecisionEngineFlows;
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_id: Scalars['uuid'];
  decision_engine_run_id?: Maybe<Scalars['uuid']>;
  diagnostics: Scalars['jsonb'];
  /** A computed field, executes function "decision_engine_flow_run_error_message" */
  error_message?: Maybe<Scalars['String']>;
  execution_platform?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  job_type: Scalars['String'];
  last_heartbeat?: Maybe<Scalars['timestamptz']>;
  metadata: Scalars['jsonb'];
  /** A computed field, executes function "decision_engine_flow_run_parent_run_id" */
  parent_run_id?: Maybe<Scalars['String']>;
  result: Scalars['jsonb'];
  started_at?: Maybe<Scalars['timestamptz']>;
  state: Scalars['jsonb'];
  status: Scalars['String'];
  trigger_context?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  triggered_by_run?: Maybe<DecisionEngineFlowRuns>;
  triggered_by_run_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  triggered_runs: Array<DecisionEngineFlowRuns>;
  /** An aggregate relationship */
  triggered_runs_aggregate: DecisionEngineFlowRunsAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsCancellationInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsDiagnosticsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsTriggerContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsTriggeredRunsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


/** columns and relationships of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsTriggeredRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};

/** aggregated selection of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsAggregate = {
  __typename?: 'decision_engine_flow_runs_aggregate';
  aggregate?: Maybe<DecisionEngineFlowRunsAggregateFields>;
  nodes: Array<DecisionEngineFlowRuns>;
};

export type DecisionEngineFlowRunsAggregateBoolExp = {
  count?: InputMaybe<DecisionEngineFlowRunsAggregateBoolExpCount>;
};

export type DecisionEngineFlowRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsAggregateFields = {
  __typename?: 'decision_engine_flow_runs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DecisionEngineFlowRunsMaxFields>;
  min?: Maybe<DecisionEngineFlowRunsMinFields>;
};


/** aggregate fields of "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowRunsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowRunsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_runs". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowRunsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowRunsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowRunsBoolExp>>;
  cancellation_info?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine?: InputMaybe<DecisionEnginesBoolExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_run_id?: InputMaybe<UuidComparisonExp>;
  diagnostics?: InputMaybe<JsonbComparisonExp>;
  error_message?: InputMaybe<StringComparisonExp>;
  execution_platform?: InputMaybe<StringComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_type?: InputMaybe<StringComparisonExp>;
  last_heartbeat?: InputMaybe<TimestamptzComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  parent_run_id?: InputMaybe<StringComparisonExp>;
  result?: InputMaybe<JsonbComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  trigger_context?: InputMaybe<JsonbComparisonExp>;
  triggered_by_run?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
  triggered_by_run_id?: InputMaybe<UuidComparisonExp>;
  triggered_runs?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
  triggered_runs_aggregate?: InputMaybe<DecisionEngineFlowRunsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type DecisionEngineFlowRunsMaxFields = {
  __typename?: 'decision_engine_flow_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: Maybe<Scalars['uuid']>;
  decision_engine_id?: Maybe<Scalars['uuid']>;
  decision_engine_run_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "decision_engine_flow_run_error_message" */
  error_message?: Maybe<Scalars['String']>;
  execution_platform?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  last_heartbeat?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "decision_engine_flow_run_parent_run_id" */
  parent_run_id?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  triggered_by_run_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  decision_engine_run_id?: InputMaybe<OrderBy>;
  execution_platform?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  last_heartbeat?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggered_by_run_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DecisionEngineFlowRunsMinFields = {
  __typename?: 'decision_engine_flow_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: Maybe<Scalars['uuid']>;
  decision_engine_id?: Maybe<Scalars['uuid']>;
  decision_engine_run_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "decision_engine_flow_run_error_message" */
  error_message?: Maybe<Scalars['String']>;
  execution_platform?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  last_heartbeat?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "decision_engine_flow_run_parent_run_id" */
  parent_run_id?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  triggered_by_run_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  decision_engine_run_id?: InputMaybe<OrderBy>;
  execution_platform?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  last_heartbeat?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggered_by_run_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_flow_runs". */
export type DecisionEngineFlowRunsOrderBy = {
  cancellation_info?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine?: InputMaybe<DecisionEnginesOrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  decision_engine_run_id?: InputMaybe<OrderBy>;
  diagnostics?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  execution_platform?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  last_heartbeat?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  parent_run_id?: InputMaybe<OrderBy>;
  result?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger_context?: InputMaybe<OrderBy>;
  triggered_by_run?: InputMaybe<DecisionEngineFlowRunsOrderBy>;
  triggered_by_run_id?: InputMaybe<OrderBy>;
  triggered_runs_aggregate?: InputMaybe<DecisionEngineFlowRunsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_runs" */
export const DecisionEngineFlowRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  DecisionEngineRunId: 'decision_engine_run_id',
  /** column name */
  Diagnostics: 'diagnostics',
  /** column name */
  ExecutionPlatform: 'execution_platform',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  JobType: 'job_type',
  /** column name */
  LastHeartbeat: 'last_heartbeat',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Result: 'result',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  State: 'state',
  /** column name */
  Status: 'status',
  /** column name */
  TriggerContext: 'trigger_context',
  /** column name */
  TriggeredByRunId: 'triggered_by_run_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineFlowRunsSelectColumn = typeof DecisionEngineFlowRunsSelectColumn[keyof typeof DecisionEngineFlowRunsSelectColumn];
/** Streaming cursor of the table "decision_engine_flow_runs" */
export type DecisionEngineFlowRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_run_id?: InputMaybe<Scalars['uuid']>;
  diagnostics?: InputMaybe<Scalars['jsonb']>;
  execution_platform?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_type?: InputMaybe<Scalars['String']>;
  last_heartbeat?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  trigger_context?: InputMaybe<Scalars['jsonb']>;
  triggered_by_run_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "decision_engine_flow_tags" */
export type DecisionEngineFlowTags = {
  __typename?: 'decision_engine_flow_tags';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  decision_engine_flow: DecisionEngineFlows;
  decision_engine_flow_id: Scalars['uuid'];
  /** An object relationship */
  flow?: Maybe<DecisionEngineFlows>;
  tag_key: Scalars['String'];
  tag_value: Scalars['String'];
  timing?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsTimingArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowTagsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowTagsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFlowTagsAppendInput = {
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_tags". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowTagsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowTagsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowTagsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  tag_key?: InputMaybe<StringComparisonExp>;
  tag_value?: InputMaybe<StringComparisonExp>;
  timing?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_flow_tags" */
export const DecisionEngineFlowTagsConstraint = {
  /** unique or primary key constraint on columns "tag_key", "decision_engine_flow_id", "tag_value" */
  DecisionEngineFlowTagsPkey: 'decision_engine_flow_tags_pkey'
} as const;

export type DecisionEngineFlowTagsConstraint = typeof DecisionEngineFlowTagsConstraint[keyof typeof DecisionEngineFlowTagsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineFlowTagsDeleteAtPathInput = {
  timing?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineFlowTagsDeleteElemInput = {
  timing?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineFlowTagsDeleteKeyInput = {
  timing?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsInsertInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  tag_key?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  tag_key?: InputMaybe<OrderBy>;
  tag_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  tag_key?: InputMaybe<OrderBy>;
  tag_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsMutationResponse = {
  __typename?: 'decision_engine_flow_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFlowTags>;
};

/** on_conflict condition type for table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsOnConflict = {
  constraint: DecisionEngineFlowTagsConstraint;
  update_columns?: Array<DecisionEngineFlowTagsUpdateColumn>;
  where?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_tags". */
export type DecisionEngineFlowTagsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  tag_key?: InputMaybe<OrderBy>;
  tag_value?: InputMaybe<OrderBy>;
  timing?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_flow_tags */
export type DecisionEngineFlowTagsPkColumnsInput = {
  decision_engine_flow_id: Scalars['uuid'];
  tag_key: Scalars['String'];
  tag_value: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFlowTagsPrependInput = {
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_flow_tags" */
export const DecisionEngineFlowTagsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  TagKey: 'tag_key',
  /** column name */
  TagValue: 'tag_value',
  /** column name */
  Timing: 'timing',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineFlowTagsSelectColumn = typeof DecisionEngineFlowTagsSelectColumn[keyof typeof DecisionEngineFlowTagsSelectColumn];
/** input type for updating data in table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsSetInput = {
  tag_key?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "decision_engine_flow_tags" */
export type DecisionEngineFlowTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowTagsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  tag_key?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "decision_engine_flow_tags" */
export const DecisionEngineFlowTagsUpdateColumn = {
  /** column name */
  TagKey: 'tag_key',
  /** column name */
  TagValue: 'tag_value',
  /** column name */
  Timing: 'timing'
} as const;

export type DecisionEngineFlowTagsUpdateColumn = typeof DecisionEngineFlowTagsUpdateColumn[keyof typeof DecisionEngineFlowTagsUpdateColumn];
export type DecisionEngineFlowTagsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineFlowTagsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineFlowTagsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineFlowTagsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineFlowTagsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineFlowTagsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineFlowTagsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineFlowTagsBoolExp;
};

/** columns and relationships of "decision_engine_flow_volume_ramps" */
export type DecisionEngineFlowVolumeRamps = {
  __typename?: 'decision_engine_flow_volume_ramps';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  decision_engine_flow_id: Scalars['uuid'];
  ended_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  kind: Scalars['String'];
  plan: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_flow_volume_ramps" */
export type DecisionEngineFlowVolumeRampsPlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "decision_engine_flow_volume_ramps". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowVolumeRampsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowVolumeRampsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowVolumeRampsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowVolumeRampsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  ended_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  plan?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "decision_engine_flow_volume_ramps". */
export type DecisionEngineFlowVolumeRampsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  ended_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_flow_volume_ramps" */
export const DecisionEngineFlowVolumeRampsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  EndedAt: 'ended_at',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  Plan: 'plan',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFlowVolumeRampsSelectColumn = typeof DecisionEngineFlowVolumeRampsSelectColumn[keyof typeof DecisionEngineFlowVolumeRampsSelectColumn];
/** Streaming cursor of the table "decision_engine_flow_volume_ramps" */
export type DecisionEngineFlowVolumeRampsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowVolumeRampsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowVolumeRampsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  ended_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  kind?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlows = {
  __typename?: 'decision_engine_flows';
  /** An object relationship */
  audience?: Maybe<Segments>;
  audience_id: Scalars['bigint'];
  config: Scalars['jsonb'];
  /** An object relationship */
  decision_engine_feature_matrix?: Maybe<DecisionEngineFeatureMatrices>;
  decision_engine_feature_matrix_id?: Maybe<Scalars['uuid']>;
  decision_engine_id: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  /** An array relationship */
  experiments: Array<DecisionEngineFlowExperiments>;
  flow_type: Scalars['String'];
  /** An object relationship */
  group_membership?: Maybe<DecisionEngineArbitrationGroupMemberships>;
  id: Scalars['uuid'];
  /** An array relationship */
  interaction_manifests: Array<DecisionEngineInteractionManifests>;
  /** An array relationship */
  messages: Array<DecisionEngineFlowMessages>;
  /** An array relationship */
  model_outcomes: Array<DecisionEngineModelOutcomes>;
  /** An array relationship */
  models: Array<DecisionEngineModels>;
  name: Scalars['String'];
  /** An array relationship */
  offers: Array<DecisionEngineOffers>;
  /** An array relationship */
  outcomes: Array<DecisionEngineFlowOutcomes>;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  /** An array relationship */
  splits: Array<DecisionEngineSplits>;
  status: Scalars['String'];
  /** An array relationship */
  tags: Array<DecisionEngineFlowTags>;
  timing: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsExperimentsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowExperimentsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsInteractionManifestsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineInteractionManifestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineInteractionManifestsOrderBy>>;
  where?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsModelOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsModelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelsOrderBy>>;
  where?: InputMaybe<DecisionEngineModelsBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsOffersArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOffersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOffersOrderBy>>;
  where?: InputMaybe<DecisionEngineOffersBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsSplitsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSplitsOrderBy>>;
  where?: InputMaybe<DecisionEngineSplitsBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsTagsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowTagsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
};


/** columns and relationships of "decision_engine_flows" */
export type DecisionEngineFlowsTimingArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_flows" */
export type DecisionEngineFlowsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineFlowsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineFlowsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineFlowsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineFlowsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineFlowsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineFlowsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineFlowsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineFlowsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineFlowsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineFlowsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFlowsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_flows". All fields are combined with a logical 'AND'. */
export type DecisionEngineFlowsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineFlowsBoolExp>>;
  _not?: InputMaybe<DecisionEngineFlowsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineFlowsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  decision_engine_feature_matrix?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
  decision_engine_feature_matrix_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  experiments?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
  flow_type?: InputMaybe<StringComparisonExp>;
  group_membership?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  interaction_manifests?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
  messages?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
  model_outcomes?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
  models?: InputMaybe<DecisionEngineModelsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  offers?: InputMaybe<DecisionEngineOffersBoolExp>;
  outcomes?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  splits?: InputMaybe<DecisionEngineSplitsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
  timing?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineFlowsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  timing?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineFlowsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  timing?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineFlowsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "decision_engine_flows" */
export type DecisionEngineFlowsIncInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsMaxOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  flow_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsMinOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  flow_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_flows" */
export type DecisionEngineFlowsMutationResponse = {
  __typename?: 'decision_engine_flows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineFlows>;
};

/** Ordering options when selecting data from "decision_engine_flows". */
export type DecisionEngineFlowsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  decision_engine_feature_matrix?: InputMaybe<DecisionEngineFeatureMatricesOrderBy>;
  decision_engine_feature_matrix_id?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  experiments_aggregate?: InputMaybe<DecisionEngineFlowExperimentsAggregateOrderBy>;
  flow_type?: InputMaybe<OrderBy>;
  group_membership?: InputMaybe<DecisionEngineArbitrationGroupMembershipsOrderBy>;
  id?: InputMaybe<OrderBy>;
  interaction_manifests_aggregate?: InputMaybe<DecisionEngineInteractionManifestsAggregateOrderBy>;
  messages_aggregate?: InputMaybe<DecisionEngineFlowMessagesAggregateOrderBy>;
  model_outcomes_aggregate?: InputMaybe<DecisionEngineModelOutcomesAggregateOrderBy>;
  models_aggregate?: InputMaybe<DecisionEngineModelsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  offers_aggregate?: InputMaybe<DecisionEngineOffersAggregateOrderBy>;
  outcomes_aggregate?: InputMaybe<DecisionEngineFlowOutcomesAggregateOrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  splits_aggregate?: InputMaybe<DecisionEngineSplitsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  tags_aggregate?: InputMaybe<DecisionEngineFlowTagsAggregateOrderBy>;
  timing?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_flows */
export type DecisionEngineFlowsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineFlowsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_flows" */
export const DecisionEngineFlowsSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Config: 'config',
  /** column name */
  DecisionEngineFeatureMatrixId: 'decision_engine_feature_matrix_id',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  FlowType: 'flow_type',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Status: 'status',
  /** column name */
  Timing: 'timing',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineFlowsSelectColumn = typeof DecisionEngineFlowsSelectColumn[keyof typeof DecisionEngineFlowsSelectColumn];
/** input type for updating data in table "decision_engine_flows" */
export type DecisionEngineFlowsSetInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_feature_matrix_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_flows" */
export type DecisionEngineFlowsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineFlowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineFlowsStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_feature_matrix_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  flow_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  timing?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type DecisionEngineFlowsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineFlowsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineFlowsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineFlowsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineFlowsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineFlowsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineFlowsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineFlowsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineFlowsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_flows" */
export type DecisionEngineFlowsVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifests = {
  __typename?: 'decision_engine_interaction_manifests';
  commit_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  decision_engine_flow: DecisionEngineFlows;
  decision_engine_flow_id: Scalars['uuid'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  manifest: Scalars['jsonb'];
  storage_key?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsManifestArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineInteractionManifestsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineInteractionManifestsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineInteractionManifestsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineInteractionManifestsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineInteractionManifestsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineInteractionManifestsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineInteractionManifestsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineInteractionManifestsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineInteractionManifestsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineInteractionManifestsVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_interaction_manifests". All fields are combined with a logical 'AND'. */
export type DecisionEngineInteractionManifestsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineInteractionManifestsBoolExp>>;
  _not?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineInteractionManifestsBoolExp>>;
  commit_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  manifest?: InputMaybe<JsonbComparisonExp>;
  storage_key?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsMaxOrderBy = {
  commit_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  storage_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsMinOrderBy = {
  commit_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  storage_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_interaction_manifests". */
export type DecisionEngineInteractionManifestsOrderBy = {
  commit_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  manifest?: InputMaybe<OrderBy>;
  storage_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "decision_engine_interaction_manifests" */
export const DecisionEngineInteractionManifestsSelectColumn = {
  /** column name */
  CommitId: 'commit_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Manifest: 'manifest',
  /** column name */
  StorageKey: 'storage_key',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineInteractionManifestsSelectColumn = typeof DecisionEngineInteractionManifestsSelectColumn[keyof typeof DecisionEngineInteractionManifestsSelectColumn];
/** order by stddev() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineInteractionManifestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineInteractionManifestsStreamCursorValueInput = {
  commit_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  manifest?: InputMaybe<Scalars['jsonb']>;
  storage_key?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_interaction_manifests" */
export type DecisionEngineInteractionManifestsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_message_collections" */
export type DecisionEngineMessageCollections = {
  __typename?: 'decision_engine_message_collections';
  /** An object relationship */
  decision_engine_collection: DecisionEngineCollections;
  decision_engine_collection_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  item_count: Scalars['Int'];
  /** An object relationship */
  message?: Maybe<DecisionEngineMessages>;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineMessageCollectionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineMessageCollectionsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineMessageCollectionsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineMessageCollectionsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineMessageCollectionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineMessageCollectionsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineMessageCollectionsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineMessageCollectionsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineMessageCollectionsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineMessageCollectionsVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsAvgOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_message_collections". All fields are combined with a logical 'AND'. */
export type DecisionEngineMessageCollectionsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineMessageCollectionsBoolExp>>;
  _not?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineMessageCollectionsBoolExp>>;
  decision_engine_collection?: InputMaybe<DecisionEngineCollectionsBoolExp>;
  decision_engine_collection_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_message_id?: InputMaybe<UuidComparisonExp>;
  item_count?: InputMaybe<IntComparisonExp>;
  message?: InputMaybe<DecisionEngineMessagesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_message_collections" */
export const DecisionEngineMessageCollectionsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "decision_engine_message_id", "decision_engine_collection_id" */
  DecisionEngineMessageCollectionsPkey: 'decision_engine_message_collections_pkey'
} as const;

export type DecisionEngineMessageCollectionsConstraint = typeof DecisionEngineMessageCollectionsConstraint[keyof typeof DecisionEngineMessageCollectionsConstraint];
/** input type for incrementing numeric columns in table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsIncInput = {
  item_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsInsertInput = {
  decision_engine_collection?: InputMaybe<DecisionEngineCollectionsObjRelInsertInput>;
  decision_engine_collection_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_message_id?: InputMaybe<Scalars['uuid']>;
  item_count?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsMaxOrderBy = {
  decision_engine_collection_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsMinOrderBy = {
  decision_engine_collection_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsMutationResponse = {
  __typename?: 'decision_engine_message_collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineMessageCollections>;
};

/** on_conflict condition type for table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsOnConflict = {
  constraint: DecisionEngineMessageCollectionsConstraint;
  update_columns?: Array<DecisionEngineMessageCollectionsUpdateColumn>;
  where?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_message_collections". */
export type DecisionEngineMessageCollectionsOrderBy = {
  decision_engine_collection?: InputMaybe<DecisionEngineCollectionsOrderBy>;
  decision_engine_collection_id?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  item_count?: InputMaybe<OrderBy>;
  message?: InputMaybe<DecisionEngineMessagesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_message_collections */
export type DecisionEngineMessageCollectionsPkColumnsInput = {
  decision_engine_collection_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "decision_engine_message_collections" */
export const DecisionEngineMessageCollectionsSelectColumn = {
  /** column name */
  DecisionEngineCollectionId: 'decision_engine_collection_id',
  /** column name */
  DecisionEngineMessageId: 'decision_engine_message_id',
  /** column name */
  ItemCount: 'item_count',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineMessageCollectionsSelectColumn = typeof DecisionEngineMessageCollectionsSelectColumn[keyof typeof DecisionEngineMessageCollectionsSelectColumn];
/** input type for updating data in table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsSetInput = {
  item_count?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsStddevOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsStddevPopOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsStddevSampOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineMessageCollectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineMessageCollectionsStreamCursorValueInput = {
  decision_engine_collection_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_message_id?: InputMaybe<Scalars['uuid']>;
  item_count?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsSumOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_message_collections" */
export const DecisionEngineMessageCollectionsUpdateColumn = {
  /** column name */
  ItemCount: 'item_count'
} as const;

export type DecisionEngineMessageCollectionsUpdateColumn = typeof DecisionEngineMessageCollectionsUpdateColumn[keyof typeof DecisionEngineMessageCollectionsUpdateColumn];
export type DecisionEngineMessageCollectionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineMessageCollectionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineMessageCollectionsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineMessageCollectionsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsVarPopOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsVarSampOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_message_collections" */
export type DecisionEngineMessageCollectionsVarianceOrderBy = {
  item_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestions = {
  __typename?: 'decision_engine_message_variant_suggestions';
  created_at: Scalars['timestamptz'];
  decision_engine_message_id: Scalars['uuid'];
  feedback?: Maybe<Scalars['String']>;
  /** An object relationship */
  message?: Maybe<DecisionEngineMessages>;
  reasoning?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  suggested_value: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_edited_value?: Maybe<Scalars['String']>;
  variable_name: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineMessageVariantSuggestionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineMessageVariantSuggestionsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineMessageVariantSuggestionsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineMessageVariantSuggestionsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineMessageVariantSuggestionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineMessageVariantSuggestionsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineMessageVariantSuggestionsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineMessageVariantSuggestionsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineMessageVariantSuggestionsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineMessageVariantSuggestionsVarianceOrderBy>;
};

/** order by avg() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_message_variant_suggestions". All fields are combined with a logical 'AND'. */
export type DecisionEngineMessageVariantSuggestionsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsBoolExp>>;
  _not?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_message_id?: InputMaybe<UuidComparisonExp>;
  feedback?: InputMaybe<StringComparisonExp>;
  message?: InputMaybe<DecisionEngineMessagesBoolExp>;
  reasoning?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  suggested_value?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_edited_value?: InputMaybe<StringComparisonExp>;
  variable_name?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_message_variant_suggestions" */
export const DecisionEngineMessageVariantSuggestionsConstraint = {
  /** unique or primary key constraint on columns "suggested_value", "variable_name", "decision_engine_message_id" */
  DecisionEngineMessageVariantSuggestionsPkey: 'decision_engine_message_variant_suggestions_pkey'
} as const;

export type DecisionEngineMessageVariantSuggestionsConstraint = typeof DecisionEngineMessageVariantSuggestionsConstraint[keyof typeof DecisionEngineMessageVariantSuggestionsConstraint];
/** input type for inserting data into table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsInsertInput = {
  decision_engine_message_id?: InputMaybe<Scalars['uuid']>;
  feedback?: InputMaybe<Scalars['String']>;
  reasoning?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  suggested_value?: InputMaybe<Scalars['String']>;
  user_edited_value?: InputMaybe<Scalars['String']>;
  variable_name?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  feedback?: InputMaybe<OrderBy>;
  reasoning?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggested_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_edited_value?: InputMaybe<OrderBy>;
  variable_name?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  feedback?: InputMaybe<OrderBy>;
  reasoning?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggested_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_edited_value?: InputMaybe<OrderBy>;
  variable_name?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsMutationResponse = {
  __typename?: 'decision_engine_message_variant_suggestions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineMessageVariantSuggestions>;
};

/** on_conflict condition type for table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsOnConflict = {
  constraint: DecisionEngineMessageVariantSuggestionsConstraint;
  update_columns?: Array<DecisionEngineMessageVariantSuggestionsUpdateColumn>;
  where?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_message_variant_suggestions". */
export type DecisionEngineMessageVariantSuggestionsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_message_id?: InputMaybe<OrderBy>;
  feedback?: InputMaybe<OrderBy>;
  message?: InputMaybe<DecisionEngineMessagesOrderBy>;
  reasoning?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggested_value?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_edited_value?: InputMaybe<OrderBy>;
  variable_name?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_message_variant_suggestions */
export type DecisionEngineMessageVariantSuggestionsPkColumnsInput = {
  decision_engine_message_id: Scalars['uuid'];
  suggested_value: Scalars['String'];
  variable_name: Scalars['String'];
};

/** select columns of table "decision_engine_message_variant_suggestions" */
export const DecisionEngineMessageVariantSuggestionsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineMessageId: 'decision_engine_message_id',
  /** column name */
  Feedback: 'feedback',
  /** column name */
  Reasoning: 'reasoning',
  /** column name */
  Status: 'status',
  /** column name */
  SuggestedValue: 'suggested_value',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserEditedValue: 'user_edited_value',
  /** column name */
  VariableName: 'variable_name',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineMessageVariantSuggestionsSelectColumn = typeof DecisionEngineMessageVariantSuggestionsSelectColumn[keyof typeof DecisionEngineMessageVariantSuggestionsSelectColumn];
/** input type for updating data in table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsSetInput = {
  feedback?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  user_edited_value?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineMessageVariantSuggestionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineMessageVariantSuggestionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_message_id?: InputMaybe<Scalars['uuid']>;
  feedback?: InputMaybe<Scalars['String']>;
  reasoning?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  suggested_value?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_edited_value?: InputMaybe<Scalars['String']>;
  variable_name?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_message_variant_suggestions" */
export const DecisionEngineMessageVariantSuggestionsUpdateColumn = {
  /** column name */
  Feedback: 'feedback',
  /** column name */
  Status: 'status',
  /** column name */
  UserEditedValue: 'user_edited_value'
} as const;

export type DecisionEngineMessageVariantSuggestionsUpdateColumn = typeof DecisionEngineMessageVariantSuggestionsUpdateColumn[keyof typeof DecisionEngineMessageVariantSuggestionsUpdateColumn];
export type DecisionEngineMessageVariantSuggestionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineMessageVariantSuggestionsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineMessageVariantSuggestionsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_message_variant_suggestions" */
export type DecisionEngineMessageVariantSuggestionsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessages = {
  __typename?: 'decision_engine_messages';
  /** An object relationship */
  channel: DecisionEngineChannels;
  /** An array relationship */
  collections: Array<DecisionEngineMessageCollections>;
  config: Scalars['jsonb'];
  content?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  decision_engine_channel_id: Scalars['uuid'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  embedding?: Maybe<Scalars['vector']>;
  /** An object relationship */
  flow_message?: Maybe<DecisionEngineFlowMessages>;
  id: Scalars['uuid'];
  llm_description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object relationship */
  offer?: Maybe<DecisionEngineOffers>;
  offer_id?: Maybe<Scalars['uuid']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Returns message variables from normalized tables instead of legacy JSONB column */
  variables_normalized?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  variant_suggestions: Array<DecisionEngineMessageVariantSuggestions>;
};


/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessagesCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
};


/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessagesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessagesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessagesVariablesNormalizedArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_messages" */
export type DecisionEngineMessagesVariantSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};

/** aggregated selection of "decision_engine_messages" */
export type DecisionEngineMessagesAggregate = {
  __typename?: 'decision_engine_messages_aggregate';
  aggregate?: Maybe<DecisionEngineMessagesAggregateFields>;
  nodes: Array<DecisionEngineMessages>;
};

export type DecisionEngineMessagesAggregateBoolExp = {
  count?: InputMaybe<DecisionEngineMessagesAggregateBoolExpCount>;
};

export type DecisionEngineMessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DecisionEngineMessagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "decision_engine_messages" */
export type DecisionEngineMessagesAggregateFields = {
  __typename?: 'decision_engine_messages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<DecisionEngineMessagesMaxFields>;
  min?: Maybe<DecisionEngineMessagesMinFields>;
};


/** aggregate fields of "decision_engine_messages" */
export type DecisionEngineMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "decision_engine_messages" */
export type DecisionEngineMessagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineMessagesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineMessagesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_messages". All fields are combined with a logical 'AND'. */
export type DecisionEngineMessagesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineMessagesBoolExp>>;
  _not?: InputMaybe<DecisionEngineMessagesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineMessagesBoolExp>>;
  channel?: InputMaybe<DecisionEngineChannelsBoolExp>;
  collections?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_channel_id?: InputMaybe<UuidComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  flow_message?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_description?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  offer?: InputMaybe<DecisionEngineOffersBoolExp>;
  offer_id?: InputMaybe<UuidComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  variables_normalized?: InputMaybe<JsonbComparisonExp>;
  variant_suggestions?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};

/** aggregate max on columns */
export type DecisionEngineMessagesMaxFields = {
  __typename?: 'decision_engine_messages_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  decision_engine_channel_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "decision_engine_messages" */
export type DecisionEngineMessagesMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_channel_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  offer_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DecisionEngineMessagesMinFields = {
  __typename?: 'decision_engine_messages_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  decision_engine_channel_id?: Maybe<Scalars['uuid']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "decision_engine_messages" */
export type DecisionEngineMessagesMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_channel_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  offer_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "decision_engine_messages". */
export type DecisionEngineMessagesOrderBy = {
  channel?: InputMaybe<DecisionEngineChannelsOrderBy>;
  collections_aggregate?: InputMaybe<DecisionEngineMessageCollectionsAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_channel_id?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  embedding?: InputMaybe<OrderBy>;
  flow_message?: InputMaybe<DecisionEngineFlowMessagesOrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  offer?: InputMaybe<DecisionEngineOffersOrderBy>;
  offer_id?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  variables_normalized?: InputMaybe<OrderBy>;
  variant_suggestions_aggregate?: InputMaybe<DecisionEngineMessageVariantSuggestionsAggregateOrderBy>;
};

/** select columns of table "decision_engine_messages" */
export const DecisionEngineMessagesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineChannelId: 'decision_engine_channel_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Embedding: 'embedding',
  /** column name */
  Id: 'id',
  /** column name */
  LlmDescription: 'llm_description',
  /** column name */
  Name: 'name',
  /** column name */
  OfferId: 'offer_id',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineMessagesSelectColumn = typeof DecisionEngineMessagesSelectColumn[keyof typeof DecisionEngineMessagesSelectColumn];
/** Streaming cursor of the table "decision_engine_messages" */
export type DecisionEngineMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineMessagesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_channel_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  embedding?: InputMaybe<Scalars['vector']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomes = {
  __typename?: 'decision_engine_model_outcomes';
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_model_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
  /** An object relationship */
  flow: DecisionEngineFlows;
  /** An object relationship */
  model: DecisionEngineModels;
  /** An object relationship */
  outcome: DecisionEngineOutcomes;
  weight: Scalars['jsonb'];
};


/** columns and relationships of "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesWeightArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineModelOutcomesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineModelOutcomesMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineModelOutcomesAppendInput = {
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesArrRelInsertInput = {
  data: Array<DecisionEngineModelOutcomesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineModelOutcomesOnConflict>;
};

/** Boolean expression to filter rows from the table "decision_engine_model_outcomes". All fields are combined with a logical 'AND'. */
export type DecisionEngineModelOutcomesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineModelOutcomesBoolExp>>;
  _not?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineModelOutcomesBoolExp>>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_model_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_outcome_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  model?: InputMaybe<DecisionEngineModelsBoolExp>;
  outcome?: InputMaybe<DecisionEngineOutcomesBoolExp>;
  weight?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_model_outcomes" */
export const DecisionEngineModelOutcomesConstraint = {
  /** unique or primary key constraint on columns "decision_engine_outcome_id", "decision_engine_flow_id", "decision_engine_model_id" */
  DecisionEngineModelOutcomesPkey: 'decision_engine_model_outcomes_pkey'
} as const;

export type DecisionEngineModelOutcomesConstraint = typeof DecisionEngineModelOutcomesConstraint[keyof typeof DecisionEngineModelOutcomesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineModelOutcomesDeleteAtPathInput = {
  weight?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineModelOutcomesDeleteElemInput = {
  weight?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineModelOutcomesDeleteKeyInput = {
  weight?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesInsertInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_model_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_outcome_id?: InputMaybe<Scalars['uuid']>;
  model?: InputMaybe<DecisionEngineModelsObjRelInsertInput>;
  outcome?: InputMaybe<DecisionEngineOutcomesObjRelInsertInput>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesMaxOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_model_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesMinOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_model_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesMutationResponse = {
  __typename?: 'decision_engine_model_outcomes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineModelOutcomes>;
};

/** on_conflict condition type for table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesOnConflict = {
  constraint: DecisionEngineModelOutcomesConstraint;
  update_columns?: Array<DecisionEngineModelOutcomesUpdateColumn>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_model_outcomes". */
export type DecisionEngineModelOutcomesOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  decision_engine_model_id?: InputMaybe<OrderBy>;
  decision_engine_outcome_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  model?: InputMaybe<DecisionEngineModelsOrderBy>;
  outcome?: InputMaybe<DecisionEngineOutcomesOrderBy>;
  weight?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_model_outcomes */
export type DecisionEngineModelOutcomesPkColumnsInput = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_model_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineModelOutcomesPrependInput = {
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_model_outcomes" */
export const DecisionEngineModelOutcomesSelectColumn = {
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DecisionEngineModelId: 'decision_engine_model_id',
  /** column name */
  DecisionEngineOutcomeId: 'decision_engine_outcome_id',
  /** column name */
  Weight: 'weight'
} as const;

export type DecisionEngineModelOutcomesSelectColumn = typeof DecisionEngineModelOutcomesSelectColumn[keyof typeof DecisionEngineModelOutcomesSelectColumn];
/** input type for updating data in table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesSetInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_model_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_outcome_id?: InputMaybe<Scalars['uuid']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "decision_engine_model_outcomes" */
export type DecisionEngineModelOutcomesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineModelOutcomesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineModelOutcomesStreamCursorValueInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_model_id?: InputMaybe<Scalars['uuid']>;
  decision_engine_outcome_id?: InputMaybe<Scalars['uuid']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "decision_engine_model_outcomes" */
export const DecisionEngineModelOutcomesUpdateColumn = {
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  DecisionEngineModelId: 'decision_engine_model_id',
  /** column name */
  DecisionEngineOutcomeId: 'decision_engine_outcome_id',
  /** column name */
  Weight: 'weight'
} as const;

export type DecisionEngineModelOutcomesUpdateColumn = typeof DecisionEngineModelOutcomesUpdateColumn[keyof typeof DecisionEngineModelOutcomesUpdateColumn];
export type DecisionEngineModelOutcomesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineModelOutcomesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineModelOutcomesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineModelOutcomesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineModelOutcomesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineModelOutcomesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineModelOutcomesSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineModelOutcomesBoolExp;
};

/** columns and relationships of "decision_engine_models" */
export type DecisionEngineModels = {
  __typename?: 'decision_engine_models';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_flow_id: Scalars['uuid'];
  /** An object relationship */
  flow: DecisionEngineFlows;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  outcomes: Array<DecisionEngineModelOutcomes>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "decision_engine_models" */
export type DecisionEngineModelsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_models" */
export type DecisionEngineModelsOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};

/** order by aggregate values of table "decision_engine_models" */
export type DecisionEngineModelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineModelsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineModelsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineModelsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "decision_engine_models". All fields are combined with a logical 'AND'. */
export type DecisionEngineModelsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineModelsBoolExp>>;
  _not?: InputMaybe<DecisionEngineModelsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineModelsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  outcomes?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_models" */
export const DecisionEngineModelsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineModelsIdWorkspaceIdKey: 'decision_engine_models_id_workspace_id_key',
  /** unique or primary key constraint on columns "decision_engine_flow_id", "name" */
  DecisionEngineModelsNameDecisionEngineFlowIdKey: 'decision_engine_models_name_decision_engine_flow_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineModelsPkey: 'decision_engine_models_pkey'
} as const;

export type DecisionEngineModelsConstraint = typeof DecisionEngineModelsConstraint[keyof typeof DecisionEngineModelsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineModelsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineModelsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineModelsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_models" */
export type DecisionEngineModelsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  outcomes?: InputMaybe<DecisionEngineModelOutcomesArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "decision_engine_models" */
export type DecisionEngineModelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_models" */
export type DecisionEngineModelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_models" */
export type DecisionEngineModelsMutationResponse = {
  __typename?: 'decision_engine_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineModels>;
};

/** input type for inserting object relation for remote table "decision_engine_models" */
export type DecisionEngineModelsObjRelInsertInput = {
  data: DecisionEngineModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineModelsOnConflict>;
};

/** on_conflict condition type for table "decision_engine_models" */
export type DecisionEngineModelsOnConflict = {
  constraint: DecisionEngineModelsConstraint;
  update_columns?: Array<DecisionEngineModelsUpdateColumn>;
  where?: InputMaybe<DecisionEngineModelsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_models". */
export type DecisionEngineModelsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  outcomes_aggregate?: InputMaybe<DecisionEngineModelOutcomesAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_models */
export type DecisionEngineModelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineModelsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_models" */
export const DecisionEngineModelsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineModelsSelectColumn = typeof DecisionEngineModelsSelectColumn[keyof typeof DecisionEngineModelsSelectColumn];
/** input type for updating data in table "decision_engine_models" */
export type DecisionEngineModelsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "decision_engine_models" */
export type DecisionEngineModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineModelsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "decision_engine_models" */
export const DecisionEngineModelsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Name: 'name',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineModelsUpdateColumn = typeof DecisionEngineModelsUpdateColumn[keyof typeof DecisionEngineModelsUpdateColumn];
export type DecisionEngineModelsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineModelsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineModelsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineModelsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineModelsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineModelsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineModelsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineModelsBoolExp;
};

/** columns and relationships of "decision_engine_offers" */
export type DecisionEngineOffers = {
  __typename?: 'decision_engine_offers';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_flow_id: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  flow: DecisionEngineFlows;
  id: Scalars['uuid'];
  /** An array relationship */
  messages: Array<DecisionEngineMessages>;
  /** An aggregate relationship */
  messages_aggregate: DecisionEngineMessagesAggregate;
  name: Scalars['String'];
  tags: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_offers" */
export type DecisionEngineOffersConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_offers" */
export type DecisionEngineOffersMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


/** columns and relationships of "decision_engine_offers" */
export type DecisionEngineOffersMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


/** columns and relationships of "decision_engine_offers" */
export type DecisionEngineOffersTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_offers" */
export type DecisionEngineOffersAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineOffersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineOffersMaxOrderBy>;
  min?: InputMaybe<DecisionEngineOffersMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineOffersStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineOffersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineOffersStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineOffersSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineOffersVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineOffersVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineOffersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineOffersAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_offers". All fields are combined with a logical 'AND'. */
export type DecisionEngineOffersBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineOffersBoolExp>>;
  _not?: InputMaybe<DecisionEngineOffersBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineOffersBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  external_id?: InputMaybe<StringComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  messages?: InputMaybe<DecisionEngineMessagesBoolExp>;
  messages_aggregate?: InputMaybe<DecisionEngineMessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_offers" */
export const DecisionEngineOffersConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineOffersIdWorkspaceIdKey: 'decision_engine_offers_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineOffersPkey: 'decision_engine_offers_pkey',
  /** unique or primary key constraint on columns "workspace_id", "external_id" */
  DecisionEngineOffersWorkspaceIdExternalIdKey: 'decision_engine_offers_workspace_id_external_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineOffersWorkspaceIdIdKey: 'decision_engine_offers_workspace_id_id_key'
} as const;

export type DecisionEngineOffersConstraint = typeof DecisionEngineOffersConstraint[keyof typeof DecisionEngineOffersConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineOffersDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineOffersDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineOffersDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_offers" */
export type DecisionEngineOffersInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_offers" */
export type DecisionEngineOffersMutationResponse = {
  __typename?: 'decision_engine_offers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineOffers>;
};

/** on_conflict condition type for table "decision_engine_offers" */
export type DecisionEngineOffersOnConflict = {
  constraint: DecisionEngineOffersConstraint;
  update_columns?: Array<DecisionEngineOffersUpdateColumn>;
  where?: InputMaybe<DecisionEngineOffersBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_offers". */
export type DecisionEngineOffersOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  id?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<DecisionEngineMessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_offers */
export type DecisionEngineOffersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineOffersPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_offers" */
export const DecisionEngineOffersSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  Description: 'description',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineOffersSelectColumn = typeof DecisionEngineOffersSelectColumn[keyof typeof DecisionEngineOffersSelectColumn];
/** input type for updating data in table "decision_engine_offers" */
export type DecisionEngineOffersSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_offers" */
export type DecisionEngineOffersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineOffersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineOffersStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_offers" */
export const DecisionEngineOffersUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  Name: 'name',
  /** column name */
  Tags: 'tags'
} as const;

export type DecisionEngineOffersUpdateColumn = typeof DecisionEngineOffersUpdateColumn[keyof typeof DecisionEngineOffersUpdateColumn];
export type DecisionEngineOffersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineOffersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineOffersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineOffersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineOffersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineOffersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineOffersSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineOffersBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_offers" */
export type DecisionEngineOffersVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_outcomes" */
export type DecisionEngineOutcomes = {
  __typename?: 'decision_engine_outcomes';
  attribution: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  decision_engine_id: Scalars['uuid'];
  filter?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  latest_event_at?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_outcomes" */
export type DecisionEngineOutcomesAttributionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_outcomes" */
export type DecisionEngineOutcomesFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_outcomes" */
export type DecisionEngineOutcomesWeightArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineOutcomesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineOutcomesMaxOrderBy>;
  min?: InputMaybe<DecisionEngineOutcomesMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineOutcomesStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineOutcomesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineOutcomesStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineOutcomesSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineOutcomesVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineOutcomesVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineOutcomesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineOutcomesAppendInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "decision_engine_outcomes" */
export type DecisionEngineOutcomesArrRelInsertInput = {
  data: Array<DecisionEngineOutcomesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineOutcomesOnConflict>;
};

/** order by avg() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesAvgOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_outcomes". All fields are combined with a logical 'AND'. */
export type DecisionEngineOutcomesBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineOutcomesBoolExp>>;
  _not?: InputMaybe<DecisionEngineOutcomesBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineOutcomesBoolExp>>;
  attribution?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  filter?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  latest_event_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  weight?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_outcomes" */
export const DecisionEngineOutcomesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineOutcomesIdWorkspaceIdKey: 'decision_engine_outcomes_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineOutcomesPkey: 'decision_engine_outcomes_pkey'
} as const;

export type DecisionEngineOutcomesConstraint = typeof DecisionEngineOutcomesConstraint[keyof typeof DecisionEngineOutcomesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineOutcomesDeleteAtPathInput = {
  attribution?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<Scalars['String']>>;
  weight?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineOutcomesDeleteElemInput = {
  attribution?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineOutcomesDeleteKeyInput = {
  attribution?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "decision_engine_outcomes" */
export type DecisionEngineOutcomesIncInput = {
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "decision_engine_outcomes" */
export type DecisionEngineOutcomesInsertInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latest_event_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latest_event_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_outcomes" */
export type DecisionEngineOutcomesMutationResponse = {
  __typename?: 'decision_engine_outcomes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineOutcomes>;
};

/** input type for inserting object relation for remote table "decision_engine_outcomes" */
export type DecisionEngineOutcomesObjRelInsertInput = {
  data: DecisionEngineOutcomesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineOutcomesOnConflict>;
};

/** on_conflict condition type for table "decision_engine_outcomes" */
export type DecisionEngineOutcomesOnConflict = {
  constraint: DecisionEngineOutcomesConstraint;
  update_columns?: Array<DecisionEngineOutcomesUpdateColumn>;
  where?: InputMaybe<DecisionEngineOutcomesBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_outcomes". */
export type DecisionEngineOutcomesOrderBy = {
  attribution?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  filter?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  latest_event_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  weight?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_outcomes */
export type DecisionEngineOutcomesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineOutcomesPrependInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_outcomes" */
export const DecisionEngineOutcomesSelectColumn = {
  /** column name */
  Attribution: 'attribution',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  Filter: 'filter',
  /** column name */
  Id: 'id',
  /** column name */
  LatestEventAt: 'latest_event_at',
  /** column name */
  Name: 'name',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  Weight: 'weight',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineOutcomesSelectColumn = typeof DecisionEngineOutcomesSelectColumn[keyof typeof DecisionEngineOutcomesSelectColumn];
/** input type for updating data in table "decision_engine_outcomes" */
export type DecisionEngineOutcomesSetInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  weight?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesStddevOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesStddevPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesStddevSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_outcomes" */
export type DecisionEngineOutcomesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineOutcomesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineOutcomesStreamCursorValueInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  latest_event_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesSumOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_outcomes" */
export const DecisionEngineOutcomesUpdateColumn = {
  /** column name */
  Attribution: 'attribution',
  /** column name */
  Filter: 'filter',
  /** column name */
  Name: 'name',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Weight: 'weight'
} as const;

export type DecisionEngineOutcomesUpdateColumn = typeof DecisionEngineOutcomesUpdateColumn[keyof typeof DecisionEngineOutcomesUpdateColumn];
export type DecisionEngineOutcomesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineOutcomesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineOutcomesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineOutcomesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineOutcomesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineOutcomesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineOutcomesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineOutcomesSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineOutcomesBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesVarPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesVarSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_outcomes" */
export type DecisionEngineOutcomesVarianceOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_send_events" */
export type DecisionEngineSendEvents = {
  __typename?: 'decision_engine_send_events';
  attribution: Scalars['jsonb'];
  /** An array relationship */
  channels: Array<DecisionEngineChannels>;
  created_at: Scalars['timestamptz'];
  decision_engine_id: Scalars['uuid'];
  filter?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engine_send_events" */
export type DecisionEngineSendEventsAttributionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engine_send_events" */
export type DecisionEngineSendEventsChannelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineChannelsOrderBy>>;
  where?: InputMaybe<DecisionEngineChannelsBoolExp>;
};


/** columns and relationships of "decision_engine_send_events" */
export type DecisionEngineSendEventsFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_send_events" */
export type DecisionEngineSendEventsAggregateOrderBy = {
  avg?: InputMaybe<DecisionEngineSendEventsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineSendEventsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineSendEventsMinOrderBy>;
  stddev?: InputMaybe<DecisionEngineSendEventsStddevOrderBy>;
  stddev_pop?: InputMaybe<DecisionEngineSendEventsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DecisionEngineSendEventsStddevSampOrderBy>;
  sum?: InputMaybe<DecisionEngineSendEventsSumOrderBy>;
  var_pop?: InputMaybe<DecisionEngineSendEventsVarPopOrderBy>;
  var_samp?: InputMaybe<DecisionEngineSendEventsVarSampOrderBy>;
  variance?: InputMaybe<DecisionEngineSendEventsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineSendEventsAppendInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "decision_engine_send_events" */
export type DecisionEngineSendEventsArrRelInsertInput = {
  data: Array<DecisionEngineSendEventsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEngineSendEventsOnConflict>;
};

/** order by avg() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsAvgOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "decision_engine_send_events". All fields are combined with a logical 'AND'. */
export type DecisionEngineSendEventsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineSendEventsBoolExp>>;
  _not?: InputMaybe<DecisionEngineSendEventsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineSendEventsBoolExp>>;
  attribution?: InputMaybe<JsonbComparisonExp>;
  channels?: InputMaybe<DecisionEngineChannelsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  decision_engine_id?: InputMaybe<UuidComparisonExp>;
  filter?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_send_events" */
export const DecisionEngineSendEventsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineSendEventsIdWorkspaceIdKey: 'decision_engine_send_events_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineSendEventsPkey: 'decision_engine_send_events_pkey'
} as const;

export type DecisionEngineSendEventsConstraint = typeof DecisionEngineSendEventsConstraint[keyof typeof DecisionEngineSendEventsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineSendEventsDeleteAtPathInput = {
  attribution?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineSendEventsDeleteElemInput = {
  attribution?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineSendEventsDeleteKeyInput = {
  attribution?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "decision_engine_send_events" */
export type DecisionEngineSendEventsIncInput = {
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "decision_engine_send_events" */
export type DecisionEngineSendEventsInsertInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_send_events" */
export type DecisionEngineSendEventsMutationResponse = {
  __typename?: 'decision_engine_send_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineSendEvents>;
};

/** on_conflict condition type for table "decision_engine_send_events" */
export type DecisionEngineSendEventsOnConflict = {
  constraint: DecisionEngineSendEventsConstraint;
  update_columns?: Array<DecisionEngineSendEventsUpdateColumn>;
  where?: InputMaybe<DecisionEngineSendEventsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_send_events". */
export type DecisionEngineSendEventsOrderBy = {
  attribution?: InputMaybe<OrderBy>;
  channels_aggregate?: InputMaybe<DecisionEngineChannelsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  decision_engine_id?: InputMaybe<OrderBy>;
  filter?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_send_events */
export type DecisionEngineSendEventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineSendEventsPrependInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_send_events" */
export const DecisionEngineSendEventsSelectColumn = {
  /** column name */
  Attribution: 'attribution',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DecisionEngineId: 'decision_engine_id',
  /** column name */
  Filter: 'filter',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEngineSendEventsSelectColumn = typeof DecisionEngineSendEventsSelectColumn[keyof typeof DecisionEngineSendEventsSelectColumn];
/** input type for updating data in table "decision_engine_send_events" */
export type DecisionEngineSendEventsSetInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsStddevOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsStddevPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsStddevSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "decision_engine_send_events" */
export type DecisionEngineSendEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineSendEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineSendEventsStreamCursorValueInput = {
  attribution?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  decision_engine_id?: InputMaybe<Scalars['uuid']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsSumOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "decision_engine_send_events" */
export const DecisionEngineSendEventsUpdateColumn = {
  /** column name */
  Attribution: 'attribution',
  /** column name */
  Filter: 'filter',
  /** column name */
  Name: 'name',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type DecisionEngineSendEventsUpdateColumn = typeof DecisionEngineSendEventsUpdateColumn[keyof typeof DecisionEngineSendEventsUpdateColumn];
export type DecisionEngineSendEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineSendEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineSendEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineSendEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineSendEventsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DecisionEngineSendEventsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineSendEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineSendEventsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineSendEventsBoolExp;
};

/** order by var_pop() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsVarPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsVarSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "decision_engine_send_events" */
export type DecisionEngineSendEventsVarianceOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "decision_engine_splits" */
export type DecisionEngineSplits = {
  __typename?: 'decision_engine_splits';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  end_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flow: DecisionEngineFlows;
  flow_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  start_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  training_completed_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "decision_engine_splits" */
export type DecisionEngineSplitsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "decision_engine_splits" */
export type DecisionEngineSplitsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DecisionEngineSplitsMaxOrderBy>;
  min?: InputMaybe<DecisionEngineSplitsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineSplitsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "decision_engine_splits". All fields are combined with a logical 'AND'. */
export type DecisionEngineSplitsBoolExp = {
  _and?: InputMaybe<Array<DecisionEngineSplitsBoolExp>>;
  _not?: InputMaybe<DecisionEngineSplitsBoolExp>;
  _or?: InputMaybe<Array<DecisionEngineSplitsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  end_at?: InputMaybe<TimestamptzComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  flow_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  start_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  training_completed_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "decision_engine_splits" */
export const DecisionEngineSplitsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEngineSplitsIdWorkspaceIdKey: 'decision_engine_splits_id_workspace_id_key',
  /** unique or primary key constraint on columns "flow_id", "name" */
  DecisionEngineSplitsNameFlowIdKey: 'decision_engine_splits_name_flow_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEngineSplitsPkey: 'decision_engine_splits_pkey'
} as const;

export type DecisionEngineSplitsConstraint = typeof DecisionEngineSplitsConstraint[keyof typeof DecisionEngineSplitsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEngineSplitsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEngineSplitsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEngineSplitsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engine_splits" */
export type DecisionEngineSplitsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_at?: InputMaybe<Scalars['timestamptz']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "decision_engine_splits" */
export type DecisionEngineSplitsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  end_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_completed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "decision_engine_splits" */
export type DecisionEngineSplitsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  end_at?: InputMaybe<OrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_completed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "decision_engine_splits" */
export type DecisionEngineSplitsMutationResponse = {
  __typename?: 'decision_engine_splits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngineSplits>;
};

/** on_conflict condition type for table "decision_engine_splits" */
export type DecisionEngineSplitsOnConflict = {
  constraint: DecisionEngineSplitsConstraint;
  update_columns?: Array<DecisionEngineSplitsUpdateColumn>;
  where?: InputMaybe<DecisionEngineSplitsBoolExp>;
};

/** Ordering options when selecting data from "decision_engine_splits". */
export type DecisionEngineSplitsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  end_at?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  flow_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  start_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_completed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engine_splits */
export type DecisionEngineSplitsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEngineSplitsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engine_splits" */
export const DecisionEngineSplitsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  EndAt: 'end_at',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  StartAt: 'start_at',
  /** column name */
  Status: 'status',
  /** column name */
  TrainingCompletedAt: 'training_completed_at',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type DecisionEngineSplitsSelectColumn = typeof DecisionEngineSplitsSelectColumn[keyof typeof DecisionEngineSplitsSelectColumn];
/** input type for updating data in table "decision_engine_splits" */
export type DecisionEngineSplitsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  end_at?: InputMaybe<Scalars['timestamptz']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "decision_engine_splits" */
export type DecisionEngineSplitsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEngineSplitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEngineSplitsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_at?: InputMaybe<Scalars['timestamptz']>;
  flow_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  start_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  training_completed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "decision_engine_splits" */
export const DecisionEngineSplitsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  EndAt: 'end_at',
  /** column name */
  FlowId: 'flow_id',
  /** column name */
  Name: 'name',
  /** column name */
  StartAt: 'start_at',
  /** column name */
  Status: 'status'
} as const;

export type DecisionEngineSplitsUpdateColumn = typeof DecisionEngineSplitsUpdateColumn[keyof typeof DecisionEngineSplitsUpdateColumn];
export type DecisionEngineSplitsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEngineSplitsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEngineSplitsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEngineSplitsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEngineSplitsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEngineSplitsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEngineSplitsSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEngineSplitsBoolExp;
};

/** columns and relationships of "decision_engines" */
export type DecisionEngines = {
  __typename?: 'decision_engines';
  /** An array relationship */
  channels: Array<DecisionEngineChannels>;
  /** An array relationship */
  collections: Array<DecisionEngineCollections>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  error?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  featureMatrices: Array<DecisionEngineFeatureMatrices>;
  /** An array relationship */
  flows: Array<DecisionEngineFlows>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  outcomes: Array<DecisionEngineOutcomes>;
  /** An array relationship */
  send_events: Array<DecisionEngineSendEvents>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesChannelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineChannelsOrderBy>>;
  where?: InputMaybe<DecisionEngineChannelsBoolExp>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineCollectionsBoolExp>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesFeatureMatricesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatricesOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesFlowsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowsBoolExp>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineOutcomesBoolExp>;
};


/** columns and relationships of "decision_engines" */
export type DecisionEnginesSendEventsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSendEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSendEventsOrderBy>>;
  where?: InputMaybe<DecisionEngineSendEventsBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DecisionEnginesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "decision_engines". All fields are combined with a logical 'AND'. */
export type DecisionEnginesBoolExp = {
  _and?: InputMaybe<Array<DecisionEnginesBoolExp>>;
  _not?: InputMaybe<DecisionEnginesBoolExp>;
  _or?: InputMaybe<Array<DecisionEnginesBoolExp>>;
  channels?: InputMaybe<DecisionEngineChannelsBoolExp>;
  collections?: InputMaybe<DecisionEngineCollectionsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  featureMatrices?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
  flows?: InputMaybe<DecisionEngineFlowsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  outcomes?: InputMaybe<DecisionEngineOutcomesBoolExp>;
  send_events?: InputMaybe<DecisionEngineSendEventsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "decision_engines" */
export const DecisionEnginesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEnginesIdWorkspaceIdKey: 'decision_engines_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DecisionEnginesPkey: 'decision_engines_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DecisionEnginesWorkspaceIdIdKey: 'decision_engines_workspace_id_id_key'
} as const;

export type DecisionEnginesConstraint = typeof DecisionEnginesConstraint[keyof typeof DecisionEnginesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DecisionEnginesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DecisionEnginesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DecisionEnginesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "decision_engines" */
export type DecisionEnginesInsertInput = {
  collections?: InputMaybe<DecisionEngineCollectionsArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['jsonb']>;
  featureMatrices?: InputMaybe<DecisionEngineFeatureMatricesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  outcomes?: InputMaybe<DecisionEngineOutcomesArrRelInsertInput>;
  send_events?: InputMaybe<DecisionEngineSendEventsArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "decision_engines" */
export type DecisionEnginesMutationResponse = {
  __typename?: 'decision_engines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DecisionEngines>;
};

/** input type for inserting object relation for remote table "decision_engines" */
export type DecisionEnginesObjRelInsertInput = {
  data: DecisionEnginesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DecisionEnginesOnConflict>;
};

/** on_conflict condition type for table "decision_engines" */
export type DecisionEnginesOnConflict = {
  constraint: DecisionEnginesConstraint;
  update_columns?: Array<DecisionEnginesUpdateColumn>;
  where?: InputMaybe<DecisionEnginesBoolExp>;
};

/** Ordering options when selecting data from "decision_engines". */
export type DecisionEnginesOrderBy = {
  channels_aggregate?: InputMaybe<DecisionEngineChannelsAggregateOrderBy>;
  collections_aggregate?: InputMaybe<DecisionEngineCollectionsAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  featureMatrices_aggregate?: InputMaybe<DecisionEngineFeatureMatricesAggregateOrderBy>;
  flows_aggregate?: InputMaybe<DecisionEngineFlowsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  outcomes_aggregate?: InputMaybe<DecisionEngineOutcomesAggregateOrderBy>;
  send_events_aggregate?: InputMaybe<DecisionEngineSendEventsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: decision_engines */
export type DecisionEnginesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DecisionEnginesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "decision_engines" */
export const DecisionEnginesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DecisionEnginesSelectColumn = typeof DecisionEnginesSelectColumn[keyof typeof DecisionEnginesSelectColumn];
/** input type for updating data in table "decision_engines" */
export type DecisionEnginesSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "decision_engines" */
export type DecisionEnginesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DecisionEnginesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DecisionEnginesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "decision_engines" */
export const DecisionEnginesUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Name: 'name',
  /** column name */
  Status: 'status'
} as const;

export type DecisionEnginesUpdateColumn = typeof DecisionEnginesUpdateColumn[keyof typeof DecisionEnginesUpdateColumn];
export type DecisionEnginesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DecisionEnginesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DecisionEnginesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DecisionEnginesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DecisionEnginesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DecisionEnginesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DecisionEnginesSetInput>;
  /** filter the rows which have to be updated */
  where: DecisionEnginesBoolExp;
};

/** columns and relationships of "deliverability_feeds" */
export type DeliverabilityFeeds = {
  __typename?: 'deliverability_feeds';
  config: Scalars['jsonb'];
  connected_at?: Maybe<Scalars['timestamptz']>;
  connected_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  connected_by_user?: Maybe<Users>;
  connection_generation: Scalars['Int'];
  connection_status: Scalars['String'];
  created_at: Scalars['timestamptz'];
  feed_type: Scalars['String'];
  id: Scalars['uuid'];
  last_error?: Maybe<Scalars['String']>;
  last_error_at?: Maybe<Scalars['timestamptz']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_summary?: Maybe<Scalars['jsonb']>;
  last_scheduled_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  schedule_interval?: Maybe<Scalars['interval']>;
  selected_domains: Array<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "deliverability_feeds" */
export type DeliverabilityFeedsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deliverability_feeds" */
export type DeliverabilityFeedsLastRunSummaryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deliverability_feeds" */
export type DeliverabilityFeedsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "deliverability_feeds" */
export type DeliverabilityFeedsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "deliverability_feeds" */
export type DeliverabilityFeedsAggregate = {
  __typename?: 'deliverability_feeds_aggregate';
  aggregate?: Maybe<DeliverabilityFeedsAggregateFields>;
  nodes: Array<DeliverabilityFeeds>;
};

/** aggregate fields of "deliverability_feeds" */
export type DeliverabilityFeedsAggregateFields = {
  __typename?: 'deliverability_feeds_aggregate_fields';
  avg?: Maybe<DeliverabilityFeedsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DeliverabilityFeedsMaxFields>;
  min?: Maybe<DeliverabilityFeedsMinFields>;
  stddev?: Maybe<DeliverabilityFeedsStddevFields>;
  stddev_pop?: Maybe<DeliverabilityFeedsStddevPopFields>;
  stddev_samp?: Maybe<DeliverabilityFeedsStddevSampFields>;
  sum?: Maybe<DeliverabilityFeedsSumFields>;
  var_pop?: Maybe<DeliverabilityFeedsVarPopFields>;
  var_samp?: Maybe<DeliverabilityFeedsVarSampFields>;
  variance?: Maybe<DeliverabilityFeedsVarianceFields>;
};


/** aggregate fields of "deliverability_feeds" */
export type DeliverabilityFeedsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeliverabilityFeedsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DeliverabilityFeedsAvgFields = {
  __typename?: 'deliverability_feeds_avg_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "deliverability_feeds". All fields are combined with a logical 'AND'. */
export type DeliverabilityFeedsBoolExp = {
  _and?: InputMaybe<Array<DeliverabilityFeedsBoolExp>>;
  _not?: InputMaybe<DeliverabilityFeedsBoolExp>;
  _or?: InputMaybe<Array<DeliverabilityFeedsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  connected_at?: InputMaybe<TimestamptzComparisonExp>;
  connected_by?: InputMaybe<BigintComparisonExp>;
  connected_by_user?: InputMaybe<UsersBoolExp>;
  connection_generation?: InputMaybe<IntComparisonExp>;
  connection_status?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  feed_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_error?: InputMaybe<StringComparisonExp>;
  last_error_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_summary?: InputMaybe<JsonbComparisonExp>;
  last_scheduled_at?: InputMaybe<TimestamptzComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  schedule_interval?: InputMaybe<IntervalComparisonExp>;
  selected_domains?: InputMaybe<StringArrayComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "deliverability_feeds" */
export const DeliverabilityFeedsConstraint = {
  /** unique or primary key constraint on columns "id" */
  DeliverabilityFeedsPkey: 'deliverability_feeds_pkey',
  /** unique or primary key constraint on columns "workspace_id", "feed_type" */
  DeliverabilityFeedsWorkspaceIdFeedTypeKey: 'deliverability_feeds_workspace_id_feed_type_key'
} as const;

export type DeliverabilityFeedsConstraint = typeof DeliverabilityFeedsConstraint[keyof typeof DeliverabilityFeedsConstraint];
/** input type for inserting data into table "deliverability_feeds" */
export type DeliverabilityFeedsInsertInput = {
  feed_type?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  schedule_interval?: InputMaybe<Scalars['interval']>;
  selected_domains?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate max on columns */
export type DeliverabilityFeedsMaxFields = {
  __typename?: 'deliverability_feeds_max_fields';
  connected_at?: Maybe<Scalars['timestamptz']>;
  connected_by?: Maybe<Scalars['bigint']>;
  connection_generation?: Maybe<Scalars['Int']>;
  connection_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  feed_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_error?: Maybe<Scalars['String']>;
  last_error_at?: Maybe<Scalars['timestamptz']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_scheduled_at?: Maybe<Scalars['timestamptz']>;
  selected_domains?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DeliverabilityFeedsMinFields = {
  __typename?: 'deliverability_feeds_min_fields';
  connected_at?: Maybe<Scalars['timestamptz']>;
  connected_by?: Maybe<Scalars['bigint']>;
  connection_generation?: Maybe<Scalars['Int']>;
  connection_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  feed_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_error?: Maybe<Scalars['String']>;
  last_error_at?: Maybe<Scalars['timestamptz']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_scheduled_at?: Maybe<Scalars['timestamptz']>;
  selected_domains?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "deliverability_feeds" */
export type DeliverabilityFeedsMutationResponse = {
  __typename?: 'deliverability_feeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DeliverabilityFeeds>;
};

/** on_conflict condition type for table "deliverability_feeds" */
export type DeliverabilityFeedsOnConflict = {
  constraint: DeliverabilityFeedsConstraint;
  update_columns?: Array<DeliverabilityFeedsUpdateColumn>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};

/** Ordering options when selecting data from "deliverability_feeds". */
export type DeliverabilityFeedsOrderBy = {
  config?: InputMaybe<OrderBy>;
  connected_at?: InputMaybe<OrderBy>;
  connected_by?: InputMaybe<OrderBy>;
  connected_by_user?: InputMaybe<UsersOrderBy>;
  connection_generation?: InputMaybe<OrderBy>;
  connection_status?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  feed_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_error?: InputMaybe<OrderBy>;
  last_error_at?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_summary?: InputMaybe<OrderBy>;
  last_scheduled_at?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  schedule_interval?: InputMaybe<OrderBy>;
  selected_domains?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: deliverability_feeds */
export type DeliverabilityFeedsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "deliverability_feeds" */
export const DeliverabilityFeedsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  ConnectedAt: 'connected_at',
  /** column name */
  ConnectedBy: 'connected_by',
  /** column name */
  ConnectionGeneration: 'connection_generation',
  /** column name */
  ConnectionStatus: 'connection_status',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FeedType: 'feed_type',
  /** column name */
  Id: 'id',
  /** column name */
  LastError: 'last_error',
  /** column name */
  LastErrorAt: 'last_error_at',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunSummary: 'last_run_summary',
  /** column name */
  LastScheduledAt: 'last_scheduled_at',
  /** column name */
  ScheduleInterval: 'schedule_interval',
  /** column name */
  SelectedDomains: 'selected_domains',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DeliverabilityFeedsSelectColumn = typeof DeliverabilityFeedsSelectColumn[keyof typeof DeliverabilityFeedsSelectColumn];
/** input type for updating data in table "deliverability_feeds" */
export type DeliverabilityFeedsSetInput = {
  schedule_interval?: InputMaybe<Scalars['interval']>;
  selected_domains?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate stddev on columns */
export type DeliverabilityFeedsStddevFields = {
  __typename?: 'deliverability_feeds_stddev_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DeliverabilityFeedsStddevPopFields = {
  __typename?: 'deliverability_feeds_stddev_pop_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DeliverabilityFeedsStddevSampFields = {
  __typename?: 'deliverability_feeds_stddev_samp_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "deliverability_feeds" */
export type DeliverabilityFeedsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DeliverabilityFeedsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeliverabilityFeedsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  connected_at?: InputMaybe<Scalars['timestamptz']>;
  connected_by?: InputMaybe<Scalars['bigint']>;
  connection_generation?: InputMaybe<Scalars['Int']>;
  connection_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feed_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_error?: InputMaybe<Scalars['String']>;
  last_error_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_summary?: InputMaybe<Scalars['jsonb']>;
  last_scheduled_at?: InputMaybe<Scalars['timestamptz']>;
  schedule_interval?: InputMaybe<Scalars['interval']>;
  selected_domains?: InputMaybe<Array<Scalars['String']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DeliverabilityFeedsSumFields = {
  __typename?: 'deliverability_feeds_sum_fields';
  connected_by?: Maybe<Scalars['bigint']>;
  connection_generation?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "deliverability_feeds" */
export const DeliverabilityFeedsUpdateColumn = {
  /** column name */
  ScheduleInterval: 'schedule_interval',
  /** column name */
  SelectedDomains: 'selected_domains'
} as const;

export type DeliverabilityFeedsUpdateColumn = typeof DeliverabilityFeedsUpdateColumn[keyof typeof DeliverabilityFeedsUpdateColumn];
export type DeliverabilityFeedsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeliverabilityFeedsSetInput>;
  /** filter the rows which have to be updated */
  where: DeliverabilityFeedsBoolExp;
};

/** aggregate var_pop on columns */
export type DeliverabilityFeedsVarPopFields = {
  __typename?: 'deliverability_feeds_var_pop_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DeliverabilityFeedsVarSampFields = {
  __typename?: 'deliverability_feeds_var_samp_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DeliverabilityFeedsVarianceFields = {
  __typename?: 'deliverability_feeds_variance_fields';
  connected_by?: Maybe<Scalars['Float']>;
  connection_generation?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Stores a history of deployments made between workspaces.  */
export type DeploymentHistory = {
  __typename?: 'deployment_history';
  changelog_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  from_workspace: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  source_workspace: Workspaces;
  /** An object relationship */
  target_workspace: Workspaces;
  to_id?: Maybe<Scalars['bigint']>;
  to_workspace: Scalars['bigint'];
  /** An object relationship */
  user: Users;
};

/** Boolean expression to filter rows from the table "deployment_history". All fields are combined with a logical 'AND'. */
export type DeploymentHistoryBoolExp = {
  _and?: InputMaybe<Array<DeploymentHistoryBoolExp>>;
  _not?: InputMaybe<DeploymentHistoryBoolExp>;
  _or?: InputMaybe<Array<DeploymentHistoryBoolExp>>;
  changelog_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  from_workspace?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  source_workspace?: InputMaybe<WorkspacesBoolExp>;
  target_workspace?: InputMaybe<WorkspacesBoolExp>;
  to_id?: InputMaybe<BigintComparisonExp>;
  to_workspace?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "deployment_history". */
export type DeploymentHistoryOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  from_workspace?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  source_workspace?: InputMaybe<WorkspacesOrderBy>;
  target_workspace?: InputMaybe<WorkspacesOrderBy>;
  to_id?: InputMaybe<OrderBy>;
  to_workspace?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "deployment_history" */
export const DeploymentHistorySelectColumn = {
  /** column name */
  ChangelogId: 'changelog_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FromWorkspace: 'from_workspace',
  /** column name */
  Id: 'id',
  /** column name */
  ToId: 'to_id',
  /** column name */
  ToWorkspace: 'to_workspace'
} as const;

export type DeploymentHistorySelectColumn = typeof DeploymentHistorySelectColumn[keyof typeof DeploymentHistorySelectColumn];
/** Streaming cursor of the table "deployment_history" */
export type DeploymentHistoryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DeploymentHistoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeploymentHistoryStreamCursorValueInput = {
  changelog_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_workspace?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  to_id?: InputMaybe<Scalars['bigint']>;
  to_workspace?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "destination_instance_splits" */
export type DestinationInstanceSplits = {
  __typename?: 'destination_instance_splits';
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  /** An object relationship */
  split: AudienceSplits;
  split_id: Scalars['uuid'];
  /** An object relationship */
  sync?: Maybe<Syncs>;
};

/** order by aggregate values of table "destination_instance_splits" */
export type DestinationInstanceSplitsAggregateOrderBy = {
  avg?: InputMaybe<DestinationInstanceSplitsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DestinationInstanceSplitsMaxOrderBy>;
  min?: InputMaybe<DestinationInstanceSplitsMinOrderBy>;
  stddev?: InputMaybe<DestinationInstanceSplitsStddevOrderBy>;
  stddev_pop?: InputMaybe<DestinationInstanceSplitsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DestinationInstanceSplitsStddevSampOrderBy>;
  sum?: InputMaybe<DestinationInstanceSplitsSumOrderBy>;
  var_pop?: InputMaybe<DestinationInstanceSplitsVarPopOrderBy>;
  var_samp?: InputMaybe<DestinationInstanceSplitsVarSampOrderBy>;
  variance?: InputMaybe<DestinationInstanceSplitsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "destination_instance_splits" */
export type DestinationInstanceSplitsArrRelInsertInput = {
  data: Array<DestinationInstanceSplitsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DestinationInstanceSplitsOnConflict>;
};

/** order by avg() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsAvgOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "destination_instance_splits". All fields are combined with a logical 'AND'. */
export type DestinationInstanceSplitsBoolExp = {
  _and?: InputMaybe<Array<DestinationInstanceSplitsBoolExp>>;
  _not?: InputMaybe<DestinationInstanceSplitsBoolExp>;
  _or?: InputMaybe<Array<DestinationInstanceSplitsBoolExp>>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  split?: InputMaybe<AudienceSplitsBoolExp>;
  split_id?: InputMaybe<UuidComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
};

/** unique or primary key constraints on table "destination_instance_splits" */
export const DestinationInstanceSplitsConstraint = {
  /** unique or primary key constraint on columns "destination_instance_id", "split_id" */
  DestinationInstanceSplitsPkey: 'destination_instance_splits_pkey'
} as const;

export type DestinationInstanceSplitsConstraint = typeof DestinationInstanceSplitsConstraint[keyof typeof DestinationInstanceSplitsConstraint];
/** input type for inserting data into table "destination_instance_splits" */
export type DestinationInstanceSplitsInsertInput = {
  destination_instance?: InputMaybe<DestinationInstancesObjRelInsertInput>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  split?: InputMaybe<AudienceSplitsObjRelInsertInput>;
  split_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsMaxOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  split_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsMinOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  split_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "destination_instance_splits" */
export type DestinationInstanceSplitsMutationResponse = {
  __typename?: 'destination_instance_splits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DestinationInstanceSplits>;
};

/** on_conflict condition type for table "destination_instance_splits" */
export type DestinationInstanceSplitsOnConflict = {
  constraint: DestinationInstanceSplitsConstraint;
  update_columns?: Array<DestinationInstanceSplitsUpdateColumn>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};

/** Ordering options when selecting data from "destination_instance_splits". */
export type DestinationInstanceSplitsOrderBy = {
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  split?: InputMaybe<AudienceSplitsOrderBy>;
  split_id?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
};

/** primary key columns input for table: destination_instance_splits */
export type DestinationInstanceSplitsPkColumnsInput = {
  destination_instance_id: Scalars['bigint'];
  split_id: Scalars['uuid'];
};

/** select columns of table "destination_instance_splits" */
export const DestinationInstanceSplitsSelectColumn = {
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  SplitId: 'split_id'
} as const;

export type DestinationInstanceSplitsSelectColumn = typeof DestinationInstanceSplitsSelectColumn[keyof typeof DestinationInstanceSplitsSelectColumn];
/** order by stddev() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsStddevOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsStddevPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsStddevSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "destination_instance_splits" */
export type DestinationInstanceSplitsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DestinationInstanceSplitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DestinationInstanceSplitsStreamCursorValueInput = {
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  split_id?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsSumOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "destination_instance_splits" (current role has no relevant permissions) */
export const DestinationInstanceSplitsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type DestinationInstanceSplitsUpdateColumn = typeof DestinationInstanceSplitsUpdateColumn[keyof typeof DestinationInstanceSplitsUpdateColumn];
export type DestinationInstanceSplitsUpdates = {
  /** filter the rows which have to be updated */
  where: DestinationInstanceSplitsBoolExp;
};

/** order by var_pop() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsVarPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsVarSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "destination_instance_splits" */
export type DestinationInstanceSplitsVarianceOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "destination_instances" */
export type DestinationInstances = {
  __typename?: 'destination_instances';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  approved_draft_id?: Maybe<Scalars['uuid']>;
  clear_and_fill_hold_until?: Maybe<Scalars['timestamptz']>;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  /** An object relationship */
  draftByApprovedDraftId?: Maybe<Drafts>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  force_run: Scalars['Boolean'];
  full_resync?: Maybe<Scalars['Boolean']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id: Scalars['bigint'];
  is_streaming: Scalars['Boolean'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: Maybe<Scalars['String']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "sync_status" */
  status?: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** An array relationship */
  sync_sequence_members: Array<SyncSequenceMembers>;
  /** An array relationship */
  sync_sequence_requests: Array<SyncSequenceRequests>;
  /** An object relationship */
  sync_template?: Maybe<SyncTemplates>;
  sync_template_id?: Maybe<Scalars['Int']>;
  sync_template_overrides?: Maybe<Scalars['jsonb']>;
  tags: Scalars['jsonb'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesAlertInstancesArgs = {
  distinct_on?: InputMaybe<Array<AlertInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertInstancesOrderBy>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesAlertStatusesArgs = {
  distinct_on?: InputMaybe<Array<AlertStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertStatusesOrderBy>>;
  where?: InputMaybe<AlertStatusesBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesExternalSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalSegmentsOrderBy>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesMonitoringArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncSequenceMembersArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceMembersOrderBy>>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncSequenceRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRequestsOrderBy>>;
  where?: InputMaybe<SyncSequenceRequestsBoolExp>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesSyncTemplateOverridesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destination_instances" */
export type DestinationInstancesWarehouseHistoryConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "destination_instances" */
export type DestinationInstancesAggregate = {
  __typename?: 'destination_instances_aggregate';
  aggregate?: Maybe<DestinationInstancesAggregateFields>;
  nodes: Array<DestinationInstances>;
};

export type DestinationInstancesAggregateBoolExp = {
  bool_and?: InputMaybe<DestinationInstancesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<DestinationInstancesAggregateBoolExpBoolOr>;
  count?: InputMaybe<DestinationInstancesAggregateBoolExpCount>;
};

export type DestinationInstancesAggregateBoolExpBoolAnd = {
  arguments: DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationInstancesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DestinationInstancesAggregateBoolExpBoolOr = {
  arguments: DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationInstancesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DestinationInstancesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationInstancesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "destination_instances" */
export type DestinationInstancesAggregateFields = {
  __typename?: 'destination_instances_aggregate_fields';
  avg?: Maybe<DestinationInstancesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DestinationInstancesMaxFields>;
  min?: Maybe<DestinationInstancesMinFields>;
  stddev?: Maybe<DestinationInstancesStddevFields>;
  stddev_pop?: Maybe<DestinationInstancesStddevPopFields>;
  stddev_samp?: Maybe<DestinationInstancesStddevSampFields>;
  sum?: Maybe<DestinationInstancesSumFields>;
  var_pop?: Maybe<DestinationInstancesVarPopFields>;
  var_samp?: Maybe<DestinationInstancesVarSampFields>;
  variance?: Maybe<DestinationInstancesVarianceFields>;
};


/** aggregate fields of "destination_instances" */
export type DestinationInstancesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "destination_instances" */
export type DestinationInstancesAggregateOrderBy = {
  avg?: InputMaybe<DestinationInstancesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DestinationInstancesMaxOrderBy>;
  min?: InputMaybe<DestinationInstancesMinOrderBy>;
  stddev?: InputMaybe<DestinationInstancesStddevOrderBy>;
  stddev_pop?: InputMaybe<DestinationInstancesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DestinationInstancesStddevSampOrderBy>;
  sum?: InputMaybe<DestinationInstancesSumOrderBy>;
  var_pop?: InputMaybe<DestinationInstancesVarPopOrderBy>;
  var_samp?: InputMaybe<DestinationInstancesVarSampOrderBy>;
  variance?: InputMaybe<DestinationInstancesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DestinationInstancesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "destination_instances" */
export type DestinationInstancesArrRelInsertInput = {
  data: Array<DestinationInstancesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DestinationInstancesOnConflict>;
};

/** aggregate avg on columns */
export type DestinationInstancesAvgFields = {
  __typename?: 'destination_instances_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "destination_instances" */
export type DestinationInstancesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "destination_instances". All fields are combined with a logical 'AND'. */
export type DestinationInstancesBoolExp = {
  _and?: InputMaybe<Array<DestinationInstancesBoolExp>>;
  _not?: InputMaybe<DestinationInstancesBoolExp>;
  _or?: InputMaybe<Array<DestinationInstancesBoolExp>>;
  alert_instances?: InputMaybe<AlertInstancesBoolExp>;
  alert_statuses?: InputMaybe<AlertStatusesBoolExp>;
  approved_draft_id?: InputMaybe<UuidComparisonExp>;
  clear_and_fill_hold_until?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsBoolExp>;
  draftByApprovedDraftId?: InputMaybe<DraftsBoolExp>;
  external_segments?: InputMaybe<ExternalSegmentsBoolExp>;
  force_run?: InputMaybe<BooleanComparisonExp>;
  full_resync?: InputMaybe<BooleanComparisonExp>;
  full_resync_interval?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_streaming?: InputMaybe<BooleanComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_planner_type?: InputMaybe<StringComparisonExp>;
  matchbooster_region?: InputMaybe<StringComparisonExp>;
  monitoring?: InputMaybe<JsonbComparisonExp>;
  row_threshold_attempted?: InputMaybe<BigintComparisonExp>;
  row_threshold_total?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync_requests?: InputMaybe<SyncRequestsBoolExp>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateBoolExp>;
  sync_sequence_members?: InputMaybe<SyncSequenceMembersBoolExp>;
  sync_sequence_requests?: InputMaybe<SyncSequenceRequestsBoolExp>;
  sync_template?: InputMaybe<SyncTemplatesBoolExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
  sync_template_overrides?: InputMaybe<JsonbComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  warehouse_history_config?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "destination_instances" */
export const DestinationInstancesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DestinationInstancesIdWorkspaceIdKey: 'destination_instances_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  DestinationInstancesPkey: 'destination_instances_pkey',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  DestinationInstancesWorkspaceIdSlugKey: 'destination_instances_workspace_id_slug_key'
} as const;

export type DestinationInstancesConstraint = typeof DestinationInstancesConstraint[keyof typeof DestinationInstancesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DestinationInstancesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  monitoring?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Array<Scalars['String']>>;
  sync_template_overrides?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  warehouse_history_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DestinationInstancesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  monitoring?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
  warehouse_history_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DestinationInstancesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  sync_template_overrides?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  warehouse_history_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "destination_instances" */
export type DestinationInstancesIncInput = {
  destination_id?: InputMaybe<Scalars['bigint']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "destination_instances" */
export type DestinationInstancesInsertInput = {
  alert_instances?: InputMaybe<AlertInstancesArrRelInsertInput>;
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsArrRelInsertInput>;
  draft?: InputMaybe<Scalars['Boolean']>;
  force_run?: InputMaybe<Scalars['Boolean']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  is_streaming?: InputMaybe<Scalars['Boolean']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  next_diff_mode_override?: InputMaybe<Scalars['String']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  sync_sequence_members?: InputMaybe<SyncSequenceMembersArrRelInsertInput>;
  sync_template?: InputMaybe<SyncTemplatesObjRelInsertInput>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type DestinationInstancesMaxFields = {
  __typename?: 'destination_instances_max_fields';
  approved_draft_id?: Maybe<Scalars['uuid']>;
  clear_and_fill_hold_until?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "sync_status" */
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "destination_instances" */
export type DestinationInstancesMaxOrderBy = {
  approved_draft_id?: InputMaybe<OrderBy>;
  clear_and_fill_hold_until?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DestinationInstancesMinFields = {
  __typename?: 'destination_instances_min_fields';
  approved_draft_id?: Maybe<Scalars['uuid']>;
  clear_and_fill_hold_until?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "sync_status" */
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "destination_instances" */
export type DestinationInstancesMinOrderBy = {
  approved_draft_id?: InputMaybe<OrderBy>;
  clear_and_fill_hold_until?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "destination_instances" */
export type DestinationInstancesMutationResponse = {
  __typename?: 'destination_instances_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DestinationInstances>;
};

/** input type for inserting object relation for remote table "destination_instances" */
export type DestinationInstancesObjRelInsertInput = {
  data: DestinationInstancesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DestinationInstancesOnConflict>;
};

/** on_conflict condition type for table "destination_instances" */
export type DestinationInstancesOnConflict = {
  constraint: DestinationInstancesConstraint;
  update_columns?: Array<DestinationInstancesUpdateColumn>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};

/** Ordering options when selecting data from "destination_instances". */
export type DestinationInstancesOrderBy = {
  alert_instances_aggregate?: InputMaybe<AlertInstancesAggregateOrderBy>;
  alert_statuses_aggregate?: InputMaybe<AlertStatusesAggregateOrderBy>;
  approved_draft_id?: InputMaybe<OrderBy>;
  clear_and_fill_hold_until?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  destination_instance_splits_aggregate?: InputMaybe<DestinationInstanceSplitsAggregateOrderBy>;
  draftByApprovedDraftId?: InputMaybe<DraftsOrderBy>;
  external_segments_aggregate?: InputMaybe<ExternalSegmentsAggregateOrderBy>;
  force_run?: InputMaybe<OrderBy>;
  full_resync?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_streaming?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  matchbooster_region?: InputMaybe<OrderBy>;
  monitoring?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateOrderBy>;
  sync_sequence_members_aggregate?: InputMaybe<SyncSequenceMembersAggregateOrderBy>;
  sync_sequence_requests_aggregate?: InputMaybe<SyncSequenceRequestsAggregateOrderBy>;
  sync_template?: InputMaybe<SyncTemplatesOrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  sync_template_overrides?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  warehouse_history_config?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: destination_instances */
export type DestinationInstancesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DestinationInstancesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "destination_instances" */
export const DestinationInstancesSelectColumn = {
  /** column name */
  ApprovedDraftId: 'approved_draft_id',
  /** column name */
  ClearAndFillHoldUntil: 'clear_and_fill_hold_until',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  FullResyncInterval: 'full_resync_interval',
  /** column name */
  Id: 'id',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunPlannerType: 'last_run_planner_type',
  /** column name */
  MatchboosterRegion: 'matchbooster_region',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  SyncTemplateOverrides: 'sync_template_overrides',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DestinationInstancesSelectColumn = typeof DestinationInstancesSelectColumn[keyof typeof DestinationInstancesSelectColumn];
/** select "destination_instances_aggregate_bool_exp_bool_and_arguments_columns" columns of table "destination_instances" */
export const DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolAndArgumentsColumns = typeof DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolAndArgumentsColumns];
/** select "destination_instances_aggregate_bool_exp_bool_or_arguments_columns" columns of table "destination_instances" */
export const DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolOrArgumentsColumns = typeof DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof DestinationInstancesSelectColumnDestinationInstancesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "destination_instances" */
export type DestinationInstancesSetInput = {
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  force_run?: InputMaybe<Scalars['Boolean']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  is_streaming?: InputMaybe<Scalars['Boolean']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  next_diff_mode_override?: InputMaybe<Scalars['String']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type DestinationInstancesStddevFields = {
  __typename?: 'destination_instances_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "destination_instances" */
export type DestinationInstancesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DestinationInstancesStddevPopFields = {
  __typename?: 'destination_instances_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "destination_instances" */
export type DestinationInstancesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DestinationInstancesStddevSampFields = {
  __typename?: 'destination_instances_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "destination_instances" */
export type DestinationInstancesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "destination_instances" */
export type DestinationInstancesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DestinationInstancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DestinationInstancesStreamCursorValueInput = {
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  clear_and_fill_hold_until?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  force_run?: InputMaybe<Scalars['Boolean']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_streaming?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_planner_type?: InputMaybe<Scalars['String']>;
  /** Match Booster region for this sync. Defaults to the model's region today; becomes user-settable for multi-region models. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DestinationInstancesSumFields = {
  __typename?: 'destination_instances_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "destination_instances" */
export type DestinationInstancesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "destination_instances" */
export const DestinationInstancesUpdateColumn = {
  /** column name */
  ApprovedDraftId: 'approved_draft_id',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Draft: 'draft',
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  FullResyncInterval: 'full_resync_interval',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  MatchboosterRegion: 'matchbooster_region',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  NextDiffModeOverride: 'next_diff_mode_override',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  SyncTemplateOverrides: 'sync_template_overrides',
  /** column name */
  Tags: 'tags',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config'
} as const;

export type DestinationInstancesUpdateColumn = typeof DestinationInstancesUpdateColumn[keyof typeof DestinationInstancesUpdateColumn];
export type DestinationInstancesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DestinationInstancesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DestinationInstancesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DestinationInstancesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DestinationInstancesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DestinationInstancesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DestinationInstancesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DestinationInstancesSetInput>;
  /** filter the rows which have to be updated */
  where: DestinationInstancesBoolExp;
};

/** aggregate var_pop on columns */
export type DestinationInstancesVarPopFields = {
  __typename?: 'destination_instances_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "destination_instances" */
export type DestinationInstancesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DestinationInstancesVarSampFields = {
  __typename?: 'destination_instances_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "destination_instances" */
export type DestinationInstancesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DestinationInstancesVarianceFields = {
  __typename?: 'destination_instances_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "destination_instances" */
export type DestinationInstancesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "destination_rules" */
export type DestinationRules = {
  __typename?: 'destination_rules';
  conditions: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "destination_rules" */
export type DestinationRulesConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "destination_rules" */
export type DestinationRulesAggregate = {
  __typename?: 'destination_rules_aggregate';
  aggregate?: Maybe<DestinationRulesAggregateFields>;
  nodes: Array<DestinationRules>;
};

export type DestinationRulesAggregateBoolExp = {
  count?: InputMaybe<DestinationRulesAggregateBoolExpCount>;
};

export type DestinationRulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationRulesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "destination_rules" */
export type DestinationRulesAggregateFields = {
  __typename?: 'destination_rules_aggregate_fields';
  avg?: Maybe<DestinationRulesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DestinationRulesMaxFields>;
  min?: Maybe<DestinationRulesMinFields>;
  stddev?: Maybe<DestinationRulesStddevFields>;
  stddev_pop?: Maybe<DestinationRulesStddevPopFields>;
  stddev_samp?: Maybe<DestinationRulesStddevSampFields>;
  sum?: Maybe<DestinationRulesSumFields>;
  var_pop?: Maybe<DestinationRulesVarPopFields>;
  var_samp?: Maybe<DestinationRulesVarSampFields>;
  variance?: Maybe<DestinationRulesVarianceFields>;
};


/** aggregate fields of "destination_rules" */
export type DestinationRulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "destination_rules" */
export type DestinationRulesAggregateOrderBy = {
  avg?: InputMaybe<DestinationRulesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DestinationRulesMaxOrderBy>;
  min?: InputMaybe<DestinationRulesMinOrderBy>;
  stddev?: InputMaybe<DestinationRulesStddevOrderBy>;
  stddev_pop?: InputMaybe<DestinationRulesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DestinationRulesStddevSampOrderBy>;
  sum?: InputMaybe<DestinationRulesSumOrderBy>;
  var_pop?: InputMaybe<DestinationRulesVarPopOrderBy>;
  var_samp?: InputMaybe<DestinationRulesVarSampOrderBy>;
  variance?: InputMaybe<DestinationRulesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DestinationRulesAppendInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "destination_rules" */
export type DestinationRulesArrRelInsertInput = {
  data: Array<DestinationRulesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DestinationRulesOnConflict>;
};

/** aggregate avg on columns */
export type DestinationRulesAvgFields = {
  __typename?: 'destination_rules_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "destination_rules" */
export type DestinationRulesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "destination_rules". All fields are combined with a logical 'AND'. */
export type DestinationRulesBoolExp = {
  _and?: InputMaybe<Array<DestinationRulesBoolExp>>;
  _not?: InputMaybe<DestinationRulesBoolExp>;
  _or?: InputMaybe<Array<DestinationRulesBoolExp>>;
  conditions?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "destination_rules" */
export const DestinationRulesConstraint = {
  /** unique or primary key constraint on columns "destination_id", "parent_model_id" */
  DestinationRulesParentModelIdDestinationIdKey: 'destination_rules_parent_model_id_destination_id_key',
  /** unique or primary key constraint on columns "id" */
  DestinationRulesPkey: 'destination_rules_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  DestinationRulesWorkspaceIdIdKey: 'destination_rules_workspace_id_id_key'
} as const;

export type DestinationRulesConstraint = typeof DestinationRulesConstraint[keyof typeof DestinationRulesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DestinationRulesDeleteAtPathInput = {
  conditions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DestinationRulesDeleteElemInput = {
  conditions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DestinationRulesDeleteKeyInput = {
  conditions?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "destination_rules" */
export type DestinationRulesInsertInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type DestinationRulesMaxFields = {
  __typename?: 'destination_rules_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "destination_rules" */
export type DestinationRulesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DestinationRulesMinFields = {
  __typename?: 'destination_rules_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "destination_rules" */
export type DestinationRulesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "destination_rules" */
export type DestinationRulesMutationResponse = {
  __typename?: 'destination_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DestinationRules>;
};

/** on_conflict condition type for table "destination_rules" */
export type DestinationRulesOnConflict = {
  constraint: DestinationRulesConstraint;
  update_columns?: Array<DestinationRulesUpdateColumn>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};

/** Ordering options when selecting data from "destination_rules". */
export type DestinationRulesOrderBy = {
  conditions?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: destination_rules */
export type DestinationRulesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DestinationRulesPrependInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "destination_rules" */
export const DestinationRulesSelectColumn = {
  /** column name */
  Conditions: 'conditions',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DestinationRulesSelectColumn = typeof DestinationRulesSelectColumn[keyof typeof DestinationRulesSelectColumn];
/** input type for updating data in table "destination_rules" */
export type DestinationRulesSetInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type DestinationRulesStddevFields = {
  __typename?: 'destination_rules_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "destination_rules" */
export type DestinationRulesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DestinationRulesStddevPopFields = {
  __typename?: 'destination_rules_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "destination_rules" */
export type DestinationRulesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DestinationRulesStddevSampFields = {
  __typename?: 'destination_rules_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "destination_rules" */
export type DestinationRulesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "destination_rules" */
export type DestinationRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DestinationRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DestinationRulesStreamCursorValueInput = {
  conditions?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DestinationRulesSumFields = {
  __typename?: 'destination_rules_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "destination_rules" */
export type DestinationRulesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "destination_rules" */
export const DestinationRulesUpdateColumn = {
  /** column name */
  Conditions: 'conditions'
} as const;

export type DestinationRulesUpdateColumn = typeof DestinationRulesUpdateColumn[keyof typeof DestinationRulesUpdateColumn];
export type DestinationRulesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DestinationRulesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DestinationRulesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DestinationRulesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DestinationRulesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DestinationRulesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DestinationRulesSetInput>;
  /** filter the rows which have to be updated */
  where: DestinationRulesBoolExp;
};

/** aggregate var_pop on columns */
export type DestinationRulesVarPopFields = {
  __typename?: 'destination_rules_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "destination_rules" */
export type DestinationRulesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DestinationRulesVarSampFields = {
  __typename?: 'destination_rules_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "destination_rules" */
export type DestinationRulesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DestinationRulesVarianceFields = {
  __typename?: 'destination_rules_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "destination_rules" */
export type DestinationRulesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "destinations" */
export type Destinations = {
  __typename?: 'destinations';
  analytics_ingestion_connection_id?: Maybe<Scalars['bigint']>;
  analytics_ingestion_schedule?: Maybe<Scalars['jsonb']>;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  credential_id?: Maybe<Scalars['bigint']>;
  definition: DestinationDefinition;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  /** An array relationship */
  destination_rules: Array<DestinationRules>;
  /** An aggregate relationship */
  destination_rules_aggregate: DestinationRulesAggregate;
  /** An array relationship */
  event_forwarding_syncs: Array<EventForwardingSyncs>;
  id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  setup_complete: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  stripped_config: Scalars['JSONObject'];
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  tags: Scalars['jsonb'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "destinations" */
export type DestinationsAnalyticsIngestionScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destinations" */
export type DestinationsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "destinations" */
export type DestinationsDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsDestinationRulesArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsDestinationRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsEventForwardingSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncsOrderBy>>;
  where?: InputMaybe<EventForwardingSyncsBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsSyncsArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


/** columns and relationships of "destinations" */
export type DestinationsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "destinations" */
export type DestinationsAggregate = {
  __typename?: 'destinations_aggregate';
  aggregate?: Maybe<DestinationsAggregateFields>;
  nodes: Array<Destinations>;
};

export type DestinationsAggregateBoolExp = {
  bool_and?: InputMaybe<DestinationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<DestinationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<DestinationsAggregateBoolExpCount>;
};

export type DestinationsAggregateBoolExpBoolAnd = {
  arguments: DestinationsSelectColumnDestinationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DestinationsAggregateBoolExpBoolOr = {
  arguments: DestinationsSelectColumnDestinationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DestinationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DestinationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DestinationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "destinations" */
export type DestinationsAggregateFields = {
  __typename?: 'destinations_aggregate_fields';
  avg?: Maybe<DestinationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DestinationsMaxFields>;
  min?: Maybe<DestinationsMinFields>;
  stddev?: Maybe<DestinationsStddevFields>;
  stddev_pop?: Maybe<DestinationsStddevPopFields>;
  stddev_samp?: Maybe<DestinationsStddevSampFields>;
  sum?: Maybe<DestinationsSumFields>;
  var_pop?: Maybe<DestinationsVarPopFields>;
  var_samp?: Maybe<DestinationsVarSampFields>;
  variance?: Maybe<DestinationsVarianceFields>;
};


/** aggregate fields of "destinations" */
export type DestinationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DestinationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "destinations" */
export type DestinationsAggregateOrderBy = {
  avg?: InputMaybe<DestinationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DestinationsMaxOrderBy>;
  min?: InputMaybe<DestinationsMinOrderBy>;
  stddev?: InputMaybe<DestinationsStddevOrderBy>;
  stddev_pop?: InputMaybe<DestinationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DestinationsStddevSampOrderBy>;
  sum?: InputMaybe<DestinationsSumOrderBy>;
  var_pop?: InputMaybe<DestinationsVarPopOrderBy>;
  var_samp?: InputMaybe<DestinationsVarSampOrderBy>;
  variance?: InputMaybe<DestinationsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type DestinationsAvgFields = {
  __typename?: 'destinations_avg_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "destinations" */
export type DestinationsAvgOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "destinations". All fields are combined with a logical 'AND'. */
export type DestinationsBoolExp = {
  _and?: InputMaybe<Array<DestinationsBoolExp>>;
  _not?: InputMaybe<DestinationsBoolExp>;
  _or?: InputMaybe<Array<DestinationsBoolExp>>;
  analytics_ingestion_connection_id?: InputMaybe<BigintComparisonExp>;
  analytics_ingestion_schedule?: InputMaybe<JsonbComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  credential_id?: InputMaybe<BigintComparisonExp>;
  destination_instances?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateBoolExp>;
  destination_rules?: InputMaybe<DestinationRulesBoolExp>;
  destination_rules_aggregate?: InputMaybe<DestinationRulesAggregateBoolExp>;
  event_forwarding_syncs?: InputMaybe<EventForwardingSyncsBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  setup_complete?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  syncs?: InputMaybe<SyncsBoolExp>;
  syncs_aggregate?: InputMaybe<SyncsAggregateBoolExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type DestinationsMaxFields = {
  __typename?: 'destinations_max_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "destinations" */
export type DestinationsMaxOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DestinationsMinFields = {
  __typename?: 'destinations_min_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "destinations" */
export type DestinationsMinOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "destinations" */
export type DestinationsMutationResponse = {
  __typename?: 'destinations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Destinations>;
};

/** Ordering options when selecting data from "destinations". */
export type DestinationsOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  analytics_ingestion_schedule?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateOrderBy>;
  destination_rules_aggregate?: InputMaybe<DestinationRulesAggregateOrderBy>;
  event_forwarding_syncs_aggregate?: InputMaybe<EventForwardingSyncsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  setup_complete?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  syncs_aggregate?: InputMaybe<SyncsAggregateOrderBy>;
  tags?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "destinations" */
export const DestinationsSelectColumn = {
  /** column name */
  AnalyticsIngestionConnectionId: 'analytics_ingestion_connection_id',
  /** column name */
  AnalyticsIngestionSchedule: 'analytics_ingestion_schedule',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DestinationsSelectColumn = typeof DestinationsSelectColumn[keyof typeof DestinationsSelectColumn];
/** select "destinations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "destinations" */
export const DestinationsSelectColumnDestinationsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  SetupComplete: 'setup_complete'
} as const;

export type DestinationsSelectColumnDestinationsAggregateBoolExpBoolAndArgumentsColumns = typeof DestinationsSelectColumnDestinationsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof DestinationsSelectColumnDestinationsAggregateBoolExpBoolAndArgumentsColumns];
/** select "destinations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "destinations" */
export const DestinationsSelectColumnDestinationsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  SetupComplete: 'setup_complete'
} as const;

export type DestinationsSelectColumnDestinationsAggregateBoolExpBoolOrArgumentsColumns = typeof DestinationsSelectColumnDestinationsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof DestinationsSelectColumnDestinationsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type DestinationsStddevFields = {
  __typename?: 'destinations_stddev_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "destinations" */
export type DestinationsStddevOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DestinationsStddevPopFields = {
  __typename?: 'destinations_stddev_pop_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "destinations" */
export type DestinationsStddevPopOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DestinationsStddevSampFields = {
  __typename?: 'destinations_stddev_samp_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "destinations" */
export type DestinationsStddevSampOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "destinations" */
export type DestinationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DestinationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DestinationsStreamCursorValueInput = {
  analytics_ingestion_connection_id?: InputMaybe<Scalars['bigint']>;
  analytics_ingestion_schedule?: InputMaybe<Scalars['jsonb']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  setup_complete?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DestinationsSumFields = {
  __typename?: 'destinations_sum_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "destinations" */
export type DestinationsSumOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type DestinationsVarPopFields = {
  __typename?: 'destinations_var_pop_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "destinations" */
export type DestinationsVarPopOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DestinationsVarSampFields = {
  __typename?: 'destinations_var_samp_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "destinations" */
export type DestinationsVarSampOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DestinationsVarianceFields = {
  __typename?: 'destinations_variance_fields';
  analytics_ingestion_connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "destinations" */
export type DestinationsVarianceOrderBy = {
  analytics_ingestion_connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "direct_model_relationships" */
export type DirectModelRelationships = {
  __typename?: 'direct_model_relationships';
  from_column: Scalars['String'];
  from_model_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
  /** An object relationship */
  to_model: Segments;
  to_model_id: Scalars['bigint'];
};

/** order by aggregate values of table "direct_model_relationships" */
export type DirectModelRelationshipsAggregateOrderBy = {
  avg?: InputMaybe<DirectModelRelationshipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DirectModelRelationshipsMaxOrderBy>;
  min?: InputMaybe<DirectModelRelationshipsMinOrderBy>;
  stddev?: InputMaybe<DirectModelRelationshipsStddevOrderBy>;
  stddev_pop?: InputMaybe<DirectModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DirectModelRelationshipsStddevSampOrderBy>;
  sum?: InputMaybe<DirectModelRelationshipsSumOrderBy>;
  var_pop?: InputMaybe<DirectModelRelationshipsVarPopOrderBy>;
  var_samp?: InputMaybe<DirectModelRelationshipsVarSampOrderBy>;
  variance?: InputMaybe<DirectModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "direct_model_relationships" */
export type DirectModelRelationshipsArrRelInsertInput = {
  data: Array<DirectModelRelationshipsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DirectModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsAvgOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "direct_model_relationships". All fields are combined with a logical 'AND'. */
export type DirectModelRelationshipsBoolExp = {
  _and?: InputMaybe<Array<DirectModelRelationshipsBoolExp>>;
  _not?: InputMaybe<DirectModelRelationshipsBoolExp>;
  _or?: InputMaybe<Array<DirectModelRelationshipsBoolExp>>;
  from_column?: InputMaybe<StringComparisonExp>;
  from_model_id?: InputMaybe<BigintComparisonExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
  to_column?: InputMaybe<StringComparisonExp>;
  to_model?: InputMaybe<SegmentsBoolExp>;
  to_model_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "direct_model_relationships" */
export const DirectModelRelationshipsConstraint = {
  /** unique or primary key constraint on columns "to_column", "relationship_id", "from_column" */
  DirectModelRelationshipsPkey: 'direct_model_relationships_pkey'
} as const;

export type DirectModelRelationshipsConstraint = typeof DirectModelRelationshipsConstraint[keyof typeof DirectModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "direct_model_relationships" */
export type DirectModelRelationshipsIncInput = {
  from_model_id?: InputMaybe<Scalars['bigint']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "direct_model_relationships" */
export type DirectModelRelationshipsInsertInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_model_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_model?: InputMaybe<SegmentsObjRelInsertInput>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsMaxOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsMinOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "direct_model_relationships" */
export type DirectModelRelationshipsMutationResponse = {
  __typename?: 'direct_model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DirectModelRelationships>;
};

/** on_conflict condition type for table "direct_model_relationships" */
export type DirectModelRelationshipsOnConflict = {
  constraint: DirectModelRelationshipsConstraint;
  update_columns?: Array<DirectModelRelationshipsUpdateColumn>;
  where?: InputMaybe<DirectModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "direct_model_relationships". */
export type DirectModelRelationshipsOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_model?: InputMaybe<SegmentsOrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: direct_model_relationships */
export type DirectModelRelationshipsPkColumnsInput = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};

/** select columns of table "direct_model_relationships" */
export const DirectModelRelationshipsSelectColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type DirectModelRelationshipsSelectColumn = typeof DirectModelRelationshipsSelectColumn[keyof typeof DirectModelRelationshipsSelectColumn];
/** input type for updating data in table "direct_model_relationships" */
export type DirectModelRelationshipsSetInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_model_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevPopOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsStddevSampOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "direct_model_relationships" */
export type DirectModelRelationshipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DirectModelRelationshipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DirectModelRelationshipsStreamCursorValueInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_model_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsSumOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** update columns of table "direct_model_relationships" */
export const DirectModelRelationshipsUpdateColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type DirectModelRelationshipsUpdateColumn = typeof DirectModelRelationshipsUpdateColumn[keyof typeof DirectModelRelationshipsUpdateColumn];
export type DirectModelRelationshipsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DirectModelRelationshipsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DirectModelRelationshipsSetInput>;
  /** filter the rows which have to be updated */
  where: DirectModelRelationshipsBoolExp;
};

/** order by var_pop() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarPopOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarSampOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "direct_model_relationships" */
export type DirectModelRelationshipsVarianceOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "draft_approval_requests" */
export type DraftApprovalRequests = {
  __typename?: 'draft_approval_requests';
  /** An object relationship */
  draft?: Maybe<Drafts>;
  draft_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "draft_approval_requests" */
export type DraftApprovalRequestsAggregateOrderBy = {
  avg?: InputMaybe<DraftApprovalRequestsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DraftApprovalRequestsMaxOrderBy>;
  min?: InputMaybe<DraftApprovalRequestsMinOrderBy>;
  stddev?: InputMaybe<DraftApprovalRequestsStddevOrderBy>;
  stddev_pop?: InputMaybe<DraftApprovalRequestsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DraftApprovalRequestsStddevSampOrderBy>;
  sum?: InputMaybe<DraftApprovalRequestsSumOrderBy>;
  var_pop?: InputMaybe<DraftApprovalRequestsVarPopOrderBy>;
  var_samp?: InputMaybe<DraftApprovalRequestsVarSampOrderBy>;
  variance?: InputMaybe<DraftApprovalRequestsVarianceOrderBy>;
};

/** order by avg() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "draft_approval_requests". All fields are combined with a logical 'AND'. */
export type DraftApprovalRequestsBoolExp = {
  _and?: InputMaybe<Array<DraftApprovalRequestsBoolExp>>;
  _not?: InputMaybe<DraftApprovalRequestsBoolExp>;
  _or?: InputMaybe<Array<DraftApprovalRequestsBoolExp>>;
  draft?: InputMaybe<DraftsBoolExp>;
  draft_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsMaxOrderBy = {
  draft_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsMinOrderBy = {
  draft_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "draft_approval_requests". */
export type DraftApprovalRequestsOrderBy = {
  draft?: InputMaybe<DraftsOrderBy>;
  draft_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "draft_approval_requests" */
export const DraftApprovalRequestsSelectColumn = {
  /** column name */
  DraftId: 'draft_id',
  /** column name */
  Id: 'id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DraftApprovalRequestsSelectColumn = typeof DraftApprovalRequestsSelectColumn[keyof typeof DraftApprovalRequestsSelectColumn];
/** order by stddev() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "draft_approval_requests" */
export type DraftApprovalRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DraftApprovalRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DraftApprovalRequestsStreamCursorValueInput = {
  draft_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "draft_approval_requests" */
export type DraftApprovalRequestsVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "drafts" */
export type Drafts = {
  __typename?: 'drafts';
  applied_at?: Maybe<Scalars['timestamptz']>;
  applied_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  applied_by_user?: Maybe<Users>;
  /** An array relationship */
  approval_requests: Array<DraftApprovalRequests>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  model?: Maybe<Segments>;
  new_resource?: Maybe<Scalars['jsonb']>;
  old_resource?: Maybe<Scalars['jsonb']>;
  operation?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  review_metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  segments: Array<Segments>;
  /** An aggregate relationship */
  segments_aggregate: SegmentsAggregate;
  status: Scalars['String'];
  /** An object relationship */
  sync?: Maybe<Syncs>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "drafts" */
export type DraftsApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<DraftApprovalRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftApprovalRequestsOrderBy>>;
  where?: InputMaybe<DraftApprovalRequestsBoolExp>;
};


/** columns and relationships of "drafts" */
export type DraftsDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "drafts" */
export type DraftsDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "drafts" */
export type DraftsNewResourceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "drafts" */
export type DraftsOldResourceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "drafts" */
export type DraftsReviewMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "drafts" */
export type DraftsSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


/** columns and relationships of "drafts" */
export type DraftsSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};

/** aggregated selection of "drafts" */
export type DraftsAggregate = {
  __typename?: 'drafts_aggregate';
  aggregate?: Maybe<DraftsAggregateFields>;
  nodes: Array<Drafts>;
};

/** aggregate fields of "drafts" */
export type DraftsAggregateFields = {
  __typename?: 'drafts_aggregate_fields';
  avg?: Maybe<DraftsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DraftsMaxFields>;
  min?: Maybe<DraftsMinFields>;
  stddev?: Maybe<DraftsStddevFields>;
  stddev_pop?: Maybe<DraftsStddevPopFields>;
  stddev_samp?: Maybe<DraftsStddevSampFields>;
  sum?: Maybe<DraftsSumFields>;
  var_pop?: Maybe<DraftsVarPopFields>;
  var_samp?: Maybe<DraftsVarSampFields>;
  variance?: Maybe<DraftsVarianceFields>;
};


/** aggregate fields of "drafts" */
export type DraftsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DraftsAvgFields = {
  __typename?: 'drafts_avg_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "drafts". All fields are combined with a logical 'AND'. */
export type DraftsBoolExp = {
  _and?: InputMaybe<Array<DraftsBoolExp>>;
  _not?: InputMaybe<DraftsBoolExp>;
  _or?: InputMaybe<Array<DraftsBoolExp>>;
  applied_at?: InputMaybe<TimestamptzComparisonExp>;
  applied_by?: InputMaybe<BigintComparisonExp>;
  applied_by_user?: InputMaybe<UsersBoolExp>;
  approval_requests?: InputMaybe<DraftApprovalRequestsBoolExp>;
  comment?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  destination_instances?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  new_resource?: InputMaybe<JsonbComparisonExp>;
  old_resource?: InputMaybe<JsonbComparisonExp>;
  operation?: InputMaybe<StringComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  review_metadata?: InputMaybe<JsonbComparisonExp>;
  segments?: InputMaybe<SegmentsBoolExp>;
  segments_aggregate?: InputMaybe<SegmentsAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type DraftsMaxFields = {
  __typename?: 'drafts_max_fields';
  applied_at?: Maybe<Scalars['timestamptz']>;
  applied_by?: Maybe<Scalars['bigint']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DraftsMinFields = {
  __typename?: 'drafts_min_fields';
  applied_at?: Maybe<Scalars['timestamptz']>;
  applied_by?: Maybe<Scalars['bigint']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  operation?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "drafts" */
export type DraftsMutationResponse = {
  __typename?: 'drafts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Drafts>;
};

/** Ordering options when selecting data from "drafts". */
export type DraftsOrderBy = {
  applied_at?: InputMaybe<OrderBy>;
  applied_by?: InputMaybe<OrderBy>;
  applied_by_user?: InputMaybe<UsersOrderBy>;
  approval_requests_aggregate?: InputMaybe<DraftApprovalRequestsAggregateOrderBy>;
  comment?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  new_resource?: InputMaybe<OrderBy>;
  old_resource?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  review_metadata?: InputMaybe<OrderBy>;
  segments_aggregate?: InputMaybe<SegmentsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "drafts" */
export const DraftsSelectColumn = {
  /** column name */
  AppliedAt: 'applied_at',
  /** column name */
  AppliedBy: 'applied_by',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  NewResource: 'new_resource',
  /** column name */
  OldResource: 'old_resource',
  /** column name */
  Operation: 'operation',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  ReviewMetadata: 'review_metadata',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type DraftsSelectColumn = typeof DraftsSelectColumn[keyof typeof DraftsSelectColumn];
/** aggregate stddev on columns */
export type DraftsStddevFields = {
  __typename?: 'drafts_stddev_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DraftsStddevPopFields = {
  __typename?: 'drafts_stddev_pop_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DraftsStddevSampFields = {
  __typename?: 'drafts_stddev_samp_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "drafts" */
export type DraftsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DraftsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DraftsStreamCursorValueInput = {
  applied_at?: InputMaybe<Scalars['timestamptz']>;
  applied_by?: InputMaybe<Scalars['bigint']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_resource?: InputMaybe<Scalars['jsonb']>;
  old_resource?: InputMaybe<Scalars['jsonb']>;
  operation?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  review_metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DraftsSumFields = {
  __typename?: 'drafts_sum_fields';
  applied_by?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type DraftsVarPopFields = {
  __typename?: 'drafts_var_pop_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DraftsVarSampFields = {
  __typename?: 'drafts_var_samp_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DraftsVarianceFields = {
  __typename?: 'drafts_variance_fields';
  applied_by?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "email_template_labels" */
export type EmailTemplateLabels = {
  __typename?: 'email_template_labels';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  email_template: CepEmailTemplates;
  email_template_id: Scalars['uuid'];
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "email_template_labels" */
export type EmailTemplateLabelsAggregate = {
  __typename?: 'email_template_labels_aggregate';
  aggregate?: Maybe<EmailTemplateLabelsAggregateFields>;
  nodes: Array<EmailTemplateLabels>;
};

export type EmailTemplateLabelsAggregateBoolExp = {
  count?: InputMaybe<EmailTemplateLabelsAggregateBoolExpCount>;
};

export type EmailTemplateLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EmailTemplateLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "email_template_labels" */
export type EmailTemplateLabelsAggregateFields = {
  __typename?: 'email_template_labels_aggregate_fields';
  avg?: Maybe<EmailTemplateLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EmailTemplateLabelsMaxFields>;
  min?: Maybe<EmailTemplateLabelsMinFields>;
  stddev?: Maybe<EmailTemplateLabelsStddevFields>;
  stddev_pop?: Maybe<EmailTemplateLabelsStddevPopFields>;
  stddev_samp?: Maybe<EmailTemplateLabelsStddevSampFields>;
  sum?: Maybe<EmailTemplateLabelsSumFields>;
  var_pop?: Maybe<EmailTemplateLabelsVarPopFields>;
  var_samp?: Maybe<EmailTemplateLabelsVarSampFields>;
  variance?: Maybe<EmailTemplateLabelsVarianceFields>;
};


/** aggregate fields of "email_template_labels" */
export type EmailTemplateLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_template_labels" */
export type EmailTemplateLabelsAggregateOrderBy = {
  avg?: InputMaybe<EmailTemplateLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EmailTemplateLabelsMaxOrderBy>;
  min?: InputMaybe<EmailTemplateLabelsMinOrderBy>;
  stddev?: InputMaybe<EmailTemplateLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<EmailTemplateLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EmailTemplateLabelsStddevSampOrderBy>;
  sum?: InputMaybe<EmailTemplateLabelsSumOrderBy>;
  var_pop?: InputMaybe<EmailTemplateLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<EmailTemplateLabelsVarSampOrderBy>;
  variance?: InputMaybe<EmailTemplateLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "email_template_labels" */
export type EmailTemplateLabelsArrRelInsertInput = {
  data: Array<EmailTemplateLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EmailTemplateLabelsOnConflict>;
};

/** aggregate avg on columns */
export type EmailTemplateLabelsAvgFields = {
  __typename?: 'email_template_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "email_template_labels" */
export type EmailTemplateLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "email_template_labels". All fields are combined with a logical 'AND'. */
export type EmailTemplateLabelsBoolExp = {
  _and?: InputMaybe<Array<EmailTemplateLabelsBoolExp>>;
  _not?: InputMaybe<EmailTemplateLabelsBoolExp>;
  _or?: InputMaybe<Array<EmailTemplateLabelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  email_template?: InputMaybe<CepEmailTemplatesBoolExp>;
  email_template_id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "email_template_labels" */
export const EmailTemplateLabelsConstraint = {
  /** unique or primary key constraint on columns "label_id", "email_template_id" */
  EmailTemplateLabelsPkey: 'email_template_labels_pkey'
} as const;

export type EmailTemplateLabelsConstraint = typeof EmailTemplateLabelsConstraint[keyof typeof EmailTemplateLabelsConstraint];
/** input type for inserting data into table "email_template_labels" */
export type EmailTemplateLabelsInsertInput = {
  email_template?: InputMaybe<CepEmailTemplatesObjRelInsertInput>;
  email_template_id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EmailTemplateLabelsMaxFields = {
  __typename?: 'email_template_labels_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  email_template_id?: Maybe<Scalars['uuid']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "email_template_labels" */
export type EmailTemplateLabelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  email_template_id?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EmailTemplateLabelsMinFields = {
  __typename?: 'email_template_labels_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  email_template_id?: Maybe<Scalars['uuid']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "email_template_labels" */
export type EmailTemplateLabelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  email_template_id?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "email_template_labels" */
export type EmailTemplateLabelsMutationResponse = {
  __typename?: 'email_template_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailTemplateLabels>;
};

/** on_conflict condition type for table "email_template_labels" */
export type EmailTemplateLabelsOnConflict = {
  constraint: EmailTemplateLabelsConstraint;
  update_columns?: Array<EmailTemplateLabelsUpdateColumn>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};

/** Ordering options when selecting data from "email_template_labels". */
export type EmailTemplateLabelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  email_template?: InputMaybe<CepEmailTemplatesOrderBy>;
  email_template_id?: InputMaybe<OrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "email_template_labels" */
export const EmailTemplateLabelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EmailTemplateId: 'email_template_id',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EmailTemplateLabelsSelectColumn = typeof EmailTemplateLabelsSelectColumn[keyof typeof EmailTemplateLabelsSelectColumn];
/** aggregate stddev on columns */
export type EmailTemplateLabelsStddevFields = {
  __typename?: 'email_template_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "email_template_labels" */
export type EmailTemplateLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EmailTemplateLabelsStddevPopFields = {
  __typename?: 'email_template_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "email_template_labels" */
export type EmailTemplateLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EmailTemplateLabelsStddevSampFields = {
  __typename?: 'email_template_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "email_template_labels" */
export type EmailTemplateLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "email_template_labels" */
export type EmailTemplateLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EmailTemplateLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailTemplateLabelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  email_template_id?: InputMaybe<Scalars['uuid']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EmailTemplateLabelsSumFields = {
  __typename?: 'email_template_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "email_template_labels" */
export type EmailTemplateLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "email_template_labels" (current role has no relevant permissions) */
export const EmailTemplateLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type EmailTemplateLabelsUpdateColumn = typeof EmailTemplateLabelsUpdateColumn[keyof typeof EmailTemplateLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type EmailTemplateLabelsVarPopFields = {
  __typename?: 'email_template_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "email_template_labels" */
export type EmailTemplateLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EmailTemplateLabelsVarSampFields = {
  __typename?: 'email_template_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "email_template_labels" */
export type EmailTemplateLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EmailTemplateLabelsVarianceFields = {
  __typename?: 'email_template_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "email_template_labels" */
export type EmailTemplateLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "esp_catalog_state" */
export type EspCatalogState = {
  __typename?: 'esp_catalog_state';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** Operator-safe summary only — never a provider response body, request URL, or serialized error object. Sanitized and length-bounded at the writer. */
  last_error?: Maybe<Scalars['String']>;
  refreshed_at?: Maybe<Scalars['timestamptz']>;
  refreshing_since?: Maybe<Scalars['timestamptz']>;
  resource: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "esp_catalog_state". All fields are combined with a logical 'AND'. */
export type EspCatalogStateBoolExp = {
  _and?: InputMaybe<Array<EspCatalogStateBoolExp>>;
  _not?: InputMaybe<EspCatalogStateBoolExp>;
  _or?: InputMaybe<Array<EspCatalogStateBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_error?: InputMaybe<StringComparisonExp>;
  refreshed_at?: InputMaybe<TimestamptzComparisonExp>;
  refreshing_since?: InputMaybe<TimestamptzComparisonExp>;
  resource?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "esp_catalog_state". */
export type EspCatalogStateOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_error?: InputMaybe<OrderBy>;
  refreshed_at?: InputMaybe<OrderBy>;
  refreshing_since?: InputMaybe<OrderBy>;
  resource?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "esp_catalog_state" */
export const EspCatalogStateSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastError: 'last_error',
  /** column name */
  RefreshedAt: 'refreshed_at',
  /** column name */
  RefreshingSince: 'refreshing_since',
  /** column name */
  Resource: 'resource',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EspCatalogStateSelectColumn = typeof EspCatalogStateSelectColumn[keyof typeof EspCatalogStateSelectColumn];
/** Streaming cursor of the table "esp_catalog_state" */
export type EspCatalogStateStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EspCatalogStateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EspCatalogStateStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Operator-safe summary only — never a provider response body, request URL, or serialized error object. Sanitized and length-bounded at the writer. */
  last_error?: InputMaybe<Scalars['String']>;
  refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  refreshing_since?: InputMaybe<Scalars['timestamptz']>;
  resource?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "esp_content_blocks" */
export type EspContentBlocks = {
  __typename?: 'esp_content_blocks';
  content?: Maybe<Scalars['String']>;
  content_fetched_at?: Maybe<Scalars['timestamptz']>;
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  external_id: Scalars['String'];
  external_updated_at?: Maybe<Scalars['timestamptz']>;
  fetched_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  parameters?: Maybe<Scalars['jsonb']>;
  provider_metadata?: Maybe<Scalars['jsonb']>;
  reference_tag?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "esp_content_blocks" */
export type EspContentBlocksParametersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "esp_content_blocks" */
export type EspContentBlocksProviderMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "esp_content_blocks" */
export type EspContentBlocksAggregate = {
  __typename?: 'esp_content_blocks_aggregate';
  aggregate?: Maybe<EspContentBlocksAggregateFields>;
  nodes: Array<EspContentBlocks>;
};

/** aggregate fields of "esp_content_blocks" */
export type EspContentBlocksAggregateFields = {
  __typename?: 'esp_content_blocks_aggregate_fields';
  avg?: Maybe<EspContentBlocksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EspContentBlocksMaxFields>;
  min?: Maybe<EspContentBlocksMinFields>;
  stddev?: Maybe<EspContentBlocksStddevFields>;
  stddev_pop?: Maybe<EspContentBlocksStddevPopFields>;
  stddev_samp?: Maybe<EspContentBlocksStddevSampFields>;
  sum?: Maybe<EspContentBlocksSumFields>;
  var_pop?: Maybe<EspContentBlocksVarPopFields>;
  var_samp?: Maybe<EspContentBlocksVarSampFields>;
  variance?: Maybe<EspContentBlocksVarianceFields>;
};


/** aggregate fields of "esp_content_blocks" */
export type EspContentBlocksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EspContentBlocksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EspContentBlocksAvgFields = {
  __typename?: 'esp_content_blocks_avg_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "esp_content_blocks". All fields are combined with a logical 'AND'. */
export type EspContentBlocksBoolExp = {
  _and?: InputMaybe<Array<EspContentBlocksBoolExp>>;
  _not?: InputMaybe<EspContentBlocksBoolExp>;
  _or?: InputMaybe<Array<EspContentBlocksBoolExp>>;
  content?: InputMaybe<StringComparisonExp>;
  content_fetched_at?: InputMaybe<TimestamptzComparisonExp>;
  content_type?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  external_id?: InputMaybe<StringComparisonExp>;
  external_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  fetched_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parameters?: InputMaybe<JsonbComparisonExp>;
  provider_metadata?: InputMaybe<JsonbComparisonExp>;
  reference_tag?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EspContentBlocksMaxFields = {
  __typename?: 'esp_content_blocks_max_fields';
  content?: Maybe<Scalars['String']>;
  content_fetched_at?: Maybe<Scalars['timestamptz']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  external_id?: Maybe<Scalars['String']>;
  external_updated_at?: Maybe<Scalars['timestamptz']>;
  fetched_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  reference_tag?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EspContentBlocksMinFields = {
  __typename?: 'esp_content_blocks_min_fields';
  content?: Maybe<Scalars['String']>;
  content_fetched_at?: Maybe<Scalars['timestamptz']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  external_id?: Maybe<Scalars['String']>;
  external_updated_at?: Maybe<Scalars['timestamptz']>;
  fetched_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  reference_tag?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "esp_content_blocks" */
export type EspContentBlocksMutationResponse = {
  __typename?: 'esp_content_blocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EspContentBlocks>;
};

/** Ordering options when selecting data from "esp_content_blocks". */
export type EspContentBlocksOrderBy = {
  content?: InputMaybe<OrderBy>;
  content_fetched_at?: InputMaybe<OrderBy>;
  content_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  external_updated_at?: InputMaybe<OrderBy>;
  fetched_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parameters?: InputMaybe<OrderBy>;
  provider_metadata?: InputMaybe<OrderBy>;
  reference_tag?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "esp_content_blocks" */
export const EspContentBlocksSelectColumn = {
  /** column name */
  Content: 'content',
  /** column name */
  ContentFetchedAt: 'content_fetched_at',
  /** column name */
  ContentType: 'content_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  ExternalUpdatedAt: 'external_updated_at',
  /** column name */
  FetchedAt: 'fetched_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Parameters: 'parameters',
  /** column name */
  ProviderMetadata: 'provider_metadata',
  /** column name */
  ReferenceTag: 'reference_tag',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EspContentBlocksSelectColumn = typeof EspContentBlocksSelectColumn[keyof typeof EspContentBlocksSelectColumn];
/** aggregate stddev on columns */
export type EspContentBlocksStddevFields = {
  __typename?: 'esp_content_blocks_stddev_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EspContentBlocksStddevPopFields = {
  __typename?: 'esp_content_blocks_stddev_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EspContentBlocksStddevSampFields = {
  __typename?: 'esp_content_blocks_stddev_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "esp_content_blocks" */
export type EspContentBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EspContentBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EspContentBlocksStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  content_fetched_at?: InputMaybe<Scalars['timestamptz']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  external_id?: InputMaybe<Scalars['String']>;
  external_updated_at?: InputMaybe<Scalars['timestamptz']>;
  fetched_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Scalars['jsonb']>;
  provider_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_tag?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EspContentBlocksSumFields = {
  __typename?: 'esp_content_blocks_sum_fields';
  destination_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type EspContentBlocksVarPopFields = {
  __typename?: 'esp_content_blocks_var_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EspContentBlocksVarSampFields = {
  __typename?: 'esp_content_blocks_var_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EspContentBlocksVarianceFields = {
  __typename?: 'esp_content_blocks_variance_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "esp_user_fields" */
export type EspUserFields = {
  __typename?: 'esp_user_fields';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  fetched_at: Scalars['timestamptz'];
  field_type?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  merge_tag: Scalars['String'];
  name: Scalars['String'];
  source: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "esp_user_fields" */
export type EspUserFieldsAggregate = {
  __typename?: 'esp_user_fields_aggregate';
  aggregate?: Maybe<EspUserFieldsAggregateFields>;
  nodes: Array<EspUserFields>;
};

/** aggregate fields of "esp_user_fields" */
export type EspUserFieldsAggregateFields = {
  __typename?: 'esp_user_fields_aggregate_fields';
  avg?: Maybe<EspUserFieldsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EspUserFieldsMaxFields>;
  min?: Maybe<EspUserFieldsMinFields>;
  stddev?: Maybe<EspUserFieldsStddevFields>;
  stddev_pop?: Maybe<EspUserFieldsStddevPopFields>;
  stddev_samp?: Maybe<EspUserFieldsStddevSampFields>;
  sum?: Maybe<EspUserFieldsSumFields>;
  var_pop?: Maybe<EspUserFieldsVarPopFields>;
  var_samp?: Maybe<EspUserFieldsVarSampFields>;
  variance?: Maybe<EspUserFieldsVarianceFields>;
};


/** aggregate fields of "esp_user_fields" */
export type EspUserFieldsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EspUserFieldsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EspUserFieldsAvgFields = {
  __typename?: 'esp_user_fields_avg_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "esp_user_fields". All fields are combined with a logical 'AND'. */
export type EspUserFieldsBoolExp = {
  _and?: InputMaybe<Array<EspUserFieldsBoolExp>>;
  _not?: InputMaybe<EspUserFieldsBoolExp>;
  _or?: InputMaybe<Array<EspUserFieldsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  fetched_at?: InputMaybe<TimestamptzComparisonExp>;
  field_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merge_tag?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EspUserFieldsMaxFields = {
  __typename?: 'esp_user_fields_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  fetched_at?: Maybe<Scalars['timestamptz']>;
  field_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merge_tag?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EspUserFieldsMinFields = {
  __typename?: 'esp_user_fields_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  fetched_at?: Maybe<Scalars['timestamptz']>;
  field_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merge_tag?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "esp_user_fields" */
export type EspUserFieldsMutationResponse = {
  __typename?: 'esp_user_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EspUserFields>;
};

/** Ordering options when selecting data from "esp_user_fields". */
export type EspUserFieldsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  fetched_at?: InputMaybe<OrderBy>;
  field_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merge_tag?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "esp_user_fields" */
export const EspUserFieldsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  FetchedAt: 'fetched_at',
  /** column name */
  FieldType: 'field_type',
  /** column name */
  Id: 'id',
  /** column name */
  MergeTag: 'merge_tag',
  /** column name */
  Name: 'name',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EspUserFieldsSelectColumn = typeof EspUserFieldsSelectColumn[keyof typeof EspUserFieldsSelectColumn];
/** aggregate stddev on columns */
export type EspUserFieldsStddevFields = {
  __typename?: 'esp_user_fields_stddev_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EspUserFieldsStddevPopFields = {
  __typename?: 'esp_user_fields_stddev_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EspUserFieldsStddevSampFields = {
  __typename?: 'esp_user_fields_stddev_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "esp_user_fields" */
export type EspUserFieldsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EspUserFieldsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EspUserFieldsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  fetched_at?: InputMaybe<Scalars['timestamptz']>;
  field_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merge_tag?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EspUserFieldsSumFields = {
  __typename?: 'esp_user_fields_sum_fields';
  destination_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type EspUserFieldsVarPopFields = {
  __typename?: 'esp_user_fields_var_pop_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EspUserFieldsVarSampFields = {
  __typename?: 'esp_user_fields_var_samp_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EspUserFieldsVarianceFields = {
  __typename?: 'esp_user_fields_variance_fields';
  destination_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "etl_connections" */
export type EtlConnections = {
  __typename?: 'etl_connections';
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  data_source: Destinations;
  data_source_id: Scalars['bigint'];
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schema?: Maybe<Scalars['jsonb']>;
  sync_behavior?: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_runs: Array<EtlSyncRuns>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  updated_by_user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  warehouse: Destinations;
  /** An object relationship */
  warehouseV2: Connections;
  warehouse_id: Scalars['bigint'];
};


/** columns and relationships of "etl_connections" */
export type EtlConnectionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "etl_connections" */
export type EtlConnectionsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "etl_connections" */
export type EtlConnectionsSchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "etl_connections" */
export type EtlConnectionsSyncRunsArgs = {
  distinct_on?: InputMaybe<Array<EtlSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlSyncRunsOrderBy>>;
  where?: InputMaybe<EtlSyncRunsBoolExp>;
};

/** aggregated selection of "etl_connections" */
export type EtlConnectionsAggregate = {
  __typename?: 'etl_connections_aggregate';
  aggregate?: Maybe<EtlConnectionsAggregateFields>;
  nodes: Array<EtlConnections>;
};

/** aggregate fields of "etl_connections" */
export type EtlConnectionsAggregateFields = {
  __typename?: 'etl_connections_aggregate_fields';
  avg?: Maybe<EtlConnectionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EtlConnectionsMaxFields>;
  min?: Maybe<EtlConnectionsMinFields>;
  stddev?: Maybe<EtlConnectionsStddevFields>;
  stddev_pop?: Maybe<EtlConnectionsStddevPopFields>;
  stddev_samp?: Maybe<EtlConnectionsStddevSampFields>;
  sum?: Maybe<EtlConnectionsSumFields>;
  var_pop?: Maybe<EtlConnectionsVarPopFields>;
  var_samp?: Maybe<EtlConnectionsVarSampFields>;
  variance?: Maybe<EtlConnectionsVarianceFields>;
};


/** aggregate fields of "etl_connections" */
export type EtlConnectionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EtlConnectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EtlConnectionsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EtlConnectionsAvgFields = {
  __typename?: 'etl_connections_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "etl_connections". All fields are combined with a logical 'AND'. */
export type EtlConnectionsBoolExp = {
  _and?: InputMaybe<Array<EtlConnectionsBoolExp>>;
  _not?: InputMaybe<EtlConnectionsBoolExp>;
  _or?: InputMaybe<Array<EtlConnectionsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  created_by_user_id?: InputMaybe<BigintComparisonExp>;
  data_source?: InputMaybe<DestinationsBoolExp>;
  data_source_id?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schema?: InputMaybe<JsonbComparisonExp>;
  sync_behavior?: InputMaybe<StringComparisonExp>;
  sync_runs?: InputMaybe<EtlSyncRunsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  updated_by_user_id?: InputMaybe<BigintComparisonExp>;
  warehouse?: InputMaybe<DestinationsBoolExp>;
  warehouseV2?: InputMaybe<ConnectionsBoolExp>;
  warehouse_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "etl_connections" */
export const EtlConnectionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  EtlConnectionsPkey: 'etl_connections_pkey'
} as const;

export type EtlConnectionsConstraint = typeof EtlConnectionsConstraint[keyof typeof EtlConnectionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EtlConnectionsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Array<Scalars['String']>>;
  schema?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EtlConnectionsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
  schema?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EtlConnectionsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "etl_connections" */
export type EtlConnectionsIncInput = {
  data_source_id?: InputMaybe<Scalars['bigint']>;
  warehouse_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "etl_connections" */
export type EtlConnectionsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  data_source_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  sync_behavior?: InputMaybe<Scalars['String']>;
  warehouse_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EtlConnectionsMaxFields = {
  __typename?: 'etl_connections_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  data_source_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  sync_behavior?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_user_id?: Maybe<Scalars['bigint']>;
  warehouse_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EtlConnectionsMinFields = {
  __typename?: 'etl_connections_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['bigint']>;
  data_source_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  sync_behavior?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_user_id?: Maybe<Scalars['bigint']>;
  warehouse_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "etl_connections" */
export type EtlConnectionsMutationResponse = {
  __typename?: 'etl_connections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EtlConnections>;
};

/** on_conflict condition type for table "etl_connections" */
export type EtlConnectionsOnConflict = {
  constraint: EtlConnectionsConstraint;
  update_columns?: Array<EtlConnectionsUpdateColumn>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};

/** Ordering options when selecting data from "etl_connections". */
export type EtlConnectionsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  created_by_user_id?: InputMaybe<OrderBy>;
  data_source?: InputMaybe<DestinationsOrderBy>;
  data_source_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  sync_behavior?: InputMaybe<OrderBy>;
  sync_runs_aggregate?: InputMaybe<EtlSyncRunsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  updated_by_user_id?: InputMaybe<OrderBy>;
  warehouse?: InputMaybe<DestinationsOrderBy>;
  warehouseV2?: InputMaybe<ConnectionsOrderBy>;
  warehouse_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: etl_connections */
export type EtlConnectionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EtlConnectionsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "etl_connections" */
export const EtlConnectionsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedByUserId: 'created_by_user_id',
  /** column name */
  DataSourceId: 'data_source_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  Schema: 'schema',
  /** column name */
  SyncBehavior: 'sync_behavior',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedByUserId: 'updated_by_user_id',
  /** column name */
  WarehouseId: 'warehouse_id'
} as const;

export type EtlConnectionsSelectColumn = typeof EtlConnectionsSelectColumn[keyof typeof EtlConnectionsSelectColumn];
/** input type for updating data in table "etl_connections" */
export type EtlConnectionsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  data_source_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  sync_behavior?: InputMaybe<Scalars['String']>;
  warehouse_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type EtlConnectionsStddevFields = {
  __typename?: 'etl_connections_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EtlConnectionsStddevPopFields = {
  __typename?: 'etl_connections_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EtlConnectionsStddevSampFields = {
  __typename?: 'etl_connections_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "etl_connections" */
export type EtlConnectionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EtlConnectionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EtlConnectionsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['bigint']>;
  data_source_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  sync_behavior?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_user_id?: InputMaybe<Scalars['bigint']>;
  warehouse_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EtlConnectionsSumFields = {
  __typename?: 'etl_connections_sum_fields';
  created_by_user_id?: Maybe<Scalars['bigint']>;
  data_source_id?: Maybe<Scalars['bigint']>;
  updated_by_user_id?: Maybe<Scalars['bigint']>;
  warehouse_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "etl_connections" */
export const EtlConnectionsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  DataSourceId: 'data_source_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  Schema: 'schema',
  /** column name */
  SyncBehavior: 'sync_behavior',
  /** column name */
  WarehouseId: 'warehouse_id'
} as const;

export type EtlConnectionsUpdateColumn = typeof EtlConnectionsUpdateColumn[keyof typeof EtlConnectionsUpdateColumn];
export type EtlConnectionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EtlConnectionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EtlConnectionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EtlConnectionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EtlConnectionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EtlConnectionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EtlConnectionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EtlConnectionsSetInput>;
  /** filter the rows which have to be updated */
  where: EtlConnectionsBoolExp;
};

/** aggregate var_pop on columns */
export type EtlConnectionsVarPopFields = {
  __typename?: 'etl_connections_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EtlConnectionsVarSampFields = {
  __typename?: 'etl_connections_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EtlConnectionsVarianceFields = {
  __typename?: 'etl_connections_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  data_source_id?: Maybe<Scalars['Float']>;
  updated_by_user_id?: Maybe<Scalars['Float']>;
  warehouse_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "etl_sync_runs" */
export type EtlSyncRuns = {
  __typename?: 'etl_sync_runs';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  etl_connection: EtlConnections;
  etl_connection_id: Scalars['uuid'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  result?: Maybe<Scalars['jsonb']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "etl_sync_runs" */
export type EtlSyncRunsResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "etl_sync_runs" */
export type EtlSyncRunsAggregateOrderBy = {
  avg?: InputMaybe<EtlSyncRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EtlSyncRunsMaxOrderBy>;
  min?: InputMaybe<EtlSyncRunsMinOrderBy>;
  stddev?: InputMaybe<EtlSyncRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<EtlSyncRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EtlSyncRunsStddevSampOrderBy>;
  sum?: InputMaybe<EtlSyncRunsSumOrderBy>;
  var_pop?: InputMaybe<EtlSyncRunsVarPopOrderBy>;
  var_samp?: InputMaybe<EtlSyncRunsVarSampOrderBy>;
  variance?: InputMaybe<EtlSyncRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "etl_sync_runs" */
export type EtlSyncRunsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "etl_sync_runs". All fields are combined with a logical 'AND'. */
export type EtlSyncRunsBoolExp = {
  _and?: InputMaybe<Array<EtlSyncRunsBoolExp>>;
  _not?: InputMaybe<EtlSyncRunsBoolExp>;
  _or?: InputMaybe<Array<EtlSyncRunsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  etl_connection?: InputMaybe<EtlConnectionsBoolExp>;
  etl_connection_id?: InputMaybe<UuidComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  result?: InputMaybe<JsonbComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "etl_sync_runs" */
export type EtlSyncRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  etl_connection_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "etl_sync_runs" */
export type EtlSyncRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  etl_connection_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "etl_sync_runs". */
export type EtlSyncRunsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  etl_connection?: InputMaybe<EtlConnectionsOrderBy>;
  etl_connection_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  result?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "etl_sync_runs" */
export const EtlSyncRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  EtlConnectionId: 'etl_connection_id',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  Result: 'result',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EtlSyncRunsSelectColumn = typeof EtlSyncRunsSelectColumn[keyof typeof EtlSyncRunsSelectColumn];
/** order by stddev() on columns of table "etl_sync_runs" */
export type EtlSyncRunsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "etl_sync_runs" */
export type EtlSyncRunsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "etl_sync_runs" */
export type EtlSyncRunsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "etl_sync_runs" */
export type EtlSyncRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EtlSyncRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EtlSyncRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etl_connection_id?: InputMaybe<Scalars['uuid']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  result?: InputMaybe<Scalars['jsonb']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "etl_sync_runs" */
export type EtlSyncRunsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "etl_sync_runs" */
export type EtlSyncRunsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "etl_sync_runs" */
export type EtlSyncRunsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "etl_sync_runs" */
export type EtlSyncRunsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** reusable JSON-schema fragments owned by a domain */
export type EventComponents = {
  __typename?: 'event_components';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_components_conditions: Array<EventComponentsConditions>;
  /** An aggregate relationship */
  event_components_conditions_aggregate: EventComponentsConditionsAggregate;
  /** An array relationship */
  event_components_join_as_importee: Array<EventComponentsJoin>;
  /** An aggregate relationship */
  event_components_join_as_importee_aggregate: EventComponentsJoinAggregate;
  /** An array relationship */
  event_components_join_as_importer: Array<EventComponentsJoin>;
  /** An aggregate relationship */
  event_components_join_as_importer_aggregate: EventComponentsJoinAggregate;
  /** An object relationship */
  event_plan: EventPlans;
  event_plan_id: Scalars['uuid'];
  /** An array relationship */
  event_schema_components: Array<EventSchemaComponents>;
  /** An aggregate relationship */
  event_schema_components_aggregate: EventSchemaComponentsAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  schema: Scalars['jsonb'];
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  version: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsConditionsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsJoinAsImporteeArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsJoinAsImporteeAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsJoinAsImporterArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventComponentsJoinAsImporterAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventSchemaComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsEventSchemaComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


/** reusable JSON-schema fragments owned by a domain */
export type EventComponentsSchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_components" */
export type EventComponentsAggregate = {
  __typename?: 'event_components_aggregate';
  aggregate?: Maybe<EventComponentsAggregateFields>;
  nodes: Array<EventComponents>;
};

export type EventComponentsAggregateBoolExp = {
  count?: InputMaybe<EventComponentsAggregateBoolExpCount>;
};

export type EventComponentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventComponentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventComponentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_components" */
export type EventComponentsAggregateFields = {
  __typename?: 'event_components_aggregate_fields';
  avg?: Maybe<EventComponentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventComponentsMaxFields>;
  min?: Maybe<EventComponentsMinFields>;
  stddev?: Maybe<EventComponentsStddevFields>;
  stddev_pop?: Maybe<EventComponentsStddevPopFields>;
  stddev_samp?: Maybe<EventComponentsStddevSampFields>;
  sum?: Maybe<EventComponentsSumFields>;
  var_pop?: Maybe<EventComponentsVarPopFields>;
  var_samp?: Maybe<EventComponentsVarSampFields>;
  variance?: Maybe<EventComponentsVarianceFields>;
};


/** aggregate fields of "event_components" */
export type EventComponentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventComponentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_components" */
export type EventComponentsAggregateOrderBy = {
  avg?: InputMaybe<EventComponentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventComponentsMaxOrderBy>;
  min?: InputMaybe<EventComponentsMinOrderBy>;
  stddev?: InputMaybe<EventComponentsStddevOrderBy>;
  stddev_pop?: InputMaybe<EventComponentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventComponentsStddevSampOrderBy>;
  sum?: InputMaybe<EventComponentsSumOrderBy>;
  var_pop?: InputMaybe<EventComponentsVarPopOrderBy>;
  var_samp?: InputMaybe<EventComponentsVarSampOrderBy>;
  variance?: InputMaybe<EventComponentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventComponentsAppendInput = {
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event_components" */
export type EventComponentsArrRelInsertInput = {
  data: Array<EventComponentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventComponentsOnConflict>;
};

/** aggregate avg on columns */
export type EventComponentsAvgFields = {
  __typename?: 'event_components_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_components" */
export type EventComponentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_components". All fields are combined with a logical 'AND'. */
export type EventComponentsBoolExp = {
  _and?: InputMaybe<Array<EventComponentsBoolExp>>;
  _not?: InputMaybe<EventComponentsBoolExp>;
  _or?: InputMaybe<Array<EventComponentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_components_conditions?: InputMaybe<EventComponentsConditionsBoolExp>;
  event_components_conditions_aggregate?: InputMaybe<EventComponentsConditionsAggregateBoolExp>;
  event_components_join_as_importee?: InputMaybe<EventComponentsJoinBoolExp>;
  event_components_join_as_importee_aggregate?: InputMaybe<EventComponentsJoinAggregateBoolExp>;
  event_components_join_as_importer?: InputMaybe<EventComponentsJoinBoolExp>;
  event_components_join_as_importer_aggregate?: InputMaybe<EventComponentsJoinAggregateBoolExp>;
  event_plan?: InputMaybe<EventPlansBoolExp>;
  event_plan_id?: InputMaybe<UuidComparisonExp>;
  event_schema_components?: InputMaybe<EventSchemaComponentsBoolExp>;
  event_schema_components_aggregate?: InputMaybe<EventSchemaComponentsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schema?: InputMaybe<JsonbComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  version?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** columns and relationships of "event_components_conditions" */
export type EventComponentsConditions = {
  __typename?: 'event_components_conditions';
  component_id: Scalars['uuid'];
  /** An object relationship */
  event_component: EventComponents;
  /** An object relationship */
  event_source: EventSources;
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_components_conditions" */
export type EventComponentsConditionsAggregate = {
  __typename?: 'event_components_conditions_aggregate';
  aggregate?: Maybe<EventComponentsConditionsAggregateFields>;
  nodes: Array<EventComponentsConditions>;
};

export type EventComponentsConditionsAggregateBoolExp = {
  count?: InputMaybe<EventComponentsConditionsAggregateBoolExpCount>;
};

export type EventComponentsConditionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventComponentsConditionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_components_conditions" */
export type EventComponentsConditionsAggregateFields = {
  __typename?: 'event_components_conditions_aggregate_fields';
  avg?: Maybe<EventComponentsConditionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventComponentsConditionsMaxFields>;
  min?: Maybe<EventComponentsConditionsMinFields>;
  stddev?: Maybe<EventComponentsConditionsStddevFields>;
  stddev_pop?: Maybe<EventComponentsConditionsStddevPopFields>;
  stddev_samp?: Maybe<EventComponentsConditionsStddevSampFields>;
  sum?: Maybe<EventComponentsConditionsSumFields>;
  var_pop?: Maybe<EventComponentsConditionsVarPopFields>;
  var_samp?: Maybe<EventComponentsConditionsVarSampFields>;
  variance?: Maybe<EventComponentsConditionsVarianceFields>;
};


/** aggregate fields of "event_components_conditions" */
export type EventComponentsConditionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_components_conditions" */
export type EventComponentsConditionsAggregateOrderBy = {
  avg?: InputMaybe<EventComponentsConditionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventComponentsConditionsMaxOrderBy>;
  min?: InputMaybe<EventComponentsConditionsMinOrderBy>;
  stddev?: InputMaybe<EventComponentsConditionsStddevOrderBy>;
  stddev_pop?: InputMaybe<EventComponentsConditionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventComponentsConditionsStddevSampOrderBy>;
  sum?: InputMaybe<EventComponentsConditionsSumOrderBy>;
  var_pop?: InputMaybe<EventComponentsConditionsVarPopOrderBy>;
  var_samp?: InputMaybe<EventComponentsConditionsVarSampOrderBy>;
  variance?: InputMaybe<EventComponentsConditionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_components_conditions" */
export type EventComponentsConditionsArrRelInsertInput = {
  data: Array<EventComponentsConditionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventComponentsConditionsOnConflict>;
};

/** aggregate avg on columns */
export type EventComponentsConditionsAvgFields = {
  __typename?: 'event_components_conditions_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_components_conditions" */
export type EventComponentsConditionsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_components_conditions". All fields are combined with a logical 'AND'. */
export type EventComponentsConditionsBoolExp = {
  _and?: InputMaybe<Array<EventComponentsConditionsBoolExp>>;
  _not?: InputMaybe<EventComponentsConditionsBoolExp>;
  _or?: InputMaybe<Array<EventComponentsConditionsBoolExp>>;
  component_id?: InputMaybe<UuidComparisonExp>;
  event_component?: InputMaybe<EventComponentsBoolExp>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_components_conditions" */
export const EventComponentsConditionsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "component_id", "event_source_id" */
  EventComponentsConditionsPkey: 'event_components_conditions_pkey'
} as const;

export type EventComponentsConditionsConstraint = typeof EventComponentsConditionsConstraint[keyof typeof EventComponentsConditionsConstraint];
/** input type for inserting data into table "event_components_conditions" */
export type EventComponentsConditionsInsertInput = {
  component_id?: InputMaybe<Scalars['uuid']>;
  event_component?: InputMaybe<EventComponentsObjRelInsertInput>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventComponentsConditionsMaxFields = {
  __typename?: 'event_components_conditions_max_fields';
  component_id?: Maybe<Scalars['uuid']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_components_conditions" */
export type EventComponentsConditionsMaxOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventComponentsConditionsMinFields = {
  __typename?: 'event_components_conditions_min_fields';
  component_id?: Maybe<Scalars['uuid']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_components_conditions" */
export type EventComponentsConditionsMinOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_components_conditions" */
export type EventComponentsConditionsMutationResponse = {
  __typename?: 'event_components_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventComponentsConditions>;
};

/** on_conflict condition type for table "event_components_conditions" */
export type EventComponentsConditionsOnConflict = {
  constraint: EventComponentsConditionsConstraint;
  update_columns?: Array<EventComponentsConditionsUpdateColumn>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};

/** Ordering options when selecting data from "event_components_conditions". */
export type EventComponentsConditionsOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_component?: InputMaybe<EventComponentsOrderBy>;
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_components_conditions" */
export const EventComponentsConditionsSelectColumn = {
  /** column name */
  ComponentId: 'component_id',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventComponentsConditionsSelectColumn = typeof EventComponentsConditionsSelectColumn[keyof typeof EventComponentsConditionsSelectColumn];
/** aggregate stddev on columns */
export type EventComponentsConditionsStddevFields = {
  __typename?: 'event_components_conditions_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_components_conditions" */
export type EventComponentsConditionsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventComponentsConditionsStddevPopFields = {
  __typename?: 'event_components_conditions_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_components_conditions" */
export type EventComponentsConditionsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventComponentsConditionsStddevSampFields = {
  __typename?: 'event_components_conditions_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_components_conditions" */
export type EventComponentsConditionsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_components_conditions" */
export type EventComponentsConditionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventComponentsConditionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventComponentsConditionsStreamCursorValueInput = {
  component_id?: InputMaybe<Scalars['uuid']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventComponentsConditionsSumFields = {
  __typename?: 'event_components_conditions_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_components_conditions" */
export type EventComponentsConditionsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "event_components_conditions" (current role has no relevant permissions) */
export const EventComponentsConditionsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type EventComponentsConditionsUpdateColumn = typeof EventComponentsConditionsUpdateColumn[keyof typeof EventComponentsConditionsUpdateColumn];
/** aggregate var_pop on columns */
export type EventComponentsConditionsVarPopFields = {
  __typename?: 'event_components_conditions_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_components_conditions" */
export type EventComponentsConditionsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventComponentsConditionsVarSampFields = {
  __typename?: 'event_components_conditions_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_components_conditions" */
export type EventComponentsConditionsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventComponentsConditionsVarianceFields = {
  __typename?: 'event_components_conditions_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_components_conditions" */
export type EventComponentsConditionsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "event_components" */
export const EventComponentsConstraint = {
  /** unique or primary key constraint on columns "name", "version", "event_plan_id" */
  EventComponentsEventPlanIdNameVersionKey: 'event_components_event_plan_id_name_version_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventComponentsPkey: 'event_components_pkey',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  EventComponentsSlugWorkspaceIdKey: 'event_components_slug_workspace_id_key'
} as const;

export type EventComponentsConstraint = typeof EventComponentsConstraint[keyof typeof EventComponentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventComponentsDeleteAtPathInput = {
  schema?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventComponentsDeleteElemInput = {
  schema?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventComponentsDeleteKeyInput = {
  schema?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "event_components" */
export type EventComponentsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  event_components_conditions?: InputMaybe<EventComponentsConditionsArrRelInsertInput>;
  event_components_join_as_importee?: InputMaybe<EventComponentsJoinArrRelInsertInput>;
  event_components_join_as_importer?: InputMaybe<EventComponentsJoinArrRelInsertInput>;
  event_plan?: InputMaybe<EventPlansObjRelInsertInput>;
  event_plan_id?: InputMaybe<Scalars['uuid']>;
  event_schema_components?: InputMaybe<EventSchemaComponentsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "event_components_join" */
export type EventComponentsJoin = {
  __typename?: 'event_components_join';
  /** An object relationship */
  importee: EventComponents;
  importee_id: Scalars['uuid'];
  /** An object relationship */
  importer: EventComponents;
  importer_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_components_join" */
export type EventComponentsJoinAggregate = {
  __typename?: 'event_components_join_aggregate';
  aggregate?: Maybe<EventComponentsJoinAggregateFields>;
  nodes: Array<EventComponentsJoin>;
};

export type EventComponentsJoinAggregateBoolExp = {
  count?: InputMaybe<EventComponentsJoinAggregateBoolExpCount>;
};

export type EventComponentsJoinAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventComponentsJoinBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_components_join" */
export type EventComponentsJoinAggregateFields = {
  __typename?: 'event_components_join_aggregate_fields';
  avg?: Maybe<EventComponentsJoinAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventComponentsJoinMaxFields>;
  min?: Maybe<EventComponentsJoinMinFields>;
  stddev?: Maybe<EventComponentsJoinStddevFields>;
  stddev_pop?: Maybe<EventComponentsJoinStddevPopFields>;
  stddev_samp?: Maybe<EventComponentsJoinStddevSampFields>;
  sum?: Maybe<EventComponentsJoinSumFields>;
  var_pop?: Maybe<EventComponentsJoinVarPopFields>;
  var_samp?: Maybe<EventComponentsJoinVarSampFields>;
  variance?: Maybe<EventComponentsJoinVarianceFields>;
};


/** aggregate fields of "event_components_join" */
export type EventComponentsJoinAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_components_join" */
export type EventComponentsJoinAggregateOrderBy = {
  avg?: InputMaybe<EventComponentsJoinAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventComponentsJoinMaxOrderBy>;
  min?: InputMaybe<EventComponentsJoinMinOrderBy>;
  stddev?: InputMaybe<EventComponentsJoinStddevOrderBy>;
  stddev_pop?: InputMaybe<EventComponentsJoinStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventComponentsJoinStddevSampOrderBy>;
  sum?: InputMaybe<EventComponentsJoinSumOrderBy>;
  var_pop?: InputMaybe<EventComponentsJoinVarPopOrderBy>;
  var_samp?: InputMaybe<EventComponentsJoinVarSampOrderBy>;
  variance?: InputMaybe<EventComponentsJoinVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_components_join" */
export type EventComponentsJoinArrRelInsertInput = {
  data: Array<EventComponentsJoinInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventComponentsJoinOnConflict>;
};

/** aggregate avg on columns */
export type EventComponentsJoinAvgFields = {
  __typename?: 'event_components_join_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_components_join" */
export type EventComponentsJoinAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_components_join". All fields are combined with a logical 'AND'. */
export type EventComponentsJoinBoolExp = {
  _and?: InputMaybe<Array<EventComponentsJoinBoolExp>>;
  _not?: InputMaybe<EventComponentsJoinBoolExp>;
  _or?: InputMaybe<Array<EventComponentsJoinBoolExp>>;
  importee?: InputMaybe<EventComponentsBoolExp>;
  importee_id?: InputMaybe<UuidComparisonExp>;
  importer?: InputMaybe<EventComponentsBoolExp>;
  importer_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_components_join" */
export const EventComponentsJoinConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "importer_id", "importee_id" */
  EventComponentsJoinPkey: 'event_components_join_pkey'
} as const;

export type EventComponentsJoinConstraint = typeof EventComponentsJoinConstraint[keyof typeof EventComponentsJoinConstraint];
/** input type for inserting data into table "event_components_join" */
export type EventComponentsJoinInsertInput = {
  importee?: InputMaybe<EventComponentsObjRelInsertInput>;
  importee_id?: InputMaybe<Scalars['uuid']>;
  importer?: InputMaybe<EventComponentsObjRelInsertInput>;
  importer_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventComponentsJoinMaxFields = {
  __typename?: 'event_components_join_max_fields';
  importee_id?: Maybe<Scalars['uuid']>;
  importer_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_components_join" */
export type EventComponentsJoinMaxOrderBy = {
  importee_id?: InputMaybe<OrderBy>;
  importer_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventComponentsJoinMinFields = {
  __typename?: 'event_components_join_min_fields';
  importee_id?: Maybe<Scalars['uuid']>;
  importer_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_components_join" */
export type EventComponentsJoinMinOrderBy = {
  importee_id?: InputMaybe<OrderBy>;
  importer_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_components_join" */
export type EventComponentsJoinMutationResponse = {
  __typename?: 'event_components_join_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventComponentsJoin>;
};

/** on_conflict condition type for table "event_components_join" */
export type EventComponentsJoinOnConflict = {
  constraint: EventComponentsJoinConstraint;
  update_columns?: Array<EventComponentsJoinUpdateColumn>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};

/** Ordering options when selecting data from "event_components_join". */
export type EventComponentsJoinOrderBy = {
  importee?: InputMaybe<EventComponentsOrderBy>;
  importee_id?: InputMaybe<OrderBy>;
  importer?: InputMaybe<EventComponentsOrderBy>;
  importer_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_components_join" */
export const EventComponentsJoinSelectColumn = {
  /** column name */
  ImporteeId: 'importee_id',
  /** column name */
  ImporterId: 'importer_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventComponentsJoinSelectColumn = typeof EventComponentsJoinSelectColumn[keyof typeof EventComponentsJoinSelectColumn];
/** aggregate stddev on columns */
export type EventComponentsJoinStddevFields = {
  __typename?: 'event_components_join_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_components_join" */
export type EventComponentsJoinStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventComponentsJoinStddevPopFields = {
  __typename?: 'event_components_join_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_components_join" */
export type EventComponentsJoinStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventComponentsJoinStddevSampFields = {
  __typename?: 'event_components_join_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_components_join" */
export type EventComponentsJoinStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_components_join" */
export type EventComponentsJoinStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventComponentsJoinStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventComponentsJoinStreamCursorValueInput = {
  importee_id?: InputMaybe<Scalars['uuid']>;
  importer_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventComponentsJoinSumFields = {
  __typename?: 'event_components_join_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_components_join" */
export type EventComponentsJoinSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "event_components_join" (current role has no relevant permissions) */
export const EventComponentsJoinUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type EventComponentsJoinUpdateColumn = typeof EventComponentsJoinUpdateColumn[keyof typeof EventComponentsJoinUpdateColumn];
/** aggregate var_pop on columns */
export type EventComponentsJoinVarPopFields = {
  __typename?: 'event_components_join_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_components_join" */
export type EventComponentsJoinVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventComponentsJoinVarSampFields = {
  __typename?: 'event_components_join_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_components_join" */
export type EventComponentsJoinVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventComponentsJoinVarianceFields = {
  __typename?: 'event_components_join_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_components_join" */
export type EventComponentsJoinVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate max on columns */
export type EventComponentsMaxFields = {
  __typename?: 'event_components_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  event_plan_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_components" */
export type EventComponentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventComponentsMinFields = {
  __typename?: 'event_components_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  event_plan_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_components" */
export type EventComponentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_components" */
export type EventComponentsMutationResponse = {
  __typename?: 'event_components_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventComponents>;
};

/** input type for inserting object relation for remote table "event_components" */
export type EventComponentsObjRelInsertInput = {
  data: EventComponentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EventComponentsOnConflict>;
};

/** on_conflict condition type for table "event_components" */
export type EventComponentsOnConflict = {
  constraint: EventComponentsConstraint;
  update_columns?: Array<EventComponentsUpdateColumn>;
  where?: InputMaybe<EventComponentsBoolExp>;
};

/** Ordering options when selecting data from "event_components". */
export type EventComponentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  event_components_conditions_aggregate?: InputMaybe<EventComponentsConditionsAggregateOrderBy>;
  event_components_join_as_importee_aggregate?: InputMaybe<EventComponentsJoinAggregateOrderBy>;
  event_components_join_as_importer_aggregate?: InputMaybe<EventComponentsJoinAggregateOrderBy>;
  event_plan?: InputMaybe<EventPlansOrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  event_schema_components_aggregate?: InputMaybe<EventSchemaComponentsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_components */
export type EventComponentsPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventComponentsPrependInput = {
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_components" */
export const EventComponentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  EventPlanId: 'event_plan_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schema: 'schema',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventComponentsSelectColumn = typeof EventComponentsSelectColumn[keyof typeof EventComponentsSelectColumn];
/** input type for updating data in table "event_components" */
export type EventComponentsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EventComponentsStddevFields = {
  __typename?: 'event_components_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_components" */
export type EventComponentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventComponentsStddevPopFields = {
  __typename?: 'event_components_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_components" */
export type EventComponentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventComponentsStddevSampFields = {
  __typename?: 'event_components_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_components" */
export type EventComponentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_components" */
export type EventComponentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventComponentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventComponentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  event_plan_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventComponentsSumFields = {
  __typename?: 'event_components_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_components" */
export type EventComponentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "event_components" */
export const EventComponentsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  Schema: 'schema',
  /** column name */
  Version: 'version'
} as const;

export type EventComponentsUpdateColumn = typeof EventComponentsUpdateColumn[keyof typeof EventComponentsUpdateColumn];
export type EventComponentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventComponentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventComponentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventComponentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventComponentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventComponentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventComponentsSetInput>;
  /** filter the rows which have to be updated */
  where: EventComponentsBoolExp;
};

/** aggregate var_pop on columns */
export type EventComponentsVarPopFields = {
  __typename?: 'event_components_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_components" */
export type EventComponentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventComponentsVarSampFields = {
  __typename?: 'event_components_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_components" */
export type EventComponentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventComponentsVarianceFields = {
  __typename?: 'event_components_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_components" */
export type EventComponentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_contracts" */
export type EventContracts = {
  __typename?: 'event_contracts';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "event_contracts". All fields are combined with a logical 'AND'. */
export type EventContractsBoolExp = {
  _and?: InputMaybe<Array<EventContractsBoolExp>>;
  _not?: InputMaybe<EventContractsBoolExp>;
  _or?: InputMaybe<Array<EventContractsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_contracts" */
export const EventContractsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventContractsPkey: 'event_contracts_pkey'
} as const;

export type EventContractsConstraint = typeof EventContractsConstraint[keyof typeof EventContractsConstraint];
/** input type for inserting data into table "event_contracts" */
export type EventContractsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "event_contracts" */
export type EventContractsMutationResponse = {
  __typename?: 'event_contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventContracts>;
};

/** on_conflict condition type for table "event_contracts" */
export type EventContractsOnConflict = {
  constraint: EventContractsConstraint;
  update_columns?: Array<EventContractsUpdateColumn>;
  where?: InputMaybe<EventContractsBoolExp>;
};

/** Ordering options when selecting data from "event_contracts". */
export type EventContractsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_contracts */
export type EventContractsPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** columns and relationships of "event_contracts_schema" */
export type EventContractsSchema = {
  __typename?: 'event_contracts_schema';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  description?: Maybe<Scalars['String']>;
  event_contract_id: Scalars['uuid'];
  event_type: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  schema: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "event_contracts_schema". All fields are combined with a logical 'AND'. */
export type EventContractsSchemaBoolExp = {
  _and?: InputMaybe<Array<EventContractsSchemaBoolExp>>;
  _not?: InputMaybe<EventContractsSchemaBoolExp>;
  _or?: InputMaybe<Array<EventContractsSchemaBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_contract_id?: InputMaybe<UuidComparisonExp>;
  event_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schema?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_contracts_schema" */
export const EventContractsSchemaConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventContractsSchemaPkey: 'event_contracts_schema_pkey'
} as const;

export type EventContractsSchemaConstraint = typeof EventContractsSchemaConstraint[keyof typeof EventContractsSchemaConstraint];
/** input type for inserting data into table "event_contracts_schema" */
export type EventContractsSchemaInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  event_contract_id?: InputMaybe<Scalars['uuid']>;
  event_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "event_contracts_schema" */
export type EventContractsSchemaMutationResponse = {
  __typename?: 'event_contracts_schema_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventContractsSchema>;
};

/** on_conflict condition type for table "event_contracts_schema" */
export type EventContractsSchemaOnConflict = {
  constraint: EventContractsSchemaConstraint;
  update_columns?: Array<EventContractsSchemaUpdateColumn>;
  where?: InputMaybe<EventContractsSchemaBoolExp>;
};

/** Ordering options when selecting data from "event_contracts_schema". */
export type EventContractsSchemaOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  event_contract_id?: InputMaybe<OrderBy>;
  event_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_contracts_schema */
export type EventContractsSchemaPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "event_contracts_schema" */
export const EventContractsSchemaSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  EventContractId: 'event_contract_id',
  /** column name */
  EventType: 'event_type',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schema: 'schema',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventContractsSchemaSelectColumn = typeof EventContractsSchemaSelectColumn[keyof typeof EventContractsSchemaSelectColumn];
/** input type for updating data in table "event_contracts_schema" */
export type EventContractsSchemaSetInput = {
  description?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_contracts_schema" */
export type EventContractsSchemaStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventContractsSchemaStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventContractsSchemaStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  event_contract_id?: InputMaybe<Scalars['uuid']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "event_contracts_schema" */
export const EventContractsSchemaUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  EventType: 'event_type',
  /** column name */
  Name: 'name',
  /** column name */
  Schema: 'schema',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type EventContractsSchemaUpdateColumn = typeof EventContractsSchemaUpdateColumn[keyof typeof EventContractsSchemaUpdateColumn];
export type EventContractsSchemaUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventContractsSchemaSetInput>;
  /** filter the rows which have to be updated */
  where: EventContractsSchemaBoolExp;
};

/** select columns of table "event_contracts" */
export const EventContractsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventContractsSelectColumn = typeof EventContractsSelectColumn[keyof typeof EventContractsSelectColumn];
/** input type for updating data in table "event_contracts" */
export type EventContractsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_contracts" */
export type EventContractsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventContractsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventContractsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "event_contracts" */
export const EventContractsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type EventContractsUpdateColumn = typeof EventContractsUpdateColumn[keyof typeof EventContractsUpdateColumn];
export type EventContractsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventContractsSetInput>;
  /** filter the rows which have to be updated */
  where: EventContractsBoolExp;
};

/** columns and relationships of "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrants = {
  __typename?: 'event_forwarding_destination_grants';
  can_access_data: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['uuid'];
  resource_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsAggregate = {
  __typename?: 'event_forwarding_destination_grants_aggregate';
  aggregate?: Maybe<EventForwardingDestinationGrantsAggregateFields>;
  nodes: Array<EventForwardingDestinationGrants>;
};

/** aggregate fields of "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsAggregateFields = {
  __typename?: 'event_forwarding_destination_grants_aggregate_fields';
  avg?: Maybe<EventForwardingDestinationGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventForwardingDestinationGrantsMaxFields>;
  min?: Maybe<EventForwardingDestinationGrantsMinFields>;
  stddev?: Maybe<EventForwardingDestinationGrantsStddevFields>;
  stddev_pop?: Maybe<EventForwardingDestinationGrantsStddevPopFields>;
  stddev_samp?: Maybe<EventForwardingDestinationGrantsStddevSampFields>;
  sum?: Maybe<EventForwardingDestinationGrantsSumFields>;
  var_pop?: Maybe<EventForwardingDestinationGrantsVarPopFields>;
  var_samp?: Maybe<EventForwardingDestinationGrantsVarSampFields>;
  variance?: Maybe<EventForwardingDestinationGrantsVarianceFields>;
};


/** aggregate fields of "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventForwardingDestinationGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventForwardingDestinationGrantsAvgFields = {
  __typename?: 'event_forwarding_destination_grants_avg_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_forwarding_destination_grants". All fields are combined with a logical 'AND'. */
export type EventForwardingDestinationGrantsBoolExp = {
  _and?: InputMaybe<Array<EventForwardingDestinationGrantsBoolExp>>;
  _not?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
  _or?: InputMaybe<Array<EventForwardingDestinationGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<BigintComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_forwarding_destination_grants" */
export const EventForwardingDestinationGrantsConstraint = {
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id" */
  EventForwardingDestinationUserGroupIdWorkspaceIdReKey: 'event_forwarding_destination__user_group_id_workspace_id_re_key',
  /** unique or primary key constraint on columns "id" */
  EventForwardingDestinationGrantsPkey: 'event_forwarding_destination_grants_pkey'
} as const;

export type EventForwardingDestinationGrantsConstraint = typeof EventForwardingDestinationGrantsConstraint[keyof typeof EventForwardingDestinationGrantsConstraint];
/** input type for inserting data into table "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventForwardingDestinationGrantsMaxFields = {
  __typename?: 'event_forwarding_destination_grants_max_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventForwardingDestinationGrantsMinFields = {
  __typename?: 'event_forwarding_destination_grants_min_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsMutationResponse = {
  __typename?: 'event_forwarding_destination_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventForwardingDestinationGrants>;
};

/** on_conflict condition type for table "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsOnConflict = {
  constraint: EventForwardingDestinationGrantsConstraint;
  update_columns?: Array<EventForwardingDestinationGrantsUpdateColumn>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};

/** Ordering options when selecting data from "event_forwarding_destination_grants". */
export type EventForwardingDestinationGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_forwarding_destination_grants */
export type EventForwardingDestinationGrantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_forwarding_destination_grants" */
export const EventForwardingDestinationGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventForwardingDestinationGrantsSelectColumn = typeof EventForwardingDestinationGrantsSelectColumn[keyof typeof EventForwardingDestinationGrantsSelectColumn];
/** input type for updating data in table "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EventForwardingDestinationGrantsStddevFields = {
  __typename?: 'event_forwarding_destination_grants_stddev_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventForwardingDestinationGrantsStddevPopFields = {
  __typename?: 'event_forwarding_destination_grants_stddev_pop_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventForwardingDestinationGrantsStddevSampFields = {
  __typename?: 'event_forwarding_destination_grants_stddev_samp_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_forwarding_destination_grants" */
export type EventForwardingDestinationGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventForwardingDestinationGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventForwardingDestinationGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventForwardingDestinationGrantsSumFields = {
  __typename?: 'event_forwarding_destination_grants_sum_fields';
  resource_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_forwarding_destination_grants" */
export const EventForwardingDestinationGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type EventForwardingDestinationGrantsUpdateColumn = typeof EventForwardingDestinationGrantsUpdateColumn[keyof typeof EventForwardingDestinationGrantsUpdateColumn];
export type EventForwardingDestinationGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventForwardingDestinationGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: EventForwardingDestinationGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type EventForwardingDestinationGrantsVarPopFields = {
  __typename?: 'event_forwarding_destination_grants_var_pop_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventForwardingDestinationGrantsVarSampFields = {
  __typename?: 'event_forwarding_destination_grants_var_samp_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventForwardingDestinationGrantsVarianceFields = {
  __typename?: 'event_forwarding_destination_grants_variance_fields';
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_forwarding_sync_sources" */
export type EventForwardingSyncSources = {
  __typename?: 'event_forwarding_sync_sources';
  /** An object relationship */
  event_forwarding_sync: EventForwardingSyncs;
  /** An object relationship */
  event_source: EventSources;
  event_source_id: Scalars['uuid'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesAggregate = {
  __typename?: 'event_forwarding_sync_sources_aggregate';
  aggregate?: Maybe<EventForwardingSyncSourcesAggregateFields>;
  nodes: Array<EventForwardingSyncSources>;
};

export type EventForwardingSyncSourcesAggregateBoolExp = {
  count?: InputMaybe<EventForwardingSyncSourcesAggregateBoolExpCount>;
};

export type EventForwardingSyncSourcesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesAggregateFields = {
  __typename?: 'event_forwarding_sync_sources_aggregate_fields';
  avg?: Maybe<EventForwardingSyncSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventForwardingSyncSourcesMaxFields>;
  min?: Maybe<EventForwardingSyncSourcesMinFields>;
  stddev?: Maybe<EventForwardingSyncSourcesStddevFields>;
  stddev_pop?: Maybe<EventForwardingSyncSourcesStddevPopFields>;
  stddev_samp?: Maybe<EventForwardingSyncSourcesStddevSampFields>;
  sum?: Maybe<EventForwardingSyncSourcesSumFields>;
  var_pop?: Maybe<EventForwardingSyncSourcesVarPopFields>;
  var_samp?: Maybe<EventForwardingSyncSourcesVarSampFields>;
  variance?: Maybe<EventForwardingSyncSourcesVarianceFields>;
};


/** aggregate fields of "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesAggregateOrderBy = {
  avg?: InputMaybe<EventForwardingSyncSourcesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventForwardingSyncSourcesMaxOrderBy>;
  min?: InputMaybe<EventForwardingSyncSourcesMinOrderBy>;
  stddev?: InputMaybe<EventForwardingSyncSourcesStddevOrderBy>;
  stddev_pop?: InputMaybe<EventForwardingSyncSourcesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventForwardingSyncSourcesStddevSampOrderBy>;
  sum?: InputMaybe<EventForwardingSyncSourcesSumOrderBy>;
  var_pop?: InputMaybe<EventForwardingSyncSourcesVarPopOrderBy>;
  var_samp?: InputMaybe<EventForwardingSyncSourcesVarSampOrderBy>;
  variance?: InputMaybe<EventForwardingSyncSourcesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type EventForwardingSyncSourcesAvgFields = {
  __typename?: 'event_forwarding_sync_sources_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_forwarding_sync_sources". All fields are combined with a logical 'AND'. */
export type EventForwardingSyncSourcesBoolExp = {
  _and?: InputMaybe<Array<EventForwardingSyncSourcesBoolExp>>;
  _not?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
  _or?: InputMaybe<Array<EventForwardingSyncSourcesBoolExp>>;
  event_forwarding_sync?: InputMaybe<EventForwardingSyncsBoolExp>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  sync_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EventForwardingSyncSourcesMaxFields = {
  __typename?: 'event_forwarding_sync_sources_max_fields';
  event_source_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesMaxOrderBy = {
  event_source_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventForwardingSyncSourcesMinFields = {
  __typename?: 'event_forwarding_sync_sources_min_fields';
  event_source_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesMinOrderBy = {
  event_source_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_forwarding_sync_sources". */
export type EventForwardingSyncSourcesOrderBy = {
  event_forwarding_sync?: InputMaybe<EventForwardingSyncsOrderBy>;
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_forwarding_sync_sources" */
export const EventForwardingSyncSourcesSelectColumn = {
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventForwardingSyncSourcesSelectColumn = typeof EventForwardingSyncSourcesSelectColumn[keyof typeof EventForwardingSyncSourcesSelectColumn];
/** aggregate stddev on columns */
export type EventForwardingSyncSourcesStddevFields = {
  __typename?: 'event_forwarding_sync_sources_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventForwardingSyncSourcesStddevPopFields = {
  __typename?: 'event_forwarding_sync_sources_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventForwardingSyncSourcesStddevSampFields = {
  __typename?: 'event_forwarding_sync_sources_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventForwardingSyncSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventForwardingSyncSourcesStreamCursorValueInput = {
  event_source_id?: InputMaybe<Scalars['uuid']>;
  sync_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventForwardingSyncSourcesSumFields = {
  __typename?: 'event_forwarding_sync_sources_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type EventForwardingSyncSourcesVarPopFields = {
  __typename?: 'event_forwarding_sync_sources_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventForwardingSyncSourcesVarSampFields = {
  __typename?: 'event_forwarding_sync_sources_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventForwardingSyncSourcesVarianceFields = {
  __typename?: 'event_forwarding_sync_sources_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_forwarding_sync_sources" */
export type EventForwardingSyncSourcesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_forwarding_syncs" */
export type EventForwardingSyncs = {
  __typename?: 'event_forwarding_syncs';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  enabled: Scalars['Boolean'];
  /** An array relationship */
  event_forwarding_sync_sources: Array<EventForwardingSyncSources>;
  /** An aggregate relationship */
  event_forwarding_sync_sources_aggregate: EventForwardingSyncSourcesAggregate;
  id: Scalars['uuid'];
  migrated_config: Scalars['JSONObject'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "event_forwarding_syncs" */
export type EventForwardingSyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "event_forwarding_syncs" */
export type EventForwardingSyncsEventForwardingSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


/** columns and relationships of "event_forwarding_syncs" */
export type EventForwardingSyncsEventForwardingSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};

/** order by aggregate values of table "event_forwarding_syncs" */
export type EventForwardingSyncsAggregateOrderBy = {
  avg?: InputMaybe<EventForwardingSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventForwardingSyncsMaxOrderBy>;
  min?: InputMaybe<EventForwardingSyncsMinOrderBy>;
  stddev?: InputMaybe<EventForwardingSyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<EventForwardingSyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventForwardingSyncsStddevSampOrderBy>;
  sum?: InputMaybe<EventForwardingSyncsSumOrderBy>;
  var_pop?: InputMaybe<EventForwardingSyncsVarPopOrderBy>;
  var_samp?: InputMaybe<EventForwardingSyncsVarSampOrderBy>;
  variance?: InputMaybe<EventForwardingSyncsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventForwardingSyncsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_forwarding_syncs". All fields are combined with a logical 'AND'. */
export type EventForwardingSyncsBoolExp = {
  _and?: InputMaybe<Array<EventForwardingSyncsBoolExp>>;
  _not?: InputMaybe<EventForwardingSyncsBoolExp>;
  _or?: InputMaybe<Array<EventForwardingSyncsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  event_forwarding_sync_sources?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
  event_forwarding_sync_sources_aggregate?: InputMaybe<EventForwardingSyncSourcesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_forwarding_syncs" */
export const EventForwardingSyncsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventForwardingSyncsPkey: 'event_forwarding_syncs_pkey',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  EventForwardingSyncsWorkspaceIdSlugKey: 'event_forwarding_syncs_workspace_id_slug_key'
} as const;

export type EventForwardingSyncsConstraint = typeof EventForwardingSyncsConstraint[keyof typeof EventForwardingSyncsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventForwardingSyncsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventForwardingSyncsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventForwardingSyncsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "event_forwarding_syncs" */
export type EventForwardingSyncsIncInput = {
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "event_forwarding_syncs" */
export type EventForwardingSyncsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_forwarding_syncs" */
export type EventForwardingSyncsMutationResponse = {
  __typename?: 'event_forwarding_syncs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventForwardingSyncs>;
};

/** input type for inserting object relation for remote table "event_forwarding_syncs" */
export type EventForwardingSyncsObjRelInsertInput = {
  data: EventForwardingSyncsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EventForwardingSyncsOnConflict>;
};

/** on_conflict condition type for table "event_forwarding_syncs" */
export type EventForwardingSyncsOnConflict = {
  constraint: EventForwardingSyncsConstraint;
  update_columns?: Array<EventForwardingSyncsUpdateColumn>;
  where?: InputMaybe<EventForwardingSyncsBoolExp>;
};

/** Ordering options when selecting data from "event_forwarding_syncs". */
export type EventForwardingSyncsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  event_forwarding_sync_sources_aggregate?: InputMaybe<EventForwardingSyncSourcesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_forwarding_syncs */
export type EventForwardingSyncsPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventForwardingSyncsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_forwarding_syncs" */
export const EventForwardingSyncsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventForwardingSyncsSelectColumn = typeof EventForwardingSyncsSelectColumn[keyof typeof EventForwardingSyncsSelectColumn];
/** input type for updating data in table "event_forwarding_syncs" */
export type EventForwardingSyncsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_forwarding_syncs" */
export type EventForwardingSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventForwardingSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventForwardingSyncsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "event_forwarding_syncs" */
export const EventForwardingSyncsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Name: 'name',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type EventForwardingSyncsUpdateColumn = typeof EventForwardingSyncsUpdateColumn[keyof typeof EventForwardingSyncsUpdateColumn];
export type EventForwardingSyncsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventForwardingSyncsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventForwardingSyncsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventForwardingSyncsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventForwardingSyncsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventForwardingSyncsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventForwardingSyncsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventForwardingSyncsSetInput>;
  /** filter the rows which have to be updated */
  where: EventForwardingSyncsBoolExp;
};

/** order by var_pop() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "event_forwarding_syncs" */
export type EventForwardingSyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_model_event_sources" */
export type EventModelEventSources = {
  __typename?: 'event_model_event_sources';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  event_model: EventModels;
  /** An object relationship */
  event_source: EventSources;
  event_source_id: Scalars['uuid'];
  id: Scalars['uuid'];
  model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_model_event_sources" */
export type EventModelEventSourcesAggregate = {
  __typename?: 'event_model_event_sources_aggregate';
  aggregate?: Maybe<EventModelEventSourcesAggregateFields>;
  nodes: Array<EventModelEventSources>;
};

export type EventModelEventSourcesAggregateBoolExp = {
  count?: InputMaybe<EventModelEventSourcesAggregateBoolExpCount>;
};

export type EventModelEventSourcesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventModelEventSourcesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_model_event_sources" */
export type EventModelEventSourcesAggregateFields = {
  __typename?: 'event_model_event_sources_aggregate_fields';
  avg?: Maybe<EventModelEventSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventModelEventSourcesMaxFields>;
  min?: Maybe<EventModelEventSourcesMinFields>;
  stddev?: Maybe<EventModelEventSourcesStddevFields>;
  stddev_pop?: Maybe<EventModelEventSourcesStddevPopFields>;
  stddev_samp?: Maybe<EventModelEventSourcesStddevSampFields>;
  sum?: Maybe<EventModelEventSourcesSumFields>;
  var_pop?: Maybe<EventModelEventSourcesVarPopFields>;
  var_samp?: Maybe<EventModelEventSourcesVarSampFields>;
  variance?: Maybe<EventModelEventSourcesVarianceFields>;
};


/** aggregate fields of "event_model_event_sources" */
export type EventModelEventSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_model_event_sources" */
export type EventModelEventSourcesAggregateOrderBy = {
  avg?: InputMaybe<EventModelEventSourcesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventModelEventSourcesMaxOrderBy>;
  min?: InputMaybe<EventModelEventSourcesMinOrderBy>;
  stddev?: InputMaybe<EventModelEventSourcesStddevOrderBy>;
  stddev_pop?: InputMaybe<EventModelEventSourcesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventModelEventSourcesStddevSampOrderBy>;
  sum?: InputMaybe<EventModelEventSourcesSumOrderBy>;
  var_pop?: InputMaybe<EventModelEventSourcesVarPopOrderBy>;
  var_samp?: InputMaybe<EventModelEventSourcesVarSampOrderBy>;
  variance?: InputMaybe<EventModelEventSourcesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_model_event_sources" */
export type EventModelEventSourcesArrRelInsertInput = {
  data: Array<EventModelEventSourcesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventModelEventSourcesOnConflict>;
};

/** aggregate avg on columns */
export type EventModelEventSourcesAvgFields = {
  __typename?: 'event_model_event_sources_avg_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_model_event_sources". All fields are combined with a logical 'AND'. */
export type EventModelEventSourcesBoolExp = {
  _and?: InputMaybe<Array<EventModelEventSourcesBoolExp>>;
  _not?: InputMaybe<EventModelEventSourcesBoolExp>;
  _or?: InputMaybe<Array<EventModelEventSourcesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  event_model?: InputMaybe<EventModelsBoolExp>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_model_event_sources" */
export const EventModelEventSourcesConstraint = {
  /** unique or primary key constraint on columns "id" */
  EventModelEventSourcesPkey: 'event_model_event_sources_pkey',
  /** unique or primary key constraint on columns "workspace_id", "event_source_id", "model_id" */
  EventModelEventSourcesWorkspaceIdModelIdEventSourcKey: 'event_model_event_sources_workspace_id_model_id_event_sourc_key'
} as const;

export type EventModelEventSourcesConstraint = typeof EventModelEventSourcesConstraint[keyof typeof EventModelEventSourcesConstraint];
/** input type for inserting data into table "event_model_event_sources" */
export type EventModelEventSourcesInsertInput = {
  event_model?: InputMaybe<EventModelsObjRelInsertInput>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventModelEventSourcesMaxFields = {
  __typename?: 'event_model_event_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventModelEventSourcesMinFields = {
  __typename?: 'event_model_event_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_model_event_sources" */
export type EventModelEventSourcesMutationResponse = {
  __typename?: 'event_model_event_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventModelEventSources>;
};

/** on_conflict condition type for table "event_model_event_sources" */
export type EventModelEventSourcesOnConflict = {
  constraint: EventModelEventSourcesConstraint;
  update_columns?: Array<EventModelEventSourcesUpdateColumn>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};

/** Ordering options when selecting data from "event_model_event_sources". */
export type EventModelEventSourcesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  event_model?: InputMaybe<EventModelsOrderBy>;
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_model_event_sources" */
export const EventModelEventSourcesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  Id: 'id',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventModelEventSourcesSelectColumn = typeof EventModelEventSourcesSelectColumn[keyof typeof EventModelEventSourcesSelectColumn];
/** aggregate stddev on columns */
export type EventModelEventSourcesStddevFields = {
  __typename?: 'event_model_event_sources_stddev_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventModelEventSourcesStddevPopFields = {
  __typename?: 'event_model_event_sources_stddev_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventModelEventSourcesStddevSampFields = {
  __typename?: 'event_model_event_sources_stddev_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_model_event_sources" */
export type EventModelEventSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventModelEventSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventModelEventSourcesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventModelEventSourcesSumFields = {
  __typename?: 'event_model_event_sources_sum_fields';
  model_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "event_model_event_sources" (current role has no relevant permissions) */
export const EventModelEventSourcesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type EventModelEventSourcesUpdateColumn = typeof EventModelEventSourcesUpdateColumn[keyof typeof EventModelEventSourcesUpdateColumn];
/** aggregate var_pop on columns */
export type EventModelEventSourcesVarPopFields = {
  __typename?: 'event_model_event_sources_var_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventModelEventSourcesVarSampFields = {
  __typename?: 'event_model_event_sources_var_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventModelEventSourcesVarianceFields = {
  __typename?: 'event_model_event_sources_variance_fields';
  model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_model_event_sources" */
export type EventModelEventSourcesVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_models" */
export type EventModels = {
  __typename?: 'event_models';
  campaign_id_column?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_model_event_sources: Array<EventModelEventSources>;
  /** An aggregate relationship */
  event_model_event_sources_aggregate: EventModelEventSourcesAggregate;
  /** An object relationship */
  interaction?: Maybe<InteractionModels>;
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  primary_key?: Maybe<Scalars['String']>;
  realtime_event_type?: Maybe<Scalars['String']>;
  realtime_filter_config?: Maybe<Scalars['jsonb']>;
  timestamp_column: Scalars['String'];
};


/** columns and relationships of "event_models" */
export type EventModelsEventModelEventSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


/** columns and relationships of "event_models" */
export type EventModelsEventModelEventSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


/** columns and relationships of "event_models" */
export type EventModelsRealtimeFilterConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventModelsAppendInput = {
  realtime_filter_config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "event_models". All fields are combined with a logical 'AND'. */
export type EventModelsBoolExp = {
  _and?: InputMaybe<Array<EventModelsBoolExp>>;
  _not?: InputMaybe<EventModelsBoolExp>;
  _or?: InputMaybe<Array<EventModelsBoolExp>>;
  campaign_id_column?: InputMaybe<StringComparisonExp>;
  event_model_event_sources?: InputMaybe<EventModelEventSourcesBoolExp>;
  event_model_event_sources_aggregate?: InputMaybe<EventModelEventSourcesAggregateBoolExp>;
  interaction?: InputMaybe<InteractionModelsBoolExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  primary_key?: InputMaybe<StringComparisonExp>;
  realtime_event_type?: InputMaybe<StringComparisonExp>;
  realtime_filter_config?: InputMaybe<JsonbComparisonExp>;
  timestamp_column?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "event_models" */
export const EventModelsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "model_id" */
  EventModelsModelIdWorkspaceIdKey: 'event_models_model_id_workspace_id_key',
  /** unique or primary key constraint on columns "model_id" */
  EventModelsPkey: 'event_models_pkey'
} as const;

export type EventModelsConstraint = typeof EventModelsConstraint[keyof typeof EventModelsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventModelsDeleteAtPathInput = {
  realtime_filter_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventModelsDeleteElemInput = {
  realtime_filter_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventModelsDeleteKeyInput = {
  realtime_filter_config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "event_models" */
export type EventModelsInsertInput = {
  campaign_id_column?: InputMaybe<Scalars['String']>;
  event_model_event_sources?: InputMaybe<EventModelEventSourcesArrRelInsertInput>;
  interaction?: InputMaybe<InteractionModelsObjRelInsertInput>;
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key?: InputMaybe<Scalars['String']>;
  realtime_event_type?: InputMaybe<Scalars['String']>;
  realtime_filter_config?: InputMaybe<Scalars['jsonb']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "event_models" */
export type EventModelsMutationResponse = {
  __typename?: 'event_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventModels>;
};

/** input type for inserting object relation for remote table "event_models" */
export type EventModelsObjRelInsertInput = {
  data: EventModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EventModelsOnConflict>;
};

/** on_conflict condition type for table "event_models" */
export type EventModelsOnConflict = {
  constraint: EventModelsConstraint;
  update_columns?: Array<EventModelsUpdateColumn>;
  where?: InputMaybe<EventModelsBoolExp>;
};

/** Ordering options when selecting data from "event_models". */
export type EventModelsOrderBy = {
  campaign_id_column?: InputMaybe<OrderBy>;
  event_model_event_sources_aggregate?: InputMaybe<EventModelEventSourcesAggregateOrderBy>;
  interaction?: InputMaybe<InteractionModelsOrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  primary_key?: InputMaybe<OrderBy>;
  realtime_event_type?: InputMaybe<OrderBy>;
  realtime_filter_config?: InputMaybe<OrderBy>;
  timestamp_column?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_models */
export type EventModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventModelsPrependInput = {
  realtime_filter_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_models" */
export const EventModelsSelectColumn = {
  /** column name */
  CampaignIdColumn: 'campaign_id_column',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  RealtimeEventType: 'realtime_event_type',
  /** column name */
  RealtimeFilterConfig: 'realtime_filter_config',
  /** column name */
  TimestampColumn: 'timestamp_column'
} as const;

export type EventModelsSelectColumn = typeof EventModelsSelectColumn[keyof typeof EventModelsSelectColumn];
/** input type for updating data in table "event_models" */
export type EventModelsSetInput = {
  campaign_id_column?: InputMaybe<Scalars['String']>;
  primary_key?: InputMaybe<Scalars['String']>;
  realtime_event_type?: InputMaybe<Scalars['String']>;
  realtime_filter_config?: InputMaybe<Scalars['jsonb']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_models" */
export type EventModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventModelsStreamCursorValueInput = {
  campaign_id_column?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  primary_key?: InputMaybe<Scalars['String']>;
  realtime_event_type?: InputMaybe<Scalars['String']>;
  realtime_filter_config?: InputMaybe<Scalars['jsonb']>;
  timestamp_column?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_models" */
export const EventModelsUpdateColumn = {
  /** column name */
  CampaignIdColumn: 'campaign_id_column',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  RealtimeEventType: 'realtime_event_type',
  /** column name */
  RealtimeFilterConfig: 'realtime_filter_config',
  /** column name */
  TimestampColumn: 'timestamp_column'
} as const;

export type EventModelsUpdateColumn = typeof EventModelsUpdateColumn[keyof typeof EventModelsUpdateColumn];
export type EventModelsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventModelsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventModelsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventModelsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventModelsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventModelsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventModelsSetInput>;
  /** filter the rows which have to be updated */
  where: EventModelsBoolExp;
};

/** columns and relationships of "event_plan_grants" */
export type EventPlanGrants = {
  __typename?: 'event_plan_grants';
  can_access_data: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['uuid'];
  resource_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_plan_grants" */
export type EventPlanGrantsAggregate = {
  __typename?: 'event_plan_grants_aggregate';
  aggregate?: Maybe<EventPlanGrantsAggregateFields>;
  nodes: Array<EventPlanGrants>;
};

/** aggregate fields of "event_plan_grants" */
export type EventPlanGrantsAggregateFields = {
  __typename?: 'event_plan_grants_aggregate_fields';
  avg?: Maybe<EventPlanGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventPlanGrantsMaxFields>;
  min?: Maybe<EventPlanGrantsMinFields>;
  stddev?: Maybe<EventPlanGrantsStddevFields>;
  stddev_pop?: Maybe<EventPlanGrantsStddevPopFields>;
  stddev_samp?: Maybe<EventPlanGrantsStddevSampFields>;
  sum?: Maybe<EventPlanGrantsSumFields>;
  var_pop?: Maybe<EventPlanGrantsVarPopFields>;
  var_samp?: Maybe<EventPlanGrantsVarSampFields>;
  variance?: Maybe<EventPlanGrantsVarianceFields>;
};


/** aggregate fields of "event_plan_grants" */
export type EventPlanGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPlanGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventPlanGrantsAvgFields = {
  __typename?: 'event_plan_grants_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_plan_grants". All fields are combined with a logical 'AND'. */
export type EventPlanGrantsBoolExp = {
  _and?: InputMaybe<Array<EventPlanGrantsBoolExp>>;
  _not?: InputMaybe<EventPlanGrantsBoolExp>;
  _or?: InputMaybe<Array<EventPlanGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_plan_grants" */
export const EventPlanGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  EventPlanGrantsPkey: 'event_plan_grants_pkey',
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id" */
  EventPlanGrantsUserGroupIdWorkspaceIdResourceIdKey: 'event_plan_grants_user_group_id_workspace_id_resource_id_key'
} as const;

export type EventPlanGrantsConstraint = typeof EventPlanGrantsConstraint[keyof typeof EventPlanGrantsConstraint];
/** input type for inserting data into table "event_plan_grants" */
export type EventPlanGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventPlanGrantsMaxFields = {
  __typename?: 'event_plan_grants_max_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventPlanGrantsMinFields = {
  __typename?: 'event_plan_grants_min_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_plan_grants" */
export type EventPlanGrantsMutationResponse = {
  __typename?: 'event_plan_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPlanGrants>;
};

/** on_conflict condition type for table "event_plan_grants" */
export type EventPlanGrantsOnConflict = {
  constraint: EventPlanGrantsConstraint;
  update_columns?: Array<EventPlanGrantsUpdateColumn>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};

/** Ordering options when selecting data from "event_plan_grants". */
export type EventPlanGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_plan_grants */
export type EventPlanGrantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_plan_grants" */
export const EventPlanGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventPlanGrantsSelectColumn = typeof EventPlanGrantsSelectColumn[keyof typeof EventPlanGrantsSelectColumn];
/** input type for updating data in table "event_plan_grants" */
export type EventPlanGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EventPlanGrantsStddevFields = {
  __typename?: 'event_plan_grants_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventPlanGrantsStddevPopFields = {
  __typename?: 'event_plan_grants_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventPlanGrantsStddevSampFields = {
  __typename?: 'event_plan_grants_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_plan_grants" */
export type EventPlanGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventPlanGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlanGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventPlanGrantsSumFields = {
  __typename?: 'event_plan_grants_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_plan_grants" */
export const EventPlanGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type EventPlanGrantsUpdateColumn = typeof EventPlanGrantsUpdateColumn[keyof typeof EventPlanGrantsUpdateColumn];
export type EventPlanGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPlanGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: EventPlanGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type EventPlanGrantsVarPopFields = {
  __typename?: 'event_plan_grants_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventPlanGrantsVarSampFields = {
  __typename?: 'event_plan_grants_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventPlanGrantsVarianceFields = {
  __typename?: 'event_plan_grants_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** tracking plans that configure event_schemas for event_sources */
export type EventPlans = {
  __typename?: 'event_plans';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  default_schema_version: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_components: Array<EventComponents>;
  /** An aggregate relationship */
  event_components_aggregate: EventComponentsAggregate;
  /** An array relationship */
  event_schemas: Array<EventSchemas>;
  /** An aggregate relationship */
  event_schemas_aggregate: EventSchemasAggregate;
  /** An array relationship */
  event_sources_plans: Array<EventSourcesPlans>;
  /** An aggregate relationship */
  event_sources_plans_aggregate: EventSourcesPlansAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  on_undeclared_schema: Scalars['String'];
  schema_version_path: Scalars['jsonb'];
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventSchemasArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventSchemasAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventSourcesPlansArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansEventSourcesPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


/** tracking plans that configure event_schemas for event_sources */
export type EventPlansSchemaVersionPathArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_plans" */
export type EventPlansAggregate = {
  __typename?: 'event_plans_aggregate';
  aggregate?: Maybe<EventPlansAggregateFields>;
  nodes: Array<EventPlans>;
};

/** aggregate fields of "event_plans" */
export type EventPlansAggregateFields = {
  __typename?: 'event_plans_aggregate_fields';
  avg?: Maybe<EventPlansAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventPlansMaxFields>;
  min?: Maybe<EventPlansMinFields>;
  stddev?: Maybe<EventPlansStddevFields>;
  stddev_pop?: Maybe<EventPlansStddevPopFields>;
  stddev_samp?: Maybe<EventPlansStddevSampFields>;
  sum?: Maybe<EventPlansSumFields>;
  var_pop?: Maybe<EventPlansVarPopFields>;
  var_samp?: Maybe<EventPlansVarSampFields>;
  variance?: Maybe<EventPlansVarianceFields>;
};


/** aggregate fields of "event_plans" */
export type EventPlansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventPlansAppendInput = {
  schema_version_path?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EventPlansAvgFields = {
  __typename?: 'event_plans_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_plans". All fields are combined with a logical 'AND'. */
export type EventPlansBoolExp = {
  _and?: InputMaybe<Array<EventPlansBoolExp>>;
  _not?: InputMaybe<EventPlansBoolExp>;
  _or?: InputMaybe<Array<EventPlansBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  default_schema_version?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_components?: InputMaybe<EventComponentsBoolExp>;
  event_components_aggregate?: InputMaybe<EventComponentsAggregateBoolExp>;
  event_schemas?: InputMaybe<EventSchemasBoolExp>;
  event_schemas_aggregate?: InputMaybe<EventSchemasAggregateBoolExp>;
  event_sources_plans?: InputMaybe<EventSourcesPlansBoolExp>;
  event_sources_plans_aggregate?: InputMaybe<EventSourcesPlansAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  on_undeclared_schema?: InputMaybe<StringComparisonExp>;
  schema_version_path?: InputMaybe<JsonbComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_plans" */
export const EventPlansConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventPlansPkey: 'event_plans_pkey',
  /** unique or primary key constraint on columns "workspace_id", "name" */
  EventPlansWorkspaceIdNameKey: 'event_plans_workspace_id_name_key',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  EventPlansWorkspaceIdSlugKey: 'event_plans_workspace_id_slug_key'
} as const;

export type EventPlansConstraint = typeof EventPlansConstraint[keyof typeof EventPlansConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventPlansDeleteAtPathInput = {
  schema_version_path?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventPlansDeleteElemInput = {
  schema_version_path?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventPlansDeleteKeyInput = {
  schema_version_path?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "event_plans" */
export type EventPlansInsertInput = {
  default_schema_version?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  event_components?: InputMaybe<EventComponentsArrRelInsertInput>;
  event_schemas?: InputMaybe<EventSchemasArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schema_version_path?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventPlansMaxFields = {
  __typename?: 'event_plans_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_schema_version?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  on_undeclared_schema?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventPlansMinFields = {
  __typename?: 'event_plans_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_schema_version?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  on_undeclared_schema?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_plans" */
export type EventPlansMutationResponse = {
  __typename?: 'event_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventPlans>;
};

/** input type for inserting object relation for remote table "event_plans" */
export type EventPlansObjRelInsertInput = {
  data: EventPlansInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EventPlansOnConflict>;
};

/** on_conflict condition type for table "event_plans" */
export type EventPlansOnConflict = {
  constraint: EventPlansConstraint;
  update_columns?: Array<EventPlansUpdateColumn>;
  where?: InputMaybe<EventPlansBoolExp>;
};

/** Ordering options when selecting data from "event_plans". */
export type EventPlansOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  default_schema_version?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event_components_aggregate?: InputMaybe<EventComponentsAggregateOrderBy>;
  event_schemas_aggregate?: InputMaybe<EventSchemasAggregateOrderBy>;
  event_sources_plans_aggregate?: InputMaybe<EventSourcesPlansAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  on_undeclared_schema?: InputMaybe<OrderBy>;
  schema_version_path?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_plans */
export type EventPlansPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventPlansPrependInput = {
  schema_version_path?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_plans" */
export const EventPlansSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DefaultSchemaVersion: 'default_schema_version',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OnUndeclaredSchema: 'on_undeclared_schema',
  /** column name */
  SchemaVersionPath: 'schema_version_path',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventPlansSelectColumn = typeof EventPlansSelectColumn[keyof typeof EventPlansSelectColumn];
/** input type for updating data in table "event_plans" */
export type EventPlansSetInput = {
  default_schema_version?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema_version_path?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EventPlansStddevFields = {
  __typename?: 'event_plans_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventPlansStddevPopFields = {
  __typename?: 'event_plans_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventPlansStddevSampFields = {
  __typename?: 'event_plans_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_plans" */
export type EventPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventPlansStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  default_schema_version?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  on_undeclared_schema?: InputMaybe<Scalars['String']>;
  schema_version_path?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventPlansSumFields = {
  __typename?: 'event_plans_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_plans" */
export const EventPlansUpdateColumn = {
  /** column name */
  DefaultSchemaVersion: 'default_schema_version',
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  SchemaVersionPath: 'schema_version_path',
  /** column name */
  Slug: 'slug'
} as const;

export type EventPlansUpdateColumn = typeof EventPlansUpdateColumn[keyof typeof EventPlansUpdateColumn];
export type EventPlansUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventPlansAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventPlansDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventPlansDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventPlansDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventPlansPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventPlansSetInput>;
  /** filter the rows which have to be updated */
  where: EventPlansBoolExp;
};

/** aggregate var_pop on columns */
export type EventPlansVarPopFields = {
  __typename?: 'event_plans_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventPlansVarSampFields = {
  __typename?: 'event_plans_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventPlansVarianceFields = {
  __typename?: 'event_plans_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_schema_components" */
export type EventSchemaComponents = {
  __typename?: 'event_schema_components';
  component_id: Scalars['uuid'];
  /** An object relationship */
  event_component: EventComponents;
  /** An object relationship */
  event_schema: EventSchemas;
  event_schema_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_schema_components" */
export type EventSchemaComponentsAggregate = {
  __typename?: 'event_schema_components_aggregate';
  aggregate?: Maybe<EventSchemaComponentsAggregateFields>;
  nodes: Array<EventSchemaComponents>;
};

export type EventSchemaComponentsAggregateBoolExp = {
  count?: InputMaybe<EventSchemaComponentsAggregateBoolExpCount>;
};

export type EventSchemaComponentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSchemaComponentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_schema_components" */
export type EventSchemaComponentsAggregateFields = {
  __typename?: 'event_schema_components_aggregate_fields';
  avg?: Maybe<EventSchemaComponentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventSchemaComponentsMaxFields>;
  min?: Maybe<EventSchemaComponentsMinFields>;
  stddev?: Maybe<EventSchemaComponentsStddevFields>;
  stddev_pop?: Maybe<EventSchemaComponentsStddevPopFields>;
  stddev_samp?: Maybe<EventSchemaComponentsStddevSampFields>;
  sum?: Maybe<EventSchemaComponentsSumFields>;
  var_pop?: Maybe<EventSchemaComponentsVarPopFields>;
  var_samp?: Maybe<EventSchemaComponentsVarSampFields>;
  variance?: Maybe<EventSchemaComponentsVarianceFields>;
};


/** aggregate fields of "event_schema_components" */
export type EventSchemaComponentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_schema_components" */
export type EventSchemaComponentsAggregateOrderBy = {
  avg?: InputMaybe<EventSchemaComponentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSchemaComponentsMaxOrderBy>;
  min?: InputMaybe<EventSchemaComponentsMinOrderBy>;
  stddev?: InputMaybe<EventSchemaComponentsStddevOrderBy>;
  stddev_pop?: InputMaybe<EventSchemaComponentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventSchemaComponentsStddevSampOrderBy>;
  sum?: InputMaybe<EventSchemaComponentsSumOrderBy>;
  var_pop?: InputMaybe<EventSchemaComponentsVarPopOrderBy>;
  var_samp?: InputMaybe<EventSchemaComponentsVarSampOrderBy>;
  variance?: InputMaybe<EventSchemaComponentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "event_schema_components" */
export type EventSchemaComponentsArrRelInsertInput = {
  data: Array<EventSchemaComponentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventSchemaComponentsOnConflict>;
};

/** aggregate avg on columns */
export type EventSchemaComponentsAvgFields = {
  __typename?: 'event_schema_components_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_schema_components" */
export type EventSchemaComponentsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_schema_components". All fields are combined with a logical 'AND'. */
export type EventSchemaComponentsBoolExp = {
  _and?: InputMaybe<Array<EventSchemaComponentsBoolExp>>;
  _not?: InputMaybe<EventSchemaComponentsBoolExp>;
  _or?: InputMaybe<Array<EventSchemaComponentsBoolExp>>;
  component_id?: InputMaybe<UuidComparisonExp>;
  event_component?: InputMaybe<EventComponentsBoolExp>;
  event_schema?: InputMaybe<EventSchemasBoolExp>;
  event_schema_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_schema_components" */
export const EventSchemaComponentsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "component_id", "event_schema_id" */
  EventSchemaComponentsPkey: 'event_schema_components_pkey'
} as const;

export type EventSchemaComponentsConstraint = typeof EventSchemaComponentsConstraint[keyof typeof EventSchemaComponentsConstraint];
/** input type for inserting data into table "event_schema_components" */
export type EventSchemaComponentsInsertInput = {
  component_id?: InputMaybe<Scalars['uuid']>;
  event_component?: InputMaybe<EventComponentsObjRelInsertInput>;
  event_schema?: InputMaybe<EventSchemasObjRelInsertInput>;
  event_schema_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EventSchemaComponentsMaxFields = {
  __typename?: 'event_schema_components_max_fields';
  component_id?: Maybe<Scalars['uuid']>;
  event_schema_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_schema_components" */
export type EventSchemaComponentsMaxOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_schema_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventSchemaComponentsMinFields = {
  __typename?: 'event_schema_components_min_fields';
  component_id?: Maybe<Scalars['uuid']>;
  event_schema_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_schema_components" */
export type EventSchemaComponentsMinOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_schema_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_schema_components" */
export type EventSchemaComponentsMutationResponse = {
  __typename?: 'event_schema_components_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSchemaComponents>;
};

/** on_conflict condition type for table "event_schema_components" */
export type EventSchemaComponentsOnConflict = {
  constraint: EventSchemaComponentsConstraint;
  update_columns?: Array<EventSchemaComponentsUpdateColumn>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};

/** Ordering options when selecting data from "event_schema_components". */
export type EventSchemaComponentsOrderBy = {
  component_id?: InputMaybe<OrderBy>;
  event_component?: InputMaybe<EventComponentsOrderBy>;
  event_schema?: InputMaybe<EventSchemasOrderBy>;
  event_schema_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_schema_components" */
export const EventSchemaComponentsSelectColumn = {
  /** column name */
  ComponentId: 'component_id',
  /** column name */
  EventSchemaId: 'event_schema_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventSchemaComponentsSelectColumn = typeof EventSchemaComponentsSelectColumn[keyof typeof EventSchemaComponentsSelectColumn];
/** aggregate stddev on columns */
export type EventSchemaComponentsStddevFields = {
  __typename?: 'event_schema_components_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_schema_components" */
export type EventSchemaComponentsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventSchemaComponentsStddevPopFields = {
  __typename?: 'event_schema_components_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_schema_components" */
export type EventSchemaComponentsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventSchemaComponentsStddevSampFields = {
  __typename?: 'event_schema_components_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_schema_components" */
export type EventSchemaComponentsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_schema_components" */
export type EventSchemaComponentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSchemaComponentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSchemaComponentsStreamCursorValueInput = {
  component_id?: InputMaybe<Scalars['uuid']>;
  event_schema_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventSchemaComponentsSumFields = {
  __typename?: 'event_schema_components_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_schema_components" */
export type EventSchemaComponentsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "event_schema_components" (current role has no relevant permissions) */
export const EventSchemaComponentsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type EventSchemaComponentsUpdateColumn = typeof EventSchemaComponentsUpdateColumn[keyof typeof EventSchemaComponentsUpdateColumn];
/** aggregate var_pop on columns */
export type EventSchemaComponentsVarPopFields = {
  __typename?: 'event_schema_components_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_schema_components" */
export type EventSchemaComponentsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventSchemaComponentsVarSampFields = {
  __typename?: 'event_schema_components_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_schema_components" */
export type EventSchemaComponentsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventSchemaComponentsVarianceFields = {
  __typename?: 'event_schema_components_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_schema_components" */
export type EventSchemaComponentsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** validation rules for specific events found in a tracking plan */
export type EventSchemas = {
  __typename?: 'event_schemas';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  event_name?: Maybe<Scalars['String']>;
  event_plan_id: Scalars['uuid'];
  /** An array relationship */
  event_schema_components: Array<EventSchemaComponents>;
  /** An aggregate relationship */
  event_schema_components_aggregate: EventSchemaComponentsAggregate;
  event_type: Scalars['String'];
  event_version: Scalars['String'];
  id: Scalars['uuid'];
  include_built_in_context: Scalars['Boolean'];
  on_schema_violation: Scalars['String'];
  on_undeclared_fields: Scalars['String'];
  schema: Scalars['jsonb'];
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** validation rules for specific events found in a tracking plan */
export type EventSchemasEventSchemaComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


/** validation rules for specific events found in a tracking plan */
export type EventSchemasEventSchemaComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


/** validation rules for specific events found in a tracking plan */
export type EventSchemasSchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_schemas" */
export type EventSchemasAggregate = {
  __typename?: 'event_schemas_aggregate';
  aggregate?: Maybe<EventSchemasAggregateFields>;
  nodes: Array<EventSchemas>;
};

export type EventSchemasAggregateBoolExp = {
  bool_and?: InputMaybe<EventSchemasAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<EventSchemasAggregateBoolExpBoolOr>;
  count?: InputMaybe<EventSchemasAggregateBoolExpCount>;
};

export type EventSchemasAggregateBoolExpBoolAnd = {
  arguments: EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSchemasBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventSchemasAggregateBoolExpBoolOr = {
  arguments: EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSchemasBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventSchemasAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventSchemasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSchemasBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_schemas" */
export type EventSchemasAggregateFields = {
  __typename?: 'event_schemas_aggregate_fields';
  avg?: Maybe<EventSchemasAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventSchemasMaxFields>;
  min?: Maybe<EventSchemasMinFields>;
  stddev?: Maybe<EventSchemasStddevFields>;
  stddev_pop?: Maybe<EventSchemasStddevPopFields>;
  stddev_samp?: Maybe<EventSchemasStddevSampFields>;
  sum?: Maybe<EventSchemasSumFields>;
  var_pop?: Maybe<EventSchemasVarPopFields>;
  var_samp?: Maybe<EventSchemasVarSampFields>;
  variance?: Maybe<EventSchemasVarianceFields>;
};


/** aggregate fields of "event_schemas" */
export type EventSchemasAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSchemasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_schemas" */
export type EventSchemasAggregateOrderBy = {
  avg?: InputMaybe<EventSchemasAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSchemasMaxOrderBy>;
  min?: InputMaybe<EventSchemasMinOrderBy>;
  stddev?: InputMaybe<EventSchemasStddevOrderBy>;
  stddev_pop?: InputMaybe<EventSchemasStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventSchemasStddevSampOrderBy>;
  sum?: InputMaybe<EventSchemasSumOrderBy>;
  var_pop?: InputMaybe<EventSchemasVarPopOrderBy>;
  var_samp?: InputMaybe<EventSchemasVarSampOrderBy>;
  variance?: InputMaybe<EventSchemasVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventSchemasAppendInput = {
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event_schemas" */
export type EventSchemasArrRelInsertInput = {
  data: Array<EventSchemasInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventSchemasOnConflict>;
};

/** aggregate avg on columns */
export type EventSchemasAvgFields = {
  __typename?: 'event_schemas_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_schemas" */
export type EventSchemasAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_schemas". All fields are combined with a logical 'AND'. */
export type EventSchemasBoolExp = {
  _and?: InputMaybe<Array<EventSchemasBoolExp>>;
  _not?: InputMaybe<EventSchemasBoolExp>;
  _or?: InputMaybe<Array<EventSchemasBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  event_name?: InputMaybe<StringComparisonExp>;
  event_plan_id?: InputMaybe<UuidComparisonExp>;
  event_schema_components?: InputMaybe<EventSchemaComponentsBoolExp>;
  event_schema_components_aggregate?: InputMaybe<EventSchemaComponentsAggregateBoolExp>;
  event_type?: InputMaybe<StringComparisonExp>;
  event_version?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  include_built_in_context?: InputMaybe<BooleanComparisonExp>;
  on_schema_violation?: InputMaybe<StringComparisonExp>;
  on_undeclared_fields?: InputMaybe<StringComparisonExp>;
  schema?: InputMaybe<JsonbComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_schemas" */
export const EventSchemasConstraint = {
  /** unique or primary key constraint on columns "event_version", "event_name", "event_type", "event_plan_id" */
  EventSchemasEventPlanIdEventTypeEventVersionEventName: 'event_schemas_event_plan_id_event_type_event_version_event_name',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  EventSchemasPkey: 'event_schemas_pkey',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  EventSchemasWorkspaceIdSlugKey: 'event_schemas_workspace_id_slug_key'
} as const;

export type EventSchemasConstraint = typeof EventSchemasConstraint[keyof typeof EventSchemasConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventSchemasDeleteAtPathInput = {
  schema?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventSchemasDeleteElemInput = {
  schema?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventSchemasDeleteKeyInput = {
  schema?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "event_schemas" */
export type EventSchemasInsertInput = {
  event_name?: InputMaybe<Scalars['String']>;
  event_plan_id?: InputMaybe<Scalars['uuid']>;
  event_schema_components?: InputMaybe<EventSchemaComponentsArrRelInsertInput>;
  event_type?: InputMaybe<Scalars['String']>;
  event_version?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_built_in_context?: InputMaybe<Scalars['Boolean']>;
  on_schema_violation?: InputMaybe<Scalars['String']>;
  on_undeclared_fields?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EventSchemasMaxFields = {
  __typename?: 'event_schemas_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  event_name?: Maybe<Scalars['String']>;
  event_plan_id?: Maybe<Scalars['uuid']>;
  event_type?: Maybe<Scalars['String']>;
  event_version?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  on_schema_violation?: Maybe<Scalars['String']>;
  on_undeclared_fields?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_schemas" */
export type EventSchemasMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  event_name?: InputMaybe<OrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  event_type?: InputMaybe<OrderBy>;
  event_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  on_schema_violation?: InputMaybe<OrderBy>;
  on_undeclared_fields?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventSchemasMinFields = {
  __typename?: 'event_schemas_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  event_name?: Maybe<Scalars['String']>;
  event_plan_id?: Maybe<Scalars['uuid']>;
  event_type?: Maybe<Scalars['String']>;
  event_version?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  on_schema_violation?: Maybe<Scalars['String']>;
  on_undeclared_fields?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_schemas" */
export type EventSchemasMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  event_name?: InputMaybe<OrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  event_type?: InputMaybe<OrderBy>;
  event_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  on_schema_violation?: InputMaybe<OrderBy>;
  on_undeclared_fields?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_schemas" */
export type EventSchemasMutationResponse = {
  __typename?: 'event_schemas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSchemas>;
};

/** input type for inserting object relation for remote table "event_schemas" */
export type EventSchemasObjRelInsertInput = {
  data: EventSchemasInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EventSchemasOnConflict>;
};

/** on_conflict condition type for table "event_schemas" */
export type EventSchemasOnConflict = {
  constraint: EventSchemasConstraint;
  update_columns?: Array<EventSchemasUpdateColumn>;
  where?: InputMaybe<EventSchemasBoolExp>;
};

/** Ordering options when selecting data from "event_schemas". */
export type EventSchemasOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  event_name?: InputMaybe<OrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  event_schema_components_aggregate?: InputMaybe<EventSchemaComponentsAggregateOrderBy>;
  event_type?: InputMaybe<OrderBy>;
  event_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  include_built_in_context?: InputMaybe<OrderBy>;
  on_schema_violation?: InputMaybe<OrderBy>;
  on_undeclared_fields?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_schemas */
export type EventSchemasPkColumnsInput = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventSchemasPrependInput = {
  schema?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_schemas" */
export const EventSchemasSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EventName: 'event_name',
  /** column name */
  EventPlanId: 'event_plan_id',
  /** column name */
  EventType: 'event_type',
  /** column name */
  EventVersion: 'event_version',
  /** column name */
  Id: 'id',
  /** column name */
  IncludeBuiltInContext: 'include_built_in_context',
  /** column name */
  OnSchemaViolation: 'on_schema_violation',
  /** column name */
  OnUndeclaredFields: 'on_undeclared_fields',
  /** column name */
  Schema: 'schema',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventSchemasSelectColumn = typeof EventSchemasSelectColumn[keyof typeof EventSchemasSelectColumn];
/** select "event_schemas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event_schemas" */
export const EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IncludeBuiltInContext: 'include_built_in_context'
} as const;

export type EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolAndArgumentsColumns = typeof EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolAndArgumentsColumns[keyof typeof EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolAndArgumentsColumns];
/** select "event_schemas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event_schemas" */
export const EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IncludeBuiltInContext: 'include_built_in_context'
} as const;

export type EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolOrArgumentsColumns = typeof EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolOrArgumentsColumns[keyof typeof EventSchemasSelectColumnEventSchemasAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "event_schemas" */
export type EventSchemasSetInput = {
  event_name?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<Scalars['String']>;
  event_version?: InputMaybe<Scalars['String']>;
  include_built_in_context?: InputMaybe<Scalars['Boolean']>;
  on_schema_violation?: InputMaybe<Scalars['String']>;
  on_undeclared_fields?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type EventSchemasStddevFields = {
  __typename?: 'event_schemas_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_schemas" */
export type EventSchemasStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventSchemasStddevPopFields = {
  __typename?: 'event_schemas_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_schemas" */
export type EventSchemasStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventSchemasStddevSampFields = {
  __typename?: 'event_schemas_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_schemas" */
export type EventSchemasStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_schemas" */
export type EventSchemasStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSchemasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSchemasStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  event_name?: InputMaybe<Scalars['String']>;
  event_plan_id?: InputMaybe<Scalars['uuid']>;
  event_type?: InputMaybe<Scalars['String']>;
  event_version?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_built_in_context?: InputMaybe<Scalars['Boolean']>;
  on_schema_violation?: InputMaybe<Scalars['String']>;
  on_undeclared_fields?: InputMaybe<Scalars['String']>;
  schema?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventSchemasSumFields = {
  __typename?: 'event_schemas_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_schemas" */
export type EventSchemasSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "event_schemas" */
export const EventSchemasUpdateColumn = {
  /** column name */
  EventName: 'event_name',
  /** column name */
  EventType: 'event_type',
  /** column name */
  EventVersion: 'event_version',
  /** column name */
  IncludeBuiltInContext: 'include_built_in_context',
  /** column name */
  OnSchemaViolation: 'on_schema_violation',
  /** column name */
  OnUndeclaredFields: 'on_undeclared_fields',
  /** column name */
  Schema: 'schema',
  /** column name */
  Slug: 'slug'
} as const;

export type EventSchemasUpdateColumn = typeof EventSchemasUpdateColumn[keyof typeof EventSchemasUpdateColumn];
export type EventSchemasUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventSchemasAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventSchemasDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventSchemasDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventSchemasDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventSchemasPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSchemasSetInput>;
  /** filter the rows which have to be updated */
  where: EventSchemasBoolExp;
};

/** aggregate var_pop on columns */
export type EventSchemasVarPopFields = {
  __typename?: 'event_schemas_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_schemas" */
export type EventSchemasVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventSchemasVarSampFields = {
  __typename?: 'event_schemas_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_schemas" */
export type EventSchemasVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventSchemasVarianceFields = {
  __typename?: 'event_schemas_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_schemas" */
export type EventSchemasVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_source_contracts" */
export type EventSourceContracts = {
  __typename?: 'event_source_contracts';
  event_contract_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "event_source_contracts". All fields are combined with a logical 'AND'. */
export type EventSourceContractsBoolExp = {
  _and?: InputMaybe<Array<EventSourceContractsBoolExp>>;
  _not?: InputMaybe<EventSourceContractsBoolExp>;
  _or?: InputMaybe<Array<EventSourceContractsBoolExp>>;
  event_contract_id?: InputMaybe<UuidComparisonExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_source_contracts" */
export const EventSourceContractsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "event_contract_id", "event_source_id" */
  EventSourceContractsPkey: 'event_source_contracts_pkey'
} as const;

export type EventSourceContractsConstraint = typeof EventSourceContractsConstraint[keyof typeof EventSourceContractsConstraint];
/** input type for inserting data into table "event_source_contracts" */
export type EventSourceContractsInsertInput = {
  event_contract_id?: InputMaybe<Scalars['uuid']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "event_source_contracts" */
export type EventSourceContractsMutationResponse = {
  __typename?: 'event_source_contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSourceContracts>;
};

/** on_conflict condition type for table "event_source_contracts" */
export type EventSourceContractsOnConflict = {
  constraint: EventSourceContractsConstraint;
  update_columns?: Array<EventSourceContractsUpdateColumn>;
  where?: InputMaybe<EventSourceContractsBoolExp>;
};

/** Ordering options when selecting data from "event_source_contracts". */
export type EventSourceContractsOrderBy = {
  event_contract_id?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_source_contracts */
export type EventSourceContractsPkColumnsInput = {
  event_contract_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "event_source_contracts" */
export const EventSourceContractsSelectColumn = {
  /** column name */
  EventContractId: 'event_contract_id',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventSourceContractsSelectColumn = typeof EventSourceContractsSelectColumn[keyof typeof EventSourceContractsSelectColumn];
/** input type for updating data in table "event_source_contracts" */
export type EventSourceContractsSetInput = {
  event_contract_id?: InputMaybe<Scalars['uuid']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_source_contracts" */
export type EventSourceContractsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSourceContractsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSourceContractsStreamCursorValueInput = {
  event_contract_id?: InputMaybe<Scalars['uuid']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "event_source_contracts" */
export const EventSourceContractsUpdateColumn = {
  /** column name */
  EventContractId: 'event_contract_id',
  /** column name */
  EventSourceId: 'event_source_id'
} as const;

export type EventSourceContractsUpdateColumn = typeof EventSourceContractsUpdateColumn[keyof typeof EventSourceContractsUpdateColumn];
export type EventSourceContractsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSourceContractsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSourceContractsBoolExp;
};

/** columns and relationships of "event_source_grants" */
export type EventSourceGrants = {
  __typename?: 'event_source_grants';
  can_access_data: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['uuid'];
  resource_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_source_grants" */
export type EventSourceGrantsAggregate = {
  __typename?: 'event_source_grants_aggregate';
  aggregate?: Maybe<EventSourceGrantsAggregateFields>;
  nodes: Array<EventSourceGrants>;
};

/** aggregate fields of "event_source_grants" */
export type EventSourceGrantsAggregateFields = {
  __typename?: 'event_source_grants_aggregate_fields';
  avg?: Maybe<EventSourceGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventSourceGrantsMaxFields>;
  min?: Maybe<EventSourceGrantsMinFields>;
  stddev?: Maybe<EventSourceGrantsStddevFields>;
  stddev_pop?: Maybe<EventSourceGrantsStddevPopFields>;
  stddev_samp?: Maybe<EventSourceGrantsStddevSampFields>;
  sum?: Maybe<EventSourceGrantsSumFields>;
  var_pop?: Maybe<EventSourceGrantsVarPopFields>;
  var_samp?: Maybe<EventSourceGrantsVarSampFields>;
  variance?: Maybe<EventSourceGrantsVarianceFields>;
};


/** aggregate fields of "event_source_grants" */
export type EventSourceGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSourceGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventSourceGrantsAvgFields = {
  __typename?: 'event_source_grants_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_source_grants". All fields are combined with a logical 'AND'. */
export type EventSourceGrantsBoolExp = {
  _and?: InputMaybe<Array<EventSourceGrantsBoolExp>>;
  _not?: InputMaybe<EventSourceGrantsBoolExp>;
  _or?: InputMaybe<Array<EventSourceGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_source_grants" */
export const EventSourceGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  EventSourceGrantsPkey: 'event_source_grants_pkey',
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id" */
  EventSourceGrantsUserGroupIdWorkspaceIdResourceIdKey: 'event_source_grants_user_group_id_workspace_id_resource_id_key'
} as const;

export type EventSourceGrantsConstraint = typeof EventSourceGrantsConstraint[keyof typeof EventSourceGrantsConstraint];
/** input type for inserting data into table "event_source_grants" */
export type EventSourceGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventSourceGrantsMaxFields = {
  __typename?: 'event_source_grants_max_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventSourceGrantsMinFields = {
  __typename?: 'event_source_grants_min_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_source_grants" */
export type EventSourceGrantsMutationResponse = {
  __typename?: 'event_source_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSourceGrants>;
};

/** on_conflict condition type for table "event_source_grants" */
export type EventSourceGrantsOnConflict = {
  constraint: EventSourceGrantsConstraint;
  update_columns?: Array<EventSourceGrantsUpdateColumn>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};

/** Ordering options when selecting data from "event_source_grants". */
export type EventSourceGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_source_grants */
export type EventSourceGrantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_source_grants" */
export const EventSourceGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventSourceGrantsSelectColumn = typeof EventSourceGrantsSelectColumn[keyof typeof EventSourceGrantsSelectColumn];
/** input type for updating data in table "event_source_grants" */
export type EventSourceGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EventSourceGrantsStddevFields = {
  __typename?: 'event_source_grants_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventSourceGrantsStddevPopFields = {
  __typename?: 'event_source_grants_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventSourceGrantsStddevSampFields = {
  __typename?: 'event_source_grants_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_source_grants" */
export type EventSourceGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSourceGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSourceGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventSourceGrantsSumFields = {
  __typename?: 'event_source_grants_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_source_grants" */
export const EventSourceGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type EventSourceGrantsUpdateColumn = typeof EventSourceGrantsUpdateColumn[keyof typeof EventSourceGrantsUpdateColumn];
export type EventSourceGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventSourceGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: EventSourceGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type EventSourceGrantsVarPopFields = {
  __typename?: 'event_source_grants_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventSourceGrantsVarSampFields = {
  __typename?: 'event_source_grants_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventSourceGrantsVarianceFields = {
  __typename?: 'event_source_grants_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_sources" */
export type EventSources = {
  __typename?: 'event_sources';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  credential_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  event_sources_plans: Array<EventSourcesPlans>;
  /** An aggregate relationship */
  event_sources_plans_aggregate: EventSourcesPlansAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  on_undeclared_schema: Scalars['String'];
  slug: Scalars['String'];
  tunnel_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
  write_key?: Maybe<Scalars['String']>;
};


/** columns and relationships of "event_sources" */
export type EventSourcesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "event_sources" */
export type EventSourcesEventSourcesPlansArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


/** columns and relationships of "event_sources" */
export type EventSourcesEventSourcesPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};

/** aggregated selection of "event_sources" */
export type EventSourcesAggregate = {
  __typename?: 'event_sources_aggregate';
  aggregate?: Maybe<EventSourcesAggregateFields>;
  nodes: Array<EventSources>;
};

/** aggregate fields of "event_sources" */
export type EventSourcesAggregateFields = {
  __typename?: 'event_sources_aggregate_fields';
  avg?: Maybe<EventSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventSourcesMaxFields>;
  min?: Maybe<EventSourcesMinFields>;
  stddev?: Maybe<EventSourcesStddevFields>;
  stddev_pop?: Maybe<EventSourcesStddevPopFields>;
  stddev_samp?: Maybe<EventSourcesStddevSampFields>;
  sum?: Maybe<EventSourcesSumFields>;
  var_pop?: Maybe<EventSourcesVarPopFields>;
  var_samp?: Maybe<EventSourcesVarSampFields>;
  variance?: Maybe<EventSourcesVarianceFields>;
};


/** aggregate fields of "event_sources" */
export type EventSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventSourcesAvgFields = {
  __typename?: 'event_sources_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_sources". All fields are combined with a logical 'AND'. */
export type EventSourcesBoolExp = {
  _and?: InputMaybe<Array<EventSourcesBoolExp>>;
  _not?: InputMaybe<EventSourcesBoolExp>;
  _or?: InputMaybe<Array<EventSourcesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  credential_id?: InputMaybe<BigintComparisonExp>;
  event_sources_plans?: InputMaybe<EventSourcesPlansBoolExp>;
  event_sources_plans_aggregate?: InputMaybe<EventSourcesPlansAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  on_undeclared_schema?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
  write_key?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type EventSourcesMaxFields = {
  __typename?: 'event_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  on_undeclared_schema?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
  write_key?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EventSourcesMinFields = {
  __typename?: 'event_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  on_undeclared_schema?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
  write_key?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_sources" */
export type EventSourcesMutationResponse = {
  __typename?: 'event_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventSources>;
};

/** Ordering options when selecting data from "event_sources". */
export type EventSourcesOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  event_sources_plans_aggregate?: InputMaybe<EventSourcesPlansAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  on_undeclared_schema?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
  write_key?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_sources_plans" */
export type EventSourcesPlans = {
  __typename?: 'event_sources_plans';
  /** An object relationship */
  event_plan: EventPlans;
  event_plan_id: Scalars['uuid'];
  /** An object relationship */
  event_source: EventSources;
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_sources_plans" */
export type EventSourcesPlansAggregate = {
  __typename?: 'event_sources_plans_aggregate';
  aggregate?: Maybe<EventSourcesPlansAggregateFields>;
  nodes: Array<EventSourcesPlans>;
};

export type EventSourcesPlansAggregateBoolExp = {
  count?: InputMaybe<EventSourcesPlansAggregateBoolExpCount>;
};

export type EventSourcesPlansAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventSourcesPlansBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_sources_plans" */
export type EventSourcesPlansAggregateFields = {
  __typename?: 'event_sources_plans_aggregate_fields';
  avg?: Maybe<EventSourcesPlansAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventSourcesPlansMaxFields>;
  min?: Maybe<EventSourcesPlansMinFields>;
  stddev?: Maybe<EventSourcesPlansStddevFields>;
  stddev_pop?: Maybe<EventSourcesPlansStddevPopFields>;
  stddev_samp?: Maybe<EventSourcesPlansStddevSampFields>;
  sum?: Maybe<EventSourcesPlansSumFields>;
  var_pop?: Maybe<EventSourcesPlansVarPopFields>;
  var_samp?: Maybe<EventSourcesPlansVarSampFields>;
  variance?: Maybe<EventSourcesPlansVarianceFields>;
};


/** aggregate fields of "event_sources_plans" */
export type EventSourcesPlansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_sources_plans" */
export type EventSourcesPlansAggregateOrderBy = {
  avg?: InputMaybe<EventSourcesPlansAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventSourcesPlansMaxOrderBy>;
  min?: InputMaybe<EventSourcesPlansMinOrderBy>;
  stddev?: InputMaybe<EventSourcesPlansStddevOrderBy>;
  stddev_pop?: InputMaybe<EventSourcesPlansStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventSourcesPlansStddevSampOrderBy>;
  sum?: InputMaybe<EventSourcesPlansSumOrderBy>;
  var_pop?: InputMaybe<EventSourcesPlansVarPopOrderBy>;
  var_samp?: InputMaybe<EventSourcesPlansVarSampOrderBy>;
  variance?: InputMaybe<EventSourcesPlansVarianceOrderBy>;
};

/** aggregate avg on columns */
export type EventSourcesPlansAvgFields = {
  __typename?: 'event_sources_plans_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_sources_plans" */
export type EventSourcesPlansAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_sources_plans". All fields are combined with a logical 'AND'. */
export type EventSourcesPlansBoolExp = {
  _and?: InputMaybe<Array<EventSourcesPlansBoolExp>>;
  _not?: InputMaybe<EventSourcesPlansBoolExp>;
  _or?: InputMaybe<Array<EventSourcesPlansBoolExp>>;
  event_plan?: InputMaybe<EventPlansBoolExp>;
  event_plan_id?: InputMaybe<UuidComparisonExp>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EventSourcesPlansMaxFields = {
  __typename?: 'event_sources_plans_max_fields';
  event_plan_id?: Maybe<Scalars['uuid']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_sources_plans" */
export type EventSourcesPlansMaxOrderBy = {
  event_plan_id?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventSourcesPlansMinFields = {
  __typename?: 'event_sources_plans_min_fields';
  event_plan_id?: Maybe<Scalars['uuid']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_sources_plans" */
export type EventSourcesPlansMinOrderBy = {
  event_plan_id?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_sources_plans". */
export type EventSourcesPlansOrderBy = {
  event_plan?: InputMaybe<EventPlansOrderBy>;
  event_plan_id?: InputMaybe<OrderBy>;
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_sources_plans" */
export const EventSourcesPlansSelectColumn = {
  /** column name */
  EventPlanId: 'event_plan_id',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventSourcesPlansSelectColumn = typeof EventSourcesPlansSelectColumn[keyof typeof EventSourcesPlansSelectColumn];
/** aggregate stddev on columns */
export type EventSourcesPlansStddevFields = {
  __typename?: 'event_sources_plans_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_sources_plans" */
export type EventSourcesPlansStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventSourcesPlansStddevPopFields = {
  __typename?: 'event_sources_plans_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_sources_plans" */
export type EventSourcesPlansStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventSourcesPlansStddevSampFields = {
  __typename?: 'event_sources_plans_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_sources_plans" */
export type EventSourcesPlansStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_sources_plans" */
export type EventSourcesPlansStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSourcesPlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSourcesPlansStreamCursorValueInput = {
  event_plan_id?: InputMaybe<Scalars['uuid']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventSourcesPlansSumFields = {
  __typename?: 'event_sources_plans_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_sources_plans" */
export type EventSourcesPlansSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type EventSourcesPlansVarPopFields = {
  __typename?: 'event_sources_plans_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_sources_plans" */
export type EventSourcesPlansVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventSourcesPlansVarSampFields = {
  __typename?: 'event_sources_plans_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_sources_plans" */
export type EventSourcesPlansVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventSourcesPlansVarianceFields = {
  __typename?: 'event_sources_plans_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_sources_plans" */
export type EventSourcesPlansVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_sources" */
export const EventSourcesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OnUndeclaredSchema: 'on_undeclared_schema',
  /** column name */
  Slug: 'slug',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id',
  /** column name */
  WriteKey: 'write_key'
} as const;

export type EventSourcesSelectColumn = typeof EventSourcesSelectColumn[keyof typeof EventSourcesSelectColumn];
/** aggregate stddev on columns */
export type EventSourcesStddevFields = {
  __typename?: 'event_sources_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventSourcesStddevPopFields = {
  __typename?: 'event_sources_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventSourcesStddevSampFields = {
  __typename?: 'event_sources_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_sources" */
export type EventSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventSourcesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  on_undeclared_schema?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
  write_key?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type EventSourcesSumFields = {
  __typename?: 'event_sources_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type EventSourcesVarPopFields = {
  __typename?: 'event_sources_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventSourcesVarSampFields = {
  __typename?: 'event_sources_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventSourcesVarianceFields = {
  __typename?: 'event_sources_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrants = {
  __typename?: 'event_warehouse_destination_grants';
  can_access_data: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['uuid'];
  resource_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsAggregate = {
  __typename?: 'event_warehouse_destination_grants_aggregate';
  aggregate?: Maybe<EventWarehouseDestinationGrantsAggregateFields>;
  nodes: Array<EventWarehouseDestinationGrants>;
};

/** aggregate fields of "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsAggregateFields = {
  __typename?: 'event_warehouse_destination_grants_aggregate_fields';
  avg?: Maybe<EventWarehouseDestinationGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventWarehouseDestinationGrantsMaxFields>;
  min?: Maybe<EventWarehouseDestinationGrantsMinFields>;
  stddev?: Maybe<EventWarehouseDestinationGrantsStddevFields>;
  stddev_pop?: Maybe<EventWarehouseDestinationGrantsStddevPopFields>;
  stddev_samp?: Maybe<EventWarehouseDestinationGrantsStddevSampFields>;
  sum?: Maybe<EventWarehouseDestinationGrantsSumFields>;
  var_pop?: Maybe<EventWarehouseDestinationGrantsVarPopFields>;
  var_samp?: Maybe<EventWarehouseDestinationGrantsVarSampFields>;
  variance?: Maybe<EventWarehouseDestinationGrantsVarianceFields>;
};


/** aggregate fields of "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventWarehouseDestinationGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EventWarehouseDestinationGrantsAvgFields = {
  __typename?: 'event_warehouse_destination_grants_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_warehouse_destination_grants". All fields are combined with a logical 'AND'. */
export type EventWarehouseDestinationGrantsBoolExp = {
  _and?: InputMaybe<Array<EventWarehouseDestinationGrantsBoolExp>>;
  _not?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
  _or?: InputMaybe<Array<EventWarehouseDestinationGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "event_warehouse_destination_grants" */
export const EventWarehouseDestinationGrantsConstraint = {
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id" */
  EventWarehouseDestinationGUserGroupIdWorkspaceIdReKey: 'event_warehouse_destination_g_user_group_id_workspace_id_re_key',
  /** unique or primary key constraint on columns "id" */
  EventWarehouseDestinationGrantsPkey: 'event_warehouse_destination_grants_pkey'
} as const;

export type EventWarehouseDestinationGrantsConstraint = typeof EventWarehouseDestinationGrantsConstraint[keyof typeof EventWarehouseDestinationGrantsConstraint];
/** input type for inserting data into table "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventWarehouseDestinationGrantsMaxFields = {
  __typename?: 'event_warehouse_destination_grants_max_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventWarehouseDestinationGrantsMinFields = {
  __typename?: 'event_warehouse_destination_grants_min_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsMutationResponse = {
  __typename?: 'event_warehouse_destination_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventWarehouseDestinationGrants>;
};

/** on_conflict condition type for table "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsOnConflict = {
  constraint: EventWarehouseDestinationGrantsConstraint;
  update_columns?: Array<EventWarehouseDestinationGrantsUpdateColumn>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};

/** Ordering options when selecting data from "event_warehouse_destination_grants". */
export type EventWarehouseDestinationGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_warehouse_destination_grants */
export type EventWarehouseDestinationGrantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_warehouse_destination_grants" */
export const EventWarehouseDestinationGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventWarehouseDestinationGrantsSelectColumn = typeof EventWarehouseDestinationGrantsSelectColumn[keyof typeof EventWarehouseDestinationGrantsSelectColumn];
/** input type for updating data in table "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EventWarehouseDestinationGrantsStddevFields = {
  __typename?: 'event_warehouse_destination_grants_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventWarehouseDestinationGrantsStddevPopFields = {
  __typename?: 'event_warehouse_destination_grants_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventWarehouseDestinationGrantsStddevSampFields = {
  __typename?: 'event_warehouse_destination_grants_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_warehouse_destination_grants" */
export type EventWarehouseDestinationGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventWarehouseDestinationGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventWarehouseDestinationGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventWarehouseDestinationGrantsSumFields = {
  __typename?: 'event_warehouse_destination_grants_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "event_warehouse_destination_grants" */
export const EventWarehouseDestinationGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type EventWarehouseDestinationGrantsUpdateColumn = typeof EventWarehouseDestinationGrantsUpdateColumn[keyof typeof EventWarehouseDestinationGrantsUpdateColumn];
export type EventWarehouseDestinationGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventWarehouseDestinationGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: EventWarehouseDestinationGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type EventWarehouseDestinationGrantsVarPopFields = {
  __typename?: 'event_warehouse_destination_grants_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventWarehouseDestinationGrantsVarSampFields = {
  __typename?: 'event_warehouse_destination_grants_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventWarehouseDestinationGrantsVarianceFields = {
  __typename?: 'event_warehouse_destination_grants_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_warehouse_destinations" */
export type EventWarehouseDestinations = {
  __typename?: 'event_warehouse_destinations';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  credential_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  event_warehouse_syncs: Array<EventWarehouseSyncs>;
  /** An aggregate relationship */
  event_warehouse_syncs_aggregate: EventWarehouseSyncsAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  schema_settings: Scalars['jsonb'];
  slug: Scalars['String'];
  /** An object relationship */
  tunnel?: Maybe<Tunnels>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "event_warehouse_destinations" */
export type EventWarehouseDestinationsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "event_warehouse_destinations" */
export type EventWarehouseDestinationsEventWarehouseSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


/** columns and relationships of "event_warehouse_destinations" */
export type EventWarehouseDestinationsEventWarehouseSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


/** columns and relationships of "event_warehouse_destinations" */
export type EventWarehouseDestinationsSchemaSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_warehouse_destinations" */
export type EventWarehouseDestinationsAggregate = {
  __typename?: 'event_warehouse_destinations_aggregate';
  aggregate?: Maybe<EventWarehouseDestinationsAggregateFields>;
  nodes: Array<EventWarehouseDestinations>;
};

/** aggregate fields of "event_warehouse_destinations" */
export type EventWarehouseDestinationsAggregateFields = {
  __typename?: 'event_warehouse_destinations_aggregate_fields';
  avg?: Maybe<EventWarehouseDestinationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventWarehouseDestinationsMaxFields>;
  min?: Maybe<EventWarehouseDestinationsMinFields>;
  stddev?: Maybe<EventWarehouseDestinationsStddevFields>;
  stddev_pop?: Maybe<EventWarehouseDestinationsStddevPopFields>;
  stddev_samp?: Maybe<EventWarehouseDestinationsStddevSampFields>;
  sum?: Maybe<EventWarehouseDestinationsSumFields>;
  var_pop?: Maybe<EventWarehouseDestinationsVarPopFields>;
  var_samp?: Maybe<EventWarehouseDestinationsVarSampFields>;
  variance?: Maybe<EventWarehouseDestinationsVarianceFields>;
};


/** aggregate fields of "event_warehouse_destinations" */
export type EventWarehouseDestinationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventWarehouseDestinationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventWarehouseDestinationsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  schema_settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type EventWarehouseDestinationsAvgFields = {
  __typename?: 'event_warehouse_destinations_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "event_warehouse_destinations". All fields are combined with a logical 'AND'. */
export type EventWarehouseDestinationsBoolExp = {
  _and?: InputMaybe<Array<EventWarehouseDestinationsBoolExp>>;
  _not?: InputMaybe<EventWarehouseDestinationsBoolExp>;
  _or?: InputMaybe<Array<EventWarehouseDestinationsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  credential_id?: InputMaybe<BigintComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_warehouse_syncs?: InputMaybe<EventWarehouseSyncsBoolExp>;
  event_warehouse_syncs_aggregate?: InputMaybe<EventWarehouseSyncsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schema_settings?: InputMaybe<JsonbComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tunnel?: InputMaybe<TunnelsBoolExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventWarehouseDestinationsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  schema_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventWarehouseDestinationsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  schema_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventWarehouseDestinationsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  schema_settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "event_warehouse_destinations" */
export type EventWarehouseDestinationsIncInput = {
  credential_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EventWarehouseDestinationsMaxFields = {
  __typename?: 'event_warehouse_destinations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EventWarehouseDestinationsMinFields = {
  __typename?: 'event_warehouse_destinations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "event_warehouse_destinations" */
export type EventWarehouseDestinationsMutationResponse = {
  __typename?: 'event_warehouse_destinations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventWarehouseDestinations>;
};

/** Ordering options when selecting data from "event_warehouse_destinations". */
export type EventWarehouseDestinationsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event_warehouse_syncs_aggregate?: InputMaybe<EventWarehouseSyncsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schema_settings?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tunnel?: InputMaybe<TunnelsOrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_warehouse_destinations */
export type EventWarehouseDestinationsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventWarehouseDestinationsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  schema_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_warehouse_destinations" */
export const EventWarehouseDestinationsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SchemaSettings: 'schema_settings',
  /** column name */
  Slug: 'slug',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventWarehouseDestinationsSelectColumn = typeof EventWarehouseDestinationsSelectColumn[keyof typeof EventWarehouseDestinationsSelectColumn];
/** input type for updating data in table "event_warehouse_destinations" */
export type EventWarehouseDestinationsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schema_settings?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type EventWarehouseDestinationsStddevFields = {
  __typename?: 'event_warehouse_destinations_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EventWarehouseDestinationsStddevPopFields = {
  __typename?: 'event_warehouse_destinations_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EventWarehouseDestinationsStddevSampFields = {
  __typename?: 'event_warehouse_destinations_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "event_warehouse_destinations" */
export type EventWarehouseDestinationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventWarehouseDestinationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventWarehouseDestinationsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  credential_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schema_settings?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventWarehouseDestinationsSumFields = {
  __typename?: 'event_warehouse_destinations_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  credential_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

export type EventWarehouseDestinationsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventWarehouseDestinationsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EventWarehouseDestinationsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EventWarehouseDestinationsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EventWarehouseDestinationsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventWarehouseDestinationsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventWarehouseDestinationsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventWarehouseDestinationsSetInput>;
  /** filter the rows which have to be updated */
  where: EventWarehouseDestinationsBoolExp;
};

/** aggregate var_pop on columns */
export type EventWarehouseDestinationsVarPopFields = {
  __typename?: 'event_warehouse_destinations_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EventWarehouseDestinationsVarSampFields = {
  __typename?: 'event_warehouse_destinations_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EventWarehouseDestinationsVarianceFields = {
  __typename?: 'event_warehouse_destinations_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  credential_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "event_warehouse_sync_sources" */
export type EventWarehouseSyncSources = {
  __typename?: 'event_warehouse_sync_sources';
  /** An object relationship */
  event_source: EventSources;
  event_source_id: Scalars['uuid'];
  /** An object relationship */
  event_warehouse_sync: EventWarehouseSyncs;
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesAggregate = {
  __typename?: 'event_warehouse_sync_sources_aggregate';
  aggregate?: Maybe<EventWarehouseSyncSourcesAggregateFields>;
  nodes: Array<EventWarehouseSyncSources>;
};

export type EventWarehouseSyncSourcesAggregateBoolExp = {
  count?: InputMaybe<EventWarehouseSyncSourcesAggregateBoolExpCount>;
};

export type EventWarehouseSyncSourcesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesAggregateFields = {
  __typename?: 'event_warehouse_sync_sources_aggregate_fields';
  avg?: Maybe<EventWarehouseSyncSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventWarehouseSyncSourcesMaxFields>;
  min?: Maybe<EventWarehouseSyncSourcesMinFields>;
  stddev?: Maybe<EventWarehouseSyncSourcesStddevFields>;
  stddev_pop?: Maybe<EventWarehouseSyncSourcesStddevPopFields>;
  stddev_samp?: Maybe<EventWarehouseSyncSourcesStddevSampFields>;
  sum?: Maybe<EventWarehouseSyncSourcesSumFields>;
  var_pop?: Maybe<EventWarehouseSyncSourcesVarPopFields>;
  var_samp?: Maybe<EventWarehouseSyncSourcesVarSampFields>;
  variance?: Maybe<EventWarehouseSyncSourcesVarianceFields>;
};


/** aggregate fields of "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesAggregateOrderBy = {
  avg?: InputMaybe<EventWarehouseSyncSourcesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventWarehouseSyncSourcesMaxOrderBy>;
  min?: InputMaybe<EventWarehouseSyncSourcesMinOrderBy>;
  stddev?: InputMaybe<EventWarehouseSyncSourcesStddevOrderBy>;
  stddev_pop?: InputMaybe<EventWarehouseSyncSourcesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventWarehouseSyncSourcesStddevSampOrderBy>;
  sum?: InputMaybe<EventWarehouseSyncSourcesSumOrderBy>;
  var_pop?: InputMaybe<EventWarehouseSyncSourcesVarPopOrderBy>;
  var_samp?: InputMaybe<EventWarehouseSyncSourcesVarSampOrderBy>;
  variance?: InputMaybe<EventWarehouseSyncSourcesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type EventWarehouseSyncSourcesAvgFields = {
  __typename?: 'event_warehouse_sync_sources_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_warehouse_sync_sources". All fields are combined with a logical 'AND'. */
export type EventWarehouseSyncSourcesBoolExp = {
  _and?: InputMaybe<Array<EventWarehouseSyncSourcesBoolExp>>;
  _not?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
  _or?: InputMaybe<Array<EventWarehouseSyncSourcesBoolExp>>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  event_warehouse_sync?: InputMaybe<EventWarehouseSyncsBoolExp>;
  sync_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EventWarehouseSyncSourcesMaxFields = {
  __typename?: 'event_warehouse_sync_sources_max_fields';
  event_source_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesMaxOrderBy = {
  event_source_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventWarehouseSyncSourcesMinFields = {
  __typename?: 'event_warehouse_sync_sources_min_fields';
  event_source_id?: Maybe<Scalars['uuid']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesMinOrderBy = {
  event_source_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "event_warehouse_sync_sources". */
export type EventWarehouseSyncSourcesOrderBy = {
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  event_warehouse_sync?: InputMaybe<EventWarehouseSyncsOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "event_warehouse_sync_sources" */
export const EventWarehouseSyncSourcesSelectColumn = {
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventWarehouseSyncSourcesSelectColumn = typeof EventWarehouseSyncSourcesSelectColumn[keyof typeof EventWarehouseSyncSourcesSelectColumn];
/** aggregate stddev on columns */
export type EventWarehouseSyncSourcesStddevFields = {
  __typename?: 'event_warehouse_sync_sources_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventWarehouseSyncSourcesStddevPopFields = {
  __typename?: 'event_warehouse_sync_sources_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventWarehouseSyncSourcesStddevSampFields = {
  __typename?: 'event_warehouse_sync_sources_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventWarehouseSyncSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventWarehouseSyncSourcesStreamCursorValueInput = {
  event_source_id?: InputMaybe<Scalars['uuid']>;
  sync_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventWarehouseSyncSourcesSumFields = {
  __typename?: 'event_warehouse_sync_sources_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type EventWarehouseSyncSourcesVarPopFields = {
  __typename?: 'event_warehouse_sync_sources_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventWarehouseSyncSourcesVarSampFields = {
  __typename?: 'event_warehouse_sync_sources_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventWarehouseSyncSourcesVarianceFields = {
  __typename?: 'event_warehouse_sync_sources_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_warehouse_sync_sources" */
export type EventWarehouseSyncSourcesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_warehouse_syncs" */
export type EventWarehouseSyncs = {
  __typename?: 'event_warehouse_syncs';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  enabled: Scalars['Boolean'];
  /** An object relationship */
  event_warehouse_destination: EventWarehouseDestinations;
  event_warehouse_destination_id: Scalars['uuid'];
  /** An array relationship */
  event_warehouse_sync_sources: Array<EventWarehouseSyncSources>;
  /** An aggregate relationship */
  event_warehouse_sync_sources_aggregate: EventWarehouseSyncSourcesAggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  runs: GetEventWarehouseSyncRunsResult;
  schedule: Scalars['jsonb'];
  schema_only: Scalars['Boolean'];
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "event_warehouse_syncs" */
export type EventWarehouseSyncsEventWarehouseSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


/** columns and relationships of "event_warehouse_syncs" */
export type EventWarehouseSyncsEventWarehouseSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


/** columns and relationships of "event_warehouse_syncs" */
export type EventWarehouseSyncsRunsArgs = {
  input?: InputMaybe<GetEventWarehouseSyncRunsInputRemoteRelEventWarehouseSyncsruns>;
};


/** columns and relationships of "event_warehouse_syncs" */
export type EventWarehouseSyncsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_warehouse_syncs" */
export type EventWarehouseSyncsAggregate = {
  __typename?: 'event_warehouse_syncs_aggregate';
  aggregate?: Maybe<EventWarehouseSyncsAggregateFields>;
  nodes: Array<EventWarehouseSyncs>;
};

export type EventWarehouseSyncsAggregateBoolExp = {
  bool_and?: InputMaybe<EventWarehouseSyncsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<EventWarehouseSyncsAggregateBoolExpBoolOr>;
  count?: InputMaybe<EventWarehouseSyncsAggregateBoolExpCount>;
};

export type EventWarehouseSyncsAggregateBoolExpBoolAnd = {
  arguments: EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventWarehouseSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventWarehouseSyncsAggregateBoolExpBoolOr = {
  arguments: EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventWarehouseSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EventWarehouseSyncsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventWarehouseSyncsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "event_warehouse_syncs" */
export type EventWarehouseSyncsAggregateFields = {
  __typename?: 'event_warehouse_syncs_aggregate_fields';
  avg?: Maybe<EventWarehouseSyncsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventWarehouseSyncsMaxFields>;
  min?: Maybe<EventWarehouseSyncsMinFields>;
  stddev?: Maybe<EventWarehouseSyncsStddevFields>;
  stddev_pop?: Maybe<EventWarehouseSyncsStddevPopFields>;
  stddev_samp?: Maybe<EventWarehouseSyncsStddevSampFields>;
  sum?: Maybe<EventWarehouseSyncsSumFields>;
  var_pop?: Maybe<EventWarehouseSyncsVarPopFields>;
  var_samp?: Maybe<EventWarehouseSyncsVarSampFields>;
  variance?: Maybe<EventWarehouseSyncsVarianceFields>;
};


/** aggregate fields of "event_warehouse_syncs" */
export type EventWarehouseSyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_warehouse_syncs" */
export type EventWarehouseSyncsAggregateOrderBy = {
  avg?: InputMaybe<EventWarehouseSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventWarehouseSyncsMaxOrderBy>;
  min?: InputMaybe<EventWarehouseSyncsMinOrderBy>;
  stddev?: InputMaybe<EventWarehouseSyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<EventWarehouseSyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EventWarehouseSyncsStddevSampOrderBy>;
  sum?: InputMaybe<EventWarehouseSyncsSumOrderBy>;
  var_pop?: InputMaybe<EventWarehouseSyncsVarPopOrderBy>;
  var_samp?: InputMaybe<EventWarehouseSyncsVarSampOrderBy>;
  variance?: InputMaybe<EventWarehouseSyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type EventWarehouseSyncsAvgFields = {
  __typename?: 'event_warehouse_syncs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_warehouse_syncs". All fields are combined with a logical 'AND'. */
export type EventWarehouseSyncsBoolExp = {
  _and?: InputMaybe<Array<EventWarehouseSyncsBoolExp>>;
  _not?: InputMaybe<EventWarehouseSyncsBoolExp>;
  _or?: InputMaybe<Array<EventWarehouseSyncsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  event_warehouse_destination?: InputMaybe<EventWarehouseDestinationsBoolExp>;
  event_warehouse_destination_id?: InputMaybe<UuidComparisonExp>;
  event_warehouse_sync_sources?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
  event_warehouse_sync_sources_aggregate?: InputMaybe<EventWarehouseSyncSourcesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schema_only?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EventWarehouseSyncsMaxFields = {
  __typename?: 'event_warehouse_syncs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  event_warehouse_destination_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  event_warehouse_destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventWarehouseSyncsMinFields = {
  __typename?: 'event_warehouse_syncs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  event_warehouse_destination_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  event_warehouse_destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_warehouse_syncs" */
export type EventWarehouseSyncsMutationResponse = {
  __typename?: 'event_warehouse_syncs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventWarehouseSyncs>;
};

/** Ordering options when selecting data from "event_warehouse_syncs". */
export type EventWarehouseSyncsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  enabled?: InputMaybe<OrderBy>;
  event_warehouse_destination?: InputMaybe<EventWarehouseDestinationsOrderBy>;
  event_warehouse_destination_id?: InputMaybe<OrderBy>;
  event_warehouse_sync_sources_aggregate?: InputMaybe<EventWarehouseSyncSourcesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schema_only?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: event_warehouse_syncs */
export type EventWarehouseSyncsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "event_warehouse_syncs" */
export const EventWarehouseSyncsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EventWarehouseDestinationId: 'event_warehouse_destination_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchemaOnly: 'schema_only',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type EventWarehouseSyncsSelectColumn = typeof EventWarehouseSyncsSelectColumn[keyof typeof EventWarehouseSyncsSelectColumn];
/** select "event_warehouse_syncs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "event_warehouse_syncs" */
export const EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  SchemaOnly: 'schema_only'
} as const;

export type EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolAndArgumentsColumns = typeof EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolAndArgumentsColumns];
/** select "event_warehouse_syncs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "event_warehouse_syncs" */
export const EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  SchemaOnly: 'schema_only'
} as const;

export type EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolOrArgumentsColumns = typeof EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof EventWarehouseSyncsSelectColumnEventWarehouseSyncsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "event_warehouse_syncs" */
export type EventWarehouseSyncsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type EventWarehouseSyncsStddevFields = {
  __typename?: 'event_warehouse_syncs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EventWarehouseSyncsStddevPopFields = {
  __typename?: 'event_warehouse_syncs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EventWarehouseSyncsStddevSampFields = {
  __typename?: 'event_warehouse_syncs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_warehouse_syncs" */
export type EventWarehouseSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: EventWarehouseSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventWarehouseSyncsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  event_warehouse_destination_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schema_only?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EventWarehouseSyncsSumFields = {
  __typename?: 'event_warehouse_syncs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type EventWarehouseSyncsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventWarehouseSyncsSetInput>;
  /** filter the rows which have to be updated */
  where: EventWarehouseSyncsBoolExp;
};

/** aggregate var_pop on columns */
export type EventWarehouseSyncsVarPopFields = {
  __typename?: 'event_warehouse_syncs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EventWarehouseSyncsVarSampFields = {
  __typename?: 'event_warehouse_syncs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventWarehouseSyncsVarianceFields = {
  __typename?: 'event_warehouse_syncs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_warehouse_syncs" */
export type EventWarehouseSyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "experiment_metrics" */
export type ExperimentMetrics = {
  __typename?: 'experiment_metrics';
  created_at: Scalars['timestamptz'];
  direction?: Maybe<Scalars['String']>;
  /** An object relationship */
  experiment: Experiments;
  experiment_id: Scalars['uuid'];
  /** An object relationship */
  goal?: Maybe<Goals>;
  goal_definition?: Maybe<Scalars['jsonb']>;
  goal_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  primary: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "experiment_metrics" */
export type ExperimentMetricsGoalDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "experiment_metrics" */
export type ExperimentMetricsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ExperimentMetricsMaxOrderBy>;
  min?: InputMaybe<ExperimentMetricsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExperimentMetricsAppendInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "experiment_metrics" */
export type ExperimentMetricsArrRelInsertInput = {
  data: Array<ExperimentMetricsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ExperimentMetricsOnConflict>;
};

/** Boolean expression to filter rows from the table "experiment_metrics". All fields are combined with a logical 'AND'. */
export type ExperimentMetricsBoolExp = {
  _and?: InputMaybe<Array<ExperimentMetricsBoolExp>>;
  _not?: InputMaybe<ExperimentMetricsBoolExp>;
  _or?: InputMaybe<Array<ExperimentMetricsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  experiment?: InputMaybe<ExperimentsBoolExp>;
  experiment_id?: InputMaybe<UuidComparisonExp>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_definition?: InputMaybe<JsonbComparisonExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  primary?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "experiment_metrics" */
export const ExperimentMetricsConstraint = {
  /** unique or primary key constraint on columns "experiment_id", "goal_id" */
  ExperimentMetricsExperimentIdGoalIdKey: 'experiment_metrics_experiment_id_goal_id_key',
  /** unique or primary key constraint on columns "experiment_id" */
  ExperimentMetricsExperimentIdPrimaryKey: 'experiment_metrics_experiment_id_primary_key',
  /** unique or primary key constraint on columns "id" */
  ExperimentMetricsPkey: 'experiment_metrics_pkey'
} as const;

export type ExperimentMetricsConstraint = typeof ExperimentMetricsConstraint[keyof typeof ExperimentMetricsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExperimentMetricsDeleteAtPathInput = {
  goal_definition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExperimentMetricsDeleteElemInput = {
  goal_definition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExperimentMetricsDeleteKeyInput = {
  goal_definition?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "experiment_metrics" */
export type ExperimentMetricsInsertInput = {
  direction?: InputMaybe<Scalars['String']>;
  experiment?: InputMaybe<ExperimentsObjRelInsertInput>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  goal?: InputMaybe<GoalsObjRelInsertInput>;
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** order by max() on columns of table "experiment_metrics" */
export type ExperimentMetricsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "experiment_metrics" */
export type ExperimentMetricsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "experiment_metrics" */
export type ExperimentMetricsMutationResponse = {
  __typename?: 'experiment_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExperimentMetrics>;
};

/** on_conflict condition type for table "experiment_metrics" */
export type ExperimentMetricsOnConflict = {
  constraint: ExperimentMetricsConstraint;
  update_columns?: Array<ExperimentMetricsUpdateColumn>;
  where?: InputMaybe<ExperimentMetricsBoolExp>;
};

/** Ordering options when selecting data from "experiment_metrics". */
export type ExperimentMetricsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  experiment?: InputMaybe<ExperimentsOrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  goal?: InputMaybe<GoalsOrderBy>;
  goal_definition?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  primary?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: experiment_metrics */
export type ExperimentMetricsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExperimentMetricsPrependInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "experiment_metrics" */
export const ExperimentMetricsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Direction: 'direction',
  /** column name */
  ExperimentId: 'experiment_id',
  /** column name */
  GoalDefinition: 'goal_definition',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  Id: 'id',
  /** column name */
  Primary: 'primary',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type ExperimentMetricsSelectColumn = typeof ExperimentMetricsSelectColumn[keyof typeof ExperimentMetricsSelectColumn];
/** input type for updating data in table "experiment_metrics" */
export type ExperimentMetricsSetInput = {
  direction?: InputMaybe<Scalars['String']>;
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "experiment_metrics" */
export type ExperimentMetricsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExperimentMetricsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExperimentMetricsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['String']>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "experiment_metrics" */
export const ExperimentMetricsUpdateColumn = {
  /** column name */
  Direction: 'direction',
  /** column name */
  GoalDefinition: 'goal_definition',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  Primary: 'primary'
} as const;

export type ExperimentMetricsUpdateColumn = typeof ExperimentMetricsUpdateColumn[keyof typeof ExperimentMetricsUpdateColumn];
export type ExperimentMetricsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExperimentMetricsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExperimentMetricsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExperimentMetricsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExperimentMetricsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExperimentMetricsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExperimentMetricsSetInput>;
  /** filter the rows which have to be updated */
  where: ExperimentMetricsBoolExp;
};

/** columns and relationships of "experiments" */
export type Experiments = {
  __typename?: 'experiments';
  /** An object relationship */
  analytics_report?: Maybe<AnalyticsReports>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  experiment_metrics: Array<ExperimentMetrics>;
  /** An object relationship */
  folder?: Maybe<Folders>;
  id: Scalars['uuid'];
  /** An object relationship */
  journey_node?: Maybe<JourneyNodes>;
  journey_node_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  journey_nodes: Array<JourneyNodes>;
  /** An aggregate relationship */
  journey_nodes_aggregate: JourneyNodesAggregate;
  last_chart_options?: Maybe<Scalars['jsonb']>;
  measurement_window?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  message_experiment?: Maybe<MessageExperiments>;
  name: Scalars['String'];
  organization_id: Scalars['bigint'];
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id?: Maybe<Scalars['bigint']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "experiment_status" */
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "experiments" */
export type ExperimentsExperimentMetricsArgs = {
  distinct_on?: InputMaybe<Array<ExperimentMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentMetricsOrderBy>>;
  where?: InputMaybe<ExperimentMetricsBoolExp>;
};


/** columns and relationships of "experiments" */
export type ExperimentsJourneyNodesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


/** columns and relationships of "experiments" */
export type ExperimentsJourneyNodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


/** columns and relationships of "experiments" */
export type ExperimentsLastChartOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "experiments" */
export type ExperimentsMeasurementWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "experiments" */
export type ExperimentsAggregate = {
  __typename?: 'experiments_aggregate';
  aggregate?: Maybe<ExperimentsAggregateFields>;
  nodes: Array<Experiments>;
};

/** aggregate fields of "experiments" */
export type ExperimentsAggregateFields = {
  __typename?: 'experiments_aggregate_fields';
  avg?: Maybe<ExperimentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ExperimentsMaxFields>;
  min?: Maybe<ExperimentsMinFields>;
  stddev?: Maybe<ExperimentsStddevFields>;
  stddev_pop?: Maybe<ExperimentsStddevPopFields>;
  stddev_samp?: Maybe<ExperimentsStddevSampFields>;
  sum?: Maybe<ExperimentsSumFields>;
  var_pop?: Maybe<ExperimentsVarPopFields>;
  var_samp?: Maybe<ExperimentsVarSampFields>;
  variance?: Maybe<ExperimentsVarianceFields>;
};


/** aggregate fields of "experiments" */
export type ExperimentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ExperimentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExperimentsAppendInput = {
  last_chart_options?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ExperimentsAvgFields = {
  __typename?: 'experiments_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "experiments". All fields are combined with a logical 'AND'. */
export type ExperimentsBoolExp = {
  _and?: InputMaybe<Array<ExperimentsBoolExp>>;
  _not?: InputMaybe<ExperimentsBoolExp>;
  _or?: InputMaybe<Array<ExperimentsBoolExp>>;
  analytics_report?: InputMaybe<AnalyticsReportsBoolExp>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  experiment_metrics?: InputMaybe<ExperimentMetricsBoolExp>;
  folder?: InputMaybe<FoldersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_node?: InputMaybe<JourneyNodesBoolExp>;
  journey_node_id?: InputMaybe<UuidComparisonExp>;
  journey_nodes?: InputMaybe<JourneyNodesBoolExp>;
  journey_nodes_aggregate?: InputMaybe<JourneyNodesAggregateBoolExp>;
  last_chart_options?: InputMaybe<JsonbComparisonExp>;
  measurement_window?: InputMaybe<JsonbComparisonExp>;
  message_experiment?: InputMaybe<MessageExperimentsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "experiments" */
export const ExperimentsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ExperimentsIdWorkspaceIdKey: 'experiments_id_workspace_id_key',
  /** unique or primary key constraint on columns "workspace_id", "journey_node_id" */
  ExperimentsJourneyNodeIdWorkspaceIdKey: 'experiments_journey_node_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ExperimentsPkey: 'experiments_pkey',
  /** unique or primary key constraint on columns "workspace_id", "segment_id" */
  ExperimentsWorkspaceIdSegmentIdKey: 'experiments_workspace_id_segment_id_key'
} as const;

export type ExperimentsConstraint = typeof ExperimentsConstraint[keyof typeof ExperimentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExperimentsDeleteAtPathInput = {
  last_chart_options?: InputMaybe<Array<Scalars['String']>>;
  measurement_window?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExperimentsDeleteElemInput = {
  last_chart_options?: InputMaybe<Scalars['Int']>;
  measurement_window?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExperimentsDeleteKeyInput = {
  last_chart_options?: InputMaybe<Scalars['String']>;
  measurement_window?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "experiments" */
export type ExperimentsInsertInput = {
  analytics_report?: InputMaybe<AnalyticsReportsObjRelInsertInput>;
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  experiment_metrics?: InputMaybe<ExperimentMetricsArrRelInsertInput>;
  folder?: InputMaybe<FoldersObjRelInsertInput>;
  journey_node_id?: InputMaybe<Scalars['uuid']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  message_experiment?: InputMaybe<MessageExperimentsObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ExperimentsMaxFields = {
  __typename?: 'experiments_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  journey_node_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "experiment_status" */
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ExperimentsMinFields = {
  __typename?: 'experiments_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  journey_node_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "experiment_status" */
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "experiments" */
export type ExperimentsMutationResponse = {
  __typename?: 'experiments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Experiments>;
};

/** input type for inserting object relation for remote table "experiments" */
export type ExperimentsObjRelInsertInput = {
  data: ExperimentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ExperimentsOnConflict>;
};

/** on_conflict condition type for table "experiments" */
export type ExperimentsOnConflict = {
  constraint: ExperimentsConstraint;
  update_columns?: Array<ExperimentsUpdateColumn>;
  where?: InputMaybe<ExperimentsBoolExp>;
};

/** Ordering options when selecting data from "experiments". */
export type ExperimentsOrderBy = {
  analytics_report?: InputMaybe<AnalyticsReportsOrderBy>;
  archived_at?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  experiment_metrics_aggregate?: InputMaybe<ExperimentMetricsAggregateOrderBy>;
  folder?: InputMaybe<FoldersOrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_node?: InputMaybe<JourneyNodesOrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_nodes_aggregate?: InputMaybe<JourneyNodesAggregateOrderBy>;
  last_chart_options?: InputMaybe<OrderBy>;
  measurement_window?: InputMaybe<OrderBy>;
  message_experiment?: InputMaybe<MessageExperimentsOrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: experiments */
export type ExperimentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExperimentsPrependInput = {
  last_chart_options?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "experiments" */
export const ExperimentsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyNodeId: 'journey_node_id',
  /** column name */
  LastChartOptions: 'last_chart_options',
  /** column name */
  MeasurementWindow: 'measurement_window',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExperimentsSelectColumn = typeof ExperimentsSelectColumn[keyof typeof ExperimentsSelectColumn];
/** input type for updating data in table "experiments" */
export type ExperimentsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  journey_node_id?: InputMaybe<Scalars['uuid']>;
  last_chart_options?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ExperimentsStddevFields = {
  __typename?: 'experiments_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ExperimentsStddevPopFields = {
  __typename?: 'experiments_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ExperimentsStddevSampFields = {
  __typename?: 'experiments_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "experiments" */
export type ExperimentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExperimentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExperimentsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_node_id?: InputMaybe<Scalars['uuid']>;
  last_chart_options?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ExperimentsSumFields = {
  __typename?: 'experiments_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "experiments" */
export const ExperimentsUpdateColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  Description: 'description',
  /** column name */
  JourneyNodeId: 'journey_node_id',
  /** column name */
  LastChartOptions: 'last_chart_options',
  /** column name */
  MeasurementWindow: 'measurement_window',
  /** column name */
  Name: 'name',
  /** column name */
  StartedAt: 'started_at'
} as const;

export type ExperimentsUpdateColumn = typeof ExperimentsUpdateColumn[keyof typeof ExperimentsUpdateColumn];
export type ExperimentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExperimentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExperimentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExperimentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExperimentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExperimentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExperimentsSetInput>;
  /** filter the rows which have to be updated */
  where: ExperimentsBoolExp;
};

/** aggregate var_pop on columns */
export type ExperimentsVarPopFields = {
  __typename?: 'experiments_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ExperimentsVarSampFields = {
  __typename?: 'experiments_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ExperimentsVarianceFields = {
  __typename?: 'experiments_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "exposure_log_resolution_runs" */
export type ExposureLogResolutionRuns = {
  __typename?: 'exposure_log_resolution_runs';
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['String']>;
  failed_attempts: Scalars['Int'];
  feed: Scalars['String'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  job_id?: Maybe<Scalars['String']>;
  log_date: Scalars['date'];
  rows_loaded?: Maybe<Scalars['bigint']>;
  rows_resolved?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  started_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  sv?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "exposure_log_resolution_runs". All fields are combined with a logical 'AND'. */
export type ExposureLogResolutionRunsBoolExp = {
  _and?: InputMaybe<Array<ExposureLogResolutionRunsBoolExp>>;
  _not?: InputMaybe<ExposureLogResolutionRunsBoolExp>;
  _or?: InputMaybe<Array<ExposureLogResolutionRunsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  failed_attempts?: InputMaybe<IntComparisonExp>;
  feed?: InputMaybe<StringComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_id?: InputMaybe<StringComparisonExp>;
  log_date?: InputMaybe<DateComparisonExp>;
  rows_loaded?: InputMaybe<BigintComparisonExp>;
  rows_resolved?: InputMaybe<BigintComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sv?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "exposure_log_resolution_runs". */
export type ExposureLogResolutionRunsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  failed_attempts?: InputMaybe<OrderBy>;
  feed?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_id?: InputMaybe<OrderBy>;
  log_date?: InputMaybe<OrderBy>;
  rows_loaded?: InputMaybe<OrderBy>;
  rows_resolved?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sv?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "exposure_log_resolution_runs" */
export const ExposureLogResolutionRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  FailedAttempts: 'failed_attempts',
  /** column name */
  Feed: 'feed',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  JobId: 'job_id',
  /** column name */
  LogDate: 'log_date',
  /** column name */
  RowsLoaded: 'rows_loaded',
  /** column name */
  RowsResolved: 'rows_resolved',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  Sv: 'sv',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExposureLogResolutionRunsSelectColumn = typeof ExposureLogResolutionRunsSelectColumn[keyof typeof ExposureLogResolutionRunsSelectColumn];
/** Streaming cursor of the table "exposure_log_resolution_runs" */
export type ExposureLogResolutionRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExposureLogResolutionRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExposureLogResolutionRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['String']>;
  failed_attempts?: InputMaybe<Scalars['Int']>;
  feed?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['String']>;
  log_date?: InputMaybe<Scalars['date']>;
  rows_loaded?: InputMaybe<Scalars['bigint']>;
  rows_resolved?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  sv?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "extensions" */
export type Extensions = {
  __typename?: 'extensions';
  ad_studio_sync_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  amp_asset_source?: Maybe<AmpAssetSources>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  export_config?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  setup_complete: Scalars['Boolean'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "extensions" */
export type ExtensionsAdStudioSyncConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extensions" */
export type ExtensionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extensions" */
export type ExtensionsExportConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "extensions" */
export type ExtensionsAggregate = {
  __typename?: 'extensions_aggregate';
  aggregate?: Maybe<ExtensionsAggregateFields>;
  nodes: Array<Extensions>;
};

/** aggregate fields of "extensions" */
export type ExtensionsAggregateFields = {
  __typename?: 'extensions_aggregate_fields';
  avg?: Maybe<ExtensionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ExtensionsMaxFields>;
  min?: Maybe<ExtensionsMinFields>;
  stddev?: Maybe<ExtensionsStddevFields>;
  stddev_pop?: Maybe<ExtensionsStddevPopFields>;
  stddev_samp?: Maybe<ExtensionsStddevSampFields>;
  sum?: Maybe<ExtensionsSumFields>;
  var_pop?: Maybe<ExtensionsVarPopFields>;
  var_samp?: Maybe<ExtensionsVarSampFields>;
  variance?: Maybe<ExtensionsVarianceFields>;
};


/** aggregate fields of "extensions" */
export type ExtensionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ExtensionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ExtensionsAvgFields = {
  __typename?: 'extensions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "extensions". All fields are combined with a logical 'AND'. */
export type ExtensionsBoolExp = {
  _and?: InputMaybe<Array<ExtensionsBoolExp>>;
  _not?: InputMaybe<ExtensionsBoolExp>;
  _or?: InputMaybe<Array<ExtensionsBoolExp>>;
  ad_studio_sync_config?: InputMaybe<JsonbComparisonExp>;
  amp_asset_source?: InputMaybe<AmpAssetSourcesBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  export_config?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  setup_complete?: InputMaybe<BooleanComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ExtensionsMaxFields = {
  __typename?: 'extensions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ExtensionsMinFields = {
  __typename?: 'extensions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "extensions". */
export type ExtensionsOrderBy = {
  ad_studio_sync_config?: InputMaybe<OrderBy>;
  amp_asset_source?: InputMaybe<AmpAssetSourcesOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  export_config?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  setup_complete?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "extensions" */
export const ExtensionsSelectColumn = {
  /** column name */
  AdStudioSyncConfig: 'ad_studio_sync_config',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ExportConfig: 'export_config',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SetupComplete: 'setup_complete',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExtensionsSelectColumn = typeof ExtensionsSelectColumn[keyof typeof ExtensionsSelectColumn];
/** aggregate stddev on columns */
export type ExtensionsStddevFields = {
  __typename?: 'extensions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ExtensionsStddevPopFields = {
  __typename?: 'extensions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ExtensionsStddevSampFields = {
  __typename?: 'extensions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "extensions" */
export type ExtensionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExtensionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExtensionsStreamCursorValueInput = {
  ad_studio_sync_config?: InputMaybe<Scalars['jsonb']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  export_config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  setup_complete?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ExtensionsSumFields = {
  __typename?: 'extensions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ExtensionsVarPopFields = {
  __typename?: 'extensions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ExtensionsVarSampFields = {
  __typename?: 'extensions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ExtensionsVarianceFields = {
  __typename?: 'extensions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "external_buckets" */
export type ExternalBuckets = {
  __typename?: 'external_buckets';
  /** An object relationship */
  cloud_credential?: Maybe<CloudCredentials>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  credential_id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "external_buckets" */
export type ExternalBucketsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExternalBucketsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "external_buckets". All fields are combined with a logical 'AND'. */
export type ExternalBucketsBoolExp = {
  _and?: InputMaybe<Array<ExternalBucketsBoolExp>>;
  _not?: InputMaybe<ExternalBucketsBoolExp>;
  _or?: InputMaybe<Array<ExternalBucketsBoolExp>>;
  cloud_credential?: InputMaybe<CloudCredentialsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  credential_id?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "external_buckets" */
export const ExternalBucketsConstraint = {
  /** unique or primary key constraint on columns "workspace_id" */
  ExternalBucketsPkey: 'external_buckets_pkey'
} as const;

export type ExternalBucketsConstraint = typeof ExternalBucketsConstraint[keyof typeof ExternalBucketsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExternalBucketsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExternalBucketsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExternalBucketsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "external_buckets" */
export type ExternalBucketsIncInput = {
  credential_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "external_buckets" */
export type ExternalBucketsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  credential_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "external_buckets" */
export type ExternalBucketsMutationResponse = {
  __typename?: 'external_buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalBuckets>;
};

/** on_conflict condition type for table "external_buckets" */
export type ExternalBucketsOnConflict = {
  constraint: ExternalBucketsConstraint;
  update_columns?: Array<ExternalBucketsUpdateColumn>;
  where?: InputMaybe<ExternalBucketsBoolExp>;
};

/** Ordering options when selecting data from "external_buckets". */
export type ExternalBucketsOrderBy = {
  cloud_credential?: InputMaybe<CloudCredentialsOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  credential_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_buckets */
export type ExternalBucketsPkColumnsInput = {
  workspace_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExternalBucketsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "external_buckets" */
export const ExternalBucketsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExternalBucketsSelectColumn = typeof ExternalBucketsSelectColumn[keyof typeof ExternalBucketsSelectColumn];
/** input type for updating data in table "external_buckets" */
export type ExternalBucketsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  credential_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "external_buckets" */
export type ExternalBucketsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExternalBucketsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalBucketsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credential_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "external_buckets" */
export const ExternalBucketsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CredentialId: 'credential_id',
  /** column name */
  Type: 'type'
} as const;

export type ExternalBucketsUpdateColumn = typeof ExternalBucketsUpdateColumn[keyof typeof ExternalBucketsUpdateColumn];
export type ExternalBucketsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExternalBucketsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExternalBucketsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExternalBucketsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExternalBucketsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExternalBucketsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExternalBucketsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExternalBucketsSetInput>;
  /** filter the rows which have to be updated */
  where: ExternalBucketsBoolExp;
};

/** columns and relationships of "external_context_sources" */
export type ExternalContextSources = {
  __typename?: 'external_context_sources';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  integration: Scalars['String'];
  last_error?: Maybe<Scalars['String']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_status?: Maybe<Scalars['String']>;
  last_successful_run_at?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  purpose: Scalars['String'];
  sync_frequency: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "external_context_sources" */
export type ExternalContextSourcesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_context_sources" */
export type ExternalContextSourcesSyncFrequencyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "external_context_sources" */
export type ExternalContextSourcesAggregate = {
  __typename?: 'external_context_sources_aggregate';
  aggregate?: Maybe<ExternalContextSourcesAggregateFields>;
  nodes: Array<ExternalContextSources>;
};

/** aggregate fields of "external_context_sources" */
export type ExternalContextSourcesAggregateFields = {
  __typename?: 'external_context_sources_aggregate_fields';
  avg?: Maybe<ExternalContextSourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ExternalContextSourcesMaxFields>;
  min?: Maybe<ExternalContextSourcesMinFields>;
  stddev?: Maybe<ExternalContextSourcesStddevFields>;
  stddev_pop?: Maybe<ExternalContextSourcesStddevPopFields>;
  stddev_samp?: Maybe<ExternalContextSourcesStddevSampFields>;
  sum?: Maybe<ExternalContextSourcesSumFields>;
  var_pop?: Maybe<ExternalContextSourcesVarPopFields>;
  var_samp?: Maybe<ExternalContextSourcesVarSampFields>;
  variance?: Maybe<ExternalContextSourcesVarianceFields>;
};


/** aggregate fields of "external_context_sources" */
export type ExternalContextSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ExternalContextSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ExternalContextSourcesAvgFields = {
  __typename?: 'external_context_sources_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_context_sources". All fields are combined with a logical 'AND'. */
export type ExternalContextSourcesBoolExp = {
  _and?: InputMaybe<Array<ExternalContextSourcesBoolExp>>;
  _not?: InputMaybe<ExternalContextSourcesBoolExp>;
  _or?: InputMaybe<Array<ExternalContextSourcesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  last_error?: InputMaybe<StringComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_status?: InputMaybe<StringComparisonExp>;
  last_successful_run_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  purpose?: InputMaybe<StringComparisonExp>;
  sync_frequency?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ExternalContextSourcesMaxFields = {
  __typename?: 'external_context_sources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integration?: Maybe<Scalars['String']>;
  last_error?: Maybe<Scalars['String']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_status?: Maybe<Scalars['String']>;
  last_successful_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ExternalContextSourcesMinFields = {
  __typename?: 'external_context_sources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  integration?: Maybe<Scalars['String']>;
  last_error?: Maybe<Scalars['String']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_status?: Maybe<Scalars['String']>;
  last_successful_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "external_context_sources". */
export type ExternalContextSourcesOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<OrderBy>;
  last_error?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_status?: InputMaybe<OrderBy>;
  last_successful_run_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  purpose?: InputMaybe<OrderBy>;
  sync_frequency?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "external_context_sources" */
export const ExternalContextSourcesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Integration: 'integration',
  /** column name */
  LastError: 'last_error',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastStatus: 'last_status',
  /** column name */
  LastSuccessfulRunAt: 'last_successful_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  Purpose: 'purpose',
  /** column name */
  SyncFrequency: 'sync_frequency',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ExternalContextSourcesSelectColumn = typeof ExternalContextSourcesSelectColumn[keyof typeof ExternalContextSourcesSelectColumn];
/** aggregate stddev on columns */
export type ExternalContextSourcesStddevFields = {
  __typename?: 'external_context_sources_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ExternalContextSourcesStddevPopFields = {
  __typename?: 'external_context_sources_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ExternalContextSourcesStddevSampFields = {
  __typename?: 'external_context_sources_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_context_sources" */
export type ExternalContextSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExternalContextSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalContextSourcesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration?: InputMaybe<Scalars['String']>;
  last_error?: InputMaybe<Scalars['String']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_status?: InputMaybe<Scalars['String']>;
  last_successful_run_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  sync_frequency?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ExternalContextSourcesSumFields = {
  __typename?: 'external_context_sources_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ExternalContextSourcesVarPopFields = {
  __typename?: 'external_context_sources_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ExternalContextSourcesVarSampFields = {
  __typename?: 'external_context_sources_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ExternalContextSourcesVarianceFields = {
  __typename?: 'external_context_sources_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "external_segments" */
export type ExternalSegments = {
  __typename?: 'external_segments';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance: DestinationInstances;
  destination_instance_id: Scalars['bigint'];
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  status: Scalars['String'];
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
};


/** columns and relationships of "external_segments" */
export type ExternalSegmentsSyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "external_segments" */
export type ExternalSegmentsSyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};

/** order by aggregate values of table "external_segments" */
export type ExternalSegmentsAggregateOrderBy = {
  avg?: InputMaybe<ExternalSegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ExternalSegmentsMaxOrderBy>;
  min?: InputMaybe<ExternalSegmentsMinOrderBy>;
  stddev?: InputMaybe<ExternalSegmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ExternalSegmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ExternalSegmentsStddevSampOrderBy>;
  sum?: InputMaybe<ExternalSegmentsSumOrderBy>;
  var_pop?: InputMaybe<ExternalSegmentsVarPopOrderBy>;
  var_samp?: InputMaybe<ExternalSegmentsVarSampOrderBy>;
  variance?: InputMaybe<ExternalSegmentsVarianceOrderBy>;
};

/** order by avg() on columns of table "external_segments" */
export type ExternalSegmentsAvgOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "external_segments". All fields are combined with a logical 'AND'. */
export type ExternalSegmentsBoolExp = {
  _and?: InputMaybe<Array<ExternalSegmentsBoolExp>>;
  _not?: InputMaybe<ExternalSegmentsBoolExp>;
  _or?: InputMaybe<Array<ExternalSegmentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  external_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync_requests?: InputMaybe<SyncRequestsBoolExp>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateBoolExp>;
};

/** order by max() on columns of table "external_segments" */
export type ExternalSegmentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "external_segments" */
export type ExternalSegmentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "external_segments" */
export type ExternalSegmentsMutationResponse = {
  __typename?: 'external_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalSegments>;
};

/** Ordering options when selecting data from "external_segments". */
export type ExternalSegmentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  external_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateOrderBy>;
};

/** select columns of table "external_segments" */
export const ExternalSegmentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  ExternalId: 'external_id',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status'
} as const;

export type ExternalSegmentsSelectColumn = typeof ExternalSegmentsSelectColumn[keyof typeof ExternalSegmentsSelectColumn];
/** order by stddev() on columns of table "external_segments" */
export type ExternalSegmentsStddevOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "external_segments" */
export type ExternalSegmentsStddevPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "external_segments" */
export type ExternalSegmentsStddevSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "external_segments" */
export type ExternalSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExternalSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalSegmentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "external_segments" */
export type ExternalSegmentsSumOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "external_segments" */
export type ExternalSegmentsVarPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "external_segments" */
export type ExternalSegmentsVarSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "external_segments" */
export type ExternalSegmentsVarianceOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "figma_import_drafts" */
export type FigmaImportDrafts = {
  __typename?: 'figma_import_drafts';
  confirmed_at?: Maybe<Scalars['timestamptz']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  discovered_images: Scalars['jsonb'];
  extension_id: Scalars['uuid'];
  figma_file_key: Scalars['String'];
  figma_node_id: Scalars['String'];
  id: Scalars['uuid'];
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  preview_html: Scalars['String'];
  status: Scalars['String'];
  warnings: Scalars['jsonb'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "figma_import_drafts" */
export type FigmaImportDraftsDiscoveredImagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "figma_import_drafts" */
export type FigmaImportDraftsWarningsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "figma_import_drafts" */
export type FigmaImportDraftsAggregateOrderBy = {
  avg?: InputMaybe<FigmaImportDraftsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FigmaImportDraftsMaxOrderBy>;
  min?: InputMaybe<FigmaImportDraftsMinOrderBy>;
  stddev?: InputMaybe<FigmaImportDraftsStddevOrderBy>;
  stddev_pop?: InputMaybe<FigmaImportDraftsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<FigmaImportDraftsStddevSampOrderBy>;
  sum?: InputMaybe<FigmaImportDraftsSumOrderBy>;
  var_pop?: InputMaybe<FigmaImportDraftsVarPopOrderBy>;
  var_samp?: InputMaybe<FigmaImportDraftsVarSampOrderBy>;
  variance?: InputMaybe<FigmaImportDraftsVarianceOrderBy>;
};

/** order by avg() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "figma_import_drafts". All fields are combined with a logical 'AND'. */
export type FigmaImportDraftsBoolExp = {
  _and?: InputMaybe<Array<FigmaImportDraftsBoolExp>>;
  _not?: InputMaybe<FigmaImportDraftsBoolExp>;
  _or?: InputMaybe<Array<FigmaImportDraftsBoolExp>>;
  confirmed_at?: InputMaybe<TimestamptzComparisonExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  discovered_images?: InputMaybe<JsonbComparisonExp>;
  extension_id?: InputMaybe<UuidComparisonExp>;
  figma_file_key?: InputMaybe<StringComparisonExp>;
  figma_node_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  preview_html?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  warnings?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsMaxOrderBy = {
  confirmed_at?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  extension_id?: InputMaybe<OrderBy>;
  figma_file_key?: InputMaybe<OrderBy>;
  figma_node_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  preview_html?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsMinOrderBy = {
  confirmed_at?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  extension_id?: InputMaybe<OrderBy>;
  figma_file_key?: InputMaybe<OrderBy>;
  figma_node_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  preview_html?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "figma_import_drafts" */
export type FigmaImportDraftsMutationResponse = {
  __typename?: 'figma_import_drafts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FigmaImportDrafts>;
};

/** Ordering options when selecting data from "figma_import_drafts". */
export type FigmaImportDraftsOrderBy = {
  confirmed_at?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  discovered_images?: InputMaybe<OrderBy>;
  extension_id?: InputMaybe<OrderBy>;
  figma_file_key?: InputMaybe<OrderBy>;
  figma_node_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  preview_html?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  warnings?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: figma_import_drafts */
export type FigmaImportDraftsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "figma_import_drafts" */
export const FigmaImportDraftsSelectColumn = {
  /** column name */
  ConfirmedAt: 'confirmed_at',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DiscoveredImages: 'discovered_images',
  /** column name */
  ExtensionId: 'extension_id',
  /** column name */
  FigmaFileKey: 'figma_file_key',
  /** column name */
  FigmaNodeId: 'figma_node_id',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  PreviewHtml: 'preview_html',
  /** column name */
  Status: 'status',
  /** column name */
  Warnings: 'warnings',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FigmaImportDraftsSelectColumn = typeof FigmaImportDraftsSelectColumn[keyof typeof FigmaImportDraftsSelectColumn];
/** input type for updating data in table "figma_import_drafts" */
export type FigmaImportDraftsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "figma_import_drafts" */
export type FigmaImportDraftsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FigmaImportDraftsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FigmaImportDraftsStreamCursorValueInput = {
  confirmed_at?: InputMaybe<Scalars['timestamptz']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  discovered_images?: InputMaybe<Scalars['jsonb']>;
  extension_id?: InputMaybe<Scalars['uuid']>;
  figma_file_key?: InputMaybe<Scalars['String']>;
  figma_node_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  preview_html?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  warnings?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type FigmaImportDraftsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FigmaImportDraftsSetInput>;
  /** filter the rows which have to be updated */
  where: FigmaImportDraftsBoolExp;
};

/** order by var_pop() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "figma_import_drafts" */
export type FigmaImportDraftsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncs = {
  __typename?: 'fivetran_agent_syncs';
  authenticated_at?: Maybe<Scalars['timestamptz']>;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  destination_id?: Maybe<Scalars['bigint']>;
  fivetran_connection?: Maybe<Scalars['jsonb']>;
  fivetran_connector_id: Scalars['String'];
  fivetran_destination_id: Scalars['String'];
  fivetran_fetched_at?: Maybe<Scalars['timestamptz']>;
  fivetran_group_id: Scalars['String'];
  fivetran_last_test?: Maybe<Scalars['jsonb']>;
  fivetran_log?: Maybe<Scalars['jsonb']>;
  fivetran_sync_history?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  last_successful_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  schema_name: Scalars['String'];
  source_type: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncsFivetranConnectionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncsFivetranLastTestArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncsFivetranLogArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "fivetran_agent_syncs" */
export type FivetranAgentSyncsFivetranSyncHistoryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "fivetran_agent_syncs". All fields are combined with a logical 'AND'. */
export type FivetranAgentSyncsBoolExp = {
  _and?: InputMaybe<Array<FivetranAgentSyncsBoolExp>>;
  _not?: InputMaybe<FivetranAgentSyncsBoolExp>;
  _or?: InputMaybe<Array<FivetranAgentSyncsBoolExp>>;
  authenticated_at?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  fivetran_connection?: InputMaybe<JsonbComparisonExp>;
  fivetran_connector_id?: InputMaybe<StringComparisonExp>;
  fivetran_destination_id?: InputMaybe<StringComparisonExp>;
  fivetran_fetched_at?: InputMaybe<TimestamptzComparisonExp>;
  fivetran_group_id?: InputMaybe<StringComparisonExp>;
  fivetran_last_test?: InputMaybe<JsonbComparisonExp>;
  fivetran_log?: InputMaybe<JsonbComparisonExp>;
  fivetran_sync_history?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_successful_run_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  schema_name?: InputMaybe<StringComparisonExp>;
  source_type?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** response of any mutation on the table "fivetran_agent_syncs" */
export type FivetranAgentSyncsMutationResponse = {
  __typename?: 'fivetran_agent_syncs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FivetranAgentSyncs>;
};

/** Ordering options when selecting data from "fivetran_agent_syncs". */
export type FivetranAgentSyncsOrderBy = {
  authenticated_at?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  fivetran_connection?: InputMaybe<OrderBy>;
  fivetran_connector_id?: InputMaybe<OrderBy>;
  fivetran_destination_id?: InputMaybe<OrderBy>;
  fivetran_fetched_at?: InputMaybe<OrderBy>;
  fivetran_group_id?: InputMaybe<OrderBy>;
  fivetran_last_test?: InputMaybe<OrderBy>;
  fivetran_log?: InputMaybe<OrderBy>;
  fivetran_sync_history?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_successful_run_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  schema_name?: InputMaybe<OrderBy>;
  source_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: fivetran_agent_syncs */
export type FivetranAgentSyncsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "fivetran_agent_syncs" */
export const FivetranAgentSyncsSelectColumn = {
  /** column name */
  AuthenticatedAt: 'authenticated_at',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  FivetranConnection: 'fivetran_connection',
  /** column name */
  FivetranConnectorId: 'fivetran_connector_id',
  /** column name */
  FivetranDestinationId: 'fivetran_destination_id',
  /** column name */
  FivetranFetchedAt: 'fivetran_fetched_at',
  /** column name */
  FivetranGroupId: 'fivetran_group_id',
  /** column name */
  FivetranLastTest: 'fivetran_last_test',
  /** column name */
  FivetranLog: 'fivetran_log',
  /** column name */
  FivetranSyncHistory: 'fivetran_sync_history',
  /** column name */
  Id: 'id',
  /** column name */
  LastSuccessfulRunAt: 'last_successful_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  SchemaName: 'schema_name',
  /** column name */
  SourceType: 'source_type',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FivetranAgentSyncsSelectColumn = typeof FivetranAgentSyncsSelectColumn[keyof typeof FivetranAgentSyncsSelectColumn];
/** input type for updating data in table "fivetran_agent_syncs" */
export type FivetranAgentSyncsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "fivetran_agent_syncs" */
export type FivetranAgentSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FivetranAgentSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FivetranAgentSyncsStreamCursorValueInput = {
  authenticated_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  fivetran_connection?: InputMaybe<Scalars['jsonb']>;
  fivetran_connector_id?: InputMaybe<Scalars['String']>;
  fivetran_destination_id?: InputMaybe<Scalars['String']>;
  fivetran_fetched_at?: InputMaybe<Scalars['timestamptz']>;
  fivetran_group_id?: InputMaybe<Scalars['String']>;
  fivetran_last_test?: InputMaybe<Scalars['jsonb']>;
  fivetran_log?: InputMaybe<Scalars['jsonb']>;
  fivetran_sync_history?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_successful_run_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  schema_name?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

export type FivetranAgentSyncsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FivetranAgentSyncsSetInput>;
  /** filter the rows which have to be updated */
  where: FivetranAgentSyncsBoolExp;
};

/** columns and relationships of "fivetran_credentials" */
export type FivetranCredentials = {
  __typename?: 'fivetran_credentials';
  api_key: Scalars['String'];
  created_at: Scalars['timestamptz'];
  fivetran_webhook_id: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  incoming_webhook: IncomingWebhooks;
  metadata?: Maybe<Scalars['jsonb']>;
  webhook_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "fivetran_credentials" */
export type FivetranCredentialsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FivetranCredentialsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "fivetran_credentials". All fields are combined with a logical 'AND'. */
export type FivetranCredentialsBoolExp = {
  _and?: InputMaybe<Array<FivetranCredentialsBoolExp>>;
  _not?: InputMaybe<FivetranCredentialsBoolExp>;
  _or?: InputMaybe<Array<FivetranCredentialsBoolExp>>;
  api_key?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  fivetran_webhook_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  incoming_webhook?: InputMaybe<IncomingWebhooksBoolExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  webhook_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FivetranCredentialsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FivetranCredentialsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FivetranCredentialsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "fivetran_credentials" */
export type FivetranCredentialsMutationResponse = {
  __typename?: 'fivetran_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FivetranCredentials>;
};

/** Ordering options when selecting data from "fivetran_credentials". */
export type FivetranCredentialsOrderBy = {
  api_key?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  fivetran_webhook_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  incoming_webhook?: InputMaybe<IncomingWebhooksOrderBy>;
  metadata?: InputMaybe<OrderBy>;
  webhook_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: fivetran_credentials */
export type FivetranCredentialsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FivetranCredentialsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "fivetran_credentials" */
export const FivetranCredentialsSelectColumn = {
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FivetranWebhookId: 'fivetran_webhook_id',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  WebhookId: 'webhook_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FivetranCredentialsSelectColumn = typeof FivetranCredentialsSelectColumn[keyof typeof FivetranCredentialsSelectColumn];
/** input type for updating data in table "fivetran_credentials" */
export type FivetranCredentialsSetInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "fivetran_credentials" */
export type FivetranCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FivetranCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FivetranCredentialsStreamCursorValueInput = {
  api_key?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fivetran_webhook_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  webhook_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

export type FivetranCredentialsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FivetranCredentialsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<FivetranCredentialsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<FivetranCredentialsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<FivetranCredentialsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FivetranCredentialsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FivetranCredentialsSetInput>;
  /** filter the rows which have to be updated */
  where: FivetranCredentialsBoolExp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "folders" */
export type Folders = {
  __typename?: 'folders';
  /** An array relationship */
  ad_brief_assets: Array<AdBriefAssets>;
  /** An aggregate relationship */
  ad_brief_assets_aggregate: AdBriefAssetsAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  parent?: Maybe<Folders>;
  parent_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  segments: Array<Segments>;
  /** An aggregate relationship */
  segments_aggregate: SegmentsAggregate;
  type?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "folders" */
export type FoldersAdBriefAssetsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


/** columns and relationships of "folders" */
export type FoldersAdBriefAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


/** columns and relationships of "folders" */
export type FoldersSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


/** columns and relationships of "folders" */
export type FoldersSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};

/** Boolean expression to filter rows from the table "folders". All fields are combined with a logical 'AND'. */
export type FoldersBoolExp = {
  _and?: InputMaybe<Array<FoldersBoolExp>>;
  _not?: InputMaybe<FoldersBoolExp>;
  _or?: InputMaybe<Array<FoldersBoolExp>>;
  ad_brief_assets?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_assets_aggregate?: InputMaybe<AdBriefAssetsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent?: InputMaybe<FoldersBoolExp>;
  parent_id?: InputMaybe<UuidComparisonExp>;
  segments?: InputMaybe<SegmentsBoolExp>;
  segments_aggregate?: InputMaybe<SegmentsAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "folders" */
export const FoldersConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  FoldersIdWorkspaceIdUnique: 'folders_id_workspace_id_unique',
  /** unique or primary key constraint on columns "id" */
  FoldersPkey: 'folders_pkey'
} as const;

export type FoldersConstraint = typeof FoldersConstraint[keyof typeof FoldersConstraint];
/** input type for inserting data into table "folders" */
export type FoldersInsertInput = {
  ad_brief_assets?: InputMaybe<AdBriefAssetsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<FoldersObjRelInsertInput>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  segments?: InputMaybe<SegmentsArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "folders" */
export type FoldersMutationResponse = {
  __typename?: 'folders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Folders>;
};

/** input type for inserting object relation for remote table "folders" */
export type FoldersObjRelInsertInput = {
  data: FoldersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<FoldersOnConflict>;
};

/** on_conflict condition type for table "folders" */
export type FoldersOnConflict = {
  constraint: FoldersConstraint;
  update_columns?: Array<FoldersUpdateColumn>;
  where?: InputMaybe<FoldersBoolExp>;
};

/** Ordering options when selecting data from "folders". */
export type FoldersOrderBy = {
  ad_brief_assets_aggregate?: InputMaybe<AdBriefAssetsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent?: InputMaybe<FoldersOrderBy>;
  parent_id?: InputMaybe<OrderBy>;
  segments_aggregate?: InputMaybe<SegmentsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: folders */
export type FoldersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "folders" */
export const FoldersSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentId: 'parent_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FoldersSelectColumn = typeof FoldersSelectColumn[keyof typeof FoldersSelectColumn];
/** input type for updating data in table "folders" */
export type FoldersSetInput = {
  name?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "folders" */
export type FoldersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FoldersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FoldersStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "folders" */
export const FoldersUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  ParentId: 'parent_id'
} as const;

export type FoldersUpdateColumn = typeof FoldersUpdateColumn[keyof typeof FoldersUpdateColumn];
export type FoldersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FoldersSetInput>;
  /** filter the rows which have to be updated */
  where: FoldersBoolExp;
};

/** columns and relationships of "function_grants" */
export type FunctionGrants = {
  __typename?: 'function_grants';
  can_access_data: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['uuid'];
  resource_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "function_grants" */
export type FunctionGrantsAggregate = {
  __typename?: 'function_grants_aggregate';
  aggregate?: Maybe<FunctionGrantsAggregateFields>;
  nodes: Array<FunctionGrants>;
};

/** aggregate fields of "function_grants" */
export type FunctionGrantsAggregateFields = {
  __typename?: 'function_grants_aggregate_fields';
  avg?: Maybe<FunctionGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FunctionGrantsMaxFields>;
  min?: Maybe<FunctionGrantsMinFields>;
  stddev?: Maybe<FunctionGrantsStddevFields>;
  stddev_pop?: Maybe<FunctionGrantsStddevPopFields>;
  stddev_samp?: Maybe<FunctionGrantsStddevSampFields>;
  sum?: Maybe<FunctionGrantsSumFields>;
  var_pop?: Maybe<FunctionGrantsVarPopFields>;
  var_samp?: Maybe<FunctionGrantsVarSampFields>;
  variance?: Maybe<FunctionGrantsVarianceFields>;
};


/** aggregate fields of "function_grants" */
export type FunctionGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FunctionGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type FunctionGrantsAvgFields = {
  __typename?: 'function_grants_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "function_grants". All fields are combined with a logical 'AND'. */
export type FunctionGrantsBoolExp = {
  _and?: InputMaybe<Array<FunctionGrantsBoolExp>>;
  _not?: InputMaybe<FunctionGrantsBoolExp>;
  _or?: InputMaybe<Array<FunctionGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "function_grants" */
export const FunctionGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  FunctionGrantsPkey: 'function_grants_pkey',
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id" */
  FunctionGrantsUserGroupIdWorkspaceIdResourceIdKey: 'function_grants_user_group_id_workspace_id_resource_id_key'
} as const;

export type FunctionGrantsConstraint = typeof FunctionGrantsConstraint[keyof typeof FunctionGrantsConstraint];
/** input type for inserting data into table "function_grants" */
export type FunctionGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type FunctionGrantsMaxFields = {
  __typename?: 'function_grants_max_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type FunctionGrantsMinFields = {
  __typename?: 'function_grants_min_fields';
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "function_grants" */
export type FunctionGrantsMutationResponse = {
  __typename?: 'function_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FunctionGrants>;
};

/** on_conflict condition type for table "function_grants" */
export type FunctionGrantsOnConflict = {
  constraint: FunctionGrantsConstraint;
  update_columns?: Array<FunctionGrantsUpdateColumn>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};

/** Ordering options when selecting data from "function_grants". */
export type FunctionGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: function_grants */
export type FunctionGrantsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "function_grants" */
export const FunctionGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FunctionGrantsSelectColumn = typeof FunctionGrantsSelectColumn[keyof typeof FunctionGrantsSelectColumn];
/** input type for updating data in table "function_grants" */
export type FunctionGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type FunctionGrantsStddevFields = {
  __typename?: 'function_grants_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type FunctionGrantsStddevPopFields = {
  __typename?: 'function_grants_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type FunctionGrantsStddevSampFields = {
  __typename?: 'function_grants_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "function_grants" */
export type FunctionGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FunctionGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FunctionGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type FunctionGrantsSumFields = {
  __typename?: 'function_grants_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "function_grants" */
export const FunctionGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type FunctionGrantsUpdateColumn = typeof FunctionGrantsUpdateColumn[keyof typeof FunctionGrantsUpdateColumn];
export type FunctionGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FunctionGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: FunctionGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type FunctionGrantsVarPopFields = {
  __typename?: 'function_grants_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type FunctionGrantsVarSampFields = {
  __typename?: 'function_grants_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FunctionGrantsVarianceFields = {
  __typename?: 'function_grants_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "function_resources" */
export type FunctionResources = {
  __typename?: 'function_resources';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  function_id: Scalars['uuid'];
  /** An array relationship */
  functions: Array<Functions>;
  id: Scalars['uuid'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "function_resources" */
export type FunctionResourcesFunctionsArgs = {
  distinct_on?: InputMaybe<Array<FunctionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionsOrderBy>>;
  where?: InputMaybe<FunctionsBoolExp>;
};

/** aggregated selection of "function_resources" */
export type FunctionResourcesAggregate = {
  __typename?: 'function_resources_aggregate';
  aggregate?: Maybe<FunctionResourcesAggregateFields>;
  nodes: Array<FunctionResources>;
};

export type FunctionResourcesAggregateBoolExp = {
  count?: InputMaybe<FunctionResourcesAggregateBoolExpCount>;
};

export type FunctionResourcesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FunctionResourcesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "function_resources" */
export type FunctionResourcesAggregateFields = {
  __typename?: 'function_resources_aggregate_fields';
  avg?: Maybe<FunctionResourcesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FunctionResourcesMaxFields>;
  min?: Maybe<FunctionResourcesMinFields>;
  stddev?: Maybe<FunctionResourcesStddevFields>;
  stddev_pop?: Maybe<FunctionResourcesStddevPopFields>;
  stddev_samp?: Maybe<FunctionResourcesStddevSampFields>;
  sum?: Maybe<FunctionResourcesSumFields>;
  var_pop?: Maybe<FunctionResourcesVarPopFields>;
  var_samp?: Maybe<FunctionResourcesVarSampFields>;
  variance?: Maybe<FunctionResourcesVarianceFields>;
};


/** aggregate fields of "function_resources" */
export type FunctionResourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "function_resources" */
export type FunctionResourcesAggregateOrderBy = {
  avg?: InputMaybe<FunctionResourcesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FunctionResourcesMaxOrderBy>;
  min?: InputMaybe<FunctionResourcesMinOrderBy>;
  stddev?: InputMaybe<FunctionResourcesStddevOrderBy>;
  stddev_pop?: InputMaybe<FunctionResourcesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<FunctionResourcesStddevSampOrderBy>;
  sum?: InputMaybe<FunctionResourcesSumOrderBy>;
  var_pop?: InputMaybe<FunctionResourcesVarPopOrderBy>;
  var_samp?: InputMaybe<FunctionResourcesVarSampOrderBy>;
  variance?: InputMaybe<FunctionResourcesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type FunctionResourcesAvgFields = {
  __typename?: 'function_resources_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "function_resources" */
export type FunctionResourcesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "function_resources". All fields are combined with a logical 'AND'. */
export type FunctionResourcesBoolExp = {
  _and?: InputMaybe<Array<FunctionResourcesBoolExp>>;
  _not?: InputMaybe<FunctionResourcesBoolExp>;
  _or?: InputMaybe<Array<FunctionResourcesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  function_id?: InputMaybe<UuidComparisonExp>;
  functions?: InputMaybe<FunctionsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "function_resources" */
export const FunctionResourcesConstraint = {
  /** unique or primary key constraint on columns "id" */
  FunctionResourcesPkey: 'function_resources_pkey',
  /** unique or primary key constraint on columns "resource_id", "resource_type" */
  FunctionResourcesResourceIdResourceType: 'function_resources_resource_id_resource_type'
} as const;

export type FunctionResourcesConstraint = typeof FunctionResourcesConstraint[keyof typeof FunctionResourcesConstraint];
/** input type for inserting data into table "function_resources" */
export type FunctionResourcesInsertInput = {
  function_id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FunctionResourcesMaxFields = {
  __typename?: 'function_resources_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  function_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "function_resources" */
export type FunctionResourcesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  function_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FunctionResourcesMinFields = {
  __typename?: 'function_resources_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  function_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "function_resources" */
export type FunctionResourcesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  function_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "function_resources" */
export type FunctionResourcesMutationResponse = {
  __typename?: 'function_resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FunctionResources>;
};

/** on_conflict condition type for table "function_resources" */
export type FunctionResourcesOnConflict = {
  constraint: FunctionResourcesConstraint;
  update_columns?: Array<FunctionResourcesUpdateColumn>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};

/** Ordering options when selecting data from "function_resources". */
export type FunctionResourcesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  function_id?: InputMaybe<OrderBy>;
  functions_aggregate?: InputMaybe<FunctionsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: function_resources */
export type FunctionResourcesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "function_resources" */
export const FunctionResourcesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FunctionId: 'function_id',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FunctionResourcesSelectColumn = typeof FunctionResourcesSelectColumn[keyof typeof FunctionResourcesSelectColumn];
/** input type for updating data in table "function_resources" */
export type FunctionResourcesSetInput = {
  function_id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type FunctionResourcesStddevFields = {
  __typename?: 'function_resources_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "function_resources" */
export type FunctionResourcesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type FunctionResourcesStddevPopFields = {
  __typename?: 'function_resources_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "function_resources" */
export type FunctionResourcesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type FunctionResourcesStddevSampFields = {
  __typename?: 'function_resources_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "function_resources" */
export type FunctionResourcesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "function_resources" */
export type FunctionResourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FunctionResourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FunctionResourcesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  function_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type FunctionResourcesSumFields = {
  __typename?: 'function_resources_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "function_resources" */
export type FunctionResourcesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "function_resources" */
export const FunctionResourcesUpdateColumn = {
  /** column name */
  FunctionId: 'function_id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type'
} as const;

export type FunctionResourcesUpdateColumn = typeof FunctionResourcesUpdateColumn[keyof typeof FunctionResourcesUpdateColumn];
export type FunctionResourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FunctionResourcesSetInput>;
  /** filter the rows which have to be updated */
  where: FunctionResourcesBoolExp;
};

/** aggregate var_pop on columns */
export type FunctionResourcesVarPopFields = {
  __typename?: 'function_resources_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "function_resources" */
export type FunctionResourcesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type FunctionResourcesVarSampFields = {
  __typename?: 'function_resources_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "function_resources" */
export type FunctionResourcesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type FunctionResourcesVarianceFields = {
  __typename?: 'function_resources_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "function_resources" */
export type FunctionResourcesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "function_settings" */
export type FunctionSettings = {
  __typename?: 'function_settings';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  encrypted_value?: Maybe<Scalars['String']>;
  function_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  value?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "function_settings" */
export type FunctionSettingsAggregateOrderBy = {
  avg?: InputMaybe<FunctionSettingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FunctionSettingsMaxOrderBy>;
  min?: InputMaybe<FunctionSettingsMinOrderBy>;
  stddev?: InputMaybe<FunctionSettingsStddevOrderBy>;
  stddev_pop?: InputMaybe<FunctionSettingsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<FunctionSettingsStddevSampOrderBy>;
  sum?: InputMaybe<FunctionSettingsSumOrderBy>;
  var_pop?: InputMaybe<FunctionSettingsVarPopOrderBy>;
  var_samp?: InputMaybe<FunctionSettingsVarSampOrderBy>;
  variance?: InputMaybe<FunctionSettingsVarianceOrderBy>;
};

/** order by avg() on columns of table "function_settings" */
export type FunctionSettingsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "function_settings". All fields are combined with a logical 'AND'. */
export type FunctionSettingsBoolExp = {
  _and?: InputMaybe<Array<FunctionSettingsBoolExp>>;
  _not?: InputMaybe<FunctionSettingsBoolExp>;
  _or?: InputMaybe<Array<FunctionSettingsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  encrypted_value?: InputMaybe<StringComparisonExp>;
  function_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "function_settings" */
export const FunctionSettingsConstraint = {
  /** unique or primary key constraint on columns "name", "function_id" */
  FunctionSettingsFunctionIdName: 'function_settings_function_id_name',
  /** unique or primary key constraint on columns "id" */
  FunctionSettingsPkey: 'function_settings_pkey'
} as const;

export type FunctionSettingsConstraint = typeof FunctionSettingsConstraint[keyof typeof FunctionSettingsConstraint];
/** input type for inserting data into table "function_settings" */
export type FunctionSettingsInsertInput = {
  function_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "function_settings" */
export type FunctionSettingsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  encrypted_value?: InputMaybe<OrderBy>;
  function_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "function_settings" */
export type FunctionSettingsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  encrypted_value?: InputMaybe<OrderBy>;
  function_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "function_settings" */
export type FunctionSettingsMutationResponse = {
  __typename?: 'function_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FunctionSettings>;
};

/** on_conflict condition type for table "function_settings" */
export type FunctionSettingsOnConflict = {
  constraint: FunctionSettingsConstraint;
  update_columns?: Array<FunctionSettingsUpdateColumn>;
  where?: InputMaybe<FunctionSettingsBoolExp>;
};

/** Ordering options when selecting data from "function_settings". */
export type FunctionSettingsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  encrypted_value?: InputMaybe<OrderBy>;
  function_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  value?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: function_settings */
export type FunctionSettingsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "function_settings" */
export const FunctionSettingsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EncryptedValue: 'encrypted_value',
  /** column name */
  FunctionId: 'function_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Value: 'value',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FunctionSettingsSelectColumn = typeof FunctionSettingsSelectColumn[keyof typeof FunctionSettingsSelectColumn];
/** input type for updating data in table "function_settings" */
export type FunctionSettingsSetInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "function_settings" */
export type FunctionSettingsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "function_settings" */
export type FunctionSettingsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "function_settings" */
export type FunctionSettingsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "function_settings" */
export type FunctionSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FunctionSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FunctionSettingsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  encrypted_value?: InputMaybe<Scalars['String']>;
  function_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "function_settings" */
export type FunctionSettingsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "function_settings" */
export const FunctionSettingsUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  Value: 'value'
} as const;

export type FunctionSettingsUpdateColumn = typeof FunctionSettingsUpdateColumn[keyof typeof FunctionSettingsUpdateColumn];
export type FunctionSettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FunctionSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: FunctionSettingsBoolExp;
};

/** order by var_pop() on columns of table "function_settings" */
export type FunctionSettingsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "function_settings" */
export type FunctionSettingsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "function_settings" */
export type FunctionSettingsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "functions" */
export type Functions = {
  __typename?: 'functions';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  function_resources: Array<FunctionResources>;
  /** An aggregate relationship */
  function_resources_aggregate: FunctionResourcesAggregate;
  /** An array relationship */
  function_settings: Array<FunctionSettings>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  version_number: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "functions" */
export type FunctionsFunctionResourcesArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


/** columns and relationships of "functions" */
export type FunctionsFunctionResourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


/** columns and relationships of "functions" */
export type FunctionsFunctionSettingsArgs = {
  distinct_on?: InputMaybe<Array<FunctionSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionSettingsOrderBy>>;
  where?: InputMaybe<FunctionSettingsBoolExp>;
};

/** order by aggregate values of table "functions" */
export type FunctionsAggregateOrderBy = {
  avg?: InputMaybe<FunctionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FunctionsMaxOrderBy>;
  min?: InputMaybe<FunctionsMinOrderBy>;
  stddev?: InputMaybe<FunctionsStddevOrderBy>;
  stddev_pop?: InputMaybe<FunctionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<FunctionsStddevSampOrderBy>;
  sum?: InputMaybe<FunctionsSumOrderBy>;
  var_pop?: InputMaybe<FunctionsVarPopOrderBy>;
  var_samp?: InputMaybe<FunctionsVarSampOrderBy>;
  variance?: InputMaybe<FunctionsVarianceOrderBy>;
};

/** order by avg() on columns of table "functions" */
export type FunctionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "functions". All fields are combined with a logical 'AND'. */
export type FunctionsBoolExp = {
  _and?: InputMaybe<Array<FunctionsBoolExp>>;
  _not?: InputMaybe<FunctionsBoolExp>;
  _or?: InputMaybe<Array<FunctionsBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  function_resources?: InputMaybe<FunctionResourcesBoolExp>;
  function_resources_aggregate?: InputMaybe<FunctionResourcesAggregateBoolExp>;
  function_settings?: InputMaybe<FunctionSettingsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  version_number?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "functions" */
export type FunctionsMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "functions" */
export type FunctionsMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "functions" */
export type FunctionsMutationResponse = {
  __typename?: 'functions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Functions>;
};

/** Ordering options when selecting data from "functions". */
export type FunctionsOrderBy = {
  code?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  function_resources_aggregate?: InputMaybe<FunctionResourcesAggregateOrderBy>;
  function_settings_aggregate?: InputMaybe<FunctionSettingsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: functions */
export type FunctionsPkColumnsInput = {
  id: Scalars['uuid'];
  version_number: Scalars['Int'];
};

/** select columns of table "functions" */
export const FunctionsSelectColumn = {
  /** column name */
  Code: 'code',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VersionNumber: 'version_number',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type FunctionsSelectColumn = typeof FunctionsSelectColumn[keyof typeof FunctionsSelectColumn];
/** input type for updating data in table "functions" */
export type FunctionsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "functions" */
export type FunctionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "functions" */
export type FunctionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "functions" */
export type FunctionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "functions" */
export type FunctionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FunctionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FunctionsStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  version_number?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "functions" */
export type FunctionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type FunctionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FunctionsSetInput>;
  /** filter the rows which have to be updated */
  where: FunctionsBoolExp;
};

/** order by var_pop() on columns of table "functions" */
export type FunctionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "functions" */
export type FunctionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "functions" */
export type FunctionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "git_credentials" */
export type GitCredentials = {
  __typename?: 'git_credentials';
  credentials?: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  repository?: Maybe<Scalars['String']>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "git_credentials" */
export type GitCredentialsCredentialsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "git_credentials". All fields are combined with a logical 'AND'. */
export type GitCredentialsBoolExp = {
  _and?: InputMaybe<Array<GitCredentialsBoolExp>>;
  _not?: InputMaybe<GitCredentialsBoolExp>;
  _or?: InputMaybe<Array<GitCredentialsBoolExp>>;
  credentials?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  repository?: InputMaybe<StringComparisonExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** response of any mutation on the table "git_credentials" */
export type GitCredentialsMutationResponse = {
  __typename?: 'git_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GitCredentials>;
};

/** Ordering options when selecting data from "git_credentials". */
export type GitCredentialsOrderBy = {
  credentials?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  repository?: InputMaybe<OrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "git_credentials" */
export const GitCredentialsSelectColumn = {
  /** column name */
  Credentials: 'credentials',
  /** column name */
  Id: 'id',
  /** column name */
  Repository: 'repository',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  Username: 'username',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitCredentialsSelectColumn = typeof GitCredentialsSelectColumn[keyof typeof GitCredentialsSelectColumn];
/** Streaming cursor of the table "git_credentials" */
export type GitCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GitCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GitCredentialsStreamCursorValueInput = {
  credentials?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  repository?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "git_inbound_runs" */
export type GitInboundRuns = {
  __typename?: 'git_inbound_runs';
  affected_resources?: Maybe<Scalars['jsonb']>;
  commit?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  git_outbound_run?: Maybe<GitOutboundRuns>;
  git_outbound_run_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  git_sync_config: GitSyncConfigs;
  git_sync_config_id: Scalars['bigint'];
  id: Scalars['bigint'];
};


/** columns and relationships of "git_inbound_runs" */
export type GitInboundRunsAffectedResourcesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "git_inbound_runs" */
export type GitInboundRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "git_inbound_runs" */
export type GitInboundRunsAggregateOrderBy = {
  avg?: InputMaybe<GitInboundRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GitInboundRunsMaxOrderBy>;
  min?: InputMaybe<GitInboundRunsMinOrderBy>;
  stddev?: InputMaybe<GitInboundRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<GitInboundRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GitInboundRunsStddevSampOrderBy>;
  sum?: InputMaybe<GitInboundRunsSumOrderBy>;
  var_pop?: InputMaybe<GitInboundRunsVarPopOrderBy>;
  var_samp?: InputMaybe<GitInboundRunsVarSampOrderBy>;
  variance?: InputMaybe<GitInboundRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "git_inbound_runs" */
export type GitInboundRunsAvgOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "git_inbound_runs". All fields are combined with a logical 'AND'. */
export type GitInboundRunsBoolExp = {
  _and?: InputMaybe<Array<GitInboundRunsBoolExp>>;
  _not?: InputMaybe<GitInboundRunsBoolExp>;
  _or?: InputMaybe<Array<GitInboundRunsBoolExp>>;
  affected_resources?: InputMaybe<JsonbComparisonExp>;
  commit?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  git_outbound_run?: InputMaybe<GitOutboundRunsBoolExp>;
  git_outbound_run_id?: InputMaybe<BigintComparisonExp>;
  git_sync_config?: InputMaybe<GitSyncConfigsBoolExp>;
  git_sync_config_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "git_inbound_runs" */
export type GitInboundRunsMaxOrderBy = {
  commit?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "git_inbound_runs" */
export type GitInboundRunsMinOrderBy = {
  commit?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "git_inbound_runs". */
export type GitInboundRunsOrderBy = {
  affected_resources?: InputMaybe<OrderBy>;
  commit?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  git_outbound_run?: InputMaybe<GitOutboundRunsOrderBy>;
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config?: InputMaybe<GitSyncConfigsOrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** select columns of table "git_inbound_runs" */
export const GitInboundRunsSelectColumn = {
  /** column name */
  AffectedResources: 'affected_resources',
  /** column name */
  Commit: 'commit',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  GitOutboundRunId: 'git_outbound_run_id',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id'
} as const;

export type GitInboundRunsSelectColumn = typeof GitInboundRunsSelectColumn[keyof typeof GitInboundRunsSelectColumn];
/** order by stddev() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevPopOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "git_inbound_runs" */
export type GitInboundRunsStddevSampOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "git_inbound_runs" */
export type GitInboundRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GitInboundRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GitInboundRunsStreamCursorValueInput = {
  affected_resources?: InputMaybe<Scalars['jsonb']>;
  commit?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  git_outbound_run_id?: InputMaybe<Scalars['bigint']>;
  git_sync_config_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "git_inbound_runs" */
export type GitInboundRunsSumOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarPopOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarSampOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "git_inbound_runs" */
export type GitInboundRunsVarianceOrderBy = {
  git_outbound_run_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRuns = {
  __typename?: 'git_outbound_runs';
  changelog_id?: Maybe<Scalars['bigint']>;
  commits?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  git_sync_config: GitSyncConfigs;
  git_sync_config_id: Scalars['bigint'];
  id: Scalars['bigint'];
  state: Scalars['jsonb'];
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsCommitsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "git_outbound_runs" */
export type GitOutboundRunsStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "git_outbound_runs" */
export type GitOutboundRunsAggregateOrderBy = {
  avg?: InputMaybe<GitOutboundRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GitOutboundRunsMaxOrderBy>;
  min?: InputMaybe<GitOutboundRunsMinOrderBy>;
  stddev?: InputMaybe<GitOutboundRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<GitOutboundRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GitOutboundRunsStddevSampOrderBy>;
  sum?: InputMaybe<GitOutboundRunsSumOrderBy>;
  var_pop?: InputMaybe<GitOutboundRunsVarPopOrderBy>;
  var_samp?: InputMaybe<GitOutboundRunsVarSampOrderBy>;
  variance?: InputMaybe<GitOutboundRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "git_outbound_runs" */
export type GitOutboundRunsAvgOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "git_outbound_runs". All fields are combined with a logical 'AND'. */
export type GitOutboundRunsBoolExp = {
  _and?: InputMaybe<Array<GitOutboundRunsBoolExp>>;
  _not?: InputMaybe<GitOutboundRunsBoolExp>;
  _or?: InputMaybe<Array<GitOutboundRunsBoolExp>>;
  changelog_id?: InputMaybe<BigintComparisonExp>;
  commits?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  git_sync_config?: InputMaybe<GitSyncConfigsBoolExp>;
  git_sync_config_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
};

/** order by max() on columns of table "git_outbound_runs" */
export type GitOutboundRunsMaxOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "git_outbound_runs" */
export type GitOutboundRunsMinOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "git_outbound_runs". */
export type GitOutboundRunsOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  commits?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  git_sync_config?: InputMaybe<GitSyncConfigsOrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
};

/** select columns of table "git_outbound_runs" */
export const GitOutboundRunsSelectColumn = {
  /** column name */
  ChangelogId: 'changelog_id',
  /** column name */
  Commits: 'commits',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  GitSyncConfigId: 'git_sync_config_id',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state'
} as const;

export type GitOutboundRunsSelectColumn = typeof GitOutboundRunsSelectColumn[keyof typeof GitOutboundRunsSelectColumn];
/** order by stddev() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevPopOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "git_outbound_runs" */
export type GitOutboundRunsStddevSampOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "git_outbound_runs" */
export type GitOutboundRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GitOutboundRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GitOutboundRunsStreamCursorValueInput = {
  changelog_id?: InputMaybe<Scalars['bigint']>;
  commits?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  git_sync_config_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Scalars['jsonb']>;
};

/** order by sum() on columns of table "git_outbound_runs" */
export type GitOutboundRunsSumOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarPopOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarSampOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "git_outbound_runs" */
export type GitOutboundRunsVarianceOrderBy = {
  changelog_id?: InputMaybe<OrderBy>;
  git_sync_config_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigs = {
  __typename?: 'git_sync_configs';
  branch: Scalars['String'];
  checks_enabled?: Maybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  full_resync?: Maybe<Scalars['Boolean']>;
  fully_synced_resources: Array<Scalars['String']>;
  /** An object relationship */
  git_credential: GitCredentials;
  git_credential_id: Scalars['bigint'];
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** An array relationship */
  git_outbound_runs: Array<GitOutboundRuns>;
  id: Scalars['bigint'];
  inbound_error?: Maybe<Scalars['jsonb']>;
  last_attempted_at?: Maybe<Scalars['timestamptz']>;
  outbound_error?: Maybe<Scalars['jsonb']>;
  path?: Maybe<Scalars['String']>;
  repository: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsGitInboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitInboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitInboundRunsOrderBy>>;
  where?: InputMaybe<GitInboundRunsBoolExp>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsGitOutboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitOutboundRunsOrderBy>>;
  where?: InputMaybe<GitOutboundRunsBoolExp>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsInboundErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "git_sync_configs" */
export type GitSyncConfigsOutboundErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "git_sync_configs". All fields are combined with a logical 'AND'. */
export type GitSyncConfigsBoolExp = {
  _and?: InputMaybe<Array<GitSyncConfigsBoolExp>>;
  _not?: InputMaybe<GitSyncConfigsBoolExp>;
  _or?: InputMaybe<Array<GitSyncConfigsBoolExp>>;
  branch?: InputMaybe<StringComparisonExp>;
  checks_enabled?: InputMaybe<BooleanComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  full_resync?: InputMaybe<BooleanComparisonExp>;
  fully_synced_resources?: InputMaybe<StringArrayComparisonExp>;
  git_credential?: InputMaybe<GitCredentialsBoolExp>;
  git_credential_id?: InputMaybe<BigintComparisonExp>;
  git_inbound_runs?: InputMaybe<GitInboundRunsBoolExp>;
  git_outbound_runs?: InputMaybe<GitOutboundRunsBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  inbound_error?: InputMaybe<JsonbComparisonExp>;
  last_attempted_at?: InputMaybe<TimestamptzComparisonExp>;
  outbound_error?: InputMaybe<JsonbComparisonExp>;
  path?: InputMaybe<StringComparisonExp>;
  repository?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "git_sync_configs" */
export type GitSyncConfigsIncInput = {
  git_credential_id?: InputMaybe<Scalars['bigint']>;
};

/** response of any mutation on the table "git_sync_configs" */
export type GitSyncConfigsMutationResponse = {
  __typename?: 'git_sync_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GitSyncConfigs>;
};

/** Ordering options when selecting data from "git_sync_configs". */
export type GitSyncConfigsOrderBy = {
  branch?: InputMaybe<OrderBy>;
  checks_enabled?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  full_resync?: InputMaybe<OrderBy>;
  fully_synced_resources?: InputMaybe<OrderBy>;
  git_credential?: InputMaybe<GitCredentialsOrderBy>;
  git_credential_id?: InputMaybe<OrderBy>;
  git_inbound_runs_aggregate?: InputMaybe<GitInboundRunsAggregateOrderBy>;
  git_outbound_runs_aggregate?: InputMaybe<GitOutboundRunsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  inbound_error?: InputMaybe<OrderBy>;
  last_attempted_at?: InputMaybe<OrderBy>;
  outbound_error?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  repository?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: git_sync_configs */
export type GitSyncConfigsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "git_sync_configs" */
export const GitSyncConfigsSelectColumn = {
  /** column name */
  Branch: 'branch',
  /** column name */
  ChecksEnabled: 'checks_enabled',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  FullySyncedResources: 'fully_synced_resources',
  /** column name */
  GitCredentialId: 'git_credential_id',
  /** column name */
  Id: 'id',
  /** column name */
  InboundError: 'inbound_error',
  /** column name */
  LastAttemptedAt: 'last_attempted_at',
  /** column name */
  OutboundError: 'outbound_error',
  /** column name */
  Path: 'path',
  /** column name */
  Repository: 'repository',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GitSyncConfigsSelectColumn = typeof GitSyncConfigsSelectColumn[keyof typeof GitSyncConfigsSelectColumn];
/** input type for updating data in table "git_sync_configs" */
export type GitSyncConfigsSetInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  fully_synced_resources?: InputMaybe<Array<Scalars['String']>>;
  git_credential_id?: InputMaybe<Scalars['bigint']>;
  last_attempted_at?: InputMaybe<Scalars['timestamptz']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "git_sync_configs" */
export type GitSyncConfigsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GitSyncConfigsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GitSyncConfigsStreamCursorValueInput = {
  branch?: InputMaybe<Scalars['String']>;
  checks_enabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  fully_synced_resources?: InputMaybe<Array<Scalars['String']>>;
  git_credential_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  inbound_error?: InputMaybe<Scalars['jsonb']>;
  last_attempted_at?: InputMaybe<Scalars['timestamptz']>;
  outbound_error?: InputMaybe<Scalars['jsonb']>;
  path?: InputMaybe<Scalars['String']>;
  repository?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

export type GitSyncConfigsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GitSyncConfigsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GitSyncConfigsSetInput>;
  /** filter the rows which have to be updated */
  where: GitSyncConfigsBoolExp;
};

/** columns and relationships of "goal_metrics" */
export type GoalMetrics = {
  __typename?: 'goal_metrics';
  audience_contribution_size: Scalars['Int'];
  /** An object relationship */
  audience_split?: Maybe<AudienceSplits>;
  calculated_at: Scalars['timestamptz'];
  /** An object relationship */
  goal: Goals;
  goal_id: Scalars['uuid'];
  id: Scalars['uuid'];
  metric_value: Scalars['Float'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  split_id?: Maybe<Scalars['uuid']>;
};

/** order by aggregate values of table "goal_metrics" */
export type GoalMetricsAggregateOrderBy = {
  avg?: InputMaybe<GoalMetricsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoalMetricsMaxOrderBy>;
  min?: InputMaybe<GoalMetricsMinOrderBy>;
  stddev?: InputMaybe<GoalMetricsStddevOrderBy>;
  stddev_pop?: InputMaybe<GoalMetricsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GoalMetricsStddevSampOrderBy>;
  sum?: InputMaybe<GoalMetricsSumOrderBy>;
  var_pop?: InputMaybe<GoalMetricsVarPopOrderBy>;
  var_samp?: InputMaybe<GoalMetricsVarSampOrderBy>;
  variance?: InputMaybe<GoalMetricsVarianceOrderBy>;
};

/** order by avg() on columns of table "goal_metrics" */
export type GoalMetricsAvgOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "goal_metrics". All fields are combined with a logical 'AND'. */
export type GoalMetricsBoolExp = {
  _and?: InputMaybe<Array<GoalMetricsBoolExp>>;
  _not?: InputMaybe<GoalMetricsBoolExp>;
  _or?: InputMaybe<Array<GoalMetricsBoolExp>>;
  audience_contribution_size?: InputMaybe<IntComparisonExp>;
  audience_split?: InputMaybe<AudienceSplitsBoolExp>;
  calculated_at?: InputMaybe<TimestamptzComparisonExp>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metric_value?: InputMaybe<FloatComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  split_id?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "goal_metrics" */
export type GoalMetricsMaxOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  calculated_at?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  split_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "goal_metrics" */
export type GoalMetricsMinOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  calculated_at?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  split_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "goal_metrics" */
export type GoalMetricsMutationResponse = {
  __typename?: 'goal_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GoalMetrics>;
};

/** Ordering options when selecting data from "goal_metrics". */
export type GoalMetricsOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  audience_split?: InputMaybe<AudienceSplitsOrderBy>;
  calculated_at?: InputMaybe<OrderBy>;
  goal?: InputMaybe<GoalsOrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  split_id?: InputMaybe<OrderBy>;
};

/** select columns of table "goal_metrics" */
export const GoalMetricsSelectColumn = {
  /** column name */
  AudienceContributionSize: 'audience_contribution_size',
  /** column name */
  CalculatedAt: 'calculated_at',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  Id: 'id',
  /** column name */
  MetricValue: 'metric_value',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SplitId: 'split_id'
} as const;

export type GoalMetricsSelectColumn = typeof GoalMetricsSelectColumn[keyof typeof GoalMetricsSelectColumn];
/** order by stddev() on columns of table "goal_metrics" */
export type GoalMetricsStddevOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "goal_metrics" */
export type GoalMetricsStddevPopOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "goal_metrics" */
export type GoalMetricsStddevSampOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "goal_metrics" */
export type GoalMetricsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GoalMetricsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoalMetricsStreamCursorValueInput = {
  audience_contribution_size?: InputMaybe<Scalars['Int']>;
  calculated_at?: InputMaybe<Scalars['timestamptz']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  metric_value?: InputMaybe<Scalars['Float']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  split_id?: InputMaybe<Scalars['uuid']>;
};

/** order by sum() on columns of table "goal_metrics" */
export type GoalMetricsSumOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "goal_metrics" */
export type GoalMetricsVarPopOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "goal_metrics" */
export type GoalMetricsVarSampOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "goal_metrics" */
export type GoalMetricsVarianceOrderBy = {
  audience_contribution_size?: InputMaybe<OrderBy>;
  metric_value?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "goals" */
export type Goals = {
  __typename?: 'goals';
  aggregation: Scalars['String'];
  attribution_window: Scalars['jsonb'];
  audience_aggregation: Scalars['String'];
  /** An array relationship */
  audience_goals: Array<AudienceGoals>;
  /** An aggregate relationship */
  audience_goals_aggregate: AudienceGoalsAggregate;
  /** An array relationship */
  audience_primary_metrics: Array<AudiencePrimaryMetrics>;
  /** An aggregate relationship */
  audience_primary_metrics_aggregate: AudiencePrimaryMetricsAggregate;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  /** An array relationship */
  goal_metrics: Array<GoalMetrics>;
  /** An array relationship */
  goals_attribution_methods: Array<GoalsAttributionMethods>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "goals" */
export type GoalsAttributionWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goals" */
export type GoalsAudienceGoalsArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


/** columns and relationships of "goals" */
export type GoalsAudienceGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


/** columns and relationships of "goals" */
export type GoalsAudiencePrimaryMetricsArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


/** columns and relationships of "goals" */
export type GoalsAudiencePrimaryMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


/** columns and relationships of "goals" */
export type GoalsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goals" */
export type GoalsGoalMetricsArgs = {
  distinct_on?: InputMaybe<Array<GoalMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalMetricsOrderBy>>;
  where?: InputMaybe<GoalMetricsBoolExp>;
};


/** columns and relationships of "goals" */
export type GoalsGoalsAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<GoalsAttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsAttributionMethodsOrderBy>>;
  where?: InputMaybe<GoalsAttributionMethodsBoolExp>;
};

/** aggregated selection of "goals" */
export type GoalsAggregate = {
  __typename?: 'goals_aggregate';
  aggregate?: Maybe<GoalsAggregateFields>;
  nodes: Array<Goals>;
};

export type GoalsAggregateBoolExp = {
  bool_and?: InputMaybe<GoalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<GoalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<GoalsAggregateBoolExpCount>;
};

export type GoalsAggregateBoolExpBoolAnd = {
  arguments: GoalsSelectColumnGoalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GoalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GoalsAggregateBoolExpBoolOr = {
  arguments: GoalsSelectColumnGoalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GoalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type GoalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<GoalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "goals" */
export type GoalsAggregateFields = {
  __typename?: 'goals_aggregate_fields';
  avg?: Maybe<GoalsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<GoalsMaxFields>;
  min?: Maybe<GoalsMinFields>;
  stddev?: Maybe<GoalsStddevFields>;
  stddev_pop?: Maybe<GoalsStddevPopFields>;
  stddev_samp?: Maybe<GoalsStddevSampFields>;
  sum?: Maybe<GoalsSumFields>;
  var_pop?: Maybe<GoalsVarPopFields>;
  var_samp?: Maybe<GoalsVarSampFields>;
  variance?: Maybe<GoalsVarianceFields>;
};


/** aggregate fields of "goals" */
export type GoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<GoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "goals" */
export type GoalsAggregateOrderBy = {
  avg?: InputMaybe<GoalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoalsMaxOrderBy>;
  min?: InputMaybe<GoalsMinOrderBy>;
  stddev?: InputMaybe<GoalsStddevOrderBy>;
  stddev_pop?: InputMaybe<GoalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<GoalsStddevSampOrderBy>;
  sum?: InputMaybe<GoalsSumOrderBy>;
  var_pop?: InputMaybe<GoalsVarPopOrderBy>;
  var_samp?: InputMaybe<GoalsVarSampOrderBy>;
  variance?: InputMaybe<GoalsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GoalsAppendInput = {
  attribution_window?: InputMaybe<Scalars['jsonb']>;
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "goals" */
export type GoalsArrRelInsertInput = {
  data: Array<GoalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GoalsOnConflict>;
};

/** columns and relationships of "goals_attribution_methods" */
export type GoalsAttributionMethods = {
  __typename?: 'goals_attribution_methods';
  /** An object relationship */
  attribution_method: AttributionMethods;
  attribution_method_id: Scalars['uuid'];
  /** An object relationship */
  goal: Goals;
  goal_id: Scalars['uuid'];
};

/** order by aggregate values of table "goals_attribution_methods" */
export type GoalsAttributionMethodsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GoalsAttributionMethodsMaxOrderBy>;
  min?: InputMaybe<GoalsAttributionMethodsMinOrderBy>;
};

/** input type for inserting array relation for remote table "goals_attribution_methods" */
export type GoalsAttributionMethodsArrRelInsertInput = {
  data: Array<GoalsAttributionMethodsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GoalsAttributionMethodsOnConflict>;
};

/** Boolean expression to filter rows from the table "goals_attribution_methods". All fields are combined with a logical 'AND'. */
export type GoalsAttributionMethodsBoolExp = {
  _and?: InputMaybe<Array<GoalsAttributionMethodsBoolExp>>;
  _not?: InputMaybe<GoalsAttributionMethodsBoolExp>;
  _or?: InputMaybe<Array<GoalsAttributionMethodsBoolExp>>;
  attribution_method?: InputMaybe<AttributionMethodsBoolExp>;
  attribution_method_id?: InputMaybe<UuidComparisonExp>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "goals_attribution_methods" */
export const GoalsAttributionMethodsConstraint = {
  /** unique or primary key constraint on columns "attribution_method_id", "goal_id" */
  GoalsAttributionMethodsPkey: 'goals_attribution_methods_pkey'
} as const;

export type GoalsAttributionMethodsConstraint = typeof GoalsAttributionMethodsConstraint[keyof typeof GoalsAttributionMethodsConstraint];
/** input type for inserting data into table "goals_attribution_methods" */
export type GoalsAttributionMethodsInsertInput = {
  attribution_method?: InputMaybe<AttributionMethodsObjRelInsertInput>;
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal?: InputMaybe<GoalsObjRelInsertInput>;
  goal_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "goals_attribution_methods" */
export type GoalsAttributionMethodsMaxOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "goals_attribution_methods" */
export type GoalsAttributionMethodsMinOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "goals_attribution_methods" */
export type GoalsAttributionMethodsMutationResponse = {
  __typename?: 'goals_attribution_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GoalsAttributionMethods>;
};

/** on_conflict condition type for table "goals_attribution_methods" */
export type GoalsAttributionMethodsOnConflict = {
  constraint: GoalsAttributionMethodsConstraint;
  update_columns?: Array<GoalsAttributionMethodsUpdateColumn>;
  where?: InputMaybe<GoalsAttributionMethodsBoolExp>;
};

/** Ordering options when selecting data from "goals_attribution_methods". */
export type GoalsAttributionMethodsOrderBy = {
  attribution_method?: InputMaybe<AttributionMethodsOrderBy>;
  attribution_method_id?: InputMaybe<OrderBy>;
  goal?: InputMaybe<GoalsOrderBy>;
  goal_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: goals_attribution_methods */
export type GoalsAttributionMethodsPkColumnsInput = {
  attribution_method_id: Scalars['uuid'];
  goal_id: Scalars['uuid'];
};

/** select columns of table "goals_attribution_methods" */
export const GoalsAttributionMethodsSelectColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  GoalId: 'goal_id'
} as const;

export type GoalsAttributionMethodsSelectColumn = typeof GoalsAttributionMethodsSelectColumn[keyof typeof GoalsAttributionMethodsSelectColumn];
/** input type for updating data in table "goals_attribution_methods" */
export type GoalsAttributionMethodsSetInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "goals_attribution_methods" */
export type GoalsAttributionMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GoalsAttributionMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoalsAttributionMethodsStreamCursorValueInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "goals_attribution_methods" */
export const GoalsAttributionMethodsUpdateColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  GoalId: 'goal_id'
} as const;

export type GoalsAttributionMethodsUpdateColumn = typeof GoalsAttributionMethodsUpdateColumn[keyof typeof GoalsAttributionMethodsUpdateColumn];
export type GoalsAttributionMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GoalsAttributionMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: GoalsAttributionMethodsBoolExp;
};

/** aggregate avg on columns */
export type GoalsAvgFields = {
  __typename?: 'goals_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "goals" */
export type GoalsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "goals". All fields are combined with a logical 'AND'. */
export type GoalsBoolExp = {
  _and?: InputMaybe<Array<GoalsBoolExp>>;
  _not?: InputMaybe<GoalsBoolExp>;
  _or?: InputMaybe<Array<GoalsBoolExp>>;
  aggregation?: InputMaybe<StringComparisonExp>;
  attribution_window?: InputMaybe<JsonbComparisonExp>;
  audience_aggregation?: InputMaybe<StringComparisonExp>;
  audience_goals?: InputMaybe<AudienceGoalsBoolExp>;
  audience_goals_aggregate?: InputMaybe<AudienceGoalsAggregateBoolExp>;
  audience_primary_metrics?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
  audience_primary_metrics_aggregate?: InputMaybe<AudiencePrimaryMetricsAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  goal_metrics?: InputMaybe<GoalMetricsBoolExp>;
  goals_attribution_methods?: InputMaybe<GoalsAttributionMethodsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "goals" */
export const GoalsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  GoalsIdWorkspaceIdKey: 'goals_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  GoalsPkey: 'goals_pkey',
  /** unique or primary key constraint on columns "parent_model_id" */
  GoalsPredefinedMetricUniqueIndex: 'goals_predefined_metric_unique_index'
} as const;

export type GoalsConstraint = typeof GoalsConstraint[keyof typeof GoalsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GoalsDeleteAtPathInput = {
  attribution_window?: InputMaybe<Array<Scalars['String']>>;
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GoalsDeleteElemInput = {
  attribution_window?: InputMaybe<Scalars['Int']>;
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GoalsDeleteKeyInput = {
  attribution_window?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "goals" */
export type GoalsIncInput = {
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "goals" */
export type GoalsInsertInput = {
  aggregation?: InputMaybe<Scalars['String']>;
  attribution_window?: InputMaybe<Scalars['jsonb']>;
  audience_aggregation?: InputMaybe<Scalars['String']>;
  audience_goals?: InputMaybe<AudienceGoalsArrRelInsertInput>;
  audience_primary_metrics?: InputMaybe<AudiencePrimaryMetricsArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  goals_attribution_methods?: InputMaybe<GoalsAttributionMethodsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type GoalsMaxFields = {
  __typename?: 'goals_max_fields';
  aggregation?: Maybe<Scalars['String']>;
  audience_aggregation?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "goals" */
export type GoalsMaxOrderBy = {
  aggregation?: InputMaybe<OrderBy>;
  audience_aggregation?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GoalsMinFields = {
  __typename?: 'goals_min_fields';
  aggregation?: Maybe<Scalars['String']>;
  audience_aggregation?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "goals" */
export type GoalsMinOrderBy = {
  aggregation?: InputMaybe<OrderBy>;
  audience_aggregation?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "goals" */
export type GoalsMutationResponse = {
  __typename?: 'goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Goals>;
};

/** input type for inserting object relation for remote table "goals" */
export type GoalsObjRelInsertInput = {
  data: GoalsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GoalsOnConflict>;
};

/** on_conflict condition type for table "goals" */
export type GoalsOnConflict = {
  constraint: GoalsConstraint;
  update_columns?: Array<GoalsUpdateColumn>;
  where?: InputMaybe<GoalsBoolExp>;
};

/** Ordering options when selecting data from "goals". */
export type GoalsOrderBy = {
  aggregation?: InputMaybe<OrderBy>;
  attribution_window?: InputMaybe<OrderBy>;
  audience_aggregation?: InputMaybe<OrderBy>;
  audience_goals_aggregate?: InputMaybe<AudienceGoalsAggregateOrderBy>;
  audience_primary_metrics_aggregate?: InputMaybe<AudiencePrimaryMetricsAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  goal_metrics_aggregate?: InputMaybe<GoalMetricsAggregateOrderBy>;
  goals_attribution_methods_aggregate?: InputMaybe<GoalsAttributionMethodsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: goals */
export type GoalsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GoalsPrependInput = {
  attribution_window?: InputMaybe<Scalars['jsonb']>;
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "goals" */
export const GoalsSelectColumn = {
  /** column name */
  Aggregation: 'aggregation',
  /** column name */
  AttributionWindow: 'attribution_window',
  /** column name */
  AudienceAggregation: 'audience_aggregation',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type GoalsSelectColumn = typeof GoalsSelectColumn[keyof typeof GoalsSelectColumn];
/** select "goals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "goals" */
export const GoalsSelectColumnGoalsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type GoalsSelectColumnGoalsAggregateBoolExpBoolAndArgumentsColumns = typeof GoalsSelectColumnGoalsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof GoalsSelectColumnGoalsAggregateBoolExpBoolAndArgumentsColumns];
/** select "goals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "goals" */
export const GoalsSelectColumnGoalsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type GoalsSelectColumnGoalsAggregateBoolExpBoolOrArgumentsColumns = typeof GoalsSelectColumnGoalsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof GoalsSelectColumnGoalsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "goals" */
export type GoalsSetInput = {
  aggregation?: InputMaybe<Scalars['String']>;
  attribution_window?: InputMaybe<Scalars['jsonb']>;
  audience_aggregation?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type GoalsStddevFields = {
  __typename?: 'goals_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "goals" */
export type GoalsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GoalsStddevPopFields = {
  __typename?: 'goals_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "goals" */
export type GoalsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GoalsStddevSampFields = {
  __typename?: 'goals_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "goals" */
export type GoalsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "goals" */
export type GoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: GoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GoalsStreamCursorValueInput = {
  aggregation?: InputMaybe<Scalars['String']>;
  attribution_window?: InputMaybe<Scalars['jsonb']>;
  audience_aggregation?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type GoalsSumFields = {
  __typename?: 'goals_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "goals" */
export type GoalsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "goals" */
export const GoalsUpdateColumn = {
  /** column name */
  Aggregation: 'aggregation',
  /** column name */
  AttributionWindow: 'attribution_window',
  /** column name */
  AudienceAggregation: 'audience_aggregation',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id'
} as const;

export type GoalsUpdateColumn = typeof GoalsUpdateColumn[keyof typeof GoalsUpdateColumn];
export type GoalsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<GoalsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<GoalsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<GoalsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<GoalsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GoalsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<GoalsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GoalsSetInput>;
  /** filter the rows which have to be updated */
  where: GoalsBoolExp;
};

/** aggregate var_pop on columns */
export type GoalsVarPopFields = {
  __typename?: 'goals_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "goals" */
export type GoalsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GoalsVarSampFields = {
  __typename?: 'goals_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "goals" */
export type GoalsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type GoalsVarianceFields = {
  __typename?: 'goals_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "goals" */
export type GoalsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "idr" */
export type Idr = {
  __typename?: 'idr';
  block_rules?: Maybe<Scalars['jsonb']>;
  connection_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  description?: Maybe<Scalars['String']>;
  full_rerun?: Maybe<Scalars['Boolean']>;
  householding_enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  merge_rules?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  models: Array<IdrModels>;
  name: Scalars['String'];
  on_complete_sql?: Maybe<Scalars['String']>;
  output_schema?: Maybe<Scalars['String']>;
  output_table: Scalars['String'];
  pending_blocklist_count: Scalars['Int'];
  probabilistic_config?: Maybe<Scalars['jsonb']>;
  resolution_rules?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  runs: Array<IdrRuns>;
  /** An aggregate relationship */
  runs_aggregate: IdrRunsAggregate;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  schedule_updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  scheduled_syncs: Array<SyncIdrSchedules>;
  /** An aggregate relationship */
  scheduled_syncs_aggregate: SyncIdrSchedulesAggregate;
  /** An object relationship */
  source: Connections;
  state: Scalars['String'];
  /** An array relationship */
  training_runs: Array<IdrTrainingRuns>;
  /** An aggregate relationship */
  training_runs_aggregate: IdrTrainingRunsAggregate;
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  version?: Maybe<Scalars['Int']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "idr" */
export type IdrBlockRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr" */
export type IdrMergeRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr" */
export type IdrModelsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelsOrderBy>>;
  where?: InputMaybe<IdrModelsBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrProbabilisticConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr" */
export type IdrResolutionRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr" */
export type IdrRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr" */
export type IdrScheduledSyncsArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrScheduledSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrTrainingRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


/** columns and relationships of "idr" */
export type IdrTrainingRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};

/** Boolean expression to filter rows from the table "idr". All fields are combined with a logical 'AND'. */
export type IdrBoolExp = {
  _and?: InputMaybe<Array<IdrBoolExp>>;
  _not?: InputMaybe<IdrBoolExp>;
  _or?: InputMaybe<Array<IdrBoolExp>>;
  block_rules?: InputMaybe<JsonbComparisonExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  full_rerun?: InputMaybe<BooleanComparisonExp>;
  householding_enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  merge_rules?: InputMaybe<JsonbComparisonExp>;
  models?: InputMaybe<IdrModelsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  on_complete_sql?: InputMaybe<StringComparisonExp>;
  output_schema?: InputMaybe<StringComparisonExp>;
  output_table?: InputMaybe<StringComparisonExp>;
  pending_blocklist_count?: InputMaybe<IntComparisonExp>;
  probabilistic_config?: InputMaybe<JsonbComparisonExp>;
  resolution_rules?: InputMaybe<JsonbComparisonExp>;
  runs?: InputMaybe<IdrRunsBoolExp>;
  runs_aggregate?: InputMaybe<IdrRunsAggregateBoolExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  schedule_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  scheduled_syncs?: InputMaybe<SyncIdrSchedulesBoolExp>;
  scheduled_syncs_aggregate?: InputMaybe<SyncIdrSchedulesAggregateBoolExp>;
  source?: InputMaybe<ConnectionsBoolExp>;
  state?: InputMaybe<StringComparisonExp>;
  training_runs?: InputMaybe<IdrTrainingRunsBoolExp>;
  training_runs_aggregate?: InputMaybe<IdrTrainingRunsAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** columns and relationships of "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumns = {
  __typename?: 'idr_golden_record_base_columns';
  column_name: Scalars['String'];
  golden_record_id: Scalars['uuid'];
  /** An object relationship */
  idr_golden_record: IdrGoldenRecords;
  idr_model_id: Scalars['uuid'];
  /** An object relationship */
  model?: Maybe<Segments>;
  model_id: Scalars['bigint'];
};

/** order by aggregate values of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsAggregateOrderBy = {
  avg?: InputMaybe<IdrGoldenRecordBaseColumnsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrGoldenRecordBaseColumnsMaxOrderBy>;
  min?: InputMaybe<IdrGoldenRecordBaseColumnsMinOrderBy>;
  stddev?: InputMaybe<IdrGoldenRecordBaseColumnsStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrGoldenRecordBaseColumnsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrGoldenRecordBaseColumnsStddevSampOrderBy>;
  sum?: InputMaybe<IdrGoldenRecordBaseColumnsSumOrderBy>;
  var_pop?: InputMaybe<IdrGoldenRecordBaseColumnsVarPopOrderBy>;
  var_samp?: InputMaybe<IdrGoldenRecordBaseColumnsVarSampOrderBy>;
  variance?: InputMaybe<IdrGoldenRecordBaseColumnsVarianceOrderBy>;
};

/** order by avg() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_golden_record_base_columns". All fields are combined with a logical 'AND'. */
export type IdrGoldenRecordBaseColumnsBoolExp = {
  _and?: InputMaybe<Array<IdrGoldenRecordBaseColumnsBoolExp>>;
  _not?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
  _or?: InputMaybe<Array<IdrGoldenRecordBaseColumnsBoolExp>>;
  column_name?: InputMaybe<StringComparisonExp>;
  golden_record_id?: InputMaybe<UuidComparisonExp>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsBoolExp>;
  idr_model_id?: InputMaybe<UuidComparisonExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsMaxOrderBy = {
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsMinOrderBy = {
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_golden_record_base_columns". */
export type IdrGoldenRecordBaseColumnsOrderBy = {
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsOrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_golden_record_base_columns" */
export const IdrGoldenRecordBaseColumnsSelectColumn = {
  /** column name */
  ColumnName: 'column_name',
  /** column name */
  GoldenRecordId: 'golden_record_id',
  /** column name */
  IdrModelId: 'idr_model_id',
  /** column name */
  ModelId: 'model_id'
} as const;

export type IdrGoldenRecordBaseColumnsSelectColumn = typeof IdrGoldenRecordBaseColumnsSelectColumn[keyof typeof IdrGoldenRecordBaseColumnsSelectColumn];
/** order by stddev() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrGoldenRecordBaseColumnsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrGoldenRecordBaseColumnsStreamCursorValueInput = {
  column_name?: InputMaybe<Scalars['String']>;
  golden_record_id?: InputMaybe<Scalars['uuid']>;
  idr_model_id?: InputMaybe<Scalars['uuid']>;
  model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "idr_golden_record_base_columns" */
export type IdrGoldenRecordBaseColumnsVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorship = {
  __typename?: 'idr_golden_record_column_source_survivorship';
  golden_record_column_id: Scalars['uuid'];
  golden_record_id: Scalars['uuid'];
  /** An object relationship */
  idr_golden_record: IdrGoldenRecords;
  /** An object relationship */
  idr_model: IdrModels;
  idr_model_id: Scalars['uuid'];
  rank: Scalars['Int'];
  survivorship_rule_type: Scalars['String'];
};

/** order by aggregate values of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipAggregateOrderBy = {
  avg?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipMaxOrderBy>;
  min?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipMinOrderBy>;
  stddev?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipStddevSampOrderBy>;
  sum?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipSumOrderBy>;
  var_pop?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipVarPopOrderBy>;
  var_samp?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipVarSampOrderBy>;
  variance?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipVarianceOrderBy>;
};

/** order by avg() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipAvgOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_golden_record_column_source_survivorship". All fields are combined with a logical 'AND'. */
export type IdrGoldenRecordColumnSourceSurvivorshipBoolExp = {
  _and?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>>;
  _not?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
  _or?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>>;
  golden_record_column_id?: InputMaybe<UuidComparisonExp>;
  golden_record_id?: InputMaybe<UuidComparisonExp>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsBoolExp>;
  idr_model?: InputMaybe<IdrModelsBoolExp>;
  idr_model_id?: InputMaybe<UuidComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  survivorship_rule_type?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipMaxOrderBy = {
  golden_record_column_id?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipMinOrderBy = {
  golden_record_column_id?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_golden_record_column_source_survivorship". */
export type IdrGoldenRecordColumnSourceSurvivorshipOrderBy = {
  golden_record_column_id?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsOrderBy>;
  idr_model?: InputMaybe<IdrModelsOrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_golden_record_column_source_survivorship" */
export const IdrGoldenRecordColumnSourceSurvivorshipSelectColumn = {
  /** column name */
  GoldenRecordColumnId: 'golden_record_column_id',
  /** column name */
  GoldenRecordId: 'golden_record_id',
  /** column name */
  IdrModelId: 'idr_model_id',
  /** column name */
  Rank: 'rank',
  /** column name */
  SurvivorshipRuleType: 'survivorship_rule_type'
} as const;

export type IdrGoldenRecordColumnSourceSurvivorshipSelectColumn = typeof IdrGoldenRecordColumnSourceSurvivorshipSelectColumn[keyof typeof IdrGoldenRecordColumnSourceSurvivorshipSelectColumn];
/** order by stddev() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipStddevOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipStddevPopOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipStddevSampOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrGoldenRecordColumnSourceSurvivorshipStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrGoldenRecordColumnSourceSurvivorshipStreamCursorValueInput = {
  golden_record_column_id?: InputMaybe<Scalars['uuid']>;
  golden_record_id?: InputMaybe<Scalars['uuid']>;
  idr_model_id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Int']>;
  survivorship_rule_type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipSumOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipVarPopOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipVarSampOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "idr_golden_record_column_source_survivorship" */
export type IdrGoldenRecordColumnSourceSurvivorshipVarianceOrderBy = {
  rank?: InputMaybe<OrderBy>;
};

/** columns and relationships of "idr_golden_record_columns" */
export type IdrGoldenRecordColumns = {
  __typename?: 'idr_golden_record_columns';
  alias?: Maybe<Scalars['String']>;
  column_name: Scalars['String'];
  golden_record_id: Scalars['uuid'];
  id: Scalars['uuid'];
  identifier?: Maybe<Scalars['String']>;
  /** An object relationship */
  idr_golden_record: IdrGoldenRecords;
  /** An array relationship */
  idr_golden_record_column_source_survivorships: Array<IdrGoldenRecordColumnSourceSurvivorship>;
  survivorship_rule_type: Scalars['String'];
};


/** columns and relationships of "idr_golden_record_columns" */
export type IdrGoldenRecordColumnsIdrGoldenRecordColumnSourceSurvivorshipsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
};

/** order by aggregate values of table "idr_golden_record_columns" */
export type IdrGoldenRecordColumnsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrGoldenRecordColumnsMaxOrderBy>;
  min?: InputMaybe<IdrGoldenRecordColumnsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "idr_golden_record_columns". All fields are combined with a logical 'AND'. */
export type IdrGoldenRecordColumnsBoolExp = {
  _and?: InputMaybe<Array<IdrGoldenRecordColumnsBoolExp>>;
  _not?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
  _or?: InputMaybe<Array<IdrGoldenRecordColumnsBoolExp>>;
  alias?: InputMaybe<StringComparisonExp>;
  column_name?: InputMaybe<StringComparisonExp>;
  golden_record_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  identifier?: InputMaybe<StringComparisonExp>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsBoolExp>;
  idr_golden_record_column_source_survivorships?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
  survivorship_rule_type?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "idr_golden_record_columns" */
export type IdrGoldenRecordColumnsMaxOrderBy = {
  alias?: InputMaybe<OrderBy>;
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "idr_golden_record_columns" */
export type IdrGoldenRecordColumnsMinOrderBy = {
  alias?: InputMaybe<OrderBy>;
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_golden_record_columns". */
export type IdrGoldenRecordColumnsOrderBy = {
  alias?: InputMaybe<OrderBy>;
  column_name?: InputMaybe<OrderBy>;
  golden_record_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  idr_golden_record?: InputMaybe<IdrGoldenRecordsOrderBy>;
  idr_golden_record_column_source_survivorships_aggregate?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipAggregateOrderBy>;
  survivorship_rule_type?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_golden_record_columns" */
export const IdrGoldenRecordColumnsSelectColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  ColumnName: 'column_name',
  /** column name */
  GoldenRecordId: 'golden_record_id',
  /** column name */
  Id: 'id',
  /** column name */
  Identifier: 'identifier',
  /** column name */
  SurvivorshipRuleType: 'survivorship_rule_type'
} as const;

export type IdrGoldenRecordColumnsSelectColumn = typeof IdrGoldenRecordColumnsSelectColumn[keyof typeof IdrGoldenRecordColumnsSelectColumn];
/** Streaming cursor of the table "idr_golden_record_columns" */
export type IdrGoldenRecordColumnsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrGoldenRecordColumnsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrGoldenRecordColumnsStreamCursorValueInput = {
  alias?: InputMaybe<Scalars['String']>;
  column_name?: InputMaybe<Scalars['String']>;
  golden_record_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  identifier?: InputMaybe<Scalars['String']>;
  survivorship_rule_type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "idr_golden_records" */
export type IdrGoldenRecords = {
  __typename?: 'idr_golden_records';
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  idr_golden_record_base_columns: Array<IdrGoldenRecordBaseColumns>;
  /** An array relationship */
  idr_golden_record_columns: Array<IdrGoldenRecordColumns>;
  /** An object relationship */
  idr_graph: Idr;
  idr_id: Scalars['uuid'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  primary_key?: Maybe<IdrGoldenRecordColumns>;
  primary_key_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  primary_label?: Maybe<IdrGoldenRecordColumns>;
  primary_label_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  secondary_label?: Maybe<IdrGoldenRecordColumns>;
  secondary_label_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "idr_golden_records" */
export type IdrGoldenRecordsIdrGoldenRecordBaseColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordBaseColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordBaseColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
};


/** columns and relationships of "idr_golden_records" */
export type IdrGoldenRecordsIdrGoldenRecordColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
};

/** Boolean expression to filter rows from the table "idr_golden_records". All fields are combined with a logical 'AND'. */
export type IdrGoldenRecordsBoolExp = {
  _and?: InputMaybe<Array<IdrGoldenRecordsBoolExp>>;
  _not?: InputMaybe<IdrGoldenRecordsBoolExp>;
  _or?: InputMaybe<Array<IdrGoldenRecordsBoolExp>>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr_golden_record_base_columns?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
  idr_golden_record_columns?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
  idr_graph?: InputMaybe<IdrBoolExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  primary_key?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
  primary_key_id?: InputMaybe<UuidComparisonExp>;
  primary_label?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
  primary_label_id?: InputMaybe<UuidComparisonExp>;
  secondary_label?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
  secondary_label_id?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "idr_golden_records". */
export type IdrGoldenRecordsOrderBy = {
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_golden_record_base_columns_aggregate?: InputMaybe<IdrGoldenRecordBaseColumnsAggregateOrderBy>;
  idr_golden_record_columns_aggregate?: InputMaybe<IdrGoldenRecordColumnsAggregateOrderBy>;
  idr_graph?: InputMaybe<IdrOrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  primary_key?: InputMaybe<IdrGoldenRecordColumnsOrderBy>;
  primary_key_id?: InputMaybe<OrderBy>;
  primary_label?: InputMaybe<IdrGoldenRecordColumnsOrderBy>;
  primary_label_id?: InputMaybe<OrderBy>;
  secondary_label?: InputMaybe<IdrGoldenRecordColumnsOrderBy>;
  secondary_label_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_golden_records" */
export const IdrGoldenRecordsSelectColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  PrimaryKeyId: 'primary_key_id',
  /** column name */
  PrimaryLabelId: 'primary_label_id',
  /** column name */
  SecondaryLabelId: 'secondary_label_id'
} as const;

export type IdrGoldenRecordsSelectColumn = typeof IdrGoldenRecordsSelectColumn[keyof typeof IdrGoldenRecordsSelectColumn];
/** Streaming cursor of the table "idr_golden_records" */
export type IdrGoldenRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrGoldenRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrGoldenRecordsStreamCursorValueInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  idr_id?: InputMaybe<Scalars['uuid']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  primary_key_id?: InputMaybe<Scalars['uuid']>;
  primary_label_id?: InputMaybe<Scalars['uuid']>;
  secondary_label_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "idr_model_mappings" */
export type IdrModelMappings = {
  __typename?: 'idr_model_mappings';
  column: Scalars['String'];
  identifier: Scalars['String'];
  /** An object relationship */
  idr_model: IdrModels;
  idr_model_id: Scalars['uuid'];
  /** An object relationship */
  model_column?: Maybe<ModelColumns>;
  model_id: Scalars['bigint'];
};

/** order by aggregate values of table "idr_model_mappings" */
export type IdrModelMappingsAggregateOrderBy = {
  avg?: InputMaybe<IdrModelMappingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrModelMappingsMaxOrderBy>;
  min?: InputMaybe<IdrModelMappingsMinOrderBy>;
  stddev?: InputMaybe<IdrModelMappingsStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrModelMappingsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrModelMappingsStddevSampOrderBy>;
  sum?: InputMaybe<IdrModelMappingsSumOrderBy>;
  var_pop?: InputMaybe<IdrModelMappingsVarPopOrderBy>;
  var_samp?: InputMaybe<IdrModelMappingsVarSampOrderBy>;
  variance?: InputMaybe<IdrModelMappingsVarianceOrderBy>;
};

/** order by avg() on columns of table "idr_model_mappings" */
export type IdrModelMappingsAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_model_mappings". All fields are combined with a logical 'AND'. */
export type IdrModelMappingsBoolExp = {
  _and?: InputMaybe<Array<IdrModelMappingsBoolExp>>;
  _not?: InputMaybe<IdrModelMappingsBoolExp>;
  _or?: InputMaybe<Array<IdrModelMappingsBoolExp>>;
  column?: InputMaybe<StringComparisonExp>;
  identifier?: InputMaybe<StringComparisonExp>;
  idr_model?: InputMaybe<IdrModelsBoolExp>;
  idr_model_id?: InputMaybe<UuidComparisonExp>;
  model_column?: InputMaybe<ModelColumnsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "idr_model_mappings" */
export type IdrModelMappingsMaxOrderBy = {
  column?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "idr_model_mappings" */
export type IdrModelMappingsMinOrderBy = {
  column?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_model_mappings". */
export type IdrModelMappingsOrderBy = {
  column?: InputMaybe<OrderBy>;
  identifier?: InputMaybe<OrderBy>;
  idr_model?: InputMaybe<IdrModelsOrderBy>;
  idr_model_id?: InputMaybe<OrderBy>;
  model_column?: InputMaybe<ModelColumnsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_model_mappings" */
export const IdrModelMappingsSelectColumn = {
  /** column name */
  Column: 'column',
  /** column name */
  Identifier: 'identifier',
  /** column name */
  IdrModelId: 'idr_model_id',
  /** column name */
  ModelId: 'model_id'
} as const;

export type IdrModelMappingsSelectColumn = typeof IdrModelMappingsSelectColumn[keyof typeof IdrModelMappingsSelectColumn];
/** order by stddev() on columns of table "idr_model_mappings" */
export type IdrModelMappingsStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "idr_model_mappings" */
export type IdrModelMappingsStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "idr_model_mappings" */
export type IdrModelMappingsStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_model_mappings" */
export type IdrModelMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrModelMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrModelMappingsStreamCursorValueInput = {
  column?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  idr_model_id?: InputMaybe<Scalars['uuid']>;
  model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "idr_model_mappings" */
export type IdrModelMappingsSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "idr_model_mappings" */
export type IdrModelMappingsVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "idr_model_mappings" */
export type IdrModelMappingsVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "idr_model_mappings" */
export type IdrModelMappingsVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "idr_models" */
export type IdrModels = {
  __typename?: 'idr_models';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  /** An object relationship */
  customer_studio_model?: Maybe<Segments>;
  filter?: Maybe<Scalars['jsonb']>;
  golden_record_base_survivorship_rule_type?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  idr: Idr;
  idr_id: Scalars['uuid'];
  /** An array relationship */
  mappings: Array<IdrModelMappings>;
  /** An object relationship */
  model: Segments;
  order_by?: Maybe<Scalars['jsonb']>;
  rank: Scalars['Int'];
  scope_column?: Maybe<Scalars['String']>;
  segment_id: Scalars['bigint'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  watermark_lookback_days?: Maybe<Scalars['Int']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "idr_models" */
export type IdrModelsFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr_models" */
export type IdrModelsMappingsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelMappingsOrderBy>>;
  where?: InputMaybe<IdrModelMappingsBoolExp>;
};


/** columns and relationships of "idr_models" */
export type IdrModelsOrderByArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "idr_models" */
export type IdrModelsAggregateOrderBy = {
  avg?: InputMaybe<IdrModelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrModelsMaxOrderBy>;
  min?: InputMaybe<IdrModelsMinOrderBy>;
  stddev?: InputMaybe<IdrModelsStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrModelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrModelsStddevSampOrderBy>;
  sum?: InputMaybe<IdrModelsSumOrderBy>;
  var_pop?: InputMaybe<IdrModelsVarPopOrderBy>;
  var_samp?: InputMaybe<IdrModelsVarSampOrderBy>;
  variance?: InputMaybe<IdrModelsVarianceOrderBy>;
};

/** order by avg() on columns of table "idr_models" */
export type IdrModelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_models". All fields are combined with a logical 'AND'. */
export type IdrModelsBoolExp = {
  _and?: InputMaybe<Array<IdrModelsBoolExp>>;
  _not?: InputMaybe<IdrModelsBoolExp>;
  _or?: InputMaybe<Array<IdrModelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  customer_studio_model?: InputMaybe<SegmentsBoolExp>;
  filter?: InputMaybe<JsonbComparisonExp>;
  golden_record_base_survivorship_rule_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr?: InputMaybe<IdrBoolExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  mappings?: InputMaybe<IdrModelMappingsBoolExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  order_by?: InputMaybe<JsonbComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  scope_column?: InputMaybe<StringComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  watermark_lookback_days?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "idr_models" */
export type IdrModelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  golden_record_base_survivorship_rule_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  scope_column?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "idr_models" */
export type IdrModelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  golden_record_base_survivorship_rule_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  scope_column?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_models". */
export type IdrModelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  customer_studio_model?: InputMaybe<SegmentsOrderBy>;
  filter?: InputMaybe<OrderBy>;
  golden_record_base_survivorship_rule_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr?: InputMaybe<IdrOrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  mappings_aggregate?: InputMaybe<IdrModelMappingsAggregateOrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  order_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  scope_column?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_models" */
export const IdrModelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Filter: 'filter',
  /** column name */
  GoldenRecordBaseSurvivorshipRuleType: 'golden_record_base_survivorship_rule_type',
  /** column name */
  Id: 'id',
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  OrderBy: 'order_by',
  /** column name */
  Rank: 'rank',
  /** column name */
  ScopeColumn: 'scope_column',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WatermarkLookbackDays: 'watermark_lookback_days',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IdrModelsSelectColumn = typeof IdrModelsSelectColumn[keyof typeof IdrModelsSelectColumn];
/** order by stddev() on columns of table "idr_models" */
export type IdrModelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "idr_models" */
export type IdrModelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "idr_models" */
export type IdrModelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_models" */
export type IdrModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrModelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  filter?: InputMaybe<Scalars['jsonb']>;
  golden_record_base_survivorship_rule_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idr_id?: InputMaybe<Scalars['uuid']>;
  order_by?: InputMaybe<Scalars['jsonb']>;
  rank?: InputMaybe<Scalars['Int']>;
  scope_column?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  watermark_lookback_days?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "idr_models" */
export type IdrModelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "idr_models" */
export type IdrModelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "idr_models" */
export type IdrModelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "idr_models" */
export type IdrModelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  watermark_lookback_days?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr". */
export type IdrOrderBy = {
  block_rules?: InputMaybe<OrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  full_rerun?: InputMaybe<OrderBy>;
  householding_enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  merge_rules?: InputMaybe<OrderBy>;
  models_aggregate?: InputMaybe<IdrModelsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  on_complete_sql?: InputMaybe<OrderBy>;
  output_schema?: InputMaybe<OrderBy>;
  output_table?: InputMaybe<OrderBy>;
  pending_blocklist_count?: InputMaybe<OrderBy>;
  probabilistic_config?: InputMaybe<OrderBy>;
  resolution_rules?: InputMaybe<OrderBy>;
  runs_aggregate?: InputMaybe<IdrRunsAggregateOrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  schedule_updated_at?: InputMaybe<OrderBy>;
  scheduled_syncs_aggregate?: InputMaybe<SyncIdrSchedulesAggregateOrderBy>;
  source?: InputMaybe<ConnectionsOrderBy>;
  state?: InputMaybe<OrderBy>;
  training_runs_aggregate?: InputMaybe<IdrTrainingRunsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "idr_output_segments" */
export type IdrOutputSegments = {
  __typename?: 'idr_output_segments';
  /** An object relationship */
  idr?: Maybe<Idr>;
  idr_id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "idr_output_segments". All fields are combined with a logical 'AND'. */
export type IdrOutputSegmentsBoolExp = {
  _and?: InputMaybe<Array<IdrOutputSegmentsBoolExp>>;
  _not?: InputMaybe<IdrOutputSegmentsBoolExp>;
  _or?: InputMaybe<Array<IdrOutputSegmentsBoolExp>>;
  idr?: InputMaybe<IdrBoolExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "idr_output_segments". */
export type IdrOutputSegmentsOrderBy = {
  idr?: InputMaybe<IdrOrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_output_segments" */
export const IdrOutputSegmentsSelectColumn = {
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IdrOutputSegmentsSelectColumn = typeof IdrOutputSegmentsSelectColumn[keyof typeof IdrOutputSegmentsSelectColumn];
/** Streaming cursor of the table "idr_output_segments" */
export type IdrOutputSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrOutputSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrOutputSegmentsStreamCursorValueInput = {
  idr_id?: InputMaybe<Scalars['uuid']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "idr_runs" */
export type IdrRuns = {
  __typename?: 'idr_runs';
  config_snapshot?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['jsonb']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  full_rerun: Scalars['Boolean'];
  full_rerun_reason?: Maybe<Scalars['String']>;
  health?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  idr_id: Scalars['uuid'];
  ran_healthchecks: Scalars['Boolean'];
  started_at?: Maybe<Scalars['timestamptz']>;
  stats?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "idr_runs" */
export type IdrRunsConfigSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr_runs" */
export type IdrRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr_runs" */
export type IdrRunsHealthArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr_runs" */
export type IdrRunsStatsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "idr_runs" */
export type IdrRunsAggregate = {
  __typename?: 'idr_runs_aggregate';
  aggregate?: Maybe<IdrRunsAggregateFields>;
  nodes: Array<IdrRuns>;
};

export type IdrRunsAggregateBoolExp = {
  bool_and?: InputMaybe<IdrRunsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<IdrRunsAggregateBoolExpBoolOr>;
  count?: InputMaybe<IdrRunsAggregateBoolExpCount>;
};

export type IdrRunsAggregateBoolExpBoolAnd = {
  arguments: IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrRunsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IdrRunsAggregateBoolExpBoolOr = {
  arguments: IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrRunsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IdrRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IdrRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "idr_runs" */
export type IdrRunsAggregateFields = {
  __typename?: 'idr_runs_aggregate_fields';
  avg?: Maybe<IdrRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<IdrRunsMaxFields>;
  min?: Maybe<IdrRunsMinFields>;
  stddev?: Maybe<IdrRunsStddevFields>;
  stddev_pop?: Maybe<IdrRunsStddevPopFields>;
  stddev_samp?: Maybe<IdrRunsStddevSampFields>;
  sum?: Maybe<IdrRunsSumFields>;
  var_pop?: Maybe<IdrRunsVarPopFields>;
  var_samp?: Maybe<IdrRunsVarSampFields>;
  variance?: Maybe<IdrRunsVarianceFields>;
};


/** aggregate fields of "idr_runs" */
export type IdrRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IdrRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "idr_runs" */
export type IdrRunsAggregateOrderBy = {
  avg?: InputMaybe<IdrRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrRunsMaxOrderBy>;
  min?: InputMaybe<IdrRunsMinOrderBy>;
  stddev?: InputMaybe<IdrRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrRunsStddevSampOrderBy>;
  sum?: InputMaybe<IdrRunsSumOrderBy>;
  var_pop?: InputMaybe<IdrRunsVarPopOrderBy>;
  var_samp?: InputMaybe<IdrRunsVarSampOrderBy>;
  variance?: InputMaybe<IdrRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type IdrRunsAvgFields = {
  __typename?: 'idr_runs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "idr_runs" */
export type IdrRunsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_runs". All fields are combined with a logical 'AND'. */
export type IdrRunsBoolExp = {
  _and?: InputMaybe<Array<IdrRunsBoolExp>>;
  _not?: InputMaybe<IdrRunsBoolExp>;
  _or?: InputMaybe<Array<IdrRunsBoolExp>>;
  config_snapshot?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  full_rerun?: InputMaybe<BooleanComparisonExp>;
  full_rerun_reason?: InputMaybe<StringComparisonExp>;
  health?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  ran_healthchecks?: InputMaybe<BooleanComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  stats?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type IdrRunsMaxFields = {
  __typename?: 'idr_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  full_rerun_reason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "idr_runs" */
export type IdrRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  full_rerun_reason?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IdrRunsMinFields = {
  __typename?: 'idr_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  full_rerun_reason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "idr_runs" */
export type IdrRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  full_rerun_reason?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_runs". */
export type IdrRunsOrderBy = {
  config_snapshot?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  full_rerun?: InputMaybe<OrderBy>;
  full_rerun_reason?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  ran_healthchecks?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  stats?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_runs" */
export const IdrRunsSelectColumn = {
  /** column name */
  ConfigSnapshot: 'config_snapshot',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  FullRerun: 'full_rerun',
  /** column name */
  FullRerunReason: 'full_rerun_reason',
  /** column name */
  Health: 'health',
  /** column name */
  Id: 'id',
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  RanHealthchecks: 'ran_healthchecks',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Stats: 'stats',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IdrRunsSelectColumn = typeof IdrRunsSelectColumn[keyof typeof IdrRunsSelectColumn];
/** select "idr_runs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "idr_runs" */
export const IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  FullRerun: 'full_rerun',
  /** column name */
  RanHealthchecks: 'ran_healthchecks'
} as const;

export type IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolAndArgumentsColumns = typeof IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolAndArgumentsColumns];
/** select "idr_runs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "idr_runs" */
export const IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  FullRerun: 'full_rerun',
  /** column name */
  RanHealthchecks: 'ran_healthchecks'
} as const;

export type IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolOrArgumentsColumns = typeof IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof IdrRunsSelectColumnIdrRunsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type IdrRunsStddevFields = {
  __typename?: 'idr_runs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "idr_runs" */
export type IdrRunsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type IdrRunsStddevPopFields = {
  __typename?: 'idr_runs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "idr_runs" */
export type IdrRunsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type IdrRunsStddevSampFields = {
  __typename?: 'idr_runs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "idr_runs" */
export type IdrRunsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_runs" */
export type IdrRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrRunsStreamCursorValueInput = {
  config_snapshot?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  full_rerun?: InputMaybe<Scalars['Boolean']>;
  full_rerun_reason?: InputMaybe<Scalars['String']>;
  health?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  idr_id?: InputMaybe<Scalars['uuid']>;
  ran_healthchecks?: InputMaybe<Scalars['Boolean']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  stats?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type IdrRunsSumFields = {
  __typename?: 'idr_runs_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "idr_runs" */
export type IdrRunsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type IdrRunsVarPopFields = {
  __typename?: 'idr_runs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "idr_runs" */
export type IdrRunsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type IdrRunsVarSampFields = {
  __typename?: 'idr_runs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "idr_runs" */
export type IdrRunsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type IdrRunsVarianceFields = {
  __typename?: 'idr_runs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "idr_runs" */
export type IdrRunsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr" */
export const IdrSelectColumn = {
  /** column name */
  BlockRules: 'block_rules',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  FullRerun: 'full_rerun',
  /** column name */
  HouseholdingEnabled: 'householding_enabled',
  /** column name */
  Id: 'id',
  /** column name */
  MergeRules: 'merge_rules',
  /** column name */
  Name: 'name',
  /** column name */
  OnCompleteSql: 'on_complete_sql',
  /** column name */
  OutputSchema: 'output_schema',
  /** column name */
  OutputTable: 'output_table',
  /** column name */
  PendingBlocklistCount: 'pending_blocklist_count',
  /** column name */
  ProbabilisticConfig: 'probabilistic_config',
  /** column name */
  ResolutionRules: 'resolution_rules',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  ScheduleUpdatedAt: 'schedule_updated_at',
  /** column name */
  State: 'state',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IdrSelectColumn = typeof IdrSelectColumn[keyof typeof IdrSelectColumn];
/** Streaming cursor of the table "idr" */
export type IdrStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrStreamCursorValueInput = {
  block_rules?: InputMaybe<Scalars['jsonb']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  full_rerun?: InputMaybe<Scalars['Boolean']>;
  householding_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  merge_rules?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  on_complete_sql?: InputMaybe<Scalars['String']>;
  output_schema?: InputMaybe<Scalars['String']>;
  output_table?: InputMaybe<Scalars['String']>;
  pending_blocklist_count?: InputMaybe<Scalars['Int']>;
  probabilistic_config?: InputMaybe<Scalars['jsonb']>;
  resolution_rules?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  schedule_updated_at?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "idr_training_runs" */
export type IdrTrainingRuns = {
  __typename?: 'idr_training_runs';
  config_snapshot?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  dry_run: Scalars['Boolean'];
  /** A computed field, executes function "idr_training_run_error" */
  error?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "idr_training_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  idr: Idr;
  idr_id: Scalars['uuid'];
  model_name?: Maybe<Scalars['String']>;
  model_version?: Maybe<Scalars['String']>;
  /** A computed field, executes function "idr_training_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "idr_training_run_status" */
  status?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "idr_training_runs" */
export type IdrTrainingRunsConfigSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "idr_training_runs" */
export type IdrTrainingRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "idr_training_runs" */
export type IdrTrainingRunsAggregate = {
  __typename?: 'idr_training_runs_aggregate';
  aggregate?: Maybe<IdrTrainingRunsAggregateFields>;
  nodes: Array<IdrTrainingRuns>;
};

export type IdrTrainingRunsAggregateBoolExp = {
  bool_and?: InputMaybe<IdrTrainingRunsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<IdrTrainingRunsAggregateBoolExpBoolOr>;
  count?: InputMaybe<IdrTrainingRunsAggregateBoolExpCount>;
};

export type IdrTrainingRunsAggregateBoolExpBoolAnd = {
  arguments: IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrTrainingRunsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IdrTrainingRunsAggregateBoolExpBoolOr = {
  arguments: IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrTrainingRunsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IdrTrainingRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IdrTrainingRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "idr_training_runs" */
export type IdrTrainingRunsAggregateFields = {
  __typename?: 'idr_training_runs_aggregate_fields';
  avg?: Maybe<IdrTrainingRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<IdrTrainingRunsMaxFields>;
  min?: Maybe<IdrTrainingRunsMinFields>;
  stddev?: Maybe<IdrTrainingRunsStddevFields>;
  stddev_pop?: Maybe<IdrTrainingRunsStddevPopFields>;
  stddev_samp?: Maybe<IdrTrainingRunsStddevSampFields>;
  sum?: Maybe<IdrTrainingRunsSumFields>;
  var_pop?: Maybe<IdrTrainingRunsVarPopFields>;
  var_samp?: Maybe<IdrTrainingRunsVarSampFields>;
  variance?: Maybe<IdrTrainingRunsVarianceFields>;
};


/** aggregate fields of "idr_training_runs" */
export type IdrTrainingRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "idr_training_runs" */
export type IdrTrainingRunsAggregateOrderBy = {
  avg?: InputMaybe<IdrTrainingRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IdrTrainingRunsMaxOrderBy>;
  min?: InputMaybe<IdrTrainingRunsMinOrderBy>;
  stddev?: InputMaybe<IdrTrainingRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<IdrTrainingRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<IdrTrainingRunsStddevSampOrderBy>;
  sum?: InputMaybe<IdrTrainingRunsSumOrderBy>;
  var_pop?: InputMaybe<IdrTrainingRunsVarPopOrderBy>;
  var_samp?: InputMaybe<IdrTrainingRunsVarSampOrderBy>;
  variance?: InputMaybe<IdrTrainingRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type IdrTrainingRunsAvgFields = {
  __typename?: 'idr_training_runs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "idr_training_runs" */
export type IdrTrainingRunsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "idr_training_runs". All fields are combined with a logical 'AND'. */
export type IdrTrainingRunsBoolExp = {
  _and?: InputMaybe<Array<IdrTrainingRunsBoolExp>>;
  _not?: InputMaybe<IdrTrainingRunsBoolExp>;
  _or?: InputMaybe<Array<IdrTrainingRunsBoolExp>>;
  config_snapshot?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  dry_run?: InputMaybe<BooleanComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr?: InputMaybe<IdrBoolExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  model_name?: InputMaybe<StringComparisonExp>;
  model_version?: InputMaybe<StringComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type IdrTrainingRunsMaxFields = {
  __typename?: 'idr_training_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "idr_training_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  model_name?: Maybe<Scalars['String']>;
  model_version?: Maybe<Scalars['String']>;
  /** A computed field, executes function "idr_training_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "idr_training_run_status" */
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "idr_training_runs" */
export type IdrTrainingRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  model_name?: InputMaybe<OrderBy>;
  model_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IdrTrainingRunsMinFields = {
  __typename?: 'idr_training_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "idr_training_run_finished_at" */
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  model_name?: Maybe<Scalars['String']>;
  model_version?: Maybe<Scalars['String']>;
  /** A computed field, executes function "idr_training_run_started_at" */
  started_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "idr_training_run_status" */
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "idr_training_runs" */
export type IdrTrainingRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  model_name?: InputMaybe<OrderBy>;
  model_version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "idr_training_runs". */
export type IdrTrainingRunsOrderBy = {
  config_snapshot?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  dry_run?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr?: InputMaybe<IdrOrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  model_name?: InputMaybe<OrderBy>;
  model_version?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "idr_training_runs" */
export const IdrTrainingRunsSelectColumn = {
  /** column name */
  ConfigSnapshot: 'config_snapshot',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DryRun: 'dry_run',
  /** column name */
  Id: 'id',
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  ModelName: 'model_name',
  /** column name */
  ModelVersion: 'model_version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IdrTrainingRunsSelectColumn = typeof IdrTrainingRunsSelectColumn[keyof typeof IdrTrainingRunsSelectColumn];
/** select "idr_training_runs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "idr_training_runs" */
export const IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  DryRun: 'dry_run'
} as const;

export type IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolAndArgumentsColumns = typeof IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolAndArgumentsColumns];
/** select "idr_training_runs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "idr_training_runs" */
export const IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  DryRun: 'dry_run'
} as const;

export type IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolOrArgumentsColumns = typeof IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof IdrTrainingRunsSelectColumnIdrTrainingRunsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type IdrTrainingRunsStddevFields = {
  __typename?: 'idr_training_runs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "idr_training_runs" */
export type IdrTrainingRunsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type IdrTrainingRunsStddevPopFields = {
  __typename?: 'idr_training_runs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "idr_training_runs" */
export type IdrTrainingRunsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type IdrTrainingRunsStddevSampFields = {
  __typename?: 'idr_training_runs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "idr_training_runs" */
export type IdrTrainingRunsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "idr_training_runs" */
export type IdrTrainingRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdrTrainingRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdrTrainingRunsStreamCursorValueInput = {
  config_snapshot?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  dry_run?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  idr_id?: InputMaybe<Scalars['uuid']>;
  model_name?: InputMaybe<Scalars['String']>;
  model_version?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type IdrTrainingRunsSumFields = {
  __typename?: 'idr_training_runs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "idr_training_runs" */
export type IdrTrainingRunsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type IdrTrainingRunsVarPopFields = {
  __typename?: 'idr_training_runs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "idr_training_runs" */
export type IdrTrainingRunsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type IdrTrainingRunsVarSampFields = {
  __typename?: 'idr_training_runs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "idr_training_runs" */
export type IdrTrainingRunsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type IdrTrainingRunsVarianceFields = {
  __typename?: 'idr_training_runs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "idr_training_runs" */
export type IdrTrainingRunsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "incoming_webhooks" */
export type IncomingWebhooks = {
  __typename?: 'incoming_webhooks';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  verification_header?: Maybe<Scalars['String']>;
  webhook_type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "incoming_webhooks". All fields are combined with a logical 'AND'. */
export type IncomingWebhooksBoolExp = {
  _and?: InputMaybe<Array<IncomingWebhooksBoolExp>>;
  _not?: InputMaybe<IncomingWebhooksBoolExp>;
  _or?: InputMaybe<Array<IncomingWebhooksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  verification_header?: InputMaybe<StringComparisonExp>;
  webhook_type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "incoming_webhooks". */
export type IncomingWebhooksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  verification_header?: InputMaybe<OrderBy>;
  webhook_type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "incoming_webhooks" */
export const IncomingWebhooksSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  VerificationHeader: 'verification_header',
  /** column name */
  WebhookType: 'webhook_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type IncomingWebhooksSelectColumn = typeof IncomingWebhooksSelectColumn[keyof typeof IncomingWebhooksSelectColumn];
/** Streaming cursor of the table "incoming_webhooks" */
export type IncomingWebhooksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IncomingWebhooksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IncomingWebhooksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  verification_header?: InputMaybe<Scalars['String']>;
  webhook_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "initiative_goals" */
export type InitiativeGoals = {
  __typename?: 'initiative_goals';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  details?: Maybe<Scalars['String']>;
  goal: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  initiative_insights: Array<InitiativeInsights>;
  /** An aggregate relationship */
  initiative_insights_aggregate: InitiativeInsightsAggregate;
  latest_insight_generation_job_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "initiative_goals" */
export type InitiativeGoalsInitiativeInsightsArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


/** columns and relationships of "initiative_goals" */
export type InitiativeGoalsInitiativeInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};

/** Boolean expression to filter rows from the table "initiative_goals". All fields are combined with a logical 'AND'. */
export type InitiativeGoalsBoolExp = {
  _and?: InputMaybe<Array<InitiativeGoalsBoolExp>>;
  _not?: InputMaybe<InitiativeGoalsBoolExp>;
  _or?: InputMaybe<Array<InitiativeGoalsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  details?: InputMaybe<StringComparisonExp>;
  goal?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  initiative_insights?: InputMaybe<InitiativeInsightsBoolExp>;
  initiative_insights_aggregate?: InputMaybe<InitiativeInsightsAggregateBoolExp>;
  latest_insight_generation_job_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "initiative_goals" */
export const InitiativeGoalsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  InitiativeGoalsIdWorkspaceIdKey: 'initiative_goals_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  InitiativeGoalsPkey: 'initiative_goals_pkey'
} as const;

export type InitiativeGoalsConstraint = typeof InitiativeGoalsConstraint[keyof typeof InitiativeGoalsConstraint];
/** input type for inserting data into table "initiative_goals" */
export type InitiativeGoalsInsertInput = {
  details?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "initiative_goals" */
export type InitiativeGoalsMutationResponse = {
  __typename?: 'initiative_goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InitiativeGoals>;
};

/** on_conflict condition type for table "initiative_goals" */
export type InitiativeGoalsOnConflict = {
  constraint: InitiativeGoalsConstraint;
  update_columns?: Array<InitiativeGoalsUpdateColumn>;
  where?: InputMaybe<InitiativeGoalsBoolExp>;
};

/** Ordering options when selecting data from "initiative_goals". */
export type InitiativeGoalsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  details?: InputMaybe<OrderBy>;
  goal?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initiative_insights_aggregate?: InputMaybe<InitiativeInsightsAggregateOrderBy>;
  latest_insight_generation_job_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: initiative_goals */
export type InitiativeGoalsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "initiative_goals" */
export const InitiativeGoalsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Details: 'details',
  /** column name */
  Goal: 'goal',
  /** column name */
  Id: 'id',
  /** column name */
  LatestInsightGenerationJobId: 'latest_insight_generation_job_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InitiativeGoalsSelectColumn = typeof InitiativeGoalsSelectColumn[keyof typeof InitiativeGoalsSelectColumn];
/** input type for updating data in table "initiative_goals" */
export type InitiativeGoalsSetInput = {
  details?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "initiative_goals" */
export type InitiativeGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InitiativeGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InitiativeGoalsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  details?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  latest_insight_generation_job_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "initiative_goals" */
export const InitiativeGoalsUpdateColumn = {
  /** column name */
  Details: 'details',
  /** column name */
  Goal: 'goal'
} as const;

export type InitiativeGoalsUpdateColumn = typeof InitiativeGoalsUpdateColumn[keyof typeof InitiativeGoalsUpdateColumn];
export type InitiativeGoalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InitiativeGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: InitiativeGoalsBoolExp;
};

/** columns and relationships of "initiative_insights" */
export type InitiativeInsights = {
  __typename?: 'initiative_insights';
  content: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  initiative_goal: InitiativeGoals;
  initiative_goal_id: Scalars['uuid'];
  title: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "initiative_insights" */
export type InitiativeInsightsContentArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "initiative_insights" */
export type InitiativeInsightsAggregate = {
  __typename?: 'initiative_insights_aggregate';
  aggregate?: Maybe<InitiativeInsightsAggregateFields>;
  nodes: Array<InitiativeInsights>;
};

export type InitiativeInsightsAggregateBoolExp = {
  bool_and?: InputMaybe<InitiativeInsightsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InitiativeInsightsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InitiativeInsightsAggregateBoolExpCount>;
};

export type InitiativeInsightsAggregateBoolExpBoolAnd = {
  arguments: InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InitiativeInsightsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InitiativeInsightsAggregateBoolExpBoolOr = {
  arguments: InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InitiativeInsightsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InitiativeInsightsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InitiativeInsightsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "initiative_insights" */
export type InitiativeInsightsAggregateFields = {
  __typename?: 'initiative_insights_aggregate_fields';
  avg?: Maybe<InitiativeInsightsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InitiativeInsightsMaxFields>;
  min?: Maybe<InitiativeInsightsMinFields>;
  stddev?: Maybe<InitiativeInsightsStddevFields>;
  stddev_pop?: Maybe<InitiativeInsightsStddevPopFields>;
  stddev_samp?: Maybe<InitiativeInsightsStddevSampFields>;
  sum?: Maybe<InitiativeInsightsSumFields>;
  var_pop?: Maybe<InitiativeInsightsVarPopFields>;
  var_samp?: Maybe<InitiativeInsightsVarSampFields>;
  variance?: Maybe<InitiativeInsightsVarianceFields>;
};


/** aggregate fields of "initiative_insights" */
export type InitiativeInsightsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "initiative_insights" */
export type InitiativeInsightsAggregateOrderBy = {
  avg?: InputMaybe<InitiativeInsightsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InitiativeInsightsMaxOrderBy>;
  min?: InputMaybe<InitiativeInsightsMinOrderBy>;
  stddev?: InputMaybe<InitiativeInsightsStddevOrderBy>;
  stddev_pop?: InputMaybe<InitiativeInsightsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<InitiativeInsightsStddevSampOrderBy>;
  sum?: InputMaybe<InitiativeInsightsSumOrderBy>;
  var_pop?: InputMaybe<InitiativeInsightsVarPopOrderBy>;
  var_samp?: InputMaybe<InitiativeInsightsVarSampOrderBy>;
  variance?: InputMaybe<InitiativeInsightsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type InitiativeInsightsAvgFields = {
  __typename?: 'initiative_insights_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "initiative_insights" */
export type InitiativeInsightsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "initiative_insights". All fields are combined with a logical 'AND'. */
export type InitiativeInsightsBoolExp = {
  _and?: InputMaybe<Array<InitiativeInsightsBoolExp>>;
  _not?: InputMaybe<InitiativeInsightsBoolExp>;
  _or?: InputMaybe<Array<InitiativeInsightsBoolExp>>;
  content?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  hidden?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  initiative_goal?: InputMaybe<InitiativeGoalsBoolExp>;
  initiative_goal_id?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type InitiativeInsightsMaxFields = {
  __typename?: 'initiative_insights_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  initiative_goal_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "initiative_insights" */
export type InitiativeInsightsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initiative_goal_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InitiativeInsightsMinFields = {
  __typename?: 'initiative_insights_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  initiative_goal_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "initiative_insights" */
export type InitiativeInsightsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initiative_goal_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "initiative_insights" */
export type InitiativeInsightsMutationResponse = {
  __typename?: 'initiative_insights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InitiativeInsights>;
};

/** Ordering options when selecting data from "initiative_insights". */
export type InitiativeInsightsOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  hidden?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  initiative_goal?: InputMaybe<InitiativeGoalsOrderBy>;
  initiative_goal_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: initiative_insights */
export type InitiativeInsightsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "initiative_insights" */
export const InitiativeInsightsSelectColumn = {
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Hidden: 'hidden',
  /** column name */
  Id: 'id',
  /** column name */
  InitiativeGoalId: 'initiative_goal_id',
  /** column name */
  Title: 'title',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InitiativeInsightsSelectColumn = typeof InitiativeInsightsSelectColumn[keyof typeof InitiativeInsightsSelectColumn];
/** select "initiative_insights_aggregate_bool_exp_bool_and_arguments_columns" columns of table "initiative_insights" */
export const InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Hidden: 'hidden'
} as const;

export type InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolAndArgumentsColumns = typeof InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolAndArgumentsColumns];
/** select "initiative_insights_aggregate_bool_exp_bool_or_arguments_columns" columns of table "initiative_insights" */
export const InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Hidden: 'hidden'
} as const;

export type InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolOrArgumentsColumns = typeof InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof InitiativeInsightsSelectColumnInitiativeInsightsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "initiative_insights" */
export type InitiativeInsightsSetInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InitiativeInsightsStddevFields = {
  __typename?: 'initiative_insights_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "initiative_insights" */
export type InitiativeInsightsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type InitiativeInsightsStddevPopFields = {
  __typename?: 'initiative_insights_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "initiative_insights" */
export type InitiativeInsightsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type InitiativeInsightsStddevSampFields = {
  __typename?: 'initiative_insights_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "initiative_insights" */
export type InitiativeInsightsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "initiative_insights" */
export type InitiativeInsightsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InitiativeInsightsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InitiativeInsightsStreamCursorValueInput = {
  content?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  initiative_goal_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type InitiativeInsightsSumFields = {
  __typename?: 'initiative_insights_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "initiative_insights" */
export type InitiativeInsightsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

export type InitiativeInsightsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InitiativeInsightsSetInput>;
  /** filter the rows which have to be updated */
  where: InitiativeInsightsBoolExp;
};

/** aggregate var_pop on columns */
export type InitiativeInsightsVarPopFields = {
  __typename?: 'initiative_insights_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "initiative_insights" */
export type InitiativeInsightsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type InitiativeInsightsVarSampFields = {
  __typename?: 'initiative_insights_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "initiative_insights" */
export type InitiativeInsightsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InitiativeInsightsVarianceFields = {
  __typename?: 'initiative_insights_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "initiative_insights" */
export type InitiativeInsightsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "insights_agent_data_sources" */
export type InsightsAgentDataSources = {
  __typename?: 'insights_agent_data_sources';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "insights_agent_data_sources". All fields are combined with a logical 'AND'. */
export type InsightsAgentDataSourcesBoolExp = {
  _and?: InputMaybe<Array<InsightsAgentDataSourcesBoolExp>>;
  _not?: InputMaybe<InsightsAgentDataSourcesBoolExp>;
  _or?: InputMaybe<Array<InsightsAgentDataSourcesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  hidden?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "insights_agent_data_sources". */
export type InsightsAgentDataSourcesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  hidden?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "insights_agent_data_sources" */
export const InsightsAgentDataSourcesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  Hidden: 'hidden',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InsightsAgentDataSourcesSelectColumn = typeof InsightsAgentDataSourcesSelectColumn[keyof typeof InsightsAgentDataSourcesSelectColumn];
/** Streaming cursor of the table "insights_agent_data_sources" */
export type InsightsAgentDataSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InsightsAgentDataSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InsightsAgentDataSourcesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "inspiration_board_ads" */
export type InspirationBoardAds = {
  __typename?: 'inspiration_board_ads';
  ad_id: Scalars['String'];
  /** An object relationship */
  board: InspirationBoards;
  board_id: Scalars['uuid'];
  channel: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  page_id: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "inspiration_board_ads" */
export type InspirationBoardAdsAggregate = {
  __typename?: 'inspiration_board_ads_aggregate';
  aggregate?: Maybe<InspirationBoardAdsAggregateFields>;
  nodes: Array<InspirationBoardAds>;
};

export type InspirationBoardAdsAggregateBoolExp = {
  count?: InputMaybe<InspirationBoardAdsAggregateBoolExpCount>;
};

export type InspirationBoardAdsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InspirationBoardAdsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "inspiration_board_ads" */
export type InspirationBoardAdsAggregateFields = {
  __typename?: 'inspiration_board_ads_aggregate_fields';
  avg?: Maybe<InspirationBoardAdsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InspirationBoardAdsMaxFields>;
  min?: Maybe<InspirationBoardAdsMinFields>;
  stddev?: Maybe<InspirationBoardAdsStddevFields>;
  stddev_pop?: Maybe<InspirationBoardAdsStddevPopFields>;
  stddev_samp?: Maybe<InspirationBoardAdsStddevSampFields>;
  sum?: Maybe<InspirationBoardAdsSumFields>;
  var_pop?: Maybe<InspirationBoardAdsVarPopFields>;
  var_samp?: Maybe<InspirationBoardAdsVarSampFields>;
  variance?: Maybe<InspirationBoardAdsVarianceFields>;
};


/** aggregate fields of "inspiration_board_ads" */
export type InspirationBoardAdsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "inspiration_board_ads" */
export type InspirationBoardAdsAggregateOrderBy = {
  avg?: InputMaybe<InspirationBoardAdsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InspirationBoardAdsMaxOrderBy>;
  min?: InputMaybe<InspirationBoardAdsMinOrderBy>;
  stddev?: InputMaybe<InspirationBoardAdsStddevOrderBy>;
  stddev_pop?: InputMaybe<InspirationBoardAdsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<InspirationBoardAdsStddevSampOrderBy>;
  sum?: InputMaybe<InspirationBoardAdsSumOrderBy>;
  var_pop?: InputMaybe<InspirationBoardAdsVarPopOrderBy>;
  var_samp?: InputMaybe<InspirationBoardAdsVarSampOrderBy>;
  variance?: InputMaybe<InspirationBoardAdsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type InspirationBoardAdsAvgFields = {
  __typename?: 'inspiration_board_ads_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "inspiration_board_ads". All fields are combined with a logical 'AND'. */
export type InspirationBoardAdsBoolExp = {
  _and?: InputMaybe<Array<InspirationBoardAdsBoolExp>>;
  _not?: InputMaybe<InspirationBoardAdsBoolExp>;
  _or?: InputMaybe<Array<InspirationBoardAdsBoolExp>>;
  ad_id?: InputMaybe<StringComparisonExp>;
  board?: InputMaybe<InspirationBoardsBoolExp>;
  board_id?: InputMaybe<UuidComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  page_id?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type InspirationBoardAdsMaxFields = {
  __typename?: 'inspiration_board_ads_max_fields';
  ad_id?: Maybe<Scalars['String']>;
  board_id?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsMaxOrderBy = {
  ad_id?: InputMaybe<OrderBy>;
  board_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  page_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InspirationBoardAdsMinFields = {
  __typename?: 'inspiration_board_ads_min_fields';
  ad_id?: Maybe<Scalars['String']>;
  board_id?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  page_id?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsMinOrderBy = {
  ad_id?: InputMaybe<OrderBy>;
  board_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  page_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "inspiration_board_ads". */
export type InspirationBoardAdsOrderBy = {
  ad_id?: InputMaybe<OrderBy>;
  board?: InputMaybe<InspirationBoardsOrderBy>;
  board_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  page_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "inspiration_board_ads" */
export const InspirationBoardAdsSelectColumn = {
  /** column name */
  AdId: 'ad_id',
  /** column name */
  BoardId: 'board_id',
  /** column name */
  Channel: 'channel',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  PageId: 'page_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InspirationBoardAdsSelectColumn = typeof InspirationBoardAdsSelectColumn[keyof typeof InspirationBoardAdsSelectColumn];
/** aggregate stddev on columns */
export type InspirationBoardAdsStddevFields = {
  __typename?: 'inspiration_board_ads_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type InspirationBoardAdsStddevPopFields = {
  __typename?: 'inspiration_board_ads_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type InspirationBoardAdsStddevSampFields = {
  __typename?: 'inspiration_board_ads_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "inspiration_board_ads" */
export type InspirationBoardAdsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InspirationBoardAdsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InspirationBoardAdsStreamCursorValueInput = {
  ad_id?: InputMaybe<Scalars['String']>;
  board_id?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type InspirationBoardAdsSumFields = {
  __typename?: 'inspiration_board_ads_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type InspirationBoardAdsVarPopFields = {
  __typename?: 'inspiration_board_ads_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type InspirationBoardAdsVarSampFields = {
  __typename?: 'inspiration_board_ads_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InspirationBoardAdsVarianceFields = {
  __typename?: 'inspiration_board_ads_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "inspiration_board_ads" */
export type InspirationBoardAdsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "inspiration_boards" */
export type InspirationBoards = {
  __typename?: 'inspiration_boards';
  /** An array relationship */
  ads: Array<InspirationBoardAds>;
  /** An aggregate relationship */
  ads_aggregate: InspirationBoardAdsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "inspiration_boards" */
export type InspirationBoardsAdsArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


/** columns and relationships of "inspiration_boards" */
export type InspirationBoardsAdsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};

/** aggregated selection of "inspiration_boards" */
export type InspirationBoardsAggregate = {
  __typename?: 'inspiration_boards_aggregate';
  aggregate?: Maybe<InspirationBoardsAggregateFields>;
  nodes: Array<InspirationBoards>;
};

/** aggregate fields of "inspiration_boards" */
export type InspirationBoardsAggregateFields = {
  __typename?: 'inspiration_boards_aggregate_fields';
  avg?: Maybe<InspirationBoardsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InspirationBoardsMaxFields>;
  min?: Maybe<InspirationBoardsMinFields>;
  stddev?: Maybe<InspirationBoardsStddevFields>;
  stddev_pop?: Maybe<InspirationBoardsStddevPopFields>;
  stddev_samp?: Maybe<InspirationBoardsStddevSampFields>;
  sum?: Maybe<InspirationBoardsSumFields>;
  var_pop?: Maybe<InspirationBoardsVarPopFields>;
  var_samp?: Maybe<InspirationBoardsVarSampFields>;
  variance?: Maybe<InspirationBoardsVarianceFields>;
};


/** aggregate fields of "inspiration_boards" */
export type InspirationBoardsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InspirationBoardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InspirationBoardsAvgFields = {
  __typename?: 'inspiration_boards_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inspiration_boards". All fields are combined with a logical 'AND'. */
export type InspirationBoardsBoolExp = {
  _and?: InputMaybe<Array<InspirationBoardsBoolExp>>;
  _not?: InputMaybe<InspirationBoardsBoolExp>;
  _or?: InputMaybe<Array<InspirationBoardsBoolExp>>;
  ads?: InputMaybe<InspirationBoardAdsBoolExp>;
  ads_aggregate?: InputMaybe<InspirationBoardAdsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type InspirationBoardsMaxFields = {
  __typename?: 'inspiration_boards_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type InspirationBoardsMinFields = {
  __typename?: 'inspiration_boards_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "inspiration_boards". */
export type InspirationBoardsOrderBy = {
  ads_aggregate?: InputMaybe<InspirationBoardAdsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "inspiration_boards" */
export const InspirationBoardsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InspirationBoardsSelectColumn = typeof InspirationBoardsSelectColumn[keyof typeof InspirationBoardsSelectColumn];
/** aggregate stddev on columns */
export type InspirationBoardsStddevFields = {
  __typename?: 'inspiration_boards_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type InspirationBoardsStddevPopFields = {
  __typename?: 'inspiration_boards_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type InspirationBoardsStddevSampFields = {
  __typename?: 'inspiration_boards_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inspiration_boards" */
export type InspirationBoardsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InspirationBoardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InspirationBoardsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type InspirationBoardsSumFields = {
  __typename?: 'inspiration_boards_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type InspirationBoardsVarPopFields = {
  __typename?: 'inspiration_boards_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type InspirationBoardsVarSampFields = {
  __typename?: 'inspiration_boards_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InspirationBoardsVarianceFields = {
  __typename?: 'inspiration_boards_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "interaction_models" */
export type InteractionModels = {
  __typename?: 'interaction_models';
  /** An object relationship */
  event?: Maybe<EventModels>;
  /** An object relationship */
  model: Segments;
  model_id: Scalars['bigint'];
  type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "interaction_models" */
export type InteractionModelsAggregateOrderBy = {
  avg?: InputMaybe<InteractionModelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InteractionModelsMaxOrderBy>;
  min?: InputMaybe<InteractionModelsMinOrderBy>;
  stddev?: InputMaybe<InteractionModelsStddevOrderBy>;
  stddev_pop?: InputMaybe<InteractionModelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<InteractionModelsStddevSampOrderBy>;
  sum?: InputMaybe<InteractionModelsSumOrderBy>;
  var_pop?: InputMaybe<InteractionModelsVarPopOrderBy>;
  var_samp?: InputMaybe<InteractionModelsVarSampOrderBy>;
  variance?: InputMaybe<InteractionModelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "interaction_models" */
export type InteractionModelsArrRelInsertInput = {
  data: Array<InteractionModelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<InteractionModelsOnConflict>;
};

/** order by avg() on columns of table "interaction_models" */
export type InteractionModelsAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "interaction_models". All fields are combined with a logical 'AND'. */
export type InteractionModelsBoolExp = {
  _and?: InputMaybe<Array<InteractionModelsBoolExp>>;
  _not?: InputMaybe<InteractionModelsBoolExp>;
  _or?: InputMaybe<Array<InteractionModelsBoolExp>>;
  event?: InputMaybe<EventModelsBoolExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "interaction_models" */
export const InteractionModelsConstraint = {
  /** unique or primary key constraint on columns "model_id" */
  InteractionModelsPkey: 'interaction_models_pkey',
  /** unique or primary key constraint on columns "workspace_id", "model_id" */
  InteractionModelsWorkspaceIdModelIdKey: 'interaction_models_workspace_id_model_id_key'
} as const;

export type InteractionModelsConstraint = typeof InteractionModelsConstraint[keyof typeof InteractionModelsConstraint];
/** input type for incrementing numeric columns in table "interaction_models" */
export type InteractionModelsIncInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "interaction_models" */
export type InteractionModelsInsertInput = {
  event?: InputMaybe<EventModelsObjRelInsertInput>;
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "interaction_models" */
export type InteractionModelsMaxOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "interaction_models" */
export type InteractionModelsMinOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "interaction_models" */
export type InteractionModelsMutationResponse = {
  __typename?: 'interaction_models_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InteractionModels>;
};

/** input type for inserting object relation for remote table "interaction_models" */
export type InteractionModelsObjRelInsertInput = {
  data: InteractionModelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<InteractionModelsOnConflict>;
};

/** on_conflict condition type for table "interaction_models" */
export type InteractionModelsOnConflict = {
  constraint: InteractionModelsConstraint;
  update_columns?: Array<InteractionModelsUpdateColumn>;
  where?: InputMaybe<InteractionModelsBoolExp>;
};

/** Ordering options when selecting data from "interaction_models". */
export type InteractionModelsOrderBy = {
  event?: InputMaybe<EventModelsOrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: interaction_models */
export type InteractionModelsPkColumnsInput = {
  model_id: Scalars['bigint'];
};

/** select columns of table "interaction_models" */
export const InteractionModelsSelectColumn = {
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type InteractionModelsSelectColumn = typeof InteractionModelsSelectColumn[keyof typeof InteractionModelsSelectColumn];
/** input type for updating data in table "interaction_models" */
export type InteractionModelsSetInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "interaction_models" */
export type InteractionModelsStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "interaction_models" */
export type InteractionModelsStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "interaction_models" */
export type InteractionModelsStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "interaction_models" */
export type InteractionModelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: InteractionModelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InteractionModelsStreamCursorValueInput = {
  model_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "interaction_models" */
export type InteractionModelsSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "interaction_models" */
export const InteractionModelsUpdateColumn = {
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Type: 'type'
} as const;

export type InteractionModelsUpdateColumn = typeof InteractionModelsUpdateColumn[keyof typeof InteractionModelsUpdateColumn];
export type InteractionModelsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InteractionModelsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InteractionModelsSetInput>;
  /** filter the rows which have to be updated */
  where: InteractionModelsBoolExp;
};

/** order by var_pop() on columns of table "interaction_models" */
export type InteractionModelsVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "interaction_models" */
export type InteractionModelsVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "interaction_models" */
export type InteractionModelsVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type IntervalComparisonExp = {
  _eq?: InputMaybe<Scalars['interval']>;
  _gt?: InputMaybe<Scalars['interval']>;
  _gte?: InputMaybe<Scalars['interval']>;
  _in?: InputMaybe<Array<Scalars['interval']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['interval']>;
  _lte?: InputMaybe<Scalars['interval']>;
  _neq?: InputMaybe<Scalars['interval']>;
  _nin?: InputMaybe<Array<Scalars['interval']>>;
};

/** columns and relationships of "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlows = {
  __typename?: 'journey_decision_engine_flows';
  decision_engine_flow_id: Scalars['uuid'];
  /** An object relationship */
  flow: DecisionEngineFlows;
  journey_node_id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsAggregateOrderBy = {
  avg?: InputMaybe<JourneyDecisionEngineFlowsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyDecisionEngineFlowsMaxOrderBy>;
  min?: InputMaybe<JourneyDecisionEngineFlowsMinOrderBy>;
  stddev?: InputMaybe<JourneyDecisionEngineFlowsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyDecisionEngineFlowsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyDecisionEngineFlowsStddevSampOrderBy>;
  sum?: InputMaybe<JourneyDecisionEngineFlowsSumOrderBy>;
  var_pop?: InputMaybe<JourneyDecisionEngineFlowsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyDecisionEngineFlowsVarSampOrderBy>;
  variance?: InputMaybe<JourneyDecisionEngineFlowsVarianceOrderBy>;
};

/** order by avg() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_decision_engine_flows". All fields are combined with a logical 'AND'. */
export type JourneyDecisionEngineFlowsBoolExp = {
  _and?: InputMaybe<Array<JourneyDecisionEngineFlowsBoolExp>>;
  _not?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
  _or?: InputMaybe<Array<JourneyDecisionEngineFlowsBoolExp>>;
  decision_engine_flow_id?: InputMaybe<UuidComparisonExp>;
  flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  journey_node_id?: InputMaybe<UuidComparisonExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsMaxOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsMinOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_decision_engine_flows". */
export type JourneyDecisionEngineFlowsOrderBy = {
  decision_engine_flow_id?: InputMaybe<OrderBy>;
  flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_decision_engine_flows" */
export const JourneyDecisionEngineFlowsSelectColumn = {
  /** column name */
  DecisionEngineFlowId: 'decision_engine_flow_id',
  /** column name */
  JourneyNodeId: 'journey_node_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type JourneyDecisionEngineFlowsSelectColumn = typeof JourneyDecisionEngineFlowsSelectColumn[keyof typeof JourneyDecisionEngineFlowsSelectColumn];
/** order by stddev() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyDecisionEngineFlowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyDecisionEngineFlowsStreamCursorValueInput = {
  decision_engine_flow_id?: InputMaybe<Scalars['uuid']>;
  journey_node_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "journey_decision_engine_flows" */
export type JourneyDecisionEngineFlowsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_drafts" */
export type JourneyDrafts = {
  __typename?: 'journey_drafts';
  approved_journey_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  journey_id: Scalars['uuid'];
  requested_approver_ids: Scalars['jsonb'];
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  reviewed_by_user?: Maybe<Users>;
  status: Scalars['String'];
  submission_comment?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "journey_drafts" */
export type JourneyDraftsRequestedApproverIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "journey_drafts" */
export type JourneyDraftsAggregate = {
  __typename?: 'journey_drafts_aggregate';
  aggregate?: Maybe<JourneyDraftsAggregateFields>;
  nodes: Array<JourneyDrafts>;
};

export type JourneyDraftsAggregateBoolExp = {
  count?: InputMaybe<JourneyDraftsAggregateBoolExpCount>;
};

export type JourneyDraftsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneyDraftsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journey_drafts" */
export type JourneyDraftsAggregateFields = {
  __typename?: 'journey_drafts_aggregate_fields';
  avg?: Maybe<JourneyDraftsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyDraftsMaxFields>;
  min?: Maybe<JourneyDraftsMinFields>;
  stddev?: Maybe<JourneyDraftsStddevFields>;
  stddev_pop?: Maybe<JourneyDraftsStddevPopFields>;
  stddev_samp?: Maybe<JourneyDraftsStddevSampFields>;
  sum?: Maybe<JourneyDraftsSumFields>;
  var_pop?: Maybe<JourneyDraftsVarPopFields>;
  var_samp?: Maybe<JourneyDraftsVarSampFields>;
  variance?: Maybe<JourneyDraftsVarianceFields>;
};


/** aggregate fields of "journey_drafts" */
export type JourneyDraftsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journey_drafts" */
export type JourneyDraftsAggregateOrderBy = {
  avg?: InputMaybe<JourneyDraftsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyDraftsMaxOrderBy>;
  min?: InputMaybe<JourneyDraftsMinOrderBy>;
  stddev?: InputMaybe<JourneyDraftsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyDraftsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyDraftsStddevSampOrderBy>;
  sum?: InputMaybe<JourneyDraftsSumOrderBy>;
  var_pop?: InputMaybe<JourneyDraftsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyDraftsVarSampOrderBy>;
  variance?: InputMaybe<JourneyDraftsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type JourneyDraftsAvgFields = {
  __typename?: 'journey_drafts_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journey_drafts" */
export type JourneyDraftsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_drafts". All fields are combined with a logical 'AND'. */
export type JourneyDraftsBoolExp = {
  _and?: InputMaybe<Array<JourneyDraftsBoolExp>>;
  _not?: InputMaybe<JourneyDraftsBoolExp>;
  _or?: InputMaybe<Array<JourneyDraftsBoolExp>>;
  approved_journey_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  requested_approver_ids?: InputMaybe<JsonbComparisonExp>;
  resolution_comment?: InputMaybe<StringComparisonExp>;
  reviewed_at?: InputMaybe<TimestamptzComparisonExp>;
  reviewed_by?: InputMaybe<BigintComparisonExp>;
  reviewed_by_user?: InputMaybe<UsersBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  submission_comment?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type JourneyDraftsMaxFields = {
  __typename?: 'journey_drafts_max_fields';
  approved_journey_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  submission_comment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journey_drafts" */
export type JourneyDraftsMaxOrderBy = {
  approved_journey_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneyDraftsMinFields = {
  __typename?: 'journey_drafts_min_fields';
  approved_journey_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  resolution_comment?: Maybe<Scalars['String']>;
  reviewed_at?: Maybe<Scalars['timestamptz']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  submission_comment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journey_drafts" */
export type JourneyDraftsMinOrderBy = {
  approved_journey_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_drafts". */
export type JourneyDraftsOrderBy = {
  approved_journey_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  requested_approver_ids?: InputMaybe<OrderBy>;
  resolution_comment?: InputMaybe<OrderBy>;
  reviewed_at?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  reviewed_by_user?: InputMaybe<UsersOrderBy>;
  status?: InputMaybe<OrderBy>;
  submission_comment?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_drafts" */
export const JourneyDraftsSelectColumn = {
  /** column name */
  ApprovedJourneyVersionId: 'approved_journey_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  RequestedApproverIds: 'requested_approver_ids',
  /** column name */
  ResolutionComment: 'resolution_comment',
  /** column name */
  ReviewedAt: 'reviewed_at',
  /** column name */
  ReviewedBy: 'reviewed_by',
  /** column name */
  Status: 'status',
  /** column name */
  SubmissionComment: 'submission_comment',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type JourneyDraftsSelectColumn = typeof JourneyDraftsSelectColumn[keyof typeof JourneyDraftsSelectColumn];
/** aggregate stddev on columns */
export type JourneyDraftsStddevFields = {
  __typename?: 'journey_drafts_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journey_drafts" */
export type JourneyDraftsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneyDraftsStddevPopFields = {
  __typename?: 'journey_drafts_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journey_drafts" */
export type JourneyDraftsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneyDraftsStddevSampFields = {
  __typename?: 'journey_drafts_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journey_drafts" */
export type JourneyDraftsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_drafts" */
export type JourneyDraftsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyDraftsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyDraftsStreamCursorValueInput = {
  approved_journey_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  requested_approver_ids?: InputMaybe<Scalars['jsonb']>;
  resolution_comment?: InputMaybe<Scalars['String']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']>;
  reviewed_by?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  submission_comment?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyDraftsSumFields = {
  __typename?: 'journey_drafts_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  reviewed_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_drafts" */
export type JourneyDraftsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type JourneyDraftsVarPopFields = {
  __typename?: 'journey_drafts_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journey_drafts" */
export type JourneyDraftsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneyDraftsVarSampFields = {
  __typename?: 'journey_drafts_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journey_drafts" */
export type JourneyDraftsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneyDraftsVarianceFields = {
  __typename?: 'journey_drafts_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  reviewed_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journey_drafts" */
export type JourneyDraftsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  reviewed_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_edges" */
export type JourneyEdges = {
  __typename?: 'journey_edges';
  from_node_id: Scalars['uuid'];
  journey_id: Scalars['uuid'];
  /** An object relationship */
  journey_version: Journeys;
  journey_version_id: Scalars['uuid'];
  to_node_id: Scalars['uuid'];
};

/** order by aggregate values of table "journey_edges" */
export type JourneyEdgesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyEdgesMaxOrderBy>;
  min?: InputMaybe<JourneyEdgesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "journey_edges". All fields are combined with a logical 'AND'. */
export type JourneyEdgesBoolExp = {
  _and?: InputMaybe<Array<JourneyEdgesBoolExp>>;
  _not?: InputMaybe<JourneyEdgesBoolExp>;
  _or?: InputMaybe<Array<JourneyEdgesBoolExp>>;
  from_node_id?: InputMaybe<UuidComparisonExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_version?: InputMaybe<JourneysBoolExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  to_node_id?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "journey_edges" */
export type JourneyEdgesMaxOrderBy = {
  from_node_id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  to_node_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "journey_edges" */
export type JourneyEdgesMinOrderBy = {
  from_node_id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  to_node_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_edges". */
export type JourneyEdgesOrderBy = {
  from_node_id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version?: InputMaybe<JourneysOrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  to_node_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_edges" */
export const JourneyEdgesSelectColumn = {
  /** column name */
  FromNodeId: 'from_node_id',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  ToNodeId: 'to_node_id'
} as const;

export type JourneyEdgesSelectColumn = typeof JourneyEdgesSelectColumn[keyof typeof JourneyEdgesSelectColumn];
/** Streaming cursor of the table "journey_edges" */
export type JourneyEdgesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyEdgesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyEdgesStreamCursorValueInput = {
  from_node_id?: InputMaybe<Scalars['uuid']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  to_node_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "journey_labels" */
export type JourneyLabels = {
  __typename?: 'journey_labels';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  journey_id: Scalars['uuid'];
  /** An array relationship */
  journey_versions: Array<Journeys>;
  /** An aggregate relationship */
  journey_versions_aggregate: JourneysAggregate;
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "journey_labels" */
export type JourneyLabelsJourneyVersionsArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};


/** columns and relationships of "journey_labels" */
export type JourneyLabelsJourneyVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};

/** aggregated selection of "journey_labels" */
export type JourneyLabelsAggregate = {
  __typename?: 'journey_labels_aggregate';
  aggregate?: Maybe<JourneyLabelsAggregateFields>;
  nodes: Array<JourneyLabels>;
};

export type JourneyLabelsAggregateBoolExp = {
  count?: InputMaybe<JourneyLabelsAggregateBoolExpCount>;
};

export type JourneyLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneyLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journey_labels" */
export type JourneyLabelsAggregateFields = {
  __typename?: 'journey_labels_aggregate_fields';
  avg?: Maybe<JourneyLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyLabelsMaxFields>;
  min?: Maybe<JourneyLabelsMinFields>;
  stddev?: Maybe<JourneyLabelsStddevFields>;
  stddev_pop?: Maybe<JourneyLabelsStddevPopFields>;
  stddev_samp?: Maybe<JourneyLabelsStddevSampFields>;
  sum?: Maybe<JourneyLabelsSumFields>;
  var_pop?: Maybe<JourneyLabelsVarPopFields>;
  var_samp?: Maybe<JourneyLabelsVarSampFields>;
  variance?: Maybe<JourneyLabelsVarianceFields>;
};


/** aggregate fields of "journey_labels" */
export type JourneyLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journey_labels" */
export type JourneyLabelsAggregateOrderBy = {
  avg?: InputMaybe<JourneyLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyLabelsMaxOrderBy>;
  min?: InputMaybe<JourneyLabelsMinOrderBy>;
  stddev?: InputMaybe<JourneyLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyLabelsStddevSampOrderBy>;
  sum?: InputMaybe<JourneyLabelsSumOrderBy>;
  var_pop?: InputMaybe<JourneyLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyLabelsVarSampOrderBy>;
  variance?: InputMaybe<JourneyLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "journey_labels" */
export type JourneyLabelsArrRelInsertInput = {
  data: Array<JourneyLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<JourneyLabelsOnConflict>;
};

/** aggregate avg on columns */
export type JourneyLabelsAvgFields = {
  __typename?: 'journey_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journey_labels" */
export type JourneyLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_labels". All fields are combined with a logical 'AND'. */
export type JourneyLabelsBoolExp = {
  _and?: InputMaybe<Array<JourneyLabelsBoolExp>>;
  _not?: InputMaybe<JourneyLabelsBoolExp>;
  _or?: InputMaybe<Array<JourneyLabelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_versions?: InputMaybe<JourneysBoolExp>;
  journey_versions_aggregate?: InputMaybe<JourneysAggregateBoolExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "journey_labels" */
export const JourneyLabelsConstraint = {
  /** unique or primary key constraint on columns "label_id", "journey_id" */
  JourneyLabelsPkey: 'journey_labels_pkey'
} as const;

export type JourneyLabelsConstraint = typeof JourneyLabelsConstraint[keyof typeof JourneyLabelsConstraint];
/** input type for inserting data into table "journey_labels" */
export type JourneyLabelsInsertInput = {
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_versions?: InputMaybe<JourneysArrRelInsertInput>;
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JourneyLabelsMaxFields = {
  __typename?: 'journey_labels_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  journey_id?: Maybe<Scalars['uuid']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journey_labels" */
export type JourneyLabelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneyLabelsMinFields = {
  __typename?: 'journey_labels_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  journey_id?: Maybe<Scalars['uuid']>;
  label_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journey_labels" */
export type JourneyLabelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "journey_labels" */
export type JourneyLabelsMutationResponse = {
  __typename?: 'journey_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JourneyLabels>;
};

/** on_conflict condition type for table "journey_labels" */
export type JourneyLabelsOnConflict = {
  constraint: JourneyLabelsConstraint;
  update_columns?: Array<JourneyLabelsUpdateColumn>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};

/** Ordering options when selecting data from "journey_labels". */
export type JourneyLabelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_versions_aggregate?: InputMaybe<JourneysAggregateOrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_labels" */
export const JourneyLabelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type JourneyLabelsSelectColumn = typeof JourneyLabelsSelectColumn[keyof typeof JourneyLabelsSelectColumn];
/** aggregate stddev on columns */
export type JourneyLabelsStddevFields = {
  __typename?: 'journey_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journey_labels" */
export type JourneyLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneyLabelsStddevPopFields = {
  __typename?: 'journey_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journey_labels" */
export type JourneyLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneyLabelsStddevSampFields = {
  __typename?: 'journey_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journey_labels" */
export type JourneyLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_labels" */
export type JourneyLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyLabelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyLabelsSumFields = {
  __typename?: 'journey_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_labels" */
export type JourneyLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "journey_labels" (current role has no relevant permissions) */
export const JourneyLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type JourneyLabelsUpdateColumn = typeof JourneyLabelsUpdateColumn[keyof typeof JourneyLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type JourneyLabelsVarPopFields = {
  __typename?: 'journey_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journey_labels" */
export type JourneyLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneyLabelsVarSampFields = {
  __typename?: 'journey_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journey_labels" */
export type JourneyLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneyLabelsVarianceFields = {
  __typename?: 'journey_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journey_labels" */
export type JourneyLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_messages" */
export type JourneyMessages = {
  __typename?: 'journey_messages';
  id: Scalars['uuid'];
  /** An object relationship */
  journey_node: JourneyNodes;
  journey_node_id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
};

/** order by aggregate values of table "journey_messages" */
export type JourneyMessagesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyMessagesMaxOrderBy>;
  min?: InputMaybe<JourneyMessagesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "journey_messages". All fields are combined with a logical 'AND'. */
export type JourneyMessagesBoolExp = {
  _and?: InputMaybe<Array<JourneyMessagesBoolExp>>;
  _not?: InputMaybe<JourneyMessagesBoolExp>;
  _or?: InputMaybe<Array<JourneyMessagesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_node?: InputMaybe<JourneyNodesBoolExp>;
  journey_node_id?: InputMaybe<UuidComparisonExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "journey_messages" */
export type JourneyMessagesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "journey_messages" */
export type JourneyMessagesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_messages". */
export type JourneyMessagesOrderBy = {
  id?: InputMaybe<OrderBy>;
  journey_node?: InputMaybe<JourneyNodesOrderBy>;
  journey_node_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_messages" */
export const JourneyMessagesSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  JourneyNodeId: 'journey_node_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  MessageId: 'message_id'
} as const;

export type JourneyMessagesSelectColumn = typeof JourneyMessagesSelectColumn[keyof typeof JourneyMessagesSelectColumn];
/** Streaming cursor of the table "journey_messages" */
export type JourneyMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyMessagesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  journey_node_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "journey_node_runs" */
export type JourneyNodeRuns = {
  __typename?: 'journey_node_runs';
  advanced_count?: Maybe<Scalars['bigint']>;
  completed_count?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  entry_count?: Maybe<Scalars['bigint']>;
  error?: Maybe<Scalars['String']>;
  exit_count?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  journey_run: JourneyRuns;
  node_id: Scalars['uuid'];
  run_id: Scalars['uuid'];
  started_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  unique_advanced_count?: Maybe<Scalars['bigint']>;
  unique_completed_count?: Maybe<Scalars['bigint']>;
  unique_entry_count?: Maybe<Scalars['bigint']>;
  unique_exit_count?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "journey_node_runs" */
export type JourneyNodeRunsAggregateOrderBy = {
  avg?: InputMaybe<JourneyNodeRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyNodeRunsMaxOrderBy>;
  min?: InputMaybe<JourneyNodeRunsMinOrderBy>;
  stddev?: InputMaybe<JourneyNodeRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyNodeRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyNodeRunsStddevSampOrderBy>;
  sum?: InputMaybe<JourneyNodeRunsSumOrderBy>;
  var_pop?: InputMaybe<JourneyNodeRunsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyNodeRunsVarSampOrderBy>;
  variance?: InputMaybe<JourneyNodeRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "journey_node_runs" */
export type JourneyNodeRunsAvgOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_node_runs". All fields are combined with a logical 'AND'. */
export type JourneyNodeRunsBoolExp = {
  _and?: InputMaybe<Array<JourneyNodeRunsBoolExp>>;
  _not?: InputMaybe<JourneyNodeRunsBoolExp>;
  _or?: InputMaybe<Array<JourneyNodeRunsBoolExp>>;
  advanced_count?: InputMaybe<BigintComparisonExp>;
  completed_count?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  entry_count?: InputMaybe<BigintComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  exit_count?: InputMaybe<BigintComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  journey_run?: InputMaybe<JourneyRunsBoolExp>;
  node_id?: InputMaybe<UuidComparisonExp>;
  run_id?: InputMaybe<UuidComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  unique_advanced_count?: InputMaybe<BigintComparisonExp>;
  unique_completed_count?: InputMaybe<BigintComparisonExp>;
  unique_entry_count?: InputMaybe<BigintComparisonExp>;
  unique_exit_count?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "journey_node_runs" */
export type JourneyNodeRunsMaxOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  run_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "journey_node_runs" */
export type JourneyNodeRunsMinOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  run_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_node_runs". */
export type JourneyNodeRunsOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  journey_run?: InputMaybe<JourneyRunsOrderBy>;
  node_id?: InputMaybe<OrderBy>;
  run_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_node_runs" */
export const JourneyNodeRunsSelectColumn = {
  /** column name */
  AdvancedCount: 'advanced_count',
  /** column name */
  CompletedCount: 'completed_count',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  EntryCount: 'entry_count',
  /** column name */
  Error: 'error',
  /** column name */
  ExitCount: 'exit_count',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  NodeId: 'node_id',
  /** column name */
  RunId: 'run_id',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  UniqueAdvancedCount: 'unique_advanced_count',
  /** column name */
  UniqueCompletedCount: 'unique_completed_count',
  /** column name */
  UniqueEntryCount: 'unique_entry_count',
  /** column name */
  UniqueExitCount: 'unique_exit_count'
} as const;

export type JourneyNodeRunsSelectColumn = typeof JourneyNodeRunsSelectColumn[keyof typeof JourneyNodeRunsSelectColumn];
/** order by stddev() on columns of table "journey_node_runs" */
export type JourneyNodeRunsStddevOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "journey_node_runs" */
export type JourneyNodeRunsStddevPopOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "journey_node_runs" */
export type JourneyNodeRunsStddevSampOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_node_runs" */
export type JourneyNodeRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyNodeRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyNodeRunsStreamCursorValueInput = {
  advanced_count?: InputMaybe<Scalars['bigint']>;
  completed_count?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entry_count?: InputMaybe<Scalars['bigint']>;
  error?: InputMaybe<Scalars['String']>;
  exit_count?: InputMaybe<Scalars['bigint']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  node_id?: InputMaybe<Scalars['uuid']>;
  run_id?: InputMaybe<Scalars['uuid']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  unique_advanced_count?: InputMaybe<Scalars['bigint']>;
  unique_completed_count?: InputMaybe<Scalars['bigint']>;
  unique_entry_count?: InputMaybe<Scalars['bigint']>;
  unique_exit_count?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_node_runs" */
export type JourneyNodeRunsSumOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "journey_node_runs" */
export type JourneyNodeRunsVarPopOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "journey_node_runs" */
export type JourneyNodeRunsVarSampOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "journey_node_runs" */
export type JourneyNodeRunsVarianceOrderBy = {
  advanced_count?: InputMaybe<OrderBy>;
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_advanced_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_nodes" */
export type JourneyNodes = {
  __typename?: 'journey_nodes';
  /** An array relationship */
  campaign_messages: Array<JourneyMessages>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  decision_engine_flow_links: Array<JourneyDecisionEngineFlows>;
  description?: Maybe<Scalars['String']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['bigint']>;
  execution_mode: Scalars['String'];
  /** An object relationship */
  experiment?: Maybe<Experiments>;
  id: Scalars['uuid'];
  /** An array relationship */
  journey_node_runs: Array<JourneyNodeRuns>;
  /** An object relationship */
  journey_version: Journeys;
  journey_version_id: Scalars['uuid'];
  name: Scalars['String'];
  number_unique_users?: Maybe<Scalars['bigint']>;
  number_users?: Maybe<Scalars['bigint']>;
  position?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  sync_configs: Array<JourneySyncs>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesCampaignMessagesArgs = {
  distinct_on?: InputMaybe<Array<JourneyMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyMessagesOrderBy>>;
  where?: InputMaybe<JourneyMessagesBoolExp>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesDecisionEngineFlowLinksArgs = {
  distinct_on?: InputMaybe<Array<JourneyDecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesJourneyNodeRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodeRunsOrderBy>>;
  where?: InputMaybe<JourneyNodeRunsBoolExp>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesPositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "journey_nodes" */
export type JourneyNodesSyncConfigsArgs = {
  distinct_on?: InputMaybe<Array<JourneySyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySyncsOrderBy>>;
  where?: InputMaybe<JourneySyncsBoolExp>;
};

/** aggregated selection of "journey_nodes" */
export type JourneyNodesAggregate = {
  __typename?: 'journey_nodes_aggregate';
  aggregate?: Maybe<JourneyNodesAggregateFields>;
  nodes: Array<JourneyNodes>;
};

export type JourneyNodesAggregateBoolExp = {
  count?: InputMaybe<JourneyNodesAggregateBoolExpCount>;
};

export type JourneyNodesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneyNodesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journey_nodes" */
export type JourneyNodesAggregateFields = {
  __typename?: 'journey_nodes_aggregate_fields';
  avg?: Maybe<JourneyNodesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyNodesMaxFields>;
  min?: Maybe<JourneyNodesMinFields>;
  stddev?: Maybe<JourneyNodesStddevFields>;
  stddev_pop?: Maybe<JourneyNodesStddevPopFields>;
  stddev_samp?: Maybe<JourneyNodesStddevSampFields>;
  sum?: Maybe<JourneyNodesSumFields>;
  var_pop?: Maybe<JourneyNodesVarPopFields>;
  var_samp?: Maybe<JourneyNodesVarSampFields>;
  variance?: Maybe<JourneyNodesVarianceFields>;
};


/** aggregate fields of "journey_nodes" */
export type JourneyNodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journey_nodes" */
export type JourneyNodesAggregateOrderBy = {
  avg?: InputMaybe<JourneyNodesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyNodesMaxOrderBy>;
  min?: InputMaybe<JourneyNodesMinOrderBy>;
  stddev?: InputMaybe<JourneyNodesStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyNodesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyNodesStddevSampOrderBy>;
  sum?: InputMaybe<JourneyNodesSumOrderBy>;
  var_pop?: InputMaybe<JourneyNodesVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyNodesVarSampOrderBy>;
  variance?: InputMaybe<JourneyNodesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type JourneyNodesAvgFields = {
  __typename?: 'journey_nodes_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journey_nodes" */
export type JourneyNodesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_nodes". All fields are combined with a logical 'AND'. */
export type JourneyNodesBoolExp = {
  _and?: InputMaybe<Array<JourneyNodesBoolExp>>;
  _not?: InputMaybe<JourneyNodesBoolExp>;
  _or?: InputMaybe<Array<JourneyNodesBoolExp>>;
  campaign_messages?: InputMaybe<JourneyMessagesBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  decision_engine_flow_links?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  event_relationship_id?: InputMaybe<BigintComparisonExp>;
  execution_mode?: InputMaybe<StringComparisonExp>;
  experiment?: InputMaybe<ExperimentsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_node_runs?: InputMaybe<JourneyNodeRunsBoolExp>;
  journey_version?: InputMaybe<JourneysBoolExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  number_unique_users?: InputMaybe<BigintComparisonExp>;
  number_users?: InputMaybe<BigintComparisonExp>;
  position?: InputMaybe<JsonbComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  sync_configs?: InputMaybe<JourneySyncsBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type JourneyNodesMaxFields = {
  __typename?: 'journey_nodes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['bigint']>;
  execution_mode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  number_unique_users?: Maybe<Scalars['bigint']>;
  number_users?: Maybe<Scalars['bigint']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journey_nodes" */
export type JourneyNodesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneyNodesMinFields = {
  __typename?: 'journey_nodes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['bigint']>;
  execution_mode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  number_unique_users?: Maybe<Scalars['bigint']>;
  number_users?: Maybe<Scalars['bigint']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journey_nodes" */
export type JourneyNodesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_nodes". */
export type JourneyNodesOrderBy = {
  campaign_messages_aggregate?: InputMaybe<JourneyMessagesAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  decision_engine_flow_links_aggregate?: InputMaybe<JourneyDecisionEngineFlowsAggregateOrderBy>;
  description?: InputMaybe<OrderBy>;
  event_relationship_id?: InputMaybe<OrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  experiment?: InputMaybe<ExperimentsOrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_node_runs_aggregate?: InputMaybe<JourneyNodeRunsAggregateOrderBy>;
  journey_version?: InputMaybe<JourneysOrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_configs_aggregate?: InputMaybe<JourneySyncsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_nodes" */
export const JourneyNodesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  EventRelationshipId: 'event_relationship_id',
  /** column name */
  ExecutionMode: 'execution_mode',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  Name: 'name',
  /** column name */
  NumberUniqueUsers: 'number_unique_users',
  /** column name */
  NumberUsers: 'number_users',
  /** column name */
  Position: 'position',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type JourneyNodesSelectColumn = typeof JourneyNodesSelectColumn[keyof typeof JourneyNodesSelectColumn];
/** aggregate stddev on columns */
export type JourneyNodesStddevFields = {
  __typename?: 'journey_nodes_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journey_nodes" */
export type JourneyNodesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneyNodesStddevPopFields = {
  __typename?: 'journey_nodes_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journey_nodes" */
export type JourneyNodesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneyNodesStddevSampFields = {
  __typename?: 'journey_nodes_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journey_nodes" */
export type JourneyNodesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_nodes" */
export type JourneyNodesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyNodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyNodesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<Scalars['bigint']>;
  execution_mode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  number_unique_users?: InputMaybe<Scalars['bigint']>;
  number_users?: InputMaybe<Scalars['bigint']>;
  position?: InputMaybe<Scalars['jsonb']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyNodesSumFields = {
  __typename?: 'journey_nodes_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['bigint']>;
  number_unique_users?: Maybe<Scalars['bigint']>;
  number_users?: Maybe<Scalars['bigint']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_nodes" */
export type JourneyNodesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type JourneyNodesVarPopFields = {
  __typename?: 'journey_nodes_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journey_nodes" */
export type JourneyNodesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneyNodesVarSampFields = {
  __typename?: 'journey_nodes_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journey_nodes" */
export type JourneyNodesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneyNodesVarianceFields = {
  __typename?: 'journey_nodes_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: Maybe<Scalars['Float']>;
  number_unique_users?: Maybe<Scalars['Float']>;
  number_users?: Maybe<Scalars['Float']>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journey_nodes" */
export type JourneyNodesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  /** If segment_id represents an event, this is the relationship used to get to that event from the journey's parent model. */
  event_relationship_id?: InputMaybe<OrderBy>;
  number_unique_users?: InputMaybe<OrderBy>;
  number_users?: InputMaybe<OrderBy>;
  /** Used for linking a journey node against either an audience or an event model, depending on the node type. */
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_notes" */
export type JourneyNotes = {
  __typename?: 'journey_notes';
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  is_deleted_version?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  journey_version: Journeys;
  node_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  note_deleted_journey_version?: Maybe<Journeys>;
  position?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};


/** columns and relationships of "journey_notes" */
export type JourneyNotesPositionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "journey_notes" */
export type JourneyNotesAggregate = {
  __typename?: 'journey_notes_aggregate';
  aggregate?: Maybe<JourneyNotesAggregateFields>;
  nodes: Array<JourneyNotes>;
};

export type JourneyNotesAggregateBoolExp = {
  count?: InputMaybe<JourneyNotesAggregateBoolExpCount>;
};

export type JourneyNotesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneyNotesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journey_notes" */
export type JourneyNotesAggregateFields = {
  __typename?: 'journey_notes_aggregate_fields';
  avg?: Maybe<JourneyNotesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyNotesMaxFields>;
  min?: Maybe<JourneyNotesMinFields>;
  stddev?: Maybe<JourneyNotesStddevFields>;
  stddev_pop?: Maybe<JourneyNotesStddevPopFields>;
  stddev_samp?: Maybe<JourneyNotesStddevSampFields>;
  sum?: Maybe<JourneyNotesSumFields>;
  var_pop?: Maybe<JourneyNotesVarPopFields>;
  var_samp?: Maybe<JourneyNotesVarSampFields>;
  variance?: Maybe<JourneyNotesVarianceFields>;
};


/** aggregate fields of "journey_notes" */
export type JourneyNotesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journey_notes" */
export type JourneyNotesAggregateOrderBy = {
  avg?: InputMaybe<JourneyNotesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyNotesMaxOrderBy>;
  min?: InputMaybe<JourneyNotesMinOrderBy>;
  stddev?: InputMaybe<JourneyNotesStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyNotesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyNotesStddevSampOrderBy>;
  sum?: InputMaybe<JourneyNotesSumOrderBy>;
  var_pop?: InputMaybe<JourneyNotesVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyNotesVarSampOrderBy>;
  variance?: InputMaybe<JourneyNotesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type JourneyNotesAvgFields = {
  __typename?: 'journey_notes_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journey_notes" */
export type JourneyNotesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_notes". All fields are combined with a logical 'AND'. */
export type JourneyNotesBoolExp = {
  _and?: InputMaybe<Array<JourneyNotesBoolExp>>;
  _not?: InputMaybe<JourneyNotesBoolExp>;
  _or?: InputMaybe<Array<JourneyNotesBoolExp>>;
  content?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_deleted_version?: InputMaybe<UuidComparisonExp>;
  journey_version?: InputMaybe<JourneysBoolExp>;
  node_id?: InputMaybe<UuidComparisonExp>;
  note_deleted_journey_version?: InputMaybe<JourneysBoolExp>;
  position?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
};

/** aggregate max on columns */
export type JourneyNotesMaxFields = {
  __typename?: 'journey_notes_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  is_deleted_version?: Maybe<Scalars['uuid']>;
  node_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journey_notes" */
export type JourneyNotesMaxOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_deleted_version?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneyNotesMinFields = {
  __typename?: 'journey_notes_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  is_deleted_version?: Maybe<Scalars['uuid']>;
  node_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journey_notes" */
export type JourneyNotesMinOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_deleted_version?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_notes". */
export type JourneyNotesOrderBy = {
  content?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  is_deleted_version?: InputMaybe<OrderBy>;
  journey_version?: InputMaybe<JourneysOrderBy>;
  node_id?: InputMaybe<OrderBy>;
  note_deleted_journey_version?: InputMaybe<JourneysOrderBy>;
  position?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
};

/** select columns of table "journey_notes" */
export const JourneyNotesSelectColumn = {
  /** column name */
  Content: 'content',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  IsDeletedVersion: 'is_deleted_version',
  /** column name */
  NodeId: 'node_id',
  /** column name */
  Position: 'position',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by'
} as const;

export type JourneyNotesSelectColumn = typeof JourneyNotesSelectColumn[keyof typeof JourneyNotesSelectColumn];
/** aggregate stddev on columns */
export type JourneyNotesStddevFields = {
  __typename?: 'journey_notes_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journey_notes" */
export type JourneyNotesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneyNotesStddevPopFields = {
  __typename?: 'journey_notes_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journey_notes" */
export type JourneyNotesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneyNotesStddevSampFields = {
  __typename?: 'journey_notes_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journey_notes" */
export type JourneyNotesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_notes" */
export type JourneyNotesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyNotesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyNotesStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted_version?: InputMaybe<Scalars['uuid']>;
  node_id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyNotesSumFields = {
  __typename?: 'journey_notes_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_notes" */
export type JourneyNotesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type JourneyNotesVarPopFields = {
  __typename?: 'journey_notes_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journey_notes" */
export type JourneyNotesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneyNotesVarSampFields = {
  __typename?: 'journey_notes_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journey_notes" */
export type JourneyNotesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneyNotesVarianceFields = {
  __typename?: 'journey_notes_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journey_notes" */
export type JourneyNotesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_runs" */
export type JourneyRuns = {
  __typename?: 'journey_runs';
  completed_count?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  entry_count?: Maybe<Scalars['bigint']>;
  error?: Maybe<Scalars['String']>;
  exit_count?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  journey_id: Scalars['uuid'];
  /** An array relationship */
  journey_node_runs: Array<JourneyNodeRuns>;
  /** An object relationship */
  journey_version?: Maybe<Journeys>;
  journey_version_id: Scalars['uuid'];
  reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  simulation?: Maybe<JourneySimulations>;
  simulation_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  unique_completed_count?: Maybe<Scalars['bigint']>;
  unique_entry_count?: Maybe<Scalars['bigint']>;
  unique_exit_count?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "journey_runs" */
export type JourneyRunsJourneyNodeRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodeRunsOrderBy>>;
  where?: InputMaybe<JourneyNodeRunsBoolExp>;
};

/** aggregated selection of "journey_runs" */
export type JourneyRunsAggregate = {
  __typename?: 'journey_runs_aggregate';
  aggregate?: Maybe<JourneyRunsAggregateFields>;
  nodes: Array<JourneyRuns>;
};

export type JourneyRunsAggregateBoolExp = {
  count?: InputMaybe<JourneyRunsAggregateBoolExpCount>;
};

export type JourneyRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneyRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journey_runs" */
export type JourneyRunsAggregateFields = {
  __typename?: 'journey_runs_aggregate_fields';
  avg?: Maybe<JourneyRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyRunsMaxFields>;
  min?: Maybe<JourneyRunsMinFields>;
  stddev?: Maybe<JourneyRunsStddevFields>;
  stddev_pop?: Maybe<JourneyRunsStddevPopFields>;
  stddev_samp?: Maybe<JourneyRunsStddevSampFields>;
  sum?: Maybe<JourneyRunsSumFields>;
  var_pop?: Maybe<JourneyRunsVarPopFields>;
  var_samp?: Maybe<JourneyRunsVarSampFields>;
  variance?: Maybe<JourneyRunsVarianceFields>;
};


/** aggregate fields of "journey_runs" */
export type JourneyRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journey_runs" */
export type JourneyRunsAggregateOrderBy = {
  avg?: InputMaybe<JourneyRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneyRunsMaxOrderBy>;
  min?: InputMaybe<JourneyRunsMinOrderBy>;
  stddev?: InputMaybe<JourneyRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneyRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneyRunsStddevSampOrderBy>;
  sum?: InputMaybe<JourneyRunsSumOrderBy>;
  var_pop?: InputMaybe<JourneyRunsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneyRunsVarSampOrderBy>;
  variance?: InputMaybe<JourneyRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type JourneyRunsAvgFields = {
  __typename?: 'journey_runs_avg_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journey_runs" */
export type JourneyRunsAvgOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_runs". All fields are combined with a logical 'AND'. */
export type JourneyRunsBoolExp = {
  _and?: InputMaybe<Array<JourneyRunsBoolExp>>;
  _not?: InputMaybe<JourneyRunsBoolExp>;
  _or?: InputMaybe<Array<JourneyRunsBoolExp>>;
  completed_count?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  entry_count?: InputMaybe<BigintComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  exit_count?: InputMaybe<BigintComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_node_runs?: InputMaybe<JourneyNodeRunsBoolExp>;
  journey_version?: InputMaybe<JourneysBoolExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  simulation?: InputMaybe<JourneySimulationsBoolExp>;
  simulation_id?: InputMaybe<UuidComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  unique_completed_count?: InputMaybe<BigintComparisonExp>;
  unique_entry_count?: InputMaybe<BigintComparisonExp>;
  unique_exit_count?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type JourneyRunsMaxFields = {
  __typename?: 'journey_runs_max_fields';
  completed_count?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entry_count?: Maybe<Scalars['bigint']>;
  error?: Maybe<Scalars['String']>;
  exit_count?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  simulation_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  unique_completed_count?: Maybe<Scalars['bigint']>;
  unique_entry_count?: Maybe<Scalars['bigint']>;
  unique_exit_count?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journey_runs" */
export type JourneyRunsMaxOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  simulation_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneyRunsMinFields = {
  __typename?: 'journey_runs_min_fields';
  completed_count?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  entry_count?: Maybe<Scalars['bigint']>;
  error?: Maybe<Scalars['String']>;
  exit_count?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  simulation_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  unique_completed_count?: Maybe<Scalars['bigint']>;
  unique_entry_count?: Maybe<Scalars['bigint']>;
  unique_exit_count?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journey_runs" */
export type JourneyRunsMinOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  simulation_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_runs". */
export type JourneyRunsOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_node_runs_aggregate?: InputMaybe<JourneyNodeRunsAggregateOrderBy>;
  journey_version?: InputMaybe<JourneysOrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  simulation?: InputMaybe<JourneySimulationsOrderBy>;
  simulation_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_runs" */
export const JourneyRunsSelectColumn = {
  /** column name */
  CompletedCount: 'completed_count',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  EntryCount: 'entry_count',
  /** column name */
  Error: 'error',
  /** column name */
  ExitCount: 'exit_count',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  Reason: 'reason',
  /** column name */
  SimulationId: 'simulation_id',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  UniqueCompletedCount: 'unique_completed_count',
  /** column name */
  UniqueEntryCount: 'unique_entry_count',
  /** column name */
  UniqueExitCount: 'unique_exit_count'
} as const;

export type JourneyRunsSelectColumn = typeof JourneyRunsSelectColumn[keyof typeof JourneyRunsSelectColumn];
/** aggregate stddev on columns */
export type JourneyRunsStddevFields = {
  __typename?: 'journey_runs_stddev_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journey_runs" */
export type JourneyRunsStddevOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneyRunsStddevPopFields = {
  __typename?: 'journey_runs_stddev_pop_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journey_runs" */
export type JourneyRunsStddevPopOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneyRunsStddevSampFields = {
  __typename?: 'journey_runs_stddev_samp_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journey_runs" */
export type JourneyRunsStddevSampOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_runs" */
export type JourneyRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyRunsStreamCursorValueInput = {
  completed_count?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entry_count?: InputMaybe<Scalars['bigint']>;
  error?: InputMaybe<Scalars['String']>;
  exit_count?: InputMaybe<Scalars['bigint']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  simulation_id?: InputMaybe<Scalars['uuid']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  unique_completed_count?: InputMaybe<Scalars['bigint']>;
  unique_entry_count?: InputMaybe<Scalars['bigint']>;
  unique_exit_count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyRunsSumFields = {
  __typename?: 'journey_runs_sum_fields';
  completed_count?: Maybe<Scalars['bigint']>;
  entry_count?: Maybe<Scalars['bigint']>;
  exit_count?: Maybe<Scalars['bigint']>;
  unique_completed_count?: Maybe<Scalars['bigint']>;
  unique_entry_count?: Maybe<Scalars['bigint']>;
  unique_exit_count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_runs" */
export type JourneyRunsSumOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type JourneyRunsVarPopFields = {
  __typename?: 'journey_runs_var_pop_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journey_runs" */
export type JourneyRunsVarPopOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneyRunsVarSampFields = {
  __typename?: 'journey_runs_var_samp_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journey_runs" */
export type JourneyRunsVarSampOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneyRunsVarianceFields = {
  __typename?: 'journey_runs_variance_fields';
  completed_count?: Maybe<Scalars['Float']>;
  entry_count?: Maybe<Scalars['Float']>;
  exit_count?: Maybe<Scalars['Float']>;
  unique_completed_count?: Maybe<Scalars['Float']>;
  unique_entry_count?: Maybe<Scalars['Float']>;
  unique_exit_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journey_runs" */
export type JourneyRunsVarianceOrderBy = {
  completed_count?: InputMaybe<OrderBy>;
  entry_count?: InputMaybe<OrderBy>;
  exit_count?: InputMaybe<OrderBy>;
  unique_completed_count?: InputMaybe<OrderBy>;
  unique_entry_count?: InputMaybe<OrderBy>;
  unique_exit_count?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_simulations" */
export type JourneySimulations = {
  __typename?: 'journey_simulations';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  entry_execution_timestamp: Scalars['timestamptz'];
  id: Scalars['uuid'];
  journey_id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
  output_warehouse_tablename?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "journey_simulations" */
export type JourneySimulationsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "journey_simulations" */
export type JourneySimulationsAggregate = {
  __typename?: 'journey_simulations_aggregate';
  aggregate?: Maybe<JourneySimulationsAggregateFields>;
  nodes: Array<JourneySimulations>;
};

/** aggregate fields of "journey_simulations" */
export type JourneySimulationsAggregateFields = {
  __typename?: 'journey_simulations_aggregate_fields';
  avg?: Maybe<JourneySimulationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneySimulationsMaxFields>;
  min?: Maybe<JourneySimulationsMinFields>;
  stddev?: Maybe<JourneySimulationsStddevFields>;
  stddev_pop?: Maybe<JourneySimulationsStddevPopFields>;
  stddev_samp?: Maybe<JourneySimulationsStddevSampFields>;
  sum?: Maybe<JourneySimulationsSumFields>;
  var_pop?: Maybe<JourneySimulationsVarPopFields>;
  var_samp?: Maybe<JourneySimulationsVarSampFields>;
  variance?: Maybe<JourneySimulationsVarianceFields>;
};


/** aggregate fields of "journey_simulations" */
export type JourneySimulationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneySimulationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JourneySimulationsAvgFields = {
  __typename?: 'journey_simulations_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "journey_simulations". All fields are combined with a logical 'AND'. */
export type JourneySimulationsBoolExp = {
  _and?: InputMaybe<Array<JourneySimulationsBoolExp>>;
  _not?: InputMaybe<JourneySimulationsBoolExp>;
  _or?: InputMaybe<Array<JourneySimulationsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  entry_execution_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  output_warehouse_tablename?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "journey_simulations" */
export const JourneySimulationsConstraint = {
  /** unique or primary key constraint on columns "id" */
  JourneySimulationsPkey: 'journey_simulations_pkey'
} as const;

export type JourneySimulationsConstraint = typeof JourneySimulationsConstraint[keyof typeof JourneySimulationsConstraint];
/** input type for inserting data into table "journey_simulations" */
export type JourneySimulationsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  entry_execution_timestamp?: InputMaybe<Scalars['timestamptz']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JourneySimulationsMaxFields = {
  __typename?: 'journey_simulations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  entry_execution_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  output_warehouse_tablename?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JourneySimulationsMinFields = {
  __typename?: 'journey_simulations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  entry_execution_timestamp?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  journey_id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  output_warehouse_tablename?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "journey_simulations" */
export type JourneySimulationsMutationResponse = {
  __typename?: 'journey_simulations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JourneySimulations>;
};

/** on_conflict condition type for table "journey_simulations" */
export type JourneySimulationsOnConflict = {
  constraint: JourneySimulationsConstraint;
  update_columns?: Array<JourneySimulationsUpdateColumn>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};

/** Ordering options when selecting data from "journey_simulations". */
export type JourneySimulationsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  entry_execution_timestamp?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  output_warehouse_tablename?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_simulations" */
export const JourneySimulationsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EntryExecutionTimestamp: 'entry_execution_timestamp',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  OutputWarehouseTablename: 'output_warehouse_tablename',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type JourneySimulationsSelectColumn = typeof JourneySimulationsSelectColumn[keyof typeof JourneySimulationsSelectColumn];
/** aggregate stddev on columns */
export type JourneySimulationsStddevFields = {
  __typename?: 'journey_simulations_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JourneySimulationsStddevPopFields = {
  __typename?: 'journey_simulations_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JourneySimulationsStddevSampFields = {
  __typename?: 'journey_simulations_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "journey_simulations" */
export type JourneySimulationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneySimulationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneySimulationsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  entry_execution_timestamp?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  output_warehouse_tablename?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JourneySimulationsSumFields = {
  __typename?: 'journey_simulations_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "journey_simulations" (current role has no relevant permissions) */
export const JourneySimulationsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type JourneySimulationsUpdateColumn = typeof JourneySimulationsUpdateColumn[keyof typeof JourneySimulationsUpdateColumn];
/** aggregate var_pop on columns */
export type JourneySimulationsVarPopFields = {
  __typename?: 'journey_simulations_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JourneySimulationsVarSampFields = {
  __typename?: 'journey_simulations_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JourneySimulationsVarianceFields = {
  __typename?: 'journey_simulations_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "journey_syncs" */
export type JourneySyncs = {
  __typename?: 'journey_syncs';
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  exit_config: Scalars['jsonb'];
  id: Scalars['uuid'];
  /** An object relationship */
  journey_node: JourneyNodes;
  journey_version_id: Scalars['uuid'];
  mode: Scalars['String'];
  node_id: Scalars['uuid'];
  /** An object relationship */
  placeholder_destination?: Maybe<Destinations>;
  placeholder_destination_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync?: Maybe<Syncs>;
};


/** columns and relationships of "journey_syncs" */
export type JourneySyncsExitConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "journey_syncs" */
export type JourneySyncsAggregateOrderBy = {
  avg?: InputMaybe<JourneySyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneySyncsMaxOrderBy>;
  min?: InputMaybe<JourneySyncsMinOrderBy>;
  stddev?: InputMaybe<JourneySyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneySyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneySyncsStddevSampOrderBy>;
  sum?: InputMaybe<JourneySyncsSumOrderBy>;
  var_pop?: InputMaybe<JourneySyncsVarPopOrderBy>;
  var_samp?: InputMaybe<JourneySyncsVarSampOrderBy>;
  variance?: InputMaybe<JourneySyncsVarianceOrderBy>;
};

/** order by avg() on columns of table "journey_syncs" */
export type JourneySyncsAvgOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journey_syncs". All fields are combined with a logical 'AND'. */
export type JourneySyncsBoolExp = {
  _and?: InputMaybe<Array<JourneySyncsBoolExp>>;
  _not?: InputMaybe<JourneySyncsBoolExp>;
  _or?: InputMaybe<Array<JourneySyncsBoolExp>>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  exit_config?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_node?: InputMaybe<JourneyNodesBoolExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  mode?: InputMaybe<StringComparisonExp>;
  node_id?: InputMaybe<UuidComparisonExp>;
  placeholder_destination?: InputMaybe<DestinationsBoolExp>;
  placeholder_destination_id?: InputMaybe<BigintComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
};

/** order by max() on columns of table "journey_syncs" */
export type JourneySyncsMaxOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  mode?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "journey_syncs" */
export type JourneySyncsMinOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  mode?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "journey_syncs". */
export type JourneySyncsOrderBy = {
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  exit_config?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_node?: InputMaybe<JourneyNodesOrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  mode?: InputMaybe<OrderBy>;
  node_id?: InputMaybe<OrderBy>;
  placeholder_destination?: InputMaybe<DestinationsOrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
};

/** select columns of table "journey_syncs" */
export const JourneySyncsSelectColumn = {
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  ExitConfig: 'exit_config',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  Mode: 'mode',
  /** column name */
  NodeId: 'node_id',
  /** column name */
  PlaceholderDestinationId: 'placeholder_destination_id',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type JourneySyncsSelectColumn = typeof JourneySyncsSelectColumn[keyof typeof JourneySyncsSelectColumn];
/** order by stddev() on columns of table "journey_syncs" */
export type JourneySyncsStddevOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "journey_syncs" */
export type JourneySyncsStddevPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "journey_syncs" */
export type JourneySyncsStddevSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journey_syncs" */
export type JourneySyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneySyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneySyncsStreamCursorValueInput = {
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  exit_config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  mode?: InputMaybe<Scalars['String']>;
  node_id?: InputMaybe<Scalars['uuid']>;
  placeholder_destination_id?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journey_syncs" */
export type JourneySyncsSumOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "journey_syncs" */
export type JourneySyncsVarPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "journey_syncs" */
export type JourneySyncsVarSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "journey_syncs" */
export type JourneySyncsVarianceOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "journey_template_references" */
export type JourneyTemplateReferences = {
  __typename?: 'journey_template_references';
  /** An object relationship */
  destination?: Maybe<Destinations>;
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  journey_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  journey_template: JourneyTemplates;
  /** An object relationship */
  journeys?: Maybe<Journeys>;
  model_relationship_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  model_relationships?: Maybe<ModelRelationships>;
  placeholder_destination_id?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  segments?: Maybe<Segments>;
  template_id: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "journey_template_references". All fields are combined with a logical 'AND'. */
export type JourneyTemplateReferencesBoolExp = {
  _and?: InputMaybe<Array<JourneyTemplateReferencesBoolExp>>;
  _not?: InputMaybe<JourneyTemplateReferencesBoolExp>;
  _or?: InputMaybe<Array<JourneyTemplateReferencesBoolExp>>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_template?: InputMaybe<JourneyTemplatesBoolExp>;
  journeys?: InputMaybe<JourneysBoolExp>;
  model_relationship_id?: InputMaybe<BigintComparisonExp>;
  model_relationships?: InputMaybe<ModelRelationshipsBoolExp>;
  placeholder_destination_id?: InputMaybe<BigintComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  segments?: InputMaybe<SegmentsBoolExp>;
  template_id?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "journey_template_references". */
export type JourneyTemplateReferencesOrderBy = {
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_template?: InputMaybe<JourneyTemplatesOrderBy>;
  journeys?: InputMaybe<JourneysOrderBy>;
  model_relationship_id?: InputMaybe<OrderBy>;
  model_relationships?: InputMaybe<ModelRelationshipsOrderBy>;
  placeholder_destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  segments?: InputMaybe<SegmentsOrderBy>;
  template_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_template_references" */
export const JourneyTemplateReferencesSelectColumn = {
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  Id: 'id',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  ModelRelationshipId: 'model_relationship_id',
  /** column name */
  PlaceholderDestinationId: 'placeholder_destination_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  TemplateId: 'template_id'
} as const;

export type JourneyTemplateReferencesSelectColumn = typeof JourneyTemplateReferencesSelectColumn[keyof typeof JourneyTemplateReferencesSelectColumn];
/** Streaming cursor of the table "journey_template_references" */
export type JourneyTemplateReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyTemplateReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyTemplateReferencesStreamCursorValueInput = {
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  model_relationship_id?: InputMaybe<Scalars['bigint']>;
  placeholder_destination_id?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "journey_templates" */
export type JourneyTemplates = {
  __typename?: 'journey_templates';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  definition: Scalars['jsonb'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  labels?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "journey_templates" */
export type JourneyTemplatesDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "journey_templates" */
export type JourneyTemplatesLabelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "journey_templates" */
export type JourneyTemplatesAggregate = {
  __typename?: 'journey_templates_aggregate';
  aggregate?: Maybe<JourneyTemplatesAggregateFields>;
  nodes: Array<JourneyTemplates>;
};

/** aggregate fields of "journey_templates" */
export type JourneyTemplatesAggregateFields = {
  __typename?: 'journey_templates_aggregate_fields';
  avg?: Maybe<JourneyTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneyTemplatesMaxFields>;
  min?: Maybe<JourneyTemplatesMinFields>;
  stddev?: Maybe<JourneyTemplatesStddevFields>;
  stddev_pop?: Maybe<JourneyTemplatesStddevPopFields>;
  stddev_samp?: Maybe<JourneyTemplatesStddevSampFields>;
  sum?: Maybe<JourneyTemplatesSumFields>;
  var_pop?: Maybe<JourneyTemplatesVarPopFields>;
  var_samp?: Maybe<JourneyTemplatesVarSampFields>;
  variance?: Maybe<JourneyTemplatesVarianceFields>;
};


/** aggregate fields of "journey_templates" */
export type JourneyTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneyTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JourneyTemplatesAvgFields = {
  __typename?: 'journey_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "journey_templates". All fields are combined with a logical 'AND'. */
export type JourneyTemplatesBoolExp = {
  _and?: InputMaybe<Array<JourneyTemplatesBoolExp>>;
  _not?: InputMaybe<JourneyTemplatesBoolExp>;
  _or?: InputMaybe<Array<JourneyTemplatesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  definition?: InputMaybe<JsonbComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  labels?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "journey_templates" */
export const JourneyTemplatesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  JourneyTemplatesIdWorkspaceIdKey: 'journey_templates_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  JourneyTemplatesPkey: 'journey_templates_pkey'
} as const;

export type JourneyTemplatesConstraint = typeof JourneyTemplatesConstraint[keyof typeof JourneyTemplatesConstraint];
/** input type for inserting data into table "journey_templates" */
export type JourneyTemplatesInsertInput = {
  definition?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JourneyTemplatesMaxFields = {
  __typename?: 'journey_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JourneyTemplatesMinFields = {
  __typename?: 'journey_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "journey_templates" */
export type JourneyTemplatesMutationResponse = {
  __typename?: 'journey_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JourneyTemplates>;
};

/** on_conflict condition type for table "journey_templates" */
export type JourneyTemplatesOnConflict = {
  constraint: JourneyTemplatesConstraint;
  update_columns?: Array<JourneyTemplatesUpdateColumn>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};

/** Ordering options when selecting data from "journey_templates". */
export type JourneyTemplatesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  definition?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  labels?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "journey_templates" */
export const JourneyTemplatesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Definition: 'definition',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Labels: 'labels',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type JourneyTemplatesSelectColumn = typeof JourneyTemplatesSelectColumn[keyof typeof JourneyTemplatesSelectColumn];
/** aggregate stddev on columns */
export type JourneyTemplatesStddevFields = {
  __typename?: 'journey_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JourneyTemplatesStddevPopFields = {
  __typename?: 'journey_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JourneyTemplatesStddevSampFields = {
  __typename?: 'journey_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "journey_templates" */
export type JourneyTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneyTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneyTemplatesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  definition?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneyTemplatesSumFields = {
  __typename?: 'journey_templates_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "journey_templates" (current role has no relevant permissions) */
export const JourneyTemplatesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type JourneyTemplatesUpdateColumn = typeof JourneyTemplatesUpdateColumn[keyof typeof JourneyTemplatesUpdateColumn];
/** aggregate var_pop on columns */
export type JourneyTemplatesVarPopFields = {
  __typename?: 'journey_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JourneyTemplatesVarSampFields = {
  __typename?: 'journey_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JourneyTemplatesVarianceFields = {
  __typename?: 'journey_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "journeys" */
export type Journeys = {
  __typename?: 'journeys';
  archived: Scalars['Boolean'];
  context_config?: Maybe<Scalars['jsonb']>;
  context_model_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  drafts: Array<JourneyDrafts>;
  /** An aggregate relationship */
  drafts_aggregate: JourneyDraftsAggregate;
  /** An array relationship */
  edges: Array<JourneyEdges>;
  execution_mode: Scalars['String'];
  exit_criteria?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  is_latest: Scalars['Boolean'];
  /** An array relationship */
  journey_labels: Array<JourneyLabels>;
  /** An aggregate relationship */
  journey_labels_aggregate: JourneyLabelsAggregate;
  name: Scalars['String'];
  /** An array relationship */
  nodes: Array<JourneyNodes>;
  /** An aggregate relationship */
  nodes_aggregate: JourneyNodesAggregate;
  /** An array relationship */
  notes: Array<JourneyNotes>;
  /** An aggregate relationship */
  notes_aggregate: JourneyNotesAggregate;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  reset?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  runs: Array<JourneyRuns>;
  /** An aggregate relationship */
  runs_aggregate: JourneyRunsAggregate;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_updated_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  version_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "journeys" */
export type JourneysContextConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "journeys" */
export type JourneysDraftsArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysEdgesArgs = {
  distinct_on?: InputMaybe<Array<JourneyEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyEdgesOrderBy>>;
  where?: InputMaybe<JourneyEdgesBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysExitCriteriaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "journeys" */
export type JourneysJourneyLabelsArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysJourneyLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysNodesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysNodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysNotesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysNotesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


/** columns and relationships of "journeys" */
export type JourneysScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "journeys" */
export type JourneysAggregate = {
  __typename?: 'journeys_aggregate';
  aggregate?: Maybe<JourneysAggregateFields>;
  nodes: Array<Journeys>;
};

export type JourneysAggregateBoolExp = {
  bool_and?: InputMaybe<JourneysAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<JourneysAggregateBoolExpBoolOr>;
  count?: InputMaybe<JourneysAggregateBoolExpCount>;
};

export type JourneysAggregateBoolExpBoolAnd = {
  arguments: JourneysSelectColumnJourneysAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneysBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JourneysAggregateBoolExpBoolOr = {
  arguments: JourneysSelectColumnJourneysAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneysBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JourneysAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JourneysSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JourneysBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "journeys" */
export type JourneysAggregateFields = {
  __typename?: 'journeys_aggregate_fields';
  avg?: Maybe<JourneysAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JourneysMaxFields>;
  min?: Maybe<JourneysMinFields>;
  stddev?: Maybe<JourneysStddevFields>;
  stddev_pop?: Maybe<JourneysStddevPopFields>;
  stddev_samp?: Maybe<JourneysStddevSampFields>;
  sum?: Maybe<JourneysSumFields>;
  var_pop?: Maybe<JourneysVarPopFields>;
  var_samp?: Maybe<JourneysVarSampFields>;
  variance?: Maybe<JourneysVarianceFields>;
};


/** aggregate fields of "journeys" */
export type JourneysAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JourneysSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "journeys" */
export type JourneysAggregateOrderBy = {
  avg?: InputMaybe<JourneysAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JourneysMaxOrderBy>;
  min?: InputMaybe<JourneysMinOrderBy>;
  stddev?: InputMaybe<JourneysStddevOrderBy>;
  stddev_pop?: InputMaybe<JourneysStddevPopOrderBy>;
  stddev_samp?: InputMaybe<JourneysStddevSampOrderBy>;
  sum?: InputMaybe<JourneysSumOrderBy>;
  var_pop?: InputMaybe<JourneysVarPopOrderBy>;
  var_samp?: InputMaybe<JourneysVarSampOrderBy>;
  variance?: InputMaybe<JourneysVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "journeys" */
export type JourneysArrRelInsertInput = {
  data: Array<JourneysInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<JourneysOnConflict>;
};

/** aggregate avg on columns */
export type JourneysAvgFields = {
  __typename?: 'journeys_avg_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "journeys" */
export type JourneysAvgOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "journeys". All fields are combined with a logical 'AND'. */
export type JourneysBoolExp = {
  _and?: InputMaybe<Array<JourneysBoolExp>>;
  _not?: InputMaybe<JourneysBoolExp>;
  _or?: InputMaybe<Array<JourneysBoolExp>>;
  archived?: InputMaybe<BooleanComparisonExp>;
  context_config?: InputMaybe<JsonbComparisonExp>;
  context_model_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted?: InputMaybe<BooleanComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  drafts?: InputMaybe<JourneyDraftsBoolExp>;
  drafts_aggregate?: InputMaybe<JourneyDraftsAggregateBoolExp>;
  edges?: InputMaybe<JourneyEdgesBoolExp>;
  execution_mode?: InputMaybe<StringComparisonExp>;
  exit_criteria?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_latest?: InputMaybe<BooleanComparisonExp>;
  journey_labels?: InputMaybe<JourneyLabelsBoolExp>;
  journey_labels_aggregate?: InputMaybe<JourneyLabelsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  nodes?: InputMaybe<JourneyNodesBoolExp>;
  nodes_aggregate?: InputMaybe<JourneyNodesAggregateBoolExp>;
  notes?: InputMaybe<JourneyNotesBoolExp>;
  notes_aggregate?: InputMaybe<JourneyNotesAggregateBoolExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  reset?: InputMaybe<BooleanComparisonExp>;
  runs?: InputMaybe<JourneyRunsBoolExp>;
  runs_aggregate?: InputMaybe<JourneyRunsAggregateBoolExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_updated_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  version_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "journeys" */
export const JourneysConstraint = {
  /** unique or primary key constraint on columns "id", "version_id", "workspace_id" */
  JourneysIdVersionIdWorkspaceIdKey: 'journeys_id_version_id_workspace_id_key',
  /** unique or primary key constraint on columns "id", "is_latest" */
  JourneysOneLatestPerJourney: 'journeys_one_latest_per_journey',
  /** unique or primary key constraint on columns "id", "version_id" */
  JourneysPkey: 'journeys_pkey'
} as const;

export type JourneysConstraint = typeof JourneysConstraint[keyof typeof JourneysConstraint];
/** input type for inserting data into table "journeys" */
export type JourneysInsertInput = {
  context_config?: InputMaybe<Scalars['jsonb']>;
  context_model_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  execution_mode?: InputMaybe<Scalars['String']>;
  exit_criteria?: InputMaybe<Scalars['jsonb']>;
  is_latest?: InputMaybe<Scalars['Boolean']>;
  journey_labels?: InputMaybe<JourneyLabelsArrRelInsertInput>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type JourneysMaxFields = {
  __typename?: 'journeys_max_fields';
  context_model_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  execution_mode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  schedule_updated_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "journeys" */
export type JourneysMaxOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  schedule_updated_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JourneysMinFields = {
  __typename?: 'journeys_min_fields';
  context_model_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  execution_mode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  schedule_updated_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "journeys" */
export type JourneysMinOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  schedule_updated_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "journeys" */
export type JourneysMutationResponse = {
  __typename?: 'journeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Journeys>;
};

/** input type for inserting object relation for remote table "journeys" */
export type JourneysObjRelInsertInput = {
  data: JourneysInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<JourneysOnConflict>;
};

/** on_conflict condition type for table "journeys" */
export type JourneysOnConflict = {
  constraint: JourneysConstraint;
  update_columns?: Array<JourneysUpdateColumn>;
  where?: InputMaybe<JourneysBoolExp>;
};

/** Ordering options when selecting data from "journeys". */
export type JourneysOrderBy = {
  archived?: InputMaybe<OrderBy>;
  context_config?: InputMaybe<OrderBy>;
  context_model_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  drafts_aggregate?: InputMaybe<JourneyDraftsAggregateOrderBy>;
  edges_aggregate?: InputMaybe<JourneyEdgesAggregateOrderBy>;
  execution_mode?: InputMaybe<OrderBy>;
  exit_criteria?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_latest?: InputMaybe<OrderBy>;
  journey_labels_aggregate?: InputMaybe<JourneyLabelsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  nodes_aggregate?: InputMaybe<JourneyNodesAggregateOrderBy>;
  notes_aggregate?: InputMaybe<JourneyNotesAggregateOrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  reset?: InputMaybe<OrderBy>;
  runs_aggregate?: InputMaybe<JourneyRunsAggregateOrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_updated_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: journeys */
export type JourneysPkColumnsInput = {
  id: Scalars['uuid'];
  version_id: Scalars['uuid'];
};

/** select columns of table "journeys" */
export const JourneysSelectColumn = {
  /** column name */
  Archived: 'archived',
  /** column name */
  ContextConfig: 'context_config',
  /** column name */
  ContextModelId: 'context_model_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Deleted: 'deleted',
  /** column name */
  Description: 'description',
  /** column name */
  ExecutionMode: 'execution_mode',
  /** column name */
  ExitCriteria: 'exit_criteria',
  /** column name */
  Id: 'id',
  /** column name */
  IsLatest: 'is_latest',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Reset: 'reset',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  ScheduleUpdatedAt: 'schedule_updated_at',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VersionId: 'version_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type JourneysSelectColumn = typeof JourneysSelectColumn[keyof typeof JourneysSelectColumn];
/** select "journeys_aggregate_bool_exp_bool_and_arguments_columns" columns of table "journeys" */
export const JourneysSelectColumnJourneysAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Archived: 'archived',
  /** column name */
  Deleted: 'deleted',
  /** column name */
  IsLatest: 'is_latest',
  /** column name */
  Reset: 'reset'
} as const;

export type JourneysSelectColumnJourneysAggregateBoolExpBoolAndArgumentsColumns = typeof JourneysSelectColumnJourneysAggregateBoolExpBoolAndArgumentsColumns[keyof typeof JourneysSelectColumnJourneysAggregateBoolExpBoolAndArgumentsColumns];
/** select "journeys_aggregate_bool_exp_bool_or_arguments_columns" columns of table "journeys" */
export const JourneysSelectColumnJourneysAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Archived: 'archived',
  /** column name */
  Deleted: 'deleted',
  /** column name */
  IsLatest: 'is_latest',
  /** column name */
  Reset: 'reset'
} as const;

export type JourneysSelectColumnJourneysAggregateBoolExpBoolOrArgumentsColumns = typeof JourneysSelectColumnJourneysAggregateBoolExpBoolOrArgumentsColumns[keyof typeof JourneysSelectColumnJourneysAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "journeys" */
export type JourneysSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type JourneysStddevFields = {
  __typename?: 'journeys_stddev_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "journeys" */
export type JourneysStddevOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type JourneysStddevPopFields = {
  __typename?: 'journeys_stddev_pop_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "journeys" */
export type JourneysStddevPopOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type JourneysStddevSampFields = {
  __typename?: 'journeys_stddev_samp_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "journeys" */
export type JourneysStddevSampOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "journeys" */
export type JourneysStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: JourneysStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JourneysStreamCursorValueInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  context_config?: InputMaybe<Scalars['jsonb']>;
  context_model_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  execution_mode?: InputMaybe<Scalars['String']>;
  exit_criteria?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_latest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  reset?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_updated_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  version_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JourneysSumFields = {
  __typename?: 'journeys_sum_fields';
  context_model_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "journeys" */
export type JourneysSumOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "journeys" */
export const JourneysUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name'
} as const;

export type JourneysUpdateColumn = typeof JourneysUpdateColumn[keyof typeof JourneysUpdateColumn];
export type JourneysUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JourneysSetInput>;
  /** filter the rows which have to be updated */
  where: JourneysBoolExp;
};

/** aggregate var_pop on columns */
export type JourneysVarPopFields = {
  __typename?: 'journeys_var_pop_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "journeys" */
export type JourneysVarPopOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type JourneysVarSampFields = {
  __typename?: 'journeys_var_samp_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "journeys" */
export type JourneysVarSampOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JourneysVarianceFields = {
  __typename?: 'journeys_variance_fields';
  context_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "journeys" */
export type JourneysVarianceOrderBy = {
  context_model_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "label_groups" */
export type LabelGroups = {
  __typename?: 'label_groups';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An array relationship */
  labels: Array<Labels>;
  /** An aggregate relationship */
  labels_aggregate: LabelsAggregate;
  name: Scalars['String'];
  resource_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "label_groups" */
export type LabelGroupsLabelsArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};


/** columns and relationships of "label_groups" */
export type LabelGroupsLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};

/** aggregated selection of "label_groups" */
export type LabelGroupsAggregate = {
  __typename?: 'label_groups_aggregate';
  aggregate?: Maybe<LabelGroupsAggregateFields>;
  nodes: Array<LabelGroups>;
};

/** aggregate fields of "label_groups" */
export type LabelGroupsAggregateFields = {
  __typename?: 'label_groups_aggregate_fields';
  avg?: Maybe<LabelGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LabelGroupsMaxFields>;
  min?: Maybe<LabelGroupsMinFields>;
  stddev?: Maybe<LabelGroupsStddevFields>;
  stddev_pop?: Maybe<LabelGroupsStddevPopFields>;
  stddev_samp?: Maybe<LabelGroupsStddevSampFields>;
  sum?: Maybe<LabelGroupsSumFields>;
  var_pop?: Maybe<LabelGroupsVarPopFields>;
  var_samp?: Maybe<LabelGroupsVarSampFields>;
  variance?: Maybe<LabelGroupsVarianceFields>;
};


/** aggregate fields of "label_groups" */
export type LabelGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LabelGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type LabelGroupsAvgFields = {
  __typename?: 'label_groups_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "label_groups". All fields are combined with a logical 'AND'. */
export type LabelGroupsBoolExp = {
  _and?: InputMaybe<Array<LabelGroupsBoolExp>>;
  _not?: InputMaybe<LabelGroupsBoolExp>;
  _or?: InputMaybe<Array<LabelGroupsBoolExp>>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  labels?: InputMaybe<LabelsBoolExp>;
  labels_aggregate?: InputMaybe<LabelsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "label_groups" */
export const LabelGroupsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id", "resource_type" */
  LabelGroupsIdWorkspaceResourceTypeKey: 'label_groups_id_workspace_resource_type_key',
  /** unique or primary key constraint on columns "id" */
  LabelGroupsPkey: 'label_groups_pkey',
  /** unique or primary key constraint on columns "workspace_id", "resource_type" */
  LabelGroupsWorkspaceResourceTypeNameKey: 'label_groups_workspace_resource_type_name_key'
} as const;

export type LabelGroupsConstraint = typeof LabelGroupsConstraint[keyof typeof LabelGroupsConstraint];
/** input type for inserting data into table "label_groups" */
export type LabelGroupsInsertInput = {
  labels?: InputMaybe<LabelsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LabelGroupsMaxFields = {
  __typename?: 'label_groups_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type LabelGroupsMinFields = {
  __typename?: 'label_groups_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "label_groups" */
export type LabelGroupsMutationResponse = {
  __typename?: 'label_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LabelGroups>;
};

/** input type for inserting object relation for remote table "label_groups" */
export type LabelGroupsObjRelInsertInput = {
  data: LabelGroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LabelGroupsOnConflict>;
};

/** on_conflict condition type for table "label_groups" */
export type LabelGroupsOnConflict = {
  constraint: LabelGroupsConstraint;
  update_columns?: Array<LabelGroupsUpdateColumn>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};

/** Ordering options when selecting data from "label_groups". */
export type LabelGroupsOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  labels_aggregate?: InputMaybe<LabelsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: label_groups */
export type LabelGroupsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "label_groups" */
export const LabelGroupsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LabelGroupsSelectColumn = typeof LabelGroupsSelectColumn[keyof typeof LabelGroupsSelectColumn];
/** input type for updating data in table "label_groups" */
export type LabelGroupsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LabelGroupsStddevFields = {
  __typename?: 'label_groups_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type LabelGroupsStddevPopFields = {
  __typename?: 'label_groups_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type LabelGroupsStddevSampFields = {
  __typename?: 'label_groups_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "label_groups" */
export type LabelGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LabelGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LabelGroupsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LabelGroupsSumFields = {
  __typename?: 'label_groups_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "label_groups" */
export const LabelGroupsUpdateColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  Name: 'name'
} as const;

export type LabelGroupsUpdateColumn = typeof LabelGroupsUpdateColumn[keyof typeof LabelGroupsUpdateColumn];
export type LabelGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LabelGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: LabelGroupsBoolExp;
};

/** aggregate var_pop on columns */
export type LabelGroupsVarPopFields = {
  __typename?: 'label_groups_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type LabelGroupsVarSampFields = {
  __typename?: 'label_groups_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type LabelGroupsVarianceFields = {
  __typename?: 'label_groups_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "labels" */
export type Labels = {
  __typename?: 'labels';
  /** An array relationship */
  campaign_labels: Array<CampaignLabels>;
  /** An aggregate relationship */
  campaign_labels_aggregate: CampaignLabelsAggregate;
  /** An array relationship */
  condition_template_labels: Array<ConditionTemplateLabels>;
  /** An aggregate relationship */
  condition_template_labels_aggregate: ConditionTemplateLabelsAggregate;
  /** An array relationship */
  content_block_labels: Array<ContentBlockLabels>;
  /** An aggregate relationship */
  content_block_labels_aggregate: ContentBlockLabelsAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An array relationship */
  email_template_labels: Array<EmailTemplateLabels>;
  /** An aggregate relationship */
  email_template_labels_aggregate: EmailTemplateLabelsAggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  journey_labels: Array<JourneyLabels>;
  /** An aggregate relationship */
  journey_labels_aggregate: JourneyLabelsAggregate;
  /** An object relationship */
  label_group: LabelGroups;
  label_group_id: Scalars['uuid'];
  /** An array relationship */
  message_labels: Array<MessageLabels>;
  /** An aggregate relationship */
  message_labels_aggregate: MessageLabelsAggregate;
  name: Scalars['String'];
  resource_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "labels" */
export type LabelsCampaignLabelsArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsCampaignLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsConditionTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsConditionTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsContentBlockLabelsArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsContentBlockLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsEmailTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsEmailTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsJourneyLabelsArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsJourneyLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsMessageLabelsArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


/** columns and relationships of "labels" */
export type LabelsMessageLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};

/** aggregated selection of "labels" */
export type LabelsAggregate = {
  __typename?: 'labels_aggregate';
  aggregate?: Maybe<LabelsAggregateFields>;
  nodes: Array<Labels>;
};

export type LabelsAggregateBoolExp = {
  count?: InputMaybe<LabelsAggregateBoolExpCount>;
};

export type LabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "labels" */
export type LabelsAggregateFields = {
  __typename?: 'labels_aggregate_fields';
  avg?: Maybe<LabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LabelsMaxFields>;
  min?: Maybe<LabelsMinFields>;
  stddev?: Maybe<LabelsStddevFields>;
  stddev_pop?: Maybe<LabelsStddevPopFields>;
  stddev_samp?: Maybe<LabelsStddevSampFields>;
  sum?: Maybe<LabelsSumFields>;
  var_pop?: Maybe<LabelsVarPopFields>;
  var_samp?: Maybe<LabelsVarSampFields>;
  variance?: Maybe<LabelsVarianceFields>;
};


/** aggregate fields of "labels" */
export type LabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "labels" */
export type LabelsAggregateOrderBy = {
  avg?: InputMaybe<LabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LabelsMaxOrderBy>;
  min?: InputMaybe<LabelsMinOrderBy>;
  stddev?: InputMaybe<LabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<LabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LabelsStddevSampOrderBy>;
  sum?: InputMaybe<LabelsSumOrderBy>;
  var_pop?: InputMaybe<LabelsVarPopOrderBy>;
  var_samp?: InputMaybe<LabelsVarSampOrderBy>;
  variance?: InputMaybe<LabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "labels" */
export type LabelsArrRelInsertInput = {
  data: Array<LabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LabelsOnConflict>;
};

/** aggregate avg on columns */
export type LabelsAvgFields = {
  __typename?: 'labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "labels" */
export type LabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "labels". All fields are combined with a logical 'AND'. */
export type LabelsBoolExp = {
  _and?: InputMaybe<Array<LabelsBoolExp>>;
  _not?: InputMaybe<LabelsBoolExp>;
  _or?: InputMaybe<Array<LabelsBoolExp>>;
  campaign_labels?: InputMaybe<CampaignLabelsBoolExp>;
  campaign_labels_aggregate?: InputMaybe<CampaignLabelsAggregateBoolExp>;
  condition_template_labels?: InputMaybe<ConditionTemplateLabelsBoolExp>;
  condition_template_labels_aggregate?: InputMaybe<ConditionTemplateLabelsAggregateBoolExp>;
  content_block_labels?: InputMaybe<ContentBlockLabelsBoolExp>;
  content_block_labels_aggregate?: InputMaybe<ContentBlockLabelsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  email_template_labels?: InputMaybe<EmailTemplateLabelsBoolExp>;
  email_template_labels_aggregate?: InputMaybe<EmailTemplateLabelsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_labels?: InputMaybe<JourneyLabelsBoolExp>;
  journey_labels_aggregate?: InputMaybe<JourneyLabelsAggregateBoolExp>;
  label_group?: InputMaybe<LabelGroupsBoolExp>;
  label_group_id?: InputMaybe<UuidComparisonExp>;
  message_labels?: InputMaybe<MessageLabelsBoolExp>;
  message_labels_aggregate?: InputMaybe<MessageLabelsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "labels" */
export const LabelsConstraint = {
  /** unique or primary key constraint on columns "label_group_id" */
  LabelsGroupNameKey: 'labels_group_name_key',
  /** unique or primary key constraint on columns "id", "workspace_id", "resource_type" */
  LabelsIdWorkspaceResourceTypeKey: 'labels_id_workspace_resource_type_key',
  /** unique or primary key constraint on columns "id" */
  LabelsPkey: 'labels_pkey'
} as const;

export type LabelsConstraint = typeof LabelsConstraint[keyof typeof LabelsConstraint];
/** input type for inserting data into table "labels" */
export type LabelsInsertInput = {
  campaign_labels?: InputMaybe<CampaignLabelsArrRelInsertInput>;
  condition_template_labels?: InputMaybe<ConditionTemplateLabelsArrRelInsertInput>;
  content_block_labels?: InputMaybe<ContentBlockLabelsArrRelInsertInput>;
  email_template_labels?: InputMaybe<EmailTemplateLabelsArrRelInsertInput>;
  journey_labels?: InputMaybe<JourneyLabelsArrRelInsertInput>;
  label_group?: InputMaybe<LabelGroupsObjRelInsertInput>;
  label_group_id?: InputMaybe<Scalars['uuid']>;
  message_labels?: InputMaybe<MessageLabelsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type LabelsMaxFields = {
  __typename?: 'labels_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  label_group_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "labels" */
export type LabelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label_group_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LabelsMinFields = {
  __typename?: 'labels_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  label_group_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "labels" */
export type LabelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label_group_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "labels" */
export type LabelsMutationResponse = {
  __typename?: 'labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Labels>;
};

/** input type for inserting object relation for remote table "labels" */
export type LabelsObjRelInsertInput = {
  data: LabelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LabelsOnConflict>;
};

/** on_conflict condition type for table "labels" */
export type LabelsOnConflict = {
  constraint: LabelsConstraint;
  update_columns?: Array<LabelsUpdateColumn>;
  where?: InputMaybe<LabelsBoolExp>;
};

/** Ordering options when selecting data from "labels". */
export type LabelsOrderBy = {
  campaign_labels_aggregate?: InputMaybe<CampaignLabelsAggregateOrderBy>;
  condition_template_labels_aggregate?: InputMaybe<ConditionTemplateLabelsAggregateOrderBy>;
  content_block_labels_aggregate?: InputMaybe<ContentBlockLabelsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  email_template_labels_aggregate?: InputMaybe<EmailTemplateLabelsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_labels_aggregate?: InputMaybe<JourneyLabelsAggregateOrderBy>;
  label_group?: InputMaybe<LabelGroupsOrderBy>;
  label_group_id?: InputMaybe<OrderBy>;
  message_labels_aggregate?: InputMaybe<MessageLabelsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: labels */
export type LabelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "labels" */
export const LabelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  LabelGroupId: 'label_group_id',
  /** column name */
  Name: 'name',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LabelsSelectColumn = typeof LabelsSelectColumn[keyof typeof LabelsSelectColumn];
/** input type for updating data in table "labels" */
export type LabelsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LabelsStddevFields = {
  __typename?: 'labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "labels" */
export type LabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LabelsStddevPopFields = {
  __typename?: 'labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "labels" */
export type LabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LabelsStddevSampFields = {
  __typename?: 'labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "labels" */
export type LabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "labels" */
export type LabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LabelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  label_group_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LabelsSumFields = {
  __typename?: 'labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "labels" */
export type LabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "labels" */
export const LabelsUpdateColumn = {
  /** column name */
  Name: 'name'
} as const;

export type LabelsUpdateColumn = typeof LabelsUpdateColumn[keyof typeof LabelsUpdateColumn];
export type LabelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LabelsSetInput>;
  /** filter the rows which have to be updated */
  where: LabelsBoolExp;
};

/** aggregate var_pop on columns */
export type LabelsVarPopFields = {
  __typename?: 'labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "labels" */
export type LabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LabelsVarSampFields = {
  __typename?: 'labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "labels" */
export type LabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LabelsVarianceFields = {
  __typename?: 'labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "labels" */
export type LabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lcm_message_candidates" */
export type LcmMessageCandidates = {
  __typename?: 'lcm_message_candidates';
  /** An object relationship */
  audience?: Maybe<Segments>;
  audience_id?: Maybe<Scalars['bigint']>;
  channel: Scalars['String'];
  /** An object relationship */
  content_artifact?: Maybe<CampaignArtifacts>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  favorited: Scalars['Boolean'];
  id: Scalars['uuid'];
  lcm_message_plan_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  marketing_campaign: MarketingCampaigns;
  marketing_campaign_id: Scalars['uuid'];
  /** An object relationship */
  message_plan?: Maybe<LcmMessagePlans>;
  name: Scalars['String'];
  plan_candidate_id: Scalars['String'];
  source_plan?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "lcm_message_candidates" */
export type LcmMessageCandidatesSourcePlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "lcm_message_candidates" */
export type LcmMessageCandidatesAggregate = {
  __typename?: 'lcm_message_candidates_aggregate';
  aggregate?: Maybe<LcmMessageCandidatesAggregateFields>;
  nodes: Array<LcmMessageCandidates>;
};

export type LcmMessageCandidatesAggregateBoolExp = {
  bool_and?: InputMaybe<LcmMessageCandidatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<LcmMessageCandidatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<LcmMessageCandidatesAggregateBoolExpCount>;
};

export type LcmMessageCandidatesAggregateBoolExpBoolAnd = {
  arguments: LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LcmMessageCandidatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LcmMessageCandidatesAggregateBoolExpBoolOr = {
  arguments: LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LcmMessageCandidatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type LcmMessageCandidatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LcmMessageCandidatesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lcm_message_candidates" */
export type LcmMessageCandidatesAggregateFields = {
  __typename?: 'lcm_message_candidates_aggregate_fields';
  avg?: Maybe<LcmMessageCandidatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LcmMessageCandidatesMaxFields>;
  min?: Maybe<LcmMessageCandidatesMinFields>;
  stddev?: Maybe<LcmMessageCandidatesStddevFields>;
  stddev_pop?: Maybe<LcmMessageCandidatesStddevPopFields>;
  stddev_samp?: Maybe<LcmMessageCandidatesStddevSampFields>;
  sum?: Maybe<LcmMessageCandidatesSumFields>;
  var_pop?: Maybe<LcmMessageCandidatesVarPopFields>;
  var_samp?: Maybe<LcmMessageCandidatesVarSampFields>;
  variance?: Maybe<LcmMessageCandidatesVarianceFields>;
};


/** aggregate fields of "lcm_message_candidates" */
export type LcmMessageCandidatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lcm_message_candidates" */
export type LcmMessageCandidatesAggregateOrderBy = {
  avg?: InputMaybe<LcmMessageCandidatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LcmMessageCandidatesMaxOrderBy>;
  min?: InputMaybe<LcmMessageCandidatesMinOrderBy>;
  stddev?: InputMaybe<LcmMessageCandidatesStddevOrderBy>;
  stddev_pop?: InputMaybe<LcmMessageCandidatesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LcmMessageCandidatesStddevSampOrderBy>;
  sum?: InputMaybe<LcmMessageCandidatesSumOrderBy>;
  var_pop?: InputMaybe<LcmMessageCandidatesVarPopOrderBy>;
  var_samp?: InputMaybe<LcmMessageCandidatesVarSampOrderBy>;
  variance?: InputMaybe<LcmMessageCandidatesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LcmMessageCandidatesAppendInput = {
  source_plan?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "lcm_message_candidates" */
export type LcmMessageCandidatesArrRelInsertInput = {
  data: Array<LcmMessageCandidatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<LcmMessageCandidatesOnConflict>;
};

/** aggregate avg on columns */
export type LcmMessageCandidatesAvgFields = {
  __typename?: 'lcm_message_candidates_avg_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lcm_message_candidates". All fields are combined with a logical 'AND'. */
export type LcmMessageCandidatesBoolExp = {
  _and?: InputMaybe<Array<LcmMessageCandidatesBoolExp>>;
  _not?: InputMaybe<LcmMessageCandidatesBoolExp>;
  _or?: InputMaybe<Array<LcmMessageCandidatesBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  content_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  content_artifact_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  favorited?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lcm_message_plan_id?: InputMaybe<UuidComparisonExp>;
  marketing_campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  marketing_campaign_id?: InputMaybe<UuidComparisonExp>;
  message_plan?: InputMaybe<LcmMessagePlansBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  plan_candidate_id?: InputMaybe<StringComparisonExp>;
  source_plan?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "lcm_message_candidates" */
export const LcmMessageCandidatesConstraint = {
  /** unique or primary key constraint on columns "content_email_id" */
  LcmMessageCandidatesContentEmailIdKey: 'lcm_message_candidates_content_email_id_key',
  /** unique or primary key constraint on columns "id" */
  LcmMessageCandidatesPkey: 'lcm_message_candidates_pkey',
  /** unique or primary key constraint on columns "lcm_message_plan_id", "plan_candidate_id" */
  LcmMessageCandidatesPlanCandidateUq: 'lcm_message_candidates_plan_candidate_uq',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  LcmMessageCandidatesWorkspaceUq: 'lcm_message_candidates_workspace_uq'
} as const;

export type LcmMessageCandidatesConstraint = typeof LcmMessageCandidatesConstraint[keyof typeof LcmMessageCandidatesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LcmMessageCandidatesDeleteAtPathInput = {
  source_plan?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LcmMessageCandidatesDeleteElemInput = {
  source_plan?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LcmMessageCandidatesDeleteKeyInput = {
  source_plan?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "lcm_message_candidates" */
export type LcmMessageCandidatesIncInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "lcm_message_candidates" */
export type LcmMessageCandidatesInsertInput = {
  audience?: InputMaybe<SegmentsObjRelInsertInput>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  channel?: InputMaybe<Scalars['String']>;
  content_artifact?: InputMaybe<CampaignArtifactsObjRelInsertInput>;
  content_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  lcm_message_plan_id?: InputMaybe<Scalars['uuid']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  message_plan?: InputMaybe<LcmMessagePlansObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  source_plan?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type LcmMessageCandidatesMaxFields = {
  __typename?: 'lcm_message_candidates_max_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lcm_message_plan_id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  plan_candidate_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesMaxOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lcm_message_plan_id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plan_candidate_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LcmMessageCandidatesMinFields = {
  __typename?: 'lcm_message_candidates_min_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lcm_message_plan_id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  plan_candidate_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesMinOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lcm_message_plan_id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  plan_candidate_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lcm_message_candidates" */
export type LcmMessageCandidatesMutationResponse = {
  __typename?: 'lcm_message_candidates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LcmMessageCandidates>;
};

/** on_conflict condition type for table "lcm_message_candidates" */
export type LcmMessageCandidatesOnConflict = {
  constraint: LcmMessageCandidatesConstraint;
  update_columns?: Array<LcmMessageCandidatesUpdateColumn>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};

/** Ordering options when selecting data from "lcm_message_candidates". */
export type LcmMessageCandidatesOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  favorited?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lcm_message_plan_id?: InputMaybe<OrderBy>;
  marketing_campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  message_plan?: InputMaybe<LcmMessagePlansOrderBy>;
  name?: InputMaybe<OrderBy>;
  plan_candidate_id?: InputMaybe<OrderBy>;
  source_plan?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lcm_message_candidates */
export type LcmMessageCandidatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LcmMessageCandidatesPrependInput = {
  source_plan?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "lcm_message_candidates" */
export const LcmMessageCandidatesSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Channel: 'channel',
  /** column name */
  ContentArtifactId: 'content_artifact_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Favorited: 'favorited',
  /** column name */
  Id: 'id',
  /** column name */
  LcmMessagePlanId: 'lcm_message_plan_id',
  /** column name */
  MarketingCampaignId: 'marketing_campaign_id',
  /** column name */
  Name: 'name',
  /** column name */
  PlanCandidateId: 'plan_candidate_id',
  /** column name */
  SourcePlan: 'source_plan',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LcmMessageCandidatesSelectColumn = typeof LcmMessageCandidatesSelectColumn[keyof typeof LcmMessageCandidatesSelectColumn];
/** select "lcm_message_candidates_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lcm_message_candidates" */
export const LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Favorited: 'favorited'
} as const;

export type LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolAndArgumentsColumns = typeof LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolAndArgumentsColumns];
/** select "lcm_message_candidates_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lcm_message_candidates" */
export const LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Favorited: 'favorited'
} as const;

export type LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolOrArgumentsColumns = typeof LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof LcmMessageCandidatesSelectColumnLcmMessageCandidatesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "lcm_message_candidates" */
export type LcmMessageCandidatesSetInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  channel?: InputMaybe<Scalars['String']>;
  content_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  favorited?: InputMaybe<Scalars['Boolean']>;
  lcm_message_plan_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  source_plan?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LcmMessageCandidatesStddevFields = {
  __typename?: 'lcm_message_candidates_stddev_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LcmMessageCandidatesStddevPopFields = {
  __typename?: 'lcm_message_candidates_stddev_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LcmMessageCandidatesStddevSampFields = {
  __typename?: 'lcm_message_candidates_stddev_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lcm_message_candidates" */
export type LcmMessageCandidatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LcmMessageCandidatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LcmMessageCandidatesStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  channel?: InputMaybe<Scalars['String']>;
  content_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  favorited?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  lcm_message_plan_id?: InputMaybe<Scalars['uuid']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  plan_candidate_id?: InputMaybe<Scalars['String']>;
  source_plan?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LcmMessageCandidatesSumFields = {
  __typename?: 'lcm_message_candidates_sum_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "lcm_message_candidates" */
export const LcmMessageCandidatesUpdateColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Channel: 'channel',
  /** column name */
  ContentArtifactId: 'content_artifact_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Favorited: 'favorited',
  /** column name */
  LcmMessagePlanId: 'lcm_message_plan_id',
  /** column name */
  Name: 'name',
  /** column name */
  SourcePlan: 'source_plan',
  /** column name */
  Status: 'status'
} as const;

export type LcmMessageCandidatesUpdateColumn = typeof LcmMessageCandidatesUpdateColumn[keyof typeof LcmMessageCandidatesUpdateColumn];
export type LcmMessageCandidatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LcmMessageCandidatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LcmMessageCandidatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LcmMessageCandidatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LcmMessageCandidatesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LcmMessageCandidatesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LcmMessageCandidatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LcmMessageCandidatesSetInput>;
  /** filter the rows which have to be updated */
  where: LcmMessageCandidatesBoolExp;
};

/** aggregate var_pop on columns */
export type LcmMessageCandidatesVarPopFields = {
  __typename?: 'lcm_message_candidates_var_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LcmMessageCandidatesVarSampFields = {
  __typename?: 'lcm_message_candidates_var_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LcmMessageCandidatesVarianceFields = {
  __typename?: 'lcm_message_candidates_variance_fields';
  audience_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lcm_message_candidates" */
export type LcmMessageCandidatesVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "lcm_message_plans" */
export type LcmMessagePlans = {
  __typename?: 'lcm_message_plans';
  /** An array relationship */
  candidates: Array<LcmMessageCandidates>;
  /** An aggregate relationship */
  candidates_aggregate: LcmMessageCandidatesAggregate;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  index: Scalars['Int'];
  /** An object relationship */
  marketing_campaign: MarketingCampaigns;
  marketing_campaign_id: Scalars['uuid'];
  plan: Scalars['jsonb'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "lcm_message_plans" */
export type LcmMessagePlansCandidatesArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


/** columns and relationships of "lcm_message_plans" */
export type LcmMessagePlansCandidatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


/** columns and relationships of "lcm_message_plans" */
export type LcmMessagePlansPlanArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "lcm_message_plans" */
export type LcmMessagePlansAggregate = {
  __typename?: 'lcm_message_plans_aggregate';
  aggregate?: Maybe<LcmMessagePlansAggregateFields>;
  nodes: Array<LcmMessagePlans>;
};

export type LcmMessagePlansAggregateBoolExp = {
  count?: InputMaybe<LcmMessagePlansAggregateBoolExpCount>;
};

export type LcmMessagePlansAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LcmMessagePlansBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "lcm_message_plans" */
export type LcmMessagePlansAggregateFields = {
  __typename?: 'lcm_message_plans_aggregate_fields';
  avg?: Maybe<LcmMessagePlansAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LcmMessagePlansMaxFields>;
  min?: Maybe<LcmMessagePlansMinFields>;
  stddev?: Maybe<LcmMessagePlansStddevFields>;
  stddev_pop?: Maybe<LcmMessagePlansStddevPopFields>;
  stddev_samp?: Maybe<LcmMessagePlansStddevSampFields>;
  sum?: Maybe<LcmMessagePlansSumFields>;
  var_pop?: Maybe<LcmMessagePlansVarPopFields>;
  var_samp?: Maybe<LcmMessagePlansVarSampFields>;
  variance?: Maybe<LcmMessagePlansVarianceFields>;
};


/** aggregate fields of "lcm_message_plans" */
export type LcmMessagePlansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lcm_message_plans" */
export type LcmMessagePlansAggregateOrderBy = {
  avg?: InputMaybe<LcmMessagePlansAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LcmMessagePlansMaxOrderBy>;
  min?: InputMaybe<LcmMessagePlansMinOrderBy>;
  stddev?: InputMaybe<LcmMessagePlansStddevOrderBy>;
  stddev_pop?: InputMaybe<LcmMessagePlansStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LcmMessagePlansStddevSampOrderBy>;
  sum?: InputMaybe<LcmMessagePlansSumOrderBy>;
  var_pop?: InputMaybe<LcmMessagePlansVarPopOrderBy>;
  var_samp?: InputMaybe<LcmMessagePlansVarSampOrderBy>;
  variance?: InputMaybe<LcmMessagePlansVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LcmMessagePlansAppendInput = {
  plan?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type LcmMessagePlansAvgFields = {
  __typename?: 'lcm_message_plans_avg_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "lcm_message_plans" */
export type LcmMessagePlansAvgOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "lcm_message_plans". All fields are combined with a logical 'AND'. */
export type LcmMessagePlansBoolExp = {
  _and?: InputMaybe<Array<LcmMessagePlansBoolExp>>;
  _not?: InputMaybe<LcmMessagePlansBoolExp>;
  _or?: InputMaybe<Array<LcmMessagePlansBoolExp>>;
  candidates?: InputMaybe<LcmMessageCandidatesBoolExp>;
  candidates_aggregate?: InputMaybe<LcmMessageCandidatesAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  index?: InputMaybe<IntComparisonExp>;
  marketing_campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  marketing_campaign_id?: InputMaybe<UuidComparisonExp>;
  plan?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "lcm_message_plans" */
export const LcmMessagePlansConstraint = {
  /** unique or primary key constraint on columns "index", "marketing_campaign_id" */
  LcmMessagePlansCampaignIndexUq: 'lcm_message_plans_campaign_index_uq',
  /** unique or primary key constraint on columns "id" */
  LcmMessagePlansPkey: 'lcm_message_plans_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  LcmMessagePlansWorkspaceUq: 'lcm_message_plans_workspace_uq'
} as const;

export type LcmMessagePlansConstraint = typeof LcmMessagePlansConstraint[keyof typeof LcmMessagePlansConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LcmMessagePlansDeleteAtPathInput = {
  plan?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LcmMessagePlansDeleteElemInput = {
  plan?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LcmMessagePlansDeleteKeyInput = {
  plan?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "lcm_message_plans" */
export type LcmMessagePlansIncInput = {
  index?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "lcm_message_plans" */
export type LcmMessagePlansInsertInput = {
  candidates?: InputMaybe<LcmMessageCandidatesArrRelInsertInput>;
  index?: InputMaybe<Scalars['Int']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type LcmMessagePlansMaxFields = {
  __typename?: 'lcm_message_plans_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "lcm_message_plans" */
export type LcmMessagePlansMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LcmMessagePlansMinFields = {
  __typename?: 'lcm_message_plans_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  index?: Maybe<Scalars['Int']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "lcm_message_plans" */
export type LcmMessagePlansMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "lcm_message_plans" */
export type LcmMessagePlansMutationResponse = {
  __typename?: 'lcm_message_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LcmMessagePlans>;
};

/** input type for inserting object relation for remote table "lcm_message_plans" */
export type LcmMessagePlansObjRelInsertInput = {
  data: LcmMessagePlansInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LcmMessagePlansOnConflict>;
};

/** on_conflict condition type for table "lcm_message_plans" */
export type LcmMessagePlansOnConflict = {
  constraint: LcmMessagePlansConstraint;
  update_columns?: Array<LcmMessagePlansUpdateColumn>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};

/** Ordering options when selecting data from "lcm_message_plans". */
export type LcmMessagePlansOrderBy = {
  candidates_aggregate?: InputMaybe<LcmMessageCandidatesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  marketing_campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  plan?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: lcm_message_plans */
export type LcmMessagePlansPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LcmMessagePlansPrependInput = {
  plan?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "lcm_message_plans" */
export const LcmMessagePlansSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Index: 'index',
  /** column name */
  MarketingCampaignId: 'marketing_campaign_id',
  /** column name */
  Plan: 'plan',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LcmMessagePlansSelectColumn = typeof LcmMessagePlansSelectColumn[keyof typeof LcmMessagePlansSelectColumn];
/** input type for updating data in table "lcm_message_plans" */
export type LcmMessagePlansSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  index?: InputMaybe<Scalars['Int']>;
  plan?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type LcmMessagePlansStddevFields = {
  __typename?: 'lcm_message_plans_stddev_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "lcm_message_plans" */
export type LcmMessagePlansStddevOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LcmMessagePlansStddevPopFields = {
  __typename?: 'lcm_message_plans_stddev_pop_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "lcm_message_plans" */
export type LcmMessagePlansStddevPopOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LcmMessagePlansStddevSampFields = {
  __typename?: 'lcm_message_plans_stddev_samp_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "lcm_message_plans" */
export type LcmMessagePlansStddevSampOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "lcm_message_plans" */
export type LcmMessagePlansStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LcmMessagePlansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LcmMessagePlansStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  index?: InputMaybe<Scalars['Int']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  plan?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LcmMessagePlansSumFields = {
  __typename?: 'lcm_message_plans_sum_fields';
  index?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "lcm_message_plans" */
export type LcmMessagePlansSumOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "lcm_message_plans" */
export const LcmMessagePlansUpdateColumn = {
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Index: 'index',
  /** column name */
  Plan: 'plan'
} as const;

export type LcmMessagePlansUpdateColumn = typeof LcmMessagePlansUpdateColumn[keyof typeof LcmMessagePlansUpdateColumn];
export type LcmMessagePlansUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LcmMessagePlansAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<LcmMessagePlansDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<LcmMessagePlansDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<LcmMessagePlansDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LcmMessagePlansIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LcmMessagePlansPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LcmMessagePlansSetInput>;
  /** filter the rows which have to be updated */
  where: LcmMessagePlansBoolExp;
};

/** aggregate var_pop on columns */
export type LcmMessagePlansVarPopFields = {
  __typename?: 'lcm_message_plans_var_pop_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "lcm_message_plans" */
export type LcmMessagePlansVarPopOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LcmMessagePlansVarSampFields = {
  __typename?: 'lcm_message_plans_var_samp_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "lcm_message_plans" */
export type LcmMessagePlansVarSampOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LcmMessagePlansVarianceFields = {
  __typename?: 'lcm_message_plans_variance_fields';
  index?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "lcm_message_plans" */
export type LcmMessagePlansVarianceOrderBy = {
  index?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "llm_chat_interactions" */
export type LlmChatInteractions = {
  __typename?: 'llm_chat_interactions';
  agent?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  inference_backend?: Maybe<LlmInferenceBackends>;
  inference_backend_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id: Scalars['uuid'];
  parameters?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  triggered_by_tool_call_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "llm_chat_interactions" */
export type LlmChatInteractionsContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "llm_chat_interactions" */
export type LlmChatInteractionsParametersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "llm_chat_interactions" */
export type LlmChatInteractionsAggregate = {
  __typename?: 'llm_chat_interactions_aggregate';
  aggregate?: Maybe<LlmChatInteractionsAggregateFields>;
  nodes: Array<LlmChatInteractions>;
};

export type LlmChatInteractionsAggregateBoolExp = {
  count?: InputMaybe<LlmChatInteractionsAggregateBoolExpCount>;
};

export type LlmChatInteractionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LlmChatInteractionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "llm_chat_interactions" */
export type LlmChatInteractionsAggregateFields = {
  __typename?: 'llm_chat_interactions_aggregate_fields';
  avg?: Maybe<LlmChatInteractionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LlmChatInteractionsMaxFields>;
  min?: Maybe<LlmChatInteractionsMinFields>;
  stddev?: Maybe<LlmChatInteractionsStddevFields>;
  stddev_pop?: Maybe<LlmChatInteractionsStddevPopFields>;
  stddev_samp?: Maybe<LlmChatInteractionsStddevSampFields>;
  sum?: Maybe<LlmChatInteractionsSumFields>;
  var_pop?: Maybe<LlmChatInteractionsVarPopFields>;
  var_samp?: Maybe<LlmChatInteractionsVarSampFields>;
  variance?: Maybe<LlmChatInteractionsVarianceFields>;
};


/** aggregate fields of "llm_chat_interactions" */
export type LlmChatInteractionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "llm_chat_interactions" */
export type LlmChatInteractionsAggregateOrderBy = {
  avg?: InputMaybe<LlmChatInteractionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LlmChatInteractionsMaxOrderBy>;
  min?: InputMaybe<LlmChatInteractionsMinOrderBy>;
  stddev?: InputMaybe<LlmChatInteractionsStddevOrderBy>;
  stddev_pop?: InputMaybe<LlmChatInteractionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LlmChatInteractionsStddevSampOrderBy>;
  sum?: InputMaybe<LlmChatInteractionsSumOrderBy>;
  var_pop?: InputMaybe<LlmChatInteractionsVarPopOrderBy>;
  var_samp?: InputMaybe<LlmChatInteractionsVarSampOrderBy>;
  variance?: InputMaybe<LlmChatInteractionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type LlmChatInteractionsAvgFields = {
  __typename?: 'llm_chat_interactions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "llm_chat_interactions". All fields are combined with a logical 'AND'. */
export type LlmChatInteractionsBoolExp = {
  _and?: InputMaybe<Array<LlmChatInteractionsBoolExp>>;
  _not?: InputMaybe<LlmChatInteractionsBoolExp>;
  _or?: InputMaybe<Array<LlmChatInteractionsBoolExp>>;
  agent?: InputMaybe<StringComparisonExp>;
  context?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inference_backend?: InputMaybe<LlmInferenceBackendsBoolExp>;
  inference_backend_id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  parameters?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  triggered_by_tool_call_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type LlmChatInteractionsMaxFields = {
  __typename?: 'llm_chat_interactions_max_fields';
  agent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  inference_backend_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  triggered_by_tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsMaxOrderBy = {
  agent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inference_backend_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggered_by_tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LlmChatInteractionsMinFields = {
  __typename?: 'llm_chat_interactions_min_fields';
  agent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  inference_backend_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  triggered_by_tool_call_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsMinOrderBy = {
  agent?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inference_backend_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggered_by_tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "llm_chat_interactions". */
export type LlmChatInteractionsOrderBy = {
  agent?: InputMaybe<OrderBy>;
  context?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  inference_backend?: InputMaybe<LlmInferenceBackendsOrderBy>;
  inference_backend_id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parameters?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggered_by_tool_call_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "llm_chat_interactions" */
export const LlmChatInteractionsSelectColumn = {
  /** column name */
  Agent: 'agent',
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  InferenceBackendId: 'inference_backend_id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Parameters: 'parameters',
  /** column name */
  Status: 'status',
  /** column name */
  TriggeredByToolCallId: 'triggered_by_tool_call_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type LlmChatInteractionsSelectColumn = typeof LlmChatInteractionsSelectColumn[keyof typeof LlmChatInteractionsSelectColumn];
/** aggregate stddev on columns */
export type LlmChatInteractionsStddevFields = {
  __typename?: 'llm_chat_interactions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LlmChatInteractionsStddevPopFields = {
  __typename?: 'llm_chat_interactions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LlmChatInteractionsStddevSampFields = {
  __typename?: 'llm_chat_interactions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "llm_chat_interactions" */
export type LlmChatInteractionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LlmChatInteractionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LlmChatInteractionsStreamCursorValueInput = {
  agent?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  inference_backend_id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  parameters?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  triggered_by_tool_call_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LlmChatInteractionsSumFields = {
  __typename?: 'llm_chat_interactions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type LlmChatInteractionsVarPopFields = {
  __typename?: 'llm_chat_interactions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LlmChatInteractionsVarSampFields = {
  __typename?: 'llm_chat_interactions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LlmChatInteractionsVarianceFields = {
  __typename?: 'llm_chat_interactions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "llm_chat_interactions" */
export type LlmChatInteractionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
};

/** columns and relationships of "llm_chat_messages" */
export type LlmChatMessages = {
  __typename?: 'llm_chat_messages';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id: Scalars['uuid'];
  role: Scalars['String'];
  sender_agent_id?: Maybe<Scalars['uuid']>;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "llm_chat_messages" */
export type LlmChatMessagesAggregate = {
  __typename?: 'llm_chat_messages_aggregate';
  aggregate?: Maybe<LlmChatMessagesAggregateFields>;
  nodes: Array<LlmChatMessages>;
};

export type LlmChatMessagesAggregateBoolExp = {
  count?: InputMaybe<LlmChatMessagesAggregateBoolExpCount>;
};

export type LlmChatMessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LlmChatMessagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "llm_chat_messages" */
export type LlmChatMessagesAggregateFields = {
  __typename?: 'llm_chat_messages_aggregate_fields';
  avg?: Maybe<LlmChatMessagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LlmChatMessagesMaxFields>;
  min?: Maybe<LlmChatMessagesMinFields>;
  stddev?: Maybe<LlmChatMessagesStddevFields>;
  stddev_pop?: Maybe<LlmChatMessagesStddevPopFields>;
  stddev_samp?: Maybe<LlmChatMessagesStddevSampFields>;
  sum?: Maybe<LlmChatMessagesSumFields>;
  var_pop?: Maybe<LlmChatMessagesVarPopFields>;
  var_samp?: Maybe<LlmChatMessagesVarSampFields>;
  variance?: Maybe<LlmChatMessagesVarianceFields>;
};


/** aggregate fields of "llm_chat_messages" */
export type LlmChatMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "llm_chat_messages" */
export type LlmChatMessagesAggregateOrderBy = {
  avg?: InputMaybe<LlmChatMessagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LlmChatMessagesMaxOrderBy>;
  min?: InputMaybe<LlmChatMessagesMinOrderBy>;
  stddev?: InputMaybe<LlmChatMessagesStddevOrderBy>;
  stddev_pop?: InputMaybe<LlmChatMessagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<LlmChatMessagesStddevSampOrderBy>;
  sum?: InputMaybe<LlmChatMessagesSumOrderBy>;
  var_pop?: InputMaybe<LlmChatMessagesVarPopOrderBy>;
  var_samp?: InputMaybe<LlmChatMessagesVarSampOrderBy>;
  variance?: InputMaybe<LlmChatMessagesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type LlmChatMessagesAvgFields = {
  __typename?: 'llm_chat_messages_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "llm_chat_messages" */
export type LlmChatMessagesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "llm_chat_messages". All fields are combined with a logical 'AND'. */
export type LlmChatMessagesBoolExp = {
  _and?: InputMaybe<Array<LlmChatMessagesBoolExp>>;
  _not?: InputMaybe<LlmChatMessagesBoolExp>;
  _or?: InputMaybe<Array<LlmChatMessagesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  interaction_id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  sender_agent_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type LlmChatMessagesMaxFields = {
  __typename?: 'llm_chat_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  sender_agent_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "llm_chat_messages" */
export type LlmChatMessagesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  sender_agent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LlmChatMessagesMinFields = {
  __typename?: 'llm_chat_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  sender_agent_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "llm_chat_messages" */
export type LlmChatMessagesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  sender_agent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "llm_chat_messages" */
export type LlmChatMessagesMutationResponse = {
  __typename?: 'llm_chat_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LlmChatMessages>;
};

/** Ordering options when selecting data from "llm_chat_messages". */
export type LlmChatMessagesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  interaction_id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  sender_agent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: llm_chat_messages */
export type LlmChatMessagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "llm_chat_messages" */
export const LlmChatMessagesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  InteractionId: 'interaction_id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Role: 'role',
  /** column name */
  SenderAgentId: 'sender_agent_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LlmChatMessagesSelectColumn = typeof LlmChatMessagesSelectColumn[keyof typeof LlmChatMessagesSelectColumn];
/** input type for updating data in table "llm_chat_messages" */
export type LlmChatMessagesSetInput = {
  content?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type LlmChatMessagesStddevFields = {
  __typename?: 'llm_chat_messages_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "llm_chat_messages" */
export type LlmChatMessagesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type LlmChatMessagesStddevPopFields = {
  __typename?: 'llm_chat_messages_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "llm_chat_messages" */
export type LlmChatMessagesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type LlmChatMessagesStddevSampFields = {
  __typename?: 'llm_chat_messages_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "llm_chat_messages" */
export type LlmChatMessagesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "llm_chat_messages" */
export type LlmChatMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LlmChatMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LlmChatMessagesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** The interaction that delivered or wrote the row. NULL while a Pi message waits. Set once, at delivery, with index. */
  interaction_id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['String']>;
  sender_agent_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type LlmChatMessagesSumFields = {
  __typename?: 'llm_chat_messages_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "llm_chat_messages" */
export type LlmChatMessagesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

export type LlmChatMessagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LlmChatMessagesSetInput>;
  /** filter the rows which have to be updated */
  where: LlmChatMessagesBoolExp;
};

/** aggregate var_pop on columns */
export type LlmChatMessagesVarPopFields = {
  __typename?: 'llm_chat_messages_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "llm_chat_messages" */
export type LlmChatMessagesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type LlmChatMessagesVarSampFields = {
  __typename?: 'llm_chat_messages_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "llm_chat_messages" */
export type LlmChatMessagesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LlmChatMessagesVarianceFields = {
  __typename?: 'llm_chat_messages_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "llm_chat_messages" */
export type LlmChatMessagesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessions = {
  __typename?: 'llm_chat_sessions';
  /** An array relationship */
  amp_action_plans: Array<AmpActionPlans>;
  /** An aggregate relationship */
  amp_action_plans_aggregate: AmpActionPlansAggregate;
  /** An array relationship */
  amp_action_tool_calls: Array<AmpActionToolCalls>;
  /** An aggregate relationship */
  amp_action_tool_calls_aggregate: AmpActionToolCallsAggregate;
  context?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  /** The source context where this session was created (e.g., agents, audiences). */
  creation_source?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_private: Scalars['Boolean'];
  /** An array relationship */
  llm_chat_interactions: Array<LlmChatInteractions>;
  /** An aggregate relationship */
  llm_chat_interactions_aggregate: LlmChatInteractionsAggregate;
  /** An array relationship */
  llm_chat_messages: Array<LlmChatMessages>;
  /** An aggregate relationship */
  llm_chat_messages_aggregate: LlmChatMessagesAggregate;
  name: Scalars['String'];
  /** An object relationship */
  parent_session?: Maybe<LlmChatSessions>;
  /** The session that started this one, whatever its agent runtime. NULL for a session a person started. */
  parent_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  report_schedule_run?: Maybe<ReportScheduleRuns>;
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsAmpActionPlansArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsAmpActionPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsAmpActionToolCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsAmpActionToolCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsLlmChatInteractionsArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsLlmChatInteractionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsLlmChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


/** columns and relationships of "llm_chat_sessions" */
export type LlmChatSessionsLlmChatMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};

/** Boolean expression to filter rows from the table "llm_chat_sessions". All fields are combined with a logical 'AND'. */
export type LlmChatSessionsBoolExp = {
  _and?: InputMaybe<Array<LlmChatSessionsBoolExp>>;
  _not?: InputMaybe<LlmChatSessionsBoolExp>;
  _or?: InputMaybe<Array<LlmChatSessionsBoolExp>>;
  amp_action_plans?: InputMaybe<AmpActionPlansBoolExp>;
  amp_action_plans_aggregate?: InputMaybe<AmpActionPlansAggregateBoolExp>;
  amp_action_tool_calls?: InputMaybe<AmpActionToolCallsBoolExp>;
  amp_action_tool_calls_aggregate?: InputMaybe<AmpActionToolCallsAggregateBoolExp>;
  context?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  creation_source?: InputMaybe<StringComparisonExp>;
  deleted?: InputMaybe<BooleanComparisonExp>;
  hidden?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_private?: InputMaybe<BooleanComparisonExp>;
  llm_chat_interactions?: InputMaybe<LlmChatInteractionsBoolExp>;
  llm_chat_interactions_aggregate?: InputMaybe<LlmChatInteractionsAggregateBoolExp>;
  llm_chat_messages?: InputMaybe<LlmChatMessagesBoolExp>;
  llm_chat_messages_aggregate?: InputMaybe<LlmChatMessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_session?: InputMaybe<LlmChatSessionsBoolExp>;
  parent_session_id?: InputMaybe<UuidComparisonExp>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** response of any mutation on the table "llm_chat_sessions" */
export type LlmChatSessionsMutationResponse = {
  __typename?: 'llm_chat_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LlmChatSessions>;
};

/** Ordering options when selecting data from "llm_chat_sessions". */
export type LlmChatSessionsOrderBy = {
  amp_action_plans_aggregate?: InputMaybe<AmpActionPlansAggregateOrderBy>;
  amp_action_tool_calls_aggregate?: InputMaybe<AmpActionToolCallsAggregateOrderBy>;
  context?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  creation_source?: InputMaybe<OrderBy>;
  deleted?: InputMaybe<OrderBy>;
  hidden?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_private?: InputMaybe<OrderBy>;
  llm_chat_interactions_aggregate?: InputMaybe<LlmChatInteractionsAggregateOrderBy>;
  llm_chat_messages_aggregate?: InputMaybe<LlmChatMessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_session?: InputMaybe<LlmChatSessionsOrderBy>;
  parent_session_id?: InputMaybe<OrderBy>;
  report_schedule_run?: InputMaybe<ReportScheduleRunsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: llm_chat_sessions */
export type LlmChatSessionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "llm_chat_sessions" */
export const LlmChatSessionsSelectColumn = {
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreationSource: 'creation_source',
  /** column name */
  Deleted: 'deleted',
  /** column name */
  Hidden: 'hidden',
  /** column name */
  Id: 'id',
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  Name: 'name',
  /** column name */
  ParentSessionId: 'parent_session_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LlmChatSessionsSelectColumn = typeof LlmChatSessionsSelectColumn[keyof typeof LlmChatSessionsSelectColumn];
/** input type for updating data in table "llm_chat_sessions" */
export type LlmChatSessionsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "llm_chat_sessions" */
export type LlmChatSessionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LlmChatSessionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LlmChatSessionsStreamCursorValueInput = {
  context?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  /** The source context where this session was created (e.g., agents, audiences). */
  creation_source?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** The session that started this one, whatever its agent runtime. NULL for a session a person started. */
  parent_session_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

export type LlmChatSessionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LlmChatSessionsSetInput>;
  /** filter the rows which have to be updated */
  where: LlmChatSessionsBoolExp;
};

/** columns and relationships of "llm_inference_backends" */
export type LlmInferenceBackends = {
  __typename?: 'llm_inference_backends';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  provider: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "llm_inference_backends" */
export type LlmInferenceBackendsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "llm_inference_backends". All fields are combined with a logical 'AND'. */
export type LlmInferenceBackendsBoolExp = {
  _and?: InputMaybe<Array<LlmInferenceBackendsBoolExp>>;
  _not?: InputMaybe<LlmInferenceBackendsBoolExp>;
  _or?: InputMaybe<Array<LlmInferenceBackendsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** response of any mutation on the table "llm_inference_backends" */
export type LlmInferenceBackendsMutationResponse = {
  __typename?: 'llm_inference_backends_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LlmInferenceBackends>;
};

/** Ordering options when selecting data from "llm_inference_backends". */
export type LlmInferenceBackendsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "llm_inference_backends" */
export const LlmInferenceBackendsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Provider: 'provider',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LlmInferenceBackendsSelectColumn = typeof LlmInferenceBackendsSelectColumn[keyof typeof LlmInferenceBackendsSelectColumn];
/** Streaming cursor of the table "llm_inference_backends" */
export type LlmInferenceBackendsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LlmInferenceBackendsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LlmInferenceBackendsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "looker_credentials" */
export type LookerCredentials = {
  __typename?: 'looker_credentials';
  client_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  tunnel?: Maybe<Tunnels>;
  tunnel_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "looker_credentials". All fields are combined with a logical 'AND'. */
export type LookerCredentialsBoolExp = {
  _and?: InputMaybe<Array<LookerCredentialsBoolExp>>;
  _not?: InputMaybe<LookerCredentialsBoolExp>;
  _or?: InputMaybe<Array<LookerCredentialsBoolExp>>;
  client_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  tunnel?: InputMaybe<TunnelsBoolExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "looker_credentials" */
export const LookerCredentialsConstraint = {
  /** unique or primary key constraint on columns "id" */
  LookerCredentialsPkey: 'looker_credentials_pkey'
} as const;

export type LookerCredentialsConstraint = typeof LookerCredentialsConstraint[keyof typeof LookerCredentialsConstraint];
/** input type for inserting data into table "looker_credentials" */
export type LookerCredentialsInsertInput = {
  client_id?: InputMaybe<Scalars['String']>;
  tunnel?: InputMaybe<TunnelsObjRelInsertInput>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "looker_credentials" */
export type LookerCredentialsMutationResponse = {
  __typename?: 'looker_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LookerCredentials>;
};

/** on_conflict condition type for table "looker_credentials" */
export type LookerCredentialsOnConflict = {
  constraint: LookerCredentialsConstraint;
  update_columns?: Array<LookerCredentialsUpdateColumn>;
  where?: InputMaybe<LookerCredentialsBoolExp>;
};

/** Ordering options when selecting data from "looker_credentials". */
export type LookerCredentialsOrderBy = {
  client_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tunnel?: InputMaybe<TunnelsOrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: looker_credentials */
export type LookerCredentialsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "looker_credentials" */
export const LookerCredentialsSelectColumn = {
  /** column name */
  ClientId: 'client_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Url: 'url',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type LookerCredentialsSelectColumn = typeof LookerCredentialsSelectColumn[keyof typeof LookerCredentialsSelectColumn];
/** input type for updating data in table "looker_credentials" */
export type LookerCredentialsSetInput = {
  client_id?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "looker_credentials" */
export type LookerCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: LookerCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LookerCredentialsStreamCursorValueInput = {
  client_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "looker_credentials" */
export const LookerCredentialsUpdateColumn = {
  /** column name */
  ClientId: 'client_id',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  Url: 'url'
} as const;

export type LookerCredentialsUpdateColumn = typeof LookerCredentialsUpdateColumn[keyof typeof LookerCredentialsUpdateColumn];
export type LookerCredentialsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LookerCredentialsSetInput>;
  /** filter the rows which have to be updated */
  where: LookerCredentialsBoolExp;
};

/** columns and relationships of "marketing_campaign_messages" */
export type MarketingCampaignMessages = {
  __typename?: 'marketing_campaign_messages';
  additional_prompt?: Maybe<Scalars['String']>;
  /** An object relationship */
  audience?: Maybe<Segments>;
  audience_id?: Maybe<Scalars['bigint']>;
  channel: Scalars['String'];
  /** An object relationship */
  content_artifact?: Maybe<CampaignArtifacts>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  marketing_campaign: MarketingCampaigns;
  marketing_campaign_id: Scalars['uuid'];
  message_concept_id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "marketing_campaign_messages" */
export type MarketingCampaignMessagesAggregate = {
  __typename?: 'marketing_campaign_messages_aggregate';
  aggregate?: Maybe<MarketingCampaignMessagesAggregateFields>;
  nodes: Array<MarketingCampaignMessages>;
};

export type MarketingCampaignMessagesAggregateBoolExp = {
  count?: InputMaybe<MarketingCampaignMessagesAggregateBoolExpCount>;
};

export type MarketingCampaignMessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MarketingCampaignMessagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "marketing_campaign_messages" */
export type MarketingCampaignMessagesAggregateFields = {
  __typename?: 'marketing_campaign_messages_aggregate_fields';
  avg?: Maybe<MarketingCampaignMessagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MarketingCampaignMessagesMaxFields>;
  min?: Maybe<MarketingCampaignMessagesMinFields>;
  stddev?: Maybe<MarketingCampaignMessagesStddevFields>;
  stddev_pop?: Maybe<MarketingCampaignMessagesStddevPopFields>;
  stddev_samp?: Maybe<MarketingCampaignMessagesStddevSampFields>;
  sum?: Maybe<MarketingCampaignMessagesSumFields>;
  var_pop?: Maybe<MarketingCampaignMessagesVarPopFields>;
  var_samp?: Maybe<MarketingCampaignMessagesVarSampFields>;
  variance?: Maybe<MarketingCampaignMessagesVarianceFields>;
};


/** aggregate fields of "marketing_campaign_messages" */
export type MarketingCampaignMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesAggregateOrderBy = {
  avg?: InputMaybe<MarketingCampaignMessagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MarketingCampaignMessagesMaxOrderBy>;
  min?: InputMaybe<MarketingCampaignMessagesMinOrderBy>;
  stddev?: InputMaybe<MarketingCampaignMessagesStddevOrderBy>;
  stddev_pop?: InputMaybe<MarketingCampaignMessagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MarketingCampaignMessagesStddevSampOrderBy>;
  sum?: InputMaybe<MarketingCampaignMessagesSumOrderBy>;
  var_pop?: InputMaybe<MarketingCampaignMessagesVarPopOrderBy>;
  var_samp?: InputMaybe<MarketingCampaignMessagesVarSampOrderBy>;
  variance?: InputMaybe<MarketingCampaignMessagesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type MarketingCampaignMessagesAvgFields = {
  __typename?: 'marketing_campaign_messages_avg_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "marketing_campaign_messages". All fields are combined with a logical 'AND'. */
export type MarketingCampaignMessagesBoolExp = {
  _and?: InputMaybe<Array<MarketingCampaignMessagesBoolExp>>;
  _not?: InputMaybe<MarketingCampaignMessagesBoolExp>;
  _or?: InputMaybe<Array<MarketingCampaignMessagesBoolExp>>;
  additional_prompt?: InputMaybe<StringComparisonExp>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  content_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  content_artifact_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  marketing_campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  marketing_campaign_id?: InputMaybe<UuidComparisonExp>;
  message_concept_id?: InputMaybe<UuidComparisonExp>;
  notes?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type MarketingCampaignMessagesMaxFields = {
  __typename?: 'marketing_campaign_messages_max_fields';
  additional_prompt?: Maybe<Scalars['String']>;
  audience_id?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  message_concept_id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesMaxOrderBy = {
  additional_prompt?: InputMaybe<OrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  message_concept_id?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MarketingCampaignMessagesMinFields = {
  __typename?: 'marketing_campaign_messages_min_fields';
  additional_prompt?: Maybe<Scalars['String']>;
  audience_id?: Maybe<Scalars['bigint']>;
  channel?: Maybe<Scalars['String']>;
  content_artifact_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  marketing_campaign_id?: Maybe<Scalars['uuid']>;
  message_concept_id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesMinOrderBy = {
  additional_prompt?: InputMaybe<OrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  message_concept_id?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "marketing_campaign_messages" */
export type MarketingCampaignMessagesMutationResponse = {
  __typename?: 'marketing_campaign_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MarketingCampaignMessages>;
};

/** Ordering options when selecting data from "marketing_campaign_messages". */
export type MarketingCampaignMessagesOrderBy = {
  additional_prompt?: InputMaybe<OrderBy>;
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  content_artifact_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  marketing_campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  marketing_campaign_id?: InputMaybe<OrderBy>;
  message_concept_id?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "marketing_campaign_messages" */
export const MarketingCampaignMessagesSelectColumn = {
  /** column name */
  AdditionalPrompt: 'additional_prompt',
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Channel: 'channel',
  /** column name */
  ContentArtifactId: 'content_artifact_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  MarketingCampaignId: 'marketing_campaign_id',
  /** column name */
  MessageConceptId: 'message_concept_id',
  /** column name */
  Notes: 'notes',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MarketingCampaignMessagesSelectColumn = typeof MarketingCampaignMessagesSelectColumn[keyof typeof MarketingCampaignMessagesSelectColumn];
/** aggregate stddev on columns */
export type MarketingCampaignMessagesStddevFields = {
  __typename?: 'marketing_campaign_messages_stddev_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MarketingCampaignMessagesStddevPopFields = {
  __typename?: 'marketing_campaign_messages_stddev_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MarketingCampaignMessagesStddevSampFields = {
  __typename?: 'marketing_campaign_messages_stddev_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "marketing_campaign_messages" */
export type MarketingCampaignMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MarketingCampaignMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MarketingCampaignMessagesStreamCursorValueInput = {
  additional_prompt?: InputMaybe<Scalars['String']>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  channel?: InputMaybe<Scalars['String']>;
  content_artifact_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  marketing_campaign_id?: InputMaybe<Scalars['uuid']>;
  message_concept_id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MarketingCampaignMessagesSumFields = {
  __typename?: 'marketing_campaign_messages_sum_fields';
  audience_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type MarketingCampaignMessagesVarPopFields = {
  __typename?: 'marketing_campaign_messages_var_pop_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MarketingCampaignMessagesVarSampFields = {
  __typename?: 'marketing_campaign_messages_var_samp_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MarketingCampaignMessagesVarianceFields = {
  __typename?: 'marketing_campaign_messages_variance_fields';
  audience_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "marketing_campaign_messages" */
export type MarketingCampaignMessagesVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaigns = {
  __typename?: 'marketing_campaigns';
  additional_context?: Maybe<Scalars['String']>;
  audience_description?: Maybe<Scalars['String']>;
  auto_mode: Scalars['Boolean'];
  brand_profile_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  campaign_artifacts: Array<CampaignArtifacts>;
  /** An aggregate relationship */
  campaign_artifacts_aggregate: CampaignArtifactsAggregate;
  /** An object relationship */
  concept_generation_session?: Maybe<LlmChatSessions>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  default_assignment_source?: Maybe<Scalars['String']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  external_source?: Maybe<Scalars['jsonb']>;
  goal?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_private: Scalars['Boolean'];
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  message_plans: Array<LcmMessagePlans>;
  /** An aggregate relationship */
  message_plans_aggregate: LcmMessagePlansAggregate;
  /** An array relationship */
  messages: Array<MarketingCampaignMessages>;
  /** An aggregate relationship */
  messages_aggregate: MarketingCampaignMessagesAggregate;
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  project_status?: Maybe<Scalars['String']>;
  /** An object relationship */
  source_session?: Maybe<LlmChatSessions>;
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsCampaignArtifactsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsCampaignArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsExternalSourceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsMessagePlansArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsMessagePlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsMessagesArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


/** columns and relationships of "marketing_campaigns" */
export type MarketingCampaignsMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};

/** aggregated selection of "marketing_campaigns" */
export type MarketingCampaignsAggregate = {
  __typename?: 'marketing_campaigns_aggregate';
  aggregate?: Maybe<MarketingCampaignsAggregateFields>;
  nodes: Array<MarketingCampaigns>;
};

/** aggregate fields of "marketing_campaigns" */
export type MarketingCampaignsAggregateFields = {
  __typename?: 'marketing_campaigns_aggregate_fields';
  avg?: Maybe<MarketingCampaignsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MarketingCampaignsMaxFields>;
  min?: Maybe<MarketingCampaignsMinFields>;
  stddev?: Maybe<MarketingCampaignsStddevFields>;
  stddev_pop?: Maybe<MarketingCampaignsStddevPopFields>;
  stddev_samp?: Maybe<MarketingCampaignsStddevSampFields>;
  sum?: Maybe<MarketingCampaignsSumFields>;
  var_pop?: Maybe<MarketingCampaignsVarPopFields>;
  var_samp?: Maybe<MarketingCampaignsVarSampFields>;
  variance?: Maybe<MarketingCampaignsVarianceFields>;
};


/** aggregate fields of "marketing_campaigns" */
export type MarketingCampaignsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MarketingCampaignsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MarketingCampaignsAvgFields = {
  __typename?: 'marketing_campaigns_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "marketing_campaigns". All fields are combined with a logical 'AND'. */
export type MarketingCampaignsBoolExp = {
  _and?: InputMaybe<Array<MarketingCampaignsBoolExp>>;
  _not?: InputMaybe<MarketingCampaignsBoolExp>;
  _or?: InputMaybe<Array<MarketingCampaignsBoolExp>>;
  additional_context?: InputMaybe<StringComparisonExp>;
  audience_description?: InputMaybe<StringComparisonExp>;
  auto_mode?: InputMaybe<BooleanComparisonExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  campaign_artifacts?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_artifacts_aggregate?: InputMaybe<CampaignArtifactsAggregateBoolExp>;
  concept_generation_session?: InputMaybe<LlmChatSessionsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  default_assignment_source?: InputMaybe<StringComparisonExp>;
  esp_destination_id?: InputMaybe<BigintComparisonExp>;
  esp_target_kind?: InputMaybe<StringComparisonExp>;
  external_source?: InputMaybe<JsonbComparisonExp>;
  goal?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_private?: InputMaybe<BooleanComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  message_plans?: InputMaybe<LcmMessagePlansBoolExp>;
  message_plans_aggregate?: InputMaybe<LcmMessagePlansAggregateBoolExp>;
  messages?: InputMaybe<MarketingCampaignMessagesBoolExp>;
  messages_aggregate?: InputMaybe<MarketingCampaignMessagesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  project_status?: InputMaybe<StringComparisonExp>;
  source_session?: InputMaybe<LlmChatSessionsBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type MarketingCampaignsMaxFields = {
  __typename?: 'marketing_campaigns_max_fields';
  additional_context?: Maybe<Scalars['String']>;
  audience_description?: Maybe<Scalars['String']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  project_status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MarketingCampaignsMinFields = {
  __typename?: 'marketing_campaigns_min_fields';
  additional_context?: Maybe<Scalars['String']>;
  audience_description?: Maybe<Scalars['String']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  default_assignment_source?: Maybe<Scalars['String']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  esp_target_kind?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  project_status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "marketing_campaigns" */
export type MarketingCampaignsMutationResponse = {
  __typename?: 'marketing_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MarketingCampaigns>;
};

/** Ordering options when selecting data from "marketing_campaigns". */
export type MarketingCampaignsOrderBy = {
  additional_context?: InputMaybe<OrderBy>;
  audience_description?: InputMaybe<OrderBy>;
  auto_mode?: InputMaybe<OrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  campaign_artifacts_aggregate?: InputMaybe<CampaignArtifactsAggregateOrderBy>;
  concept_generation_session?: InputMaybe<LlmChatSessionsOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  default_assignment_source?: InputMaybe<OrderBy>;
  esp_destination_id?: InputMaybe<OrderBy>;
  esp_target_kind?: InputMaybe<OrderBy>;
  external_source?: InputMaybe<OrderBy>;
  goal?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_private?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  message_plans_aggregate?: InputMaybe<LcmMessagePlansAggregateOrderBy>;
  messages_aggregate?: InputMaybe<MarketingCampaignMessagesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  project_status?: InputMaybe<OrderBy>;
  source_session?: InputMaybe<LlmChatSessionsOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: marketing_campaigns */
export type MarketingCampaignsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "marketing_campaigns" */
export const MarketingCampaignsSelectColumn = {
  /** column name */
  AdditionalContext: 'additional_context',
  /** column name */
  AudienceDescription: 'audience_description',
  /** column name */
  AutoMode: 'auto_mode',
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DefaultAssignmentSource: 'default_assignment_source',
  /** column name */
  EspDestinationId: 'esp_destination_id',
  /** column name */
  EspTargetKind: 'esp_target_kind',
  /** column name */
  ExternalSource: 'external_source',
  /** column name */
  Goal: 'goal',
  /** column name */
  Id: 'id',
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  ProjectStatus: 'project_status',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MarketingCampaignsSelectColumn = typeof MarketingCampaignsSelectColumn[keyof typeof MarketingCampaignsSelectColumn];
/** input type for updating data in table "marketing_campaigns" */
export type MarketingCampaignsSetInput = {
  additional_context?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MarketingCampaignsStddevFields = {
  __typename?: 'marketing_campaigns_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MarketingCampaignsStddevPopFields = {
  __typename?: 'marketing_campaigns_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MarketingCampaignsStddevSampFields = {
  __typename?: 'marketing_campaigns_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "marketing_campaigns" */
export type MarketingCampaignsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MarketingCampaignsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MarketingCampaignsStreamCursorValueInput = {
  additional_context?: InputMaybe<Scalars['String']>;
  audience_description?: InputMaybe<Scalars['String']>;
  auto_mode?: InputMaybe<Scalars['Boolean']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  default_assignment_source?: InputMaybe<Scalars['String']>;
  esp_destination_id?: InputMaybe<Scalars['bigint']>;
  esp_target_kind?: InputMaybe<Scalars['String']>;
  external_source?: InputMaybe<Scalars['jsonb']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  project_status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MarketingCampaignsSumFields = {
  __typename?: 'marketing_campaigns_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  esp_destination_id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

export type MarketingCampaignsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MarketingCampaignsSetInput>;
  /** filter the rows which have to be updated */
  where: MarketingCampaignsBoolExp;
};

/** aggregate var_pop on columns */
export type MarketingCampaignsVarPopFields = {
  __typename?: 'marketing_campaigns_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MarketingCampaignsVarSampFields = {
  __typename?: 'marketing_campaigns_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MarketingCampaignsVarianceFields = {
  __typename?: 'marketing_campaigns_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  esp_destination_id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "matchboosting_config" */
export type MatchboostingConfig = {
  __typename?: 'matchboosting_config';
  config: Scalars['jsonb'];
  config_name?: Maybe<Scalars['String']>;
  destination?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  model_id: Scalars['bigint'];
  region: Scalars['String'];
  /** An object relationship */
  segment: Segments;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "matchboosting_config" */
export type MatchboostingConfigConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MatchboostingConfigAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "matchboosting_config". All fields are combined with a logical 'AND'. */
export type MatchboostingConfigBoolExp = {
  _and?: InputMaybe<Array<MatchboostingConfigBoolExp>>;
  _not?: InputMaybe<MatchboostingConfigBoolExp>;
  _or?: InputMaybe<Array<MatchboostingConfigBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  config_name?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "matchboosting_config" */
export const MatchboostingConfigConstraint = {
  /** unique or primary key constraint on columns "destination", "region", "model_id" */
  MatchboostingConfigModelDestinationRegionKey: 'matchboosting_config_model_destination_region_key',
  /** unique or primary key constraint on columns "id" */
  MatchboostingConfigPkey: 'matchboosting_config_pkey'
} as const;

export type MatchboostingConfigConstraint = typeof MatchboostingConfigConstraint[keyof typeof MatchboostingConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MatchboostingConfigDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MatchboostingConfigDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MatchboostingConfigDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "matchboosting_config" */
export type MatchboostingConfigInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  region?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
};

/** response of any mutation on the table "matchboosting_config" */
export type MatchboostingConfigMutationResponse = {
  __typename?: 'matchboosting_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MatchboostingConfig>;
};

/** on_conflict condition type for table "matchboosting_config" */
export type MatchboostingConfigOnConflict = {
  constraint: MatchboostingConfigConstraint;
  update_columns?: Array<MatchboostingConfigUpdateColumn>;
  where?: InputMaybe<MatchboostingConfigBoolExp>;
};

/** Ordering options when selecting data from "matchboosting_config". */
export type MatchboostingConfigOrderBy = {
  config?: InputMaybe<OrderBy>;
  config_name?: InputMaybe<OrderBy>;
  destination?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: matchboosting_config */
export type MatchboostingConfigPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MatchboostingConfigPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "matchboosting_config" */
export const MatchboostingConfigSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  ConfigName: 'config_name',
  /** column name */
  Destination: 'destination',
  /** column name */
  Id: 'id',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Region: 'region',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MatchboostingConfigSelectColumn = typeof MatchboostingConfigSelectColumn[keyof typeof MatchboostingConfigSelectColumn];
/** input type for updating data in table "matchboosting_config" */
export type MatchboostingConfigSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "matchboosting_config" */
export type MatchboostingConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MatchboostingConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchboostingConfigStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  region?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "matchboosting_config" */
export const MatchboostingConfigUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  ConfigName: 'config_name',
  /** column name */
  Destination: 'destination',
  /** column name */
  Region: 'region'
} as const;

export type MatchboostingConfigUpdateColumn = typeof MatchboostingConfigUpdateColumn[keyof typeof MatchboostingConfigUpdateColumn];
export type MatchboostingConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MatchboostingConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MatchboostingConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MatchboostingConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MatchboostingConfigDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MatchboostingConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MatchboostingConfigSetInput>;
  /** filter the rows which have to be updated */
  where: MatchboostingConfigBoolExp;
};

/** columns and relationships of "matchboosting_stats" */
export type MatchboostingStats = {
  __typename?: 'matchboosting_stats';
  enriched_duration_ms: Scalars['bigint'];
  enriched_rows?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  is_full_enrichment?: Maybe<Scalars['Boolean']>;
  last_enriched_at: Scalars['timestamptz'];
  region: Scalars['String'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  status: Scalars['String'];
  uuid: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "matchboosting_stats". All fields are combined with a logical 'AND'. */
export type MatchboostingStatsBoolExp = {
  _and?: InputMaybe<Array<MatchboostingStatsBoolExp>>;
  _not?: InputMaybe<MatchboostingStatsBoolExp>;
  _or?: InputMaybe<Array<MatchboostingStatsBoolExp>>;
  enriched_duration_ms?: InputMaybe<BigintComparisonExp>;
  enriched_rows?: InputMaybe<IntComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  is_full_enrichment?: InputMaybe<BooleanComparisonExp>;
  last_enriched_at?: InputMaybe<TimestamptzComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "matchboosting_stats". */
export type MatchboostingStatsOrderBy = {
  enriched_duration_ms?: InputMaybe<OrderBy>;
  enriched_rows?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  is_full_enrichment?: InputMaybe<OrderBy>;
  last_enriched_at?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "matchboosting_stats" */
export const MatchboostingStatsSelectColumn = {
  /** column name */
  EnrichedDurationMs: 'enriched_duration_ms',
  /** column name */
  EnrichedRows: 'enriched_rows',
  /** column name */
  Error: 'error',
  /** column name */
  IsFullEnrichment: 'is_full_enrichment',
  /** column name */
  LastEnrichedAt: 'last_enriched_at',
  /** column name */
  Region: 'region',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Status: 'status',
  /** column name */
  Uuid: 'uuid',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MatchboostingStatsSelectColumn = typeof MatchboostingStatsSelectColumn[keyof typeof MatchboostingStatsSelectColumn];
/** Streaming cursor of the table "matchboosting_stats" */
export type MatchboostingStatsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MatchboostingStatsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchboostingStatsStreamCursorValueInput = {
  enriched_duration_ms?: InputMaybe<Scalars['bigint']>;
  enriched_rows?: InputMaybe<Scalars['Int']>;
  error?: InputMaybe<Scalars['String']>;
  is_full_enrichment?: InputMaybe<Scalars['Boolean']>;
  last_enriched_at?: InputMaybe<Scalars['timestamptz']>;
  region?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfig = {
  __typename?: 'matchboosting_workspace_config';
  config_name: Scalars['String'];
  destination: Scalars['String'];
  region: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "matchboosting_workspace_config". All fields are combined with a logical 'AND'. */
export type MatchboostingWorkspaceConfigBoolExp = {
  _and?: InputMaybe<Array<MatchboostingWorkspaceConfigBoolExp>>;
  _not?: InputMaybe<MatchboostingWorkspaceConfigBoolExp>;
  _or?: InputMaybe<Array<MatchboostingWorkspaceConfigBoolExp>>;
  config_name?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<StringComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "matchboosting_workspace_config" */
export const MatchboostingWorkspaceConfigConstraint = {
  /** unique or primary key constraint on columns "destination", "workspace_id", "region", "config_name" */
  MatchboostingWorkspaceConfigPkey: 'matchboosting_workspace_config_pkey',
  /** unique or primary key constraint on columns "destination", "workspace_id", "region" */
  MatchboostingWorkspaceDestinationRegionKey: 'matchboosting_workspace_destination_region_key'
} as const;

export type MatchboostingWorkspaceConfigConstraint = typeof MatchboostingWorkspaceConfigConstraint[keyof typeof MatchboostingWorkspaceConfigConstraint];
/** input type for inserting data into table "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfigInsertInput = {
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfigMutationResponse = {
  __typename?: 'matchboosting_workspace_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MatchboostingWorkspaceConfig>;
};

/** on_conflict condition type for table "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfigOnConflict = {
  constraint: MatchboostingWorkspaceConfigConstraint;
  update_columns?: Array<MatchboostingWorkspaceConfigUpdateColumn>;
  where?: InputMaybe<MatchboostingWorkspaceConfigBoolExp>;
};

/** Ordering options when selecting data from "matchboosting_workspace_config". */
export type MatchboostingWorkspaceConfigOrderBy = {
  config_name?: InputMaybe<OrderBy>;
  destination?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: matchboosting_workspace_config */
export type MatchboostingWorkspaceConfigPkColumnsInput = {
  config_name: Scalars['String'];
  destination: Scalars['String'];
  region: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "matchboosting_workspace_config" */
export const MatchboostingWorkspaceConfigSelectColumn = {
  /** column name */
  ConfigName: 'config_name',
  /** column name */
  Destination: 'destination',
  /** column name */
  Region: 'region',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MatchboostingWorkspaceConfigSelectColumn = typeof MatchboostingWorkspaceConfigSelectColumn[keyof typeof MatchboostingWorkspaceConfigSelectColumn];
/** input type for updating data in table "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfigSetInput = {
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "matchboosting_workspace_config" */
export type MatchboostingWorkspaceConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MatchboostingWorkspaceConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchboostingWorkspaceConfigStreamCursorValueInput = {
  config_name?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "matchboosting_workspace_config" */
export const MatchboostingWorkspaceConfigUpdateColumn = {
  /** column name */
  ConfigName: 'config_name',
  /** column name */
  Destination: 'destination',
  /** column name */
  Region: 'region'
} as const;

export type MatchboostingWorkspaceConfigUpdateColumn = typeof MatchboostingWorkspaceConfigUpdateColumn[keyof typeof MatchboostingWorkspaceConfigUpdateColumn];
export type MatchboostingWorkspaceConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MatchboostingWorkspaceConfigSetInput>;
  /** filter the rows which have to be updated */
  where: MatchboostingWorkspaceConfigBoolExp;
};

/** columns and relationships of "message_contents" */
export type MessageContents = {
  __typename?: 'message_contents';
  /** An object relationship */
  cep_whatsapp_template?: Maybe<CepWhatsappTemplates>;
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email_version?: Maybe<ContentEmailVersions>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  editor_state?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings: Scalars['jsonb'];
  rendered_output?: Maybe<Scalars['jsonb']>;
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "message_contents" */
export type MessageContentsEditorStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "message_contents" */
export type MessageContentsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "message_contents" */
export type MessageContentsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "message_contents" */
export type MessageContentsProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "message_contents" */
export type MessageContentsRenderedOutputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "message_contents" */
export type MessageContentsAggregate = {
  __typename?: 'message_contents_aggregate';
  aggregate?: Maybe<MessageContentsAggregateFields>;
  nodes: Array<MessageContents>;
};

export type MessageContentsAggregateBoolExp = {
  count?: InputMaybe<MessageContentsAggregateBoolExpCount>;
};

export type MessageContentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessageContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessageContentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "message_contents" */
export type MessageContentsAggregateFields = {
  __typename?: 'message_contents_aggregate_fields';
  avg?: Maybe<MessageContentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageContentsMaxFields>;
  min?: Maybe<MessageContentsMinFields>;
  stddev?: Maybe<MessageContentsStddevFields>;
  stddev_pop?: Maybe<MessageContentsStddevPopFields>;
  stddev_samp?: Maybe<MessageContentsStddevSampFields>;
  sum?: Maybe<MessageContentsSumFields>;
  var_pop?: Maybe<MessageContentsVarPopFields>;
  var_samp?: Maybe<MessageContentsVarSampFields>;
  variance?: Maybe<MessageContentsVarianceFields>;
};


/** aggregate fields of "message_contents" */
export type MessageContentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageContentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message_contents" */
export type MessageContentsAggregateOrderBy = {
  avg?: InputMaybe<MessageContentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessageContentsMaxOrderBy>;
  min?: InputMaybe<MessageContentsMinOrderBy>;
  stddev?: InputMaybe<MessageContentsStddevOrderBy>;
  stddev_pop?: InputMaybe<MessageContentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessageContentsStddevSampOrderBy>;
  sum?: InputMaybe<MessageContentsSumOrderBy>;
  var_pop?: InputMaybe<MessageContentsVarPopOrderBy>;
  var_samp?: InputMaybe<MessageContentsVarSampOrderBy>;
  variance?: InputMaybe<MessageContentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MessageContentsAppendInput = {
  editor_state?: InputMaybe<Scalars['jsonb']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "message_contents" */
export type MessageContentsArrRelInsertInput = {
  data: Array<MessageContentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageContentsOnConflict>;
};

/** aggregate avg on columns */
export type MessageContentsAvgFields = {
  __typename?: 'message_contents_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "message_contents" */
export type MessageContentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "message_contents_base" */
export type MessageContentsBase = {
  __typename?: 'message_contents_base';
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  content_email_version?: Maybe<ContentEmailVersions>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  editor_state?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings?: Maybe<Scalars['jsonb']>;
  rendered_output?: Maybe<Scalars['jsonb']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "message_contents_base" */
export type MessageContentsBaseEditorStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "message_contents_base" */
export type MessageContentsBaseProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "message_contents_base" */
export type MessageContentsBaseRenderedOutputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "message_contents_base" */
export type MessageContentsBaseAggregate = {
  __typename?: 'message_contents_base_aggregate';
  aggregate?: Maybe<MessageContentsBaseAggregateFields>;
  nodes: Array<MessageContentsBase>;
};

/** aggregate fields of "message_contents_base" */
export type MessageContentsBaseAggregateFields = {
  __typename?: 'message_contents_base_aggregate_fields';
  avg?: Maybe<MessageContentsBaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageContentsBaseMaxFields>;
  min?: Maybe<MessageContentsBaseMinFields>;
  stddev?: Maybe<MessageContentsBaseStddevFields>;
  stddev_pop?: Maybe<MessageContentsBaseStddevPopFields>;
  stddev_samp?: Maybe<MessageContentsBaseStddevSampFields>;
  sum?: Maybe<MessageContentsBaseSumFields>;
  var_pop?: Maybe<MessageContentsBaseVarPopFields>;
  var_samp?: Maybe<MessageContentsBaseVarSampFields>;
  variance?: Maybe<MessageContentsBaseVarianceFields>;
};


/** aggregate fields of "message_contents_base" */
export type MessageContentsBaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageContentsBaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MessageContentsBaseAvgFields = {
  __typename?: 'message_contents_base_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message_contents_base". All fields are combined with a logical 'AND'. */
export type MessageContentsBaseBoolExp = {
  _and?: InputMaybe<Array<MessageContentsBaseBoolExp>>;
  _not?: InputMaybe<MessageContentsBaseBoolExp>;
  _or?: InputMaybe<Array<MessageContentsBaseBoolExp>>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  content_email_version?: InputMaybe<ContentEmailVersionsBoolExp>;
  content_email_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  editor_state?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  rendered_output?: InputMaybe<JsonbComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  variant_id?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type MessageContentsBaseMaxFields = {
  __typename?: 'message_contents_base_max_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MessageContentsBaseMinFields = {
  __typename?: 'message_contents_base_min_fields';
  content_email_id?: Maybe<Scalars['uuid']>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "message_contents_base". */
export type MessageContentsBaseOrderBy = {
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  content_email_version?: InputMaybe<ContentEmailVersionsOrderBy>;
  content_email_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  editor_state?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  rendered_output?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "message_contents_base" */
export const MessageContentsBaseSelectColumn = {
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  ContentEmailVersionId: 'content_email_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EditorState: 'editor_state',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  RenderedOutput: 'rendered_output',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageContentsBaseSelectColumn = typeof MessageContentsBaseSelectColumn[keyof typeof MessageContentsBaseSelectColumn];
/** aggregate stddev on columns */
export type MessageContentsBaseStddevFields = {
  __typename?: 'message_contents_base_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MessageContentsBaseStddevPopFields = {
  __typename?: 'message_contents_base_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MessageContentsBaseStddevSampFields = {
  __typename?: 'message_contents_base_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "message_contents_base" */
export type MessageContentsBaseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageContentsBaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageContentsBaseStreamCursorValueInput = {
  content_email_id?: InputMaybe<Scalars['uuid']>;
  content_email_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  editor_state?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageContentsBaseSumFields = {
  __typename?: 'message_contents_base_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type MessageContentsBaseVarPopFields = {
  __typename?: 'message_contents_base_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MessageContentsBaseVarSampFields = {
  __typename?: 'message_contents_base_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MessageContentsBaseVarianceFields = {
  __typename?: 'message_contents_base_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message_contents". All fields are combined with a logical 'AND'. */
export type MessageContentsBoolExp = {
  _and?: InputMaybe<Array<MessageContentsBoolExp>>;
  _not?: InputMaybe<MessageContentsBoolExp>;
  _or?: InputMaybe<Array<MessageContentsBoolExp>>;
  cep_whatsapp_template?: InputMaybe<CepWhatsappTemplatesBoolExp>;
  cep_whatsapp_template_id?: InputMaybe<UuidComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  content_email_version?: InputMaybe<ContentEmailVersionsBoolExp>;
  content_email_version_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  editor_state?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  rendered_output?: InputMaybe<JsonbComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  variant_id?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_contents" */
export const MessageContentsConstraint = {
  /** unique or primary key constraint on columns "version", "message_id" */
  MessageContentsCommittedVersionKey: 'message_contents_committed_version_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MessageContentsIdWorkspaceIdKey: 'message_contents_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageContentsPkey: 'message_contents_pkey',
  /** unique or primary key constraint on columns "version", "message_id", "variant_id" */
  MessageContentsVariantVersionKey: 'message_contents_variant_version_key'
} as const;

export type MessageContentsConstraint = typeof MessageContentsConstraint[keyof typeof MessageContentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MessageContentsDeleteAtPathInput = {
  editor_state?: InputMaybe<Array<Scalars['String']>>;
  profile_mappings?: InputMaybe<Array<Scalars['String']>>;
  rendered_output?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MessageContentsDeleteElemInput = {
  editor_state?: InputMaybe<Scalars['Int']>;
  profile_mappings?: InputMaybe<Scalars['Int']>;
  rendered_output?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MessageContentsDeleteKeyInput = {
  editor_state?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['String']>;
  rendered_output?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "message_contents" */
export type MessageContentsInsertInput = {
  editor_state?: InputMaybe<Scalars['jsonb']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MessageContentsMaxFields = {
  __typename?: 'message_contents_max_fields';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "message_contents" */
export type MessageContentsMaxOrderBy = {
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  content_email_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Mirrors message_contents, holding the subject/preheader (email) or title/subtitle (push) part of a message version. */
export type MessageContentsMetadata = {
  __typename?: 'message_contents_metadata';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  preheader?: Maybe<Scalars['String']>;
  profile_mappings: Scalars['jsonb'];
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** Mirrors message_contents, holding the subject/preheader (email) or title/subtitle (push) part of a message version. */
export type MessageContentsMetadataProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "message_contents_metadata" */
export type MessageContentsMetadataAggregate = {
  __typename?: 'message_contents_metadata_aggregate';
  aggregate?: Maybe<MessageContentsMetadataAggregateFields>;
  nodes: Array<MessageContentsMetadata>;
};

export type MessageContentsMetadataAggregateBoolExp = {
  count?: InputMaybe<MessageContentsMetadataAggregateBoolExpCount>;
};

export type MessageContentsMetadataAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessageContentsMetadataBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "message_contents_metadata" */
export type MessageContentsMetadataAggregateFields = {
  __typename?: 'message_contents_metadata_aggregate_fields';
  avg?: Maybe<MessageContentsMetadataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageContentsMetadataMaxFields>;
  min?: Maybe<MessageContentsMetadataMinFields>;
  stddev?: Maybe<MessageContentsMetadataStddevFields>;
  stddev_pop?: Maybe<MessageContentsMetadataStddevPopFields>;
  stddev_samp?: Maybe<MessageContentsMetadataStddevSampFields>;
  sum?: Maybe<MessageContentsMetadataSumFields>;
  var_pop?: Maybe<MessageContentsMetadataVarPopFields>;
  var_samp?: Maybe<MessageContentsMetadataVarSampFields>;
  variance?: Maybe<MessageContentsMetadataVarianceFields>;
};


/** aggregate fields of "message_contents_metadata" */
export type MessageContentsMetadataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message_contents_metadata" */
export type MessageContentsMetadataAggregateOrderBy = {
  avg?: InputMaybe<MessageContentsMetadataAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessageContentsMetadataMaxOrderBy>;
  min?: InputMaybe<MessageContentsMetadataMinOrderBy>;
  stddev?: InputMaybe<MessageContentsMetadataStddevOrderBy>;
  stddev_pop?: InputMaybe<MessageContentsMetadataStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessageContentsMetadataStddevSampOrderBy>;
  sum?: InputMaybe<MessageContentsMetadataSumOrderBy>;
  var_pop?: InputMaybe<MessageContentsMetadataVarPopOrderBy>;
  var_samp?: InputMaybe<MessageContentsMetadataVarSampOrderBy>;
  variance?: InputMaybe<MessageContentsMetadataVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MessageContentsMetadataAppendInput = {
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "message_contents_metadata" */
export type MessageContentsMetadataArrRelInsertInput = {
  data: Array<MessageContentsMetadataInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageContentsMetadataOnConflict>;
};

/** aggregate avg on columns */
export type MessageContentsMetadataAvgFields = {
  __typename?: 'message_contents_metadata_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "message_contents_metadata_base" */
export type MessageContentsMetadataBase = {
  __typename?: 'message_contents_metadata_base';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  profile_mappings?: Maybe<Scalars['jsonb']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "message_contents_metadata_base" */
export type MessageContentsMetadataBaseProfileMappingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "message_contents_metadata_base" */
export type MessageContentsMetadataBaseAggregate = {
  __typename?: 'message_contents_metadata_base_aggregate';
  aggregate?: Maybe<MessageContentsMetadataBaseAggregateFields>;
  nodes: Array<MessageContentsMetadataBase>;
};

/** aggregate fields of "message_contents_metadata_base" */
export type MessageContentsMetadataBaseAggregateFields = {
  __typename?: 'message_contents_metadata_base_aggregate_fields';
  avg?: Maybe<MessageContentsMetadataBaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageContentsMetadataBaseMaxFields>;
  min?: Maybe<MessageContentsMetadataBaseMinFields>;
  stddev?: Maybe<MessageContentsMetadataBaseStddevFields>;
  stddev_pop?: Maybe<MessageContentsMetadataBaseStddevPopFields>;
  stddev_samp?: Maybe<MessageContentsMetadataBaseStddevSampFields>;
  sum?: Maybe<MessageContentsMetadataBaseSumFields>;
  var_pop?: Maybe<MessageContentsMetadataBaseVarPopFields>;
  var_samp?: Maybe<MessageContentsMetadataBaseVarSampFields>;
  variance?: Maybe<MessageContentsMetadataBaseVarianceFields>;
};


/** aggregate fields of "message_contents_metadata_base" */
export type MessageContentsMetadataBaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageContentsMetadataBaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MessageContentsMetadataBaseAvgFields = {
  __typename?: 'message_contents_metadata_base_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message_contents_metadata_base". All fields are combined with a logical 'AND'. */
export type MessageContentsMetadataBaseBoolExp = {
  _and?: InputMaybe<Array<MessageContentsMetadataBaseBoolExp>>;
  _not?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
  _or?: InputMaybe<Array<MessageContentsMetadataBaseBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  variant_id?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type MessageContentsMetadataBaseMaxFields = {
  __typename?: 'message_contents_metadata_base_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MessageContentsMetadataBaseMinFields = {
  __typename?: 'message_contents_metadata_base_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "message_contents_metadata_base". */
export type MessageContentsMetadataBaseOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "message_contents_metadata_base" */
export const MessageContentsMetadataBaseSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageContentsMetadataBaseSelectColumn = typeof MessageContentsMetadataBaseSelectColumn[keyof typeof MessageContentsMetadataBaseSelectColumn];
/** aggregate stddev on columns */
export type MessageContentsMetadataBaseStddevFields = {
  __typename?: 'message_contents_metadata_base_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MessageContentsMetadataBaseStddevPopFields = {
  __typename?: 'message_contents_metadata_base_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MessageContentsMetadataBaseStddevSampFields = {
  __typename?: 'message_contents_metadata_base_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "message_contents_metadata_base" */
export type MessageContentsMetadataBaseStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageContentsMetadataBaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageContentsMetadataBaseStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageContentsMetadataBaseSumFields = {
  __typename?: 'message_contents_metadata_base_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type MessageContentsMetadataBaseVarPopFields = {
  __typename?: 'message_contents_metadata_base_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MessageContentsMetadataBaseVarSampFields = {
  __typename?: 'message_contents_metadata_base_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MessageContentsMetadataBaseVarianceFields = {
  __typename?: 'message_contents_metadata_base_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message_contents_metadata". All fields are combined with a logical 'AND'. */
export type MessageContentsMetadataBoolExp = {
  _and?: InputMaybe<Array<MessageContentsMetadataBoolExp>>;
  _not?: InputMaybe<MessageContentsMetadataBoolExp>;
  _or?: InputMaybe<Array<MessageContentsMetadataBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  preheader?: InputMaybe<StringComparisonExp>;
  profile_mappings?: InputMaybe<JsonbComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  variant_id?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_contents_metadata" */
export const MessageContentsMetadataConstraint = {
  /** unique or primary key constraint on columns "version", "message_id" */
  MessageContentsMetadataCommittedVersionKey: 'message_contents_metadata_committed_version_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MessageContentsMetadataIdWorkspaceIdKey: 'message_contents_metadata_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageContentsMetadataPkey: 'message_contents_metadata_pkey',
  /** unique or primary key constraint on columns "version", "message_id", "variant_id" */
  MessageContentsMetadataVariantVersionKey: 'message_contents_metadata_variant_version_key'
} as const;

export type MessageContentsMetadataConstraint = typeof MessageContentsMetadataConstraint[keyof typeof MessageContentsMetadataConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MessageContentsMetadataDeleteAtPathInput = {
  profile_mappings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MessageContentsMetadataDeleteElemInput = {
  profile_mappings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MessageContentsMetadataDeleteKeyInput = {
  profile_mappings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "message_contents_metadata" */
export type MessageContentsMetadataInsertInput = {
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MessageContentsMetadataMaxFields = {
  __typename?: 'message_contents_metadata_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessageContentsMetadataMinFields = {
  __typename?: 'message_contents_metadata_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_contents_metadata" */
export type MessageContentsMetadataMutationResponse = {
  __typename?: 'message_contents_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageContentsMetadata>;
};

/** input type for inserting object relation for remote table "message_contents_metadata" */
export type MessageContentsMetadataObjRelInsertInput = {
  data: MessageContentsMetadataInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageContentsMetadataOnConflict>;
};

/** on_conflict condition type for table "message_contents_metadata" */
export type MessageContentsMetadataOnConflict = {
  constraint: MessageContentsMetadataConstraint;
  update_columns?: Array<MessageContentsMetadataUpdateColumn>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};

/** Ordering options when selecting data from "message_contents_metadata". */
export type MessageContentsMetadataOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: message_contents_metadata */
export type MessageContentsMetadataPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MessageContentsMetadataPrependInput = {
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "message_contents_metadata" */
export const MessageContentsMetadataSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageContentsMetadataSelectColumn = typeof MessageContentsMetadataSelectColumn[keyof typeof MessageContentsMetadataSelectColumn];
/** input type for updating data in table "message_contents_metadata" */
export type MessageContentsMetadataSetInput = {
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type MessageContentsMetadataStddevFields = {
  __typename?: 'message_contents_metadata_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MessageContentsMetadataStddevPopFields = {
  __typename?: 'message_contents_metadata_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MessageContentsMetadataStddevSampFields = {
  __typename?: 'message_contents_metadata_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_contents_metadata" */
export type MessageContentsMetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageContentsMetadataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageContentsMetadataStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageContentsMetadataSumFields = {
  __typename?: 'message_contents_metadata_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "message_contents_metadata" */
export const MessageContentsMetadataUpdateColumn = {
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id'
} as const;

export type MessageContentsMetadataUpdateColumn = typeof MessageContentsMetadataUpdateColumn[keyof typeof MessageContentsMetadataUpdateColumn];
export type MessageContentsMetadataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MessageContentsMetadataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MessageContentsMetadataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MessageContentsMetadataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MessageContentsMetadataDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MessageContentsMetadataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessageContentsMetadataSetInput>;
  /** filter the rows which have to be updated */
  where: MessageContentsMetadataBoolExp;
};

/** aggregate var_pop on columns */
export type MessageContentsMetadataVarPopFields = {
  __typename?: 'message_contents_metadata_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MessageContentsMetadataVarSampFields = {
  __typename?: 'message_contents_metadata_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MessageContentsMetadataVarianceFields = {
  __typename?: 'message_contents_metadata_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "message_contents_metadata" */
export type MessageContentsMetadataVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessageContentsMinFields = {
  __typename?: 'message_contents_min_fields';
  cep_whatsapp_template_id?: Maybe<Scalars['uuid']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  content_email_version_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "message_contents" */
export type MessageContentsMinOrderBy = {
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  content_email_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  preheader?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_contents" */
export type MessageContentsMutationResponse = {
  __typename?: 'message_contents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageContents>;
};

/** input type for inserting object relation for remote table "message_contents" */
export type MessageContentsObjRelInsertInput = {
  data: MessageContentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageContentsOnConflict>;
};

/** on_conflict condition type for table "message_contents" */
export type MessageContentsOnConflict = {
  constraint: MessageContentsConstraint;
  update_columns?: Array<MessageContentsUpdateColumn>;
  where?: InputMaybe<MessageContentsBoolExp>;
};

/** Ordering options when selecting data from "message_contents". */
export type MessageContentsOrderBy = {
  cep_whatsapp_template?: InputMaybe<CepWhatsappTemplatesOrderBy>;
  cep_whatsapp_template_id?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  content_email_version?: InputMaybe<ContentEmailVersionsOrderBy>;
  content_email_version_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  editor_state?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  preheader?: InputMaybe<OrderBy>;
  profile_mappings?: InputMaybe<OrderBy>;
  rendered_output?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  variant_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: message_contents */
export type MessageContentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MessageContentsPrependInput = {
  editor_state?: InputMaybe<Scalars['jsonb']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "message_contents" */
export const MessageContentsSelectColumn = {
  /** column name */
  CepWhatsappTemplateId: 'cep_whatsapp_template_id',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  ContentEmailVersionId: 'content_email_version_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  EditorState: 'editor_state',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  RenderedOutput: 'rendered_output',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id',
  /** column name */
  Version: 'version',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageContentsSelectColumn = typeof MessageContentsSelectColumn[keyof typeof MessageContentsSelectColumn];
/** input type for updating data in table "message_contents" */
export type MessageContentsSetInput = {
  editor_state?: InputMaybe<Scalars['jsonb']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type MessageContentsStddevFields = {
  __typename?: 'message_contents_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "message_contents" */
export type MessageContentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MessageContentsStddevPopFields = {
  __typename?: 'message_contents_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "message_contents" */
export type MessageContentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MessageContentsStddevSampFields = {
  __typename?: 'message_contents_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "message_contents" */
export type MessageContentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_contents" */
export type MessageContentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageContentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageContentsStreamCursorValueInput = {
  cep_whatsapp_template_id?: InputMaybe<Scalars['uuid']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  content_email_version_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  editor_state?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  preheader?: InputMaybe<Scalars['String']>;
  profile_mappings?: InputMaybe<Scalars['jsonb']>;
  rendered_output?: InputMaybe<Scalars['jsonb']>;
  subject?: InputMaybe<Scalars['String']>;
  /** non-NULL tags the row as an A/B variant. */
  variant_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageContentsSumFields = {
  __typename?: 'message_contents_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_contents" */
export type MessageContentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "message_contents" */
export const MessageContentsUpdateColumn = {
  /** column name */
  EditorState: 'editor_state',
  /** column name */
  Preheader: 'preheader',
  /** column name */
  ProfileMappings: 'profile_mappings',
  /** column name */
  RenderedOutput: 'rendered_output',
  /** column name */
  Subject: 'subject',
  /** column name */
  VariantId: 'variant_id'
} as const;

export type MessageContentsUpdateColumn = typeof MessageContentsUpdateColumn[keyof typeof MessageContentsUpdateColumn];
export type MessageContentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MessageContentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MessageContentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MessageContentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MessageContentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MessageContentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessageContentsSetInput>;
  /** filter the rows which have to be updated */
  where: MessageContentsBoolExp;
};

/** aggregate var_pop on columns */
export type MessageContentsVarPopFields = {
  __typename?: 'message_contents_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "message_contents" */
export type MessageContentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MessageContentsVarSampFields = {
  __typename?: 'message_contents_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "message_contents" */
export type MessageContentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MessageContentsVarianceFields = {
  __typename?: 'message_contents_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "message_contents" */
export type MessageContentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Thin control-plane row (1:1 with experiments) linking a Native Delivery message + tested element (subject_preheader | body) to an experiment. At most one test per element per message. */
export type MessageExperiments = {
  __typename?: 'message_experiments';
  /** An array relationship */
  arms: Array<MessageVariantArm>;
  /** An aggregate relationship */
  arms_aggregate: MessageVariantArmAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  element: Scalars['String'];
  /** An object relationship */
  experiment: Experiments;
  experiment_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  promoted_variant_key?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** Thin control-plane row (1:1 with experiments) linking a Native Delivery message + tested element (subject_preheader | body) to an experiment. At most one test per element per message. */
export type MessageExperimentsArmsArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


/** Thin control-plane row (1:1 with experiments) linking a Native Delivery message + tested element (subject_preheader | body) to an experiment. At most one test per element per message. */
export type MessageExperimentsArmsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};

/** order by aggregate values of table "message_experiments" */
export type MessageExperimentsAggregateOrderBy = {
  avg?: InputMaybe<MessageExperimentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessageExperimentsMaxOrderBy>;
  min?: InputMaybe<MessageExperimentsMinOrderBy>;
  stddev?: InputMaybe<MessageExperimentsStddevOrderBy>;
  stddev_pop?: InputMaybe<MessageExperimentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessageExperimentsStddevSampOrderBy>;
  sum?: InputMaybe<MessageExperimentsSumOrderBy>;
  var_pop?: InputMaybe<MessageExperimentsVarPopOrderBy>;
  var_samp?: InputMaybe<MessageExperimentsVarSampOrderBy>;
  variance?: InputMaybe<MessageExperimentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "message_experiments" */
export type MessageExperimentsArrRelInsertInput = {
  data: Array<MessageExperimentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageExperimentsOnConflict>;
};

/** order by avg() on columns of table "message_experiments" */
export type MessageExperimentsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "message_experiments". All fields are combined with a logical 'AND'. */
export type MessageExperimentsBoolExp = {
  _and?: InputMaybe<Array<MessageExperimentsBoolExp>>;
  _not?: InputMaybe<MessageExperimentsBoolExp>;
  _or?: InputMaybe<Array<MessageExperimentsBoolExp>>;
  arms?: InputMaybe<MessageVariantArmBoolExp>;
  arms_aggregate?: InputMaybe<MessageVariantArmAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  element?: InputMaybe<StringComparisonExp>;
  experiment?: InputMaybe<ExperimentsBoolExp>;
  experiment_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  promoted_variant_key?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_experiments" */
export const MessageExperimentsConstraint = {
  /** unique or primary key constraint on columns "experiment_id" */
  MessageExperimentsExperimentIdKey: 'message_experiments_experiment_id_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MessageExperimentsIdWorkspaceIdKey: 'message_experiments_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageExperimentsPkey: 'message_experiments_pkey',
  /** unique or primary key constraint on columns "workspace_id", "element", "message_id" */
  MessageExperimentsWorkspaceIdMessageIdElementKey: 'message_experiments_workspace_id_message_id_element_key'
} as const;

export type MessageExperimentsConstraint = typeof MessageExperimentsConstraint[keyof typeof MessageExperimentsConstraint];
/** input type for inserting data into table "message_experiments" */
export type MessageExperimentsInsertInput = {
  arms?: InputMaybe<MessageVariantArmArrRelInsertInput>;
  element?: InputMaybe<Scalars['String']>;
  experiment?: InputMaybe<ExperimentsObjRelInsertInput>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
  promoted_variant_key?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "message_experiments" */
export type MessageExperimentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  element?: InputMaybe<OrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  promoted_variant_key?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "message_experiments" */
export type MessageExperimentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  element?: InputMaybe<OrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  promoted_variant_key?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_experiments" */
export type MessageExperimentsMutationResponse = {
  __typename?: 'message_experiments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageExperiments>;
};

/** input type for inserting object relation for remote table "message_experiments" */
export type MessageExperimentsObjRelInsertInput = {
  data: MessageExperimentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageExperimentsOnConflict>;
};

/** on_conflict condition type for table "message_experiments" */
export type MessageExperimentsOnConflict = {
  constraint: MessageExperimentsConstraint;
  update_columns?: Array<MessageExperimentsUpdateColumn>;
  where?: InputMaybe<MessageExperimentsBoolExp>;
};

/** Ordering options when selecting data from "message_experiments". */
export type MessageExperimentsOrderBy = {
  arms_aggregate?: InputMaybe<MessageVariantArmAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  element?: InputMaybe<OrderBy>;
  experiment?: InputMaybe<ExperimentsOrderBy>;
  experiment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  promoted_variant_key?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: message_experiments */
export type MessageExperimentsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "message_experiments" */
export const MessageExperimentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Element: 'element',
  /** column name */
  ExperimentId: 'experiment_id',
  /** column name */
  Id: 'id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  PromotedVariantKey: 'promoted_variant_key',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageExperimentsSelectColumn = typeof MessageExperimentsSelectColumn[keyof typeof MessageExperimentsSelectColumn];
/** input type for updating data in table "message_experiments" */
export type MessageExperimentsSetInput = {
  promoted_variant_key?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "message_experiments" */
export type MessageExperimentsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "message_experiments" */
export type MessageExperimentsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "message_experiments" */
export type MessageExperimentsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_experiments" */
export type MessageExperimentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageExperimentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageExperimentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  element?: InputMaybe<Scalars['String']>;
  experiment_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  promoted_variant_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_experiments" */
export type MessageExperimentsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "message_experiments" */
export const MessageExperimentsUpdateColumn = {
  /** column name */
  PromotedVariantKey: 'promoted_variant_key'
} as const;

export type MessageExperimentsUpdateColumn = typeof MessageExperimentsUpdateColumn[keyof typeof MessageExperimentsUpdateColumn];
export type MessageExperimentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessageExperimentsSetInput>;
  /** filter the rows which have to be updated */
  where: MessageExperimentsBoolExp;
};

/** order by var_pop() on columns of table "message_experiments" */
export type MessageExperimentsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "message_experiments" */
export type MessageExperimentsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "message_experiments" */
export type MessageExperimentsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "message_labels" */
export type MessageLabels = {
  __typename?: 'message_labels';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  label: Labels;
  label_id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  resource_type: Scalars['String'];
  source: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "message_labels" */
export type MessageLabelsAggregate = {
  __typename?: 'message_labels_aggregate';
  aggregate?: Maybe<MessageLabelsAggregateFields>;
  nodes: Array<MessageLabels>;
};

export type MessageLabelsAggregateBoolExp = {
  count?: InputMaybe<MessageLabelsAggregateBoolExpCount>;
};

export type MessageLabelsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessageLabelsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "message_labels" */
export type MessageLabelsAggregateFields = {
  __typename?: 'message_labels_aggregate_fields';
  avg?: Maybe<MessageLabelsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageLabelsMaxFields>;
  min?: Maybe<MessageLabelsMinFields>;
  stddev?: Maybe<MessageLabelsStddevFields>;
  stddev_pop?: Maybe<MessageLabelsStddevPopFields>;
  stddev_samp?: Maybe<MessageLabelsStddevSampFields>;
  sum?: Maybe<MessageLabelsSumFields>;
  var_pop?: Maybe<MessageLabelsVarPopFields>;
  var_samp?: Maybe<MessageLabelsVarSampFields>;
  variance?: Maybe<MessageLabelsVarianceFields>;
};


/** aggregate fields of "message_labels" */
export type MessageLabelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message_labels" */
export type MessageLabelsAggregateOrderBy = {
  avg?: InputMaybe<MessageLabelsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessageLabelsMaxOrderBy>;
  min?: InputMaybe<MessageLabelsMinOrderBy>;
  stddev?: InputMaybe<MessageLabelsStddevOrderBy>;
  stddev_pop?: InputMaybe<MessageLabelsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessageLabelsStddevSampOrderBy>;
  sum?: InputMaybe<MessageLabelsSumOrderBy>;
  var_pop?: InputMaybe<MessageLabelsVarPopOrderBy>;
  var_samp?: InputMaybe<MessageLabelsVarSampOrderBy>;
  variance?: InputMaybe<MessageLabelsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "message_labels" */
export type MessageLabelsArrRelInsertInput = {
  data: Array<MessageLabelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageLabelsOnConflict>;
};

/** aggregate avg on columns */
export type MessageLabelsAvgFields = {
  __typename?: 'message_labels_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "message_labels" */
export type MessageLabelsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "message_labels". All fields are combined with a logical 'AND'. */
export type MessageLabelsBoolExp = {
  _and?: InputMaybe<Array<MessageLabelsBoolExp>>;
  _not?: InputMaybe<MessageLabelsBoolExp>;
  _or?: InputMaybe<Array<MessageLabelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  label?: InputMaybe<LabelsBoolExp>;
  label_id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_labels" */
export const MessageLabelsConstraint = {
  /** unique or primary key constraint on columns "label_id", "message_id" */
  MessageLabelsPkey: 'message_labels_pkey'
} as const;

export type MessageLabelsConstraint = typeof MessageLabelsConstraint[keyof typeof MessageLabelsConstraint];
/** input type for inserting data into table "message_labels" */
export type MessageLabelsInsertInput = {
  label?: InputMaybe<LabelsObjRelInsertInput>;
  label_id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type MessageLabelsMaxFields = {
  __typename?: 'message_labels_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "message_labels" */
export type MessageLabelsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessageLabelsMinFields = {
  __typename?: 'message_labels_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  label_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "message_labels" */
export type MessageLabelsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  label_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_labels" */
export type MessageLabelsMutationResponse = {
  __typename?: 'message_labels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageLabels>;
};

/** on_conflict condition type for table "message_labels" */
export type MessageLabelsOnConflict = {
  constraint: MessageLabelsConstraint;
  update_columns?: Array<MessageLabelsUpdateColumn>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};

/** Ordering options when selecting data from "message_labels". */
export type MessageLabelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  label?: InputMaybe<LabelsOrderBy>;
  label_id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "message_labels" */
export const MessageLabelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  LabelId: 'label_id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Source: 'source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageLabelsSelectColumn = typeof MessageLabelsSelectColumn[keyof typeof MessageLabelsSelectColumn];
/** aggregate stddev on columns */
export type MessageLabelsStddevFields = {
  __typename?: 'message_labels_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "message_labels" */
export type MessageLabelsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MessageLabelsStddevPopFields = {
  __typename?: 'message_labels_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "message_labels" */
export type MessageLabelsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MessageLabelsStddevSampFields = {
  __typename?: 'message_labels_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "message_labels" */
export type MessageLabelsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_labels" */
export type MessageLabelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageLabelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageLabelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  label_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageLabelsSumFields = {
  __typename?: 'message_labels_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_labels" */
export type MessageLabelsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "message_labels" (current role has no relevant permissions) */
export const MessageLabelsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type MessageLabelsUpdateColumn = typeof MessageLabelsUpdateColumn[keyof typeof MessageLabelsUpdateColumn];
/** aggregate var_pop on columns */
export type MessageLabelsVarPopFields = {
  __typename?: 'message_labels_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "message_labels" */
export type MessageLabelsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MessageLabelsVarSampFields = {
  __typename?: 'message_labels_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "message_labels" */
export type MessageLabelsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MessageLabelsVarianceFields = {
  __typename?: 'message_labels_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "message_labels" */
export type MessageLabelsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "message_push_apps" */
export type MessagePushApps = {
  __typename?: 'message_push_apps';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  message: Messages;
  message_id: Scalars['uuid'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  /** An object relationship */
  push_app: PushApps;
  push_app_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "message_push_apps" */
export type MessagePushAppsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "message_push_apps" */
export type MessagePushAppsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** order by aggregate values of table "message_push_apps" */
export type MessagePushAppsAggregateOrderBy = {
  avg?: InputMaybe<MessagePushAppsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagePushAppsMaxOrderBy>;
  min?: InputMaybe<MessagePushAppsMinOrderBy>;
  stddev?: InputMaybe<MessagePushAppsStddevOrderBy>;
  stddev_pop?: InputMaybe<MessagePushAppsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessagePushAppsStddevSampOrderBy>;
  sum?: InputMaybe<MessagePushAppsSumOrderBy>;
  var_pop?: InputMaybe<MessagePushAppsVarPopOrderBy>;
  var_samp?: InputMaybe<MessagePushAppsVarSampOrderBy>;
  variance?: InputMaybe<MessagePushAppsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "message_push_apps" */
export type MessagePushAppsArrRelInsertInput = {
  data: Array<MessagePushAppsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessagePushAppsOnConflict>;
};

/** order by avg() on columns of table "message_push_apps" */
export type MessagePushAppsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "message_push_apps". All fields are combined with a logical 'AND'. */
export type MessagePushAppsBoolExp = {
  _and?: InputMaybe<Array<MessagePushAppsBoolExp>>;
  _not?: InputMaybe<MessagePushAppsBoolExp>;
  _or?: InputMaybe<Array<MessagePushAppsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  push_app?: InputMaybe<PushAppsBoolExp>;
  push_app_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_push_apps" */
export const MessagePushAppsConstraint = {
  /** unique or primary key constraint on columns "push_app_id", "message_id" */
  MessagePushAppsPkey: 'message_push_apps_pkey'
} as const;

export type MessagePushAppsConstraint = typeof MessagePushAppsConstraint[keyof typeof MessagePushAppsConstraint];
/** input type for inserting data into table "message_push_apps" */
export type MessagePushAppsInsertInput = {
  message?: InputMaybe<MessagesObjRelInsertInput>;
  message_id?: InputMaybe<Scalars['uuid']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  push_app?: InputMaybe<PushAppsObjRelInsertInput>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "message_push_apps" */
export type MessagePushAppsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "message_push_apps" */
export type MessagePushAppsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_push_apps" */
export type MessagePushAppsMutationResponse = {
  __typename?: 'message_push_apps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagePushApps>;
};

/** on_conflict condition type for table "message_push_apps" */
export type MessagePushAppsOnConflict = {
  constraint: MessagePushAppsConstraint;
  update_columns?: Array<MessagePushAppsUpdateColumn>;
  where?: InputMaybe<MessagePushAppsBoolExp>;
};

/** Ordering options when selecting data from "message_push_apps". */
export type MessagePushAppsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_id?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  push_app?: InputMaybe<PushAppsOrderBy>;
  push_app_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "message_push_apps" */
export const MessagePushAppsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  PushAppId: 'push_app_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessagePushAppsSelectColumn = typeof MessagePushAppsSelectColumn[keyof typeof MessagePushAppsSelectColumn];
/** order by stddev() on columns of table "message_push_apps" */
export type MessagePushAppsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "message_push_apps" */
export type MessagePushAppsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "message_push_apps" */
export type MessagePushAppsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_push_apps" */
export type MessagePushAppsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessagePushAppsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagePushAppsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  push_app_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_push_apps" */
export type MessagePushAppsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "message_push_apps" (current role has no relevant permissions) */
export const MessagePushAppsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type MessagePushAppsUpdateColumn = typeof MessagePushAppsUpdateColumn[keyof typeof MessagePushAppsUpdateColumn];
/** order by var_pop() on columns of table "message_push_apps" */
export type MessagePushAppsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "message_push_apps" */
export type MessagePushAppsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "message_push_apps" */
export type MessagePushAppsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "message_variant_arm" */
export type MessageVariantArm = {
  __typename?: 'message_variant_arm';
  /** An object relationship */
  body_contents?: Maybe<MessageContents>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  draft_body_contents?: Maybe<MessageContents>;
  draft_body_contents_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  draft_metadata_contents?: Maybe<MessageContentsMetadata>;
  draft_metadata_contents_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  experiment: MessageExperiments;
  id: Scalars['uuid'];
  /** An object relationship */
  message: Messages;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: Maybe<Scalars['uuid']>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  metadata_contents?: Maybe<MessageContentsMetadata>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "message_variant_arm" */
export type MessageVariantArmAggregate = {
  __typename?: 'message_variant_arm_aggregate';
  aggregate?: Maybe<MessageVariantArmAggregateFields>;
  nodes: Array<MessageVariantArm>;
};

export type MessageVariantArmAggregateBoolExp = {
  count?: InputMaybe<MessageVariantArmAggregateBoolExpCount>;
};

export type MessageVariantArmAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessageVariantArmBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "message_variant_arm" */
export type MessageVariantArmAggregateFields = {
  __typename?: 'message_variant_arm_aggregate_fields';
  avg?: Maybe<MessageVariantArmAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessageVariantArmMaxFields>;
  min?: Maybe<MessageVariantArmMinFields>;
  stddev?: Maybe<MessageVariantArmStddevFields>;
  stddev_pop?: Maybe<MessageVariantArmStddevPopFields>;
  stddev_samp?: Maybe<MessageVariantArmStddevSampFields>;
  sum?: Maybe<MessageVariantArmSumFields>;
  var_pop?: Maybe<MessageVariantArmVarPopFields>;
  var_samp?: Maybe<MessageVariantArmVarSampFields>;
  variance?: Maybe<MessageVariantArmVarianceFields>;
};


/** aggregate fields of "message_variant_arm" */
export type MessageVariantArmAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message_variant_arm" */
export type MessageVariantArmAggregateOrderBy = {
  avg?: InputMaybe<MessageVariantArmAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessageVariantArmMaxOrderBy>;
  min?: InputMaybe<MessageVariantArmMinOrderBy>;
  stddev?: InputMaybe<MessageVariantArmStddevOrderBy>;
  stddev_pop?: InputMaybe<MessageVariantArmStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessageVariantArmStddevSampOrderBy>;
  sum?: InputMaybe<MessageVariantArmSumOrderBy>;
  var_pop?: InputMaybe<MessageVariantArmVarPopOrderBy>;
  var_samp?: InputMaybe<MessageVariantArmVarSampOrderBy>;
  variance?: InputMaybe<MessageVariantArmVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "message_variant_arm" */
export type MessageVariantArmArrRelInsertInput = {
  data: Array<MessageVariantArmInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessageVariantArmOnConflict>;
};

/** aggregate avg on columns */
export type MessageVariantArmAvgFields = {
  __typename?: 'message_variant_arm_avg_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "message_variant_arm" */
export type MessageVariantArmAvgOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "message_variant_arm". All fields are combined with a logical 'AND'. */
export type MessageVariantArmBoolExp = {
  _and?: InputMaybe<Array<MessageVariantArmBoolExp>>;
  _not?: InputMaybe<MessageVariantArmBoolExp>;
  _or?: InputMaybe<Array<MessageVariantArmBoolExp>>;
  body_contents?: InputMaybe<MessageContentsBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  draft_body_contents?: InputMaybe<MessageContentsBoolExp>;
  draft_body_contents_id?: InputMaybe<UuidComparisonExp>;
  draft_metadata_contents?: InputMaybe<MessageContentsMetadataBoolExp>;
  draft_metadata_contents_id?: InputMaybe<UuidComparisonExp>;
  experiment?: InputMaybe<MessageExperimentsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<MessagesBoolExp>;
  message_body_contents_id?: InputMaybe<UuidComparisonExp>;
  message_experiment_id?: InputMaybe<UuidComparisonExp>;
  message_id?: InputMaybe<UuidComparisonExp>;
  message_metadata_contents_id?: InputMaybe<UuidComparisonExp>;
  metadata_contents?: InputMaybe<MessageContentsMetadataBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  percentage?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  variant_key?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "message_variant_arm" */
export const MessageVariantArmConstraint = {
  /** unique or primary key constraint on columns "message_experiment_id", "variant_key" */
  MessageVariantArmExperimentIdVariantKeyKey: 'message_variant_arm_experiment_id_variant_key_key',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MessageVariantArmIdWorkspaceIdKey: 'message_variant_arm_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageVariantArmPkey: 'message_variant_arm_pkey'
} as const;

export type MessageVariantArmConstraint = typeof MessageVariantArmConstraint[keyof typeof MessageVariantArmConstraint];
/** input type for incrementing numeric columns in table "message_variant_arm" */
export type MessageVariantArmIncInput = {
  percentage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "message_variant_arm" */
export type MessageVariantArmInsertInput = {
  body_contents?: InputMaybe<MessageContentsObjRelInsertInput>;
  draft_body_contents?: InputMaybe<MessageContentsObjRelInsertInput>;
  draft_metadata_contents?: InputMaybe<MessageContentsMetadataObjRelInsertInput>;
  experiment?: InputMaybe<MessageExperimentsObjRelInsertInput>;
  message?: InputMaybe<MessagesObjRelInsertInput>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: InputMaybe<Scalars['uuid']>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: InputMaybe<Scalars['uuid']>;
  metadata_contents?: InputMaybe<MessageContentsMetadataObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MessageVariantArmMaxFields = {
  __typename?: 'message_variant_arm_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  draft_body_contents_id?: Maybe<Scalars['uuid']>;
  draft_metadata_contents_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: Maybe<Scalars['uuid']>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "message_variant_arm" */
export type MessageVariantArmMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  draft_body_contents_id?: InputMaybe<OrderBy>;
  draft_metadata_contents_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: InputMaybe<OrderBy>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessageVariantArmMinFields = {
  __typename?: 'message_variant_arm_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  draft_body_contents_id?: Maybe<Scalars['uuid']>;
  draft_metadata_contents_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: Maybe<Scalars['uuid']>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "message_variant_arm" */
export type MessageVariantArmMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  draft_body_contents_id?: InputMaybe<OrderBy>;
  draft_metadata_contents_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: InputMaybe<OrderBy>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "message_variant_arm" */
export type MessageVariantArmMutationResponse = {
  __typename?: 'message_variant_arm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageVariantArm>;
};

/** on_conflict condition type for table "message_variant_arm" */
export type MessageVariantArmOnConflict = {
  constraint: MessageVariantArmConstraint;
  update_columns?: Array<MessageVariantArmUpdateColumn>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};

/** Ordering options when selecting data from "message_variant_arm". */
export type MessageVariantArmOrderBy = {
  body_contents?: InputMaybe<MessageContentsOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  draft_body_contents?: InputMaybe<MessageContentsOrderBy>;
  draft_body_contents_id?: InputMaybe<OrderBy>;
  draft_metadata_contents?: InputMaybe<MessageContentsMetadataOrderBy>;
  draft_metadata_contents_id?: InputMaybe<OrderBy>;
  experiment?: InputMaybe<MessageExperimentsOrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<MessagesOrderBy>;
  message_body_contents_id?: InputMaybe<OrderBy>;
  message_experiment_id?: InputMaybe<OrderBy>;
  message_id?: InputMaybe<OrderBy>;
  message_metadata_contents_id?: InputMaybe<OrderBy>;
  metadata_contents?: InputMaybe<MessageContentsMetadataOrderBy>;
  name?: InputMaybe<OrderBy>;
  percentage?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  variant_key?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: message_variant_arm */
export type MessageVariantArmPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "message_variant_arm" */
export const MessageVariantArmSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DraftBodyContentsId: 'draft_body_contents_id',
  /** column name */
  DraftMetadataContentsId: 'draft_metadata_contents_id',
  /** column name */
  Id: 'id',
  /** column name */
  MessageBodyContentsId: 'message_body_contents_id',
  /** column name */
  MessageExperimentId: 'message_experiment_id',
  /** column name */
  MessageId: 'message_id',
  /** column name */
  MessageMetadataContentsId: 'message_metadata_contents_id',
  /** column name */
  Name: 'name',
  /** column name */
  Percentage: 'percentage',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  VariantKey: 'variant_key',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessageVariantArmSelectColumn = typeof MessageVariantArmSelectColumn[keyof typeof MessageVariantArmSelectColumn];
/** input type for updating data in table "message_variant_arm" */
export type MessageVariantArmSetInput = {
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: InputMaybe<Scalars['uuid']>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MessageVariantArmStddevFields = {
  __typename?: 'message_variant_arm_stddev_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "message_variant_arm" */
export type MessageVariantArmStddevOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MessageVariantArmStddevPopFields = {
  __typename?: 'message_variant_arm_stddev_pop_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "message_variant_arm" */
export type MessageVariantArmStddevPopOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MessageVariantArmStddevSampFields = {
  __typename?: 'message_variant_arm_stddev_samp_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "message_variant_arm" */
export type MessageVariantArmStddevSampOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "message_variant_arm" */
export type MessageVariantArmStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessageVariantArmStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageVariantArmStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  draft_body_contents_id?: InputMaybe<Scalars['uuid']>;
  draft_metadata_contents_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Set for body variants; references message_contents by workspace-scoped id. */
  message_body_contents_id?: InputMaybe<Scalars['uuid']>;
  /** The experiment (test) this arm belongs to (FK -> message_experiments). */
  message_experiment_id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['uuid']>;
  /** Set for subject/push-notification variants; references message_contents_metadata by workspace-scoped id. */
  message_metadata_contents_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  /** Stable split-group value used by addSplitTestColumn for per-recipient assignment. */
  variant_key?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageVariantArmSumFields = {
  __typename?: 'message_variant_arm_sum_fields';
  percentage?: Maybe<Scalars['numeric']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "message_variant_arm" */
export type MessageVariantArmSumOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "message_variant_arm" */
export const MessageVariantArmUpdateColumn = {
  /** column name */
  MessageBodyContentsId: 'message_body_contents_id',
  /** column name */
  MessageMetadataContentsId: 'message_metadata_contents_id',
  /** column name */
  Name: 'name',
  /** column name */
  Percentage: 'percentage',
  /** column name */
  VariantKey: 'variant_key'
} as const;

export type MessageVariantArmUpdateColumn = typeof MessageVariantArmUpdateColumn[keyof typeof MessageVariantArmUpdateColumn];
export type MessageVariantArmUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MessageVariantArmIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessageVariantArmSetInput>;
  /** filter the rows which have to be updated */
  where: MessageVariantArmBoolExp;
};

/** aggregate var_pop on columns */
export type MessageVariantArmVarPopFields = {
  __typename?: 'message_variant_arm_var_pop_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "message_variant_arm" */
export type MessageVariantArmVarPopOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MessageVariantArmVarSampFields = {
  __typename?: 'message_variant_arm_var_samp_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "message_variant_arm" */
export type MessageVariantArmVarSampOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MessageVariantArmVarianceFields = {
  __typename?: 'message_variant_arm_variance_fields';
  percentage?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "message_variant_arm" */
export type MessageVariantArmVarianceOrderBy = {
  percentage?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "messages" */
export type Messages = {
  __typename?: 'messages';
  /** An object relationship */
  brand_settings: CepBrandSettings;
  /** An object relationship */
  campaign?: Maybe<Campaigns>;
  campaign_id?: Maybe<Scalars['uuid']>;
  cep_brand_id: Scalars['uuid'];
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cep_sender_identity?: Maybe<CepSenderIdentities>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  cep_subscription_topic?: Maybe<CepSubscriptionTopics>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  channel_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  content_block_usages: Array<CepContentBlockMessageUsages>;
  /** An aggregate relationship */
  content_block_usages_aggregate: CepContentBlockMessageUsagesAggregate;
  /** An array relationship */
  content_dynamic_slot_usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  content_dynamic_slot_usages_aggregate: ContentDynamicSlotUsagesAggregate;
  /** An array relationship */
  content_email_message_links: Array<ContentEmailMessageLinks>;
  /** An aggregate relationship */
  content_email_message_links_aggregate: ContentEmailMessageLinksAggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  current_content?: Maybe<MessageContentsBase>;
  /** An object relationship */
  current_metadata?: Maybe<MessageContentsMetadataBase>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  device_preview?: Maybe<CepDevicePreviews>;
  /** An array relationship */
  device_previews: Array<CepMessageDevicePreviews>;
  /** An aggregate relationship */
  device_previews_aggregate: CepMessageDevicePreviewsAggregate;
  /** An object relationship */
  draft_content?: Maybe<MessageContentsBase>;
  /** An object relationship */
  draft_metadata?: Maybe<MessageContentsMetadataBase>;
  draft_metadata_version?: Maybe<Scalars['Int']>;
  draft_version?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An array relationship */
  journey_messages: Array<JourneyMessages>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  measurement_config: Scalars['jsonb'];
  /** An array relationship */
  message_contents: Array<MessageContents>;
  /** An aggregate relationship */
  message_contents_aggregate: MessageContentsAggregate;
  /** An array relationship */
  message_contents_metadata: Array<MessageContentsMetadata>;
  /** An aggregate relationship */
  message_contents_metadata_aggregate: MessageContentsMetadataAggregate;
  /** An array relationship */
  message_experiments: Array<MessageExperiments>;
  /** An array relationship */
  message_labels: Array<MessageLabels>;
  /** An aggregate relationship */
  message_labels_aggregate: MessageLabelsAggregate;
  /** An array relationship */
  message_push_apps: Array<MessagePushApps>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  published_metadata_version?: Maybe<Scalars['Int']>;
  published_version: Scalars['Int'];
  /** An object relationship */
  push_config?: Maybe<PushConfig>;
  push_config_id?: Maybe<Scalars['uuid']>;
  send_config: Scalars['jsonb'];
  send_gates: Scalars['jsonb'];
  tags: Scalars['jsonb'];
  targeting_config: Scalars['jsonb'];
  transactional?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "messages" */
export type MessagesContentBlockUsagesArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesContentBlockUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesContentDynamicSlotUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesContentDynamicSlotUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesContentEmailMessageLinksArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesContentEmailMessageLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesDevicePreviewsArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesDevicePreviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesJourneyMessagesArgs = {
  distinct_on?: InputMaybe<Array<JourneyMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyMessagesOrderBy>>;
  where?: InputMaybe<JourneyMessagesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMeasurementConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "messages" */
export type MessagesMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageContentsMetadataArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageContentsMetadataAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageExperimentsArgs = {
  distinct_on?: InputMaybe<Array<MessageExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageExperimentsOrderBy>>;
  where?: InputMaybe<MessageExperimentsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageLabelsArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessageLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesMessagePushAppsArgs = {
  distinct_on?: InputMaybe<Array<MessagePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagePushAppsOrderBy>>;
  where?: InputMaybe<MessagePushAppsBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "messages" */
export type MessagesSendConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "messages" */
export type MessagesSendGatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "messages" */
export type MessagesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "messages" */
export type MessagesTargetingConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "messages" */
export type MessagesAggregate = {
  __typename?: 'messages_aggregate';
  aggregate?: Maybe<MessagesAggregateFields>;
  nodes: Array<Messages>;
};

export type MessagesAggregateBoolExp = {
  bool_and?: InputMaybe<MessagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<MessagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<MessagesAggregateBoolExpCount>;
};

export type MessagesAggregateBoolExpBoolAnd = {
  arguments: MessagesSelectColumnMessagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessagesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MessagesAggregateBoolExpBoolOr = {
  arguments: MessagesSelectColumnMessagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessagesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MessagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messages" */
export type MessagesAggregateFields = {
  __typename?: 'messages_aggregate_fields';
  avg?: Maybe<MessagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MessagesMaxFields>;
  min?: Maybe<MessagesMinFields>;
  stddev?: Maybe<MessagesStddevFields>;
  stddev_pop?: Maybe<MessagesStddevPopFields>;
  stddev_samp?: Maybe<MessagesStddevSampFields>;
  sum?: Maybe<MessagesSumFields>;
  var_pop?: Maybe<MessagesVarPopFields>;
  var_samp?: Maybe<MessagesVarSampFields>;
  variance?: Maybe<MessagesVarianceFields>;
};


/** aggregate fields of "messages" */
export type MessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "messages" */
export type MessagesAggregateOrderBy = {
  avg?: InputMaybe<MessagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagesMaxOrderBy>;
  min?: InputMaybe<MessagesMinOrderBy>;
  stddev?: InputMaybe<MessagesStddevOrderBy>;
  stddev_pop?: InputMaybe<MessagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<MessagesStddevSampOrderBy>;
  sum?: InputMaybe<MessagesSumOrderBy>;
  var_pop?: InputMaybe<MessagesVarPopOrderBy>;
  var_samp?: InputMaybe<MessagesVarSampOrderBy>;
  variance?: InputMaybe<MessagesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MessagesAppendInput = {
  measurement_config?: InputMaybe<Scalars['jsonb']>;
  send_config?: InputMaybe<Scalars['jsonb']>;
  send_gates?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "messages" */
export type MessagesArrRelInsertInput = {
  data: Array<MessagesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<MessagesOnConflict>;
};

/** aggregate avg on columns */
export type MessagesAvgFields = {
  __typename?: 'messages_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "messages" */
export type MessagesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type MessagesBoolExp = {
  _and?: InputMaybe<Array<MessagesBoolExp>>;
  _not?: InputMaybe<MessagesBoolExp>;
  _or?: InputMaybe<Array<MessagesBoolExp>>;
  brand_settings?: InputMaybe<CepBrandSettingsBoolExp>;
  campaign?: InputMaybe<CampaignsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  cep_brand_id?: InputMaybe<UuidComparisonExp>;
  cep_device_preview_id?: InputMaybe<UuidComparisonExp>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesBoolExp>;
  cep_sender_identity_id?: InputMaybe<UuidComparisonExp>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topic_id?: InputMaybe<UuidComparisonExp>;
  channel_type?: InputMaybe<StringComparisonExp>;
  content_block_usages?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
  content_block_usages_aggregate?: InputMaybe<CepContentBlockMessageUsagesAggregateBoolExp>;
  content_dynamic_slot_usages?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateBoolExp>;
  content_email_message_links?: InputMaybe<ContentEmailMessageLinksBoolExp>;
  content_email_message_links_aggregate?: InputMaybe<ContentEmailMessageLinksAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  current_content?: InputMaybe<MessageContentsBaseBoolExp>;
  current_metadata?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  device_preview?: InputMaybe<CepDevicePreviewsBoolExp>;
  device_previews?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
  device_previews_aggregate?: InputMaybe<CepMessageDevicePreviewsAggregateBoolExp>;
  draft_content?: InputMaybe<MessageContentsBaseBoolExp>;
  draft_metadata?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
  draft_metadata_version?: InputMaybe<IntComparisonExp>;
  draft_version?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  journey_messages?: InputMaybe<JourneyMessagesBoolExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  measurement_config?: InputMaybe<JsonbComparisonExp>;
  message_contents?: InputMaybe<MessageContentsBoolExp>;
  message_contents_aggregate?: InputMaybe<MessageContentsAggregateBoolExp>;
  message_contents_metadata?: InputMaybe<MessageContentsMetadataBoolExp>;
  message_contents_metadata_aggregate?: InputMaybe<MessageContentsMetadataAggregateBoolExp>;
  message_experiments?: InputMaybe<MessageExperimentsBoolExp>;
  message_labels?: InputMaybe<MessageLabelsBoolExp>;
  message_labels_aggregate?: InputMaybe<MessageLabelsAggregateBoolExp>;
  message_push_apps?: InputMaybe<MessagePushAppsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  published_metadata_version?: InputMaybe<IntComparisonExp>;
  published_version?: InputMaybe<IntComparisonExp>;
  push_config?: InputMaybe<PushConfigBoolExp>;
  push_config_id?: InputMaybe<UuidComparisonExp>;
  send_config?: InputMaybe<JsonbComparisonExp>;
  send_gates?: InputMaybe<JsonbComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  targeting_config?: InputMaybe<JsonbComparisonExp>;
  transactional?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "messages" */
export const MessagesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MessagesIdWorkspaceIdKey: 'messages_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  MessagesPkey: 'messages_pkey'
} as const;

export type MessagesConstraint = typeof MessagesConstraint[keyof typeof MessagesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MessagesDeleteAtPathInput = {
  measurement_config?: InputMaybe<Array<Scalars['String']>>;
  send_config?: InputMaybe<Array<Scalars['String']>>;
  send_gates?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  targeting_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MessagesDeleteElemInput = {
  measurement_config?: InputMaybe<Scalars['Int']>;
  send_config?: InputMaybe<Scalars['Int']>;
  send_gates?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
  targeting_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MessagesDeleteKeyInput = {
  measurement_config?: InputMaybe<Scalars['String']>;
  send_config?: InputMaybe<Scalars['String']>;
  send_gates?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  targeting_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "messages" */
export type MessagesIncInput = {
  draft_metadata_version?: InputMaybe<Scalars['Int']>;
  draft_version?: InputMaybe<Scalars['Int']>;
  published_metadata_version?: InputMaybe<Scalars['Int']>;
  published_version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "messages" */
export type MessagesInsertInput = {
  brand_settings?: InputMaybe<CepBrandSettingsObjRelInsertInput>;
  campaign?: InputMaybe<CampaignsObjRelInsertInput>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesObjRelInsertInput>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsObjRelInsertInput>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  channel_type?: InputMaybe<Scalars['String']>;
  content_dynamic_slot_usages?: InputMaybe<ContentDynamicSlotUsagesArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  measurement_config?: InputMaybe<Scalars['jsonb']>;
  message_contents?: InputMaybe<MessageContentsArrRelInsertInput>;
  message_contents_metadata?: InputMaybe<MessageContentsMetadataArrRelInsertInput>;
  message_experiments?: InputMaybe<MessageExperimentsArrRelInsertInput>;
  message_labels?: InputMaybe<MessageLabelsArrRelInsertInput>;
  message_push_apps?: InputMaybe<MessagePushAppsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  published_metadata_version?: InputMaybe<Scalars['Int']>;
  published_version?: InputMaybe<Scalars['Int']>;
  push_config?: InputMaybe<PushConfigObjRelInsertInput>;
  push_config_id?: InputMaybe<Scalars['uuid']>;
  send_config?: InputMaybe<Scalars['jsonb']>;
  send_gates?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_config?: InputMaybe<Scalars['jsonb']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type MessagesMaxFields = {
  __typename?: 'messages_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  draft_metadata_version?: Maybe<Scalars['Int']>;
  draft_version?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  published_metadata_version?: Maybe<Scalars['Int']>;
  published_version?: Maybe<Scalars['Int']>;
  push_config_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "messages" */
export type MessagesMaxOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  cep_device_preview_id?: InputMaybe<OrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  push_config_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessagesMinFields = {
  __typename?: 'messages_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  cep_brand_id?: Maybe<Scalars['uuid']>;
  cep_device_preview_id?: Maybe<Scalars['uuid']>;
  cep_sender_identity_id?: Maybe<Scalars['uuid']>;
  cep_subscription_topic_id?: Maybe<Scalars['uuid']>;
  channel_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  draft_metadata_version?: Maybe<Scalars['Int']>;
  draft_version?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  published_metadata_version?: Maybe<Scalars['Int']>;
  published_version?: Maybe<Scalars['Int']>;
  push_config_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "messages" */
export type MessagesMinOrderBy = {
  campaign_id?: InputMaybe<OrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  cep_device_preview_id?: InputMaybe<OrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  channel_type?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  push_config_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messages" */
export type MessagesMutationResponse = {
  __typename?: 'messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
};

/** input type for inserting object relation for remote table "messages" */
export type MessagesObjRelInsertInput = {
  data: MessagesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<MessagesOnConflict>;
};

/** on_conflict condition type for table "messages" */
export type MessagesOnConflict = {
  constraint: MessagesConstraint;
  update_columns?: Array<MessagesUpdateColumn>;
  where?: InputMaybe<MessagesBoolExp>;
};

/** Ordering options when selecting data from "messages". */
export type MessagesOrderBy = {
  brand_settings?: InputMaybe<CepBrandSettingsOrderBy>;
  campaign?: InputMaybe<CampaignsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  cep_brand_id?: InputMaybe<OrderBy>;
  cep_device_preview_id?: InputMaybe<OrderBy>;
  cep_sender_identity?: InputMaybe<CepSenderIdentitiesOrderBy>;
  cep_sender_identity_id?: InputMaybe<OrderBy>;
  cep_subscription_topic?: InputMaybe<CepSubscriptionTopicsOrderBy>;
  cep_subscription_topic_id?: InputMaybe<OrderBy>;
  channel_type?: InputMaybe<OrderBy>;
  content_block_usages_aggregate?: InputMaybe<CepContentBlockMessageUsagesAggregateOrderBy>;
  content_dynamic_slot_usages_aggregate?: InputMaybe<ContentDynamicSlotUsagesAggregateOrderBy>;
  content_email_message_links_aggregate?: InputMaybe<ContentEmailMessageLinksAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  current_content?: InputMaybe<MessageContentsBaseOrderBy>;
  current_metadata?: InputMaybe<MessageContentsMetadataBaseOrderBy>;
  description?: InputMaybe<OrderBy>;
  device_preview?: InputMaybe<CepDevicePreviewsOrderBy>;
  device_previews_aggregate?: InputMaybe<CepMessageDevicePreviewsAggregateOrderBy>;
  draft_content?: InputMaybe<MessageContentsBaseOrderBy>;
  draft_metadata?: InputMaybe<MessageContentsMetadataBaseOrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_messages_aggregate?: InputMaybe<JourneyMessagesAggregateOrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  measurement_config?: InputMaybe<OrderBy>;
  message_contents_aggregate?: InputMaybe<MessageContentsAggregateOrderBy>;
  message_contents_metadata_aggregate?: InputMaybe<MessageContentsMetadataAggregateOrderBy>;
  message_experiments_aggregate?: InputMaybe<MessageExperimentsAggregateOrderBy>;
  message_labels_aggregate?: InputMaybe<MessageLabelsAggregateOrderBy>;
  message_push_apps_aggregate?: InputMaybe<MessagePushAppsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  push_config?: InputMaybe<PushConfigOrderBy>;
  push_config_id?: InputMaybe<OrderBy>;
  send_config?: InputMaybe<OrderBy>;
  send_gates?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  targeting_config?: InputMaybe<OrderBy>;
  transactional?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messages */
export type MessagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MessagesPrependInput = {
  measurement_config?: InputMaybe<Scalars['jsonb']>;
  send_config?: InputMaybe<Scalars['jsonb']>;
  send_gates?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "messages" */
export const MessagesSelectColumn = {
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  CepDevicePreviewId: 'cep_device_preview_id',
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DraftMetadataVersion: 'draft_metadata_version',
  /** column name */
  DraftVersion: 'draft_version',
  /** column name */
  Id: 'id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  MeasurementConfig: 'measurement_config',
  /** column name */
  Name: 'name',
  /** column name */
  PublishedMetadataVersion: 'published_metadata_version',
  /** column name */
  PublishedVersion: 'published_version',
  /** column name */
  PushConfigId: 'push_config_id',
  /** column name */
  SendConfig: 'send_config',
  /** column name */
  SendGates: 'send_gates',
  /** column name */
  Tags: 'tags',
  /** column name */
  TargetingConfig: 'targeting_config',
  /** column name */
  Transactional: 'transactional',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MessagesSelectColumn = typeof MessagesSelectColumn[keyof typeof MessagesSelectColumn];
/** select "messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "messages" */
export const MessagesSelectColumnMessagesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type MessagesSelectColumnMessagesAggregateBoolExpBoolAndArgumentsColumns = typeof MessagesSelectColumnMessagesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof MessagesSelectColumnMessagesAggregateBoolExpBoolAndArgumentsColumns];
/** select "messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "messages" */
export const MessagesSelectColumnMessagesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Transactional: 'transactional'
} as const;

export type MessagesSelectColumnMessagesAggregateBoolExpBoolOrArgumentsColumns = typeof MessagesSelectColumnMessagesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof MessagesSelectColumnMessagesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "messages" */
export type MessagesSetInput = {
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  channel_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  draft_metadata_version?: InputMaybe<Scalars['Int']>;
  draft_version?: InputMaybe<Scalars['Int']>;
  measurement_config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  published_metadata_version?: InputMaybe<Scalars['Int']>;
  published_version?: InputMaybe<Scalars['Int']>;
  push_config_id?: InputMaybe<Scalars['uuid']>;
  send_config?: InputMaybe<Scalars['jsonb']>;
  send_gates?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_config?: InputMaybe<Scalars['jsonb']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type MessagesStddevFields = {
  __typename?: 'messages_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "messages" */
export type MessagesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type MessagesStddevPopFields = {
  __typename?: 'messages_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "messages" */
export type MessagesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type MessagesStddevSampFields = {
  __typename?: 'messages_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "messages" */
export type MessagesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "messages" */
export type MessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagesStreamCursorValueInput = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  cep_brand_id?: InputMaybe<Scalars['uuid']>;
  cep_device_preview_id?: InputMaybe<Scalars['uuid']>;
  cep_sender_identity_id?: InputMaybe<Scalars['uuid']>;
  cep_subscription_topic_id?: InputMaybe<Scalars['uuid']>;
  channel_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  draft_metadata_version?: InputMaybe<Scalars['Int']>;
  draft_version?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  measurement_config?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  published_metadata_version?: InputMaybe<Scalars['Int']>;
  published_version?: InputMaybe<Scalars['Int']>;
  push_config_id?: InputMaybe<Scalars['uuid']>;
  send_config?: InputMaybe<Scalars['jsonb']>;
  send_gates?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  targeting_config?: InputMaybe<Scalars['jsonb']>;
  transactional?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessagesSumFields = {
  __typename?: 'messages_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  draft_metadata_version?: Maybe<Scalars['Int']>;
  draft_version?: Maybe<Scalars['Int']>;
  published_metadata_version?: Maybe<Scalars['Int']>;
  published_version?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "messages" */
export type MessagesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "messages" */
export const MessagesUpdateColumn = {
  /** column name */
  CepBrandId: 'cep_brand_id',
  /** column name */
  CepSenderIdentityId: 'cep_sender_identity_id',
  /** column name */
  CepSubscriptionTopicId: 'cep_subscription_topic_id',
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  Description: 'description',
  /** column name */
  DraftMetadataVersion: 'draft_metadata_version',
  /** column name */
  DraftVersion: 'draft_version',
  /** column name */
  MeasurementConfig: 'measurement_config',
  /** column name */
  Name: 'name',
  /** column name */
  PublishedMetadataVersion: 'published_metadata_version',
  /** column name */
  PublishedVersion: 'published_version',
  /** column name */
  PushConfigId: 'push_config_id',
  /** column name */
  SendConfig: 'send_config',
  /** column name */
  SendGates: 'send_gates',
  /** column name */
  Tags: 'tags',
  /** column name */
  TargetingConfig: 'targeting_config',
  /** column name */
  Transactional: 'transactional'
} as const;

export type MessagesUpdateColumn = typeof MessagesUpdateColumn[keyof typeof MessagesUpdateColumn];
export type MessagesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MessagesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MessagesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MessagesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MessagesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MessagesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MessagesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagesSetInput>;
  /** filter the rows which have to be updated */
  where: MessagesBoolExp;
};

/** aggregate var_pop on columns */
export type MessagesVarPopFields = {
  __typename?: 'messages_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "messages" */
export type MessagesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type MessagesVarSampFields = {
  __typename?: 'messages_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "messages" */
export type MessagesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MessagesVarianceFields = {
  __typename?: 'messages_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  draft_metadata_version?: Maybe<Scalars['Float']>;
  draft_version?: Maybe<Scalars['Float']>;
  published_metadata_version?: Maybe<Scalars['Float']>;
  published_version?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "messages" */
export type MessagesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  draft_metadata_version?: InputMaybe<OrderBy>;
  draft_version?: InputMaybe<OrderBy>;
  published_metadata_version?: InputMaybe<OrderBy>;
  published_version?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "model_column_references" */
export type ModelColumnReferences = {
  __typename?: 'model_column_references';
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  model_column: ModelColumns;
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  resource_id: Scalars['String'];
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "model_column_references" */
export type ModelColumnReferencesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "model_column_references" */
export type ModelColumnReferencesAggregate = {
  __typename?: 'model_column_references_aggregate';
  aggregate?: Maybe<ModelColumnReferencesAggregateFields>;
  nodes: Array<ModelColumnReferences>;
};

/** aggregate fields of "model_column_references" */
export type ModelColumnReferencesAggregateFields = {
  __typename?: 'model_column_references_aggregate_fields';
  avg?: Maybe<ModelColumnReferencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ModelColumnReferencesMaxFields>;
  min?: Maybe<ModelColumnReferencesMinFields>;
  stddev?: Maybe<ModelColumnReferencesStddevFields>;
  stddev_pop?: Maybe<ModelColumnReferencesStddevPopFields>;
  stddev_samp?: Maybe<ModelColumnReferencesStddevSampFields>;
  sum?: Maybe<ModelColumnReferencesSumFields>;
  var_pop?: Maybe<ModelColumnReferencesVarPopFields>;
  var_samp?: Maybe<ModelColumnReferencesVarSampFields>;
  variance?: Maybe<ModelColumnReferencesVarianceFields>;
};


/** aggregate fields of "model_column_references" */
export type ModelColumnReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ModelColumnReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ModelColumnReferencesAvgFields = {
  __typename?: 'model_column_references_avg_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "model_column_references". All fields are combined with a logical 'AND'. */
export type ModelColumnReferencesBoolExp = {
  _and?: InputMaybe<Array<ModelColumnReferencesBoolExp>>;
  _not?: InputMaybe<ModelColumnReferencesBoolExp>;
  _or?: InputMaybe<Array<ModelColumnReferencesBoolExp>>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  model_column?: InputMaybe<ModelColumnsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_id_bigint?: InputMaybe<BigintComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ModelColumnReferencesMaxFields = {
  __typename?: 'model_column_references_max_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ModelColumnReferencesMinFields = {
  __typename?: 'model_column_references_min_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "model_column_references". */
export type ModelColumnReferencesOrderBy = {
  metadata?: InputMaybe<OrderBy>;
  model_column?: InputMaybe<ModelColumnsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_id_bigint?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "model_column_references_segments" */
export type ModelColumnReferencesSegments = {
  __typename?: 'model_column_references_segments';
  /** An object relationship */
  audience?: Maybe<Segments>;
  metadata?: Maybe<Scalars['jsonb']>;
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "model_column_references_segments" */
export type ModelColumnReferencesSegmentsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "model_column_references_segments" */
export type ModelColumnReferencesSegmentsAggregate = {
  __typename?: 'model_column_references_segments_aggregate';
  aggregate?: Maybe<ModelColumnReferencesSegmentsAggregateFields>;
  nodes: Array<ModelColumnReferencesSegments>;
};

export type ModelColumnReferencesSegmentsAggregateBoolExp = {
  count?: InputMaybe<ModelColumnReferencesSegmentsAggregateBoolExpCount>;
};

export type ModelColumnReferencesSegmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "model_column_references_segments" */
export type ModelColumnReferencesSegmentsAggregateFields = {
  __typename?: 'model_column_references_segments_aggregate_fields';
  avg?: Maybe<ModelColumnReferencesSegmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ModelColumnReferencesSegmentsMaxFields>;
  min?: Maybe<ModelColumnReferencesSegmentsMinFields>;
  stddev?: Maybe<ModelColumnReferencesSegmentsStddevFields>;
  stddev_pop?: Maybe<ModelColumnReferencesSegmentsStddevPopFields>;
  stddev_samp?: Maybe<ModelColumnReferencesSegmentsStddevSampFields>;
  sum?: Maybe<ModelColumnReferencesSegmentsSumFields>;
  var_pop?: Maybe<ModelColumnReferencesSegmentsVarPopFields>;
  var_samp?: Maybe<ModelColumnReferencesSegmentsVarSampFields>;
  variance?: Maybe<ModelColumnReferencesSegmentsVarianceFields>;
};


/** aggregate fields of "model_column_references_segments" */
export type ModelColumnReferencesSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsAggregateOrderBy = {
  avg?: InputMaybe<ModelColumnReferencesSegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ModelColumnReferencesSegmentsMaxOrderBy>;
  min?: InputMaybe<ModelColumnReferencesSegmentsMinOrderBy>;
  stddev?: InputMaybe<ModelColumnReferencesSegmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ModelColumnReferencesSegmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ModelColumnReferencesSegmentsStddevSampOrderBy>;
  sum?: InputMaybe<ModelColumnReferencesSegmentsSumOrderBy>;
  var_pop?: InputMaybe<ModelColumnReferencesSegmentsVarPopOrderBy>;
  var_samp?: InputMaybe<ModelColumnReferencesSegmentsVarSampOrderBy>;
  variance?: InputMaybe<ModelColumnReferencesSegmentsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ModelColumnReferencesSegmentsAvgFields = {
  __typename?: 'model_column_references_segments_avg_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "model_column_references_segments". All fields are combined with a logical 'AND'. */
export type ModelColumnReferencesSegmentsBoolExp = {
  _and?: InputMaybe<Array<ModelColumnReferencesSegmentsBoolExp>>;
  _not?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
  _or?: InputMaybe<Array<ModelColumnReferencesSegmentsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  resource_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ModelColumnReferencesSegmentsMaxFields = {
  __typename?: 'model_column_references_segments_max_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsMaxOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ModelColumnReferencesSegmentsMinFields = {
  __typename?: 'model_column_references_segments_min_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsMinOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "model_column_references_segments". */
export type ModelColumnReferencesSegmentsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  metadata?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "model_column_references_segments" */
export const ModelColumnReferencesSegmentsSelectColumn = {
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Name: 'name',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ModelColumnReferencesSegmentsSelectColumn = typeof ModelColumnReferencesSegmentsSelectColumn[keyof typeof ModelColumnReferencesSegmentsSelectColumn];
/** aggregate stddev on columns */
export type ModelColumnReferencesSegmentsStddevFields = {
  __typename?: 'model_column_references_segments_stddev_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ModelColumnReferencesSegmentsStddevPopFields = {
  __typename?: 'model_column_references_segments_stddev_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ModelColumnReferencesSegmentsStddevSampFields = {
  __typename?: 'model_column_references_segments_stddev_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelColumnReferencesSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelColumnReferencesSegmentsStreamCursorValueInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ModelColumnReferencesSegmentsSumFields = {
  __typename?: 'model_column_references_segments_sum_fields';
  model_id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ModelColumnReferencesSegmentsVarPopFields = {
  __typename?: 'model_column_references_segments_var_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ModelColumnReferencesSegmentsVarSampFields = {
  __typename?: 'model_column_references_segments_var_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ModelColumnReferencesSegmentsVarianceFields = {
  __typename?: 'model_column_references_segments_variance_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "model_column_references_segments" */
export type ModelColumnReferencesSegmentsVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "model_column_references" */
export const ModelColumnReferencesSelectColumn = {
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Name: 'name',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceIdBigint: 'resource_id_bigint',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ModelColumnReferencesSelectColumn = typeof ModelColumnReferencesSelectColumn[keyof typeof ModelColumnReferencesSelectColumn];
/** aggregate stddev on columns */
export type ModelColumnReferencesStddevFields = {
  __typename?: 'model_column_references_stddev_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ModelColumnReferencesStddevPopFields = {
  __typename?: 'model_column_references_stddev_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ModelColumnReferencesStddevSampFields = {
  __typename?: 'model_column_references_stddev_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "model_column_references" */
export type ModelColumnReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelColumnReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelColumnReferencesStreamCursorValueInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_id_bigint?: InputMaybe<Scalars['bigint']>;
  resource_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ModelColumnReferencesSumFields = {
  __typename?: 'model_column_references_sum_fields';
  model_id?: Maybe<Scalars['bigint']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "model_column_references_syncs" */
export type ModelColumnReferencesSyncs = {
  __typename?: 'model_column_references_syncs';
  metadata?: Maybe<Scalars['jsonb']>;
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync?: Maybe<Syncs>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "model_column_references_syncs" */
export type ModelColumnReferencesSyncsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "model_column_references_syncs" */
export type ModelColumnReferencesSyncsAggregate = {
  __typename?: 'model_column_references_syncs_aggregate';
  aggregate?: Maybe<ModelColumnReferencesSyncsAggregateFields>;
  nodes: Array<ModelColumnReferencesSyncs>;
};

/** aggregate fields of "model_column_references_syncs" */
export type ModelColumnReferencesSyncsAggregateFields = {
  __typename?: 'model_column_references_syncs_aggregate_fields';
  avg?: Maybe<ModelColumnReferencesSyncsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ModelColumnReferencesSyncsMaxFields>;
  min?: Maybe<ModelColumnReferencesSyncsMinFields>;
  stddev?: Maybe<ModelColumnReferencesSyncsStddevFields>;
  stddev_pop?: Maybe<ModelColumnReferencesSyncsStddevPopFields>;
  stddev_samp?: Maybe<ModelColumnReferencesSyncsStddevSampFields>;
  sum?: Maybe<ModelColumnReferencesSyncsSumFields>;
  var_pop?: Maybe<ModelColumnReferencesSyncsVarPopFields>;
  var_samp?: Maybe<ModelColumnReferencesSyncsVarSampFields>;
  variance?: Maybe<ModelColumnReferencesSyncsVarianceFields>;
};


/** aggregate fields of "model_column_references_syncs" */
export type ModelColumnReferencesSyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ModelColumnReferencesSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ModelColumnReferencesSyncsAvgFields = {
  __typename?: 'model_column_references_syncs_avg_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "model_column_references_syncs". All fields are combined with a logical 'AND'. */
export type ModelColumnReferencesSyncsBoolExp = {
  _and?: InputMaybe<Array<ModelColumnReferencesSyncsBoolExp>>;
  _not?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
  _or?: InputMaybe<Array<ModelColumnReferencesSyncsBoolExp>>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  resource_id?: InputMaybe<BigintComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ModelColumnReferencesSyncsMaxFields = {
  __typename?: 'model_column_references_syncs_max_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ModelColumnReferencesSyncsMinFields = {
  __typename?: 'model_column_references_syncs_min_fields';
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "model_column_references_syncs". */
export type ModelColumnReferencesSyncsOrderBy = {
  metadata?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "model_column_references_syncs" */
export const ModelColumnReferencesSyncsSelectColumn = {
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Name: 'name',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ModelColumnReferencesSyncsSelectColumn = typeof ModelColumnReferencesSyncsSelectColumn[keyof typeof ModelColumnReferencesSyncsSelectColumn];
/** aggregate stddev on columns */
export type ModelColumnReferencesSyncsStddevFields = {
  __typename?: 'model_column_references_syncs_stddev_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ModelColumnReferencesSyncsStddevPopFields = {
  __typename?: 'model_column_references_syncs_stddev_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ModelColumnReferencesSyncsStddevSampFields = {
  __typename?: 'model_column_references_syncs_stddev_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "model_column_references_syncs" */
export type ModelColumnReferencesSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelColumnReferencesSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelColumnReferencesSyncsStreamCursorValueInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ModelColumnReferencesSyncsSumFields = {
  __typename?: 'model_column_references_syncs_sum_fields';
  model_id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ModelColumnReferencesSyncsVarPopFields = {
  __typename?: 'model_column_references_syncs_var_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ModelColumnReferencesSyncsVarSampFields = {
  __typename?: 'model_column_references_syncs_var_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ModelColumnReferencesSyncsVarianceFields = {
  __typename?: 'model_column_references_syncs_variance_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type ModelColumnReferencesVarPopFields = {
  __typename?: 'model_column_references_var_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ModelColumnReferencesVarSampFields = {
  __typename?: 'model_column_references_var_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ModelColumnReferencesVarianceFields = {
  __typename?: 'model_column_references_variance_fields';
  model_id?: Maybe<Scalars['Float']>;
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "model_columns" */
export type ModelColumns = {
  __typename?: 'model_columns';
  alias?: Maybe<Scalars['String']>;
  case_sensitive?: Maybe<Scalars['Boolean']>;
  custom_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disable: Scalars['Boolean'];
  disable_preview: Scalars['Boolean'];
  last_attempted_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  last_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  model?: Maybe<Segments>;
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  pii_category?: Maybe<Scalars['String']>;
  privacy_level?: Maybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: Maybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: Maybe<Scalars['String']>;
  semantic_type?: Maybe<Scalars['String']>;
  top_k_enabled?: Maybe<Scalars['Boolean']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_space_scoped: Scalars['Boolean'];
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  trigger_top_k_sync?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};


/** columns and relationships of "model_columns" */
export type ModelColumnsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "model_columns" */
export type ModelColumnsAggregate = {
  __typename?: 'model_columns_aggregate';
  aggregate?: Maybe<ModelColumnsAggregateFields>;
  nodes: Array<ModelColumns>;
};

export type ModelColumnsAggregateBoolExp = {
  bool_and?: InputMaybe<ModelColumnsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ModelColumnsAggregateBoolExpBoolOr>;
  count?: InputMaybe<ModelColumnsAggregateBoolExpCount>;
};

export type ModelColumnsAggregateBoolExpBoolAnd = {
  arguments: ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ModelColumnsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ModelColumnsAggregateBoolExpBoolOr = {
  arguments: ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ModelColumnsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ModelColumnsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ModelColumnsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "model_columns" */
export type ModelColumnsAggregateFields = {
  __typename?: 'model_columns_aggregate_fields';
  avg?: Maybe<ModelColumnsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ModelColumnsMaxFields>;
  min?: Maybe<ModelColumnsMinFields>;
  stddev?: Maybe<ModelColumnsStddevFields>;
  stddev_pop?: Maybe<ModelColumnsStddevPopFields>;
  stddev_samp?: Maybe<ModelColumnsStddevSampFields>;
  sum?: Maybe<ModelColumnsSumFields>;
  var_pop?: Maybe<ModelColumnsVarPopFields>;
  var_samp?: Maybe<ModelColumnsVarSampFields>;
  variance?: Maybe<ModelColumnsVarianceFields>;
};


/** aggregate fields of "model_columns" */
export type ModelColumnsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "model_columns" */
export type ModelColumnsAggregateOrderBy = {
  avg?: InputMaybe<ModelColumnsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ModelColumnsMaxOrderBy>;
  min?: InputMaybe<ModelColumnsMinOrderBy>;
  stddev?: InputMaybe<ModelColumnsStddevOrderBy>;
  stddev_pop?: InputMaybe<ModelColumnsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ModelColumnsStddevSampOrderBy>;
  sum?: InputMaybe<ModelColumnsSumOrderBy>;
  var_pop?: InputMaybe<ModelColumnsVarPopOrderBy>;
  var_samp?: InputMaybe<ModelColumnsVarSampOrderBy>;
  variance?: InputMaybe<ModelColumnsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ModelColumnsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "model_columns" */
export type ModelColumnsArrRelInsertInput = {
  data: Array<ModelColumnsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ModelColumnsOnConflict>;
};

/** aggregate avg on columns */
export type ModelColumnsAvgFields = {
  __typename?: 'model_columns_avg_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "model_columns" */
export type ModelColumnsAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "model_columns". All fields are combined with a logical 'AND'. */
export type ModelColumnsBoolExp = {
  _and?: InputMaybe<Array<ModelColumnsBoolExp>>;
  _not?: InputMaybe<ModelColumnsBoolExp>;
  _or?: InputMaybe<Array<ModelColumnsBoolExp>>;
  alias?: InputMaybe<StringComparisonExp>;
  case_sensitive?: InputMaybe<BooleanComparisonExp>;
  custom_type?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  disable?: InputMaybe<BooleanComparisonExp>;
  disable_preview?: InputMaybe<BooleanComparisonExp>;
  last_attempted_top_k_sync_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  last_top_k_sync_timestamp?: InputMaybe<TimestamptzComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  model?: InputMaybe<SegmentsBoolExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pii_category?: InputMaybe<StringComparisonExp>;
  privacy_level?: InputMaybe<StringComparisonExp>;
  raw_type?: InputMaybe<StringComparisonExp>;
  redacted_text?: InputMaybe<StringComparisonExp>;
  semantic_type?: InputMaybe<StringComparisonExp>;
  top_k_enabled?: InputMaybe<BooleanComparisonExp>;
  top_k_error?: InputMaybe<StringComparisonExp>;
  top_k_space_scoped?: InputMaybe<BooleanComparisonExp>;
  top_k_sync_interval?: InputMaybe<IntComparisonExp>;
  trigger_top_k_sync?: InputMaybe<BooleanComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "model_columns" */
export const ModelColumnsConstraint = {
  /** unique or primary key constraint on columns "name", "model_id" */
  ModelColumnsPkey: 'model_columns_pkey'
} as const;

export type ModelColumnsConstraint = typeof ModelColumnsConstraint[keyof typeof ModelColumnsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ModelColumnsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ModelColumnsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ModelColumnsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "model_columns" */
export type ModelColumnsIncInput = {
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "model_columns" */
export type ModelColumnsInsertInput = {
  alias?: InputMaybe<Scalars['String']>;
  case_sensitive?: InputMaybe<Scalars['Boolean']>;
  custom_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disable?: InputMaybe<Scalars['Boolean']>;
  disable_preview?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  model?: InputMaybe<SegmentsObjRelInsertInput>;
  model_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: InputMaybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: InputMaybe<Scalars['String']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_space_scoped?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ModelColumnsMaxFields = {
  __typename?: 'model_columns_max_fields';
  alias?: Maybe<Scalars['String']>;
  custom_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  last_attempted_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  last_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pii_category?: Maybe<Scalars['String']>;
  privacy_level?: Maybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: Maybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: Maybe<Scalars['String']>;
  semantic_type?: Maybe<Scalars['String']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "model_columns" */
export type ModelColumnsMaxOrderBy = {
  alias?: InputMaybe<OrderBy>;
  custom_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  last_attempted_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  last_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pii_category?: InputMaybe<OrderBy>;
  privacy_level?: InputMaybe<OrderBy>;
  /** Raw type of this column from the underlying source. */
  raw_type?: InputMaybe<OrderBy>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ModelColumnsMinFields = {
  __typename?: 'model_columns_min_fields';
  alias?: Maybe<Scalars['String']>;
  custom_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  last_attempted_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  last_top_k_sync_timestamp?: Maybe<Scalars['timestamptz']>;
  model_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pii_category?: Maybe<Scalars['String']>;
  privacy_level?: Maybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: Maybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: Maybe<Scalars['String']>;
  semantic_type?: Maybe<Scalars['String']>;
  top_k_error?: Maybe<Scalars['String']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "model_columns" */
export type ModelColumnsMinOrderBy = {
  alias?: InputMaybe<OrderBy>;
  custom_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  last_attempted_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  last_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pii_category?: InputMaybe<OrderBy>;
  privacy_level?: InputMaybe<OrderBy>;
  /** Raw type of this column from the underlying source. */
  raw_type?: InputMaybe<OrderBy>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "model_columns" */
export type ModelColumnsMutationResponse = {
  __typename?: 'model_columns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ModelColumns>;
};

/** on_conflict condition type for table "model_columns" */
export type ModelColumnsOnConflict = {
  constraint: ModelColumnsConstraint;
  update_columns?: Array<ModelColumnsUpdateColumn>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};

/** Ordering options when selecting data from "model_columns". */
export type ModelColumnsOrderBy = {
  alias?: InputMaybe<OrderBy>;
  case_sensitive?: InputMaybe<OrderBy>;
  custom_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  disable?: InputMaybe<OrderBy>;
  disable_preview?: InputMaybe<OrderBy>;
  last_attempted_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  last_top_k_sync_timestamp?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  model?: InputMaybe<SegmentsOrderBy>;
  model_id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pii_category?: InputMaybe<OrderBy>;
  privacy_level?: InputMaybe<OrderBy>;
  raw_type?: InputMaybe<OrderBy>;
  redacted_text?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  top_k_enabled?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  top_k_space_scoped?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  trigger_top_k_sync?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: model_columns */
export type ModelColumnsPkColumnsInput = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ModelColumnsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "model_columns" */
export const ModelColumnsSelectColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  CaseSensitive: 'case_sensitive',
  /** column name */
  CustomType: 'custom_type',
  /** column name */
  Description: 'description',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  LastAttemptedTopKSyncTimestamp: 'last_attempted_top_k_sync_timestamp',
  /** column name */
  LastTopKSyncTimestamp: 'last_top_k_sync_timestamp',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  Name: 'name',
  /** column name */
  PiiCategory: 'pii_category',
  /** column name */
  PrivacyLevel: 'privacy_level',
  /** column name */
  RawType: 'raw_type',
  /** column name */
  RedactedText: 'redacted_text',
  /** column name */
  SemanticType: 'semantic_type',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKError: 'top_k_error',
  /** column name */
  TopKSpaceScoped: 'top_k_space_scoped',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type'
} as const;

export type ModelColumnsSelectColumn = typeof ModelColumnsSelectColumn[keyof typeof ModelColumnsSelectColumn];
/** select "model_columns_aggregate_bool_exp_bool_and_arguments_columns" columns of table "model_columns" */
export const ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  CaseSensitive: 'case_sensitive',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKSpaceScoped: 'top_k_space_scoped',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync'
} as const;

export type ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolAndArgumentsColumns = typeof ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolAndArgumentsColumns];
/** select "model_columns_aggregate_bool_exp_bool_or_arguments_columns" columns of table "model_columns" */
export const ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  CaseSensitive: 'case_sensitive',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKSpaceScoped: 'top_k_space_scoped',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync'
} as const;

export type ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolOrArgumentsColumns = typeof ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof ModelColumnsSelectColumnModelColumnsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "model_columns" */
export type ModelColumnsSetInput = {
  alias?: InputMaybe<Scalars['String']>;
  case_sensitive?: InputMaybe<Scalars['Boolean']>;
  custom_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disable?: InputMaybe<Scalars['Boolean']>;
  disable_preview?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  pii_category?: InputMaybe<Scalars['String']>;
  privacy_level?: InputMaybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: InputMaybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: InputMaybe<Scalars['String']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_error?: InputMaybe<Scalars['String']>;
  top_k_space_scoped?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ModelColumnsStddevFields = {
  __typename?: 'model_columns_stddev_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "model_columns" */
export type ModelColumnsStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ModelColumnsStddevPopFields = {
  __typename?: 'model_columns_stddev_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "model_columns" */
export type ModelColumnsStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ModelColumnsStddevSampFields = {
  __typename?: 'model_columns_stddev_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "model_columns" */
export type ModelColumnsStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "model_columns" */
export type ModelColumnsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelColumnsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelColumnsStreamCursorValueInput = {
  alias?: InputMaybe<Scalars['String']>;
  case_sensitive?: InputMaybe<Scalars['Boolean']>;
  custom_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disable?: InputMaybe<Scalars['Boolean']>;
  disable_preview?: InputMaybe<Scalars['Boolean']>;
  last_attempted_top_k_sync_timestamp?: InputMaybe<Scalars['timestamptz']>;
  last_top_k_sync_timestamp?: InputMaybe<Scalars['timestamptz']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  pii_category?: InputMaybe<Scalars['String']>;
  privacy_level?: InputMaybe<Scalars['String']>;
  /** Raw type of this column from the underlying source. */
  raw_type?: InputMaybe<Scalars['String']>;
  /** Custom text that should be shown in the audience builder for redacted columns */
  redacted_text?: InputMaybe<Scalars['String']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_error?: InputMaybe<Scalars['String']>;
  top_k_space_scoped?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ModelColumnsSumFields = {
  __typename?: 'model_columns_sum_fields';
  model_id?: Maybe<Scalars['bigint']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "model_columns" */
export type ModelColumnsSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** update columns of table "model_columns" */
export const ModelColumnsUpdateColumn = {
  /** column name */
  Alias: 'alias',
  /** column name */
  CaseSensitive: 'case_sensitive',
  /** column name */
  CustomType: 'custom_type',
  /** column name */
  Description: 'description',
  /** column name */
  Disable: 'disable',
  /** column name */
  DisablePreview: 'disable_preview',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Name: 'name',
  /** column name */
  PiiCategory: 'pii_category',
  /** column name */
  PrivacyLevel: 'privacy_level',
  /** column name */
  RawType: 'raw_type',
  /** column name */
  RedactedText: 'redacted_text',
  /** column name */
  SemanticType: 'semantic_type',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKError: 'top_k_error',
  /** column name */
  TopKSpaceScoped: 'top_k_space_scoped',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type'
} as const;

export type ModelColumnsUpdateColumn = typeof ModelColumnsUpdateColumn[keyof typeof ModelColumnsUpdateColumn];
export type ModelColumnsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ModelColumnsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ModelColumnsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ModelColumnsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ModelColumnsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ModelColumnsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ModelColumnsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ModelColumnsSetInput>;
  /** filter the rows which have to be updated */
  where: ModelColumnsBoolExp;
};

/** aggregate var_pop on columns */
export type ModelColumnsVarPopFields = {
  __typename?: 'model_columns_var_pop_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "model_columns" */
export type ModelColumnsVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ModelColumnsVarSampFields = {
  __typename?: 'model_columns_var_samp_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "model_columns" */
export type ModelColumnsVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ModelColumnsVarianceFields = {
  __typename?: 'model_columns_variance_fields';
  model_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "model_columns" */
export type ModelColumnsVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
};

/** columns and relationships of "model_relationship_references" */
export type ModelRelationshipReferences = {
  __typename?: 'model_relationship_references';
  /** An object relationship */
  model_relationship: ModelRelationships;
  model_relationship_id: Scalars['bigint'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "model_relationship_references" */
export type ModelRelationshipReferencesAggregate = {
  __typename?: 'model_relationship_references_aggregate';
  aggregate?: Maybe<ModelRelationshipReferencesAggregateFields>;
  nodes: Array<ModelRelationshipReferences>;
};

/** aggregate fields of "model_relationship_references" */
export type ModelRelationshipReferencesAggregateFields = {
  __typename?: 'model_relationship_references_aggregate_fields';
  avg?: Maybe<ModelRelationshipReferencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ModelRelationshipReferencesMaxFields>;
  min?: Maybe<ModelRelationshipReferencesMinFields>;
  stddev?: Maybe<ModelRelationshipReferencesStddevFields>;
  stddev_pop?: Maybe<ModelRelationshipReferencesStddevPopFields>;
  stddev_samp?: Maybe<ModelRelationshipReferencesStddevSampFields>;
  sum?: Maybe<ModelRelationshipReferencesSumFields>;
  var_pop?: Maybe<ModelRelationshipReferencesVarPopFields>;
  var_samp?: Maybe<ModelRelationshipReferencesVarSampFields>;
  variance?: Maybe<ModelRelationshipReferencesVarianceFields>;
};


/** aggregate fields of "model_relationship_references" */
export type ModelRelationshipReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ModelRelationshipReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ModelRelationshipReferencesAvgFields = {
  __typename?: 'model_relationship_references_avg_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "model_relationship_references". All fields are combined with a logical 'AND'. */
export type ModelRelationshipReferencesBoolExp = {
  _and?: InputMaybe<Array<ModelRelationshipReferencesBoolExp>>;
  _not?: InputMaybe<ModelRelationshipReferencesBoolExp>;
  _or?: InputMaybe<Array<ModelRelationshipReferencesBoolExp>>;
  model_relationship?: InputMaybe<ModelRelationshipsBoolExp>;
  model_relationship_id?: InputMaybe<BigintComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ModelRelationshipReferencesMaxFields = {
  __typename?: 'model_relationship_references_max_fields';
  model_relationship_id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ModelRelationshipReferencesMinFields = {
  __typename?: 'model_relationship_references_min_fields';
  model_relationship_id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['String']>;
  resource_type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "model_relationship_references". */
export type ModelRelationshipReferencesOrderBy = {
  model_relationship?: InputMaybe<ModelRelationshipsOrderBy>;
  model_relationship_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "model_relationship_references" */
export const ModelRelationshipReferencesSelectColumn = {
  /** column name */
  ModelRelationshipId: 'model_relationship_id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ModelRelationshipReferencesSelectColumn = typeof ModelRelationshipReferencesSelectColumn[keyof typeof ModelRelationshipReferencesSelectColumn];
/** aggregate stddev on columns */
export type ModelRelationshipReferencesStddevFields = {
  __typename?: 'model_relationship_references_stddev_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ModelRelationshipReferencesStddevPopFields = {
  __typename?: 'model_relationship_references_stddev_pop_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ModelRelationshipReferencesStddevSampFields = {
  __typename?: 'model_relationship_references_stddev_samp_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "model_relationship_references" */
export type ModelRelationshipReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelRelationshipReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelRelationshipReferencesStreamCursorValueInput = {
  model_relationship_id?: InputMaybe<Scalars['bigint']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ModelRelationshipReferencesSumFields = {
  __typename?: 'model_relationship_references_sum_fields';
  model_relationship_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ModelRelationshipReferencesVarPopFields = {
  __typename?: 'model_relationship_references_var_pop_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ModelRelationshipReferencesVarSampFields = {
  __typename?: 'model_relationship_references_var_samp_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ModelRelationshipReferencesVarianceFields = {
  __typename?: 'model_relationship_references_variance_fields';
  model_relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "model_relationships" */
export type ModelRelationships = {
  __typename?: 'model_relationships';
  /** This refers to the cardinality of the "to" column, which should have the values "one" or "many". For example, the relationship from users to pets will have the cardinality "many". */
  cardinality?: Maybe<Scalars['String']>;
  cardinality_detection_status?: Maybe<Scalars['String']>;
  cardinality_detection_ts?: Maybe<Scalars['timestamptz']>;
  detected_cardinality?: Maybe<Scalars['String']>;
  /** An array relationship */
  direct_relationships: Array<DirectModelRelationships>;
  /** An object relationship */
  from_model: Segments;
  from_model_id: Scalars['bigint'];
  id: Scalars['bigint'];
  is_direct_relationship: Scalars['Boolean'];
  is_hidden_from_audience_filter: Scalars['Boolean'];
  merge_columns?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** An array relationship */
  through_relationships: Array<ThroughModelRelationships>;
  /** An object relationship */
  to_model: Segments;
  to_model_id: Scalars['bigint'];
};


/** columns and relationships of "model_relationships" */
export type ModelRelationshipsDirectRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: InputMaybe<DirectModelRelationshipsBoolExp>;
};


/** columns and relationships of "model_relationships" */
export type ModelRelationshipsThroughRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: InputMaybe<ThroughModelRelationshipsBoolExp>;
};

/** order by aggregate values of table "model_relationships" */
export type ModelRelationshipsAggregateOrderBy = {
  avg?: InputMaybe<ModelRelationshipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ModelRelationshipsMaxOrderBy>;
  min?: InputMaybe<ModelRelationshipsMinOrderBy>;
  stddev?: InputMaybe<ModelRelationshipsStddevOrderBy>;
  stddev_pop?: InputMaybe<ModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ModelRelationshipsStddevSampOrderBy>;
  sum?: InputMaybe<ModelRelationshipsSumOrderBy>;
  var_pop?: InputMaybe<ModelRelationshipsVarPopOrderBy>;
  var_samp?: InputMaybe<ModelRelationshipsVarSampOrderBy>;
  variance?: InputMaybe<ModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "model_relationships" */
export type ModelRelationshipsArrRelInsertInput = {
  data: Array<ModelRelationshipsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "model_relationships" */
export type ModelRelationshipsAvgOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "model_relationships". All fields are combined with a logical 'AND'. */
export type ModelRelationshipsBoolExp = {
  _and?: InputMaybe<Array<ModelRelationshipsBoolExp>>;
  _not?: InputMaybe<ModelRelationshipsBoolExp>;
  _or?: InputMaybe<Array<ModelRelationshipsBoolExp>>;
  cardinality?: InputMaybe<StringComparisonExp>;
  cardinality_detection_status?: InputMaybe<StringComparisonExp>;
  cardinality_detection_ts?: InputMaybe<TimestamptzComparisonExp>;
  detected_cardinality?: InputMaybe<StringComparisonExp>;
  direct_relationships?: InputMaybe<DirectModelRelationshipsBoolExp>;
  from_model?: InputMaybe<SegmentsBoolExp>;
  from_model_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_direct_relationship?: InputMaybe<BooleanComparisonExp>;
  is_hidden_from_audience_filter?: InputMaybe<BooleanComparisonExp>;
  merge_columns?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  through_relationships?: InputMaybe<ThroughModelRelationshipsBoolExp>;
  to_model?: InputMaybe<SegmentsBoolExp>;
  to_model_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "model_relationships" */
export const ModelRelationshipsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ModelRelationshipsIdWorkspaceIdKey: 'model_relationships_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ModelRelationshipsPkey: 'model_relationships_pkey'
} as const;

export type ModelRelationshipsConstraint = typeof ModelRelationshipsConstraint[keyof typeof ModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "model_relationships" */
export type ModelRelationshipsIncInput = {
  from_model_id?: InputMaybe<Scalars['bigint']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "model_relationships" */
export type ModelRelationshipsInsertInput = {
  direct_relationships?: InputMaybe<DirectModelRelationshipsArrRelInsertInput>;
  from_model?: InputMaybe<SegmentsObjRelInsertInput>;
  from_model_id?: InputMaybe<Scalars['bigint']>;
  is_direct_relationship?: InputMaybe<Scalars['Boolean']>;
  merge_columns?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  through_relationships?: InputMaybe<ThroughModelRelationshipsArrRelInsertInput>;
  to_model?: InputMaybe<SegmentsObjRelInsertInput>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "model_relationships" */
export type ModelRelationshipsMaxOrderBy = {
  /** This refers to the cardinality of the "to" column, which should have the values "one" or "many". For example, the relationship from users to pets will have the cardinality "many". */
  cardinality?: InputMaybe<OrderBy>;
  cardinality_detection_status?: InputMaybe<OrderBy>;
  cardinality_detection_ts?: InputMaybe<OrderBy>;
  detected_cardinality?: InputMaybe<OrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "model_relationships" */
export type ModelRelationshipsMinOrderBy = {
  /** This refers to the cardinality of the "to" column, which should have the values "one" or "many". For example, the relationship from users to pets will have the cardinality "many". */
  cardinality?: InputMaybe<OrderBy>;
  cardinality_detection_status?: InputMaybe<OrderBy>;
  cardinality_detection_ts?: InputMaybe<OrderBy>;
  detected_cardinality?: InputMaybe<OrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "model_relationships" */
export type ModelRelationshipsMutationResponse = {
  __typename?: 'model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ModelRelationships>;
};

/** input type for inserting object relation for remote table "model_relationships" */
export type ModelRelationshipsObjRelInsertInput = {
  data: ModelRelationshipsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ModelRelationshipsOnConflict>;
};

/** on_conflict condition type for table "model_relationships" */
export type ModelRelationshipsOnConflict = {
  constraint: ModelRelationshipsConstraint;
  update_columns?: Array<ModelRelationshipsUpdateColumn>;
  where?: InputMaybe<ModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "model_relationships". */
export type ModelRelationshipsOrderBy = {
  cardinality?: InputMaybe<OrderBy>;
  cardinality_detection_status?: InputMaybe<OrderBy>;
  cardinality_detection_ts?: InputMaybe<OrderBy>;
  detected_cardinality?: InputMaybe<OrderBy>;
  direct_relationships_aggregate?: InputMaybe<DirectModelRelationshipsAggregateOrderBy>;
  from_model?: InputMaybe<SegmentsOrderBy>;
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_direct_relationship?: InputMaybe<OrderBy>;
  is_hidden_from_audience_filter?: InputMaybe<OrderBy>;
  merge_columns?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  through_relationships_aggregate?: InputMaybe<ThroughModelRelationshipsAggregateOrderBy>;
  to_model?: InputMaybe<SegmentsOrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: model_relationships */
export type ModelRelationshipsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "model_relationships" */
export const ModelRelationshipsSelectColumn = {
  /** column name */
  Cardinality: 'cardinality',
  /** column name */
  CardinalityDetectionStatus: 'cardinality_detection_status',
  /** column name */
  CardinalityDetectionTs: 'cardinality_detection_ts',
  /** column name */
  DetectedCardinality: 'detected_cardinality',
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  Id: 'id',
  /** column name */
  IsDirectRelationship: 'is_direct_relationship',
  /** column name */
  IsHiddenFromAudienceFilter: 'is_hidden_from_audience_filter',
  /** column name */
  MergeColumns: 'merge_columns',
  /** column name */
  Name: 'name',
  /** column name */
  Slug: 'slug',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type ModelRelationshipsSelectColumn = typeof ModelRelationshipsSelectColumn[keyof typeof ModelRelationshipsSelectColumn];
/** input type for updating data in table "model_relationships" */
export type ModelRelationshipsSetInput = {
  from_model_id?: InputMaybe<Scalars['bigint']>;
  merge_columns?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "model_relationships" */
export type ModelRelationshipsStddevOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "model_relationships" */
export type ModelRelationshipsStddevPopOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "model_relationships" */
export type ModelRelationshipsStddevSampOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "model_relationships" */
export type ModelRelationshipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ModelRelationshipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ModelRelationshipsStreamCursorValueInput = {
  /** This refers to the cardinality of the "to" column, which should have the values "one" or "many". For example, the relationship from users to pets will have the cardinality "many". */
  cardinality?: InputMaybe<Scalars['String']>;
  cardinality_detection_status?: InputMaybe<Scalars['String']>;
  cardinality_detection_ts?: InputMaybe<Scalars['timestamptz']>;
  detected_cardinality?: InputMaybe<Scalars['String']>;
  from_model_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_direct_relationship?: InputMaybe<Scalars['Boolean']>;
  is_hidden_from_audience_filter?: InputMaybe<Scalars['Boolean']>;
  merge_columns?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  to_model_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "model_relationships" */
export type ModelRelationshipsSumOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** update columns of table "model_relationships" */
export const ModelRelationshipsUpdateColumn = {
  /** column name */
  FromModelId: 'from_model_id',
  /** column name */
  MergeColumns: 'merge_columns',
  /** column name */
  Name: 'name',
  /** column name */
  ToModelId: 'to_model_id'
} as const;

export type ModelRelationshipsUpdateColumn = typeof ModelRelationshipsUpdateColumn[keyof typeof ModelRelationshipsUpdateColumn];
export type ModelRelationshipsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ModelRelationshipsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ModelRelationshipsSetInput>;
  /** filter the rows which have to be updated */
  where: ModelRelationshipsBoolExp;
};

/** order by var_pop() on columns of table "model_relationships" */
export type ModelRelationshipsVarPopOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "model_relationships" */
export type ModelRelationshipsVarSampOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "model_relationships" */
export type ModelRelationshipsVarianceOrderBy = {
  from_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  to_model_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "monitor_condition_statuses" */
export type MonitorConditionStatuses = {
  __typename?: 'monitor_condition_statuses';
  condition_id?: Maybe<Scalars['uuid']>;
  condition_template_id?: Maybe<Scalars['uuid']>;
  evaluated_at: Scalars['timestamptz'];
  event_time: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  monitor_condition_template?: Maybe<MonitorConditionTemplates>;
  resource_id: Scalars['String'];
  /** An object relationship */
  resource_monitor_condition?: Maybe<ResourceMonitorConditions>;
  resource_type: Scalars['String'];
  state?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
};


/** columns and relationships of "monitor_condition_statuses" */
export type MonitorConditionStatusesStateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "monitor_condition_statuses" */
export type MonitorConditionStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MonitorConditionStatusesMaxOrderBy>;
  min?: InputMaybe<MonitorConditionStatusesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "monitor_condition_statuses". All fields are combined with a logical 'AND'. */
export type MonitorConditionStatusesBoolExp = {
  _and?: InputMaybe<Array<MonitorConditionStatusesBoolExp>>;
  _not?: InputMaybe<MonitorConditionStatusesBoolExp>;
  _or?: InputMaybe<Array<MonitorConditionStatusesBoolExp>>;
  condition_id?: InputMaybe<UuidComparisonExp>;
  condition_template_id?: InputMaybe<UuidComparisonExp>;
  evaluated_at?: InputMaybe<TimestamptzComparisonExp>;
  event_time?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  monitor_condition_template?: InputMaybe<MonitorConditionTemplatesBoolExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_monitor_condition?: InputMaybe<ResourceMonitorConditionsBoolExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** order by max() on columns of table "monitor_condition_statuses" */
export type MonitorConditionStatusesMaxOrderBy = {
  condition_id?: InputMaybe<OrderBy>;
  condition_template_id?: InputMaybe<OrderBy>;
  evaluated_at?: InputMaybe<OrderBy>;
  event_time?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "monitor_condition_statuses" */
export type MonitorConditionStatusesMinOrderBy = {
  condition_id?: InputMaybe<OrderBy>;
  condition_template_id?: InputMaybe<OrderBy>;
  evaluated_at?: InputMaybe<OrderBy>;
  event_time?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "monitor_condition_statuses". */
export type MonitorConditionStatusesOrderBy = {
  condition_id?: InputMaybe<OrderBy>;
  condition_template_id?: InputMaybe<OrderBy>;
  evaluated_at?: InputMaybe<OrderBy>;
  event_time?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  monitor_condition_template?: InputMaybe<MonitorConditionTemplatesOrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_monitor_condition?: InputMaybe<ResourceMonitorConditionsOrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** select columns of table "monitor_condition_statuses" */
export const MonitorConditionStatusesSelectColumn = {
  /** column name */
  ConditionId: 'condition_id',
  /** column name */
  ConditionTemplateId: 'condition_template_id',
  /** column name */
  EvaluatedAt: 'evaluated_at',
  /** column name */
  EventTime: 'event_time',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  State: 'state',
  /** column name */
  Status: 'status'
} as const;

export type MonitorConditionStatusesSelectColumn = typeof MonitorConditionStatusesSelectColumn[keyof typeof MonitorConditionStatusesSelectColumn];
/** Streaming cursor of the table "monitor_condition_statuses" */
export type MonitorConditionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MonitorConditionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MonitorConditionStatusesStreamCursorValueInput = {
  condition_id?: InputMaybe<Scalars['uuid']>;
  condition_template_id?: InputMaybe<Scalars['uuid']>;
  evaluated_at?: InputMaybe<Scalars['timestamptz']>;
  event_time?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "monitor_condition_templates" */
export type MonitorConditionTemplates = {
  __typename?: 'monitor_condition_templates';
  enabled: Scalars['Boolean'];
  error_value?: Maybe<Scalars['jsonb']>;
  evaluation_trigger: Scalars['String'];
  evaluation_type: Scalars['String'];
  id: Scalars['uuid'];
  parent_resource_id: Scalars['String'];
  parent_resource_type: Scalars['String'];
  type: Scalars['String'];
  warning_value?: Maybe<Scalars['jsonb']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "monitor_condition_templates" */
export type MonitorConditionTemplatesErrorValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "monitor_condition_templates" */
export type MonitorConditionTemplatesWarningValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MonitorConditionTemplatesAppendInput = {
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "monitor_condition_templates". All fields are combined with a logical 'AND'. */
export type MonitorConditionTemplatesBoolExp = {
  _and?: InputMaybe<Array<MonitorConditionTemplatesBoolExp>>;
  _not?: InputMaybe<MonitorConditionTemplatesBoolExp>;
  _or?: InputMaybe<Array<MonitorConditionTemplatesBoolExp>>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error_value?: InputMaybe<JsonbComparisonExp>;
  evaluation_trigger?: InputMaybe<StringComparisonExp>;
  evaluation_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  parent_resource_id?: InputMaybe<StringComparisonExp>;
  parent_resource_type?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  warning_value?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "monitor_condition_templates" */
export const MonitorConditionTemplatesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  MonitorConditionTemplatesIdWorkspaceIdKey: 'monitor_condition_templates_id_workspace_id_key',
  /** unique or primary key constraint on columns "type", "parent_resource_type", "parent_resource_id" */
  MonitorConditionTemplatesParentResourceIdParentResource: 'monitor_condition_templates_parent_resource_id_parent_resource_',
  /** unique or primary key constraint on columns "id" */
  MonitorConditionTemplatesPkey: 'monitor_condition_templates_pkey'
} as const;

export type MonitorConditionTemplatesConstraint = typeof MonitorConditionTemplatesConstraint[keyof typeof MonitorConditionTemplatesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MonitorConditionTemplatesDeleteAtPathInput = {
  error_value?: InputMaybe<Array<Scalars['String']>>;
  warning_value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MonitorConditionTemplatesDeleteElemInput = {
  error_value?: InputMaybe<Scalars['Int']>;
  warning_value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MonitorConditionTemplatesDeleteKeyInput = {
  error_value?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "monitor_condition_templates" */
export type MonitorConditionTemplatesInsertInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  evaluation_trigger?: InputMaybe<Scalars['String']>;
  evaluation_type?: InputMaybe<Scalars['String']>;
  parent_resource_id?: InputMaybe<Scalars['String']>;
  parent_resource_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "monitor_condition_templates" */
export type MonitorConditionTemplatesMutationResponse = {
  __typename?: 'monitor_condition_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MonitorConditionTemplates>;
};

/** on_conflict condition type for table "monitor_condition_templates" */
export type MonitorConditionTemplatesOnConflict = {
  constraint: MonitorConditionTemplatesConstraint;
  update_columns?: Array<MonitorConditionTemplatesUpdateColumn>;
  where?: InputMaybe<MonitorConditionTemplatesBoolExp>;
};

/** Ordering options when selecting data from "monitor_condition_templates". */
export type MonitorConditionTemplatesOrderBy = {
  enabled?: InputMaybe<OrderBy>;
  error_value?: InputMaybe<OrderBy>;
  evaluation_trigger?: InputMaybe<OrderBy>;
  evaluation_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_resource_id?: InputMaybe<OrderBy>;
  parent_resource_type?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  warning_value?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: monitor_condition_templates */
export type MonitorConditionTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MonitorConditionTemplatesPrependInput = {
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "monitor_condition_templates" */
export const MonitorConditionTemplatesSelectColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  ErrorValue: 'error_value',
  /** column name */
  EvaluationTrigger: 'evaluation_trigger',
  /** column name */
  EvaluationType: 'evaluation_type',
  /** column name */
  Id: 'id',
  /** column name */
  ParentResourceId: 'parent_resource_id',
  /** column name */
  ParentResourceType: 'parent_resource_type',
  /** column name */
  Type: 'type',
  /** column name */
  WarningValue: 'warning_value',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type MonitorConditionTemplatesSelectColumn = typeof MonitorConditionTemplatesSelectColumn[keyof typeof MonitorConditionTemplatesSelectColumn];
/** input type for updating data in table "monitor_condition_templates" */
export type MonitorConditionTemplatesSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "monitor_condition_templates" */
export type MonitorConditionTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: MonitorConditionTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MonitorConditionTemplatesStreamCursorValueInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  evaluation_trigger?: InputMaybe<Scalars['String']>;
  evaluation_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_resource_id?: InputMaybe<Scalars['String']>;
  parent_resource_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "monitor_condition_templates" */
export const MonitorConditionTemplatesUpdateColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  ErrorValue: 'error_value',
  /** column name */
  WarningValue: 'warning_value'
} as const;

export type MonitorConditionTemplatesUpdateColumn = typeof MonitorConditionTemplatesUpdateColumn[keyof typeof MonitorConditionTemplatesUpdateColumn];
export type MonitorConditionTemplatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MonitorConditionTemplatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MonitorConditionTemplatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MonitorConditionTemplatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MonitorConditionTemplatesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MonitorConditionTemplatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MonitorConditionTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: MonitorConditionTemplatesBoolExp;
};

/** mutation root */
export type Mutation = {
  __typename?: 'mutation';
  /**
   * Records Native Delivery terms-of-service acceptance for the current
   * workspace. First acceptance wins; subsequent calls return the existing record.
   */
  acceptCepTos: AcceptCepTosResult;
  acceptLiquidV10Incompatibility?: Maybe<Scalars['Boolean']>;
  /**
   * Activate the current Iterable campaign for a dynamic content deployment
   * after its delivery settings have been reviewed.
   */
  activateContentEmailDynamicContentCampaign: ActivateContentEmailDynamicContentCampaignResponse;
  addAdExportChannelSize: AdExportChannelMutationResponse;
  addAmpCanvasNode: AmpCanvasNode;
  /**
   * Gives a project without a task board one, on the workflow named or the
   * workspace default. A project keeps its workflow once it has one.
   */
  addAmpProjectTaskBoard: AmpMutationResult;
  /**
   * The blocker can be a task on another project. A blocker that would close
   * a loop is refused.
   */
  addAmpTaskBlocker: AmpMutationResult;
  /**
   * Pass exactly one of userId or userGroupId. A required group takes a
   * memberRule, and nothing else does. A reviewer who is also one of the
   * status's defaults is held to the stricter of the two.
   */
  addAmpTaskReviewer: AmpMutationResult;
  addAsanaTaskComment: AsanaComment;
  /**
   * Adds parent models to the workspace's Native Delivery setup. The first call
   * also sets the source and the mode, which cannot change afterwards.
   */
  addCepParentModels: AddCepParentModelsResult;
  addCompetitorAccounts: Competitor;
  addExistingAmpCanvasNode: AmpCanvasNode;
  /**
   * Adds an agent to a group. The agent's parent model must read from the
   * group's source. A parent model whose primary key column differs from the
   * group's needs confirmDifferentPrimaryKey, which asserts that both columns
   * hold the same user identifier.
   */
  addFlowToDecisionEngineArbitrationGroup: DecisionEngineArbitrationGroup;
  /** Saving an ad the board already holds leaves it unchanged. */
  addInspirationBoardAd: InspirationBoard;
  /**
   * Links every CEP brand in a workspace to exactly one brand profile, creating
   * profiles and CEP brands where either is missing. Hightouch staff admins only.
   */
  adminLinkCepBrandsToProfiles: AdminLinkCepBrandsToProfilesResult;
  adminManualRetryFragment: AdminManualRetryFragmentResult;
  adminManualRetryFragmentsForExecution: AdminManualRetryFragmentsForExecutionResult;
  adminRedriveCampaignRun: AdminRedriveCampaignRunResult;
  adminReplaceGlobalSuppressionList: AdminReplaceGlobalSuppressionListResult;
  adminRepointCepForwardingQueues: AdminRepointCepForwardingQueuesResult;
  adminResetCepUserState: AdminResetCepUserStateResult;
  adminUpdateFragments: AdminUpdateFragmentsResult;
  /** Moves the next stage to today, from the next run. Advancing to 100% ends the ramp-up. */
  advanceDecisionEngineFlowVolumeRamp: Scalars['Boolean'];
  aeoArchiveSite: AeoSiteResult;
  /** Registers a website. Does not provision research or start jobs. */
  aeoCreateSite: AeoCreateSiteResult;
  applyAgenticSettingsContextReview: AgenticSettingsContextReviewApplyResult;
  /**
   * Commit the Localize tab's staged inline edits in one batch: non-null values
   * upsert, nulls clear their cell. Pass owner, or exactly one of messageId and
   * contentBlockId. All-or-nothing: any invalid edit rejects the whole batch and
   * nothing is written. There is no draft lane, so an applied edit is live on the
   * next send.
   */
  applyCepTranslationEdits: CepTranslationEditsResult;
  applyCopyReferencesReview: AgenticSettingsContextReviewApplyResult;
  applyEspUserFieldsImport: ApplyEspUserFieldsImportResult;
  applyIdrChangePlan: ApplyIdrChangePlanResponse;
  applyVariantSuggestions: DecisionEngineResult;
  approveActionPlan: ActionPlanApproval;
  archiveCepWhatsAppTemplate: ArchiveCepWhatsAppTemplateResult;
  assignDecisionEngineChannelParent: DecisionEngineResult;
  associateStaticListToAudience: AssociateStaticListToAudienceResult;
  /** Queues the brief and the named candidates to be rendered and appended to the task. Attaching never replaces; take a file down with `deleteAsanaTaskAttachment`. */
  attachCampaignAssetsToAsanaTask: AsanaAttachAssetsResponse;
  bulkDeleteEventPlans: BulkDeleteResult;
  bulkUpsertDecisionEngineMessages: BulkUpsertDecisionEngineMessagesResult;
  bundleVideoExports: BundleVideoExportsResponse;
  cancelAnalyticsQuery: CancelAnalyticsQueryResponse;
  cancelCampaignAnalyticsDashboardQuery: CancelCampaignAnalyticsDashboardQueryResponse;
  cancelChartCardRun: ChartCardRunHandle;
  cancelDamSyncRun: Scalars['Boolean'];
  cancelDecisionEngineRun: DecisionEngineResult;
  cancelEnrichedCatalogSync: EnrichedCatalogSyncJobRef;
  cancelEnrichment: CancelEnrichmentResponse;
  cancelExtensionExport: CancelExtensionExportResult;
  cancelExtensionImport: CancelExtensionImportResult;
  cancelIdrRun: Scalars['Boolean'];
  cancelIdrTraining: Scalars['Boolean'];
  cancelLLMBackgroundJob: CancelLlmBackgroundJobResponse;
  cancelLLMChatInteraction: CancelLlmChatInteractionResponse;
  cancelPredictiveTraitsQueueJob: CancelPredictiveTraitsQueueJobResult;
  cancelPredictorRun: CancelPredictorRunResult;
  cancelPreviewQueryJob: CancelPreviewQueryJobResponse;
  cancelSyncRun: CancelSyncRunOutput;
  cancelTagsBackgroundJob: TagsJobResponse;
  cancelUpcomingRecommendations: Scalars['Boolean'];
  /** Checks the saved flow-message template only when explicitly requested. */
  checkPreviewSnippet: MessagePreviewSnippetCheckResult;
  checkPreviewTestUser: MessagePreviewTestUserCheckResult;
  cleanUpDestinationsWithSecrets: CleanUpDestinationsResponse;
  /** Deletes all content recommendation rows for a flow. Admin analytics tool. */
  clearAIDContentRecommendations: ClearAidContentRecommendationsResponse;
  clearCachedState: Scalars['Boolean'];
  /**
   * Remove the caller's rating on an insight card. Returns false when they had
   * none.
   */
  clearCampaignInsightRating: Scalars['Boolean'];
  clearConnectionRoleSettings: Scalars['Boolean'];
  /** Enqueue a group-scoped wipe of this group's de_arbitration rows */
  clearGlobalDecisioningData?: Maybe<Scalars['JSONObject']>;
  clearPredictorError: ClearPredictorErrorResult;
  cloneAgentSession: CloneAgentSessionResponse;
  cloneDecisionEngineMessage: CreateDecisionEngineMessageResult;
  cloneJourney: CloneJourneyOutput;
  compareMatchBoosterDatasets: Scalars['Boolean'];
  /** Exchanges a finished WhatsApp embedded signup for a token that createCepProvider accepts. */
  completeCepWhatsAppEmbeddedSignup: CompleteCepWhatsAppEmbeddedSignupResult;
  /**
   * Enables double opt-in on a channel: creates the campaign-less opt-in
   * message(s) and sets cep_channels.double_opt_in_* in a single transaction.
   * Fails if the channel already has double opt-in enabled (use
   * editChannelDoubleOptIn instead).
   */
  configureChannelDoubleOptIn: ConfigureChannelDoubleOptInResult;
  configureSso: Scalars['Boolean'];
  confirmAdAssetMediaUpload: ConfirmAdAssetMediaUploadResponse;
  convertEmlToHtml: ConvertEmlToHtmlResponse;
  convertSessionToReportPrompt: ConvertSessionToReportPromptResponse;
  createAdInsightsSavedView: AdInsightsSavedView;
  createAdStudioProjectSession: CreateAdStudioProjectSessionResponse;
  createAdTemplate: Array<CreateAdTemplateResponse>;
  createAgentConnector: AgentConnector;
  createAgentDefinition: AgentDefinition;
  createAgentMemories: CreateAgentMemoriesResponse;
  createAgentSession: CreateAgentSessionResponse;
  createAgenticSettingsEntity: AgenticSettingsEntity;
  createAmpAction: CreateAmpActionResult;
  /** Creates a root AMP agent in the Space of the session and sends it the first message. */
  createAmpAgent: CreateAmpAgentResponse;
  createAmpAssetSync: Scalars['ID'];
  createAmpFile: AmpFile;
  /** Omitting parentId creates the folder at the top level. */
  createAmpFileFolder: AmpFolder;
  createAmpProject: AmpProjectMutationResult;
  createAmpTask: AmpMutationResult;
  createApiKey: CreateApiKeyResult;
  /** Creates a task in Asana and links the campaign to it, replacing any existing link. */
  createAsanaTaskForCampaign?: Maybe<AsanaTaskDetail>;
  createAssetCollection: AssetCollection;
  /** Adds a reply to an existing thread. */
  createAssetComment: AssetCommentPayload;
  /**
   * Opens a thread on an asset with its first comment. Both are created in one
   * transaction.
   */
  createAssetCommentThread: AssetCommentThreadPayload;
  createAssetVersion: CreateAssetVersionResponse;
  createAudienceTemplate: CreateAudienceTemplateResponse;
  createAuditLogExport: CreateAuditLogExportResult;
  createBeefreeAccessToken: BeefreeAccessToken;
  createCalendarView: CalendarView;
  createCepChannel: CreateCepChannelResult;
  createCepCloudflareTrackingDomain: CreateCepCloudflareTrackingDomainResult;
  createCepDevicePreview: CreateCepDevicePreviewResult;
  createCepEventSync: CreateCepEventSyncResult;
  createCepProvider: CepProviderResult;
  createCepWhatsAppTemplate: CreateCepWhatsAppTemplateResult;
  createCloudCredentials: CloudCredentialsResult;
  /** Creates a competitor with its accounts, schedules its daily report, and starts scraping. */
  createCompetitor: Competitor;
  /**
   * Create a reusable component from a selected element in the email editor.
   * Creates a placeholder component row in `processing` status and queues the
   * extraction agent; the agent's canonical fragment becomes the row's first
   * real version. Returns the placeholder row's id/name immediately.
   */
  createComponentFromDocument: ImportContentEmailResponse;
  createConnectionRoleMapping: ConnectionRoleMapping;
  createContentArtifact: CreateContentArtifactResponse;
  createContentCopyVersion: CreateContentCopyVersionResponse;
  createContentEmailAndSession: CreateContentEmailAndSessionResponse;
  /**
   * Mint an UNLINKED content email from a published Native Delivery template,
   * for use as an agent reference. Hidden source — never a library item. Gated
   * by the lcmLinkedNdContent feature flag.
   */
  createContentEmailFromNdTemplate: CreateContentEmailFromNdTemplateResult;
  createContentEmailVersion: CreateContentEmailVersionResponse;
  createContentImageUploadV2: CreateContentImageUploadResponseV2;
  createDamSync: Scalars['ID'];
  createDbtCloudCredential: DbtCredential;
  createDbtSyncConfig: FrontendDbtSyncConfig;
  createDecisionEngineArbitrationGroup: DecisionEngineArbitrationGroup;
  /** Creates a Draft. */
  createDecisionEngineFlowOverridePeriod: Scalars['uuid'];
  createDecisionEngineFlowWithModel: CreateDecisionEngineFlowWithModelResult;
  createDecisionEngineMessage: CreateDecisionEngineMessageResult;
  createDestinationWithSecrets: DestinationResult;
  /**
   * Legacy compatibility mutation for master's historical DOI-topic flow.
   * Canonical DOI config now lives on cep_channels.
   */
  createDoubleOptInSubscriptionTopic: CreateDoubleOptInSubscriptionTopicResult;
  createEmailTemplateInDestination: CreateEmailTemplateResult;
  createEventComponent: EventComponentResult;
  createEventForwardingSync: EventForwardingSyncResult;
  createEventPlan: EventPlanResult;
  createEventSchemaV2: UpsertEventSchemaResult;
  createEventSource: EventSourceResult;
  createEventVolumeReport: CreateEventVolumeReportResult;
  createEventWarehouseDestination: EventWarehouseDestinationResult;
  createEventWarehouseSync: EventWarehouseSyncResult;
  createExtensionExport: ExtensionExportJob;
  createExtensionWithSecrets: CreateExtensionResult;
  createExternalContextSource: ExternalContextSource;
  /**
   * Approve a Figma plugin connect handshake: mints a workspace-scoped API
   * key acting as the approving user and deposits it for the polling plugin
   * to pick up. The key plaintext is never returned to the caller.
   */
  createFigmaPluginApiKey: CreateFigmaPluginApiKeyResult;
  createFivetranExtension: CreateFivetranExtensionResult;
  createFunction: CreateFunctionResponse;
  createFunctionResource: FunctionResourceResponse;
  createFunctionVersion: CreateFunctionVersionResponse;
  createGitSyncConfig: GitSyncConfigResult;
  createGithubCredentials: GithubCredentialResult;
  createGoldenRecord: CreateGoldenRecordResponse;
  createGoldenRecordBaseColumns: CreateGoldenRecordBaseColumnsResponse;
  createGoldenRecordColumn: CreateGoldenRecordColumnResponse;
  createGoogleServiceAccount: CreateGoogleServiceAccountResult;
  createHouseholdingModel?: Maybe<CreateHouseholdingModelResponse>;
  createIDRGraph: CreateIdrGraphResponse;
  createIDRModel: CreateIdrModelResponse;
  createIdrSequenceLinks: CreateIdrSequenceLinksResponse;
  createInAppMessageTemplate: InAppMessageTemplate;
  createInAppMessageTemplateVersion: InAppMessageTemplate;
  /**
   * Manually add an insight to an initiative goal. Hightouch employees only.
   * `type` is "insight" or "suggestion". `content` is the insight's content
   * block: `{ lead, body_markdown, actions? }`, matching the stored jsonb and
   * the insight-generation tool. Returns the new insight id.
   */
  createInitiativeInsight: Scalars['uuid'];
  createInspirationBoard: InspirationBoard;
  createJourneyFromTemplate: CreateJourneyFromTemplateOutput;
  createJourneyTrait: CreateJourneyTraitOutput;
  /**
   * Fork an existing Lifecycle Studio email (typically one already linked to
   * another message) and link the copy to this message, atomically. The source
   * email is untouched. Gated by the lcmLinkedNdContent feature flag.
   */
  createLinkedEmailFromContentEmail: CreateLinkedEmailFromContentEmailResult;
  /**
   * Bootstrap a linked LCM email draft for a Native Delivery email message from
   * a published LCM template. Gated by the lcmLinkedNdContent feature flag.
   */
  createLinkedEmailFromTemplate: CreateLinkedEmailFromTemplateResult;
  /**
   * Create the next linked draft for a message whose previous linked draft has
   * been published. Gated by the lcmLinkedNdContent feature flag.
   */
  createLinkedMessageDraft: CreateLinkedMessageDraftResult;
  createLlmInferenceBackend: LlmInferenceBackend;
  createModelConfiguration: CreateModelConfigurationResponse;
  createNormalTunnel: NormalTunnelOutput;
  createOpportunityDefinition: OpportunityDefinition;
  createOrUpdateCepManagedModels: CreateOrUpdateCepManagedModelsResult;
  createPagerdutyCredentials: Scalars['String'];
  createPredictor: CreatePredictorResult;
  createPredictorCatalogFeatureDefinition: CreatePredictorFeatureDefinitionResult;
  createPredictorFeatureDefinition: CreatePredictorFeatureDefinitionResult;
  createPriorityList?: Maybe<UpdatePriorityListResponse>;
  createProjectCampaign: CreateProjectCampaignResponse;
  createPublicFontFromFile: CreatePublicFontFromFileResponse;
  createPublicImageFromCatalogProduct: CreatePublicImageFromCatalogProductResponse;
  createPublicImageFromContentImage: CreatePublicImageFromContentImageResponse;
  createPushApp: CreatePushAppResult;
  createPushCampaignInDestination: CreateCampaignResult;
  createPushEventSync: CreatePushEventSyncResult;
  createQueuedEventFragments: CreateQueuedEventFragmentsResult;
  createRealtimeEventModel: CreatedRealtimeEventModel;
  createRelationship: Array<Scalars['String']>;
  createReportScheduleContent: ReportScheduleContentMutationResponse;
  createReverseTunnel: ReverseTunnelOutput;
  /**
   * settingsEntityId must be an agentic settings entity whose current version is
   * classified as a skill in this workspace.
   */
  createReviewAgent: ReviewAgentPayload;
  createSizeVariant: CreateSizeVariantResponse;
  createSmsCampaignInDestination: CreateCampaignResult;
  createSourceWithSecrets: SourceMutationResult;
  createStagedJourney: CreateStagedJourneyOutput;
  createStyleEntity: StyleEntity;
  /**
   * Create a "tracked audience membership" trait backed by an allowlist of
   * audiences. Writes both the trait_definitions row and the
   * tracked_audience_lists row in a single transaction.
   */
  createTrackedAudienceList: CreateTrackedAudienceListResult;
  createTraitDefinition: TraitDefinition;
  createUserImageEditNode: CreateUserImageEditNodeResult;
  createUserSvgEditNode: CreateUserSvgEditNodeResult;
  createWorkspace: CreateWorkspaceResult;
  createWorkspaceNotificationChannel?: Maybe<WorkspaceNotificationChannelResult>;
  deactivateSsoUser?: Maybe<Scalars['Boolean']>;
  deleteAdArtifact: AdAgentArtifact;
  deleteAdInsightsSavedView: Scalars['ID'];
  deleteAgentConnector: Scalars['Boolean'];
  /** Soft delete: appends a deleted version so history is kept. */
  deleteAgentDefinition: Scalars['Boolean'];
  deleteAgentFile: DeleteAgentFileResponse;
  /**
   * Soft delete: appends a deleted version, so history is kept. success is
   * false when the id is not a live memory in this workspace.
   */
  deleteAgentMemory: DeleteAgentMemoryResponse;
  deleteAgenticSettingsEntity: Scalars['Boolean'];
  deleteAllEventSchemaVersions: BulkDeleteResult;
  deleteAmpAssetSync: Scalars['Boolean'];
  /** With deleteFiles, a canvas also deletes the files on it, which removes them from any other canvases. Restoring the canvas restores them. */
  deleteAmpFile: Scalars['Boolean'];
  /** Moves the folder's subfolders and files up to its parent. With deleteFiles, deletes its files instead. */
  deleteAmpFileFolder: Scalars['Boolean'];
  deleteAmpInboxNotifications: Scalars['Int'];
  deleteAmpWorkflow: AmpMutationResult;
  /** Moves the status's tasks to the replacement, then deletes the status. */
  deleteAmpWorkflowStatus: AmpMutationResult;
  deleteAsanaTaskAttachment: Scalars['Boolean'];
  deleteAssetCollection: Scalars['Boolean'];
  /** Soft-deletes a comment. Author only. */
  deleteAssetComment: Scalars['Boolean'];
  /**
   * Soft-deletes a thread by appending a deleted status; rows are retained as
   * the audit trail.
   */
  deleteAssetCommentThread: AssetCommentThreadPayload;
  deleteAssetVersion: DeleteAssetVersionResponse;
  deleteCalendarView: Scalars['ID'];
  /**
   * Delete one batch's rows in the caller's workspace. Hightouch employees
   * only. Returns false when the batch had no rows here.
   */
  deleteCampaignInsightBatch: Scalars['Boolean'];
  deleteCepBrandLogo: DeleteCepBrandLogoResponse;
  deleteCepEventSync: DeleteCepEventSyncResult;
  /** Removes the competitor, its account links, and its report schedule. */
  deleteCompetitor: Scalars['Boolean'];
  deleteConnectionRoleMapping: Scalars['Boolean'];
  deleteContentArtifactDynamicSlot: Scalars['Boolean'];
  deleteContentEmailDynamicSlot: Scalars['Boolean'];
  deleteContentSettingsFontFile: DeleteContentSettingsFontFileOutput;
  deleteDamSync: Scalars['Boolean'];
  deleteDbtCloudCredential: DeleteDbtCloudCredentialResult;
  /** Rejected while the group still has members. */
  deleteDecisionEngineArbitrationGroup: Scalars['Boolean'];
  deleteDecisionEngineFlow: DecisionEngineResult;
  /** Only Drafts and Scheduled periods can be deleted. */
  deleteDecisionEngineFlowOverridePeriod: Scalars['Boolean'];
  deleteDecisionEngineMessage: DecisionEngineResult;
  deleteEventComponent: DeleteEventComponentResult;
  deleteEventForwardingDestination: DeleteResult;
  deleteEventForwardingSync: DeleteResult;
  deleteEventPlan: DeleteResult;
  deleteEventSchemaVersion: BulkDeleteResult;
  deleteEventSource: DeleteResult;
  deleteEventWarehouseDestination: DeleteResult;
  deleteEventWarehouseSync: DeleteResult;
  deleteExtension: DeleteExtensionResult;
  deleteExternalContextSource: Scalars['Boolean'];
  deleteFivetranAgentSync: DeleteFivetranAgentSyncResponse;
  deleteFivetranExtension: DeleteFivetranExtensionResult;
  deleteFontFile: DeleteFontFileResponse;
  deleteFunction: DeleteFunctionResponse;
  deleteFunctionResource: DeleteFunctionResourceResponse;
  deleteGoldenRecordBaseColumn: DeleteGoldenRecordBaseColumnResponse;
  deleteGoldenRecordColumn: DeleteGoldenRecordColumnResponse;
  deleteIDRGraph: DeleteIdrGraphResponse;
  deleteIDRModel: DeleteIdrModelResponse;
  deleteIdrSequenceLinks: DeleteIdrSequenceLinksResponse;
  /** Delete a stored in-app message by key (POC). */
  deleteInAppMessage: DeleteInAppMessageResult;
  /**
   * eventIds, in the order of ids, are the events the notifications showed:
   * one that has since moved to a newer event is kept.
   */
  deleteInboxNotifications: Scalars['Int'];
  /** Removes the board and its saved ads; the ads themselves stay in the library. */
  deleteInspirationBoard: Scalars['Boolean'];
  deleteJourney: DeleteJourneyOutput;
  deleteJourneyTemplate: DeleteJourneyTemplateOutput;
  deleteJourneyTrait: DeleteJourneyTraitOutput;
  deleteLLMChatSession: DeleteLlmChatSessionResponse;
  deleteLibraryImages: LibraryMutationResult;
  deleteLogoFile: DeleteLogoFileResponse;
  /**
   * Staff-only. Delete a global Hightouch-managed skill (append a deleted
   * version); visible to every workspace. Idempotent.
   */
  deleteManagedSkill: Scalars['Boolean'];
  deleteMessageAbTest: DeleteMessageAbTestResult;
  deleteMetaAd: DeleteMetaAdResponse;
  deleteModel: DeleteModelOutput;
  deleteModelColumnsV2: DeleteModelColumnsV2Response;
  deleteOpportunityDefinition: Scalars['Boolean'];
  deletePredictor: DeletePredictorResult;
  deletePredictorFeatureDefinition: DeletePredictorFeatureDefinitionResult;
  deletePriorityList?: Maybe<UpdatePriorityListResponse>;
  deletePushEventSync: DeletePushEventSyncResult;
  deleteRelationship: Array<Scalars['String']>;
  deleteResourceLink: Scalars['bigint'];
  /** Soft-deletes an agent. Comments it authored are retained and keep naming it. */
  deleteReviewAgent: Scalars['Boolean'];
  deleteSendInsightChart: DecisionEngineResult;
  deleteSigmaExtension: SigmaExtensionOrError;
  deleteSizeVariant: DeleteSizeVariantResponse;
  /**
   * Soft-deletes the given styles (writes Deleted versions). Returns the number
   * deleted.
   */
  deleteStyleEntities: Scalars['Int'];
  deleteSync: DeleteSyncOutput;
  deleteSyncIdrSchedule: DeleteSyncIdrScheduleResponse;
  deleteTraitDefinition: TraitDefinition;
  deleteTunnel?: Maybe<Scalars['Boolean']>;
  /** delete data from the table: "ad_asset_favorites" */
  delete_ad_asset_favorites?: Maybe<AdAssetFavoritesMutationResponse>;
  /** delete single row from the table: "ad_asset_favorites" */
  delete_ad_asset_favorites_by_pk?: Maybe<AdAssetFavorites>;
  /** delete data from the table: "ad_brief_asset_launch_queue" */
  delete_ad_brief_asset_launch_queue?: Maybe<AdBriefAssetLaunchQueueMutationResponse>;
  /** delete single row from the table: "ad_brief_asset_launch_queue" */
  delete_ad_brief_asset_launch_queue_by_pk?: Maybe<AdBriefAssetLaunchQueue>;
  /** delete data from the table: "ad_brief_asset_launches" */
  delete_ad_brief_asset_launches?: Maybe<AdBriefAssetLaunchesMutationResponse>;
  /** delete single row from the table: "ad_brief_asset_launches" */
  delete_ad_brief_asset_launches_by_pk?: Maybe<AdBriefAssetLaunches>;
  /** delete data from the table: "ad_brief_assets" */
  delete_ad_brief_assets?: Maybe<AdBriefAssetsMutationResponse>;
  /** delete single row from the table: "ad_brief_assets" */
  delete_ad_brief_assets_by_pk?: Maybe<AdBriefAssets>;
  /** delete data from the table: "ad_briefs" */
  delete_ad_briefs?: Maybe<AdBriefsMutationResponse>;
  /** delete single row from the table: "ad_briefs" */
  delete_ad_briefs_by_pk?: Maybe<AdBriefs>;
  /** delete data from the table: "ad_export_channel_sizes" */
  delete_ad_export_channel_sizes?: Maybe<AdExportChannelSizesMutationResponse>;
  /** delete single row from the table: "ad_export_channel_sizes" */
  delete_ad_export_channel_sizes_by_pk?: Maybe<AdExportChannelSizes>;
  /** delete data from the table: "ad_stats_models" */
  delete_ad_stats_models?: Maybe<AdStatsModelsMutationResponse>;
  /** delete single row from the table: "ad_stats_models" */
  delete_ad_stats_models_by_pk?: Maybe<AdStatsModels>;
  /** delete data from the table: "ad_studio_product_feeds" */
  delete_ad_studio_product_feeds?: Maybe<AdStudioProductFeedsMutationResponse>;
  /** delete single row from the table: "ad_studio_product_feeds" */
  delete_ad_studio_product_feeds_by_pk?: Maybe<AdStudioProductFeeds>;
  /** delete data from the table: "ad_studio_project_pins" */
  delete_ad_studio_project_pins?: Maybe<AdStudioProjectPinsMutationResponse>;
  /** delete single row from the table: "ad_studio_project_pins" */
  delete_ad_studio_project_pins_by_pk?: Maybe<AdStudioProjectPins>;
  /** delete data from the table: "ad_studio_projects" */
  delete_ad_studio_projects?: Maybe<AdStudioProjectsMutationResponse>;
  /** delete single row from the table: "ad_studio_projects" */
  delete_ad_studio_projects_by_pk?: Maybe<AdStudioProjects>;
  /** delete data from the table: "ad_studio_treatments" */
  delete_ad_studio_treatments?: Maybe<AdStudioTreatmentsMutationResponse>;
  /** delete single row from the table: "ad_studio_treatments" */
  delete_ad_studio_treatments_by_pk?: Maybe<AdStudioTreatments>;
  /** delete data from the table: "agentic_settings_entities_links" */
  delete_agentic_settings_entities_links?: Maybe<AgenticSettingsEntitiesLinksMutationResponse>;
  /** delete single row from the table: "agentic_settings_entities_links" */
  delete_agentic_settings_entities_links_by_pk?: Maybe<AgenticSettingsEntitiesLinks>;
  /** delete data from the table: "alert_instances" */
  delete_alert_instances?: Maybe<AlertInstancesMutationResponse>;
  /** delete data from the table: "alerts" */
  delete_alerts?: Maybe<AlertsMutationResponse>;
  /** delete single row from the table: "alerts" */
  delete_alerts_by_pk?: Maybe<Alerts>;
  /** delete data from the table: "amp_asset_ratings" */
  delete_amp_asset_ratings?: Maybe<AmpAssetRatingsMutationResponse>;
  /** delete single row from the table: "amp_asset_ratings" */
  delete_amp_asset_ratings_by_pk?: Maybe<AmpAssetRatings>;
  /** delete data from the table: "amp_creative_dimensions" */
  delete_amp_creative_dimensions?: Maybe<AmpCreativeDimensionsMutationResponse>;
  /** delete single row from the table: "amp_creative_dimensions" */
  delete_amp_creative_dimensions_by_pk?: Maybe<AmpCreativeDimensions>;
  /** delete data from the table: "amp_file_favorites" */
  delete_amp_file_favorites?: Maybe<AmpFileFavoritesMutationResponse>;
  /** delete single row from the table: "amp_file_favorites" */
  delete_amp_file_favorites_by_pk?: Maybe<AmpFileFavorites>;
  /** delete data from the table: "amp_followed_sources" */
  delete_amp_followed_sources?: Maybe<AmpFollowedSourcesMutationResponse>;
  /** delete single row from the table: "amp_followed_sources" */
  delete_amp_followed_sources_by_pk?: Maybe<AmpFollowedSources>;
  /** delete data from the table: "amp_followed_topics" */
  delete_amp_followed_topics?: Maybe<AmpFollowedTopicsMutationResponse>;
  /** delete single row from the table: "amp_followed_topics" */
  delete_amp_followed_topics_by_pk?: Maybe<AmpFollowedTopics>;
  /** delete data from the table: "amp_project_links" */
  delete_amp_project_links?: Maybe<AmpProjectLinksMutationResponse>;
  /** delete single row from the table: "amp_project_links" */
  delete_amp_project_links_by_pk?: Maybe<AmpProjectLinks>;
  /** delete data from the table: "amp_project_pins" */
  delete_amp_project_pins?: Maybe<AmpProjectPinsMutationResponse>;
  /** delete single row from the table: "amp_project_pins" */
  delete_amp_project_pins_by_pk?: Maybe<AmpProjectPins>;
  /** delete data from the table: "amp_project_users" */
  delete_amp_project_users?: Maybe<AmpProjectUsersMutationResponse>;
  /** delete single row from the table: "amp_project_users" */
  delete_amp_project_users_by_pk?: Maybe<AmpProjectUsers>;
  /** delete data from the table: "amp_tags" */
  delete_amp_tags?: Maybe<AmpTagsMutationResponse>;
  /** delete single row from the table: "amp_tags" */
  delete_amp_tags_by_pk?: Maybe<AmpTags>;
  /** delete data from the table: "amp_task_relations" */
  delete_amp_task_relations?: Maybe<AmpTaskRelationsMutationResponse>;
  /** delete single row from the table: "amp_task_relations" */
  delete_amp_task_relations_by_pk?: Maybe<AmpTaskRelations>;
  /** delete data from the table: "amp_task_tags" */
  delete_amp_task_tags?: Maybe<AmpTaskTagsMutationResponse>;
  /** delete single row from the table: "amp_task_tags" */
  delete_amp_task_tags_by_pk?: Maybe<AmpTaskTags>;
  /** delete data from the table: "amp_task_users" */
  delete_amp_task_users?: Maybe<AmpTaskUsersMutationResponse>;
  /** delete single row from the table: "amp_task_users" */
  delete_amp_task_users_by_pk?: Maybe<AmpTaskUsers>;
  /** delete data from the table: "amp_tasks" */
  delete_amp_tasks?: Maybe<AmpTasksMutationResponse>;
  /** delete single row from the table: "amp_tasks" */
  delete_amp_tasks_by_pk?: Maybe<AmpTasks>;
  /** delete data from the table: "amp_team_members" */
  delete_amp_team_members?: Maybe<AmpTeamMembersMutationResponse>;
  /** delete single row from the table: "amp_team_members" */
  delete_amp_team_members_by_pk?: Maybe<AmpTeamMembers>;
  /** delete data from the table: "amp_teams" */
  delete_amp_teams?: Maybe<AmpTeamsMutationResponse>;
  /** delete single row from the table: "amp_teams" */
  delete_amp_teams_by_pk?: Maybe<AmpTeams>;
  /** delete data from the table: "amp_workflow_status_reviewers" */
  delete_amp_workflow_status_reviewers?: Maybe<AmpWorkflowStatusReviewersMutationResponse>;
  /** delete single row from the table: "amp_workflow_status_reviewers" */
  delete_amp_workflow_status_reviewers_by_pk?: Maybe<AmpWorkflowStatusReviewers>;
  /** delete data from the table: "api_keys" */
  delete_api_keys?: Maybe<ApiKeysMutationResponse>;
  /** delete single row from the table: "api_keys" */
  delete_api_keys_by_pk?: Maybe<ApiKeys>;
  /** delete data from the table: "artifact_favorites" */
  delete_artifact_favorites?: Maybe<ArtifactFavoritesMutationResponse>;
  /** delete single row from the table: "artifact_favorites" */
  delete_artifact_favorites_by_pk?: Maybe<ArtifactFavorites>;
  /** delete data from the table: "artifact_review_comments" */
  delete_artifact_review_comments?: Maybe<ArtifactReviewCommentsMutationResponse>;
  /** delete single row from the table: "artifact_review_comments" */
  delete_artifact_review_comments_by_pk?: Maybe<ArtifactReviewComments>;
  /** delete data from the table: "artifact_review_statuses" */
  delete_artifact_review_statuses?: Maybe<ArtifactReviewStatusesMutationResponse>;
  /** delete single row from the table: "artifact_review_statuses" */
  delete_artifact_review_statuses_by_pk?: Maybe<ArtifactReviewStatuses>;
  /** delete data from the table: "artifact_reviewers" */
  delete_artifact_reviewers?: Maybe<ArtifactReviewersMutationResponse>;
  /** delete single row from the table: "artifact_reviewers" */
  delete_artifact_reviewers_by_pk?: Maybe<ArtifactReviewers>;
  /** delete data from the table: "artifact_reviews" */
  delete_artifact_reviews?: Maybe<ArtifactReviewsMutationResponse>;
  /** delete single row from the table: "artifact_reviews" */
  delete_artifact_reviews_by_pk?: Maybe<ArtifactReviews>;
  /** delete data from the table: "attribution_methods" */
  delete_attribution_methods?: Maybe<AttributionMethodsMutationResponse>;
  /** delete single row from the table: "attribution_methods" */
  delete_attribution_methods_by_pk?: Maybe<AttributionMethods>;
  /** delete data from the table: "attribution_methods_interactions" */
  delete_attribution_methods_interactions?: Maybe<AttributionMethodsInteractionsMutationResponse>;
  /** delete single row from the table: "attribution_methods_interactions" */
  delete_attribution_methods_interactions_by_pk?: Maybe<AttributionMethodsInteractions>;
  /** delete data from the table: "audience_goals" */
  delete_audience_goals?: Maybe<AudienceGoalsMutationResponse>;
  /** delete single row from the table: "audience_goals" */
  delete_audience_goals_by_pk?: Maybe<AudienceGoals>;
  /** delete data from the table: "audience_primary_metrics" */
  delete_audience_primary_metrics?: Maybe<AudiencePrimaryMetricsMutationResponse>;
  /** delete single row from the table: "audience_primary_metrics" */
  delete_audience_primary_metrics_by_pk?: Maybe<AudiencePrimaryMetrics>;
  /** delete data from the table: "audience_splits" */
  delete_audience_splits?: Maybe<AudienceSplitsMutationResponse>;
  /** delete single row from the table: "audience_splits" */
  delete_audience_splits_by_pk?: Maybe<AudienceSplits>;
  /** delete data from the table: "audience_subset_group_required_models" */
  delete_audience_subset_group_required_models?: Maybe<AudienceSubsetGroupRequiredModelsMutationResponse>;
  /** delete single row from the table: "audience_subset_group_required_models" */
  delete_audience_subset_group_required_models_by_pk?: Maybe<AudienceSubsetGroupRequiredModels>;
  /** delete data from the table: "audience_subset_groups" */
  delete_audience_subset_groups?: Maybe<AudienceSubsetGroupsMutationResponse>;
  /** delete single row from the table: "audience_subset_groups" */
  delete_audience_subset_groups_by_pk?: Maybe<AudienceSubsetGroups>;
  /** delete data from the table: "audience_subset_values" */
  delete_audience_subset_values?: Maybe<AudienceSubsetValuesMutationResponse>;
  /** delete single row from the table: "audience_subset_values" */
  delete_audience_subset_values_by_pk?: Maybe<AudienceSubsetValues>;
  /** delete data from the table: "audience_templates" */
  delete_audience_templates?: Maybe<AudienceTemplatesMutationResponse>;
  /** delete single row from the table: "audience_templates" */
  delete_audience_templates_by_pk?: Maybe<AudienceTemplates>;
  /** delete data from the table: "audiences_subsets" */
  delete_audiences_subsets?: Maybe<AudiencesSubsetsMutationResponse>;
  /** delete single row from the table: "audiences_subsets" */
  delete_audiences_subsets_by_pk?: Maybe<AudiencesSubsets>;
  /** delete data from the table: "campaign_artifacts" */
  delete_campaign_artifacts?: Maybe<CampaignArtifactsMutationResponse>;
  /** delete single row from the table: "campaign_artifacts" */
  delete_campaign_artifacts_by_pk?: Maybe<CampaignArtifacts>;
  /** delete data from the table: "campaign_labels" */
  delete_campaign_labels?: Maybe<CampaignLabelsMutationResponse>;
  /** delete single row from the table: "campaign_labels" */
  delete_campaign_labels_by_pk?: Maybe<CampaignLabels>;
  /** delete data from the table: "campaigns" */
  delete_campaigns?: Maybe<CampaignsMutationResponse>;
  /** delete single row from the table: "campaigns" */
  delete_campaigns_by_pk?: Maybe<Campaigns>;
  /** delete data from the table: "catalog_collections" */
  delete_catalog_collections?: Maybe<CatalogCollectionsMutationResponse>;
  /** delete single row from the table: "catalog_collections" */
  delete_catalog_collections_by_pk?: Maybe<CatalogCollections>;
  /** delete data from the table: "catalog_models" */
  delete_catalog_models?: Maybe<CatalogModelsMutationResponse>;
  /** delete single row from the table: "catalog_models" */
  delete_catalog_models_by_pk?: Maybe<CatalogModels>;
  /** delete data from the table: "cep_brand_settings" */
  delete_cep_brand_settings?: Maybe<CepBrandSettingsMutationResponse>;
  /** delete single row from the table: "cep_brand_settings" */
  delete_cep_brand_settings_by_pk?: Maybe<CepBrandSettings>;
  /** delete data from the table: "cep_channels" */
  delete_cep_channels?: Maybe<CepChannelsMutationResponse>;
  /** delete single row from the table: "cep_channels" */
  delete_cep_channels_by_pk?: Maybe<CepChannels>;
  /** delete data from the table: "cep_domains" */
  delete_cep_domains?: Maybe<CepDomainsMutationResponse>;
  /** delete single row from the table: "cep_domains" */
  delete_cep_domains_by_pk?: Maybe<CepDomains>;
  /** delete data from the table: "cep_email_template_contents" */
  delete_cep_email_template_contents?: Maybe<CepEmailTemplateContentsMutationResponse>;
  /** delete single row from the table: "cep_email_template_contents" */
  delete_cep_email_template_contents_by_pk?: Maybe<CepEmailTemplateContents>;
  /** delete data from the table: "cep_locales" */
  delete_cep_locales?: Maybe<CepLocalesMutationResponse>;
  /** delete single row from the table: "cep_locales" */
  delete_cep_locales_by_pk?: Maybe<CepLocales>;
  /** delete data from the table: "cep_localization_settings" */
  delete_cep_localization_settings?: Maybe<CepLocalizationSettingsMutationResponse>;
  /** delete single row from the table: "cep_localization_settings" */
  delete_cep_localization_settings_by_pk?: Maybe<CepLocalizationSettings>;
  /** delete data from the table: "cep_message_device_previews" */
  delete_cep_message_device_previews?: Maybe<CepMessageDevicePreviewsMutationResponse>;
  /** delete single row from the table: "cep_message_device_previews" */
  delete_cep_message_device_previews_by_pk?: Maybe<CepMessageDevicePreviews>;
  /** delete data from the table: "cep_providers" */
  delete_cep_providers?: Maybe<CepProvidersMutationResponse>;
  /** delete single row from the table: "cep_providers" */
  delete_cep_providers_by_pk?: Maybe<CepProviders>;
  /** delete data from the table: "cep_sender_identities" */
  delete_cep_sender_identities?: Maybe<CepSenderIdentitiesMutationResponse>;
  /** delete single row from the table: "cep_sender_identities" */
  delete_cep_sender_identities_by_pk?: Maybe<CepSenderIdentities>;
  /** delete data from the table: "cep_subscription_topic_sender_identities" */
  delete_cep_subscription_topic_sender_identities?: Maybe<CepSubscriptionTopicSenderIdentitiesMutationResponse>;
  /** delete single row from the table: "cep_subscription_topic_sender_identities" */
  delete_cep_subscription_topic_sender_identities_by_pk?: Maybe<CepSubscriptionTopicSenderIdentities>;
  /** delete data from the table: "cep_subscription_topics" */
  delete_cep_subscription_topics?: Maybe<CepSubscriptionTopicsMutationResponse>;
  /** delete single row from the table: "cep_subscription_topics" */
  delete_cep_subscription_topics_by_pk?: Maybe<CepSubscriptionTopics>;
  /** delete data from the table: "cep_suppression_list_subscription_topics" */
  delete_cep_suppression_list_subscription_topics?: Maybe<CepSuppressionListSubscriptionTopicsMutationResponse>;
  /** delete single row from the table: "cep_suppression_list_subscription_topics" */
  delete_cep_suppression_list_subscription_topics_by_pk?: Maybe<CepSuppressionListSubscriptionTopics>;
  /** delete data from the table: "cep_suppression_lists" */
  delete_cep_suppression_lists?: Maybe<CepSuppressionListsMutationResponse>;
  /** delete single row from the table: "cep_suppression_lists" */
  delete_cep_suppression_lists_by_pk?: Maybe<CepSuppressionLists>;
  /** delete data from the table: "cep_test_group_members" */
  delete_cep_test_group_members?: Maybe<CepTestGroupMembersMutationResponse>;
  /** delete single row from the table: "cep_test_group_members" */
  delete_cep_test_group_members_by_pk?: Maybe<CepTestGroupMembers>;
  /** delete data from the table: "cep_test_groups" */
  delete_cep_test_groups?: Maybe<CepTestGroupsMutationResponse>;
  /** delete single row from the table: "cep_test_groups" */
  delete_cep_test_groups_by_pk?: Maybe<CepTestGroups>;
  /** delete data from the table: "cep_workspace_config" */
  delete_cep_workspace_config?: Maybe<CepWorkspaceConfigMutationResponse>;
  /** delete single row from the table: "cep_workspace_config" */
  delete_cep_workspace_config_by_pk?: Maybe<CepWorkspaceConfig>;
  /** delete data from the table: "chart_cards" */
  delete_chart_cards?: Maybe<ChartCardsMutationResponse>;
  /** delete single row from the table: "chart_cards" */
  delete_chart_cards_by_pk?: Maybe<ChartCards>;
  /** delete data from the table: "cloud_credentials" */
  delete_cloud_credentials?: Maybe<CloudCredentialsMutationResponse>;
  /** delete single row from the table: "cloud_credentials" */
  delete_cloud_credentials_by_pk?: Maybe<CloudCredentials>;
  /** delete data from the table: "condition_template_labels" */
  delete_condition_template_labels?: Maybe<ConditionTemplateLabelsMutationResponse>;
  /** delete single row from the table: "condition_template_labels" */
  delete_condition_template_labels_by_pk?: Maybe<ConditionTemplateLabels>;
  /** delete data from the table: "connections" */
  delete_connections?: Maybe<ConnectionsMutationResponse>;
  /** delete single row from the table: "connections" */
  delete_connections_by_pk?: Maybe<Connections>;
  /** delete data from the table: "content_block_labels" */
  delete_content_block_labels?: Maybe<ContentBlockLabelsMutationResponse>;
  /** delete single row from the table: "content_block_labels" */
  delete_content_block_labels_by_pk?: Maybe<ContentBlockLabels>;
  /** delete data from the table: "content_blocks" */
  delete_content_blocks?: Maybe<ContentBlocksMutationResponse>;
  /** delete single row from the table: "content_blocks" */
  delete_content_blocks_by_pk?: Maybe<ContentBlocks>;
  /** delete data from the table: "content_dynamic_slot_assignments" */
  delete_content_dynamic_slot_assignments?: Maybe<ContentDynamicSlotAssignmentsMutationResponse>;
  /** delete single row from the table: "content_dynamic_slot_assignments" */
  delete_content_dynamic_slot_assignments_by_pk?: Maybe<ContentDynamicSlotAssignments>;
  /** delete data from the table: "content_dynamic_slot_branches" */
  delete_content_dynamic_slot_branches?: Maybe<ContentDynamicSlotBranchesMutationResponse>;
  /** delete single row from the table: "content_dynamic_slot_branches" */
  delete_content_dynamic_slot_branches_by_pk?: Maybe<ContentDynamicSlotBranches>;
  /** delete data from the table: "content_dynamic_slot_contents" */
  delete_content_dynamic_slot_contents?: Maybe<ContentDynamicSlotContentsMutationResponse>;
  /** delete single row from the table: "content_dynamic_slot_contents" */
  delete_content_dynamic_slot_contents_by_pk?: Maybe<ContentDynamicSlotContents>;
  /** delete data from the table: "content_dynamic_slot_libraries" */
  delete_content_dynamic_slot_libraries?: Maybe<ContentDynamicSlotLibrariesMutationResponse>;
  /** delete single row from the table: "content_dynamic_slot_libraries" */
  delete_content_dynamic_slot_libraries_by_pk?: Maybe<ContentDynamicSlotLibraries>;
  /** delete data from the table: "content_dynamic_slot_usages" */
  delete_content_dynamic_slot_usages?: Maybe<ContentDynamicSlotUsagesMutationResponse>;
  /** delete single row from the table: "content_dynamic_slot_usages" */
  delete_content_dynamic_slot_usages_by_pk?: Maybe<ContentDynamicSlotUsages>;
  /** delete data from the table: "content_email_variants" */
  delete_content_email_variants?: Maybe<ContentEmailVariantsMutationResponse>;
  /** delete single row from the table: "content_email_variants" */
  delete_content_email_variants_by_pk?: Maybe<ContentEmailVariants>;
  /** delete data from the table: "content_emails" */
  delete_content_emails?: Maybe<ContentEmailsMutationResponse>;
  /** delete single row from the table: "content_emails" */
  delete_content_emails_by_pk?: Maybe<ContentEmails>;
  /** delete data from the table: "content_settings" */
  delete_content_settings?: Maybe<ContentSettingsMutationResponse>;
  /** delete single row from the table: "content_settings" */
  delete_content_settings_by_pk?: Maybe<ContentSettings>;
  /** delete data from the table: "content_templates" */
  delete_content_templates?: Maybe<ContentTemplatesMutationResponse>;
  /** delete single row from the table: "content_templates" */
  delete_content_templates_by_pk?: Maybe<ContentTemplates>;
  /** delete data from the table: "custom_agents" */
  delete_custom_agents?: Maybe<CustomAgentsMutationResponse>;
  /** delete single row from the table: "custom_agents" */
  delete_custom_agents_by_pk?: Maybe<CustomAgents>;
  /** delete data from the table: "dashboards" */
  delete_dashboards?: Maybe<DashboardsMutationResponse>;
  /** delete single row from the table: "dashboards" */
  delete_dashboards_by_pk?: Maybe<Dashboards>;
  /** delete data from the table: "dbt_cloud_sync_config" */
  delete_dbt_cloud_sync_config?: Maybe<DbtCloudSyncConfigMutationResponse>;
  /** delete single row from the table: "dbt_cloud_sync_config" */
  delete_dbt_cloud_sync_config_by_pk?: Maybe<DbtCloudSyncConfig>;
  /** delete data from the table: "dbt_sync_config" */
  delete_dbt_sync_config?: Maybe<DbtSyncConfigMutationResponse>;
  /** delete single row from the table: "dbt_sync_config" */
  delete_dbt_sync_config_by_pk?: Maybe<DbtSyncConfig>;
  /** delete data from the table: "decision_engine_collections" */
  delete_decision_engine_collections?: Maybe<DecisionEngineCollectionsMutationResponse>;
  /** delete single row from the table: "decision_engine_collections" */
  delete_decision_engine_collections_by_pk?: Maybe<DecisionEngineCollections>;
  /** delete data from the table: "decision_engine_feature_matrices" */
  delete_decision_engine_feature_matrices?: Maybe<DecisionEngineFeatureMatricesMutationResponse>;
  /** delete single row from the table: "decision_engine_feature_matrices" */
  delete_decision_engine_feature_matrices_by_pk?: Maybe<DecisionEngineFeatureMatrices>;
  /** delete data from the table: "decision_engine_feature_matrix_relationships" */
  delete_decision_engine_feature_matrix_relationships?: Maybe<DecisionEngineFeatureMatrixRelationshipsMutationResponse>;
  /** delete single row from the table: "decision_engine_feature_matrix_relationships" */
  delete_decision_engine_feature_matrix_relationships_by_pk?: Maybe<DecisionEngineFeatureMatrixRelationships>;
  /** delete data from the table: "decision_engine_flow_experiments" */
  delete_decision_engine_flow_experiments?: Maybe<DecisionEngineFlowExperimentsMutationResponse>;
  /** delete single row from the table: "decision_engine_flow_experiments" */
  delete_decision_engine_flow_experiments_by_pk?: Maybe<DecisionEngineFlowExperiments>;
  /** delete data from the table: "decision_engine_flow_outcomes" */
  delete_decision_engine_flow_outcomes?: Maybe<DecisionEngineFlowOutcomesMutationResponse>;
  /** delete single row from the table: "decision_engine_flow_outcomes" */
  delete_decision_engine_flow_outcomes_by_pk?: Maybe<DecisionEngineFlowOutcomes>;
  /** delete data from the table: "decision_engine_flow_tags" */
  delete_decision_engine_flow_tags?: Maybe<DecisionEngineFlowTagsMutationResponse>;
  /** delete single row from the table: "decision_engine_flow_tags" */
  delete_decision_engine_flow_tags_by_pk?: Maybe<DecisionEngineFlowTags>;
  /** delete data from the table: "decision_engine_flows" */
  delete_decision_engine_flows?: Maybe<DecisionEngineFlowsMutationResponse>;
  /** delete single row from the table: "decision_engine_flows" */
  delete_decision_engine_flows_by_pk?: Maybe<DecisionEngineFlows>;
  /** delete data from the table: "decision_engine_message_collections" */
  delete_decision_engine_message_collections?: Maybe<DecisionEngineMessageCollectionsMutationResponse>;
  /** delete single row from the table: "decision_engine_message_collections" */
  delete_decision_engine_message_collections_by_pk?: Maybe<DecisionEngineMessageCollections>;
  /** delete data from the table: "decision_engine_model_outcomes" */
  delete_decision_engine_model_outcomes?: Maybe<DecisionEngineModelOutcomesMutationResponse>;
  /** delete single row from the table: "decision_engine_model_outcomes" */
  delete_decision_engine_model_outcomes_by_pk?: Maybe<DecisionEngineModelOutcomes>;
  /** delete data from the table: "decision_engine_models" */
  delete_decision_engine_models?: Maybe<DecisionEngineModelsMutationResponse>;
  /** delete single row from the table: "decision_engine_models" */
  delete_decision_engine_models_by_pk?: Maybe<DecisionEngineModels>;
  /** delete data from the table: "decision_engine_offers" */
  delete_decision_engine_offers?: Maybe<DecisionEngineOffersMutationResponse>;
  /** delete single row from the table: "decision_engine_offers" */
  delete_decision_engine_offers_by_pk?: Maybe<DecisionEngineOffers>;
  /** delete data from the table: "decision_engine_outcomes" */
  delete_decision_engine_outcomes?: Maybe<DecisionEngineOutcomesMutationResponse>;
  /** delete single row from the table: "decision_engine_outcomes" */
  delete_decision_engine_outcomes_by_pk?: Maybe<DecisionEngineOutcomes>;
  /** delete data from the table: "decision_engine_send_events" */
  delete_decision_engine_send_events?: Maybe<DecisionEngineSendEventsMutationResponse>;
  /** delete single row from the table: "decision_engine_send_events" */
  delete_decision_engine_send_events_by_pk?: Maybe<DecisionEngineSendEvents>;
  /** delete data from the table: "decision_engine_splits" */
  delete_decision_engine_splits?: Maybe<DecisionEngineSplitsMutationResponse>;
  /** delete single row from the table: "decision_engine_splits" */
  delete_decision_engine_splits_by_pk?: Maybe<DecisionEngineSplits>;
  /** delete data from the table: "decision_engines" */
  delete_decision_engines?: Maybe<DecisionEnginesMutationResponse>;
  /** delete single row from the table: "decision_engines" */
  delete_decision_engines_by_pk?: Maybe<DecisionEngines>;
  /** delete data from the table: "destination_instance_splits" */
  delete_destination_instance_splits?: Maybe<DestinationInstanceSplitsMutationResponse>;
  /** delete single row from the table: "destination_instance_splits" */
  delete_destination_instance_splits_by_pk?: Maybe<DestinationInstanceSplits>;
  /** delete data from the table: "destination_instances" */
  delete_destination_instances?: Maybe<DestinationInstancesMutationResponse>;
  /** delete single row from the table: "destination_instances" */
  delete_destination_instances_by_pk?: Maybe<DestinationInstances>;
  /** delete data from the table: "destination_rules" */
  delete_destination_rules?: Maybe<DestinationRulesMutationResponse>;
  /** delete single row from the table: "destination_rules" */
  delete_destination_rules_by_pk?: Maybe<DestinationRules>;
  /** delete data from the table: "destinations" */
  delete_destinations?: Maybe<DestinationsMutationResponse>;
  /** delete single row from the table: "destinations" */
  delete_destinations_by_pk?: Maybe<Destinations>;
  /** delete data from the table: "direct_model_relationships" */
  delete_direct_model_relationships?: Maybe<DirectModelRelationshipsMutationResponse>;
  /** delete single row from the table: "direct_model_relationships" */
  delete_direct_model_relationships_by_pk?: Maybe<DirectModelRelationships>;
  /** delete data from the table: "drafts" */
  delete_drafts?: Maybe<DraftsMutationResponse>;
  /** delete single row from the table: "drafts" */
  delete_drafts_by_pk?: Maybe<Drafts>;
  /** delete data from the table: "email_template_labels" */
  delete_email_template_labels?: Maybe<EmailTemplateLabelsMutationResponse>;
  /** delete single row from the table: "email_template_labels" */
  delete_email_template_labels_by_pk?: Maybe<EmailTemplateLabels>;
  /** delete data from the table: "esp_content_blocks" */
  delete_esp_content_blocks?: Maybe<EspContentBlocksMutationResponse>;
  /** delete single row from the table: "esp_content_blocks" */
  delete_esp_content_blocks_by_pk?: Maybe<EspContentBlocks>;
  /** delete data from the table: "esp_user_fields" */
  delete_esp_user_fields?: Maybe<EspUserFieldsMutationResponse>;
  /** delete single row from the table: "esp_user_fields" */
  delete_esp_user_fields_by_pk?: Maybe<EspUserFields>;
  /** delete data from the table: "etl_connections" */
  delete_etl_connections?: Maybe<EtlConnectionsMutationResponse>;
  /** delete single row from the table: "etl_connections" */
  delete_etl_connections_by_pk?: Maybe<EtlConnections>;
  /** delete data from the table: "event_components" */
  delete_event_components?: Maybe<EventComponentsMutationResponse>;
  /** delete single row from the table: "event_components" */
  delete_event_components_by_pk?: Maybe<EventComponents>;
  /** delete data from the table: "event_components_conditions" */
  delete_event_components_conditions?: Maybe<EventComponentsConditionsMutationResponse>;
  /** delete single row from the table: "event_components_conditions" */
  delete_event_components_conditions_by_pk?: Maybe<EventComponentsConditions>;
  /** delete data from the table: "event_components_join" */
  delete_event_components_join?: Maybe<EventComponentsJoinMutationResponse>;
  /** delete single row from the table: "event_components_join" */
  delete_event_components_join_by_pk?: Maybe<EventComponentsJoin>;
  /** delete data from the table: "event_contracts" */
  delete_event_contracts?: Maybe<EventContractsMutationResponse>;
  /** delete single row from the table: "event_contracts" */
  delete_event_contracts_by_pk?: Maybe<EventContracts>;
  /** delete data from the table: "event_contracts_schema" */
  delete_event_contracts_schema?: Maybe<EventContractsSchemaMutationResponse>;
  /** delete single row from the table: "event_contracts_schema" */
  delete_event_contracts_schema_by_pk?: Maybe<EventContractsSchema>;
  /** delete data from the table: "event_forwarding_syncs" */
  delete_event_forwarding_syncs?: Maybe<EventForwardingSyncsMutationResponse>;
  /** delete single row from the table: "event_forwarding_syncs" */
  delete_event_forwarding_syncs_by_pk?: Maybe<EventForwardingSyncs>;
  /** delete data from the table: "event_model_event_sources" */
  delete_event_model_event_sources?: Maybe<EventModelEventSourcesMutationResponse>;
  /** delete single row from the table: "event_model_event_sources" */
  delete_event_model_event_sources_by_pk?: Maybe<EventModelEventSources>;
  /** delete data from the table: "event_plans" */
  delete_event_plans?: Maybe<EventPlansMutationResponse>;
  /** delete single row from the table: "event_plans" */
  delete_event_plans_by_pk?: Maybe<EventPlans>;
  /** delete data from the table: "event_schema_components" */
  delete_event_schema_components?: Maybe<EventSchemaComponentsMutationResponse>;
  /** delete single row from the table: "event_schema_components" */
  delete_event_schema_components_by_pk?: Maybe<EventSchemaComponents>;
  /** delete data from the table: "event_schemas" */
  delete_event_schemas?: Maybe<EventSchemasMutationResponse>;
  /** delete single row from the table: "event_schemas" */
  delete_event_schemas_by_pk?: Maybe<EventSchemas>;
  /** delete data from the table: "event_source_contracts" */
  delete_event_source_contracts?: Maybe<EventSourceContractsMutationResponse>;
  /** delete single row from the table: "event_source_contracts" */
  delete_event_source_contracts_by_pk?: Maybe<EventSourceContracts>;
  /** delete data from the table: "event_sources" */
  delete_event_sources?: Maybe<EventSourcesMutationResponse>;
  /** delete single row from the table: "event_sources" */
  delete_event_sources_by_pk?: Maybe<EventSources>;
  /** delete data from the table: "event_warehouse_destinations" */
  delete_event_warehouse_destinations?: Maybe<EventWarehouseDestinationsMutationResponse>;
  /** delete single row from the table: "event_warehouse_destinations" */
  delete_event_warehouse_destinations_by_pk?: Maybe<EventWarehouseDestinations>;
  /** delete data from the table: "event_warehouse_syncs" */
  delete_event_warehouse_syncs?: Maybe<EventWarehouseSyncsMutationResponse>;
  /** delete single row from the table: "event_warehouse_syncs" */
  delete_event_warehouse_syncs_by_pk?: Maybe<EventWarehouseSyncs>;
  /** delete data from the table: "experiment_metrics" */
  delete_experiment_metrics?: Maybe<ExperimentMetricsMutationResponse>;
  /** delete single row from the table: "experiment_metrics" */
  delete_experiment_metrics_by_pk?: Maybe<ExperimentMetrics>;
  /** delete data from the table: "experiments" */
  delete_experiments?: Maybe<ExperimentsMutationResponse>;
  /** delete single row from the table: "experiments" */
  delete_experiments_by_pk?: Maybe<Experiments>;
  /** delete data from the table: "external_buckets" */
  delete_external_buckets?: Maybe<ExternalBucketsMutationResponse>;
  /** delete single row from the table: "external_buckets" */
  delete_external_buckets_by_pk?: Maybe<ExternalBuckets>;
  /** delete data from the table: "external_segments" */
  delete_external_segments?: Maybe<ExternalSegmentsMutationResponse>;
  /** delete single row from the table: "external_segments" */
  delete_external_segments_by_pk?: Maybe<ExternalSegments>;
  /** delete data from the table: "folders" */
  delete_folders?: Maybe<FoldersMutationResponse>;
  /** delete single row from the table: "folders" */
  delete_folders_by_pk?: Maybe<Folders>;
  /** delete data from the table: "function_resources" */
  delete_function_resources?: Maybe<FunctionResourcesMutationResponse>;
  /** delete single row from the table: "function_resources" */
  delete_function_resources_by_pk?: Maybe<FunctionResources>;
  /** delete data from the table: "function_settings" */
  delete_function_settings?: Maybe<FunctionSettingsMutationResponse>;
  /** delete single row from the table: "function_settings" */
  delete_function_settings_by_pk?: Maybe<FunctionSettings>;
  /** delete data from the table: "functions" */
  delete_functions?: Maybe<FunctionsMutationResponse>;
  /** delete single row from the table: "functions" */
  delete_functions_by_pk?: Maybe<Functions>;
  /** delete data from the table: "git_credentials" */
  delete_git_credentials?: Maybe<GitCredentialsMutationResponse>;
  /** delete single row from the table: "git_credentials" */
  delete_git_credentials_by_pk?: Maybe<GitCredentials>;
  /** delete data from the table: "git_sync_configs" */
  delete_git_sync_configs?: Maybe<GitSyncConfigsMutationResponse>;
  /** delete single row from the table: "git_sync_configs" */
  delete_git_sync_configs_by_pk?: Maybe<GitSyncConfigs>;
  /** delete data from the table: "goal_metrics" */
  delete_goal_metrics?: Maybe<GoalMetricsMutationResponse>;
  /** delete single row from the table: "goal_metrics" */
  delete_goal_metrics_by_pk?: Maybe<GoalMetrics>;
  /** delete data from the table: "goals" */
  delete_goals?: Maybe<GoalsMutationResponse>;
  /** delete data from the table: "goals_attribution_methods" */
  delete_goals_attribution_methods?: Maybe<GoalsAttributionMethodsMutationResponse>;
  /** delete single row from the table: "goals_attribution_methods" */
  delete_goals_attribution_methods_by_pk?: Maybe<GoalsAttributionMethods>;
  /** delete single row from the table: "goals" */
  delete_goals_by_pk?: Maybe<Goals>;
  /** delete data from the table: "initiative_goals" */
  delete_initiative_goals?: Maybe<InitiativeGoalsMutationResponse>;
  /** delete single row from the table: "initiative_goals" */
  delete_initiative_goals_by_pk?: Maybe<InitiativeGoals>;
  /** delete data from the table: "initiative_insights" */
  delete_initiative_insights?: Maybe<InitiativeInsightsMutationResponse>;
  /** delete single row from the table: "initiative_insights" */
  delete_initiative_insights_by_pk?: Maybe<InitiativeInsights>;
  /** delete data from the table: "interaction_models" */
  delete_interaction_models?: Maybe<InteractionModelsMutationResponse>;
  /** delete single row from the table: "interaction_models" */
  delete_interaction_models_by_pk?: Maybe<InteractionModels>;
  /** delete data from the table: "journey_labels" */
  delete_journey_labels?: Maybe<JourneyLabelsMutationResponse>;
  /** delete single row from the table: "journey_labels" */
  delete_journey_labels_by_pk?: Maybe<JourneyLabels>;
  /** delete data from the table: "label_groups" */
  delete_label_groups?: Maybe<LabelGroupsMutationResponse>;
  /** delete single row from the table: "label_groups" */
  delete_label_groups_by_pk?: Maybe<LabelGroups>;
  /** delete data from the table: "labels" */
  delete_labels?: Maybe<LabelsMutationResponse>;
  /** delete single row from the table: "labels" */
  delete_labels_by_pk?: Maybe<Labels>;
  /** delete data from the table: "lcm_message_candidates" */
  delete_lcm_message_candidates?: Maybe<LcmMessageCandidatesMutationResponse>;
  /** delete single row from the table: "lcm_message_candidates" */
  delete_lcm_message_candidates_by_pk?: Maybe<LcmMessageCandidates>;
  /** delete data from the table: "lcm_message_plans" */
  delete_lcm_message_plans?: Maybe<LcmMessagePlansMutationResponse>;
  /** delete single row from the table: "lcm_message_plans" */
  delete_lcm_message_plans_by_pk?: Maybe<LcmMessagePlans>;
  /** delete data from the table: "llm_inference_backends" */
  delete_llm_inference_backends?: Maybe<LlmInferenceBackendsMutationResponse>;
  /** delete single row from the table: "llm_inference_backends" */
  delete_llm_inference_backends_by_pk?: Maybe<LlmInferenceBackends>;
  /** delete data from the table: "looker_credentials" */
  delete_looker_credentials?: Maybe<LookerCredentialsMutationResponse>;
  /** delete single row from the table: "looker_credentials" */
  delete_looker_credentials_by_pk?: Maybe<LookerCredentials>;
  /** delete data from the table: "marketing_campaign_messages" */
  delete_marketing_campaign_messages?: Maybe<MarketingCampaignMessagesMutationResponse>;
  /** delete single row from the table: "marketing_campaign_messages" */
  delete_marketing_campaign_messages_by_pk?: Maybe<MarketingCampaignMessages>;
  /** delete data from the table: "marketing_campaigns" */
  delete_marketing_campaigns?: Maybe<MarketingCampaignsMutationResponse>;
  /** delete single row from the table: "marketing_campaigns" */
  delete_marketing_campaigns_by_pk?: Maybe<MarketingCampaigns>;
  /** delete data from the table: "matchboosting_config" */
  delete_matchboosting_config?: Maybe<MatchboostingConfigMutationResponse>;
  /** delete single row from the table: "matchboosting_config" */
  delete_matchboosting_config_by_pk?: Maybe<MatchboostingConfig>;
  /** delete data from the table: "matchboosting_workspace_config" */
  delete_matchboosting_workspace_config?: Maybe<MatchboostingWorkspaceConfigMutationResponse>;
  /** delete single row from the table: "matchboosting_workspace_config" */
  delete_matchboosting_workspace_config_by_pk?: Maybe<MatchboostingWorkspaceConfig>;
  /** delete data from the table: "message_contents" */
  delete_message_contents?: Maybe<MessageContentsMutationResponse>;
  /** delete single row from the table: "message_contents" */
  delete_message_contents_by_pk?: Maybe<MessageContents>;
  /** delete data from the table: "message_contents_metadata" */
  delete_message_contents_metadata?: Maybe<MessageContentsMetadataMutationResponse>;
  /** delete single row from the table: "message_contents_metadata" */
  delete_message_contents_metadata_by_pk?: Maybe<MessageContentsMetadata>;
  /** delete data from the table: "message_experiments" */
  delete_message_experiments?: Maybe<MessageExperimentsMutationResponse>;
  /** delete single row from the table: "message_experiments" */
  delete_message_experiments_by_pk?: Maybe<MessageExperiments>;
  /** delete data from the table: "message_labels" */
  delete_message_labels?: Maybe<MessageLabelsMutationResponse>;
  /** delete single row from the table: "message_labels" */
  delete_message_labels_by_pk?: Maybe<MessageLabels>;
  /** delete data from the table: "message_push_apps" */
  delete_message_push_apps?: Maybe<MessagePushAppsMutationResponse>;
  /** delete single row from the table: "message_push_apps" */
  delete_message_push_apps_by_pk?: Maybe<MessagePushApps>;
  /** delete data from the table: "message_variant_arm" */
  delete_message_variant_arm?: Maybe<MessageVariantArmMutationResponse>;
  /** delete single row from the table: "message_variant_arm" */
  delete_message_variant_arm_by_pk?: Maybe<MessageVariantArm>;
  /** delete data from the table: "messages" */
  delete_messages?: Maybe<MessagesMutationResponse>;
  /** delete single row from the table: "messages" */
  delete_messages_by_pk?: Maybe<Messages>;
  /** delete data from the table: "model_columns" */
  delete_model_columns?: Maybe<ModelColumnsMutationResponse>;
  /** delete single row from the table: "model_columns" */
  delete_model_columns_by_pk?: Maybe<ModelColumns>;
  /** delete data from the table: "model_relationships" */
  delete_model_relationships?: Maybe<ModelRelationshipsMutationResponse>;
  /** delete single row from the table: "model_relationships" */
  delete_model_relationships_by_pk?: Maybe<ModelRelationships>;
  /** delete data from the table: "monitor_condition_templates" */
  delete_monitor_condition_templates?: Maybe<MonitorConditionTemplatesMutationResponse>;
  /** delete single row from the table: "monitor_condition_templates" */
  delete_monitor_condition_templates_by_pk?: Maybe<MonitorConditionTemplates>;
  /** delete data from the table: "notification_channel_templates" */
  delete_notification_channel_templates?: Maybe<NotificationChannelTemplatesMutationResponse>;
  /** delete single row from the table: "notification_channel_templates" */
  delete_notification_channel_templates_by_pk?: Maybe<NotificationChannelTemplates>;
  /** delete data from the table: "organization_invites" */
  delete_organization_invites?: Maybe<OrganizationInvitesMutationResponse>;
  /** delete single row from the table: "organization_invites" */
  delete_organization_invites_by_pk?: Maybe<OrganizationInvites>;
  /** delete data from the table: "pagerduty_credentials" */
  delete_pagerduty_credentials?: Maybe<PagerdutyCredentialsMutationResponse>;
  /** delete single row from the table: "pagerduty_credentials" */
  delete_pagerduty_credentials_by_pk?: Maybe<PagerdutyCredentials>;
  /** delete data from the table: "predictor_feature_definition_events" */
  delete_predictor_feature_definition_events?: Maybe<PredictorFeatureDefinitionEventsMutationResponse>;
  /** delete single row from the table: "predictor_feature_definition_events" */
  delete_predictor_feature_definition_events_by_pk?: Maybe<PredictorFeatureDefinitionEvents>;
  /** delete data from the table: "predictor_feature_definitions" */
  delete_predictor_feature_definitions?: Maybe<PredictorFeatureDefinitionsMutationResponse>;
  /** delete single row from the table: "predictor_feature_definitions" */
  delete_predictor_feature_definitions_by_pk?: Maybe<PredictorFeatureDefinitions>;
  /** delete data from the table: "predictor_outcomes" */
  delete_predictor_outcomes?: Maybe<PredictorOutcomesMutationResponse>;
  /** delete single row from the table: "predictor_outcomes" */
  delete_predictor_outcomes_by_pk?: Maybe<PredictorOutcomes>;
  /** delete data from the table: "predictors" */
  delete_predictors?: Maybe<PredictorsMutationResponse>;
  /** delete single row from the table: "predictors" */
  delete_predictors_by_pk?: Maybe<Predictors>;
  /** delete data from the table: "push_apps" */
  delete_push_apps?: Maybe<PushAppsMutationResponse>;
  /** delete single row from the table: "push_apps" */
  delete_push_apps_by_pk?: Maybe<PushApps>;
  /** delete data from the table: "push_config" */
  delete_push_config?: Maybe<PushConfigMutationResponse>;
  /** delete single row from the table: "push_config" */
  delete_push_config_by_pk?: Maybe<PushConfig>;
  /** delete data from the table: "realtime_audience_syncs" */
  delete_realtime_audience_syncs?: Maybe<RealtimeAudienceSyncsMutationResponse>;
  /** delete single row from the table: "realtime_audience_syncs" */
  delete_realtime_audience_syncs_by_pk?: Maybe<RealtimeAudienceSyncs>;
  /** delete data from the table: "relationship_references" */
  delete_relationship_references?: Maybe<RelationshipReferencesMutationResponse>;
  /** delete single row from the table: "relationship_references" */
  delete_relationship_references_by_pk?: Maybe<RelationshipReferences>;
  /** delete data from the table: "relationships" */
  delete_relationships?: Maybe<RelationshipsMutationResponse>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: Maybe<Relationships>;
  /** delete data from the table: "report_schedule" */
  delete_report_schedule?: Maybe<ReportScheduleMutationResponse>;
  /** delete single row from the table: "report_schedule" */
  delete_report_schedule_by_pk?: Maybe<ReportSchedule>;
  /** delete data from the table: "report_schedule_run_comments" */
  delete_report_schedule_run_comments?: Maybe<ReportScheduleRunCommentsMutationResponse>;
  /** delete single row from the table: "report_schedule_run_comments" */
  delete_report_schedule_run_comments_by_pk?: Maybe<ReportScheduleRunComments>;
  /** delete data from the table: "report_schedule_runs" */
  delete_report_schedule_runs?: Maybe<ReportScheduleRunsMutationResponse>;
  /** delete single row from the table: "report_schedule_runs" */
  delete_report_schedule_runs_by_pk?: Maybe<ReportScheduleRuns>;
  /** delete data from the table: "resource_monitor_conditions" */
  delete_resource_monitor_conditions?: Maybe<ResourceMonitorConditionsMutationResponse>;
  /** delete single row from the table: "resource_monitor_conditions" */
  delete_resource_monitor_conditions_by_pk?: Maybe<ResourceMonitorConditions>;
  /** delete data from the table: "resource_notification_channels" */
  delete_resource_notification_channels?: Maybe<ResourceNotificationChannelsMutationResponse>;
  /** delete single row from the table: "resource_notification_channels" */
  delete_resource_notification_channels_by_pk?: Maybe<ResourceNotificationChannels>;
  /** delete data from the table: "resource_views" */
  delete_resource_views?: Maybe<ResourceViewsMutationResponse>;
  /** delete single row from the table: "resource_views" */
  delete_resource_views_by_pk?: Maybe<ResourceViews>;
  /** delete data from the table: "saved_analytics_charts" */
  delete_saved_analytics_charts?: Maybe<SavedAnalyticsChartsMutationResponse>;
  /** delete single row from the table: "saved_analytics_charts" */
  delete_saved_analytics_charts_by_pk?: Maybe<SavedAnalyticsCharts>;
  /** delete data from the table: "saved_analytics_charts_cohorts" */
  delete_saved_analytics_charts_cohorts?: Maybe<SavedAnalyticsChartsCohortsMutationResponse>;
  /** delete single row from the table: "saved_analytics_charts_cohorts" */
  delete_saved_analytics_charts_cohorts_by_pk?: Maybe<SavedAnalyticsChartsCohorts>;
  /** delete data from the table: "saved_analytics_charts_funnel_stages" */
  delete_saved_analytics_charts_funnel_stages?: Maybe<SavedAnalyticsChartsFunnelStagesMutationResponse>;
  /** delete single row from the table: "saved_analytics_charts_funnel_stages" */
  delete_saved_analytics_charts_funnel_stages_by_pk?: Maybe<SavedAnalyticsChartsFunnelStages>;
  /** delete data from the table: "saved_analytics_charts_goals" */
  delete_saved_analytics_charts_goals?: Maybe<SavedAnalyticsChartsGoalsMutationResponse>;
  /** delete single row from the table: "saved_analytics_charts_goals" */
  delete_saved_analytics_charts_goals_by_pk?: Maybe<SavedAnalyticsChartsGoals>;
  /** delete data from the table: "saved_campaign_views" */
  delete_saved_campaign_views?: Maybe<SavedCampaignViewsMutationResponse>;
  /** delete single row from the table: "saved_campaign_views" */
  delete_saved_campaign_views_by_pk?: Maybe<SavedCampaignViews>;
  /** delete data from the table: "saved_campaign_views_goals" */
  delete_saved_campaign_views_goals?: Maybe<SavedCampaignViewsGoalsMutationResponse>;
  /** delete single row from the table: "saved_campaign_views_goals" */
  delete_saved_campaign_views_goals_by_pk?: Maybe<SavedCampaignViewsGoals>;
  /** delete data from the table: "saved_queries" */
  delete_saved_queries?: Maybe<SavedQueriesMutationResponse>;
  /** delete single row from the table: "saved_queries" */
  delete_saved_queries_by_pk?: Maybe<SavedQueries>;
  /** delete data from the table: "segments" */
  delete_segments?: Maybe<SegmentsMutationResponse>;
  /** delete single row from the table: "segments" */
  delete_segments_by_pk?: Maybe<Segments>;
  /** delete data from the table: "slack_credentials" */
  delete_slack_credentials?: Maybe<SlackCredentialsMutationResponse>;
  /** delete single row from the table: "slack_credentials" */
  delete_slack_credentials_by_pk?: Maybe<SlackCredentials>;
  /** delete data from the table: "space_subset_grants" */
  delete_space_subset_grants?: Maybe<SpaceSubsetGrantsMutationResponse>;
  /** delete single row from the table: "space_subset_grants" */
  delete_space_subset_grants_by_pk?: Maybe<SpaceSubsetGrants>;
  /** delete data from the table: "space_sync_templates" */
  delete_space_sync_templates?: Maybe<SpaceSyncTemplatesMutationResponse>;
  /** delete single row from the table: "space_sync_templates" */
  delete_space_sync_templates_by_pk?: Maybe<SpaceSyncTemplates>;
  /** delete data from the table: "space_user_groups" */
  delete_space_user_groups?: Maybe<SpaceUserGroupsMutationResponse>;
  /** delete single row from the table: "space_user_groups" */
  delete_space_user_groups_by_pk?: Maybe<SpaceUserGroups>;
  /** delete data from the table: "spaces" */
  delete_spaces?: Maybe<SpacesMutationResponse>;
  /** delete single row from the table: "spaces" */
  delete_spaces_by_pk?: Maybe<Spaces>;
  /** delete data from the table: "sso_group_user_groups" */
  delete_sso_group_user_groups?: Maybe<SsoGroupUserGroupsMutationResponse>;
  /** delete single row from the table: "sso_group_user_groups" */
  delete_sso_group_user_groups_by_pk?: Maybe<SsoGroupUserGroups>;
  /** delete data from the table: "sync_sequence_members" */
  delete_sync_sequence_members?: Maybe<SyncSequenceMembersMutationResponse>;
  /** delete single row from the table: "sync_sequence_members" */
  delete_sync_sequence_members_by_pk?: Maybe<SyncSequenceMembers>;
  /** delete data from the table: "sync_sequences" */
  delete_sync_sequences?: Maybe<SyncSequencesMutationResponse>;
  /** delete single row from the table: "sync_sequences" */
  delete_sync_sequences_by_pk?: Maybe<SyncSequences>;
  /** delete data from the table: "sync_templates" */
  delete_sync_templates?: Maybe<SyncTemplatesMutationResponse>;
  /** delete single row from the table: "sync_templates" */
  delete_sync_templates_by_pk?: Maybe<SyncTemplates>;
  /** delete data from the table: "through_model_relationships" */
  delete_through_model_relationships?: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** delete single row from the table: "through_model_relationships" */
  delete_through_model_relationships_by_pk?: Maybe<ThroughModelRelationships>;
  /** delete data from the table: "tracked_audience_list_audiences" */
  delete_tracked_audience_list_audiences?: Maybe<TrackedAudienceListAudiencesMutationResponse>;
  /** delete single row from the table: "tracked_audience_list_audiences" */
  delete_tracked_audience_list_audiences_by_pk?: Maybe<TrackedAudienceListAudiences>;
  /** delete data from the table: "trait_definitions" */
  delete_trait_definitions?: Maybe<TraitDefinitionsMutationResponse>;
  /** delete single row from the table: "trait_definitions" */
  delete_trait_definitions_by_pk?: Maybe<TraitDefinitions>;
  /** delete data from the table: "tunnels" */
  delete_tunnels?: Maybe<TunnelsMutationResponse>;
  /** delete single row from the table: "tunnels" */
  delete_tunnels_by_pk?: Maybe<Tunnels>;
  /** delete data from the table: "user_group_members" */
  delete_user_group_members?: Maybe<UserGroupMembersMutationResponse>;
  /** delete single row from the table: "user_group_members" */
  delete_user_group_members_by_pk?: Maybe<UserGroupMembers>;
  /** delete data from the table: "user_group_workspaces" */
  delete_user_group_workspaces?: Maybe<UserGroupWorkspacesMutationResponse>;
  /** delete single row from the table: "user_group_workspaces" */
  delete_user_group_workspaces_by_pk?: Maybe<UserGroupWorkspaces>;
  /** delete data from the table: "user_groups" */
  delete_user_groups?: Maybe<UserGroupsMutationResponse>;
  /** delete single row from the table: "user_groups" */
  delete_user_groups_by_pk?: Maybe<UserGroups>;
  /** delete data from the table: "workspace_notification_channels" */
  delete_workspace_notification_channels?: Maybe<WorkspaceNotificationChannelsMutationResponse>;
  /** delete single row from the table: "workspace_notification_channels" */
  delete_workspace_notification_channels_by_pk?: Maybe<WorkspaceNotificationChannels>;
  demoMockMessageStatistics: DemoMockMessageStatisticsResult;
  deployContentArtifactDynamicContent: DeployContentArtifactDynamicContentResponse;
  /**
   * Deploy an email's dynamic content to an ESP: compiled template + created
   * campaign + a paused, unscheduled trigger sync carrying the branch keys.
   */
  deployContentEmailDynamicContent: DeployContentEmailDynamicContentResponse;
  deployModel: ModelDeploymentResult;
  deploySync: SyncDeploymentResult;
  /** Remove the attached CSV from a draft one-time email campaign. */
  detachCampaignCsv: Scalars['Boolean'];
  /**
   * Copies the library template a WhatsApp message sends into its own template,
   * so it can be edited. Allowed while the campaign is a draft.
   */
  detachCepWhatsAppTemplate: CepWhatsAppTemplateLinkResult;
  detectRelationshipCardinality: DetectRelationshipCardinalityOutput;
  disableDecisionEngineFlow: DecisionEngineResult;
  disableDecisionEngineFlowMessage: DecisionEngineResult;
  /**
   * Destroy-disable: mark all children removing and enqueue converge. Null once
   * no mirror row remains.
   */
  disableWarehouseShare?: Maybe<WarehouseShareMirror>;
  /**
   * Puts the live version of one translated locale back into a live
   * campaign's draft, so the draft no longer changes it.
   */
  discardCepWhatsAppDraftLocaleEdits: Scalars['Boolean'];
  discardFigmaImportDraft: DiscardFigmaImportDraftResult;
  /**
   * Discard staged changes: hard-deletes content rows past published_version
   * and clears the draft pointers.
   */
  discardMessageContentDraft: DiscardMessageDraftResult;
  discardReportDraft: ReportScheduleContentMutationResponse;
  /** Drops the workspace's stored credentials for a deliverability feed and stops its pulls. Collected data stays. False when the workspace has no row for the feed. */
  disconnectDeliverabilityFeed: Scalars['Boolean'];
  discover?: Maybe<Scalars['Boolean']>;
  discoverFigmaDesigns: FigmaDesignDiscovery;
  /**
   * Hide an insight card for everyone in the workspace. Cannot be undone.
   * Returns true even when the card was already hidden.
   */
  dismissCampaignInsight: Scalars['Boolean'];
  draftModelConfiguration: DraftModelConfigurationResponse;
  dryRunDecisionEngine?: Maybe<Scalars['JSONObject']>;
  duplicateAdTemplate: Scalars['uuid'];
  /** Copies a file's current version into a new file. Canvas files cannot be copied. A null folderId files the copy at the top level; omitting it puts the copy where the source is. A copy placed on a canvas takes the canvas's visibility, and any other copy takes its source's. */
  duplicateAmpFile: AmpFile;
  duplicateAmpWorkflow: AmpMutationResult;
  duplicateIDRGraph: DuplicateIdrGraphResponse;
  editAmpProject: AmpMutationResult;
  editAmpTask: AmpMutationResult;
  /**
   * Edits the opt-in message(s) / redirect URL of a channel that already has
   * double opt-in enabled. Double opt-in cannot be disabled once configured.
   */
  editChannelDoubleOptIn: ConfigureChannelDoubleOptInResult;
  editDbtSyncConfig: FrontendDbtSyncConfig;
  ellieAdminAddContext: Scalars['jsonb'];
  ellieAdminAddSource: Scalars['jsonb'];
  ellieAdminAppendTopicReviews: Scalars['jsonb'];
  ellieAdminAssessSourceBatch: Scalars['jsonb'];
  ellieAdminCloseDiagnosticCycle: Scalars['jsonb'];
  ellieAdminCollectAppstoreReviews: Scalars['jsonb'];
  ellieAdminCollectBrandSearch: Scalars['jsonb'];
  ellieAdminCollectLinkedinMention: Scalars['jsonb'];
  ellieAdminCollectMapsReviews: Scalars['jsonb'];
  ellieAdminCollectPlayReviews: Scalars['jsonb'];
  ellieAdminCorrectFindingCitations: Scalars['jsonb'];
  ellieAdminCreateBuyerDiagnostic: Scalars['jsonb'];
  ellieAdminCreateDiagnosticMonitor: Scalars['jsonb'];
  ellieAdminDeepenCampaign: Scalars['jsonb'];
  ellieAdminDevelopUnderstanding: Scalars['jsonb'];
  ellieAdminEnhanceCampaign: Scalars['jsonb'];
  ellieAdminFeedbackUnderstanding: Scalars['jsonb'];
  ellieAdminMeasureCampaign: Scalars['jsonb'];
  ellieAdminObserveNow: Scalars['jsonb'];
  ellieAdminPauseCampaign: Scalars['jsonb'];
  ellieAdminPreviewBrandSearch: Scalars['jsonb'];
  ellieAdminPreviewLinkedinMentions: Scalars['jsonb'];
  ellieAdminPreviewMapsReviews: Scalars['jsonb'];
  ellieAdminPreviewPlayReviews: Scalars['jsonb'];
  ellieAdminPreviewSourceKeywords: Scalars['jsonb'];
  ellieAdminReadSourceBatch: Scalars['jsonb'];
  ellieAdminReconcileInternetRequest: Scalars['jsonb'];
  ellieAdminRecoverPromptAllocation: Scalars['jsonb'];
  ellieAdminRecoverPromptReservations: Scalars['jsonb'];
  ellieAdminRefreshUnderstanding: Scalars['jsonb'];
  ellieAdminRepeatPrompts: Scalars['jsonb'];
  ellieAdminResearchCompany: Scalars['jsonb'];
  ellieAdminResolveChromeCapture: Scalars['jsonb'];
  ellieAdminResumeCampaign: Scalars['jsonb'];
  ellieAdminRetryJob: Scalars['jsonb'];
  ellieAdminRunAeoTrial: Scalars['jsonb'];
  ellieAdminRunDiagnosticMonitor: Scalars['jsonb'];
  ellieAdminRunSourceKeywords: Scalars['jsonb'];
  ellieAdminRunSourceStep: Scalars['jsonb'];
  ellieAdminSendCampaignMessage: Scalars['jsonb'];
  ellieAdminSetDiagnosticMonitorState: Scalars['jsonb'];
  ellieAdminStartCampaign: Scalars['jsonb'];
  ellieAdminStartDiscovery: Scalars['jsonb'];
  ellieAdminStopCampaign: Scalars['jsonb'];
  ellieAdminUpdateAppstoreReviewSchedule: Scalars['jsonb'];
  ellieAdminUpdateBrandSearchSchedule: Scalars['jsonb'];
  ellieAdminUpdateDiagnosticMonitor: Scalars['jsonb'];
  ellieAdminUpdateIdeaStatus: Scalars['jsonb'];
  ellieAdminUpdateLinkedinMentionSchedule: Scalars['jsonb'];
  ellieAdminUpdateLinkedinSchedule: Scalars['jsonb'];
  ellieAdminUpdateMapsReviewSchedule: Scalars['jsonb'];
  ellieAdminUpdateMapsReviewTargets: Scalars['jsonb'];
  ellieAdminUpdatePlayReviewSchedule: Scalars['jsonb'];
  ellieAdminUpdateSettings: Scalars['jsonb'];
  ellieAdminUpdateSourceKeywords: Scalars['jsonb'];
  ellieAdminUpdateSourceQueue: Scalars['jsonb'];
  ellieAdminUpdateSourceReadSchedule: Scalars['jsonb'];
  ellieAdminWriteBrain: Scalars['jsonb'];
  ellieAssessSource: Scalars['jsonb'];
  ellieCollectLinkedin: Scalars['jsonb'];
  ellieCopyChat: EllieChatCopy;
  ellieDeleteChat: Scalars['Boolean'];
  ellieReadSource: Scalars['jsonb'];
  ellieRenameChat: Scalars['Boolean'];
  ellieShareChat: Scalars['Boolean'];
  ellieStopChat: Scalars['Boolean'];
  ellieUpdateBrandTags: Scalars['jsonb'];
  ellieUpdateLinkedinSchedule: Scalars['jsonb'];
  ellieUpdateSourceExclusions: Scalars['jsonb'];
  ellieUpdateSourceRelationships: Scalars['jsonb'];
  ellieUpdateSourceReviews: Scalars['jsonb'];
  ellieUpdateSourceTypes: Scalars['jsonb'];
  ellieUpdateTopic: Scalars['jsonb'];
  enableDecisionEngineFlow: DecisionEngineResult;
  enableDecisionEngineFlowMessage: DecisionEngineResult;
  enablePushAppAndConfigureEvents: EnablePushAppAndConfigureEventsResult;
  /** Every later run admits the full audience. A launch plan no live run has used is removed instead. */
  endDecisionEngineFlowVolumeRamp: Scalars['Boolean'];
  enqueueGetAgentTags: TagsJobResponse;
  enqueueGetMessageTags: TagsJobResponse;
  enqueueGoalComputation?: Maybe<EnqueueGoalComputationResponse>;
  /**
   * Create a CSV-backed static list and enqueue its warehouse materialization
   * job. Returns the new static list id and the enqueued job id.
   */
  enqueueStaticListCsvMaterialization: EnqueueStaticListCsvMaterializationResult;
  /**
   * Preview refreshing an audience's snapshot static list (preview-and-confirm
   * refresh): materialize the audience's current membership into a new,
   * unassociated static list and
   * report the membership diff, without touching the live set. Confirm with
   * `associateStaticListToAudience` (which detaches the old list and enqueues
   * its cleanup). Returns the new static list id and job id.
   */
  enqueueStaticListRefreshPreview: EnqueueStaticListRefreshPreviewResult;
  /**
   * Create a snapshot-backed static list from an audience and enqueue its
   * warehouse materialization job. Returns the new static list id and the
   * enqueued job id.
   */
  enqueueStaticListSnapshotMaterialization: EnqueueStaticListSnapshotMaterializationResult;
  /**
   * Re-materialize an audience's snapshot static list in place against its
   * current filter (in-place refresh). The existing row keeps pointing at the
   * same (replaced) member table; only its membership and size change.
   */
  enqueueStaticListSnapshotRefresh: EnqueueStaticListSnapshotRefreshResult;
  /**
   * The template a WhatsApp message sends, created and bound on first use.
   * With draft on a live campaign, returns the draft's copy of the template,
   * creating the copy and the draft on first use. The campaign keeps sending
   * the live template until the draft is published.
   */
  ensureCepWhatsAppMessageTemplate: EnsureCepWhatsAppMessageTemplateResult;
  ensureTemplateEditingSession: EnsureTemplateEditingSessionResponse;
  executeLLMBackgroundJob: ExecuteLlmBackgroundJobResponse;
  executeMarketingAgentConversation: ExecuteLlmConversationBackgroundResponse;
  exportBulkVideoAds: ExportBulkVideoAdsResponse;
  exportContentArtifactDynamicContentToProvider: ExportContentArtifactDynamicContentResponse;
  /** Makes a draft Native Delivery campaign from a saved Lifecycle Studio email version. Returns the problems instead when the email cannot be sent from Native Delivery as it is. */
  exportContentEmailToNativeDelivery: ExportContentEmailToNativeDeliveryResult;
  exportEmailHtmlToStorageDestination: ExportEmailHtmlToStorageResult;
  exportEmailToPng: ExportEmailToPngResponse;
  exportEmailToPsd: ExportEmailToPngResponse;
  exportVideoAd: ExportVideoAdResponse;
  exportWebPageToPsd: ExportWebPageToPsdResponse;
  extractEspUserFieldsFromContext: ExtractEspUserFieldsResult;
  fetchCepProviderDomains: FetchCepProviderDomainsResult;
  generateAdVariations: GenerateAdVariationsResponse;
  generateAgentPromptSuggestions: BackgroundJobResponse;
  generateAgenticUFM: AgenticUfmJobResponse;
  generateAssetVariant: GenerateAssetVariantResponse;
  generateBreakdowns?: Maybe<Scalars['JSONObject']>;
  /**
   * Start a campaign insights run for the current workspace. Hightouch staff
   * with write access only.
   * Returns the new run without waiting for the analysis.
   */
  generateCampaignInsights: CampaignInsightsRun;
  generateCopy: GenerateCopyResponse;
  generateDemoInsights: DemoInsightsRun;
  /**
   * Enqueue an agent run that creates audience variants for the selected
   * element on the dynamic content canvas. The prompt is built server-side;
   * the interaction is tagged with a generating_dynamic_content lcmActivity so
   * the canvas can render a refresh-proof loading lane at the element.
   */
  generateDynamicContentVariants: GenerateDynamicContentVariantsResponse;
  generateEmail: GenerateEmailResponse;
  generateExperimentGroups: Scalars['Boolean'];
  /**
   * Kick off insight generation for an initiative goal. Hightouch employees
   * only. Returns the background job id.
   */
  generateInitiativeInsights: Scalars['uuid'];
  generateMessageCandidates: GenerateMessageCandidatesResponse;
  generateMessageDynamicContentVariants: GenerateMessageDynamicContentVariantsResponse;
  generateMessagePlans: GenerateMessagePlansResponse;
  generateMoreCandidates: GenerateMoreCandidatesResponse;
  generateReportCustomization: ReportCustomization;
  generateReportCustomizationQuestions: Array<ReportCustomizationQuestion>;
  /**
   * Staff-only manual trigger to (re)generate report suggestions for the
   * current workspace. Gated by Hightouch-staff membership; the scheduler
   * regenerates automatically in production.
   */
  generateReportSuggestions: BackgroundJobResponse;
  generateVariantsSuggestions: GenerateVariantsSuggestionsResult;
  /**
   * Force-regenerate the Hightouch-managed workspace-context document for the
   * authenticated user's workspace.
   *
   * systemPromptOverride replaces the default instructional system prompt
   * used by the generator. The override is restricted to Hightouch staff;
   * requests from non-staff users will silently ignore the override and fall
   * back to the default prompt.
   */
  generateWorkspaceContext: BackgroundJobResponse;
  getCepMessagingServiceChannels: GetCepMessagingServiceChannelsResult;
  /** Lists the workspace's saved Performance tab views by name, first creating the preset views when it has none and has ad data to scope them to. */
  getOrCreateAdInsightsSavedViews: Array<AdInsightsSavedView>;
  hardDeletePredictor: DeletePredictorResult;
  importAllAssetsForExtension: ImportAllAssetsResult;
  importContentCopy: ImportContentCopyResponse;
  importContentEmail: ImportContentEmailResponse;
  importEmailTemplatesFromDestination: ImportEmailTemplatesResult;
  improveReportInstructionsDraft: ImproveReportInstructionsResponse;
  initiateAdAssetMediaUpload: InitiateAdAssetMediaUploadResponse;
  initiateAmpFileUpload: AmpFileUpload;
  initiateChatFileUpload: InitiateChatFileUploadResponse;
  initiateChatFileUploads: InitiateChatFileUploadsResponse;
  /**
   * Start a presigned direct-to-storage upload for a context file. The browser
   * PUTs the bytes to the returned URL, then passes the returned s3Key on
   * create/update via AgenticSettingsFileContentInput.s3Key. Avoids
   * base64-encoding file bytes into the GraphQL request body.
   */
  initiateContextFileUpload: InitiateContextFileUploadResult;
  initiateLaunchAssetUpload: InitiateLaunchAssetUploadResponse;
  /**
   * Insert a batch of insight cards. Hightouch employees only. `insights` is
   * { creative: [], segments: [], frequency: [] } of findings without ids, plus
   * an optional `sends` map from calendar send id to findings
   * without `recommendation` or `chart`. `llmChatSessionId` optionally
   * records the agent session the cards came from; it must name a session in
   * the caller's workspace. Send findings whose send id is not in the calendar
   * are dropped. Returns the new batch id and which send findings were
   * dropped. `dryRun` runs the same checks and reports without inserting.
   */
  injectCampaignInsightsV2: InjectCampaignInsightsResult;
  insertAdBriefWithVersion: InsertAdBriefWithVersionResponse;
  insertLibraryTags: LibraryTagInsertResult;
  /** insert data into the table: "ad_asset_favorites" */
  insert_ad_asset_favorites?: Maybe<AdAssetFavoritesMutationResponse>;
  /** insert a single row into the table: "ad_asset_favorites" */
  insert_ad_asset_favorites_one?: Maybe<AdAssetFavorites>;
  /** insert data into the table: "ad_brief_asset_launch_queue" */
  insert_ad_brief_asset_launch_queue?: Maybe<AdBriefAssetLaunchQueueMutationResponse>;
  /** insert a single row into the table: "ad_brief_asset_launch_queue" */
  insert_ad_brief_asset_launch_queue_one?: Maybe<AdBriefAssetLaunchQueue>;
  /** insert data into the table: "ad_brief_asset_launches" */
  insert_ad_brief_asset_launches?: Maybe<AdBriefAssetLaunchesMutationResponse>;
  /** insert a single row into the table: "ad_brief_asset_launches" */
  insert_ad_brief_asset_launches_one?: Maybe<AdBriefAssetLaunches>;
  /** insert data into the table: "ad_brief_asset_size_variants" */
  insert_ad_brief_asset_size_variants?: Maybe<AdBriefAssetSizeVariantsMutationResponse>;
  /** insert a single row into the table: "ad_brief_asset_size_variants" */
  insert_ad_brief_asset_size_variants_one?: Maybe<AdBriefAssetSizeVariants>;
  /** insert data into the table: "ad_brief_asset_versions" */
  insert_ad_brief_asset_versions?: Maybe<AdBriefAssetVersionsMutationResponse>;
  /** insert a single row into the table: "ad_brief_asset_versions" */
  insert_ad_brief_asset_versions_one?: Maybe<AdBriefAssetVersions>;
  /** insert data into the table: "ad_brief_assets" */
  insert_ad_brief_assets?: Maybe<AdBriefAssetsMutationResponse>;
  /** insert a single row into the table: "ad_brief_assets" */
  insert_ad_brief_assets_one?: Maybe<AdBriefAssets>;
  /** insert data into the table: "ad_briefs" */
  insert_ad_briefs?: Maybe<AdBriefsMutationResponse>;
  /** insert a single row into the table: "ad_briefs" */
  insert_ad_briefs_one?: Maybe<AdBriefs>;
  /** insert data into the table: "ad_export_channel_sizes" */
  insert_ad_export_channel_sizes?: Maybe<AdExportChannelSizesMutationResponse>;
  /** insert a single row into the table: "ad_export_channel_sizes" */
  insert_ad_export_channel_sizes_one?: Maybe<AdExportChannelSizes>;
  /** insert data into the table: "ad_export_channels" */
  insert_ad_export_channels?: Maybe<AdExportChannelsMutationResponse>;
  /** insert a single row into the table: "ad_export_channels" */
  insert_ad_export_channels_one?: Maybe<AdExportChannels>;
  /** insert data into the table: "ad_stats_models" */
  insert_ad_stats_models?: Maybe<AdStatsModelsMutationResponse>;
  /** insert a single row into the table: "ad_stats_models" */
  insert_ad_stats_models_one?: Maybe<AdStatsModels>;
  /** insert data into the table: "ad_studio_product_feeds" */
  insert_ad_studio_product_feeds?: Maybe<AdStudioProductFeedsMutationResponse>;
  /** insert a single row into the table: "ad_studio_product_feeds" */
  insert_ad_studio_product_feeds_one?: Maybe<AdStudioProductFeeds>;
  /** insert data into the table: "ad_studio_project_brief_versions" */
  insert_ad_studio_project_brief_versions?: Maybe<AdStudioProjectBriefVersionsMutationResponse>;
  /** insert a single row into the table: "ad_studio_project_brief_versions" */
  insert_ad_studio_project_brief_versions_one?: Maybe<AdStudioProjectBriefVersions>;
  /** insert data into the table: "ad_studio_project_pins" */
  insert_ad_studio_project_pins?: Maybe<AdStudioProjectPinsMutationResponse>;
  /** insert a single row into the table: "ad_studio_project_pins" */
  insert_ad_studio_project_pins_one?: Maybe<AdStudioProjectPins>;
  /** insert data into the table: "ad_studio_projects" */
  insert_ad_studio_projects?: Maybe<AdStudioProjectsMutationResponse>;
  /** insert a single row into the table: "ad_studio_projects" */
  insert_ad_studio_projects_one?: Maybe<AdStudioProjects>;
  /** insert data into the table: "ad_studio_treatments" */
  insert_ad_studio_treatments?: Maybe<AdStudioTreatmentsMutationResponse>;
  /** insert a single row into the table: "ad_studio_treatments" */
  insert_ad_studio_treatments_one?: Maybe<AdStudioTreatments>;
  /** insert data into the table: "agentic_settings" */
  insert_agentic_settings?: Maybe<AgenticSettingsMutationResponse>;
  /** insert data into the table: "agentic_settings_entities_links" */
  insert_agentic_settings_entities_links?: Maybe<AgenticSettingsEntitiesLinksMutationResponse>;
  /** insert a single row into the table: "agentic_settings_entities_links" */
  insert_agentic_settings_entities_links_one?: Maybe<AgenticSettingsEntitiesLinks>;
  /** insert a single row into the table: "agentic_settings" */
  insert_agentic_settings_one?: Maybe<AgenticSettings>;
  /** insert data into the table: "alert_instances" */
  insert_alert_instances?: Maybe<AlertInstancesMutationResponse>;
  /** insert a single row into the table: "alert_instances" */
  insert_alert_instances_one?: Maybe<AlertInstances>;
  /** insert data into the table: "alerts" */
  insert_alerts?: Maybe<AlertsMutationResponse>;
  /** insert a single row into the table: "alerts" */
  insert_alerts_one?: Maybe<Alerts>;
  /** insert data into the table: "amp_asset_ratings" */
  insert_amp_asset_ratings?: Maybe<AmpAssetRatingsMutationResponse>;
  /** insert a single row into the table: "amp_asset_ratings" */
  insert_amp_asset_ratings_one?: Maybe<AmpAssetRatings>;
  /** insert data into the table: "amp_creative_dimensions" */
  insert_amp_creative_dimensions?: Maybe<AmpCreativeDimensionsMutationResponse>;
  /** insert a single row into the table: "amp_creative_dimensions" */
  insert_amp_creative_dimensions_one?: Maybe<AmpCreativeDimensions>;
  /** insert data into the table: "amp_file_favorites" */
  insert_amp_file_favorites?: Maybe<AmpFileFavoritesMutationResponse>;
  /** insert a single row into the table: "amp_file_favorites" */
  insert_amp_file_favorites_one?: Maybe<AmpFileFavorites>;
  /** insert data into the table: "amp_followed_sources" */
  insert_amp_followed_sources?: Maybe<AmpFollowedSourcesMutationResponse>;
  /** insert a single row into the table: "amp_followed_sources" */
  insert_amp_followed_sources_one?: Maybe<AmpFollowedSources>;
  /** insert data into the table: "amp_followed_topics" */
  insert_amp_followed_topics?: Maybe<AmpFollowedTopicsMutationResponse>;
  /** insert a single row into the table: "amp_followed_topics" */
  insert_amp_followed_topics_one?: Maybe<AmpFollowedTopics>;
  /** insert data into the table: "amp_project_pins" */
  insert_amp_project_pins?: Maybe<AmpProjectPinsMutationResponse>;
  /** insert a single row into the table: "amp_project_pins" */
  insert_amp_project_pins_one?: Maybe<AmpProjectPins>;
  /** insert data into the table: "amp_project_users" */
  insert_amp_project_users?: Maybe<AmpProjectUsersMutationResponse>;
  /** insert a single row into the table: "amp_project_users" */
  insert_amp_project_users_one?: Maybe<AmpProjectUsers>;
  /** insert data into the table: "amp_tags" */
  insert_amp_tags?: Maybe<AmpTagsMutationResponse>;
  /** insert a single row into the table: "amp_tags" */
  insert_amp_tags_one?: Maybe<AmpTags>;
  /** insert data into the table: "amp_task_relations" */
  insert_amp_task_relations?: Maybe<AmpTaskRelationsMutationResponse>;
  /** insert a single row into the table: "amp_task_relations" */
  insert_amp_task_relations_one?: Maybe<AmpTaskRelations>;
  /** insert data into the table: "amp_task_users" */
  insert_amp_task_users?: Maybe<AmpTaskUsersMutationResponse>;
  /** insert a single row into the table: "amp_task_users" */
  insert_amp_task_users_one?: Maybe<AmpTaskUsers>;
  /** insert data into the table: "amp_team_members" */
  insert_amp_team_members?: Maybe<AmpTeamMembersMutationResponse>;
  /** insert a single row into the table: "amp_team_members" */
  insert_amp_team_members_one?: Maybe<AmpTeamMembers>;
  /** insert data into the table: "amp_teams" */
  insert_amp_teams?: Maybe<AmpTeamsMutationResponse>;
  /** insert a single row into the table: "amp_teams" */
  insert_amp_teams_one?: Maybe<AmpTeams>;
  /** insert data into the table: "amp_workflow_status_reviewers" */
  insert_amp_workflow_status_reviewers?: Maybe<AmpWorkflowStatusReviewersMutationResponse>;
  /** insert a single row into the table: "amp_workflow_status_reviewers" */
  insert_amp_workflow_status_reviewers_one?: Maybe<AmpWorkflowStatusReviewers>;
  /** insert data into the table: "amp_workflow_statuses" */
  insert_amp_workflow_statuses?: Maybe<AmpWorkflowStatusesMutationResponse>;
  /** insert a single row into the table: "amp_workflow_statuses" */
  insert_amp_workflow_statuses_one?: Maybe<AmpWorkflowStatuses>;
  /** insert data into the table: "amp_workflows" */
  insert_amp_workflows?: Maybe<AmpWorkflowsMutationResponse>;
  /** insert a single row into the table: "amp_workflows" */
  insert_amp_workflows_one?: Maybe<AmpWorkflows>;
  /** insert data into the table: "analytics_reports" */
  insert_analytics_reports?: Maybe<AnalyticsReportsMutationResponse>;
  /** insert a single row into the table: "analytics_reports" */
  insert_analytics_reports_one?: Maybe<AnalyticsReports>;
  /** insert data into the table: "artifact_favorites" */
  insert_artifact_favorites?: Maybe<ArtifactFavoritesMutationResponse>;
  /** insert a single row into the table: "artifact_favorites" */
  insert_artifact_favorites_one?: Maybe<ArtifactFavorites>;
  /** insert data into the table: "artifact_review_comments" */
  insert_artifact_review_comments?: Maybe<ArtifactReviewCommentsMutationResponse>;
  /** insert a single row into the table: "artifact_review_comments" */
  insert_artifact_review_comments_one?: Maybe<ArtifactReviewComments>;
  /** insert data into the table: "artifact_review_statuses" */
  insert_artifact_review_statuses?: Maybe<ArtifactReviewStatusesMutationResponse>;
  /** insert a single row into the table: "artifact_review_statuses" */
  insert_artifact_review_statuses_one?: Maybe<ArtifactReviewStatuses>;
  /** insert data into the table: "artifact_reviewers" */
  insert_artifact_reviewers?: Maybe<ArtifactReviewersMutationResponse>;
  /** insert a single row into the table: "artifact_reviewers" */
  insert_artifact_reviewers_one?: Maybe<ArtifactReviewers>;
  /** insert data into the table: "artifact_reviews" */
  insert_artifact_reviews?: Maybe<ArtifactReviewsMutationResponse>;
  /** insert a single row into the table: "artifact_reviews" */
  insert_artifact_reviews_one?: Maybe<ArtifactReviews>;
  /** insert data into the table: "asset_comment_thread_reads" */
  insert_asset_comment_thread_reads?: Maybe<AssetCommentThreadReadsMutationResponse>;
  /** insert a single row into the table: "asset_comment_thread_reads" */
  insert_asset_comment_thread_reads_one?: Maybe<AssetCommentThreadReads>;
  /** insert data into the table: "asset_models" */
  insert_asset_models?: Maybe<AssetModelsMutationResponse>;
  /** insert a single row into the table: "asset_models" */
  insert_asset_models_one?: Maybe<AssetModels>;
  /** insert data into the table: "attribution_methods" */
  insert_attribution_methods?: Maybe<AttributionMethodsMutationResponse>;
  /** insert data into the table: "attribution_methods_interactions" */
  insert_attribution_methods_interactions?: Maybe<AttributionMethodsInteractionsMutationResponse>;
  /** insert a single row into the table: "attribution_methods_interactions" */
  insert_attribution_methods_interactions_one?: Maybe<AttributionMethodsInteractions>;
  /** insert a single row into the table: "attribution_methods" */
  insert_attribution_methods_one?: Maybe<AttributionMethods>;
  /** insert data into the table: "audience_goals" */
  insert_audience_goals?: Maybe<AudienceGoalsMutationResponse>;
  /** insert a single row into the table: "audience_goals" */
  insert_audience_goals_one?: Maybe<AudienceGoals>;
  /** insert data into the table: "audience_overviews" */
  insert_audience_overviews?: Maybe<AudienceOverviewsMutationResponse>;
  /** insert a single row into the table: "audience_overviews" */
  insert_audience_overviews_one?: Maybe<AudienceOverviews>;
  /** insert data into the table: "audience_primary_metrics" */
  insert_audience_primary_metrics?: Maybe<AudiencePrimaryMetricsMutationResponse>;
  /** insert a single row into the table: "audience_primary_metrics" */
  insert_audience_primary_metrics_one?: Maybe<AudiencePrimaryMetrics>;
  /** insert data into the table: "audience_splits" */
  insert_audience_splits?: Maybe<AudienceSplitsMutationResponse>;
  /** insert a single row into the table: "audience_splits" */
  insert_audience_splits_one?: Maybe<AudienceSplits>;
  /** insert data into the table: "audience_subset_group_required_models" */
  insert_audience_subset_group_required_models?: Maybe<AudienceSubsetGroupRequiredModelsMutationResponse>;
  /** insert a single row into the table: "audience_subset_group_required_models" */
  insert_audience_subset_group_required_models_one?: Maybe<AudienceSubsetGroupRequiredModels>;
  /** insert data into the table: "audience_subset_groups" */
  insert_audience_subset_groups?: Maybe<AudienceSubsetGroupsMutationResponse>;
  /** insert a single row into the table: "audience_subset_groups" */
  insert_audience_subset_groups_one?: Maybe<AudienceSubsetGroups>;
  /** insert data into the table: "audience_subset_values" */
  insert_audience_subset_values?: Maybe<AudienceSubsetValuesMutationResponse>;
  /** insert a single row into the table: "audience_subset_values" */
  insert_audience_subset_values_one?: Maybe<AudienceSubsetValues>;
  /** insert data into the table: "audience_template_segments" */
  insert_audience_template_segments?: Maybe<AudienceTemplateSegmentsMutationResponse>;
  /** insert data into the table: "audiences_subsets" */
  insert_audiences_subsets?: Maybe<AudiencesSubsetsMutationResponse>;
  /** insert a single row into the table: "audiences_subsets" */
  insert_audiences_subsets_one?: Maybe<AudiencesSubsets>;
  /** insert data into the table: "brand_profiles" */
  insert_brand_profiles?: Maybe<BrandProfilesMutationResponse>;
  /** insert a single row into the table: "brand_profiles" */
  insert_brand_profiles_one?: Maybe<BrandProfiles>;
  /** insert data into the table: "campaign_artifacts" */
  insert_campaign_artifacts?: Maybe<CampaignArtifactsMutationResponse>;
  /** insert a single row into the table: "campaign_artifacts" */
  insert_campaign_artifacts_one?: Maybe<CampaignArtifacts>;
  /** insert data into the table: "campaign_labels" */
  insert_campaign_labels?: Maybe<CampaignLabelsMutationResponse>;
  /** insert a single row into the table: "campaign_labels" */
  insert_campaign_labels_one?: Maybe<CampaignLabels>;
  /** insert data into the table: "campaigns" */
  insert_campaigns?: Maybe<CampaignsMutationResponse>;
  /** insert a single row into the table: "campaigns" */
  insert_campaigns_one?: Maybe<Campaigns>;
  /** insert data into the table: "catalog_collections" */
  insert_catalog_collections?: Maybe<CatalogCollectionsMutationResponse>;
  /** insert a single row into the table: "catalog_collections" */
  insert_catalog_collections_one?: Maybe<CatalogCollections>;
  /** insert data into the table: "catalog_models" */
  insert_catalog_models?: Maybe<CatalogModelsMutationResponse>;
  /** insert a single row into the table: "catalog_models" */
  insert_catalog_models_one?: Maybe<CatalogModels>;
  /** insert data into the table: "cep_brand_settings" */
  insert_cep_brand_settings?: Maybe<CepBrandSettingsMutationResponse>;
  /** insert a single row into the table: "cep_brand_settings" */
  insert_cep_brand_settings_one?: Maybe<CepBrandSettings>;
  /** insert data into the table: "cep_channels" */
  insert_cep_channels?: Maybe<CepChannelsMutationResponse>;
  /** insert a single row into the table: "cep_channels" */
  insert_cep_channels_one?: Maybe<CepChannels>;
  /** insert data into the table: "cep_content_blocks" */
  insert_cep_content_blocks?: Maybe<CepContentBlocksMutationResponse>;
  /** insert a single row into the table: "cep_content_blocks" */
  insert_cep_content_blocks_one?: Maybe<CepContentBlocks>;
  /** insert data into the table: "cep_domains" */
  insert_cep_domains?: Maybe<CepDomainsMutationResponse>;
  /** insert a single row into the table: "cep_domains" */
  insert_cep_domains_one?: Maybe<CepDomains>;
  /** insert data into the table: "cep_email_template_contents" */
  insert_cep_email_template_contents?: Maybe<CepEmailTemplateContentsMutationResponse>;
  /** insert a single row into the table: "cep_email_template_contents" */
  insert_cep_email_template_contents_one?: Maybe<CepEmailTemplateContents>;
  /** insert data into the table: "cep_email_templates" */
  insert_cep_email_templates?: Maybe<CepEmailTemplatesMutationResponse>;
  /** insert a single row into the table: "cep_email_templates" */
  insert_cep_email_templates_one?: Maybe<CepEmailTemplates>;
  /** insert data into the table: "cep_locales" */
  insert_cep_locales?: Maybe<CepLocalesMutationResponse>;
  /** insert a single row into the table: "cep_locales" */
  insert_cep_locales_one?: Maybe<CepLocales>;
  /** insert data into the table: "cep_localization_settings" */
  insert_cep_localization_settings?: Maybe<CepLocalizationSettingsMutationResponse>;
  /** insert a single row into the table: "cep_localization_settings" */
  insert_cep_localization_settings_one?: Maybe<CepLocalizationSettings>;
  /** insert data into the table: "cep_providers" */
  insert_cep_providers?: Maybe<CepProvidersMutationResponse>;
  /** insert a single row into the table: "cep_providers" */
  insert_cep_providers_one?: Maybe<CepProviders>;
  /** insert data into the table: "cep_sender_identities" */
  insert_cep_sender_identities?: Maybe<CepSenderIdentitiesMutationResponse>;
  /** insert a single row into the table: "cep_sender_identities" */
  insert_cep_sender_identities_one?: Maybe<CepSenderIdentities>;
  /** insert data into the table: "cep_subscription_topic_sender_identities" */
  insert_cep_subscription_topic_sender_identities?: Maybe<CepSubscriptionTopicSenderIdentitiesMutationResponse>;
  /** insert a single row into the table: "cep_subscription_topic_sender_identities" */
  insert_cep_subscription_topic_sender_identities_one?: Maybe<CepSubscriptionTopicSenderIdentities>;
  /** insert data into the table: "cep_subscription_topics" */
  insert_cep_subscription_topics?: Maybe<CepSubscriptionTopicsMutationResponse>;
  /** insert a single row into the table: "cep_subscription_topics" */
  insert_cep_subscription_topics_one?: Maybe<CepSubscriptionTopics>;
  /** insert data into the table: "cep_suppression_list_subscription_topics" */
  insert_cep_suppression_list_subscription_topics?: Maybe<CepSuppressionListSubscriptionTopicsMutationResponse>;
  /** insert a single row into the table: "cep_suppression_list_subscription_topics" */
  insert_cep_suppression_list_subscription_topics_one?: Maybe<CepSuppressionListSubscriptionTopics>;
  /** insert data into the table: "cep_suppression_lists" */
  insert_cep_suppression_lists?: Maybe<CepSuppressionListsMutationResponse>;
  /** insert a single row into the table: "cep_suppression_lists" */
  insert_cep_suppression_lists_one?: Maybe<CepSuppressionLists>;
  /** insert data into the table: "cep_test_group_members" */
  insert_cep_test_group_members?: Maybe<CepTestGroupMembersMutationResponse>;
  /** insert a single row into the table: "cep_test_group_members" */
  insert_cep_test_group_members_one?: Maybe<CepTestGroupMembers>;
  /** insert data into the table: "cep_test_groups" */
  insert_cep_test_groups?: Maybe<CepTestGroupsMutationResponse>;
  /** insert a single row into the table: "cep_test_groups" */
  insert_cep_test_groups_one?: Maybe<CepTestGroups>;
  /** insert data into the table: "cep_workspace_config" */
  insert_cep_workspace_config?: Maybe<CepWorkspaceConfigMutationResponse>;
  /** insert a single row into the table: "cep_workspace_config" */
  insert_cep_workspace_config_one?: Maybe<CepWorkspaceConfig>;
  /** insert data into the table: "chart_cards" */
  insert_chart_cards?: Maybe<ChartCardsMutationResponse>;
  /** insert a single row into the table: "chart_cards" */
  insert_chart_cards_one?: Maybe<ChartCards>;
  /** insert data into the table: "condition_template_labels" */
  insert_condition_template_labels?: Maybe<ConditionTemplateLabelsMutationResponse>;
  /** insert a single row into the table: "condition_template_labels" */
  insert_condition_template_labels_one?: Maybe<ConditionTemplateLabels>;
  /** insert data into the table: "content_block_labels" */
  insert_content_block_labels?: Maybe<ContentBlockLabelsMutationResponse>;
  /** insert a single row into the table: "content_block_labels" */
  insert_content_block_labels_one?: Maybe<ContentBlockLabels>;
  /** insert data into the table: "content_blocks" */
  insert_content_blocks?: Maybe<ContentBlocksMutationResponse>;
  /** insert a single row into the table: "content_blocks" */
  insert_content_blocks_one?: Maybe<ContentBlocks>;
  /** insert data into the table: "content_dynamic_slot_assignments" */
  insert_content_dynamic_slot_assignments?: Maybe<ContentDynamicSlotAssignmentsMutationResponse>;
  /** insert a single row into the table: "content_dynamic_slot_assignments" */
  insert_content_dynamic_slot_assignments_one?: Maybe<ContentDynamicSlotAssignments>;
  /** insert data into the table: "content_dynamic_slot_branches" */
  insert_content_dynamic_slot_branches?: Maybe<ContentDynamicSlotBranchesMutationResponse>;
  /** insert a single row into the table: "content_dynamic_slot_branches" */
  insert_content_dynamic_slot_branches_one?: Maybe<ContentDynamicSlotBranches>;
  /** insert data into the table: "content_dynamic_slot_contents" */
  insert_content_dynamic_slot_contents?: Maybe<ContentDynamicSlotContentsMutationResponse>;
  /** insert a single row into the table: "content_dynamic_slot_contents" */
  insert_content_dynamic_slot_contents_one?: Maybe<ContentDynamicSlotContents>;
  /** insert data into the table: "content_dynamic_slot_libraries" */
  insert_content_dynamic_slot_libraries?: Maybe<ContentDynamicSlotLibrariesMutationResponse>;
  /** insert a single row into the table: "content_dynamic_slot_libraries" */
  insert_content_dynamic_slot_libraries_one?: Maybe<ContentDynamicSlotLibraries>;
  /** insert data into the table: "content_dynamic_slot_usages" */
  insert_content_dynamic_slot_usages?: Maybe<ContentDynamicSlotUsagesMutationResponse>;
  /** insert a single row into the table: "content_dynamic_slot_usages" */
  insert_content_dynamic_slot_usages_one?: Maybe<ContentDynamicSlotUsages>;
  /** insert data into the table: "content_email_variants" */
  insert_content_email_variants?: Maybe<ContentEmailVariantsMutationResponse>;
  /** insert a single row into the table: "content_email_variants" */
  insert_content_email_variants_one?: Maybe<ContentEmailVariants>;
  /** insert data into the table: "content_settings" */
  insert_content_settings?: Maybe<ContentSettingsMutationResponse>;
  /** insert a single row into the table: "content_settings" */
  insert_content_settings_one?: Maybe<ContentSettings>;
  /** insert data into the table: "content_templates" */
  insert_content_templates?: Maybe<ContentTemplatesMutationResponse>;
  /** insert a single row into the table: "content_templates" */
  insert_content_templates_one?: Maybe<ContentTemplates>;
  /** insert data into the table: "custom_agents" */
  insert_custom_agents?: Maybe<CustomAgentsMutationResponse>;
  /** insert a single row into the table: "custom_agents" */
  insert_custom_agents_one?: Maybe<CustomAgents>;
  /** insert data into the table: "dashboards" */
  insert_dashboards?: Maybe<DashboardsMutationResponse>;
  /** insert a single row into the table: "dashboards" */
  insert_dashboards_one?: Maybe<Dashboards>;
  /** insert data into the table: "datadog_credentials" */
  insert_datadog_credentials?: Maybe<DatadogCredentialsMutationResponse>;
  /** insert a single row into the table: "datadog_credentials" */
  insert_datadog_credentials_one?: Maybe<DatadogCredentials>;
  /** insert data into the table: "dbt_cloud_sync_config" */
  insert_dbt_cloud_sync_config?: Maybe<DbtCloudSyncConfigMutationResponse>;
  /** insert a single row into the table: "dbt_cloud_sync_config" */
  insert_dbt_cloud_sync_config_one?: Maybe<DbtCloudSyncConfig>;
  /** insert data into the table: "dbt_sync_config" */
  insert_dbt_sync_config?: Maybe<DbtSyncConfigMutationResponse>;
  /** insert a single row into the table: "dbt_sync_config" */
  insert_dbt_sync_config_one?: Maybe<DbtSyncConfig>;
  /** insert data into the table: "decision_engine_collections" */
  insert_decision_engine_collections?: Maybe<DecisionEngineCollectionsMutationResponse>;
  /** insert a single row into the table: "decision_engine_collections" */
  insert_decision_engine_collections_one?: Maybe<DecisionEngineCollections>;
  /** insert data into the table: "decision_engine_feature_matrices" */
  insert_decision_engine_feature_matrices?: Maybe<DecisionEngineFeatureMatricesMutationResponse>;
  /** insert a single row into the table: "decision_engine_feature_matrices" */
  insert_decision_engine_feature_matrices_one?: Maybe<DecisionEngineFeatureMatrices>;
  /** insert data into the table: "decision_engine_feature_matrix_relationships" */
  insert_decision_engine_feature_matrix_relationships?: Maybe<DecisionEngineFeatureMatrixRelationshipsMutationResponse>;
  /** insert a single row into the table: "decision_engine_feature_matrix_relationships" */
  insert_decision_engine_feature_matrix_relationships_one?: Maybe<DecisionEngineFeatureMatrixRelationships>;
  /** insert data into the table: "decision_engine_flow_experiments" */
  insert_decision_engine_flow_experiments?: Maybe<DecisionEngineFlowExperimentsMutationResponse>;
  /** insert a single row into the table: "decision_engine_flow_experiments" */
  insert_decision_engine_flow_experiments_one?: Maybe<DecisionEngineFlowExperiments>;
  /** insert data into the table: "decision_engine_flow_outcomes" */
  insert_decision_engine_flow_outcomes?: Maybe<DecisionEngineFlowOutcomesMutationResponse>;
  /** insert a single row into the table: "decision_engine_flow_outcomes" */
  insert_decision_engine_flow_outcomes_one?: Maybe<DecisionEngineFlowOutcomes>;
  /** insert data into the table: "decision_engine_flow_tags" */
  insert_decision_engine_flow_tags?: Maybe<DecisionEngineFlowTagsMutationResponse>;
  /** insert a single row into the table: "decision_engine_flow_tags" */
  insert_decision_engine_flow_tags_one?: Maybe<DecisionEngineFlowTags>;
  /** insert data into the table: "decision_engine_message_collections" */
  insert_decision_engine_message_collections?: Maybe<DecisionEngineMessageCollectionsMutationResponse>;
  /** insert a single row into the table: "decision_engine_message_collections" */
  insert_decision_engine_message_collections_one?: Maybe<DecisionEngineMessageCollections>;
  /** insert data into the table: "decision_engine_message_variant_suggestions" */
  insert_decision_engine_message_variant_suggestions?: Maybe<DecisionEngineMessageVariantSuggestionsMutationResponse>;
  /** insert a single row into the table: "decision_engine_message_variant_suggestions" */
  insert_decision_engine_message_variant_suggestions_one?: Maybe<DecisionEngineMessageVariantSuggestions>;
  /** insert data into the table: "decision_engine_model_outcomes" */
  insert_decision_engine_model_outcomes?: Maybe<DecisionEngineModelOutcomesMutationResponse>;
  /** insert a single row into the table: "decision_engine_model_outcomes" */
  insert_decision_engine_model_outcomes_one?: Maybe<DecisionEngineModelOutcomes>;
  /** insert data into the table: "decision_engine_models" */
  insert_decision_engine_models?: Maybe<DecisionEngineModelsMutationResponse>;
  /** insert a single row into the table: "decision_engine_models" */
  insert_decision_engine_models_one?: Maybe<DecisionEngineModels>;
  /** insert data into the table: "decision_engine_offers" */
  insert_decision_engine_offers?: Maybe<DecisionEngineOffersMutationResponse>;
  /** insert a single row into the table: "decision_engine_offers" */
  insert_decision_engine_offers_one?: Maybe<DecisionEngineOffers>;
  /** insert data into the table: "decision_engine_outcomes" */
  insert_decision_engine_outcomes?: Maybe<DecisionEngineOutcomesMutationResponse>;
  /** insert a single row into the table: "decision_engine_outcomes" */
  insert_decision_engine_outcomes_one?: Maybe<DecisionEngineOutcomes>;
  /** insert data into the table: "decision_engine_send_events" */
  insert_decision_engine_send_events?: Maybe<DecisionEngineSendEventsMutationResponse>;
  /** insert a single row into the table: "decision_engine_send_events" */
  insert_decision_engine_send_events_one?: Maybe<DecisionEngineSendEvents>;
  /** insert data into the table: "decision_engine_splits" */
  insert_decision_engine_splits?: Maybe<DecisionEngineSplitsMutationResponse>;
  /** insert a single row into the table: "decision_engine_splits" */
  insert_decision_engine_splits_one?: Maybe<DecisionEngineSplits>;
  /** insert data into the table: "decision_engines" */
  insert_decision_engines?: Maybe<DecisionEnginesMutationResponse>;
  /** insert a single row into the table: "decision_engines" */
  insert_decision_engines_one?: Maybe<DecisionEngines>;
  /** insert data into the table: "deliverability_feeds" */
  insert_deliverability_feeds?: Maybe<DeliverabilityFeedsMutationResponse>;
  /** insert a single row into the table: "deliverability_feeds" */
  insert_deliverability_feeds_one?: Maybe<DeliverabilityFeeds>;
  /** insert data into the table: "destination_instance_splits" */
  insert_destination_instance_splits?: Maybe<DestinationInstanceSplitsMutationResponse>;
  /** insert a single row into the table: "destination_instance_splits" */
  insert_destination_instance_splits_one?: Maybe<DestinationInstanceSplits>;
  /** insert data into the table: "destination_instances" */
  insert_destination_instances?: Maybe<DestinationInstancesMutationResponse>;
  /** insert a single row into the table: "destination_instances" */
  insert_destination_instances_one?: Maybe<DestinationInstances>;
  /** insert data into the table: "destination_rules" */
  insert_destination_rules?: Maybe<DestinationRulesMutationResponse>;
  /** insert a single row into the table: "destination_rules" */
  insert_destination_rules_one?: Maybe<DestinationRules>;
  /** insert data into the table: "direct_model_relationships" */
  insert_direct_model_relationships?: Maybe<DirectModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "direct_model_relationships" */
  insert_direct_model_relationships_one?: Maybe<DirectModelRelationships>;
  /** insert data into the table: "email_template_labels" */
  insert_email_template_labels?: Maybe<EmailTemplateLabelsMutationResponse>;
  /** insert a single row into the table: "email_template_labels" */
  insert_email_template_labels_one?: Maybe<EmailTemplateLabels>;
  /** insert data into the table: "etl_connections" */
  insert_etl_connections?: Maybe<EtlConnectionsMutationResponse>;
  /** insert a single row into the table: "etl_connections" */
  insert_etl_connections_one?: Maybe<EtlConnections>;
  /** insert data into the table: "event_components" */
  insert_event_components?: Maybe<EventComponentsMutationResponse>;
  /** insert data into the table: "event_components_conditions" */
  insert_event_components_conditions?: Maybe<EventComponentsConditionsMutationResponse>;
  /** insert a single row into the table: "event_components_conditions" */
  insert_event_components_conditions_one?: Maybe<EventComponentsConditions>;
  /** insert data into the table: "event_components_join" */
  insert_event_components_join?: Maybe<EventComponentsJoinMutationResponse>;
  /** insert a single row into the table: "event_components_join" */
  insert_event_components_join_one?: Maybe<EventComponentsJoin>;
  /** insert a single row into the table: "event_components" */
  insert_event_components_one?: Maybe<EventComponents>;
  /** insert data into the table: "event_contracts" */
  insert_event_contracts?: Maybe<EventContractsMutationResponse>;
  /** insert a single row into the table: "event_contracts" */
  insert_event_contracts_one?: Maybe<EventContracts>;
  /** insert data into the table: "event_contracts_schema" */
  insert_event_contracts_schema?: Maybe<EventContractsSchemaMutationResponse>;
  /** insert a single row into the table: "event_contracts_schema" */
  insert_event_contracts_schema_one?: Maybe<EventContractsSchema>;
  /** insert data into the table: "event_forwarding_destination_grants" */
  insert_event_forwarding_destination_grants?: Maybe<EventForwardingDestinationGrantsMutationResponse>;
  /** insert a single row into the table: "event_forwarding_destination_grants" */
  insert_event_forwarding_destination_grants_one?: Maybe<EventForwardingDestinationGrants>;
  /** insert data into the table: "event_forwarding_syncs" */
  insert_event_forwarding_syncs?: Maybe<EventForwardingSyncsMutationResponse>;
  /** insert a single row into the table: "event_forwarding_syncs" */
  insert_event_forwarding_syncs_one?: Maybe<EventForwardingSyncs>;
  /** insert data into the table: "event_model_event_sources" */
  insert_event_model_event_sources?: Maybe<EventModelEventSourcesMutationResponse>;
  /** insert a single row into the table: "event_model_event_sources" */
  insert_event_model_event_sources_one?: Maybe<EventModelEventSources>;
  /** insert data into the table: "event_models" */
  insert_event_models?: Maybe<EventModelsMutationResponse>;
  /** insert a single row into the table: "event_models" */
  insert_event_models_one?: Maybe<EventModels>;
  /** insert data into the table: "event_plan_grants" */
  insert_event_plan_grants?: Maybe<EventPlanGrantsMutationResponse>;
  /** insert a single row into the table: "event_plan_grants" */
  insert_event_plan_grants_one?: Maybe<EventPlanGrants>;
  /** insert data into the table: "event_plans" */
  insert_event_plans?: Maybe<EventPlansMutationResponse>;
  /** insert a single row into the table: "event_plans" */
  insert_event_plans_one?: Maybe<EventPlans>;
  /** insert data into the table: "event_schema_components" */
  insert_event_schema_components?: Maybe<EventSchemaComponentsMutationResponse>;
  /** insert a single row into the table: "event_schema_components" */
  insert_event_schema_components_one?: Maybe<EventSchemaComponents>;
  /** insert data into the table: "event_schemas" */
  insert_event_schemas?: Maybe<EventSchemasMutationResponse>;
  /** insert a single row into the table: "event_schemas" */
  insert_event_schemas_one?: Maybe<EventSchemas>;
  /** insert data into the table: "event_source_contracts" */
  insert_event_source_contracts?: Maybe<EventSourceContractsMutationResponse>;
  /** insert a single row into the table: "event_source_contracts" */
  insert_event_source_contracts_one?: Maybe<EventSourceContracts>;
  /** insert data into the table: "event_source_grants" */
  insert_event_source_grants?: Maybe<EventSourceGrantsMutationResponse>;
  /** insert a single row into the table: "event_source_grants" */
  insert_event_source_grants_one?: Maybe<EventSourceGrants>;
  /** insert data into the table: "event_warehouse_destination_grants" */
  insert_event_warehouse_destination_grants?: Maybe<EventWarehouseDestinationGrantsMutationResponse>;
  /** insert a single row into the table: "event_warehouse_destination_grants" */
  insert_event_warehouse_destination_grants_one?: Maybe<EventWarehouseDestinationGrants>;
  /** insert data into the table: "experiment_metrics" */
  insert_experiment_metrics?: Maybe<ExperimentMetricsMutationResponse>;
  /** insert a single row into the table: "experiment_metrics" */
  insert_experiment_metrics_one?: Maybe<ExperimentMetrics>;
  /** insert data into the table: "experiments" */
  insert_experiments?: Maybe<ExperimentsMutationResponse>;
  /** insert a single row into the table: "experiments" */
  insert_experiments_one?: Maybe<Experiments>;
  /** insert data into the table: "external_buckets" */
  insert_external_buckets?: Maybe<ExternalBucketsMutationResponse>;
  /** insert a single row into the table: "external_buckets" */
  insert_external_buckets_one?: Maybe<ExternalBuckets>;
  /** insert data into the table: "folders" */
  insert_folders?: Maybe<FoldersMutationResponse>;
  /** insert a single row into the table: "folders" */
  insert_folders_one?: Maybe<Folders>;
  /** insert data into the table: "function_grants" */
  insert_function_grants?: Maybe<FunctionGrantsMutationResponse>;
  /** insert a single row into the table: "function_grants" */
  insert_function_grants_one?: Maybe<FunctionGrants>;
  /** insert data into the table: "function_resources" */
  insert_function_resources?: Maybe<FunctionResourcesMutationResponse>;
  /** insert a single row into the table: "function_resources" */
  insert_function_resources_one?: Maybe<FunctionResources>;
  /** insert data into the table: "function_settings" */
  insert_function_settings?: Maybe<FunctionSettingsMutationResponse>;
  /** insert a single row into the table: "function_settings" */
  insert_function_settings_one?: Maybe<FunctionSettings>;
  /** insert data into the table: "goals" */
  insert_goals?: Maybe<GoalsMutationResponse>;
  /** insert data into the table: "goals_attribution_methods" */
  insert_goals_attribution_methods?: Maybe<GoalsAttributionMethodsMutationResponse>;
  /** insert a single row into the table: "goals_attribution_methods" */
  insert_goals_attribution_methods_one?: Maybe<GoalsAttributionMethods>;
  /** insert a single row into the table: "goals" */
  insert_goals_one?: Maybe<Goals>;
  /** insert data into the table: "initiative_goals" */
  insert_initiative_goals?: Maybe<InitiativeGoalsMutationResponse>;
  /** insert a single row into the table: "initiative_goals" */
  insert_initiative_goals_one?: Maybe<InitiativeGoals>;
  /** insert data into the table: "interaction_models" */
  insert_interaction_models?: Maybe<InteractionModelsMutationResponse>;
  /** insert a single row into the table: "interaction_models" */
  insert_interaction_models_one?: Maybe<InteractionModels>;
  /** insert data into the table: "journey_labels" */
  insert_journey_labels?: Maybe<JourneyLabelsMutationResponse>;
  /** insert a single row into the table: "journey_labels" */
  insert_journey_labels_one?: Maybe<JourneyLabels>;
  /** insert data into the table: "journey_simulations" */
  insert_journey_simulations?: Maybe<JourneySimulationsMutationResponse>;
  /** insert a single row into the table: "journey_simulations" */
  insert_journey_simulations_one?: Maybe<JourneySimulations>;
  /** insert data into the table: "journey_templates" */
  insert_journey_templates?: Maybe<JourneyTemplatesMutationResponse>;
  /** insert a single row into the table: "journey_templates" */
  insert_journey_templates_one?: Maybe<JourneyTemplates>;
  /** insert data into the table: "journeys" */
  insert_journeys?: Maybe<JourneysMutationResponse>;
  /** insert a single row into the table: "journeys" */
  insert_journeys_one?: Maybe<Journeys>;
  /** insert data into the table: "label_groups" */
  insert_label_groups?: Maybe<LabelGroupsMutationResponse>;
  /** insert a single row into the table: "label_groups" */
  insert_label_groups_one?: Maybe<LabelGroups>;
  /** insert data into the table: "labels" */
  insert_labels?: Maybe<LabelsMutationResponse>;
  /** insert a single row into the table: "labels" */
  insert_labels_one?: Maybe<Labels>;
  /** insert data into the table: "lcm_message_candidates" */
  insert_lcm_message_candidates?: Maybe<LcmMessageCandidatesMutationResponse>;
  /** insert a single row into the table: "lcm_message_candidates" */
  insert_lcm_message_candidates_one?: Maybe<LcmMessageCandidates>;
  /** insert data into the table: "lcm_message_plans" */
  insert_lcm_message_plans?: Maybe<LcmMessagePlansMutationResponse>;
  /** insert a single row into the table: "lcm_message_plans" */
  insert_lcm_message_plans_one?: Maybe<LcmMessagePlans>;
  /** insert data into the table: "looker_credentials" */
  insert_looker_credentials?: Maybe<LookerCredentialsMutationResponse>;
  /** insert a single row into the table: "looker_credentials" */
  insert_looker_credentials_one?: Maybe<LookerCredentials>;
  /** insert data into the table: "matchboosting_config" */
  insert_matchboosting_config?: Maybe<MatchboostingConfigMutationResponse>;
  /** insert a single row into the table: "matchboosting_config" */
  insert_matchboosting_config_one?: Maybe<MatchboostingConfig>;
  /** insert data into the table: "matchboosting_workspace_config" */
  insert_matchboosting_workspace_config?: Maybe<MatchboostingWorkspaceConfigMutationResponse>;
  /** insert a single row into the table: "matchboosting_workspace_config" */
  insert_matchboosting_workspace_config_one?: Maybe<MatchboostingWorkspaceConfig>;
  /** insert data into the table: "message_contents" */
  insert_message_contents?: Maybe<MessageContentsMutationResponse>;
  /** insert data into the table: "message_contents_metadata" */
  insert_message_contents_metadata?: Maybe<MessageContentsMetadataMutationResponse>;
  /** insert a single row into the table: "message_contents_metadata" */
  insert_message_contents_metadata_one?: Maybe<MessageContentsMetadata>;
  /** insert a single row into the table: "message_contents" */
  insert_message_contents_one?: Maybe<MessageContents>;
  /** insert data into the table: "message_experiments" */
  insert_message_experiments?: Maybe<MessageExperimentsMutationResponse>;
  /** insert a single row into the table: "message_experiments" */
  insert_message_experiments_one?: Maybe<MessageExperiments>;
  /** insert data into the table: "message_labels" */
  insert_message_labels?: Maybe<MessageLabelsMutationResponse>;
  /** insert a single row into the table: "message_labels" */
  insert_message_labels_one?: Maybe<MessageLabels>;
  /** insert data into the table: "message_push_apps" */
  insert_message_push_apps?: Maybe<MessagePushAppsMutationResponse>;
  /** insert a single row into the table: "message_push_apps" */
  insert_message_push_apps_one?: Maybe<MessagePushApps>;
  /** insert data into the table: "message_variant_arm" */
  insert_message_variant_arm?: Maybe<MessageVariantArmMutationResponse>;
  /** insert a single row into the table: "message_variant_arm" */
  insert_message_variant_arm_one?: Maybe<MessageVariantArm>;
  /** insert data into the table: "messages" */
  insert_messages?: Maybe<MessagesMutationResponse>;
  /** insert a single row into the table: "messages" */
  insert_messages_one?: Maybe<Messages>;
  /** insert data into the table: "model_columns" */
  insert_model_columns?: Maybe<ModelColumnsMutationResponse>;
  /** insert a single row into the table: "model_columns" */
  insert_model_columns_one?: Maybe<ModelColumns>;
  /** insert data into the table: "model_relationships" */
  insert_model_relationships?: Maybe<ModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "model_relationships" */
  insert_model_relationships_one?: Maybe<ModelRelationships>;
  /** insert data into the table: "monitor_condition_templates" */
  insert_monitor_condition_templates?: Maybe<MonitorConditionTemplatesMutationResponse>;
  /** insert a single row into the table: "monitor_condition_templates" */
  insert_monitor_condition_templates_one?: Maybe<MonitorConditionTemplates>;
  /** insert data into the table: "notification_channel_templates" */
  insert_notification_channel_templates?: Maybe<NotificationChannelTemplatesMutationResponse>;
  /** insert a single row into the table: "notification_channel_templates" */
  insert_notification_channel_templates_one?: Maybe<NotificationChannelTemplates>;
  /** insert data into the table: "object_schemas" */
  insert_object_schemas?: Maybe<ObjectSchemasMutationResponse>;
  /** insert a single row into the table: "object_schemas" */
  insert_object_schemas_one?: Maybe<ObjectSchemas>;
  /** insert data into the table: "pagerduty_credentials" */
  insert_pagerduty_credentials?: Maybe<PagerdutyCredentialsMutationResponse>;
  /** insert a single row into the table: "pagerduty_credentials" */
  insert_pagerduty_credentials_one?: Maybe<PagerdutyCredentials>;
  /** insert data into the table: "push_apps" */
  insert_push_apps?: Maybe<PushAppsMutationResponse>;
  /** insert a single row into the table: "push_apps" */
  insert_push_apps_one?: Maybe<PushApps>;
  /** insert data into the table: "push_config" */
  insert_push_config?: Maybe<PushConfigMutationResponse>;
  /** insert a single row into the table: "push_config" */
  insert_push_config_one?: Maybe<PushConfig>;
  /** insert data into the table: "realtime_audience_sync_segments" */
  insert_realtime_audience_sync_segments?: Maybe<RealtimeAudienceSyncSegmentsMutationResponse>;
  /** insert a single row into the table: "realtime_audience_sync_segments" */
  insert_realtime_audience_sync_segments_one?: Maybe<RealtimeAudienceSyncSegments>;
  /** insert data into the table: "realtime_audience_syncs" */
  insert_realtime_audience_syncs?: Maybe<RealtimeAudienceSyncsMutationResponse>;
  /** insert a single row into the table: "realtime_audience_syncs" */
  insert_realtime_audience_syncs_one?: Maybe<RealtimeAudienceSyncs>;
  /** insert data into the table: "relationship_references" */
  insert_relationship_references?: Maybe<RelationshipReferencesMutationResponse>;
  /** insert a single row into the table: "relationship_references" */
  insert_relationship_references_one?: Maybe<RelationshipReferences>;
  /** insert data into the table: "relationships" */
  insert_relationships?: Maybe<RelationshipsMutationResponse>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: Maybe<Relationships>;
  /** insert data into the table: "resource_interactions" */
  insert_resource_interactions?: Maybe<ResourceInteractionsMutationResponse>;
  /** insert a single row into the table: "resource_interactions" */
  insert_resource_interactions_one?: Maybe<ResourceInteractions>;
  /** insert data into the table: "resource_monitor_conditions" */
  insert_resource_monitor_conditions?: Maybe<ResourceMonitorConditionsMutationResponse>;
  /** insert a single row into the table: "resource_monitor_conditions" */
  insert_resource_monitor_conditions_one?: Maybe<ResourceMonitorConditions>;
  /** insert data into the table: "resource_notification_channels" */
  insert_resource_notification_channels?: Maybe<ResourceNotificationChannelsMutationResponse>;
  /** insert a single row into the table: "resource_notification_channels" */
  insert_resource_notification_channels_one?: Maybe<ResourceNotificationChannels>;
  /** insert data into the table: "resource_to_monitor_condition_type" */
  insert_resource_to_monitor_condition_type?: Maybe<ResourceToMonitorConditionTypeMutationResponse>;
  /** insert a single row into the table: "resource_to_monitor_condition_type" */
  insert_resource_to_monitor_condition_type_one?: Maybe<ResourceToMonitorConditionType>;
  /** insert data into the table: "resource_views" */
  insert_resource_views?: Maybe<ResourceViewsMutationResponse>;
  /** insert a single row into the table: "resource_views" */
  insert_resource_views_one?: Maybe<ResourceViews>;
  /** insert data into the table: "sampled_segments" */
  insert_sampled_segments?: Maybe<SampledSegmentsMutationResponse>;
  /** insert a single row into the table: "sampled_segments" */
  insert_sampled_segments_one?: Maybe<SampledSegments>;
  /** insert data into the table: "saved_analytics_charts" */
  insert_saved_analytics_charts?: Maybe<SavedAnalyticsChartsMutationResponse>;
  /** insert data into the table: "saved_analytics_charts_cohorts" */
  insert_saved_analytics_charts_cohorts?: Maybe<SavedAnalyticsChartsCohortsMutationResponse>;
  /** insert a single row into the table: "saved_analytics_charts_cohorts" */
  insert_saved_analytics_charts_cohorts_one?: Maybe<SavedAnalyticsChartsCohorts>;
  /** insert data into the table: "saved_analytics_charts_funnel_stages" */
  insert_saved_analytics_charts_funnel_stages?: Maybe<SavedAnalyticsChartsFunnelStagesMutationResponse>;
  /** insert a single row into the table: "saved_analytics_charts_funnel_stages" */
  insert_saved_analytics_charts_funnel_stages_one?: Maybe<SavedAnalyticsChartsFunnelStages>;
  /** insert data into the table: "saved_analytics_charts_goals" */
  insert_saved_analytics_charts_goals?: Maybe<SavedAnalyticsChartsGoalsMutationResponse>;
  /** insert a single row into the table: "saved_analytics_charts_goals" */
  insert_saved_analytics_charts_goals_one?: Maybe<SavedAnalyticsChartsGoals>;
  /** insert a single row into the table: "saved_analytics_charts" */
  insert_saved_analytics_charts_one?: Maybe<SavedAnalyticsCharts>;
  /** insert data into the table: "saved_campaign_views" */
  insert_saved_campaign_views?: Maybe<SavedCampaignViewsMutationResponse>;
  /** insert data into the table: "saved_campaign_views_goals" */
  insert_saved_campaign_views_goals?: Maybe<SavedCampaignViewsGoalsMutationResponse>;
  /** insert a single row into the table: "saved_campaign_views_goals" */
  insert_saved_campaign_views_goals_one?: Maybe<SavedCampaignViewsGoals>;
  /** insert a single row into the table: "saved_campaign_views" */
  insert_saved_campaign_views_one?: Maybe<SavedCampaignViews>;
  /** insert data into the table: "saved_queries" */
  insert_saved_queries?: Maybe<SavedQueriesMutationResponse>;
  /** insert a single row into the table: "saved_queries" */
  insert_saved_queries_one?: Maybe<SavedQueries>;
  /** insert data into the table: "segments" */
  insert_segments?: Maybe<SegmentsMutationResponse>;
  /** insert a single row into the table: "segments" */
  insert_segments_one?: Maybe<Segments>;
  /** insert data into the table: "space_subset_grants" */
  insert_space_subset_grants?: Maybe<SpaceSubsetGrantsMutationResponse>;
  /** insert a single row into the table: "space_subset_grants" */
  insert_space_subset_grants_one?: Maybe<SpaceSubsetGrants>;
  /** insert data into the table: "space_sync_templates" */
  insert_space_sync_templates?: Maybe<SpaceSyncTemplatesMutationResponse>;
  /** insert a single row into the table: "space_sync_templates" */
  insert_space_sync_templates_one?: Maybe<SpaceSyncTemplates>;
  /** insert data into the table: "space_user_groups" */
  insert_space_user_groups?: Maybe<SpaceUserGroupsMutationResponse>;
  /** insert a single row into the table: "space_user_groups" */
  insert_space_user_groups_one?: Maybe<SpaceUserGroups>;
  /** insert data into the table: "spaces" */
  insert_spaces?: Maybe<SpacesMutationResponse>;
  /** insert a single row into the table: "spaces" */
  insert_spaces_one?: Maybe<Spaces>;
  /** insert data into the table: "sso_group_user_groups" */
  insert_sso_group_user_groups?: Maybe<SsoGroupUserGroupsMutationResponse>;
  /** insert a single row into the table: "sso_group_user_groups" */
  insert_sso_group_user_groups_one?: Maybe<SsoGroupUserGroups>;
  /** insert data into the table: "support_access_grant" */
  insert_support_access_grant?: Maybe<SupportAccessGrantMutationResponse>;
  /** insert a single row into the table: "support_access_grant" */
  insert_support_access_grant_one?: Maybe<SupportAccessGrant>;
  /** insert data into the table: "sync_sequence_members" */
  insert_sync_sequence_members?: Maybe<SyncSequenceMembersMutationResponse>;
  /** insert a single row into the table: "sync_sequence_members" */
  insert_sync_sequence_members_one?: Maybe<SyncSequenceMembers>;
  /** insert data into the table: "sync_sequences" */
  insert_sync_sequences?: Maybe<SyncSequencesMutationResponse>;
  /** insert a single row into the table: "sync_sequences" */
  insert_sync_sequences_one?: Maybe<SyncSequences>;
  /** insert data into the table: "sync_templates" */
  insert_sync_templates?: Maybe<SyncTemplatesMutationResponse>;
  /** insert a single row into the table: "sync_templates" */
  insert_sync_templates_one?: Maybe<SyncTemplates>;
  /** insert data into the table: "through_model_relationships" */
  insert_through_model_relationships?: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** insert a single row into the table: "through_model_relationships" */
  insert_through_model_relationships_one?: Maybe<ThroughModelRelationships>;
  /** insert data into the table: "tracked_audience_list_audiences" */
  insert_tracked_audience_list_audiences?: Maybe<TrackedAudienceListAudiencesMutationResponse>;
  /** insert a single row into the table: "tracked_audience_list_audiences" */
  insert_tracked_audience_list_audiences_one?: Maybe<TrackedAudienceListAudiences>;
  /** insert data into the table: "trait_definitions" */
  insert_trait_definitions?: Maybe<TraitDefinitionsMutationResponse>;
  /** insert a single row into the table: "trait_definitions" */
  insert_trait_definitions_one?: Maybe<TraitDefinitions>;
  /** insert data into the table: "tunnels" */
  insert_tunnels?: Maybe<TunnelsMutationResponse>;
  /** insert a single row into the table: "tunnels" */
  insert_tunnels_one?: Maybe<Tunnels>;
  /** insert data into the table: "user_group_grants" */
  insert_user_group_grants?: Maybe<UserGroupGrantsMutationResponse>;
  /** insert a single row into the table: "user_group_grants" */
  insert_user_group_grants_one?: Maybe<UserGroupGrants>;
  /** insert data into the table: "user_group_members" */
  insert_user_group_members?: Maybe<UserGroupMembersMutationResponse>;
  /** insert a single row into the table: "user_group_members" */
  insert_user_group_members_one?: Maybe<UserGroupMembers>;
  /** insert data into the table: "user_group_subset_grants" */
  insert_user_group_subset_grants?: Maybe<UserGroupSubsetGrantsMutationResponse>;
  /** insert a single row into the table: "user_group_subset_grants" */
  insert_user_group_subset_grants_one?: Maybe<UserGroupSubsetGrants>;
  /** insert data into the table: "user_group_workspaces" */
  insert_user_group_workspaces?: Maybe<UserGroupWorkspacesMutationResponse>;
  /** insert a single row into the table: "user_group_workspaces" */
  insert_user_group_workspaces_one?: Maybe<UserGroupWorkspaces>;
  /** insert data into the table: "user_groups" */
  insert_user_groups?: Maybe<UserGroupsMutationResponse>;
  /** insert a single row into the table: "user_groups" */
  insert_user_groups_one?: Maybe<UserGroups>;
  /** insert data into the table: "workspace_notification_channels" */
  insert_workspace_notification_channels?: Maybe<WorkspaceNotificationChannelsMutationResponse>;
  /** insert a single row into the table: "workspace_notification_channels" */
  insert_workspace_notification_channels_one?: Maybe<WorkspaceNotificationChannels>;
  invokeWorkspaceFunctionTester: InvokeWorkspaceFunctionTesterResponse;
  launchAds: LaunchAdsResponse;
  /** Licenses the images and returns their catalog ids, in order. */
  licenseGettyImages: Array<Scalars['String']>;
  /** With a taskId the object attaches to that task instead of the project. */
  linkAmpProjectWork: AmpProjectLinkResult;
  /** Links a campaign to an Asana task, replacing any existing link. */
  linkAsanaTask?: Maybe<AsanaTaskDetail>;
  /**
   * Makes a WhatsApp message send a library template in place of its own.
   * Allowed once, while the campaign is a draft and before the message has
   * content.
   */
  linkCepWhatsAppTemplate: CepWhatsAppTemplateLinkResult;
  linkDestinations: LinkDestinationsResponse;
  /**
   * Link an existing Lifecycle Studio email to a Native Delivery email message
   * (agent-generate flow and the "Choose existing" picker). Gated by the
   * lcmLinkedNdContent feature flag.
   */
  linkExistingContentEmail: LinkExistingContentEmailResult;
  linkSources: LinkConnectionsResponse;
  manuallyEnqueuePredictiveTraitsJob: ManuallyEnqueuePredictiveTraitsJobResult;
  /**
   * Marks every ad thread the caller still has unread as read, across the whole
   * workspace, and returns how many were marked. Marking a single thread read
   * is a Hasura upsert on asset_comment_thread_reads; this exists because
   * "all of them" is one set-based write rather than a row the client can name.
   */
  markAllAssetCommentThreadsRead: Scalars['Int'];
  /**
   * Marks the given partitions dirty (or none for all partitions) so the next
   * read enqueues a rebuild.
   */
  markLineagePartitionsDirty: LineageMarkDirtyResult;
  migrateV1Alerts: AlertMigrationResult;
  modifyModelColumns?: Maybe<ModifyModelColumnsResponse>;
  moveAmpCanvasNode: AmpNodeWriteResult;
  /** Moves a file into a folder, to the top level when folderId is null, or into Drafts when drafts is true. Canvases can't go in Drafts. */
  moveAmpFile: AmpFile;
  /** Moves a parent task and its subtasks to another project using a status from its workflow. */
  moveAmpTaskToProject: AmpChangeResult;
  /** The session the file's editor opens with, created on first open when the file has none. */
  openAmpFileEditorSession: Scalars['ID'];
  partnerConnectLinkWorkspace: Scalars['Int'];
  pauseFivetranAgentSync: FivetranAgentSyncResponse;
  /** Render a treatment's template against selected (or auto-sampled) products; results land on ad_studio_treatments.preview. */
  previewTreatment: TreatmentPreviewJob;
  promoteAdStudioIdea: PromoteAdStudioIdeaResponse;
  promoteContentNodeToPublic: PromoteContentNodeToPublicResult;
  promoteFigmaImportDraft: PromoteFigmaImportDraftResult;
  promoteReportDraft: ReportScheduleContentMutationResponse;
  /**
   * Staff-only. Promote a workspace skill into the GLOBAL, Hightouch-managed
   * store, copying its current version into the dedicated managed tables. The
   * managed skill then becomes visible read-only to every workspace. Operates on
   * the global managed store, not the caller's per-workspace entities.
   */
  promoteSkillToManaged: AgenticSettingsEntity;
  /**
   * Publish the staged draft: point published_version / published_metadata_version
   * at the staged content and metadata versions, and clear the corresponding
   * drafts. Each lane advances only when its version is provided
   */
  publishMessageContentDraft: PublishMessageDraftResult;
  publishStagedJourney: PublishStagedJourneyOutput;
  purgeWorkspacePredictiveTraitsQueue: PurgeWorkspacePredictiveTraitsQueueResult;
  queueAdForLaunch: QueueAdForLaunchResponse;
  queueEmailBestPracticeSession: QueueEmailBestPracticeSessionResponse;
  queueMultipleAdsForLaunch: QueueMultipleAdsForLaunchResponse;
  /**
   * Set the caller's rating on an insight card, replacing any earlier one.
   * A blank `reason` is treated as none, and omitting it drops a stored
   * reason. Returns the saved rating.
   */
  rateCampaignInsight: CampaignInsightRating;
  /**
   * Without userId, every member of a group reviewer is asked. commentId is the
   * reply on the task that asks, shown with the request.
   */
  reRequestAmpTaskReview: AmpMutationResult;
  recalculateEmbeddings: RecalculateEmbeddingsResult;
  recalculateMessageEmbedding: Scalars['Boolean'];
  recalculateMessageVariableVariantEmbeddings: Scalars['Boolean'];
  recomputeSuppressionListSize: SuppressionListSizeResult;
  /**
   * Staff-only manual trigger to regenerate a missing report card summary for
   * one report run.
   */
  reconcileReportCardSummary: BackgroundJobResponse;
  /** Lists the connector's tools again from the connected system. Only for a connector that discovers its tools. */
  refreshAgentConnectorTools: AgentConnector;
  /**
   * Refresh a copy-examples entity by re-running the ingestion agent end-to-end
   * against its saved source (fivetran or warehouse). Returns the launched run;
   * the refreshed examples land as a review the user approves. Manual sources
   * can't be refreshed.
   */
  refreshAgenticSettingsCopyExamples: CopyReferencesIngestionRun;
  refreshAllCepManagedModels: RefreshAllCepManagedModelsResult;
  refreshCepProfileCache: RefreshCepProfileCacheResult;
  /** Re-scrapes stale accounts and queues a report run. */
  refreshCompetitor: Competitor;
  refreshConnectionRoles: ConnectionRoleCacheStatus;
  refreshDecisionEngineChannelSyncs: DecisionEngineResult;
  refreshDecisionEngineChannelUserColumns: DecisionEngineResult;
  /**
   * Customer-facing refresh of stored eligible-user counts (audience_size) for
   * a flow's messages, or a single message when messageId is given. Nulls the
   * stored values (UI shows Pending) and enqueues the recompute job.
   */
  refreshDecisionEngineFlowAudienceSizes: RefreshDecisionEngineFlowAudienceSizesResponse;
  refreshEspCatalog: Array<EspCatalogRefreshJobResult>;
  /** Rereads the connection from Fivetran's REST API. */
  refreshFivetranConnection: FivetranAgentSyncResponse;
  refreshMessageStats: Scalars['Boolean'];
  refreshModelConfiguration: UpdateModelColumnsResponse;
  /** Refreshes the flow's native delivery snapshot now instead of at the next hourly tick, then wakes its linked native delivery messages to load and send what is due. Returns the number of refreshes enqueued: 0 when no active native delivery campaign is linked to the flow. */
  refreshNativeDeliveryAgentFlow: Scalars['Int'];
  /** Precomputes the Reporting page into the CEP Redis cache. */
  refreshReportingCache: RefreshReportingCacheStatus;
  refreshSignals: RefreshSignalsResponse;
  /**
   * Force-regenerate agent suggestion batches for the authenticated user's
   * workspace. Restricted to Hightouch staff. End users do not call this —
   * the scheduler keeps suggestions fresh.
   *
   * systemPromptOverride replaces the default suggestion-batch prompt for
   * every per-pair LLM call in the resulting job.
   */
  regenerateAgentSuggestionBatches: BackgroundJobResponse;
  regenerateSizeVariant: RegenerateSizeVariantResponse;
  rejectIdrChangePlan: Scalars['Boolean'];
  relaunchMetaAd: RelaunchMetaAdResponse;
  removeAdFromLaunchQueue: RemoveAdFromLaunchQueueResponse;
  removeAmpCanvasNode: AmpNodeWriteResult;
  removeAmpTaskBlocker: AmpChangeResult;
  /** Pass exactly one of userId or userGroupId. */
  removeAmpTaskReviewer: AmpChangeResult;
  removeCompetitorAccount: Competitor;
  removeFlowFromDecisionEngineArbitrationGroup: DecisionEngineArbitrationGroup;
  removeInspirationBoardAd: InspirationBoard;
  /**
   * Remove a day's cached interaction files from the latest manifest.
   * 'skip' deletes the day key so the day is not re-cached; 'reseed' empties
   * the day so the seeder re-fetches it from the warehouse on the next run.
   * Inserts a new manifest revision rather than editing in place, so the
   * prior state is preserved in history.
   */
  removeManifestDay: RemoveManifestDayResult;
  /** Clears the current organization's logo, so each workspace's nav shows its initial again. */
  removeOrganizationLogo: Scalars['Boolean'];
  /**
   * Remove databases from the share (mark removing + enqueue converge). Siblings
   * stay. Null when that removed the last database and the mirror row is gone —
   * same "no mirror" the warehouseShareMirror query returns.
   */
  removeSharedDatabases?: Maybe<WarehouseShareMirror>;
  /** Drop products from a treatment's ready preview without re-rendering the rest. Returns the treatment id. */
  removeTreatmentPreviewProducts: Scalars['ID'];
  renameAdInsightsSavedView: Scalars['ID'];
  renameCompetitor: Competitor;
  renameInspirationBoard: InspirationBoard;
  renameMessagePlan: RenameMessagePlanResponse;
  renameSendInsightChart: DecisionEngineResult;
  reopenAssetCommentThread: AssetCommentThreadPayload;
  reorderConnectionRoleMappings: Array<ConnectionRoleMapping>;
  /**
   * Replaces one translated locale of a live campaign's template with its
   * draft's version, for an edit Meta would reject as a duplicate of the live
   * one. The locale follows the workspace fallback until Meta approves it.
   */
  replaceCepWhatsAppTemplateLocaleInPlace: SubmitCepWhatsAppTemplateLocaleResult;
  requestAdminEntitlement: AdminEntitlementRequestResult;
  requestArtifactReviews: RequestArtifactReviewsResponse;
  requestCampaignCalendarEnrichment: CampaignCalendarEnrichmentStart;
  requestCampaignCalendarRebuild: Scalars['ID'];
  requestCampaignCreativeCapture: Scalars['ID'];
  /** Queues a full rebuild of the caller's workspace's Insights tables. */
  requestInsightsRebuild: InsightsRebuildResult;
  rerunDbtCloudModelSync: Scalars['Boolean'];
  resetAggregationState: Scalars['Boolean'];
  resetAttributionState: Scalars['Boolean'];
  resetCachedEventPullWatermark: ResetCachedEventPullWatermarkResult;
  resetExperimentGroups: Scalars['Boolean'];
  resetFeatureDefinitionCachedState: ResetFeatureDefinitionCachedStateResult;
  resetPredictorState: ResetPredictorStateResult;
  resetSendEventCacheForChannel: DecisionEngineResult;
  resetSendState: Scalars['Boolean'];
  resetState: Scalars['Boolean'];
  resolveAssetCommentThread: AssetCommentThreadPayload;
  /** Restoring a canvas also restores the files deleted with it. */
  restoreAmpFile: AmpFileActionResult;
  /** Saves a past version of a doc, upload, web page or slide deck as its newest version. Conflicts when baseVersionId is no longer the latest. */
  restoreAmpFileVersion: AmpFileWriteResult;
  restoreDecisionEngineMessage: DecisionEngineResult;
  restoreReportVersion: ReportScheduleContentMutationResponse;
  resumeFivetranAgentSync: FivetranAgentSyncResponse;
  retryArchivedFailures: RetryArchivedFailuresResult;
  retryExtensionExport: ExtensionExportJob;
  /**
   * reviewerId is any of the viewer's reviewer rows from the task's current
   * visit to its status. The decision lands on every row the viewer has there,
   * and a row from an earlier visit is refused.
   */
  reviewAmpTask: AmpTaskReviewOutcome;
  /**
   * Approve or reject a pending campaign review request. Approval requires
   * reviewedMessageVersions — the content and metadata versions the reviewer's
   * screen rendered, currently exactly one entry as only single-message
   * campaigns can be reviewed — and aborts if either version changed since;
   * approving a never-launched campaign also launches it.
   */
  reviewCampaignDraft: ReviewCampaignDraftResult;
  /**
   * Approve or reject a pending journey review request. Approval requires
   * reviewedJourneyVersionId + reviewedJourneyUpdatedAt — the version the
   * reviewer saw — and aborts if the journey changed since; it applies the
   * staged edit (or enables a never-enabled journey) and only records the
   * approval once that succeeds.
   */
  reviewJourneyDraft: ReviewJourneyDraftResult;
  rollbackBlackoutDays: Scalars['Boolean'];
  rowExportBackground: RowExportBackgroundResult;
  runAggregations?: Maybe<Scalars['JSONObject']>;
  runAmpAssetSync: AmpAssetSyncRunRef;
  runAssetClassification: RunAssetClassificationResult;
  runChartCard: ChartCardRunHandle;
  runCreativeClassification: CreativeClassificationRunRef;
  runDamSync: AmpAssetSyncRunRef;
  runDashboard: Array<ChartResult>;
  runDecisionEngine?: Maybe<Scalars['JSONObject']>;
  runEnrichedCatalogSync: EnrichedCatalogSyncJobRef;
  runEventWarehouseSync: Scalars['Boolean'];
  runExperiment: ExperimentRunHandle;
  runExposureLogResolution: RunExposureLogResolutionResponse;
  runJourney: JourneyRun;
  runMatchBoosterTest: RunMatchBoosterTestResponse;
  runOpportunityDefinitionNow: RunOpportunityDefinitionResponse;
  runRealtimeAudiencePull: Scalars['Boolean'];
  runRefreshAnalyticsCache?: Maybe<Scalars['JSONObject']>;
  runRefreshEligibleUserCounts?: Maybe<Scalars['JSONObject']>;
  /**
   * Runs the consent purge for a flow outside the daily scheduler. The mode
   * comes from the feature matrix's saved consent settings, not from the
   * caller, so an execute-mode agent purges for real. Pass the mode the caller
   * showed the user as expectedMode and the run is refused if the saved mode
   * has changed since, so nobody confirms a plan and gets a purge.
   */
  runSanitizeUserFeatures?: Maybe<Scalars['JSONObject']>;
  runSavePlots?: Maybe<Scalars['JSONObject']>;
  runSendAttribution?: Maybe<Scalars['JSONObject']>;
  runSendDiagnostics?: Maybe<Scalars['JSONObject']>;
  runSyncReconciliation?: Maybe<Scalars['JSONObject']>;
  runTimezoneAnalysis?: Maybe<Scalars['JSONObject']>;
  runWriteAttribution?: Maybe<Scalars['JSONObject']>;
  saveAdArtifact: AdAgentArtifact;
  saveAgentAudience: SaveAgentAudienceResponse;
  saveAgentDefinition: AgentDefinition;
  saveArtifact: SaveArtifactResponse;
  saveCalendarContext: CalendarContext;
  saveContentArtifactVersion: SaveContentArtifactVersionResponse;
  saveCreativeDimension: SaveCreativeDimensionResult;
  saveDecisionEngineChannel: SavedDecisionEngineChannel;
  saveDecisionEngineFlowMessages: DecisionEngineResult;
  /**
   * Apply a batch of staged entitlement changes atomically. Fired once, on Save.
   * Returns the refreshed view so the client re-renders without a round-trip.
   */
  saveEntitlementChanges: EntitlementCenterView;
  saveExposureLogResolutionConfig: ExposureLogResolutionConfig;
  saveInAppMessageContent: InAppMessageContent;
  /**
   * Create a Native Delivery A/B test: the experiment, its message_experiment
   * link, an optional primary metric, and one seeded body-variant per arm.
   */
  saveMessageAbTest: SaveMessageAbTestResult;
  saveMessageBodyDraft: SaveMessageContentResult;
  /**
   * Sparse write — content lane only. Insert a message_contents row (body) and
   * advance published_version (Version) or draft_version (Draft). Does not touch
   * message_contents_metadata.
   */
  saveMessageBodyVersion: SaveMessageContentResult;
  /** Stage a content version without publishing */
  saveMessageContentDraft: SaveMessageContentResult;
  /** Publish a new content version */
  saveMessageContentVersion: SaveMessageContentResult;
  saveMessageMetadataDraft: SaveMessageContentResult;
  /**
   * Sparse write — metadata lane only. Upsert the message_contents_metadata row
   * at the given version (subject/preheader) and advance
   * published_metadata_version (Version) or draft_metadata_version (Draft). The
   * caller supplies the version (current pointer for an in-place edit, or a
   * freshly reserved version to open a draft). Does not touch message_contents.
   */
  saveMessageMetadataVersion: SaveMessageContentResult;
  saveModelConfiguration: UpdateModelColumnsResponse;
  saveSendInsightChart: DecisionEngineResult;
  saveSessionAssumption: SaveSessionAssumptionResponse;
  /** Searches every channel's ad library (or the given channels) for advertiser accounts matching a name. */
  searchCompetitorAccounts: Array<CompetitorAccountSearch>;
  /** Finds a brand's accounts on every channel (or the given channels) from its website and social profiles. */
  searchCompetitorBrandAccounts: Array<CompetitorAccountSearch>;
  /** Sends a message to an AMP agent. A message to a running agent steers its open interaction. */
  sendAmpAgentMessage: SendAmpAgentMessageResponse;
  /**
   * Send a preview email through a destination (Braze, Iterable).
   * The email will be sent to a Hightouch-managed inbox and can be retrieved
   * via the getEmailPreview query using the returned previewId.
   */
  sendEmailPreview: SendEmailPreviewResponse;
  /** Store an in-app message and fire a silent ghost push to the user's iOS devices (POC). */
  sendInAppMessage: SendInAppMessageResult;
  sendOrganizationInvite?: Maybe<Scalars['Boolean']>;
  sendSeedBatch: SendSeedBatchResult;
  sendTestEmail: SendTestEmailResult;
  sendTestPush: SendTestPushResult;
  sendTestSms: SendTestSmsResult;
  /** Sends a saved WhatsApp template to one recipient as a test. */
  sendTestWhatsAppMessage: SendTestWhatsAppMessageResult;
  setAgentConnectorPermissions: AgentConnector;
  setAmpFileFavorite: Scalars['Boolean'];
  /** Hightouch staff only. Making a canvas visible to the workspace makes the private files on it visible too. */
  setAmpFileVisibility: AmpFileActionResult;
  /**
   * Marks these notifications, by the ids ampInbox returns as changelogId, or
   * every notification under the filters, read or unread. Pass one of
   * changelogIds or filters.
   */
  setAmpInboxRead: Scalars['Int'];
  /**
   * The status must be in the task's workflow. Moving an archived task to a
   * status brings it back.
   */
  setAmpTaskStatus: AmpChangeResult;
  setAsanaSubtaskCompleted: AsanaSubtask;
  /**
   * Sets a brand profile's default dynamic-content assignment source.
   * Pass null to inherit from the workspace or resolved email provider.
   */
  setBrandProfileDefaultAssignmentSource: SaveDefaultAssignmentSourceResult;
  setBrandProfileEspDestination: SaveEspDestinationResult;
  setCampaignEspDestination: SaveEspDestinationResult;
  setCampaignInsightSaveStatus: CampaignInsightFeedItem;
  /**
   * Replace the saved definitions Campaign Insights runs in the current
   * workspace use as segments and metrics. A definition can have both roles. Ids
   * already saved under a role may stay after their definition stops being
   * eligible; added ids must be eligible. Returns the settings as saved.
   */
  setCampaignInsightsDefinitions: CampaignInsightsDefinitionSettings;
  setCatalogProductTag: CatalogProduct;
  setCepBrandFooter: SetCepBrandFooterResponse;
  setCepBrandLogo: SetCepBrandLogoResponse;
  setCepParentModelAndConfigureEvents: SetCepParentModelAndConfigureEventsResult;
  /**
   * Sets the examples Meta reviews one translated locale of a WhatsApp
   * template with. Values matching the default locale's are not stored, so
   * those keep following the default locale's examples.
   */
  setCepWhatsAppTemplateLocaleSamples: SetCepWhatsAppTemplateLocaleSamplesResult;
  /**
   * Sets the locales a WhatsApp template is translated into. Adding a locale
   * creates its own unsubmitted version of the template. Removing one keeps
   * that version, with its translations and Meta template, so adding it back
   * restores it.
   */
  setCepWhatsAppTemplateLocalization: SetCepWhatsAppTemplateLocalizationResult;
  setCepWorkspaceFallbackLocale: SetCepWorkspaceFallbackLocaleResult;
  setCompetitorKind: Competitor;
  setConnectionRoleSettings: ConnectionRoleSettings;
  /** Turn learning on or off for an intelligence tag. Never re-tags. */
  setCreativeDimensionLearning: SaveCreativeDimensionResult;
  /** Requires the observed epoch to avoid overwriting concurrent mode changes. */
  setDecisionEngineArbitrationGroupMode: DecisionEngineArbitrationGroup;
  setDecisionEngineCollectionConfig: DecisionEngineResult;
  setDecisionEngineConfig: DecisionEngineResult;
  setDecisionEngineFlowStatus: DecisionEngineSuccess;
  setDecisionEngineOutcomeConfig: DecisionEngineResult;
  /**
   * Sets the workspace default dynamic-content assignment source.
   * Pass `audience_schema` (warehouse audience conditions) or `esp_profile`
   * (ESP-native predicates). Pass null to clear and inherit from the resolved
   * email provider (Native Delivery → audience_schema; unset or ESP →
   * esp_profile).
   */
  setDefaultAssignmentSource: SaveDefaultAssignmentSourceResult;
  setDefaultBrandProfile: BrandProfile;
  setDefaultChannelSize: AdExportChannelSuccessResponse;
  /**
   * Sets the email target for a scope. Pass `destinationId` for an ESP
   * destination, `targetKind: "native_delivery"` for Hightouch's own sending
   * path, or neither to inherit from the next scope out. Passing both is an
   * error.
   */
  setDefaultEspDestination: SaveEspDestinationResult;
  setEventForwardingSyncSources: EventForwardingSyncResult;
  setEventWarehouseSyncSources: EventWarehouseSyncResult;
  setGoldenRecordColumnSourceSurvivorship: SetGoldenRecordColumnSourceSurvivorshipResponse;
  /**
   * Replace the push apps an in-app message targets. Every app must exist in
   * the workspace and be enabled; an empty list clears the links.
   */
  setInAppMessagePushApps: SetInAppMessagePushAppsResult;
  /**
   * Marks these notifications, or every notification under the filters, read
   * or unread. Pass one of ids or filters. eventIds, in the order of ids, are
   * the events the notifications showed: one that has since moved to a newer
   * event is left as it is.
   */
  setInboxRead: Scalars['Int'];
  setLibraryImageTags: LibraryMutationResult;
  /**
   * Staff-only. Replace the set of brand profiles for which a GLOBAL
   * Hightouch-managed skill is disabled in the CALLER'S workspace. The skill
   * stays global; this writes only this workspace's per-brand-profile overrides
   * and leaves the workspace-wide override untouched. An empty array re-enables
   * the skill for every brand profile in the workspace. `id` is the managed
   * entity id. Returns the managed entity projected onto the caller's workspace
   * override state.
   */
  setManagedSkillDisabledBrandProfiles: AgenticSettingsEntity;
  /**
   * Staff-only. Enable or disable a GLOBAL Hightouch-managed skill for the
   * CALLER'S workspace only. The skill stays global and visible to every
   * workspace; this toggles just this workspace's workspace-wide override.
   * `id` is the managed entity id. Returns the managed entity projected onto
   * the caller's workspace override state.
   */
  setManagedSkillWorkspaceEnabled: AgenticSettingsEntity;
  setOpportunityDefinitionStatus: OpportunityDefinition;
  /** Sets the current organization's logo, shown in every workspace's nav, and returns its public URL. Takes a base64 PNG of at most 128px on a side and 256 KB, which the settings page resizes every pick to. */
  setOrganizationLogo: Scalars['String'];
  setSpacesAudienceTemplateAccess: Scalars['Boolean'];
  setSsoEnforcement?: Maybe<Scalars['Boolean']>;
  setSyncIdrSchedule: SetSyncIdrScheduleResponse;
  /**
   * Creates the schema models a signup needs and declares the realtime traits a
   * welcome message personalizes from, one per field the signup form posts.
   *
   * Someone calls this per workspace; configuring Native Delivery does not do it
   * on its own, because it writes models into the customer's own schema. Stands
   * in for the Native Delivery setup page until it exists.
   */
  setUpCepSignups: SetUpCepSignupsResult;
  setWarehouseExportEnabled: SetWarehouseExportEnabledOutput;
  setWarehouseExportEnabledForSource: SetWarehouseExportEnabledForSourceOutput;
  setupDemoData: Scalars['JSONObject'];
  setupFivetranSync: SetupFivetranSyncResponse;
  setupInWarehouseDiffingForSource: SetupInWarehouseDiffingForSourceOutput;
  setupInWarehouseDiffingWithCredentials: SetupInWarehouseDiffingWithCredentialsOutput;
  shareAgentSessionToSlack: ShareAgentSessionToSlackResponse;
  /**
   * Share the given databases/catalogs: marks them pending and enqueues
   * converge. Additive (union with any existing children), so this is both the
   * first-time enable and the later add — there is no separate update mutation.
   */
  shareDatabases: WarehouseShareMirror;
  /**
   * Asks every named review agent to review every named ad — the bulk form of
   * mentioning one agent in one thread.
   *
   * One thread per (ad, agent) pair, each opened on the ad's primary size with
   * an unpinned comment naming that agent, and each starting that agent's run.
   * A review is a conversation with one reviewer, so the agents do not share a
   * thread.
   *
   * Ids are deduplicated. See StartAssetCommentReviewsPayload for what a
   * partial result means.
   */
  startAssetCommentReviews: StartAssetCommentReviewsPayload;
  startAssetEditSession: StartAssetEditSessionResponse;
  /**
   * Compute one window of a campaign run's recipients into the cache. Always
   * computes; concurrent callers asking the same question share one job.
   */
  startCampaignRecipientsComputation: CampaignRecipientsResult;
  /**
   * Serves the cache when it has an answer, otherwise enqueues the computation
   * and returns a job id to poll with cepReachabilityResult. Concurrent callers
   * asking the same question share one job.
   */
  startCepReachabilityComputation: CepReachabilityResult;
  startContentImageSearchV2: ContentImageSearchJobResponse;
  startContentNodeEditSession: StartContentNodeEditSessionResult;
  startCopyReferencesIngestion: CopyReferencesIngestionRun;
  startEnrichment: EnrichmentJob;
  startFigmaImport: StartFigmaImportResult;
  startIdrRun: IdrRun;
  startIdrTraining: IdrTrainingRun;
  startPublicImageFromContentImage: StartPublicImageFromContentImageResponse;
  startSyncRun: StartSyncRunOutput;
  startSyncRunsForSegment: StartSyncRunsForSegmentOutput;
  startSyncRunsWithDiffModeOverride: StartSyncRunsWithDiffModeOverrideOutput;
  /**
   * Enqueue live grant validation on the customer-data worker (same pattern as
   * testSource). Poll warehouseShareSetupBackgroundJobResult for the result.
   */
  startWarehouseShareSetupBackgroundJob: StartWarehouseShareSetupBackgroundJob;
  /** Stops an AMP agent, and with tree every agent in its subtree. The inbox stays. */
  stopAmpAgent: StopAmpAgentResponse;
  /** Stops only the caller's waiting v2 run; terminal runs remain terminal. */
  stopMessagePreviewRun: MessagePreviewRun;
  /**
   * Stops waiting for a requested preview email and closes the acceptance
   * window. The ESP send is not recalled — an email may still be delivered,
   * but it will no longer be accepted.
   */
  stopWaitingMessagePreview: MessagePreviewState;
  submitAmpTaskReview: AmpTaskReviewResult;
  /**
   * Request a review of a campaign's staged message changes. While a request is
   * pending, re-submitting replaces the requested approver list (only newly
   * added approvers are notified).
   */
  submitCampaignDraft: NativeDeliveryDraftResult;
  /** Sends a template to Meta for review. Retries reuse the same provider template. */
  submitCepWhatsAppTemplate: SubmitCepWhatsAppTemplateResult;
  /** Sends each chosen locale of a template to Meta for review, reporting on each. */
  submitCepWhatsAppTemplateLocales: Array<SubmitCepWhatsAppTemplateLocaleResult>;
  submitDraftModel: ResourceDraftResult;
  submitDraftSync: ResourceDraftResult;
  /**
   * Request a review of a journey's staged changes. While a request is pending,
   * re-submitting replaces the requested approver list (only newly added
   * approvers are notified).
   */
  submitJourneyDraft: NativeDeliveryDraftResult;
  /** Hightouch admins only. Queues a copy of this workspace's Ad Studio ads, folders, comments and favorites onto its Library. False when a sync is already queued or running. */
  syncAdStudioToLibrary: Scalars['Boolean'];
  /** Moves tasks whose approval step is met. Returns the ones that moved. */
  syncAmpTaskApprovals: Array<AmpTaskApprovalMove>;
  syncFivetranConnectionNow: FivetranAgentSyncResponse;
  syncLifecycleStudioToLibrary: Scalars['Boolean'];
  /**
   * Tags the task by name. A new name creates the tag with color; an existing
   * tag keeps its color. Names match without case.
   */
  tagAmpTask: AmpTaskTagResult;
  tagContentImagesWithPipeline: TagContentImagesPipelineResponse;
  testCepProviderConnection: TestCepProviderConnectionResult;
  testExtensionConnection: TestExtensionConnectionResult;
  /**
   * Enqueues an out-of-band warehouse-reachability probe for the given
   * integration/config pair (no row created). FE polls
   * `externalContextSourceConnectionTestResult` with the returned jobId.
   */
  testExternalContextSourceConnection: TestExternalContextSourceConnectionJob;
  /** Runs Fivetran's setup tests and stores the failures in fivetran_last_test. */
  testFivetranConnection: TestFivetranConnectionResponse;
  testIDROnCompleteSql: TestIdrOnCompleteSqlResponse;
  testNewDestination?: Maybe<TestDestinationResponse>;
  testPersonalizationApi: TestPersonalizationApiResult;
  testUpdatedDestination?: Maybe<TestDestinationResponse>;
  toggleCachedEventPullEnabled: ToggleCachedEventPullEnabledResult;
  togglePredictorEnabled: TogglePredictorEnabledResult;
  trainModels?: Maybe<Scalars['JSONObject']>;
  /** Runs the content recommendation action tracking report for a flow and arms its weekly schedule. Admin analytics tool. */
  triggerAIDContentRecommendationsReconcileRun: TriggerAidContentRecommendationsRunResponse;
  triggerAIDContentRecommendationsRun: TriggerAidContentRecommendationsRunResponse;
  triggerEtlSyncRun?: Maybe<TriggerEtlSyncRunResult>;
  triggerExternalContextSourceSync: ExternalContextSource;
  /**
   * Enqueue global-decisioning-arbitration for a group ignoring the hourly scheduler cadence.
   * forceFullPack re-packs every candidate instead of locking the next slice of an unchanged latest plan.
   */
  triggerGlobalDecisioningArbitration?: Maybe<Scalars['JSONObject']>;
  triggerIdeasRun: TriggerIdeasRunResponse;
  /** Creates or updates the daily launches report from saved winner criteria and starts a run now. */
  triggerLaunchTrackingRun: TriggerLaunchTrackingRunResponse;
  /**
   * Sends a preview email for the message and opens (or extends) the
   * acceptance window. V2 callers receive a separate run per request; legacy
   * callers share the message's state and the latest request wins.
   */
  triggerMessagePreview: MessagePreviewState;
  triggerMessageRecheck: Scalars['Boolean'];
  /**
   * Queues a manual suggestions refresh for one column, scoped to the caller's
   * current space. Recomputes only that space's suggestions for every parent
   * model the column is reachable from -- the workspace-level value and every
   * other space are left untouched. No-ops (returns false) when the caller
   * isn't in a space, the column isn't opted into space-scoped suggestions, or
   * the space has no eligible parent model to scope by.
   */
  triggerSpaceScopedColumnTopKSync: Scalars['Boolean'];
  /**
   * Queues a manual suggestions refresh for one column across every space in
   * the workspace at once, unlike triggerSpaceScopedColumnTopKSync which only
   * refreshes the caller's current space. Intended for the advanced options
   * modal, not the plain workspace-level refresh button, since it can queue a
   * sync per (space, parent model) pair. No-ops (returns false) when the
   * column isn't opted into space-scoped suggestions or has no eligible
   * parent model to scope by.
   */
  triggerSpaceScopedColumnTopKSyncAllSpaces: Scalars['Boolean'];
  /** False when the workspace has no such link. */
  unlinkAmpProjectWork: AmpChangeResult;
  /** Clears the link and removes the campaign's attachment from the task. */
  unlinkAsanaTask: Scalars['Boolean'];
  untagAmpTask: AmpChangeResult;
  updateAdInsightsSavedView: Scalars['ID'];
  /**
   * Sets the status of one or more ads. An id the workspace can't reach fails
   * the whole batch rather than writing half of it.
   */
  updateAdStatuses: AdStatusWritePayload;
  updateAgenticSettingsEntity: AgenticSettingsEntity;
  /**
   * Replace an entity's brand-profile assignments with the supplied set.
   * Empty array deletes all join rows for the entity, meaning "applies to all
   * brand profiles" by convention. Each id must reference a non-deleted brand
   * profile in the caller's workspace.
   */
  updateAgenticSettingsEntityBrandProfileAssignment: Scalars['Boolean'];
  updateAmpAssetSync: Scalars['ID'];
  updateAmpFile: AmpFileWriteResult;
  /** Omitted fields stay as they are; a null parentId moves the folder to the top level. */
  updateAmpFileFolder: AmpFolder;
  updateApiKeyUserGroup: CreateApiKeyResult;
  updateAsanaTask: AsanaTaskDetail;
  updateAssetCollection: AssetCollection;
  /** Edits a comment's body and re-syncs its mentions. Author only. */
  updateAssetComment: AssetCommentPayload;
  /**
   * Moves a thread's pin to a new point on the asset — dragging a comment
   * around the canvas. The anchor is required: an unpinned thread comments on
   * the asset as a whole rather than on a location within it, so there is
   * nothing to drag and nothing to drag it to.
   */
  updateAssetCommentThread: AssetCommentThreadPayload;
  updateAudienceTemplate?: Maybe<UpdateAudienceTemplateResponse>;
  updateAudienceTemplateSpaces: Scalars['Boolean'];
  updateBlocklist: UpdateBlocklistJob;
  updateCachedEventPullSettings: UpdateCachedEventPullSettingsResult;
  updateCalendarView: CalendarView;
  updateCampaignStatus: UpdateCampaignStatusResult;
  updateCanvas: AmpFile;
  /**
   * Sets a channel's daily send cap, or removes it with null. While Meta's
   * messaging limit is capped, a WhatsApp cap is required and may not exceed it.
   */
  updateCepChannelDailyCap: UpdateCepChannelDailyCapResult;
  /**
   * Saves one parent model's Native Delivery settings. A field left out stays
   * unchanged, and a null warehouseAttributeCacheSyncId clears the sync.
   */
  updateCepParentModelSettings: CepParentModelSettings;
  /**
   * Saves several parent models' Native Delivery settings in one transaction,
   * so one invalid item saves nothing. Each item follows the rules of
   * updateCepParentModelSettings. Returns the saved settings in input order.
   */
  updateCepParentModelsSettings: Array<CepParentModelSettings>;
  updateCepProvider: CepProviderResult;
  /** Sets the category Meta reviews a WhatsApp message's template under. */
  updateCepWhatsAppMessageCategory: UpdateCepWhatsAppTemplateResult;
  updateCepWhatsAppTemplate: UpdateCepWhatsAppTemplateResult;
  updateComponentAsset: UpdateComponentAssetResponse;
  updateConnectionRoleMapping: ConnectionRoleMapping;
  updateContentArtifactMetadata: UpdateContentArtifactMetadataResponse;
  /**
   * Replace a content email's brand-profile assignments with the supplied
   * set. Empty array deletes all join rows for the email, meaning "applies
   * to all brand profiles" by convention. Each id must reference a
   * non-deleted brand profile in the caller's workspace.
   */
  updateContentEmailBrandProfileAssignment: Scalars['Boolean'];
  updateContentImage?: Maybe<LibraryImage>;
  /** Set one creative tag by hand. The dimension must be a single-value enum and the value one of its allowedValues; creative_tags is updated and creative_tags_wide patched so stats follow. */
  updateCreativeTag: AdInsightsCreativeTagUpdate;
  updateDamSync: Scalars['ID'];
  updateDbtCloudCredential: DbtCredential;
  updateDecisionEngineArbitrationGroup: DecisionEngineArbitrationGroup;
  updateDecisionEngineArbitrationGroupMembership: DecisionEngineArbitrationGroupMembership;
  updateDecisionEngineChannelConfig: DecisionEngineResult;
  /**
   * Sets or clears (null) the consent-purge section of a feature matrix's
   * config. The config column is not writable through Hasura; this validating
   * mutation is the only write path for the section.
   */
  updateDecisionEngineFeatureMatrixConsentPurge: UpdateConsentPurgeResult;
  /**
   * Validates the Sanitize flags of a pending feature-matrix save and records the
   * consent-dependent feature keys it leaves behind, in the tombstones section of
   * the matrix config. Call it before writing the relationships: a deleted column's
   * keys can only be resolved while the column is still stored.
   */
  updateDecisionEngineFeatureMatrixTombstones: UpdateConsentPurgeResult;
  /** Rejects edits a live or ended period does not allow. */
  updateDecisionEngineFlowOverridePeriod: Scalars['Boolean'];
  updateDecisionEngineMessage: DecisionEngineResult;
  updateDecisionEngineScheduling: DecisionEngineSuccess;
  updateDestinationWithSecrets: DestinationResult;
  updateDomainSources: UpdateDomainSourcesResult;
  updateDraftsStatus: Scalars['Boolean'];
  updateEmailTemplateInDestination: Scalars['Boolean'];
  updateEnrichedFeedSchedule: Scalars['ID'];
  updateEventComponent: EventComponentResult;
  updateEventForwardingSync: EventForwardingSyncResult;
  updateEventPlan: EventPlanResult;
  updateEventSchemaV2: UpsertEventSchemaResult;
  updateEventSource: EventSourceResult;
  updateEventWarehouseDestination: EventWarehouseDestinationResult;
  updateEventWarehouseSync: EventWarehouseSyncResult;
  updateExtensionExportConfig: UpdateExtensionResult;
  updateExtensionWithSecrets: UpdateExtensionResult;
  updateExternalContextSource: ExternalContextSource;
  updateFivetranSyncAccounts: UpdateFivetranSyncAccountsResponse;
  updateFivetranSyncAuth: SetupFivetranSyncResponse;
  updateFunction: UpdateFunctionResponse;
  updateGithubCredentials: GithubCredentialResult;
  updateGoldenRecord: UpdateGoldenRecordResponse;
  updateGoldenRecordColumn: UpdateGoldenRecordColumnResponse;
  updateIDRGraph: UpdateIdrGraphResponse;
  updateIDRModel: UpdateIdrModelResponse;
  /**
   * Edit an existing insight on an initiative goal. Hightouch employees only.
   * `type`, `title`, and `content` match createInitiativeInsight. Returns
   * the edited insight id.
   */
  updateInitiativeInsight: Scalars['uuid'];
  updateJourney: UpdateJourneyOutput;
  updateJourneyTemplate: UpdateJourneyTemplateOutput;
  updateJourneyTrait: UpdateJourneyTraitOutput;
  updateLlmChatMessageContent: Scalars['Boolean'];
  updateLlmInferenceBackend: LlmInferenceBackend;
  /**
   * Staff-only. Edit a global Hightouch-managed skill by appending an 'updated'
   * version to its managed entity; the change is visible to every workspace.
   * Markdown and file skills (file edits mirror the workspace path: replace the
   * file, or edit metadata and keep it). `input.id` is the managed entity id.
   * Operates on the global managed store, not the caller's per-workspace entities.
   */
  updateManagedSkill: AgenticSettingsEntity;
  updateManyDecisionEngineMessages: DecisionEngineResult;
  updateMessageAbTest: UpdateMessageAbTestResult;
  /** In-place update of an existing content row (no new version) */
  updateMessageContent: SaveMessageContentResult;
  updateMessagePlan: UpdateMessagePlanResponse;
  updateOpportunityDefinition: OpportunityDefinition;
  updatePidrPairBlocklist: UpdateBlocklistJob;
  updatePidrRowBlocklist: UpdateBlocklistJob;
  updatePidrValueBlocklist: UpdateBlocklistJob;
  updatePredictor: UpdatePredictorResult;
  updatePredictorCatalogFeatureDefinition: UpdatePredictorFeatureDefinitionResult;
  updatePredictorFeatureDefinition: UpdatePredictorFeatureDefinitionResult;
  updatePredictorSettings: UpdatePredictorSettingsResult;
  updatePreviewRecipient: MessagePreviewRecipient;
  updatePriorityList?: Maybe<UpdatePriorityListResponse>;
  updatePushApp: PushAppResult;
  updatePushCampaignInDestination: Scalars['Boolean'];
  updateRealtimeEventColumns: UpdateRealtimeEventColumnsOutput;
  updateRelationship: Array<Scalars['String']>;
  updateReportScheduleContent: ReportScheduleContentMutationResponse;
  /**
   * An omitted field is left alone. Changing settingsEntityId keeps the
   * comments the agent has already written.
   */
  updateReviewAgent: ReviewAgentPayload;
  updateSchemaModel: UpdateSchemaModelResponse;
  updateSmsCampaignInDestination: Scalars['Boolean'];
  updateSourceWithSecrets: SourceMutationResult;
  updateSplitsConfig?: Maybe<UpdateSplitsConfigResponse>;
  updateStyleEntity: UpdateStyleEntityResult;
  updateSyncTemplate: UpdateSyncTemplateResponse;
  updateTrait?: Maybe<UpdateTraitResponse>;
  updateTraitDefinition: TraitDefinition;
  updateWorkspaceNotificationChannelConfig?: Maybe<WorkspaceNotificationChannelResult>;
  /** update data of the table: "ad_brief_asset_launch_queue" */
  update_ad_brief_asset_launch_queue?: Maybe<AdBriefAssetLaunchQueueMutationResponse>;
  /** update single row of the table: "ad_brief_asset_launch_queue" */
  update_ad_brief_asset_launch_queue_by_pk?: Maybe<AdBriefAssetLaunchQueue>;
  /** update multiples rows of table: "ad_brief_asset_launch_queue" */
  update_ad_brief_asset_launch_queue_many?: Maybe<Array<Maybe<AdBriefAssetLaunchQueueMutationResponse>>>;
  /** update data of the table: "ad_brief_asset_launches" */
  update_ad_brief_asset_launches?: Maybe<AdBriefAssetLaunchesMutationResponse>;
  /** update single row of the table: "ad_brief_asset_launches" */
  update_ad_brief_asset_launches_by_pk?: Maybe<AdBriefAssetLaunches>;
  /** update multiples rows of table: "ad_brief_asset_launches" */
  update_ad_brief_asset_launches_many?: Maybe<Array<Maybe<AdBriefAssetLaunchesMutationResponse>>>;
  /** update data of the table: "ad_brief_assets" */
  update_ad_brief_assets?: Maybe<AdBriefAssetsMutationResponse>;
  /** update single row of the table: "ad_brief_assets" */
  update_ad_brief_assets_by_pk?: Maybe<AdBriefAssets>;
  /** update multiples rows of table: "ad_brief_assets" */
  update_ad_brief_assets_many?: Maybe<Array<Maybe<AdBriefAssetsMutationResponse>>>;
  /** update data of the table: "ad_briefs" */
  update_ad_briefs?: Maybe<AdBriefsMutationResponse>;
  /** update single row of the table: "ad_briefs" */
  update_ad_briefs_by_pk?: Maybe<AdBriefs>;
  /** update multiples rows of table: "ad_briefs" */
  update_ad_briefs_many?: Maybe<Array<Maybe<AdBriefsMutationResponse>>>;
  /** update data of the table: "ad_export_channel_sizes" */
  update_ad_export_channel_sizes?: Maybe<AdExportChannelSizesMutationResponse>;
  /** update single row of the table: "ad_export_channel_sizes" */
  update_ad_export_channel_sizes_by_pk?: Maybe<AdExportChannelSizes>;
  /** update multiples rows of table: "ad_export_channel_sizes" */
  update_ad_export_channel_sizes_many?: Maybe<Array<Maybe<AdExportChannelSizesMutationResponse>>>;
  /** update data of the table: "ad_export_channels" */
  update_ad_export_channels?: Maybe<AdExportChannelsMutationResponse>;
  /** update single row of the table: "ad_export_channels" */
  update_ad_export_channels_by_pk?: Maybe<AdExportChannels>;
  /** update multiples rows of table: "ad_export_channels" */
  update_ad_export_channels_many?: Maybe<Array<Maybe<AdExportChannelsMutationResponse>>>;
  /** update data of the table: "ad_generation_pipeline_runs" */
  update_ad_generation_pipeline_runs?: Maybe<AdGenerationPipelineRunsMutationResponse>;
  /** update single row of the table: "ad_generation_pipeline_runs" */
  update_ad_generation_pipeline_runs_by_pk?: Maybe<AdGenerationPipelineRuns>;
  /** update multiples rows of table: "ad_generation_pipeline_runs" */
  update_ad_generation_pipeline_runs_many?: Maybe<Array<Maybe<AdGenerationPipelineRunsMutationResponse>>>;
  /** update data of the table: "ad_generation_workflows" */
  update_ad_generation_workflows?: Maybe<AdGenerationWorkflowsMutationResponse>;
  /** update single row of the table: "ad_generation_workflows" */
  update_ad_generation_workflows_by_pk?: Maybe<AdGenerationWorkflows>;
  /** update multiples rows of table: "ad_generation_workflows" */
  update_ad_generation_workflows_many?: Maybe<Array<Maybe<AdGenerationWorkflowsMutationResponse>>>;
  /** update data of the table: "ad_stats_models" */
  update_ad_stats_models?: Maybe<AdStatsModelsMutationResponse>;
  /** update single row of the table: "ad_stats_models" */
  update_ad_stats_models_by_pk?: Maybe<AdStatsModels>;
  /** update multiples rows of table: "ad_stats_models" */
  update_ad_stats_models_many?: Maybe<Array<Maybe<AdStatsModelsMutationResponse>>>;
  /** update data of the table: "ad_studio_product_feeds" */
  update_ad_studio_product_feeds?: Maybe<AdStudioProductFeedsMutationResponse>;
  /** update single row of the table: "ad_studio_product_feeds" */
  update_ad_studio_product_feeds_by_pk?: Maybe<AdStudioProductFeeds>;
  /** update multiples rows of table: "ad_studio_product_feeds" */
  update_ad_studio_product_feeds_many?: Maybe<Array<Maybe<AdStudioProductFeedsMutationResponse>>>;
  /** update data of the table: "ad_studio_projects" */
  update_ad_studio_projects?: Maybe<AdStudioProjectsMutationResponse>;
  /** update single row of the table: "ad_studio_projects" */
  update_ad_studio_projects_by_pk?: Maybe<AdStudioProjects>;
  /** update multiples rows of table: "ad_studio_projects" */
  update_ad_studio_projects_many?: Maybe<Array<Maybe<AdStudioProjectsMutationResponse>>>;
  /** update data of the table: "ad_studio_treatments" */
  update_ad_studio_treatments?: Maybe<AdStudioTreatmentsMutationResponse>;
  /** update single row of the table: "ad_studio_treatments" */
  update_ad_studio_treatments_by_pk?: Maybe<AdStudioTreatments>;
  /** update multiples rows of table: "ad_studio_treatments" */
  update_ad_studio_treatments_many?: Maybe<Array<Maybe<AdStudioTreatmentsMutationResponse>>>;
  /** update data of the table: "agentic_settings" */
  update_agentic_settings?: Maybe<AgenticSettingsMutationResponse>;
  /** update single row of the table: "agentic_settings" */
  update_agentic_settings_by_pk?: Maybe<AgenticSettings>;
  /** update data of the table: "agentic_settings_entities_links" */
  update_agentic_settings_entities_links?: Maybe<AgenticSettingsEntitiesLinksMutationResponse>;
  /** update single row of the table: "agentic_settings_entities_links" */
  update_agentic_settings_entities_links_by_pk?: Maybe<AgenticSettingsEntitiesLinks>;
  /** update multiples rows of table: "agentic_settings_entities_links" */
  update_agentic_settings_entities_links_many?: Maybe<Array<Maybe<AgenticSettingsEntitiesLinksMutationResponse>>>;
  /** update multiples rows of table: "agentic_settings" */
  update_agentic_settings_many?: Maybe<Array<Maybe<AgenticSettingsMutationResponse>>>;
  /** update data of the table: "alert_instances" */
  update_alert_instances?: Maybe<AlertInstancesMutationResponse>;
  /** update multiples rows of table: "alert_instances" */
  update_alert_instances_many?: Maybe<Array<Maybe<AlertInstancesMutationResponse>>>;
  /** update data of the table: "alerts" */
  update_alerts?: Maybe<AlertsMutationResponse>;
  /** update single row of the table: "alerts" */
  update_alerts_by_pk?: Maybe<Alerts>;
  /** update multiples rows of table: "alerts" */
  update_alerts_many?: Maybe<Array<Maybe<AlertsMutationResponse>>>;
  /** update data of the table: "amp_asset_ratings" */
  update_amp_asset_ratings?: Maybe<AmpAssetRatingsMutationResponse>;
  /** update single row of the table: "amp_asset_ratings" */
  update_amp_asset_ratings_by_pk?: Maybe<AmpAssetRatings>;
  /** update multiples rows of table: "amp_asset_ratings" */
  update_amp_asset_ratings_many?: Maybe<Array<Maybe<AmpAssetRatingsMutationResponse>>>;
  /** update data of the table: "amp_creative_dimensions" */
  update_amp_creative_dimensions?: Maybe<AmpCreativeDimensionsMutationResponse>;
  /** update single row of the table: "amp_creative_dimensions" */
  update_amp_creative_dimensions_by_pk?: Maybe<AmpCreativeDimensions>;
  /** update multiples rows of table: "amp_creative_dimensions" */
  update_amp_creative_dimensions_many?: Maybe<Array<Maybe<AmpCreativeDimensionsMutationResponse>>>;
  /** update data of the table: "amp_followed_sources" */
  update_amp_followed_sources?: Maybe<AmpFollowedSourcesMutationResponse>;
  /** update single row of the table: "amp_followed_sources" */
  update_amp_followed_sources_by_pk?: Maybe<AmpFollowedSources>;
  /** update multiples rows of table: "amp_followed_sources" */
  update_amp_followed_sources_many?: Maybe<Array<Maybe<AmpFollowedSourcesMutationResponse>>>;
  /** update data of the table: "amp_followed_topics" */
  update_amp_followed_topics?: Maybe<AmpFollowedTopicsMutationResponse>;
  /** update single row of the table: "amp_followed_topics" */
  update_amp_followed_topics_by_pk?: Maybe<AmpFollowedTopics>;
  /** update multiples rows of table: "amp_followed_topics" */
  update_amp_followed_topics_many?: Maybe<Array<Maybe<AmpFollowedTopicsMutationResponse>>>;
  /** update data of the table: "amp_opportunities" */
  update_amp_opportunities?: Maybe<AmpOpportunitiesMutationResponse>;
  /** update single row of the table: "amp_opportunities" */
  update_amp_opportunities_by_pk?: Maybe<AmpOpportunities>;
  /** update multiples rows of table: "amp_opportunities" */
  update_amp_opportunities_many?: Maybe<Array<Maybe<AmpOpportunitiesMutationResponse>>>;
  /** update data of the table: "amp_projects" */
  update_amp_projects?: Maybe<AmpProjectsMutationResponse>;
  /** update single row of the table: "amp_projects" */
  update_amp_projects_by_pk?: Maybe<AmpProjects>;
  /** update multiples rows of table: "amp_projects" */
  update_amp_projects_many?: Maybe<Array<Maybe<AmpProjectsMutationResponse>>>;
  /** update data of the table: "amp_tags" */
  update_amp_tags?: Maybe<AmpTagsMutationResponse>;
  /** update single row of the table: "amp_tags" */
  update_amp_tags_by_pk?: Maybe<AmpTags>;
  /** update multiples rows of table: "amp_tags" */
  update_amp_tags_many?: Maybe<Array<Maybe<AmpTagsMutationResponse>>>;
  /** update data of the table: "amp_tasks" */
  update_amp_tasks?: Maybe<AmpTasksMutationResponse>;
  /** update single row of the table: "amp_tasks" */
  update_amp_tasks_by_pk?: Maybe<AmpTasks>;
  /** update multiples rows of table: "amp_tasks" */
  update_amp_tasks_many?: Maybe<Array<Maybe<AmpTasksMutationResponse>>>;
  /** update data of the table: "amp_teams" */
  update_amp_teams?: Maybe<AmpTeamsMutationResponse>;
  /** update single row of the table: "amp_teams" */
  update_amp_teams_by_pk?: Maybe<AmpTeams>;
  /** update multiples rows of table: "amp_teams" */
  update_amp_teams_many?: Maybe<Array<Maybe<AmpTeamsMutationResponse>>>;
  /** update data of the table: "amp_workflow_status_reviewers" */
  update_amp_workflow_status_reviewers?: Maybe<AmpWorkflowStatusReviewersMutationResponse>;
  /** update single row of the table: "amp_workflow_status_reviewers" */
  update_amp_workflow_status_reviewers_by_pk?: Maybe<AmpWorkflowStatusReviewers>;
  /** update multiples rows of table: "amp_workflow_status_reviewers" */
  update_amp_workflow_status_reviewers_many?: Maybe<Array<Maybe<AmpWorkflowStatusReviewersMutationResponse>>>;
  /** update data of the table: "amp_workflow_statuses" */
  update_amp_workflow_statuses?: Maybe<AmpWorkflowStatusesMutationResponse>;
  /** update single row of the table: "amp_workflow_statuses" */
  update_amp_workflow_statuses_by_pk?: Maybe<AmpWorkflowStatuses>;
  /** update multiples rows of table: "amp_workflow_statuses" */
  update_amp_workflow_statuses_many?: Maybe<Array<Maybe<AmpWorkflowStatusesMutationResponse>>>;
  /** update data of the table: "amp_workflows" */
  update_amp_workflows?: Maybe<AmpWorkflowsMutationResponse>;
  /** update single row of the table: "amp_workflows" */
  update_amp_workflows_by_pk?: Maybe<AmpWorkflows>;
  /** update multiples rows of table: "amp_workflows" */
  update_amp_workflows_many?: Maybe<Array<Maybe<AmpWorkflowsMutationResponse>>>;
  /** update data of the table: "analytics_reports" */
  update_analytics_reports?: Maybe<AnalyticsReportsMutationResponse>;
  /** update single row of the table: "analytics_reports" */
  update_analytics_reports_by_pk?: Maybe<AnalyticsReports>;
  /** update multiples rows of table: "analytics_reports" */
  update_analytics_reports_many?: Maybe<Array<Maybe<AnalyticsReportsMutationResponse>>>;
  /** update data of the table: "artifact_review_comments" */
  update_artifact_review_comments?: Maybe<ArtifactReviewCommentsMutationResponse>;
  /** update single row of the table: "artifact_review_comments" */
  update_artifact_review_comments_by_pk?: Maybe<ArtifactReviewComments>;
  /** update multiples rows of table: "artifact_review_comments" */
  update_artifact_review_comments_many?: Maybe<Array<Maybe<ArtifactReviewCommentsMutationResponse>>>;
  /** update data of the table: "artifact_reviewers" */
  update_artifact_reviewers?: Maybe<ArtifactReviewersMutationResponse>;
  /** update single row of the table: "artifact_reviewers" */
  update_artifact_reviewers_by_pk?: Maybe<ArtifactReviewers>;
  /** update multiples rows of table: "artifact_reviewers" */
  update_artifact_reviewers_many?: Maybe<Array<Maybe<ArtifactReviewersMutationResponse>>>;
  /** update data of the table: "artifact_reviews" */
  update_artifact_reviews?: Maybe<ArtifactReviewsMutationResponse>;
  /** update single row of the table: "artifact_reviews" */
  update_artifact_reviews_by_pk?: Maybe<ArtifactReviews>;
  /** update multiples rows of table: "artifact_reviews" */
  update_artifact_reviews_many?: Maybe<Array<Maybe<ArtifactReviewsMutationResponse>>>;
  /** update data of the table: "asset_comment_thread_reads" */
  update_asset_comment_thread_reads?: Maybe<AssetCommentThreadReadsMutationResponse>;
  /** update single row of the table: "asset_comment_thread_reads" */
  update_asset_comment_thread_reads_by_pk?: Maybe<AssetCommentThreadReads>;
  /** update multiples rows of table: "asset_comment_thread_reads" */
  update_asset_comment_thread_reads_many?: Maybe<Array<Maybe<AssetCommentThreadReadsMutationResponse>>>;
  /** update data of the table: "asset_models" */
  update_asset_models?: Maybe<AssetModelsMutationResponse>;
  /** update single row of the table: "asset_models" */
  update_asset_models_by_pk?: Maybe<AssetModels>;
  /** update multiples rows of table: "asset_models" */
  update_asset_models_many?: Maybe<Array<Maybe<AssetModelsMutationResponse>>>;
  /** update data of the table: "attribution_methods" */
  update_attribution_methods?: Maybe<AttributionMethodsMutationResponse>;
  /** update single row of the table: "attribution_methods" */
  update_attribution_methods_by_pk?: Maybe<AttributionMethods>;
  /** update data of the table: "attribution_methods_interactions" */
  update_attribution_methods_interactions?: Maybe<AttributionMethodsInteractionsMutationResponse>;
  /** update single row of the table: "attribution_methods_interactions" */
  update_attribution_methods_interactions_by_pk?: Maybe<AttributionMethodsInteractions>;
  /** update multiples rows of table: "attribution_methods_interactions" */
  update_attribution_methods_interactions_many?: Maybe<Array<Maybe<AttributionMethodsInteractionsMutationResponse>>>;
  /** update multiples rows of table: "attribution_methods" */
  update_attribution_methods_many?: Maybe<Array<Maybe<AttributionMethodsMutationResponse>>>;
  /** update data of the table: "audience_goals" */
  update_audience_goals?: Maybe<AudienceGoalsMutationResponse>;
  /** update single row of the table: "audience_goals" */
  update_audience_goals_by_pk?: Maybe<AudienceGoals>;
  /** update multiples rows of table: "audience_goals" */
  update_audience_goals_many?: Maybe<Array<Maybe<AudienceGoalsMutationResponse>>>;
  /** update data of the table: "audience_overviews" */
  update_audience_overviews?: Maybe<AudienceOverviewsMutationResponse>;
  /** update single row of the table: "audience_overviews" */
  update_audience_overviews_by_pk?: Maybe<AudienceOverviews>;
  /** update multiples rows of table: "audience_overviews" */
  update_audience_overviews_many?: Maybe<Array<Maybe<AudienceOverviewsMutationResponse>>>;
  /** update data of the table: "audience_primary_metrics" */
  update_audience_primary_metrics?: Maybe<AudiencePrimaryMetricsMutationResponse>;
  /** update single row of the table: "audience_primary_metrics" */
  update_audience_primary_metrics_by_pk?: Maybe<AudiencePrimaryMetrics>;
  /** update multiples rows of table: "audience_primary_metrics" */
  update_audience_primary_metrics_many?: Maybe<Array<Maybe<AudiencePrimaryMetricsMutationResponse>>>;
  /** update data of the table: "audience_splits" */
  update_audience_splits?: Maybe<AudienceSplitsMutationResponse>;
  /** update single row of the table: "audience_splits" */
  update_audience_splits_by_pk?: Maybe<AudienceSplits>;
  /** update multiples rows of table: "audience_splits" */
  update_audience_splits_many?: Maybe<Array<Maybe<AudienceSplitsMutationResponse>>>;
  /** update data of the table: "audience_subset_groups" */
  update_audience_subset_groups?: Maybe<AudienceSubsetGroupsMutationResponse>;
  /** update single row of the table: "audience_subset_groups" */
  update_audience_subset_groups_by_pk?: Maybe<AudienceSubsetGroups>;
  /** update multiples rows of table: "audience_subset_groups" */
  update_audience_subset_groups_many?: Maybe<Array<Maybe<AudienceSubsetGroupsMutationResponse>>>;
  /** update data of the table: "audience_subset_values" */
  update_audience_subset_values?: Maybe<AudienceSubsetValuesMutationResponse>;
  /** update single row of the table: "audience_subset_values" */
  update_audience_subset_values_by_pk?: Maybe<AudienceSubsetValues>;
  /** update multiples rows of table: "audience_subset_values" */
  update_audience_subset_values_many?: Maybe<Array<Maybe<AudienceSubsetValuesMutationResponse>>>;
  /** update data of the table: "audience_templates" */
  update_audience_templates?: Maybe<AudienceTemplatesMutationResponse>;
  /** update single row of the table: "audience_templates" */
  update_audience_templates_by_pk?: Maybe<AudienceTemplates>;
  /** update multiples rows of table: "audience_templates" */
  update_audience_templates_many?: Maybe<Array<Maybe<AudienceTemplatesMutationResponse>>>;
  /** update data of the table: "audiences_subsets" */
  update_audiences_subsets?: Maybe<AudiencesSubsetsMutationResponse>;
  /** update single row of the table: "audiences_subsets" */
  update_audiences_subsets_by_pk?: Maybe<AudiencesSubsets>;
  /** update multiples rows of table: "audiences_subsets" */
  update_audiences_subsets_many?: Maybe<Array<Maybe<AudiencesSubsetsMutationResponse>>>;
  /** update data of the table: "brand_profiles" */
  update_brand_profiles?: Maybe<BrandProfilesMutationResponse>;
  /** update single row of the table: "brand_profiles" */
  update_brand_profiles_by_pk?: Maybe<BrandProfiles>;
  /** update multiples rows of table: "brand_profiles" */
  update_brand_profiles_many?: Maybe<Array<Maybe<BrandProfilesMutationResponse>>>;
  /** update data of the table: "campaign_artifacts" */
  update_campaign_artifacts?: Maybe<CampaignArtifactsMutationResponse>;
  /** update single row of the table: "campaign_artifacts" */
  update_campaign_artifacts_by_pk?: Maybe<CampaignArtifacts>;
  /** update multiples rows of table: "campaign_artifacts" */
  update_campaign_artifacts_many?: Maybe<Array<Maybe<CampaignArtifactsMutationResponse>>>;
  /** update data of the table: "campaign_runs" */
  update_campaign_runs?: Maybe<CampaignRunsMutationResponse>;
  /** update single row of the table: "campaign_runs" */
  update_campaign_runs_by_pk?: Maybe<CampaignRuns>;
  /** update multiples rows of table: "campaign_runs" */
  update_campaign_runs_many?: Maybe<Array<Maybe<CampaignRunsMutationResponse>>>;
  /** update data of the table: "campaigns" */
  update_campaigns?: Maybe<CampaignsMutationResponse>;
  /** update single row of the table: "campaigns" */
  update_campaigns_by_pk?: Maybe<Campaigns>;
  /** update multiples rows of table: "campaigns" */
  update_campaigns_many?: Maybe<Array<Maybe<CampaignsMutationResponse>>>;
  /** update data of the table: "catalog_collections" */
  update_catalog_collections?: Maybe<CatalogCollectionsMutationResponse>;
  /** update single row of the table: "catalog_collections" */
  update_catalog_collections_by_pk?: Maybe<CatalogCollections>;
  /** update multiples rows of table: "catalog_collections" */
  update_catalog_collections_many?: Maybe<Array<Maybe<CatalogCollectionsMutationResponse>>>;
  /** update data of the table: "catalog_models" */
  update_catalog_models?: Maybe<CatalogModelsMutationResponse>;
  /** update single row of the table: "catalog_models" */
  update_catalog_models_by_pk?: Maybe<CatalogModels>;
  /** update multiples rows of table: "catalog_models" */
  update_catalog_models_many?: Maybe<Array<Maybe<CatalogModelsMutationResponse>>>;
  /** update data of the table: "cep_brand_settings" */
  update_cep_brand_settings?: Maybe<CepBrandSettingsMutationResponse>;
  /** update single row of the table: "cep_brand_settings" */
  update_cep_brand_settings_by_pk?: Maybe<CepBrandSettings>;
  /** update multiples rows of table: "cep_brand_settings" */
  update_cep_brand_settings_many?: Maybe<Array<Maybe<CepBrandSettingsMutationResponse>>>;
  /** update data of the table: "cep_channels" */
  update_cep_channels?: Maybe<CepChannelsMutationResponse>;
  /** update single row of the table: "cep_channels" */
  update_cep_channels_by_pk?: Maybe<CepChannels>;
  /** update multiples rows of table: "cep_channels" */
  update_cep_channels_many?: Maybe<Array<Maybe<CepChannelsMutationResponse>>>;
  /** update data of the table: "cep_content_blocks" */
  update_cep_content_blocks?: Maybe<CepContentBlocksMutationResponse>;
  /** update single row of the table: "cep_content_blocks" */
  update_cep_content_blocks_by_pk?: Maybe<CepContentBlocks>;
  /** update multiples rows of table: "cep_content_blocks" */
  update_cep_content_blocks_many?: Maybe<Array<Maybe<CepContentBlocksMutationResponse>>>;
  /** update data of the table: "cep_domains" */
  update_cep_domains?: Maybe<CepDomainsMutationResponse>;
  /** update single row of the table: "cep_domains" */
  update_cep_domains_by_pk?: Maybe<CepDomains>;
  /** update multiples rows of table: "cep_domains" */
  update_cep_domains_many?: Maybe<Array<Maybe<CepDomainsMutationResponse>>>;
  /** update data of the table: "cep_email_template_contents" */
  update_cep_email_template_contents?: Maybe<CepEmailTemplateContentsMutationResponse>;
  /** update single row of the table: "cep_email_template_contents" */
  update_cep_email_template_contents_by_pk?: Maybe<CepEmailTemplateContents>;
  /** update multiples rows of table: "cep_email_template_contents" */
  update_cep_email_template_contents_many?: Maybe<Array<Maybe<CepEmailTemplateContentsMutationResponse>>>;
  /** update data of the table: "cep_email_templates" */
  update_cep_email_templates?: Maybe<CepEmailTemplatesMutationResponse>;
  /** update single row of the table: "cep_email_templates" */
  update_cep_email_templates_by_pk?: Maybe<CepEmailTemplates>;
  /** update multiples rows of table: "cep_email_templates" */
  update_cep_email_templates_many?: Maybe<Array<Maybe<CepEmailTemplatesMutationResponse>>>;
  /** update data of the table: "cep_locales" */
  update_cep_locales?: Maybe<CepLocalesMutationResponse>;
  /** update single row of the table: "cep_locales" */
  update_cep_locales_by_pk?: Maybe<CepLocales>;
  /** update multiples rows of table: "cep_locales" */
  update_cep_locales_many?: Maybe<Array<Maybe<CepLocalesMutationResponse>>>;
  /** update data of the table: "cep_localization_settings" */
  update_cep_localization_settings?: Maybe<CepLocalizationSettingsMutationResponse>;
  /** update single row of the table: "cep_localization_settings" */
  update_cep_localization_settings_by_pk?: Maybe<CepLocalizationSettings>;
  /** update multiples rows of table: "cep_localization_settings" */
  update_cep_localization_settings_many?: Maybe<Array<Maybe<CepLocalizationSettingsMutationResponse>>>;
  /** update data of the table: "cep_message_device_previews" */
  update_cep_message_device_previews?: Maybe<CepMessageDevicePreviewsMutationResponse>;
  /** update single row of the table: "cep_message_device_previews" */
  update_cep_message_device_previews_by_pk?: Maybe<CepMessageDevicePreviews>;
  /** update multiples rows of table: "cep_message_device_previews" */
  update_cep_message_device_previews_many?: Maybe<Array<Maybe<CepMessageDevicePreviewsMutationResponse>>>;
  /** update data of the table: "cep_providers" */
  update_cep_providers?: Maybe<CepProvidersMutationResponse>;
  /** update single row of the table: "cep_providers" */
  update_cep_providers_by_pk?: Maybe<CepProviders>;
  /** update multiples rows of table: "cep_providers" */
  update_cep_providers_many?: Maybe<Array<Maybe<CepProvidersMutationResponse>>>;
  /** update data of the table: "cep_sender_identities" */
  update_cep_sender_identities?: Maybe<CepSenderIdentitiesMutationResponse>;
  /** update single row of the table: "cep_sender_identities" */
  update_cep_sender_identities_by_pk?: Maybe<CepSenderIdentities>;
  /** update multiples rows of table: "cep_sender_identities" */
  update_cep_sender_identities_many?: Maybe<Array<Maybe<CepSenderIdentitiesMutationResponse>>>;
  /** update data of the table: "cep_subscription_topics" */
  update_cep_subscription_topics?: Maybe<CepSubscriptionTopicsMutationResponse>;
  /** update single row of the table: "cep_subscription_topics" */
  update_cep_subscription_topics_by_pk?: Maybe<CepSubscriptionTopics>;
  /** update multiples rows of table: "cep_subscription_topics" */
  update_cep_subscription_topics_many?: Maybe<Array<Maybe<CepSubscriptionTopicsMutationResponse>>>;
  /** update data of the table: "cep_suppression_lists" */
  update_cep_suppression_lists?: Maybe<CepSuppressionListsMutationResponse>;
  /** update single row of the table: "cep_suppression_lists" */
  update_cep_suppression_lists_by_pk?: Maybe<CepSuppressionLists>;
  /** update multiples rows of table: "cep_suppression_lists" */
  update_cep_suppression_lists_many?: Maybe<Array<Maybe<CepSuppressionListsMutationResponse>>>;
  /** update data of the table: "cep_test_groups" */
  update_cep_test_groups?: Maybe<CepTestGroupsMutationResponse>;
  /** update single row of the table: "cep_test_groups" */
  update_cep_test_groups_by_pk?: Maybe<CepTestGroups>;
  /** update multiples rows of table: "cep_test_groups" */
  update_cep_test_groups_many?: Maybe<Array<Maybe<CepTestGroupsMutationResponse>>>;
  /** update data of the table: "cep_workspace_config" */
  update_cep_workspace_config?: Maybe<CepWorkspaceConfigMutationResponse>;
  /** update single row of the table: "cep_workspace_config" */
  update_cep_workspace_config_by_pk?: Maybe<CepWorkspaceConfig>;
  /** update multiples rows of table: "cep_workspace_config" */
  update_cep_workspace_config_many?: Maybe<Array<Maybe<CepWorkspaceConfigMutationResponse>>>;
  /** update data of the table: "content_blocks" */
  update_content_blocks?: Maybe<ContentBlocksMutationResponse>;
  /** update single row of the table: "content_blocks" */
  update_content_blocks_by_pk?: Maybe<ContentBlocks>;
  /** update multiples rows of table: "content_blocks" */
  update_content_blocks_many?: Maybe<Array<Maybe<ContentBlocksMutationResponse>>>;
  /** update data of the table: "content_dynamic_slot_assignments" */
  update_content_dynamic_slot_assignments?: Maybe<ContentDynamicSlotAssignmentsMutationResponse>;
  /** update single row of the table: "content_dynamic_slot_assignments" */
  update_content_dynamic_slot_assignments_by_pk?: Maybe<ContentDynamicSlotAssignments>;
  /** update multiples rows of table: "content_dynamic_slot_assignments" */
  update_content_dynamic_slot_assignments_many?: Maybe<Array<Maybe<ContentDynamicSlotAssignmentsMutationResponse>>>;
  /** update data of the table: "content_dynamic_slot_branches" */
  update_content_dynamic_slot_branches?: Maybe<ContentDynamicSlotBranchesMutationResponse>;
  /** update single row of the table: "content_dynamic_slot_branches" */
  update_content_dynamic_slot_branches_by_pk?: Maybe<ContentDynamicSlotBranches>;
  /** update multiples rows of table: "content_dynamic_slot_branches" */
  update_content_dynamic_slot_branches_many?: Maybe<Array<Maybe<ContentDynamicSlotBranchesMutationResponse>>>;
  /** update data of the table: "content_dynamic_slot_contents" */
  update_content_dynamic_slot_contents?: Maybe<ContentDynamicSlotContentsMutationResponse>;
  /** update single row of the table: "content_dynamic_slot_contents" */
  update_content_dynamic_slot_contents_by_pk?: Maybe<ContentDynamicSlotContents>;
  /** update multiples rows of table: "content_dynamic_slot_contents" */
  update_content_dynamic_slot_contents_many?: Maybe<Array<Maybe<ContentDynamicSlotContentsMutationResponse>>>;
  /** update data of the table: "content_dynamic_slot_libraries" */
  update_content_dynamic_slot_libraries?: Maybe<ContentDynamicSlotLibrariesMutationResponse>;
  /** update single row of the table: "content_dynamic_slot_libraries" */
  update_content_dynamic_slot_libraries_by_pk?: Maybe<ContentDynamicSlotLibraries>;
  /** update multiples rows of table: "content_dynamic_slot_libraries" */
  update_content_dynamic_slot_libraries_many?: Maybe<Array<Maybe<ContentDynamicSlotLibrariesMutationResponse>>>;
  /** update data of the table: "content_dynamic_slot_usages" */
  update_content_dynamic_slot_usages?: Maybe<ContentDynamicSlotUsagesMutationResponse>;
  /** update single row of the table: "content_dynamic_slot_usages" */
  update_content_dynamic_slot_usages_by_pk?: Maybe<ContentDynamicSlotUsages>;
  /** update multiples rows of table: "content_dynamic_slot_usages" */
  update_content_dynamic_slot_usages_many?: Maybe<Array<Maybe<ContentDynamicSlotUsagesMutationResponse>>>;
  /** update data of the table: "content_email_variants" */
  update_content_email_variants?: Maybe<ContentEmailVariantsMutationResponse>;
  /** update single row of the table: "content_email_variants" */
  update_content_email_variants_by_pk?: Maybe<ContentEmailVariants>;
  /** update multiples rows of table: "content_email_variants" */
  update_content_email_variants_many?: Maybe<Array<Maybe<ContentEmailVariantsMutationResponse>>>;
  /** update data of the table: "content_emails" */
  update_content_emails?: Maybe<ContentEmailsMutationResponse>;
  /** update single row of the table: "content_emails" */
  update_content_emails_by_pk?: Maybe<ContentEmails>;
  /** update multiples rows of table: "content_emails" */
  update_content_emails_many?: Maybe<Array<Maybe<ContentEmailsMutationResponse>>>;
  /** update data of the table: "content_settings" */
  update_content_settings?: Maybe<ContentSettingsMutationResponse>;
  /** update single row of the table: "content_settings" */
  update_content_settings_by_pk?: Maybe<ContentSettings>;
  /** update multiples rows of table: "content_settings" */
  update_content_settings_many?: Maybe<Array<Maybe<ContentSettingsMutationResponse>>>;
  /** update data of the table: "content_templates" */
  update_content_templates?: Maybe<ContentTemplatesMutationResponse>;
  /** update single row of the table: "content_templates" */
  update_content_templates_by_pk?: Maybe<ContentTemplates>;
  /** update multiples rows of table: "content_templates" */
  update_content_templates_many?: Maybe<Array<Maybe<ContentTemplatesMutationResponse>>>;
  /** update data of the table: "custom_agents" */
  update_custom_agents?: Maybe<CustomAgentsMutationResponse>;
  /** update single row of the table: "custom_agents" */
  update_custom_agents_by_pk?: Maybe<CustomAgents>;
  /** update multiples rows of table: "custom_agents" */
  update_custom_agents_many?: Maybe<Array<Maybe<CustomAgentsMutationResponse>>>;
  /** update data of the table: "dashboards" */
  update_dashboards?: Maybe<DashboardsMutationResponse>;
  /** update single row of the table: "dashboards" */
  update_dashboards_by_pk?: Maybe<Dashboards>;
  /** update multiples rows of table: "dashboards" */
  update_dashboards_many?: Maybe<Array<Maybe<DashboardsMutationResponse>>>;
  /** update data of the table: "datadog_credentials" */
  update_datadog_credentials?: Maybe<DatadogCredentialsMutationResponse>;
  /** update single row of the table: "datadog_credentials" */
  update_datadog_credentials_by_pk?: Maybe<DatadogCredentials>;
  /** update multiples rows of table: "datadog_credentials" */
  update_datadog_credentials_many?: Maybe<Array<Maybe<DatadogCredentialsMutationResponse>>>;
  /** update data of the table: "dbt_cloud_sync_config" */
  update_dbt_cloud_sync_config?: Maybe<DbtCloudSyncConfigMutationResponse>;
  /** update single row of the table: "dbt_cloud_sync_config" */
  update_dbt_cloud_sync_config_by_pk?: Maybe<DbtCloudSyncConfig>;
  /** update multiples rows of table: "dbt_cloud_sync_config" */
  update_dbt_cloud_sync_config_many?: Maybe<Array<Maybe<DbtCloudSyncConfigMutationResponse>>>;
  /** update data of the table: "dbt_sync_config" */
  update_dbt_sync_config?: Maybe<DbtSyncConfigMutationResponse>;
  /** update single row of the table: "dbt_sync_config" */
  update_dbt_sync_config_by_pk?: Maybe<DbtSyncConfig>;
  /** update multiples rows of table: "dbt_sync_config" */
  update_dbt_sync_config_many?: Maybe<Array<Maybe<DbtSyncConfigMutationResponse>>>;
  /** update data of the table: "decision_engine_channels" */
  update_decision_engine_channels?: Maybe<DecisionEngineChannelsMutationResponse>;
  /** update single row of the table: "decision_engine_channels" */
  update_decision_engine_channels_by_pk?: Maybe<DecisionEngineChannels>;
  /** update multiples rows of table: "decision_engine_channels" */
  update_decision_engine_channels_many?: Maybe<Array<Maybe<DecisionEngineChannelsMutationResponse>>>;
  /** update data of the table: "decision_engine_collections" */
  update_decision_engine_collections?: Maybe<DecisionEngineCollectionsMutationResponse>;
  /** update single row of the table: "decision_engine_collections" */
  update_decision_engine_collections_by_pk?: Maybe<DecisionEngineCollections>;
  /** update multiples rows of table: "decision_engine_collections" */
  update_decision_engine_collections_many?: Maybe<Array<Maybe<DecisionEngineCollectionsMutationResponse>>>;
  /** update data of the table: "decision_engine_content_recommendations" */
  update_decision_engine_content_recommendations?: Maybe<DecisionEngineContentRecommendationsMutationResponse>;
  /** update single row of the table: "decision_engine_content_recommendations" */
  update_decision_engine_content_recommendations_by_pk?: Maybe<DecisionEngineContentRecommendations>;
  /** update multiples rows of table: "decision_engine_content_recommendations" */
  update_decision_engine_content_recommendations_many?: Maybe<Array<Maybe<DecisionEngineContentRecommendationsMutationResponse>>>;
  /** update data of the table: "decision_engine_feature_matrices" */
  update_decision_engine_feature_matrices?: Maybe<DecisionEngineFeatureMatricesMutationResponse>;
  /** update single row of the table: "decision_engine_feature_matrices" */
  update_decision_engine_feature_matrices_by_pk?: Maybe<DecisionEngineFeatureMatrices>;
  /** update multiples rows of table: "decision_engine_feature_matrices" */
  update_decision_engine_feature_matrices_many?: Maybe<Array<Maybe<DecisionEngineFeatureMatricesMutationResponse>>>;
  /** update data of the table: "decision_engine_feature_matrix_relationships" */
  update_decision_engine_feature_matrix_relationships?: Maybe<DecisionEngineFeatureMatrixRelationshipsMutationResponse>;
  /** update single row of the table: "decision_engine_feature_matrix_relationships" */
  update_decision_engine_feature_matrix_relationships_by_pk?: Maybe<DecisionEngineFeatureMatrixRelationships>;
  /** update multiples rows of table: "decision_engine_feature_matrix_relationships" */
  update_decision_engine_feature_matrix_relationships_many?: Maybe<Array<Maybe<DecisionEngineFeatureMatrixRelationshipsMutationResponse>>>;
  /** update data of the table: "decision_engine_flow_experiments" */
  update_decision_engine_flow_experiments?: Maybe<DecisionEngineFlowExperimentsMutationResponse>;
  /** update single row of the table: "decision_engine_flow_experiments" */
  update_decision_engine_flow_experiments_by_pk?: Maybe<DecisionEngineFlowExperiments>;
  /** update multiples rows of table: "decision_engine_flow_experiments" */
  update_decision_engine_flow_experiments_many?: Maybe<Array<Maybe<DecisionEngineFlowExperimentsMutationResponse>>>;
  /** update data of the table: "decision_engine_flow_tags" */
  update_decision_engine_flow_tags?: Maybe<DecisionEngineFlowTagsMutationResponse>;
  /** update single row of the table: "decision_engine_flow_tags" */
  update_decision_engine_flow_tags_by_pk?: Maybe<DecisionEngineFlowTags>;
  /** update multiples rows of table: "decision_engine_flow_tags" */
  update_decision_engine_flow_tags_many?: Maybe<Array<Maybe<DecisionEngineFlowTagsMutationResponse>>>;
  /** update data of the table: "decision_engine_flows" */
  update_decision_engine_flows?: Maybe<DecisionEngineFlowsMutationResponse>;
  /** update single row of the table: "decision_engine_flows" */
  update_decision_engine_flows_by_pk?: Maybe<DecisionEngineFlows>;
  /** update multiples rows of table: "decision_engine_flows" */
  update_decision_engine_flows_many?: Maybe<Array<Maybe<DecisionEngineFlowsMutationResponse>>>;
  /** update data of the table: "decision_engine_message_collections" */
  update_decision_engine_message_collections?: Maybe<DecisionEngineMessageCollectionsMutationResponse>;
  /** update single row of the table: "decision_engine_message_collections" */
  update_decision_engine_message_collections_by_pk?: Maybe<DecisionEngineMessageCollections>;
  /** update multiples rows of table: "decision_engine_message_collections" */
  update_decision_engine_message_collections_many?: Maybe<Array<Maybe<DecisionEngineMessageCollectionsMutationResponse>>>;
  /** update data of the table: "decision_engine_message_variant_suggestions" */
  update_decision_engine_message_variant_suggestions?: Maybe<DecisionEngineMessageVariantSuggestionsMutationResponse>;
  /** update single row of the table: "decision_engine_message_variant_suggestions" */
  update_decision_engine_message_variant_suggestions_by_pk?: Maybe<DecisionEngineMessageVariantSuggestions>;
  /** update multiples rows of table: "decision_engine_message_variant_suggestions" */
  update_decision_engine_message_variant_suggestions_many?: Maybe<Array<Maybe<DecisionEngineMessageVariantSuggestionsMutationResponse>>>;
  /** update data of the table: "decision_engine_model_outcomes" */
  update_decision_engine_model_outcomes?: Maybe<DecisionEngineModelOutcomesMutationResponse>;
  /** update single row of the table: "decision_engine_model_outcomes" */
  update_decision_engine_model_outcomes_by_pk?: Maybe<DecisionEngineModelOutcomes>;
  /** update multiples rows of table: "decision_engine_model_outcomes" */
  update_decision_engine_model_outcomes_many?: Maybe<Array<Maybe<DecisionEngineModelOutcomesMutationResponse>>>;
  /** update data of the table: "decision_engine_models" */
  update_decision_engine_models?: Maybe<DecisionEngineModelsMutationResponse>;
  /** update single row of the table: "decision_engine_models" */
  update_decision_engine_models_by_pk?: Maybe<DecisionEngineModels>;
  /** update multiples rows of table: "decision_engine_models" */
  update_decision_engine_models_many?: Maybe<Array<Maybe<DecisionEngineModelsMutationResponse>>>;
  /** update data of the table: "decision_engine_offers" */
  update_decision_engine_offers?: Maybe<DecisionEngineOffersMutationResponse>;
  /** update single row of the table: "decision_engine_offers" */
  update_decision_engine_offers_by_pk?: Maybe<DecisionEngineOffers>;
  /** update multiples rows of table: "decision_engine_offers" */
  update_decision_engine_offers_many?: Maybe<Array<Maybe<DecisionEngineOffersMutationResponse>>>;
  /** update data of the table: "decision_engine_outcomes" */
  update_decision_engine_outcomes?: Maybe<DecisionEngineOutcomesMutationResponse>;
  /** update single row of the table: "decision_engine_outcomes" */
  update_decision_engine_outcomes_by_pk?: Maybe<DecisionEngineOutcomes>;
  /** update multiples rows of table: "decision_engine_outcomes" */
  update_decision_engine_outcomes_many?: Maybe<Array<Maybe<DecisionEngineOutcomesMutationResponse>>>;
  /** update data of the table: "decision_engine_send_events" */
  update_decision_engine_send_events?: Maybe<DecisionEngineSendEventsMutationResponse>;
  /** update single row of the table: "decision_engine_send_events" */
  update_decision_engine_send_events_by_pk?: Maybe<DecisionEngineSendEvents>;
  /** update multiples rows of table: "decision_engine_send_events" */
  update_decision_engine_send_events_many?: Maybe<Array<Maybe<DecisionEngineSendEventsMutationResponse>>>;
  /** update data of the table: "decision_engine_splits" */
  update_decision_engine_splits?: Maybe<DecisionEngineSplitsMutationResponse>;
  /** update single row of the table: "decision_engine_splits" */
  update_decision_engine_splits_by_pk?: Maybe<DecisionEngineSplits>;
  /** update multiples rows of table: "decision_engine_splits" */
  update_decision_engine_splits_many?: Maybe<Array<Maybe<DecisionEngineSplitsMutationResponse>>>;
  /** update data of the table: "decision_engines" */
  update_decision_engines?: Maybe<DecisionEnginesMutationResponse>;
  /** update single row of the table: "decision_engines" */
  update_decision_engines_by_pk?: Maybe<DecisionEngines>;
  /** update multiples rows of table: "decision_engines" */
  update_decision_engines_many?: Maybe<Array<Maybe<DecisionEnginesMutationResponse>>>;
  /** update data of the table: "deliverability_feeds" */
  update_deliverability_feeds?: Maybe<DeliverabilityFeedsMutationResponse>;
  /** update single row of the table: "deliverability_feeds" */
  update_deliverability_feeds_by_pk?: Maybe<DeliverabilityFeeds>;
  /** update multiples rows of table: "deliverability_feeds" */
  update_deliverability_feeds_many?: Maybe<Array<Maybe<DeliverabilityFeedsMutationResponse>>>;
  /** update data of the table: "destination_instance_splits" */
  update_destination_instance_splits?: Maybe<DestinationInstanceSplitsMutationResponse>;
  /** update single row of the table: "destination_instance_splits" */
  update_destination_instance_splits_by_pk?: Maybe<DestinationInstanceSplits>;
  /** update multiples rows of table: "destination_instance_splits" */
  update_destination_instance_splits_many?: Maybe<Array<Maybe<DestinationInstanceSplitsMutationResponse>>>;
  /** update data of the table: "destination_instances" */
  update_destination_instances?: Maybe<DestinationInstancesMutationResponse>;
  /** update single row of the table: "destination_instances" */
  update_destination_instances_by_pk?: Maybe<DestinationInstances>;
  /** update multiples rows of table: "destination_instances" */
  update_destination_instances_many?: Maybe<Array<Maybe<DestinationInstancesMutationResponse>>>;
  /** update data of the table: "destination_rules" */
  update_destination_rules?: Maybe<DestinationRulesMutationResponse>;
  /** update single row of the table: "destination_rules" */
  update_destination_rules_by_pk?: Maybe<DestinationRules>;
  /** update multiples rows of table: "destination_rules" */
  update_destination_rules_many?: Maybe<Array<Maybe<DestinationRulesMutationResponse>>>;
  /** update data of the table: "direct_model_relationships" */
  update_direct_model_relationships?: Maybe<DirectModelRelationshipsMutationResponse>;
  /** update single row of the table: "direct_model_relationships" */
  update_direct_model_relationships_by_pk?: Maybe<DirectModelRelationships>;
  /** update multiples rows of table: "direct_model_relationships" */
  update_direct_model_relationships_many?: Maybe<Array<Maybe<DirectModelRelationshipsMutationResponse>>>;
  /** update data of the table: "etl_connections" */
  update_etl_connections?: Maybe<EtlConnectionsMutationResponse>;
  /** update single row of the table: "etl_connections" */
  update_etl_connections_by_pk?: Maybe<EtlConnections>;
  /** update multiples rows of table: "etl_connections" */
  update_etl_connections_many?: Maybe<Array<Maybe<EtlConnectionsMutationResponse>>>;
  /** update data of the table: "event_components" */
  update_event_components?: Maybe<EventComponentsMutationResponse>;
  /** update single row of the table: "event_components" */
  update_event_components_by_pk?: Maybe<EventComponents>;
  /** update multiples rows of table: "event_components" */
  update_event_components_many?: Maybe<Array<Maybe<EventComponentsMutationResponse>>>;
  /** update data of the table: "event_contracts" */
  update_event_contracts?: Maybe<EventContractsMutationResponse>;
  /** update single row of the table: "event_contracts" */
  update_event_contracts_by_pk?: Maybe<EventContracts>;
  /** update multiples rows of table: "event_contracts" */
  update_event_contracts_many?: Maybe<Array<Maybe<EventContractsMutationResponse>>>;
  /** update data of the table: "event_contracts_schema" */
  update_event_contracts_schema?: Maybe<EventContractsSchemaMutationResponse>;
  /** update single row of the table: "event_contracts_schema" */
  update_event_contracts_schema_by_pk?: Maybe<EventContractsSchema>;
  /** update multiples rows of table: "event_contracts_schema" */
  update_event_contracts_schema_many?: Maybe<Array<Maybe<EventContractsSchemaMutationResponse>>>;
  /** update data of the table: "event_forwarding_destination_grants" */
  update_event_forwarding_destination_grants?: Maybe<EventForwardingDestinationGrantsMutationResponse>;
  /** update single row of the table: "event_forwarding_destination_grants" */
  update_event_forwarding_destination_grants_by_pk?: Maybe<EventForwardingDestinationGrants>;
  /** update multiples rows of table: "event_forwarding_destination_grants" */
  update_event_forwarding_destination_grants_many?: Maybe<Array<Maybe<EventForwardingDestinationGrantsMutationResponse>>>;
  /** update data of the table: "event_forwarding_syncs" */
  update_event_forwarding_syncs?: Maybe<EventForwardingSyncsMutationResponse>;
  /** update single row of the table: "event_forwarding_syncs" */
  update_event_forwarding_syncs_by_pk?: Maybe<EventForwardingSyncs>;
  /** update multiples rows of table: "event_forwarding_syncs" */
  update_event_forwarding_syncs_many?: Maybe<Array<Maybe<EventForwardingSyncsMutationResponse>>>;
  /** update data of the table: "event_models" */
  update_event_models?: Maybe<EventModelsMutationResponse>;
  /** update single row of the table: "event_models" */
  update_event_models_by_pk?: Maybe<EventModels>;
  /** update multiples rows of table: "event_models" */
  update_event_models_many?: Maybe<Array<Maybe<EventModelsMutationResponse>>>;
  /** update data of the table: "event_plan_grants" */
  update_event_plan_grants?: Maybe<EventPlanGrantsMutationResponse>;
  /** update single row of the table: "event_plan_grants" */
  update_event_plan_grants_by_pk?: Maybe<EventPlanGrants>;
  /** update multiples rows of table: "event_plan_grants" */
  update_event_plan_grants_many?: Maybe<Array<Maybe<EventPlanGrantsMutationResponse>>>;
  /** update data of the table: "event_plans" */
  update_event_plans?: Maybe<EventPlansMutationResponse>;
  /** update single row of the table: "event_plans" */
  update_event_plans_by_pk?: Maybe<EventPlans>;
  /** update multiples rows of table: "event_plans" */
  update_event_plans_many?: Maybe<Array<Maybe<EventPlansMutationResponse>>>;
  /** update data of the table: "event_schemas" */
  update_event_schemas?: Maybe<EventSchemasMutationResponse>;
  /** update single row of the table: "event_schemas" */
  update_event_schemas_by_pk?: Maybe<EventSchemas>;
  /** update multiples rows of table: "event_schemas" */
  update_event_schemas_many?: Maybe<Array<Maybe<EventSchemasMutationResponse>>>;
  /** update data of the table: "event_source_contracts" */
  update_event_source_contracts?: Maybe<EventSourceContractsMutationResponse>;
  /** update single row of the table: "event_source_contracts" */
  update_event_source_contracts_by_pk?: Maybe<EventSourceContracts>;
  /** update multiples rows of table: "event_source_contracts" */
  update_event_source_contracts_many?: Maybe<Array<Maybe<EventSourceContractsMutationResponse>>>;
  /** update data of the table: "event_source_grants" */
  update_event_source_grants?: Maybe<EventSourceGrantsMutationResponse>;
  /** update single row of the table: "event_source_grants" */
  update_event_source_grants_by_pk?: Maybe<EventSourceGrants>;
  /** update multiples rows of table: "event_source_grants" */
  update_event_source_grants_many?: Maybe<Array<Maybe<EventSourceGrantsMutationResponse>>>;
  /** update data of the table: "event_warehouse_destination_grants" */
  update_event_warehouse_destination_grants?: Maybe<EventWarehouseDestinationGrantsMutationResponse>;
  /** update single row of the table: "event_warehouse_destination_grants" */
  update_event_warehouse_destination_grants_by_pk?: Maybe<EventWarehouseDestinationGrants>;
  /** update multiples rows of table: "event_warehouse_destination_grants" */
  update_event_warehouse_destination_grants_many?: Maybe<Array<Maybe<EventWarehouseDestinationGrantsMutationResponse>>>;
  /** update data of the table: "event_warehouse_destinations" */
  update_event_warehouse_destinations?: Maybe<EventWarehouseDestinationsMutationResponse>;
  /** update single row of the table: "event_warehouse_destinations" */
  update_event_warehouse_destinations_by_pk?: Maybe<EventWarehouseDestinations>;
  /** update multiples rows of table: "event_warehouse_destinations" */
  update_event_warehouse_destinations_many?: Maybe<Array<Maybe<EventWarehouseDestinationsMutationResponse>>>;
  /** update data of the table: "event_warehouse_syncs" */
  update_event_warehouse_syncs?: Maybe<EventWarehouseSyncsMutationResponse>;
  /** update single row of the table: "event_warehouse_syncs" */
  update_event_warehouse_syncs_by_pk?: Maybe<EventWarehouseSyncs>;
  /** update multiples rows of table: "event_warehouse_syncs" */
  update_event_warehouse_syncs_many?: Maybe<Array<Maybe<EventWarehouseSyncsMutationResponse>>>;
  /** update data of the table: "experiment_metrics" */
  update_experiment_metrics?: Maybe<ExperimentMetricsMutationResponse>;
  /** update single row of the table: "experiment_metrics" */
  update_experiment_metrics_by_pk?: Maybe<ExperimentMetrics>;
  /** update multiples rows of table: "experiment_metrics" */
  update_experiment_metrics_many?: Maybe<Array<Maybe<ExperimentMetricsMutationResponse>>>;
  /** update data of the table: "experiments" */
  update_experiments?: Maybe<ExperimentsMutationResponse>;
  /** update single row of the table: "experiments" */
  update_experiments_by_pk?: Maybe<Experiments>;
  /** update multiples rows of table: "experiments" */
  update_experiments_many?: Maybe<Array<Maybe<ExperimentsMutationResponse>>>;
  /** update data of the table: "external_buckets" */
  update_external_buckets?: Maybe<ExternalBucketsMutationResponse>;
  /** update single row of the table: "external_buckets" */
  update_external_buckets_by_pk?: Maybe<ExternalBuckets>;
  /** update multiples rows of table: "external_buckets" */
  update_external_buckets_many?: Maybe<Array<Maybe<ExternalBucketsMutationResponse>>>;
  /** update data of the table: "figma_import_drafts" */
  update_figma_import_drafts?: Maybe<FigmaImportDraftsMutationResponse>;
  /** update single row of the table: "figma_import_drafts" */
  update_figma_import_drafts_by_pk?: Maybe<FigmaImportDrafts>;
  /** update multiples rows of table: "figma_import_drafts" */
  update_figma_import_drafts_many?: Maybe<Array<Maybe<FigmaImportDraftsMutationResponse>>>;
  /** update data of the table: "fivetran_agent_syncs" */
  update_fivetran_agent_syncs?: Maybe<FivetranAgentSyncsMutationResponse>;
  /** update single row of the table: "fivetran_agent_syncs" */
  update_fivetran_agent_syncs_by_pk?: Maybe<FivetranAgentSyncs>;
  /** update multiples rows of table: "fivetran_agent_syncs" */
  update_fivetran_agent_syncs_many?: Maybe<Array<Maybe<FivetranAgentSyncsMutationResponse>>>;
  /** update data of the table: "fivetran_credentials" */
  update_fivetran_credentials?: Maybe<FivetranCredentialsMutationResponse>;
  /** update single row of the table: "fivetran_credentials" */
  update_fivetran_credentials_by_pk?: Maybe<FivetranCredentials>;
  /** update multiples rows of table: "fivetran_credentials" */
  update_fivetran_credentials_many?: Maybe<Array<Maybe<FivetranCredentialsMutationResponse>>>;
  /** update data of the table: "folders" */
  update_folders?: Maybe<FoldersMutationResponse>;
  /** update single row of the table: "folders" */
  update_folders_by_pk?: Maybe<Folders>;
  /** update multiples rows of table: "folders" */
  update_folders_many?: Maybe<Array<Maybe<FoldersMutationResponse>>>;
  /** update data of the table: "function_grants" */
  update_function_grants?: Maybe<FunctionGrantsMutationResponse>;
  /** update single row of the table: "function_grants" */
  update_function_grants_by_pk?: Maybe<FunctionGrants>;
  /** update multiples rows of table: "function_grants" */
  update_function_grants_many?: Maybe<Array<Maybe<FunctionGrantsMutationResponse>>>;
  /** update data of the table: "function_resources" */
  update_function_resources?: Maybe<FunctionResourcesMutationResponse>;
  /** update single row of the table: "function_resources" */
  update_function_resources_by_pk?: Maybe<FunctionResources>;
  /** update multiples rows of table: "function_resources" */
  update_function_resources_many?: Maybe<Array<Maybe<FunctionResourcesMutationResponse>>>;
  /** update data of the table: "function_settings" */
  update_function_settings?: Maybe<FunctionSettingsMutationResponse>;
  /** update single row of the table: "function_settings" */
  update_function_settings_by_pk?: Maybe<FunctionSettings>;
  /** update multiples rows of table: "function_settings" */
  update_function_settings_many?: Maybe<Array<Maybe<FunctionSettingsMutationResponse>>>;
  /** update data of the table: "functions" */
  update_functions?: Maybe<FunctionsMutationResponse>;
  /** update single row of the table: "functions" */
  update_functions_by_pk?: Maybe<Functions>;
  /** update multiples rows of table: "functions" */
  update_functions_many?: Maybe<Array<Maybe<FunctionsMutationResponse>>>;
  /** update data of the table: "git_sync_configs" */
  update_git_sync_configs?: Maybe<GitSyncConfigsMutationResponse>;
  /** update single row of the table: "git_sync_configs" */
  update_git_sync_configs_by_pk?: Maybe<GitSyncConfigs>;
  /** update multiples rows of table: "git_sync_configs" */
  update_git_sync_configs_many?: Maybe<Array<Maybe<GitSyncConfigsMutationResponse>>>;
  /** update data of the table: "goals" */
  update_goals?: Maybe<GoalsMutationResponse>;
  /** update data of the table: "goals_attribution_methods" */
  update_goals_attribution_methods?: Maybe<GoalsAttributionMethodsMutationResponse>;
  /** update single row of the table: "goals_attribution_methods" */
  update_goals_attribution_methods_by_pk?: Maybe<GoalsAttributionMethods>;
  /** update multiples rows of table: "goals_attribution_methods" */
  update_goals_attribution_methods_many?: Maybe<Array<Maybe<GoalsAttributionMethodsMutationResponse>>>;
  /** update single row of the table: "goals" */
  update_goals_by_pk?: Maybe<Goals>;
  /** update multiples rows of table: "goals" */
  update_goals_many?: Maybe<Array<Maybe<GoalsMutationResponse>>>;
  /** update data of the table: "initiative_goals" */
  update_initiative_goals?: Maybe<InitiativeGoalsMutationResponse>;
  /** update single row of the table: "initiative_goals" */
  update_initiative_goals_by_pk?: Maybe<InitiativeGoals>;
  /** update multiples rows of table: "initiative_goals" */
  update_initiative_goals_many?: Maybe<Array<Maybe<InitiativeGoalsMutationResponse>>>;
  /** update data of the table: "initiative_insights" */
  update_initiative_insights?: Maybe<InitiativeInsightsMutationResponse>;
  /** update single row of the table: "initiative_insights" */
  update_initiative_insights_by_pk?: Maybe<InitiativeInsights>;
  /** update multiples rows of table: "initiative_insights" */
  update_initiative_insights_many?: Maybe<Array<Maybe<InitiativeInsightsMutationResponse>>>;
  /** update data of the table: "interaction_models" */
  update_interaction_models?: Maybe<InteractionModelsMutationResponse>;
  /** update single row of the table: "interaction_models" */
  update_interaction_models_by_pk?: Maybe<InteractionModels>;
  /** update multiples rows of table: "interaction_models" */
  update_interaction_models_many?: Maybe<Array<Maybe<InteractionModelsMutationResponse>>>;
  /** update data of the table: "journeys" */
  update_journeys?: Maybe<JourneysMutationResponse>;
  /** update single row of the table: "journeys" */
  update_journeys_by_pk?: Maybe<Journeys>;
  /** update multiples rows of table: "journeys" */
  update_journeys_many?: Maybe<Array<Maybe<JourneysMutationResponse>>>;
  /** update data of the table: "label_groups" */
  update_label_groups?: Maybe<LabelGroupsMutationResponse>;
  /** update single row of the table: "label_groups" */
  update_label_groups_by_pk?: Maybe<LabelGroups>;
  /** update multiples rows of table: "label_groups" */
  update_label_groups_many?: Maybe<Array<Maybe<LabelGroupsMutationResponse>>>;
  /** update data of the table: "labels" */
  update_labels?: Maybe<LabelsMutationResponse>;
  /** update single row of the table: "labels" */
  update_labels_by_pk?: Maybe<Labels>;
  /** update multiples rows of table: "labels" */
  update_labels_many?: Maybe<Array<Maybe<LabelsMutationResponse>>>;
  /** update data of the table: "lcm_message_candidates" */
  update_lcm_message_candidates?: Maybe<LcmMessageCandidatesMutationResponse>;
  /** update single row of the table: "lcm_message_candidates" */
  update_lcm_message_candidates_by_pk?: Maybe<LcmMessageCandidates>;
  /** update multiples rows of table: "lcm_message_candidates" */
  update_lcm_message_candidates_many?: Maybe<Array<Maybe<LcmMessageCandidatesMutationResponse>>>;
  /** update data of the table: "lcm_message_plans" */
  update_lcm_message_plans?: Maybe<LcmMessagePlansMutationResponse>;
  /** update single row of the table: "lcm_message_plans" */
  update_lcm_message_plans_by_pk?: Maybe<LcmMessagePlans>;
  /** update multiples rows of table: "lcm_message_plans" */
  update_lcm_message_plans_many?: Maybe<Array<Maybe<LcmMessagePlansMutationResponse>>>;
  /** update data of the table: "llm_chat_messages" */
  update_llm_chat_messages?: Maybe<LlmChatMessagesMutationResponse>;
  /** update single row of the table: "llm_chat_messages" */
  update_llm_chat_messages_by_pk?: Maybe<LlmChatMessages>;
  /** update multiples rows of table: "llm_chat_messages" */
  update_llm_chat_messages_many?: Maybe<Array<Maybe<LlmChatMessagesMutationResponse>>>;
  /** update data of the table: "llm_chat_sessions" */
  update_llm_chat_sessions?: Maybe<LlmChatSessionsMutationResponse>;
  /** update single row of the table: "llm_chat_sessions" */
  update_llm_chat_sessions_by_pk?: Maybe<LlmChatSessions>;
  /** update multiples rows of table: "llm_chat_sessions" */
  update_llm_chat_sessions_many?: Maybe<Array<Maybe<LlmChatSessionsMutationResponse>>>;
  /** update data of the table: "looker_credentials" */
  update_looker_credentials?: Maybe<LookerCredentialsMutationResponse>;
  /** update single row of the table: "looker_credentials" */
  update_looker_credentials_by_pk?: Maybe<LookerCredentials>;
  /** update multiples rows of table: "looker_credentials" */
  update_looker_credentials_many?: Maybe<Array<Maybe<LookerCredentialsMutationResponse>>>;
  /** update data of the table: "marketing_campaigns" */
  update_marketing_campaigns?: Maybe<MarketingCampaignsMutationResponse>;
  /** update single row of the table: "marketing_campaigns" */
  update_marketing_campaigns_by_pk?: Maybe<MarketingCampaigns>;
  /** update multiples rows of table: "marketing_campaigns" */
  update_marketing_campaigns_many?: Maybe<Array<Maybe<MarketingCampaignsMutationResponse>>>;
  /** update data of the table: "matchboosting_config" */
  update_matchboosting_config?: Maybe<MatchboostingConfigMutationResponse>;
  /** update single row of the table: "matchboosting_config" */
  update_matchboosting_config_by_pk?: Maybe<MatchboostingConfig>;
  /** update multiples rows of table: "matchboosting_config" */
  update_matchboosting_config_many?: Maybe<Array<Maybe<MatchboostingConfigMutationResponse>>>;
  /** update data of the table: "matchboosting_workspace_config" */
  update_matchboosting_workspace_config?: Maybe<MatchboostingWorkspaceConfigMutationResponse>;
  /** update single row of the table: "matchboosting_workspace_config" */
  update_matchboosting_workspace_config_by_pk?: Maybe<MatchboostingWorkspaceConfig>;
  /** update multiples rows of table: "matchboosting_workspace_config" */
  update_matchboosting_workspace_config_many?: Maybe<Array<Maybe<MatchboostingWorkspaceConfigMutationResponse>>>;
  /** update data of the table: "message_contents" */
  update_message_contents?: Maybe<MessageContentsMutationResponse>;
  /** update single row of the table: "message_contents" */
  update_message_contents_by_pk?: Maybe<MessageContents>;
  /** update multiples rows of table: "message_contents" */
  update_message_contents_many?: Maybe<Array<Maybe<MessageContentsMutationResponse>>>;
  /** update data of the table: "message_contents_metadata" */
  update_message_contents_metadata?: Maybe<MessageContentsMetadataMutationResponse>;
  /** update single row of the table: "message_contents_metadata" */
  update_message_contents_metadata_by_pk?: Maybe<MessageContentsMetadata>;
  /** update multiples rows of table: "message_contents_metadata" */
  update_message_contents_metadata_many?: Maybe<Array<Maybe<MessageContentsMetadataMutationResponse>>>;
  /** update data of the table: "message_experiments" */
  update_message_experiments?: Maybe<MessageExperimentsMutationResponse>;
  /** update single row of the table: "message_experiments" */
  update_message_experiments_by_pk?: Maybe<MessageExperiments>;
  /** update multiples rows of table: "message_experiments" */
  update_message_experiments_many?: Maybe<Array<Maybe<MessageExperimentsMutationResponse>>>;
  /** update data of the table: "message_variant_arm" */
  update_message_variant_arm?: Maybe<MessageVariantArmMutationResponse>;
  /** update single row of the table: "message_variant_arm" */
  update_message_variant_arm_by_pk?: Maybe<MessageVariantArm>;
  /** update multiples rows of table: "message_variant_arm" */
  update_message_variant_arm_many?: Maybe<Array<Maybe<MessageVariantArmMutationResponse>>>;
  /** update data of the table: "messages" */
  update_messages?: Maybe<MessagesMutationResponse>;
  /** update single row of the table: "messages" */
  update_messages_by_pk?: Maybe<Messages>;
  /** update multiples rows of table: "messages" */
  update_messages_many?: Maybe<Array<Maybe<MessagesMutationResponse>>>;
  /** update data of the table: "model_columns" */
  update_model_columns?: Maybe<ModelColumnsMutationResponse>;
  /** update single row of the table: "model_columns" */
  update_model_columns_by_pk?: Maybe<ModelColumns>;
  /** update multiples rows of table: "model_columns" */
  update_model_columns_many?: Maybe<Array<Maybe<ModelColumnsMutationResponse>>>;
  /** update data of the table: "model_relationships" */
  update_model_relationships?: Maybe<ModelRelationshipsMutationResponse>;
  /** update single row of the table: "model_relationships" */
  update_model_relationships_by_pk?: Maybe<ModelRelationships>;
  /** update multiples rows of table: "model_relationships" */
  update_model_relationships_many?: Maybe<Array<Maybe<ModelRelationshipsMutationResponse>>>;
  /** update data of the table: "monitor_condition_templates" */
  update_monitor_condition_templates?: Maybe<MonitorConditionTemplatesMutationResponse>;
  /** update single row of the table: "monitor_condition_templates" */
  update_monitor_condition_templates_by_pk?: Maybe<MonitorConditionTemplates>;
  /** update multiples rows of table: "monitor_condition_templates" */
  update_monitor_condition_templates_many?: Maybe<Array<Maybe<MonitorConditionTemplatesMutationResponse>>>;
  /** update data of the table: "notification_channel_templates" */
  update_notification_channel_templates?: Maybe<NotificationChannelTemplatesMutationResponse>;
  /** update single row of the table: "notification_channel_templates" */
  update_notification_channel_templates_by_pk?: Maybe<NotificationChannelTemplates>;
  /** update multiples rows of table: "notification_channel_templates" */
  update_notification_channel_templates_many?: Maybe<Array<Maybe<NotificationChannelTemplatesMutationResponse>>>;
  /** update data of the table: "object_definitions" */
  update_object_definitions?: Maybe<ObjectDefinitionsMutationResponse>;
  /** update single row of the table: "object_definitions" */
  update_object_definitions_by_pk?: Maybe<ObjectDefinitions>;
  /** update multiples rows of table: "object_definitions" */
  update_object_definitions_many?: Maybe<Array<Maybe<ObjectDefinitionsMutationResponse>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<OrganizationsMutationResponse>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<OrganizationsMutationResponse>>>;
  /** update data of the table: "pagerduty_credentials" */
  update_pagerduty_credentials?: Maybe<PagerdutyCredentialsMutationResponse>;
  /** update single row of the table: "pagerduty_credentials" */
  update_pagerduty_credentials_by_pk?: Maybe<PagerdutyCredentials>;
  /** update multiples rows of table: "pagerduty_credentials" */
  update_pagerduty_credentials_many?: Maybe<Array<Maybe<PagerdutyCredentialsMutationResponse>>>;
  /** update data of the table: "predictor_feature_definition_events" */
  update_predictor_feature_definition_events?: Maybe<PredictorFeatureDefinitionEventsMutationResponse>;
  /** update single row of the table: "predictor_feature_definition_events" */
  update_predictor_feature_definition_events_by_pk?: Maybe<PredictorFeatureDefinitionEvents>;
  /** update multiples rows of table: "predictor_feature_definition_events" */
  update_predictor_feature_definition_events_many?: Maybe<Array<Maybe<PredictorFeatureDefinitionEventsMutationResponse>>>;
  /** update data of the table: "predictor_feature_definitions" */
  update_predictor_feature_definitions?: Maybe<PredictorFeatureDefinitionsMutationResponse>;
  /** update single row of the table: "predictor_feature_definitions" */
  update_predictor_feature_definitions_by_pk?: Maybe<PredictorFeatureDefinitions>;
  /** update multiples rows of table: "predictor_feature_definitions" */
  update_predictor_feature_definitions_many?: Maybe<Array<Maybe<PredictorFeatureDefinitionsMutationResponse>>>;
  /** update data of the table: "predictors" */
  update_predictors?: Maybe<PredictorsMutationResponse>;
  /** update single row of the table: "predictors" */
  update_predictors_by_pk?: Maybe<Predictors>;
  /** update multiples rows of table: "predictors" */
  update_predictors_many?: Maybe<Array<Maybe<PredictorsMutationResponse>>>;
  /** update data of the table: "push_apps" */
  update_push_apps?: Maybe<PushAppsMutationResponse>;
  /** update single row of the table: "push_apps" */
  update_push_apps_by_pk?: Maybe<PushApps>;
  /** update multiples rows of table: "push_apps" */
  update_push_apps_many?: Maybe<Array<Maybe<PushAppsMutationResponse>>>;
  /** update data of the table: "push_config" */
  update_push_config?: Maybe<PushConfigMutationResponse>;
  /** update single row of the table: "push_config" */
  update_push_config_by_pk?: Maybe<PushConfig>;
  /** update multiples rows of table: "push_config" */
  update_push_config_many?: Maybe<Array<Maybe<PushConfigMutationResponse>>>;
  /** update data of the table: "realtime_audience_syncs" */
  update_realtime_audience_syncs?: Maybe<RealtimeAudienceSyncsMutationResponse>;
  /** update single row of the table: "realtime_audience_syncs" */
  update_realtime_audience_syncs_by_pk?: Maybe<RealtimeAudienceSyncs>;
  /** update multiples rows of table: "realtime_audience_syncs" */
  update_realtime_audience_syncs_many?: Maybe<Array<Maybe<RealtimeAudienceSyncsMutationResponse>>>;
  /** update data of the table: "realtime_audiences_scheduled_warehouse_pulls" */
  update_realtime_audiences_scheduled_warehouse_pulls?: Maybe<RealtimeAudiencesScheduledWarehousePullsMutationResponse>;
  /** update multiples rows of table: "realtime_audiences_scheduled_warehouse_pulls" */
  update_realtime_audiences_scheduled_warehouse_pulls_many?: Maybe<Array<Maybe<RealtimeAudiencesScheduledWarehousePullsMutationResponse>>>;
  /** update data of the table: "relationship_references" */
  update_relationship_references?: Maybe<RelationshipReferencesMutationResponse>;
  /** update single row of the table: "relationship_references" */
  update_relationship_references_by_pk?: Maybe<RelationshipReferences>;
  /** update multiples rows of table: "relationship_references" */
  update_relationship_references_many?: Maybe<Array<Maybe<RelationshipReferencesMutationResponse>>>;
  /** update data of the table: "relationships" */
  update_relationships?: Maybe<RelationshipsMutationResponse>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: Maybe<Relationships>;
  /** update multiples rows of table: "relationships" */
  update_relationships_many?: Maybe<Array<Maybe<RelationshipsMutationResponse>>>;
  /** update data of the table: "report_schedule" */
  update_report_schedule?: Maybe<ReportScheduleMutationResponse>;
  /** update single row of the table: "report_schedule" */
  update_report_schedule_by_pk?: Maybe<ReportSchedule>;
  /** update multiples rows of table: "report_schedule" */
  update_report_schedule_many?: Maybe<Array<Maybe<ReportScheduleMutationResponse>>>;
  /** update data of the table: "resource_interactions" */
  update_resource_interactions?: Maybe<ResourceInteractionsMutationResponse>;
  /** update single row of the table: "resource_interactions" */
  update_resource_interactions_by_pk?: Maybe<ResourceInteractions>;
  /** update multiples rows of table: "resource_interactions" */
  update_resource_interactions_many?: Maybe<Array<Maybe<ResourceInteractionsMutationResponse>>>;
  /** update data of the table: "resource_monitor_conditions" */
  update_resource_monitor_conditions?: Maybe<ResourceMonitorConditionsMutationResponse>;
  /** update single row of the table: "resource_monitor_conditions" */
  update_resource_monitor_conditions_by_pk?: Maybe<ResourceMonitorConditions>;
  /** update multiples rows of table: "resource_monitor_conditions" */
  update_resource_monitor_conditions_many?: Maybe<Array<Maybe<ResourceMonitorConditionsMutationResponse>>>;
  /** update data of the table: "resource_notification_channels" */
  update_resource_notification_channels?: Maybe<ResourceNotificationChannelsMutationResponse>;
  /** update single row of the table: "resource_notification_channels" */
  update_resource_notification_channels_by_pk?: Maybe<ResourceNotificationChannels>;
  /** update multiples rows of table: "resource_notification_channels" */
  update_resource_notification_channels_many?: Maybe<Array<Maybe<ResourceNotificationChannelsMutationResponse>>>;
  /** update data of the table: "resource_to_monitor_condition_type" */
  update_resource_to_monitor_condition_type?: Maybe<ResourceToMonitorConditionTypeMutationResponse>;
  /** update single row of the table: "resource_to_monitor_condition_type" */
  update_resource_to_monitor_condition_type_by_pk?: Maybe<ResourceToMonitorConditionType>;
  /** update multiples rows of table: "resource_to_monitor_condition_type" */
  update_resource_to_monitor_condition_type_many?: Maybe<Array<Maybe<ResourceToMonitorConditionTypeMutationResponse>>>;
  /** update data of the table: "resource_views" */
  update_resource_views?: Maybe<ResourceViewsMutationResponse>;
  /** update single row of the table: "resource_views" */
  update_resource_views_by_pk?: Maybe<ResourceViews>;
  /** update multiples rows of table: "resource_views" */
  update_resource_views_many?: Maybe<Array<Maybe<ResourceViewsMutationResponse>>>;
  /** update data of the table: "sampled_segments" */
  update_sampled_segments?: Maybe<SampledSegmentsMutationResponse>;
  /** update single row of the table: "sampled_segments" */
  update_sampled_segments_by_pk?: Maybe<SampledSegments>;
  /** update multiples rows of table: "sampled_segments" */
  update_sampled_segments_many?: Maybe<Array<Maybe<SampledSegmentsMutationResponse>>>;
  /** update data of the table: "saved_analytics_charts" */
  update_saved_analytics_charts?: Maybe<SavedAnalyticsChartsMutationResponse>;
  /** update single row of the table: "saved_analytics_charts" */
  update_saved_analytics_charts_by_pk?: Maybe<SavedAnalyticsCharts>;
  /** update data of the table: "saved_analytics_charts_cohorts" */
  update_saved_analytics_charts_cohorts?: Maybe<SavedAnalyticsChartsCohortsMutationResponse>;
  /** update single row of the table: "saved_analytics_charts_cohorts" */
  update_saved_analytics_charts_cohorts_by_pk?: Maybe<SavedAnalyticsChartsCohorts>;
  /** update multiples rows of table: "saved_analytics_charts_cohorts" */
  update_saved_analytics_charts_cohorts_many?: Maybe<Array<Maybe<SavedAnalyticsChartsCohortsMutationResponse>>>;
  /** update data of the table: "saved_analytics_charts_funnel_stages" */
  update_saved_analytics_charts_funnel_stages?: Maybe<SavedAnalyticsChartsFunnelStagesMutationResponse>;
  /** update single row of the table: "saved_analytics_charts_funnel_stages" */
  update_saved_analytics_charts_funnel_stages_by_pk?: Maybe<SavedAnalyticsChartsFunnelStages>;
  /** update multiples rows of table: "saved_analytics_charts_funnel_stages" */
  update_saved_analytics_charts_funnel_stages_many?: Maybe<Array<Maybe<SavedAnalyticsChartsFunnelStagesMutationResponse>>>;
  /** update data of the table: "saved_analytics_charts_goals" */
  update_saved_analytics_charts_goals?: Maybe<SavedAnalyticsChartsGoalsMutationResponse>;
  /** update single row of the table: "saved_analytics_charts_goals" */
  update_saved_analytics_charts_goals_by_pk?: Maybe<SavedAnalyticsChartsGoals>;
  /** update multiples rows of table: "saved_analytics_charts_goals" */
  update_saved_analytics_charts_goals_many?: Maybe<Array<Maybe<SavedAnalyticsChartsGoalsMutationResponse>>>;
  /** update multiples rows of table: "saved_analytics_charts" */
  update_saved_analytics_charts_many?: Maybe<Array<Maybe<SavedAnalyticsChartsMutationResponse>>>;
  /** update data of the table: "saved_campaign_views" */
  update_saved_campaign_views?: Maybe<SavedCampaignViewsMutationResponse>;
  /** update single row of the table: "saved_campaign_views" */
  update_saved_campaign_views_by_pk?: Maybe<SavedCampaignViews>;
  /** update data of the table: "saved_campaign_views_goals" */
  update_saved_campaign_views_goals?: Maybe<SavedCampaignViewsGoalsMutationResponse>;
  /** update single row of the table: "saved_campaign_views_goals" */
  update_saved_campaign_views_goals_by_pk?: Maybe<SavedCampaignViewsGoals>;
  /** update multiples rows of table: "saved_campaign_views_goals" */
  update_saved_campaign_views_goals_many?: Maybe<Array<Maybe<SavedCampaignViewsGoalsMutationResponse>>>;
  /** update multiples rows of table: "saved_campaign_views" */
  update_saved_campaign_views_many?: Maybe<Array<Maybe<SavedCampaignViewsMutationResponse>>>;
  /** update data of the table: "saved_queries" */
  update_saved_queries?: Maybe<SavedQueriesMutationResponse>;
  /** update single row of the table: "saved_queries" */
  update_saved_queries_by_pk?: Maybe<SavedQueries>;
  /** update multiples rows of table: "saved_queries" */
  update_saved_queries_many?: Maybe<Array<Maybe<SavedQueriesMutationResponse>>>;
  /** update data of the table: "segments" */
  update_segments?: Maybe<SegmentsMutationResponse>;
  /** update single row of the table: "segments" */
  update_segments_by_pk?: Maybe<Segments>;
  /** update multiples rows of table: "segments" */
  update_segments_many?: Maybe<Array<Maybe<SegmentsMutationResponse>>>;
  /** update data of the table: "slack_credentials" */
  update_slack_credentials?: Maybe<SlackCredentialsMutationResponse>;
  /** update single row of the table: "slack_credentials" */
  update_slack_credentials_by_pk?: Maybe<SlackCredentials>;
  /** update multiples rows of table: "slack_credentials" */
  update_slack_credentials_many?: Maybe<Array<Maybe<SlackCredentialsMutationResponse>>>;
  /** update data of the table: "spaces" */
  update_spaces?: Maybe<SpacesMutationResponse>;
  /** update single row of the table: "spaces" */
  update_spaces_by_pk?: Maybe<Spaces>;
  /** update multiples rows of table: "spaces" */
  update_spaces_many?: Maybe<Array<Maybe<SpacesMutationResponse>>>;
  /** update data of the table: "support_access_grant" */
  update_support_access_grant?: Maybe<SupportAccessGrantMutationResponse>;
  /** update single row of the table: "support_access_grant" */
  update_support_access_grant_by_pk?: Maybe<SupportAccessGrant>;
  /** update multiples rows of table: "support_access_grant" */
  update_support_access_grant_many?: Maybe<Array<Maybe<SupportAccessGrantMutationResponse>>>;
  /** update data of the table: "sync_requests" */
  update_sync_requests?: Maybe<SyncRequestsMutationResponse>;
  /** update single row of the table: "sync_requests" */
  update_sync_requests_by_pk?: Maybe<SyncRequests>;
  /** update multiples rows of table: "sync_requests" */
  update_sync_requests_many?: Maybe<Array<Maybe<SyncRequestsMutationResponse>>>;
  /** update data of the table: "sync_sequence_members" */
  update_sync_sequence_members?: Maybe<SyncSequenceMembersMutationResponse>;
  /** update single row of the table: "sync_sequence_members" */
  update_sync_sequence_members_by_pk?: Maybe<SyncSequenceMembers>;
  /** update multiples rows of table: "sync_sequence_members" */
  update_sync_sequence_members_many?: Maybe<Array<Maybe<SyncSequenceMembersMutationResponse>>>;
  /** update data of the table: "sync_sequence_runs" */
  update_sync_sequence_runs?: Maybe<SyncSequenceRunsMutationResponse>;
  /** update single row of the table: "sync_sequence_runs" */
  update_sync_sequence_runs_by_pk?: Maybe<SyncSequenceRuns>;
  /** update multiples rows of table: "sync_sequence_runs" */
  update_sync_sequence_runs_many?: Maybe<Array<Maybe<SyncSequenceRunsMutationResponse>>>;
  /** update data of the table: "sync_sequences" */
  update_sync_sequences?: Maybe<SyncSequencesMutationResponse>;
  /** update single row of the table: "sync_sequences" */
  update_sync_sequences_by_pk?: Maybe<SyncSequences>;
  /** update multiples rows of table: "sync_sequences" */
  update_sync_sequences_many?: Maybe<Array<Maybe<SyncSequencesMutationResponse>>>;
  /** update data of the table: "sync_templates" */
  update_sync_templates?: Maybe<SyncTemplatesMutationResponse>;
  /** update single row of the table: "sync_templates" */
  update_sync_templates_by_pk?: Maybe<SyncTemplates>;
  /** update multiples rows of table: "sync_templates" */
  update_sync_templates_many?: Maybe<Array<Maybe<SyncTemplatesMutationResponse>>>;
  /** update data of the table: "through_model_relationships" */
  update_through_model_relationships?: Maybe<ThroughModelRelationshipsMutationResponse>;
  /** update single row of the table: "through_model_relationships" */
  update_through_model_relationships_by_pk?: Maybe<ThroughModelRelationships>;
  /** update multiples rows of table: "through_model_relationships" */
  update_through_model_relationships_many?: Maybe<Array<Maybe<ThroughModelRelationshipsMutationResponse>>>;
  /** update data of the table: "tracked_audience_lists" */
  update_tracked_audience_lists?: Maybe<TrackedAudienceListsMutationResponse>;
  /** update single row of the table: "tracked_audience_lists" */
  update_tracked_audience_lists_by_pk?: Maybe<TrackedAudienceLists>;
  /** update multiples rows of table: "tracked_audience_lists" */
  update_tracked_audience_lists_many?: Maybe<Array<Maybe<TrackedAudienceListsMutationResponse>>>;
  /** update data of the table: "trait_definitions" */
  update_trait_definitions?: Maybe<TraitDefinitionsMutationResponse>;
  /** update single row of the table: "trait_definitions" */
  update_trait_definitions_by_pk?: Maybe<TraitDefinitions>;
  /** update multiples rows of table: "trait_definitions" */
  update_trait_definitions_many?: Maybe<Array<Maybe<TraitDefinitionsMutationResponse>>>;
  /** update data of the table: "tunnels" */
  update_tunnels?: Maybe<TunnelsMutationResponse>;
  /** update single row of the table: "tunnels" */
  update_tunnels_by_pk?: Maybe<Tunnels>;
  /** update multiples rows of table: "tunnels" */
  update_tunnels_many?: Maybe<Array<Maybe<TunnelsMutationResponse>>>;
  /** update data of the table: "user_group_grants" */
  update_user_group_grants?: Maybe<UserGroupGrantsMutationResponse>;
  /** update single row of the table: "user_group_grants" */
  update_user_group_grants_by_pk?: Maybe<UserGroupGrants>;
  /** update multiples rows of table: "user_group_grants" */
  update_user_group_grants_many?: Maybe<Array<Maybe<UserGroupGrantsMutationResponse>>>;
  /** update data of the table: "user_group_members" */
  update_user_group_members?: Maybe<UserGroupMembersMutationResponse>;
  /** update single row of the table: "user_group_members" */
  update_user_group_members_by_pk?: Maybe<UserGroupMembers>;
  /** update multiples rows of table: "user_group_members" */
  update_user_group_members_many?: Maybe<Array<Maybe<UserGroupMembersMutationResponse>>>;
  /** update data of the table: "user_group_subset_grants" */
  update_user_group_subset_grants?: Maybe<UserGroupSubsetGrantsMutationResponse>;
  /** update single row of the table: "user_group_subset_grants" */
  update_user_group_subset_grants_by_pk?: Maybe<UserGroupSubsetGrants>;
  /** update multiples rows of table: "user_group_subset_grants" */
  update_user_group_subset_grants_many?: Maybe<Array<Maybe<UserGroupSubsetGrantsMutationResponse>>>;
  /** update data of the table: "user_group_workspaces" */
  update_user_group_workspaces?: Maybe<UserGroupWorkspacesMutationResponse>;
  /** update single row of the table: "user_group_workspaces" */
  update_user_group_workspaces_by_pk?: Maybe<UserGroupWorkspaces>;
  /** update multiples rows of table: "user_group_workspaces" */
  update_user_group_workspaces_many?: Maybe<Array<Maybe<UserGroupWorkspacesMutationResponse>>>;
  /** update data of the table: "user_groups" */
  update_user_groups?: Maybe<UserGroupsMutationResponse>;
  /** update single row of the table: "user_groups" */
  update_user_groups_by_pk?: Maybe<UserGroups>;
  /** update multiples rows of table: "user_groups" */
  update_user_groups_many?: Maybe<Array<Maybe<UserGroupsMutationResponse>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "workspace_notification_channels" */
  update_workspace_notification_channels?: Maybe<WorkspaceNotificationChannelsMutationResponse>;
  /** update single row of the table: "workspace_notification_channels" */
  update_workspace_notification_channels_by_pk?: Maybe<WorkspaceNotificationChannels>;
  /** update multiples rows of table: "workspace_notification_channels" */
  update_workspace_notification_channels_many?: Maybe<Array<Maybe<WorkspaceNotificationChannelsMutationResponse>>>;
  /** update data of the table: "workspaces" */
  update_workspaces?: Maybe<WorkspacesMutationResponse>;
  /** update single row of the table: "workspaces" */
  update_workspaces_by_pk?: Maybe<Workspaces>;
  /** update multiples rows of table: "workspaces" */
  update_workspaces_many?: Maybe<Array<Maybe<WorkspacesMutationResponse>>>;
  uploadAgentFile: AgentFileUploadResponse;
  uploadContentSettingsFontFile: UploadContentSettingsFontFileOutput;
  uploadFontFile: FontFileUploadResponse;
  uploadLogoFile: LogoFileUploadResponse;
  uploadManuallyEditedImage: UploadManuallyEditedImageResponse;
  uploadMediaAssetsToDestination: UploadMediaAssetsResult;
  upsertAgentSettings: AgentSettings;
  upsertContentArtifactDynamicSlot: UpsertContentArtifactDynamicSlotResponse;
  upsertContentArtifactDynamicSlotContent: UpsertContentArtifactDynamicSlotContentResponse;
  upsertContentEmailDynamicSlot: UpsertContentEmailDynamicSlotResponse;
  /**
   * Create or update a usage-scoped content variant. Returns contentId for
   * branch upserts (create-then-reference / N→1 sharing).
   */
  upsertContentEmailDynamicSlotContent: UpsertContentEmailDynamicSlotContentResponse;
  upsertContentSettings: UpsertContentSettingsOutput;
  /** Creates the launch episode before the first live run since the latest reset, or edits the ramping one. Rejects edits to stages before today and edits below the share already admitted. */
  upsertDecisionEngineFlowVolumeRamp: Scalars['uuid'];
  /**
   * Save the workspace's insight-generation prompt. Hightouch employees only.
   * Gated by the agenticInitiatives flag.
   */
  upsertInitiativeInsightPrompt: Scalars['Boolean'];
  upsertLookerExtension: LookerConfig;
  upsertRelationships: UpsertRelationshipsOutput;
  upsertSigmaExtension: SigmaExtensionOrError;
  validateSettings: ValidateSettingsResponse;
  verifyCepCloudflareTrackingDomain: VerifyCepDomainResult;
  verifyCepDomain: VerifyCepDomainResult;
  /**
   * Seeds or refreshes stale content block catalogs for the workspace's
   * calendar connectors. Called by the calendar page on mount.
   */
  warmEspContentBlockCatalogs: WarmEspContentBlockCatalogsResult;
  /**
   * Takes back the viewer's approval or change request, and the comment it
   * left, so they are waiting again. reviewerId is any of the viewer's
   * reviewer rows from the task's current visit to its status.
   */
  withdrawAmpTaskDecision: AmpTaskWithdrawOutcome;
  /**
   * Takes back the viewer's approval or change request, and the comment it
   * left, so they are waiting again.
   */
  withdrawAmpTaskReview: AmpMutationResult;
  /** Cancel the pending review request for a campaign. */
  withdrawCampaignDraft: NativeDeliveryDraftResult;
  /** Cancel the pending review request for a journey. */
  withdrawJourneyDraft: NativeDeliveryDraftResult;
};


/** mutation root */
export type MutationAcceptLiquidV10IncompatibilityArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationActivateContentEmailDynamicContentCampaignArgs = {
  deploymentId: Scalars['uuid'];
};


/** mutation root */
export type MutationAddAdExportChannelSizeArgs = {
  input: AddAdExportChannelSizeInput;
};


/** mutation root */
export type MutationAddAmpCanvasNodeArgs = {
  input: AmpNodeCreateInput;
};


/** mutation root */
export type MutationAddAmpProjectTaskBoardArgs = {
  projectId: Scalars['ID'];
  workflowId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationAddAmpTaskBlockerArgs = {
  blockerTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
};


/** mutation root */
export type MutationAddAmpTaskReviewerArgs = {
  id: Scalars['ID'];
  memberRule?: InputMaybe<AmpApprovalRule>;
  required?: Scalars['Boolean'];
  userGroupId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationAddAsanaTaskCommentArgs = {
  input: AddAsanaTaskCommentInput;
};


/** mutation root */
export type MutationAddCepParentModelsArgs = {
  input: AddCepParentModelsInput;
};


/** mutation root */
export type MutationAddCompetitorAccountsArgs = {
  accounts: Array<CompetitorAccountInput>;
  competitorId: Scalars['ID'];
};


/** mutation root */
export type MutationAddExistingAmpCanvasNodeArgs = {
  input: AmpExistingNodeCreateInput;
};


/** mutation root */
export type MutationAddFlowToDecisionEngineArbitrationGroupArgs = {
  confirmDifferentPrimaryKey?: InputMaybe<Scalars['Boolean']>;
  flowId: Scalars['uuid'];
  flowWeight?: InputMaybe<Scalars['Float']>;
  groupId: Scalars['uuid'];
};


/** mutation root */
export type MutationAddInspirationBoardAdArgs = {
  ad: InspirationBoardAdInput;
  boardId: Scalars['ID'];
};


/** mutation root */
export type MutationAdminLinkCepBrandsToProfilesArgs = {
  input: AdminLinkCepBrandsToProfilesInput;
};


/** mutation root */
export type MutationAdminManualRetryFragmentArgs = {
  input: AdminManualRetryFragmentInput;
};


/** mutation root */
export type MutationAdminManualRetryFragmentsForExecutionArgs = {
  input: AdminManualRetryFragmentsForExecutionInput;
};


/** mutation root */
export type MutationAdminRedriveCampaignRunArgs = {
  input: AdminRedriveCampaignRunInput;
};


/** mutation root */
export type MutationAdminReplaceGlobalSuppressionListArgs = {
  input: AdminReplaceGlobalSuppressionListInput;
};


/** mutation root */
export type MutationAdminRepointCepForwardingQueuesArgs = {
  input: AdminRepointCepForwardingQueuesInput;
};


/** mutation root */
export type MutationAdminResetCepUserStateArgs = {
  input: AdminResetCepUserStateInput;
};


/** mutation root */
export type MutationAdminUpdateFragmentsArgs = {
  input: AdminUpdateFragmentsInput;
};


/** mutation root */
export type MutationAdvanceDecisionEngineFlowVolumeRampArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationAeoArchiveSiteArgs = {
  siteId: Scalars['ID'];
};


/** mutation root */
export type MutationAeoCreateSiteArgs = {
  url: Scalars['String'];
  withAgent?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationApplyAgenticSettingsContextReviewArgs = {
  decisions: Array<AgenticSettingsContextReviewDecisionInput>;
  reviewId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationApplyCepTranslationEditsArgs = {
  contentBlockId?: InputMaybe<Scalars['ID']>;
  dropStaleEdits?: InputMaybe<Scalars['Boolean']>;
  edits: Array<CepTranslationEditInput>;
  messageId?: InputMaybe<Scalars['ID']>;
  owner?: InputMaybe<CepLocalizationOwnerInput>;
};


/** mutation root */
export type MutationApplyCopyReferencesReviewArgs = {
  decisions: Array<CopyReferencesReviewDecisionInput>;
  reviewId: Scalars['uuid'];
};


/** mutation root */
export type MutationApplyEspUserFieldsImportArgs = {
  destinationId: Scalars['String'];
  fields: Array<EspUserFieldImportInput>;
};


/** mutation root */
export type MutationApplyIdrChangePlanArgs = {
  input: ApplyIdrChangePlanInput;
};


/** mutation root */
export type MutationApplyVariantSuggestionsArgs = {
  messageId: Scalars['uuid'];
  suggestions: Array<ApplyVariantSuggestionInput>;
};


/** mutation root */
export type MutationApproveActionPlanArgs = {
  input: ApproveActionPlanInput;
};


/** mutation root */
export type MutationArchiveCepWhatsAppTemplateArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationAssignDecisionEngineChannelParentArgs = {
  channelId: Scalars['uuid'];
  expectedParentModelId?: InputMaybe<Scalars['bigint']>;
  parentModelId: Scalars['bigint'];
};


/** mutation root */
export type MutationAssociateStaticListToAudienceArgs = {
  input: AssociateStaticListToAudienceInput;
};


/** mutation root */
export type MutationAttachCampaignAssetsToAsanaTaskArgs = {
  input: AttachCampaignAssetsToAsanaTaskInput;
};


/** mutation root */
export type MutationBulkDeleteEventPlansArgs = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type MutationBulkUpsertDecisionEngineMessagesArgs = {
  messages: Array<BulkUpsertDecisionEngineMessageInput>;
};


/** mutation root */
export type MutationBundleVideoExportsArgs = {
  input: BundleVideoExportsInput;
};


/** mutation root */
export type MutationCancelAnalyticsQueryArgs = {
  jobId: Scalars['String'];
};


/** mutation root */
export type MutationCancelCampaignAnalyticsDashboardQueryArgs = {
  jobId: Scalars['String'];
};


/** mutation root */
export type MutationCancelChartCardRunArgs = {
  chartCardRunId: Scalars['uuid'];
};


/** mutation root */
export type MutationCancelDamSyncRunArgs = {
  runId: Scalars['ID'];
};


/** mutation root */
export type MutationCancelDecisionEngineRunArgs = {
  jobId: Scalars['uuid'];
  reason?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationCancelEnrichedCatalogSyncArgs = {
  feedId: Scalars['ID'];
  jobId: Scalars['ID'];
};


/** mutation root */
export type MutationCancelEnrichmentArgs = {
  modelId: Scalars['String'];
  region?: InputMaybe<MatchBoosterRegion>;
};


/** mutation root */
export type MutationCancelExtensionExportArgs = {
  exportId: Scalars['String'];
};


/** mutation root */
export type MutationCancelExtensionImportArgs = {
  extensionImportId: Scalars['String'];
};


/** mutation root */
export type MutationCancelIdrRunArgs = {
  graphId: Scalars['String'];
};


/** mutation root */
export type MutationCancelIdrTrainingArgs = {
  idrId: Scalars['String'];
};


/** mutation root */
export type MutationCancelLlmBackgroundJobArgs = {
  input: CancelLlmBackgroundJobInput;
};


/** mutation root */
export type MutationCancelLlmChatInteractionArgs = {
  interactionId: Scalars['uuid'];
};


/** mutation root */
export type MutationCancelPredictiveTraitsQueueJobArgs = {
  input: CancelPredictiveTraitsQueueJobInput;
};


/** mutation root */
export type MutationCancelPredictorRunArgs = {
  input: CancelPredictorRunInput;
};


/** mutation root */
export type MutationCancelPreviewQueryJobArgs = {
  jobId: Scalars['String'];
};


/** mutation root */
export type MutationCancelSyncRunArgs = {
  id: Scalars['Int'];
  syncRequestId: Scalars['Int'];
};


/** mutation root */
export type MutationCancelTagsBackgroundJobArgs = {
  jobId: Scalars['String'];
};


/** mutation root */
export type MutationCancelUpcomingRecommendationsArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationCheckPreviewSnippetArgs = {
  flowMessageId: MessagePreviewFlowMessageIdInput;
};


/** mutation root */
export type MutationCheckPreviewTestUserArgs = {
  channelId: Scalars['uuid'];
};


/** mutation root */
export type MutationCleanUpDestinationsWithSecretsArgs = {
  input: CleanUpDestinationsInput;
};


/** mutation root */
export type MutationClearAidContentRecommendationsArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationClearCachedStateArgs = {
  decisionEngineId: Scalars['uuid'];
};


/** mutation root */
export type MutationClearCampaignInsightRatingArgs = {
  insightId: Scalars['uuid'];
};


/** mutation root */
export type MutationClearConnectionRoleSettingsArgs = {
  connectionId: Scalars['Int'];
};


/** mutation root */
export type MutationClearGlobalDecisioningDataArgs = {
  groupId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationClearPredictorErrorArgs = {
  input: ClearPredictorErrorInput;
};


/** mutation root */
export type MutationCloneAgentSessionArgs = {
  input: CloneAgentSessionInput;
};


/** mutation root */
export type MutationCloneDecisionEngineMessageArgs = {
  messageId: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationCloneJourneyArgs = {
  clone_journey_input: CloneJourneyInput;
};


/** mutation root */
export type MutationCompareMatchBoosterDatasetsArgs = {
  modelId: Scalars['bigint'];
};


/** mutation root */
export type MutationCompleteCepWhatsAppEmbeddedSignupArgs = {
  input: CompleteCepWhatsAppEmbeddedSignupInput;
};


/** mutation root */
export type MutationConfigureChannelDoubleOptInArgs = {
  input: ConfigureChannelDoubleOptInInput;
};


/** mutation root */
export type MutationConfigureSsoArgs = {
  details: ConfigureSsoInput;
};


/** mutation root */
export type MutationConfirmAdAssetMediaUploadArgs = {
  input: ConfirmAdAssetMediaUploadInput;
};


/** mutation root */
export type MutationConvertEmlToHtmlArgs = {
  input: ConvertEmlToHtmlInput;
};


/** mutation root */
export type MutationConvertSessionToReportPromptArgs = {
  input: ConvertSessionToReportPromptInput;
};


/** mutation root */
export type MutationCreateAdInsightsSavedViewArgs = {
  layout: Scalars['String'];
  name: Scalars['String'];
  query: Scalars['JSON'];
};


/** mutation root */
export type MutationCreateAdStudioProjectSessionArgs = {
  input: CreateAdStudioProjectSessionInput;
};


/** mutation root */
export type MutationCreateAdTemplateArgs = {
  templates: Array<CreateAdTemplateInput>;
};


/** mutation root */
export type MutationCreateAgentConnectorArgs = {
  input: CreateAgentConnectorInput;
};


/** mutation root */
export type MutationCreateAgentDefinitionArgs = {
  input: CreateAgentDefinitionInput;
};


/** mutation root */
export type MutationCreateAgentMemoriesArgs = {
  input: CreateAgentMemoriesInput;
};


/** mutation root */
export type MutationCreateAgentSessionArgs = {
  input: CreateAgentSessionInput;
};


/** mutation root */
export type MutationCreateAgenticSettingsEntityArgs = {
  input: CreateAgenticSettingsEntityInput;
};


/** mutation root */
export type MutationCreateAmpActionArgs = {
  input: CreateAmpActionInput;
  projectId: Scalars['ID'];
};


/** mutation root */
export type MutationCreateAmpAgentArgs = {
  input: CreateAmpAgentInput;
};


/** mutation root */
export type MutationCreateAmpAssetSyncArgs = {
  input: CreateAmpAssetSyncInput;
};


/** mutation root */
export type MutationCreateAmpFileArgs = {
  input: AmpFileCreateInput;
};


/** mutation root */
export type MutationCreateAmpFileFolderArgs = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationCreateAmpProjectArgs = {
  input: CreateAmpProjectInput;
};


/** mutation root */
export type MutationCreateAmpTaskArgs = {
  input: CreateAmpTaskInput;
  projectId: Scalars['ID'];
};


/** mutation root */
export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


/** mutation root */
export type MutationCreateAsanaTaskForCampaignArgs = {
  input: CreateAsanaTaskForCampaignInput;
};


/** mutation root */
export type MutationCreateAssetCollectionArgs = {
  input: AssetCollectionInput;
};


/** mutation root */
export type MutationCreateAssetCommentArgs = {
  body: Scalars['String'];
  mentions?: InputMaybe<Array<AssetCommentMentionInput>>;
  threadId: Scalars['uuid'];
  version?: InputMaybe<AssetCommentVersionInput>;
};


/** mutation root */
export type MutationCreateAssetCommentThreadArgs = {
  ampFileId?: InputMaybe<Scalars['uuid']>;
  anchor?: InputMaybe<AssetCommentAnchorInput>;
  body: Scalars['String'];
  mentions?: InputMaybe<Array<AssetCommentMentionInput>>;
  subject: AssetCommentSubjectInput;
  version?: InputMaybe<AssetCommentVersionInput>;
};


/** mutation root */
export type MutationCreateAssetVersionArgs = {
  input: CreateAssetVersionInput;
};


/** mutation root */
export type MutationCreateAudienceTemplateArgs = {
  input: CreateAudienceTemplateInput;
  spaceIds?: InputMaybe<Array<Scalars['uuid']>>;
};


/** mutation root */
export type MutationCreateCalendarViewArgs = {
  input: CreateCalendarViewInput;
};


/** mutation root */
export type MutationCreateCepChannelArgs = {
  input: CreateCepChannelInput;
};


/** mutation root */
export type MutationCreateCepCloudflareTrackingDomainArgs = {
  input: CreateCepCloudflareTrackingDomainInput;
};


/** mutation root */
export type MutationCreateCepDevicePreviewArgs = {
  input: CreateCepDevicePreviewInput;
};


/** mutation root */
export type MutationCreateCepEventSyncArgs = {
  input: CreateCepEventSyncInput;
};


/** mutation root */
export type MutationCreateCepProviderArgs = {
  input: CreateCepProviderInput;
};


/** mutation root */
export type MutationCreateCepWhatsAppTemplateArgs = {
  input: CreateCepWhatsAppTemplateInput;
};


/** mutation root */
export type MutationCreateCloudCredentialsArgs = {
  object: CloudCredentialsMutationInput;
};


/** mutation root */
export type MutationCreateCompetitorArgs = {
  accounts: Array<CompetitorAccountInput>;
  domain?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


/** mutation root */
export type MutationCreateComponentFromDocumentArgs = {
  input: CreateComponentFromDocumentInput;
};


/** mutation root */
export type MutationCreateConnectionRoleMappingArgs = {
  input: CreateConnectionRoleMappingInput;
};


/** mutation root */
export type MutationCreateContentArtifactArgs = {
  input: CreateContentArtifactInput;
};


/** mutation root */
export type MutationCreateContentCopyVersionArgs = {
  input: CreateContentCopyVersionInput;
};


/** mutation root */
export type MutationCreateContentEmailAndSessionArgs = {
  input: CreateContentEmailAndSessionInput;
};


/** mutation root */
export type MutationCreateContentEmailFromNdTemplateArgs = {
  templateId: Scalars['uuid'];
};


/** mutation root */
export type MutationCreateContentEmailVersionArgs = {
  input: CreateContentEmailVersionInput;
};


/** mutation root */
export type MutationCreateContentImageUploadV2Args = {
  input: CreateContentImageUploadInput;
};


/** mutation root */
export type MutationCreateDamSyncArgs = {
  extensionId: Scalars['String'];
  input: CreateDamSyncInput;
};


/** mutation root */
export type MutationCreateDbtCloudCredentialArgs = {
  accountUrl: Scalars['String'];
  apiKey: Scalars['String'];
};


/** mutation root */
export type MutationCreateDbtSyncConfigArgs = {
  input: FrontendDbtSyncConfigInput;
};


/** mutation root */
export type MutationCreateDecisionEngineArbitrationGroupArgs = {
  config: DecisionEngineArbitrationGroupConfigInput;
  name: Scalars['String'];
};


/** mutation root */
export type MutationCreateDecisionEngineFlowOverridePeriodArgs = {
  flowId: Scalars['uuid'];
  input: DecisionEngineFlowOverridePeriodCreateInput;
};


/** mutation root */
export type MutationCreateDecisionEngineFlowWithModelArgs = {
  createReportSchedule?: InputMaybe<Scalars['Boolean']>;
  input: DecisionEngineFlowWithModelInput;
};


/** mutation root */
export type MutationCreateDecisionEngineMessageArgs = {
  autoTag?: InputMaybe<Scalars['Boolean']>;
  flowId: Scalars['uuid'];
  flowMessageConfig: Scalars['JSONObject'];
  message: Scalars['JSONObject'];
};


/** mutation root */
export type MutationCreateDestinationWithSecretsArgs = {
  destination: DestinationsMutationInput;
  eventGrants?: InputMaybe<Array<EventForwardingDestinationGrant>>;
  grants?: InputMaybe<Array<DestinationGrant>>;
};


/** mutation root */
export type MutationCreateDoubleOptInSubscriptionTopicArgs = {
  input: CreateDoubleOptInSubscriptionTopicInput;
};


/** mutation root */
export type MutationCreateEmailTemplateInDestinationArgs = {
  destinationId: Scalars['String'];
  input: CreateEmailTemplateInput;
  overrideTemplateErrors?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationCreateEventComponentArgs = {
  input: CreateEventComponentInput;
};


/** mutation root */
export type MutationCreateEventForwardingSyncArgs = {
  input: CreateEventForwardingSyncInput;
};


/** mutation root */
export type MutationCreateEventPlanArgs = {
  input: CreateEventPlanInput;
};


/** mutation root */
export type MutationCreateEventSchemaV2Args = {
  input: CreateEventSchemaInput;
};


/** mutation root */
export type MutationCreateEventSourceArgs = {
  input: CreateEventSourceInput;
};


/** mutation root */
export type MutationCreateEventWarehouseDestinationArgs = {
  input: CreateEventWarehouseDestinationInput;
};


/** mutation root */
export type MutationCreateEventWarehouseSyncArgs = {
  input: CreateEventWarehouseSyncInput;
};


/** mutation root */
export type MutationCreateExtensionExportArgs = {
  additionalClassificationIds?: InputMaybe<Array<Scalars['String']>>;
  assetIds: Array<Scalars['String']>;
  extensionId: Scalars['String'];
  fieldValueOverrides?: InputMaybe<Scalars['JSON']>;
  variantIds?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationCreateExtensionWithSecretsArgs = {
  input: CreateExtensionInput;
};


/** mutation root */
export type MutationCreateExternalContextSourceArgs = {
  input: CreateExternalContextSourceInput;
};


/** mutation root */
export type MutationCreateFigmaPluginApiKeyArgs = {
  input: CreateFigmaPluginApiKeyInput;
};


/** mutation root */
export type MutationCreateFivetranExtensionArgs = {
  input: CreateFivetranExtensionInput;
};


/** mutation root */
export type MutationCreateFunctionArgs = {
  input: CreateFunctionInput;
};


/** mutation root */
export type MutationCreateFunctionResourceArgs = {
  input: CreateFunctionResourceInput;
};


/** mutation root */
export type MutationCreateFunctionVersionArgs = {
  input: CreateFunctionVersionInput;
};


/** mutation root */
export type MutationCreateGitSyncConfigArgs = {
  branch: Scalars['String'];
  checks_enabled: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  git_credential_id: Scalars['int8'];
  path: Scalars['String'];
  repository: Scalars['String'];
};


/** mutation root */
export type MutationCreateGithubCredentialsArgs = {
  object: GithubCredentialMutationInput;
};


/** mutation root */
export type MutationCreateGoldenRecordArgs = {
  input: CreateGoldenRecordInput;
};


/** mutation root */
export type MutationCreateGoldenRecordBaseColumnsArgs = {
  input: CreateGoldenRecordBaseColumnsInput;
};


/** mutation root */
export type MutationCreateGoldenRecordColumnArgs = {
  input: CreateGoldenRecordColumnInput;
};


/** mutation root */
export type MutationCreateHouseholdingModelArgs = {
  input: CreateHouseholdingModelInput;
};


/** mutation root */
export type MutationCreateIdrGraphArgs = {
  input: CreateIdrGraphInput;
};


/** mutation root */
export type MutationCreateIdrModelArgs = {
  input: CreateIdrModelBulkInput;
};


/** mutation root */
export type MutationCreateIdrSequenceLinksArgs = {
  links: Array<IdrSequenceLinkInput>;
};


/** mutation root */
export type MutationCreateInAppMessageTemplateArgs = {
  input: CreateInAppMessageTemplateInput;
};


/** mutation root */
export type MutationCreateInAppMessageTemplateVersionArgs = {
  input: CreateInAppMessageTemplateInput;
};


/** mutation root */
export type MutationCreateInitiativeInsightArgs = {
  content: Scalars['JSONObject'];
  goalId: Scalars['uuid'];
  title: Scalars['String'];
  type: Scalars['String'];
};


/** mutation root */
export type MutationCreateInspirationBoardArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type MutationCreateJourneyFromTemplateArgs = {
  create_journey_from_template_input: CreateJourneyFromTemplateInput;
};


/** mutation root */
export type MutationCreateJourneyTraitArgs = {
  input: CreateJourneyTraitInput;
};


/** mutation root */
export type MutationCreateLinkedEmailFromContentEmailArgs = {
  messageId: Scalars['uuid'];
  sourceContentEmailId: Scalars['uuid'];
};


/** mutation root */
export type MutationCreateLinkedEmailFromTemplateArgs = {
  messageId: Scalars['uuid'];
  templateId: Scalars['uuid'];
};


/** mutation root */
export type MutationCreateLinkedMessageDraftArgs = {
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationCreateLlmInferenceBackendArgs = {
  input: CreateLlmInferenceBackendInput;
};


/** mutation root */
export type MutationCreateModelConfigurationArgs = {
  approver_ids?: InputMaybe<Array<Scalars['Int']>>;
  comment?: InputMaybe<Scalars['String']>;
  input: CreateModelConfigurationInput;
};


/** mutation root */
export type MutationCreateNormalTunnelArgs = {
  input: NormalTunnelInput;
};


/** mutation root */
export type MutationCreateOpportunityDefinitionArgs = {
  input: OpportunityDefinitionInput;
};


/** mutation root */
export type MutationCreateOrUpdateCepManagedModelsArgs = {
  input: CreateOrUpdateCepManagedModelsInput;
};


/** mutation root */
export type MutationCreatePagerdutyCredentialsArgs = {
  api_key: Scalars['String'];
};


/** mutation root */
export type MutationCreatePredictorArgs = {
  input: CreatePredictorInput;
};


/** mutation root */
export type MutationCreatePredictorCatalogFeatureDefinitionArgs = {
  input: CreatePredictorCatalogFeatureDefinitionInput;
};


/** mutation root */
export type MutationCreatePredictorFeatureDefinitionArgs = {
  input: CreatePredictorFeatureDefinitionInput;
};


/** mutation root */
export type MutationCreatePriorityListArgs = {
  audienceIds: Array<Scalars['String']>;
  name: Scalars['String'];
  parentModelId: Scalars['String'];
};


/** mutation root */
export type MutationCreateProjectCampaignArgs = {
  input: CreateProjectCampaignInput;
};


/** mutation root */
export type MutationCreatePublicFontFromFileArgs = {
  input: CreatePublicFontFromFileInput;
};


/** mutation root */
export type MutationCreatePublicImageFromCatalogProductArgs = {
  input: CreatePublicImageFromCatalogProductInput;
};


/** mutation root */
export type MutationCreatePublicImageFromContentImageArgs = {
  input: CreatePublicImageFromContentImageInput;
};


/** mutation root */
export type MutationCreatePushAppArgs = {
  input: CreatePushAppInput;
};


/** mutation root */
export type MutationCreatePushCampaignInDestinationArgs = {
  destinationId: Scalars['String'];
  input: CreatePushCampaignInput;
};


/** mutation root */
export type MutationCreatePushEventSyncArgs = {
  input: CreatePushEventSyncInput;
};


/** mutation root */
export type MutationCreateQueuedEventFragmentsArgs = {
  input?: InputMaybe<CreateQueuedEventFragmentsInput>;
};


/** mutation root */
export type MutationCreateRealtimeEventModelArgs = {
  input: CreateRealtimeEventModelInput;
};


/** mutation root */
export type MutationCreateRelationshipArgs = {
  relationship: CreateRelationshipInput;
};


/** mutation root */
export type MutationCreateReportScheduleContentArgs = {
  input: CreateReportScheduleContentInput;
};


/** mutation root */
export type MutationCreateReverseTunnelArgs = {
  input: ReverseTunnelInput;
};


/** mutation root */
export type MutationCreateReviewAgentArgs = {
  brandProfileId: Scalars['uuid'];
  name: Scalars['String'];
  settingsEntityId: Scalars['uuid'];
};


/** mutation root */
export type MutationCreateSizeVariantArgs = {
  input: CreateSizeVariantInput;
};


/** mutation root */
export type MutationCreateSmsCampaignInDestinationArgs = {
  destinationId: Scalars['String'];
  input: CreateSmsCampaignInput;
};


/** mutation root */
export type MutationCreateSourceWithSecretsArgs = {
  grants?: InputMaybe<Array<SourceGrant>>;
  source: SourceMutationInput;
};


/** mutation root */
export type MutationCreateStagedJourneyArgs = {
  input: CreateStagedJourneyInput;
};


/** mutation root */
export type MutationCreateStyleEntityArgs = {
  input: CreateStyleEntityInput;
};


/** mutation root */
export type MutationCreateTrackedAudienceListArgs = {
  input: CreateTrackedAudienceListInput;
};


/** mutation root */
export type MutationCreateTraitDefinitionArgs = {
  input: CreateTraitDefinitionInput;
};


/** mutation root */
export type MutationCreateUserImageEditNodeArgs = {
  input: CreateUserImageEditNodeInput;
};


/** mutation root */
export type MutationCreateUserSvgEditNodeArgs = {
  input: CreateUserSvgEditNodeInput;
};


/** mutation root */
export type MutationCreateWorkspaceArgs = {
  isPartnerWorkspace?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  onboarding?: InputMaybe<Scalars['JSONObject']>;
  organization?: InputMaybe<Scalars['Int']>;
  region: Scalars['String'];
  slug: Scalars['String'];
};


/** mutation root */
export type MutationCreateWorkspaceNotificationChannelArgs = {
  channelType: Scalars['String'];
  config: Scalars['JSONObject'];
  status?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationDeactivateSsoUserArgs = {
  targetUserId: Scalars['String'];
};


/** mutation root */
export type MutationDeleteAdArtifactArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdInsightsSavedViewArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAgentConnectorArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAgentDefinitionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAgentFileArgs = {
  input: DeleteAgentFileInput;
};


/** mutation root */
export type MutationDeleteAgentMemoryArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAgenticSettingsEntityArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAllEventSchemaVersionsArgs = {
  input: DeleteEventSchemasInput;
};


/** mutation root */
export type MutationDeleteAmpAssetSyncArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAmpFileArgs = {
  deleteFiles?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAmpFileFolderArgs = {
  deleteFiles?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAmpInboxNotificationsArgs = {
  changelogIds: Array<Scalars['ID']>;
};


/** mutation root */
export type MutationDeleteAmpWorkflowArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAmpWorkflowStatusArgs = {
  id: Scalars['ID'];
  replacementStatusId: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAsanaTaskAttachmentArgs = {
  input: DeleteAsanaTaskAttachmentInput;
};


/** mutation root */
export type MutationDeleteAssetCollectionArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteAssetCommentArgs = {
  commentId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAssetCommentThreadArgs = {
  threadId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAssetVersionArgs = {
  input: DeleteAssetVersionInput;
};


/** mutation root */
export type MutationDeleteCalendarViewArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteCampaignInsightBatchArgs = {
  batchId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepBrandLogoArgs = {
  input: DeleteCepBrandLogoInput;
};


/** mutation root */
export type MutationDeleteCompetitorArgs = {
  competitorId: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteConnectionRoleMappingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteContentArtifactDynamicSlotArgs = {
  artifactId: Scalars['uuid'];
  slotId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentEmailDynamicSlotArgs = {
  emailId: Scalars['uuid'];
  slotId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentSettingsFontFileArgs = {
  input: DeleteContentSettingsFontFileInput;
};


/** mutation root */
export type MutationDeleteDamSyncArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteDecisionEngineArbitrationGroupArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowOverridePeriodArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineMessageArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEventComponentArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventForwardingDestinationArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventForwardingSyncArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventPlanArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventSchemaVersionArgs = {
  input: DeleteEventSchemasInput;
};


/** mutation root */
export type MutationDeleteEventSourceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventWarehouseDestinationArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteEventWarehouseSyncArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteExtensionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteExternalContextSourceArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteFivetranAgentSyncArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationDeleteFontFileArgs = {
  input: DeleteFontFileInput;
};


/** mutation root */
export type MutationDeleteFunctionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteFunctionResourceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteGoldenRecordBaseColumnArgs = {
  input: DeleteGoldenRecordBaseColumnInput;
};


/** mutation root */
export type MutationDeleteGoldenRecordColumnArgs = {
  input: DeleteGoldenRecordColumnInput;
};


/** mutation root */
export type MutationDeleteIdrGraphArgs = {
  input: DeleteIdrGraphInput;
};


/** mutation root */
export type MutationDeleteIdrModelArgs = {
  input: DeleteIdrModelInput;
};


/** mutation root */
export type MutationDeleteIdrSequenceLinksArgs = {
  links: Array<IdrSequenceLinkInput>;
};


/** mutation root */
export type MutationDeleteInAppMessageArgs = {
  input: DeleteInAppMessageInput;
};


/** mutation root */
export type MutationDeleteInboxNotificationsArgs = {
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  ids: Array<Scalars['ID']>;
};


/** mutation root */
export type MutationDeleteInspirationBoardArgs = {
  boardId: Scalars['ID'];
};


/** mutation root */
export type MutationDeleteJourneyArgs = {
  input: DeleteJourneyInput;
};


/** mutation root */
export type MutationDeleteJourneyTemplateArgs = {
  input: DeleteJourneyTemplateInput;
};


/** mutation root */
export type MutationDeleteJourneyTraitArgs = {
  input: DeleteJourneyTraitInput;
};


/** mutation root */
export type MutationDeleteLlmChatSessionArgs = {
  sessionId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLibraryImagesArgs = {
  ids: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationDeleteLogoFileArgs = {
  input: DeleteLogoFileInput;
};


/** mutation root */
export type MutationDeleteManagedSkillArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessageAbTestArgs = {
  input: DeleteMessageAbTestInput;
};


/** mutation root */
export type MutationDeleteMetaAdArgs = {
  input: DeleteMetaAdInput;
};


/** mutation root */
export type MutationDeleteModelArgs = {
  id: Scalars['int8'];
};


/** mutation root */
export type MutationDeleteModelColumnsV2Args = {
  model_id: Scalars['bigint'];
  names: Array<Scalars['String']>;
};


/** mutation root */
export type MutationDeleteOpportunityDefinitionArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationDeletePredictorArgs = {
  input: DeletePredictorInput;
};


/** mutation root */
export type MutationDeletePredictorFeatureDefinitionArgs = {
  input: DeletePredictorFeatureDefinitionInput;
};


/** mutation root */
export type MutationDeletePriorityListArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeletePushEventSyncArgs = {
  input: DeletePushEventSyncInput;
};


/** mutation root */
export type MutationDeleteRelationshipArgs = {
  edgeId?: InputMaybe<Scalars['String']>;
  reverseEdgeId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationDeleteResourceLinkArgs = {
  linkId: Scalars['bigint'];
  resourceType: DeploymentResourceType;
};


/** mutation root */
export type MutationDeleteReviewAgentArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSendInsightChartArgs = {
  chartId: Scalars['String'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSizeVariantArgs = {
  input: DeleteSizeVariantInput;
};


/** mutation root */
export type MutationDeleteStyleEntitiesArgs = {
  ids: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationDeleteSyncArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSyncIdrScheduleArgs = {
  destinationInstanceId: Scalars['String'];
};


/** mutation root */
export type MutationDeleteTraitDefinitionArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteTunnelArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationDeleteAdAssetFavoritesArgs = {
  where: AdAssetFavoritesBoolExp;
};


/** mutation root */
export type MutationDeleteAdAssetFavoritesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdBriefAssetLaunchQueueArgs = {
  where: AdBriefAssetLaunchQueueBoolExp;
};


/** mutation root */
export type MutationDeleteAdBriefAssetLaunchQueueByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdBriefAssetLaunchesArgs = {
  where: AdBriefAssetLaunchesBoolExp;
};


/** mutation root */
export type MutationDeleteAdBriefAssetLaunchesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdBriefAssetsArgs = {
  where: AdBriefAssetsBoolExp;
};


/** mutation root */
export type MutationDeleteAdBriefAssetsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdBriefsArgs = {
  where: AdBriefsBoolExp;
};


/** mutation root */
export type MutationDeleteAdBriefsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdExportChannelSizesArgs = {
  where: AdExportChannelSizesBoolExp;
};


/** mutation root */
export type MutationDeleteAdExportChannelSizesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdStatsModelsArgs = {
  where: AdStatsModelsBoolExp;
};


/** mutation root */
export type MutationDeleteAdStatsModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAdStudioProductFeedsArgs = {
  where: AdStudioProductFeedsBoolExp;
};


/** mutation root */
export type MutationDeleteAdStudioProductFeedsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdStudioProjectPinsArgs = {
  where: AdStudioProjectPinsBoolExp;
};


/** mutation root */
export type MutationDeleteAdStudioProjectPinsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdStudioProjectsArgs = {
  where: AdStudioProjectsBoolExp;
};


/** mutation root */
export type MutationDeleteAdStudioProjectsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAdStudioTreatmentsArgs = {
  where: AdStudioTreatmentsBoolExp;
};


/** mutation root */
export type MutationDeleteAdStudioTreatmentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAgenticSettingsEntitiesLinksArgs = {
  where: AgenticSettingsEntitiesLinksBoolExp;
};


/** mutation root */
export type MutationDeleteAgenticSettingsEntitiesLinksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAlertInstancesArgs = {
  where: AlertInstancesBoolExp;
};


/** mutation root */
export type MutationDeleteAlertsArgs = {
  where: AlertsBoolExp;
};


/** mutation root */
export type MutationDeleteAlertsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAmpAssetRatingsArgs = {
  where: AmpAssetRatingsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpAssetRatingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpCreativeDimensionsArgs = {
  where: AmpCreativeDimensionsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpCreativeDimensionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpFileFavoritesArgs = {
  where: AmpFileFavoritesBoolExp;
};


/** mutation root */
export type MutationDeleteAmpFileFavoritesByPkArgs = {
  amp_file_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAmpFollowedSourcesArgs = {
  where: AmpFollowedSourcesBoolExp;
};


/** mutation root */
export type MutationDeleteAmpFollowedSourcesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpFollowedTopicsArgs = {
  where: AmpFollowedTopicsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpFollowedTopicsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpProjectLinksArgs = {
  where: AmpProjectLinksBoolExp;
};


/** mutation root */
export type MutationDeleteAmpProjectLinksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpProjectPinsArgs = {
  where: AmpProjectPinsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpProjectPinsByPkArgs = {
  amp_project_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAmpProjectUsersArgs = {
  where: AmpProjectUsersBoolExp;
};


/** mutation root */
export type MutationDeleteAmpProjectUsersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTagsArgs = {
  where: AmpTagsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTagsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTaskRelationsArgs = {
  where: AmpTaskRelationsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTaskRelationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTaskTagsArgs = {
  where: AmpTaskTagsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTaskTagsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTaskUsersArgs = {
  where: AmpTaskUsersBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTaskUsersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTasksArgs = {
  where: AmpTasksBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTasksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTeamMembersArgs = {
  where: AmpTeamMembersBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpTeamsArgs = {
  where: AmpTeamsBoolExp;
};


/** mutation root */
export type MutationDeleteAmpTeamsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAmpWorkflowStatusReviewersArgs = {
  where: AmpWorkflowStatusReviewersBoolExp;
};


/** mutation root */
export type MutationDeleteAmpWorkflowStatusReviewersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteApiKeysArgs = {
  where: ApiKeysBoolExp;
};


/** mutation root */
export type MutationDeleteApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteArtifactFavoritesArgs = {
  where: ArtifactFavoritesBoolExp;
};


/** mutation root */
export type MutationDeleteArtifactFavoritesByPkArgs = {
  campaign_artifact_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteArtifactReviewCommentsArgs = {
  where: ArtifactReviewCommentsBoolExp;
};


/** mutation root */
export type MutationDeleteArtifactReviewCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteArtifactReviewStatusesArgs = {
  where: ArtifactReviewStatusesBoolExp;
};


/** mutation root */
export type MutationDeleteArtifactReviewStatusesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteArtifactReviewersArgs = {
  where: ArtifactReviewersBoolExp;
};


/** mutation root */
export type MutationDeleteArtifactReviewersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteArtifactReviewsArgs = {
  where: ArtifactReviewsBoolExp;
};


/** mutation root */
export type MutationDeleteArtifactReviewsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAttributionMethodsArgs = {
  where: AttributionMethodsBoolExp;
};


/** mutation root */
export type MutationDeleteAttributionMethodsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAttributionMethodsInteractionsArgs = {
  where: AttributionMethodsInteractionsBoolExp;
};


/** mutation root */
export type MutationDeleteAttributionMethodsInteractionsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  interaction_model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAudienceGoalsArgs = {
  where: AudienceGoalsBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceGoalsByPkArgs = {
  goal_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteAudiencePrimaryMetricsArgs = {
  where: AudiencePrimaryMetricsBoolExp;
};


/** mutation root */
export type MutationDeleteAudiencePrimaryMetricsByPkArgs = {
  audience_id: Scalars['bigint'];
  metric_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudienceSplitsArgs = {
  where: AudienceSplitsBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceSplitsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudienceSubsetGroupRequiredModelsArgs = {
  where: AudienceSubsetGroupRequiredModelsBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceSubsetGroupRequiredModelsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_group_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudienceSubsetGroupsArgs = {
  where: AudienceSubsetGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceSubsetGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudienceSubsetValuesArgs = {
  where: AudienceSubsetValuesBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceSubsetValuesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudienceTemplatesArgs = {
  where: AudienceTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteAudienceTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteAudiencesSubsetsArgs = {
  where: AudiencesSubsetsBoolExp;
};


/** mutation root */
export type MutationDeleteAudiencesSubsetsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_value_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCampaignArtifactsArgs = {
  where: CampaignArtifactsBoolExp;
};


/** mutation root */
export type MutationDeleteCampaignArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCampaignLabelsArgs = {
  where: CampaignLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteCampaignLabelsByPkArgs = {
  campaign_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCampaignsArgs = {
  where: CampaignsBoolExp;
};


/** mutation root */
export type MutationDeleteCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCatalogCollectionsArgs = {
  where: CatalogCollectionsBoolExp;
};


/** mutation root */
export type MutationDeleteCatalogCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCatalogModelsArgs = {
  where: CatalogModelsBoolExp;
};


/** mutation root */
export type MutationDeleteCatalogModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteCepBrandSettingsArgs = {
  where: CepBrandSettingsBoolExp;
};


/** mutation root */
export type MutationDeleteCepBrandSettingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepChannelsArgs = {
  where: CepChannelsBoolExp;
};


/** mutation root */
export type MutationDeleteCepChannelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepDomainsArgs = {
  where: CepDomainsBoolExp;
};


/** mutation root */
export type MutationDeleteCepDomainsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepEmailTemplateContentsArgs = {
  where: CepEmailTemplateContentsBoolExp;
};


/** mutation root */
export type MutationDeleteCepEmailTemplateContentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepLocalesArgs = {
  where: CepLocalesBoolExp;
};


/** mutation root */
export type MutationDeleteCepLocalesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepLocalizationSettingsArgs = {
  where: CepLocalizationSettingsBoolExp;
};


/** mutation root */
export type MutationDeleteCepLocalizationSettingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepMessageDevicePreviewsArgs = {
  where: CepMessageDevicePreviewsBoolExp;
};


/** mutation root */
export type MutationDeleteCepMessageDevicePreviewsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepProvidersArgs = {
  where: CepProvidersBoolExp;
};


/** mutation root */
export type MutationDeleteCepProvidersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepSenderIdentitiesArgs = {
  where: CepSenderIdentitiesBoolExp;
};


/** mutation root */
export type MutationDeleteCepSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepSubscriptionTopicSenderIdentitiesArgs = {
  where: CepSubscriptionTopicSenderIdentitiesBoolExp;
};


/** mutation root */
export type MutationDeleteCepSubscriptionTopicSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepSubscriptionTopicsArgs = {
  where: CepSubscriptionTopicsBoolExp;
};


/** mutation root */
export type MutationDeleteCepSubscriptionTopicsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepSuppressionListSubscriptionTopicsArgs = {
  where: CepSuppressionListSubscriptionTopicsBoolExp;
};


/** mutation root */
export type MutationDeleteCepSuppressionListSubscriptionTopicsByPkArgs = {
  cep_subscription_topic_id: Scalars['uuid'];
  suppression_list_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepSuppressionListsArgs = {
  where: CepSuppressionListsBoolExp;
};


/** mutation root */
export type MutationDeleteCepSuppressionListsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepTestGroupMembersArgs = {
  where: CepTestGroupMembersBoolExp;
};


/** mutation root */
export type MutationDeleteCepTestGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepTestGroupsArgs = {
  where: CepTestGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteCepTestGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCepWorkspaceConfigArgs = {
  where: CepWorkspaceConfigBoolExp;
};


/** mutation root */
export type MutationDeleteCepWorkspaceConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteChartCardsArgs = {
  where: ChartCardsBoolExp;
};


/** mutation root */
export type MutationDeleteChartCardsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCloudCredentialsArgs = {
  where: CloudCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteConditionTemplateLabelsArgs = {
  where: ConditionTemplateLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteConditionTemplateLabelsByPkArgs = {
  condition_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteConnectionsArgs = {
  where: ConnectionsBoolExp;
};


/** mutation root */
export type MutationDeleteConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteContentBlockLabelsArgs = {
  where: ContentBlockLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteContentBlockLabelsByPkArgs = {
  content_block_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentBlocksArgs = {
  where: ContentBlocksBoolExp;
};


/** mutation root */
export type MutationDeleteContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentDynamicSlotAssignmentsArgs = {
  where: ContentDynamicSlotAssignmentsBoolExp;
};


/** mutation root */
export type MutationDeleteContentDynamicSlotAssignmentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentDynamicSlotBranchesArgs = {
  where: ContentDynamicSlotBranchesBoolExp;
};


/** mutation root */
export type MutationDeleteContentDynamicSlotBranchesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentDynamicSlotContentsArgs = {
  where: ContentDynamicSlotContentsBoolExp;
};


/** mutation root */
export type MutationDeleteContentDynamicSlotContentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentDynamicSlotLibrariesArgs = {
  where: ContentDynamicSlotLibrariesBoolExp;
};


/** mutation root */
export type MutationDeleteContentDynamicSlotLibrariesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentDynamicSlotUsagesArgs = {
  where: ContentDynamicSlotUsagesBoolExp;
};


/** mutation root */
export type MutationDeleteContentDynamicSlotUsagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentEmailVariantsArgs = {
  where: ContentEmailVariantsBoolExp;
};


/** mutation root */
export type MutationDeleteContentEmailVariantsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentEmailsArgs = {
  where: ContentEmailsBoolExp;
};


/** mutation root */
export type MutationDeleteContentEmailsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentSettingsArgs = {
  where: ContentSettingsBoolExp;
};


/** mutation root */
export type MutationDeleteContentSettingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteContentTemplatesArgs = {
  where: ContentTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteContentTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteCustomAgentsArgs = {
  where: CustomAgentsBoolExp;
};


/** mutation root */
export type MutationDeleteCustomAgentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDashboardsArgs = {
  where: DashboardsBoolExp;
};


/** mutation root */
export type MutationDeleteDashboardsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDbtCloudSyncConfigArgs = {
  where: DbtCloudSyncConfigBoolExp;
};


/** mutation root */
export type MutationDeleteDbtCloudSyncConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDbtSyncConfigArgs = {
  where: DbtSyncConfigBoolExp;
};


/** mutation root */
export type MutationDeleteDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDecisionEngineCollectionsArgs = {
  where: DecisionEngineCollectionsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFeatureMatricesArgs = {
  where: DecisionEngineFeatureMatricesBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFeatureMatricesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFeatureMatrixRelationshipsArgs = {
  where: DecisionEngineFeatureMatrixRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFeatureMatrixRelationshipsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowExperimentsArgs = {
  where: DecisionEngineFlowExperimentsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowExperimentsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowOutcomesArgs = {
  where: DecisionEngineFlowOutcomesBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowTagsArgs = {
  where: DecisionEngineFlowTagsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowTagsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  tag_key: Scalars['String'];
  tag_value: Scalars['String'];
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowsArgs = {
  where: DecisionEngineFlowsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineFlowsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineMessageCollectionsArgs = {
  where: DecisionEngineMessageCollectionsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineMessageCollectionsByPkArgs = {
  decision_engine_collection_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDecisionEngineModelOutcomesArgs = {
  where: DecisionEngineModelOutcomesBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineModelOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_model_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineModelsArgs = {
  where: DecisionEngineModelsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineModelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineOffersArgs = {
  where: DecisionEngineOffersBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineOffersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineOutcomesArgs = {
  where: DecisionEngineOutcomesBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineSendEventsArgs = {
  where: DecisionEngineSendEventsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineSendEventsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEngineSplitsArgs = {
  where: DecisionEngineSplitsBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEngineSplitsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDecisionEnginesArgs = {
  where: DecisionEnginesBoolExp;
};


/** mutation root */
export type MutationDeleteDecisionEnginesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDestinationInstanceSplitsArgs = {
  where: DestinationInstanceSplitsBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationInstanceSplitsByPkArgs = {
  destination_instance_id: Scalars['bigint'];
  split_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDestinationInstancesArgs = {
  where: DestinationInstancesBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDestinationRulesArgs = {
  where: DestinationRulesBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationRulesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteDestinationsArgs = {
  where: DestinationsBoolExp;
};


/** mutation root */
export type MutationDeleteDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteDirectModelRelationshipsArgs = {
  where: DirectModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


/** mutation root */
export type MutationDeleteDraftsArgs = {
  where: DraftsBoolExp;
};


/** mutation root */
export type MutationDeleteDraftsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEmailTemplateLabelsArgs = {
  where: EmailTemplateLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteEmailTemplateLabelsByPkArgs = {
  email_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEspContentBlocksArgs = {
  where: EspContentBlocksBoolExp;
};


/** mutation root */
export type MutationDeleteEspContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEspUserFieldsArgs = {
  where: EspUserFieldsBoolExp;
};


/** mutation root */
export type MutationDeleteEspUserFieldsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEtlConnectionsArgs = {
  where: EtlConnectionsBoolExp;
};


/** mutation root */
export type MutationDeleteEtlConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEventComponentsArgs = {
  where: EventComponentsBoolExp;
};


/** mutation root */
export type MutationDeleteEventComponentsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventComponentsConditionsArgs = {
  where: EventComponentsConditionsBoolExp;
};


/** mutation root */
export type MutationDeleteEventComponentsConditionsByPkArgs = {
  component_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventComponentsJoinArgs = {
  where: EventComponentsJoinBoolExp;
};


/** mutation root */
export type MutationDeleteEventComponentsJoinByPkArgs = {
  importee_id: Scalars['uuid'];
  importer_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventContractsArgs = {
  where: EventContractsBoolExp;
};


/** mutation root */
export type MutationDeleteEventContractsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventContractsSchemaArgs = {
  where: EventContractsSchemaBoolExp;
};


/** mutation root */
export type MutationDeleteEventContractsSchemaByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventForwardingSyncsArgs = {
  where: EventForwardingSyncsBoolExp;
};


/** mutation root */
export type MutationDeleteEventForwardingSyncsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventModelEventSourcesArgs = {
  where: EventModelEventSourcesBoolExp;
};


/** mutation root */
export type MutationDeleteEventModelEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEventPlansArgs = {
  where: EventPlansBoolExp;
};


/** mutation root */
export type MutationDeleteEventPlansByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventSchemaComponentsArgs = {
  where: EventSchemaComponentsBoolExp;
};


/** mutation root */
export type MutationDeleteEventSchemaComponentsByPkArgs = {
  component_id: Scalars['uuid'];
  event_schema_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventSchemasArgs = {
  where: EventSchemasBoolExp;
};


/** mutation root */
export type MutationDeleteEventSchemasByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventSourceContractsArgs = {
  where: EventSourceContractsBoolExp;
};


/** mutation root */
export type MutationDeleteEventSourceContractsByPkArgs = {
  event_contract_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteEventSourcesArgs = {
  where: EventSourcesBoolExp;
};


/** mutation root */
export type MutationDeleteEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEventWarehouseDestinationsArgs = {
  where: EventWarehouseDestinationsBoolExp;
};


/** mutation root */
export type MutationDeleteEventWarehouseDestinationsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteEventWarehouseSyncsArgs = {
  where: EventWarehouseSyncsBoolExp;
};


/** mutation root */
export type MutationDeleteEventWarehouseSyncsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteExperimentMetricsArgs = {
  where: ExperimentMetricsBoolExp;
};


/** mutation root */
export type MutationDeleteExperimentMetricsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteExperimentsArgs = {
  where: ExperimentsBoolExp;
};


/** mutation root */
export type MutationDeleteExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteExternalBucketsArgs = {
  where: ExternalBucketsBoolExp;
};


/** mutation root */
export type MutationDeleteExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteExternalSegmentsArgs = {
  where: ExternalSegmentsBoolExp;
};


/** mutation root */
export type MutationDeleteExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteFoldersArgs = {
  where: FoldersBoolExp;
};


/** mutation root */
export type MutationDeleteFoldersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteFunctionResourcesArgs = {
  where: FunctionResourcesBoolExp;
};


/** mutation root */
export type MutationDeleteFunctionResourcesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteFunctionSettingsArgs = {
  where: FunctionSettingsBoolExp;
};


/** mutation root */
export type MutationDeleteFunctionSettingsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteFunctionsArgs = {
  where: FunctionsBoolExp;
};


/** mutation root */
export type MutationDeleteFunctionsByPkArgs = {
  id: Scalars['uuid'];
  version_number: Scalars['Int'];
};


/** mutation root */
export type MutationDeleteGitCredentialsArgs = {
  where: GitCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteGitSyncConfigsArgs = {
  where: GitSyncConfigsBoolExp;
};


/** mutation root */
export type MutationDeleteGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteGoalMetricsArgs = {
  where: GoalMetricsBoolExp;
};


/** mutation root */
export type MutationDeleteGoalMetricsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteGoalsArgs = {
  where: GoalsBoolExp;
};


/** mutation root */
export type MutationDeleteGoalsAttributionMethodsArgs = {
  where: GoalsAttributionMethodsBoolExp;
};


/** mutation root */
export type MutationDeleteGoalsAttributionMethodsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  goal_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteGoalsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteInitiativeGoalsArgs = {
  where: InitiativeGoalsBoolExp;
};


/** mutation root */
export type MutationDeleteInitiativeGoalsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteInitiativeInsightsArgs = {
  where: InitiativeInsightsBoolExp;
};


/** mutation root */
export type MutationDeleteInitiativeInsightsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteInteractionModelsArgs = {
  where: InteractionModelsBoolExp;
};


/** mutation root */
export type MutationDeleteInteractionModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteJourneyLabelsArgs = {
  where: JourneyLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteJourneyLabelsByPkArgs = {
  journey_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLabelGroupsArgs = {
  where: LabelGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteLabelGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLabelsArgs = {
  where: LabelsBoolExp;
};


/** mutation root */
export type MutationDeleteLabelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLcmMessageCandidatesArgs = {
  where: LcmMessageCandidatesBoolExp;
};


/** mutation root */
export type MutationDeleteLcmMessageCandidatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLcmMessagePlansArgs = {
  where: LcmMessagePlansBoolExp;
};


/** mutation root */
export type MutationDeleteLcmMessagePlansByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLlmInferenceBackendsArgs = {
  where: LlmInferenceBackendsBoolExp;
};


/** mutation root */
export type MutationDeleteLlmInferenceBackendsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteLookerCredentialsArgs = {
  where: LookerCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteLookerCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteMarketingCampaignMessagesArgs = {
  where: MarketingCampaignMessagesBoolExp;
};


/** mutation root */
export type MutationDeleteMarketingCampaignMessagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMarketingCampaignsArgs = {
  where: MarketingCampaignsBoolExp;
};


/** mutation root */
export type MutationDeleteMarketingCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMatchboostingConfigArgs = {
  where: MatchboostingConfigBoolExp;
};


/** mutation root */
export type MutationDeleteMatchboostingConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMatchboostingWorkspaceConfigArgs = {
  where: MatchboostingWorkspaceConfigBoolExp;
};


/** mutation root */
export type MutationDeleteMatchboostingWorkspaceConfigByPkArgs = {
  config_name: Scalars['String'];
  destination: Scalars['String'];
  region: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteMessageContentsArgs = {
  where: MessageContentsBoolExp;
};


/** mutation root */
export type MutationDeleteMessageContentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessageContentsMetadataArgs = {
  where: MessageContentsMetadataBoolExp;
};


/** mutation root */
export type MutationDeleteMessageContentsMetadataByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessageExperimentsArgs = {
  where: MessageExperimentsBoolExp;
};


/** mutation root */
export type MutationDeleteMessageExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessageLabelsArgs = {
  where: MessageLabelsBoolExp;
};


/** mutation root */
export type MutationDeleteMessageLabelsByPkArgs = {
  label_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessagePushAppsArgs = {
  where: MessagePushAppsBoolExp;
};


/** mutation root */
export type MutationDeleteMessagePushAppsByPkArgs = {
  message_id: Scalars['uuid'];
  push_app_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessageVariantArmArgs = {
  where: MessageVariantArmBoolExp;
};


/** mutation root */
export type MutationDeleteMessageVariantArmByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteMessagesArgs = {
  where: MessagesBoolExp;
};


/** mutation root */
export type MutationDeleteMessagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteModelColumnsArgs = {
  where: ModelColumnsBoolExp;
};


/** mutation root */
export type MutationDeleteModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationDeleteModelRelationshipsArgs = {
  where: ModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteMonitorConditionTemplatesArgs = {
  where: MonitorConditionTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteMonitorConditionTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteNotificationChannelTemplatesArgs = {
  where: NotificationChannelTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteNotificationChannelTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteOrganizationInvitesArgs = {
  where: OrganizationInvitesBoolExp;
};


/** mutation root */
export type MutationDeleteOrganizationInvitesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeletePagerdutyCredentialsArgs = {
  where: PagerdutyCredentialsBoolExp;
};


/** mutation root */
export type MutationDeletePagerdutyCredentialsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationDeletePredictorFeatureDefinitionEventsArgs = {
  where: PredictorFeatureDefinitionEventsBoolExp;
};


/** mutation root */
export type MutationDeletePredictorFeatureDefinitionEventsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeletePredictorFeatureDefinitionsArgs = {
  where: PredictorFeatureDefinitionsBoolExp;
};


/** mutation root */
export type MutationDeletePredictorFeatureDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeletePredictorOutcomesArgs = {
  where: PredictorOutcomesBoolExp;
};


/** mutation root */
export type MutationDeletePredictorOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeletePredictorsArgs = {
  where: PredictorsBoolExp;
};


/** mutation root */
export type MutationDeletePredictorsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeletePushAppsArgs = {
  where: PushAppsBoolExp;
};


/** mutation root */
export type MutationDeletePushAppsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeletePushConfigArgs = {
  where: PushConfigBoolExp;
};


/** mutation root */
export type MutationDeletePushConfigByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteRealtimeAudienceSyncsArgs = {
  where: RealtimeAudienceSyncsBoolExp;
};


/** mutation root */
export type MutationDeleteRealtimeAudienceSyncsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteRelationshipReferencesArgs = {
  where: RelationshipReferencesBoolExp;
};


/** mutation root */
export type MutationDeleteRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


/** mutation root */
export type MutationDeleteRelationshipsArgs = {
  where: RelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteReportScheduleArgs = {
  where: ReportScheduleBoolExp;
};


/** mutation root */
export type MutationDeleteReportScheduleByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteReportScheduleRunCommentsArgs = {
  where: ReportScheduleRunCommentsBoolExp;
};


/** mutation root */
export type MutationDeleteReportScheduleRunCommentsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteReportScheduleRunsArgs = {
  where: ReportScheduleRunsBoolExp;
};


/** mutation root */
export type MutationDeleteReportScheduleRunsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteResourceMonitorConditionsArgs = {
  where: ResourceMonitorConditionsBoolExp;
};


/** mutation root */
export type MutationDeleteResourceMonitorConditionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteResourceNotificationChannelsArgs = {
  where: ResourceNotificationChannelsBoolExp;
};


/** mutation root */
export type MutationDeleteResourceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteResourceViewsArgs = {
  where: ResourceViewsBoolExp;
};


/** mutation root */
export type MutationDeleteResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsArgs = {
  where: SavedAnalyticsChartsBoolExp;
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsCohortsArgs = {
  where: SavedAnalyticsChartsCohortsBoolExp;
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsCohortsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsFunnelStagesArgs = {
  where: SavedAnalyticsChartsFunnelStagesBoolExp;
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsFunnelStagesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsGoalsArgs = {
  where: SavedAnalyticsChartsGoalsBoolExp;
};


/** mutation root */
export type MutationDeleteSavedAnalyticsChartsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedCampaignViewsArgs = {
  where: SavedCampaignViewsBoolExp;
};


/** mutation root */
export type MutationDeleteSavedCampaignViewsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedCampaignViewsGoalsArgs = {
  where: SavedCampaignViewsGoalsBoolExp;
};


/** mutation root */
export type MutationDeleteSavedCampaignViewsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSavedQueriesArgs = {
  where: SavedQueriesBoolExp;
};


/** mutation root */
export type MutationDeleteSavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSegmentsArgs = {
  where: SegmentsBoolExp;
};


/** mutation root */
export type MutationDeleteSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSlackCredentialsArgs = {
  where: SlackCredentialsBoolExp;
};


/** mutation root */
export type MutationDeleteSlackCredentialsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationDeleteSpaceSubsetGrantsArgs = {
  where: SpaceSubsetGrantsBoolExp;
};


/** mutation root */
export type MutationDeleteSpaceSubsetGrantsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSpaceSyncTemplatesArgs = {
  where: SpaceSyncTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteSpaceSyncTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSpaceUserGroupsArgs = {
  where: SpaceUserGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteSpaceUserGroupsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSpacesArgs = {
  where: SpacesBoolExp;
};


/** mutation root */
export type MutationDeleteSpacesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSsoGroupUserGroupsArgs = {
  where: SsoGroupUserGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteSsoGroupUserGroupsByPkArgs = {
  sso_group_id: Scalars['uuid'];
  user_group_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteSyncSequenceMembersArgs = {
  where: SyncSequenceMembersBoolExp;
};


/** mutation root */
export type MutationDeleteSyncSequenceMembersByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSyncSequencesArgs = {
  where: SyncSequencesBoolExp;
};


/** mutation root */
export type MutationDeleteSyncSequencesByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteSyncTemplatesArgs = {
  where: SyncTemplatesBoolExp;
};


/** mutation root */
export type MutationDeleteSyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationDeleteThroughModelRelationshipsArgs = {
  where: ThroughModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationDeleteThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteTrackedAudienceListAudiencesArgs = {
  where: TrackedAudienceListAudiencesBoolExp;
};


/** mutation root */
export type MutationDeleteTrackedAudienceListAudiencesByPkArgs = {
  audience_id: Scalars['bigint'];
  list_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteTraitDefinitionsArgs = {
  where: TraitDefinitionsBoolExp;
};


/** mutation root */
export type MutationDeleteTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteTunnelsArgs = {
  where: TunnelsBoolExp;
};


/** mutation root */
export type MutationDeleteTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDeleteUserGroupMembersArgs = {
  where: UserGroupMembersBoolExp;
};


/** mutation root */
export type MutationDeleteUserGroupMembersByPkArgs = {
  user_group_id: Scalars['bigint'];
  user_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteUserGroupWorkspacesArgs = {
  where: UserGroupWorkspacesBoolExp;
};


/** mutation root */
export type MutationDeleteUserGroupWorkspacesByPkArgs = {
  user_group_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteUserGroupsArgs = {
  where: UserGroupsBoolExp;
};


/** mutation root */
export type MutationDeleteUserGroupsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationDeleteWorkspaceNotificationChannelsArgs = {
  where: WorkspaceNotificationChannelsBoolExp;
};


/** mutation root */
export type MutationDeleteWorkspaceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDemoMockMessageStatisticsArgs = {
  input: DemoMockMessageStatisticsInput;
};


/** mutation root */
export type MutationDeployContentArtifactDynamicContentArgs = {
  input: DeployContentArtifactDynamicContentInput;
};


/** mutation root */
export type MutationDeployContentEmailDynamicContentArgs = {
  input: DeployContentEmailDynamicContentInput;
};


/** mutation root */
export type MutationDeployModelArgs = {
  draft: Scalars['Boolean'];
  sourceSegmentId: Scalars['bigint'];
  targetWorkspaceId: Scalars['bigint'];
};


/** mutation root */
export type MutationDeploySyncArgs = {
  deploySchedule?: InputMaybe<Scalars['Boolean']>;
  draft: Scalars['Boolean'];
  scheduleEnabled?: InputMaybe<Scalars['Boolean']>;
  sourceDestinationInstanceId: Scalars['bigint'];
  targetWorkspaceId: Scalars['bigint'];
};


/** mutation root */
export type MutationDetachCampaignCsvArgs = {
  audienceChanges: CampaignCsvAudienceChangesInput;
  audienceId: Scalars['ID'];
  staticListId: Scalars['ID'];
};


/** mutation root */
export type MutationDetachCepWhatsAppTemplateArgs = {
  messageId: Scalars['ID'];
};


/** mutation root */
export type MutationDetectRelationshipCardinalityArgs = {
  edgeId: Scalars['String'];
  reverseEdgeId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationDisableDecisionEngineFlowArgs = {
  clearUpcomingRecommendations?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDisableDecisionEngineFlowMessageArgs = {
  clearUpcomingRecommendations?: InputMaybe<Scalars['Boolean']>;
  flowId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationDisableWarehouseShareArgs = {
  connectionId: Scalars['bigint'];
};


/** mutation root */
export type MutationDiscardCepWhatsAppDraftLocaleEditsArgs = {
  localeId: Scalars['ID'];
  messageId: Scalars['ID'];
};


/** mutation root */
export type MutationDiscardFigmaImportDraftArgs = {
  draftId: Scalars['String'];
};


/** mutation root */
export type MutationDiscardMessageContentDraftArgs = {
  messageId: Scalars['uuid'];
  publishedMetadataVersion?: InputMaybe<Scalars['Int']>;
  publishedVersion: Scalars['Int'];
};


/** mutation root */
export type MutationDiscardReportDraftArgs = {
  input: DiscardReportDraftInput;
};


/** mutation root */
export type MutationDisconnectDeliverabilityFeedArgs = {
  feedType: Scalars['String'];
};


/** mutation root */
export type MutationDiscoverArgs = {
  connectionId: Scalars['String'];
};


/** mutation root */
export type MutationDiscoverFigmaDesignsArgs = {
  input: DiscoverFigmaDesignsInput;
};


/** mutation root */
export type MutationDismissCampaignInsightArgs = {
  insightId: Scalars['uuid'];
};


/** mutation root */
export type MutationDraftModelConfigurationArgs = {
  approver_ids?: InputMaybe<Array<Scalars['Int']>>;
  comment?: InputMaybe<Scalars['String']>;
  input: SaveModelConfigurationInput;
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationDryRunDecisionEngineArgs = {
  input: DryRunInput;
};


/** mutation root */
export type MutationDuplicateAdTemplateArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDuplicateAmpFileArgs = {
  canvas?: InputMaybe<AmpFilePlacementInput>;
  folderId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationDuplicateAmpWorkflowArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationDuplicateIdrGraphArgs = {
  input: DuplicateIdrGraphInput;
};


/** mutation root */
export type MutationEditAmpProjectArgs = {
  id: Scalars['ID'];
  input: EditAmpProjectInput;
};


/** mutation root */
export type MutationEditAmpTaskArgs = {
  id: Scalars['ID'];
  input: EditAmpTaskInput;
};


/** mutation root */
export type MutationEditChannelDoubleOptInArgs = {
  input: ConfigureChannelDoubleOptInInput;
};


/** mutation root */
export type MutationEditDbtSyncConfigArgs = {
  id: Scalars['bigint'];
  input: FrontendDbtSyncConfigUpdateInput;
};


/** mutation root */
export type MutationEllieAdminAddContextArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminAddSourceArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminAppendTopicReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminAssessSourceBatchArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCloseDiagnosticCycleArgs = {
  cycleId: Scalars['String'];
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCollectAppstoreReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCollectBrandSearchArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCollectLinkedinMentionArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCollectMapsReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCollectPlayReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCorrectFindingCitationsArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCreateBuyerDiagnosticArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminCreateDiagnosticMonitorArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminDeepenCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminDevelopUnderstandingArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminEnhanceCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminFeedbackUnderstandingArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminMeasureCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminObserveNowArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPauseCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPreviewBrandSearchArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPreviewLinkedinMentionsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPreviewMapsReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPreviewPlayReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminPreviewSourceKeywordsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminReadSourceBatchArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminReconcileInternetRequestArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRecoverPromptAllocationArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRecoverPromptReservationsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRefreshUnderstandingArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRepeatPromptsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminResearchCompanyArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminResolveChromeCaptureArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminResumeCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRetryJobArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRunAeoTrialArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRunDiagnosticMonitorArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRunSourceKeywordsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminRunSourceStepArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminSendCampaignMessageArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminSetDiagnosticMonitorStateArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminStartCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminStartDiscoveryArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminStopCampaignArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateAppstoreReviewScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateBrandSearchScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateDiagnosticMonitorArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateIdeaStatusArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateLinkedinMentionScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateLinkedinScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateMapsReviewScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateMapsReviewTargetsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdatePlayReviewScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateSettingsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateSourceKeywordsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateSourceQueueArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminUpdateSourceReadScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAdminWriteBrainArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieAssessSourceArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieCollectLinkedinArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieCopyChatArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
};


/** mutation root */
export type MutationEllieDeleteChatArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
};


/** mutation root */
export type MutationEllieReadSourceArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieRenameChatArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
  title: Scalars['String'];
};


/** mutation root */
export type MutationEllieShareChatArgs = {
  id: Scalars['String'];
  shared: Scalars['Boolean'];
  siteId: Scalars['String'];
};


/** mutation root */
export type MutationEllieStopChatArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
};


/** mutation root */
export type MutationEllieUpdateBrandTagsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateLinkedinScheduleArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateSourceExclusionsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateSourceRelationshipsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateSourceReviewsArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateSourceTypesArgs = {
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEllieUpdateTopicArgs = {
  id: Scalars['String'];
  input: ElliePatchInput;
};


/** mutation root */
export type MutationEnableDecisionEngineFlowArgs = {
  id: Scalars['uuid'];
  volumeRamp?: InputMaybe<DecisionEngineFlowVolumeRampStartInput>;
};


/** mutation root */
export type MutationEnableDecisionEngineFlowMessageArgs = {
  flowId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationEnablePushAppAndConfigureEventsArgs = {
  input: EnablePushAppAndConfigureEventsInput;
};


/** mutation root */
export type MutationEndDecisionEngineFlowVolumeRampArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationEnqueueGetAgentTagsArgs = {
  agentId: Scalars['String'];
  flowMessageResources?: InputMaybe<Array<DecisionEngineMessageTagResource>>;
  saveResults?: InputMaybe<Scalars['Boolean']>;
  schema: Scalars['JSONObject'];
  tagType: TagType;
  variantResources?: InputMaybe<Array<DecisionEngineVariantTagResource>>;
};


/** mutation root */
export type MutationEnqueueGetMessageTagsArgs = {
  agentId: Scalars['String'];
  flowMessageResource?: InputMaybe<DecisionEngineMessageTagResource>;
  messageId: Scalars['String'];
  saveResults?: InputMaybe<Scalars['Boolean']>;
  schema: Scalars['JSONObject'];
  tagType: TagType;
  variantResources?: InputMaybe<Array<DecisionEngineVariantTagResource>>;
};


/** mutation root */
export type MutationEnqueueGoalComputationArgs = {
  goal_id: Scalars['String'];
};


/** mutation root */
export type MutationEnqueueStaticListCsvMaterializationArgs = {
  input: EnqueueStaticListCsvMaterializationInput;
};


/** mutation root */
export type MutationEnqueueStaticListRefreshPreviewArgs = {
  input: EnqueueStaticListRefreshPreviewInput;
};


/** mutation root */
export type MutationEnqueueStaticListSnapshotMaterializationArgs = {
  input: EnqueueStaticListSnapshotMaterializationInput;
};


/** mutation root */
export type MutationEnqueueStaticListSnapshotRefreshArgs = {
  input: EnqueueStaticListSnapshotRefreshInput;
};


/** mutation root */
export type MutationEnsureCepWhatsAppMessageTemplateArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


/** mutation root */
export type MutationEnsureTemplateEditingSessionArgs = {
  input: EnsureTemplateEditingSessionInput;
};


/** mutation root */
export type MutationExecuteLlmBackgroundJobArgs = {
  input: ExecuteLlmBackgroundJobInput;
};


/** mutation root */
export type MutationExecuteMarketingAgentConversationArgs = {
  input: ExecuteMarketingAgentConversationInput;
};


/** mutation root */
export type MutationExportBulkVideoAdsArgs = {
  input: ExportBulkVideoAdsInput;
};


/** mutation root */
export type MutationExportContentArtifactDynamicContentToProviderArgs = {
  input: ExportContentArtifactDynamicContentInput;
};


/** mutation root */
export type MutationExportContentEmailToNativeDeliveryArgs = {
  contentEmailId: Scalars['uuid'];
  contentEmailVersionId: Scalars['uuid'];
};


/** mutation root */
export type MutationExportEmailHtmlToStorageDestinationArgs = {
  destinationId: Scalars['String'];
  input: ExportEmailHtmlToStorageInput;
};


/** mutation root */
export type MutationExportEmailToPngArgs = {
  input: ExportEmailToPngInput;
};


/** mutation root */
export type MutationExportEmailToPsdArgs = {
  input: ExportEmailToPngInput;
};


/** mutation root */
export type MutationExportVideoAdArgs = {
  input: ExportVideoAdInput;
};


/** mutation root */
export type MutationExportWebPageToPsdArgs = {
  fileId: Scalars['ID'];
  widths: Array<Scalars['Int']>;
};


/** mutation root */
export type MutationExtractEspUserFieldsFromContextArgs = {
  destinationId: Scalars['String'];
  entityId: Scalars['uuid'];
};


/** mutation root */
export type MutationFetchCepProviderDomainsArgs = {
  input: FetchCepProviderDomainsInput;
};


/** mutation root */
export type MutationGenerateAdVariationsArgs = {
  input: GenerateAdVariationsInput;
};


/** mutation root */
export type MutationGenerateAgenticUfmArgs = {
  agentId: Scalars['uuid'];
};


/** mutation root */
export type MutationGenerateAssetVariantArgs = {
  input: GenerateAssetVariantInput;
};


/** mutation root */
export type MutationGenerateBreakdownsArgs = {
  flowId: Scalars['uuid'];
  forceGenerateBreakdowns?: InputMaybe<Scalars['Boolean']>;
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationGenerateCampaignInsightsArgs = {
  workspaceId: Scalars['Int'];
};


/** mutation root */
export type MutationGenerateCopyArgs = {
  input: GenerateCopyInput;
};


/** mutation root */
export type MutationGenerateDemoInsightsArgs = {
  input: GenerateDemoInsightsInput;
};


/** mutation root */
export type MutationGenerateDynamicContentVariantsArgs = {
  input: GenerateDynamicContentVariantsInput;
};


/** mutation root */
export type MutationGenerateEmailArgs = {
  input: GenerateEmailInput;
};


/** mutation root */
export type MutationGenerateExperimentGroupsArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationGenerateInitiativeInsightsArgs = {
  goalId: Scalars['uuid'];
};


/** mutation root */
export type MutationGenerateMessageCandidatesArgs = {
  input: GenerateMessageCandidatesInput;
};


/** mutation root */
export type MutationGenerateMessageDynamicContentVariantsArgs = {
  input: GenerateMessageDynamicContentVariantsInput;
};


/** mutation root */
export type MutationGenerateMessagePlansArgs = {
  input: GenerateMessagePlansInput;
};


/** mutation root */
export type MutationGenerateMoreCandidatesArgs = {
  input: GenerateMoreCandidatesInput;
};


/** mutation root */
export type MutationGenerateReportCustomizationArgs = {
  reportIntent: Scalars['String'];
};


/** mutation root */
export type MutationGenerateReportCustomizationQuestionsArgs = {
  reportIntent: Scalars['String'];
};


/** mutation root */
export type MutationGenerateVariantsSuggestionsArgs = {
  input: GenerateVariantsSuggestionsInput;
};


/** mutation root */
export type MutationGenerateWorkspaceContextArgs = {
  systemPromptOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationGetCepMessagingServiceChannelsArgs = {
  input: GetCepMessagingServiceChannelsInput;
};


/** mutation root */
export type MutationHardDeletePredictorArgs = {
  input: DeletePredictorInput;
};


/** mutation root */
export type MutationImportAllAssetsForExtensionArgs = {
  assetGroupId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ImportFiltersInput>;
  id: Scalars['String'];
  resumeImportId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationImportContentCopyArgs = {
  input: ImportContentCopyInput;
};


/** mutation root */
export type MutationImportContentEmailArgs = {
  input: ImportContentEmailInput;
};


/** mutation root */
export type MutationImportEmailTemplatesFromDestinationArgs = {
  brandProfileIds?: InputMaybe<Array<Scalars['uuid']>>;
  destinationId: Scalars['String'];
  templateIds: Array<Scalars['String']>;
};


/** mutation root */
export type MutationImproveReportInstructionsDraftArgs = {
  input: ImproveReportInstructionsInput;
};


/** mutation root */
export type MutationInitiateAdAssetMediaUploadArgs = {
  input: InitiateAdAssetMediaUploadInput;
};


/** mutation root */
export type MutationInitiateAmpFileUploadArgs = {
  fileSizeBytes: Scalars['Float'];
  filename: Scalars['String'];
};


/** mutation root */
export type MutationInitiateChatFileUploadArgs = {
  input: InitiateChatFileUploadInput;
};


/** mutation root */
export type MutationInitiateChatFileUploadsArgs = {
  input: InitiateChatFileUploadsInput;
};


/** mutation root */
export type MutationInitiateContextFileUploadArgs = {
  input: InitiateContextFileUploadInput;
};


/** mutation root */
export type MutationInitiateLaunchAssetUploadArgs = {
  input: InitiateLaunchAssetUploadInput;
};


/** mutation root */
export type MutationInjectCampaignInsightsV2Args = {
  dryRun?: Scalars['Boolean'];
  insights: Scalars['jsonb'];
  llmChatSessionId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationInsertAdBriefWithVersionArgs = {
  input: InsertAdBriefWithVersionInput;
};


/** mutation root */
export type MutationInsertLibraryTagsArgs = {
  objects: Array<LibraryTagInput>;
};


/** mutation root */
export type MutationInsertAdAssetFavoritesArgs = {
  objects: Array<AdAssetFavoritesInsertInput>;
  on_conflict?: InputMaybe<AdAssetFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertAdAssetFavoritesOneArgs = {
  object: AdAssetFavoritesInsertInput;
  on_conflict?: InputMaybe<AdAssetFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetLaunchQueueArgs = {
  objects: Array<AdBriefAssetLaunchQueueInsertInput>;
  on_conflict?: InputMaybe<AdBriefAssetLaunchQueueOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetLaunchQueueOneArgs = {
  object: AdBriefAssetLaunchQueueInsertInput;
  on_conflict?: InputMaybe<AdBriefAssetLaunchQueueOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetLaunchesArgs = {
  objects: Array<AdBriefAssetLaunchesInsertInput>;
  on_conflict?: InputMaybe<AdBriefAssetLaunchesOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetLaunchesOneArgs = {
  object: AdBriefAssetLaunchesInsertInput;
  on_conflict?: InputMaybe<AdBriefAssetLaunchesOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetSizeVariantsArgs = {
  objects: Array<AdBriefAssetSizeVariantsInsertInput>;
  on_conflict?: InputMaybe<AdBriefAssetSizeVariantsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetSizeVariantsOneArgs = {
  object: AdBriefAssetSizeVariantsInsertInput;
  on_conflict?: InputMaybe<AdBriefAssetSizeVariantsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetVersionsArgs = {
  objects: Array<AdBriefAssetVersionsInsertInput>;
  on_conflict?: InputMaybe<AdBriefAssetVersionsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetVersionsOneArgs = {
  object: AdBriefAssetVersionsInsertInput;
  on_conflict?: InputMaybe<AdBriefAssetVersionsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetsArgs = {
  objects: Array<AdBriefAssetsInsertInput>;
  on_conflict?: InputMaybe<AdBriefAssetsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefAssetsOneArgs = {
  object: AdBriefAssetsInsertInput;
  on_conflict?: InputMaybe<AdBriefAssetsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefsArgs = {
  objects: Array<AdBriefsInsertInput>;
  on_conflict?: InputMaybe<AdBriefsOnConflict>;
};


/** mutation root */
export type MutationInsertAdBriefsOneArgs = {
  object: AdBriefsInsertInput;
  on_conflict?: InputMaybe<AdBriefsOnConflict>;
};


/** mutation root */
export type MutationInsertAdExportChannelSizesArgs = {
  objects: Array<AdExportChannelSizesInsertInput>;
  on_conflict?: InputMaybe<AdExportChannelSizesOnConflict>;
};


/** mutation root */
export type MutationInsertAdExportChannelSizesOneArgs = {
  object: AdExportChannelSizesInsertInput;
  on_conflict?: InputMaybe<AdExportChannelSizesOnConflict>;
};


/** mutation root */
export type MutationInsertAdExportChannelsArgs = {
  objects: Array<AdExportChannelsInsertInput>;
  on_conflict?: InputMaybe<AdExportChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertAdExportChannelsOneArgs = {
  object: AdExportChannelsInsertInput;
  on_conflict?: InputMaybe<AdExportChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStatsModelsArgs = {
  objects: Array<AdStatsModelsInsertInput>;
  on_conflict?: InputMaybe<AdStatsModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStatsModelsOneArgs = {
  object: AdStatsModelsInsertInput;
  on_conflict?: InputMaybe<AdStatsModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProductFeedsArgs = {
  objects: Array<AdStudioProductFeedsInsertInput>;
  on_conflict?: InputMaybe<AdStudioProductFeedsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProductFeedsOneArgs = {
  object: AdStudioProductFeedsInsertInput;
  on_conflict?: InputMaybe<AdStudioProductFeedsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectBriefVersionsArgs = {
  objects: Array<AdStudioProjectBriefVersionsInsertInput>;
  on_conflict?: InputMaybe<AdStudioProjectBriefVersionsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectBriefVersionsOneArgs = {
  object: AdStudioProjectBriefVersionsInsertInput;
  on_conflict?: InputMaybe<AdStudioProjectBriefVersionsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectPinsArgs = {
  objects: Array<AdStudioProjectPinsInsertInput>;
  on_conflict?: InputMaybe<AdStudioProjectPinsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectPinsOneArgs = {
  object: AdStudioProjectPinsInsertInput;
  on_conflict?: InputMaybe<AdStudioProjectPinsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectsArgs = {
  objects: Array<AdStudioProjectsInsertInput>;
  on_conflict?: InputMaybe<AdStudioProjectsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioProjectsOneArgs = {
  object: AdStudioProjectsInsertInput;
  on_conflict?: InputMaybe<AdStudioProjectsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioTreatmentsArgs = {
  objects: Array<AdStudioTreatmentsInsertInput>;
  on_conflict?: InputMaybe<AdStudioTreatmentsOnConflict>;
};


/** mutation root */
export type MutationInsertAdStudioTreatmentsOneArgs = {
  object: AdStudioTreatmentsInsertInput;
  on_conflict?: InputMaybe<AdStudioTreatmentsOnConflict>;
};


/** mutation root */
export type MutationInsertAgenticSettingsArgs = {
  objects: Array<AgenticSettingsInsertInput>;
  on_conflict?: InputMaybe<AgenticSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertAgenticSettingsEntitiesLinksArgs = {
  objects: Array<AgenticSettingsEntitiesLinksInsertInput>;
  on_conflict?: InputMaybe<AgenticSettingsEntitiesLinksOnConflict>;
};


/** mutation root */
export type MutationInsertAgenticSettingsEntitiesLinksOneArgs = {
  object: AgenticSettingsEntitiesLinksInsertInput;
  on_conflict?: InputMaybe<AgenticSettingsEntitiesLinksOnConflict>;
};


/** mutation root */
export type MutationInsertAgenticSettingsOneArgs = {
  object: AgenticSettingsInsertInput;
  on_conflict?: InputMaybe<AgenticSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertAlertInstancesArgs = {
  objects: Array<AlertInstancesInsertInput>;
  on_conflict?: InputMaybe<AlertInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertAlertInstancesOneArgs = {
  object: AlertInstancesInsertInput;
  on_conflict?: InputMaybe<AlertInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertAlertsArgs = {
  objects: Array<AlertsInsertInput>;
  on_conflict?: InputMaybe<AlertsOnConflict>;
};


/** mutation root */
export type MutationInsertAlertsOneArgs = {
  object: AlertsInsertInput;
  on_conflict?: InputMaybe<AlertsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpAssetRatingsArgs = {
  objects: Array<AmpAssetRatingsInsertInput>;
  on_conflict?: InputMaybe<AmpAssetRatingsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpAssetRatingsOneArgs = {
  object: AmpAssetRatingsInsertInput;
  on_conflict?: InputMaybe<AmpAssetRatingsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpCreativeDimensionsArgs = {
  objects: Array<AmpCreativeDimensionsInsertInput>;
  on_conflict?: InputMaybe<AmpCreativeDimensionsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpCreativeDimensionsOneArgs = {
  object: AmpCreativeDimensionsInsertInput;
  on_conflict?: InputMaybe<AmpCreativeDimensionsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFileFavoritesArgs = {
  objects: Array<AmpFileFavoritesInsertInput>;
  on_conflict?: InputMaybe<AmpFileFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFileFavoritesOneArgs = {
  object: AmpFileFavoritesInsertInput;
  on_conflict?: InputMaybe<AmpFileFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFollowedSourcesArgs = {
  objects: Array<AmpFollowedSourcesInsertInput>;
  on_conflict?: InputMaybe<AmpFollowedSourcesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFollowedSourcesOneArgs = {
  object: AmpFollowedSourcesInsertInput;
  on_conflict?: InputMaybe<AmpFollowedSourcesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFollowedTopicsArgs = {
  objects: Array<AmpFollowedTopicsInsertInput>;
  on_conflict?: InputMaybe<AmpFollowedTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpFollowedTopicsOneArgs = {
  object: AmpFollowedTopicsInsertInput;
  on_conflict?: InputMaybe<AmpFollowedTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpProjectPinsArgs = {
  objects: Array<AmpProjectPinsInsertInput>;
  on_conflict?: InputMaybe<AmpProjectPinsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpProjectPinsOneArgs = {
  object: AmpProjectPinsInsertInput;
  on_conflict?: InputMaybe<AmpProjectPinsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpProjectUsersArgs = {
  objects: Array<AmpProjectUsersInsertInput>;
  on_conflict?: InputMaybe<AmpProjectUsersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpProjectUsersOneArgs = {
  object: AmpProjectUsersInsertInput;
  on_conflict?: InputMaybe<AmpProjectUsersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTagsArgs = {
  objects: Array<AmpTagsInsertInput>;
  on_conflict?: InputMaybe<AmpTagsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTagsOneArgs = {
  object: AmpTagsInsertInput;
  on_conflict?: InputMaybe<AmpTagsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTaskRelationsArgs = {
  objects: Array<AmpTaskRelationsInsertInput>;
  on_conflict?: InputMaybe<AmpTaskRelationsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTaskRelationsOneArgs = {
  object: AmpTaskRelationsInsertInput;
  on_conflict?: InputMaybe<AmpTaskRelationsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTaskUsersArgs = {
  objects: Array<AmpTaskUsersInsertInput>;
  on_conflict?: InputMaybe<AmpTaskUsersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTaskUsersOneArgs = {
  object: AmpTaskUsersInsertInput;
  on_conflict?: InputMaybe<AmpTaskUsersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTeamMembersArgs = {
  objects: Array<AmpTeamMembersInsertInput>;
  on_conflict?: InputMaybe<AmpTeamMembersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTeamMembersOneArgs = {
  object: AmpTeamMembersInsertInput;
  on_conflict?: InputMaybe<AmpTeamMembersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTeamsArgs = {
  objects: Array<AmpTeamsInsertInput>;
  on_conflict?: InputMaybe<AmpTeamsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpTeamsOneArgs = {
  object: AmpTeamsInsertInput;
  on_conflict?: InputMaybe<AmpTeamsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowStatusReviewersArgs = {
  objects: Array<AmpWorkflowStatusReviewersInsertInput>;
  on_conflict?: InputMaybe<AmpWorkflowStatusReviewersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowStatusReviewersOneArgs = {
  object: AmpWorkflowStatusReviewersInsertInput;
  on_conflict?: InputMaybe<AmpWorkflowStatusReviewersOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowStatusesArgs = {
  objects: Array<AmpWorkflowStatusesInsertInput>;
  on_conflict?: InputMaybe<AmpWorkflowStatusesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowStatusesOneArgs = {
  object: AmpWorkflowStatusesInsertInput;
  on_conflict?: InputMaybe<AmpWorkflowStatusesOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowsArgs = {
  objects: Array<AmpWorkflowsInsertInput>;
  on_conflict?: InputMaybe<AmpWorkflowsOnConflict>;
};


/** mutation root */
export type MutationInsertAmpWorkflowsOneArgs = {
  object: AmpWorkflowsInsertInput;
  on_conflict?: InputMaybe<AmpWorkflowsOnConflict>;
};


/** mutation root */
export type MutationInsertAnalyticsReportsArgs = {
  objects: Array<AnalyticsReportsInsertInput>;
  on_conflict?: InputMaybe<AnalyticsReportsOnConflict>;
};


/** mutation root */
export type MutationInsertAnalyticsReportsOneArgs = {
  object: AnalyticsReportsInsertInput;
  on_conflict?: InputMaybe<AnalyticsReportsOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactFavoritesArgs = {
  objects: Array<ArtifactFavoritesInsertInput>;
  on_conflict?: InputMaybe<ArtifactFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactFavoritesOneArgs = {
  object: ArtifactFavoritesInsertInput;
  on_conflict?: InputMaybe<ArtifactFavoritesOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewCommentsArgs = {
  objects: Array<ArtifactReviewCommentsInsertInput>;
  on_conflict?: InputMaybe<ArtifactReviewCommentsOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewCommentsOneArgs = {
  object: ArtifactReviewCommentsInsertInput;
  on_conflict?: InputMaybe<ArtifactReviewCommentsOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewStatusesArgs = {
  objects: Array<ArtifactReviewStatusesInsertInput>;
  on_conflict?: InputMaybe<ArtifactReviewStatusesOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewStatusesOneArgs = {
  object: ArtifactReviewStatusesInsertInput;
  on_conflict?: InputMaybe<ArtifactReviewStatusesOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewersArgs = {
  objects: Array<ArtifactReviewersInsertInput>;
  on_conflict?: InputMaybe<ArtifactReviewersOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewersOneArgs = {
  object: ArtifactReviewersInsertInput;
  on_conflict?: InputMaybe<ArtifactReviewersOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewsArgs = {
  objects: Array<ArtifactReviewsInsertInput>;
  on_conflict?: InputMaybe<ArtifactReviewsOnConflict>;
};


/** mutation root */
export type MutationInsertArtifactReviewsOneArgs = {
  object: ArtifactReviewsInsertInput;
  on_conflict?: InputMaybe<ArtifactReviewsOnConflict>;
};


/** mutation root */
export type MutationInsertAssetCommentThreadReadsArgs = {
  objects: Array<AssetCommentThreadReadsInsertInput>;
  on_conflict?: InputMaybe<AssetCommentThreadReadsOnConflict>;
};


/** mutation root */
export type MutationInsertAssetCommentThreadReadsOneArgs = {
  object: AssetCommentThreadReadsInsertInput;
  on_conflict?: InputMaybe<AssetCommentThreadReadsOnConflict>;
};


/** mutation root */
export type MutationInsertAssetModelsArgs = {
  objects: Array<AssetModelsInsertInput>;
  on_conflict?: InputMaybe<AssetModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAssetModelsOneArgs = {
  object: AssetModelsInsertInput;
  on_conflict?: InputMaybe<AssetModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAttributionMethodsArgs = {
  objects: Array<AttributionMethodsInsertInput>;
  on_conflict?: InputMaybe<AttributionMethodsOnConflict>;
};


/** mutation root */
export type MutationInsertAttributionMethodsInteractionsArgs = {
  objects: Array<AttributionMethodsInteractionsInsertInput>;
  on_conflict?: InputMaybe<AttributionMethodsInteractionsOnConflict>;
};


/** mutation root */
export type MutationInsertAttributionMethodsInteractionsOneArgs = {
  object: AttributionMethodsInteractionsInsertInput;
  on_conflict?: InputMaybe<AttributionMethodsInteractionsOnConflict>;
};


/** mutation root */
export type MutationInsertAttributionMethodsOneArgs = {
  object: AttributionMethodsInsertInput;
  on_conflict?: InputMaybe<AttributionMethodsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceGoalsArgs = {
  objects: Array<AudienceGoalsInsertInput>;
  on_conflict?: InputMaybe<AudienceGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceGoalsOneArgs = {
  object: AudienceGoalsInsertInput;
  on_conflict?: InputMaybe<AudienceGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceOverviewsArgs = {
  objects: Array<AudienceOverviewsInsertInput>;
  on_conflict?: InputMaybe<AudienceOverviewsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceOverviewsOneArgs = {
  object: AudienceOverviewsInsertInput;
  on_conflict?: InputMaybe<AudienceOverviewsOnConflict>;
};


/** mutation root */
export type MutationInsertAudiencePrimaryMetricsArgs = {
  objects: Array<AudiencePrimaryMetricsInsertInput>;
  on_conflict?: InputMaybe<AudiencePrimaryMetricsOnConflict>;
};


/** mutation root */
export type MutationInsertAudiencePrimaryMetricsOneArgs = {
  object: AudiencePrimaryMetricsInsertInput;
  on_conflict?: InputMaybe<AudiencePrimaryMetricsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSplitsArgs = {
  objects: Array<AudienceSplitsInsertInput>;
  on_conflict?: InputMaybe<AudienceSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSplitsOneArgs = {
  object: AudienceSplitsInsertInput;
  on_conflict?: InputMaybe<AudienceSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetGroupRequiredModelsArgs = {
  objects: Array<AudienceSubsetGroupRequiredModelsInsertInput>;
  on_conflict?: InputMaybe<AudienceSubsetGroupRequiredModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetGroupRequiredModelsOneArgs = {
  object: AudienceSubsetGroupRequiredModelsInsertInput;
  on_conflict?: InputMaybe<AudienceSubsetGroupRequiredModelsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetGroupsArgs = {
  objects: Array<AudienceSubsetGroupsInsertInput>;
  on_conflict?: InputMaybe<AudienceSubsetGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetGroupsOneArgs = {
  object: AudienceSubsetGroupsInsertInput;
  on_conflict?: InputMaybe<AudienceSubsetGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetValuesArgs = {
  objects: Array<AudienceSubsetValuesInsertInput>;
  on_conflict?: InputMaybe<AudienceSubsetValuesOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceSubsetValuesOneArgs = {
  object: AudienceSubsetValuesInsertInput;
  on_conflict?: InputMaybe<AudienceSubsetValuesOnConflict>;
};


/** mutation root */
export type MutationInsertAudienceTemplateSegmentsArgs = {
  objects: Array<AudienceTemplateSegmentsInsertInput>;
  on_conflict?: InputMaybe<AudienceTemplateSegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertAudiencesSubsetsArgs = {
  objects: Array<AudiencesSubsetsInsertInput>;
  on_conflict?: InputMaybe<AudiencesSubsetsOnConflict>;
};


/** mutation root */
export type MutationInsertAudiencesSubsetsOneArgs = {
  object: AudiencesSubsetsInsertInput;
  on_conflict?: InputMaybe<AudiencesSubsetsOnConflict>;
};


/** mutation root */
export type MutationInsertBrandProfilesArgs = {
  objects: Array<BrandProfilesInsertInput>;
  on_conflict?: InputMaybe<BrandProfilesOnConflict>;
};


/** mutation root */
export type MutationInsertBrandProfilesOneArgs = {
  object: BrandProfilesInsertInput;
  on_conflict?: InputMaybe<BrandProfilesOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignArtifactsArgs = {
  objects: Array<CampaignArtifactsInsertInput>;
  on_conflict?: InputMaybe<CampaignArtifactsOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignArtifactsOneArgs = {
  object: CampaignArtifactsInsertInput;
  on_conflict?: InputMaybe<CampaignArtifactsOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignLabelsArgs = {
  objects: Array<CampaignLabelsInsertInput>;
  on_conflict?: InputMaybe<CampaignLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignLabelsOneArgs = {
  object: CampaignLabelsInsertInput;
  on_conflict?: InputMaybe<CampaignLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignsArgs = {
  objects: Array<CampaignsInsertInput>;
  on_conflict?: InputMaybe<CampaignsOnConflict>;
};


/** mutation root */
export type MutationInsertCampaignsOneArgs = {
  object: CampaignsInsertInput;
  on_conflict?: InputMaybe<CampaignsOnConflict>;
};


/** mutation root */
export type MutationInsertCatalogCollectionsArgs = {
  objects: Array<CatalogCollectionsInsertInput>;
  on_conflict?: InputMaybe<CatalogCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertCatalogCollectionsOneArgs = {
  object: CatalogCollectionsInsertInput;
  on_conflict?: InputMaybe<CatalogCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertCatalogModelsArgs = {
  objects: Array<CatalogModelsInsertInput>;
  on_conflict?: InputMaybe<CatalogModelsOnConflict>;
};


/** mutation root */
export type MutationInsertCatalogModelsOneArgs = {
  object: CatalogModelsInsertInput;
  on_conflict?: InputMaybe<CatalogModelsOnConflict>;
};


/** mutation root */
export type MutationInsertCepBrandSettingsArgs = {
  objects: Array<CepBrandSettingsInsertInput>;
  on_conflict?: InputMaybe<CepBrandSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertCepBrandSettingsOneArgs = {
  object: CepBrandSettingsInsertInput;
  on_conflict?: InputMaybe<CepBrandSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertCepChannelsArgs = {
  objects: Array<CepChannelsInsertInput>;
  on_conflict?: InputMaybe<CepChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertCepChannelsOneArgs = {
  object: CepChannelsInsertInput;
  on_conflict?: InputMaybe<CepChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertCepContentBlocksArgs = {
  objects: Array<CepContentBlocksInsertInput>;
  on_conflict?: InputMaybe<CepContentBlocksOnConflict>;
};


/** mutation root */
export type MutationInsertCepContentBlocksOneArgs = {
  object: CepContentBlocksInsertInput;
  on_conflict?: InputMaybe<CepContentBlocksOnConflict>;
};


/** mutation root */
export type MutationInsertCepDomainsArgs = {
  objects: Array<CepDomainsInsertInput>;
  on_conflict?: InputMaybe<CepDomainsOnConflict>;
};


/** mutation root */
export type MutationInsertCepDomainsOneArgs = {
  object: CepDomainsInsertInput;
  on_conflict?: InputMaybe<CepDomainsOnConflict>;
};


/** mutation root */
export type MutationInsertCepEmailTemplateContentsArgs = {
  objects: Array<CepEmailTemplateContentsInsertInput>;
  on_conflict?: InputMaybe<CepEmailTemplateContentsOnConflict>;
};


/** mutation root */
export type MutationInsertCepEmailTemplateContentsOneArgs = {
  object: CepEmailTemplateContentsInsertInput;
  on_conflict?: InputMaybe<CepEmailTemplateContentsOnConflict>;
};


/** mutation root */
export type MutationInsertCepEmailTemplatesArgs = {
  objects: Array<CepEmailTemplatesInsertInput>;
  on_conflict?: InputMaybe<CepEmailTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertCepEmailTemplatesOneArgs = {
  object: CepEmailTemplatesInsertInput;
  on_conflict?: InputMaybe<CepEmailTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertCepLocalesArgs = {
  objects: Array<CepLocalesInsertInput>;
  on_conflict?: InputMaybe<CepLocalesOnConflict>;
};


/** mutation root */
export type MutationInsertCepLocalesOneArgs = {
  object: CepLocalesInsertInput;
  on_conflict?: InputMaybe<CepLocalesOnConflict>;
};


/** mutation root */
export type MutationInsertCepLocalizationSettingsArgs = {
  objects: Array<CepLocalizationSettingsInsertInput>;
  on_conflict?: InputMaybe<CepLocalizationSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertCepLocalizationSettingsOneArgs = {
  object: CepLocalizationSettingsInsertInput;
  on_conflict?: InputMaybe<CepLocalizationSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertCepProvidersArgs = {
  objects: Array<CepProvidersInsertInput>;
  on_conflict?: InputMaybe<CepProvidersOnConflict>;
};


/** mutation root */
export type MutationInsertCepProvidersOneArgs = {
  object: CepProvidersInsertInput;
  on_conflict?: InputMaybe<CepProvidersOnConflict>;
};


/** mutation root */
export type MutationInsertCepSenderIdentitiesArgs = {
  objects: Array<CepSenderIdentitiesInsertInput>;
  on_conflict?: InputMaybe<CepSenderIdentitiesOnConflict>;
};


/** mutation root */
export type MutationInsertCepSenderIdentitiesOneArgs = {
  object: CepSenderIdentitiesInsertInput;
  on_conflict?: InputMaybe<CepSenderIdentitiesOnConflict>;
};


/** mutation root */
export type MutationInsertCepSubscriptionTopicSenderIdentitiesArgs = {
  objects: Array<CepSubscriptionTopicSenderIdentitiesInsertInput>;
  on_conflict?: InputMaybe<CepSubscriptionTopicSenderIdentitiesOnConflict>;
};


/** mutation root */
export type MutationInsertCepSubscriptionTopicSenderIdentitiesOneArgs = {
  object: CepSubscriptionTopicSenderIdentitiesInsertInput;
  on_conflict?: InputMaybe<CepSubscriptionTopicSenderIdentitiesOnConflict>;
};


/** mutation root */
export type MutationInsertCepSubscriptionTopicsArgs = {
  objects: Array<CepSubscriptionTopicsInsertInput>;
  on_conflict?: InputMaybe<CepSubscriptionTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertCepSubscriptionTopicsOneArgs = {
  object: CepSubscriptionTopicsInsertInput;
  on_conflict?: InputMaybe<CepSubscriptionTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertCepSuppressionListSubscriptionTopicsArgs = {
  objects: Array<CepSuppressionListSubscriptionTopicsInsertInput>;
  on_conflict?: InputMaybe<CepSuppressionListSubscriptionTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertCepSuppressionListSubscriptionTopicsOneArgs = {
  object: CepSuppressionListSubscriptionTopicsInsertInput;
  on_conflict?: InputMaybe<CepSuppressionListSubscriptionTopicsOnConflict>;
};


/** mutation root */
export type MutationInsertCepSuppressionListsArgs = {
  objects: Array<CepSuppressionListsInsertInput>;
  on_conflict?: InputMaybe<CepSuppressionListsOnConflict>;
};


/** mutation root */
export type MutationInsertCepSuppressionListsOneArgs = {
  object: CepSuppressionListsInsertInput;
  on_conflict?: InputMaybe<CepSuppressionListsOnConflict>;
};


/** mutation root */
export type MutationInsertCepTestGroupMembersArgs = {
  objects: Array<CepTestGroupMembersInsertInput>;
  on_conflict?: InputMaybe<CepTestGroupMembersOnConflict>;
};


/** mutation root */
export type MutationInsertCepTestGroupMembersOneArgs = {
  object: CepTestGroupMembersInsertInput;
  on_conflict?: InputMaybe<CepTestGroupMembersOnConflict>;
};


/** mutation root */
export type MutationInsertCepTestGroupsArgs = {
  objects: Array<CepTestGroupsInsertInput>;
  on_conflict?: InputMaybe<CepTestGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertCepTestGroupsOneArgs = {
  object: CepTestGroupsInsertInput;
  on_conflict?: InputMaybe<CepTestGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertCepWorkspaceConfigArgs = {
  objects: Array<CepWorkspaceConfigInsertInput>;
  on_conflict?: InputMaybe<CepWorkspaceConfigOnConflict>;
};


/** mutation root */
export type MutationInsertCepWorkspaceConfigOneArgs = {
  object: CepWorkspaceConfigInsertInput;
  on_conflict?: InputMaybe<CepWorkspaceConfigOnConflict>;
};


/** mutation root */
export type MutationInsertChartCardsArgs = {
  objects: Array<ChartCardsInsertInput>;
  on_conflict?: InputMaybe<ChartCardsOnConflict>;
};


/** mutation root */
export type MutationInsertChartCardsOneArgs = {
  object: ChartCardsInsertInput;
  on_conflict?: InputMaybe<ChartCardsOnConflict>;
};


/** mutation root */
export type MutationInsertConditionTemplateLabelsArgs = {
  objects: Array<ConditionTemplateLabelsInsertInput>;
  on_conflict?: InputMaybe<ConditionTemplateLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertConditionTemplateLabelsOneArgs = {
  object: ConditionTemplateLabelsInsertInput;
  on_conflict?: InputMaybe<ConditionTemplateLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertContentBlockLabelsArgs = {
  objects: Array<ContentBlockLabelsInsertInput>;
  on_conflict?: InputMaybe<ContentBlockLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertContentBlockLabelsOneArgs = {
  object: ContentBlockLabelsInsertInput;
  on_conflict?: InputMaybe<ContentBlockLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertContentBlocksArgs = {
  objects: Array<ContentBlocksInsertInput>;
  on_conflict?: InputMaybe<ContentBlocksOnConflict>;
};


/** mutation root */
export type MutationInsertContentBlocksOneArgs = {
  object: ContentBlocksInsertInput;
  on_conflict?: InputMaybe<ContentBlocksOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotAssignmentsArgs = {
  objects: Array<ContentDynamicSlotAssignmentsInsertInput>;
  on_conflict?: InputMaybe<ContentDynamicSlotAssignmentsOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotAssignmentsOneArgs = {
  object: ContentDynamicSlotAssignmentsInsertInput;
  on_conflict?: InputMaybe<ContentDynamicSlotAssignmentsOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotBranchesArgs = {
  objects: Array<ContentDynamicSlotBranchesInsertInput>;
  on_conflict?: InputMaybe<ContentDynamicSlotBranchesOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotBranchesOneArgs = {
  object: ContentDynamicSlotBranchesInsertInput;
  on_conflict?: InputMaybe<ContentDynamicSlotBranchesOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotContentsArgs = {
  objects: Array<ContentDynamicSlotContentsInsertInput>;
  on_conflict?: InputMaybe<ContentDynamicSlotContentsOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotContentsOneArgs = {
  object: ContentDynamicSlotContentsInsertInput;
  on_conflict?: InputMaybe<ContentDynamicSlotContentsOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotLibrariesArgs = {
  objects: Array<ContentDynamicSlotLibrariesInsertInput>;
  on_conflict?: InputMaybe<ContentDynamicSlotLibrariesOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotLibrariesOneArgs = {
  object: ContentDynamicSlotLibrariesInsertInput;
  on_conflict?: InputMaybe<ContentDynamicSlotLibrariesOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotUsagesArgs = {
  objects: Array<ContentDynamicSlotUsagesInsertInput>;
  on_conflict?: InputMaybe<ContentDynamicSlotUsagesOnConflict>;
};


/** mutation root */
export type MutationInsertContentDynamicSlotUsagesOneArgs = {
  object: ContentDynamicSlotUsagesInsertInput;
  on_conflict?: InputMaybe<ContentDynamicSlotUsagesOnConflict>;
};


/** mutation root */
export type MutationInsertContentEmailVariantsArgs = {
  objects: Array<ContentEmailVariantsInsertInput>;
  on_conflict?: InputMaybe<ContentEmailVariantsOnConflict>;
};


/** mutation root */
export type MutationInsertContentEmailVariantsOneArgs = {
  object: ContentEmailVariantsInsertInput;
  on_conflict?: InputMaybe<ContentEmailVariantsOnConflict>;
};


/** mutation root */
export type MutationInsertContentSettingsArgs = {
  objects: Array<ContentSettingsInsertInput>;
  on_conflict?: InputMaybe<ContentSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertContentSettingsOneArgs = {
  object: ContentSettingsInsertInput;
  on_conflict?: InputMaybe<ContentSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertContentTemplatesArgs = {
  objects: Array<ContentTemplatesInsertInput>;
  on_conflict?: InputMaybe<ContentTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertContentTemplatesOneArgs = {
  object: ContentTemplatesInsertInput;
  on_conflict?: InputMaybe<ContentTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertCustomAgentsArgs = {
  objects: Array<CustomAgentsInsertInput>;
  on_conflict?: InputMaybe<CustomAgentsOnConflict>;
};


/** mutation root */
export type MutationInsertCustomAgentsOneArgs = {
  object: CustomAgentsInsertInput;
  on_conflict?: InputMaybe<CustomAgentsOnConflict>;
};


/** mutation root */
export type MutationInsertDashboardsArgs = {
  objects: Array<DashboardsInsertInput>;
  on_conflict?: InputMaybe<DashboardsOnConflict>;
};


/** mutation root */
export type MutationInsertDashboardsOneArgs = {
  object: DashboardsInsertInput;
  on_conflict?: InputMaybe<DashboardsOnConflict>;
};


/** mutation root */
export type MutationInsertDatadogCredentialsArgs = {
  objects: Array<DatadogCredentialsInsertInput>;
  on_conflict?: InputMaybe<DatadogCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertDatadogCredentialsOneArgs = {
  object: DatadogCredentialsInsertInput;
  on_conflict?: InputMaybe<DatadogCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertDbtCloudSyncConfigArgs = {
  objects: Array<DbtCloudSyncConfigInsertInput>;
  on_conflict?: InputMaybe<DbtCloudSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDbtCloudSyncConfigOneArgs = {
  object: DbtCloudSyncConfigInsertInput;
  on_conflict?: InputMaybe<DbtCloudSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDbtSyncConfigArgs = {
  objects: Array<DbtSyncConfigInsertInput>;
  on_conflict?: InputMaybe<DbtSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDbtSyncConfigOneArgs = {
  object: DbtSyncConfigInsertInput;
  on_conflict?: InputMaybe<DbtSyncConfigOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineCollectionsArgs = {
  objects: Array<DecisionEngineCollectionsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineCollectionsOneArgs = {
  object: DecisionEngineCollectionsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFeatureMatricesArgs = {
  objects: Array<DecisionEngineFeatureMatricesInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineFeatureMatricesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFeatureMatricesOneArgs = {
  object: DecisionEngineFeatureMatricesInsertInput;
  on_conflict?: InputMaybe<DecisionEngineFeatureMatricesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFeatureMatrixRelationshipsArgs = {
  objects: Array<DecisionEngineFeatureMatrixRelationshipsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFeatureMatrixRelationshipsOneArgs = {
  object: DecisionEngineFeatureMatrixRelationshipsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowExperimentsArgs = {
  objects: Array<DecisionEngineFlowExperimentsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineFlowExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowExperimentsOneArgs = {
  object: DecisionEngineFlowExperimentsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineFlowExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowOutcomesArgs = {
  objects: Array<DecisionEngineFlowOutcomesInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineFlowOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowOutcomesOneArgs = {
  object: DecisionEngineFlowOutcomesInsertInput;
  on_conflict?: InputMaybe<DecisionEngineFlowOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowTagsArgs = {
  objects: Array<DecisionEngineFlowTagsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineFlowTagsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineFlowTagsOneArgs = {
  object: DecisionEngineFlowTagsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineFlowTagsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineMessageCollectionsArgs = {
  objects: Array<DecisionEngineMessageCollectionsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineMessageCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineMessageCollectionsOneArgs = {
  object: DecisionEngineMessageCollectionsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineMessageCollectionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineMessageVariantSuggestionsArgs = {
  objects: Array<DecisionEngineMessageVariantSuggestionsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineMessageVariantSuggestionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineMessageVariantSuggestionsOneArgs = {
  object: DecisionEngineMessageVariantSuggestionsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineMessageVariantSuggestionsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineModelOutcomesArgs = {
  objects: Array<DecisionEngineModelOutcomesInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineModelOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineModelOutcomesOneArgs = {
  object: DecisionEngineModelOutcomesInsertInput;
  on_conflict?: InputMaybe<DecisionEngineModelOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineModelsArgs = {
  objects: Array<DecisionEngineModelsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineModelsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineModelsOneArgs = {
  object: DecisionEngineModelsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineModelsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineOffersArgs = {
  objects: Array<DecisionEngineOffersInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineOffersOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineOffersOneArgs = {
  object: DecisionEngineOffersInsertInput;
  on_conflict?: InputMaybe<DecisionEngineOffersOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineOutcomesArgs = {
  objects: Array<DecisionEngineOutcomesInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineOutcomesOneArgs = {
  object: DecisionEngineOutcomesInsertInput;
  on_conflict?: InputMaybe<DecisionEngineOutcomesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineSendEventsArgs = {
  objects: Array<DecisionEngineSendEventsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineSendEventsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineSendEventsOneArgs = {
  object: DecisionEngineSendEventsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineSendEventsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineSplitsArgs = {
  objects: Array<DecisionEngineSplitsInsertInput>;
  on_conflict?: InputMaybe<DecisionEngineSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEngineSplitsOneArgs = {
  object: DecisionEngineSplitsInsertInput;
  on_conflict?: InputMaybe<DecisionEngineSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEnginesArgs = {
  objects: Array<DecisionEnginesInsertInput>;
  on_conflict?: InputMaybe<DecisionEnginesOnConflict>;
};


/** mutation root */
export type MutationInsertDecisionEnginesOneArgs = {
  object: DecisionEnginesInsertInput;
  on_conflict?: InputMaybe<DecisionEnginesOnConflict>;
};


/** mutation root */
export type MutationInsertDeliverabilityFeedsArgs = {
  objects: Array<DeliverabilityFeedsInsertInput>;
  on_conflict?: InputMaybe<DeliverabilityFeedsOnConflict>;
};


/** mutation root */
export type MutationInsertDeliverabilityFeedsOneArgs = {
  object: DeliverabilityFeedsInsertInput;
  on_conflict?: InputMaybe<DeliverabilityFeedsOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstanceSplitsArgs = {
  objects: Array<DestinationInstanceSplitsInsertInput>;
  on_conflict?: InputMaybe<DestinationInstanceSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstanceSplitsOneArgs = {
  object: DestinationInstanceSplitsInsertInput;
  on_conflict?: InputMaybe<DestinationInstanceSplitsOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstancesArgs = {
  objects: Array<DestinationInstancesInsertInput>;
  on_conflict?: InputMaybe<DestinationInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationInstancesOneArgs = {
  object: DestinationInstancesInsertInput;
  on_conflict?: InputMaybe<DestinationInstancesOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationRulesArgs = {
  objects: Array<DestinationRulesInsertInput>;
  on_conflict?: InputMaybe<DestinationRulesOnConflict>;
};


/** mutation root */
export type MutationInsertDestinationRulesOneArgs = {
  object: DestinationRulesInsertInput;
  on_conflict?: InputMaybe<DestinationRulesOnConflict>;
};


/** mutation root */
export type MutationInsertDirectModelRelationshipsArgs = {
  objects: Array<DirectModelRelationshipsInsertInput>;
  on_conflict?: InputMaybe<DirectModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertDirectModelRelationshipsOneArgs = {
  object: DirectModelRelationshipsInsertInput;
  on_conflict?: InputMaybe<DirectModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertEmailTemplateLabelsArgs = {
  objects: Array<EmailTemplateLabelsInsertInput>;
  on_conflict?: InputMaybe<EmailTemplateLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertEmailTemplateLabelsOneArgs = {
  object: EmailTemplateLabelsInsertInput;
  on_conflict?: InputMaybe<EmailTemplateLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertEtlConnectionsArgs = {
  objects: Array<EtlConnectionsInsertInput>;
  on_conflict?: InputMaybe<EtlConnectionsOnConflict>;
};


/** mutation root */
export type MutationInsertEtlConnectionsOneArgs = {
  object: EtlConnectionsInsertInput;
  on_conflict?: InputMaybe<EtlConnectionsOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsArgs = {
  objects: Array<EventComponentsInsertInput>;
  on_conflict?: InputMaybe<EventComponentsOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsConditionsArgs = {
  objects: Array<EventComponentsConditionsInsertInput>;
  on_conflict?: InputMaybe<EventComponentsConditionsOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsConditionsOneArgs = {
  object: EventComponentsConditionsInsertInput;
  on_conflict?: InputMaybe<EventComponentsConditionsOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsJoinArgs = {
  objects: Array<EventComponentsJoinInsertInput>;
  on_conflict?: InputMaybe<EventComponentsJoinOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsJoinOneArgs = {
  object: EventComponentsJoinInsertInput;
  on_conflict?: InputMaybe<EventComponentsJoinOnConflict>;
};


/** mutation root */
export type MutationInsertEventComponentsOneArgs = {
  object: EventComponentsInsertInput;
  on_conflict?: InputMaybe<EventComponentsOnConflict>;
};


/** mutation root */
export type MutationInsertEventContractsArgs = {
  objects: Array<EventContractsInsertInput>;
  on_conflict?: InputMaybe<EventContractsOnConflict>;
};


/** mutation root */
export type MutationInsertEventContractsOneArgs = {
  object: EventContractsInsertInput;
  on_conflict?: InputMaybe<EventContractsOnConflict>;
};


/** mutation root */
export type MutationInsertEventContractsSchemaArgs = {
  objects: Array<EventContractsSchemaInsertInput>;
  on_conflict?: InputMaybe<EventContractsSchemaOnConflict>;
};


/** mutation root */
export type MutationInsertEventContractsSchemaOneArgs = {
  object: EventContractsSchemaInsertInput;
  on_conflict?: InputMaybe<EventContractsSchemaOnConflict>;
};


/** mutation root */
export type MutationInsertEventForwardingDestinationGrantsArgs = {
  objects: Array<EventForwardingDestinationGrantsInsertInput>;
  on_conflict?: InputMaybe<EventForwardingDestinationGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventForwardingDestinationGrantsOneArgs = {
  object: EventForwardingDestinationGrantsInsertInput;
  on_conflict?: InputMaybe<EventForwardingDestinationGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventForwardingSyncsArgs = {
  objects: Array<EventForwardingSyncsInsertInput>;
  on_conflict?: InputMaybe<EventForwardingSyncsOnConflict>;
};


/** mutation root */
export type MutationInsertEventForwardingSyncsOneArgs = {
  object: EventForwardingSyncsInsertInput;
  on_conflict?: InputMaybe<EventForwardingSyncsOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelEventSourcesArgs = {
  objects: Array<EventModelEventSourcesInsertInput>;
  on_conflict?: InputMaybe<EventModelEventSourcesOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelEventSourcesOneArgs = {
  object: EventModelEventSourcesInsertInput;
  on_conflict?: InputMaybe<EventModelEventSourcesOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelsArgs = {
  objects: Array<EventModelsInsertInput>;
  on_conflict?: InputMaybe<EventModelsOnConflict>;
};


/** mutation root */
export type MutationInsertEventModelsOneArgs = {
  object: EventModelsInsertInput;
  on_conflict?: InputMaybe<EventModelsOnConflict>;
};


/** mutation root */
export type MutationInsertEventPlanGrantsArgs = {
  objects: Array<EventPlanGrantsInsertInput>;
  on_conflict?: InputMaybe<EventPlanGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventPlanGrantsOneArgs = {
  object: EventPlanGrantsInsertInput;
  on_conflict?: InputMaybe<EventPlanGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventPlansArgs = {
  objects: Array<EventPlansInsertInput>;
  on_conflict?: InputMaybe<EventPlansOnConflict>;
};


/** mutation root */
export type MutationInsertEventPlansOneArgs = {
  object: EventPlansInsertInput;
  on_conflict?: InputMaybe<EventPlansOnConflict>;
};


/** mutation root */
export type MutationInsertEventSchemaComponentsArgs = {
  objects: Array<EventSchemaComponentsInsertInput>;
  on_conflict?: InputMaybe<EventSchemaComponentsOnConflict>;
};


/** mutation root */
export type MutationInsertEventSchemaComponentsOneArgs = {
  object: EventSchemaComponentsInsertInput;
  on_conflict?: InputMaybe<EventSchemaComponentsOnConflict>;
};


/** mutation root */
export type MutationInsertEventSchemasArgs = {
  objects: Array<EventSchemasInsertInput>;
  on_conflict?: InputMaybe<EventSchemasOnConflict>;
};


/** mutation root */
export type MutationInsertEventSchemasOneArgs = {
  object: EventSchemasInsertInput;
  on_conflict?: InputMaybe<EventSchemasOnConflict>;
};


/** mutation root */
export type MutationInsertEventSourceContractsArgs = {
  objects: Array<EventSourceContractsInsertInput>;
  on_conflict?: InputMaybe<EventSourceContractsOnConflict>;
};


/** mutation root */
export type MutationInsertEventSourceContractsOneArgs = {
  object: EventSourceContractsInsertInput;
  on_conflict?: InputMaybe<EventSourceContractsOnConflict>;
};


/** mutation root */
export type MutationInsertEventSourceGrantsArgs = {
  objects: Array<EventSourceGrantsInsertInput>;
  on_conflict?: InputMaybe<EventSourceGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventSourceGrantsOneArgs = {
  object: EventSourceGrantsInsertInput;
  on_conflict?: InputMaybe<EventSourceGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventWarehouseDestinationGrantsArgs = {
  objects: Array<EventWarehouseDestinationGrantsInsertInput>;
  on_conflict?: InputMaybe<EventWarehouseDestinationGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertEventWarehouseDestinationGrantsOneArgs = {
  object: EventWarehouseDestinationGrantsInsertInput;
  on_conflict?: InputMaybe<EventWarehouseDestinationGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertExperimentMetricsArgs = {
  objects: Array<ExperimentMetricsInsertInput>;
  on_conflict?: InputMaybe<ExperimentMetricsOnConflict>;
};


/** mutation root */
export type MutationInsertExperimentMetricsOneArgs = {
  object: ExperimentMetricsInsertInput;
  on_conflict?: InputMaybe<ExperimentMetricsOnConflict>;
};


/** mutation root */
export type MutationInsertExperimentsArgs = {
  objects: Array<ExperimentsInsertInput>;
  on_conflict?: InputMaybe<ExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertExperimentsOneArgs = {
  object: ExperimentsInsertInput;
  on_conflict?: InputMaybe<ExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertExternalBucketsArgs = {
  objects: Array<ExternalBucketsInsertInput>;
  on_conflict?: InputMaybe<ExternalBucketsOnConflict>;
};


/** mutation root */
export type MutationInsertExternalBucketsOneArgs = {
  object: ExternalBucketsInsertInput;
  on_conflict?: InputMaybe<ExternalBucketsOnConflict>;
};


/** mutation root */
export type MutationInsertFoldersArgs = {
  objects: Array<FoldersInsertInput>;
  on_conflict?: InputMaybe<FoldersOnConflict>;
};


/** mutation root */
export type MutationInsertFoldersOneArgs = {
  object: FoldersInsertInput;
  on_conflict?: InputMaybe<FoldersOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionGrantsArgs = {
  objects: Array<FunctionGrantsInsertInput>;
  on_conflict?: InputMaybe<FunctionGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionGrantsOneArgs = {
  object: FunctionGrantsInsertInput;
  on_conflict?: InputMaybe<FunctionGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionResourcesArgs = {
  objects: Array<FunctionResourcesInsertInput>;
  on_conflict?: InputMaybe<FunctionResourcesOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionResourcesOneArgs = {
  object: FunctionResourcesInsertInput;
  on_conflict?: InputMaybe<FunctionResourcesOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionSettingsArgs = {
  objects: Array<FunctionSettingsInsertInput>;
  on_conflict?: InputMaybe<FunctionSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertFunctionSettingsOneArgs = {
  object: FunctionSettingsInsertInput;
  on_conflict?: InputMaybe<FunctionSettingsOnConflict>;
};


/** mutation root */
export type MutationInsertGoalsArgs = {
  objects: Array<GoalsInsertInput>;
  on_conflict?: InputMaybe<GoalsOnConflict>;
};


/** mutation root */
export type MutationInsertGoalsAttributionMethodsArgs = {
  objects: Array<GoalsAttributionMethodsInsertInput>;
  on_conflict?: InputMaybe<GoalsAttributionMethodsOnConflict>;
};


/** mutation root */
export type MutationInsertGoalsAttributionMethodsOneArgs = {
  object: GoalsAttributionMethodsInsertInput;
  on_conflict?: InputMaybe<GoalsAttributionMethodsOnConflict>;
};


/** mutation root */
export type MutationInsertGoalsOneArgs = {
  object: GoalsInsertInput;
  on_conflict?: InputMaybe<GoalsOnConflict>;
};


/** mutation root */
export type MutationInsertInitiativeGoalsArgs = {
  objects: Array<InitiativeGoalsInsertInput>;
  on_conflict?: InputMaybe<InitiativeGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertInitiativeGoalsOneArgs = {
  object: InitiativeGoalsInsertInput;
  on_conflict?: InputMaybe<InitiativeGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertInteractionModelsArgs = {
  objects: Array<InteractionModelsInsertInput>;
  on_conflict?: InputMaybe<InteractionModelsOnConflict>;
};


/** mutation root */
export type MutationInsertInteractionModelsOneArgs = {
  object: InteractionModelsInsertInput;
  on_conflict?: InputMaybe<InteractionModelsOnConflict>;
};


/** mutation root */
export type MutationInsertJourneyLabelsArgs = {
  objects: Array<JourneyLabelsInsertInput>;
  on_conflict?: InputMaybe<JourneyLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertJourneyLabelsOneArgs = {
  object: JourneyLabelsInsertInput;
  on_conflict?: InputMaybe<JourneyLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertJourneySimulationsArgs = {
  objects: Array<JourneySimulationsInsertInput>;
  on_conflict?: InputMaybe<JourneySimulationsOnConflict>;
};


/** mutation root */
export type MutationInsertJourneySimulationsOneArgs = {
  object: JourneySimulationsInsertInput;
  on_conflict?: InputMaybe<JourneySimulationsOnConflict>;
};


/** mutation root */
export type MutationInsertJourneyTemplatesArgs = {
  objects: Array<JourneyTemplatesInsertInput>;
  on_conflict?: InputMaybe<JourneyTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertJourneyTemplatesOneArgs = {
  object: JourneyTemplatesInsertInput;
  on_conflict?: InputMaybe<JourneyTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertJourneysArgs = {
  objects: Array<JourneysInsertInput>;
  on_conflict?: InputMaybe<JourneysOnConflict>;
};


/** mutation root */
export type MutationInsertJourneysOneArgs = {
  object: JourneysInsertInput;
  on_conflict?: InputMaybe<JourneysOnConflict>;
};


/** mutation root */
export type MutationInsertLabelGroupsArgs = {
  objects: Array<LabelGroupsInsertInput>;
  on_conflict?: InputMaybe<LabelGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertLabelGroupsOneArgs = {
  object: LabelGroupsInsertInput;
  on_conflict?: InputMaybe<LabelGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertLabelsArgs = {
  objects: Array<LabelsInsertInput>;
  on_conflict?: InputMaybe<LabelsOnConflict>;
};


/** mutation root */
export type MutationInsertLabelsOneArgs = {
  object: LabelsInsertInput;
  on_conflict?: InputMaybe<LabelsOnConflict>;
};


/** mutation root */
export type MutationInsertLcmMessageCandidatesArgs = {
  objects: Array<LcmMessageCandidatesInsertInput>;
  on_conflict?: InputMaybe<LcmMessageCandidatesOnConflict>;
};


/** mutation root */
export type MutationInsertLcmMessageCandidatesOneArgs = {
  object: LcmMessageCandidatesInsertInput;
  on_conflict?: InputMaybe<LcmMessageCandidatesOnConflict>;
};


/** mutation root */
export type MutationInsertLcmMessagePlansArgs = {
  objects: Array<LcmMessagePlansInsertInput>;
  on_conflict?: InputMaybe<LcmMessagePlansOnConflict>;
};


/** mutation root */
export type MutationInsertLcmMessagePlansOneArgs = {
  object: LcmMessagePlansInsertInput;
  on_conflict?: InputMaybe<LcmMessagePlansOnConflict>;
};


/** mutation root */
export type MutationInsertLookerCredentialsArgs = {
  objects: Array<LookerCredentialsInsertInput>;
  on_conflict?: InputMaybe<LookerCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertLookerCredentialsOneArgs = {
  object: LookerCredentialsInsertInput;
  on_conflict?: InputMaybe<LookerCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertMatchboostingConfigArgs = {
  objects: Array<MatchboostingConfigInsertInput>;
  on_conflict?: InputMaybe<MatchboostingConfigOnConflict>;
};


/** mutation root */
export type MutationInsertMatchboostingConfigOneArgs = {
  object: MatchboostingConfigInsertInput;
  on_conflict?: InputMaybe<MatchboostingConfigOnConflict>;
};


/** mutation root */
export type MutationInsertMatchboostingWorkspaceConfigArgs = {
  objects: Array<MatchboostingWorkspaceConfigInsertInput>;
  on_conflict?: InputMaybe<MatchboostingWorkspaceConfigOnConflict>;
};


/** mutation root */
export type MutationInsertMatchboostingWorkspaceConfigOneArgs = {
  object: MatchboostingWorkspaceConfigInsertInput;
  on_conflict?: InputMaybe<MatchboostingWorkspaceConfigOnConflict>;
};


/** mutation root */
export type MutationInsertMessageContentsArgs = {
  objects: Array<MessageContentsInsertInput>;
  on_conflict?: InputMaybe<MessageContentsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageContentsMetadataArgs = {
  objects: Array<MessageContentsMetadataInsertInput>;
  on_conflict?: InputMaybe<MessageContentsMetadataOnConflict>;
};


/** mutation root */
export type MutationInsertMessageContentsMetadataOneArgs = {
  object: MessageContentsMetadataInsertInput;
  on_conflict?: InputMaybe<MessageContentsMetadataOnConflict>;
};


/** mutation root */
export type MutationInsertMessageContentsOneArgs = {
  object: MessageContentsInsertInput;
  on_conflict?: InputMaybe<MessageContentsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageExperimentsArgs = {
  objects: Array<MessageExperimentsInsertInput>;
  on_conflict?: InputMaybe<MessageExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageExperimentsOneArgs = {
  object: MessageExperimentsInsertInput;
  on_conflict?: InputMaybe<MessageExperimentsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageLabelsArgs = {
  objects: Array<MessageLabelsInsertInput>;
  on_conflict?: InputMaybe<MessageLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageLabelsOneArgs = {
  object: MessageLabelsInsertInput;
  on_conflict?: InputMaybe<MessageLabelsOnConflict>;
};


/** mutation root */
export type MutationInsertMessagePushAppsArgs = {
  objects: Array<MessagePushAppsInsertInput>;
  on_conflict?: InputMaybe<MessagePushAppsOnConflict>;
};


/** mutation root */
export type MutationInsertMessagePushAppsOneArgs = {
  object: MessagePushAppsInsertInput;
  on_conflict?: InputMaybe<MessagePushAppsOnConflict>;
};


/** mutation root */
export type MutationInsertMessageVariantArmArgs = {
  objects: Array<MessageVariantArmInsertInput>;
  on_conflict?: InputMaybe<MessageVariantArmOnConflict>;
};


/** mutation root */
export type MutationInsertMessageVariantArmOneArgs = {
  object: MessageVariantArmInsertInput;
  on_conflict?: InputMaybe<MessageVariantArmOnConflict>;
};


/** mutation root */
export type MutationInsertMessagesArgs = {
  objects: Array<MessagesInsertInput>;
  on_conflict?: InputMaybe<MessagesOnConflict>;
};


/** mutation root */
export type MutationInsertMessagesOneArgs = {
  object: MessagesInsertInput;
  on_conflict?: InputMaybe<MessagesOnConflict>;
};


/** mutation root */
export type MutationInsertModelColumnsArgs = {
  objects: Array<ModelColumnsInsertInput>;
  on_conflict?: InputMaybe<ModelColumnsOnConflict>;
};


/** mutation root */
export type MutationInsertModelColumnsOneArgs = {
  object: ModelColumnsInsertInput;
  on_conflict?: InputMaybe<ModelColumnsOnConflict>;
};


/** mutation root */
export type MutationInsertModelRelationshipsArgs = {
  objects: Array<ModelRelationshipsInsertInput>;
  on_conflict?: InputMaybe<ModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertModelRelationshipsOneArgs = {
  object: ModelRelationshipsInsertInput;
  on_conflict?: InputMaybe<ModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertMonitorConditionTemplatesArgs = {
  objects: Array<MonitorConditionTemplatesInsertInput>;
  on_conflict?: InputMaybe<MonitorConditionTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertMonitorConditionTemplatesOneArgs = {
  object: MonitorConditionTemplatesInsertInput;
  on_conflict?: InputMaybe<MonitorConditionTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertNotificationChannelTemplatesArgs = {
  objects: Array<NotificationChannelTemplatesInsertInput>;
  on_conflict?: InputMaybe<NotificationChannelTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertNotificationChannelTemplatesOneArgs = {
  object: NotificationChannelTemplatesInsertInput;
  on_conflict?: InputMaybe<NotificationChannelTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertObjectSchemasArgs = {
  objects: Array<ObjectSchemasInsertInput>;
  on_conflict?: InputMaybe<ObjectSchemasOnConflict>;
};


/** mutation root */
export type MutationInsertObjectSchemasOneArgs = {
  object: ObjectSchemasInsertInput;
  on_conflict?: InputMaybe<ObjectSchemasOnConflict>;
};


/** mutation root */
export type MutationInsertPagerdutyCredentialsArgs = {
  objects: Array<PagerdutyCredentialsInsertInput>;
  on_conflict?: InputMaybe<PagerdutyCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertPagerdutyCredentialsOneArgs = {
  object: PagerdutyCredentialsInsertInput;
  on_conflict?: InputMaybe<PagerdutyCredentialsOnConflict>;
};


/** mutation root */
export type MutationInsertPushAppsArgs = {
  objects: Array<PushAppsInsertInput>;
  on_conflict?: InputMaybe<PushAppsOnConflict>;
};


/** mutation root */
export type MutationInsertPushAppsOneArgs = {
  object: PushAppsInsertInput;
  on_conflict?: InputMaybe<PushAppsOnConflict>;
};


/** mutation root */
export type MutationInsertPushConfigArgs = {
  objects: Array<PushConfigInsertInput>;
  on_conflict?: InputMaybe<PushConfigOnConflict>;
};


/** mutation root */
export type MutationInsertPushConfigOneArgs = {
  object: PushConfigInsertInput;
  on_conflict?: InputMaybe<PushConfigOnConflict>;
};


/** mutation root */
export type MutationInsertRealtimeAudienceSyncSegmentsArgs = {
  objects: Array<RealtimeAudienceSyncSegmentsInsertInput>;
  on_conflict?: InputMaybe<RealtimeAudienceSyncSegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertRealtimeAudienceSyncSegmentsOneArgs = {
  object: RealtimeAudienceSyncSegmentsInsertInput;
  on_conflict?: InputMaybe<RealtimeAudienceSyncSegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertRealtimeAudienceSyncsArgs = {
  objects: Array<RealtimeAudienceSyncsInsertInput>;
  on_conflict?: InputMaybe<RealtimeAudienceSyncsOnConflict>;
};


/** mutation root */
export type MutationInsertRealtimeAudienceSyncsOneArgs = {
  object: RealtimeAudienceSyncsInsertInput;
  on_conflict?: InputMaybe<RealtimeAudienceSyncsOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipReferencesArgs = {
  objects: Array<RelationshipReferencesInsertInput>;
  on_conflict?: InputMaybe<RelationshipReferencesOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipReferencesOneArgs = {
  object: RelationshipReferencesInsertInput;
  on_conflict?: InputMaybe<RelationshipReferencesOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipsArgs = {
  objects: Array<RelationshipsInsertInput>;
  on_conflict?: InputMaybe<RelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertRelationshipsOneArgs = {
  object: RelationshipsInsertInput;
  on_conflict?: InputMaybe<RelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceInteractionsArgs = {
  objects: Array<ResourceInteractionsInsertInput>;
  on_conflict?: InputMaybe<ResourceInteractionsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceInteractionsOneArgs = {
  object: ResourceInteractionsInsertInput;
  on_conflict?: InputMaybe<ResourceInteractionsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceMonitorConditionsArgs = {
  objects: Array<ResourceMonitorConditionsInsertInput>;
  on_conflict?: InputMaybe<ResourceMonitorConditionsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceMonitorConditionsOneArgs = {
  object: ResourceMonitorConditionsInsertInput;
  on_conflict?: InputMaybe<ResourceMonitorConditionsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceNotificationChannelsArgs = {
  objects: Array<ResourceNotificationChannelsInsertInput>;
  on_conflict?: InputMaybe<ResourceNotificationChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceNotificationChannelsOneArgs = {
  object: ResourceNotificationChannelsInsertInput;
  on_conflict?: InputMaybe<ResourceNotificationChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceToMonitorConditionTypeArgs = {
  objects: Array<ResourceToMonitorConditionTypeInsertInput>;
  on_conflict?: InputMaybe<ResourceToMonitorConditionTypeOnConflict>;
};


/** mutation root */
export type MutationInsertResourceToMonitorConditionTypeOneArgs = {
  object: ResourceToMonitorConditionTypeInsertInput;
  on_conflict?: InputMaybe<ResourceToMonitorConditionTypeOnConflict>;
};


/** mutation root */
export type MutationInsertResourceViewsArgs = {
  objects: Array<ResourceViewsInsertInput>;
  on_conflict?: InputMaybe<ResourceViewsOnConflict>;
};


/** mutation root */
export type MutationInsertResourceViewsOneArgs = {
  object: ResourceViewsInsertInput;
  on_conflict?: InputMaybe<ResourceViewsOnConflict>;
};


/** mutation root */
export type MutationInsertSampledSegmentsArgs = {
  objects: Array<SampledSegmentsInsertInput>;
  on_conflict?: InputMaybe<SampledSegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSampledSegmentsOneArgs = {
  object: SampledSegmentsInsertInput;
  on_conflict?: InputMaybe<SampledSegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsArgs = {
  objects: Array<SavedAnalyticsChartsInsertInput>;
  on_conflict?: InputMaybe<SavedAnalyticsChartsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsCohortsArgs = {
  objects: Array<SavedAnalyticsChartsCohortsInsertInput>;
  on_conflict?: InputMaybe<SavedAnalyticsChartsCohortsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsCohortsOneArgs = {
  object: SavedAnalyticsChartsCohortsInsertInput;
  on_conflict?: InputMaybe<SavedAnalyticsChartsCohortsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsFunnelStagesArgs = {
  objects: Array<SavedAnalyticsChartsFunnelStagesInsertInput>;
  on_conflict?: InputMaybe<SavedAnalyticsChartsFunnelStagesOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsFunnelStagesOneArgs = {
  object: SavedAnalyticsChartsFunnelStagesInsertInput;
  on_conflict?: InputMaybe<SavedAnalyticsChartsFunnelStagesOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsGoalsArgs = {
  objects: Array<SavedAnalyticsChartsGoalsInsertInput>;
  on_conflict?: InputMaybe<SavedAnalyticsChartsGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsGoalsOneArgs = {
  object: SavedAnalyticsChartsGoalsInsertInput;
  on_conflict?: InputMaybe<SavedAnalyticsChartsGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedAnalyticsChartsOneArgs = {
  object: SavedAnalyticsChartsInsertInput;
  on_conflict?: InputMaybe<SavedAnalyticsChartsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedCampaignViewsArgs = {
  objects: Array<SavedCampaignViewsInsertInput>;
  on_conflict?: InputMaybe<SavedCampaignViewsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedCampaignViewsGoalsArgs = {
  objects: Array<SavedCampaignViewsGoalsInsertInput>;
  on_conflict?: InputMaybe<SavedCampaignViewsGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedCampaignViewsGoalsOneArgs = {
  object: SavedCampaignViewsGoalsInsertInput;
  on_conflict?: InputMaybe<SavedCampaignViewsGoalsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedCampaignViewsOneArgs = {
  object: SavedCampaignViewsInsertInput;
  on_conflict?: InputMaybe<SavedCampaignViewsOnConflict>;
};


/** mutation root */
export type MutationInsertSavedQueriesArgs = {
  objects: Array<SavedQueriesInsertInput>;
  on_conflict?: InputMaybe<SavedQueriesOnConflict>;
};


/** mutation root */
export type MutationInsertSavedQueriesOneArgs = {
  object: SavedQueriesInsertInput;
  on_conflict?: InputMaybe<SavedQueriesOnConflict>;
};


/** mutation root */
export type MutationInsertSegmentsArgs = {
  objects: Array<SegmentsInsertInput>;
  on_conflict?: InputMaybe<SegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSegmentsOneArgs = {
  object: SegmentsInsertInput;
  on_conflict?: InputMaybe<SegmentsOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceSubsetGrantsArgs = {
  objects: Array<SpaceSubsetGrantsInsertInput>;
  on_conflict?: InputMaybe<SpaceSubsetGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceSubsetGrantsOneArgs = {
  object: SpaceSubsetGrantsInsertInput;
  on_conflict?: InputMaybe<SpaceSubsetGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceSyncTemplatesArgs = {
  objects: Array<SpaceSyncTemplatesInsertInput>;
  on_conflict?: InputMaybe<SpaceSyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceSyncTemplatesOneArgs = {
  object: SpaceSyncTemplatesInsertInput;
  on_conflict?: InputMaybe<SpaceSyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceUserGroupsArgs = {
  objects: Array<SpaceUserGroupsInsertInput>;
  on_conflict?: InputMaybe<SpaceUserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertSpaceUserGroupsOneArgs = {
  object: SpaceUserGroupsInsertInput;
  on_conflict?: InputMaybe<SpaceUserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertSpacesArgs = {
  objects: Array<SpacesInsertInput>;
  on_conflict?: InputMaybe<SpacesOnConflict>;
};


/** mutation root */
export type MutationInsertSpacesOneArgs = {
  object: SpacesInsertInput;
  on_conflict?: InputMaybe<SpacesOnConflict>;
};


/** mutation root */
export type MutationInsertSsoGroupUserGroupsArgs = {
  objects: Array<SsoGroupUserGroupsInsertInput>;
  on_conflict?: InputMaybe<SsoGroupUserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertSsoGroupUserGroupsOneArgs = {
  object: SsoGroupUserGroupsInsertInput;
  on_conflict?: InputMaybe<SsoGroupUserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertSupportAccessGrantArgs = {
  objects: Array<SupportAccessGrantInsertInput>;
  on_conflict?: InputMaybe<SupportAccessGrantOnConflict>;
};


/** mutation root */
export type MutationInsertSupportAccessGrantOneArgs = {
  object: SupportAccessGrantInsertInput;
  on_conflict?: InputMaybe<SupportAccessGrantOnConflict>;
};


/** mutation root */
export type MutationInsertSyncSequenceMembersArgs = {
  objects: Array<SyncSequenceMembersInsertInput>;
  on_conflict?: InputMaybe<SyncSequenceMembersOnConflict>;
};


/** mutation root */
export type MutationInsertSyncSequenceMembersOneArgs = {
  object: SyncSequenceMembersInsertInput;
  on_conflict?: InputMaybe<SyncSequenceMembersOnConflict>;
};


/** mutation root */
export type MutationInsertSyncSequencesArgs = {
  objects: Array<SyncSequencesInsertInput>;
  on_conflict?: InputMaybe<SyncSequencesOnConflict>;
};


/** mutation root */
export type MutationInsertSyncSequencesOneArgs = {
  object: SyncSequencesInsertInput;
  on_conflict?: InputMaybe<SyncSequencesOnConflict>;
};


/** mutation root */
export type MutationInsertSyncTemplatesArgs = {
  objects: Array<SyncTemplatesInsertInput>;
  on_conflict?: InputMaybe<SyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertSyncTemplatesOneArgs = {
  object: SyncTemplatesInsertInput;
  on_conflict?: InputMaybe<SyncTemplatesOnConflict>;
};


/** mutation root */
export type MutationInsertThroughModelRelationshipsArgs = {
  objects: Array<ThroughModelRelationshipsInsertInput>;
  on_conflict?: InputMaybe<ThroughModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertThroughModelRelationshipsOneArgs = {
  object: ThroughModelRelationshipsInsertInput;
  on_conflict?: InputMaybe<ThroughModelRelationshipsOnConflict>;
};


/** mutation root */
export type MutationInsertTrackedAudienceListAudiencesArgs = {
  objects: Array<TrackedAudienceListAudiencesInsertInput>;
  on_conflict?: InputMaybe<TrackedAudienceListAudiencesOnConflict>;
};


/** mutation root */
export type MutationInsertTrackedAudienceListAudiencesOneArgs = {
  object: TrackedAudienceListAudiencesInsertInput;
  on_conflict?: InputMaybe<TrackedAudienceListAudiencesOnConflict>;
};


/** mutation root */
export type MutationInsertTraitDefinitionsArgs = {
  objects: Array<TraitDefinitionsInsertInput>;
  on_conflict?: InputMaybe<TraitDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertTraitDefinitionsOneArgs = {
  object: TraitDefinitionsInsertInput;
  on_conflict?: InputMaybe<TraitDefinitionsOnConflict>;
};


/** mutation root */
export type MutationInsertTunnelsArgs = {
  objects: Array<TunnelsInsertInput>;
  on_conflict?: InputMaybe<TunnelsOnConflict>;
};


/** mutation root */
export type MutationInsertTunnelsOneArgs = {
  object: TunnelsInsertInput;
  on_conflict?: InputMaybe<TunnelsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupGrantsArgs = {
  objects: Array<UserGroupGrantsInsertInput>;
  on_conflict?: InputMaybe<UserGroupGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupGrantsOneArgs = {
  object: UserGroupGrantsInsertInput;
  on_conflict?: InputMaybe<UserGroupGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupMembersArgs = {
  objects: Array<UserGroupMembersInsertInput>;
  on_conflict?: InputMaybe<UserGroupMembersOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupMembersOneArgs = {
  object: UserGroupMembersInsertInput;
  on_conflict?: InputMaybe<UserGroupMembersOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupSubsetGrantsArgs = {
  objects: Array<UserGroupSubsetGrantsInsertInput>;
  on_conflict?: InputMaybe<UserGroupSubsetGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupSubsetGrantsOneArgs = {
  object: UserGroupSubsetGrantsInsertInput;
  on_conflict?: InputMaybe<UserGroupSubsetGrantsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupWorkspacesArgs = {
  objects: Array<UserGroupWorkspacesInsertInput>;
  on_conflict?: InputMaybe<UserGroupWorkspacesOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupWorkspacesOneArgs = {
  object: UserGroupWorkspacesInsertInput;
  on_conflict?: InputMaybe<UserGroupWorkspacesOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupsArgs = {
  objects: Array<UserGroupsInsertInput>;
  on_conflict?: InputMaybe<UserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertUserGroupsOneArgs = {
  object: UserGroupsInsertInput;
  on_conflict?: InputMaybe<UserGroupsOnConflict>;
};


/** mutation root */
export type MutationInsertWorkspaceNotificationChannelsArgs = {
  objects: Array<WorkspaceNotificationChannelsInsertInput>;
  on_conflict?: InputMaybe<WorkspaceNotificationChannelsOnConflict>;
};


/** mutation root */
export type MutationInsertWorkspaceNotificationChannelsOneArgs = {
  object: WorkspaceNotificationChannelsInsertInput;
  on_conflict?: InputMaybe<WorkspaceNotificationChannelsOnConflict>;
};


/** mutation root */
export type MutationInvokeWorkspaceFunctionTesterArgs = {
  args: InvokeWorkspaceFunctionTesterArgs;
};


/** mutation root */
export type MutationLaunchAdsArgs = {
  input: LaunchAdsInput;
};


/** mutation root */
export type MutationLicenseGettyImagesArgs = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type MutationLinkAmpProjectWorkArgs = {
  projectId: Scalars['ID'];
  target: AmpProjectLinkTargetInput;
  taskId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationLinkAsanaTaskArgs = {
  input: LinkAsanaTaskInput;
};


/** mutation root */
export type MutationLinkCepWhatsAppTemplateArgs = {
  messageId: Scalars['ID'];
  templateId: Scalars['ID'];
};


/** mutation root */
export type MutationLinkDestinationsArgs = {
  sourceDestinationId: Scalars['bigint'];
  targetDestinationId: Scalars['bigint'];
  targetWorkspaceId: Scalars['bigint'];
};


/** mutation root */
export type MutationLinkExistingContentEmailArgs = {
  contentEmailId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationLinkSourcesArgs = {
  sourceConnectionId: Scalars['bigint'];
  targetConnectionId: Scalars['bigint'];
  targetWorkspaceId: Scalars['bigint'];
};


/** mutation root */
export type MutationManuallyEnqueuePredictiveTraitsJobArgs = {
  input: ManuallyEnqueuePredictiveTraitsJobInput;
};


/** mutation root */
export type MutationMarkLineagePartitionsDirtyArgs = {
  ownerResourceTypes?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationMigrateV1AlertsArgs = {
  force: Scalars['Boolean'];
};


/** mutation root */
export type MutationModifyModelColumnsArgs = {
  columns: Array<ModelColumnInput>;
  model_id: Scalars['bigint'];
  overwriteMetadata?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationMoveAmpCanvasNodeArgs = {
  input: AmpNodeMoveInput;
};


/** mutation root */
export type MutationMoveAmpFileArgs = {
  drafts?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


/** mutation root */
export type MutationMoveAmpTaskToProjectArgs = {
  id: Scalars['ID'];
  projectId: Scalars['ID'];
  statusId: Scalars['ID'];
};


/** mutation root */
export type MutationOpenAmpFileEditorSessionArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationPartnerConnectLinkWorkspaceArgs = {
  uuid: Scalars['String'];
  workspaceId: Scalars['Int'];
};


/** mutation root */
export type MutationPauseFivetranAgentSyncArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationPreviewTreatmentArgs = {
  k?: InputMaybe<Scalars['Int']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  treatmentId: Scalars['ID'];
};


/** mutation root */
export type MutationPromoteAdStudioIdeaArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationPromoteContentNodeToPublicArgs = {
  input: PromoteContentNodeToPublicInput;
};


/** mutation root */
export type MutationPromoteFigmaImportDraftArgs = {
  input: PromoteFigmaImportDraftInput;
};


/** mutation root */
export type MutationPromoteReportDraftArgs = {
  input: PromoteReportDraftInput;
};


/** mutation root */
export type MutationPromoteSkillToManagedArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationPublishMessageContentDraftArgs = {
  messageId: Scalars['uuid'];
  metadataVersion?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type MutationPublishStagedJourneyArgs = {
  input: PublishStagedJourneyInput;
};


/** mutation root */
export type MutationQueueAdForLaunchArgs = {
  input: QueueAdForLaunchInput;
};


/** mutation root */
export type MutationQueueEmailBestPracticeSessionArgs = {
  input: QueueEmailBestPracticeSessionInput;
};


/** mutation root */
export type MutationQueueMultipleAdsForLaunchArgs = {
  input: QueueMultipleAdsForLaunchInput;
};


/** mutation root */
export type MutationRateCampaignInsightArgs = {
  insightId: Scalars['uuid'];
  reason?: InputMaybe<Scalars['String']>;
  score: CampaignInsightRatingScore;
};


/** mutation root */
export type MutationReRequestAmpTaskReviewArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  taskUserId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationRecalculateEmbeddingsArgs = {
  agentId: Scalars['uuid'];
};


/** mutation root */
export type MutationRecalculateMessageEmbeddingArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRecalculateMessageVariableVariantEmbeddingsArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRecomputeSuppressionListSizeArgs = {
  suppressionListId: Scalars['ID'];
};


/** mutation root */
export type MutationReconcileReportCardSummaryArgs = {
  runId: Scalars['uuid'];
};


/** mutation root */
export type MutationRefreshAgentConnectorToolsArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationRefreshAgenticSettingsCopyExamplesArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRefreshCepProfileCacheArgs = {
  parentModelId: Scalars['String'];
};


/** mutation root */
export type MutationRefreshCompetitorArgs = {
  competitorId: Scalars['ID'];
};


/** mutation root */
export type MutationRefreshConnectionRolesArgs = {
  connectionId: Scalars['Int'];
};


/** mutation root */
export type MutationRefreshDecisionEngineChannelSyncsArgs = {
  channelId: Scalars['uuid'];
};


/** mutation root */
export type MutationRefreshDecisionEngineChannelUserColumnsArgs = {
  channelId: Scalars['uuid'];
};


/** mutation root */
export type MutationRefreshDecisionEngineFlowAudienceSizesArgs = {
  flowId: Scalars['uuid'];
  messageId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationRefreshEspCatalogArgs = {
  destinationId: Scalars['String'];
  resources?: InputMaybe<Array<EspCatalogResource>>;
};


/** mutation root */
export type MutationRefreshFivetranConnectionArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationRefreshModelConfigurationArgs = {
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRefreshNativeDeliveryAgentFlowArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationRegenerateAgentSuggestionBatchesArgs = {
  systemPromptOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRegenerateSizeVariantArgs = {
  input: RegenerateSizeVariantInput;
};


/** mutation root */
export type MutationRejectIdrChangePlanArgs = {
  input: RejectIdrChangePlanInput;
};


/** mutation root */
export type MutationRelaunchMetaAdArgs = {
  input: RelaunchMetaAdInput;
};


/** mutation root */
export type MutationRemoveAdFromLaunchQueueArgs = {
  input: RemoveAdFromLaunchQueueInput;
};


/** mutation root */
export type MutationRemoveAmpCanvasNodeArgs = {
  input: AmpNodeRemoveInput;
};


/** mutation root */
export type MutationRemoveAmpTaskBlockerArgs = {
  blockerTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
};


/** mutation root */
export type MutationRemoveAmpTaskReviewerArgs = {
  id: Scalars['ID'];
  userGroupId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationRemoveCompetitorAccountArgs = {
  accountId: Scalars['ID'];
  competitorId: Scalars['ID'];
};


/** mutation root */
export type MutationRemoveFlowFromDecisionEngineArbitrationGroupArgs = {
  flowId: Scalars['uuid'];
  groupId: Scalars['uuid'];
};


/** mutation root */
export type MutationRemoveInspirationBoardAdArgs = {
  adId: Scalars['String'];
  boardId: Scalars['ID'];
  channel: Scalars['String'];
};


/** mutation root */
export type MutationRemoveManifestDayArgs = {
  day: Scalars['String'];
  manifestId: Scalars['uuid'];
  mode: ManifestDayRemovalMode;
};


/** mutation root */
export type MutationRemoveSharedDatabasesArgs = {
  connectionId: Scalars['bigint'];
  databases: Array<Scalars['String']>;
};


/** mutation root */
export type MutationRemoveTreatmentPreviewProductsArgs = {
  productIds: Array<Scalars['ID']>;
  treatmentId: Scalars['ID'];
};


/** mutation root */
export type MutationRenameAdInsightsSavedViewArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationRenameCompetitorArgs = {
  competitorId: Scalars['ID'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationRenameInspirationBoardArgs = {
  boardId: Scalars['ID'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationRenameMessagePlanArgs = {
  input: RenameMessagePlanInput;
};


/** mutation root */
export type MutationRenameSendInsightChartArgs = {
  chartId: Scalars['String'];
  flowId: Scalars['uuid'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationReopenAssetCommentThreadArgs = {
  threadId: Scalars['uuid'];
};


/** mutation root */
export type MutationReorderConnectionRoleMappingsArgs = {
  connectionId: Scalars['Int'];
  orderedIds: Array<Scalars['String']>;
};


/** mutation root */
export type MutationReplaceCepWhatsAppTemplateLocaleInPlaceArgs = {
  localeId: Scalars['ID'];
  messageId: Scalars['ID'];
};


/** mutation root */
export type MutationRequestAdminEntitlementArgs = {
  input: AdminEntitlementRequestInput;
};


/** mutation root */
export type MutationRequestArtifactReviewsArgs = {
  input: RequestArtifactReviewsInput;
};


/** mutation root */
export type MutationRequestCampaignCalendarRebuildArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationRequestCampaignCreativeCaptureArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationRerunDbtCloudModelSyncArgs = {
  configId: Scalars['String'];
};


/** mutation root */
export type MutationResetAggregationStateArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationResetAttributionStateArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationResetCachedEventPullWatermarkArgs = {
  input: ResetCachedEventPullWatermarkInput;
};


/** mutation root */
export type MutationResetExperimentGroupsArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationResetFeatureDefinitionCachedStateArgs = {
  input: ResetFeatureDefinitionCachedStateInput;
};


/** mutation root */
export type MutationResetPredictorStateArgs = {
  input: ResetPredictorStateInput;
};


/** mutation root */
export type MutationResetSendEventCacheForChannelArgs = {
  channelId: Scalars['uuid'];
};


/** mutation root */
export type MutationResetSendStateArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationResetStateArgs = {
  decisionEngineId: Scalars['uuid'];
  flowId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationResolveAssetCommentThreadArgs = {
  threadId: Scalars['uuid'];
};


/** mutation root */
export type MutationRestoreAmpFileArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationRestoreAmpFileVersionArgs = {
  baseVersionId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


/** mutation root */
export type MutationRestoreDecisionEngineMessageArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRestoreReportVersionArgs = {
  input: RestoreReportVersionInput;
};


/** mutation root */
export type MutationResumeFivetranAgentSyncArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationRetryArchivedFailuresArgs = {
  input: RetryArchivedFailuresInput;
};


/** mutation root */
export type MutationRetryExtensionExportArgs = {
  exportId: Scalars['String'];
};


/** mutation root */
export type MutationReviewAmpTaskArgs = {
  comment?: InputMaybe<Scalars['String']>;
  kind: AmpTaskReviewSubmitKind;
  reviewerId: Scalars['ID'];
};


/** mutation root */
export type MutationReviewCampaignDraftArgs = {
  decision: NativeDeliveryReviewDecision;
  draftId: Scalars['uuid'];
  resolutionComment?: InputMaybe<Scalars['String']>;
  reviewedMessageVersions?: InputMaybe<Array<ReviewedMessageVersionInput>>;
};


/** mutation root */
export type MutationReviewJourneyDraftArgs = {
  decision: NativeDeliveryReviewDecision;
  draftId: Scalars['uuid'];
  resolutionComment?: InputMaybe<Scalars['String']>;
  reviewedJourneyUpdatedAt?: InputMaybe<Scalars['String']>;
  reviewedJourneyVersionId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationRollbackBlackoutDaysArgs = {
  decisionEngineId: Scalars['uuid'];
  endDate: Scalars['String'];
  flowId: Scalars['uuid'];
  startDate: Scalars['String'];
};


/** mutation root */
export type MutationRowExportBackgroundArgs = {
  exportType?: InputMaybe<RowExportType>;
  format?: InputMaybe<RowExportFormat>;
  syncRequestId: Scalars['bigint'];
};


/** mutation root */
export type MutationRunAggregationsArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunAmpAssetSyncArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationRunChartCardArgs = {
  chartCardId: Scalars['uuid'];
  options: DashboardOptions;
};


/** mutation root */
export type MutationRunDamSyncArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationRunDashboardArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['uuid']>;
  options: DashboardOptions;
};


/** mutation root */
export type MutationRunDecisionEngineArgs = {
  flowId?: InputMaybe<Scalars['uuid']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationRunEnrichedCatalogSyncArgs = {
  feedId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  testRun?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationRunEventWarehouseSyncArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRunExperimentArgs = {
  experimentId: Scalars['uuid'];
  options: DashboardOptions;
};


/** mutation root */
export type MutationRunExposureLogResolutionArgs = {
  exposureLogTable?: InputMaybe<Scalars['String']>;
  modelId: Scalars['bigint'];
  redsDay?: InputMaybe<ExposureLogRedsDayInput>;
  writeToCustomerWarehouse?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationRunJourneyArgs = {
  id: Scalars['String'];
  simulation_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunMatchBoosterTestArgs = {
  modelId: Scalars['bigint'];
  region: Scalars['String'];
  useHouseholdTargeting?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationRunOpportunityDefinitionNowArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationRunRealtimeAudiencePullArgs = {
  mode: RtaWarehousePullMode;
  parentModelId: Scalars['String'];
};


/** mutation root */
export type MutationRunRefreshAnalyticsCacheArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunRefreshEligibleUserCountsArgs = {
  flowId: Scalars['uuid'];
  messageId?: InputMaybe<Scalars['uuid']>;
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunSanitizeUserFeaturesArgs = {
  expectedMode?: InputMaybe<DecisionEngineConsentPurgeMode>;
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunSavePlotsArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunSendAttributionArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunSendDiagnosticsArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunSyncReconciliationArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunTimezoneAnalysisArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationRunWriteAttributionArgs = {
  flowId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSaveAdArtifactArgs = {
  interactionId: Scalars['uuid'];
  path: Scalars['String'];
};


/** mutation root */
export type MutationSaveAgentAudienceArgs = {
  input: SaveAgentAudienceInput;
};


/** mutation root */
export type MutationSaveAgentDefinitionArgs = {
  input: SaveAgentDefinitionInput;
};


/** mutation root */
export type MutationSaveArtifactArgs = {
  input: SaveArtifactInput;
};


/** mutation root */
export type MutationSaveCalendarContextArgs = {
  input: SaveCalendarContextInput;
};


/** mutation root */
export type MutationSaveContentArtifactVersionArgs = {
  input: SaveContentArtifactVersionInput;
};


/** mutation root */
export type MutationSaveCreativeDimensionArgs = {
  input: SaveCreativeDimensionInput;
};


/** mutation root */
export type MutationSaveDecisionEngineChannelArgs = {
  input: SaveDecisionEngineChannelInput;
};


/** mutation root */
export type MutationSaveDecisionEngineFlowMessagesArgs = {
  flowId: Scalars['uuid'];
  updates: Array<SaveDecisionEngineFlowMessageInput>;
};


/** mutation root */
export type MutationSaveEntitlementChangesArgs = {
  input: SaveEntitlementChangesInput;
};


/** mutation root */
export type MutationSaveExposureLogResolutionConfigArgs = {
  input: ExposureLogResolutionConfigInput;
  modelId: Scalars['bigint'];
};


/** mutation root */
export type MutationSaveInAppMessageContentArgs = {
  input: SaveInAppMessageContentInput;
};


/** mutation root */
export type MutationSaveMessageAbTestArgs = {
  input: SaveMessageAbTestInput;
};


/** mutation root */
export type MutationSaveMessageBodyDraftArgs = {
  input: SaveMessageBodyInput;
};


/** mutation root */
export type MutationSaveMessageBodyVersionArgs = {
  input: SaveMessageBodyInput;
};


/** mutation root */
export type MutationSaveMessageContentDraftArgs = {
  input: SaveMessageContentInput;
};


/** mutation root */
export type MutationSaveMessageContentVersionArgs = {
  input: SaveMessageContentInput;
};


/** mutation root */
export type MutationSaveMessageMetadataDraftArgs = {
  input: SaveMessageMetadataInput;
};


/** mutation root */
export type MutationSaveMessageMetadataVersionArgs = {
  input: SaveMessageMetadataInput;
};


/** mutation root */
export type MutationSaveModelConfigurationArgs = {
  input: SaveModelConfigurationInput;
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationSaveSendInsightChartArgs = {
  chart: Scalars['JSONObject'];
  flowId: Scalars['uuid'];
  tab: Scalars['String'];
};


/** mutation root */
export type MutationSaveSessionAssumptionArgs = {
  input: SaveSessionAssumptionInput;
};


/** mutation root */
export type MutationSearchCompetitorAccountsArgs = {
  channels?: InputMaybe<Array<Scalars['String']>>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  query: Scalars['String'];
};


/** mutation root */
export type MutationSearchCompetitorBrandAccountsArgs = {
  brand: CompetitorBrandInput;
  channels?: InputMaybe<Array<Scalars['String']>>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationSendAmpAgentMessageArgs = {
  input: SendAmpAgentMessageInput;
};


/** mutation root */
export type MutationSendEmailPreviewArgs = {
  input: SendEmailPreviewInput;
};


/** mutation root */
export type MutationSendInAppMessageArgs = {
  input: SendInAppMessageInput;
};


/** mutation root */
export type MutationSendOrganizationInviteArgs = {
  organizationId: Scalars['String'];
  recipientEmail: Scalars['String'];
  recipientUserGroupIds: Array<Scalars['String']>;
};


/** mutation root */
export type MutationSendSeedBatchArgs = {
  input: SendSeedBatchInput;
};


/** mutation root */
export type MutationSendTestEmailArgs = {
  input: SendTestEmailInput;
};


/** mutation root */
export type MutationSendTestPushArgs = {
  input: SendTestPushInput;
};


/** mutation root */
export type MutationSendTestSmsArgs = {
  input: SendTestSmsInput;
};


/** mutation root */
export type MutationSendTestWhatsAppMessageArgs = {
  input: SendTestWhatsAppMessageInput;
};


/** mutation root */
export type MutationSetAgentConnectorPermissionsArgs = {
  input: SetAgentConnectorPermissionsInput;
};


/** mutation root */
export type MutationSetAmpFileFavoriteArgs = {
  favorite: Scalars['Boolean'];
  id: Scalars['ID'];
};


/** mutation root */
export type MutationSetAmpFileVisibilityArgs = {
  id: Scalars['ID'];
  visibility: AmpFileVisibility;
};


/** mutation root */
export type MutationSetAmpInboxReadArgs = {
  changelogIds?: InputMaybe<Array<Scalars['ID']>>;
  filters?: InputMaybe<AmpInboxFiltersInput>;
  isRead: Scalars['Boolean'];
};


/** mutation root */
export type MutationSetAmpTaskStatusArgs = {
  id: Scalars['ID'];
  statusId: Scalars['ID'];
};


/** mutation root */
export type MutationSetAsanaSubtaskCompletedArgs = {
  input: SetAsanaSubtaskCompletedInput;
};


/** mutation root */
export type MutationSetBrandProfileDefaultAssignmentSourceArgs = {
  assignmentSource?: InputMaybe<Scalars['String']>;
  brandProfileId: Scalars['String'];
};


/** mutation root */
export type MutationSetBrandProfileEspDestinationArgs = {
  brandProfileId: Scalars['String'];
  destinationId?: InputMaybe<Scalars['String']>;
  targetKind?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSetCampaignEspDestinationArgs = {
  campaignId: Scalars['String'];
  destinationId?: InputMaybe<Scalars['String']>;
  targetKind?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSetCampaignInsightSaveStatusArgs = {
  insightId: Scalars['uuid'];
  saved: Scalars['Boolean'];
};


/** mutation root */
export type MutationSetCampaignInsightsDefinitionsArgs = {
  metricDefinitionIds: Array<Scalars['uuid']>;
  segmentDefinitionIds: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationSetCatalogProductTagArgs = {
  catalogProductId: Scalars['ID'];
  dimensionKey: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type MutationSetCepBrandFooterArgs = {
  input: SetCepBrandFooterInput;
};


/** mutation root */
export type MutationSetCepBrandLogoArgs = {
  input: SetCepBrandLogoInput;
};


/** mutation root */
export type MutationSetCepParentModelAndConfigureEventsArgs = {
  input: SetCepParentModelAndConfigureEventsInput;
};


/** mutation root */
export type MutationSetCepWhatsAppTemplateLocaleSamplesArgs = {
  input: SetCepWhatsAppTemplateLocaleSamplesInput;
};


/** mutation root */
export type MutationSetCepWhatsAppTemplateLocalizationArgs = {
  input: SetCepWhatsAppTemplateLocalizationInput;
};


/** mutation root */
export type MutationSetCepWorkspaceFallbackLocaleArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationSetCompetitorKindArgs = {
  competitorId: Scalars['ID'];
  kind: Scalars['String'];
};


/** mutation root */
export type MutationSetConnectionRoleSettingsArgs = {
  connectionId: Scalars['Int'];
  defaultConnectionRoleId: Scalars['String'];
};


/** mutation root */
export type MutationSetCreativeDimensionLearningArgs = {
  allowLearning: Scalars['Boolean'];
  key: Scalars['String'];
};


/** mutation root */
export type MutationSetDecisionEngineArbitrationGroupModeArgs = {
  expectedEpoch: Scalars['Int'];
  id: Scalars['uuid'];
  mode: DecisionEngineArbitrationGroupMode;
};


/** mutation root */
export type MutationSetDecisionEngineCollectionConfigArgs = {
  collectionId: Scalars['String'];
  decisionEngineId: Scalars['uuid'];
  schema: Array<Scalars['JSONObject']>;
};


/** mutation root */
export type MutationSetDecisionEngineConfigArgs = {
  config: DecisionEngineConfigInput;
  decisionEngineId: Scalars['uuid'];
};


/** mutation root */
export type MutationSetDecisionEngineFlowStatusArgs = {
  id: Scalars['uuid'];
  status: Scalars['String'];
};


/** mutation root */
export type MutationSetDecisionEngineOutcomeConfigArgs = {
  decisionEngineId: Scalars['uuid'];
  metadataColumn?: InputMaybe<Scalars['String']>;
  outcomeId: Scalars['String'];
};


/** mutation root */
export type MutationSetDefaultAssignmentSourceArgs = {
  assignmentSource?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSetDefaultBrandProfileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationSetDefaultChannelSizeArgs = {
  input: SetDefaultChannelSizeInput;
};


/** mutation root */
export type MutationSetDefaultEspDestinationArgs = {
  destinationId?: InputMaybe<Scalars['String']>;
  targetKind?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSetEventForwardingSyncSourcesArgs = {
  event_source_ids: Array<Scalars['String']>;
  id: Scalars['String'];
};


/** mutation root */
export type MutationSetEventWarehouseSyncSourcesArgs = {
  event_source_ids: Array<Scalars['String']>;
  id: Scalars['String'];
};


/** mutation root */
export type MutationSetGoldenRecordColumnSourceSurvivorshipArgs = {
  input: SetGoldenRecordColumnSourceSurvivorshipInput;
};


/** mutation root */
export type MutationSetInAppMessagePushAppsArgs = {
  input: SetInAppMessagePushAppsInput;
};


/** mutation root */
export type MutationSetInboxReadArgs = {
  eventIds?: InputMaybe<Array<Scalars['ID']>>;
  filters?: InputMaybe<InboxFiltersInput>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isRead: Scalars['Boolean'];
};


/** mutation root */
export type MutationSetLibraryImageTagsArgs = {
  objects: Array<LibraryImageTagInput>;
};


/** mutation root */
export type MutationSetManagedSkillDisabledBrandProfilesArgs = {
  disabledBrandProfileIds: Array<Scalars['uuid']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationSetManagedSkillWorkspaceEnabledArgs = {
  id: Scalars['uuid'];
  isEnabled: Scalars['Boolean'];
};


/** mutation root */
export type MutationSetOpportunityDefinitionStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


/** mutation root */
export type MutationSetOrganizationLogoArgs = {
  png: Scalars['String'];
};


/** mutation root */
export type MutationSetSpacesAudienceTemplateAccessArgs = {
  audienceTemplateIds?: InputMaybe<Array<Scalars['uuid']>>;
  mode: SpaceAudienceTemplateAccessMode;
  spaceIds: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationSetSsoEnforcementArgs = {
  enforcement: SsoEnforcement;
  organizationId: Scalars['String'];
};


/** mutation root */
export type MutationSetSyncIdrScheduleArgs = {
  destinationInstanceId: Scalars['String'];
  idrId: Scalars['String'];
};


/** mutation root */
export type MutationSetUpCepSignupsArgs = {
  connectionId: Scalars['String'];
  fields: Array<CepSignupTraitFieldInput>;
};


/** mutation root */
export type MutationSetWarehouseExportEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
};


/** mutation root */
export type MutationSetWarehouseExportEnabledForSourceArgs = {
  sourceId: Scalars['Int'];
};


/** mutation root */
export type MutationSetupDemoDataArgs = {
  flowId: Scalars['uuid'];
  model?: InputMaybe<LlmModel>;
};


/** mutation root */
export type MutationSetupFivetranSyncArgs = {
  input: SetupFivetranSyncInput;
};


/** mutation root */
export type MutationSetupInWarehouseDiffingForSourceArgs = {
  plannerDatabase?: InputMaybe<Scalars['String']>;
  schemaConfig?: InputMaybe<SourceSchemaConfigInput>;
  sourceId: Scalars['String'];
};


/** mutation root */
export type MutationSetupInWarehouseDiffingWithCredentialsArgs = {
  configurationJson: Scalars['String'];
  credentialId?: InputMaybe<Scalars['Int']>;
  plannerDatabase?: InputMaybe<Scalars['String']>;
  schemaConfig?: InputMaybe<SourceSchemaConfigInput>;
  tunnelId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


/** mutation root */
export type MutationShareAgentSessionToSlackArgs = {
  input: ShareAgentSessionToSlackInput;
};


/** mutation root */
export type MutationShareDatabasesArgs = {
  connectionId: Scalars['bigint'];
  databases: Array<Scalars['String']>;
};


/** mutation root */
export type MutationStartAssetCommentReviewsArgs = {
  adBriefAssetIds: Array<Scalars['uuid']>;
  reviewAgentIds: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationStartAssetEditSessionArgs = {
  input: StartAssetEditSessionInput;
};


/** mutation root */
export type MutationStartCampaignRecipientsComputationArgs = {
  campaignRunId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CampaignRecipientFiltersInput>;
  messageIds: Array<Scalars['String']>;
  statuses?: InputMaybe<Array<CampaignRecipientStatus>>;
};


/** mutation root */
export type MutationStartCepReachabilityComputationArgs = {
  audienceId: Scalars['String'];
  filter?: InputMaybe<Scalars['JSONObject']>;
};


/** mutation root */
export type MutationStartContentImageSearchV2Args = {
  input: SearchContentImagesInput;
};


/** mutation root */
export type MutationStartContentNodeEditSessionArgs = {
  input: StartContentNodeEditSessionInput;
};


/** mutation root */
export type MutationStartCopyReferencesIngestionArgs = {
  input: StartCopyReferencesIngestionInput;
};


/** mutation root */
export type MutationStartEnrichmentArgs = {
  forceFullEnrichment?: InputMaybe<Scalars['Boolean']>;
  modelId: Scalars['String'];
  region?: InputMaybe<MatchBoosterRegion>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationStartFigmaImportArgs = {
  input: StartFigmaImportInput;
};


/** mutation root */
export type MutationStartIdrRunArgs = {
  input: IdrInput;
};


/** mutation root */
export type MutationStartIdrTrainingArgs = {
  input: IdrTrainingInput;
};


/** mutation root */
export type MutationStartPublicImageFromContentImageArgs = {
  input: CreatePublicImageFromContentImageInput;
};


/** mutation root */
export type MutationStartSyncRunArgs = {
  clearAndFill?: InputMaybe<Scalars['Boolean']>;
  fullResync?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  resetCDC?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationStartSyncRunsForSegmentArgs = {
  clearAndFill?: InputMaybe<Scalars['Boolean']>;
  fullResync?: InputMaybe<Scalars['Boolean']>;
  resetCDC?: InputMaybe<Scalars['Boolean']>;
  segmentId: Scalars['bigint'];
};


/** mutation root */
export type MutationStartSyncRunsWithDiffModeOverrideArgs = {
  diffModeOverride: Scalars['String'];
  diffModeOverrideReason: Scalars['String'];
  segmentId: Scalars['bigint'];
};


/** mutation root */
export type MutationStartWarehouseShareSetupBackgroundJobArgs = {
  connectionId: Scalars['bigint'];
  databases: Array<Scalars['String']>;
};


/** mutation root */
export type MutationStopAmpAgentArgs = {
  agentId: Scalars['uuid'];
  tree?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationStopMessagePreviewRunArgs = {
  runId: Scalars['uuid'];
};


/** mutation root */
export type MutationStopWaitingMessagePreviewArgs = {
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationSubmitAmpTaskReviewArgs = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: AmpTaskReviewSubmitKind;
};


/** mutation root */
export type MutationSubmitCampaignDraftArgs = {
  approverIds: Array<Scalars['String']>;
  campaignId: Scalars['uuid'];
  comment?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSubmitCepWhatsAppTemplateArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationSubmitCepWhatsAppTemplateLocalesArgs = {
  id: Scalars['ID'];
  localeIds: Array<Scalars['ID']>;
};


/** mutation root */
export type MutationSubmitDraftModelArgs = {
  approverIds: Array<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<ModelDraft>;
  isDeployment?: InputMaybe<Scalars['Boolean']>;
  operation?: InputMaybe<DraftOperation>;
  resourceId: Scalars['String'];
};


/** mutation root */
export type MutationSubmitDraftSyncArgs = {
  approverIds: Array<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<SyncDraft>;
  isDeployment?: InputMaybe<Scalars['Boolean']>;
  operation?: InputMaybe<DraftOperation>;
  resourceId: Scalars['String'];
};


/** mutation root */
export type MutationSubmitJourneyDraftArgs = {
  approverIds: Array<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  journeyId: Scalars['uuid'];
};


/** mutation root */
export type MutationSyncAmpTaskApprovalsArgs = {
  ids: Array<Scalars['ID']>;
};


/** mutation root */
export type MutationSyncFivetranConnectionNowArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationTagAmpTaskArgs = {
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  taskId: Scalars['ID'];
};


/** mutation root */
export type MutationTagContentImagesWithPipelineArgs = {
  input: TagContentImagesInput;
};


/** mutation root */
export type MutationTestCepProviderConnectionArgs = {
  input: TestCepProviderConnectionInput;
};


/** mutation root */
export type MutationTestExtensionConnectionArgs = {
  input: TestExtensionConnectionInput;
};


/** mutation root */
export type MutationTestExternalContextSourceConnectionArgs = {
  input: TestExternalContextSourceConnectionInput;
};


/** mutation root */
export type MutationTestFivetranConnectionArgs = {
  syncId: Scalars['String'];
};


/** mutation root */
export type MutationTestIdrOnCompleteSqlArgs = {
  input: TestIdrOnCompleteSqlInput;
};


/** mutation root */
export type MutationTestNewDestinationArgs = {
  configuration: Scalars['JSONObject'];
  credentialId?: InputMaybe<Scalars['bigint']>;
  type: Scalars['String'];
};


/** mutation root */
export type MutationTestPersonalizationApiArgs = {
  input: TestPersonalizationApiInput;
};


/** mutation root */
export type MutationTestUpdatedDestinationArgs = {
  credentialId?: InputMaybe<Scalars['bigint']>;
  destinationId: Scalars['String'];
  newConfiguration: Scalars['JSONObject'];
};


/** mutation root */
export type MutationToggleCachedEventPullEnabledArgs = {
  input: ToggleCachedEventPullEnabledInput;
};


/** mutation root */
export type MutationTogglePredictorEnabledArgs = {
  input: TogglePredictorEnabledInput;
};


/** mutation root */
export type MutationTrainModelsArgs = {
  flowId: Scalars['uuid'];
  modelId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationTriggerAidContentRecommendationsReconcileRunArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationTriggerAidContentRecommendationsRunArgs = {
  flowId: Scalars['uuid'];
};


/** mutation root */
export type MutationTriggerEtlSyncRunArgs = {
  etlConnectionId: Scalars['String'];
};


/** mutation root */
export type MutationTriggerExternalContextSourceSyncArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationTriggerGlobalDecisioningArbitrationArgs = {
  forceFullPack?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['uuid'];
  stackOverride?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationTriggerMessagePreviewArgs = {
  messageId: Scalars['uuid'];
  payload: TriggerMessagePreviewInput;
};


/** mutation root */
export type MutationTriggerMessageRecheckArgs = {
  messageId: Scalars['String'];
};


/** mutation root */
export type MutationTriggerSpaceScopedColumnTopKSyncArgs = {
  columnName: Scalars['String'];
  modelId: Scalars['String'];
};


/** mutation root */
export type MutationTriggerSpaceScopedColumnTopKSyncAllSpacesArgs = {
  columnName: Scalars['String'];
  modelId: Scalars['String'];
};


/** mutation root */
export type MutationUnlinkAmpProjectWorkArgs = {
  linkId: Scalars['ID'];
};


/** mutation root */
export type MutationUnlinkAsanaTaskArgs = {
  input: UnlinkAsanaTaskInput;
};


/** mutation root */
export type MutationUntagAmpTaskArgs = {
  tagId: Scalars['ID'];
  taskId: Scalars['ID'];
};


/** mutation root */
export type MutationUpdateAdInsightsSavedViewArgs = {
  id: Scalars['ID'];
  layout: Scalars['String'];
  query: Scalars['JSON'];
};


/** mutation root */
export type MutationUpdateAdStatusesArgs = {
  updates: Array<AdStatusUpdateInput>;
};


/** mutation root */
export type MutationUpdateAgenticSettingsEntityArgs = {
  input: UpdateAgenticSettingsEntityInput;
};


/** mutation root */
export type MutationUpdateAgenticSettingsEntityBrandProfileAssignmentArgs = {
  brandProfileIds: Array<Scalars['uuid']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateAmpAssetSyncArgs = {
  id: Scalars['ID'];
  input: UpdateAmpAssetSyncInput;
};


/** mutation root */
export type MutationUpdateAmpFileArgs = {
  input: AmpFileUpdateInput;
};


/** mutation root */
export type MutationUpdateAmpFileFolderArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type MutationUpdateApiKeyUserGroupArgs = {
  input: UpdateApiKeyUserGroupInput;
};


/** mutation root */
export type MutationUpdateAsanaTaskArgs = {
  input: UpdateAsanaTaskInput;
};


/** mutation root */
export type MutationUpdateAssetCollectionArgs = {
  id: Scalars['ID'];
  patch: AssetCollectionPatch;
};


/** mutation root */
export type MutationUpdateAssetCommentArgs = {
  body: Scalars['String'];
  commentId: Scalars['uuid'];
  mentions?: InputMaybe<Array<AssetCommentMentionInput>>;
};


/** mutation root */
export type MutationUpdateAssetCommentThreadArgs = {
  anchor: AssetCommentAnchorInput;
  threadId: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateAudienceTemplateArgs = {
  id: Scalars['uuid'];
  input: UpdateAudienceTemplateInput;
};


/** mutation root */
export type MutationUpdateAudienceTemplateSpacesArgs = {
  addSpaceIds: Array<Scalars['uuid']>;
  audienceTemplateId: Scalars['uuid'];
  removeSpaceIds: Array<Scalars['uuid']>;
};


/** mutation root */
export type MutationUpdateBlocklistArgs = {
  input: UpdateBlocklistInput;
};


/** mutation root */
export type MutationUpdateCachedEventPullSettingsArgs = {
  input: UpdateCachedEventPullSettingsInput;
};


/** mutation root */
export type MutationUpdateCalendarViewArgs = {
  id: Scalars['ID'];
  input: UpdateCalendarViewInput;
};


/** mutation root */
export type MutationUpdateCampaignStatusArgs = {
  campaignId: Scalars['ID'];
  newStatus: Scalars['String'];
};


/** mutation root */
export type MutationUpdateCanvasArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


/** mutation root */
export type MutationUpdateCepChannelDailyCapArgs = {
  channelDailyCap?: InputMaybe<Scalars['Int']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateCepParentModelSettingsArgs = {
  input: UpdateCepParentModelSettingsInput;
};


/** mutation root */
export type MutationUpdateCepParentModelsSettingsArgs = {
  input: UpdateCepParentModelsSettingsInput;
};


/** mutation root */
export type MutationUpdateCepProviderArgs = {
  input: UpdateCepProviderInput;
};


/** mutation root */
export type MutationUpdateCepWhatsAppMessageCategoryArgs = {
  input: UpdateCepWhatsAppMessageCategoryInput;
};


/** mutation root */
export type MutationUpdateCepWhatsAppTemplateArgs = {
  input: UpdateCepWhatsAppTemplateInput;
};


/** mutation root */
export type MutationUpdateComponentAssetArgs = {
  input: UpdateComponentAssetInput;
};


/** mutation root */
export type MutationUpdateConnectionRoleMappingArgs = {
  input: UpdateConnectionRoleMappingInput;
};


/** mutation root */
export type MutationUpdateContentArtifactMetadataArgs = {
  input: UpdateContentArtifactMetadataInput;
};


/** mutation root */
export type MutationUpdateContentEmailBrandProfileAssignmentArgs = {
  brandProfileIds: Array<Scalars['uuid']>;
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateContentImageArgs = {
  id: Scalars['uuid'];
  input: UpdateLibraryImageInput;
};


/** mutation root */
export type MutationUpdateCreativeTagArgs = {
  creativeId: Scalars['String'];
  dimensionKey: Scalars['String'];
  fivetranSyncId: Scalars['String'];
  value: Scalars['String'];
};


/** mutation root */
export type MutationUpdateDamSyncArgs = {
  id: Scalars['ID'];
  input: UpdateDamSyncInput;
};


/** mutation root */
export type MutationUpdateDbtCloudCredentialArgs = {
  accountUrl?: InputMaybe<Scalars['String']>;
  apiKey?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


/** mutation root */
export type MutationUpdateDecisionEngineArbitrationGroupArgs = {
  config?: InputMaybe<DecisionEngineArbitrationGroupConfigInput>;
  id: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdateDecisionEngineArbitrationGroupMembershipArgs = {
  flowId: Scalars['uuid'];
  flowWeight: Scalars['Float'];
  groupId: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateDecisionEngineChannelConfigArgs = {
  channelId: Scalars['uuid'];
  config: Scalars['JSONObject'];
  syncTuning?: InputMaybe<DecisionEngineSyncTuningInput>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatrixConsentPurgeArgs = {
  consentPurge?: InputMaybe<DecisionEngineConsentPurgeInput>;
  featureMatrixId: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatrixTombstonesArgs = {
  featureMatrixId: Scalars['uuid'];
  relationships: Array<DecisionEngineFeatureMatrixRelationshipInput>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowOverridePeriodArgs = {
  id: Scalars['uuid'];
  input: DecisionEngineFlowOverridePeriodUpdateInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageArgs = {
  input: UpdateDecisionEngineMessageInput;
  messageId: Scalars['uuid'];
};


/** mutation root */
export type MutationUpdateDecisionEngineSchedulingArgs = {
  channels: Array<DecisionEngineChannelSchedulingInput>;
  engineId: Scalars['uuid'];
  flows: Array<DecisionEngineFlowSchedulingInput>;
};


/** mutation root */
export type MutationUpdateDestinationWithSecretsArgs = {
  _append?: InputMaybe<Scalars['JSONObject']>;
  destination?: InputMaybe<DestinationsMutationInput>;
  destinationId: Scalars['String'];
  eventGrants?: InputMaybe<Array<EventForwardingDestinationGrant>>;
  grants?: InputMaybe<Array<DestinationGrant>>;
};


/** mutation root */
export type MutationUpdateDomainSourcesArgs = {
  input: UpdateDomainSourcesInput;
};


/** mutation root */
export type MutationUpdateDraftsStatusArgs = {
  draftIds: Array<Scalars['String']>;
  status: DraftStatus;
};


/** mutation root */
export type MutationUpdateEmailTemplateInDestinationArgs = {
  destinationId: Scalars['String'];
  input: UpdateEmailTemplateInput;
  overrideTemplateErrors?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type MutationUpdateEnrichedFeedScheduleArgs = {
  feedId: Scalars['ID'];
  schedule?: InputMaybe<Scalars['JSON']>;
};


/** mutation root */
export type MutationUpdateEventComponentArgs = {
  input: UpdateEventComponentInput;
};


/** mutation root */
export type MutationUpdateEventForwardingSyncArgs = {
  id: Scalars['String'];
  input: UpdateEventForwardingSyncInput;
};


/** mutation root */
export type MutationUpdateEventPlanArgs = {
  id: Scalars['String'];
  input: UpdateEventPlanInput;
};


/** mutation root */
export type MutationUpdateEventSchemaV2Args = {
  input: UpdateEventSchemaInput;
};


/** mutation root */
export type MutationUpdateEventSourceArgs = {
  id: Scalars['String'];
  input: UpdateEventSourceInput;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationArgs = {
  id: Scalars['String'];
  input: UpdateEventWarehouseDestinationInput;
};


/** mutation root */
export type MutationUpdateEventWarehouseSyncArgs = {
  id: Scalars['String'];
  input: UpdateEventWarehouseSyncInput;
};


/** mutation root */
export type MutationUpdateExtensionExportConfigArgs = {
  exportConfig: Scalars['JSON'];
  extensionId: Scalars['String'];
};


/** mutation root */
export type MutationUpdateExtensionWithSecretsArgs = {
  id: Scalars['String'];
  input: UpdateExtensionInput;
};


/** mutation root */
export type MutationUpdateExternalContextSourceArgs = {
  id: Scalars['uuid'];
  input: UpdateExternalContextSourceInput;
};


/** mutation root */
export type MutationUpdateFivetranSyncAccountsArgs = {
  input: UpdateFivetranSyncAccountsInput;
};


/** mutation root */
export type MutationUpdateFivetranSyncAuthArgs = {
  input: UpdateFivetranSyncAuthInput;
};


/** mutation root */
export type MutationUpdateFunctionArgs = {
  id: Scalars['String'];
  input: UpdateFunctionInput;
  versionNumber: Scalars['Int'];
};


/** mutation root */
export type MutationUpdateGithubCredentialsArgs = {
  object: GithubCredentialMutationInput;
};


/** mutation root */
export type MutationUpdateGoldenRecordArgs = {
  input: UpdateGoldenRecordInput;
};


/** mutation root */
export type MutationUpdateGoldenRecordColumnArgs = {
  input: UpdateGoldenRecordColumnInput;
};


/** mutation root */
export type MutationUpdateIdrGraphArgs = {
  input: UpdateIdrGraphInput;
};


/** mutation root */
export type MutationUpdateIdrModelArgs = {
  input: UpdateIdrModelBulkInput;
};


/** mutation root */
export type MutationUpdateInitiativeInsightArgs = {
  content: Scalars['JSONObject'];
  insightId: Scalars['uuid'];
  title: Scalars['String'];
  type: Scalars['String'];
};


/** mutation root */
export type MutationUpdateJourneyArgs = {
  journey_graph: JourneyGraphInput;
};


/** mutation root */
export type MutationUpdateJourneyTemplateArgs = {
  template_input: JourneyTemplateInput;
};


/** mutation root */
export type MutationUpdateJourneyTraitArgs = {
  input: UpdateJourneyTraitInput;
};


/** mutation root */
export type MutationUpdateLlmChatMessageContentArgs = {
  input: UpdateLlmChatMessageContentInput;
};


/** mutation root */
export type MutationUpdateLlmInferenceBackendArgs = {
  input: UpdateLlmInferenceBackendInput;
};


/** mutation root */
export type MutationUpdateManagedSkillArgs = {
  input: UpdateAgenticSettingsEntityInput;
};


/** mutation root */
export type MutationUpdateManyDecisionEngineMessagesArgs = {
  updates: Array<UpdateManyDecisionEngineMessagesInput>;
};


/** mutation root */
export type MutationUpdateMessageAbTestArgs = {
  input: UpdateMessageAbTestInput;
};


/** mutation root */
export type MutationUpdateMessageContentArgs = {
  input: UpdateMessageContentInput;
};


/** mutation root */
export type MutationUpdateMessagePlanArgs = {
  input: UpdateMessagePlanInput;
};


/** mutation root */
export type MutationUpdateOpportunityDefinitionArgs = {
  id: Scalars['ID'];
  input: OpportunityDefinitionInput;
};


/** mutation root */
export type MutationUpdatePidrPairBlocklistArgs = {
  input: UpdatePidrPairBlocklistInput;
};


/** mutation root */
export type MutationUpdatePidrRowBlocklistArgs = {
  input: UpdatePidrRowBlocklistInput;
};


/** mutation root */
export type MutationUpdatePidrValueBlocklistArgs = {
  input: UpdatePidrValueBlocklistInput;
};


/** mutation root */
export type MutationUpdatePredictorArgs = {
  input: UpdatePredictorInput;
};


/** mutation root */
export type MutationUpdatePredictorCatalogFeatureDefinitionArgs = {
  input: UpdatePredictorCatalogFeatureDefinitionInput;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionArgs = {
  input: UpdatePredictorFeatureDefinitionInput;
};


/** mutation root */
export type MutationUpdatePredictorSettingsArgs = {
  input: UpdatePredictorSettingsInput;
};


/** mutation root */
export type MutationUpdatePreviewRecipientArgs = {
  channelId: Scalars['uuid'];
  patch: MessagePreviewRecipientPatch;
};


/** mutation root */
export type MutationUpdatePriorityListArgs = {
  audienceIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdatePushAppArgs = {
  input: UpdatePushAppInput;
};


/** mutation root */
export type MutationUpdatePushCampaignInDestinationArgs = {
  destinationId: Scalars['String'];
  input: UpdatePushCampaignInput;
};


/** mutation root */
export type MutationUpdateRealtimeEventColumnsArgs = {
  columnChanges: Array<RealtimeEventColumnChangeInput>;
  modelId: Scalars['String'];
};


/** mutation root */
export type MutationUpdateRelationshipArgs = {
  edgeId?: InputMaybe<Scalars['String']>;
  relationship: UpdateRelationshipInput;
  reverseEdgeId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdateReportScheduleContentArgs = {
  input: UpdateReportScheduleContentInput;
};


/** mutation root */
export type MutationUpdateReviewAgentArgs = {
  id: Scalars['uuid'];
  name?: InputMaybe<Scalars['String']>;
  settingsEntityId?: InputMaybe<Scalars['uuid']>;
};


/** mutation root */
export type MutationUpdateSchemaModelArgs = {
  input: UpdateSchemaModelInput;
  model_id: Scalars['bigint'];
};


/** mutation root */
export type MutationUpdateSmsCampaignInDestinationArgs = {
  destinationId: Scalars['String'];
  input: UpdateSmsCampaignInput;
};


/** mutation root */
export type MutationUpdateSourceWithSecretsArgs = {
  _append?: InputMaybe<Scalars['JSONObject']>;
  grants?: InputMaybe<Array<SourceGrant>>;
  source?: InputMaybe<SourceMutationInput>;
  sourceId: Scalars['String'];
};


/** mutation root */
export type MutationUpdateSplitsConfigArgs = {
  audienceId: Scalars['String'];
  enabled: Scalars['Boolean'];
  exactCount?: InputMaybe<Scalars['Boolean']>;
  groupColumnName?: InputMaybe<Scalars['String']>;
  samplingType?: InputMaybe<Scalars['String']>;
  splitAssignmentColumn?: InputMaybe<Scalars['JSONObject']>;
  stratificationVariables?: InputMaybe<Array<InputMaybe<Scalars['JSONObject']>>>;
};


/** mutation root */
export type MutationUpdateStyleEntityArgs = {
  input: UpdateStyleEntityInput;
};


/** mutation root */
export type MutationUpdateSyncTemplateArgs = {
  id: Scalars['Int'];
  input: UpdateSyncTemplateInput;
};


/** mutation root */
export type MutationUpdateTraitArgs = {
  id: Scalars['uuid'];
  input: UpdateTraitInput;
};


/** mutation root */
export type MutationUpdateTraitDefinitionArgs = {
  id: Scalars['uuid'];
  input: UpdateTraitDefinitionInput;
};


/** mutation root */
export type MutationUpdateWorkspaceNotificationChannelConfigArgs = {
  channelId: Scalars['String'];
  config: Scalars['JSONObject'];
  status?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchQueueArgs = {
  _append?: InputMaybe<AdBriefAssetLaunchQueueAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchQueueDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetLaunchQueueDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetLaunchQueueDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetLaunchQueuePrependInput>;
  _set?: InputMaybe<AdBriefAssetLaunchQueueSetInput>;
  where: AdBriefAssetLaunchQueueBoolExp;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchQueueByPkArgs = {
  _append?: InputMaybe<AdBriefAssetLaunchQueueAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchQueueDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetLaunchQueueDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetLaunchQueueDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetLaunchQueuePrependInput>;
  _set?: InputMaybe<AdBriefAssetLaunchQueueSetInput>;
  pk_columns: AdBriefAssetLaunchQueuePkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchQueueManyArgs = {
  updates: Array<AdBriefAssetLaunchQueueUpdates>;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchesArgs = {
  _append?: InputMaybe<AdBriefAssetLaunchesAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetLaunchesDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetLaunchesDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetLaunchesPrependInput>;
  _set?: InputMaybe<AdBriefAssetLaunchesSetInput>;
  where: AdBriefAssetLaunchesBoolExp;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchesByPkArgs = {
  _append?: InputMaybe<AdBriefAssetLaunchesAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetLaunchesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetLaunchesDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetLaunchesDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetLaunchesPrependInput>;
  _set?: InputMaybe<AdBriefAssetLaunchesSetInput>;
  pk_columns: AdBriefAssetLaunchesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdBriefAssetLaunchesManyArgs = {
  updates: Array<AdBriefAssetLaunchesUpdates>;
};


/** mutation root */
export type MutationUpdateAdBriefAssetsArgs = {
  _append?: InputMaybe<AdBriefAssetsAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetsDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetsDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetsPrependInput>;
  _set?: InputMaybe<AdBriefAssetsSetInput>;
  where: AdBriefAssetsBoolExp;
};


/** mutation root */
export type MutationUpdateAdBriefAssetsByPkArgs = {
  _append?: InputMaybe<AdBriefAssetsAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefAssetsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefAssetsDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefAssetsDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefAssetsPrependInput>;
  _set?: InputMaybe<AdBriefAssetsSetInput>;
  pk_columns: AdBriefAssetsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdBriefAssetsManyArgs = {
  updates: Array<AdBriefAssetsUpdates>;
};


/** mutation root */
export type MutationUpdateAdBriefsArgs = {
  _append?: InputMaybe<AdBriefsAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefsDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefsDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefsPrependInput>;
  _set?: InputMaybe<AdBriefsSetInput>;
  where: AdBriefsBoolExp;
};


/** mutation root */
export type MutationUpdateAdBriefsByPkArgs = {
  _append?: InputMaybe<AdBriefsAppendInput>;
  _delete_at_path?: InputMaybe<AdBriefsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdBriefsDeleteElemInput>;
  _delete_key?: InputMaybe<AdBriefsDeleteKeyInput>;
  _prepend?: InputMaybe<AdBriefsPrependInput>;
  _set?: InputMaybe<AdBriefsSetInput>;
  pk_columns: AdBriefsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdBriefsManyArgs = {
  updates: Array<AdBriefsUpdates>;
};


/** mutation root */
export type MutationUpdateAdExportChannelSizesArgs = {
  _set?: InputMaybe<AdExportChannelSizesSetInput>;
  where: AdExportChannelSizesBoolExp;
};


/** mutation root */
export type MutationUpdateAdExportChannelSizesByPkArgs = {
  _set?: InputMaybe<AdExportChannelSizesSetInput>;
  pk_columns: AdExportChannelSizesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdExportChannelSizesManyArgs = {
  updates: Array<AdExportChannelSizesUpdates>;
};


/** mutation root */
export type MutationUpdateAdExportChannelsArgs = {
  _set?: InputMaybe<AdExportChannelsSetInput>;
  where: AdExportChannelsBoolExp;
};


/** mutation root */
export type MutationUpdateAdExportChannelsByPkArgs = {
  _set?: InputMaybe<AdExportChannelsSetInput>;
  pk_columns: AdExportChannelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdExportChannelsManyArgs = {
  updates: Array<AdExportChannelsUpdates>;
};


/** mutation root */
export type MutationUpdateAdGenerationPipelineRunsArgs = {
  _set?: InputMaybe<AdGenerationPipelineRunsSetInput>;
  where: AdGenerationPipelineRunsBoolExp;
};


/** mutation root */
export type MutationUpdateAdGenerationPipelineRunsByPkArgs = {
  _set?: InputMaybe<AdGenerationPipelineRunsSetInput>;
  pk_columns: AdGenerationPipelineRunsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdGenerationPipelineRunsManyArgs = {
  updates: Array<AdGenerationPipelineRunsUpdates>;
};


/** mutation root */
export type MutationUpdateAdGenerationWorkflowsArgs = {
  _append?: InputMaybe<AdGenerationWorkflowsAppendInput>;
  _delete_at_path?: InputMaybe<AdGenerationWorkflowsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdGenerationWorkflowsDeleteElemInput>;
  _delete_key?: InputMaybe<AdGenerationWorkflowsDeleteKeyInput>;
  _prepend?: InputMaybe<AdGenerationWorkflowsPrependInput>;
  _set?: InputMaybe<AdGenerationWorkflowsSetInput>;
  where: AdGenerationWorkflowsBoolExp;
};


/** mutation root */
export type MutationUpdateAdGenerationWorkflowsByPkArgs = {
  _append?: InputMaybe<AdGenerationWorkflowsAppendInput>;
  _delete_at_path?: InputMaybe<AdGenerationWorkflowsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdGenerationWorkflowsDeleteElemInput>;
  _delete_key?: InputMaybe<AdGenerationWorkflowsDeleteKeyInput>;
  _prepend?: InputMaybe<AdGenerationWorkflowsPrependInput>;
  _set?: InputMaybe<AdGenerationWorkflowsSetInput>;
  pk_columns: AdGenerationWorkflowsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdGenerationWorkflowsManyArgs = {
  updates: Array<AdGenerationWorkflowsUpdates>;
};


/** mutation root */
export type MutationUpdateAdStatsModelsArgs = {
  _inc?: InputMaybe<AdStatsModelsIncInput>;
  _set?: InputMaybe<AdStatsModelsSetInput>;
  where: AdStatsModelsBoolExp;
};


/** mutation root */
export type MutationUpdateAdStatsModelsByPkArgs = {
  _inc?: InputMaybe<AdStatsModelsIncInput>;
  _set?: InputMaybe<AdStatsModelsSetInput>;
  pk_columns: AdStatsModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdStatsModelsManyArgs = {
  updates: Array<AdStatsModelsUpdates>;
};


/** mutation root */
export type MutationUpdateAdStudioProductFeedsArgs = {
  _append?: InputMaybe<AdStudioProductFeedsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioProductFeedsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioProductFeedsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioProductFeedsDeleteKeyInput>;
  _prepend?: InputMaybe<AdStudioProductFeedsPrependInput>;
  _set?: InputMaybe<AdStudioProductFeedsSetInput>;
  where: AdStudioProductFeedsBoolExp;
};


/** mutation root */
export type MutationUpdateAdStudioProductFeedsByPkArgs = {
  _append?: InputMaybe<AdStudioProductFeedsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioProductFeedsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioProductFeedsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioProductFeedsDeleteKeyInput>;
  _prepend?: InputMaybe<AdStudioProductFeedsPrependInput>;
  _set?: InputMaybe<AdStudioProductFeedsSetInput>;
  pk_columns: AdStudioProductFeedsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdStudioProductFeedsManyArgs = {
  updates: Array<AdStudioProductFeedsUpdates>;
};


/** mutation root */
export type MutationUpdateAdStudioProjectsArgs = {
  _append?: InputMaybe<AdStudioProjectsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioProjectsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioProjectsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioProjectsDeleteKeyInput>;
  _prepend?: InputMaybe<AdStudioProjectsPrependInput>;
  _set?: InputMaybe<AdStudioProjectsSetInput>;
  where: AdStudioProjectsBoolExp;
};


/** mutation root */
export type MutationUpdateAdStudioProjectsByPkArgs = {
  _append?: InputMaybe<AdStudioProjectsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioProjectsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioProjectsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioProjectsDeleteKeyInput>;
  _prepend?: InputMaybe<AdStudioProjectsPrependInput>;
  _set?: InputMaybe<AdStudioProjectsSetInput>;
  pk_columns: AdStudioProjectsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdStudioProjectsManyArgs = {
  updates: Array<AdStudioProjectsUpdates>;
};


/** mutation root */
export type MutationUpdateAdStudioTreatmentsArgs = {
  _append?: InputMaybe<AdStudioTreatmentsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioTreatmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioTreatmentsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioTreatmentsDeleteKeyInput>;
  _inc?: InputMaybe<AdStudioTreatmentsIncInput>;
  _prepend?: InputMaybe<AdStudioTreatmentsPrependInput>;
  _set?: InputMaybe<AdStudioTreatmentsSetInput>;
  where: AdStudioTreatmentsBoolExp;
};


/** mutation root */
export type MutationUpdateAdStudioTreatmentsByPkArgs = {
  _append?: InputMaybe<AdStudioTreatmentsAppendInput>;
  _delete_at_path?: InputMaybe<AdStudioTreatmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AdStudioTreatmentsDeleteElemInput>;
  _delete_key?: InputMaybe<AdStudioTreatmentsDeleteKeyInput>;
  _inc?: InputMaybe<AdStudioTreatmentsIncInput>;
  _prepend?: InputMaybe<AdStudioTreatmentsPrependInput>;
  _set?: InputMaybe<AdStudioTreatmentsSetInput>;
  pk_columns: AdStudioTreatmentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAdStudioTreatmentsManyArgs = {
  updates: Array<AdStudioTreatmentsUpdates>;
};


/** mutation root */
export type MutationUpdateAgenticSettingsArgs = {
  _append?: InputMaybe<AgenticSettingsAppendInput>;
  _delete_at_path?: InputMaybe<AgenticSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AgenticSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<AgenticSettingsDeleteKeyInput>;
  _prepend?: InputMaybe<AgenticSettingsPrependInput>;
  _set?: InputMaybe<AgenticSettingsSetInput>;
  where: AgenticSettingsBoolExp;
};


/** mutation root */
export type MutationUpdateAgenticSettingsByPkArgs = {
  _append?: InputMaybe<AgenticSettingsAppendInput>;
  _delete_at_path?: InputMaybe<AgenticSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AgenticSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<AgenticSettingsDeleteKeyInput>;
  _prepend?: InputMaybe<AgenticSettingsPrependInput>;
  _set?: InputMaybe<AgenticSettingsSetInput>;
  pk_columns: AgenticSettingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAgenticSettingsEntitiesLinksArgs = {
  _inc?: InputMaybe<AgenticSettingsEntitiesLinksIncInput>;
  _set?: InputMaybe<AgenticSettingsEntitiesLinksSetInput>;
  where: AgenticSettingsEntitiesLinksBoolExp;
};


/** mutation root */
export type MutationUpdateAgenticSettingsEntitiesLinksByPkArgs = {
  _inc?: InputMaybe<AgenticSettingsEntitiesLinksIncInput>;
  _set?: InputMaybe<AgenticSettingsEntitiesLinksSetInput>;
  pk_columns: AgenticSettingsEntitiesLinksPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAgenticSettingsEntitiesLinksManyArgs = {
  updates: Array<AgenticSettingsEntitiesLinksUpdates>;
};


/** mutation root */
export type MutationUpdateAgenticSettingsManyArgs = {
  updates: Array<AgenticSettingsUpdates>;
};


/** mutation root */
export type MutationUpdateAlertInstancesArgs = {
  _set?: InputMaybe<AlertInstancesSetInput>;
  where: AlertInstancesBoolExp;
};


/** mutation root */
export type MutationUpdateAlertInstancesManyArgs = {
  updates: Array<AlertInstancesUpdates>;
};


/** mutation root */
export type MutationUpdateAlertsArgs = {
  _append?: InputMaybe<AlertsAppendInput>;
  _delete_at_path?: InputMaybe<AlertsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AlertsDeleteElemInput>;
  _delete_key?: InputMaybe<AlertsDeleteKeyInput>;
  _inc?: InputMaybe<AlertsIncInput>;
  _prepend?: InputMaybe<AlertsPrependInput>;
  _set?: InputMaybe<AlertsSetInput>;
  where: AlertsBoolExp;
};


/** mutation root */
export type MutationUpdateAlertsByPkArgs = {
  _append?: InputMaybe<AlertsAppendInput>;
  _delete_at_path?: InputMaybe<AlertsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AlertsDeleteElemInput>;
  _delete_key?: InputMaybe<AlertsDeleteKeyInput>;
  _inc?: InputMaybe<AlertsIncInput>;
  _prepend?: InputMaybe<AlertsPrependInput>;
  _set?: InputMaybe<AlertsSetInput>;
  pk_columns: AlertsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAlertsManyArgs = {
  updates: Array<AlertsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpAssetRatingsArgs = {
  _append?: InputMaybe<AmpAssetRatingsAppendInput>;
  _delete_at_path?: InputMaybe<AmpAssetRatingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpAssetRatingsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpAssetRatingsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpAssetRatingsPrependInput>;
  _set?: InputMaybe<AmpAssetRatingsSetInput>;
  where: AmpAssetRatingsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpAssetRatingsByPkArgs = {
  _append?: InputMaybe<AmpAssetRatingsAppendInput>;
  _delete_at_path?: InputMaybe<AmpAssetRatingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpAssetRatingsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpAssetRatingsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpAssetRatingsPrependInput>;
  _set?: InputMaybe<AmpAssetRatingsSetInput>;
  pk_columns: AmpAssetRatingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpAssetRatingsManyArgs = {
  updates: Array<AmpAssetRatingsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpCreativeDimensionsArgs = {
  _append?: InputMaybe<AmpCreativeDimensionsAppendInput>;
  _delete_at_path?: InputMaybe<AmpCreativeDimensionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpCreativeDimensionsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpCreativeDimensionsDeleteKeyInput>;
  _inc?: InputMaybe<AmpCreativeDimensionsIncInput>;
  _prepend?: InputMaybe<AmpCreativeDimensionsPrependInput>;
  _set?: InputMaybe<AmpCreativeDimensionsSetInput>;
  where: AmpCreativeDimensionsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpCreativeDimensionsByPkArgs = {
  _append?: InputMaybe<AmpCreativeDimensionsAppendInput>;
  _delete_at_path?: InputMaybe<AmpCreativeDimensionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpCreativeDimensionsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpCreativeDimensionsDeleteKeyInput>;
  _inc?: InputMaybe<AmpCreativeDimensionsIncInput>;
  _prepend?: InputMaybe<AmpCreativeDimensionsPrependInput>;
  _set?: InputMaybe<AmpCreativeDimensionsSetInput>;
  pk_columns: AmpCreativeDimensionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpCreativeDimensionsManyArgs = {
  updates: Array<AmpCreativeDimensionsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpFollowedSourcesArgs = {
  _set?: InputMaybe<AmpFollowedSourcesSetInput>;
  where: AmpFollowedSourcesBoolExp;
};


/** mutation root */
export type MutationUpdateAmpFollowedSourcesByPkArgs = {
  _set?: InputMaybe<AmpFollowedSourcesSetInput>;
  pk_columns: AmpFollowedSourcesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpFollowedSourcesManyArgs = {
  updates: Array<AmpFollowedSourcesUpdates>;
};


/** mutation root */
export type MutationUpdateAmpFollowedTopicsArgs = {
  _append?: InputMaybe<AmpFollowedTopicsAppendInput>;
  _delete_at_path?: InputMaybe<AmpFollowedTopicsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpFollowedTopicsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpFollowedTopicsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpFollowedTopicsPrependInput>;
  _set?: InputMaybe<AmpFollowedTopicsSetInput>;
  where: AmpFollowedTopicsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpFollowedTopicsByPkArgs = {
  _append?: InputMaybe<AmpFollowedTopicsAppendInput>;
  _delete_at_path?: InputMaybe<AmpFollowedTopicsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpFollowedTopicsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpFollowedTopicsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpFollowedTopicsPrependInput>;
  _set?: InputMaybe<AmpFollowedTopicsSetInput>;
  pk_columns: AmpFollowedTopicsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpFollowedTopicsManyArgs = {
  updates: Array<AmpFollowedTopicsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpOpportunitiesArgs = {
  _set?: InputMaybe<AmpOpportunitiesSetInput>;
  where: AmpOpportunitiesBoolExp;
};


/** mutation root */
export type MutationUpdateAmpOpportunitiesByPkArgs = {
  _set?: InputMaybe<AmpOpportunitiesSetInput>;
  pk_columns: AmpOpportunitiesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpOpportunitiesManyArgs = {
  updates: Array<AmpOpportunitiesUpdates>;
};


/** mutation root */
export type MutationUpdateAmpProjectsArgs = {
  _append?: InputMaybe<AmpProjectsAppendInput>;
  _delete_at_path?: InputMaybe<AmpProjectsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpProjectsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpProjectsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpProjectsPrependInput>;
  _set?: InputMaybe<AmpProjectsSetInput>;
  where: AmpProjectsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpProjectsByPkArgs = {
  _append?: InputMaybe<AmpProjectsAppendInput>;
  _delete_at_path?: InputMaybe<AmpProjectsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AmpProjectsDeleteElemInput>;
  _delete_key?: InputMaybe<AmpProjectsDeleteKeyInput>;
  _prepend?: InputMaybe<AmpProjectsPrependInput>;
  _set?: InputMaybe<AmpProjectsSetInput>;
  pk_columns: AmpProjectsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpProjectsManyArgs = {
  updates: Array<AmpProjectsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpTagsArgs = {
  _set?: InputMaybe<AmpTagsSetInput>;
  where: AmpTagsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpTagsByPkArgs = {
  _set?: InputMaybe<AmpTagsSetInput>;
  pk_columns: AmpTagsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpTagsManyArgs = {
  updates: Array<AmpTagsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpTasksArgs = {
  _inc?: InputMaybe<AmpTasksIncInput>;
  _set?: InputMaybe<AmpTasksSetInput>;
  where: AmpTasksBoolExp;
};


/** mutation root */
export type MutationUpdateAmpTasksByPkArgs = {
  _inc?: InputMaybe<AmpTasksIncInput>;
  _set?: InputMaybe<AmpTasksSetInput>;
  pk_columns: AmpTasksPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpTasksManyArgs = {
  updates: Array<AmpTasksUpdates>;
};


/** mutation root */
export type MutationUpdateAmpTeamsArgs = {
  _set?: InputMaybe<AmpTeamsSetInput>;
  where: AmpTeamsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpTeamsByPkArgs = {
  _set?: InputMaybe<AmpTeamsSetInput>;
  pk_columns: AmpTeamsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpTeamsManyArgs = {
  updates: Array<AmpTeamsUpdates>;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusReviewersArgs = {
  _set?: InputMaybe<AmpWorkflowStatusReviewersSetInput>;
  where: AmpWorkflowStatusReviewersBoolExp;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusReviewersByPkArgs = {
  _set?: InputMaybe<AmpWorkflowStatusReviewersSetInput>;
  pk_columns: AmpWorkflowStatusReviewersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusReviewersManyArgs = {
  updates: Array<AmpWorkflowStatusReviewersUpdates>;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusesArgs = {
  _inc?: InputMaybe<AmpWorkflowStatusesIncInput>;
  _set?: InputMaybe<AmpWorkflowStatusesSetInput>;
  where: AmpWorkflowStatusesBoolExp;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusesByPkArgs = {
  _inc?: InputMaybe<AmpWorkflowStatusesIncInput>;
  _set?: InputMaybe<AmpWorkflowStatusesSetInput>;
  pk_columns: AmpWorkflowStatusesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpWorkflowStatusesManyArgs = {
  updates: Array<AmpWorkflowStatusesUpdates>;
};


/** mutation root */
export type MutationUpdateAmpWorkflowsArgs = {
  _set?: InputMaybe<AmpWorkflowsSetInput>;
  where: AmpWorkflowsBoolExp;
};


/** mutation root */
export type MutationUpdateAmpWorkflowsByPkArgs = {
  _set?: InputMaybe<AmpWorkflowsSetInput>;
  pk_columns: AmpWorkflowsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAmpWorkflowsManyArgs = {
  updates: Array<AmpWorkflowsUpdates>;
};


/** mutation root */
export type MutationUpdateAnalyticsReportsArgs = {
  _append?: InputMaybe<AnalyticsReportsAppendInput>;
  _delete_at_path?: InputMaybe<AnalyticsReportsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AnalyticsReportsDeleteElemInput>;
  _delete_key?: InputMaybe<AnalyticsReportsDeleteKeyInput>;
  _prepend?: InputMaybe<AnalyticsReportsPrependInput>;
  _set?: InputMaybe<AnalyticsReportsSetInput>;
  where: AnalyticsReportsBoolExp;
};


/** mutation root */
export type MutationUpdateAnalyticsReportsByPkArgs = {
  _append?: InputMaybe<AnalyticsReportsAppendInput>;
  _delete_at_path?: InputMaybe<AnalyticsReportsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AnalyticsReportsDeleteElemInput>;
  _delete_key?: InputMaybe<AnalyticsReportsDeleteKeyInput>;
  _prepend?: InputMaybe<AnalyticsReportsPrependInput>;
  _set?: InputMaybe<AnalyticsReportsSetInput>;
  pk_columns: AnalyticsReportsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAnalyticsReportsManyArgs = {
  updates: Array<AnalyticsReportsUpdates>;
};


/** mutation root */
export type MutationUpdateArtifactReviewCommentsArgs = {
  _set?: InputMaybe<ArtifactReviewCommentsSetInput>;
  where: ArtifactReviewCommentsBoolExp;
};


/** mutation root */
export type MutationUpdateArtifactReviewCommentsByPkArgs = {
  _set?: InputMaybe<ArtifactReviewCommentsSetInput>;
  pk_columns: ArtifactReviewCommentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateArtifactReviewCommentsManyArgs = {
  updates: Array<ArtifactReviewCommentsUpdates>;
};


/** mutation root */
export type MutationUpdateArtifactReviewersArgs = {
  _set?: InputMaybe<ArtifactReviewersSetInput>;
  where: ArtifactReviewersBoolExp;
};


/** mutation root */
export type MutationUpdateArtifactReviewersByPkArgs = {
  _set?: InputMaybe<ArtifactReviewersSetInput>;
  pk_columns: ArtifactReviewersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateArtifactReviewersManyArgs = {
  updates: Array<ArtifactReviewersUpdates>;
};


/** mutation root */
export type MutationUpdateArtifactReviewsArgs = {
  _set?: InputMaybe<ArtifactReviewsSetInput>;
  where: ArtifactReviewsBoolExp;
};


/** mutation root */
export type MutationUpdateArtifactReviewsByPkArgs = {
  _set?: InputMaybe<ArtifactReviewsSetInput>;
  pk_columns: ArtifactReviewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateArtifactReviewsManyArgs = {
  updates: Array<ArtifactReviewsUpdates>;
};


/** mutation root */
export type MutationUpdateAssetCommentThreadReadsArgs = {
  _set?: InputMaybe<AssetCommentThreadReadsSetInput>;
  where: AssetCommentThreadReadsBoolExp;
};


/** mutation root */
export type MutationUpdateAssetCommentThreadReadsByPkArgs = {
  _set?: InputMaybe<AssetCommentThreadReadsSetInput>;
  pk_columns: AssetCommentThreadReadsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAssetCommentThreadReadsManyArgs = {
  updates: Array<AssetCommentThreadReadsUpdates>;
};


/** mutation root */
export type MutationUpdateAssetModelsArgs = {
  _set?: InputMaybe<AssetModelsSetInput>;
  where: AssetModelsBoolExp;
};


/** mutation root */
export type MutationUpdateAssetModelsByPkArgs = {
  _set?: InputMaybe<AssetModelsSetInput>;
  pk_columns: AssetModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAssetModelsManyArgs = {
  updates: Array<AssetModelsUpdates>;
};


/** mutation root */
export type MutationUpdateAttributionMethodsArgs = {
  _set?: InputMaybe<AttributionMethodsSetInput>;
  where: AttributionMethodsBoolExp;
};


/** mutation root */
export type MutationUpdateAttributionMethodsByPkArgs = {
  _set?: InputMaybe<AttributionMethodsSetInput>;
  pk_columns: AttributionMethodsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAttributionMethodsInteractionsArgs = {
  _append?: InputMaybe<AttributionMethodsInteractionsAppendInput>;
  _delete_at_path?: InputMaybe<AttributionMethodsInteractionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AttributionMethodsInteractionsDeleteElemInput>;
  _delete_key?: InputMaybe<AttributionMethodsInteractionsDeleteKeyInput>;
  _inc?: InputMaybe<AttributionMethodsInteractionsIncInput>;
  _prepend?: InputMaybe<AttributionMethodsInteractionsPrependInput>;
  _set?: InputMaybe<AttributionMethodsInteractionsSetInput>;
  where: AttributionMethodsInteractionsBoolExp;
};


/** mutation root */
export type MutationUpdateAttributionMethodsInteractionsByPkArgs = {
  _append?: InputMaybe<AttributionMethodsInteractionsAppendInput>;
  _delete_at_path?: InputMaybe<AttributionMethodsInteractionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AttributionMethodsInteractionsDeleteElemInput>;
  _delete_key?: InputMaybe<AttributionMethodsInteractionsDeleteKeyInput>;
  _inc?: InputMaybe<AttributionMethodsInteractionsIncInput>;
  _prepend?: InputMaybe<AttributionMethodsInteractionsPrependInput>;
  _set?: InputMaybe<AttributionMethodsInteractionsSetInput>;
  pk_columns: AttributionMethodsInteractionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAttributionMethodsInteractionsManyArgs = {
  updates: Array<AttributionMethodsInteractionsUpdates>;
};


/** mutation root */
export type MutationUpdateAttributionMethodsManyArgs = {
  updates: Array<AttributionMethodsUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceGoalsArgs = {
  _inc?: InputMaybe<AudienceGoalsIncInput>;
  _set?: InputMaybe<AudienceGoalsSetInput>;
  where: AudienceGoalsBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceGoalsByPkArgs = {
  _inc?: InputMaybe<AudienceGoalsIncInput>;
  _set?: InputMaybe<AudienceGoalsSetInput>;
  pk_columns: AudienceGoalsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceGoalsManyArgs = {
  updates: Array<AudienceGoalsUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceOverviewsArgs = {
  _set?: InputMaybe<AudienceOverviewsSetInput>;
  where: AudienceOverviewsBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceOverviewsByPkArgs = {
  _set?: InputMaybe<AudienceOverviewsSetInput>;
  pk_columns: AudienceOverviewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceOverviewsManyArgs = {
  updates: Array<AudienceOverviewsUpdates>;
};


/** mutation root */
export type MutationUpdateAudiencePrimaryMetricsArgs = {
  _inc?: InputMaybe<AudiencePrimaryMetricsIncInput>;
  _set?: InputMaybe<AudiencePrimaryMetricsSetInput>;
  where: AudiencePrimaryMetricsBoolExp;
};


/** mutation root */
export type MutationUpdateAudiencePrimaryMetricsByPkArgs = {
  _inc?: InputMaybe<AudiencePrimaryMetricsIncInput>;
  _set?: InputMaybe<AudiencePrimaryMetricsSetInput>;
  pk_columns: AudiencePrimaryMetricsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudiencePrimaryMetricsManyArgs = {
  updates: Array<AudiencePrimaryMetricsUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceSplitsArgs = {
  _append?: InputMaybe<AudienceSplitsAppendInput>;
  _delete_at_path?: InputMaybe<AudienceSplitsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceSplitsDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceSplitsDeleteKeyInput>;
  _inc?: InputMaybe<AudienceSplitsIncInput>;
  _prepend?: InputMaybe<AudienceSplitsPrependInput>;
  _set?: InputMaybe<AudienceSplitsSetInput>;
  where: AudienceSplitsBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceSplitsByPkArgs = {
  _append?: InputMaybe<AudienceSplitsAppendInput>;
  _delete_at_path?: InputMaybe<AudienceSplitsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceSplitsDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceSplitsDeleteKeyInput>;
  _inc?: InputMaybe<AudienceSplitsIncInput>;
  _prepend?: InputMaybe<AudienceSplitsPrependInput>;
  _set?: InputMaybe<AudienceSplitsSetInput>;
  pk_columns: AudienceSplitsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceSplitsManyArgs = {
  updates: Array<AudienceSplitsUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceSubsetGroupsArgs = {
  _set?: InputMaybe<AudienceSubsetGroupsSetInput>;
  where: AudienceSubsetGroupsBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceSubsetGroupsByPkArgs = {
  _set?: InputMaybe<AudienceSubsetGroupsSetInput>;
  pk_columns: AudienceSubsetGroupsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceSubsetGroupsManyArgs = {
  updates: Array<AudienceSubsetGroupsUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceSubsetValuesArgs = {
  _append?: InputMaybe<AudienceSubsetValuesAppendInput>;
  _delete_at_path?: InputMaybe<AudienceSubsetValuesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceSubsetValuesDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceSubsetValuesDeleteKeyInput>;
  _prepend?: InputMaybe<AudienceSubsetValuesPrependInput>;
  _set?: InputMaybe<AudienceSubsetValuesSetInput>;
  where: AudienceSubsetValuesBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceSubsetValuesByPkArgs = {
  _append?: InputMaybe<AudienceSubsetValuesAppendInput>;
  _delete_at_path?: InputMaybe<AudienceSubsetValuesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceSubsetValuesDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceSubsetValuesDeleteKeyInput>;
  _prepend?: InputMaybe<AudienceSubsetValuesPrependInput>;
  _set?: InputMaybe<AudienceSubsetValuesSetInput>;
  pk_columns: AudienceSubsetValuesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceSubsetValuesManyArgs = {
  updates: Array<AudienceSubsetValuesUpdates>;
};


/** mutation root */
export type MutationUpdateAudienceTemplatesArgs = {
  _append?: InputMaybe<AudienceTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<AudienceTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceTemplatesDeleteKeyInput>;
  _inc?: InputMaybe<AudienceTemplatesIncInput>;
  _prepend?: InputMaybe<AudienceTemplatesPrependInput>;
  _set?: InputMaybe<AudienceTemplatesSetInput>;
  where: AudienceTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateAudienceTemplatesByPkArgs = {
  _append?: InputMaybe<AudienceTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<AudienceTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AudienceTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<AudienceTemplatesDeleteKeyInput>;
  _inc?: InputMaybe<AudienceTemplatesIncInput>;
  _prepend?: InputMaybe<AudienceTemplatesPrependInput>;
  _set?: InputMaybe<AudienceTemplatesSetInput>;
  pk_columns: AudienceTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudienceTemplatesManyArgs = {
  updates: Array<AudienceTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateAudiencesSubsetsArgs = {
  _set?: InputMaybe<AudiencesSubsetsSetInput>;
  where: AudiencesSubsetsBoolExp;
};


/** mutation root */
export type MutationUpdateAudiencesSubsetsByPkArgs = {
  _set?: InputMaybe<AudiencesSubsetsSetInput>;
  pk_columns: AudiencesSubsetsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateAudiencesSubsetsManyArgs = {
  updates: Array<AudiencesSubsetsUpdates>;
};


/** mutation root */
export type MutationUpdateBrandProfilesArgs = {
  _append?: InputMaybe<BrandProfilesAppendInput>;
  _delete_at_path?: InputMaybe<BrandProfilesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BrandProfilesDeleteElemInput>;
  _delete_key?: InputMaybe<BrandProfilesDeleteKeyInput>;
  _prepend?: InputMaybe<BrandProfilesPrependInput>;
  _set?: InputMaybe<BrandProfilesSetInput>;
  where: BrandProfilesBoolExp;
};


/** mutation root */
export type MutationUpdateBrandProfilesByPkArgs = {
  _append?: InputMaybe<BrandProfilesAppendInput>;
  _delete_at_path?: InputMaybe<BrandProfilesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<BrandProfilesDeleteElemInput>;
  _delete_key?: InputMaybe<BrandProfilesDeleteKeyInput>;
  _prepend?: InputMaybe<BrandProfilesPrependInput>;
  _set?: InputMaybe<BrandProfilesSetInput>;
  pk_columns: BrandProfilesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateBrandProfilesManyArgs = {
  updates: Array<BrandProfilesUpdates>;
};


/** mutation root */
export type MutationUpdateCampaignArtifactsArgs = {
  _append?: InputMaybe<CampaignArtifactsAppendInput>;
  _delete_at_path?: InputMaybe<CampaignArtifactsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CampaignArtifactsDeleteElemInput>;
  _delete_key?: InputMaybe<CampaignArtifactsDeleteKeyInput>;
  _inc?: InputMaybe<CampaignArtifactsIncInput>;
  _prepend?: InputMaybe<CampaignArtifactsPrependInput>;
  _set?: InputMaybe<CampaignArtifactsSetInput>;
  where: CampaignArtifactsBoolExp;
};


/** mutation root */
export type MutationUpdateCampaignArtifactsByPkArgs = {
  _append?: InputMaybe<CampaignArtifactsAppendInput>;
  _delete_at_path?: InputMaybe<CampaignArtifactsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CampaignArtifactsDeleteElemInput>;
  _delete_key?: InputMaybe<CampaignArtifactsDeleteKeyInput>;
  _inc?: InputMaybe<CampaignArtifactsIncInput>;
  _prepend?: InputMaybe<CampaignArtifactsPrependInput>;
  _set?: InputMaybe<CampaignArtifactsSetInput>;
  pk_columns: CampaignArtifactsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCampaignArtifactsManyArgs = {
  updates: Array<CampaignArtifactsUpdates>;
};


/** mutation root */
export type MutationUpdateCampaignRunsArgs = {
  _set?: InputMaybe<CampaignRunsSetInput>;
  where: CampaignRunsBoolExp;
};


/** mutation root */
export type MutationUpdateCampaignRunsByPkArgs = {
  _set?: InputMaybe<CampaignRunsSetInput>;
  pk_columns: CampaignRunsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCampaignRunsManyArgs = {
  updates: Array<CampaignRunsUpdates>;
};


/** mutation root */
export type MutationUpdateCampaignsArgs = {
  _append?: InputMaybe<CampaignsAppendInput>;
  _delete_at_path?: InputMaybe<CampaignsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CampaignsDeleteElemInput>;
  _delete_key?: InputMaybe<CampaignsDeleteKeyInput>;
  _inc?: InputMaybe<CampaignsIncInput>;
  _prepend?: InputMaybe<CampaignsPrependInput>;
  _set?: InputMaybe<CampaignsSetInput>;
  where: CampaignsBoolExp;
};


/** mutation root */
export type MutationUpdateCampaignsByPkArgs = {
  _append?: InputMaybe<CampaignsAppendInput>;
  _delete_at_path?: InputMaybe<CampaignsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CampaignsDeleteElemInput>;
  _delete_key?: InputMaybe<CampaignsDeleteKeyInput>;
  _inc?: InputMaybe<CampaignsIncInput>;
  _prepend?: InputMaybe<CampaignsPrependInput>;
  _set?: InputMaybe<CampaignsSetInput>;
  pk_columns: CampaignsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCampaignsManyArgs = {
  updates: Array<CampaignsUpdates>;
};


/** mutation root */
export type MutationUpdateCatalogCollectionsArgs = {
  _append?: InputMaybe<CatalogCollectionsAppendInput>;
  _delete_at_path?: InputMaybe<CatalogCollectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CatalogCollectionsDeleteElemInput>;
  _delete_key?: InputMaybe<CatalogCollectionsDeleteKeyInput>;
  _prepend?: InputMaybe<CatalogCollectionsPrependInput>;
  _set?: InputMaybe<CatalogCollectionsSetInput>;
  where: CatalogCollectionsBoolExp;
};


/** mutation root */
export type MutationUpdateCatalogCollectionsByPkArgs = {
  _append?: InputMaybe<CatalogCollectionsAppendInput>;
  _delete_at_path?: InputMaybe<CatalogCollectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CatalogCollectionsDeleteElemInput>;
  _delete_key?: InputMaybe<CatalogCollectionsDeleteKeyInput>;
  _prepend?: InputMaybe<CatalogCollectionsPrependInput>;
  _set?: InputMaybe<CatalogCollectionsSetInput>;
  pk_columns: CatalogCollectionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCatalogCollectionsManyArgs = {
  updates: Array<CatalogCollectionsUpdates>;
};


/** mutation root */
export type MutationUpdateCatalogModelsArgs = {
  _set?: InputMaybe<CatalogModelsSetInput>;
  where: CatalogModelsBoolExp;
};


/** mutation root */
export type MutationUpdateCatalogModelsByPkArgs = {
  _set?: InputMaybe<CatalogModelsSetInput>;
  pk_columns: CatalogModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCatalogModelsManyArgs = {
  updates: Array<CatalogModelsUpdates>;
};


/** mutation root */
export type MutationUpdateCepBrandSettingsArgs = {
  _append?: InputMaybe<CepBrandSettingsAppendInput>;
  _delete_at_path?: InputMaybe<CepBrandSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepBrandSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<CepBrandSettingsDeleteKeyInput>;
  _inc?: InputMaybe<CepBrandSettingsIncInput>;
  _prepend?: InputMaybe<CepBrandSettingsPrependInput>;
  _set?: InputMaybe<CepBrandSettingsSetInput>;
  where: CepBrandSettingsBoolExp;
};


/** mutation root */
export type MutationUpdateCepBrandSettingsByPkArgs = {
  _append?: InputMaybe<CepBrandSettingsAppendInput>;
  _delete_at_path?: InputMaybe<CepBrandSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepBrandSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<CepBrandSettingsDeleteKeyInput>;
  _inc?: InputMaybe<CepBrandSettingsIncInput>;
  _prepend?: InputMaybe<CepBrandSettingsPrependInput>;
  _set?: InputMaybe<CepBrandSettingsSetInput>;
  pk_columns: CepBrandSettingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepBrandSettingsManyArgs = {
  updates: Array<CepBrandSettingsUpdates>;
};


/** mutation root */
export type MutationUpdateCepChannelsArgs = {
  _append?: InputMaybe<CepChannelsAppendInput>;
  _delete_at_path?: InputMaybe<CepChannelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepChannelsDeleteElemInput>;
  _delete_key?: InputMaybe<CepChannelsDeleteKeyInput>;
  _prepend?: InputMaybe<CepChannelsPrependInput>;
  _set?: InputMaybe<CepChannelsSetInput>;
  where: CepChannelsBoolExp;
};


/** mutation root */
export type MutationUpdateCepChannelsByPkArgs = {
  _append?: InputMaybe<CepChannelsAppendInput>;
  _delete_at_path?: InputMaybe<CepChannelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepChannelsDeleteElemInput>;
  _delete_key?: InputMaybe<CepChannelsDeleteKeyInput>;
  _prepend?: InputMaybe<CepChannelsPrependInput>;
  _set?: InputMaybe<CepChannelsSetInput>;
  pk_columns: CepChannelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepChannelsManyArgs = {
  updates: Array<CepChannelsUpdates>;
};


/** mutation root */
export type MutationUpdateCepContentBlocksArgs = {
  _append?: InputMaybe<CepContentBlocksAppendInput>;
  _delete_at_path?: InputMaybe<CepContentBlocksDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepContentBlocksDeleteElemInput>;
  _delete_key?: InputMaybe<CepContentBlocksDeleteKeyInput>;
  _prepend?: InputMaybe<CepContentBlocksPrependInput>;
  _set?: InputMaybe<CepContentBlocksSetInput>;
  where: CepContentBlocksBoolExp;
};


/** mutation root */
export type MutationUpdateCepContentBlocksByPkArgs = {
  _append?: InputMaybe<CepContentBlocksAppendInput>;
  _delete_at_path?: InputMaybe<CepContentBlocksDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepContentBlocksDeleteElemInput>;
  _delete_key?: InputMaybe<CepContentBlocksDeleteKeyInput>;
  _prepend?: InputMaybe<CepContentBlocksPrependInput>;
  _set?: InputMaybe<CepContentBlocksSetInput>;
  pk_columns: CepContentBlocksPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepContentBlocksManyArgs = {
  updates: Array<CepContentBlocksUpdates>;
};


/** mutation root */
export type MutationUpdateCepDomainsArgs = {
  _append?: InputMaybe<CepDomainsAppendInput>;
  _delete_at_path?: InputMaybe<CepDomainsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepDomainsDeleteElemInput>;
  _delete_key?: InputMaybe<CepDomainsDeleteKeyInput>;
  _prepend?: InputMaybe<CepDomainsPrependInput>;
  _set?: InputMaybe<CepDomainsSetInput>;
  where: CepDomainsBoolExp;
};


/** mutation root */
export type MutationUpdateCepDomainsByPkArgs = {
  _append?: InputMaybe<CepDomainsAppendInput>;
  _delete_at_path?: InputMaybe<CepDomainsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepDomainsDeleteElemInput>;
  _delete_key?: InputMaybe<CepDomainsDeleteKeyInput>;
  _prepend?: InputMaybe<CepDomainsPrependInput>;
  _set?: InputMaybe<CepDomainsSetInput>;
  pk_columns: CepDomainsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepDomainsManyArgs = {
  updates: Array<CepDomainsUpdates>;
};


/** mutation root */
export type MutationUpdateCepEmailTemplateContentsArgs = {
  _append?: InputMaybe<CepEmailTemplateContentsAppendInput>;
  _delete_at_path?: InputMaybe<CepEmailTemplateContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepEmailTemplateContentsDeleteElemInput>;
  _delete_key?: InputMaybe<CepEmailTemplateContentsDeleteKeyInput>;
  _prepend?: InputMaybe<CepEmailTemplateContentsPrependInput>;
  _set?: InputMaybe<CepEmailTemplateContentsSetInput>;
  where: CepEmailTemplateContentsBoolExp;
};


/** mutation root */
export type MutationUpdateCepEmailTemplateContentsByPkArgs = {
  _append?: InputMaybe<CepEmailTemplateContentsAppendInput>;
  _delete_at_path?: InputMaybe<CepEmailTemplateContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepEmailTemplateContentsDeleteElemInput>;
  _delete_key?: InputMaybe<CepEmailTemplateContentsDeleteKeyInput>;
  _prepend?: InputMaybe<CepEmailTemplateContentsPrependInput>;
  _set?: InputMaybe<CepEmailTemplateContentsSetInput>;
  pk_columns: CepEmailTemplateContentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepEmailTemplateContentsManyArgs = {
  updates: Array<CepEmailTemplateContentsUpdates>;
};


/** mutation root */
export type MutationUpdateCepEmailTemplatesArgs = {
  _inc?: InputMaybe<CepEmailTemplatesIncInput>;
  _set?: InputMaybe<CepEmailTemplatesSetInput>;
  where: CepEmailTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateCepEmailTemplatesByPkArgs = {
  _inc?: InputMaybe<CepEmailTemplatesIncInput>;
  _set?: InputMaybe<CepEmailTemplatesSetInput>;
  pk_columns: CepEmailTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepEmailTemplatesManyArgs = {
  updates: Array<CepEmailTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateCepLocalesArgs = {
  _set?: InputMaybe<CepLocalesSetInput>;
  where: CepLocalesBoolExp;
};


/** mutation root */
export type MutationUpdateCepLocalesByPkArgs = {
  _set?: InputMaybe<CepLocalesSetInput>;
  pk_columns: CepLocalesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepLocalesManyArgs = {
  updates: Array<CepLocalesUpdates>;
};


/** mutation root */
export type MutationUpdateCepLocalizationSettingsArgs = {
  _set?: InputMaybe<CepLocalizationSettingsSetInput>;
  where: CepLocalizationSettingsBoolExp;
};


/** mutation root */
export type MutationUpdateCepLocalizationSettingsByPkArgs = {
  _set?: InputMaybe<CepLocalizationSettingsSetInput>;
  pk_columns: CepLocalizationSettingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepLocalizationSettingsManyArgs = {
  updates: Array<CepLocalizationSettingsUpdates>;
};


/** mutation root */
export type MutationUpdateCepMessageDevicePreviewsArgs = {
  _set?: InputMaybe<CepMessageDevicePreviewsSetInput>;
  where: CepMessageDevicePreviewsBoolExp;
};


/** mutation root */
export type MutationUpdateCepMessageDevicePreviewsByPkArgs = {
  _set?: InputMaybe<CepMessageDevicePreviewsSetInput>;
  pk_columns: CepMessageDevicePreviewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepMessageDevicePreviewsManyArgs = {
  updates: Array<CepMessageDevicePreviewsUpdates>;
};


/** mutation root */
export type MutationUpdateCepProvidersArgs = {
  _append?: InputMaybe<CepProvidersAppendInput>;
  _delete_at_path?: InputMaybe<CepProvidersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepProvidersDeleteElemInput>;
  _delete_key?: InputMaybe<CepProvidersDeleteKeyInput>;
  _prepend?: InputMaybe<CepProvidersPrependInput>;
  _set?: InputMaybe<CepProvidersSetInput>;
  where: CepProvidersBoolExp;
};


/** mutation root */
export type MutationUpdateCepProvidersByPkArgs = {
  _append?: InputMaybe<CepProvidersAppendInput>;
  _delete_at_path?: InputMaybe<CepProvidersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepProvidersDeleteElemInput>;
  _delete_key?: InputMaybe<CepProvidersDeleteKeyInput>;
  _prepend?: InputMaybe<CepProvidersPrependInput>;
  _set?: InputMaybe<CepProvidersSetInput>;
  pk_columns: CepProvidersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepProvidersManyArgs = {
  updates: Array<CepProvidersUpdates>;
};


/** mutation root */
export type MutationUpdateCepSenderIdentitiesArgs = {
  _append?: InputMaybe<CepSenderIdentitiesAppendInput>;
  _delete_at_path?: InputMaybe<CepSenderIdentitiesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepSenderIdentitiesDeleteElemInput>;
  _delete_key?: InputMaybe<CepSenderIdentitiesDeleteKeyInput>;
  _prepend?: InputMaybe<CepSenderIdentitiesPrependInput>;
  _set?: InputMaybe<CepSenderIdentitiesSetInput>;
  where: CepSenderIdentitiesBoolExp;
};


/** mutation root */
export type MutationUpdateCepSenderIdentitiesByPkArgs = {
  _append?: InputMaybe<CepSenderIdentitiesAppendInput>;
  _delete_at_path?: InputMaybe<CepSenderIdentitiesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepSenderIdentitiesDeleteElemInput>;
  _delete_key?: InputMaybe<CepSenderIdentitiesDeleteKeyInput>;
  _prepend?: InputMaybe<CepSenderIdentitiesPrependInput>;
  _set?: InputMaybe<CepSenderIdentitiesSetInput>;
  pk_columns: CepSenderIdentitiesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepSenderIdentitiesManyArgs = {
  updates: Array<CepSenderIdentitiesUpdates>;
};


/** mutation root */
export type MutationUpdateCepSubscriptionTopicsArgs = {
  _set?: InputMaybe<CepSubscriptionTopicsSetInput>;
  where: CepSubscriptionTopicsBoolExp;
};


/** mutation root */
export type MutationUpdateCepSubscriptionTopicsByPkArgs = {
  _set?: InputMaybe<CepSubscriptionTopicsSetInput>;
  pk_columns: CepSubscriptionTopicsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepSubscriptionTopicsManyArgs = {
  updates: Array<CepSubscriptionTopicsUpdates>;
};


/** mutation root */
export type MutationUpdateCepSuppressionListsArgs = {
  _append?: InputMaybe<CepSuppressionListsAppendInput>;
  _delete_at_path?: InputMaybe<CepSuppressionListsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepSuppressionListsDeleteElemInput>;
  _delete_key?: InputMaybe<CepSuppressionListsDeleteKeyInput>;
  _prepend?: InputMaybe<CepSuppressionListsPrependInput>;
  _set?: InputMaybe<CepSuppressionListsSetInput>;
  where: CepSuppressionListsBoolExp;
};


/** mutation root */
export type MutationUpdateCepSuppressionListsByPkArgs = {
  _append?: InputMaybe<CepSuppressionListsAppendInput>;
  _delete_at_path?: InputMaybe<CepSuppressionListsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepSuppressionListsDeleteElemInput>;
  _delete_key?: InputMaybe<CepSuppressionListsDeleteKeyInput>;
  _prepend?: InputMaybe<CepSuppressionListsPrependInput>;
  _set?: InputMaybe<CepSuppressionListsSetInput>;
  pk_columns: CepSuppressionListsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepSuppressionListsManyArgs = {
  updates: Array<CepSuppressionListsUpdates>;
};


/** mutation root */
export type MutationUpdateCepTestGroupsArgs = {
  _set?: InputMaybe<CepTestGroupsSetInput>;
  where: CepTestGroupsBoolExp;
};


/** mutation root */
export type MutationUpdateCepTestGroupsByPkArgs = {
  _set?: InputMaybe<CepTestGroupsSetInput>;
  pk_columns: CepTestGroupsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepTestGroupsManyArgs = {
  updates: Array<CepTestGroupsUpdates>;
};


/** mutation root */
export type MutationUpdateCepWorkspaceConfigArgs = {
  _append?: InputMaybe<CepWorkspaceConfigAppendInput>;
  _delete_at_path?: InputMaybe<CepWorkspaceConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepWorkspaceConfigDeleteElemInput>;
  _delete_key?: InputMaybe<CepWorkspaceConfigDeleteKeyInput>;
  _inc?: InputMaybe<CepWorkspaceConfigIncInput>;
  _prepend?: InputMaybe<CepWorkspaceConfigPrependInput>;
  _set?: InputMaybe<CepWorkspaceConfigSetInput>;
  where: CepWorkspaceConfigBoolExp;
};


/** mutation root */
export type MutationUpdateCepWorkspaceConfigByPkArgs = {
  _append?: InputMaybe<CepWorkspaceConfigAppendInput>;
  _delete_at_path?: InputMaybe<CepWorkspaceConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CepWorkspaceConfigDeleteElemInput>;
  _delete_key?: InputMaybe<CepWorkspaceConfigDeleteKeyInput>;
  _inc?: InputMaybe<CepWorkspaceConfigIncInput>;
  _prepend?: InputMaybe<CepWorkspaceConfigPrependInput>;
  _set?: InputMaybe<CepWorkspaceConfigSetInput>;
  pk_columns: CepWorkspaceConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCepWorkspaceConfigManyArgs = {
  updates: Array<CepWorkspaceConfigUpdates>;
};


/** mutation root */
export type MutationUpdateContentBlocksArgs = {
  _set?: InputMaybe<ContentBlocksSetInput>;
  where: ContentBlocksBoolExp;
};


/** mutation root */
export type MutationUpdateContentBlocksByPkArgs = {
  _set?: InputMaybe<ContentBlocksSetInput>;
  pk_columns: ContentBlocksPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentBlocksManyArgs = {
  updates: Array<ContentBlocksUpdates>;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotAssignmentsArgs = {
  _set?: InputMaybe<ContentDynamicSlotAssignmentsSetInput>;
  where: ContentDynamicSlotAssignmentsBoolExp;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotAssignmentsByPkArgs = {
  _set?: InputMaybe<ContentDynamicSlotAssignmentsSetInput>;
  pk_columns: ContentDynamicSlotAssignmentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotAssignmentsManyArgs = {
  updates: Array<ContentDynamicSlotAssignmentsUpdates>;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotBranchesArgs = {
  _append?: InputMaybe<ContentDynamicSlotBranchesAppendInput>;
  _delete_at_path?: InputMaybe<ContentDynamicSlotBranchesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentDynamicSlotBranchesDeleteElemInput>;
  _delete_key?: InputMaybe<ContentDynamicSlotBranchesDeleteKeyInput>;
  _inc?: InputMaybe<ContentDynamicSlotBranchesIncInput>;
  _prepend?: InputMaybe<ContentDynamicSlotBranchesPrependInput>;
  _set?: InputMaybe<ContentDynamicSlotBranchesSetInput>;
  where: ContentDynamicSlotBranchesBoolExp;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotBranchesByPkArgs = {
  _append?: InputMaybe<ContentDynamicSlotBranchesAppendInput>;
  _delete_at_path?: InputMaybe<ContentDynamicSlotBranchesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentDynamicSlotBranchesDeleteElemInput>;
  _delete_key?: InputMaybe<ContentDynamicSlotBranchesDeleteKeyInput>;
  _inc?: InputMaybe<ContentDynamicSlotBranchesIncInput>;
  _prepend?: InputMaybe<ContentDynamicSlotBranchesPrependInput>;
  _set?: InputMaybe<ContentDynamicSlotBranchesSetInput>;
  pk_columns: ContentDynamicSlotBranchesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotBranchesManyArgs = {
  updates: Array<ContentDynamicSlotBranchesUpdates>;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotContentsArgs = {
  _append?: InputMaybe<ContentDynamicSlotContentsAppendInput>;
  _delete_at_path?: InputMaybe<ContentDynamicSlotContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentDynamicSlotContentsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentDynamicSlotContentsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentDynamicSlotContentsPrependInput>;
  _set?: InputMaybe<ContentDynamicSlotContentsSetInput>;
  where: ContentDynamicSlotContentsBoolExp;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotContentsByPkArgs = {
  _append?: InputMaybe<ContentDynamicSlotContentsAppendInput>;
  _delete_at_path?: InputMaybe<ContentDynamicSlotContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentDynamicSlotContentsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentDynamicSlotContentsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentDynamicSlotContentsPrependInput>;
  _set?: InputMaybe<ContentDynamicSlotContentsSetInput>;
  pk_columns: ContentDynamicSlotContentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotContentsManyArgs = {
  updates: Array<ContentDynamicSlotContentsUpdates>;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotLibrariesArgs = {
  _inc?: InputMaybe<ContentDynamicSlotLibrariesIncInput>;
  _set?: InputMaybe<ContentDynamicSlotLibrariesSetInput>;
  where: ContentDynamicSlotLibrariesBoolExp;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotLibrariesByPkArgs = {
  _inc?: InputMaybe<ContentDynamicSlotLibrariesIncInput>;
  _set?: InputMaybe<ContentDynamicSlotLibrariesSetInput>;
  pk_columns: ContentDynamicSlotLibrariesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotLibrariesManyArgs = {
  updates: Array<ContentDynamicSlotLibrariesUpdates>;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotUsagesArgs = {
  _set?: InputMaybe<ContentDynamicSlotUsagesSetInput>;
  where: ContentDynamicSlotUsagesBoolExp;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotUsagesByPkArgs = {
  _set?: InputMaybe<ContentDynamicSlotUsagesSetInput>;
  pk_columns: ContentDynamicSlotUsagesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentDynamicSlotUsagesManyArgs = {
  updates: Array<ContentDynamicSlotUsagesUpdates>;
};


/** mutation root */
export type MutationUpdateContentEmailVariantsArgs = {
  _append?: InputMaybe<ContentEmailVariantsAppendInput>;
  _delete_at_path?: InputMaybe<ContentEmailVariantsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentEmailVariantsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentEmailVariantsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentEmailVariantsPrependInput>;
  _set?: InputMaybe<ContentEmailVariantsSetInput>;
  where: ContentEmailVariantsBoolExp;
};


/** mutation root */
export type MutationUpdateContentEmailVariantsByPkArgs = {
  _append?: InputMaybe<ContentEmailVariantsAppendInput>;
  _delete_at_path?: InputMaybe<ContentEmailVariantsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentEmailVariantsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentEmailVariantsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentEmailVariantsPrependInput>;
  _set?: InputMaybe<ContentEmailVariantsSetInput>;
  pk_columns: ContentEmailVariantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentEmailVariantsManyArgs = {
  updates: Array<ContentEmailVariantsUpdates>;
};


/** mutation root */
export type MutationUpdateContentEmailsArgs = {
  _append?: InputMaybe<ContentEmailsAppendInput>;
  _delete_at_path?: InputMaybe<ContentEmailsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentEmailsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentEmailsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentEmailsPrependInput>;
  _set?: InputMaybe<ContentEmailsSetInput>;
  where: ContentEmailsBoolExp;
};


/** mutation root */
export type MutationUpdateContentEmailsByPkArgs = {
  _append?: InputMaybe<ContentEmailsAppendInput>;
  _delete_at_path?: InputMaybe<ContentEmailsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentEmailsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentEmailsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentEmailsPrependInput>;
  _set?: InputMaybe<ContentEmailsSetInput>;
  pk_columns: ContentEmailsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentEmailsManyArgs = {
  updates: Array<ContentEmailsUpdates>;
};


/** mutation root */
export type MutationUpdateContentSettingsArgs = {
  _append?: InputMaybe<ContentSettingsAppendInput>;
  _delete_at_path?: InputMaybe<ContentSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentSettingsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentSettingsPrependInput>;
  _set?: InputMaybe<ContentSettingsSetInput>;
  where: ContentSettingsBoolExp;
};


/** mutation root */
export type MutationUpdateContentSettingsByPkArgs = {
  _append?: InputMaybe<ContentSettingsAppendInput>;
  _delete_at_path?: InputMaybe<ContentSettingsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ContentSettingsDeleteElemInput>;
  _delete_key?: InputMaybe<ContentSettingsDeleteKeyInput>;
  _prepend?: InputMaybe<ContentSettingsPrependInput>;
  _set?: InputMaybe<ContentSettingsSetInput>;
  pk_columns: ContentSettingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentSettingsManyArgs = {
  updates: Array<ContentSettingsUpdates>;
};


/** mutation root */
export type MutationUpdateContentTemplatesArgs = {
  _set?: InputMaybe<ContentTemplatesSetInput>;
  where: ContentTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateContentTemplatesByPkArgs = {
  _set?: InputMaybe<ContentTemplatesSetInput>;
  pk_columns: ContentTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateContentTemplatesManyArgs = {
  updates: Array<ContentTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateCustomAgentsArgs = {
  _append?: InputMaybe<CustomAgentsAppendInput>;
  _delete_at_path?: InputMaybe<CustomAgentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CustomAgentsDeleteElemInput>;
  _delete_key?: InputMaybe<CustomAgentsDeleteKeyInput>;
  _inc?: InputMaybe<CustomAgentsIncInput>;
  _prepend?: InputMaybe<CustomAgentsPrependInput>;
  _set?: InputMaybe<CustomAgentsSetInput>;
  where: CustomAgentsBoolExp;
};


/** mutation root */
export type MutationUpdateCustomAgentsByPkArgs = {
  _append?: InputMaybe<CustomAgentsAppendInput>;
  _delete_at_path?: InputMaybe<CustomAgentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<CustomAgentsDeleteElemInput>;
  _delete_key?: InputMaybe<CustomAgentsDeleteKeyInput>;
  _inc?: InputMaybe<CustomAgentsIncInput>;
  _prepend?: InputMaybe<CustomAgentsPrependInput>;
  _set?: InputMaybe<CustomAgentsSetInput>;
  pk_columns: CustomAgentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateCustomAgentsManyArgs = {
  updates: Array<CustomAgentsUpdates>;
};


/** mutation root */
export type MutationUpdateDashboardsArgs = {
  _append?: InputMaybe<DashboardsAppendInput>;
  _delete_at_path?: InputMaybe<DashboardsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DashboardsDeleteElemInput>;
  _delete_key?: InputMaybe<DashboardsDeleteKeyInput>;
  _prepend?: InputMaybe<DashboardsPrependInput>;
  _set?: InputMaybe<DashboardsSetInput>;
  where: DashboardsBoolExp;
};


/** mutation root */
export type MutationUpdateDashboardsByPkArgs = {
  _append?: InputMaybe<DashboardsAppendInput>;
  _delete_at_path?: InputMaybe<DashboardsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DashboardsDeleteElemInput>;
  _delete_key?: InputMaybe<DashboardsDeleteKeyInput>;
  _prepend?: InputMaybe<DashboardsPrependInput>;
  _set?: InputMaybe<DashboardsSetInput>;
  pk_columns: DashboardsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDashboardsManyArgs = {
  updates: Array<DashboardsUpdates>;
};


/** mutation root */
export type MutationUpdateDatadogCredentialsArgs = {
  _set?: InputMaybe<DatadogCredentialsSetInput>;
  where: DatadogCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateDatadogCredentialsByPkArgs = {
  _set?: InputMaybe<DatadogCredentialsSetInput>;
  pk_columns: DatadogCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDatadogCredentialsManyArgs = {
  updates: Array<DatadogCredentialsUpdates>;
};


/** mutation root */
export type MutationUpdateDbtCloudSyncConfigArgs = {
  _inc?: InputMaybe<DbtCloudSyncConfigIncInput>;
  _set?: InputMaybe<DbtCloudSyncConfigSetInput>;
  where: DbtCloudSyncConfigBoolExp;
};


/** mutation root */
export type MutationUpdateDbtCloudSyncConfigByPkArgs = {
  _inc?: InputMaybe<DbtCloudSyncConfigIncInput>;
  _set?: InputMaybe<DbtCloudSyncConfigSetInput>;
  pk_columns: DbtCloudSyncConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDbtCloudSyncConfigManyArgs = {
  updates: Array<DbtCloudSyncConfigUpdates>;
};


/** mutation root */
export type MutationUpdateDbtSyncConfigArgs = {
  _append?: InputMaybe<DbtSyncConfigAppendInput>;
  _delete_at_path?: InputMaybe<DbtSyncConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DbtSyncConfigDeleteElemInput>;
  _delete_key?: InputMaybe<DbtSyncConfigDeleteKeyInput>;
  _inc?: InputMaybe<DbtSyncConfigIncInput>;
  _prepend?: InputMaybe<DbtSyncConfigPrependInput>;
  _set?: InputMaybe<DbtSyncConfigSetInput>;
  where: DbtSyncConfigBoolExp;
};


/** mutation root */
export type MutationUpdateDbtSyncConfigByPkArgs = {
  _append?: InputMaybe<DbtSyncConfigAppendInput>;
  _delete_at_path?: InputMaybe<DbtSyncConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DbtSyncConfigDeleteElemInput>;
  _delete_key?: InputMaybe<DbtSyncConfigDeleteKeyInput>;
  _inc?: InputMaybe<DbtSyncConfigIncInput>;
  _prepend?: InputMaybe<DbtSyncConfigPrependInput>;
  _set?: InputMaybe<DbtSyncConfigSetInput>;
  pk_columns: DbtSyncConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDbtSyncConfigManyArgs = {
  updates: Array<DbtSyncConfigUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineChannelsArgs = {
  _append?: InputMaybe<DecisionEngineChannelsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineChannelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineChannelsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineChannelsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineChannelsIncInput>;
  _prepend?: InputMaybe<DecisionEngineChannelsPrependInput>;
  _set?: InputMaybe<DecisionEngineChannelsSetInput>;
  where: DecisionEngineChannelsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineChannelsByPkArgs = {
  _append?: InputMaybe<DecisionEngineChannelsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineChannelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineChannelsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineChannelsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineChannelsIncInput>;
  _prepend?: InputMaybe<DecisionEngineChannelsPrependInput>;
  _set?: InputMaybe<DecisionEngineChannelsSetInput>;
  pk_columns: DecisionEngineChannelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineChannelsManyArgs = {
  updates: Array<DecisionEngineChannelsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineCollectionsArgs = {
  _append?: InputMaybe<DecisionEngineCollectionsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineCollectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineCollectionsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineCollectionsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineCollectionsPrependInput>;
  _set?: InputMaybe<DecisionEngineCollectionsSetInput>;
  where: DecisionEngineCollectionsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineCollectionsByPkArgs = {
  _append?: InputMaybe<DecisionEngineCollectionsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineCollectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineCollectionsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineCollectionsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineCollectionsPrependInput>;
  _set?: InputMaybe<DecisionEngineCollectionsSetInput>;
  pk_columns: DecisionEngineCollectionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineCollectionsManyArgs = {
  updates: Array<DecisionEngineCollectionsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineContentRecommendationsArgs = {
  _set?: InputMaybe<DecisionEngineContentRecommendationsSetInput>;
  where: DecisionEngineContentRecommendationsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineContentRecommendationsByPkArgs = {
  _set?: InputMaybe<DecisionEngineContentRecommendationsSetInput>;
  pk_columns: DecisionEngineContentRecommendationsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineContentRecommendationsManyArgs = {
  updates: Array<DecisionEngineContentRecommendationsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatricesArgs = {
  _inc?: InputMaybe<DecisionEngineFeatureMatricesIncInput>;
  _set?: InputMaybe<DecisionEngineFeatureMatricesSetInput>;
  where: DecisionEngineFeatureMatricesBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatricesByPkArgs = {
  _inc?: InputMaybe<DecisionEngineFeatureMatricesIncInput>;
  _set?: InputMaybe<DecisionEngineFeatureMatricesSetInput>;
  pk_columns: DecisionEngineFeatureMatricesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatricesManyArgs = {
  updates: Array<DecisionEngineFeatureMatricesUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatrixRelationshipsArgs = {
  _append?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsIncInput>;
  _prepend?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsPrependInput>;
  _set?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsSetInput>;
  where: DecisionEngineFeatureMatrixRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatrixRelationshipsByPkArgs = {
  _append?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsIncInput>;
  _prepend?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsPrependInput>;
  _set?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsSetInput>;
  pk_columns: DecisionEngineFeatureMatrixRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineFeatureMatrixRelationshipsManyArgs = {
  updates: Array<DecisionEngineFeatureMatrixRelationshipsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowExperimentsArgs = {
  _inc?: InputMaybe<DecisionEngineFlowExperimentsIncInput>;
  _set?: InputMaybe<DecisionEngineFlowExperimentsSetInput>;
  where: DecisionEngineFlowExperimentsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowExperimentsByPkArgs = {
  _inc?: InputMaybe<DecisionEngineFlowExperimentsIncInput>;
  _set?: InputMaybe<DecisionEngineFlowExperimentsSetInput>;
  pk_columns: DecisionEngineFlowExperimentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowExperimentsManyArgs = {
  updates: Array<DecisionEngineFlowExperimentsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowTagsArgs = {
  _append?: InputMaybe<DecisionEngineFlowTagsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFlowTagsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFlowTagsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFlowTagsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineFlowTagsPrependInput>;
  _set?: InputMaybe<DecisionEngineFlowTagsSetInput>;
  where: DecisionEngineFlowTagsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowTagsByPkArgs = {
  _append?: InputMaybe<DecisionEngineFlowTagsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFlowTagsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFlowTagsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFlowTagsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineFlowTagsPrependInput>;
  _set?: InputMaybe<DecisionEngineFlowTagsSetInput>;
  pk_columns: DecisionEngineFlowTagsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowTagsManyArgs = {
  updates: Array<DecisionEngineFlowTagsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowsArgs = {
  _append?: InputMaybe<DecisionEngineFlowsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFlowsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFlowsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFlowsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineFlowsIncInput>;
  _prepend?: InputMaybe<DecisionEngineFlowsPrependInput>;
  _set?: InputMaybe<DecisionEngineFlowsSetInput>;
  where: DecisionEngineFlowsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowsByPkArgs = {
  _append?: InputMaybe<DecisionEngineFlowsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineFlowsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineFlowsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineFlowsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineFlowsIncInput>;
  _prepend?: InputMaybe<DecisionEngineFlowsPrependInput>;
  _set?: InputMaybe<DecisionEngineFlowsSetInput>;
  pk_columns: DecisionEngineFlowsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineFlowsManyArgs = {
  updates: Array<DecisionEngineFlowsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageCollectionsArgs = {
  _inc?: InputMaybe<DecisionEngineMessageCollectionsIncInput>;
  _set?: InputMaybe<DecisionEngineMessageCollectionsSetInput>;
  where: DecisionEngineMessageCollectionsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageCollectionsByPkArgs = {
  _inc?: InputMaybe<DecisionEngineMessageCollectionsIncInput>;
  _set?: InputMaybe<DecisionEngineMessageCollectionsSetInput>;
  pk_columns: DecisionEngineMessageCollectionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageCollectionsManyArgs = {
  updates: Array<DecisionEngineMessageCollectionsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageVariantSuggestionsArgs = {
  _set?: InputMaybe<DecisionEngineMessageVariantSuggestionsSetInput>;
  where: DecisionEngineMessageVariantSuggestionsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageVariantSuggestionsByPkArgs = {
  _set?: InputMaybe<DecisionEngineMessageVariantSuggestionsSetInput>;
  pk_columns: DecisionEngineMessageVariantSuggestionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineMessageVariantSuggestionsManyArgs = {
  updates: Array<DecisionEngineMessageVariantSuggestionsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelOutcomesArgs = {
  _append?: InputMaybe<DecisionEngineModelOutcomesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineModelOutcomesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineModelOutcomesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineModelOutcomesDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineModelOutcomesPrependInput>;
  _set?: InputMaybe<DecisionEngineModelOutcomesSetInput>;
  where: DecisionEngineModelOutcomesBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelOutcomesByPkArgs = {
  _append?: InputMaybe<DecisionEngineModelOutcomesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineModelOutcomesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineModelOutcomesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineModelOutcomesDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineModelOutcomesPrependInput>;
  _set?: InputMaybe<DecisionEngineModelOutcomesSetInput>;
  pk_columns: DecisionEngineModelOutcomesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelOutcomesManyArgs = {
  updates: Array<DecisionEngineModelOutcomesUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelsArgs = {
  _append?: InputMaybe<DecisionEngineModelsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineModelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineModelsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineModelsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineModelsPrependInput>;
  _set?: InputMaybe<DecisionEngineModelsSetInput>;
  where: DecisionEngineModelsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelsByPkArgs = {
  _append?: InputMaybe<DecisionEngineModelsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineModelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineModelsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineModelsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineModelsPrependInput>;
  _set?: InputMaybe<DecisionEngineModelsSetInput>;
  pk_columns: DecisionEngineModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineModelsManyArgs = {
  updates: Array<DecisionEngineModelsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineOffersArgs = {
  _append?: InputMaybe<DecisionEngineOffersAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineOffersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineOffersDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineOffersDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineOffersPrependInput>;
  _set?: InputMaybe<DecisionEngineOffersSetInput>;
  where: DecisionEngineOffersBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineOffersByPkArgs = {
  _append?: InputMaybe<DecisionEngineOffersAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineOffersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineOffersDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineOffersDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineOffersPrependInput>;
  _set?: InputMaybe<DecisionEngineOffersSetInput>;
  pk_columns: DecisionEngineOffersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineOffersManyArgs = {
  updates: Array<DecisionEngineOffersUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineOutcomesArgs = {
  _append?: InputMaybe<DecisionEngineOutcomesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineOutcomesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineOutcomesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineOutcomesDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineOutcomesIncInput>;
  _prepend?: InputMaybe<DecisionEngineOutcomesPrependInput>;
  _set?: InputMaybe<DecisionEngineOutcomesSetInput>;
  where: DecisionEngineOutcomesBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineOutcomesByPkArgs = {
  _append?: InputMaybe<DecisionEngineOutcomesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineOutcomesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineOutcomesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineOutcomesDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineOutcomesIncInput>;
  _prepend?: InputMaybe<DecisionEngineOutcomesPrependInput>;
  _set?: InputMaybe<DecisionEngineOutcomesSetInput>;
  pk_columns: DecisionEngineOutcomesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineOutcomesManyArgs = {
  updates: Array<DecisionEngineOutcomesUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineSendEventsArgs = {
  _append?: InputMaybe<DecisionEngineSendEventsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineSendEventsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineSendEventsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineSendEventsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineSendEventsIncInput>;
  _prepend?: InputMaybe<DecisionEngineSendEventsPrependInput>;
  _set?: InputMaybe<DecisionEngineSendEventsSetInput>;
  where: DecisionEngineSendEventsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineSendEventsByPkArgs = {
  _append?: InputMaybe<DecisionEngineSendEventsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineSendEventsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineSendEventsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineSendEventsDeleteKeyInput>;
  _inc?: InputMaybe<DecisionEngineSendEventsIncInput>;
  _prepend?: InputMaybe<DecisionEngineSendEventsPrependInput>;
  _set?: InputMaybe<DecisionEngineSendEventsSetInput>;
  pk_columns: DecisionEngineSendEventsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineSendEventsManyArgs = {
  updates: Array<DecisionEngineSendEventsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEngineSplitsArgs = {
  _append?: InputMaybe<DecisionEngineSplitsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineSplitsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineSplitsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineSplitsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineSplitsPrependInput>;
  _set?: InputMaybe<DecisionEngineSplitsSetInput>;
  where: DecisionEngineSplitsBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEngineSplitsByPkArgs = {
  _append?: InputMaybe<DecisionEngineSplitsAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEngineSplitsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEngineSplitsDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEngineSplitsDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEngineSplitsPrependInput>;
  _set?: InputMaybe<DecisionEngineSplitsSetInput>;
  pk_columns: DecisionEngineSplitsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEngineSplitsManyArgs = {
  updates: Array<DecisionEngineSplitsUpdates>;
};


/** mutation root */
export type MutationUpdateDecisionEnginesArgs = {
  _append?: InputMaybe<DecisionEnginesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEnginesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEnginesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEnginesDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEnginesPrependInput>;
  _set?: InputMaybe<DecisionEnginesSetInput>;
  where: DecisionEnginesBoolExp;
};


/** mutation root */
export type MutationUpdateDecisionEnginesByPkArgs = {
  _append?: InputMaybe<DecisionEnginesAppendInput>;
  _delete_at_path?: InputMaybe<DecisionEnginesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DecisionEnginesDeleteElemInput>;
  _delete_key?: InputMaybe<DecisionEnginesDeleteKeyInput>;
  _prepend?: InputMaybe<DecisionEnginesPrependInput>;
  _set?: InputMaybe<DecisionEnginesSetInput>;
  pk_columns: DecisionEnginesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDecisionEnginesManyArgs = {
  updates: Array<DecisionEnginesUpdates>;
};


/** mutation root */
export type MutationUpdateDeliverabilityFeedsArgs = {
  _set?: InputMaybe<DeliverabilityFeedsSetInput>;
  where: DeliverabilityFeedsBoolExp;
};


/** mutation root */
export type MutationUpdateDeliverabilityFeedsByPkArgs = {
  _set?: InputMaybe<DeliverabilityFeedsSetInput>;
  pk_columns: DeliverabilityFeedsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDeliverabilityFeedsManyArgs = {
  updates: Array<DeliverabilityFeedsUpdates>;
};


/** mutation root */
export type MutationUpdateDestinationInstanceSplitsArgs = {
  where: DestinationInstanceSplitsBoolExp;
};


/** mutation root */
export type MutationUpdateDestinationInstanceSplitsByPkArgs = {
  pk_columns: DestinationInstanceSplitsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDestinationInstanceSplitsManyArgs = {
  updates: Array<DestinationInstanceSplitsUpdates>;
};


/** mutation root */
export type MutationUpdateDestinationInstancesArgs = {
  _append?: InputMaybe<DestinationInstancesAppendInput>;
  _delete_at_path?: InputMaybe<DestinationInstancesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DestinationInstancesDeleteElemInput>;
  _delete_key?: InputMaybe<DestinationInstancesDeleteKeyInput>;
  _inc?: InputMaybe<DestinationInstancesIncInput>;
  _prepend?: InputMaybe<DestinationInstancesPrependInput>;
  _set?: InputMaybe<DestinationInstancesSetInput>;
  where: DestinationInstancesBoolExp;
};


/** mutation root */
export type MutationUpdateDestinationInstancesByPkArgs = {
  _append?: InputMaybe<DestinationInstancesAppendInput>;
  _delete_at_path?: InputMaybe<DestinationInstancesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DestinationInstancesDeleteElemInput>;
  _delete_key?: InputMaybe<DestinationInstancesDeleteKeyInput>;
  _inc?: InputMaybe<DestinationInstancesIncInput>;
  _prepend?: InputMaybe<DestinationInstancesPrependInput>;
  _set?: InputMaybe<DestinationInstancesSetInput>;
  pk_columns: DestinationInstancesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDestinationInstancesManyArgs = {
  updates: Array<DestinationInstancesUpdates>;
};


/** mutation root */
export type MutationUpdateDestinationRulesArgs = {
  _append?: InputMaybe<DestinationRulesAppendInput>;
  _delete_at_path?: InputMaybe<DestinationRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DestinationRulesDeleteElemInput>;
  _delete_key?: InputMaybe<DestinationRulesDeleteKeyInput>;
  _prepend?: InputMaybe<DestinationRulesPrependInput>;
  _set?: InputMaybe<DestinationRulesSetInput>;
  where: DestinationRulesBoolExp;
};


/** mutation root */
export type MutationUpdateDestinationRulesByPkArgs = {
  _append?: InputMaybe<DestinationRulesAppendInput>;
  _delete_at_path?: InputMaybe<DestinationRulesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DestinationRulesDeleteElemInput>;
  _delete_key?: InputMaybe<DestinationRulesDeleteKeyInput>;
  _prepend?: InputMaybe<DestinationRulesPrependInput>;
  _set?: InputMaybe<DestinationRulesSetInput>;
  pk_columns: DestinationRulesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDestinationRulesManyArgs = {
  updates: Array<DestinationRulesUpdates>;
};


/** mutation root */
export type MutationUpdateDirectModelRelationshipsArgs = {
  _inc?: InputMaybe<DirectModelRelationshipsIncInput>;
  _set?: InputMaybe<DirectModelRelationshipsSetInput>;
  where: DirectModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateDirectModelRelationshipsByPkArgs = {
  _inc?: InputMaybe<DirectModelRelationshipsIncInput>;
  _set?: InputMaybe<DirectModelRelationshipsSetInput>;
  pk_columns: DirectModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateDirectModelRelationshipsManyArgs = {
  updates: Array<DirectModelRelationshipsUpdates>;
};


/** mutation root */
export type MutationUpdateEtlConnectionsArgs = {
  _append?: InputMaybe<EtlConnectionsAppendInput>;
  _delete_at_path?: InputMaybe<EtlConnectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EtlConnectionsDeleteElemInput>;
  _delete_key?: InputMaybe<EtlConnectionsDeleteKeyInput>;
  _inc?: InputMaybe<EtlConnectionsIncInput>;
  _prepend?: InputMaybe<EtlConnectionsPrependInput>;
  _set?: InputMaybe<EtlConnectionsSetInput>;
  where: EtlConnectionsBoolExp;
};


/** mutation root */
export type MutationUpdateEtlConnectionsByPkArgs = {
  _append?: InputMaybe<EtlConnectionsAppendInput>;
  _delete_at_path?: InputMaybe<EtlConnectionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EtlConnectionsDeleteElemInput>;
  _delete_key?: InputMaybe<EtlConnectionsDeleteKeyInput>;
  _inc?: InputMaybe<EtlConnectionsIncInput>;
  _prepend?: InputMaybe<EtlConnectionsPrependInput>;
  _set?: InputMaybe<EtlConnectionsSetInput>;
  pk_columns: EtlConnectionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEtlConnectionsManyArgs = {
  updates: Array<EtlConnectionsUpdates>;
};


/** mutation root */
export type MutationUpdateEventComponentsArgs = {
  _append?: InputMaybe<EventComponentsAppendInput>;
  _delete_at_path?: InputMaybe<EventComponentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventComponentsDeleteElemInput>;
  _delete_key?: InputMaybe<EventComponentsDeleteKeyInput>;
  _prepend?: InputMaybe<EventComponentsPrependInput>;
  _set?: InputMaybe<EventComponentsSetInput>;
  where: EventComponentsBoolExp;
};


/** mutation root */
export type MutationUpdateEventComponentsByPkArgs = {
  _append?: InputMaybe<EventComponentsAppendInput>;
  _delete_at_path?: InputMaybe<EventComponentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventComponentsDeleteElemInput>;
  _delete_key?: InputMaybe<EventComponentsDeleteKeyInput>;
  _prepend?: InputMaybe<EventComponentsPrependInput>;
  _set?: InputMaybe<EventComponentsSetInput>;
  pk_columns: EventComponentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventComponentsManyArgs = {
  updates: Array<EventComponentsUpdates>;
};


/** mutation root */
export type MutationUpdateEventContractsArgs = {
  _set?: InputMaybe<EventContractsSetInput>;
  where: EventContractsBoolExp;
};


/** mutation root */
export type MutationUpdateEventContractsByPkArgs = {
  _set?: InputMaybe<EventContractsSetInput>;
  pk_columns: EventContractsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventContractsManyArgs = {
  updates: Array<EventContractsUpdates>;
};


/** mutation root */
export type MutationUpdateEventContractsSchemaArgs = {
  _set?: InputMaybe<EventContractsSchemaSetInput>;
  where: EventContractsSchemaBoolExp;
};


/** mutation root */
export type MutationUpdateEventContractsSchemaByPkArgs = {
  _set?: InputMaybe<EventContractsSchemaSetInput>;
  pk_columns: EventContractsSchemaPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventContractsSchemaManyArgs = {
  updates: Array<EventContractsSchemaUpdates>;
};


/** mutation root */
export type MutationUpdateEventForwardingDestinationGrantsArgs = {
  _set?: InputMaybe<EventForwardingDestinationGrantsSetInput>;
  where: EventForwardingDestinationGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateEventForwardingDestinationGrantsByPkArgs = {
  _set?: InputMaybe<EventForwardingDestinationGrantsSetInput>;
  pk_columns: EventForwardingDestinationGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventForwardingDestinationGrantsManyArgs = {
  updates: Array<EventForwardingDestinationGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateEventForwardingSyncsArgs = {
  _append?: InputMaybe<EventForwardingSyncsAppendInput>;
  _delete_at_path?: InputMaybe<EventForwardingSyncsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventForwardingSyncsDeleteElemInput>;
  _delete_key?: InputMaybe<EventForwardingSyncsDeleteKeyInput>;
  _inc?: InputMaybe<EventForwardingSyncsIncInput>;
  _prepend?: InputMaybe<EventForwardingSyncsPrependInput>;
  _set?: InputMaybe<EventForwardingSyncsSetInput>;
  where: EventForwardingSyncsBoolExp;
};


/** mutation root */
export type MutationUpdateEventForwardingSyncsByPkArgs = {
  _append?: InputMaybe<EventForwardingSyncsAppendInput>;
  _delete_at_path?: InputMaybe<EventForwardingSyncsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventForwardingSyncsDeleteElemInput>;
  _delete_key?: InputMaybe<EventForwardingSyncsDeleteKeyInput>;
  _inc?: InputMaybe<EventForwardingSyncsIncInput>;
  _prepend?: InputMaybe<EventForwardingSyncsPrependInput>;
  _set?: InputMaybe<EventForwardingSyncsSetInput>;
  pk_columns: EventForwardingSyncsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventForwardingSyncsManyArgs = {
  updates: Array<EventForwardingSyncsUpdates>;
};


/** mutation root */
export type MutationUpdateEventModelsArgs = {
  _append?: InputMaybe<EventModelsAppendInput>;
  _delete_at_path?: InputMaybe<EventModelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventModelsDeleteElemInput>;
  _delete_key?: InputMaybe<EventModelsDeleteKeyInput>;
  _prepend?: InputMaybe<EventModelsPrependInput>;
  _set?: InputMaybe<EventModelsSetInput>;
  where: EventModelsBoolExp;
};


/** mutation root */
export type MutationUpdateEventModelsByPkArgs = {
  _append?: InputMaybe<EventModelsAppendInput>;
  _delete_at_path?: InputMaybe<EventModelsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventModelsDeleteElemInput>;
  _delete_key?: InputMaybe<EventModelsDeleteKeyInput>;
  _prepend?: InputMaybe<EventModelsPrependInput>;
  _set?: InputMaybe<EventModelsSetInput>;
  pk_columns: EventModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventModelsManyArgs = {
  updates: Array<EventModelsUpdates>;
};


/** mutation root */
export type MutationUpdateEventPlanGrantsArgs = {
  _set?: InputMaybe<EventPlanGrantsSetInput>;
  where: EventPlanGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateEventPlanGrantsByPkArgs = {
  _set?: InputMaybe<EventPlanGrantsSetInput>;
  pk_columns: EventPlanGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventPlanGrantsManyArgs = {
  updates: Array<EventPlanGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateEventPlansArgs = {
  _append?: InputMaybe<EventPlansAppendInput>;
  _delete_at_path?: InputMaybe<EventPlansDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventPlansDeleteElemInput>;
  _delete_key?: InputMaybe<EventPlansDeleteKeyInput>;
  _prepend?: InputMaybe<EventPlansPrependInput>;
  _set?: InputMaybe<EventPlansSetInput>;
  where: EventPlansBoolExp;
};


/** mutation root */
export type MutationUpdateEventPlansByPkArgs = {
  _append?: InputMaybe<EventPlansAppendInput>;
  _delete_at_path?: InputMaybe<EventPlansDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventPlansDeleteElemInput>;
  _delete_key?: InputMaybe<EventPlansDeleteKeyInput>;
  _prepend?: InputMaybe<EventPlansPrependInput>;
  _set?: InputMaybe<EventPlansSetInput>;
  pk_columns: EventPlansPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventPlansManyArgs = {
  updates: Array<EventPlansUpdates>;
};


/** mutation root */
export type MutationUpdateEventSchemasArgs = {
  _append?: InputMaybe<EventSchemasAppendInput>;
  _delete_at_path?: InputMaybe<EventSchemasDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventSchemasDeleteElemInput>;
  _delete_key?: InputMaybe<EventSchemasDeleteKeyInput>;
  _prepend?: InputMaybe<EventSchemasPrependInput>;
  _set?: InputMaybe<EventSchemasSetInput>;
  where: EventSchemasBoolExp;
};


/** mutation root */
export type MutationUpdateEventSchemasByPkArgs = {
  _append?: InputMaybe<EventSchemasAppendInput>;
  _delete_at_path?: InputMaybe<EventSchemasDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventSchemasDeleteElemInput>;
  _delete_key?: InputMaybe<EventSchemasDeleteKeyInput>;
  _prepend?: InputMaybe<EventSchemasPrependInput>;
  _set?: InputMaybe<EventSchemasSetInput>;
  pk_columns: EventSchemasPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventSchemasManyArgs = {
  updates: Array<EventSchemasUpdates>;
};


/** mutation root */
export type MutationUpdateEventSourceContractsArgs = {
  _set?: InputMaybe<EventSourceContractsSetInput>;
  where: EventSourceContractsBoolExp;
};


/** mutation root */
export type MutationUpdateEventSourceContractsByPkArgs = {
  _set?: InputMaybe<EventSourceContractsSetInput>;
  pk_columns: EventSourceContractsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventSourceContractsManyArgs = {
  updates: Array<EventSourceContractsUpdates>;
};


/** mutation root */
export type MutationUpdateEventSourceGrantsArgs = {
  _set?: InputMaybe<EventSourceGrantsSetInput>;
  where: EventSourceGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateEventSourceGrantsByPkArgs = {
  _set?: InputMaybe<EventSourceGrantsSetInput>;
  pk_columns: EventSourceGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventSourceGrantsManyArgs = {
  updates: Array<EventSourceGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationGrantsArgs = {
  _set?: InputMaybe<EventWarehouseDestinationGrantsSetInput>;
  where: EventWarehouseDestinationGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationGrantsByPkArgs = {
  _set?: InputMaybe<EventWarehouseDestinationGrantsSetInput>;
  pk_columns: EventWarehouseDestinationGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationGrantsManyArgs = {
  updates: Array<EventWarehouseDestinationGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationsArgs = {
  _append?: InputMaybe<EventWarehouseDestinationsAppendInput>;
  _delete_at_path?: InputMaybe<EventWarehouseDestinationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventWarehouseDestinationsDeleteElemInput>;
  _delete_key?: InputMaybe<EventWarehouseDestinationsDeleteKeyInput>;
  _inc?: InputMaybe<EventWarehouseDestinationsIncInput>;
  _prepend?: InputMaybe<EventWarehouseDestinationsPrependInput>;
  _set?: InputMaybe<EventWarehouseDestinationsSetInput>;
  where: EventWarehouseDestinationsBoolExp;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationsByPkArgs = {
  _append?: InputMaybe<EventWarehouseDestinationsAppendInput>;
  _delete_at_path?: InputMaybe<EventWarehouseDestinationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<EventWarehouseDestinationsDeleteElemInput>;
  _delete_key?: InputMaybe<EventWarehouseDestinationsDeleteKeyInput>;
  _inc?: InputMaybe<EventWarehouseDestinationsIncInput>;
  _prepend?: InputMaybe<EventWarehouseDestinationsPrependInput>;
  _set?: InputMaybe<EventWarehouseDestinationsSetInput>;
  pk_columns: EventWarehouseDestinationsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventWarehouseDestinationsManyArgs = {
  updates: Array<EventWarehouseDestinationsUpdates>;
};


/** mutation root */
export type MutationUpdateEventWarehouseSyncsArgs = {
  _set?: InputMaybe<EventWarehouseSyncsSetInput>;
  where: EventWarehouseSyncsBoolExp;
};


/** mutation root */
export type MutationUpdateEventWarehouseSyncsByPkArgs = {
  _set?: InputMaybe<EventWarehouseSyncsSetInput>;
  pk_columns: EventWarehouseSyncsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateEventWarehouseSyncsManyArgs = {
  updates: Array<EventWarehouseSyncsUpdates>;
};


/** mutation root */
export type MutationUpdateExperimentMetricsArgs = {
  _append?: InputMaybe<ExperimentMetricsAppendInput>;
  _delete_at_path?: InputMaybe<ExperimentMetricsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExperimentMetricsDeleteElemInput>;
  _delete_key?: InputMaybe<ExperimentMetricsDeleteKeyInput>;
  _prepend?: InputMaybe<ExperimentMetricsPrependInput>;
  _set?: InputMaybe<ExperimentMetricsSetInput>;
  where: ExperimentMetricsBoolExp;
};


/** mutation root */
export type MutationUpdateExperimentMetricsByPkArgs = {
  _append?: InputMaybe<ExperimentMetricsAppendInput>;
  _delete_at_path?: InputMaybe<ExperimentMetricsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExperimentMetricsDeleteElemInput>;
  _delete_key?: InputMaybe<ExperimentMetricsDeleteKeyInput>;
  _prepend?: InputMaybe<ExperimentMetricsPrependInput>;
  _set?: InputMaybe<ExperimentMetricsSetInput>;
  pk_columns: ExperimentMetricsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateExperimentMetricsManyArgs = {
  updates: Array<ExperimentMetricsUpdates>;
};


/** mutation root */
export type MutationUpdateExperimentsArgs = {
  _append?: InputMaybe<ExperimentsAppendInput>;
  _delete_at_path?: InputMaybe<ExperimentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExperimentsDeleteElemInput>;
  _delete_key?: InputMaybe<ExperimentsDeleteKeyInput>;
  _prepend?: InputMaybe<ExperimentsPrependInput>;
  _set?: InputMaybe<ExperimentsSetInput>;
  where: ExperimentsBoolExp;
};


/** mutation root */
export type MutationUpdateExperimentsByPkArgs = {
  _append?: InputMaybe<ExperimentsAppendInput>;
  _delete_at_path?: InputMaybe<ExperimentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExperimentsDeleteElemInput>;
  _delete_key?: InputMaybe<ExperimentsDeleteKeyInput>;
  _prepend?: InputMaybe<ExperimentsPrependInput>;
  _set?: InputMaybe<ExperimentsSetInput>;
  pk_columns: ExperimentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateExperimentsManyArgs = {
  updates: Array<ExperimentsUpdates>;
};


/** mutation root */
export type MutationUpdateExternalBucketsArgs = {
  _append?: InputMaybe<ExternalBucketsAppendInput>;
  _delete_at_path?: InputMaybe<ExternalBucketsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExternalBucketsDeleteElemInput>;
  _delete_key?: InputMaybe<ExternalBucketsDeleteKeyInput>;
  _inc?: InputMaybe<ExternalBucketsIncInput>;
  _prepend?: InputMaybe<ExternalBucketsPrependInput>;
  _set?: InputMaybe<ExternalBucketsSetInput>;
  where: ExternalBucketsBoolExp;
};


/** mutation root */
export type MutationUpdateExternalBucketsByPkArgs = {
  _append?: InputMaybe<ExternalBucketsAppendInput>;
  _delete_at_path?: InputMaybe<ExternalBucketsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ExternalBucketsDeleteElemInput>;
  _delete_key?: InputMaybe<ExternalBucketsDeleteKeyInput>;
  _inc?: InputMaybe<ExternalBucketsIncInput>;
  _prepend?: InputMaybe<ExternalBucketsPrependInput>;
  _set?: InputMaybe<ExternalBucketsSetInput>;
  pk_columns: ExternalBucketsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateExternalBucketsManyArgs = {
  updates: Array<ExternalBucketsUpdates>;
};


/** mutation root */
export type MutationUpdateFigmaImportDraftsArgs = {
  _set?: InputMaybe<FigmaImportDraftsSetInput>;
  where: FigmaImportDraftsBoolExp;
};


/** mutation root */
export type MutationUpdateFigmaImportDraftsByPkArgs = {
  _set?: InputMaybe<FigmaImportDraftsSetInput>;
  pk_columns: FigmaImportDraftsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFigmaImportDraftsManyArgs = {
  updates: Array<FigmaImportDraftsUpdates>;
};


/** mutation root */
export type MutationUpdateFivetranAgentSyncsArgs = {
  _set?: InputMaybe<FivetranAgentSyncsSetInput>;
  where: FivetranAgentSyncsBoolExp;
};


/** mutation root */
export type MutationUpdateFivetranAgentSyncsByPkArgs = {
  _set?: InputMaybe<FivetranAgentSyncsSetInput>;
  pk_columns: FivetranAgentSyncsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFivetranAgentSyncsManyArgs = {
  updates: Array<FivetranAgentSyncsUpdates>;
};


/** mutation root */
export type MutationUpdateFivetranCredentialsArgs = {
  _append?: InputMaybe<FivetranCredentialsAppendInput>;
  _delete_at_path?: InputMaybe<FivetranCredentialsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<FivetranCredentialsDeleteElemInput>;
  _delete_key?: InputMaybe<FivetranCredentialsDeleteKeyInput>;
  _prepend?: InputMaybe<FivetranCredentialsPrependInput>;
  _set?: InputMaybe<FivetranCredentialsSetInput>;
  where: FivetranCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateFivetranCredentialsByPkArgs = {
  _append?: InputMaybe<FivetranCredentialsAppendInput>;
  _delete_at_path?: InputMaybe<FivetranCredentialsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<FivetranCredentialsDeleteElemInput>;
  _delete_key?: InputMaybe<FivetranCredentialsDeleteKeyInput>;
  _prepend?: InputMaybe<FivetranCredentialsPrependInput>;
  _set?: InputMaybe<FivetranCredentialsSetInput>;
  pk_columns: FivetranCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFivetranCredentialsManyArgs = {
  updates: Array<FivetranCredentialsUpdates>;
};


/** mutation root */
export type MutationUpdateFoldersArgs = {
  _set?: InputMaybe<FoldersSetInput>;
  where: FoldersBoolExp;
};


/** mutation root */
export type MutationUpdateFoldersByPkArgs = {
  _set?: InputMaybe<FoldersSetInput>;
  pk_columns: FoldersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFoldersManyArgs = {
  updates: Array<FoldersUpdates>;
};


/** mutation root */
export type MutationUpdateFunctionGrantsArgs = {
  _set?: InputMaybe<FunctionGrantsSetInput>;
  where: FunctionGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateFunctionGrantsByPkArgs = {
  _set?: InputMaybe<FunctionGrantsSetInput>;
  pk_columns: FunctionGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFunctionGrantsManyArgs = {
  updates: Array<FunctionGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateFunctionResourcesArgs = {
  _set?: InputMaybe<FunctionResourcesSetInput>;
  where: FunctionResourcesBoolExp;
};


/** mutation root */
export type MutationUpdateFunctionResourcesByPkArgs = {
  _set?: InputMaybe<FunctionResourcesSetInput>;
  pk_columns: FunctionResourcesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFunctionResourcesManyArgs = {
  updates: Array<FunctionResourcesUpdates>;
};


/** mutation root */
export type MutationUpdateFunctionSettingsArgs = {
  _set?: InputMaybe<FunctionSettingsSetInput>;
  where: FunctionSettingsBoolExp;
};


/** mutation root */
export type MutationUpdateFunctionSettingsByPkArgs = {
  _set?: InputMaybe<FunctionSettingsSetInput>;
  pk_columns: FunctionSettingsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFunctionSettingsManyArgs = {
  updates: Array<FunctionSettingsUpdates>;
};


/** mutation root */
export type MutationUpdateFunctionsArgs = {
  _set?: InputMaybe<FunctionsSetInput>;
  where: FunctionsBoolExp;
};


/** mutation root */
export type MutationUpdateFunctionsByPkArgs = {
  _set?: InputMaybe<FunctionsSetInput>;
  pk_columns: FunctionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateFunctionsManyArgs = {
  updates: Array<FunctionsUpdates>;
};


/** mutation root */
export type MutationUpdateGitSyncConfigsArgs = {
  _inc?: InputMaybe<GitSyncConfigsIncInput>;
  _set?: InputMaybe<GitSyncConfigsSetInput>;
  where: GitSyncConfigsBoolExp;
};


/** mutation root */
export type MutationUpdateGitSyncConfigsByPkArgs = {
  _inc?: InputMaybe<GitSyncConfigsIncInput>;
  _set?: InputMaybe<GitSyncConfigsSetInput>;
  pk_columns: GitSyncConfigsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGitSyncConfigsManyArgs = {
  updates: Array<GitSyncConfigsUpdates>;
};


/** mutation root */
export type MutationUpdateGoalsArgs = {
  _append?: InputMaybe<GoalsAppendInput>;
  _delete_at_path?: InputMaybe<GoalsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GoalsDeleteElemInput>;
  _delete_key?: InputMaybe<GoalsDeleteKeyInput>;
  _inc?: InputMaybe<GoalsIncInput>;
  _prepend?: InputMaybe<GoalsPrependInput>;
  _set?: InputMaybe<GoalsSetInput>;
  where: GoalsBoolExp;
};


/** mutation root */
export type MutationUpdateGoalsAttributionMethodsArgs = {
  _set?: InputMaybe<GoalsAttributionMethodsSetInput>;
  where: GoalsAttributionMethodsBoolExp;
};


/** mutation root */
export type MutationUpdateGoalsAttributionMethodsByPkArgs = {
  _set?: InputMaybe<GoalsAttributionMethodsSetInput>;
  pk_columns: GoalsAttributionMethodsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGoalsAttributionMethodsManyArgs = {
  updates: Array<GoalsAttributionMethodsUpdates>;
};


/** mutation root */
export type MutationUpdateGoalsByPkArgs = {
  _append?: InputMaybe<GoalsAppendInput>;
  _delete_at_path?: InputMaybe<GoalsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<GoalsDeleteElemInput>;
  _delete_key?: InputMaybe<GoalsDeleteKeyInput>;
  _inc?: InputMaybe<GoalsIncInput>;
  _prepend?: InputMaybe<GoalsPrependInput>;
  _set?: InputMaybe<GoalsSetInput>;
  pk_columns: GoalsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateGoalsManyArgs = {
  updates: Array<GoalsUpdates>;
};


/** mutation root */
export type MutationUpdateInitiativeGoalsArgs = {
  _set?: InputMaybe<InitiativeGoalsSetInput>;
  where: InitiativeGoalsBoolExp;
};


/** mutation root */
export type MutationUpdateInitiativeGoalsByPkArgs = {
  _set?: InputMaybe<InitiativeGoalsSetInput>;
  pk_columns: InitiativeGoalsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateInitiativeGoalsManyArgs = {
  updates: Array<InitiativeGoalsUpdates>;
};


/** mutation root */
export type MutationUpdateInitiativeInsightsArgs = {
  _set?: InputMaybe<InitiativeInsightsSetInput>;
  where: InitiativeInsightsBoolExp;
};


/** mutation root */
export type MutationUpdateInitiativeInsightsByPkArgs = {
  _set?: InputMaybe<InitiativeInsightsSetInput>;
  pk_columns: InitiativeInsightsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateInitiativeInsightsManyArgs = {
  updates: Array<InitiativeInsightsUpdates>;
};


/** mutation root */
export type MutationUpdateInteractionModelsArgs = {
  _inc?: InputMaybe<InteractionModelsIncInput>;
  _set?: InputMaybe<InteractionModelsSetInput>;
  where: InteractionModelsBoolExp;
};


/** mutation root */
export type MutationUpdateInteractionModelsByPkArgs = {
  _inc?: InputMaybe<InteractionModelsIncInput>;
  _set?: InputMaybe<InteractionModelsSetInput>;
  pk_columns: InteractionModelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateInteractionModelsManyArgs = {
  updates: Array<InteractionModelsUpdates>;
};


/** mutation root */
export type MutationUpdateJourneysArgs = {
  _set?: InputMaybe<JourneysSetInput>;
  where: JourneysBoolExp;
};


/** mutation root */
export type MutationUpdateJourneysByPkArgs = {
  _set?: InputMaybe<JourneysSetInput>;
  pk_columns: JourneysPkColumnsInput;
};


/** mutation root */
export type MutationUpdateJourneysManyArgs = {
  updates: Array<JourneysUpdates>;
};


/** mutation root */
export type MutationUpdateLabelGroupsArgs = {
  _set?: InputMaybe<LabelGroupsSetInput>;
  where: LabelGroupsBoolExp;
};


/** mutation root */
export type MutationUpdateLabelGroupsByPkArgs = {
  _set?: InputMaybe<LabelGroupsSetInput>;
  pk_columns: LabelGroupsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLabelGroupsManyArgs = {
  updates: Array<LabelGroupsUpdates>;
};


/** mutation root */
export type MutationUpdateLabelsArgs = {
  _set?: InputMaybe<LabelsSetInput>;
  where: LabelsBoolExp;
};


/** mutation root */
export type MutationUpdateLabelsByPkArgs = {
  _set?: InputMaybe<LabelsSetInput>;
  pk_columns: LabelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLabelsManyArgs = {
  updates: Array<LabelsUpdates>;
};


/** mutation root */
export type MutationUpdateLcmMessageCandidatesArgs = {
  _append?: InputMaybe<LcmMessageCandidatesAppendInput>;
  _delete_at_path?: InputMaybe<LcmMessageCandidatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LcmMessageCandidatesDeleteElemInput>;
  _delete_key?: InputMaybe<LcmMessageCandidatesDeleteKeyInput>;
  _inc?: InputMaybe<LcmMessageCandidatesIncInput>;
  _prepend?: InputMaybe<LcmMessageCandidatesPrependInput>;
  _set?: InputMaybe<LcmMessageCandidatesSetInput>;
  where: LcmMessageCandidatesBoolExp;
};


/** mutation root */
export type MutationUpdateLcmMessageCandidatesByPkArgs = {
  _append?: InputMaybe<LcmMessageCandidatesAppendInput>;
  _delete_at_path?: InputMaybe<LcmMessageCandidatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LcmMessageCandidatesDeleteElemInput>;
  _delete_key?: InputMaybe<LcmMessageCandidatesDeleteKeyInput>;
  _inc?: InputMaybe<LcmMessageCandidatesIncInput>;
  _prepend?: InputMaybe<LcmMessageCandidatesPrependInput>;
  _set?: InputMaybe<LcmMessageCandidatesSetInput>;
  pk_columns: LcmMessageCandidatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLcmMessageCandidatesManyArgs = {
  updates: Array<LcmMessageCandidatesUpdates>;
};


/** mutation root */
export type MutationUpdateLcmMessagePlansArgs = {
  _append?: InputMaybe<LcmMessagePlansAppendInput>;
  _delete_at_path?: InputMaybe<LcmMessagePlansDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LcmMessagePlansDeleteElemInput>;
  _delete_key?: InputMaybe<LcmMessagePlansDeleteKeyInput>;
  _inc?: InputMaybe<LcmMessagePlansIncInput>;
  _prepend?: InputMaybe<LcmMessagePlansPrependInput>;
  _set?: InputMaybe<LcmMessagePlansSetInput>;
  where: LcmMessagePlansBoolExp;
};


/** mutation root */
export type MutationUpdateLcmMessagePlansByPkArgs = {
  _append?: InputMaybe<LcmMessagePlansAppendInput>;
  _delete_at_path?: InputMaybe<LcmMessagePlansDeleteAtPathInput>;
  _delete_elem?: InputMaybe<LcmMessagePlansDeleteElemInput>;
  _delete_key?: InputMaybe<LcmMessagePlansDeleteKeyInput>;
  _inc?: InputMaybe<LcmMessagePlansIncInput>;
  _prepend?: InputMaybe<LcmMessagePlansPrependInput>;
  _set?: InputMaybe<LcmMessagePlansSetInput>;
  pk_columns: LcmMessagePlansPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLcmMessagePlansManyArgs = {
  updates: Array<LcmMessagePlansUpdates>;
};


/** mutation root */
export type MutationUpdateLlmChatMessagesArgs = {
  _set?: InputMaybe<LlmChatMessagesSetInput>;
  where: LlmChatMessagesBoolExp;
};


/** mutation root */
export type MutationUpdateLlmChatMessagesByPkArgs = {
  _set?: InputMaybe<LlmChatMessagesSetInput>;
  pk_columns: LlmChatMessagesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLlmChatMessagesManyArgs = {
  updates: Array<LlmChatMessagesUpdates>;
};


/** mutation root */
export type MutationUpdateLlmChatSessionsArgs = {
  _set?: InputMaybe<LlmChatSessionsSetInput>;
  where: LlmChatSessionsBoolExp;
};


/** mutation root */
export type MutationUpdateLlmChatSessionsByPkArgs = {
  _set?: InputMaybe<LlmChatSessionsSetInput>;
  pk_columns: LlmChatSessionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLlmChatSessionsManyArgs = {
  updates: Array<LlmChatSessionsUpdates>;
};


/** mutation root */
export type MutationUpdateLookerCredentialsArgs = {
  _set?: InputMaybe<LookerCredentialsSetInput>;
  where: LookerCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateLookerCredentialsByPkArgs = {
  _set?: InputMaybe<LookerCredentialsSetInput>;
  pk_columns: LookerCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateLookerCredentialsManyArgs = {
  updates: Array<LookerCredentialsUpdates>;
};


/** mutation root */
export type MutationUpdateMarketingCampaignsArgs = {
  _set?: InputMaybe<MarketingCampaignsSetInput>;
  where: MarketingCampaignsBoolExp;
};


/** mutation root */
export type MutationUpdateMarketingCampaignsByPkArgs = {
  _set?: InputMaybe<MarketingCampaignsSetInput>;
  pk_columns: MarketingCampaignsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMarketingCampaignsManyArgs = {
  updates: Array<MarketingCampaignsUpdates>;
};


/** mutation root */
export type MutationUpdateMatchboostingConfigArgs = {
  _append?: InputMaybe<MatchboostingConfigAppendInput>;
  _delete_at_path?: InputMaybe<MatchboostingConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MatchboostingConfigDeleteElemInput>;
  _delete_key?: InputMaybe<MatchboostingConfigDeleteKeyInput>;
  _prepend?: InputMaybe<MatchboostingConfigPrependInput>;
  _set?: InputMaybe<MatchboostingConfigSetInput>;
  where: MatchboostingConfigBoolExp;
};


/** mutation root */
export type MutationUpdateMatchboostingConfigByPkArgs = {
  _append?: InputMaybe<MatchboostingConfigAppendInput>;
  _delete_at_path?: InputMaybe<MatchboostingConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MatchboostingConfigDeleteElemInput>;
  _delete_key?: InputMaybe<MatchboostingConfigDeleteKeyInput>;
  _prepend?: InputMaybe<MatchboostingConfigPrependInput>;
  _set?: InputMaybe<MatchboostingConfigSetInput>;
  pk_columns: MatchboostingConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMatchboostingConfigManyArgs = {
  updates: Array<MatchboostingConfigUpdates>;
};


/** mutation root */
export type MutationUpdateMatchboostingWorkspaceConfigArgs = {
  _set?: InputMaybe<MatchboostingWorkspaceConfigSetInput>;
  where: MatchboostingWorkspaceConfigBoolExp;
};


/** mutation root */
export type MutationUpdateMatchboostingWorkspaceConfigByPkArgs = {
  _set?: InputMaybe<MatchboostingWorkspaceConfigSetInput>;
  pk_columns: MatchboostingWorkspaceConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMatchboostingWorkspaceConfigManyArgs = {
  updates: Array<MatchboostingWorkspaceConfigUpdates>;
};


/** mutation root */
export type MutationUpdateMessageContentsArgs = {
  _append?: InputMaybe<MessageContentsAppendInput>;
  _delete_at_path?: InputMaybe<MessageContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessageContentsDeleteElemInput>;
  _delete_key?: InputMaybe<MessageContentsDeleteKeyInput>;
  _prepend?: InputMaybe<MessageContentsPrependInput>;
  _set?: InputMaybe<MessageContentsSetInput>;
  where: MessageContentsBoolExp;
};


/** mutation root */
export type MutationUpdateMessageContentsByPkArgs = {
  _append?: InputMaybe<MessageContentsAppendInput>;
  _delete_at_path?: InputMaybe<MessageContentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessageContentsDeleteElemInput>;
  _delete_key?: InputMaybe<MessageContentsDeleteKeyInput>;
  _prepend?: InputMaybe<MessageContentsPrependInput>;
  _set?: InputMaybe<MessageContentsSetInput>;
  pk_columns: MessageContentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMessageContentsManyArgs = {
  updates: Array<MessageContentsUpdates>;
};


/** mutation root */
export type MutationUpdateMessageContentsMetadataArgs = {
  _append?: InputMaybe<MessageContentsMetadataAppendInput>;
  _delete_at_path?: InputMaybe<MessageContentsMetadataDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessageContentsMetadataDeleteElemInput>;
  _delete_key?: InputMaybe<MessageContentsMetadataDeleteKeyInput>;
  _prepend?: InputMaybe<MessageContentsMetadataPrependInput>;
  _set?: InputMaybe<MessageContentsMetadataSetInput>;
  where: MessageContentsMetadataBoolExp;
};


/** mutation root */
export type MutationUpdateMessageContentsMetadataByPkArgs = {
  _append?: InputMaybe<MessageContentsMetadataAppendInput>;
  _delete_at_path?: InputMaybe<MessageContentsMetadataDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessageContentsMetadataDeleteElemInput>;
  _delete_key?: InputMaybe<MessageContentsMetadataDeleteKeyInput>;
  _prepend?: InputMaybe<MessageContentsMetadataPrependInput>;
  _set?: InputMaybe<MessageContentsMetadataSetInput>;
  pk_columns: MessageContentsMetadataPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMessageContentsMetadataManyArgs = {
  updates: Array<MessageContentsMetadataUpdates>;
};


/** mutation root */
export type MutationUpdateMessageExperimentsArgs = {
  _set?: InputMaybe<MessageExperimentsSetInput>;
  where: MessageExperimentsBoolExp;
};


/** mutation root */
export type MutationUpdateMessageExperimentsByPkArgs = {
  _set?: InputMaybe<MessageExperimentsSetInput>;
  pk_columns: MessageExperimentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMessageExperimentsManyArgs = {
  updates: Array<MessageExperimentsUpdates>;
};


/** mutation root */
export type MutationUpdateMessageVariantArmArgs = {
  _inc?: InputMaybe<MessageVariantArmIncInput>;
  _set?: InputMaybe<MessageVariantArmSetInput>;
  where: MessageVariantArmBoolExp;
};


/** mutation root */
export type MutationUpdateMessageVariantArmByPkArgs = {
  _inc?: InputMaybe<MessageVariantArmIncInput>;
  _set?: InputMaybe<MessageVariantArmSetInput>;
  pk_columns: MessageVariantArmPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMessageVariantArmManyArgs = {
  updates: Array<MessageVariantArmUpdates>;
};


/** mutation root */
export type MutationUpdateMessagesArgs = {
  _append?: InputMaybe<MessagesAppendInput>;
  _delete_at_path?: InputMaybe<MessagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessagesDeleteElemInput>;
  _delete_key?: InputMaybe<MessagesDeleteKeyInput>;
  _inc?: InputMaybe<MessagesIncInput>;
  _prepend?: InputMaybe<MessagesPrependInput>;
  _set?: InputMaybe<MessagesSetInput>;
  where: MessagesBoolExp;
};


/** mutation root */
export type MutationUpdateMessagesByPkArgs = {
  _append?: InputMaybe<MessagesAppendInput>;
  _delete_at_path?: InputMaybe<MessagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MessagesDeleteElemInput>;
  _delete_key?: InputMaybe<MessagesDeleteKeyInput>;
  _inc?: InputMaybe<MessagesIncInput>;
  _prepend?: InputMaybe<MessagesPrependInput>;
  _set?: InputMaybe<MessagesSetInput>;
  pk_columns: MessagesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMessagesManyArgs = {
  updates: Array<MessagesUpdates>;
};


/** mutation root */
export type MutationUpdateModelColumnsArgs = {
  _append?: InputMaybe<ModelColumnsAppendInput>;
  _delete_at_path?: InputMaybe<ModelColumnsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ModelColumnsDeleteElemInput>;
  _delete_key?: InputMaybe<ModelColumnsDeleteKeyInput>;
  _inc?: InputMaybe<ModelColumnsIncInput>;
  _prepend?: InputMaybe<ModelColumnsPrependInput>;
  _set?: InputMaybe<ModelColumnsSetInput>;
  where: ModelColumnsBoolExp;
};


/** mutation root */
export type MutationUpdateModelColumnsByPkArgs = {
  _append?: InputMaybe<ModelColumnsAppendInput>;
  _delete_at_path?: InputMaybe<ModelColumnsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ModelColumnsDeleteElemInput>;
  _delete_key?: InputMaybe<ModelColumnsDeleteKeyInput>;
  _inc?: InputMaybe<ModelColumnsIncInput>;
  _prepend?: InputMaybe<ModelColumnsPrependInput>;
  _set?: InputMaybe<ModelColumnsSetInput>;
  pk_columns: ModelColumnsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateModelColumnsManyArgs = {
  updates: Array<ModelColumnsUpdates>;
};


/** mutation root */
export type MutationUpdateModelRelationshipsArgs = {
  _inc?: InputMaybe<ModelRelationshipsIncInput>;
  _set?: InputMaybe<ModelRelationshipsSetInput>;
  where: ModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateModelRelationshipsByPkArgs = {
  _inc?: InputMaybe<ModelRelationshipsIncInput>;
  _set?: InputMaybe<ModelRelationshipsSetInput>;
  pk_columns: ModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateModelRelationshipsManyArgs = {
  updates: Array<ModelRelationshipsUpdates>;
};


/** mutation root */
export type MutationUpdateMonitorConditionTemplatesArgs = {
  _append?: InputMaybe<MonitorConditionTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<MonitorConditionTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MonitorConditionTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<MonitorConditionTemplatesDeleteKeyInput>;
  _prepend?: InputMaybe<MonitorConditionTemplatesPrependInput>;
  _set?: InputMaybe<MonitorConditionTemplatesSetInput>;
  where: MonitorConditionTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateMonitorConditionTemplatesByPkArgs = {
  _append?: InputMaybe<MonitorConditionTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<MonitorConditionTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<MonitorConditionTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<MonitorConditionTemplatesDeleteKeyInput>;
  _prepend?: InputMaybe<MonitorConditionTemplatesPrependInput>;
  _set?: InputMaybe<MonitorConditionTemplatesSetInput>;
  pk_columns: MonitorConditionTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateMonitorConditionTemplatesManyArgs = {
  updates: Array<MonitorConditionTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateNotificationChannelTemplatesArgs = {
  _set?: InputMaybe<NotificationChannelTemplatesSetInput>;
  where: NotificationChannelTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateNotificationChannelTemplatesByPkArgs = {
  _set?: InputMaybe<NotificationChannelTemplatesSetInput>;
  pk_columns: NotificationChannelTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateNotificationChannelTemplatesManyArgs = {
  updates: Array<NotificationChannelTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateObjectDefinitionsArgs = {
  _set?: InputMaybe<ObjectDefinitionsSetInput>;
  where: ObjectDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdateObjectDefinitionsByPkArgs = {
  _set?: InputMaybe<ObjectDefinitionsSetInput>;
  pk_columns: ObjectDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateObjectDefinitionsManyArgs = {
  updates: Array<ObjectDefinitionsUpdates>;
};


/** mutation root */
export type MutationUpdateOrganizationsArgs = {
  _append?: InputMaybe<OrganizationsAppendInput>;
  _delete_at_path?: InputMaybe<OrganizationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<OrganizationsDeleteElemInput>;
  _delete_key?: InputMaybe<OrganizationsDeleteKeyInput>;
  _prepend?: InputMaybe<OrganizationsPrependInput>;
  _set?: InputMaybe<OrganizationsSetInput>;
  where: OrganizationsBoolExp;
};


/** mutation root */
export type MutationUpdateOrganizationsByPkArgs = {
  _append?: InputMaybe<OrganizationsAppendInput>;
  _delete_at_path?: InputMaybe<OrganizationsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<OrganizationsDeleteElemInput>;
  _delete_key?: InputMaybe<OrganizationsDeleteKeyInput>;
  _prepend?: InputMaybe<OrganizationsPrependInput>;
  _set?: InputMaybe<OrganizationsSetInput>;
  pk_columns: OrganizationsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateOrganizationsManyArgs = {
  updates: Array<OrganizationsUpdates>;
};


/** mutation root */
export type MutationUpdatePagerdutyCredentialsArgs = {
  _append?: InputMaybe<PagerdutyCredentialsAppendInput>;
  _delete_at_path?: InputMaybe<PagerdutyCredentialsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PagerdutyCredentialsDeleteElemInput>;
  _delete_key?: InputMaybe<PagerdutyCredentialsDeleteKeyInput>;
  _prepend?: InputMaybe<PagerdutyCredentialsPrependInput>;
  _set?: InputMaybe<PagerdutyCredentialsSetInput>;
  where: PagerdutyCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdatePagerdutyCredentialsByPkArgs = {
  _append?: InputMaybe<PagerdutyCredentialsAppendInput>;
  _delete_at_path?: InputMaybe<PagerdutyCredentialsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PagerdutyCredentialsDeleteElemInput>;
  _delete_key?: InputMaybe<PagerdutyCredentialsDeleteKeyInput>;
  _prepend?: InputMaybe<PagerdutyCredentialsPrependInput>;
  _set?: InputMaybe<PagerdutyCredentialsSetInput>;
  pk_columns: PagerdutyCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePagerdutyCredentialsManyArgs = {
  updates: Array<PagerdutyCredentialsUpdates>;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionEventsArgs = {
  _set?: InputMaybe<PredictorFeatureDefinitionEventsSetInput>;
  where: PredictorFeatureDefinitionEventsBoolExp;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionEventsByPkArgs = {
  _set?: InputMaybe<PredictorFeatureDefinitionEventsSetInput>;
  pk_columns: PredictorFeatureDefinitionEventsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionEventsManyArgs = {
  updates: Array<PredictorFeatureDefinitionEventsUpdates>;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionsArgs = {
  _set?: InputMaybe<PredictorFeatureDefinitionsSetInput>;
  where: PredictorFeatureDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionsByPkArgs = {
  _set?: InputMaybe<PredictorFeatureDefinitionsSetInput>;
  pk_columns: PredictorFeatureDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePredictorFeatureDefinitionsManyArgs = {
  updates: Array<PredictorFeatureDefinitionsUpdates>;
};


/** mutation root */
export type MutationUpdatePredictorsArgs = {
  _set?: InputMaybe<PredictorsSetInput>;
  where: PredictorsBoolExp;
};


/** mutation root */
export type MutationUpdatePredictorsByPkArgs = {
  _set?: InputMaybe<PredictorsSetInput>;
  pk_columns: PredictorsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePredictorsManyArgs = {
  updates: Array<PredictorsUpdates>;
};


/** mutation root */
export type MutationUpdatePushAppsArgs = {
  _set?: InputMaybe<PushAppsSetInput>;
  where: PushAppsBoolExp;
};


/** mutation root */
export type MutationUpdatePushAppsByPkArgs = {
  _set?: InputMaybe<PushAppsSetInput>;
  pk_columns: PushAppsPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePushAppsManyArgs = {
  updates: Array<PushAppsUpdates>;
};


/** mutation root */
export type MutationUpdatePushConfigArgs = {
  _append?: InputMaybe<PushConfigAppendInput>;
  _delete_at_path?: InputMaybe<PushConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PushConfigDeleteElemInput>;
  _delete_key?: InputMaybe<PushConfigDeleteKeyInput>;
  _inc?: InputMaybe<PushConfigIncInput>;
  _prepend?: InputMaybe<PushConfigPrependInput>;
  _set?: InputMaybe<PushConfigSetInput>;
  where: PushConfigBoolExp;
};


/** mutation root */
export type MutationUpdatePushConfigByPkArgs = {
  _append?: InputMaybe<PushConfigAppendInput>;
  _delete_at_path?: InputMaybe<PushConfigDeleteAtPathInput>;
  _delete_elem?: InputMaybe<PushConfigDeleteElemInput>;
  _delete_key?: InputMaybe<PushConfigDeleteKeyInput>;
  _inc?: InputMaybe<PushConfigIncInput>;
  _prepend?: InputMaybe<PushConfigPrependInput>;
  _set?: InputMaybe<PushConfigSetInput>;
  pk_columns: PushConfigPkColumnsInput;
};


/** mutation root */
export type MutationUpdatePushConfigManyArgs = {
  updates: Array<PushConfigUpdates>;
};


/** mutation root */
export type MutationUpdateRealtimeAudienceSyncsArgs = {
  _append?: InputMaybe<RealtimeAudienceSyncsAppendInput>;
  _delete_at_path?: InputMaybe<RealtimeAudienceSyncsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RealtimeAudienceSyncsDeleteElemInput>;
  _delete_key?: InputMaybe<RealtimeAudienceSyncsDeleteKeyInput>;
  _prepend?: InputMaybe<RealtimeAudienceSyncsPrependInput>;
  _set?: InputMaybe<RealtimeAudienceSyncsSetInput>;
  where: RealtimeAudienceSyncsBoolExp;
};


/** mutation root */
export type MutationUpdateRealtimeAudienceSyncsByPkArgs = {
  _append?: InputMaybe<RealtimeAudienceSyncsAppendInput>;
  _delete_at_path?: InputMaybe<RealtimeAudienceSyncsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RealtimeAudienceSyncsDeleteElemInput>;
  _delete_key?: InputMaybe<RealtimeAudienceSyncsDeleteKeyInput>;
  _prepend?: InputMaybe<RealtimeAudienceSyncsPrependInput>;
  _set?: InputMaybe<RealtimeAudienceSyncsSetInput>;
  pk_columns: RealtimeAudienceSyncsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRealtimeAudienceSyncsManyArgs = {
  updates: Array<RealtimeAudienceSyncsUpdates>;
};


/** mutation root */
export type MutationUpdateRealtimeAudiencesScheduledWarehousePullsArgs = {
  _append?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsAppendInput>;
  _delete_at_path?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteElemInput>;
  _delete_key?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteKeyInput>;
  _prepend?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsPrependInput>;
  _set?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsSetInput>;
  where: RealtimeAudiencesScheduledWarehousePullsBoolExp;
};


/** mutation root */
export type MutationUpdateRealtimeAudiencesScheduledWarehousePullsManyArgs = {
  updates: Array<RealtimeAudiencesScheduledWarehousePullsUpdates>;
};


/** mutation root */
export type MutationUpdateRelationshipReferencesArgs = {
  _inc?: InputMaybe<RelationshipReferencesIncInput>;
  _set?: InputMaybe<RelationshipReferencesSetInput>;
  where: RelationshipReferencesBoolExp;
};


/** mutation root */
export type MutationUpdateRelationshipReferencesByPkArgs = {
  _inc?: InputMaybe<RelationshipReferencesIncInput>;
  _set?: InputMaybe<RelationshipReferencesSetInput>;
  pk_columns: RelationshipReferencesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRelationshipReferencesManyArgs = {
  updates: Array<RelationshipReferencesUpdates>;
};


/** mutation root */
export type MutationUpdateRelationshipsArgs = {
  _inc?: InputMaybe<RelationshipsIncInput>;
  _set?: InputMaybe<RelationshipsSetInput>;
  where: RelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateRelationshipsByPkArgs = {
  _inc?: InputMaybe<RelationshipsIncInput>;
  _set?: InputMaybe<RelationshipsSetInput>;
  pk_columns: RelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateRelationshipsManyArgs = {
  updates: Array<RelationshipsUpdates>;
};


/** mutation root */
export type MutationUpdateReportScheduleArgs = {
  _append?: InputMaybe<ReportScheduleAppendInput>;
  _delete_at_path?: InputMaybe<ReportScheduleDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ReportScheduleDeleteElemInput>;
  _delete_key?: InputMaybe<ReportScheduleDeleteKeyInput>;
  _inc?: InputMaybe<ReportScheduleIncInput>;
  _prepend?: InputMaybe<ReportSchedulePrependInput>;
  _set?: InputMaybe<ReportScheduleSetInput>;
  where: ReportScheduleBoolExp;
};


/** mutation root */
export type MutationUpdateReportScheduleByPkArgs = {
  _append?: InputMaybe<ReportScheduleAppendInput>;
  _delete_at_path?: InputMaybe<ReportScheduleDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ReportScheduleDeleteElemInput>;
  _delete_key?: InputMaybe<ReportScheduleDeleteKeyInput>;
  _inc?: InputMaybe<ReportScheduleIncInput>;
  _prepend?: InputMaybe<ReportSchedulePrependInput>;
  _set?: InputMaybe<ReportScheduleSetInput>;
  pk_columns: ReportSchedulePkColumnsInput;
};


/** mutation root */
export type MutationUpdateReportScheduleManyArgs = {
  updates: Array<ReportScheduleUpdates>;
};


/** mutation root */
export type MutationUpdateResourceInteractionsArgs = {
  _set?: InputMaybe<ResourceInteractionsSetInput>;
  where: ResourceInteractionsBoolExp;
};


/** mutation root */
export type MutationUpdateResourceInteractionsByPkArgs = {
  _set?: InputMaybe<ResourceInteractionsSetInput>;
  pk_columns: ResourceInteractionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceInteractionsManyArgs = {
  updates: Array<ResourceInteractionsUpdates>;
};


/** mutation root */
export type MutationUpdateResourceMonitorConditionsArgs = {
  _append?: InputMaybe<ResourceMonitorConditionsAppendInput>;
  _delete_at_path?: InputMaybe<ResourceMonitorConditionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ResourceMonitorConditionsDeleteElemInput>;
  _delete_key?: InputMaybe<ResourceMonitorConditionsDeleteKeyInput>;
  _prepend?: InputMaybe<ResourceMonitorConditionsPrependInput>;
  _set?: InputMaybe<ResourceMonitorConditionsSetInput>;
  where: ResourceMonitorConditionsBoolExp;
};


/** mutation root */
export type MutationUpdateResourceMonitorConditionsByPkArgs = {
  _append?: InputMaybe<ResourceMonitorConditionsAppendInput>;
  _delete_at_path?: InputMaybe<ResourceMonitorConditionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ResourceMonitorConditionsDeleteElemInput>;
  _delete_key?: InputMaybe<ResourceMonitorConditionsDeleteKeyInput>;
  _prepend?: InputMaybe<ResourceMonitorConditionsPrependInput>;
  _set?: InputMaybe<ResourceMonitorConditionsSetInput>;
  pk_columns: ResourceMonitorConditionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceMonitorConditionsManyArgs = {
  updates: Array<ResourceMonitorConditionsUpdates>;
};


/** mutation root */
export type MutationUpdateResourceNotificationChannelsArgs = {
  _set?: InputMaybe<ResourceNotificationChannelsSetInput>;
  where: ResourceNotificationChannelsBoolExp;
};


/** mutation root */
export type MutationUpdateResourceNotificationChannelsByPkArgs = {
  _set?: InputMaybe<ResourceNotificationChannelsSetInput>;
  pk_columns: ResourceNotificationChannelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceNotificationChannelsManyArgs = {
  updates: Array<ResourceNotificationChannelsUpdates>;
};


/** mutation root */
export type MutationUpdateResourceToMonitorConditionTypeArgs = {
  _set?: InputMaybe<ResourceToMonitorConditionTypeSetInput>;
  where: ResourceToMonitorConditionTypeBoolExp;
};


/** mutation root */
export type MutationUpdateResourceToMonitorConditionTypeByPkArgs = {
  _set?: InputMaybe<ResourceToMonitorConditionTypeSetInput>;
  pk_columns: ResourceToMonitorConditionTypePkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceToMonitorConditionTypeManyArgs = {
  updates: Array<ResourceToMonitorConditionTypeUpdates>;
};


/** mutation root */
export type MutationUpdateResourceViewsArgs = {
  _append?: InputMaybe<ResourceViewsAppendInput>;
  _delete_at_path?: InputMaybe<ResourceViewsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ResourceViewsDeleteElemInput>;
  _delete_key?: InputMaybe<ResourceViewsDeleteKeyInput>;
  _prepend?: InputMaybe<ResourceViewsPrependInput>;
  _set?: InputMaybe<ResourceViewsSetInput>;
  where: ResourceViewsBoolExp;
};


/** mutation root */
export type MutationUpdateResourceViewsByPkArgs = {
  _append?: InputMaybe<ResourceViewsAppendInput>;
  _delete_at_path?: InputMaybe<ResourceViewsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ResourceViewsDeleteElemInput>;
  _delete_key?: InputMaybe<ResourceViewsDeleteKeyInput>;
  _prepend?: InputMaybe<ResourceViewsPrependInput>;
  _set?: InputMaybe<ResourceViewsSetInput>;
  pk_columns: ResourceViewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateResourceViewsManyArgs = {
  updates: Array<ResourceViewsUpdates>;
};


/** mutation root */
export type MutationUpdateSampledSegmentsArgs = {
  _append?: InputMaybe<SampledSegmentsAppendInput>;
  _delete_at_path?: InputMaybe<SampledSegmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SampledSegmentsDeleteElemInput>;
  _delete_key?: InputMaybe<SampledSegmentsDeleteKeyInput>;
  _inc?: InputMaybe<SampledSegmentsIncInput>;
  _prepend?: InputMaybe<SampledSegmentsPrependInput>;
  _set?: InputMaybe<SampledSegmentsSetInput>;
  where: SampledSegmentsBoolExp;
};


/** mutation root */
export type MutationUpdateSampledSegmentsByPkArgs = {
  _append?: InputMaybe<SampledSegmentsAppendInput>;
  _delete_at_path?: InputMaybe<SampledSegmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SampledSegmentsDeleteElemInput>;
  _delete_key?: InputMaybe<SampledSegmentsDeleteKeyInput>;
  _inc?: InputMaybe<SampledSegmentsIncInput>;
  _prepend?: InputMaybe<SampledSegmentsPrependInput>;
  _set?: InputMaybe<SampledSegmentsSetInput>;
  pk_columns: SampledSegmentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSampledSegmentsManyArgs = {
  updates: Array<SampledSegmentsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsSetInput>;
  where: SavedAnalyticsChartsBoolExp;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsByPkArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsSetInput>;
  pk_columns: SavedAnalyticsChartsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsCohortsArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsCohortsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsCohortsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsCohortsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsCohortsDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsCohortsIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsCohortsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsCohortsSetInput>;
  where: SavedAnalyticsChartsCohortsBoolExp;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsCohortsByPkArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsCohortsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsCohortsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsCohortsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsCohortsDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsCohortsIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsCohortsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsCohortsSetInput>;
  pk_columns: SavedAnalyticsChartsCohortsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsCohortsManyArgs = {
  updates: Array<SavedAnalyticsChartsCohortsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsFunnelStagesArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsFunnelStagesAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsFunnelStagesIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsFunnelStagesPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsFunnelStagesSetInput>;
  where: SavedAnalyticsChartsFunnelStagesBoolExp;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsFunnelStagesByPkArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsFunnelStagesAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteKeyInput>;
  _inc?: InputMaybe<SavedAnalyticsChartsFunnelStagesIncInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsFunnelStagesPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsFunnelStagesSetInput>;
  pk_columns: SavedAnalyticsChartsFunnelStagesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsFunnelStagesManyArgs = {
  updates: Array<SavedAnalyticsChartsFunnelStagesUpdates>;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsGoalsArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsGoalsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsGoalsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsGoalsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsGoalsDeleteKeyInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsGoalsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsGoalsSetInput>;
  where: SavedAnalyticsChartsGoalsBoolExp;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsGoalsByPkArgs = {
  _append?: InputMaybe<SavedAnalyticsChartsGoalsAppendInput>;
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsGoalsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedAnalyticsChartsGoalsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedAnalyticsChartsGoalsDeleteKeyInput>;
  _prepend?: InputMaybe<SavedAnalyticsChartsGoalsPrependInput>;
  _set?: InputMaybe<SavedAnalyticsChartsGoalsSetInput>;
  pk_columns: SavedAnalyticsChartsGoalsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsGoalsManyArgs = {
  updates: Array<SavedAnalyticsChartsGoalsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedAnalyticsChartsManyArgs = {
  updates: Array<SavedAnalyticsChartsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsArgs = {
  _append?: InputMaybe<SavedCampaignViewsAppendInput>;
  _delete_at_path?: InputMaybe<SavedCampaignViewsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedCampaignViewsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedCampaignViewsDeleteKeyInput>;
  _inc?: InputMaybe<SavedCampaignViewsIncInput>;
  _prepend?: InputMaybe<SavedCampaignViewsPrependInput>;
  _set?: InputMaybe<SavedCampaignViewsSetInput>;
  where: SavedCampaignViewsBoolExp;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsByPkArgs = {
  _append?: InputMaybe<SavedCampaignViewsAppendInput>;
  _delete_at_path?: InputMaybe<SavedCampaignViewsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedCampaignViewsDeleteElemInput>;
  _delete_key?: InputMaybe<SavedCampaignViewsDeleteKeyInput>;
  _inc?: InputMaybe<SavedCampaignViewsIncInput>;
  _prepend?: InputMaybe<SavedCampaignViewsPrependInput>;
  _set?: InputMaybe<SavedCampaignViewsSetInput>;
  pk_columns: SavedCampaignViewsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsGoalsArgs = {
  _set?: InputMaybe<SavedCampaignViewsGoalsSetInput>;
  where: SavedCampaignViewsGoalsBoolExp;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsGoalsByPkArgs = {
  _set?: InputMaybe<SavedCampaignViewsGoalsSetInput>;
  pk_columns: SavedCampaignViewsGoalsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsGoalsManyArgs = {
  updates: Array<SavedCampaignViewsGoalsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedCampaignViewsManyArgs = {
  updates: Array<SavedCampaignViewsUpdates>;
};


/** mutation root */
export type MutationUpdateSavedQueriesArgs = {
  _append?: InputMaybe<SavedQueriesAppendInput>;
  _delete_at_path?: InputMaybe<SavedQueriesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedQueriesDeleteElemInput>;
  _delete_key?: InputMaybe<SavedQueriesDeleteKeyInput>;
  _inc?: InputMaybe<SavedQueriesIncInput>;
  _prepend?: InputMaybe<SavedQueriesPrependInput>;
  _set?: InputMaybe<SavedQueriesSetInput>;
  where: SavedQueriesBoolExp;
};


/** mutation root */
export type MutationUpdateSavedQueriesByPkArgs = {
  _append?: InputMaybe<SavedQueriesAppendInput>;
  _delete_at_path?: InputMaybe<SavedQueriesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SavedQueriesDeleteElemInput>;
  _delete_key?: InputMaybe<SavedQueriesDeleteKeyInput>;
  _inc?: InputMaybe<SavedQueriesIncInput>;
  _prepend?: InputMaybe<SavedQueriesPrependInput>;
  _set?: InputMaybe<SavedQueriesSetInput>;
  pk_columns: SavedQueriesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSavedQueriesManyArgs = {
  updates: Array<SavedQueriesUpdates>;
};


/** mutation root */
export type MutationUpdateSegmentsArgs = {
  _append?: InputMaybe<SegmentsAppendInput>;
  _delete_at_path?: InputMaybe<SegmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SegmentsDeleteElemInput>;
  _delete_key?: InputMaybe<SegmentsDeleteKeyInput>;
  _inc?: InputMaybe<SegmentsIncInput>;
  _prepend?: InputMaybe<SegmentsPrependInput>;
  _set?: InputMaybe<SegmentsSetInput>;
  where: SegmentsBoolExp;
};


/** mutation root */
export type MutationUpdateSegmentsByPkArgs = {
  _append?: InputMaybe<SegmentsAppendInput>;
  _delete_at_path?: InputMaybe<SegmentsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SegmentsDeleteElemInput>;
  _delete_key?: InputMaybe<SegmentsDeleteKeyInput>;
  _inc?: InputMaybe<SegmentsIncInput>;
  _prepend?: InputMaybe<SegmentsPrependInput>;
  _set?: InputMaybe<SegmentsSetInput>;
  pk_columns: SegmentsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSegmentsManyArgs = {
  updates: Array<SegmentsUpdates>;
};


/** mutation root */
export type MutationUpdateSlackCredentialsArgs = {
  _set?: InputMaybe<SlackCredentialsSetInput>;
  where: SlackCredentialsBoolExp;
};


/** mutation root */
export type MutationUpdateSlackCredentialsByPkArgs = {
  _set?: InputMaybe<SlackCredentialsSetInput>;
  pk_columns: SlackCredentialsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSlackCredentialsManyArgs = {
  updates: Array<SlackCredentialsUpdates>;
};


/** mutation root */
export type MutationUpdateSpacesArgs = {
  _set?: InputMaybe<SpacesSetInput>;
  where: SpacesBoolExp;
};


/** mutation root */
export type MutationUpdateSpacesByPkArgs = {
  _set?: InputMaybe<SpacesSetInput>;
  pk_columns: SpacesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSpacesManyArgs = {
  updates: Array<SpacesUpdates>;
};


/** mutation root */
export type MutationUpdateSupportAccessGrantArgs = {
  where: SupportAccessGrantBoolExp;
};


/** mutation root */
export type MutationUpdateSupportAccessGrantByPkArgs = {
  pk_columns: SupportAccessGrantPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSupportAccessGrantManyArgs = {
  updates: Array<SupportAccessGrantUpdates>;
};


/** mutation root */
export type MutationUpdateSyncRequestsArgs = {
  _set?: InputMaybe<SyncRequestsSetInput>;
  where: SyncRequestsBoolExp;
};


/** mutation root */
export type MutationUpdateSyncRequestsByPkArgs = {
  _set?: InputMaybe<SyncRequestsSetInput>;
  pk_columns: SyncRequestsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncRequestsManyArgs = {
  updates: Array<SyncRequestsUpdates>;
};


/** mutation root */
export type MutationUpdateSyncSequenceMembersArgs = {
  _append?: InputMaybe<SyncSequenceMembersAppendInput>;
  _delete_at_path?: InputMaybe<SyncSequenceMembersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncSequenceMembersDeleteElemInput>;
  _delete_key?: InputMaybe<SyncSequenceMembersDeleteKeyInput>;
  _inc?: InputMaybe<SyncSequenceMembersIncInput>;
  _prepend?: InputMaybe<SyncSequenceMembersPrependInput>;
  _set?: InputMaybe<SyncSequenceMembersSetInput>;
  where: SyncSequenceMembersBoolExp;
};


/** mutation root */
export type MutationUpdateSyncSequenceMembersByPkArgs = {
  _append?: InputMaybe<SyncSequenceMembersAppendInput>;
  _delete_at_path?: InputMaybe<SyncSequenceMembersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncSequenceMembersDeleteElemInput>;
  _delete_key?: InputMaybe<SyncSequenceMembersDeleteKeyInput>;
  _inc?: InputMaybe<SyncSequenceMembersIncInput>;
  _prepend?: InputMaybe<SyncSequenceMembersPrependInput>;
  _set?: InputMaybe<SyncSequenceMembersSetInput>;
  pk_columns: SyncSequenceMembersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncSequenceMembersManyArgs = {
  updates: Array<SyncSequenceMembersUpdates>;
};


/** mutation root */
export type MutationUpdateSyncSequenceRunsArgs = {
  _set?: InputMaybe<SyncSequenceRunsSetInput>;
  where: SyncSequenceRunsBoolExp;
};


/** mutation root */
export type MutationUpdateSyncSequenceRunsByPkArgs = {
  _set?: InputMaybe<SyncSequenceRunsSetInput>;
  pk_columns: SyncSequenceRunsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncSequenceRunsManyArgs = {
  updates: Array<SyncSequenceRunsUpdates>;
};


/** mutation root */
export type MutationUpdateSyncSequencesArgs = {
  _append?: InputMaybe<SyncSequencesAppendInput>;
  _delete_at_path?: InputMaybe<SyncSequencesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncSequencesDeleteElemInput>;
  _delete_key?: InputMaybe<SyncSequencesDeleteKeyInput>;
  _prepend?: InputMaybe<SyncSequencesPrependInput>;
  _set?: InputMaybe<SyncSequencesSetInput>;
  where: SyncSequencesBoolExp;
};


/** mutation root */
export type MutationUpdateSyncSequencesByPkArgs = {
  _append?: InputMaybe<SyncSequencesAppendInput>;
  _delete_at_path?: InputMaybe<SyncSequencesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncSequencesDeleteElemInput>;
  _delete_key?: InputMaybe<SyncSequencesDeleteKeyInput>;
  _prepend?: InputMaybe<SyncSequencesPrependInput>;
  _set?: InputMaybe<SyncSequencesSetInput>;
  pk_columns: SyncSequencesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncSequencesManyArgs = {
  updates: Array<SyncSequencesUpdates>;
};


/** mutation root */
export type MutationUpdateSyncTemplatesArgs = {
  _append?: InputMaybe<SyncTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<SyncTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<SyncTemplatesDeleteKeyInput>;
  _inc?: InputMaybe<SyncTemplatesIncInput>;
  _prepend?: InputMaybe<SyncTemplatesPrependInput>;
  _set?: InputMaybe<SyncTemplatesSetInput>;
  where: SyncTemplatesBoolExp;
};


/** mutation root */
export type MutationUpdateSyncTemplatesByPkArgs = {
  _append?: InputMaybe<SyncTemplatesAppendInput>;
  _delete_at_path?: InputMaybe<SyncTemplatesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<SyncTemplatesDeleteElemInput>;
  _delete_key?: InputMaybe<SyncTemplatesDeleteKeyInput>;
  _inc?: InputMaybe<SyncTemplatesIncInput>;
  _prepend?: InputMaybe<SyncTemplatesPrependInput>;
  _set?: InputMaybe<SyncTemplatesSetInput>;
  pk_columns: SyncTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateSyncTemplatesManyArgs = {
  updates: Array<SyncTemplatesUpdates>;
};


/** mutation root */
export type MutationUpdateThroughModelRelationshipsArgs = {
  _inc?: InputMaybe<ThroughModelRelationshipsIncInput>;
  _set?: InputMaybe<ThroughModelRelationshipsSetInput>;
  where: ThroughModelRelationshipsBoolExp;
};


/** mutation root */
export type MutationUpdateThroughModelRelationshipsByPkArgs = {
  _inc?: InputMaybe<ThroughModelRelationshipsIncInput>;
  _set?: InputMaybe<ThroughModelRelationshipsSetInput>;
  pk_columns: ThroughModelRelationshipsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateThroughModelRelationshipsManyArgs = {
  updates: Array<ThroughModelRelationshipsUpdates>;
};


/** mutation root */
export type MutationUpdateTrackedAudienceListsArgs = {
  _inc?: InputMaybe<TrackedAudienceListsIncInput>;
  _set?: InputMaybe<TrackedAudienceListsSetInput>;
  where: TrackedAudienceListsBoolExp;
};


/** mutation root */
export type MutationUpdateTrackedAudienceListsByPkArgs = {
  _inc?: InputMaybe<TrackedAudienceListsIncInput>;
  _set?: InputMaybe<TrackedAudienceListsSetInput>;
  pk_columns: TrackedAudienceListsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateTrackedAudienceListsManyArgs = {
  updates: Array<TrackedAudienceListsUpdates>;
};


/** mutation root */
export type MutationUpdateTraitDefinitionsArgs = {
  _append?: InputMaybe<TraitDefinitionsAppendInput>;
  _delete_at_path?: InputMaybe<TraitDefinitionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TraitDefinitionsDeleteElemInput>;
  _delete_key?: InputMaybe<TraitDefinitionsDeleteKeyInput>;
  _inc?: InputMaybe<TraitDefinitionsIncInput>;
  _prepend?: InputMaybe<TraitDefinitionsPrependInput>;
  _set?: InputMaybe<TraitDefinitionsSetInput>;
  where: TraitDefinitionsBoolExp;
};


/** mutation root */
export type MutationUpdateTraitDefinitionsByPkArgs = {
  _append?: InputMaybe<TraitDefinitionsAppendInput>;
  _delete_at_path?: InputMaybe<TraitDefinitionsDeleteAtPathInput>;
  _delete_elem?: InputMaybe<TraitDefinitionsDeleteElemInput>;
  _delete_key?: InputMaybe<TraitDefinitionsDeleteKeyInput>;
  _inc?: InputMaybe<TraitDefinitionsIncInput>;
  _prepend?: InputMaybe<TraitDefinitionsPrependInput>;
  _set?: InputMaybe<TraitDefinitionsSetInput>;
  pk_columns: TraitDefinitionsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateTraitDefinitionsManyArgs = {
  updates: Array<TraitDefinitionsUpdates>;
};


/** mutation root */
export type MutationUpdateTunnelsArgs = {
  _set?: InputMaybe<TunnelsSetInput>;
  where: TunnelsBoolExp;
};


/** mutation root */
export type MutationUpdateTunnelsByPkArgs = {
  _set?: InputMaybe<TunnelsSetInput>;
  pk_columns: TunnelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateTunnelsManyArgs = {
  updates: Array<TunnelsUpdates>;
};


/** mutation root */
export type MutationUpdateUserGroupGrantsArgs = {
  _set?: InputMaybe<UserGroupGrantsSetInput>;
  where: UserGroupGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateUserGroupGrantsByPkArgs = {
  _set?: InputMaybe<UserGroupGrantsSetInput>;
  pk_columns: UserGroupGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUserGroupGrantsManyArgs = {
  updates: Array<UserGroupGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateUserGroupMembersArgs = {
  _set?: InputMaybe<UserGroupMembersSetInput>;
  where: UserGroupMembersBoolExp;
};


/** mutation root */
export type MutationUpdateUserGroupMembersByPkArgs = {
  _set?: InputMaybe<UserGroupMembersSetInput>;
  pk_columns: UserGroupMembersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUserGroupMembersManyArgs = {
  updates: Array<UserGroupMembersUpdates>;
};


/** mutation root */
export type MutationUpdateUserGroupSubsetGrantsArgs = {
  _set?: InputMaybe<UserGroupSubsetGrantsSetInput>;
  where: UserGroupSubsetGrantsBoolExp;
};


/** mutation root */
export type MutationUpdateUserGroupSubsetGrantsByPkArgs = {
  _set?: InputMaybe<UserGroupSubsetGrantsSetInput>;
  pk_columns: UserGroupSubsetGrantsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUserGroupSubsetGrantsManyArgs = {
  updates: Array<UserGroupSubsetGrantsUpdates>;
};


/** mutation root */
export type MutationUpdateUserGroupWorkspacesArgs = {
  _set?: InputMaybe<UserGroupWorkspacesSetInput>;
  where: UserGroupWorkspacesBoolExp;
};


/** mutation root */
export type MutationUpdateUserGroupWorkspacesByPkArgs = {
  _set?: InputMaybe<UserGroupWorkspacesSetInput>;
  pk_columns: UserGroupWorkspacesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUserGroupWorkspacesManyArgs = {
  updates: Array<UserGroupWorkspacesUpdates>;
};


/** mutation root */
export type MutationUpdateUserGroupsArgs = {
  _set?: InputMaybe<UserGroupsSetInput>;
  where: UserGroupsBoolExp;
};


/** mutation root */
export type MutationUpdateUserGroupsByPkArgs = {
  _set?: InputMaybe<UserGroupsSetInput>;
  pk_columns: UserGroupsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUserGroupsManyArgs = {
  updates: Array<UserGroupsUpdates>;
};


/** mutation root */
export type MutationUpdateUsersArgs = {
  _append?: InputMaybe<UsersAppendInput>;
  _delete_at_path?: InputMaybe<UsersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UsersDeleteElemInput>;
  _delete_key?: InputMaybe<UsersDeleteKeyInput>;
  _prepend?: InputMaybe<UsersPrependInput>;
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type MutationUpdateUsersByPkArgs = {
  _append?: InputMaybe<UsersAppendInput>;
  _delete_at_path?: InputMaybe<UsersDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UsersDeleteElemInput>;
  _delete_key?: InputMaybe<UsersDeleteKeyInput>;
  _prepend?: InputMaybe<UsersPrependInput>;
  _set?: InputMaybe<UsersSetInput>;
  pk_columns: UsersPkColumnsInput;
};


/** mutation root */
export type MutationUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type MutationUpdateWorkspaceNotificationChannelsArgs = {
  _set?: InputMaybe<WorkspaceNotificationChannelsSetInput>;
  where: WorkspaceNotificationChannelsBoolExp;
};


/** mutation root */
export type MutationUpdateWorkspaceNotificationChannelsByPkArgs = {
  _set?: InputMaybe<WorkspaceNotificationChannelsSetInput>;
  pk_columns: WorkspaceNotificationChannelsPkColumnsInput;
};


/** mutation root */
export type MutationUpdateWorkspaceNotificationChannelsManyArgs = {
  updates: Array<WorkspaceNotificationChannelsUpdates>;
};


/** mutation root */
export type MutationUpdateWorkspacesArgs = {
  _append?: InputMaybe<WorkspacesAppendInput>;
  _delete_at_path?: InputMaybe<WorkspacesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WorkspacesDeleteElemInput>;
  _delete_key?: InputMaybe<WorkspacesDeleteKeyInput>;
  _inc?: InputMaybe<WorkspacesIncInput>;
  _prepend?: InputMaybe<WorkspacesPrependInput>;
  _set?: InputMaybe<WorkspacesSetInput>;
  where: WorkspacesBoolExp;
};


/** mutation root */
export type MutationUpdateWorkspacesByPkArgs = {
  _append?: InputMaybe<WorkspacesAppendInput>;
  _delete_at_path?: InputMaybe<WorkspacesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<WorkspacesDeleteElemInput>;
  _delete_key?: InputMaybe<WorkspacesDeleteKeyInput>;
  _inc?: InputMaybe<WorkspacesIncInput>;
  _prepend?: InputMaybe<WorkspacesPrependInput>;
  _set?: InputMaybe<WorkspacesSetInput>;
  pk_columns: WorkspacesPkColumnsInput;
};


/** mutation root */
export type MutationUpdateWorkspacesManyArgs = {
  updates: Array<WorkspacesUpdates>;
};


/** mutation root */
export type MutationUploadAgentFileArgs = {
  input: UploadAgentFileInput;
};


/** mutation root */
export type MutationUploadContentSettingsFontFileArgs = {
  input: UploadContentSettingsFontFileInput;
};


/** mutation root */
export type MutationUploadFontFileArgs = {
  input: UploadFontFileInput;
};


/** mutation root */
export type MutationUploadLogoFileArgs = {
  input: UploadLogoFileInput;
};


/** mutation root */
export type MutationUploadManuallyEditedImageArgs = {
  input: UploadManuallyEditedImageInput;
};


/** mutation root */
export type MutationUploadMediaAssetsToDestinationArgs = {
  assets: Array<UploadMediaAssetInput>;
  destinationId: Scalars['String'];
};


/** mutation root */
export type MutationUpsertAgentSettingsArgs = {
  input: UpsertAgentSettingsInput;
};


/** mutation root */
export type MutationUpsertContentArtifactDynamicSlotArgs = {
  input: UpsertContentArtifactDynamicSlotInput;
};


/** mutation root */
export type MutationUpsertContentArtifactDynamicSlotContentArgs = {
  input: UpsertContentArtifactDynamicSlotContentInput;
};


/** mutation root */
export type MutationUpsertContentEmailDynamicSlotArgs = {
  input: UpsertContentEmailDynamicSlotInput;
};


/** mutation root */
export type MutationUpsertContentEmailDynamicSlotContentArgs = {
  input: UpsertContentEmailDynamicSlotContentInput;
};


/** mutation root */
export type MutationUpsertContentSettingsArgs = {
  input: UpsertContentSettingsInput;
};


/** mutation root */
export type MutationUpsertDecisionEngineFlowVolumeRampArgs = {
  flowId: Scalars['uuid'];
  plan: DecisionEngineFlowVolumeRampPlanInput;
};


/** mutation root */
export type MutationUpsertInitiativeInsightPromptArgs = {
  prompt: Scalars['String'];
};


/** mutation root */
export type MutationUpsertLookerExtensionArgs = {
  input: LookerCredentialsInput;
};


/** mutation root */
export type MutationUpsertRelationshipsArgs = {
  modelId: Scalars['String'];
  relationships: Array<UpdateRelationshipInput>;
};


/** mutation root */
export type MutationUpsertSigmaExtensionArgs = {
  input: UpsertSigmaExtensionInput;
};


/** mutation root */
export type MutationValidateSettingsArgs = {
  input: ValidateSettingsInput;
};


/** mutation root */
export type MutationVerifyCepCloudflareTrackingDomainArgs = {
  input: VerifyCepCloudflareTrackingDomainInput;
};


/** mutation root */
export type MutationVerifyCepDomainArgs = {
  input: VerifyCepDomainInput;
};


/** mutation root */
export type MutationWithdrawAmpTaskDecisionArgs = {
  reviewerId: Scalars['ID'];
};


/** mutation root */
export type MutationWithdrawAmpTaskReviewArgs = {
  id: Scalars['ID'];
};


/** mutation root */
export type MutationWithdrawCampaignDraftArgs = {
  campaignId: Scalars['uuid'];
};


/** mutation root */
export type MutationWithdrawJourneyDraftArgs = {
  journeyId: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type NameComparisonExp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** columns and relationships of "notification_channel_templates" */
export type NotificationChannelTemplates = {
  __typename?: 'notification_channel_templates';
  channel_id: Scalars['uuid'];
  /** An object relationship */
  destination?: Maybe<Destinations>;
  disabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  parent_resource_id: Scalars['String'];
  parent_resource_type: Scalars['String'];
  /** An array relationship */
  sent_resource_notifications: Array<SentResourceNotifications>;
  should_send_recovery: Scalars['Boolean'];
  status: Scalars['String'];
  /** An object relationship */
  workspace_notification_channel: WorkspaceNotificationChannels;
};


/** columns and relationships of "notification_channel_templates" */
export type NotificationChannelTemplatesSentResourceNotificationsArgs = {
  distinct_on?: InputMaybe<Array<SentResourceNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SentResourceNotificationsOrderBy>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};

/** order by aggregate values of table "notification_channel_templates" */
export type NotificationChannelTemplatesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NotificationChannelTemplatesMaxOrderBy>;
  min?: InputMaybe<NotificationChannelTemplatesMinOrderBy>;
};

/** input type for inserting array relation for remote table "notification_channel_templates" */
export type NotificationChannelTemplatesArrRelInsertInput = {
  data: Array<NotificationChannelTemplatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationChannelTemplatesOnConflict>;
};

/** Boolean expression to filter rows from the table "notification_channel_templates". All fields are combined with a logical 'AND'. */
export type NotificationChannelTemplatesBoolExp = {
  _and?: InputMaybe<Array<NotificationChannelTemplatesBoolExp>>;
  _not?: InputMaybe<NotificationChannelTemplatesBoolExp>;
  _or?: InputMaybe<Array<NotificationChannelTemplatesBoolExp>>;
  channel_id?: InputMaybe<UuidComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  disabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  parent_resource_id?: InputMaybe<StringComparisonExp>;
  parent_resource_type?: InputMaybe<StringComparisonExp>;
  sent_resource_notifications?: InputMaybe<SentResourceNotificationsBoolExp>;
  should_send_recovery?: InputMaybe<BooleanComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};

/** unique or primary key constraints on table "notification_channel_templates" */
export const NotificationChannelTemplatesConstraint = {
  /** unique or primary key constraint on columns "status", "parent_resource_type", "channel_id", "parent_resource_id" */
  NotificationChannelTemplatesChannelIdStatusParentResourc: 'notification_channel_templates_channel_id_status_parent_resourc',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  NotificationChannelTemplatesIdWorkspaceIdKey: 'notification_channel_templates_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  NotificationChannelTemplatesPkey: 'notification_channel_templates_pkey'
} as const;

export type NotificationChannelTemplatesConstraint = typeof NotificationChannelTemplatesConstraint[keyof typeof NotificationChannelTemplatesConstraint];
/** input type for inserting data into table "notification_channel_templates" */
export type NotificationChannelTemplatesInsertInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_resource_id?: InputMaybe<Scalars['String']>;
  parent_resource_type?: InputMaybe<Scalars['String']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsObjRelInsertInput>;
};

/** order by max() on columns of table "notification_channel_templates" */
export type NotificationChannelTemplatesMaxOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_resource_id?: InputMaybe<OrderBy>;
  parent_resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "notification_channel_templates" */
export type NotificationChannelTemplatesMinOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_resource_id?: InputMaybe<OrderBy>;
  parent_resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "notification_channel_templates" */
export type NotificationChannelTemplatesMutationResponse = {
  __typename?: 'notification_channel_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationChannelTemplates>;
};

/** on_conflict condition type for table "notification_channel_templates" */
export type NotificationChannelTemplatesOnConflict = {
  constraint: NotificationChannelTemplatesConstraint;
  update_columns?: Array<NotificationChannelTemplatesUpdateColumn>;
  where?: InputMaybe<NotificationChannelTemplatesBoolExp>;
};

/** Ordering options when selecting data from "notification_channel_templates". */
export type NotificationChannelTemplatesOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  disabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parent_resource_id?: InputMaybe<OrderBy>;
  parent_resource_type?: InputMaybe<OrderBy>;
  sent_resource_notifications_aggregate?: InputMaybe<SentResourceNotificationsAggregateOrderBy>;
  should_send_recovery?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsOrderBy>;
};

/** primary key columns input for table: notification_channel_templates */
export type NotificationChannelTemplatesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "notification_channel_templates" */
export const NotificationChannelTemplatesSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  Disabled: 'disabled',
  /** column name */
  Id: 'id',
  /** column name */
  ParentResourceId: 'parent_resource_id',
  /** column name */
  ParentResourceType: 'parent_resource_type',
  /** column name */
  ShouldSendRecovery: 'should_send_recovery',
  /** column name */
  Status: 'status'
} as const;

export type NotificationChannelTemplatesSelectColumn = typeof NotificationChannelTemplatesSelectColumn[keyof typeof NotificationChannelTemplatesSelectColumn];
/** input type for updating data in table "notification_channel_templates" */
export type NotificationChannelTemplatesSetInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_channel_templates" */
export type NotificationChannelTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationChannelTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationChannelTemplatesStreamCursorValueInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  parent_resource_id?: InputMaybe<Scalars['String']>;
  parent_resource_type?: InputMaybe<Scalars['String']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_channel_templates" */
export const NotificationChannelTemplatesUpdateColumn = {
  /** column name */
  Disabled: 'disabled',
  /** column name */
  ShouldSendRecovery: 'should_send_recovery',
  /** column name */
  Status: 'status'
} as const;

export type NotificationChannelTemplatesUpdateColumn = typeof NotificationChannelTemplatesUpdateColumn[keyof typeof NotificationChannelTemplatesUpdateColumn];
export type NotificationChannelTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationChannelTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationChannelTemplatesBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "object_definition_groups" */
export type ObjectDefinitionGroups = {
  __typename?: 'object_definition_groups';
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  /** In some sources this is called catalog/table_catalog - top level hierarchy. NULL in sources that do not support it */
  database?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "object_definition_groups". All fields are combined with a logical 'AND'. */
export type ObjectDefinitionGroupsBoolExp = {
  _and?: InputMaybe<Array<ObjectDefinitionGroupsBoolExp>>;
  _not?: InputMaybe<ObjectDefinitionGroupsBoolExp>;
  _or?: InputMaybe<Array<ObjectDefinitionGroupsBoolExp>>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  database?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "object_definition_groups". */
export type ObjectDefinitionGroupsOrderBy = {
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  database?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "object_definition_groups" */
export const ObjectDefinitionGroupsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  Database: 'database',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ObjectDefinitionGroupsSelectColumn = typeof ObjectDefinitionGroupsSelectColumn[keyof typeof ObjectDefinitionGroupsSelectColumn];
/** Streaming cursor of the table "object_definition_groups" */
export type ObjectDefinitionGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ObjectDefinitionGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ObjectDefinitionGroupsStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  /** In some sources this is called catalog/table_catalog - top level hierarchy. NULL in sources that do not support it */
  database?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "object_definitions" */
export type ObjectDefinitions = {
  __typename?: 'object_definitions';
  connection_id?: Maybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  /** An array relationship */
  from_relationships: Array<Relationships>;
  id: Scalars['bigint'];
  important: Scalars['Boolean'];
  meta?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  object_definition_group?: Maybe<ObjectDefinitionGroups>;
  object_definition_group_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  plural_name?: Maybe<Scalars['String']>;
  singular_name?: Maybe<Scalars['String']>;
  special_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  to_relationships: Array<Relationships>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsFromRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<RelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipsOrderBy>>;
  where?: InputMaybe<RelationshipsBoolExp>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsObjectSchemasArgs = {
  distinct_on?: InputMaybe<Array<ObjectSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectSchemasOrderBy>>;
  where?: InputMaybe<ObjectSchemasBoolExp>;
};


/** columns and relationships of "object_definitions" */
export type ObjectDefinitionsToRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<RelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipsOrderBy>>;
  where?: InputMaybe<RelationshipsBoolExp>;
};

/** Boolean expression to filter rows from the table "object_definitions". All fields are combined with a logical 'AND'. */
export type ObjectDefinitionsBoolExp = {
  _and?: InputMaybe<Array<ObjectDefinitionsBoolExp>>;
  _not?: InputMaybe<ObjectDefinitionsBoolExp>;
  _or?: InputMaybe<Array<ObjectDefinitionsBoolExp>>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  from_relationships?: InputMaybe<RelationshipsBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  important?: InputMaybe<BooleanComparisonExp>;
  meta?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  object_definition_group?: InputMaybe<ObjectDefinitionGroupsBoolExp>;
  object_definition_group_id?: InputMaybe<BigintComparisonExp>;
  object_schemas?: InputMaybe<ObjectSchemasBoolExp>;
  plural_name?: InputMaybe<StringComparisonExp>;
  singular_name?: InputMaybe<StringComparisonExp>;
  special_type?: InputMaybe<StringComparisonExp>;
  to_relationships?: InputMaybe<RelationshipsBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** response of any mutation on the table "object_definitions" */
export type ObjectDefinitionsMutationResponse = {
  __typename?: 'object_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ObjectDefinitions>;
};

/** Ordering options when selecting data from "object_definitions". */
export type ObjectDefinitionsOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  from_relationships_aggregate?: InputMaybe<RelationshipsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  important?: InputMaybe<OrderBy>;
  meta?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  object_definition_group?: InputMaybe<ObjectDefinitionGroupsOrderBy>;
  object_definition_group_id?: InputMaybe<OrderBy>;
  object_schemas_aggregate?: InputMaybe<ObjectSchemasAggregateOrderBy>;
  plural_name?: InputMaybe<OrderBy>;
  singular_name?: InputMaybe<OrderBy>;
  special_type?: InputMaybe<OrderBy>;
  to_relationships_aggregate?: InputMaybe<RelationshipsAggregateOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: object_definitions */
export type ObjectDefinitionsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "object_definitions" */
export const ObjectDefinitionsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  Important: 'important',
  /** column name */
  Meta: 'meta',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionGroupId: 'object_definition_group_id',
  /** column name */
  PluralName: 'plural_name',
  /** column name */
  SingularName: 'singular_name',
  /** column name */
  SpecialType: 'special_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ObjectDefinitionsSelectColumn = typeof ObjectDefinitionsSelectColumn[keyof typeof ObjectDefinitionsSelectColumn];
/** input type for updating data in table "object_definitions" */
export type ObjectDefinitionsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  important?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  plural_name?: InputMaybe<Scalars['String']>;
  singular_name?: InputMaybe<Scalars['String']>;
  special_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "object_definitions" */
export type ObjectDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ObjectDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ObjectDefinitionsStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  important?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  object_definition_group_id?: InputMaybe<Scalars['bigint']>;
  plural_name?: InputMaybe<Scalars['String']>;
  singular_name?: InputMaybe<Scalars['String']>;
  special_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

export type ObjectDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ObjectDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: ObjectDefinitionsBoolExp;
};

/** columns and relationships of "object_schemas" */
export type ObjectSchemas = {
  __typename?: 'object_schemas';
  comment?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  /** An object relationship */
  object_definition: ObjectDefinitions;
  object_definition_id: Scalars['bigint'];
  type: Scalars['String'];
};

/** order by aggregate values of table "object_schemas" */
export type ObjectSchemasAggregateOrderBy = {
  avg?: InputMaybe<ObjectSchemasAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ObjectSchemasMaxOrderBy>;
  min?: InputMaybe<ObjectSchemasMinOrderBy>;
  stddev?: InputMaybe<ObjectSchemasStddevOrderBy>;
  stddev_pop?: InputMaybe<ObjectSchemasStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ObjectSchemasStddevSampOrderBy>;
  sum?: InputMaybe<ObjectSchemasSumOrderBy>;
  var_pop?: InputMaybe<ObjectSchemasVarPopOrderBy>;
  var_samp?: InputMaybe<ObjectSchemasVarSampOrderBy>;
  variance?: InputMaybe<ObjectSchemasVarianceOrderBy>;
};

/** order by avg() on columns of table "object_schemas" */
export type ObjectSchemasAvgOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "object_schemas". All fields are combined with a logical 'AND'. */
export type ObjectSchemasBoolExp = {
  _and?: InputMaybe<Array<ObjectSchemasBoolExp>>;
  _not?: InputMaybe<ObjectSchemasBoolExp>;
  _or?: InputMaybe<Array<ObjectSchemasBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  object_definition?: InputMaybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "object_schemas" */
export const ObjectSchemasConstraint = {
  /** unique or primary key constraint on columns "key", "object_definition_id" */
  ObjectSchemasPkey: 'object_schemas_pkey'
} as const;

export type ObjectSchemasConstraint = typeof ObjectSchemasConstraint[keyof typeof ObjectSchemasConstraint];
/** input type for inserting data into table "object_schemas" */
export type ObjectSchemasInsertInput = {
  key?: InputMaybe<Scalars['String']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "object_schemas" */
export type ObjectSchemasMaxOrderBy = {
  comment?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "object_schemas" */
export type ObjectSchemasMinOrderBy = {
  comment?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "object_schemas" */
export type ObjectSchemasMutationResponse = {
  __typename?: 'object_schemas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ObjectSchemas>;
};

/** on_conflict condition type for table "object_schemas" */
export type ObjectSchemasOnConflict = {
  constraint: ObjectSchemasConstraint;
  update_columns?: Array<ObjectSchemasUpdateColumn>;
  where?: InputMaybe<ObjectSchemasBoolExp>;
};

/** Ordering options when selecting data from "object_schemas". */
export type ObjectSchemasOrderBy = {
  comment?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  object_definition?: InputMaybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** select columns of table "object_schemas" */
export const ObjectSchemasSelectColumn = {
  /** column name */
  Comment: 'comment',
  /** column name */
  Key: 'key',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type ObjectSchemasSelectColumn = typeof ObjectSchemasSelectColumn[keyof typeof ObjectSchemasSelectColumn];
/** order by stddev() on columns of table "object_schemas" */
export type ObjectSchemasStddevOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "object_schemas" */
export type ObjectSchemasStddevPopOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "object_schemas" */
export type ObjectSchemasStddevSampOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "object_schemas" */
export type ObjectSchemasStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ObjectSchemasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ObjectSchemasStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "object_schemas" */
export type ObjectSchemasSumOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "object_schemas" (current role has no relevant permissions) */
export const ObjectSchemasUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type ObjectSchemasUpdateColumn = typeof ObjectSchemasUpdateColumn[keyof typeof ObjectSchemasUpdateColumn];
/** order by var_pop() on columns of table "object_schemas" */
export type ObjectSchemasVarPopOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "object_schemas" */
export type ObjectSchemasVarSampOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "object_schemas" */
export type ObjectSchemasVarianceOrderBy = {
  object_definition_id?: InputMaybe<OrderBy>;
};

/** column ordering options */
export const OrderBy = {
  /** in ascending order, nulls last */
  Asc: 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst: 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast: 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc: 'desc',
  /** in descending order, nulls first */
  DescNullsFirst: 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast: 'desc_nulls_last'
} as const;

export type OrderBy = typeof OrderBy[keyof typeof OrderBy];
/** columns and relationships of "organization_active_syncs" */
export type OrganizationActiveSyncs = {
  __typename?: 'organization_active_syncs';
  active_syncs: Scalars['Int'];
  calendar_month: Scalars['String'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['bigint'];
  pkey: Scalars['String'];
};

/** Boolean expression to filter rows from the table "organization_active_syncs". All fields are combined with a logical 'AND'. */
export type OrganizationActiveSyncsBoolExp = {
  _and?: InputMaybe<Array<OrganizationActiveSyncsBoolExp>>;
  _not?: InputMaybe<OrganizationActiveSyncsBoolExp>;
  _or?: InputMaybe<Array<OrganizationActiveSyncsBoolExp>>;
  active_syncs?: InputMaybe<IntComparisonExp>;
  calendar_month?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  pkey?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "organization_active_syncs". */
export type OrganizationActiveSyncsOrderBy = {
  active_syncs?: InputMaybe<OrderBy>;
  calendar_month?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  pkey?: InputMaybe<OrderBy>;
};

/** select columns of table "organization_active_syncs" */
export const OrganizationActiveSyncsSelectColumn = {
  /** column name */
  ActiveSyncs: 'active_syncs',
  /** column name */
  CalendarMonth: 'calendar_month',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  Pkey: 'pkey'
} as const;

export type OrganizationActiveSyncsSelectColumn = typeof OrganizationActiveSyncsSelectColumn[keyof typeof OrganizationActiveSyncsSelectColumn];
/** Streaming cursor of the table "organization_active_syncs" */
export type OrganizationActiveSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationActiveSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationActiveSyncsStreamCursorValueInput = {
  active_syncs?: InputMaybe<Scalars['Int']>;
  calendar_month?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  pkey?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "organization_invites" */
export type OrganizationInvites = {
  __typename?: 'organization_invites';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  expires_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['bigint'];
  recipient_email: Scalars['String'];
  /** An array relationship */
  user_groups: Array<OrganizationInvitesUserGroups>;
};


/** columns and relationships of "organization_invites" */
export type OrganizationInvitesUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesUserGroupsOrderBy>>;
  where?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
};

/** aggregated selection of "organization_invites" */
export type OrganizationInvitesAggregate = {
  __typename?: 'organization_invites_aggregate';
  aggregate?: Maybe<OrganizationInvitesAggregateFields>;
  nodes: Array<OrganizationInvites>;
};

/** aggregate fields of "organization_invites" */
export type OrganizationInvitesAggregateFields = {
  __typename?: 'organization_invites_aggregate_fields';
  avg?: Maybe<OrganizationInvitesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationInvitesMaxFields>;
  min?: Maybe<OrganizationInvitesMinFields>;
  stddev?: Maybe<OrganizationInvitesStddevFields>;
  stddev_pop?: Maybe<OrganizationInvitesStddevPopFields>;
  stddev_samp?: Maybe<OrganizationInvitesStddevSampFields>;
  sum?: Maybe<OrganizationInvitesSumFields>;
  var_pop?: Maybe<OrganizationInvitesVarPopFields>;
  var_samp?: Maybe<OrganizationInvitesVarSampFields>;
  variance?: Maybe<OrganizationInvitesVarianceFields>;
};


/** aggregate fields of "organization_invites" */
export type OrganizationInvitesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationInvitesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OrganizationInvitesAvgFields = {
  __typename?: 'organization_invites_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organization_invites". All fields are combined with a logical 'AND'. */
export type OrganizationInvitesBoolExp = {
  _and?: InputMaybe<Array<OrganizationInvitesBoolExp>>;
  _not?: InputMaybe<OrganizationInvitesBoolExp>;
  _or?: InputMaybe<Array<OrganizationInvitesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  expires_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  recipient_email?: InputMaybe<StringComparisonExp>;
  user_groups?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
};

/** aggregate max on columns */
export type OrganizationInvitesMaxFields = {
  __typename?: 'organization_invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
  recipient_email?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type OrganizationInvitesMinFields = {
  __typename?: 'organization_invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
  recipient_email?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organization_invites" */
export type OrganizationInvitesMutationResponse = {
  __typename?: 'organization_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationInvites>;
};

/** Ordering options when selecting data from "organization_invites". */
export type OrganizationInvitesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  expires_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  recipient_email?: InputMaybe<OrderBy>;
  user_groups_aggregate?: InputMaybe<OrganizationInvitesUserGroupsAggregateOrderBy>;
};

/** select columns of table "organization_invites" */
export const OrganizationInvitesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ExpiresAt: 'expires_at',
  /** column name */
  Id: 'id',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  RecipientEmail: 'recipient_email'
} as const;

export type OrganizationInvitesSelectColumn = typeof OrganizationInvitesSelectColumn[keyof typeof OrganizationInvitesSelectColumn];
/** aggregate stddev on columns */
export type OrganizationInvitesStddevFields = {
  __typename?: 'organization_invites_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OrganizationInvitesStddevPopFields = {
  __typename?: 'organization_invites_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OrganizationInvitesStddevSampFields = {
  __typename?: 'organization_invites_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organization_invites" */
export type OrganizationInvitesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationInvitesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationInvitesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  recipient_email?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type OrganizationInvitesSumFields = {
  __typename?: 'organization_invites_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "organization_invites_user_groups" */
export type OrganizationInvitesUserGroups = {
  __typename?: 'organization_invites_user_groups';
  organization_invite_id: Scalars['bigint'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
};

/** order by aggregate values of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsAggregateOrderBy = {
  avg?: InputMaybe<OrganizationInvitesUserGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganizationInvitesUserGroupsMaxOrderBy>;
  min?: InputMaybe<OrganizationInvitesUserGroupsMinOrderBy>;
  stddev?: InputMaybe<OrganizationInvitesUserGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganizationInvitesUserGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganizationInvitesUserGroupsStddevSampOrderBy>;
  sum?: InputMaybe<OrganizationInvitesUserGroupsSumOrderBy>;
  var_pop?: InputMaybe<OrganizationInvitesUserGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<OrganizationInvitesUserGroupsVarSampOrderBy>;
  variance?: InputMaybe<OrganizationInvitesUserGroupsVarianceOrderBy>;
};

/** order by avg() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsAvgOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organization_invites_user_groups". All fields are combined with a logical 'AND'. */
export type OrganizationInvitesUserGroupsBoolExp = {
  _and?: InputMaybe<Array<OrganizationInvitesUserGroupsBoolExp>>;
  _not?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
  _or?: InputMaybe<Array<OrganizationInvitesUserGroupsBoolExp>>;
  organization_invite_id?: InputMaybe<BigintComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsMaxOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsMinOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "organization_invites_user_groups". */
export type OrganizationInvitesUserGroupsOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** select columns of table "organization_invites_user_groups" */
export const OrganizationInvitesUserGroupsSelectColumn = {
  /** column name */
  OrganizationInviteId: 'organization_invite_id',
  /** column name */
  UserGroupId: 'user_group_id'
} as const;

export type OrganizationInvitesUserGroupsSelectColumn = typeof OrganizationInvitesUserGroupsSelectColumn[keyof typeof OrganizationInvitesUserGroupsSelectColumn];
/** order by stddev() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsStddevOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsStddevPopOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsStddevSampOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationInvitesUserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationInvitesUserGroupsStreamCursorValueInput = {
  organization_invite_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsSumOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsVarPopOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsVarSampOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "organization_invites_user_groups" */
export type OrganizationInvitesUserGroupsVarianceOrderBy = {
  organization_invite_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type OrganizationInvitesVarPopFields = {
  __typename?: 'organization_invites_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OrganizationInvitesVarSampFields = {
  __typename?: 'organization_invites_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OrganizationInvitesVarianceFields = {
  __typename?: 'organization_invites_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "organization_members" */
export type OrganizationMembers = {
  __typename?: 'organization_members';
  is_group_manager?: Maybe<Scalars['Boolean']>;
  is_organization_admin?: Maybe<Scalars['Boolean']>;
  is_sso?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_group?: Maybe<UserGroups>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "organization_members" */
export type OrganizationMembersAggregate = {
  __typename?: 'organization_members_aggregate';
  aggregate?: Maybe<OrganizationMembersAggregateFields>;
  nodes: Array<OrganizationMembers>;
};

export type OrganizationMembersAggregateBoolExp = {
  bool_and?: InputMaybe<OrganizationMembersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganizationMembersAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganizationMembersAggregateBoolExpCount>;
};

export type OrganizationMembersAggregateBoolExpBoolAnd = {
  arguments: OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OrganizationMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganizationMembersAggregateBoolExpBoolOr = {
  arguments: OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OrganizationMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganizationMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OrganizationMembersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organization_members" */
export type OrganizationMembersAggregateFields = {
  __typename?: 'organization_members_aggregate_fields';
  avg?: Maybe<OrganizationMembersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationMembersMaxFields>;
  min?: Maybe<OrganizationMembersMinFields>;
  stddev?: Maybe<OrganizationMembersStddevFields>;
  stddev_pop?: Maybe<OrganizationMembersStddevPopFields>;
  stddev_samp?: Maybe<OrganizationMembersStddevSampFields>;
  sum?: Maybe<OrganizationMembersSumFields>;
  var_pop?: Maybe<OrganizationMembersVarPopFields>;
  var_samp?: Maybe<OrganizationMembersVarSampFields>;
  variance?: Maybe<OrganizationMembersVarianceFields>;
};


/** aggregate fields of "organization_members" */
export type OrganizationMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_members" */
export type OrganizationMembersAggregateOrderBy = {
  avg?: InputMaybe<OrganizationMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganizationMembersMaxOrderBy>;
  min?: InputMaybe<OrganizationMembersMinOrderBy>;
  stddev?: InputMaybe<OrganizationMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganizationMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganizationMembersStddevSampOrderBy>;
  sum?: InputMaybe<OrganizationMembersSumOrderBy>;
  var_pop?: InputMaybe<OrganizationMembersVarPopOrderBy>;
  var_samp?: InputMaybe<OrganizationMembersVarSampOrderBy>;
  variance?: InputMaybe<OrganizationMembersVarianceOrderBy>;
};

/** aggregate avg on columns */
export type OrganizationMembersAvgFields = {
  __typename?: 'organization_members_avg_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organization_members" */
export type OrganizationMembersAvgOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organization_members". All fields are combined with a logical 'AND'. */
export type OrganizationMembersBoolExp = {
  _and?: InputMaybe<Array<OrganizationMembersBoolExp>>;
  _not?: InputMaybe<OrganizationMembersBoolExp>;
  _or?: InputMaybe<Array<OrganizationMembersBoolExp>>;
  is_group_manager?: InputMaybe<BooleanComparisonExp>;
  is_organization_admin?: InputMaybe<BooleanComparisonExp>;
  is_sso?: InputMaybe<BooleanComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
};

/** columns and relationships of "organization_members_distinct" */
export type OrganizationMembersDistinct = {
  __typename?: 'organization_members_distinct';
  is_sso?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  memberships: Array<OrganizationMembers>;
  /** An aggregate relationship */
  memberships_aggregate: OrganizationMembersAggregate;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "organization_members_distinct" */
export type OrganizationMembersDistinctMembershipsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "organization_members_distinct" */
export type OrganizationMembersDistinctMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};

/** aggregated selection of "organization_members_distinct" */
export type OrganizationMembersDistinctAggregate = {
  __typename?: 'organization_members_distinct_aggregate';
  aggregate?: Maybe<OrganizationMembersDistinctAggregateFields>;
  nodes: Array<OrganizationMembersDistinct>;
};

/** aggregate fields of "organization_members_distinct" */
export type OrganizationMembersDistinctAggregateFields = {
  __typename?: 'organization_members_distinct_aggregate_fields';
  avg?: Maybe<OrganizationMembersDistinctAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationMembersDistinctMaxFields>;
  min?: Maybe<OrganizationMembersDistinctMinFields>;
  stddev?: Maybe<OrganizationMembersDistinctStddevFields>;
  stddev_pop?: Maybe<OrganizationMembersDistinctStddevPopFields>;
  stddev_samp?: Maybe<OrganizationMembersDistinctStddevSampFields>;
  sum?: Maybe<OrganizationMembersDistinctSumFields>;
  var_pop?: Maybe<OrganizationMembersDistinctVarPopFields>;
  var_samp?: Maybe<OrganizationMembersDistinctVarSampFields>;
  variance?: Maybe<OrganizationMembersDistinctVarianceFields>;
};


/** aggregate fields of "organization_members_distinct" */
export type OrganizationMembersDistinctAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationMembersDistinctSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OrganizationMembersDistinctAvgFields = {
  __typename?: 'organization_members_distinct_avg_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organization_members_distinct". All fields are combined with a logical 'AND'. */
export type OrganizationMembersDistinctBoolExp = {
  _and?: InputMaybe<Array<OrganizationMembersDistinctBoolExp>>;
  _not?: InputMaybe<OrganizationMembersDistinctBoolExp>;
  _or?: InputMaybe<Array<OrganizationMembersDistinctBoolExp>>;
  is_sso?: InputMaybe<BooleanComparisonExp>;
  memberships?: InputMaybe<OrganizationMembersBoolExp>;
  memberships_aggregate?: InputMaybe<OrganizationMembersAggregateBoolExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type OrganizationMembersDistinctMaxFields = {
  __typename?: 'organization_members_distinct_max_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type OrganizationMembersDistinctMinFields = {
  __typename?: 'organization_members_distinct_min_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "organization_members_distinct". */
export type OrganizationMembersDistinctOrderBy = {
  is_sso?: InputMaybe<OrderBy>;
  memberships_aggregate?: InputMaybe<OrganizationMembersAggregateOrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "organization_members_distinct" */
export const OrganizationMembersDistinctSelectColumn = {
  /** column name */
  IsSso: 'is_sso',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  UserId: 'user_id'
} as const;

export type OrganizationMembersDistinctSelectColumn = typeof OrganizationMembersDistinctSelectColumn[keyof typeof OrganizationMembersDistinctSelectColumn];
/** aggregate stddev on columns */
export type OrganizationMembersDistinctStddevFields = {
  __typename?: 'organization_members_distinct_stddev_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OrganizationMembersDistinctStddevPopFields = {
  __typename?: 'organization_members_distinct_stddev_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OrganizationMembersDistinctStddevSampFields = {
  __typename?: 'organization_members_distinct_stddev_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organization_members_distinct" */
export type OrganizationMembersDistinctStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationMembersDistinctStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationMembersDistinctStreamCursorValueInput = {
  is_sso?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type OrganizationMembersDistinctSumFields = {
  __typename?: 'organization_members_distinct_sum_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type OrganizationMembersDistinctVarPopFields = {
  __typename?: 'organization_members_distinct_var_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OrganizationMembersDistinctVarSampFields = {
  __typename?: 'organization_members_distinct_var_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OrganizationMembersDistinctVarianceFields = {
  __typename?: 'organization_members_distinct_variance_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type OrganizationMembersMaxFields = {
  __typename?: 'organization_members_max_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "organization_members" */
export type OrganizationMembersMaxOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OrganizationMembersMinFields = {
  __typename?: 'organization_members_min_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "organization_members" */
export type OrganizationMembersMinOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "organization_members". */
export type OrganizationMembersOrderBy = {
  is_group_manager?: InputMaybe<OrderBy>;
  is_organization_admin?: InputMaybe<OrderBy>;
  is_sso?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "organization_members" */
export const OrganizationMembersSelectColumn = {
  /** column name */
  IsGroupManager: 'is_group_manager',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin',
  /** column name */
  IsSso: 'is_sso',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id'
} as const;

export type OrganizationMembersSelectColumn = typeof OrganizationMembersSelectColumn[keyof typeof OrganizationMembersSelectColumn];
/** select "organization_members_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_members" */
export const OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsGroupManager: 'is_group_manager',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin',
  /** column name */
  IsSso: 'is_sso'
} as const;

export type OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolAndArgumentsColumns = typeof OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolAndArgumentsColumns[keyof typeof OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolAndArgumentsColumns];
/** select "organization_members_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_members" */
export const OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsGroupManager: 'is_group_manager',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin',
  /** column name */
  IsSso: 'is_sso'
} as const;

export type OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolOrArgumentsColumns = typeof OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolOrArgumentsColumns[keyof typeof OrganizationMembersSelectColumnOrganizationMembersAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type OrganizationMembersStddevFields = {
  __typename?: 'organization_members_stddev_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organization_members" */
export type OrganizationMembersStddevOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type OrganizationMembersStddevPopFields = {
  __typename?: 'organization_members_stddev_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organization_members" */
export type OrganizationMembersStddevPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type OrganizationMembersStddevSampFields = {
  __typename?: 'organization_members_stddev_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organization_members" */
export type OrganizationMembersStddevSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "organization_members" */
export type OrganizationMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationMembersStreamCursorValueInput = {
  is_group_manager?: InputMaybe<Scalars['Boolean']>;
  is_organization_admin?: InputMaybe<Scalars['Boolean']>;
  is_sso?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type OrganizationMembersSumFields = {
  __typename?: 'organization_members_sum_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "organization_members" */
export type OrganizationMembersSumOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type OrganizationMembersVarPopFields = {
  __typename?: 'organization_members_var_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organization_members" */
export type OrganizationMembersVarPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type OrganizationMembersVarSampFields = {
  __typename?: 'organization_members_var_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organization_members" */
export type OrganizationMembersVarSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OrganizationMembersVarianceFields = {
  __typename?: 'organization_members_variance_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organization_members" */
export type OrganizationMembersVarianceOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "organization_overage_dates" */
export type OrganizationOverageDates = {
  __typename?: 'organization_overage_dates';
  entitlements?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['bigint']>;
  is_org_in_overage?: Maybe<Scalars['Boolean']>;
  num_paid_destination_types?: Maybe<Scalars['bigint']>;
  num_premium_destination_types?: Maybe<Scalars['bigint']>;
  overage_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  workspaces: Array<Workspaces>;
};


/** columns and relationships of "organization_overage_dates" */
export type OrganizationOverageDatesEntitlementsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization_overage_dates" */
export type OrganizationOverageDatesWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<WorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspacesOrderBy>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};

/** Boolean expression to filter rows from the table "organization_overage_dates". All fields are combined with a logical 'AND'. */
export type OrganizationOverageDatesBoolExp = {
  _and?: InputMaybe<Array<OrganizationOverageDatesBoolExp>>;
  _not?: InputMaybe<OrganizationOverageDatesBoolExp>;
  _or?: InputMaybe<Array<OrganizationOverageDatesBoolExp>>;
  entitlements?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_org_in_overage?: InputMaybe<BooleanComparisonExp>;
  num_paid_destination_types?: InputMaybe<BigintComparisonExp>;
  num_premium_destination_types?: InputMaybe<BigintComparisonExp>;
  overage_date?: InputMaybe<DateComparisonExp>;
  workspaces?: InputMaybe<WorkspacesBoolExp>;
};

/** Ordering options when selecting data from "organization_overage_dates". */
export type OrganizationOverageDatesOrderBy = {
  entitlements?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_org_in_overage?: InputMaybe<OrderBy>;
  num_paid_destination_types?: InputMaybe<OrderBy>;
  num_premium_destination_types?: InputMaybe<OrderBy>;
  overage_date?: InputMaybe<OrderBy>;
  workspaces_aggregate?: InputMaybe<WorkspacesAggregateOrderBy>;
};

/** select columns of table "organization_overage_dates" */
export const OrganizationOverageDatesSelectColumn = {
  /** column name */
  Entitlements: 'entitlements',
  /** column name */
  Id: 'id',
  /** column name */
  IsOrgInOverage: 'is_org_in_overage',
  /** column name */
  NumPaidDestinationTypes: 'num_paid_destination_types',
  /** column name */
  NumPremiumDestinationTypes: 'num_premium_destination_types',
  /** column name */
  OverageDate: 'overage_date'
} as const;

export type OrganizationOverageDatesSelectColumn = typeof OrganizationOverageDatesSelectColumn[keyof typeof OrganizationOverageDatesSelectColumn];
/** Streaming cursor of the table "organization_overage_dates" */
export type OrganizationOverageDatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationOverageDatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationOverageDatesStreamCursorValueInput = {
  entitlements?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_org_in_overage?: InputMaybe<Scalars['Boolean']>;
  num_paid_destination_types?: InputMaybe<Scalars['bigint']>;
  num_premium_destination_types?: InputMaybe<Scalars['bigint']>;
  overage_date?: InputMaybe<Scalars['date']>;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  ai_feature_settings: Scalars['jsonb'];
  api_key?: Maybe<Scalars['String']>;
  /** An array relationship */
  auth0_connections: Array<Auth0Connections>;
  billing?: Maybe<Scalars['jsonb']>;
  can_invite_users?: Maybe<Scalars['Boolean']>;
  custom_lockout_message?: Maybe<Scalars['String']>;
  entitlements?: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  lock_popup_date?: Maybe<Scalars['timestamptz']>;
  logo_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  organization_members: Array<OrganizationMembers>;
  /** An aggregate relationship */
  organization_members_aggregate: OrganizationMembersAggregate;
  override_sso_roles?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  plan?: Maybe<BillingProducts>;
  product_id?: Maybe<Scalars['uuid']>;
  require_sso_login: Scalars['Boolean'];
  requires_sensitive_data_controls?: Maybe<Scalars['Boolean']>;
  show_lock_popup: Scalars['Boolean'];
  slug: Scalars['String'];
  /** An array relationship */
  sso_groups: Array<SsoGroups>;
  support_access_type: Scalars['String'];
  /** An array relationship */
  user_groups: Array<UserGroups>;
  /** An aggregate relationship */
  user_groups_aggregate: UserGroupsAggregate;
  /** An array relationship */
  workspaces: Array<Workspaces>;
};


/** columns and relationships of "organizations" */
export type OrganizationsAiFeatureSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsAuth0ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<Auth0ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth0ConnectionsOrderBy>>;
  where?: InputMaybe<Auth0ConnectionsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsBillingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsEntitlementsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationMembersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsSsoGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUserGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<WorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspacesOrderBy>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OrganizationsAppendInput = {
  ai_feature_settings?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsBoolExp>>;
  _not?: InputMaybe<OrganizationsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsBoolExp>>;
  ai_feature_settings?: InputMaybe<JsonbComparisonExp>;
  api_key?: InputMaybe<StringComparisonExp>;
  auth0_connections?: InputMaybe<Auth0ConnectionsBoolExp>;
  billing?: InputMaybe<JsonbComparisonExp>;
  can_invite_users?: InputMaybe<BooleanComparisonExp>;
  custom_lockout_message?: InputMaybe<StringComparisonExp>;
  entitlements?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  lock_popup_date?: InputMaybe<TimestamptzComparisonExp>;
  logo_url?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization_members?: InputMaybe<OrganizationMembersBoolExp>;
  organization_members_aggregate?: InputMaybe<OrganizationMembersAggregateBoolExp>;
  override_sso_roles?: InputMaybe<BooleanComparisonExp>;
  plan?: InputMaybe<BillingProductsBoolExp>;
  product_id?: InputMaybe<UuidComparisonExp>;
  require_sso_login?: InputMaybe<BooleanComparisonExp>;
  requires_sensitive_data_controls?: InputMaybe<BooleanComparisonExp>;
  show_lock_popup?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  sso_groups?: InputMaybe<SsoGroupsBoolExp>;
  support_access_type?: InputMaybe<StringComparisonExp>;
  user_groups?: InputMaybe<UserGroupsBoolExp>;
  user_groups_aggregate?: InputMaybe<UserGroupsAggregateBoolExp>;
  workspaces?: InputMaybe<WorkspacesBoolExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OrganizationsDeleteAtPathInput = {
  ai_feature_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OrganizationsDeleteElemInput = {
  ai_feature_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OrganizationsDeleteKeyInput = {
  ai_feature_settings?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "organizations" */
export type OrganizationsMutationResponse = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  ai_feature_settings?: InputMaybe<OrderBy>;
  api_key?: InputMaybe<OrderBy>;
  auth0_connections_aggregate?: InputMaybe<Auth0ConnectionsAggregateOrderBy>;
  billing?: InputMaybe<OrderBy>;
  can_invite_users?: InputMaybe<OrderBy>;
  custom_lockout_message?: InputMaybe<OrderBy>;
  entitlements?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lock_popup_date?: InputMaybe<OrderBy>;
  logo_url?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_members_aggregate?: InputMaybe<OrganizationMembersAggregateOrderBy>;
  override_sso_roles?: InputMaybe<OrderBy>;
  plan?: InputMaybe<BillingProductsOrderBy>;
  product_id?: InputMaybe<OrderBy>;
  require_sso_login?: InputMaybe<OrderBy>;
  requires_sensitive_data_controls?: InputMaybe<OrderBy>;
  show_lock_popup?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  sso_groups_aggregate?: InputMaybe<SsoGroupsAggregateOrderBy>;
  support_access_type?: InputMaybe<OrderBy>;
  user_groups_aggregate?: InputMaybe<UserGroupsAggregateOrderBy>;
  workspaces_aggregate?: InputMaybe<WorkspacesAggregateOrderBy>;
};

/** primary key columns input for table: organizations */
export type OrganizationsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OrganizationsPrependInput = {
  ai_feature_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "organizations" */
export const OrganizationsSelectColumn = {
  /** column name */
  AiFeatureSettings: 'ai_feature_settings',
  /** column name */
  ApiKey: 'api_key',
  /** column name */
  Billing: 'billing',
  /** column name */
  CanInviteUsers: 'can_invite_users',
  /** column name */
  CustomLockoutMessage: 'custom_lockout_message',
  /** column name */
  Entitlements: 'entitlements',
  /** column name */
  Id: 'id',
  /** column name */
  LockPopupDate: 'lock_popup_date',
  /** column name */
  LogoUrl: 'logo_url',
  /** column name */
  Name: 'name',
  /** column name */
  OverrideSsoRoles: 'override_sso_roles',
  /** column name */
  ProductId: 'product_id',
  /** column name */
  RequireSsoLogin: 'require_sso_login',
  /** column name */
  RequiresSensitiveDataControls: 'requires_sensitive_data_controls',
  /** column name */
  ShowLockPopup: 'show_lock_popup',
  /** column name */
  Slug: 'slug',
  /** column name */
  SupportAccessType: 'support_access_type'
} as const;

export type OrganizationsSelectColumn = typeof OrganizationsSelectColumn[keyof typeof OrganizationsSelectColumn];
/** input type for updating data in table "organizations" */
export type OrganizationsSetInput = {
  ai_feature_settings?: InputMaybe<Scalars['jsonb']>;
  api_key?: InputMaybe<Scalars['String']>;
  can_invite_users?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  support_access_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organizations" */
export type OrganizationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsStreamCursorValueInput = {
  ai_feature_settings?: InputMaybe<Scalars['jsonb']>;
  api_key?: InputMaybe<Scalars['String']>;
  billing?: InputMaybe<Scalars['jsonb']>;
  can_invite_users?: InputMaybe<Scalars['Boolean']>;
  custom_lockout_message?: InputMaybe<Scalars['String']>;
  entitlements?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  lock_popup_date?: InputMaybe<Scalars['timestamptz']>;
  logo_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  override_sso_roles?: InputMaybe<Scalars['Boolean']>;
  product_id?: InputMaybe<Scalars['uuid']>;
  require_sso_login?: InputMaybe<Scalars['Boolean']>;
  requires_sensitive_data_controls?: InputMaybe<Scalars['Boolean']>;
  show_lock_popup?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  support_access_type?: InputMaybe<Scalars['String']>;
};

export type OrganizationsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OrganizationsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OrganizationsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OrganizationsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OrganizationsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OrganizationsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsBoolExp;
};

/** columns and relationships of "pagerduty_credentials" */
export type PagerdutyCredentials = {
  __typename?: 'pagerduty_credentials';
  config: Scalars['jsonb'];
  id: Scalars['Int'];
  state: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "pagerduty_credentials" */
export type PagerdutyCredentialsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PagerdutyCredentialsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "pagerduty_credentials". All fields are combined with a logical 'AND'. */
export type PagerdutyCredentialsBoolExp = {
  _and?: InputMaybe<Array<PagerdutyCredentialsBoolExp>>;
  _not?: InputMaybe<PagerdutyCredentialsBoolExp>;
  _or?: InputMaybe<Array<PagerdutyCredentialsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pagerduty_credentials" */
export const PagerdutyCredentialsConstraint = {
  /** unique or primary key constraint on columns "id" */
  PagerdutyCredentialsPkey: 'pagerduty_credentials_pkey',
  /** unique or primary key constraint on columns "workspace_id" */
  PagerdutyCredentialsWorkspaceIdKey: 'pagerduty_credentials_workspace_id_key',
  /** unique or primary key constraint on columns "workspace_id" */
  PagerdutyCredentialsWorkspaceIdKeyIdx: 'pagerduty_credentials_workspace_id_key_idx'
} as const;

export type PagerdutyCredentialsConstraint = typeof PagerdutyCredentialsConstraint[keyof typeof PagerdutyCredentialsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PagerdutyCredentialsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PagerdutyCredentialsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PagerdutyCredentialsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "pagerduty_credentials" */
export type PagerdutyCredentialsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "pagerduty_credentials" */
export type PagerdutyCredentialsMutationResponse = {
  __typename?: 'pagerduty_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PagerdutyCredentials>;
};

/** input type for inserting object relation for remote table "pagerduty_credentials" */
export type PagerdutyCredentialsObjRelInsertInput = {
  data: PagerdutyCredentialsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PagerdutyCredentialsOnConflict>;
};

/** on_conflict condition type for table "pagerduty_credentials" */
export type PagerdutyCredentialsOnConflict = {
  constraint: PagerdutyCredentialsConstraint;
  update_columns?: Array<PagerdutyCredentialsUpdateColumn>;
  where?: InputMaybe<PagerdutyCredentialsBoolExp>;
};

/** Ordering options when selecting data from "pagerduty_credentials". */
export type PagerdutyCredentialsOrderBy = {
  config?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pagerduty_credentials */
export type PagerdutyCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PagerdutyCredentialsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "pagerduty_credentials" */
export const PagerdutyCredentialsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PagerdutyCredentialsSelectColumn = typeof PagerdutyCredentialsSelectColumn[keyof typeof PagerdutyCredentialsSelectColumn];
/** input type for updating data in table "pagerduty_credentials" */
export type PagerdutyCredentialsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "pagerduty_credentials" */
export type PagerdutyCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PagerdutyCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PagerdutyCredentialsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** update columns of table "pagerduty_credentials" */
export const PagerdutyCredentialsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  State: 'state'
} as const;

export type PagerdutyCredentialsUpdateColumn = typeof PagerdutyCredentialsUpdateColumn[keyof typeof PagerdutyCredentialsUpdateColumn];
export type PagerdutyCredentialsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PagerdutyCredentialsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PagerdutyCredentialsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PagerdutyCredentialsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PagerdutyCredentialsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PagerdutyCredentialsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PagerdutyCredentialsSetInput>;
  /** filter the rows which have to be updated */
  where: PagerdutyCredentialsBoolExp;
};

/** Stores ML model artifacts produced by predictive traits training jobs */
export type PredictorArtifacts = {
  __typename?: 'predictor_artifacts';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  predictor: Predictors;
  predictor_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** Stores ML model artifacts produced by predictive traits training jobs */
export type PredictorArtifactsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "predictor_artifacts" */
export type PredictorArtifactsAggregate = {
  __typename?: 'predictor_artifacts_aggregate';
  aggregate?: Maybe<PredictorArtifactsAggregateFields>;
  nodes: Array<PredictorArtifacts>;
};

export type PredictorArtifactsAggregateBoolExp = {
  count?: InputMaybe<PredictorArtifactsAggregateBoolExpCount>;
};

export type PredictorArtifactsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PredictorArtifactsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "predictor_artifacts" */
export type PredictorArtifactsAggregateFields = {
  __typename?: 'predictor_artifacts_aggregate_fields';
  avg?: Maybe<PredictorArtifactsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PredictorArtifactsMaxFields>;
  min?: Maybe<PredictorArtifactsMinFields>;
  stddev?: Maybe<PredictorArtifactsStddevFields>;
  stddev_pop?: Maybe<PredictorArtifactsStddevPopFields>;
  stddev_samp?: Maybe<PredictorArtifactsStddevSampFields>;
  sum?: Maybe<PredictorArtifactsSumFields>;
  var_pop?: Maybe<PredictorArtifactsVarPopFields>;
  var_samp?: Maybe<PredictorArtifactsVarSampFields>;
  variance?: Maybe<PredictorArtifactsVarianceFields>;
};


/** aggregate fields of "predictor_artifacts" */
export type PredictorArtifactsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "predictor_artifacts" */
export type PredictorArtifactsAggregateOrderBy = {
  avg?: InputMaybe<PredictorArtifactsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PredictorArtifactsMaxOrderBy>;
  min?: InputMaybe<PredictorArtifactsMinOrderBy>;
  stddev?: InputMaybe<PredictorArtifactsStddevOrderBy>;
  stddev_pop?: InputMaybe<PredictorArtifactsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PredictorArtifactsStddevSampOrderBy>;
  sum?: InputMaybe<PredictorArtifactsSumOrderBy>;
  var_pop?: InputMaybe<PredictorArtifactsVarPopOrderBy>;
  var_samp?: InputMaybe<PredictorArtifactsVarSampOrderBy>;
  variance?: InputMaybe<PredictorArtifactsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type PredictorArtifactsAvgFields = {
  __typename?: 'predictor_artifacts_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "predictor_artifacts" */
export type PredictorArtifactsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "predictor_artifacts". All fields are combined with a logical 'AND'. */
export type PredictorArtifactsBoolExp = {
  _and?: InputMaybe<Array<PredictorArtifactsBoolExp>>;
  _not?: InputMaybe<PredictorArtifactsBoolExp>;
  _or?: InputMaybe<Array<PredictorArtifactsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  predictor?: InputMaybe<PredictorsBoolExp>;
  predictor_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type PredictorArtifactsMaxFields = {
  __typename?: 'predictor_artifacts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "predictor_artifacts" */
export type PredictorArtifactsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PredictorArtifactsMinFields = {
  __typename?: 'predictor_artifacts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "predictor_artifacts" */
export type PredictorArtifactsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "predictor_artifacts". */
export type PredictorArtifactsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  predictor?: InputMaybe<PredictorsOrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "predictor_artifacts" */
export const PredictorArtifactsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  PredictorId: 'predictor_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorArtifactsSelectColumn = typeof PredictorArtifactsSelectColumn[keyof typeof PredictorArtifactsSelectColumn];
/** aggregate stddev on columns */
export type PredictorArtifactsStddevFields = {
  __typename?: 'predictor_artifacts_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "predictor_artifacts" */
export type PredictorArtifactsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type PredictorArtifactsStddevPopFields = {
  __typename?: 'predictor_artifacts_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "predictor_artifacts" */
export type PredictorArtifactsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type PredictorArtifactsStddevSampFields = {
  __typename?: 'predictor_artifacts_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "predictor_artifacts" */
export type PredictorArtifactsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "predictor_artifacts" */
export type PredictorArtifactsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorArtifactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorArtifactsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  predictor_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PredictorArtifactsSumFields = {
  __typename?: 'predictor_artifacts_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "predictor_artifacts" */
export type PredictorArtifactsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type PredictorArtifactsVarPopFields = {
  __typename?: 'predictor_artifacts_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "predictor_artifacts" */
export type PredictorArtifactsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type PredictorArtifactsVarSampFields = {
  __typename?: 'predictor_artifacts_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "predictor_artifacts" */
export type PredictorArtifactsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PredictorArtifactsVarianceFields = {
  __typename?: 'predictor_artifacts_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "predictor_artifacts" */
export type PredictorArtifactsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEvents = {
  __typename?: 'predictor_feature_definition_events';
  /** An object relationship */
  cached_event_pull: CachedEventPulls;
  cached_event_pull_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  feature_definition_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsAggregateOrderBy = {
  avg?: InputMaybe<PredictorFeatureDefinitionEventsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PredictorFeatureDefinitionEventsMaxOrderBy>;
  min?: InputMaybe<PredictorFeatureDefinitionEventsMinOrderBy>;
  stddev?: InputMaybe<PredictorFeatureDefinitionEventsStddevOrderBy>;
  stddev_pop?: InputMaybe<PredictorFeatureDefinitionEventsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PredictorFeatureDefinitionEventsStddevSampOrderBy>;
  sum?: InputMaybe<PredictorFeatureDefinitionEventsSumOrderBy>;
  var_pop?: InputMaybe<PredictorFeatureDefinitionEventsVarPopOrderBy>;
  var_samp?: InputMaybe<PredictorFeatureDefinitionEventsVarSampOrderBy>;
  variance?: InputMaybe<PredictorFeatureDefinitionEventsVarianceOrderBy>;
};

/** order by avg() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "predictor_feature_definition_events". All fields are combined with a logical 'AND'. */
export type PredictorFeatureDefinitionEventsBoolExp = {
  _and?: InputMaybe<Array<PredictorFeatureDefinitionEventsBoolExp>>;
  _not?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
  _or?: InputMaybe<Array<PredictorFeatureDefinitionEventsBoolExp>>;
  cached_event_pull?: InputMaybe<CachedEventPullsBoolExp>;
  cached_event_pull_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  feature_definition_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsMaxOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  feature_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsMinOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  feature_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsMutationResponse = {
  __typename?: 'predictor_feature_definition_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PredictorFeatureDefinitionEvents>;
};

/** Ordering options when selecting data from "predictor_feature_definition_events". */
export type PredictorFeatureDefinitionEventsOrderBy = {
  cached_event_pull?: InputMaybe<CachedEventPullsOrderBy>;
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  feature_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: predictor_feature_definition_events */
export type PredictorFeatureDefinitionEventsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "predictor_feature_definition_events" */
export const PredictorFeatureDefinitionEventsSelectColumn = {
  /** column name */
  CachedEventPullId: 'cached_event_pull_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FeatureDefinitionId: 'feature_definition_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorFeatureDefinitionEventsSelectColumn = typeof PredictorFeatureDefinitionEventsSelectColumn[keyof typeof PredictorFeatureDefinitionEventsSelectColumn];
/** input type for updating data in table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorFeatureDefinitionEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorFeatureDefinitionEventsStreamCursorValueInput = {
  cached_event_pull_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature_definition_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

export type PredictorFeatureDefinitionEventsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PredictorFeatureDefinitionEventsSetInput>;
  /** filter the rows which have to be updated */
  where: PredictorFeatureDefinitionEventsBoolExp;
};

/** order by var_pop() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "predictor_feature_definition_events" */
export type PredictorFeatureDefinitionEventsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "predictor_feature_definitions" */
export type PredictorFeatureDefinitions = {
  __typename?: 'predictor_feature_definitions';
  catalog_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  predictor_feature_definition_events: Array<PredictorFeatureDefinitionEvents>;
  properties: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsPredictorFeatureDefinitionEventsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionEventsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
};


/** columns and relationships of "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsAggregateOrderBy = {
  avg?: InputMaybe<PredictorFeatureDefinitionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PredictorFeatureDefinitionsMaxOrderBy>;
  min?: InputMaybe<PredictorFeatureDefinitionsMinOrderBy>;
  stddev?: InputMaybe<PredictorFeatureDefinitionsStddevOrderBy>;
  stddev_pop?: InputMaybe<PredictorFeatureDefinitionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PredictorFeatureDefinitionsStddevSampOrderBy>;
  sum?: InputMaybe<PredictorFeatureDefinitionsSumOrderBy>;
  var_pop?: InputMaybe<PredictorFeatureDefinitionsVarPopOrderBy>;
  var_samp?: InputMaybe<PredictorFeatureDefinitionsVarSampOrderBy>;
  variance?: InputMaybe<PredictorFeatureDefinitionsVarianceOrderBy>;
};

/** order by avg() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsAvgOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "predictor_feature_definitions". All fields are combined with a logical 'AND'. */
export type PredictorFeatureDefinitionsBoolExp = {
  _and?: InputMaybe<Array<PredictorFeatureDefinitionsBoolExp>>;
  _not?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
  _or?: InputMaybe<Array<PredictorFeatureDefinitionsBoolExp>>;
  catalog_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  predictor_feature_definition_events?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsMaxOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsMinOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsMutationResponse = {
  __typename?: 'predictor_feature_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PredictorFeatureDefinitions>;
};

/** Ordering options when selecting data from "predictor_feature_definitions". */
export type PredictorFeatureDefinitionsOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  predictor_feature_definition_events_aggregate?: InputMaybe<PredictorFeatureDefinitionEventsAggregateOrderBy>;
  properties?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: predictor_feature_definitions */
export type PredictorFeatureDefinitionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "predictor_feature_definitions" */
export const PredictorFeatureDefinitionsSelectColumn = {
  /** column name */
  CatalogId: 'catalog_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Properties: 'properties',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorFeatureDefinitionsSelectColumn = typeof PredictorFeatureDefinitionsSelectColumn[keyof typeof PredictorFeatureDefinitionsSelectColumn];
/** input type for updating data in table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsStddevOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsStddevPopOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsStddevSampOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorFeatureDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorFeatureDefinitionsStreamCursorValueInput = {
  catalog_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsSumOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type PredictorFeatureDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PredictorFeatureDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: PredictorFeatureDefinitionsBoolExp;
};

/** order by var_pop() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsVarPopOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsVarSampOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "predictor_feature_definitions" */
export type PredictorFeatureDefinitionsVarianceOrderBy = {
  catalog_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "predictor_outcomes" */
export type PredictorOutcomes = {
  __typename?: 'predictor_outcomes';
  /** An object relationship */
  cached_event_pull: CachedEventPulls;
  cached_event_pull_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  definition?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  timeframe: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "predictor_outcomes" */
export type PredictorOutcomesDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "predictor_outcomes" */
export type PredictorOutcomesTimeframeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "predictor_outcomes" */
export type PredictorOutcomesAggregateOrderBy = {
  avg?: InputMaybe<PredictorOutcomesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PredictorOutcomesMaxOrderBy>;
  min?: InputMaybe<PredictorOutcomesMinOrderBy>;
  stddev?: InputMaybe<PredictorOutcomesStddevOrderBy>;
  stddev_pop?: InputMaybe<PredictorOutcomesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PredictorOutcomesStddevSampOrderBy>;
  sum?: InputMaybe<PredictorOutcomesSumOrderBy>;
  var_pop?: InputMaybe<PredictorOutcomesVarPopOrderBy>;
  var_samp?: InputMaybe<PredictorOutcomesVarSampOrderBy>;
  variance?: InputMaybe<PredictorOutcomesVarianceOrderBy>;
};

/** order by avg() on columns of table "predictor_outcomes" */
export type PredictorOutcomesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "predictor_outcomes". All fields are combined with a logical 'AND'. */
export type PredictorOutcomesBoolExp = {
  _and?: InputMaybe<Array<PredictorOutcomesBoolExp>>;
  _not?: InputMaybe<PredictorOutcomesBoolExp>;
  _or?: InputMaybe<Array<PredictorOutcomesBoolExp>>;
  cached_event_pull?: InputMaybe<CachedEventPullsBoolExp>;
  cached_event_pull_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  definition?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  timeframe?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "predictor_outcomes" */
export type PredictorOutcomesMaxOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "predictor_outcomes" */
export type PredictorOutcomesMinOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "predictor_outcomes" */
export type PredictorOutcomesMutationResponse = {
  __typename?: 'predictor_outcomes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PredictorOutcomes>;
};

/** Ordering options when selecting data from "predictor_outcomes". */
export type PredictorOutcomesOrderBy = {
  cached_event_pull?: InputMaybe<CachedEventPullsOrderBy>;
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  definition?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  timeframe?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "predictor_outcomes" */
export const PredictorOutcomesSelectColumn = {
  /** column name */
  CachedEventPullId: 'cached_event_pull_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Definition: 'definition',
  /** column name */
  Id: 'id',
  /** column name */
  Timeframe: 'timeframe',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorOutcomesSelectColumn = typeof PredictorOutcomesSelectColumn[keyof typeof PredictorOutcomesSelectColumn];
/** order by stddev() on columns of table "predictor_outcomes" */
export type PredictorOutcomesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "predictor_outcomes" */
export type PredictorOutcomesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "predictor_outcomes" */
export type PredictorOutcomesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "predictor_outcomes" */
export type PredictorOutcomesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorOutcomesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorOutcomesStreamCursorValueInput = {
  cached_event_pull_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  definition?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  timeframe?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "predictor_outcomes" */
export type PredictorOutcomesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "predictor_outcomes" */
export type PredictorOutcomesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "predictor_outcomes" */
export type PredictorOutcomesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "predictor_outcomes" */
export type PredictorOutcomesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "predictor_runs" */
export type PredictorRuns = {
  __typename?: 'predictor_runs';
  /** An object relationship */
  cached_event_pull?: Maybe<CachedEventPulls>;
  cached_event_pull_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  job_type: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  predictor?: Maybe<Predictors>;
  predictor_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  training_config_changed_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['Int'];
};


/** columns and relationships of "predictor_runs" */
export type PredictorRunsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "predictor_runs" */
export type PredictorRunsAggregate = {
  __typename?: 'predictor_runs_aggregate';
  aggregate?: Maybe<PredictorRunsAggregateFields>;
  nodes: Array<PredictorRuns>;
};

export type PredictorRunsAggregateBoolExp = {
  count?: InputMaybe<PredictorRunsAggregateBoolExpCount>;
};

export type PredictorRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PredictorRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "predictor_runs" */
export type PredictorRunsAggregateFields = {
  __typename?: 'predictor_runs_aggregate_fields';
  avg?: Maybe<PredictorRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PredictorRunsMaxFields>;
  min?: Maybe<PredictorRunsMinFields>;
  stddev?: Maybe<PredictorRunsStddevFields>;
  stddev_pop?: Maybe<PredictorRunsStddevPopFields>;
  stddev_samp?: Maybe<PredictorRunsStddevSampFields>;
  sum?: Maybe<PredictorRunsSumFields>;
  var_pop?: Maybe<PredictorRunsVarPopFields>;
  var_samp?: Maybe<PredictorRunsVarSampFields>;
  variance?: Maybe<PredictorRunsVarianceFields>;
};


/** aggregate fields of "predictor_runs" */
export type PredictorRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "predictor_runs" */
export type PredictorRunsAggregateOrderBy = {
  avg?: InputMaybe<PredictorRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PredictorRunsMaxOrderBy>;
  min?: InputMaybe<PredictorRunsMinOrderBy>;
  stddev?: InputMaybe<PredictorRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<PredictorRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PredictorRunsStddevSampOrderBy>;
  sum?: InputMaybe<PredictorRunsSumOrderBy>;
  var_pop?: InputMaybe<PredictorRunsVarPopOrderBy>;
  var_samp?: InputMaybe<PredictorRunsVarSampOrderBy>;
  variance?: InputMaybe<PredictorRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type PredictorRunsAvgFields = {
  __typename?: 'predictor_runs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "predictor_runs" */
export type PredictorRunsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "predictor_runs". All fields are combined with a logical 'AND'. */
export type PredictorRunsBoolExp = {
  _and?: InputMaybe<Array<PredictorRunsBoolExp>>;
  _not?: InputMaybe<PredictorRunsBoolExp>;
  _or?: InputMaybe<Array<PredictorRunsBoolExp>>;
  cached_event_pull?: InputMaybe<CachedEventPullsBoolExp>;
  cached_event_pull_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  job_type?: InputMaybe<StringComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  predictor?: InputMaybe<PredictorsBoolExp>;
  predictor_id?: InputMaybe<UuidComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  training_config_changed_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** aggregate max on columns */
export type PredictorRunsMaxFields = {
  __typename?: 'predictor_runs_max_fields';
  cached_event_pull_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  training_config_changed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "predictor_runs" */
export type PredictorRunsMaxOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_config_changed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PredictorRunsMinFields = {
  __typename?: 'predictor_runs_min_fields';
  cached_event_pull_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  training_config_changed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "predictor_runs" */
export type PredictorRunsMinOrderBy = {
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_config_changed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "predictor_runs". */
export type PredictorRunsOrderBy = {
  cached_event_pull?: InputMaybe<CachedEventPullsOrderBy>;
  cached_event_pull_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  job_type?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  predictor?: InputMaybe<PredictorsOrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  training_config_changed_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "predictor_runs" */
export const PredictorRunsSelectColumn = {
  /** column name */
  CachedEventPullId: 'cached_event_pull_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  JobType: 'job_type',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  PredictorId: 'predictor_id',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  TrainingConfigChangedAt: 'training_config_changed_at',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorRunsSelectColumn = typeof PredictorRunsSelectColumn[keyof typeof PredictorRunsSelectColumn];
/** aggregate stddev on columns */
export type PredictorRunsStddevFields = {
  __typename?: 'predictor_runs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "predictor_runs" */
export type PredictorRunsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type PredictorRunsStddevPopFields = {
  __typename?: 'predictor_runs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "predictor_runs" */
export type PredictorRunsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type PredictorRunsStddevSampFields = {
  __typename?: 'predictor_runs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "predictor_runs" */
export type PredictorRunsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "predictor_runs" */
export type PredictorRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorRunsStreamCursorValueInput = {
  cached_event_pull_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_type?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  predictor_id?: InputMaybe<Scalars['uuid']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  training_config_changed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PredictorRunsSumFields = {
  __typename?: 'predictor_runs_sum_fields';
  workspace_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "predictor_runs" */
export type PredictorRunsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type PredictorRunsVarPopFields = {
  __typename?: 'predictor_runs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "predictor_runs" */
export type PredictorRunsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type PredictorRunsVarSampFields = {
  __typename?: 'predictor_runs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "predictor_runs" */
export type PredictorRunsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PredictorRunsVarianceFields = {
  __typename?: 'predictor_runs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "predictor_runs" */
export type PredictorRunsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "predictors" */
export type Predictors = {
  __typename?: 'predictors';
  audience_definition: Scalars['jsonb'];
  /** An object relationship */
  base_audience?: Maybe<Segments>;
  base_audience_id?: Maybe<Scalars['bigint']>;
  catalog_collection_id?: Maybe<Scalars['uuid']>;
  catalog_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  catalog_model?: Maybe<CatalogModels>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  error_message?: Maybe<Scalars['String']>;
  feature_definition_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  outcome_id?: Maybe<Scalars['uuid']>;
  parent_model_id: Scalars['bigint'];
  /** An array relationship */
  predictor_artifacts: Array<PredictorArtifacts>;
  /** An aggregate relationship */
  predictor_artifacts_aggregate: PredictorArtifactsAggregate;
  /** An object relationship */
  predictor_feature_definition?: Maybe<PredictorFeatureDefinitions>;
  /** An object relationship */
  predictor_outcome?: Maybe<PredictorOutcomes>;
  /** An array relationship */
  predictor_runs: Array<PredictorRuns>;
  /** An aggregate relationship */
  predictor_runs_aggregate: PredictorRunsAggregate;
  status: Scalars['String'];
  suppression_filter: Scalars['jsonb'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "predictors" */
export type PredictorsAudienceDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "predictors" */
export type PredictorsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "predictors" */
export type PredictorsPredictorArtifactsArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


/** columns and relationships of "predictors" */
export type PredictorsPredictorArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


/** columns and relationships of "predictors" */
export type PredictorsPredictorRunsArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


/** columns and relationships of "predictors" */
export type PredictorsPredictorRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


/** columns and relationships of "predictors" */
export type PredictorsSuppressionFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "predictors". All fields are combined with a logical 'AND'. */
export type PredictorsBoolExp = {
  _and?: InputMaybe<Array<PredictorsBoolExp>>;
  _not?: InputMaybe<PredictorsBoolExp>;
  _or?: InputMaybe<Array<PredictorsBoolExp>>;
  audience_definition?: InputMaybe<JsonbComparisonExp>;
  base_audience?: InputMaybe<SegmentsBoolExp>;
  base_audience_id?: InputMaybe<BigintComparisonExp>;
  catalog_collection_id?: InputMaybe<UuidComparisonExp>;
  catalog_id?: InputMaybe<BigintComparisonExp>;
  catalog_model?: InputMaybe<CatalogModelsBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error_message?: InputMaybe<StringComparisonExp>;
  feature_definition_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  outcome_id?: InputMaybe<UuidComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  predictor_artifacts?: InputMaybe<PredictorArtifactsBoolExp>;
  predictor_artifacts_aggregate?: InputMaybe<PredictorArtifactsAggregateBoolExp>;
  predictor_feature_definition?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
  predictor_outcome?: InputMaybe<PredictorOutcomesBoolExp>;
  predictor_runs?: InputMaybe<PredictorRunsBoolExp>;
  predictor_runs_aggregate?: InputMaybe<PredictorRunsAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  suppression_filter?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** response of any mutation on the table "predictors" */
export type PredictorsMutationResponse = {
  __typename?: 'predictors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Predictors>;
};

/** Ordering options when selecting data from "predictors". */
export type PredictorsOrderBy = {
  audience_definition?: InputMaybe<OrderBy>;
  base_audience?: InputMaybe<SegmentsOrderBy>;
  base_audience_id?: InputMaybe<OrderBy>;
  catalog_collection_id?: InputMaybe<OrderBy>;
  catalog_id?: InputMaybe<OrderBy>;
  catalog_model?: InputMaybe<CatalogModelsOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  error_message?: InputMaybe<OrderBy>;
  feature_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  outcome_id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  predictor_artifacts_aggregate?: InputMaybe<PredictorArtifactsAggregateOrderBy>;
  predictor_feature_definition?: InputMaybe<PredictorFeatureDefinitionsOrderBy>;
  predictor_outcome?: InputMaybe<PredictorOutcomesOrderBy>;
  predictor_runs_aggregate?: InputMaybe<PredictorRunsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  suppression_filter?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: predictors */
export type PredictorsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "predictors" */
export const PredictorsSelectColumn = {
  /** column name */
  AudienceDefinition: 'audience_definition',
  /** column name */
  BaseAudienceId: 'base_audience_id',
  /** column name */
  CatalogCollectionId: 'catalog_collection_id',
  /** column name */
  CatalogId: 'catalog_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  ErrorMessage: 'error_message',
  /** column name */
  FeatureDefinitionId: 'feature_definition_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OutcomeId: 'outcome_id',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Status: 'status',
  /** column name */
  SuppressionFilter: 'suppression_filter',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PredictorsSelectColumn = typeof PredictorsSelectColumn[keyof typeof PredictorsSelectColumn];
/** input type for updating data in table "predictors" */
export type PredictorsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "predictors" */
export type PredictorsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PredictorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PredictorsStreamCursorValueInput = {
  audience_definition?: InputMaybe<Scalars['jsonb']>;
  base_audience_id?: InputMaybe<Scalars['bigint']>;
  catalog_collection_id?: InputMaybe<Scalars['uuid']>;
  catalog_id?: InputMaybe<Scalars['bigint']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_message?: InputMaybe<Scalars['String']>;
  feature_definition_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  outcome_id?: InputMaybe<Scalars['uuid']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  suppression_filter?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

export type PredictorsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PredictorsSetInput>;
  /** filter the rows which have to be updated */
  where: PredictorsBoolExp;
};

/** Represents the link between segments and priority lists. */
export type PriorityListMemberships = {
  __typename?: 'priority_list_memberships';
  /** An object relationship */
  priority_list: PriorityLists;
  priority_list_id: Scalars['bigint'];
  rank: Scalars['Int'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
};

/** order by aggregate values of table "priority_list_memberships" */
export type PriorityListMembershipsAggregateOrderBy = {
  avg?: InputMaybe<PriorityListMembershipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PriorityListMembershipsMaxOrderBy>;
  min?: InputMaybe<PriorityListMembershipsMinOrderBy>;
  stddev?: InputMaybe<PriorityListMembershipsStddevOrderBy>;
  stddev_pop?: InputMaybe<PriorityListMembershipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PriorityListMembershipsStddevSampOrderBy>;
  sum?: InputMaybe<PriorityListMembershipsSumOrderBy>;
  var_pop?: InputMaybe<PriorityListMembershipsVarPopOrderBy>;
  var_samp?: InputMaybe<PriorityListMembershipsVarSampOrderBy>;
  variance?: InputMaybe<PriorityListMembershipsVarianceOrderBy>;
};

/** order by avg() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsAvgOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "priority_list_memberships". All fields are combined with a logical 'AND'. */
export type PriorityListMembershipsBoolExp = {
  _and?: InputMaybe<Array<PriorityListMembershipsBoolExp>>;
  _not?: InputMaybe<PriorityListMembershipsBoolExp>;
  _or?: InputMaybe<Array<PriorityListMembershipsBoolExp>>;
  priority_list?: InputMaybe<PriorityListsBoolExp>;
  priority_list_id?: InputMaybe<BigintComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsMaxOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsMinOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "priority_list_memberships". */
export type PriorityListMembershipsOrderBy = {
  priority_list?: InputMaybe<PriorityListsOrderBy>;
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** select columns of table "priority_list_memberships" */
export const PriorityListMembershipsSelectColumn = {
  /** column name */
  PriorityListId: 'priority_list_id',
  /** column name */
  Rank: 'rank',
  /** column name */
  SegmentId: 'segment_id'
} as const;

export type PriorityListMembershipsSelectColumn = typeof PriorityListMembershipsSelectColumn[keyof typeof PriorityListMembershipsSelectColumn];
/** order by stddev() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsStddevOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsStddevPopOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsStddevSampOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "priority_list_memberships" */
export type PriorityListMembershipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PriorityListMembershipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PriorityListMembershipsStreamCursorValueInput = {
  priority_list_id?: InputMaybe<Scalars['bigint']>;
  rank?: InputMaybe<Scalars['Int']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsSumOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsVarPopOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsVarSampOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "priority_list_memberships" */
export type PriorityListMembershipsVarianceOrderBy = {
  priority_list_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "priority_lists" */
export type PriorityLists = {
  __typename?: 'priority_lists';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  /** An array relationship */
  priority_list_memberships: Array<PriorityListMemberships>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "priority_lists" */
export type PriorityListsPriorityListMembershipsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListMembershipsOrderBy>>;
  where?: InputMaybe<PriorityListMembershipsBoolExp>;
};

/** aggregated selection of "priority_lists" */
export type PriorityListsAggregate = {
  __typename?: 'priority_lists_aggregate';
  aggregate?: Maybe<PriorityListsAggregateFields>;
  nodes: Array<PriorityLists>;
};

/** aggregate fields of "priority_lists" */
export type PriorityListsAggregateFields = {
  __typename?: 'priority_lists_aggregate_fields';
  avg?: Maybe<PriorityListsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PriorityListsMaxFields>;
  min?: Maybe<PriorityListsMinFields>;
  stddev?: Maybe<PriorityListsStddevFields>;
  stddev_pop?: Maybe<PriorityListsStddevPopFields>;
  stddev_samp?: Maybe<PriorityListsStddevSampFields>;
  sum?: Maybe<PriorityListsSumFields>;
  var_pop?: Maybe<PriorityListsVarPopFields>;
  var_samp?: Maybe<PriorityListsVarSampFields>;
  variance?: Maybe<PriorityListsVarianceFields>;
};


/** aggregate fields of "priority_lists" */
export type PriorityListsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PriorityListsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PriorityListsAvgFields = {
  __typename?: 'priority_lists_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "priority_lists". All fields are combined with a logical 'AND'. */
export type PriorityListsBoolExp = {
  _and?: InputMaybe<Array<PriorityListsBoolExp>>;
  _not?: InputMaybe<PriorityListsBoolExp>;
  _or?: InputMaybe<Array<PriorityListsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  priority_list_memberships?: InputMaybe<PriorityListMembershipsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type PriorityListsMaxFields = {
  __typename?: 'priority_lists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PriorityListsMinFields = {
  __typename?: 'priority_lists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "priority_lists". */
export type PriorityListsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  priority_list_memberships_aggregate?: InputMaybe<PriorityListMembershipsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "priority_lists" */
export const PriorityListsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PriorityListsSelectColumn = typeof PriorityListsSelectColumn[keyof typeof PriorityListsSelectColumn];
/** aggregate stddev on columns */
export type PriorityListsStddevFields = {
  __typename?: 'priority_lists_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PriorityListsStddevPopFields = {
  __typename?: 'priority_lists_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PriorityListsStddevSampFields = {
  __typename?: 'priority_lists_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "priority_lists" */
export type PriorityListsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PriorityListsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PriorityListsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PriorityListsSumFields = {
  __typename?: 'priority_lists_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type PriorityListsVarPopFields = {
  __typename?: 'priority_lists_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PriorityListsVarSampFields = {
  __typename?: 'priority_lists_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PriorityListsVarianceFields = {
  __typename?: 'priority_lists_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "push_apps" */
export type PushApps = {
  __typename?: 'push_apps';
  app_icon_image_id?: Maybe<Scalars['uuid']>;
  bundle_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  cep_subscription_topics: Array<CepSubscriptionTopics>;
  /** An aggregate relationship */
  cep_subscription_topics_aggregate: CepSubscriptionTopicsAggregate;
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  environment?: Maybe<Scalars['String']>;
  event_source_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  last_test_at?: Maybe<Scalars['timestamptz']>;
  last_test_passed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  platform: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "push_apps" */
export type PushAppsCepSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "push_apps" */
export type PushAppsCepSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


/** columns and relationships of "push_apps" */
export type PushAppsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_apps" */
export type PushAppsNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "push_apps" */
export type PushAppsNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** Boolean expression to filter rows from the table "push_apps". All fields are combined with a logical 'AND'. */
export type PushAppsBoolExp = {
  _and?: InputMaybe<Array<PushAppsBoolExp>>;
  _not?: InputMaybe<PushAppsBoolExp>;
  _or?: InputMaybe<Array<PushAppsBoolExp>>;
  app_icon_image_id?: InputMaybe<UuidComparisonExp>;
  bundle_id?: InputMaybe<StringComparisonExp>;
  cep_subscription_topics?: InputMaybe<CepSubscriptionTopicsBoolExp>;
  cep_subscription_topics_aggregate?: InputMaybe<CepSubscriptionTopicsAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  environment?: InputMaybe<StringComparisonExp>;
  event_source_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_test_at?: InputMaybe<TimestamptzComparisonExp>;
  last_test_passed?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  platform?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "push_apps" */
export const PushAppsConstraint = {
  /** unique or primary key constraint on columns "id" */
  PushAppsPkey: 'push_apps_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  PushAppsWorkspaceIdIdKey: 'push_apps_workspace_id_id_key'
} as const;

export type PushAppsConstraint = typeof PushAppsConstraint[keyof typeof PushAppsConstraint];
/** input type for inserting data into table "push_apps" */
export type PushAppsInsertInput = {
  bundle_id?: InputMaybe<Scalars['String']>;
  cep_subscription_topics?: InputMaybe<CepSubscriptionTopicsArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  platform?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "push_apps" */
export type PushAppsMutationResponse = {
  __typename?: 'push_apps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PushApps>;
};

/** input type for inserting object relation for remote table "push_apps" */
export type PushAppsObjRelInsertInput = {
  data: PushAppsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PushAppsOnConflict>;
};

/** on_conflict condition type for table "push_apps" */
export type PushAppsOnConflict = {
  constraint: PushAppsConstraint;
  update_columns?: Array<PushAppsUpdateColumn>;
  where?: InputMaybe<PushAppsBoolExp>;
};

/** Ordering options when selecting data from "push_apps". */
export type PushAppsOrderBy = {
  app_icon_image_id?: InputMaybe<OrderBy>;
  bundle_id?: InputMaybe<OrderBy>;
  cep_subscription_topics_aggregate?: InputMaybe<CepSubscriptionTopicsAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  environment?: InputMaybe<OrderBy>;
  event_source_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_test_at?: InputMaybe<OrderBy>;
  last_test_passed?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  platform?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: push_apps */
export type PushAppsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "push_apps" */
export const PushAppsSelectColumn = {
  /** column name */
  AppIconImageId: 'app_icon_image_id',
  /** column name */
  BundleId: 'bundle_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Environment: 'environment',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  Id: 'id',
  /** column name */
  LastTestAt: 'last_test_at',
  /** column name */
  LastTestPassed: 'last_test_passed',
  /** column name */
  Name: 'name',
  /** column name */
  Platform: 'platform',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PushAppsSelectColumn = typeof PushAppsSelectColumn[keyof typeof PushAppsSelectColumn];
/** input type for updating data in table "push_apps" */
export type PushAppsSetInput = {
  bundle_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "push_apps" */
export type PushAppsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PushAppsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PushAppsStreamCursorValueInput = {
  app_icon_image_id?: InputMaybe<Scalars['uuid']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  event_source_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_test_at?: InputMaybe<Scalars['timestamptz']>;
  last_test_passed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "push_apps" */
export const PushAppsUpdateColumn = {
  /** column name */
  BundleId: 'bundle_id',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Environment: 'environment',
  /** column name */
  EventSourceId: 'event_source_id',
  /** column name */
  Name: 'name'
} as const;

export type PushAppsUpdateColumn = typeof PushAppsUpdateColumn[keyof typeof PushAppsUpdateColumn];
export type PushAppsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PushAppsSetInput>;
  /** filter the rows which have to be updated */
  where: PushAppsBoolExp;
};

/** columns and relationships of "push_config" */
export type PushConfig = {
  __typename?: 'push_config';
  action_buttons?: Maybe<Scalars['jsonb']>;
  android_click_behavior_type?: Maybe<Scalars['String']>;
  android_click_behavior_url?: Maybe<Scalars['String']>;
  android_delivery_priority?: Maybe<Scalars['String']>;
  android_group_key?: Maybe<Scalars['String']>;
  android_notification_channel?: Maybe<Scalars['String']>;
  android_replace_notification_id?: Maybe<Scalars['String']>;
  collapse_key?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  custom_data?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  ios_badge_config?: Maybe<Scalars['jsonb']>;
  ios_click_behavior_type?: Maybe<Scalars['String']>;
  ios_click_behavior_url?: Maybe<Scalars['String']>;
  ios_interruption_level?: Maybe<Scalars['String']>;
  ios_relevance_score?: Maybe<Scalars['numeric']>;
  ios_thread_id?: Maybe<Scalars['String']>;
  is_silent: Scalars['Boolean'];
  message_expiry_hours?: Maybe<Scalars['Int']>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  /** An array relationship */
  native_delivery_grants: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  native_delivery_grants_aggregate: UserGroupWorkspacesAggregate;
  sound?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "push_config" */
export type PushConfigActionButtonsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_config" */
export type PushConfigCustomDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_config" */
export type PushConfigIosBadgeConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "push_config" */
export type PushConfigMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "push_config" */
export type PushConfigMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


/** columns and relationships of "push_config" */
export type PushConfigNativeDeliveryGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "push_config" */
export type PushConfigNativeDeliveryGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "push_config" */
export type PushConfigAggregate = {
  __typename?: 'push_config_aggregate';
  aggregate?: Maybe<PushConfigAggregateFields>;
  nodes: Array<PushConfig>;
};

/** aggregate fields of "push_config" */
export type PushConfigAggregateFields = {
  __typename?: 'push_config_aggregate_fields';
  avg?: Maybe<PushConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PushConfigMaxFields>;
  min?: Maybe<PushConfigMinFields>;
  stddev?: Maybe<PushConfigStddevFields>;
  stddev_pop?: Maybe<PushConfigStddevPopFields>;
  stddev_samp?: Maybe<PushConfigStddevSampFields>;
  sum?: Maybe<PushConfigSumFields>;
  var_pop?: Maybe<PushConfigVarPopFields>;
  var_samp?: Maybe<PushConfigVarSampFields>;
  variance?: Maybe<PushConfigVarianceFields>;
};


/** aggregate fields of "push_config" */
export type PushConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PushConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PushConfigAppendInput = {
  action_buttons?: InputMaybe<Scalars['jsonb']>;
  custom_data?: InputMaybe<Scalars['jsonb']>;
  ios_badge_config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PushConfigAvgFields = {
  __typename?: 'push_config_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "push_config". All fields are combined with a logical 'AND'. */
export type PushConfigBoolExp = {
  _and?: InputMaybe<Array<PushConfigBoolExp>>;
  _not?: InputMaybe<PushConfigBoolExp>;
  _or?: InputMaybe<Array<PushConfigBoolExp>>;
  action_buttons?: InputMaybe<JsonbComparisonExp>;
  android_click_behavior_type?: InputMaybe<StringComparisonExp>;
  android_click_behavior_url?: InputMaybe<StringComparisonExp>;
  android_delivery_priority?: InputMaybe<StringComparisonExp>;
  android_group_key?: InputMaybe<StringComparisonExp>;
  android_notification_channel?: InputMaybe<StringComparisonExp>;
  android_replace_notification_id?: InputMaybe<StringComparisonExp>;
  collapse_key?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  custom_data?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ios_badge_config?: InputMaybe<JsonbComparisonExp>;
  ios_click_behavior_type?: InputMaybe<StringComparisonExp>;
  ios_click_behavior_url?: InputMaybe<StringComparisonExp>;
  ios_interruption_level?: InputMaybe<StringComparisonExp>;
  ios_relevance_score?: InputMaybe<NumericComparisonExp>;
  ios_thread_id?: InputMaybe<StringComparisonExp>;
  is_silent?: InputMaybe<BooleanComparisonExp>;
  message_expiry_hours?: InputMaybe<IntComparisonExp>;
  messages?: InputMaybe<MessagesBoolExp>;
  messages_aggregate?: InputMaybe<MessagesAggregateBoolExp>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesBoolExp>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  sound?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "push_config" */
export const PushConfigConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  PushConfigIdWorkspaceIdKey: 'push_config_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  PushConfigPkey: 'push_config_pkey'
} as const;

export type PushConfigConstraint = typeof PushConfigConstraint[keyof typeof PushConfigConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PushConfigDeleteAtPathInput = {
  action_buttons?: InputMaybe<Array<Scalars['String']>>;
  custom_data?: InputMaybe<Array<Scalars['String']>>;
  ios_badge_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PushConfigDeleteElemInput = {
  action_buttons?: InputMaybe<Scalars['Int']>;
  custom_data?: InputMaybe<Scalars['Int']>;
  ios_badge_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PushConfigDeleteKeyInput = {
  action_buttons?: InputMaybe<Scalars['String']>;
  custom_data?: InputMaybe<Scalars['String']>;
  ios_badge_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "push_config" */
export type PushConfigIncInput = {
  ios_relevance_score?: InputMaybe<Scalars['numeric']>;
  message_expiry_hours?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "push_config" */
export type PushConfigInsertInput = {
  action_buttons?: InputMaybe<Scalars['jsonb']>;
  android_click_behavior_type?: InputMaybe<Scalars['String']>;
  android_click_behavior_url?: InputMaybe<Scalars['String']>;
  android_delivery_priority?: InputMaybe<Scalars['String']>;
  android_group_key?: InputMaybe<Scalars['String']>;
  android_notification_channel?: InputMaybe<Scalars['String']>;
  android_replace_notification_id?: InputMaybe<Scalars['String']>;
  collapse_key?: InputMaybe<Scalars['String']>;
  custom_data?: InputMaybe<Scalars['jsonb']>;
  ios_badge_config?: InputMaybe<Scalars['jsonb']>;
  ios_click_behavior_type?: InputMaybe<Scalars['String']>;
  ios_click_behavior_url?: InputMaybe<Scalars['String']>;
  ios_interruption_level?: InputMaybe<Scalars['String']>;
  ios_relevance_score?: InputMaybe<Scalars['numeric']>;
  ios_thread_id?: InputMaybe<Scalars['String']>;
  is_silent?: InputMaybe<Scalars['Boolean']>;
  message_expiry_hours?: InputMaybe<Scalars['Int']>;
  messages?: InputMaybe<MessagesArrRelInsertInput>;
  native_delivery_grants?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
  sound?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PushConfigMaxFields = {
  __typename?: 'push_config_max_fields';
  android_click_behavior_type?: Maybe<Scalars['String']>;
  android_click_behavior_url?: Maybe<Scalars['String']>;
  android_delivery_priority?: Maybe<Scalars['String']>;
  android_group_key?: Maybe<Scalars['String']>;
  android_notification_channel?: Maybe<Scalars['String']>;
  android_replace_notification_id?: Maybe<Scalars['String']>;
  collapse_key?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  ios_click_behavior_type?: Maybe<Scalars['String']>;
  ios_click_behavior_url?: Maybe<Scalars['String']>;
  ios_interruption_level?: Maybe<Scalars['String']>;
  ios_relevance_score?: Maybe<Scalars['numeric']>;
  ios_thread_id?: Maybe<Scalars['String']>;
  message_expiry_hours?: Maybe<Scalars['Int']>;
  sound?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PushConfigMinFields = {
  __typename?: 'push_config_min_fields';
  android_click_behavior_type?: Maybe<Scalars['String']>;
  android_click_behavior_url?: Maybe<Scalars['String']>;
  android_delivery_priority?: Maybe<Scalars['String']>;
  android_group_key?: Maybe<Scalars['String']>;
  android_notification_channel?: Maybe<Scalars['String']>;
  android_replace_notification_id?: Maybe<Scalars['String']>;
  collapse_key?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  ios_click_behavior_type?: Maybe<Scalars['String']>;
  ios_click_behavior_url?: Maybe<Scalars['String']>;
  ios_interruption_level?: Maybe<Scalars['String']>;
  ios_relevance_score?: Maybe<Scalars['numeric']>;
  ios_thread_id?: Maybe<Scalars['String']>;
  message_expiry_hours?: Maybe<Scalars['Int']>;
  sound?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "push_config" */
export type PushConfigMutationResponse = {
  __typename?: 'push_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PushConfig>;
};

/** input type for inserting object relation for remote table "push_config" */
export type PushConfigObjRelInsertInput = {
  data: PushConfigInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PushConfigOnConflict>;
};

/** on_conflict condition type for table "push_config" */
export type PushConfigOnConflict = {
  constraint: PushConfigConstraint;
  update_columns?: Array<PushConfigUpdateColumn>;
  where?: InputMaybe<PushConfigBoolExp>;
};

/** Ordering options when selecting data from "push_config". */
export type PushConfigOrderBy = {
  action_buttons?: InputMaybe<OrderBy>;
  android_click_behavior_type?: InputMaybe<OrderBy>;
  android_click_behavior_url?: InputMaybe<OrderBy>;
  android_delivery_priority?: InputMaybe<OrderBy>;
  android_group_key?: InputMaybe<OrderBy>;
  android_notification_channel?: InputMaybe<OrderBy>;
  android_replace_notification_id?: InputMaybe<OrderBy>;
  collapse_key?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  custom_data?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ios_badge_config?: InputMaybe<OrderBy>;
  ios_click_behavior_type?: InputMaybe<OrderBy>;
  ios_click_behavior_url?: InputMaybe<OrderBy>;
  ios_interruption_level?: InputMaybe<OrderBy>;
  ios_relevance_score?: InputMaybe<OrderBy>;
  ios_thread_id?: InputMaybe<OrderBy>;
  is_silent?: InputMaybe<OrderBy>;
  message_expiry_hours?: InputMaybe<OrderBy>;
  messages_aggregate?: InputMaybe<MessagesAggregateOrderBy>;
  native_delivery_grants_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  sound?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: push_config */
export type PushConfigPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PushConfigPrependInput = {
  action_buttons?: InputMaybe<Scalars['jsonb']>;
  custom_data?: InputMaybe<Scalars['jsonb']>;
  ios_badge_config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "push_config" */
export const PushConfigSelectColumn = {
  /** column name */
  ActionButtons: 'action_buttons',
  /** column name */
  AndroidClickBehaviorType: 'android_click_behavior_type',
  /** column name */
  AndroidClickBehaviorUrl: 'android_click_behavior_url',
  /** column name */
  AndroidDeliveryPriority: 'android_delivery_priority',
  /** column name */
  AndroidGroupKey: 'android_group_key',
  /** column name */
  AndroidNotificationChannel: 'android_notification_channel',
  /** column name */
  AndroidReplaceNotificationId: 'android_replace_notification_id',
  /** column name */
  CollapseKey: 'collapse_key',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CustomData: 'custom_data',
  /** column name */
  Id: 'id',
  /** column name */
  IosBadgeConfig: 'ios_badge_config',
  /** column name */
  IosClickBehaviorType: 'ios_click_behavior_type',
  /** column name */
  IosClickBehaviorUrl: 'ios_click_behavior_url',
  /** column name */
  IosInterruptionLevel: 'ios_interruption_level',
  /** column name */
  IosRelevanceScore: 'ios_relevance_score',
  /** column name */
  IosThreadId: 'ios_thread_id',
  /** column name */
  IsSilent: 'is_silent',
  /** column name */
  MessageExpiryHours: 'message_expiry_hours',
  /** column name */
  Sound: 'sound',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type PushConfigSelectColumn = typeof PushConfigSelectColumn[keyof typeof PushConfigSelectColumn];
/** input type for updating data in table "push_config" */
export type PushConfigSetInput = {
  action_buttons?: InputMaybe<Scalars['jsonb']>;
  android_click_behavior_type?: InputMaybe<Scalars['String']>;
  android_click_behavior_url?: InputMaybe<Scalars['String']>;
  android_delivery_priority?: InputMaybe<Scalars['String']>;
  android_group_key?: InputMaybe<Scalars['String']>;
  android_notification_channel?: InputMaybe<Scalars['String']>;
  android_replace_notification_id?: InputMaybe<Scalars['String']>;
  collapse_key?: InputMaybe<Scalars['String']>;
  custom_data?: InputMaybe<Scalars['jsonb']>;
  ios_badge_config?: InputMaybe<Scalars['jsonb']>;
  ios_click_behavior_type?: InputMaybe<Scalars['String']>;
  ios_click_behavior_url?: InputMaybe<Scalars['String']>;
  ios_interruption_level?: InputMaybe<Scalars['String']>;
  ios_relevance_score?: InputMaybe<Scalars['numeric']>;
  ios_thread_id?: InputMaybe<Scalars['String']>;
  is_silent?: InputMaybe<Scalars['Boolean']>;
  message_expiry_hours?: InputMaybe<Scalars['Int']>;
  sound?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type PushConfigStddevFields = {
  __typename?: 'push_config_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PushConfigStddevPopFields = {
  __typename?: 'push_config_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PushConfigStddevSampFields = {
  __typename?: 'push_config_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "push_config" */
export type PushConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PushConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PushConfigStreamCursorValueInput = {
  action_buttons?: InputMaybe<Scalars['jsonb']>;
  android_click_behavior_type?: InputMaybe<Scalars['String']>;
  android_click_behavior_url?: InputMaybe<Scalars['String']>;
  android_delivery_priority?: InputMaybe<Scalars['String']>;
  android_group_key?: InputMaybe<Scalars['String']>;
  android_notification_channel?: InputMaybe<Scalars['String']>;
  android_replace_notification_id?: InputMaybe<Scalars['String']>;
  collapse_key?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  custom_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  ios_badge_config?: InputMaybe<Scalars['jsonb']>;
  ios_click_behavior_type?: InputMaybe<Scalars['String']>;
  ios_click_behavior_url?: InputMaybe<Scalars['String']>;
  ios_interruption_level?: InputMaybe<Scalars['String']>;
  ios_relevance_score?: InputMaybe<Scalars['numeric']>;
  ios_thread_id?: InputMaybe<Scalars['String']>;
  is_silent?: InputMaybe<Scalars['Boolean']>;
  message_expiry_hours?: InputMaybe<Scalars['Int']>;
  sound?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PushConfigSumFields = {
  __typename?: 'push_config_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  ios_relevance_score?: Maybe<Scalars['numeric']>;
  message_expiry_hours?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "push_config" */
export const PushConfigUpdateColumn = {
  /** column name */
  ActionButtons: 'action_buttons',
  /** column name */
  AndroidClickBehaviorType: 'android_click_behavior_type',
  /** column name */
  AndroidClickBehaviorUrl: 'android_click_behavior_url',
  /** column name */
  AndroidDeliveryPriority: 'android_delivery_priority',
  /** column name */
  AndroidGroupKey: 'android_group_key',
  /** column name */
  AndroidNotificationChannel: 'android_notification_channel',
  /** column name */
  AndroidReplaceNotificationId: 'android_replace_notification_id',
  /** column name */
  CollapseKey: 'collapse_key',
  /** column name */
  CustomData: 'custom_data',
  /** column name */
  IosBadgeConfig: 'ios_badge_config',
  /** column name */
  IosClickBehaviorType: 'ios_click_behavior_type',
  /** column name */
  IosClickBehaviorUrl: 'ios_click_behavior_url',
  /** column name */
  IosInterruptionLevel: 'ios_interruption_level',
  /** column name */
  IosRelevanceScore: 'ios_relevance_score',
  /** column name */
  IosThreadId: 'ios_thread_id',
  /** column name */
  IsSilent: 'is_silent',
  /** column name */
  MessageExpiryHours: 'message_expiry_hours',
  /** column name */
  Sound: 'sound'
} as const;

export type PushConfigUpdateColumn = typeof PushConfigUpdateColumn[keyof typeof PushConfigUpdateColumn];
export type PushConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PushConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PushConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PushConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PushConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PushConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PushConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PushConfigSetInput>;
  /** filter the rows which have to be updated */
  where: PushConfigBoolExp;
};

/** aggregate var_pop on columns */
export type PushConfigVarPopFields = {
  __typename?: 'push_config_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PushConfigVarSampFields = {
  __typename?: 'push_config_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PushConfigVarianceFields = {
  __typename?: 'push_config_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  ios_relevance_score?: Maybe<Scalars['Float']>;
  message_expiry_hours?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'query';
  ValidateDatadogCredentials?: Maybe<ValidateDatadogCredentialsOutput>;
  actionPlanFiles: Array<ActionPlanFile>;
  activeCampaignDescribeObject: ActiveCampaignDescribeObjectResult;
  /**
   * Newest first. With a taskId the feed includes the task's subtasks. With
   * neither id it covers every project that is not archived.
   */
  activity: Array<ActivityEvent>;
  adExportChannels: Array<AdExportChannel>;
  /** Stored video media extraction (transcript, hooks, scenes) for one Insights ad's creatives, in the order the ad maps to them. Creatives without extracted media are omitted. Empty when the flag is off or creative tagging has not run. */
  adInsightsCreativeMedia: Array<AdInsightsCreativeMedia>;
  /** Warehouse creative tags for one Insights ad, keyed by native asset id. Empty when the flag is off or creative_tags has not been written yet. */
  adInsightsCreativeTags: Array<AdInsightsCreativeTag>;
  /** Cube's MetaResponse for the workspace's insights views, one view per insights Malloy source. conversion_event carries each channel's default events in meta. */
  adInsightsCubeMeta: Scalars['JSON'];
  /** Takes Cube's load Query and returns Cube's LoadResponse from the workspace's insights views. conversion_channel and conversion_event filters pick the events the conversions measure counts, as a top-level or-group of per-channel and-groups. */
  adInsightsCubeQuery: Scalars['JSON'];
  adLaunchProgress: Array<AdLaunchProgressItem>;
  adReferenceOrigins: Array<AdReferenceOrigin>;
  /** Meta ad accounts available for the given sync — enumerated from the agents DB account_history table, sorted by name. */
  adStudioAccounts: Array<AdStudioAccount>;
  /** The brand profile a catalog asset group's templates are authored in (its assignment, or the workspace default). Scopes the template style picker and seeds the session brand context. */
  adStudioCatalogBrandProfileId?: Maybe<Scalars['ID']>;
  /** Tag keys (+ sample values) available on a catalog asset group's products. Powers the Enriched Catalog treatment filter builder. */
  adStudioCatalogTagSchema: AdStudioCatalogTagSchema;
  adStudioCompetitor?: Maybe<Competitor>;
  adStudioCompetitors: Array<Competitor>;
  adStudioEnrichedProductOutputs: AdStudioEnrichedProductsPage;
  adStudioEnrichmentRuns: Array<AdStudioEnrichmentRun>;
  adStudioFeedEnrichmentSummary: AdStudioFeedEnrichmentSummary;
  /** Catalog products for a treatment's feed, with presigned thumbnails — powers the preview product picker. */
  adStudioFeedProducts: Array<AdStudioFeedProduct>;
  /** Catalog products for a feed narrowed by an ad-hoc segment filter (no treatment required) — powers the Add-template modal's live product preview. */
  adStudioPreviewFeedProducts: Array<AdStudioFeedProduct>;
  /** Presigned URLs for a treatment's last rendered preview, keyed by product id. */
  adStudioPreviewImageUrls: Array<AdStudioPreviewImageUrl>;
  /** Sample catalog product thumbnails for a product feed (unfiltered by any treatment's segment) — powers the feed list card thumbnails. */
  adStudioProductFeedThumbnails: Array<AdStudioFeedProduct>;
  /** fetch data from the table: "ad_agent_artifacts" */
  ad_agent_artifacts: Array<AdAgentArtifacts>;
  /** fetch data from the table: "ad_agent_artifacts" using primary key columns */
  ad_agent_artifacts_by_pk?: Maybe<AdAgentArtifacts>;
  /** An array relationship */
  ad_asset_favorites: Array<AdAssetFavorites>;
  /** An aggregate relationship */
  ad_asset_favorites_aggregate: AdAssetFavoritesAggregate;
  /** fetch data from the table: "ad_asset_favorites" using primary key columns */
  ad_asset_favorites_by_pk?: Maybe<AdAssetFavorites>;
  /** fetch data from the table: "ad_brief_asset_launch_queue" */
  ad_brief_asset_launch_queue: Array<AdBriefAssetLaunchQueue>;
  /** fetch aggregated fields from the table: "ad_brief_asset_launch_queue" */
  ad_brief_asset_launch_queue_aggregate: AdBriefAssetLaunchQueueAggregate;
  /** fetch data from the table: "ad_brief_asset_launch_queue" using primary key columns */
  ad_brief_asset_launch_queue_by_pk?: Maybe<AdBriefAssetLaunchQueue>;
  /** fetch data from the table: "ad_brief_asset_launches" */
  ad_brief_asset_launches: Array<AdBriefAssetLaunches>;
  /** fetch aggregated fields from the table: "ad_brief_asset_launches" */
  ad_brief_asset_launches_aggregate: AdBriefAssetLaunchesAggregate;
  /** fetch data from the table: "ad_brief_asset_launches" using primary key columns */
  ad_brief_asset_launches_by_pk?: Maybe<AdBriefAssetLaunches>;
  /** An array relationship */
  ad_brief_asset_size_variants: Array<AdBriefAssetSizeVariants>;
  /** An aggregate relationship */
  ad_brief_asset_size_variants_aggregate: AdBriefAssetSizeVariantsAggregate;
  /** fetch data from the table: "ad_brief_asset_size_variants" using primary key columns */
  ad_brief_asset_size_variants_by_pk?: Maybe<AdBriefAssetSizeVariants>;
  /** An array relationship */
  ad_brief_asset_versions: Array<AdBriefAssetVersions>;
  /** An aggregate relationship */
  ad_brief_asset_versions_aggregate: AdBriefAssetVersionsAggregate;
  /** fetch data from the table: "ad_brief_asset_versions" using primary key columns */
  ad_brief_asset_versions_by_pk?: Maybe<AdBriefAssetVersions>;
  /** An array relationship */
  ad_brief_assets: Array<AdBriefAssets>;
  /** An aggregate relationship */
  ad_brief_assets_aggregate: AdBriefAssetsAggregate;
  /** fetch data from the table: "ad_brief_assets" using primary key columns */
  ad_brief_assets_by_pk?: Maybe<AdBriefAssets>;
  /** An array relationship */
  ad_briefs: Array<AdBriefs>;
  /** An aggregate relationship */
  ad_briefs_aggregate: AdBriefsAggregate;
  /** fetch data from the table: "ad_briefs" using primary key columns */
  ad_briefs_by_pk?: Maybe<AdBriefs>;
  /** fetch data from the table: "ad_export_channel_sizes" */
  ad_export_channel_sizes: Array<AdExportChannelSizes>;
  /** fetch aggregated fields from the table: "ad_export_channel_sizes" */
  ad_export_channel_sizes_aggregate: AdExportChannelSizesAggregate;
  /** fetch data from the table: "ad_export_channel_sizes" using primary key columns */
  ad_export_channel_sizes_by_pk?: Maybe<AdExportChannelSizes>;
  /** fetch data from the table: "ad_export_channels" */
  ad_export_channels: Array<AdExportChannels>;
  /** fetch aggregated fields from the table: "ad_export_channels" */
  ad_export_channels_aggregate: AdExportChannelsAggregate;
  /** fetch data from the table: "ad_export_channels" using primary key columns */
  ad_export_channels_by_pk?: Maybe<AdExportChannels>;
  /** fetch data from the table: "ad_generation_pipeline_runs" */
  ad_generation_pipeline_runs: Array<AdGenerationPipelineRuns>;
  /** fetch aggregated fields from the table: "ad_generation_pipeline_runs" */
  ad_generation_pipeline_runs_aggregate: AdGenerationPipelineRunsAggregate;
  /** fetch data from the table: "ad_generation_pipeline_runs" using primary key columns */
  ad_generation_pipeline_runs_by_pk?: Maybe<AdGenerationPipelineRuns>;
  /** fetch data from the table: "ad_generation_workflows" */
  ad_generation_workflows: Array<AdGenerationWorkflows>;
  /** fetch aggregated fields from the table: "ad_generation_workflows" */
  ad_generation_workflows_aggregate: AdGenerationWorkflowsAggregate;
  /** fetch data from the table: "ad_generation_workflows" using primary key columns */
  ad_generation_workflows_by_pk?: Maybe<AdGenerationWorkflows>;
  /** fetch data from the table: "ad_stats_models" */
  ad_stats_models: Array<AdStatsModels>;
  /** fetch data from the table: "ad_stats_models" using primary key columns */
  ad_stats_models_by_pk?: Maybe<AdStatsModels>;
  /** fetch data from the table: "ad_studio_product_feeds" */
  ad_studio_product_feeds: Array<AdStudioProductFeeds>;
  /** fetch aggregated fields from the table: "ad_studio_product_feeds" */
  ad_studio_product_feeds_aggregate: AdStudioProductFeedsAggregate;
  /** fetch data from the table: "ad_studio_product_feeds" using primary key columns */
  ad_studio_product_feeds_by_pk?: Maybe<AdStudioProductFeeds>;
  /** fetch data from the table: "ad_studio_project_brief_versions" */
  ad_studio_project_brief_versions: Array<AdStudioProjectBriefVersions>;
  /** fetch aggregated fields from the table: "ad_studio_project_brief_versions" */
  ad_studio_project_brief_versions_aggregate: AdStudioProjectBriefVersionsAggregate;
  /** fetch data from the table: "ad_studio_project_brief_versions" using primary key columns */
  ad_studio_project_brief_versions_by_pk?: Maybe<AdStudioProjectBriefVersions>;
  /** fetch data from the table: "ad_studio_project_pins" */
  ad_studio_project_pins: Array<AdStudioProjectPins>;
  /** fetch aggregated fields from the table: "ad_studio_project_pins" */
  ad_studio_project_pins_aggregate: AdStudioProjectPinsAggregate;
  /** fetch data from the table: "ad_studio_project_pins" using primary key columns */
  ad_studio_project_pins_by_pk?: Maybe<AdStudioProjectPins>;
  /** An array relationship */
  ad_studio_projects: Array<AdStudioProjects>;
  /** An aggregate relationship */
  ad_studio_projects_aggregate: AdStudioProjectsAggregate;
  /** fetch data from the table: "ad_studio_projects" using primary key columns */
  ad_studio_projects_by_pk?: Maybe<AdStudioProjects>;
  /** An array relationship */
  ad_studio_sessions: Array<AdStudioSessions>;
  /** An aggregate relationship */
  ad_studio_sessions_aggregate: AdStudioSessionsAggregate;
  /** fetch data from the table: "ad_studio_sessions" using primary key columns */
  ad_studio_sessions_by_pk?: Maybe<AdStudioSessions>;
  /** fetch data from the table: "ad_studio_treatments" */
  ad_studio_treatments: Array<AdStudioTreatments>;
  /** fetch aggregated fields from the table: "ad_studio_treatments" */
  ad_studio_treatments_aggregate: AdStudioTreatmentsAggregate;
  /** fetch data from the table: "ad_studio_treatments" using primary key columns */
  ad_studio_treatments_by_pk?: Maybe<AdStudioTreatments>;
  adminEntitlementStatus: AdminEntitlementStatusResult;
  adminFragment: AdminFragmentResult;
  /** fetch data from the table: "admin_entitlements" */
  admin_entitlements: Array<AdminEntitlements>;
  /** fetch data from the table: "admin_entitlements" using primary key columns */
  admin_entitlements_by_pk?: Maybe<AdminEntitlements>;
  /** fetch data from the table: "admin_workspace_entitlements" */
  admin_workspace_entitlements: Array<AdminWorkspaceEntitlements>;
  /** The ads saved to an inspiration board, newest first. */
  adsForInspirationBoard: CompetitorAdsResult;
  aeo_sites_with_last_run: Array<AiChannelSite>;
  agentConnectorDefinitions: Array<AgentConnectorDefinition>;
  agentConnectors: Array<AgentConnector>;
  /** A live definition with its versions, or null when there is none with this id. */
  agentDefinition?: Maybe<AgentDefinitionDetail>;
  /**
   * Sessions that read the definition, newest read first. limit defaults to
   * 10 and may not exceed 100.
   */
  agentDefinitionSessions: AgentDefinitionSessionPage;
  /** Definition versions by id, including superseded ones and those of deleted definitions. Unknown ids are skipped. */
  agentDefinitionVersions: Array<CitedAgentDefinitionVersion>;
  /** Every live definition in the workspace, or only those whose id is in ids. Unknown ids are skipped. */
  agentDefinitions: Array<AgentDefinition>;
  agentSessionMessages?: Maybe<AgentSessionMessagesResponse>;
  agentUsageBreakdown: AgentUsageBreakdownResponse;
  agentUsageCredits: AgentUsageCredits;
  /** fetch data from the table: "agent_asset_versions" */
  agent_asset_versions: Array<AgentAssetVersions>;
  /** fetch aggregated fields from the table: "agent_asset_versions" */
  agent_asset_versions_aggregate: AgentAssetVersionsAggregate;
  /** fetch data from the table: "agent_asset_versions" using primary key columns */
  agent_asset_versions_by_pk?: Maybe<AgentAssetVersions>;
  /** fetch data from the table: "agent_assets" */
  agent_assets: Array<AgentAssets>;
  /** fetch aggregated fields from the table: "agent_assets" */
  agent_assets_aggregate: AgentAssetsAggregate;
  /** fetch data from the table: "agent_assets" using primary key columns */
  agent_assets_by_pk?: Maybe<AgentAssets>;
  /** fetch data from the table: "agent_report_suggestions" */
  agent_report_suggestions: Array<AgentReportSuggestions>;
  /** fetch data from the table: "agent_report_suggestions" using primary key columns */
  agent_report_suggestions_by_pk?: Maybe<AgentReportSuggestions>;
  /** fetch data from the table: "agent_suggestion_batches" */
  agent_suggestion_batches: Array<AgentSuggestionBatches>;
  /** fetch data from the table: "agent_suggestion_batches" using primary key columns */
  agent_suggestion_batches_by_pk?: Maybe<AgentSuggestionBatches>;
  /** fetch data from the table: "agent_suggestions" */
  agent_suggestions: Array<AgentSuggestions>;
  /** fetch data from the table: "agent_suggestions" using primary key columns */
  agent_suggestions_by_pk?: Maybe<AgentSuggestions>;
  /**
   * Per-file usage stats, categorized by agent, over existing audit rows. Scoped
   * to the caller's workspace and to the requested `entityIds`. `windowDays`
   * sets the "this window" size (default 7).
   */
  agenticSettingsEntityUsage: Array<ContextEntityUsage>;
  /** fetch data from the table: "agentic_settings" */
  agentic_settings: Array<AgenticSettings>;
  /** fetch data from the table: "agentic_settings" using primary key columns */
  agentic_settings_by_pk?: Maybe<AgenticSettings>;
  /** An array relationship */
  agentic_settings_entities_links: Array<AgenticSettingsEntitiesLinks>;
  /** fetch data from the table: "agentic_settings_entities_links" using primary key columns */
  agentic_settings_entities_links_by_pk?: Maybe<AgenticSettingsEntitiesLinks>;
  /** fetch data from the table: "agentic_settings_entity_review_suggestions" */
  agentic_settings_entity_review_suggestions: Array<AgenticSettingsEntityReviewSuggestions>;
  /** fetch aggregated fields from the table: "agentic_settings_entity_review_suggestions" */
  agentic_settings_entity_review_suggestions_aggregate: AgenticSettingsEntityReviewSuggestionsAggregate;
  /** fetch data from the table: "agentic_settings_entity_review_suggestions" using primary key columns */
  agentic_settings_entity_review_suggestions_by_pk?: Maybe<AgenticSettingsEntityReviewSuggestions>;
  /** fetch data from the table: "agentic_settings_entity_reviews" */
  agentic_settings_entity_reviews: Array<AgenticSettingsEntityReviews>;
  /** fetch data from the table: "agentic_settings_entity_reviews" using primary key columns */
  agentic_settings_entity_reviews_by_pk?: Maybe<AgenticSettingsEntityReviews>;
  airBoardTree: AirBoardTreeResult;
  /** fetch data from the table: "airbyte_syncs" */
  airbyte_syncs: Array<AirbyteSyncs>;
  /** fetch data from the table: "airbyte_syncs" using primary key columns */
  airbyte_syncs_by_pk?: Maybe<AirbyteSyncs>;
  airtableGetBases: AirtableGetBasesResult;
  airtableGetTablesMeta: AirtableGetTablesMetaResult;
  airtableListBases?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  airtableListTables?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  /** fetch data from the table: "alert_statuses" using primary key columns */
  alert_statuses_by_pk?: Maybe<AlertStatuses>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk?: Maybe<Alerts>;
  /** An array relationship */
  all_memberships_v2: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  all_memberships_v2_aggregate: AllMembershipsV2Aggregate;
  /** The AMP agent with the id, or null when the session is not an AMP agent of the workspace. */
  ampAgent?: Maybe<AmpAgent>;
  /** The transcript of an AMP agent in index order, then its inbox in arrival order. */
  ampAgentMessages: Array<AmpAgentMessage>;
  /** The root AMP agents that the user created, newest first. */
  ampAgents: Array<AmpAgent>;
  ampAssetSourceDefinitions: Array<AmpAssetSourceDefinition>;
  /**
   * Newest first. With a taskId the feed includes the task's subtasks. With
   * neither id it covers every project that is not archived.
   */
  ampBoardActivity: Array<AmpBoardActivityEvent>;
  /** When the newest project event happened, so a client can tell when to refetch. */
  ampBoardLatestActivityAt?: Maybe<Scalars['String']>;
  ampBoardLatestActivityId?: Maybe<Scalars['ID']>;
  ampCanvas: AmpCanvas;
  ampCanvasStamp: AmpCanvasStamp;
  /** The private originals of the given published email image URLs, for previews that load them resized. URLs that aren't this workspace's content-node images in a format the resizer shrinks are left out. */
  ampEmailImageKeys: AmpEmailImageKeysResult;
  ampFile: AmpFile;
  /** A doc, upload, web page or slide deck as it was saved at one of its past versions. Other file types return an error. */
  ampFileAtVersion: AmpFile;
  ampFileFolders: Array<AmpFolder>;
  /** The stamps of the files the user can see among these ids, in the order asked. Reads no content, so it is cheap to poll. */
  ampFileStamps: Array<AmpFileStamp>;
  ampFileUsage: AmpFileUsage;
  ampFileVersions: Array<AmpFileVersion>;
  /** updatesLimit is how many of the updates to return. */
  ampInbox: AmpInbox;
  ampInboxUnreadCount: AmpInboxUnreadCount;
  /** includeHidden counts private files, as listAmpFiles does. */
  ampLibraryCounts: AmpLibraryCounts;
  /** The active monitors of the task's agent session and of every session below it, newest first. */
  ampTaskMonitors: Array<AmpTaskMonitor>;
  /** fetch data from the table: "amp_action_calls" */
  amp_action_calls: Array<AmpActionCalls>;
  /** fetch aggregated fields from the table: "amp_action_calls" */
  amp_action_calls_aggregate: AmpActionCallsAggregate;
  /** fetch data from the table: "amp_action_calls" using primary key columns */
  amp_action_calls_by_pk?: Maybe<AmpActionCalls>;
  /** fetch data from the table: "amp_action_plan_versions" */
  amp_action_plan_versions: Array<AmpActionPlanVersions>;
  /** fetch aggregated fields from the table: "amp_action_plan_versions" */
  amp_action_plan_versions_aggregate: AmpActionPlanVersionsAggregate;
  /** fetch data from the table: "amp_action_plan_versions" using primary key columns */
  amp_action_plan_versions_by_pk?: Maybe<AmpActionPlanVersions>;
  /** An array relationship */
  amp_action_plans: Array<AmpActionPlans>;
  /** An aggregate relationship */
  amp_action_plans_aggregate: AmpActionPlansAggregate;
  /** fetch data from the table: "amp_action_plans" using primary key columns */
  amp_action_plans_by_pk?: Maybe<AmpActionPlans>;
  /** An array relationship */
  amp_action_tool_calls: Array<AmpActionToolCalls>;
  /** An aggregate relationship */
  amp_action_tool_calls_aggregate: AmpActionToolCallsAggregate;
  /** fetch data from the table: "amp_action_tool_calls" using primary key columns */
  amp_action_tool_calls_by_pk?: Maybe<AmpActionToolCalls>;
  /** fetch data from the table: "amp_actions" */
  amp_actions: Array<AmpActions>;
  /** fetch aggregated fields from the table: "amp_actions" */
  amp_actions_aggregate: AmpActionsAggregate;
  /** fetch data from the table: "amp_actions" using primary key columns */
  amp_actions_by_pk?: Maybe<AmpActions>;
  /** fetch data from the table: "amp_asset_groups" */
  amp_asset_groups: Array<AmpAssetGroups>;
  /** fetch aggregated fields from the table: "amp_asset_groups" */
  amp_asset_groups_aggregate: AmpAssetGroupsAggregate;
  /** fetch data from the table: "amp_asset_groups" using primary key columns */
  amp_asset_groups_by_pk?: Maybe<AmpAssetGroups>;
  /** An array relationship */
  amp_asset_ratings: Array<AmpAssetRatings>;
  /** An aggregate relationship */
  amp_asset_ratings_aggregate: AmpAssetRatingsAggregate;
  /** fetch data from the table: "amp_asset_ratings" using primary key columns */
  amp_asset_ratings_by_pk?: Maybe<AmpAssetRatings>;
  /** fetch data from the table: "amp_asset_sources" */
  amp_asset_sources: Array<AmpAssetSources>;
  /** fetch aggregated fields from the table: "amp_asset_sources" */
  amp_asset_sources_aggregate: AmpAssetSourcesAggregate;
  /** fetch data from the table: "amp_asset_sources" using primary key columns */
  amp_asset_sources_by_pk?: Maybe<AmpAssetSources>;
  /** fetch data from the table: "amp_asset_sync_runs" */
  amp_asset_sync_runs: Array<AmpAssetSyncRuns>;
  /** fetch aggregated fields from the table: "amp_asset_sync_runs" */
  amp_asset_sync_runs_aggregate: AmpAssetSyncRunsAggregate;
  /** fetch data from the table: "amp_asset_sync_runs" using primary key columns */
  amp_asset_sync_runs_by_pk?: Maybe<AmpAssetSyncRuns>;
  /** fetch data from the table: "amp_asset_syncs" */
  amp_asset_syncs: Array<AmpAssetSyncs>;
  /** fetch aggregated fields from the table: "amp_asset_syncs" */
  amp_asset_syncs_aggregate: AmpAssetSyncsAggregate;
  /** fetch data from the table: "amp_asset_syncs" using primary key columns */
  amp_asset_syncs_by_pk?: Maybe<AmpAssetSyncs>;
  /** fetch data from the table: "amp_creative_classification_runs" */
  amp_creative_classification_runs: Array<AmpCreativeClassificationRuns>;
  /** fetch aggregated fields from the table: "amp_creative_classification_runs" */
  amp_creative_classification_runs_aggregate: AmpCreativeClassificationRunsAggregate;
  /** fetch data from the table: "amp_creative_classification_runs" using primary key columns */
  amp_creative_classification_runs_by_pk?: Maybe<AmpCreativeClassificationRuns>;
  /** fetch data from the table: "amp_creative_dimension_values" */
  amp_creative_dimension_values: Array<AmpCreativeDimensionValues>;
  /** fetch data from the table: "amp_creative_dimension_values" using primary key columns */
  amp_creative_dimension_values_by_pk?: Maybe<AmpCreativeDimensionValues>;
  /** fetch data from the table: "amp_creative_dimensions" */
  amp_creative_dimensions: Array<AmpCreativeDimensions>;
  /** fetch aggregated fields from the table: "amp_creative_dimensions" */
  amp_creative_dimensions_aggregate: AmpCreativeDimensionsAggregate;
  /** fetch data from the table: "amp_creative_dimensions" using primary key columns */
  amp_creative_dimensions_by_pk?: Maybe<AmpCreativeDimensions>;
  /** fetch data from the table: "amp_file_favorites" */
  amp_file_favorites: Array<AmpFileFavorites>;
  /** fetch data from the table: "amp_file_favorites" using primary key columns */
  amp_file_favorites_by_pk?: Maybe<AmpFileFavorites>;
  /** fetch data from the table: "amp_files" */
  amp_files: Array<AmpFiles>;
  /** fetch aggregated fields from the table: "amp_files" */
  amp_files_aggregate: AmpFilesAggregate;
  /** fetch data from the table: "amp_files" using primary key columns */
  amp_files_by_pk?: Maybe<AmpFiles>;
  /** fetch data from the table: "amp_followed_sources" */
  amp_followed_sources: Array<AmpFollowedSources>;
  /** fetch aggregated fields from the table: "amp_followed_sources" */
  amp_followed_sources_aggregate: AmpFollowedSourcesAggregate;
  /** fetch data from the table: "amp_followed_sources" using primary key columns */
  amp_followed_sources_by_pk?: Maybe<AmpFollowedSources>;
  /** fetch data from the table: "amp_followed_topics" */
  amp_followed_topics: Array<AmpFollowedTopics>;
  /** fetch aggregated fields from the table: "amp_followed_topics" */
  amp_followed_topics_aggregate: AmpFollowedTopicsAggregate;
  /** fetch data from the table: "amp_followed_topics" using primary key columns */
  amp_followed_topics_by_pk?: Maybe<AmpFollowedTopics>;
  /** An array relationship */
  amp_launch_verdicts: Array<AmpLaunchVerdicts>;
  /** fetch data from the table: "amp_launch_verdicts" using primary key columns */
  amp_launch_verdicts_by_pk?: Maybe<AmpLaunchVerdicts>;
  /** An array relationship */
  amp_opportunities: Array<AmpOpportunities>;
  /** An aggregate relationship */
  amp_opportunities_aggregate: AmpOpportunitiesAggregate;
  /** fetch data from the table: "amp_opportunities" using primary key columns */
  amp_opportunities_by_pk?: Maybe<AmpOpportunities>;
  /** fetch data from the table: "amp_project_links" */
  amp_project_links: Array<AmpProjectLinks>;
  /** fetch aggregated fields from the table: "amp_project_links" */
  amp_project_links_aggregate: AmpProjectLinksAggregate;
  /** fetch data from the table: "amp_project_links" using primary key columns */
  amp_project_links_by_pk?: Maybe<AmpProjectLinks>;
  /** fetch data from the table: "amp_project_pins" */
  amp_project_pins: Array<AmpProjectPins>;
  /** fetch data from the table: "amp_project_pins" using primary key columns */
  amp_project_pins_by_pk?: Maybe<AmpProjectPins>;
  /** fetch data from the table: "amp_project_users" */
  amp_project_users: Array<AmpProjectUsers>;
  /** fetch aggregated fields from the table: "amp_project_users" */
  amp_project_users_aggregate: AmpProjectUsersAggregate;
  /** fetch data from the table: "amp_project_users" using primary key columns */
  amp_project_users_by_pk?: Maybe<AmpProjectUsers>;
  /** fetch data from the table: "amp_projects" */
  amp_projects: Array<AmpProjects>;
  /** fetch aggregated fields from the table: "amp_projects" */
  amp_projects_aggregate: AmpProjectsAggregate;
  /** fetch data from the table: "amp_projects" using primary key columns */
  amp_projects_by_pk?: Maybe<AmpProjects>;
  /** An array relationship */
  amp_signals: Array<AmpSignals>;
  /** An aggregate relationship */
  amp_signals_aggregate: AmpSignalsAggregate;
  /** fetch data from the table: "amp_signals" using primary key columns */
  amp_signals_by_pk?: Maybe<AmpSignals>;
  /** fetch data from the table: "amp_tags" */
  amp_tags: Array<AmpTags>;
  /** fetch aggregated fields from the table: "amp_tags" */
  amp_tags_aggregate: AmpTagsAggregate;
  /** fetch data from the table: "amp_tags" using primary key columns */
  amp_tags_by_pk?: Maybe<AmpTags>;
  /** fetch data from the table: "amp_task_relations" */
  amp_task_relations: Array<AmpTaskRelations>;
  /** fetch aggregated fields from the table: "amp_task_relations" */
  amp_task_relations_aggregate: AmpTaskRelationsAggregate;
  /** fetch data from the table: "amp_task_relations" using primary key columns */
  amp_task_relations_by_pk?: Maybe<AmpTaskRelations>;
  /** fetch data from the table: "amp_task_reviews" */
  amp_task_reviews: Array<AmpTaskReviews>;
  /** fetch aggregated fields from the table: "amp_task_reviews" */
  amp_task_reviews_aggregate: AmpTaskReviewsAggregate;
  /** fetch data from the table: "amp_task_reviews" using primary key columns */
  amp_task_reviews_by_pk?: Maybe<AmpTaskReviews>;
  /** fetch data from the table: "amp_task_tags" */
  amp_task_tags: Array<AmpTaskTags>;
  /** fetch aggregated fields from the table: "amp_task_tags" */
  amp_task_tags_aggregate: AmpTaskTagsAggregate;
  /** fetch data from the table: "amp_task_tags" using primary key columns */
  amp_task_tags_by_pk?: Maybe<AmpTaskTags>;
  /** fetch data from the table: "amp_task_users" */
  amp_task_users: Array<AmpTaskUsers>;
  /** fetch aggregated fields from the table: "amp_task_users" */
  amp_task_users_aggregate: AmpTaskUsersAggregate;
  /** fetch data from the table: "amp_task_users" using primary key columns */
  amp_task_users_by_pk?: Maybe<AmpTaskUsers>;
  /** fetch data from the table: "amp_tasks" */
  amp_tasks: Array<AmpTasks>;
  /** fetch aggregated fields from the table: "amp_tasks" */
  amp_tasks_aggregate: AmpTasksAggregate;
  /** fetch data from the table: "amp_tasks" using primary key columns */
  amp_tasks_by_pk?: Maybe<AmpTasks>;
  /** fetch data from the table: "amp_team_members" */
  amp_team_members: Array<AmpTeamMembers>;
  /** fetch aggregated fields from the table: "amp_team_members" */
  amp_team_members_aggregate: AmpTeamMembersAggregate;
  /** fetch data from the table: "amp_team_members" using primary key columns */
  amp_team_members_by_pk?: Maybe<AmpTeamMembers>;
  /** fetch data from the table: "amp_teams" */
  amp_teams: Array<AmpTeams>;
  /** fetch aggregated fields from the table: "amp_teams" */
  amp_teams_aggregate: AmpTeamsAggregate;
  /** fetch data from the table: "amp_teams" using primary key columns */
  amp_teams_by_pk?: Maybe<AmpTeams>;
  /** fetch data from the table: "amp_workflow_status_reviewers" */
  amp_workflow_status_reviewers: Array<AmpWorkflowStatusReviewers>;
  /** fetch aggregated fields from the table: "amp_workflow_status_reviewers" */
  amp_workflow_status_reviewers_aggregate: AmpWorkflowStatusReviewersAggregate;
  /** fetch data from the table: "amp_workflow_status_reviewers" using primary key columns */
  amp_workflow_status_reviewers_by_pk?: Maybe<AmpWorkflowStatusReviewers>;
  /** fetch data from the table: "amp_workflow_statuses" */
  amp_workflow_statuses: Array<AmpWorkflowStatuses>;
  /** fetch aggregated fields from the table: "amp_workflow_statuses" */
  amp_workflow_statuses_aggregate: AmpWorkflowStatusesAggregate;
  /** fetch data from the table: "amp_workflow_statuses" using primary key columns */
  amp_workflow_statuses_by_pk?: Maybe<AmpWorkflowStatuses>;
  /** fetch data from the table: "amp_workflows" */
  amp_workflows: Array<AmpWorkflows>;
  /** fetch aggregated fields from the table: "amp_workflows" */
  amp_workflows_aggregate: AmpWorkflowsAggregate;
  /** fetch data from the table: "amp_workflows" using primary key columns */
  amp_workflows_by_pk?: Maybe<AmpWorkflows>;
  /** fetch data from the table: "analytics_ingestion_stats" */
  analytics_ingestion_stats: Array<AnalyticsIngestionStats>;
  /** fetch data from the table: "analytics_ingestion_stats" using primary key columns */
  analytics_ingestion_stats_by_pk?: Maybe<AnalyticsIngestionStats>;
  /** fetch data from the table: "analytics_reports" */
  analytics_reports: Array<AnalyticsReports>;
  /** fetch data from the table: "analytics_reports" using primary key columns */
  analytics_reports_by_pk?: Maybe<AnalyticsReports>;
  analyzeDecisionEngineTagsForMessage: Scalars['String'];
  /**
   * Per-property value distribution over a journey's entry-event model. Powers
   * the entry-event groups in the Scenarios sidebar; empty if no entry event.
   */
  analyzeEntryEventDistribution: PreviewAnalysis;
  /** Powers the Scenarios sidebar. Empty if flag off or no parent model. */
  analyzeMessagePreview: PreviewAnalysis;
  /** An array relationship */
  api_keys: Array<ApiKeys>;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk?: Maybe<ApiKeys>;
  aprimoClassification: AprimoClassification;
  aprimoClassificationTree: AprimoClassificationTreeResult;
  aprimoMetadataFieldOptions: Array<AprimoMetadataFieldOption>;
  /** fetch data from the table: "artifact_favorites" */
  artifact_favorites: Array<ArtifactFavorites>;
  /** fetch aggregated fields from the table: "artifact_favorites" */
  artifact_favorites_aggregate: ArtifactFavoritesAggregate;
  /** fetch data from the table: "artifact_favorites" using primary key columns */
  artifact_favorites_by_pk?: Maybe<ArtifactFavorites>;
  /** fetch data from the table: "artifact_review_comments" */
  artifact_review_comments: Array<ArtifactReviewComments>;
  /** fetch aggregated fields from the table: "artifact_review_comments" */
  artifact_review_comments_aggregate: ArtifactReviewCommentsAggregate;
  /** fetch data from the table: "artifact_review_comments" using primary key columns */
  artifact_review_comments_by_pk?: Maybe<ArtifactReviewComments>;
  /** fetch data from the table: "artifact_review_statuses" */
  artifact_review_statuses: Array<ArtifactReviewStatuses>;
  /** fetch aggregated fields from the table: "artifact_review_statuses" */
  artifact_review_statuses_aggregate: ArtifactReviewStatusesAggregate;
  /** fetch data from the table: "artifact_review_statuses" using primary key columns */
  artifact_review_statuses_by_pk?: Maybe<ArtifactReviewStatuses>;
  /** fetch data from the table: "artifact_reviewers" */
  artifact_reviewers: Array<ArtifactReviewers>;
  /** fetch aggregated fields from the table: "artifact_reviewers" */
  artifact_reviewers_aggregate: ArtifactReviewersAggregate;
  /** fetch data from the table: "artifact_reviewers" using primary key columns */
  artifact_reviewers_by_pk?: Maybe<ArtifactReviewers>;
  /** fetch data from the table: "artifact_reviews" */
  artifact_reviews: Array<ArtifactReviews>;
  /** fetch aggregated fields from the table: "artifact_reviews" */
  artifact_reviews_aggregate: ArtifactReviewsAggregate;
  /** fetch data from the table: "artifact_reviews" using primary key columns */
  artifact_reviews_by_pk?: Maybe<ArtifactReviews>;
  asanaAssignableUsers: Array<AsanaNamedRef>;
  /** How far an attach job has got. Null when no such job belongs to this workspace. */
  asanaAttachStatus?: Maybe<AsanaAttachStatus>;
  /** Sections of one of the task's projects. Loaded on demand — the picker is rarely opened. */
  asanaProjectSections: Array<AsanaNamedRef>;
  /** Projects in the workspace's connected Asana, for the create-task picker. Empty when Asana is not connected. */
  asanaProjects: Array<AsanaNamedRef>;
  /** Subtasks, comments and attachments, each degrading independently. */
  asanaTaskActivity?: Maybe<AsanaTaskActivity>;
  /** The Asana task this campaign was created from, or null when it has no link. `ancestorGids` drills into a subtask: the verified path from the campaign's task down to the one wanted. */
  asanaTaskDetail?: Maybe<AsanaTaskDetail>;
  /**
   * The workspace's asset collections. Sourced from amp_asset_groups — the
   * canonical read path, replacing the legacy
   * agentic_settings.settings.campaignAgent.assetTypes blob.
   */
  assetCollections: Array<AssetCollection>;
  /**
   * The notification feed: every ad comment the caller can see, newest first, or
   * only the unread ones. See AssetCommentFeedFilter.
   *
   * Read state is per-thread, so opening a thread clears all of its comments
   * from the unread half at once.
   *
   * limit is the page size, 1 to 100, defaulting to 20.
   */
  assetCommentFeed: AssetCommentFeedPage;
  assetTagDimensions: Array<AssetTagDimension>;
  /** fetch data from the table: "asset_comment_mentions" */
  asset_comment_mentions: Array<AssetCommentMentions>;
  /** fetch aggregated fields from the table: "asset_comment_mentions" */
  asset_comment_mentions_aggregate: AssetCommentMentionsAggregate;
  /** fetch data from the table: "asset_comment_mentions" using primary key columns */
  asset_comment_mentions_by_pk?: Maybe<AssetCommentMentions>;
  /** fetch data from the table: "asset_comment_statuses" */
  asset_comment_statuses: Array<AssetCommentStatuses>;
  /** fetch aggregated fields from the table: "asset_comment_statuses" */
  asset_comment_statuses_aggregate: AssetCommentStatusesAggregate;
  /** fetch data from the table: "asset_comment_statuses" using primary key columns */
  asset_comment_statuses_by_pk?: Maybe<AssetCommentStatuses>;
  /** fetch data from the table: "asset_comment_thread_reads" */
  asset_comment_thread_reads: Array<AssetCommentThreadReads>;
  /** fetch data from the table: "asset_comment_thread_reads" using primary key columns */
  asset_comment_thread_reads_by_pk?: Maybe<AssetCommentThreadReads>;
  /** fetch data from the table: "asset_comment_thread_statuses" */
  asset_comment_thread_statuses: Array<AssetCommentThreadStatuses>;
  /** fetch aggregated fields from the table: "asset_comment_thread_statuses" */
  asset_comment_thread_statuses_aggregate: AssetCommentThreadStatusesAggregate;
  /** fetch data from the table: "asset_comment_thread_statuses" using primary key columns */
  asset_comment_thread_statuses_by_pk?: Maybe<AssetCommentThreadStatuses>;
  /** fetch data from the table: "asset_comment_threads" */
  asset_comment_threads: Array<AssetCommentThreads>;
  /** fetch aggregated fields from the table: "asset_comment_threads" */
  asset_comment_threads_aggregate: AssetCommentThreadsAggregate;
  /** fetch data from the table: "asset_comment_threads" using primary key columns */
  asset_comment_threads_by_pk?: Maybe<AssetCommentThreads>;
  /** fetch data from the table: "asset_comments" */
  asset_comments: Array<AssetComments>;
  /** fetch aggregated fields from the table: "asset_comments" */
  asset_comments_aggregate: AssetCommentsAggregate;
  /** fetch data from the table: "asset_comments" using primary key columns */
  asset_comments_by_pk?: Maybe<AssetComments>;
  /** fetch data from the table: "asset_models" */
  asset_models: Array<AssetModels>;
  /** fetch data from the table: "asset_models" using primary key columns */
  asset_models_by_pk?: Maybe<AssetModels>;
  /** fetch data from the table: "asset_statuses" */
  asset_statuses: Array<AssetStatuses>;
  /** fetch aggregated fields from the table: "asset_statuses" */
  asset_statuses_aggregate: AssetStatusesAggregate;
  /** fetch data from the table: "asset_statuses" using primary key columns */
  asset_statuses_by_pk?: Maybe<AssetStatuses>;
  assignableUserGroups: Array<AssignableUserGroup>;
  athenaListDataCatalogs: AthenaListDataCatalogsResult;
  athenaListDataCatalogsNewSource: AthenaListDataCatalogsResult;
  athenaListDatabases: AthenaListDatabasesResult;
  athenaListDatabasesNewSource: AthenaListDatabasesResult;
  athenaListWorkGroups: AthenaListWorkGroupsResult;
  athenaListWorkGroupsNewSource: AthenaListWorkGroupsResult;
  /** An array relationship */
  attribution_methods: Array<AttributionMethods>;
  /** An aggregate relationship */
  attribution_methods_aggregate: AttributionMethodsAggregate;
  /** fetch data from the table: "attribution_methods" using primary key columns */
  attribution_methods_by_pk?: Maybe<AttributionMethods>;
  /** An array relationship */
  attribution_methods_interactions: Array<AttributionMethodsInteractions>;
  /** fetch data from the table: "attribution_methods_interactions" using primary key columns */
  attribution_methods_interactions_by_pk?: Maybe<AttributionMethodsInteractions>;
  audienceComparison: AudienceComparisonResult;
  audienceComparisonBackground: AudienceComparisonBackgroundJob;
  audienceComparisonBackgroundResult: AudienceComparisonBackgroundResponse;
  audienceFilterOptions: AudienceFilterOptions;
  audienceLabels: Array<AudienceLabelPair>;
  audienceMembershipsBackground: ProfileExplorerJob;
  audienceMembershipsBackgroundResult?: Maybe<AudienceMembershipsBackgroundResult>;
  audienceReferenceStats?: Maybe<AudienceReferenceStats>;
  /**
   * Returns the audience as it looked at the time of the last successful
   * warehouse pull, by reading the `old` field of the oldest changelog
   * entry after `afterTimestamp`. Returns null if there have been no
   * changes to the audience since that timestamp (i.e. nothing is stale).
   */
  audienceSnapshotAtLastPull?: Maybe<AudienceSnapshotAtPull>;
  /** An array relationship */
  audience_goals: Array<AudienceGoals>;
  /** An aggregate relationship */
  audience_goals_aggregate: AudienceGoalsAggregate;
  /** fetch data from the table: "audience_goals" using primary key columns */
  audience_goals_by_pk?: Maybe<AudienceGoals>;
  /** An array relationship */
  audience_overviews: Array<AudienceOverviews>;
  /** An aggregate relationship */
  audience_overviews_aggregate: AudienceOverviewsAggregate;
  /** fetch data from the table: "audience_overviews" using primary key columns */
  audience_overviews_by_pk?: Maybe<AudienceOverviews>;
  /** An array relationship */
  audience_primary_metrics: Array<AudiencePrimaryMetrics>;
  /** An aggregate relationship */
  audience_primary_metrics_aggregate: AudiencePrimaryMetricsAggregate;
  /** fetch data from the table: "audience_primary_metrics" using primary key columns */
  audience_primary_metrics_by_pk?: Maybe<AudiencePrimaryMetrics>;
  /** fetch data from the table: "audience_splits" */
  audience_splits: Array<AudienceSplits>;
  /** fetch aggregated fields from the table: "audience_splits" */
  audience_splits_aggregate: AudienceSplitsAggregate;
  /** fetch data from the table: "audience_splits" using primary key columns */
  audience_splits_by_pk?: Maybe<AudienceSplits>;
  /** fetch data from the table: "audience_subset_group_required_models" */
  audience_subset_group_required_models: Array<AudienceSubsetGroupRequiredModels>;
  /** fetch aggregated fields from the table: "audience_subset_group_required_models" */
  audience_subset_group_required_models_aggregate: AudienceSubsetGroupRequiredModelsAggregate;
  /** fetch data from the table: "audience_subset_group_required_models" using primary key columns */
  audience_subset_group_required_models_by_pk?: Maybe<AudienceSubsetGroupRequiredModels>;
  /** fetch data from the table: "audience_subset_groups" */
  audience_subset_groups: Array<AudienceSubsetGroups>;
  /** fetch aggregated fields from the table: "audience_subset_groups" */
  audience_subset_groups_aggregate: AudienceSubsetGroupsAggregate;
  /** fetch data from the table: "audience_subset_groups" using primary key columns */
  audience_subset_groups_by_pk?: Maybe<AudienceSubsetGroups>;
  /** fetch data from the table: "audience_subset_value_scoped_conditions" */
  audience_subset_value_scoped_conditions: Array<AudienceSubsetValueScopedConditions>;
  /** fetch aggregated fields from the table: "audience_subset_value_scoped_conditions" */
  audience_subset_value_scoped_conditions_aggregate: AudienceSubsetValueScopedConditionsAggregate;
  /** fetch data from the table: "audience_subset_value_scoped_conditions" using primary key columns */
  audience_subset_value_scoped_conditions_by_pk?: Maybe<AudienceSubsetValueScopedConditions>;
  /** fetch data from the table: "audience_subset_values" */
  audience_subset_values: Array<AudienceSubsetValues>;
  /** fetch aggregated fields from the table: "audience_subset_values" */
  audience_subset_values_aggregate: AudienceSubsetValuesAggregate;
  /** fetch data from the table: "audience_subset_values" using primary key columns */
  audience_subset_values_by_pk?: Maybe<AudienceSubsetValues>;
  /** fetch data from the table: "audience_templates" */
  audience_templates: Array<AudienceTemplates>;
  /** fetch aggregated fields from the table: "audience_templates" */
  audience_templates_aggregate: AudienceTemplatesAggregate;
  /** fetch data from the table: "audience_templates" using primary key columns */
  audience_templates_by_pk?: Maybe<AudienceTemplates>;
  /** An array relationship */
  audiences_subsets: Array<AudiencesSubsets>;
  /** An aggregate relationship */
  audiences_subsets_aggregate: AudiencesSubsetsAggregate;
  /** fetch data from the table: "audiences_subsets" using primary key columns */
  audiences_subsets_by_pk?: Maybe<AudiencesSubsets>;
  auditLog: ChangelogResult;
  /** An array relationship */
  auth0_connections: Array<Auth0Connections>;
  /** fetch data from the table: "auth0_connections" using primary key columns */
  auth0_connections_by_pk?: Maybe<Auth0Connections>;
  authorizedDraftModelReviewers: AuthorizedReviewers;
  authorizedDraftSyncReviewers: AuthorizedReviewers;
  authorizedNativeDeliveryReviewers: AuthorizedReviewers;
  backgroundDiscoveryResult: DiscoverBackgroundResult;
  backgroundModelPreviewQueryResult?: Maybe<QueryResponse>;
  backgroundPreviewQueryResult?: Maybe<QueryResponse>;
  /** fetch data from the table: "billing_by_destination" */
  billing_by_destination: Array<BillingByDestination>;
  /** fetch data from the table: "billing_products" */
  billing_products: Array<BillingProducts>;
  /** fetch data from the table: "billing_products" using primary key columns */
  billing_products_by_pk?: Maybe<BillingProducts>;
  brandProfileFonts: Array<BrandProfileFonts>;
  /** fetch data from the table: "brand_profile_asset_groups" */
  brand_profile_asset_groups: Array<BrandProfileAssetGroups>;
  /** fetch aggregated fields from the table: "brand_profile_asset_groups" */
  brand_profile_asset_groups_aggregate: BrandProfileAssetGroupsAggregate;
  /** fetch data from the table: "brand_profile_asset_groups" using primary key columns */
  brand_profile_asset_groups_by_pk?: Maybe<BrandProfileAssetGroups>;
  /** fetch data from the table: "brand_profile_content_emails" */
  brand_profile_content_emails: Array<BrandProfileContentEmails>;
  /** fetch aggregated fields from the table: "brand_profile_content_emails" */
  brand_profile_content_emails_aggregate: BrandProfileContentEmailsAggregate;
  /** fetch data from the table: "brand_profile_content_emails" using primary key columns */
  brand_profile_content_emails_by_pk?: Maybe<BrandProfileContentEmails>;
  /** fetch data from the table: "brand_profile_settings_entities" */
  brand_profile_settings_entities: Array<BrandProfileSettingsEntities>;
  /** fetch aggregated fields from the table: "brand_profile_settings_entities" */
  brand_profile_settings_entities_aggregate: BrandProfileSettingsEntitiesAggregate;
  /** fetch data from the table: "brand_profile_settings_entities" using primary key columns */
  brand_profile_settings_entities_by_pk?: Maybe<BrandProfileSettingsEntities>;
  /** fetch data from the table: "brand_profiles" */
  brand_profiles: Array<BrandProfiles>;
  /** fetch aggregated fields from the table: "brand_profiles" */
  brand_profiles_aggregate: BrandProfilesAggregate;
  /** fetch data from the table: "brand_profiles" using primary key columns */
  brand_profiles_by_pk?: Maybe<BrandProfiles>;
  bynderCollections: BynderCollectionsResult;
  bynderMetaproperties: BynderMetapropertiesResult;
  bynderMetapropertyOptions: BynderMetapropertyOptionsResult;
  bynderTags: BynderTagsResult;
  cachedAudienceSize: CachedAudienceSizeResponse;
  cachedAudienceSizes: Array<CachedAudienceSizesResponse>;
  cachedSuppressionListSize: SuppressionListSizeResult;
  cachedSuppressionListSizes: Array<SuppressionListSizeResult>;
  /** fetch data from the table: "cached_event_pulls" */
  cached_event_pulls: Array<CachedEventPulls>;
  /** fetch data from the table: "cached_event_pulls" using primary key columns */
  cached_event_pulls_by_pk?: Maybe<CachedEventPulls>;
  calendarContext: CalendarContext;
  calendarView: CalendarView;
  calendarViews: Array<CalendarView>;
  campaignCalendar: CampaignCalendar;
  campaignCalendarConnectorSetup: Array<CampaignCalendarConnectorSetup>;
  campaignCalendarEngagementSetup: Array<CampaignCalendarEngagementSetup>;
  campaignCalendarEnrichmentLastRun?: Maybe<CampaignCalendarEnrichmentRun>;
  /**
   * sendId is a campaign calendar send id, <connectorId>:<native send id>.
   * The creative is the send's first channel unless channel names another one
   * the send carries: email, in_app, push, web_push, or sms.
   */
  campaignChannelCreative: CampaignChannelCreative;
  campaignInsight?: Maybe<CampaignInsightFeedItem>;
  campaignInsightFeed: CampaignInsightFeedPage;
  /**
   * The newest batch of calendar insight cards, minus dismissed cards. Empty
   * arrays when no batch exists or every card in it is dismissed.
   */
  campaignInsights: CampaignInsightSet;
  /**
   * The saved definitions Campaign Insights runs in the current workspace use
   * as segments and metrics, and the definitions that can be selected.
   * Requires Calendar access.
   */
  campaignInsightsDefinitionSettings: CampaignInsightsDefinitionSettings;
  /**
   * Summary of the newest insight batch for the staff dialog. Hightouch
   * employees only. Null when no batch exists.
   */
  campaignInsightsLiveBatch?: Maybe<CampaignInsightsLiveBatch>;
  /**
   * Custom metrics for a calendar month (YYYY-MM) from the newest completed
   * run. Empty when absent.
   */
  campaignMonthCustomMetrics: Array<CampaignInsightStat>;
  /** Poll a computation started by startCampaignRecipientsComputation. */
  campaignRecipientsResult: CampaignRecipientsResult;
  /** Custom metrics for this send from the newest completed run. Empty when absent. */
  campaignSendCustomMetrics: Array<CampaignInsightStat>;
  /** Calendar send ids that have cards in the newest batch. */
  campaignSendIdsWithInsights: Array<Scalars['String']>;
  /**
   * The newest batch's cards for one calendar send, in rank order. Empty when
   * that batch has no cards for the send, including for an unknown send id.
   */
  campaignSendInsights: Array<CampaignInsightFinding>;
  /** fetch data from the table: "campaign_artifact_version_best_practice_runs" */
  campaign_artifact_version_best_practice_runs: Array<CampaignArtifactVersionBestPracticeRuns>;
  /** fetch aggregated fields from the table: "campaign_artifact_version_best_practice_runs" */
  campaign_artifact_version_best_practice_runs_aggregate: CampaignArtifactVersionBestPracticeRunsAggregate;
  /** fetch data from the table: "campaign_artifact_version_best_practice_runs" using primary key columns */
  campaign_artifact_version_best_practice_runs_by_pk?: Maybe<CampaignArtifactVersionBestPracticeRuns>;
  /** fetch data from the table: "campaign_artifact_versions" */
  campaign_artifact_versions: Array<CampaignArtifactVersions>;
  /** fetch aggregated fields from the table: "campaign_artifact_versions" */
  campaign_artifact_versions_aggregate: CampaignArtifactVersionsAggregate;
  /** fetch data from the table: "campaign_artifact_versions" using primary key columns */
  campaign_artifact_versions_by_pk?: Maybe<CampaignArtifactVersions>;
  /** An array relationship */
  campaign_artifacts: Array<CampaignArtifacts>;
  /** An aggregate relationship */
  campaign_artifacts_aggregate: CampaignArtifactsAggregate;
  /** fetch data from the table: "campaign_artifacts" using primary key columns */
  campaign_artifacts_by_pk?: Maybe<CampaignArtifacts>;
  /** fetch data from the table: "campaign_drafts" */
  campaign_drafts: Array<CampaignDrafts>;
  /** fetch aggregated fields from the table: "campaign_drafts" */
  campaign_drafts_aggregate: CampaignDraftsAggregate;
  /** fetch data from the table: "campaign_drafts" using primary key columns */
  campaign_drafts_by_pk?: Maybe<CampaignDrafts>;
  /** An array relationship */
  campaign_labels: Array<CampaignLabels>;
  /** An aggregate relationship */
  campaign_labels_aggregate: CampaignLabelsAggregate;
  /** fetch data from the table: "campaign_labels" using primary key columns */
  campaign_labels_by_pk?: Maybe<CampaignLabels>;
  /** fetch data from the table: "campaign_list_entries" */
  campaign_list_entries: Array<CampaignListEntries>;
  /** fetch aggregated fields from the table: "campaign_list_entries" */
  campaign_list_entries_aggregate: CampaignListEntriesAggregate;
  /** An array relationship */
  campaign_runs: Array<CampaignRuns>;
  /** An aggregate relationship */
  campaign_runs_aggregate: CampaignRunsAggregate;
  /** fetch data from the table: "campaign_runs" using primary key columns */
  campaign_runs_by_pk?: Maybe<CampaignRuns>;
  /** An array relationship */
  campaigns: Array<Campaigns>;
  /** An aggregate relationship */
  campaigns_aggregate: CampaignsAggregate;
  /** fetch data from the table: "campaigns" using primary key columns */
  campaigns_by_pk?: Maybe<Campaigns>;
  canCreateAnyEventSync: CanCreateAnyEventSync;
  canDeployDestinationInstances: Array<DeploymentTestResult>;
  canDeploySegments: Array<DeploymentTestResult>;
  cantoFolderTree: CantoFolderTreeResult;
  cardinalityDetectionResult: CardinalityDetectionResult;
  /**
   * Folders holding assets in one collection, for a folder view. Only
   * DAM-imported assets carry a folder, so an empty list means there is no
   * folder structure to show.
   */
  catalogDirectories: Array<Scalars['String']>;
  /**
   * The allowlisted user tags (such as status) that assets in one collection
   * carry, with their values, for the Assets filter bar's pick lists.
   */
  catalogFilterableUserTags: Array<CatalogFilterableUserTag>;
  /** Fetch a single catalog product by id. Returns null if it doesn't exist in the workspace. Powers deep links to products outside the initially loaded page. */
  catalogProduct?: Maybe<CatalogProduct>;
  catalogProducts: CatalogProductsResult;
  /** Fetch multiple catalog products in one request (max 100), by artifact ids or by exact sourceRowKeys (usually SKUs; case-insensitive). Provide exactly one. Values that don't resolve in the workspace are dropped; results follow the input order. Powers hydrating stored selections (ids) and the intake picker's bulk SKU search (sourceRowKeys). */
  catalogProductsByIds: Array<CatalogProduct>;
  /** fetch data from the table: "catalog_collections" */
  catalog_collections: Array<CatalogCollections>;
  /** fetch data from the table: "catalog_collections" using primary key columns */
  catalog_collections_by_pk?: Maybe<CatalogCollections>;
  /** fetch data from the table: "catalog_models" */
  catalog_models: Array<CatalogModels>;
  /** fetch data from the table: "catalog_models" using primary key columns */
  catalog_models_by_pk?: Maybe<CatalogModels>;
  /**
   * Mints a consent-center preview URL for the calling user's workspace
   * (CEP-877). The token has no recipient identity; the consent-center
   * service renders against real workspace topics + brand_settings only.
   * Used by the in-product Settings → Consent → Preview pane. cepBrandId
   * previews that CEP brand; omitted, the page renders the earliest brand.
   */
  cepConsentCenterPreviewUrl: Scalars['String'];
  /**
   * Mints a hosted-preference-page URL for a Hightouch user with the
   * can_update_cep_consent grant to edit a specific profile's consent
   * (profile explorer "Manage subscriptions"). The link is recipient-scoped,
   * attributed to the calling user, and short-lived. Requires
   * can_update_cep_consent on the workspace.
   */
  cepConsentManagementUrl: CepConsentManagementUrlResult;
  /**
   * The HTML to save as a content block from the sections of an email marked with data-ht-component-anchor. Takes the
   * whole email and returns those sections with its CSS inlined, led by its font links and remaining rules.
   */
  cepContentBlockHtmlFromSection: Scalars['String'];
  /**
   * Defaults the FE uses to seed SMS link tracking config on new channels.
   * The default tracking domain is sourced from the API pod's
   * CEP_LINK_REDIRECT_BASE_URL env var so the FE doesn't need to hardcode
   * the regional hostname pattern.
   */
  cepLinkTrackingDefaults: CepLinkTrackingDefaults;
  /**
   * Errors when localization is not enabled for the message — resolve
   * enablement from the settings row before asking, as the Localize tab does.
   */
  cepLocalizationStatus: CepLocalizationStatus;
  /** Poll a reachability computation started by startCepReachabilityComputation. */
  cepReachabilityResult: CepReachabilityResult;
  /** The phone numbers on a Twilio account, read with credentials that aren't saved yet. */
  cepTwilioPhoneNumbers: Array<CepTwilioPhoneNumber>;
  /**
   * Variables the message's published content uses that no parent-model column
   * supplies. Each one blocks activating a campaign that is not API-triggered.
   */
  cepUnresolvedTemplateVariables: Array<Scalars['String']>;
  /**
   * Returns the @font-face families declared by a customer-supplied CSS URL.
   * Fetched server-side to avoid the browser CORS that blocks most font CDNs.
   * Used by Settings → Brand guidelines → Fonts.
   */
  cepValidateFontCss: CepValidateFontCssResult;
  /**
   * Where Meta's review of a live WhatsApp campaign's draft stands, across the
   * locales publishing checks. Null when the message has no draft on a copy of
   * its template.
   */
  cepWhatsAppDraftReview?: Maybe<CepWhatsAppDraftReview>;
  /**
   * WhatsApp account status per provider, for the Sending platforms table.
   * Refreshes from Meta on a stale read, so treat it as a poll target.
   */
  cepWhatsAppProviderStatuses: Array<CepWhatsAppProviderStatus>;
  /**
   * Every WhatsApp sender in the workspace, refreshed from Twilio and Meta when
   * the stored set is stale. Writes on a stale read, so treat it as a poll
   * target.
   */
  cepWhatsAppSenders: CepWhatsAppSendersResult;
  /**
   * An existing template on the same WhatsApp account whose body and footer
   * match this one's, which Meta rejects a submission for. Null when there is
   * none, or when this template has nothing left to submit.
   */
  cepWhatsAppTemplateDuplicate?: Maybe<CepWhatsAppTemplateDuplicate>;
  /**
   * Each selected locale of a localized WhatsApp template with the content Meta
   * would review for it, the default locale first. Empty unless the template's
   * localization is enabled.
   */
  cepWhatsAppTemplateLocales: Array<CepWhatsAppTemplateLocale>;
  /** fetch data from the table: "cep_brand_settings" */
  cep_brand_settings: Array<CepBrandSettings>;
  /** fetch aggregated fields from the table: "cep_brand_settings" */
  cep_brand_settings_aggregate: CepBrandSettingsAggregate;
  /** fetch data from the table: "cep_brand_settings" using primary key columns */
  cep_brand_settings_by_pk?: Maybe<CepBrandSettings>;
  /** fetch data from the table: "cep_channels" */
  cep_channels: Array<CepChannels>;
  /** fetch aggregated fields from the table: "cep_channels" */
  cep_channels_aggregate: CepChannelsAggregate;
  /** fetch data from the table: "cep_channels" using primary key columns */
  cep_channels_by_pk?: Maybe<CepChannels>;
  /** fetch data from the table: "cep_content_block_message_usages" */
  cep_content_block_message_usages: Array<CepContentBlockMessageUsages>;
  /** fetch aggregated fields from the table: "cep_content_block_message_usages" */
  cep_content_block_message_usages_aggregate: CepContentBlockMessageUsagesAggregate;
  /** fetch data from the table: "cep_content_block_message_usages" using primary key columns */
  cep_content_block_message_usages_by_pk?: Maybe<CepContentBlockMessageUsages>;
  /** fetch data from the table: "cep_content_blocks" */
  cep_content_blocks: Array<CepContentBlocks>;
  /** fetch aggregated fields from the table: "cep_content_blocks" */
  cep_content_blocks_aggregate: CepContentBlocksAggregate;
  /** fetch data from the table: "cep_content_blocks" using primary key columns */
  cep_content_blocks_by_pk?: Maybe<CepContentBlocks>;
  /** fetch data from the table: "cep_device_previews" */
  cep_device_previews: Array<CepDevicePreviews>;
  /** fetch aggregated fields from the table: "cep_device_previews" */
  cep_device_previews_aggregate: CepDevicePreviewsAggregate;
  /** fetch data from the table: "cep_device_previews" using primary key columns */
  cep_device_previews_by_pk?: Maybe<CepDevicePreviews>;
  /** An array relationship */
  cep_domains: Array<CepDomains>;
  /** An aggregate relationship */
  cep_domains_aggregate: CepDomainsAggregate;
  /** fetch data from the table: "cep_domains" using primary key columns */
  cep_domains_by_pk?: Maybe<CepDomains>;
  /** An array relationship */
  cep_email_template_contents: Array<CepEmailTemplateContents>;
  /** An aggregate relationship */
  cep_email_template_contents_aggregate: CepEmailTemplateContentsAggregate;
  /** fetch data from the table: "cep_email_template_contents" using primary key columns */
  cep_email_template_contents_by_pk?: Maybe<CepEmailTemplateContents>;
  /** fetch data from the table: "cep_email_templates" */
  cep_email_templates: Array<CepEmailTemplates>;
  /** fetch aggregated fields from the table: "cep_email_templates" */
  cep_email_templates_aggregate: CepEmailTemplatesAggregate;
  /** fetch data from the table: "cep_email_templates" using primary key columns */
  cep_email_templates_by_pk?: Maybe<CepEmailTemplates>;
  /** fetch data from the table: "cep_inapp_message_contents" */
  cep_inapp_message_contents: Array<CepInappMessageContents>;
  /** fetch aggregated fields from the table: "cep_inapp_message_contents" */
  cep_inapp_message_contents_aggregate: CepInappMessageContentsAggregate;
  /** fetch data from the table: "cep_inapp_message_contents" using primary key columns */
  cep_inapp_message_contents_by_pk?: Maybe<CepInappMessageContents>;
  /** fetch data from the table: "cep_inapp_message_template_push_apps" */
  cep_inapp_message_template_push_apps: Array<CepInappMessageTemplatePushApps>;
  /** fetch data from the table: "cep_inapp_message_template_push_apps" using primary key columns */
  cep_inapp_message_template_push_apps_by_pk?: Maybe<CepInappMessageTemplatePushApps>;
  /** fetch data from the table: "cep_inapp_message_templates" */
  cep_inapp_message_templates: Array<CepInappMessageTemplates>;
  /** fetch aggregated fields from the table: "cep_inapp_message_templates" */
  cep_inapp_message_templates_aggregate: CepInappMessageTemplatesAggregate;
  /** fetch data from the table: "cep_inapp_message_templates" using primary key columns */
  cep_inapp_message_templates_by_pk?: Maybe<CepInappMessageTemplates>;
  /** fetch data from the table: "cep_locales" */
  cep_locales: Array<CepLocales>;
  /** fetch aggregated fields from the table: "cep_locales" */
  cep_locales_aggregate: CepLocalesAggregate;
  /** fetch data from the table: "cep_locales" using primary key columns */
  cep_locales_by_pk?: Maybe<CepLocales>;
  /** fetch data from the table: "cep_localization_settings" */
  cep_localization_settings: Array<CepLocalizationSettings>;
  /** fetch aggregated fields from the table: "cep_localization_settings" */
  cep_localization_settings_aggregate: CepLocalizationSettingsAggregate;
  /** fetch data from the table: "cep_localization_settings" using primary key columns */
  cep_localization_settings_by_pk?: Maybe<CepLocalizationSettings>;
  /** fetch data from the table: "cep_managed_models" */
  cep_managed_models: Array<CepManagedModels>;
  /** fetch data from the table: "cep_managed_models" using primary key columns */
  cep_managed_models_by_pk?: Maybe<CepManagedModels>;
  /** fetch data from the table: "cep_message_device_previews" */
  cep_message_device_previews: Array<CepMessageDevicePreviews>;
  /** fetch aggregated fields from the table: "cep_message_device_previews" */
  cep_message_device_previews_aggregate: CepMessageDevicePreviewsAggregate;
  /** fetch data from the table: "cep_message_device_previews" using primary key columns */
  cep_message_device_previews_by_pk?: Maybe<CepMessageDevicePreviews>;
  /** An array relationship */
  cep_providers: Array<CepProviders>;
  /** An aggregate relationship */
  cep_providers_aggregate: CepProvidersAggregate;
  /** fetch data from the table: "cep_providers" using primary key columns */
  cep_providers_by_pk?: Maybe<CepProviders>;
  /** An array relationship */
  cep_sender_identities: Array<CepSenderIdentities>;
  /** An aggregate relationship */
  cep_sender_identities_aggregate: CepSenderIdentitiesAggregate;
  /** fetch data from the table: "cep_sender_identities" using primary key columns */
  cep_sender_identities_by_pk?: Maybe<CepSenderIdentities>;
  /** fetch data from the table: "cep_sender_identity_senders" */
  cep_sender_identity_senders: Array<CepSenderIdentitySenders>;
  /** fetch aggregated fields from the table: "cep_sender_identity_senders" */
  cep_sender_identity_senders_aggregate: CepSenderIdentitySendersAggregate;
  /** fetch data from the table: "cep_sender_identity_senders" using primary key columns */
  cep_sender_identity_senders_by_pk?: Maybe<CepSenderIdentitySenders>;
  /** An array relationship */
  cep_subscription_topic_sender_identities: Array<CepSubscriptionTopicSenderIdentities>;
  /** An aggregate relationship */
  cep_subscription_topic_sender_identities_aggregate: CepSubscriptionTopicSenderIdentitiesAggregate;
  /** fetch data from the table: "cep_subscription_topic_sender_identities" using primary key columns */
  cep_subscription_topic_sender_identities_by_pk?: Maybe<CepSubscriptionTopicSenderIdentities>;
  /** An array relationship */
  cep_subscription_topics: Array<CepSubscriptionTopics>;
  /** An aggregate relationship */
  cep_subscription_topics_aggregate: CepSubscriptionTopicsAggregate;
  /** fetch data from the table: "cep_subscription_topics" using primary key columns */
  cep_subscription_topics_by_pk?: Maybe<CepSubscriptionTopics>;
  /** An array relationship */
  cep_suppression_list_subscription_topics: Array<CepSuppressionListSubscriptionTopics>;
  /** An aggregate relationship */
  cep_suppression_list_subscription_topics_aggregate: CepSuppressionListSubscriptionTopicsAggregate;
  /** fetch data from the table: "cep_suppression_list_subscription_topics" using primary key columns */
  cep_suppression_list_subscription_topics_by_pk?: Maybe<CepSuppressionListSubscriptionTopics>;
  /** fetch data from the table: "cep_suppression_lists" */
  cep_suppression_lists: Array<CepSuppressionLists>;
  /** fetch aggregated fields from the table: "cep_suppression_lists" */
  cep_suppression_lists_aggregate: CepSuppressionListsAggregate;
  /** fetch data from the table: "cep_suppression_lists" using primary key columns */
  cep_suppression_lists_by_pk?: Maybe<CepSuppressionLists>;
  /** fetch data from the table: "cep_test_group_members" */
  cep_test_group_members: Array<CepTestGroupMembers>;
  /** fetch aggregated fields from the table: "cep_test_group_members" */
  cep_test_group_members_aggregate: CepTestGroupMembersAggregate;
  /** fetch data from the table: "cep_test_group_members" using primary key columns */
  cep_test_group_members_by_pk?: Maybe<CepTestGroupMembers>;
  /** fetch data from the table: "cep_test_groups" */
  cep_test_groups: Array<CepTestGroups>;
  /** fetch aggregated fields from the table: "cep_test_groups" */
  cep_test_groups_aggregate: CepTestGroupsAggregate;
  /** fetch data from the table: "cep_test_groups" using primary key columns */
  cep_test_groups_by_pk?: Maybe<CepTestGroups>;
  /** fetch data from the table: "cep_translations" */
  cep_translations: Array<CepTranslations>;
  /** fetch data from the table: "cep_translations" using primary key columns */
  cep_translations_by_pk?: Maybe<CepTranslations>;
  /** An array relationship */
  cep_whatsapp_template_locales: Array<CepWhatsappTemplateLocales>;
  /** An aggregate relationship */
  cep_whatsapp_template_locales_aggregate: CepWhatsappTemplateLocalesAggregate;
  /** fetch data from the table: "cep_whatsapp_template_locales" using primary key columns */
  cep_whatsapp_template_locales_by_pk?: Maybe<CepWhatsappTemplateLocales>;
  /** fetch data from the table: "cep_whatsapp_templates" */
  cep_whatsapp_templates: Array<CepWhatsappTemplates>;
  /** fetch aggregated fields from the table: "cep_whatsapp_templates" */
  cep_whatsapp_templates_aggregate: CepWhatsappTemplatesAggregate;
  /** fetch data from the table: "cep_whatsapp_templates" using primary key columns */
  cep_whatsapp_templates_by_pk?: Maybe<CepWhatsappTemplates>;
  /** fetch data from the table: "cep_workspace_config" */
  cep_workspace_config: Array<CepWorkspaceConfig>;
  /** fetch aggregated fields from the table: "cep_workspace_config" */
  cep_workspace_config_aggregate: CepWorkspaceConfigAggregate;
  /** fetch data from the table: "cep_workspace_config" using primary key columns */
  cep_workspace_config_by_pk?: Maybe<CepWorkspaceConfig>;
  /** fetch data from the table: "cep_workspace_parent_models" */
  cep_workspace_parent_models: Array<CepWorkspaceParentModels>;
  /** fetch aggregated fields from the table: "cep_workspace_parent_models" */
  cep_workspace_parent_models_aggregate: CepWorkspaceParentModelsAggregate;
  /** fetch data from the table: "cep_workspace_parent_models" using primary key columns */
  cep_workspace_parent_models_by_pk?: Maybe<CepWorkspaceParentModels>;
  /** An array relationship */
  chart_cards: Array<ChartCards>;
  /** fetch data from the table: "chart_cards" using primary key columns */
  chart_cards_by_pk?: Maybe<ChartCards>;
  checkDebuggerExport?: Maybe<DebuggerExportStatus>;
  checkDestinationPermissions: Array<DestinationPermissionResult>;
  checkFacebookTokenPermissions: CheckFacebookTokenPermissionsResponse;
  checkReportVersionReferences: ReportVersionReferenceCheck;
  checkTunnel: CheckTunnelResult;
  clientSuccessDescribeObject: ClientSuccessDescribeObjectResult;
  /** fetch data from the table: "cloud_credentials" */
  cloud_credentials: Array<CloudCredentials>;
  /** fetch data from the table: "cloud_credentials" using primary key columns */
  cloud_credentials_by_pk?: Maybe<CloudCredentials>;
  commonFilterSuggestions: CommonFilterSuggestionsResult;
  /** Ads across a competitor's connected accounts, optionally limited to some channels. */
  competitorAdsForCompetitor: CompetitorAdsResult;
  /** An array relationship */
  competitor_accounts: Array<CompetitorAccounts>;
  /** An aggregate relationship */
  competitor_accounts_aggregate: CompetitorAccountsAggregate;
  /** fetch data from the table: "competitor_accounts" using primary key columns */
  competitor_accounts_by_pk?: Maybe<CompetitorAccounts>;
  /** fetch data from the table: "competitor_ad_scrapes" */
  competitor_ad_scrapes: Array<CompetitorAdScrapes>;
  /** fetch data from the table: "competitor_ad_scrapes" using primary key columns */
  competitor_ad_scrapes_by_pk?: Maybe<CompetitorAdScrapes>;
  /** fetch data from the table: "competitors" */
  competitors: Array<Competitors>;
  /** fetch aggregated fields from the table: "competitors" */
  competitors_aggregate: CompetitorsAggregate;
  /** fetch data from the table: "competitors" using primary key columns */
  competitors_by_pk?: Maybe<Competitors>;
  compileContentArtifactDynamicContent: CompileContentArtifactDynamicContentResponse;
  compileContentEmailDynamicContent: CompileContentEmailDynamicContentResponse;
  computeSendInsightCharts: Scalars['JSONObject'];
  /** An array relationship */
  condition_template_labels: Array<ConditionTemplateLabels>;
  /** An aggregate relationship */
  condition_template_labels_aggregate: ConditionTemplateLabelsAggregate;
  /** fetch data from the table: "condition_template_labels" using primary key columns */
  condition_template_labels_by_pk?: Maybe<ConditionTemplateLabels>;
  connectionRoleCacheStatus?: Maybe<ConnectionRoleCacheStatus>;
  connectionRoleMappings: Array<ConnectionRoleMapping>;
  connectionRoleSettings?: Maybe<ConnectionRoleSettings>;
  connectionRoles: Array<ConnectionRole>;
  /** An array relationship */
  connections: Array<Connections>;
  /** An aggregate relationship */
  connections_aggregate: ConnectionsAggregate;
  /** fetch data from the table: "connections" using primary key columns */
  connections_by_pk?: Maybe<Connections>;
  contentArtifactDynamicSlots: Array<ContentArtifactDynamicSlot>;
  contentEmailDynamicSlots: Array<ContentEmailDynamicSlot>;
  contentImageSearchV2Result?: Maybe<ContentImageSearchResultResponse>;
  /** An array relationship */
  content_block_labels: Array<ContentBlockLabels>;
  /** An aggregate relationship */
  content_block_labels_aggregate: ContentBlockLabelsAggregate;
  /** fetch data from the table: "content_block_labels" using primary key columns */
  content_block_labels_by_pk?: Maybe<ContentBlockLabels>;
  /** fetch data from the table: "content_blocks" */
  content_blocks: Array<ContentBlocks>;
  /** fetch aggregated fields from the table: "content_blocks" */
  content_blocks_aggregate: ContentBlocksAggregate;
  /** fetch data from the table: "content_blocks" using primary key columns */
  content_blocks_by_pk?: Maybe<ContentBlocks>;
  /** fetch data from the table: "content_deployments" */
  content_deployments: Array<ContentDeployments>;
  /** fetch aggregated fields from the table: "content_deployments" */
  content_deployments_aggregate: ContentDeploymentsAggregate;
  /** fetch data from the table: "content_deployments" using primary key columns */
  content_deployments_by_pk?: Maybe<ContentDeployments>;
  /** fetch data from the table: "content_dynamic_slot_assignments" */
  content_dynamic_slot_assignments: Array<ContentDynamicSlotAssignments>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_assignments" */
  content_dynamic_slot_assignments_aggregate: ContentDynamicSlotAssignmentsAggregate;
  /** fetch data from the table: "content_dynamic_slot_assignments" using primary key columns */
  content_dynamic_slot_assignments_by_pk?: Maybe<ContentDynamicSlotAssignments>;
  /** fetch data from the table: "content_dynamic_slot_branches" */
  content_dynamic_slot_branches: Array<ContentDynamicSlotBranches>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_branches" */
  content_dynamic_slot_branches_aggregate: ContentDynamicSlotBranchesAggregate;
  /** fetch data from the table: "content_dynamic_slot_branches" using primary key columns */
  content_dynamic_slot_branches_by_pk?: Maybe<ContentDynamicSlotBranches>;
  /** fetch data from the table: "content_dynamic_slot_contents" */
  content_dynamic_slot_contents: Array<ContentDynamicSlotContents>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_contents" */
  content_dynamic_slot_contents_aggregate: ContentDynamicSlotContentsAggregate;
  /** fetch data from the table: "content_dynamic_slot_contents" using primary key columns */
  content_dynamic_slot_contents_by_pk?: Maybe<ContentDynamicSlotContents>;
  /** fetch data from the table: "content_dynamic_slot_libraries" */
  content_dynamic_slot_libraries: Array<ContentDynamicSlotLibraries>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_libraries" */
  content_dynamic_slot_libraries_aggregate: ContentDynamicSlotLibrariesAggregate;
  /** fetch data from the table: "content_dynamic_slot_libraries" using primary key columns */
  content_dynamic_slot_libraries_by_pk?: Maybe<ContentDynamicSlotLibraries>;
  /** An array relationship */
  content_dynamic_slot_usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  content_dynamic_slot_usages_aggregate: ContentDynamicSlotUsagesAggregate;
  /** fetch data from the table: "content_dynamic_slot_usages" using primary key columns */
  content_dynamic_slot_usages_by_pk?: Maybe<ContentDynamicSlotUsages>;
  /** An array relationship */
  content_email_message_links: Array<ContentEmailMessageLinks>;
  /** An aggregate relationship */
  content_email_message_links_aggregate: ContentEmailMessageLinksAggregate;
  /** fetch data from the table: "content_email_message_links" using primary key columns */
  content_email_message_links_by_pk?: Maybe<ContentEmailMessageLinks>;
  /** An array relationship */
  content_email_variants: Array<ContentEmailVariants>;
  /** An aggregate relationship */
  content_email_variants_aggregate: ContentEmailVariantsAggregate;
  /** fetch data from the table: "content_email_variants" using primary key columns */
  content_email_variants_by_pk?: Maybe<ContentEmailVariants>;
  /** An array relationship */
  content_email_versions: Array<ContentEmailVersions>;
  /** An aggregate relationship */
  content_email_versions_aggregate: ContentEmailVersionsAggregate;
  /** fetch data from the table: "content_email_versions" using primary key columns */
  content_email_versions_by_pk?: Maybe<ContentEmailVersions>;
  /** An array relationship */
  content_emails: Array<ContentEmails>;
  /** An aggregate relationship */
  content_emails_aggregate: ContentEmailsAggregate;
  /** fetch data from the table: "content_emails" using primary key columns */
  content_emails_by_pk?: Maybe<ContentEmails>;
  /** fetch data from the table: "content_settings" */
  content_settings: Array<ContentSettings>;
  /** fetch aggregated fields from the table: "content_settings" */
  content_settings_aggregate: ContentSettingsAggregate;
  /** fetch data from the table: "content_settings" using primary key columns */
  content_settings_by_pk?: Maybe<ContentSettings>;
  /** fetch data from the table: "content_tags" */
  content_tags: Array<ContentTags>;
  /** fetch aggregated fields from the table: "content_tags" */
  content_tags_aggregate: ContentTagsAggregate;
  /** fetch data from the table: "content_tags" using primary key columns */
  content_tags_by_pk?: Maybe<ContentTags>;
  /** fetch data from the table: "content_templates" */
  content_templates: Array<ContentTemplates>;
  /** fetch aggregated fields from the table: "content_templates" */
  content_templates_aggregate: ContentTemplatesAggregate;
  /** fetch data from the table: "content_templates" using primary key columns */
  content_templates_by_pk?: Maybe<ContentTemplates>;
  copyReferencesIngestionRuns: Array<CopyReferencesIngestionRun>;
  /** fetch data from the table: "current_report_schedule_versions" */
  current_report_schedule_versions: Array<CurrentReportScheduleVersions>;
  customListFields: CustomDestinationListFieldsResult;
  customListModes: CustomDestinationListModesResult;
  customListObjects: CustomDestinationListObjectsResult;
  customListOptions: CustomDestinationListOptionsResult;
  customQueryBackground: BackgroundJobResult;
  customValidateConfiguration: CustomDestinationValidateConfigurationResult;
  /** fetch data from the table: "custom_agents" */
  custom_agents: Array<CustomAgents>;
  /** fetch data from the table: "custom_agents" using primary key columns */
  custom_agents_by_pk?: Maybe<CustomAgents>;
  dashboardSyncAttemptsV2?: Maybe<Array<SyncAttemptMetric>>;
  dashboardSyncRequestIds?: Maybe<DashboardSyncRequestIds>;
  dashboardSyncRequestsV2?: Maybe<Array<SyncRequestMetricV2>>;
  /** fetch data from the table: "dashboards" */
  dashboards: Array<Dashboards>;
  /** fetch aggregated fields from the table: "dashboards" */
  dashboards_aggregate: DashboardsAggregate;
  /** fetch data from the table: "dashboards" using primary key columns */
  dashboards_by_pk?: Maybe<Dashboards>;
  /** fetch data from the table: "datadog_credentials" */
  datadog_credentials: Array<DatadogCredentials>;
  /** fetch data from the table: "datadog_credentials" using primary key columns */
  datadog_credentials_by_pk?: Maybe<DatadogCredentials>;
  dbtModelQueryBackground: BackgroundJobResult;
  dbtQueryBackground: BackgroundJobResult;
  /** fetch data from the table: "dbt_cloud_sync_config" */
  dbt_cloud_sync_config: Array<DbtCloudSyncConfig>;
  /** fetch data from the table: "dbt_cloud_sync_config" using primary key columns */
  dbt_cloud_sync_config_by_pk?: Maybe<DbtCloudSyncConfig>;
  /** fetch data from the table: "dbt_cloud_webhooks" */
  dbt_cloud_webhooks: Array<DbtCloudWebhooks>;
  /** fetch data from the table: "dbt_cloud_webhooks" using primary key columns */
  dbt_cloud_webhooks_by_pk?: Maybe<DbtCloudWebhooks>;
  /** fetch data from the table: "dbt_credentials" */
  dbt_credentials: Array<DbtCredentials>;
  /** fetch data from the table: "dbt_credentials" using primary key columns */
  dbt_credentials_by_pk?: Maybe<DbtCredentials>;
  /** fetch data from the table: "dbt_sync_config" */
  dbt_sync_config: Array<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_config" using primary key columns */
  dbt_sync_config_by_pk?: Maybe<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_models" */
  dbt_sync_models: Array<DbtSyncModels>;
  /** fetch data from the table: "dbt_sync_models" using primary key columns */
  dbt_sync_models_by_pk?: Maybe<DbtSyncModels>;
  /**
   * Hightouch staff only. Raw Graph API reads (status + Meta error body) for
   * every path that could surface a Facebook Page for the destination's token
   * user and the given ad account.
   */
  debugMetaPageAccess: DebugMetaPageAccessResponse;
  debugSendMatching: DebugSendMatchingResult;
  decisionEngineArbitrationGroupModeStatus: DecisionEngineArbitrationModeStatus;
  decisionEngineFlowVolumeRampState: DecisionEngineFlowVolumeRampState;
  decisionEngineQueryBackground: BackgroundJobResult;
  /** fetch data from the table: "decision_engine_arbitration_group_memberships" */
  decision_engine_arbitration_group_memberships: Array<DecisionEngineArbitrationGroupMemberships>;
  /** fetch aggregated fields from the table: "decision_engine_arbitration_group_memberships" */
  decision_engine_arbitration_group_memberships_aggregate: DecisionEngineArbitrationGroupMembershipsAggregate;
  /** fetch data from the table: "decision_engine_arbitration_group_memberships" using primary key columns */
  decision_engine_arbitration_group_memberships_by_pk?: Maybe<DecisionEngineArbitrationGroupMemberships>;
  /** fetch data from the table: "decision_engine_arbitration_groups" */
  decision_engine_arbitration_groups: Array<DecisionEngineArbitrationGroups>;
  /** fetch aggregated fields from the table: "decision_engine_arbitration_groups" */
  decision_engine_arbitration_groups_aggregate: DecisionEngineArbitrationGroupsAggregate;
  /** fetch data from the table: "decision_engine_arbitration_groups" using primary key columns */
  decision_engine_arbitration_groups_by_pk?: Maybe<DecisionEngineArbitrationGroups>;
  /** fetch data from the table: "decision_engine_channels" */
  decision_engine_channels: Array<DecisionEngineChannels>;
  /** fetch data from the table: "decision_engine_channels" using primary key columns */
  decision_engine_channels_by_pk?: Maybe<DecisionEngineChannels>;
  /** fetch data from the table: "decision_engine_collections" */
  decision_engine_collections: Array<DecisionEngineCollections>;
  /** fetch data from the table: "decision_engine_collections" using primary key columns */
  decision_engine_collections_by_pk?: Maybe<DecisionEngineCollections>;
  /** fetch data from the table: "decision_engine_content_recommendations" */
  decision_engine_content_recommendations: Array<DecisionEngineContentRecommendations>;
  /** fetch aggregated fields from the table: "decision_engine_content_recommendations" */
  decision_engine_content_recommendations_aggregate: DecisionEngineContentRecommendationsAggregate;
  /** fetch data from the table: "decision_engine_content_recommendations" using primary key columns */
  decision_engine_content_recommendations_by_pk?: Maybe<DecisionEngineContentRecommendations>;
  /** fetch data from the table: "decision_engine_feature_matrices" */
  decision_engine_feature_matrices: Array<DecisionEngineFeatureMatrices>;
  /** fetch data from the table: "decision_engine_feature_matrices" using primary key columns */
  decision_engine_feature_matrices_by_pk?: Maybe<DecisionEngineFeatureMatrices>;
  /** fetch data from the table: "decision_engine_feature_matrix_relationships" */
  decision_engine_feature_matrix_relationships: Array<DecisionEngineFeatureMatrixRelationships>;
  /** fetch data from the table: "decision_engine_feature_matrix_relationships" using primary key columns */
  decision_engine_feature_matrix_relationships_by_pk?: Maybe<DecisionEngineFeatureMatrixRelationships>;
  /** fetch data from the table: "decision_engine_flow_channel_sync" */
  decision_engine_flow_channel_sync: Array<DecisionEngineFlowChannelSync>;
  /** fetch data from the table: "decision_engine_flow_channel_sync" using primary key columns */
  decision_engine_flow_channel_sync_by_pk?: Maybe<DecisionEngineFlowChannelSync>;
  /** fetch data from the table: "decision_engine_flow_charts" */
  decision_engine_flow_charts: Array<DecisionEngineFlowCharts>;
  /** fetch data from the table: "decision_engine_flow_charts" using primary key columns */
  decision_engine_flow_charts_by_pk?: Maybe<DecisionEngineFlowCharts>;
  /** fetch data from the table: "decision_engine_flow_experiments" */
  decision_engine_flow_experiments: Array<DecisionEngineFlowExperiments>;
  /** fetch data from the table: "decision_engine_flow_experiments" using primary key columns */
  decision_engine_flow_experiments_by_pk?: Maybe<DecisionEngineFlowExperiments>;
  /** fetch data from the table: "decision_engine_flow_messages" */
  decision_engine_flow_messages: Array<DecisionEngineFlowMessages>;
  /** fetch data from the table: "decision_engine_flow_messages" using primary key columns */
  decision_engine_flow_messages_by_pk?: Maybe<DecisionEngineFlowMessages>;
  /** fetch data from the table: "decision_engine_flow_outcomes" */
  decision_engine_flow_outcomes: Array<DecisionEngineFlowOutcomes>;
  /** fetch data from the table: "decision_engine_flow_outcomes" using primary key columns */
  decision_engine_flow_outcomes_by_pk?: Maybe<DecisionEngineFlowOutcomes>;
  /** fetch data from the table: "decision_engine_flow_override_periods" */
  decision_engine_flow_override_periods: Array<DecisionEngineFlowOverridePeriods>;
  /** fetch data from the table: "decision_engine_flow_override_periods" using primary key columns */
  decision_engine_flow_override_periods_by_pk?: Maybe<DecisionEngineFlowOverridePeriods>;
  /** fetch data from the table: "decision_engine_flow_runs" */
  decision_engine_flow_runs: Array<DecisionEngineFlowRuns>;
  /** fetch aggregated fields from the table: "decision_engine_flow_runs" */
  decision_engine_flow_runs_aggregate: DecisionEngineFlowRunsAggregate;
  /** fetch data from the table: "decision_engine_flow_runs" using primary key columns */
  decision_engine_flow_runs_by_pk?: Maybe<DecisionEngineFlowRuns>;
  /** fetch data from the table: "decision_engine_flow_tags" */
  decision_engine_flow_tags: Array<DecisionEngineFlowTags>;
  /** fetch data from the table: "decision_engine_flow_tags" using primary key columns */
  decision_engine_flow_tags_by_pk?: Maybe<DecisionEngineFlowTags>;
  /** fetch data from the table: "decision_engine_flow_volume_ramps" */
  decision_engine_flow_volume_ramps: Array<DecisionEngineFlowVolumeRamps>;
  /** fetch data from the table: "decision_engine_flow_volume_ramps" using primary key columns */
  decision_engine_flow_volume_ramps_by_pk?: Maybe<DecisionEngineFlowVolumeRamps>;
  /** fetch data from the table: "decision_engine_flows" */
  decision_engine_flows: Array<DecisionEngineFlows>;
  /** fetch data from the table: "decision_engine_flows" using primary key columns */
  decision_engine_flows_by_pk?: Maybe<DecisionEngineFlows>;
  /** fetch data from the table: "decision_engine_interaction_manifests" */
  decision_engine_interaction_manifests: Array<DecisionEngineInteractionManifests>;
  /** fetch data from the table: "decision_engine_interaction_manifests" using primary key columns */
  decision_engine_interaction_manifests_by_pk?: Maybe<DecisionEngineInteractionManifests>;
  /** fetch data from the table: "decision_engine_message_collections" */
  decision_engine_message_collections: Array<DecisionEngineMessageCollections>;
  /** fetch data from the table: "decision_engine_message_collections" using primary key columns */
  decision_engine_message_collections_by_pk?: Maybe<DecisionEngineMessageCollections>;
  /** fetch data from the table: "decision_engine_message_variant_suggestions" */
  decision_engine_message_variant_suggestions: Array<DecisionEngineMessageVariantSuggestions>;
  /** fetch data from the table: "decision_engine_message_variant_suggestions" using primary key columns */
  decision_engine_message_variant_suggestions_by_pk?: Maybe<DecisionEngineMessageVariantSuggestions>;
  /** fetch data from the table: "decision_engine_messages" */
  decision_engine_messages: Array<DecisionEngineMessages>;
  /** fetch aggregated fields from the table: "decision_engine_messages" */
  decision_engine_messages_aggregate: DecisionEngineMessagesAggregate;
  /** fetch data from the table: "decision_engine_messages" using primary key columns */
  decision_engine_messages_by_pk?: Maybe<DecisionEngineMessages>;
  /** fetch data from the table: "decision_engine_model_outcomes" */
  decision_engine_model_outcomes: Array<DecisionEngineModelOutcomes>;
  /** fetch data from the table: "decision_engine_model_outcomes" using primary key columns */
  decision_engine_model_outcomes_by_pk?: Maybe<DecisionEngineModelOutcomes>;
  /** fetch data from the table: "decision_engine_models" */
  decision_engine_models: Array<DecisionEngineModels>;
  /** fetch data from the table: "decision_engine_models" using primary key columns */
  decision_engine_models_by_pk?: Maybe<DecisionEngineModels>;
  /** fetch data from the table: "decision_engine_offers" */
  decision_engine_offers: Array<DecisionEngineOffers>;
  /** fetch data from the table: "decision_engine_offers" using primary key columns */
  decision_engine_offers_by_pk?: Maybe<DecisionEngineOffers>;
  /** fetch data from the table: "decision_engine_outcomes" */
  decision_engine_outcomes: Array<DecisionEngineOutcomes>;
  /** fetch data from the table: "decision_engine_outcomes" using primary key columns */
  decision_engine_outcomes_by_pk?: Maybe<DecisionEngineOutcomes>;
  /** fetch data from the table: "decision_engine_send_events" */
  decision_engine_send_events: Array<DecisionEngineSendEvents>;
  /** fetch data from the table: "decision_engine_send_events" using primary key columns */
  decision_engine_send_events_by_pk?: Maybe<DecisionEngineSendEvents>;
  /** fetch data from the table: "decision_engine_splits" */
  decision_engine_splits: Array<DecisionEngineSplits>;
  /** fetch data from the table: "decision_engine_splits" using primary key columns */
  decision_engine_splits_by_pk?: Maybe<DecisionEngineSplits>;
  /** fetch data from the table: "decision_engines" */
  decision_engines: Array<DecisionEngines>;
  /** fetch data from the table: "decision_engines" using primary key columns */
  decision_engines_by_pk?: Maybe<DecisionEngines>;
  /** Which of the workspace's sending domains the connected Google account can read in Postmaster Tools, checked with Google now. Empty when the feed isn't connected. */
  deliverabilityFeedDomainAccess: Array<DeliverabilityFeedDomainAccess>;
  /** fetch data from the table: "deliverability_feeds" */
  deliverability_feeds: Array<DeliverabilityFeeds>;
  /** fetch aggregated fields from the table: "deliverability_feeds" */
  deliverability_feeds_aggregate: DeliverabilityFeedsAggregate;
  /** fetch data from the table: "deliverability_feeds" using primary key columns */
  deliverability_feeds_by_pk?: Maybe<DeliverabilityFeeds>;
  demoInsightsRun?: Maybe<DemoInsightsRun>;
  /** fetch data from the table: "deployment_history" */
  deployment_history: Array<DeploymentHistory>;
  /** fetch data from the table: "deployment_history" using primary key columns */
  deployment_history_by_pk?: Maybe<DeploymentHistory>;
  describeSemanticView: SemanticViewDefinition;
  destinationCanActionGrants: CanActionGrants;
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  /** fetch data from the table: "destination_instance_splits" using primary key columns */
  destination_instance_splits_by_pk?: Maybe<DestinationInstanceSplits>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  /** fetch data from the table: "destination_instances" using primary key columns */
  destination_instances_by_pk?: Maybe<DestinationInstances>;
  /** An array relationship */
  destination_rules: Array<DestinationRules>;
  /** An aggregate relationship */
  destination_rules_aggregate: DestinationRulesAggregate;
  /** fetch data from the table: "destination_rules" using primary key columns */
  destination_rules_by_pk?: Maybe<DestinationRules>;
  /** An array relationship */
  destinations: Array<Destinations>;
  /** An aggregate relationship */
  destinations_aggregate: DestinationsAggregate;
  /** fetch data from the table: "destinations" using primary key columns */
  destinations_by_pk?: Maybe<Destinations>;
  detectSubsetScopedConditionCycles: DetectSubsetScopedConditionCyclesResult;
  diffRealtimeEventColumns: DiffRealtimeEventColumnsOutput;
  /** fetch data from the table: "direct_model_relationships" */
  direct_model_relationships: Array<DirectModelRelationships>;
  /** fetch data from the table: "direct_model_relationships" using primary key columns */
  direct_model_relationships_by_pk?: Maybe<DirectModelRelationships>;
  /** fetch data from the table: "draft_approval_requests" */
  draft_approval_requests: Array<DraftApprovalRequests>;
  /** fetch data from the table: "draft_approval_requests" using primary key columns */
  draft_approval_requests_by_pk?: Maybe<DraftApprovalRequests>;
  /** fetch data from the table: "drafts" */
  drafts: Array<Drafts>;
  /** fetch aggregated fields from the table: "drafts" */
  drafts_aggregate: DraftsAggregate;
  /** fetch data from the table: "drafts" using primary key columns */
  drafts_by_pk?: Maybe<Drafts>;
  ellieAdminCloudReview?: Maybe<Scalars['jsonb']>;
  ellieAdminDiagnosticMonitors: Scalars['jsonb'];
  ellieAdminEnhanceStatus: Scalars['jsonb'];
  ellieAdminInternetReconciliation: Scalars['jsonb'];
  ellieAdminInternetRequests: Scalars['jsonb'];
  ellieAdminMonitor: Scalars['jsonb'];
  ellieAdminOperationsHealth: Scalars['jsonb'];
  ellieAdminSourceKeywords: Scalars['jsonb'];
  ellieAdminSourceQueue: Scalars['jsonb'];
  ellieAdminSourceReadSchedule: Scalars['jsonb'];
  ellieAeoTactics: EllieResearchResult;
  ellieAeoTrial: EllieResearchResult;
  ellieAnswerAnalysis: EllieResearchResult;
  ellieAppstoreReviewCollections: EllieResearchResult;
  ellieBrain: EllieResearchResult;
  ellieBrainCatalog: EllieResearchResult;
  ellieBrainHistory: EllieResearchResult;
  ellieBrandSearchCollections: EllieResearchResult;
  ellieChat: EllieChat;
  ellieChats: Array<EllieChatSummary>;
  ellieConfiguration: EllieConfiguration;
  ellieIdeaExport: EllieResearchResult;
  ellieInsights: EllieResearchResult;
  ellieInternet: EllieResearchResult;
  ellieJob: EllieResearchResult;
  ellieKnowledge: EllieResearchResult;
  ellieKnowledgeObject: EllieResearchResult;
  ellieLinkedinCollections: EllieResearchResult;
  ellieLinkedinMentionCollections: EllieResearchResult;
  ellieMaintenanceReport: EllieResearchResult;
  ellieMapsReviewCollections: EllieResearchResult;
  ellieMeasurements: EllieResearchResult;
  ellieMessages: EllieResearchResult;
  ellieMonitoringSummary: EllieResearchResult;
  ellieOpportunityLoop: EllieResearchResult;
  ellieOpportunityPortfolio: EllieResearchResult;
  elliePlayReviewCollections: EllieResearchResult;
  elliePromptData: EllieResearchResult;
  elliePromptRun: EllieResearchResult;
  ellieReviewBacklog: EllieResearchResult;
  ellieReviewBacklogItem: EllieResearchResult;
  ellieSearchExcerpts: EllieResearchResult;
  ellieSource: EllieResearchResult;
  ellieSourceFailures: EllieResearchResult;
  ellieSourceInventory: EllieResearchResult;
  ellieSourceInventoryDetail: EllieResearchResult;
  ellieSourceKeywords: EllieResearchResult;
  ellieSourceVersion: EllieResearchResult;
  ellieState: EllieResearchResult;
  ellieTopics: EllieResearchResult;
  ellieUnderstandingHistory: EllieResearchResult;
  emailPngExportRun?: Maybe<EmailPngExportRun>;
  /** An array relationship */
  email_template_labels: Array<EmailTemplateLabels>;
  /** An aggregate relationship */
  email_template_labels_aggregate: EmailTemplateLabelsAggregate;
  /** fetch data from the table: "email_template_labels" using primary key columns */
  email_template_labels_by_pk?: Maybe<EmailTemplateLabels>;
  enrichmentStatus?: Maybe<EnrichmentJob>;
  entitlementCenter: EntitlementCenterView;
  /**
   * Both citation directions for each of `entityIds`, in one batched read:
   * what each entity cites, and which workspace documents cite it. Ids outside
   * the caller's workspace are absent from the result.
   */
  entityCitations: Array<EntityCitations>;
  /** fetch data from the table: "esp_catalog_state" */
  esp_catalog_state: Array<EspCatalogState>;
  /** fetch data from the table: "esp_catalog_state" using primary key columns */
  esp_catalog_state_by_pk?: Maybe<EspCatalogState>;
  /** fetch data from the table: "esp_content_blocks" */
  esp_content_blocks: Array<EspContentBlocks>;
  /** fetch aggregated fields from the table: "esp_content_blocks" */
  esp_content_blocks_aggregate: EspContentBlocksAggregate;
  /** fetch data from the table: "esp_content_blocks" using primary key columns */
  esp_content_blocks_by_pk?: Maybe<EspContentBlocks>;
  /** fetch data from the table: "esp_user_fields" */
  esp_user_fields: Array<EspUserFields>;
  /** fetch aggregated fields from the table: "esp_user_fields" */
  esp_user_fields_aggregate: EspUserFieldsAggregate;
  /** fetch data from the table: "esp_user_fields" using primary key columns */
  esp_user_fields_by_pk?: Maybe<EspUserFields>;
  /** fetch data from the table: "etl_connections" */
  etl_connections: Array<EtlConnections>;
  /** fetch aggregated fields from the table: "etl_connections" */
  etl_connections_aggregate: EtlConnectionsAggregate;
  /** fetch data from the table: "etl_connections" using primary key columns */
  etl_connections_by_pk?: Maybe<EtlConnections>;
  /** fetch data from the table: "etl_sync_runs" */
  etl_sync_runs: Array<EtlSyncRuns>;
  /** fetch data from the table: "etl_sync_runs" using primary key columns */
  etl_sync_runs_by_pk?: Maybe<EtlSyncRuns>;
  evaluateCampaignAnalyticsDashboardQuery?: Maybe<CampaignAnalyticsDashboardResult>;
  evaluateFunnelMetric: FunnelMetricResult;
  evaluateTimeSeriesMetric: TimeSeriesMetricResult;
  eventForwardingEventDefinition: Scalars['JSON'];
  eventForwardingEventValidation?: Maybe<Scalars['JSON']>;
  eventForwardingEvents: Array<EventDefintion>;
  eventForwardingHandler: Scalars['JSON'];
  eventForwardingSharedDefinition?: Maybe<Scalars['JSON']>;
  eventForwardingSharedValidation?: Maybe<Scalars['JSON']>;
  /** An array relationship */
  event_components: Array<EventComponents>;
  /** An aggregate relationship */
  event_components_aggregate: EventComponentsAggregate;
  /** fetch data from the table: "event_components" using primary key columns */
  event_components_by_pk?: Maybe<EventComponents>;
  /** An array relationship */
  event_components_conditions: Array<EventComponentsConditions>;
  /** An aggregate relationship */
  event_components_conditions_aggregate: EventComponentsConditionsAggregate;
  /** fetch data from the table: "event_components_conditions" using primary key columns */
  event_components_conditions_by_pk?: Maybe<EventComponentsConditions>;
  /** fetch data from the table: "event_components_join" */
  event_components_join: Array<EventComponentsJoin>;
  /** fetch aggregated fields from the table: "event_components_join" */
  event_components_join_aggregate: EventComponentsJoinAggregate;
  /** fetch data from the table: "event_components_join" using primary key columns */
  event_components_join_by_pk?: Maybe<EventComponentsJoin>;
  /** fetch data from the table: "event_contracts" */
  event_contracts: Array<EventContracts>;
  /** fetch data from the table: "event_contracts" using primary key columns */
  event_contracts_by_pk?: Maybe<EventContracts>;
  /** fetch data from the table: "event_contracts_schema" */
  event_contracts_schema: Array<EventContractsSchema>;
  /** fetch data from the table: "event_contracts_schema" using primary key columns */
  event_contracts_schema_by_pk?: Maybe<EventContractsSchema>;
  /** fetch data from the table: "event_forwarding_destination_grants" */
  event_forwarding_destination_grants: Array<EventForwardingDestinationGrants>;
  /** fetch aggregated fields from the table: "event_forwarding_destination_grants" */
  event_forwarding_destination_grants_aggregate: EventForwardingDestinationGrantsAggregate;
  /** fetch data from the table: "event_forwarding_destination_grants" using primary key columns */
  event_forwarding_destination_grants_by_pk?: Maybe<EventForwardingDestinationGrants>;
  /** An array relationship */
  event_forwarding_sync_sources: Array<EventForwardingSyncSources>;
  /** An aggregate relationship */
  event_forwarding_sync_sources_aggregate: EventForwardingSyncSourcesAggregate;
  /** fetch data from the table: "event_forwarding_sync_sources" using primary key columns */
  event_forwarding_sync_sources_by_pk?: Maybe<EventForwardingSyncSources>;
  /** An array relationship */
  event_forwarding_syncs: Array<EventForwardingSyncs>;
  /** fetch data from the table: "event_forwarding_syncs" using primary key columns */
  event_forwarding_syncs_by_pk?: Maybe<EventForwardingSyncs>;
  /** An array relationship */
  event_model_event_sources: Array<EventModelEventSources>;
  /** An aggregate relationship */
  event_model_event_sources_aggregate: EventModelEventSourcesAggregate;
  /** fetch data from the table: "event_model_event_sources" using primary key columns */
  event_model_event_sources_by_pk?: Maybe<EventModelEventSources>;
  /** fetch data from the table: "event_models" */
  event_models: Array<EventModels>;
  /** fetch data from the table: "event_models" using primary key columns */
  event_models_by_pk?: Maybe<EventModels>;
  /** fetch data from the table: "event_plan_grants" */
  event_plan_grants: Array<EventPlanGrants>;
  /** fetch aggregated fields from the table: "event_plan_grants" */
  event_plan_grants_aggregate: EventPlanGrantsAggregate;
  /** fetch data from the table: "event_plan_grants" using primary key columns */
  event_plan_grants_by_pk?: Maybe<EventPlanGrants>;
  /** fetch data from the table: "event_plans" */
  event_plans: Array<EventPlans>;
  /** fetch aggregated fields from the table: "event_plans" */
  event_plans_aggregate: EventPlansAggregate;
  /** fetch data from the table: "event_plans" using primary key columns */
  event_plans_by_pk?: Maybe<EventPlans>;
  /** An array relationship */
  event_schema_components: Array<EventSchemaComponents>;
  /** An aggregate relationship */
  event_schema_components_aggregate: EventSchemaComponentsAggregate;
  /** fetch data from the table: "event_schema_components" using primary key columns */
  event_schema_components_by_pk?: Maybe<EventSchemaComponents>;
  /** An array relationship */
  event_schemas: Array<EventSchemas>;
  /** An aggregate relationship */
  event_schemas_aggregate: EventSchemasAggregate;
  /** fetch data from the table: "event_schemas" using primary key columns */
  event_schemas_by_pk?: Maybe<EventSchemas>;
  /** fetch data from the table: "event_source_contracts" */
  event_source_contracts: Array<EventSourceContracts>;
  /** fetch data from the table: "event_source_contracts" using primary key columns */
  event_source_contracts_by_pk?: Maybe<EventSourceContracts>;
  /** fetch data from the table: "event_source_grants" */
  event_source_grants: Array<EventSourceGrants>;
  /** fetch aggregated fields from the table: "event_source_grants" */
  event_source_grants_aggregate: EventSourceGrantsAggregate;
  /** fetch data from the table: "event_source_grants" using primary key columns */
  event_source_grants_by_pk?: Maybe<EventSourceGrants>;
  /** fetch data from the table: "event_sources" */
  event_sources: Array<EventSources>;
  /** fetch aggregated fields from the table: "event_sources" */
  event_sources_aggregate: EventSourcesAggregate;
  /** fetch data from the table: "event_sources" using primary key columns */
  event_sources_by_pk?: Maybe<EventSources>;
  /** An array relationship */
  event_sources_plans: Array<EventSourcesPlans>;
  /** An aggregate relationship */
  event_sources_plans_aggregate: EventSourcesPlansAggregate;
  /** fetch data from the table: "event_sources_plans" using primary key columns */
  event_sources_plans_by_pk?: Maybe<EventSourcesPlans>;
  /** fetch data from the table: "event_warehouse_destination_grants" */
  event_warehouse_destination_grants: Array<EventWarehouseDestinationGrants>;
  /** fetch aggregated fields from the table: "event_warehouse_destination_grants" */
  event_warehouse_destination_grants_aggregate: EventWarehouseDestinationGrantsAggregate;
  /** fetch data from the table: "event_warehouse_destination_grants" using primary key columns */
  event_warehouse_destination_grants_by_pk?: Maybe<EventWarehouseDestinationGrants>;
  /** fetch data from the table: "event_warehouse_destinations" */
  event_warehouse_destinations: Array<EventWarehouseDestinations>;
  /** fetch aggregated fields from the table: "event_warehouse_destinations" */
  event_warehouse_destinations_aggregate: EventWarehouseDestinationsAggregate;
  /** fetch data from the table: "event_warehouse_destinations" using primary key columns */
  event_warehouse_destinations_by_pk?: Maybe<EventWarehouseDestinations>;
  /** An array relationship */
  event_warehouse_sync_sources: Array<EventWarehouseSyncSources>;
  /** An aggregate relationship */
  event_warehouse_sync_sources_aggregate: EventWarehouseSyncSourcesAggregate;
  /** fetch data from the table: "event_warehouse_sync_sources" using primary key columns */
  event_warehouse_sync_sources_by_pk?: Maybe<EventWarehouseSyncSources>;
  /** An array relationship */
  event_warehouse_syncs: Array<EventWarehouseSyncs>;
  /** An aggregate relationship */
  event_warehouse_syncs_aggregate: EventWarehouseSyncsAggregate;
  /** fetch data from the table: "event_warehouse_syncs" using primary key columns */
  event_warehouse_syncs_by_pk?: Maybe<EventWarehouseSyncs>;
  /** An array relationship */
  experiment_metrics: Array<ExperimentMetrics>;
  /** fetch data from the table: "experiment_metrics" using primary key columns */
  experiment_metrics_by_pk?: Maybe<ExperimentMetrics>;
  /** fetch data from the table: "experiments" */
  experiments: Array<Experiments>;
  /** fetch aggregated fields from the table: "experiments" */
  experiments_aggregate: ExperimentsAggregate;
  /** fetch data from the table: "experiments" using primary key columns */
  experiments_by_pk?: Maybe<Experiments>;
  exposureLogResolutionConfig: ExposureLogResolutionConfigResult;
  /** fetch data from the table: "exposure_log_resolution_runs" */
  exposure_log_resolution_runs: Array<ExposureLogResolutionRuns>;
  /** fetch data from the table: "exposure_log_resolution_runs" using primary key columns */
  exposure_log_resolution_runs_by_pk?: Maybe<ExposureLogResolutionRuns>;
  extensionCapabilities: Array<ExtensionCapability>;
  extensionDefinition?: Maybe<ExtensionDefinition>;
  extensionExportHistory: Array<ExtensionExportJob>;
  extensionImportHistory: Array<ExtensionImportJob>;
  /** fetch data from the table: "extensions" */
  extensions: Array<Extensions>;
  /** fetch aggregated fields from the table: "extensions" */
  extensions_aggregate: ExtensionsAggregate;
  /** fetch data from the table: "extensions" using primary key columns */
  extensions_by_pk?: Maybe<Extensions>;
  externalContextSourceConnectionTestResult: ExternalContextSourceConnectionTestResult;
  /** fetch data from the table: "external_buckets" */
  external_buckets: Array<ExternalBuckets>;
  /** fetch data from the table: "external_buckets" using primary key columns */
  external_buckets_by_pk?: Maybe<ExternalBuckets>;
  /** fetch data from the table: "external_context_sources" */
  external_context_sources: Array<ExternalContextSources>;
  /** fetch aggregated fields from the table: "external_context_sources" */
  external_context_sources_aggregate: ExternalContextSourcesAggregate;
  /** fetch data from the table: "external_context_sources" using primary key columns */
  external_context_sources_by_pk?: Maybe<ExternalContextSources>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  /** fetch data from the table: "external_segments" using primary key columns */
  external_segments_by_pk?: Maybe<ExternalSegments>;
  facebookAdCatalogGetProductCatalogs: FacebookAdCatalogGetProductCatalogsResult;
  featureSqlBackground: FeatureSqlBackgroundResult;
  fetchMetaAdAccounts: Array<MetaAdAccount>;
  fetchMetaAdStatuses: Array<MetaAdStatus>;
  fetchMetaAdsetAds: Array<MetaAdsetAd>;
  fetchMetaAdsets: Array<MetaAdset>;
  fetchMetaCampaigns: Array<MetaCampaign>;
  fetchMetaInstagramIdentities: MetaInstagramIdentities;
  fetchMetaPages: Array<MetaPage>;
  figmaImportDrafts: Array<FigmaImportDraft>;
  /** An array relationship */
  figma_import_drafts: Array<FigmaImportDrafts>;
  /** fetch data from the table: "figma_import_drafts" using primary key columns */
  figma_import_drafts_by_pk?: Maybe<FigmaImportDrafts>;
  filterableAudienceColumnsForSegmentIds: Array<FilterableColumnsForSegment>;
  /** fetch data from the table: "fivetran_agent_syncs" */
  fivetran_agent_syncs: Array<FivetranAgentSyncs>;
  /** fetch data from the table: "fivetran_agent_syncs" using primary key columns */
  fivetran_agent_syncs_by_pk?: Maybe<FivetranAgentSyncs>;
  /** fetch data from the table: "fivetran_credentials" */
  fivetran_credentials: Array<FivetranCredentials>;
  /** fetch data from the table: "fivetran_credentials" using primary key columns */
  fivetran_credentials_by_pk?: Maybe<FivetranCredentials>;
  /** fetch data from the table: "folders" */
  folders: Array<Folders>;
  /** fetch data from the table: "folders" using primary key columns */
  folders_by_pk?: Maybe<Folders>;
  formkitDestinationDefinition: Array<DestinationMethod>;
  formkitDestinationHandler: Scalars['JSON'];
  formkitDestinationValidation?: Maybe<Scalars['JSON']>;
  formkitEventDestinationDefinition: Array<SourceMethod>;
  formkitEventDestinationHandler: Scalars['JSON'];
  formkitEventDestinationValidation?: Maybe<Scalars['JSON']>;
  formkitSourceDefinition: Array<SourceMethod>;
  formkitSourceHandler: Scalars['JSON'];
  formkitSourceValidation?: Maybe<Scalars['JSON']>;
  formkitSyncDefinition: FormkitSyncDefinition;
  formkitSyncHandler: Scalars['JSON'];
  formkitSyncValidation?: Maybe<Scalars['JSON']>;
  freshdeskListCustomFields: FreshdeskListCustomFieldsResult;
  frontDescribeObject: FrontDescribeObjectResult;
  /** Pass libraryId for a library's top-level folders, or parentFolderId for a folder's children. */
  frontifyFolderTree: FrontifyFolderTreeResult;
  frontifyLibraries: FrontifyLibrariesResult;
  frontifyMetadataProperties: Array<FrontifyMetadataProperty>;
  functionResponseModelInUse: Scalars['Boolean'];
  /** fetch data from the table: "function_grants" */
  function_grants: Array<FunctionGrants>;
  /** fetch aggregated fields from the table: "function_grants" */
  function_grants_aggregate: FunctionGrantsAggregate;
  /** fetch data from the table: "function_grants" using primary key columns */
  function_grants_by_pk?: Maybe<FunctionGrants>;
  /** An array relationship */
  function_resources: Array<FunctionResources>;
  /** An aggregate relationship */
  function_resources_aggregate: FunctionResourcesAggregate;
  /** fetch data from the table: "function_resources" using primary key columns */
  function_resources_by_pk?: Maybe<FunctionResources>;
  /** An array relationship */
  function_settings: Array<FunctionSettings>;
  /** fetch data from the table: "function_settings" using primary key columns */
  function_settings_by_pk?: Maybe<FunctionSettings>;
  /** An array relationship */
  functions: Array<Functions>;
  /** fetch data from the table: "functions" using primary key columns */
  functions_by_pk?: Maybe<Functions>;
  gainsightpxGetAccountAttributes: GainsightpxGetAccountAttributesResult;
  gainsightpxGetUserAttributes: GainsightpxGetUserAttributesResult;
  generateResourceSlug: Scalars['String'];
  generateWorkspaceSlug: Scalars['String'];
  getAccessibleModelIds: GetAccessibleModelIdsOutput;
  getAccessibleOrganizations: GetAccessibleOrganizationsResult;
  getAdComponentAssetUrls: GetAdComponentAssetUrlsResponse;
  getAgentEligibilityBackground: BackgroundQueryResult;
  /**
   * With a parentModelId or sourceId: the workspace-wide memories plus those
   * scoped to that parent. With neither: every memory in the workspace.
   */
  getAgentMemories: Array<AgentMemory>;
  getAgentSettingsFileReadUrl: AgentSettingsFileReadUrlResponse;
  getAgenticSettingsCopyExamplesSources: Array<AgenticSettingsCopyExamplesConnectionSource>;
  /** AI feature matrix generation runs from the last 7 days */
  getAgenticUFMJobs: Array<AgenticUfmJob>;
  getAnalyzedEventSchemas: GetAnalyzedEventSchemasResult;
  getArchivedFailures: GetArchivedFailuresResult;
  getArchivedFailuresSummary: GetArchivedFailuresSummaryResult;
  getAttemptedRows: AttemptedRowsResult;
  getAttemptedRowsByPrimaryKey: AttemptedRowsResult;
  getAudienceSizeMetrics: AudienceSizeMetricsResult;
  getAvailableEventMetrics: AvailableEventMetrics;
  getAvailableFeatures: AvailableFeatures;
  getBillingChartEmbedUrl: BillingChartEmbedUrlResult;
  getBillingOrganization?: Maybe<BillingOrganization>;
  getBingAdAccounts: Array<BingAdAccount>;
  getBulkVideoExportStatuses: GetBulkVideoExportStatusesResponse;
  getCampaignAllStats: CampaignAllStats;
  getCampaignAnalyticsDashboardResultBackground: CampaignAnalyticsDashboardBackgroundResult;
  getCampaignDerivedStatus: Array<CampaignDerivedStatusResult>;
  /**
   * One page of a campaign run's recipients from the cache. Null on a miss —
   * call startCampaignRecipientsComputation and poll campaignRecipientsResult.
   * Never computes: the collapse behind it ranks every event in the run.
   */
  getCampaignRecipients?: Maybe<CampaignRecipientsPage>;
  getCepDevicePreviewResults: GetCepDevicePreviewResultsResponse;
  getCepProfileCacheRows?: Maybe<CepProfileCacheResult>;
  /**
   * Reads the cache only — never queries the warehouse, and never starts work.
   * Null means nothing has been measured for this configuration yet; call
   * startCepReachabilityComputation to ask for it.
   */
  getCepReachabilityCounts?: Maybe<CepReachabilityCounts>;
  getChartCardRunBackground: ChartCardRunData;
  getCheckoutUrl: StripeRedirectResult;
  getCloudCredentials: Array<CloudCredentialQueryResult>;
  getConnectedChannels: Array<ConnectedChannel>;
  getContentArtifactContent?: Maybe<GetContentArtifactContentResponse>;
  getContentBlockFromDestination: ContentBlock;
  getContentEmailPersonalizationPreview: ContentEmailPersonalizationPreviewResponse;
  getContentEmailVersionResolvedHtml: ContentEmailVersionResolvedHtmlResponse;
  getContentImageReadUrl: ContentImageReadUrlResponse;
  getContentNodeSvgEditVersionHistory: Array<ImageLineageNode>;
  getContentNodesForImageUrls: Array<ContentNodeForImageUrl>;
  getContextReviewSuggestions: ContextReviewSuggestions;
  getCopyReferencesReview?: Maybe<CopyReferencesReview>;
  /**
   * Returns the current version of every active agentic settings entity in the
   * workspace. Hightouch-managed entities are excluded by default; callers
   * that want them opt in via `includeHightouchManaged`. `contextType`
   * returns only entities of that classification (e.g. skills);
   * `excludeContextTypes` hides the listed classifications (e.g. the Context
   * tab passing `[skill]` so skills only appear in the Skills tab).
   * Reference-only entities are excluded unless `includeReferenceOnly` is set.
   */
  getCurrentAgenticSettingsEntities: Array<AgenticSettingsEntity>;
  getCurrentRunningMessageTagsJobs?: Maybe<Array<Maybe<RunningTagsJobResponse>>>;
  getCurrentTagsMessageJobFromMessage?: Maybe<TagsJobResponse>;
  getCurrentUserV2: CurrentUser;
  getDbtCloudAccounts: Array<DbtAccount>;
  getDbtCloudJobs: Array<DbtJob>;
  getDbtSyncConfig?: Maybe<FrontendDbtSyncConfig>;
  getDbtSyncConfigBySource?: Maybe<FrontendDbtSyncConfig>;
  getDbtSyncConfigs: Array<FrontendDbtSyncConfig>;
  getDecisionEngineChartMetadataFromS3: Array<ChartMetadataEntry>;
  getDecisionEngineDestinationResource: DecisionEngineDestinationResource;
  getDecisionEngineDestinationResources: Array<DecisionEngineDestinationBaseResource>;
  getDecisionEngineFlowRunChartData?: Maybe<Scalars['JSONObject']>;
  getDecisionEngineFlowRunPlotImageUrl: DecisionEngineFlowRunPlotImageUrl;
  getDecisionEngineFlowRunPlotManifest: Array<DecisionEngineFlowRunPlotManifest>;
  /** Rows of { bucket, users }: unique audience users per ramp bucket from 0 to 99. A ramp at p% admits the users in buckets below p. */
  getDecisionEngineFlowVolumeRampAudienceBucketsBackground: BackgroundQueryResult;
  getDecisionEngineMessageTags: Array<DecisionEngineMessageTag>;
  getDecisionEngineTableNames: Array<DecisionEngineTableNames>;
  /** Bounces of one class (soft/hard) broken down by SMTP code or recipient domain. Email-only; returns empty for SMS/Push. */
  getDeliverabilityBounceBreakdown: DeliverabilityBounceDimensionBreakdown;
  /**
   * Per-campaign windowed metrics for the Reporting Campaigns tab. channelType
   * omitted = all channels.
   *
   * Cost does not scale with limit: every channel is queried unbounded and rolled
   * up in memory before the slice, so a narrow limit does not make this cheap.
   */
  getDeliverabilityByCampaign: DeliverabilityByCampaign;
  /**
   * Sends, opens and clicks per locale each recipient was sent, most sends
   * first. Opens and clicks count against the send they answer and are dated by
   * it.
   */
  getDeliverabilityByLocale: DeliverabilityByLocale;
  getDeliverabilityByMessage: DeliverabilityByMessage;
  getDeliverabilityByOsOverTime: DeliverabilityByOsOverTime;
  getDeliverabilityByProviderOverTime: DeliverabilityByProviderOverTime;
  getDeliverabilityMetrics: Array<DeliverabilityMetricEntry>;
  getDeliverabilityOverTime: DeliverabilityOverTime;
  /**
   * Recipients dropped by the dispatcher before send, bucketed by reason.
   *
   * Not filterable by OS: drop rows are written before per-token fan-out, so they
   * carry no OS and an OS-scoped count is not something this can answer.
   */
  getDeliverabilitySkipsByReason: DeliverabilitySkipsByReason;
  getDestinationDefinition: DestinationDefinition;
  getDestinationDefinitions: Array<DestinationDefinition>;
  getDestinationMetadata?: Maybe<Scalars['JSONObject']>;
  getDestinationStrippedConfiguration: Scalars['JSONObject'];
  getDeviceTokensForUser: Array<CepDeviceToken>;
  getEmailPreview?: Maybe<Scalars['String']>;
  /**
   * Get available email templates/campaigns from a destination.
   * Returns campaigns and canvases for Braze, campaigns for Iterable.
   */
  getEmailPreviewTemplates: Array<EmailPreviewTemplate>;
  getEmailTemplateFromDestination: EmailTemplate;
  /**
   * Provider template settings (UTM link params etc.) that would be replayed
   * when exporting this content email to the destination. Null when the email
   * has no captured metadata for the destination's provider type.
   */
  getEmailTemplateProviderMetadata?: Maybe<EmailTemplateProviderMetadata>;
  getErrorCode?: Maybe<Scalars['JSONObject']>;
  getEventMetrics: EventMetrics;
  getEventPayload: GetEventPayloadResult;
  getEventRequest?: Maybe<EventRequest>;
  getEventTrace?: Maybe<EventTrace>;
  getEventWarehouseSyncRun: EventWarehouseSyncRun;
  getEventWarehouseSyncRuns: GetEventWarehouseSyncRunsResult;
  getFacebookAdAccounts: Array<FacebookAdAccount>;
  getFailedEvents: FailedEvents;
  getFeatureMatrixColumnsForSegment: FeatureMatrixColumnsResult;
  getFeatureMatrixSql: FeatureMatrixSqlResult;
  getFivetranConnectors: Array<FivetranConnector>;
  getFivetranDbtTransformations: Array<FivetranTransformation>;
  getFivetranGroups: Array<FivetranGroup>;
  getFivetranResources: Array<FivetranSyncTrigger>;
  getFlowAggregations: FlowAggregations;
  getFlowMessageAggregations: Array<MessageAggregations>;
  getFunnelMetricResultBackground: FunnelMetricBackgroundResult;
  getGeneratedFeatureSchema: Array<FeatureSchemaEntry>;
  getGithubBranches: Array<GithubBranch>;
  getGithubRepositories: Array<GithubRepository>;
  getGoogleAdAccounts: Array<GoogleAdAccount>;
  getIdrReingests: Array<IdrReingestRow>;
  getImageLineageGraph?: Maybe<ImageLineageGraphResult>;
  getInteractionArtifact: Scalars['String'];
  getLatestChartCardRun?: Maybe<ChartCardRunData>;
  getLatestDashboardChartCardRuns?: Maybe<LatestDashboardChartCardRuns>;
  getLatestExperimentRun?: Maybe<ExperimentRunData>;
  getLatestSampledSegmentJobs: LatestSampledSegmentJobOutput;
  getLatestSavedChartRun?: Maybe<SavedChartRunData>;
  getLinkClicks: Array<LinkClickRow>;
  getLinkableResources: Array<LinkableResource>;
  getLiveSourceEvents: LiveSourceEvents;
  getLookerLook?: Maybe<GetLookerLookOutput>;
  getMarketingCampaignArtifactContent: Scalars['String'];
  getMarketingDestinations: Array<MarketingDestination>;
  /**
   * Composed A/B results for a message experiment: per-arm delivery stats from
   * the warehouse plus the latest analytics run's summary stats. Pass
   * campaignRunId to scope delivery stats to one run; omit it for the whole
   * experiment history.
   */
  getMessageAbTestResults: MessageAbTestResults;
  getMessageActivity: MessageActivityResponse;
  getMessageAggregations: MessageAggregations;
  getMessageContactInfo: MessageContactInfo;
  getMessageEngagement: MessageEngagement;
  getMessageHourlyStatsBatch: Array<MessageHourlyStatsBatch>;
  /**
   * Current preview state for a message. Waiting past the acceptance window
   * is persisted as failed on read; otherwise the read is pure.
   */
  getMessagePreviewState: MessagePreviewState;
  getMessageSimilarity: Array<MessageSimilarity>;
  getMessageSimilarityRating: MessageSimilarityRatingResult;
  getMessageSimilarityReasons: MessageSimilarityReasonsResult;
  getMessageStats: Array<MessageStats>;
  getMessageTimelineEvents: MessageTimelineEventsResponse;
  getMessageVariableSimilarity: Array<MessageVariableSimilarity>;
  getMessageVariables: Scalars['JSON'];
  getMessagesList: MessagesList;
  getMetricResultBackground: MetricBackgroundResult;
  getMigratedEventSyncConfiguration: Scalars['JSONObject'];
  getModelCountsByPkBackground: ProfileExplorerJob;
  getModelCountsByPkBackgroundResult?: Maybe<ModelCountsByPkBackgroundResult>;
  getModelRowsByPkBackground: ProfileExplorerJob;
  /** The agent-chosen groups a native delivery message registers on its agent messages, with the branch names the content tab shows. */
  getNativeDeliveryAgentGroups: NativeDeliveryAgentGroups;
  getOrganization?: Maybe<Organization>;
  getOrganizationDestinationTypes: Array<Maybe<DestinationTypesResult>>;
  getOrganizationDestinations: OrganizationDestinations;
  getOrganizationGeneralModels: OrganizationGeneralModels;
  getOrganizationMetrics: MetricsResult;
  getOrganizationMqrs: Array<OrganizationMqr>;
  getOrganizationParentModels: OrganizationParentModels;
  getOrganizationSources: OrganizationSources;
  getOverlappingAgentEligibilityBackground: BackgroundQueryResult;
  getPortalUrl: StripeRedirectResult;
  getPriorityList: PriorityList;
  getQueueSource?: Maybe<QueueSource>;
  /**
   * Every user who has commented on an ad, opened, resolved or reopened one of
   * its threads, been mentioned on it, or changed its status. Empty when the ad
   * is not in the caller's workspace.
   */
  getRelevantUsersForAsset: Array<AssetRelevantUser>;
  getRequestInfoSet?: Maybe<Array<RequestInfo>>;
  getSampleDataSourceDefinition: SourceDefinition;
  getSampleDataSourceDefinitions: Array<SourceDefinition>;
  getSchemaGraph: GetSchemaGraphOutput;
  /** Ranked send-drop suspects from the latest send-diagnostics run. Null until the first run. */
  getSendDiagnostics?: Maybe<SendDiagnostics>;
  getSigmaElements: SigmaElements;
  getSigmaPages: SigmaPages;
  getSigmaQuery?: Maybe<SigmaQuery>;
  getSigmaWorkbookDetail: SigmaWorkbookDetail;
  getSigmaWorkbooks: SigmaWorkbooks;
  getSourceDefinedDescription?: Maybe<SourceDefinedDescription>;
  getSourceDefinition: SourceDefinition;
  getSourceDefinitionV2: SourceDefinition;
  getSourceDefinitions: Array<SourceDefinition>;
  getSourceStrippedConfiguration: Scalars['JSONObject'];
  getSubscriptionEvents: SubscriptionEventsResponse;
  getSuccessfulSyncOpsByDestination: SuccessfulSyncOpsByDestinationResult;
  getSyncAttemptProgress: Scalars['Float'];
  getSyncMetadata?: Maybe<Scalars['JSONObject']>;
  getSyncReconciliationData: Array<SyncReconciliationDataPoint>;
  getSyncRequestEvents: Array<MergedSyncRequestEvent>;
  getSyncRowsQueried: SyncRowsQueriedResult;
  getSyncRunMetrics: SyncRunMetricsResult;
  getSyncUsageChartEmbedUrl: BillingChartEmbedUrlResult;
  getTagsBackgroundJobResult?: Maybe<TagsBackgroundJobResult>;
  getTagsForMessagesBackground: Scalars['String'];
  getTopK: TopKResponse;
  getTransformedRetlAndRealtimeSyncConfiguration: Scalars['JSONObject'];
  getTransformedSyncConfiguration: Scalars['JSONObject'];
  getTransformedSyncRunConfiguration: Scalars['JSONObject'];
  getTransformedSyncTemplateConfiguration: Scalars['JSONObject'];
  getTunnel: GetTunnelResult;
  getTunnels: Array<GetTunnelResult>;
  getUserDevices: UserDevicesResponse;
  getUserInferredTimeZone: UserInferredTimeZoneResponse;
  getUserSubscriptions: UserSubscriptionsResponse;
  getVideoExportBundleStatus: GetVideoExportBundleStatusResponse;
  getVideoExportStatus: GetVideoExportStatusResponse;
  getWarehouseSyncErrorSummary: GetWarehouseSyncErrorSummaryResult;
  getWorkspaceEntitlements: WorkspaceEntitlements;
  getWorkspaceExtensionHealth?: Maybe<Array<ExtensionHealthCheck>>;
  gettyImagesByIds: Array<GettyImage>;
  gettySearchImages: GettySearchResult;
  /** fetch data from the table: "git_credentials" */
  git_credentials: Array<GitCredentials>;
  /** fetch data from the table: "git_credentials" using primary key columns */
  git_credentials_by_pk?: Maybe<GitCredentials>;
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** fetch data from the table: "git_inbound_runs" using primary key columns */
  git_inbound_runs_by_pk?: Maybe<GitInboundRuns>;
  /** An array relationship */
  git_outbound_runs: Array<GitOutboundRuns>;
  /** fetch data from the table: "git_outbound_runs" using primary key columns */
  git_outbound_runs_by_pk?: Maybe<GitOutboundRuns>;
  /** fetch data from the table: "git_sync_configs" */
  git_sync_configs: Array<GitSyncConfigs>;
  /** fetch data from the table: "git_sync_configs" using primary key columns */
  git_sync_configs_by_pk?: Maybe<GitSyncConfigs>;
  globalDecisioningAgentSummary: GlobalDecisioningAgentSummary;
  globalDecisioningCompetition: GlobalDecisioningCompetition;
  /**
   * User-made changes to a group's name, caps, mode and agent membership and weights.
   * Changes made while impersonating are left out.
   */
  globalDecisioningConfigChanges: GlobalDecisioningConfigChanges;
  /**
   * Decision mix for a group's current arbitration epoch, at flow x state x send-date grain.
   * Passing flowId narrows to one agent for the over-time chart.
   */
  globalDecisioningDecisionMix: GlobalDecisioningDecisionMix;
  /** One user's committed and planned sends for a group's current arbitration epoch. */
  globalDecisioningUserTimeline: GlobalDecisioningUserTimeline;
  /** An array relationship */
  goal_metrics: Array<GoalMetrics>;
  /** fetch data from the table: "goal_metrics" using primary key columns */
  goal_metrics_by_pk?: Maybe<GoalMetrics>;
  /** fetch data from the table: "goals" */
  goals: Array<Goals>;
  /** fetch aggregated fields from the table: "goals" */
  goals_aggregate: GoalsAggregate;
  /** An array relationship */
  goals_attribution_methods: Array<GoalsAttributionMethods>;
  /** fetch data from the table: "goals_attribution_methods" using primary key columns */
  goals_attribution_methods_by_pk?: Maybe<GoalsAttributionMethods>;
  /** fetch data from the table: "goals" using primary key columns */
  goals_by_pk?: Maybe<Goals>;
  googlesheetsListSheets: GooglesheetsListSheetsResult;
  googlesheetsListSpreadSheets: Array<GooglesheetsSpreadSheet>;
  googlesheetsSourceListSheets?: Maybe<Array<Maybe<Scalars['String']>>>;
  hello?: Maybe<Scalars['String']>;
  householdMembershipsBackground: ProfileExplorerJob;
  householdMembershipsBackgroundResult?: Maybe<HouseholdMembershipsBackgroundResult>;
  hubspotDescribeGlobal: HubSpotDescribeGlobalResult;
  hubspotDescribeObject: HubSpotDescribeObjectResult;
  hubspotLegacyDescribeGlobal: HubSpotLegacyDescribeGlobalResult;
  hubspotLegacyDescribeObject: HubSpotLegacyDescribeObjectResult;
  /** fetch data from the table: "idr" */
  idr: Array<Idr>;
  idrIdentifierSuggestions: IdrIdentifierSuggestionsResult;
  idrMergeConvergence: IdrMergeConvergence;
  idrPidrOverlay: IdrPidrOverlay;
  idrProfileAnalysisBackground: IdrProfileAnalysisJob;
  idrProfileAnalysisSql: IdrProfileAnalysisSql;
  idrProfiles: IdrProfilesJob;
  idrProfilesJobResult?: Maybe<IdrProfilesJobResult>;
  idrRuleSuggestions: IdrRuleSuggestionsResult;
  idrSequenceLinks: Array<IdrSequenceLink>;
  /** fetch data from the table: "idr" using primary key columns */
  idr_by_pk?: Maybe<Idr>;
  /** An array relationship */
  idr_golden_record_base_columns: Array<IdrGoldenRecordBaseColumns>;
  /** fetch data from the table: "idr_golden_record_base_columns" using primary key columns */
  idr_golden_record_base_columns_by_pk?: Maybe<IdrGoldenRecordBaseColumns>;
  /** fetch data from the table: "idr_golden_record_column_source_survivorship" */
  idr_golden_record_column_source_survivorship: Array<IdrGoldenRecordColumnSourceSurvivorship>;
  /** fetch data from the table: "idr_golden_record_column_source_survivorship" using primary key columns */
  idr_golden_record_column_source_survivorship_by_pk?: Maybe<IdrGoldenRecordColumnSourceSurvivorship>;
  /** An array relationship */
  idr_golden_record_columns: Array<IdrGoldenRecordColumns>;
  /** fetch data from the table: "idr_golden_record_columns" using primary key columns */
  idr_golden_record_columns_by_pk?: Maybe<IdrGoldenRecordColumns>;
  /** fetch data from the table: "idr_golden_records" */
  idr_golden_records: Array<IdrGoldenRecords>;
  /** fetch data from the table: "idr_golden_records" using primary key columns */
  idr_golden_records_by_pk?: Maybe<IdrGoldenRecords>;
  /** fetch data from the table: "idr_model_mappings" */
  idr_model_mappings: Array<IdrModelMappings>;
  /** fetch data from the table: "idr_model_mappings" using primary key columns */
  idr_model_mappings_by_pk?: Maybe<IdrModelMappings>;
  /** fetch data from the table: "idr_models" */
  idr_models: Array<IdrModels>;
  /** fetch data from the table: "idr_models" using primary key columns */
  idr_models_by_pk?: Maybe<IdrModels>;
  /** fetch data from the table: "idr_output_segments" */
  idr_output_segments: Array<IdrOutputSegments>;
  /** fetch data from the table: "idr_runs" */
  idr_runs: Array<IdrRuns>;
  /** fetch aggregated fields from the table: "idr_runs" */
  idr_runs_aggregate: IdrRunsAggregate;
  /** fetch data from the table: "idr_runs" using primary key columns */
  idr_runs_by_pk?: Maybe<IdrRuns>;
  /** fetch data from the table: "idr_training_runs" */
  idr_training_runs: Array<IdrTrainingRuns>;
  /** fetch aggregated fields from the table: "idr_training_runs" */
  idr_training_runs_aggregate: IdrTrainingRunsAggregate;
  /** fetch data from the table: "idr_training_runs" using primary key columns */
  idr_training_runs_by_pk?: Maybe<IdrTrainingRuns>;
  /** updatesLimit is how many groups of updates to return. */
  inbox: Inbox;
  /**
   * When the viewer's newest notification arrived, so a client can tell when
   * to refetch the inbox.
   */
  inboxLatestNotificationAt?: Maybe<Scalars['String']>;
  inboxUnreadCount: InboxUnreadCount;
  /** fetch data from the table: "incoming_webhooks" */
  incoming_webhooks: Array<IncomingWebhooks>;
  /** fetch data from the table: "incoming_webhooks" using primary key columns */
  incoming_webhooks_by_pk?: Maybe<IncomingWebhooks>;
  /**
   * List the workspace's initiative goals with insight counts and the latest
   * insight-generation job status. Gated by the agenticInitiatives flag.
   */
  initiativeGoals: Array<InitiativeGoalListItem>;
  /** fetch data from the table: "initiative_goals" */
  initiative_goals: Array<InitiativeGoals>;
  /** fetch data from the table: "initiative_goals" using primary key columns */
  initiative_goals_by_pk?: Maybe<InitiativeGoals>;
  /** An array relationship */
  initiative_insights: Array<InitiativeInsights>;
  /** An aggregate relationship */
  initiative_insights_aggregate: InitiativeInsightsAggregate;
  /** fetch data from the table: "initiative_insights" using primary key columns */
  initiative_insights_by_pk?: Maybe<InitiativeInsights>;
  /** fetch data from the table: "insights_agent_data_sources" */
  insights_agent_data_sources: Array<InsightsAgentDataSources>;
  /** fetch data from the table: "insights_agent_data_sources" using primary key columns */
  insights_agent_data_sources_by_pk?: Maybe<InsightsAgentDataSources>;
  /** Build the exact APNs/FCM payload a push send would produce, without sending. */
  inspectPushPayload: InspectPushPayloadResult;
  inspectorMessagesBackground: Scalars['String'];
  inspectorV2MessagesBackground: Scalars['String'];
  inspirationBoard?: Maybe<InspirationBoard>;
  inspirationBoards: Array<InspirationBoard>;
  /** fetch data from the table: "inspiration_board_ads" */
  inspiration_board_ads: Array<InspirationBoardAds>;
  /** fetch aggregated fields from the table: "inspiration_board_ads" */
  inspiration_board_ads_aggregate: InspirationBoardAdsAggregate;
  /** fetch data from the table: "inspiration_board_ads" using primary key columns */
  inspiration_board_ads_by_pk?: Maybe<InspirationBoardAds>;
  /** fetch data from the table: "inspiration_boards" */
  inspiration_boards: Array<InspirationBoards>;
  /** fetch aggregated fields from the table: "inspiration_boards" */
  inspiration_boards_aggregate: InspirationBoardsAggregate;
  /** fetch data from the table: "inspiration_boards" using primary key columns */
  inspiration_boards_by_pk?: Maybe<InspirationBoards>;
  /**
   * The context files the root agent actually read during an interaction, each
   * with inline usage stats scoped to the interaction's agent category. Files
   * that were available but unread are excluded.
   */
  interactionContextFilesRead: InteractionContextFilesRead;
  /** fetch data from the table: "interaction_models" */
  interaction_models: Array<InteractionModels>;
  /** fetch data from the table: "interaction_models" using primary key columns */
  interaction_models_by_pk?: Maybe<InteractionModels>;
  intercomListAttributes: IntercomListAttributesResult;
  isAdminEntitlementRequired: Scalars['Boolean'];
  isDestinationAuthorized: ResourceAuthorization;
  isModelAuthorized: ResourceAuthorization;
  isOrganizationAvailable: Scalars['Boolean'];
  isResourceAuthorized: ResourceAuthorization;
  isResourceSlugAvailable: Scalars['Boolean'];
  isResourcesAuthorized: Array<ResourceAuthorization>;
  isSourceAuthorized: ResourceAuthorization;
  isSyncAuthorized: ResourceAuthorization;
  isValidEventSchema: IsValidEventSchemaResult;
  isWorkspaceAuthorized: ResourceAuthorization;
  isWorkspaceSlugAvailable: Scalars['Boolean'];
  iterableGetCampaigns: IterableGetCampaigns;
  iterableGetCatalogFields?: Maybe<IterableGetCatalogFields>;
  iterableGetCatalogs?: Maybe<IterableGetCatalogs>;
  iterableGetTemplates: IterableGetTemplates;
  iterableUserFields: IterableUserFieldsResult;
  journeyChangeLog: Array<JourneyChange>;
  journeyContextVariablesBackground: ProfileExplorerJob;
  journeyContextVariablesBackgroundResult?: Maybe<JourneyContextVariablesBackgroundResult>;
  journeyEntityPathQueryBackground: BackgroundJobResult;
  journeyMembershipsBackground: ProfileExplorerJob;
  journeyMembershipsBackgroundResult?: Maybe<JourneyMembershipsBackgroundResult>;
  journeyNodeMembersQueryBackground: BackgroundJobResult;
  journeyNodeQueryBackground: BackgroundJobResult;
  journeyRealtimeSyncConfigs: Array<NodeRealtimeSyncConfig>;
  journeyTraits: Array<JourneyTrait>;
  /** fetch data from the table: "journey_decision_engine_flows" */
  journey_decision_engine_flows: Array<JourneyDecisionEngineFlows>;
  /** fetch data from the table: "journey_drafts" */
  journey_drafts: Array<JourneyDrafts>;
  /** fetch aggregated fields from the table: "journey_drafts" */
  journey_drafts_aggregate: JourneyDraftsAggregate;
  /** fetch data from the table: "journey_drafts" using primary key columns */
  journey_drafts_by_pk?: Maybe<JourneyDrafts>;
  /** fetch data from the table: "journey_edges" */
  journey_edges: Array<JourneyEdges>;
  /** fetch data from the table: "journey_edges" using primary key columns */
  journey_edges_by_pk?: Maybe<JourneyEdges>;
  /** An array relationship */
  journey_labels: Array<JourneyLabels>;
  /** An aggregate relationship */
  journey_labels_aggregate: JourneyLabelsAggregate;
  /** fetch data from the table: "journey_labels" using primary key columns */
  journey_labels_by_pk?: Maybe<JourneyLabels>;
  /** An array relationship */
  journey_messages: Array<JourneyMessages>;
  /** fetch data from the table: "journey_messages" using primary key columns */
  journey_messages_by_pk?: Maybe<JourneyMessages>;
  /** An array relationship */
  journey_node_runs: Array<JourneyNodeRuns>;
  /** fetch data from the table: "journey_node_runs" using primary key columns */
  journey_node_runs_by_pk?: Maybe<JourneyNodeRuns>;
  /** An array relationship */
  journey_nodes: Array<JourneyNodes>;
  /** An aggregate relationship */
  journey_nodes_aggregate: JourneyNodesAggregate;
  /** fetch data from the table: "journey_nodes" using primary key columns */
  journey_nodes_by_pk?: Maybe<JourneyNodes>;
  /** fetch data from the table: "journey_notes" */
  journey_notes: Array<JourneyNotes>;
  /** fetch aggregated fields from the table: "journey_notes" */
  journey_notes_aggregate: JourneyNotesAggregate;
  /** fetch data from the table: "journey_runs" */
  journey_runs: Array<JourneyRuns>;
  /** fetch aggregated fields from the table: "journey_runs" */
  journey_runs_aggregate: JourneyRunsAggregate;
  /** fetch data from the table: "journey_runs" using primary key columns */
  journey_runs_by_pk?: Maybe<JourneyRuns>;
  /** fetch data from the table: "journey_simulations" */
  journey_simulations: Array<JourneySimulations>;
  /** fetch aggregated fields from the table: "journey_simulations" */
  journey_simulations_aggregate: JourneySimulationsAggregate;
  /** fetch data from the table: "journey_simulations" using primary key columns */
  journey_simulations_by_pk?: Maybe<JourneySimulations>;
  /** fetch data from the table: "journey_syncs" */
  journey_syncs: Array<JourneySyncs>;
  /** fetch data from the table: "journey_syncs" using primary key columns */
  journey_syncs_by_pk?: Maybe<JourneySyncs>;
  /** fetch data from the table: "journey_template_references" */
  journey_template_references: Array<JourneyTemplateReferences>;
  /** fetch data from the table: "journey_template_references" using primary key columns */
  journey_template_references_by_pk?: Maybe<JourneyTemplateReferences>;
  /** fetch data from the table: "journey_templates" */
  journey_templates: Array<JourneyTemplates>;
  /** fetch aggregated fields from the table: "journey_templates" */
  journey_templates_aggregate: JourneyTemplatesAggregate;
  /** fetch data from the table: "journey_templates" using primary key columns */
  journey_templates_by_pk?: Maybe<JourneyTemplates>;
  /** fetch data from the table: "journeys" */
  journeys: Array<Journeys>;
  /** fetch aggregated fields from the table: "journeys" */
  journeys_aggregate: JourneysAggregate;
  /** fetch data from the table: "journeys" using primary key columns */
  journeys_by_pk?: Maybe<Journeys>;
  klaviyoConversionMetrics: Array<KlaviyoMetric>;
  /** fetch data from the table: "label_groups" */
  label_groups: Array<LabelGroups>;
  /** fetch aggregated fields from the table: "label_groups" */
  label_groups_aggregate: LabelGroupsAggregate;
  /** fetch data from the table: "label_groups" using primary key columns */
  label_groups_by_pk?: Maybe<LabelGroups>;
  /** An array relationship */
  labels: Array<Labels>;
  /** An aggregate relationship */
  labels_aggregate: LabelsAggregate;
  /** fetch data from the table: "labels" using primary key columns */
  labels_by_pk?: Maybe<Labels>;
  /**
   * When the newest project event happened, so a client can tell when to
   * refetch the activity feed.
   */
  latestActivityAt?: Maybe<Scalars['String']>;
  latestIngestionJob?: Maybe<BackgroundJob>;
  /** The caller's latest v2 run within retention, authorized against the flow-message pair. */
  latestMessagePreviewRun?: Maybe<MessagePreviewRun>;
  launches: LaunchesState;
  /** fetch data from the table: "lcm_message_candidates" */
  lcm_message_candidates: Array<LcmMessageCandidates>;
  /** fetch aggregated fields from the table: "lcm_message_candidates" */
  lcm_message_candidates_aggregate: LcmMessageCandidatesAggregate;
  /** fetch data from the table: "lcm_message_candidates" using primary key columns */
  lcm_message_candidates_by_pk?: Maybe<LcmMessageCandidates>;
  /** fetch data from the table: "lcm_message_plans" */
  lcm_message_plans: Array<LcmMessagePlans>;
  /** fetch aggregated fields from the table: "lcm_message_plans" */
  lcm_message_plans_aggregate: LcmMessagePlansAggregate;
  /** fetch data from the table: "lcm_message_plans" using primary key columns */
  lcm_message_plans_by_pk?: Maybe<LcmMessagePlans>;
  /**
   * Preview an lcs-triggered-send managed model (parent model plus
   * per-branch boolean columns compiled from the email's slot config).
   */
  lcsTriggeredSendQueryBackground: BackgroundJobResult;
  libraryImage?: Maybe<LibraryImage>;
  libraryImageCountsByGroup: Array<LibraryImageGroupCount>;
  libraryImages: Array<LibraryImage>;
  libraryImagesAggregate: LibraryImageAggregate;
  libraryTags: Array<LibraryTag>;
  /**
   * Read the complete graph of a workspace. Returns a cursor to continue paging
   * from the next page.
   * Throws LINEAGE_PAGINATION_EXPIRED if the snapshotToken is too stale to read.
   */
  lineageGraph: LineageGraphResult;
  listAllSourceDependencies: ListAllSourceDependenciesResult;
  listAllTraitReferencesV2: ListAllTraitReferencesResultV2;
  listAmpFiles: AmpFilePage;
  listAvailableThroughRelationships: ListAvailableThroughRelationshipsOutput;
  listCepMessageDevicePreviewClients: ListCepMessageDevicePreviewClientsResult;
  listContentBlocksFromDestination: Array<ContentBlock>;
  listEmailMessageTypesFromDestination: Array<EmailMessageType>;
  /** @deprecated Use listEmailTemplatesFromDestinationPaginated instead for better performance */
  listEmailTemplatesFromDestination: Array<EmailTemplate>;
  listEmailTemplatesFromDestinationPaginated: PaginatedEmailTemplatesResult;
  listFilterableColumns: Array<FilterableColumn>;
  listFolders: ListFoldersOutput;
  listGitRepositoryTree: GitRepositoryTreeResult;
  /**
   * The Drive files a Google Drive context source would sync, each with why it
   * won't sync: everything the service account can see (SERVICE_ACCOUNT, with
   * allowedDomains) or the picked fileIds (OAUTH).
   */
  listGoogleDriveContextFiles: GoogleDriveContextFilesResult;
  listInteractionArtifacts: Array<Scalars['String']>;
  listJourneyEntryEventMergeTagColumns: Array<MergeTagColumn>;
  listJourneySyncableContextColumns: Array<SyncableColumn>;
  listJourneySyncableEventColumns: Array<SyncableColumn>;
  listMergeTagColumns: Array<MergeTagColumn>;
  listModelColumns: Array<ModelColumn>;
  listModelDependencies: Scalars['JSONObject'];
  listPushCampaignsFromDestination: Array<MessagingCampaign>;
  listRelationshipDependencies: Scalars['JSONObject'];
  listRelationships: ListRelationshipsOutput;
  listSemanticViews: ListSemanticViewsResult;
  listSlackChannelsByCredentials: Array<SlackChannel>;
  listSmsCampaignsFromDestination: Array<MessagingCampaign>;
  listSourceTestSteps: Array<TestSourceStep>;
  listSyncableColumnRowKeys: Array<SyncableColumnRowKey>;
  listSyncableColumns: Array<SyncableColumn>;
  listTraitDefinitions: TraitDefinitionsResult;
  llmBackgroundJobResult?: Maybe<LlmBackgroundJobResult>;
  llmChatInteractionDetails?: Maybe<LlmChatInteractionDetailsResponse>;
  /** An array relationship */
  llm_chat_interactions: Array<LlmChatInteractions>;
  /** An aggregate relationship */
  llm_chat_interactions_aggregate: LlmChatInteractionsAggregate;
  /** fetch data from the table: "llm_chat_interactions" using primary key columns */
  llm_chat_interactions_by_pk?: Maybe<LlmChatInteractions>;
  /** An array relationship */
  llm_chat_messages: Array<LlmChatMessages>;
  /** An aggregate relationship */
  llm_chat_messages_aggregate: LlmChatMessagesAggregate;
  /** fetch data from the table: "llm_chat_messages" using primary key columns */
  llm_chat_messages_by_pk?: Maybe<LlmChatMessages>;
  /** fetch data from the table: "llm_chat_sessions" */
  llm_chat_sessions: Array<LlmChatSessions>;
  /** fetch data from the table: "llm_chat_sessions" using primary key columns */
  llm_chat_sessions_by_pk?: Maybe<LlmChatSessions>;
  /** fetch data from the table: "llm_inference_backends" */
  llm_inference_backends: Array<LlmInferenceBackends>;
  /** fetch data from the table: "llm_inference_backends" using primary key columns */
  llm_inference_backends_by_pk?: Maybe<LlmInferenceBackends>;
  lookerLookQueryBackground: BackgroundJobResult;
  /** fetch data from the table: "looker_credentials" */
  looker_credentials: Array<LookerCredentials>;
  /** fetch data from the table: "looker_credentials" using primary key columns */
  looker_credentials_by_pk?: Maybe<LookerCredentials>;
  /**
   * Staff-only. Usage stats for global Hightouch-managed skills, aggregated
   * across all workspaces. `windowDays` defaults to 7.
   */
  managedSettingsEntityUsage: Array<ContextEntityUsage>;
  /** An array relationship */
  marketing_campaign_messages: Array<MarketingCampaignMessages>;
  /** An aggregate relationship */
  marketing_campaign_messages_aggregate: MarketingCampaignMessagesAggregate;
  /** fetch data from the table: "marketing_campaign_messages" using primary key columns */
  marketing_campaign_messages_by_pk?: Maybe<MarketingCampaignMessages>;
  /** fetch data from the table: "marketing_campaigns" */
  marketing_campaigns: Array<MarketingCampaigns>;
  /** fetch aggregated fields from the table: "marketing_campaigns" */
  marketing_campaigns_aggregate: MarketingCampaignsAggregate;
  /** fetch data from the table: "marketing_campaigns" using primary key columns */
  marketing_campaigns_by_pk?: Maybe<MarketingCampaigns>;
  matchBoosterTest?: Maybe<MatchBoosterTest>;
  matchboostingIdentifiers: Array<MatchboostingIdentifier>;
  /** fetch data from the table: "matchboosting_config" */
  matchboosting_config: Array<MatchboostingConfig>;
  /** fetch data from the table: "matchboosting_config" using primary key columns */
  matchboosting_config_by_pk?: Maybe<MatchboostingConfig>;
  /** fetch data from the table: "matchboosting_stats" */
  matchboosting_stats: Array<MatchboostingStats>;
  /** fetch data from the table: "matchboosting_stats" using primary key columns */
  matchboosting_stats_by_pk?: Maybe<MatchboostingStats>;
  /** fetch data from the table: "matchboosting_workspace_config" */
  matchboosting_workspace_config: Array<MatchboostingWorkspaceConfig>;
  /** fetch data from the table: "matchboosting_workspace_config" using primary key columns */
  matchboosting_workspace_config_by_pk?: Maybe<MatchboostingWorkspaceConfig>;
  messagePreviewAidAdmins: Array<MessagePreviewAidAdmin>;
  /** Saved recipient prerequisites and dated verification facts for this message. */
  messagePreviewDeliverySetup: MessagePreviewDeliverySetup;
  /** Authorized v2 run history, newest first, including teammates' runs. */
  messagePreviewRuns: Array<MessagePreviewRun>;
  /** Latest unverified registered-address email; body requires workspace-wide AID access. */
  messagePreviewUnmatchedEmailRender?: Maybe<MessagePreviewUnmatchedEmailRender>;
  /** An array relationship */
  message_contents: Array<MessageContents>;
  /** An aggregate relationship */
  message_contents_aggregate: MessageContentsAggregate;
  /** fetch data from the table: "message_contents_base" */
  message_contents_base: Array<MessageContentsBase>;
  /** fetch aggregated fields from the table: "message_contents_base" */
  message_contents_base_aggregate: MessageContentsBaseAggregate;
  /** fetch data from the table: "message_contents" using primary key columns */
  message_contents_by_pk?: Maybe<MessageContents>;
  /** An array relationship */
  message_contents_metadata: Array<MessageContentsMetadata>;
  /** An aggregate relationship */
  message_contents_metadata_aggregate: MessageContentsMetadataAggregate;
  /** fetch data from the table: "message_contents_metadata_base" */
  message_contents_metadata_base: Array<MessageContentsMetadataBase>;
  /** fetch aggregated fields from the table: "message_contents_metadata_base" */
  message_contents_metadata_base_aggregate: MessageContentsMetadataBaseAggregate;
  /** fetch data from the table: "message_contents_metadata" using primary key columns */
  message_contents_metadata_by_pk?: Maybe<MessageContentsMetadata>;
  /** An array relationship */
  message_experiments: Array<MessageExperiments>;
  /** fetch data from the table: "message_experiments" using primary key columns */
  message_experiments_by_pk?: Maybe<MessageExperiments>;
  /** An array relationship */
  message_labels: Array<MessageLabels>;
  /** An aggregate relationship */
  message_labels_aggregate: MessageLabelsAggregate;
  /** fetch data from the table: "message_labels" using primary key columns */
  message_labels_by_pk?: Maybe<MessageLabels>;
  /** An array relationship */
  message_push_apps: Array<MessagePushApps>;
  /** fetch data from the table: "message_push_apps" using primary key columns */
  message_push_apps_by_pk?: Maybe<MessagePushApps>;
  /** fetch data from the table: "message_variant_arm" */
  message_variant_arm: Array<MessageVariantArm>;
  /** fetch aggregated fields from the table: "message_variant_arm" */
  message_variant_arm_aggregate: MessageVariantArmAggregate;
  /** fetch data from the table: "message_variant_arm" using primary key columns */
  message_variant_arm_by_pk?: Maybe<MessageVariantArm>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  metaCtaOptions: Array<Scalars['String']>;
  metabaseListDatabases?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  metabaseListQuestions?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  metabaseListTables?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  microsoftexcelListSheets?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  microsoftexcelListWorkbooks?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  migrateConfig?: Maybe<Scalars['JSONObject']>;
  mixpanelListCohorts?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  mixpanelListProjects?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  modelCanActionGrants: CanActionGrants;
  /**
   * Whether modelId has at least one ancestor parent model that could
   * actually get space-scoped suggestions computed for it: a parent model
   * reachable through a genuine relationship path, with at least one
   * required subset group defined. Used to gate the space-scoped-suggestions
   * opt-in in the UI: a column on a model with no such parent model could
   * never get space-scoped suggestions computed for it.
   */
  modelHasAncestorParentModel: Scalars['Boolean'];
  /** fetch data from the table: "model_column_references" */
  model_column_references: Array<ModelColumnReferences>;
  /** fetch aggregated fields from the table: "model_column_references" */
  model_column_references_aggregate: ModelColumnReferencesAggregate;
  /** fetch data from the table: "model_column_references" using primary key columns */
  model_column_references_by_pk?: Maybe<ModelColumnReferences>;
  /** fetch data from the table: "model_column_references_segments" */
  model_column_references_segments: Array<ModelColumnReferencesSegments>;
  /** fetch aggregated fields from the table: "model_column_references_segments" */
  model_column_references_segments_aggregate: ModelColumnReferencesSegmentsAggregate;
  /** fetch data from the table: "model_column_references_syncs" */
  model_column_references_syncs: Array<ModelColumnReferencesSyncs>;
  /** fetch aggregated fields from the table: "model_column_references_syncs" */
  model_column_references_syncs_aggregate: ModelColumnReferencesSyncsAggregate;
  /** fetch data from the table: "model_columns" */
  model_columns: Array<ModelColumns>;
  /** fetch aggregated fields from the table: "model_columns" */
  model_columns_aggregate: ModelColumnsAggregate;
  /** fetch data from the table: "model_columns" using primary key columns */
  model_columns_by_pk?: Maybe<ModelColumns>;
  /** fetch data from the table: "model_relationship_references" */
  model_relationship_references: Array<ModelRelationshipReferences>;
  /** fetch aggregated fields from the table: "model_relationship_references" */
  model_relationship_references_aggregate: ModelRelationshipReferencesAggregate;
  /** fetch data from the table: "model_relationship_references" using primary key columns */
  model_relationship_references_by_pk?: Maybe<ModelRelationshipReferences>;
  /** fetch data from the table: "model_relationships" */
  model_relationships: Array<ModelRelationships>;
  /** fetch data from the table: "model_relationships" using primary key columns */
  model_relationships_by_pk?: Maybe<ModelRelationships>;
  mongodbListCollections: Array<Maybe<Scalars['String']>>;
  mongodbSourceListCollections?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  mongodbSourceListDatabases?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  /** fetch data from the table: "monitor_condition_statuses" */
  monitor_condition_statuses: Array<MonitorConditionStatuses>;
  /** fetch data from the table: "monitor_condition_statuses" using primary key columns */
  monitor_condition_statuses_by_pk?: Maybe<MonitorConditionStatuses>;
  /** fetch data from the table: "monitor_condition_templates" */
  monitor_condition_templates: Array<MonitorConditionTemplates>;
  /** fetch data from the table: "monitor_condition_templates" using primary key columns */
  monitor_condition_templates_by_pk?: Maybe<MonitorConditionTemplates>;
  /** An array relationship */
  notification_channel_templates: Array<NotificationChannelTemplates>;
  /** fetch data from the table: "notification_channel_templates" using primary key columns */
  notification_channel_templates_by_pk?: Maybe<NotificationChannelTemplates>;
  /** fetch data from the table: "object_definition_groups" */
  object_definition_groups: Array<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definition_groups" using primary key columns */
  object_definition_groups_by_pk?: Maybe<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definitions" */
  object_definitions: Array<ObjectDefinitions>;
  /** fetch data from the table: "object_definitions" using primary key columns */
  object_definitions_by_pk?: Maybe<ObjectDefinitions>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  /** fetch data from the table: "object_schemas" using primary key columns */
  object_schemas_by_pk?: Maybe<ObjectSchemas>;
  opportunityDefinitions: Array<OpportunityDefinition>;
  orangeLogicFolderTree: OrangeLogicFolderTreeResult;
  orbitListWorkspaces: OrbitListWorkspaces;
  /** fetch data from the table: "organization_active_syncs" */
  organization_active_syncs: Array<OrganizationActiveSyncs>;
  /** fetch data from the table: "organization_active_syncs" using primary key columns */
  organization_active_syncs_by_pk?: Maybe<OrganizationActiveSyncs>;
  /** fetch data from the table: "organization_invites" */
  organization_invites: Array<OrganizationInvites>;
  /** fetch aggregated fields from the table: "organization_invites" */
  organization_invites_aggregate: OrganizationInvitesAggregate;
  /** fetch data from the table: "organization_invites" using primary key columns */
  organization_invites_by_pk?: Maybe<OrganizationInvites>;
  /** fetch data from the table: "organization_invites_user_groups" */
  organization_invites_user_groups: Array<OrganizationInvitesUserGroups>;
  /** fetch data from the table: "organization_invites_user_groups" using primary key columns */
  organization_invites_user_groups_by_pk?: Maybe<OrganizationInvitesUserGroups>;
  /** An array relationship */
  organization_members: Array<OrganizationMembers>;
  /** An aggregate relationship */
  organization_members_aggregate: OrganizationMembersAggregate;
  /** fetch data from the table: "organization_members_distinct" */
  organization_members_distinct: Array<OrganizationMembersDistinct>;
  /** fetch aggregated fields from the table: "organization_members_distinct" */
  organization_members_distinct_aggregate: OrganizationMembersDistinctAggregate;
  /** fetch data from the table: "organization_overage_dates" */
  organization_overage_dates: Array<OrganizationOverageDates>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "pagerduty_credentials" */
  pagerduty_credentials: Array<PagerdutyCredentials>;
  /** fetch data from the table: "pagerduty_credentials" using primary key columns */
  pagerduty_credentials_by_pk?: Maybe<PagerdutyCredentials>;
  partnerConnectGetConnection?: Maybe<PartnerConnection>;
  partnerConnectGetInformation?: Maybe<PartnerInformation>;
  predictiveTraitsQueue: PredictiveTraitsQueueResult;
  /** An array relationship */
  predictor_artifacts: Array<PredictorArtifacts>;
  /** An aggregate relationship */
  predictor_artifacts_aggregate: PredictorArtifactsAggregate;
  /** fetch data from the table: "predictor_artifacts" using primary key columns */
  predictor_artifacts_by_pk?: Maybe<PredictorArtifacts>;
  /** An array relationship */
  predictor_feature_definition_events: Array<PredictorFeatureDefinitionEvents>;
  /** fetch data from the table: "predictor_feature_definition_events" using primary key columns */
  predictor_feature_definition_events_by_pk?: Maybe<PredictorFeatureDefinitionEvents>;
  /** An array relationship */
  predictor_feature_definitions: Array<PredictorFeatureDefinitions>;
  /** fetch data from the table: "predictor_feature_definitions" using primary key columns */
  predictor_feature_definitions_by_pk?: Maybe<PredictorFeatureDefinitions>;
  /** An array relationship */
  predictor_outcomes: Array<PredictorOutcomes>;
  /** fetch data from the table: "predictor_outcomes" using primary key columns */
  predictor_outcomes_by_pk?: Maybe<PredictorOutcomes>;
  /** An array relationship */
  predictor_runs: Array<PredictorRuns>;
  /** An aggregate relationship */
  predictor_runs_aggregate: PredictorRunsAggregate;
  /** fetch data from the table: "predictor_runs" using primary key columns */
  predictor_runs_by_pk?: Maybe<PredictorRuns>;
  /** fetch data from the table: "predictors" */
  predictors: Array<Predictors>;
  /** fetch data from the table: "predictors" using primary key columns */
  predictors_by_pk?: Maybe<Predictors>;
  previewFeatureMatrixForFlow: PreviewFeatureMatrixForFlowResult;
  previewMatchingEntryEvent: PreviewMatchingEntryEventResult;
  previewMatchingProfile: PreviewMatchingProfileResult;
  previewQuerySchemaBackgroundJobResult: PreviewQuerySchemaBackgroundJobResult;
  /** An array relationship */
  priority_list_memberships: Array<PriorityListMemberships>;
  /** fetch data from the table: "priority_list_memberships" using primary key columns */
  priority_list_memberships_by_pk?: Maybe<PriorityListMemberships>;
  /** fetch data from the table: "priority_lists" */
  priority_lists: Array<PriorityLists>;
  /** fetch aggregated fields from the table: "priority_lists" */
  priority_lists_aggregate: PriorityListsAggregate;
  /** fetch data from the table: "priority_lists" using primary key columns */
  priority_lists_by_pk?: Maybe<PriorityLists>;
  publicImageJobResult?: Maybe<PublicImageJobResultResponse>;
  /** fetch data from the table: "push_apps" */
  push_apps: Array<PushApps>;
  /** fetch data from the table: "push_apps" using primary key columns */
  push_apps_by_pk?: Maybe<PushApps>;
  /** fetch data from the table: "push_config" */
  push_config: Array<PushConfig>;
  /** fetch aggregated fields from the table: "push_config" */
  push_config_aggregate: PushConfigAggregate;
  /** fetch data from the table: "push_config" using primary key columns */
  push_config_by_pk?: Maybe<PushConfig>;
  queryExport?: Maybe<QueryExportResult>;
  queryExportCompare?: Maybe<QueryExportResult>;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  /** fetch data from the table: "query_runs" using primary key columns */
  query_runs_by_pk?: Maybe<QueryRuns>;
  rawSqlQueryBackground: BackgroundJobResult;
  realtimeAddressTraits: Array<RealtimeAddressTrait>;
  /** The condition trees of the journey a warehouse pull read, or null if the pull isn't one of the journey's parent model's. */
  realtimeJourneyConditionsAtPull?: Maybe<RealtimeJourneyConditionsAtPull>;
  /** An array relationship */
  realtime_audience_sync_segments: Array<RealtimeAudienceSyncSegments>;
  /** An aggregate relationship */
  realtime_audience_sync_segments_aggregate: RealtimeAudienceSyncSegmentsAggregate;
  /** fetch data from the table: "realtime_audience_sync_segments" using primary key columns */
  realtime_audience_sync_segments_by_pk?: Maybe<RealtimeAudienceSyncSegments>;
  /** An array relationship */
  realtime_audience_syncs: Array<RealtimeAudienceSyncs>;
  /** fetch data from the table: "realtime_audience_syncs" using primary key columns */
  realtime_audience_syncs_by_pk?: Maybe<RealtimeAudienceSyncs>;
  /** fetch data from the table: "realtime_audiences_scheduled_warehouse_pulls" */
  realtime_audiences_scheduled_warehouse_pulls: Array<RealtimeAudiencesScheduledWarehousePulls>;
  /** An array relationship */
  realtime_audiences_warehouse_pull_runs: Array<RealtimeAudiencesWarehousePullRuns>;
  /** An aggregate relationship */
  realtime_audiences_warehouse_pull_runs_aggregate: RealtimeAudiencesWarehousePullRunsAggregate;
  relatedGoldenRecord?: Maybe<RelatedGoldenRecordModel>;
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** fetch data from the table: "relationship_references" using primary key columns */
  relationship_references_by_pk?: Maybe<RelationshipReferences>;
  /** fetch data from the table: "relationships" */
  relationships: Array<Relationships>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: Maybe<Relationships>;
  relevantReportCard?: Maybe<RelevantReportCard>;
  renderContentEmailWithContentBlocksV2: RenderedEmailWithContentBlocks;
  renderEmailHtmlWithContentBlocks: RenderedEmailWithContentBlocks;
  renderMessage: RenderMessageResult;
  /** Renders the native delivery message an agent message delivers through, with the given preview values and user. */
  renderNativeDeliveryAgentPreview: NativeDeliveryAgentPreview;
  renderedMonitorConditionStatuses: Array<RenderedMonitorConditionStatus>;
  reportCardByRunId?: Maybe<ReportCardByRunId>;
  /** Null when the run or its session is not visible to the caller, or the run is unfinished, failed, or has no report text. */
  reportRunContent?: Maybe<Scalars['String']>;
  /** fetch data from the table: "report_schedule" */
  report_schedule: Array<ReportSchedule>;
  /** fetch aggregated fields from the table: "report_schedule" */
  report_schedule_aggregate: ReportScheduleAggregate;
  /** fetch data from the table: "report_schedule" using primary key columns */
  report_schedule_by_pk?: Maybe<ReportSchedule>;
  /** An array relationship */
  report_schedule_run_comments: Array<ReportScheduleRunComments>;
  /** An aggregate relationship */
  report_schedule_run_comments_aggregate: ReportScheduleRunCommentsAggregate;
  /** fetch data from the table: "report_schedule_run_comments" using primary key columns */
  report_schedule_run_comments_by_pk?: Maybe<ReportScheduleRunComments>;
  /** An array relationship */
  report_schedule_runs: Array<ReportScheduleRuns>;
  /** An aggregate relationship */
  report_schedule_runs_aggregate: ReportScheduleRunsAggregate;
  /** fetch data from the table: "report_schedule_runs" using primary key columns */
  report_schedule_runs_by_pk?: Maybe<ReportScheduleRuns>;
  /** An array relationship */
  report_schedule_versions: Array<ReportScheduleVersions>;
  /** An aggregate relationship */
  report_schedule_versions_aggregate: ReportScheduleVersionsAggregate;
  /** fetch data from the table: "report_schedule_versions" using primary key columns */
  report_schedule_versions_by_pk?: Maybe<ReportScheduleVersions>;
  /**
   * When the cached entries behind this window's totals were computed, or null
   * when it reads live. Describes the unscoped totals grain only: a panel with a
   * narrower grain, a provider or locale filter, or a truncated entry reads live
   * whatever this returns.
   */
  reportingCacheFreshness?: Maybe<Scalars['String']>;
  /**
   * Bulk dependent counts for several resources in one read. Includes both direct
   * and indirect dependents.
   * Throws LINEAGE_PAGINATION_EXPIRED if the snapshotToken is too stale to read.
   */
  resourceDependentCounts: LineageResourceDependentCountsResult;
  /**
   * Reads one level of a resource's direct dependents. Returns a cursor to continue
   * paging from the next page.
   * Throws LINEAGE_PAGINATION_EXPIRED if the snapshotToken is too stale to read.
   */
  resourceDependentsPage: LineageDependentsPage;
  /**
   * Entire graph counts for one resource.
   * Throws LINEAGE_PAGINATION_EXPIRED if the snapshotToken is too stale to read.
   */
  resourceDependentsSummary: LineageResourceStats;
  resourceHealth: Array<ResourceHealthMetric>;
  /** fetch data from the table: "resource_interactions" */
  resource_interactions: Array<ResourceInteractions>;
  /** fetch data from the table: "resource_interactions" using primary key columns */
  resource_interactions_by_pk?: Maybe<ResourceInteractions>;
  /** fetch data from the table: "resource_monitor_conditions" */
  resource_monitor_conditions: Array<ResourceMonitorConditions>;
  /** fetch data from the table: "resource_monitor_conditions" using primary key columns */
  resource_monitor_conditions_by_pk?: Maybe<ResourceMonitorConditions>;
  /** fetch data from the table: "resource_monitor_statuses" */
  resource_monitor_statuses: Array<ResourceMonitorStatuses>;
  /** fetch data from the table: "resource_monitor_statuses" using primary key columns */
  resource_monitor_statuses_by_pk?: Maybe<ResourceMonitorStatuses>;
  /** An array relationship */
  resource_notification_channels: Array<ResourceNotificationChannels>;
  /** fetch data from the table: "resource_notification_channels" using primary key columns */
  resource_notification_channels_by_pk?: Maybe<ResourceNotificationChannels>;
  /** fetch data from the table: "resource_tag_values" */
  resource_tag_values: Array<ResourceTagValues>;
  /** fetch data from the table: "resource_to_monitor_condition_type" */
  resource_to_monitor_condition_type: Array<ResourceToMonitorConditionType>;
  /** fetch data from the table: "resource_to_monitor_condition_type" using primary key columns */
  resource_to_monitor_condition_type_by_pk?: Maybe<ResourceToMonitorConditionType>;
  /** fetch data from the table: "resource_views" */
  resource_views: Array<ResourceViews>;
  /** fetch data from the table: "resource_views" using primary key columns */
  resource_views_by_pk?: Maybe<ResourceViews>;
  resourcesWithCanAction: ResourcesWithCanActionResult;
  /** An array relationship */
  retl_and_realtime_syncs: Array<RetlAndRealtimeSyncs>;
  /** An aggregate relationship */
  retl_and_realtime_syncs_aggregate: RetlAndRealtimeSyncsAggregate;
  /**
   * Live review agents, oldest first, each with its resolved skill. Omit
   * brandProfileId for every agent in the workspace.
   */
  reviewAgentsWithSkills: Array<ReviewAgent>;
  /** fetch data from the table: "review_agent_entities" */
  review_agent_entities: Array<ReviewAgentEntities>;
  /** fetch aggregated fields from the table: "review_agent_entities" */
  review_agent_entities_aggregate: ReviewAgentEntitiesAggregate;
  /** fetch data from the table: "review_agent_entities" using primary key columns */
  review_agent_entities_by_pk?: Maybe<ReviewAgentEntities>;
  /** fetch data from the table: "review_agents" */
  review_agents: Array<ReviewAgents>;
  /** fetch aggregated fields from the table: "review_agents" */
  review_agents_aggregate: ReviewAgentsAggregate;
  /** fetch data from the table: "review_agents" using primary key columns */
  review_agents_by_pk?: Maybe<ReviewAgents>;
  rowExportBackgroundResult: RowExportResponse;
  salesloftListCustomFields: SalesloftCustomFieldsResult;
  /** fetch data from the table: "sample_data_sources" */
  sample_data_sources: Array<SampleDataSources>;
  /** fetch data from the table: "sample_data_sources" using primary key columns */
  sample_data_sources_by_pk?: Maybe<SampleDataSources>;
  sampledModelAvailable: Scalars['Boolean'];
  /** An array relationship */
  sampled_segments: Array<SampledSegments>;
  /** An aggregate relationship */
  sampled_segments_aggregate: SampledSegmentsAggregate;
  /** fetch data from the table: "sampled_segments" using primary key columns */
  sampled_segments_by_pk?: Maybe<SampledSegments>;
  /** fetch data from the table: "saved_analytics_charts" */
  saved_analytics_charts: Array<SavedAnalyticsCharts>;
  /** fetch aggregated fields from the table: "saved_analytics_charts" */
  saved_analytics_charts_aggregate: SavedAnalyticsChartsAggregate;
  /** fetch data from the table: "saved_analytics_charts" using primary key columns */
  saved_analytics_charts_by_pk?: Maybe<SavedAnalyticsCharts>;
  /** fetch data from the table: "saved_analytics_charts_cohorts" */
  saved_analytics_charts_cohorts: Array<SavedAnalyticsChartsCohorts>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_cohorts" */
  saved_analytics_charts_cohorts_aggregate: SavedAnalyticsChartsCohortsAggregate;
  /** fetch data from the table: "saved_analytics_charts_cohorts" using primary key columns */
  saved_analytics_charts_cohorts_by_pk?: Maybe<SavedAnalyticsChartsCohorts>;
  /** fetch data from the table: "saved_analytics_charts_funnel_stages" */
  saved_analytics_charts_funnel_stages: Array<SavedAnalyticsChartsFunnelStages>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_funnel_stages" */
  saved_analytics_charts_funnel_stages_aggregate: SavedAnalyticsChartsFunnelStagesAggregate;
  /** fetch data from the table: "saved_analytics_charts_funnel_stages" using primary key columns */
  saved_analytics_charts_funnel_stages_by_pk?: Maybe<SavedAnalyticsChartsFunnelStages>;
  /** fetch data from the table: "saved_analytics_charts_goals" */
  saved_analytics_charts_goals: Array<SavedAnalyticsChartsGoals>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_goals" */
  saved_analytics_charts_goals_aggregate: SavedAnalyticsChartsGoalsAggregate;
  /** fetch data from the table: "saved_analytics_charts_goals" using primary key columns */
  saved_analytics_charts_goals_by_pk?: Maybe<SavedAnalyticsChartsGoals>;
  /** fetch data from the table: "saved_campaign_views" */
  saved_campaign_views: Array<SavedCampaignViews>;
  /** fetch aggregated fields from the table: "saved_campaign_views" */
  saved_campaign_views_aggregate: SavedCampaignViewsAggregate;
  /** fetch data from the table: "saved_campaign_views" using primary key columns */
  saved_campaign_views_by_pk?: Maybe<SavedCampaignViews>;
  /** fetch data from the table: "saved_campaign_views_goals" */
  saved_campaign_views_goals: Array<SavedCampaignViewsGoals>;
  /** fetch aggregated fields from the table: "saved_campaign_views_goals" */
  saved_campaign_views_goals_aggregate: SavedCampaignViewsGoalsAggregate;
  /** fetch data from the table: "saved_campaign_views_goals" using primary key columns */
  saved_campaign_views_goals_by_pk?: Maybe<SavedCampaignViewsGoals>;
  /** fetch data from the table: "saved_messages" */
  saved_messages: Array<SavedMessages>;
  /** fetch aggregated fields from the table: "saved_messages" */
  saved_messages_aggregate: SavedMessagesAggregate;
  /** fetch data from the table: "saved_queries" */
  saved_queries: Array<SavedQueries>;
  /** fetch data from the table: "saved_queries" using primary key columns */
  saved_queries_by_pk?: Maybe<SavedQueries>;
  /**
   * Recipients of this run whose handle contains the term, read live from the
   * warehouse rather than the cache. Both event tables are scanned in full
   * whatever the term is, since a contains-match cannot use an index; the term
   * bounds how many rows survive to be ranked, not how many are read. A term
   * shorter than four characters is rejected, because it narrows neither.
   */
  searchCampaignRecipients: CampaignRecipientSearchResult;
  /** Search asset collections using the same relevance ranking as the Ad Studio agent. Returns up to 100 results. */
  searchCatalogProducts: Array<CatalogProduct>;
  /**
   * Up to 100 members of the audience, or of the people who entered
   * `journeyTile`, or the one member with `primaryKeyValue`.
   */
  searchCepAudienceProfiles: CepAudienceProfileSearchResult;
  searchCepProfileRow: CepProfileSearchResult;
  /** Finds brands by name for the Add competitor typeahead. */
  searchCompetitorBrands: Array<CompetitorBrand>;
  searchContentImages: Array<SearchContentImagesResult>;
  searchLookerLooks?: Maybe<SearchLookerLooksOutput>;
  /**
   * Search the public Meta Ad Library for advertiser pages matching a company
   * name. Powers the ads-channel copy references wizard's page picker.
   */
  searchMetaAdLibraryCompanies: Array<MetaAdLibraryCompanyMatch>;
  /** fetch data from the table: "segment_references" */
  segment_references: Array<SegmentReferences>;
  /** fetch aggregated fields from the table: "segment_references" */
  segment_references_aggregate: SegmentReferencesAggregate;
  /** fetch data from the table: "segment_references" using primary key columns */
  segment_references_by_pk?: Maybe<SegmentReferences>;
  /** An array relationship */
  segments: Array<Segments>;
  /** An aggregate relationship */
  segments_aggregate: SegmentsAggregate;
  /** fetch data from the table: "segments" using primary key columns */
  segments_by_pk?: Maybe<Segments>;
  /**
   * The templates selected for one space individually. Hasura joins to this
   * field through the "selected_audience_templates" relationship on spaces;
   * every such field of one request is answered by one query.
   */
  selectedAudienceTemplatesForSpace: Array<SpaceAudienceTemplate>;
  /**
   * The templates selected for spaces individually. A space-scoped session
   * sees only its own space's selections.
   */
  selectedSpaceAudienceTemplates: Array<SpaceAudienceTemplate>;
  /** An array relationship */
  sent_resource_notifications: Array<SentResourceNotifications>;
  /** fetch data from the table: "sent_resource_notifications" using primary key columns */
  sent_resource_notifications_by_pk?: Maybe<SentResourceNotifications>;
  /** The context files the root agent read across a session, one row per file, most recently read first. */
  sessionContextFilesRead: Array<SessionContextFile>;
  sigmaQueryBackground: BackgroundJobResult;
  /** fetch data from the table: "sigma_credentials" */
  sigma_credentials: Array<SigmaCredentials>;
  /** fetch data from the table: "sigma_credentials" using primary key columns */
  sigma_credentials_by_pk?: Maybe<SigmaCredentials>;
  slackListChannels: SlackListChannelsSuccess;
  /** fetch data from the table: "slack_credentials" */
  slack_credentials: Array<SlackCredentials>;
  /** fetch data from the table: "slack_credentials" using primary key columns */
  slack_credentials_by_pk?: Maybe<SlackCredentials>;
  sourceCanActionGrants: CanActionGrants;
  sourceColumnDescriptions?: Maybe<Array<SourceColumnDescription>>;
  /** fetch data from the table: "source_share_mirror_databases" */
  source_share_mirror_databases: Array<SourceShareMirrorDatabases>;
  /** fetch data from the table: "source_share_mirror_databases" using primary key columns */
  source_share_mirror_databases_by_pk?: Maybe<SourceShareMirrorDatabases>;
  /** fetch data from the table: "source_share_mirrors" */
  source_share_mirrors: Array<SourceShareMirrors>;
  /** fetch data from the table: "source_share_mirrors" using primary key columns */
  source_share_mirrors_by_pk?: Maybe<SourceShareMirrors>;
  /**
   * The space-scoped refresh status of every space-scoped column on
   * modelId, one entry per column, scoped to the caller's current space.
   * Returns [] when the caller isn't in a space. A column reachable from
   * multiple parent models is collapsed to its most recently attempted
   * status row.
   */
  spaceScopedColumnsTopKStatus: Array<SpaceScopedColumnTopKStatus>;
  /** An array relationship */
  space_subset_grants: Array<SpaceSubsetGrants>;
  /** fetch data from the table: "space_subset_grants" using primary key columns */
  space_subset_grants_by_pk?: Maybe<SpaceSubsetGrants>;
  /** An array relationship */
  space_sync_templates: Array<SpaceSyncTemplates>;
  /** fetch data from the table: "space_sync_templates" using primary key columns */
  space_sync_templates_by_pk?: Maybe<SpaceSyncTemplates>;
  /** An array relationship */
  space_user_groups: Array<SpaceUserGroups>;
  /** fetch data from the table: "space_user_groups" using primary key columns */
  space_user_groups_by_pk?: Maybe<SpaceUserGroups>;
  /** fetch data from the table: "spaces" */
  spaces: Array<Spaces>;
  /** fetch data from the table: "spaces" using primary key columns */
  spaces_by_pk?: Maybe<Spaces>;
  ssoEnforcementImpact: SsoEnforcementImpact;
  /** An array relationship */
  sso_group_user_groups: Array<SsoGroupUserGroups>;
  /** fetch data from the table: "sso_group_user_groups" using primary key columns */
  sso_group_user_groups_by_pk?: Maybe<SsoGroupUserGroups>;
  /** An array relationship */
  sso_groups: Array<SsoGroups>;
  /** fetch data from the table: "sso_groups" using primary key columns */
  sso_groups_by_pk?: Maybe<SsoGroups>;
  /** An array relationship */
  sso_user_groups: Array<SsoUserGroups>;
  /** fetch data from the table: "sso_user_groups" using primary key columns */
  sso_user_groups_by_pk?: Maybe<SsoUserGroups>;
  startBackgroundDiscovery: StartBackgroundDiscovery;
  startPreviewQuerySchemaBackgroundJob: BackgroundJobResult;
  startTestSourceBackgroundJob: StartTestSourceBackgroundJob;
  staticListCsvFile: StaticListCsvFile;
  /**
   * Result of a snapshot refresh-preview job, keyed by the job id from
   * `enqueueStaticListRefreshPreview`. Null while the job is still running; a
   * `StaticListRefreshPreviewError` if the job failed or was cancelled;
   * otherwise the new size and the entered/exited membership diff.
   */
  staticListRefreshPreview?: Maybe<StaticListRefreshPreviewResponse>;
  /**
   * Paginated diagnostic preview of the CSV values that matched no parent-model
   * row, keyed by the materialize job id from
   * `enqueueStaticListCsvMaterialization`. Null while the job is still running;
   * a `StaticListUnmatchedResultError` if the job failed or was cancelled.
   */
  staticListUnmatchedResult?: Maybe<StaticListUnmatchedResultResponse>;
  /** fetch data from the table: "static_lists" */
  static_lists: Array<StaticLists>;
  /** fetch aggregated fields from the table: "static_lists" */
  static_lists_aggregate: StaticListsAggregate;
  /** fetch data from the table: "static_lists" using primary key columns */
  static_lists_by_pk?: Maybe<StaticLists>;
  styleEntities: Array<StyleEntity>;
  styleEntity?: Maybe<StyleEntity>;
  suggestFilterColumns: SuggestFilterColumnsResponse;
  suggestProjectCampaignIntake: SuggestProjectCampaignIntakeResponse;
  suggestProjectCampaignIntakeFromAsanaTask: SuggestCampaignIntakeFromAsanaTaskResponse;
  suggestTopicsForWorkspace: Array<SuggestedTopicsForCategory>;
  /** fetch data from the table: "support_access_grant" */
  support_access_grant: Array<SupportAccessGrant>;
  /** fetch data from the table: "support_access_grant" using primary key columns */
  support_access_grant_by_pk?: Maybe<SupportAccessGrant>;
  supportsAnalyticsIngestion: Scalars['Boolean'];
  supportsClearingAudience: Scalars['Boolean'];
  supportsDestinationMetadata?: Maybe<Scalars['Boolean']>;
  supportsMatchboosting: Scalars['Boolean'];
  syncCanActionGrants: CanActionGrants;
  syncClearAndFillHoldHours?: Maybe<Scalars['Int']>;
  syncFilterOptions: SyncFilterOptions;
  syncSupportsClearingAudience: Scalars['Boolean'];
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  /** fetch data from the table: "sync_attempts" using primary key columns */
  sync_attempts_by_pk?: Maybe<SyncAttempts>;
  /** fetch data from the table: "sync_idr_schedules" */
  sync_idr_schedules: Array<SyncIdrSchedules>;
  /** fetch aggregated fields from the table: "sync_idr_schedules" */
  sync_idr_schedules_aggregate: SyncIdrSchedulesAggregate;
  /** fetch data from the table: "sync_idr_schedules" using primary key columns */
  sync_idr_schedules_by_pk?: Maybe<SyncIdrSchedules>;
  /** fetch data from the table: "sync_request_computed_progress" */
  sync_request_computed_progress: Array<SyncRequestComputedProgress>;
  /** fetch data from the table: "sync_request_diffs" */
  sync_request_diffs: Array<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_diffs" using primary key columns */
  sync_request_diffs_by_pk?: Maybe<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_event_spans" */
  sync_request_event_spans: Array<SyncRequestEventSpans>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** fetch data from the table: "sync_requests" using primary key columns */
  sync_requests_by_pk?: Maybe<SyncRequests>;
  /** An array relationship */
  sync_sequence_members: Array<SyncSequenceMembers>;
  /** fetch data from the table: "sync_sequence_members" using primary key columns */
  sync_sequence_members_by_pk?: Maybe<SyncSequenceMembers>;
  /** An array relationship */
  sync_sequence_requests: Array<SyncSequenceRequests>;
  /** fetch data from the table: "sync_sequence_requests" using primary key columns */
  sync_sequence_requests_by_pk?: Maybe<SyncSequenceRequests>;
  /** fetch data from the table: "sync_sequence_runs" */
  sync_sequence_runs: Array<SyncSequenceRuns>;
  /** fetch aggregated fields from the table: "sync_sequence_runs" */
  sync_sequence_runs_aggregate: SyncSequenceRunsAggregate;
  /** fetch data from the table: "sync_sequence_runs" using primary key columns */
  sync_sequence_runs_by_pk?: Maybe<SyncSequenceRuns>;
  /** fetch data from the table: "sync_sequences" */
  sync_sequences: Array<SyncSequences>;
  /** fetch aggregated fields from the table: "sync_sequences" */
  sync_sequences_aggregate: SyncSequencesAggregate;
  /** fetch data from the table: "sync_sequences" using primary key columns */
  sync_sequences_by_pk?: Maybe<SyncSequences>;
  /** An array relationship */
  sync_templates: Array<SyncTemplates>;
  /** An aggregate relationship */
  sync_templates_aggregate: SyncTemplatesAggregate;
  /** fetch data from the table: "sync_templates" using primary key columns */
  sync_templates_by_pk?: Maybe<SyncTemplates>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  /** fetch data from the table: "syncs_to_journeys" */
  syncs_to_journeys: Array<SyncsToJourneys>;
  tableQueryBackground: BackgroundJobResult;
  tableauListViews?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  tableauListWorkbooks?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  /**
   * The tasks whose review waits on the viewer, as the inbox's needsYou reads
   * them.
   */
  tasksAwaitingMyReview: Array<Scalars['ID']>;
  testAuthentication: Scalars['String'];
  testDbtCloudCredential: Scalars['Boolean'];
  testFivetranWebhook: TestFivetranWebhookResult;
  testLookerExtension: Scalars['Boolean'];
  testNewWorkspaceNotificationChannel?: Maybe<WorkspaceNotificationChannelTest>;
  testSigmaExtension: SigmaExtensionOrError;
  testSource: TestSourceResult;
  testSourceBackgroundJobResult: TestSourceBackgroundJobResult;
  testStorageConnection?: Maybe<Scalars['Boolean']>;
  testStorageConnectionV2: TestConnectionResult;
  testStorageFailoverBuckets: TestFailoverBucketsResult;
  testSyncConfiguration: TestSyncConfigurationResult;
  testSyncConfigurationSupported: Scalars['Boolean'];
  testWorkspaceNotificationChannel?: Maybe<WorkspaceNotificationChannelTest>;
  /** fetch data from the table: "through_model_relationships" */
  through_model_relationships: Array<ThroughModelRelationships>;
  /** fetch data from the table: "through_model_relationships" using primary key columns */
  through_model_relationships_by_pk?: Maybe<ThroughModelRelationships>;
  topKForQuery: TopKColumnResponse;
  topKForTrait: TopKTraitResponse;
  /**
   * An estimate of how much extra top-k sync load turning on space-scoped
   * suggestions for a column could add: a space-scoped column computes a
   * separate set of suggestions per space per parent model it's reachable
   * from, instead of one shared set for the whole workspace, so the added
   * load scales with spacesCount * parentModelsCount. Used to warn in the
   * UI before a user opts a column in.
   */
  topKSpaceScopingLoadEstimate: TopKSpaceScopingLoadEstimate;
  /** fetch data from the table: "top_k_trait_status" */
  top_k_trait_status: Array<TopKTraitStatus>;
  /** fetch data from the table: "top_k_trait_status" using primary key columns */
  top_k_trait_status_by_pk?: Maybe<TopKTraitStatus>;
  /** fetch data from the table: "tracked_audience_list_audiences" */
  tracked_audience_list_audiences: Array<TrackedAudienceListAudiences>;
  /** fetch data from the table: "tracked_audience_list_audiences" using primary key columns */
  tracked_audience_list_audiences_by_pk?: Maybe<TrackedAudienceListAudiences>;
  /** fetch data from the table: "tracked_audience_lists" */
  tracked_audience_lists: Array<TrackedAudienceLists>;
  /** fetch aggregated fields from the table: "tracked_audience_lists" */
  tracked_audience_lists_aggregate: TrackedAudienceListsAggregate;
  /** fetch data from the table: "tracked_audience_lists" using primary key columns */
  tracked_audience_lists_by_pk?: Maybe<TrackedAudienceLists>;
  traitDefinition?: Maybe<TraitDefinition>;
  /**
   * Target field for the segments -> traits Hasura remote relationship
   * (added in a follow-up metadata change); also callable directly.
   */
  traitDefinitionsForSegment: Array<TraitDefinition>;
  /** fetch data from the table: "trait_definitions" */
  trait_definitions: Array<TraitDefinitions>;
  /** fetch aggregated fields from the table: "trait_definitions" */
  trait_definitions_aggregate: TraitDefinitionsAggregate;
  /** fetch data from the table: "trait_definitions" using primary key columns */
  trait_definitions_by_pk?: Maybe<TraitDefinitions>;
  /** fetch data from the table: "trait_references" */
  trait_references: Array<TraitReferences>;
  /** fetch aggregated fields from the table: "trait_references" */
  trait_references_aggregate: TraitReferencesAggregate;
  /** fetch data from the table: "trait_references" using primary key columns */
  trait_references_by_pk?: Maybe<TraitReferences>;
  /** fetch data from the table: "trait_references_segments" */
  trait_references_segments: Array<TraitReferencesSegments>;
  /** fetch aggregated fields from the table: "trait_references_segments" */
  trait_references_segments_aggregate: TraitReferencesSegmentsAggregate;
  /** fetch data from the table: "tunnels" */
  tunnels: Array<Tunnels>;
  /** fetch data from the table: "tunnels" using primary key columns */
  tunnels_by_pk?: Maybe<Tunnels>;
  /**
   * How many ad comments the caller hasn't caught up on, for a notification badge.
   * Excludes their own comments and anything written before they joined.
   *
   * limit is the cap the tally stops at, 1 to 999, defaulting to 99.
   */
  unreadAssetCommentCount: UnreadAssetCommentCount;
  updateBlocklistJobResult: UpdateBlocklistJobResult;
  /** An array relationship */
  user_group_audience_creation_authorization: Array<UserGroupAudienceCreationAuthorization>;
  /** fetch data from the table: "user_group_grants" */
  user_group_grants: Array<UserGroupGrants>;
  /** fetch aggregated fields from the table: "user_group_grants" */
  user_group_grants_aggregate: UserGroupGrantsAggregate;
  /** fetch data from the table: "user_group_grants" using primary key columns */
  user_group_grants_by_pk?: Maybe<UserGroupGrants>;
  /** An array relationship */
  user_group_members: Array<UserGroupMembers>;
  /** fetch data from the table: "user_group_members" using primary key columns */
  user_group_members_by_pk?: Maybe<UserGroupMembers>;
  /** An array relationship */
  user_group_model_authorization: Array<UserGroupModelAuthorization>;
  /** fetch data from the table: "user_group_model_creation_authorization" */
  user_group_model_creation_authorization: Array<UserGroupModelCreationAuthorization>;
  /** An array relationship */
  user_group_source_grants: Array<UserGroupSourceGrants>;
  /** An array relationship */
  user_group_subset_authorization: Array<UserGroupSubsetAuthorization>;
  /** An array relationship */
  user_group_subset_grants: Array<UserGroupSubsetGrants>;
  /** An aggregate relationship */
  user_group_subset_grants_aggregate: UserGroupSubsetGrantsAggregate;
  /** fetch data from the table: "user_group_subset_grants" using primary key columns */
  user_group_subset_grants_by_pk?: Maybe<UserGroupSubsetGrants>;
  /** fetch data from the table: "user_group_sync_creation_authorization" */
  user_group_sync_creation_authorization: Array<UserGroupSyncCreationAuthorization>;
  /** An array relationship */
  user_group_trait_authorization: Array<UserGroupTraitAuthorization>;
  /** An array relationship */
  user_group_workspaces: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  user_group_workspaces_aggregate: UserGroupWorkspacesAggregate;
  /** fetch data from the table: "user_group_workspaces" using primary key columns */
  user_group_workspaces_by_pk?: Maybe<UserGroupWorkspaces>;
  /** An array relationship */
  user_groups: Array<UserGroups>;
  /** An aggregate relationship */
  user_groups_aggregate: UserGroupsAggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  user_groups_by_pk?: Maybe<UserGroups>;
  validateDecisionEngineConfig: DecisionEngineResult;
  validateInAppMessageContent: ValidateInAppMessageContentResult;
  validatePredictorFeatureDefinition: ValidatePredictorFeatureDefinitionResult;
  verifyManifestFiles: Array<ManifestFileVerification>;
  /** An array relationship */
  video_exports: Array<VideoExports>;
  /** An aggregate relationship */
  video_exports_aggregate: VideoExportsAggregate;
  /** fetch data from the table: "video_exports" using primary key columns */
  video_exports_by_pk?: Maybe<VideoExports>;
  visualQueryBackground: BackgroundJobResult;
  visualQueryBackgroundResult?: Maybe<QueryResponse>;
  visualQuerySQL: VisualQuerySqlResult;
  warehouseEventsTimelineBackground: ProfileExplorerJob;
  warehouseEventsTimelineBackgroundResult?: Maybe<WarehouseEventsTimelineBackgroundResult>;
  warehouseExportDisabledSyncCount: Scalars['Int'];
  /** Databases/catalogs the source's credential can see (for the picker). */
  warehouseShareAvailableDatabases: WarehouseShareAvailableDatabases;
  /** Whether this source can use zero-copy sharing, without exposing warehouse configuration. */
  warehouseShareEligibility: WarehouseShareEligibility;
  /** Current zero-copy mirror for a source, or null if none exists. */
  warehouseShareMirror?: Maybe<WarehouseShareMirror>;
  /** Poll result for startWarehouseShareSetupBackgroundJob. */
  warehouseShareSetupBackgroundJobResult: WarehouseShareSetupBackgroundJobResult;
  /** fetch data from the table: "warehouse_snapshots" */
  warehouse_snapshots: Array<WarehouseSnapshots>;
  /** fetch data from the table: "warehouse_snapshots" using primary key columns */
  warehouse_snapshots_by_pk?: Maybe<WarehouseSnapshots>;
  webPagePsdExportRun?: Maybe<WebPagePsdExportRun>;
  /** The number a test send of this template comes from. */
  whatsAppTestSender: WhatsAppTestSenderResult;
  /** The numbers a test send of this template can come from, the default first. */
  whatsAppTestSenders: WhatsAppTestSendersResult;
  workspaceCanActionGrants: CanActionGrants;
  /** An array relationship */
  workspace_members: Array<WorkspaceMembers>;
  /** An aggregate relationship */
  workspace_members_aggregate: WorkspaceMembersAggregate;
  /** fetch data from the table: "workspace_notification_channels" */
  workspace_notification_channels: Array<WorkspaceNotificationChannels>;
  /** fetch data from the table: "workspace_notification_channels" using primary key columns */
  workspace_notification_channels_by_pk?: Maybe<WorkspaceNotificationChannels>;
  /** fetch data from the table: "workspace_overage_dates" */
  workspace_overage_dates: Array<WorkspaceOverageDates>;
  /** An array relationship */
  workspaces: Array<Workspaces>;
  /** fetch data from the table: "workspaces" using primary key columns */
  workspaces_by_pk?: Maybe<Workspaces>;
  zendeskListCustomFields: ZendeskListCustomFieldsResult;
  zendeskListCustomObjectProperties: ZendeskListCustomObjectPropertiesResult;
  zendeskListCustomObjectTypes: ZendeskListCustomObjectTypesResult;
};


export type QueryValidateDatadogCredentialsArgs = {
  input: ValidateDatadogCredentialsInput;
};


export type QueryActionPlanFilesArgs = {
  input: ActionPlanFilesInput;
};


export type QueryActiveCampaignDescribeObjectArgs = {
  input: ActiveCampaignDescribeObjectInput;
};


export type QueryActivityArgs = {
  limit: Scalars['Int'];
  projectId?: InputMaybe<Scalars['uuid']>;
  taskId?: InputMaybe<Scalars['uuid']>;
};


export type QueryAdInsightsCreativeMediaArgs = {
  adId: Scalars['String'];
  fivetranSyncId: Scalars['String'];
};


export type QueryAdInsightsCreativeTagsArgs = {
  adId: Scalars['String'];
  fivetranSyncId: Scalars['String'];
};


export type QueryAdInsightsCubeQueryArgs = {
  query: Scalars['JSON'];
};


export type QueryAdLaunchProgressArgs = {
  input: AdLaunchProgressInput;
};


export type QueryAdReferenceOriginsArgs = {
  adBriefAssetId: Scalars['uuid'];
};


export type QueryAdStudioAccountsArgs = {
  fivetranSyncId: Scalars['String'];
};


export type QueryAdStudioCatalogBrandProfileIdArgs = {
  assetGroupId: Scalars['String'];
};


export type QueryAdStudioCatalogTagSchemaArgs = {
  assetGroupId: Scalars['String'];
};


export type QueryAdStudioCompetitorArgs = {
  id: Scalars['ID'];
};


export type QueryAdStudioEnrichedProductOutputsArgs = {
  feedId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAdStudioEnrichmentRunsArgs = {
  feedId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAdStudioFeedEnrichmentSummaryArgs = {
  feedId: Scalars['ID'];
};


export type QueryAdStudioFeedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  treatmentId: Scalars['ID'];
};


export type QueryAdStudioPreviewFeedProductsArgs = {
  feedId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  segmentFilters?: InputMaybe<Scalars['JSON']>;
};


export type QueryAdStudioPreviewImageUrlsArgs = {
  treatmentId: Scalars['ID'];
};


export type QueryAdStudioProductFeedThumbnailsArgs = {
  feedId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAdAgentArtifactsArgs = {
  distinct_on?: InputMaybe<Array<AdAgentArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAgentArtifactsOrderBy>>;
  where?: InputMaybe<AdAgentArtifactsBoolExp>;
};


export type QueryAdAgentArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdAssetFavoritesArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


export type QueryAdAssetFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


export type QueryAdAssetFavoritesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefAssetLaunchQueueArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchQueueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchQueueOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};


export type QueryAdBriefAssetLaunchQueueAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchQueueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchQueueOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};


export type QueryAdBriefAssetLaunchQueueByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefAssetLaunchesArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchesOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};


export type QueryAdBriefAssetLaunchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchesOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};


export type QueryAdBriefAssetLaunchesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefAssetSizeVariantsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


export type QueryAdBriefAssetSizeVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


export type QueryAdBriefAssetSizeVariantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefAssetVersionsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


export type QueryAdBriefAssetVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


export type QueryAdBriefAssetVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefAssetsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


export type QueryAdBriefAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


export type QueryAdBriefAssetsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdBriefsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


export type QueryAdBriefsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


export type QueryAdBriefsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdExportChannelSizesArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


export type QueryAdExportChannelSizesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


export type QueryAdExportChannelSizesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdExportChannelsArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelsOrderBy>>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};


export type QueryAdExportChannelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelsOrderBy>>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};


export type QueryAdExportChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdGenerationPipelineRunsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


export type QueryAdGenerationPipelineRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


export type QueryAdGenerationPipelineRunsByPkArgs = {
  job_id: Scalars['uuid'];
};


export type QueryAdGenerationWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationWorkflowsOrderBy>>;
  where?: InputMaybe<AdGenerationWorkflowsBoolExp>;
};


export type QueryAdGenerationWorkflowsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationWorkflowsOrderBy>>;
  where?: InputMaybe<AdGenerationWorkflowsBoolExp>;
};


export type QueryAdGenerationWorkflowsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStatsModelsArgs = {
  distinct_on?: InputMaybe<Array<AdStatsModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStatsModelsOrderBy>>;
  where?: InputMaybe<AdStatsModelsBoolExp>;
};


export type QueryAdStatsModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryAdStudioProductFeedsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProductFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProductFeedsOrderBy>>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};


export type QueryAdStudioProductFeedsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProductFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProductFeedsOrderBy>>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};


export type QueryAdStudioProductFeedsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStudioProjectBriefVersionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectBriefVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectBriefVersionsOrderBy>>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};


export type QueryAdStudioProjectBriefVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectBriefVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectBriefVersionsOrderBy>>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};


export type QueryAdStudioProjectBriefVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStudioProjectPinsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


export type QueryAdStudioProjectPinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


export type QueryAdStudioProjectPinsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStudioProjectsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


export type QueryAdStudioProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


export type QueryAdStudioProjectsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStudioSessionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


export type QueryAdStudioSessionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


export type QueryAdStudioSessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdStudioTreatmentsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


export type QueryAdStudioTreatmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


export type QueryAdStudioTreatmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdminEntitlementStatusArgs = {
  input: AdminEntitlementStatusInput;
};


export type QueryAdminFragmentArgs = {
  input: AdminFragmentInput;
};


export type QueryAdminEntitlementsArgs = {
  distinct_on?: InputMaybe<Array<AdminEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminEntitlementsOrderBy>>;
  where?: InputMaybe<AdminEntitlementsBoolExp>;
};


export type QueryAdminEntitlementsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAdminWorkspaceEntitlementsArgs = {
  distinct_on?: InputMaybe<Array<AdminWorkspaceEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminWorkspaceEntitlementsOrderBy>>;
  where?: InputMaybe<AdminWorkspaceEntitlementsBoolExp>;
};


export type QueryAdsForInspirationBoardArgs = {
  boardId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAeoSitesWithLastRunArgs = {
  order_by?: InputMaybe<AiChannelSiteOrderBy>;
};


export type QueryAgentDefinitionArgs = {
  id: Scalars['uuid'];
};


export type QueryAgentDefinitionSessionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  id: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAgentDefinitionVersionsArgs = {
  ids: Array<Scalars['uuid']>;
};


export type QueryAgentDefinitionsArgs = {
  ids?: InputMaybe<Array<Scalars['uuid']>>;
};


export type QueryAgentSessionMessagesArgs = {
  devMode?: InputMaybe<Scalars['Boolean']>;
  sessionId: Scalars['uuid'];
};


export type QueryAgentAssetVersionsArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


export type QueryAgentAssetVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


export type QueryAgentAssetVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgentAssetsArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetsOrderBy>>;
  where?: InputMaybe<AgentAssetsBoolExp>;
};


export type QueryAgentAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetsOrderBy>>;
  where?: InputMaybe<AgentAssetsBoolExp>;
};


export type QueryAgentAssetsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgentReportSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgentReportSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentReportSuggestionsOrderBy>>;
  where?: InputMaybe<AgentReportSuggestionsBoolExp>;
};


export type QueryAgentReportSuggestionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgentSuggestionBatchesArgs = {
  distinct_on?: InputMaybe<Array<AgentSuggestionBatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentSuggestionBatchesOrderBy>>;
  where?: InputMaybe<AgentSuggestionBatchesBoolExp>;
};


export type QueryAgentSuggestionBatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgentSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgentSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentSuggestionsOrderBy>>;
  where?: InputMaybe<AgentSuggestionsBoolExp>;
};


export type QueryAgentSuggestionsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type QueryAgenticSettingsEntityUsageArgs = {
  entityIds: Array<Scalars['uuid']>;
  windowDays?: InputMaybe<Scalars['Int']>;
};


export type QueryAgenticSettingsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsOrderBy>>;
  where?: InputMaybe<AgenticSettingsBoolExp>;
};


export type QueryAgenticSettingsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type QueryAgenticSettingsEntitiesLinksArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntitiesLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntitiesLinksOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
};


export type QueryAgenticSettingsEntitiesLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgenticSettingsEntityReviewSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


export type QueryAgenticSettingsEntityReviewSuggestionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


export type QueryAgenticSettingsEntityReviewSuggestionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAgenticSettingsEntityReviewsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewsBoolExp>;
};


export type QueryAgenticSettingsEntityReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAirBoardTreeArgs = {
  extensionId: Scalars['String'];
  parentBoardId?: InputMaybe<Scalars['String']>;
};


export type QueryAirbyteSyncsArgs = {
  distinct_on?: InputMaybe<Array<AirbyteSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirbyteSyncsOrderBy>>;
  where?: InputMaybe<AirbyteSyncsBoolExp>;
};


export type QueryAirbyteSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAirtableGetBasesArgs = {
  input: AirtableGetBasesInput;
};


export type QueryAirtableGetTablesMetaArgs = {
  input: AirtableGetTablesMetaInput;
};


export type QueryAirtableListBasesArgs = {
  connectionId: Scalars['String'];
};


export type QueryAirtableListTablesArgs = {
  baseId: Scalars['String'];
  connectionId: Scalars['String'];
};


export type QueryAlertInstancesArgs = {
  distinct_on?: InputMaybe<Array<AlertInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertInstancesOrderBy>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


export type QueryAlertStatusesArgs = {
  distinct_on?: InputMaybe<Array<AlertStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertStatusesOrderBy>>;
  where?: InputMaybe<AlertStatusesBoolExp>;
};


export type QueryAlertStatusesByPkArgs = {
  alert_id: Scalars['bigint'];
  destination_instance_id: Scalars['bigint'];
};


export type QueryAlertsArgs = {
  distinct_on?: InputMaybe<Array<AlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertsOrderBy>>;
  where?: InputMaybe<AlertsBoolExp>;
};


export type QueryAlertsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryAllMembershipsV2Args = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


export type QueryAllMembershipsV2AggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


export type QueryAmpAgentArgs = {
  agentId: Scalars['uuid'];
};


export type QueryAmpAgentMessagesArgs = {
  agentId: Scalars['uuid'];
};


export type QueryAmpBoardActivityArgs = {
  limit: Scalars['Int'];
  projectId?: InputMaybe<Scalars['uuid']>;
  taskId?: InputMaybe<Scalars['uuid']>;
};


export type QueryAmpCanvasArgs = {
  id: Scalars['ID'];
};


export type QueryAmpCanvasStampArgs = {
  id: Scalars['ID'];
};


export type QueryAmpEmailImageKeysArgs = {
  urls: Array<Scalars['String']>;
};


export type QueryAmpFileArgs = {
  id: Scalars['ID'];
};


export type QueryAmpFileAtVersionArgs = {
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type QueryAmpFileStampsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryAmpFileUsageArgs = {
  id: Scalars['ID'];
};


export type QueryAmpFileVersionsArgs = {
  id: Scalars['ID'];
};


export type QueryAmpInboxArgs = {
  filters?: InputMaybe<AmpInboxFiltersInput>;
  updatesLimit: Scalars['Int'];
};


export type QueryAmpLibraryCountsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAmpTaskMonitorsArgs = {
  taskId: Scalars['ID'];
};


export type QueryAmpActionCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


export type QueryAmpActionCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


export type QueryAmpActionCallsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpActionPlanVersionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


export type QueryAmpActionPlanVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


export type QueryAmpActionPlanVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpActionPlansArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


export type QueryAmpActionPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


export type QueryAmpActionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpActionToolCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


export type QueryAmpActionToolCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


export type QueryAmpActionToolCallsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpActionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


export type QueryAmpActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


export type QueryAmpActionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpAssetGroupsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetGroupsOrderBy>>;
  where?: InputMaybe<AmpAssetGroupsBoolExp>;
};


export type QueryAmpAssetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetGroupsOrderBy>>;
  where?: InputMaybe<AmpAssetGroupsBoolExp>;
};


export type QueryAmpAssetGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpAssetRatingsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


export type QueryAmpAssetRatingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


export type QueryAmpAssetRatingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpAssetSourcesArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSourcesOrderBy>>;
  where?: InputMaybe<AmpAssetSourcesBoolExp>;
};


export type QueryAmpAssetSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSourcesOrderBy>>;
  where?: InputMaybe<AmpAssetSourcesBoolExp>;
};


export type QueryAmpAssetSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpAssetSyncRunsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


export type QueryAmpAssetSyncRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


export type QueryAmpAssetSyncRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpAssetSyncsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


export type QueryAmpAssetSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


export type QueryAmpAssetSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpCreativeClassificationRunsArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeClassificationRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeClassificationRunsOrderBy>>;
  where?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
};


export type QueryAmpCreativeClassificationRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeClassificationRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeClassificationRunsOrderBy>>;
  where?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
};


export type QueryAmpCreativeClassificationRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpCreativeDimensionValuesArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionValuesOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
};


export type QueryAmpCreativeDimensionValuesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpCreativeDimensionsArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionsOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};


export type QueryAmpCreativeDimensionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionsOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};


export type QueryAmpCreativeDimensionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpFileFavoritesArgs = {
  distinct_on?: InputMaybe<Array<AmpFileFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFileFavoritesOrderBy>>;
  where?: InputMaybe<AmpFileFavoritesBoolExp>;
};


export type QueryAmpFileFavoritesByPkArgs = {
  amp_file_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type QueryAmpFilesArgs = {
  distinct_on?: InputMaybe<Array<AmpFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFilesOrderBy>>;
  where?: InputMaybe<AmpFilesBoolExp>;
};


export type QueryAmpFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFilesOrderBy>>;
  where?: InputMaybe<AmpFilesBoolExp>;
};


export type QueryAmpFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpFollowedSourcesArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedSourcesOrderBy>>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};


export type QueryAmpFollowedSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedSourcesOrderBy>>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};


export type QueryAmpFollowedSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpFollowedTopicsArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedTopicsOrderBy>>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};


export type QueryAmpFollowedTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedTopicsOrderBy>>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};


export type QueryAmpFollowedTopicsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpLaunchVerdictsArgs = {
  distinct_on?: InputMaybe<Array<AmpLaunchVerdictsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpLaunchVerdictsOrderBy>>;
  where?: InputMaybe<AmpLaunchVerdictsBoolExp>;
};


export type QueryAmpLaunchVerdictsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


export type QueryAmpOpportunitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


export type QueryAmpOpportunitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpProjectLinksArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


export type QueryAmpProjectLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


export type QueryAmpProjectLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpProjectPinsArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectPinsOrderBy>>;
  where?: InputMaybe<AmpProjectPinsBoolExp>;
};


export type QueryAmpProjectPinsByPkArgs = {
  amp_project_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type QueryAmpProjectUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


export type QueryAmpProjectUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


export type QueryAmpProjectUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpProjectsArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


export type QueryAmpProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


export type QueryAmpProjectsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpSignalsArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


export type QueryAmpSignalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


export type QueryAmpSignalsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTagsOrderBy>>;
  where?: InputMaybe<AmpTagsBoolExp>;
};


export type QueryAmpTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTagsOrderBy>>;
  where?: InputMaybe<AmpTagsBoolExp>;
};


export type QueryAmpTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTaskRelationsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


export type QueryAmpTaskRelationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


export type QueryAmpTaskRelationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTaskReviewsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


export type QueryAmpTaskReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


export type QueryAmpTaskReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTaskTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


export type QueryAmpTaskTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


export type QueryAmpTaskTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTaskUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


export type QueryAmpTaskUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


export type QueryAmpTaskUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


export type QueryAmpTasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


export type QueryAmpTasksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTeamMembersArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


export type QueryAmpTeamMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


export type QueryAmpTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpTeamsArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamsOrderBy>>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};


export type QueryAmpTeamsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamsOrderBy>>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};


export type QueryAmpTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpWorkflowStatusReviewersArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


export type QueryAmpWorkflowStatusReviewersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


export type QueryAmpWorkflowStatusReviewersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpWorkflowStatusesArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


export type QueryAmpWorkflowStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


export type QueryAmpWorkflowStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAmpWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowsOrderBy>>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};


export type QueryAmpWorkflowsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowsOrderBy>>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};


export type QueryAmpWorkflowsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAnalyticsIngestionStatsArgs = {
  distinct_on?: InputMaybe<Array<AnalyticsIngestionStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalyticsIngestionStatsOrderBy>>;
  where?: InputMaybe<AnalyticsIngestionStatsBoolExp>;
};


export type QueryAnalyticsIngestionStatsByPkArgs = {
  uuid: Scalars['uuid'];
};


export type QueryAnalyticsReportsArgs = {
  distinct_on?: InputMaybe<Array<AnalyticsReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalyticsReportsOrderBy>>;
  where?: InputMaybe<AnalyticsReportsBoolExp>;
};


export type QueryAnalyticsReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAnalyzeDecisionEngineTagsForMessageArgs = {
  messageId: Scalars['String'];
  tags: Scalars['JSONObject'];
};


export type QueryAnalyzeEntryEventDistributionArgs = {
  input: AnalyzeEntryEventDistributionInput;
};


export type QueryAnalyzeMessagePreviewArgs = {
  input: AnalyzeMessagePreviewInput;
};


export type QueryApiKeysArgs = {
  distinct_on?: InputMaybe<Array<ApiKeysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApiKeysOrderBy>>;
  where?: InputMaybe<ApiKeysBoolExp>;
};


export type QueryApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryAprimoClassificationArgs = {
  classificationId: Scalars['String'];
  extensionId: Scalars['String'];
};


export type QueryAprimoClassificationTreeArgs = {
  extensionId: Scalars['String'];
  parentClassificationId?: InputMaybe<Scalars['String']>;
};


export type QueryAprimoMetadataFieldOptionsArgs = {
  input?: InputMaybe<AprimoMetadataFieldOptionsInput>;
};


export type QueryArtifactFavoritesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


export type QueryArtifactFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


export type QueryArtifactFavoritesByPkArgs = {
  campaign_artifact_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type QueryArtifactReviewCommentsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


export type QueryArtifactReviewCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


export type QueryArtifactReviewCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryArtifactReviewStatusesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


export type QueryArtifactReviewStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


export type QueryArtifactReviewStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryArtifactReviewersArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewersOrderBy>>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};


export type QueryArtifactReviewersAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewersOrderBy>>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};


export type QueryArtifactReviewersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryArtifactReviewsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


export type QueryArtifactReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


export type QueryArtifactReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAsanaAssignableUsersArgs = {
  campaignId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAsanaAttachStatusArgs = {
  jobId: Scalars['ID'];
};


export type QueryAsanaProjectSectionsArgs = {
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
  projectGid: Scalars['ID'];
};


export type QueryAsanaProjectsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAsanaTaskActivityArgs = {
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
};


export type QueryAsanaTaskDetailArgs = {
  ancestorGids?: InputMaybe<Array<Scalars['ID']>>;
  campaignId: Scalars['ID'];
};


export type QueryAssetCommentFeedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: AssetCommentFeedFilter;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetCommentMentionsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


export type QueryAssetCommentMentionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


export type QueryAssetCommentMentionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssetCommentStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


export type QueryAssetCommentStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


export type QueryAssetCommentStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssetCommentThreadReadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadReadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadReadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadReadsBoolExp>;
};


export type QueryAssetCommentThreadReadsByPkArgs = {
  asset_comment_thread_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QueryAssetCommentThreadStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


export type QueryAssetCommentThreadStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


export type QueryAssetCommentThreadStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssetCommentThreadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


export type QueryAssetCommentThreadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


export type QueryAssetCommentThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssetCommentsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


export type QueryAssetCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


export type QueryAssetCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssetModelsArgs = {
  distinct_on?: InputMaybe<Array<AssetModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetModelsOrderBy>>;
  where?: InputMaybe<AssetModelsBoolExp>;
};


export type QueryAssetModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryAssetStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


export type QueryAssetStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


export type QueryAssetStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAssignableUserGroupsArgs = {
  connectionId: Scalars['Int'];
};


export type QueryAthenaListDataCatalogsArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListDataCatalogsNewSourceArgs = {
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListDatabasesArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
  region: Scalars['String'];
};


export type QueryAthenaListDatabasesNewSourceArgs = {
  credentials: AthenaCredentials;
  dataCatalog: Scalars['String'];
  region: Scalars['String'];
};


export type QueryAthenaListWorkGroupsArgs = {
  connectionId: Scalars['Int'];
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAthenaListWorkGroupsNewSourceArgs = {
  credentials: AthenaCredentials;
  region: Scalars['String'];
};


export type QueryAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


export type QueryAttributionMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


export type QueryAttributionMethodsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAttributionMethodsInteractionsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsInteractionsOrderBy>>;
  where?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
};


export type QueryAttributionMethodsInteractionsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  interaction_model_id: Scalars['bigint'];
};


export type QueryAudienceComparisonArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  compareToAudiences: Array<Scalars['String']>;
  connectionId: Scalars['String'];
  destinationId?: InputMaybe<Scalars['String']>;
  filter: Scalars['JSONObject'];
  parentModelId: Scalars['String'];
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryAudienceComparisonBackgroundArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  compareToAudiences: Array<Scalars['String']>;
  connectionId: Scalars['String'];
  destinationId?: InputMaybe<Scalars['String']>;
  filter: Scalars['JSONObject'];
  parentModelId: Scalars['String'];
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAudienceComparisonBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryAudienceMembershipsBackgroundArgs = {
  includePastMemberships?: InputMaybe<Scalars['Boolean']>;
  parentModelId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type QueryAudienceMembershipsBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryAudienceReferenceStatsArgs = {
  parentModelId: Scalars['bigint'];
};


export type QueryAudienceSnapshotAtLastPullArgs = {
  afterTimestamp: Scalars['String'];
  audienceId: Scalars['String'];
};


export type QueryAudienceGoalsArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


export type QueryAudienceGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


export type QueryAudienceGoalsByPkArgs = {
  goal_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};


export type QueryAudienceOverviewsArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


export type QueryAudienceOverviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


export type QueryAudienceOverviewsByPkArgs = {
  audience_id: Scalars['bigint'];
};


export type QueryAudiencePrimaryMetricsArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


export type QueryAudiencePrimaryMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


export type QueryAudiencePrimaryMetricsByPkArgs = {
  audience_id: Scalars['bigint'];
  metric_id: Scalars['uuid'];
};


export type QueryAudienceSplitsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


export type QueryAudienceSplitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


export type QueryAudienceSplitsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAudienceSubsetGroupRequiredModelsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


export type QueryAudienceSubsetGroupRequiredModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


export type QueryAudienceSubsetGroupRequiredModelsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_group_id: Scalars['uuid'];
};


export type QueryAudienceSubsetGroupsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};


export type QueryAudienceSubsetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};


export type QueryAudienceSubsetGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAudienceSubsetValueScopedConditionsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValueScopedConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValueScopedConditionsOrderBy>>;
  where?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
};


export type QueryAudienceSubsetValueScopedConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValueScopedConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValueScopedConditionsOrderBy>>;
  where?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
};


export type QueryAudienceSubsetValueScopedConditionsByPkArgs = {
  ordinal: Scalars['smallint'];
  subset_value_id: Scalars['uuid'];
};


export type QueryAudienceSubsetValuesArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


export type QueryAudienceSubsetValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


export type QueryAudienceSubsetValuesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAudienceTemplatesArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


export type QueryAudienceTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


export type QueryAudienceTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryAudiencesSubsetsArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


export type QueryAudiencesSubsetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


export type QueryAudiencesSubsetsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_value_id: Scalars['uuid'];
};


export type QueryAuditLogArgs = {
  filters: AuditLogFilters;
};


export type QueryAuth0ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<Auth0ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth0ConnectionsOrderBy>>;
  where?: InputMaybe<Auth0ConnectionsBoolExp>;
};


export type QueryAuth0ConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryAuthorizedDraftModelReviewersArgs = {
  modelId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
};


export type QueryAuthorizedDraftSyncReviewersArgs = {
  destinationId?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  syncId?: InputMaybe<Scalars['String']>;
};


export type QueryBackgroundDiscoveryResultArgs = {
  jobId: Scalars['String'];
};


export type QueryBackgroundModelPreviewQueryResultArgs = {
  input: BackgroundJobInput;
  page: Scalars['Int'];
};


export type QueryBackgroundPreviewQueryResultArgs = {
  input: BackgroundJobInput;
  page: Scalars['Int'];
};


export type QueryBillingByDestinationArgs = {
  distinct_on?: InputMaybe<Array<BillingByDestinationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BillingByDestinationOrderBy>>;
  where?: InputMaybe<BillingByDestinationBoolExp>;
};


export type QueryBillingProductsArgs = {
  distinct_on?: InputMaybe<Array<BillingProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BillingProductsOrderBy>>;
  where?: InputMaybe<BillingProductsBoolExp>;
};


export type QueryBillingProductsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryBrandProfileFontsArgs = {
  brandProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryBrandProfileAssetGroupsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


export type QueryBrandProfileAssetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


export type QueryBrandProfileAssetGroupsByPkArgs = {
  asset_group_id: Scalars['uuid'];
  brand_profile_id: Scalars['uuid'];
};


export type QueryBrandProfileContentEmailsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


export type QueryBrandProfileContentEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


export type QueryBrandProfileContentEmailsByPkArgs = {
  brand_profile_id: Scalars['uuid'];
  content_email_id: Scalars['uuid'];
};


export type QueryBrandProfileSettingsEntitiesArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


export type QueryBrandProfileSettingsEntitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


export type QueryBrandProfileSettingsEntitiesByPkArgs = {
  brand_profile_id: Scalars['uuid'];
  settings_entity_id: Scalars['uuid'];
};


export type QueryBrandProfilesArgs = {
  distinct_on?: InputMaybe<Array<BrandProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfilesOrderBy>>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};


export type QueryBrandProfilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfilesOrderBy>>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};


export type QueryBrandProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryBynderCollectionsArgs = {
  extensionId: Scalars['String'];
  keyword?: InputMaybe<Scalars['String']>;
};


export type QueryBynderMetapropertiesArgs = {
  extensionId: Scalars['String'];
};


export type QueryBynderMetapropertyOptionsArgs = {
  extensionId: Scalars['String'];
  metapropertyId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type QueryBynderTagsArgs = {
  extensionId: Scalars['String'];
};


export type QueryCachedAudienceSizeArgs = {
  audienceId?: InputMaybe<Scalars['bigint']>;
  parentModelId: Scalars['bigint'];
  relatedModelId?: InputMaybe<Scalars['bigint']>;
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
  visualQueryFilter?: InputMaybe<Scalars['JSONObject']>;
};


export type QueryCachedAudienceSizesArgs = {
  audienceIds: Array<Scalars['bigint']>;
};


export type QueryCachedSuppressionListSizeArgs = {
  suppressionListId: Scalars['ID'];
  visualQueryFilter?: InputMaybe<Scalars['JSONObject']>;
};


export type QueryCachedSuppressionListSizesArgs = {
  suppressionListIds: Array<Scalars['ID']>;
};


export type QueryCachedEventPullsArgs = {
  distinct_on?: InputMaybe<Array<CachedEventPullsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CachedEventPullsOrderBy>>;
  where?: InputMaybe<CachedEventPullsBoolExp>;
};


export type QueryCachedEventPullsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCalendarViewArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignCalendarArgs = {
  input: CampaignCalendarInput;
};


export type QueryCampaignChannelCreativeArgs = {
  channel?: InputMaybe<Scalars['String']>;
  sendId: Scalars['String'];
  variationId?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignInsightArgs = {
  insightId: Scalars['uuid'];
};


export type QueryCampaignInsightFeedArgs = {
  categories?: InputMaybe<Array<CampaignInsightCategory>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  savedOnly?: Scalars['Boolean'];
};


export type QueryCampaignMonthCustomMetricsArgs = {
  month: Scalars['String'];
};


export type QueryCampaignRecipientsResultArgs = {
  jobId: Scalars['ID'];
};


export type QueryCampaignSendCustomMetricsArgs = {
  sendId: Scalars['String'];
};


export type QueryCampaignSendInsightsArgs = {
  sendId: Scalars['String'];
};


export type QueryCampaignArtifactVersionBestPracticeRunsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
};


export type QueryCampaignArtifactVersionBestPracticeRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
};


export type QueryCampaignArtifactVersionBestPracticeRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCampaignArtifactVersionsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


export type QueryCampaignArtifactVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


export type QueryCampaignArtifactVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCampaignArtifactsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


export type QueryCampaignArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


export type QueryCampaignArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCampaignDraftsArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


export type QueryCampaignDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


export type QueryCampaignDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCampaignLabelsArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


export type QueryCampaignLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


export type QueryCampaignLabelsByPkArgs = {
  campaign_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type QueryCampaignListEntriesArgs = {
  distinct_on?: InputMaybe<Array<CampaignListEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignListEntriesOrderBy>>;
  where?: InputMaybe<CampaignListEntriesBoolExp>;
};


export type QueryCampaignListEntriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignListEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignListEntriesOrderBy>>;
  where?: InputMaybe<CampaignListEntriesBoolExp>;
};


export type QueryCampaignRunsArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


export type QueryCampaignRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


export type QueryCampaignRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCampaignsArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


export type QueryCampaignsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


export type QueryCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCanDeployDestinationInstancesArgs = {
  sourceResourceId: Scalars['bigint'];
};


export type QueryCanDeploySegmentsArgs = {
  sourceResourceId: Scalars['bigint'];
};


export type QueryCantoFolderTreeArgs = {
  extensionId: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['String']>;
};


export type QueryCardinalityDetectionResultArgs = {
  input: CardinalityDetectionInput;
};


export type QueryCatalogDirectoriesArgs = {
  userDefinedType: Scalars['String'];
};


export type QueryCatalogFilterableUserTagsArgs = {
  assetGroupId: Scalars['String'];
};


export type QueryCatalogProductArgs = {
  id: Scalars['String'];
};


export type QueryCatalogProductsArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  dimensionTags?: InputMaybe<Array<CatalogDimensionTagFilter>>;
  directoryExact?: InputMaybe<Scalars['String']>;
  directoryPrefix?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['JSON']>;
  limit?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  unfiledOnly?: InputMaybe<Scalars['Boolean']>;
  userDefinedType?: InputMaybe<Scalars['String']>;
};


export type QueryCatalogProductsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  sourceRowKeys?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCatalogCollectionsArgs = {
  distinct_on?: InputMaybe<Array<CatalogCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CatalogCollectionsOrderBy>>;
  where?: InputMaybe<CatalogCollectionsBoolExp>;
};


export type QueryCatalogCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCatalogModelsArgs = {
  distinct_on?: InputMaybe<Array<CatalogModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CatalogModelsOrderBy>>;
  where?: InputMaybe<CatalogModelsBoolExp>;
};


export type QueryCatalogModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryCepConsentCenterPreviewUrlArgs = {
  cepBrandId?: InputMaybe<Scalars['ID']>;
};


export type QueryCepConsentManagementUrlArgs = {
  channel?: InputMaybe<Scalars['String']>;
  parentModelId?: InputMaybe<Scalars['ID']>;
  primaryKeyValue: Scalars['String'];
  userHandle: Scalars['String'];
};


export type QueryCepContentBlockHtmlFromSectionArgs = {
  html: Scalars['String'];
};


export type QueryCepLocalizationStatusArgs = {
  messageId: Scalars['ID'];
};


export type QueryCepReachabilityResultArgs = {
  jobId: Scalars['ID'];
};


export type QueryCepTwilioPhoneNumbersArgs = {
  input: CepTwilioPhoneNumbersInput;
};


export type QueryCepUnresolvedTemplateVariablesArgs = {
  messageId: Scalars['ID'];
};


export type QueryCepValidateFontCssArgs = {
  url: Scalars['String'];
};


export type QueryCepWhatsAppDraftReviewArgs = {
  messageId: Scalars['ID'];
};


export type QueryCepWhatsAppTemplateDuplicateArgs = {
  id: Scalars['ID'];
  localeId?: InputMaybe<Scalars['ID']>;
};


export type QueryCepWhatsAppTemplateLocalesArgs = {
  id: Scalars['ID'];
};


export type QueryCepBrandSettingsArgs = {
  distinct_on?: InputMaybe<Array<CepBrandSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepBrandSettingsOrderBy>>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};


export type QueryCepBrandSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepBrandSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepBrandSettingsOrderBy>>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};


export type QueryCepBrandSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepChannelsArgs = {
  distinct_on?: InputMaybe<Array<CepChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepChannelsOrderBy>>;
  where?: InputMaybe<CepChannelsBoolExp>;
};


export type QueryCepChannelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepChannelsOrderBy>>;
  where?: InputMaybe<CepChannelsBoolExp>;
};


export type QueryCepChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepContentBlockMessageUsagesArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


export type QueryCepContentBlockMessageUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


export type QueryCepContentBlockMessageUsagesByPkArgs = {
  content_block_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
};


export type QueryCepContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlocksOrderBy>>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};


export type QueryCepContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlocksOrderBy>>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};


export type QueryCepContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepDevicePreviewsArgs = {
  distinct_on?: InputMaybe<Array<CepDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepDevicePreviewsBoolExp>;
};


export type QueryCepDevicePreviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepDevicePreviewsBoolExp>;
};


export type QueryCepDevicePreviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepDomainsArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


export type QueryCepDomainsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


export type QueryCepDomainsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepEmailTemplateContentsArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


export type QueryCepEmailTemplateContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


export type QueryCepEmailTemplateContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepEmailTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplatesOrderBy>>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};


export type QueryCepEmailTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplatesOrderBy>>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};


export type QueryCepEmailTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepInappMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


export type QueryCepInappMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


export type QueryCepInappMessageContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepInappMessageTemplatePushAppsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatePushAppsOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
};


export type QueryCepInappMessageTemplatePushAppsByPkArgs = {
  push_app_id: Scalars['uuid'];
  template_id: Scalars['uuid'];
};


export type QueryCepInappMessageTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatesOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatesBoolExp>;
};


export type QueryCepInappMessageTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatesOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatesBoolExp>;
};


export type QueryCepInappMessageTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepLocalesArgs = {
  distinct_on?: InputMaybe<Array<CepLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalesOrderBy>>;
  where?: InputMaybe<CepLocalesBoolExp>;
};


export type QueryCepLocalesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalesOrderBy>>;
  where?: InputMaybe<CepLocalesBoolExp>;
};


export type QueryCepLocalesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepLocalizationSettingsArgs = {
  distinct_on?: InputMaybe<Array<CepLocalizationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalizationSettingsOrderBy>>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};


export type QueryCepLocalizationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepLocalizationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalizationSettingsOrderBy>>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};


export type QueryCepLocalizationSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepManagedModelsArgs = {
  distinct_on?: InputMaybe<Array<CepManagedModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepManagedModelsOrderBy>>;
  where?: InputMaybe<CepManagedModelsBoolExp>;
};


export type QueryCepManagedModelsByPkArgs = {
  segment_id: Scalars['bigint'];
};


export type QueryCepMessageDevicePreviewsArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


export type QueryCepMessageDevicePreviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


export type QueryCepMessageDevicePreviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepProvidersArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


export type QueryCepProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


export type QueryCepProvidersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


export type QueryCepSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


export type QueryCepSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepSenderIdentitySendersArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitySendersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitySendersOrderBy>>;
  where?: InputMaybe<CepSenderIdentitySendersBoolExp>;
};


export type QueryCepSenderIdentitySendersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitySendersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitySendersOrderBy>>;
  where?: InputMaybe<CepSenderIdentitySendersBoolExp>;
};


export type QueryCepSenderIdentitySendersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepSubscriptionTopicSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


export type QueryCepSubscriptionTopicSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


export type QueryCepSubscriptionTopicSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


export type QueryCepSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


export type QueryCepSubscriptionTopicsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepSuppressionListSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


export type QueryCepSuppressionListSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


export type QueryCepSuppressionListSubscriptionTopicsByPkArgs = {
  cep_subscription_topic_id: Scalars['uuid'];
  suppression_list_id: Scalars['uuid'];
};


export type QueryCepSuppressionListsArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListsOrderBy>>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};


export type QueryCepSuppressionListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListsOrderBy>>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};


export type QueryCepSuppressionListsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepTestGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


export type QueryCepTestGroupMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


export type QueryCepTestGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepTestGroupsArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupsOrderBy>>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};


export type QueryCepTestGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupsOrderBy>>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};


export type QueryCepTestGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepTranslationsArgs = {
  distinct_on?: InputMaybe<Array<CepTranslationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTranslationsOrderBy>>;
  where?: InputMaybe<CepTranslationsBoolExp>;
};


export type QueryCepTranslationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepWhatsappTemplateLocalesArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


export type QueryCepWhatsappTemplateLocalesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


export type QueryCepWhatsappTemplateLocalesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepWhatsappTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplatesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplatesBoolExp>;
};


export type QueryCepWhatsappTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplatesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplatesBoolExp>;
};


export type QueryCepWhatsappTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepWorkspaceConfigArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceConfigOrderBy>>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};


export type QueryCepWorkspaceConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceConfigOrderBy>>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};


export type QueryCepWorkspaceConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCepWorkspaceParentModelsArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


export type QueryCepWorkspaceParentModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


export type QueryCepWorkspaceParentModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryChartCardsArgs = {
  distinct_on?: InputMaybe<Array<ChartCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChartCardsOrderBy>>;
  where?: InputMaybe<ChartCardsBoolExp>;
};


export type QueryChartCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCheckDebuggerExportArgs = {
  syncRunId: Scalars['Int'];
};


export type QueryCheckDestinationPermissionsArgs = {
  input?: InputMaybe<CheckDestinationPermissionsInput>;
};


export type QueryCheckFacebookTokenPermissionsArgs = {
  input: CheckFacebookTokenPermissionsInput;
};


export type QueryCheckReportVersionReferencesArgs = {
  reportScheduleId: Scalars['uuid'];
  versionId: Scalars['uuid'];
};


export type QueryCheckTunnelArgs = {
  id: Scalars['String'];
};


export type QueryClientSuccessDescribeObjectArgs = {
  input: ClientSuccessDescribeObjectInput;
};


export type QueryCloudCredentialsArgs = {
  distinct_on?: InputMaybe<Array<CloudCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CloudCredentialsOrderBy>>;
  where?: InputMaybe<CloudCredentialsBoolExp>;
};


export type QueryCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryCommonFilterSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  parentModelId: Scalars['bigint'];
};


export type QueryCompetitorAdsForCompetitorArgs = {
  channels?: InputMaybe<Array<Scalars['String']>>;
  competitorId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCompetitorAccountsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


export type QueryCompetitorAccountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


export type QueryCompetitorAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCompetitorAdScrapesArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAdScrapesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAdScrapesOrderBy>>;
  where?: InputMaybe<CompetitorAdScrapesBoolExp>;
};


export type QueryCompetitorAdScrapesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCompetitorsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorsOrderBy>>;
  where?: InputMaybe<CompetitorsBoolExp>;
};


export type QueryCompetitorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorsOrderBy>>;
  where?: InputMaybe<CompetitorsBoolExp>;
};


export type QueryCompetitorsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCompileContentArtifactDynamicContentArgs = {
  input: CompileContentArtifactDynamicContentInput;
};


export type QueryCompileContentEmailDynamicContentArgs = {
  input: CompileContentEmailDynamicContentInput;
};


export type QueryComputeSendInsightChartsArgs = {
  charts: Array<Scalars['JSONObject']>;
  flowId: Scalars['uuid'];
};


export type QueryConditionTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


export type QueryConditionTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


export type QueryConditionTemplateLabelsByPkArgs = {
  condition_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type QueryConnectionRoleCacheStatusArgs = {
  connectionId: Scalars['Int'];
};


export type QueryConnectionRoleMappingsArgs = {
  connectionId: Scalars['Int'];
};


export type QueryConnectionRoleSettingsArgs = {
  connectionId: Scalars['Int'];
};


export type QueryConnectionRolesArgs = {
  connectionId: Scalars['Int'];
  includeUnavailable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryConnectionsArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


export type QueryConnectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


export type QueryConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryContentArtifactDynamicSlotsArgs = {
  artifactId: Scalars['uuid'];
};


export type QueryContentEmailDynamicSlotsArgs = {
  emailId: Scalars['uuid'];
};


export type QueryContentImageSearchV2ResultArgs = {
  jobId: Scalars['String'];
};


export type QueryContentBlockLabelsArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


export type QueryContentBlockLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


export type QueryContentBlockLabelsByPkArgs = {
  content_block_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type QueryContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<ContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlocksOrderBy>>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};


export type QueryContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlocksOrderBy>>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};


export type QueryContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDeploymentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDeploymentsOrderBy>>;
  where?: InputMaybe<ContentDeploymentsBoolExp>;
};


export type QueryContentDeploymentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDeploymentsOrderBy>>;
  where?: InputMaybe<ContentDeploymentsBoolExp>;
};


export type QueryContentDeploymentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDynamicSlotAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


export type QueryContentDynamicSlotAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


export type QueryContentDynamicSlotAssignmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDynamicSlotBranchesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


export type QueryContentDynamicSlotBranchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


export type QueryContentDynamicSlotBranchesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDynamicSlotContentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


export type QueryContentDynamicSlotContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


export type QueryContentDynamicSlotContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDynamicSlotLibrariesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotLibrariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotLibrariesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};


export type QueryContentDynamicSlotLibrariesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotLibrariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotLibrariesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};


export type QueryContentDynamicSlotLibrariesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentDynamicSlotUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


export type QueryContentDynamicSlotUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


export type QueryContentDynamicSlotUsagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentEmailMessageLinksArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


export type QueryContentEmailMessageLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


export type QueryContentEmailMessageLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentEmailVariantsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


export type QueryContentEmailVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


export type QueryContentEmailVariantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentEmailVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


export type QueryContentEmailVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


export type QueryContentEmailVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentEmailsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


export type QueryContentEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


export type QueryContentEmailsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentSettingsArgs = {
  distinct_on?: InputMaybe<Array<ContentSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentSettingsOrderBy>>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};


export type QueryContentSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentSettingsOrderBy>>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};


export type QueryContentSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentTagsArgs = {
  distinct_on?: InputMaybe<Array<ContentTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTagsOrderBy>>;
  where?: InputMaybe<ContentTagsBoolExp>;
};


export type QueryContentTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTagsOrderBy>>;
  where?: InputMaybe<ContentTagsBoolExp>;
};


export type QueryContentTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryContentTemplatesArgs = {
  distinct_on?: InputMaybe<Array<ContentTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTemplatesOrderBy>>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};


export type QueryContentTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTemplatesOrderBy>>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};


export type QueryContentTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryCopyReferencesIngestionRunsArgs = {
  channel?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCurrentReportScheduleVersionsArgs = {
  distinct_on?: InputMaybe<Array<CurrentReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrentReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<CurrentReportScheduleVersionsBoolExp>;
};


export type QueryCustomListFieldsArgs = {
  input: CustomDestinationListFieldsInput;
};


export type QueryCustomListModesArgs = {
  input: CustomDestinationListModesInput;
};


export type QueryCustomListObjectsArgs = {
  input: CustomDestinationListObjectsInput;
};


export type QueryCustomListOptionsArgs = {
  input: CustomDestinationListOptionsInput;
};


export type QueryCustomQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query: Scalars['JSONObject'];
};


export type QueryCustomValidateConfigurationArgs = {
  input: CustomDestinationValidateConfigurationInput;
};


export type QueryCustomAgentsArgs = {
  distinct_on?: InputMaybe<Array<CustomAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomAgentsOrderBy>>;
  where?: InputMaybe<CustomAgentsBoolExp>;
};


export type QueryCustomAgentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDashboardSyncAttemptsV2Args = {
  destination_ids: Array<Scalars['bigint']>;
  granularity: DashboardSyncMetricGranularity;
  source_ids: Array<Scalars['bigint']>;
};


export type QueryDashboardSyncRequestIdsArgs = {
  destination_ids: Array<Scalars['bigint']>;
  endTime?: InputMaybe<Scalars['String']>;
  source_ids: Array<Scalars['bigint']>;
  startTime: Scalars['String'];
};


export type QueryDashboardSyncRequestsV2Args = {
  destination_ids: Array<Scalars['bigint']>;
  granularity: DashboardSyncMetricGranularity;
  source_ids: Array<Scalars['bigint']>;
};


export type QueryDashboardsArgs = {
  distinct_on?: InputMaybe<Array<DashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DashboardsOrderBy>>;
  where?: InputMaybe<DashboardsBoolExp>;
};


export type QueryDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DashboardsOrderBy>>;
  where?: InputMaybe<DashboardsBoolExp>;
};


export type QueryDashboardsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDatadogCredentialsArgs = {
  distinct_on?: InputMaybe<Array<DatadogCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DatadogCredentialsOrderBy>>;
  where?: InputMaybe<DatadogCredentialsBoolExp>;
};


export type QueryDatadogCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryDbtModelQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  dbtModelId?: InputMaybe<Scalars['Int']>;
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryDbtQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  dbtModelId?: InputMaybe<Scalars['Int']>;
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryDbtCloudSyncConfigArgs = {
  distinct_on?: InputMaybe<Array<DbtCloudSyncConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCloudSyncConfigOrderBy>>;
  where?: InputMaybe<DbtCloudSyncConfigBoolExp>;
};


export type QueryDbtCloudSyncConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDbtCloudWebhooksArgs = {
  distinct_on?: InputMaybe<Array<DbtCloudWebhooksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCloudWebhooksOrderBy>>;
  where?: InputMaybe<DbtCloudWebhooksBoolExp>;
};


export type QueryDbtCloudWebhooksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDbtCredentialsArgs = {
  distinct_on?: InputMaybe<Array<DbtCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCredentialsOrderBy>>;
  where?: InputMaybe<DbtCredentialsBoolExp>;
};


export type QueryDbtCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryDbtSyncConfigArgs = {
  distinct_on?: InputMaybe<Array<DbtSyncConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtSyncConfigOrderBy>>;
  where?: InputMaybe<DbtSyncConfigBoolExp>;
};


export type QueryDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDbtSyncModelsArgs = {
  distinct_on?: InputMaybe<Array<DbtSyncModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtSyncModelsOrderBy>>;
  where?: InputMaybe<DbtSyncModelsBoolExp>;
};


export type QueryDbtSyncModelsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDebugMetaPageAccessArgs = {
  input: DebugMetaPageAccessInput;
};


export type QueryDebugSendMatchingArgs = {
  input: DebugSendMatchingInput;
};


export type QueryDecisionEngineArbitrationGroupModeStatusArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowVolumeRampStateArgs = {
  flowId: Scalars['uuid'];
};


export type QueryDecisionEngineQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sqlOverride?: InputMaybe<Scalars['String']>;
};


export type QueryDecisionEngineArbitrationGroupMembershipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


export type QueryDecisionEngineArbitrationGroupMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


export type QueryDecisionEngineArbitrationGroupMembershipsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineArbitrationGroupsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
};


export type QueryDecisionEngineArbitrationGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
};


export type QueryDecisionEngineArbitrationGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineChannelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineChannelsOrderBy>>;
  where?: InputMaybe<DecisionEngineChannelsBoolExp>;
};


export type QueryDecisionEngineChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineCollectionsBoolExp>;
};


export type QueryDecisionEngineCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineContentRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineContentRecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineContentRecommendationsOrderBy>>;
  where?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
};


export type QueryDecisionEngineContentRecommendationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineContentRecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineContentRecommendationsOrderBy>>;
  where?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
};


export type QueryDecisionEngineContentRecommendationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFeatureMatricesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatricesOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
};


export type QueryDecisionEngineFeatureMatricesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFeatureMatrixRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
};


export type QueryDecisionEngineFeatureMatrixRelationshipsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowChannelSyncArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowChannelSyncSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowChannelSyncOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
};


export type QueryDecisionEngineFlowChannelSyncByPkArgs = {
  channel_id: Scalars['uuid'];
  flow_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};


export type QueryDecisionEngineFlowChartsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowChartsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowChartsBoolExp>;
};


export type QueryDecisionEngineFlowChartsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowExperimentsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowExperimentsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
};


export type QueryDecisionEngineFlowExperimentsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  name: Scalars['String'];
};


export type QueryDecisionEngineFlowMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
};


export type QueryDecisionEngineFlowMessagesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
};


export type QueryDecisionEngineFlowOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowOverridePeriodsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowOverridePeriodsBoolExp>;
};


export type QueryDecisionEngineFlowOverridePeriodsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowRunsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


export type QueryDecisionEngineFlowRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


export type QueryDecisionEngineFlowRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowTagsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowTagsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
};


export type QueryDecisionEngineFlowTagsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  tag_key: Scalars['String'];
  tag_value: Scalars['String'];
};


export type QueryDecisionEngineFlowVolumeRampsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowVolumeRampsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowVolumeRampsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowVolumeRampsBoolExp>;
};


export type QueryDecisionEngineFlowVolumeRampsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineFlowsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowsBoolExp>;
};


export type QueryDecisionEngineFlowsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineInteractionManifestsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineInteractionManifestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineInteractionManifestsOrderBy>>;
  where?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
};


export type QueryDecisionEngineInteractionManifestsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineMessageCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
};


export type QueryDecisionEngineMessageCollectionsByPkArgs = {
  decision_engine_collection_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryDecisionEngineMessageVariantSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};


export type QueryDecisionEngineMessageVariantSuggestionsByPkArgs = {
  decision_engine_message_id: Scalars['uuid'];
  suggested_value: Scalars['String'];
  variable_name: Scalars['String'];
};


export type QueryDecisionEngineMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


export type QueryDecisionEngineMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


export type QueryDecisionEngineMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineModelOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};


export type QueryDecisionEngineModelOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_model_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


export type QueryDecisionEngineModelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelsOrderBy>>;
  where?: InputMaybe<DecisionEngineModelsBoolExp>;
};


export type QueryDecisionEngineModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineOffersArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOffersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOffersOrderBy>>;
  where?: InputMaybe<DecisionEngineOffersBoolExp>;
};


export type QueryDecisionEngineOffersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineOutcomesBoolExp>;
};


export type QueryDecisionEngineOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineSendEventsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSendEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSendEventsOrderBy>>;
  where?: InputMaybe<DecisionEngineSendEventsBoolExp>;
};


export type QueryDecisionEngineSendEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEngineSplitsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSplitsOrderBy>>;
  where?: InputMaybe<DecisionEngineSplitsBoolExp>;
};


export type QueryDecisionEngineSplitsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDecisionEnginesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEnginesOrderBy>>;
  where?: InputMaybe<DecisionEnginesBoolExp>;
};


export type QueryDecisionEnginesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDeliverabilityFeedDomainAccessArgs = {
  feedType: Scalars['String'];
};


export type QueryDeliverabilityFeedsArgs = {
  distinct_on?: InputMaybe<Array<DeliverabilityFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeliverabilityFeedsOrderBy>>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};


export type QueryDeliverabilityFeedsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeliverabilityFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeliverabilityFeedsOrderBy>>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};


export type QueryDeliverabilityFeedsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDeploymentHistoryArgs = {
  distinct_on?: InputMaybe<Array<DeploymentHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeploymentHistoryOrderBy>>;
  where?: InputMaybe<DeploymentHistoryBoolExp>;
};


export type QueryDeploymentHistoryByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDescribeSemanticViewArgs = {
  connectionId: Scalars['String'];
  view: SemanticViewReferenceInput;
};


export type QueryDestinationCanActionGrantsArgs = {
  destinationId: Scalars['String'];
};


export type QueryDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


export type QueryDestinationInstanceSplitsByPkArgs = {
  destination_instance_id: Scalars['bigint'];
  split_id: Scalars['uuid'];
};


export type QueryDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


export type QueryDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


export type QueryDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDestinationRulesArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


export type QueryDestinationRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


export type QueryDestinationRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDestinationsArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


export type QueryDestinationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


export type QueryDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryDetectSubsetScopedConditionCyclesArgs = {
  parentModelId: Scalars['String'];
  scopedConditions: Scalars['JSON'];
};


export type QueryDiffRealtimeEventColumnsArgs = {
  modelId: Scalars['String'];
  newColumns: Array<DiffRealtimeEventColumnInput>;
  oldColumns: Array<DiffRealtimeEventColumnInput>;
};


export type QueryDirectModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: InputMaybe<DirectModelRelationshipsBoolExp>;
};


export type QueryDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type QueryDraftApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<DraftApprovalRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftApprovalRequestsOrderBy>>;
  where?: InputMaybe<DraftApprovalRequestsBoolExp>;
};


export type QueryDraftApprovalRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryDraftsArgs = {
  distinct_on?: InputMaybe<Array<DraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftsOrderBy>>;
  where?: InputMaybe<DraftsBoolExp>;
};


export type QueryDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftsOrderBy>>;
  where?: InputMaybe<DraftsBoolExp>;
};


export type QueryDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEllieAdminCloudReviewArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieAdminDiagnosticMonitorsArgs = {
  input: EllieAdminReadInput;
};


export type QueryEllieAdminEnhanceStatusArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieAdminInternetReconciliationArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
};


export type QueryEllieAdminInternetRequestsArgs = {
  input: EllieAdminInternetRequestsInput;
};


export type QueryEllieAdminMonitorArgs = {
  input: EllieAdminMonitorInput;
};


export type QueryEllieAdminOperationsHealthArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieAdminSourceKeywordsArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieAdminSourceQueueArgs = {
  input: EllieAdminReadInput;
};


export type QueryEllieAdminSourceReadScheduleArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieAeoTacticsArgs = {
  input: EllieReadInput;
};


export type QueryEllieAeoTrialArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieAnswerAnalysisArgs = {
  input: EllieReadInput;
};


export type QueryEllieAppstoreReviewCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryEllieBrainArgs = {
  input: EllieReadInput;
};


export type QueryEllieBrainCatalogArgs = {
  input: EllieReadInput;
};


export type QueryEllieBrainHistoryArgs = {
  input: EllieReadInput;
};


export type QueryEllieBrandSearchCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryEllieChatArgs = {
  id: Scalars['String'];
  siteId: Scalars['String'];
};


export type QueryEllieChatsArgs = {
  shared?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['String'];
};


export type QueryEllieConfigurationArgs = {
  siteId: Scalars['String'];
};


export type QueryEllieIdeaExportArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieInsightsArgs = {
  input: EllieReadInput;
};


export type QueryEllieInternetArgs = {
  input: EllieReadInput;
};


export type QueryEllieJobArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieKnowledgeArgs = {
  input: EllieReadInput;
};


export type QueryEllieKnowledgeObjectArgs = {
  input: EllieReadInput;
};


export type QueryEllieLinkedinCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryEllieLinkedinMentionCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryEllieMaintenanceReportArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieMapsReviewCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryEllieMeasurementsArgs = {
  input: EllieReadInput;
};


export type QueryEllieMessagesArgs = {
  input: EllieReadInput;
};


export type QueryEllieMonitoringSummaryArgs = {
  input: EllieReadInput;
};


export type QueryEllieOpportunityLoopArgs = {
  input: EllieReadInput;
};


export type QueryEllieOpportunityPortfolioArgs = {
  input: EllieReadInput;
};


export type QueryElliePlayReviewCollectionsArgs = {
  input: EllieReadInput;
};


export type QueryElliePromptDataArgs = {
  input: EllieReadInput;
};


export type QueryElliePromptRunArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieReviewBacklogArgs = {
  input: EllieReadInput;
};


export type QueryEllieReviewBacklogItemArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieSearchExcerptsArgs = {
  input: EllieReadInput;
};


export type QueryEllieSourceArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEllieSourceFailuresArgs = {
  input: EllieReadInput;
};


export type QueryEllieSourceInventoryArgs = {
  input: EllieReadInput;
};


export type QueryEllieSourceInventoryDetailArgs = {
  input: EllieReadInput;
};


export type QueryEllieSourceKeywordsArgs = {
  input: EllieReadInput;
};


export type QueryEllieSourceVersionArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
  version: Scalars['String'];
};


export type QueryEllieStateArgs = {
  input: EllieReadInput;
};


export type QueryEllieTopicsArgs = {
  input: EllieReadInput;
};


export type QueryEllieUnderstandingHistoryArgs = {
  id: Scalars['String'];
  input: EllieReadInput;
};


export type QueryEmailPngExportRunArgs = {
  id: Scalars['ID'];
};


export type QueryEmailTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


export type QueryEmailTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


export type QueryEmailTemplateLabelsByPkArgs = {
  email_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type QueryEnrichmentStatusArgs = {
  isInitializing?: InputMaybe<Scalars['Boolean']>;
  modelId: Scalars['String'];
  region: MatchBoosterRegion;
};


export type QueryEntityCitationsArgs = {
  entityIds: Array<Scalars['uuid']>;
};


export type QueryEspCatalogStateArgs = {
  distinct_on?: InputMaybe<Array<EspCatalogStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspCatalogStateOrderBy>>;
  where?: InputMaybe<EspCatalogStateBoolExp>;
};


export type QueryEspCatalogStateByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEspContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<EspContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspContentBlocksOrderBy>>;
  where?: InputMaybe<EspContentBlocksBoolExp>;
};


export type QueryEspContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<EspContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspContentBlocksOrderBy>>;
  where?: InputMaybe<EspContentBlocksBoolExp>;
};


export type QueryEspContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEspUserFieldsArgs = {
  distinct_on?: InputMaybe<Array<EspUserFieldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspUserFieldsOrderBy>>;
  where?: InputMaybe<EspUserFieldsBoolExp>;
};


export type QueryEspUserFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EspUserFieldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspUserFieldsOrderBy>>;
  where?: InputMaybe<EspUserFieldsBoolExp>;
};


export type QueryEspUserFieldsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEtlConnectionsArgs = {
  distinct_on?: InputMaybe<Array<EtlConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlConnectionsOrderBy>>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};


export type QueryEtlConnectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EtlConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlConnectionsOrderBy>>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};


export type QueryEtlConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEtlSyncRunsArgs = {
  distinct_on?: InputMaybe<Array<EtlSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlSyncRunsOrderBy>>;
  where?: InputMaybe<EtlSyncRunsBoolExp>;
};


export type QueryEtlSyncRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEvaluateCampaignAnalyticsDashboardQueryArgs = {
  assetModelColumns: Array<AssetModelColumn>;
  assetModelFilter?: InputMaybe<Scalars['JSONObject']>;
  assetModelId: Scalars['String'];
  metricAttributionFilter?: InputMaybe<Scalars['JSONObject']>;
  metrics: Array<Metric>;
  orderBy?: InputMaybe<OrderByCampaignColumn>;
  paginationOptions: PaginationOptions;
  parentModelId: Scalars['String'];
  timeWindow: Scalars['String'];
};


export type QueryEvaluateFunnelMetricArgs = {
  cohortDefinitions?: InputMaybe<Array<AnalyticsCohortDefinitionInput>>;
  cohortIds?: InputMaybe<Array<Scalars['String']>>;
  completionWindow: Scalars['Int'];
  groupByColumns?: InputMaybe<Array<MetricGroupByColumn>>;
  ignoreCache?: InputMaybe<Scalars['Boolean']>;
  lookbackWindow?: InputMaybe<Scalars['Int']>;
  stages: Array<FunnelStageDefinitionInput>;
  timeWindow?: InputMaybe<TimeWindow>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEvaluateTimeSeriesMetricArgs = {
  bypassComputedValues?: InputMaybe<Scalars['Boolean']>;
  cohortDefinitions?: InputMaybe<Array<AnalyticsCohortDefinitionInput>>;
  cohortFilter?: InputMaybe<Scalars['JSONObject']>;
  cohortIds?: InputMaybe<Array<Scalars['String']>>;
  cohorts?: InputMaybe<Array<CohortInput>>;
  frequency: Scalars['String'];
  groupByColumns?: InputMaybe<Array<MetricGroupByColumn>>;
  ignoreAudienceSnapshot?: InputMaybe<Scalars['Boolean']>;
  ignoreCache?: InputMaybe<Scalars['Boolean']>;
  lookbackWindow?: InputMaybe<Scalars['Int']>;
  metricDefinitions?: InputMaybe<Array<Scalars['JSONObject']>>;
  metricIds?: InputMaybe<Array<Scalars['String']>>;
  queryDebugName?: InputMaybe<Scalars['String']>;
  timeWindow?: InputMaybe<TimeWindow>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEventForwardingEventDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryEventForwardingEventValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryEventForwardingEventsArgs = {
  input: FormkitDefinitionInput;
};


export type QueryEventForwardingHandlerArgs = {
  input: FormkitEventSyncHandlerInput;
};


export type QueryEventForwardingSharedDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryEventForwardingSharedValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryEventComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


export type QueryEventComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


export type QueryEventComponentsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventComponentsConditionsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


export type QueryEventComponentsConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


export type QueryEventComponentsConditionsByPkArgs = {
  component_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventComponentsJoinArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


export type QueryEventComponentsJoinAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


export type QueryEventComponentsJoinByPkArgs = {
  importee_id: Scalars['uuid'];
  importer_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventContractsArgs = {
  distinct_on?: InputMaybe<Array<EventContractsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventContractsOrderBy>>;
  where?: InputMaybe<EventContractsBoolExp>;
};


export type QueryEventContractsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventContractsSchemaArgs = {
  distinct_on?: InputMaybe<Array<EventContractsSchemaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventContractsSchemaOrderBy>>;
  where?: InputMaybe<EventContractsSchemaBoolExp>;
};


export type QueryEventContractsSchemaByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventForwardingDestinationGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};


export type QueryEventForwardingDestinationGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};


export type QueryEventForwardingDestinationGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventForwardingSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


export type QueryEventForwardingSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


export type QueryEventForwardingSyncSourcesByPkArgs = {
  event_source_id: Scalars['uuid'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventForwardingSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncsOrderBy>>;
  where?: InputMaybe<EventForwardingSyncsBoolExp>;
};


export type QueryEventForwardingSyncsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventModelEventSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


export type QueryEventModelEventSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


export type QueryEventModelEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventModelsArgs = {
  distinct_on?: InputMaybe<Array<EventModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelsOrderBy>>;
  where?: InputMaybe<EventModelsBoolExp>;
};


export type QueryEventModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryEventPlanGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventPlanGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlanGrantsOrderBy>>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};


export type QueryEventPlanGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPlanGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlanGrantsOrderBy>>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};


export type QueryEventPlanGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventPlansArgs = {
  distinct_on?: InputMaybe<Array<EventPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlansOrderBy>>;
  where?: InputMaybe<EventPlansBoolExp>;
};


export type QueryEventPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlansOrderBy>>;
  where?: InputMaybe<EventPlansBoolExp>;
};


export type QueryEventPlansByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventSchemaComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


export type QueryEventSchemaComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


export type QueryEventSchemaComponentsByPkArgs = {
  component_id: Scalars['uuid'];
  event_schema_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventSchemasArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


export type QueryEventSchemasAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


export type QueryEventSchemasByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventSourceContractsArgs = {
  distinct_on?: InputMaybe<Array<EventSourceContractsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceContractsOrderBy>>;
  where?: InputMaybe<EventSourceContractsBoolExp>;
};


export type QueryEventSourceContractsByPkArgs = {
  event_contract_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventSourceGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceGrantsOrderBy>>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};


export type QueryEventSourceGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceGrantsOrderBy>>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};


export type QueryEventSourceGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesOrderBy>>;
  where?: InputMaybe<EventSourcesBoolExp>;
};


export type QueryEventSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesOrderBy>>;
  where?: InputMaybe<EventSourcesBoolExp>;
};


export type QueryEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventSourcesPlansArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


export type QueryEventSourcesPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


export type QueryEventSourcesPlansByPkArgs = {
  event_plan_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventWarehouseDestinationGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};


export type QueryEventWarehouseDestinationGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};


export type QueryEventWarehouseDestinationGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventWarehouseDestinationsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationsBoolExp>;
};


export type QueryEventWarehouseDestinationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationsBoolExp>;
};


export type QueryEventWarehouseDestinationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryEventWarehouseSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


export type QueryEventWarehouseSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


export type QueryEventWarehouseSyncSourcesByPkArgs = {
  event_source_id: Scalars['uuid'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryEventWarehouseSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


export type QueryEventWarehouseSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


export type QueryEventWarehouseSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExperimentMetricsArgs = {
  distinct_on?: InputMaybe<Array<ExperimentMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentMetricsOrderBy>>;
  where?: InputMaybe<ExperimentMetricsBoolExp>;
};


export type QueryExperimentMetricsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExperimentsArgs = {
  distinct_on?: InputMaybe<Array<ExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentsOrderBy>>;
  where?: InputMaybe<ExperimentsBoolExp>;
};


export type QueryExperimentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentsOrderBy>>;
  where?: InputMaybe<ExperimentsBoolExp>;
};


export type QueryExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExposureLogResolutionConfigArgs = {
  modelId: Scalars['bigint'];
};


export type QueryExposureLogResolutionRunsArgs = {
  distinct_on?: InputMaybe<Array<ExposureLogResolutionRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExposureLogResolutionRunsOrderBy>>;
  where?: InputMaybe<ExposureLogResolutionRunsBoolExp>;
};


export type QueryExposureLogResolutionRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExtensionDefinitionArgs = {
  type: Scalars['String'];
};


export type QueryExtensionExportHistoryArgs = {
  extensionId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryExtensionImportHistoryArgs = {
  extensionId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryExtensionsArgs = {
  distinct_on?: InputMaybe<Array<ExtensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExtensionsOrderBy>>;
  where?: InputMaybe<ExtensionsBoolExp>;
};


export type QueryExtensionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExtensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExtensionsOrderBy>>;
  where?: InputMaybe<ExtensionsBoolExp>;
};


export type QueryExtensionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExternalContextSourceConnectionTestResultArgs = {
  jobId: Scalars['uuid'];
};


export type QueryExternalBucketsArgs = {
  distinct_on?: InputMaybe<Array<ExternalBucketsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalBucketsOrderBy>>;
  where?: InputMaybe<ExternalBucketsBoolExp>;
};


export type QueryExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type QueryExternalContextSourcesArgs = {
  distinct_on?: InputMaybe<Array<ExternalContextSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalContextSourcesOrderBy>>;
  where?: InputMaybe<ExternalContextSourcesBoolExp>;
};


export type QueryExternalContextSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExternalContextSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalContextSourcesOrderBy>>;
  where?: InputMaybe<ExternalContextSourcesBoolExp>;
};


export type QueryExternalContextSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryExternalSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalSegmentsOrderBy>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


export type QueryExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryFacebookAdCatalogGetProductCatalogsArgs = {
  input: FacebookAdCatalogGetProductCatalogsInput;
};


export type QueryFeatureSqlBackgroundArgs = {
  input?: InputMaybe<FeatureSqlBackgroundInput>;
};


export type QueryFetchMetaAdAccountsArgs = {
  input: FetchMetaAdAccountsInput;
};


export type QueryFetchMetaAdStatusesArgs = {
  input: FetchMetaAdStatusesInput;
};


export type QueryFetchMetaAdsetAdsArgs = {
  input: FetchMetaAdsetAdsInput;
};


export type QueryFetchMetaAdsetsArgs = {
  input: FetchMetaAdsetsInput;
};


export type QueryFetchMetaCampaignsArgs = {
  input: FetchMetaCampaignsInput;
};


export type QueryFetchMetaInstagramIdentitiesArgs = {
  input: FetchMetaInstagramIdentitiesInput;
};


export type QueryFetchMetaPagesArgs = {
  input: FetchMetaPagesInput;
};


export type QueryFigmaImportDraftsArgs = {
  distinct_on?: InputMaybe<Array<FigmaImportDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FigmaImportDraftsOrderBy>>;
  where?: InputMaybe<FigmaImportDraftsBoolExp>;
};


export type QueryFigmaImportDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFilterableAudienceColumnsForSegmentIdsArgs = {
  segmentIds: Array<Scalars['bigint']>;
};


export type QueryFivetranAgentSyncsArgs = {
  distinct_on?: InputMaybe<Array<FivetranAgentSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FivetranAgentSyncsOrderBy>>;
  where?: InputMaybe<FivetranAgentSyncsBoolExp>;
};


export type QueryFivetranAgentSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFivetranCredentialsArgs = {
  distinct_on?: InputMaybe<Array<FivetranCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FivetranCredentialsOrderBy>>;
  where?: InputMaybe<FivetranCredentialsBoolExp>;
};


export type QueryFivetranCredentialsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFoldersArgs = {
  distinct_on?: InputMaybe<Array<FoldersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FoldersOrderBy>>;
  where?: InputMaybe<FoldersBoolExp>;
};


export type QueryFoldersByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFormkitDestinationDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitDestinationHandlerArgs = {
  input: FormkitSourceHandlerInput;
};


export type QueryFormkitDestinationValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFormkitEventDestinationDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitEventDestinationHandlerArgs = {
  input: FormkitSourceHandlerInput;
};


export type QueryFormkitEventDestinationValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFormkitSourceDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitSourceHandlerArgs = {
  input: FormkitSourceHandlerInput;
};


export type QueryFormkitSourceValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFormkitSyncDefinitionArgs = {
  input: FormkitDefinitionInput;
};


export type QueryFormkitSyncHandlerArgs = {
  input: FormkitSyncHandlerInput;
};


export type QueryFormkitSyncValidationArgs = {
  input: FormkitValidationInput;
};


export type QueryFreshdeskListCustomFieldsArgs = {
  input: FreshdeskListCustomFieldsInput;
};


export type QueryFrontDescribeObjectArgs = {
  input: FrontDescribeObjectInput;
};


export type QueryFrontifyFolderTreeArgs = {
  extensionId: Scalars['String'];
  libraryId?: InputMaybe<Scalars['String']>;
  parentFolderId?: InputMaybe<Scalars['String']>;
};


export type QueryFrontifyLibrariesArgs = {
  extensionId: Scalars['String'];
};


export type QueryFrontifyMetadataPropertiesArgs = {
  extensionId: Scalars['String'];
  libraryId: Scalars['String'];
};


export type QueryFunctionResponseModelInUseArgs = {
  modelId: Scalars['String'];
};


export type QueryFunctionGrantsArgs = {
  distinct_on?: InputMaybe<Array<FunctionGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionGrantsOrderBy>>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};


export type QueryFunctionGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<FunctionGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionGrantsOrderBy>>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};


export type QueryFunctionGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFunctionResourcesArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


export type QueryFunctionResourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


export type QueryFunctionResourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFunctionSettingsArgs = {
  distinct_on?: InputMaybe<Array<FunctionSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionSettingsOrderBy>>;
  where?: InputMaybe<FunctionSettingsBoolExp>;
};


export type QueryFunctionSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryFunctionsArgs = {
  distinct_on?: InputMaybe<Array<FunctionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionsOrderBy>>;
  where?: InputMaybe<FunctionsBoolExp>;
};


export type QueryFunctionsByPkArgs = {
  id: Scalars['uuid'];
  version_number: Scalars['Int'];
};


export type QueryGainsightpxGetAccountAttributesArgs = {
  input?: InputMaybe<GainsightGetAccountAttributesInput>;
};


export type QueryGainsightpxGetUserAttributesArgs = {
  input: GainsightGetUserAttributesInput;
};


export type QueryGenerateResourceSlugArgs = {
  resourceType: SlugResourceType;
  slug: Scalars['String'];
};


export type QueryGenerateWorkspaceSlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetAccessibleModelIdsArgs = {
  modelId: Scalars['String'];
  sourceId: Scalars['String'];
};


export type QueryGetAccessibleOrganizationsArgs = {
  includeAdStudio?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAdComponentAssetUrlsArgs = {
  input: GetAdComponentAssetUrlsInput;
};


export type QueryGetAgentEligibilityBackgroundArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetAgentMemoriesArgs = {
  parentModelId?: InputMaybe<Scalars['bigint']>;
  sourceId?: InputMaybe<Scalars['bigint']>;
};


export type QueryGetAgentSettingsFileReadUrlArgs = {
  input: GetAgentSettingsFileReadUrlInput;
};


export type QueryGetAgenticUfmJobsArgs = {
  decisionEngineId: Scalars['uuid'];
};


export type QueryGetAnalyzedEventSchemasArgs = {
  input: GetAnalyzedEventSchemasInput;
};


export type QueryGetArchivedFailuresArgs = {
  input: GetArchivedFailuresInput;
};


export type QueryGetArchivedFailuresSummaryArgs = {
  input: GetArchivedFailuresSummaryInput;
};


export type QueryGetAttemptedRowsArgs = {
  destinationInstanceId: Scalars['Int'];
  onlyRejected?: InputMaybe<Scalars['Boolean']>;
  onlySuccessful?: InputMaybe<Scalars['Boolean']>;
  opTypes: Array<SyncOp>;
  paginationOptions: AttemptedRowsPaginationOptions;
  plannerType: Scalars['String'];
  syncRequestId: Scalars['Int'];
};


export type QueryGetAttemptedRowsByPrimaryKeyArgs = {
  alreadyHashed?: InputMaybe<Scalars['Boolean']>;
  destinationInstanceId: Scalars['Int'];
  id: Scalars['String'];
  onlyRejected?: InputMaybe<Scalars['Boolean']>;
  onlySuccessful?: InputMaybe<Scalars['Boolean']>;
  paginationOptions: AttemptedRowsPaginationOptions;
  plannerType: Scalars['String'];
  syncRequestId: Scalars['Int'];
};


export type QueryGetAudienceSizeMetricsArgs = {
  input: AudienceSizeMetricsInput;
};


export type QueryGetAvailableEventMetricsArgs = {
  input?: InputMaybe<GetAvailableEventMetricsInput>;
};


export type QueryGetAvailableFeaturesArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetBingAdAccountsArgs = {
  input: BingAdAccountInput;
};


export type QueryGetBulkVideoExportStatusesArgs = {
  input: GetBulkVideoExportStatusesInput;
};


export type QueryGetCampaignAllStatsArgs = {
  allTimeSince: Scalars['String'];
  campaignIds: Array<Scalars['ID']>;
  hourlySince: Scalars['String'];
};


export type QueryGetCampaignAnalyticsDashboardResultBackgroundArgs = {
  jobId: Scalars['String'];
};


export type QueryGetCampaignDerivedStatusArgs = {
  campaignIds: Array<Scalars['ID']>;
};


export type QueryGetCampaignRecipientsArgs = {
  campaignRunId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CampaignRecipientFiltersInput>;
  limit: Scalars['Int'];
  messageIds: Array<Scalars['String']>;
  offset: Scalars['Int'];
  statuses?: InputMaybe<Array<CampaignRecipientStatus>>;
};


export type QueryGetCepDevicePreviewResultsArgs = {
  id: Scalars['uuid'];
};


export type QueryGetCepProfileCacheRowsArgs = {
  parentModelId: Scalars['String'];
};


export type QueryGetCepReachabilityCountsArgs = {
  audienceId: Scalars['String'];
  filter?: InputMaybe<Scalars['JSONObject']>;
};


export type QueryGetChartCardRunBackgroundArgs = {
  chartCardRunId: Scalars['uuid'];
};


export type QueryGetCheckoutUrlArgs = {
  lookup_key: Scalars['String'];
  org_name: Scalars['String'];
  workspace_id: Scalars['Int'];
};


export type QueryGetCloudCredentialsArgs = {
  id?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
};


export type QueryGetConnectedChannelsArgs = {
  category?: InputMaybe<Scalars['String']>;
};


export type QueryGetContentArtifactContentArgs = {
  input: GetContentArtifactContentInput;
};


export type QueryGetContentBlockFromDestinationArgs = {
  contentBlockId: Scalars['String'];
  destinationId: Scalars['String'];
};


export type QueryGetContentEmailPersonalizationPreviewArgs = {
  input: GetContentEmailPersonalizationPreviewInput;
};


export type QueryGetContentEmailVersionResolvedHtmlArgs = {
  input: GetContentEmailVersionResolvedHtmlInput;
};


export type QueryGetContentImageReadUrlArgs = {
  input: GetContentImageReadUrlInput;
};


export type QueryGetContentNodeSvgEditVersionHistoryArgs = {
  nodeId: Scalars['uuid'];
};


export type QueryGetContentNodesForImageUrlsArgs = {
  input: GetContentNodesForImageUrlsInput;
};


export type QueryGetContextReviewSuggestionsArgs = {
  reviewId: Scalars['uuid'];
  sessionId: Scalars['uuid'];
};


export type QueryGetCopyReferencesReviewArgs = {
  reviewId: Scalars['uuid'];
};


export type QueryGetCurrentAgenticSettingsEntitiesArgs = {
  contextType?: InputMaybe<ContextFileType>;
  entityIds?: InputMaybe<Array<Scalars['uuid']>>;
  excludeContextTypes?: InputMaybe<Array<ContextFileType>>;
  includeDraftTemplates?: InputMaybe<Scalars['Boolean']>;
  includeHightouchManaged?: InputMaybe<Scalars['Boolean']>;
  includeReferenceOnly?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<AgenticSettingsEntityType>>;
};


export type QueryGetCurrentRunningMessageTagsJobsArgs = {
  agentId: Scalars['uuid'];
  isSavingResults?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  messageId: Scalars['uuid'];
  tagType: Scalars['String'];
};


export type QueryGetCurrentTagsMessageJobFromMessageArgs = {
  agentId: Scalars['uuid'];
  messageId: Scalars['uuid'];
  tagType: Scalars['String'];
};


export type QueryGetDbtCloudJobsArgs = {
  accountId: Scalars['String'];
};


export type QueryGetDbtSyncConfigArgs = {
  id: Scalars['bigint'];
};


export type QueryGetDbtSyncConfigBySourceArgs = {
  sourceId: Scalars['bigint'];
};


export type QueryGetDecisionEngineChartMetadataFromS3Args = {
  chartIds: Array<Scalars['uuid']>;
  flowId: Scalars['uuid'];
};


export type QueryGetDecisionEngineDestinationResourceArgs = {
  channelId: Scalars['bigint'];
  protocolVersion?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGetDecisionEngineDestinationResourcesArgs = {
  channelConfig?: InputMaybe<Scalars['JSONObject']>;
  channelId?: InputMaybe<Scalars['bigint']>;
  destinationId?: InputMaybe<Scalars['bigint']>;
  parentResourceId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type QueryGetDecisionEngineFlowRunChartDataArgs = {
  fileName: Scalars['String'];
  flowRunId: Scalars['uuid'];
};


export type QueryGetDecisionEngineFlowRunPlotImageUrlArgs = {
  flowRunId: Scalars['uuid'];
  key: Scalars['String'];
};


export type QueryGetDecisionEngineFlowRunPlotManifestArgs = {
  flowRunId: Scalars['uuid'];
};


export type QueryGetDecisionEngineFlowVolumeRampAudienceBucketsBackgroundArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetDecisionEngineMessageTagsArgs = {
  engineId: Scalars['uuid'];
};


export type QueryGetDecisionEngineTableNamesArgs = {
  decisionEngineId: Scalars['uuid'];
};


export type QueryGetDeliverabilityBounceBreakdownArgs = {
  bounceClass: DeliverabilityBounceClass;
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  breakdownBy: DeliverabilityBounceDimension;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityByCampaignArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignIds?: InputMaybe<Array<Scalars['String']>>;
  channelType?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<DeliverabilitySortDirection>;
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  journeyId?: InputMaybe<Scalars['String']>;
  labelFilters?: InputMaybe<Array<CampaignReportingLabelFilter>>;
  limit: Scalars['Int'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  orderBy?: InputMaybe<DeliverabilityMetricSortField>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityByLocaleArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityByMessageArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  direction?: InputMaybe<DeliverabilitySortDirection>;
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  limit: Scalars['Int'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  orderBy?: InputMaybe<DeliverabilityMetricSortField>;
  os?: InputMaybe<PushOs>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityByOsOverTimeArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  metric: Scalars['String'];
  os?: InputMaybe<PushOs>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityByProviderOverTimeArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  metric: Scalars['String'];
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilityMetricsArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  metrics: Array<Scalars['String']>;
  os?: InputMaybe<PushOs>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
  timeSeriesMetrics?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetDeliverabilityOverTimeArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  os?: InputMaybe<PushOs>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDeliverabilitySkipsByReasonArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryGetDestinationDefinitionArgs = {
  input: DestinationDefinitionInput;
};


export type QueryGetDestinationMetadataArgs = {
  id: Scalars['bigint'];
};


export type QueryGetDestinationStrippedConfigurationArgs = {
  input?: InputMaybe<GetDestinationStrippedConfigurationInput>;
};


export type QueryGetDeviceTokensForUserArgs = {
  input: GetDeviceTokensForUserInput;
};


export type QueryGetEmailPreviewArgs = {
  previewId: Scalars['String'];
};


export type QueryGetEmailPreviewTemplatesArgs = {
  destinationId: Scalars['String'];
};


export type QueryGetEmailTemplateFromDestinationArgs = {
  destinationId: Scalars['String'];
  templateId: Scalars['String'];
};


export type QueryGetEmailTemplateProviderMetadataArgs = {
  contentEmailId: Scalars['String'];
  destinationId: Scalars['String'];
};


export type QueryGetErrorCodeArgs = {
  error: Scalars['JSONObject'];
};


export type QueryGetEventMetricsArgs = {
  input?: InputMaybe<GetEventMetricsInput>;
};


export type QueryGetEventPayloadArgs = {
  input: GetEventPayloadInput;
};


export type QueryGetEventRequestArgs = {
  input?: InputMaybe<GetEventRequestInput>;
};


export type QueryGetEventTraceArgs = {
  input: GetEventTraceInput;
};


export type QueryGetEventWarehouseSyncRunArgs = {
  id: Scalars['String'];
};


export type QueryGetEventWarehouseSyncRunsArgs = {
  input?: InputMaybe<GetEventWarehouseSyncRunsInput>;
};


export type QueryGetFacebookAdAccountsArgs = {
  input: FacebookAdAccountInput;
};


export type QueryGetFailedEventsArgs = {
  input?: InputMaybe<GetFailedEventsInput>;
};


export type QueryGetFeatureMatrixColumnsForSegmentArgs = {
  decisionEngineId: Scalars['uuid'];
  segmentId: Scalars['Int'];
};


export type QueryGetFeatureMatrixSqlArgs = {
  featureMatrixId: Scalars['uuid'];
};


export type QueryGetFivetranConnectorsArgs = {
  groupId: Scalars['String'];
};


export type QueryGetFivetranDbtTransformationsArgs = {
  groupId: Scalars['String'];
};


export type QueryGetFivetranResourcesArgs = {
  groupId: Scalars['String'];
};


export type QueryGetFlowAggregationsArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetFlowMessageAggregationsArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetFunnelMetricResultBackgroundArgs = {
  jobIds: Array<Scalars['String']>;
};


export type QueryGetGeneratedFeatureSchemaArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetGithubBranchesArgs = {
  credentialId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  repo: Scalars['String'];
};


export type QueryGetGithubRepositoriesArgs = {
  credentialId: Scalars['String'];
};


export type QueryGetGoogleAdAccountsArgs = {
  input: GoogleAdAccountInput;
};


export type QueryGetIdrReingestsArgs = {
  idrId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  processed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetImageLineageGraphArgs = {
  input: GetImageLineageInput;
};


export type QueryGetInteractionArtifactArgs = {
  interactionId: Scalars['uuid'];
  path: Scalars['String'];
};


export type QueryGetLatestChartCardRunArgs = {
  chartCardId: Scalars['uuid'];
  options: DashboardOptions;
};


export type QueryGetLatestDashboardChartCardRunsArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  dashboardId?: InputMaybe<Scalars['uuid']>;
  options: DashboardOptions;
};


export type QueryGetLatestExperimentRunArgs = {
  experimentId: Scalars['uuid'];
  options: DashboardOptions;
};


export type QueryGetLatestSampledSegmentJobsArgs = {
  parentModelId: Scalars['bigint'];
};


export type QueryGetLatestSavedChartRunArgs = {
  options: DashboardOptions;
  savedChartId: Scalars['uuid'];
};


export type QueryGetLinkClicksArgs = {
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  messageId: Scalars['String'];
  since: Scalars['String'];
};


export type QueryGetLinkableResourcesArgs = {
  resourceType: DeploymentResourceType;
  sourceResourceId: Scalars['bigint'];
};


export type QueryGetLiveSourceEventsArgs = {
  input?: InputMaybe<LiveSourceEventsInput>;
};


export type QueryGetLookerLookArgs = {
  id: Scalars['String'];
  withSql?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetMarketingCampaignArtifactContentArgs = {
  input: GetMarketingCampaignArtifactContentInput;
};


export type QueryGetMarketingDestinationsArgs = {
  input: DestinationInput;
};


export type QueryGetMessageAbTestResultsArgs = {
  campaignRunId?: InputMaybe<Scalars['uuid']>;
  experimentId: Scalars['uuid'];
  since?: InputMaybe<Scalars['String']>;
};


export type QueryGetMessageActivityArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  timeRangeDays?: InputMaybe<Scalars['Int']>;
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetMessageAggregationsArgs = {
  messageId: Scalars['uuid'];
};


export type QueryGetMessageContactInfoArgs = {
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
};


export type QueryGetMessageEngagementArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  timeRangeDays?: InputMaybe<Scalars['Int']>;
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetMessageHourlyStatsBatchArgs = {
  messageIds: Array<Scalars['String']>;
  since: Scalars['String'];
};


export type QueryGetMessagePreviewStateArgs = {
  messageId: Scalars['uuid'];
};


export type QueryGetMessageSimilarityArgs = {
  agentId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};


export type QueryGetMessageSimilarityRatingArgs = {
  agentId: Scalars['uuid'];
};


export type QueryGetMessageSimilarityReasonsArgs = {
  comparedMessageIds: Array<InputMaybe<Scalars['String']>>;
  messageId: Scalars['uuid'];
};


export type QueryGetMessageStatsArgs = {
  campaignId?: InputMaybe<Scalars['String']>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  messageIds: Array<Scalars['String']>;
  since: Scalars['String'];
};


export type QueryGetMessageTimelineEventsArgs = {
  email?: InputMaybe<Scalars['String']>;
  messageExecutionId: Scalars['String'];
  messageId: Scalars['String'];
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetMessageVariableSimilarityArgs = {
  agentId: Scalars['uuid'];
  messageId: Scalars['uuid'];
};


export type QueryGetMessageVariablesArgs = {
  messageId: Scalars['uuid'];
};


export type QueryGetMessagesListArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  messageExecutionId?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  sortBy?: InputMaybe<MessagesSortKey>;
  timeRangeDays?: InputMaybe<Scalars['Int']>;
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetMetricResultBackgroundArgs = {
  jobIds: Array<Scalars['String']>;
};


export type QueryGetMigratedEventSyncConfigurationArgs = {
  id: Scalars['uuid'];
};


export type QueryGetModelCountsByPkBackgroundArgs = {
  input: ModelCountsByPkInput;
};


export type QueryGetModelCountsByPkBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryGetModelRowsByPkBackgroundArgs = {
  input: ModelRowsByPkInput;
};


export type QueryGetNativeDeliveryAgentGroupsArgs = {
  agentMessageId?: InputMaybe<Scalars['uuid']>;
  messageId?: InputMaybe<Scalars['uuid']>;
};


export type QueryGetOrganizationDestinationsArgs = {
  filters: OrganizationDestinationFilters;
};


export type QueryGetOrganizationGeneralModelsArgs = {
  filters: OrganizationGeneralModelFilters;
};


export type QueryGetOrganizationParentModelsArgs = {
  filters: OrganizationParentModelFilters;
};


export type QueryGetOrganizationSourcesArgs = {
  filters: OrganizationSourceFilters;
};


export type QueryGetOverlappingAgentEligibilityBackgroundArgs = {
  flowIds: Array<Scalars['uuid']>;
};


export type QueryGetPortalUrlArgs = {
  customer_id: Scalars['String'];
};


export type QueryGetPriorityListArgs = {
  id: Scalars['String'];
};


export type QueryGetQueueSourceArgs = {
  id: Scalars['String'];
};


export type QueryGetRelevantUsersForAssetArgs = {
  assetId: Scalars['uuid'];
};


export type QueryGetRequestInfoSetArgs = {
  plannerType: Scalars['String'];
  requestInfoKeys?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetSampleDataSourceDefinitionArgs = {
  sampleDataSourceId: Scalars['String'];
};


export type QueryGetSchemaGraphArgs = {
  parentModelId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};


export type QueryGetSendDiagnosticsArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetSigmaElementsArgs = {
  pageId: Scalars['String'];
  workbookId: Scalars['String'];
};


export type QueryGetSigmaPagesArgs = {
  workbookId: Scalars['String'];
};


export type QueryGetSigmaQueryArgs = {
  elementId: Scalars['String'];
  workbookId: Scalars['String'];
};


export type QueryGetSigmaWorkbookDetailArgs = {
  workbookId: Scalars['String'];
};


export type QueryGetSourceDefinedDescriptionArgs = {
  resourceId: Scalars['Int'];
};


export type QueryGetSourceDefinitionArgs = {
  input: SourceDefinitionInput;
};


export type QueryGetSourceDefinitionV2Args = {
  input: SourceDefinitionInputV2;
};


export type QueryGetSourceStrippedConfigurationArgs = {
  connectionId: Scalars['bigint'];
};


export type QueryGetSubscriptionEventsArgs = {
  email?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  timeRangeDays?: InputMaybe<Scalars['Int']>;
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetSuccessfulSyncOpsByDestinationArgs = {
  input: SuccessfulSyncOpsByDestinationInput;
};


export type QueryGetSyncAttemptProgressArgs = {
  id: Scalars['Int'];
};


export type QueryGetSyncMetadataArgs = {
  id: Scalars['bigint'];
};


export type QueryGetSyncReconciliationDataArgs = {
  flowId: Scalars['uuid'];
};


export type QueryGetSyncRequestEventsArgs = {
  debug?: InputMaybe<DebugParams>;
  syncId: Scalars['bigint'];
  syncRequestId: Scalars['bigint'];
};


export type QueryGetSyncRowsQueriedArgs = {
  input: SyncRowsQueriedInput;
};


export type QueryGetSyncRunMetricsArgs = {
  input: SyncRunMetricsInput;
};


export type QueryGetTagsBackgroundJobResultArgs = {
  jobId: Scalars['String'];
};


export type QueryGetTagsForMessagesBackgroundArgs = {
  decisionEngineChannelId: Scalars['uuid'];
};


export type QueryGetTopKArgs = {
  columnNames: Array<Scalars['String']>;
  modelIds: Array<Scalars['String']>;
};


export type QueryGetTransformedRetlAndRealtimeSyncConfigurationArgs = {
  id: Scalars['String'];
};


export type QueryGetTransformedSyncConfigurationArgs = {
  id: Scalars['bigint'];
};


export type QueryGetTransformedSyncRunConfigurationArgs = {
  id: Scalars['bigint'];
  runId: Scalars['bigint'];
};


export type QueryGetTransformedSyncTemplateConfigurationArgs = {
  id: Scalars['Int'];
};


export type QueryGetTunnelArgs = {
  id: Scalars['String'];
};


export type QueryGetUserDevicesArgs = {
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
  timeRangeDays?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUserInferredTimeZoneArgs = {
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
};


export type QueryGetUserSubscriptionsArgs = {
  email?: InputMaybe<Scalars['String']>;
  parentModelId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primaryKeyValue: Scalars['String'];
  userHandle?: InputMaybe<Scalars['String']>;
  whatsappHandle?: InputMaybe<Scalars['String']>;
};


export type QueryGetVideoExportBundleStatusArgs = {
  input: GetVideoExportBundleStatusInput;
};


export type QueryGetVideoExportStatusArgs = {
  input: GetVideoExportStatusInput;
};


export type QueryGetWarehouseSyncErrorSummaryArgs = {
  input: GetWarehouseSyncErrorSummaryInput;
};


export type QueryGettyImagesByIdsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryGettySearchImagesArgs = {
  compositions?: InputMaybe<Array<GettyComposition>>;
  graphicalStyles?: InputMaybe<Array<GettyGraphicalStyle>>;
  orientations?: InputMaybe<Array<GettyOrientation>>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  phrase: Scalars['String'];
  sortOrder?: InputMaybe<GettySortOrder>;
};


export type QueryGitCredentialsArgs = {
  distinct_on?: InputMaybe<Array<GitCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitCredentialsOrderBy>>;
  where?: InputMaybe<GitCredentialsBoolExp>;
};


export type QueryGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitInboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitInboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitInboundRunsOrderBy>>;
  where?: InputMaybe<GitInboundRunsBoolExp>;
};


export type QueryGitInboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitOutboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitOutboundRunsOrderBy>>;
  where?: InputMaybe<GitOutboundRunsBoolExp>;
};


export type QueryGitOutboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGitSyncConfigsArgs = {
  distinct_on?: InputMaybe<Array<GitSyncConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitSyncConfigsOrderBy>>;
  where?: InputMaybe<GitSyncConfigsBoolExp>;
};


export type QueryGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryGlobalDecisioningAgentSummaryArgs = {
  groupId: Scalars['uuid'];
  lookbackDays: Scalars['Int'];
};


export type QueryGlobalDecisioningCompetitionArgs = {
  groupId: Scalars['uuid'];
  lookbackDays: Scalars['Int'];
};


export type QueryGlobalDecisioningConfigChangesArgs = {
  groupId: Scalars['uuid'];
  lookbackDays: Scalars['Int'];
};


export type QueryGlobalDecisioningDecisionMixArgs = {
  flowId?: InputMaybe<Scalars['uuid']>;
  groupId: Scalars['uuid'];
  lookbackDays: Scalars['Int'];
};


export type QueryGlobalDecisioningUserTimelineArgs = {
  fromDate: Scalars['String'];
  groupId: Scalars['uuid'];
  primaryKey: Scalars['String'];
  toDate?: InputMaybe<Scalars['String']>;
};


export type QueryGoalMetricsArgs = {
  distinct_on?: InputMaybe<Array<GoalMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalMetricsOrderBy>>;
  where?: InputMaybe<GoalMetricsBoolExp>;
};


export type QueryGoalMetricsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryGoalsArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


export type QueryGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


export type QueryGoalsAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<GoalsAttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsAttributionMethodsOrderBy>>;
  where?: InputMaybe<GoalsAttributionMethodsBoolExp>;
};


export type QueryGoalsAttributionMethodsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  goal_id: Scalars['uuid'];
};


export type QueryGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryGooglesheetsListSheetsArgs = {
  input: GooglesheetsListSheetsInput;
};


export type QueryGooglesheetsListSpreadSheetsArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  destinationId?: InputMaybe<Scalars['Int']>;
};


export type QueryGooglesheetsSourceListSheetsArgs = {
  connectionId: Scalars['String'];
};


export type QueryHouseholdMembershipsBackgroundArgs = {
  input: HouseholdMembershipsInput;
};


export type QueryHouseholdMembershipsBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryHubspotDescribeGlobalArgs = {
  input: HubSpotDescribeGlobalInput;
};


export type QueryHubspotDescribeObjectArgs = {
  input: HubSpotDescribeObjectInput;
};


export type QueryHubspotLegacyDescribeGlobalArgs = {
  input: HubSpotLegacyDescribeGlobalInput;
};


export type QueryHubspotLegacyDescribeObjectArgs = {
  input: HubSpotLegacyDescribeObjectInput;
};


export type QueryIdrArgs = {
  distinct_on?: InputMaybe<Array<IdrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrOrderBy>>;
  where?: InputMaybe<IdrBoolExp>;
};


export type QueryIdrIdentifierSuggestionsArgs = {
  input: IdrIdentifierSuggestionsInput;
};


export type QueryIdrMergeConvergenceArgs = {
  idrGraphId: Scalars['String'];
  records: Array<IdrMergeConvergenceRecordInput>;
};


export type QueryIdrPidrOverlayArgs = {
  finalHtIds: Array<Scalars['String']>;
  idrGraphId: Scalars['String'];
};


export type QueryIdrProfileAnalysisBackgroundArgs = {
  input: IdrProfileAnalysisRequest;
};


export type QueryIdrProfileAnalysisSqlArgs = {
  input: IdrProfileAnalysisRequest;
};


export type QueryIdrProfilesArgs = {
  input: IdrProfilesRequest;
};


export type QueryIdrProfilesJobResultArgs = {
  jobId: Scalars['String'];
};


export type QueryIdrRuleSuggestionsArgs = {
  input: IdrRuleSuggestionsInput;
};


export type QueryIdrSequenceLinksArgs = {
  idrId: Scalars['String'];
};


export type QueryIdrByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryIdrGoldenRecordBaseColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordBaseColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordBaseColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
};


export type QueryIdrGoldenRecordBaseColumnsByPkArgs = {
  column_name: Scalars['String'];
  golden_record_id: Scalars['uuid'];
  idr_model_id: Scalars['uuid'];
  model_id: Scalars['bigint'];
};


export type QueryIdrGoldenRecordColumnSourceSurvivorshipArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
};


export type QueryIdrGoldenRecordColumnSourceSurvivorshipByPkArgs = {
  golden_record_column_id: Scalars['uuid'];
  idr_model_id: Scalars['uuid'];
};


export type QueryIdrGoldenRecordColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
};


export type QueryIdrGoldenRecordColumnsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryIdrGoldenRecordsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordsBoolExp>;
};


export type QueryIdrGoldenRecordsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryIdrModelMappingsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelMappingsOrderBy>>;
  where?: InputMaybe<IdrModelMappingsBoolExp>;
};


export type QueryIdrModelMappingsByPkArgs = {
  column: Scalars['String'];
  idr_model_id: Scalars['uuid'];
  model_id: Scalars['bigint'];
};


export type QueryIdrModelsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelsOrderBy>>;
  where?: InputMaybe<IdrModelsBoolExp>;
};


export type QueryIdrModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryIdrOutputSegmentsArgs = {
  distinct_on?: InputMaybe<Array<IdrOutputSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrOutputSegmentsOrderBy>>;
  where?: InputMaybe<IdrOutputSegmentsBoolExp>;
};


export type QueryIdrRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


export type QueryIdrRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


export type QueryIdrRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryIdrTrainingRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


export type QueryIdrTrainingRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


export type QueryIdrTrainingRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInboxArgs = {
  filters?: InputMaybe<InboxFiltersInput>;
  updatesLimit: Scalars['Int'];
};


export type QueryIncomingWebhooksArgs = {
  distinct_on?: InputMaybe<Array<IncomingWebhooksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IncomingWebhooksOrderBy>>;
  where?: InputMaybe<IncomingWebhooksBoolExp>;
};


export type QueryIncomingWebhooksByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInitiativeGoalsArgs = {
  distinct_on?: InputMaybe<Array<InitiativeGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeGoalsOrderBy>>;
  where?: InputMaybe<InitiativeGoalsBoolExp>;
};


export type QueryInitiativeGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInitiativeInsightsArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


export type QueryInitiativeInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


export type QueryInitiativeInsightsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInsightsAgentDataSourcesArgs = {
  distinct_on?: InputMaybe<Array<InsightsAgentDataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InsightsAgentDataSourcesOrderBy>>;
  where?: InputMaybe<InsightsAgentDataSourcesBoolExp>;
};


export type QueryInsightsAgentDataSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInspectPushPayloadArgs = {
  input: InspectPushPayloadInput;
};


export type QueryInspectorMessagesBackgroundArgs = {
  input?: InputMaybe<InspectorMessagesBackgroundInput>;
};


export type QueryInspectorV2MessagesBackgroundArgs = {
  input?: InputMaybe<InspectorV2MessagesBackgroundInput>;
};


export type QueryInspirationBoardArgs = {
  id: Scalars['ID'];
};


export type QueryInspirationBoardAdsArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


export type QueryInspirationBoardAdsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


export type QueryInspirationBoardAdsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInspirationBoardsArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardsOrderBy>>;
  where?: InputMaybe<InspirationBoardsBoolExp>;
};


export type QueryInspirationBoardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardsOrderBy>>;
  where?: InputMaybe<InspirationBoardsBoolExp>;
};


export type QueryInspirationBoardsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryInteractionContextFilesReadArgs = {
  interactionId: Scalars['uuid'];
  windowDays?: InputMaybe<Scalars['Int']>;
};


export type QueryInteractionModelsArgs = {
  distinct_on?: InputMaybe<Array<InteractionModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InteractionModelsOrderBy>>;
  where?: InputMaybe<InteractionModelsBoolExp>;
};


export type QueryInteractionModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type QueryIntercomListAttributesArgs = {
  input: IntercomListAttributesInput;
};


export type QueryIsAdminEntitlementRequiredArgs = {
  workspaceId?: InputMaybe<Scalars['Int']>;
};


export type QueryIsDestinationAuthorizedArgs = {
  canAction: CanAction;
  destinationId?: InputMaybe<Scalars['String']>;
};


export type QueryIsModelAuthorizedArgs = {
  canAction: CanAction;
  modelId?: InputMaybe<Scalars['String']>;
  parentModelId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ModelType>;
};


export type QueryIsOrganizationAvailableArgs = {
  name: Scalars['String'];
};


export type QueryIsResourceAuthorizedArgs = {
  v2?: InputMaybe<ResourceAuthorizationInput>;
};


export type QueryIsResourceSlugAvailableArgs = {
  resourceType: SlugResourceType;
  slug: Scalars['String'];
};


export type QueryIsResourcesAuthorizedArgs = {
  inputs: Array<ResourceAuthorizationBatchInput>;
};


export type QueryIsSourceAuthorizedArgs = {
  canAction: CanAction;
  sourceId?: InputMaybe<Scalars['String']>;
};


export type QueryIsSyncAuthorizedArgs = {
  canAction: CanAction;
  destinationId?: InputMaybe<Scalars['String']>;
  modelId?: InputMaybe<Scalars['String']>;
  syncId?: InputMaybe<Scalars['String']>;
  syncTemplateId?: InputMaybe<Scalars['String']>;
};


export type QueryIsValidEventSchemaArgs = {
  input: Scalars['JSONObject'];
};


export type QueryIsWorkspaceAuthorizedArgs = {
  canAction: CanAction;
};


export type QueryIsWorkspaceSlugAvailableArgs = {
  slug: Scalars['String'];
};


export type QueryIterableGetCampaignsArgs = {
  input: IterableGetCampaignsInput;
};


export type QueryIterableGetCatalogFieldsArgs = {
  input?: InputMaybe<IterableGetCatalogFieldsInput>;
};


export type QueryIterableGetCatalogsArgs = {
  input: IterableGetCatalogsInput;
};


export type QueryIterableGetTemplatesArgs = {
  input: IterableGetTemplatesInput;
};


export type QueryIterableUserFieldsArgs = {
  input: IterableUserFieldsInput;
};


export type QueryJourneyChangeLogArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneyContextVariablesBackgroundArgs = {
  parentModelId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryJourneyContextVariablesBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryJourneyEntityPathQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  eventRowId?: InputMaybe<Scalars['String']>;
  journeyId: Scalars['String'];
  rowId: Scalars['String'];
  simulationId?: InputMaybe<Scalars['uuid']>;
};


export type QueryJourneyMembershipsBackgroundArgs = {
  parentModelId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryJourneyMembershipsBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryJourneyNodeMembersQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  direction?: InputMaybe<Scalars['String']>;
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  eventRowId?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  includeEventDetails?: InputMaybe<Scalars['Boolean']>;
  journeyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nodeId?: InputMaybe<Scalars['String']>;
  rowId?: InputMaybe<Scalars['String']>;
  simulationId?: InputMaybe<Scalars['uuid']>;
};


export type QueryJourneyNodeQueryBackgroundArgs = {
  additionalColumns?: InputMaybe<Array<Scalars['JSONObject']>>;
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  primaryKeyIds?: InputMaybe<Array<Scalars['String']>>;
  simulationId?: InputMaybe<Scalars['uuid']>;
};


export type QueryJourneyRealtimeSyncConfigsArgs = {
  journeyId: Scalars['String'];
};


export type QueryJourneyTraitsArgs = {
  journeyId: Scalars['String'];
};


export type QueryJourneyDecisionEngineFlowsArgs = {
  distinct_on?: InputMaybe<Array<JourneyDecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
};


export type QueryJourneyDraftsArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


export type QueryJourneyDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


export type QueryJourneyDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneyEdgesArgs = {
  distinct_on?: InputMaybe<Array<JourneyEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyEdgesOrderBy>>;
  where?: InputMaybe<JourneyEdgesBoolExp>;
};


export type QueryJourneyEdgesByPkArgs = {
  from_node_id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
  to_node_id: Scalars['uuid'];
};


export type QueryJourneyLabelsArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


export type QueryJourneyLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


export type QueryJourneyLabelsByPkArgs = {
  journey_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type QueryJourneyMessagesArgs = {
  distinct_on?: InputMaybe<Array<JourneyMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyMessagesOrderBy>>;
  where?: InputMaybe<JourneyMessagesBoolExp>;
};


export type QueryJourneyMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneyNodeRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodeRunsOrderBy>>;
  where?: InputMaybe<JourneyNodeRunsBoolExp>;
};


export type QueryJourneyNodeRunsByPkArgs = {
  node_id: Scalars['uuid'];
  run_id: Scalars['uuid'];
};


export type QueryJourneyNodesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


export type QueryJourneyNodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


export type QueryJourneyNodesByPkArgs = {
  id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
};


export type QueryJourneyNotesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


export type QueryJourneyNotesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


export type QueryJourneyRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


export type QueryJourneyRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


export type QueryJourneyRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneySimulationsArgs = {
  distinct_on?: InputMaybe<Array<JourneySimulationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySimulationsOrderBy>>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};


export type QueryJourneySimulationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneySimulationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySimulationsOrderBy>>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};


export type QueryJourneySimulationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneySyncsArgs = {
  distinct_on?: InputMaybe<Array<JourneySyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySyncsOrderBy>>;
  where?: InputMaybe<JourneySyncsBoolExp>;
};


export type QueryJourneySyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneyTemplateReferencesArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplateReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplateReferencesOrderBy>>;
  where?: InputMaybe<JourneyTemplateReferencesBoolExp>;
};


export type QueryJourneyTemplateReferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneyTemplatesArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplatesOrderBy>>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};


export type QueryJourneyTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplatesOrderBy>>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};


export type QueryJourneyTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryJourneysArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};


export type QueryJourneysAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};


export type QueryJourneysByPkArgs = {
  id: Scalars['uuid'];
  version_id: Scalars['uuid'];
};


export type QueryKlaviyoConversionMetricsArgs = {
  input: KlaviyoConversionMetricsInput;
};


export type QueryLabelGroupsArgs = {
  distinct_on?: InputMaybe<Array<LabelGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelGroupsOrderBy>>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};


export type QueryLabelGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LabelGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelGroupsOrderBy>>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};


export type QueryLabelGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLabelsArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};


export type QueryLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};


export type QueryLabelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLatestIngestionJobArgs = {
  destinationId: Scalars['String'];
};


export type QueryLatestMessagePreviewRunArgs = {
  flowMessageId: MessagePreviewFlowMessageIdInput;
};


export type QueryLcmMessageCandidatesArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


export type QueryLcmMessageCandidatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


export type QueryLcmMessageCandidatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLcmMessagePlansArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


export type QueryLcmMessagePlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


export type QueryLcmMessagePlansByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLcsTriggeredSendQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId: Scalars['Int'];
};


export type QueryLibraryImageArgs = {
  id: Scalars['uuid'];
};


export type QueryLibraryImageCountsByGroupArgs = {
  where?: InputMaybe<LibraryImagesFilter>;
};


export type QueryLibraryImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LibraryImagesFilter>;
};


export type QueryLibraryImagesAggregateArgs = {
  where?: InputMaybe<LibraryImagesFilter>;
};


export type QueryLineageGraphArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryListAllSourceDependenciesArgs = {
  ids: Array<Scalars['bigint']>;
};


export type QueryListAllTraitReferencesV2Args = {
  id: Scalars['String'];
};


export type QueryListAmpFilesArgs = {
  brandProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  favorites?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Scalars['ID']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  mine?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<AmpFileSort>;
  type?: InputMaybe<AmpFileType>;
  types?: InputMaybe<Array<AmpFileType>>;
};


export type QueryListAvailableThroughRelationshipsArgs = {
  modelId: Scalars['String'];
  sourceId: Scalars['String'];
};


export type QueryListContentBlocksFromDestinationArgs = {
  destinationId: Scalars['String'];
};


export type QueryListEmailMessageTypesFromDestinationArgs = {
  destinationId: Scalars['String'];
};


export type QueryListEmailTemplatesFromDestinationArgs = {
  destinationId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<IterableTemplateType>;
};


export type QueryListEmailTemplatesFromDestinationPaginatedArgs = {
  destinationId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<IterableTemplateType>;
};


export type QueryListFilterableColumnsArgs = {
  segmentId: Scalars['bigint'];
};


export type QueryListFoldersArgs = {
  folderType?: InputMaybe<FolderType>;
  resourceType: FolderResourceType;
};


export type QueryListGitRepositoryTreeArgs = {
  branch: Scalars['String'];
  credentialId: Scalars['bigint'];
  repository: Scalars['String'];
};


export type QueryListGoogleDriveContextFilesArgs = {
  allowedDomains?: InputMaybe<Array<Scalars['String']>>;
  auth: GoogleDriveContextAuth;
  credentialId: Scalars['bigint'];
  fileIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryListInteractionArtifactsArgs = {
  interactionId: Scalars['uuid'];
};


export type QueryListJourneyEntryEventMergeTagColumnsArgs = {
  eventRelationshipId: Scalars['String'];
  journeyId?: InputMaybe<Scalars['String']>;
};


export type QueryListJourneySyncableContextColumnsArgs = {
  journeyId: Scalars['String'];
};


export type QueryListJourneySyncableEventColumnsArgs = {
  eventRelationshipId: Scalars['String'];
  journeyId?: InputMaybe<Scalars['String']>;
};


export type QueryListMergeTagColumnsArgs = {
  modelId: Scalars['String'];
  realtimeJourneyId?: InputMaybe<Scalars['String']>;
};


export type QueryListModelColumnsArgs = {
  modelId: Scalars['bigint'];
};


export type QueryListModelDependenciesArgs = {
  id: Scalars['String'];
};


export type QueryListPushCampaignsFromDestinationArgs = {
  destinationId: Scalars['String'];
};


export type QueryListRelationshipDependenciesArgs = {
  id: Scalars['String'];
};


export type QueryListRelationshipsArgs = {
  modelId: Scalars['String'];
};


export type QueryListSemanticViewsArgs = {
  connectionId: Scalars['String'];
};


export type QueryListSlackChannelsByCredentialsArgs = {
  currentChannelId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type QueryListSmsCampaignsFromDestinationArgs = {
  destinationId: Scalars['String'];
};


export type QueryListSourceTestStepsArgs = {
  input: TestSourceInput;
};


export type QueryListSyncableColumnRowKeysArgs = {
  modelId: Scalars['bigint'];
};


export type QueryListSyncableColumnsArgs = {
  modelId: Scalars['bigint'];
};


export type QueryListTraitDefinitionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  predictorFeatureDefinitionId?: InputMaybe<Scalars['uuid']>;
  search?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['bigint']>;
  sortDirection?: InputMaybe<TraitDefinitionsSortDirection>;
  sortKey?: InputMaybe<TraitDefinitionsSortKey>;
};


export type QueryLlmBackgroundJobResultArgs = {
  jobId: Scalars['String'];
};


export type QueryLlmChatInteractionDetailsArgs = {
  devMode?: InputMaybe<Scalars['Boolean']>;
  interactionId: Scalars['uuid'];
};


export type QueryLlmChatInteractionsArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


export type QueryLlmChatInteractionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


export type QueryLlmChatInteractionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLlmChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


export type QueryLlmChatMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


export type QueryLlmChatMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLlmChatSessionsArgs = {
  distinct_on?: InputMaybe<Array<LlmChatSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatSessionsOrderBy>>;
  where?: InputMaybe<LlmChatSessionsBoolExp>;
};


export type QueryLlmChatSessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLlmInferenceBackendsArgs = {
  distinct_on?: InputMaybe<Array<LlmInferenceBackendsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmInferenceBackendsOrderBy>>;
  where?: InputMaybe<LlmInferenceBackendsBoolExp>;
};


export type QueryLlmInferenceBackendsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryLookerLookQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  lookId: Scalars['String'];
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryLookerCredentialsArgs = {
  distinct_on?: InputMaybe<Array<LookerCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LookerCredentialsOrderBy>>;
  where?: InputMaybe<LookerCredentialsBoolExp>;
};


export type QueryLookerCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryManagedSettingsEntityUsageArgs = {
  entityIds: Array<Scalars['uuid']>;
  windowDays?: InputMaybe<Scalars['Int']>;
};


export type QueryMarketingCampaignMessagesArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


export type QueryMarketingCampaignMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


export type QueryMarketingCampaignMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMarketingCampaignsArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignsOrderBy>>;
  where?: InputMaybe<MarketingCampaignsBoolExp>;
};


export type QueryMarketingCampaignsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignsOrderBy>>;
  where?: InputMaybe<MarketingCampaignsBoolExp>;
};


export type QueryMarketingCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMatchBoosterTestArgs = {
  modelId: Scalars['String'];
  region: MatchBoosterRegion;
};


export type QueryMatchboostingConfigArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingConfigOrderBy>>;
  where?: InputMaybe<MatchboostingConfigBoolExp>;
};


export type QueryMatchboostingConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMatchboostingStatsArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingStatsOrderBy>>;
  where?: InputMaybe<MatchboostingStatsBoolExp>;
};


export type QueryMatchboostingStatsByPkArgs = {
  uuid: Scalars['uuid'];
};


export type QueryMatchboostingWorkspaceConfigArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingWorkspaceConfigOrderBy>>;
  where?: InputMaybe<MatchboostingWorkspaceConfigBoolExp>;
};


export type QueryMatchboostingWorkspaceConfigByPkArgs = {
  config_name: Scalars['String'];
  destination: Scalars['String'];
  region: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type QueryMessagePreviewDeliverySetupArgs = {
  channelId: Scalars['uuid'];
  flowMessageId: MessagePreviewFlowMessageIdInput;
};


export type QueryMessagePreviewRunsArgs = {
  flowMessageId: MessagePreviewFlowMessageIdInput;
};


export type QueryMessagePreviewUnmatchedEmailRenderArgs = {
  runId: Scalars['uuid'];
};


export type QueryMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


export type QueryMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


export type QueryMessageContentsBaseArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsBaseOrderBy>>;
  where?: InputMaybe<MessageContentsBaseBoolExp>;
};


export type QueryMessageContentsBaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsBaseOrderBy>>;
  where?: InputMaybe<MessageContentsBaseBoolExp>;
};


export type QueryMessageContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMessageContentsMetadataArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


export type QueryMessageContentsMetadataAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


export type QueryMessageContentsMetadataBaseArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataBaseOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
};


export type QueryMessageContentsMetadataBaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataBaseOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
};


export type QueryMessageContentsMetadataByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMessageExperimentsArgs = {
  distinct_on?: InputMaybe<Array<MessageExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageExperimentsOrderBy>>;
  where?: InputMaybe<MessageExperimentsBoolExp>;
};


export type QueryMessageExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMessageLabelsArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


export type QueryMessageLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


export type QueryMessageLabelsByPkArgs = {
  label_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
};


export type QueryMessagePushAppsArgs = {
  distinct_on?: InputMaybe<Array<MessagePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagePushAppsOrderBy>>;
  where?: InputMaybe<MessagePushAppsBoolExp>;
};


export type QueryMessagePushAppsByPkArgs = {
  message_id: Scalars['uuid'];
  push_app_id: Scalars['uuid'];
};


export type QueryMessageVariantArmArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


export type QueryMessageVariantArmAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


export type QueryMessageVariantArmByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type QueryMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type QueryMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMetabaseListDatabasesArgs = {
  connectionId: Scalars['String'];
};


export type QueryMetabaseListQuestionsArgs = {
  connectionId: Scalars['String'];
};


export type QueryMetabaseListTablesArgs = {
  connectionId: Scalars['String'];
};


export type QueryMicrosoftexcelListSheetsArgs = {
  connectionId: Scalars['String'];
  workbookId: Scalars['String'];
};


export type QueryMicrosoftexcelListWorkbooksArgs = {
  connectionId: Scalars['String'];
};


export type QueryMigrateConfigArgs = {
  draftId: Scalars['String'];
};


export type QueryMixpanelListCohortsArgs = {
  connectionId: Scalars['String'];
  projectId: Scalars['Int'];
};


export type QueryMixpanelListProjectsArgs = {
  connectionId: Scalars['String'];
};


export type QueryModelCanActionGrantsArgs = {
  modelId: Scalars['String'];
};


export type QueryModelHasAncestorParentModelArgs = {
  modelId: Scalars['String'];
};


export type QueryModelColumnReferencesArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesBoolExp>;
};


export type QueryModelColumnReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesBoolExp>;
};


export type QueryModelColumnReferencesByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type QueryModelColumnReferencesSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


export type QueryModelColumnReferencesSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


export type QueryModelColumnReferencesSyncsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSyncsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
};


export type QueryModelColumnReferencesSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSyncsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
};


export type QueryModelColumnsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


export type QueryModelColumnsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


export type QueryModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


export type QueryModelRelationshipReferencesArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipReferencesOrderBy>>;
  where?: InputMaybe<ModelRelationshipReferencesBoolExp>;
};


export type QueryModelRelationshipReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipReferencesOrderBy>>;
  where?: InputMaybe<ModelRelationshipReferencesBoolExp>;
};


export type QueryModelRelationshipReferencesByPkArgs = {
  model_relationship_id: Scalars['bigint'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type QueryModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipsOrderBy>>;
  where?: InputMaybe<ModelRelationshipsBoolExp>;
};


export type QueryModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryMongodbListCollectionsArgs = {
  input: MongoDbListCollectionsInput;
};


export type QueryMongodbSourceListCollectionsArgs = {
  connectionId: Scalars['String'];
  database: Scalars['String'];
};


export type QueryMongodbSourceListDatabasesArgs = {
  connectionId: Scalars['String'];
};


export type QueryMonitorConditionStatusesArgs = {
  distinct_on?: InputMaybe<Array<MonitorConditionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitorConditionStatusesOrderBy>>;
  where?: InputMaybe<MonitorConditionStatusesBoolExp>;
};


export type QueryMonitorConditionStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryMonitorConditionTemplatesArgs = {
  distinct_on?: InputMaybe<Array<MonitorConditionTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitorConditionTemplatesOrderBy>>;
  where?: InputMaybe<MonitorConditionTemplatesBoolExp>;
};


export type QueryMonitorConditionTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryNotificationChannelTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannelTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationChannelTemplatesOrderBy>>;
  where?: InputMaybe<NotificationChannelTemplatesBoolExp>;
};


export type QueryNotificationChannelTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryObjectDefinitionGroupsArgs = {
  distinct_on?: InputMaybe<Array<ObjectDefinitionGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectDefinitionGroupsOrderBy>>;
  where?: InputMaybe<ObjectDefinitionGroupsBoolExp>;
};


export type QueryObjectDefinitionGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryObjectDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ObjectDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectDefinitionsOrderBy>>;
  where?: InputMaybe<ObjectDefinitionsBoolExp>;
};


export type QueryObjectDefinitionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryObjectSchemasArgs = {
  distinct_on?: InputMaybe<Array<ObjectSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectSchemasOrderBy>>;
  where?: InputMaybe<ObjectSchemasBoolExp>;
};


export type QueryObjectSchemasByPkArgs = {
  key: Scalars['String'];
  object_definition_id: Scalars['bigint'];
};


export type QueryOrangeLogicFolderTreeArgs = {
  extensionId: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['String']>;
};


export type QueryOrbitListWorkspacesArgs = {
  input: OrbitListWorkspacesInput;
};


export type QueryOrganizationActiveSyncsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationActiveSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationActiveSyncsOrderBy>>;
  where?: InputMaybe<OrganizationActiveSyncsBoolExp>;
};


export type QueryOrganizationActiveSyncsByPkArgs = {
  pkey: Scalars['String'];
};


export type QueryOrganizationInvitesArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesOrderBy>>;
  where?: InputMaybe<OrganizationInvitesBoolExp>;
};


export type QueryOrganizationInvitesAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesOrderBy>>;
  where?: InputMaybe<OrganizationInvitesBoolExp>;
};


export type QueryOrganizationInvitesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryOrganizationInvitesUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesUserGroupsOrderBy>>;
  where?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
};


export type QueryOrganizationInvitesUserGroupsByPkArgs = {
  organization_invite_id: Scalars['bigint'];
  user_group_id: Scalars['bigint'];
};


export type QueryOrganizationMembersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


export type QueryOrganizationMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


export type QueryOrganizationMembersDistinctArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersDistinctSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersDistinctOrderBy>>;
  where?: InputMaybe<OrganizationMembersDistinctBoolExp>;
};


export type QueryOrganizationMembersDistinctAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersDistinctSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersDistinctOrderBy>>;
  where?: InputMaybe<OrganizationMembersDistinctBoolExp>;
};


export type QueryOrganizationOverageDatesArgs = {
  distinct_on?: InputMaybe<Array<OrganizationOverageDatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationOverageDatesOrderBy>>;
  where?: InputMaybe<OrganizationOverageDatesBoolExp>;
};


export type QueryOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type QueryOrganizationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryPagerdutyCredentialsArgs = {
  distinct_on?: InputMaybe<Array<PagerdutyCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PagerdutyCredentialsOrderBy>>;
  where?: InputMaybe<PagerdutyCredentialsBoolExp>;
};


export type QueryPagerdutyCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryPartnerConnectGetConnectionArgs = {
  uuid: Scalars['String'];
};


export type QueryPartnerConnectGetInformationArgs = {
  uuid: Scalars['String'];
};


export type QueryPredictorArtifactsArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


export type QueryPredictorArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


export type QueryPredictorArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPredictorFeatureDefinitionEventsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionEventsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
};


export type QueryPredictorFeatureDefinitionEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPredictorFeatureDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
};


export type QueryPredictorFeatureDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPredictorOutcomesArgs = {
  distinct_on?: InputMaybe<Array<PredictorOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorOutcomesOrderBy>>;
  where?: InputMaybe<PredictorOutcomesBoolExp>;
};


export type QueryPredictorOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPredictorRunsArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


export type QueryPredictorRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


export type QueryPredictorRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPredictorsArgs = {
  distinct_on?: InputMaybe<Array<PredictorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorsOrderBy>>;
  where?: InputMaybe<PredictorsBoolExp>;
};


export type QueryPredictorsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPreviewFeatureMatrixForFlowArgs = {
  input: PreviewFeatureMatrixForFlowInput;
};


export type QueryPreviewMatchingEntryEventArgs = {
  input: PreviewMatchingEntryEventInput;
};


export type QueryPreviewMatchingProfileArgs = {
  input: PreviewMatchingProfileInput;
};


export type QueryPreviewQuerySchemaBackgroundJobResultArgs = {
  input: BackgroundJobInput;
};


export type QueryPriorityListMembershipsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListMembershipsOrderBy>>;
  where?: InputMaybe<PriorityListMembershipsBoolExp>;
};


export type QueryPriorityListMembershipsByPkArgs = {
  priority_list_id: Scalars['bigint'];
  segment_id: Scalars['bigint'];
};


export type QueryPriorityListsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListsOrderBy>>;
  where?: InputMaybe<PriorityListsBoolExp>;
};


export type QueryPriorityListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PriorityListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListsOrderBy>>;
  where?: InputMaybe<PriorityListsBoolExp>;
};


export type QueryPriorityListsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryPublicImageJobResultArgs = {
  jobId: Scalars['String'];
};


export type QueryPushAppsArgs = {
  distinct_on?: InputMaybe<Array<PushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushAppsOrderBy>>;
  where?: InputMaybe<PushAppsBoolExp>;
};


export type QueryPushAppsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryPushConfigArgs = {
  distinct_on?: InputMaybe<Array<PushConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushConfigOrderBy>>;
  where?: InputMaybe<PushConfigBoolExp>;
};


export type QueryPushConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<PushConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushConfigOrderBy>>;
  where?: InputMaybe<PushConfigBoolExp>;
};


export type QueryPushConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryQueryExportArgs = {
  rawSql?: InputMaybe<Scalars['String']>;
  syncRunId: Scalars['Int'];
};


export type QueryQueryExportCompareArgs = {
  rawSql?: InputMaybe<Scalars['String']>;
  syncRunId1: Scalars['Int'];
  syncRunId2: Scalars['Int'];
};


export type QueryQueryRunsArgs = {
  distinct_on?: InputMaybe<Array<QueryRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QueryRunsOrderBy>>;
  where?: InputMaybe<QueryRunsBoolExp>;
};


export type QueryQueryRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRawSqlQueryBackgroundArgs = {
  cacheKey?: InputMaybe<Scalars['String']>;
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sql: Scalars['String'];
};


export type QueryRealtimeAddressTraitsArgs = {
  parentModelId: Scalars['ID'];
};


export type QueryRealtimeJourneyConditionsAtPullArgs = {
  journeyId: Scalars['String'];
  pullRunId: Scalars['String'];
};


export type QueryRealtimeAudienceSyncSegmentsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


export type QueryRealtimeAudienceSyncSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


export type QueryRealtimeAudienceSyncSegmentsByPkArgs = {
  segment_id: Scalars['bigint'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryRealtimeAudienceSyncsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
};


export type QueryRealtimeAudienceSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRealtimeAudiencesScheduledWarehousePullsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsBoolExp>;
};


export type QueryRealtimeAudiencesWarehousePullRunsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


export type QueryRealtimeAudiencesWarehousePullRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


export type QueryRelatedGoldenRecordArgs = {
  segmentId: Scalars['bigint'];
};


export type QueryRelationshipReferencesArgs = {
  distinct_on?: InputMaybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipReferencesOrderBy>>;
  where?: InputMaybe<RelationshipReferencesBoolExp>;
};


export type QueryRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type QueryRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<RelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipsOrderBy>>;
  where?: InputMaybe<RelationshipsBoolExp>;
};


export type QueryRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRenderContentEmailWithContentBlocksV2Args = {
  campaignId?: InputMaybe<Scalars['String']>;
  contentEmailId: Scalars['String'];
  versionId?: InputMaybe<Scalars['String']>;
};


export type QueryRenderEmailHtmlWithContentBlocksArgs = {
  campaignId?: InputMaybe<Scalars['String']>;
  contentEmailId: Scalars['String'];
  localSource: LocalEmailTemplateInput;
};


export type QueryRenderMessageArgs = {
  input: RenderMessageInput;
};


export type QueryRenderNativeDeliveryAgentPreviewArgs = {
  agentMessageId: Scalars['uuid'];
  user?: InputMaybe<Scalars['JSON']>;
  variables?: InputMaybe<Scalars['JSON']>;
};


export type QueryRenderedMonitorConditionStatusesArgs = {
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  statusIds: Array<Scalars['uuid']>;
};


export type QueryReportCardByRunIdArgs = {
  runId: Scalars['uuid'];
};


export type QueryReportRunContentArgs = {
  runId: Scalars['uuid'];
};


export type QueryReportScheduleArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleOrderBy>>;
  where?: InputMaybe<ReportScheduleBoolExp>;
};


export type QueryReportScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleOrderBy>>;
  where?: InputMaybe<ReportScheduleBoolExp>;
};


export type QueryReportScheduleByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryReportScheduleRunCommentsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


export type QueryReportScheduleRunCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


export type QueryReportScheduleRunCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryReportScheduleRunsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


export type QueryReportScheduleRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


export type QueryReportScheduleRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryReportScheduleVersionsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


export type QueryReportScheduleVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


export type QueryReportScheduleVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryReportingCacheFreshnessArgs = {
  brandIds?: InputMaybe<Array<Scalars['String']>>;
  campaignRunId?: InputMaybe<Scalars['String']>;
  channelType: Scalars['String'];
  dynamicContentBranches?: InputMaybe<Array<DynamicContentBranchSelectionInput>>;
  endDate: Scalars['String'];
  localeIds?: InputMaybe<Array<Scalars['String']>>;
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  os?: InputMaybe<PushOs>;
  providerDomains?: InputMaybe<Array<Scalars['String']>>;
  startDate: Scalars['String'];
};


export type QueryResourceDependentCountsArgs = {
  resources: Array<LineageResourceRef>;
  snapshotToken?: InputMaybe<Scalars['String']>;
};


export type QueryResourceDependentsPageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  snapshotToken?: InputMaybe<Scalars['String']>;
};


export type QueryResourceDependentsSummaryArgs = {
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
  snapshotToken?: InputMaybe<Scalars['String']>;
};


export type QueryResourceHealthArgs = {
  granularity: DashboardSyncMetricGranularity;
  resourceId: Scalars['String'];
  resourceType: Scalars['String'];
};


export type QueryResourceInteractionsArgs = {
  distinct_on?: InputMaybe<Array<ResourceInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceInteractionsOrderBy>>;
  where?: InputMaybe<ResourceInteractionsBoolExp>;
};


export type QueryResourceInteractionsByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QueryResourceMonitorConditionsArgs = {
  distinct_on?: InputMaybe<Array<ResourceMonitorConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceMonitorConditionsOrderBy>>;
  where?: InputMaybe<ResourceMonitorConditionsBoolExp>;
};


export type QueryResourceMonitorConditionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryResourceMonitorStatusesArgs = {
  distinct_on?: InputMaybe<Array<ResourceMonitorStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceMonitorStatusesOrderBy>>;
  where?: InputMaybe<ResourceMonitorStatusesBoolExp>;
};


export type QueryResourceMonitorStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryResourceNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<ResourceNotificationChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceNotificationChannelsOrderBy>>;
  where?: InputMaybe<ResourceNotificationChannelsBoolExp>;
};


export type QueryResourceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryResourceTagValuesArgs = {
  distinct_on?: InputMaybe<Array<ResourceTagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceTagValuesOrderBy>>;
  where?: InputMaybe<ResourceTagValuesBoolExp>;
};


export type QueryResourceToMonitorConditionTypeArgs = {
  distinct_on?: InputMaybe<Array<ResourceToMonitorConditionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceToMonitorConditionTypeOrderBy>>;
  where?: InputMaybe<ResourceToMonitorConditionTypeBoolExp>;
};


export type QueryResourceToMonitorConditionTypeByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryResourceViewsArgs = {
  distinct_on?: InputMaybe<Array<ResourceViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceViewsOrderBy>>;
  where?: InputMaybe<ResourceViewsBoolExp>;
};


export type QueryResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryResourcesWithCanActionArgs = {
  input: ResourcesWithCanActionInput;
};


export type QueryRetlAndRealtimeSyncsArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


export type QueryRetlAndRealtimeSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


export type QueryReviewAgentsWithSkillsArgs = {
  brandProfileId?: InputMaybe<Scalars['uuid']>;
};


export type QueryReviewAgentEntitiesArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


export type QueryReviewAgentEntitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


export type QueryReviewAgentEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryReviewAgentsArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentsOrderBy>>;
  where?: InputMaybe<ReviewAgentsBoolExp>;
};


export type QueryReviewAgentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentsOrderBy>>;
  where?: InputMaybe<ReviewAgentsBoolExp>;
};


export type QueryReviewAgentsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryRowExportBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QuerySalesloftListCustomFieldsArgs = {
  input?: InputMaybe<SalesloftCustomFieldsInput>;
};


export type QuerySampleDataSourcesArgs = {
  distinct_on?: InputMaybe<Array<SampleDataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleDataSourcesOrderBy>>;
  where?: InputMaybe<SampleDataSourcesBoolExp>;
};


export type QuerySampleDataSourcesByPkArgs = {
  uuid: Scalars['uuid'];
};


export type QuerySampledModelAvailableArgs = {
  segmentId: Scalars['bigint'];
};


export type QuerySampledSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


export type QuerySampledSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


export type QuerySampledSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySavedAnalyticsChartsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};


export type QuerySavedAnalyticsChartsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};


export type QuerySavedAnalyticsChartsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedAnalyticsChartsCohortsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


export type QuerySavedAnalyticsChartsCohortsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


export type QuerySavedAnalyticsChartsCohortsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedAnalyticsChartsFunnelStagesArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


export type QuerySavedAnalyticsChartsFunnelStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


export type QuerySavedAnalyticsChartsFunnelStagesByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedAnalyticsChartsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


export type QuerySavedAnalyticsChartsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


export type QuerySavedAnalyticsChartsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedCampaignViewsArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};


export type QuerySavedCampaignViewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};


export type QuerySavedCampaignViewsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedCampaignViewsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


export type QuerySavedCampaignViewsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


export type QuerySavedCampaignViewsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySavedMessagesArgs = {
  distinct_on?: InputMaybe<Array<SavedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedMessagesOrderBy>>;
  where?: InputMaybe<SavedMessagesBoolExp>;
};


export type QuerySavedMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedMessagesOrderBy>>;
  where?: InputMaybe<SavedMessagesBoolExp>;
};


export type QuerySavedQueriesArgs = {
  distinct_on?: InputMaybe<Array<SavedQueriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedQueriesOrderBy>>;
  where?: InputMaybe<SavedQueriesBoolExp>;
};


export type QuerySavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySearchCampaignRecipientsArgs = {
  campaignRunId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CampaignRecipientFiltersInput>;
  messageIds: Array<Scalars['String']>;
  search: Scalars['String'];
  statuses?: InputMaybe<Array<CampaignRecipientStatus>>;
};


export type QuerySearchCatalogProductsArgs = {
  assetGroupId?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<Scalars['String']>;
  directoryPrefix?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};


export type QuerySearchCepAudienceProfilesArgs = {
  audienceId?: InputMaybe<Scalars['ID']>;
  journeyTile?: InputMaybe<CepJourneyTileInput>;
  primaryKeyValue?: InputMaybe<Scalars['String']>;
  templateKeys?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchCepProfileRowArgs = {
  parentModelId: Scalars['String'];
  primaryKeyValue: Scalars['String'];
  templateKeys?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySearchCompetitorBrandsArgs = {
  query: Scalars['String'];
};


export type QuerySearchContentImagesArgs = {
  input: SearchContentImagesInput;
};


export type QuerySearchLookerLooksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QuerySearchMetaAdLibraryCompaniesArgs = {
  query: Scalars['String'];
};


export type QuerySegmentReferencesArgs = {
  distinct_on?: InputMaybe<Array<SegmentReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentReferencesOrderBy>>;
  where?: InputMaybe<SegmentReferencesBoolExp>;
};


export type QuerySegmentReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentReferencesOrderBy>>;
  where?: InputMaybe<SegmentReferencesBoolExp>;
};


export type QuerySegmentReferencesByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  segment_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QuerySegmentsArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


export type QuerySegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


export type QuerySegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySelectedAudienceTemplatesForSpaceArgs = {
  spaceId: Scalars['uuid'];
};


export type QuerySelectedSpaceAudienceTemplatesArgs = {
  audienceTemplateIds?: InputMaybe<Array<Scalars['uuid']>>;
  spaceIds?: InputMaybe<Array<Scalars['uuid']>>;
};


export type QuerySentResourceNotificationsArgs = {
  distinct_on?: InputMaybe<Array<SentResourceNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SentResourceNotificationsOrderBy>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};


export type QuerySentResourceNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySessionContextFilesReadArgs = {
  sessionId: Scalars['uuid'];
};


export type QuerySigmaQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  elementId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  workbookId: Scalars['String'];
};


export type QuerySigmaCredentialsArgs = {
  distinct_on?: InputMaybe<Array<SigmaCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SigmaCredentialsOrderBy>>;
  where?: InputMaybe<SigmaCredentialsBoolExp>;
};


export type QuerySigmaCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QuerySlackListChannelsArgs = {
  input: SlackListChannelsInput;
};


export type QuerySlackCredentialsArgs = {
  distinct_on?: InputMaybe<Array<SlackCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SlackCredentialsOrderBy>>;
  where?: InputMaybe<SlackCredentialsBoolExp>;
};


export type QuerySlackCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type QuerySourceCanActionGrantsArgs = {
  sourceId: Scalars['String'];
};


export type QuerySourceColumnDescriptionsArgs = {
  modelId: Scalars['Int'];
};


export type QuerySourceShareMirrorDatabasesArgs = {
  distinct_on?: InputMaybe<Array<SourceShareMirrorDatabasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SourceShareMirrorDatabasesOrderBy>>;
  where?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
};


export type QuerySourceShareMirrorDatabasesByPkArgs = {
  connection_id: Scalars['bigint'];
  database_name: Scalars['String'];
};


export type QuerySourceShareMirrorsArgs = {
  distinct_on?: InputMaybe<Array<SourceShareMirrorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SourceShareMirrorsOrderBy>>;
  where?: InputMaybe<SourceShareMirrorsBoolExp>;
};


export type QuerySourceShareMirrorsByPkArgs = {
  connection_id: Scalars['bigint'];
};


export type QuerySpaceScopedColumnsTopKStatusArgs = {
  modelId: Scalars['String'];
};


export type QuerySpaceSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<SpaceSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSubsetGrantsOrderBy>>;
  where?: InputMaybe<SpaceSubsetGrantsBoolExp>;
};


export type QuerySpaceSubsetGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySpaceSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SpaceSyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSyncTemplatesOrderBy>>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};


export type QuerySpaceSyncTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySpaceUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SpaceUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceUserGroupsOrderBy>>;
  where?: InputMaybe<SpaceUserGroupsBoolExp>;
};


export type QuerySpaceUserGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySpacesArgs = {
  distinct_on?: InputMaybe<Array<SpacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpacesOrderBy>>;
  where?: InputMaybe<SpacesBoolExp>;
};


export type QuerySpacesByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySsoEnforcementImpactArgs = {
  organizationId: Scalars['String'];
};


export type QuerySsoGroupUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupUserGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupUserGroupsBoolExp>;
};


export type QuerySsoGroupUserGroupsByPkArgs = {
  sso_group_id: Scalars['uuid'];
  user_group_id: Scalars['bigint'];
};


export type QuerySsoGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupsBoolExp>;
};


export type QuerySsoGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySsoUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoUserGroupsOrderBy>>;
  where?: InputMaybe<SsoUserGroupsBoolExp>;
};


export type QuerySsoUserGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryStartBackgroundDiscoveryArgs = {
  connectionId: Scalars['String'];
};


export type QueryStartPreviewQuerySchemaBackgroundJobArgs = {
  connectionId: Scalars['String'];
  query: Scalars['JSONObject'];
  queryType: Scalars['String'];
};


export type QueryStartTestSourceBackgroundJobArgs = {
  input: TestSourceInput;
};


export type QueryStaticListCsvFileArgs = {
  audienceId: Scalars['ID'];
  staticListId: Scalars['ID'];
};


export type QueryStaticListRefreshPreviewArgs = {
  jobId: Scalars['ID'];
};


export type QueryStaticListUnmatchedResultArgs = {
  jobId: Scalars['ID'];
  kind?: InputMaybe<StaticListResultKind>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryStaticListsArgs = {
  distinct_on?: InputMaybe<Array<StaticListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaticListsOrderBy>>;
  where?: InputMaybe<StaticListsBoolExp>;
};


export type QueryStaticListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<StaticListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaticListsOrderBy>>;
  where?: InputMaybe<StaticListsBoolExp>;
};


export type QueryStaticListsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryStyleEntityArgs = {
  id: Scalars['uuid'];
};


export type QuerySuggestFilterColumnsArgs = {
  parentModelId: Scalars['bigint'];
  search: Scalars['String'];
};


export type QuerySuggestProjectCampaignIntakeArgs = {
  sessionId: Scalars['uuid'];
};


export type QuerySuggestProjectCampaignIntakeFromAsanaTaskArgs = {
  taskUrl: Scalars['String'];
};


export type QuerySuggestTopicsForWorkspaceArgs = {
  categories: Array<Scalars['String']>;
};


export type QuerySupportAccessGrantArgs = {
  distinct_on?: InputMaybe<Array<SupportAccessGrantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportAccessGrantOrderBy>>;
  where?: InputMaybe<SupportAccessGrantBoolExp>;
};


export type QuerySupportAccessGrantByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySupportsAnalyticsIngestionArgs = {
  destinationType: Scalars['String'];
};


export type QuerySupportsClearingAudienceArgs = {
  destinationConfig?: InputMaybe<Scalars['JSONObject']>;
  destinationType: Scalars['String'];
  syncConfig?: InputMaybe<Scalars['JSONObject']>;
};


export type QuerySupportsDestinationMetadataArgs = {
  id: Scalars['bigint'];
};


export type QuerySupportsMatchboostingArgs = {
  config?: InputMaybe<Scalars['JSONObject']>;
  destinationType: Scalars['String'];
};


export type QuerySyncCanActionGrantsArgs = {
  syncId: Scalars['String'];
};


export type QuerySyncClearAndFillHoldHoursArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncSupportsClearingAudienceArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncAlertsArgs = {
  distinct_on?: InputMaybe<Array<SyncAlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAlertsOrderBy>>;
  where?: InputMaybe<SyncAlertsBoolExp>;
};


export type QuerySyncAttemptsArgs = {
  distinct_on?: InputMaybe<Array<SyncAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAttemptsOrderBy>>;
  where?: InputMaybe<SyncAttemptsBoolExp>;
};


export type QuerySyncAttemptsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncIdrSchedulesArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


export type QuerySyncIdrSchedulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


export type QuerySyncIdrSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySyncRequestComputedProgressArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestComputedProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestComputedProgressOrderBy>>;
  where?: InputMaybe<SyncRequestComputedProgressBoolExp>;
};


export type QuerySyncRequestDiffsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestDiffsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestDiffsOrderBy>>;
  where?: InputMaybe<SyncRequestDiffsBoolExp>;
};


export type QuerySyncRequestDiffsByPkArgs = {
  sync_request_id: Scalars['bigint'];
};


export type QuerySyncRequestEventSpansArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestEventSpansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestEventSpansOrderBy>>;
  where?: InputMaybe<SyncRequestEventSpansBoolExp>;
};


export type QuerySyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


export type QuerySyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


export type QuerySyncRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type QuerySyncSequenceMembersArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceMembersOrderBy>>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};


export type QuerySyncSequenceMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySyncSequenceRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRequestsOrderBy>>;
  where?: InputMaybe<SyncSequenceRequestsBoolExp>;
};


export type QuerySyncSequenceRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySyncSequenceRunsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


export type QuerySyncSequenceRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


export type QuerySyncSequenceRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySyncSequencesArgs = {
  distinct_on?: InputMaybe<Array<SyncSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequencesOrderBy>>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};


export type QuerySyncSequencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequencesOrderBy>>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};


export type QuerySyncSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type QuerySyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


export type QuerySyncTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


export type QuerySyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


export type QuerySyncsArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


export type QuerySyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


export type QuerySyncsToJourneysArgs = {
  distinct_on?: InputMaybe<Array<SyncsToJourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsToJourneysOrderBy>>;
  where?: InputMaybe<SyncsToJourneysBoolExp>;
};


export type QueryTableQueryBackgroundArgs = {
  connectionId: Scalars['String'];
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  modelId?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  table: Scalars['String'];
};


export type QueryTableauListViewsArgs = {
  connectionId: Scalars['String'];
  workbookId: Scalars['String'];
};


export type QueryTableauListWorkbooksArgs = {
  connectionId: Scalars['String'];
};


export type QueryTestNewWorkspaceNotificationChannelArgs = {
  channelConfig?: InputMaybe<Scalars['JSONObject']>;
  channelType: Scalars['String'];
};


export type QueryTestSourceArgs = {
  input: TestSourceInput;
};


export type QueryTestSourceBackgroundJobResultArgs = {
  jobId: Scalars['uuid'];
};


export type QueryTestStorageConnectionArgs = {
  config?: InputMaybe<Scalars['String']>;
  credentialId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryTestStorageConnectionV2Args = {
  config?: InputMaybe<Scalars['String']>;
  credentialId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryTestSyncConfigurationArgs = {
  decisionEngineMessageId?: InputMaybe<Scalars['String']>;
  destinationId: Scalars['Int'];
  operation: SyncOp;
  rows: Array<Scalars['JSONObject']>;
  segmentId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
};


export type QueryTestSyncConfigurationSupportedArgs = {
  destinationId: Scalars['Int'];
  segmentId: Scalars['Int'];
  syncConfig: Scalars['JSONObject'];
};


export type QueryTestWorkspaceNotificationChannelArgs = {
  channelId: Scalars['String'];
  newConfig?: InputMaybe<Scalars['JSONObject']>;
};


export type QueryThroughModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: InputMaybe<ThroughModelRelationshipsBoolExp>;
};


export type QueryThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


export type QueryTopKForQueryArgs = {
  columnName: Scalars['String'];
  modelId: Scalars['String'];
  parentModelId?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};


export type QueryTopKForTraitArgs = {
  query: Scalars['String'];
  traitId: Scalars['String'];
};


export type QueryTopKTraitStatusArgs = {
  distinct_on?: InputMaybe<Array<TopKTraitStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TopKTraitStatusOrderBy>>;
  where?: InputMaybe<TopKTraitStatusBoolExp>;
};


export type QueryTopKTraitStatusByPkArgs = {
  trait_id: Scalars['uuid'];
};


export type QueryTrackedAudienceListAudiencesArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListAudiencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListAudiencesOrderBy>>;
  where?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
};


export type QueryTrackedAudienceListAudiencesByPkArgs = {
  audience_id: Scalars['bigint'];
  list_id: Scalars['uuid'];
};


export type QueryTrackedAudienceListsArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


export type QueryTrackedAudienceListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


export type QueryTrackedAudienceListsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryTraitDefinitionArgs = {
  id: Scalars['uuid'];
};


export type QueryTraitDefinitionsForSegmentArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  segmentId: Scalars['bigint'];
};


export type QueryTraitDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


export type QueryTraitDefinitionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


export type QueryTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryTraitReferencesArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesOrderBy>>;
  where?: InputMaybe<TraitReferencesBoolExp>;
};


export type QueryTraitReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesOrderBy>>;
  where?: InputMaybe<TraitReferencesBoolExp>;
};


export type QueryTraitReferencesByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  trait_definition_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type QueryTraitReferencesSegmentsArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesSegmentsOrderBy>>;
  where?: InputMaybe<TraitReferencesSegmentsBoolExp>;
};


export type QueryTraitReferencesSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesSegmentsOrderBy>>;
  where?: InputMaybe<TraitReferencesSegmentsBoolExp>;
};


export type QueryTunnelsArgs = {
  distinct_on?: InputMaybe<Array<TunnelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelsOrderBy>>;
  where?: InputMaybe<TunnelsBoolExp>;
};


export type QueryTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


export type QueryUnreadAssetCommentCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryUpdateBlocklistJobResultArgs = {
  jobId: Scalars['String'];
};


export type QueryUserGroupAudienceCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
};


export type QueryUserGroupGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupGrantsOrderBy>>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};


export type QueryUserGroupGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupGrantsOrderBy>>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};


export type QueryUserGroupGrantsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryUserGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<UserGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupMembersOrderBy>>;
  where?: InputMaybe<UserGroupMembersBoolExp>;
};


export type QueryUserGroupMembersByPkArgs = {
  user_group_id: Scalars['bigint'];
  user_id: Scalars['bigint'];
};


export type QueryUserGroupModelAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupModelAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupModelAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
};


export type QueryUserGroupModelCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupModelCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupModelCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupModelCreationAuthorizationBoolExp>;
};


export type QueryUserGroupSourceGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSourceGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSourceGrantsBoolExp>;
};


export type QueryUserGroupSubsetAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
};


export type QueryUserGroupSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


export type QueryUserGroupSubsetGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


export type QueryUserGroupSubsetGrantsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryUserGroupSyncCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSyncCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSyncCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupSyncCreationAuthorizationBoolExp>;
};


export type QueryUserGroupTraitAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupTraitAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupTraitAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
};


export type QueryUserGroupWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


export type QueryUserGroupWorkspacesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


export type QueryUserGroupWorkspacesByPkArgs = {
  user_group_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type QueryUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type QueryUserGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type QueryUserGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryValidateDecisionEngineConfigArgs = {
  decisionEngineId: Scalars['uuid'];
};


export type QueryValidateInAppMessageContentArgs = {
  input: ValidateInAppMessageContentInput;
};


export type QueryValidatePredictorFeatureDefinitionArgs = {
  input: ValidatePredictorFeatureDefinitionInput;
};


export type QueryVerifyManifestFilesArgs = {
  manifestId: Scalars['uuid'];
};


export type QueryVideoExportsArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


export type QueryVideoExportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


export type QueryVideoExportsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryVisualQueryBackgroundArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  connectionId: Scalars['String'];
  countOnly?: InputMaybe<Scalars['Boolean']>;
  destinationId?: InputMaybe<Scalars['String']>;
  disableRowCounter?: InputMaybe<Scalars['Boolean']>;
  filter: Scalars['JSONObject'];
  includeColumnsFromFilter?: InputMaybe<Scalars['Boolean']>;
  includeTraitDependencies?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  parentModelId: Scalars['String'];
  precompiledSql?: InputMaybe<Scalars['String']>;
  primaryKeyIds?: InputMaybe<Array<Scalars['String']>>;
  relatedModelId?: InputMaybe<Scalars['String']>;
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
  syncConfig?: InputMaybe<Scalars['JSONObject']>;
  useDefaultSubsets?: InputMaybe<Scalars['Boolean']>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};


export type QueryVisualQueryBackgroundResultArgs = {
  filter: Scalars['JSONObject'];
  input: BackgroundJobInput;
  page: Scalars['Int'];
  parentModelId: Scalars['String'];
};


export type QueryVisualQuerySqlArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  connectionId?: InputMaybe<Scalars['String']>;
  countOnly?: InputMaybe<Scalars['Boolean']>;
  destinationId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JSONObject']>;
  includeColumnsFromFilter?: InputMaybe<Scalars['Boolean']>;
  includeTraitDependencies?: InputMaybe<Scalars['Boolean']>;
  parentModelId?: InputMaybe<Scalars['String']>;
  relatedModelId?: InputMaybe<Scalars['String']>;
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
  syncConfig?: InputMaybe<Scalars['JSONObject']>;
  useDefaultSubsets?: InputMaybe<Scalars['Boolean']>;
  useSampledModels?: InputMaybe<Scalars['Boolean']>;
};


export type QueryWarehouseEventsTimelineBackgroundArgs = {
  input: WarehouseEventsTimelineInput;
};


export type QueryWarehouseEventsTimelineBackgroundResultArgs = {
  jobId: Scalars['String'];
};


export type QueryWarehouseExportDisabledSyncCountArgs = {
  sourceId: Scalars['Int'];
};


export type QueryWarehouseShareAvailableDatabasesArgs = {
  connectionId: Scalars['bigint'];
};


export type QueryWarehouseShareEligibilityArgs = {
  connectionId: Scalars['bigint'];
};


export type QueryWarehouseShareMirrorArgs = {
  connectionId: Scalars['bigint'];
};


export type QueryWarehouseShareSetupBackgroundJobResultArgs = {
  jobId: Scalars['uuid'];
};


export type QueryWarehouseSnapshotsArgs = {
  distinct_on?: InputMaybe<Array<WarehouseSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WarehouseSnapshotsOrderBy>>;
  where?: InputMaybe<WarehouseSnapshotsBoolExp>;
};


export type QueryWarehouseSnapshotsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryWebPagePsdExportRunArgs = {
  id: Scalars['ID'];
};


export type QueryWhatsAppTestSenderArgs = {
  templateId: Scalars['ID'];
};


export type QueryWhatsAppTestSendersArgs = {
  messageId?: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
};


export type QueryWorkspaceMembersArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


export type QueryWorkspaceMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


export type QueryWorkspaceNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceNotificationChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceNotificationChannelsOrderBy>>;
  where?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};


export type QueryWorkspaceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type QueryWorkspaceOverageDatesArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceOverageDatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceOverageDatesOrderBy>>;
  where?: InputMaybe<WorkspaceOverageDatesBoolExp>;
};


export type QueryWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<WorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspacesOrderBy>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};


export type QueryWorkspacesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryZendeskListCustomFieldsArgs = {
  input: ZendeskListCustomFieldsInput;
};


export type QueryZendeskListCustomObjectPropertiesArgs = {
  input: ZendeskListCustomObjectPropertiesInput;
};


export type QueryZendeskListCustomObjectTypesArgs = {
  input: ZendeskListCustomObjectTypesInput;
};

/** columns and relationships of "query_runs" */
export type QueryRuns = {
  __typename?: 'query_runs';
  created_at: Scalars['timestamptz'];
  duplicate_primary_keys?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['bigint'];
  pending_rows?: Maybe<Scalars['Int']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id: Scalars['bigint'];
  size: Scalars['Int'];
};

/** order by aggregate values of table "query_runs" */
export type QueryRunsAggregateOrderBy = {
  avg?: InputMaybe<QueryRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<QueryRunsMaxOrderBy>;
  min?: InputMaybe<QueryRunsMinOrderBy>;
  stddev?: InputMaybe<QueryRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<QueryRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<QueryRunsStddevSampOrderBy>;
  sum?: InputMaybe<QueryRunsSumOrderBy>;
  var_pop?: InputMaybe<QueryRunsVarPopOrderBy>;
  var_samp?: InputMaybe<QueryRunsVarSampOrderBy>;
  variance?: InputMaybe<QueryRunsVarianceOrderBy>;
};

/** order by avg() on columns of table "query_runs" */
export type QueryRunsAvgOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "query_runs". All fields are combined with a logical 'AND'. */
export type QueryRunsBoolExp = {
  _and?: InputMaybe<Array<QueryRunsBoolExp>>;
  _not?: InputMaybe<QueryRunsBoolExp>;
  _or?: InputMaybe<Array<QueryRunsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  duplicate_primary_keys?: InputMaybe<IntComparisonExp>;
  duration?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  pending_rows?: InputMaybe<IntComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  size?: InputMaybe<IntComparisonExp>;
};

/** order by max() on columns of table "query_runs" */
export type QueryRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "query_runs" */
export type QueryRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "query_runs". */
export type QueryRunsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** select columns of table "query_runs" */
export const QueryRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DuplicatePrimaryKeys: 'duplicate_primary_keys',
  /** column name */
  Duration: 'duration',
  /** column name */
  Id: 'id',
  /** column name */
  PendingRows: 'pending_rows',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Size: 'size'
} as const;

export type QueryRunsSelectColumn = typeof QueryRunsSelectColumn[keyof typeof QueryRunsSelectColumn];
/** order by stddev() on columns of table "query_runs" */
export type QueryRunsStddevOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "query_runs" */
export type QueryRunsStddevPopOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "query_runs" */
export type QueryRunsStddevSampOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "query_runs" */
export type QueryRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: QueryRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QueryRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duplicate_primary_keys?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  pending_rows?: InputMaybe<Scalars['Int']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "query_runs" */
export type QueryRunsSumOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "query_runs" */
export type QueryRunsVarPopOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "query_runs" */
export type QueryRunsVarSampOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "query_runs" */
export type QueryRunsVarianceOrderBy = {
  duplicate_primary_keys?: InputMaybe<OrderBy>;
  duration?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pending_rows?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** columns and relationships of "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegments = {
  __typename?: 'realtime_audience_sync_segments';
  /** An object relationship */
  realtime_audience_sync: RealtimeAudienceSyncs;
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsAggregate = {
  __typename?: 'realtime_audience_sync_segments_aggregate';
  aggregate?: Maybe<RealtimeAudienceSyncSegmentsAggregateFields>;
  nodes: Array<RealtimeAudienceSyncSegments>;
};

export type RealtimeAudienceSyncSegmentsAggregateBoolExp = {
  count?: InputMaybe<RealtimeAudienceSyncSegmentsAggregateBoolExpCount>;
};

export type RealtimeAudienceSyncSegmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsAggregateFields = {
  __typename?: 'realtime_audience_sync_segments_aggregate_fields';
  avg?: Maybe<RealtimeAudienceSyncSegmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RealtimeAudienceSyncSegmentsMaxFields>;
  min?: Maybe<RealtimeAudienceSyncSegmentsMinFields>;
  stddev?: Maybe<RealtimeAudienceSyncSegmentsStddevFields>;
  stddev_pop?: Maybe<RealtimeAudienceSyncSegmentsStddevPopFields>;
  stddev_samp?: Maybe<RealtimeAudienceSyncSegmentsStddevSampFields>;
  sum?: Maybe<RealtimeAudienceSyncSegmentsSumFields>;
  var_pop?: Maybe<RealtimeAudienceSyncSegmentsVarPopFields>;
  var_samp?: Maybe<RealtimeAudienceSyncSegmentsVarSampFields>;
  variance?: Maybe<RealtimeAudienceSyncSegmentsVarianceFields>;
};


/** aggregate fields of "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsAggregateOrderBy = {
  avg?: InputMaybe<RealtimeAudienceSyncSegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RealtimeAudienceSyncSegmentsMaxOrderBy>;
  min?: InputMaybe<RealtimeAudienceSyncSegmentsMinOrderBy>;
  stddev?: InputMaybe<RealtimeAudienceSyncSegmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<RealtimeAudienceSyncSegmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RealtimeAudienceSyncSegmentsStddevSampOrderBy>;
  sum?: InputMaybe<RealtimeAudienceSyncSegmentsSumOrderBy>;
  var_pop?: InputMaybe<RealtimeAudienceSyncSegmentsVarPopOrderBy>;
  var_samp?: InputMaybe<RealtimeAudienceSyncSegmentsVarSampOrderBy>;
  variance?: InputMaybe<RealtimeAudienceSyncSegmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsArrRelInsertInput = {
  data: Array<RealtimeAudienceSyncSegmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RealtimeAudienceSyncSegmentsOnConflict>;
};

/** aggregate avg on columns */
export type RealtimeAudienceSyncSegmentsAvgFields = {
  __typename?: 'realtime_audience_sync_segments_avg_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsAvgOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "realtime_audience_sync_segments". All fields are combined with a logical 'AND'. */
export type RealtimeAudienceSyncSegmentsBoolExp = {
  _and?: InputMaybe<Array<RealtimeAudienceSyncSegmentsBoolExp>>;
  _not?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
  _or?: InputMaybe<Array<RealtimeAudienceSyncSegmentsBoolExp>>;
  realtime_audience_sync?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  sync_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "realtime_audience_sync_segments" */
export const RealtimeAudienceSyncSegmentsConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "segment_id", "sync_id" */
  RealtimeAudienceSyncSegmentsPkey: 'realtime_audience_sync_segments_pkey'
} as const;

export type RealtimeAudienceSyncSegmentsConstraint = typeof RealtimeAudienceSyncSegmentsConstraint[keyof typeof RealtimeAudienceSyncSegmentsConstraint];
/** input type for inserting data into table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsInsertInput = {
  realtime_audience_sync?: InputMaybe<RealtimeAudienceSyncsObjRelInsertInput>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  sync_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RealtimeAudienceSyncSegmentsMaxFields = {
  __typename?: 'realtime_audience_sync_segments_max_fields';
  segment_id?: Maybe<Scalars['bigint']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsMaxOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RealtimeAudienceSyncSegmentsMinFields = {
  __typename?: 'realtime_audience_sync_segments_min_fields';
  segment_id?: Maybe<Scalars['bigint']>;
  sync_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsMinOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsMutationResponse = {
  __typename?: 'realtime_audience_sync_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RealtimeAudienceSyncSegments>;
};

/** on_conflict condition type for table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsOnConflict = {
  constraint: RealtimeAudienceSyncSegmentsConstraint;
  update_columns?: Array<RealtimeAudienceSyncSegmentsUpdateColumn>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};

/** Ordering options when selecting data from "realtime_audience_sync_segments". */
export type RealtimeAudienceSyncSegmentsOrderBy = {
  realtime_audience_sync?: InputMaybe<RealtimeAudienceSyncsOrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "realtime_audience_sync_segments" */
export const RealtimeAudienceSyncSegmentsSelectColumn = {
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type RealtimeAudienceSyncSegmentsSelectColumn = typeof RealtimeAudienceSyncSegmentsSelectColumn[keyof typeof RealtimeAudienceSyncSegmentsSelectColumn];
/** aggregate stddev on columns */
export type RealtimeAudienceSyncSegmentsStddevFields = {
  __typename?: 'realtime_audience_sync_segments_stddev_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsStddevOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RealtimeAudienceSyncSegmentsStddevPopFields = {
  __typename?: 'realtime_audience_sync_segments_stddev_pop_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsStddevPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RealtimeAudienceSyncSegmentsStddevSampFields = {
  __typename?: 'realtime_audience_sync_segments_stddev_samp_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsStddevSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RealtimeAudienceSyncSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RealtimeAudienceSyncSegmentsStreamCursorValueInput = {
  segment_id?: InputMaybe<Scalars['bigint']>;
  sync_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RealtimeAudienceSyncSegmentsSumFields = {
  __typename?: 'realtime_audience_sync_segments_sum_fields';
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsSumOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "realtime_audience_sync_segments" (current role has no relevant permissions) */
export const RealtimeAudienceSyncSegmentsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type RealtimeAudienceSyncSegmentsUpdateColumn = typeof RealtimeAudienceSyncSegmentsUpdateColumn[keyof typeof RealtimeAudienceSyncSegmentsUpdateColumn];
/** aggregate var_pop on columns */
export type RealtimeAudienceSyncSegmentsVarPopFields = {
  __typename?: 'realtime_audience_sync_segments_var_pop_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsVarPopOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RealtimeAudienceSyncSegmentsVarSampFields = {
  __typename?: 'realtime_audience_sync_segments_var_samp_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsVarSampOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RealtimeAudienceSyncSegmentsVarianceFields = {
  __typename?: 'realtime_audience_sync_segments_variance_fields';
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "realtime_audience_sync_segments" */
export type RealtimeAudienceSyncSegmentsVarianceOrderBy = {
  segment_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "realtime_audience_syncs" */
export type RealtimeAudienceSyncs = {
  __typename?: 'realtime_audience_syncs';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['bigint'];
  enabled: Scalars['Boolean'];
  enabled_events: Array<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  realtime_audience_sync_segments: Array<RealtimeAudienceSyncSegments>;
  /** An aggregate relationship */
  realtime_audience_sync_segments_aggregate: RealtimeAudienceSyncSegmentsAggregate;
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  slug?: Maybe<Scalars['String']>;
  tags: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "realtime_audience_syncs" */
export type RealtimeAudienceSyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "realtime_audience_syncs" */
export type RealtimeAudienceSyncsRealtimeAudienceSyncSegmentsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


/** columns and relationships of "realtime_audience_syncs" */
export type RealtimeAudienceSyncsRealtimeAudienceSyncSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


/** columns and relationships of "realtime_audience_syncs" */
export type RealtimeAudienceSyncsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsAggregateOrderBy = {
  avg?: InputMaybe<RealtimeAudienceSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RealtimeAudienceSyncsMaxOrderBy>;
  min?: InputMaybe<RealtimeAudienceSyncsMinOrderBy>;
  stddev?: InputMaybe<RealtimeAudienceSyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<RealtimeAudienceSyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RealtimeAudienceSyncsStddevSampOrderBy>;
  sum?: InputMaybe<RealtimeAudienceSyncsSumOrderBy>;
  var_pop?: InputMaybe<RealtimeAudienceSyncsVarPopOrderBy>;
  var_samp?: InputMaybe<RealtimeAudienceSyncsVarSampOrderBy>;
  variance?: InputMaybe<RealtimeAudienceSyncsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RealtimeAudienceSyncsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsArrRelInsertInput = {
  data: Array<RealtimeAudienceSyncsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RealtimeAudienceSyncsOnConflict>;
};

/** order by avg() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "realtime_audience_syncs". All fields are combined with a logical 'AND'. */
export type RealtimeAudienceSyncsBoolExp = {
  _and?: InputMaybe<Array<RealtimeAudienceSyncsBoolExp>>;
  _not?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
  _or?: InputMaybe<Array<RealtimeAudienceSyncsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  enabled_events?: InputMaybe<StringArrayComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  realtime_audience_sync_segments?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
  realtime_audience_sync_segments_aggregate?: InputMaybe<RealtimeAudienceSyncSegmentsAggregateBoolExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "realtime_audience_syncs" */
export const RealtimeAudienceSyncsConstraint = {
  /** unique or primary key constraint on columns "id" */
  RealtimeAudienceSyncsPkey: 'realtime_audience_syncs_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  RealtimeAudienceSyncsWorkspaceIdIdKey: 'realtime_audience_syncs_workspace_id_id_key'
} as const;

export type RealtimeAudienceSyncsConstraint = typeof RealtimeAudienceSyncsConstraint[keyof typeof RealtimeAudienceSyncsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RealtimeAudienceSyncsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RealtimeAudienceSyncsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RealtimeAudienceSyncsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled_events?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  realtime_audience_sync_segments?: InputMaybe<RealtimeAudienceSyncSegmentsArrRelInsertInput>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** order by max() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  enabled_events?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  enabled_events?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsMutationResponse = {
  __typename?: 'realtime_audience_syncs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RealtimeAudienceSyncs>;
};

/** input type for inserting object relation for remote table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsObjRelInsertInput = {
  data: RealtimeAudienceSyncsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RealtimeAudienceSyncsOnConflict>;
};

/** on_conflict condition type for table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsOnConflict = {
  constraint: RealtimeAudienceSyncsConstraint;
  update_columns?: Array<RealtimeAudienceSyncsUpdateColumn>;
  where?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
};

/** Ordering options when selecting data from "realtime_audience_syncs". */
export type RealtimeAudienceSyncsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  enabled_events?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  realtime_audience_sync_segments_aggregate?: InputMaybe<RealtimeAudienceSyncSegmentsAggregateOrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: realtime_audience_syncs */
export type RealtimeAudienceSyncsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RealtimeAudienceSyncsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "realtime_audience_syncs" */
export const RealtimeAudienceSyncsSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnabledEvents: 'enabled_events',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type RealtimeAudienceSyncsSelectColumn = typeof RealtimeAudienceSyncsSelectColumn[keyof typeof RealtimeAudienceSyncsSelectColumn];
/** input type for updating data in table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  enabled_events?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RealtimeAudienceSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RealtimeAudienceSyncsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  enabled_events?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "realtime_audience_syncs" */
export const RealtimeAudienceSyncsUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  EnabledEvents: 'enabled_events',
  /** column name */
  Name: 'name',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags'
} as const;

export type RealtimeAudienceSyncsUpdateColumn = typeof RealtimeAudienceSyncsUpdateColumn[keyof typeof RealtimeAudienceSyncsUpdateColumn];
export type RealtimeAudienceSyncsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RealtimeAudienceSyncsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RealtimeAudienceSyncsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RealtimeAudienceSyncsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RealtimeAudienceSyncsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RealtimeAudienceSyncsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RealtimeAudienceSyncsSetInput>;
  /** filter the rows which have to be updated */
  where: RealtimeAudienceSyncsBoolExp;
};

/** order by var_pop() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "realtime_audience_syncs" */
export type RealtimeAudienceSyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "realtime_audiences_scheduled_warehouse_pulls" */
export type RealtimeAudiencesScheduledWarehousePulls = {
  __typename?: 'realtime_audiences_scheduled_warehouse_pulls';
  /** An object relationship */
  last_successful_run?: Maybe<RealtimeAudiencesWarehousePullRuns>;
  next_full_refresh_date?: Maybe<Scalars['timestamptz']>;
  parent_model_id: Scalars['bigint'];
  schedule: Scalars['jsonb'];
};


/** columns and relationships of "realtime_audiences_scheduled_warehouse_pulls" */
export type RealtimeAudiencesScheduledWarehousePullsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RealtimeAudiencesScheduledWarehousePullsAppendInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "realtime_audiences_scheduled_warehouse_pulls". All fields are combined with a logical 'AND'. */
export type RealtimeAudiencesScheduledWarehousePullsBoolExp = {
  _and?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsBoolExp>>;
  _not?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsBoolExp>;
  _or?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsBoolExp>>;
  last_successful_run?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
  next_full_refresh_date?: InputMaybe<TimestamptzComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RealtimeAudiencesScheduledWarehousePullsDeleteAtPathInput = {
  schedule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RealtimeAudiencesScheduledWarehousePullsDeleteElemInput = {
  schedule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RealtimeAudiencesScheduledWarehousePullsDeleteKeyInput = {
  schedule?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "realtime_audiences_scheduled_warehouse_pulls" */
export type RealtimeAudiencesScheduledWarehousePullsMutationResponse = {
  __typename?: 'realtime_audiences_scheduled_warehouse_pulls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RealtimeAudiencesScheduledWarehousePulls>;
};

/** Ordering options when selecting data from "realtime_audiences_scheduled_warehouse_pulls". */
export type RealtimeAudiencesScheduledWarehousePullsOrderBy = {
  last_successful_run?: InputMaybe<RealtimeAudiencesWarehousePullRunsOrderBy>;
  next_full_refresh_date?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RealtimeAudiencesScheduledWarehousePullsPrependInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "realtime_audiences_scheduled_warehouse_pulls" */
export const RealtimeAudiencesScheduledWarehousePullsSelectColumn = {
  /** column name */
  NextFullRefreshDate: 'next_full_refresh_date',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Schedule: 'schedule'
} as const;

export type RealtimeAudiencesScheduledWarehousePullsSelectColumn = typeof RealtimeAudiencesScheduledWarehousePullsSelectColumn[keyof typeof RealtimeAudiencesScheduledWarehousePullsSelectColumn];
/** input type for updating data in table "realtime_audiences_scheduled_warehouse_pulls" */
export type RealtimeAudiencesScheduledWarehousePullsSetInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "realtime_audiences_scheduled_warehouse_pulls" */
export type RealtimeAudiencesScheduledWarehousePullsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RealtimeAudiencesScheduledWarehousePullsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RealtimeAudiencesScheduledWarehousePullsStreamCursorValueInput = {
  next_full_refresh_date?: InputMaybe<Scalars['timestamptz']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
};

export type RealtimeAudiencesScheduledWarehousePullsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsSetInput>;
  /** filter the rows which have to be updated */
  where: RealtimeAudiencesScheduledWarehousePullsBoolExp;
};

/** columns and relationships of "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRuns = {
  __typename?: 'realtime_audiences_warehouse_pull_runs';
  completed_at?: Maybe<Scalars['timestamptz']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  last_resumed_at?: Maybe<Scalars['timestamptz']>;
  parent_model_id: Scalars['bigint'];
  refresh_type?: Maybe<Scalars['String']>;
  row_count?: Maybe<Scalars['bigint']>;
  started_at: Scalars['timestamptz'];
  status: Scalars['String'];
  trigger_source: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsAggregate = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_aggregate';
  aggregate?: Maybe<RealtimeAudiencesWarehousePullRunsAggregateFields>;
  nodes: Array<RealtimeAudiencesWarehousePullRuns>;
};

export type RealtimeAudiencesWarehousePullRunsAggregateBoolExp = {
  count?: InputMaybe<RealtimeAudiencesWarehousePullRunsAggregateBoolExpCount>;
};

export type RealtimeAudiencesWarehousePullRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsAggregateFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_aggregate_fields';
  avg?: Maybe<RealtimeAudiencesWarehousePullRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RealtimeAudiencesWarehousePullRunsMaxFields>;
  min?: Maybe<RealtimeAudiencesWarehousePullRunsMinFields>;
  stddev?: Maybe<RealtimeAudiencesWarehousePullRunsStddevFields>;
  stddev_pop?: Maybe<RealtimeAudiencesWarehousePullRunsStddevPopFields>;
  stddev_samp?: Maybe<RealtimeAudiencesWarehousePullRunsStddevSampFields>;
  sum?: Maybe<RealtimeAudiencesWarehousePullRunsSumFields>;
  var_pop?: Maybe<RealtimeAudiencesWarehousePullRunsVarPopFields>;
  var_samp?: Maybe<RealtimeAudiencesWarehousePullRunsVarSampFields>;
  variance?: Maybe<RealtimeAudiencesWarehousePullRunsVarianceFields>;
};


/** aggregate fields of "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsAggregateOrderBy = {
  avg?: InputMaybe<RealtimeAudiencesWarehousePullRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RealtimeAudiencesWarehousePullRunsMaxOrderBy>;
  min?: InputMaybe<RealtimeAudiencesWarehousePullRunsMinOrderBy>;
  stddev?: InputMaybe<RealtimeAudiencesWarehousePullRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<RealtimeAudiencesWarehousePullRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RealtimeAudiencesWarehousePullRunsStddevSampOrderBy>;
  sum?: InputMaybe<RealtimeAudiencesWarehousePullRunsSumOrderBy>;
  var_pop?: InputMaybe<RealtimeAudiencesWarehousePullRunsVarPopOrderBy>;
  var_samp?: InputMaybe<RealtimeAudiencesWarehousePullRunsVarSampOrderBy>;
  variance?: InputMaybe<RealtimeAudiencesWarehousePullRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type RealtimeAudiencesWarehousePullRunsAvgFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_avg_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsAvgOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "realtime_audiences_warehouse_pull_runs". All fields are combined with a logical 'AND'. */
export type RealtimeAudiencesWarehousePullRunsBoolExp = {
  _and?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsBoolExp>>;
  _not?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
  _or?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsBoolExp>>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_resumed_at?: InputMaybe<TimestamptzComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  refresh_type?: InputMaybe<StringComparisonExp>;
  row_count?: InputMaybe<BigintComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  trigger_source?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type RealtimeAudiencesWarehousePullRunsMaxFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_resumed_at?: Maybe<Scalars['timestamptz']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  refresh_type?: Maybe<Scalars['String']>;
  row_count?: Maybe<Scalars['bigint']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  trigger_source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsMaxOrderBy = {
  completed_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_resumed_at?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  refresh_type?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger_source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RealtimeAudiencesWarehousePullRunsMinFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_resumed_at?: Maybe<Scalars['timestamptz']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  refresh_type?: Maybe<Scalars['String']>;
  row_count?: Maybe<Scalars['bigint']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  trigger_source?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsMinOrderBy = {
  completed_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_resumed_at?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  refresh_type?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger_source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "realtime_audiences_warehouse_pull_runs". */
export type RealtimeAudiencesWarehousePullRunsOrderBy = {
  completed_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_resumed_at?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  refresh_type?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trigger_source?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "realtime_audiences_warehouse_pull_runs" */
export const RealtimeAudiencesWarehousePullRunsSelectColumn = {
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  LastResumedAt: 'last_resumed_at',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  RefreshType: 'refresh_type',
  /** column name */
  RowCount: 'row_count',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  TriggerSource: 'trigger_source',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type RealtimeAudiencesWarehousePullRunsSelectColumn = typeof RealtimeAudiencesWarehousePullRunsSelectColumn[keyof typeof RealtimeAudiencesWarehousePullRunsSelectColumn];
/** aggregate stddev on columns */
export type RealtimeAudiencesWarehousePullRunsStddevFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_stddev_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsStddevOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RealtimeAudiencesWarehousePullRunsStddevPopFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_stddev_pop_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsStddevPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RealtimeAudiencesWarehousePullRunsStddevSampFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_stddev_samp_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsStddevSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RealtimeAudiencesWarehousePullRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RealtimeAudiencesWarehousePullRunsStreamCursorValueInput = {
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_resumed_at?: InputMaybe<Scalars['timestamptz']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  refresh_type?: InputMaybe<Scalars['String']>;
  row_count?: InputMaybe<Scalars['bigint']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  trigger_source?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RealtimeAudiencesWarehousePullRunsSumFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_sum_fields';
  parent_model_id?: Maybe<Scalars['bigint']>;
  row_count?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsSumOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type RealtimeAudiencesWarehousePullRunsVarPopFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_var_pop_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsVarPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RealtimeAudiencesWarehousePullRunsVarSampFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_var_samp_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsVarSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RealtimeAudiencesWarehousePullRunsVarianceFields = {
  __typename?: 'realtime_audiences_warehouse_pull_runs_variance_fields';
  parent_model_id?: Maybe<Scalars['Float']>;
  row_count?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "realtime_audiences_warehouse_pull_runs" */
export type RealtimeAudiencesWarehousePullRunsVarianceOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  row_count?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "relationship_references" */
export type RelationshipReferences = {
  __typename?: 'relationship_references';
  from_column: Scalars['String'];
  from_through_column?: Maybe<Scalars['String']>;
  ordinal_number: Scalars['smallint'];
  /** An object relationship */
  relationship: Relationships;
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
  to_through_column?: Maybe<Scalars['String']>;
};

/** order by aggregate values of table "relationship_references" */
export type RelationshipReferencesAggregateOrderBy = {
  avg?: InputMaybe<RelationshipReferencesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RelationshipReferencesMaxOrderBy>;
  min?: InputMaybe<RelationshipReferencesMinOrderBy>;
  stddev?: InputMaybe<RelationshipReferencesStddevOrderBy>;
  stddev_pop?: InputMaybe<RelationshipReferencesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RelationshipReferencesStddevSampOrderBy>;
  sum?: InputMaybe<RelationshipReferencesSumOrderBy>;
  var_pop?: InputMaybe<RelationshipReferencesVarPopOrderBy>;
  var_samp?: InputMaybe<RelationshipReferencesVarSampOrderBy>;
  variance?: InputMaybe<RelationshipReferencesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "relationship_references" */
export type RelationshipReferencesArrRelInsertInput = {
  data: Array<RelationshipReferencesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RelationshipReferencesOnConflict>;
};

/** order by avg() on columns of table "relationship_references" */
export type RelationshipReferencesAvgOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "relationship_references". All fields are combined with a logical 'AND'. */
export type RelationshipReferencesBoolExp = {
  _and?: InputMaybe<Array<RelationshipReferencesBoolExp>>;
  _not?: InputMaybe<RelationshipReferencesBoolExp>;
  _or?: InputMaybe<Array<RelationshipReferencesBoolExp>>;
  from_column?: InputMaybe<StringComparisonExp>;
  from_through_column?: InputMaybe<StringComparisonExp>;
  ordinal_number?: InputMaybe<SmallintComparisonExp>;
  relationship?: InputMaybe<RelationshipsBoolExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
  to_column?: InputMaybe<StringComparisonExp>;
  to_through_column?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "relationship_references" */
export const RelationshipReferencesConstraint = {
  /** unique or primary key constraint on columns "to_column", "ordinal_number", "relationship_id", "from_column" */
  RelationshipReferencesPkey: 'relationship_references_pkey'
} as const;

export type RelationshipReferencesConstraint = typeof RelationshipReferencesConstraint[keyof typeof RelationshipReferencesConstraint];
/** input type for incrementing numeric columns in table "relationship_references" */
export type RelationshipReferencesIncInput = {
  ordinal_number?: InputMaybe<Scalars['smallint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relationship_references" */
export type RelationshipReferencesInsertInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_through_column?: InputMaybe<Scalars['String']>;
  ordinal_number?: InputMaybe<Scalars['smallint']>;
  relationship?: InputMaybe<RelationshipsObjRelInsertInput>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_through_column?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "relationship_references" */
export type RelationshipReferencesMaxOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_through_column?: InputMaybe<OrderBy>;
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_through_column?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "relationship_references" */
export type RelationshipReferencesMinOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_through_column?: InputMaybe<OrderBy>;
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_through_column?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "relationship_references" */
export type RelationshipReferencesMutationResponse = {
  __typename?: 'relationship_references_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationshipReferences>;
};

/** on_conflict condition type for table "relationship_references" */
export type RelationshipReferencesOnConflict = {
  constraint: RelationshipReferencesConstraint;
  update_columns?: Array<RelationshipReferencesUpdateColumn>;
  where?: InputMaybe<RelationshipReferencesBoolExp>;
};

/** Ordering options when selecting data from "relationship_references". */
export type RelationshipReferencesOrderBy = {
  from_column?: InputMaybe<OrderBy>;
  from_through_column?: InputMaybe<OrderBy>;
  ordinal_number?: InputMaybe<OrderBy>;
  relationship?: InputMaybe<RelationshipsOrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  to_column?: InputMaybe<OrderBy>;
  to_through_column?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: relationship_references */
export type RelationshipReferencesPkColumnsInput = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};

/** select columns of table "relationship_references" */
export const RelationshipReferencesSelectColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromThroughColumn: 'from_through_column',
  /** column name */
  OrdinalNumber: 'ordinal_number',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToThroughColumn: 'to_through_column'
} as const;

export type RelationshipReferencesSelectColumn = typeof RelationshipReferencesSelectColumn[keyof typeof RelationshipReferencesSelectColumn];
/** input type for updating data in table "relationship_references" */
export type RelationshipReferencesSetInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_through_column?: InputMaybe<Scalars['String']>;
  ordinal_number?: InputMaybe<Scalars['smallint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_through_column?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "relationship_references" */
export type RelationshipReferencesStddevOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "relationship_references" */
export type RelationshipReferencesStddevPopOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "relationship_references" */
export type RelationshipReferencesStddevSampOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "relationship_references" */
export type RelationshipReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RelationshipReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationshipReferencesStreamCursorValueInput = {
  from_column?: InputMaybe<Scalars['String']>;
  from_through_column?: InputMaybe<Scalars['String']>;
  ordinal_number?: InputMaybe<Scalars['smallint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  to_column?: InputMaybe<Scalars['String']>;
  to_through_column?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "relationship_references" */
export type RelationshipReferencesSumOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** update columns of table "relationship_references" */
export const RelationshipReferencesUpdateColumn = {
  /** column name */
  FromColumn: 'from_column',
  /** column name */
  FromThroughColumn: 'from_through_column',
  /** column name */
  OrdinalNumber: 'ordinal_number',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  ToColumn: 'to_column',
  /** column name */
  ToThroughColumn: 'to_through_column'
} as const;

export type RelationshipReferencesUpdateColumn = typeof RelationshipReferencesUpdateColumn[keyof typeof RelationshipReferencesUpdateColumn];
export type RelationshipReferencesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RelationshipReferencesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationshipReferencesSetInput>;
  /** filter the rows which have to be updated */
  where: RelationshipReferencesBoolExp;
};

/** order by var_pop() on columns of table "relationship_references" */
export type RelationshipReferencesVarPopOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "relationship_references" */
export type RelationshipReferencesVarSampOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "relationship_references" */
export type RelationshipReferencesVarianceOrderBy = {
  ordinal_number?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "relationships" */
export type Relationships = {
  __typename?: 'relationships';
  from_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  from_object_definition: ObjectDefinitions;
  from_object_definition_id: Scalars['bigint'];
  id: Scalars['bigint'];
  ownership: Scalars['Boolean'];
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** An object relationship */
  through_object_definition?: Maybe<ObjectDefinitions>;
  through_object_definition_id?: Maybe<Scalars['bigint']>;
  to_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  to_object_definition: ObjectDefinitions;
  to_object_definition_id: Scalars['bigint'];
  type: Scalars['String'];
};


/** columns and relationships of "relationships" */
export type RelationshipsRelationshipReferencesArgs = {
  distinct_on?: InputMaybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipReferencesOrderBy>>;
  where?: InputMaybe<RelationshipReferencesBoolExp>;
};

/** order by aggregate values of table "relationships" */
export type RelationshipsAggregateOrderBy = {
  avg?: InputMaybe<RelationshipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RelationshipsMaxOrderBy>;
  min?: InputMaybe<RelationshipsMinOrderBy>;
  stddev?: InputMaybe<RelationshipsStddevOrderBy>;
  stddev_pop?: InputMaybe<RelationshipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RelationshipsStddevSampOrderBy>;
  sum?: InputMaybe<RelationshipsSumOrderBy>;
  var_pop?: InputMaybe<RelationshipsVarPopOrderBy>;
  var_samp?: InputMaybe<RelationshipsVarSampOrderBy>;
  variance?: InputMaybe<RelationshipsVarianceOrderBy>;
};

/** order by avg() on columns of table "relationships" */
export type RelationshipsAvgOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export type RelationshipsBoolExp = {
  _and?: InputMaybe<Array<RelationshipsBoolExp>>;
  _not?: InputMaybe<RelationshipsBoolExp>;
  _or?: InputMaybe<Array<RelationshipsBoolExp>>;
  from_name?: InputMaybe<StringComparisonExp>;
  from_object_definition?: InputMaybe<ObjectDefinitionsBoolExp>;
  from_object_definition_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  ownership?: InputMaybe<BooleanComparisonExp>;
  relationship_references?: InputMaybe<RelationshipReferencesBoolExp>;
  through_object_definition?: InputMaybe<ObjectDefinitionsBoolExp>;
  through_object_definition_id?: InputMaybe<BigintComparisonExp>;
  to_name?: InputMaybe<StringComparisonExp>;
  to_object_definition?: InputMaybe<ObjectDefinitionsBoolExp>;
  to_object_definition_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "relationships" */
export const RelationshipsConstraint = {
  /** unique or primary key constraint on columns "from_object_definition_id", "to_object_definition_id" */
  RelationshipsFromObjectDefinitionIdToObjectDefinitioKey: 'relationships_from_object_definition_id_to_object_definitio_key',
  /** unique or primary key constraint on columns "id" */
  RelationshipsPkey: 'relationships_pkey'
} as const;

export type RelationshipsConstraint = typeof RelationshipsConstraint[keyof typeof RelationshipsConstraint];
/** input type for incrementing numeric columns in table "relationships" */
export type RelationshipsIncInput = {
  from_object_definition_id?: InputMaybe<Scalars['bigint']>;
  through_object_definition_id?: InputMaybe<Scalars['bigint']>;
  to_object_definition_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relationships" */
export type RelationshipsInsertInput = {
  from_name?: InputMaybe<Scalars['String']>;
  from_object_definition_id?: InputMaybe<Scalars['bigint']>;
  ownership?: InputMaybe<Scalars['Boolean']>;
  relationship_references?: InputMaybe<RelationshipReferencesArrRelInsertInput>;
  through_object_definition_id?: InputMaybe<Scalars['bigint']>;
  to_name?: InputMaybe<Scalars['String']>;
  to_object_definition_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "relationships" */
export type RelationshipsMaxOrderBy = {
  from_name?: InputMaybe<OrderBy>;
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_name?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "relationships" */
export type RelationshipsMinOrderBy = {
  from_name?: InputMaybe<OrderBy>;
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_name?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "relationships" */
export type RelationshipsMutationResponse = {
  __typename?: 'relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relationships>;
};

/** input type for inserting object relation for remote table "relationships" */
export type RelationshipsObjRelInsertInput = {
  data: RelationshipsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RelationshipsOnConflict>;
};

/** on_conflict condition type for table "relationships" */
export type RelationshipsOnConflict = {
  constraint: RelationshipsConstraint;
  update_columns?: Array<RelationshipsUpdateColumn>;
  where?: InputMaybe<RelationshipsBoolExp>;
};

/** Ordering options when selecting data from "relationships". */
export type RelationshipsOrderBy = {
  from_name?: InputMaybe<OrderBy>;
  from_object_definition?: InputMaybe<ObjectDefinitionsOrderBy>;
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ownership?: InputMaybe<OrderBy>;
  relationship_references_aggregate?: InputMaybe<RelationshipReferencesAggregateOrderBy>;
  through_object_definition?: InputMaybe<ObjectDefinitionsOrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_name?: InputMaybe<OrderBy>;
  to_object_definition?: InputMaybe<ObjectDefinitionsOrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: relationships */
export type RelationshipsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "relationships" */
export const RelationshipsSelectColumn = {
  /** column name */
  FromName: 'from_name',
  /** column name */
  FromObjectDefinitionId: 'from_object_definition_id',
  /** column name */
  Id: 'id',
  /** column name */
  Ownership: 'ownership',
  /** column name */
  ThroughObjectDefinitionId: 'through_object_definition_id',
  /** column name */
  ToName: 'to_name',
  /** column name */
  ToObjectDefinitionId: 'to_object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type RelationshipsSelectColumn = typeof RelationshipsSelectColumn[keyof typeof RelationshipsSelectColumn];
/** input type for updating data in table "relationships" */
export type RelationshipsSetInput = {
  from_name?: InputMaybe<Scalars['String']>;
  from_object_definition_id?: InputMaybe<Scalars['bigint']>;
  ownership?: InputMaybe<Scalars['Boolean']>;
  through_object_definition_id?: InputMaybe<Scalars['bigint']>;
  to_name?: InputMaybe<Scalars['String']>;
  to_object_definition_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "relationships" */
export type RelationshipsStddevOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "relationships" */
export type RelationshipsStddevPopOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "relationships" */
export type RelationshipsStddevSampOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "relationships" */
export type RelationshipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RelationshipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationshipsStreamCursorValueInput = {
  from_name?: InputMaybe<Scalars['String']>;
  from_object_definition_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  ownership?: InputMaybe<Scalars['Boolean']>;
  through_object_definition_id?: InputMaybe<Scalars['bigint']>;
  to_name?: InputMaybe<Scalars['String']>;
  to_object_definition_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "relationships" */
export type RelationshipsSumOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** update columns of table "relationships" */
export const RelationshipsUpdateColumn = {
  /** column name */
  FromName: 'from_name',
  /** column name */
  FromObjectDefinitionId: 'from_object_definition_id',
  /** column name */
  Ownership: 'ownership',
  /** column name */
  ThroughObjectDefinitionId: 'through_object_definition_id',
  /** column name */
  ToName: 'to_name',
  /** column name */
  ToObjectDefinitionId: 'to_object_definition_id',
  /** column name */
  Type: 'type'
} as const;

export type RelationshipsUpdateColumn = typeof RelationshipsUpdateColumn[keyof typeof RelationshipsUpdateColumn];
export type RelationshipsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RelationshipsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationshipsSetInput>;
  /** filter the rows which have to be updated */
  where: RelationshipsBoolExp;
};

/** order by var_pop() on columns of table "relationships" */
export type RelationshipsVarPopOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "relationships" */
export type RelationshipsVarSampOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "relationships" */
export type RelationshipsVarianceOrderBy = {
  from_object_definition_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  through_object_definition_id?: InputMaybe<OrderBy>;
  to_object_definition_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "report_schedule" */
export type ReportSchedule = {
  __typename?: 'report_schedule';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  /** An object relationship */
  current_version?: Maybe<CurrentReportScheduleVersions>;
  delivery_config?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name: Scalars['String'];
  recipient?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  report_schedule_runs: Array<ReportScheduleRuns>;
  /** An aggregate relationship */
  report_schedule_runs_aggregate: ReportScheduleRunsAggregate;
  /** An array relationship */
  report_schedule_versions: Array<ReportScheduleVersions>;
  /** An aggregate relationship */
  report_schedule_versions_aggregate: ReportScheduleVersionsAggregate;
  schedule?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  /** An object relationship */
  updated_by_user: Users;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleDeliveryConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleRecipientArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleReportScheduleRunsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleReportScheduleRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleReportScheduleVersionsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleReportScheduleVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


/** columns and relationships of "report_schedule" */
export type ReportScheduleScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "report_schedule" */
export type ReportScheduleAggregate = {
  __typename?: 'report_schedule_aggregate';
  aggregate?: Maybe<ReportScheduleAggregateFields>;
  nodes: Array<ReportSchedule>;
};

/** aggregate fields of "report_schedule" */
export type ReportScheduleAggregateFields = {
  __typename?: 'report_schedule_aggregate_fields';
  avg?: Maybe<ReportScheduleAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReportScheduleMaxFields>;
  min?: Maybe<ReportScheduleMinFields>;
  stddev?: Maybe<ReportScheduleStddevFields>;
  stddev_pop?: Maybe<ReportScheduleStddevPopFields>;
  stddev_samp?: Maybe<ReportScheduleStddevSampFields>;
  sum?: Maybe<ReportScheduleSumFields>;
  var_pop?: Maybe<ReportScheduleVarPopFields>;
  var_samp?: Maybe<ReportScheduleVarSampFields>;
  variance?: Maybe<ReportScheduleVarianceFields>;
};


/** aggregate fields of "report_schedule" */
export type ReportScheduleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportScheduleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ReportScheduleAppendInput = {
  delivery_config?: InputMaybe<Scalars['jsonb']>;
  recipient?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ReportScheduleAvgFields = {
  __typename?: 'report_schedule_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "report_schedule". All fields are combined with a logical 'AND'. */
export type ReportScheduleBoolExp = {
  _and?: InputMaybe<Array<ReportScheduleBoolExp>>;
  _not?: InputMaybe<ReportScheduleBoolExp>;
  _or?: InputMaybe<Array<ReportScheduleBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  current_version?: InputMaybe<CurrentReportScheduleVersionsBoolExp>;
  delivery_config?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  recipient?: InputMaybe<JsonbComparisonExp>;
  report_schedule_runs?: InputMaybe<ReportScheduleRunsBoolExp>;
  report_schedule_runs_aggregate?: InputMaybe<ReportScheduleRunsAggregateBoolExp>;
  report_schedule_versions?: InputMaybe<ReportScheduleVersionsBoolExp>;
  report_schedule_versions_aggregate?: InputMaybe<ReportScheduleVersionsAggregateBoolExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ReportScheduleDeleteAtPathInput = {
  delivery_config?: InputMaybe<Array<Scalars['String']>>;
  recipient?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ReportScheduleDeleteElemInput = {
  delivery_config?: InputMaybe<Scalars['Int']>;
  recipient?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ReportScheduleDeleteKeyInput = {
  delivery_config?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "report_schedule" */
export type ReportScheduleIncInput = {
  created_by?: InputMaybe<Scalars['bigint']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ReportScheduleMaxFields = {
  __typename?: 'report_schedule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ReportScheduleMinFields = {
  __typename?: 'report_schedule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "report_schedule" */
export type ReportScheduleMutationResponse = {
  __typename?: 'report_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportSchedule>;
};

/** Ordering options when selecting data from "report_schedule". */
export type ReportScheduleOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  current_version?: InputMaybe<CurrentReportScheduleVersionsOrderBy>;
  delivery_config?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  recipient?: InputMaybe<OrderBy>;
  report_schedule_runs_aggregate?: InputMaybe<ReportScheduleRunsAggregateOrderBy>;
  report_schedule_versions_aggregate?: InputMaybe<ReportScheduleVersionsAggregateOrderBy>;
  schedule?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: report_schedule */
export type ReportSchedulePkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ReportSchedulePrependInput = {
  delivery_config?: InputMaybe<Scalars['jsonb']>;
  recipient?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "report_schedule_run_comments" */
export type ReportScheduleRunComments = {
  __typename?: 'report_schedule_run_comments';
  anchor_kind: Scalars['String'];
  annotation: Scalars['String'];
  /** An object relationship */
  applied_by_interaction?: Maybe<LlmChatInteractions>;
  applied_by_llm_chat_interaction_id: Scalars['uuid'];
  comment_order: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  /** An object relationship */
  created_by_user: Users;
  id: Scalars['uuid'];
  report_schedule_run_id: Scalars['uuid'];
  section_heading?: Maybe<Scalars['String']>;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "report_schedule_run_comments" */
export type ReportScheduleRunCommentsAggregate = {
  __typename?: 'report_schedule_run_comments_aggregate';
  aggregate?: Maybe<ReportScheduleRunCommentsAggregateFields>;
  nodes: Array<ReportScheduleRunComments>;
};

export type ReportScheduleRunCommentsAggregateBoolExp = {
  count?: InputMaybe<ReportScheduleRunCommentsAggregateBoolExpCount>;
};

export type ReportScheduleRunCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "report_schedule_run_comments" */
export type ReportScheduleRunCommentsAggregateFields = {
  __typename?: 'report_schedule_run_comments_aggregate_fields';
  avg?: Maybe<ReportScheduleRunCommentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReportScheduleRunCommentsMaxFields>;
  min?: Maybe<ReportScheduleRunCommentsMinFields>;
  stddev?: Maybe<ReportScheduleRunCommentsStddevFields>;
  stddev_pop?: Maybe<ReportScheduleRunCommentsStddevPopFields>;
  stddev_samp?: Maybe<ReportScheduleRunCommentsStddevSampFields>;
  sum?: Maybe<ReportScheduleRunCommentsSumFields>;
  var_pop?: Maybe<ReportScheduleRunCommentsVarPopFields>;
  var_samp?: Maybe<ReportScheduleRunCommentsVarSampFields>;
  variance?: Maybe<ReportScheduleRunCommentsVarianceFields>;
};


/** aggregate fields of "report_schedule_run_comments" */
export type ReportScheduleRunCommentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsAggregateOrderBy = {
  avg?: InputMaybe<ReportScheduleRunCommentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReportScheduleRunCommentsMaxOrderBy>;
  min?: InputMaybe<ReportScheduleRunCommentsMinOrderBy>;
  stddev?: InputMaybe<ReportScheduleRunCommentsStddevOrderBy>;
  stddev_pop?: InputMaybe<ReportScheduleRunCommentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ReportScheduleRunCommentsStddevSampOrderBy>;
  sum?: InputMaybe<ReportScheduleRunCommentsSumOrderBy>;
  var_pop?: InputMaybe<ReportScheduleRunCommentsVarPopOrderBy>;
  var_samp?: InputMaybe<ReportScheduleRunCommentsVarSampOrderBy>;
  variance?: InputMaybe<ReportScheduleRunCommentsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ReportScheduleRunCommentsAvgFields = {
  __typename?: 'report_schedule_run_comments_avg_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsAvgOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "report_schedule_run_comments". All fields are combined with a logical 'AND'. */
export type ReportScheduleRunCommentsBoolExp = {
  _and?: InputMaybe<Array<ReportScheduleRunCommentsBoolExp>>;
  _not?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
  _or?: InputMaybe<Array<ReportScheduleRunCommentsBoolExp>>;
  anchor_kind?: InputMaybe<StringComparisonExp>;
  annotation?: InputMaybe<StringComparisonExp>;
  applied_by_interaction?: InputMaybe<LlmChatInteractionsBoolExp>;
  applied_by_llm_chat_interaction_id?: InputMaybe<UuidComparisonExp>;
  comment_order?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  report_schedule_run_id?: InputMaybe<UuidComparisonExp>;
  section_heading?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ReportScheduleRunCommentsMaxFields = {
  __typename?: 'report_schedule_run_comments_max_fields';
  anchor_kind?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  applied_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  comment_order?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  section_heading?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsMaxOrderBy = {
  anchor_kind?: InputMaybe<OrderBy>;
  annotation?: InputMaybe<OrderBy>;
  applied_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  comment_order?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  section_heading?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReportScheduleRunCommentsMinFields = {
  __typename?: 'report_schedule_run_comments_min_fields';
  anchor_kind?: Maybe<Scalars['String']>;
  annotation?: Maybe<Scalars['String']>;
  applied_by_llm_chat_interaction_id?: Maybe<Scalars['uuid']>;
  comment_order?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  report_schedule_run_id?: Maybe<Scalars['uuid']>;
  section_heading?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsMinOrderBy = {
  anchor_kind?: InputMaybe<OrderBy>;
  annotation?: InputMaybe<OrderBy>;
  applied_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  comment_order?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  section_heading?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsMutationResponse = {
  __typename?: 'report_schedule_run_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportScheduleRunComments>;
};

/** Ordering options when selecting data from "report_schedule_run_comments". */
export type ReportScheduleRunCommentsOrderBy = {
  anchor_kind?: InputMaybe<OrderBy>;
  annotation?: InputMaybe<OrderBy>;
  applied_by_interaction?: InputMaybe<LlmChatInteractionsOrderBy>;
  applied_by_llm_chat_interaction_id?: InputMaybe<OrderBy>;
  comment_order?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  id?: InputMaybe<OrderBy>;
  report_schedule_run_id?: InputMaybe<OrderBy>;
  section_heading?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "report_schedule_run_comments" */
export const ReportScheduleRunCommentsSelectColumn = {
  /** column name */
  AnchorKind: 'anchor_kind',
  /** column name */
  Annotation: 'annotation',
  /** column name */
  AppliedByLlmChatInteractionId: 'applied_by_llm_chat_interaction_id',
  /** column name */
  CommentOrder: 'comment_order',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  ReportScheduleRunId: 'report_schedule_run_id',
  /** column name */
  SectionHeading: 'section_heading',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReportScheduleRunCommentsSelectColumn = typeof ReportScheduleRunCommentsSelectColumn[keyof typeof ReportScheduleRunCommentsSelectColumn];
/** aggregate stddev on columns */
export type ReportScheduleRunCommentsStddevFields = {
  __typename?: 'report_schedule_run_comments_stddev_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsStddevOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ReportScheduleRunCommentsStddevPopFields = {
  __typename?: 'report_schedule_run_comments_stddev_pop_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsStddevPopOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ReportScheduleRunCommentsStddevSampFields = {
  __typename?: 'report_schedule_run_comments_stddev_samp_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsStddevSampOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReportScheduleRunCommentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportScheduleRunCommentsStreamCursorValueInput = {
  anchor_kind?: InputMaybe<Scalars['String']>;
  annotation?: InputMaybe<Scalars['String']>;
  applied_by_llm_chat_interaction_id?: InputMaybe<Scalars['uuid']>;
  comment_order?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  report_schedule_run_id?: InputMaybe<Scalars['uuid']>;
  section_heading?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReportScheduleRunCommentsSumFields = {
  __typename?: 'report_schedule_run_comments_sum_fields';
  comment_order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsSumOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ReportScheduleRunCommentsVarPopFields = {
  __typename?: 'report_schedule_run_comments_var_pop_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsVarPopOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ReportScheduleRunCommentsVarSampFields = {
  __typename?: 'report_schedule_run_comments_var_samp_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsVarSampOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReportScheduleRunCommentsVarianceFields = {
  __typename?: 'report_schedule_run_comments_variance_fields';
  comment_order?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "report_schedule_run_comments" */
export type ReportScheduleRunCommentsVarianceOrderBy = {
  comment_order?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRuns = {
  __typename?: 'report_schedule_runs';
  /** An array relationship */
  amp_launch_verdicts: Array<AmpLaunchVerdicts>;
  /** An array relationship */
  amp_opportunities: Array<AmpOpportunities>;
  /** An aggregate relationship */
  amp_opportunities_aggregate: AmpOpportunitiesAggregate;
  /** An array relationship */
  amp_signals: Array<AmpSignals>;
  /** An aggregate relationship */
  amp_signals_aggregate: AmpSignalsAggregate;
  card_summary?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['jsonb']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  llm_chat_session: LlmChatSessions;
  /** An object relationship */
  report_schedule: ReportSchedule;
  report_schedule_id: Scalars['uuid'];
  /** An array relationship */
  report_schedule_run_comments: Array<ReportScheduleRunComments>;
  /** An aggregate relationship */
  report_schedule_run_comments_aggregate: ReportScheduleRunCommentsAggregate;
  session_id: Scalars['uuid'];
  summary?: Maybe<Scalars['String']>;
  trigger_type: Scalars['String'];
  /** An object relationship */
  version?: Maybe<ReportScheduleVersions>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsAmpLaunchVerdictsArgs = {
  distinct_on?: InputMaybe<Array<AmpLaunchVerdictsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpLaunchVerdictsOrderBy>>;
  where?: InputMaybe<AmpLaunchVerdictsBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsAmpOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsAmpOpportunitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsAmpSignalsArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsAmpSignalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsCardSummaryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsReportScheduleRunCommentsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


/** columns and relationships of "report_schedule_runs" */
export type ReportScheduleRunsReportScheduleRunCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};

/** aggregated selection of "report_schedule_runs" */
export type ReportScheduleRunsAggregate = {
  __typename?: 'report_schedule_runs_aggregate';
  aggregate?: Maybe<ReportScheduleRunsAggregateFields>;
  nodes: Array<ReportScheduleRuns>;
};

export type ReportScheduleRunsAggregateBoolExp = {
  count?: InputMaybe<ReportScheduleRunsAggregateBoolExpCount>;
};

export type ReportScheduleRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReportScheduleRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "report_schedule_runs" */
export type ReportScheduleRunsAggregateFields = {
  __typename?: 'report_schedule_runs_aggregate_fields';
  avg?: Maybe<ReportScheduleRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReportScheduleRunsMaxFields>;
  min?: Maybe<ReportScheduleRunsMinFields>;
  stddev?: Maybe<ReportScheduleRunsStddevFields>;
  stddev_pop?: Maybe<ReportScheduleRunsStddevPopFields>;
  stddev_samp?: Maybe<ReportScheduleRunsStddevSampFields>;
  sum?: Maybe<ReportScheduleRunsSumFields>;
  var_pop?: Maybe<ReportScheduleRunsVarPopFields>;
  var_samp?: Maybe<ReportScheduleRunsVarSampFields>;
  variance?: Maybe<ReportScheduleRunsVarianceFields>;
};


/** aggregate fields of "report_schedule_runs" */
export type ReportScheduleRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_schedule_runs" */
export type ReportScheduleRunsAggregateOrderBy = {
  avg?: InputMaybe<ReportScheduleRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReportScheduleRunsMaxOrderBy>;
  min?: InputMaybe<ReportScheduleRunsMinOrderBy>;
  stddev?: InputMaybe<ReportScheduleRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<ReportScheduleRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ReportScheduleRunsStddevSampOrderBy>;
  sum?: InputMaybe<ReportScheduleRunsSumOrderBy>;
  var_pop?: InputMaybe<ReportScheduleRunsVarPopOrderBy>;
  var_samp?: InputMaybe<ReportScheduleRunsVarSampOrderBy>;
  variance?: InputMaybe<ReportScheduleRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ReportScheduleRunsAvgFields = {
  __typename?: 'report_schedule_runs_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "report_schedule_runs". All fields are combined with a logical 'AND'. */
export type ReportScheduleRunsBoolExp = {
  _and?: InputMaybe<Array<ReportScheduleRunsBoolExp>>;
  _not?: InputMaybe<ReportScheduleRunsBoolExp>;
  _or?: InputMaybe<Array<ReportScheduleRunsBoolExp>>;
  amp_launch_verdicts?: InputMaybe<AmpLaunchVerdictsBoolExp>;
  amp_opportunities?: InputMaybe<AmpOpportunitiesBoolExp>;
  amp_opportunities_aggregate?: InputMaybe<AmpOpportunitiesAggregateBoolExp>;
  amp_signals?: InputMaybe<AmpSignalsBoolExp>;
  amp_signals_aggregate?: InputMaybe<AmpSignalsAggregateBoolExp>;
  card_summary?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  report_schedule?: InputMaybe<ReportScheduleBoolExp>;
  report_schedule_id?: InputMaybe<UuidComparisonExp>;
  report_schedule_run_comments?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
  report_schedule_run_comments_aggregate?: InputMaybe<ReportScheduleRunCommentsAggregateBoolExp>;
  session_id?: InputMaybe<UuidComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  trigger_type?: InputMaybe<StringComparisonExp>;
  version?: InputMaybe<ReportScheduleVersionsBoolExp>;
  version_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ReportScheduleRunsMaxFields = {
  __typename?: 'report_schedule_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  report_schedule_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  trigger_type?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  session_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  trigger_type?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReportScheduleRunsMinFields = {
  __typename?: 'report_schedule_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  report_schedule_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['uuid']>;
  summary?: Maybe<Scalars['String']>;
  trigger_type?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  session_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  trigger_type?: InputMaybe<OrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "report_schedule_runs" */
export type ReportScheduleRunsMutationResponse = {
  __typename?: 'report_schedule_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportScheduleRuns>;
};

/** Ordering options when selecting data from "report_schedule_runs". */
export type ReportScheduleRunsOrderBy = {
  amp_launch_verdicts_aggregate?: InputMaybe<AmpLaunchVerdictsAggregateOrderBy>;
  amp_opportunities_aggregate?: InputMaybe<AmpOpportunitiesAggregateOrderBy>;
  amp_signals_aggregate?: InputMaybe<AmpSignalsAggregateOrderBy>;
  card_summary?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  report_schedule?: InputMaybe<ReportScheduleOrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  report_schedule_run_comments_aggregate?: InputMaybe<ReportScheduleRunCommentsAggregateOrderBy>;
  session_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  trigger_type?: InputMaybe<OrderBy>;
  version?: InputMaybe<ReportScheduleVersionsOrderBy>;
  version_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "report_schedule_runs" */
export const ReportScheduleRunsSelectColumn = {
  /** column name */
  CardSummary: 'card_summary',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  ReportScheduleId: 'report_schedule_id',
  /** column name */
  SessionId: 'session_id',
  /** column name */
  Summary: 'summary',
  /** column name */
  TriggerType: 'trigger_type',
  /** column name */
  VersionId: 'version_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReportScheduleRunsSelectColumn = typeof ReportScheduleRunsSelectColumn[keyof typeof ReportScheduleRunsSelectColumn];
/** aggregate stddev on columns */
export type ReportScheduleRunsStddevFields = {
  __typename?: 'report_schedule_runs_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ReportScheduleRunsStddevPopFields = {
  __typename?: 'report_schedule_runs_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ReportScheduleRunsStddevSampFields = {
  __typename?: 'report_schedule_runs_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "report_schedule_runs" */
export type ReportScheduleRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReportScheduleRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportScheduleRunsStreamCursorValueInput = {
  card_summary?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  report_schedule_id?: InputMaybe<Scalars['uuid']>;
  session_id?: InputMaybe<Scalars['uuid']>;
  summary?: InputMaybe<Scalars['String']>;
  trigger_type?: InputMaybe<Scalars['String']>;
  version_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReportScheduleRunsSumFields = {
  __typename?: 'report_schedule_runs_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ReportScheduleRunsVarPopFields = {
  __typename?: 'report_schedule_runs_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ReportScheduleRunsVarSampFields = {
  __typename?: 'report_schedule_runs_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReportScheduleRunsVarianceFields = {
  __typename?: 'report_schedule_runs_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "report_schedule_runs" */
export type ReportScheduleRunsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "report_schedule" */
export const ReportScheduleSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeliveryConfig: 'delivery_config',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  Recipient: 'recipient',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReportScheduleSelectColumn = typeof ReportScheduleSelectColumn[keyof typeof ReportScheduleSelectColumn];
/** input type for updating data in table "report_schedule" */
export type ReportScheduleSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  delivery_config?: InputMaybe<Scalars['jsonb']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ReportScheduleStddevFields = {
  __typename?: 'report_schedule_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ReportScheduleStddevPopFields = {
  __typename?: 'report_schedule_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ReportScheduleStddevSampFields = {
  __typename?: 'report_schedule_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "report_schedule" */
export type ReportScheduleStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReportScheduleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportScheduleStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  delivery_config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReportScheduleSumFields = {
  __typename?: 'report_schedule_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

export type ReportScheduleUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ReportScheduleAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ReportScheduleDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ReportScheduleDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ReportScheduleDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportScheduleIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ReportSchedulePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportScheduleSetInput>;
  /** filter the rows which have to be updated */
  where: ReportScheduleBoolExp;
};

/** aggregate var_pop on columns */
export type ReportScheduleVarPopFields = {
  __typename?: 'report_schedule_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ReportScheduleVarSampFields = {
  __typename?: 'report_schedule_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ReportScheduleVarianceFields = {
  __typename?: 'report_schedule_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "report_schedule_versions" */
export type ReportScheduleVersions = {
  __typename?: 'report_schedule_versions';
  context: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  discarded_at?: Maybe<Scalars['timestamptz']>;
  files: Scalars['jsonb'];
  id: Scalars['uuid'];
  /** An object relationship */
  last_version?: Maybe<ReportScheduleVersions>;
  last_version_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parent_version?: Maybe<ReportScheduleVersions>;
  parent_version_id?: Maybe<Scalars['uuid']>;
  prompt: Scalars['String'];
  /** An object relationship */
  report_schedule: ReportSchedule;
  report_schedule_id: Scalars['uuid'];
  source: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version_number?: Maybe<Scalars['Int']>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "report_schedule_versions" */
export type ReportScheduleVersionsContextArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "report_schedule_versions" */
export type ReportScheduleVersionsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "report_schedule_versions" */
export type ReportScheduleVersionsAggregate = {
  __typename?: 'report_schedule_versions_aggregate';
  aggregate?: Maybe<ReportScheduleVersionsAggregateFields>;
  nodes: Array<ReportScheduleVersions>;
};

export type ReportScheduleVersionsAggregateBoolExp = {
  count?: InputMaybe<ReportScheduleVersionsAggregateBoolExpCount>;
};

export type ReportScheduleVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReportScheduleVersionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "report_schedule_versions" */
export type ReportScheduleVersionsAggregateFields = {
  __typename?: 'report_schedule_versions_aggregate_fields';
  avg?: Maybe<ReportScheduleVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReportScheduleVersionsMaxFields>;
  min?: Maybe<ReportScheduleVersionsMinFields>;
  stddev?: Maybe<ReportScheduleVersionsStddevFields>;
  stddev_pop?: Maybe<ReportScheduleVersionsStddevPopFields>;
  stddev_samp?: Maybe<ReportScheduleVersionsStddevSampFields>;
  sum?: Maybe<ReportScheduleVersionsSumFields>;
  var_pop?: Maybe<ReportScheduleVersionsVarPopFields>;
  var_samp?: Maybe<ReportScheduleVersionsVarSampFields>;
  variance?: Maybe<ReportScheduleVersionsVarianceFields>;
};


/** aggregate fields of "report_schedule_versions" */
export type ReportScheduleVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_schedule_versions" */
export type ReportScheduleVersionsAggregateOrderBy = {
  avg?: InputMaybe<ReportScheduleVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReportScheduleVersionsMaxOrderBy>;
  min?: InputMaybe<ReportScheduleVersionsMinOrderBy>;
  stddev?: InputMaybe<ReportScheduleVersionsStddevOrderBy>;
  stddev_pop?: InputMaybe<ReportScheduleVersionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ReportScheduleVersionsStddevSampOrderBy>;
  sum?: InputMaybe<ReportScheduleVersionsSumOrderBy>;
  var_pop?: InputMaybe<ReportScheduleVersionsVarPopOrderBy>;
  var_samp?: InputMaybe<ReportScheduleVersionsVarSampOrderBy>;
  variance?: InputMaybe<ReportScheduleVersionsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ReportScheduleVersionsAvgFields = {
  __typename?: 'report_schedule_versions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "report_schedule_versions". All fields are combined with a logical 'AND'. */
export type ReportScheduleVersionsBoolExp = {
  _and?: InputMaybe<Array<ReportScheduleVersionsBoolExp>>;
  _not?: InputMaybe<ReportScheduleVersionsBoolExp>;
  _or?: InputMaybe<Array<ReportScheduleVersionsBoolExp>>;
  context?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  discarded_at?: InputMaybe<TimestamptzComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_version?: InputMaybe<ReportScheduleVersionsBoolExp>;
  last_version_id?: InputMaybe<UuidComparisonExp>;
  llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  parent_version?: InputMaybe<ReportScheduleVersionsBoolExp>;
  parent_version_id?: InputMaybe<UuidComparisonExp>;
  prompt?: InputMaybe<StringComparisonExp>;
  report_schedule?: InputMaybe<ReportScheduleBoolExp>;
  report_schedule_id?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  version_number?: InputMaybe<IntComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ReportScheduleVersionsMaxFields = {
  __typename?: 'report_schedule_versions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  discarded_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_version_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  parent_version_id?: Maybe<Scalars['uuid']>;
  prompt?: Maybe<Scalars['String']>;
  report_schedule_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version_number?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  discarded_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_version_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parent_version_id?: InputMaybe<OrderBy>;
  prompt?: InputMaybe<OrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReportScheduleVersionsMinFields = {
  __typename?: 'report_schedule_versions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  discarded_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_version_id?: Maybe<Scalars['uuid']>;
  llm_chat_session_id?: Maybe<Scalars['uuid']>;
  parent_version_id?: Maybe<Scalars['uuid']>;
  prompt?: Maybe<Scalars['String']>;
  report_schedule_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version_number?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  discarded_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_version_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parent_version_id?: InputMaybe<OrderBy>;
  prompt?: InputMaybe<OrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "report_schedule_versions". */
export type ReportScheduleVersionsOrderBy = {
  context?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  discarded_at?: InputMaybe<OrderBy>;
  files?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_version?: InputMaybe<ReportScheduleVersionsOrderBy>;
  last_version_id?: InputMaybe<OrderBy>;
  llm_chat_session_id?: InputMaybe<OrderBy>;
  parent_version?: InputMaybe<ReportScheduleVersionsOrderBy>;
  parent_version_id?: InputMaybe<OrderBy>;
  prompt?: InputMaybe<OrderBy>;
  report_schedule?: InputMaybe<ReportScheduleOrderBy>;
  report_schedule_id?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "report_schedule_versions" */
export const ReportScheduleVersionsSelectColumn = {
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DiscardedAt: 'discarded_at',
  /** column name */
  Files: 'files',
  /** column name */
  Id: 'id',
  /** column name */
  LastVersionId: 'last_version_id',
  /** column name */
  LlmChatSessionId: 'llm_chat_session_id',
  /** column name */
  ParentVersionId: 'parent_version_id',
  /** column name */
  Prompt: 'prompt',
  /** column name */
  ReportScheduleId: 'report_schedule_id',
  /** column name */
  Source: 'source',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  VersionNumber: 'version_number',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReportScheduleVersionsSelectColumn = typeof ReportScheduleVersionsSelectColumn[keyof typeof ReportScheduleVersionsSelectColumn];
/** aggregate stddev on columns */
export type ReportScheduleVersionsStddevFields = {
  __typename?: 'report_schedule_versions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ReportScheduleVersionsStddevPopFields = {
  __typename?: 'report_schedule_versions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ReportScheduleVersionsStddevSampFields = {
  __typename?: 'report_schedule_versions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "report_schedule_versions" */
export type ReportScheduleVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReportScheduleVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReportScheduleVersionsStreamCursorValueInput = {
  context?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  discarded_at?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_version_id?: InputMaybe<Scalars['uuid']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  parent_version_id?: InputMaybe<Scalars['uuid']>;
  prompt?: InputMaybe<Scalars['String']>;
  report_schedule_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version_number?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReportScheduleVersionsSumFields = {
  __typename?: 'report_schedule_versions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  version_number?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ReportScheduleVersionsVarPopFields = {
  __typename?: 'report_schedule_versions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ReportScheduleVersionsVarSampFields = {
  __typename?: 'report_schedule_versions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReportScheduleVersionsVarianceFields = {
  __typename?: 'report_schedule_versions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  version_number?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "report_schedule_versions" */
export type ReportScheduleVersionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  version_number?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "resource_interactions" */
export type ResourceInteractions = {
  __typename?: 'resource_interactions';
  created_at: Scalars['timestamptz'];
  last_viewed_at: Scalars['timestamptz'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "resource_interactions". All fields are combined with a logical 'AND'. */
export type ResourceInteractionsBoolExp = {
  _and?: InputMaybe<Array<ResourceInteractionsBoolExp>>;
  _not?: InputMaybe<ResourceInteractionsBoolExp>;
  _or?: InputMaybe<Array<ResourceInteractionsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  last_viewed_at?: InputMaybe<TimestamptzComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "resource_interactions" */
export const ResourceInteractionsConstraint = {
  /** unique or primary key constraint on columns "user_id", "workspace_id", "resource_id", "resource_type" */
  ResourceInteractionsPkey: 'resource_interactions_pkey'
} as const;

export type ResourceInteractionsConstraint = typeof ResourceInteractionsConstraint[keyof typeof ResourceInteractionsConstraint];
/** input type for inserting data into table "resource_interactions" */
export type ResourceInteractionsInsertInput = {
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "resource_interactions" */
export type ResourceInteractionsMutationResponse = {
  __typename?: 'resource_interactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceInteractions>;
};

/** on_conflict condition type for table "resource_interactions" */
export type ResourceInteractionsOnConflict = {
  constraint: ResourceInteractionsConstraint;
  update_columns?: Array<ResourceInteractionsUpdateColumn>;
  where?: InputMaybe<ResourceInteractionsBoolExp>;
};

/** Ordering options when selecting data from "resource_interactions". */
export type ResourceInteractionsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  last_viewed_at?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: resource_interactions */
export type ResourceInteractionsPkColumnsInput = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "resource_interactions" */
export const ResourceInteractionsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  LastViewedAt: 'last_viewed_at',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceInteractionsSelectColumn = typeof ResourceInteractionsSelectColumn[keyof typeof ResourceInteractionsSelectColumn];
/** input type for updating data in table "resource_interactions" */
export type ResourceInteractionsSetInput = {
  last_viewed_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "resource_interactions" */
export type ResourceInteractionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceInteractionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceInteractionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "resource_interactions" */
export const ResourceInteractionsUpdateColumn = {
  /** column name */
  LastViewedAt: 'last_viewed_at'
} as const;

export type ResourceInteractionsUpdateColumn = typeof ResourceInteractionsUpdateColumn[keyof typeof ResourceInteractionsUpdateColumn];
export type ResourceInteractionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ResourceInteractionsSetInput>;
  /** filter the rows which have to be updated */
  where: ResourceInteractionsBoolExp;
};

/** columns and relationships of "resource_monitor_conditions" */
export type ResourceMonitorConditions = {
  __typename?: 'resource_monitor_conditions';
  enabled: Scalars['Boolean'];
  error_value?: Maybe<Scalars['jsonb']>;
  evaluation_trigger: Scalars['String'];
  evaluation_type: Scalars['String'];
  id: Scalars['uuid'];
  last_evaluated?: Maybe<Scalars['timestamptz']>;
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  /** An array relationship */
  statuses: Array<MonitorConditionStatuses>;
  type: Scalars['String'];
  warning_value?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "resource_monitor_conditions" */
export type ResourceMonitorConditionsErrorValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "resource_monitor_conditions" */
export type ResourceMonitorConditionsStatusesArgs = {
  distinct_on?: InputMaybe<Array<MonitorConditionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitorConditionStatusesOrderBy>>;
  where?: InputMaybe<MonitorConditionStatusesBoolExp>;
};


/** columns and relationships of "resource_monitor_conditions" */
export type ResourceMonitorConditionsWarningValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ResourceMonitorConditionsAppendInput = {
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "resource_monitor_conditions". All fields are combined with a logical 'AND'. */
export type ResourceMonitorConditionsBoolExp = {
  _and?: InputMaybe<Array<ResourceMonitorConditionsBoolExp>>;
  _not?: InputMaybe<ResourceMonitorConditionsBoolExp>;
  _or?: InputMaybe<Array<ResourceMonitorConditionsBoolExp>>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  error_value?: InputMaybe<JsonbComparisonExp>;
  evaluation_trigger?: InputMaybe<StringComparisonExp>;
  evaluation_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_evaluated?: InputMaybe<TimestamptzComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  statuses?: InputMaybe<MonitorConditionStatusesBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  warning_value?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "resource_monitor_conditions" */
export const ResourceMonitorConditionsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ResourceMonitorConditionsIdWorkspaceIdKey: 'resource_monitor_conditions_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ResourceMonitorConditionsPkey: 'resource_monitor_conditions_pkey',
  /** unique or primary key constraint on columns "type", "resource_id", "resource_type" */
  ResourceMonitorConditionsTypeResourceIdResourceTypeKey: 'resource_monitor_conditions_type_resource_id_resource_type_key'
} as const;

export type ResourceMonitorConditionsConstraint = typeof ResourceMonitorConditionsConstraint[keyof typeof ResourceMonitorConditionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ResourceMonitorConditionsDeleteAtPathInput = {
  error_value?: InputMaybe<Array<Scalars['String']>>;
  warning_value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ResourceMonitorConditionsDeleteElemInput = {
  error_value?: InputMaybe<Scalars['Int']>;
  warning_value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ResourceMonitorConditionsDeleteKeyInput = {
  error_value?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "resource_monitor_conditions" */
export type ResourceMonitorConditionsInsertInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  evaluation_trigger?: InputMaybe<Scalars['String']>;
  evaluation_type?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "resource_monitor_conditions" */
export type ResourceMonitorConditionsMutationResponse = {
  __typename?: 'resource_monitor_conditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceMonitorConditions>;
};

/** on_conflict condition type for table "resource_monitor_conditions" */
export type ResourceMonitorConditionsOnConflict = {
  constraint: ResourceMonitorConditionsConstraint;
  update_columns?: Array<ResourceMonitorConditionsUpdateColumn>;
  where?: InputMaybe<ResourceMonitorConditionsBoolExp>;
};

/** Ordering options when selecting data from "resource_monitor_conditions". */
export type ResourceMonitorConditionsOrderBy = {
  enabled?: InputMaybe<OrderBy>;
  error_value?: InputMaybe<OrderBy>;
  evaluation_trigger?: InputMaybe<OrderBy>;
  evaluation_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_evaluated?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  statuses_aggregate?: InputMaybe<MonitorConditionStatusesAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  warning_value?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: resource_monitor_conditions */
export type ResourceMonitorConditionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ResourceMonitorConditionsPrependInput = {
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "resource_monitor_conditions" */
export const ResourceMonitorConditionsSelectColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  ErrorValue: 'error_value',
  /** column name */
  EvaluationTrigger: 'evaluation_trigger',
  /** column name */
  EvaluationType: 'evaluation_type',
  /** column name */
  Id: 'id',
  /** column name */
  LastEvaluated: 'last_evaluated',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  Type: 'type',
  /** column name */
  WarningValue: 'warning_value',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceMonitorConditionsSelectColumn = typeof ResourceMonitorConditionsSelectColumn[keyof typeof ResourceMonitorConditionsSelectColumn];
/** input type for updating data in table "resource_monitor_conditions" */
export type ResourceMonitorConditionsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "resource_monitor_conditions" */
export type ResourceMonitorConditionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceMonitorConditionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceMonitorConditionsStreamCursorValueInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  error_value?: InputMaybe<Scalars['jsonb']>;
  evaluation_trigger?: InputMaybe<Scalars['String']>;
  evaluation_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_evaluated?: InputMaybe<Scalars['timestamptz']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warning_value?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "resource_monitor_conditions" */
export const ResourceMonitorConditionsUpdateColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  ErrorValue: 'error_value',
  /** column name */
  WarningValue: 'warning_value'
} as const;

export type ResourceMonitorConditionsUpdateColumn = typeof ResourceMonitorConditionsUpdateColumn[keyof typeof ResourceMonitorConditionsUpdateColumn];
export type ResourceMonitorConditionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ResourceMonitorConditionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ResourceMonitorConditionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ResourceMonitorConditionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ResourceMonitorConditionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ResourceMonitorConditionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ResourceMonitorConditionsSetInput>;
  /** filter the rows which have to be updated */
  where: ResourceMonitorConditionsBoolExp;
};

/** columns and relationships of "resource_monitor_statuses" */
export type ResourceMonitorStatuses = {
  __typename?: 'resource_monitor_statuses';
  condition_changes: Scalars['jsonb'];
  id: Scalars['uuid'];
  new_status: Scalars['String'];
  old_status?: Maybe<Scalars['String']>;
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  transitioned_at: Scalars['timestamptz'];
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "resource_monitor_statuses" */
export type ResourceMonitorStatusesConditionChangesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "resource_monitor_statuses". All fields are combined with a logical 'AND'. */
export type ResourceMonitorStatusesBoolExp = {
  _and?: InputMaybe<Array<ResourceMonitorStatusesBoolExp>>;
  _not?: InputMaybe<ResourceMonitorStatusesBoolExp>;
  _or?: InputMaybe<Array<ResourceMonitorStatusesBoolExp>>;
  condition_changes?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  new_status?: InputMaybe<StringComparisonExp>;
  old_status?: InputMaybe<StringComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  transitioned_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "resource_monitor_statuses". */
export type ResourceMonitorStatusesOrderBy = {
  condition_changes?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  new_status?: InputMaybe<OrderBy>;
  old_status?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  transitioned_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "resource_monitor_statuses" */
export const ResourceMonitorStatusesSelectColumn = {
  /** column name */
  ConditionChanges: 'condition_changes',
  /** column name */
  Id: 'id',
  /** column name */
  NewStatus: 'new_status',
  /** column name */
  OldStatus: 'old_status',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  TransitionedAt: 'transitioned_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceMonitorStatusesSelectColumn = typeof ResourceMonitorStatusesSelectColumn[keyof typeof ResourceMonitorStatusesSelectColumn];
/** Streaming cursor of the table "resource_monitor_statuses" */
export type ResourceMonitorStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceMonitorStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceMonitorStatusesStreamCursorValueInput = {
  condition_changes?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_status?: InputMaybe<Scalars['String']>;
  old_status?: InputMaybe<Scalars['String']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  transitioned_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "resource_notification_channels" */
export type ResourceNotificationChannels = {
  __typename?: 'resource_notification_channels';
  channel_id: Scalars['uuid'];
  /** An object relationship */
  decision_engine_flow?: Maybe<DecisionEngineFlows>;
  disabled: Scalars['Boolean'];
  /** An object relationship */
  event_source?: Maybe<EventSources>;
  /** An object relationship */
  event_streaming_sync?: Maybe<EventForwardingSyncs>;
  /** An object relationship */
  event_sync?: Maybe<EventWarehouseSyncs>;
  id: Scalars['uuid'];
  /** An object relationship */
  idr?: Maybe<Idr>;
  /** An object relationship */
  journey?: Maybe<Journeys>;
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  /** An array relationship */
  sent_resource_notifications: Array<SentResourceNotifications>;
  should_send_recovery: Scalars['Boolean'];
  status: Scalars['String'];
  /** An object relationship */
  sync?: Maybe<Syncs>;
  /** An object relationship */
  workspace_notification_channel: WorkspaceNotificationChannels;
};


/** columns and relationships of "resource_notification_channels" */
export type ResourceNotificationChannelsSentResourceNotificationsArgs = {
  distinct_on?: InputMaybe<Array<SentResourceNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SentResourceNotificationsOrderBy>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};

/** order by aggregate values of table "resource_notification_channels" */
export type ResourceNotificationChannelsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ResourceNotificationChannelsMaxOrderBy>;
  min?: InputMaybe<ResourceNotificationChannelsMinOrderBy>;
};

/** input type for inserting array relation for remote table "resource_notification_channels" */
export type ResourceNotificationChannelsArrRelInsertInput = {
  data: Array<ResourceNotificationChannelsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ResourceNotificationChannelsOnConflict>;
};

/** Boolean expression to filter rows from the table "resource_notification_channels". All fields are combined with a logical 'AND'. */
export type ResourceNotificationChannelsBoolExp = {
  _and?: InputMaybe<Array<ResourceNotificationChannelsBoolExp>>;
  _not?: InputMaybe<ResourceNotificationChannelsBoolExp>;
  _or?: InputMaybe<Array<ResourceNotificationChannelsBoolExp>>;
  channel_id?: InputMaybe<UuidComparisonExp>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsBoolExp>;
  disabled?: InputMaybe<BooleanComparisonExp>;
  event_source?: InputMaybe<EventSourcesBoolExp>;
  event_streaming_sync?: InputMaybe<EventForwardingSyncsBoolExp>;
  event_sync?: InputMaybe<EventWarehouseSyncsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr?: InputMaybe<IdrBoolExp>;
  journey?: InputMaybe<JourneysBoolExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  sent_resource_notifications?: InputMaybe<SentResourceNotificationsBoolExp>;
  should_send_recovery?: InputMaybe<BooleanComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};

/** unique or primary key constraints on table "resource_notification_channels" */
export const ResourceNotificationChannelsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  ResourceNotificationChannelsIdWorkspaceIdKey: 'resource_notification_channels_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  ResourceNotificationChannelsPkey: 'resource_notification_channels_pkey',
  /** unique or primary key constraint on columns "status", "channel_id", "resource_id", "resource_type" */
  ResourceNotificationChannelsStatusResourceTypeChannelId: 'resource_notification_channels_status_resource_type_channel_id_'
} as const;

export type ResourceNotificationChannelsConstraint = typeof ResourceNotificationChannelsConstraint[keyof typeof ResourceNotificationChannelsConstraint];
/** input type for inserting data into table "resource_notification_channels" */
export type ResourceNotificationChannelsInsertInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  event_streaming_sync?: InputMaybe<EventForwardingSyncsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']>;
  journey?: InputMaybe<JourneysObjRelInsertInput>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsObjRelInsertInput>;
};

/** order by max() on columns of table "resource_notification_channels" */
export type ResourceNotificationChannelsMaxOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "resource_notification_channels" */
export type ResourceNotificationChannelsMinOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "resource_notification_channels" */
export type ResourceNotificationChannelsMutationResponse = {
  __typename?: 'resource_notification_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceNotificationChannels>;
};

/** on_conflict condition type for table "resource_notification_channels" */
export type ResourceNotificationChannelsOnConflict = {
  constraint: ResourceNotificationChannelsConstraint;
  update_columns?: Array<ResourceNotificationChannelsUpdateColumn>;
  where?: InputMaybe<ResourceNotificationChannelsBoolExp>;
};

/** Ordering options when selecting data from "resource_notification_channels". */
export type ResourceNotificationChannelsOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  decision_engine_flow?: InputMaybe<DecisionEngineFlowsOrderBy>;
  disabled?: InputMaybe<OrderBy>;
  event_source?: InputMaybe<EventSourcesOrderBy>;
  event_streaming_sync?: InputMaybe<EventForwardingSyncsOrderBy>;
  event_sync?: InputMaybe<EventWarehouseSyncsOrderBy>;
  id?: InputMaybe<OrderBy>;
  idr?: InputMaybe<IdrOrderBy>;
  journey?: InputMaybe<JourneysOrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  sent_resource_notifications_aggregate?: InputMaybe<SentResourceNotificationsAggregateOrderBy>;
  should_send_recovery?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsOrderBy>;
};

/** primary key columns input for table: resource_notification_channels */
export type ResourceNotificationChannelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "resource_notification_channels" */
export const ResourceNotificationChannelsSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  Disabled: 'disabled',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  ShouldSendRecovery: 'should_send_recovery',
  /** column name */
  Status: 'status'
} as const;

export type ResourceNotificationChannelsSelectColumn = typeof ResourceNotificationChannelsSelectColumn[keyof typeof ResourceNotificationChannelsSelectColumn];
/** input type for updating data in table "resource_notification_channels" */
export type ResourceNotificationChannelsSetInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_notification_channels" */
export type ResourceNotificationChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceNotificationChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceNotificationChannelsStreamCursorValueInput = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  should_send_recovery?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "resource_notification_channels" */
export const ResourceNotificationChannelsUpdateColumn = {
  /** column name */
  Disabled: 'disabled',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  ShouldSendRecovery: 'should_send_recovery',
  /** column name */
  Status: 'status'
} as const;

export type ResourceNotificationChannelsUpdateColumn = typeof ResourceNotificationChannelsUpdateColumn[keyof typeof ResourceNotificationChannelsUpdateColumn];
export type ResourceNotificationChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ResourceNotificationChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: ResourceNotificationChannelsBoolExp;
};

/** columns and relationships of "resource_tag_values" */
export type ResourceTagValues = {
  __typename?: 'resource_tag_values';
  resource_type?: Maybe<Scalars['String']>;
  tag_key?: Maybe<Scalars['String']>;
  tag_values?: Maybe<Scalars['json']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "resource_tag_values" */
export type ResourceTagValuesTagValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "resource_tag_values". All fields are combined with a logical 'AND'. */
export type ResourceTagValuesBoolExp = {
  _and?: InputMaybe<Array<ResourceTagValuesBoolExp>>;
  _not?: InputMaybe<ResourceTagValuesBoolExp>;
  _or?: InputMaybe<Array<ResourceTagValuesBoolExp>>;
  resource_type?: InputMaybe<StringComparisonExp>;
  tag_key?: InputMaybe<StringComparisonExp>;
  tag_values?: InputMaybe<JsonComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "resource_tag_values". */
export type ResourceTagValuesOrderBy = {
  resource_type?: InputMaybe<OrderBy>;
  tag_key?: InputMaybe<OrderBy>;
  tag_values?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "resource_tag_values" */
export const ResourceTagValuesSelectColumn = {
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  TagKey: 'tag_key',
  /** column name */
  TagValues: 'tag_values',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceTagValuesSelectColumn = typeof ResourceTagValuesSelectColumn[keyof typeof ResourceTagValuesSelectColumn];
/** Streaming cursor of the table "resource_tag_values" */
export type ResourceTagValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceTagValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceTagValuesStreamCursorValueInput = {
  resource_type?: InputMaybe<Scalars['String']>;
  tag_key?: InputMaybe<Scalars['String']>;
  tag_values?: InputMaybe<Scalars['json']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionType = {
  __typename?: 'resource_to_monitor_condition_type';
  condition_type: Scalars['String'];
  id: Scalars['uuid'];
  mute_until?: Maybe<Scalars['timestamptz']>;
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "resource_to_monitor_condition_type". All fields are combined with a logical 'AND'. */
export type ResourceToMonitorConditionTypeBoolExp = {
  _and?: InputMaybe<Array<ResourceToMonitorConditionTypeBoolExp>>;
  _not?: InputMaybe<ResourceToMonitorConditionTypeBoolExp>;
  _or?: InputMaybe<Array<ResourceToMonitorConditionTypeBoolExp>>;
  condition_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mute_until?: InputMaybe<TimestamptzComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "resource_to_monitor_condition_type" */
export const ResourceToMonitorConditionTypeConstraint = {
  /** unique or primary key constraint on columns "condition_type", "resource_id", "resource_type" */
  ResourceToMonitorConditionTypeConditionType: 'resource_to_monitor_condition_type_condition_type',
  /** unique or primary key constraint on columns "id" */
  ResourceToMonitorConditionTypePkey: 'resource_to_monitor_condition_type_pkey'
} as const;

export type ResourceToMonitorConditionTypeConstraint = typeof ResourceToMonitorConditionTypeConstraint[keyof typeof ResourceToMonitorConditionTypeConstraint];
/** input type for inserting data into table "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionTypeInsertInput = {
  condition_type?: InputMaybe<Scalars['String']>;
  mute_until?: InputMaybe<Scalars['timestamptz']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** response of any mutation on the table "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionTypeMutationResponse = {
  __typename?: 'resource_to_monitor_condition_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceToMonitorConditionType>;
};

/** on_conflict condition type for table "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionTypeOnConflict = {
  constraint: ResourceToMonitorConditionTypeConstraint;
  update_columns?: Array<ResourceToMonitorConditionTypeUpdateColumn>;
  where?: InputMaybe<ResourceToMonitorConditionTypeBoolExp>;
};

/** Ordering options when selecting data from "resource_to_monitor_condition_type". */
export type ResourceToMonitorConditionTypeOrderBy = {
  condition_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mute_until?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: resource_to_monitor_condition_type */
export type ResourceToMonitorConditionTypePkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "resource_to_monitor_condition_type" */
export const ResourceToMonitorConditionTypeSelectColumn = {
  /** column name */
  ConditionType: 'condition_type',
  /** column name */
  Id: 'id',
  /** column name */
  MuteUntil: 'mute_until',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceToMonitorConditionTypeSelectColumn = typeof ResourceToMonitorConditionTypeSelectColumn[keyof typeof ResourceToMonitorConditionTypeSelectColumn];
/** input type for updating data in table "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionTypeSetInput = {
  condition_type?: InputMaybe<Scalars['String']>;
  mute_until?: InputMaybe<Scalars['timestamptz']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_to_monitor_condition_type" */
export type ResourceToMonitorConditionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceToMonitorConditionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceToMonitorConditionTypeStreamCursorValueInput = {
  condition_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  mute_until?: InputMaybe<Scalars['timestamptz']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "resource_to_monitor_condition_type" */
export const ResourceToMonitorConditionTypeUpdateColumn = {
  /** column name */
  ConditionType: 'condition_type',
  /** column name */
  MuteUntil: 'mute_until',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type'
} as const;

export type ResourceToMonitorConditionTypeUpdateColumn = typeof ResourceToMonitorConditionTypeUpdateColumn[keyof typeof ResourceToMonitorConditionTypeUpdateColumn];
export type ResourceToMonitorConditionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ResourceToMonitorConditionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ResourceToMonitorConditionTypeBoolExp;
};

/** columns and relationships of "resource_views" */
export type ResourceViews = {
  __typename?: 'resource_views';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  private: Scalars['Boolean'];
  resource_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  view: Scalars['jsonb'];
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "resource_views" */
export type ResourceViewsViewArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ResourceViewsAppendInput = {
  view?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "resource_views". All fields are combined with a logical 'AND'. */
export type ResourceViewsBoolExp = {
  _and?: InputMaybe<Array<ResourceViewsBoolExp>>;
  _not?: InputMaybe<ResourceViewsBoolExp>;
  _or?: InputMaybe<Array<ResourceViewsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  private?: InputMaybe<BooleanComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  view?: InputMaybe<JsonbComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "resource_views" */
export const ResourceViewsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ResourceViewsPkey: 'resource_views_pkey'
} as const;

export type ResourceViewsConstraint = typeof ResourceViewsConstraint[keyof typeof ResourceViewsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ResourceViewsDeleteAtPathInput = {
  view?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ResourceViewsDeleteElemInput = {
  view?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ResourceViewsDeleteKeyInput = {
  view?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "resource_views" */
export type ResourceViewsInsertInput = {
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  resource_type?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "resource_views" */
export type ResourceViewsMutationResponse = {
  __typename?: 'resource_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ResourceViews>;
};

/** on_conflict condition type for table "resource_views" */
export type ResourceViewsOnConflict = {
  constraint: ResourceViewsConstraint;
  update_columns?: Array<ResourceViewsUpdateColumn>;
  where?: InputMaybe<ResourceViewsBoolExp>;
};

/** Ordering options when selecting data from "resource_views". */
export type ResourceViewsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  private?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  view?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: resource_views */
export type ResourceViewsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ResourceViewsPrependInput = {
  view?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "resource_views" */
export const ResourceViewsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Private: 'private',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  View: 'view',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ResourceViewsSelectColumn = typeof ResourceViewsSelectColumn[keyof typeof ResourceViewsSelectColumn];
/** input type for updating data in table "resource_views" */
export type ResourceViewsSetInput = {
  name?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  view?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "resource_views" */
export type ResourceViewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ResourceViewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ResourceViewsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  resource_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  view?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "resource_views" */
export const ResourceViewsUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  Private: 'private',
  /** column name */
  View: 'view'
} as const;

export type ResourceViewsUpdateColumn = typeof ResourceViewsUpdateColumn[keyof typeof ResourceViewsUpdateColumn];
export type ResourceViewsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ResourceViewsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ResourceViewsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ResourceViewsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ResourceViewsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ResourceViewsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ResourceViewsSetInput>;
  /** filter the rows which have to be updated */
  where: ResourceViewsBoolExp;
};

/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncs = {
  __typename?: 'retl_and_realtime_syncs';
  canary?: Maybe<Scalars['Boolean']>;
  config?: Maybe<Scalars['jsonb']>;
  config_metadata?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  destination_metadata?: Maybe<Scalars['JSONObject']>;
  draft?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  is_effectively_disabled?: Maybe<Scalars['Boolean']>;
  is_streaming?: Maybe<Scalars['Boolean']>;
  labels?: Maybe<Scalars['JSONObject']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** An object relationship */
  sync_template?: Maybe<SyncTemplates>;
  sync_template_id?: Maybe<Scalars['Int']>;
  sync_template_overrides?: Maybe<Scalars['jsonb']>;
  sync_type?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  transformed_config: Scalars['JSONObject'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsConfigMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsExternalSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalSegmentsOrderBy>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsMonitoringArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsSyncAlertsArgs = {
  distinct_on?: InputMaybe<Array<SyncAlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAlertsOrderBy>>;
  where?: InputMaybe<SyncAlertsBoolExp>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsSyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsSyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsSyncTemplateOverridesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsWarehouseHistoryConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsAggregate = {
  __typename?: 'retl_and_realtime_syncs_aggregate';
  aggregate?: Maybe<RetlAndRealtimeSyncsAggregateFields>;
  nodes: Array<RetlAndRealtimeSyncs>;
};

export type RetlAndRealtimeSyncsAggregateBoolExp = {
  bool_and?: InputMaybe<RetlAndRealtimeSyncsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RetlAndRealtimeSyncsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RetlAndRealtimeSyncsAggregateBoolExpCount>;
};

export type RetlAndRealtimeSyncsAggregateBoolExpBoolAnd = {
  arguments: RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RetlAndRealtimeSyncsAggregateBoolExpBoolOr = {
  arguments: RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RetlAndRealtimeSyncsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsAggregateFields = {
  __typename?: 'retl_and_realtime_syncs_aggregate_fields';
  avg?: Maybe<RetlAndRealtimeSyncsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RetlAndRealtimeSyncsMaxFields>;
  min?: Maybe<RetlAndRealtimeSyncsMinFields>;
  stddev?: Maybe<RetlAndRealtimeSyncsStddevFields>;
  stddev_pop?: Maybe<RetlAndRealtimeSyncsStddevPopFields>;
  stddev_samp?: Maybe<RetlAndRealtimeSyncsStddevSampFields>;
  sum?: Maybe<RetlAndRealtimeSyncsSumFields>;
  var_pop?: Maybe<RetlAndRealtimeSyncsVarPopFields>;
  var_samp?: Maybe<RetlAndRealtimeSyncsVarSampFields>;
  variance?: Maybe<RetlAndRealtimeSyncsVarianceFields>;
};


/** aggregate fields of "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsAggregateOrderBy = {
  avg?: InputMaybe<RetlAndRealtimeSyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RetlAndRealtimeSyncsMaxOrderBy>;
  min?: InputMaybe<RetlAndRealtimeSyncsMinOrderBy>;
  stddev?: InputMaybe<RetlAndRealtimeSyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<RetlAndRealtimeSyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RetlAndRealtimeSyncsStddevSampOrderBy>;
  sum?: InputMaybe<RetlAndRealtimeSyncsSumOrderBy>;
  var_pop?: InputMaybe<RetlAndRealtimeSyncsVarPopOrderBy>;
  var_samp?: InputMaybe<RetlAndRealtimeSyncsVarSampOrderBy>;
  variance?: InputMaybe<RetlAndRealtimeSyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type RetlAndRealtimeSyncsAvgFields = {
  __typename?: 'retl_and_realtime_syncs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "retl_and_realtime_syncs". All fields are combined with a logical 'AND'. */
export type RetlAndRealtimeSyncsBoolExp = {
  _and?: InputMaybe<Array<RetlAndRealtimeSyncsBoolExp>>;
  _not?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
  _or?: InputMaybe<Array<RetlAndRealtimeSyncsBoolExp>>;
  canary?: InputMaybe<BooleanComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  config_metadata?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsBoolExp>;
  draft?: InputMaybe<BooleanComparisonExp>;
  external_segments?: InputMaybe<ExternalSegmentsBoolExp>;
  health?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  is_effectively_disabled?: InputMaybe<BooleanComparisonExp>;
  is_streaming?: InputMaybe<BooleanComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_planner_type?: InputMaybe<StringComparisonExp>;
  monitoring?: InputMaybe<JsonbComparisonExp>;
  next_diff_mode_override?: InputMaybe<StringComparisonExp>;
  row_threshold_attempted?: InputMaybe<BigintComparisonExp>;
  row_threshold_total?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync_alerts?: InputMaybe<SyncAlertsBoolExp>;
  sync_requests?: InputMaybe<SyncRequestsBoolExp>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateBoolExp>;
  sync_template?: InputMaybe<SyncTemplatesBoolExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
  sync_template_overrides?: InputMaybe<JsonbComparisonExp>;
  sync_type?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  warehouse_history_config?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type RetlAndRealtimeSyncsMaxFields = {
  __typename?: 'retl_and_realtime_syncs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  sync_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  sync_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RetlAndRealtimeSyncsMinFields = {
  __typename?: 'retl_and_realtime_syncs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  sync_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  sync_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "retl_and_realtime_syncs". */
export type RetlAndRealtimeSyncsOrderBy = {
  canary?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  config_metadata?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  destination_instance_splits_aggregate?: InputMaybe<DestinationInstanceSplitsAggregateOrderBy>;
  draft?: InputMaybe<OrderBy>;
  external_segments_aggregate?: InputMaybe<ExternalSegmentsAggregateOrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_effectively_disabled?: InputMaybe<OrderBy>;
  is_streaming?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  monitoring?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_alerts_aggregate?: InputMaybe<SyncAlertsAggregateOrderBy>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateOrderBy>;
  sync_template?: InputMaybe<SyncTemplatesOrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  sync_template_overrides?: InputMaybe<OrderBy>;
  sync_type?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  warehouse_history_config?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "retl_and_realtime_syncs" */
export const RetlAndRealtimeSyncsSelectColumn = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Config: 'config',
  /** column name */
  ConfigMetadata: 'config_metadata',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Draft: 'draft',
  /** column name */
  Health: 'health',
  /** column name */
  Id: 'id',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunPlannerType: 'last_run_planner_type',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  NextDiffModeOverride: 'next_diff_mode_override',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  Status: 'status',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  SyncTemplateOverrides: 'sync_template_overrides',
  /** column name */
  SyncType: 'sync_type',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type RetlAndRealtimeSyncsSelectColumn = typeof RetlAndRealtimeSyncsSelectColumn[keyof typeof RetlAndRealtimeSyncsSelectColumn];
/** select "retl_and_realtime_syncs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "retl_and_realtime_syncs" */
export const RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Draft: 'draft',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolAndArgumentsColumns = typeof RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolAndArgumentsColumns];
/** select "retl_and_realtime_syncs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "retl_and_realtime_syncs" */
export const RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Draft: 'draft',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolOrArgumentsColumns = typeof RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof RetlAndRealtimeSyncsSelectColumnRetlAndRealtimeSyncsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type RetlAndRealtimeSyncsStddevFields = {
  __typename?: 'retl_and_realtime_syncs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RetlAndRealtimeSyncsStddevPopFields = {
  __typename?: 'retl_and_realtime_syncs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RetlAndRealtimeSyncsStddevSampFields = {
  __typename?: 'retl_and_realtime_syncs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RetlAndRealtimeSyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RetlAndRealtimeSyncsStreamCursorValueInput = {
  canary?: InputMaybe<Scalars['Boolean']>;
  config?: InputMaybe<Scalars['jsonb']>;
  config_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  health?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_effectively_disabled?: InputMaybe<Scalars['Boolean']>;
  is_streaming?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_planner_type?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  next_diff_mode_override?: InputMaybe<Scalars['String']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  sync_type?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RetlAndRealtimeSyncsSumFields = {
  __typename?: 'retl_and_realtime_syncs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type RetlAndRealtimeSyncsVarPopFields = {
  __typename?: 'retl_and_realtime_syncs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RetlAndRealtimeSyncsVarSampFields = {
  __typename?: 'retl_and_realtime_syncs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RetlAndRealtimeSyncsVarianceFields = {
  __typename?: 'retl_and_realtime_syncs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "retl_and_realtime_syncs" */
export type RetlAndRealtimeSyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "review_agent_entities" */
export type ReviewAgentEntities = {
  __typename?: 'review_agent_entities';
  agentic_settings_entity_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  review_agent?: Maybe<ReviewAgents>;
  review_agent_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "review_agent_entities" */
export type ReviewAgentEntitiesAggregate = {
  __typename?: 'review_agent_entities_aggregate';
  aggregate?: Maybe<ReviewAgentEntitiesAggregateFields>;
  nodes: Array<ReviewAgentEntities>;
};

export type ReviewAgentEntitiesAggregateBoolExp = {
  count?: InputMaybe<ReviewAgentEntitiesAggregateBoolExpCount>;
};

export type ReviewAgentEntitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReviewAgentEntitiesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "review_agent_entities" */
export type ReviewAgentEntitiesAggregateFields = {
  __typename?: 'review_agent_entities_aggregate_fields';
  avg?: Maybe<ReviewAgentEntitiesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewAgentEntitiesMaxFields>;
  min?: Maybe<ReviewAgentEntitiesMinFields>;
  stddev?: Maybe<ReviewAgentEntitiesStddevFields>;
  stddev_pop?: Maybe<ReviewAgentEntitiesStddevPopFields>;
  stddev_samp?: Maybe<ReviewAgentEntitiesStddevSampFields>;
  sum?: Maybe<ReviewAgentEntitiesSumFields>;
  var_pop?: Maybe<ReviewAgentEntitiesVarPopFields>;
  var_samp?: Maybe<ReviewAgentEntitiesVarSampFields>;
  variance?: Maybe<ReviewAgentEntitiesVarianceFields>;
};


/** aggregate fields of "review_agent_entities" */
export type ReviewAgentEntitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_agent_entities" */
export type ReviewAgentEntitiesAggregateOrderBy = {
  avg?: InputMaybe<ReviewAgentEntitiesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReviewAgentEntitiesMaxOrderBy>;
  min?: InputMaybe<ReviewAgentEntitiesMinOrderBy>;
  stddev?: InputMaybe<ReviewAgentEntitiesStddevOrderBy>;
  stddev_pop?: InputMaybe<ReviewAgentEntitiesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ReviewAgentEntitiesStddevSampOrderBy>;
  sum?: InputMaybe<ReviewAgentEntitiesSumOrderBy>;
  var_pop?: InputMaybe<ReviewAgentEntitiesVarPopOrderBy>;
  var_samp?: InputMaybe<ReviewAgentEntitiesVarSampOrderBy>;
  variance?: InputMaybe<ReviewAgentEntitiesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type ReviewAgentEntitiesAvgFields = {
  __typename?: 'review_agent_entities_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "review_agent_entities". All fields are combined with a logical 'AND'. */
export type ReviewAgentEntitiesBoolExp = {
  _and?: InputMaybe<Array<ReviewAgentEntitiesBoolExp>>;
  _not?: InputMaybe<ReviewAgentEntitiesBoolExp>;
  _or?: InputMaybe<Array<ReviewAgentEntitiesBoolExp>>;
  agentic_settings_entity_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  review_agent?: InputMaybe<ReviewAgentsBoolExp>;
  review_agent_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ReviewAgentEntitiesMaxFields = {
  __typename?: 'review_agent_entities_max_fields';
  agentic_settings_entity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  review_agent_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesMaxOrderBy = {
  agentic_settings_entity_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  review_agent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReviewAgentEntitiesMinFields = {
  __typename?: 'review_agent_entities_min_fields';
  agentic_settings_entity_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  review_agent_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesMinOrderBy = {
  agentic_settings_entity_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  review_agent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "review_agent_entities". */
export type ReviewAgentEntitiesOrderBy = {
  agentic_settings_entity_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  review_agent?: InputMaybe<ReviewAgentsOrderBy>;
  review_agent_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "review_agent_entities" */
export const ReviewAgentEntitiesSelectColumn = {
  /** column name */
  AgenticSettingsEntityId: 'agentic_settings_entity_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  ReviewAgentId: 'review_agent_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReviewAgentEntitiesSelectColumn = typeof ReviewAgentEntitiesSelectColumn[keyof typeof ReviewAgentEntitiesSelectColumn];
/** aggregate stddev on columns */
export type ReviewAgentEntitiesStddevFields = {
  __typename?: 'review_agent_entities_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ReviewAgentEntitiesStddevPopFields = {
  __typename?: 'review_agent_entities_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ReviewAgentEntitiesStddevSampFields = {
  __typename?: 'review_agent_entities_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "review_agent_entities" */
export type ReviewAgentEntitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReviewAgentEntitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewAgentEntitiesStreamCursorValueInput = {
  agentic_settings_entity_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  review_agent_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReviewAgentEntitiesSumFields = {
  __typename?: 'review_agent_entities_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type ReviewAgentEntitiesVarPopFields = {
  __typename?: 'review_agent_entities_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ReviewAgentEntitiesVarSampFields = {
  __typename?: 'review_agent_entities_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReviewAgentEntitiesVarianceFields = {
  __typename?: 'review_agent_entities_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "review_agent_entities" */
export type ReviewAgentEntitiesVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "review_agents" */
export type ReviewAgents = {
  __typename?: 'review_agents';
  /** An object relationship */
  brand_profile?: Maybe<BrandProfiles>;
  brand_profile_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  entities: Array<ReviewAgentEntities>;
  /** An aggregate relationship */
  entities_aggregate: ReviewAgentEntitiesAggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "review_agents" */
export type ReviewAgentsEntitiesArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


/** columns and relationships of "review_agents" */
export type ReviewAgentsEntitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};

/** aggregated selection of "review_agents" */
export type ReviewAgentsAggregate = {
  __typename?: 'review_agents_aggregate';
  aggregate?: Maybe<ReviewAgentsAggregateFields>;
  nodes: Array<ReviewAgents>;
};

/** aggregate fields of "review_agents" */
export type ReviewAgentsAggregateFields = {
  __typename?: 'review_agents_aggregate_fields';
  avg?: Maybe<ReviewAgentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ReviewAgentsMaxFields>;
  min?: Maybe<ReviewAgentsMinFields>;
  stddev?: Maybe<ReviewAgentsStddevFields>;
  stddev_pop?: Maybe<ReviewAgentsStddevPopFields>;
  stddev_samp?: Maybe<ReviewAgentsStddevSampFields>;
  sum?: Maybe<ReviewAgentsSumFields>;
  var_pop?: Maybe<ReviewAgentsVarPopFields>;
  var_samp?: Maybe<ReviewAgentsVarSampFields>;
  variance?: Maybe<ReviewAgentsVarianceFields>;
};


/** aggregate fields of "review_agents" */
export type ReviewAgentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReviewAgentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ReviewAgentsAvgFields = {
  __typename?: 'review_agents_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "review_agents". All fields are combined with a logical 'AND'. */
export type ReviewAgentsBoolExp = {
  _and?: InputMaybe<Array<ReviewAgentsBoolExp>>;
  _not?: InputMaybe<ReviewAgentsBoolExp>;
  _or?: InputMaybe<Array<ReviewAgentsBoolExp>>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  entities?: InputMaybe<ReviewAgentEntitiesBoolExp>;
  entities_aggregate?: InputMaybe<ReviewAgentEntitiesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type ReviewAgentsMaxFields = {
  __typename?: 'review_agents_max_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ReviewAgentsMinFields = {
  __typename?: 'review_agents_min_fields';
  brand_profile_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "review_agents". */
export type ReviewAgentsOrderBy = {
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  entities_aggregate?: InputMaybe<ReviewAgentEntitiesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "review_agents" */
export const ReviewAgentsSelectColumn = {
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type ReviewAgentsSelectColumn = typeof ReviewAgentsSelectColumn[keyof typeof ReviewAgentsSelectColumn];
/** aggregate stddev on columns */
export type ReviewAgentsStddevFields = {
  __typename?: 'review_agents_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ReviewAgentsStddevPopFields = {
  __typename?: 'review_agents_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ReviewAgentsStddevSampFields = {
  __typename?: 'review_agents_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "review_agents" */
export type ReviewAgentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ReviewAgentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReviewAgentsStreamCursorValueInput = {
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ReviewAgentsSumFields = {
  __typename?: 'review_agents_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type ReviewAgentsVarPopFields = {
  __typename?: 'review_agents_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ReviewAgentsVarSampFields = {
  __typename?: 'review_agents_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ReviewAgentsVarianceFields = {
  __typename?: 'review_agents_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sample_data_sources" */
export type SampleDataSources = {
  __typename?: 'sample_data_sources';
  metadata_slug: Scalars['String'];
  source_type: Scalars['String'];
  uuid: Scalars['uuid'];
};

/** Boolean expression to filter rows from the table "sample_data_sources". All fields are combined with a logical 'AND'. */
export type SampleDataSourcesBoolExp = {
  _and?: InputMaybe<Array<SampleDataSourcesBoolExp>>;
  _not?: InputMaybe<SampleDataSourcesBoolExp>;
  _or?: InputMaybe<Array<SampleDataSourcesBoolExp>>;
  metadata_slug?: InputMaybe<StringComparisonExp>;
  source_type?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** Ordering options when selecting data from "sample_data_sources". */
export type SampleDataSourcesOrderBy = {
  metadata_slug?: InputMaybe<OrderBy>;
  source_type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** select columns of table "sample_data_sources" */
export const SampleDataSourcesSelectColumn = {
  /** column name */
  MetadataSlug: 'metadata_slug',
  /** column name */
  SourceType: 'source_type',
  /** column name */
  Uuid: 'uuid'
} as const;

export type SampleDataSourcesSelectColumn = typeof SampleDataSourcesSelectColumn[keyof typeof SampleDataSourcesSelectColumn];
/** Streaming cursor of the table "sample_data_sources" */
export type SampleDataSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SampleDataSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleDataSourcesStreamCursorValueInput = {
  metadata_slug?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "sampled_segments" */
export type SampledSegments = {
  __typename?: 'sampled_segments';
  created_at: Scalars['timestamptz'];
  enabled: Scalars['Boolean'];
  id: Scalars['bigint'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  pending_manual_run?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  relationship?: Maybe<ModelRelationships>;
  relationship_id?: Maybe<Scalars['bigint']>;
  sample_rate: Scalars['numeric'];
  sampled_table_name?: Maybe<Scalars['String']>;
  schedule: Scalars['jsonb'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "sampled_segments" */
export type SampledSegmentsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sampled_segments" */
export type SampledSegmentsAggregate = {
  __typename?: 'sampled_segments_aggregate';
  aggregate?: Maybe<SampledSegmentsAggregateFields>;
  nodes: Array<SampledSegments>;
};

export type SampledSegmentsAggregateBoolExp = {
  bool_and?: InputMaybe<SampledSegmentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SampledSegmentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<SampledSegmentsAggregateBoolExpCount>;
};

export type SampledSegmentsAggregateBoolExpBoolAnd = {
  arguments: SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SampledSegmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SampledSegmentsAggregateBoolExpBoolOr = {
  arguments: SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SampledSegmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SampledSegmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SampledSegmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "sampled_segments" */
export type SampledSegmentsAggregateFields = {
  __typename?: 'sampled_segments_aggregate_fields';
  avg?: Maybe<SampledSegmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SampledSegmentsMaxFields>;
  min?: Maybe<SampledSegmentsMinFields>;
  stddev?: Maybe<SampledSegmentsStddevFields>;
  stddev_pop?: Maybe<SampledSegmentsStddevPopFields>;
  stddev_samp?: Maybe<SampledSegmentsStddevSampFields>;
  sum?: Maybe<SampledSegmentsSumFields>;
  var_pop?: Maybe<SampledSegmentsVarPopFields>;
  var_samp?: Maybe<SampledSegmentsVarSampFields>;
  variance?: Maybe<SampledSegmentsVarianceFields>;
};


/** aggregate fields of "sampled_segments" */
export type SampledSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sampled_segments" */
export type SampledSegmentsAggregateOrderBy = {
  avg?: InputMaybe<SampledSegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SampledSegmentsMaxOrderBy>;
  min?: InputMaybe<SampledSegmentsMinOrderBy>;
  stddev?: InputMaybe<SampledSegmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<SampledSegmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SampledSegmentsStddevSampOrderBy>;
  sum?: InputMaybe<SampledSegmentsSumOrderBy>;
  var_pop?: InputMaybe<SampledSegmentsVarPopOrderBy>;
  var_samp?: InputMaybe<SampledSegmentsVarSampOrderBy>;
  variance?: InputMaybe<SampledSegmentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SampledSegmentsAppendInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sampled_segments" */
export type SampledSegmentsArrRelInsertInput = {
  data: Array<SampledSegmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SampledSegmentsOnConflict>;
};

/** aggregate avg on columns */
export type SampledSegmentsAvgFields = {
  __typename?: 'sampled_segments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sampled_segments" */
export type SampledSegmentsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sampled_segments". All fields are combined with a logical 'AND'. */
export type SampledSegmentsBoolExp = {
  _and?: InputMaybe<Array<SampledSegmentsBoolExp>>;
  _not?: InputMaybe<SampledSegmentsBoolExp>;
  _or?: InputMaybe<Array<SampledSegmentsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  pending_manual_run?: InputMaybe<TimestamptzComparisonExp>;
  relationship?: InputMaybe<ModelRelationshipsBoolExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
  sample_rate?: InputMaybe<NumericComparisonExp>;
  sampled_table_name?: InputMaybe<StringComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "sampled_segments" */
export const SampledSegmentsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SampledSegmentsPkey: 'sampled_segments_pkey',
  /** unique or primary key constraint on columns "segment_id", "parent_model_id" */
  SampledSegmentsSegmentIdParentModelIdKey: 'sampled_segments_segment_id_parent_model_id_key'
} as const;

export type SampledSegmentsConstraint = typeof SampledSegmentsConstraint[keyof typeof SampledSegmentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SampledSegmentsDeleteAtPathInput = {
  schedule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SampledSegmentsDeleteElemInput = {
  schedule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SampledSegmentsDeleteKeyInput = {
  schedule?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sampled_segments" */
export type SampledSegmentsIncInput = {
  sample_rate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sampled_segments" */
export type SampledSegmentsInsertInput = {
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  pending_manual_run?: InputMaybe<Scalars['timestamptz']>;
  relationship?: InputMaybe<ModelRelationshipsObjRelInsertInput>;
  sample_rate?: InputMaybe<Scalars['numeric']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SampledSegmentsMaxFields = {
  __typename?: 'sampled_segments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  pending_manual_run?: Maybe<Scalars['timestamptz']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  sample_rate?: Maybe<Scalars['numeric']>;
  sampled_table_name?: Maybe<Scalars['String']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "sampled_segments" */
export type SampledSegmentsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  pending_manual_run?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  sampled_table_name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SampledSegmentsMinFields = {
  __typename?: 'sampled_segments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  pending_manual_run?: Maybe<Scalars['timestamptz']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  sample_rate?: Maybe<Scalars['numeric']>;
  sampled_table_name?: Maybe<Scalars['String']>;
  segment_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "sampled_segments" */
export type SampledSegmentsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  pending_manual_run?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  sampled_table_name?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sampled_segments" */
export type SampledSegmentsMutationResponse = {
  __typename?: 'sampled_segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SampledSegments>;
};

/** on_conflict condition type for table "sampled_segments" */
export type SampledSegmentsOnConflict = {
  constraint: SampledSegmentsConstraint;
  update_columns?: Array<SampledSegmentsUpdateColumn>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};

/** Ordering options when selecting data from "sampled_segments". */
export type SampledSegmentsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  pending_manual_run?: InputMaybe<OrderBy>;
  relationship?: InputMaybe<ModelRelationshipsOrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  sampled_table_name?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sampled_segments */
export type SampledSegmentsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SampledSegmentsPrependInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sampled_segments" */
export const SampledSegmentsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  PendingManualRun: 'pending_manual_run',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  SampleRate: 'sample_rate',
  /** column name */
  SampledTableName: 'sampled_table_name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type SampledSegmentsSelectColumn = typeof SampledSegmentsSelectColumn[keyof typeof SampledSegmentsSelectColumn];
/** select "sampled_segments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sampled_segments" */
export const SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolAndArgumentsColumns = typeof SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolAndArgumentsColumns];
/** select "sampled_segments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sampled_segments" */
export const SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Enabled: 'enabled'
} as const;

export type SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolOrArgumentsColumns = typeof SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof SampledSegmentsSelectColumnSampledSegmentsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "sampled_segments" */
export type SampledSegmentsSetInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  pending_manual_run?: InputMaybe<Scalars['timestamptz']>;
  sample_rate?: InputMaybe<Scalars['numeric']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SampledSegmentsStddevFields = {
  __typename?: 'sampled_segments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sampled_segments" */
export type SampledSegmentsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SampledSegmentsStddevPopFields = {
  __typename?: 'sampled_segments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sampled_segments" */
export type SampledSegmentsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SampledSegmentsStddevSampFields = {
  __typename?: 'sampled_segments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sampled_segments" */
export type SampledSegmentsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sampled_segments" */
export type SampledSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SampledSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SampledSegmentsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  pending_manual_run?: InputMaybe<Scalars['timestamptz']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  sample_rate?: InputMaybe<Scalars['numeric']>;
  sampled_table_name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SampledSegmentsSumFields = {
  __typename?: 'sampled_segments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  sample_rate?: Maybe<Scalars['numeric']>;
  segment_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sampled_segments" */
export type SampledSegmentsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** update columns of table "sampled_segments" */
export const SampledSegmentsUpdateColumn = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  PendingManualRun: 'pending_manual_run',
  /** column name */
  SampleRate: 'sample_rate',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type SampledSegmentsUpdateColumn = typeof SampledSegmentsUpdateColumn[keyof typeof SampledSegmentsUpdateColumn];
export type SampledSegmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SampledSegmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SampledSegmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SampledSegmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SampledSegmentsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SampledSegmentsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SampledSegmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SampledSegmentsSetInput>;
  /** filter the rows which have to be updated */
  where: SampledSegmentsBoolExp;
};

/** aggregate var_pop on columns */
export type SampledSegmentsVarPopFields = {
  __typename?: 'sampled_segments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sampled_segments" */
export type SampledSegmentsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SampledSegmentsVarSampFields = {
  __typename?: 'sampled_segments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sampled_segments" */
export type SampledSegmentsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SampledSegmentsVarianceFields = {
  __typename?: 'sampled_segments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  sample_rate?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sampled_segments" */
export type SampledSegmentsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  sample_rate?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsCharts = {
  __typename?: 'saved_analytics_charts';
  /** An object relationship */
  analytics_report?: Maybe<AnalyticsReports>;
  archived_at?: Maybe<Scalars['timestamptz']>;
  chart_type: Scalars['String'];
  cohort_filter?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  cohorts: Array<SavedAnalyticsChartsCohorts>;
  /** An aggregate relationship */
  cohorts_aggregate: SavedAnalyticsChartsCohortsAggregate;
  conversion_window?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  cumulative?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  frequency: Scalars['String'];
  /** An array relationship */
  funnel_stages: Array<SavedAnalyticsChartsFunnelStages>;
  /** An aggregate relationship */
  funnel_stages_aggregate: SavedAnalyticsChartsFunnelStagesAggregate;
  /** An array relationship */
  goals: Array<SavedAnalyticsChartsGoals>;
  /** An aggregate relationship */
  goals_aggregate: SavedAnalyticsChartsGoalsAggregate;
  group_by?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  lookback_window: Scalars['jsonb'];
  measurement_window?: Maybe<Scalars['jsonb']>;
  measuring_id?: Maybe<Scalars['String']>;
  measuring_mode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  normalization?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsCohortFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsCohortsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsCohortsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsConversionWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsFunnelStagesArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsFunnelStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsGroupByArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsLookbackWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_analytics_charts" */
export type SavedAnalyticsChartsMeasurementWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "saved_analytics_charts" */
export type SavedAnalyticsChartsAggregate = {
  __typename?: 'saved_analytics_charts_aggregate';
  aggregate?: Maybe<SavedAnalyticsChartsAggregateFields>;
  nodes: Array<SavedAnalyticsCharts>;
};

/** aggregate fields of "saved_analytics_charts" */
export type SavedAnalyticsChartsAggregateFields = {
  __typename?: 'saved_analytics_charts_aggregate_fields';
  avg?: Maybe<SavedAnalyticsChartsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedAnalyticsChartsMaxFields>;
  min?: Maybe<SavedAnalyticsChartsMinFields>;
  stddev?: Maybe<SavedAnalyticsChartsStddevFields>;
  stddev_pop?: Maybe<SavedAnalyticsChartsStddevPopFields>;
  stddev_samp?: Maybe<SavedAnalyticsChartsStddevSampFields>;
  sum?: Maybe<SavedAnalyticsChartsSumFields>;
  var_pop?: Maybe<SavedAnalyticsChartsVarPopFields>;
  var_samp?: Maybe<SavedAnalyticsChartsVarSampFields>;
  variance?: Maybe<SavedAnalyticsChartsVarianceFields>;
};


/** aggregate fields of "saved_analytics_charts" */
export type SavedAnalyticsChartsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedAnalyticsChartsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsAppendInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  conversion_window?: InputMaybe<Scalars['jsonb']>;
  group_by?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SavedAnalyticsChartsAvgFields = {
  __typename?: 'saved_analytics_charts_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "saved_analytics_charts". All fields are combined with a logical 'AND'. */
export type SavedAnalyticsChartsBoolExp = {
  _and?: InputMaybe<Array<SavedAnalyticsChartsBoolExp>>;
  _not?: InputMaybe<SavedAnalyticsChartsBoolExp>;
  _or?: InputMaybe<Array<SavedAnalyticsChartsBoolExp>>;
  analytics_report?: InputMaybe<AnalyticsReportsBoolExp>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  chart_type?: InputMaybe<StringComparisonExp>;
  cohort_filter?: InputMaybe<JsonbComparisonExp>;
  cohorts?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
  cohorts_aggregate?: InputMaybe<SavedAnalyticsChartsCohortsAggregateBoolExp>;
  conversion_window?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  cumulative?: InputMaybe<BooleanComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  frequency?: InputMaybe<StringComparisonExp>;
  funnel_stages?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
  funnel_stages_aggregate?: InputMaybe<SavedAnalyticsChartsFunnelStagesAggregateBoolExp>;
  goals?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
  goals_aggregate?: InputMaybe<SavedAnalyticsChartsGoalsAggregateBoolExp>;
  group_by?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lookback_window?: InputMaybe<JsonbComparisonExp>;
  measurement_window?: InputMaybe<JsonbComparisonExp>;
  measuring_id?: InputMaybe<StringComparisonExp>;
  measuring_mode?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  normalization?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Bridge table between saved_analytics_charts and cohorts */
export type SavedAnalyticsChartsCohorts = {
  __typename?: 'saved_analytics_charts_cohorts';
  /** An object relationship */
  cohort?: Maybe<Segments>;
  cohort_definition?: Maybe<Scalars['jsonb']>;
  cohort_id?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  /** An object relationship */
  saved_analytics_chart?: Maybe<SavedAnalyticsCharts>;
  saved_chart_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** Bridge table between saved_analytics_charts and cohorts */
export type SavedAnalyticsChartsCohortsCohortDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsAggregate = {
  __typename?: 'saved_analytics_charts_cohorts_aggregate';
  aggregate?: Maybe<SavedAnalyticsChartsCohortsAggregateFields>;
  nodes: Array<SavedAnalyticsChartsCohorts>;
};

export type SavedAnalyticsChartsCohortsAggregateBoolExp = {
  count?: InputMaybe<SavedAnalyticsChartsCohortsAggregateBoolExpCount>;
};

export type SavedAnalyticsChartsCohortsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsAggregateFields = {
  __typename?: 'saved_analytics_charts_cohorts_aggregate_fields';
  avg?: Maybe<SavedAnalyticsChartsCohortsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedAnalyticsChartsCohortsMaxFields>;
  min?: Maybe<SavedAnalyticsChartsCohortsMinFields>;
  stddev?: Maybe<SavedAnalyticsChartsCohortsStddevFields>;
  stddev_pop?: Maybe<SavedAnalyticsChartsCohortsStddevPopFields>;
  stddev_samp?: Maybe<SavedAnalyticsChartsCohortsStddevSampFields>;
  sum?: Maybe<SavedAnalyticsChartsCohortsSumFields>;
  var_pop?: Maybe<SavedAnalyticsChartsCohortsVarPopFields>;
  var_samp?: Maybe<SavedAnalyticsChartsCohortsVarSampFields>;
  variance?: Maybe<SavedAnalyticsChartsCohortsVarianceFields>;
};


/** aggregate fields of "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsAggregateOrderBy = {
  avg?: InputMaybe<SavedAnalyticsChartsCohortsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SavedAnalyticsChartsCohortsMaxOrderBy>;
  min?: InputMaybe<SavedAnalyticsChartsCohortsMinOrderBy>;
  stddev?: InputMaybe<SavedAnalyticsChartsCohortsStddevOrderBy>;
  stddev_pop?: InputMaybe<SavedAnalyticsChartsCohortsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SavedAnalyticsChartsCohortsStddevSampOrderBy>;
  sum?: InputMaybe<SavedAnalyticsChartsCohortsSumOrderBy>;
  var_pop?: InputMaybe<SavedAnalyticsChartsCohortsVarPopOrderBy>;
  var_samp?: InputMaybe<SavedAnalyticsChartsCohortsVarSampOrderBy>;
  variance?: InputMaybe<SavedAnalyticsChartsCohortsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsCohortsAppendInput = {
  cohort_definition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsArrRelInsertInput = {
  data: Array<SavedAnalyticsChartsCohortsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedAnalyticsChartsCohortsOnConflict>;
};

/** aggregate avg on columns */
export type SavedAnalyticsChartsCohortsAvgFields = {
  __typename?: 'saved_analytics_charts_cohorts_avg_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsAvgOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "saved_analytics_charts_cohorts". All fields are combined with a logical 'AND'. */
export type SavedAnalyticsChartsCohortsBoolExp = {
  _and?: InputMaybe<Array<SavedAnalyticsChartsCohortsBoolExp>>;
  _not?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
  _or?: InputMaybe<Array<SavedAnalyticsChartsCohortsBoolExp>>;
  cohort?: InputMaybe<SegmentsBoolExp>;
  cohort_definition?: InputMaybe<JsonbComparisonExp>;
  cohort_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsBoolExp>;
  saved_chart_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_analytics_charts_cohorts" */
export const SavedAnalyticsChartsCohortsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SavedAnalyticsChartsCohortsPkey: 'saved_analytics_charts_cohorts_pkey'
} as const;

export type SavedAnalyticsChartsCohortsConstraint = typeof SavedAnalyticsChartsCohortsConstraint[keyof typeof SavedAnalyticsChartsCohortsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedAnalyticsChartsCohortsDeleteAtPathInput = {
  cohort_definition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedAnalyticsChartsCohortsDeleteElemInput = {
  cohort_definition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedAnalyticsChartsCohortsDeleteKeyInput = {
  cohort_definition?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsIncInput = {
  cohort_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsInsertInput = {
  cohort?: InputMaybe<SegmentsObjRelInsertInput>;
  cohort_definition?: InputMaybe<Scalars['jsonb']>;
  cohort_id?: InputMaybe<Scalars['bigint']>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsObjRelInsertInput>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SavedAnalyticsChartsCohortsMaxFields = {
  __typename?: 'saved_analytics_charts_cohorts_max_fields';
  cohort_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsMaxOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SavedAnalyticsChartsCohortsMinFields = {
  __typename?: 'saved_analytics_charts_cohorts_min_fields';
  cohort_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsMinOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsMutationResponse = {
  __typename?: 'saved_analytics_charts_cohorts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedAnalyticsChartsCohorts>;
};

/** on_conflict condition type for table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsOnConflict = {
  constraint: SavedAnalyticsChartsCohortsConstraint;
  update_columns?: Array<SavedAnalyticsChartsCohortsUpdateColumn>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};

/** Ordering options when selecting data from "saved_analytics_charts_cohorts". */
export type SavedAnalyticsChartsCohortsOrderBy = {
  cohort?: InputMaybe<SegmentsOrderBy>;
  cohort_definition?: InputMaybe<OrderBy>;
  cohort_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsOrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_analytics_charts_cohorts */
export type SavedAnalyticsChartsCohortsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsCohortsPrependInput = {
  cohort_definition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_analytics_charts_cohorts" */
export const SavedAnalyticsChartsCohortsSelectColumn = {
  /** column name */
  CohortDefinition: 'cohort_definition',
  /** column name */
  CohortId: 'cohort_id',
  /** column name */
  Id: 'id',
  /** column name */
  SavedChartId: 'saved_chart_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedAnalyticsChartsCohortsSelectColumn = typeof SavedAnalyticsChartsCohortsSelectColumn[keyof typeof SavedAnalyticsChartsCohortsSelectColumn];
/** input type for updating data in table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsSetInput = {
  cohort_definition?: InputMaybe<Scalars['jsonb']>;
  cohort_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SavedAnalyticsChartsCohortsStddevFields = {
  __typename?: 'saved_analytics_charts_cohorts_stddev_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsStddevOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SavedAnalyticsChartsCohortsStddevPopFields = {
  __typename?: 'saved_analytics_charts_cohorts_stddev_pop_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsStddevPopOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SavedAnalyticsChartsCohortsStddevSampFields = {
  __typename?: 'saved_analytics_charts_cohorts_stddev_samp_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsStddevSampOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedAnalyticsChartsCohortsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedAnalyticsChartsCohortsStreamCursorValueInput = {
  cohort_definition?: InputMaybe<Scalars['jsonb']>;
  cohort_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedAnalyticsChartsCohortsSumFields = {
  __typename?: 'saved_analytics_charts_cohorts_sum_fields';
  cohort_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsSumOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "saved_analytics_charts_cohorts" */
export const SavedAnalyticsChartsCohortsUpdateColumn = {
  /** column name */
  CohortDefinition: 'cohort_definition',
  /** column name */
  CohortId: 'cohort_id'
} as const;

export type SavedAnalyticsChartsCohortsUpdateColumn = typeof SavedAnalyticsChartsCohortsUpdateColumn[keyof typeof SavedAnalyticsChartsCohortsUpdateColumn];
export type SavedAnalyticsChartsCohortsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedAnalyticsChartsCohortsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsCohortsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedAnalyticsChartsCohortsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedAnalyticsChartsCohortsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SavedAnalyticsChartsCohortsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedAnalyticsChartsCohortsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedAnalyticsChartsCohortsSetInput>;
  /** filter the rows which have to be updated */
  where: SavedAnalyticsChartsCohortsBoolExp;
};

/** aggregate var_pop on columns */
export type SavedAnalyticsChartsCohortsVarPopFields = {
  __typename?: 'saved_analytics_charts_cohorts_var_pop_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsVarPopOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SavedAnalyticsChartsCohortsVarSampFields = {
  __typename?: 'saved_analytics_charts_cohorts_var_samp_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsVarSampOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SavedAnalyticsChartsCohortsVarianceFields = {
  __typename?: 'saved_analytics_charts_cohorts_variance_fields';
  cohort_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "saved_analytics_charts_cohorts" */
export type SavedAnalyticsChartsCohortsVarianceOrderBy = {
  cohort_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "saved_analytics_charts" */
export const SavedAnalyticsChartsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SavedAnalyticsChartsIdWorkspaceIdKey: 'saved_analytics_charts_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  SavedAnalyticsChartsPkey: 'saved_analytics_charts_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SavedAnalyticsChartsWorkspaceIdIdKey: 'saved_analytics_charts_workspace_id_id_key'
} as const;

export type SavedAnalyticsChartsConstraint = typeof SavedAnalyticsChartsConstraint[keyof typeof SavedAnalyticsChartsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedAnalyticsChartsDeleteAtPathInput = {
  cohort_filter?: InputMaybe<Array<Scalars['String']>>;
  conversion_window?: InputMaybe<Array<Scalars['String']>>;
  group_by?: InputMaybe<Array<Scalars['String']>>;
  lookback_window?: InputMaybe<Array<Scalars['String']>>;
  measurement_window?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedAnalyticsChartsDeleteElemInput = {
  cohort_filter?: InputMaybe<Scalars['Int']>;
  conversion_window?: InputMaybe<Scalars['Int']>;
  group_by?: InputMaybe<Scalars['Int']>;
  lookback_window?: InputMaybe<Scalars['Int']>;
  measurement_window?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedAnalyticsChartsDeleteKeyInput = {
  cohort_filter?: InputMaybe<Scalars['String']>;
  conversion_window?: InputMaybe<Scalars['String']>;
  group_by?: InputMaybe<Scalars['String']>;
  lookback_window?: InputMaybe<Scalars['String']>;
  measurement_window?: InputMaybe<Scalars['String']>;
};

/** Bridge table between saved_analytics_charts and segments */
export type SavedAnalyticsChartsFunnelStages = {
  __typename?: 'saved_analytics_charts_funnel_stages';
  /** An object relationship */
  event_model?: Maybe<Segments>;
  event_model_id?: Maybe<Scalars['bigint']>;
  funnel_stage_definition?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  relationship_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  saved_analytics_chart?: Maybe<SavedAnalyticsCharts>;
  saved_chart_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** Bridge table between saved_analytics_charts and segments */
export type SavedAnalyticsChartsFunnelStagesFunnelStageDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesAggregate = {
  __typename?: 'saved_analytics_charts_funnel_stages_aggregate';
  aggregate?: Maybe<SavedAnalyticsChartsFunnelStagesAggregateFields>;
  nodes: Array<SavedAnalyticsChartsFunnelStages>;
};

export type SavedAnalyticsChartsFunnelStagesAggregateBoolExp = {
  count?: InputMaybe<SavedAnalyticsChartsFunnelStagesAggregateBoolExpCount>;
};

export type SavedAnalyticsChartsFunnelStagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesAggregateFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_aggregate_fields';
  avg?: Maybe<SavedAnalyticsChartsFunnelStagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedAnalyticsChartsFunnelStagesMaxFields>;
  min?: Maybe<SavedAnalyticsChartsFunnelStagesMinFields>;
  stddev?: Maybe<SavedAnalyticsChartsFunnelStagesStddevFields>;
  stddev_pop?: Maybe<SavedAnalyticsChartsFunnelStagesStddevPopFields>;
  stddev_samp?: Maybe<SavedAnalyticsChartsFunnelStagesStddevSampFields>;
  sum?: Maybe<SavedAnalyticsChartsFunnelStagesSumFields>;
  var_pop?: Maybe<SavedAnalyticsChartsFunnelStagesVarPopFields>;
  var_samp?: Maybe<SavedAnalyticsChartsFunnelStagesVarSampFields>;
  variance?: Maybe<SavedAnalyticsChartsFunnelStagesVarianceFields>;
};


/** aggregate fields of "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesAggregateOrderBy = {
  avg?: InputMaybe<SavedAnalyticsChartsFunnelStagesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SavedAnalyticsChartsFunnelStagesMaxOrderBy>;
  min?: InputMaybe<SavedAnalyticsChartsFunnelStagesMinOrderBy>;
  stddev?: InputMaybe<SavedAnalyticsChartsFunnelStagesStddevOrderBy>;
  stddev_pop?: InputMaybe<SavedAnalyticsChartsFunnelStagesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SavedAnalyticsChartsFunnelStagesStddevSampOrderBy>;
  sum?: InputMaybe<SavedAnalyticsChartsFunnelStagesSumOrderBy>;
  var_pop?: InputMaybe<SavedAnalyticsChartsFunnelStagesVarPopOrderBy>;
  var_samp?: InputMaybe<SavedAnalyticsChartsFunnelStagesVarSampOrderBy>;
  variance?: InputMaybe<SavedAnalyticsChartsFunnelStagesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsFunnelStagesAppendInput = {
  funnel_stage_definition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesArrRelInsertInput = {
  data: Array<SavedAnalyticsChartsFunnelStagesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedAnalyticsChartsFunnelStagesOnConflict>;
};

/** aggregate avg on columns */
export type SavedAnalyticsChartsFunnelStagesAvgFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_avg_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesAvgOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "saved_analytics_charts_funnel_stages". All fields are combined with a logical 'AND'. */
export type SavedAnalyticsChartsFunnelStagesBoolExp = {
  _and?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesBoolExp>>;
  _not?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
  _or?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesBoolExp>>;
  event_model?: InputMaybe<SegmentsBoolExp>;
  event_model_id?: InputMaybe<BigintComparisonExp>;
  funnel_stage_definition?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsBoolExp>;
  saved_chart_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_analytics_charts_funnel_stages" */
export const SavedAnalyticsChartsFunnelStagesConstraint = {
  /** unique or primary key constraint on columns "id" */
  SavedAnalyticsChartsFunnelStagesPkey: 'saved_analytics_charts_funnel_stages_pkey'
} as const;

export type SavedAnalyticsChartsFunnelStagesConstraint = typeof SavedAnalyticsChartsFunnelStagesConstraint[keyof typeof SavedAnalyticsChartsFunnelStagesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedAnalyticsChartsFunnelStagesDeleteAtPathInput = {
  funnel_stage_definition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedAnalyticsChartsFunnelStagesDeleteElemInput = {
  funnel_stage_definition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedAnalyticsChartsFunnelStagesDeleteKeyInput = {
  funnel_stage_definition?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesIncInput = {
  event_model_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesInsertInput = {
  event_model?: InputMaybe<SegmentsObjRelInsertInput>;
  event_model_id?: InputMaybe<Scalars['bigint']>;
  funnel_stage_definition?: InputMaybe<Scalars['jsonb']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsObjRelInsertInput>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SavedAnalyticsChartsFunnelStagesMaxFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_max_fields';
  event_model_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesMaxOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SavedAnalyticsChartsFunnelStagesMinFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_min_fields';
  event_model_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesMinOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesMutationResponse = {
  __typename?: 'saved_analytics_charts_funnel_stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedAnalyticsChartsFunnelStages>;
};

/** on_conflict condition type for table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesOnConflict = {
  constraint: SavedAnalyticsChartsFunnelStagesConstraint;
  update_columns?: Array<SavedAnalyticsChartsFunnelStagesUpdateColumn>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};

/** Ordering options when selecting data from "saved_analytics_charts_funnel_stages". */
export type SavedAnalyticsChartsFunnelStagesOrderBy = {
  event_model?: InputMaybe<SegmentsOrderBy>;
  event_model_id?: InputMaybe<OrderBy>;
  funnel_stage_definition?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsOrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_analytics_charts_funnel_stages */
export type SavedAnalyticsChartsFunnelStagesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsFunnelStagesPrependInput = {
  funnel_stage_definition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_analytics_charts_funnel_stages" */
export const SavedAnalyticsChartsFunnelStagesSelectColumn = {
  /** column name */
  EventModelId: 'event_model_id',
  /** column name */
  FunnelStageDefinition: 'funnel_stage_definition',
  /** column name */
  Id: 'id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  SavedChartId: 'saved_chart_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedAnalyticsChartsFunnelStagesSelectColumn = typeof SavedAnalyticsChartsFunnelStagesSelectColumn[keyof typeof SavedAnalyticsChartsFunnelStagesSelectColumn];
/** input type for updating data in table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesSetInput = {
  event_model_id?: InputMaybe<Scalars['bigint']>;
  funnel_stage_definition?: InputMaybe<Scalars['jsonb']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SavedAnalyticsChartsFunnelStagesStddevFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_stddev_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesStddevOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SavedAnalyticsChartsFunnelStagesStddevPopFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_stddev_pop_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesStddevPopOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SavedAnalyticsChartsFunnelStagesStddevSampFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_stddev_samp_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesStddevSampOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedAnalyticsChartsFunnelStagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedAnalyticsChartsFunnelStagesStreamCursorValueInput = {
  event_model_id?: InputMaybe<Scalars['bigint']>;
  funnel_stage_definition?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedAnalyticsChartsFunnelStagesSumFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_sum_fields';
  event_model_id?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesSumOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "saved_analytics_charts_funnel_stages" */
export const SavedAnalyticsChartsFunnelStagesUpdateColumn = {
  /** column name */
  EventModelId: 'event_model_id',
  /** column name */
  FunnelStageDefinition: 'funnel_stage_definition',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type SavedAnalyticsChartsFunnelStagesUpdateColumn = typeof SavedAnalyticsChartsFunnelStagesUpdateColumn[keyof typeof SavedAnalyticsChartsFunnelStagesUpdateColumn];
export type SavedAnalyticsChartsFunnelStagesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedAnalyticsChartsFunnelStagesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedAnalyticsChartsFunnelStagesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SavedAnalyticsChartsFunnelStagesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedAnalyticsChartsFunnelStagesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedAnalyticsChartsFunnelStagesSetInput>;
  /** filter the rows which have to be updated */
  where: SavedAnalyticsChartsFunnelStagesBoolExp;
};

/** aggregate var_pop on columns */
export type SavedAnalyticsChartsFunnelStagesVarPopFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_var_pop_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesVarPopOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SavedAnalyticsChartsFunnelStagesVarSampFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_var_samp_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesVarSampOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SavedAnalyticsChartsFunnelStagesVarianceFields = {
  __typename?: 'saved_analytics_charts_funnel_stages_variance_fields';
  event_model_id?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "saved_analytics_charts_funnel_stages" */
export type SavedAnalyticsChartsFunnelStagesVarianceOrderBy = {
  event_model_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Bridge table between saved_analytics_charts and goals */
export type SavedAnalyticsChartsGoals = {
  __typename?: 'saved_analytics_charts_goals';
  /** An object relationship */
  goal?: Maybe<Goals>;
  goal_definition?: Maybe<Scalars['jsonb']>;
  goal_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  saved_analytics_chart?: Maybe<SavedAnalyticsCharts>;
  saved_chart_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


/** Bridge table between saved_analytics_charts and goals */
export type SavedAnalyticsChartsGoalsGoalDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsAggregate = {
  __typename?: 'saved_analytics_charts_goals_aggregate';
  aggregate?: Maybe<SavedAnalyticsChartsGoalsAggregateFields>;
  nodes: Array<SavedAnalyticsChartsGoals>;
};

export type SavedAnalyticsChartsGoalsAggregateBoolExp = {
  count?: InputMaybe<SavedAnalyticsChartsGoalsAggregateBoolExpCount>;
};

export type SavedAnalyticsChartsGoalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsAggregateFields = {
  __typename?: 'saved_analytics_charts_goals_aggregate_fields';
  avg?: Maybe<SavedAnalyticsChartsGoalsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedAnalyticsChartsGoalsMaxFields>;
  min?: Maybe<SavedAnalyticsChartsGoalsMinFields>;
  stddev?: Maybe<SavedAnalyticsChartsGoalsStddevFields>;
  stddev_pop?: Maybe<SavedAnalyticsChartsGoalsStddevPopFields>;
  stddev_samp?: Maybe<SavedAnalyticsChartsGoalsStddevSampFields>;
  sum?: Maybe<SavedAnalyticsChartsGoalsSumFields>;
  var_pop?: Maybe<SavedAnalyticsChartsGoalsVarPopFields>;
  var_samp?: Maybe<SavedAnalyticsChartsGoalsVarSampFields>;
  variance?: Maybe<SavedAnalyticsChartsGoalsVarianceFields>;
};


/** aggregate fields of "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsAggregateOrderBy = {
  avg?: InputMaybe<SavedAnalyticsChartsGoalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SavedAnalyticsChartsGoalsMaxOrderBy>;
  min?: InputMaybe<SavedAnalyticsChartsGoalsMinOrderBy>;
  stddev?: InputMaybe<SavedAnalyticsChartsGoalsStddevOrderBy>;
  stddev_pop?: InputMaybe<SavedAnalyticsChartsGoalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SavedAnalyticsChartsGoalsStddevSampOrderBy>;
  sum?: InputMaybe<SavedAnalyticsChartsGoalsSumOrderBy>;
  var_pop?: InputMaybe<SavedAnalyticsChartsGoalsVarPopOrderBy>;
  var_samp?: InputMaybe<SavedAnalyticsChartsGoalsVarSampOrderBy>;
  variance?: InputMaybe<SavedAnalyticsChartsGoalsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsGoalsAppendInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsArrRelInsertInput = {
  data: Array<SavedAnalyticsChartsGoalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedAnalyticsChartsGoalsOnConflict>;
};

/** aggregate avg on columns */
export type SavedAnalyticsChartsGoalsAvgFields = {
  __typename?: 'saved_analytics_charts_goals_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "saved_analytics_charts_goals". All fields are combined with a logical 'AND'. */
export type SavedAnalyticsChartsGoalsBoolExp = {
  _and?: InputMaybe<Array<SavedAnalyticsChartsGoalsBoolExp>>;
  _not?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
  _or?: InputMaybe<Array<SavedAnalyticsChartsGoalsBoolExp>>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_definition?: InputMaybe<JsonbComparisonExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsBoolExp>;
  saved_chart_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_analytics_charts_goals" */
export const SavedAnalyticsChartsGoalsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SavedAnalyticsChartsGoalsPkey: 'saved_analytics_charts_goals_pkey'
} as const;

export type SavedAnalyticsChartsGoalsConstraint = typeof SavedAnalyticsChartsGoalsConstraint[keyof typeof SavedAnalyticsChartsGoalsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedAnalyticsChartsGoalsDeleteAtPathInput = {
  goal_definition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedAnalyticsChartsGoalsDeleteElemInput = {
  goal_definition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedAnalyticsChartsGoalsDeleteKeyInput = {
  goal_definition?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsInsertInput = {
  goal?: InputMaybe<GoalsObjRelInsertInput>;
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsObjRelInsertInput>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SavedAnalyticsChartsGoalsMaxFields = {
  __typename?: 'saved_analytics_charts_goals_max_fields';
  goal_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsMaxOrderBy = {
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SavedAnalyticsChartsGoalsMinFields = {
  __typename?: 'saved_analytics_charts_goals_min_fields';
  goal_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_chart_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsMinOrderBy = {
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsMutationResponse = {
  __typename?: 'saved_analytics_charts_goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedAnalyticsChartsGoals>;
};

/** on_conflict condition type for table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsOnConflict = {
  constraint: SavedAnalyticsChartsGoalsConstraint;
  update_columns?: Array<SavedAnalyticsChartsGoalsUpdateColumn>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};

/** Ordering options when selecting data from "saved_analytics_charts_goals". */
export type SavedAnalyticsChartsGoalsOrderBy = {
  goal?: InputMaybe<GoalsOrderBy>;
  goal_definition?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_analytics_chart?: InputMaybe<SavedAnalyticsChartsOrderBy>;
  saved_chart_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_analytics_charts_goals */
export type SavedAnalyticsChartsGoalsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsGoalsPrependInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_analytics_charts_goals" */
export const SavedAnalyticsChartsGoalsSelectColumn = {
  /** column name */
  GoalDefinition: 'goal_definition',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  Id: 'id',
  /** column name */
  SavedChartId: 'saved_chart_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedAnalyticsChartsGoalsSelectColumn = typeof SavedAnalyticsChartsGoalsSelectColumn[keyof typeof SavedAnalyticsChartsGoalsSelectColumn];
/** input type for updating data in table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsSetInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type SavedAnalyticsChartsGoalsStddevFields = {
  __typename?: 'saved_analytics_charts_goals_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SavedAnalyticsChartsGoalsStddevPopFields = {
  __typename?: 'saved_analytics_charts_goals_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SavedAnalyticsChartsGoalsStddevSampFields = {
  __typename?: 'saved_analytics_charts_goals_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedAnalyticsChartsGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedAnalyticsChartsGoalsStreamCursorValueInput = {
  goal_definition?: InputMaybe<Scalars['jsonb']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  saved_chart_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedAnalyticsChartsGoalsSumFields = {
  __typename?: 'saved_analytics_charts_goals_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "saved_analytics_charts_goals" */
export const SavedAnalyticsChartsGoalsUpdateColumn = {
  /** column name */
  GoalDefinition: 'goal_definition',
  /** column name */
  GoalId: 'goal_id'
} as const;

export type SavedAnalyticsChartsGoalsUpdateColumn = typeof SavedAnalyticsChartsGoalsUpdateColumn[keyof typeof SavedAnalyticsChartsGoalsUpdateColumn];
export type SavedAnalyticsChartsGoalsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedAnalyticsChartsGoalsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsGoalsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedAnalyticsChartsGoalsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedAnalyticsChartsGoalsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedAnalyticsChartsGoalsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedAnalyticsChartsGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: SavedAnalyticsChartsGoalsBoolExp;
};

/** aggregate var_pop on columns */
export type SavedAnalyticsChartsGoalsVarPopFields = {
  __typename?: 'saved_analytics_charts_goals_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SavedAnalyticsChartsGoalsVarSampFields = {
  __typename?: 'saved_analytics_charts_goals_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SavedAnalyticsChartsGoalsVarianceFields = {
  __typename?: 'saved_analytics_charts_goals_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "saved_analytics_charts_goals" */
export type SavedAnalyticsChartsGoalsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "saved_analytics_charts" */
export type SavedAnalyticsChartsIncInput = {
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_analytics_charts" */
export type SavedAnalyticsChartsInsertInput = {
  analytics_report?: InputMaybe<AnalyticsReportsObjRelInsertInput>;
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  chart_type?: InputMaybe<Scalars['String']>;
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  cohorts?: InputMaybe<SavedAnalyticsChartsCohortsArrRelInsertInput>;
  conversion_window?: InputMaybe<Scalars['jsonb']>;
  cumulative?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  funnel_stages?: InputMaybe<SavedAnalyticsChartsFunnelStagesArrRelInsertInput>;
  goals?: InputMaybe<SavedAnalyticsChartsGoalsArrRelInsertInput>;
  group_by?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  measuring_id?: InputMaybe<Scalars['String']>;
  measuring_mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  normalization?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SavedAnalyticsChartsMaxFields = {
  __typename?: 'saved_analytics_charts_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  chart_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  measuring_id?: Maybe<Scalars['String']>;
  measuring_mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  normalization?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SavedAnalyticsChartsMinFields = {
  __typename?: 'saved_analytics_charts_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  chart_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  measuring_id?: Maybe<Scalars['String']>;
  measuring_mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  normalization?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "saved_analytics_charts" */
export type SavedAnalyticsChartsMutationResponse = {
  __typename?: 'saved_analytics_charts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedAnalyticsCharts>;
};

/** input type for inserting object relation for remote table "saved_analytics_charts" */
export type SavedAnalyticsChartsObjRelInsertInput = {
  data: SavedAnalyticsChartsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedAnalyticsChartsOnConflict>;
};

/** on_conflict condition type for table "saved_analytics_charts" */
export type SavedAnalyticsChartsOnConflict = {
  constraint: SavedAnalyticsChartsConstraint;
  update_columns?: Array<SavedAnalyticsChartsUpdateColumn>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};

/** Ordering options when selecting data from "saved_analytics_charts". */
export type SavedAnalyticsChartsOrderBy = {
  analytics_report?: InputMaybe<AnalyticsReportsOrderBy>;
  archived_at?: InputMaybe<OrderBy>;
  chart_type?: InputMaybe<OrderBy>;
  cohort_filter?: InputMaybe<OrderBy>;
  cohorts_aggregate?: InputMaybe<SavedAnalyticsChartsCohortsAggregateOrderBy>;
  conversion_window?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  cumulative?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  frequency?: InputMaybe<OrderBy>;
  funnel_stages_aggregate?: InputMaybe<SavedAnalyticsChartsFunnelStagesAggregateOrderBy>;
  goals_aggregate?: InputMaybe<SavedAnalyticsChartsGoalsAggregateOrderBy>;
  group_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lookback_window?: InputMaybe<OrderBy>;
  measurement_window?: InputMaybe<OrderBy>;
  measuring_id?: InputMaybe<OrderBy>;
  measuring_mode?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  normalization?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_analytics_charts */
export type SavedAnalyticsChartsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedAnalyticsChartsPrependInput = {
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  conversion_window?: InputMaybe<Scalars['jsonb']>;
  group_by?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_analytics_charts" */
export const SavedAnalyticsChartsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  ChartType: 'chart_type',
  /** column name */
  CohortFilter: 'cohort_filter',
  /** column name */
  ConversionWindow: 'conversion_window',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Cumulative: 'cumulative',
  /** column name */
  Description: 'description',
  /** column name */
  Frequency: 'frequency',
  /** column name */
  GroupBy: 'group_by',
  /** column name */
  Id: 'id',
  /** column name */
  LookbackWindow: 'lookback_window',
  /** column name */
  MeasurementWindow: 'measurement_window',
  /** column name */
  MeasuringId: 'measuring_id',
  /** column name */
  MeasuringMode: 'measuring_mode',
  /** column name */
  Name: 'name',
  /** column name */
  Normalization: 'normalization',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedAnalyticsChartsSelectColumn = typeof SavedAnalyticsChartsSelectColumn[keyof typeof SavedAnalyticsChartsSelectColumn];
/** input type for updating data in table "saved_analytics_charts" */
export type SavedAnalyticsChartsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  chart_type?: InputMaybe<Scalars['String']>;
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  conversion_window?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  group_by?: InputMaybe<Scalars['jsonb']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  measuring_id?: InputMaybe<Scalars['String']>;
  measuring_mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  normalization?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SavedAnalyticsChartsStddevFields = {
  __typename?: 'saved_analytics_charts_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SavedAnalyticsChartsStddevPopFields = {
  __typename?: 'saved_analytics_charts_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SavedAnalyticsChartsStddevSampFields = {
  __typename?: 'saved_analytics_charts_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "saved_analytics_charts" */
export type SavedAnalyticsChartsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedAnalyticsChartsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedAnalyticsChartsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  chart_type?: InputMaybe<Scalars['String']>;
  cohort_filter?: InputMaybe<Scalars['jsonb']>;
  conversion_window?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  cumulative?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  group_by?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  lookback_window?: InputMaybe<Scalars['jsonb']>;
  measurement_window?: InputMaybe<Scalars['jsonb']>;
  measuring_id?: InputMaybe<Scalars['String']>;
  measuring_mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  normalization?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedAnalyticsChartsSumFields = {
  __typename?: 'saved_analytics_charts_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "saved_analytics_charts" */
export const SavedAnalyticsChartsUpdateColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  ChartType: 'chart_type',
  /** column name */
  CohortFilter: 'cohort_filter',
  /** column name */
  ConversionWindow: 'conversion_window',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Cumulative: 'cumulative',
  /** column name */
  Description: 'description',
  /** column name */
  Frequency: 'frequency',
  /** column name */
  GroupBy: 'group_by',
  /** column name */
  LookbackWindow: 'lookback_window',
  /** column name */
  MeasurementWindow: 'measurement_window',
  /** column name */
  MeasuringId: 'measuring_id',
  /** column name */
  MeasuringMode: 'measuring_mode',
  /** column name */
  Name: 'name',
  /** column name */
  Normalization: 'normalization',
  /** column name */
  ParentModelId: 'parent_model_id'
} as const;

export type SavedAnalyticsChartsUpdateColumn = typeof SavedAnalyticsChartsUpdateColumn[keyof typeof SavedAnalyticsChartsUpdateColumn];
export type SavedAnalyticsChartsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedAnalyticsChartsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedAnalyticsChartsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedAnalyticsChartsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedAnalyticsChartsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SavedAnalyticsChartsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedAnalyticsChartsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedAnalyticsChartsSetInput>;
  /** filter the rows which have to be updated */
  where: SavedAnalyticsChartsBoolExp;
};

/** aggregate var_pop on columns */
export type SavedAnalyticsChartsVarPopFields = {
  __typename?: 'saved_analytics_charts_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SavedAnalyticsChartsVarSampFields = {
  __typename?: 'saved_analytics_charts_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SavedAnalyticsChartsVarianceFields = {
  __typename?: 'saved_analytics_charts_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViews = {
  __typename?: 'saved_campaign_views';
  archived_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  asset_model?: Maybe<Segments>;
  asset_model_id: Scalars['bigint'];
  column_references: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  goals: Array<SavedCampaignViewsGoals>;
  /** An aggregate relationship */
  goals_aggregate: SavedCampaignViewsGoalsAggregate;
  id: Scalars['uuid'];
  metric_filters?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  parent_model?: Maybe<Segments>;
  parent_model_id: Scalars['bigint'];
  sort: Scalars['jsonb'];
  time_window: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsColumnReferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsFiltersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsMetricFiltersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsSortArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_campaign_views" */
export type SavedCampaignViewsTimeWindowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "saved_campaign_views" */
export type SavedCampaignViewsAggregate = {
  __typename?: 'saved_campaign_views_aggregate';
  aggregate?: Maybe<SavedCampaignViewsAggregateFields>;
  nodes: Array<SavedCampaignViews>;
};

/** aggregate fields of "saved_campaign_views" */
export type SavedCampaignViewsAggregateFields = {
  __typename?: 'saved_campaign_views_aggregate_fields';
  avg?: Maybe<SavedCampaignViewsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedCampaignViewsMaxFields>;
  min?: Maybe<SavedCampaignViewsMinFields>;
  stddev?: Maybe<SavedCampaignViewsStddevFields>;
  stddev_pop?: Maybe<SavedCampaignViewsStddevPopFields>;
  stddev_samp?: Maybe<SavedCampaignViewsStddevSampFields>;
  sum?: Maybe<SavedCampaignViewsSumFields>;
  var_pop?: Maybe<SavedCampaignViewsVarPopFields>;
  var_samp?: Maybe<SavedCampaignViewsVarSampFields>;
  variance?: Maybe<SavedCampaignViewsVarianceFields>;
};


/** aggregate fields of "saved_campaign_views" */
export type SavedCampaignViewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedCampaignViewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedCampaignViewsAppendInput = {
  column_references?: InputMaybe<Scalars['jsonb']>;
  filters?: InputMaybe<Scalars['jsonb']>;
  metric_filters?: InputMaybe<Scalars['jsonb']>;
  sort?: InputMaybe<Scalars['jsonb']>;
  time_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SavedCampaignViewsAvgFields = {
  __typename?: 'saved_campaign_views_avg_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "saved_campaign_views". All fields are combined with a logical 'AND'. */
export type SavedCampaignViewsBoolExp = {
  _and?: InputMaybe<Array<SavedCampaignViewsBoolExp>>;
  _not?: InputMaybe<SavedCampaignViewsBoolExp>;
  _or?: InputMaybe<Array<SavedCampaignViewsBoolExp>>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  asset_model?: InputMaybe<SegmentsBoolExp>;
  asset_model_id?: InputMaybe<BigintComparisonExp>;
  column_references?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  filters?: InputMaybe<JsonbComparisonExp>;
  goals?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
  goals_aggregate?: InputMaybe<SavedCampaignViewsGoalsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metric_filters?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  sort?: InputMaybe<JsonbComparisonExp>;
  time_window?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_campaign_views" */
export const SavedCampaignViewsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SavedCampaignViewsIdWorkspaceIdKey: 'saved_campaign_views_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  SavedCampaignViewsPkey: 'saved_campaign_views_pkey'
} as const;

export type SavedCampaignViewsConstraint = typeof SavedCampaignViewsConstraint[keyof typeof SavedCampaignViewsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedCampaignViewsDeleteAtPathInput = {
  column_references?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<Array<Scalars['String']>>;
  metric_filters?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<Array<Scalars['String']>>;
  time_window?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedCampaignViewsDeleteElemInput = {
  column_references?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Scalars['Int']>;
  metric_filters?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  time_window?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedCampaignViewsDeleteKeyInput = {
  column_references?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['String']>;
  metric_filters?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  time_window?: InputMaybe<Scalars['String']>;
};

/** Bridge table between `saved_campaign_views` and `goals` */
export type SavedCampaignViewsGoals = {
  __typename?: 'saved_campaign_views_goals';
  /** An object relationship */
  attribution_method?: Maybe<AttributionMethods>;
  attribution_method_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  goal: Goals;
  goal_id: Scalars['uuid'];
  id: Scalars['uuid'];
  saved_campaign_view_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsAggregate = {
  __typename?: 'saved_campaign_views_goals_aggregate';
  aggregate?: Maybe<SavedCampaignViewsGoalsAggregateFields>;
  nodes: Array<SavedCampaignViewsGoals>;
};

export type SavedCampaignViewsGoalsAggregateBoolExp = {
  count?: InputMaybe<SavedCampaignViewsGoalsAggregateBoolExpCount>;
};

export type SavedCampaignViewsGoalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsAggregateFields = {
  __typename?: 'saved_campaign_views_goals_aggregate_fields';
  avg?: Maybe<SavedCampaignViewsGoalsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedCampaignViewsGoalsMaxFields>;
  min?: Maybe<SavedCampaignViewsGoalsMinFields>;
  stddev?: Maybe<SavedCampaignViewsGoalsStddevFields>;
  stddev_pop?: Maybe<SavedCampaignViewsGoalsStddevPopFields>;
  stddev_samp?: Maybe<SavedCampaignViewsGoalsStddevSampFields>;
  sum?: Maybe<SavedCampaignViewsGoalsSumFields>;
  var_pop?: Maybe<SavedCampaignViewsGoalsVarPopFields>;
  var_samp?: Maybe<SavedCampaignViewsGoalsVarSampFields>;
  variance?: Maybe<SavedCampaignViewsGoalsVarianceFields>;
};


/** aggregate fields of "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsAggregateOrderBy = {
  avg?: InputMaybe<SavedCampaignViewsGoalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SavedCampaignViewsGoalsMaxOrderBy>;
  min?: InputMaybe<SavedCampaignViewsGoalsMinOrderBy>;
  stddev?: InputMaybe<SavedCampaignViewsGoalsStddevOrderBy>;
  stddev_pop?: InputMaybe<SavedCampaignViewsGoalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SavedCampaignViewsGoalsStddevSampOrderBy>;
  sum?: InputMaybe<SavedCampaignViewsGoalsSumOrderBy>;
  var_pop?: InputMaybe<SavedCampaignViewsGoalsVarPopOrderBy>;
  var_samp?: InputMaybe<SavedCampaignViewsGoalsVarSampOrderBy>;
  variance?: InputMaybe<SavedCampaignViewsGoalsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsArrRelInsertInput = {
  data: Array<SavedCampaignViewsGoalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedCampaignViewsGoalsOnConflict>;
};

/** aggregate avg on columns */
export type SavedCampaignViewsGoalsAvgFields = {
  __typename?: 'saved_campaign_views_goals_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "saved_campaign_views_goals". All fields are combined with a logical 'AND'. */
export type SavedCampaignViewsGoalsBoolExp = {
  _and?: InputMaybe<Array<SavedCampaignViewsGoalsBoolExp>>;
  _not?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
  _or?: InputMaybe<Array<SavedCampaignViewsGoalsBoolExp>>;
  attribution_method?: InputMaybe<AttributionMethodsBoolExp>;
  attribution_method_id?: InputMaybe<UuidComparisonExp>;
  goal?: InputMaybe<GoalsBoolExp>;
  goal_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  saved_campaign_view_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_campaign_views_goals" */
export const SavedCampaignViewsGoalsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SavedCampaignViewsGoalsPkey: 'saved_campaign_views_goals_pkey'
} as const;

export type SavedCampaignViewsGoalsConstraint = typeof SavedCampaignViewsGoalsConstraint[keyof typeof SavedCampaignViewsGoalsConstraint];
/** input type for inserting data into table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsInsertInput = {
  attribution_method?: InputMaybe<AttributionMethodsObjRelInsertInput>;
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal?: InputMaybe<GoalsObjRelInsertInput>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  saved_campaign_view_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type SavedCampaignViewsGoalsMaxFields = {
  __typename?: 'saved_campaign_views_goals_max_fields';
  attribution_method_id?: Maybe<Scalars['uuid']>;
  goal_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_campaign_view_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsMaxOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_campaign_view_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SavedCampaignViewsGoalsMinFields = {
  __typename?: 'saved_campaign_views_goals_min_fields';
  attribution_method_id?: Maybe<Scalars['uuid']>;
  goal_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  saved_campaign_view_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsMinOrderBy = {
  attribution_method_id?: InputMaybe<OrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_campaign_view_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsMutationResponse = {
  __typename?: 'saved_campaign_views_goals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedCampaignViewsGoals>;
};

/** on_conflict condition type for table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsOnConflict = {
  constraint: SavedCampaignViewsGoalsConstraint;
  update_columns?: Array<SavedCampaignViewsGoalsUpdateColumn>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};

/** Ordering options when selecting data from "saved_campaign_views_goals". */
export type SavedCampaignViewsGoalsOrderBy = {
  attribution_method?: InputMaybe<AttributionMethodsOrderBy>;
  attribution_method_id?: InputMaybe<OrderBy>;
  goal?: InputMaybe<GoalsOrderBy>;
  goal_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  saved_campaign_view_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_campaign_views_goals */
export type SavedCampaignViewsGoalsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "saved_campaign_views_goals" */
export const SavedCampaignViewsGoalsSelectColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  GoalId: 'goal_id',
  /** column name */
  Id: 'id',
  /** column name */
  SavedCampaignViewId: 'saved_campaign_view_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedCampaignViewsGoalsSelectColumn = typeof SavedCampaignViewsGoalsSelectColumn[keyof typeof SavedCampaignViewsGoalsSelectColumn];
/** input type for updating data in table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsSetInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type SavedCampaignViewsGoalsStddevFields = {
  __typename?: 'saved_campaign_views_goals_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SavedCampaignViewsGoalsStddevPopFields = {
  __typename?: 'saved_campaign_views_goals_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SavedCampaignViewsGoalsStddevSampFields = {
  __typename?: 'saved_campaign_views_goals_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedCampaignViewsGoalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedCampaignViewsGoalsStreamCursorValueInput = {
  attribution_method_id?: InputMaybe<Scalars['uuid']>;
  goal_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  saved_campaign_view_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedCampaignViewsGoalsSumFields = {
  __typename?: 'saved_campaign_views_goals_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "saved_campaign_views_goals" */
export const SavedCampaignViewsGoalsUpdateColumn = {
  /** column name */
  AttributionMethodId: 'attribution_method_id',
  /** column name */
  GoalId: 'goal_id'
} as const;

export type SavedCampaignViewsGoalsUpdateColumn = typeof SavedCampaignViewsGoalsUpdateColumn[keyof typeof SavedCampaignViewsGoalsUpdateColumn];
export type SavedCampaignViewsGoalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedCampaignViewsGoalsSetInput>;
  /** filter the rows which have to be updated */
  where: SavedCampaignViewsGoalsBoolExp;
};

/** aggregate var_pop on columns */
export type SavedCampaignViewsGoalsVarPopFields = {
  __typename?: 'saved_campaign_views_goals_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SavedCampaignViewsGoalsVarSampFields = {
  __typename?: 'saved_campaign_views_goals_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SavedCampaignViewsGoalsVarianceFields = {
  __typename?: 'saved_campaign_views_goals_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "saved_campaign_views_goals" */
export type SavedCampaignViewsGoalsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "saved_campaign_views" */
export type SavedCampaignViewsIncInput = {
  asset_model_id?: InputMaybe<Scalars['bigint']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_campaign_views" */
export type SavedCampaignViewsInsertInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  asset_model?: InputMaybe<SegmentsObjRelInsertInput>;
  asset_model_id?: InputMaybe<Scalars['bigint']>;
  column_references?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['jsonb']>;
  goals?: InputMaybe<SavedCampaignViewsGoalsArrRelInsertInput>;
  metric_filters?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  sort?: InputMaybe<Scalars['jsonb']>;
  time_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type SavedCampaignViewsMaxFields = {
  __typename?: 'saved_campaign_views_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  asset_model_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SavedCampaignViewsMinFields = {
  __typename?: 'saved_campaign_views_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  asset_model_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "saved_campaign_views" */
export type SavedCampaignViewsMutationResponse = {
  __typename?: 'saved_campaign_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedCampaignViews>;
};

/** on_conflict condition type for table "saved_campaign_views" */
export type SavedCampaignViewsOnConflict = {
  constraint: SavedCampaignViewsConstraint;
  update_columns?: Array<SavedCampaignViewsUpdateColumn>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};

/** Ordering options when selecting data from "saved_campaign_views". */
export type SavedCampaignViewsOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  asset_model?: InputMaybe<SegmentsOrderBy>;
  asset_model_id?: InputMaybe<OrderBy>;
  column_references?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  filters?: InputMaybe<OrderBy>;
  goals_aggregate?: InputMaybe<SavedCampaignViewsGoalsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  metric_filters?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  sort?: InputMaybe<OrderBy>;
  time_window?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_campaign_views */
export type SavedCampaignViewsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedCampaignViewsPrependInput = {
  column_references?: InputMaybe<Scalars['jsonb']>;
  filters?: InputMaybe<Scalars['jsonb']>;
  metric_filters?: InputMaybe<Scalars['jsonb']>;
  sort?: InputMaybe<Scalars['jsonb']>;
  time_window?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_campaign_views" */
export const SavedCampaignViewsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  AssetModelId: 'asset_model_id',
  /** column name */
  ColumnReferences: 'column_references',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Filters: 'filters',
  /** column name */
  Id: 'id',
  /** column name */
  MetricFilters: 'metric_filters',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Sort: 'sort',
  /** column name */
  TimeWindow: 'time_window',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedCampaignViewsSelectColumn = typeof SavedCampaignViewsSelectColumn[keyof typeof SavedCampaignViewsSelectColumn];
/** input type for updating data in table "saved_campaign_views" */
export type SavedCampaignViewsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  asset_model_id?: InputMaybe<Scalars['bigint']>;
  column_references?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['jsonb']>;
  metric_filters?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  sort?: InputMaybe<Scalars['jsonb']>;
  time_window?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type SavedCampaignViewsStddevFields = {
  __typename?: 'saved_campaign_views_stddev_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SavedCampaignViewsStddevPopFields = {
  __typename?: 'saved_campaign_views_stddev_pop_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SavedCampaignViewsStddevSampFields = {
  __typename?: 'saved_campaign_views_stddev_samp_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "saved_campaign_views" */
export type SavedCampaignViewsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedCampaignViewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedCampaignViewsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  asset_model_id?: InputMaybe<Scalars['bigint']>;
  column_references?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  metric_filters?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  sort?: InputMaybe<Scalars['jsonb']>;
  time_window?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedCampaignViewsSumFields = {
  __typename?: 'saved_campaign_views_sum_fields';
  asset_model_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "saved_campaign_views" */
export const SavedCampaignViewsUpdateColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  AssetModelId: 'asset_model_id',
  /** column name */
  ColumnReferences: 'column_references',
  /** column name */
  Description: 'description',
  /** column name */
  Filters: 'filters',
  /** column name */
  MetricFilters: 'metric_filters',
  /** column name */
  Name: 'name',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Sort: 'sort',
  /** column name */
  TimeWindow: 'time_window'
} as const;

export type SavedCampaignViewsUpdateColumn = typeof SavedCampaignViewsUpdateColumn[keyof typeof SavedCampaignViewsUpdateColumn];
export type SavedCampaignViewsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedCampaignViewsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedCampaignViewsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedCampaignViewsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedCampaignViewsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SavedCampaignViewsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedCampaignViewsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedCampaignViewsSetInput>;
  /** filter the rows which have to be updated */
  where: SavedCampaignViewsBoolExp;
};

/** aggregate var_pop on columns */
export type SavedCampaignViewsVarPopFields = {
  __typename?: 'saved_campaign_views_var_pop_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SavedCampaignViewsVarSampFields = {
  __typename?: 'saved_campaign_views_var_samp_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SavedCampaignViewsVarianceFields = {
  __typename?: 'saved_campaign_views_variance_fields';
  asset_model_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "saved_messages" */
export type SavedMessages = {
  __typename?: 'saved_messages';
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  brand_profile?: Maybe<BrandProfiles>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  campaign?: Maybe<MarketingCampaigns>;
  /** An object relationship */
  campaign_artifact?: Maybe<CampaignArtifacts>;
  campaign_id?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  /** An object relationship */
  content_email?: Maybe<ContentEmails>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  current_version?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  edited_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  edited_by_user?: Maybe<Users>;
  filename?: Maybe<Scalars['String']>;
  /** An object relationship */
  folder?: Maybe<Folders>;
  folder_id?: Maybe<Scalars['uuid']>;
  is_private?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  llm_chat_session?: Maybe<LlmChatSessions>;
  /** An array relationship */
  my_favorites: Array<ArtifactFavorites>;
  /** An aggregate relationship */
  my_favorites_aggregate: ArtifactFavoritesAggregate;
  name?: Maybe<Scalars['String']>;
  promoted?: Maybe<Scalars['Boolean']>;
  source_id?: Maybe<Scalars['uuid']>;
  source_kind?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "saved_messages" */
export type SavedMessagesMyFavoritesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


/** columns and relationships of "saved_messages" */
export type SavedMessagesMyFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};

/** aggregated selection of "saved_messages" */
export type SavedMessagesAggregate = {
  __typename?: 'saved_messages_aggregate';
  aggregate?: Maybe<SavedMessagesAggregateFields>;
  nodes: Array<SavedMessages>;
};

/** aggregate fields of "saved_messages" */
export type SavedMessagesAggregateFields = {
  __typename?: 'saved_messages_aggregate_fields';
  avg?: Maybe<SavedMessagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SavedMessagesMaxFields>;
  min?: Maybe<SavedMessagesMinFields>;
  stddev?: Maybe<SavedMessagesStddevFields>;
  stddev_pop?: Maybe<SavedMessagesStddevPopFields>;
  stddev_samp?: Maybe<SavedMessagesStddevSampFields>;
  sum?: Maybe<SavedMessagesSumFields>;
  var_pop?: Maybe<SavedMessagesVarPopFields>;
  var_samp?: Maybe<SavedMessagesVarSampFields>;
  variance?: Maybe<SavedMessagesVarianceFields>;
};


/** aggregate fields of "saved_messages" */
export type SavedMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SavedMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SavedMessagesAvgFields = {
  __typename?: 'saved_messages_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "saved_messages". All fields are combined with a logical 'AND'. */
export type SavedMessagesBoolExp = {
  _and?: InputMaybe<Array<SavedMessagesBoolExp>>;
  _not?: InputMaybe<SavedMessagesBoolExp>;
  _or?: InputMaybe<Array<SavedMessagesBoolExp>>;
  artifact_id?: InputMaybe<UuidComparisonExp>;
  artifact_type?: InputMaybe<StringComparisonExp>;
  brand_profile?: InputMaybe<BrandProfilesBoolExp>;
  brand_profile_id?: InputMaybe<UuidComparisonExp>;
  campaign?: InputMaybe<MarketingCampaignsBoolExp>;
  campaign_artifact?: InputMaybe<CampaignArtifactsBoolExp>;
  campaign_id?: InputMaybe<UuidComparisonExp>;
  channel?: InputMaybe<StringComparisonExp>;
  content_email?: InputMaybe<ContentEmailsBoolExp>;
  content_email_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_llm_chat_session_id?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  current_version?: InputMaybe<IntComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  edited_by?: InputMaybe<BigintComparisonExp>;
  edited_by_user?: InputMaybe<UsersBoolExp>;
  filename?: InputMaybe<StringComparisonExp>;
  folder?: InputMaybe<FoldersBoolExp>;
  folder_id?: InputMaybe<UuidComparisonExp>;
  is_private?: InputMaybe<BooleanComparisonExp>;
  llm_chat_session?: InputMaybe<LlmChatSessionsBoolExp>;
  my_favorites?: InputMaybe<ArtifactFavoritesBoolExp>;
  my_favorites_aggregate?: InputMaybe<ArtifactFavoritesAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  promoted?: InputMaybe<BooleanComparisonExp>;
  source_id?: InputMaybe<UuidComparisonExp>;
  source_kind?: InputMaybe<StringComparisonExp>;
  subject?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SavedMessagesMaxFields = {
  __typename?: 'saved_messages_max_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_type?: Maybe<Scalars['String']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  current_version?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  edited_by?: Maybe<Scalars['bigint']>;
  filename?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['uuid']>;
  source_kind?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SavedMessagesMinFields = {
  __typename?: 'saved_messages_min_fields';
  artifact_id?: Maybe<Scalars['uuid']>;
  artifact_type?: Maybe<Scalars['String']>;
  brand_profile_id?: Maybe<Scalars['uuid']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  channel?: Maybe<Scalars['String']>;
  content_email_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  created_by_llm_chat_session_id?: Maybe<Scalars['uuid']>;
  current_version?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  edited_by?: Maybe<Scalars['bigint']>;
  filename?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['uuid']>;
  source_kind?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "saved_messages". */
export type SavedMessagesOrderBy = {
  artifact_id?: InputMaybe<OrderBy>;
  artifact_type?: InputMaybe<OrderBy>;
  brand_profile?: InputMaybe<BrandProfilesOrderBy>;
  brand_profile_id?: InputMaybe<OrderBy>;
  campaign?: InputMaybe<MarketingCampaignsOrderBy>;
  campaign_artifact?: InputMaybe<CampaignArtifactsOrderBy>;
  campaign_id?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  content_email?: InputMaybe<ContentEmailsOrderBy>;
  content_email_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_llm_chat_session_id?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  current_version?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  edited_by?: InputMaybe<OrderBy>;
  edited_by_user?: InputMaybe<UsersOrderBy>;
  filename?: InputMaybe<OrderBy>;
  folder?: InputMaybe<FoldersOrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  is_private?: InputMaybe<OrderBy>;
  llm_chat_session?: InputMaybe<LlmChatSessionsOrderBy>;
  my_favorites_aggregate?: InputMaybe<ArtifactFavoritesAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  promoted?: InputMaybe<OrderBy>;
  source_id?: InputMaybe<OrderBy>;
  source_kind?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "saved_messages" */
export const SavedMessagesSelectColumn = {
  /** column name */
  ArtifactId: 'artifact_id',
  /** column name */
  ArtifactType: 'artifact_type',
  /** column name */
  BrandProfileId: 'brand_profile_id',
  /** column name */
  CampaignId: 'campaign_id',
  /** column name */
  Channel: 'channel',
  /** column name */
  ContentEmailId: 'content_email_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CreatedByLlmChatSessionId: 'created_by_llm_chat_session_id',
  /** column name */
  CurrentVersion: 'current_version',
  /** column name */
  Description: 'description',
  /** column name */
  EditedBy: 'edited_by',
  /** column name */
  Filename: 'filename',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  IsPrivate: 'is_private',
  /** column name */
  Name: 'name',
  /** column name */
  Promoted: 'promoted',
  /** column name */
  SourceId: 'source_id',
  /** column name */
  SourceKind: 'source_kind',
  /** column name */
  Subject: 'subject',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedMessagesSelectColumn = typeof SavedMessagesSelectColumn[keyof typeof SavedMessagesSelectColumn];
/** aggregate stddev on columns */
export type SavedMessagesStddevFields = {
  __typename?: 'saved_messages_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SavedMessagesStddevPopFields = {
  __typename?: 'saved_messages_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SavedMessagesStddevSampFields = {
  __typename?: 'saved_messages_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "saved_messages" */
export type SavedMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedMessagesStreamCursorValueInput = {
  artifact_id?: InputMaybe<Scalars['uuid']>;
  artifact_type?: InputMaybe<Scalars['String']>;
  brand_profile_id?: InputMaybe<Scalars['uuid']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  channel?: InputMaybe<Scalars['String']>;
  content_email_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  created_by_llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  current_version?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  edited_by?: InputMaybe<Scalars['bigint']>;
  filename?: InputMaybe<Scalars['String']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  promoted?: InputMaybe<Scalars['Boolean']>;
  source_id?: InputMaybe<Scalars['uuid']>;
  source_kind?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SavedMessagesSumFields = {
  __typename?: 'saved_messages_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  current_version?: Maybe<Scalars['Int']>;
  edited_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type SavedMessagesVarPopFields = {
  __typename?: 'saved_messages_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SavedMessagesVarSampFields = {
  __typename?: 'saved_messages_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SavedMessagesVarianceFields = {
  __typename?: 'saved_messages_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  current_version?: Maybe<Scalars['Float']>;
  edited_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "saved_queries" */
export type SavedQueries = {
  __typename?: 'saved_queries';
  /** An object relationship */
  connection?: Maybe<Connections>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  filter_json?: Maybe<Scalars['jsonb']>;
  id: Scalars['bigint'];
  last_columns_cache?: Maybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  object_definition?: Maybe<ObjectDefinitions>;
  object_definition_id?: Maybe<Scalars['bigint']>;
  public: Scalars['Boolean'];
  query_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "saved_queries" */
export type SavedQueriesFilterJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "saved_queries" */
export type SavedQueriesLastColumnsCacheArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SavedQueriesAppendInput = {
  filter_json?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "saved_queries". All fields are combined with a logical 'AND'. */
export type SavedQueriesBoolExp = {
  _and?: InputMaybe<Array<SavedQueriesBoolExp>>;
  _not?: InputMaybe<SavedQueriesBoolExp>;
  _or?: InputMaybe<Array<SavedQueriesBoolExp>>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  filter_json?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  last_columns_cache?: InputMaybe<JsonbComparisonExp>;
  last_columns_cache_refreshed_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  object_definition?: InputMaybe<ObjectDefinitionsBoolExp>;
  object_definition_id?: InputMaybe<BigintComparisonExp>;
  public?: InputMaybe<BooleanComparisonExp>;
  query_type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "saved_queries" */
export const SavedQueriesConstraint = {
  /** unique or primary key constraint on columns "id" */
  FiltersPkey: 'filters_pkey'
} as const;

export type SavedQueriesConstraint = typeof SavedQueriesConstraint[keyof typeof SavedQueriesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SavedQueriesDeleteAtPathInput = {
  filter_json?: InputMaybe<Array<Scalars['String']>>;
  last_columns_cache?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SavedQueriesDeleteElemInput = {
  filter_json?: InputMaybe<Scalars['Int']>;
  last_columns_cache?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SavedQueriesDeleteKeyInput = {
  filter_json?: InputMaybe<Scalars['String']>;
  last_columns_cache?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "saved_queries" */
export type SavedQueriesIncInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "saved_queries" */
export type SavedQueriesInsertInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filter_json?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
  public?: InputMaybe<Scalars['Boolean']>;
  query_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** response of any mutation on the table "saved_queries" */
export type SavedQueriesMutationResponse = {
  __typename?: 'saved_queries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SavedQueries>;
};

/** input type for inserting object relation for remote table "saved_queries" */
export type SavedQueriesObjRelInsertInput = {
  data: SavedQueriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SavedQueriesOnConflict>;
};

/** on_conflict condition type for table "saved_queries" */
export type SavedQueriesOnConflict = {
  constraint: SavedQueriesConstraint;
  update_columns?: Array<SavedQueriesUpdateColumn>;
  where?: InputMaybe<SavedQueriesBoolExp>;
};

/** Ordering options when selecting data from "saved_queries". */
export type SavedQueriesOrderBy = {
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  filter_json?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_columns_cache?: InputMaybe<OrderBy>;
  last_columns_cache_refreshed_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  object_definition?: InputMaybe<ObjectDefinitionsOrderBy>;
  object_definition_id?: InputMaybe<OrderBy>;
  public?: InputMaybe<OrderBy>;
  query_type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: saved_queries */
export type SavedQueriesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SavedQueriesPrependInput = {
  filter_json?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "saved_queries" */
export const SavedQueriesSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  FilterJson: 'filter_json',
  /** column name */
  Id: 'id',
  /** column name */
  LastColumnsCache: 'last_columns_cache',
  /** column name */
  LastColumnsCacheRefreshedAt: 'last_columns_cache_refreshed_at',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Public: 'public',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SavedQueriesSelectColumn = typeof SavedQueriesSelectColumn[keyof typeof SavedQueriesSelectColumn];
/** input type for updating data in table "saved_queries" */
export type SavedQueriesSetInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  filter_json?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
  public?: InputMaybe<Scalars['Boolean']>;
  query_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "saved_queries" */
export type SavedQueriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SavedQueriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SavedQueriesStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  filter_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_columns_cache?: InputMaybe<Scalars['jsonb']>;
  last_columns_cache_refreshed_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  object_definition_id?: InputMaybe<Scalars['bigint']>;
  public?: InputMaybe<Scalars['Boolean']>;
  query_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "saved_queries" */
export const SavedQueriesUpdateColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  FilterJson: 'filter_json',
  /** column name */
  LastColumnsCache: 'last_columns_cache',
  /** column name */
  LastColumnsCacheRefreshedAt: 'last_columns_cache_refreshed_at',
  /** column name */
  Name: 'name',
  /** column name */
  ObjectDefinitionId: 'object_definition_id',
  /** column name */
  Public: 'public',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type SavedQueriesUpdateColumn = typeof SavedQueriesUpdateColumn[keyof typeof SavedQueriesUpdateColumn];
export type SavedQueriesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SavedQueriesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SavedQueriesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SavedQueriesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SavedQueriesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SavedQueriesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SavedQueriesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SavedQueriesSetInput>;
  /** filter the rows which have to be updated */
  where: SavedQueriesBoolExp;
};

/** columns and relationships of "segment_references" */
export type SegmentReferences = {
  __typename?: 'segment_references';
  resource_id: Scalars['String'];
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type: Scalars['String'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "segment_references" */
export type SegmentReferencesAggregate = {
  __typename?: 'segment_references_aggregate';
  aggregate?: Maybe<SegmentReferencesAggregateFields>;
  nodes: Array<SegmentReferences>;
};

/** aggregate fields of "segment_references" */
export type SegmentReferencesAggregateFields = {
  __typename?: 'segment_references_aggregate_fields';
  avg?: Maybe<SegmentReferencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SegmentReferencesMaxFields>;
  min?: Maybe<SegmentReferencesMinFields>;
  stddev?: Maybe<SegmentReferencesStddevFields>;
  stddev_pop?: Maybe<SegmentReferencesStddevPopFields>;
  stddev_samp?: Maybe<SegmentReferencesStddevSampFields>;
  sum?: Maybe<SegmentReferencesSumFields>;
  var_pop?: Maybe<SegmentReferencesVarPopFields>;
  var_samp?: Maybe<SegmentReferencesVarSampFields>;
  variance?: Maybe<SegmentReferencesVarianceFields>;
};


/** aggregate fields of "segment_references" */
export type SegmentReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SegmentReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SegmentReferencesAvgFields = {
  __typename?: 'segment_references_avg_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "segment_references". All fields are combined with a logical 'AND'. */
export type SegmentReferencesBoolExp = {
  _and?: InputMaybe<Array<SegmentReferencesBoolExp>>;
  _not?: InputMaybe<SegmentReferencesBoolExp>;
  _or?: InputMaybe<Array<SegmentReferencesBoolExp>>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_id_bigint?: InputMaybe<BigintComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SegmentReferencesMaxFields = {
  __typename?: 'segment_references_max_fields';
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SegmentReferencesMinFields = {
  __typename?: 'segment_references_min_fields';
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "segment_references". */
export type SegmentReferencesOrderBy = {
  resource_id?: InputMaybe<OrderBy>;
  resource_id_bigint?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "segment_references" */
export const SegmentReferencesSelectColumn = {
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceIdBigint: 'resource_id_bigint',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SegmentReferencesSelectColumn = typeof SegmentReferencesSelectColumn[keyof typeof SegmentReferencesSelectColumn];
/** aggregate stddev on columns */
export type SegmentReferencesStddevFields = {
  __typename?: 'segment_references_stddev_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SegmentReferencesStddevPopFields = {
  __typename?: 'segment_references_stddev_pop_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SegmentReferencesStddevSampFields = {
  __typename?: 'segment_references_stddev_samp_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "segment_references" */
export type SegmentReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SegmentReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SegmentReferencesStreamCursorValueInput = {
  resource_id?: InputMaybe<Scalars['String']>;
  resource_id_bigint?: InputMaybe<Scalars['bigint']>;
  resource_type?: InputMaybe<Scalars['String']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SegmentReferencesSumFields = {
  __typename?: 'segment_references_sum_fields';
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type SegmentReferencesVarPopFields = {
  __typename?: 'segment_references_var_pop_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SegmentReferencesVarSampFields = {
  __typename?: 'segment_references_var_samp_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SegmentReferencesVarianceFields = {
  __typename?: 'segment_references_variance_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "segments" */
export type Segments = {
  __typename?: 'segments';
  /** An object relationship */
  ad_stats?: Maybe<AdStatsModels>;
  /** An object relationship */
  analytics_report?: Maybe<AnalyticsReports>;
  approved_draft_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  asset?: Maybe<AssetModels>;
  /** An array relationship */
  attribution_methods: Array<AttributionMethods>;
  /** An aggregate relationship */
  attribution_methods_aggregate: AttributionMethodsAggregate;
  /** An array relationship */
  audience_column_references: Array<ModelColumnReferencesSegments>;
  /** An aggregate relationship */
  audience_column_references_aggregate: ModelColumnReferencesSegmentsAggregate;
  audience_columns: Array<ModelColumn>;
  /** An array relationship */
  audience_goals: Array<AudienceGoals>;
  /** An aggregate relationship */
  audience_goals_aggregate: AudienceGoalsAggregate;
  /** An object relationship */
  audience_overview?: Maybe<AudienceOverviews>;
  /** An array relationship */
  audience_primary_metrics: Array<AudiencePrimaryMetrics>;
  /** An aggregate relationship */
  audience_primary_metrics_aggregate: AudiencePrimaryMetricsAggregate;
  audience_reference_stats?: Maybe<AudienceReferenceStats>;
  /** An array relationship */
  audience_templates_for_parent_model: Array<AudienceTemplates>;
  /** An aggregate relationship */
  audience_templates_for_parent_model_aggregate: AudienceTemplatesAggregate;
  /** An array relationship */
  audiences_for_parent_model: Array<Segments>;
  /** An aggregate relationship */
  audiences_for_parent_model_aggregate: SegmentsAggregate;
  cached_audience_size: CachedAudienceSizeResponse;
  /** An array relationship */
  campaigns: Array<Campaigns>;
  /** An aggregate relationship */
  campaigns_aggregate: CampaignsAggregate;
  /** An object relationship */
  catalog?: Maybe<CatalogModels>;
  /** An object relationship */
  cep_managed_model?: Maybe<CepManagedModels>;
  /** An object relationship */
  cep_workspace_config?: Maybe<CepWorkspaceConfig>;
  /** An object relationship */
  channel_syncs?: Maybe<DecisionEngineFlowChannelSync>;
  /** An array relationship */
  columns: Array<ModelColumns>;
  /** An aggregate relationship */
  columns_aggregate: ModelColumnsAggregate;
  /** An object relationship */
  connection?: Maybe<Connections>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  custom_query?: Maybe<Scalars['jsonb']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  /** An array relationship */
  destination_rules: Array<DestinationRules>;
  /** An aggregate relationship */
  destination_rules_aggregate: DestinationRulesAggregate;
  draft: Scalars['Boolean'];
  /** An object relationship */
  draftByApprovedDraftId?: Maybe<Drafts>;
  enrichment_schedule?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  event?: Maybe<EventModels>;
  /** An object relationship */
  experiment?: Maybe<Experiments>;
  filterable_audience_columns: Array<FilterableColumn>;
  /** An object relationship */
  flow_message?: Maybe<DecisionEngineFlowMessages>;
  /** An object relationship */
  folder?: Maybe<Folders>;
  folder_id?: Maybe<Scalars['uuid']>;
  git_sync_metadata?: Maybe<Scalars['jsonb']>;
  golden_record?: Maybe<RelatedGoldenRecordModel>;
  id: Scalars['bigint'];
  /** An object relationship */
  idr_output?: Maybe<IdrOutputSegments>;
  /** An object relationship */
  interaction?: Maybe<InteractionModels>;
  is_general_model: Scalars['Boolean'];
  is_realtime_audience: Scalars['Boolean'];
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: Maybe<Scalars['Boolean']>;
  is_streamable?: Maybe<Scalars['Boolean']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Int']>;
  last_run_size?: Maybe<Scalars['Int']>;
  llm_description?: Maybe<Scalars['String']>;
  llm_description_job_id?: Maybe<Scalars['uuid']>;
  llm_description_job_status?: Maybe<Scalars['String']>;
  llm_detailed_description_info?: Maybe<Scalars['jsonb']>;
  matchbooster_audience_filter?: Maybe<Scalars['jsonb']>;
  matchbooster_settings?: Maybe<Scalars['jsonb']>;
  matchboosting_enabled: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  parent?: Maybe<Segments>;
  /** An array relationship */
  parent_model_goals: Array<Goals>;
  /** An aggregate relationship */
  parent_model_goals_aggregate: GoalsAggregate;
  /** An array relationship */
  predictor_feature_definitions: Array<PredictorFeatureDefinitions>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: Maybe<Scalars['String']>;
  /** An array relationship */
  priority_list_memberships: Array<PriorityListMemberships>;
  /** An object relationship */
  query_dbt_model?: Maybe<DbtSyncModels>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  query_integrations?: Maybe<Scalars['jsonb']>;
  query_looker_look_id?: Maybe<Scalars['String']>;
  query_raw_sql?: Maybe<Scalars['String']>;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  query_table_name?: Maybe<Scalars['String']>;
  query_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  realtime_audience_syncs: Array<RealtimeAudienceSyncs>;
  /** An object relationship */
  realtime_audiences_scheduled_warehouse_pull?: Maybe<RealtimeAudiencesScheduledWarehousePulls>;
  /** An array relationship */
  realtime_audiences_warehouse_pull_runs: Array<RealtimeAudiencesWarehousePullRuns>;
  /** An aggregate relationship */
  realtime_audiences_warehouse_pull_runs_aggregate: RealtimeAudiencesWarehousePullRunsAggregate;
  realtime_enabled?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  relationships: Array<ModelRelationships>;
  /** An array relationship */
  required_subset_groups: Array<AudienceSubsetGroupRequiredModels>;
  /** An aggregate relationship */
  required_subset_groups_aggregate: AudienceSubsetGroupRequiredModelsAggregate;
  /** An array relationship */
  retl_and_realtime_syncs: Array<RetlAndRealtimeSyncs>;
  /** An aggregate relationship */
  retl_and_realtime_syncs_aggregate: RetlAndRealtimeSyncsAggregate;
  /** The `Boolean` scalar type represents `true` or `false`. */
  sampled_model_available: Scalars['Boolean'];
  /** An array relationship */
  sampled_segments: Array<SampledSegments>;
  /** An aggregate relationship */
  sampled_segments_aggregate: SampledSegmentsAggregate;
  /** An object relationship */
  saved_query?: Maybe<SavedQueries>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  semantic_type?: Maybe<Scalars['String']>;
  semantic_type_name_column?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source_column_descriptions?: Maybe<Array<SourceColumnDescription>>;
  source_description?: Maybe<SourceDefinedDescription>;
  space_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  splits: Array<AudienceSplits>;
  /** An aggregate relationship */
  splits_aggregate: AudienceSplitsAggregate;
  /** An object relationship */
  static_list?: Maybe<StaticLists>;
  /** An array relationship */
  subsets: Array<AudiencesSubsets>;
  /** An aggregate relationship */
  subsets_aggregate: AudiencesSubsetsAggregate;
  /** An array relationship */
  sync_templates: Array<SyncTemplates>;
  /** An aggregate relationship */
  sync_templates_aggregate: SyncTemplatesAggregate;
  syncable_columns: Array<SyncableColumn>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  tags: Scalars['jsonb'];
  /** An array relationship */
  traits: Array<TraitDefinitions>;
  /** An aggregate relationship */
  traits_aggregate: TraitDefinitionsAggregate;
  traits_v2: Array<TraitDefinition>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An array relationship */
  user_group_audience_creation_authorization: Array<UserGroupAudienceCreationAuthorization>;
  /** An array relationship */
  user_group_model_authorization: Array<UserGroupModelAuthorization>;
  /** An array relationship */
  user_group_trait_authorization: Array<UserGroupTraitAuthorization>;
  visual_query_filter?: Maybe<Scalars['jsonb']>;
  visual_query_parent_id?: Maybe<Scalars['bigint']>;
  visual_query_primary_label?: Maybe<Scalars['String']>;
  visual_query_secondary_label?: Maybe<Scalars['String']>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "segments" */
export type SegmentsAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAttributionMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceColumnReferencesArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceColumnReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceGoalsArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudiencePrimaryMetricsArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudiencePrimaryMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceTemplatesForParentModelArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudienceTemplatesForParentModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudiencesForParentModelArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsAudiencesForParentModelAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsCachedAudienceSizeArgs = {
  relatedModelId?: InputMaybe<Scalars['bigint']>;
  subsetIds?: InputMaybe<Array<Scalars['String']>>;
};


/** columns and relationships of "segments" */
export type SegmentsCampaignsArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsCampaignsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsColumnsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsColumnsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsCustomQueryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsDestinationRulesArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsDestinationRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsEnrichmentScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsGitSyncMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsLlmDetailedDescriptionInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsMatchboosterAudienceFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsMatchboosterSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsParentModelGoalsArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsParentModelGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsPredictorFeatureDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsPriorityListMembershipsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListMembershipsOrderBy>>;
  where?: InputMaybe<PriorityListMembershipsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsQueryIntegrationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsQueryRunsArgs = {
  distinct_on?: InputMaybe<Array<QueryRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QueryRunsOrderBy>>;
  where?: InputMaybe<QueryRunsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRealtimeAudienceSyncsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRealtimeAudiencesWarehousePullRunsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRealtimeAudiencesWarehousePullRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipsOrderBy>>;
  where?: InputMaybe<ModelRelationshipsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRequiredSubsetGroupsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRequiredSubsetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRetlAndRealtimeSyncsArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsRetlAndRealtimeSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSampledSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSampledSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsSplitsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSplitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSubsetsArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSubsetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncsArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "segments" */
export type SegmentsTraitsArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsTraitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsTraitsV2Args = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


/** columns and relationships of "segments" */
export type SegmentsUserGroupAudienceCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsUserGroupModelAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupModelAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupModelAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsUserGroupTraitAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupTraitAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupTraitAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
};


/** columns and relationships of "segments" */
export type SegmentsVisualQueryFilterArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "segments" */
export type SegmentsAggregate = {
  __typename?: 'segments_aggregate';
  aggregate?: Maybe<SegmentsAggregateFields>;
  nodes: Array<Segments>;
};

export type SegmentsAggregateBoolExp = {
  bool_and?: InputMaybe<SegmentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SegmentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<SegmentsAggregateBoolExpCount>;
};

export type SegmentsAggregateBoolExpBoolAnd = {
  arguments: SegmentsSelectColumnSegmentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SegmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SegmentsAggregateBoolExpBoolOr = {
  arguments: SegmentsSelectColumnSegmentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SegmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SegmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SegmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "segments" */
export type SegmentsAggregateFields = {
  __typename?: 'segments_aggregate_fields';
  avg?: Maybe<SegmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SegmentsMaxFields>;
  min?: Maybe<SegmentsMinFields>;
  stddev?: Maybe<SegmentsStddevFields>;
  stddev_pop?: Maybe<SegmentsStddevPopFields>;
  stddev_samp?: Maybe<SegmentsStddevSampFields>;
  sum?: Maybe<SegmentsSumFields>;
  var_pop?: Maybe<SegmentsVarPopFields>;
  var_samp?: Maybe<SegmentsVarSampFields>;
  variance?: Maybe<SegmentsVarianceFields>;
};


/** aggregate fields of "segments" */
export type SegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "segments" */
export type SegmentsAggregateOrderBy = {
  avg?: InputMaybe<SegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SegmentsMaxOrderBy>;
  min?: InputMaybe<SegmentsMinOrderBy>;
  stddev?: InputMaybe<SegmentsStddevOrderBy>;
  stddev_pop?: InputMaybe<SegmentsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SegmentsStddevSampOrderBy>;
  sum?: InputMaybe<SegmentsSumOrderBy>;
  var_pop?: InputMaybe<SegmentsVarPopOrderBy>;
  var_samp?: InputMaybe<SegmentsVarSampOrderBy>;
  variance?: InputMaybe<SegmentsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SegmentsAppendInput = {
  custom_query?: InputMaybe<Scalars['jsonb']>;
  enrichment_schedule?: InputMaybe<Scalars['jsonb']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['jsonb']>;
  matchbooster_settings?: InputMaybe<Scalars['jsonb']>;
  query_integrations?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  visual_query_filter?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "segments" */
export type SegmentsArrRelInsertInput = {
  data: Array<SegmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SegmentsOnConflict>;
};

/** aggregate avg on columns */
export type SegmentsAvgFields = {
  __typename?: 'segments_avg_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "segments" */
export type SegmentsAvgOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "segments". All fields are combined with a logical 'AND'. */
export type SegmentsBoolExp = {
  _and?: InputMaybe<Array<SegmentsBoolExp>>;
  _not?: InputMaybe<SegmentsBoolExp>;
  _or?: InputMaybe<Array<SegmentsBoolExp>>;
  ad_stats?: InputMaybe<AdStatsModelsBoolExp>;
  analytics_report?: InputMaybe<AnalyticsReportsBoolExp>;
  approved_draft_id?: InputMaybe<UuidComparisonExp>;
  asset?: InputMaybe<AssetModelsBoolExp>;
  attribution_methods?: InputMaybe<AttributionMethodsBoolExp>;
  attribution_methods_aggregate?: InputMaybe<AttributionMethodsAggregateBoolExp>;
  audience_column_references?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
  audience_column_references_aggregate?: InputMaybe<ModelColumnReferencesSegmentsAggregateBoolExp>;
  audience_goals?: InputMaybe<AudienceGoalsBoolExp>;
  audience_goals_aggregate?: InputMaybe<AudienceGoalsAggregateBoolExp>;
  audience_overview?: InputMaybe<AudienceOverviewsBoolExp>;
  audience_primary_metrics?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
  audience_primary_metrics_aggregate?: InputMaybe<AudiencePrimaryMetricsAggregateBoolExp>;
  audience_templates_for_parent_model?: InputMaybe<AudienceTemplatesBoolExp>;
  audience_templates_for_parent_model_aggregate?: InputMaybe<AudienceTemplatesAggregateBoolExp>;
  audiences_for_parent_model?: InputMaybe<SegmentsBoolExp>;
  audiences_for_parent_model_aggregate?: InputMaybe<SegmentsAggregateBoolExp>;
  campaigns?: InputMaybe<CampaignsBoolExp>;
  campaigns_aggregate?: InputMaybe<CampaignsAggregateBoolExp>;
  catalog?: InputMaybe<CatalogModelsBoolExp>;
  cep_managed_model?: InputMaybe<CepManagedModelsBoolExp>;
  cep_workspace_config?: InputMaybe<CepWorkspaceConfigBoolExp>;
  channel_syncs?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
  columns?: InputMaybe<ModelColumnsBoolExp>;
  columns_aggregate?: InputMaybe<ModelColumnsAggregateBoolExp>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  custom_query?: InputMaybe<JsonbComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination_instances?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateBoolExp>;
  destination_rules?: InputMaybe<DestinationRulesBoolExp>;
  destination_rules_aggregate?: InputMaybe<DestinationRulesAggregateBoolExp>;
  draft?: InputMaybe<BooleanComparisonExp>;
  draftByApprovedDraftId?: InputMaybe<DraftsBoolExp>;
  enrichment_schedule?: InputMaybe<JsonbComparisonExp>;
  event?: InputMaybe<EventModelsBoolExp>;
  experiment?: InputMaybe<ExperimentsBoolExp>;
  flow_message?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
  folder?: InputMaybe<FoldersBoolExp>;
  folder_id?: InputMaybe<UuidComparisonExp>;
  git_sync_metadata?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  idr_output?: InputMaybe<IdrOutputSegmentsBoolExp>;
  interaction?: InputMaybe<InteractionModelsBoolExp>;
  is_general_model?: InputMaybe<BooleanComparisonExp>;
  is_realtime_audience?: InputMaybe<BooleanComparisonExp>;
  is_schema?: InputMaybe<BooleanComparisonExp>;
  is_streamable?: InputMaybe<BooleanComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_duplicate_primary_keys?: InputMaybe<IntComparisonExp>;
  last_run_size?: InputMaybe<IntComparisonExp>;
  llm_description?: InputMaybe<StringComparisonExp>;
  llm_description_job_id?: InputMaybe<UuidComparisonExp>;
  llm_description_job_status?: InputMaybe<StringComparisonExp>;
  llm_detailed_description_info?: InputMaybe<JsonbComparisonExp>;
  matchbooster_audience_filter?: InputMaybe<JsonbComparisonExp>;
  matchbooster_settings?: InputMaybe<JsonbComparisonExp>;
  matchboosting_enabled?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent?: InputMaybe<SegmentsBoolExp>;
  parent_model_goals?: InputMaybe<GoalsBoolExp>;
  parent_model_goals_aggregate?: InputMaybe<GoalsAggregateBoolExp>;
  predictor_feature_definitions?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
  primary_key?: InputMaybe<StringComparisonExp>;
  priority_list_memberships?: InputMaybe<PriorityListMembershipsBoolExp>;
  query_dbt_model?: InputMaybe<DbtSyncModelsBoolExp>;
  query_dbt_model_id?: InputMaybe<IntComparisonExp>;
  query_integrations?: InputMaybe<JsonbComparisonExp>;
  query_looker_look_id?: InputMaybe<StringComparisonExp>;
  query_raw_sql?: InputMaybe<StringComparisonExp>;
  query_runs?: InputMaybe<QueryRunsBoolExp>;
  query_table_name?: InputMaybe<StringComparisonExp>;
  query_type?: InputMaybe<StringComparisonExp>;
  realtime_audience_syncs?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
  realtime_audiences_scheduled_warehouse_pull?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsBoolExp>;
  realtime_audiences_warehouse_pull_runs?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
  realtime_audiences_warehouse_pull_runs_aggregate?: InputMaybe<RealtimeAudiencesWarehousePullRunsAggregateBoolExp>;
  realtime_enabled?: InputMaybe<BooleanComparisonExp>;
  relationships?: InputMaybe<ModelRelationshipsBoolExp>;
  required_subset_groups?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
  required_subset_groups_aggregate?: InputMaybe<AudienceSubsetGroupRequiredModelsAggregateBoolExp>;
  retl_and_realtime_syncs?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
  retl_and_realtime_syncs_aggregate?: InputMaybe<RetlAndRealtimeSyncsAggregateBoolExp>;
  sampled_segments?: InputMaybe<SampledSegmentsBoolExp>;
  sampled_segments_aggregate?: InputMaybe<SampledSegmentsAggregateBoolExp>;
  saved_query?: InputMaybe<SavedQueriesBoolExp>;
  saved_query_id?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  semantic_type?: InputMaybe<StringComparisonExp>;
  semantic_type_name_column?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  splits?: InputMaybe<AudienceSplitsBoolExp>;
  splits_aggregate?: InputMaybe<AudienceSplitsAggregateBoolExp>;
  static_list?: InputMaybe<StaticListsBoolExp>;
  subsets?: InputMaybe<AudiencesSubsetsBoolExp>;
  subsets_aggregate?: InputMaybe<AudiencesSubsetsAggregateBoolExp>;
  sync_templates?: InputMaybe<SyncTemplatesBoolExp>;
  sync_templates_aggregate?: InputMaybe<SyncTemplatesAggregateBoolExp>;
  syncs?: InputMaybe<SyncsBoolExp>;
  syncs_aggregate?: InputMaybe<SyncsAggregateBoolExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  traits?: InputMaybe<TraitDefinitionsBoolExp>;
  traits_aggregate?: InputMaybe<TraitDefinitionsAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user_group_audience_creation_authorization?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
  user_group_model_authorization?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
  user_group_trait_authorization?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
  visual_query_filter?: InputMaybe<JsonbComparisonExp>;
  visual_query_parent_id?: InputMaybe<BigintComparisonExp>;
  visual_query_primary_label?: InputMaybe<StringComparisonExp>;
  visual_query_secondary_label?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "segments" */
export const SegmentsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SegmentPkey: 'segment_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SegmentsIdWorkspaceIdKey: 'segments_id_workspace_id_key',
  /** unique or primary key constraint on columns "workspace_id", "visual_query_parent_id" */
  SegmentsRealtimeTraitWarehouseStateUnique: 'segments_realtime_trait_warehouse_state_unique',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  SegmentsSlugWorkspaceIdKey: 'segments_slug_workspace_id_key'
} as const;

export type SegmentsConstraint = typeof SegmentsConstraint[keyof typeof SegmentsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SegmentsDeleteAtPathInput = {
  custom_query?: InputMaybe<Array<Scalars['String']>>;
  enrichment_schedule?: InputMaybe<Array<Scalars['String']>>;
  matchbooster_audience_filter?: InputMaybe<Array<Scalars['String']>>;
  matchbooster_settings?: InputMaybe<Array<Scalars['String']>>;
  query_integrations?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  visual_query_filter?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SegmentsDeleteElemInput = {
  custom_query?: InputMaybe<Scalars['Int']>;
  enrichment_schedule?: InputMaybe<Scalars['Int']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['Int']>;
  matchbooster_settings?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
  visual_query_filter?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SegmentsDeleteKeyInput = {
  custom_query?: InputMaybe<Scalars['String']>;
  enrichment_schedule?: InputMaybe<Scalars['String']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['String']>;
  matchbooster_settings?: InputMaybe<Scalars['String']>;
  query_integrations?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  visual_query_filter?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "segments" */
export type SegmentsIncInput = {
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  saved_query_id?: InputMaybe<Scalars['bigint']>;
  visual_query_parent_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "segments" */
export type SegmentsInsertInput = {
  ad_stats?: InputMaybe<AdStatsModelsObjRelInsertInput>;
  analytics_report?: InputMaybe<AnalyticsReportsObjRelInsertInput>;
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  asset?: InputMaybe<AssetModelsObjRelInsertInput>;
  attribution_methods?: InputMaybe<AttributionMethodsArrRelInsertInput>;
  audience_goals?: InputMaybe<AudienceGoalsArrRelInsertInput>;
  audience_overview?: InputMaybe<AudienceOverviewsObjRelInsertInput>;
  audience_primary_metrics?: InputMaybe<AudiencePrimaryMetricsArrRelInsertInput>;
  audience_templates?: InputMaybe<AudienceTemplateSegmentsArrRelInsertInput>;
  audiences_for_parent_model?: InputMaybe<SegmentsArrRelInsertInput>;
  campaigns?: InputMaybe<CampaignsArrRelInsertInput>;
  catalog?: InputMaybe<CatalogModelsObjRelInsertInput>;
  cep_workspace_config?: InputMaybe<CepWorkspaceConfigObjRelInsertInput>;
  columns?: InputMaybe<ModelColumnsArrRelInsertInput>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_query?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  destination_instances?: InputMaybe<DestinationInstancesArrRelInsertInput>;
  destination_rules?: InputMaybe<DestinationRulesArrRelInsertInput>;
  draft?: InputMaybe<Scalars['Boolean']>;
  enrichment_schedule?: InputMaybe<Scalars['jsonb']>;
  event?: InputMaybe<EventModelsObjRelInsertInput>;
  experiment?: InputMaybe<ExperimentsObjRelInsertInput>;
  folder?: InputMaybe<FoldersObjRelInsertInput>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  git_sync_metadata?: InputMaybe<Scalars['jsonb']>;
  interaction?: InputMaybe<InteractionModelsObjRelInsertInput>;
  is_general_model?: InputMaybe<Scalars['Boolean']>;
  is_realtime_audience?: InputMaybe<Scalars['Boolean']>;
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: InputMaybe<Scalars['Boolean']>;
  is_streamable?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  llm_chat_session_id?: InputMaybe<Scalars['uuid']>;
  llm_description?: InputMaybe<Scalars['String']>;
  llm_detailed_description_info?: InputMaybe<Scalars['jsonb']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['jsonb']>;
  matchbooster_settings?: InputMaybe<Scalars['jsonb']>;
  matchboosting_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<SegmentsObjRelInsertInput>;
  parent_model_goals?: InputMaybe<GoalsArrRelInsertInput>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: InputMaybe<Scalars['String']>;
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['jsonb']>;
  query_looker_look_id?: InputMaybe<Scalars['String']>;
  query_raw_sql?: InputMaybe<Scalars['String']>;
  query_table_name?: InputMaybe<Scalars['String']>;
  query_type?: InputMaybe<Scalars['String']>;
  realtime_audience_syncs?: InputMaybe<RealtimeAudienceSyncsArrRelInsertInput>;
  realtime_enabled?: InputMaybe<Scalars['Boolean']>;
  relationships?: InputMaybe<ModelRelationshipsArrRelInsertInput>;
  required_subset_groups?: InputMaybe<AudienceSubsetGroupRequiredModelsArrRelInsertInput>;
  sampled_segments?: InputMaybe<SampledSegmentsArrRelInsertInput>;
  saved_query?: InputMaybe<SavedQueriesObjRelInsertInput>;
  saved_query_id?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  semantic_type_name_column?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  splits?: InputMaybe<AudienceSplitsArrRelInsertInput>;
  subsets?: InputMaybe<AudiencesSubsetsArrRelInsertInput>;
  sync_templates?: InputMaybe<SyncTemplatesArrRelInsertInput>;
  tags?: InputMaybe<Scalars['jsonb']>;
  traits?: InputMaybe<TraitDefinitionsArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
  visual_query_filter?: InputMaybe<Scalars['jsonb']>;
  visual_query_parent_id?: InputMaybe<Scalars['bigint']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SegmentsMaxFields = {
  __typename?: 'segments_max_fields';
  approved_draft_id?: Maybe<Scalars['uuid']>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Int']>;
  last_run_size?: Maybe<Scalars['Int']>;
  llm_description?: Maybe<Scalars['String']>;
  llm_description_job_id?: Maybe<Scalars['uuid']>;
  llm_description_job_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: Maybe<Scalars['String']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  query_looker_look_id?: Maybe<Scalars['String']>;
  query_raw_sql?: Maybe<Scalars['String']>;
  query_table_name?: Maybe<Scalars['String']>;
  query_type?: Maybe<Scalars['String']>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  semantic_type?: Maybe<Scalars['String']>;
  semantic_type_name_column?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  visual_query_parent_id?: Maybe<Scalars['bigint']>;
  visual_query_primary_label?: Maybe<Scalars['String']>;
  visual_query_secondary_label?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "segments" */
export type SegmentsMaxOrderBy = {
  approved_draft_id?: InputMaybe<OrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  llm_description_job_id?: InputMaybe<OrderBy>;
  llm_description_job_status?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  query_looker_look_id?: InputMaybe<OrderBy>;
  query_raw_sql?: InputMaybe<OrderBy>;
  query_table_name?: InputMaybe<OrderBy>;
  query_type?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  semantic_type_name_column?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  visual_query_primary_label?: InputMaybe<OrderBy>;
  visual_query_secondary_label?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SegmentsMinFields = {
  __typename?: 'segments_min_fields';
  approved_draft_id?: Maybe<Scalars['uuid']>;
  connection_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  folder_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Int']>;
  last_run_size?: Maybe<Scalars['Int']>;
  llm_description?: Maybe<Scalars['String']>;
  llm_description_job_id?: Maybe<Scalars['uuid']>;
  llm_description_job_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: Maybe<Scalars['String']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  query_looker_look_id?: Maybe<Scalars['String']>;
  query_raw_sql?: Maybe<Scalars['String']>;
  query_table_name?: Maybe<Scalars['String']>;
  query_type?: Maybe<Scalars['String']>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  semantic_type?: Maybe<Scalars['String']>;
  semantic_type_name_column?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  visual_query_parent_id?: Maybe<Scalars['bigint']>;
  visual_query_primary_label?: Maybe<Scalars['String']>;
  visual_query_secondary_label?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "segments" */
export type SegmentsMinOrderBy = {
  approved_draft_id?: InputMaybe<OrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  llm_description_job_id?: InputMaybe<OrderBy>;
  llm_description_job_status?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  query_looker_look_id?: InputMaybe<OrderBy>;
  query_raw_sql?: InputMaybe<OrderBy>;
  query_table_name?: InputMaybe<OrderBy>;
  query_type?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  semantic_type_name_column?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  visual_query_primary_label?: InputMaybe<OrderBy>;
  visual_query_secondary_label?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "segments" */
export type SegmentsMutationResponse = {
  __typename?: 'segments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Segments>;
};

/** input type for inserting object relation for remote table "segments" */
export type SegmentsObjRelInsertInput = {
  data: SegmentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SegmentsOnConflict>;
};

/** on_conflict condition type for table "segments" */
export type SegmentsOnConflict = {
  constraint: SegmentsConstraint;
  update_columns?: Array<SegmentsUpdateColumn>;
  where?: InputMaybe<SegmentsBoolExp>;
};

/** Ordering options when selecting data from "segments". */
export type SegmentsOrderBy = {
  ad_stats?: InputMaybe<AdStatsModelsOrderBy>;
  analytics_report?: InputMaybe<AnalyticsReportsOrderBy>;
  approved_draft_id?: InputMaybe<OrderBy>;
  asset?: InputMaybe<AssetModelsOrderBy>;
  attribution_methods_aggregate?: InputMaybe<AttributionMethodsAggregateOrderBy>;
  audience_column_references_aggregate?: InputMaybe<ModelColumnReferencesSegmentsAggregateOrderBy>;
  audience_goals_aggregate?: InputMaybe<AudienceGoalsAggregateOrderBy>;
  audience_overview?: InputMaybe<AudienceOverviewsOrderBy>;
  audience_primary_metrics_aggregate?: InputMaybe<AudiencePrimaryMetricsAggregateOrderBy>;
  audience_templates_for_parent_model_aggregate?: InputMaybe<AudienceTemplatesAggregateOrderBy>;
  audiences_for_parent_model_aggregate?: InputMaybe<SegmentsAggregateOrderBy>;
  campaigns_aggregate?: InputMaybe<CampaignsAggregateOrderBy>;
  catalog?: InputMaybe<CatalogModelsOrderBy>;
  cep_managed_model?: InputMaybe<CepManagedModelsOrderBy>;
  cep_workspace_config?: InputMaybe<CepWorkspaceConfigOrderBy>;
  channel_syncs?: InputMaybe<DecisionEngineFlowChannelSyncOrderBy>;
  columns_aggregate?: InputMaybe<ModelColumnsAggregateOrderBy>;
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  custom_query?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateOrderBy>;
  destination_rules_aggregate?: InputMaybe<DestinationRulesAggregateOrderBy>;
  draft?: InputMaybe<OrderBy>;
  draftByApprovedDraftId?: InputMaybe<DraftsOrderBy>;
  enrichment_schedule?: InputMaybe<OrderBy>;
  event?: InputMaybe<EventModelsOrderBy>;
  experiment?: InputMaybe<ExperimentsOrderBy>;
  flow_message?: InputMaybe<DecisionEngineFlowMessagesOrderBy>;
  folder?: InputMaybe<FoldersOrderBy>;
  folder_id?: InputMaybe<OrderBy>;
  git_sync_metadata?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_output?: InputMaybe<IdrOutputSegmentsOrderBy>;
  interaction?: InputMaybe<InteractionModelsOrderBy>;
  is_general_model?: InputMaybe<OrderBy>;
  is_realtime_audience?: InputMaybe<OrderBy>;
  is_schema?: InputMaybe<OrderBy>;
  is_streamable?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  llm_description?: InputMaybe<OrderBy>;
  llm_description_job_id?: InputMaybe<OrderBy>;
  llm_description_job_status?: InputMaybe<OrderBy>;
  llm_detailed_description_info?: InputMaybe<OrderBy>;
  matchbooster_audience_filter?: InputMaybe<OrderBy>;
  matchbooster_settings?: InputMaybe<OrderBy>;
  matchboosting_enabled?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent?: InputMaybe<SegmentsOrderBy>;
  parent_model_goals_aggregate?: InputMaybe<GoalsAggregateOrderBy>;
  predictor_feature_definitions_aggregate?: InputMaybe<PredictorFeatureDefinitionsAggregateOrderBy>;
  primary_key?: InputMaybe<OrderBy>;
  priority_list_memberships_aggregate?: InputMaybe<PriorityListMembershipsAggregateOrderBy>;
  query_dbt_model?: InputMaybe<DbtSyncModelsOrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  query_integrations?: InputMaybe<OrderBy>;
  query_looker_look_id?: InputMaybe<OrderBy>;
  query_raw_sql?: InputMaybe<OrderBy>;
  query_runs_aggregate?: InputMaybe<QueryRunsAggregateOrderBy>;
  query_table_name?: InputMaybe<OrderBy>;
  query_type?: InputMaybe<OrderBy>;
  realtime_audience_syncs_aggregate?: InputMaybe<RealtimeAudienceSyncsAggregateOrderBy>;
  realtime_audiences_scheduled_warehouse_pull?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsOrderBy>;
  realtime_audiences_warehouse_pull_runs_aggregate?: InputMaybe<RealtimeAudiencesWarehousePullRunsAggregateOrderBy>;
  realtime_enabled?: InputMaybe<OrderBy>;
  relationships_aggregate?: InputMaybe<ModelRelationshipsAggregateOrderBy>;
  required_subset_groups_aggregate?: InputMaybe<AudienceSubsetGroupRequiredModelsAggregateOrderBy>;
  retl_and_realtime_syncs_aggregate?: InputMaybe<RetlAndRealtimeSyncsAggregateOrderBy>;
  sampled_segments_aggregate?: InputMaybe<SampledSegmentsAggregateOrderBy>;
  saved_query?: InputMaybe<SavedQueriesOrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  semantic_type?: InputMaybe<OrderBy>;
  semantic_type_name_column?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  splits_aggregate?: InputMaybe<AudienceSplitsAggregateOrderBy>;
  static_list?: InputMaybe<StaticListsOrderBy>;
  subsets_aggregate?: InputMaybe<AudiencesSubsetsAggregateOrderBy>;
  sync_templates_aggregate?: InputMaybe<SyncTemplatesAggregateOrderBy>;
  syncs_aggregate?: InputMaybe<SyncsAggregateOrderBy>;
  tags?: InputMaybe<OrderBy>;
  traits_aggregate?: InputMaybe<TraitDefinitionsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  user_group_audience_creation_authorization_aggregate?: InputMaybe<UserGroupAudienceCreationAuthorizationAggregateOrderBy>;
  user_group_model_authorization_aggregate?: InputMaybe<UserGroupModelAuthorizationAggregateOrderBy>;
  user_group_trait_authorization_aggregate?: InputMaybe<UserGroupTraitAuthorizationAggregateOrderBy>;
  visual_query_filter?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  visual_query_primary_label?: InputMaybe<OrderBy>;
  visual_query_secondary_label?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: segments */
export type SegmentsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SegmentsPrependInput = {
  custom_query?: InputMaybe<Scalars['jsonb']>;
  enrichment_schedule?: InputMaybe<Scalars['jsonb']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['jsonb']>;
  matchbooster_settings?: InputMaybe<Scalars['jsonb']>;
  query_integrations?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  visual_query_filter?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "segments" */
export const SegmentsSelectColumn = {
  /** column name */
  ApprovedDraftId: 'approved_draft_id',
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  CustomQuery: 'custom_query',
  /** column name */
  Description: 'description',
  /** column name */
  Draft: 'draft',
  /** column name */
  EnrichmentSchedule: 'enrichment_schedule',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  GitSyncMetadata: 'git_sync_metadata',
  /** column name */
  Id: 'id',
  /** column name */
  IsGeneralModel: 'is_general_model',
  /** column name */
  IsRealtimeAudience: 'is_realtime_audience',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  IsStreamable: 'is_streamable',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunDuplicatePrimaryKeys: 'last_run_duplicate_primary_keys',
  /** column name */
  LastRunSize: 'last_run_size',
  /** column name */
  LlmDescription: 'llm_description',
  /** column name */
  LlmDescriptionJobId: 'llm_description_job_id',
  /** column name */
  LlmDescriptionJobStatus: 'llm_description_job_status',
  /** column name */
  LlmDetailedDescriptionInfo: 'llm_detailed_description_info',
  /** column name */
  MatchboosterAudienceFilter: 'matchbooster_audience_filter',
  /** column name */
  MatchboosterSettings: 'matchbooster_settings',
  /** column name */
  MatchboostingEnabled: 'matchboosting_enabled',
  /** column name */
  Name: 'name',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  QueryDbtModelId: 'query_dbt_model_id',
  /** column name */
  QueryIntegrations: 'query_integrations',
  /** column name */
  QueryLookerLookId: 'query_looker_look_id',
  /** column name */
  QueryRawSql: 'query_raw_sql',
  /** column name */
  QueryTableName: 'query_table_name',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  RealtimeEnabled: 'realtime_enabled',
  /** column name */
  SavedQueryId: 'saved_query_id',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SemanticType: 'semantic_type',
  /** column name */
  SemanticTypeNameColumn: 'semantic_type_name_column',
  /** column name */
  Slug: 'slug',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  VisualQueryFilter: 'visual_query_filter',
  /** column name */
  VisualQueryParentId: 'visual_query_parent_id',
  /** column name */
  VisualQueryPrimaryLabel: 'visual_query_primary_label',
  /** column name */
  VisualQuerySecondaryLabel: 'visual_query_secondary_label',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SegmentsSelectColumn = typeof SegmentsSelectColumn[keyof typeof SegmentsSelectColumn];
/** select "segments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "segments" */
export const SegmentsSelectColumnSegmentsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Draft: 'draft',
  /** column name */
  IsGeneralModel: 'is_general_model',
  /** column name */
  IsRealtimeAudience: 'is_realtime_audience',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  IsStreamable: 'is_streamable',
  /** column name */
  MatchboostingEnabled: 'matchboosting_enabled',
  /** column name */
  RealtimeEnabled: 'realtime_enabled',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SegmentsSelectColumnSegmentsAggregateBoolExpBoolAndArgumentsColumns = typeof SegmentsSelectColumnSegmentsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof SegmentsSelectColumnSegmentsAggregateBoolExpBoolAndArgumentsColumns];
/** select "segments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "segments" */
export const SegmentsSelectColumnSegmentsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Draft: 'draft',
  /** column name */
  IsGeneralModel: 'is_general_model',
  /** column name */
  IsRealtimeAudience: 'is_realtime_audience',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  IsStreamable: 'is_streamable',
  /** column name */
  MatchboostingEnabled: 'matchboosting_enabled',
  /** column name */
  RealtimeEnabled: 'realtime_enabled',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SegmentsSelectColumnSegmentsAggregateBoolExpBoolOrArgumentsColumns = typeof SegmentsSelectColumnSegmentsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof SegmentsSelectColumnSegmentsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "segments" */
export type SegmentsSetInput = {
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  custom_query?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  enrichment_schedule?: InputMaybe<Scalars['jsonb']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  is_general_model?: InputMaybe<Scalars['Boolean']>;
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: InputMaybe<Scalars['Boolean']>;
  is_streamable?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['jsonb']>;
  matchbooster_settings?: InputMaybe<Scalars['jsonb']>;
  matchboosting_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: InputMaybe<Scalars['String']>;
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['jsonb']>;
  query_looker_look_id?: InputMaybe<Scalars['String']>;
  query_raw_sql?: InputMaybe<Scalars['String']>;
  query_table_name?: InputMaybe<Scalars['String']>;
  query_type?: InputMaybe<Scalars['String']>;
  realtime_enabled?: InputMaybe<Scalars['Boolean']>;
  saved_query_id?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  semantic_type_name_column?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visual_query_filter?: InputMaybe<Scalars['jsonb']>;
  visual_query_parent_id?: InputMaybe<Scalars['bigint']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SegmentsStddevFields = {
  __typename?: 'segments_stddev_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "segments" */
export type SegmentsStddevOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SegmentsStddevPopFields = {
  __typename?: 'segments_stddev_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "segments" */
export type SegmentsStddevPopOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SegmentsStddevSampFields = {
  __typename?: 'segments_stddev_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "segments" */
export type SegmentsStddevSampOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "segments" */
export type SegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SegmentsStreamCursorValueInput = {
  approved_draft_id?: InputMaybe<Scalars['uuid']>;
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  custom_query?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  enrichment_schedule?: InputMaybe<Scalars['jsonb']>;
  folder_id?: InputMaybe<Scalars['uuid']>;
  git_sync_metadata?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_general_model?: InputMaybe<Scalars['Boolean']>;
  is_realtime_audience?: InputMaybe<Scalars['Boolean']>;
  /** If is_schema is true, the model is just used to build other models. Either as part of visual querying, or as the root of a visual query. */
  is_schema?: InputMaybe<Scalars['Boolean']>;
  is_streamable?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_duplicate_primary_keys?: InputMaybe<Scalars['Int']>;
  last_run_size?: InputMaybe<Scalars['Int']>;
  llm_description?: InputMaybe<Scalars['String']>;
  llm_description_job_id?: InputMaybe<Scalars['uuid']>;
  llm_description_job_status?: InputMaybe<Scalars['String']>;
  llm_detailed_description_info?: InputMaybe<Scalars['jsonb']>;
  matchbooster_audience_filter?: InputMaybe<Scalars['jsonb']>;
  matchbooster_settings?: InputMaybe<Scalars['jsonb']>;
  matchboosting_enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** The primary key will be null if the query doesn't get directly synced (e.g. a relationship table for visual querying) */
  primary_key?: InputMaybe<Scalars['String']>;
  query_dbt_model_id?: InputMaybe<Scalars['Int']>;
  query_integrations?: InputMaybe<Scalars['jsonb']>;
  query_looker_look_id?: InputMaybe<Scalars['String']>;
  query_raw_sql?: InputMaybe<Scalars['String']>;
  query_table_name?: InputMaybe<Scalars['String']>;
  query_type?: InputMaybe<Scalars['String']>;
  realtime_enabled?: InputMaybe<Scalars['Boolean']>;
  saved_query_id?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  semantic_type?: InputMaybe<Scalars['String']>;
  semantic_type_name_column?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  visual_query_filter?: InputMaybe<Scalars['jsonb']>;
  visual_query_parent_id?: InputMaybe<Scalars['bigint']>;
  visual_query_primary_label?: InputMaybe<Scalars['String']>;
  visual_query_secondary_label?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SegmentsSumFields = {
  __typename?: 'segments_sum_fields';
  connection_id?: Maybe<Scalars['bigint']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Int']>;
  last_run_size?: Maybe<Scalars['Int']>;
  query_dbt_model_id?: Maybe<Scalars['Int']>;
  saved_query_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  visual_query_parent_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "segments" */
export type SegmentsSumOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "segments" */
export const SegmentsUpdateColumn = {
  /** column name */
  ApprovedDraftId: 'approved_draft_id',
  /** column name */
  CustomQuery: 'custom_query',
  /** column name */
  Description: 'description',
  /** column name */
  Draft: 'draft',
  /** column name */
  EnrichmentSchedule: 'enrichment_schedule',
  /** column name */
  FolderId: 'folder_id',
  /** column name */
  IsGeneralModel: 'is_general_model',
  /** column name */
  IsSchema: 'is_schema',
  /** column name */
  IsStreamable: 'is_streamable',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  MatchboosterAudienceFilter: 'matchbooster_audience_filter',
  /** column name */
  MatchboosterSettings: 'matchbooster_settings',
  /** column name */
  MatchboostingEnabled: 'matchboosting_enabled',
  /** column name */
  Name: 'name',
  /** column name */
  PrimaryKey: 'primary_key',
  /** column name */
  QueryDbtModelId: 'query_dbt_model_id',
  /** column name */
  QueryIntegrations: 'query_integrations',
  /** column name */
  QueryLookerLookId: 'query_looker_look_id',
  /** column name */
  QueryRawSql: 'query_raw_sql',
  /** column name */
  QueryTableName: 'query_table_name',
  /** column name */
  QueryType: 'query_type',
  /** column name */
  RealtimeEnabled: 'realtime_enabled',
  /** column name */
  SavedQueryId: 'saved_query_id',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SemanticType: 'semantic_type',
  /** column name */
  SemanticTypeNameColumn: 'semantic_type_name_column',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  VisualQueryFilter: 'visual_query_filter',
  /** column name */
  VisualQueryParentId: 'visual_query_parent_id',
  /** column name */
  VisualQueryPrimaryLabel: 'visual_query_primary_label',
  /** column name */
  VisualQuerySecondaryLabel: 'visual_query_secondary_label'
} as const;

export type SegmentsUpdateColumn = typeof SegmentsUpdateColumn[keyof typeof SegmentsUpdateColumn];
export type SegmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SegmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SegmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SegmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SegmentsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SegmentsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SegmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SegmentsSetInput>;
  /** filter the rows which have to be updated */
  where: SegmentsBoolExp;
};

/** aggregate var_pop on columns */
export type SegmentsVarPopFields = {
  __typename?: 'segments_var_pop_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "segments" */
export type SegmentsVarPopOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SegmentsVarSampFields = {
  __typename?: 'segments_var_samp_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "segments" */
export type SegmentsVarSampOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SegmentsVarianceFields = {
  __typename?: 'segments_variance_fields';
  connection_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  last_run_duplicate_primary_keys?: Maybe<Scalars['Float']>;
  last_run_size?: Maybe<Scalars['Float']>;
  query_dbt_model_id?: Maybe<Scalars['Float']>;
  saved_query_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  visual_query_parent_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "segments" */
export type SegmentsVarianceOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_duplicate_primary_keys?: InputMaybe<OrderBy>;
  last_run_size?: InputMaybe<OrderBy>;
  query_dbt_model_id?: InputMaybe<OrderBy>;
  saved_query_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  visual_query_parent_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sent_resource_notifications" */
export type SentResourceNotifications = {
  __typename?: 'sent_resource_notifications';
  channel_template_id?: Maybe<Scalars['uuid']>;
  condition_status_id?: Maybe<Scalars['uuid']>;
  error?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An object relationship */
  notification_channel_template?: Maybe<NotificationChannelTemplates>;
  resource_channel_id?: Maybe<Scalars['uuid']>;
  resource_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  resource_notification_channel?: Maybe<ResourceNotificationChannels>;
  resource_status_id?: Maybe<Scalars['uuid']>;
  resource_type: Scalars['String'];
  sent_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace_notification_channel?: Maybe<WorkspaceNotificationChannels>;
};


/** columns and relationships of "sent_resource_notifications" */
export type SentResourceNotificationsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "sent_resource_notifications" */
export type SentResourceNotificationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SentResourceNotificationsMaxOrderBy>;
  min?: InputMaybe<SentResourceNotificationsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "sent_resource_notifications". All fields are combined with a logical 'AND'. */
export type SentResourceNotificationsBoolExp = {
  _and?: InputMaybe<Array<SentResourceNotificationsBoolExp>>;
  _not?: InputMaybe<SentResourceNotificationsBoolExp>;
  _or?: InputMaybe<Array<SentResourceNotificationsBoolExp>>;
  channel_template_id?: InputMaybe<UuidComparisonExp>;
  condition_status_id?: InputMaybe<UuidComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notification_channel_template?: InputMaybe<NotificationChannelTemplatesBoolExp>;
  resource_channel_id?: InputMaybe<UuidComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_notification_channel?: InputMaybe<ResourceNotificationChannelsBoolExp>;
  resource_status_id?: InputMaybe<UuidComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  sent_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};

/** order by max() on columns of table "sent_resource_notifications" */
export type SentResourceNotificationsMaxOrderBy = {
  channel_template_id?: InputMaybe<OrderBy>;
  condition_status_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_channel_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_status_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sent_resource_notifications" */
export type SentResourceNotificationsMinOrderBy = {
  channel_template_id?: InputMaybe<OrderBy>;
  condition_status_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_channel_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_status_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sent_resource_notifications". */
export type SentResourceNotificationsOrderBy = {
  channel_template_id?: InputMaybe<OrderBy>;
  condition_status_id?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notification_channel_template?: InputMaybe<NotificationChannelTemplatesOrderBy>;
  resource_channel_id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_notification_channel?: InputMaybe<ResourceNotificationChannelsOrderBy>;
  resource_status_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  sent_at?: InputMaybe<OrderBy>;
  workspace_notification_channel?: InputMaybe<WorkspaceNotificationChannelsOrderBy>;
};

/** select columns of table "sent_resource_notifications" */
export const SentResourceNotificationsSelectColumn = {
  /** column name */
  ChannelTemplateId: 'channel_template_id',
  /** column name */
  ConditionStatusId: 'condition_status_id',
  /** column name */
  Error: 'error',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceChannelId: 'resource_channel_id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceStatusId: 'resource_status_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  SentAt: 'sent_at'
} as const;

export type SentResourceNotificationsSelectColumn = typeof SentResourceNotificationsSelectColumn[keyof typeof SentResourceNotificationsSelectColumn];
/** Streaming cursor of the table "sent_resource_notifications" */
export type SentResourceNotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SentResourceNotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SentResourceNotificationsStreamCursorValueInput = {
  channel_template_id?: InputMaybe<Scalars['uuid']>;
  condition_status_id?: InputMaybe<Scalars['uuid']>;
  error?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_channel_id?: InputMaybe<Scalars['uuid']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_status_id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  sent_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "sigma_credentials" */
export type SigmaCredentials = {
  __typename?: 'sigma_credentials';
  client_id: Scalars['String'];
  cloud: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "sigma_credentials". All fields are combined with a logical 'AND'. */
export type SigmaCredentialsBoolExp = {
  _and?: InputMaybe<Array<SigmaCredentialsBoolExp>>;
  _not?: InputMaybe<SigmaCredentialsBoolExp>;
  _or?: InputMaybe<Array<SigmaCredentialsBoolExp>>;
  client_id?: InputMaybe<StringComparisonExp>;
  cloud?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "sigma_credentials". */
export type SigmaCredentialsOrderBy = {
  client_id?: InputMaybe<OrderBy>;
  cloud?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sigma_credentials" */
export const SigmaCredentialsSelectColumn = {
  /** column name */
  ClientId: 'client_id',
  /** column name */
  Cloud: 'cloud',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SigmaCredentialsSelectColumn = typeof SigmaCredentialsSelectColumn[keyof typeof SigmaCredentialsSelectColumn];
/** Streaming cursor of the table "sigma_credentials" */
export type SigmaCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SigmaCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SigmaCredentialsStreamCursorValueInput = {
  client_id?: InputMaybe<Scalars['String']>;
  cloud?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "slack_credentials" */
export type SlackCredentials = {
  __typename?: 'slack_credentials';
  channel_id?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  state: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
};

/** Boolean expression to filter rows from the table "slack_credentials". All fields are combined with a logical 'AND'. */
export type SlackCredentialsBoolExp = {
  _and?: InputMaybe<Array<SlackCredentialsBoolExp>>;
  _not?: InputMaybe<SlackCredentialsBoolExp>;
  _or?: InputMaybe<Array<SlackCredentialsBoolExp>>;
  channel_id?: InputMaybe<StringComparisonExp>;
  channel_name?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
};

/** response of any mutation on the table "slack_credentials" */
export type SlackCredentialsMutationResponse = {
  __typename?: 'slack_credentials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SlackCredentials>;
};

/** Ordering options when selecting data from "slack_credentials". */
export type SlackCredentialsOrderBy = {
  channel_id?: InputMaybe<OrderBy>;
  channel_name?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
};

/** primary key columns input for table: slack_credentials */
export type SlackCredentialsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "slack_credentials" */
export const SlackCredentialsSelectColumn = {
  /** column name */
  ChannelId: 'channel_id',
  /** column name */
  ChannelName: 'channel_name',
  /** column name */
  Id: 'id',
  /** column name */
  State: 'state'
} as const;

export type SlackCredentialsSelectColumn = typeof SlackCredentialsSelectColumn[keyof typeof SlackCredentialsSelectColumn];
/** input type for updating data in table "slack_credentials" */
export type SlackCredentialsSetInput = {
  channel_id?: InputMaybe<Scalars['String']>;
  channel_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "slack_credentials" */
export type SlackCredentialsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SlackCredentialsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SlackCredentialsStreamCursorValueInput = {
  channel_id?: InputMaybe<Scalars['String']>;
  channel_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};

export type SlackCredentialsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SlackCredentialsSetInput>;
  /** filter the rows which have to be updated */
  where: SlackCredentialsBoolExp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "source_share_mirror_databases" */
export type SourceShareMirrorDatabases = {
  __typename?: 'source_share_mirror_databases';
  /** An object relationship */
  connection?: Maybe<Connections>;
  connection_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  database_name: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  mirror_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  share_mirror: SourceShareMirrors;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesAggregateOrderBy = {
  avg?: InputMaybe<SourceShareMirrorDatabasesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SourceShareMirrorDatabasesMaxOrderBy>;
  min?: InputMaybe<SourceShareMirrorDatabasesMinOrderBy>;
  stddev?: InputMaybe<SourceShareMirrorDatabasesStddevOrderBy>;
  stddev_pop?: InputMaybe<SourceShareMirrorDatabasesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SourceShareMirrorDatabasesStddevSampOrderBy>;
  sum?: InputMaybe<SourceShareMirrorDatabasesSumOrderBy>;
  var_pop?: InputMaybe<SourceShareMirrorDatabasesVarPopOrderBy>;
  var_samp?: InputMaybe<SourceShareMirrorDatabasesVarSampOrderBy>;
  variance?: InputMaybe<SourceShareMirrorDatabasesVarianceOrderBy>;
};

/** order by avg() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesAvgOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "source_share_mirror_databases". All fields are combined with a logical 'AND'. */
export type SourceShareMirrorDatabasesBoolExp = {
  _and?: InputMaybe<Array<SourceShareMirrorDatabasesBoolExp>>;
  _not?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
  _or?: InputMaybe<Array<SourceShareMirrorDatabasesBoolExp>>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  database_name?: InputMaybe<StringComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  mirror_name?: InputMaybe<StringComparisonExp>;
  share_mirror?: InputMaybe<SourceShareMirrorsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesMaxOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  database_name?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  mirror_name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesMinOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  database_name?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  mirror_name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "source_share_mirror_databases". */
export type SourceShareMirrorDatabasesOrderBy = {
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  database_name?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  mirror_name?: InputMaybe<OrderBy>;
  share_mirror?: InputMaybe<SourceShareMirrorsOrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "source_share_mirror_databases" */
export const SourceShareMirrorDatabasesSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DatabaseName: 'database_name',
  /** column name */
  Error: 'error',
  /** column name */
  MirrorName: 'mirror_name',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SourceShareMirrorDatabasesSelectColumn = typeof SourceShareMirrorDatabasesSelectColumn[keyof typeof SourceShareMirrorDatabasesSelectColumn];
/** order by stddev() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesStddevOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesStddevPopOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesStddevSampOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SourceShareMirrorDatabasesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SourceShareMirrorDatabasesStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  database_name?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  mirror_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesSumOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesVarPopOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesVarSampOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "source_share_mirror_databases" */
export type SourceShareMirrorDatabasesVarianceOrderBy = {
  connection_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "source_share_mirrors" */
export type SourceShareMirrors = {
  __typename?: 'source_share_mirrors';
  /** An object relationship */
  connection: Connections;
  connection_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  /** An array relationship */
  databases: Array<SourceShareMirrorDatabases>;
  error?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updater?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "source_share_mirrors" */
export type SourceShareMirrorsDatabasesArgs = {
  distinct_on?: InputMaybe<Array<SourceShareMirrorDatabasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SourceShareMirrorDatabasesOrderBy>>;
  where?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
};

/** Boolean expression to filter rows from the table "source_share_mirrors". All fields are combined with a logical 'AND'. */
export type SourceShareMirrorsBoolExp = {
  _and?: InputMaybe<Array<SourceShareMirrorsBoolExp>>;
  _not?: InputMaybe<SourceShareMirrorsBoolExp>;
  _or?: InputMaybe<Array<SourceShareMirrorsBoolExp>>;
  connection?: InputMaybe<ConnectionsBoolExp>;
  connection_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  creator?: InputMaybe<UsersBoolExp>;
  databases?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
  error?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updater?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "source_share_mirrors". */
export type SourceShareMirrorsOrderBy = {
  connection?: InputMaybe<ConnectionsOrderBy>;
  connection_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  creator?: InputMaybe<UsersOrderBy>;
  databases_aggregate?: InputMaybe<SourceShareMirrorDatabasesAggregateOrderBy>;
  error?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updater?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "source_share_mirrors" */
export const SourceShareMirrorsSelectColumn = {
  /** column name */
  ConnectionId: 'connection_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Error: 'error',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SourceShareMirrorsSelectColumn = typeof SourceShareMirrorsSelectColumn[keyof typeof SourceShareMirrorsSelectColumn];
/** Streaming cursor of the table "source_share_mirrors" */
export type SourceShareMirrorsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SourceShareMirrorsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SourceShareMirrorsStreamCursorValueInput = {
  connection_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  error?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "space_subset_grants" */
export type SpaceSubsetGrants = {
  __typename?: 'space_subset_grants';
  id: Scalars['uuid'];
  space_id: Scalars['uuid'];
  subset_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "space_subset_grants" */
export type SpaceSubsetGrantsAggregateOrderBy = {
  avg?: InputMaybe<SpaceSubsetGrantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SpaceSubsetGrantsMaxOrderBy>;
  min?: InputMaybe<SpaceSubsetGrantsMinOrderBy>;
  stddev?: InputMaybe<SpaceSubsetGrantsStddevOrderBy>;
  stddev_pop?: InputMaybe<SpaceSubsetGrantsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SpaceSubsetGrantsStddevSampOrderBy>;
  sum?: InputMaybe<SpaceSubsetGrantsSumOrderBy>;
  var_pop?: InputMaybe<SpaceSubsetGrantsVarPopOrderBy>;
  var_samp?: InputMaybe<SpaceSubsetGrantsVarSampOrderBy>;
  variance?: InputMaybe<SpaceSubsetGrantsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "space_subset_grants" */
export type SpaceSubsetGrantsArrRelInsertInput = {
  data: Array<SpaceSubsetGrantsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SpaceSubsetGrantsOnConflict>;
};

/** order by avg() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "space_subset_grants". All fields are combined with a logical 'AND'. */
export type SpaceSubsetGrantsBoolExp = {
  _and?: InputMaybe<Array<SpaceSubsetGrantsBoolExp>>;
  _not?: InputMaybe<SpaceSubsetGrantsBoolExp>;
  _or?: InputMaybe<Array<SpaceSubsetGrantsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  subset_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "space_subset_grants" */
export const SpaceSubsetGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SpaceSubsetGrantsPkey: 'space_subset_grants_pkey',
  /** unique or primary key constraint on columns "subset_id", "space_id" */
  SpaceSubsetGrantsUnique: 'space_subset_grants_unique'
} as const;

export type SpaceSubsetGrantsConstraint = typeof SpaceSubsetGrantsConstraint[keyof typeof SpaceSubsetGrantsConstraint];
/** input type for inserting data into table "space_subset_grants" */
export type SpaceSubsetGrantsInsertInput = {
  space_id?: InputMaybe<Scalars['uuid']>;
  subset_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "space_subset_grants" */
export type SpaceSubsetGrantsMutationResponse = {
  __typename?: 'space_subset_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SpaceSubsetGrants>;
};

/** on_conflict condition type for table "space_subset_grants" */
export type SpaceSubsetGrantsOnConflict = {
  constraint: SpaceSubsetGrantsConstraint;
  update_columns?: Array<SpaceSubsetGrantsUpdateColumn>;
  where?: InputMaybe<SpaceSubsetGrantsBoolExp>;
};

/** Ordering options when selecting data from "space_subset_grants". */
export type SpaceSubsetGrantsOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "space_subset_grants" */
export const SpaceSubsetGrantsSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  SubsetId: 'subset_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SpaceSubsetGrantsSelectColumn = typeof SpaceSubsetGrantsSelectColumn[keyof typeof SpaceSubsetGrantsSelectColumn];
/** order by stddev() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "space_subset_grants" */
export type SpaceSubsetGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SpaceSubsetGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SpaceSubsetGrantsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  subset_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "space_subset_grants" (current role has no relevant permissions) */
export const SpaceSubsetGrantsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type SpaceSubsetGrantsUpdateColumn = typeof SpaceSubsetGrantsUpdateColumn[keyof typeof SpaceSubsetGrantsUpdateColumn];
/** order by var_pop() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "space_subset_grants" */
export type SpaceSubsetGrantsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "space_sync_templates" */
export type SpaceSyncTemplates = {
  __typename?: 'space_sync_templates';
  id: Scalars['uuid'];
  organization_id: Scalars['bigint'];
  /** An object relationship */
  space: Spaces;
  space_id: Scalars['uuid'];
  sync_template_id: Scalars['Int'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "space_sync_templates" */
export type SpaceSyncTemplatesAggregateOrderBy = {
  avg?: InputMaybe<SpaceSyncTemplatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SpaceSyncTemplatesMaxOrderBy>;
  min?: InputMaybe<SpaceSyncTemplatesMinOrderBy>;
  stddev?: InputMaybe<SpaceSyncTemplatesStddevOrderBy>;
  stddev_pop?: InputMaybe<SpaceSyncTemplatesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SpaceSyncTemplatesStddevSampOrderBy>;
  sum?: InputMaybe<SpaceSyncTemplatesSumOrderBy>;
  var_pop?: InputMaybe<SpaceSyncTemplatesVarPopOrderBy>;
  var_samp?: InputMaybe<SpaceSyncTemplatesVarSampOrderBy>;
  variance?: InputMaybe<SpaceSyncTemplatesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "space_sync_templates" */
export type SpaceSyncTemplatesArrRelInsertInput = {
  data: Array<SpaceSyncTemplatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SpaceSyncTemplatesOnConflict>;
};

/** order by avg() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesAvgOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "space_sync_templates". All fields are combined with a logical 'AND'. */
export type SpaceSyncTemplatesBoolExp = {
  _and?: InputMaybe<Array<SpaceSyncTemplatesBoolExp>>;
  _not?: InputMaybe<SpaceSyncTemplatesBoolExp>;
  _or?: InputMaybe<Array<SpaceSyncTemplatesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  space?: InputMaybe<SpacesBoolExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "space_sync_templates" */
export const SpaceSyncTemplatesConstraint = {
  /** unique or primary key constraint on columns "id" */
  SpaceSyncTemplatesPkey: 'space_sync_templates_pkey',
  /** unique or primary key constraint on columns "sync_template_id", "space_id" */
  SpaceSyncTemplatesUnique: 'space_sync_templates_unique'
} as const;

export type SpaceSyncTemplatesConstraint = typeof SpaceSyncTemplatesConstraint[keyof typeof SpaceSyncTemplatesConstraint];
/** input type for inserting data into table "space_sync_templates" */
export type SpaceSyncTemplatesInsertInput = {
  space?: InputMaybe<SpacesObjRelInsertInput>;
  space_id?: InputMaybe<Scalars['uuid']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "space_sync_templates" */
export type SpaceSyncTemplatesMutationResponse = {
  __typename?: 'space_sync_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SpaceSyncTemplates>;
};

/** on_conflict condition type for table "space_sync_templates" */
export type SpaceSyncTemplatesOnConflict = {
  constraint: SpaceSyncTemplatesConstraint;
  update_columns?: Array<SpaceSyncTemplatesUpdateColumn>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};

/** Ordering options when selecting data from "space_sync_templates". */
export type SpaceSyncTemplatesOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  space?: InputMaybe<SpacesOrderBy>;
  space_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "space_sync_templates" */
export const SpaceSyncTemplatesSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SpaceSyncTemplatesSelectColumn = typeof SpaceSyncTemplatesSelectColumn[keyof typeof SpaceSyncTemplatesSelectColumn];
/** order by stddev() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesStddevOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesStddevPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesStddevSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "space_sync_templates" */
export type SpaceSyncTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SpaceSyncTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SpaceSyncTemplatesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesSumOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "space_sync_templates" (current role has no relevant permissions) */
export const SpaceSyncTemplatesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type SpaceSyncTemplatesUpdateColumn = typeof SpaceSyncTemplatesUpdateColumn[keyof typeof SpaceSyncTemplatesUpdateColumn];
/** order by var_pop() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesVarPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesVarSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "space_sync_templates" */
export type SpaceSyncTemplatesVarianceOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "space_user_groups" */
export type SpaceUserGroups = {
  __typename?: 'space_user_groups';
  id: Scalars['uuid'];
  space_id: Scalars['uuid'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspaces?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "space_user_groups" */
export type SpaceUserGroupsAggregateOrderBy = {
  avg?: InputMaybe<SpaceUserGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SpaceUserGroupsMaxOrderBy>;
  min?: InputMaybe<SpaceUserGroupsMinOrderBy>;
  stddev?: InputMaybe<SpaceUserGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<SpaceUserGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SpaceUserGroupsStddevSampOrderBy>;
  sum?: InputMaybe<SpaceUserGroupsSumOrderBy>;
  var_pop?: InputMaybe<SpaceUserGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<SpaceUserGroupsVarSampOrderBy>;
  variance?: InputMaybe<SpaceUserGroupsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "space_user_groups" */
export type SpaceUserGroupsArrRelInsertInput = {
  data: Array<SpaceUserGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SpaceUserGroupsOnConflict>;
};

/** order by avg() on columns of table "space_user_groups" */
export type SpaceUserGroupsAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "space_user_groups". All fields are combined with a logical 'AND'. */
export type SpaceUserGroupsBoolExp = {
  _and?: InputMaybe<Array<SpaceUserGroupsBoolExp>>;
  _not?: InputMaybe<SpaceUserGroupsBoolExp>;
  _or?: InputMaybe<Array<SpaceUserGroupsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspaces?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "space_user_groups" */
export const SpaceUserGroupsConstraint = {
  /** unique or primary key constraint on columns "id" */
  SpaceUserGroupsPkey: 'space_user_groups_pkey',
  /** unique or primary key constraint on columns "user_group_id", "space_id" */
  SpaceUserGroupsUnique: 'space_user_groups_unique'
} as const;

export type SpaceUserGroupsConstraint = typeof SpaceUserGroupsConstraint[keyof typeof SpaceUserGroupsConstraint];
/** input type for inserting data into table "space_user_groups" */
export type SpaceUserGroupsInsertInput = {
  space_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspaces?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
};

/** order by max() on columns of table "space_user_groups" */
export type SpaceUserGroupsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "space_user_groups" */
export type SpaceUserGroupsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "space_user_groups" */
export type SpaceUserGroupsMutationResponse = {
  __typename?: 'space_user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SpaceUserGroups>;
};

/** on_conflict condition type for table "space_user_groups" */
export type SpaceUserGroupsOnConflict = {
  constraint: SpaceUserGroupsConstraint;
  update_columns?: Array<SpaceUserGroupsUpdateColumn>;
  where?: InputMaybe<SpaceUserGroupsBoolExp>;
};

/** Ordering options when selecting data from "space_user_groups". */
export type SpaceUserGroupsOrderBy = {
  id?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspaces?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "space_user_groups" */
export const SpaceUserGroupsSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SpaceUserGroupsSelectColumn = typeof SpaceUserGroupsSelectColumn[keyof typeof SpaceUserGroupsSelectColumn];
/** order by stddev() on columns of table "space_user_groups" */
export type SpaceUserGroupsStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "space_user_groups" */
export type SpaceUserGroupsStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "space_user_groups" */
export type SpaceUserGroupsStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "space_user_groups" */
export type SpaceUserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SpaceUserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SpaceUserGroupsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "space_user_groups" */
export type SpaceUserGroupsSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "space_user_groups" (current role has no relevant permissions) */
export const SpaceUserGroupsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type SpaceUserGroupsUpdateColumn = typeof SpaceUserGroupsUpdateColumn[keyof typeof SpaceUserGroupsUpdateColumn];
/** order by var_pop() on columns of table "space_user_groups" */
export type SpaceUserGroupsVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "space_user_groups" */
export type SpaceUserGroupsVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "space_user_groups" */
export type SpaceUserGroupsVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "spaces" */
export type Spaces = {
  __typename?: 'spaces';
  audience_template_access_mode: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /**
   * An audience template selected for a space individually. Can only be changed,
   * and is only consulted, while the space's access mode is "selected".
   */
  selected_audience_templates: Array<SpaceAudienceTemplate>;
  /** An array relationship */
  space_subset_grants: Array<SpaceSubsetGrants>;
  /** An array relationship */
  space_sync_templates: Array<SpaceSyncTemplates>;
  /** An array relationship */
  space_user_groups: Array<SpaceUserGroups>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "spaces" */
export type SpacesSpaceSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<SpaceSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSubsetGrantsOrderBy>>;
  where?: InputMaybe<SpaceSubsetGrantsBoolExp>;
};


/** columns and relationships of "spaces" */
export type SpacesSpaceSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SpaceSyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSyncTemplatesOrderBy>>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};


/** columns and relationships of "spaces" */
export type SpacesSpaceUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SpaceUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceUserGroupsOrderBy>>;
  where?: InputMaybe<SpaceUserGroupsBoolExp>;
};

/** Boolean expression to filter rows from the table "spaces". All fields are combined with a logical 'AND'. */
export type SpacesBoolExp = {
  _and?: InputMaybe<Array<SpacesBoolExp>>;
  _not?: InputMaybe<SpacesBoolExp>;
  _or?: InputMaybe<Array<SpacesBoolExp>>;
  audience_template_access_mode?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  space_subset_grants?: InputMaybe<SpaceSubsetGrantsBoolExp>;
  space_sync_templates?: InputMaybe<SpaceSyncTemplatesBoolExp>;
  space_user_groups?: InputMaybe<SpaceUserGroupsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "spaces" */
export const SpacesConstraint = {
  /** unique or primary key constraint on columns "id", "organization_id" */
  SpacesIdOrgUnique: 'spaces_id_org_unique',
  /** unique or primary key constraint on columns "id" */
  SpacesPkey: 'spaces_pkey',
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SpacesWorkspaceIdUnique: 'spaces_workspace_id_unique'
} as const;

export type SpacesConstraint = typeof SpacesConstraint[keyof typeof SpacesConstraint];
/** input type for inserting data into table "spaces" */
export type SpacesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  space_subset_grants?: InputMaybe<SpaceSubsetGrantsArrRelInsertInput>;
  space_sync_templates?: InputMaybe<SpaceSyncTemplatesArrRelInsertInput>;
  space_user_groups?: InputMaybe<SpaceUserGroupsArrRelInsertInput>;
};

/** response of any mutation on the table "spaces" */
export type SpacesMutationResponse = {
  __typename?: 'spaces_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spaces>;
};

/** input type for inserting object relation for remote table "spaces" */
export type SpacesObjRelInsertInput = {
  data: SpacesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SpacesOnConflict>;
};

/** on_conflict condition type for table "spaces" */
export type SpacesOnConflict = {
  constraint: SpacesConstraint;
  update_columns?: Array<SpacesUpdateColumn>;
  where?: InputMaybe<SpacesBoolExp>;
};

/** Ordering options when selecting data from "spaces". */
export type SpacesOrderBy = {
  audience_template_access_mode?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  space_subset_grants_aggregate?: InputMaybe<SpaceSubsetGrantsAggregateOrderBy>;
  space_sync_templates_aggregate?: InputMaybe<SpaceSyncTemplatesAggregateOrderBy>;
  space_user_groups_aggregate?: InputMaybe<SpaceUserGroupsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: spaces */
export type SpacesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "spaces" */
export const SpacesSelectColumn = {
  /** column name */
  AudienceTemplateAccessMode: 'audience_template_access_mode',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SpacesSelectColumn = typeof SpacesSelectColumn[keyof typeof SpacesSelectColumn];
/** input type for updating data in table "spaces" */
export type SpacesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "spaces" */
export type SpacesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SpacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SpacesStreamCursorValueInput = {
  audience_template_access_mode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "spaces" */
export const SpacesUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name'
} as const;

export type SpacesUpdateColumn = typeof SpacesUpdateColumn[keyof typeof SpacesUpdateColumn];
export type SpacesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SpacesSetInput>;
  /** filter the rows which have to be updated */
  where: SpacesBoolExp;
};

/** columns and relationships of "sso_group_user_groups" */
export type SsoGroupUserGroups = {
  __typename?: 'sso_group_user_groups';
  created_at: Scalars['timestamptz'];
  sso_group_id: Scalars['uuid'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
};

/** order by aggregate values of table "sso_group_user_groups" */
export type SsoGroupUserGroupsAggregateOrderBy = {
  avg?: InputMaybe<SsoGroupUserGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SsoGroupUserGroupsMaxOrderBy>;
  min?: InputMaybe<SsoGroupUserGroupsMinOrderBy>;
  stddev?: InputMaybe<SsoGroupUserGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<SsoGroupUserGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SsoGroupUserGroupsStddevSampOrderBy>;
  sum?: InputMaybe<SsoGroupUserGroupsSumOrderBy>;
  var_pop?: InputMaybe<SsoGroupUserGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<SsoGroupUserGroupsVarSampOrderBy>;
  variance?: InputMaybe<SsoGroupUserGroupsVarianceOrderBy>;
};

/** order by avg() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sso_group_user_groups". All fields are combined with a logical 'AND'. */
export type SsoGroupUserGroupsBoolExp = {
  _and?: InputMaybe<Array<SsoGroupUserGroupsBoolExp>>;
  _not?: InputMaybe<SsoGroupUserGroupsBoolExp>;
  _or?: InputMaybe<Array<SsoGroupUserGroupsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  sso_group_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "sso_group_user_groups" */
export const SsoGroupUserGroupsConstraint = {
  /** unique or primary key constraint on columns "user_group_id", "sso_group_id" */
  SsoGroupUserGroupsPkey: 'sso_group_user_groups_pkey'
} as const;

export type SsoGroupUserGroupsConstraint = typeof SsoGroupUserGroupsConstraint[keyof typeof SsoGroupUserGroupsConstraint];
/** input type for inserting data into table "sso_group_user_groups" */
export type SsoGroupUserGroupsInsertInput = {
  sso_group_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  sso_group_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  sso_group_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sso_group_user_groups" */
export type SsoGroupUserGroupsMutationResponse = {
  __typename?: 'sso_group_user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SsoGroupUserGroups>;
};

/** on_conflict condition type for table "sso_group_user_groups" */
export type SsoGroupUserGroupsOnConflict = {
  constraint: SsoGroupUserGroupsConstraint;
  update_columns?: Array<SsoGroupUserGroupsUpdateColumn>;
  where?: InputMaybe<SsoGroupUserGroupsBoolExp>;
};

/** Ordering options when selecting data from "sso_group_user_groups". */
export type SsoGroupUserGroupsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  sso_group_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sso_group_user_groups" */
export const SsoGroupUserGroupsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  SsoGroupId: 'sso_group_id',
  /** column name */
  UserGroupId: 'user_group_id'
} as const;

export type SsoGroupUserGroupsSelectColumn = typeof SsoGroupUserGroupsSelectColumn[keyof typeof SsoGroupUserGroupsSelectColumn];
/** order by stddev() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sso_group_user_groups" */
export type SsoGroupUserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SsoGroupUserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SsoGroupUserGroupsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  sso_group_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "sso_group_user_groups" (current role has no relevant permissions) */
export const SsoGroupUserGroupsUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type SsoGroupUserGroupsUpdateColumn = typeof SsoGroupUserGroupsUpdateColumn[keyof typeof SsoGroupUserGroupsUpdateColumn];
/** order by var_pop() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sso_group_user_groups" */
export type SsoGroupUserGroupsVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sso_groups" */
export type SsoGroups = {
  __typename?: 'sso_groups';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['bigint'];
  /** An array relationship */
  sso_group_user_groups: Array<SsoGroupUserGroups>;
  /** An array relationship */
  sso_user_groups: Array<SsoUserGroups>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "sso_groups" */
export type SsoGroupsSsoGroupUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupUserGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupUserGroupsBoolExp>;
};


/** columns and relationships of "sso_groups" */
export type SsoGroupsSsoUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoUserGroupsOrderBy>>;
  where?: InputMaybe<SsoUserGroupsBoolExp>;
};

/** order by aggregate values of table "sso_groups" */
export type SsoGroupsAggregateOrderBy = {
  avg?: InputMaybe<SsoGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SsoGroupsMaxOrderBy>;
  min?: InputMaybe<SsoGroupsMinOrderBy>;
  stddev?: InputMaybe<SsoGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<SsoGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SsoGroupsStddevSampOrderBy>;
  sum?: InputMaybe<SsoGroupsSumOrderBy>;
  var_pop?: InputMaybe<SsoGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<SsoGroupsVarSampOrderBy>;
  variance?: InputMaybe<SsoGroupsVarianceOrderBy>;
};

/** order by avg() on columns of table "sso_groups" */
export type SsoGroupsAvgOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sso_groups". All fields are combined with a logical 'AND'. */
export type SsoGroupsBoolExp = {
  _and?: InputMaybe<Array<SsoGroupsBoolExp>>;
  _not?: InputMaybe<SsoGroupsBoolExp>;
  _or?: InputMaybe<Array<SsoGroupsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  sso_group_user_groups?: InputMaybe<SsoGroupUserGroupsBoolExp>;
  sso_user_groups?: InputMaybe<SsoUserGroupsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** order by max() on columns of table "sso_groups" */
export type SsoGroupsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sso_groups" */
export type SsoGroupsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sso_groups". */
export type SsoGroupsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  sso_group_user_groups_aggregate?: InputMaybe<SsoGroupUserGroupsAggregateOrderBy>;
  sso_user_groups_aggregate?: InputMaybe<SsoUserGroupsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** select columns of table "sso_groups" */
export const SsoGroupsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type SsoGroupsSelectColumn = typeof SsoGroupsSelectColumn[keyof typeof SsoGroupsSelectColumn];
/** order by stddev() on columns of table "sso_groups" */
export type SsoGroupsStddevOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sso_groups" */
export type SsoGroupsStddevPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sso_groups" */
export type SsoGroupsStddevSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sso_groups" */
export type SsoGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SsoGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SsoGroupsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "sso_groups" */
export type SsoGroupsSumOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "sso_groups" */
export type SsoGroupsVarPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sso_groups" */
export type SsoGroupsVarSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sso_groups" */
export type SsoGroupsVarianceOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sso_user_groups" */
export type SsoUserGroups = {
  __typename?: 'sso_user_groups';
  created_at: Scalars['timestamptz'];
  group_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  sso_group: SsoGroups;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['bigint'];
};

/** order by aggregate values of table "sso_user_groups" */
export type SsoUserGroupsAggregateOrderBy = {
  avg?: InputMaybe<SsoUserGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SsoUserGroupsMaxOrderBy>;
  min?: InputMaybe<SsoUserGroupsMinOrderBy>;
  stddev?: InputMaybe<SsoUserGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<SsoUserGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SsoUserGroupsStddevSampOrderBy>;
  sum?: InputMaybe<SsoUserGroupsSumOrderBy>;
  var_pop?: InputMaybe<SsoUserGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<SsoUserGroupsVarSampOrderBy>;
  variance?: InputMaybe<SsoUserGroupsVarianceOrderBy>;
};

/** order by avg() on columns of table "sso_user_groups" */
export type SsoUserGroupsAvgOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sso_user_groups". All fields are combined with a logical 'AND'. */
export type SsoUserGroupsBoolExp = {
  _and?: InputMaybe<Array<SsoUserGroupsBoolExp>>;
  _not?: InputMaybe<SsoUserGroupsBoolExp>;
  _or?: InputMaybe<Array<SsoUserGroupsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  group_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sso_group?: InputMaybe<SsoGroupsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "sso_user_groups" */
export type SsoUserGroupsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sso_user_groups" */
export type SsoUserGroupsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sso_user_groups". */
export type SsoUserGroupsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  group_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sso_group?: InputMaybe<SsoGroupsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sso_user_groups" */
export const SsoUserGroupsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  GroupId: 'group_id',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id'
} as const;

export type SsoUserGroupsSelectColumn = typeof SsoUserGroupsSelectColumn[keyof typeof SsoUserGroupsSelectColumn];
/** order by stddev() on columns of table "sso_user_groups" */
export type SsoUserGroupsStddevOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sso_user_groups" */
export type SsoUserGroupsStddevPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sso_user_groups" */
export type SsoUserGroupsStddevSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sso_user_groups" */
export type SsoUserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SsoUserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SsoUserGroupsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  group_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sso_user_groups" */
export type SsoUserGroupsSumOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "sso_user_groups" */
export type SsoUserGroupsVarPopOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sso_user_groups" */
export type SsoUserGroupsVarSampOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sso_user_groups" */
export type SsoUserGroupsVarianceOrderBy = {
  user_id?: InputMaybe<OrderBy>;
};

/** One materialized member set backing a static audience (segments.is_static_audience = true). Each row is produced by a single materialization of either a CSV upload (type='csv') or a frozen audience-filter snapshot (type='snapshot'), and owns up to three deterministically-named warehouse tables (static_list_<id>_pks / _unmatched / _staging) computed from its id. The audience relationship lives here via audience_id (nullable during the CSV preview window), not on segments. status drives the materializing -> ready_to_commit/committed -> discarded state machine. Non-committed, non-failed sets with no audience_id are reaped by a 24h TTL sweep keyed on updated_at. */
export type StaticLists = {
  __typename?: 'static_lists';
  /** An object relationship */
  audience?: Maybe<Segments>;
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['bigint']>;
  /** CSV only. JSON config for the upload: { sourceFileUrl, columnMapping: [{source, target}] }. columnMapping's array shape is forward-compatible with multi-key joins. */
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** Populated when status = failed; stringified worker exception. */
  last_error?: Maybe<Scalars['String']>;
  last_materialized_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  parent_model: Segments;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id: Scalars['bigint'];
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size: Scalars['bigint'];
  /** State machine: materializing | failed | ready_to_commit | committed | discarded. */
  status: Scalars['String'];
  /** Worker dispatch discriminator: csv | snapshot. */
  type: Scalars['String'];
  /** Drives the 24h TTL cleanup sweep for non-committed sets. */
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** One materialized member set backing a static audience (segments.is_static_audience = true). Each row is produced by a single materialization of either a CSV upload (type='csv') or a frozen audience-filter snapshot (type='snapshot'), and owns up to three deterministically-named warehouse tables (static_list_<id>_pks / _unmatched / _staging) computed from its id. The audience relationship lives here via audience_id (nullable during the CSV preview window), not on segments. status drives the materializing -> ready_to_commit/committed -> discarded state machine. Non-committed, non-failed sets with no audience_id are reaped by a 24h TTL sweep keyed on updated_at. */
export type StaticListsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "static_lists" */
export type StaticListsAggregate = {
  __typename?: 'static_lists_aggregate';
  aggregate?: Maybe<StaticListsAggregateFields>;
  nodes: Array<StaticLists>;
};

/** aggregate fields of "static_lists" */
export type StaticListsAggregateFields = {
  __typename?: 'static_lists_aggregate_fields';
  avg?: Maybe<StaticListsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<StaticListsMaxFields>;
  min?: Maybe<StaticListsMinFields>;
  stddev?: Maybe<StaticListsStddevFields>;
  stddev_pop?: Maybe<StaticListsStddevPopFields>;
  stddev_samp?: Maybe<StaticListsStddevSampFields>;
  sum?: Maybe<StaticListsSumFields>;
  var_pop?: Maybe<StaticListsVarPopFields>;
  var_samp?: Maybe<StaticListsVarSampFields>;
  variance?: Maybe<StaticListsVarianceFields>;
};


/** aggregate fields of "static_lists" */
export type StaticListsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<StaticListsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StaticListsAvgFields = {
  __typename?: 'static_lists_avg_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "static_lists". All fields are combined with a logical 'AND'. */
export type StaticListsBoolExp = {
  _and?: InputMaybe<Array<StaticListsBoolExp>>;
  _not?: InputMaybe<StaticListsBoolExp>;
  _or?: InputMaybe<Array<StaticListsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_error?: InputMaybe<StringComparisonExp>;
  last_materialized_at?: InputMaybe<TimestamptzComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  size?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type StaticListsMaxFields = {
  __typename?: 'static_lists_max_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Populated when status = failed; stringified worker exception. */
  last_error?: Maybe<Scalars['String']>;
  last_materialized_at?: Maybe<Scalars['timestamptz']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['bigint']>;
  /** State machine: materializing | failed | ready_to_commit | committed | discarded. */
  status?: Maybe<Scalars['String']>;
  /** Worker dispatch discriminator: csv | snapshot. */
  type?: Maybe<Scalars['String']>;
  /** Drives the 24h TTL cleanup sweep for non-committed sets. */
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type StaticListsMinFields = {
  __typename?: 'static_lists_min_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Populated when status = failed; stringified worker exception. */
  last_error?: Maybe<Scalars['String']>;
  last_materialized_at?: Maybe<Scalars['timestamptz']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['bigint']>;
  /** State machine: materializing | failed | ready_to_commit | committed | discarded. */
  status?: Maybe<Scalars['String']>;
  /** Worker dispatch discriminator: csv | snapshot. */
  type?: Maybe<Scalars['String']>;
  /** Drives the 24h TTL cleanup sweep for non-committed sets. */
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "static_lists". */
export type StaticListsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_error?: InputMaybe<OrderBy>;
  last_materialized_at?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "static_lists" */
export const StaticListsSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  LastError: 'last_error',
  /** column name */
  LastMaterializedAt: 'last_materialized_at',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  Size: 'size',
  /** column name */
  Status: 'status',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type StaticListsSelectColumn = typeof StaticListsSelectColumn[keyof typeof StaticListsSelectColumn];
/** aggregate stddev on columns */
export type StaticListsStddevFields = {
  __typename?: 'static_lists_stddev_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StaticListsStddevPopFields = {
  __typename?: 'static_lists_stddev_pop_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StaticListsStddevSampFields = {
  __typename?: 'static_lists_stddev_samp_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "static_lists" */
export type StaticListsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: StaticListsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type StaticListsStreamCursorValueInput = {
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: InputMaybe<Scalars['bigint']>;
  /** CSV only. JSON config for the upload: { sourceFileUrl, columnMapping: [{source, target}] }. columnMapping's array shape is forward-compatible with multi-key joins. */
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Populated when status = failed; stringified worker exception. */
  last_error?: InputMaybe<Scalars['String']>;
  last_materialized_at?: InputMaybe<Scalars['timestamptz']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: InputMaybe<Scalars['bigint']>;
  /** State machine: materializing | failed | ready_to_commit | committed | discarded. */
  status?: InputMaybe<Scalars['String']>;
  /** Worker dispatch discriminator: csv | snapshot. */
  type?: InputMaybe<Scalars['String']>;
  /** Drives the 24h TTL cleanup sweep for non-committed sets. */
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type StaticListsSumFields = {
  __typename?: 'static_lists_sum_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['bigint']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['bigint']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type StaticListsVarPopFields = {
  __typename?: 'static_lists_var_pop_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StaticListsVarSampFields = {
  __typename?: 'static_lists_var_samp_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StaticListsVarianceFields = {
  __typename?: 'static_lists_variance_fields';
  /** FK to segments.id. Set on convert/re-upload/refresh; null for "create from scratch" CSV flows during the preview window, and after the audience is deleted (the orphan sweep then reaps the row). */
  audience_id?: Maybe<Scalars['Float']>;
  /** FK to segments.id; member PKs are drawn from this model. */
  parent_model_id?: Maybe<Scalars['Float']>;
  /** Member count of the materialized set (row count of static_list_<id>). Written at materialization; 0 until first materialized. */
  size?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'subscription';
  /** fetch data from the table: "ad_agent_artifacts" */
  ad_agent_artifacts: Array<AdAgentArtifacts>;
  /** fetch data from the table: "ad_agent_artifacts" using primary key columns */
  ad_agent_artifacts_by_pk?: Maybe<AdAgentArtifacts>;
  /** fetch data from the table in a streaming manner: "ad_agent_artifacts" */
  ad_agent_artifacts_stream: Array<AdAgentArtifacts>;
  /** An array relationship */
  ad_asset_favorites: Array<AdAssetFavorites>;
  /** An aggregate relationship */
  ad_asset_favorites_aggregate: AdAssetFavoritesAggregate;
  /** fetch data from the table: "ad_asset_favorites" using primary key columns */
  ad_asset_favorites_by_pk?: Maybe<AdAssetFavorites>;
  /** fetch data from the table in a streaming manner: "ad_asset_favorites" */
  ad_asset_favorites_stream: Array<AdAssetFavorites>;
  /** fetch data from the table: "ad_brief_asset_launch_queue" */
  ad_brief_asset_launch_queue: Array<AdBriefAssetLaunchQueue>;
  /** fetch aggregated fields from the table: "ad_brief_asset_launch_queue" */
  ad_brief_asset_launch_queue_aggregate: AdBriefAssetLaunchQueueAggregate;
  /** fetch data from the table: "ad_brief_asset_launch_queue" using primary key columns */
  ad_brief_asset_launch_queue_by_pk?: Maybe<AdBriefAssetLaunchQueue>;
  /** fetch data from the table in a streaming manner: "ad_brief_asset_launch_queue" */
  ad_brief_asset_launch_queue_stream: Array<AdBriefAssetLaunchQueue>;
  /** fetch data from the table: "ad_brief_asset_launches" */
  ad_brief_asset_launches: Array<AdBriefAssetLaunches>;
  /** fetch aggregated fields from the table: "ad_brief_asset_launches" */
  ad_brief_asset_launches_aggregate: AdBriefAssetLaunchesAggregate;
  /** fetch data from the table: "ad_brief_asset_launches" using primary key columns */
  ad_brief_asset_launches_by_pk?: Maybe<AdBriefAssetLaunches>;
  /** fetch data from the table in a streaming manner: "ad_brief_asset_launches" */
  ad_brief_asset_launches_stream: Array<AdBriefAssetLaunches>;
  /** An array relationship */
  ad_brief_asset_size_variants: Array<AdBriefAssetSizeVariants>;
  /** An aggregate relationship */
  ad_brief_asset_size_variants_aggregate: AdBriefAssetSizeVariantsAggregate;
  /** fetch data from the table: "ad_brief_asset_size_variants" using primary key columns */
  ad_brief_asset_size_variants_by_pk?: Maybe<AdBriefAssetSizeVariants>;
  /** fetch data from the table in a streaming manner: "ad_brief_asset_size_variants" */
  ad_brief_asset_size_variants_stream: Array<AdBriefAssetSizeVariants>;
  /** An array relationship */
  ad_brief_asset_versions: Array<AdBriefAssetVersions>;
  /** An aggregate relationship */
  ad_brief_asset_versions_aggregate: AdBriefAssetVersionsAggregate;
  /** fetch data from the table: "ad_brief_asset_versions" using primary key columns */
  ad_brief_asset_versions_by_pk?: Maybe<AdBriefAssetVersions>;
  /** fetch data from the table in a streaming manner: "ad_brief_asset_versions" */
  ad_brief_asset_versions_stream: Array<AdBriefAssetVersions>;
  /** An array relationship */
  ad_brief_assets: Array<AdBriefAssets>;
  /** An aggregate relationship */
  ad_brief_assets_aggregate: AdBriefAssetsAggregate;
  /** fetch data from the table: "ad_brief_assets" using primary key columns */
  ad_brief_assets_by_pk?: Maybe<AdBriefAssets>;
  /** fetch data from the table in a streaming manner: "ad_brief_assets" */
  ad_brief_assets_stream: Array<AdBriefAssets>;
  /** An array relationship */
  ad_briefs: Array<AdBriefs>;
  /** An aggregate relationship */
  ad_briefs_aggregate: AdBriefsAggregate;
  /** fetch data from the table: "ad_briefs" using primary key columns */
  ad_briefs_by_pk?: Maybe<AdBriefs>;
  /** fetch data from the table in a streaming manner: "ad_briefs" */
  ad_briefs_stream: Array<AdBriefs>;
  /** fetch data from the table: "ad_export_channel_sizes" */
  ad_export_channel_sizes: Array<AdExportChannelSizes>;
  /** fetch aggregated fields from the table: "ad_export_channel_sizes" */
  ad_export_channel_sizes_aggregate: AdExportChannelSizesAggregate;
  /** fetch data from the table: "ad_export_channel_sizes" using primary key columns */
  ad_export_channel_sizes_by_pk?: Maybe<AdExportChannelSizes>;
  /** fetch data from the table in a streaming manner: "ad_export_channel_sizes" */
  ad_export_channel_sizes_stream: Array<AdExportChannelSizes>;
  /** fetch data from the table: "ad_export_channels" */
  ad_export_channels: Array<AdExportChannels>;
  /** fetch aggregated fields from the table: "ad_export_channels" */
  ad_export_channels_aggregate: AdExportChannelsAggregate;
  /** fetch data from the table: "ad_export_channels" using primary key columns */
  ad_export_channels_by_pk?: Maybe<AdExportChannels>;
  /** fetch data from the table in a streaming manner: "ad_export_channels" */
  ad_export_channels_stream: Array<AdExportChannels>;
  /** fetch data from the table: "ad_generation_pipeline_runs" */
  ad_generation_pipeline_runs: Array<AdGenerationPipelineRuns>;
  /** fetch aggregated fields from the table: "ad_generation_pipeline_runs" */
  ad_generation_pipeline_runs_aggregate: AdGenerationPipelineRunsAggregate;
  /** fetch data from the table: "ad_generation_pipeline_runs" using primary key columns */
  ad_generation_pipeline_runs_by_pk?: Maybe<AdGenerationPipelineRuns>;
  /** fetch data from the table in a streaming manner: "ad_generation_pipeline_runs" */
  ad_generation_pipeline_runs_stream: Array<AdGenerationPipelineRuns>;
  /** fetch data from the table: "ad_generation_workflows" */
  ad_generation_workflows: Array<AdGenerationWorkflows>;
  /** fetch aggregated fields from the table: "ad_generation_workflows" */
  ad_generation_workflows_aggregate: AdGenerationWorkflowsAggregate;
  /** fetch data from the table: "ad_generation_workflows" using primary key columns */
  ad_generation_workflows_by_pk?: Maybe<AdGenerationWorkflows>;
  /** fetch data from the table in a streaming manner: "ad_generation_workflows" */
  ad_generation_workflows_stream: Array<AdGenerationWorkflows>;
  /** fetch data from the table: "ad_stats_models" */
  ad_stats_models: Array<AdStatsModels>;
  /** fetch data from the table: "ad_stats_models" using primary key columns */
  ad_stats_models_by_pk?: Maybe<AdStatsModels>;
  /** fetch data from the table in a streaming manner: "ad_stats_models" */
  ad_stats_models_stream: Array<AdStatsModels>;
  /** fetch data from the table: "ad_studio_product_feeds" */
  ad_studio_product_feeds: Array<AdStudioProductFeeds>;
  /** fetch aggregated fields from the table: "ad_studio_product_feeds" */
  ad_studio_product_feeds_aggregate: AdStudioProductFeedsAggregate;
  /** fetch data from the table: "ad_studio_product_feeds" using primary key columns */
  ad_studio_product_feeds_by_pk?: Maybe<AdStudioProductFeeds>;
  /** fetch data from the table in a streaming manner: "ad_studio_product_feeds" */
  ad_studio_product_feeds_stream: Array<AdStudioProductFeeds>;
  /** fetch data from the table: "ad_studio_project_brief_versions" */
  ad_studio_project_brief_versions: Array<AdStudioProjectBriefVersions>;
  /** fetch aggregated fields from the table: "ad_studio_project_brief_versions" */
  ad_studio_project_brief_versions_aggregate: AdStudioProjectBriefVersionsAggregate;
  /** fetch data from the table: "ad_studio_project_brief_versions" using primary key columns */
  ad_studio_project_brief_versions_by_pk?: Maybe<AdStudioProjectBriefVersions>;
  /** fetch data from the table in a streaming manner: "ad_studio_project_brief_versions" */
  ad_studio_project_brief_versions_stream: Array<AdStudioProjectBriefVersions>;
  /** fetch data from the table: "ad_studio_project_pins" */
  ad_studio_project_pins: Array<AdStudioProjectPins>;
  /** fetch aggregated fields from the table: "ad_studio_project_pins" */
  ad_studio_project_pins_aggregate: AdStudioProjectPinsAggregate;
  /** fetch data from the table: "ad_studio_project_pins" using primary key columns */
  ad_studio_project_pins_by_pk?: Maybe<AdStudioProjectPins>;
  /** fetch data from the table in a streaming manner: "ad_studio_project_pins" */
  ad_studio_project_pins_stream: Array<AdStudioProjectPins>;
  /** An array relationship */
  ad_studio_projects: Array<AdStudioProjects>;
  /** An aggregate relationship */
  ad_studio_projects_aggregate: AdStudioProjectsAggregate;
  /** fetch data from the table: "ad_studio_projects" using primary key columns */
  ad_studio_projects_by_pk?: Maybe<AdStudioProjects>;
  /** fetch data from the table in a streaming manner: "ad_studio_projects" */
  ad_studio_projects_stream: Array<AdStudioProjects>;
  /** An array relationship */
  ad_studio_sessions: Array<AdStudioSessions>;
  /** An aggregate relationship */
  ad_studio_sessions_aggregate: AdStudioSessionsAggregate;
  /** fetch data from the table: "ad_studio_sessions" using primary key columns */
  ad_studio_sessions_by_pk?: Maybe<AdStudioSessions>;
  /** fetch data from the table in a streaming manner: "ad_studio_sessions" */
  ad_studio_sessions_stream: Array<AdStudioSessions>;
  /** fetch data from the table: "ad_studio_treatments" */
  ad_studio_treatments: Array<AdStudioTreatments>;
  /** fetch aggregated fields from the table: "ad_studio_treatments" */
  ad_studio_treatments_aggregate: AdStudioTreatmentsAggregate;
  /** fetch data from the table: "ad_studio_treatments" using primary key columns */
  ad_studio_treatments_by_pk?: Maybe<AdStudioTreatments>;
  /** fetch data from the table in a streaming manner: "ad_studio_treatments" */
  ad_studio_treatments_stream: Array<AdStudioTreatments>;
  /** fetch data from the table: "admin_entitlements" */
  admin_entitlements: Array<AdminEntitlements>;
  /** fetch data from the table: "admin_entitlements" using primary key columns */
  admin_entitlements_by_pk?: Maybe<AdminEntitlements>;
  /** fetch data from the table in a streaming manner: "admin_entitlements" */
  admin_entitlements_stream: Array<AdminEntitlements>;
  /** fetch data from the table: "admin_workspace_entitlements" */
  admin_workspace_entitlements: Array<AdminWorkspaceEntitlements>;
  /** fetch data from the table in a streaming manner: "admin_workspace_entitlements" */
  admin_workspace_entitlements_stream: Array<AdminWorkspaceEntitlements>;
  /** fetch data from the table: "agent_asset_versions" */
  agent_asset_versions: Array<AgentAssetVersions>;
  /** fetch aggregated fields from the table: "agent_asset_versions" */
  agent_asset_versions_aggregate: AgentAssetVersionsAggregate;
  /** fetch data from the table: "agent_asset_versions" using primary key columns */
  agent_asset_versions_by_pk?: Maybe<AgentAssetVersions>;
  /** fetch data from the table in a streaming manner: "agent_asset_versions" */
  agent_asset_versions_stream: Array<AgentAssetVersions>;
  /** fetch data from the table: "agent_assets" */
  agent_assets: Array<AgentAssets>;
  /** fetch aggregated fields from the table: "agent_assets" */
  agent_assets_aggregate: AgentAssetsAggregate;
  /** fetch data from the table: "agent_assets" using primary key columns */
  agent_assets_by_pk?: Maybe<AgentAssets>;
  /** fetch data from the table in a streaming manner: "agent_assets" */
  agent_assets_stream: Array<AgentAssets>;
  /** fetch data from the table: "agent_report_suggestions" */
  agent_report_suggestions: Array<AgentReportSuggestions>;
  /** fetch data from the table: "agent_report_suggestions" using primary key columns */
  agent_report_suggestions_by_pk?: Maybe<AgentReportSuggestions>;
  /** fetch data from the table in a streaming manner: "agent_report_suggestions" */
  agent_report_suggestions_stream: Array<AgentReportSuggestions>;
  /** fetch data from the table: "agent_suggestion_batches" */
  agent_suggestion_batches: Array<AgentSuggestionBatches>;
  /** fetch data from the table: "agent_suggestion_batches" using primary key columns */
  agent_suggestion_batches_by_pk?: Maybe<AgentSuggestionBatches>;
  /** fetch data from the table in a streaming manner: "agent_suggestion_batches" */
  agent_suggestion_batches_stream: Array<AgentSuggestionBatches>;
  /** fetch data from the table: "agent_suggestions" */
  agent_suggestions: Array<AgentSuggestions>;
  /** fetch data from the table: "agent_suggestions" using primary key columns */
  agent_suggestions_by_pk?: Maybe<AgentSuggestions>;
  /** fetch data from the table in a streaming manner: "agent_suggestions" */
  agent_suggestions_stream: Array<AgentSuggestions>;
  /** fetch data from the table: "agentic_settings" */
  agentic_settings: Array<AgenticSettings>;
  /** fetch data from the table: "agentic_settings" using primary key columns */
  agentic_settings_by_pk?: Maybe<AgenticSettings>;
  /** An array relationship */
  agentic_settings_entities_links: Array<AgenticSettingsEntitiesLinks>;
  /** fetch data from the table: "agentic_settings_entities_links" using primary key columns */
  agentic_settings_entities_links_by_pk?: Maybe<AgenticSettingsEntitiesLinks>;
  /** fetch data from the table in a streaming manner: "agentic_settings_entities_links" */
  agentic_settings_entities_links_stream: Array<AgenticSettingsEntitiesLinks>;
  /** fetch data from the table: "agentic_settings_entity_review_suggestions" */
  agentic_settings_entity_review_suggestions: Array<AgenticSettingsEntityReviewSuggestions>;
  /** fetch aggregated fields from the table: "agentic_settings_entity_review_suggestions" */
  agentic_settings_entity_review_suggestions_aggregate: AgenticSettingsEntityReviewSuggestionsAggregate;
  /** fetch data from the table: "agentic_settings_entity_review_suggestions" using primary key columns */
  agentic_settings_entity_review_suggestions_by_pk?: Maybe<AgenticSettingsEntityReviewSuggestions>;
  /** fetch data from the table in a streaming manner: "agentic_settings_entity_review_suggestions" */
  agentic_settings_entity_review_suggestions_stream: Array<AgenticSettingsEntityReviewSuggestions>;
  /** fetch data from the table: "agentic_settings_entity_reviews" */
  agentic_settings_entity_reviews: Array<AgenticSettingsEntityReviews>;
  /** fetch data from the table: "agentic_settings_entity_reviews" using primary key columns */
  agentic_settings_entity_reviews_by_pk?: Maybe<AgenticSettingsEntityReviews>;
  /** fetch data from the table in a streaming manner: "agentic_settings_entity_reviews" */
  agentic_settings_entity_reviews_stream: Array<AgenticSettingsEntityReviews>;
  /** fetch data from the table in a streaming manner: "agentic_settings" */
  agentic_settings_stream: Array<AgenticSettings>;
  /** fetch data from the table: "airbyte_syncs" */
  airbyte_syncs: Array<AirbyteSyncs>;
  /** fetch data from the table: "airbyte_syncs" using primary key columns */
  airbyte_syncs_by_pk?: Maybe<AirbyteSyncs>;
  /** fetch data from the table in a streaming manner: "airbyte_syncs" */
  airbyte_syncs_stream: Array<AirbyteSyncs>;
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  /** fetch data from the table in a streaming manner: "alert_instances" */
  alert_instances_stream: Array<AlertInstances>;
  /** An array relationship */
  alert_statuses: Array<AlertStatuses>;
  /** fetch data from the table: "alert_statuses" using primary key columns */
  alert_statuses_by_pk?: Maybe<AlertStatuses>;
  /** fetch data from the table in a streaming manner: "alert_statuses" */
  alert_statuses_stream: Array<AlertStatuses>;
  /** fetch data from the table: "alerts" */
  alerts: Array<Alerts>;
  /** fetch data from the table: "alerts" using primary key columns */
  alerts_by_pk?: Maybe<Alerts>;
  /** fetch data from the table in a streaming manner: "alerts" */
  alerts_stream: Array<Alerts>;
  /** An array relationship */
  all_memberships_v2: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  all_memberships_v2_aggregate: AllMembershipsV2Aggregate;
  /** fetch data from the table in a streaming manner: "all_memberships_v2" */
  all_memberships_v2_stream: Array<AllMembershipsV2>;
  /** fetch data from the table: "amp_action_calls" */
  amp_action_calls: Array<AmpActionCalls>;
  /** fetch aggregated fields from the table: "amp_action_calls" */
  amp_action_calls_aggregate: AmpActionCallsAggregate;
  /** fetch data from the table: "amp_action_calls" using primary key columns */
  amp_action_calls_by_pk?: Maybe<AmpActionCalls>;
  /** fetch data from the table in a streaming manner: "amp_action_calls" */
  amp_action_calls_stream: Array<AmpActionCalls>;
  /** fetch data from the table: "amp_action_plan_versions" */
  amp_action_plan_versions: Array<AmpActionPlanVersions>;
  /** fetch aggregated fields from the table: "amp_action_plan_versions" */
  amp_action_plan_versions_aggregate: AmpActionPlanVersionsAggregate;
  /** fetch data from the table: "amp_action_plan_versions" using primary key columns */
  amp_action_plan_versions_by_pk?: Maybe<AmpActionPlanVersions>;
  /** fetch data from the table in a streaming manner: "amp_action_plan_versions" */
  amp_action_plan_versions_stream: Array<AmpActionPlanVersions>;
  /** An array relationship */
  amp_action_plans: Array<AmpActionPlans>;
  /** An aggregate relationship */
  amp_action_plans_aggregate: AmpActionPlansAggregate;
  /** fetch data from the table: "amp_action_plans" using primary key columns */
  amp_action_plans_by_pk?: Maybe<AmpActionPlans>;
  /** fetch data from the table in a streaming manner: "amp_action_plans" */
  amp_action_plans_stream: Array<AmpActionPlans>;
  /** An array relationship */
  amp_action_tool_calls: Array<AmpActionToolCalls>;
  /** An aggregate relationship */
  amp_action_tool_calls_aggregate: AmpActionToolCallsAggregate;
  /** fetch data from the table: "amp_action_tool_calls" using primary key columns */
  amp_action_tool_calls_by_pk?: Maybe<AmpActionToolCalls>;
  /** fetch data from the table in a streaming manner: "amp_action_tool_calls" */
  amp_action_tool_calls_stream: Array<AmpActionToolCalls>;
  /** fetch data from the table: "amp_actions" */
  amp_actions: Array<AmpActions>;
  /** fetch aggregated fields from the table: "amp_actions" */
  amp_actions_aggregate: AmpActionsAggregate;
  /** fetch data from the table: "amp_actions" using primary key columns */
  amp_actions_by_pk?: Maybe<AmpActions>;
  /** fetch data from the table in a streaming manner: "amp_actions" */
  amp_actions_stream: Array<AmpActions>;
  /** fetch data from the table: "amp_asset_groups" */
  amp_asset_groups: Array<AmpAssetGroups>;
  /** fetch aggregated fields from the table: "amp_asset_groups" */
  amp_asset_groups_aggregate: AmpAssetGroupsAggregate;
  /** fetch data from the table: "amp_asset_groups" using primary key columns */
  amp_asset_groups_by_pk?: Maybe<AmpAssetGroups>;
  /** fetch data from the table in a streaming manner: "amp_asset_groups" */
  amp_asset_groups_stream: Array<AmpAssetGroups>;
  /** An array relationship */
  amp_asset_ratings: Array<AmpAssetRatings>;
  /** An aggregate relationship */
  amp_asset_ratings_aggregate: AmpAssetRatingsAggregate;
  /** fetch data from the table: "amp_asset_ratings" using primary key columns */
  amp_asset_ratings_by_pk?: Maybe<AmpAssetRatings>;
  /** fetch data from the table in a streaming manner: "amp_asset_ratings" */
  amp_asset_ratings_stream: Array<AmpAssetRatings>;
  /** fetch data from the table: "amp_asset_sources" */
  amp_asset_sources: Array<AmpAssetSources>;
  /** fetch aggregated fields from the table: "amp_asset_sources" */
  amp_asset_sources_aggregate: AmpAssetSourcesAggregate;
  /** fetch data from the table: "amp_asset_sources" using primary key columns */
  amp_asset_sources_by_pk?: Maybe<AmpAssetSources>;
  /** fetch data from the table in a streaming manner: "amp_asset_sources" */
  amp_asset_sources_stream: Array<AmpAssetSources>;
  /** fetch data from the table: "amp_asset_sync_runs" */
  amp_asset_sync_runs: Array<AmpAssetSyncRuns>;
  /** fetch aggregated fields from the table: "amp_asset_sync_runs" */
  amp_asset_sync_runs_aggregate: AmpAssetSyncRunsAggregate;
  /** fetch data from the table: "amp_asset_sync_runs" using primary key columns */
  amp_asset_sync_runs_by_pk?: Maybe<AmpAssetSyncRuns>;
  /** fetch data from the table in a streaming manner: "amp_asset_sync_runs" */
  amp_asset_sync_runs_stream: Array<AmpAssetSyncRuns>;
  /** fetch data from the table: "amp_asset_syncs" */
  amp_asset_syncs: Array<AmpAssetSyncs>;
  /** fetch aggregated fields from the table: "amp_asset_syncs" */
  amp_asset_syncs_aggregate: AmpAssetSyncsAggregate;
  /** fetch data from the table: "amp_asset_syncs" using primary key columns */
  amp_asset_syncs_by_pk?: Maybe<AmpAssetSyncs>;
  /** fetch data from the table in a streaming manner: "amp_asset_syncs" */
  amp_asset_syncs_stream: Array<AmpAssetSyncs>;
  /** fetch data from the table: "amp_creative_classification_runs" */
  amp_creative_classification_runs: Array<AmpCreativeClassificationRuns>;
  /** fetch aggregated fields from the table: "amp_creative_classification_runs" */
  amp_creative_classification_runs_aggregate: AmpCreativeClassificationRunsAggregate;
  /** fetch data from the table: "amp_creative_classification_runs" using primary key columns */
  amp_creative_classification_runs_by_pk?: Maybe<AmpCreativeClassificationRuns>;
  /** fetch data from the table in a streaming manner: "amp_creative_classification_runs" */
  amp_creative_classification_runs_stream: Array<AmpCreativeClassificationRuns>;
  /** fetch data from the table: "amp_creative_dimension_values" */
  amp_creative_dimension_values: Array<AmpCreativeDimensionValues>;
  /** fetch data from the table: "amp_creative_dimension_values" using primary key columns */
  amp_creative_dimension_values_by_pk?: Maybe<AmpCreativeDimensionValues>;
  /** fetch data from the table in a streaming manner: "amp_creative_dimension_values" */
  amp_creative_dimension_values_stream: Array<AmpCreativeDimensionValues>;
  /** fetch data from the table: "amp_creative_dimensions" */
  amp_creative_dimensions: Array<AmpCreativeDimensions>;
  /** fetch aggregated fields from the table: "amp_creative_dimensions" */
  amp_creative_dimensions_aggregate: AmpCreativeDimensionsAggregate;
  /** fetch data from the table: "amp_creative_dimensions" using primary key columns */
  amp_creative_dimensions_by_pk?: Maybe<AmpCreativeDimensions>;
  /** fetch data from the table in a streaming manner: "amp_creative_dimensions" */
  amp_creative_dimensions_stream: Array<AmpCreativeDimensions>;
  /** fetch data from the table: "amp_file_favorites" */
  amp_file_favorites: Array<AmpFileFavorites>;
  /** fetch data from the table: "amp_file_favorites" using primary key columns */
  amp_file_favorites_by_pk?: Maybe<AmpFileFavorites>;
  /** fetch data from the table in a streaming manner: "amp_file_favorites" */
  amp_file_favorites_stream: Array<AmpFileFavorites>;
  /** fetch data from the table: "amp_files" */
  amp_files: Array<AmpFiles>;
  /** fetch aggregated fields from the table: "amp_files" */
  amp_files_aggregate: AmpFilesAggregate;
  /** fetch data from the table: "amp_files" using primary key columns */
  amp_files_by_pk?: Maybe<AmpFiles>;
  /** fetch data from the table in a streaming manner: "amp_files" */
  amp_files_stream: Array<AmpFiles>;
  /** fetch data from the table: "amp_followed_sources" */
  amp_followed_sources: Array<AmpFollowedSources>;
  /** fetch aggregated fields from the table: "amp_followed_sources" */
  amp_followed_sources_aggregate: AmpFollowedSourcesAggregate;
  /** fetch data from the table: "amp_followed_sources" using primary key columns */
  amp_followed_sources_by_pk?: Maybe<AmpFollowedSources>;
  /** fetch data from the table in a streaming manner: "amp_followed_sources" */
  amp_followed_sources_stream: Array<AmpFollowedSources>;
  /** fetch data from the table: "amp_followed_topics" */
  amp_followed_topics: Array<AmpFollowedTopics>;
  /** fetch aggregated fields from the table: "amp_followed_topics" */
  amp_followed_topics_aggregate: AmpFollowedTopicsAggregate;
  /** fetch data from the table: "amp_followed_topics" using primary key columns */
  amp_followed_topics_by_pk?: Maybe<AmpFollowedTopics>;
  /** fetch data from the table in a streaming manner: "amp_followed_topics" */
  amp_followed_topics_stream: Array<AmpFollowedTopics>;
  /** An array relationship */
  amp_launch_verdicts: Array<AmpLaunchVerdicts>;
  /** fetch data from the table: "amp_launch_verdicts" using primary key columns */
  amp_launch_verdicts_by_pk?: Maybe<AmpLaunchVerdicts>;
  /** fetch data from the table in a streaming manner: "amp_launch_verdicts" */
  amp_launch_verdicts_stream: Array<AmpLaunchVerdicts>;
  /** An array relationship */
  amp_opportunities: Array<AmpOpportunities>;
  /** An aggregate relationship */
  amp_opportunities_aggregate: AmpOpportunitiesAggregate;
  /** fetch data from the table: "amp_opportunities" using primary key columns */
  amp_opportunities_by_pk?: Maybe<AmpOpportunities>;
  /** fetch data from the table in a streaming manner: "amp_opportunities" */
  amp_opportunities_stream: Array<AmpOpportunities>;
  /** fetch data from the table: "amp_project_links" */
  amp_project_links: Array<AmpProjectLinks>;
  /** fetch aggregated fields from the table: "amp_project_links" */
  amp_project_links_aggregate: AmpProjectLinksAggregate;
  /** fetch data from the table: "amp_project_links" using primary key columns */
  amp_project_links_by_pk?: Maybe<AmpProjectLinks>;
  /** fetch data from the table in a streaming manner: "amp_project_links" */
  amp_project_links_stream: Array<AmpProjectLinks>;
  /** fetch data from the table: "amp_project_pins" */
  amp_project_pins: Array<AmpProjectPins>;
  /** fetch data from the table: "amp_project_pins" using primary key columns */
  amp_project_pins_by_pk?: Maybe<AmpProjectPins>;
  /** fetch data from the table in a streaming manner: "amp_project_pins" */
  amp_project_pins_stream: Array<AmpProjectPins>;
  /** fetch data from the table: "amp_project_users" */
  amp_project_users: Array<AmpProjectUsers>;
  /** fetch aggregated fields from the table: "amp_project_users" */
  amp_project_users_aggregate: AmpProjectUsersAggregate;
  /** fetch data from the table: "amp_project_users" using primary key columns */
  amp_project_users_by_pk?: Maybe<AmpProjectUsers>;
  /** fetch data from the table in a streaming manner: "amp_project_users" */
  amp_project_users_stream: Array<AmpProjectUsers>;
  /** fetch data from the table: "amp_projects" */
  amp_projects: Array<AmpProjects>;
  /** fetch aggregated fields from the table: "amp_projects" */
  amp_projects_aggregate: AmpProjectsAggregate;
  /** fetch data from the table: "amp_projects" using primary key columns */
  amp_projects_by_pk?: Maybe<AmpProjects>;
  /** fetch data from the table in a streaming manner: "amp_projects" */
  amp_projects_stream: Array<AmpProjects>;
  /** An array relationship */
  amp_signals: Array<AmpSignals>;
  /** An aggregate relationship */
  amp_signals_aggregate: AmpSignalsAggregate;
  /** fetch data from the table: "amp_signals" using primary key columns */
  amp_signals_by_pk?: Maybe<AmpSignals>;
  /** fetch data from the table in a streaming manner: "amp_signals" */
  amp_signals_stream: Array<AmpSignals>;
  /** fetch data from the table: "amp_tags" */
  amp_tags: Array<AmpTags>;
  /** fetch aggregated fields from the table: "amp_tags" */
  amp_tags_aggregate: AmpTagsAggregate;
  /** fetch data from the table: "amp_tags" using primary key columns */
  amp_tags_by_pk?: Maybe<AmpTags>;
  /** fetch data from the table in a streaming manner: "amp_tags" */
  amp_tags_stream: Array<AmpTags>;
  /** fetch data from the table: "amp_task_relations" */
  amp_task_relations: Array<AmpTaskRelations>;
  /** fetch aggregated fields from the table: "amp_task_relations" */
  amp_task_relations_aggregate: AmpTaskRelationsAggregate;
  /** fetch data from the table: "amp_task_relations" using primary key columns */
  amp_task_relations_by_pk?: Maybe<AmpTaskRelations>;
  /** fetch data from the table in a streaming manner: "amp_task_relations" */
  amp_task_relations_stream: Array<AmpTaskRelations>;
  /** fetch data from the table: "amp_task_reviews" */
  amp_task_reviews: Array<AmpTaskReviews>;
  /** fetch aggregated fields from the table: "amp_task_reviews" */
  amp_task_reviews_aggregate: AmpTaskReviewsAggregate;
  /** fetch data from the table: "amp_task_reviews" using primary key columns */
  amp_task_reviews_by_pk?: Maybe<AmpTaskReviews>;
  /** fetch data from the table in a streaming manner: "amp_task_reviews" */
  amp_task_reviews_stream: Array<AmpTaskReviews>;
  /** fetch data from the table: "amp_task_tags" */
  amp_task_tags: Array<AmpTaskTags>;
  /** fetch aggregated fields from the table: "amp_task_tags" */
  amp_task_tags_aggregate: AmpTaskTagsAggregate;
  /** fetch data from the table: "amp_task_tags" using primary key columns */
  amp_task_tags_by_pk?: Maybe<AmpTaskTags>;
  /** fetch data from the table in a streaming manner: "amp_task_tags" */
  amp_task_tags_stream: Array<AmpTaskTags>;
  /** fetch data from the table: "amp_task_users" */
  amp_task_users: Array<AmpTaskUsers>;
  /** fetch aggregated fields from the table: "amp_task_users" */
  amp_task_users_aggregate: AmpTaskUsersAggregate;
  /** fetch data from the table: "amp_task_users" using primary key columns */
  amp_task_users_by_pk?: Maybe<AmpTaskUsers>;
  /** fetch data from the table in a streaming manner: "amp_task_users" */
  amp_task_users_stream: Array<AmpTaskUsers>;
  /** fetch data from the table: "amp_tasks" */
  amp_tasks: Array<AmpTasks>;
  /** fetch aggregated fields from the table: "amp_tasks" */
  amp_tasks_aggregate: AmpTasksAggregate;
  /** fetch data from the table: "amp_tasks" using primary key columns */
  amp_tasks_by_pk?: Maybe<AmpTasks>;
  /** fetch data from the table in a streaming manner: "amp_tasks" */
  amp_tasks_stream: Array<AmpTasks>;
  /** fetch data from the table: "amp_team_members" */
  amp_team_members: Array<AmpTeamMembers>;
  /** fetch aggregated fields from the table: "amp_team_members" */
  amp_team_members_aggregate: AmpTeamMembersAggregate;
  /** fetch data from the table: "amp_team_members" using primary key columns */
  amp_team_members_by_pk?: Maybe<AmpTeamMembers>;
  /** fetch data from the table in a streaming manner: "amp_team_members" */
  amp_team_members_stream: Array<AmpTeamMembers>;
  /** fetch data from the table: "amp_teams" */
  amp_teams: Array<AmpTeams>;
  /** fetch aggregated fields from the table: "amp_teams" */
  amp_teams_aggregate: AmpTeamsAggregate;
  /** fetch data from the table: "amp_teams" using primary key columns */
  amp_teams_by_pk?: Maybe<AmpTeams>;
  /** fetch data from the table in a streaming manner: "amp_teams" */
  amp_teams_stream: Array<AmpTeams>;
  /** fetch data from the table: "amp_workflow_status_reviewers" */
  amp_workflow_status_reviewers: Array<AmpWorkflowStatusReviewers>;
  /** fetch aggregated fields from the table: "amp_workflow_status_reviewers" */
  amp_workflow_status_reviewers_aggregate: AmpWorkflowStatusReviewersAggregate;
  /** fetch data from the table: "amp_workflow_status_reviewers" using primary key columns */
  amp_workflow_status_reviewers_by_pk?: Maybe<AmpWorkflowStatusReviewers>;
  /** fetch data from the table in a streaming manner: "amp_workflow_status_reviewers" */
  amp_workflow_status_reviewers_stream: Array<AmpWorkflowStatusReviewers>;
  /** fetch data from the table: "amp_workflow_statuses" */
  amp_workflow_statuses: Array<AmpWorkflowStatuses>;
  /** fetch aggregated fields from the table: "amp_workflow_statuses" */
  amp_workflow_statuses_aggregate: AmpWorkflowStatusesAggregate;
  /** fetch data from the table: "amp_workflow_statuses" using primary key columns */
  amp_workflow_statuses_by_pk?: Maybe<AmpWorkflowStatuses>;
  /** fetch data from the table in a streaming manner: "amp_workflow_statuses" */
  amp_workflow_statuses_stream: Array<AmpWorkflowStatuses>;
  /** fetch data from the table: "amp_workflows" */
  amp_workflows: Array<AmpWorkflows>;
  /** fetch aggregated fields from the table: "amp_workflows" */
  amp_workflows_aggregate: AmpWorkflowsAggregate;
  /** fetch data from the table: "amp_workflows" using primary key columns */
  amp_workflows_by_pk?: Maybe<AmpWorkflows>;
  /** fetch data from the table in a streaming manner: "amp_workflows" */
  amp_workflows_stream: Array<AmpWorkflows>;
  /** fetch data from the table: "analytics_ingestion_stats" */
  analytics_ingestion_stats: Array<AnalyticsIngestionStats>;
  /** fetch data from the table: "analytics_ingestion_stats" using primary key columns */
  analytics_ingestion_stats_by_pk?: Maybe<AnalyticsIngestionStats>;
  /** fetch data from the table in a streaming manner: "analytics_ingestion_stats" */
  analytics_ingestion_stats_stream: Array<AnalyticsIngestionStats>;
  /** fetch data from the table: "analytics_reports" */
  analytics_reports: Array<AnalyticsReports>;
  /** fetch data from the table: "analytics_reports" using primary key columns */
  analytics_reports_by_pk?: Maybe<AnalyticsReports>;
  /** fetch data from the table in a streaming manner: "analytics_reports" */
  analytics_reports_stream: Array<AnalyticsReports>;
  /** An array relationship */
  api_keys: Array<ApiKeys>;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk?: Maybe<ApiKeys>;
  /** fetch data from the table in a streaming manner: "api_keys" */
  api_keys_stream: Array<ApiKeys>;
  /** fetch data from the table: "artifact_favorites" */
  artifact_favorites: Array<ArtifactFavorites>;
  /** fetch aggregated fields from the table: "artifact_favorites" */
  artifact_favorites_aggregate: ArtifactFavoritesAggregate;
  /** fetch data from the table: "artifact_favorites" using primary key columns */
  artifact_favorites_by_pk?: Maybe<ArtifactFavorites>;
  /** fetch data from the table in a streaming manner: "artifact_favorites" */
  artifact_favorites_stream: Array<ArtifactFavorites>;
  /** fetch data from the table: "artifact_review_comments" */
  artifact_review_comments: Array<ArtifactReviewComments>;
  /** fetch aggregated fields from the table: "artifact_review_comments" */
  artifact_review_comments_aggregate: ArtifactReviewCommentsAggregate;
  /** fetch data from the table: "artifact_review_comments" using primary key columns */
  artifact_review_comments_by_pk?: Maybe<ArtifactReviewComments>;
  /** fetch data from the table in a streaming manner: "artifact_review_comments" */
  artifact_review_comments_stream: Array<ArtifactReviewComments>;
  /** fetch data from the table: "artifact_review_statuses" */
  artifact_review_statuses: Array<ArtifactReviewStatuses>;
  /** fetch aggregated fields from the table: "artifact_review_statuses" */
  artifact_review_statuses_aggregate: ArtifactReviewStatusesAggregate;
  /** fetch data from the table: "artifact_review_statuses" using primary key columns */
  artifact_review_statuses_by_pk?: Maybe<ArtifactReviewStatuses>;
  /** fetch data from the table in a streaming manner: "artifact_review_statuses" */
  artifact_review_statuses_stream: Array<ArtifactReviewStatuses>;
  /** fetch data from the table: "artifact_reviewers" */
  artifact_reviewers: Array<ArtifactReviewers>;
  /** fetch aggregated fields from the table: "artifact_reviewers" */
  artifact_reviewers_aggregate: ArtifactReviewersAggregate;
  /** fetch data from the table: "artifact_reviewers" using primary key columns */
  artifact_reviewers_by_pk?: Maybe<ArtifactReviewers>;
  /** fetch data from the table in a streaming manner: "artifact_reviewers" */
  artifact_reviewers_stream: Array<ArtifactReviewers>;
  /** fetch data from the table: "artifact_reviews" */
  artifact_reviews: Array<ArtifactReviews>;
  /** fetch aggregated fields from the table: "artifact_reviews" */
  artifact_reviews_aggregate: ArtifactReviewsAggregate;
  /** fetch data from the table: "artifact_reviews" using primary key columns */
  artifact_reviews_by_pk?: Maybe<ArtifactReviews>;
  /** fetch data from the table in a streaming manner: "artifact_reviews" */
  artifact_reviews_stream: Array<ArtifactReviews>;
  /** fetch data from the table: "asset_comment_mentions" */
  asset_comment_mentions: Array<AssetCommentMentions>;
  /** fetch aggregated fields from the table: "asset_comment_mentions" */
  asset_comment_mentions_aggregate: AssetCommentMentionsAggregate;
  /** fetch data from the table: "asset_comment_mentions" using primary key columns */
  asset_comment_mentions_by_pk?: Maybe<AssetCommentMentions>;
  /** fetch data from the table in a streaming manner: "asset_comment_mentions" */
  asset_comment_mentions_stream: Array<AssetCommentMentions>;
  /** fetch data from the table: "asset_comment_statuses" */
  asset_comment_statuses: Array<AssetCommentStatuses>;
  /** fetch aggregated fields from the table: "asset_comment_statuses" */
  asset_comment_statuses_aggregate: AssetCommentStatusesAggregate;
  /** fetch data from the table: "asset_comment_statuses" using primary key columns */
  asset_comment_statuses_by_pk?: Maybe<AssetCommentStatuses>;
  /** fetch data from the table in a streaming manner: "asset_comment_statuses" */
  asset_comment_statuses_stream: Array<AssetCommentStatuses>;
  /** fetch data from the table: "asset_comment_thread_reads" */
  asset_comment_thread_reads: Array<AssetCommentThreadReads>;
  /** fetch data from the table: "asset_comment_thread_reads" using primary key columns */
  asset_comment_thread_reads_by_pk?: Maybe<AssetCommentThreadReads>;
  /** fetch data from the table in a streaming manner: "asset_comment_thread_reads" */
  asset_comment_thread_reads_stream: Array<AssetCommentThreadReads>;
  /** fetch data from the table: "asset_comment_thread_statuses" */
  asset_comment_thread_statuses: Array<AssetCommentThreadStatuses>;
  /** fetch aggregated fields from the table: "asset_comment_thread_statuses" */
  asset_comment_thread_statuses_aggregate: AssetCommentThreadStatusesAggregate;
  /** fetch data from the table: "asset_comment_thread_statuses" using primary key columns */
  asset_comment_thread_statuses_by_pk?: Maybe<AssetCommentThreadStatuses>;
  /** fetch data from the table in a streaming manner: "asset_comment_thread_statuses" */
  asset_comment_thread_statuses_stream: Array<AssetCommentThreadStatuses>;
  /** fetch data from the table: "asset_comment_threads" */
  asset_comment_threads: Array<AssetCommentThreads>;
  /** fetch aggregated fields from the table: "asset_comment_threads" */
  asset_comment_threads_aggregate: AssetCommentThreadsAggregate;
  /** fetch data from the table: "asset_comment_threads" using primary key columns */
  asset_comment_threads_by_pk?: Maybe<AssetCommentThreads>;
  /** fetch data from the table in a streaming manner: "asset_comment_threads" */
  asset_comment_threads_stream: Array<AssetCommentThreads>;
  /** fetch data from the table: "asset_comments" */
  asset_comments: Array<AssetComments>;
  /** fetch aggregated fields from the table: "asset_comments" */
  asset_comments_aggregate: AssetCommentsAggregate;
  /** fetch data from the table: "asset_comments" using primary key columns */
  asset_comments_by_pk?: Maybe<AssetComments>;
  /** fetch data from the table in a streaming manner: "asset_comments" */
  asset_comments_stream: Array<AssetComments>;
  /** fetch data from the table: "asset_models" */
  asset_models: Array<AssetModels>;
  /** fetch data from the table: "asset_models" using primary key columns */
  asset_models_by_pk?: Maybe<AssetModels>;
  /** fetch data from the table in a streaming manner: "asset_models" */
  asset_models_stream: Array<AssetModels>;
  /** fetch data from the table: "asset_statuses" */
  asset_statuses: Array<AssetStatuses>;
  /** fetch aggregated fields from the table: "asset_statuses" */
  asset_statuses_aggregate: AssetStatusesAggregate;
  /** fetch data from the table: "asset_statuses" using primary key columns */
  asset_statuses_by_pk?: Maybe<AssetStatuses>;
  /** fetch data from the table in a streaming manner: "asset_statuses" */
  asset_statuses_stream: Array<AssetStatuses>;
  /** An array relationship */
  attribution_methods: Array<AttributionMethods>;
  /** An aggregate relationship */
  attribution_methods_aggregate: AttributionMethodsAggregate;
  /** fetch data from the table: "attribution_methods" using primary key columns */
  attribution_methods_by_pk?: Maybe<AttributionMethods>;
  /** An array relationship */
  attribution_methods_interactions: Array<AttributionMethodsInteractions>;
  /** fetch data from the table: "attribution_methods_interactions" using primary key columns */
  attribution_methods_interactions_by_pk?: Maybe<AttributionMethodsInteractions>;
  /** fetch data from the table in a streaming manner: "attribution_methods_interactions" */
  attribution_methods_interactions_stream: Array<AttributionMethodsInteractions>;
  /** fetch data from the table in a streaming manner: "attribution_methods" */
  attribution_methods_stream: Array<AttributionMethods>;
  /** An array relationship */
  audience_goals: Array<AudienceGoals>;
  /** An aggregate relationship */
  audience_goals_aggregate: AudienceGoalsAggregate;
  /** fetch data from the table: "audience_goals" using primary key columns */
  audience_goals_by_pk?: Maybe<AudienceGoals>;
  /** fetch data from the table in a streaming manner: "audience_goals" */
  audience_goals_stream: Array<AudienceGoals>;
  /** An array relationship */
  audience_overviews: Array<AudienceOverviews>;
  /** An aggregate relationship */
  audience_overviews_aggregate: AudienceOverviewsAggregate;
  /** fetch data from the table: "audience_overviews" using primary key columns */
  audience_overviews_by_pk?: Maybe<AudienceOverviews>;
  /** fetch data from the table in a streaming manner: "audience_overviews" */
  audience_overviews_stream: Array<AudienceOverviews>;
  /** An array relationship */
  audience_primary_metrics: Array<AudiencePrimaryMetrics>;
  /** An aggregate relationship */
  audience_primary_metrics_aggregate: AudiencePrimaryMetricsAggregate;
  /** fetch data from the table: "audience_primary_metrics" using primary key columns */
  audience_primary_metrics_by_pk?: Maybe<AudiencePrimaryMetrics>;
  /** fetch data from the table in a streaming manner: "audience_primary_metrics" */
  audience_primary_metrics_stream: Array<AudiencePrimaryMetrics>;
  /** fetch data from the table: "audience_splits" */
  audience_splits: Array<AudienceSplits>;
  /** fetch aggregated fields from the table: "audience_splits" */
  audience_splits_aggregate: AudienceSplitsAggregate;
  /** fetch data from the table: "audience_splits" using primary key columns */
  audience_splits_by_pk?: Maybe<AudienceSplits>;
  /** fetch data from the table in a streaming manner: "audience_splits" */
  audience_splits_stream: Array<AudienceSplits>;
  /** fetch data from the table: "audience_subset_group_required_models" */
  audience_subset_group_required_models: Array<AudienceSubsetGroupRequiredModels>;
  /** fetch aggregated fields from the table: "audience_subset_group_required_models" */
  audience_subset_group_required_models_aggregate: AudienceSubsetGroupRequiredModelsAggregate;
  /** fetch data from the table: "audience_subset_group_required_models" using primary key columns */
  audience_subset_group_required_models_by_pk?: Maybe<AudienceSubsetGroupRequiredModels>;
  /** fetch data from the table in a streaming manner: "audience_subset_group_required_models" */
  audience_subset_group_required_models_stream: Array<AudienceSubsetGroupRequiredModels>;
  /** fetch data from the table: "audience_subset_groups" */
  audience_subset_groups: Array<AudienceSubsetGroups>;
  /** fetch aggregated fields from the table: "audience_subset_groups" */
  audience_subset_groups_aggregate: AudienceSubsetGroupsAggregate;
  /** fetch data from the table: "audience_subset_groups" using primary key columns */
  audience_subset_groups_by_pk?: Maybe<AudienceSubsetGroups>;
  /** fetch data from the table in a streaming manner: "audience_subset_groups" */
  audience_subset_groups_stream: Array<AudienceSubsetGroups>;
  /** fetch data from the table: "audience_subset_value_scoped_conditions" */
  audience_subset_value_scoped_conditions: Array<AudienceSubsetValueScopedConditions>;
  /** fetch aggregated fields from the table: "audience_subset_value_scoped_conditions" */
  audience_subset_value_scoped_conditions_aggregate: AudienceSubsetValueScopedConditionsAggregate;
  /** fetch data from the table: "audience_subset_value_scoped_conditions" using primary key columns */
  audience_subset_value_scoped_conditions_by_pk?: Maybe<AudienceSubsetValueScopedConditions>;
  /** fetch data from the table in a streaming manner: "audience_subset_value_scoped_conditions" */
  audience_subset_value_scoped_conditions_stream: Array<AudienceSubsetValueScopedConditions>;
  /** fetch data from the table: "audience_subset_values" */
  audience_subset_values: Array<AudienceSubsetValues>;
  /** fetch aggregated fields from the table: "audience_subset_values" */
  audience_subset_values_aggregate: AudienceSubsetValuesAggregate;
  /** fetch data from the table: "audience_subset_values" using primary key columns */
  audience_subset_values_by_pk?: Maybe<AudienceSubsetValues>;
  /** fetch data from the table in a streaming manner: "audience_subset_values" */
  audience_subset_values_stream: Array<AudienceSubsetValues>;
  /** fetch data from the table: "audience_templates" */
  audience_templates: Array<AudienceTemplates>;
  /** fetch aggregated fields from the table: "audience_templates" */
  audience_templates_aggregate: AudienceTemplatesAggregate;
  /** fetch data from the table: "audience_templates" using primary key columns */
  audience_templates_by_pk?: Maybe<AudienceTemplates>;
  /** fetch data from the table in a streaming manner: "audience_templates" */
  audience_templates_stream: Array<AudienceTemplates>;
  /** An array relationship */
  audiences_subsets: Array<AudiencesSubsets>;
  /** An aggregate relationship */
  audiences_subsets_aggregate: AudiencesSubsetsAggregate;
  /** fetch data from the table: "audiences_subsets" using primary key columns */
  audiences_subsets_by_pk?: Maybe<AudiencesSubsets>;
  /** fetch data from the table in a streaming manner: "audiences_subsets" */
  audiences_subsets_stream: Array<AudiencesSubsets>;
  /** An array relationship */
  auth0_connections: Array<Auth0Connections>;
  /** fetch data from the table: "auth0_connections" using primary key columns */
  auth0_connections_by_pk?: Maybe<Auth0Connections>;
  /** fetch data from the table in a streaming manner: "auth0_connections" */
  auth0_connections_stream: Array<Auth0Connections>;
  /** fetch data from the table: "billing_by_destination" */
  billing_by_destination: Array<BillingByDestination>;
  /** fetch data from the table in a streaming manner: "billing_by_destination" */
  billing_by_destination_stream: Array<BillingByDestination>;
  /** fetch data from the table: "billing_products" */
  billing_products: Array<BillingProducts>;
  /** fetch data from the table: "billing_products" using primary key columns */
  billing_products_by_pk?: Maybe<BillingProducts>;
  /** fetch data from the table in a streaming manner: "billing_products" */
  billing_products_stream: Array<BillingProducts>;
  /** fetch data from the table: "brand_profile_asset_groups" */
  brand_profile_asset_groups: Array<BrandProfileAssetGroups>;
  /** fetch aggregated fields from the table: "brand_profile_asset_groups" */
  brand_profile_asset_groups_aggregate: BrandProfileAssetGroupsAggregate;
  /** fetch data from the table: "brand_profile_asset_groups" using primary key columns */
  brand_profile_asset_groups_by_pk?: Maybe<BrandProfileAssetGroups>;
  /** fetch data from the table in a streaming manner: "brand_profile_asset_groups" */
  brand_profile_asset_groups_stream: Array<BrandProfileAssetGroups>;
  /** fetch data from the table: "brand_profile_content_emails" */
  brand_profile_content_emails: Array<BrandProfileContentEmails>;
  /** fetch aggregated fields from the table: "brand_profile_content_emails" */
  brand_profile_content_emails_aggregate: BrandProfileContentEmailsAggregate;
  /** fetch data from the table: "brand_profile_content_emails" using primary key columns */
  brand_profile_content_emails_by_pk?: Maybe<BrandProfileContentEmails>;
  /** fetch data from the table in a streaming manner: "brand_profile_content_emails" */
  brand_profile_content_emails_stream: Array<BrandProfileContentEmails>;
  /** fetch data from the table: "brand_profile_settings_entities" */
  brand_profile_settings_entities: Array<BrandProfileSettingsEntities>;
  /** fetch aggregated fields from the table: "brand_profile_settings_entities" */
  brand_profile_settings_entities_aggregate: BrandProfileSettingsEntitiesAggregate;
  /** fetch data from the table: "brand_profile_settings_entities" using primary key columns */
  brand_profile_settings_entities_by_pk?: Maybe<BrandProfileSettingsEntities>;
  /** fetch data from the table in a streaming manner: "brand_profile_settings_entities" */
  brand_profile_settings_entities_stream: Array<BrandProfileSettingsEntities>;
  /** fetch data from the table: "brand_profiles" */
  brand_profiles: Array<BrandProfiles>;
  /** fetch aggregated fields from the table: "brand_profiles" */
  brand_profiles_aggregate: BrandProfilesAggregate;
  /** fetch data from the table: "brand_profiles" using primary key columns */
  brand_profiles_by_pk?: Maybe<BrandProfiles>;
  /** fetch data from the table in a streaming manner: "brand_profiles" */
  brand_profiles_stream: Array<BrandProfiles>;
  /** fetch data from the table: "cached_event_pulls" */
  cached_event_pulls: Array<CachedEventPulls>;
  /** fetch data from the table: "cached_event_pulls" using primary key columns */
  cached_event_pulls_by_pk?: Maybe<CachedEventPulls>;
  /** fetch data from the table in a streaming manner: "cached_event_pulls" */
  cached_event_pulls_stream: Array<CachedEventPulls>;
  /** fetch data from the table: "campaign_artifact_version_best_practice_runs" */
  campaign_artifact_version_best_practice_runs: Array<CampaignArtifactVersionBestPracticeRuns>;
  /** fetch aggregated fields from the table: "campaign_artifact_version_best_practice_runs" */
  campaign_artifact_version_best_practice_runs_aggregate: CampaignArtifactVersionBestPracticeRunsAggregate;
  /** fetch data from the table: "campaign_artifact_version_best_practice_runs" using primary key columns */
  campaign_artifact_version_best_practice_runs_by_pk?: Maybe<CampaignArtifactVersionBestPracticeRuns>;
  /** fetch data from the table in a streaming manner: "campaign_artifact_version_best_practice_runs" */
  campaign_artifact_version_best_practice_runs_stream: Array<CampaignArtifactVersionBestPracticeRuns>;
  /** fetch data from the table: "campaign_artifact_versions" */
  campaign_artifact_versions: Array<CampaignArtifactVersions>;
  /** fetch aggregated fields from the table: "campaign_artifact_versions" */
  campaign_artifact_versions_aggregate: CampaignArtifactVersionsAggregate;
  /** fetch data from the table: "campaign_artifact_versions" using primary key columns */
  campaign_artifact_versions_by_pk?: Maybe<CampaignArtifactVersions>;
  /** fetch data from the table in a streaming manner: "campaign_artifact_versions" */
  campaign_artifact_versions_stream: Array<CampaignArtifactVersions>;
  /** An array relationship */
  campaign_artifacts: Array<CampaignArtifacts>;
  /** An aggregate relationship */
  campaign_artifacts_aggregate: CampaignArtifactsAggregate;
  /** fetch data from the table: "campaign_artifacts" using primary key columns */
  campaign_artifacts_by_pk?: Maybe<CampaignArtifacts>;
  /** fetch data from the table in a streaming manner: "campaign_artifacts" */
  campaign_artifacts_stream: Array<CampaignArtifacts>;
  /** fetch data from the table: "campaign_drafts" */
  campaign_drafts: Array<CampaignDrafts>;
  /** fetch aggregated fields from the table: "campaign_drafts" */
  campaign_drafts_aggregate: CampaignDraftsAggregate;
  /** fetch data from the table: "campaign_drafts" using primary key columns */
  campaign_drafts_by_pk?: Maybe<CampaignDrafts>;
  /** fetch data from the table in a streaming manner: "campaign_drafts" */
  campaign_drafts_stream: Array<CampaignDrafts>;
  /** An array relationship */
  campaign_labels: Array<CampaignLabels>;
  /** An aggregate relationship */
  campaign_labels_aggregate: CampaignLabelsAggregate;
  /** fetch data from the table: "campaign_labels" using primary key columns */
  campaign_labels_by_pk?: Maybe<CampaignLabels>;
  /** fetch data from the table in a streaming manner: "campaign_labels" */
  campaign_labels_stream: Array<CampaignLabels>;
  /** fetch data from the table: "campaign_list_entries" */
  campaign_list_entries: Array<CampaignListEntries>;
  /** fetch aggregated fields from the table: "campaign_list_entries" */
  campaign_list_entries_aggregate: CampaignListEntriesAggregate;
  /** fetch data from the table in a streaming manner: "campaign_list_entries" */
  campaign_list_entries_stream: Array<CampaignListEntries>;
  /** An array relationship */
  campaign_runs: Array<CampaignRuns>;
  /** An aggregate relationship */
  campaign_runs_aggregate: CampaignRunsAggregate;
  /** fetch data from the table: "campaign_runs" using primary key columns */
  campaign_runs_by_pk?: Maybe<CampaignRuns>;
  /** fetch data from the table in a streaming manner: "campaign_runs" */
  campaign_runs_stream: Array<CampaignRuns>;
  /** An array relationship */
  campaigns: Array<Campaigns>;
  /** An aggregate relationship */
  campaigns_aggregate: CampaignsAggregate;
  /** fetch data from the table: "campaigns" using primary key columns */
  campaigns_by_pk?: Maybe<Campaigns>;
  /** fetch data from the table in a streaming manner: "campaigns" */
  campaigns_stream: Array<Campaigns>;
  /** fetch data from the table: "catalog_collections" */
  catalog_collections: Array<CatalogCollections>;
  /** fetch data from the table: "catalog_collections" using primary key columns */
  catalog_collections_by_pk?: Maybe<CatalogCollections>;
  /** fetch data from the table in a streaming manner: "catalog_collections" */
  catalog_collections_stream: Array<CatalogCollections>;
  /** fetch data from the table: "catalog_models" */
  catalog_models: Array<CatalogModels>;
  /** fetch data from the table: "catalog_models" using primary key columns */
  catalog_models_by_pk?: Maybe<CatalogModels>;
  /** fetch data from the table in a streaming manner: "catalog_models" */
  catalog_models_stream: Array<CatalogModels>;
  /** fetch data from the table: "cep_brand_settings" */
  cep_brand_settings: Array<CepBrandSettings>;
  /** fetch aggregated fields from the table: "cep_brand_settings" */
  cep_brand_settings_aggregate: CepBrandSettingsAggregate;
  /** fetch data from the table: "cep_brand_settings" using primary key columns */
  cep_brand_settings_by_pk?: Maybe<CepBrandSettings>;
  /** fetch data from the table in a streaming manner: "cep_brand_settings" */
  cep_brand_settings_stream: Array<CepBrandSettings>;
  /** fetch data from the table: "cep_channels" */
  cep_channels: Array<CepChannels>;
  /** fetch aggregated fields from the table: "cep_channels" */
  cep_channels_aggregate: CepChannelsAggregate;
  /** fetch data from the table: "cep_channels" using primary key columns */
  cep_channels_by_pk?: Maybe<CepChannels>;
  /** fetch data from the table in a streaming manner: "cep_channels" */
  cep_channels_stream: Array<CepChannels>;
  /** fetch data from the table: "cep_content_block_message_usages" */
  cep_content_block_message_usages: Array<CepContentBlockMessageUsages>;
  /** fetch aggregated fields from the table: "cep_content_block_message_usages" */
  cep_content_block_message_usages_aggregate: CepContentBlockMessageUsagesAggregate;
  /** fetch data from the table: "cep_content_block_message_usages" using primary key columns */
  cep_content_block_message_usages_by_pk?: Maybe<CepContentBlockMessageUsages>;
  /** fetch data from the table in a streaming manner: "cep_content_block_message_usages" */
  cep_content_block_message_usages_stream: Array<CepContentBlockMessageUsages>;
  /** fetch data from the table: "cep_content_blocks" */
  cep_content_blocks: Array<CepContentBlocks>;
  /** fetch aggregated fields from the table: "cep_content_blocks" */
  cep_content_blocks_aggregate: CepContentBlocksAggregate;
  /** fetch data from the table: "cep_content_blocks" using primary key columns */
  cep_content_blocks_by_pk?: Maybe<CepContentBlocks>;
  /** fetch data from the table in a streaming manner: "cep_content_blocks" */
  cep_content_blocks_stream: Array<CepContentBlocks>;
  /** fetch data from the table: "cep_device_previews" */
  cep_device_previews: Array<CepDevicePreviews>;
  /** fetch aggregated fields from the table: "cep_device_previews" */
  cep_device_previews_aggregate: CepDevicePreviewsAggregate;
  /** fetch data from the table: "cep_device_previews" using primary key columns */
  cep_device_previews_by_pk?: Maybe<CepDevicePreviews>;
  /** fetch data from the table in a streaming manner: "cep_device_previews" */
  cep_device_previews_stream: Array<CepDevicePreviews>;
  /** An array relationship */
  cep_domains: Array<CepDomains>;
  /** An aggregate relationship */
  cep_domains_aggregate: CepDomainsAggregate;
  /** fetch data from the table: "cep_domains" using primary key columns */
  cep_domains_by_pk?: Maybe<CepDomains>;
  /** fetch data from the table in a streaming manner: "cep_domains" */
  cep_domains_stream: Array<CepDomains>;
  /** An array relationship */
  cep_email_template_contents: Array<CepEmailTemplateContents>;
  /** An aggregate relationship */
  cep_email_template_contents_aggregate: CepEmailTemplateContentsAggregate;
  /** fetch data from the table: "cep_email_template_contents" using primary key columns */
  cep_email_template_contents_by_pk?: Maybe<CepEmailTemplateContents>;
  /** fetch data from the table in a streaming manner: "cep_email_template_contents" */
  cep_email_template_contents_stream: Array<CepEmailTemplateContents>;
  /** fetch data from the table: "cep_email_templates" */
  cep_email_templates: Array<CepEmailTemplates>;
  /** fetch aggregated fields from the table: "cep_email_templates" */
  cep_email_templates_aggregate: CepEmailTemplatesAggregate;
  /** fetch data from the table: "cep_email_templates" using primary key columns */
  cep_email_templates_by_pk?: Maybe<CepEmailTemplates>;
  /** fetch data from the table in a streaming manner: "cep_email_templates" */
  cep_email_templates_stream: Array<CepEmailTemplates>;
  /** fetch data from the table: "cep_inapp_message_contents" */
  cep_inapp_message_contents: Array<CepInappMessageContents>;
  /** fetch aggregated fields from the table: "cep_inapp_message_contents" */
  cep_inapp_message_contents_aggregate: CepInappMessageContentsAggregate;
  /** fetch data from the table: "cep_inapp_message_contents" using primary key columns */
  cep_inapp_message_contents_by_pk?: Maybe<CepInappMessageContents>;
  /** fetch data from the table in a streaming manner: "cep_inapp_message_contents" */
  cep_inapp_message_contents_stream: Array<CepInappMessageContents>;
  /** fetch data from the table: "cep_inapp_message_template_push_apps" */
  cep_inapp_message_template_push_apps: Array<CepInappMessageTemplatePushApps>;
  /** fetch data from the table: "cep_inapp_message_template_push_apps" using primary key columns */
  cep_inapp_message_template_push_apps_by_pk?: Maybe<CepInappMessageTemplatePushApps>;
  /** fetch data from the table in a streaming manner: "cep_inapp_message_template_push_apps" */
  cep_inapp_message_template_push_apps_stream: Array<CepInappMessageTemplatePushApps>;
  /** fetch data from the table: "cep_inapp_message_templates" */
  cep_inapp_message_templates: Array<CepInappMessageTemplates>;
  /** fetch aggregated fields from the table: "cep_inapp_message_templates" */
  cep_inapp_message_templates_aggregate: CepInappMessageTemplatesAggregate;
  /** fetch data from the table: "cep_inapp_message_templates" using primary key columns */
  cep_inapp_message_templates_by_pk?: Maybe<CepInappMessageTemplates>;
  /** fetch data from the table in a streaming manner: "cep_inapp_message_templates" */
  cep_inapp_message_templates_stream: Array<CepInappMessageTemplates>;
  /** fetch data from the table: "cep_locales" */
  cep_locales: Array<CepLocales>;
  /** fetch aggregated fields from the table: "cep_locales" */
  cep_locales_aggregate: CepLocalesAggregate;
  /** fetch data from the table: "cep_locales" using primary key columns */
  cep_locales_by_pk?: Maybe<CepLocales>;
  /** fetch data from the table in a streaming manner: "cep_locales" */
  cep_locales_stream: Array<CepLocales>;
  /** fetch data from the table: "cep_localization_settings" */
  cep_localization_settings: Array<CepLocalizationSettings>;
  /** fetch aggregated fields from the table: "cep_localization_settings" */
  cep_localization_settings_aggregate: CepLocalizationSettingsAggregate;
  /** fetch data from the table: "cep_localization_settings" using primary key columns */
  cep_localization_settings_by_pk?: Maybe<CepLocalizationSettings>;
  /** fetch data from the table in a streaming manner: "cep_localization_settings" */
  cep_localization_settings_stream: Array<CepLocalizationSettings>;
  /** fetch data from the table: "cep_managed_models" */
  cep_managed_models: Array<CepManagedModels>;
  /** fetch data from the table: "cep_managed_models" using primary key columns */
  cep_managed_models_by_pk?: Maybe<CepManagedModels>;
  /** fetch data from the table in a streaming manner: "cep_managed_models" */
  cep_managed_models_stream: Array<CepManagedModels>;
  /** fetch data from the table: "cep_message_device_previews" */
  cep_message_device_previews: Array<CepMessageDevicePreviews>;
  /** fetch aggregated fields from the table: "cep_message_device_previews" */
  cep_message_device_previews_aggregate: CepMessageDevicePreviewsAggregate;
  /** fetch data from the table: "cep_message_device_previews" using primary key columns */
  cep_message_device_previews_by_pk?: Maybe<CepMessageDevicePreviews>;
  /** fetch data from the table in a streaming manner: "cep_message_device_previews" */
  cep_message_device_previews_stream: Array<CepMessageDevicePreviews>;
  /** An array relationship */
  cep_providers: Array<CepProviders>;
  /** An aggregate relationship */
  cep_providers_aggregate: CepProvidersAggregate;
  /** fetch data from the table: "cep_providers" using primary key columns */
  cep_providers_by_pk?: Maybe<CepProviders>;
  /** fetch data from the table in a streaming manner: "cep_providers" */
  cep_providers_stream: Array<CepProviders>;
  /** An array relationship */
  cep_sender_identities: Array<CepSenderIdentities>;
  /** An aggregate relationship */
  cep_sender_identities_aggregate: CepSenderIdentitiesAggregate;
  /** fetch data from the table: "cep_sender_identities" using primary key columns */
  cep_sender_identities_by_pk?: Maybe<CepSenderIdentities>;
  /** fetch data from the table in a streaming manner: "cep_sender_identities" */
  cep_sender_identities_stream: Array<CepSenderIdentities>;
  /** fetch data from the table: "cep_sender_identity_senders" */
  cep_sender_identity_senders: Array<CepSenderIdentitySenders>;
  /** fetch aggregated fields from the table: "cep_sender_identity_senders" */
  cep_sender_identity_senders_aggregate: CepSenderIdentitySendersAggregate;
  /** fetch data from the table: "cep_sender_identity_senders" using primary key columns */
  cep_sender_identity_senders_by_pk?: Maybe<CepSenderIdentitySenders>;
  /** fetch data from the table in a streaming manner: "cep_sender_identity_senders" */
  cep_sender_identity_senders_stream: Array<CepSenderIdentitySenders>;
  /** An array relationship */
  cep_subscription_topic_sender_identities: Array<CepSubscriptionTopicSenderIdentities>;
  /** An aggregate relationship */
  cep_subscription_topic_sender_identities_aggregate: CepSubscriptionTopicSenderIdentitiesAggregate;
  /** fetch data from the table: "cep_subscription_topic_sender_identities" using primary key columns */
  cep_subscription_topic_sender_identities_by_pk?: Maybe<CepSubscriptionTopicSenderIdentities>;
  /** fetch data from the table in a streaming manner: "cep_subscription_topic_sender_identities" */
  cep_subscription_topic_sender_identities_stream: Array<CepSubscriptionTopicSenderIdentities>;
  /** An array relationship */
  cep_subscription_topics: Array<CepSubscriptionTopics>;
  /** An aggregate relationship */
  cep_subscription_topics_aggregate: CepSubscriptionTopicsAggregate;
  /** fetch data from the table: "cep_subscription_topics" using primary key columns */
  cep_subscription_topics_by_pk?: Maybe<CepSubscriptionTopics>;
  /** fetch data from the table in a streaming manner: "cep_subscription_topics" */
  cep_subscription_topics_stream: Array<CepSubscriptionTopics>;
  /** An array relationship */
  cep_suppression_list_subscription_topics: Array<CepSuppressionListSubscriptionTopics>;
  /** An aggregate relationship */
  cep_suppression_list_subscription_topics_aggregate: CepSuppressionListSubscriptionTopicsAggregate;
  /** fetch data from the table: "cep_suppression_list_subscription_topics" using primary key columns */
  cep_suppression_list_subscription_topics_by_pk?: Maybe<CepSuppressionListSubscriptionTopics>;
  /** fetch data from the table in a streaming manner: "cep_suppression_list_subscription_topics" */
  cep_suppression_list_subscription_topics_stream: Array<CepSuppressionListSubscriptionTopics>;
  /** fetch data from the table: "cep_suppression_lists" */
  cep_suppression_lists: Array<CepSuppressionLists>;
  /** fetch aggregated fields from the table: "cep_suppression_lists" */
  cep_suppression_lists_aggregate: CepSuppressionListsAggregate;
  /** fetch data from the table: "cep_suppression_lists" using primary key columns */
  cep_suppression_lists_by_pk?: Maybe<CepSuppressionLists>;
  /** fetch data from the table in a streaming manner: "cep_suppression_lists" */
  cep_suppression_lists_stream: Array<CepSuppressionLists>;
  /** fetch data from the table: "cep_test_group_members" */
  cep_test_group_members: Array<CepTestGroupMembers>;
  /** fetch aggregated fields from the table: "cep_test_group_members" */
  cep_test_group_members_aggregate: CepTestGroupMembersAggregate;
  /** fetch data from the table: "cep_test_group_members" using primary key columns */
  cep_test_group_members_by_pk?: Maybe<CepTestGroupMembers>;
  /** fetch data from the table in a streaming manner: "cep_test_group_members" */
  cep_test_group_members_stream: Array<CepTestGroupMembers>;
  /** fetch data from the table: "cep_test_groups" */
  cep_test_groups: Array<CepTestGroups>;
  /** fetch aggregated fields from the table: "cep_test_groups" */
  cep_test_groups_aggregate: CepTestGroupsAggregate;
  /** fetch data from the table: "cep_test_groups" using primary key columns */
  cep_test_groups_by_pk?: Maybe<CepTestGroups>;
  /** fetch data from the table in a streaming manner: "cep_test_groups" */
  cep_test_groups_stream: Array<CepTestGroups>;
  /** fetch data from the table: "cep_translations" */
  cep_translations: Array<CepTranslations>;
  /** fetch data from the table: "cep_translations" using primary key columns */
  cep_translations_by_pk?: Maybe<CepTranslations>;
  /** fetch data from the table in a streaming manner: "cep_translations" */
  cep_translations_stream: Array<CepTranslations>;
  /** An array relationship */
  cep_whatsapp_template_locales: Array<CepWhatsappTemplateLocales>;
  /** An aggregate relationship */
  cep_whatsapp_template_locales_aggregate: CepWhatsappTemplateLocalesAggregate;
  /** fetch data from the table: "cep_whatsapp_template_locales" using primary key columns */
  cep_whatsapp_template_locales_by_pk?: Maybe<CepWhatsappTemplateLocales>;
  /** fetch data from the table in a streaming manner: "cep_whatsapp_template_locales" */
  cep_whatsapp_template_locales_stream: Array<CepWhatsappTemplateLocales>;
  /** fetch data from the table: "cep_whatsapp_templates" */
  cep_whatsapp_templates: Array<CepWhatsappTemplates>;
  /** fetch aggregated fields from the table: "cep_whatsapp_templates" */
  cep_whatsapp_templates_aggregate: CepWhatsappTemplatesAggregate;
  /** fetch data from the table: "cep_whatsapp_templates" using primary key columns */
  cep_whatsapp_templates_by_pk?: Maybe<CepWhatsappTemplates>;
  /** fetch data from the table in a streaming manner: "cep_whatsapp_templates" */
  cep_whatsapp_templates_stream: Array<CepWhatsappTemplates>;
  /** fetch data from the table: "cep_workspace_config" */
  cep_workspace_config: Array<CepWorkspaceConfig>;
  /** fetch aggregated fields from the table: "cep_workspace_config" */
  cep_workspace_config_aggregate: CepWorkspaceConfigAggregate;
  /** fetch data from the table: "cep_workspace_config" using primary key columns */
  cep_workspace_config_by_pk?: Maybe<CepWorkspaceConfig>;
  /** fetch data from the table in a streaming manner: "cep_workspace_config" */
  cep_workspace_config_stream: Array<CepWorkspaceConfig>;
  /** fetch data from the table: "cep_workspace_parent_models" */
  cep_workspace_parent_models: Array<CepWorkspaceParentModels>;
  /** fetch aggregated fields from the table: "cep_workspace_parent_models" */
  cep_workspace_parent_models_aggregate: CepWorkspaceParentModelsAggregate;
  /** fetch data from the table: "cep_workspace_parent_models" using primary key columns */
  cep_workspace_parent_models_by_pk?: Maybe<CepWorkspaceParentModels>;
  /** fetch data from the table in a streaming manner: "cep_workspace_parent_models" */
  cep_workspace_parent_models_stream: Array<CepWorkspaceParentModels>;
  /** An array relationship */
  chart_cards: Array<ChartCards>;
  /** fetch data from the table: "chart_cards" using primary key columns */
  chart_cards_by_pk?: Maybe<ChartCards>;
  /** fetch data from the table in a streaming manner: "chart_cards" */
  chart_cards_stream: Array<ChartCards>;
  /** fetch data from the table: "cloud_credentials" */
  cloud_credentials: Array<CloudCredentials>;
  /** fetch data from the table: "cloud_credentials" using primary key columns */
  cloud_credentials_by_pk?: Maybe<CloudCredentials>;
  /** fetch data from the table in a streaming manner: "cloud_credentials" */
  cloud_credentials_stream: Array<CloudCredentials>;
  /** An array relationship */
  competitor_accounts: Array<CompetitorAccounts>;
  /** An aggregate relationship */
  competitor_accounts_aggregate: CompetitorAccountsAggregate;
  /** fetch data from the table: "competitor_accounts" using primary key columns */
  competitor_accounts_by_pk?: Maybe<CompetitorAccounts>;
  /** fetch data from the table in a streaming manner: "competitor_accounts" */
  competitor_accounts_stream: Array<CompetitorAccounts>;
  /** fetch data from the table: "competitor_ad_scrapes" */
  competitor_ad_scrapes: Array<CompetitorAdScrapes>;
  /** fetch data from the table: "competitor_ad_scrapes" using primary key columns */
  competitor_ad_scrapes_by_pk?: Maybe<CompetitorAdScrapes>;
  /** fetch data from the table in a streaming manner: "competitor_ad_scrapes" */
  competitor_ad_scrapes_stream: Array<CompetitorAdScrapes>;
  /** fetch data from the table: "competitors" */
  competitors: Array<Competitors>;
  /** fetch aggregated fields from the table: "competitors" */
  competitors_aggregate: CompetitorsAggregate;
  /** fetch data from the table: "competitors" using primary key columns */
  competitors_by_pk?: Maybe<Competitors>;
  /** fetch data from the table in a streaming manner: "competitors" */
  competitors_stream: Array<Competitors>;
  /** An array relationship */
  condition_template_labels: Array<ConditionTemplateLabels>;
  /** An aggregate relationship */
  condition_template_labels_aggregate: ConditionTemplateLabelsAggregate;
  /** fetch data from the table: "condition_template_labels" using primary key columns */
  condition_template_labels_by_pk?: Maybe<ConditionTemplateLabels>;
  /** fetch data from the table in a streaming manner: "condition_template_labels" */
  condition_template_labels_stream: Array<ConditionTemplateLabels>;
  /** An array relationship */
  connections: Array<Connections>;
  /** An aggregate relationship */
  connections_aggregate: ConnectionsAggregate;
  /** fetch data from the table: "connections" using primary key columns */
  connections_by_pk?: Maybe<Connections>;
  /** fetch data from the table in a streaming manner: "connections" */
  connections_stream: Array<Connections>;
  /** An array relationship */
  content_block_labels: Array<ContentBlockLabels>;
  /** An aggregate relationship */
  content_block_labels_aggregate: ContentBlockLabelsAggregate;
  /** fetch data from the table: "content_block_labels" using primary key columns */
  content_block_labels_by_pk?: Maybe<ContentBlockLabels>;
  /** fetch data from the table in a streaming manner: "content_block_labels" */
  content_block_labels_stream: Array<ContentBlockLabels>;
  /** fetch data from the table: "content_blocks" */
  content_blocks: Array<ContentBlocks>;
  /** fetch aggregated fields from the table: "content_blocks" */
  content_blocks_aggregate: ContentBlocksAggregate;
  /** fetch data from the table: "content_blocks" using primary key columns */
  content_blocks_by_pk?: Maybe<ContentBlocks>;
  /** fetch data from the table in a streaming manner: "content_blocks" */
  content_blocks_stream: Array<ContentBlocks>;
  /** fetch data from the table: "content_deployments" */
  content_deployments: Array<ContentDeployments>;
  /** fetch aggregated fields from the table: "content_deployments" */
  content_deployments_aggregate: ContentDeploymentsAggregate;
  /** fetch data from the table: "content_deployments" using primary key columns */
  content_deployments_by_pk?: Maybe<ContentDeployments>;
  /** fetch data from the table in a streaming manner: "content_deployments" */
  content_deployments_stream: Array<ContentDeployments>;
  /** fetch data from the table: "content_dynamic_slot_assignments" */
  content_dynamic_slot_assignments: Array<ContentDynamicSlotAssignments>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_assignments" */
  content_dynamic_slot_assignments_aggregate: ContentDynamicSlotAssignmentsAggregate;
  /** fetch data from the table: "content_dynamic_slot_assignments" using primary key columns */
  content_dynamic_slot_assignments_by_pk?: Maybe<ContentDynamicSlotAssignments>;
  /** fetch data from the table in a streaming manner: "content_dynamic_slot_assignments" */
  content_dynamic_slot_assignments_stream: Array<ContentDynamicSlotAssignments>;
  /** fetch data from the table: "content_dynamic_slot_branches" */
  content_dynamic_slot_branches: Array<ContentDynamicSlotBranches>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_branches" */
  content_dynamic_slot_branches_aggregate: ContentDynamicSlotBranchesAggregate;
  /** fetch data from the table: "content_dynamic_slot_branches" using primary key columns */
  content_dynamic_slot_branches_by_pk?: Maybe<ContentDynamicSlotBranches>;
  /** fetch data from the table in a streaming manner: "content_dynamic_slot_branches" */
  content_dynamic_slot_branches_stream: Array<ContentDynamicSlotBranches>;
  /** fetch data from the table: "content_dynamic_slot_contents" */
  content_dynamic_slot_contents: Array<ContentDynamicSlotContents>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_contents" */
  content_dynamic_slot_contents_aggregate: ContentDynamicSlotContentsAggregate;
  /** fetch data from the table: "content_dynamic_slot_contents" using primary key columns */
  content_dynamic_slot_contents_by_pk?: Maybe<ContentDynamicSlotContents>;
  /** fetch data from the table in a streaming manner: "content_dynamic_slot_contents" */
  content_dynamic_slot_contents_stream: Array<ContentDynamicSlotContents>;
  /** fetch data from the table: "content_dynamic_slot_libraries" */
  content_dynamic_slot_libraries: Array<ContentDynamicSlotLibraries>;
  /** fetch aggregated fields from the table: "content_dynamic_slot_libraries" */
  content_dynamic_slot_libraries_aggregate: ContentDynamicSlotLibrariesAggregate;
  /** fetch data from the table: "content_dynamic_slot_libraries" using primary key columns */
  content_dynamic_slot_libraries_by_pk?: Maybe<ContentDynamicSlotLibraries>;
  /** fetch data from the table in a streaming manner: "content_dynamic_slot_libraries" */
  content_dynamic_slot_libraries_stream: Array<ContentDynamicSlotLibraries>;
  /** An array relationship */
  content_dynamic_slot_usages: Array<ContentDynamicSlotUsages>;
  /** An aggregate relationship */
  content_dynamic_slot_usages_aggregate: ContentDynamicSlotUsagesAggregate;
  /** fetch data from the table: "content_dynamic_slot_usages" using primary key columns */
  content_dynamic_slot_usages_by_pk?: Maybe<ContentDynamicSlotUsages>;
  /** fetch data from the table in a streaming manner: "content_dynamic_slot_usages" */
  content_dynamic_slot_usages_stream: Array<ContentDynamicSlotUsages>;
  /** An array relationship */
  content_email_message_links: Array<ContentEmailMessageLinks>;
  /** An aggregate relationship */
  content_email_message_links_aggregate: ContentEmailMessageLinksAggregate;
  /** fetch data from the table: "content_email_message_links" using primary key columns */
  content_email_message_links_by_pk?: Maybe<ContentEmailMessageLinks>;
  /** fetch data from the table in a streaming manner: "content_email_message_links" */
  content_email_message_links_stream: Array<ContentEmailMessageLinks>;
  /** An array relationship */
  content_email_variants: Array<ContentEmailVariants>;
  /** An aggregate relationship */
  content_email_variants_aggregate: ContentEmailVariantsAggregate;
  /** fetch data from the table: "content_email_variants" using primary key columns */
  content_email_variants_by_pk?: Maybe<ContentEmailVariants>;
  /** fetch data from the table in a streaming manner: "content_email_variants" */
  content_email_variants_stream: Array<ContentEmailVariants>;
  /** An array relationship */
  content_email_versions: Array<ContentEmailVersions>;
  /** An aggregate relationship */
  content_email_versions_aggregate: ContentEmailVersionsAggregate;
  /** fetch data from the table: "content_email_versions" using primary key columns */
  content_email_versions_by_pk?: Maybe<ContentEmailVersions>;
  /** fetch data from the table in a streaming manner: "content_email_versions" */
  content_email_versions_stream: Array<ContentEmailVersions>;
  /** An array relationship */
  content_emails: Array<ContentEmails>;
  /** An aggregate relationship */
  content_emails_aggregate: ContentEmailsAggregate;
  /** fetch data from the table: "content_emails" using primary key columns */
  content_emails_by_pk?: Maybe<ContentEmails>;
  /** fetch data from the table in a streaming manner: "content_emails" */
  content_emails_stream: Array<ContentEmails>;
  /** fetch data from the table: "content_settings" */
  content_settings: Array<ContentSettings>;
  /** fetch aggregated fields from the table: "content_settings" */
  content_settings_aggregate: ContentSettingsAggregate;
  /** fetch data from the table: "content_settings" using primary key columns */
  content_settings_by_pk?: Maybe<ContentSettings>;
  /** fetch data from the table in a streaming manner: "content_settings" */
  content_settings_stream: Array<ContentSettings>;
  /** fetch data from the table: "content_tags" */
  content_tags: Array<ContentTags>;
  /** fetch aggregated fields from the table: "content_tags" */
  content_tags_aggregate: ContentTagsAggregate;
  /** fetch data from the table: "content_tags" using primary key columns */
  content_tags_by_pk?: Maybe<ContentTags>;
  /** fetch data from the table in a streaming manner: "content_tags" */
  content_tags_stream: Array<ContentTags>;
  /** fetch data from the table: "content_templates" */
  content_templates: Array<ContentTemplates>;
  /** fetch aggregated fields from the table: "content_templates" */
  content_templates_aggregate: ContentTemplatesAggregate;
  /** fetch data from the table: "content_templates" using primary key columns */
  content_templates_by_pk?: Maybe<ContentTemplates>;
  /** fetch data from the table in a streaming manner: "content_templates" */
  content_templates_stream: Array<ContentTemplates>;
  /** fetch data from the table: "current_report_schedule_versions" */
  current_report_schedule_versions: Array<CurrentReportScheduleVersions>;
  /** fetch data from the table in a streaming manner: "current_report_schedule_versions" */
  current_report_schedule_versions_stream: Array<CurrentReportScheduleVersions>;
  /** fetch data from the table: "custom_agents" */
  custom_agents: Array<CustomAgents>;
  /** fetch data from the table: "custom_agents" using primary key columns */
  custom_agents_by_pk?: Maybe<CustomAgents>;
  /** fetch data from the table in a streaming manner: "custom_agents" */
  custom_agents_stream: Array<CustomAgents>;
  /** fetch data from the table: "dashboards" */
  dashboards: Array<Dashboards>;
  /** fetch aggregated fields from the table: "dashboards" */
  dashboards_aggregate: DashboardsAggregate;
  /** fetch data from the table: "dashboards" using primary key columns */
  dashboards_by_pk?: Maybe<Dashboards>;
  /** fetch data from the table in a streaming manner: "dashboards" */
  dashboards_stream: Array<Dashboards>;
  /** fetch data from the table: "datadog_credentials" */
  datadog_credentials: Array<DatadogCredentials>;
  /** fetch data from the table: "datadog_credentials" using primary key columns */
  datadog_credentials_by_pk?: Maybe<DatadogCredentials>;
  /** fetch data from the table in a streaming manner: "datadog_credentials" */
  datadog_credentials_stream: Array<DatadogCredentials>;
  /** fetch data from the table: "dbt_cloud_sync_config" */
  dbt_cloud_sync_config: Array<DbtCloudSyncConfig>;
  /** fetch data from the table: "dbt_cloud_sync_config" using primary key columns */
  dbt_cloud_sync_config_by_pk?: Maybe<DbtCloudSyncConfig>;
  /** fetch data from the table in a streaming manner: "dbt_cloud_sync_config" */
  dbt_cloud_sync_config_stream: Array<DbtCloudSyncConfig>;
  /** fetch data from the table: "dbt_cloud_webhooks" */
  dbt_cloud_webhooks: Array<DbtCloudWebhooks>;
  /** fetch data from the table: "dbt_cloud_webhooks" using primary key columns */
  dbt_cloud_webhooks_by_pk?: Maybe<DbtCloudWebhooks>;
  /** fetch data from the table in a streaming manner: "dbt_cloud_webhooks" */
  dbt_cloud_webhooks_stream: Array<DbtCloudWebhooks>;
  /** fetch data from the table: "dbt_credentials" */
  dbt_credentials: Array<DbtCredentials>;
  /** fetch data from the table: "dbt_credentials" using primary key columns */
  dbt_credentials_by_pk?: Maybe<DbtCredentials>;
  /** fetch data from the table in a streaming manner: "dbt_credentials" */
  dbt_credentials_stream: Array<DbtCredentials>;
  /** fetch data from the table: "dbt_sync_config" */
  dbt_sync_config: Array<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_config" using primary key columns */
  dbt_sync_config_by_pk?: Maybe<DbtSyncConfig>;
  /** fetch data from the table in a streaming manner: "dbt_sync_config" */
  dbt_sync_config_stream: Array<DbtSyncConfig>;
  /** fetch data from the table: "dbt_sync_models" */
  dbt_sync_models: Array<DbtSyncModels>;
  /** fetch data from the table: "dbt_sync_models" using primary key columns */
  dbt_sync_models_by_pk?: Maybe<DbtSyncModels>;
  /** fetch data from the table in a streaming manner: "dbt_sync_models" */
  dbt_sync_models_stream: Array<DbtSyncModels>;
  /** fetch data from the table: "decision_engine_arbitration_group_memberships" */
  decision_engine_arbitration_group_memberships: Array<DecisionEngineArbitrationGroupMemberships>;
  /** fetch aggregated fields from the table: "decision_engine_arbitration_group_memberships" */
  decision_engine_arbitration_group_memberships_aggregate: DecisionEngineArbitrationGroupMembershipsAggregate;
  /** fetch data from the table: "decision_engine_arbitration_group_memberships" using primary key columns */
  decision_engine_arbitration_group_memberships_by_pk?: Maybe<DecisionEngineArbitrationGroupMemberships>;
  /** fetch data from the table in a streaming manner: "decision_engine_arbitration_group_memberships" */
  decision_engine_arbitration_group_memberships_stream: Array<DecisionEngineArbitrationGroupMemberships>;
  /** fetch data from the table: "decision_engine_arbitration_groups" */
  decision_engine_arbitration_groups: Array<DecisionEngineArbitrationGroups>;
  /** fetch aggregated fields from the table: "decision_engine_arbitration_groups" */
  decision_engine_arbitration_groups_aggregate: DecisionEngineArbitrationGroupsAggregate;
  /** fetch data from the table: "decision_engine_arbitration_groups" using primary key columns */
  decision_engine_arbitration_groups_by_pk?: Maybe<DecisionEngineArbitrationGroups>;
  /** fetch data from the table in a streaming manner: "decision_engine_arbitration_groups" */
  decision_engine_arbitration_groups_stream: Array<DecisionEngineArbitrationGroups>;
  /** fetch data from the table: "decision_engine_channels" */
  decision_engine_channels: Array<DecisionEngineChannels>;
  /** fetch data from the table: "decision_engine_channels" using primary key columns */
  decision_engine_channels_by_pk?: Maybe<DecisionEngineChannels>;
  /** fetch data from the table in a streaming manner: "decision_engine_channels" */
  decision_engine_channels_stream: Array<DecisionEngineChannels>;
  /** fetch data from the table: "decision_engine_collections" */
  decision_engine_collections: Array<DecisionEngineCollections>;
  /** fetch data from the table: "decision_engine_collections" using primary key columns */
  decision_engine_collections_by_pk?: Maybe<DecisionEngineCollections>;
  /** fetch data from the table in a streaming manner: "decision_engine_collections" */
  decision_engine_collections_stream: Array<DecisionEngineCollections>;
  /** fetch data from the table: "decision_engine_content_recommendations" */
  decision_engine_content_recommendations: Array<DecisionEngineContentRecommendations>;
  /** fetch aggregated fields from the table: "decision_engine_content_recommendations" */
  decision_engine_content_recommendations_aggregate: DecisionEngineContentRecommendationsAggregate;
  /** fetch data from the table: "decision_engine_content_recommendations" using primary key columns */
  decision_engine_content_recommendations_by_pk?: Maybe<DecisionEngineContentRecommendations>;
  /** fetch data from the table in a streaming manner: "decision_engine_content_recommendations" */
  decision_engine_content_recommendations_stream: Array<DecisionEngineContentRecommendations>;
  /** fetch data from the table: "decision_engine_feature_matrices" */
  decision_engine_feature_matrices: Array<DecisionEngineFeatureMatrices>;
  /** fetch data from the table: "decision_engine_feature_matrices" using primary key columns */
  decision_engine_feature_matrices_by_pk?: Maybe<DecisionEngineFeatureMatrices>;
  /** fetch data from the table in a streaming manner: "decision_engine_feature_matrices" */
  decision_engine_feature_matrices_stream: Array<DecisionEngineFeatureMatrices>;
  /** fetch data from the table: "decision_engine_feature_matrix_relationships" */
  decision_engine_feature_matrix_relationships: Array<DecisionEngineFeatureMatrixRelationships>;
  /** fetch data from the table: "decision_engine_feature_matrix_relationships" using primary key columns */
  decision_engine_feature_matrix_relationships_by_pk?: Maybe<DecisionEngineFeatureMatrixRelationships>;
  /** fetch data from the table in a streaming manner: "decision_engine_feature_matrix_relationships" */
  decision_engine_feature_matrix_relationships_stream: Array<DecisionEngineFeatureMatrixRelationships>;
  /** fetch data from the table: "decision_engine_flow_channel_sync" */
  decision_engine_flow_channel_sync: Array<DecisionEngineFlowChannelSync>;
  /** fetch data from the table: "decision_engine_flow_channel_sync" using primary key columns */
  decision_engine_flow_channel_sync_by_pk?: Maybe<DecisionEngineFlowChannelSync>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_channel_sync" */
  decision_engine_flow_channel_sync_stream: Array<DecisionEngineFlowChannelSync>;
  /** fetch data from the table: "decision_engine_flow_charts" */
  decision_engine_flow_charts: Array<DecisionEngineFlowCharts>;
  /** fetch data from the table: "decision_engine_flow_charts" using primary key columns */
  decision_engine_flow_charts_by_pk?: Maybe<DecisionEngineFlowCharts>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_charts" */
  decision_engine_flow_charts_stream: Array<DecisionEngineFlowCharts>;
  /** fetch data from the table: "decision_engine_flow_experiments" */
  decision_engine_flow_experiments: Array<DecisionEngineFlowExperiments>;
  /** fetch data from the table: "decision_engine_flow_experiments" using primary key columns */
  decision_engine_flow_experiments_by_pk?: Maybe<DecisionEngineFlowExperiments>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_experiments" */
  decision_engine_flow_experiments_stream: Array<DecisionEngineFlowExperiments>;
  /** fetch data from the table: "decision_engine_flow_messages" */
  decision_engine_flow_messages: Array<DecisionEngineFlowMessages>;
  /** fetch data from the table: "decision_engine_flow_messages" using primary key columns */
  decision_engine_flow_messages_by_pk?: Maybe<DecisionEngineFlowMessages>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_messages" */
  decision_engine_flow_messages_stream: Array<DecisionEngineFlowMessages>;
  /** fetch data from the table: "decision_engine_flow_outcomes" */
  decision_engine_flow_outcomes: Array<DecisionEngineFlowOutcomes>;
  /** fetch data from the table: "decision_engine_flow_outcomes" using primary key columns */
  decision_engine_flow_outcomes_by_pk?: Maybe<DecisionEngineFlowOutcomes>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_outcomes" */
  decision_engine_flow_outcomes_stream: Array<DecisionEngineFlowOutcomes>;
  /** fetch data from the table: "decision_engine_flow_override_periods" */
  decision_engine_flow_override_periods: Array<DecisionEngineFlowOverridePeriods>;
  /** fetch data from the table: "decision_engine_flow_override_periods" using primary key columns */
  decision_engine_flow_override_periods_by_pk?: Maybe<DecisionEngineFlowOverridePeriods>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_override_periods" */
  decision_engine_flow_override_periods_stream: Array<DecisionEngineFlowOverridePeriods>;
  /** fetch data from the table: "decision_engine_flow_runs" */
  decision_engine_flow_runs: Array<DecisionEngineFlowRuns>;
  /** fetch aggregated fields from the table: "decision_engine_flow_runs" */
  decision_engine_flow_runs_aggregate: DecisionEngineFlowRunsAggregate;
  /** fetch data from the table: "decision_engine_flow_runs" using primary key columns */
  decision_engine_flow_runs_by_pk?: Maybe<DecisionEngineFlowRuns>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_runs" */
  decision_engine_flow_runs_stream: Array<DecisionEngineFlowRuns>;
  /** fetch data from the table: "decision_engine_flow_tags" */
  decision_engine_flow_tags: Array<DecisionEngineFlowTags>;
  /** fetch data from the table: "decision_engine_flow_tags" using primary key columns */
  decision_engine_flow_tags_by_pk?: Maybe<DecisionEngineFlowTags>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_tags" */
  decision_engine_flow_tags_stream: Array<DecisionEngineFlowTags>;
  /** fetch data from the table: "decision_engine_flow_volume_ramps" */
  decision_engine_flow_volume_ramps: Array<DecisionEngineFlowVolumeRamps>;
  /** fetch data from the table: "decision_engine_flow_volume_ramps" using primary key columns */
  decision_engine_flow_volume_ramps_by_pk?: Maybe<DecisionEngineFlowVolumeRamps>;
  /** fetch data from the table in a streaming manner: "decision_engine_flow_volume_ramps" */
  decision_engine_flow_volume_ramps_stream: Array<DecisionEngineFlowVolumeRamps>;
  /** fetch data from the table: "decision_engine_flows" */
  decision_engine_flows: Array<DecisionEngineFlows>;
  /** fetch data from the table: "decision_engine_flows" using primary key columns */
  decision_engine_flows_by_pk?: Maybe<DecisionEngineFlows>;
  /** fetch data from the table in a streaming manner: "decision_engine_flows" */
  decision_engine_flows_stream: Array<DecisionEngineFlows>;
  /** fetch data from the table: "decision_engine_interaction_manifests" */
  decision_engine_interaction_manifests: Array<DecisionEngineInteractionManifests>;
  /** fetch data from the table: "decision_engine_interaction_manifests" using primary key columns */
  decision_engine_interaction_manifests_by_pk?: Maybe<DecisionEngineInteractionManifests>;
  /** fetch data from the table in a streaming manner: "decision_engine_interaction_manifests" */
  decision_engine_interaction_manifests_stream: Array<DecisionEngineInteractionManifests>;
  /** fetch data from the table: "decision_engine_message_collections" */
  decision_engine_message_collections: Array<DecisionEngineMessageCollections>;
  /** fetch data from the table: "decision_engine_message_collections" using primary key columns */
  decision_engine_message_collections_by_pk?: Maybe<DecisionEngineMessageCollections>;
  /** fetch data from the table in a streaming manner: "decision_engine_message_collections" */
  decision_engine_message_collections_stream: Array<DecisionEngineMessageCollections>;
  /** fetch data from the table: "decision_engine_message_variant_suggestions" */
  decision_engine_message_variant_suggestions: Array<DecisionEngineMessageVariantSuggestions>;
  /** fetch data from the table: "decision_engine_message_variant_suggestions" using primary key columns */
  decision_engine_message_variant_suggestions_by_pk?: Maybe<DecisionEngineMessageVariantSuggestions>;
  /** fetch data from the table in a streaming manner: "decision_engine_message_variant_suggestions" */
  decision_engine_message_variant_suggestions_stream: Array<DecisionEngineMessageVariantSuggestions>;
  /** fetch data from the table: "decision_engine_messages" */
  decision_engine_messages: Array<DecisionEngineMessages>;
  /** fetch aggregated fields from the table: "decision_engine_messages" */
  decision_engine_messages_aggregate: DecisionEngineMessagesAggregate;
  /** fetch data from the table: "decision_engine_messages" using primary key columns */
  decision_engine_messages_by_pk?: Maybe<DecisionEngineMessages>;
  /** fetch data from the table in a streaming manner: "decision_engine_messages" */
  decision_engine_messages_stream: Array<DecisionEngineMessages>;
  /** fetch data from the table: "decision_engine_model_outcomes" */
  decision_engine_model_outcomes: Array<DecisionEngineModelOutcomes>;
  /** fetch data from the table: "decision_engine_model_outcomes" using primary key columns */
  decision_engine_model_outcomes_by_pk?: Maybe<DecisionEngineModelOutcomes>;
  /** fetch data from the table in a streaming manner: "decision_engine_model_outcomes" */
  decision_engine_model_outcomes_stream: Array<DecisionEngineModelOutcomes>;
  /** fetch data from the table: "decision_engine_models" */
  decision_engine_models: Array<DecisionEngineModels>;
  /** fetch data from the table: "decision_engine_models" using primary key columns */
  decision_engine_models_by_pk?: Maybe<DecisionEngineModels>;
  /** fetch data from the table in a streaming manner: "decision_engine_models" */
  decision_engine_models_stream: Array<DecisionEngineModels>;
  /** fetch data from the table: "decision_engine_offers" */
  decision_engine_offers: Array<DecisionEngineOffers>;
  /** fetch data from the table: "decision_engine_offers" using primary key columns */
  decision_engine_offers_by_pk?: Maybe<DecisionEngineOffers>;
  /** fetch data from the table in a streaming manner: "decision_engine_offers" */
  decision_engine_offers_stream: Array<DecisionEngineOffers>;
  /** fetch data from the table: "decision_engine_outcomes" */
  decision_engine_outcomes: Array<DecisionEngineOutcomes>;
  /** fetch data from the table: "decision_engine_outcomes" using primary key columns */
  decision_engine_outcomes_by_pk?: Maybe<DecisionEngineOutcomes>;
  /** fetch data from the table in a streaming manner: "decision_engine_outcomes" */
  decision_engine_outcomes_stream: Array<DecisionEngineOutcomes>;
  /** fetch data from the table: "decision_engine_send_events" */
  decision_engine_send_events: Array<DecisionEngineSendEvents>;
  /** fetch data from the table: "decision_engine_send_events" using primary key columns */
  decision_engine_send_events_by_pk?: Maybe<DecisionEngineSendEvents>;
  /** fetch data from the table in a streaming manner: "decision_engine_send_events" */
  decision_engine_send_events_stream: Array<DecisionEngineSendEvents>;
  /** fetch data from the table: "decision_engine_splits" */
  decision_engine_splits: Array<DecisionEngineSplits>;
  /** fetch data from the table: "decision_engine_splits" using primary key columns */
  decision_engine_splits_by_pk?: Maybe<DecisionEngineSplits>;
  /** fetch data from the table in a streaming manner: "decision_engine_splits" */
  decision_engine_splits_stream: Array<DecisionEngineSplits>;
  /** fetch data from the table: "decision_engines" */
  decision_engines: Array<DecisionEngines>;
  /** fetch data from the table: "decision_engines" using primary key columns */
  decision_engines_by_pk?: Maybe<DecisionEngines>;
  /** fetch data from the table in a streaming manner: "decision_engines" */
  decision_engines_stream: Array<DecisionEngines>;
  /** fetch data from the table: "deliverability_feeds" */
  deliverability_feeds: Array<DeliverabilityFeeds>;
  /** fetch aggregated fields from the table: "deliverability_feeds" */
  deliverability_feeds_aggregate: DeliverabilityFeedsAggregate;
  /** fetch data from the table: "deliverability_feeds" using primary key columns */
  deliverability_feeds_by_pk?: Maybe<DeliverabilityFeeds>;
  /** fetch data from the table in a streaming manner: "deliverability_feeds" */
  deliverability_feeds_stream: Array<DeliverabilityFeeds>;
  /** fetch data from the table: "deployment_history" */
  deployment_history: Array<DeploymentHistory>;
  /** fetch data from the table: "deployment_history" using primary key columns */
  deployment_history_by_pk?: Maybe<DeploymentHistory>;
  /** fetch data from the table in a streaming manner: "deployment_history" */
  deployment_history_stream: Array<DeploymentHistory>;
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  /** fetch data from the table: "destination_instance_splits" using primary key columns */
  destination_instance_splits_by_pk?: Maybe<DestinationInstanceSplits>;
  /** fetch data from the table in a streaming manner: "destination_instance_splits" */
  destination_instance_splits_stream: Array<DestinationInstanceSplits>;
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  /** fetch data from the table: "destination_instances" using primary key columns */
  destination_instances_by_pk?: Maybe<DestinationInstances>;
  /** fetch data from the table in a streaming manner: "destination_instances" */
  destination_instances_stream: Array<DestinationInstances>;
  /** An array relationship */
  destination_rules: Array<DestinationRules>;
  /** An aggregate relationship */
  destination_rules_aggregate: DestinationRulesAggregate;
  /** fetch data from the table: "destination_rules" using primary key columns */
  destination_rules_by_pk?: Maybe<DestinationRules>;
  /** fetch data from the table in a streaming manner: "destination_rules" */
  destination_rules_stream: Array<DestinationRules>;
  /** An array relationship */
  destinations: Array<Destinations>;
  /** An aggregate relationship */
  destinations_aggregate: DestinationsAggregate;
  /** fetch data from the table: "destinations" using primary key columns */
  destinations_by_pk?: Maybe<Destinations>;
  /** fetch data from the table in a streaming manner: "destinations" */
  destinations_stream: Array<Destinations>;
  /** fetch data from the table: "direct_model_relationships" */
  direct_model_relationships: Array<DirectModelRelationships>;
  /** fetch data from the table: "direct_model_relationships" using primary key columns */
  direct_model_relationships_by_pk?: Maybe<DirectModelRelationships>;
  /** fetch data from the table in a streaming manner: "direct_model_relationships" */
  direct_model_relationships_stream: Array<DirectModelRelationships>;
  /** fetch data from the table: "draft_approval_requests" */
  draft_approval_requests: Array<DraftApprovalRequests>;
  /** fetch data from the table: "draft_approval_requests" using primary key columns */
  draft_approval_requests_by_pk?: Maybe<DraftApprovalRequests>;
  /** fetch data from the table in a streaming manner: "draft_approval_requests" */
  draft_approval_requests_stream: Array<DraftApprovalRequests>;
  /** fetch data from the table: "drafts" */
  drafts: Array<Drafts>;
  /** fetch aggregated fields from the table: "drafts" */
  drafts_aggregate: DraftsAggregate;
  /** fetch data from the table: "drafts" using primary key columns */
  drafts_by_pk?: Maybe<Drafts>;
  /** fetch data from the table in a streaming manner: "drafts" */
  drafts_stream: Array<Drafts>;
  /** An array relationship */
  email_template_labels: Array<EmailTemplateLabels>;
  /** An aggregate relationship */
  email_template_labels_aggregate: EmailTemplateLabelsAggregate;
  /** fetch data from the table: "email_template_labels" using primary key columns */
  email_template_labels_by_pk?: Maybe<EmailTemplateLabels>;
  /** fetch data from the table in a streaming manner: "email_template_labels" */
  email_template_labels_stream: Array<EmailTemplateLabels>;
  /** fetch data from the table: "esp_catalog_state" */
  esp_catalog_state: Array<EspCatalogState>;
  /** fetch data from the table: "esp_catalog_state" using primary key columns */
  esp_catalog_state_by_pk?: Maybe<EspCatalogState>;
  /** fetch data from the table in a streaming manner: "esp_catalog_state" */
  esp_catalog_state_stream: Array<EspCatalogState>;
  /** fetch data from the table: "esp_content_blocks" */
  esp_content_blocks: Array<EspContentBlocks>;
  /** fetch aggregated fields from the table: "esp_content_blocks" */
  esp_content_blocks_aggregate: EspContentBlocksAggregate;
  /** fetch data from the table: "esp_content_blocks" using primary key columns */
  esp_content_blocks_by_pk?: Maybe<EspContentBlocks>;
  /** fetch data from the table in a streaming manner: "esp_content_blocks" */
  esp_content_blocks_stream: Array<EspContentBlocks>;
  /** fetch data from the table: "esp_user_fields" */
  esp_user_fields: Array<EspUserFields>;
  /** fetch aggregated fields from the table: "esp_user_fields" */
  esp_user_fields_aggregate: EspUserFieldsAggregate;
  /** fetch data from the table: "esp_user_fields" using primary key columns */
  esp_user_fields_by_pk?: Maybe<EspUserFields>;
  /** fetch data from the table in a streaming manner: "esp_user_fields" */
  esp_user_fields_stream: Array<EspUserFields>;
  /** fetch data from the table: "etl_connections" */
  etl_connections: Array<EtlConnections>;
  /** fetch aggregated fields from the table: "etl_connections" */
  etl_connections_aggregate: EtlConnectionsAggregate;
  /** fetch data from the table: "etl_connections" using primary key columns */
  etl_connections_by_pk?: Maybe<EtlConnections>;
  /** fetch data from the table in a streaming manner: "etl_connections" */
  etl_connections_stream: Array<EtlConnections>;
  /** fetch data from the table: "etl_sync_runs" */
  etl_sync_runs: Array<EtlSyncRuns>;
  /** fetch data from the table: "etl_sync_runs" using primary key columns */
  etl_sync_runs_by_pk?: Maybe<EtlSyncRuns>;
  /** fetch data from the table in a streaming manner: "etl_sync_runs" */
  etl_sync_runs_stream: Array<EtlSyncRuns>;
  /** An array relationship */
  event_components: Array<EventComponents>;
  /** An aggregate relationship */
  event_components_aggregate: EventComponentsAggregate;
  /** fetch data from the table: "event_components" using primary key columns */
  event_components_by_pk?: Maybe<EventComponents>;
  /** An array relationship */
  event_components_conditions: Array<EventComponentsConditions>;
  /** An aggregate relationship */
  event_components_conditions_aggregate: EventComponentsConditionsAggregate;
  /** fetch data from the table: "event_components_conditions" using primary key columns */
  event_components_conditions_by_pk?: Maybe<EventComponentsConditions>;
  /** fetch data from the table in a streaming manner: "event_components_conditions" */
  event_components_conditions_stream: Array<EventComponentsConditions>;
  /** fetch data from the table: "event_components_join" */
  event_components_join: Array<EventComponentsJoin>;
  /** fetch aggregated fields from the table: "event_components_join" */
  event_components_join_aggregate: EventComponentsJoinAggregate;
  /** fetch data from the table: "event_components_join" using primary key columns */
  event_components_join_by_pk?: Maybe<EventComponentsJoin>;
  /** fetch data from the table in a streaming manner: "event_components_join" */
  event_components_join_stream: Array<EventComponentsJoin>;
  /** fetch data from the table in a streaming manner: "event_components" */
  event_components_stream: Array<EventComponents>;
  /** fetch data from the table: "event_contracts" */
  event_contracts: Array<EventContracts>;
  /** fetch data from the table: "event_contracts" using primary key columns */
  event_contracts_by_pk?: Maybe<EventContracts>;
  /** fetch data from the table: "event_contracts_schema" */
  event_contracts_schema: Array<EventContractsSchema>;
  /** fetch data from the table: "event_contracts_schema" using primary key columns */
  event_contracts_schema_by_pk?: Maybe<EventContractsSchema>;
  /** fetch data from the table in a streaming manner: "event_contracts_schema" */
  event_contracts_schema_stream: Array<EventContractsSchema>;
  /** fetch data from the table in a streaming manner: "event_contracts" */
  event_contracts_stream: Array<EventContracts>;
  /** fetch data from the table: "event_forwarding_destination_grants" */
  event_forwarding_destination_grants: Array<EventForwardingDestinationGrants>;
  /** fetch aggregated fields from the table: "event_forwarding_destination_grants" */
  event_forwarding_destination_grants_aggregate: EventForwardingDestinationGrantsAggregate;
  /** fetch data from the table: "event_forwarding_destination_grants" using primary key columns */
  event_forwarding_destination_grants_by_pk?: Maybe<EventForwardingDestinationGrants>;
  /** fetch data from the table in a streaming manner: "event_forwarding_destination_grants" */
  event_forwarding_destination_grants_stream: Array<EventForwardingDestinationGrants>;
  /** An array relationship */
  event_forwarding_sync_sources: Array<EventForwardingSyncSources>;
  /** An aggregate relationship */
  event_forwarding_sync_sources_aggregate: EventForwardingSyncSourcesAggregate;
  /** fetch data from the table: "event_forwarding_sync_sources" using primary key columns */
  event_forwarding_sync_sources_by_pk?: Maybe<EventForwardingSyncSources>;
  /** fetch data from the table in a streaming manner: "event_forwarding_sync_sources" */
  event_forwarding_sync_sources_stream: Array<EventForwardingSyncSources>;
  /** An array relationship */
  event_forwarding_syncs: Array<EventForwardingSyncs>;
  /** fetch data from the table: "event_forwarding_syncs" using primary key columns */
  event_forwarding_syncs_by_pk?: Maybe<EventForwardingSyncs>;
  /** fetch data from the table in a streaming manner: "event_forwarding_syncs" */
  event_forwarding_syncs_stream: Array<EventForwardingSyncs>;
  /** An array relationship */
  event_model_event_sources: Array<EventModelEventSources>;
  /** An aggregate relationship */
  event_model_event_sources_aggregate: EventModelEventSourcesAggregate;
  /** fetch data from the table: "event_model_event_sources" using primary key columns */
  event_model_event_sources_by_pk?: Maybe<EventModelEventSources>;
  /** fetch data from the table in a streaming manner: "event_model_event_sources" */
  event_model_event_sources_stream: Array<EventModelEventSources>;
  /** fetch data from the table: "event_models" */
  event_models: Array<EventModels>;
  /** fetch data from the table: "event_models" using primary key columns */
  event_models_by_pk?: Maybe<EventModels>;
  /** fetch data from the table in a streaming manner: "event_models" */
  event_models_stream: Array<EventModels>;
  /** fetch data from the table: "event_plan_grants" */
  event_plan_grants: Array<EventPlanGrants>;
  /** fetch aggregated fields from the table: "event_plan_grants" */
  event_plan_grants_aggregate: EventPlanGrantsAggregate;
  /** fetch data from the table: "event_plan_grants" using primary key columns */
  event_plan_grants_by_pk?: Maybe<EventPlanGrants>;
  /** fetch data from the table in a streaming manner: "event_plan_grants" */
  event_plan_grants_stream: Array<EventPlanGrants>;
  /** fetch data from the table: "event_plans" */
  event_plans: Array<EventPlans>;
  /** fetch aggregated fields from the table: "event_plans" */
  event_plans_aggregate: EventPlansAggregate;
  /** fetch data from the table: "event_plans" using primary key columns */
  event_plans_by_pk?: Maybe<EventPlans>;
  /** fetch data from the table in a streaming manner: "event_plans" */
  event_plans_stream: Array<EventPlans>;
  /** An array relationship */
  event_schema_components: Array<EventSchemaComponents>;
  /** An aggregate relationship */
  event_schema_components_aggregate: EventSchemaComponentsAggregate;
  /** fetch data from the table: "event_schema_components" using primary key columns */
  event_schema_components_by_pk?: Maybe<EventSchemaComponents>;
  /** fetch data from the table in a streaming manner: "event_schema_components" */
  event_schema_components_stream: Array<EventSchemaComponents>;
  /** An array relationship */
  event_schemas: Array<EventSchemas>;
  /** An aggregate relationship */
  event_schemas_aggregate: EventSchemasAggregate;
  /** fetch data from the table: "event_schemas" using primary key columns */
  event_schemas_by_pk?: Maybe<EventSchemas>;
  /** fetch data from the table in a streaming manner: "event_schemas" */
  event_schemas_stream: Array<EventSchemas>;
  /** fetch data from the table: "event_source_contracts" */
  event_source_contracts: Array<EventSourceContracts>;
  /** fetch data from the table: "event_source_contracts" using primary key columns */
  event_source_contracts_by_pk?: Maybe<EventSourceContracts>;
  /** fetch data from the table in a streaming manner: "event_source_contracts" */
  event_source_contracts_stream: Array<EventSourceContracts>;
  /** fetch data from the table: "event_source_grants" */
  event_source_grants: Array<EventSourceGrants>;
  /** fetch aggregated fields from the table: "event_source_grants" */
  event_source_grants_aggregate: EventSourceGrantsAggregate;
  /** fetch data from the table: "event_source_grants" using primary key columns */
  event_source_grants_by_pk?: Maybe<EventSourceGrants>;
  /** fetch data from the table in a streaming manner: "event_source_grants" */
  event_source_grants_stream: Array<EventSourceGrants>;
  /** fetch data from the table: "event_sources" */
  event_sources: Array<EventSources>;
  /** fetch aggregated fields from the table: "event_sources" */
  event_sources_aggregate: EventSourcesAggregate;
  /** fetch data from the table: "event_sources" using primary key columns */
  event_sources_by_pk?: Maybe<EventSources>;
  /** An array relationship */
  event_sources_plans: Array<EventSourcesPlans>;
  /** An aggregate relationship */
  event_sources_plans_aggregate: EventSourcesPlansAggregate;
  /** fetch data from the table: "event_sources_plans" using primary key columns */
  event_sources_plans_by_pk?: Maybe<EventSourcesPlans>;
  /** fetch data from the table in a streaming manner: "event_sources_plans" */
  event_sources_plans_stream: Array<EventSourcesPlans>;
  /** fetch data from the table in a streaming manner: "event_sources" */
  event_sources_stream: Array<EventSources>;
  /** fetch data from the table: "event_warehouse_destination_grants" */
  event_warehouse_destination_grants: Array<EventWarehouseDestinationGrants>;
  /** fetch aggregated fields from the table: "event_warehouse_destination_grants" */
  event_warehouse_destination_grants_aggregate: EventWarehouseDestinationGrantsAggregate;
  /** fetch data from the table: "event_warehouse_destination_grants" using primary key columns */
  event_warehouse_destination_grants_by_pk?: Maybe<EventWarehouseDestinationGrants>;
  /** fetch data from the table in a streaming manner: "event_warehouse_destination_grants" */
  event_warehouse_destination_grants_stream: Array<EventWarehouseDestinationGrants>;
  /** fetch data from the table: "event_warehouse_destinations" */
  event_warehouse_destinations: Array<EventWarehouseDestinations>;
  /** fetch aggregated fields from the table: "event_warehouse_destinations" */
  event_warehouse_destinations_aggregate: EventWarehouseDestinationsAggregate;
  /** fetch data from the table: "event_warehouse_destinations" using primary key columns */
  event_warehouse_destinations_by_pk?: Maybe<EventWarehouseDestinations>;
  /** fetch data from the table in a streaming manner: "event_warehouse_destinations" */
  event_warehouse_destinations_stream: Array<EventWarehouseDestinations>;
  /** An array relationship */
  event_warehouse_sync_sources: Array<EventWarehouseSyncSources>;
  /** An aggregate relationship */
  event_warehouse_sync_sources_aggregate: EventWarehouseSyncSourcesAggregate;
  /** fetch data from the table: "event_warehouse_sync_sources" using primary key columns */
  event_warehouse_sync_sources_by_pk?: Maybe<EventWarehouseSyncSources>;
  /** fetch data from the table in a streaming manner: "event_warehouse_sync_sources" */
  event_warehouse_sync_sources_stream: Array<EventWarehouseSyncSources>;
  /** An array relationship */
  event_warehouse_syncs: Array<EventWarehouseSyncs>;
  /** An aggregate relationship */
  event_warehouse_syncs_aggregate: EventWarehouseSyncsAggregate;
  /** fetch data from the table: "event_warehouse_syncs" using primary key columns */
  event_warehouse_syncs_by_pk?: Maybe<EventWarehouseSyncs>;
  /** fetch data from the table in a streaming manner: "event_warehouse_syncs" */
  event_warehouse_syncs_stream: Array<EventWarehouseSyncs>;
  /** An array relationship */
  experiment_metrics: Array<ExperimentMetrics>;
  /** fetch data from the table: "experiment_metrics" using primary key columns */
  experiment_metrics_by_pk?: Maybe<ExperimentMetrics>;
  /** fetch data from the table in a streaming manner: "experiment_metrics" */
  experiment_metrics_stream: Array<ExperimentMetrics>;
  /** fetch data from the table: "experiments" */
  experiments: Array<Experiments>;
  /** fetch aggregated fields from the table: "experiments" */
  experiments_aggregate: ExperimentsAggregate;
  /** fetch data from the table: "experiments" using primary key columns */
  experiments_by_pk?: Maybe<Experiments>;
  /** fetch data from the table in a streaming manner: "experiments" */
  experiments_stream: Array<Experiments>;
  /** fetch data from the table: "exposure_log_resolution_runs" */
  exposure_log_resolution_runs: Array<ExposureLogResolutionRuns>;
  /** fetch data from the table: "exposure_log_resolution_runs" using primary key columns */
  exposure_log_resolution_runs_by_pk?: Maybe<ExposureLogResolutionRuns>;
  /** fetch data from the table in a streaming manner: "exposure_log_resolution_runs" */
  exposure_log_resolution_runs_stream: Array<ExposureLogResolutionRuns>;
  /** fetch data from the table: "extensions" */
  extensions: Array<Extensions>;
  /** fetch aggregated fields from the table: "extensions" */
  extensions_aggregate: ExtensionsAggregate;
  /** fetch data from the table: "extensions" using primary key columns */
  extensions_by_pk?: Maybe<Extensions>;
  /** fetch data from the table in a streaming manner: "extensions" */
  extensions_stream: Array<Extensions>;
  /** fetch data from the table: "external_buckets" */
  external_buckets: Array<ExternalBuckets>;
  /** fetch data from the table: "external_buckets" using primary key columns */
  external_buckets_by_pk?: Maybe<ExternalBuckets>;
  /** fetch data from the table in a streaming manner: "external_buckets" */
  external_buckets_stream: Array<ExternalBuckets>;
  /** fetch data from the table: "external_context_sources" */
  external_context_sources: Array<ExternalContextSources>;
  /** fetch aggregated fields from the table: "external_context_sources" */
  external_context_sources_aggregate: ExternalContextSourcesAggregate;
  /** fetch data from the table: "external_context_sources" using primary key columns */
  external_context_sources_by_pk?: Maybe<ExternalContextSources>;
  /** fetch data from the table in a streaming manner: "external_context_sources" */
  external_context_sources_stream: Array<ExternalContextSources>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  /** fetch data from the table: "external_segments" using primary key columns */
  external_segments_by_pk?: Maybe<ExternalSegments>;
  /** fetch data from the table in a streaming manner: "external_segments" */
  external_segments_stream: Array<ExternalSegments>;
  /** An array relationship */
  figma_import_drafts: Array<FigmaImportDrafts>;
  /** fetch data from the table: "figma_import_drafts" using primary key columns */
  figma_import_drafts_by_pk?: Maybe<FigmaImportDrafts>;
  /** fetch data from the table in a streaming manner: "figma_import_drafts" */
  figma_import_drafts_stream: Array<FigmaImportDrafts>;
  /** fetch data from the table: "fivetran_agent_syncs" */
  fivetran_agent_syncs: Array<FivetranAgentSyncs>;
  /** fetch data from the table: "fivetran_agent_syncs" using primary key columns */
  fivetran_agent_syncs_by_pk?: Maybe<FivetranAgentSyncs>;
  /** fetch data from the table in a streaming manner: "fivetran_agent_syncs" */
  fivetran_agent_syncs_stream: Array<FivetranAgentSyncs>;
  /** fetch data from the table: "fivetran_credentials" */
  fivetran_credentials: Array<FivetranCredentials>;
  /** fetch data from the table: "fivetran_credentials" using primary key columns */
  fivetran_credentials_by_pk?: Maybe<FivetranCredentials>;
  /** fetch data from the table in a streaming manner: "fivetran_credentials" */
  fivetran_credentials_stream: Array<FivetranCredentials>;
  /** fetch data from the table: "folders" */
  folders: Array<Folders>;
  /** fetch data from the table: "folders" using primary key columns */
  folders_by_pk?: Maybe<Folders>;
  /** fetch data from the table in a streaming manner: "folders" */
  folders_stream: Array<Folders>;
  /** fetch data from the table: "function_grants" */
  function_grants: Array<FunctionGrants>;
  /** fetch aggregated fields from the table: "function_grants" */
  function_grants_aggregate: FunctionGrantsAggregate;
  /** fetch data from the table: "function_grants" using primary key columns */
  function_grants_by_pk?: Maybe<FunctionGrants>;
  /** fetch data from the table in a streaming manner: "function_grants" */
  function_grants_stream: Array<FunctionGrants>;
  /** An array relationship */
  function_resources: Array<FunctionResources>;
  /** An aggregate relationship */
  function_resources_aggregate: FunctionResourcesAggregate;
  /** fetch data from the table: "function_resources" using primary key columns */
  function_resources_by_pk?: Maybe<FunctionResources>;
  /** fetch data from the table in a streaming manner: "function_resources" */
  function_resources_stream: Array<FunctionResources>;
  /** An array relationship */
  function_settings: Array<FunctionSettings>;
  /** fetch data from the table: "function_settings" using primary key columns */
  function_settings_by_pk?: Maybe<FunctionSettings>;
  /** fetch data from the table in a streaming manner: "function_settings" */
  function_settings_stream: Array<FunctionSettings>;
  /** An array relationship */
  functions: Array<Functions>;
  /** fetch data from the table: "functions" using primary key columns */
  functions_by_pk?: Maybe<Functions>;
  /** fetch data from the table in a streaming manner: "functions" */
  functions_stream: Array<Functions>;
  /** fetch data from the table: "git_credentials" */
  git_credentials: Array<GitCredentials>;
  /** fetch data from the table: "git_credentials" using primary key columns */
  git_credentials_by_pk?: Maybe<GitCredentials>;
  /** fetch data from the table in a streaming manner: "git_credentials" */
  git_credentials_stream: Array<GitCredentials>;
  /** An array relationship */
  git_inbound_runs: Array<GitInboundRuns>;
  /** fetch data from the table: "git_inbound_runs" using primary key columns */
  git_inbound_runs_by_pk?: Maybe<GitInboundRuns>;
  /** fetch data from the table in a streaming manner: "git_inbound_runs" */
  git_inbound_runs_stream: Array<GitInboundRuns>;
  /** An array relationship */
  git_outbound_runs: Array<GitOutboundRuns>;
  /** fetch data from the table: "git_outbound_runs" using primary key columns */
  git_outbound_runs_by_pk?: Maybe<GitOutboundRuns>;
  /** fetch data from the table in a streaming manner: "git_outbound_runs" */
  git_outbound_runs_stream: Array<GitOutboundRuns>;
  /** fetch data from the table: "git_sync_configs" */
  git_sync_configs: Array<GitSyncConfigs>;
  /** fetch data from the table: "git_sync_configs" using primary key columns */
  git_sync_configs_by_pk?: Maybe<GitSyncConfigs>;
  /** fetch data from the table in a streaming manner: "git_sync_configs" */
  git_sync_configs_stream: Array<GitSyncConfigs>;
  /** An array relationship */
  goal_metrics: Array<GoalMetrics>;
  /** fetch data from the table: "goal_metrics" using primary key columns */
  goal_metrics_by_pk?: Maybe<GoalMetrics>;
  /** fetch data from the table in a streaming manner: "goal_metrics" */
  goal_metrics_stream: Array<GoalMetrics>;
  /** fetch data from the table: "goals" */
  goals: Array<Goals>;
  /** fetch aggregated fields from the table: "goals" */
  goals_aggregate: GoalsAggregate;
  /** An array relationship */
  goals_attribution_methods: Array<GoalsAttributionMethods>;
  /** fetch data from the table: "goals_attribution_methods" using primary key columns */
  goals_attribution_methods_by_pk?: Maybe<GoalsAttributionMethods>;
  /** fetch data from the table in a streaming manner: "goals_attribution_methods" */
  goals_attribution_methods_stream: Array<GoalsAttributionMethods>;
  /** fetch data from the table: "goals" using primary key columns */
  goals_by_pk?: Maybe<Goals>;
  /** fetch data from the table in a streaming manner: "goals" */
  goals_stream: Array<Goals>;
  /** fetch data from the table: "idr" */
  idr: Array<Idr>;
  /** fetch data from the table: "idr" using primary key columns */
  idr_by_pk?: Maybe<Idr>;
  /** An array relationship */
  idr_golden_record_base_columns: Array<IdrGoldenRecordBaseColumns>;
  /** fetch data from the table: "idr_golden_record_base_columns" using primary key columns */
  idr_golden_record_base_columns_by_pk?: Maybe<IdrGoldenRecordBaseColumns>;
  /** fetch data from the table in a streaming manner: "idr_golden_record_base_columns" */
  idr_golden_record_base_columns_stream: Array<IdrGoldenRecordBaseColumns>;
  /** fetch data from the table: "idr_golden_record_column_source_survivorship" */
  idr_golden_record_column_source_survivorship: Array<IdrGoldenRecordColumnSourceSurvivorship>;
  /** fetch data from the table: "idr_golden_record_column_source_survivorship" using primary key columns */
  idr_golden_record_column_source_survivorship_by_pk?: Maybe<IdrGoldenRecordColumnSourceSurvivorship>;
  /** fetch data from the table in a streaming manner: "idr_golden_record_column_source_survivorship" */
  idr_golden_record_column_source_survivorship_stream: Array<IdrGoldenRecordColumnSourceSurvivorship>;
  /** An array relationship */
  idr_golden_record_columns: Array<IdrGoldenRecordColumns>;
  /** fetch data from the table: "idr_golden_record_columns" using primary key columns */
  idr_golden_record_columns_by_pk?: Maybe<IdrGoldenRecordColumns>;
  /** fetch data from the table in a streaming manner: "idr_golden_record_columns" */
  idr_golden_record_columns_stream: Array<IdrGoldenRecordColumns>;
  /** fetch data from the table: "idr_golden_records" */
  idr_golden_records: Array<IdrGoldenRecords>;
  /** fetch data from the table: "idr_golden_records" using primary key columns */
  idr_golden_records_by_pk?: Maybe<IdrGoldenRecords>;
  /** fetch data from the table in a streaming manner: "idr_golden_records" */
  idr_golden_records_stream: Array<IdrGoldenRecords>;
  /** fetch data from the table: "idr_model_mappings" */
  idr_model_mappings: Array<IdrModelMappings>;
  /** fetch data from the table: "idr_model_mappings" using primary key columns */
  idr_model_mappings_by_pk?: Maybe<IdrModelMappings>;
  /** fetch data from the table in a streaming manner: "idr_model_mappings" */
  idr_model_mappings_stream: Array<IdrModelMappings>;
  /** fetch data from the table: "idr_models" */
  idr_models: Array<IdrModels>;
  /** fetch data from the table: "idr_models" using primary key columns */
  idr_models_by_pk?: Maybe<IdrModels>;
  /** fetch data from the table in a streaming manner: "idr_models" */
  idr_models_stream: Array<IdrModels>;
  /** fetch data from the table: "idr_output_segments" */
  idr_output_segments: Array<IdrOutputSegments>;
  /** fetch data from the table in a streaming manner: "idr_output_segments" */
  idr_output_segments_stream: Array<IdrOutputSegments>;
  /** fetch data from the table: "idr_runs" */
  idr_runs: Array<IdrRuns>;
  /** fetch aggregated fields from the table: "idr_runs" */
  idr_runs_aggregate: IdrRunsAggregate;
  /** fetch data from the table: "idr_runs" using primary key columns */
  idr_runs_by_pk?: Maybe<IdrRuns>;
  /** fetch data from the table in a streaming manner: "idr_runs" */
  idr_runs_stream: Array<IdrRuns>;
  /** fetch data from the table in a streaming manner: "idr" */
  idr_stream: Array<Idr>;
  /** fetch data from the table: "idr_training_runs" */
  idr_training_runs: Array<IdrTrainingRuns>;
  /** fetch aggregated fields from the table: "idr_training_runs" */
  idr_training_runs_aggregate: IdrTrainingRunsAggregate;
  /** fetch data from the table: "idr_training_runs" using primary key columns */
  idr_training_runs_by_pk?: Maybe<IdrTrainingRuns>;
  /** fetch data from the table in a streaming manner: "idr_training_runs" */
  idr_training_runs_stream: Array<IdrTrainingRuns>;
  /** fetch data from the table: "incoming_webhooks" */
  incoming_webhooks: Array<IncomingWebhooks>;
  /** fetch data from the table: "incoming_webhooks" using primary key columns */
  incoming_webhooks_by_pk?: Maybe<IncomingWebhooks>;
  /** fetch data from the table in a streaming manner: "incoming_webhooks" */
  incoming_webhooks_stream: Array<IncomingWebhooks>;
  /** fetch data from the table: "initiative_goals" */
  initiative_goals: Array<InitiativeGoals>;
  /** fetch data from the table: "initiative_goals" using primary key columns */
  initiative_goals_by_pk?: Maybe<InitiativeGoals>;
  /** fetch data from the table in a streaming manner: "initiative_goals" */
  initiative_goals_stream: Array<InitiativeGoals>;
  /** An array relationship */
  initiative_insights: Array<InitiativeInsights>;
  /** An aggregate relationship */
  initiative_insights_aggregate: InitiativeInsightsAggregate;
  /** fetch data from the table: "initiative_insights" using primary key columns */
  initiative_insights_by_pk?: Maybe<InitiativeInsights>;
  /** fetch data from the table in a streaming manner: "initiative_insights" */
  initiative_insights_stream: Array<InitiativeInsights>;
  /** fetch data from the table: "insights_agent_data_sources" */
  insights_agent_data_sources: Array<InsightsAgentDataSources>;
  /** fetch data from the table: "insights_agent_data_sources" using primary key columns */
  insights_agent_data_sources_by_pk?: Maybe<InsightsAgentDataSources>;
  /** fetch data from the table in a streaming manner: "insights_agent_data_sources" */
  insights_agent_data_sources_stream: Array<InsightsAgentDataSources>;
  /** fetch data from the table: "inspiration_board_ads" */
  inspiration_board_ads: Array<InspirationBoardAds>;
  /** fetch aggregated fields from the table: "inspiration_board_ads" */
  inspiration_board_ads_aggregate: InspirationBoardAdsAggregate;
  /** fetch data from the table: "inspiration_board_ads" using primary key columns */
  inspiration_board_ads_by_pk?: Maybe<InspirationBoardAds>;
  /** fetch data from the table in a streaming manner: "inspiration_board_ads" */
  inspiration_board_ads_stream: Array<InspirationBoardAds>;
  /** fetch data from the table: "inspiration_boards" */
  inspiration_boards: Array<InspirationBoards>;
  /** fetch aggregated fields from the table: "inspiration_boards" */
  inspiration_boards_aggregate: InspirationBoardsAggregate;
  /** fetch data from the table: "inspiration_boards" using primary key columns */
  inspiration_boards_by_pk?: Maybe<InspirationBoards>;
  /** fetch data from the table in a streaming manner: "inspiration_boards" */
  inspiration_boards_stream: Array<InspirationBoards>;
  /** fetch data from the table: "interaction_models" */
  interaction_models: Array<InteractionModels>;
  /** fetch data from the table: "interaction_models" using primary key columns */
  interaction_models_by_pk?: Maybe<InteractionModels>;
  /** fetch data from the table in a streaming manner: "interaction_models" */
  interaction_models_stream: Array<InteractionModels>;
  /** fetch data from the table: "journey_decision_engine_flows" */
  journey_decision_engine_flows: Array<JourneyDecisionEngineFlows>;
  /** fetch data from the table in a streaming manner: "journey_decision_engine_flows" */
  journey_decision_engine_flows_stream: Array<JourneyDecisionEngineFlows>;
  /** fetch data from the table: "journey_drafts" */
  journey_drafts: Array<JourneyDrafts>;
  /** fetch aggregated fields from the table: "journey_drafts" */
  journey_drafts_aggregate: JourneyDraftsAggregate;
  /** fetch data from the table: "journey_drafts" using primary key columns */
  journey_drafts_by_pk?: Maybe<JourneyDrafts>;
  /** fetch data from the table in a streaming manner: "journey_drafts" */
  journey_drafts_stream: Array<JourneyDrafts>;
  /** fetch data from the table: "journey_edges" */
  journey_edges: Array<JourneyEdges>;
  /** fetch data from the table: "journey_edges" using primary key columns */
  journey_edges_by_pk?: Maybe<JourneyEdges>;
  /** fetch data from the table in a streaming manner: "journey_edges" */
  journey_edges_stream: Array<JourneyEdges>;
  /** An array relationship */
  journey_labels: Array<JourneyLabels>;
  /** An aggregate relationship */
  journey_labels_aggregate: JourneyLabelsAggregate;
  /** fetch data from the table: "journey_labels" using primary key columns */
  journey_labels_by_pk?: Maybe<JourneyLabels>;
  /** fetch data from the table in a streaming manner: "journey_labels" */
  journey_labels_stream: Array<JourneyLabels>;
  /** An array relationship */
  journey_messages: Array<JourneyMessages>;
  /** fetch data from the table: "journey_messages" using primary key columns */
  journey_messages_by_pk?: Maybe<JourneyMessages>;
  /** fetch data from the table in a streaming manner: "journey_messages" */
  journey_messages_stream: Array<JourneyMessages>;
  /** An array relationship */
  journey_node_runs: Array<JourneyNodeRuns>;
  /** fetch data from the table: "journey_node_runs" using primary key columns */
  journey_node_runs_by_pk?: Maybe<JourneyNodeRuns>;
  /** fetch data from the table in a streaming manner: "journey_node_runs" */
  journey_node_runs_stream: Array<JourneyNodeRuns>;
  /** An array relationship */
  journey_nodes: Array<JourneyNodes>;
  /** An aggregate relationship */
  journey_nodes_aggregate: JourneyNodesAggregate;
  /** fetch data from the table: "journey_nodes" using primary key columns */
  journey_nodes_by_pk?: Maybe<JourneyNodes>;
  /** fetch data from the table in a streaming manner: "journey_nodes" */
  journey_nodes_stream: Array<JourneyNodes>;
  /** fetch data from the table: "journey_notes" */
  journey_notes: Array<JourneyNotes>;
  /** fetch aggregated fields from the table: "journey_notes" */
  journey_notes_aggregate: JourneyNotesAggregate;
  /** fetch data from the table in a streaming manner: "journey_notes" */
  journey_notes_stream: Array<JourneyNotes>;
  /** fetch data from the table: "journey_runs" */
  journey_runs: Array<JourneyRuns>;
  /** fetch aggregated fields from the table: "journey_runs" */
  journey_runs_aggregate: JourneyRunsAggregate;
  /** fetch data from the table: "journey_runs" using primary key columns */
  journey_runs_by_pk?: Maybe<JourneyRuns>;
  /** fetch data from the table in a streaming manner: "journey_runs" */
  journey_runs_stream: Array<JourneyRuns>;
  /** fetch data from the table: "journey_simulations" */
  journey_simulations: Array<JourneySimulations>;
  /** fetch aggregated fields from the table: "journey_simulations" */
  journey_simulations_aggregate: JourneySimulationsAggregate;
  /** fetch data from the table: "journey_simulations" using primary key columns */
  journey_simulations_by_pk?: Maybe<JourneySimulations>;
  /** fetch data from the table in a streaming manner: "journey_simulations" */
  journey_simulations_stream: Array<JourneySimulations>;
  /** fetch data from the table: "journey_syncs" */
  journey_syncs: Array<JourneySyncs>;
  /** fetch data from the table: "journey_syncs" using primary key columns */
  journey_syncs_by_pk?: Maybe<JourneySyncs>;
  /** fetch data from the table in a streaming manner: "journey_syncs" */
  journey_syncs_stream: Array<JourneySyncs>;
  /** fetch data from the table: "journey_template_references" */
  journey_template_references: Array<JourneyTemplateReferences>;
  /** fetch data from the table: "journey_template_references" using primary key columns */
  journey_template_references_by_pk?: Maybe<JourneyTemplateReferences>;
  /** fetch data from the table in a streaming manner: "journey_template_references" */
  journey_template_references_stream: Array<JourneyTemplateReferences>;
  /** fetch data from the table: "journey_templates" */
  journey_templates: Array<JourneyTemplates>;
  /** fetch aggregated fields from the table: "journey_templates" */
  journey_templates_aggregate: JourneyTemplatesAggregate;
  /** fetch data from the table: "journey_templates" using primary key columns */
  journey_templates_by_pk?: Maybe<JourneyTemplates>;
  /** fetch data from the table in a streaming manner: "journey_templates" */
  journey_templates_stream: Array<JourneyTemplates>;
  /** fetch data from the table: "journeys" */
  journeys: Array<Journeys>;
  /** fetch aggregated fields from the table: "journeys" */
  journeys_aggregate: JourneysAggregate;
  /** fetch data from the table: "journeys" using primary key columns */
  journeys_by_pk?: Maybe<Journeys>;
  /** fetch data from the table in a streaming manner: "journeys" */
  journeys_stream: Array<Journeys>;
  /** fetch data from the table: "label_groups" */
  label_groups: Array<LabelGroups>;
  /** fetch aggregated fields from the table: "label_groups" */
  label_groups_aggregate: LabelGroupsAggregate;
  /** fetch data from the table: "label_groups" using primary key columns */
  label_groups_by_pk?: Maybe<LabelGroups>;
  /** fetch data from the table in a streaming manner: "label_groups" */
  label_groups_stream: Array<LabelGroups>;
  /** An array relationship */
  labels: Array<Labels>;
  /** An aggregate relationship */
  labels_aggregate: LabelsAggregate;
  /** fetch data from the table: "labels" using primary key columns */
  labels_by_pk?: Maybe<Labels>;
  /** fetch data from the table in a streaming manner: "labels" */
  labels_stream: Array<Labels>;
  /** fetch data from the table: "lcm_message_candidates" */
  lcm_message_candidates: Array<LcmMessageCandidates>;
  /** fetch aggregated fields from the table: "lcm_message_candidates" */
  lcm_message_candidates_aggregate: LcmMessageCandidatesAggregate;
  /** fetch data from the table: "lcm_message_candidates" using primary key columns */
  lcm_message_candidates_by_pk?: Maybe<LcmMessageCandidates>;
  /** fetch data from the table in a streaming manner: "lcm_message_candidates" */
  lcm_message_candidates_stream: Array<LcmMessageCandidates>;
  /** fetch data from the table: "lcm_message_plans" */
  lcm_message_plans: Array<LcmMessagePlans>;
  /** fetch aggregated fields from the table: "lcm_message_plans" */
  lcm_message_plans_aggregate: LcmMessagePlansAggregate;
  /** fetch data from the table: "lcm_message_plans" using primary key columns */
  lcm_message_plans_by_pk?: Maybe<LcmMessagePlans>;
  /** fetch data from the table in a streaming manner: "lcm_message_plans" */
  lcm_message_plans_stream: Array<LcmMessagePlans>;
  /** An array relationship */
  llm_chat_interactions: Array<LlmChatInteractions>;
  /** An aggregate relationship */
  llm_chat_interactions_aggregate: LlmChatInteractionsAggregate;
  /** fetch data from the table: "llm_chat_interactions" using primary key columns */
  llm_chat_interactions_by_pk?: Maybe<LlmChatInteractions>;
  /** fetch data from the table in a streaming manner: "llm_chat_interactions" */
  llm_chat_interactions_stream: Array<LlmChatInteractions>;
  /** An array relationship */
  llm_chat_messages: Array<LlmChatMessages>;
  /** An aggregate relationship */
  llm_chat_messages_aggregate: LlmChatMessagesAggregate;
  /** fetch data from the table: "llm_chat_messages" using primary key columns */
  llm_chat_messages_by_pk?: Maybe<LlmChatMessages>;
  /** fetch data from the table in a streaming manner: "llm_chat_messages" */
  llm_chat_messages_stream: Array<LlmChatMessages>;
  /** fetch data from the table: "llm_chat_sessions" */
  llm_chat_sessions: Array<LlmChatSessions>;
  /** fetch data from the table: "llm_chat_sessions" using primary key columns */
  llm_chat_sessions_by_pk?: Maybe<LlmChatSessions>;
  /** fetch data from the table in a streaming manner: "llm_chat_sessions" */
  llm_chat_sessions_stream: Array<LlmChatSessions>;
  /** fetch data from the table: "llm_inference_backends" */
  llm_inference_backends: Array<LlmInferenceBackends>;
  /** fetch data from the table: "llm_inference_backends" using primary key columns */
  llm_inference_backends_by_pk?: Maybe<LlmInferenceBackends>;
  /** fetch data from the table in a streaming manner: "llm_inference_backends" */
  llm_inference_backends_stream: Array<LlmInferenceBackends>;
  /** fetch data from the table: "looker_credentials" */
  looker_credentials: Array<LookerCredentials>;
  /** fetch data from the table: "looker_credentials" using primary key columns */
  looker_credentials_by_pk?: Maybe<LookerCredentials>;
  /** fetch data from the table in a streaming manner: "looker_credentials" */
  looker_credentials_stream: Array<LookerCredentials>;
  /** An array relationship */
  marketing_campaign_messages: Array<MarketingCampaignMessages>;
  /** An aggregate relationship */
  marketing_campaign_messages_aggregate: MarketingCampaignMessagesAggregate;
  /** fetch data from the table: "marketing_campaign_messages" using primary key columns */
  marketing_campaign_messages_by_pk?: Maybe<MarketingCampaignMessages>;
  /** fetch data from the table in a streaming manner: "marketing_campaign_messages" */
  marketing_campaign_messages_stream: Array<MarketingCampaignMessages>;
  /** fetch data from the table: "marketing_campaigns" */
  marketing_campaigns: Array<MarketingCampaigns>;
  /** fetch aggregated fields from the table: "marketing_campaigns" */
  marketing_campaigns_aggregate: MarketingCampaignsAggregate;
  /** fetch data from the table: "marketing_campaigns" using primary key columns */
  marketing_campaigns_by_pk?: Maybe<MarketingCampaigns>;
  /** fetch data from the table in a streaming manner: "marketing_campaigns" */
  marketing_campaigns_stream: Array<MarketingCampaigns>;
  /** fetch data from the table: "matchboosting_config" */
  matchboosting_config: Array<MatchboostingConfig>;
  /** fetch data from the table: "matchboosting_config" using primary key columns */
  matchboosting_config_by_pk?: Maybe<MatchboostingConfig>;
  /** fetch data from the table in a streaming manner: "matchboosting_config" */
  matchboosting_config_stream: Array<MatchboostingConfig>;
  /** fetch data from the table: "matchboosting_stats" */
  matchboosting_stats: Array<MatchboostingStats>;
  /** fetch data from the table: "matchboosting_stats" using primary key columns */
  matchboosting_stats_by_pk?: Maybe<MatchboostingStats>;
  /** fetch data from the table in a streaming manner: "matchboosting_stats" */
  matchboosting_stats_stream: Array<MatchboostingStats>;
  /** fetch data from the table: "matchboosting_workspace_config" */
  matchboosting_workspace_config: Array<MatchboostingWorkspaceConfig>;
  /** fetch data from the table: "matchboosting_workspace_config" using primary key columns */
  matchboosting_workspace_config_by_pk?: Maybe<MatchboostingWorkspaceConfig>;
  /** fetch data from the table in a streaming manner: "matchboosting_workspace_config" */
  matchboosting_workspace_config_stream: Array<MatchboostingWorkspaceConfig>;
  /** An array relationship */
  message_contents: Array<MessageContents>;
  /** An aggregate relationship */
  message_contents_aggregate: MessageContentsAggregate;
  /** fetch data from the table: "message_contents_base" */
  message_contents_base: Array<MessageContentsBase>;
  /** fetch aggregated fields from the table: "message_contents_base" */
  message_contents_base_aggregate: MessageContentsBaseAggregate;
  /** fetch data from the table in a streaming manner: "message_contents_base" */
  message_contents_base_stream: Array<MessageContentsBase>;
  /** fetch data from the table: "message_contents" using primary key columns */
  message_contents_by_pk?: Maybe<MessageContents>;
  /** An array relationship */
  message_contents_metadata: Array<MessageContentsMetadata>;
  /** An aggregate relationship */
  message_contents_metadata_aggregate: MessageContentsMetadataAggregate;
  /** fetch data from the table: "message_contents_metadata_base" */
  message_contents_metadata_base: Array<MessageContentsMetadataBase>;
  /** fetch aggregated fields from the table: "message_contents_metadata_base" */
  message_contents_metadata_base_aggregate: MessageContentsMetadataBaseAggregate;
  /** fetch data from the table in a streaming manner: "message_contents_metadata_base" */
  message_contents_metadata_base_stream: Array<MessageContentsMetadataBase>;
  /** fetch data from the table: "message_contents_metadata" using primary key columns */
  message_contents_metadata_by_pk?: Maybe<MessageContentsMetadata>;
  /** fetch data from the table in a streaming manner: "message_contents_metadata" */
  message_contents_metadata_stream: Array<MessageContentsMetadata>;
  /** fetch data from the table in a streaming manner: "message_contents" */
  message_contents_stream: Array<MessageContents>;
  /** An array relationship */
  message_experiments: Array<MessageExperiments>;
  /** fetch data from the table: "message_experiments" using primary key columns */
  message_experiments_by_pk?: Maybe<MessageExperiments>;
  /** fetch data from the table in a streaming manner: "message_experiments" */
  message_experiments_stream: Array<MessageExperiments>;
  /** An array relationship */
  message_labels: Array<MessageLabels>;
  /** An aggregate relationship */
  message_labels_aggregate: MessageLabelsAggregate;
  /** fetch data from the table: "message_labels" using primary key columns */
  message_labels_by_pk?: Maybe<MessageLabels>;
  /** fetch data from the table in a streaming manner: "message_labels" */
  message_labels_stream: Array<MessageLabels>;
  /** An array relationship */
  message_push_apps: Array<MessagePushApps>;
  /** fetch data from the table: "message_push_apps" using primary key columns */
  message_push_apps_by_pk?: Maybe<MessagePushApps>;
  /** fetch data from the table in a streaming manner: "message_push_apps" */
  message_push_apps_stream: Array<MessagePushApps>;
  /** fetch data from the table: "message_variant_arm" */
  message_variant_arm: Array<MessageVariantArm>;
  /** fetch aggregated fields from the table: "message_variant_arm" */
  message_variant_arm_aggregate: MessageVariantArmAggregate;
  /** fetch data from the table: "message_variant_arm" using primary key columns */
  message_variant_arm_by_pk?: Maybe<MessageVariantArm>;
  /** fetch data from the table in a streaming manner: "message_variant_arm" */
  message_variant_arm_stream: Array<MessageVariantArm>;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: MessagesAggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messages_by_pk?: Maybe<Messages>;
  /** fetch data from the table in a streaming manner: "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "model_column_references" */
  model_column_references: Array<ModelColumnReferences>;
  /** fetch aggregated fields from the table: "model_column_references" */
  model_column_references_aggregate: ModelColumnReferencesAggregate;
  /** fetch data from the table: "model_column_references" using primary key columns */
  model_column_references_by_pk?: Maybe<ModelColumnReferences>;
  /** fetch data from the table: "model_column_references_segments" */
  model_column_references_segments: Array<ModelColumnReferencesSegments>;
  /** fetch aggregated fields from the table: "model_column_references_segments" */
  model_column_references_segments_aggregate: ModelColumnReferencesSegmentsAggregate;
  /** fetch data from the table in a streaming manner: "model_column_references_segments" */
  model_column_references_segments_stream: Array<ModelColumnReferencesSegments>;
  /** fetch data from the table in a streaming manner: "model_column_references" */
  model_column_references_stream: Array<ModelColumnReferences>;
  /** fetch data from the table: "model_column_references_syncs" */
  model_column_references_syncs: Array<ModelColumnReferencesSyncs>;
  /** fetch aggregated fields from the table: "model_column_references_syncs" */
  model_column_references_syncs_aggregate: ModelColumnReferencesSyncsAggregate;
  /** fetch data from the table in a streaming manner: "model_column_references_syncs" */
  model_column_references_syncs_stream: Array<ModelColumnReferencesSyncs>;
  /** fetch data from the table: "model_columns" */
  model_columns: Array<ModelColumns>;
  /** fetch aggregated fields from the table: "model_columns" */
  model_columns_aggregate: ModelColumnsAggregate;
  /** fetch data from the table: "model_columns" using primary key columns */
  model_columns_by_pk?: Maybe<ModelColumns>;
  /** fetch data from the table in a streaming manner: "model_columns" */
  model_columns_stream: Array<ModelColumns>;
  /** fetch data from the table: "model_relationship_references" */
  model_relationship_references: Array<ModelRelationshipReferences>;
  /** fetch aggregated fields from the table: "model_relationship_references" */
  model_relationship_references_aggregate: ModelRelationshipReferencesAggregate;
  /** fetch data from the table: "model_relationship_references" using primary key columns */
  model_relationship_references_by_pk?: Maybe<ModelRelationshipReferences>;
  /** fetch data from the table in a streaming manner: "model_relationship_references" */
  model_relationship_references_stream: Array<ModelRelationshipReferences>;
  /** fetch data from the table: "model_relationships" */
  model_relationships: Array<ModelRelationships>;
  /** fetch data from the table: "model_relationships" using primary key columns */
  model_relationships_by_pk?: Maybe<ModelRelationships>;
  /** fetch data from the table in a streaming manner: "model_relationships" */
  model_relationships_stream: Array<ModelRelationships>;
  /** fetch data from the table: "monitor_condition_statuses" */
  monitor_condition_statuses: Array<MonitorConditionStatuses>;
  /** fetch data from the table: "monitor_condition_statuses" using primary key columns */
  monitor_condition_statuses_by_pk?: Maybe<MonitorConditionStatuses>;
  /** fetch data from the table in a streaming manner: "monitor_condition_statuses" */
  monitor_condition_statuses_stream: Array<MonitorConditionStatuses>;
  /** fetch data from the table: "monitor_condition_templates" */
  monitor_condition_templates: Array<MonitorConditionTemplates>;
  /** fetch data from the table: "monitor_condition_templates" using primary key columns */
  monitor_condition_templates_by_pk?: Maybe<MonitorConditionTemplates>;
  /** fetch data from the table in a streaming manner: "monitor_condition_templates" */
  monitor_condition_templates_stream: Array<MonitorConditionTemplates>;
  /** An array relationship */
  notification_channel_templates: Array<NotificationChannelTemplates>;
  /** fetch data from the table: "notification_channel_templates" using primary key columns */
  notification_channel_templates_by_pk?: Maybe<NotificationChannelTemplates>;
  /** fetch data from the table in a streaming manner: "notification_channel_templates" */
  notification_channel_templates_stream: Array<NotificationChannelTemplates>;
  /** fetch data from the table: "object_definition_groups" */
  object_definition_groups: Array<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definition_groups" using primary key columns */
  object_definition_groups_by_pk?: Maybe<ObjectDefinitionGroups>;
  /** fetch data from the table in a streaming manner: "object_definition_groups" */
  object_definition_groups_stream: Array<ObjectDefinitionGroups>;
  /** fetch data from the table: "object_definitions" */
  object_definitions: Array<ObjectDefinitions>;
  /** fetch data from the table: "object_definitions" using primary key columns */
  object_definitions_by_pk?: Maybe<ObjectDefinitions>;
  /** fetch data from the table in a streaming manner: "object_definitions" */
  object_definitions_stream: Array<ObjectDefinitions>;
  /** An array relationship */
  object_schemas: Array<ObjectSchemas>;
  /** fetch data from the table: "object_schemas" using primary key columns */
  object_schemas_by_pk?: Maybe<ObjectSchemas>;
  /** fetch data from the table in a streaming manner: "object_schemas" */
  object_schemas_stream: Array<ObjectSchemas>;
  /** fetch data from the table: "organization_active_syncs" */
  organization_active_syncs: Array<OrganizationActiveSyncs>;
  /** fetch data from the table: "organization_active_syncs" using primary key columns */
  organization_active_syncs_by_pk?: Maybe<OrganizationActiveSyncs>;
  /** fetch data from the table in a streaming manner: "organization_active_syncs" */
  organization_active_syncs_stream: Array<OrganizationActiveSyncs>;
  /** fetch data from the table: "organization_invites" */
  organization_invites: Array<OrganizationInvites>;
  /** fetch aggregated fields from the table: "organization_invites" */
  organization_invites_aggregate: OrganizationInvitesAggregate;
  /** fetch data from the table: "organization_invites" using primary key columns */
  organization_invites_by_pk?: Maybe<OrganizationInvites>;
  /** fetch data from the table in a streaming manner: "organization_invites" */
  organization_invites_stream: Array<OrganizationInvites>;
  /** fetch data from the table: "organization_invites_user_groups" */
  organization_invites_user_groups: Array<OrganizationInvitesUserGroups>;
  /** fetch data from the table: "organization_invites_user_groups" using primary key columns */
  organization_invites_user_groups_by_pk?: Maybe<OrganizationInvitesUserGroups>;
  /** fetch data from the table in a streaming manner: "organization_invites_user_groups" */
  organization_invites_user_groups_stream: Array<OrganizationInvitesUserGroups>;
  /** An array relationship */
  organization_members: Array<OrganizationMembers>;
  /** An aggregate relationship */
  organization_members_aggregate: OrganizationMembersAggregate;
  /** fetch data from the table: "organization_members_distinct" */
  organization_members_distinct: Array<OrganizationMembersDistinct>;
  /** fetch aggregated fields from the table: "organization_members_distinct" */
  organization_members_distinct_aggregate: OrganizationMembersDistinctAggregate;
  /** fetch data from the table in a streaming manner: "organization_members_distinct" */
  organization_members_distinct_stream: Array<OrganizationMembersDistinct>;
  /** fetch data from the table in a streaming manner: "organization_members" */
  organization_members_stream: Array<OrganizationMembers>;
  /** fetch data from the table: "organization_overage_dates" */
  organization_overage_dates: Array<OrganizationOverageDates>;
  /** fetch data from the table in a streaming manner: "organization_overage_dates" */
  organization_overage_dates_stream: Array<OrganizationOverageDates>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** fetch data from the table: "pagerduty_credentials" */
  pagerduty_credentials: Array<PagerdutyCredentials>;
  /** fetch data from the table: "pagerduty_credentials" using primary key columns */
  pagerduty_credentials_by_pk?: Maybe<PagerdutyCredentials>;
  /** fetch data from the table in a streaming manner: "pagerduty_credentials" */
  pagerduty_credentials_stream: Array<PagerdutyCredentials>;
  /** An array relationship */
  predictor_artifacts: Array<PredictorArtifacts>;
  /** An aggregate relationship */
  predictor_artifacts_aggregate: PredictorArtifactsAggregate;
  /** fetch data from the table: "predictor_artifacts" using primary key columns */
  predictor_artifacts_by_pk?: Maybe<PredictorArtifacts>;
  /** fetch data from the table in a streaming manner: "predictor_artifacts" */
  predictor_artifacts_stream: Array<PredictorArtifacts>;
  /** An array relationship */
  predictor_feature_definition_events: Array<PredictorFeatureDefinitionEvents>;
  /** fetch data from the table: "predictor_feature_definition_events" using primary key columns */
  predictor_feature_definition_events_by_pk?: Maybe<PredictorFeatureDefinitionEvents>;
  /** fetch data from the table in a streaming manner: "predictor_feature_definition_events" */
  predictor_feature_definition_events_stream: Array<PredictorFeatureDefinitionEvents>;
  /** An array relationship */
  predictor_feature_definitions: Array<PredictorFeatureDefinitions>;
  /** fetch data from the table: "predictor_feature_definitions" using primary key columns */
  predictor_feature_definitions_by_pk?: Maybe<PredictorFeatureDefinitions>;
  /** fetch data from the table in a streaming manner: "predictor_feature_definitions" */
  predictor_feature_definitions_stream: Array<PredictorFeatureDefinitions>;
  /** An array relationship */
  predictor_outcomes: Array<PredictorOutcomes>;
  /** fetch data from the table: "predictor_outcomes" using primary key columns */
  predictor_outcomes_by_pk?: Maybe<PredictorOutcomes>;
  /** fetch data from the table in a streaming manner: "predictor_outcomes" */
  predictor_outcomes_stream: Array<PredictorOutcomes>;
  /** An array relationship */
  predictor_runs: Array<PredictorRuns>;
  /** An aggregate relationship */
  predictor_runs_aggregate: PredictorRunsAggregate;
  /** fetch data from the table: "predictor_runs" using primary key columns */
  predictor_runs_by_pk?: Maybe<PredictorRuns>;
  /** fetch data from the table in a streaming manner: "predictor_runs" */
  predictor_runs_stream: Array<PredictorRuns>;
  /** fetch data from the table: "predictors" */
  predictors: Array<Predictors>;
  /** fetch data from the table: "predictors" using primary key columns */
  predictors_by_pk?: Maybe<Predictors>;
  /** fetch data from the table in a streaming manner: "predictors" */
  predictors_stream: Array<Predictors>;
  /** An array relationship */
  priority_list_memberships: Array<PriorityListMemberships>;
  /** fetch data from the table: "priority_list_memberships" using primary key columns */
  priority_list_memberships_by_pk?: Maybe<PriorityListMemberships>;
  /** fetch data from the table in a streaming manner: "priority_list_memberships" */
  priority_list_memberships_stream: Array<PriorityListMemberships>;
  /** fetch data from the table: "priority_lists" */
  priority_lists: Array<PriorityLists>;
  /** fetch aggregated fields from the table: "priority_lists" */
  priority_lists_aggregate: PriorityListsAggregate;
  /** fetch data from the table: "priority_lists" using primary key columns */
  priority_lists_by_pk?: Maybe<PriorityLists>;
  /** fetch data from the table in a streaming manner: "priority_lists" */
  priority_lists_stream: Array<PriorityLists>;
  /** fetch data from the table: "push_apps" */
  push_apps: Array<PushApps>;
  /** fetch data from the table: "push_apps" using primary key columns */
  push_apps_by_pk?: Maybe<PushApps>;
  /** fetch data from the table in a streaming manner: "push_apps" */
  push_apps_stream: Array<PushApps>;
  /** fetch data from the table: "push_config" */
  push_config: Array<PushConfig>;
  /** fetch aggregated fields from the table: "push_config" */
  push_config_aggregate: PushConfigAggregate;
  /** fetch data from the table: "push_config" using primary key columns */
  push_config_by_pk?: Maybe<PushConfig>;
  /** fetch data from the table in a streaming manner: "push_config" */
  push_config_stream: Array<PushConfig>;
  /** An array relationship */
  query_runs: Array<QueryRuns>;
  /** fetch data from the table: "query_runs" using primary key columns */
  query_runs_by_pk?: Maybe<QueryRuns>;
  /** fetch data from the table in a streaming manner: "query_runs" */
  query_runs_stream: Array<QueryRuns>;
  /** An array relationship */
  realtime_audience_sync_segments: Array<RealtimeAudienceSyncSegments>;
  /** An aggregate relationship */
  realtime_audience_sync_segments_aggregate: RealtimeAudienceSyncSegmentsAggregate;
  /** fetch data from the table: "realtime_audience_sync_segments" using primary key columns */
  realtime_audience_sync_segments_by_pk?: Maybe<RealtimeAudienceSyncSegments>;
  /** fetch data from the table in a streaming manner: "realtime_audience_sync_segments" */
  realtime_audience_sync_segments_stream: Array<RealtimeAudienceSyncSegments>;
  /** An array relationship */
  realtime_audience_syncs: Array<RealtimeAudienceSyncs>;
  /** fetch data from the table: "realtime_audience_syncs" using primary key columns */
  realtime_audience_syncs_by_pk?: Maybe<RealtimeAudienceSyncs>;
  /** fetch data from the table in a streaming manner: "realtime_audience_syncs" */
  realtime_audience_syncs_stream: Array<RealtimeAudienceSyncs>;
  /** fetch data from the table: "realtime_audiences_scheduled_warehouse_pulls" */
  realtime_audiences_scheduled_warehouse_pulls: Array<RealtimeAudiencesScheduledWarehousePulls>;
  /** fetch data from the table in a streaming manner: "realtime_audiences_scheduled_warehouse_pulls" */
  realtime_audiences_scheduled_warehouse_pulls_stream: Array<RealtimeAudiencesScheduledWarehousePulls>;
  /** An array relationship */
  realtime_audiences_warehouse_pull_runs: Array<RealtimeAudiencesWarehousePullRuns>;
  /** An aggregate relationship */
  realtime_audiences_warehouse_pull_runs_aggregate: RealtimeAudiencesWarehousePullRunsAggregate;
  /** fetch data from the table in a streaming manner: "realtime_audiences_warehouse_pull_runs" */
  realtime_audiences_warehouse_pull_runs_stream: Array<RealtimeAudiencesWarehousePullRuns>;
  /** An array relationship */
  relationship_references: Array<RelationshipReferences>;
  /** fetch data from the table: "relationship_references" using primary key columns */
  relationship_references_by_pk?: Maybe<RelationshipReferences>;
  /** fetch data from the table in a streaming manner: "relationship_references" */
  relationship_references_stream: Array<RelationshipReferences>;
  /** fetch data from the table: "relationships" */
  relationships: Array<Relationships>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: Maybe<Relationships>;
  /** fetch data from the table in a streaming manner: "relationships" */
  relationships_stream: Array<Relationships>;
  /** fetch data from the table: "report_schedule" */
  report_schedule: Array<ReportSchedule>;
  /** fetch aggregated fields from the table: "report_schedule" */
  report_schedule_aggregate: ReportScheduleAggregate;
  /** fetch data from the table: "report_schedule" using primary key columns */
  report_schedule_by_pk?: Maybe<ReportSchedule>;
  /** An array relationship */
  report_schedule_run_comments: Array<ReportScheduleRunComments>;
  /** An aggregate relationship */
  report_schedule_run_comments_aggregate: ReportScheduleRunCommentsAggregate;
  /** fetch data from the table: "report_schedule_run_comments" using primary key columns */
  report_schedule_run_comments_by_pk?: Maybe<ReportScheduleRunComments>;
  /** fetch data from the table in a streaming manner: "report_schedule_run_comments" */
  report_schedule_run_comments_stream: Array<ReportScheduleRunComments>;
  /** An array relationship */
  report_schedule_runs: Array<ReportScheduleRuns>;
  /** An aggregate relationship */
  report_schedule_runs_aggregate: ReportScheduleRunsAggregate;
  /** fetch data from the table: "report_schedule_runs" using primary key columns */
  report_schedule_runs_by_pk?: Maybe<ReportScheduleRuns>;
  /** fetch data from the table in a streaming manner: "report_schedule_runs" */
  report_schedule_runs_stream: Array<ReportScheduleRuns>;
  /** fetch data from the table in a streaming manner: "report_schedule" */
  report_schedule_stream: Array<ReportSchedule>;
  /** An array relationship */
  report_schedule_versions: Array<ReportScheduleVersions>;
  /** An aggregate relationship */
  report_schedule_versions_aggregate: ReportScheduleVersionsAggregate;
  /** fetch data from the table: "report_schedule_versions" using primary key columns */
  report_schedule_versions_by_pk?: Maybe<ReportScheduleVersions>;
  /** fetch data from the table in a streaming manner: "report_schedule_versions" */
  report_schedule_versions_stream: Array<ReportScheduleVersions>;
  /** fetch data from the table: "resource_interactions" */
  resource_interactions: Array<ResourceInteractions>;
  /** fetch data from the table: "resource_interactions" using primary key columns */
  resource_interactions_by_pk?: Maybe<ResourceInteractions>;
  /** fetch data from the table in a streaming manner: "resource_interactions" */
  resource_interactions_stream: Array<ResourceInteractions>;
  /** fetch data from the table: "resource_monitor_conditions" */
  resource_monitor_conditions: Array<ResourceMonitorConditions>;
  /** fetch data from the table: "resource_monitor_conditions" using primary key columns */
  resource_monitor_conditions_by_pk?: Maybe<ResourceMonitorConditions>;
  /** fetch data from the table in a streaming manner: "resource_monitor_conditions" */
  resource_monitor_conditions_stream: Array<ResourceMonitorConditions>;
  /** fetch data from the table: "resource_monitor_statuses" */
  resource_monitor_statuses: Array<ResourceMonitorStatuses>;
  /** fetch data from the table: "resource_monitor_statuses" using primary key columns */
  resource_monitor_statuses_by_pk?: Maybe<ResourceMonitorStatuses>;
  /** fetch data from the table in a streaming manner: "resource_monitor_statuses" */
  resource_monitor_statuses_stream: Array<ResourceMonitorStatuses>;
  /** An array relationship */
  resource_notification_channels: Array<ResourceNotificationChannels>;
  /** fetch data from the table: "resource_notification_channels" using primary key columns */
  resource_notification_channels_by_pk?: Maybe<ResourceNotificationChannels>;
  /** fetch data from the table in a streaming manner: "resource_notification_channels" */
  resource_notification_channels_stream: Array<ResourceNotificationChannels>;
  /** fetch data from the table: "resource_tag_values" */
  resource_tag_values: Array<ResourceTagValues>;
  /** fetch data from the table in a streaming manner: "resource_tag_values" */
  resource_tag_values_stream: Array<ResourceTagValues>;
  /** fetch data from the table: "resource_to_monitor_condition_type" */
  resource_to_monitor_condition_type: Array<ResourceToMonitorConditionType>;
  /** fetch data from the table: "resource_to_monitor_condition_type" using primary key columns */
  resource_to_monitor_condition_type_by_pk?: Maybe<ResourceToMonitorConditionType>;
  /** fetch data from the table in a streaming manner: "resource_to_monitor_condition_type" */
  resource_to_monitor_condition_type_stream: Array<ResourceToMonitorConditionType>;
  /** fetch data from the table: "resource_views" */
  resource_views: Array<ResourceViews>;
  /** fetch data from the table: "resource_views" using primary key columns */
  resource_views_by_pk?: Maybe<ResourceViews>;
  /** fetch data from the table in a streaming manner: "resource_views" */
  resource_views_stream: Array<ResourceViews>;
  /** An array relationship */
  retl_and_realtime_syncs: Array<RetlAndRealtimeSyncs>;
  /** An aggregate relationship */
  retl_and_realtime_syncs_aggregate: RetlAndRealtimeSyncsAggregate;
  /** fetch data from the table in a streaming manner: "retl_and_realtime_syncs" */
  retl_and_realtime_syncs_stream: Array<RetlAndRealtimeSyncs>;
  /** fetch data from the table: "review_agent_entities" */
  review_agent_entities: Array<ReviewAgentEntities>;
  /** fetch aggregated fields from the table: "review_agent_entities" */
  review_agent_entities_aggregate: ReviewAgentEntitiesAggregate;
  /** fetch data from the table: "review_agent_entities" using primary key columns */
  review_agent_entities_by_pk?: Maybe<ReviewAgentEntities>;
  /** fetch data from the table in a streaming manner: "review_agent_entities" */
  review_agent_entities_stream: Array<ReviewAgentEntities>;
  /** fetch data from the table: "review_agents" */
  review_agents: Array<ReviewAgents>;
  /** fetch aggregated fields from the table: "review_agents" */
  review_agents_aggregate: ReviewAgentsAggregate;
  /** fetch data from the table: "review_agents" using primary key columns */
  review_agents_by_pk?: Maybe<ReviewAgents>;
  /** fetch data from the table in a streaming manner: "review_agents" */
  review_agents_stream: Array<ReviewAgents>;
  /** fetch data from the table: "sample_data_sources" */
  sample_data_sources: Array<SampleDataSources>;
  /** fetch data from the table: "sample_data_sources" using primary key columns */
  sample_data_sources_by_pk?: Maybe<SampleDataSources>;
  /** fetch data from the table in a streaming manner: "sample_data_sources" */
  sample_data_sources_stream: Array<SampleDataSources>;
  /** An array relationship */
  sampled_segments: Array<SampledSegments>;
  /** An aggregate relationship */
  sampled_segments_aggregate: SampledSegmentsAggregate;
  /** fetch data from the table: "sampled_segments" using primary key columns */
  sampled_segments_by_pk?: Maybe<SampledSegments>;
  /** fetch data from the table in a streaming manner: "sampled_segments" */
  sampled_segments_stream: Array<SampledSegments>;
  /** fetch data from the table: "saved_analytics_charts" */
  saved_analytics_charts: Array<SavedAnalyticsCharts>;
  /** fetch aggregated fields from the table: "saved_analytics_charts" */
  saved_analytics_charts_aggregate: SavedAnalyticsChartsAggregate;
  /** fetch data from the table: "saved_analytics_charts" using primary key columns */
  saved_analytics_charts_by_pk?: Maybe<SavedAnalyticsCharts>;
  /** fetch data from the table: "saved_analytics_charts_cohorts" */
  saved_analytics_charts_cohorts: Array<SavedAnalyticsChartsCohorts>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_cohorts" */
  saved_analytics_charts_cohorts_aggregate: SavedAnalyticsChartsCohortsAggregate;
  /** fetch data from the table: "saved_analytics_charts_cohorts" using primary key columns */
  saved_analytics_charts_cohorts_by_pk?: Maybe<SavedAnalyticsChartsCohorts>;
  /** fetch data from the table in a streaming manner: "saved_analytics_charts_cohorts" */
  saved_analytics_charts_cohorts_stream: Array<SavedAnalyticsChartsCohorts>;
  /** fetch data from the table: "saved_analytics_charts_funnel_stages" */
  saved_analytics_charts_funnel_stages: Array<SavedAnalyticsChartsFunnelStages>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_funnel_stages" */
  saved_analytics_charts_funnel_stages_aggregate: SavedAnalyticsChartsFunnelStagesAggregate;
  /** fetch data from the table: "saved_analytics_charts_funnel_stages" using primary key columns */
  saved_analytics_charts_funnel_stages_by_pk?: Maybe<SavedAnalyticsChartsFunnelStages>;
  /** fetch data from the table in a streaming manner: "saved_analytics_charts_funnel_stages" */
  saved_analytics_charts_funnel_stages_stream: Array<SavedAnalyticsChartsFunnelStages>;
  /** fetch data from the table: "saved_analytics_charts_goals" */
  saved_analytics_charts_goals: Array<SavedAnalyticsChartsGoals>;
  /** fetch aggregated fields from the table: "saved_analytics_charts_goals" */
  saved_analytics_charts_goals_aggregate: SavedAnalyticsChartsGoalsAggregate;
  /** fetch data from the table: "saved_analytics_charts_goals" using primary key columns */
  saved_analytics_charts_goals_by_pk?: Maybe<SavedAnalyticsChartsGoals>;
  /** fetch data from the table in a streaming manner: "saved_analytics_charts_goals" */
  saved_analytics_charts_goals_stream: Array<SavedAnalyticsChartsGoals>;
  /** fetch data from the table in a streaming manner: "saved_analytics_charts" */
  saved_analytics_charts_stream: Array<SavedAnalyticsCharts>;
  /** fetch data from the table: "saved_campaign_views" */
  saved_campaign_views: Array<SavedCampaignViews>;
  /** fetch aggregated fields from the table: "saved_campaign_views" */
  saved_campaign_views_aggregate: SavedCampaignViewsAggregate;
  /** fetch data from the table: "saved_campaign_views" using primary key columns */
  saved_campaign_views_by_pk?: Maybe<SavedCampaignViews>;
  /** fetch data from the table: "saved_campaign_views_goals" */
  saved_campaign_views_goals: Array<SavedCampaignViewsGoals>;
  /** fetch aggregated fields from the table: "saved_campaign_views_goals" */
  saved_campaign_views_goals_aggregate: SavedCampaignViewsGoalsAggregate;
  /** fetch data from the table: "saved_campaign_views_goals" using primary key columns */
  saved_campaign_views_goals_by_pk?: Maybe<SavedCampaignViewsGoals>;
  /** fetch data from the table in a streaming manner: "saved_campaign_views_goals" */
  saved_campaign_views_goals_stream: Array<SavedCampaignViewsGoals>;
  /** fetch data from the table in a streaming manner: "saved_campaign_views" */
  saved_campaign_views_stream: Array<SavedCampaignViews>;
  /** fetch data from the table: "saved_messages" */
  saved_messages: Array<SavedMessages>;
  /** fetch aggregated fields from the table: "saved_messages" */
  saved_messages_aggregate: SavedMessagesAggregate;
  /** fetch data from the table in a streaming manner: "saved_messages" */
  saved_messages_stream: Array<SavedMessages>;
  /** fetch data from the table: "saved_queries" */
  saved_queries: Array<SavedQueries>;
  /** fetch data from the table: "saved_queries" using primary key columns */
  saved_queries_by_pk?: Maybe<SavedQueries>;
  /** fetch data from the table in a streaming manner: "saved_queries" */
  saved_queries_stream: Array<SavedQueries>;
  /** fetch data from the table: "segment_references" */
  segment_references: Array<SegmentReferences>;
  /** fetch aggregated fields from the table: "segment_references" */
  segment_references_aggregate: SegmentReferencesAggregate;
  /** fetch data from the table: "segment_references" using primary key columns */
  segment_references_by_pk?: Maybe<SegmentReferences>;
  /** fetch data from the table in a streaming manner: "segment_references" */
  segment_references_stream: Array<SegmentReferences>;
  /** An array relationship */
  segments: Array<Segments>;
  /** An aggregate relationship */
  segments_aggregate: SegmentsAggregate;
  /** fetch data from the table: "segments" using primary key columns */
  segments_by_pk?: Maybe<Segments>;
  /** fetch data from the table in a streaming manner: "segments" */
  segments_stream: Array<Segments>;
  /** An array relationship */
  sent_resource_notifications: Array<SentResourceNotifications>;
  /** fetch data from the table: "sent_resource_notifications" using primary key columns */
  sent_resource_notifications_by_pk?: Maybe<SentResourceNotifications>;
  /** fetch data from the table in a streaming manner: "sent_resource_notifications" */
  sent_resource_notifications_stream: Array<SentResourceNotifications>;
  /** fetch data from the table: "sigma_credentials" */
  sigma_credentials: Array<SigmaCredentials>;
  /** fetch data from the table: "sigma_credentials" using primary key columns */
  sigma_credentials_by_pk?: Maybe<SigmaCredentials>;
  /** fetch data from the table in a streaming manner: "sigma_credentials" */
  sigma_credentials_stream: Array<SigmaCredentials>;
  /** fetch data from the table: "slack_credentials" */
  slack_credentials: Array<SlackCredentials>;
  /** fetch data from the table: "slack_credentials" using primary key columns */
  slack_credentials_by_pk?: Maybe<SlackCredentials>;
  /** fetch data from the table in a streaming manner: "slack_credentials" */
  slack_credentials_stream: Array<SlackCredentials>;
  /** fetch data from the table: "source_share_mirror_databases" */
  source_share_mirror_databases: Array<SourceShareMirrorDatabases>;
  /** fetch data from the table: "source_share_mirror_databases" using primary key columns */
  source_share_mirror_databases_by_pk?: Maybe<SourceShareMirrorDatabases>;
  /** fetch data from the table in a streaming manner: "source_share_mirror_databases" */
  source_share_mirror_databases_stream: Array<SourceShareMirrorDatabases>;
  /** fetch data from the table: "source_share_mirrors" */
  source_share_mirrors: Array<SourceShareMirrors>;
  /** fetch data from the table: "source_share_mirrors" using primary key columns */
  source_share_mirrors_by_pk?: Maybe<SourceShareMirrors>;
  /** fetch data from the table in a streaming manner: "source_share_mirrors" */
  source_share_mirrors_stream: Array<SourceShareMirrors>;
  /** An array relationship */
  space_subset_grants: Array<SpaceSubsetGrants>;
  /** fetch data from the table: "space_subset_grants" using primary key columns */
  space_subset_grants_by_pk?: Maybe<SpaceSubsetGrants>;
  /** fetch data from the table in a streaming manner: "space_subset_grants" */
  space_subset_grants_stream: Array<SpaceSubsetGrants>;
  /** An array relationship */
  space_sync_templates: Array<SpaceSyncTemplates>;
  /** fetch data from the table: "space_sync_templates" using primary key columns */
  space_sync_templates_by_pk?: Maybe<SpaceSyncTemplates>;
  /** fetch data from the table in a streaming manner: "space_sync_templates" */
  space_sync_templates_stream: Array<SpaceSyncTemplates>;
  /** An array relationship */
  space_user_groups: Array<SpaceUserGroups>;
  /** fetch data from the table: "space_user_groups" using primary key columns */
  space_user_groups_by_pk?: Maybe<SpaceUserGroups>;
  /** fetch data from the table in a streaming manner: "space_user_groups" */
  space_user_groups_stream: Array<SpaceUserGroups>;
  /** fetch data from the table: "spaces" */
  spaces: Array<Spaces>;
  /** fetch data from the table: "spaces" using primary key columns */
  spaces_by_pk?: Maybe<Spaces>;
  /** fetch data from the table in a streaming manner: "spaces" */
  spaces_stream: Array<Spaces>;
  /** An array relationship */
  sso_group_user_groups: Array<SsoGroupUserGroups>;
  /** fetch data from the table: "sso_group_user_groups" using primary key columns */
  sso_group_user_groups_by_pk?: Maybe<SsoGroupUserGroups>;
  /** fetch data from the table in a streaming manner: "sso_group_user_groups" */
  sso_group_user_groups_stream: Array<SsoGroupUserGroups>;
  /** An array relationship */
  sso_groups: Array<SsoGroups>;
  /** fetch data from the table: "sso_groups" using primary key columns */
  sso_groups_by_pk?: Maybe<SsoGroups>;
  /** fetch data from the table in a streaming manner: "sso_groups" */
  sso_groups_stream: Array<SsoGroups>;
  /** An array relationship */
  sso_user_groups: Array<SsoUserGroups>;
  /** fetch data from the table: "sso_user_groups" using primary key columns */
  sso_user_groups_by_pk?: Maybe<SsoUserGroups>;
  /** fetch data from the table in a streaming manner: "sso_user_groups" */
  sso_user_groups_stream: Array<SsoUserGroups>;
  /** fetch data from the table: "static_lists" */
  static_lists: Array<StaticLists>;
  /** fetch aggregated fields from the table: "static_lists" */
  static_lists_aggregate: StaticListsAggregate;
  /** fetch data from the table: "static_lists" using primary key columns */
  static_lists_by_pk?: Maybe<StaticLists>;
  /** fetch data from the table in a streaming manner: "static_lists" */
  static_lists_stream: Array<StaticLists>;
  /** fetch data from the table: "support_access_grant" */
  support_access_grant: Array<SupportAccessGrant>;
  /** fetch data from the table: "support_access_grant" using primary key columns */
  support_access_grant_by_pk?: Maybe<SupportAccessGrant>;
  /** fetch data from the table in a streaming manner: "support_access_grant" */
  support_access_grant_stream: Array<SupportAccessGrant>;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** fetch data from the table in a streaming manner: "sync_alerts" */
  sync_alerts_stream: Array<SyncAlerts>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  /** fetch data from the table: "sync_attempts" using primary key columns */
  sync_attempts_by_pk?: Maybe<SyncAttempts>;
  /** fetch data from the table in a streaming manner: "sync_attempts" */
  sync_attempts_stream: Array<SyncAttempts>;
  /** fetch data from the table: "sync_idr_schedules" */
  sync_idr_schedules: Array<SyncIdrSchedules>;
  /** fetch aggregated fields from the table: "sync_idr_schedules" */
  sync_idr_schedules_aggregate: SyncIdrSchedulesAggregate;
  /** fetch data from the table: "sync_idr_schedules" using primary key columns */
  sync_idr_schedules_by_pk?: Maybe<SyncIdrSchedules>;
  /** fetch data from the table in a streaming manner: "sync_idr_schedules" */
  sync_idr_schedules_stream: Array<SyncIdrSchedules>;
  /** fetch data from the table: "sync_request_computed_progress" */
  sync_request_computed_progress: Array<SyncRequestComputedProgress>;
  /** fetch data from the table in a streaming manner: "sync_request_computed_progress" */
  sync_request_computed_progress_stream: Array<SyncRequestComputedProgress>;
  /** fetch data from the table: "sync_request_diffs" */
  sync_request_diffs: Array<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_diffs" using primary key columns */
  sync_request_diffs_by_pk?: Maybe<SyncRequestDiffs>;
  /** fetch data from the table in a streaming manner: "sync_request_diffs" */
  sync_request_diffs_stream: Array<SyncRequestDiffs>;
  /** fetch data from the table: "sync_request_event_spans" */
  sync_request_event_spans: Array<SyncRequestEventSpans>;
  /** fetch data from the table in a streaming manner: "sync_request_event_spans" */
  sync_request_event_spans_stream: Array<SyncRequestEventSpans>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** fetch data from the table: "sync_requests" using primary key columns */
  sync_requests_by_pk?: Maybe<SyncRequests>;
  /** fetch data from the table in a streaming manner: "sync_requests" */
  sync_requests_stream: Array<SyncRequests>;
  /** An array relationship */
  sync_sequence_members: Array<SyncSequenceMembers>;
  /** fetch data from the table: "sync_sequence_members" using primary key columns */
  sync_sequence_members_by_pk?: Maybe<SyncSequenceMembers>;
  /** fetch data from the table in a streaming manner: "sync_sequence_members" */
  sync_sequence_members_stream: Array<SyncSequenceMembers>;
  /** An array relationship */
  sync_sequence_requests: Array<SyncSequenceRequests>;
  /** fetch data from the table: "sync_sequence_requests" using primary key columns */
  sync_sequence_requests_by_pk?: Maybe<SyncSequenceRequests>;
  /** fetch data from the table in a streaming manner: "sync_sequence_requests" */
  sync_sequence_requests_stream: Array<SyncSequenceRequests>;
  /** fetch data from the table: "sync_sequence_runs" */
  sync_sequence_runs: Array<SyncSequenceRuns>;
  /** fetch aggregated fields from the table: "sync_sequence_runs" */
  sync_sequence_runs_aggregate: SyncSequenceRunsAggregate;
  /** fetch data from the table: "sync_sequence_runs" using primary key columns */
  sync_sequence_runs_by_pk?: Maybe<SyncSequenceRuns>;
  /** fetch data from the table in a streaming manner: "sync_sequence_runs" */
  sync_sequence_runs_stream: Array<SyncSequenceRuns>;
  /** fetch data from the table: "sync_sequences" */
  sync_sequences: Array<SyncSequences>;
  /** fetch aggregated fields from the table: "sync_sequences" */
  sync_sequences_aggregate: SyncSequencesAggregate;
  /** fetch data from the table: "sync_sequences" using primary key columns */
  sync_sequences_by_pk?: Maybe<SyncSequences>;
  /** fetch data from the table in a streaming manner: "sync_sequences" */
  sync_sequences_stream: Array<SyncSequences>;
  /** An array relationship */
  sync_templates: Array<SyncTemplates>;
  /** An aggregate relationship */
  sync_templates_aggregate: SyncTemplatesAggregate;
  /** fetch data from the table: "sync_templates" using primary key columns */
  sync_templates_by_pk?: Maybe<SyncTemplates>;
  /** fetch data from the table in a streaming manner: "sync_templates" */
  sync_templates_stream: Array<SyncTemplates>;
  /** An array relationship */
  syncs: Array<Syncs>;
  /** An aggregate relationship */
  syncs_aggregate: SyncsAggregate;
  /** fetch data from the table in a streaming manner: "syncs" */
  syncs_stream: Array<Syncs>;
  /** fetch data from the table: "syncs_to_journeys" */
  syncs_to_journeys: Array<SyncsToJourneys>;
  /** fetch data from the table in a streaming manner: "syncs_to_journeys" */
  syncs_to_journeys_stream: Array<SyncsToJourneys>;
  /** fetch data from the table: "through_model_relationships" */
  through_model_relationships: Array<ThroughModelRelationships>;
  /** fetch data from the table: "through_model_relationships" using primary key columns */
  through_model_relationships_by_pk?: Maybe<ThroughModelRelationships>;
  /** fetch data from the table in a streaming manner: "through_model_relationships" */
  through_model_relationships_stream: Array<ThroughModelRelationships>;
  /** fetch data from the table: "top_k_trait_status" */
  top_k_trait_status: Array<TopKTraitStatus>;
  /** fetch data from the table: "top_k_trait_status" using primary key columns */
  top_k_trait_status_by_pk?: Maybe<TopKTraitStatus>;
  /** fetch data from the table in a streaming manner: "top_k_trait_status" */
  top_k_trait_status_stream: Array<TopKTraitStatus>;
  /** fetch data from the table: "tracked_audience_list_audiences" */
  tracked_audience_list_audiences: Array<TrackedAudienceListAudiences>;
  /** fetch data from the table: "tracked_audience_list_audiences" using primary key columns */
  tracked_audience_list_audiences_by_pk?: Maybe<TrackedAudienceListAudiences>;
  /** fetch data from the table in a streaming manner: "tracked_audience_list_audiences" */
  tracked_audience_list_audiences_stream: Array<TrackedAudienceListAudiences>;
  /** fetch data from the table: "tracked_audience_lists" */
  tracked_audience_lists: Array<TrackedAudienceLists>;
  /** fetch aggregated fields from the table: "tracked_audience_lists" */
  tracked_audience_lists_aggregate: TrackedAudienceListsAggregate;
  /** fetch data from the table: "tracked_audience_lists" using primary key columns */
  tracked_audience_lists_by_pk?: Maybe<TrackedAudienceLists>;
  /** fetch data from the table in a streaming manner: "tracked_audience_lists" */
  tracked_audience_lists_stream: Array<TrackedAudienceLists>;
  /** fetch data from the table: "trait_definitions" */
  trait_definitions: Array<TraitDefinitions>;
  /** fetch aggregated fields from the table: "trait_definitions" */
  trait_definitions_aggregate: TraitDefinitionsAggregate;
  /** fetch data from the table: "trait_definitions" using primary key columns */
  trait_definitions_by_pk?: Maybe<TraitDefinitions>;
  /** fetch data from the table in a streaming manner: "trait_definitions" */
  trait_definitions_stream: Array<TraitDefinitions>;
  /** fetch data from the table: "trait_references" */
  trait_references: Array<TraitReferences>;
  /** fetch aggregated fields from the table: "trait_references" */
  trait_references_aggregate: TraitReferencesAggregate;
  /** fetch data from the table: "trait_references" using primary key columns */
  trait_references_by_pk?: Maybe<TraitReferences>;
  /** fetch data from the table: "trait_references_segments" */
  trait_references_segments: Array<TraitReferencesSegments>;
  /** fetch aggregated fields from the table: "trait_references_segments" */
  trait_references_segments_aggregate: TraitReferencesSegmentsAggregate;
  /** fetch data from the table in a streaming manner: "trait_references_segments" */
  trait_references_segments_stream: Array<TraitReferencesSegments>;
  /** fetch data from the table in a streaming manner: "trait_references" */
  trait_references_stream: Array<TraitReferences>;
  /** fetch data from the table: "tunnels" */
  tunnels: Array<Tunnels>;
  /** fetch data from the table: "tunnels" using primary key columns */
  tunnels_by_pk?: Maybe<Tunnels>;
  /** fetch data from the table in a streaming manner: "tunnels" */
  tunnels_stream: Array<Tunnels>;
  /** An array relationship */
  user_group_audience_creation_authorization: Array<UserGroupAudienceCreationAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_audience_creation_authorization" */
  user_group_audience_creation_authorization_stream: Array<UserGroupAudienceCreationAuthorization>;
  /** fetch data from the table: "user_group_grants" */
  user_group_grants: Array<UserGroupGrants>;
  /** fetch aggregated fields from the table: "user_group_grants" */
  user_group_grants_aggregate: UserGroupGrantsAggregate;
  /** fetch data from the table: "user_group_grants" using primary key columns */
  user_group_grants_by_pk?: Maybe<UserGroupGrants>;
  /** fetch data from the table in a streaming manner: "user_group_grants" */
  user_group_grants_stream: Array<UserGroupGrants>;
  /** An array relationship */
  user_group_members: Array<UserGroupMembers>;
  /** fetch data from the table: "user_group_members" using primary key columns */
  user_group_members_by_pk?: Maybe<UserGroupMembers>;
  /** fetch data from the table in a streaming manner: "user_group_members" */
  user_group_members_stream: Array<UserGroupMembers>;
  /** An array relationship */
  user_group_model_authorization: Array<UserGroupModelAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_model_authorization" */
  user_group_model_authorization_stream: Array<UserGroupModelAuthorization>;
  /** fetch data from the table: "user_group_model_creation_authorization" */
  user_group_model_creation_authorization: Array<UserGroupModelCreationAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_model_creation_authorization" */
  user_group_model_creation_authorization_stream: Array<UserGroupModelCreationAuthorization>;
  /** An array relationship */
  user_group_source_grants: Array<UserGroupSourceGrants>;
  /** fetch data from the table in a streaming manner: "user_group_source_grants" */
  user_group_source_grants_stream: Array<UserGroupSourceGrants>;
  /** An array relationship */
  user_group_subset_authorization: Array<UserGroupSubsetAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_subset_authorization" */
  user_group_subset_authorization_stream: Array<UserGroupSubsetAuthorization>;
  /** An array relationship */
  user_group_subset_grants: Array<UserGroupSubsetGrants>;
  /** An aggregate relationship */
  user_group_subset_grants_aggregate: UserGroupSubsetGrantsAggregate;
  /** fetch data from the table: "user_group_subset_grants" using primary key columns */
  user_group_subset_grants_by_pk?: Maybe<UserGroupSubsetGrants>;
  /** fetch data from the table in a streaming manner: "user_group_subset_grants" */
  user_group_subset_grants_stream: Array<UserGroupSubsetGrants>;
  /** fetch data from the table: "user_group_sync_creation_authorization" */
  user_group_sync_creation_authorization: Array<UserGroupSyncCreationAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_sync_creation_authorization" */
  user_group_sync_creation_authorization_stream: Array<UserGroupSyncCreationAuthorization>;
  /** An array relationship */
  user_group_trait_authorization: Array<UserGroupTraitAuthorization>;
  /** fetch data from the table in a streaming manner: "user_group_trait_authorization" */
  user_group_trait_authorization_stream: Array<UserGroupTraitAuthorization>;
  /** An array relationship */
  user_group_workspaces: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  user_group_workspaces_aggregate: UserGroupWorkspacesAggregate;
  /** fetch data from the table: "user_group_workspaces" using primary key columns */
  user_group_workspaces_by_pk?: Maybe<UserGroupWorkspaces>;
  /** fetch data from the table in a streaming manner: "user_group_workspaces" */
  user_group_workspaces_stream: Array<UserGroupWorkspaces>;
  /** An array relationship */
  user_groups: Array<UserGroups>;
  /** An aggregate relationship */
  user_groups_aggregate: UserGroupsAggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  user_groups_by_pk?: Maybe<UserGroups>;
  /** fetch data from the table in a streaming manner: "user_groups" */
  user_groups_stream: Array<UserGroups>;
  /** An array relationship */
  video_exports: Array<VideoExports>;
  /** An aggregate relationship */
  video_exports_aggregate: VideoExportsAggregate;
  /** fetch data from the table: "video_exports" using primary key columns */
  video_exports_by_pk?: Maybe<VideoExports>;
  /** fetch data from the table in a streaming manner: "video_exports" */
  video_exports_stream: Array<VideoExports>;
  /** fetch data from the table: "warehouse_snapshots" */
  warehouse_snapshots: Array<WarehouseSnapshots>;
  /** fetch data from the table: "warehouse_snapshots" using primary key columns */
  warehouse_snapshots_by_pk?: Maybe<WarehouseSnapshots>;
  /** fetch data from the table in a streaming manner: "warehouse_snapshots" */
  warehouse_snapshots_stream: Array<WarehouseSnapshots>;
  /** An array relationship */
  workspace_members: Array<WorkspaceMembers>;
  /** An aggregate relationship */
  workspace_members_aggregate: WorkspaceMembersAggregate;
  /** fetch data from the table in a streaming manner: "workspace_members" */
  workspace_members_stream: Array<WorkspaceMembers>;
  /** fetch data from the table: "workspace_notification_channels" */
  workspace_notification_channels: Array<WorkspaceNotificationChannels>;
  /** fetch data from the table: "workspace_notification_channels" using primary key columns */
  workspace_notification_channels_by_pk?: Maybe<WorkspaceNotificationChannels>;
  /** fetch data from the table in a streaming manner: "workspace_notification_channels" */
  workspace_notification_channels_stream: Array<WorkspaceNotificationChannels>;
  /** fetch data from the table: "workspace_overage_dates" */
  workspace_overage_dates: Array<WorkspaceOverageDates>;
  /** fetch data from the table in a streaming manner: "workspace_overage_dates" */
  workspace_overage_dates_stream: Array<WorkspaceOverageDates>;
  /** An array relationship */
  workspaces: Array<Workspaces>;
  /** fetch data from the table: "workspaces" using primary key columns */
  workspaces_by_pk?: Maybe<Workspaces>;
  /** fetch data from the table in a streaming manner: "workspaces" */
  workspaces_stream: Array<Workspaces>;
};


export type SubscriptionAdAgentArtifactsArgs = {
  distinct_on?: InputMaybe<Array<AdAgentArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAgentArtifactsOrderBy>>;
  where?: InputMaybe<AdAgentArtifactsBoolExp>;
};


export type SubscriptionAdAgentArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdAgentArtifactsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdAgentArtifactsStreamCursorInput>>;
  where?: InputMaybe<AdAgentArtifactsBoolExp>;
};


export type SubscriptionAdAssetFavoritesArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


export type SubscriptionAdAssetFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdAssetFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdAssetFavoritesOrderBy>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


export type SubscriptionAdAssetFavoritesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdAssetFavoritesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdAssetFavoritesStreamCursorInput>>;
  where?: InputMaybe<AdAssetFavoritesBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchQueueArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchQueueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchQueueOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchQueueAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchQueueSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchQueueOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchQueueByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefAssetLaunchQueueStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefAssetLaunchQueueStreamCursorInput>>;
  where?: InputMaybe<AdBriefAssetLaunchQueueBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchesArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchesOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetLaunchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetLaunchesOrderBy>>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};


export type SubscriptionAdBriefAssetLaunchesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefAssetLaunchesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefAssetLaunchesStreamCursorInput>>;
  where?: InputMaybe<AdBriefAssetLaunchesBoolExp>;
};


export type SubscriptionAdBriefAssetSizeVariantsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


export type SubscriptionAdBriefAssetSizeVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetSizeVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetSizeVariantsOrderBy>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


export type SubscriptionAdBriefAssetSizeVariantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefAssetSizeVariantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefAssetSizeVariantsStreamCursorInput>>;
  where?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
};


export type SubscriptionAdBriefAssetVersionsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


export type SubscriptionAdBriefAssetVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetVersionsOrderBy>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


export type SubscriptionAdBriefAssetVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefAssetVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefAssetVersionsStreamCursorInput>>;
  where?: InputMaybe<AdBriefAssetVersionsBoolExp>;
};


export type SubscriptionAdBriefAssetsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


export type SubscriptionAdBriefAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefAssetsOrderBy>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


export type SubscriptionAdBriefAssetsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefAssetsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefAssetsStreamCursorInput>>;
  where?: InputMaybe<AdBriefAssetsBoolExp>;
};


export type SubscriptionAdBriefsArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


export type SubscriptionAdBriefsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdBriefsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdBriefsOrderBy>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


export type SubscriptionAdBriefsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdBriefsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdBriefsStreamCursorInput>>;
  where?: InputMaybe<AdBriefsBoolExp>;
};


export type SubscriptionAdExportChannelSizesArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


export type SubscriptionAdExportChannelSizesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelSizesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelSizesOrderBy>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


export type SubscriptionAdExportChannelSizesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdExportChannelSizesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdExportChannelSizesStreamCursorInput>>;
  where?: InputMaybe<AdExportChannelSizesBoolExp>;
};


export type SubscriptionAdExportChannelsArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelsOrderBy>>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};


export type SubscriptionAdExportChannelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdExportChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdExportChannelsOrderBy>>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};


export type SubscriptionAdExportChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdExportChannelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdExportChannelsStreamCursorInput>>;
  where?: InputMaybe<AdExportChannelsBoolExp>;
};


export type SubscriptionAdGenerationPipelineRunsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


export type SubscriptionAdGenerationPipelineRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationPipelineRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationPipelineRunsOrderBy>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


export type SubscriptionAdGenerationPipelineRunsByPkArgs = {
  job_id: Scalars['uuid'];
};


export type SubscriptionAdGenerationPipelineRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdGenerationPipelineRunsStreamCursorInput>>;
  where?: InputMaybe<AdGenerationPipelineRunsBoolExp>;
};


export type SubscriptionAdGenerationWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationWorkflowsOrderBy>>;
  where?: InputMaybe<AdGenerationWorkflowsBoolExp>;
};


export type SubscriptionAdGenerationWorkflowsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdGenerationWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdGenerationWorkflowsOrderBy>>;
  where?: InputMaybe<AdGenerationWorkflowsBoolExp>;
};


export type SubscriptionAdGenerationWorkflowsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdGenerationWorkflowsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdGenerationWorkflowsStreamCursorInput>>;
  where?: InputMaybe<AdGenerationWorkflowsBoolExp>;
};


export type SubscriptionAdStatsModelsArgs = {
  distinct_on?: InputMaybe<Array<AdStatsModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStatsModelsOrderBy>>;
  where?: InputMaybe<AdStatsModelsBoolExp>;
};


export type SubscriptionAdStatsModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionAdStatsModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStatsModelsStreamCursorInput>>;
  where?: InputMaybe<AdStatsModelsBoolExp>;
};


export type SubscriptionAdStudioProductFeedsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProductFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProductFeedsOrderBy>>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};


export type SubscriptionAdStudioProductFeedsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProductFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProductFeedsOrderBy>>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};


export type SubscriptionAdStudioProductFeedsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioProductFeedsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioProductFeedsStreamCursorInput>>;
  where?: InputMaybe<AdStudioProductFeedsBoolExp>;
};


export type SubscriptionAdStudioProjectBriefVersionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectBriefVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectBriefVersionsOrderBy>>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};


export type SubscriptionAdStudioProjectBriefVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectBriefVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectBriefVersionsOrderBy>>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};


export type SubscriptionAdStudioProjectBriefVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioProjectBriefVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioProjectBriefVersionsStreamCursorInput>>;
  where?: InputMaybe<AdStudioProjectBriefVersionsBoolExp>;
};


export type SubscriptionAdStudioProjectPinsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


export type SubscriptionAdStudioProjectPinsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectPinsOrderBy>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


export type SubscriptionAdStudioProjectPinsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioProjectPinsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioProjectPinsStreamCursorInput>>;
  where?: InputMaybe<AdStudioProjectPinsBoolExp>;
};


export type SubscriptionAdStudioProjectsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


export type SubscriptionAdStudioProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioProjectsOrderBy>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


export type SubscriptionAdStudioProjectsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioProjectsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioProjectsStreamCursorInput>>;
  where?: InputMaybe<AdStudioProjectsBoolExp>;
};


export type SubscriptionAdStudioSessionsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


export type SubscriptionAdStudioSessionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioSessionsOrderBy>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


export type SubscriptionAdStudioSessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioSessionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioSessionsStreamCursorInput>>;
  where?: InputMaybe<AdStudioSessionsBoolExp>;
};


export type SubscriptionAdStudioTreatmentsArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


export type SubscriptionAdStudioTreatmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AdStudioTreatmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdStudioTreatmentsOrderBy>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


export type SubscriptionAdStudioTreatmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdStudioTreatmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdStudioTreatmentsStreamCursorInput>>;
  where?: InputMaybe<AdStudioTreatmentsBoolExp>;
};


export type SubscriptionAdminEntitlementsArgs = {
  distinct_on?: InputMaybe<Array<AdminEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminEntitlementsOrderBy>>;
  where?: InputMaybe<AdminEntitlementsBoolExp>;
};


export type SubscriptionAdminEntitlementsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAdminEntitlementsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdminEntitlementsStreamCursorInput>>;
  where?: InputMaybe<AdminEntitlementsBoolExp>;
};


export type SubscriptionAdminWorkspaceEntitlementsArgs = {
  distinct_on?: InputMaybe<Array<AdminWorkspaceEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AdminWorkspaceEntitlementsOrderBy>>;
  where?: InputMaybe<AdminWorkspaceEntitlementsBoolExp>;
};


export type SubscriptionAdminWorkspaceEntitlementsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AdminWorkspaceEntitlementsStreamCursorInput>>;
  where?: InputMaybe<AdminWorkspaceEntitlementsBoolExp>;
};


export type SubscriptionAgentAssetVersionsArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


export type SubscriptionAgentAssetVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetVersionsOrderBy>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


export type SubscriptionAgentAssetVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgentAssetVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgentAssetVersionsStreamCursorInput>>;
  where?: InputMaybe<AgentAssetVersionsBoolExp>;
};


export type SubscriptionAgentAssetsArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetsOrderBy>>;
  where?: InputMaybe<AgentAssetsBoolExp>;
};


export type SubscriptionAgentAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgentAssetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentAssetsOrderBy>>;
  where?: InputMaybe<AgentAssetsBoolExp>;
};


export type SubscriptionAgentAssetsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgentAssetsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgentAssetsStreamCursorInput>>;
  where?: InputMaybe<AgentAssetsBoolExp>;
};


export type SubscriptionAgentReportSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgentReportSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentReportSuggestionsOrderBy>>;
  where?: InputMaybe<AgentReportSuggestionsBoolExp>;
};


export type SubscriptionAgentReportSuggestionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgentReportSuggestionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgentReportSuggestionsStreamCursorInput>>;
  where?: InputMaybe<AgentReportSuggestionsBoolExp>;
};


export type SubscriptionAgentSuggestionBatchesArgs = {
  distinct_on?: InputMaybe<Array<AgentSuggestionBatchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentSuggestionBatchesOrderBy>>;
  where?: InputMaybe<AgentSuggestionBatchesBoolExp>;
};


export type SubscriptionAgentSuggestionBatchesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgentSuggestionBatchesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgentSuggestionBatchesStreamCursorInput>>;
  where?: InputMaybe<AgentSuggestionBatchesBoolExp>;
};


export type SubscriptionAgentSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgentSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgentSuggestionsOrderBy>>;
  where?: InputMaybe<AgentSuggestionsBoolExp>;
};


export type SubscriptionAgentSuggestionsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type SubscriptionAgentSuggestionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgentSuggestionsStreamCursorInput>>;
  where?: InputMaybe<AgentSuggestionsBoolExp>;
};


export type SubscriptionAgenticSettingsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsOrderBy>>;
  where?: InputMaybe<AgenticSettingsBoolExp>;
};


export type SubscriptionAgenticSettingsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type SubscriptionAgenticSettingsEntitiesLinksArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntitiesLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntitiesLinksOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
};


export type SubscriptionAgenticSettingsEntitiesLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgenticSettingsEntitiesLinksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgenticSettingsEntitiesLinksStreamCursorInput>>;
  where?: InputMaybe<AgenticSettingsEntitiesLinksBoolExp>;
};


export type SubscriptionAgenticSettingsEntityReviewSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


export type SubscriptionAgenticSettingsEntityReviewSuggestionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewSuggestionsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


export type SubscriptionAgenticSettingsEntityReviewSuggestionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgenticSettingsEntityReviewSuggestionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgenticSettingsEntityReviewSuggestionsStreamCursorInput>>;
  where?: InputMaybe<AgenticSettingsEntityReviewSuggestionsBoolExp>;
};


export type SubscriptionAgenticSettingsEntityReviewsArgs = {
  distinct_on?: InputMaybe<Array<AgenticSettingsEntityReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgenticSettingsEntityReviewsOrderBy>>;
  where?: InputMaybe<AgenticSettingsEntityReviewsBoolExp>;
};


export type SubscriptionAgenticSettingsEntityReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAgenticSettingsEntityReviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgenticSettingsEntityReviewsStreamCursorInput>>;
  where?: InputMaybe<AgenticSettingsEntityReviewsBoolExp>;
};


export type SubscriptionAgenticSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgenticSettingsStreamCursorInput>>;
  where?: InputMaybe<AgenticSettingsBoolExp>;
};


export type SubscriptionAirbyteSyncsArgs = {
  distinct_on?: InputMaybe<Array<AirbyteSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AirbyteSyncsOrderBy>>;
  where?: InputMaybe<AirbyteSyncsBoolExp>;
};


export type SubscriptionAirbyteSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAirbyteSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AirbyteSyncsStreamCursorInput>>;
  where?: InputMaybe<AirbyteSyncsBoolExp>;
};


export type SubscriptionAlertInstancesArgs = {
  distinct_on?: InputMaybe<Array<AlertInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertInstancesOrderBy>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


export type SubscriptionAlertInstancesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AlertInstancesStreamCursorInput>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


export type SubscriptionAlertStatusesArgs = {
  distinct_on?: InputMaybe<Array<AlertStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertStatusesOrderBy>>;
  where?: InputMaybe<AlertStatusesBoolExp>;
};


export type SubscriptionAlertStatusesByPkArgs = {
  alert_id: Scalars['bigint'];
  destination_instance_id: Scalars['bigint'];
};


export type SubscriptionAlertStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AlertStatusesStreamCursorInput>>;
  where?: InputMaybe<AlertStatusesBoolExp>;
};


export type SubscriptionAlertsArgs = {
  distinct_on?: InputMaybe<Array<AlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertsOrderBy>>;
  where?: InputMaybe<AlertsBoolExp>;
};


export type SubscriptionAlertsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionAlertsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AlertsStreamCursorInput>>;
  where?: InputMaybe<AlertsBoolExp>;
};


export type SubscriptionAllMembershipsV2Args = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


export type SubscriptionAllMembershipsV2AggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


export type SubscriptionAllMembershipsV2StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AllMembershipsV2StreamCursorInput>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


export type SubscriptionAmpActionCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


export type SubscriptionAmpActionCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionCallsOrderBy>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


export type SubscriptionAmpActionCallsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpActionCallsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpActionCallsStreamCursorInput>>;
  where?: InputMaybe<AmpActionCallsBoolExp>;
};


export type SubscriptionAmpActionPlanVersionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


export type SubscriptionAmpActionPlanVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlanVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlanVersionsOrderBy>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


export type SubscriptionAmpActionPlanVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpActionPlanVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpActionPlanVersionsStreamCursorInput>>;
  where?: InputMaybe<AmpActionPlanVersionsBoolExp>;
};


export type SubscriptionAmpActionPlansArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


export type SubscriptionAmpActionPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionPlansOrderBy>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


export type SubscriptionAmpActionPlansByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpActionPlansStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpActionPlansStreamCursorInput>>;
  where?: InputMaybe<AmpActionPlansBoolExp>;
};


export type SubscriptionAmpActionToolCallsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


export type SubscriptionAmpActionToolCallsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionToolCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionToolCallsOrderBy>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


export type SubscriptionAmpActionToolCallsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpActionToolCallsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpActionToolCallsStreamCursorInput>>;
  where?: InputMaybe<AmpActionToolCallsBoolExp>;
};


export type SubscriptionAmpActionsArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


export type SubscriptionAmpActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpActionsOrderBy>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


export type SubscriptionAmpActionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpActionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpActionsStreamCursorInput>>;
  where?: InputMaybe<AmpActionsBoolExp>;
};


export type SubscriptionAmpAssetGroupsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetGroupsOrderBy>>;
  where?: InputMaybe<AmpAssetGroupsBoolExp>;
};


export type SubscriptionAmpAssetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetGroupsOrderBy>>;
  where?: InputMaybe<AmpAssetGroupsBoolExp>;
};


export type SubscriptionAmpAssetGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpAssetGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpAssetGroupsStreamCursorInput>>;
  where?: InputMaybe<AmpAssetGroupsBoolExp>;
};


export type SubscriptionAmpAssetRatingsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


export type SubscriptionAmpAssetRatingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetRatingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetRatingsOrderBy>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


export type SubscriptionAmpAssetRatingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpAssetRatingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpAssetRatingsStreamCursorInput>>;
  where?: InputMaybe<AmpAssetRatingsBoolExp>;
};


export type SubscriptionAmpAssetSourcesArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSourcesOrderBy>>;
  where?: InputMaybe<AmpAssetSourcesBoolExp>;
};


export type SubscriptionAmpAssetSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSourcesOrderBy>>;
  where?: InputMaybe<AmpAssetSourcesBoolExp>;
};


export type SubscriptionAmpAssetSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpAssetSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpAssetSourcesStreamCursorInput>>;
  where?: InputMaybe<AmpAssetSourcesBoolExp>;
};


export type SubscriptionAmpAssetSyncRunsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


export type SubscriptionAmpAssetSyncRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncRunsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


export type SubscriptionAmpAssetSyncRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpAssetSyncRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpAssetSyncRunsStreamCursorInput>>;
  where?: InputMaybe<AmpAssetSyncRunsBoolExp>;
};


export type SubscriptionAmpAssetSyncsArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


export type SubscriptionAmpAssetSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpAssetSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpAssetSyncsOrderBy>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


export type SubscriptionAmpAssetSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpAssetSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpAssetSyncsStreamCursorInput>>;
  where?: InputMaybe<AmpAssetSyncsBoolExp>;
};


export type SubscriptionAmpCreativeClassificationRunsArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeClassificationRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeClassificationRunsOrderBy>>;
  where?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
};


export type SubscriptionAmpCreativeClassificationRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeClassificationRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeClassificationRunsOrderBy>>;
  where?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
};


export type SubscriptionAmpCreativeClassificationRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpCreativeClassificationRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpCreativeClassificationRunsStreamCursorInput>>;
  where?: InputMaybe<AmpCreativeClassificationRunsBoolExp>;
};


export type SubscriptionAmpCreativeDimensionValuesArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionValuesOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
};


export type SubscriptionAmpCreativeDimensionValuesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpCreativeDimensionValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpCreativeDimensionValuesStreamCursorInput>>;
  where?: InputMaybe<AmpCreativeDimensionValuesBoolExp>;
};


export type SubscriptionAmpCreativeDimensionsArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionsOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};


export type SubscriptionAmpCreativeDimensionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpCreativeDimensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpCreativeDimensionsOrderBy>>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};


export type SubscriptionAmpCreativeDimensionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpCreativeDimensionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpCreativeDimensionsStreamCursorInput>>;
  where?: InputMaybe<AmpCreativeDimensionsBoolExp>;
};


export type SubscriptionAmpFileFavoritesArgs = {
  distinct_on?: InputMaybe<Array<AmpFileFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFileFavoritesOrderBy>>;
  where?: InputMaybe<AmpFileFavoritesBoolExp>;
};


export type SubscriptionAmpFileFavoritesByPkArgs = {
  amp_file_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type SubscriptionAmpFileFavoritesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpFileFavoritesStreamCursorInput>>;
  where?: InputMaybe<AmpFileFavoritesBoolExp>;
};


export type SubscriptionAmpFilesArgs = {
  distinct_on?: InputMaybe<Array<AmpFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFilesOrderBy>>;
  where?: InputMaybe<AmpFilesBoolExp>;
};


export type SubscriptionAmpFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFilesOrderBy>>;
  where?: InputMaybe<AmpFilesBoolExp>;
};


export type SubscriptionAmpFilesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpFilesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpFilesStreamCursorInput>>;
  where?: InputMaybe<AmpFilesBoolExp>;
};


export type SubscriptionAmpFollowedSourcesArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedSourcesOrderBy>>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};


export type SubscriptionAmpFollowedSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedSourcesOrderBy>>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};


export type SubscriptionAmpFollowedSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpFollowedSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpFollowedSourcesStreamCursorInput>>;
  where?: InputMaybe<AmpFollowedSourcesBoolExp>;
};


export type SubscriptionAmpFollowedTopicsArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedTopicsOrderBy>>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};


export type SubscriptionAmpFollowedTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpFollowedTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpFollowedTopicsOrderBy>>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};


export type SubscriptionAmpFollowedTopicsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpFollowedTopicsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpFollowedTopicsStreamCursorInput>>;
  where?: InputMaybe<AmpFollowedTopicsBoolExp>;
};


export type SubscriptionAmpLaunchVerdictsArgs = {
  distinct_on?: InputMaybe<Array<AmpLaunchVerdictsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpLaunchVerdictsOrderBy>>;
  where?: InputMaybe<AmpLaunchVerdictsBoolExp>;
};


export type SubscriptionAmpLaunchVerdictsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpLaunchVerdictsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpLaunchVerdictsStreamCursorInput>>;
  where?: InputMaybe<AmpLaunchVerdictsBoolExp>;
};


export type SubscriptionAmpOpportunitiesArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


export type SubscriptionAmpOpportunitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpOpportunitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpOpportunitiesOrderBy>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


export type SubscriptionAmpOpportunitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpOpportunitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpOpportunitiesStreamCursorInput>>;
  where?: InputMaybe<AmpOpportunitiesBoolExp>;
};


export type SubscriptionAmpProjectLinksArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


export type SubscriptionAmpProjectLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectLinksOrderBy>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


export type SubscriptionAmpProjectLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpProjectLinksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpProjectLinksStreamCursorInput>>;
  where?: InputMaybe<AmpProjectLinksBoolExp>;
};


export type SubscriptionAmpProjectPinsArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectPinsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectPinsOrderBy>>;
  where?: InputMaybe<AmpProjectPinsBoolExp>;
};


export type SubscriptionAmpProjectPinsByPkArgs = {
  amp_project_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type SubscriptionAmpProjectPinsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpProjectPinsStreamCursorInput>>;
  where?: InputMaybe<AmpProjectPinsBoolExp>;
};


export type SubscriptionAmpProjectUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


export type SubscriptionAmpProjectUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectUsersOrderBy>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


export type SubscriptionAmpProjectUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpProjectUsersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpProjectUsersStreamCursorInput>>;
  where?: InputMaybe<AmpProjectUsersBoolExp>;
};


export type SubscriptionAmpProjectsArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


export type SubscriptionAmpProjectsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpProjectsOrderBy>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


export type SubscriptionAmpProjectsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpProjectsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpProjectsStreamCursorInput>>;
  where?: InputMaybe<AmpProjectsBoolExp>;
};


export type SubscriptionAmpSignalsArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


export type SubscriptionAmpSignalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpSignalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpSignalsOrderBy>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


export type SubscriptionAmpSignalsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpSignalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpSignalsStreamCursorInput>>;
  where?: InputMaybe<AmpSignalsBoolExp>;
};


export type SubscriptionAmpTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTagsOrderBy>>;
  where?: InputMaybe<AmpTagsBoolExp>;
};


export type SubscriptionAmpTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTagsOrderBy>>;
  where?: InputMaybe<AmpTagsBoolExp>;
};


export type SubscriptionAmpTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTagsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTagsStreamCursorInput>>;
  where?: InputMaybe<AmpTagsBoolExp>;
};


export type SubscriptionAmpTaskRelationsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


export type SubscriptionAmpTaskRelationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskRelationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskRelationsOrderBy>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


export type SubscriptionAmpTaskRelationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTaskRelationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTaskRelationsStreamCursorInput>>;
  where?: InputMaybe<AmpTaskRelationsBoolExp>;
};


export type SubscriptionAmpTaskReviewsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


export type SubscriptionAmpTaskReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskReviewsOrderBy>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


export type SubscriptionAmpTaskReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTaskReviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTaskReviewsStreamCursorInput>>;
  where?: InputMaybe<AmpTaskReviewsBoolExp>;
};


export type SubscriptionAmpTaskTagsArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


export type SubscriptionAmpTaskTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskTagsOrderBy>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


export type SubscriptionAmpTaskTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTaskTagsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTaskTagsStreamCursorInput>>;
  where?: InputMaybe<AmpTaskTagsBoolExp>;
};


export type SubscriptionAmpTaskUsersArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


export type SubscriptionAmpTaskUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTaskUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTaskUsersOrderBy>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


export type SubscriptionAmpTaskUsersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTaskUsersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTaskUsersStreamCursorInput>>;
  where?: InputMaybe<AmpTaskUsersBoolExp>;
};


export type SubscriptionAmpTasksArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


export type SubscriptionAmpTasksAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTasksOrderBy>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


export type SubscriptionAmpTasksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTasksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTasksStreamCursorInput>>;
  where?: InputMaybe<AmpTasksBoolExp>;
};


export type SubscriptionAmpTeamMembersArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


export type SubscriptionAmpTeamMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamMembersOrderBy>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


export type SubscriptionAmpTeamMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTeamMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTeamMembersStreamCursorInput>>;
  where?: InputMaybe<AmpTeamMembersBoolExp>;
};


export type SubscriptionAmpTeamsArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamsOrderBy>>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};


export type SubscriptionAmpTeamsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpTeamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpTeamsOrderBy>>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};


export type SubscriptionAmpTeamsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpTeamsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpTeamsStreamCursorInput>>;
  where?: InputMaybe<AmpTeamsBoolExp>;
};


export type SubscriptionAmpWorkflowStatusReviewersArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


export type SubscriptionAmpWorkflowStatusReviewersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusReviewersOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


export type SubscriptionAmpWorkflowStatusReviewersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpWorkflowStatusReviewersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpWorkflowStatusReviewersStreamCursorInput>>;
  where?: InputMaybe<AmpWorkflowStatusReviewersBoolExp>;
};


export type SubscriptionAmpWorkflowStatusesArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


export type SubscriptionAmpWorkflowStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowStatusesOrderBy>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


export type SubscriptionAmpWorkflowStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpWorkflowStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpWorkflowStatusesStreamCursorInput>>;
  where?: InputMaybe<AmpWorkflowStatusesBoolExp>;
};


export type SubscriptionAmpWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowsOrderBy>>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};


export type SubscriptionAmpWorkflowsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AmpWorkflowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AmpWorkflowsOrderBy>>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};


export type SubscriptionAmpWorkflowsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAmpWorkflowsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AmpWorkflowsStreamCursorInput>>;
  where?: InputMaybe<AmpWorkflowsBoolExp>;
};


export type SubscriptionAnalyticsIngestionStatsArgs = {
  distinct_on?: InputMaybe<Array<AnalyticsIngestionStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalyticsIngestionStatsOrderBy>>;
  where?: InputMaybe<AnalyticsIngestionStatsBoolExp>;
};


export type SubscriptionAnalyticsIngestionStatsByPkArgs = {
  uuid: Scalars['uuid'];
};


export type SubscriptionAnalyticsIngestionStatsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalyticsIngestionStatsStreamCursorInput>>;
  where?: InputMaybe<AnalyticsIngestionStatsBoolExp>;
};


export type SubscriptionAnalyticsReportsArgs = {
  distinct_on?: InputMaybe<Array<AnalyticsReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalyticsReportsOrderBy>>;
  where?: InputMaybe<AnalyticsReportsBoolExp>;
};


export type SubscriptionAnalyticsReportsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAnalyticsReportsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalyticsReportsStreamCursorInput>>;
  where?: InputMaybe<AnalyticsReportsBoolExp>;
};


export type SubscriptionApiKeysArgs = {
  distinct_on?: InputMaybe<Array<ApiKeysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApiKeysOrderBy>>;
  where?: InputMaybe<ApiKeysBoolExp>;
};


export type SubscriptionApiKeysByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionApiKeysStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApiKeysStreamCursorInput>>;
  where?: InputMaybe<ApiKeysBoolExp>;
};


export type SubscriptionArtifactFavoritesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


export type SubscriptionArtifactFavoritesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactFavoritesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactFavoritesOrderBy>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


export type SubscriptionArtifactFavoritesByPkArgs = {
  campaign_artifact_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
};


export type SubscriptionArtifactFavoritesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ArtifactFavoritesStreamCursorInput>>;
  where?: InputMaybe<ArtifactFavoritesBoolExp>;
};


export type SubscriptionArtifactReviewCommentsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


export type SubscriptionArtifactReviewCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewCommentsOrderBy>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


export type SubscriptionArtifactReviewCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionArtifactReviewCommentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ArtifactReviewCommentsStreamCursorInput>>;
  where?: InputMaybe<ArtifactReviewCommentsBoolExp>;
};


export type SubscriptionArtifactReviewStatusesArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


export type SubscriptionArtifactReviewStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewStatusesOrderBy>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


export type SubscriptionArtifactReviewStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionArtifactReviewStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ArtifactReviewStatusesStreamCursorInput>>;
  where?: InputMaybe<ArtifactReviewStatusesBoolExp>;
};


export type SubscriptionArtifactReviewersArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewersOrderBy>>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};


export type SubscriptionArtifactReviewersAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewersOrderBy>>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};


export type SubscriptionArtifactReviewersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionArtifactReviewersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ArtifactReviewersStreamCursorInput>>;
  where?: InputMaybe<ArtifactReviewersBoolExp>;
};


export type SubscriptionArtifactReviewsArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


export type SubscriptionArtifactReviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ArtifactReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ArtifactReviewsOrderBy>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


export type SubscriptionArtifactReviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionArtifactReviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ArtifactReviewsStreamCursorInput>>;
  where?: InputMaybe<ArtifactReviewsBoolExp>;
};


export type SubscriptionAssetCommentMentionsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


export type SubscriptionAssetCommentMentionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentMentionsOrderBy>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


export type SubscriptionAssetCommentMentionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetCommentMentionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentMentionsStreamCursorInput>>;
  where?: InputMaybe<AssetCommentMentionsBoolExp>;
};


export type SubscriptionAssetCommentStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


export type SubscriptionAssetCommentStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


export type SubscriptionAssetCommentStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetCommentStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentStatusesStreamCursorInput>>;
  where?: InputMaybe<AssetCommentStatusesBoolExp>;
};


export type SubscriptionAssetCommentThreadReadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadReadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadReadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadReadsBoolExp>;
};


export type SubscriptionAssetCommentThreadReadsByPkArgs = {
  asset_comment_thread_id: Scalars['uuid'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionAssetCommentThreadReadsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentThreadReadsStreamCursorInput>>;
  where?: InputMaybe<AssetCommentThreadReadsBoolExp>;
};


export type SubscriptionAssetCommentThreadStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


export type SubscriptionAssetCommentThreadStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadStatusesOrderBy>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


export type SubscriptionAssetCommentThreadStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetCommentThreadStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentThreadStatusesStreamCursorInput>>;
  where?: InputMaybe<AssetCommentThreadStatusesBoolExp>;
};


export type SubscriptionAssetCommentThreadsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


export type SubscriptionAssetCommentThreadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentThreadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentThreadsOrderBy>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


export type SubscriptionAssetCommentThreadsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetCommentThreadsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentThreadsStreamCursorInput>>;
  where?: InputMaybe<AssetCommentThreadsBoolExp>;
};


export type SubscriptionAssetCommentsArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


export type SubscriptionAssetCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetCommentsOrderBy>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


export type SubscriptionAssetCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetCommentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetCommentsStreamCursorInput>>;
  where?: InputMaybe<AssetCommentsBoolExp>;
};


export type SubscriptionAssetModelsArgs = {
  distinct_on?: InputMaybe<Array<AssetModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetModelsOrderBy>>;
  where?: InputMaybe<AssetModelsBoolExp>;
};


export type SubscriptionAssetModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionAssetModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetModelsStreamCursorInput>>;
  where?: InputMaybe<AssetModelsBoolExp>;
};


export type SubscriptionAssetStatusesArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


export type SubscriptionAssetStatusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetStatusesOrderBy>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


export type SubscriptionAssetStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAssetStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetStatusesStreamCursorInput>>;
  where?: InputMaybe<AssetStatusesBoolExp>;
};


export type SubscriptionAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


export type SubscriptionAttributionMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsOrderBy>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


export type SubscriptionAttributionMethodsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAttributionMethodsInteractionsArgs = {
  distinct_on?: InputMaybe<Array<AttributionMethodsInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AttributionMethodsInteractionsOrderBy>>;
  where?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
};


export type SubscriptionAttributionMethodsInteractionsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  interaction_model_id: Scalars['bigint'];
};


export type SubscriptionAttributionMethodsInteractionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AttributionMethodsInteractionsStreamCursorInput>>;
  where?: InputMaybe<AttributionMethodsInteractionsBoolExp>;
};


export type SubscriptionAttributionMethodsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AttributionMethodsStreamCursorInput>>;
  where?: InputMaybe<AttributionMethodsBoolExp>;
};


export type SubscriptionAudienceGoalsArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


export type SubscriptionAudienceGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceGoalsOrderBy>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


export type SubscriptionAudienceGoalsByPkArgs = {
  goal_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};


export type SubscriptionAudienceGoalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceGoalsStreamCursorInput>>;
  where?: InputMaybe<AudienceGoalsBoolExp>;
};


export type SubscriptionAudienceOverviewsArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


export type SubscriptionAudienceOverviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceOverviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceOverviewsOrderBy>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


export type SubscriptionAudienceOverviewsByPkArgs = {
  audience_id: Scalars['bigint'];
};


export type SubscriptionAudienceOverviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceOverviewsStreamCursorInput>>;
  where?: InputMaybe<AudienceOverviewsBoolExp>;
};


export type SubscriptionAudiencePrimaryMetricsArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


export type SubscriptionAudiencePrimaryMetricsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencePrimaryMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencePrimaryMetricsOrderBy>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


export type SubscriptionAudiencePrimaryMetricsByPkArgs = {
  audience_id: Scalars['bigint'];
  metric_id: Scalars['uuid'];
};


export type SubscriptionAudiencePrimaryMetricsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudiencePrimaryMetricsStreamCursorInput>>;
  where?: InputMaybe<AudiencePrimaryMetricsBoolExp>;
};


export type SubscriptionAudienceSplitsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


export type SubscriptionAudienceSplitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSplitsOrderBy>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


export type SubscriptionAudienceSplitsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAudienceSplitsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceSplitsStreamCursorInput>>;
  where?: InputMaybe<AudienceSplitsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupRequiredModelsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupRequiredModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupRequiredModelsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupRequiredModelsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_group_id: Scalars['uuid'];
};


export type SubscriptionAudienceSubsetGroupRequiredModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceSubsetGroupRequiredModelsStreamCursorInput>>;
  where?: InputMaybe<AudienceSubsetGroupRequiredModelsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetGroupsOrderBy>>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};


export type SubscriptionAudienceSubsetGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAudienceSubsetGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceSubsetGroupsStreamCursorInput>>;
  where?: InputMaybe<AudienceSubsetGroupsBoolExp>;
};


export type SubscriptionAudienceSubsetValueScopedConditionsArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValueScopedConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValueScopedConditionsOrderBy>>;
  where?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
};


export type SubscriptionAudienceSubsetValueScopedConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValueScopedConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValueScopedConditionsOrderBy>>;
  where?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
};


export type SubscriptionAudienceSubsetValueScopedConditionsByPkArgs = {
  ordinal: Scalars['smallint'];
  subset_value_id: Scalars['uuid'];
};


export type SubscriptionAudienceSubsetValueScopedConditionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceSubsetValueScopedConditionsStreamCursorInput>>;
  where?: InputMaybe<AudienceSubsetValueScopedConditionsBoolExp>;
};


export type SubscriptionAudienceSubsetValuesArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


export type SubscriptionAudienceSubsetValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceSubsetValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceSubsetValuesOrderBy>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


export type SubscriptionAudienceSubsetValuesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAudienceSubsetValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceSubsetValuesStreamCursorInput>>;
  where?: InputMaybe<AudienceSubsetValuesBoolExp>;
};


export type SubscriptionAudienceTemplatesArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


export type SubscriptionAudienceTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudienceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudienceTemplatesOrderBy>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


export type SubscriptionAudienceTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionAudienceTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudienceTemplatesStreamCursorInput>>;
  where?: InputMaybe<AudienceTemplatesBoolExp>;
};


export type SubscriptionAudiencesSubsetsArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


export type SubscriptionAudiencesSubsetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AudiencesSubsetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AudiencesSubsetsOrderBy>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


export type SubscriptionAudiencesSubsetsByPkArgs = {
  segment_id: Scalars['bigint'];
  subset_value_id: Scalars['uuid'];
};


export type SubscriptionAudiencesSubsetsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AudiencesSubsetsStreamCursorInput>>;
  where?: InputMaybe<AudiencesSubsetsBoolExp>;
};


export type SubscriptionAuth0ConnectionsArgs = {
  distinct_on?: InputMaybe<Array<Auth0ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth0ConnectionsOrderBy>>;
  where?: InputMaybe<Auth0ConnectionsBoolExp>;
};


export type SubscriptionAuth0ConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionAuth0ConnectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth0ConnectionsStreamCursorInput>>;
  where?: InputMaybe<Auth0ConnectionsBoolExp>;
};


export type SubscriptionBillingByDestinationArgs = {
  distinct_on?: InputMaybe<Array<BillingByDestinationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BillingByDestinationOrderBy>>;
  where?: InputMaybe<BillingByDestinationBoolExp>;
};


export type SubscriptionBillingByDestinationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BillingByDestinationStreamCursorInput>>;
  where?: InputMaybe<BillingByDestinationBoolExp>;
};


export type SubscriptionBillingProductsArgs = {
  distinct_on?: InputMaybe<Array<BillingProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BillingProductsOrderBy>>;
  where?: InputMaybe<BillingProductsBoolExp>;
};


export type SubscriptionBillingProductsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionBillingProductsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BillingProductsStreamCursorInput>>;
  where?: InputMaybe<BillingProductsBoolExp>;
};


export type SubscriptionBrandProfileAssetGroupsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


export type SubscriptionBrandProfileAssetGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileAssetGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileAssetGroupsOrderBy>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


export type SubscriptionBrandProfileAssetGroupsByPkArgs = {
  asset_group_id: Scalars['uuid'];
  brand_profile_id: Scalars['uuid'];
};


export type SubscriptionBrandProfileAssetGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BrandProfileAssetGroupsStreamCursorInput>>;
  where?: InputMaybe<BrandProfileAssetGroupsBoolExp>;
};


export type SubscriptionBrandProfileContentEmailsArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


export type SubscriptionBrandProfileContentEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileContentEmailsOrderBy>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


export type SubscriptionBrandProfileContentEmailsByPkArgs = {
  brand_profile_id: Scalars['uuid'];
  content_email_id: Scalars['uuid'];
};


export type SubscriptionBrandProfileContentEmailsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BrandProfileContentEmailsStreamCursorInput>>;
  where?: InputMaybe<BrandProfileContentEmailsBoolExp>;
};


export type SubscriptionBrandProfileSettingsEntitiesArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


export type SubscriptionBrandProfileSettingsEntitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfileSettingsEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfileSettingsEntitiesOrderBy>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


export type SubscriptionBrandProfileSettingsEntitiesByPkArgs = {
  brand_profile_id: Scalars['uuid'];
  settings_entity_id: Scalars['uuid'];
};


export type SubscriptionBrandProfileSettingsEntitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BrandProfileSettingsEntitiesStreamCursorInput>>;
  where?: InputMaybe<BrandProfileSettingsEntitiesBoolExp>;
};


export type SubscriptionBrandProfilesArgs = {
  distinct_on?: InputMaybe<Array<BrandProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfilesOrderBy>>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};


export type SubscriptionBrandProfilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<BrandProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BrandProfilesOrderBy>>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};


export type SubscriptionBrandProfilesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionBrandProfilesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BrandProfilesStreamCursorInput>>;
  where?: InputMaybe<BrandProfilesBoolExp>;
};


export type SubscriptionCachedEventPullsArgs = {
  distinct_on?: InputMaybe<Array<CachedEventPullsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CachedEventPullsOrderBy>>;
  where?: InputMaybe<CachedEventPullsBoolExp>;
};


export type SubscriptionCachedEventPullsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCachedEventPullsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CachedEventPullsStreamCursorInput>>;
  where?: InputMaybe<CachedEventPullsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionBestPracticeRunsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionBestPracticeRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionBestPracticeRunsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionBestPracticeRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignArtifactVersionBestPracticeRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignArtifactVersionBestPracticeRunsStreamCursorInput>>;
  where?: InputMaybe<CampaignArtifactVersionBestPracticeRunsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactVersionsOrderBy>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


export type SubscriptionCampaignArtifactVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignArtifactVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignArtifactVersionsStreamCursorInput>>;
  where?: InputMaybe<CampaignArtifactVersionsBoolExp>;
};


export type SubscriptionCampaignArtifactsArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


export type SubscriptionCampaignArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignArtifactsOrderBy>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


export type SubscriptionCampaignArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignArtifactsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignArtifactsStreamCursorInput>>;
  where?: InputMaybe<CampaignArtifactsBoolExp>;
};


export type SubscriptionCampaignDraftsArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


export type SubscriptionCampaignDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignDraftsOrderBy>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


export type SubscriptionCampaignDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignDraftsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignDraftsStreamCursorInput>>;
  where?: InputMaybe<CampaignDraftsBoolExp>;
};


export type SubscriptionCampaignLabelsArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


export type SubscriptionCampaignLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignLabelsOrderBy>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


export type SubscriptionCampaignLabelsByPkArgs = {
  campaign_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type SubscriptionCampaignLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignLabelsStreamCursorInput>>;
  where?: InputMaybe<CampaignLabelsBoolExp>;
};


export type SubscriptionCampaignListEntriesArgs = {
  distinct_on?: InputMaybe<Array<CampaignListEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignListEntriesOrderBy>>;
  where?: InputMaybe<CampaignListEntriesBoolExp>;
};


export type SubscriptionCampaignListEntriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignListEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignListEntriesOrderBy>>;
  where?: InputMaybe<CampaignListEntriesBoolExp>;
};


export type SubscriptionCampaignListEntriesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignListEntriesStreamCursorInput>>;
  where?: InputMaybe<CampaignListEntriesBoolExp>;
};


export type SubscriptionCampaignRunsArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


export type SubscriptionCampaignRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignRunsOrderBy>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


export type SubscriptionCampaignRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignRunsStreamCursorInput>>;
  where?: InputMaybe<CampaignRunsBoolExp>;
};


export type SubscriptionCampaignsArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


export type SubscriptionCampaignsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CampaignsOrderBy>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


export type SubscriptionCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCampaignsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CampaignsStreamCursorInput>>;
  where?: InputMaybe<CampaignsBoolExp>;
};


export type SubscriptionCatalogCollectionsArgs = {
  distinct_on?: InputMaybe<Array<CatalogCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CatalogCollectionsOrderBy>>;
  where?: InputMaybe<CatalogCollectionsBoolExp>;
};


export type SubscriptionCatalogCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCatalogCollectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CatalogCollectionsStreamCursorInput>>;
  where?: InputMaybe<CatalogCollectionsBoolExp>;
};


export type SubscriptionCatalogModelsArgs = {
  distinct_on?: InputMaybe<Array<CatalogModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CatalogModelsOrderBy>>;
  where?: InputMaybe<CatalogModelsBoolExp>;
};


export type SubscriptionCatalogModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionCatalogModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CatalogModelsStreamCursorInput>>;
  where?: InputMaybe<CatalogModelsBoolExp>;
};


export type SubscriptionCepBrandSettingsArgs = {
  distinct_on?: InputMaybe<Array<CepBrandSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepBrandSettingsOrderBy>>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};


export type SubscriptionCepBrandSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepBrandSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepBrandSettingsOrderBy>>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};


export type SubscriptionCepBrandSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepBrandSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepBrandSettingsStreamCursorInput>>;
  where?: InputMaybe<CepBrandSettingsBoolExp>;
};


export type SubscriptionCepChannelsArgs = {
  distinct_on?: InputMaybe<Array<CepChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepChannelsOrderBy>>;
  where?: InputMaybe<CepChannelsBoolExp>;
};


export type SubscriptionCepChannelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepChannelsOrderBy>>;
  where?: InputMaybe<CepChannelsBoolExp>;
};


export type SubscriptionCepChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepChannelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepChannelsStreamCursorInput>>;
  where?: InputMaybe<CepChannelsBoolExp>;
};


export type SubscriptionCepContentBlockMessageUsagesArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


export type SubscriptionCepContentBlockMessageUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlockMessageUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlockMessageUsagesOrderBy>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


export type SubscriptionCepContentBlockMessageUsagesByPkArgs = {
  content_block_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
};


export type SubscriptionCepContentBlockMessageUsagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepContentBlockMessageUsagesStreamCursorInput>>;
  where?: InputMaybe<CepContentBlockMessageUsagesBoolExp>;
};


export type SubscriptionCepContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlocksOrderBy>>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};


export type SubscriptionCepContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepContentBlocksOrderBy>>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};


export type SubscriptionCepContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepContentBlocksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepContentBlocksStreamCursorInput>>;
  where?: InputMaybe<CepContentBlocksBoolExp>;
};


export type SubscriptionCepDevicePreviewsArgs = {
  distinct_on?: InputMaybe<Array<CepDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepDevicePreviewsBoolExp>;
};


export type SubscriptionCepDevicePreviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepDevicePreviewsBoolExp>;
};


export type SubscriptionCepDevicePreviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepDevicePreviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepDevicePreviewsStreamCursorInput>>;
  where?: InputMaybe<CepDevicePreviewsBoolExp>;
};


export type SubscriptionCepDomainsArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


export type SubscriptionCepDomainsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepDomainsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepDomainsOrderBy>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


export type SubscriptionCepDomainsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepDomainsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepDomainsStreamCursorInput>>;
  where?: InputMaybe<CepDomainsBoolExp>;
};


export type SubscriptionCepEmailTemplateContentsArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


export type SubscriptionCepEmailTemplateContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplateContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplateContentsOrderBy>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


export type SubscriptionCepEmailTemplateContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepEmailTemplateContentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepEmailTemplateContentsStreamCursorInput>>;
  where?: InputMaybe<CepEmailTemplateContentsBoolExp>;
};


export type SubscriptionCepEmailTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplatesOrderBy>>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};


export type SubscriptionCepEmailTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepEmailTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepEmailTemplatesOrderBy>>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};


export type SubscriptionCepEmailTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepEmailTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepEmailTemplatesStreamCursorInput>>;
  where?: InputMaybe<CepEmailTemplatesBoolExp>;
};


export type SubscriptionCepInappMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


export type SubscriptionCepInappMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageContentsOrderBy>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


export type SubscriptionCepInappMessageContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepInappMessageContentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepInappMessageContentsStreamCursorInput>>;
  where?: InputMaybe<CepInappMessageContentsBoolExp>;
};


export type SubscriptionCepInappMessageTemplatePushAppsArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatePushAppsOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
};


export type SubscriptionCepInappMessageTemplatePushAppsByPkArgs = {
  push_app_id: Scalars['uuid'];
  template_id: Scalars['uuid'];
};


export type SubscriptionCepInappMessageTemplatePushAppsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepInappMessageTemplatePushAppsStreamCursorInput>>;
  where?: InputMaybe<CepInappMessageTemplatePushAppsBoolExp>;
};


export type SubscriptionCepInappMessageTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatesOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatesBoolExp>;
};


export type SubscriptionCepInappMessageTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepInappMessageTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepInappMessageTemplatesOrderBy>>;
  where?: InputMaybe<CepInappMessageTemplatesBoolExp>;
};


export type SubscriptionCepInappMessageTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepInappMessageTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepInappMessageTemplatesStreamCursorInput>>;
  where?: InputMaybe<CepInappMessageTemplatesBoolExp>;
};


export type SubscriptionCepLocalesArgs = {
  distinct_on?: InputMaybe<Array<CepLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalesOrderBy>>;
  where?: InputMaybe<CepLocalesBoolExp>;
};


export type SubscriptionCepLocalesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalesOrderBy>>;
  where?: InputMaybe<CepLocalesBoolExp>;
};


export type SubscriptionCepLocalesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepLocalesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepLocalesStreamCursorInput>>;
  where?: InputMaybe<CepLocalesBoolExp>;
};


export type SubscriptionCepLocalizationSettingsArgs = {
  distinct_on?: InputMaybe<Array<CepLocalizationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalizationSettingsOrderBy>>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};


export type SubscriptionCepLocalizationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepLocalizationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepLocalizationSettingsOrderBy>>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};


export type SubscriptionCepLocalizationSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepLocalizationSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepLocalizationSettingsStreamCursorInput>>;
  where?: InputMaybe<CepLocalizationSettingsBoolExp>;
};


export type SubscriptionCepManagedModelsArgs = {
  distinct_on?: InputMaybe<Array<CepManagedModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepManagedModelsOrderBy>>;
  where?: InputMaybe<CepManagedModelsBoolExp>;
};


export type SubscriptionCepManagedModelsByPkArgs = {
  segment_id: Scalars['bigint'];
};


export type SubscriptionCepManagedModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepManagedModelsStreamCursorInput>>;
  where?: InputMaybe<CepManagedModelsBoolExp>;
};


export type SubscriptionCepMessageDevicePreviewsArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


export type SubscriptionCepMessageDevicePreviewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepMessageDevicePreviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepMessageDevicePreviewsOrderBy>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


export type SubscriptionCepMessageDevicePreviewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepMessageDevicePreviewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepMessageDevicePreviewsStreamCursorInput>>;
  where?: InputMaybe<CepMessageDevicePreviewsBoolExp>;
};


export type SubscriptionCepProvidersArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


export type SubscriptionCepProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepProvidersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepProvidersOrderBy>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


export type SubscriptionCepProvidersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepProvidersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepProvidersStreamCursorInput>>;
  where?: InputMaybe<CepProvidersBoolExp>;
};


export type SubscriptionCepSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepSenderIdentitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSenderIdentitiesStreamCursorInput>>;
  where?: InputMaybe<CepSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSenderIdentitySendersArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitySendersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitySendersOrderBy>>;
  where?: InputMaybe<CepSenderIdentitySendersBoolExp>;
};


export type SubscriptionCepSenderIdentitySendersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSenderIdentitySendersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSenderIdentitySendersOrderBy>>;
  where?: InputMaybe<CepSenderIdentitySendersBoolExp>;
};


export type SubscriptionCepSenderIdentitySendersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepSenderIdentitySendersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSenderIdentitySendersStreamCursorInput>>;
  where?: InputMaybe<CepSenderIdentitySendersBoolExp>;
};


export type SubscriptionCepSubscriptionTopicSenderIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSubscriptionTopicSenderIdentitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicSenderIdentitiesOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSubscriptionTopicSenderIdentitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepSubscriptionTopicSenderIdentitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSubscriptionTopicSenderIdentitiesStreamCursorInput>>;
  where?: InputMaybe<CepSubscriptionTopicSenderIdentitiesBoolExp>;
};


export type SubscriptionCepSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSubscriptionTopicsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepSubscriptionTopicsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSubscriptionTopicsStreamCursorInput>>;
  where?: InputMaybe<CepSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSuppressionListSubscriptionTopicsArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSuppressionListSubscriptionTopicsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListSubscriptionTopicsOrderBy>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSuppressionListSubscriptionTopicsByPkArgs = {
  cep_subscription_topic_id: Scalars['uuid'];
  suppression_list_id: Scalars['uuid'];
};


export type SubscriptionCepSuppressionListSubscriptionTopicsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSuppressionListSubscriptionTopicsStreamCursorInput>>;
  where?: InputMaybe<CepSuppressionListSubscriptionTopicsBoolExp>;
};


export type SubscriptionCepSuppressionListsArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListsOrderBy>>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};


export type SubscriptionCepSuppressionListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepSuppressionListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepSuppressionListsOrderBy>>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};


export type SubscriptionCepSuppressionListsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepSuppressionListsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepSuppressionListsStreamCursorInput>>;
  where?: InputMaybe<CepSuppressionListsBoolExp>;
};


export type SubscriptionCepTestGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


export type SubscriptionCepTestGroupMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupMembersOrderBy>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


export type SubscriptionCepTestGroupMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepTestGroupMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepTestGroupMembersStreamCursorInput>>;
  where?: InputMaybe<CepTestGroupMembersBoolExp>;
};


export type SubscriptionCepTestGroupsArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupsOrderBy>>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};


export type SubscriptionCepTestGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepTestGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTestGroupsOrderBy>>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};


export type SubscriptionCepTestGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepTestGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepTestGroupsStreamCursorInput>>;
  where?: InputMaybe<CepTestGroupsBoolExp>;
};


export type SubscriptionCepTranslationsArgs = {
  distinct_on?: InputMaybe<Array<CepTranslationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepTranslationsOrderBy>>;
  where?: InputMaybe<CepTranslationsBoolExp>;
};


export type SubscriptionCepTranslationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepTranslationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepTranslationsStreamCursorInput>>;
  where?: InputMaybe<CepTranslationsBoolExp>;
};


export type SubscriptionCepWhatsappTemplateLocalesArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


export type SubscriptionCepWhatsappTemplateLocalesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplateLocalesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplateLocalesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


export type SubscriptionCepWhatsappTemplateLocalesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepWhatsappTemplateLocalesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepWhatsappTemplateLocalesStreamCursorInput>>;
  where?: InputMaybe<CepWhatsappTemplateLocalesBoolExp>;
};


export type SubscriptionCepWhatsappTemplatesArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplatesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplatesBoolExp>;
};


export type SubscriptionCepWhatsappTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWhatsappTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWhatsappTemplatesOrderBy>>;
  where?: InputMaybe<CepWhatsappTemplatesBoolExp>;
};


export type SubscriptionCepWhatsappTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepWhatsappTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepWhatsappTemplatesStreamCursorInput>>;
  where?: InputMaybe<CepWhatsappTemplatesBoolExp>;
};


export type SubscriptionCepWorkspaceConfigArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceConfigOrderBy>>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};


export type SubscriptionCepWorkspaceConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceConfigOrderBy>>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};


export type SubscriptionCepWorkspaceConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepWorkspaceConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepWorkspaceConfigStreamCursorInput>>;
  where?: InputMaybe<CepWorkspaceConfigBoolExp>;
};


export type SubscriptionCepWorkspaceParentModelsArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


export type SubscriptionCepWorkspaceParentModelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CepWorkspaceParentModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CepWorkspaceParentModelsOrderBy>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


export type SubscriptionCepWorkspaceParentModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCepWorkspaceParentModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CepWorkspaceParentModelsStreamCursorInput>>;
  where?: InputMaybe<CepWorkspaceParentModelsBoolExp>;
};


export type SubscriptionChartCardsArgs = {
  distinct_on?: InputMaybe<Array<ChartCardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChartCardsOrderBy>>;
  where?: InputMaybe<ChartCardsBoolExp>;
};


export type SubscriptionChartCardsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionChartCardsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ChartCardsStreamCursorInput>>;
  where?: InputMaybe<ChartCardsBoolExp>;
};


export type SubscriptionCloudCredentialsArgs = {
  distinct_on?: InputMaybe<Array<CloudCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CloudCredentialsOrderBy>>;
  where?: InputMaybe<CloudCredentialsBoolExp>;
};


export type SubscriptionCloudCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionCloudCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CloudCredentialsStreamCursorInput>>;
  where?: InputMaybe<CloudCredentialsBoolExp>;
};


export type SubscriptionCompetitorAccountsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


export type SubscriptionCompetitorAccountsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAccountsOrderBy>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


export type SubscriptionCompetitorAccountsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCompetitorAccountsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitorAccountsStreamCursorInput>>;
  where?: InputMaybe<CompetitorAccountsBoolExp>;
};


export type SubscriptionCompetitorAdScrapesArgs = {
  distinct_on?: InputMaybe<Array<CompetitorAdScrapesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorAdScrapesOrderBy>>;
  where?: InputMaybe<CompetitorAdScrapesBoolExp>;
};


export type SubscriptionCompetitorAdScrapesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCompetitorAdScrapesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitorAdScrapesStreamCursorInput>>;
  where?: InputMaybe<CompetitorAdScrapesBoolExp>;
};


export type SubscriptionCompetitorsArgs = {
  distinct_on?: InputMaybe<Array<CompetitorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorsOrderBy>>;
  where?: InputMaybe<CompetitorsBoolExp>;
};


export type SubscriptionCompetitorsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CompetitorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompetitorsOrderBy>>;
  where?: InputMaybe<CompetitorsBoolExp>;
};


export type SubscriptionCompetitorsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCompetitorsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompetitorsStreamCursorInput>>;
  where?: InputMaybe<CompetitorsBoolExp>;
};


export type SubscriptionConditionTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


export type SubscriptionConditionTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConditionTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConditionTemplateLabelsOrderBy>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


export type SubscriptionConditionTemplateLabelsByPkArgs = {
  condition_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type SubscriptionConditionTemplateLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConditionTemplateLabelsStreamCursorInput>>;
  where?: InputMaybe<ConditionTemplateLabelsBoolExp>;
};


export type SubscriptionConnectionsArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


export type SubscriptionConnectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


export type SubscriptionConnectionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionConnectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ConnectionsStreamCursorInput>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


export type SubscriptionContentBlockLabelsArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


export type SubscriptionContentBlockLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlockLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlockLabelsOrderBy>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


export type SubscriptionContentBlockLabelsByPkArgs = {
  content_block_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type SubscriptionContentBlockLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentBlockLabelsStreamCursorInput>>;
  where?: InputMaybe<ContentBlockLabelsBoolExp>;
};


export type SubscriptionContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<ContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlocksOrderBy>>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};


export type SubscriptionContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentBlocksOrderBy>>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};


export type SubscriptionContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentBlocksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentBlocksStreamCursorInput>>;
  where?: InputMaybe<ContentBlocksBoolExp>;
};


export type SubscriptionContentDeploymentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDeploymentsOrderBy>>;
  where?: InputMaybe<ContentDeploymentsBoolExp>;
};


export type SubscriptionContentDeploymentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDeploymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDeploymentsOrderBy>>;
  where?: InputMaybe<ContentDeploymentsBoolExp>;
};


export type SubscriptionContentDeploymentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDeploymentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDeploymentsStreamCursorInput>>;
  where?: InputMaybe<ContentDeploymentsBoolExp>;
};


export type SubscriptionContentDynamicSlotAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


export type SubscriptionContentDynamicSlotAssignmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotAssignmentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


export type SubscriptionContentDynamicSlotAssignmentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDynamicSlotAssignmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDynamicSlotAssignmentsStreamCursorInput>>;
  where?: InputMaybe<ContentDynamicSlotAssignmentsBoolExp>;
};


export type SubscriptionContentDynamicSlotBranchesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


export type SubscriptionContentDynamicSlotBranchesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotBranchesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotBranchesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


export type SubscriptionContentDynamicSlotBranchesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDynamicSlotBranchesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDynamicSlotBranchesStreamCursorInput>>;
  where?: InputMaybe<ContentDynamicSlotBranchesBoolExp>;
};


export type SubscriptionContentDynamicSlotContentsArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


export type SubscriptionContentDynamicSlotContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotContentsOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


export type SubscriptionContentDynamicSlotContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDynamicSlotContentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDynamicSlotContentsStreamCursorInput>>;
  where?: InputMaybe<ContentDynamicSlotContentsBoolExp>;
};


export type SubscriptionContentDynamicSlotLibrariesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotLibrariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotLibrariesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};


export type SubscriptionContentDynamicSlotLibrariesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotLibrariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotLibrariesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};


export type SubscriptionContentDynamicSlotLibrariesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDynamicSlotLibrariesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDynamicSlotLibrariesStreamCursorInput>>;
  where?: InputMaybe<ContentDynamicSlotLibrariesBoolExp>;
};


export type SubscriptionContentDynamicSlotUsagesArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


export type SubscriptionContentDynamicSlotUsagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentDynamicSlotUsagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentDynamicSlotUsagesOrderBy>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


export type SubscriptionContentDynamicSlotUsagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentDynamicSlotUsagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentDynamicSlotUsagesStreamCursorInput>>;
  where?: InputMaybe<ContentDynamicSlotUsagesBoolExp>;
};


export type SubscriptionContentEmailMessageLinksArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


export type SubscriptionContentEmailMessageLinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailMessageLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailMessageLinksOrderBy>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


export type SubscriptionContentEmailMessageLinksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentEmailMessageLinksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentEmailMessageLinksStreamCursorInput>>;
  where?: InputMaybe<ContentEmailMessageLinksBoolExp>;
};


export type SubscriptionContentEmailVariantsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


export type SubscriptionContentEmailVariantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVariantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVariantsOrderBy>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


export type SubscriptionContentEmailVariantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentEmailVariantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentEmailVariantsStreamCursorInput>>;
  where?: InputMaybe<ContentEmailVariantsBoolExp>;
};


export type SubscriptionContentEmailVersionsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


export type SubscriptionContentEmailVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailVersionsOrderBy>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


export type SubscriptionContentEmailVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentEmailVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentEmailVersionsStreamCursorInput>>;
  where?: InputMaybe<ContentEmailVersionsBoolExp>;
};


export type SubscriptionContentEmailsArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


export type SubscriptionContentEmailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentEmailsOrderBy>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


export type SubscriptionContentEmailsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentEmailsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentEmailsStreamCursorInput>>;
  where?: InputMaybe<ContentEmailsBoolExp>;
};


export type SubscriptionContentSettingsArgs = {
  distinct_on?: InputMaybe<Array<ContentSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentSettingsOrderBy>>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};


export type SubscriptionContentSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentSettingsOrderBy>>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};


export type SubscriptionContentSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentSettingsStreamCursorInput>>;
  where?: InputMaybe<ContentSettingsBoolExp>;
};


export type SubscriptionContentTagsArgs = {
  distinct_on?: InputMaybe<Array<ContentTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTagsOrderBy>>;
  where?: InputMaybe<ContentTagsBoolExp>;
};


export type SubscriptionContentTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTagsOrderBy>>;
  where?: InputMaybe<ContentTagsBoolExp>;
};


export type SubscriptionContentTagsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentTagsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentTagsStreamCursorInput>>;
  where?: InputMaybe<ContentTagsBoolExp>;
};


export type SubscriptionContentTemplatesArgs = {
  distinct_on?: InputMaybe<Array<ContentTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTemplatesOrderBy>>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};


export type SubscriptionContentTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ContentTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ContentTemplatesOrderBy>>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};


export type SubscriptionContentTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionContentTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ContentTemplatesStreamCursorInput>>;
  where?: InputMaybe<ContentTemplatesBoolExp>;
};


export type SubscriptionCurrentReportScheduleVersionsArgs = {
  distinct_on?: InputMaybe<Array<CurrentReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrentReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<CurrentReportScheduleVersionsBoolExp>;
};


export type SubscriptionCurrentReportScheduleVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CurrentReportScheduleVersionsStreamCursorInput>>;
  where?: InputMaybe<CurrentReportScheduleVersionsBoolExp>;
};


export type SubscriptionCustomAgentsArgs = {
  distinct_on?: InputMaybe<Array<CustomAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CustomAgentsOrderBy>>;
  where?: InputMaybe<CustomAgentsBoolExp>;
};


export type SubscriptionCustomAgentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCustomAgentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CustomAgentsStreamCursorInput>>;
  where?: InputMaybe<CustomAgentsBoolExp>;
};


export type SubscriptionDashboardsArgs = {
  distinct_on?: InputMaybe<Array<DashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DashboardsOrderBy>>;
  where?: InputMaybe<DashboardsBoolExp>;
};


export type SubscriptionDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DashboardsOrderBy>>;
  where?: InputMaybe<DashboardsBoolExp>;
};


export type SubscriptionDashboardsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDashboardsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DashboardsStreamCursorInput>>;
  where?: InputMaybe<DashboardsBoolExp>;
};


export type SubscriptionDatadogCredentialsArgs = {
  distinct_on?: InputMaybe<Array<DatadogCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DatadogCredentialsOrderBy>>;
  where?: InputMaybe<DatadogCredentialsBoolExp>;
};


export type SubscriptionDatadogCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionDatadogCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DatadogCredentialsStreamCursorInput>>;
  where?: InputMaybe<DatadogCredentialsBoolExp>;
};


export type SubscriptionDbtCloudSyncConfigArgs = {
  distinct_on?: InputMaybe<Array<DbtCloudSyncConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCloudSyncConfigOrderBy>>;
  where?: InputMaybe<DbtCloudSyncConfigBoolExp>;
};


export type SubscriptionDbtCloudSyncConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDbtCloudSyncConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DbtCloudSyncConfigStreamCursorInput>>;
  where?: InputMaybe<DbtCloudSyncConfigBoolExp>;
};


export type SubscriptionDbtCloudWebhooksArgs = {
  distinct_on?: InputMaybe<Array<DbtCloudWebhooksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCloudWebhooksOrderBy>>;
  where?: InputMaybe<DbtCloudWebhooksBoolExp>;
};


export type SubscriptionDbtCloudWebhooksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDbtCloudWebhooksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DbtCloudWebhooksStreamCursorInput>>;
  where?: InputMaybe<DbtCloudWebhooksBoolExp>;
};


export type SubscriptionDbtCredentialsArgs = {
  distinct_on?: InputMaybe<Array<DbtCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtCredentialsOrderBy>>;
  where?: InputMaybe<DbtCredentialsBoolExp>;
};


export type SubscriptionDbtCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionDbtCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DbtCredentialsStreamCursorInput>>;
  where?: InputMaybe<DbtCredentialsBoolExp>;
};


export type SubscriptionDbtSyncConfigArgs = {
  distinct_on?: InputMaybe<Array<DbtSyncConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtSyncConfigOrderBy>>;
  where?: InputMaybe<DbtSyncConfigBoolExp>;
};


export type SubscriptionDbtSyncConfigByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDbtSyncConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DbtSyncConfigStreamCursorInput>>;
  where?: InputMaybe<DbtSyncConfigBoolExp>;
};


export type SubscriptionDbtSyncModelsArgs = {
  distinct_on?: InputMaybe<Array<DbtSyncModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DbtSyncModelsOrderBy>>;
  where?: InputMaybe<DbtSyncModelsBoolExp>;
};


export type SubscriptionDbtSyncModelsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDbtSyncModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DbtSyncModelsStreamCursorInput>>;
  where?: InputMaybe<DbtSyncModelsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupMembershipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupMembershipsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupMembershipsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupMembershipsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineArbitrationGroupMembershipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineArbitrationGroupMembershipsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupMembershipsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineArbitrationGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineArbitrationGroupsOrderBy>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
};


export type SubscriptionDecisionEngineArbitrationGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineArbitrationGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineArbitrationGroupsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineArbitrationGroupsBoolExp>;
};


export type SubscriptionDecisionEngineChannelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineChannelsOrderBy>>;
  where?: InputMaybe<DecisionEngineChannelsBoolExp>;
};


export type SubscriptionDecisionEngineChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineChannelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineChannelsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineChannelsBoolExp>;
};


export type SubscriptionDecisionEngineCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineCollectionsBoolExp>;
};


export type SubscriptionDecisionEngineCollectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineCollectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineCollectionsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineCollectionsBoolExp>;
};


export type SubscriptionDecisionEngineContentRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineContentRecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineContentRecommendationsOrderBy>>;
  where?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
};


export type SubscriptionDecisionEngineContentRecommendationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineContentRecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineContentRecommendationsOrderBy>>;
  where?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
};


export type SubscriptionDecisionEngineContentRecommendationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineContentRecommendationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineContentRecommendationsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineContentRecommendationsBoolExp>;
};


export type SubscriptionDecisionEngineFeatureMatricesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatricesOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
};


export type SubscriptionDecisionEngineFeatureMatricesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFeatureMatricesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFeatureMatricesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFeatureMatricesBoolExp>;
};


export type SubscriptionDecisionEngineFeatureMatrixRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFeatureMatrixRelationshipsOrderBy>>;
  where?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
};


export type SubscriptionDecisionEngineFeatureMatrixRelationshipsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFeatureMatrixRelationshipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFeatureMatrixRelationshipsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFeatureMatrixRelationshipsBoolExp>;
};


export type SubscriptionDecisionEngineFlowChannelSyncArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowChannelSyncSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowChannelSyncOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
};


export type SubscriptionDecisionEngineFlowChannelSyncByPkArgs = {
  channel_id: Scalars['uuid'];
  flow_id: Scalars['uuid'];
  segment_id: Scalars['bigint'];
};


export type SubscriptionDecisionEngineFlowChannelSyncStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowChannelSyncStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowChannelSyncBoolExp>;
};


export type SubscriptionDecisionEngineFlowChartsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowChartsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowChartsBoolExp>;
};


export type SubscriptionDecisionEngineFlowChartsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowChartsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowChartsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowChartsBoolExp>;
};


export type SubscriptionDecisionEngineFlowExperimentsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowExperimentsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
};


export type SubscriptionDecisionEngineFlowExperimentsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  name: Scalars['String'];
};


export type SubscriptionDecisionEngineFlowExperimentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowExperimentsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowExperimentsBoolExp>;
};


export type SubscriptionDecisionEngineFlowMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
};


export type SubscriptionDecisionEngineFlowMessagesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowMessagesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowMessagesBoolExp>;
};


export type SubscriptionDecisionEngineFlowOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineFlowOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowOutcomesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowOutcomesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineFlowOverridePeriodsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowOverridePeriodsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowOverridePeriodsBoolExp>;
};


export type SubscriptionDecisionEngineFlowOverridePeriodsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowOverridePeriodsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowOverridePeriodsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowOverridePeriodsBoolExp>;
};


export type SubscriptionDecisionEngineFlowRunsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


export type SubscriptionDecisionEngineFlowRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowRunsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


export type SubscriptionDecisionEngineFlowRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowRunsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowRunsBoolExp>;
};


export type SubscriptionDecisionEngineFlowTagsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowTagsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
};


export type SubscriptionDecisionEngineFlowTagsByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  tag_key: Scalars['String'];
  tag_value: Scalars['String'];
};


export type SubscriptionDecisionEngineFlowTagsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowTagsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowTagsBoolExp>;
};


export type SubscriptionDecisionEngineFlowVolumeRampsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowVolumeRampsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowVolumeRampsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowVolumeRampsBoolExp>;
};


export type SubscriptionDecisionEngineFlowVolumeRampsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowVolumeRampsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowVolumeRampsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowVolumeRampsBoolExp>;
};


export type SubscriptionDecisionEngineFlowsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<DecisionEngineFlowsBoolExp>;
};


export type SubscriptionDecisionEngineFlowsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineFlowsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineFlowsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineFlowsBoolExp>;
};


export type SubscriptionDecisionEngineInteractionManifestsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineInteractionManifestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineInteractionManifestsOrderBy>>;
  where?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
};


export type SubscriptionDecisionEngineInteractionManifestsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineInteractionManifestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineInteractionManifestsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineInteractionManifestsBoolExp>;
};


export type SubscriptionDecisionEngineMessageCollectionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageCollectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageCollectionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
};


export type SubscriptionDecisionEngineMessageCollectionsByPkArgs = {
  decision_engine_collection_id: Scalars['uuid'];
  decision_engine_message_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionDecisionEngineMessageCollectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineMessageCollectionsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineMessageCollectionsBoolExp>;
};


export type SubscriptionDecisionEngineMessageVariantSuggestionsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessageVariantSuggestionsOrderBy>>;
  where?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};


export type SubscriptionDecisionEngineMessageVariantSuggestionsByPkArgs = {
  decision_engine_message_id: Scalars['uuid'];
  suggested_value: Scalars['String'];
  variable_name: Scalars['String'];
};


export type SubscriptionDecisionEngineMessageVariantSuggestionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineMessageVariantSuggestionsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineMessageVariantSuggestionsBoolExp>;
};


export type SubscriptionDecisionEngineMessagesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


export type SubscriptionDecisionEngineMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineMessagesOrderBy>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


export type SubscriptionDecisionEngineMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineMessagesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineMessagesBoolExp>;
};


export type SubscriptionDecisionEngineModelOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineModelOutcomesByPkArgs = {
  decision_engine_flow_id: Scalars['uuid'];
  decision_engine_model_id: Scalars['uuid'];
  decision_engine_outcome_id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineModelOutcomesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineModelOutcomesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineModelOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineModelsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineModelsOrderBy>>;
  where?: InputMaybe<DecisionEngineModelsBoolExp>;
};


export type SubscriptionDecisionEngineModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineModelsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineModelsBoolExp>;
};


export type SubscriptionDecisionEngineOffersArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOffersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOffersOrderBy>>;
  where?: InputMaybe<DecisionEngineOffersBoolExp>;
};


export type SubscriptionDecisionEngineOffersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineOffersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineOffersStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineOffersBoolExp>;
};


export type SubscriptionDecisionEngineOutcomesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineOutcomesOrderBy>>;
  where?: InputMaybe<DecisionEngineOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineOutcomesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineOutcomesStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineOutcomesBoolExp>;
};


export type SubscriptionDecisionEngineSendEventsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSendEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSendEventsOrderBy>>;
  where?: InputMaybe<DecisionEngineSendEventsBoolExp>;
};


export type SubscriptionDecisionEngineSendEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineSendEventsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineSendEventsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineSendEventsBoolExp>;
};


export type SubscriptionDecisionEngineSplitsArgs = {
  distinct_on?: InputMaybe<Array<DecisionEngineSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEngineSplitsOrderBy>>;
  where?: InputMaybe<DecisionEngineSplitsBoolExp>;
};


export type SubscriptionDecisionEngineSplitsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEngineSplitsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEngineSplitsStreamCursorInput>>;
  where?: InputMaybe<DecisionEngineSplitsBoolExp>;
};


export type SubscriptionDecisionEnginesArgs = {
  distinct_on?: InputMaybe<Array<DecisionEnginesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DecisionEnginesOrderBy>>;
  where?: InputMaybe<DecisionEnginesBoolExp>;
};


export type SubscriptionDecisionEnginesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDecisionEnginesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DecisionEnginesStreamCursorInput>>;
  where?: InputMaybe<DecisionEnginesBoolExp>;
};


export type SubscriptionDeliverabilityFeedsArgs = {
  distinct_on?: InputMaybe<Array<DeliverabilityFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeliverabilityFeedsOrderBy>>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};


export type SubscriptionDeliverabilityFeedsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeliverabilityFeedsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeliverabilityFeedsOrderBy>>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};


export type SubscriptionDeliverabilityFeedsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDeliverabilityFeedsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DeliverabilityFeedsStreamCursorInput>>;
  where?: InputMaybe<DeliverabilityFeedsBoolExp>;
};


export type SubscriptionDeploymentHistoryArgs = {
  distinct_on?: InputMaybe<Array<DeploymentHistorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeploymentHistoryOrderBy>>;
  where?: InputMaybe<DeploymentHistoryBoolExp>;
};


export type SubscriptionDeploymentHistoryByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDeploymentHistoryStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DeploymentHistoryStreamCursorInput>>;
  where?: InputMaybe<DeploymentHistoryBoolExp>;
};


export type SubscriptionDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


export type SubscriptionDestinationInstanceSplitsByPkArgs = {
  destination_instance_id: Scalars['bigint'];
  split_id: Scalars['uuid'];
};


export type SubscriptionDestinationInstanceSplitsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DestinationInstanceSplitsStreamCursorInput>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


export type SubscriptionDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


export type SubscriptionDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


export type SubscriptionDestinationInstancesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDestinationInstancesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DestinationInstancesStreamCursorInput>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


export type SubscriptionDestinationRulesArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


export type SubscriptionDestinationRulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationRulesOrderBy>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


export type SubscriptionDestinationRulesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDestinationRulesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DestinationRulesStreamCursorInput>>;
  where?: InputMaybe<DestinationRulesBoolExp>;
};


export type SubscriptionDestinationsArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


export type SubscriptionDestinationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


export type SubscriptionDestinationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionDestinationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DestinationsStreamCursorInput>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


export type SubscriptionDirectModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<DirectModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DirectModelRelationshipsOrderBy>>;
  where?: InputMaybe<DirectModelRelationshipsBoolExp>;
};


export type SubscriptionDirectModelRelationshipsByPkArgs = {
  from_column: Scalars['String'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type SubscriptionDirectModelRelationshipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DirectModelRelationshipsStreamCursorInput>>;
  where?: InputMaybe<DirectModelRelationshipsBoolExp>;
};


export type SubscriptionDraftApprovalRequestsArgs = {
  distinct_on?: InputMaybe<Array<DraftApprovalRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftApprovalRequestsOrderBy>>;
  where?: InputMaybe<DraftApprovalRequestsBoolExp>;
};


export type SubscriptionDraftApprovalRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDraftApprovalRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DraftApprovalRequestsStreamCursorInput>>;
  where?: InputMaybe<DraftApprovalRequestsBoolExp>;
};


export type SubscriptionDraftsArgs = {
  distinct_on?: InputMaybe<Array<DraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftsOrderBy>>;
  where?: InputMaybe<DraftsBoolExp>;
};


export type SubscriptionDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DraftsOrderBy>>;
  where?: InputMaybe<DraftsBoolExp>;
};


export type SubscriptionDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDraftsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DraftsStreamCursorInput>>;
  where?: InputMaybe<DraftsBoolExp>;
};


export type SubscriptionEmailTemplateLabelsArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


export type SubscriptionEmailTemplateLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EmailTemplateLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EmailTemplateLabelsOrderBy>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


export type SubscriptionEmailTemplateLabelsByPkArgs = {
  email_template_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type SubscriptionEmailTemplateLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EmailTemplateLabelsStreamCursorInput>>;
  where?: InputMaybe<EmailTemplateLabelsBoolExp>;
};


export type SubscriptionEspCatalogStateArgs = {
  distinct_on?: InputMaybe<Array<EspCatalogStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspCatalogStateOrderBy>>;
  where?: InputMaybe<EspCatalogStateBoolExp>;
};


export type SubscriptionEspCatalogStateByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEspCatalogStateStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EspCatalogStateStreamCursorInput>>;
  where?: InputMaybe<EspCatalogStateBoolExp>;
};


export type SubscriptionEspContentBlocksArgs = {
  distinct_on?: InputMaybe<Array<EspContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspContentBlocksOrderBy>>;
  where?: InputMaybe<EspContentBlocksBoolExp>;
};


export type SubscriptionEspContentBlocksAggregateArgs = {
  distinct_on?: InputMaybe<Array<EspContentBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspContentBlocksOrderBy>>;
  where?: InputMaybe<EspContentBlocksBoolExp>;
};


export type SubscriptionEspContentBlocksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEspContentBlocksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EspContentBlocksStreamCursorInput>>;
  where?: InputMaybe<EspContentBlocksBoolExp>;
};


export type SubscriptionEspUserFieldsArgs = {
  distinct_on?: InputMaybe<Array<EspUserFieldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspUserFieldsOrderBy>>;
  where?: InputMaybe<EspUserFieldsBoolExp>;
};


export type SubscriptionEspUserFieldsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EspUserFieldsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EspUserFieldsOrderBy>>;
  where?: InputMaybe<EspUserFieldsBoolExp>;
};


export type SubscriptionEspUserFieldsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEspUserFieldsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EspUserFieldsStreamCursorInput>>;
  where?: InputMaybe<EspUserFieldsBoolExp>;
};


export type SubscriptionEtlConnectionsArgs = {
  distinct_on?: InputMaybe<Array<EtlConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlConnectionsOrderBy>>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};


export type SubscriptionEtlConnectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EtlConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlConnectionsOrderBy>>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};


export type SubscriptionEtlConnectionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEtlConnectionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EtlConnectionsStreamCursorInput>>;
  where?: InputMaybe<EtlConnectionsBoolExp>;
};


export type SubscriptionEtlSyncRunsArgs = {
  distinct_on?: InputMaybe<Array<EtlSyncRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EtlSyncRunsOrderBy>>;
  where?: InputMaybe<EtlSyncRunsBoolExp>;
};


export type SubscriptionEtlSyncRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEtlSyncRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EtlSyncRunsStreamCursorInput>>;
  where?: InputMaybe<EtlSyncRunsBoolExp>;
};


export type SubscriptionEventComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


export type SubscriptionEventComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsOrderBy>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


export type SubscriptionEventComponentsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventComponentsConditionsArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


export type SubscriptionEventComponentsConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsConditionsOrderBy>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


export type SubscriptionEventComponentsConditionsByPkArgs = {
  component_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventComponentsConditionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventComponentsConditionsStreamCursorInput>>;
  where?: InputMaybe<EventComponentsConditionsBoolExp>;
};


export type SubscriptionEventComponentsJoinArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


export type SubscriptionEventComponentsJoinAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventComponentsJoinSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventComponentsJoinOrderBy>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


export type SubscriptionEventComponentsJoinByPkArgs = {
  importee_id: Scalars['uuid'];
  importer_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventComponentsJoinStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventComponentsJoinStreamCursorInput>>;
  where?: InputMaybe<EventComponentsJoinBoolExp>;
};


export type SubscriptionEventComponentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventComponentsStreamCursorInput>>;
  where?: InputMaybe<EventComponentsBoolExp>;
};


export type SubscriptionEventContractsArgs = {
  distinct_on?: InputMaybe<Array<EventContractsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventContractsOrderBy>>;
  where?: InputMaybe<EventContractsBoolExp>;
};


export type SubscriptionEventContractsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventContractsSchemaArgs = {
  distinct_on?: InputMaybe<Array<EventContractsSchemaSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventContractsSchemaOrderBy>>;
  where?: InputMaybe<EventContractsSchemaBoolExp>;
};


export type SubscriptionEventContractsSchemaByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventContractsSchemaStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventContractsSchemaStreamCursorInput>>;
  where?: InputMaybe<EventContractsSchemaBoolExp>;
};


export type SubscriptionEventContractsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventContractsStreamCursorInput>>;
  where?: InputMaybe<EventContractsBoolExp>;
};


export type SubscriptionEventForwardingDestinationGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};


export type SubscriptionEventForwardingDestinationGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};


export type SubscriptionEventForwardingDestinationGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventForwardingDestinationGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventForwardingDestinationGrantsStreamCursorInput>>;
  where?: InputMaybe<EventForwardingDestinationGrantsBoolExp>;
};


export type SubscriptionEventForwardingSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


export type SubscriptionEventForwardingSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncSourcesOrderBy>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


export type SubscriptionEventForwardingSyncSourcesByPkArgs = {
  event_source_id: Scalars['uuid'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventForwardingSyncSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventForwardingSyncSourcesStreamCursorInput>>;
  where?: InputMaybe<EventForwardingSyncSourcesBoolExp>;
};


export type SubscriptionEventForwardingSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventForwardingSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventForwardingSyncsOrderBy>>;
  where?: InputMaybe<EventForwardingSyncsBoolExp>;
};


export type SubscriptionEventForwardingSyncsByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventForwardingSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventForwardingSyncsStreamCursorInput>>;
  where?: InputMaybe<EventForwardingSyncsBoolExp>;
};


export type SubscriptionEventModelEventSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


export type SubscriptionEventModelEventSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventModelEventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelEventSourcesOrderBy>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


export type SubscriptionEventModelEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventModelEventSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventModelEventSourcesStreamCursorInput>>;
  where?: InputMaybe<EventModelEventSourcesBoolExp>;
};


export type SubscriptionEventModelsArgs = {
  distinct_on?: InputMaybe<Array<EventModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventModelsOrderBy>>;
  where?: InputMaybe<EventModelsBoolExp>;
};


export type SubscriptionEventModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionEventModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventModelsStreamCursorInput>>;
  where?: InputMaybe<EventModelsBoolExp>;
};


export type SubscriptionEventPlanGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventPlanGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlanGrantsOrderBy>>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};


export type SubscriptionEventPlanGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPlanGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlanGrantsOrderBy>>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};


export type SubscriptionEventPlanGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventPlanGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlanGrantsStreamCursorInput>>;
  where?: InputMaybe<EventPlanGrantsBoolExp>;
};


export type SubscriptionEventPlansArgs = {
  distinct_on?: InputMaybe<Array<EventPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlansOrderBy>>;
  where?: InputMaybe<EventPlansBoolExp>;
};


export type SubscriptionEventPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventPlansOrderBy>>;
  where?: InputMaybe<EventPlansBoolExp>;
};


export type SubscriptionEventPlansByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventPlansStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventPlansStreamCursorInput>>;
  where?: InputMaybe<EventPlansBoolExp>;
};


export type SubscriptionEventSchemaComponentsArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


export type SubscriptionEventSchemaComponentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemaComponentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemaComponentsOrderBy>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


export type SubscriptionEventSchemaComponentsByPkArgs = {
  component_id: Scalars['uuid'];
  event_schema_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventSchemaComponentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSchemaComponentsStreamCursorInput>>;
  where?: InputMaybe<EventSchemaComponentsBoolExp>;
};


export type SubscriptionEventSchemasArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


export type SubscriptionEventSchemasAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSchemasOrderBy>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


export type SubscriptionEventSchemasByPkArgs = {
  id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventSchemasStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSchemasStreamCursorInput>>;
  where?: InputMaybe<EventSchemasBoolExp>;
};


export type SubscriptionEventSourceContractsArgs = {
  distinct_on?: InputMaybe<Array<EventSourceContractsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceContractsOrderBy>>;
  where?: InputMaybe<EventSourceContractsBoolExp>;
};


export type SubscriptionEventSourceContractsByPkArgs = {
  event_contract_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventSourceContractsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSourceContractsStreamCursorInput>>;
  where?: InputMaybe<EventSourceContractsBoolExp>;
};


export type SubscriptionEventSourceGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceGrantsOrderBy>>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};


export type SubscriptionEventSourceGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourceGrantsOrderBy>>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};


export type SubscriptionEventSourceGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventSourceGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSourceGrantsStreamCursorInput>>;
  where?: InputMaybe<EventSourceGrantsBoolExp>;
};


export type SubscriptionEventSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesOrderBy>>;
  where?: InputMaybe<EventSourcesBoolExp>;
};


export type SubscriptionEventSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesOrderBy>>;
  where?: InputMaybe<EventSourcesBoolExp>;
};


export type SubscriptionEventSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventSourcesPlansArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


export type SubscriptionEventSourcesPlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventSourcesPlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventSourcesPlansOrderBy>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


export type SubscriptionEventSourcesPlansByPkArgs = {
  event_plan_id: Scalars['uuid'];
  event_source_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventSourcesPlansStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSourcesPlansStreamCursorInput>>;
  where?: InputMaybe<EventSourcesPlansBoolExp>;
};


export type SubscriptionEventSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventSourcesStreamCursorInput>>;
  where?: InputMaybe<EventSourcesBoolExp>;
};


export type SubscriptionEventWarehouseDestinationGrantsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};


export type SubscriptionEventWarehouseDestinationGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationGrantsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};


export type SubscriptionEventWarehouseDestinationGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventWarehouseDestinationGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventWarehouseDestinationGrantsStreamCursorInput>>;
  where?: InputMaybe<EventWarehouseDestinationGrantsBoolExp>;
};


export type SubscriptionEventWarehouseDestinationsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationsBoolExp>;
};


export type SubscriptionEventWarehouseDestinationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseDestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseDestinationsOrderBy>>;
  where?: InputMaybe<EventWarehouseDestinationsBoolExp>;
};


export type SubscriptionEventWarehouseDestinationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventWarehouseDestinationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventWarehouseDestinationsStreamCursorInput>>;
  where?: InputMaybe<EventWarehouseDestinationsBoolExp>;
};


export type SubscriptionEventWarehouseSyncSourcesArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


export type SubscriptionEventWarehouseSyncSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncSourcesOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


export type SubscriptionEventWarehouseSyncSourcesByPkArgs = {
  event_source_id: Scalars['uuid'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionEventWarehouseSyncSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventWarehouseSyncSourcesStreamCursorInput>>;
  where?: InputMaybe<EventWarehouseSyncSourcesBoolExp>;
};


export type SubscriptionEventWarehouseSyncsArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


export type SubscriptionEventWarehouseSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EventWarehouseSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EventWarehouseSyncsOrderBy>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


export type SubscriptionEventWarehouseSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionEventWarehouseSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EventWarehouseSyncsStreamCursorInput>>;
  where?: InputMaybe<EventWarehouseSyncsBoolExp>;
};


export type SubscriptionExperimentMetricsArgs = {
  distinct_on?: InputMaybe<Array<ExperimentMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentMetricsOrderBy>>;
  where?: InputMaybe<ExperimentMetricsBoolExp>;
};


export type SubscriptionExperimentMetricsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExperimentMetricsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExperimentMetricsStreamCursorInput>>;
  where?: InputMaybe<ExperimentMetricsBoolExp>;
};


export type SubscriptionExperimentsArgs = {
  distinct_on?: InputMaybe<Array<ExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentsOrderBy>>;
  where?: InputMaybe<ExperimentsBoolExp>;
};


export type SubscriptionExperimentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExperimentsOrderBy>>;
  where?: InputMaybe<ExperimentsBoolExp>;
};


export type SubscriptionExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExperimentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExperimentsStreamCursorInput>>;
  where?: InputMaybe<ExperimentsBoolExp>;
};


export type SubscriptionExposureLogResolutionRunsArgs = {
  distinct_on?: InputMaybe<Array<ExposureLogResolutionRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExposureLogResolutionRunsOrderBy>>;
  where?: InputMaybe<ExposureLogResolutionRunsBoolExp>;
};


export type SubscriptionExposureLogResolutionRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExposureLogResolutionRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExposureLogResolutionRunsStreamCursorInput>>;
  where?: InputMaybe<ExposureLogResolutionRunsBoolExp>;
};


export type SubscriptionExtensionsArgs = {
  distinct_on?: InputMaybe<Array<ExtensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExtensionsOrderBy>>;
  where?: InputMaybe<ExtensionsBoolExp>;
};


export type SubscriptionExtensionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExtensionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExtensionsOrderBy>>;
  where?: InputMaybe<ExtensionsBoolExp>;
};


export type SubscriptionExtensionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExtensionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExtensionsStreamCursorInput>>;
  where?: InputMaybe<ExtensionsBoolExp>;
};


export type SubscriptionExternalBucketsArgs = {
  distinct_on?: InputMaybe<Array<ExternalBucketsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalBucketsOrderBy>>;
  where?: InputMaybe<ExternalBucketsBoolExp>;
};


export type SubscriptionExternalBucketsByPkArgs = {
  workspace_id: Scalars['bigint'];
};


export type SubscriptionExternalBucketsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExternalBucketsStreamCursorInput>>;
  where?: InputMaybe<ExternalBucketsBoolExp>;
};


export type SubscriptionExternalContextSourcesArgs = {
  distinct_on?: InputMaybe<Array<ExternalContextSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalContextSourcesOrderBy>>;
  where?: InputMaybe<ExternalContextSourcesBoolExp>;
};


export type SubscriptionExternalContextSourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExternalContextSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalContextSourcesOrderBy>>;
  where?: InputMaybe<ExternalContextSourcesBoolExp>;
};


export type SubscriptionExternalContextSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExternalContextSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExternalContextSourcesStreamCursorInput>>;
  where?: InputMaybe<ExternalContextSourcesBoolExp>;
};


export type SubscriptionExternalSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalSegmentsOrderBy>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


export type SubscriptionExternalSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionExternalSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExternalSegmentsStreamCursorInput>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


export type SubscriptionFigmaImportDraftsArgs = {
  distinct_on?: InputMaybe<Array<FigmaImportDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FigmaImportDraftsOrderBy>>;
  where?: InputMaybe<FigmaImportDraftsBoolExp>;
};


export type SubscriptionFigmaImportDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFigmaImportDraftsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FigmaImportDraftsStreamCursorInput>>;
  where?: InputMaybe<FigmaImportDraftsBoolExp>;
};


export type SubscriptionFivetranAgentSyncsArgs = {
  distinct_on?: InputMaybe<Array<FivetranAgentSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FivetranAgentSyncsOrderBy>>;
  where?: InputMaybe<FivetranAgentSyncsBoolExp>;
};


export type SubscriptionFivetranAgentSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFivetranAgentSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FivetranAgentSyncsStreamCursorInput>>;
  where?: InputMaybe<FivetranAgentSyncsBoolExp>;
};


export type SubscriptionFivetranCredentialsArgs = {
  distinct_on?: InputMaybe<Array<FivetranCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FivetranCredentialsOrderBy>>;
  where?: InputMaybe<FivetranCredentialsBoolExp>;
};


export type SubscriptionFivetranCredentialsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFivetranCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FivetranCredentialsStreamCursorInput>>;
  where?: InputMaybe<FivetranCredentialsBoolExp>;
};


export type SubscriptionFoldersArgs = {
  distinct_on?: InputMaybe<Array<FoldersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FoldersOrderBy>>;
  where?: InputMaybe<FoldersBoolExp>;
};


export type SubscriptionFoldersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFoldersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FoldersStreamCursorInput>>;
  where?: InputMaybe<FoldersBoolExp>;
};


export type SubscriptionFunctionGrantsArgs = {
  distinct_on?: InputMaybe<Array<FunctionGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionGrantsOrderBy>>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};


export type SubscriptionFunctionGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<FunctionGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionGrantsOrderBy>>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};


export type SubscriptionFunctionGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFunctionGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunctionGrantsStreamCursorInput>>;
  where?: InputMaybe<FunctionGrantsBoolExp>;
};


export type SubscriptionFunctionResourcesArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


export type SubscriptionFunctionResourcesAggregateArgs = {
  distinct_on?: InputMaybe<Array<FunctionResourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionResourcesOrderBy>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


export type SubscriptionFunctionResourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFunctionResourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunctionResourcesStreamCursorInput>>;
  where?: InputMaybe<FunctionResourcesBoolExp>;
};


export type SubscriptionFunctionSettingsArgs = {
  distinct_on?: InputMaybe<Array<FunctionSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionSettingsOrderBy>>;
  where?: InputMaybe<FunctionSettingsBoolExp>;
};


export type SubscriptionFunctionSettingsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFunctionSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunctionSettingsStreamCursorInput>>;
  where?: InputMaybe<FunctionSettingsBoolExp>;
};


export type SubscriptionFunctionsArgs = {
  distinct_on?: InputMaybe<Array<FunctionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FunctionsOrderBy>>;
  where?: InputMaybe<FunctionsBoolExp>;
};


export type SubscriptionFunctionsByPkArgs = {
  id: Scalars['uuid'];
  version_number: Scalars['Int'];
};


export type SubscriptionFunctionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FunctionsStreamCursorInput>>;
  where?: InputMaybe<FunctionsBoolExp>;
};


export type SubscriptionGitCredentialsArgs = {
  distinct_on?: InputMaybe<Array<GitCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitCredentialsOrderBy>>;
  where?: InputMaybe<GitCredentialsBoolExp>;
};


export type SubscriptionGitCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GitCredentialsStreamCursorInput>>;
  where?: InputMaybe<GitCredentialsBoolExp>;
};


export type SubscriptionGitInboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitInboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitInboundRunsOrderBy>>;
  where?: InputMaybe<GitInboundRunsBoolExp>;
};


export type SubscriptionGitInboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitInboundRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GitInboundRunsStreamCursorInput>>;
  where?: InputMaybe<GitInboundRunsBoolExp>;
};


export type SubscriptionGitOutboundRunsArgs = {
  distinct_on?: InputMaybe<Array<GitOutboundRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitOutboundRunsOrderBy>>;
  where?: InputMaybe<GitOutboundRunsBoolExp>;
};


export type SubscriptionGitOutboundRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitOutboundRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GitOutboundRunsStreamCursorInput>>;
  where?: InputMaybe<GitOutboundRunsBoolExp>;
};


export type SubscriptionGitSyncConfigsArgs = {
  distinct_on?: InputMaybe<Array<GitSyncConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GitSyncConfigsOrderBy>>;
  where?: InputMaybe<GitSyncConfigsBoolExp>;
};


export type SubscriptionGitSyncConfigsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionGitSyncConfigsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GitSyncConfigsStreamCursorInput>>;
  where?: InputMaybe<GitSyncConfigsBoolExp>;
};


export type SubscriptionGoalMetricsArgs = {
  distinct_on?: InputMaybe<Array<GoalMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalMetricsOrderBy>>;
  where?: InputMaybe<GoalMetricsBoolExp>;
};


export type SubscriptionGoalMetricsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionGoalMetricsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GoalMetricsStreamCursorInput>>;
  where?: InputMaybe<GoalMetricsBoolExp>;
};


export type SubscriptionGoalsArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


export type SubscriptionGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<GoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsOrderBy>>;
  where?: InputMaybe<GoalsBoolExp>;
};


export type SubscriptionGoalsAttributionMethodsArgs = {
  distinct_on?: InputMaybe<Array<GoalsAttributionMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GoalsAttributionMethodsOrderBy>>;
  where?: InputMaybe<GoalsAttributionMethodsBoolExp>;
};


export type SubscriptionGoalsAttributionMethodsByPkArgs = {
  attribution_method_id: Scalars['uuid'];
  goal_id: Scalars['uuid'];
};


export type SubscriptionGoalsAttributionMethodsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GoalsAttributionMethodsStreamCursorInput>>;
  where?: InputMaybe<GoalsAttributionMethodsBoolExp>;
};


export type SubscriptionGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionGoalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<GoalsStreamCursorInput>>;
  where?: InputMaybe<GoalsBoolExp>;
};


export type SubscriptionIdrArgs = {
  distinct_on?: InputMaybe<Array<IdrSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrOrderBy>>;
  where?: InputMaybe<IdrBoolExp>;
};


export type SubscriptionIdrByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrGoldenRecordBaseColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordBaseColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordBaseColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
};


export type SubscriptionIdrGoldenRecordBaseColumnsByPkArgs = {
  column_name: Scalars['String'];
  golden_record_id: Scalars['uuid'];
  idr_model_id: Scalars['uuid'];
  model_id: Scalars['bigint'];
};


export type SubscriptionIdrGoldenRecordBaseColumnsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrGoldenRecordBaseColumnsStreamCursorInput>>;
  where?: InputMaybe<IdrGoldenRecordBaseColumnsBoolExp>;
};


export type SubscriptionIdrGoldenRecordColumnSourceSurvivorshipArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnSourceSurvivorshipOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
};


export type SubscriptionIdrGoldenRecordColumnSourceSurvivorshipByPkArgs = {
  golden_record_column_id: Scalars['uuid'];
  idr_model_id: Scalars['uuid'];
};


export type SubscriptionIdrGoldenRecordColumnSourceSurvivorshipStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipStreamCursorInput>>;
  where?: InputMaybe<IdrGoldenRecordColumnSourceSurvivorshipBoolExp>;
};


export type SubscriptionIdrGoldenRecordColumnsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordColumnsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
};


export type SubscriptionIdrGoldenRecordColumnsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrGoldenRecordColumnsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrGoldenRecordColumnsStreamCursorInput>>;
  where?: InputMaybe<IdrGoldenRecordColumnsBoolExp>;
};


export type SubscriptionIdrGoldenRecordsArgs = {
  distinct_on?: InputMaybe<Array<IdrGoldenRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrGoldenRecordsOrderBy>>;
  where?: InputMaybe<IdrGoldenRecordsBoolExp>;
};


export type SubscriptionIdrGoldenRecordsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrGoldenRecordsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrGoldenRecordsStreamCursorInput>>;
  where?: InputMaybe<IdrGoldenRecordsBoolExp>;
};


export type SubscriptionIdrModelMappingsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelMappingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelMappingsOrderBy>>;
  where?: InputMaybe<IdrModelMappingsBoolExp>;
};


export type SubscriptionIdrModelMappingsByPkArgs = {
  column: Scalars['String'];
  idr_model_id: Scalars['uuid'];
  model_id: Scalars['bigint'];
};


export type SubscriptionIdrModelMappingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrModelMappingsStreamCursorInput>>;
  where?: InputMaybe<IdrModelMappingsBoolExp>;
};


export type SubscriptionIdrModelsArgs = {
  distinct_on?: InputMaybe<Array<IdrModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrModelsOrderBy>>;
  where?: InputMaybe<IdrModelsBoolExp>;
};


export type SubscriptionIdrModelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrModelsStreamCursorInput>>;
  where?: InputMaybe<IdrModelsBoolExp>;
};


export type SubscriptionIdrOutputSegmentsArgs = {
  distinct_on?: InputMaybe<Array<IdrOutputSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrOutputSegmentsOrderBy>>;
  where?: InputMaybe<IdrOutputSegmentsBoolExp>;
};


export type SubscriptionIdrOutputSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrOutputSegmentsStreamCursorInput>>;
  where?: InputMaybe<IdrOutputSegmentsBoolExp>;
};


export type SubscriptionIdrRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


export type SubscriptionIdrRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrRunsOrderBy>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


export type SubscriptionIdrRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrRunsStreamCursorInput>>;
  where?: InputMaybe<IdrRunsBoolExp>;
};


export type SubscriptionIdrStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrStreamCursorInput>>;
  where?: InputMaybe<IdrBoolExp>;
};


export type SubscriptionIdrTrainingRunsArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


export type SubscriptionIdrTrainingRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdrTrainingRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdrTrainingRunsOrderBy>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


export type SubscriptionIdrTrainingRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIdrTrainingRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdrTrainingRunsStreamCursorInput>>;
  where?: InputMaybe<IdrTrainingRunsBoolExp>;
};


export type SubscriptionIncomingWebhooksArgs = {
  distinct_on?: InputMaybe<Array<IncomingWebhooksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IncomingWebhooksOrderBy>>;
  where?: InputMaybe<IncomingWebhooksBoolExp>;
};


export type SubscriptionIncomingWebhooksByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionIncomingWebhooksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IncomingWebhooksStreamCursorInput>>;
  where?: InputMaybe<IncomingWebhooksBoolExp>;
};


export type SubscriptionInitiativeGoalsArgs = {
  distinct_on?: InputMaybe<Array<InitiativeGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeGoalsOrderBy>>;
  where?: InputMaybe<InitiativeGoalsBoolExp>;
};


export type SubscriptionInitiativeGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionInitiativeGoalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InitiativeGoalsStreamCursorInput>>;
  where?: InputMaybe<InitiativeGoalsBoolExp>;
};


export type SubscriptionInitiativeInsightsArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


export type SubscriptionInitiativeInsightsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InitiativeInsightsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InitiativeInsightsOrderBy>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


export type SubscriptionInitiativeInsightsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionInitiativeInsightsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InitiativeInsightsStreamCursorInput>>;
  where?: InputMaybe<InitiativeInsightsBoolExp>;
};


export type SubscriptionInsightsAgentDataSourcesArgs = {
  distinct_on?: InputMaybe<Array<InsightsAgentDataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InsightsAgentDataSourcesOrderBy>>;
  where?: InputMaybe<InsightsAgentDataSourcesBoolExp>;
};


export type SubscriptionInsightsAgentDataSourcesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionInsightsAgentDataSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InsightsAgentDataSourcesStreamCursorInput>>;
  where?: InputMaybe<InsightsAgentDataSourcesBoolExp>;
};


export type SubscriptionInspirationBoardAdsArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


export type SubscriptionInspirationBoardAdsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardAdsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardAdsOrderBy>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


export type SubscriptionInspirationBoardAdsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionInspirationBoardAdsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InspirationBoardAdsStreamCursorInput>>;
  where?: InputMaybe<InspirationBoardAdsBoolExp>;
};


export type SubscriptionInspirationBoardsArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardsOrderBy>>;
  where?: InputMaybe<InspirationBoardsBoolExp>;
};


export type SubscriptionInspirationBoardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<InspirationBoardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InspirationBoardsOrderBy>>;
  where?: InputMaybe<InspirationBoardsBoolExp>;
};


export type SubscriptionInspirationBoardsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionInspirationBoardsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InspirationBoardsStreamCursorInput>>;
  where?: InputMaybe<InspirationBoardsBoolExp>;
};


export type SubscriptionInteractionModelsArgs = {
  distinct_on?: InputMaybe<Array<InteractionModelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<InteractionModelsOrderBy>>;
  where?: InputMaybe<InteractionModelsBoolExp>;
};


export type SubscriptionInteractionModelsByPkArgs = {
  model_id: Scalars['bigint'];
};


export type SubscriptionInteractionModelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<InteractionModelsStreamCursorInput>>;
  where?: InputMaybe<InteractionModelsBoolExp>;
};


export type SubscriptionJourneyDecisionEngineFlowsArgs = {
  distinct_on?: InputMaybe<Array<JourneyDecisionEngineFlowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDecisionEngineFlowsOrderBy>>;
  where?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
};


export type SubscriptionJourneyDecisionEngineFlowsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyDecisionEngineFlowsStreamCursorInput>>;
  where?: InputMaybe<JourneyDecisionEngineFlowsBoolExp>;
};


export type SubscriptionJourneyDraftsArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


export type SubscriptionJourneyDraftsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyDraftsOrderBy>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


export type SubscriptionJourneyDraftsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneyDraftsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyDraftsStreamCursorInput>>;
  where?: InputMaybe<JourneyDraftsBoolExp>;
};


export type SubscriptionJourneyEdgesArgs = {
  distinct_on?: InputMaybe<Array<JourneyEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyEdgesOrderBy>>;
  where?: InputMaybe<JourneyEdgesBoolExp>;
};


export type SubscriptionJourneyEdgesByPkArgs = {
  from_node_id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
  to_node_id: Scalars['uuid'];
};


export type SubscriptionJourneyEdgesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyEdgesStreamCursorInput>>;
  where?: InputMaybe<JourneyEdgesBoolExp>;
};


export type SubscriptionJourneyLabelsArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


export type SubscriptionJourneyLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyLabelsOrderBy>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


export type SubscriptionJourneyLabelsByPkArgs = {
  journey_id: Scalars['uuid'];
  label_id: Scalars['uuid'];
};


export type SubscriptionJourneyLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyLabelsStreamCursorInput>>;
  where?: InputMaybe<JourneyLabelsBoolExp>;
};


export type SubscriptionJourneyMessagesArgs = {
  distinct_on?: InputMaybe<Array<JourneyMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyMessagesOrderBy>>;
  where?: InputMaybe<JourneyMessagesBoolExp>;
};


export type SubscriptionJourneyMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneyMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyMessagesStreamCursorInput>>;
  where?: InputMaybe<JourneyMessagesBoolExp>;
};


export type SubscriptionJourneyNodeRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodeRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodeRunsOrderBy>>;
  where?: InputMaybe<JourneyNodeRunsBoolExp>;
};


export type SubscriptionJourneyNodeRunsByPkArgs = {
  node_id: Scalars['uuid'];
  run_id: Scalars['uuid'];
};


export type SubscriptionJourneyNodeRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyNodeRunsStreamCursorInput>>;
  where?: InputMaybe<JourneyNodeRunsBoolExp>;
};


export type SubscriptionJourneyNodesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


export type SubscriptionJourneyNodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNodesOrderBy>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


export type SubscriptionJourneyNodesByPkArgs = {
  id: Scalars['uuid'];
  journey_version_id: Scalars['uuid'];
};


export type SubscriptionJourneyNodesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyNodesStreamCursorInput>>;
  where?: InputMaybe<JourneyNodesBoolExp>;
};


export type SubscriptionJourneyNotesArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


export type SubscriptionJourneyNotesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyNotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyNotesOrderBy>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


export type SubscriptionJourneyNotesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyNotesStreamCursorInput>>;
  where?: InputMaybe<JourneyNotesBoolExp>;
};


export type SubscriptionJourneyRunsArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


export type SubscriptionJourneyRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyRunsOrderBy>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


export type SubscriptionJourneyRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneyRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyRunsStreamCursorInput>>;
  where?: InputMaybe<JourneyRunsBoolExp>;
};


export type SubscriptionJourneySimulationsArgs = {
  distinct_on?: InputMaybe<Array<JourneySimulationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySimulationsOrderBy>>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};


export type SubscriptionJourneySimulationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneySimulationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySimulationsOrderBy>>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};


export type SubscriptionJourneySimulationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneySimulationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneySimulationsStreamCursorInput>>;
  where?: InputMaybe<JourneySimulationsBoolExp>;
};


export type SubscriptionJourneySyncsArgs = {
  distinct_on?: InputMaybe<Array<JourneySyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneySyncsOrderBy>>;
  where?: InputMaybe<JourneySyncsBoolExp>;
};


export type SubscriptionJourneySyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneySyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneySyncsStreamCursorInput>>;
  where?: InputMaybe<JourneySyncsBoolExp>;
};


export type SubscriptionJourneyTemplateReferencesArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplateReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplateReferencesOrderBy>>;
  where?: InputMaybe<JourneyTemplateReferencesBoolExp>;
};


export type SubscriptionJourneyTemplateReferencesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneyTemplateReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyTemplateReferencesStreamCursorInput>>;
  where?: InputMaybe<JourneyTemplateReferencesBoolExp>;
};


export type SubscriptionJourneyTemplatesArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplatesOrderBy>>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};


export type SubscriptionJourneyTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneyTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneyTemplatesOrderBy>>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};


export type SubscriptionJourneyTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionJourneyTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneyTemplatesStreamCursorInput>>;
  where?: InputMaybe<JourneyTemplatesBoolExp>;
};


export type SubscriptionJourneysArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};


export type SubscriptionJourneysAggregateArgs = {
  distinct_on?: InputMaybe<Array<JourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JourneysOrderBy>>;
  where?: InputMaybe<JourneysBoolExp>;
};


export type SubscriptionJourneysByPkArgs = {
  id: Scalars['uuid'];
  version_id: Scalars['uuid'];
};


export type SubscriptionJourneysStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JourneysStreamCursorInput>>;
  where?: InputMaybe<JourneysBoolExp>;
};


export type SubscriptionLabelGroupsArgs = {
  distinct_on?: InputMaybe<Array<LabelGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelGroupsOrderBy>>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};


export type SubscriptionLabelGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LabelGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelGroupsOrderBy>>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};


export type SubscriptionLabelGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLabelGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LabelGroupsStreamCursorInput>>;
  where?: InputMaybe<LabelGroupsBoolExp>;
};


export type SubscriptionLabelsArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};


export type SubscriptionLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LabelsOrderBy>>;
  where?: InputMaybe<LabelsBoolExp>;
};


export type SubscriptionLabelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LabelsStreamCursorInput>>;
  where?: InputMaybe<LabelsBoolExp>;
};


export type SubscriptionLcmMessageCandidatesArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


export type SubscriptionLcmMessageCandidatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessageCandidatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessageCandidatesOrderBy>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


export type SubscriptionLcmMessageCandidatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLcmMessageCandidatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LcmMessageCandidatesStreamCursorInput>>;
  where?: InputMaybe<LcmMessageCandidatesBoolExp>;
};


export type SubscriptionLcmMessagePlansArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


export type SubscriptionLcmMessagePlansAggregateArgs = {
  distinct_on?: InputMaybe<Array<LcmMessagePlansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LcmMessagePlansOrderBy>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


export type SubscriptionLcmMessagePlansByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLcmMessagePlansStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LcmMessagePlansStreamCursorInput>>;
  where?: InputMaybe<LcmMessagePlansBoolExp>;
};


export type SubscriptionLlmChatInteractionsArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


export type SubscriptionLlmChatInteractionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatInteractionsOrderBy>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


export type SubscriptionLlmChatInteractionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLlmChatInteractionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LlmChatInteractionsStreamCursorInput>>;
  where?: InputMaybe<LlmChatInteractionsBoolExp>;
};


export type SubscriptionLlmChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


export type SubscriptionLlmChatMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<LlmChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatMessagesOrderBy>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


export type SubscriptionLlmChatMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLlmChatMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LlmChatMessagesStreamCursorInput>>;
  where?: InputMaybe<LlmChatMessagesBoolExp>;
};


export type SubscriptionLlmChatSessionsArgs = {
  distinct_on?: InputMaybe<Array<LlmChatSessionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmChatSessionsOrderBy>>;
  where?: InputMaybe<LlmChatSessionsBoolExp>;
};


export type SubscriptionLlmChatSessionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLlmChatSessionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LlmChatSessionsStreamCursorInput>>;
  where?: InputMaybe<LlmChatSessionsBoolExp>;
};


export type SubscriptionLlmInferenceBackendsArgs = {
  distinct_on?: InputMaybe<Array<LlmInferenceBackendsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LlmInferenceBackendsOrderBy>>;
  where?: InputMaybe<LlmInferenceBackendsBoolExp>;
};


export type SubscriptionLlmInferenceBackendsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionLlmInferenceBackendsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LlmInferenceBackendsStreamCursorInput>>;
  where?: InputMaybe<LlmInferenceBackendsBoolExp>;
};


export type SubscriptionLookerCredentialsArgs = {
  distinct_on?: InputMaybe<Array<LookerCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LookerCredentialsOrderBy>>;
  where?: InputMaybe<LookerCredentialsBoolExp>;
};


export type SubscriptionLookerCredentialsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionLookerCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<LookerCredentialsStreamCursorInput>>;
  where?: InputMaybe<LookerCredentialsBoolExp>;
};


export type SubscriptionMarketingCampaignMessagesArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


export type SubscriptionMarketingCampaignMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignMessagesOrderBy>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


export type SubscriptionMarketingCampaignMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMarketingCampaignMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MarketingCampaignMessagesStreamCursorInput>>;
  where?: InputMaybe<MarketingCampaignMessagesBoolExp>;
};


export type SubscriptionMarketingCampaignsArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignsOrderBy>>;
  where?: InputMaybe<MarketingCampaignsBoolExp>;
};


export type SubscriptionMarketingCampaignsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MarketingCampaignsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MarketingCampaignsOrderBy>>;
  where?: InputMaybe<MarketingCampaignsBoolExp>;
};


export type SubscriptionMarketingCampaignsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMarketingCampaignsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MarketingCampaignsStreamCursorInput>>;
  where?: InputMaybe<MarketingCampaignsBoolExp>;
};


export type SubscriptionMatchboostingConfigArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingConfigOrderBy>>;
  where?: InputMaybe<MatchboostingConfigBoolExp>;
};


export type SubscriptionMatchboostingConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMatchboostingConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MatchboostingConfigStreamCursorInput>>;
  where?: InputMaybe<MatchboostingConfigBoolExp>;
};


export type SubscriptionMatchboostingStatsArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingStatsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingStatsOrderBy>>;
  where?: InputMaybe<MatchboostingStatsBoolExp>;
};


export type SubscriptionMatchboostingStatsByPkArgs = {
  uuid: Scalars['uuid'];
};


export type SubscriptionMatchboostingStatsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MatchboostingStatsStreamCursorInput>>;
  where?: InputMaybe<MatchboostingStatsBoolExp>;
};


export type SubscriptionMatchboostingWorkspaceConfigArgs = {
  distinct_on?: InputMaybe<Array<MatchboostingWorkspaceConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchboostingWorkspaceConfigOrderBy>>;
  where?: InputMaybe<MatchboostingWorkspaceConfigBoolExp>;
};


export type SubscriptionMatchboostingWorkspaceConfigByPkArgs = {
  config_name: Scalars['String'];
  destination: Scalars['String'];
  region: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionMatchboostingWorkspaceConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MatchboostingWorkspaceConfigStreamCursorInput>>;
  where?: InputMaybe<MatchboostingWorkspaceConfigBoolExp>;
};


export type SubscriptionMessageContentsArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


export type SubscriptionMessageContentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsOrderBy>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


export type SubscriptionMessageContentsBaseArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsBaseOrderBy>>;
  where?: InputMaybe<MessageContentsBaseBoolExp>;
};


export type SubscriptionMessageContentsBaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsBaseOrderBy>>;
  where?: InputMaybe<MessageContentsBaseBoolExp>;
};


export type SubscriptionMessageContentsBaseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageContentsBaseStreamCursorInput>>;
  where?: InputMaybe<MessageContentsBaseBoolExp>;
};


export type SubscriptionMessageContentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMessageContentsMetadataArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


export type SubscriptionMessageContentsMetadataAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


export type SubscriptionMessageContentsMetadataBaseArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataBaseOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
};


export type SubscriptionMessageContentsMetadataBaseAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageContentsMetadataBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageContentsMetadataBaseOrderBy>>;
  where?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
};


export type SubscriptionMessageContentsMetadataBaseStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageContentsMetadataBaseStreamCursorInput>>;
  where?: InputMaybe<MessageContentsMetadataBaseBoolExp>;
};


export type SubscriptionMessageContentsMetadataByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMessageContentsMetadataStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageContentsMetadataStreamCursorInput>>;
  where?: InputMaybe<MessageContentsMetadataBoolExp>;
};


export type SubscriptionMessageContentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageContentsStreamCursorInput>>;
  where?: InputMaybe<MessageContentsBoolExp>;
};


export type SubscriptionMessageExperimentsArgs = {
  distinct_on?: InputMaybe<Array<MessageExperimentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageExperimentsOrderBy>>;
  where?: InputMaybe<MessageExperimentsBoolExp>;
};


export type SubscriptionMessageExperimentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMessageExperimentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageExperimentsStreamCursorInput>>;
  where?: InputMaybe<MessageExperimentsBoolExp>;
};


export type SubscriptionMessageLabelsArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


export type SubscriptionMessageLabelsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageLabelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageLabelsOrderBy>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


export type SubscriptionMessageLabelsByPkArgs = {
  label_id: Scalars['uuid'];
  message_id: Scalars['uuid'];
};


export type SubscriptionMessageLabelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageLabelsStreamCursorInput>>;
  where?: InputMaybe<MessageLabelsBoolExp>;
};


export type SubscriptionMessagePushAppsArgs = {
  distinct_on?: InputMaybe<Array<MessagePushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagePushAppsOrderBy>>;
  where?: InputMaybe<MessagePushAppsBoolExp>;
};


export type SubscriptionMessagePushAppsByPkArgs = {
  message_id: Scalars['uuid'];
  push_app_id: Scalars['uuid'];
};


export type SubscriptionMessagePushAppsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessagePushAppsStreamCursorInput>>;
  where?: InputMaybe<MessagePushAppsBoolExp>;
};


export type SubscriptionMessageVariantArmArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


export type SubscriptionMessageVariantArmAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageVariantArmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageVariantArmOrderBy>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


export type SubscriptionMessageVariantArmByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMessageVariantArmStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageVariantArmStreamCursorInput>>;
  where?: InputMaybe<MessageVariantArmBoolExp>;
};


export type SubscriptionMessagesArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type SubscriptionMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessagesOrderBy>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type SubscriptionMessagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessagesStreamCursorInput>>;
  where?: InputMaybe<MessagesBoolExp>;
};


export type SubscriptionModelColumnReferencesArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesBoolExp>;
};


export type SubscriptionModelColumnReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesBoolExp>;
};


export type SubscriptionModelColumnReferencesByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionModelColumnReferencesSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


export type SubscriptionModelColumnReferencesSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSegmentsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


export type SubscriptionModelColumnReferencesSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelColumnReferencesSegmentsStreamCursorInput>>;
  where?: InputMaybe<ModelColumnReferencesSegmentsBoolExp>;
};


export type SubscriptionModelColumnReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelColumnReferencesStreamCursorInput>>;
  where?: InputMaybe<ModelColumnReferencesBoolExp>;
};


export type SubscriptionModelColumnReferencesSyncsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSyncsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
};


export type SubscriptionModelColumnReferencesSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnReferencesSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnReferencesSyncsOrderBy>>;
  where?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
};


export type SubscriptionModelColumnReferencesSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelColumnReferencesSyncsStreamCursorInput>>;
  where?: InputMaybe<ModelColumnReferencesSyncsBoolExp>;
};


export type SubscriptionModelColumnsArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


export type SubscriptionModelColumnsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelColumnsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelColumnsOrderBy>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


export type SubscriptionModelColumnsByPkArgs = {
  model_id: Scalars['bigint'];
  name: Scalars['String'];
};


export type SubscriptionModelColumnsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelColumnsStreamCursorInput>>;
  where?: InputMaybe<ModelColumnsBoolExp>;
};


export type SubscriptionModelRelationshipReferencesArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipReferencesOrderBy>>;
  where?: InputMaybe<ModelRelationshipReferencesBoolExp>;
};


export type SubscriptionModelRelationshipReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipReferencesOrderBy>>;
  where?: InputMaybe<ModelRelationshipReferencesBoolExp>;
};


export type SubscriptionModelRelationshipReferencesByPkArgs = {
  model_relationship_id: Scalars['bigint'];
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionModelRelationshipReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelRelationshipReferencesStreamCursorInput>>;
  where?: InputMaybe<ModelRelationshipReferencesBoolExp>;
};


export type SubscriptionModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ModelRelationshipsOrderBy>>;
  where?: InputMaybe<ModelRelationshipsBoolExp>;
};


export type SubscriptionModelRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionModelRelationshipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ModelRelationshipsStreamCursorInput>>;
  where?: InputMaybe<ModelRelationshipsBoolExp>;
};


export type SubscriptionMonitorConditionStatusesArgs = {
  distinct_on?: InputMaybe<Array<MonitorConditionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitorConditionStatusesOrderBy>>;
  where?: InputMaybe<MonitorConditionStatusesBoolExp>;
};


export type SubscriptionMonitorConditionStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMonitorConditionStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonitorConditionStatusesStreamCursorInput>>;
  where?: InputMaybe<MonitorConditionStatusesBoolExp>;
};


export type SubscriptionMonitorConditionTemplatesArgs = {
  distinct_on?: InputMaybe<Array<MonitorConditionTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MonitorConditionTemplatesOrderBy>>;
  where?: InputMaybe<MonitorConditionTemplatesBoolExp>;
};


export type SubscriptionMonitorConditionTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionMonitorConditionTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MonitorConditionTemplatesStreamCursorInput>>;
  where?: InputMaybe<MonitorConditionTemplatesBoolExp>;
};


export type SubscriptionNotificationChannelTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannelTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationChannelTemplatesOrderBy>>;
  where?: InputMaybe<NotificationChannelTemplatesBoolExp>;
};


export type SubscriptionNotificationChannelTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionNotificationChannelTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationChannelTemplatesStreamCursorInput>>;
  where?: InputMaybe<NotificationChannelTemplatesBoolExp>;
};


export type SubscriptionObjectDefinitionGroupsArgs = {
  distinct_on?: InputMaybe<Array<ObjectDefinitionGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectDefinitionGroupsOrderBy>>;
  where?: InputMaybe<ObjectDefinitionGroupsBoolExp>;
};


export type SubscriptionObjectDefinitionGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionObjectDefinitionGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ObjectDefinitionGroupsStreamCursorInput>>;
  where?: InputMaybe<ObjectDefinitionGroupsBoolExp>;
};


export type SubscriptionObjectDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<ObjectDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectDefinitionsOrderBy>>;
  where?: InputMaybe<ObjectDefinitionsBoolExp>;
};


export type SubscriptionObjectDefinitionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionObjectDefinitionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ObjectDefinitionsStreamCursorInput>>;
  where?: InputMaybe<ObjectDefinitionsBoolExp>;
};


export type SubscriptionObjectSchemasArgs = {
  distinct_on?: InputMaybe<Array<ObjectSchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ObjectSchemasOrderBy>>;
  where?: InputMaybe<ObjectSchemasBoolExp>;
};


export type SubscriptionObjectSchemasByPkArgs = {
  key: Scalars['String'];
  object_definition_id: Scalars['bigint'];
};


export type SubscriptionObjectSchemasStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ObjectSchemasStreamCursorInput>>;
  where?: InputMaybe<ObjectSchemasBoolExp>;
};


export type SubscriptionOrganizationActiveSyncsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationActiveSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationActiveSyncsOrderBy>>;
  where?: InputMaybe<OrganizationActiveSyncsBoolExp>;
};


export type SubscriptionOrganizationActiveSyncsByPkArgs = {
  pkey: Scalars['String'];
};


export type SubscriptionOrganizationActiveSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationActiveSyncsStreamCursorInput>>;
  where?: InputMaybe<OrganizationActiveSyncsBoolExp>;
};


export type SubscriptionOrganizationInvitesArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesOrderBy>>;
  where?: InputMaybe<OrganizationInvitesBoolExp>;
};


export type SubscriptionOrganizationInvitesAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesOrderBy>>;
  where?: InputMaybe<OrganizationInvitesBoolExp>;
};


export type SubscriptionOrganizationInvitesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionOrganizationInvitesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationInvitesStreamCursorInput>>;
  where?: InputMaybe<OrganizationInvitesBoolExp>;
};


export type SubscriptionOrganizationInvitesUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationInvitesUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationInvitesUserGroupsOrderBy>>;
  where?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
};


export type SubscriptionOrganizationInvitesUserGroupsByPkArgs = {
  organization_invite_id: Scalars['bigint'];
  user_group_id: Scalars['bigint'];
};


export type SubscriptionOrganizationInvitesUserGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationInvitesUserGroupsStreamCursorInput>>;
  where?: InputMaybe<OrganizationInvitesUserGroupsBoolExp>;
};


export type SubscriptionOrganizationMembersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


export type SubscriptionOrganizationMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


export type SubscriptionOrganizationMembersDistinctArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersDistinctSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersDistinctOrderBy>>;
  where?: InputMaybe<OrganizationMembersDistinctBoolExp>;
};


export type SubscriptionOrganizationMembersDistinctAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersDistinctSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersDistinctOrderBy>>;
  where?: InputMaybe<OrganizationMembersDistinctBoolExp>;
};


export type SubscriptionOrganizationMembersDistinctStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationMembersDistinctStreamCursorInput>>;
  where?: InputMaybe<OrganizationMembersDistinctBoolExp>;
};


export type SubscriptionOrganizationMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationMembersStreamCursorInput>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


export type SubscriptionOrganizationOverageDatesArgs = {
  distinct_on?: InputMaybe<Array<OrganizationOverageDatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationOverageDatesOrderBy>>;
  where?: InputMaybe<OrganizationOverageDatesBoolExp>;
};


export type SubscriptionOrganizationOverageDatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationOverageDatesStreamCursorInput>>;
  where?: InputMaybe<OrganizationOverageDatesBoolExp>;
};


export type SubscriptionOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type SubscriptionOrganizationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionOrganizationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type SubscriptionPagerdutyCredentialsArgs = {
  distinct_on?: InputMaybe<Array<PagerdutyCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PagerdutyCredentialsOrderBy>>;
  where?: InputMaybe<PagerdutyCredentialsBoolExp>;
};


export type SubscriptionPagerdutyCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionPagerdutyCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PagerdutyCredentialsStreamCursorInput>>;
  where?: InputMaybe<PagerdutyCredentialsBoolExp>;
};


export type SubscriptionPredictorArtifactsArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


export type SubscriptionPredictorArtifactsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorArtifactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorArtifactsOrderBy>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


export type SubscriptionPredictorArtifactsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorArtifactsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorArtifactsStreamCursorInput>>;
  where?: InputMaybe<PredictorArtifactsBoolExp>;
};


export type SubscriptionPredictorFeatureDefinitionEventsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionEventsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
};


export type SubscriptionPredictorFeatureDefinitionEventsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorFeatureDefinitionEventsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorFeatureDefinitionEventsStreamCursorInput>>;
  where?: InputMaybe<PredictorFeatureDefinitionEventsBoolExp>;
};


export type SubscriptionPredictorFeatureDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<PredictorFeatureDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorFeatureDefinitionsOrderBy>>;
  where?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
};


export type SubscriptionPredictorFeatureDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorFeatureDefinitionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorFeatureDefinitionsStreamCursorInput>>;
  where?: InputMaybe<PredictorFeatureDefinitionsBoolExp>;
};


export type SubscriptionPredictorOutcomesArgs = {
  distinct_on?: InputMaybe<Array<PredictorOutcomesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorOutcomesOrderBy>>;
  where?: InputMaybe<PredictorOutcomesBoolExp>;
};


export type SubscriptionPredictorOutcomesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorOutcomesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorOutcomesStreamCursorInput>>;
  where?: InputMaybe<PredictorOutcomesBoolExp>;
};


export type SubscriptionPredictorRunsArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


export type SubscriptionPredictorRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PredictorRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorRunsOrderBy>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


export type SubscriptionPredictorRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorRunsStreamCursorInput>>;
  where?: InputMaybe<PredictorRunsBoolExp>;
};


export type SubscriptionPredictorsArgs = {
  distinct_on?: InputMaybe<Array<PredictorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PredictorsOrderBy>>;
  where?: InputMaybe<PredictorsBoolExp>;
};


export type SubscriptionPredictorsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPredictorsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PredictorsStreamCursorInput>>;
  where?: InputMaybe<PredictorsBoolExp>;
};


export type SubscriptionPriorityListMembershipsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListMembershipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListMembershipsOrderBy>>;
  where?: InputMaybe<PriorityListMembershipsBoolExp>;
};


export type SubscriptionPriorityListMembershipsByPkArgs = {
  priority_list_id: Scalars['bigint'];
  segment_id: Scalars['bigint'];
};


export type SubscriptionPriorityListMembershipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PriorityListMembershipsStreamCursorInput>>;
  where?: InputMaybe<PriorityListMembershipsBoolExp>;
};


export type SubscriptionPriorityListsArgs = {
  distinct_on?: InputMaybe<Array<PriorityListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListsOrderBy>>;
  where?: InputMaybe<PriorityListsBoolExp>;
};


export type SubscriptionPriorityListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<PriorityListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PriorityListsOrderBy>>;
  where?: InputMaybe<PriorityListsBoolExp>;
};


export type SubscriptionPriorityListsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionPriorityListsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PriorityListsStreamCursorInput>>;
  where?: InputMaybe<PriorityListsBoolExp>;
};


export type SubscriptionPushAppsArgs = {
  distinct_on?: InputMaybe<Array<PushAppsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushAppsOrderBy>>;
  where?: InputMaybe<PushAppsBoolExp>;
};


export type SubscriptionPushAppsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPushAppsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PushAppsStreamCursorInput>>;
  where?: InputMaybe<PushAppsBoolExp>;
};


export type SubscriptionPushConfigArgs = {
  distinct_on?: InputMaybe<Array<PushConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushConfigOrderBy>>;
  where?: InputMaybe<PushConfigBoolExp>;
};


export type SubscriptionPushConfigAggregateArgs = {
  distinct_on?: InputMaybe<Array<PushConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PushConfigOrderBy>>;
  where?: InputMaybe<PushConfigBoolExp>;
};


export type SubscriptionPushConfigByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionPushConfigStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PushConfigStreamCursorInput>>;
  where?: InputMaybe<PushConfigBoolExp>;
};


export type SubscriptionQueryRunsArgs = {
  distinct_on?: InputMaybe<Array<QueryRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<QueryRunsOrderBy>>;
  where?: InputMaybe<QueryRunsBoolExp>;
};


export type SubscriptionQueryRunsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionQueryRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<QueryRunsStreamCursorInput>>;
  where?: InputMaybe<QueryRunsBoolExp>;
};


export type SubscriptionRealtimeAudienceSyncSegmentsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


export type SubscriptionRealtimeAudienceSyncSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncSegmentsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


export type SubscriptionRealtimeAudienceSyncSegmentsByPkArgs = {
  segment_id: Scalars['bigint'];
  sync_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionRealtimeAudienceSyncSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RealtimeAudienceSyncSegmentsStreamCursorInput>>;
  where?: InputMaybe<RealtimeAudienceSyncSegmentsBoolExp>;
};


export type SubscriptionRealtimeAudienceSyncsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudienceSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudienceSyncsOrderBy>>;
  where?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
};


export type SubscriptionRealtimeAudienceSyncsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRealtimeAudienceSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RealtimeAudienceSyncsStreamCursorInput>>;
  where?: InputMaybe<RealtimeAudienceSyncsBoolExp>;
};


export type SubscriptionRealtimeAudiencesScheduledWarehousePullsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesScheduledWarehousePullsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsBoolExp>;
};


export type SubscriptionRealtimeAudiencesScheduledWarehousePullsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RealtimeAudiencesScheduledWarehousePullsStreamCursorInput>>;
  where?: InputMaybe<RealtimeAudiencesScheduledWarehousePullsBoolExp>;
};


export type SubscriptionRealtimeAudiencesWarehousePullRunsArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


export type SubscriptionRealtimeAudiencesWarehousePullRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RealtimeAudiencesWarehousePullRunsOrderBy>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


export type SubscriptionRealtimeAudiencesWarehousePullRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RealtimeAudiencesWarehousePullRunsStreamCursorInput>>;
  where?: InputMaybe<RealtimeAudiencesWarehousePullRunsBoolExp>;
};


export type SubscriptionRelationshipReferencesArgs = {
  distinct_on?: InputMaybe<Array<RelationshipReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipReferencesOrderBy>>;
  where?: InputMaybe<RelationshipReferencesBoolExp>;
};


export type SubscriptionRelationshipReferencesByPkArgs = {
  from_column: Scalars['String'];
  ordinal_number: Scalars['smallint'];
  relationship_id: Scalars['bigint'];
  to_column: Scalars['String'];
};


export type SubscriptionRelationshipReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RelationshipReferencesStreamCursorInput>>;
  where?: InputMaybe<RelationshipReferencesBoolExp>;
};


export type SubscriptionRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<RelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelationshipsOrderBy>>;
  where?: InputMaybe<RelationshipsBoolExp>;
};


export type SubscriptionRelationshipsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRelationshipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RelationshipsStreamCursorInput>>;
  where?: InputMaybe<RelationshipsBoolExp>;
};


export type SubscriptionReportScheduleArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleOrderBy>>;
  where?: InputMaybe<ReportScheduleBoolExp>;
};


export type SubscriptionReportScheduleAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleOrderBy>>;
  where?: InputMaybe<ReportScheduleBoolExp>;
};


export type SubscriptionReportScheduleByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReportScheduleRunCommentsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


export type SubscriptionReportScheduleRunCommentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunCommentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunCommentsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


export type SubscriptionReportScheduleRunCommentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReportScheduleRunCommentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReportScheduleRunCommentsStreamCursorInput>>;
  where?: InputMaybe<ReportScheduleRunCommentsBoolExp>;
};


export type SubscriptionReportScheduleRunsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


export type SubscriptionReportScheduleRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleRunsOrderBy>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


export type SubscriptionReportScheduleRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReportScheduleRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReportScheduleRunsStreamCursorInput>>;
  where?: InputMaybe<ReportScheduleRunsBoolExp>;
};


export type SubscriptionReportScheduleStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReportScheduleStreamCursorInput>>;
  where?: InputMaybe<ReportScheduleBoolExp>;
};


export type SubscriptionReportScheduleVersionsArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


export type SubscriptionReportScheduleVersionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReportScheduleVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReportScheduleVersionsOrderBy>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


export type SubscriptionReportScheduleVersionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReportScheduleVersionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReportScheduleVersionsStreamCursorInput>>;
  where?: InputMaybe<ReportScheduleVersionsBoolExp>;
};


export type SubscriptionResourceInteractionsArgs = {
  distinct_on?: InputMaybe<Array<ResourceInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceInteractionsOrderBy>>;
  where?: InputMaybe<ResourceInteractionsBoolExp>;
};


export type SubscriptionResourceInteractionsByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  user_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionResourceInteractionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceInteractionsStreamCursorInput>>;
  where?: InputMaybe<ResourceInteractionsBoolExp>;
};


export type SubscriptionResourceMonitorConditionsArgs = {
  distinct_on?: InputMaybe<Array<ResourceMonitorConditionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceMonitorConditionsOrderBy>>;
  where?: InputMaybe<ResourceMonitorConditionsBoolExp>;
};


export type SubscriptionResourceMonitorConditionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionResourceMonitorConditionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceMonitorConditionsStreamCursorInput>>;
  where?: InputMaybe<ResourceMonitorConditionsBoolExp>;
};


export type SubscriptionResourceMonitorStatusesArgs = {
  distinct_on?: InputMaybe<Array<ResourceMonitorStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceMonitorStatusesOrderBy>>;
  where?: InputMaybe<ResourceMonitorStatusesBoolExp>;
};


export type SubscriptionResourceMonitorStatusesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionResourceMonitorStatusesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceMonitorStatusesStreamCursorInput>>;
  where?: InputMaybe<ResourceMonitorStatusesBoolExp>;
};


export type SubscriptionResourceNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<ResourceNotificationChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceNotificationChannelsOrderBy>>;
  where?: InputMaybe<ResourceNotificationChannelsBoolExp>;
};


export type SubscriptionResourceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionResourceNotificationChannelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceNotificationChannelsStreamCursorInput>>;
  where?: InputMaybe<ResourceNotificationChannelsBoolExp>;
};


export type SubscriptionResourceTagValuesArgs = {
  distinct_on?: InputMaybe<Array<ResourceTagValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceTagValuesOrderBy>>;
  where?: InputMaybe<ResourceTagValuesBoolExp>;
};


export type SubscriptionResourceTagValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceTagValuesStreamCursorInput>>;
  where?: InputMaybe<ResourceTagValuesBoolExp>;
};


export type SubscriptionResourceToMonitorConditionTypeArgs = {
  distinct_on?: InputMaybe<Array<ResourceToMonitorConditionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceToMonitorConditionTypeOrderBy>>;
  where?: InputMaybe<ResourceToMonitorConditionTypeBoolExp>;
};


export type SubscriptionResourceToMonitorConditionTypeByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionResourceToMonitorConditionTypeStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceToMonitorConditionTypeStreamCursorInput>>;
  where?: InputMaybe<ResourceToMonitorConditionTypeBoolExp>;
};


export type SubscriptionResourceViewsArgs = {
  distinct_on?: InputMaybe<Array<ResourceViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceViewsOrderBy>>;
  where?: InputMaybe<ResourceViewsBoolExp>;
};


export type SubscriptionResourceViewsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionResourceViewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ResourceViewsStreamCursorInput>>;
  where?: InputMaybe<ResourceViewsBoolExp>;
};


export type SubscriptionRetlAndRealtimeSyncsArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


export type SubscriptionRetlAndRealtimeSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RetlAndRealtimeSyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RetlAndRealtimeSyncsOrderBy>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


export type SubscriptionRetlAndRealtimeSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RetlAndRealtimeSyncsStreamCursorInput>>;
  where?: InputMaybe<RetlAndRealtimeSyncsBoolExp>;
};


export type SubscriptionReviewAgentEntitiesArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


export type SubscriptionReviewAgentEntitiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentEntitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentEntitiesOrderBy>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


export type SubscriptionReviewAgentEntitiesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReviewAgentEntitiesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewAgentEntitiesStreamCursorInput>>;
  where?: InputMaybe<ReviewAgentEntitiesBoolExp>;
};


export type SubscriptionReviewAgentsArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentsOrderBy>>;
  where?: InputMaybe<ReviewAgentsBoolExp>;
};


export type SubscriptionReviewAgentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ReviewAgentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ReviewAgentsOrderBy>>;
  where?: InputMaybe<ReviewAgentsBoolExp>;
};


export type SubscriptionReviewAgentsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionReviewAgentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ReviewAgentsStreamCursorInput>>;
  where?: InputMaybe<ReviewAgentsBoolExp>;
};


export type SubscriptionSampleDataSourcesArgs = {
  distinct_on?: InputMaybe<Array<SampleDataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleDataSourcesOrderBy>>;
  where?: InputMaybe<SampleDataSourcesBoolExp>;
};


export type SubscriptionSampleDataSourcesByPkArgs = {
  uuid: Scalars['uuid'];
};


export type SubscriptionSampleDataSourcesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampleDataSourcesStreamCursorInput>>;
  where?: InputMaybe<SampleDataSourcesBoolExp>;
};


export type SubscriptionSampledSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


export type SubscriptionSampledSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SampledSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampledSegmentsOrderBy>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


export type SubscriptionSampledSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSampledSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampledSegmentsStreamCursorInput>>;
  where?: InputMaybe<SampledSegmentsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedAnalyticsChartsCohortsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsCohortsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsCohortsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsCohortsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsCohortsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedAnalyticsChartsCohortsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedAnalyticsChartsCohortsStreamCursorInput>>;
  where?: InputMaybe<SavedAnalyticsChartsCohortsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsFunnelStagesArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsFunnelStagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsFunnelStagesOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsFunnelStagesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedAnalyticsChartsFunnelStagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedAnalyticsChartsFunnelStagesStreamCursorInput>>;
  where?: InputMaybe<SavedAnalyticsChartsFunnelStagesBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedAnalyticsChartsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedAnalyticsChartsGoalsOrderBy>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedAnalyticsChartsGoalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedAnalyticsChartsGoalsStreamCursorInput>>;
  where?: InputMaybe<SavedAnalyticsChartsGoalsBoolExp>;
};


export type SubscriptionSavedAnalyticsChartsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedAnalyticsChartsStreamCursorInput>>;
  where?: InputMaybe<SavedAnalyticsChartsBoolExp>;
};


export type SubscriptionSavedCampaignViewsArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};


export type SubscriptionSavedCampaignViewsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};


export type SubscriptionSavedCampaignViewsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedCampaignViewsGoalsArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


export type SubscriptionSavedCampaignViewsGoalsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedCampaignViewsGoalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedCampaignViewsGoalsOrderBy>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


export type SubscriptionSavedCampaignViewsGoalsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSavedCampaignViewsGoalsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedCampaignViewsGoalsStreamCursorInput>>;
  where?: InputMaybe<SavedCampaignViewsGoalsBoolExp>;
};


export type SubscriptionSavedCampaignViewsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedCampaignViewsStreamCursorInput>>;
  where?: InputMaybe<SavedCampaignViewsBoolExp>;
};


export type SubscriptionSavedMessagesArgs = {
  distinct_on?: InputMaybe<Array<SavedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedMessagesOrderBy>>;
  where?: InputMaybe<SavedMessagesBoolExp>;
};


export type SubscriptionSavedMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SavedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedMessagesOrderBy>>;
  where?: InputMaybe<SavedMessagesBoolExp>;
};


export type SubscriptionSavedMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedMessagesStreamCursorInput>>;
  where?: InputMaybe<SavedMessagesBoolExp>;
};


export type SubscriptionSavedQueriesArgs = {
  distinct_on?: InputMaybe<Array<SavedQueriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SavedQueriesOrderBy>>;
  where?: InputMaybe<SavedQueriesBoolExp>;
};


export type SubscriptionSavedQueriesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSavedQueriesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SavedQueriesStreamCursorInput>>;
  where?: InputMaybe<SavedQueriesBoolExp>;
};


export type SubscriptionSegmentReferencesArgs = {
  distinct_on?: InputMaybe<Array<SegmentReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentReferencesOrderBy>>;
  where?: InputMaybe<SegmentReferencesBoolExp>;
};


export type SubscriptionSegmentReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentReferencesOrderBy>>;
  where?: InputMaybe<SegmentReferencesBoolExp>;
};


export type SubscriptionSegmentReferencesByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  segment_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionSegmentReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SegmentReferencesStreamCursorInput>>;
  where?: InputMaybe<SegmentReferencesBoolExp>;
};


export type SubscriptionSegmentsArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


export type SubscriptionSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SegmentsOrderBy>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


export type SubscriptionSegmentsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SegmentsStreamCursorInput>>;
  where?: InputMaybe<SegmentsBoolExp>;
};


export type SubscriptionSentResourceNotificationsArgs = {
  distinct_on?: InputMaybe<Array<SentResourceNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SentResourceNotificationsOrderBy>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};


export type SubscriptionSentResourceNotificationsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSentResourceNotificationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SentResourceNotificationsStreamCursorInput>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};


export type SubscriptionSigmaCredentialsArgs = {
  distinct_on?: InputMaybe<Array<SigmaCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SigmaCredentialsOrderBy>>;
  where?: InputMaybe<SigmaCredentialsBoolExp>;
};


export type SubscriptionSigmaCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionSigmaCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SigmaCredentialsStreamCursorInput>>;
  where?: InputMaybe<SigmaCredentialsBoolExp>;
};


export type SubscriptionSlackCredentialsArgs = {
  distinct_on?: InputMaybe<Array<SlackCredentialsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SlackCredentialsOrderBy>>;
  where?: InputMaybe<SlackCredentialsBoolExp>;
};


export type SubscriptionSlackCredentialsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionSlackCredentialsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SlackCredentialsStreamCursorInput>>;
  where?: InputMaybe<SlackCredentialsBoolExp>;
};


export type SubscriptionSourceShareMirrorDatabasesArgs = {
  distinct_on?: InputMaybe<Array<SourceShareMirrorDatabasesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SourceShareMirrorDatabasesOrderBy>>;
  where?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
};


export type SubscriptionSourceShareMirrorDatabasesByPkArgs = {
  connection_id: Scalars['bigint'];
  database_name: Scalars['String'];
};


export type SubscriptionSourceShareMirrorDatabasesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SourceShareMirrorDatabasesStreamCursorInput>>;
  where?: InputMaybe<SourceShareMirrorDatabasesBoolExp>;
};


export type SubscriptionSourceShareMirrorsArgs = {
  distinct_on?: InputMaybe<Array<SourceShareMirrorsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SourceShareMirrorsOrderBy>>;
  where?: InputMaybe<SourceShareMirrorsBoolExp>;
};


export type SubscriptionSourceShareMirrorsByPkArgs = {
  connection_id: Scalars['bigint'];
};


export type SubscriptionSourceShareMirrorsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SourceShareMirrorsStreamCursorInput>>;
  where?: InputMaybe<SourceShareMirrorsBoolExp>;
};


export type SubscriptionSpaceSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<SpaceSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSubsetGrantsOrderBy>>;
  where?: InputMaybe<SpaceSubsetGrantsBoolExp>;
};


export type SubscriptionSpaceSubsetGrantsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSpaceSubsetGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SpaceSubsetGrantsStreamCursorInput>>;
  where?: InputMaybe<SpaceSubsetGrantsBoolExp>;
};


export type SubscriptionSpaceSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SpaceSyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSyncTemplatesOrderBy>>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};


export type SubscriptionSpaceSyncTemplatesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSpaceSyncTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SpaceSyncTemplatesStreamCursorInput>>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};


export type SubscriptionSpaceUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SpaceUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceUserGroupsOrderBy>>;
  where?: InputMaybe<SpaceUserGroupsBoolExp>;
};


export type SubscriptionSpaceUserGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSpaceUserGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SpaceUserGroupsStreamCursorInput>>;
  where?: InputMaybe<SpaceUserGroupsBoolExp>;
};


export type SubscriptionSpacesArgs = {
  distinct_on?: InputMaybe<Array<SpacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpacesOrderBy>>;
  where?: InputMaybe<SpacesBoolExp>;
};


export type SubscriptionSpacesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSpacesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SpacesStreamCursorInput>>;
  where?: InputMaybe<SpacesBoolExp>;
};


export type SubscriptionSsoGroupUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupUserGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupUserGroupsBoolExp>;
};


export type SubscriptionSsoGroupUserGroupsByPkArgs = {
  sso_group_id: Scalars['uuid'];
  user_group_id: Scalars['bigint'];
};


export type SubscriptionSsoGroupUserGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SsoGroupUserGroupsStreamCursorInput>>;
  where?: InputMaybe<SsoGroupUserGroupsBoolExp>;
};


export type SubscriptionSsoGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoGroupsOrderBy>>;
  where?: InputMaybe<SsoGroupsBoolExp>;
};


export type SubscriptionSsoGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSsoGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SsoGroupsStreamCursorInput>>;
  where?: InputMaybe<SsoGroupsBoolExp>;
};


export type SubscriptionSsoUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoUserGroupsOrderBy>>;
  where?: InputMaybe<SsoUserGroupsBoolExp>;
};


export type SubscriptionSsoUserGroupsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSsoUserGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SsoUserGroupsStreamCursorInput>>;
  where?: InputMaybe<SsoUserGroupsBoolExp>;
};


export type SubscriptionStaticListsArgs = {
  distinct_on?: InputMaybe<Array<StaticListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaticListsOrderBy>>;
  where?: InputMaybe<StaticListsBoolExp>;
};


export type SubscriptionStaticListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<StaticListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StaticListsOrderBy>>;
  where?: InputMaybe<StaticListsBoolExp>;
};


export type SubscriptionStaticListsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionStaticListsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StaticListsStreamCursorInput>>;
  where?: InputMaybe<StaticListsBoolExp>;
};


export type SubscriptionSupportAccessGrantArgs = {
  distinct_on?: InputMaybe<Array<SupportAccessGrantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SupportAccessGrantOrderBy>>;
  where?: InputMaybe<SupportAccessGrantBoolExp>;
};


export type SubscriptionSupportAccessGrantByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSupportAccessGrantStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SupportAccessGrantStreamCursorInput>>;
  where?: InputMaybe<SupportAccessGrantBoolExp>;
};


export type SubscriptionSyncAlertsArgs = {
  distinct_on?: InputMaybe<Array<SyncAlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAlertsOrderBy>>;
  where?: InputMaybe<SyncAlertsBoolExp>;
};


export type SubscriptionSyncAlertsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncAlertsStreamCursorInput>>;
  where?: InputMaybe<SyncAlertsBoolExp>;
};


export type SubscriptionSyncAttemptsArgs = {
  distinct_on?: InputMaybe<Array<SyncAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAttemptsOrderBy>>;
  where?: InputMaybe<SyncAttemptsBoolExp>;
};


export type SubscriptionSyncAttemptsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSyncAttemptsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncAttemptsStreamCursorInput>>;
  where?: InputMaybe<SyncAttemptsBoolExp>;
};


export type SubscriptionSyncIdrSchedulesArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


export type SubscriptionSyncIdrSchedulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncIdrSchedulesOrderBy>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


export type SubscriptionSyncIdrSchedulesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSyncIdrSchedulesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncIdrSchedulesStreamCursorInput>>;
  where?: InputMaybe<SyncIdrSchedulesBoolExp>;
};


export type SubscriptionSyncRequestComputedProgressArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestComputedProgressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestComputedProgressOrderBy>>;
  where?: InputMaybe<SyncRequestComputedProgressBoolExp>;
};


export type SubscriptionSyncRequestComputedProgressStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncRequestComputedProgressStreamCursorInput>>;
  where?: InputMaybe<SyncRequestComputedProgressBoolExp>;
};


export type SubscriptionSyncRequestDiffsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestDiffsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestDiffsOrderBy>>;
  where?: InputMaybe<SyncRequestDiffsBoolExp>;
};


export type SubscriptionSyncRequestDiffsByPkArgs = {
  sync_request_id: Scalars['bigint'];
};


export type SubscriptionSyncRequestDiffsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncRequestDiffsStreamCursorInput>>;
  where?: InputMaybe<SyncRequestDiffsBoolExp>;
};


export type SubscriptionSyncRequestEventSpansArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestEventSpansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestEventSpansOrderBy>>;
  where?: InputMaybe<SyncRequestEventSpansBoolExp>;
};


export type SubscriptionSyncRequestEventSpansStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncRequestEventSpansStreamCursorInput>>;
  where?: InputMaybe<SyncRequestEventSpansBoolExp>;
};


export type SubscriptionSyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


export type SubscriptionSyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


export type SubscriptionSyncRequestsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionSyncRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncRequestsStreamCursorInput>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


export type SubscriptionSyncSequenceMembersArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceMembersOrderBy>>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};


export type SubscriptionSyncSequenceMembersByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSyncSequenceMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncSequenceMembersStreamCursorInput>>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};


export type SubscriptionSyncSequenceRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRequestsOrderBy>>;
  where?: InputMaybe<SyncSequenceRequestsBoolExp>;
};


export type SubscriptionSyncSequenceRequestsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSyncSequenceRequestsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncSequenceRequestsStreamCursorInput>>;
  where?: InputMaybe<SyncSequenceRequestsBoolExp>;
};


export type SubscriptionSyncSequenceRunsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


export type SubscriptionSyncSequenceRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


export type SubscriptionSyncSequenceRunsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSyncSequenceRunsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncSequenceRunsStreamCursorInput>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


export type SubscriptionSyncSequencesArgs = {
  distinct_on?: InputMaybe<Array<SyncSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequencesOrderBy>>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};


export type SubscriptionSyncSequencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncSequencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequencesOrderBy>>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};


export type SubscriptionSyncSequencesByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSyncSequencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncSequencesStreamCursorInput>>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};


export type SubscriptionSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


export type SubscriptionSyncTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncTemplatesOrderBy>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


export type SubscriptionSyncTemplatesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionSyncTemplatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncTemplatesStreamCursorInput>>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};


export type SubscriptionSyncsArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


export type SubscriptionSyncsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsOrderBy>>;
  where?: InputMaybe<SyncsBoolExp>;
};


export type SubscriptionSyncsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncsStreamCursorInput>>;
  where?: InputMaybe<SyncsBoolExp>;
};


export type SubscriptionSyncsToJourneysArgs = {
  distinct_on?: InputMaybe<Array<SyncsToJourneysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncsToJourneysOrderBy>>;
  where?: InputMaybe<SyncsToJourneysBoolExp>;
};


export type SubscriptionSyncsToJourneysStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SyncsToJourneysStreamCursorInput>>;
  where?: InputMaybe<SyncsToJourneysBoolExp>;
};


export type SubscriptionThroughModelRelationshipsArgs = {
  distinct_on?: InputMaybe<Array<ThroughModelRelationshipsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ThroughModelRelationshipsOrderBy>>;
  where?: InputMaybe<ThroughModelRelationshipsBoolExp>;
};


export type SubscriptionThroughModelRelationshipsByPkArgs = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};


export type SubscriptionThroughModelRelationshipsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ThroughModelRelationshipsStreamCursorInput>>;
  where?: InputMaybe<ThroughModelRelationshipsBoolExp>;
};


export type SubscriptionTopKTraitStatusArgs = {
  distinct_on?: InputMaybe<Array<TopKTraitStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TopKTraitStatusOrderBy>>;
  where?: InputMaybe<TopKTraitStatusBoolExp>;
};


export type SubscriptionTopKTraitStatusByPkArgs = {
  trait_id: Scalars['uuid'];
};


export type SubscriptionTopKTraitStatusStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TopKTraitStatusStreamCursorInput>>;
  where?: InputMaybe<TopKTraitStatusBoolExp>;
};


export type SubscriptionTrackedAudienceListAudiencesArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListAudiencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListAudiencesOrderBy>>;
  where?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
};


export type SubscriptionTrackedAudienceListAudiencesByPkArgs = {
  audience_id: Scalars['bigint'];
  list_id: Scalars['uuid'];
};


export type SubscriptionTrackedAudienceListAudiencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TrackedAudienceListAudiencesStreamCursorInput>>;
  where?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
};


export type SubscriptionTrackedAudienceListsArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


export type SubscriptionTrackedAudienceListsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


export type SubscriptionTrackedAudienceListsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionTrackedAudienceListsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TrackedAudienceListsStreamCursorInput>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


export type SubscriptionTraitDefinitionsArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


export type SubscriptionTraitDefinitionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


export type SubscriptionTraitDefinitionsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionTraitDefinitionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TraitDefinitionsStreamCursorInput>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


export type SubscriptionTraitReferencesArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesOrderBy>>;
  where?: InputMaybe<TraitReferencesBoolExp>;
};


export type SubscriptionTraitReferencesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesOrderBy>>;
  where?: InputMaybe<TraitReferencesBoolExp>;
};


export type SubscriptionTraitReferencesByPkArgs = {
  resource_id: Scalars['String'];
  resource_type: Scalars['String'];
  trait_definition_id: Scalars['uuid'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionTraitReferencesSegmentsArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesSegmentsOrderBy>>;
  where?: InputMaybe<TraitReferencesSegmentsBoolExp>;
};


export type SubscriptionTraitReferencesSegmentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitReferencesSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitReferencesSegmentsOrderBy>>;
  where?: InputMaybe<TraitReferencesSegmentsBoolExp>;
};


export type SubscriptionTraitReferencesSegmentsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TraitReferencesSegmentsStreamCursorInput>>;
  where?: InputMaybe<TraitReferencesSegmentsBoolExp>;
};


export type SubscriptionTraitReferencesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TraitReferencesStreamCursorInput>>;
  where?: InputMaybe<TraitReferencesBoolExp>;
};


export type SubscriptionTunnelsArgs = {
  distinct_on?: InputMaybe<Array<TunnelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelsOrderBy>>;
  where?: InputMaybe<TunnelsBoolExp>;
};


export type SubscriptionTunnelsByPkArgs = {
  tunnel_id: Scalars['uuid'];
};


export type SubscriptionTunnelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TunnelsStreamCursorInput>>;
  where?: InputMaybe<TunnelsBoolExp>;
};


export type SubscriptionUserGroupAudienceCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupAudienceCreationAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupAudienceCreationAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupGrantsOrderBy>>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};


export type SubscriptionUserGroupGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupGrantsOrderBy>>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};


export type SubscriptionUserGroupGrantsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionUserGroupGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupGrantsStreamCursorInput>>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};


export type SubscriptionUserGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<UserGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupMembersOrderBy>>;
  where?: InputMaybe<UserGroupMembersBoolExp>;
};


export type SubscriptionUserGroupMembersByPkArgs = {
  user_group_id: Scalars['bigint'];
  user_id: Scalars['bigint'];
};


export type SubscriptionUserGroupMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupMembersStreamCursorInput>>;
  where?: InputMaybe<UserGroupMembersBoolExp>;
};


export type SubscriptionUserGroupModelAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupModelAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupModelAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
};


export type SubscriptionUserGroupModelAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupModelAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
};


export type SubscriptionUserGroupModelCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupModelCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupModelCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupModelCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupModelCreationAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupModelCreationAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupModelCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupSourceGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSourceGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSourceGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSourceGrantsBoolExp>;
};


export type SubscriptionUserGroupSourceGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupSourceGrantsStreamCursorInput>>;
  where?: InputMaybe<UserGroupSourceGrantsBoolExp>;
};


export type SubscriptionUserGroupSubsetAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
};


export type SubscriptionUserGroupSubsetAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupSubsetAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
};


export type SubscriptionUserGroupSubsetGrantsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


export type SubscriptionUserGroupSubsetGrantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSubsetGrantsOrderBy>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


export type SubscriptionUserGroupSubsetGrantsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionUserGroupSubsetGrantsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupSubsetGrantsStreamCursorInput>>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};


export type SubscriptionUserGroupSyncCreationAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupSyncCreationAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupSyncCreationAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupSyncCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupSyncCreationAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupSyncCreationAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupSyncCreationAuthorizationBoolExp>;
};


export type SubscriptionUserGroupTraitAuthorizationArgs = {
  distinct_on?: InputMaybe<Array<UserGroupTraitAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupTraitAuthorizationOrderBy>>;
  where?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
};


export type SubscriptionUserGroupTraitAuthorizationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupTraitAuthorizationStreamCursorInput>>;
  where?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
};


export type SubscriptionUserGroupWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


export type SubscriptionUserGroupWorkspacesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


export type SubscriptionUserGroupWorkspacesByPkArgs = {
  user_group_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


export type SubscriptionUserGroupWorkspacesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupWorkspacesStreamCursorInput>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


export type SubscriptionUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type SubscriptionUserGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type SubscriptionUserGroupsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionUserGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserGroupsStreamCursorInput>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type SubscriptionVideoExportsArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


export type SubscriptionVideoExportsAggregateArgs = {
  distinct_on?: InputMaybe<Array<VideoExportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<VideoExportsOrderBy>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


export type SubscriptionVideoExportsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionVideoExportsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<VideoExportsStreamCursorInput>>;
  where?: InputMaybe<VideoExportsBoolExp>;
};


export type SubscriptionWarehouseSnapshotsArgs = {
  distinct_on?: InputMaybe<Array<WarehouseSnapshotsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WarehouseSnapshotsOrderBy>>;
  where?: InputMaybe<WarehouseSnapshotsBoolExp>;
};


export type SubscriptionWarehouseSnapshotsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionWarehouseSnapshotsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WarehouseSnapshotsStreamCursorInput>>;
  where?: InputMaybe<WarehouseSnapshotsBoolExp>;
};


export type SubscriptionWorkspaceMembersArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


export type SubscriptionWorkspaceMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


export type SubscriptionWorkspaceMembersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkspaceMembersStreamCursorInput>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


export type SubscriptionWorkspaceNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceNotificationChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceNotificationChannelsOrderBy>>;
  where?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};


export type SubscriptionWorkspaceNotificationChannelsByPkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionWorkspaceNotificationChannelsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkspaceNotificationChannelsStreamCursorInput>>;
  where?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};


export type SubscriptionWorkspaceOverageDatesArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceOverageDatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceOverageDatesOrderBy>>;
  where?: InputMaybe<WorkspaceOverageDatesBoolExp>;
};


export type SubscriptionWorkspaceOverageDatesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkspaceOverageDatesStreamCursorInput>>;
  where?: InputMaybe<WorkspaceOverageDatesBoolExp>;
};


export type SubscriptionWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<WorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspacesOrderBy>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};


export type SubscriptionWorkspacesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionWorkspacesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<WorkspacesStreamCursorInput>>;
  where?: InputMaybe<WorkspacesBoolExp>;
};

/** columns and relationships of "support_access_grant" */
export type SupportAccessGrant = {
  __typename?: 'support_access_grant';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  expires_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['bigint'];
  revoked_at?: Maybe<Scalars['timestamptz']>;
  revoked_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "support_access_grant". All fields are combined with a logical 'AND'. */
export type SupportAccessGrantBoolExp = {
  _and?: InputMaybe<Array<SupportAccessGrantBoolExp>>;
  _not?: InputMaybe<SupportAccessGrantBoolExp>;
  _or?: InputMaybe<Array<SupportAccessGrantBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  expires_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  revoked_at?: InputMaybe<TimestamptzComparisonExp>;
  revoked_by?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "support_access_grant" */
export const SupportAccessGrantConstraint = {
  /** unique or primary key constraint on columns "id" */
  SupportAccessGrantPkey: 'support_access_grant_pkey'
} as const;

export type SupportAccessGrantConstraint = typeof SupportAccessGrantConstraint[keyof typeof SupportAccessGrantConstraint];
/** input type for inserting data into table "support_access_grant" */
export type SupportAccessGrantInsertInput = {
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** response of any mutation on the table "support_access_grant" */
export type SupportAccessGrantMutationResponse = {
  __typename?: 'support_access_grant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SupportAccessGrant>;
};

/** on_conflict condition type for table "support_access_grant" */
export type SupportAccessGrantOnConflict = {
  constraint: SupportAccessGrantConstraint;
  update_columns?: Array<SupportAccessGrantUpdateColumn>;
  where?: InputMaybe<SupportAccessGrantBoolExp>;
};

/** Ordering options when selecting data from "support_access_grant". */
export type SupportAccessGrantOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  expires_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  revoked_at?: InputMaybe<OrderBy>;
  revoked_by?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: support_access_grant */
export type SupportAccessGrantPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "support_access_grant" */
export const SupportAccessGrantSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ExpiresAt: 'expires_at',
  /** column name */
  Id: 'id',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  RevokedAt: 'revoked_at',
  /** column name */
  RevokedBy: 'revoked_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SupportAccessGrantSelectColumn = typeof SupportAccessGrantSelectColumn[keyof typeof SupportAccessGrantSelectColumn];
/** Streaming cursor of the table "support_access_grant" */
export type SupportAccessGrantStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SupportAccessGrantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SupportAccessGrantStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  expires_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']>;
  revoked_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** placeholder for update columns of table "support_access_grant" (current role has no relevant permissions) */
export const SupportAccessGrantUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type SupportAccessGrantUpdateColumn = typeof SupportAccessGrantUpdateColumn[keyof typeof SupportAccessGrantUpdateColumn];
export type SupportAccessGrantUpdates = {
  /** filter the rows which have to be updated */
  where: SupportAccessGrantBoolExp;
};

/** columns and relationships of "sync_alerts" */
export type SyncAlerts = {
  __typename?: 'sync_alerts';
  alert_interval?: Maybe<Scalars['bigint']>;
  alert_on_success?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  alert_status?: Maybe<AlertStatuses>;
  config?: Maybe<Scalars['jsonb']>;
  fatal_error?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['name']>;
  /** An object relationship */
  pagerduty_credential?: Maybe<PagerdutyCredentials>;
  pagerduty_credential_id?: Maybe<Scalars['bigint']>;
  row_error?: Maybe<Scalars['Boolean']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  slack_credential?: Maybe<SlackCredentials>;
  slack_credential_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync?: Maybe<Syncs>;
  sync_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sync_alerts" */
export type SyncAlertsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_alerts" */
export type SyncAlertsAggregateOrderBy = {
  avg?: InputMaybe<SyncAlertsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncAlertsMaxOrderBy>;
  min?: InputMaybe<SyncAlertsMinOrderBy>;
  stddev?: InputMaybe<SyncAlertsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncAlertsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncAlertsStddevSampOrderBy>;
  sum?: InputMaybe<SyncAlertsSumOrderBy>;
  var_pop?: InputMaybe<SyncAlertsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncAlertsVarSampOrderBy>;
  variance?: InputMaybe<SyncAlertsVarianceOrderBy>;
};

/** order by avg() on columns of table "sync_alerts" */
export type SyncAlertsAvgOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_alerts". All fields are combined with a logical 'AND'. */
export type SyncAlertsBoolExp = {
  _and?: InputMaybe<Array<SyncAlertsBoolExp>>;
  _not?: InputMaybe<SyncAlertsBoolExp>;
  _or?: InputMaybe<Array<SyncAlertsBoolExp>>;
  alert_interval?: InputMaybe<BigintComparisonExp>;
  alert_on_success?: InputMaybe<BooleanComparisonExp>;
  alert_status?: InputMaybe<AlertStatusesBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  fatal_error?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<NameComparisonExp>;
  pagerduty_credential?: InputMaybe<PagerdutyCredentialsBoolExp>;
  pagerduty_credential_id?: InputMaybe<BigintComparisonExp>;
  row_error?: InputMaybe<BooleanComparisonExp>;
  row_threshold_attempted?: InputMaybe<BigintComparisonExp>;
  row_threshold_total?: InputMaybe<BigintComparisonExp>;
  slack_credential?: InputMaybe<SlackCredentialsBoolExp>;
  slack_credential_id?: InputMaybe<BigintComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "sync_alerts" */
export type SyncAlertsMaxOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sync_alerts" */
export type SyncAlertsMinOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_alerts". */
export type SyncAlertsOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  alert_on_success?: InputMaybe<OrderBy>;
  alert_status?: InputMaybe<AlertStatusesOrderBy>;
  config?: InputMaybe<OrderBy>;
  fatal_error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pagerduty_credential?: InputMaybe<PagerdutyCredentialsOrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_error?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential?: InputMaybe<SlackCredentialsOrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_alerts" */
export const SyncAlertsSelectColumn = {
  /** column name */
  AlertInterval: 'alert_interval',
  /** column name */
  AlertOnSuccess: 'alert_on_success',
  /** column name */
  Config: 'config',
  /** column name */
  FatalError: 'fatal_error',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  PagerdutyCredentialId: 'pagerduty_credential_id',
  /** column name */
  RowError: 'row_error',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  SlackCredentialId: 'slack_credential_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  Type: 'type',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncAlertsSelectColumn = typeof SyncAlertsSelectColumn[keyof typeof SyncAlertsSelectColumn];
/** order by stddev() on columns of table "sync_alerts" */
export type SyncAlertsStddevOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_alerts" */
export type SyncAlertsStddevPopOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_alerts" */
export type SyncAlertsStddevSampOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_alerts" */
export type SyncAlertsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncAlertsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncAlertsStreamCursorValueInput = {
  alert_interval?: InputMaybe<Scalars['bigint']>;
  alert_on_success?: InputMaybe<Scalars['Boolean']>;
  config?: InputMaybe<Scalars['jsonb']>;
  fatal_error?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['name']>;
  pagerduty_credential_id?: InputMaybe<Scalars['bigint']>;
  row_error?: InputMaybe<Scalars['Boolean']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  slack_credential_id?: InputMaybe<Scalars['bigint']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_alerts" */
export type SyncAlertsSumOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "sync_alerts" */
export type SyncAlertsVarPopOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_alerts" */
export type SyncAlertsVarSampOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sync_alerts" */
export type SyncAlertsVarianceOrderBy = {
  alert_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  pagerduty_credential_id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  slack_credential_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_attempts" */
export type SyncAttempts = {
  __typename?: 'sync_attempts';
  add_attempted_count?: Maybe<Scalars['bigint']>;
  add_checkpoint: Scalars['Int'];
  add_rejected?: Maybe<Scalars['Int']>;
  add_rejected_count?: Maybe<Scalars['bigint']>;
  change_attempted_count?: Maybe<Scalars['bigint']>;
  change_checkpoint: Scalars['Int'];
  change_rejected?: Maybe<Scalars['Int']>;
  change_rejected_count?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  details?: Maybe<Scalars['jsonb']>;
  error?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  remove_attempted_count?: Maybe<Scalars['bigint']>;
  remove_checkpoint: Scalars['Int'];
  remove_rejected?: Maybe<Scalars['Int']>;
  remove_rejected_count?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  /** calculates the amount of successful operations for a given sync attempt */
  successful_operations_count?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sync_request?: Maybe<SyncRequests>;
  sync_request_id: Scalars['bigint'];
};


/** columns and relationships of "sync_attempts" */
export type SyncAttemptsDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_attempts" */
export type SyncAttemptsAggregateOrderBy = {
  avg?: InputMaybe<SyncAttemptsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncAttemptsMaxOrderBy>;
  min?: InputMaybe<SyncAttemptsMinOrderBy>;
  stddev?: InputMaybe<SyncAttemptsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncAttemptsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncAttemptsStddevSampOrderBy>;
  sum?: InputMaybe<SyncAttemptsSumOrderBy>;
  var_pop?: InputMaybe<SyncAttemptsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncAttemptsVarSampOrderBy>;
  variance?: InputMaybe<SyncAttemptsVarianceOrderBy>;
};

/** order by avg() on columns of table "sync_attempts" */
export type SyncAttemptsAvgOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_attempts". All fields are combined with a logical 'AND'. */
export type SyncAttemptsBoolExp = {
  _and?: InputMaybe<Array<SyncAttemptsBoolExp>>;
  _not?: InputMaybe<SyncAttemptsBoolExp>;
  _or?: InputMaybe<Array<SyncAttemptsBoolExp>>;
  add_attempted_count?: InputMaybe<BigintComparisonExp>;
  add_checkpoint?: InputMaybe<IntComparisonExp>;
  add_rejected?: InputMaybe<IntComparisonExp>;
  add_rejected_count?: InputMaybe<BigintComparisonExp>;
  change_attempted_count?: InputMaybe<BigintComparisonExp>;
  change_checkpoint?: InputMaybe<IntComparisonExp>;
  change_rejected?: InputMaybe<IntComparisonExp>;
  change_rejected_count?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  details?: InputMaybe<JsonbComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  remove_attempted_count?: InputMaybe<BigintComparisonExp>;
  remove_checkpoint?: InputMaybe<IntComparisonExp>;
  remove_rejected?: InputMaybe<IntComparisonExp>;
  remove_rejected_count?: InputMaybe<BigintComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  successful_operations_count?: InputMaybe<IntComparisonExp>;
  sync_request?: InputMaybe<SyncRequestsBoolExp>;
  sync_request_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "sync_attempts" */
export type SyncAttemptsMaxOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sync_attempts" */
export type SyncAttemptsMinOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_attempts". */
export type SyncAttemptsOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  details?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  successful_operations_count?: InputMaybe<OrderBy>;
  sync_request?: InputMaybe<SyncRequestsOrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_attempts" */
export const SyncAttemptsSelectColumn = {
  /** column name */
  AddAttemptedCount: 'add_attempted_count',
  /** column name */
  AddCheckpoint: 'add_checkpoint',
  /** column name */
  AddRejected: 'add_rejected',
  /** column name */
  AddRejectedCount: 'add_rejected_count',
  /** column name */
  ChangeAttemptedCount: 'change_attempted_count',
  /** column name */
  ChangeCheckpoint: 'change_checkpoint',
  /** column name */
  ChangeRejected: 'change_rejected',
  /** column name */
  ChangeRejectedCount: 'change_rejected_count',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Details: 'details',
  /** column name */
  Error: 'error',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  Id: 'id',
  /** column name */
  RemoveAttemptedCount: 'remove_attempted_count',
  /** column name */
  RemoveCheckpoint: 'remove_checkpoint',
  /** column name */
  RemoveRejected: 'remove_rejected',
  /** column name */
  RemoveRejectedCount: 'remove_rejected_count',
  /** column name */
  Status: 'status',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncAttemptsSelectColumn = typeof SyncAttemptsSelectColumn[keyof typeof SyncAttemptsSelectColumn];
/** order by stddev() on columns of table "sync_attempts" */
export type SyncAttemptsStddevOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_attempts" */
export type SyncAttemptsStddevPopOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_attempts" */
export type SyncAttemptsStddevSampOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_attempts" */
export type SyncAttemptsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncAttemptsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncAttemptsStreamCursorValueInput = {
  add_attempted_count?: InputMaybe<Scalars['bigint']>;
  add_checkpoint?: InputMaybe<Scalars['Int']>;
  add_rejected?: InputMaybe<Scalars['Int']>;
  add_rejected_count?: InputMaybe<Scalars['bigint']>;
  change_attempted_count?: InputMaybe<Scalars['bigint']>;
  change_checkpoint?: InputMaybe<Scalars['Int']>;
  change_rejected?: InputMaybe<Scalars['Int']>;
  change_rejected_count?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  details?: InputMaybe<Scalars['jsonb']>;
  error?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  remove_attempted_count?: InputMaybe<Scalars['bigint']>;
  remove_checkpoint?: InputMaybe<Scalars['Int']>;
  remove_rejected?: InputMaybe<Scalars['Int']>;
  remove_rejected_count?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  sync_request_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_attempts" */
export type SyncAttemptsSumOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "sync_attempts" */
export type SyncAttemptsVarPopOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_attempts" */
export type SyncAttemptsVarSampOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sync_attempts" */
export type SyncAttemptsVarianceOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_checkpoint?: InputMaybe<OrderBy>;
  add_rejected?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_checkpoint?: InputMaybe<OrderBy>;
  change_rejected?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_checkpoint?: InputMaybe<OrderBy>;
  remove_rejected?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_idr_schedules" */
export type SyncIdrSchedules = {
  __typename?: 'sync_idr_schedules';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  destination_instance_id: Scalars['bigint'];
  id: Scalars['uuid'];
  /** An object relationship */
  idr?: Maybe<Idr>;
  idr_id: Scalars['uuid'];
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "sync_idr_schedules" */
export type SyncIdrSchedulesAggregate = {
  __typename?: 'sync_idr_schedules_aggregate';
  aggregate?: Maybe<SyncIdrSchedulesAggregateFields>;
  nodes: Array<SyncIdrSchedules>;
};

export type SyncIdrSchedulesAggregateBoolExp = {
  count?: InputMaybe<SyncIdrSchedulesAggregateBoolExpCount>;
};

export type SyncIdrSchedulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncIdrSchedulesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "sync_idr_schedules" */
export type SyncIdrSchedulesAggregateFields = {
  __typename?: 'sync_idr_schedules_aggregate_fields';
  avg?: Maybe<SyncIdrSchedulesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncIdrSchedulesMaxFields>;
  min?: Maybe<SyncIdrSchedulesMinFields>;
  stddev?: Maybe<SyncIdrSchedulesStddevFields>;
  stddev_pop?: Maybe<SyncIdrSchedulesStddevPopFields>;
  stddev_samp?: Maybe<SyncIdrSchedulesStddevSampFields>;
  sum?: Maybe<SyncIdrSchedulesSumFields>;
  var_pop?: Maybe<SyncIdrSchedulesVarPopFields>;
  var_samp?: Maybe<SyncIdrSchedulesVarSampFields>;
  variance?: Maybe<SyncIdrSchedulesVarianceFields>;
};


/** aggregate fields of "sync_idr_schedules" */
export type SyncIdrSchedulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncIdrSchedulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sync_idr_schedules" */
export type SyncIdrSchedulesAggregateOrderBy = {
  avg?: InputMaybe<SyncIdrSchedulesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncIdrSchedulesMaxOrderBy>;
  min?: InputMaybe<SyncIdrSchedulesMinOrderBy>;
  stddev?: InputMaybe<SyncIdrSchedulesStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncIdrSchedulesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncIdrSchedulesStddevSampOrderBy>;
  sum?: InputMaybe<SyncIdrSchedulesSumOrderBy>;
  var_pop?: InputMaybe<SyncIdrSchedulesVarPopOrderBy>;
  var_samp?: InputMaybe<SyncIdrSchedulesVarSampOrderBy>;
  variance?: InputMaybe<SyncIdrSchedulesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncIdrSchedulesAvgFields = {
  __typename?: 'sync_idr_schedules_avg_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesAvgOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_idr_schedules". All fields are combined with a logical 'AND'. */
export type SyncIdrSchedulesBoolExp = {
  _and?: InputMaybe<Array<SyncIdrSchedulesBoolExp>>;
  _not?: InputMaybe<SyncIdrSchedulesBoolExp>;
  _or?: InputMaybe<Array<SyncIdrSchedulesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idr?: InputMaybe<IdrBoolExp>;
  idr_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SyncIdrSchedulesMaxFields = {
  __typename?: 'sync_idr_schedules_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncIdrSchedulesMinFields = {
  __typename?: 'sync_idr_schedules_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  idr_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_idr_schedules". */
export type SyncIdrSchedulesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  idr?: InputMaybe<IdrOrderBy>;
  idr_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_idr_schedules" */
export const SyncIdrSchedulesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  Id: 'id',
  /** column name */
  IdrId: 'idr_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncIdrSchedulesSelectColumn = typeof SyncIdrSchedulesSelectColumn[keyof typeof SyncIdrSchedulesSelectColumn];
/** aggregate stddev on columns */
export type SyncIdrSchedulesStddevFields = {
  __typename?: 'sync_idr_schedules_stddev_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesStddevOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncIdrSchedulesStddevPopFields = {
  __typename?: 'sync_idr_schedules_stddev_pop_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesStddevPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncIdrSchedulesStddevSampFields = {
  __typename?: 'sync_idr_schedules_stddev_samp_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesStddevSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_idr_schedules" */
export type SyncIdrSchedulesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncIdrSchedulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncIdrSchedulesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  idr_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SyncIdrSchedulesSumFields = {
  __typename?: 'sync_idr_schedules_sum_fields';
  destination_instance_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesSumOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type SyncIdrSchedulesVarPopFields = {
  __typename?: 'sync_idr_schedules_var_pop_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesVarPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncIdrSchedulesVarSampFields = {
  __typename?: 'sync_idr_schedules_var_samp_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesVarSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncIdrSchedulesVarianceFields = {
  __typename?: 'sync_idr_schedules_variance_fields';
  destination_instance_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sync_idr_schedules" */
export type SyncIdrSchedulesVarianceOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_request_computed_progress" */
export type SyncRequestComputedProgress = {
  __typename?: 'sync_request_computed_progress';
  add_attempted_count?: Maybe<Scalars['bigint']>;
  add_rejected_count?: Maybe<Scalars['bigint']>;
  change_attempted_count?: Maybe<Scalars['bigint']>;
  change_rejected_count?: Maybe<Scalars['bigint']>;
  remove_attempted_count?: Maybe<Scalars['bigint']>;
  remove_rejected_count?: Maybe<Scalars['bigint']>;
  sync_attempt_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync_request?: Maybe<SyncRequests>;
  sync_request_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "sync_request_computed_progress". All fields are combined with a logical 'AND'. */
export type SyncRequestComputedProgressBoolExp = {
  _and?: InputMaybe<Array<SyncRequestComputedProgressBoolExp>>;
  _not?: InputMaybe<SyncRequestComputedProgressBoolExp>;
  _or?: InputMaybe<Array<SyncRequestComputedProgressBoolExp>>;
  add_attempted_count?: InputMaybe<BigintComparisonExp>;
  add_rejected_count?: InputMaybe<BigintComparisonExp>;
  change_attempted_count?: InputMaybe<BigintComparisonExp>;
  change_rejected_count?: InputMaybe<BigintComparisonExp>;
  remove_attempted_count?: InputMaybe<BigintComparisonExp>;
  remove_rejected_count?: InputMaybe<BigintComparisonExp>;
  sync_attempt_id?: InputMaybe<BigintComparisonExp>;
  sync_request?: InputMaybe<SyncRequestsBoolExp>;
  sync_request_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "sync_request_computed_progress". */
export type SyncRequestComputedProgressOrderBy = {
  add_attempted_count?: InputMaybe<OrderBy>;
  add_rejected_count?: InputMaybe<OrderBy>;
  change_attempted_count?: InputMaybe<OrderBy>;
  change_rejected_count?: InputMaybe<OrderBy>;
  remove_attempted_count?: InputMaybe<OrderBy>;
  remove_rejected_count?: InputMaybe<OrderBy>;
  sync_attempt_id?: InputMaybe<OrderBy>;
  sync_request?: InputMaybe<SyncRequestsOrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_request_computed_progress" */
export const SyncRequestComputedProgressSelectColumn = {
  /** column name */
  AddAttemptedCount: 'add_attempted_count',
  /** column name */
  AddRejectedCount: 'add_rejected_count',
  /** column name */
  ChangeAttemptedCount: 'change_attempted_count',
  /** column name */
  ChangeRejectedCount: 'change_rejected_count',
  /** column name */
  RemoveAttemptedCount: 'remove_attempted_count',
  /** column name */
  RemoveRejectedCount: 'remove_rejected_count',
  /** column name */
  SyncAttemptId: 'sync_attempt_id',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncRequestComputedProgressSelectColumn = typeof SyncRequestComputedProgressSelectColumn[keyof typeof SyncRequestComputedProgressSelectColumn];
/** Streaming cursor of the table "sync_request_computed_progress" */
export type SyncRequestComputedProgressStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncRequestComputedProgressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncRequestComputedProgressStreamCursorValueInput = {
  add_attempted_count?: InputMaybe<Scalars['bigint']>;
  add_rejected_count?: InputMaybe<Scalars['bigint']>;
  change_attempted_count?: InputMaybe<Scalars['bigint']>;
  change_rejected_count?: InputMaybe<Scalars['bigint']>;
  remove_attempted_count?: InputMaybe<Scalars['bigint']>;
  remove_rejected_count?: InputMaybe<Scalars['bigint']>;
  sync_attempt_id?: InputMaybe<Scalars['bigint']>;
  sync_request_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "sync_request_diffs" */
export type SyncRequestDiffs = {
  __typename?: 'sync_request_diffs';
  added_count: Scalars['Int'];
  changed_count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  removed_count: Scalars['Int'];
  /** An object relationship */
  sync_request?: Maybe<SyncRequests>;
  sync_request_id: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "sync_request_diffs". All fields are combined with a logical 'AND'. */
export type SyncRequestDiffsBoolExp = {
  _and?: InputMaybe<Array<SyncRequestDiffsBoolExp>>;
  _not?: InputMaybe<SyncRequestDiffsBoolExp>;
  _or?: InputMaybe<Array<SyncRequestDiffsBoolExp>>;
  added_count?: InputMaybe<IntComparisonExp>;
  changed_count?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  removed_count?: InputMaybe<IntComparisonExp>;
  sync_request?: InputMaybe<SyncRequestsBoolExp>;
  sync_request_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "sync_request_diffs". */
export type SyncRequestDiffsOrderBy = {
  added_count?: InputMaybe<OrderBy>;
  changed_count?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  removed_count?: InputMaybe<OrderBy>;
  sync_request?: InputMaybe<SyncRequestsOrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_request_diffs" */
export const SyncRequestDiffsSelectColumn = {
  /** column name */
  AddedCount: 'added_count',
  /** column name */
  ChangedCount: 'changed_count',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  RemovedCount: 'removed_count',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncRequestDiffsSelectColumn = typeof SyncRequestDiffsSelectColumn[keyof typeof SyncRequestDiffsSelectColumn];
/** Streaming cursor of the table "sync_request_diffs" */
export type SyncRequestDiffsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncRequestDiffsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncRequestDiffsStreamCursorValueInput = {
  added_count?: InputMaybe<Scalars['Int']>;
  changed_count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  removed_count?: InputMaybe<Scalars['Int']>;
  sync_request_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "sync_request_event_spans" */
export type SyncRequestEventSpans = {
  __typename?: 'sync_request_event_spans';
  closing_span_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['String']>;
  error_details?: Maybe<Scalars['jsonb']>;
  event_type: Scalars['String'];
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  parent?: Maybe<SyncRequestEventSpans>;
  parent_id?: Maybe<Scalars['uuid']>;
  span_name: Scalars['String'];
  /** An object relationship */
  sync_request?: Maybe<SyncRequests>;
  sync_request_id: Scalars['bigint'];
};


/** columns and relationships of "sync_request_event_spans" */
export type SyncRequestEventSpansErrorDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_request_event_spans" */
export type SyncRequestEventSpansMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "sync_request_event_spans". All fields are combined with a logical 'AND'. */
export type SyncRequestEventSpansBoolExp = {
  _and?: InputMaybe<Array<SyncRequestEventSpansBoolExp>>;
  _not?: InputMaybe<SyncRequestEventSpansBoolExp>;
  _or?: InputMaybe<Array<SyncRequestEventSpansBoolExp>>;
  closing_span_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  error?: InputMaybe<StringComparisonExp>;
  error_details?: InputMaybe<JsonbComparisonExp>;
  event_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  parent?: InputMaybe<SyncRequestEventSpansBoolExp>;
  parent_id?: InputMaybe<UuidComparisonExp>;
  span_name?: InputMaybe<StringComparisonExp>;
  sync_request?: InputMaybe<SyncRequestsBoolExp>;
  sync_request_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "sync_request_event_spans". */
export type SyncRequestEventSpansOrderBy = {
  closing_span_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  error_details?: InputMaybe<OrderBy>;
  event_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  parent?: InputMaybe<SyncRequestEventSpansOrderBy>;
  parent_id?: InputMaybe<OrderBy>;
  span_name?: InputMaybe<OrderBy>;
  sync_request?: InputMaybe<SyncRequestsOrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
};

/** select columns of table "sync_request_event_spans" */
export const SyncRequestEventSpansSelectColumn = {
  /** column name */
  ClosingSpanId: 'closing_span_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Error: 'error',
  /** column name */
  ErrorDetails: 'error_details',
  /** column name */
  EventType: 'event_type',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ParentId: 'parent_id',
  /** column name */
  SpanName: 'span_name',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncRequestEventSpansSelectColumn = typeof SyncRequestEventSpansSelectColumn[keyof typeof SyncRequestEventSpansSelectColumn];
/** Streaming cursor of the table "sync_request_event_spans" */
export type SyncRequestEventSpansStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncRequestEventSpansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncRequestEventSpansStreamCursorValueInput = {
  closing_span_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['String']>;
  error_details?: InputMaybe<Scalars['jsonb']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  parent_id?: InputMaybe<Scalars['uuid']>;
  span_name?: InputMaybe<Scalars['String']>;
  sync_request_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "sync_requests" */
export type SyncRequests = {
  __typename?: 'sync_requests';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  archive_query_results?: Maybe<Scalars['Boolean']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  computed_progress?: Maybe<SyncRequestComputedProgress>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  destination_instance?: Maybe<DestinationInstances>;
  destination_instance_id: Scalars['bigint'];
  diff_mode?: Maybe<Scalars['String']>;
  diff_mode_override?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['jsonb']>;
  error_code_detail?: Maybe<Scalars['JSONObject']>;
  extended_status?: Maybe<Scalars['jsonb']>;
  external_segment_id?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  full_resync?: Maybe<Scalars['Boolean']>;
  id: Scalars['bigint'];
  output_files?: Maybe<Scalars['jsonb']>;
  phase_to_status?: Maybe<Scalars['jsonb']>;
  planner_type?: Maybe<Scalars['String']>;
  previous_query_run_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  previous_sync_request?: Maybe<SyncRequests>;
  /** An object relationship */
  query_run?: Maybe<QueryRuns>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['bigint']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  resync_reason?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** Generate a useful, user-facing status for the sync request */
  status_computed?: Maybe<Scalars['String']>;
  /** An object relationship */
  sync?: Maybe<Syncs>;
  /** An array relationship */
  sync_attempts: Array<SyncAttempts>;
  sync_behavior?: Maybe<Scalars['jsonb']>;
  sync_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sync_request_diff?: Maybe<SyncRequestDiffs>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
  trigger_cancel?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsExtendedStatusArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsOutputFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsPhaseToStatusArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsSyncAttemptsArgs = {
  distinct_on?: InputMaybe<Array<SyncAttemptsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAttemptsOrderBy>>;
  where?: InputMaybe<SyncAttemptsBoolExp>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsSyncBehaviorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_requests" */
export type SyncRequestsSyncConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sync_requests" */
export type SyncRequestsAggregate = {
  __typename?: 'sync_requests_aggregate';
  aggregate?: Maybe<SyncRequestsAggregateFields>;
  nodes: Array<SyncRequests>;
};

export type SyncRequestsAggregateBoolExp = {
  bool_and?: InputMaybe<SyncRequestsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SyncRequestsAggregateBoolExpBoolOr>;
  count?: InputMaybe<SyncRequestsAggregateBoolExpCount>;
};

export type SyncRequestsAggregateBoolExpBoolAnd = {
  arguments: SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncRequestsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncRequestsAggregateBoolExpBoolOr = {
  arguments: SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncRequestsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncRequestsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "sync_requests" */
export type SyncRequestsAggregateFields = {
  __typename?: 'sync_requests_aggregate_fields';
  avg?: Maybe<SyncRequestsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncRequestsMaxFields>;
  min?: Maybe<SyncRequestsMinFields>;
  stddev?: Maybe<SyncRequestsStddevFields>;
  stddev_pop?: Maybe<SyncRequestsStddevPopFields>;
  stddev_samp?: Maybe<SyncRequestsStddevSampFields>;
  sum?: Maybe<SyncRequestsSumFields>;
  var_pop?: Maybe<SyncRequestsVarPopFields>;
  var_samp?: Maybe<SyncRequestsVarSampFields>;
  variance?: Maybe<SyncRequestsVarianceFields>;
};


/** aggregate fields of "sync_requests" */
export type SyncRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sync_requests" */
export type SyncRequestsAggregateOrderBy = {
  avg?: InputMaybe<SyncRequestsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncRequestsMaxOrderBy>;
  min?: InputMaybe<SyncRequestsMinOrderBy>;
  stddev?: InputMaybe<SyncRequestsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncRequestsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncRequestsStddevSampOrderBy>;
  sum?: InputMaybe<SyncRequestsSumOrderBy>;
  var_pop?: InputMaybe<SyncRequestsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncRequestsVarSampOrderBy>;
  variance?: InputMaybe<SyncRequestsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncRequestsAvgFields = {
  __typename?: 'sync_requests_avg_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by avg() on columns of table "sync_requests" */
export type SyncRequestsAvgOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_requests". All fields are combined with a logical 'AND'. */
export type SyncRequestsBoolExp = {
  _and?: InputMaybe<Array<SyncRequestsBoolExp>>;
  _not?: InputMaybe<SyncRequestsBoolExp>;
  _or?: InputMaybe<Array<SyncRequestsBoolExp>>;
  add_executed?: InputMaybe<IntComparisonExp>;
  archive_query_results?: InputMaybe<BooleanComparisonExp>;
  change_executed?: InputMaybe<IntComparisonExp>;
  completion_ratio?: InputMaybe<NumericComparisonExp>;
  computed_progress?: InputMaybe<SyncRequestComputedProgressBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instance_id?: InputMaybe<BigintComparisonExp>;
  diff_mode?: InputMaybe<StringComparisonExp>;
  diff_mode_override?: InputMaybe<StringComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  extended_status?: InputMaybe<JsonbComparisonExp>;
  external_segment_id?: InputMaybe<BigintComparisonExp>;
  finished_at?: InputMaybe<TimestamptzComparisonExp>;
  full_resync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  output_files?: InputMaybe<JsonbComparisonExp>;
  phase_to_status?: InputMaybe<JsonbComparisonExp>;
  planner_type?: InputMaybe<StringComparisonExp>;
  previous_query_run_id?: InputMaybe<BigintComparisonExp>;
  previous_sync_request?: InputMaybe<SyncRequestsBoolExp>;
  query_run?: InputMaybe<QueryRunsBoolExp>;
  query_run_id?: InputMaybe<BigintComparisonExp>;
  rejected_ratio?: InputMaybe<NumericComparisonExp>;
  remove_executed?: InputMaybe<IntComparisonExp>;
  resync_reason?: InputMaybe<StringComparisonExp>;
  started_at?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  status_computed?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  sync_attempts?: InputMaybe<SyncAttemptsBoolExp>;
  sync_behavior?: InputMaybe<JsonbComparisonExp>;
  sync_config?: InputMaybe<JsonbComparisonExp>;
  sync_request_diff?: InputMaybe<SyncRequestDiffsBoolExp>;
  total_operations?: InputMaybe<IntComparisonExp>;
  trigger_cancel?: InputMaybe<BooleanComparisonExp>;
};

/** aggregate max on columns */
export type SyncRequestsMaxFields = {
  __typename?: 'sync_requests_max_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  diff_mode?: Maybe<Scalars['String']>;
  diff_mode_override?: Maybe<Scalars['String']>;
  external_segment_id?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  planner_type?: Maybe<Scalars['String']>;
  previous_query_run_id?: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['bigint']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  resync_reason?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  /** Generate a useful, user-facing status for the sync request */
  status_computed?: Maybe<Scalars['String']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "sync_requests" */
export type SyncRequestsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  diff_mode?: InputMaybe<OrderBy>;
  diff_mode_override?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  planner_type?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
  resync_reason?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncRequestsMinFields = {
  __typename?: 'sync_requests_min_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  diff_mode?: Maybe<Scalars['String']>;
  diff_mode_override?: Maybe<Scalars['String']>;
  external_segment_id?: Maybe<Scalars['bigint']>;
  finished_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  planner_type?: Maybe<Scalars['String']>;
  previous_query_run_id?: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['bigint']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  resync_reason?: Maybe<Scalars['String']>;
  started_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  /** Generate a useful, user-facing status for the sync request */
  status_computed?: Maybe<Scalars['String']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "sync_requests" */
export type SyncRequestsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  diff_mode?: InputMaybe<OrderBy>;
  diff_mode_override?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  planner_type?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
  resync_reason?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sync_requests" */
export type SyncRequestsMutationResponse = {
  __typename?: 'sync_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncRequests>;
};

/** Ordering options when selecting data from "sync_requests". */
export type SyncRequestsOrderBy = {
  add_executed?: InputMaybe<OrderBy>;
  archive_query_results?: InputMaybe<OrderBy>;
  change_executed?: InputMaybe<OrderBy>;
  completion_ratio?: InputMaybe<OrderBy>;
  computed_progress?: InputMaybe<SyncRequestComputedProgressOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  destination_instance_id?: InputMaybe<OrderBy>;
  diff_mode?: InputMaybe<OrderBy>;
  diff_mode_override?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  extended_status?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  finished_at?: InputMaybe<OrderBy>;
  full_resync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  output_files?: InputMaybe<OrderBy>;
  phase_to_status?: InputMaybe<OrderBy>;
  planner_type?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  previous_sync_request?: InputMaybe<SyncRequestsOrderBy>;
  query_run?: InputMaybe<QueryRunsOrderBy>;
  query_run_id?: InputMaybe<OrderBy>;
  rejected_ratio?: InputMaybe<OrderBy>;
  remove_executed?: InputMaybe<OrderBy>;
  resync_reason?: InputMaybe<OrderBy>;
  started_at?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  status_computed?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  sync_attempts_aggregate?: InputMaybe<SyncAttemptsAggregateOrderBy>;
  sync_behavior?: InputMaybe<OrderBy>;
  sync_config?: InputMaybe<OrderBy>;
  sync_request_diff?: InputMaybe<SyncRequestDiffsOrderBy>;
  total_operations?: InputMaybe<OrderBy>;
  trigger_cancel?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sync_requests */
export type SyncRequestsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "sync_requests" */
export const SyncRequestsSelectColumn = {
  /** column name */
  ArchiveQueryResults: 'archive_query_results',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DestinationInstanceId: 'destination_instance_id',
  /** column name */
  DiffMode: 'diff_mode',
  /** column name */
  DiffModeOverride: 'diff_mode_override',
  /** column name */
  Error: 'error',
  /** column name */
  ExtendedStatus: 'extended_status',
  /** column name */
  ExternalSegmentId: 'external_segment_id',
  /** column name */
  FinishedAt: 'finished_at',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  Id: 'id',
  /** column name */
  OutputFiles: 'output_files',
  /** column name */
  PhaseToStatus: 'phase_to_status',
  /** column name */
  PlannerType: 'planner_type',
  /** column name */
  PreviousQueryRunId: 'previous_query_run_id',
  /** column name */
  QueryRunId: 'query_run_id',
  /** column name */
  ResyncReason: 'resync_reason',
  /** column name */
  StartedAt: 'started_at',
  /** column name */
  Status: 'status',
  /** column name */
  SyncBehavior: 'sync_behavior',
  /** column name */
  SyncConfig: 'sync_config',
  /** column name */
  TriggerCancel: 'trigger_cancel'
} as const;

export type SyncRequestsSelectColumn = typeof SyncRequestsSelectColumn[keyof typeof SyncRequestsSelectColumn];
/** select "sync_requests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sync_requests" */
export const SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  ArchiveQueryResults: 'archive_query_results',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  TriggerCancel: 'trigger_cancel'
} as const;

export type SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolAndArgumentsColumns = typeof SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolAndArgumentsColumns];
/** select "sync_requests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sync_requests" */
export const SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  ArchiveQueryResults: 'archive_query_results',
  /** column name */
  FullResync: 'full_resync',
  /** column name */
  TriggerCancel: 'trigger_cancel'
} as const;

export type SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolOrArgumentsColumns = typeof SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof SyncRequestsSelectColumnSyncRequestsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "sync_requests" */
export type SyncRequestsSetInput = {
  trigger_cancel?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type SyncRequestsStddevFields = {
  __typename?: 'sync_requests_stddev_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "sync_requests" */
export type SyncRequestsStddevOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncRequestsStddevPopFields = {
  __typename?: 'sync_requests_stddev_pop_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by stddev_pop() on columns of table "sync_requests" */
export type SyncRequestsStddevPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncRequestsStddevSampFields = {
  __typename?: 'sync_requests_stddev_samp_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by stddev_samp() on columns of table "sync_requests" */
export type SyncRequestsStddevSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_requests" */
export type SyncRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncRequestsStreamCursorValueInput = {
  archive_query_results?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  destination_instance_id?: InputMaybe<Scalars['bigint']>;
  diff_mode?: InputMaybe<Scalars['String']>;
  diff_mode_override?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['jsonb']>;
  extended_status?: InputMaybe<Scalars['jsonb']>;
  external_segment_id?: InputMaybe<Scalars['bigint']>;
  finished_at?: InputMaybe<Scalars['timestamptz']>;
  full_resync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  output_files?: InputMaybe<Scalars['jsonb']>;
  phase_to_status?: InputMaybe<Scalars['jsonb']>;
  planner_type?: InputMaybe<Scalars['String']>;
  previous_query_run_id?: InputMaybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<Scalars['bigint']>;
  resync_reason?: InputMaybe<Scalars['String']>;
  started_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  sync_behavior?: InputMaybe<Scalars['jsonb']>;
  sync_config?: InputMaybe<Scalars['jsonb']>;
  trigger_cancel?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type SyncRequestsSumFields = {
  __typename?: 'sync_requests_sum_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['bigint']>;
  external_segment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  previous_query_run_id?: Maybe<Scalars['bigint']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['bigint']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sync_requests" */
export type SyncRequestsSumOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

export type SyncRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SyncRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: SyncRequestsBoolExp;
};

/** aggregate var_pop on columns */
export type SyncRequestsVarPopFields = {
  __typename?: 'sync_requests_var_pop_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by var_pop() on columns of table "sync_requests" */
export type SyncRequestsVarPopOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncRequestsVarSampFields = {
  __typename?: 'sync_requests_var_samp_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by var_samp() on columns of table "sync_requests" */
export type SyncRequestsVarSampOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncRequestsVarianceFields = {
  __typename?: 'sync_requests_variance_fields';
  /** Add operation number that is displayed on the syncs page. */
  add_executed?: Maybe<Scalars['Int']>;
  /** Change operation number that is displayed on the syncs page. */
  change_executed?: Maybe<Scalars['Int']>;
  /** returns a decimal value representing the progress through the planned sync */
  completion_ratio?: Maybe<Scalars['numeric']>;
  destination_instance_id?: Maybe<Scalars['Float']>;
  external_segment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  previous_query_run_id?: Maybe<Scalars['Float']>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: Maybe<Scalars['Float']>;
  /** Fraction (0-1) of attempted operations that were rejected; null when the run has no operations */
  rejected_ratio?: Maybe<Scalars['numeric']>;
  /** Remove operation number that is displayed on the syncs page. */
  remove_executed?: Maybe<Scalars['Int']>;
  /** Total attempted operations (add + change + remove) displayed on the runs page */
  total_operations?: Maybe<Scalars['Int']>;
};

/** order by variance() on columns of table "sync_requests" */
export type SyncRequestsVarianceOrderBy = {
  destination_instance_id?: InputMaybe<OrderBy>;
  external_segment_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  previous_query_run_id?: InputMaybe<OrderBy>;
  /** This is null initially, but gets set to the id after the query completes. */
  query_run_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_sequence_members" */
export type SyncSequenceMembers = {
  __typename?: 'sync_sequence_members';
  abort_seq_on_failure: Scalars['Boolean'];
  abort_seq_on_rejects?: Maybe<Scalars['smallint']>;
  /** An object relationship */
  destination_instance: DestinationInstances;
  id: Scalars['uuid'];
  links: Scalars['jsonb'];
  reference_id: Scalars['Int'];
  sequence_id: Scalars['uuid'];
  sync_id: Scalars['bigint'];
  /** An object relationship */
  sync_sequence: SyncSequences;
};


/** columns and relationships of "sync_sequence_members" */
export type SyncSequenceMembersLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_sequence_members" */
export type SyncSequenceMembersAggregateOrderBy = {
  avg?: InputMaybe<SyncSequenceMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncSequenceMembersMaxOrderBy>;
  min?: InputMaybe<SyncSequenceMembersMinOrderBy>;
  stddev?: InputMaybe<SyncSequenceMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncSequenceMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncSequenceMembersStddevSampOrderBy>;
  sum?: InputMaybe<SyncSequenceMembersSumOrderBy>;
  var_pop?: InputMaybe<SyncSequenceMembersVarPopOrderBy>;
  var_samp?: InputMaybe<SyncSequenceMembersVarSampOrderBy>;
  variance?: InputMaybe<SyncSequenceMembersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SyncSequenceMembersAppendInput = {
  links?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sync_sequence_members" */
export type SyncSequenceMembersArrRelInsertInput = {
  data: Array<SyncSequenceMembersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SyncSequenceMembersOnConflict>;
};

/** order by avg() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersAvgOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_sequence_members". All fields are combined with a logical 'AND'. */
export type SyncSequenceMembersBoolExp = {
  _and?: InputMaybe<Array<SyncSequenceMembersBoolExp>>;
  _not?: InputMaybe<SyncSequenceMembersBoolExp>;
  _or?: InputMaybe<Array<SyncSequenceMembersBoolExp>>;
  abort_seq_on_failure?: InputMaybe<BooleanComparisonExp>;
  abort_seq_on_rejects?: InputMaybe<SmallintComparisonExp>;
  destination_instance?: InputMaybe<DestinationInstancesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  links?: InputMaybe<JsonbComparisonExp>;
  reference_id?: InputMaybe<IntComparisonExp>;
  sequence_id?: InputMaybe<UuidComparisonExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  sync_sequence?: InputMaybe<SyncSequencesBoolExp>;
};

/** unique or primary key constraints on table "sync_sequence_members" */
export const SyncSequenceMembersConstraint = {
  /** unique or primary key constraint on columns "id" */
  SyncSequenceMembersPkey: 'sync_sequence_members_pkey',
  /** unique or primary key constraint on columns "sequence_id", "reference_id" */
  SyncSequenceMembersSequenceUuidReferenceIdKey: 'sync_sequence_members_sequence_uuid_reference_id_key'
} as const;

export type SyncSequenceMembersConstraint = typeof SyncSequenceMembersConstraint[keyof typeof SyncSequenceMembersConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SyncSequenceMembersDeleteAtPathInput = {
  links?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SyncSequenceMembersDeleteElemInput = {
  links?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SyncSequenceMembersDeleteKeyInput = {
  links?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sync_sequence_members" */
export type SyncSequenceMembersIncInput = {
  abort_seq_on_rejects?: InputMaybe<Scalars['smallint']>;
  reference_id?: InputMaybe<Scalars['Int']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sync_sequence_members" */
export type SyncSequenceMembersInsertInput = {
  abort_seq_on_failure?: InputMaybe<Scalars['Boolean']>;
  abort_seq_on_rejects?: InputMaybe<Scalars['smallint']>;
  destination_instance?: InputMaybe<DestinationInstancesObjRelInsertInput>;
  links?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['Int']>;
  sequence_id?: InputMaybe<Scalars['uuid']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
  sync_sequence?: InputMaybe<SyncSequencesObjRelInsertInput>;
};

/** order by max() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersMaxOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersMinOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sync_sequence_members" */
export type SyncSequenceMembersMutationResponse = {
  __typename?: 'sync_sequence_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncSequenceMembers>;
};

/** on_conflict condition type for table "sync_sequence_members" */
export type SyncSequenceMembersOnConflict = {
  constraint: SyncSequenceMembersConstraint;
  update_columns?: Array<SyncSequenceMembersUpdateColumn>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};

/** Ordering options when selecting data from "sync_sequence_members". */
export type SyncSequenceMembersOrderBy = {
  abort_seq_on_failure?: InputMaybe<OrderBy>;
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  destination_instance?: InputMaybe<DestinationInstancesOrderBy>;
  id?: InputMaybe<OrderBy>;
  links?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  sync_sequence?: InputMaybe<SyncSequencesOrderBy>;
};

/** primary key columns input for table: sync_sequence_members */
export type SyncSequenceMembersPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SyncSequenceMembersPrependInput = {
  links?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sync_sequence_members" */
export const SyncSequenceMembersSelectColumn = {
  /** column name */
  AbortSeqOnFailure: 'abort_seq_on_failure',
  /** column name */
  AbortSeqOnRejects: 'abort_seq_on_rejects',
  /** column name */
  Id: 'id',
  /** column name */
  Links: 'links',
  /** column name */
  ReferenceId: 'reference_id',
  /** column name */
  SequenceId: 'sequence_id',
  /** column name */
  SyncId: 'sync_id'
} as const;

export type SyncSequenceMembersSelectColumn = typeof SyncSequenceMembersSelectColumn[keyof typeof SyncSequenceMembersSelectColumn];
/** input type for updating data in table "sync_sequence_members" */
export type SyncSequenceMembersSetInput = {
  abort_seq_on_failure?: InputMaybe<Scalars['Boolean']>;
  abort_seq_on_rejects?: InputMaybe<Scalars['smallint']>;
  links?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['Int']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersStddevOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersStddevPopOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersStddevSampOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_sequence_members" */
export type SyncSequenceMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncSequenceMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncSequenceMembersStreamCursorValueInput = {
  abort_seq_on_failure?: InputMaybe<Scalars['Boolean']>;
  abort_seq_on_rejects?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['uuid']>;
  links?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['Int']>;
  sequence_id?: InputMaybe<Scalars['uuid']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersSumOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** update columns of table "sync_sequence_members" */
export const SyncSequenceMembersUpdateColumn = {
  /** column name */
  AbortSeqOnFailure: 'abort_seq_on_failure',
  /** column name */
  AbortSeqOnRejects: 'abort_seq_on_rejects',
  /** column name */
  Links: 'links',
  /** column name */
  ReferenceId: 'reference_id',
  /** column name */
  SyncId: 'sync_id'
} as const;

export type SyncSequenceMembersUpdateColumn = typeof SyncSequenceMembersUpdateColumn[keyof typeof SyncSequenceMembersUpdateColumn];
export type SyncSequenceMembersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SyncSequenceMembersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SyncSequenceMembersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SyncSequenceMembersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SyncSequenceMembersDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SyncSequenceMembersIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SyncSequenceMembersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SyncSequenceMembersSetInput>;
  /** filter the rows which have to be updated */
  where: SyncSequenceMembersBoolExp;
};

/** order by var_pop() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersVarPopOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersVarSampOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sync_sequence_members" */
export type SyncSequenceMembersVarianceOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_sequence_requests" */
export type SyncSequenceRequests = {
  __typename?: 'sync_sequence_requests';
  abort_seq_on_failure: Scalars['Boolean'];
  abort_seq_on_rejects?: Maybe<Scalars['smallint']>;
  id: Scalars['uuid'];
  links: Scalars['jsonb'];
  reference_id: Scalars['Int'];
  sequence_run_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  sync?: Maybe<Syncs>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync_request?: Maybe<SyncRequests>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sync_sequence_run?: Maybe<SyncSequenceRuns>;
};


/** columns and relationships of "sync_sequence_requests" */
export type SyncSequenceRequestsLinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "sync_sequence_requests" */
export type SyncSequenceRequestsAggregateOrderBy = {
  avg?: InputMaybe<SyncSequenceRequestsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncSequenceRequestsMaxOrderBy>;
  min?: InputMaybe<SyncSequenceRequestsMinOrderBy>;
  stddev?: InputMaybe<SyncSequenceRequestsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncSequenceRequestsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncSequenceRequestsStddevSampOrderBy>;
  sum?: InputMaybe<SyncSequenceRequestsSumOrderBy>;
  var_pop?: InputMaybe<SyncSequenceRequestsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncSequenceRequestsVarSampOrderBy>;
  variance?: InputMaybe<SyncSequenceRequestsVarianceOrderBy>;
};

/** order by avg() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsAvgOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_sequence_requests". All fields are combined with a logical 'AND'. */
export type SyncSequenceRequestsBoolExp = {
  _and?: InputMaybe<Array<SyncSequenceRequestsBoolExp>>;
  _not?: InputMaybe<SyncSequenceRequestsBoolExp>;
  _or?: InputMaybe<Array<SyncSequenceRequestsBoolExp>>;
  abort_seq_on_failure?: InputMaybe<BooleanComparisonExp>;
  abort_seq_on_rejects?: InputMaybe<SmallintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  links?: InputMaybe<JsonbComparisonExp>;
  reference_id?: InputMaybe<IntComparisonExp>;
  sequence_run_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync?: InputMaybe<SyncsBoolExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  sync_request?: InputMaybe<SyncRequestsBoolExp>;
  sync_request_id?: InputMaybe<BigintComparisonExp>;
  sync_sequence_run?: InputMaybe<SyncSequenceRunsBoolExp>;
};

/** order by max() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsMaxOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsMinOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "sync_sequence_requests". */
export type SyncSequenceRequestsOrderBy = {
  abort_seq_on_failure?: InputMaybe<OrderBy>;
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  links?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  sequence_run_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync?: InputMaybe<SyncsOrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  sync_request?: InputMaybe<SyncRequestsOrderBy>;
  sync_request_id?: InputMaybe<OrderBy>;
  sync_sequence_run?: InputMaybe<SyncSequenceRunsOrderBy>;
};

/** select columns of table "sync_sequence_requests" */
export const SyncSequenceRequestsSelectColumn = {
  /** column name */
  AbortSeqOnFailure: 'abort_seq_on_failure',
  /** column name */
  AbortSeqOnRejects: 'abort_seq_on_rejects',
  /** column name */
  Id: 'id',
  /** column name */
  Links: 'links',
  /** column name */
  ReferenceId: 'reference_id',
  /** column name */
  SequenceRunId: 'sequence_run_id',
  /** column name */
  Status: 'status',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  SyncRequestId: 'sync_request_id'
} as const;

export type SyncSequenceRequestsSelectColumn = typeof SyncSequenceRequestsSelectColumn[keyof typeof SyncSequenceRequestsSelectColumn];
/** order by stddev() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsStddevOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsStddevPopOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsStddevSampOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_sequence_requests" */
export type SyncSequenceRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncSequenceRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncSequenceRequestsStreamCursorValueInput = {
  abort_seq_on_failure?: InputMaybe<Scalars['Boolean']>;
  abort_seq_on_rejects?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['uuid']>;
  links?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['Int']>;
  sequence_run_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<Scalars['bigint']>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsSumOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsVarPopOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsVarSampOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "sync_sequence_requests" */
export type SyncSequenceRequestsVarianceOrderBy = {
  abort_seq_on_rejects?: InputMaybe<OrderBy>;
  reference_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync has been deleted. */
  sync_id?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to preserve sequence history after the related sync request has been deleted. */
  sync_request_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_sequence_runs" */
export type SyncSequenceRuns = {
  __typename?: 'sync_sequence_runs';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  requests: Array<SyncSequenceRequests>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "sync_sequence_runs" */
export type SyncSequenceRunsRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRequestsOrderBy>>;
  where?: InputMaybe<SyncSequenceRequestsBoolExp>;
};

/** aggregated selection of "sync_sequence_runs" */
export type SyncSequenceRunsAggregate = {
  __typename?: 'sync_sequence_runs_aggregate';
  aggregate?: Maybe<SyncSequenceRunsAggregateFields>;
  nodes: Array<SyncSequenceRuns>;
};

export type SyncSequenceRunsAggregateBoolExp = {
  count?: InputMaybe<SyncSequenceRunsAggregateBoolExpCount>;
};

export type SyncSequenceRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncSequenceRunsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "sync_sequence_runs" */
export type SyncSequenceRunsAggregateFields = {
  __typename?: 'sync_sequence_runs_aggregate_fields';
  avg?: Maybe<SyncSequenceRunsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncSequenceRunsMaxFields>;
  min?: Maybe<SyncSequenceRunsMinFields>;
  stddev?: Maybe<SyncSequenceRunsStddevFields>;
  stddev_pop?: Maybe<SyncSequenceRunsStddevPopFields>;
  stddev_samp?: Maybe<SyncSequenceRunsStddevSampFields>;
  sum?: Maybe<SyncSequenceRunsSumFields>;
  var_pop?: Maybe<SyncSequenceRunsVarPopFields>;
  var_samp?: Maybe<SyncSequenceRunsVarSampFields>;
  variance?: Maybe<SyncSequenceRunsVarianceFields>;
};


/** aggregate fields of "sync_sequence_runs" */
export type SyncSequenceRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sync_sequence_runs" */
export type SyncSequenceRunsAggregateOrderBy = {
  avg?: InputMaybe<SyncSequenceRunsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncSequenceRunsMaxOrderBy>;
  min?: InputMaybe<SyncSequenceRunsMinOrderBy>;
  stddev?: InputMaybe<SyncSequenceRunsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncSequenceRunsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncSequenceRunsStddevSampOrderBy>;
  sum?: InputMaybe<SyncSequenceRunsSumOrderBy>;
  var_pop?: InputMaybe<SyncSequenceRunsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncSequenceRunsVarSampOrderBy>;
  variance?: InputMaybe<SyncSequenceRunsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncSequenceRunsAvgFields = {
  __typename?: 'sync_sequence_runs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_sequence_runs". All fields are combined with a logical 'AND'. */
export type SyncSequenceRunsBoolExp = {
  _and?: InputMaybe<Array<SyncSequenceRunsBoolExp>>;
  _not?: InputMaybe<SyncSequenceRunsBoolExp>;
  _or?: InputMaybe<Array<SyncSequenceRunsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  requests?: InputMaybe<SyncSequenceRequestsBoolExp>;
  sequence_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SyncSequenceRunsMaxFields = {
  __typename?: 'sync_sequence_runs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncSequenceRunsMinFields = {
  __typename?: 'sync_sequence_runs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sync_sequence_runs" */
export type SyncSequenceRunsMutationResponse = {
  __typename?: 'sync_sequence_runs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncSequenceRuns>;
};

/** Ordering options when selecting data from "sync_sequence_runs". */
export type SyncSequenceRunsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  requests_aggregate?: InputMaybe<SyncSequenceRequestsAggregateOrderBy>;
  sequence_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sync_sequence_runs */
export type SyncSequenceRunsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "sync_sequence_runs" */
export const SyncSequenceRunsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SequenceId: 'sequence_id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncSequenceRunsSelectColumn = typeof SyncSequenceRunsSelectColumn[keyof typeof SyncSequenceRunsSelectColumn];
/** input type for updating data in table "sync_sequence_runs" */
export type SyncSequenceRunsSetInput = {
  trigger_cancel?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type SyncSequenceRunsStddevFields = {
  __typename?: 'sync_sequence_runs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncSequenceRunsStddevPopFields = {
  __typename?: 'sync_sequence_runs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncSequenceRunsStddevSampFields = {
  __typename?: 'sync_sequence_runs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_sequence_runs" */
export type SyncSequenceRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncSequenceRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncSequenceRunsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** The FK has ON DELETE SET NULL to allow a sequence run to be accessed via the related sync requests after the original sequence has been deleted. */
  sequence_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SyncSequenceRunsSumFields = {
  __typename?: 'sync_sequence_runs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type SyncSequenceRunsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SyncSequenceRunsSetInput>;
  /** filter the rows which have to be updated */
  where: SyncSequenceRunsBoolExp;
};

/** aggregate var_pop on columns */
export type SyncSequenceRunsVarPopFields = {
  __typename?: 'sync_sequence_runs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncSequenceRunsVarSampFields = {
  __typename?: 'sync_sequence_runs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncSequenceRunsVarianceFields = {
  __typename?: 'sync_sequence_runs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sync_sequence_runs" */
export type SyncSequenceRunsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "sync_sequences" */
export type SyncSequences = {
  __typename?: 'sync_sequences';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  force_run: Scalars['Boolean'];
  id: Scalars['uuid'];
  last_run_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  members: Array<SyncSequenceMembers>;
  name: Scalars['String'];
  /** An array relationship */
  runs: Array<SyncSequenceRuns>;
  /** An aggregate relationship */
  runs_aggregate: SyncSequenceRunsAggregate;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "sync_sequences" */
export type SyncSequencesMembersArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceMembersOrderBy>>;
  where?: InputMaybe<SyncSequenceMembersBoolExp>;
};


/** columns and relationships of "sync_sequences" */
export type SyncSequencesRunsArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


/** columns and relationships of "sync_sequences" */
export type SyncSequencesRunsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncSequenceRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncSequenceRunsOrderBy>>;
  where?: InputMaybe<SyncSequenceRunsBoolExp>;
};


/** columns and relationships of "sync_sequences" */
export type SyncSequencesScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sync_sequences" */
export type SyncSequencesAggregate = {
  __typename?: 'sync_sequences_aggregate';
  aggregate?: Maybe<SyncSequencesAggregateFields>;
  nodes: Array<SyncSequences>;
};

/** aggregate fields of "sync_sequences" */
export type SyncSequencesAggregateFields = {
  __typename?: 'sync_sequences_aggregate_fields';
  avg?: Maybe<SyncSequencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncSequencesMaxFields>;
  min?: Maybe<SyncSequencesMinFields>;
  stddev?: Maybe<SyncSequencesStddevFields>;
  stddev_pop?: Maybe<SyncSequencesStddevPopFields>;
  stddev_samp?: Maybe<SyncSequencesStddevSampFields>;
  sum?: Maybe<SyncSequencesSumFields>;
  var_pop?: Maybe<SyncSequencesVarPopFields>;
  var_samp?: Maybe<SyncSequencesVarSampFields>;
  variance?: Maybe<SyncSequencesVarianceFields>;
};


/** aggregate fields of "sync_sequences" */
export type SyncSequencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncSequencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SyncSequencesAppendInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SyncSequencesAvgFields = {
  __typename?: 'sync_sequences_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sync_sequences". All fields are combined with a logical 'AND'. */
export type SyncSequencesBoolExp = {
  _and?: InputMaybe<Array<SyncSequencesBoolExp>>;
  _not?: InputMaybe<SyncSequencesBoolExp>;
  _or?: InputMaybe<Array<SyncSequencesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  force_run?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  members?: InputMaybe<SyncSequenceMembersBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  runs?: InputMaybe<SyncSequenceRunsBoolExp>;
  runs_aggregate?: InputMaybe<SyncSequenceRunsAggregateBoolExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "sync_sequences" */
export const SyncSequencesConstraint = {
  /** unique or primary key constraint on columns "workspace_id", "name" */
  SyncSequencesNameWorkspaceIdKey: 'sync_sequences_name_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  SyncSequencesPkey: 'sync_sequences_pkey',
  /** unique or primary key constraint on columns "workspace_id", "slug" */
  SyncSequencesSlugWorkspaceIdKey: 'sync_sequences_slug_workspace_id_key'
} as const;

export type SyncSequencesConstraint = typeof SyncSequencesConstraint[keyof typeof SyncSequencesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SyncSequencesDeleteAtPathInput = {
  schedule?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SyncSequencesDeleteElemInput = {
  schedule?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SyncSequencesDeleteKeyInput = {
  schedule?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "sync_sequences" */
export type SyncSequencesInsertInput = {
  force_run?: InputMaybe<Scalars['Boolean']>;
  members?: InputMaybe<SyncSequenceMembersArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SyncSequencesMaxFields = {
  __typename?: 'sync_sequences_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SyncSequencesMinFields = {
  __typename?: 'sync_sequences_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['uuid']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sync_sequences" */
export type SyncSequencesMutationResponse = {
  __typename?: 'sync_sequences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncSequences>;
};

/** input type for inserting object relation for remote table "sync_sequences" */
export type SyncSequencesObjRelInsertInput = {
  data: SyncSequencesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SyncSequencesOnConflict>;
};

/** on_conflict condition type for table "sync_sequences" */
export type SyncSequencesOnConflict = {
  constraint: SyncSequencesConstraint;
  update_columns?: Array<SyncSequencesUpdateColumn>;
  where?: InputMaybe<SyncSequencesBoolExp>;
};

/** Ordering options when selecting data from "sync_sequences". */
export type SyncSequencesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  force_run?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  members_aggregate?: InputMaybe<SyncSequenceMembersAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  runs_aggregate?: InputMaybe<SyncSequenceRunsAggregateOrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sync_sequences */
export type SyncSequencesPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SyncSequencesPrependInput = {
  schedule?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sync_sequences" */
export const SyncSequencesSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  Id: 'id',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Slug: 'slug',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncSequencesSelectColumn = typeof SyncSequencesSelectColumn[keyof typeof SyncSequencesSelectColumn];
/** input type for updating data in table "sync_sequences" */
export type SyncSequencesSetInput = {
  force_run?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SyncSequencesStddevFields = {
  __typename?: 'sync_sequences_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SyncSequencesStddevPopFields = {
  __typename?: 'sync_sequences_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SyncSequencesStddevSampFields = {
  __typename?: 'sync_sequences_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sync_sequences" */
export type SyncSequencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncSequencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncSequencesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  force_run?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SyncSequencesSumFields = {
  __typename?: 'sync_sequences_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sync_sequences" */
export const SyncSequencesUpdateColumn = {
  /** column name */
  ForceRun: 'force_run',
  /** column name */
  Name: 'name',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  Slug: 'slug'
} as const;

export type SyncSequencesUpdateColumn = typeof SyncSequencesUpdateColumn[keyof typeof SyncSequencesUpdateColumn];
export type SyncSequencesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SyncSequencesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SyncSequencesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SyncSequencesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SyncSequencesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SyncSequencesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SyncSequencesSetInput>;
  /** filter the rows which have to be updated */
  where: SyncSequencesBoolExp;
};

/** aggregate var_pop on columns */
export type SyncSequencesVarPopFields = {
  __typename?: 'sync_sequences_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SyncSequencesVarSampFields = {
  __typename?: 'sync_sequences_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SyncSequencesVarianceFields = {
  __typename?: 'sync_sequences_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sync_templates" */
export type SyncTemplates = {
  __typename?: 'sync_templates';
  /** An array relationship */
  alert_instances: Array<AlertInstances>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination: Destinations;
  destination_id: Scalars['Int'];
  /** An array relationship */
  destination_instances: Array<DestinationInstances>;
  /** An aggregate relationship */
  destination_instances_aggregate: DestinationInstancesAggregate;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  journey_settings?: Maybe<Scalars['jsonb']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  override_config?: Maybe<Scalars['jsonb']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused: Scalars['Boolean'];
  /** An object relationship */
  segment: Segments;
  segment_id: Scalars['Int'];
  slug: Scalars['String'];
  /** An array relationship */
  space_sync_templates: Array<SpaceSyncTemplates>;
  tags: Scalars['jsonb'];
  transformed_config: Scalars['JSONObject'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesAlertInstancesArgs = {
  distinct_on?: InputMaybe<Array<AlertInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AlertInstancesOrderBy>>;
  where?: InputMaybe<AlertInstancesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesDestinationInstancesArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesDestinationInstancesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstancesOrderBy>>;
  where?: InputMaybe<DestinationInstancesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesJourneySettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesOverrideConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesSpaceSyncTemplatesArgs = {
  distinct_on?: InputMaybe<Array<SpaceSyncTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SpaceSyncTemplatesOrderBy>>;
  where?: InputMaybe<SpaceSyncTemplatesBoolExp>;
};


/** columns and relationships of "sync_templates" */
export type SyncTemplatesTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sync_templates" */
export type SyncTemplatesAggregate = {
  __typename?: 'sync_templates_aggregate';
  aggregate?: Maybe<SyncTemplatesAggregateFields>;
  nodes: Array<SyncTemplates>;
};

export type SyncTemplatesAggregateBoolExp = {
  bool_and?: InputMaybe<SyncTemplatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SyncTemplatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<SyncTemplatesAggregateBoolExpCount>;
};

export type SyncTemplatesAggregateBoolExpBoolAnd = {
  arguments: SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncTemplatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncTemplatesAggregateBoolExpBoolOr = {
  arguments: SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncTemplatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncTemplatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncTemplatesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "sync_templates" */
export type SyncTemplatesAggregateFields = {
  __typename?: 'sync_templates_aggregate_fields';
  avg?: Maybe<SyncTemplatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncTemplatesMaxFields>;
  min?: Maybe<SyncTemplatesMinFields>;
  stddev?: Maybe<SyncTemplatesStddevFields>;
  stddev_pop?: Maybe<SyncTemplatesStddevPopFields>;
  stddev_samp?: Maybe<SyncTemplatesStddevSampFields>;
  sum?: Maybe<SyncTemplatesSumFields>;
  var_pop?: Maybe<SyncTemplatesVarPopFields>;
  var_samp?: Maybe<SyncTemplatesVarSampFields>;
  variance?: Maybe<SyncTemplatesVarianceFields>;
};


/** aggregate fields of "sync_templates" */
export type SyncTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sync_templates" */
export type SyncTemplatesAggregateOrderBy = {
  avg?: InputMaybe<SyncTemplatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncTemplatesMaxOrderBy>;
  min?: InputMaybe<SyncTemplatesMinOrderBy>;
  stddev?: InputMaybe<SyncTemplatesStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncTemplatesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncTemplatesStddevSampOrderBy>;
  sum?: InputMaybe<SyncTemplatesSumOrderBy>;
  var_pop?: InputMaybe<SyncTemplatesVarPopOrderBy>;
  var_samp?: InputMaybe<SyncTemplatesVarSampOrderBy>;
  variance?: InputMaybe<SyncTemplatesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SyncTemplatesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  journey_settings?: InputMaybe<Scalars['jsonb']>;
  override_config?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sync_templates" */
export type SyncTemplatesArrRelInsertInput = {
  data: Array<SyncTemplatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<SyncTemplatesOnConflict>;
};

/** aggregate avg on columns */
export type SyncTemplatesAvgFields = {
  __typename?: 'sync_templates_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sync_templates" */
export type SyncTemplatesAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "sync_templates". All fields are combined with a logical 'AND'. */
export type SyncTemplatesBoolExp = {
  _and?: InputMaybe<Array<SyncTemplatesBoolExp>>;
  _not?: InputMaybe<SyncTemplatesBoolExp>;
  _or?: InputMaybe<Array<SyncTemplatesBoolExp>>;
  alert_instances?: InputMaybe<AlertInstancesBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<IntComparisonExp>;
  destination_instances?: InputMaybe<DestinationInstancesBoolExp>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateBoolExp>;
  full_resync_interval?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  journey_settings?: InputMaybe<JsonbComparisonExp>;
  matchbooster_region?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  override_config?: InputMaybe<JsonbComparisonExp>;
  row_threshold_attempted?: InputMaybe<BigintComparisonExp>;
  row_threshold_total?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<IntComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  space_sync_templates?: InputMaybe<SpaceSyncTemplatesBoolExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "sync_templates" */
export const SyncTemplatesConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  SyncTemplatesIdWorkspaceIdKey: 'sync_templates_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  SyncTemplatesPkey: 'sync_templates_pkey'
} as const;

export type SyncTemplatesConstraint = typeof SyncTemplatesConstraint[keyof typeof SyncTemplatesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SyncTemplatesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
  journey_settings?: InputMaybe<Array<Scalars['String']>>;
  override_config?: InputMaybe<Array<Scalars['String']>>;
  schedule?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SyncTemplatesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
  journey_settings?: InputMaybe<Scalars['Int']>;
  override_config?: InputMaybe<Scalars['Int']>;
  schedule?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SyncTemplatesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
  journey_settings?: InputMaybe<Scalars['String']>;
  override_config?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sync_templates" */
export type SyncTemplatesIncInput = {
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  segment_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sync_templates" */
export type SyncTemplatesInsertInput = {
  alert_instances?: InputMaybe<AlertInstancesArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['Int']>;
  destination_instances?: InputMaybe<DestinationInstancesArrRelInsertInput>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  journey_settings?: InputMaybe<Scalars['jsonb']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  override_config?: InputMaybe<Scalars['jsonb']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  segment_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  space_sync_templates?: InputMaybe<SpaceSyncTemplatesArrRelInsertInput>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type SyncTemplatesMaxFields = {
  __typename?: 'sync_templates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sync_templates" */
export type SyncTemplatesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncTemplatesMinFields = {
  __typename?: 'sync_templates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sync_templates" */
export type SyncTemplatesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "sync_templates" */
export type SyncTemplatesMutationResponse = {
  __typename?: 'sync_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SyncTemplates>;
};

/** input type for inserting object relation for remote table "sync_templates" */
export type SyncTemplatesObjRelInsertInput = {
  data: SyncTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SyncTemplatesOnConflict>;
};

/** on_conflict condition type for table "sync_templates" */
export type SyncTemplatesOnConflict = {
  constraint: SyncTemplatesConstraint;
  update_columns?: Array<SyncTemplatesUpdateColumn>;
  where?: InputMaybe<SyncTemplatesBoolExp>;
};

/** Ordering options when selecting data from "sync_templates". */
export type SyncTemplatesOrderBy = {
  alert_instances_aggregate?: InputMaybe<AlertInstancesAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  destination_instances_aggregate?: InputMaybe<DestinationInstancesAggregateOrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  journey_settings?: InputMaybe<OrderBy>;
  matchbooster_region?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  override_config?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_sync_templates_aggregate?: InputMaybe<SpaceSyncTemplatesAggregateOrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sync_templates */
export type SyncTemplatesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SyncTemplatesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  journey_settings?: InputMaybe<Scalars['jsonb']>;
  override_config?: InputMaybe<Scalars['jsonb']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sync_templates" */
export const SyncTemplatesSelectColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  FullResyncInterval: 'full_resync_interval',
  /** column name */
  Id: 'id',
  /** column name */
  JourneySettings: 'journey_settings',
  /** column name */
  MatchboosterRegion: 'matchbooster_region',
  /** column name */
  Name: 'name',
  /** column name */
  OverrideConfig: 'override_config',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncTemplatesSelectColumn = typeof SyncTemplatesSelectColumn[keyof typeof SyncTemplatesSelectColumn];
/** select "sync_templates_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sync_templates" */
export const SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolAndArgumentsColumns = typeof SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolAndArgumentsColumns];
/** select "sync_templates_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sync_templates" */
export const SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolOrArgumentsColumns = typeof SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof SyncTemplatesSelectColumnSyncTemplatesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "sync_templates" */
export type SyncTemplatesSetInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  journey_settings?: InputMaybe<Scalars['jsonb']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  override_config?: InputMaybe<Scalars['jsonb']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type SyncTemplatesStddevFields = {
  __typename?: 'sync_templates_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sync_templates" */
export type SyncTemplatesStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncTemplatesStddevPopFields = {
  __typename?: 'sync_templates_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sync_templates" */
export type SyncTemplatesStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncTemplatesStddevSampFields = {
  __typename?: 'sync_templates_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sync_templates" */
export type SyncTemplatesStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "sync_templates" */
export type SyncTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncTemplatesStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['Int']>;
  full_resync_interval?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  journey_settings?: InputMaybe<Scalars['jsonb']>;
  /** Match Booster region for syncs created from this template. Inherited at runtime when destination_instances.sync_template_id is set. */
  matchbooster_region?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  override_config?: InputMaybe<Scalars['jsonb']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SyncTemplatesSumFields = {
  __typename?: 'sync_templates_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  destination_id?: Maybe<Scalars['Int']>;
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sync_templates" */
export type SyncTemplatesSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "sync_templates" */
export const SyncTemplatesUpdateColumn = {
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  FullResyncInterval: 'full_resync_interval',
  /** column name */
  JourneySettings: 'journey_settings',
  /** column name */
  MatchboosterRegion: 'matchbooster_region',
  /** column name */
  Name: 'name',
  /** column name */
  OverrideConfig: 'override_config',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Tags: 'tags'
} as const;

export type SyncTemplatesUpdateColumn = typeof SyncTemplatesUpdateColumn[keyof typeof SyncTemplatesUpdateColumn];
export type SyncTemplatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SyncTemplatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SyncTemplatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SyncTemplatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SyncTemplatesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SyncTemplatesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SyncTemplatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SyncTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: SyncTemplatesBoolExp;
};

/** aggregate var_pop on columns */
export type SyncTemplatesVarPopFields = {
  __typename?: 'sync_templates_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sync_templates" */
export type SyncTemplatesVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncTemplatesVarSampFields = {
  __typename?: 'sync_templates_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sync_templates" */
export type SyncTemplatesVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncTemplatesVarianceFields = {
  __typename?: 'sync_templates_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  full_resync_interval?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sync_templates" */
export type SyncTemplatesVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "syncs" */
export type Syncs = {
  __typename?: 'syncs';
  canary?: Maybe<Scalars['Boolean']>;
  config?: Maybe<Scalars['jsonb']>;
  config_metadata?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  destination?: Maybe<Destinations>;
  destination_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  destination_instance_splits: Array<DestinationInstanceSplits>;
  destination_metadata?: Maybe<Scalars['JSONObject']>;
  draft?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  external_segments: Array<ExternalSegments>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  is_effectively_disabled?: Maybe<Scalars['Boolean']>;
  is_streaming?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  journey_version?: Maybe<SyncsToJourneys>;
  labels?: Maybe<Scalars['JSONObject']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  matchbooster_region?: Maybe<Scalars['String']>;
  monitoring?: Maybe<Scalars['jsonb']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  schedule?: Maybe<Scalars['jsonb']>;
  schedule_paused?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  segment?: Maybe<Segments>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  /** An array relationship */
  sync_alerts: Array<SyncAlerts>;
  /** An array relationship */
  sync_requests: Array<SyncRequests>;
  /** An aggregate relationship */
  sync_requests_aggregate: SyncRequestsAggregate;
  /** An object relationship */
  sync_template?: Maybe<SyncTemplates>;
  sync_template_id?: Maybe<Scalars['Int']>;
  sync_template_overrides?: Maybe<Scalars['jsonb']>;
  tags?: Maybe<Scalars['jsonb']>;
  transformed_config: Scalars['JSONObject'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  warehouse_export_settings?: Maybe<Scalars['jsonb']>;
  warehouse_history_config?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "syncs" */
export type SyncsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsConfigMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsDestinationInstanceSplitsArgs = {
  distinct_on?: InputMaybe<Array<DestinationInstanceSplitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationInstanceSplitsOrderBy>>;
  where?: InputMaybe<DestinationInstanceSplitsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsExternalSegmentsArgs = {
  distinct_on?: InputMaybe<Array<ExternalSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExternalSegmentsOrderBy>>;
  where?: InputMaybe<ExternalSegmentsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsMonitoringArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsScheduleArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncAlertsArgs = {
  distinct_on?: InputMaybe<Array<SyncAlertsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncAlertsOrderBy>>;
  where?: InputMaybe<SyncAlertsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncRequestsArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SyncRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SyncRequestsOrderBy>>;
  where?: InputMaybe<SyncRequestsBoolExp>;
};


/** columns and relationships of "syncs" */
export type SyncsSyncTemplateOverridesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsWarehouseExportSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "syncs" */
export type SyncsWarehouseHistoryConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "syncs" */
export type SyncsAggregate = {
  __typename?: 'syncs_aggregate';
  aggregate?: Maybe<SyncsAggregateFields>;
  nodes: Array<Syncs>;
};

export type SyncsAggregateBoolExp = {
  bool_and?: InputMaybe<SyncsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<SyncsAggregateBoolExpBoolOr>;
  count?: InputMaybe<SyncsAggregateBoolExpCount>;
};

export type SyncsAggregateBoolExpBoolAnd = {
  arguments: SyncsSelectColumnSyncsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncsAggregateBoolExpBoolOr = {
  arguments: SyncsSelectColumnSyncsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type SyncsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SyncsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "syncs" */
export type SyncsAggregateFields = {
  __typename?: 'syncs_aggregate_fields';
  avg?: Maybe<SyncsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SyncsMaxFields>;
  min?: Maybe<SyncsMinFields>;
  stddev?: Maybe<SyncsStddevFields>;
  stddev_pop?: Maybe<SyncsStddevPopFields>;
  stddev_samp?: Maybe<SyncsStddevSampFields>;
  sum?: Maybe<SyncsSumFields>;
  var_pop?: Maybe<SyncsVarPopFields>;
  var_samp?: Maybe<SyncsVarSampFields>;
  variance?: Maybe<SyncsVarianceFields>;
};


/** aggregate fields of "syncs" */
export type SyncsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SyncsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "syncs" */
export type SyncsAggregateOrderBy = {
  avg?: InputMaybe<SyncsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SyncsMaxOrderBy>;
  min?: InputMaybe<SyncsMinOrderBy>;
  stddev?: InputMaybe<SyncsStddevOrderBy>;
  stddev_pop?: InputMaybe<SyncsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<SyncsStddevSampOrderBy>;
  sum?: InputMaybe<SyncsSumOrderBy>;
  var_pop?: InputMaybe<SyncsVarPopOrderBy>;
  var_samp?: InputMaybe<SyncsVarSampOrderBy>;
  variance?: InputMaybe<SyncsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type SyncsAvgFields = {
  __typename?: 'syncs_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "syncs" */
export type SyncsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "syncs". All fields are combined with a logical 'AND'. */
export type SyncsBoolExp = {
  _and?: InputMaybe<Array<SyncsBoolExp>>;
  _not?: InputMaybe<SyncsBoolExp>;
  _or?: InputMaybe<Array<SyncsBoolExp>>;
  canary?: InputMaybe<BooleanComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  config_metadata?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  destination?: InputMaybe<DestinationsBoolExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  destination_instance_splits?: InputMaybe<DestinationInstanceSplitsBoolExp>;
  draft?: InputMaybe<BooleanComparisonExp>;
  external_segments?: InputMaybe<ExternalSegmentsBoolExp>;
  full_resync_interval?: InputMaybe<IntComparisonExp>;
  health?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_effectively_disabled?: InputMaybe<BooleanComparisonExp>;
  is_streaming?: InputMaybe<BooleanComparisonExp>;
  journey_version?: InputMaybe<SyncsToJourneysBoolExp>;
  last_run_at?: InputMaybe<TimestamptzComparisonExp>;
  last_run_planner_type?: InputMaybe<StringComparisonExp>;
  matchbooster_region?: InputMaybe<StringComparisonExp>;
  monitoring?: InputMaybe<JsonbComparisonExp>;
  next_diff_mode_override?: InputMaybe<StringComparisonExp>;
  row_threshold_attempted?: InputMaybe<BigintComparisonExp>;
  row_threshold_total?: InputMaybe<BigintComparisonExp>;
  schedule?: InputMaybe<JsonbComparisonExp>;
  schedule_paused?: InputMaybe<BooleanComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  space_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  sync_alerts?: InputMaybe<SyncAlertsBoolExp>;
  sync_requests?: InputMaybe<SyncRequestsBoolExp>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateBoolExp>;
  sync_template?: InputMaybe<SyncTemplatesBoolExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
  sync_template_overrides?: InputMaybe<JsonbComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  warehouse_export_settings?: InputMaybe<JsonbComparisonExp>;
  warehouse_history_config?: InputMaybe<JsonbComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type SyncsMaxFields = {
  __typename?: 'syncs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  matchbooster_region?: Maybe<Scalars['String']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "syncs" */
export type SyncsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  matchbooster_region?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SyncsMinFields = {
  __typename?: 'syncs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['bigint']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  health?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_run_at?: Maybe<Scalars['timestamptz']>;
  last_run_planner_type?: Maybe<Scalars['String']>;
  matchbooster_region?: Maybe<Scalars['String']>;
  next_diff_mode_override?: Maybe<Scalars['String']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  slug?: Maybe<Scalars['String']>;
  space_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "syncs" */
export type SyncsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  matchbooster_region?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "syncs". */
export type SyncsOrderBy = {
  canary?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  config_metadata?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  destination?: InputMaybe<DestinationsOrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  destination_instance_splits_aggregate?: InputMaybe<DestinationInstanceSplitsAggregateOrderBy>;
  draft?: InputMaybe<OrderBy>;
  external_segments_aggregate?: InputMaybe<ExternalSegmentsAggregateOrderBy>;
  full_resync_interval?: InputMaybe<OrderBy>;
  health?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_effectively_disabled?: InputMaybe<OrderBy>;
  is_streaming?: InputMaybe<OrderBy>;
  journey_version?: InputMaybe<SyncsToJourneysOrderBy>;
  last_run_at?: InputMaybe<OrderBy>;
  last_run_planner_type?: InputMaybe<OrderBy>;
  matchbooster_region?: InputMaybe<OrderBy>;
  monitoring?: InputMaybe<OrderBy>;
  next_diff_mode_override?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  schedule?: InputMaybe<OrderBy>;
  schedule_paused?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  space_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  sync_alerts_aggregate?: InputMaybe<SyncAlertsAggregateOrderBy>;
  sync_requests_aggregate?: InputMaybe<SyncRequestsAggregateOrderBy>;
  sync_template?: InputMaybe<SyncTemplatesOrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  sync_template_overrides?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  warehouse_export_settings?: InputMaybe<OrderBy>;
  warehouse_history_config?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "syncs" */
export const SyncsSelectColumn = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Config: 'config',
  /** column name */
  ConfigMetadata: 'config_metadata',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  Draft: 'draft',
  /** column name */
  Health: 'health',
  /** column name */
  Id: 'id',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  LastRunAt: 'last_run_at',
  /** column name */
  LastRunPlannerType: 'last_run_planner_type',
  /** column name */
  MatchboosterRegion: 'matchbooster_region',
  /** column name */
  Monitoring: 'monitoring',
  /** column name */
  NextDiffModeOverride: 'next_diff_mode_override',
  /** column name */
  RowThresholdAttempted: 'row_threshold_attempted',
  /** column name */
  RowThresholdTotal: 'row_threshold_total',
  /** column name */
  Schedule: 'schedule',
  /** column name */
  SchedulePaused: 'schedule_paused',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Slug: 'slug',
  /** column name */
  SpaceId: 'space_id',
  /** column name */
  Status: 'status',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  SyncTemplateOverrides: 'sync_template_overrides',
  /** column name */
  Tags: 'tags',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WarehouseExportSettings: 'warehouse_export_settings',
  /** column name */
  WarehouseHistoryConfig: 'warehouse_history_config',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncsSelectColumn = typeof SyncsSelectColumn[keyof typeof SyncsSelectColumn];
/** select "syncs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "syncs" */
export const SyncsSelectColumnSyncsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Draft: 'draft',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SyncsSelectColumnSyncsAggregateBoolExpBoolAndArgumentsColumns = typeof SyncsSelectColumnSyncsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof SyncsSelectColumnSyncsAggregateBoolExpBoolAndArgumentsColumns];
/** select "syncs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "syncs" */
export const SyncsSelectColumnSyncsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Canary: 'canary',
  /** column name */
  Draft: 'draft',
  /** column name */
  IsEffectivelyDisabled: 'is_effectively_disabled',
  /** column name */
  IsStreaming: 'is_streaming',
  /** column name */
  SchedulePaused: 'schedule_paused'
} as const;

export type SyncsSelectColumnSyncsAggregateBoolExpBoolOrArgumentsColumns = typeof SyncsSelectColumnSyncsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof SyncsSelectColumnSyncsAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type SyncsStddevFields = {
  __typename?: 'syncs_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "syncs" */
export type SyncsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type SyncsStddevPopFields = {
  __typename?: 'syncs_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "syncs" */
export type SyncsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type SyncsStddevSampFields = {
  __typename?: 'syncs_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "syncs" */
export type SyncsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "syncs" */
export type SyncsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncsStreamCursorValueInput = {
  canary?: InputMaybe<Scalars['Boolean']>;
  config?: InputMaybe<Scalars['jsonb']>;
  config_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  health?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_effectively_disabled?: InputMaybe<Scalars['Boolean']>;
  is_streaming?: InputMaybe<Scalars['Boolean']>;
  last_run_at?: InputMaybe<Scalars['timestamptz']>;
  last_run_planner_type?: InputMaybe<Scalars['String']>;
  matchbooster_region?: InputMaybe<Scalars['String']>;
  monitoring?: InputMaybe<Scalars['jsonb']>;
  next_diff_mode_override?: InputMaybe<Scalars['String']>;
  row_threshold_attempted?: InputMaybe<Scalars['bigint']>;
  row_threshold_total?: InputMaybe<Scalars['bigint']>;
  schedule?: InputMaybe<Scalars['jsonb']>;
  schedule_paused?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  slug?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  sync_template_overrides?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  warehouse_export_settings?: InputMaybe<Scalars['jsonb']>;
  warehouse_history_config?: InputMaybe<Scalars['jsonb']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SyncsSumFields = {
  __typename?: 'syncs_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  destination_id?: Maybe<Scalars['bigint']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  row_threshold_attempted?: Maybe<Scalars['bigint']>;
  row_threshold_total?: Maybe<Scalars['bigint']>;
  segment_id?: Maybe<Scalars['bigint']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "syncs" */
export type SyncsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "syncs_to_journeys" */
export type SyncsToJourneys = {
  __typename?: 'syncs_to_journeys';
  is_latest?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  journey?: Maybe<Journeys>;
  journey_id?: Maybe<Scalars['uuid']>;
  journey_version_id?: Maybe<Scalars['uuid']>;
  segment_id?: Maybe<Scalars['bigint']>;
  sync_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "syncs_to_journeys". All fields are combined with a logical 'AND'. */
export type SyncsToJourneysBoolExp = {
  _and?: InputMaybe<Array<SyncsToJourneysBoolExp>>;
  _not?: InputMaybe<SyncsToJourneysBoolExp>;
  _or?: InputMaybe<Array<SyncsToJourneysBoolExp>>;
  is_latest?: InputMaybe<BooleanComparisonExp>;
  journey?: InputMaybe<JourneysBoolExp>;
  journey_id?: InputMaybe<UuidComparisonExp>;
  journey_version_id?: InputMaybe<UuidComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  sync_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "syncs_to_journeys". */
export type SyncsToJourneysOrderBy = {
  is_latest?: InputMaybe<OrderBy>;
  journey?: InputMaybe<JourneysOrderBy>;
  journey_id?: InputMaybe<OrderBy>;
  journey_version_id?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "syncs_to_journeys" */
export const SyncsToJourneysSelectColumn = {
  /** column name */
  IsLatest: 'is_latest',
  /** column name */
  JourneyId: 'journey_id',
  /** column name */
  JourneyVersionId: 'journey_version_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  SyncId: 'sync_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type SyncsToJourneysSelectColumn = typeof SyncsToJourneysSelectColumn[keyof typeof SyncsToJourneysSelectColumn];
/** Streaming cursor of the table "syncs_to_journeys" */
export type SyncsToJourneysStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SyncsToJourneysStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SyncsToJourneysStreamCursorValueInput = {
  is_latest?: InputMaybe<Scalars['Boolean']>;
  journey_id?: InputMaybe<Scalars['uuid']>;
  journey_version_id?: InputMaybe<Scalars['uuid']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  sync_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type SyncsVarPopFields = {
  __typename?: 'syncs_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "syncs" */
export type SyncsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type SyncsVarSampFields = {
  __typename?: 'syncs_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "syncs" */
export type SyncsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type SyncsVarianceFields = {
  __typename?: 'syncs_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  /** Scheduled refresh cadence in days, with the sync's own value taking precedence over its template's. */
  full_resync_interval?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Float']>;
  row_threshold_attempted?: Maybe<Scalars['Float']>;
  row_threshold_total?: Maybe<Scalars['Float']>;
  segment_id?: Maybe<Scalars['Float']>;
  sync_template_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "syncs" */
export type SyncsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  row_threshold_attempted?: InputMaybe<OrderBy>;
  row_threshold_total?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "through_model_relationships" */
export type ThroughModelRelationships = {
  __typename?: 'through_model_relationships';
  path_segment_id: Scalars['bigint'];
  /** An object relationship */
  relationship: ModelRelationships;
  relationship_id: Scalars['bigint'];
};

/** order by aggregate values of table "through_model_relationships" */
export type ThroughModelRelationshipsAggregateOrderBy = {
  avg?: InputMaybe<ThroughModelRelationshipsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ThroughModelRelationshipsMaxOrderBy>;
  min?: InputMaybe<ThroughModelRelationshipsMinOrderBy>;
  stddev?: InputMaybe<ThroughModelRelationshipsStddevOrderBy>;
  stddev_pop?: InputMaybe<ThroughModelRelationshipsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ThroughModelRelationshipsStddevSampOrderBy>;
  sum?: InputMaybe<ThroughModelRelationshipsSumOrderBy>;
  var_pop?: InputMaybe<ThroughModelRelationshipsVarPopOrderBy>;
  var_samp?: InputMaybe<ThroughModelRelationshipsVarSampOrderBy>;
  variance?: InputMaybe<ThroughModelRelationshipsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "through_model_relationships" */
export type ThroughModelRelationshipsArrRelInsertInput = {
  data: Array<ThroughModelRelationshipsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ThroughModelRelationshipsOnConflict>;
};

/** order by avg() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsAvgOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "through_model_relationships". All fields are combined with a logical 'AND'. */
export type ThroughModelRelationshipsBoolExp = {
  _and?: InputMaybe<Array<ThroughModelRelationshipsBoolExp>>;
  _not?: InputMaybe<ThroughModelRelationshipsBoolExp>;
  _or?: InputMaybe<Array<ThroughModelRelationshipsBoolExp>>;
  path_segment_id?: InputMaybe<BigintComparisonExp>;
  relationship?: InputMaybe<ModelRelationshipsBoolExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "through_model_relationships" */
export const ThroughModelRelationshipsConstraint = {
  /** unique or primary key constraint on columns "relationship_id", "path_segment_id" */
  ThroughModelRelationshipsPkey: 'through_model_relationships_pkey'
} as const;

export type ThroughModelRelationshipsConstraint = typeof ThroughModelRelationshipsConstraint[keyof typeof ThroughModelRelationshipsConstraint];
/** input type for incrementing numeric columns in table "through_model_relationships" */
export type ThroughModelRelationshipsIncInput = {
  path_segment_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "through_model_relationships" */
export type ThroughModelRelationshipsInsertInput = {
  path_segment_id?: InputMaybe<Scalars['bigint']>;
  relationship?: InputMaybe<ModelRelationshipsObjRelInsertInput>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsMaxOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsMinOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "through_model_relationships" */
export type ThroughModelRelationshipsMutationResponse = {
  __typename?: 'through_model_relationships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ThroughModelRelationships>;
};

/** on_conflict condition type for table "through_model_relationships" */
export type ThroughModelRelationshipsOnConflict = {
  constraint: ThroughModelRelationshipsConstraint;
  update_columns?: Array<ThroughModelRelationshipsUpdateColumn>;
  where?: InputMaybe<ThroughModelRelationshipsBoolExp>;
};

/** Ordering options when selecting data from "through_model_relationships". */
export type ThroughModelRelationshipsOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship?: InputMaybe<ModelRelationshipsOrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: through_model_relationships */
export type ThroughModelRelationshipsPkColumnsInput = {
  path_segment_id: Scalars['bigint'];
  relationship_id: Scalars['bigint'];
};

/** select columns of table "through_model_relationships" */
export const ThroughModelRelationshipsSelectColumn = {
  /** column name */
  PathSegmentId: 'path_segment_id',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type ThroughModelRelationshipsSelectColumn = typeof ThroughModelRelationshipsSelectColumn[keyof typeof ThroughModelRelationshipsSelectColumn];
/** input type for updating data in table "through_model_relationships" */
export type ThroughModelRelationshipsSetInput = {
  path_segment_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** order by stddev() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevPopOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsStddevSampOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "through_model_relationships" */
export type ThroughModelRelationshipsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ThroughModelRelationshipsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ThroughModelRelationshipsStreamCursorValueInput = {
  path_segment_id?: InputMaybe<Scalars['bigint']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsSumOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** update columns of table "through_model_relationships" */
export const ThroughModelRelationshipsUpdateColumn = {
  /** column name */
  PathSegmentId: 'path_segment_id',
  /** column name */
  RelationshipId: 'relationship_id'
} as const;

export type ThroughModelRelationshipsUpdateColumn = typeof ThroughModelRelationshipsUpdateColumn[keyof typeof ThroughModelRelationshipsUpdateColumn];
export type ThroughModelRelationshipsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ThroughModelRelationshipsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ThroughModelRelationshipsSetInput>;
  /** filter the rows which have to be updated */
  where: ThroughModelRelationshipsBoolExp;
};

/** order by var_pop() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarPopOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarSampOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "through_model_relationships" */
export type ThroughModelRelationshipsVarianceOrderBy = {
  path_segment_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "top_k_trait_status" */
export type TopKTraitStatus = {
  __typename?: 'top_k_trait_status';
  last_sync_attempted?: Maybe<Scalars['timestamp']>;
  last_sync_completed?: Maybe<Scalars['timestamp']>;
  top_k_error?: Maybe<Scalars['String']>;
  /** An object relationship */
  trait_definition: TraitDefinitions;
  trait_id: Scalars['uuid'];
};

/** order by aggregate values of table "top_k_trait_status" */
export type TopKTraitStatusAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TopKTraitStatusMaxOrderBy>;
  min?: InputMaybe<TopKTraitStatusMinOrderBy>;
};

/** Boolean expression to filter rows from the table "top_k_trait_status". All fields are combined with a logical 'AND'. */
export type TopKTraitStatusBoolExp = {
  _and?: InputMaybe<Array<TopKTraitStatusBoolExp>>;
  _not?: InputMaybe<TopKTraitStatusBoolExp>;
  _or?: InputMaybe<Array<TopKTraitStatusBoolExp>>;
  last_sync_attempted?: InputMaybe<TimestampComparisonExp>;
  last_sync_completed?: InputMaybe<TimestampComparisonExp>;
  top_k_error?: InputMaybe<StringComparisonExp>;
  trait_definition?: InputMaybe<TraitDefinitionsBoolExp>;
  trait_id?: InputMaybe<UuidComparisonExp>;
};

/** order by max() on columns of table "top_k_trait_status" */
export type TopKTraitStatusMaxOrderBy = {
  last_sync_attempted?: InputMaybe<OrderBy>;
  last_sync_completed?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  trait_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "top_k_trait_status" */
export type TopKTraitStatusMinOrderBy = {
  last_sync_attempted?: InputMaybe<OrderBy>;
  last_sync_completed?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  trait_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "top_k_trait_status". */
export type TopKTraitStatusOrderBy = {
  last_sync_attempted?: InputMaybe<OrderBy>;
  last_sync_completed?: InputMaybe<OrderBy>;
  top_k_error?: InputMaybe<OrderBy>;
  trait_definition?: InputMaybe<TraitDefinitionsOrderBy>;
  trait_id?: InputMaybe<OrderBy>;
};

/** select columns of table "top_k_trait_status" */
export const TopKTraitStatusSelectColumn = {
  /** column name */
  LastSyncAttempted: 'last_sync_attempted',
  /** column name */
  LastSyncCompleted: 'last_sync_completed',
  /** column name */
  TopKError: 'top_k_error',
  /** column name */
  TraitId: 'trait_id'
} as const;

export type TopKTraitStatusSelectColumn = typeof TopKTraitStatusSelectColumn[keyof typeof TopKTraitStatusSelectColumn];
/** Streaming cursor of the table "top_k_trait_status" */
export type TopKTraitStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TopKTraitStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TopKTraitStatusStreamCursorValueInput = {
  last_sync_attempted?: InputMaybe<Scalars['timestamp']>;
  last_sync_completed?: InputMaybe<Scalars['timestamp']>;
  top_k_error?: InputMaybe<Scalars['String']>;
  trait_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiences = {
  __typename?: 'tracked_audience_list_audiences';
  /** An object relationship */
  audience: Segments;
  audience_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  list: TrackedAudienceLists;
  list_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** order by aggregate values of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesAggregateOrderBy = {
  avg?: InputMaybe<TrackedAudienceListAudiencesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedAudienceListAudiencesMaxOrderBy>;
  min?: InputMaybe<TrackedAudienceListAudiencesMinOrderBy>;
  stddev?: InputMaybe<TrackedAudienceListAudiencesStddevOrderBy>;
  stddev_pop?: InputMaybe<TrackedAudienceListAudiencesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TrackedAudienceListAudiencesStddevSampOrderBy>;
  sum?: InputMaybe<TrackedAudienceListAudiencesSumOrderBy>;
  var_pop?: InputMaybe<TrackedAudienceListAudiencesVarPopOrderBy>;
  var_samp?: InputMaybe<TrackedAudienceListAudiencesVarSampOrderBy>;
  variance?: InputMaybe<TrackedAudienceListAudiencesVarianceOrderBy>;
};

/** order by avg() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesAvgOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_audience_list_audiences". All fields are combined with a logical 'AND'. */
export type TrackedAudienceListAudiencesBoolExp = {
  _and?: InputMaybe<Array<TrackedAudienceListAudiencesBoolExp>>;
  _not?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
  _or?: InputMaybe<Array<TrackedAudienceListAudiencesBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  audience_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  list?: InputMaybe<TrackedAudienceListsBoolExp>;
  list_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "tracked_audience_list_audiences" */
export const TrackedAudienceListAudiencesConstraint = {
  /** unique or primary key constraint on columns "list_id", "audience_id" */
  TrackedAudienceListAudiencesPkey: 'tracked_audience_list_audiences_pkey'
} as const;

export type TrackedAudienceListAudiencesConstraint = typeof TrackedAudienceListAudiencesConstraint[keyof typeof TrackedAudienceListAudiencesConstraint];
/** input type for inserting data into table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesInsertInput = {
  audience?: InputMaybe<SegmentsObjRelInsertInput>;
  audience_id?: InputMaybe<Scalars['bigint']>;
  list_id?: InputMaybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesMaxOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  list_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesMinOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  list_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesMutationResponse = {
  __typename?: 'tracked_audience_list_audiences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedAudienceListAudiences>;
};

/** on_conflict condition type for table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesOnConflict = {
  constraint: TrackedAudienceListAudiencesConstraint;
  update_columns?: Array<TrackedAudienceListAudiencesUpdateColumn>;
  where?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
};

/** Ordering options when selecting data from "tracked_audience_list_audiences". */
export type TrackedAudienceListAudiencesOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  audience_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  list?: InputMaybe<TrackedAudienceListsOrderBy>;
  list_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "tracked_audience_list_audiences" */
export const TrackedAudienceListAudiencesSelectColumn = {
  /** column name */
  AudienceId: 'audience_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  ListId: 'list_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TrackedAudienceListAudiencesSelectColumn = typeof TrackedAudienceListAudiencesSelectColumn[keyof typeof TrackedAudienceListAudiencesSelectColumn];
/** order by stddev() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesStddevOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesStddevPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesStddevSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TrackedAudienceListAudiencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedAudienceListAudiencesStreamCursorValueInput = {
  audience_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  list_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesSumOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** placeholder for update columns of table "tracked_audience_list_audiences" (current role has no relevant permissions) */
export const TrackedAudienceListAudiencesUpdateColumn = {
  /** placeholder (do not use) */
  Placeholder: '_PLACEHOLDER'
} as const;

export type TrackedAudienceListAudiencesUpdateColumn = typeof TrackedAudienceListAudiencesUpdateColumn[keyof typeof TrackedAudienceListAudiencesUpdateColumn];
/** order by var_pop() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesVarPopOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesVarSampOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "tracked_audience_list_audiences" */
export type TrackedAudienceListAudiencesVarianceOrderBy = {
  audience_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "tracked_audience_lists" */
export type TrackedAudienceLists = {
  __typename?: 'tracked_audience_lists';
  audience_selection_mode: Scalars['String'];
  /** An array relationship */
  audiences: Array<TrackedAudienceListAudiences>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['bigint']>;
  enabled: Scalars['Boolean'];
  freshness_seconds: Scalars['Int'];
  id: Scalars['uuid'];
  /** When output_format = 'object', emit the audience's name (from segments.name) as audience_name. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_audience_name: Scalars['Boolean'];
  /** When output_format = 'object', emit the membership's split group as split_group. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_split_group: Scalars['Boolean'];
  output_format: Scalars['String'];
  /** An object relationship */
  parent_model: Segments;
  parent_model_id: Scalars['bigint'];
  /** An object relationship */
  trait_definition: TraitDefinitions;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "tracked_audience_lists" */
export type TrackedAudienceListsAudiencesArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListAudiencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListAudiencesOrderBy>>;
  where?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
};

/** aggregated selection of "tracked_audience_lists" */
export type TrackedAudienceListsAggregate = {
  __typename?: 'tracked_audience_lists_aggregate';
  aggregate?: Maybe<TrackedAudienceListsAggregateFields>;
  nodes: Array<TrackedAudienceLists>;
};

export type TrackedAudienceListsAggregateBoolExp = {
  bool_and?: InputMaybe<TrackedAudienceListsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TrackedAudienceListsAggregateBoolExpBoolOr>;
  count?: InputMaybe<TrackedAudienceListsAggregateBoolExpCount>;
};

export type TrackedAudienceListsAggregateBoolExpBoolAnd = {
  arguments: TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TrackedAudienceListsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TrackedAudienceListsAggregateBoolExpBoolOr = {
  arguments: TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TrackedAudienceListsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TrackedAudienceListsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TrackedAudienceListsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "tracked_audience_lists" */
export type TrackedAudienceListsAggregateFields = {
  __typename?: 'tracked_audience_lists_aggregate_fields';
  avg?: Maybe<TrackedAudienceListsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TrackedAudienceListsMaxFields>;
  min?: Maybe<TrackedAudienceListsMinFields>;
  stddev?: Maybe<TrackedAudienceListsStddevFields>;
  stddev_pop?: Maybe<TrackedAudienceListsStddevPopFields>;
  stddev_samp?: Maybe<TrackedAudienceListsStddevSampFields>;
  sum?: Maybe<TrackedAudienceListsSumFields>;
  var_pop?: Maybe<TrackedAudienceListsVarPopFields>;
  var_samp?: Maybe<TrackedAudienceListsVarSampFields>;
  variance?: Maybe<TrackedAudienceListsVarianceFields>;
};


/** aggregate fields of "tracked_audience_lists" */
export type TrackedAudienceListsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tracked_audience_lists" */
export type TrackedAudienceListsAggregateOrderBy = {
  avg?: InputMaybe<TrackedAudienceListsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TrackedAudienceListsMaxOrderBy>;
  min?: InputMaybe<TrackedAudienceListsMinOrderBy>;
  stddev?: InputMaybe<TrackedAudienceListsStddevOrderBy>;
  stddev_pop?: InputMaybe<TrackedAudienceListsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TrackedAudienceListsStddevSampOrderBy>;
  sum?: InputMaybe<TrackedAudienceListsSumOrderBy>;
  var_pop?: InputMaybe<TrackedAudienceListsVarPopOrderBy>;
  var_samp?: InputMaybe<TrackedAudienceListsVarSampOrderBy>;
  variance?: InputMaybe<TrackedAudienceListsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type TrackedAudienceListsAvgFields = {
  __typename?: 'tracked_audience_lists_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "tracked_audience_lists". All fields are combined with a logical 'AND'. */
export type TrackedAudienceListsBoolExp = {
  _and?: InputMaybe<Array<TrackedAudienceListsBoolExp>>;
  _not?: InputMaybe<TrackedAudienceListsBoolExp>;
  _or?: InputMaybe<Array<TrackedAudienceListsBoolExp>>;
  audience_selection_mode?: InputMaybe<StringComparisonExp>;
  audiences?: InputMaybe<TrackedAudienceListAudiencesBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  freshness_seconds?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  include_audience_name?: InputMaybe<BooleanComparisonExp>;
  include_split_group?: InputMaybe<BooleanComparisonExp>;
  output_format?: InputMaybe<StringComparisonExp>;
  parent_model?: InputMaybe<SegmentsBoolExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  trait_definition?: InputMaybe<TraitDefinitionsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "tracked_audience_lists" */
export type TrackedAudienceListsIncInput = {
  freshness_seconds?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TrackedAudienceListsMaxFields = {
  __typename?: 'tracked_audience_lists_max_fields';
  audience_selection_mode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  freshness_seconds?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  output_format?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsMaxOrderBy = {
  audience_selection_mode?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  output_format?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TrackedAudienceListsMinFields = {
  __typename?: 'tracked_audience_lists_min_fields';
  audience_selection_mode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  freshness_seconds?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  output_format?: Maybe<Scalars['String']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsMinOrderBy = {
  audience_selection_mode?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  output_format?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tracked_audience_lists" */
export type TrackedAudienceListsMutationResponse = {
  __typename?: 'tracked_audience_lists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TrackedAudienceLists>;
};

/** Ordering options when selecting data from "tracked_audience_lists". */
export type TrackedAudienceListsOrderBy = {
  audience_selection_mode?: InputMaybe<OrderBy>;
  audiences_aggregate?: InputMaybe<TrackedAudienceListAudiencesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  include_audience_name?: InputMaybe<OrderBy>;
  include_split_group?: InputMaybe<OrderBy>;
  output_format?: InputMaybe<OrderBy>;
  parent_model?: InputMaybe<SegmentsOrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  trait_definition?: InputMaybe<TraitDefinitionsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tracked_audience_lists */
export type TrackedAudienceListsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "tracked_audience_lists" */
export const TrackedAudienceListsSelectColumn = {
  /** column name */
  AudienceSelectionMode: 'audience_selection_mode',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Enabled: 'enabled',
  /** column name */
  FreshnessSeconds: 'freshness_seconds',
  /** column name */
  Id: 'id',
  /** column name */
  IncludeAudienceName: 'include_audience_name',
  /** column name */
  IncludeSplitGroup: 'include_split_group',
  /** column name */
  OutputFormat: 'output_format',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TrackedAudienceListsSelectColumn = typeof TrackedAudienceListsSelectColumn[keyof typeof TrackedAudienceListsSelectColumn];
/** select "tracked_audience_lists_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tracked_audience_lists" */
export const TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  IncludeAudienceName: 'include_audience_name',
  /** column name */
  IncludeSplitGroup: 'include_split_group'
} as const;

export type TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolAndArgumentsColumns = typeof TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolAndArgumentsColumns];
/** select "tracked_audience_lists_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tracked_audience_lists" */
export const TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  Enabled: 'enabled',
  /** column name */
  IncludeAudienceName: 'include_audience_name',
  /** column name */
  IncludeSplitGroup: 'include_split_group'
} as const;

export type TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolOrArgumentsColumns = typeof TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof TrackedAudienceListsSelectColumnTrackedAudienceListsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "tracked_audience_lists" */
export type TrackedAudienceListsSetInput = {
  audience_selection_mode?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  freshness_seconds?: InputMaybe<Scalars['Int']>;
  /** When output_format = 'object', emit the audience's name (from segments.name) as audience_name. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_audience_name?: InputMaybe<Scalars['Boolean']>;
  /** When output_format = 'object', emit the membership's split group as split_group. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_split_group?: InputMaybe<Scalars['Boolean']>;
  output_format?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TrackedAudienceListsStddevFields = {
  __typename?: 'tracked_audience_lists_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type TrackedAudienceListsStddevPopFields = {
  __typename?: 'tracked_audience_lists_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type TrackedAudienceListsStddevSampFields = {
  __typename?: 'tracked_audience_lists_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "tracked_audience_lists" */
export type TrackedAudienceListsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TrackedAudienceListsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TrackedAudienceListsStreamCursorValueInput = {
  audience_selection_mode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  freshness_seconds?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** When output_format = 'object', emit the audience's name (from segments.name) as audience_name. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_audience_name?: InputMaybe<Scalars['Boolean']>;
  /** When output_format = 'object', emit the membership's split group as split_group. Must be false for output_format = 'id' (see tracked_audience_lists_object_fields_valid). */
  include_split_group?: InputMaybe<Scalars['Boolean']>;
  output_format?: InputMaybe<Scalars['String']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TrackedAudienceListsSumFields = {
  __typename?: 'tracked_audience_lists_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  freshness_seconds?: Maybe<Scalars['Int']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type TrackedAudienceListsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TrackedAudienceListsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TrackedAudienceListsSetInput>;
  /** filter the rows which have to be updated */
  where: TrackedAudienceListsBoolExp;
};

/** aggregate var_pop on columns */
export type TrackedAudienceListsVarPopFields = {
  __typename?: 'tracked_audience_lists_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type TrackedAudienceListsVarSampFields = {
  __typename?: 'tracked_audience_lists_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TrackedAudienceListsVarianceFields = {
  __typename?: 'tracked_audience_lists_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  freshness_seconds?: Maybe<Scalars['Float']>;
  parent_model_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tracked_audience_lists" */
export type TrackedAudienceListsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  freshness_seconds?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Used for Audiences */
export type TraitDefinitions = {
  __typename?: 'trait_definitions';
  archived_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  child_traits: Array<TraitDefinitions>;
  /** An aggregate relationship */
  child_traits_aggregate: TraitDefinitionsAggregate;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['bigint'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_template: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  predictor?: Maybe<Predictors>;
  predictor_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  relationship?: Maybe<ModelRelationships>;
  relationship_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  segment: Segments;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id: Scalars['bigint'];
  top_k_enabled: Scalars['Boolean'];
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  /** An array relationship */
  top_k_trait_statuses: Array<TopKTraitStatus>;
  /** An array relationship */
  tracked_audience_list: Array<TrackedAudienceLists>;
  /** An aggregate relationship */
  tracked_audience_list_aggregate: TrackedAudienceListsAggregate;
  trait_references_v2: ListAllTraitReferencesResultV2;
  trait_template_id?: Maybe<Scalars['uuid']>;
  trigger_top_k_sync?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};


/** Used for Audiences */
export type TraitDefinitionsChildTraitsArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


/** Used for Audiences */
export type TraitDefinitionsChildTraitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TraitDefinitionsOrderBy>>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};


/** Used for Audiences */
export type TraitDefinitionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Used for Audiences */
export type TraitDefinitionsTopKTraitStatusesArgs = {
  distinct_on?: InputMaybe<Array<TopKTraitStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TopKTraitStatusOrderBy>>;
  where?: InputMaybe<TopKTraitStatusBoolExp>;
};


/** Used for Audiences */
export type TraitDefinitionsTrackedAudienceListArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};


/** Used for Audiences */
export type TraitDefinitionsTrackedAudienceListAggregateArgs = {
  distinct_on?: InputMaybe<Array<TrackedAudienceListsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TrackedAudienceListsOrderBy>>;
  where?: InputMaybe<TrackedAudienceListsBoolExp>;
};

/** aggregated selection of "trait_definitions" */
export type TraitDefinitionsAggregate = {
  __typename?: 'trait_definitions_aggregate';
  aggregate?: Maybe<TraitDefinitionsAggregateFields>;
  nodes: Array<TraitDefinitions>;
};

export type TraitDefinitionsAggregateBoolExp = {
  bool_and?: InputMaybe<TraitDefinitionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TraitDefinitionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<TraitDefinitionsAggregateBoolExpCount>;
};

export type TraitDefinitionsAggregateBoolExpBoolAnd = {
  arguments: TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TraitDefinitionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TraitDefinitionsAggregateBoolExpBoolOr = {
  arguments: TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TraitDefinitionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TraitDefinitionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TraitDefinitionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "trait_definitions" */
export type TraitDefinitionsAggregateFields = {
  __typename?: 'trait_definitions_aggregate_fields';
  avg?: Maybe<TraitDefinitionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TraitDefinitionsMaxFields>;
  min?: Maybe<TraitDefinitionsMinFields>;
  stddev?: Maybe<TraitDefinitionsStddevFields>;
  stddev_pop?: Maybe<TraitDefinitionsStddevPopFields>;
  stddev_samp?: Maybe<TraitDefinitionsStddevSampFields>;
  sum?: Maybe<TraitDefinitionsSumFields>;
  var_pop?: Maybe<TraitDefinitionsVarPopFields>;
  var_samp?: Maybe<TraitDefinitionsVarSampFields>;
  variance?: Maybe<TraitDefinitionsVarianceFields>;
};


/** aggregate fields of "trait_definitions" */
export type TraitDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TraitDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trait_definitions" */
export type TraitDefinitionsAggregateOrderBy = {
  avg?: InputMaybe<TraitDefinitionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TraitDefinitionsMaxOrderBy>;
  min?: InputMaybe<TraitDefinitionsMinOrderBy>;
  stddev?: InputMaybe<TraitDefinitionsStddevOrderBy>;
  stddev_pop?: InputMaybe<TraitDefinitionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TraitDefinitionsStddevSampOrderBy>;
  sum?: InputMaybe<TraitDefinitionsSumOrderBy>;
  var_pop?: InputMaybe<TraitDefinitionsVarPopOrderBy>;
  var_samp?: InputMaybe<TraitDefinitionsVarSampOrderBy>;
  variance?: InputMaybe<TraitDefinitionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TraitDefinitionsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "trait_definitions" */
export type TraitDefinitionsArrRelInsertInput = {
  data: Array<TraitDefinitionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TraitDefinitionsOnConflict>;
};

/** aggregate avg on columns */
export type TraitDefinitionsAvgFields = {
  __typename?: 'trait_definitions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trait_definitions" */
export type TraitDefinitionsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "trait_definitions". All fields are combined with a logical 'AND'. */
export type TraitDefinitionsBoolExp = {
  _and?: InputMaybe<Array<TraitDefinitionsBoolExp>>;
  _not?: InputMaybe<TraitDefinitionsBoolExp>;
  _or?: InputMaybe<Array<TraitDefinitionsBoolExp>>;
  archived_at?: InputMaybe<TimestamptzComparisonExp>;
  child_traits?: InputMaybe<TraitDefinitionsBoolExp>;
  child_traits_aggregate?: InputMaybe<TraitDefinitionsAggregateBoolExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<BigintComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  is_template?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  predictor?: InputMaybe<PredictorsBoolExp>;
  predictor_id?: InputMaybe<UuidComparisonExp>;
  relationship?: InputMaybe<ModelRelationshipsBoolExp>;
  relationship_id?: InputMaybe<BigintComparisonExp>;
  segment?: InputMaybe<SegmentsBoolExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  top_k_enabled?: InputMaybe<BooleanComparisonExp>;
  top_k_sync_interval?: InputMaybe<IntComparisonExp>;
  top_k_trait_statuses?: InputMaybe<TopKTraitStatusBoolExp>;
  tracked_audience_list?: InputMaybe<TrackedAudienceListsBoolExp>;
  tracked_audience_list_aggregate?: InputMaybe<TrackedAudienceListsAggregateBoolExp>;
  trait_template_id?: InputMaybe<UuidComparisonExp>;
  trigger_top_k_sync?: InputMaybe<BooleanComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "trait_definitions" */
export const TraitDefinitionsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  TraitDefinitionsIdWorkspaceIdKey: 'trait_definitions_id_workspace_id_key',
  /** unique or primary key constraint on columns "segment_id", "name", "journey_id" */
  TraitDefinitionsNameSegmentIdJourneyIdKey: 'trait_definitions_name_segment_id_journey_id_key',
  /** unique or primary key constraint on columns "id" */
  TraitDefinitionsPkey: 'trait_definitions_pkey'
} as const;

export type TraitDefinitionsConstraint = typeof TraitDefinitionsConstraint[keyof typeof TraitDefinitionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TraitDefinitionsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TraitDefinitionsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TraitDefinitionsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "trait_definitions" */
export type TraitDefinitionsIncInput = {
  relationship_id?: InputMaybe<Scalars['bigint']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trait_definitions" */
export type TraitDefinitionsInsertInput = {
  child_traits?: InputMaybe<TraitDefinitionsArrRelInsertInput>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  predictor_id?: InputMaybe<Scalars['uuid']>;
  relationship?: InputMaybe<ModelRelationshipsObjRelInsertInput>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  segment?: InputMaybe<SegmentsObjRelInsertInput>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<Scalars['bigint']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trait_template_id?: InputMaybe<Scalars['uuid']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TraitDefinitionsMaxFields = {
  __typename?: 'trait_definitions_max_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['bigint']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  trait_template_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trait_definitions" */
export type TraitDefinitionsMaxOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  trait_template_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TraitDefinitionsMinFields = {
  __typename?: 'trait_definitions_min_fields';
  archived_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  predictor_id?: Maybe<Scalars['uuid']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['bigint']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  trait_template_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trait_definitions" */
export type TraitDefinitionsMinOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  trait_template_id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "trait_definitions" */
export type TraitDefinitionsMutationResponse = {
  __typename?: 'trait_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TraitDefinitions>;
};

/** on_conflict condition type for table "trait_definitions" */
export type TraitDefinitionsOnConflict = {
  constraint: TraitDefinitionsConstraint;
  update_columns?: Array<TraitDefinitionsUpdateColumn>;
  where?: InputMaybe<TraitDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "trait_definitions". */
export type TraitDefinitionsOrderBy = {
  archived_at?: InputMaybe<OrderBy>;
  child_traits_aggregate?: InputMaybe<TraitDefinitionsAggregateOrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_template?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  predictor?: InputMaybe<PredictorsOrderBy>;
  predictor_id?: InputMaybe<OrderBy>;
  relationship?: InputMaybe<ModelRelationshipsOrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  segment?: InputMaybe<SegmentsOrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  top_k_enabled?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  top_k_trait_statuses_aggregate?: InputMaybe<TopKTraitStatusAggregateOrderBy>;
  tracked_audience_list_aggregate?: InputMaybe<TrackedAudienceListsAggregateOrderBy>;
  trait_template_id?: InputMaybe<OrderBy>;
  trigger_top_k_sync?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: trait_definitions */
export type TraitDefinitionsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TraitDefinitionsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "trait_definitions" */
export const TraitDefinitionsSelectColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  Config: 'config',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  CreatedBy: 'created_by',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  IsTemplate: 'is_template',
  /** column name */
  Name: 'name',
  /** column name */
  PredictorId: 'predictor_id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TraitTemplateId: 'trait_template_id',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UpdatedBy: 'updated_by',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TraitDefinitionsSelectColumn = typeof TraitDefinitionsSelectColumn[keyof typeof TraitDefinitionsSelectColumn];
/** select "trait_definitions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trait_definitions" */
export const TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsTemplate: 'is_template',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync'
} as const;

export type TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolAndArgumentsColumns = typeof TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolAndArgumentsColumns];
/** select "trait_definitions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trait_definitions" */
export const TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsTemplate: 'is_template',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync'
} as const;

export type TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolOrArgumentsColumns = typeof TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof TraitDefinitionsSelectColumnTraitDefinitionsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "trait_definitions" */
export type TraitDefinitionsSetInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  predictor_id?: InputMaybe<Scalars['uuid']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TraitDefinitionsStddevFields = {
  __typename?: 'trait_definitions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type TraitDefinitionsStddevPopFields = {
  __typename?: 'trait_definitions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type TraitDefinitionsStddevSampFields = {
  __typename?: 'trait_definitions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trait_definitions" */
export type TraitDefinitionsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "trait_definitions" */
export type TraitDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TraitDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TraitDefinitionsStreamCursorValueInput = {
  archived_at?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  predictor_id?: InputMaybe<Scalars['uuid']>;
  relationship_id?: InputMaybe<Scalars['bigint']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<Scalars['bigint']>;
  top_k_enabled?: InputMaybe<Scalars['Boolean']>;
  top_k_sync_interval?: InputMaybe<Scalars['Int']>;
  trait_template_id?: InputMaybe<Scalars['uuid']>;
  trigger_top_k_sync?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TraitDefinitionsSumFields = {
  __typename?: 'trait_definitions_sum_fields';
  created_by?: Maybe<Scalars['bigint']>;
  relationship_id?: Maybe<Scalars['bigint']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['bigint']>;
  top_k_sync_interval?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trait_definitions" */
export type TraitDefinitionsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "trait_definitions" */
export const TraitDefinitionsUpdateColumn = {
  /** column name */
  ArchivedAt: 'archived_at',
  /** column name */
  Config: 'config',
  /** column name */
  Description: 'description',
  /** column name */
  Name: 'name',
  /** column name */
  PredictorId: 'predictor_id',
  /** column name */
  RelationshipId: 'relationship_id',
  /** column name */
  TopKEnabled: 'top_k_enabled',
  /** column name */
  TopKSyncInterval: 'top_k_sync_interval',
  /** column name */
  TriggerTopKSync: 'trigger_top_k_sync',
  /** column name */
  Type: 'type'
} as const;

export type TraitDefinitionsUpdateColumn = typeof TraitDefinitionsUpdateColumn[keyof typeof TraitDefinitionsUpdateColumn];
export type TraitDefinitionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TraitDefinitionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TraitDefinitionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TraitDefinitionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TraitDefinitionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TraitDefinitionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TraitDefinitionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TraitDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: TraitDefinitionsBoolExp;
};

/** aggregate var_pop on columns */
export type TraitDefinitionsVarPopFields = {
  __typename?: 'trait_definitions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trait_definitions" */
export type TraitDefinitionsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type TraitDefinitionsVarSampFields = {
  __typename?: 'trait_definitions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trait_definitions" */
export type TraitDefinitionsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TraitDefinitionsVarianceFields = {
  __typename?: 'trait_definitions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  relationship_id?: Maybe<Scalars['Float']>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: Maybe<Scalars['Float']>;
  top_k_sync_interval?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trait_definitions" */
export type TraitDefinitionsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  relationship_id?: InputMaybe<OrderBy>;
  /** The model this trait is defined on. Renamed from parent_model_id, which was a misnomer: it can reference a parent, related, or event model. */
  segment_id?: InputMaybe<OrderBy>;
  top_k_sync_interval?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trait_references" */
export type TraitReferences = {
  __typename?: 'trait_references';
  metadata?: Maybe<Scalars['jsonb']>;
  resource_id: Scalars['String'];
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type: Scalars['String'];
  /** An object relationship */
  trait: TraitDefinitions;
  trait_definition_id: Scalars['uuid'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "trait_references" */
export type TraitReferencesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "trait_references" */
export type TraitReferencesAggregate = {
  __typename?: 'trait_references_aggregate';
  aggregate?: Maybe<TraitReferencesAggregateFields>;
  nodes: Array<TraitReferences>;
};

/** aggregate fields of "trait_references" */
export type TraitReferencesAggregateFields = {
  __typename?: 'trait_references_aggregate_fields';
  avg?: Maybe<TraitReferencesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TraitReferencesMaxFields>;
  min?: Maybe<TraitReferencesMinFields>;
  stddev?: Maybe<TraitReferencesStddevFields>;
  stddev_pop?: Maybe<TraitReferencesStddevPopFields>;
  stddev_samp?: Maybe<TraitReferencesStddevSampFields>;
  sum?: Maybe<TraitReferencesSumFields>;
  var_pop?: Maybe<TraitReferencesVarPopFields>;
  var_samp?: Maybe<TraitReferencesVarSampFields>;
  variance?: Maybe<TraitReferencesVarianceFields>;
};


/** aggregate fields of "trait_references" */
export type TraitReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TraitReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TraitReferencesAvgFields = {
  __typename?: 'trait_references_avg_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trait_references". All fields are combined with a logical 'AND'. */
export type TraitReferencesBoolExp = {
  _and?: InputMaybe<Array<TraitReferencesBoolExp>>;
  _not?: InputMaybe<TraitReferencesBoolExp>;
  _or?: InputMaybe<Array<TraitReferencesBoolExp>>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  resource_id?: InputMaybe<StringComparisonExp>;
  resource_id_bigint?: InputMaybe<BigintComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  trait?: InputMaybe<TraitDefinitionsBoolExp>;
  trait_definition_id?: InputMaybe<UuidComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type TraitReferencesMaxFields = {
  __typename?: 'trait_references_max_fields';
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  trait_definition_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TraitReferencesMinFields = {
  __typename?: 'trait_references_min_fields';
  resource_id?: Maybe<Scalars['String']>;
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  trait_definition_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "trait_references". */
export type TraitReferencesOrderBy = {
  metadata?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_id_bigint?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  trait?: InputMaybe<TraitDefinitionsOrderBy>;
  trait_definition_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "trait_references_segments" */
export type TraitReferencesSegments = {
  __typename?: 'trait_references_segments';
  /** An object relationship */
  audience?: Maybe<Segments>;
  resource_id?: Maybe<Scalars['bigint']>;
  trait_definition_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "trait_references_segments" */
export type TraitReferencesSegmentsAggregate = {
  __typename?: 'trait_references_segments_aggregate';
  aggregate?: Maybe<TraitReferencesSegmentsAggregateFields>;
  nodes: Array<TraitReferencesSegments>;
};

/** aggregate fields of "trait_references_segments" */
export type TraitReferencesSegmentsAggregateFields = {
  __typename?: 'trait_references_segments_aggregate_fields';
  avg?: Maybe<TraitReferencesSegmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TraitReferencesSegmentsMaxFields>;
  min?: Maybe<TraitReferencesSegmentsMinFields>;
  stddev?: Maybe<TraitReferencesSegmentsStddevFields>;
  stddev_pop?: Maybe<TraitReferencesSegmentsStddevPopFields>;
  stddev_samp?: Maybe<TraitReferencesSegmentsStddevSampFields>;
  sum?: Maybe<TraitReferencesSegmentsSumFields>;
  var_pop?: Maybe<TraitReferencesSegmentsVarPopFields>;
  var_samp?: Maybe<TraitReferencesSegmentsVarSampFields>;
  variance?: Maybe<TraitReferencesSegmentsVarianceFields>;
};


/** aggregate fields of "trait_references_segments" */
export type TraitReferencesSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TraitReferencesSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TraitReferencesSegmentsAvgFields = {
  __typename?: 'trait_references_segments_avg_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trait_references_segments". All fields are combined with a logical 'AND'. */
export type TraitReferencesSegmentsBoolExp = {
  _and?: InputMaybe<Array<TraitReferencesSegmentsBoolExp>>;
  _not?: InputMaybe<TraitReferencesSegmentsBoolExp>;
  _or?: InputMaybe<Array<TraitReferencesSegmentsBoolExp>>;
  audience?: InputMaybe<SegmentsBoolExp>;
  resource_id?: InputMaybe<BigintComparisonExp>;
  trait_definition_id?: InputMaybe<UuidComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type TraitReferencesSegmentsMaxFields = {
  __typename?: 'trait_references_segments_max_fields';
  resource_id?: Maybe<Scalars['bigint']>;
  trait_definition_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TraitReferencesSegmentsMinFields = {
  __typename?: 'trait_references_segments_min_fields';
  resource_id?: Maybe<Scalars['bigint']>;
  trait_definition_id?: Maybe<Scalars['uuid']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "trait_references_segments". */
export type TraitReferencesSegmentsOrderBy = {
  audience?: InputMaybe<SegmentsOrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  trait_definition_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "trait_references_segments" */
export const TraitReferencesSegmentsSelectColumn = {
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  TraitDefinitionId: 'trait_definition_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TraitReferencesSegmentsSelectColumn = typeof TraitReferencesSegmentsSelectColumn[keyof typeof TraitReferencesSegmentsSelectColumn];
/** aggregate stddev on columns */
export type TraitReferencesSegmentsStddevFields = {
  __typename?: 'trait_references_segments_stddev_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TraitReferencesSegmentsStddevPopFields = {
  __typename?: 'trait_references_segments_stddev_pop_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TraitReferencesSegmentsStddevSampFields = {
  __typename?: 'trait_references_segments_stddev_samp_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trait_references_segments" */
export type TraitReferencesSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TraitReferencesSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TraitReferencesSegmentsStreamCursorValueInput = {
  resource_id?: InputMaybe<Scalars['bigint']>;
  trait_definition_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TraitReferencesSegmentsSumFields = {
  __typename?: 'trait_references_segments_sum_fields';
  resource_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TraitReferencesSegmentsVarPopFields = {
  __typename?: 'trait_references_segments_var_pop_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TraitReferencesSegmentsVarSampFields = {
  __typename?: 'trait_references_segments_var_samp_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TraitReferencesSegmentsVarianceFields = {
  __typename?: 'trait_references_segments_variance_fields';
  resource_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "trait_references" */
export const TraitReferencesSelectColumn = {
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceIdBigint: 'resource_id_bigint',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  TraitDefinitionId: 'trait_definition_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TraitReferencesSelectColumn = typeof TraitReferencesSelectColumn[keyof typeof TraitReferencesSelectColumn];
/** aggregate stddev on columns */
export type TraitReferencesStddevFields = {
  __typename?: 'trait_references_stddev_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TraitReferencesStddevPopFields = {
  __typename?: 'trait_references_stddev_pop_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TraitReferencesStddevSampFields = {
  __typename?: 'trait_references_stddev_samp_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trait_references" */
export type TraitReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TraitReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TraitReferencesStreamCursorValueInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  resource_id?: InputMaybe<Scalars['String']>;
  resource_id_bigint?: InputMaybe<Scalars['bigint']>;
  resource_type?: InputMaybe<Scalars['String']>;
  trait_definition_id?: InputMaybe<Scalars['uuid']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TraitReferencesSumFields = {
  __typename?: 'trait_references_sum_fields';
  resource_id_bigint?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type TraitReferencesVarPopFields = {
  __typename?: 'trait_references_var_pop_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TraitReferencesVarSampFields = {
  __typename?: 'trait_references_var_samp_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TraitReferencesVarianceFields = {
  __typename?: 'trait_references_variance_fields';
  resource_id_bigint?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tunnels" */
export type Tunnels = {
  __typename?: 'tunnels';
  created_at: Scalars['timestamptz'];
  name: Scalars['String'];
  tunnel_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['Int'];
};

/** Boolean expression to filter rows from the table "tunnels". All fields are combined with a logical 'AND'. */
export type TunnelsBoolExp = {
  _and?: InputMaybe<Array<TunnelsBoolExp>>;
  _not?: InputMaybe<TunnelsBoolExp>;
  _or?: InputMaybe<Array<TunnelsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tunnel_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "tunnels" */
export const TunnelsConstraint = {
  /** unique or primary key constraint on columns "tunnel_id" */
  TunnelsPkey: 'tunnels_pkey',
  /** unique or primary key constraint on columns "workspace_id", "tunnel_id" */
  TunnelsTunnelIdWorkspaceIdKey: 'tunnels_tunnel_id_workspace_id_key'
} as const;

export type TunnelsConstraint = typeof TunnelsConstraint[keyof typeof TunnelsConstraint];
/** input type for inserting data into table "tunnels" */
export type TunnelsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tunnels" */
export type TunnelsMutationResponse = {
  __typename?: 'tunnels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tunnels>;
};

/** input type for inserting object relation for remote table "tunnels" */
export type TunnelsObjRelInsertInput = {
  data: TunnelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TunnelsOnConflict>;
};

/** on_conflict condition type for table "tunnels" */
export type TunnelsOnConflict = {
  constraint: TunnelsConstraint;
  update_columns?: Array<TunnelsUpdateColumn>;
  where?: InputMaybe<TunnelsBoolExp>;
};

/** Ordering options when selecting data from "tunnels". */
export type TunnelsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tunnel_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tunnels */
export type TunnelsPkColumnsInput = {
  tunnel_id: Scalars['uuid'];
};

/** select columns of table "tunnels" */
export const TunnelsSelectColumn = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Name: 'name',
  /** column name */
  TunnelId: 'tunnel_id',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type TunnelsSelectColumn = typeof TunnelsSelectColumn[keyof typeof TunnelsSelectColumn];
/** input type for updating data in table "tunnels" */
export type TunnelsSetInput = {
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tunnels" */
export type TunnelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TunnelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TunnelsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  tunnel_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workspace_id?: InputMaybe<Scalars['Int']>;
};

/** update columns of table "tunnels" */
export const TunnelsUpdateColumn = {
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type TunnelsUpdateColumn = typeof TunnelsUpdateColumn[keyof typeof TunnelsUpdateColumn];
export type TunnelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TunnelsSetInput>;
  /** filter the rows which have to be updated */
  where: TunnelsBoolExp;
};

/** columns and relationships of "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorization = {
  __typename?: 'user_group_audience_creation_authorization';
  can_create?: Maybe<Scalars['Boolean']>;
  can_preview?: Maybe<Scalars['Boolean']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationAggregateOrderBy = {
  avg?: InputMaybe<UserGroupAudienceCreationAuthorizationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupAudienceCreationAuthorizationMaxOrderBy>;
  min?: InputMaybe<UserGroupAudienceCreationAuthorizationMinOrderBy>;
  stddev?: InputMaybe<UserGroupAudienceCreationAuthorizationStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupAudienceCreationAuthorizationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupAudienceCreationAuthorizationStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupAudienceCreationAuthorizationSumOrderBy>;
  var_pop?: InputMaybe<UserGroupAudienceCreationAuthorizationVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupAudienceCreationAuthorizationVarSampOrderBy>;
  variance?: InputMaybe<UserGroupAudienceCreationAuthorizationVarianceOrderBy>;
};

/** order by avg() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationAvgOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_audience_creation_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupAudienceCreationAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupAudienceCreationAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupAudienceCreationAuthorizationBoolExp>>;
  can_create?: InputMaybe<BooleanComparisonExp>;
  can_preview?: InputMaybe<BooleanComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationMaxOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationMinOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_group_audience_creation_authorization". */
export type UserGroupAudienceCreationAuthorizationOrderBy = {
  can_create?: InputMaybe<OrderBy>;
  can_preview?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_audience_creation_authorization" */
export const UserGroupAudienceCreationAuthorizationSelectColumn = {
  /** column name */
  CanCreate: 'can_create',
  /** column name */
  CanPreview: 'can_preview',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupAudienceCreationAuthorizationSelectColumn = typeof UserGroupAudienceCreationAuthorizationSelectColumn[keyof typeof UserGroupAudienceCreationAuthorizationSelectColumn];
/** order by stddev() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationStddevOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationStddevPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationStddevSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupAudienceCreationAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupAudienceCreationAuthorizationStreamCursorValueInput = {
  can_create?: InputMaybe<Scalars['Boolean']>;
  can_preview?: InputMaybe<Scalars['Boolean']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationSumOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationVarPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationVarSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_audience_creation_authorization" */
export type UserGroupAudienceCreationAuthorizationVarianceOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_grants" */
export type UserGroupGrants = {
  __typename?: 'user_group_grants';
  can_access_data: Scalars['Boolean'];
  can_access_decision_engine_agents: Scalars['Boolean'];
  can_configure_journey: Scalars['Boolean'];
  can_draft: Scalars['Boolean'];
  can_edit: Scalars['Boolean'];
  can_manage_schema: Scalars['Boolean'];
  can_manage_trait: Scalars['Boolean'];
  can_run: Scalars['Boolean'];
  can_run_journey: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['bigint'];
  resource_id?: Maybe<Scalars['bigint']>;
  resource_type: Scalars['String'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "user_group_grants" */
export type UserGroupGrantsAggregate = {
  __typename?: 'user_group_grants_aggregate';
  aggregate?: Maybe<UserGroupGrantsAggregateFields>;
  nodes: Array<UserGroupGrants>;
};

/** aggregate fields of "user_group_grants" */
export type UserGroupGrantsAggregateFields = {
  __typename?: 'user_group_grants_aggregate_fields';
  avg?: Maybe<UserGroupGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserGroupGrantsMaxFields>;
  min?: Maybe<UserGroupGrantsMinFields>;
  stddev?: Maybe<UserGroupGrantsStddevFields>;
  stddev_pop?: Maybe<UserGroupGrantsStddevPopFields>;
  stddev_samp?: Maybe<UserGroupGrantsStddevSampFields>;
  sum?: Maybe<UserGroupGrantsSumFields>;
  var_pop?: Maybe<UserGroupGrantsVarPopFields>;
  var_samp?: Maybe<UserGroupGrantsVarSampFields>;
  variance?: Maybe<UserGroupGrantsVarianceFields>;
};


/** aggregate fields of "user_group_grants" */
export type UserGroupGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroupGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserGroupGrantsAvgFields = {
  __typename?: 'user_group_grants_avg_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_group_grants". All fields are combined with a logical 'AND'. */
export type UserGroupGrantsBoolExp = {
  _and?: InputMaybe<Array<UserGroupGrantsBoolExp>>;
  _not?: InputMaybe<UserGroupGrantsBoolExp>;
  _or?: InputMaybe<Array<UserGroupGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_access_decision_engine_agents?: InputMaybe<BooleanComparisonExp>;
  can_configure_journey?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_manage_schema?: InputMaybe<BooleanComparisonExp>;
  can_manage_trait?: InputMaybe<BooleanComparisonExp>;
  can_run?: InputMaybe<BooleanComparisonExp>;
  can_run_journey?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  resource_id?: InputMaybe<BigintComparisonExp>;
  resource_type?: InputMaybe<StringComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "user_group_grants" */
export const UserGroupGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  UserGroupGrantsPkey: 'user_group_grants_pkey',
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "resource_id", "resource_type" */
  UserGroupGrantsResourceTypeResourceIdWorkspaceIdUsKey: 'user_group_grants_resource_type_resource_id_workspace_id_us_key'
} as const;

export type UserGroupGrantsConstraint = typeof UserGroupGrantsConstraint[keyof typeof UserGroupGrantsConstraint];
/** input type for inserting data into table "user_group_grants" */
export type UserGroupGrantsInsertInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_access_decision_engine_agents?: InputMaybe<Scalars['Boolean']>;
  can_configure_journey?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_manage_schema?: InputMaybe<Scalars['Boolean']>;
  can_manage_trait?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_run_journey?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  resource_type?: InputMaybe<Scalars['String']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type UserGroupGrantsMaxFields = {
  __typename?: 'user_group_grants_max_fields';
  id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type UserGroupGrantsMinFields = {
  __typename?: 'user_group_grants_min_fields';
  id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['bigint']>;
  resource_type?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "user_group_grants" */
export type UserGroupGrantsMutationResponse = {
  __typename?: 'user_group_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroupGrants>;
};

/** on_conflict condition type for table "user_group_grants" */
export type UserGroupGrantsOnConflict = {
  constraint: UserGroupGrantsConstraint;
  update_columns?: Array<UserGroupGrantsUpdateColumn>;
  where?: InputMaybe<UserGroupGrantsBoolExp>;
};

/** Ordering options when selecting data from "user_group_grants". */
export type UserGroupGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_access_decision_engine_agents?: InputMaybe<OrderBy>;
  can_configure_journey?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_manage_schema?: InputMaybe<OrderBy>;
  can_manage_trait?: InputMaybe<OrderBy>;
  can_run?: InputMaybe<OrderBy>;
  can_run_journey?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  resource_id?: InputMaybe<OrderBy>;
  resource_type?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_group_grants */
export type UserGroupGrantsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "user_group_grants" */
export const UserGroupGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanAccessDecisionEngineAgents: 'can_access_decision_engine_agents',
  /** column name */
  CanConfigureJourney: 'can_configure_journey',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanManageSchema: 'can_manage_schema',
  /** column name */
  CanManageTrait: 'can_manage_trait',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanRunJourney: 'can_run_journey',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  ResourceId: 'resource_id',
  /** column name */
  ResourceType: 'resource_type',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupGrantsSelectColumn = typeof UserGroupGrantsSelectColumn[keyof typeof UserGroupGrantsSelectColumn];
/** input type for updating data in table "user_group_grants" */
export type UserGroupGrantsSetInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_access_decision_engine_agents?: InputMaybe<Scalars['Boolean']>;
  can_configure_journey?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_manage_schema?: InputMaybe<Scalars['Boolean']>;
  can_manage_trait?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_run_journey?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type UserGroupGrantsStddevFields = {
  __typename?: 'user_group_grants_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserGroupGrantsStddevPopFields = {
  __typename?: 'user_group_grants_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserGroupGrantsStddevSampFields = {
  __typename?: 'user_group_grants_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_group_grants" */
export type UserGroupGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_access_decision_engine_agents?: InputMaybe<Scalars['Boolean']>;
  can_configure_journey?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_manage_schema?: InputMaybe<Scalars['Boolean']>;
  can_manage_trait?: InputMaybe<Scalars['Boolean']>;
  can_run?: InputMaybe<Scalars['Boolean']>;
  can_run_journey?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  resource_id?: InputMaybe<Scalars['bigint']>;
  resource_type?: InputMaybe<Scalars['String']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type UserGroupGrantsSumFields = {
  __typename?: 'user_group_grants_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  resource_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_group_grants" */
export const UserGroupGrantsUpdateColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanAccessDecisionEngineAgents: 'can_access_decision_engine_agents',
  /** column name */
  CanConfigureJourney: 'can_configure_journey',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanManageSchema: 'can_manage_schema',
  /** column name */
  CanManageTrait: 'can_manage_trait',
  /** column name */
  CanRun: 'can_run',
  /** column name */
  CanRunJourney: 'can_run_journey',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type UserGroupGrantsUpdateColumn = typeof UserGroupGrantsUpdateColumn[keyof typeof UserGroupGrantsUpdateColumn];
export type UserGroupGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type UserGroupGrantsVarPopFields = {
  __typename?: 'user_group_grants_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserGroupGrantsVarSampFields = {
  __typename?: 'user_group_grants_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserGroupGrantsVarianceFields = {
  __typename?: 'user_group_grants_variance_fields';
  id?: Maybe<Scalars['Float']>;
  resource_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_group_members" */
export type UserGroupMembers = {
  __typename?: 'user_group_members';
  is_group_manager: Scalars['Boolean'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  user_id: Scalars['bigint'];
};

/** order by aggregate values of table "user_group_members" */
export type UserGroupMembersAggregateOrderBy = {
  avg?: InputMaybe<UserGroupMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupMembersMaxOrderBy>;
  min?: InputMaybe<UserGroupMembersMinOrderBy>;
  stddev?: InputMaybe<UserGroupMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupMembersStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupMembersSumOrderBy>;
  var_pop?: InputMaybe<UserGroupMembersVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupMembersVarSampOrderBy>;
  variance?: InputMaybe<UserGroupMembersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_group_members" */
export type UserGroupMembersArrRelInsertInput = {
  data: Array<UserGroupMembersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroupMembersOnConflict>;
};

/** order by avg() on columns of table "user_group_members" */
export type UserGroupMembersAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_members". All fields are combined with a logical 'AND'. */
export type UserGroupMembersBoolExp = {
  _and?: InputMaybe<Array<UserGroupMembersBoolExp>>;
  _not?: InputMaybe<UserGroupMembersBoolExp>;
  _or?: InputMaybe<Array<UserGroupMembersBoolExp>>;
  is_group_manager?: InputMaybe<BooleanComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "user_group_members" */
export const UserGroupMembersConstraint = {
  /** unique or primary key constraint on columns "user_id", "user_group_id" */
  UserGroupMembersPkey: 'user_group_members_pkey'
} as const;

export type UserGroupMembersConstraint = typeof UserGroupMembersConstraint[keyof typeof UserGroupMembersConstraint];
/** input type for inserting data into table "user_group_members" */
export type UserGroupMembersInsertInput = {
  is_group_manager?: InputMaybe<Scalars['Boolean']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "user_group_members" */
export type UserGroupMembersMaxOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_members" */
export type UserGroupMembersMinOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_group_members" */
export type UserGroupMembersMutationResponse = {
  __typename?: 'user_group_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroupMembers>;
};

/** on_conflict condition type for table "user_group_members" */
export type UserGroupMembersOnConflict = {
  constraint: UserGroupMembersConstraint;
  update_columns?: Array<UserGroupMembersUpdateColumn>;
  where?: InputMaybe<UserGroupMembersBoolExp>;
};

/** Ordering options when selecting data from "user_group_members". */
export type UserGroupMembersOrderBy = {
  is_group_manager?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_group_members */
export type UserGroupMembersPkColumnsInput = {
  user_group_id: Scalars['bigint'];
  user_id: Scalars['bigint'];
};

/** select columns of table "user_group_members" */
export const UserGroupMembersSelectColumn = {
  /** column name */
  IsGroupManager: 'is_group_manager',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id'
} as const;

export type UserGroupMembersSelectColumn = typeof UserGroupMembersSelectColumn[keyof typeof UserGroupMembersSelectColumn];
/** input type for updating data in table "user_group_members" */
export type UserGroupMembersSetInput = {
  is_group_manager?: InputMaybe<Scalars['Boolean']>;
};

/** order by stddev() on columns of table "user_group_members" */
export type UserGroupMembersStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_members" */
export type UserGroupMembersStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_members" */
export type UserGroupMembersStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_members" */
export type UserGroupMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupMembersStreamCursorValueInput = {
  is_group_manager?: InputMaybe<Scalars['Boolean']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_members" */
export type UserGroupMembersSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_group_members" */
export const UserGroupMembersUpdateColumn = {
  /** column name */
  IsGroupManager: 'is_group_manager'
} as const;

export type UserGroupMembersUpdateColumn = typeof UserGroupMembersUpdateColumn[keyof typeof UserGroupMembersUpdateColumn];
export type UserGroupMembersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupMembersSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupMembersBoolExp;
};

/** order by var_pop() on columns of table "user_group_members" */
export type UserGroupMembersVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_members" */
export type UserGroupMembersVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_members" */
export type UserGroupMembersVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_model_authorization" */
export type UserGroupModelAuthorization = {
  __typename?: 'user_group_model_authorization';
  can_approve?: Maybe<Scalars['Boolean']>;
  can_delete?: Maybe<Scalars['Boolean']>;
  can_preview?: Maybe<Scalars['Boolean']>;
  can_read?: Maybe<Scalars['Boolean']>;
  can_update?: Maybe<Scalars['Boolean']>;
  model_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationAggregateOrderBy = {
  avg?: InputMaybe<UserGroupModelAuthorizationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupModelAuthorizationMaxOrderBy>;
  min?: InputMaybe<UserGroupModelAuthorizationMinOrderBy>;
  stddev?: InputMaybe<UserGroupModelAuthorizationStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupModelAuthorizationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupModelAuthorizationStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupModelAuthorizationSumOrderBy>;
  var_pop?: InputMaybe<UserGroupModelAuthorizationVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupModelAuthorizationVarSampOrderBy>;
  variance?: InputMaybe<UserGroupModelAuthorizationVarianceOrderBy>;
};

/** order by avg() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationAvgOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_model_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupModelAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupModelAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupModelAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupModelAuthorizationBoolExp>>;
  can_approve?: InputMaybe<BooleanComparisonExp>;
  can_delete?: InputMaybe<BooleanComparisonExp>;
  can_preview?: InputMaybe<BooleanComparisonExp>;
  can_read?: InputMaybe<BooleanComparisonExp>;
  can_update?: InputMaybe<BooleanComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationMaxOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationMinOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_group_model_authorization". */
export type UserGroupModelAuthorizationOrderBy = {
  can_approve?: InputMaybe<OrderBy>;
  can_delete?: InputMaybe<OrderBy>;
  can_preview?: InputMaybe<OrderBy>;
  can_read?: InputMaybe<OrderBy>;
  can_update?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_model_authorization" */
export const UserGroupModelAuthorizationSelectColumn = {
  /** column name */
  CanApprove: 'can_approve',
  /** column name */
  CanDelete: 'can_delete',
  /** column name */
  CanPreview: 'can_preview',
  /** column name */
  CanRead: 'can_read',
  /** column name */
  CanUpdate: 'can_update',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupModelAuthorizationSelectColumn = typeof UserGroupModelAuthorizationSelectColumn[keyof typeof UserGroupModelAuthorizationSelectColumn];
/** order by stddev() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationStddevOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationStddevPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationStddevSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_model_authorization" */
export type UserGroupModelAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupModelAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupModelAuthorizationStreamCursorValueInput = {
  can_approve?: InputMaybe<Scalars['Boolean']>;
  can_delete?: InputMaybe<Scalars['Boolean']>;
  can_preview?: InputMaybe<Scalars['Boolean']>;
  can_read?: InputMaybe<Scalars['Boolean']>;
  can_update?: InputMaybe<Scalars['Boolean']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationSumOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationVarPopOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationVarSampOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_model_authorization" */
export type UserGroupModelAuthorizationVarianceOrderBy = {
  model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_model_creation_authorization" */
export type UserGroupModelCreationAuthorization = {
  __typename?: 'user_group_model_creation_authorization';
  can_approve?: Maybe<Scalars['Boolean']>;
  can_create?: Maybe<Scalars['Boolean']>;
  can_preview?: Maybe<Scalars['Boolean']>;
  source_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "user_group_model_creation_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupModelCreationAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupModelCreationAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupModelCreationAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupModelCreationAuthorizationBoolExp>>;
  can_approve?: InputMaybe<BooleanComparisonExp>;
  can_create?: InputMaybe<BooleanComparisonExp>;
  can_preview?: InputMaybe<BooleanComparisonExp>;
  source_id?: InputMaybe<BigintComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "user_group_model_creation_authorization". */
export type UserGroupModelCreationAuthorizationOrderBy = {
  can_approve?: InputMaybe<OrderBy>;
  can_create?: InputMaybe<OrderBy>;
  can_preview?: InputMaybe<OrderBy>;
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_model_creation_authorization" */
export const UserGroupModelCreationAuthorizationSelectColumn = {
  /** column name */
  CanApprove: 'can_approve',
  /** column name */
  CanCreate: 'can_create',
  /** column name */
  CanPreview: 'can_preview',
  /** column name */
  SourceId: 'source_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupModelCreationAuthorizationSelectColumn = typeof UserGroupModelCreationAuthorizationSelectColumn[keyof typeof UserGroupModelCreationAuthorizationSelectColumn];
/** Streaming cursor of the table "user_group_model_creation_authorization" */
export type UserGroupModelCreationAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupModelCreationAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupModelCreationAuthorizationStreamCursorValueInput = {
  can_approve?: InputMaybe<Scalars['Boolean']>;
  can_create?: InputMaybe<Scalars['Boolean']>;
  can_preview?: InputMaybe<Scalars['Boolean']>;
  source_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "user_group_source_grants" */
export type UserGroupSourceGrants = {
  __typename?: 'user_group_source_grants';
  can_access_data?: Maybe<Scalars['Boolean']>;
  can_draft?: Maybe<Scalars['Boolean']>;
  can_edit?: Maybe<Scalars['Boolean']>;
  can_manage_schema?: Maybe<Scalars['Boolean']>;
  can_read?: Maybe<Scalars['Boolean']>;
  can_sync?: Maybe<Scalars['Boolean']>;
  source_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "user_group_source_grants" */
export type UserGroupSourceGrantsAggregateOrderBy = {
  avg?: InputMaybe<UserGroupSourceGrantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupSourceGrantsMaxOrderBy>;
  min?: InputMaybe<UserGroupSourceGrantsMinOrderBy>;
  stddev?: InputMaybe<UserGroupSourceGrantsStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupSourceGrantsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupSourceGrantsStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupSourceGrantsSumOrderBy>;
  var_pop?: InputMaybe<UserGroupSourceGrantsVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupSourceGrantsVarSampOrderBy>;
  variance?: InputMaybe<UserGroupSourceGrantsVarianceOrderBy>;
};

/** order by avg() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsAvgOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_source_grants". All fields are combined with a logical 'AND'. */
export type UserGroupSourceGrantsBoolExp = {
  _and?: InputMaybe<Array<UserGroupSourceGrantsBoolExp>>;
  _not?: InputMaybe<UserGroupSourceGrantsBoolExp>;
  _or?: InputMaybe<Array<UserGroupSourceGrantsBoolExp>>;
  can_access_data?: InputMaybe<BooleanComparisonExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_edit?: InputMaybe<BooleanComparisonExp>;
  can_manage_schema?: InputMaybe<BooleanComparisonExp>;
  can_read?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  source_id?: InputMaybe<BigintComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsMaxOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsMinOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_group_source_grants". */
export type UserGroupSourceGrantsOrderBy = {
  can_access_data?: InputMaybe<OrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_edit?: InputMaybe<OrderBy>;
  can_manage_schema?: InputMaybe<OrderBy>;
  can_read?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_source_grants" */
export const UserGroupSourceGrantsSelectColumn = {
  /** column name */
  CanAccessData: 'can_access_data',
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanEdit: 'can_edit',
  /** column name */
  CanManageSchema: 'can_manage_schema',
  /** column name */
  CanRead: 'can_read',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  SourceId: 'source_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupSourceGrantsSelectColumn = typeof UserGroupSourceGrantsSelectColumn[keyof typeof UserGroupSourceGrantsSelectColumn];
/** order by stddev() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsStddevOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsStddevPopOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsStddevSampOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_source_grants" */
export type UserGroupSourceGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupSourceGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupSourceGrantsStreamCursorValueInput = {
  can_access_data?: InputMaybe<Scalars['Boolean']>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_edit?: InputMaybe<Scalars['Boolean']>;
  can_manage_schema?: InputMaybe<Scalars['Boolean']>;
  can_read?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  source_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsSumOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsVarPopOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsVarSampOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_source_grants" */
export type UserGroupSourceGrantsVarianceOrderBy = {
  source_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_subset_authorization" */
export type UserGroupSubsetAuthorization = {
  __typename?: 'user_group_subset_authorization';
  can_create?: Maybe<Scalars['Boolean']>;
  can_delete?: Maybe<Scalars['Boolean']>;
  can_preview?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  space_subset_grants?: Maybe<SpaceSubsetGrants>;
  subset_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationAggregateOrderBy = {
  avg?: InputMaybe<UserGroupSubsetAuthorizationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupSubsetAuthorizationMaxOrderBy>;
  min?: InputMaybe<UserGroupSubsetAuthorizationMinOrderBy>;
  stddev?: InputMaybe<UserGroupSubsetAuthorizationStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupSubsetAuthorizationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupSubsetAuthorizationStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupSubsetAuthorizationSumOrderBy>;
  var_pop?: InputMaybe<UserGroupSubsetAuthorizationVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupSubsetAuthorizationVarSampOrderBy>;
  variance?: InputMaybe<UserGroupSubsetAuthorizationVarianceOrderBy>;
};

/** order by avg() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_subset_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupSubsetAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupSubsetAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupSubsetAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupSubsetAuthorizationBoolExp>>;
  can_create?: InputMaybe<BooleanComparisonExp>;
  can_delete?: InputMaybe<BooleanComparisonExp>;
  can_preview?: InputMaybe<BooleanComparisonExp>;
  space_subset_grants?: InputMaybe<SpaceSubsetGrantsBoolExp>;
  subset_id?: InputMaybe<UuidComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationMaxOrderBy = {
  subset_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationMinOrderBy = {
  subset_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_group_subset_authorization". */
export type UserGroupSubsetAuthorizationOrderBy = {
  can_create?: InputMaybe<OrderBy>;
  can_delete?: InputMaybe<OrderBy>;
  can_preview?: InputMaybe<OrderBy>;
  space_subset_grants?: InputMaybe<SpaceSubsetGrantsOrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_subset_authorization" */
export const UserGroupSubsetAuthorizationSelectColumn = {
  /** column name */
  CanCreate: 'can_create',
  /** column name */
  CanDelete: 'can_delete',
  /** column name */
  CanPreview: 'can_preview',
  /** column name */
  SubsetId: 'subset_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupSubsetAuthorizationSelectColumn = typeof UserGroupSubsetAuthorizationSelectColumn[keyof typeof UserGroupSubsetAuthorizationSelectColumn];
/** order by stddev() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupSubsetAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupSubsetAuthorizationStreamCursorValueInput = {
  can_create?: InputMaybe<Scalars['Boolean']>;
  can_delete?: InputMaybe<Scalars['Boolean']>;
  can_preview?: InputMaybe<Scalars['Boolean']>;
  subset_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_subset_authorization" */
export type UserGroupSubsetAuthorizationVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_subset_grants" */
export type UserGroupSubsetGrants = {
  __typename?: 'user_group_subset_grants';
  /** An object relationship */
  audience_subset_value: AudienceSubsetValues;
  can_draft: Scalars['Boolean'];
  can_sync: Scalars['Boolean'];
  id: Scalars['bigint'];
  subset_id: Scalars['uuid'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  user_group_workspace?: Maybe<UserGroupWorkspaces>;
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "user_group_subset_grants" */
export type UserGroupSubsetGrantsAggregate = {
  __typename?: 'user_group_subset_grants_aggregate';
  aggregate?: Maybe<UserGroupSubsetGrantsAggregateFields>;
  nodes: Array<UserGroupSubsetGrants>;
};

export type UserGroupSubsetGrantsAggregateBoolExp = {
  bool_and?: InputMaybe<UserGroupSubsetGrantsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<UserGroupSubsetGrantsAggregateBoolExpBoolOr>;
  count?: InputMaybe<UserGroupSubsetGrantsAggregateBoolExpCount>;
};

export type UserGroupSubsetGrantsAggregateBoolExpBoolAnd = {
  arguments: UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupSubsetGrantsAggregateBoolExpBoolOr = {
  arguments: UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupSubsetGrantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "user_group_subset_grants" */
export type UserGroupSubsetGrantsAggregateFields = {
  __typename?: 'user_group_subset_grants_aggregate_fields';
  avg?: Maybe<UserGroupSubsetGrantsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserGroupSubsetGrantsMaxFields>;
  min?: Maybe<UserGroupSubsetGrantsMinFields>;
  stddev?: Maybe<UserGroupSubsetGrantsStddevFields>;
  stddev_pop?: Maybe<UserGroupSubsetGrantsStddevPopFields>;
  stddev_samp?: Maybe<UserGroupSubsetGrantsStddevSampFields>;
  sum?: Maybe<UserGroupSubsetGrantsSumFields>;
  var_pop?: Maybe<UserGroupSubsetGrantsVarPopFields>;
  var_samp?: Maybe<UserGroupSubsetGrantsVarSampFields>;
  variance?: Maybe<UserGroupSubsetGrantsVarianceFields>;
};


/** aggregate fields of "user_group_subset_grants" */
export type UserGroupSubsetGrantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroupSubsetGrantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsAggregateOrderBy = {
  avg?: InputMaybe<UserGroupSubsetGrantsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupSubsetGrantsMaxOrderBy>;
  min?: InputMaybe<UserGroupSubsetGrantsMinOrderBy>;
  stddev?: InputMaybe<UserGroupSubsetGrantsStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupSubsetGrantsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupSubsetGrantsStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupSubsetGrantsSumOrderBy>;
  var_pop?: InputMaybe<UserGroupSubsetGrantsVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupSubsetGrantsVarSampOrderBy>;
  variance?: InputMaybe<UserGroupSubsetGrantsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_group_subset_grants" */
export type UserGroupSubsetGrantsArrRelInsertInput = {
  data: Array<UserGroupSubsetGrantsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroupSubsetGrantsOnConflict>;
};

/** aggregate avg on columns */
export type UserGroupSubsetGrantsAvgFields = {
  __typename?: 'user_group_subset_grants_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_subset_grants". All fields are combined with a logical 'AND'. */
export type UserGroupSubsetGrantsBoolExp = {
  _and?: InputMaybe<Array<UserGroupSubsetGrantsBoolExp>>;
  _not?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
  _or?: InputMaybe<Array<UserGroupSubsetGrantsBoolExp>>;
  audience_subset_value?: InputMaybe<AudienceSubsetValuesBoolExp>;
  can_draft?: InputMaybe<BooleanComparisonExp>;
  can_sync?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  subset_id?: InputMaybe<UuidComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesBoolExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "user_group_subset_grants" */
export const UserGroupSubsetGrantsConstraint = {
  /** unique or primary key constraint on columns "id" */
  UserGroupSubsetGrantsPkey: 'user_group_subset_grants_pkey',
  /** unique or primary key constraint on columns "user_group_id", "workspace_id", "subset_id" */
  UserGroupSubsetGrantsWorkspaceIdUserGroupIdSubsetKey: 'user_group_subset_grants_workspace_id_user_group_id_subset__key'
} as const;

export type UserGroupSubsetGrantsConstraint = typeof UserGroupSubsetGrantsConstraint[keyof typeof UserGroupSubsetGrantsConstraint];
/** input type for inserting data into table "user_group_subset_grants" */
export type UserGroupSubsetGrantsInsertInput = {
  audience_subset_value?: InputMaybe<AudienceSubsetValuesObjRelInsertInput>;
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  subset_id?: InputMaybe<Scalars['uuid']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesObjRelInsertInput>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type UserGroupSubsetGrantsMaxFields = {
  __typename?: 'user_group_subset_grants_max_fields';
  id?: Maybe<Scalars['bigint']>;
  subset_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserGroupSubsetGrantsMinFields = {
  __typename?: 'user_group_subset_grants_min_fields';
  id?: Maybe<Scalars['bigint']>;
  subset_id?: Maybe<Scalars['uuid']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_group_subset_grants" */
export type UserGroupSubsetGrantsMutationResponse = {
  __typename?: 'user_group_subset_grants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroupSubsetGrants>;
};

/** on_conflict condition type for table "user_group_subset_grants" */
export type UserGroupSubsetGrantsOnConflict = {
  constraint: UserGroupSubsetGrantsConstraint;
  update_columns?: Array<UserGroupSubsetGrantsUpdateColumn>;
  where?: InputMaybe<UserGroupSubsetGrantsBoolExp>;
};

/** Ordering options when selecting data from "user_group_subset_grants". */
export type UserGroupSubsetGrantsOrderBy = {
  audience_subset_value?: InputMaybe<AudienceSubsetValuesOrderBy>;
  can_draft?: InputMaybe<OrderBy>;
  can_sync?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  subset_id?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_group_workspace?: InputMaybe<UserGroupWorkspacesOrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_group_subset_grants */
export type UserGroupSubsetGrantsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "user_group_subset_grants" */
export const UserGroupSubsetGrantsSelectColumn = {
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanSync: 'can_sync',
  /** column name */
  Id: 'id',
  /** column name */
  SubsetId: 'subset_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupSubsetGrantsSelectColumn = typeof UserGroupSubsetGrantsSelectColumn[keyof typeof UserGroupSubsetGrantsSelectColumn];
/** select "user_group_subset_grants_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_group_subset_grants" */
export const UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolAndArgumentsColumns = typeof UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolAndArgumentsColumns];
/** select "user_group_subset_grants_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_group_subset_grants" */
export const UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolOrArgumentsColumns = typeof UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof UserGroupSubsetGrantsSelectColumnUserGroupSubsetGrantsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "user_group_subset_grants" */
export type UserGroupSubsetGrantsSetInput = {
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type UserGroupSubsetGrantsStddevFields = {
  __typename?: 'user_group_subset_grants_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserGroupSubsetGrantsStddevPopFields = {
  __typename?: 'user_group_subset_grants_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserGroupSubsetGrantsStddevSampFields = {
  __typename?: 'user_group_subset_grants_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_subset_grants" */
export type UserGroupSubsetGrantsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupSubsetGrantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupSubsetGrantsStreamCursorValueInput = {
  can_draft?: InputMaybe<Scalars['Boolean']>;
  can_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  subset_id?: InputMaybe<Scalars['uuid']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type UserGroupSubsetGrantsSumFields = {
  __typename?: 'user_group_subset_grants_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_group_subset_grants" */
export const UserGroupSubsetGrantsUpdateColumn = {
  /** column name */
  CanDraft: 'can_draft',
  /** column name */
  CanSync: 'can_sync'
} as const;

export type UserGroupSubsetGrantsUpdateColumn = typeof UserGroupSubsetGrantsUpdateColumn[keyof typeof UserGroupSubsetGrantsUpdateColumn];
export type UserGroupSubsetGrantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupSubsetGrantsSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupSubsetGrantsBoolExp;
};

/** aggregate var_pop on columns */
export type UserGroupSubsetGrantsVarPopFields = {
  __typename?: 'user_group_subset_grants_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserGroupSubsetGrantsVarSampFields = {
  __typename?: 'user_group_subset_grants_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserGroupSubsetGrantsVarianceFields = {
  __typename?: 'user_group_subset_grants_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_group_subset_grants" */
export type UserGroupSubsetGrantsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_sync_creation_authorization" */
export type UserGroupSyncCreationAuthorization = {
  __typename?: 'user_group_sync_creation_authorization';
  can_approve?: Maybe<Scalars['Boolean']>;
  can_create?: Maybe<Scalars['Boolean']>;
  can_test?: Maybe<Scalars['Boolean']>;
  destination_id?: Maybe<Scalars['bigint']>;
  model_id?: Maybe<Scalars['bigint']>;
  sync_template_id?: Maybe<Scalars['Int']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "user_group_sync_creation_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupSyncCreationAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupSyncCreationAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupSyncCreationAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupSyncCreationAuthorizationBoolExp>>;
  can_approve?: InputMaybe<BooleanComparisonExp>;
  can_create?: InputMaybe<BooleanComparisonExp>;
  can_test?: InputMaybe<BooleanComparisonExp>;
  destination_id?: InputMaybe<BigintComparisonExp>;
  model_id?: InputMaybe<BigintComparisonExp>;
  sync_template_id?: InputMaybe<IntComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "user_group_sync_creation_authorization". */
export type UserGroupSyncCreationAuthorizationOrderBy = {
  can_approve?: InputMaybe<OrderBy>;
  can_create?: InputMaybe<OrderBy>;
  can_test?: InputMaybe<OrderBy>;
  destination_id?: InputMaybe<OrderBy>;
  model_id?: InputMaybe<OrderBy>;
  sync_template_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_sync_creation_authorization" */
export const UserGroupSyncCreationAuthorizationSelectColumn = {
  /** column name */
  CanApprove: 'can_approve',
  /** column name */
  CanCreate: 'can_create',
  /** column name */
  CanTest: 'can_test',
  /** column name */
  DestinationId: 'destination_id',
  /** column name */
  ModelId: 'model_id',
  /** column name */
  SyncTemplateId: 'sync_template_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupSyncCreationAuthorizationSelectColumn = typeof UserGroupSyncCreationAuthorizationSelectColumn[keyof typeof UserGroupSyncCreationAuthorizationSelectColumn];
/** Streaming cursor of the table "user_group_sync_creation_authorization" */
export type UserGroupSyncCreationAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupSyncCreationAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupSyncCreationAuthorizationStreamCursorValueInput = {
  can_approve?: InputMaybe<Scalars['Boolean']>;
  can_create?: InputMaybe<Scalars['Boolean']>;
  can_test?: InputMaybe<Scalars['Boolean']>;
  destination_id?: InputMaybe<Scalars['bigint']>;
  model_id?: InputMaybe<Scalars['bigint']>;
  sync_template_id?: InputMaybe<Scalars['Int']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "user_group_trait_authorization" */
export type UserGroupTraitAuthorization = {
  __typename?: 'user_group_trait_authorization';
  can_create?: Maybe<Scalars['Boolean']>;
  can_delete?: Maybe<Scalars['Boolean']>;
  can_read?: Maybe<Scalars['Boolean']>;
  can_update?: Maybe<Scalars['Boolean']>;
  parent_model_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by aggregate values of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationAggregateOrderBy = {
  avg?: InputMaybe<UserGroupTraitAuthorizationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupTraitAuthorizationMaxOrderBy>;
  min?: InputMaybe<UserGroupTraitAuthorizationMinOrderBy>;
  stddev?: InputMaybe<UserGroupTraitAuthorizationStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupTraitAuthorizationStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupTraitAuthorizationStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupTraitAuthorizationSumOrderBy>;
  var_pop?: InputMaybe<UserGroupTraitAuthorizationVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupTraitAuthorizationVarSampOrderBy>;
  variance?: InputMaybe<UserGroupTraitAuthorizationVarianceOrderBy>;
};

/** order by avg() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationAvgOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_trait_authorization". All fields are combined with a logical 'AND'. */
export type UserGroupTraitAuthorizationBoolExp = {
  _and?: InputMaybe<Array<UserGroupTraitAuthorizationBoolExp>>;
  _not?: InputMaybe<UserGroupTraitAuthorizationBoolExp>;
  _or?: InputMaybe<Array<UserGroupTraitAuthorizationBoolExp>>;
  can_create?: InputMaybe<BooleanComparisonExp>;
  can_delete?: InputMaybe<BooleanComparisonExp>;
  can_read?: InputMaybe<BooleanComparisonExp>;
  can_update?: InputMaybe<BooleanComparisonExp>;
  parent_model_id?: InputMaybe<BigintComparisonExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** order by max() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationMaxOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationMinOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_group_trait_authorization". */
export type UserGroupTraitAuthorizationOrderBy = {
  can_create?: InputMaybe<OrderBy>;
  can_delete?: InputMaybe<OrderBy>;
  can_read?: InputMaybe<OrderBy>;
  can_update?: InputMaybe<OrderBy>;
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "user_group_trait_authorization" */
export const UserGroupTraitAuthorizationSelectColumn = {
  /** column name */
  CanCreate: 'can_create',
  /** column name */
  CanDelete: 'can_delete',
  /** column name */
  CanRead: 'can_read',
  /** column name */
  CanUpdate: 'can_update',
  /** column name */
  ParentModelId: 'parent_model_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupTraitAuthorizationSelectColumn = typeof UserGroupTraitAuthorizationSelectColumn[keyof typeof UserGroupTraitAuthorizationSelectColumn];
/** order by stddev() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationStddevOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationStddevPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationStddevSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupTraitAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupTraitAuthorizationStreamCursorValueInput = {
  can_create?: InputMaybe<Scalars['Boolean']>;
  can_delete?: InputMaybe<Scalars['Boolean']>;
  can_read?: InputMaybe<Scalars['Boolean']>;
  can_update?: InputMaybe<Scalars['Boolean']>;
  parent_model_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationSumOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_pop() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationVarPopOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationVarSampOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "user_group_trait_authorization" */
export type UserGroupTraitAuthorizationVarianceOrderBy = {
  parent_model_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_group_workspaces" */
export type UserGroupWorkspaces = {
  __typename?: 'user_group_workspaces';
  built_in_permission_set?: Maybe<Scalars['String']>;
  can_configure_agents: Scalars['Boolean'];
  can_create_destinations: Scalars['Boolean'];
  can_create_event_forwarding_destinations: Scalars['Boolean'];
  can_create_event_functions: Scalars['Boolean'];
  can_create_event_plans: Scalars['Boolean'];
  can_create_event_sources: Scalars['Boolean'];
  can_create_event_warehouse_destinations: Scalars['Boolean'];
  can_create_sources: Scalars['Boolean'];
  can_draft_native_delivery: Scalars['Boolean'];
  can_edit_decision_engine_content: Scalars['Boolean'];
  can_grant_support_access: Scalars['Boolean'];
  can_ingest_cep_push_tokens: Scalars['Boolean'];
  can_manage_decision_engine: Scalars['Boolean'];
  can_manage_native_delivery_assets: Scalars['Boolean'];
  can_manage_native_delivery_channels: Scalars['Boolean'];
  can_manage_native_delivery_messages: Scalars['Boolean'];
  can_manage_native_delivery_settings: Scalars['Boolean'];
  can_read_cep_consent: Scalars['Boolean'];
  can_update_cep_consent: Scalars['Boolean'];
  can_view_agents: Scalars['Boolean'];
  can_view_native_delivery: Scalars['Boolean'];
  is_space_scoped: Scalars['Boolean'];
  is_workspace_admin: Scalars['Boolean'];
  /** An object relationship */
  user_group: UserGroups;
  user_group_id: Scalars['bigint'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "user_group_workspaces" */
export type UserGroupWorkspacesAggregate = {
  __typename?: 'user_group_workspaces_aggregate';
  aggregate?: Maybe<UserGroupWorkspacesAggregateFields>;
  nodes: Array<UserGroupWorkspaces>;
};

export type UserGroupWorkspacesAggregateBoolExp = {
  bool_and?: InputMaybe<UserGroupWorkspacesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<UserGroupWorkspacesAggregateBoolExpBoolOr>;
  count?: InputMaybe<UserGroupWorkspacesAggregateBoolExpCount>;
};

export type UserGroupWorkspacesAggregateBoolExpBoolAnd = {
  arguments: UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupWorkspacesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupWorkspacesAggregateBoolExpBoolOr = {
  arguments: UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupWorkspacesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupWorkspacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupWorkspacesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "user_group_workspaces" */
export type UserGroupWorkspacesAggregateFields = {
  __typename?: 'user_group_workspaces_aggregate_fields';
  avg?: Maybe<UserGroupWorkspacesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserGroupWorkspacesMaxFields>;
  min?: Maybe<UserGroupWorkspacesMinFields>;
  stddev?: Maybe<UserGroupWorkspacesStddevFields>;
  stddev_pop?: Maybe<UserGroupWorkspacesStddevPopFields>;
  stddev_samp?: Maybe<UserGroupWorkspacesStddevSampFields>;
  sum?: Maybe<UserGroupWorkspacesSumFields>;
  var_pop?: Maybe<UserGroupWorkspacesVarPopFields>;
  var_samp?: Maybe<UserGroupWorkspacesVarSampFields>;
  variance?: Maybe<UserGroupWorkspacesVarianceFields>;
};


/** aggregate fields of "user_group_workspaces" */
export type UserGroupWorkspacesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_group_workspaces" */
export type UserGroupWorkspacesAggregateOrderBy = {
  avg?: InputMaybe<UserGroupWorkspacesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupWorkspacesMaxOrderBy>;
  min?: InputMaybe<UserGroupWorkspacesMinOrderBy>;
  stddev?: InputMaybe<UserGroupWorkspacesStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupWorkspacesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupWorkspacesStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupWorkspacesSumOrderBy>;
  var_pop?: InputMaybe<UserGroupWorkspacesVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupWorkspacesVarSampOrderBy>;
  variance?: InputMaybe<UserGroupWorkspacesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_group_workspaces" */
export type UserGroupWorkspacesArrRelInsertInput = {
  data: Array<UserGroupWorkspacesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroupWorkspacesOnConflict>;
};

/** aggregate avg on columns */
export type UserGroupWorkspacesAvgFields = {
  __typename?: 'user_group_workspaces_avg_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesAvgOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_group_workspaces". All fields are combined with a logical 'AND'. */
export type UserGroupWorkspacesBoolExp = {
  _and?: InputMaybe<Array<UserGroupWorkspacesBoolExp>>;
  _not?: InputMaybe<UserGroupWorkspacesBoolExp>;
  _or?: InputMaybe<Array<UserGroupWorkspacesBoolExp>>;
  built_in_permission_set?: InputMaybe<StringComparisonExp>;
  can_configure_agents?: InputMaybe<BooleanComparisonExp>;
  can_create_destinations?: InputMaybe<BooleanComparisonExp>;
  can_create_event_forwarding_destinations?: InputMaybe<BooleanComparisonExp>;
  can_create_event_functions?: InputMaybe<BooleanComparisonExp>;
  can_create_event_plans?: InputMaybe<BooleanComparisonExp>;
  can_create_event_sources?: InputMaybe<BooleanComparisonExp>;
  can_create_event_warehouse_destinations?: InputMaybe<BooleanComparisonExp>;
  can_create_sources?: InputMaybe<BooleanComparisonExp>;
  can_draft_native_delivery?: InputMaybe<BooleanComparisonExp>;
  can_edit_decision_engine_content?: InputMaybe<BooleanComparisonExp>;
  can_grant_support_access?: InputMaybe<BooleanComparisonExp>;
  can_ingest_cep_push_tokens?: InputMaybe<BooleanComparisonExp>;
  can_manage_decision_engine?: InputMaybe<BooleanComparisonExp>;
  can_manage_native_delivery_assets?: InputMaybe<BooleanComparisonExp>;
  can_manage_native_delivery_channels?: InputMaybe<BooleanComparisonExp>;
  can_manage_native_delivery_messages?: InputMaybe<BooleanComparisonExp>;
  can_manage_native_delivery_settings?: InputMaybe<BooleanComparisonExp>;
  can_read_cep_consent?: InputMaybe<BooleanComparisonExp>;
  can_update_cep_consent?: InputMaybe<BooleanComparisonExp>;
  can_view_agents?: InputMaybe<BooleanComparisonExp>;
  can_view_native_delivery?: InputMaybe<BooleanComparisonExp>;
  is_space_scoped?: InputMaybe<BooleanComparisonExp>;
  is_workspace_admin?: InputMaybe<BooleanComparisonExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "user_group_workspaces" */
export const UserGroupWorkspacesConstraint = {
  /** unique or primary key constraint on columns "user_group_id", "workspace_id" */
  UserGroupWorkspacesPkey: 'user_group_workspaces_pkey'
} as const;

export type UserGroupWorkspacesConstraint = typeof UserGroupWorkspacesConstraint[keyof typeof UserGroupWorkspacesConstraint];
/** input type for inserting data into table "user_group_workspaces" */
export type UserGroupWorkspacesInsertInput = {
  built_in_permission_set?: InputMaybe<Scalars['String']>;
  can_configure_agents?: InputMaybe<Scalars['Boolean']>;
  can_create_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_forwarding_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_functions?: InputMaybe<Scalars['Boolean']>;
  can_create_event_plans?: InputMaybe<Scalars['Boolean']>;
  can_create_event_sources?: InputMaybe<Scalars['Boolean']>;
  can_create_event_warehouse_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_sources?: InputMaybe<Scalars['Boolean']>;
  can_draft_native_delivery?: InputMaybe<Scalars['Boolean']>;
  can_grant_support_access?: InputMaybe<Scalars['Boolean']>;
  can_ingest_cep_push_tokens?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_assets?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_channels?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_messages?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_settings?: InputMaybe<Scalars['Boolean']>;
  can_read_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_update_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_view_agents?: InputMaybe<Scalars['Boolean']>;
  can_view_native_delivery?: InputMaybe<Scalars['Boolean']>;
  is_space_scoped?: InputMaybe<Scalars['Boolean']>;
  is_workspace_admin?: InputMaybe<Scalars['Boolean']>;
  user_group?: InputMaybe<UserGroupsObjRelInsertInput>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type UserGroupWorkspacesMaxFields = {
  __typename?: 'user_group_workspaces_max_fields';
  built_in_permission_set?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesMaxOrderBy = {
  built_in_permission_set?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserGroupWorkspacesMinFields = {
  __typename?: 'user_group_workspaces_min_fields';
  built_in_permission_set?: Maybe<Scalars['String']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesMinOrderBy = {
  built_in_permission_set?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_group_workspaces" */
export type UserGroupWorkspacesMutationResponse = {
  __typename?: 'user_group_workspaces_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroupWorkspaces>;
};

/** input type for inserting object relation for remote table "user_group_workspaces" */
export type UserGroupWorkspacesObjRelInsertInput = {
  data: UserGroupWorkspacesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroupWorkspacesOnConflict>;
};

/** on_conflict condition type for table "user_group_workspaces" */
export type UserGroupWorkspacesOnConflict = {
  constraint: UserGroupWorkspacesConstraint;
  update_columns?: Array<UserGroupWorkspacesUpdateColumn>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** Ordering options when selecting data from "user_group_workspaces". */
export type UserGroupWorkspacesOrderBy = {
  built_in_permission_set?: InputMaybe<OrderBy>;
  can_configure_agents?: InputMaybe<OrderBy>;
  can_create_destinations?: InputMaybe<OrderBy>;
  can_create_event_forwarding_destinations?: InputMaybe<OrderBy>;
  can_create_event_functions?: InputMaybe<OrderBy>;
  can_create_event_plans?: InputMaybe<OrderBy>;
  can_create_event_sources?: InputMaybe<OrderBy>;
  can_create_event_warehouse_destinations?: InputMaybe<OrderBy>;
  can_create_sources?: InputMaybe<OrderBy>;
  can_draft_native_delivery?: InputMaybe<OrderBy>;
  can_edit_decision_engine_content?: InputMaybe<OrderBy>;
  can_grant_support_access?: InputMaybe<OrderBy>;
  can_ingest_cep_push_tokens?: InputMaybe<OrderBy>;
  can_manage_decision_engine?: InputMaybe<OrderBy>;
  can_manage_native_delivery_assets?: InputMaybe<OrderBy>;
  can_manage_native_delivery_channels?: InputMaybe<OrderBy>;
  can_manage_native_delivery_messages?: InputMaybe<OrderBy>;
  can_manage_native_delivery_settings?: InputMaybe<OrderBy>;
  can_read_cep_consent?: InputMaybe<OrderBy>;
  can_update_cep_consent?: InputMaybe<OrderBy>;
  can_view_agents?: InputMaybe<OrderBy>;
  can_view_native_delivery?: InputMaybe<OrderBy>;
  is_space_scoped?: InputMaybe<OrderBy>;
  is_workspace_admin?: InputMaybe<OrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_group_workspaces */
export type UserGroupWorkspacesPkColumnsInput = {
  user_group_id: Scalars['bigint'];
  workspace_id: Scalars['bigint'];
};

/** select columns of table "user_group_workspaces" */
export const UserGroupWorkspacesSelectColumn = {
  /** column name */
  BuiltInPermissionSet: 'built_in_permission_set',
  /** column name */
  CanConfigureAgents: 'can_configure_agents',
  /** column name */
  CanCreateDestinations: 'can_create_destinations',
  /** column name */
  CanCreateEventForwardingDestinations: 'can_create_event_forwarding_destinations',
  /** column name */
  CanCreateEventFunctions: 'can_create_event_functions',
  /** column name */
  CanCreateEventPlans: 'can_create_event_plans',
  /** column name */
  CanCreateEventSources: 'can_create_event_sources',
  /** column name */
  CanCreateEventWarehouseDestinations: 'can_create_event_warehouse_destinations',
  /** column name */
  CanCreateSources: 'can_create_sources',
  /** column name */
  CanDraftNativeDelivery: 'can_draft_native_delivery',
  /** column name */
  CanEditDecisionEngineContent: 'can_edit_decision_engine_content',
  /** column name */
  CanGrantSupportAccess: 'can_grant_support_access',
  /** column name */
  CanIngestCepPushTokens: 'can_ingest_cep_push_tokens',
  /** column name */
  CanManageDecisionEngine: 'can_manage_decision_engine',
  /** column name */
  CanManageNativeDeliveryAssets: 'can_manage_native_delivery_assets',
  /** column name */
  CanManageNativeDeliveryChannels: 'can_manage_native_delivery_channels',
  /** column name */
  CanManageNativeDeliveryMessages: 'can_manage_native_delivery_messages',
  /** column name */
  CanManageNativeDeliverySettings: 'can_manage_native_delivery_settings',
  /** column name */
  CanReadCepConsent: 'can_read_cep_consent',
  /** column name */
  CanUpdateCepConsent: 'can_update_cep_consent',
  /** column name */
  CanViewAgents: 'can_view_agents',
  /** column name */
  CanViewNativeDelivery: 'can_view_native_delivery',
  /** column name */
  IsSpaceScoped: 'is_space_scoped',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UserGroupWorkspacesSelectColumn = typeof UserGroupWorkspacesSelectColumn[keyof typeof UserGroupWorkspacesSelectColumn];
/** select "user_group_workspaces_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_group_workspaces" */
export const UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  CanConfigureAgents: 'can_configure_agents',
  /** column name */
  CanCreateDestinations: 'can_create_destinations',
  /** column name */
  CanCreateEventForwardingDestinations: 'can_create_event_forwarding_destinations',
  /** column name */
  CanCreateEventFunctions: 'can_create_event_functions',
  /** column name */
  CanCreateEventPlans: 'can_create_event_plans',
  /** column name */
  CanCreateEventSources: 'can_create_event_sources',
  /** column name */
  CanCreateEventWarehouseDestinations: 'can_create_event_warehouse_destinations',
  /** column name */
  CanCreateSources: 'can_create_sources',
  /** column name */
  CanDraftNativeDelivery: 'can_draft_native_delivery',
  /** column name */
  CanEditDecisionEngineContent: 'can_edit_decision_engine_content',
  /** column name */
  CanGrantSupportAccess: 'can_grant_support_access',
  /** column name */
  CanIngestCepPushTokens: 'can_ingest_cep_push_tokens',
  /** column name */
  CanManageDecisionEngine: 'can_manage_decision_engine',
  /** column name */
  CanManageNativeDeliveryAssets: 'can_manage_native_delivery_assets',
  /** column name */
  CanManageNativeDeliveryChannels: 'can_manage_native_delivery_channels',
  /** column name */
  CanManageNativeDeliveryMessages: 'can_manage_native_delivery_messages',
  /** column name */
  CanManageNativeDeliverySettings: 'can_manage_native_delivery_settings',
  /** column name */
  CanReadCepConsent: 'can_read_cep_consent',
  /** column name */
  CanUpdateCepConsent: 'can_update_cep_consent',
  /** column name */
  CanViewAgents: 'can_view_agents',
  /** column name */
  CanViewNativeDelivery: 'can_view_native_delivery',
  /** column name */
  IsSpaceScoped: 'is_space_scoped',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolAndArgumentsColumns = typeof UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolAndArgumentsColumns[keyof typeof UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolAndArgumentsColumns];
/** select "user_group_workspaces_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_group_workspaces" */
export const UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  CanConfigureAgents: 'can_configure_agents',
  /** column name */
  CanCreateDestinations: 'can_create_destinations',
  /** column name */
  CanCreateEventForwardingDestinations: 'can_create_event_forwarding_destinations',
  /** column name */
  CanCreateEventFunctions: 'can_create_event_functions',
  /** column name */
  CanCreateEventPlans: 'can_create_event_plans',
  /** column name */
  CanCreateEventSources: 'can_create_event_sources',
  /** column name */
  CanCreateEventWarehouseDestinations: 'can_create_event_warehouse_destinations',
  /** column name */
  CanCreateSources: 'can_create_sources',
  /** column name */
  CanDraftNativeDelivery: 'can_draft_native_delivery',
  /** column name */
  CanEditDecisionEngineContent: 'can_edit_decision_engine_content',
  /** column name */
  CanGrantSupportAccess: 'can_grant_support_access',
  /** column name */
  CanIngestCepPushTokens: 'can_ingest_cep_push_tokens',
  /** column name */
  CanManageDecisionEngine: 'can_manage_decision_engine',
  /** column name */
  CanManageNativeDeliveryAssets: 'can_manage_native_delivery_assets',
  /** column name */
  CanManageNativeDeliveryChannels: 'can_manage_native_delivery_channels',
  /** column name */
  CanManageNativeDeliveryMessages: 'can_manage_native_delivery_messages',
  /** column name */
  CanManageNativeDeliverySettings: 'can_manage_native_delivery_settings',
  /** column name */
  CanReadCepConsent: 'can_read_cep_consent',
  /** column name */
  CanUpdateCepConsent: 'can_update_cep_consent',
  /** column name */
  CanViewAgents: 'can_view_agents',
  /** column name */
  CanViewNativeDelivery: 'can_view_native_delivery',
  /** column name */
  IsSpaceScoped: 'is_space_scoped',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolOrArgumentsColumns = typeof UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolOrArgumentsColumns[keyof typeof UserGroupWorkspacesSelectColumnUserGroupWorkspacesAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "user_group_workspaces" */
export type UserGroupWorkspacesSetInput = {
  built_in_permission_set?: InputMaybe<Scalars['String']>;
  can_configure_agents?: InputMaybe<Scalars['Boolean']>;
  can_create_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_forwarding_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_functions?: InputMaybe<Scalars['Boolean']>;
  can_create_event_plans?: InputMaybe<Scalars['Boolean']>;
  can_create_event_sources?: InputMaybe<Scalars['Boolean']>;
  can_create_event_warehouse_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_sources?: InputMaybe<Scalars['Boolean']>;
  can_draft_native_delivery?: InputMaybe<Scalars['Boolean']>;
  can_edit_decision_engine_content?: InputMaybe<Scalars['Boolean']>;
  can_grant_support_access?: InputMaybe<Scalars['Boolean']>;
  can_ingest_cep_push_tokens?: InputMaybe<Scalars['Boolean']>;
  can_manage_decision_engine?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_assets?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_channels?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_messages?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_settings?: InputMaybe<Scalars['Boolean']>;
  can_read_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_update_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_view_agents?: InputMaybe<Scalars['Boolean']>;
  can_view_native_delivery?: InputMaybe<Scalars['Boolean']>;
  is_space_scoped?: InputMaybe<Scalars['Boolean']>;
  is_workspace_admin?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type UserGroupWorkspacesStddevFields = {
  __typename?: 'user_group_workspaces_stddev_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesStddevOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserGroupWorkspacesStddevPopFields = {
  __typename?: 'user_group_workspaces_stddev_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesStddevPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserGroupWorkspacesStddevSampFields = {
  __typename?: 'user_group_workspaces_stddev_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesStddevSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_group_workspaces" */
export type UserGroupWorkspacesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupWorkspacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupWorkspacesStreamCursorValueInput = {
  built_in_permission_set?: InputMaybe<Scalars['String']>;
  can_configure_agents?: InputMaybe<Scalars['Boolean']>;
  can_create_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_forwarding_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_event_functions?: InputMaybe<Scalars['Boolean']>;
  can_create_event_plans?: InputMaybe<Scalars['Boolean']>;
  can_create_event_sources?: InputMaybe<Scalars['Boolean']>;
  can_create_event_warehouse_destinations?: InputMaybe<Scalars['Boolean']>;
  can_create_sources?: InputMaybe<Scalars['Boolean']>;
  can_draft_native_delivery?: InputMaybe<Scalars['Boolean']>;
  can_edit_decision_engine_content?: InputMaybe<Scalars['Boolean']>;
  can_grant_support_access?: InputMaybe<Scalars['Boolean']>;
  can_ingest_cep_push_tokens?: InputMaybe<Scalars['Boolean']>;
  can_manage_decision_engine?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_assets?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_channels?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_messages?: InputMaybe<Scalars['Boolean']>;
  can_manage_native_delivery_settings?: InputMaybe<Scalars['Boolean']>;
  can_read_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_update_cep_consent?: InputMaybe<Scalars['Boolean']>;
  can_view_agents?: InputMaybe<Scalars['Boolean']>;
  can_view_native_delivery?: InputMaybe<Scalars['Boolean']>;
  is_space_scoped?: InputMaybe<Scalars['Boolean']>;
  is_workspace_admin?: InputMaybe<Scalars['Boolean']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type UserGroupWorkspacesSumFields = {
  __typename?: 'user_group_workspaces_sum_fields';
  user_group_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesSumOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_group_workspaces" */
export const UserGroupWorkspacesUpdateColumn = {
  /** column name */
  BuiltInPermissionSet: 'built_in_permission_set',
  /** column name */
  CanConfigureAgents: 'can_configure_agents',
  /** column name */
  CanCreateDestinations: 'can_create_destinations',
  /** column name */
  CanCreateEventForwardingDestinations: 'can_create_event_forwarding_destinations',
  /** column name */
  CanCreateEventFunctions: 'can_create_event_functions',
  /** column name */
  CanCreateEventPlans: 'can_create_event_plans',
  /** column name */
  CanCreateEventSources: 'can_create_event_sources',
  /** column name */
  CanCreateEventWarehouseDestinations: 'can_create_event_warehouse_destinations',
  /** column name */
  CanCreateSources: 'can_create_sources',
  /** column name */
  CanDraftNativeDelivery: 'can_draft_native_delivery',
  /** column name */
  CanEditDecisionEngineContent: 'can_edit_decision_engine_content',
  /** column name */
  CanGrantSupportAccess: 'can_grant_support_access',
  /** column name */
  CanIngestCepPushTokens: 'can_ingest_cep_push_tokens',
  /** column name */
  CanManageDecisionEngine: 'can_manage_decision_engine',
  /** column name */
  CanManageNativeDeliveryAssets: 'can_manage_native_delivery_assets',
  /** column name */
  CanManageNativeDeliveryChannels: 'can_manage_native_delivery_channels',
  /** column name */
  CanManageNativeDeliveryMessages: 'can_manage_native_delivery_messages',
  /** column name */
  CanManageNativeDeliverySettings: 'can_manage_native_delivery_settings',
  /** column name */
  CanReadCepConsent: 'can_read_cep_consent',
  /** column name */
  CanUpdateCepConsent: 'can_update_cep_consent',
  /** column name */
  CanViewAgents: 'can_view_agents',
  /** column name */
  CanViewNativeDelivery: 'can_view_native_delivery',
  /** column name */
  IsSpaceScoped: 'is_space_scoped',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type UserGroupWorkspacesUpdateColumn = typeof UserGroupWorkspacesUpdateColumn[keyof typeof UserGroupWorkspacesUpdateColumn];
export type UserGroupWorkspacesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupWorkspacesSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupWorkspacesBoolExp;
};

/** aggregate var_pop on columns */
export type UserGroupWorkspacesVarPopFields = {
  __typename?: 'user_group_workspaces_var_pop_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesVarPopOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserGroupWorkspacesVarSampFields = {
  __typename?: 'user_group_workspaces_var_samp_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesVarSampOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserGroupWorkspacesVarianceFields = {
  __typename?: 'user_group_workspaces_variance_fields';
  user_group_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_group_workspaces" */
export type UserGroupWorkspacesVarianceOrderBy = {
  user_group_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "user_groups" */
export type UserGroups = {
  __typename?: 'user_groups';
  /** An array relationship */
  api_keys: Array<ApiKeys>;
  built_in_role_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_default_sso_user_group: Scalars['Boolean'];
  is_organization_admin: Scalars['Boolean'];
  /** An array relationship */
  members: Array<OrganizationMembers>;
  /** An aggregate relationship */
  members_aggregate: OrganizationMembersAggregate;
  name: Scalars['String'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['bigint'];
  /** An array relationship */
  user_group_members: Array<UserGroupMembers>;
  /** An array relationship */
  user_group_workspaces: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  user_group_workspaces_aggregate: UserGroupWorkspacesAggregate;
};


/** columns and relationships of "user_groups" */
export type UserGroupsApiKeysArgs = {
  distinct_on?: InputMaybe<Array<ApiKeysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApiKeysOrderBy>>;
  where?: InputMaybe<ApiKeysBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsMembersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsUserGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<UserGroupMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupMembersOrderBy>>;
  where?: InputMaybe<UserGroupMembersBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsUserGroupWorkspacesArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsUserGroupWorkspacesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};

/** aggregated selection of "user_groups" */
export type UserGroupsAggregate = {
  __typename?: 'user_groups_aggregate';
  aggregate?: Maybe<UserGroupsAggregateFields>;
  nodes: Array<UserGroups>;
};

export type UserGroupsAggregateBoolExp = {
  bool_and?: InputMaybe<UserGroupsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<UserGroupsAggregateBoolExpBoolOr>;
  count?: InputMaybe<UserGroupsAggregateBoolExpCount>;
};

export type UserGroupsAggregateBoolExpBoolAnd = {
  arguments: UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupsAggregateBoolExpBoolOr = {
  arguments: UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserGroupsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "user_groups" */
export type UserGroupsAggregateFields = {
  __typename?: 'user_groups_aggregate_fields';
  avg?: Maybe<UserGroupsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserGroupsMaxFields>;
  min?: Maybe<UserGroupsMinFields>;
  stddev?: Maybe<UserGroupsStddevFields>;
  stddev_pop?: Maybe<UserGroupsStddevPopFields>;
  stddev_samp?: Maybe<UserGroupsStddevSampFields>;
  sum?: Maybe<UserGroupsSumFields>;
  var_pop?: Maybe<UserGroupsVarPopFields>;
  var_samp?: Maybe<UserGroupsVarSampFields>;
  variance?: Maybe<UserGroupsVarianceFields>;
};


/** aggregate fields of "user_groups" */
export type UserGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_groups" */
export type UserGroupsAggregateOrderBy = {
  avg?: InputMaybe<UserGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserGroupsMaxOrderBy>;
  min?: InputMaybe<UserGroupsMinOrderBy>;
  stddev?: InputMaybe<UserGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<UserGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserGroupsStddevSampOrderBy>;
  sum?: InputMaybe<UserGroupsSumOrderBy>;
  var_pop?: InputMaybe<UserGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<UserGroupsVarSampOrderBy>;
  variance?: InputMaybe<UserGroupsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type UserGroupsAvgFields = {
  __typename?: 'user_groups_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_groups" */
export type UserGroupsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: InputMaybe<Array<UserGroupsBoolExp>>;
  _not?: InputMaybe<UserGroupsBoolExp>;
  _or?: InputMaybe<Array<UserGroupsBoolExp>>;
  api_keys?: InputMaybe<ApiKeysBoolExp>;
  built_in_role_type?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_default_sso_user_group?: InputMaybe<BooleanComparisonExp>;
  is_organization_admin?: InputMaybe<BooleanComparisonExp>;
  members?: InputMaybe<OrganizationMembersBoolExp>;
  members_aggregate?: InputMaybe<OrganizationMembersAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  user_group_members?: InputMaybe<UserGroupMembersBoolExp>;
  user_group_workspaces?: InputMaybe<UserGroupWorkspacesBoolExp>;
  user_group_workspaces_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
};

/** unique or primary key constraints on table "user_groups" */
export const UserGroupsConstraint = {
  /** unique or primary key constraint on columns "id", "organization_id" */
  UserGroupsIdOrgUnique: 'user_groups_id_org_unique',
  /** unique or primary key constraint on columns "organization_id", "name" */
  UserGroupsOrganizationIdNameKey: 'user_groups_organization_id_name_key',
  /** unique or primary key constraint on columns "id" */
  UserGroupsPkey: 'user_groups_pkey'
} as const;

export type UserGroupsConstraint = typeof UserGroupsConstraint[keyof typeof UserGroupsConstraint];
/** input type for inserting data into table "user_groups" */
export type UserGroupsInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  user_group_members?: InputMaybe<UserGroupMembersArrRelInsertInput>;
  user_group_workspaces?: InputMaybe<UserGroupWorkspacesArrRelInsertInput>;
};

/** aggregate max on columns */
export type UserGroupsMaxFields = {
  __typename?: 'user_groups_max_fields';
  built_in_role_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "user_groups" */
export type UserGroupsMaxOrderBy = {
  built_in_role_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserGroupsMinFields = {
  __typename?: 'user_groups_min_fields';
  built_in_role_type?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "user_groups" */
export type UserGroupsMinOrderBy = {
  built_in_role_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_groups" */
export type UserGroupsMutationResponse = {
  __typename?: 'user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroups>;
};

/** input type for inserting object relation for remote table "user_groups" */
export type UserGroupsObjRelInsertInput = {
  data: UserGroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UserGroupsOnConflict>;
};

/** on_conflict condition type for table "user_groups" */
export type UserGroupsOnConflict = {
  constraint: UserGroupsConstraint;
  update_columns?: Array<UserGroupsUpdateColumn>;
  where?: InputMaybe<UserGroupsBoolExp>;
};

/** Ordering options when selecting data from "user_groups". */
export type UserGroupsOrderBy = {
  api_keys_aggregate?: InputMaybe<ApiKeysAggregateOrderBy>;
  built_in_role_type?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_default_sso_user_group?: InputMaybe<OrderBy>;
  is_organization_admin?: InputMaybe<OrderBy>;
  members_aggregate?: InputMaybe<OrganizationMembersAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_group_members_aggregate?: InputMaybe<UserGroupMembersAggregateOrderBy>;
  user_group_workspaces_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
};

/** primary key columns input for table: user_groups */
export type UserGroupsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "user_groups" */
export const UserGroupsSelectColumn = {
  /** column name */
  BuiltInRoleType: 'built_in_role_type',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  IsDefaultSsoUserGroup: 'is_default_sso_user_group',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organization_id'
} as const;

export type UserGroupsSelectColumn = typeof UserGroupsSelectColumn[keyof typeof UserGroupsSelectColumn];
/** select "user_groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_groups" */
export const UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsDefaultSsoUserGroup: 'is_default_sso_user_group',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin'
} as const;

export type UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns = typeof UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns[keyof typeof UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns];
/** select "user_groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_groups" */
export const UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsDefaultSsoUserGroup: 'is_default_sso_user_group',
  /** column name */
  IsOrganizationAdmin: 'is_organization_admin'
} as const;

export type UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns = typeof UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns[keyof typeof UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns];
/** input type for updating data in table "user_groups" */
export type UserGroupsSetInput = {
  description?: InputMaybe<Scalars['String']>;
  is_default_sso_user_group?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserGroupsStddevFields = {
  __typename?: 'user_groups_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_groups" */
export type UserGroupsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserGroupsStddevPopFields = {
  __typename?: 'user_groups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_groups" */
export type UserGroupsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserGroupsStddevSampFields = {
  __typename?: 'user_groups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_groups" */
export type UserGroupsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_groups" */
export type UserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupsStreamCursorValueInput = {
  built_in_role_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_default_sso_user_group?: InputMaybe<Scalars['Boolean']>;
  is_organization_admin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type UserGroupsSumFields = {
  __typename?: 'user_groups_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_groups" */
export type UserGroupsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_groups" */
export const UserGroupsUpdateColumn = {
  /** column name */
  Description: 'description',
  /** column name */
  IsDefaultSsoUserGroup: 'is_default_sso_user_group',
  /** column name */
  Name: 'name'
} as const;

export type UserGroupsUpdateColumn = typeof UserGroupsUpdateColumn[keyof typeof UserGroupsUpdateColumn];
export type UserGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupsBoolExp;
};

/** aggregate var_pop on columns */
export type UserGroupsVarPopFields = {
  __typename?: 'user_groups_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_groups" */
export type UserGroupsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserGroupsVarSampFields = {
  __typename?: 'user_groups_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_groups" */
export type UserGroupsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserGroupsVarianceFields = {
  __typename?: 'user_groups_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_groups" */
export type UserGroupsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  active?: Maybe<Scalars['Boolean']>;
  admin_type?: Maybe<Scalars['String']>;
  auth0_auth_id?: Maybe<Scalars['String']>;
  avatar_json?: Maybe<Scalars['jsonb']>;
  azure_ad_auth_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  google_auth_id?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An array relationship */
  organization_members: Array<OrganizationMembers>;
  /** An aggregate relationship */
  organization_members_aggregate: OrganizationMembersAggregate;
  /** An array relationship */
  sso_user_groups: Array<SsoUserGroups>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "users" */
export type UsersAvatarJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersOrganizationMembersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersOrganizationMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationMembersOrderBy>>;
  where?: InputMaybe<OrganizationMembersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersSsoUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<SsoUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SsoUserGroupsOrderBy>>;
  where?: InputMaybe<SsoUserGroupsBoolExp>;
};

/** order by aggregate values of table "users" */
export type UsersAggregateOrderBy = {
  avg?: InputMaybe<UsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersMaxOrderBy>;
  min?: InputMaybe<UsersMinOrderBy>;
  stddev?: InputMaybe<UsersStddevOrderBy>;
  stddev_pop?: InputMaybe<UsersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UsersStddevSampOrderBy>;
  sum?: InputMaybe<UsersSumOrderBy>;
  var_pop?: InputMaybe<UsersVarPopOrderBy>;
  var_samp?: InputMaybe<UsersVarSampOrderBy>;
  variance?: InputMaybe<UsersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UsersAppendInput = {
  personalization?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "users" */
export type UsersAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  admin_type?: InputMaybe<StringComparisonExp>;
  auth0_auth_id?: InputMaybe<StringComparisonExp>;
  avatar_json?: InputMaybe<JsonbComparisonExp>;
  azure_ad_auth_id?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  google_auth_id?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization_members?: InputMaybe<OrganizationMembersBoolExp>;
  organization_members_aggregate?: InputMaybe<OrganizationMembersAggregateBoolExp>;
  sso_user_groups?: InputMaybe<SsoUserGroupsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UsersDeleteAtPathInput = {
  personalization?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UsersDeleteElemInput = {
  personalization?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UsersDeleteKeyInput = {
  personalization?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type UsersMaxOrderBy = {
  admin_type?: InputMaybe<OrderBy>;
  auth0_auth_id?: InputMaybe<OrderBy>;
  azure_ad_auth_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  google_auth_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "users" */
export type UsersMinOrderBy = {
  admin_type?: InputMaybe<OrderBy>;
  auth0_auth_id?: InputMaybe<OrderBy>;
  azure_ad_auth_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  google_auth_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  active?: InputMaybe<OrderBy>;
  admin_type?: InputMaybe<OrderBy>;
  auth0_auth_id?: InputMaybe<OrderBy>;
  avatar_json?: InputMaybe<OrderBy>;
  azure_ad_auth_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  google_auth_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_members_aggregate?: InputMaybe<OrganizationMembersAggregateOrderBy>;
  sso_user_groups_aggregate?: InputMaybe<SsoUserGroupsAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UsersPrependInput = {
  personalization?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export const UsersSelectColumn = {
  /** column name */
  Active: 'active',
  /** column name */
  AdminType: 'admin_type',
  /** column name */
  Auth0AuthId: 'auth0_auth_id',
  /** column name */
  AvatarJson: 'avatar_json',
  /** column name */
  AzureAdAuthId: 'azure_ad_auth_id',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Email: 'email',
  /** column name */
  GoogleAuthId: 'google_auth_id',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type UsersSelectColumn = typeof UsersSelectColumn[keyof typeof UsersSelectColumn];
/** input type for updating data in table "users" */
export type UsersSetInput = {
  personalization?: InputMaybe<Scalars['jsonb']>;
};

/** order by stddev() on columns of table "users" */
export type UsersStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "users" */
export type UsersStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "users" */
export type UsersStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "users" */
export type UsersSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

export type UsersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UsersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UsersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UsersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UsersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UsersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** order by var_pop() on columns of table "users" */
export type UsersVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "users" */
export type UsersVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "users" */
export type UsersVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['uuid']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type VectorComparisonExp = {
  _eq?: InputMaybe<Scalars['vector']>;
  _gt?: InputMaybe<Scalars['vector']>;
  _gte?: InputMaybe<Scalars['vector']>;
  _in?: InputMaybe<Array<Scalars['vector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['vector']>;
  _lte?: InputMaybe<Scalars['vector']>;
  _neq?: InputMaybe<Scalars['vector']>;
  _nin?: InputMaybe<Array<Scalars['vector']>>;
};

/** columns and relationships of "video_exports" */
export type VideoExports = {
  __typename?: 'video_exports';
  /** An object relationship */
  ad_brief_asset?: Maybe<AdBriefAssets>;
  ad_brief_asset_id: Scalars['uuid'];
  /** An object relationship */
  ad_brief_asset_size_variant?: Maybe<AdBriefAssetSizeVariants>;
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ad_brief_asset_version?: Maybe<AdBriefAssetVersions>;
  ad_brief_asset_version_id: Scalars['uuid'];
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  render_id?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};

/** aggregated selection of "video_exports" */
export type VideoExportsAggregate = {
  __typename?: 'video_exports_aggregate';
  aggregate?: Maybe<VideoExportsAggregateFields>;
  nodes: Array<VideoExports>;
};

export type VideoExportsAggregateBoolExp = {
  count?: InputMaybe<VideoExportsAggregateBoolExpCount>;
};

export type VideoExportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<VideoExportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<VideoExportsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "video_exports" */
export type VideoExportsAggregateFields = {
  __typename?: 'video_exports_aggregate_fields';
  avg?: Maybe<VideoExportsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<VideoExportsMaxFields>;
  min?: Maybe<VideoExportsMinFields>;
  stddev?: Maybe<VideoExportsStddevFields>;
  stddev_pop?: Maybe<VideoExportsStddevPopFields>;
  stddev_samp?: Maybe<VideoExportsStddevSampFields>;
  sum?: Maybe<VideoExportsSumFields>;
  var_pop?: Maybe<VideoExportsVarPopFields>;
  var_samp?: Maybe<VideoExportsVarSampFields>;
  variance?: Maybe<VideoExportsVarianceFields>;
};


/** aggregate fields of "video_exports" */
export type VideoExportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<VideoExportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "video_exports" */
export type VideoExportsAggregateOrderBy = {
  avg?: InputMaybe<VideoExportsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<VideoExportsMaxOrderBy>;
  min?: InputMaybe<VideoExportsMinOrderBy>;
  stddev?: InputMaybe<VideoExportsStddevOrderBy>;
  stddev_pop?: InputMaybe<VideoExportsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<VideoExportsStddevSampOrderBy>;
  sum?: InputMaybe<VideoExportsSumOrderBy>;
  var_pop?: InputMaybe<VideoExportsVarPopOrderBy>;
  var_samp?: InputMaybe<VideoExportsVarSampOrderBy>;
  variance?: InputMaybe<VideoExportsVarianceOrderBy>;
};

/** aggregate avg on columns */
export type VideoExportsAvgFields = {
  __typename?: 'video_exports_avg_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "video_exports" */
export type VideoExportsAvgOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "video_exports". All fields are combined with a logical 'AND'. */
export type VideoExportsBoolExp = {
  _and?: InputMaybe<Array<VideoExportsBoolExp>>;
  _not?: InputMaybe<VideoExportsBoolExp>;
  _or?: InputMaybe<Array<VideoExportsBoolExp>>;
  ad_brief_asset?: InputMaybe<AdBriefAssetsBoolExp>;
  ad_brief_asset_id?: InputMaybe<UuidComparisonExp>;
  ad_brief_asset_size_variant?: InputMaybe<AdBriefAssetSizeVariantsBoolExp>;
  ad_brief_asset_size_variant_id?: InputMaybe<UuidComparisonExp>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsBoolExp>;
  ad_brief_asset_version_id?: InputMaybe<UuidComparisonExp>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  render_id?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type VideoExportsMaxFields = {
  __typename?: 'video_exports_max_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  render_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "video_exports" */
export type VideoExportsMaxOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  render_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type VideoExportsMinFields = {
  __typename?: 'video_exports_min_fields';
  ad_brief_asset_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_size_variant_id?: Maybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  render_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "video_exports" */
export type VideoExportsMinOrderBy = {
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  render_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "video_exports". */
export type VideoExportsOrderBy = {
  ad_brief_asset?: InputMaybe<AdBriefAssetsOrderBy>;
  ad_brief_asset_id?: InputMaybe<OrderBy>;
  ad_brief_asset_size_variant?: InputMaybe<AdBriefAssetSizeVariantsOrderBy>;
  ad_brief_asset_size_variant_id?: InputMaybe<OrderBy>;
  ad_brief_asset_version?: InputMaybe<AdBriefAssetVersionsOrderBy>;
  ad_brief_asset_version_id?: InputMaybe<OrderBy>;
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  render_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "video_exports" */
export const VideoExportsSelectColumn = {
  /** column name */
  AdBriefAssetId: 'ad_brief_asset_id',
  /** column name */
  AdBriefAssetSizeVariantId: 'ad_brief_asset_size_variant_id',
  /** column name */
  AdBriefAssetVersionId: 'ad_brief_asset_version_id',
  /** column name */
  CompletedAt: 'completed_at',
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  RenderId: 'render_id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type VideoExportsSelectColumn = typeof VideoExportsSelectColumn[keyof typeof VideoExportsSelectColumn];
/** aggregate stddev on columns */
export type VideoExportsStddevFields = {
  __typename?: 'video_exports_stddev_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "video_exports" */
export type VideoExportsStddevOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type VideoExportsStddevPopFields = {
  __typename?: 'video_exports_stddev_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "video_exports" */
export type VideoExportsStddevPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type VideoExportsStddevSampFields = {
  __typename?: 'video_exports_stddev_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "video_exports" */
export type VideoExportsStddevSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "video_exports" */
export type VideoExportsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: VideoExportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VideoExportsStreamCursorValueInput = {
  ad_brief_asset_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_size_variant_id?: InputMaybe<Scalars['uuid']>;
  ad_brief_asset_version_id?: InputMaybe<Scalars['uuid']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  render_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type VideoExportsSumFields = {
  __typename?: 'video_exports_sum_fields';
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "video_exports" */
export type VideoExportsSumOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type VideoExportsVarPopFields = {
  __typename?: 'video_exports_var_pop_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "video_exports" */
export type VideoExportsVarPopOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type VideoExportsVarSampFields = {
  __typename?: 'video_exports_var_samp_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "video_exports" */
export type VideoExportsVarSampOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type VideoExportsVarianceFields = {
  __typename?: 'video_exports_variance_fields';
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "video_exports" */
export type VideoExportsVarianceOrderBy = {
  workspace_id?: InputMaybe<OrderBy>;
};

/** Bookkeeping for model snapshots we create in the customer warehouse */
export type WarehouseSnapshots = {
  __typename?: 'warehouse_snapshots';
  id: Scalars['uuid'];
  is_full: Scalars['Boolean'];
  segment_id: Scalars['bigint'];
  timestamp: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "warehouse_snapshots". All fields are combined with a logical 'AND'. */
export type WarehouseSnapshotsBoolExp = {
  _and?: InputMaybe<Array<WarehouseSnapshotsBoolExp>>;
  _not?: InputMaybe<WarehouseSnapshotsBoolExp>;
  _or?: InputMaybe<Array<WarehouseSnapshotsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  is_full?: InputMaybe<BooleanComparisonExp>;
  segment_id?: InputMaybe<BigintComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
};

/** Ordering options when selecting data from "warehouse_snapshots". */
export type WarehouseSnapshotsOrderBy = {
  id?: InputMaybe<OrderBy>;
  is_full?: InputMaybe<OrderBy>;
  segment_id?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
};

/** select columns of table "warehouse_snapshots" */
export const WarehouseSnapshotsSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  IsFull: 'is_full',
  /** column name */
  SegmentId: 'segment_id',
  /** column name */
  Timestamp: 'timestamp'
} as const;

export type WarehouseSnapshotsSelectColumn = typeof WarehouseSnapshotsSelectColumn[keyof typeof WarehouseSnapshotsSelectColumn];
/** Streaming cursor of the table "warehouse_snapshots" */
export type WarehouseSnapshotsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WarehouseSnapshotsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WarehouseSnapshotsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']>;
  is_full?: InputMaybe<Scalars['Boolean']>;
  segment_id?: InputMaybe<Scalars['bigint']>;
  timestamp?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "workspace_members" */
export type WorkspaceMembers = {
  __typename?: 'workspace_members';
  is_sso?: Maybe<Scalars['Boolean']>;
  is_workspace_admin?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  user_group?: Maybe<UserGroups>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  workspace?: Maybe<Workspaces>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "workspace_members" */
export type WorkspaceMembersAggregate = {
  __typename?: 'workspace_members_aggregate';
  aggregate?: Maybe<WorkspaceMembersAggregateFields>;
  nodes: Array<WorkspaceMembers>;
};

export type WorkspaceMembersAggregateBoolExp = {
  bool_and?: InputMaybe<WorkspaceMembersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<WorkspaceMembersAggregateBoolExpBoolOr>;
  count?: InputMaybe<WorkspaceMembersAggregateBoolExpCount>;
};

export type WorkspaceMembersAggregateBoolExpBoolAnd = {
  arguments: WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WorkspaceMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type WorkspaceMembersAggregateBoolExpBoolOr = {
  arguments: WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WorkspaceMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type WorkspaceMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WorkspaceMembersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "workspace_members" */
export type WorkspaceMembersAggregateFields = {
  __typename?: 'workspace_members_aggregate_fields';
  avg?: Maybe<WorkspaceMembersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WorkspaceMembersMaxFields>;
  min?: Maybe<WorkspaceMembersMinFields>;
  stddev?: Maybe<WorkspaceMembersStddevFields>;
  stddev_pop?: Maybe<WorkspaceMembersStddevPopFields>;
  stddev_samp?: Maybe<WorkspaceMembersStddevSampFields>;
  sum?: Maybe<WorkspaceMembersSumFields>;
  var_pop?: Maybe<WorkspaceMembersVarPopFields>;
  var_samp?: Maybe<WorkspaceMembersVarSampFields>;
  variance?: Maybe<WorkspaceMembersVarianceFields>;
};


/** aggregate fields of "workspace_members" */
export type WorkspaceMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workspace_members" */
export type WorkspaceMembersAggregateOrderBy = {
  avg?: InputMaybe<WorkspaceMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WorkspaceMembersMaxOrderBy>;
  min?: InputMaybe<WorkspaceMembersMinOrderBy>;
  stddev?: InputMaybe<WorkspaceMembersStddevOrderBy>;
  stddev_pop?: InputMaybe<WorkspaceMembersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WorkspaceMembersStddevSampOrderBy>;
  sum?: InputMaybe<WorkspaceMembersSumOrderBy>;
  var_pop?: InputMaybe<WorkspaceMembersVarPopOrderBy>;
  var_samp?: InputMaybe<WorkspaceMembersVarSampOrderBy>;
  variance?: InputMaybe<WorkspaceMembersVarianceOrderBy>;
};

/** aggregate avg on columns */
export type WorkspaceMembersAvgFields = {
  __typename?: 'workspace_members_avg_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workspace_members" */
export type WorkspaceMembersAvgOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "workspace_members". All fields are combined with a logical 'AND'. */
export type WorkspaceMembersBoolExp = {
  _and?: InputMaybe<Array<WorkspaceMembersBoolExp>>;
  _not?: InputMaybe<WorkspaceMembersBoolExp>;
  _or?: InputMaybe<Array<WorkspaceMembersBoolExp>>;
  is_sso?: InputMaybe<BooleanComparisonExp>;
  is_workspace_admin?: InputMaybe<BooleanComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_group?: InputMaybe<UserGroupsBoolExp>;
  user_group_id?: InputMaybe<BigintComparisonExp>;
  user_id?: InputMaybe<BigintComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type WorkspaceMembersMaxFields = {
  __typename?: 'workspace_members_max_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "workspace_members" */
export type WorkspaceMembersMaxOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WorkspaceMembersMinFields = {
  __typename?: 'workspace_members_min_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "workspace_members" */
export type WorkspaceMembersMinOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "workspace_members". */
export type WorkspaceMembersOrderBy = {
  is_sso?: InputMaybe<OrderBy>;
  is_workspace_admin?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_group?: InputMaybe<UserGroupsOrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** select columns of table "workspace_members" */
export const WorkspaceMembersSelectColumn = {
  /** column name */
  IsSso: 'is_sso',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  UserGroupId: 'user_group_id',
  /** column name */
  UserId: 'user_id',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type WorkspaceMembersSelectColumn = typeof WorkspaceMembersSelectColumn[keyof typeof WorkspaceMembersSelectColumn];
/** select "workspace_members_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workspace_members" */
export const WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolAndArgumentsColumns = {
  /** column name */
  IsSso: 'is_sso',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolAndArgumentsColumns = typeof WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolAndArgumentsColumns[keyof typeof WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolAndArgumentsColumns];
/** select "workspace_members_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workspace_members" */
export const WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolOrArgumentsColumns = {
  /** column name */
  IsSso: 'is_sso',
  /** column name */
  IsWorkspaceAdmin: 'is_workspace_admin'
} as const;

export type WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolOrArgumentsColumns = typeof WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolOrArgumentsColumns[keyof typeof WorkspaceMembersSelectColumnWorkspaceMembersAggregateBoolExpBoolOrArgumentsColumns];
/** aggregate stddev on columns */
export type WorkspaceMembersStddevFields = {
  __typename?: 'workspace_members_stddev_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workspace_members" */
export type WorkspaceMembersStddevOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type WorkspaceMembersStddevPopFields = {
  __typename?: 'workspace_members_stddev_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workspace_members" */
export type WorkspaceMembersStddevPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type WorkspaceMembersStddevSampFields = {
  __typename?: 'workspace_members_stddev_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workspace_members" */
export type WorkspaceMembersStddevSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "workspace_members" */
export type WorkspaceMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WorkspaceMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkspaceMembersStreamCursorValueInput = {
  is_sso?: InputMaybe<Scalars['Boolean']>;
  is_workspace_admin?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  user_group_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type WorkspaceMembersSumFields = {
  __typename?: 'workspace_members_sum_fields';
  organization_id?: Maybe<Scalars['bigint']>;
  user_group_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
  workspace_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "workspace_members" */
export type WorkspaceMembersSumOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type WorkspaceMembersVarPopFields = {
  __typename?: 'workspace_members_var_pop_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workspace_members" */
export type WorkspaceMembersVarPopOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type WorkspaceMembersVarSampFields = {
  __typename?: 'workspace_members_var_samp_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workspace_members" */
export type WorkspaceMembersVarSampOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WorkspaceMembersVarianceFields = {
  __typename?: 'workspace_members_variance_fields';
  organization_id?: Maybe<Scalars['Float']>;
  user_group_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  workspace_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workspace_members" */
export type WorkspaceMembersVarianceOrderBy = {
  organization_id?: InputMaybe<OrderBy>;
  user_group_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "workspace_notification_channels" */
export type WorkspaceNotificationChannels = {
  __typename?: 'workspace_notification_channels';
  channel_type: Scalars['String'];
  config: Scalars['jsonb'];
  id: Scalars['uuid'];
  /** An array relationship */
  notification_channel_templates: Array<NotificationChannelTemplates>;
  /** An array relationship */
  resource_notification_channels: Array<ResourceNotificationChannels>;
  /** An array relationship */
  sent_resource_notifications: Array<SentResourceNotifications>;
  status: Scalars['String'];
  /** An object relationship */
  workspace: Workspaces;
  workspace_id: Scalars['bigint'];
};


/** columns and relationships of "workspace_notification_channels" */
export type WorkspaceNotificationChannelsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspace_notification_channels" */
export type WorkspaceNotificationChannelsNotificationChannelTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannelTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationChannelTemplatesOrderBy>>;
  where?: InputMaybe<NotificationChannelTemplatesBoolExp>;
};


/** columns and relationships of "workspace_notification_channels" */
export type WorkspaceNotificationChannelsResourceNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<ResourceNotificationChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ResourceNotificationChannelsOrderBy>>;
  where?: InputMaybe<ResourceNotificationChannelsBoolExp>;
};


/** columns and relationships of "workspace_notification_channels" */
export type WorkspaceNotificationChannelsSentResourceNotificationsArgs = {
  distinct_on?: InputMaybe<Array<SentResourceNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SentResourceNotificationsOrderBy>>;
  where?: InputMaybe<SentResourceNotificationsBoolExp>;
};

/** Boolean expression to filter rows from the table "workspace_notification_channels". All fields are combined with a logical 'AND'. */
export type WorkspaceNotificationChannelsBoolExp = {
  _and?: InputMaybe<Array<WorkspaceNotificationChannelsBoolExp>>;
  _not?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
  _or?: InputMaybe<Array<WorkspaceNotificationChannelsBoolExp>>;
  channel_type?: InputMaybe<StringComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notification_channel_templates?: InputMaybe<NotificationChannelTemplatesBoolExp>;
  resource_notification_channels?: InputMaybe<ResourceNotificationChannelsBoolExp>;
  sent_resource_notifications?: InputMaybe<SentResourceNotificationsBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  workspace?: InputMaybe<WorkspacesBoolExp>;
  workspace_id?: InputMaybe<BigintComparisonExp>;
};

/** unique or primary key constraints on table "workspace_notification_channels" */
export const WorkspaceNotificationChannelsConstraint = {
  /** unique or primary key constraint on columns "id", "workspace_id" */
  WorkspaceNotificationChannelsIdWorkspaceIdKey: 'workspace_notification_channels_id_workspace_id_key',
  /** unique or primary key constraint on columns "id" */
  WorkspaceNotificationChannelsPkey: 'workspace_notification_channels_pkey'
} as const;

export type WorkspaceNotificationChannelsConstraint = typeof WorkspaceNotificationChannelsConstraint[keyof typeof WorkspaceNotificationChannelsConstraint];
/** input type for inserting data into table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsInsertInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_channel_templates?: InputMaybe<NotificationChannelTemplatesArrRelInsertInput>;
  resource_notification_channels?: InputMaybe<ResourceNotificationChannelsArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsMutationResponse = {
  __typename?: 'workspace_notification_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkspaceNotificationChannels>;
};

/** input type for inserting object relation for remote table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsObjRelInsertInput = {
  data: WorkspaceNotificationChannelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkspaceNotificationChannelsOnConflict>;
};

/** on_conflict condition type for table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsOnConflict = {
  constraint: WorkspaceNotificationChannelsConstraint;
  update_columns?: Array<WorkspaceNotificationChannelsUpdateColumn>;
  where?: InputMaybe<WorkspaceNotificationChannelsBoolExp>;
};

/** Ordering options when selecting data from "workspace_notification_channels". */
export type WorkspaceNotificationChannelsOrderBy = {
  channel_type?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notification_channel_templates_aggregate?: InputMaybe<NotificationChannelTemplatesAggregateOrderBy>;
  resource_notification_channels_aggregate?: InputMaybe<ResourceNotificationChannelsAggregateOrderBy>;
  sent_resource_notifications_aggregate?: InputMaybe<SentResourceNotificationsAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  workspace?: InputMaybe<WorkspacesOrderBy>;
  workspace_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: workspace_notification_channels */
export type WorkspaceNotificationChannelsPkColumnsInput = {
  id: Scalars['uuid'];
};

/** select columns of table "workspace_notification_channels" */
export const WorkspaceNotificationChannelsSelectColumn = {
  /** column name */
  ChannelType: 'channel_type',
  /** column name */
  Config: 'config',
  /** column name */
  Id: 'id',
  /** column name */
  Status: 'status',
  /** column name */
  WorkspaceId: 'workspace_id'
} as const;

export type WorkspaceNotificationChannelsSelectColumn = typeof WorkspaceNotificationChannelsSelectColumn[keyof typeof WorkspaceNotificationChannelsSelectColumn];
/** input type for updating data in table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsSetInput = {
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "workspace_notification_channels" */
export type WorkspaceNotificationChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WorkspaceNotificationChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkspaceNotificationChannelsStreamCursorValueInput = {
  channel_type?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  workspace_id?: InputMaybe<Scalars['bigint']>;
};

/** update columns of table "workspace_notification_channels" */
export const WorkspaceNotificationChannelsUpdateColumn = {
  /** column name */
  Status: 'status'
} as const;

export type WorkspaceNotificationChannelsUpdateColumn = typeof WorkspaceNotificationChannelsUpdateColumn[keyof typeof WorkspaceNotificationChannelsUpdateColumn];
export type WorkspaceNotificationChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkspaceNotificationChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: WorkspaceNotificationChannelsBoolExp;
};

/** columns and relationships of "workspace_overage_dates" */
export type WorkspaceOverageDates = {
  __typename?: 'workspace_overage_dates';
  id?: Maybe<Scalars['bigint']>;
  is_workspace_in_overage?: Maybe<Scalars['Boolean']>;
  num_paid_destination_types?: Maybe<Scalars['bigint']>;
  num_premium_destination_types?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['bigint']>;
  overage_date?: Maybe<Scalars['date']>;
};

/** Boolean expression to filter rows from the table "workspace_overage_dates". All fields are combined with a logical 'AND'. */
export type WorkspaceOverageDatesBoolExp = {
  _and?: InputMaybe<Array<WorkspaceOverageDatesBoolExp>>;
  _not?: InputMaybe<WorkspaceOverageDatesBoolExp>;
  _or?: InputMaybe<Array<WorkspaceOverageDatesBoolExp>>;
  id?: InputMaybe<BigintComparisonExp>;
  is_workspace_in_overage?: InputMaybe<BooleanComparisonExp>;
  num_paid_destination_types?: InputMaybe<BigintComparisonExp>;
  num_premium_destination_types?: InputMaybe<BigintComparisonExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  overage_date?: InputMaybe<DateComparisonExp>;
};

/** Ordering options when selecting data from "workspace_overage_dates". */
export type WorkspaceOverageDatesOrderBy = {
  id?: InputMaybe<OrderBy>;
  is_workspace_in_overage?: InputMaybe<OrderBy>;
  num_paid_destination_types?: InputMaybe<OrderBy>;
  num_premium_destination_types?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  overage_date?: InputMaybe<OrderBy>;
};

/** select columns of table "workspace_overage_dates" */
export const WorkspaceOverageDatesSelectColumn = {
  /** column name */
  Id: 'id',
  /** column name */
  IsWorkspaceInOverage: 'is_workspace_in_overage',
  /** column name */
  NumPaidDestinationTypes: 'num_paid_destination_types',
  /** column name */
  NumPremiumDestinationTypes: 'num_premium_destination_types',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  OverageDate: 'overage_date'
} as const;

export type WorkspaceOverageDatesSelectColumn = typeof WorkspaceOverageDatesSelectColumn[keyof typeof WorkspaceOverageDatesSelectColumn];
/** Streaming cursor of the table "workspace_overage_dates" */
export type WorkspaceOverageDatesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WorkspaceOverageDatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkspaceOverageDatesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['bigint']>;
  is_workspace_in_overage?: InputMaybe<Scalars['Boolean']>;
  num_paid_destination_types?: InputMaybe<Scalars['bigint']>;
  num_premium_destination_types?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  overage_date?: InputMaybe<Scalars['date']>;
};

/** columns and relationships of "workspaces" */
export type Workspaces = {
  __typename?: 'workspaces';
  alerting_v2_enabled?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  all_memberships_v2: Array<AllMembershipsV2>;
  /** An aggregate relationship */
  all_memberships_v2_aggregate: AllMembershipsV2Aggregate;
  approvals_required: Scalars['Boolean'];
  assign_default_role_to_sso: Scalars['Boolean'];
  audience_snapshotting_enabled: Scalars['Boolean'];
  /** An array relationship */
  connections: Array<Connections>;
  /** An aggregate relationship */
  connections_aggregate: ConnectionsAggregate;
  default_connection?: Maybe<Scalars['bigint']>;
  default_role_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  destinations: Array<Destinations>;
  /** An aggregate relationship */
  destinations_aggregate: DestinationsAggregate;
  domain?: Maybe<Scalars['String']>;
  external_bucket_required_at?: Maybe<Scalars['timestamptz']>;
  feature_flags: Scalars['jsonb'];
  first_overage_date?: Maybe<Scalars['timestamptz']>;
  google_hosted_domain?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_approved: Scalars['Boolean'];
  joinable_to?: Maybe<Scalars['jsonb']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default: Scalars['jsonb'];
  name: Scalars['String'];
  onboarding?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['bigint']>;
  personalization?: Maybe<Scalars['jsonb']>;
  prevent_self_approval: Scalars['Boolean'];
  region: Scalars['String'];
  region_config?: Maybe<Scalars['jsonb']>;
  self_serve_ad_settings?: Maybe<Scalars['jsonb']>;
  slug?: Maybe<Scalars['String']>;
  spaces_enabled?: Maybe<Scalars['Boolean']>;
  sync_templates_only?: Maybe<Scalars['Boolean']>;
  trial_ends_at?: Maybe<Scalars['timestamptz']>;
  typeform_api_key?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_groups: Array<UserGroupWorkspaces>;
  /** An aggregate relationship */
  user_groups_aggregate: UserGroupWorkspacesAggregate;
  /** An array relationship */
  users: Array<Users>;
  visible_to?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  workspace_members: Array<WorkspaceMembers>;
  /** An aggregate relationship */
  workspace_members_aggregate: WorkspaceMembersAggregate;
};


/** columns and relationships of "workspaces" */
export type WorkspacesAllMembershipsV2Args = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesAllMembershipsV2AggregateArgs = {
  distinct_on?: InputMaybe<Array<AllMembershipsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AllMembershipsV2OrderBy>>;
  where?: InputMaybe<AllMembershipsV2BoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesConnectionsArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesConnectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ConnectionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ConnectionsOrderBy>>;
  where?: InputMaybe<ConnectionsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesDestinationsArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesDestinationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DestinationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DestinationsOrderBy>>;
  where?: InputMaybe<DestinationsBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesFeatureFlagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesJoinableToArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesJourneySyncExpiryDefaultArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesOnboardingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesPersonalizationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesRegionConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesSelfServeAdSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesUserGroupsArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesUserGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserGroupWorkspacesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserGroupWorkspacesOrderBy>>;
  where?: InputMaybe<UserGroupWorkspacesBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesVisibleToArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesWorkspaceMembersArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};


/** columns and relationships of "workspaces" */
export type WorkspacesWorkspaceMembersAggregateArgs = {
  distinct_on?: InputMaybe<Array<WorkspaceMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<WorkspaceMembersOrderBy>>;
  where?: InputMaybe<WorkspaceMembersBoolExp>;
};

/** order by aggregate values of table "workspaces" */
export type WorkspacesAggregateOrderBy = {
  avg?: InputMaybe<WorkspacesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WorkspacesMaxOrderBy>;
  min?: InputMaybe<WorkspacesMinOrderBy>;
  stddev?: InputMaybe<WorkspacesStddevOrderBy>;
  stddev_pop?: InputMaybe<WorkspacesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WorkspacesStddevSampOrderBy>;
  sum?: InputMaybe<WorkspacesSumOrderBy>;
  var_pop?: InputMaybe<WorkspacesVarPopOrderBy>;
  var_samp?: InputMaybe<WorkspacesVarSampOrderBy>;
  variance?: InputMaybe<WorkspacesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WorkspacesAppendInput = {
  feature_flags?: InputMaybe<Scalars['jsonb']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['jsonb']>;
  onboarding?: InputMaybe<Scalars['jsonb']>;
  personalization?: InputMaybe<Scalars['jsonb']>;
  self_serve_ad_settings?: InputMaybe<Scalars['jsonb']>;
};

/** order by avg() on columns of table "workspaces" */
export type WorkspacesAvgOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "workspaces". All fields are combined with a logical 'AND'. */
export type WorkspacesBoolExp = {
  _and?: InputMaybe<Array<WorkspacesBoolExp>>;
  _not?: InputMaybe<WorkspacesBoolExp>;
  _or?: InputMaybe<Array<WorkspacesBoolExp>>;
  alerting_v2_enabled?: InputMaybe<BooleanComparisonExp>;
  all_memberships_v2?: InputMaybe<AllMembershipsV2BoolExp>;
  all_memberships_v2_aggregate?: InputMaybe<AllMembershipsV2AggregateBoolExp>;
  approvals_required?: InputMaybe<BooleanComparisonExp>;
  assign_default_role_to_sso?: InputMaybe<BooleanComparisonExp>;
  audience_snapshotting_enabled?: InputMaybe<BooleanComparisonExp>;
  connections?: InputMaybe<ConnectionsBoolExp>;
  connections_aggregate?: InputMaybe<ConnectionsAggregateBoolExp>;
  default_connection?: InputMaybe<BigintComparisonExp>;
  default_role_id?: InputMaybe<BigintComparisonExp>;
  destinations?: InputMaybe<DestinationsBoolExp>;
  destinations_aggregate?: InputMaybe<DestinationsAggregateBoolExp>;
  domain?: InputMaybe<StringComparisonExp>;
  external_bucket_required_at?: InputMaybe<TimestamptzComparisonExp>;
  feature_flags?: InputMaybe<JsonbComparisonExp>;
  first_overage_date?: InputMaybe<TimestamptzComparisonExp>;
  google_hosted_domain?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  is_approved?: InputMaybe<BooleanComparisonExp>;
  joinable_to?: InputMaybe<JsonbComparisonExp>;
  journey_sync_expiry_default?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  onboarding?: InputMaybe<JsonbComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<BigintComparisonExp>;
  personalization?: InputMaybe<JsonbComparisonExp>;
  prevent_self_approval?: InputMaybe<BooleanComparisonExp>;
  region?: InputMaybe<StringComparisonExp>;
  region_config?: InputMaybe<JsonbComparisonExp>;
  self_serve_ad_settings?: InputMaybe<JsonbComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  spaces_enabled?: InputMaybe<BooleanComparisonExp>;
  sync_templates_only?: InputMaybe<BooleanComparisonExp>;
  trial_ends_at?: InputMaybe<TimestamptzComparisonExp>;
  typeform_api_key?: InputMaybe<StringComparisonExp>;
  user_groups?: InputMaybe<UserGroupWorkspacesBoolExp>;
  user_groups_aggregate?: InputMaybe<UserGroupWorkspacesAggregateBoolExp>;
  users?: InputMaybe<UsersBoolExp>;
  visible_to?: InputMaybe<JsonbComparisonExp>;
  workspace_members?: InputMaybe<WorkspaceMembersBoolExp>;
  workspace_members_aggregate?: InputMaybe<WorkspaceMembersAggregateBoolExp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WorkspacesDeleteAtPathInput = {
  feature_flags?: InputMaybe<Array<Scalars['String']>>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Array<Scalars['String']>>;
  onboarding?: InputMaybe<Array<Scalars['String']>>;
  personalization?: InputMaybe<Array<Scalars['String']>>;
  self_serve_ad_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WorkspacesDeleteElemInput = {
  feature_flags?: InputMaybe<Scalars['Int']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['Int']>;
  onboarding?: InputMaybe<Scalars['Int']>;
  personalization?: InputMaybe<Scalars['Int']>;
  self_serve_ad_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WorkspacesDeleteKeyInput = {
  feature_flags?: InputMaybe<Scalars['String']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<Scalars['String']>;
  personalization?: InputMaybe<Scalars['String']>;
  self_serve_ad_settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workspaces" */
export type WorkspacesIncInput = {
  default_connection?: InputMaybe<Scalars['bigint']>;
  default_role_id?: InputMaybe<Scalars['bigint']>;
};

/** order by max() on columns of table "workspaces" */
export type WorkspacesMaxOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  external_bucket_required_at?: InputMaybe<OrderBy>;
  first_overage_date?: InputMaybe<OrderBy>;
  google_hosted_domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  trial_ends_at?: InputMaybe<OrderBy>;
  typeform_api_key?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "workspaces" */
export type WorkspacesMinOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  external_bucket_required_at?: InputMaybe<OrderBy>;
  first_overage_date?: InputMaybe<OrderBy>;
  google_hosted_domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  trial_ends_at?: InputMaybe<OrderBy>;
  typeform_api_key?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "workspaces" */
export type WorkspacesMutationResponse = {
  __typename?: 'workspaces_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workspaces>;
};

/** Ordering options when selecting data from "workspaces". */
export type WorkspacesOrderBy = {
  alerting_v2_enabled?: InputMaybe<OrderBy>;
  all_memberships_v2_aggregate?: InputMaybe<AllMembershipsV2AggregateOrderBy>;
  approvals_required?: InputMaybe<OrderBy>;
  assign_default_role_to_sso?: InputMaybe<OrderBy>;
  audience_snapshotting_enabled?: InputMaybe<OrderBy>;
  connections_aggregate?: InputMaybe<ConnectionsAggregateOrderBy>;
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  destinations_aggregate?: InputMaybe<DestinationsAggregateOrderBy>;
  domain?: InputMaybe<OrderBy>;
  external_bucket_required_at?: InputMaybe<OrderBy>;
  feature_flags?: InputMaybe<OrderBy>;
  first_overage_date?: InputMaybe<OrderBy>;
  google_hosted_domain?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_approved?: InputMaybe<OrderBy>;
  joinable_to?: InputMaybe<OrderBy>;
  journey_sync_expiry_default?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  onboarding?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  personalization?: InputMaybe<OrderBy>;
  prevent_self_approval?: InputMaybe<OrderBy>;
  region?: InputMaybe<OrderBy>;
  region_config?: InputMaybe<OrderBy>;
  self_serve_ad_settings?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  spaces_enabled?: InputMaybe<OrderBy>;
  sync_templates_only?: InputMaybe<OrderBy>;
  trial_ends_at?: InputMaybe<OrderBy>;
  typeform_api_key?: InputMaybe<OrderBy>;
  user_groups_aggregate?: InputMaybe<UserGroupWorkspacesAggregateOrderBy>;
  users_aggregate?: InputMaybe<UsersAggregateOrderBy>;
  visible_to?: InputMaybe<OrderBy>;
  workspace_members_aggregate?: InputMaybe<WorkspaceMembersAggregateOrderBy>;
};

/** primary key columns input for table: workspaces */
export type WorkspacesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WorkspacesPrependInput = {
  feature_flags?: InputMaybe<Scalars['jsonb']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['jsonb']>;
  onboarding?: InputMaybe<Scalars['jsonb']>;
  personalization?: InputMaybe<Scalars['jsonb']>;
  self_serve_ad_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workspaces" */
export const WorkspacesSelectColumn = {
  /** column name */
  AlertingV2Enabled: 'alerting_v2_enabled',
  /** column name */
  ApprovalsRequired: 'approvals_required',
  /** column name */
  AssignDefaultRoleToSso: 'assign_default_role_to_sso',
  /** column name */
  AudienceSnapshottingEnabled: 'audience_snapshotting_enabled',
  /** column name */
  DefaultConnection: 'default_connection',
  /** column name */
  DefaultRoleId: 'default_role_id',
  /** column name */
  Domain: 'domain',
  /** column name */
  ExternalBucketRequiredAt: 'external_bucket_required_at',
  /** column name */
  FeatureFlags: 'feature_flags',
  /** column name */
  FirstOverageDate: 'first_overage_date',
  /** column name */
  GoogleHostedDomain: 'google_hosted_domain',
  /** column name */
  Id: 'id',
  /** column name */
  IsApproved: 'is_approved',
  /** column name */
  JoinableTo: 'joinable_to',
  /** column name */
  JourneySyncExpiryDefault: 'journey_sync_expiry_default',
  /** column name */
  Name: 'name',
  /** column name */
  Onboarding: 'onboarding',
  /** column name */
  OrganizationId: 'organization_id',
  /** column name */
  Personalization: 'personalization',
  /** column name */
  PreventSelfApproval: 'prevent_self_approval',
  /** column name */
  Region: 'region',
  /** column name */
  RegionConfig: 'region_config',
  /** column name */
  SelfServeAdSettings: 'self_serve_ad_settings',
  /** column name */
  Slug: 'slug',
  /** column name */
  SpacesEnabled: 'spaces_enabled',
  /** column name */
  SyncTemplatesOnly: 'sync_templates_only',
  /** column name */
  TrialEndsAt: 'trial_ends_at',
  /** column name */
  TypeformApiKey: 'typeform_api_key',
  /** column name */
  VisibleTo: 'visible_to'
} as const;

export type WorkspacesSelectColumn = typeof WorkspacesSelectColumn[keyof typeof WorkspacesSelectColumn];
/** input type for updating data in table "workspaces" */
export type WorkspacesSetInput = {
  alerting_v2_enabled?: InputMaybe<Scalars['Boolean']>;
  approvals_required?: InputMaybe<Scalars['Boolean']>;
  assign_default_role_to_sso?: InputMaybe<Scalars['Boolean']>;
  audience_snapshotting_enabled?: InputMaybe<Scalars['Boolean']>;
  default_connection?: InputMaybe<Scalars['bigint']>;
  default_role_id?: InputMaybe<Scalars['bigint']>;
  domain?: InputMaybe<Scalars['String']>;
  feature_flags?: InputMaybe<Scalars['jsonb']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<Scalars['jsonb']>;
  personalization?: InputMaybe<Scalars['jsonb']>;
  prevent_self_approval?: InputMaybe<Scalars['Boolean']>;
  self_serve_ad_settings?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  sync_templates_only?: InputMaybe<Scalars['Boolean']>;
  typeform_api_key?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "workspaces" */
export type WorkspacesStddevOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "workspaces" */
export type WorkspacesStddevPopOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "workspaces" */
export type WorkspacesStddevSampOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "workspaces" */
export type WorkspacesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: WorkspacesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WorkspacesStreamCursorValueInput = {
  alerting_v2_enabled?: InputMaybe<Scalars['Boolean']>;
  approvals_required?: InputMaybe<Scalars['Boolean']>;
  assign_default_role_to_sso?: InputMaybe<Scalars['Boolean']>;
  audience_snapshotting_enabled?: InputMaybe<Scalars['Boolean']>;
  default_connection?: InputMaybe<Scalars['bigint']>;
  default_role_id?: InputMaybe<Scalars['bigint']>;
  domain?: InputMaybe<Scalars['String']>;
  external_bucket_required_at?: InputMaybe<Scalars['timestamptz']>;
  feature_flags?: InputMaybe<Scalars['jsonb']>;
  first_overage_date?: InputMaybe<Scalars['timestamptz']>;
  google_hosted_domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_approved?: InputMaybe<Scalars['Boolean']>;
  joinable_to?: InputMaybe<Scalars['jsonb']>;
  /** Default expire_after window ({unit, quantity}) applied to journey Trigger syncs that have no exit_config.expire_after of their own. */
  journey_sync_expiry_default?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['bigint']>;
  personalization?: InputMaybe<Scalars['jsonb']>;
  prevent_self_approval?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  region_config?: InputMaybe<Scalars['jsonb']>;
  self_serve_ad_settings?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  spaces_enabled?: InputMaybe<Scalars['Boolean']>;
  sync_templates_only?: InputMaybe<Scalars['Boolean']>;
  trial_ends_at?: InputMaybe<Scalars['timestamptz']>;
  typeform_api_key?: InputMaybe<Scalars['String']>;
  visible_to?: InputMaybe<Scalars['jsonb']>;
};

/** order by sum() on columns of table "workspaces" */
export type WorkspacesSumOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

export type WorkspacesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WorkspacesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WorkspacesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WorkspacesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WorkspacesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkspacesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WorkspacesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkspacesSetInput>;
  /** filter the rows which have to be updated */
  where: WorkspacesBoolExp;
};

/** order by var_pop() on columns of table "workspaces" */
export type WorkspacesVarPopOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "workspaces" */
export type WorkspacesVarSampOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "workspaces" */
export type WorkspacesVarianceOrderBy = {
  default_connection?: InputMaybe<OrderBy>;
  default_role_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
};
